
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirecd6f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirecd6f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("dARHh", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $9e584a4ba4de1e17$export$ffb0004e005737fa, (v) => $9e584a4ba4de1e17$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $9e584a4ba4de1e17$export$34b9dba7ce09269b, (v) => $9e584a4ba4de1e17$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $9e584a4ba4de1e17$export$25062201e9e25d76, (v) => $9e584a4ba4de1e17$export$25062201e9e25d76 = v);
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9e584a4ba4de1e17$export$ffb0004e005737fa;
var $9e584a4ba4de1e17$export$34b9dba7ce09269b;
var $9e584a4ba4de1e17$export$25062201e9e25d76;
'use strict';
parcelRequire("5imMc");

var $tZqWC = parcelRequire("tZqWC");
var $9e584a4ba4de1e17$var$g = 60103;
$9e584a4ba4de1e17$export$ffb0004e005737fa = 60107;
if ("function" === typeof Symbol && Symbol.for) {
    var $9e584a4ba4de1e17$var$h = Symbol.for;
    $9e584a4ba4de1e17$var$g = $9e584a4ba4de1e17$var$h("react.element");
    $9e584a4ba4de1e17$export$ffb0004e005737fa = $9e584a4ba4de1e17$var$h("react.fragment");
}
var $9e584a4ba4de1e17$var$m = $tZqWC.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $9e584a4ba4de1e17$var$n = Object.prototype.hasOwnProperty, $9e584a4ba4de1e17$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $9e584a4ba4de1e17$var$q(c, a, k) {
    var b, d = {}, e = null, l = null;
    void 0 !== k && (e = "" + k);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (l = a.ref);
    for(b in a)$9e584a4ba4de1e17$var$n.call(a, b) && !$9e584a4ba4de1e17$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $9e584a4ba4de1e17$var$g,
        type: c,
        key: e,
        ref: l,
        props: d,
        _owner: $9e584a4ba4de1e17$var$m.current
    };
}
$9e584a4ba4de1e17$export$34b9dba7ce09269b = $9e584a4ba4de1e17$var$q;
$9e584a4ba4de1e17$export$25062201e9e25d76 = $9e584a4ba4de1e17$var$q;

});
parcelRegister("5imMc", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $3db04d20a6aafd46$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $3db04d20a6aafd46$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $3db04d20a6aafd46$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $3db04d20a6aafd46$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $3db04d20a6aafd46$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $3db04d20a6aafd46$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $3db04d20a6aafd46$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($3db04d20a6aafd46$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($3db04d20a6aafd46$var$getOwnPropertySymbols) {
            symbols = $3db04d20a6aafd46$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($3db04d20a6aafd46$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});

parcelRegister("tZqWC", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2D4jB"));

});
parcelRegister("2D4jB", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $1ea2922cdc05cc2a$export$ffb0004e005737fa, (v) => $1ea2922cdc05cc2a$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "StrictMode", () => $1ea2922cdc05cc2a$export$5f8d39834fd61797, (v) => $1ea2922cdc05cc2a$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Profiler", () => $1ea2922cdc05cc2a$export$e2c29f18771995cb, (v) => $1ea2922cdc05cc2a$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "Suspense", () => $1ea2922cdc05cc2a$export$74bf444e3cd11ea5, (v) => $1ea2922cdc05cc2a$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "Children", () => $1ea2922cdc05cc2a$export$dca3b0875bd9a954, (v) => $1ea2922cdc05cc2a$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1ea2922cdc05cc2a$export$16fa2f45be04daa8, (v) => $1ea2922cdc05cc2a$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "PureComponent", () => $1ea2922cdc05cc2a$export$221d75b3f55bb0bd, (v) => $1ea2922cdc05cc2a$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1ea2922cdc05cc2a$export$ae55be85d98224ed, (v) => $1ea2922cdc05cc2a$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $1ea2922cdc05cc2a$export$e530037191fcd5d7, (v) => $1ea2922cdc05cc2a$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1ea2922cdc05cc2a$export$fd42f52fd3ae1109, (v) => $1ea2922cdc05cc2a$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1ea2922cdc05cc2a$export$c8a8987d4410bf2d, (v) => $1ea2922cdc05cc2a$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1ea2922cdc05cc2a$export$d38cd72104c1f0e9, (v) => $1ea2922cdc05cc2a$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1ea2922cdc05cc2a$export$7d1e3a5e95ceca43, (v) => $1ea2922cdc05cc2a$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1ea2922cdc05cc2a$export$257a8862b851cb5b, (v) => $1ea2922cdc05cc2a$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1ea2922cdc05cc2a$export$a8257692ac88316c, (v) => $1ea2922cdc05cc2a$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1ea2922cdc05cc2a$export$488013bae63b21da, (v) => $1ea2922cdc05cc2a$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1ea2922cdc05cc2a$export$7c73462e0d25e514, (v) => $1ea2922cdc05cc2a$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "useCallback", () => $1ea2922cdc05cc2a$export$35808ee640e87ca7, (v) => $1ea2922cdc05cc2a$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1ea2922cdc05cc2a$export$fae74005e78b1a27, (v) => $1ea2922cdc05cc2a$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1ea2922cdc05cc2a$export$dc8fbce3eb94dc1e, (v) => $1ea2922cdc05cc2a$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useEffect", () => $1ea2922cdc05cc2a$export$6d9c69b0de29b591, (v) => $1ea2922cdc05cc2a$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1ea2922cdc05cc2a$export$d5a552a76deda3c2, (v) => $1ea2922cdc05cc2a$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1ea2922cdc05cc2a$export$e5c5a5f917a5871c, (v) => $1ea2922cdc05cc2a$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1ea2922cdc05cc2a$export$1538c33de8887b59, (v) => $1ea2922cdc05cc2a$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1ea2922cdc05cc2a$export$13e3392192263954, (v) => $1ea2922cdc05cc2a$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1ea2922cdc05cc2a$export$b8f5890fc79d6aca, (v) => $1ea2922cdc05cc2a$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1ea2922cdc05cc2a$export$60241385465d0a34, (v) => $1ea2922cdc05cc2a$export$60241385465d0a34 = v);
$parcel$export(module.exports, "version", () => $1ea2922cdc05cc2a$export$83d89fbfd8236492, (v) => $1ea2922cdc05cc2a$export$83d89fbfd8236492 = v);
/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1ea2922cdc05cc2a$export$ffb0004e005737fa;
var $1ea2922cdc05cc2a$export$5f8d39834fd61797;
var $1ea2922cdc05cc2a$export$e2c29f18771995cb;
var $1ea2922cdc05cc2a$export$74bf444e3cd11ea5;
var $1ea2922cdc05cc2a$export$dca3b0875bd9a954;
var $1ea2922cdc05cc2a$export$16fa2f45be04daa8;
var $1ea2922cdc05cc2a$export$221d75b3f55bb0bd;
var $1ea2922cdc05cc2a$export$ae55be85d98224ed;
var $1ea2922cdc05cc2a$export$e530037191fcd5d7;
var $1ea2922cdc05cc2a$export$fd42f52fd3ae1109;
var $1ea2922cdc05cc2a$export$c8a8987d4410bf2d;
var $1ea2922cdc05cc2a$export$d38cd72104c1f0e9;
var $1ea2922cdc05cc2a$export$7d1e3a5e95ceca43;
var $1ea2922cdc05cc2a$export$257a8862b851cb5b;
var $1ea2922cdc05cc2a$export$a8257692ac88316c;
var $1ea2922cdc05cc2a$export$488013bae63b21da;
var $1ea2922cdc05cc2a$export$7c73462e0d25e514;
var $1ea2922cdc05cc2a$export$35808ee640e87ca7;
var $1ea2922cdc05cc2a$export$fae74005e78b1a27;
var $1ea2922cdc05cc2a$export$dc8fbce3eb94dc1e;
var $1ea2922cdc05cc2a$export$6d9c69b0de29b591;
var $1ea2922cdc05cc2a$export$d5a552a76deda3c2;
var $1ea2922cdc05cc2a$export$e5c5a5f917a5871c;
var $1ea2922cdc05cc2a$export$1538c33de8887b59;
var $1ea2922cdc05cc2a$export$13e3392192263954;
var $1ea2922cdc05cc2a$export$b8f5890fc79d6aca;
var $1ea2922cdc05cc2a$export$60241385465d0a34;
var $1ea2922cdc05cc2a$export$83d89fbfd8236492;
'use strict';

var $5imMc = parcelRequire("5imMc");
var $1ea2922cdc05cc2a$var$n = 60103, $1ea2922cdc05cc2a$var$p = 60106;
$1ea2922cdc05cc2a$export$ffb0004e005737fa = 60107;
$1ea2922cdc05cc2a$export$5f8d39834fd61797 = 60108;
$1ea2922cdc05cc2a$export$e2c29f18771995cb = 60114;
var $1ea2922cdc05cc2a$var$q = 60109, $1ea2922cdc05cc2a$var$r = 60110, $1ea2922cdc05cc2a$var$t = 60112;
$1ea2922cdc05cc2a$export$74bf444e3cd11ea5 = 60113;
var $1ea2922cdc05cc2a$var$u = 60115, $1ea2922cdc05cc2a$var$v = 60116;
if ("function" === typeof Symbol && Symbol.for) {
    var $1ea2922cdc05cc2a$var$w = Symbol.for;
    $1ea2922cdc05cc2a$var$n = $1ea2922cdc05cc2a$var$w("react.element");
    $1ea2922cdc05cc2a$var$p = $1ea2922cdc05cc2a$var$w("react.portal");
    $1ea2922cdc05cc2a$export$ffb0004e005737fa = $1ea2922cdc05cc2a$var$w("react.fragment");
    $1ea2922cdc05cc2a$export$5f8d39834fd61797 = $1ea2922cdc05cc2a$var$w("react.strict_mode");
    $1ea2922cdc05cc2a$export$e2c29f18771995cb = $1ea2922cdc05cc2a$var$w("react.profiler");
    $1ea2922cdc05cc2a$var$q = $1ea2922cdc05cc2a$var$w("react.provider");
    $1ea2922cdc05cc2a$var$r = $1ea2922cdc05cc2a$var$w("react.context");
    $1ea2922cdc05cc2a$var$t = $1ea2922cdc05cc2a$var$w("react.forward_ref");
    $1ea2922cdc05cc2a$export$74bf444e3cd11ea5 = $1ea2922cdc05cc2a$var$w("react.suspense");
    $1ea2922cdc05cc2a$var$u = $1ea2922cdc05cc2a$var$w("react.memo");
    $1ea2922cdc05cc2a$var$v = $1ea2922cdc05cc2a$var$w("react.lazy");
}
var $1ea2922cdc05cc2a$var$x = "function" === typeof Symbol && Symbol.iterator;
function $1ea2922cdc05cc2a$var$y(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1ea2922cdc05cc2a$var$x && a[$1ea2922cdc05cc2a$var$x] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function $1ea2922cdc05cc2a$var$z(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $1ea2922cdc05cc2a$var$A = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1ea2922cdc05cc2a$var$B = {};
function $1ea2922cdc05cc2a$var$C(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $1ea2922cdc05cc2a$var$B;
    this.updater = c || $1ea2922cdc05cc2a$var$A;
}
$1ea2922cdc05cc2a$var$C.prototype.isReactComponent = {};
$1ea2922cdc05cc2a$var$C.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($1ea2922cdc05cc2a$var$z(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1ea2922cdc05cc2a$var$C.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1ea2922cdc05cc2a$var$D() {}
$1ea2922cdc05cc2a$var$D.prototype = $1ea2922cdc05cc2a$var$C.prototype;
function $1ea2922cdc05cc2a$var$E(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $1ea2922cdc05cc2a$var$B;
    this.updater = c || $1ea2922cdc05cc2a$var$A;
}
var $1ea2922cdc05cc2a$var$F = $1ea2922cdc05cc2a$var$E.prototype = new $1ea2922cdc05cc2a$var$D;
$1ea2922cdc05cc2a$var$F.constructor = $1ea2922cdc05cc2a$var$E;
$5imMc($1ea2922cdc05cc2a$var$F, $1ea2922cdc05cc2a$var$C.prototype);
$1ea2922cdc05cc2a$var$F.isPureReactComponent = !0;
var $1ea2922cdc05cc2a$var$G = {
    current: null
}, $1ea2922cdc05cc2a$var$H = Object.prototype.hasOwnProperty, $1ea2922cdc05cc2a$var$I = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1ea2922cdc05cc2a$var$J(a, b, c) {
    var e, d = {}, k = null, h = null;
    if (null != b) for(e in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1ea2922cdc05cc2a$var$H.call(b, e) && !$1ea2922cdc05cc2a$var$I.hasOwnProperty(e) && (d[e] = b[e]);
    var g = arguments.length - 2;
    if (1 === g) d.children = c;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        d.children = f;
    }
    if (a && a.defaultProps) for(e in g = a.defaultProps, g)void 0 === d[e] && (d[e] = g[e]);
    return {
        $$typeof: $1ea2922cdc05cc2a$var$n,
        type: a,
        key: k,
        ref: h,
        props: d,
        _owner: $1ea2922cdc05cc2a$var$G.current
    };
}
function $1ea2922cdc05cc2a$var$K(a, b) {
    return {
        $$typeof: $1ea2922cdc05cc2a$var$n,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1ea2922cdc05cc2a$var$L(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1ea2922cdc05cc2a$var$n;
}
function $1ea2922cdc05cc2a$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1ea2922cdc05cc2a$var$M = /\/+/g;
function $1ea2922cdc05cc2a$var$N(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1ea2922cdc05cc2a$var$escape("" + a.key) : b.toString(36);
}
function $1ea2922cdc05cc2a$var$O(a, b, c, e, d) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1ea2922cdc05cc2a$var$n:
                case $1ea2922cdc05cc2a$var$p:
                    h = !0;
            }
    }
    if (h) return h = a, d = d(h), a = "" === e ? "." + $1ea2922cdc05cc2a$var$N(h, 0) : e, Array.isArray(d) ? (c = "", null != a && (c = a.replace($1ea2922cdc05cc2a$var$M, "$&/") + "/"), $1ea2922cdc05cc2a$var$O(d, b, c, "", function(a) {
        return a;
    })) : null != d && ($1ea2922cdc05cc2a$var$L(d) && (d = $1ea2922cdc05cc2a$var$K(d, c + (!d.key || h && h.key === d.key ? "" : ("" + d.key).replace($1ea2922cdc05cc2a$var$M, "$&/") + "/") + a)), b.push(d)), 1;
    h = 0;
    e = "" === e ? "." : e + ":";
    if (Array.isArray(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = e + $1ea2922cdc05cc2a$var$N(k, g);
        h += $1ea2922cdc05cc2a$var$O(k, b, c, f, d);
    }
    else if (f = $1ea2922cdc05cc2a$var$y(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = e + $1ea2922cdc05cc2a$var$N(k, g++), h += $1ea2922cdc05cc2a$var$O(k, b, c, f, d);
    else if ("object" === k) throw b = "" + a, Error($1ea2922cdc05cc2a$var$z(31, "[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b));
    return h;
}
function $1ea2922cdc05cc2a$var$P(a, b, c) {
    if (null == a) return a;
    var e = [], d = 0;
    $1ea2922cdc05cc2a$var$O(a, e, "", "", function(a) {
        return b.call(c, a, d++);
    });
    return e;
}
function $1ea2922cdc05cc2a$var$Q(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        a._status = 0;
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
    if (1 === a._status) return a._result;
    throw a._result;
}
var $1ea2922cdc05cc2a$var$R = {
    current: null
};
function $1ea2922cdc05cc2a$var$S() {
    var a = $1ea2922cdc05cc2a$var$R.current;
    if (null === a) throw Error($1ea2922cdc05cc2a$var$z(321));
    return a;
}
var $1ea2922cdc05cc2a$var$T = {
    ReactCurrentDispatcher: $1ea2922cdc05cc2a$var$R,
    ReactCurrentBatchConfig: {
        transition: 0
    },
    ReactCurrentOwner: $1ea2922cdc05cc2a$var$G,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $5imMc
};
$1ea2922cdc05cc2a$export$dca3b0875bd9a954 = {
    map: $1ea2922cdc05cc2a$var$P,
    forEach: function(a, b, c) {
        $1ea2922cdc05cc2a$var$P(a, function() {
            b.apply(this, arguments);
        }, c);
    },
    count: function(a) {
        var b = 0;
        $1ea2922cdc05cc2a$var$P(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1ea2922cdc05cc2a$var$P(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1ea2922cdc05cc2a$var$L(a)) throw Error($1ea2922cdc05cc2a$var$z(143));
        return a;
    }
};
$1ea2922cdc05cc2a$export$16fa2f45be04daa8 = $1ea2922cdc05cc2a$var$C;
$1ea2922cdc05cc2a$export$221d75b3f55bb0bd = $1ea2922cdc05cc2a$var$E;
$1ea2922cdc05cc2a$export$ae55be85d98224ed = $1ea2922cdc05cc2a$var$T;
$1ea2922cdc05cc2a$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($1ea2922cdc05cc2a$var$z(267, a));
    var e = $5imMc({}, a.props), d = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1ea2922cdc05cc2a$var$G.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1ea2922cdc05cc2a$var$H.call(b, f) && !$1ea2922cdc05cc2a$var$I.hasOwnProperty(f) && (e[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) e.children = c;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        e.children = g;
    }
    return {
        $$typeof: $1ea2922cdc05cc2a$var$n,
        type: a.type,
        key: d,
        ref: k,
        props: e,
        _owner: h
    };
};
$1ea2922cdc05cc2a$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $1ea2922cdc05cc2a$var$r,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $1ea2922cdc05cc2a$var$q,
        _context: a
    };
    return a.Consumer = a;
};
$1ea2922cdc05cc2a$export$c8a8987d4410bf2d = $1ea2922cdc05cc2a$var$J;
$1ea2922cdc05cc2a$export$d38cd72104c1f0e9 = function(a) {
    var b = $1ea2922cdc05cc2a$var$J.bind(null, a);
    b.type = a;
    return b;
};
$1ea2922cdc05cc2a$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1ea2922cdc05cc2a$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1ea2922cdc05cc2a$var$t,
        render: a
    };
};
$1ea2922cdc05cc2a$export$a8257692ac88316c = $1ea2922cdc05cc2a$var$L;
$1ea2922cdc05cc2a$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1ea2922cdc05cc2a$var$v,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1ea2922cdc05cc2a$var$Q
    };
};
$1ea2922cdc05cc2a$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1ea2922cdc05cc2a$var$u,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1ea2922cdc05cc2a$export$35808ee640e87ca7 = function(a, b) {
    return $1ea2922cdc05cc2a$var$S().useCallback(a, b);
};
$1ea2922cdc05cc2a$export$fae74005e78b1a27 = function(a, b) {
    return $1ea2922cdc05cc2a$var$S().useContext(a, b);
};
$1ea2922cdc05cc2a$export$dc8fbce3eb94dc1e = function() {};
$1ea2922cdc05cc2a$export$6d9c69b0de29b591 = function(a, b) {
    return $1ea2922cdc05cc2a$var$S().useEffect(a, b);
};
$1ea2922cdc05cc2a$export$d5a552a76deda3c2 = function(a, b, c) {
    return $1ea2922cdc05cc2a$var$S().useImperativeHandle(a, b, c);
};
$1ea2922cdc05cc2a$export$e5c5a5f917a5871c = function(a, b) {
    return $1ea2922cdc05cc2a$var$S().useLayoutEffect(a, b);
};
$1ea2922cdc05cc2a$export$1538c33de8887b59 = function(a, b) {
    return $1ea2922cdc05cc2a$var$S().useMemo(a, b);
};
$1ea2922cdc05cc2a$export$13e3392192263954 = function(a, b, c) {
    return $1ea2922cdc05cc2a$var$S().useReducer(a, b, c);
};
$1ea2922cdc05cc2a$export$b8f5890fc79d6aca = function(a) {
    return $1ea2922cdc05cc2a$var$S().useRef(a);
};
$1ea2922cdc05cc2a$export$60241385465d0a34 = function(a) {
    return $1ea2922cdc05cc2a$var$S().useState(a);
};
$1ea2922cdc05cc2a$export$83d89fbfd8236492 = "17.0.2";

});



parcelRegister("bIn0m", function(module, exports) {
/** @license React v17.0.2
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';

var $tZqWC = parcelRequire("tZqWC");

var $5imMc = parcelRequire("5imMc");

var $7bPco = parcelRequire("7bPco");
function y(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$tZqWC) throw Error(y(227));
var ba = new Set, ca = {};
function da(a, b) {
    ea(a, b);
    ea(a + "Capture", b);
}
function ea(a, b) {
    ca[a] = b;
    for(a = 0; a < b.length; a++)ba.add(b[a]);
}
var fa = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ha = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, ia = Object.prototype.hasOwnProperty, ja = {}, ka = {};
function la(a) {
    if (ia.call(ka, a)) return !0;
    if (ia.call(ja, a)) return !1;
    if (ha.test(a)) return ka[a] = !0;
    ja[a] = !0;
    return !1;
}
function ma(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function na(a, b, c, d) {
    if (null === b || "undefined" === typeof b || ma(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function B(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var D = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    D[a] = new B(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    D[b] = new B(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    D[a] = new B(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    D[a] = new B(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    D[a] = new B(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    D[a] = new B(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    D[a] = new B(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var oa = /[\-:]([a-z])/g;
function pa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
D.xlinkHref = new B("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function qa(a, b, c, d) {
    var e = D.hasOwnProperty(b) ? D[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || (na(b, c, e, d) && (c = null), d || null === e ? la(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var ra = $tZqWC.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, sa = 60103, ta = 60106, ua = 60107, wa = 60108, xa = 60114, ya = 60109, za = 60110, Aa = 60112, Ba = 60113, Ca = 60120, Da = 60115, Ea = 60116, Fa = 60121, Ga = 60128, Ha = 60129, Ia = 60130, Ja = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var E = Symbol.for;
    sa = E("react.element");
    ta = E("react.portal");
    ua = E("react.fragment");
    wa = E("react.strict_mode");
    xa = E("react.profiler");
    ya = E("react.provider");
    za = E("react.context");
    Aa = E("react.forward_ref");
    Ba = E("react.suspense");
    Ca = E("react.suspense_list");
    Da = E("react.memo");
    Ea = E("react.lazy");
    Fa = E("react.block");
    E("react.scope");
    Ga = E("react.opaque.id");
    Ha = E("react.debug_trace_mode");
    Ia = E("react.offscreen");
    Ja = E("react.legacy_hidden");
}
var Ka = "function" === typeof Symbol && Symbol.iterator;
function La(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ka && a[Ka] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var Ma;
function Na(a) {
    if (void 0 === Ma) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        Ma = b && b[1] || "";
    }
    return "\n" + Ma + a;
}
var Oa = !1;
function Pa(a, b) {
    if (!a || Oa) return "";
    Oa = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (k) {
                    var d = k;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (k) {
                    d = k;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (k) {
                d = k;
            }
            a();
        }
    } catch (k) {
        if (k && d && "string" === typeof k.stack) {
            for(var e = k.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) return "\n" + e[g].replace(" at new ", " at ");
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Oa = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Na(a) : "";
}
function Qa(a) {
    switch(a.tag){
        case 5:
            return Na(a.type);
        case 16:
            return Na("Lazy");
        case 13:
            return Na("Suspense");
        case 19:
            return Na("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Pa(a.type, !1), a;
        case 11:
            return a = Pa(a.type.render, !1), a;
        case 22:
            return a = Pa(a.type._render, !1), a;
        case 1:
            return a = Pa(a.type, !0), a;
        default:
            return "";
    }
}
function Ra(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ua:
            return "Fragment";
        case ta:
            return "Portal";
        case xa:
            return "Profiler";
        case wa:
            return "StrictMode";
        case Ba:
            return "Suspense";
        case Ca:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case za:
            return (a.displayName || "Context") + ".Consumer";
        case ya:
            return (a._context.displayName || "Context") + ".Provider";
        case Aa:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case Da:
            return Ra(a.type);
        case Fa:
            return Ra(a._render);
        case Ea:
            b = a._payload;
            a = a._init;
            try {
                return Ra(a(b));
            } catch (c) {}
    }
    return null;
}
function Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return $5imMc({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $a(a, b) {
    b = b.checked;
    null != b && qa(a, "checked", b, !1);
}
function ab(a, b) {
    $a(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && bb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function bb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function db(a) {
    var b = "";
    $tZqWC.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function eb(a, b) {
    a = $5imMc({
        children: void 0
    }, b);
    if (b = db(b.children)) a.children = b;
    return a;
}
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(y(91));
    return $5imMc({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(y(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error(y(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var kb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function lb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function mb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? lb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var nb, ob = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== kb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        nb = nb || document.createElement("div");
        nb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = nb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function pb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var qb = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, rb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(qb).forEach(function(a) {
    rb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        qb[b] = qb[a];
    });
});
function sb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || qb.hasOwnProperty(a) && qb[a] ? ("" + b).trim() : b + "px";
}
function tb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = sb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var ub = $5imMc({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function vb(a, b) {
    if (b) {
        if (ub[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(y(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(y(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error(y(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(y(62));
    }
}
function wb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(y(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb(a, b, c, d, e) {
    return a(b, c, d, e);
}
function Ib() {}
var Jb = Gb, Kb = !1, Lb = !1;
function Mb() {
    if (null !== zb || null !== Ab) Ib(), Fb();
}
function Nb(a, b, c) {
    if (Lb) return a(b, c);
    Lb = !0;
    try {
        return Jb(a, b, c);
    } finally{
        Lb = !1, Mb();
    }
}
function Ob(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(y(231, b, typeof c));
    return c;
}
var Pb = !1;
if (fa) try {
    var Qb = {};
    Object.defineProperty(Qb, "passive", {
        get: function() {
            Pb = !0;
        }
    });
    window.addEventListener("test", Qb, Qb);
    window.removeEventListener("test", Qb, Qb);
} catch (a) {
    Pb = !1;
}
function Rb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var Sb = !1, Tb = null, Ub = !1, Vb = null, Wb = {
    onError: function(a) {
        Sb = !0;
        Tb = a;
    }
};
function Xb(a, b, c, d, e, f, g, h, k) {
    Sb = !1;
    Tb = null;
    Rb.apply(Wb, arguments);
}
function Yb(a, b, c, d, e, f, g, h, k) {
    Xb.apply(this, arguments);
    if (Sb) {
        if (Sb) {
            var l = Tb;
            Sb = !1;
            Tb = null;
        } else throw Error(y(198));
        Ub || (Ub = !0, Vb = l);
    }
}
function Zb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function ac(a) {
    if (Zb(a) !== a) throw Error(y(188));
}
function bc(a) {
    var b = a.alternate;
    if (!b) {
        b = Zb(a);
        if (null === b) throw Error(y(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return ac(e), a;
                if (f === d) return ac(e), b;
                f = f.sibling;
            }
            throw Error(y(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(y(189));
            }
        }
        if (c.alternate !== d) throw Error(y(190));
    }
    if (3 !== c.tag) throw Error(y(188));
    return c.stateNode.current === c ? a : b;
}
function cc(a) {
    a = bc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function dc(a, b) {
    for(var c = a.alternate; null !== b;){
        if (b === a || b === c) return !0;
        b = b.return;
    }
    return !1;
}
var ec, fc, gc, hc, ic = !1, jc = [], kc = null, lc = null, mc = null, nc = new Map, oc = new Map, pc = [], qc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function rc(a, b, c, d, e) {
    return {
        blockedOn: a,
        domEventName: b,
        eventSystemFlags: c | 16,
        nativeEvent: e,
        targetContainers: [
            d
        ]
    };
}
function sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            kc = null;
            break;
        case "dragenter":
        case "dragleave":
            lc = null;
            break;
        case "mouseover":
        case "mouseout":
            mc = null;
            break;
        case "pointerover":
        case "pointerout":
            nc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            oc.delete(b.pointerId);
    }
}
function tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = rc(b, c, d, e, f), null !== b && (b = Cb(b), null !== b && fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return kc = tc(kc, a, b, c, d, e), !0;
        case "dragenter":
            return lc = tc(lc, a, b, c, d, e), !0;
        case "mouseover":
            return mc = tc(mc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            nc.set(f, tc(nc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, oc.set(f, tc(oc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function vc(a) {
    var b = wc(a.target);
    if (null !== b) {
        var c = Zb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b(c), null !== b) {
                    a.blockedOn = b;
                    hc(a.lanePriority, function() {
                        $7bPco.unstable_runWithPriority(a.priority, function() {
                            gc(c);
                        });
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null !== c) return b = Cb(c), null !== b && fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function zc(a, b, c) {
    xc(a) && c.delete(b);
}
function Ac() {
    for(ic = !1; 0 < jc.length;){
        var a = jc[0];
        if (null !== a.blockedOn) {
            a = Cb(a.blockedOn);
            null !== a && ec(a);
            break;
        }
        for(var b = a.targetContainers; 0 < b.length;){
            var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
            if (null !== c) {
                a.blockedOn = c;
                break;
            }
            b.shift();
        }
        null === a.blockedOn && jc.shift();
    }
    null !== kc && xc(kc) && (kc = null);
    null !== lc && xc(lc) && (lc = null);
    null !== mc && xc(mc) && (mc = null);
    nc.forEach(zc);
    oc.forEach(zc);
}
function Bc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, ic || (ic = !0, $7bPco.unstable_scheduleCallback($7bPco.unstable_NormalPriority, Ac)));
}
function Cc(a) {
    function b(b) {
        return Bc(b, a);
    }
    if (0 < jc.length) {
        Bc(jc[0], a);
        for(var c = 1; c < jc.length; c++){
            var d = jc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== kc && Bc(kc, a);
    null !== lc && Bc(lc, a);
    null !== mc && Bc(mc, a);
    nc.forEach(b);
    oc.forEach(b);
    for(c = 0; c < pc.length; c++)d = pc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < pc.length && (c = pc[0], null === c.blockedOn);)vc(c), null === c.blockedOn && pc.shift();
}
function Dc(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var Ec = {
    animationend: Dc("Animation", "AnimationEnd"),
    animationiteration: Dc("Animation", "AnimationIteration"),
    animationstart: Dc("Animation", "AnimationStart"),
    transitionend: Dc("Transition", "TransitionEnd")
}, Fc = {}, Gc = {};
fa && (Gc = document.createElement("div").style, "AnimationEvent" in window || (delete Ec.animationend.animation, delete Ec.animationiteration.animation, delete Ec.animationstart.animation), "TransitionEvent" in window || delete Ec.transitionend.transition);
function Hc(a) {
    if (Fc[a]) return Fc[a];
    if (!Ec[a]) return a;
    var b = Ec[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Gc) return Fc[a] = b[c];
    return a;
}
var Ic = Hc("animationend"), Jc = Hc("animationiteration"), Kc = Hc("animationstart"), Lc = Hc("transitionend"), Mc = new Map, Nc = new Map, Oc = [
    "abort",
    "abort",
    Ic,
    "animationEnd",
    Jc,
    "animationIteration",
    Kc,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    Lc,
    "transitionEnd",
    "waiting",
    "waiting"
];
function Pc(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1];
        e = "on" + (e[0].toUpperCase() + e.slice(1));
        Nc.set(d, b);
        Mc.set(d, e);
        da(e, [
            d
        ]);
    }
}
var Qc = $7bPco.unstable_now;
Qc();
var F = 8;
function Rc(a) {
    if (0 !== (1 & a)) return F = 15, 1;
    if (0 !== (2 & a)) return F = 14, 2;
    if (0 !== (4 & a)) return F = 13, 4;
    var b = 24 & a;
    if (0 !== b) return F = 12, b;
    if (0 !== (a & 32)) return F = 11, 32;
    b = 192 & a;
    if (0 !== b) return F = 10, b;
    if (0 !== (a & 256)) return F = 9, 256;
    b = 3584 & a;
    if (0 !== b) return F = 8, b;
    if (0 !== (a & 4096)) return F = 7, 4096;
    b = 4186112 & a;
    if (0 !== b) return F = 6, b;
    b = 62914560 & a;
    if (0 !== b) return F = 5, b;
    if (a & 67108864) return F = 4, 67108864;
    if (0 !== (a & 134217728)) return F = 3, 134217728;
    b = 805306368 & a;
    if (0 !== b) return F = 2, b;
    if (0 !== (1073741824 & a)) return F = 1, 1073741824;
    F = 8;
    return a;
}
function Sc(a) {
    switch(a){
        case 99:
            return 15;
        case 98:
            return 10;
        case 97:
        case 96:
            return 8;
        case 95:
            return 2;
        default:
            return 0;
    }
}
function Tc(a) {
    switch(a){
        case 15:
        case 14:
            return 99;
        case 13:
        case 12:
        case 11:
        case 10:
            return 98;
        case 9:
        case 8:
        case 7:
        case 6:
        case 4:
        case 5:
            return 97;
        case 3:
        case 2:
        case 1:
            return 95;
        case 0:
            return 90;
        default:
            throw Error(y(358, a));
    }
}
function Uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return F = 0;
    var d = 0, e = 0, f = a.expiredLanes, g = a.suspendedLanes, h = a.pingedLanes;
    if (0 !== f) d = f, e = F = 15;
    else if (f = c & 134217727, 0 !== f) {
        var k = f & ~g;
        0 !== k ? (d = Rc(k), e = F) : (h &= f, 0 !== h && (d = Rc(h), e = F));
    } else f = c & ~g, 0 !== f ? (d = Rc(f), e = F) : 0 !== h && (d = Rc(h), e = F);
    if (0 === d) return 0;
    d = 31 - Vc(d);
    d = c & ((0 > d ? 0 : 1 << d) << 1) - 1;
    if (0 !== b && b !== d && 0 === (b & g)) {
        Rc(b);
        if (e <= F) return b;
        F = e;
    }
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - Vc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function Wc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function Xc(a, b) {
    switch(a){
        case 15:
            return 1;
        case 14:
            return 2;
        case 12:
            return a = Yc(24 & ~b), 0 === a ? Xc(10, b) : a;
        case 10:
            return a = Yc(192 & ~b), 0 === a ? Xc(8, b) : a;
        case 8:
            return a = Yc(3584 & ~b), 0 === a && (a = Yc(4186112 & ~b), 0 === a && (a = 512)), a;
        case 2:
            return b = Yc(805306368 & ~b), 0 === b && (b = 268435456), b;
    }
    throw Error(y(358, a));
}
function Yc(a) {
    return a & -a;
}
function Zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $c(a, b, c) {
    a.pendingLanes |= b;
    var d = b - 1;
    a.suspendedLanes &= d;
    a.pingedLanes &= d;
    a = a.eventTimes;
    b = 31 - Vc(b);
    a[b] = c;
}
var Vc = Math.clz32 ? Math.clz32 : ad, bd = Math.log, cd = Math.LN2;
function ad(a) {
    return 0 === a ? 32 : 31 - (bd(a) / cd | 0) | 0;
}
var dd = $7bPco.unstable_UserBlockingPriority, ed = $7bPco.unstable_runWithPriority, fd = !0;
function gd(a, b, c, d) {
    Kb || Ib();
    var e = hd, f = Kb;
    Kb = !0;
    try {
        Hb(e, a, b, c, d);
    } finally{
        (Kb = f) || Mb();
    }
}
function id(a, b, c, d) {
    ed(dd, hd.bind(null, a, b, c, d));
}
function hd(a, b, c, d) {
    if (fd) {
        var e;
        if ((e = 0 === (b & 4)) && 0 < jc.length && -1 < qc.indexOf(a)) a = rc(null, a, b, c, d), jc.push(a);
        else {
            var f = yc(a, b, c, d);
            if (null === f) e && sc(a, d);
            else {
                if (e) {
                    if (-1 < qc.indexOf(a)) {
                        a = rc(f, a, b, c, d);
                        jc.push(a);
                        return;
                    }
                    if (uc(f, a, b, c, d)) return;
                    sc(a, d);
                }
                jd(a, b, d, null, c);
            }
        }
    }
}
function yc(a, b, c, d) {
    var e = xb(d);
    e = wc(e);
    if (null !== e) {
        var f = Zb(e);
        if (null === f) e = null;
        else {
            var g = f.tag;
            if (13 === g) {
                e = $b(f);
                if (null !== e) return e;
                e = null;
            } else if (3 === g) {
                if (f.stateNode.hydrate) return 3 === f.tag ? f.stateNode.containerInfo : null;
                e = null;
            } else f !== e && (e = null);
        }
    }
    jd(a, b, d, e, c);
    return null;
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    $5imMc(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = $5imMc({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = $5imMc({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = $5imMc({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = $5imMc({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = $5imMc({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = $5imMc({}, sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = $5imMc({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = $5imMc({}, ud, {
    key: function(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = $5imMc({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = $5imMc({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = $5imMc({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = $5imMc({}, Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = fa && "CompositionEvent" in window, be = null;
fa && "documentMode" in document && (be = document.documentMode);
var ce = fa && "TextEvent" in window && !be, de = fa && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (fa) {
    var xe;
    if (fa) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        a = re;
        if (Kb) a(b);
        else {
            Kb = !0;
            try {
                Gb(a, b);
            } finally{
                Kb = !1, Mb();
            }
        }
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge, Ie = Object.prototype.hasOwnProperty;
function Je(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!Ie.call(b, c[d]) || !He(a[c[d]], b[c[d]])) return !1;
    return !0;
}
function Ke(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Le(a, b) {
    var c = Ke(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Ke(c);
    }
}
function Me(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Me(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Ne() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Oe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var Pe = fa && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Oe(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Je(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
Pc("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
Pc("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
Pc(Oc, 2);
for(var Ve = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), We = 0; We < Ve.length; We++)Nc.set(Ve[We], 0);
ea("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ea("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ea("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ea("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
da("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
da("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
da("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
da("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var Xe = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Ye = new Set("cancel close invalid load scroll toggle".split(" ").concat(Xe));
function Ze(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Yb(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
        }
    }
    if (Ub) throw a = Vb, Ub = !1, Vb = null, a;
}
function G(a, b) {
    var c = $e(b), d = a + "__bubble";
    c.has(d) || (af(b, a, 2, !1), c.add(d));
}
var bf = "_reactListening" + Math.random().toString(36).slice(2);
function cf(a) {
    a[bf] || (a[bf] = !0, ba.forEach(function(b) {
        Ye.has(b) || df(b, !1, a, null);
        df(b, !0, a, null);
    }));
}
function df(a, b, c, d) {
    var e = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 0, f = c;
    "selectionchange" === a && 9 !== c.nodeType && (f = c.ownerDocument);
    if (null !== d && !b && Ye.has(a)) {
        if ("scroll" !== a) return;
        e |= 2;
        f = d;
    }
    var g = $e(f), h = a + "__" + (b ? "capture" : "bubble");
    g.has(h) || (b && (e |= 4), af(f, a, e, b), g.add(h));
}
function af(a, b, c, d) {
    var e = Nc.get(b);
    switch(void 0 === e ? 2 : e){
        case 0:
            e = gd;
            break;
        case 1:
            e = id;
            break;
        default:
            e = hd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Pb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function jd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Nb(function() {
        var d = f, e = xb(c), g = [];
        a: {
            var h = Mc.get(a);
            if (void 0 !== h) {
                var k = td, x = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        x = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        x = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case Ic:
                    case Jc:
                    case Kc:
                        k = Hd;
                        break;
                    case Lc:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var w = 0 !== (b & 4), z = !w && "scroll" === a, u = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var t = d, q; null !== t;){
                    q = t;
                    var v = q.stateNode;
                    5 === q.tag && null !== v && (q = v, null !== u && (v = Ob(t, u), null != v && w.push(ef(t, v, q))));
                    if (z) break;
                    t = t.return;
                }
                0 < w.length && (h = new k(h, x, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && 0 === (b & 16) && (x = c.relatedTarget || c.fromElement) && (wc(x) || x[ff])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (x = c.relatedTarget || c.toElement, k = d, x = x ? wc(x) : null, null !== x && (z = Zb(x), x !== z || 5 !== x.tag && 6 !== x.tag)) x = null;
                    } else k = null, x = d;
                    if (k !== x) {
                        w = Bd;
                        v = "onMouseLeave";
                        u = "onMouseEnter";
                        t = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = Td, v = "onPointerLeave", u = "onPointerEnter", t = "pointer";
                        z = null == k ? h : ue(k);
                        q = null == x ? h : ue(x);
                        h = new w(v, t + "leave", k, c, e);
                        h.target = z;
                        h.relatedTarget = q;
                        v = null;
                        wc(e) === d && (w = new w(u, t + "enter", x, c, e), w.target = q, w.relatedTarget = z, v = w);
                        z = v;
                        if (k && x) b: {
                            w = k;
                            u = x;
                            t = 0;
                            for(q = w; q; q = gf(q))t++;
                            q = 0;
                            for(v = u; v; v = gf(v))q++;
                            for(; 0 < t - q;)w = gf(w), t--;
                            for(; 0 < q - t;)u = gf(u), q--;
                            for(; t--;){
                                if (w === u || null !== u && w === u.alternate) break b;
                                w = gf(w);
                                u = gf(u);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && hf(g, h, k, w, !1);
                        null !== x && null !== z && hf(g, z, x, w, !0);
                    }
                }
            }
            a: {
                h = d ? ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var J = ve;
                else if (me(h)) {
                    if (we) J = Fe;
                    else {
                        J = De;
                        var K = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (J = Ee);
                if (J && (J = J(a, d))) {
                    ne(g, J, c, e);
                    break a;
                }
                K && K(a, h, d);
                "focusout" === a && (K = h._wrapperState) && K.controlled && "number" === h.type && bb(h, "number", h.value);
            }
            K = d ? ue(d) : window;
            switch(a){
                case "focusin":
                    if (me(K) || "true" === K.contentEditable) Qe = K, Re = d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, e);
            }
            var Q;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var L = "onCompositionStart";
                        break b;
                    case "compositionend":
                        L = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        L = "onCompositionUpdate";
                        break b;
                }
                L = void 0;
            }
            else ie ? ge(a, c) && (L = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (L = "onCompositionStart");
            L && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== L ? "onCompositionEnd" === L && ie && (Q = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), K = oe(d, L), 0 < K.length && (L = new Ld(L, a, null, c, e), g.push({
                event: L,
                listeners: K
            }), Q ? L.data = Q : (Q = he(c), null !== Q && (L.data = Q))));
            if (Q = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = Q);
        }
        se(g, b);
    });
}
function ef(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Ob(a, c), null != f && d.unshift(ef(a, f, e)), f = Ob(a, b), null != f && d.push(ef(a, f, e)));
        a = a.return;
    }
    return d;
}
function gf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function hf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Ob(c, f), null != k && g.unshift(ef(c, k, h))) : e || (k = Ob(c, f), null != k && g.push(ef(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
function jf() {}
var kf = null, lf = null;
function mf(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function nf(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var of = "function" === typeof setTimeout ? setTimeout : void 0, pf = "function" === typeof clearTimeout ? clearTimeout : void 0;
function qf(a) {
    1 === a.nodeType ? a.textContent = "" : 9 === a.nodeType && (a = a.body, null != a && (a.textContent = ""));
}
function rf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function sf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var tf = 0;
function uf(a) {
    return {
        $$typeof: Ga,
        toString: a,
        valueOf: a
    };
}
var vf = Math.random().toString(36).slice(2), wf = "__reactFiber$" + vf, xf = "__reactProps$" + vf, ff = "__reactContainer$" + vf, yf = "__reactEvents$" + vf;
function wc(a) {
    var b = a[wf];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[ff] || c[wf]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = sf(a); null !== a;){
                if (c = a[wf]) return c;
                a = sf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[wf] || a[ff];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(y(33));
}
function Db(a) {
    return a[xf] || null;
}
function $e(a) {
    var b = a[yf];
    void 0 === b && (b = a[yf] = new Set);
    return b;
}
var zf = [], Af = -1;
function Bf(a) {
    return {
        current: a
    };
}
function H(a) {
    0 > Af || (a.current = zf[Af], zf[Af] = null, Af--);
}
function I(a, b) {
    Af++;
    zf[Af] = a.current;
    a.current = b;
}
var Cf = {}, M = Bf(Cf), N = Bf(!1), Df = Cf;
function Ef(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Cf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Ff(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function Gf() {
    H(N);
    H(M);
}
function Hf(a, b, c) {
    if (M.current !== Cf) throw Error(y(168));
    I(M, b);
    I(N, c);
}
function If(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error(y(108, Ra(b) || "Unknown", e));
    return $5imMc({}, c, d);
}
function Jf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Cf;
    Df = M.current;
    I(M, a);
    I(N, N.current);
    return !0;
}
function Kf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(y(169));
    c ? (a = If(a, b, Df), d.__reactInternalMemoizedMergedChildContext = a, H(N), H(M), I(M, a)) : H(N);
    I(N, c);
}
var Lf = null, Mf = null, Nf = $7bPco.unstable_runWithPriority, Of = $7bPco.unstable_scheduleCallback, Pf = $7bPco.unstable_cancelCallback, Qf = $7bPco.unstable_shouldYield, Rf = $7bPco.unstable_requestPaint, Sf = $7bPco.unstable_now, Tf = $7bPco.unstable_getCurrentPriorityLevel, Uf = $7bPco.unstable_ImmediatePriority, Vf = $7bPco.unstable_UserBlockingPriority, Wf = $7bPco.unstable_NormalPriority, Xf = $7bPco.unstable_LowPriority, Yf = $7bPco.unstable_IdlePriority, Zf = {}, $f = void 0 !== Rf ? Rf : function() {}, ag = null, bg = null, cg = !1, dg = Sf(), O = 1E4 > dg ? Sf : function() {
    return Sf() - dg;
};
function eg() {
    switch(Tf()){
        case Uf:
            return 99;
        case Vf:
            return 98;
        case Wf:
            return 97;
        case Xf:
            return 96;
        case Yf:
            return 95;
        default:
            throw Error(y(332));
    }
}
function fg(a) {
    switch(a){
        case 99:
            return Uf;
        case 98:
            return Vf;
        case 97:
            return Wf;
        case 96:
            return Xf;
        case 95:
            return Yf;
        default:
            throw Error(y(332));
    }
}
function gg(a, b) {
    a = fg(a);
    return Nf(a, b);
}
function hg(a, b, c) {
    a = fg(a);
    return Of(a, b, c);
}
function ig() {
    if (null !== bg) {
        var a = bg;
        bg = null;
        Pf(a);
    }
    jg();
}
function jg() {
    if (!cg && null !== ag) {
        cg = !0;
        var a = 0;
        try {
            var b = ag;
            gg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            ag = null;
        } catch (c) {
            throw null !== ag && (ag = ag.slice(a + 1)), Of(Uf, ig), c;
        } finally{
            cg = !1;
        }
    }
}
var kg = ra.ReactCurrentBatchConfig;
function lg(a, b) {
    if (a && a.defaultProps) {
        b = $5imMc({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var mg = Bf(null), ng = null, og = null, pg = null;
function qg() {
    pg = og = ng = null;
}
function rg(a) {
    var b = mg.current;
    H(mg);
    a.type._context._currentValue = b;
}
function sg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if ((a.childLanes & b) === b) {
            if (null === c || (c.childLanes & b) === b) break;
            else c.childLanes |= b;
        } else a.childLanes |= b, null !== c && (c.childLanes |= b);
        a = a.return;
    }
}
function tg(a, b) {
    ng = a;
    pg = og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (ug = !0), a.firstContext = null);
}
function vg(a, b) {
    if (pg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) pg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === og) {
            if (null === ng) throw Error(y(308));
            og = b;
            ng.dependencies = {
                lanes: 0,
                firstContext: b,
                responders: null
            };
        } else og = og.next = b;
    }
    return a._currentValue;
}
var wg = !1;
function xg(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function yg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function zg(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function Ag(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function Bg(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function Cg(a, b, c, d) {
    var e = a.updateQueue;
    wg = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        if (null !== n) {
            n = n.updateQueue;
            var A = n.lastBaseUpdate;
            A !== g && (null === A ? n.firstBaseUpdate = l : A.next = l, n.lastBaseUpdate = k);
        }
    }
    if (null !== f) {
        A = e.baseState;
        g = 0;
        n = l = k = null;
        do {
            h = f.lane;
            var p = f.eventTime;
            if ((d & h) === h) {
                null !== n && (n = n.next = {
                    eventTime: p,
                    lane: 0,
                    tag: f.tag,
                    payload: f.payload,
                    callback: f.callback,
                    next: null
                });
                a: {
                    var C = a, x = f;
                    h = b;
                    p = c;
                    switch(x.tag){
                        case 1:
                            C = x.payload;
                            if ("function" === typeof C) {
                                A = C.call(p, A, h);
                                break a;
                            }
                            A = C;
                            break a;
                        case 3:
                            C.flags = C.flags & -4097 | 64;
                        case 0:
                            C = x.payload;
                            h = "function" === typeof C ? C.call(p, A, h) : C;
                            if (null === h || void 0 === h) break a;
                            A = $5imMc({}, A, h);
                            break a;
                        case 2:
                            wg = !0;
                    }
                }
                null !== f.callback && (a.flags |= 32, h = e.effects, null === h ? e.effects = [
                    f
                ] : h.push(f));
            } else p = {
                eventTime: p,
                lane: h,
                tag: f.tag,
                payload: f.payload,
                callback: f.callback,
                next: null
            }, null === n ? (l = n = p, k = A) : n = n.next = p, g |= h;
            f = f.next;
            if (null === f) {
                if (h = e.shared.pending, null === h) break;
                else f = h.next, h.next = null, e.lastBaseUpdate = h, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = A);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        Dg |= g;
        a.lanes = g;
        a.memoizedState = A;
    }
}
function Eg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(y(191, e));
            e.call(d);
        }
    }
}
var Fg = (new $tZqWC.Component).refs;
function Gg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $5imMc({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var Kg = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Zb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = Hg(), d = Ig(a), e = zg(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        Ag(a, e);
        Jg(a, d, c);
    }
};
function Lg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Je(c, d) || !Je(e, f) : !0;
}
function Mg(a, b, c) {
    var d = !1, e = Cf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = vg(f) : (e = Ff(b) ? Df : M.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Ef(a, e) : Cf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Kg;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Ng(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Kg.enqueueReplaceState(b, b.state, null);
}
function Og(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Fg;
    xg(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = vg(f) : (f = Ff(b) ? Df : M.current, e.context = Ef(a, f));
    Cg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Gg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Kg.enqueueReplaceState(e, e.state, null), Cg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4);
}
var Pg = Array.isArray;
function Qg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(y(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(y(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === Fg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error(y(284));
        if (!c._owner) throw Error(y(290, a));
    }
    return a;
}
function Rg(a, b) {
    if ("textarea" !== a.type) throw Error(y(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b));
}
function Sg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.flags = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Tg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags = 2, c) : d;
        b.flags = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Ug(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Qg(a, b, c), d.return = a, d;
        d = Vg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Qg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Wg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Xg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function A(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = Ug("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case sa:
                    return c = Vg(b.type, b.key, b.props, null, a.mode, c), c.ref = Qg(a, null, b), c.return = a, c;
                case ta:
                    return b = Wg(b, a.mode, c), b.return = a, b;
            }
            if (Pg(b) || La(b)) return b = Xg(b, a.mode, c, null), b.return = a, b;
            Rg(a, b);
        }
        return null;
    }
    function p(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case sa:
                    return c.key === e ? c.type === ua ? n(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case ta:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if (Pg(c) || La(c)) return null !== e ? null : n(a, b, c, d, null);
            Rg(a, c);
        }
        return null;
    }
    function C(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case sa:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === ua ? n(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case ta:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if (Pg(d) || La(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            Rg(b, d);
        }
        return null;
    }
    function x(e, g, h, k) {
        for(var l = null, t = null, u = g, z = g = 0, q = null; null !== u && z < h.length; z++){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var n = p(e, u, h[z], k);
            if (null === n) {
                null === u && (u = q);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, z);
            null === t ? l = n : t.sibling = n;
            t = n;
            u = q;
        }
        if (z === h.length) return c(e, u), l;
        if (null === u) {
            for(; z < h.length; z++)u = A(e, h[z], k), null !== u && (g = f(u, g, z), null === t ? l = u : t.sibling = u, t = u);
            return l;
        }
        for(u = d(e, u); z < h.length; z++)q = C(u, e, z, h[z], k), null !== q && (a && null !== q.alternate && u.delete(null === q.key ? z : q.key), g = f(q, g, z), null === t ? l = q : t.sibling = q, t = q);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function w(e, g, h, k) {
        var l = La(h);
        if ("function" !== typeof l) throw Error(y(150));
        h = l.call(h);
        if (null == h) throw Error(y(151));
        for(var t = l = null, u = g, z = g = 0, q = null, n = h.next(); null !== u && !n.done; z++, n = h.next()){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var w = p(e, u, n.value, k);
            if (null === w) {
                null === u && (u = q);
                break;
            }
            a && u && null === w.alternate && b(e, u);
            g = f(w, g, z);
            null === t ? l = w : t.sibling = w;
            t = w;
            u = q;
        }
        if (n.done) return c(e, u), l;
        if (null === u) {
            for(; !n.done; z++, n = h.next())n = A(e, n.value, k), null !== n && (g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
            return l;
        }
        for(u = d(e, u); !n.done; z++, n = h.next())n = C(u, e, z, n.value, k), null !== n && (a && null !== n.alternate && u.delete(null === n.key ? z : n.key), g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === ua && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case sa:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === ua) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = Qg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === ua ? (d = Xg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Vg(f.type, f.key, f.props, null, a.mode, h), h.ref = Qg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case ta:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = Wg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Ug(f, a.mode, h), d.return = a, a = d), g(a);
        if (Pg(f)) return x(a, d, f, h);
        if (La(f)) return w(a, d, f, h);
        l && Rg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 22:
            case 0:
            case 11:
            case 15:
                throw Error(y(152, Ra(a.type) || "Component"));
        }
        return c(a, d);
    };
}
var Yg = Sg(!0), Zg = Sg(!1), $g = {}, ah = Bf($g), bh = Bf($g), ch = Bf($g);
function dh(a) {
    if (a === $g) throw Error(y(174));
    return a;
}
function eh(a, b) {
    I(ch, b);
    I(bh, a);
    I(ah, $g);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : mb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = mb(b, a);
    }
    H(ah);
    I(ah, b);
}
function fh() {
    H(ah);
    H(bh);
    H(ch);
}
function gh(a) {
    dh(ch.current);
    var b = dh(ah.current);
    var c = mb(b, a.type);
    b !== c && (I(bh, a), I(ah, c));
}
function hh(a) {
    bh.current === a && (H(ah), H(bh));
}
var P = Bf(0);
function ih(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var jh = null, kh = null, lh = !1;
function mh(a, b) {
    var c = nh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.flags = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function oh(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function ph(a) {
    if (lh) {
        var b = kh;
        if (b) {
            var c = b;
            if (!oh(a, b)) {
                b = rf(c.nextSibling);
                if (!b || !oh(a, b)) {
                    a.flags = a.flags & -1025 | 2;
                    lh = !1;
                    jh = a;
                    return;
                }
                mh(jh, c);
            }
            jh = a;
            kh = rf(b.firstChild);
        } else a.flags = a.flags & -1025 | 2, lh = !1, jh = a;
    }
}
function qh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    jh = a;
}
function rh(a) {
    if (a !== jh) return !1;
    if (!lh) return qh(a), lh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !nf(b, a.memoizedProps)) for(b = kh; b;)mh(a, b), b = rf(b.nextSibling);
    qh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(y(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            kh = rf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            kh = null;
        }
    } else kh = jh ? rf(a.stateNode.nextSibling) : null;
    return !0;
}
function sh() {
    kh = jh = null;
    lh = !1;
}
var th = [];
function uh() {
    for(var a = 0; a < th.length; a++)th[a]._workInProgressVersionPrimary = null;
    th.length = 0;
}
var vh = ra.ReactCurrentDispatcher, wh = ra.ReactCurrentBatchConfig, xh = 0, R = null, S = null, T = null, yh = !1, zh = !1;
function Ah() {
    throw Error(y(321));
}
function Bh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Ch(a, b, c, d, e, f) {
    xh = f;
    R = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    vh.current = null === a || null === a.memoizedState ? Dh : Eh;
    a = c(d, e);
    if (zh) {
        f = 0;
        do {
            zh = !1;
            if (!(25 > f)) throw Error(y(301));
            f += 1;
            T = S = null;
            b.updateQueue = null;
            vh.current = Fh;
            a = c(d, e);
        }while (zh);
    }
    vh.current = Gh;
    b = null !== S && null !== S.next;
    xh = 0;
    T = S = R = null;
    yh = !1;
    if (b) throw Error(y(300));
    return a;
}
function Hh() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === T ? R.memoizedState = T = a : T = T.next = a;
    return T;
}
function Ih() {
    if (null === S) {
        var a = R.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = S.next;
    var b = null === T ? R.memoizedState : T.next;
    if (null !== b) T = b, S = a;
    else {
        if (null === a) throw Error(y(310));
        S = a;
        a = {
            memoizedState: S.memoizedState,
            baseState: S.baseState,
            baseQueue: S.baseQueue,
            queue: S.queue,
            next: null
        };
        null === T ? R.memoizedState = T = a : T = T.next = a;
    }
    return T;
}
function Jh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function Kh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = S, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.lane;
            if ((xh & l) === l) null !== h && (h = h.next = {
                lane: 0,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            else {
                var n = {
                    lane: l,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = n, f = d) : h = h.next = n;
                R.lanes |= l;
                Dg |= l;
            }
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        He(d, b.memoizedState) || (ug = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function Lh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function Mh(a, b, c) {
    var d = b._getVersion;
    d = d(b._source);
    var e = b._workInProgressVersionPrimary;
    if (null !== e) a = e === d;
    else if (a = a.mutableReadLanes, a = (xh & a) === a) b._workInProgressVersionPrimary = d, th.push(b);
    if (a) return c(b._source);
    th.push(b);
    throw Error(y(350));
}
function Nh(a, b, c, d) {
    var e = U;
    if (null === e) throw Error(y(349));
    var f = b._getVersion, g = f(b._source), h = vh.current, k = h.useState(function() {
        return Mh(e, b, c);
    }), l = k[1], n = k[0];
    k = T;
    var A = a.memoizedState, p = A.refs, C = p.getSnapshot, x = A.source;
    A = A.subscribe;
    var w = R;
    a.memoizedState = {
        refs: p,
        source: b,
        subscribe: d
    };
    h.useEffect(function() {
        p.getSnapshot = c;
        p.setSnapshot = l;
        var a = f(b._source);
        if (!He(g, a)) {
            a = c(b._source);
            He(n, a) || (l(a), a = Ig(w), e.mutableReadLanes |= a & e.pendingLanes);
            a = e.mutableReadLanes;
            e.entangledLanes |= a;
            for(var d = e.entanglements, h = a; 0 < h;){
                var k = 31 - Vc(h), v = 1 << k;
                d[k] |= a;
                h &= ~v;
            }
        }
    }, [
        c,
        b,
        d
    ]);
    h.useEffect(function() {
        return d(b._source, function() {
            var a = p.getSnapshot, c = p.setSnapshot;
            try {
                c(a(b._source));
                var d = Ig(w);
                e.mutableReadLanes |= d & e.pendingLanes;
            } catch (q) {
                c(function() {
                    throw q;
                });
            }
        });
    }, [
        b,
        d
    ]);
    He(C, c) && He(x, b) && He(A, d) || (a = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: n
    }, a.dispatch = l = Oh.bind(null, R, a), k.queue = a, k.baseQueue = null, n = Mh(e, b, c), k.memoizedState = k.baseState = n);
    return n;
}
function Ph(a, b, c) {
    var d = Ih();
    return Nh(d, a, b, c);
}
function Qh(a) {
    var b = Hh();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: a
    };
    a = a.dispatch = Oh.bind(null, R, a);
    return [
        b.memoizedState,
        a
    ];
}
function Rh(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = R.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, R.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function Sh(a) {
    var b = Hh();
    a = {
        current: a
    };
    return b.memoizedState = a;
}
function Th() {
    return Ih().memoizedState;
}
function Uh(a, b, c, d) {
    var e = Hh();
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, void 0, void 0 === d ? null : d);
}
function Vh(a, b, c, d) {
    var e = Ih();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== S) {
        var g = S.memoizedState;
        f = g.destroy;
        if (null !== d && Bh(d, g.deps)) {
            Rh(b, c, f, d);
            return;
        }
    }
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, f, d);
}
function Wh(a, b) {
    return Uh(516, 4, a, b);
}
function Xh(a, b) {
    return Vh(516, 4, a, b);
}
function Yh(a, b) {
    return Vh(4, 2, a, b);
}
function Zh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $h(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return Vh(4, 2, Zh.bind(null, b, a), c);
}
function ai() {}
function bi(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ci(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function di(a, b) {
    var c = eg();
    gg(98 > c ? 98 : c, function() {
        a(!0);
    });
    gg(97 < c ? 97 : c, function() {
        var c = wh.transition;
        wh.transition = 1;
        try {
            a(!1), b();
        } finally{
            wh.transition = c;
        }
    });
}
function Oh(a, b, c) {
    var d = Hg(), e = Ig(a), f = {
        lane: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    }, g = b.pending;
    null === g ? f.next = f : (f.next = g.next, g.next = f);
    b.pending = f;
    g = a.alternate;
    if (a === R || null !== g && g === R) zh = yh = !0;
    else {
        if (0 === a.lanes && (null === g || 0 === g.lanes) && (g = b.lastRenderedReducer, null !== g)) try {
            var h = b.lastRenderedState, k = g(h, c);
            f.eagerReducer = g;
            f.eagerState = k;
            if (He(k, h)) return;
        } catch (l) {} finally{}
        Jg(a, e, d);
    }
}
var Gh = {
    readContext: vg,
    useCallback: Ah,
    useContext: Ah,
    useEffect: Ah,
    useImperativeHandle: Ah,
    useLayoutEffect: Ah,
    useMemo: Ah,
    useReducer: Ah,
    useRef: Ah,
    useState: Ah,
    useDebugValue: Ah,
    useDeferredValue: Ah,
    useTransition: Ah,
    useMutableSource: Ah,
    useOpaqueIdentifier: Ah,
    unstable_isNewReconciler: !1
}, Dh = {
    readContext: vg,
    useCallback: function(a, b) {
        Hh().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: vg,
    useEffect: Wh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return Uh(4, 2, Zh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return Uh(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = Hh();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = Hh();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = Oh.bind(null, R, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: Sh,
    useState: Qh,
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Qh(a), c = b[0], d = b[1];
        Wh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Qh(!1), b = a[0];
        a = di.bind(null, a[1]);
        Sh(a);
        return [
            a,
            b
        ];
    },
    useMutableSource: function(a, b, c) {
        var d = Hh();
        d.memoizedState = {
            refs: {
                getSnapshot: b,
                setSnapshot: null
            },
            source: a,
            subscribe: c
        };
        return Nh(d, a, b, c);
    },
    useOpaqueIdentifier: function() {
        if (lh) {
            var a = !1, b = uf(function() {
                a || (a = !0, c("r:" + (tf++).toString(36)));
                throw Error(y(355));
            }), c = Qh(b)[1];
            0 === (R.mode & 2) && (R.flags |= 516, Rh(5, function() {
                c("r:" + (tf++).toString(36));
            }, void 0, null));
            return b;
        }
        b = "r:" + (tf++).toString(36);
        Qh(b);
        return b;
    },
    unstable_isNewReconciler: !1
}, Eh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Kh,
    useRef: Th,
    useState: function() {
        return Kh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Kh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Kh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Kh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, Fh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Lh,
    useRef: Th,
    useState: function() {
        return Lh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Lh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Lh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Lh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, ei = ra.ReactCurrentOwner, ug = !1;
function fi(a, b, c, d) {
    b.child = null === a ? Zg(b, null, c, d) : Yg(b, a.child, c, d);
}
function gi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    tg(b, e);
    d = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, d, e);
    return b.child;
}
function ii(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !ji(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ki(a, b, g, d, e, f);
        a = Vg(c.type, null, d, b, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (0 === (e & f) && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : Je, c(e, d) && a.ref === b.ref)) return hi(a, b, f);
    b.flags |= 1;
    a = Tg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function ki(a, b, c, d, e, f) {
    if (null !== a && Je(a.memoizedProps, d) && a.ref === b.ref) {
        if (ug = !1, 0 !== (f & e)) 0 !== (a.flags & 16384) && (ug = !0);
        else return b.lanes = a.lanes, hi(a, b, f);
    }
    return li(a, b, c, d, f);
}
function mi(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode || "unstable-defer-without-hiding" === d.mode) {
        if (0 === (b.mode & 4)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, c);
        else if (0 !== (c & 1073741824)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, null !== f ? f.baseLanes : c);
        else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
            baseLanes: a
        }, ni(b, a), null;
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, ni(b, d);
    fi(a, b, e, c);
    return b.child;
}
function oi(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 128;
}
function li(a, b, c, d, e) {
    var f = Ff(c) ? Df : M.current;
    f = Ef(b, f);
    tg(b, e);
    c = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, c, e);
    return b.child;
}
function pi(a, b, c, d, e) {
    if (Ff(c)) {
        var f = !0;
        Jf(b);
    } else f = !1;
    tg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), Mg(b, c, d), Og(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = vg(l) : (l = Ff(c) ? Df : M.current, l = Ef(b, l));
        var n = c.getDerivedStateFromProps, A = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        A || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Ng(b, g, d, l);
        wg = !1;
        var p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        k = b.memoizedState;
        h !== d || p !== k || N.current || wg ? ("function" === typeof n && (Gg(b, c, n, d), k = b.memoizedState), (h = wg || Lg(b, c, h, d, p, k, l)) ? (A || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4)) : ("function" === typeof g.componentDidMount && (b.flags |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4), d = !1);
    } else {
        g = b.stateNode;
        yg(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : lg(b.type, h);
        g.props = l;
        A = b.pendingProps;
        p = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = vg(k) : (k = Ff(c) ? Df : M.current, k = Ef(b, k));
        var C = c.getDerivedStateFromProps;
        (n = "function" === typeof C || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== A || p !== k) && Ng(b, g, d, k);
        wg = !1;
        p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        var x = b.memoizedState;
        h !== A || p !== x || N.current || wg ? ("function" === typeof C && (Gg(b, c, C, d), x = b.memoizedState), (l = wg || Lg(b, c, l, d, p, x, k)) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), d = !1);
    }
    return qi(a, b, c, d, f, e);
}
function qi(a, b, c, d, e, f) {
    oi(a, b);
    var g = 0 !== (b.flags & 64);
    if (!d && !g) return e && Kf(b, c, !1), hi(a, b, f);
    d = b.stateNode;
    ei.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Yg(b, a.child, null, f), b.child = Yg(b, null, h, f)) : fi(a, b, h, f);
    b.memoizedState = d.state;
    e && Kf(b, c, !0);
    return b.child;
}
function ri(a) {
    var b = a.stateNode;
    b.pendingContext ? Hf(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Hf(a, b.context, !1);
    eh(a, b.containerInfo);
}
var si = {
    dehydrated: null,
    retryLane: 0
};
function ti(a, b, c) {
    var d = b.pendingProps, e = P.current, f = !1, g;
    (g = 0 !== (b.flags & 64)) || (g = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    g ? (f = !0, b.flags &= -65) : null !== a && null === a.memoizedState || void 0 === d.fallback || !0 === d.unstable_avoidThisFallback || (e |= 1);
    I(P, e & 1);
    if (null === a) {
        void 0 !== d.fallback && ph(b);
        a = d.children;
        e = d.fallback;
        if (f) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, a;
        if ("number" === typeof d.unstable_expectedLoadTime) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, b.lanes = 33554432, a;
        c = vi({
            mode: "visible",
            children: a
        }, b.mode, c, null);
        c.return = b;
        return b.child = c;
    }
    if (null !== a.memoizedState) {
        if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
            baseLanes: c
        } : {
            baseLanes: e.baseLanes | c
        }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
        c = xi(a, b, d.children, c);
        b.memoizedState = null;
        return c;
    }
    if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
        baseLanes: c
    } : {
        baseLanes: e.baseLanes | c
    }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
    c = xi(a, b, d.children, c);
    b.memoizedState = null;
    return c;
}
function ui(a, b, c, d) {
    var e = a.mode, f = a.child;
    b = {
        mode: "hidden",
        children: b
    };
    0 === (e & 2) && null !== f ? (f.childLanes = 0, f.pendingProps = b) : f = vi(b, e, 0, null);
    c = Xg(c, e, d, null);
    f.return = a;
    c.return = a;
    f.sibling = c;
    a.child = f;
    return c;
}
function xi(a, b, c, d) {
    var e = a.child;
    a = e.sibling;
    c = Tg(e, {
        mode: "visible",
        children: c
    });
    0 === (b.mode & 2) && (c.lanes = d);
    c.return = b;
    c.sibling = null;
    null !== a && (a.nextEffect = null, a.flags = 8, b.firstEffect = b.lastEffect = a);
    return b.child = c;
}
function wi(a, b, c, d, e) {
    var f = b.mode, g = a.child;
    a = g.sibling;
    var h = {
        mode: "hidden",
        children: c
    };
    0 === (f & 2) && b.child !== g ? (c = b.child, c.childLanes = 0, c.pendingProps = h, g = c.lastEffect, null !== g ? (b.firstEffect = c.firstEffect, b.lastEffect = g, g.nextEffect = null) : b.firstEffect = b.lastEffect = null) : c = Tg(g, h);
    null !== a ? d = Tg(a, d) : (d = Xg(d, f, e, null), d.flags |= 2);
    d.return = b;
    c.return = b;
    c.sibling = d;
    b.child = c;
    return d;
}
function yi(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    sg(a.return, b);
}
function zi(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailMode = e, g.lastEffect = f);
}
function Ai(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    fi(a, b, d.children, c);
    d = P.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 64;
    else {
        if (null !== a && 0 !== (a.flags & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && yi(a, c);
            else if (19 === a.tag) yi(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    I(P, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === ih(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            zi(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === ih(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            zi(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            zi(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function hi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    Dg |= b.lanes;
    if (0 !== (c & b.childLanes)) {
        if (null !== a && b.child !== a.child) throw Error(y(153));
        if (null !== b.child) {
            a = b.child;
            c = Tg(a, a.pendingProps);
            b.child = c;
            for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Tg(a, a.pendingProps), c.return = b;
            c.sibling = null;
        }
        return b.child;
    }
    return null;
}
var Bi, Ci, Di, Ei;
Bi = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Ci = function() {};
Di = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        dh(ah.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "option":
                e = eb(a, e);
                d = eb(a, d);
                f = [];
                break;
            case "select":
                e = $5imMc({}, e, {
                    value: void 0
                });
                d = $5imMc({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = jf);
        }
        vb(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ca.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ca.hasOwnProperty(l) ? (null != k && "onScroll" === l && G("scroll", a), f || h === k || (f = [])) : "object" === typeof k && null !== k && k.$$typeof === Ga ? k.toString() : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Ei = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Fi(a, b) {
    if (!lh) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function Gi(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return Ff(b.type) && Gf(), null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            d = b.stateNode;
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) rh(b) ? b.flags |= 4 : d.hydrate || (b.flags |= 256);
            Ci(b);
            return null;
        case 5:
            hh(b);
            var e = dh(ch.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Di(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(y(166));
                    return null;
                }
                a = dh(ah.current);
                if (rh(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[wf] = b;
                    d[xf] = f;
                    switch(c){
                        case "dialog":
                            G("cancel", d);
                            G("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < Xe.length; a++)G(Xe[a], d);
                            break;
                        case "source":
                            G("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", d);
                            G("load", d);
                            break;
                        case "details":
                            G("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            G("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            G("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), G("invalid", d);
                    }
                    vb(c, f);
                    a = null;
                    for(var g in f)f.hasOwnProperty(g) && (e = f[g], "children" === g ? "string" === typeof e ? d.textContent !== e && (a = [
                        "children",
                        e
                    ]) : "number" === typeof e && d.textContent !== "" + e && (a = [
                        "children",
                        "" + e
                    ]) : ca.hasOwnProperty(g) && null != e && "onScroll" === g && G("scroll", d));
                    switch(c){
                        case "input":
                            Va(d);
                            cb(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = jf);
                    }
                    d = a;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    a === kb.html && (a = lb(c));
                    a === kb.html ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[wf] = b;
                    a[xf] = d;
                    Bi(a, b, !1, !1);
                    b.stateNode = a;
                    g = wb(c, d);
                    switch(c){
                        case "dialog":
                            G("cancel", a);
                            G("close", a);
                            e = d;
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", a);
                            e = d;
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < Xe.length; e++)G(Xe[e], a);
                            e = d;
                            break;
                        case "source":
                            G("error", a);
                            e = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", a);
                            G("load", a);
                            e = d;
                            break;
                        case "details":
                            G("toggle", a);
                            e = d;
                            break;
                        case "input":
                            Za(a, d);
                            e = Ya(a, d);
                            G("invalid", a);
                            break;
                        case "option":
                            e = eb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            e = $5imMc({}, d, {
                                value: void 0
                            });
                            G("invalid", a);
                            break;
                        case "textarea":
                            hb(a, d);
                            e = gb(a, d);
                            G("invalid", a);
                            break;
                        default:
                            e = d;
                    }
                    vb(c, e);
                    var h = e;
                    for(f in h)if (h.hasOwnProperty(f)) {
                        var k = h[f];
                        "style" === f ? tb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && ob(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && pb(a, k) : "number" === typeof k && pb(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ca.hasOwnProperty(f) ? null != k && "onScroll" === f && G("scroll", a) : null != k && qa(a, f, k, g));
                    }
                    switch(c){
                        case "input":
                            Va(a);
                            cb(a, d, !1);
                            break;
                        case "textarea":
                            Va(a);
                            jb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + Sa(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            f = d.value;
                            null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof e.onClick && (a.onclick = jf);
                    }
                    mf(c, d) && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) Ei(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(y(166));
                c = dh(ch.current);
                dh(ah.current);
                rh(b) ? (d = b.stateNode, c = b.memoizedProps, d[wf] = b, d.nodeValue !== c && (b.flags |= 4)) : (d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[wf] = b, b.stateNode = d);
            }
            return null;
        case 13:
            H(P);
            d = b.memoizedState;
            if (0 !== (b.flags & 64)) return b.lanes = c, b;
            d = null !== d;
            c = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && rh(b) : c = null !== a.memoizedState;
            if (d && !c && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (P.current & 1)) 0 === V && (V = 3);
                else {
                    if (0 === V || 3 === V) V = 4;
                    null === U || 0 === (Dg & 134217727) && 0 === (Hi & 134217727) || Ii(U, W);
                }
            }
            if (d || c) b.flags |= 4;
            return null;
        case 4:
            return fh(), Ci(b), null === a && cf(b.stateNode.containerInfo), null;
        case 10:
            return rg(b), null;
        case 17:
            return Ff(b.type) && Gf(), null;
        case 19:
            H(P);
            d = b.memoizedState;
            if (null === d) return null;
            f = 0 !== (b.flags & 64);
            g = d.rendering;
            if (null === g) {
                if (f) Fi(d, !1);
                else {
                    if (0 !== V || null !== a && 0 !== (a.flags & 64)) for(a = b.child; null !== a;){
                        g = ih(a);
                        if (null !== g) {
                            b.flags |= 64;
                            Fi(d, !1);
                            f = g.updateQueue;
                            null !== f && (b.updateQueue = f, b.flags |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 2, f.nextEffect = null, f.firstEffect = null, f.lastEffect = null, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            I(P, P.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== d.tail && O() > Ji && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
            } else {
                if (!f) {
                    if (a = ih(g), null !== a) {
                        if (b.flags |= 64, f = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Fi(d, !0), null === d.tail && "hidden" === d.tailMode && !g.alternate && !lh) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * O() - d.renderingStartTime > Ji && 1073741824 !== c && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
                d.isBackwards ? (g.sibling = b.child, b.child = g) : (c = d.last, null !== c ? c.sibling = g : b.child = g, d.last = g);
            }
            return null !== d.tail ? (c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = O(), c.sibling = null, b = P.current, I(P, f ? b & 1 | 2 : b & 1), c) : null;
        case 23:
        case 24:
            return Ki(), null !== a && null !== a.memoizedState !== (null !== b.memoizedState) && "unstable-defer-without-hiding" !== d.mode && (b.flags |= 4), null;
    }
    throw Error(y(156, b.tag));
}
function Li(a) {
    switch(a.tag){
        case 1:
            Ff(a.type) && Gf();
            var b = a.flags;
            return b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            b = a.flags;
            if (0 !== (b & 64)) throw Error(y(285));
            a.flags = b & -4097 | 64;
            return a;
        case 5:
            return hh(a), null;
        case 13:
            return H(P), b = a.flags, b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 19:
            return H(P), null;
        case 4:
            return fh(), null;
        case 10:
            return rg(a), null;
        case 23:
        case 24:
            return Ki(), null;
        default:
            return null;
    }
}
function Mi(a, b) {
    try {
        var c = "", d = b;
        do c += Qa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e
    };
}
function Ni(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Oi = "function" === typeof WeakMap ? WeakMap : Map;
function Pi(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Qi || (Qi = !0, Ri = d);
        Ni(a, b);
    };
    return c;
}
function Si(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            Ni(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === Ti ? Ti = new Set([
            this
        ]) : Ti.add(this), Ni(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var Ui = "function" === typeof WeakSet ? WeakSet : Set;
function Vi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            Wi(a, c);
        }
        else b.current = null;
    }
}
function Xi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.flags & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : lg(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
            b.flags & 256 && qf(b.stateNode.containerInfo);
            return;
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error(y(163));
}
function Yi(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    if (3 === (a.tag & 3)) {
                        var d = a.create;
                        a.destroy = d();
                    }
                    a = a.next;
                }while (a !== b);
            }
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    var e = a;
                    d = e.next;
                    e = e.tag;
                    0 !== (e & 4) && 0 !== (e & 1) && (Zi(c, a), $i(c, a));
                    a = d;
                }while (a !== b);
            }
            return;
        case 1:
            a = c.stateNode;
            c.flags & 4 && (null === b ? a.componentDidMount() : (d = c.elementType === c.type ? b.memoizedProps : lg(c.type, b.memoizedProps), a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate)));
            b = c.updateQueue;
            null !== b && Eg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                Eg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.flags & 4 && mf(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Cc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
        case 23:
        case 24:
            return;
    }
    throw Error(y(163));
}
function aj(a, b) {
    for(var c = a;;){
        if (5 === c.tag) {
            var d = c.stateNode;
            if (b) d = d.style, "function" === typeof d.setProperty ? d.setProperty("display", "none", "important") : d.display = "none";
            else {
                d = c.stateNode;
                var e = c.memoizedProps.style;
                e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null;
                d.style.display = sb("display", e);
            }
        } else if (6 === c.tag) c.stateNode.nodeValue = b ? "" : c.memoizedProps;
        else if ((23 !== c.tag && 24 !== c.tag || null === c.memoizedState || c === a) && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === a) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === a) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function bj(a, b) {
    if (Mf && "function" === typeof Mf.onCommitFiberUnmount) try {
        Mf.onCommitFiberUnmount(Lf, b);
    } catch (f) {}
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var c = a = a.next;
                do {
                    var d = c, e = d.destroy;
                    d = d.tag;
                    if (void 0 !== e) {
                        if (0 !== (d & 4)) Zi(b, c);
                        else {
                            d = b;
                            try {
                                e();
                            } catch (f) {
                                Wi(d, f);
                            }
                        }
                    }
                    c = c.next;
                }while (c !== a);
            }
            break;
        case 1:
            Vi(b);
            a = b.stateNode;
            if ("function" === typeof a.componentWillUnmount) try {
                a.props = b.memoizedProps, a.state = b.memoizedState, a.componentWillUnmount();
            } catch (f) {
                Wi(b, f);
            }
            break;
        case 5:
            Vi(b);
            break;
        case 4:
            cj(a, b);
    }
}
function dj(a) {
    a.alternate = null;
    a.child = null;
    a.dependencies = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.return = null;
    a.updateQueue = null;
}
function ej(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function fj(a) {
    a: {
        for(var b = a.return; null !== b;){
            if (ej(b)) break a;
            b = b.return;
        }
        throw Error(y(160));
    }
    var c = b;
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error(y(161));
    }
    c.flags & 16 && (pb(b, ""), c.flags &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || ej(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.flags & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.flags & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? gj(a, c, b) : hj(a, c, b);
}
function gj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = jf));
    else if (4 !== d && (a = a.child, null !== a)) for(gj(a, b, c), a = a.sibling; null !== a;)gj(a, b, c), a = a.sibling;
}
function hj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(hj(a, b, c), a = a.sibling; null !== a;)hj(a, b, c), a = a.sibling;
}
function cj(a, b) {
    for(var c = b, d = !1, e, f;;){
        if (!d) {
            d = c.return;
            a: for(;;){
                if (null === d) throw Error(y(160));
                e = d.stateNode;
                switch(d.tag){
                    case 5:
                        f = !1;
                        break a;
                    case 3:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                    case 4:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                }
                d = d.return;
            }
            d = !0;
        }
        if (5 === c.tag || 6 === c.tag) {
            a: for(var g = a, h = c, k = h;;)if (bj(g, k), null !== k.child && 4 !== k.tag) k.child.return = k, k = k.child;
            else {
                if (k === h) break a;
                for(; null === k.sibling;){
                    if (null === k.return || k.return === h) break a;
                    k = k.return;
                }
                k.sibling.return = k.return;
                k = k.sibling;
            }
            f ? (g = e, h = c.stateNode, 8 === g.nodeType ? g.parentNode.removeChild(h) : g.removeChild(h)) : e.removeChild(c.stateNode);
        } else if (4 === c.tag) {
            if (null !== c.child) {
                e = c.stateNode.containerInfo;
                f = !0;
                c.child.return = c;
                c = c.child;
                continue;
            }
        } else if (bj(a, c), null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
            4 === c.tag && (d = !1);
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function ij(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            var c = b.updateQueue;
            c = null !== c ? c.lastEffect : null;
            if (null !== c) {
                var d = c = c.next;
                do 3 === (d.tag & 3) && (a = d.destroy, d.destroy = void 0, void 0 !== a && a()), d = d.next;
                while (d !== c);
            }
            return;
        case 1:
            return;
        case 5:
            c = b.stateNode;
            if (null != c) {
                d = b.memoizedProps;
                var e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[xf] = d;
                    "input" === a && "radio" === d.type && null != d.name && $a(c, d);
                    wb(a, e);
                    b = wb(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? tb(c, h) : "dangerouslySetInnerHTML" === g ? ob(c, h) : "children" === g ? pb(c, h) : qa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            ab(c, d);
                            break;
                        case "textarea":
                            ib(c, d);
                            break;
                        case "select":
                            a = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, f = d.value, null != f ? fb(c, !!d.multiple, f, !1) : a !== !!d.multiple && (null != d.defaultValue ? fb(c, !!d.multiple, d.defaultValue, !0) : fb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error(y(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            c = b.stateNode;
            c.hydrate && (c.hydrate = !1, Cc(c.containerInfo));
            return;
        case 12:
            return;
        case 13:
            null !== b.memoizedState && (jj = O(), aj(b.child, !0));
            kj(b);
            return;
        case 19:
            kj(b);
            return;
        case 17:
            return;
        case 23:
        case 24:
            aj(b, null !== b.memoizedState);
            return;
    }
    throw Error(y(163));
}
function kj(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Ui);
        b.forEach(function(b) {
            var d = lj.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function mj(a, b) {
    return null !== a && (a = a.memoizedState, null === a || null !== a.dehydrated) ? (b = b.memoizedState, null !== b && null === b.dehydrated) : !1;
}
var nj = Math.ceil, oj = ra.ReactCurrentDispatcher, pj = ra.ReactCurrentOwner, X = 0, U = null, Y = null, W = 0, qj = 0, rj = Bf(0), V = 0, sj = null, tj = 0, Dg = 0, Hi = 0, uj = 0, vj = null, jj = 0, Ji = Infinity;
function wj() {
    Ji = O() + 500;
}
var Z = null, Qi = !1, Ri = null, Ti = null, xj = !1, yj = null, zj = 90, Aj = [], Bj = [], Cj = null, Dj = 0, Ej = null, Fj = -1, Gj = 0, Hj = 0, Ij = null, Jj = !1;
function Hg() {
    return 0 !== (X & 48) ? O() : -1 !== Fj ? Fj : Fj = O();
}
function Ig(a) {
    a = a.mode;
    if (0 === (a & 2)) return 1;
    if (0 === (a & 4)) return 99 === eg() ? 1 : 2;
    0 === Gj && (Gj = tj);
    if (0 !== kg.transition) {
        0 !== Hj && (Hj = null !== vj ? vj.pendingLanes : 0);
        a = Gj;
        var b = 4186112 & ~Hj;
        b &= -b;
        0 === b && (a = 4186112 & ~a, b = a & -a, 0 === b && (b = 8192));
        return b;
    }
    a = eg();
    0 !== (X & 4) && 98 === a ? a = Xc(12, Gj) : (a = Sc(a), a = Xc(a, Gj));
    return a;
}
function Jg(a, b, c) {
    if (50 < Dj) throw Dj = 0, Ej = null, Error(y(185));
    a = Kj(a, b);
    if (null === a) return null;
    $c(a, b, c);
    a === U && (Hi |= b, 4 === V && Ii(a, W));
    var d = eg();
    1 === b ? 0 !== (X & 8) && 0 === (X & 48) ? Lj(a) : (Mj(a, c), 0 === X && (wj(), ig())) : (0 === (X & 4) || 98 !== d && 99 !== d || (null === Cj ? Cj = new Set([
        a
    ]) : Cj.add(a)), Mj(a, c));
    vj = a;
}
function Kj(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
function Mj(a, b) {
    for(var c = a.callbackNode, d = a.suspendedLanes, e = a.pingedLanes, f = a.expirationTimes, g = a.pendingLanes; 0 < g;){
        var h = 31 - Vc(g), k = 1 << h, l = f[h];
        if (-1 === l) {
            if (0 === (k & d) || 0 !== (k & e)) {
                l = b;
                Rc(k);
                var n = F;
                f[h] = 10 <= n ? l + 250 : 6 <= n ? l + 5E3 : -1;
            }
        } else l <= b && (a.expiredLanes |= k);
        g &= ~k;
    }
    d = Uc(a, a === U ? W : 0);
    b = F;
    if (0 === d) null !== c && (c !== Zf && Pf(c), a.callbackNode = null, a.callbackPriority = 0);
    else {
        if (null !== c) {
            if (a.callbackPriority === b) return;
            c !== Zf && Pf(c);
        }
        15 === b ? (c = Lj.bind(null, a), null === ag ? (ag = [
            c
        ], bg = Of(Uf, jg)) : ag.push(c), c = Zf) : 14 === b ? c = hg(99, Lj.bind(null, a)) : (c = Tc(b), c = hg(c, Nj.bind(null, a)));
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Nj(a) {
    Fj = -1;
    Hj = Gj = 0;
    if (0 !== (X & 48)) throw Error(y(327));
    var b = a.callbackNode;
    if (Oj() && a.callbackNode !== b) return null;
    var c = Uc(a, a === U ? W : 0);
    if (0 === c) return null;
    var d = c;
    var e = X;
    X |= 16;
    var f = Pj();
    if (U !== a || W !== d) wj(), Qj(a, d);
    for(;;)try {
        Rj();
        break;
    } catch (h) {
        Sj(a, h);
    }
    qg();
    oj.current = f;
    X = e;
    null !== Y ? d = 0 : (U = null, W = 0, d = V);
    if (0 !== (tj & Hi)) Qj(a, 0);
    else if (0 !== d) {
        2 === d && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), c = Wc(a), 0 !== c && (d = Tj(a, c)));
        if (1 === d) throw b = sj, Qj(a, 0), Ii(a, c), Mj(a, O()), b;
        a.finishedWork = a.current.alternate;
        a.finishedLanes = c;
        switch(d){
            case 0:
            case 1:
                throw Error(y(345));
            case 2:
                Uj(a);
                break;
            case 3:
                Ii(a, c);
                if ((c & 62914560) === c && (d = jj + 500 - O(), 10 < d)) {
                    if (0 !== Uc(a, 0)) break;
                    e = a.suspendedLanes;
                    if ((e & c) !== c) {
                        Hg();
                        a.pingedLanes |= a.suspendedLanes & e;
                        break;
                    }
                    a.timeoutHandle = of(Uj.bind(null, a), d);
                    break;
                }
                Uj(a);
                break;
            case 4:
                Ii(a, c);
                if ((c & 4186112) === c) break;
                d = a.eventTimes;
                for(e = -1; 0 < c;){
                    var g = 31 - Vc(c);
                    f = 1 << g;
                    g = d[g];
                    g > e && (e = g);
                    c &= ~f;
                }
                c = e;
                c = O() - c;
                c = (120 > c ? 120 : 480 > c ? 480 : 1080 > c ? 1080 : 1920 > c ? 1920 : 3E3 > c ? 3E3 : 4320 > c ? 4320 : 1960 * nj(c / 1960)) - c;
                if (10 < c) {
                    a.timeoutHandle = of(Uj.bind(null, a), c);
                    break;
                }
                Uj(a);
                break;
            case 5:
                Uj(a);
                break;
            default:
                throw Error(y(329));
        }
    }
    Mj(a, O());
    return a.callbackNode === b ? Nj.bind(null, a) : null;
}
function Ii(a, b) {
    b &= ~uj;
    b &= ~Hi;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - Vc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Lj(a) {
    if (0 !== (X & 48)) throw Error(y(327));
    Oj();
    if (a === U && 0 !== (a.expiredLanes & W)) {
        var b = W;
        var c = Tj(a, b);
        0 !== (tj & Hi) && (b = Uc(a, b), c = Tj(a, b));
    } else b = Uc(a, 0), c = Tj(a, b);
    0 !== a.tag && 2 === c && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), b = Wc(a), 0 !== b && (c = Tj(a, b)));
    if (1 === c) throw c = sj, Qj(a, 0), Ii(a, b), Mj(a, O()), c;
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Uj(a);
    Mj(a, O());
    return null;
}
function Vj() {
    if (null !== Cj) {
        var a = Cj;
        Cj = null;
        a.forEach(function(a) {
            a.expiredLanes |= 24 & a.pendingLanes;
            Mj(a, O());
        });
    }
    ig();
}
function Wj(a, b) {
    var c = X;
    X |= 1;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function Xj(a, b) {
    var c = X;
    X &= -2;
    X |= 8;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function ni(a, b) {
    I(rj, qj);
    qj |= b;
    tj |= b;
}
function Ki() {
    qj = rj.current;
    H(rj);
}
function Qj(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, pf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && Gf();
                break;
            case 3:
                fh();
                H(N);
                H(M);
                uh();
                break;
            case 5:
                hh(d);
                break;
            case 4:
                fh();
                break;
            case 13:
                H(P);
                break;
            case 19:
                H(P);
                break;
            case 10:
                rg(d);
                break;
            case 23:
            case 24:
                Ki();
        }
        c = c.return;
    }
    U = a;
    Y = Tg(a.current, null);
    W = qj = tj = b;
    V = 0;
    sj = null;
    uj = Hi = Dg = 0;
}
function Sj(a, b) {
    do {
        var c = Y;
        try {
            qg();
            vh.current = Gh;
            if (yh) {
                for(var d = R.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                yh = !1;
            }
            xh = 0;
            T = S = R = null;
            zh = !1;
            pj.current = null;
            if (null === c || null === c.return) {
                V = 1;
                sj = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = W;
                h.flags |= 2048;
                h.firstEffect = h.lastEffect = null;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k;
                    if (0 === (h.mode & 2)) {
                        var n = h.alternate;
                        n ? (h.updateQueue = n.updateQueue, h.memoizedState = n.memoizedState, h.lanes = n.lanes) : (h.updateQueue = null, h.memoizedState = null);
                    }
                    var A = 0 !== (P.current & 1), p = g;
                    do {
                        var C;
                        if (C = 13 === p.tag) {
                            var x = p.memoizedState;
                            if (null !== x) C = null !== x.dehydrated ? !0 : !1;
                            else {
                                var w = p.memoizedProps;
                                C = void 0 === w.fallback ? !1 : !0 !== w.unstable_avoidThisFallback ? !0 : A ? !1 : !0;
                            }
                        }
                        if (C) {
                            var z = p.updateQueue;
                            if (null === z) {
                                var u = new Set;
                                u.add(l);
                                p.updateQueue = u;
                            } else z.add(l);
                            if (0 === (p.mode & 2)) {
                                p.flags |= 64;
                                h.flags |= 16384;
                                h.flags &= -2981;
                                if (1 === h.tag) {
                                    if (null === h.alternate) h.tag = 17;
                                    else {
                                        var t = zg(-1, 1);
                                        t.tag = 2;
                                        Ag(h, t);
                                    }
                                }
                                h.lanes |= 1;
                                break a;
                            }
                            k = void 0;
                            h = b;
                            var q = f.pingCache;
                            null === q ? (q = f.pingCache = new Oi, k = new Set, q.set(l, k)) : (k = q.get(l), void 0 === k && (k = new Set, q.set(l, k)));
                            if (!k.has(h)) {
                                k.add(h);
                                var v = Yj.bind(null, f, l, h);
                                l.then(v, v);
                            }
                            p.flags |= 4096;
                            p.lanes = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    k = Error((Ra(h.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
                }
                5 !== V && (V = 2);
                k = Mi(k, h);
                p = g;
                do {
                    switch(p.tag){
                        case 3:
                            f = k;
                            p.flags |= 4096;
                            b &= -b;
                            p.lanes |= b;
                            var J = Pi(p, f, b);
                            Bg(p, J);
                            break a;
                        case 1:
                            f = k;
                            var K = p.type, Q = p.stateNode;
                            if (0 === (p.flags & 64) && ("function" === typeof K.getDerivedStateFromError || null !== Q && "function" === typeof Q.componentDidCatch && (null === Ti || !Ti.has(Q)))) {
                                p.flags |= 4096;
                                b &= -b;
                                p.lanes |= b;
                                var L = Si(p, f, b);
                                Bg(p, L);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            Zj(c);
        } catch (va) {
            b = va;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Pj() {
    var a = oj.current;
    oj.current = Gh;
    return null === a ? Gh : a;
}
function Tj(a, b) {
    var c = X;
    X |= 16;
    var d = Pj();
    U === a && W === b || Qj(a, b);
    for(;;)try {
        ak();
        break;
    } catch (e) {
        Sj(a, e);
    }
    qg();
    X = c;
    oj.current = d;
    if (null !== Y) throw Error(y(261));
    U = null;
    W = 0;
    return V;
}
function ak() {
    for(; null !== Y;)bk(Y);
}
function Rj() {
    for(; null !== Y && !Qf();)bk(Y);
}
function bk(a) {
    var b = ck(a.alternate, a, qj);
    a.memoizedProps = a.pendingProps;
    null === b ? Zj(a) : Y = b;
    pj.current = null;
}
function Zj(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 2048)) {
            c = Gi(c, b, qj);
            if (null !== c) {
                Y = c;
                return;
            }
            c = b;
            if (24 !== c.tag && 23 !== c.tag || null === c.memoizedState || 0 !== (qj & 1073741824) || 0 === (c.mode & 4)) {
                for(var d = 0, e = c.child; null !== e;)d |= e.lanes | e.childLanes, e = e.sibling;
                c.childLanes = d;
            }
            null !== a && 0 === (a.flags & 2048) && (null === a.firstEffect && (a.firstEffect = b.firstEffect), null !== b.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = b.firstEffect), a.lastEffect = b.lastEffect), 1 < b.flags && (null !== a.lastEffect ? a.lastEffect.nextEffect = b : a.firstEffect = b, a.lastEffect = b));
        } else {
            c = Li(b);
            if (null !== c) {
                c.flags &= 2047;
                Y = c;
                return;
            }
            null !== a && (a.firstEffect = a.lastEffect = null, a.flags |= 2048);
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === V && (V = 5);
}
function Uj(a) {
    var b = eg();
    gg(99, dk.bind(null, a, b));
    return null;
}
function dk(a, b) {
    do Oj();
    while (null !== yj);
    if (0 !== (X & 48)) throw Error(y(327));
    var c = a.finishedWork;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(y(177));
    a.callbackNode = null;
    var d = c.lanes | c.childLanes, e = d, f = a.pendingLanes & ~e;
    a.pendingLanes = e;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= e;
    a.mutableReadLanes &= e;
    a.entangledLanes &= e;
    e = a.entanglements;
    for(var g = a.eventTimes, h = a.expirationTimes; 0 < f;){
        var k = 31 - Vc(f), l = 1 << k;
        e[k] = 0;
        g[k] = -1;
        h[k] = -1;
        f &= ~l;
    }
    null !== Cj && 0 === (d & 24) && Cj.has(a) && Cj.delete(a);
    a === U && (Y = U = null, W = 0);
    1 < c.flags ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, d = c.firstEffect) : d = c : d = c.firstEffect;
    if (null !== d) {
        e = X;
        X |= 32;
        pj.current = null;
        kf = fd;
        g = Ne();
        if (Oe(g)) {
            if ("selectionStart" in g) h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: if (h = (h = g.ownerDocument) && h.defaultView || window, (l = h.getSelection && h.getSelection()) && 0 !== l.rangeCount) {
                h = l.anchorNode;
                f = l.anchorOffset;
                k = l.focusNode;
                l = l.focusOffset;
                try {
                    h.nodeType, k.nodeType;
                } catch (va) {
                    h = null;
                    break a;
                }
                var n = 0, A = -1, p = -1, C = 0, x = 0, w = g, z = null;
                b: for(;;){
                    for(var u;;){
                        w !== h || 0 !== f && 3 !== w.nodeType || (A = n + f);
                        w !== k || 0 !== l && 3 !== w.nodeType || (p = n + l);
                        3 === w.nodeType && (n += w.nodeValue.length);
                        if (null === (u = w.firstChild)) break;
                        z = w;
                        w = u;
                    }
                    for(;;){
                        if (w === g) break b;
                        z === h && ++C === f && (A = n);
                        z === k && ++x === l && (p = n);
                        if (null !== (u = w.nextSibling)) break;
                        w = z;
                        z = w.parentNode;
                    }
                    w = u;
                }
                h = -1 === A || -1 === p ? null : {
                    start: A,
                    end: p
                };
            } else h = null;
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        lf = {
            focusedElem: g,
            selectionRange: h
        };
        fd = !1;
        Ij = null;
        Jj = !1;
        Z = d;
        do try {
            ek();
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Ij = null;
        Z = d;
        do try {
            for(g = a; null !== Z;){
                var t = Z.flags;
                t & 16 && pb(Z.stateNode, "");
                if (t & 128) {
                    var q = Z.alternate;
                    if (null !== q) {
                        var v = q.ref;
                        null !== v && ("function" === typeof v ? v(null) : v.current = null);
                    }
                }
                switch(t & 1038){
                    case 2:
                        fj(Z);
                        Z.flags &= -3;
                        break;
                    case 6:
                        fj(Z);
                        Z.flags &= -3;
                        ij(Z.alternate, Z);
                        break;
                    case 1024:
                        Z.flags &= -1025;
                        break;
                    case 1028:
                        Z.flags &= -1025;
                        ij(Z.alternate, Z);
                        break;
                    case 4:
                        ij(Z.alternate, Z);
                        break;
                    case 8:
                        h = Z;
                        cj(g, h);
                        var J = h.alternate;
                        dj(h);
                        null !== J && dj(J);
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        v = lf;
        q = Ne();
        t = v.focusedElem;
        g = v.selectionRange;
        if (q !== t && t && t.ownerDocument && Me(t.ownerDocument.documentElement, t)) {
            null !== g && Oe(t) && (q = g.start, v = g.end, void 0 === v && (v = q), "selectionStart" in t ? (t.selectionStart = q, t.selectionEnd = Math.min(v, t.value.length)) : (v = (q = t.ownerDocument || document) && q.defaultView || window, v.getSelection && (v = v.getSelection(), h = t.textContent.length, J = Math.min(g.start, h), g = void 0 === g.end ? J : Math.min(g.end, h), !v.extend && J > g && (h = g, g = J, J = h), h = Le(t, J), f = Le(t, g), h && f && (1 !== v.rangeCount || v.anchorNode !== h.node || v.anchorOffset !== h.offset || v.focusNode !== f.node || v.focusOffset !== f.offset) && (q = q.createRange(), q.setStart(h.node, h.offset), v.removeAllRanges(), J > g ? (v.addRange(q), v.extend(f.node, f.offset)) : (q.setEnd(f.node, f.offset), v.addRange(q))))));
            q = [];
            for(v = t; v = v.parentNode;)1 === v.nodeType && q.push({
                element: v,
                left: v.scrollLeft,
                top: v.scrollTop
            });
            "function" === typeof t.focus && t.focus();
            for(t = 0; t < q.length; t++)v = q[t], v.element.scrollLeft = v.left, v.element.scrollTop = v.top;
        }
        fd = !!kf;
        lf = kf = null;
        a.current = c;
        Z = d;
        do try {
            for(t = a; null !== Z;){
                var K = Z.flags;
                K & 36 && Yi(t, Z.alternate, Z);
                if (K & 128) {
                    q = void 0;
                    var Q = Z.ref;
                    if (null !== Q) {
                        var L = Z.stateNode;
                        switch(Z.tag){
                            case 5:
                                q = L;
                                break;
                            default:
                                q = L;
                        }
                        "function" === typeof Q ? Q(q) : Q.current = q;
                    }
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Z = null;
        $f();
        X = e;
    } else a.current = c;
    if (xj) xj = !1, yj = a, zj = b;
    else for(Z = d; null !== Z;)b = Z.nextEffect, Z.nextEffect = null, Z.flags & 8 && (K = Z, K.sibling = null, K.stateNode = null), Z = b;
    d = a.pendingLanes;
    0 === d && (Ti = null);
    1 === d ? a === Ej ? Dj++ : (Dj = 0, Ej = a) : Dj = 0;
    c = c.stateNode;
    if (Mf && "function" === typeof Mf.onCommitFiberRoot) try {
        Mf.onCommitFiberRoot(Lf, c, void 0, 64 === (c.current.flags & 64));
    } catch (va) {}
    Mj(a, O());
    if (Qi) throw Qi = !1, a = Ri, Ri = null, a;
    if (0 !== (X & 8)) return null;
    ig();
    return null;
}
function ek() {
    for(; null !== Z;){
        var a = Z.alternate;
        Jj || null === Ij || (0 !== (Z.flags & 8) ? dc(Z, Ij) && (Jj = !0) : 13 === Z.tag && mj(a, Z) && dc(Z, Ij) && (Jj = !0));
        var b = Z.flags;
        0 !== (b & 256) && Xi(a, Z);
        0 === (b & 512) || xj || (xj = !0, hg(97, function() {
            Oj();
            return null;
        }));
        Z = Z.nextEffect;
    }
}
function Oj() {
    if (90 !== zj) {
        var a = 97 < zj ? 97 : zj;
        zj = 90;
        return gg(a, fk);
    }
    return !1;
}
function $i(a, b) {
    Aj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function Zi(a, b) {
    Bj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function fk() {
    if (null === yj) return !1;
    var a = yj;
    yj = null;
    if (0 !== (X & 48)) throw Error(y(331));
    var b = X;
    X |= 32;
    var c = Bj;
    Bj = [];
    for(var d = 0; d < c.length; d += 2){
        var e = c[d], f = c[d + 1], g = e.destroy;
        e.destroy = void 0;
        if ("function" === typeof g) try {
            g();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    c = Aj;
    Aj = [];
    for(d = 0; d < c.length; d += 2){
        e = c[d];
        f = c[d + 1];
        try {
            var h = e.create;
            e.destroy = h();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    for(h = a.current.firstEffect; null !== h;)a = h.nextEffect, h.nextEffect = null, h.flags & 8 && (h.sibling = null, h.stateNode = null), h = a;
    X = b;
    ig();
    return !0;
}
function gk(a, b, c) {
    b = Mi(c, b);
    b = Pi(a, b, 1);
    Ag(a, b);
    b = Hg();
    a = Kj(a, 1);
    null !== a && ($c(a, 1, b), Mj(a, b));
}
function Wi(a, b) {
    if (3 === a.tag) gk(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            gk(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) {
                a = Mi(b, a);
                var e = Si(c, a, 1);
                Ag(c, e);
                e = Hg();
                c = Kj(c, 1);
                if (null !== c) $c(c, 1, e), Mj(c, e);
                else if ("function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) try {
                    d.componentDidCatch(b, a);
                } catch (f) {}
                break;
            }
        }
        c = c.return;
    }
}
function Yj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = Hg();
    a.pingedLanes |= a.suspendedLanes & c;
    U === a && (W & c) === c && (4 === V || 3 === V && (W & 62914560) === W && 500 > O() - jj ? Qj(a, 0) : uj |= c);
    Mj(a, b);
}
function lj(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = a.mode, 0 === (b & 2) ? b = 1 : 0 === (b & 4) ? b = 99 === eg() ? 1 : 2 : (0 === Gj && (Gj = tj), b = Yc(62914560 & ~Gj), 0 === b && (b = 4194304)));
    c = Hg();
    a = Kj(a, b);
    null !== a && ($c(a, b, c), Mj(a, c));
}
var ck;
ck = function(a, b, c) {
    var d = b.lanes;
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || N.current) ug = !0;
        else if (0 !== (c & d)) ug = 0 !== (a.flags & 16384) ? !0 : !1;
        else {
            ug = !1;
            switch(b.tag){
                case 3:
                    ri(b);
                    sh();
                    break;
                case 5:
                    gh(b);
                    break;
                case 1:
                    Ff(b.type) && Jf(b);
                    break;
                case 4:
                    eh(b, b.stateNode.containerInfo);
                    break;
                case 10:
                    d = b.memoizedProps.value;
                    var e = b.type._context;
                    I(mg, e._currentValue);
                    e._currentValue = d;
                    break;
                case 13:
                    if (null !== b.memoizedState) {
                        if (0 !== (c & b.child.childLanes)) return ti(a, b, c);
                        I(P, P.current & 1);
                        b = hi(a, b, c);
                        return null !== b ? b.sibling : null;
                    }
                    I(P, P.current & 1);
                    break;
                case 19:
                    d = 0 !== (c & b.childLanes);
                    if (0 !== (a.flags & 64)) {
                        if (d) return Ai(a, b, c);
                        b.flags |= 64;
                    }
                    e = b.memoizedState;
                    null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
                    I(P, P.current);
                    if (d) break;
                    else return null;
                case 23:
                case 24:
                    return b.lanes = 0, mi(a, b, c);
            }
            return hi(a, b, c);
        }
    } else ug = !1;
    b.lanes = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
            a = b.pendingProps;
            e = Ef(b, M.current);
            tg(b, c);
            e = Ch(null, b, d, a, e, c);
            b.flags |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if (Ff(d)) {
                    var f = !0;
                    Jf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                xg(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && Gg(b, d, g, a);
                e.updater = Kg;
                b.stateNode = e;
                e._reactInternals = b;
                Og(b, d, a, c);
                b = qi(null, b, d, !0, f, c);
            } else b.tag = 0, fi(null, b, e, c), b = b.child;
            return b;
        case 16:
            e = b.elementType;
            a: {
                null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                a = b.pendingProps;
                f = e._init;
                e = f(e._payload);
                b.type = e;
                f = b.tag = hk(e);
                a = lg(e, a);
                switch(f){
                    case 0:
                        b = li(null, b, e, a, c);
                        break a;
                    case 1:
                        b = pi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = gi(null, b, e, a, c);
                        break a;
                    case 14:
                        b = ii(null, b, e, lg(e.type, a), d, c);
                        break a;
                }
                throw Error(y(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), li(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), pi(a, b, d, e, c);
        case 3:
            ri(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error(y(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            yg(a, b);
            Cg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) sh(), b = hi(a, b, c);
            else {
                e = b.stateNode;
                if (f = e.hydrate) kh = rf(b.stateNode.containerInfo.firstChild), jh = b, f = lh = !0;
                if (f) {
                    a = e.mutableSourceEagerHydrationData;
                    if (null != a) for(e = 0; e < a.length; e += 2)f = a[e], f._workInProgressVersionPrimary = a[e + 1], th.push(f);
                    c = Zg(b, null, d, c);
                    for(b.child = c; c;)c.flags = c.flags & -3 | 1024, c = c.sibling;
                } else fi(a, b, d, c), sh();
                b = b.child;
            }
            return b;
        case 5:
            return gh(b), null === a && ph(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, nf(d, e) ? g = null : null !== f && nf(d, f) && (b.flags |= 16), oi(a, b), fi(a, b, g, c), b.child;
        case 6:
            return null === a && ph(b), null;
        case 13:
            return ti(a, b, c);
        case 4:
            return eh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Yg(b, null, d, c) : fi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), gi(a, b, d, e, c);
        case 7:
            return fi(a, b, b.pendingProps, c), b.child;
        case 8:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                I(mg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = He(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !N.current) {
                            b = hi(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = zg(-1, c & -c), l.tag = 2, Ag(h, l));
                                    h.lanes |= c;
                                    l = h.alternate;
                                    null !== l && (l.lanes |= c);
                                    sg(h.return, c);
                                    k.lanes |= c;
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                fi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, tg(b, c), e = vg(e, f.unstable_observedBits), d = d(e), b.flags |= 1, fi(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = lg(e, b.pendingProps), f = lg(e.type, f), ii(a, b, e, f, d, c);
        case 15:
            return ki(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, Ff(d) ? (a = !0, Jf(b)) : a = !1, tg(b, c), Mg(b, d, e), Og(b, d, e, c), qi(null, b, d, !0, a, c);
        case 19:
            return Ai(a, b, c);
        case 23:
            return mi(a, b, c);
        case 24:
            return mi(a, b, c);
    }
    throw Error(y(156, b.tag));
};
function ik(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.flags = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function nh(a, b, c, d) {
    return new ik(a, b, c, d);
}
function ji(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function hk(a) {
    if ("function" === typeof a) return ji(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Aa) return 11;
        if (a === Da) return 14;
    }
    return 2;
}
function Tg(a, b) {
    var c = a.alternate;
    null === c ? (c = nh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Vg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) ji(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ua:
            return Xg(c.children, e, f, b);
        case Ha:
            g = 8;
            e |= 16;
            break;
        case wa:
            g = 8;
            e |= 1;
            break;
        case xa:
            return a = nh(12, c, b, e | 8), a.elementType = xa, a.type = xa, a.lanes = f, a;
        case Ba:
            return a = nh(13, c, b, e), a.type = Ba, a.elementType = Ba, a.lanes = f, a;
        case Ca:
            return a = nh(19, c, b, e), a.elementType = Ca, a.lanes = f, a;
        case Ia:
            return vi(c, e, f, b);
        case Ja:
            return a = nh(24, c, b, e), a.elementType = Ja, a.lanes = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case ya:
                    g = 10;
                    break a;
                case za:
                    g = 9;
                    break a;
                case Aa:
                    g = 11;
                    break a;
                case Da:
                    g = 14;
                    break a;
                case Ea:
                    g = 16;
                    d = null;
                    break a;
                case Fa:
                    g = 22;
                    break a;
            }
            throw Error(y(130, null == a ? a : typeof a, ""));
    }
    b = nh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Xg(a, b, c, d) {
    a = nh(7, a, d, b);
    a.lanes = c;
    return a;
}
function vi(a, b, c, d) {
    a = nh(23, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    return a;
}
function Ug(a, b, c) {
    a = nh(6, a, null, b);
    a.lanes = c;
    return a;
}
function Wg(a, b, c) {
    b = nh(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function jk(a, b, c) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 0;
    this.eventTimes = Zc(0);
    this.expirationTimes = Zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = Zc(0);
    this.mutableSourceEagerHydrationData = null;
}
function kk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: ta,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function lk(a, b, c, d) {
    var e = b.current, f = Hg(), g = Ig(e);
    a: if (c) {
        c = c._reactInternals;
        b: {
            if (Zb(c) !== c || 1 !== c.tag) throw Error(y(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if (Ff(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error(y(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if (Ff(k)) {
                c = If(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = Cf;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = zg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    Ag(e, b);
    Jg(e, g, f);
    return g;
}
function mk(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function nk(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function ok(a, b) {
    nk(a, b);
    (a = a.alternate) && nk(a, b);
}
function pk() {
    return null;
}
function qk(a, b, c) {
    var d = null != c && null != c.hydrationOptions && c.hydrationOptions.mutableSources || null;
    c = new jk(a, b, null != c && !0 === c.hydrate);
    b = nh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    c.current = b;
    b.stateNode = c;
    xg(b);
    a[ff] = c.current;
    cf(8 === a.nodeType ? a.parentNode : a);
    if (d) for(a = 0; a < d.length; a++){
        b = d[a];
        var e = b._getVersion;
        e = e(b._source);
        null == c.mutableSourceEagerHydrationData ? c.mutableSourceEagerHydrationData = [
            b,
            e
        ] : c.mutableSourceEagerHydrationData.push(b, e);
    }
    this._internalRoot = c;
}
qk.prototype.render = function(a) {
    lk(a, this._internalRoot, null, null);
};
qk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    lk(null, a, null, function() {
        b[ff] = null;
    });
};
function rk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function sk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new qk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function tk(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = mk(g);
                h.call(a);
            };
        }
        lk(b, g, a, e);
    } else {
        f = c._reactRootContainer = sk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = mk(g);
                k.call(a);
            };
        }
        Xj(function() {
            lk(b, g, a, e);
        });
    }
    return mk(g);
}
ec = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 4, b);
        ok(a, 4);
    }
};
fc = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 67108864, b);
        ok(a, 67108864);
    }
};
gc = function(a) {
    if (13 === a.tag) {
        var b = Hg(), c = Ig(a);
        Jg(a, c, b);
        ok(a, c);
    }
};
hc = function(a, b) {
    return b();
};
yb = function(a, b, c) {
    switch(b){
        case "input":
            ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(y(90));
                        Wa(d);
                        ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Wj;
Hb = function(a, b, c, d, e) {
    var f = X;
    X |= 4;
    try {
        return gg(98, a.bind(null, b, c, d, e));
    } finally{
        X = f, 0 === X && (wj(), ig());
    }
};
Ib = function() {
    0 === (X & 49) && (Vj(), Oj());
};
Jb = function(a, b) {
    var c = X;
    X |= 2;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
};
function uk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!rk(b)) throw Error(y(200));
    return kk(a, b, null, c);
}
var vk = {
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Oj,
        {
            current: !1
        }
    ]
}, wk = {
    findFiberByHostInstance: wc,
    bundleType: 0,
    version: "17.0.2",
    rendererPackageName: "react-dom"
};
var xk = {
    bundleType: wk.bundleType,
    version: wk.version,
    rendererPackageName: wk.rendererPackageName,
    rendererConfig: wk.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ra.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = cc(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: wk.findFiberByHostInstance || pk,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var yk = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!yk.isDisabled && yk.supportsFiber) try {
        Lf = yk.inject(xk), Mf = yk;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = vk;
exports.createPortal = uk;
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(y(188));
        throw Error(y(268, Object.keys(a)));
    }
    a = cc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a, b) {
    var c = X;
    if (0 !== (c & 48)) return a(b);
    X |= 1;
    try {
        if (a) return gg(99, a.bind(null, b));
    } finally{
        X = c, ig();
    }
};
exports.hydrate = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !0, c);
};
exports.render = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!rk(a)) throw Error(y(40));
    return a._reactRootContainer ? (Xj(function() {
        tk(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[ff] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Wj;
exports.unstable_createPortal = function(a, b) {
    return uk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!rk(c)) throw Error(y(200));
    if (null == a || void 0 === a._reactInternals) throw Error(y(38));
    return tk(a, b, c, !1, d);
};
exports.version = "17.0.2";

});
parcelRegister("7bPco", function(module, exports) {
'use strict';

module.exports = (parcelRequire("bh2AD"));

});
parcelRegister("bh2AD", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $83534a8c3330e8bf$export$c4744153514ff05d, (v) => $83534a8c3330e8bf$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $83534a8c3330e8bf$export$b5836b71941fa3ed, (v) => $83534a8c3330e8bf$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $83534a8c3330e8bf$export$d66a1c1c77bd778b, (v) => $83534a8c3330e8bf$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $83534a8c3330e8bf$export$3e506c1ccc9cc1a7, (v) => $83534a8c3330e8bf$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $83534a8c3330e8bf$export$e26fe2ed2fa76875, (v) => $83534a8c3330e8bf$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $83534a8c3330e8bf$export$502329bbf4b505b1, (v) => $83534a8c3330e8bf$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $83534a8c3330e8bf$export$6e3807111c4874c4, (v) => $83534a8c3330e8bf$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $83534a8c3330e8bf$export$c27134553091fb3a, (v) => $83534a8c3330e8bf$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $83534a8c3330e8bf$export$33ee1acdc04fd2a2, (v) => $83534a8c3330e8bf$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $83534a8c3330e8bf$export$b00a404bbd5edef2, (v) => $83534a8c3330e8bf$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $83534a8c3330e8bf$export$8352ce38b91d0c62, (v) => $83534a8c3330e8bf$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $83534a8c3330e8bf$export$d3dfb8e4810cb555, (v) => $83534a8c3330e8bf$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $83534a8c3330e8bf$export$839f9183b0465a69, (v) => $83534a8c3330e8bf$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $83534a8c3330e8bf$export$72fdf0e06517287b, (v) => $83534a8c3330e8bf$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $83534a8c3330e8bf$export$4b844e58a3e414b4, (v) => $83534a8c3330e8bf$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $83534a8c3330e8bf$export$816d2913ae6b83b1, (v) => $83534a8c3330e8bf$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $83534a8c3330e8bf$export$61bcfe829111a1d0, (v) => $83534a8c3330e8bf$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $83534a8c3330e8bf$export$7ee8c9beb337bc3f, (v) => $83534a8c3330e8bf$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $83534a8c3330e8bf$export$cf845f2c119da08a, (v) => $83534a8c3330e8bf$export$cf845f2c119da08a = v);
/** @license React v0.20.2
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $83534a8c3330e8bf$export$c4744153514ff05d;
var $83534a8c3330e8bf$export$b5836b71941fa3ed;
var $83534a8c3330e8bf$export$d66a1c1c77bd778b;
var $83534a8c3330e8bf$export$3e506c1ccc9cc1a7;
var $83534a8c3330e8bf$export$e26fe2ed2fa76875;
var $83534a8c3330e8bf$export$502329bbf4b505b1;
var $83534a8c3330e8bf$export$6e3807111c4874c4;
var $83534a8c3330e8bf$export$c27134553091fb3a;
var $83534a8c3330e8bf$export$33ee1acdc04fd2a2;
var $83534a8c3330e8bf$export$b00a404bbd5edef2;
var $83534a8c3330e8bf$export$8352ce38b91d0c62;
var $83534a8c3330e8bf$export$d3dfb8e4810cb555;
var $83534a8c3330e8bf$export$839f9183b0465a69;
var $83534a8c3330e8bf$export$72fdf0e06517287b;
var $83534a8c3330e8bf$export$4b844e58a3e414b4;
var $83534a8c3330e8bf$export$816d2913ae6b83b1;
var $83534a8c3330e8bf$export$61bcfe829111a1d0;
var $83534a8c3330e8bf$export$7ee8c9beb337bc3f;
var $83534a8c3330e8bf$export$cf845f2c119da08a;
'use strict';
var $83534a8c3330e8bf$var$f, $83534a8c3330e8bf$var$g, $83534a8c3330e8bf$var$h, $83534a8c3330e8bf$var$k;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $83534a8c3330e8bf$var$l = performance;
    $83534a8c3330e8bf$export$c4744153514ff05d = function() {
        return $83534a8c3330e8bf$var$l.now();
    };
} else {
    var $83534a8c3330e8bf$var$p = Date, $83534a8c3330e8bf$var$q = $83534a8c3330e8bf$var$p.now();
    $83534a8c3330e8bf$export$c4744153514ff05d = function() {
        return $83534a8c3330e8bf$var$p.now() - $83534a8c3330e8bf$var$q;
    };
}
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $83534a8c3330e8bf$var$t = null, $83534a8c3330e8bf$var$u = null, $83534a8c3330e8bf$var$w = function() {
        if (null !== $83534a8c3330e8bf$var$t) try {
            var a = $83534a8c3330e8bf$export$c4744153514ff05d();
            $83534a8c3330e8bf$var$t(!0, a);
            $83534a8c3330e8bf$var$t = null;
        } catch (b) {
            throw setTimeout($83534a8c3330e8bf$var$w, 0), b;
        }
    };
    $83534a8c3330e8bf$var$f = function(a) {
        null !== $83534a8c3330e8bf$var$t ? setTimeout($83534a8c3330e8bf$var$f, 0, a) : ($83534a8c3330e8bf$var$t = a, setTimeout($83534a8c3330e8bf$var$w, 0));
    };
    $83534a8c3330e8bf$var$g = function(a, b) {
        $83534a8c3330e8bf$var$u = setTimeout(a, b);
    };
    $83534a8c3330e8bf$var$h = function() {
        clearTimeout($83534a8c3330e8bf$var$u);
    };
    $83534a8c3330e8bf$export$b5836b71941fa3ed = function() {
        return !1;
    };
    $83534a8c3330e8bf$var$k = $83534a8c3330e8bf$export$d66a1c1c77bd778b = function() {};
} else {
    var $83534a8c3330e8bf$var$x = window.setTimeout, $83534a8c3330e8bf$var$y = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $83534a8c3330e8bf$var$z = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
        "function" !== typeof $83534a8c3330e8bf$var$z && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    }
    var $83534a8c3330e8bf$var$A = !1, $83534a8c3330e8bf$var$B = null, $83534a8c3330e8bf$var$C = -1, $83534a8c3330e8bf$var$D = 5, $83534a8c3330e8bf$var$E = 0;
    $83534a8c3330e8bf$export$b5836b71941fa3ed = function() {
        return $83534a8c3330e8bf$export$c4744153514ff05d() >= $83534a8c3330e8bf$var$E;
    };
    $83534a8c3330e8bf$var$k = function() {};
    $83534a8c3330e8bf$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $83534a8c3330e8bf$var$D = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $83534a8c3330e8bf$var$F = new MessageChannel, $83534a8c3330e8bf$var$G = $83534a8c3330e8bf$var$F.port2;
    $83534a8c3330e8bf$var$F.port1.onmessage = function() {
        if (null !== $83534a8c3330e8bf$var$B) {
            var a = $83534a8c3330e8bf$export$c4744153514ff05d();
            $83534a8c3330e8bf$var$E = a + $83534a8c3330e8bf$var$D;
            try {
                $83534a8c3330e8bf$var$B(!0, a) ? $83534a8c3330e8bf$var$G.postMessage(null) : ($83534a8c3330e8bf$var$A = !1, $83534a8c3330e8bf$var$B = null);
            } catch (b) {
                throw $83534a8c3330e8bf$var$G.postMessage(null), b;
            }
        } else $83534a8c3330e8bf$var$A = !1;
    };
    $83534a8c3330e8bf$var$f = function(a) {
        $83534a8c3330e8bf$var$B = a;
        $83534a8c3330e8bf$var$A || ($83534a8c3330e8bf$var$A = !0, $83534a8c3330e8bf$var$G.postMessage(null));
    };
    $83534a8c3330e8bf$var$g = function(a, b) {
        $83534a8c3330e8bf$var$C = $83534a8c3330e8bf$var$x(function() {
            a($83534a8c3330e8bf$export$c4744153514ff05d());
        }, b);
    };
    $83534a8c3330e8bf$var$h = function() {
        $83534a8c3330e8bf$var$y($83534a8c3330e8bf$var$C);
        $83534a8c3330e8bf$var$C = -1;
    };
}
function $83534a8c3330e8bf$var$H(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $83534a8c3330e8bf$var$I(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $83534a8c3330e8bf$var$J(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $83534a8c3330e8bf$var$K(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $83534a8c3330e8bf$var$I(n, c)) void 0 !== r && 0 > $83534a8c3330e8bf$var$I(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $83534a8c3330e8bf$var$I(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $83534a8c3330e8bf$var$I(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $83534a8c3330e8bf$var$L = [], $83534a8c3330e8bf$var$M = [], $83534a8c3330e8bf$var$N = 1, $83534a8c3330e8bf$var$O = null, $83534a8c3330e8bf$var$P = 3, $83534a8c3330e8bf$var$Q = !1, $83534a8c3330e8bf$var$R = !1, $83534a8c3330e8bf$var$S = !1;
function $83534a8c3330e8bf$var$T(a) {
    for(var b = $83534a8c3330e8bf$var$J($83534a8c3330e8bf$var$M); null !== b;){
        if (null === b.callback) $83534a8c3330e8bf$var$K($83534a8c3330e8bf$var$M);
        else if (b.startTime <= a) $83534a8c3330e8bf$var$K($83534a8c3330e8bf$var$M), b.sortIndex = b.expirationTime, $83534a8c3330e8bf$var$H($83534a8c3330e8bf$var$L, b);
        else break;
        b = $83534a8c3330e8bf$var$J($83534a8c3330e8bf$var$M);
    }
}
function $83534a8c3330e8bf$var$U(a) {
    $83534a8c3330e8bf$var$S = !1;
    $83534a8c3330e8bf$var$T(a);
    if (!$83534a8c3330e8bf$var$R) {
        if (null !== $83534a8c3330e8bf$var$J($83534a8c3330e8bf$var$L)) $83534a8c3330e8bf$var$R = !0, $83534a8c3330e8bf$var$f($83534a8c3330e8bf$var$V);
        else {
            var b = $83534a8c3330e8bf$var$J($83534a8c3330e8bf$var$M);
            null !== b && $83534a8c3330e8bf$var$g($83534a8c3330e8bf$var$U, b.startTime - a);
        }
    }
}
function $83534a8c3330e8bf$var$V(a, b) {
    $83534a8c3330e8bf$var$R = !1;
    $83534a8c3330e8bf$var$S && ($83534a8c3330e8bf$var$S = !1, $83534a8c3330e8bf$var$h());
    $83534a8c3330e8bf$var$Q = !0;
    var c = $83534a8c3330e8bf$var$P;
    try {
        $83534a8c3330e8bf$var$T(b);
        for($83534a8c3330e8bf$var$O = $83534a8c3330e8bf$var$J($83534a8c3330e8bf$var$L); null !== $83534a8c3330e8bf$var$O && (!($83534a8c3330e8bf$var$O.expirationTime > b) || a && !$83534a8c3330e8bf$export$b5836b71941fa3ed());){
            var d = $83534a8c3330e8bf$var$O.callback;
            if ("function" === typeof d) {
                $83534a8c3330e8bf$var$O.callback = null;
                $83534a8c3330e8bf$var$P = $83534a8c3330e8bf$var$O.priorityLevel;
                var e = d($83534a8c3330e8bf$var$O.expirationTime <= b);
                b = $83534a8c3330e8bf$export$c4744153514ff05d();
                "function" === typeof e ? $83534a8c3330e8bf$var$O.callback = e : $83534a8c3330e8bf$var$O === $83534a8c3330e8bf$var$J($83534a8c3330e8bf$var$L) && $83534a8c3330e8bf$var$K($83534a8c3330e8bf$var$L);
                $83534a8c3330e8bf$var$T(b);
            } else $83534a8c3330e8bf$var$K($83534a8c3330e8bf$var$L);
            $83534a8c3330e8bf$var$O = $83534a8c3330e8bf$var$J($83534a8c3330e8bf$var$L);
        }
        if (null !== $83534a8c3330e8bf$var$O) var m = !0;
        else {
            var n = $83534a8c3330e8bf$var$J($83534a8c3330e8bf$var$M);
            null !== n && $83534a8c3330e8bf$var$g($83534a8c3330e8bf$var$U, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $83534a8c3330e8bf$var$O = null, $83534a8c3330e8bf$var$P = c, $83534a8c3330e8bf$var$Q = !1;
    }
}
var $83534a8c3330e8bf$var$W = $83534a8c3330e8bf$var$k;
$83534a8c3330e8bf$export$3e506c1ccc9cc1a7 = 5;
$83534a8c3330e8bf$export$e26fe2ed2fa76875 = 1;
$83534a8c3330e8bf$export$502329bbf4b505b1 = 4;
$83534a8c3330e8bf$export$6e3807111c4874c4 = 3;
$83534a8c3330e8bf$export$c27134553091fb3a = null;
$83534a8c3330e8bf$export$33ee1acdc04fd2a2 = 2;
$83534a8c3330e8bf$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$83534a8c3330e8bf$export$8352ce38b91d0c62 = function() {
    $83534a8c3330e8bf$var$R || $83534a8c3330e8bf$var$Q || ($83534a8c3330e8bf$var$R = !0, $83534a8c3330e8bf$var$f($83534a8c3330e8bf$var$V));
};
$83534a8c3330e8bf$export$d3dfb8e4810cb555 = function() {
    return $83534a8c3330e8bf$var$P;
};
$83534a8c3330e8bf$export$839f9183b0465a69 = function() {
    return $83534a8c3330e8bf$var$J($83534a8c3330e8bf$var$L);
};
$83534a8c3330e8bf$export$72fdf0e06517287b = function(a) {
    switch($83534a8c3330e8bf$var$P){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $83534a8c3330e8bf$var$P;
    }
    var c = $83534a8c3330e8bf$var$P;
    $83534a8c3330e8bf$var$P = b;
    try {
        return a();
    } finally{
        $83534a8c3330e8bf$var$P = c;
    }
};
$83534a8c3330e8bf$export$4b844e58a3e414b4 = function() {};
$83534a8c3330e8bf$export$816d2913ae6b83b1 = $83534a8c3330e8bf$var$W;
$83534a8c3330e8bf$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $83534a8c3330e8bf$var$P;
    $83534a8c3330e8bf$var$P = a;
    try {
        return b();
    } finally{
        $83534a8c3330e8bf$var$P = c;
    }
};
$83534a8c3330e8bf$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $83534a8c3330e8bf$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $83534a8c3330e8bf$var$N++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $83534a8c3330e8bf$var$H($83534a8c3330e8bf$var$M, a), null === $83534a8c3330e8bf$var$J($83534a8c3330e8bf$var$L) && a === $83534a8c3330e8bf$var$J($83534a8c3330e8bf$var$M) && ($83534a8c3330e8bf$var$S ? $83534a8c3330e8bf$var$h() : $83534a8c3330e8bf$var$S = !0, $83534a8c3330e8bf$var$g($83534a8c3330e8bf$var$U, c - d))) : (a.sortIndex = e, $83534a8c3330e8bf$var$H($83534a8c3330e8bf$var$L, a), $83534a8c3330e8bf$var$R || $83534a8c3330e8bf$var$Q || ($83534a8c3330e8bf$var$R = !0, $83534a8c3330e8bf$var$f($83534a8c3330e8bf$var$V)));
    return a;
};
$83534a8c3330e8bf$export$cf845f2c119da08a = function(a) {
    var b = $83534a8c3330e8bf$var$P;
    return function() {
        var c = $83534a8c3330e8bf$var$P;
        $83534a8c3330e8bf$var$P = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $83534a8c3330e8bf$var$P = c;
        }
    };
};

});



parcelRegister("4L3zM", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $376e535b1f013c40$var$ReactIs, $376e535b1f013c40$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("eEtjc"))();

});
parcelRegister("eEtjc", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $hVVq1 = parcelRequire("hVVq1");
function $aaab893b1a76f303$var$emptyFunction() {}
function $aaab893b1a76f303$var$emptyFunctionWithReset() {}
$aaab893b1a76f303$var$emptyFunctionWithReset.resetWarningCache = $aaab893b1a76f303$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $hVVq1) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $aaab893b1a76f303$var$emptyFunctionWithReset,
        resetWarningCache: $aaab893b1a76f303$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("hVVq1", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $d0e44caf0df1935f$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $d0e44caf0df1935f$var$ReactPropTypesSecret;

});



parcelRegister("bR9Ya", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $8a1c60aeca462d1f$export$2b8d127b894957b9, (v) => $8a1c60aeca462d1f$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $8a1c60aeca462d1f$export$cea3a54a6425200c, (v) => $8a1c60aeca462d1f$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $8a1c60aeca462d1f$export$a7c73072b1a182ae, (v) => $8a1c60aeca462d1f$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $8a1c60aeca462d1f$export$9f27bc3417b4524d, (v) => $8a1c60aeca462d1f$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $8a1c60aeca462d1f$export$db77ccec0bb4ccac, (v) => $8a1c60aeca462d1f$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $8a1c60aeca462d1f$export$8392c0c9d3dcbd35, (v) => $8a1c60aeca462d1f$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $8a1c60aeca462d1f$export$ffb0004e005737fa, (v) => $8a1c60aeca462d1f$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $8a1c60aeca462d1f$export$b624eff549462981, (v) => $8a1c60aeca462d1f$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $8a1c60aeca462d1f$export$7897aa7841a5380c, (v) => $8a1c60aeca462d1f$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $8a1c60aeca462d1f$export$602eac185826482c, (v) => $8a1c60aeca462d1f$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $8a1c60aeca462d1f$export$e2c29f18771995cb, (v) => $8a1c60aeca462d1f$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $8a1c60aeca462d1f$export$5f8d39834fd61797, (v) => $8a1c60aeca462d1f$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $8a1c60aeca462d1f$export$74bf444e3cd11ea5, (v) => $8a1c60aeca462d1f$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $8a1c60aeca462d1f$export$92387174baf9b227, (v) => $8a1c60aeca462d1f$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $8a1c60aeca462d1f$export$ec112efeb987d9c6, (v) => $8a1c60aeca462d1f$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $8a1c60aeca462d1f$export$b706b080d889d2c9, (v) => $8a1c60aeca462d1f$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $8a1c60aeca462d1f$export$5be5a87408f70ddc, (v) => $8a1c60aeca462d1f$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $8a1c60aeca462d1f$export$45a5e7f76e0caa8d, (v) => $8a1c60aeca462d1f$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $8a1c60aeca462d1f$export$455c2e768291efa6, (v) => $8a1c60aeca462d1f$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $8a1c60aeca462d1f$export$9522e17588c12572, (v) => $8a1c60aeca462d1f$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $8a1c60aeca462d1f$export$2110ac352bb060b9, (v) => $8a1c60aeca462d1f$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $8a1c60aeca462d1f$export$56885ab8b9c456ab, (v) => $8a1c60aeca462d1f$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $8a1c60aeca462d1f$export$d927fcb6adf8f9de, (v) => $8a1c60aeca462d1f$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $8a1c60aeca462d1f$export$b82d16f27459e05a, (v) => $8a1c60aeca462d1f$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $8a1c60aeca462d1f$export$522c17b4f5e123e8, (v) => $8a1c60aeca462d1f$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $8a1c60aeca462d1f$export$1aabd8a0274ecfd6, (v) => $8a1c60aeca462d1f$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $8a1c60aeca462d1f$export$9b621391a187a31a, (v) => $8a1c60aeca462d1f$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $8a1c60aeca462d1f$export$f5bbd400c2f4426f, (v) => $8a1c60aeca462d1f$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8a1c60aeca462d1f$export$2b8d127b894957b9;
var $8a1c60aeca462d1f$export$cea3a54a6425200c;
var $8a1c60aeca462d1f$export$a7c73072b1a182ae;
var $8a1c60aeca462d1f$export$9f27bc3417b4524d;
var $8a1c60aeca462d1f$export$db77ccec0bb4ccac;
var $8a1c60aeca462d1f$export$8392c0c9d3dcbd35;
var $8a1c60aeca462d1f$export$ffb0004e005737fa;
var $8a1c60aeca462d1f$export$b624eff549462981;
var $8a1c60aeca462d1f$export$7897aa7841a5380c;
var $8a1c60aeca462d1f$export$602eac185826482c;
var $8a1c60aeca462d1f$export$e2c29f18771995cb;
var $8a1c60aeca462d1f$export$5f8d39834fd61797;
var $8a1c60aeca462d1f$export$74bf444e3cd11ea5;
var $8a1c60aeca462d1f$export$92387174baf9b227;
var $8a1c60aeca462d1f$export$ec112efeb987d9c6;
var $8a1c60aeca462d1f$export$b706b080d889d2c9;
var $8a1c60aeca462d1f$export$5be5a87408f70ddc;
var $8a1c60aeca462d1f$export$45a5e7f76e0caa8d;
var $8a1c60aeca462d1f$export$455c2e768291efa6;
var $8a1c60aeca462d1f$export$9522e17588c12572;
var $8a1c60aeca462d1f$export$2110ac352bb060b9;
var $8a1c60aeca462d1f$export$56885ab8b9c456ab;
var $8a1c60aeca462d1f$export$d927fcb6adf8f9de;
var $8a1c60aeca462d1f$export$b82d16f27459e05a;
var $8a1c60aeca462d1f$export$522c17b4f5e123e8;
var $8a1c60aeca462d1f$export$1aabd8a0274ecfd6;
var $8a1c60aeca462d1f$export$9b621391a187a31a;
var $8a1c60aeca462d1f$export$f5bbd400c2f4426f;
'use strict';
var $8a1c60aeca462d1f$var$b = "function" === typeof Symbol && Symbol.for, $8a1c60aeca462d1f$var$c = $8a1c60aeca462d1f$var$b ? Symbol.for("react.element") : 60103, $8a1c60aeca462d1f$var$d = $8a1c60aeca462d1f$var$b ? Symbol.for("react.portal") : 60106, $8a1c60aeca462d1f$var$e = $8a1c60aeca462d1f$var$b ? Symbol.for("react.fragment") : 60107, $8a1c60aeca462d1f$var$f = $8a1c60aeca462d1f$var$b ? Symbol.for("react.strict_mode") : 60108, $8a1c60aeca462d1f$var$g = $8a1c60aeca462d1f$var$b ? Symbol.for("react.profiler") : 60114, $8a1c60aeca462d1f$var$h = $8a1c60aeca462d1f$var$b ? Symbol.for("react.provider") : 60109, $8a1c60aeca462d1f$var$k = $8a1c60aeca462d1f$var$b ? Symbol.for("react.context") : 60110, $8a1c60aeca462d1f$var$l = $8a1c60aeca462d1f$var$b ? Symbol.for("react.async_mode") : 60111, $8a1c60aeca462d1f$var$m = $8a1c60aeca462d1f$var$b ? Symbol.for("react.concurrent_mode") : 60111, $8a1c60aeca462d1f$var$n = $8a1c60aeca462d1f$var$b ? Symbol.for("react.forward_ref") : 60112, $8a1c60aeca462d1f$var$p = $8a1c60aeca462d1f$var$b ? Symbol.for("react.suspense") : 60113, $8a1c60aeca462d1f$var$q = $8a1c60aeca462d1f$var$b ? Symbol.for("react.suspense_list") : 60120, $8a1c60aeca462d1f$var$r = $8a1c60aeca462d1f$var$b ? Symbol.for("react.memo") : 60115, $8a1c60aeca462d1f$var$t = $8a1c60aeca462d1f$var$b ? Symbol.for("react.lazy") : 60116, $8a1c60aeca462d1f$var$v = $8a1c60aeca462d1f$var$b ? Symbol.for("react.block") : 60121, $8a1c60aeca462d1f$var$w = $8a1c60aeca462d1f$var$b ? Symbol.for("react.fundamental") : 60117, $8a1c60aeca462d1f$var$x = $8a1c60aeca462d1f$var$b ? Symbol.for("react.responder") : 60118, $8a1c60aeca462d1f$var$y = $8a1c60aeca462d1f$var$b ? Symbol.for("react.scope") : 60119;
function $8a1c60aeca462d1f$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $8a1c60aeca462d1f$var$c:
                switch(a = a.type, a){
                    case $8a1c60aeca462d1f$var$l:
                    case $8a1c60aeca462d1f$var$m:
                    case $8a1c60aeca462d1f$var$e:
                    case $8a1c60aeca462d1f$var$g:
                    case $8a1c60aeca462d1f$var$f:
                    case $8a1c60aeca462d1f$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $8a1c60aeca462d1f$var$k:
                            case $8a1c60aeca462d1f$var$n:
                            case $8a1c60aeca462d1f$var$t:
                            case $8a1c60aeca462d1f$var$r:
                            case $8a1c60aeca462d1f$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $8a1c60aeca462d1f$var$d:
                return u;
        }
    }
}
function $8a1c60aeca462d1f$var$A(a) {
    return $8a1c60aeca462d1f$var$z(a) === $8a1c60aeca462d1f$var$m;
}
$8a1c60aeca462d1f$export$2b8d127b894957b9 = $8a1c60aeca462d1f$var$l;
$8a1c60aeca462d1f$export$cea3a54a6425200c = $8a1c60aeca462d1f$var$m;
$8a1c60aeca462d1f$export$a7c73072b1a182ae = $8a1c60aeca462d1f$var$k;
$8a1c60aeca462d1f$export$9f27bc3417b4524d = $8a1c60aeca462d1f$var$h;
$8a1c60aeca462d1f$export$db77ccec0bb4ccac = $8a1c60aeca462d1f$var$c;
$8a1c60aeca462d1f$export$8392c0c9d3dcbd35 = $8a1c60aeca462d1f$var$n;
$8a1c60aeca462d1f$export$ffb0004e005737fa = $8a1c60aeca462d1f$var$e;
$8a1c60aeca462d1f$export$b624eff549462981 = $8a1c60aeca462d1f$var$t;
$8a1c60aeca462d1f$export$7897aa7841a5380c = $8a1c60aeca462d1f$var$r;
$8a1c60aeca462d1f$export$602eac185826482c = $8a1c60aeca462d1f$var$d;
$8a1c60aeca462d1f$export$e2c29f18771995cb = $8a1c60aeca462d1f$var$g;
$8a1c60aeca462d1f$export$5f8d39834fd61797 = $8a1c60aeca462d1f$var$f;
$8a1c60aeca462d1f$export$74bf444e3cd11ea5 = $8a1c60aeca462d1f$var$p;
$8a1c60aeca462d1f$export$92387174baf9b227 = function(a) {
    return $8a1c60aeca462d1f$var$A(a) || $8a1c60aeca462d1f$var$z(a) === $8a1c60aeca462d1f$var$l;
};
$8a1c60aeca462d1f$export$ec112efeb987d9c6 = $8a1c60aeca462d1f$var$A;
$8a1c60aeca462d1f$export$b706b080d889d2c9 = function(a) {
    return $8a1c60aeca462d1f$var$z(a) === $8a1c60aeca462d1f$var$k;
};
$8a1c60aeca462d1f$export$5be5a87408f70ddc = function(a) {
    return $8a1c60aeca462d1f$var$z(a) === $8a1c60aeca462d1f$var$h;
};
$8a1c60aeca462d1f$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $8a1c60aeca462d1f$var$c;
};
$8a1c60aeca462d1f$export$455c2e768291efa6 = function(a) {
    return $8a1c60aeca462d1f$var$z(a) === $8a1c60aeca462d1f$var$n;
};
$8a1c60aeca462d1f$export$9522e17588c12572 = function(a) {
    return $8a1c60aeca462d1f$var$z(a) === $8a1c60aeca462d1f$var$e;
};
$8a1c60aeca462d1f$export$2110ac352bb060b9 = function(a) {
    return $8a1c60aeca462d1f$var$z(a) === $8a1c60aeca462d1f$var$t;
};
$8a1c60aeca462d1f$export$56885ab8b9c456ab = function(a) {
    return $8a1c60aeca462d1f$var$z(a) === $8a1c60aeca462d1f$var$r;
};
$8a1c60aeca462d1f$export$d927fcb6adf8f9de = function(a) {
    return $8a1c60aeca462d1f$var$z(a) === $8a1c60aeca462d1f$var$d;
};
$8a1c60aeca462d1f$export$b82d16f27459e05a = function(a) {
    return $8a1c60aeca462d1f$var$z(a) === $8a1c60aeca462d1f$var$g;
};
$8a1c60aeca462d1f$export$522c17b4f5e123e8 = function(a) {
    return $8a1c60aeca462d1f$var$z(a) === $8a1c60aeca462d1f$var$f;
};
$8a1c60aeca462d1f$export$1aabd8a0274ecfd6 = function(a) {
    return $8a1c60aeca462d1f$var$z(a) === $8a1c60aeca462d1f$var$p;
};
$8a1c60aeca462d1f$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $8a1c60aeca462d1f$var$e || a === $8a1c60aeca462d1f$var$m || a === $8a1c60aeca462d1f$var$g || a === $8a1c60aeca462d1f$var$f || a === $8a1c60aeca462d1f$var$p || a === $8a1c60aeca462d1f$var$q || "object" === typeof a && null !== a && (a.$$typeof === $8a1c60aeca462d1f$var$t || a.$$typeof === $8a1c60aeca462d1f$var$r || a.$$typeof === $8a1c60aeca462d1f$var$h || a.$$typeof === $8a1c60aeca462d1f$var$k || a.$$typeof === $8a1c60aeca462d1f$var$n || a.$$typeof === $8a1c60aeca462d1f$var$w || a.$$typeof === $8a1c60aeca462d1f$var$x || a.$$typeof === $8a1c60aeca462d1f$var$y || a.$$typeof === $8a1c60aeca462d1f$var$v);
};
$8a1c60aeca462d1f$export$f5bbd400c2f4426f = $8a1c60aeca462d1f$var$z;

});

parcelRegister("1YBKS", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $1708ae6e4b4b8000$export$a7c73072b1a182ae, (v) => $1708ae6e4b4b8000$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $1708ae6e4b4b8000$export$9f27bc3417b4524d, (v) => $1708ae6e4b4b8000$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $1708ae6e4b4b8000$export$db77ccec0bb4ccac, (v) => $1708ae6e4b4b8000$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $1708ae6e4b4b8000$export$8392c0c9d3dcbd35, (v) => $1708ae6e4b4b8000$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $1708ae6e4b4b8000$export$ffb0004e005737fa, (v) => $1708ae6e4b4b8000$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $1708ae6e4b4b8000$export$b624eff549462981, (v) => $1708ae6e4b4b8000$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $1708ae6e4b4b8000$export$7897aa7841a5380c, (v) => $1708ae6e4b4b8000$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $1708ae6e4b4b8000$export$602eac185826482c, (v) => $1708ae6e4b4b8000$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $1708ae6e4b4b8000$export$e2c29f18771995cb, (v) => $1708ae6e4b4b8000$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $1708ae6e4b4b8000$export$5f8d39834fd61797, (v) => $1708ae6e4b4b8000$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1708ae6e4b4b8000$export$74bf444e3cd11ea5, (v) => $1708ae6e4b4b8000$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $1708ae6e4b4b8000$export$92387174baf9b227, (v) => $1708ae6e4b4b8000$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $1708ae6e4b4b8000$export$ec112efeb987d9c6, (v) => $1708ae6e4b4b8000$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $1708ae6e4b4b8000$export$b706b080d889d2c9, (v) => $1708ae6e4b4b8000$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $1708ae6e4b4b8000$export$5be5a87408f70ddc, (v) => $1708ae6e4b4b8000$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $1708ae6e4b4b8000$export$45a5e7f76e0caa8d, (v) => $1708ae6e4b4b8000$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $1708ae6e4b4b8000$export$455c2e768291efa6, (v) => $1708ae6e4b4b8000$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $1708ae6e4b4b8000$export$9522e17588c12572, (v) => $1708ae6e4b4b8000$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $1708ae6e4b4b8000$export$2110ac352bb060b9, (v) => $1708ae6e4b4b8000$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $1708ae6e4b4b8000$export$56885ab8b9c456ab, (v) => $1708ae6e4b4b8000$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $1708ae6e4b4b8000$export$d927fcb6adf8f9de, (v) => $1708ae6e4b4b8000$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $1708ae6e4b4b8000$export$b82d16f27459e05a, (v) => $1708ae6e4b4b8000$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $1708ae6e4b4b8000$export$522c17b4f5e123e8, (v) => $1708ae6e4b4b8000$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $1708ae6e4b4b8000$export$1aabd8a0274ecfd6, (v) => $1708ae6e4b4b8000$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $1708ae6e4b4b8000$export$9b621391a187a31a, (v) => $1708ae6e4b4b8000$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $1708ae6e4b4b8000$export$f5bbd400c2f4426f, (v) => $1708ae6e4b4b8000$export$f5bbd400c2f4426f = v);
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1708ae6e4b4b8000$export$a7c73072b1a182ae;
var $1708ae6e4b4b8000$export$9f27bc3417b4524d;
var $1708ae6e4b4b8000$export$db77ccec0bb4ccac;
var $1708ae6e4b4b8000$export$8392c0c9d3dcbd35;
var $1708ae6e4b4b8000$export$ffb0004e005737fa;
var $1708ae6e4b4b8000$export$b624eff549462981;
var $1708ae6e4b4b8000$export$7897aa7841a5380c;
var $1708ae6e4b4b8000$export$602eac185826482c;
var $1708ae6e4b4b8000$export$e2c29f18771995cb;
var $1708ae6e4b4b8000$export$5f8d39834fd61797;
var $1708ae6e4b4b8000$export$74bf444e3cd11ea5;
var $1708ae6e4b4b8000$export$92387174baf9b227;
var $1708ae6e4b4b8000$export$ec112efeb987d9c6;
var $1708ae6e4b4b8000$export$b706b080d889d2c9;
var $1708ae6e4b4b8000$export$5be5a87408f70ddc;
var $1708ae6e4b4b8000$export$45a5e7f76e0caa8d;
var $1708ae6e4b4b8000$export$455c2e768291efa6;
var $1708ae6e4b4b8000$export$9522e17588c12572;
var $1708ae6e4b4b8000$export$2110ac352bb060b9;
var $1708ae6e4b4b8000$export$56885ab8b9c456ab;
var $1708ae6e4b4b8000$export$d927fcb6adf8f9de;
var $1708ae6e4b4b8000$export$b82d16f27459e05a;
var $1708ae6e4b4b8000$export$522c17b4f5e123e8;
var $1708ae6e4b4b8000$export$1aabd8a0274ecfd6;
var $1708ae6e4b4b8000$export$9b621391a187a31a;
var $1708ae6e4b4b8000$export$f5bbd400c2f4426f;
'use strict';
var $1708ae6e4b4b8000$var$b = 60103, $1708ae6e4b4b8000$var$c = 60106, $1708ae6e4b4b8000$var$d = 60107, $1708ae6e4b4b8000$var$e = 60108, $1708ae6e4b4b8000$var$f = 60114, $1708ae6e4b4b8000$var$g = 60109, $1708ae6e4b4b8000$var$h = 60110, $1708ae6e4b4b8000$var$k = 60112, $1708ae6e4b4b8000$var$l = 60113, $1708ae6e4b4b8000$var$m = 60120, $1708ae6e4b4b8000$var$n = 60115, $1708ae6e4b4b8000$var$p = 60116, $1708ae6e4b4b8000$var$q = 60121, $1708ae6e4b4b8000$var$r = 60122, $1708ae6e4b4b8000$var$u = 60117, $1708ae6e4b4b8000$var$v = 60129, $1708ae6e4b4b8000$var$w = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var $1708ae6e4b4b8000$var$x = Symbol.for;
    $1708ae6e4b4b8000$var$b = $1708ae6e4b4b8000$var$x("react.element");
    $1708ae6e4b4b8000$var$c = $1708ae6e4b4b8000$var$x("react.portal");
    $1708ae6e4b4b8000$var$d = $1708ae6e4b4b8000$var$x("react.fragment");
    $1708ae6e4b4b8000$var$e = $1708ae6e4b4b8000$var$x("react.strict_mode");
    $1708ae6e4b4b8000$var$f = $1708ae6e4b4b8000$var$x("react.profiler");
    $1708ae6e4b4b8000$var$g = $1708ae6e4b4b8000$var$x("react.provider");
    $1708ae6e4b4b8000$var$h = $1708ae6e4b4b8000$var$x("react.context");
    $1708ae6e4b4b8000$var$k = $1708ae6e4b4b8000$var$x("react.forward_ref");
    $1708ae6e4b4b8000$var$l = $1708ae6e4b4b8000$var$x("react.suspense");
    $1708ae6e4b4b8000$var$m = $1708ae6e4b4b8000$var$x("react.suspense_list");
    $1708ae6e4b4b8000$var$n = $1708ae6e4b4b8000$var$x("react.memo");
    $1708ae6e4b4b8000$var$p = $1708ae6e4b4b8000$var$x("react.lazy");
    $1708ae6e4b4b8000$var$q = $1708ae6e4b4b8000$var$x("react.block");
    $1708ae6e4b4b8000$var$r = $1708ae6e4b4b8000$var$x("react.server.block");
    $1708ae6e4b4b8000$var$u = $1708ae6e4b4b8000$var$x("react.fundamental");
    $1708ae6e4b4b8000$var$v = $1708ae6e4b4b8000$var$x("react.debug_trace_mode");
    $1708ae6e4b4b8000$var$w = $1708ae6e4b4b8000$var$x("react.legacy_hidden");
}
function $1708ae6e4b4b8000$var$y(a) {
    if ("object" === typeof a && null !== a) {
        var t = a.$$typeof;
        switch(t){
            case $1708ae6e4b4b8000$var$b:
                switch(a = a.type, a){
                    case $1708ae6e4b4b8000$var$d:
                    case $1708ae6e4b4b8000$var$f:
                    case $1708ae6e4b4b8000$var$e:
                    case $1708ae6e4b4b8000$var$l:
                    case $1708ae6e4b4b8000$var$m:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $1708ae6e4b4b8000$var$h:
                            case $1708ae6e4b4b8000$var$k:
                            case $1708ae6e4b4b8000$var$p:
                            case $1708ae6e4b4b8000$var$n:
                            case $1708ae6e4b4b8000$var$g:
                                return a;
                            default:
                                return t;
                        }
                }
            case $1708ae6e4b4b8000$var$c:
                return t;
        }
    }
}
var $1708ae6e4b4b8000$var$z = $1708ae6e4b4b8000$var$g, $1708ae6e4b4b8000$var$A = $1708ae6e4b4b8000$var$b, $1708ae6e4b4b8000$var$B = $1708ae6e4b4b8000$var$k, $1708ae6e4b4b8000$var$C = $1708ae6e4b4b8000$var$d, $1708ae6e4b4b8000$var$D = $1708ae6e4b4b8000$var$p, $1708ae6e4b4b8000$var$E = $1708ae6e4b4b8000$var$n, $1708ae6e4b4b8000$var$F = $1708ae6e4b4b8000$var$c, $1708ae6e4b4b8000$var$G = $1708ae6e4b4b8000$var$f, $1708ae6e4b4b8000$var$H = $1708ae6e4b4b8000$var$e, $1708ae6e4b4b8000$var$I = $1708ae6e4b4b8000$var$l;
$1708ae6e4b4b8000$export$a7c73072b1a182ae = $1708ae6e4b4b8000$var$h;
$1708ae6e4b4b8000$export$9f27bc3417b4524d = $1708ae6e4b4b8000$var$z;
$1708ae6e4b4b8000$export$db77ccec0bb4ccac = $1708ae6e4b4b8000$var$A;
$1708ae6e4b4b8000$export$8392c0c9d3dcbd35 = $1708ae6e4b4b8000$var$B;
$1708ae6e4b4b8000$export$ffb0004e005737fa = $1708ae6e4b4b8000$var$C;
$1708ae6e4b4b8000$export$b624eff549462981 = $1708ae6e4b4b8000$var$D;
$1708ae6e4b4b8000$export$7897aa7841a5380c = $1708ae6e4b4b8000$var$E;
$1708ae6e4b4b8000$export$602eac185826482c = $1708ae6e4b4b8000$var$F;
$1708ae6e4b4b8000$export$e2c29f18771995cb = $1708ae6e4b4b8000$var$G;
$1708ae6e4b4b8000$export$5f8d39834fd61797 = $1708ae6e4b4b8000$var$H;
$1708ae6e4b4b8000$export$74bf444e3cd11ea5 = $1708ae6e4b4b8000$var$I;
$1708ae6e4b4b8000$export$92387174baf9b227 = function() {
    return !1;
};
$1708ae6e4b4b8000$export$ec112efeb987d9c6 = function() {
    return !1;
};
$1708ae6e4b4b8000$export$b706b080d889d2c9 = function(a) {
    return $1708ae6e4b4b8000$var$y(a) === $1708ae6e4b4b8000$var$h;
};
$1708ae6e4b4b8000$export$5be5a87408f70ddc = function(a) {
    return $1708ae6e4b4b8000$var$y(a) === $1708ae6e4b4b8000$var$g;
};
$1708ae6e4b4b8000$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1708ae6e4b4b8000$var$b;
};
$1708ae6e4b4b8000$export$455c2e768291efa6 = function(a) {
    return $1708ae6e4b4b8000$var$y(a) === $1708ae6e4b4b8000$var$k;
};
$1708ae6e4b4b8000$export$9522e17588c12572 = function(a) {
    return $1708ae6e4b4b8000$var$y(a) === $1708ae6e4b4b8000$var$d;
};
$1708ae6e4b4b8000$export$2110ac352bb060b9 = function(a) {
    return $1708ae6e4b4b8000$var$y(a) === $1708ae6e4b4b8000$var$p;
};
$1708ae6e4b4b8000$export$56885ab8b9c456ab = function(a) {
    return $1708ae6e4b4b8000$var$y(a) === $1708ae6e4b4b8000$var$n;
};
$1708ae6e4b4b8000$export$d927fcb6adf8f9de = function(a) {
    return $1708ae6e4b4b8000$var$y(a) === $1708ae6e4b4b8000$var$c;
};
$1708ae6e4b4b8000$export$b82d16f27459e05a = function(a) {
    return $1708ae6e4b4b8000$var$y(a) === $1708ae6e4b4b8000$var$f;
};
$1708ae6e4b4b8000$export$522c17b4f5e123e8 = function(a) {
    return $1708ae6e4b4b8000$var$y(a) === $1708ae6e4b4b8000$var$e;
};
$1708ae6e4b4b8000$export$1aabd8a0274ecfd6 = function(a) {
    return $1708ae6e4b4b8000$var$y(a) === $1708ae6e4b4b8000$var$l;
};
$1708ae6e4b4b8000$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $1708ae6e4b4b8000$var$d || a === $1708ae6e4b4b8000$var$f || a === $1708ae6e4b4b8000$var$v || a === $1708ae6e4b4b8000$var$e || a === $1708ae6e4b4b8000$var$l || a === $1708ae6e4b4b8000$var$m || a === $1708ae6e4b4b8000$var$w || "object" === typeof a && null !== a && (a.$$typeof === $1708ae6e4b4b8000$var$p || a.$$typeof === $1708ae6e4b4b8000$var$n || a.$$typeof === $1708ae6e4b4b8000$var$g || a.$$typeof === $1708ae6e4b4b8000$var$h || a.$$typeof === $1708ae6e4b4b8000$var$k || a.$$typeof === $1708ae6e4b4b8000$var$u || a.$$typeof === $1708ae6e4b4b8000$var$q || a[0] === $1708ae6e4b4b8000$var$r) ? !0 : !1;
};
$1708ae6e4b4b8000$export$f5bbd400c2f4426f = $1708ae6e4b4b8000$var$y;

});

parcelRegister("6bvDC", function(module, exports) {

$parcel$export(module.exports, "isDraft", () => r);
$parcel$export(module.exports, "isDraftable", () => t);
$parcel$export(module.exports, "immerable", () => L);
$parcel$export(module.exports, "original", () => e);
$parcel$export(module.exports, "freeze", () => d);
$parcel$export(module.exports, "nothing", () => H);
$parcel$export(module.exports, "current", () => R);
$parcel$export(module.exports, "enableES5", () => F);
$parcel$export(module.exports, "enablePatches", () => T);
$parcel$export(module.exports, "enableMapSet", () => C);
$parcel$export(module.exports, "enableAllPlugins", () => J);
$parcel$export(module.exports, "castDraft", () => K);
$parcel$export(module.exports, "castImmutable", () => $);
$parcel$export(module.exports, "Immer", () => un);
$parcel$export(module.exports, "produce", () => fn);
$parcel$export(module.exports, "produceWithPatches", () => cn);
$parcel$export(module.exports, "setAutoFreeze", () => sn);
$parcel$export(module.exports, "setUseProxies", () => vn);
$parcel$export(module.exports, "applyPatches", () => pn);
$parcel$export(module.exports, "createDraft", () => ln);
$parcel$export(module.exports, "finishDraft", () => dn);
$parcel$export(module.exports, "default", () => $480c4fd31131abbc$export$2e2bcd8739ae039);
function n(n) {
    for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
    var i, o;
    throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function r(n) {
    return !!n && !!n[Q];
}
function t(n) {
    var r;
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var r = Object.getPrototypeOf(n);
        if (null === r) return !0;
        var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
        return t === Object || "function" == typeof t && Function.toString.call(t) === Z;
    }(n) || Array.isArray(n) || !!n[L] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[L]) || s(n) || v(n));
}
function e(t) {
    return r(t) || n(23, t), t[Q].t;
}
function i(n, r, t) {
    void 0 === t && (t = !1), 0 === o(n) ? (t ? Object.keys : nn)(n).forEach(function(e) {
        t && "symbol" == typeof e || r(e, n[e], n);
    }) : n.forEach(function(t, e) {
        return r(e, t, n);
    });
}
function o(n) {
    var r = n[Q];
    return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : s(n) ? 2 : v(n) ? 3 : 0;
}
function u(n, r) {
    return 2 === o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function a(n, r) {
    return 2 === o(n) ? n.get(r) : n[r];
}
function f(n, r, t) {
    var e = o(n);
    2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
}
function c(n, r) {
    return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
}
function s(n) {
    return X && n instanceof Map;
}
function v(n) {
    return q && n instanceof Set;
}
function p(n) {
    return n.o || n.t;
}
function l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var r = rn(n);
    delete r[Q];
    for(var t = nn(r), e = 0; e < t.length; e++){
        var i = t[e], o = r[i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), r);
}
function d(n, e) {
    return void 0 === e && (e = !1), y(n) || r(n) || !t(n) || (o(n) > 1 && (n.set = n.add = n.clear = n.delete = h), Object.freeze(n), e && i(n, function(n, r) {
        return d(r, !0);
    }, !0)), n;
}
function h() {
    n(2);
}
function y(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function b(r) {
    var t = tn[r];
    return t || n(18, r), t;
}
function m(n, r) {
    tn[n] || (tn[n] = r);
}
function _() {
    return U;
}
function j(n, r) {
    r && (b("Patches"), n.u = [], n.s = [], n.v = r);
}
function g(n) {
    O(n), n.p.forEach(S), n.p = null;
}
function O(n) {
    n === U && (U = n.l);
}
function w(n) {
    return U = {
        p: [],
        l: U,
        h: n,
        m: !0,
        _: 0
    };
}
function S(n) {
    var r = n[Q];
    0 === r.i || 1 === r.i ? r.j() : r.g = !0;
}
function P(r, e) {
    e._ = e.p.length;
    var i = e.p[0], o = void 0 !== r && r !== i;
    return e.h.O || b("ES5").S(e, r, o), o ? (i[Q].P && (g(e), n(4)), t(r) && (r = M(e, r), e.l || x(e, r)), e.u && b("Patches").M(i[Q].t, r, e.u, e.s)) : r = M(e, i, []), g(e), e.u && e.v(e.u, e.s), r !== H ? r : void 0;
}
function M(n, r, t) {
    if (y(r)) return r;
    var e = r[Q];
    if (!e) return i(r, function(i, o) {
        return A(n, e, r, i, o, t);
    }, !0), r;
    if (e.A !== n) return r;
    if (!e.P) return x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o, u = o, a = !1;
        3 === e.i && (u = new Set(o), o.clear(), a = !0), i(u, function(r, i) {
            return A(n, e, o, r, i, t, a);
        }), x(n, o, !1), t && n.u && b("Patches").N(e, t, n.u, n.s);
    }
    return e.o;
}
function A(e, i, o, a, c, s, v) {
    if (r(c)) {
        var p = M(e, c, s && i && 3 !== i.i && !u(i.R, a) ? s.concat(a) : void 0);
        if (f(o, a, p), !r(p)) return;
        e.m = !1;
    } else v && o.add(c);
    if (t(c) && !y(c)) {
        if (!e.h.D && e._ < 1) return;
        M(e, c), i && i.A.l || x(e, c);
    }
}
function x(n, r, t) {
    void 0 === t && (t = !1), !n.l && n.h.D && n.m && d(r, t);
}
function z(n, r) {
    var t = n[Q];
    return (t ? p(t) : n)[r];
}
function I(n, r) {
    if (r in n) for(var t = Object.getPrototypeOf(n); t;){
        var e = Object.getOwnPropertyDescriptor(t, r);
        if (e) return e;
        t = Object.getPrototypeOf(t);
    }
}
function k(n) {
    n.P || (n.P = !0, n.l && k(n.l));
}
function E(n) {
    n.o || (n.o = l(n.t));
}
function N(n, r, t) {
    var e = s(r) ? b("MapSet").F(r, t) : v(r) ? b("MapSet").T(r, t) : n.O ? function(n, r) {
        var t = Array.isArray(n), e = {
            i: t ? 1 : 0,
            A: r ? r.A : _(),
            P: !1,
            I: !1,
            R: {},
            l: r,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, i = e, o = en;
        t && (i = [
            e
        ], o = on);
        var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(r, t) : b("ES5").J(r, t);
    return (t ? t.A : _()).p.push(e), e;
}
function R(e) {
    return r(e) || n(22, e), function n(r) {
        if (!t(r)) return r;
        var e, u = r[Q], c = o(r);
        if (u) {
            if (!u.P && (u.i < 4 || !b("ES5").K(u))) return u.t;
            u.I = !0, e = D(r, c), u.I = !1;
        } else e = D(r, c);
        return i(e, function(r, t) {
            u && a(u.t, r) === t || f(e, r, n(t));
        }), 3 === c ? new Set(e) : e;
    }(e);
}
function D(n, r) {
    switch(r){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return l(n);
}
function F() {
    function t(n, r) {
        var t = s[n];
        return t ? t.enumerable = r : s[n] = t = {
            configurable: !0,
            enumerable: r,
            get: function() {
                var r = this[Q];
                return en.get(r, n);
            },
            set: function(r) {
                var t = this[Q];
                en.set(t, n, r);
            }
        }, t;
    }
    function e(n) {
        for(var r = n.length - 1; r >= 0; r--){
            var t = n[r][Q];
            if (!t.P) switch(t.i){
                case 5:
                    a(t) && k(t);
                    break;
                case 4:
                    o(t) && k(t);
            }
        }
    }
    function o(n) {
        for(var r = n.t, t = n.k, e = nn(t), i = e.length - 1; i >= 0; i--){
            var o = e[i];
            if (o !== Q) {
                var a = r[o];
                if (void 0 === a && !u(r, o)) return !0;
                var f = t[o], s = f && f[Q];
                if (s ? s.t !== a : !c(f, a)) return !0;
            }
        }
        var v = !!r[Q];
        return e.length !== nn(r).length + (v ? 0 : 1);
    }
    function a(n) {
        var r = n.k;
        if (r.length !== n.t.length) return !0;
        var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
        if (t && !t.get) return !0;
        for(var e = 0; e < r.length; e++)if (!r.hasOwnProperty(e)) return !0;
        return !1;
    }
    function f(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var s = {};
    m("ES5", {
        J: function(n, r) {
            var e = Array.isArray(n), i = function(n, r) {
                if (n) {
                    for(var e = Array(r.length), i = 0; i < r.length; i++)Object.defineProperty(e, "" + i, t(i, !0));
                    return e;
                }
                var o = rn(r);
                delete o[Q];
                for(var u = nn(o), a = 0; a < u.length; a++){
                    var f = u[a];
                    o[f] = t(f, n || !!o[f].enumerable);
                }
                return Object.create(Object.getPrototypeOf(r), o);
            }(e, n), o = {
                i: e ? 5 : 4,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                R: {},
                l: r,
                t: n,
                k: i,
                o: null,
                g: !1,
                C: !1
            };
            return Object.defineProperty(i, Q, {
                value: o,
                writable: !0
            }), i;
        },
        S: function(n, t, o) {
            o ? r(t) && t[Q].A === n && e(n.p) : (n.u && function n(r) {
                if (r && "object" == typeof r) {
                    var t = r[Q];
                    if (t) {
                        var e = t.t, o = t.k, f = t.R, c = t.i;
                        if (4 === c) i(o, function(r) {
                            r !== Q && (void 0 !== e[r] || u(e, r) ? f[r] || n(o[r]) : (f[r] = !0, k(t)));
                        }), i(e, function(n) {
                            void 0 !== o[n] || u(o, n) || (f[n] = !1, k(t));
                        });
                        else if (5 === c) {
                            if (a(t) && (k(t), f.length = !0), o.length < e.length) for(var s = o.length; s < e.length; s++)f[s] = !1;
                            else for(var v = e.length; v < o.length; v++)f[v] = !0;
                            for(var p = Math.min(o.length, e.length), l = 0; l < p; l++)o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(o[l]);
                        }
                    }
                }
            }(n.p[0]), e(n.p));
        },
        K: function(n) {
            return 4 === n.i ? o(n) : a(n);
        }
    });
}
function T() {
    function e(n) {
        if (!t(n)) return n;
        if (Array.isArray(n)) return n.map(e);
        if (s(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                e(n[1])
            ];
        }));
        if (v(n)) return new Set(Array.from(n).map(e));
        var r = Object.create(Object.getPrototypeOf(n));
        for(var i in n)r[i] = e(n[i]);
        return u(n, L) && (r[L] = n[L]), r;
    }
    function f(n) {
        return r(n) ? e(n) : n;
    }
    var c = "add";
    m("Patches", {
        $: function(r, t) {
            return t.forEach(function(t) {
                for(var i = t.path, u = t.op, f = r, s = 0; s < i.length - 1; s++){
                    var v = o(f), p = i[s];
                    "string" != typeof p && "number" != typeof p && (p = "" + p), 0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || n(24), "function" == typeof f && "prototype" === p && n(24), "object" != typeof (f = a(f, p)) && n(15, i.join("/"));
                }
                var l = o(f), d = e(t.value), h = i[i.length - 1];
                switch(u){
                    case "replace":
                        switch(l){
                            case 2:
                                return f.set(h, d);
                            case 3:
                                n(16);
                            default:
                                return f[h] = d;
                        }
                    case c:
                        switch(l){
                            case 1:
                                return "-" === h ? f.push(d) : f.splice(h, 0, d);
                            case 2:
                                return f.set(h, d);
                            case 3:
                                return f.add(d);
                            default:
                                return f[h] = d;
                        }
                    case "remove":
                        switch(l){
                            case 1:
                                return f.splice(h, 1);
                            case 2:
                                return f.delete(h);
                            case 3:
                                return f.delete(t.value);
                            default:
                                return delete f[h];
                        }
                    default:
                        n(17, u);
                }
            }), r;
        },
        N: function(n, r, t, e) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, r, t, e) {
                        var o = n.t, s = n.o;
                        i(n.R, function(n, i) {
                            var v = a(o, n), p = a(s, n), l = i ? u(o, n) ? "replace" : c : "remove";
                            if (v !== p || "replace" !== l) {
                                var d = r.concat(n);
                                t.push("remove" === l ? {
                                    op: l,
                                    path: d
                                } : {
                                    op: l,
                                    path: d,
                                    value: p
                                }), e.push(l === c ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === l ? {
                                    op: c,
                                    path: d,
                                    value: f(v)
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: f(v)
                                });
                            }
                        });
                    }(n, r, t, e);
                case 5:
                case 1:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.R, u = n.o;
                        if (u.length < i.length) {
                            var a = [
                                u,
                                i
                            ];
                            i = a[0], u = a[1];
                            var s = [
                                e,
                                t
                            ];
                            t = s[0], e = s[1];
                        }
                        for(var v = 0; v < i.length; v++)if (o[v] && u[v] !== i[v]) {
                            var p = r.concat([
                                v
                            ]);
                            t.push({
                                op: "replace",
                                path: p,
                                value: f(u[v])
                            }), e.push({
                                op: "replace",
                                path: p,
                                value: f(i[v])
                            });
                        }
                        for(var l = i.length; l < u.length; l++){
                            var d = r.concat([
                                l
                            ]);
                            t.push({
                                op: c,
                                path: d,
                                value: f(u[l])
                            });
                        }
                        i.length < u.length && e.push({
                            op: "replace",
                            path: r.concat([
                                "length"
                            ]),
                            value: i.length
                        });
                    }(n, r, t, e);
                case 3:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.o, u = 0;
                        i.forEach(function(n) {
                            if (!o.has(n)) {
                                var i = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: "remove",
                                    path: i,
                                    value: n
                                }), e.unshift({
                                    op: c,
                                    path: i,
                                    value: n
                                });
                            }
                            u++;
                        }), u = 0, o.forEach(function(n) {
                            if (!i.has(n)) {
                                var o = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: c,
                                    path: o,
                                    value: n
                                }), e.unshift({
                                    op: "remove",
                                    path: o,
                                    value: n
                                });
                            }
                            u++;
                        });
                    }(n, r, t, e);
            }
        },
        M: function(n, r, t, e) {
            t.push({
                op: "replace",
                path: [],
                value: r === H ? void 0 : r
            }), e.push({
                op: "replace",
                path: [],
                value: n
            });
        }
    });
}
function C() {
    function r(n, r) {
        function t() {
            this.constructor = n;
        }
        a(n, r), n.prototype = (t.prototype = r.prototype, new t);
    }
    function e(n) {
        n.o || (n.R = new Map, n.o = new Map(n.t));
    }
    function o(n) {
        n.o || (n.o = new Set, n.t.forEach(function(r) {
            if (t(r)) {
                var e = N(n.A.h, r, n);
                n.p.set(r, e), n.o.add(e);
            } else n.o.add(r);
        }));
    }
    function u(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var a = function(n, r) {
        return (a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, r) {
            n.__proto__ = r;
        } || function(n, r) {
            for(var t in r)r.hasOwnProperty(t) && (n[t] = r[t]);
        })(n, r);
    }, f = function() {
        function n(n, r) {
            return this[Q] = {
                i: 2,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                R: void 0,
                t: n,
                k: this,
                C: !1,
                g: !1
            }, this;
        }
        r(n, Map);
        var o = n.prototype;
        return Object.defineProperty(o, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), o.has = function(n) {
            return p(this[Q]).has(n);
        }, o.set = function(n, r) {
            var t = this[Q];
            return u(t), p(t).has(n) && p(t).get(n) === r || (e(t), k(t), t.R.set(n, !0), t.o.set(n, r), t.R.set(n, !0)), this;
        }, o.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), e(r), k(r), r.t.has(n) ? r.R.set(n, !1) : r.R.delete(n), r.o.delete(n), !0;
        }, o.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (e(n), k(n), n.R = new Map, i(n.t, function(r) {
                n.R.set(r, !1);
            }), n.o.clear());
        }, o.forEach = function(n, r) {
            var t = this;
            p(this[Q]).forEach(function(e, i) {
                n.call(r, t.get(i), i, t);
            });
        }, o.get = function(n) {
            var r = this[Q];
            u(r);
            var i = p(r).get(n);
            if (r.I || !t(i)) return i;
            if (i !== r.t.get(n)) return i;
            var o = N(r.A.h, i, r);
            return e(r), r.o.set(n, o), o;
        }, o.keys = function() {
            return p(this[Q]).keys();
        }, o.values = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.values();
            }, n.next = function() {
                var n = t.next();
                return n.done ? n : {
                    done: !1,
                    value: r.get(n.value)
                };
            }, n;
        }, o.entries = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.entries();
            }, n.next = function() {
                var n = t.next();
                if (n.done) return n;
                var e = r.get(n.value);
                return {
                    done: !1,
                    value: [
                        n.value,
                        e
                    ]
                };
            }, n;
        }, o[V] = function() {
            return this.entries();
        }, n;
    }(), c = function() {
        function n(n, r) {
            return this[Q] = {
                i: 3,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                g: !1,
                C: !1
            }, this;
        }
        r(n, Set);
        var t = n.prototype;
        return Object.defineProperty(t, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), t.has = function(n) {
            var r = this[Q];
            return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
        }, t.add = function(n) {
            var r = this[Q];
            return u(r), this.has(n) || (o(r), k(r), r.o.add(n)), this;
        }, t.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), o(r), k(r), r.o.delete(n) || !!r.p.has(n) && r.o.delete(r.p.get(n));
        }, t.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (o(n), k(n), n.o.clear());
        }, t.values = function() {
            var n = this[Q];
            return u(n), o(n), n.o.values();
        }, t.entries = function() {
            var n = this[Q];
            return u(n), o(n), n.o.entries();
        }, t.keys = function() {
            return this.values();
        }, t[V] = function() {
            return this.values();
        }, t.forEach = function(n, r) {
            for(var t = this.values(), e = t.next(); !e.done;)n.call(r, e.value, e.value, this), e = t.next();
        }, n;
    }();
    m("MapSet", {
        F: function(n, r) {
            return new f(n, r);
        },
        T: function(n, r) {
            return new c(n, r);
        }
    });
}
function J() {
    F(), C(), T();
}
function K(n) {
    return n;
}
function $(n) {
    return n;
}
var G, U, W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), X = "undefined" != typeof Map, q = "undefined" != typeof Set, B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, Z = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(n) {
    var r = {};
    return nn(n).forEach(function(t) {
        r[t] = Object.getOwnPropertyDescriptor(n, t);
    }), r;
}, tn = {}, en = {
    get: function(n, r) {
        if (r === Q) return n;
        var e = p(n);
        if (!u(e, r)) return function(n, r, t) {
            var e, i = I(r, t);
            return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, r);
        var i = e[r];
        return n.I || !t(i) ? i : i === z(n.t, r) ? (E(n), n.o[r] = N(n.A.h, i, n)) : i;
    },
    has: function(n, r) {
        return r in p(n);
    },
    ownKeys: function(n) {
        return Reflect.ownKeys(p(n));
    },
    set: function(n, r, t) {
        var e = I(p(n), r);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
        if (!n.P) {
            var i = z(p(n), r), o = null == i ? void 0 : i[Q];
            if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
            if (c(t, i) && (void 0 !== t || u(n.t, r))) return !0;
            E(n), k(n);
        }
        return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
    },
    deleteProperty: function(n, r) {
        return void 0 !== z(n.t, r) || r in n.t ? (n.R[r] = !1, E(n), k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
    },
    getOwnPropertyDescriptor: function(n, r) {
        var t = p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== r,
            enumerable: e.enumerable,
            value: t[r]
        } : e;
    },
    defineProperty: function() {
        n(11);
    },
    getPrototypeOf: function(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function() {
        n(12);
    }
}, on = {};
i(en, function(n, r) {
    on[n] = function() {
        return arguments[0] = arguments[0][0], r.apply(this, arguments);
    };
}), on.deleteProperty = function(r, t) {
    return on.set.call(this, r, t, void 0);
}, on.set = function(r, t, e) {
    return en.set.call(this, r[0], t, e, r[0]);
};
var un = function() {
    function e(r) {
        var e = this;
        this.O = B, this.D = !0, this.produce = function(r, i, o) {
            if ("function" == typeof r && "function" != typeof i) {
                var u = i;
                i = r;
                var a = e;
                return function(n) {
                    var r = this;
                    void 0 === n && (n = u);
                    for(var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)e[o - 1] = arguments[o];
                    return a.produce(n, function(n) {
                        var t;
                        return (t = i).call.apply(t, [
                            r,
                            n
                        ].concat(e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && n(6), void 0 !== o && "function" != typeof o && n(7), t(r)) {
                var c = w(e), s = N(e, r, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? g(c) : O(c);
                }
                return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                    return j(c, o), P(n, c);
                }, function(n) {
                    throw g(c), n;
                }) : (j(c, o), P(f, c));
            }
            if (!r || "object" != typeof r) {
                if (void 0 === (f = i(r)) && (f = r), f === H && (f = void 0), e.D && d(f, !0), o) {
                    var p = [], l = [];
                    b("Patches").M(r, f, p, l), o(p, l);
                }
                return f;
            }
            n(21, r);
        }, this.produceWithPatches = function(n, r) {
            if ("function" == typeof n) return function(r) {
                for(var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)i[o - 1] = arguments[o];
                return e.produceWithPatches(r, function(r) {
                    return n.apply(void 0, [
                        r
                    ].concat(i));
                });
            };
            var t, i, o = e.produce(n, r, function(n, r) {
                t = n, i = r;
            });
            return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                return [
                    n,
                    t,
                    i
                ];
            }) : [
                o,
                t,
                i
            ];
        }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
    }
    var i = e.prototype;
    return i.createDraft = function(e) {
        t(e) || n(8), r(e) && (e = R(e));
        var i = w(this), o = N(this, e, void 0);
        return o[Q].C = !0, O(i), o;
    }, i.finishDraft = function(r, t) {
        var e = r && r[Q];
        var i = e.A;
        return j(i, t), P(void 0, i);
    }, i.setAutoFreeze = function(n) {
        this.D = n;
    }, i.setUseProxies = function(r) {
        r && !B && n(20), this.O = r;
    }, i.applyPatches = function(n, t) {
        var e;
        for(e = t.length - 1; e >= 0; e--){
            var i = t[e];
            if (0 === i.path.length && "replace" === i.op) {
                n = i.value;
                break;
            }
        }
        e > -1 && (t = t.slice(e + 1));
        var o = b("Patches").$;
        return r(n) ? o(n, t) : this.produce(n, function(n) {
            return o(n, t);
        });
    }, e;
}(), an = new un, fn = an.produce, cn = an.produceWithPatches.bind(an), sn = an.setAutoFreeze.bind(an), vn = an.setUseProxies.bind(an), pn = an.applyPatches.bind(an), ln = an.createDraft.bind(an), dn = an.finishDraft.bind(an);
var $480c4fd31131abbc$export$2e2bcd8739ae039 = fn;

});

parcelRegister("hrvvF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $cb2d6678dab51cb8$export$1e511d4a378977f5, (v) => $cb2d6678dab51cb8$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $cb2d6678dab51cb8$export$2e2bcd8739ae039, (v) => $cb2d6678dab51cb8$export$2e2bcd8739ae039 = v);
var $cb2d6678dab51cb8$export$1e511d4a378977f5;
var $cb2d6678dab51cb8$export$2e2bcd8739ae039;
"use strict";
$cb2d6678dab51cb8$export$1e511d4a378977f5 = true;
$cb2d6678dab51cb8$export$2e2bcd8739ae039 = $cb2d6678dab51cb8$var$createWebStorage;

var $cb2d6678dab51cb8$var$_getStorage = $cb2d6678dab51cb8$var$_interopRequireDefault((parcelRequire("1n0uj")));
function $cb2d6678dab51cb8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $cb2d6678dab51cb8$var$createWebStorage(type) {
    var storage = (0, $cb2d6678dab51cb8$var$_getStorage.default)(type);
    return {
        getItem: function getItem(key) {
            return new Promise(function(resolve, reject) {
                resolve(storage.getItem(key));
            });
        },
        setItem: function setItem(key, item) {
            return new Promise(function(resolve, reject) {
                resolve(storage.setItem(key, item));
            });
        },
        removeItem: function removeItem(key) {
            return new Promise(function(resolve, reject) {
                resolve(storage.removeItem(key));
            });
        }
    };
}

});
parcelRegister("1n0uj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $0ff8514bbd8b56f0$export$1e511d4a378977f5, (v) => $0ff8514bbd8b56f0$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $0ff8514bbd8b56f0$export$2e2bcd8739ae039, (v) => $0ff8514bbd8b56f0$export$2e2bcd8739ae039 = v);
var $0ff8514bbd8b56f0$export$1e511d4a378977f5;
var $0ff8514bbd8b56f0$export$2e2bcd8739ae039;
"use strict";
$0ff8514bbd8b56f0$export$1e511d4a378977f5 = true;
$0ff8514bbd8b56f0$export$2e2bcd8739ae039 = $0ff8514bbd8b56f0$var$getStorage;
function $0ff8514bbd8b56f0$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $0ff8514bbd8b56f0$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $0ff8514bbd8b56f0$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $0ff8514bbd8b56f0$var$_typeof(obj);
}
function $0ff8514bbd8b56f0$var$noop() {}
var $0ff8514bbd8b56f0$var$noopStorage = {
    getItem: $0ff8514bbd8b56f0$var$noop,
    setItem: $0ff8514bbd8b56f0$var$noop,
    removeItem: $0ff8514bbd8b56f0$var$noop
};
function $0ff8514bbd8b56f0$var$hasStorage(storageType) {
    if ((typeof self === "undefined" ? "undefined" : $0ff8514bbd8b56f0$var$_typeof(self)) !== 'object' || !(storageType in self)) return false;
    try {
        var storage = self[storageType];
        var testKey = "redux-persist ".concat(storageType, " test");
        storage.setItem(testKey, 'test');
        storage.getItem(testKey);
        storage.removeItem(testKey);
    } catch (e) {
        return false;
    }
    return true;
}
function $0ff8514bbd8b56f0$var$getStorage(type) {
    var storageType = "".concat(type, "Storage");
    if ($0ff8514bbd8b56f0$var$hasStorage(storageType)) return self[storageType];
    else return $0ff8514bbd8b56f0$var$noopStorage;
}

});


parcelRegister("ejSM7", function(module, exports) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, 'toString')) a.toString = b.toString;
        if (hasOwnProp(b, 'valueOf')) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) console.warn('Deprecation warning: ' + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ': ' + arguments[0][key] + ', ';
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this['_' + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L'
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, '');
        return input.replace(/\\/g, '');
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = '', i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') return tok.slice(1);
            return tok;
        }).join('');
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = 'Invalid date';
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = '%d', defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }
    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year'
    };
    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === 'string') token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken('Y', 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });
    addFormatToken(0, [
        'YY',
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        'YYYY',
        4
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYY',
        5
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYYY',
        6,
        true
    ], 0, 'year');
    // PARSING
    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);
    addParseToken([
        'YYYYY',
        'YYYYYY'
    ], YEAR);
    addParseToken('YYYY', function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet('FullYear', true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken('M', [
        'MM',
        2
    ], 'Mo', function() {
        return this.month() + 1;
    });
    addFormatToken('MMM', 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken('MMMM', 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        'M',
        'MM'
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        'MMM',
        'MMMM'
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'), defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months['standalone'];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, 'Month');
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken('w', [
        'ww',
        2
    ], 'wo', 'week');
    addFormatToken('W', [
        'WW',
        2
    ], 'Wo', 'isoWeek');
    // PARSING
    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);
    addWeekParseToken([
        'w',
        'ww',
        'W',
        'WW'
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    // FORMATTING
    addFormatToken('d', 0, 'do', 'day');
    addFormatToken('dd', 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken('ddd', 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken('dddd', 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');
    // PARSING
    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        'dd',
        'ddd',
        'dddd'
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        'd',
        'e',
        'E'
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== 'string') return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === 'number') return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'), defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'), defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken('H', [
        'HH',
        2
    ], 0, 'hour');
    addFormatToken('h', [
        'hh',
        2
    ], 0, hFormat);
    addFormatToken('k', [
        'kk',
        2
    ], 0, kFormat);
    addFormatToken('hmm', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken('hmmss', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken('Hmm', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken('Hmmss', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem('a', true);
    meridiem('A', false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);
    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);
    addParseToken([
        'H',
        'HH'
    ], HOUR);
    addParseToken([
        'k',
        'kk'
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        'a',
        'A'
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        'h',
        'hh'
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet('Hours', true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? 'pm' : 'PM';
        else return isLower ? 'am' : 'AM';
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire('./locale/' + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== 'undefined' && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride', "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            'YYYYYY-MM-DD',
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            'YYYY-MM-DD',
            /\d{4}-\d\d-\d\d/
        ],
        [
            'GGGG-[W]WW-E',
            /\d{4}-W\d\d-\d/
        ],
        [
            'GGGG-[W]WW',
            /\d{4}-W\d\d/,
            false
        ],
        [
            'YYYY-DDD',
            /\d{4}-\d{3}/
        ],
        [
            'YYYY-MM',
            /\d{4}-\d\d/,
            false
        ],
        [
            'YYYYYYMMDD',
            /[+-]\d{10}/
        ],
        [
            'YYYYMMDD',
            /\d{8}/
        ],
        [
            'GGGG[W]WWE',
            /\d{4}W\d{3}/
        ],
        [
            'GGGG[W]WW',
            /\d{4}W\d{2}/,
            false
        ],
        [
            'YYYYDDD',
            /\d{7}/
        ],
        [
            'YYYYMM',
            /\d{6}/,
            false
        ],
        [
            'YYYY',
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            'HH:mm:ss.SSSS',
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            'HH:mm:ss,SSSS',
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            'HH:mm:ss',
            /\d\d:\d\d:\d\d/
        ],
        [
            'HH:mm',
            /\d\d:\d\d/
        ],
        [
            'HHmmss.SSSS',
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            'HHmmss,SSSS',
            /\d\d\d\d\d\d,\d+/
        ],
        [
            'HHmmss',
            /\d\d\d\d\d\d/
        ],
        [
            'HHmm',
            /\d\d\d\d/
        ],
        [
            'HH',
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = 'Z';
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === '') return createInvalid({
            nullInput: true
        });
        if (typeof input === 'string') config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === 'string') configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isBefore', args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isAfter', args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond'
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset('Z', ':');
    offset('ZZ', '');
    // PARSING
    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken([
        'Z',
        'ZZ'
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || [
            '-',
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, 'm');
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), 'm');
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, '_locale')) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, '_isValid')) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, 'M');
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, 'Month') + months * isAdding);
        if (days) set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, 'add'), subtract = createAdder(-1, 'subtract');
    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'years',
            'year',
            'y',
            'months',
            'month',
            'M',
            'days',
            'day',
            'd',
            'dates',
            'date',
            'D',
            'hours',
            'hour',
            'h',
            'minutes',
            'minute',
            'm',
            'seconds',
            'second',
            's',
            'milliseconds',
            'millisecond',
            'ms'
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'sameDay',
            'nextDay',
            'lastDay',
            'nextWeek',
            'lastWeek',
            'sameElse'
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf('day'), format = hooks.calendarFormat(this, sod) || 'sameElse', output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return 'moment.invalid(/* ' + this._i + ' */)';
        var func = 'moment', zone = '', prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
    addFormatToken('y', [
        'y',
        1
    ], 'yo', 'eraYear');
    addFormatToken('y', [
        'yy',
        2
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyy',
        3
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyyy',
        4
    ], 0, 'eraYear');
    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);
    addParseToken([
        'N',
        'NN',
        'NNN',
        'NNNN',
        'NNNNN'
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);
    addParseToken([
        'y',
        'yy',
        'yyy',
        'yyyy'
    ], YEAR);
    addParseToken([
        'yo'
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale('en')._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case 'undefined':
                    eras[i].until = Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case 'N':
                case 'NN':
                case 'NNN':
                    if (abbr === eraName) return eras[i];
                    break;
                case 'NNNN':
                    if (name === eraName) return eras[i];
                    break;
                case 'NNNNN':
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return '';
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return '';
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return '';
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken(0, [
        'gg',
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        'GG',
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
    // ALIASES
    // PARSING
    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);
    addWeekParseToken([
        'gggg',
        'ggggg',
        'GGGG',
        'GGGGG'
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        'gg',
        'GG'
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken('Q', 0, 'Qo', 'quarter');
    // PARSING
    addRegexToken('Q', match1);
    addParseToken('Q', function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken('D', [
        'DD',
        2
    ], 'Do', 'date');
    // PARSING
    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        'D',
        'DD'
    ], DATE);
    addParseToken('Do', function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet('Date', true);
    // FORMATTING
    addFormatToken('DDD', [
        'DDDD',
        3
    ], 'DDDo', 'dayOfYear');
    // PARSING
    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken([
        'DDD',
        'DDDD'
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }
    // FORMATTING
    addFormatToken('m', [
        'mm',
        2
    ], 0, 'minute');
    // PARSING
    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken([
        'm',
        'mm'
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet('Minutes', false);
    // FORMATTING
    addFormatToken('s', [
        'ss',
        2
    ], 0, 'second');
    // PARSING
    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken([
        's',
        'ss'
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet('Seconds', false);
    // FORMATTING
    addFormatToken('S', 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        'SS',
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        'SSS',
        3
    ], 0, 'millisecond');
    addFormatToken(0, [
        'SSSS',
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        'SSSSS',
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        'SSSSSS',
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        'SSSSSSS',
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        'SSSSSSSS',
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        'SSSSSSSSS',
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);
    var token, getSetMillisecond;
    for(token = 'SSSS'; token.length <= 9; token += 'S')addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }
    for(token = 'S'; token.length <= 9; token += 'S')addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet('Milliseconds', false);
    // FORMATTING
    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }
    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) proto[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return 'Moment<' + this.format() + '>';
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || '';
        if (index != null) return get$1(format, index, field, 'month');
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, 'month');
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, 'day');
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, 'day');
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }
    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD'
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC'
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs('ms'), asSeconds = makeAs('s'), asMinutes = makeAs('m'), asHours = makeAs('h'), asDays = makeAs('d'), asWeeks = makeAs('w'), asMonths = makeAs('M'), asQuarters = makeAs('Q'), asYears = makeAs('y'), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter('milliseconds'), seconds = makeGetter('seconds'), minutes = makeGetter('minutes'), hours = makeGetter('hours'), days = makeGetter('days'), months = makeGetter('months'), years = makeGetter('years');
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as('s')), minutes = round(duration.as('m')), hours = round(duration.as('h')), days = round(duration.as('d')), months = round(duration.as('M')), weeks = round(duration.as('w')), years = round(duration.as('y')), a = seconds <= thresholds.ss && [
            's',
            seconds
        ] || seconds < thresholds.s && [
            'ss',
            seconds
        ] || minutes <= 1 && [
            'm'
        ] || minutes < thresholds.m && [
            'mm',
            minutes
        ] || hours <= 1 && [
            'h'
        ] || hours < thresholds.h && [
            'hh',
            hours
        ] || days <= 1 && [
            'd'
        ] || days < thresholds.d && [
            'dd',
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            'w'
        ] || weeks < thresholds.w && [
            'ww',
            weeks
        ];
        a = a || months <= 1 && [
            'M'
        ] || months < thresholds.M && [
            'MM',
            months
        ] || years <= 1 && [
            'y'
        ] || [
            'yy',
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === 's') thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') withSuffix = argWithSuffix;
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
        return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');
    // PARSING
    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = '2.30.1';
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
        DATE: 'YYYY-MM-DD',
        TIME: 'HH:mm',
        TIME_SECONDS: 'HH:mm:ss',
        TIME_MS: 'HH:mm:ss.SSS',
        WEEK: 'GGGG-[W]WW',
        MONTH: 'YYYY-MM'
    };
    return hooks;
});

});

parcelRegister("krg3S", function(module, exports) {

$parcel$export(module.exports, "Formik", () => Formik);
$parcel$export(module.exports, "useField", () => useField);
$parcel$export(module.exports, "Form", () => Form);
$parcel$export(module.exports, "ErrorMessage", () => ErrorMessage);

var $jz9i0 = parcelRequire("jz9i0");

var $k6JLi = parcelRequire("k6JLi");

var $e3GSY = parcelRequire("e3GSY");

var $tZqWC = parcelRequire("tZqWC");

var $gtGaO = parcelRequire("gtGaO");

var $gRx9P = parcelRequire("gRx9P");

var $1jWfM = parcelRequire("1jWfM");

var $gEK22 = parcelRequire("gEK22");

var $7g5pF = parcelRequire("7g5pF");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
var FormikContext = /*#__PURE__*/ (0, $tZqWC.createContext)(undefined);
FormikContext.displayName = 'FormikContext';
var FormikProvider = FormikContext.Provider;
var FormikConsumer = FormikContext.Consumer;
function useFormikContext() {
    var formik = (0, $tZqWC.useContext)(FormikContext);
    !!!formik && (0, $gRx9P.default)(false);
    return formik;
}
/** @private is the value an empty array? */ var isEmptyArray = function isEmptyArray(value) {
    return Array.isArray(value) && value.length === 0;
};
/** @private is the given object a Function? */ var isFunction = function isFunction(obj) {
    return typeof obj === 'function';
};
/** @private is the given object an Object? */ var isObject = function isObject(obj) {
    return obj !== null && typeof obj === 'object';
};
/** @private is the given object an integer? */ var isInteger = function isInteger(obj) {
    return String(Math.floor(Number(obj))) === obj;
};
/** @private is the given object a string? */ var isString = function isString(obj) {
    return Object.prototype.toString.call(obj) === '[object String]';
};
/** @private is the given object a NaN? */ // eslint-disable-next-line no-self-compare
var isNaN$1 = function isNaN1(obj) {
    return obj !== obj;
};
/** @private Does a React component have exactly 0 children? */ var isEmptyChildren = function isEmptyChildren(children) {
    return (0, $tZqWC.Children).count(children) === 0;
};
/** @private is the given object/value a promise? */ var isPromise = function isPromise(value) {
    return isObject(value) && isFunction(value.then);
};
/** @private is the given object/value a type of synthetic event? */ var isInputEvent = function isInputEvent(value) {
    return value && isObject(value) && isObject(value.target);
};
/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?Document} doc Defaults to current document.
 * @return {Element | null}
 * @see https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/dom/getActiveElement.js
 */ function getActiveElement(doc) {
    doc = doc || (typeof document !== 'undefined' ? document : undefined);
    if (typeof doc === 'undefined') return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
/**
 * Deeply get a value from an object via its path.
 */ function getIn(obj, key, def, p) {
    if (p === void 0) p = 0;
    var path = (0, $gEK22.default)(key);
    while(obj && p < path.length)obj = obj[path[p++]];
     // check if path is not in the end
    if (p !== path.length && !obj) return def;
    return obj === undefined ? def : obj;
}
/**
 * Deeply set a value from in object via it's path. If the value at `path`
 * has changed, return a shallow copy of obj with `value` set at `path`.
 * If `value` has not changed, return the original `obj`.
 *
 * Existing objects / arrays along `path` are also shallow copied. Sibling
 * objects along path retain the same internal js reference. Since new
 * objects / arrays are only created along `path`, we can test if anything
 * changed in a nested structure by comparing the object's reference in
 * the old and new object, similar to how russian doll cache invalidation
 * works.
 *
 * In earlier versions of this function, which used cloneDeep, there were
 * issues whereby settings a nested value would mutate the parent
 * instead of creating a new object. `clone` avoids that bug making a
 * shallow copy of the objects along the update path
 * so no object is mutated in place.
 *
 * Before changing this function, please read through the following
 * discussions.
 *
 * @see https://github.com/developit/linkstate
 * @see https://github.com/jaredpalmer/formik/pull/123
 */ function setIn(obj, path, value) {
    var res = (0, $1jWfM.default)(obj); // this keeps inheritance when obj is a class
    var resVal = res;
    var i = 0;
    var pathArray = (0, $gEK22.default)(path);
    for(; i < pathArray.length - 1; i++){
        var currentPath = pathArray[i];
        var currentObj = getIn(obj, pathArray.slice(0, i + 1));
        if (currentObj && (isObject(currentObj) || Array.isArray(currentObj))) resVal = resVal[currentPath] = (0, $1jWfM.default)(currentObj);
        else {
            var nextPath = pathArray[i + 1];
            resVal = resVal[currentPath] = isInteger(nextPath) && Number(nextPath) >= 0 ? [] : {};
        }
    } // Return original object if new value is the same as current
    if ((i === 0 ? obj : resVal)[pathArray[i]] === value) return obj;
    if (value === undefined) delete resVal[pathArray[i]];
    else resVal[pathArray[i]] = value;
     // If the path array has a single element, the loop did not run.
    // Deleting on `resVal` had no effect in this scenario, so we delete on the result instead.
    if (i === 0 && value === undefined) delete res[pathArray[i]];
    return res;
}
/**
 * Recursively a set the same value for all keys and arrays nested object, cloning
 * @param object
 * @param value
 * @param visited
 * @param response
 */ function setNestedObjectValues(object, value, visited, response) {
    if (visited === void 0) visited = new WeakMap();
    if (response === void 0) response = {};
    for(var _i = 0, _Object$keys = Object.keys(object); _i < _Object$keys.length; _i++){
        var k = _Object$keys[_i];
        var val = object[k];
        if (isObject(val)) {
            if (!visited.get(val)) {
                visited.set(val, true); // In order to keep array values consistent for both dot path  and
                // bracket syntax, we need to check if this is an array so that
                // this will output  { friends: [true] } and not { friends: { "0": true } }
                response[k] = Array.isArray(val) ? [] : {};
                setNestedObjectValues(val, value, visited, response[k]);
            }
        } else response[k] = value;
    }
    return response;
}
function formikReducer(state, msg) {
    switch(msg.type){
        case 'SET_VALUES':
            return _extends({}, state, {
                values: msg.payload
            });
        case 'SET_TOUCHED':
            return _extends({}, state, {
                touched: msg.payload
            });
        case 'SET_ERRORS':
            if ((0, (/*@__PURE__*/$parcel$interopDefault($gtGaO)))(state.errors, msg.payload)) return state;
            return _extends({}, state, {
                errors: msg.payload
            });
        case 'SET_STATUS':
            return _extends({}, state, {
                status: msg.payload
            });
        case 'SET_ISSUBMITTING':
            return _extends({}, state, {
                isSubmitting: msg.payload
            });
        case 'SET_ISVALIDATING':
            return _extends({}, state, {
                isValidating: msg.payload
            });
        case 'SET_FIELD_VALUE':
            return _extends({}, state, {
                values: setIn(state.values, msg.payload.field, msg.payload.value)
            });
        case 'SET_FIELD_TOUCHED':
            return _extends({}, state, {
                touched: setIn(state.touched, msg.payload.field, msg.payload.value)
            });
        case 'SET_FIELD_ERROR':
            return _extends({}, state, {
                errors: setIn(state.errors, msg.payload.field, msg.payload.value)
            });
        case 'RESET_FORM':
            return _extends({}, state, msg.payload);
        case 'SET_FORMIK_STATE':
            return msg.payload(state);
        case 'SUBMIT_ATTEMPT':
            return _extends({}, state, {
                touched: setNestedObjectValues(state.values, true),
                isSubmitting: true,
                submitCount: state.submitCount + 1
            });
        case 'SUBMIT_FAILURE':
            return _extends({}, state, {
                isSubmitting: false
            });
        case 'SUBMIT_SUCCESS':
            return _extends({}, state, {
                isSubmitting: false
            });
        default:
            return state;
    }
} // Initial empty states // objects
var emptyErrors = {};
var emptyTouched = {};
function useFormik(_ref) {
    var _ref$validateOnChange = _ref.validateOnChange, validateOnChange = _ref$validateOnChange === void 0 ? true : _ref$validateOnChange, _ref$validateOnBlur = _ref.validateOnBlur, validateOnBlur = _ref$validateOnBlur === void 0 ? true : _ref$validateOnBlur, _ref$validateOnMount = _ref.validateOnMount, validateOnMount = _ref$validateOnMount === void 0 ? false : _ref$validateOnMount, isInitialValid = _ref.isInitialValid, _ref$enableReinitiali = _ref.enableReinitialize, enableReinitialize = _ref$enableReinitiali === void 0 ? false : _ref$enableReinitiali, onSubmit = _ref.onSubmit, rest = _objectWithoutPropertiesLoose(_ref, [
        "validateOnChange",
        "validateOnBlur",
        "validateOnMount",
        "isInitialValid",
        "enableReinitialize",
        "onSubmit"
    ]);
    var props = _extends({
        validateOnChange: validateOnChange,
        validateOnBlur: validateOnBlur,
        validateOnMount: validateOnMount,
        onSubmit: onSubmit
    }, rest);
    var initialValues = (0, $tZqWC.useRef)(props.initialValues);
    var initialErrors = (0, $tZqWC.useRef)(props.initialErrors || emptyErrors);
    var initialTouched = (0, $tZqWC.useRef)(props.initialTouched || emptyTouched);
    var initialStatus = (0, $tZqWC.useRef)(props.initialStatus);
    var isMounted = (0, $tZqWC.useRef)(false);
    var fieldRegistry = (0, $tZqWC.useRef)({});
    (0, $tZqWC.useEffect)(function() {
        isMounted.current = true;
        return function() {
            isMounted.current = false;
        };
    }, []);
    var _React$useState = (0, $tZqWC.useState)(0), setIteration = _React$useState[1];
    var stateRef = (0, $tZqWC.useRef)({
        values: (0, $e3GSY.default)(props.initialValues),
        errors: (0, $e3GSY.default)(props.initialErrors) || emptyErrors,
        touched: (0, $e3GSY.default)(props.initialTouched) || emptyTouched,
        status: (0, $e3GSY.default)(props.initialStatus),
        isSubmitting: false,
        isValidating: false,
        submitCount: 0
    });
    var state = stateRef.current;
    var dispatch = (0, $tZqWC.useCallback)(function(action) {
        var prev = stateRef.current;
        stateRef.current = formikReducer(prev, action); // force rerender
        if (prev !== stateRef.current) setIteration(function(x) {
            return x + 1;
        });
    }, []);
    var runValidateHandler = (0, $tZqWC.useCallback)(function(values, field) {
        return new Promise(function(resolve, reject) {
            var maybePromisedErrors = props.validate(values, field);
            if (maybePromisedErrors == null) // use loose null check here on purpose
            resolve(emptyErrors);
            else if (isPromise(maybePromisedErrors)) maybePromisedErrors.then(function(errors) {
                resolve(errors || emptyErrors);
            }, function(actualException) {
                reject(actualException);
            });
            else resolve(maybePromisedErrors);
        });
    }, [
        props.validate
    ]);
    /**
   * Run validation against a Yup schema and optionally run a function if successful
   */ var runValidationSchema = (0, $tZqWC.useCallback)(function(values, field) {
        var validationSchema = props.validationSchema;
        var schema = isFunction(validationSchema) ? validationSchema(field) : validationSchema;
        var promise = field && schema.validateAt ? schema.validateAt(field, values) : validateYupSchema(values, schema);
        return new Promise(function(resolve, reject) {
            promise.then(function() {
                resolve(emptyErrors);
            }, function(err) {
                // Yup will throw a validation error if validation fails. We catch those and
                // resolve them into Formik errors. We can sniff if something is a Yup error
                // by checking error.name.
                // @see https://github.com/jquense/yup#validationerrorerrors-string--arraystring-value-any-path-string
                if (err.name === 'ValidationError') resolve(yupToFormErrors(err));
                else reject(err);
            });
        });
    }, [
        props.validationSchema
    ]);
    var runSingleFieldLevelValidation = (0, $tZqWC.useCallback)(function(field, value) {
        return new Promise(function(resolve) {
            return resolve(fieldRegistry.current[field].validate(value));
        });
    }, []);
    var runFieldLevelValidations = (0, $tZqWC.useCallback)(function(values) {
        var fieldKeysWithValidation = Object.keys(fieldRegistry.current).filter(function(f) {
            return isFunction(fieldRegistry.current[f].validate);
        }); // Construct an array with all of the field validation functions
        var fieldValidations = fieldKeysWithValidation.length > 0 ? fieldKeysWithValidation.map(function(f) {
            return runSingleFieldLevelValidation(f, getIn(values, f));
        }) : [
            Promise.resolve('DO_NOT_DELETE_YOU_WILL_BE_FIRED')
        ]; // use special case ;)
        return Promise.all(fieldValidations).then(function(fieldErrorsList) {
            return fieldErrorsList.reduce(function(prev, curr, index) {
                if (curr === 'DO_NOT_DELETE_YOU_WILL_BE_FIRED') return prev;
                if (curr) prev = setIn(prev, fieldKeysWithValidation[index], curr);
                return prev;
            }, {});
        });
    }, [
        runSingleFieldLevelValidation
    ]); // Run all validations and return the result
    var runAllValidations = (0, $tZqWC.useCallback)(function(values) {
        return Promise.all([
            runFieldLevelValidations(values),
            props.validationSchema ? runValidationSchema(values) : {},
            props.validate ? runValidateHandler(values) : {}
        ]).then(function(_ref2) {
            var fieldErrors = _ref2[0], schemaErrors = _ref2[1], validateErrors = _ref2[2];
            var combinedErrors = (0, $jz9i0.default).all([
                fieldErrors,
                schemaErrors,
                validateErrors
            ], {
                arrayMerge: arrayMerge
            });
            return combinedErrors;
        });
    }, [
        props.validate,
        props.validationSchema,
        runFieldLevelValidations,
        runValidateHandler,
        runValidationSchema
    ]); // Run all validations methods and update state accordingly
    var validateFormWithHighPriority = useEventCallback(function(values) {
        if (values === void 0) values = state.values;
        dispatch({
            type: 'SET_ISVALIDATING',
            payload: true
        });
        return runAllValidations(values).then(function(combinedErrors) {
            if (!!isMounted.current) {
                dispatch({
                    type: 'SET_ISVALIDATING',
                    payload: false
                });
                dispatch({
                    type: 'SET_ERRORS',
                    payload: combinedErrors
                });
            }
            return combinedErrors;
        });
    });
    (0, $tZqWC.useEffect)(function() {
        if (validateOnMount && isMounted.current === true && (0, (/*@__PURE__*/$parcel$interopDefault($gtGaO)))(initialValues.current, props.initialValues)) validateFormWithHighPriority(initialValues.current);
    }, [
        validateOnMount,
        validateFormWithHighPriority
    ]);
    var resetForm = (0, $tZqWC.useCallback)(function(nextState) {
        var values = nextState && nextState.values ? nextState.values : initialValues.current;
        var errors = nextState && nextState.errors ? nextState.errors : initialErrors.current ? initialErrors.current : props.initialErrors || {};
        var touched = nextState && nextState.touched ? nextState.touched : initialTouched.current ? initialTouched.current : props.initialTouched || {};
        var status = nextState && nextState.status ? nextState.status : initialStatus.current ? initialStatus.current : props.initialStatus;
        initialValues.current = values;
        initialErrors.current = errors;
        initialTouched.current = touched;
        initialStatus.current = status;
        var dispatchFn = function dispatchFn() {
            dispatch({
                type: 'RESET_FORM',
                payload: {
                    isSubmitting: !!nextState && !!nextState.isSubmitting,
                    errors: errors,
                    touched: touched,
                    status: status,
                    values: values,
                    isValidating: !!nextState && !!nextState.isValidating,
                    submitCount: !!nextState && !!nextState.submitCount && typeof nextState.submitCount === 'number' ? nextState.submitCount : 0
                }
            });
        };
        if (props.onReset) {
            var maybePromisedOnReset = props.onReset(state.values, imperativeMethods);
            if (isPromise(maybePromisedOnReset)) maybePromisedOnReset.then(dispatchFn);
            else dispatchFn();
        } else dispatchFn();
    }, [
        props.initialErrors,
        props.initialStatus,
        props.initialTouched,
        props.onReset
    ]);
    (0, $tZqWC.useEffect)(function() {
        if (isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($gtGaO)))(initialValues.current, props.initialValues)) {
            if (enableReinitialize) {
                initialValues.current = props.initialValues;
                resetForm();
                if (validateOnMount) validateFormWithHighPriority(initialValues.current);
            }
        }
    }, [
        enableReinitialize,
        props.initialValues,
        resetForm,
        validateOnMount,
        validateFormWithHighPriority
    ]);
    (0, $tZqWC.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($gtGaO)))(initialErrors.current, props.initialErrors)) {
            initialErrors.current = props.initialErrors || emptyErrors;
            dispatch({
                type: 'SET_ERRORS',
                payload: props.initialErrors || emptyErrors
            });
        }
    }, [
        enableReinitialize,
        props.initialErrors
    ]);
    (0, $tZqWC.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($gtGaO)))(initialTouched.current, props.initialTouched)) {
            initialTouched.current = props.initialTouched || emptyTouched;
            dispatch({
                type: 'SET_TOUCHED',
                payload: props.initialTouched || emptyTouched
            });
        }
    }, [
        enableReinitialize,
        props.initialTouched
    ]);
    (0, $tZqWC.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($gtGaO)))(initialStatus.current, props.initialStatus)) {
            initialStatus.current = props.initialStatus;
            dispatch({
                type: 'SET_STATUS',
                payload: props.initialStatus
            });
        }
    }, [
        enableReinitialize,
        props.initialStatus,
        props.initialTouched
    ]);
    var validateField = useEventCallback(function(name) {
        // This will efficiently validate a single field by avoiding state
        // changes if the validation function is synchronous. It's different from
        // what is called when using validateForm.
        if (fieldRegistry.current[name] && isFunction(fieldRegistry.current[name].validate)) {
            var value = getIn(state.values, name);
            var maybePromise = fieldRegistry.current[name].validate(value);
            if (isPromise(maybePromise)) {
                // Only flip isValidating if the function is async.
                dispatch({
                    type: 'SET_ISVALIDATING',
                    payload: true
                });
                return maybePromise.then(function(x) {
                    return x;
                }).then(function(error) {
                    dispatch({
                        type: 'SET_FIELD_ERROR',
                        payload: {
                            field: name,
                            value: error
                        }
                    });
                    dispatch({
                        type: 'SET_ISVALIDATING',
                        payload: false
                    });
                });
            } else {
                dispatch({
                    type: 'SET_FIELD_ERROR',
                    payload: {
                        field: name,
                        value: maybePromise
                    }
                });
                return Promise.resolve(maybePromise);
            }
        } else if (props.validationSchema) {
            dispatch({
                type: 'SET_ISVALIDATING',
                payload: true
            });
            return runValidationSchema(state.values, name).then(function(x) {
                return x;
            }).then(function(error) {
                dispatch({
                    type: 'SET_FIELD_ERROR',
                    payload: {
                        field: name,
                        value: getIn(error, name)
                    }
                });
                dispatch({
                    type: 'SET_ISVALIDATING',
                    payload: false
                });
            });
        }
        return Promise.resolve();
    });
    var registerField = (0, $tZqWC.useCallback)(function(name, _ref3) {
        var validate = _ref3.validate;
        fieldRegistry.current[name] = {
            validate: validate
        };
    }, []);
    var unregisterField = (0, $tZqWC.useCallback)(function(name) {
        delete fieldRegistry.current[name];
    }, []);
    var setTouched = useEventCallback(function(touched, shouldValidate) {
        dispatch({
            type: 'SET_TOUCHED',
            payload: touched
        });
        var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
        return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
    });
    var setErrors = (0, $tZqWC.useCallback)(function(errors) {
        dispatch({
            type: 'SET_ERRORS',
            payload: errors
        });
    }, []);
    var setValues = useEventCallback(function(values, shouldValidate) {
        var resolvedValues = isFunction(values) ? values(state.values) : values;
        dispatch({
            type: 'SET_VALUES',
            payload: resolvedValues
        });
        var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
        return willValidate ? validateFormWithHighPriority(resolvedValues) : Promise.resolve();
    });
    var setFieldError = (0, $tZqWC.useCallback)(function(field, value) {
        dispatch({
            type: 'SET_FIELD_ERROR',
            payload: {
                field: field,
                value: value
            }
        });
    }, []);
    var setFieldValue = useEventCallback(function(field, value, shouldValidate) {
        dispatch({
            type: 'SET_FIELD_VALUE',
            payload: {
                field: field,
                value: value
            }
        });
        var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
        return willValidate ? validateFormWithHighPriority(setIn(state.values, field, value)) : Promise.resolve();
    });
    var executeChange = (0, $tZqWC.useCallback)(function(eventOrTextValue, maybePath) {
        // By default, assume that the first argument is a string. This allows us to use
        // handleChange with React Native and React Native Web's onChangeText prop which
        // provides just the value of the input.
        var field = maybePath;
        var val = eventOrTextValue;
        var parsed; // If the first argument is not a string though, it has to be a synthetic React Event (or a fake one),
        // so we handle like we would a normal HTML change event.
        if (!isString(eventOrTextValue)) {
            // If we can, persist the event
            // @see https://reactjs.org/docs/events.html#event-pooling
            if (eventOrTextValue.persist) eventOrTextValue.persist();
            var target = eventOrTextValue.target ? eventOrTextValue.target : eventOrTextValue.currentTarget;
            var type = target.type, name = target.name, id = target.id, value = target.value, checked = target.checked, outerHTML = target.outerHTML, options = target.options, multiple = target.multiple;
            field = maybePath ? maybePath : name ? name : id;
            field;
            val = /number|range/.test(type) ? (parsed = parseFloat(value), isNaN(parsed) ? '' : parsed) : /checkbox/.test(type) // checkboxes
             ? getValueForCheckbox(getIn(state.values, field), checked, value) : options && multiple // <select multiple>
             ? getSelectedValues(options) : value;
        }
        if (field) // Set form fields by name
        setFieldValue(field, val);
    }, [
        setFieldValue,
        state.values
    ]);
    var handleChange = useEventCallback(function(eventOrPath) {
        if (isString(eventOrPath)) return function(event) {
            return executeChange(event, eventOrPath);
        };
        else executeChange(eventOrPath);
    });
    var setFieldTouched = useEventCallback(function(field, touched, shouldValidate) {
        if (touched === void 0) touched = true;
        dispatch({
            type: 'SET_FIELD_TOUCHED',
            payload: {
                field: field,
                value: touched
            }
        });
        var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
        return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
    });
    var executeBlur = (0, $tZqWC.useCallback)(function(e, path) {
        if (e.persist) e.persist();
        var _e$target = e.target, name = _e$target.name, id = _e$target.id, outerHTML = _e$target.outerHTML;
        var field = path ? path : name ? name : id;
        field;
        setFieldTouched(field, true);
    }, [
        setFieldTouched
    ]);
    var handleBlur = useEventCallback(function(eventOrString) {
        if (isString(eventOrString)) return function(event) {
            return executeBlur(event, eventOrString);
        };
        else executeBlur(eventOrString);
    });
    var setFormikState = (0, $tZqWC.useCallback)(function(stateOrCb) {
        if (isFunction(stateOrCb)) dispatch({
            type: 'SET_FORMIK_STATE',
            payload: stateOrCb
        });
        else dispatch({
            type: 'SET_FORMIK_STATE',
            payload: function payload() {
                return stateOrCb;
            }
        });
    }, []);
    var setStatus = (0, $tZqWC.useCallback)(function(status) {
        dispatch({
            type: 'SET_STATUS',
            payload: status
        });
    }, []);
    var setSubmitting = (0, $tZqWC.useCallback)(function(isSubmitting) {
        dispatch({
            type: 'SET_ISSUBMITTING',
            payload: isSubmitting
        });
    }, []);
    var submitForm = useEventCallback(function() {
        dispatch({
            type: 'SUBMIT_ATTEMPT'
        });
        return validateFormWithHighPriority().then(function(combinedErrors) {
            // In case an error was thrown and passed to the resolved Promise,
            // `combinedErrors` can be an instance of an Error. We need to check
            // that and abort the submit.
            // If we don't do that, calling `Object.keys(new Error())` yields an
            // empty array, which causes the validation to pass and the form
            // to be submitted.
            var isInstanceOfError = combinedErrors instanceof Error;
            var isActuallyValid = !isInstanceOfError && Object.keys(combinedErrors).length === 0;
            if (isActuallyValid) {
                // Proceed with submit...
                //
                // To respect sync submit fns, we can't simply wrap executeSubmit in a promise and
                // _always_ dispatch SUBMIT_SUCCESS because isSubmitting would then always be false.
                // This would be fine in simple cases, but make it impossible to disable submit
                // buttons where people use callbacks or promises as side effects (which is basically
                // all of v1 Formik code). Instead, recall that we are inside of a promise chain already,
                //  so we can try/catch executeSubmit(), if it returns undefined, then just bail.
                // If there are errors, throw em. Otherwise, wrap executeSubmit in a promise and handle
                // cleanup of isSubmitting on behalf of the consumer.
                var promiseOrUndefined;
                try {
                    promiseOrUndefined = executeSubmit(); // Bail if it's sync, consumer is responsible for cleaning up
                    // via setSubmitting(false)
                    if (promiseOrUndefined === undefined) return;
                } catch (error) {
                    throw error;
                }
                return Promise.resolve(promiseOrUndefined).then(function(result) {
                    if (!!isMounted.current) dispatch({
                        type: 'SUBMIT_SUCCESS'
                    });
                    return result;
                })["catch"](function(_errors) {
                    if (!!isMounted.current) {
                        dispatch({
                            type: 'SUBMIT_FAILURE'
                        }); // This is a legit error rejected by the onSubmit fn
                        // so we don't want to break the promise chain
                        throw _errors;
                    }
                });
            } else if (!!isMounted.current) {
                // ^^^ Make sure Formik is still mounted before updating state
                dispatch({
                    type: 'SUBMIT_FAILURE'
                }); // throw combinedErrors;
                if (isInstanceOfError) throw combinedErrors;
            }
            return;
        });
    });
    var handleSubmit = useEventCallback(function(e) {
        if (e && e.preventDefault && isFunction(e.preventDefault)) e.preventDefault();
        if (e && e.stopPropagation && isFunction(e.stopPropagation)) e.stopPropagation();
         // Warn if form submission is triggered by a <button> without a
        var activeElement;
        submitForm()["catch"](function(reason) {
            console.warn("Warning: An unhandled error was caught from submitForm()", reason);
        });
    });
    var imperativeMethods = {
        resetForm: resetForm,
        validateForm: validateFormWithHighPriority,
        validateField: validateField,
        setErrors: setErrors,
        setFieldError: setFieldError,
        setFieldTouched: setFieldTouched,
        setFieldValue: setFieldValue,
        setStatus: setStatus,
        setSubmitting: setSubmitting,
        setTouched: setTouched,
        setValues: setValues,
        setFormikState: setFormikState,
        submitForm: submitForm
    };
    var executeSubmit = useEventCallback(function() {
        return onSubmit(state.values, imperativeMethods);
    });
    var handleReset = useEventCallback(function(e) {
        if (e && e.preventDefault && isFunction(e.preventDefault)) e.preventDefault();
        if (e && e.stopPropagation && isFunction(e.stopPropagation)) e.stopPropagation();
        resetForm();
    });
    var getFieldMeta = (0, $tZqWC.useCallback)(function(name) {
        return {
            value: getIn(state.values, name),
            error: getIn(state.errors, name),
            touched: !!getIn(state.touched, name),
            initialValue: getIn(initialValues.current, name),
            initialTouched: !!getIn(initialTouched.current, name),
            initialError: getIn(initialErrors.current, name)
        };
    }, [
        state.errors,
        state.touched,
        state.values
    ]);
    var getFieldHelpers = (0, $tZqWC.useCallback)(function(name) {
        return {
            setValue: function setValue(value, shouldValidate) {
                return setFieldValue(name, value, shouldValidate);
            },
            setTouched: function setTouched(value, shouldValidate) {
                return setFieldTouched(name, value, shouldValidate);
            },
            setError: function setError(value) {
                return setFieldError(name, value);
            }
        };
    }, [
        setFieldValue,
        setFieldTouched,
        setFieldError
    ]);
    var getFieldProps = (0, $tZqWC.useCallback)(function(nameOrOptions) {
        var isAnObject = isObject(nameOrOptions);
        var name = isAnObject ? nameOrOptions.name : nameOrOptions;
        var valueState = getIn(state.values, name);
        var field = {
            name: name,
            value: valueState,
            onChange: handleChange,
            onBlur: handleBlur
        };
        if (isAnObject) {
            var type = nameOrOptions.type, valueProp = nameOrOptions.value, is = nameOrOptions.as, multiple = nameOrOptions.multiple;
            if (type === 'checkbox') {
                if (valueProp === undefined) field.checked = !!valueState;
                else {
                    field.checked = !!(Array.isArray(valueState) && ~valueState.indexOf(valueProp));
                    field.value = valueProp;
                }
            } else if (type === 'radio') {
                field.checked = valueState === valueProp;
                field.value = valueProp;
            } else if (is === 'select' && multiple) {
                field.value = field.value || [];
                field.multiple = true;
            }
        }
        return field;
    }, [
        handleBlur,
        handleChange,
        state.values
    ]);
    var dirty = (0, $tZqWC.useMemo)(function() {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($gtGaO)))(initialValues.current, state.values);
    }, [
        initialValues.current,
        state.values
    ]);
    var isValid = (0, $tZqWC.useMemo)(function() {
        return typeof isInitialValid !== 'undefined' ? dirty ? state.errors && Object.keys(state.errors).length === 0 : isInitialValid !== false && isFunction(isInitialValid) ? isInitialValid(props) : isInitialValid : state.errors && Object.keys(state.errors).length === 0;
    }, [
        isInitialValid,
        dirty,
        state.errors,
        props
    ]);
    var ctx = _extends({}, state, {
        initialValues: initialValues.current,
        initialErrors: initialErrors.current,
        initialTouched: initialTouched.current,
        initialStatus: initialStatus.current,
        handleBlur: handleBlur,
        handleChange: handleChange,
        handleReset: handleReset,
        handleSubmit: handleSubmit,
        resetForm: resetForm,
        setErrors: setErrors,
        setFormikState: setFormikState,
        setFieldTouched: setFieldTouched,
        setFieldValue: setFieldValue,
        setFieldError: setFieldError,
        setStatus: setStatus,
        setSubmitting: setSubmitting,
        setTouched: setTouched,
        setValues: setValues,
        submitForm: submitForm,
        validateForm: validateFormWithHighPriority,
        validateField: validateField,
        isValid: isValid,
        dirty: dirty,
        unregisterField: unregisterField,
        registerField: registerField,
        getFieldProps: getFieldProps,
        getFieldMeta: getFieldMeta,
        getFieldHelpers: getFieldHelpers,
        validateOnBlur: validateOnBlur,
        validateOnChange: validateOnChange,
        validateOnMount: validateOnMount
    });
    return ctx;
}
function Formik(props) {
    var formikbag = useFormik(props);
    var component = props.component, children = props.children, render = props.render, innerRef = props.innerRef; // This allows folks to pass a ref to <Formik />
    (0, $tZqWC.useImperativeHandle)(innerRef, function() {
        return formikbag;
    });
    return (0, $tZqWC.createElement)(FormikProvider, {
        value: formikbag
    }, component ? (0, $tZqWC.createElement)(component, formikbag) : render ? render(formikbag) : children // children come last, always called
     ? isFunction(children) ? children(formikbag) : !isEmptyChildren(children) ? (0, $tZqWC.Children).only(children) : null : null);
}
function warnAboutMissingIdentifier(_ref4) {
    var htmlContent = _ref4.htmlContent, documentationAnchorLink = _ref4.documentationAnchorLink, handlerName = _ref4.handlerName;
    console.warn("Warning: Formik called `" + handlerName + "`, but you forgot to pass an `id` or `name` attribute to your input:\n    " + htmlContent + "\n    Formik cannot determine which value to update. For more info see https://formik.org/docs/api/formik#" + documentationAnchorLink + "\n  ");
}
/**
 * Transform Yup ValidationError to a more usable object
 */ function yupToFormErrors(yupError) {
    var errors = {};
    if (yupError.inner) {
        if (yupError.inner.length === 0) return setIn(errors, yupError.path, yupError.message);
        for(var _iterator = yupError.inner, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
            var _ref5;
            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref5 = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref5 = _i.value;
            }
            var err = _ref5;
            if (!getIn(errors, err.path)) errors = setIn(errors, err.path, err.message);
        }
    }
    return errors;
}
/**
 * Validate a yup schema.
 */ function validateYupSchema(values, schema, sync, context) {
    if (sync === void 0) sync = false;
    var normalizedValues = prepareDataForValidation(values);
    return schema[sync ? 'validateSync' : 'validate'](normalizedValues, {
        abortEarly: false,
        context: context || normalizedValues
    });
}
/**
 * Recursively prepare values.
 */ function prepareDataForValidation(values) {
    var data = Array.isArray(values) ? [] : {};
    for(var k in values)if (Object.prototype.hasOwnProperty.call(values, k)) {
        var key = String(k);
        if (Array.isArray(values[key]) === true) data[key] = values[key].map(function(value) {
            if (Array.isArray(value) === true || (0, $k6JLi.default)(value)) return prepareDataForValidation(value);
            else return value !== '' ? value : undefined;
        });
        else if ((0, $k6JLi.default)(values[key])) data[key] = prepareDataForValidation(values[key]);
        else data[key] = values[key] !== '' ? values[key] : undefined;
    }
    return data;
}
/**
 * deepmerge array merging algorithm
 * https://github.com/KyleAMathews/deepmerge#combine-array
 */ function arrayMerge(target, source, options) {
    var destination = target.slice();
    source.forEach(function merge(e, i) {
        if (typeof destination[i] === 'undefined') {
            var cloneRequested = options.clone !== false;
            var shouldClone = cloneRequested && options.isMergeableObject(e);
            destination[i] = shouldClone ? (0, $jz9i0.default)(Array.isArray(e) ? [] : {}, e, options) : e;
        } else if (options.isMergeableObject(e)) destination[i] = (0, $jz9i0.default)(target[i], e, options);
        else if (target.indexOf(e) === -1) destination.push(e);
    });
    return destination;
}
/** Return multi select values based on an array of options */ function getSelectedValues(options) {
    return Array.from(options).filter(function(el) {
        return el.selected;
    }).map(function(el) {
        return el.value;
    });
}
/** Return the next value for a checkbox */ function getValueForCheckbox(currentValue, checked, valueProp) {
    // If the current value was a boolean, return a boolean
    if (typeof currentValue === 'boolean') return Boolean(checked);
     // If the currentValue was not a boolean we want to return an array
    var currentArrayOfValues = [];
    var isValueInArray = false;
    var index = -1;
    if (!Array.isArray(currentValue)) {
        // eslint-disable-next-line eqeqeq
        if (!valueProp || valueProp == 'true' || valueProp == 'false') return Boolean(checked);
    } else {
        // If the current value is already an array, use it
        currentArrayOfValues = currentValue;
        index = currentValue.indexOf(valueProp);
        isValueInArray = index >= 0;
    } // If the checkbox was checked and the value is not already present in the aray we want to add the new value to the array of values
    if (checked && valueProp && !isValueInArray) return currentArrayOfValues.concat(valueProp);
     // If the checkbox was unchecked and the value is not in the array, simply return the already existing array of values
    if (!isValueInArray) return currentArrayOfValues;
     // If the checkbox was unchecked and the value is in the array, remove the value and return the array
    return currentArrayOfValues.slice(0, index).concat(currentArrayOfValues.slice(index + 1));
} // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
// @see https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? (0, $tZqWC.useLayoutEffect) : (0, $tZqWC.useEffect);
function useEventCallback(fn) {
    var ref = (0, $tZqWC.useRef)(fn); // we copy a ref to the callback scoped to the current state/props on each render
    useIsomorphicLayoutEffect(function() {
        ref.current = fn;
    });
    return (0, $tZqWC.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current.apply(void 0, args);
    }, []);
}
function useField(propsOrFieldName) {
    var formik = useFormikContext();
    var getFieldProps = formik.getFieldProps, getFieldMeta = formik.getFieldMeta, getFieldHelpers = formik.getFieldHelpers, registerField = formik.registerField, unregisterField = formik.unregisterField;
    var isAnObject = isObject(propsOrFieldName); // Normalize propsOrFieldName to FieldHookConfig<Val>
    var props = isAnObject ? propsOrFieldName : {
        name: propsOrFieldName
    };
    var fieldName = props.name, validateFn = props.validate;
    (0, $tZqWC.useEffect)(function() {
        if (fieldName) registerField(fieldName, {
            validate: validateFn
        });
        return function() {
            if (fieldName) unregisterField(fieldName);
        };
    }, [
        registerField,
        unregisterField,
        fieldName,
        validateFn
    ]);
    !fieldName && (0, $gRx9P.default)(false);
    var fieldHelpers = (0, $tZqWC.useMemo)(function() {
        return getFieldHelpers(fieldName);
    }, [
        getFieldHelpers,
        fieldName
    ]);
    return [
        getFieldProps(props),
        getFieldMeta(fieldName),
        fieldHelpers
    ];
}
function Field(_ref) {
    var validate = _ref.validate, name = _ref.name, render = _ref.render, children = _ref.children, is = _ref.as, component = _ref.component, className = _ref.className, props = _objectWithoutPropertiesLoose(_ref, [
        "validate",
        "name",
        "render",
        "children",
        "as",
        "component",
        "className"
    ]);
    var _useFormikContext = useFormikContext(), formik = _objectWithoutPropertiesLoose(_useFormikContext, [
        "validate",
        "validationSchema"
    ]);
    var registerField = formik.registerField, unregisterField = formik.unregisterField;
    (0, $tZqWC.useEffect)(function() {
        registerField(name, {
            validate: validate
        });
        return function() {
            unregisterField(name);
        };
    }, [
        registerField,
        unregisterField,
        name,
        validate
    ]);
    var field = formik.getFieldProps(_extends({
        name: name
    }, props));
    var meta = formik.getFieldMeta(name);
    var legacyBag = {
        field: field,
        form: formik
    };
    if (render) return render(_extends({}, legacyBag, {
        meta: meta
    }));
    if (isFunction(children)) return children(_extends({}, legacyBag, {
        meta: meta
    }));
    if (component) {
        // This behavior is backwards compat with earlier Formik 0.9 to 1.x
        if (typeof component === 'string') {
            var innerRef = props.innerRef, rest = _objectWithoutPropertiesLoose(props, [
                "innerRef"
            ]);
            return (0, $tZqWC.createElement)(component, _extends({
                ref: innerRef
            }, field, rest, {
                className: className
            }), children);
        } // We don't pass `meta` for backwards compat
        return (0, $tZqWC.createElement)(component, _extends({
            field: field,
            form: formik
        }, props, {
            className: className
        }), children);
    } // default to input here so we can check for both `as` and `children` above
    var asElement = is || 'input';
    if (typeof asElement === 'string') {
        var _innerRef = props.innerRef, _rest = _objectWithoutPropertiesLoose(props, [
            "innerRef"
        ]);
        return (0, $tZqWC.createElement)(asElement, _extends({
            ref: _innerRef
        }, field, _rest, {
            className: className
        }), children);
    }
    return (0, $tZqWC.createElement)(asElement, _extends({}, field, props, {
        className: className
    }), children);
}
var Form = /*#__PURE__*/ (0, $tZqWC.forwardRef)(function(props, ref) {
    // iOS needs an "action" attribute for nice input: https://stackoverflow.com/a/39485162/406725
    // We default the action to "#" in case the preventDefault fails (just updates the URL hash)
    var action = props.action, rest = _objectWithoutPropertiesLoose(props, [
        "action"
    ]);
    var _action = action != null ? action : '#';
    var _useFormikContext = useFormikContext(), handleReset = _useFormikContext.handleReset, handleSubmit = _useFormikContext.handleSubmit;
    return (0, $tZqWC.createElement)("form", _extends({
        onSubmit: handleSubmit,
        ref: ref,
        onReset: handleReset,
        action: _action
    }, rest));
});
Form.displayName = 'Form';
/**
 * A public higher-order component to access the imperative API
 */ function withFormik(_ref) {
    var _ref$mapPropsToValues = _ref.mapPropsToValues, mapPropsToValues = _ref$mapPropsToValues === void 0 ? function(vanillaProps) {
        var val = {};
        for(var k in vanillaProps)if (vanillaProps.hasOwnProperty(k) && typeof vanillaProps[k] !== 'function') // @todo TypeScript fix
        val[k] = vanillaProps[k];
        return val;
    } : _ref$mapPropsToValues, config = _objectWithoutPropertiesLoose(_ref, [
        "mapPropsToValues"
    ]);
    return function createFormik(Component$1) {
        var componentDisplayName = Component$1.displayName || Component$1.name || Component$1.constructor && Component$1.constructor.name || 'Component';
        /**
     * We need to use closures here for to provide the wrapped component's props to
     * the respective withFormik config methods.
     */ var C = /*#__PURE__*/ function(_React$Component) {
            _inheritsLoose(C, _React$Component);
            function C() {
                var _this;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                _this = _React$Component.call.apply(_React$Component, [
                    this
                ].concat(args)) || this;
                _this.validate = function(values) {
                    return config.validate(values, _this.props);
                };
                _this.validationSchema = function() {
                    return isFunction(config.validationSchema) ? config.validationSchema(_this.props) : config.validationSchema;
                };
                _this.handleSubmit = function(values, actions) {
                    return config.handleSubmit(values, _extends({}, actions, {
                        props: _this.props
                    }));
                };
                _this.renderFormComponent = function(formikProps) {
                    return (0, $tZqWC.createElement)(Component$1, _extends({}, _this.props, formikProps));
                };
                return _this;
            }
            var _proto = C.prototype;
            _proto.render = function render() {
                var _this$props = this.props, props = _objectWithoutPropertiesLoose(_this$props, [
                    "children"
                ]);
                return (0, $tZqWC.createElement)(Formik, _extends({}, props, config, {
                    validate: config.validate && this.validate,
                    validationSchema: config.validationSchema && this.validationSchema,
                    initialValues: mapPropsToValues(this.props),
                    initialStatus: config.mapPropsToStatus && config.mapPropsToStatus(this.props),
                    initialErrors: config.mapPropsToErrors && config.mapPropsToErrors(this.props),
                    initialTouched: config.mapPropsToTouched && config.mapPropsToTouched(this.props),
                    onSubmit: this.handleSubmit,
                    children: this.renderFormComponent
                }));
            };
            return C;
        }((0, $tZqWC.Component));
        C.displayName = "WithFormik(" + componentDisplayName + ")";
        return (0, (/*@__PURE__*/$parcel$interopDefault($7g5pF)))(C, Component$1 // cast type to ComponentClass (even if SFC)
        );
    };
}
/**
 * Connect any component to Formik context, and inject as a prop called `formik`;
 * @param Comp React Component
 */ function connect(Comp) {
    var C = function C(props) {
        return (0, $tZqWC.createElement)(FormikConsumer, null, function(formik) {
            !!!formik && (0, $gRx9P.default)(false);
            return (0, $tZqWC.createElement)(Comp, _extends({}, props, {
                formik: formik
            }));
        });
    };
    var componentDisplayName = Comp.displayName || Comp.name || Comp.constructor && Comp.constructor.name || 'Component'; // Assign Comp to C.WrappedComponent so we can access the inner component in tests
    // For example, <Field.WrappedComponent /> gets us <FieldInner/>
    C.WrappedComponent = Comp;
    C.displayName = "FormikConnect(" + componentDisplayName + ")";
    return (0, (/*@__PURE__*/$parcel$interopDefault($7g5pF)))(C, Comp // cast type to ComponentClass (even if SFC)
    );
}
/**
 * Some array helpers!
 */ var move = function move(array, from, to) {
    var copy = copyArrayLike(array);
    var value = copy[from];
    copy.splice(from, 1);
    copy.splice(to, 0, value);
    return copy;
};
var swap = function swap(arrayLike, indexA, indexB) {
    var copy = copyArrayLike(arrayLike);
    var a = copy[indexA];
    copy[indexA] = copy[indexB];
    copy[indexB] = a;
    return copy;
};
var insert = function insert(arrayLike, index, value) {
    var copy = copyArrayLike(arrayLike);
    copy.splice(index, 0, value);
    return copy;
};
var replace = function replace(arrayLike, index, value) {
    var copy = copyArrayLike(arrayLike);
    copy[index] = value;
    return copy;
};
var copyArrayLike = function copyArrayLike(arrayLike) {
    if (!arrayLike) return [];
    else if (Array.isArray(arrayLike)) return [].concat(arrayLike);
    else {
        var maxIndex = Object.keys(arrayLike).map(function(key) {
            return parseInt(key);
        }).reduce(function(max, el) {
            return el > max ? el : max;
        }, 0);
        return Array.from(_extends({}, arrayLike, {
            length: maxIndex + 1
        }));
    }
};
var createAlterationHandler = function createAlterationHandler(alteration, defaultFunction) {
    var fn = typeof alteration === 'function' ? alteration : defaultFunction;
    return function(data) {
        if (Array.isArray(data) || isObject(data)) {
            var clone = copyArrayLike(data);
            return fn(clone);
        } // This can be assumed to be a primitive, which
        // is a case for top level validation errors
        return data;
    };
};
var FieldArrayInner = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(FieldArrayInner, _React$Component);
    function FieldArrayInner(props) {
        var _this;
        _this = _React$Component.call(this, props) || this; // We need TypeScript generics on these, so we'll bind them in the constructor
        // @todo Fix TS 3.2.1
        _this.updateArrayField = function(fn, alterTouched, alterErrors) {
            var _this$props = _this.props, name = _this$props.name, setFormikState = _this$props.formik.setFormikState;
            setFormikState(function(prevState) {
                var updateErrors = createAlterationHandler(alterErrors, fn);
                var updateTouched = createAlterationHandler(alterTouched, fn); // values fn should be executed before updateErrors and updateTouched,
                // otherwise it causes an error with unshift.
                var values = setIn(prevState.values, name, fn(getIn(prevState.values, name)));
                var fieldError = alterErrors ? updateErrors(getIn(prevState.errors, name)) : undefined;
                var fieldTouched = alterTouched ? updateTouched(getIn(prevState.touched, name)) : undefined;
                if (isEmptyArray(fieldError)) fieldError = undefined;
                if (isEmptyArray(fieldTouched)) fieldTouched = undefined;
                return _extends({}, prevState, {
                    values: values,
                    errors: alterErrors ? setIn(prevState.errors, name, fieldError) : prevState.errors,
                    touched: alterTouched ? setIn(prevState.touched, name, fieldTouched) : prevState.touched
                });
            });
        };
        _this.push = function(value) {
            return _this.updateArrayField(function(arrayLike) {
                return [].concat(copyArrayLike(arrayLike), [
                    (0, $e3GSY.default)(value)
                ]);
            }, false, false);
        };
        _this.handlePush = function(value) {
            return function() {
                return _this.push(value);
            };
        };
        _this.swap = function(indexA, indexB) {
            return _this.updateArrayField(function(array) {
                return swap(array, indexA, indexB);
            }, true, true);
        };
        _this.handleSwap = function(indexA, indexB) {
            return function() {
                return _this.swap(indexA, indexB);
            };
        };
        _this.move = function(from, to) {
            return _this.updateArrayField(function(array) {
                return move(array, from, to);
            }, true, true);
        };
        _this.handleMove = function(from, to) {
            return function() {
                return _this.move(from, to);
            };
        };
        _this.insert = function(index, value) {
            return _this.updateArrayField(function(array) {
                return insert(array, index, value);
            }, function(array) {
                return insert(array, index, null);
            }, function(array) {
                return insert(array, index, null);
            });
        };
        _this.handleInsert = function(index, value) {
            return function() {
                return _this.insert(index, value);
            };
        };
        _this.replace = function(index, value) {
            return _this.updateArrayField(function(array) {
                return replace(array, index, value);
            }, false, false);
        };
        _this.handleReplace = function(index, value) {
            return function() {
                return _this.replace(index, value);
            };
        };
        _this.unshift = function(value) {
            var length = -1;
            _this.updateArrayField(function(array) {
                var arr = array ? [
                    value
                ].concat(array) : [
                    value
                ];
                length = arr.length;
                return arr;
            }, function(array) {
                return array ? [
                    null
                ].concat(array) : [
                    null
                ];
            }, function(array) {
                return array ? [
                    null
                ].concat(array) : [
                    null
                ];
            });
            return length;
        };
        _this.handleUnshift = function(value) {
            return function() {
                return _this.unshift(value);
            };
        };
        _this.handleRemove = function(index) {
            return function() {
                return _this.remove(index);
            };
        };
        _this.handlePop = function() {
            return function() {
                return _this.pop();
            };
        };
        _this.remove = _this.remove.bind(_assertThisInitialized(_this));
        _this.pop = _this.pop.bind(_assertThisInitialized(_this));
        return _this;
    }
    var _proto = FieldArrayInner.prototype;
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.validateOnChange && this.props.formik.validateOnChange && !(0, (/*@__PURE__*/$parcel$interopDefault($gtGaO)))(getIn(prevProps.formik.values, prevProps.name), getIn(this.props.formik.values, this.props.name))) this.props.formik.validateForm(this.props.formik.values);
    };
    _proto.remove = function remove(index) {
        // We need to make sure we also remove relevant pieces of `touched` and `errors`
        var result;
        this.updateArrayField(function(array) {
            var copy = array ? copyArrayLike(array) : [];
            if (!result) result = copy[index];
            if (isFunction(copy.splice)) copy.splice(index, 1);
             // if the array only includes undefined values we have to return an empty array
            return isFunction(copy.every) ? copy.every(function(v) {
                return v === undefined;
            }) ? [] : copy : copy;
        }, true, true);
        return result;
    };
    _proto.pop = function pop() {
        // Remove relevant pieces of `touched` and `errors` too!
        var result;
        this.updateArrayField(function(array) {
            var tmp = array.slice();
            if (!result) result = tmp && tmp.pop && tmp.pop();
            return tmp;
        }, true, true);
        return result;
    };
    _proto.render = function render() {
        var arrayHelpers = {
            push: this.push,
            pop: this.pop,
            swap: this.swap,
            move: this.move,
            insert: this.insert,
            replace: this.replace,
            unshift: this.unshift,
            remove: this.remove,
            handlePush: this.handlePush,
            handlePop: this.handlePop,
            handleSwap: this.handleSwap,
            handleMove: this.handleMove,
            handleInsert: this.handleInsert,
            handleReplace: this.handleReplace,
            handleUnshift: this.handleUnshift,
            handleRemove: this.handleRemove
        };
        var _this$props2 = this.props, component = _this$props2.component, render = _this$props2.render, children = _this$props2.children, name = _this$props2.name, _this$props2$formik = _this$props2.formik, restOfFormik = _objectWithoutPropertiesLoose(_this$props2$formik, [
            "validate",
            "validationSchema"
        ]);
        var props = _extends({}, arrayHelpers, {
            form: restOfFormik,
            name: name
        });
        return component ? (0, $tZqWC.createElement)(component, props) : render ? render(props) : children // children come last, always called
         ? typeof children === 'function' ? children(props) : !isEmptyChildren(children) ? (0, $tZqWC.Children).only(children) : null : null;
    };
    return FieldArrayInner;
}((0, $tZqWC.Component));
FieldArrayInner.defaultProps = {
    validateOnChange: true
};
var FieldArray = /*#__PURE__*/ connect(FieldArrayInner);
var ErrorMessageImpl = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(ErrorMessageImpl, _React$Component);
    function ErrorMessageImpl() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = ErrorMessageImpl.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
        if (getIn(this.props.formik.errors, this.props.name) !== getIn(props.formik.errors, this.props.name) || getIn(this.props.formik.touched, this.props.name) !== getIn(props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length) return true;
        else return false;
    };
    _proto.render = function render() {
        var _this$props = this.props, component = _this$props.component, formik = _this$props.formik, render = _this$props.render, children = _this$props.children, name = _this$props.name, rest = _objectWithoutPropertiesLoose(_this$props, [
            "component",
            "formik",
            "render",
            "children",
            "name"
        ]);
        var touch = getIn(formik.touched, name);
        var error = getIn(formik.errors, name);
        return !!touch && !!error ? render ? isFunction(render) ? render(error) : null : children ? isFunction(children) ? children(error) : null : component ? (0, $tZqWC.createElement)(component, rest, error) : error : null;
    };
    return ErrorMessageImpl;
}((0, $tZqWC.Component));
var ErrorMessage = /*#__PURE__*/ connect(ErrorMessageImpl);
/**
 * Custom Field component for quickly hooking into Formik
 * context and wiring up forms.
 */ var FastFieldInner = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(FastFieldInner, _React$Component);
    function FastFieldInner(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        var render = props.render, children = props.children, component = props.component, is = props.as, name = props.name;
        !!render && (0, $gRx9P.default)(false);
        !!(component && render) && (0, $gRx9P.default)(false);
        !!(is && children && isFunction(children)) && (0, $gRx9P.default)(false);
        !!(component && children && isFunction(children)) && (0, $gRx9P.default)(false);
        !!(render && children && !isEmptyChildren(children)) && (0, $gRx9P.default)(false);
        return _this;
    }
    var _proto = FastFieldInner.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
        if (this.props.shouldUpdate) return this.props.shouldUpdate(props, this.props);
        else if (props.name !== this.props.name || getIn(props.formik.values, this.props.name) !== getIn(this.props.formik.values, this.props.name) || getIn(props.formik.errors, this.props.name) !== getIn(this.props.formik.errors, this.props.name) || getIn(props.formik.touched, this.props.name) !== getIn(this.props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length || props.formik.isSubmitting !== this.props.formik.isSubmitting) return true;
        else return false;
    };
    _proto.componentDidMount = function componentDidMount() {
        // Register the Field with the parent Formik. Parent will cycle through
        // registered Field's validate fns right prior to submit
        this.props.formik.registerField(this.props.name, {
            validate: this.props.validate
        });
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.name !== prevProps.name) {
            this.props.formik.unregisterField(prevProps.name);
            this.props.formik.registerField(this.props.name, {
                validate: this.props.validate
            });
        }
        if (this.props.validate !== prevProps.validate) this.props.formik.registerField(this.props.name, {
            validate: this.props.validate
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.props.formik.unregisterField(this.props.name);
    };
    _proto.render = function render() {
        var _this$props = this.props, name = _this$props.name, render = _this$props.render, is = _this$props.as, children = _this$props.children, component = _this$props.component, formik = _this$props.formik, props = _objectWithoutPropertiesLoose(_this$props, [
            "validate",
            "name",
            "render",
            "as",
            "children",
            "component",
            "shouldUpdate",
            "formik"
        ]);
        var restOfFormik = _objectWithoutPropertiesLoose(formik, [
            "validate",
            "validationSchema"
        ]);
        var field = formik.getFieldProps(_extends({
            name: name
        }, props));
        var meta = {
            value: getIn(formik.values, name),
            error: getIn(formik.errors, name),
            touched: !!getIn(formik.touched, name),
            initialValue: getIn(formik.initialValues, name),
            initialTouched: !!getIn(formik.initialTouched, name),
            initialError: getIn(formik.initialErrors, name)
        };
        var bag = {
            field: field,
            meta: meta,
            form: restOfFormik
        };
        if (render) return render(bag);
        if (isFunction(children)) return children(bag);
        if (component) {
            // This behavior is backwards compat with earlier Formik 0.9 to 1.x
            if (typeof component === 'string') {
                var innerRef = props.innerRef, rest = _objectWithoutPropertiesLoose(props, [
                    "innerRef"
                ]);
                return (0, $tZqWC.createElement)(component, _extends({
                    ref: innerRef
                }, field, rest), children);
            } // We don't pass `meta` for backwards compat
            return (0, $tZqWC.createElement)(component, _extends({
                field: field,
                form: formik
            }, props), children);
        } // default to input here so we can check for both `as` and `children` above
        var asElement = is || 'input';
        if (typeof asElement === 'string') {
            var _innerRef = props.innerRef, _rest = _objectWithoutPropertiesLoose(props, [
                "innerRef"
            ]);
            return (0, $tZqWC.createElement)(asElement, _extends({
                ref: _innerRef
            }, field, _rest), children);
        }
        return (0, $tZqWC.createElement)(asElement, _extends({}, field, props), children);
    };
    return FastFieldInner;
}((0, $tZqWC.Component));
var FastField = /*#__PURE__*/ connect(FastFieldInner);

});
parcelRegister("jz9i0", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3e87dde0214ec6c$export$2e2bcd8739ae039);
var $e3e87dde0214ec6c$var$isMergeableObject = function isMergeableObject(value) {
    return $e3e87dde0214ec6c$var$isNonNullObject(value) && !$e3e87dde0214ec6c$var$isSpecial(value);
};
function $e3e87dde0214ec6c$var$isNonNullObject(value) {
    return !!value && typeof value === 'object';
}
function $e3e87dde0214ec6c$var$isSpecial(value) {
    var stringValue = Object.prototype.toString.call(value);
    return stringValue === '[object RegExp]' || stringValue === '[object Date]' || $e3e87dde0214ec6c$var$isReactElement(value);
}
// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var $e3e87dde0214ec6c$var$canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var $e3e87dde0214ec6c$var$REACT_ELEMENT_TYPE = $e3e87dde0214ec6c$var$canUseSymbol ? Symbol.for('react.element') : 0xeac7;
function $e3e87dde0214ec6c$var$isReactElement(value) {
    return value.$$typeof === $e3e87dde0214ec6c$var$REACT_ELEMENT_TYPE;
}
function $e3e87dde0214ec6c$var$emptyTarget(val) {
    return Array.isArray(val) ? [] : {};
}
function $e3e87dde0214ec6c$var$cloneUnlessOtherwiseSpecified(value, options) {
    return options.clone !== false && options.isMergeableObject(value) ? $e3e87dde0214ec6c$var$deepmerge($e3e87dde0214ec6c$var$emptyTarget(value), value, options) : value;
}
function $e3e87dde0214ec6c$var$defaultArrayMerge(target, source, options) {
    return target.concat(source).map(function(element) {
        return $e3e87dde0214ec6c$var$cloneUnlessOtherwiseSpecified(element, options);
    });
}
function $e3e87dde0214ec6c$var$mergeObject(target, source, options) {
    var destination = {};
    if (options.isMergeableObject(target)) Object.keys(target).forEach(function(key) {
        destination[key] = $e3e87dde0214ec6c$var$cloneUnlessOtherwiseSpecified(target[key], options);
    });
    Object.keys(source).forEach(function(key) {
        if (!options.isMergeableObject(source[key]) || !target[key]) destination[key] = $e3e87dde0214ec6c$var$cloneUnlessOtherwiseSpecified(source[key], options);
        else destination[key] = $e3e87dde0214ec6c$var$deepmerge(target[key], source[key], options);
    });
    return destination;
}
function $e3e87dde0214ec6c$var$deepmerge(target, source, options) {
    options = options || {};
    options.arrayMerge = options.arrayMerge || $e3e87dde0214ec6c$var$defaultArrayMerge;
    options.isMergeableObject = options.isMergeableObject || $e3e87dde0214ec6c$var$isMergeableObject;
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
    if (!sourceAndTargetTypesMatch) return $e3e87dde0214ec6c$var$cloneUnlessOtherwiseSpecified(source, options);
    else if (sourceIsArray) return options.arrayMerge(target, source, options);
    else return $e3e87dde0214ec6c$var$mergeObject(target, source, options);
}
$e3e87dde0214ec6c$var$deepmerge.all = function deepmergeAll(array, options) {
    if (!Array.isArray(array)) throw new Error('first argument should be an array');
    return array.reduce(function(prev, next) {
        return $e3e87dde0214ec6c$var$deepmerge(prev, next, options);
    }, {});
};
var $e3e87dde0214ec6c$var$deepmerge_1 = $e3e87dde0214ec6c$var$deepmerge;
var $e3e87dde0214ec6c$export$2e2bcd8739ae039 = $e3e87dde0214ec6c$var$deepmerge_1;

});

parcelRegister("k6JLi", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea37dd85c0ab7fe5$export$2e2bcd8739ae039);

var $8X3vt = parcelRequire("8X3vt");

var $dkTWv = parcelRequire("dkTWv");

var $da1Ti = parcelRequire("da1Ti");
/** `Object#toString` result references. */ var $ea37dd85c0ab7fe5$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $ea37dd85c0ab7fe5$var$funcProto = Function.prototype, $ea37dd85c0ab7fe5$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $ea37dd85c0ab7fe5$var$funcToString = $ea37dd85c0ab7fe5$var$funcProto.toString;
/** Used to check objects for own properties. */ var $ea37dd85c0ab7fe5$var$hasOwnProperty = $ea37dd85c0ab7fe5$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $ea37dd85c0ab7fe5$var$objectCtorString = $ea37dd85c0ab7fe5$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $ea37dd85c0ab7fe5$var$isPlainObject(value) {
    if (!(0, $da1Ti.default)(value) || (0, $8X3vt.default)(value) != $ea37dd85c0ab7fe5$var$objectTag) return false;
    var proto = (0, $dkTWv.default)(value);
    if (proto === null) return true;
    var Ctor = $ea37dd85c0ab7fe5$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $ea37dd85c0ab7fe5$var$funcToString.call(Ctor) == $ea37dd85c0ab7fe5$var$objectCtorString;
}
var $ea37dd85c0ab7fe5$export$2e2bcd8739ae039 = $ea37dd85c0ab7fe5$var$isPlainObject;

});
parcelRegister("8X3vt", function(module, exports) {

$parcel$export(module.exports, "default", () => $68468dc8d9512fd3$export$2e2bcd8739ae039);

var $aYS7m = parcelRequire("aYS7m");

var $gmfoF = parcelRequire("gmfoF");

var $cok5v = parcelRequire("cok5v");
/** `Object#toString` result references. */ var $68468dc8d9512fd3$var$nullTag = '[object Null]', $68468dc8d9512fd3$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $68468dc8d9512fd3$var$symToStringTag = (0, $aYS7m.default) ? (0, $aYS7m.default).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $68468dc8d9512fd3$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $68468dc8d9512fd3$var$undefinedTag : $68468dc8d9512fd3$var$nullTag;
    return $68468dc8d9512fd3$var$symToStringTag && $68468dc8d9512fd3$var$symToStringTag in Object(value) ? (0, $gmfoF.default)(value) : (0, $cok5v.default)(value);
}
var $68468dc8d9512fd3$export$2e2bcd8739ae039 = $68468dc8d9512fd3$var$baseGetTag;

});
parcelRegister("aYS7m", function(module, exports) {

$parcel$export(module.exports, "default", () => $0210272bf8e1daa8$export$2e2bcd8739ae039);

var $fRXcK = parcelRequire("fRXcK");
/** Built-in value references. */ var $0210272bf8e1daa8$var$Symbol = (0, $fRXcK.default).Symbol;
var $0210272bf8e1daa8$export$2e2bcd8739ae039 = $0210272bf8e1daa8$var$Symbol;

});
parcelRegister("fRXcK", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8d9bb12be31d9ad$export$2e2bcd8739ae039);

var $1kslA = parcelRequire("1kslA");
/** Detect free variable `self`. */ var $b8d9bb12be31d9ad$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $b8d9bb12be31d9ad$var$root = (0, $1kslA.default) || $b8d9bb12be31d9ad$var$freeSelf || Function('return this')();
var $b8d9bb12be31d9ad$export$2e2bcd8739ae039 = $b8d9bb12be31d9ad$var$root;

});
parcelRegister("1kslA", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f7da5e1cb69594e$export$2e2bcd8739ae039);
/** Detect free variable `global` from Node.js. */ var $0f7da5e1cb69594e$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $0f7da5e1cb69594e$export$2e2bcd8739ae039 = $0f7da5e1cb69594e$var$freeGlobal;

});



parcelRegister("gmfoF", function(module, exports) {

$parcel$export(module.exports, "default", () => $be8aa4ebf35d483b$export$2e2bcd8739ae039);

var $aYS7m = parcelRequire("aYS7m");
/** Used for built-in method references. */ var $be8aa4ebf35d483b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $be8aa4ebf35d483b$var$hasOwnProperty = $be8aa4ebf35d483b$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $be8aa4ebf35d483b$var$nativeObjectToString = $be8aa4ebf35d483b$var$objectProto.toString;
/** Built-in value references. */ var $be8aa4ebf35d483b$var$symToStringTag = (0, $aYS7m.default) ? (0, $aYS7m.default).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $be8aa4ebf35d483b$var$getRawTag(value) {
    var isOwn = $be8aa4ebf35d483b$var$hasOwnProperty.call(value, $be8aa4ebf35d483b$var$symToStringTag), tag = value[$be8aa4ebf35d483b$var$symToStringTag];
    try {
        value[$be8aa4ebf35d483b$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $be8aa4ebf35d483b$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$be8aa4ebf35d483b$var$symToStringTag] = tag;
        else delete value[$be8aa4ebf35d483b$var$symToStringTag];
    }
    return result;
}
var $be8aa4ebf35d483b$export$2e2bcd8739ae039 = $be8aa4ebf35d483b$var$getRawTag;

});

parcelRegister("cok5v", function(module, exports) {

$parcel$export(module.exports, "default", () => $90574ef76cd32410$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $90574ef76cd32410$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $90574ef76cd32410$var$nativeObjectToString = $90574ef76cd32410$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $90574ef76cd32410$var$objectToString(value) {
    return $90574ef76cd32410$var$nativeObjectToString.call(value);
}
var $90574ef76cd32410$export$2e2bcd8739ae039 = $90574ef76cd32410$var$objectToString;

});


parcelRegister("dkTWv", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b5889a70ae02920$export$2e2bcd8739ae039);

var $kX7Ds = parcelRequire("kX7Ds");
/** Built-in value references. */ var $9b5889a70ae02920$var$getPrototype = (0, $kX7Ds.default)(Object.getPrototypeOf, Object);
var $9b5889a70ae02920$export$2e2bcd8739ae039 = $9b5889a70ae02920$var$getPrototype;

});
parcelRegister("kX7Ds", function(module, exports) {

$parcel$export(module.exports, "default", () => $f40f3d8f9bab6dbb$export$2e2bcd8739ae039);
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $f40f3d8f9bab6dbb$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var $f40f3d8f9bab6dbb$export$2e2bcd8739ae039 = $f40f3d8f9bab6dbb$var$overArg;

});


parcelRegister("da1Ti", function(module, exports) {

$parcel$export(module.exports, "default", () => $994dad09dbe65596$export$2e2bcd8739ae039);
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $994dad09dbe65596$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
var $994dad09dbe65596$export$2e2bcd8739ae039 = $994dad09dbe65596$var$isObjectLike;

});


parcelRegister("e3GSY", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3c29cb39a40953b$export$2e2bcd8739ae039);

var $k0qEi = parcelRequire("k0qEi");
/** Used to compose bitmasks for cloning. */ var $a3c29cb39a40953b$var$CLONE_DEEP_FLAG = 1, $a3c29cb39a40953b$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $a3c29cb39a40953b$var$cloneDeep(value) {
    return (0, $k0qEi.default)(value, $a3c29cb39a40953b$var$CLONE_DEEP_FLAG | $a3c29cb39a40953b$var$CLONE_SYMBOLS_FLAG);
}
var $a3c29cb39a40953b$export$2e2bcd8739ae039 = $a3c29cb39a40953b$var$cloneDeep;

});
parcelRegister("k0qEi", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9087aa2c458803d$export$2e2bcd8739ae039);

var $29wyc = parcelRequire("29wyc");

var $6tC51 = parcelRequire("6tC51");

var $5YV7T = parcelRequire("5YV7T");

var $f9u12 = parcelRequire("f9u12");

var $5h2DV = parcelRequire("5h2DV");

var $c4zsg = parcelRequire("c4zsg");

var $h3wcn = parcelRequire("h3wcn");

var $fbIah = parcelRequire("fbIah");

var $170nJ = parcelRequire("170nJ");

var $3tk8b = parcelRequire("3tk8b");

var $8b64V = parcelRequire("8b64V");

var $gbHlz = parcelRequire("gbHlz");

var $izuBR = parcelRequire("izuBR");

var $lBsJH = parcelRequire("lBsJH");

var $kraA4 = parcelRequire("kraA4");

var $5yaQN = parcelRequire("5yaQN");

var $dsiS5 = parcelRequire("dsiS5");

var $9pyJg = parcelRequire("9pyJg");

var $frrTq = parcelRequire("frrTq");

var $19too = parcelRequire("19too");

var $2jh9k = parcelRequire("2jh9k");

var $2W5yf = parcelRequire("2W5yf");
/** Used to compose bitmasks for cloning. */ var $e9087aa2c458803d$var$CLONE_DEEP_FLAG = 1, $e9087aa2c458803d$var$CLONE_FLAT_FLAG = 2, $e9087aa2c458803d$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $e9087aa2c458803d$var$argsTag = '[object Arguments]', $e9087aa2c458803d$var$arrayTag = '[object Array]', $e9087aa2c458803d$var$boolTag = '[object Boolean]', $e9087aa2c458803d$var$dateTag = '[object Date]', $e9087aa2c458803d$var$errorTag = '[object Error]', $e9087aa2c458803d$var$funcTag = '[object Function]', $e9087aa2c458803d$var$genTag = '[object GeneratorFunction]', $e9087aa2c458803d$var$mapTag = '[object Map]', $e9087aa2c458803d$var$numberTag = '[object Number]', $e9087aa2c458803d$var$objectTag = '[object Object]', $e9087aa2c458803d$var$regexpTag = '[object RegExp]', $e9087aa2c458803d$var$setTag = '[object Set]', $e9087aa2c458803d$var$stringTag = '[object String]', $e9087aa2c458803d$var$symbolTag = '[object Symbol]', $e9087aa2c458803d$var$weakMapTag = '[object WeakMap]';
var $e9087aa2c458803d$var$arrayBufferTag = '[object ArrayBuffer]', $e9087aa2c458803d$var$dataViewTag = '[object DataView]', $e9087aa2c458803d$var$float32Tag = '[object Float32Array]', $e9087aa2c458803d$var$float64Tag = '[object Float64Array]', $e9087aa2c458803d$var$int8Tag = '[object Int8Array]', $e9087aa2c458803d$var$int16Tag = '[object Int16Array]', $e9087aa2c458803d$var$int32Tag = '[object Int32Array]', $e9087aa2c458803d$var$uint8Tag = '[object Uint8Array]', $e9087aa2c458803d$var$uint8ClampedTag = '[object Uint8ClampedArray]', $e9087aa2c458803d$var$uint16Tag = '[object Uint16Array]', $e9087aa2c458803d$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $e9087aa2c458803d$var$cloneableTags = {};
$e9087aa2c458803d$var$cloneableTags[$e9087aa2c458803d$var$argsTag] = $e9087aa2c458803d$var$cloneableTags[$e9087aa2c458803d$var$arrayTag] = $e9087aa2c458803d$var$cloneableTags[$e9087aa2c458803d$var$arrayBufferTag] = $e9087aa2c458803d$var$cloneableTags[$e9087aa2c458803d$var$dataViewTag] = $e9087aa2c458803d$var$cloneableTags[$e9087aa2c458803d$var$boolTag] = $e9087aa2c458803d$var$cloneableTags[$e9087aa2c458803d$var$dateTag] = $e9087aa2c458803d$var$cloneableTags[$e9087aa2c458803d$var$float32Tag] = $e9087aa2c458803d$var$cloneableTags[$e9087aa2c458803d$var$float64Tag] = $e9087aa2c458803d$var$cloneableTags[$e9087aa2c458803d$var$int8Tag] = $e9087aa2c458803d$var$cloneableTags[$e9087aa2c458803d$var$int16Tag] = $e9087aa2c458803d$var$cloneableTags[$e9087aa2c458803d$var$int32Tag] = $e9087aa2c458803d$var$cloneableTags[$e9087aa2c458803d$var$mapTag] = $e9087aa2c458803d$var$cloneableTags[$e9087aa2c458803d$var$numberTag] = $e9087aa2c458803d$var$cloneableTags[$e9087aa2c458803d$var$objectTag] = $e9087aa2c458803d$var$cloneableTags[$e9087aa2c458803d$var$regexpTag] = $e9087aa2c458803d$var$cloneableTags[$e9087aa2c458803d$var$setTag] = $e9087aa2c458803d$var$cloneableTags[$e9087aa2c458803d$var$stringTag] = $e9087aa2c458803d$var$cloneableTags[$e9087aa2c458803d$var$symbolTag] = $e9087aa2c458803d$var$cloneableTags[$e9087aa2c458803d$var$uint8Tag] = $e9087aa2c458803d$var$cloneableTags[$e9087aa2c458803d$var$uint8ClampedTag] = $e9087aa2c458803d$var$cloneableTags[$e9087aa2c458803d$var$uint16Tag] = $e9087aa2c458803d$var$cloneableTags[$e9087aa2c458803d$var$uint32Tag] = true;
$e9087aa2c458803d$var$cloneableTags[$e9087aa2c458803d$var$errorTag] = $e9087aa2c458803d$var$cloneableTags[$e9087aa2c458803d$var$funcTag] = $e9087aa2c458803d$var$cloneableTags[$e9087aa2c458803d$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $e9087aa2c458803d$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $e9087aa2c458803d$var$CLONE_DEEP_FLAG, isFlat = bitmask & $e9087aa2c458803d$var$CLONE_FLAT_FLAG, isFull = bitmask & $e9087aa2c458803d$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!(0, $frrTq.default)(value)) return value;
    var isArr = (0, $5yaQN.default)(value);
    if (isArr) {
        result = (0, $izuBR.default)(value);
        if (!isDeep) return (0, $h3wcn.default)(value, result);
    } else {
        var tag = (0, $gbHlz.default)(value), isFunc = tag == $e9087aa2c458803d$var$funcTag || tag == $e9087aa2c458803d$var$genTag;
        if ((0, $dsiS5.default)(value)) return (0, $c4zsg.default)(value, isDeep);
        if (tag == $e9087aa2c458803d$var$objectTag || tag == $e9087aa2c458803d$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : (0, $kraA4.default)(value);
            if (!isDeep) return isFlat ? (0, $170nJ.default)(value, (0, $5h2DV.default)(result, value)) : (0, $fbIah.default)(value, (0, $f9u12.default)(result, value));
        } else {
            if (!$e9087aa2c458803d$var$cloneableTags[tag]) return object ? value : {};
            result = (0, $lBsJH.default)(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new (0, $29wyc.default));
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ((0, $19too.default)(value)) value.forEach(function(subValue) {
        result.add($e9087aa2c458803d$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ((0, $9pyJg.default)(value)) value.forEach(function(subValue, key) {
        result.set(key, $e9087aa2c458803d$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? (0, $8b64V.default) : (0, $3tk8b.default) : isFlat ? (0, $2W5yf.default) : (0, $2jh9k.default);
    var props = isArr ? undefined : keysFunc(value);
    (0, $6tC51.default)(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        (0, $5YV7T.default)(result, key, $e9087aa2c458803d$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
var $e9087aa2c458803d$export$2e2bcd8739ae039 = $e9087aa2c458803d$var$baseClone;

});
parcelRegister("29wyc", function(module, exports) {

$parcel$export(module.exports, "default", () => $1915abe93de7f94a$export$2e2bcd8739ae039);

var $bKxs2 = parcelRequire("bKxs2");

var $54bhV = parcelRequire("54bhV");

var $8TShp = parcelRequire("8TShp");

var $22Xy2 = parcelRequire("22Xy2");

var $79WLC = parcelRequire("79WLC");

var $3BXfQ = parcelRequire("3BXfQ");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $1915abe93de7f94a$var$Stack(entries) {
    var data = this.__data__ = new (0, $bKxs2.default)(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$1915abe93de7f94a$var$Stack.prototype.clear = (0, $54bhV.default);
$1915abe93de7f94a$var$Stack.prototype['delete'] = (0, $8TShp.default);
$1915abe93de7f94a$var$Stack.prototype.get = (0, $22Xy2.default);
$1915abe93de7f94a$var$Stack.prototype.has = (0, $79WLC.default);
$1915abe93de7f94a$var$Stack.prototype.set = (0, $3BXfQ.default);
var $1915abe93de7f94a$export$2e2bcd8739ae039 = $1915abe93de7f94a$var$Stack;

});
parcelRegister("bKxs2", function(module, exports) {

$parcel$export(module.exports, "default", () => $88ddf04ee0a9db3a$export$2e2bcd8739ae039);

var $cBY1p = parcelRequire("cBY1p");

var $hkApn = parcelRequire("hkApn");

var $fzjrg = parcelRequire("fzjrg");

var $8b3Ad = parcelRequire("8b3Ad");

var $hYsIA = parcelRequire("hYsIA");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $88ddf04ee0a9db3a$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$88ddf04ee0a9db3a$var$ListCache.prototype.clear = (0, $cBY1p.default);
$88ddf04ee0a9db3a$var$ListCache.prototype['delete'] = (0, $hkApn.default);
$88ddf04ee0a9db3a$var$ListCache.prototype.get = (0, $fzjrg.default);
$88ddf04ee0a9db3a$var$ListCache.prototype.has = (0, $8b3Ad.default);
$88ddf04ee0a9db3a$var$ListCache.prototype.set = (0, $hYsIA.default);
var $88ddf04ee0a9db3a$export$2e2bcd8739ae039 = $88ddf04ee0a9db3a$var$ListCache;

});
parcelRegister("cBY1p", function(module, exports) {

$parcel$export(module.exports, "default", () => $92e77fd092ca6d4c$export$2e2bcd8739ae039);
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $92e77fd092ca6d4c$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
var $92e77fd092ca6d4c$export$2e2bcd8739ae039 = $92e77fd092ca6d4c$var$listCacheClear;

});

parcelRegister("hkApn", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9e08bd5fb3e5d48$export$2e2bcd8739ae039);

var $5ibcC = parcelRequire("5ibcC");
/** Used for built-in method references. */ var $c9e08bd5fb3e5d48$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $c9e08bd5fb3e5d48$var$splice = $c9e08bd5fb3e5d48$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $c9e08bd5fb3e5d48$var$listCacheDelete(key) {
    var data = this.__data__, index = (0, $5ibcC.default)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $c9e08bd5fb3e5d48$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
var $c9e08bd5fb3e5d48$export$2e2bcd8739ae039 = $c9e08bd5fb3e5d48$var$listCacheDelete;

});
parcelRegister("5ibcC", function(module, exports) {

$parcel$export(module.exports, "default", () => $3da752c761c01e17$export$2e2bcd8739ae039);

var $7pwr8 = parcelRequire("7pwr8");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $3da752c761c01e17$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, $7pwr8.default)(array[length][0], key)) return length;
    }
    return -1;
}
var $3da752c761c01e17$export$2e2bcd8739ae039 = $3da752c761c01e17$var$assocIndexOf;

});
parcelRegister("7pwr8", function(module, exports) {

$parcel$export(module.exports, "default", () => $56540772ee4efdb4$export$2e2bcd8739ae039);
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $56540772ee4efdb4$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
var $56540772ee4efdb4$export$2e2bcd8739ae039 = $56540772ee4efdb4$var$eq;

});



parcelRegister("fzjrg", function(module, exports) {

$parcel$export(module.exports, "default", () => $b559340aec939663$export$2e2bcd8739ae039);

var $5ibcC = parcelRequire("5ibcC");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $b559340aec939663$var$listCacheGet(key) {
    var data = this.__data__, index = (0, $5ibcC.default)(data, key);
    return index < 0 ? undefined : data[index][1];
}
var $b559340aec939663$export$2e2bcd8739ae039 = $b559340aec939663$var$listCacheGet;

});

parcelRegister("8b3Ad", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f42215892c41178$export$2e2bcd8739ae039);

var $5ibcC = parcelRequire("5ibcC");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $5f42215892c41178$var$listCacheHas(key) {
    return (0, $5ibcC.default)(this.__data__, key) > -1;
}
var $5f42215892c41178$export$2e2bcd8739ae039 = $5f42215892c41178$var$listCacheHas;

});

parcelRegister("hYsIA", function(module, exports) {

$parcel$export(module.exports, "default", () => $d15e511bd8969362$export$2e2bcd8739ae039);

var $5ibcC = parcelRequire("5ibcC");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $d15e511bd8969362$var$listCacheSet(key, value) {
    var data = this.__data__, index = (0, $5ibcC.default)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
var $d15e511bd8969362$export$2e2bcd8739ae039 = $d15e511bd8969362$var$listCacheSet;

});


parcelRegister("54bhV", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b061514bde24cc2$export$2e2bcd8739ae039);

var $bKxs2 = parcelRequire("bKxs2");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $3b061514bde24cc2$var$stackClear() {
    this.__data__ = new (0, $bKxs2.default);
    this.size = 0;
}
var $3b061514bde24cc2$export$2e2bcd8739ae039 = $3b061514bde24cc2$var$stackClear;

});

parcelRegister("8TShp", function(module, exports) {

$parcel$export(module.exports, "default", () => $67ad909b39561276$export$2e2bcd8739ae039);
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $67ad909b39561276$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
var $67ad909b39561276$export$2e2bcd8739ae039 = $67ad909b39561276$var$stackDelete;

});

parcelRegister("22Xy2", function(module, exports) {

$parcel$export(module.exports, "default", () => $17d9f5aeb45870ea$export$2e2bcd8739ae039);
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $17d9f5aeb45870ea$var$stackGet(key) {
    return this.__data__.get(key);
}
var $17d9f5aeb45870ea$export$2e2bcd8739ae039 = $17d9f5aeb45870ea$var$stackGet;

});

parcelRegister("79WLC", function(module, exports) {

$parcel$export(module.exports, "default", () => $5366f5922c08e123$export$2e2bcd8739ae039);
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $5366f5922c08e123$var$stackHas(key) {
    return this.__data__.has(key);
}
var $5366f5922c08e123$export$2e2bcd8739ae039 = $5366f5922c08e123$var$stackHas;

});

parcelRegister("3BXfQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a12ca83aa150521$export$2e2bcd8739ae039);

var $bKxs2 = parcelRequire("bKxs2");

var $5atPJ = parcelRequire("5atPJ");

var $cPIJw = parcelRequire("cPIJw");
/** Used as the size to enable large array optimizations. */ var $2a12ca83aa150521$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $2a12ca83aa150521$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof (0, $bKxs2.default)) {
        var pairs = data.__data__;
        if (!(0, $5atPJ.default) || pairs.length < $2a12ca83aa150521$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new (0, $cPIJw.default)(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
var $2a12ca83aa150521$export$2e2bcd8739ae039 = $2a12ca83aa150521$var$stackSet;

});
parcelRegister("5atPJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c3507300ac7ffd8$export$2e2bcd8739ae039);

var $2h6lm = parcelRequire("2h6lm");

var $fRXcK = parcelRequire("fRXcK");
/* Built-in method references that are verified to be native. */ var $3c3507300ac7ffd8$var$Map = (0, $2h6lm.default)((0, $fRXcK.default), 'Map');
var $3c3507300ac7ffd8$export$2e2bcd8739ae039 = $3c3507300ac7ffd8$var$Map;

});
parcelRegister("2h6lm", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a8216fe5bdd61cc$export$2e2bcd8739ae039);

var $6HoRA = parcelRequire("6HoRA");

var $gRR8o = parcelRequire("gRR8o");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $1a8216fe5bdd61cc$var$getNative(object, key) {
    var value = (0, $gRR8o.default)(object, key);
    return (0, $6HoRA.default)(value) ? value : undefined;
}
var $1a8216fe5bdd61cc$export$2e2bcd8739ae039 = $1a8216fe5bdd61cc$var$getNative;

});
parcelRegister("6HoRA", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e0a0b8dae2c5158$export$2e2bcd8739ae039);

var $i2d2G = parcelRequire("i2d2G");

var $gUCSj = parcelRequire("gUCSj");

var $frrTq = parcelRequire("frrTq");

var $8Si7B = parcelRequire("8Si7B");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $4e0a0b8dae2c5158$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $4e0a0b8dae2c5158$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $4e0a0b8dae2c5158$var$funcProto = Function.prototype, $4e0a0b8dae2c5158$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $4e0a0b8dae2c5158$var$funcToString = $4e0a0b8dae2c5158$var$funcProto.toString;
/** Used to check objects for own properties. */ var $4e0a0b8dae2c5158$var$hasOwnProperty = $4e0a0b8dae2c5158$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $4e0a0b8dae2c5158$var$reIsNative = RegExp('^' + $4e0a0b8dae2c5158$var$funcToString.call($4e0a0b8dae2c5158$var$hasOwnProperty).replace($4e0a0b8dae2c5158$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $4e0a0b8dae2c5158$var$baseIsNative(value) {
    if (!(0, $frrTq.default)(value) || (0, $gUCSj.default)(value)) return false;
    var pattern = (0, $i2d2G.default)(value) ? $4e0a0b8dae2c5158$var$reIsNative : $4e0a0b8dae2c5158$var$reIsHostCtor;
    return pattern.test((0, $8Si7B.default)(value));
}
var $4e0a0b8dae2c5158$export$2e2bcd8739ae039 = $4e0a0b8dae2c5158$var$baseIsNative;

});
parcelRegister("i2d2G", function(module, exports) {

$parcel$export(module.exports, "default", () => $d21287d0c0d10911$export$2e2bcd8739ae039);

var $8X3vt = parcelRequire("8X3vt");

var $frrTq = parcelRequire("frrTq");
/** `Object#toString` result references. */ var $d21287d0c0d10911$var$asyncTag = '[object AsyncFunction]', $d21287d0c0d10911$var$funcTag = '[object Function]', $d21287d0c0d10911$var$genTag = '[object GeneratorFunction]', $d21287d0c0d10911$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $d21287d0c0d10911$var$isFunction(value) {
    if (!(0, $frrTq.default)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, $8X3vt.default)(value);
    return tag == $d21287d0c0d10911$var$funcTag || tag == $d21287d0c0d10911$var$genTag || tag == $d21287d0c0d10911$var$asyncTag || tag == $d21287d0c0d10911$var$proxyTag;
}
var $d21287d0c0d10911$export$2e2bcd8739ae039 = $d21287d0c0d10911$var$isFunction;

});
parcelRegister("frrTq", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3df039c0fe6a2f0$export$2e2bcd8739ae039);
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $b3df039c0fe6a2f0$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
var $b3df039c0fe6a2f0$export$2e2bcd8739ae039 = $b3df039c0fe6a2f0$var$isObject;

});


parcelRegister("gUCSj", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5000813d021dbca$export$2e2bcd8739ae039);

var $4qK3P = parcelRequire("4qK3P");
/** Used to detect methods masquerading as native. */ var $c5000813d021dbca$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, $4qK3P.default) && (0, $4qK3P.default).keys && (0, $4qK3P.default).keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $c5000813d021dbca$var$isMasked(func) {
    return !!$c5000813d021dbca$var$maskSrcKey && $c5000813d021dbca$var$maskSrcKey in func;
}
var $c5000813d021dbca$export$2e2bcd8739ae039 = $c5000813d021dbca$var$isMasked;

});
parcelRegister("4qK3P", function(module, exports) {

$parcel$export(module.exports, "default", () => $339d51d2beb33f96$export$2e2bcd8739ae039);

var $fRXcK = parcelRequire("fRXcK");
/** Used to detect overreaching core-js shims. */ var $339d51d2beb33f96$var$coreJsData = (0, $fRXcK.default)['__core-js_shared__'];
var $339d51d2beb33f96$export$2e2bcd8739ae039 = $339d51d2beb33f96$var$coreJsData;

});


parcelRegister("8Si7B", function(module, exports) {

$parcel$export(module.exports, "default", () => $67616c73ae0ab3b8$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $67616c73ae0ab3b8$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $67616c73ae0ab3b8$var$funcToString = $67616c73ae0ab3b8$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $67616c73ae0ab3b8$var$toSource(func) {
    if (func != null) {
        try {
            return $67616c73ae0ab3b8$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
var $67616c73ae0ab3b8$export$2e2bcd8739ae039 = $67616c73ae0ab3b8$var$toSource;

});


parcelRegister("gRR8o", function(module, exports) {

$parcel$export(module.exports, "default", () => $c47acff25e8ff3d7$export$2e2bcd8739ae039);
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $c47acff25e8ff3d7$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
var $c47acff25e8ff3d7$export$2e2bcd8739ae039 = $c47acff25e8ff3d7$var$getValue;

});



parcelRegister("cPIJw", function(module, exports) {

$parcel$export(module.exports, "default", () => $957cf28a58e20ec6$export$2e2bcd8739ae039);

var $XI5RO = parcelRequire("XI5RO");

var $hGGf4 = parcelRequire("hGGf4");

var $eUEZc = parcelRequire("eUEZc");

var $dGkb8 = parcelRequire("dGkb8");

var $hnStB = parcelRequire("hnStB");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $957cf28a58e20ec6$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$957cf28a58e20ec6$var$MapCache.prototype.clear = (0, $XI5RO.default);
$957cf28a58e20ec6$var$MapCache.prototype['delete'] = (0, $hGGf4.default);
$957cf28a58e20ec6$var$MapCache.prototype.get = (0, $eUEZc.default);
$957cf28a58e20ec6$var$MapCache.prototype.has = (0, $dGkb8.default);
$957cf28a58e20ec6$var$MapCache.prototype.set = (0, $hnStB.default);
var $957cf28a58e20ec6$export$2e2bcd8739ae039 = $957cf28a58e20ec6$var$MapCache;

});
parcelRegister("XI5RO", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b37b6e11865570f$export$2e2bcd8739ae039);

var $ctpRT = parcelRequire("ctpRT");

var $bKxs2 = parcelRequire("bKxs2");

var $5atPJ = parcelRequire("5atPJ");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $0b37b6e11865570f$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new (0, $ctpRT.default),
        'map': new ((0, $5atPJ.default) || (0, $bKxs2.default)),
        'string': new (0, $ctpRT.default)
    };
}
var $0b37b6e11865570f$export$2e2bcd8739ae039 = $0b37b6e11865570f$var$mapCacheClear;

});
parcelRegister("ctpRT", function(module, exports) {

$parcel$export(module.exports, "default", () => $914c4256658f912b$export$2e2bcd8739ae039);

var $38Emf = parcelRequire("38Emf");

var $2oals = parcelRequire("2oals");

var $hrree = parcelRequire("hrree");

var $5EeJZ = parcelRequire("5EeJZ");

var $1J3oB = parcelRequire("1J3oB");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $914c4256658f912b$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$914c4256658f912b$var$Hash.prototype.clear = (0, $38Emf.default);
$914c4256658f912b$var$Hash.prototype['delete'] = (0, $2oals.default);
$914c4256658f912b$var$Hash.prototype.get = (0, $hrree.default);
$914c4256658f912b$var$Hash.prototype.has = (0, $5EeJZ.default);
$914c4256658f912b$var$Hash.prototype.set = (0, $1J3oB.default);
var $914c4256658f912b$export$2e2bcd8739ae039 = $914c4256658f912b$var$Hash;

});
parcelRegister("38Emf", function(module, exports) {

$parcel$export(module.exports, "default", () => $24916cb0a1f5cb14$export$2e2bcd8739ae039);

var $dVQXg = parcelRequire("dVQXg");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $24916cb0a1f5cb14$var$hashClear() {
    this.__data__ = (0, $dVQXg.default) ? (0, $dVQXg.default)(null) : {};
    this.size = 0;
}
var $24916cb0a1f5cb14$export$2e2bcd8739ae039 = $24916cb0a1f5cb14$var$hashClear;

});
parcelRegister("dVQXg", function(module, exports) {

$parcel$export(module.exports, "default", () => $a249acf5c6bc3639$export$2e2bcd8739ae039);

var $2h6lm = parcelRequire("2h6lm");
/* Built-in method references that are verified to be native. */ var $a249acf5c6bc3639$var$nativeCreate = (0, $2h6lm.default)(Object, 'create');
var $a249acf5c6bc3639$export$2e2bcd8739ae039 = $a249acf5c6bc3639$var$nativeCreate;

});


parcelRegister("2oals", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bd5d8fbefb6aa42$export$2e2bcd8739ae039);
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $1bd5d8fbefb6aa42$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
var $1bd5d8fbefb6aa42$export$2e2bcd8739ae039 = $1bd5d8fbefb6aa42$var$hashDelete;

});

parcelRegister("hrree", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb2a144d0aa9deec$export$2e2bcd8739ae039);

var $dVQXg = parcelRequire("dVQXg");
/** Used to stand-in for `undefined` hash values. */ var $cb2a144d0aa9deec$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $cb2a144d0aa9deec$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $cb2a144d0aa9deec$var$hasOwnProperty = $cb2a144d0aa9deec$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $cb2a144d0aa9deec$var$hashGet(key) {
    var data = this.__data__;
    if (0, $dVQXg.default) {
        var result = data[key];
        return result === $cb2a144d0aa9deec$var$HASH_UNDEFINED ? undefined : result;
    }
    return $cb2a144d0aa9deec$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
var $cb2a144d0aa9deec$export$2e2bcd8739ae039 = $cb2a144d0aa9deec$var$hashGet;

});

parcelRegister("5EeJZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $41cc1f5e5801ce38$export$2e2bcd8739ae039);

var $dVQXg = parcelRequire("dVQXg");
/** Used for built-in method references. */ var $41cc1f5e5801ce38$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $41cc1f5e5801ce38$var$hasOwnProperty = $41cc1f5e5801ce38$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $41cc1f5e5801ce38$var$hashHas(key) {
    var data = this.__data__;
    return (0, $dVQXg.default) ? data[key] !== undefined : $41cc1f5e5801ce38$var$hasOwnProperty.call(data, key);
}
var $41cc1f5e5801ce38$export$2e2bcd8739ae039 = $41cc1f5e5801ce38$var$hashHas;

});

parcelRegister("1J3oB", function(module, exports) {

$parcel$export(module.exports, "default", () => $141ca0bf5928a85a$export$2e2bcd8739ae039);

var $dVQXg = parcelRequire("dVQXg");
/** Used to stand-in for `undefined` hash values. */ var $141ca0bf5928a85a$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $141ca0bf5928a85a$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, $dVQXg.default) && value === undefined ? $141ca0bf5928a85a$var$HASH_UNDEFINED : value;
    return this;
}
var $141ca0bf5928a85a$export$2e2bcd8739ae039 = $141ca0bf5928a85a$var$hashSet;

});



parcelRegister("hGGf4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce07204ae5cd6e47$export$2e2bcd8739ae039);

var $CBtAG = parcelRequire("CBtAG");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $ce07204ae5cd6e47$var$mapCacheDelete(key) {
    var result = (0, $CBtAG.default)(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
var $ce07204ae5cd6e47$export$2e2bcd8739ae039 = $ce07204ae5cd6e47$var$mapCacheDelete;

});
parcelRegister("CBtAG", function(module, exports) {

$parcel$export(module.exports, "default", () => $07409ebb26c77be4$export$2e2bcd8739ae039);

var $cpTBK = parcelRequire("cpTBK");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $07409ebb26c77be4$var$getMapData(map, key) {
    var data = map.__data__;
    return (0, $cpTBK.default)(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
var $07409ebb26c77be4$export$2e2bcd8739ae039 = $07409ebb26c77be4$var$getMapData;

});
parcelRegister("cpTBK", function(module, exports) {

$parcel$export(module.exports, "default", () => $90a2f4695e9c08f6$export$2e2bcd8739ae039);
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $90a2f4695e9c08f6$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
var $90a2f4695e9c08f6$export$2e2bcd8739ae039 = $90a2f4695e9c08f6$var$isKeyable;

});



parcelRegister("eUEZc", function(module, exports) {

$parcel$export(module.exports, "default", () => $adb616a8824a08aa$export$2e2bcd8739ae039);

var $CBtAG = parcelRequire("CBtAG");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $adb616a8824a08aa$var$mapCacheGet(key) {
    return (0, $CBtAG.default)(this, key).get(key);
}
var $adb616a8824a08aa$export$2e2bcd8739ae039 = $adb616a8824a08aa$var$mapCacheGet;

});

parcelRegister("dGkb8", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f5ed9abb3555b68$export$2e2bcd8739ae039);

var $CBtAG = parcelRequire("CBtAG");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $9f5ed9abb3555b68$var$mapCacheHas(key) {
    return (0, $CBtAG.default)(this, key).has(key);
}
var $9f5ed9abb3555b68$export$2e2bcd8739ae039 = $9f5ed9abb3555b68$var$mapCacheHas;

});

parcelRegister("hnStB", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca7ed787c492dedd$export$2e2bcd8739ae039);

var $CBtAG = parcelRequire("CBtAG");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $ca7ed787c492dedd$var$mapCacheSet(key, value) {
    var data = (0, $CBtAG.default)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
var $ca7ed787c492dedd$export$2e2bcd8739ae039 = $ca7ed787c492dedd$var$mapCacheSet;

});




parcelRegister("6tC51", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b72fd670e0457f1$export$2e2bcd8739ae039);
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $4b72fd670e0457f1$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
var $4b72fd670e0457f1$export$2e2bcd8739ae039 = $4b72fd670e0457f1$var$arrayEach;

});

parcelRegister("5YV7T", function(module, exports) {

$parcel$export(module.exports, "default", () => $45aede6cc1401fb2$export$2e2bcd8739ae039);

var $enhc0 = parcelRequire("enhc0");

var $7pwr8 = parcelRequire("7pwr8");
/** Used for built-in method references. */ var $45aede6cc1401fb2$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $45aede6cc1401fb2$var$hasOwnProperty = $45aede6cc1401fb2$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $45aede6cc1401fb2$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($45aede6cc1401fb2$var$hasOwnProperty.call(object, key) && (0, $7pwr8.default)(objValue, value)) || value === undefined && !(key in object)) (0, $enhc0.default)(object, key, value);
}
var $45aede6cc1401fb2$export$2e2bcd8739ae039 = $45aede6cc1401fb2$var$assignValue;

});
parcelRegister("enhc0", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7708cc41bff3746$export$2e2bcd8739ae039);

var $dolVq = parcelRequire("dolVq");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $a7708cc41bff3746$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && (0, $dolVq.default)) (0, $dolVq.default)(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
var $a7708cc41bff3746$export$2e2bcd8739ae039 = $a7708cc41bff3746$var$baseAssignValue;

});
parcelRegister("dolVq", function(module, exports) {

$parcel$export(module.exports, "default", () => $9bfe8620f76c21fc$export$2e2bcd8739ae039);

var $2h6lm = parcelRequire("2h6lm");
var $9bfe8620f76c21fc$var$defineProperty = function() {
    try {
        var func = (0, $2h6lm.default)(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
var $9bfe8620f76c21fc$export$2e2bcd8739ae039 = $9bfe8620f76c21fc$var$defineProperty;

});



parcelRegister("f9u12", function(module, exports) {

$parcel$export(module.exports, "default", () => $b07efac6142b839d$export$2e2bcd8739ae039);

var $9SYAA = parcelRequire("9SYAA");

var $2jh9k = parcelRequire("2jh9k");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $b07efac6142b839d$var$baseAssign(object, source) {
    return object && (0, $9SYAA.default)(source, (0, $2jh9k.default)(source), object);
}
var $b07efac6142b839d$export$2e2bcd8739ae039 = $b07efac6142b839d$var$baseAssign;

});
parcelRegister("9SYAA", function(module, exports) {

$parcel$export(module.exports, "default", () => $732827ed53a9fd5e$export$2e2bcd8739ae039);

var $5YV7T = parcelRequire("5YV7T");

var $enhc0 = parcelRequire("enhc0");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $732827ed53a9fd5e$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) (0, $enhc0.default)(object, key, newValue);
        else (0, $5YV7T.default)(object, key, newValue);
    }
    return object;
}
var $732827ed53a9fd5e$export$2e2bcd8739ae039 = $732827ed53a9fd5e$var$copyObject;

});

parcelRegister("2jh9k", function(module, exports) {

$parcel$export(module.exports, "default", () => $1aeaa8a4b0d3a6c5$export$2e2bcd8739ae039);

var $2Ey4s = parcelRequire("2Ey4s");

var $5OieK = parcelRequire("5OieK");

var $10Tbb = parcelRequire("10Tbb");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $1aeaa8a4b0d3a6c5$var$keys(object) {
    return (0, $10Tbb.default)(object) ? (0, $2Ey4s.default)(object) : (0, $5OieK.default)(object);
}
var $1aeaa8a4b0d3a6c5$export$2e2bcd8739ae039 = $1aeaa8a4b0d3a6c5$var$keys;

});
parcelRegister("2Ey4s", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ee9befbb41fe2a6$export$2e2bcd8739ae039);

var $b1EaJ = parcelRequire("b1EaJ");

var $80EAH = parcelRequire("80EAH");

var $5yaQN = parcelRequire("5yaQN");

var $dsiS5 = parcelRequire("dsiS5");

var $jeldA = parcelRequire("jeldA");

var $j9cN5 = parcelRequire("j9cN5");
/** Used for built-in method references. */ var $1ee9befbb41fe2a6$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $1ee9befbb41fe2a6$var$hasOwnProperty = $1ee9befbb41fe2a6$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $1ee9befbb41fe2a6$var$arrayLikeKeys(value, inherited) {
    var isArr = (0, $5yaQN.default)(value), isArg = !isArr && (0, $80EAH.default)(value), isBuff = !isArr && !isArg && (0, $dsiS5.default)(value), isType = !isArr && !isArg && !isBuff && (0, $j9cN5.default)(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? (0, $b1EaJ.default)(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $1ee9befbb41fe2a6$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    (0, $jeldA.default)(key, length)))) result.push(key);
    return result;
}
var $1ee9befbb41fe2a6$export$2e2bcd8739ae039 = $1ee9befbb41fe2a6$var$arrayLikeKeys;

});
parcelRegister("b1EaJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $806ef30d5f86a86d$export$2e2bcd8739ae039);
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $806ef30d5f86a86d$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
var $806ef30d5f86a86d$export$2e2bcd8739ae039 = $806ef30d5f86a86d$var$baseTimes;

});

parcelRegister("80EAH", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d4dcf59a89cd3a5$export$2e2bcd8739ae039);

var $9uUli = parcelRequire("9uUli");

var $da1Ti = parcelRequire("da1Ti");
/** Used for built-in method references. */ var $5d4dcf59a89cd3a5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $5d4dcf59a89cd3a5$var$hasOwnProperty = $5d4dcf59a89cd3a5$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $5d4dcf59a89cd3a5$var$propertyIsEnumerable = $5d4dcf59a89cd3a5$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $5d4dcf59a89cd3a5$var$isArguments = (0, $9uUli.default)(function() {
    return arguments;
}()) ? (0, $9uUli.default) : function(value) {
    return (0, $da1Ti.default)(value) && $5d4dcf59a89cd3a5$var$hasOwnProperty.call(value, 'callee') && !$5d4dcf59a89cd3a5$var$propertyIsEnumerable.call(value, 'callee');
};
var $5d4dcf59a89cd3a5$export$2e2bcd8739ae039 = $5d4dcf59a89cd3a5$var$isArguments;

});
parcelRegister("9uUli", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ea29edca0a9135c$export$2e2bcd8739ae039);

var $8X3vt = parcelRequire("8X3vt");

var $da1Ti = parcelRequire("da1Ti");
/** `Object#toString` result references. */ var $6ea29edca0a9135c$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $6ea29edca0a9135c$var$baseIsArguments(value) {
    return (0, $da1Ti.default)(value) && (0, $8X3vt.default)(value) == $6ea29edca0a9135c$var$argsTag;
}
var $6ea29edca0a9135c$export$2e2bcd8739ae039 = $6ea29edca0a9135c$var$baseIsArguments;

});


parcelRegister("5yaQN", function(module, exports) {

$parcel$export(module.exports, "default", () => $40a88b6b7b19c283$export$2e2bcd8739ae039);
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $40a88b6b7b19c283$var$isArray = Array.isArray;
var $40a88b6b7b19c283$export$2e2bcd8739ae039 = $40a88b6b7b19c283$var$isArray;

});

parcelRegister("dsiS5", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cbc87528db2a3ee$export$2e2bcd8739ae039);

var $fRXcK = parcelRequire("fRXcK");

var $4f1Ll = parcelRequire("4f1Ll");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $fRXcK.default).Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || (0, $4f1Ll.default);
var $9cbc87528db2a3ee$export$2e2bcd8739ae039 = isBuffer;

});
parcelRegister("4f1Ll", function(module, exports) {

$parcel$export(module.exports, "default", () => $3169ee2e9259e190$export$2e2bcd8739ae039);
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $3169ee2e9259e190$var$stubFalse() {
    return false;
}
var $3169ee2e9259e190$export$2e2bcd8739ae039 = $3169ee2e9259e190$var$stubFalse;

});


parcelRegister("jeldA", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfffc89eb4ba3bf4$export$2e2bcd8739ae039);
/** Used as references for various `Number` constants. */ var $dfffc89eb4ba3bf4$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $dfffc89eb4ba3bf4$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $dfffc89eb4ba3bf4$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $dfffc89eb4ba3bf4$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $dfffc89eb4ba3bf4$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
var $dfffc89eb4ba3bf4$export$2e2bcd8739ae039 = $dfffc89eb4ba3bf4$var$isIndex;

});

parcelRegister("j9cN5", function(module, exports) {

$parcel$export(module.exports, "default", () => $df08c787f8f9f81d$export$2e2bcd8739ae039);

var $38v8p = parcelRequire("38v8p");

var $a1upq = parcelRequire("a1upq");

var $1wE0y = parcelRequire("1wE0y");
/* Node.js helper references. */ var $df08c787f8f9f81d$var$nodeIsTypedArray = (0, $1wE0y.default) && (0, $1wE0y.default).isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $df08c787f8f9f81d$var$isTypedArray = $df08c787f8f9f81d$var$nodeIsTypedArray ? (0, $a1upq.default)($df08c787f8f9f81d$var$nodeIsTypedArray) : (0, $38v8p.default);
var $df08c787f8f9f81d$export$2e2bcd8739ae039 = $df08c787f8f9f81d$var$isTypedArray;

});
parcelRegister("38v8p", function(module, exports) {

$parcel$export(module.exports, "default", () => $248a4521821d915d$export$2e2bcd8739ae039);

var $8X3vt = parcelRequire("8X3vt");

var $3ntEU = parcelRequire("3ntEU");

var $da1Ti = parcelRequire("da1Ti");
/** `Object#toString` result references. */ var $248a4521821d915d$var$argsTag = '[object Arguments]', $248a4521821d915d$var$arrayTag = '[object Array]', $248a4521821d915d$var$boolTag = '[object Boolean]', $248a4521821d915d$var$dateTag = '[object Date]', $248a4521821d915d$var$errorTag = '[object Error]', $248a4521821d915d$var$funcTag = '[object Function]', $248a4521821d915d$var$mapTag = '[object Map]', $248a4521821d915d$var$numberTag = '[object Number]', $248a4521821d915d$var$objectTag = '[object Object]', $248a4521821d915d$var$regexpTag = '[object RegExp]', $248a4521821d915d$var$setTag = '[object Set]', $248a4521821d915d$var$stringTag = '[object String]', $248a4521821d915d$var$weakMapTag = '[object WeakMap]';
var $248a4521821d915d$var$arrayBufferTag = '[object ArrayBuffer]', $248a4521821d915d$var$dataViewTag = '[object DataView]', $248a4521821d915d$var$float32Tag = '[object Float32Array]', $248a4521821d915d$var$float64Tag = '[object Float64Array]', $248a4521821d915d$var$int8Tag = '[object Int8Array]', $248a4521821d915d$var$int16Tag = '[object Int16Array]', $248a4521821d915d$var$int32Tag = '[object Int32Array]', $248a4521821d915d$var$uint8Tag = '[object Uint8Array]', $248a4521821d915d$var$uint8ClampedTag = '[object Uint8ClampedArray]', $248a4521821d915d$var$uint16Tag = '[object Uint16Array]', $248a4521821d915d$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $248a4521821d915d$var$typedArrayTags = {};
$248a4521821d915d$var$typedArrayTags[$248a4521821d915d$var$float32Tag] = $248a4521821d915d$var$typedArrayTags[$248a4521821d915d$var$float64Tag] = $248a4521821d915d$var$typedArrayTags[$248a4521821d915d$var$int8Tag] = $248a4521821d915d$var$typedArrayTags[$248a4521821d915d$var$int16Tag] = $248a4521821d915d$var$typedArrayTags[$248a4521821d915d$var$int32Tag] = $248a4521821d915d$var$typedArrayTags[$248a4521821d915d$var$uint8Tag] = $248a4521821d915d$var$typedArrayTags[$248a4521821d915d$var$uint8ClampedTag] = $248a4521821d915d$var$typedArrayTags[$248a4521821d915d$var$uint16Tag] = $248a4521821d915d$var$typedArrayTags[$248a4521821d915d$var$uint32Tag] = true;
$248a4521821d915d$var$typedArrayTags[$248a4521821d915d$var$argsTag] = $248a4521821d915d$var$typedArrayTags[$248a4521821d915d$var$arrayTag] = $248a4521821d915d$var$typedArrayTags[$248a4521821d915d$var$arrayBufferTag] = $248a4521821d915d$var$typedArrayTags[$248a4521821d915d$var$boolTag] = $248a4521821d915d$var$typedArrayTags[$248a4521821d915d$var$dataViewTag] = $248a4521821d915d$var$typedArrayTags[$248a4521821d915d$var$dateTag] = $248a4521821d915d$var$typedArrayTags[$248a4521821d915d$var$errorTag] = $248a4521821d915d$var$typedArrayTags[$248a4521821d915d$var$funcTag] = $248a4521821d915d$var$typedArrayTags[$248a4521821d915d$var$mapTag] = $248a4521821d915d$var$typedArrayTags[$248a4521821d915d$var$numberTag] = $248a4521821d915d$var$typedArrayTags[$248a4521821d915d$var$objectTag] = $248a4521821d915d$var$typedArrayTags[$248a4521821d915d$var$regexpTag] = $248a4521821d915d$var$typedArrayTags[$248a4521821d915d$var$setTag] = $248a4521821d915d$var$typedArrayTags[$248a4521821d915d$var$stringTag] = $248a4521821d915d$var$typedArrayTags[$248a4521821d915d$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $248a4521821d915d$var$baseIsTypedArray(value) {
    return (0, $da1Ti.default)(value) && (0, $3ntEU.default)(value.length) && !!$248a4521821d915d$var$typedArrayTags[(0, $8X3vt.default)(value)];
}
var $248a4521821d915d$export$2e2bcd8739ae039 = $248a4521821d915d$var$baseIsTypedArray;

});
parcelRegister("3ntEU", function(module, exports) {

$parcel$export(module.exports, "default", () => $275a86b612593d31$export$2e2bcd8739ae039);
/** Used as references for various `Number` constants. */ var $275a86b612593d31$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $275a86b612593d31$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $275a86b612593d31$var$MAX_SAFE_INTEGER;
}
var $275a86b612593d31$export$2e2bcd8739ae039 = $275a86b612593d31$var$isLength;

});


parcelRegister("a1upq", function(module, exports) {

$parcel$export(module.exports, "default", () => $74c19602feaa3066$export$2e2bcd8739ae039);
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $74c19602feaa3066$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
var $74c19602feaa3066$export$2e2bcd8739ae039 = $74c19602feaa3066$var$baseUnary;

});

parcelRegister("1wE0y", function(module, exports) {

$parcel$export(module.exports, "default", () => $11c7d05c3117e39d$export$2e2bcd8739ae039);

var $1kslA = parcelRequire("1kslA");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && (0, $1kslA.default).process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
var $11c7d05c3117e39d$export$2e2bcd8739ae039 = nodeUtil;

});



parcelRegister("5OieK", function(module, exports) {

$parcel$export(module.exports, "default", () => $43afc4bb8d89a7bd$export$2e2bcd8739ae039);

var $dU0PL = parcelRequire("dU0PL");

var $aPlCK = parcelRequire("aPlCK");
/** Used for built-in method references. */ var $43afc4bb8d89a7bd$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $43afc4bb8d89a7bd$var$hasOwnProperty = $43afc4bb8d89a7bd$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $43afc4bb8d89a7bd$var$baseKeys(object) {
    if (!(0, $dU0PL.default)(object)) return (0, $aPlCK.default)(object);
    var result = [];
    for(var key in Object(object))if ($43afc4bb8d89a7bd$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
var $43afc4bb8d89a7bd$export$2e2bcd8739ae039 = $43afc4bb8d89a7bd$var$baseKeys;

});
parcelRegister("dU0PL", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1f126e8eddaa8ab$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $a1f126e8eddaa8ab$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $a1f126e8eddaa8ab$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $a1f126e8eddaa8ab$var$objectProto;
    return value === proto;
}
var $a1f126e8eddaa8ab$export$2e2bcd8739ae039 = $a1f126e8eddaa8ab$var$isPrototype;

});

parcelRegister("aPlCK", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e1f70e42ac81693$export$2e2bcd8739ae039);

var $kX7Ds = parcelRequire("kX7Ds");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $7e1f70e42ac81693$var$nativeKeys = (0, $kX7Ds.default)(Object.keys, Object);
var $7e1f70e42ac81693$export$2e2bcd8739ae039 = $7e1f70e42ac81693$var$nativeKeys;

});


parcelRegister("10Tbb", function(module, exports) {

$parcel$export(module.exports, "default", () => $0bd097fe0adacb0c$export$2e2bcd8739ae039);

var $i2d2G = parcelRequire("i2d2G");

var $3ntEU = parcelRequire("3ntEU");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $0bd097fe0adacb0c$var$isArrayLike(value) {
    return value != null && (0, $3ntEU.default)(value.length) && !(0, $i2d2G.default)(value);
}
var $0bd097fe0adacb0c$export$2e2bcd8739ae039 = $0bd097fe0adacb0c$var$isArrayLike;

});



parcelRegister("5h2DV", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d709718d4f710f2$export$2e2bcd8739ae039);

var $9SYAA = parcelRequire("9SYAA");

var $2W5yf = parcelRequire("2W5yf");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $3d709718d4f710f2$var$baseAssignIn(object, source) {
    return object && (0, $9SYAA.default)(source, (0, $2W5yf.default)(source), object);
}
var $3d709718d4f710f2$export$2e2bcd8739ae039 = $3d709718d4f710f2$var$baseAssignIn;

});
parcelRegister("2W5yf", function(module, exports) {

$parcel$export(module.exports, "default", () => $22354deb72ac72e5$export$2e2bcd8739ae039);

var $2Ey4s = parcelRequire("2Ey4s");

var $6A5i5 = parcelRequire("6A5i5");

var $10Tbb = parcelRequire("10Tbb");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $22354deb72ac72e5$var$keysIn(object) {
    return (0, $10Tbb.default)(object) ? (0, $2Ey4s.default)(object, true) : (0, $6A5i5.default)(object);
}
var $22354deb72ac72e5$export$2e2bcd8739ae039 = $22354deb72ac72e5$var$keysIn;

});
parcelRegister("6A5i5", function(module, exports) {

$parcel$export(module.exports, "default", () => $4caa3583e2a58f16$export$2e2bcd8739ae039);

var $frrTq = parcelRequire("frrTq");

var $dU0PL = parcelRequire("dU0PL");

var $bK1FG = parcelRequire("bK1FG");
/** Used for built-in method references. */ var $4caa3583e2a58f16$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $4caa3583e2a58f16$var$hasOwnProperty = $4caa3583e2a58f16$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $4caa3583e2a58f16$var$baseKeysIn(object) {
    if (!(0, $frrTq.default)(object)) return (0, $bK1FG.default)(object);
    var isProto = (0, $dU0PL.default)(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$4caa3583e2a58f16$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
var $4caa3583e2a58f16$export$2e2bcd8739ae039 = $4caa3583e2a58f16$var$baseKeysIn;

});
parcelRegister("bK1FG", function(module, exports) {

$parcel$export(module.exports, "default", () => $88c5497c4daf1d09$export$2e2bcd8739ae039);
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $88c5497c4daf1d09$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
var $88c5497c4daf1d09$export$2e2bcd8739ae039 = $88c5497c4daf1d09$var$nativeKeysIn;

});




parcelRegister("c4zsg", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ca15c60c7d72159$export$2e2bcd8739ae039);

var $fRXcK = parcelRequire("fRXcK");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $fRXcK.default).Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
var $8ca15c60c7d72159$export$2e2bcd8739ae039 = cloneBuffer;

});

parcelRegister("h3wcn", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6abb176712716ec$export$2e2bcd8739ae039);
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $c6abb176712716ec$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
var $c6abb176712716ec$export$2e2bcd8739ae039 = $c6abb176712716ec$var$copyArray;

});

parcelRegister("fbIah", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0ea24505f79aadc$export$2e2bcd8739ae039);

var $9SYAA = parcelRequire("9SYAA");

var $kALHS = parcelRequire("kALHS");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $b0ea24505f79aadc$var$copySymbols(source, object) {
    return (0, $9SYAA.default)(source, (0, $kALHS.default)(source), object);
}
var $b0ea24505f79aadc$export$2e2bcd8739ae039 = $b0ea24505f79aadc$var$copySymbols;

});
parcelRegister("kALHS", function(module, exports) {

$parcel$export(module.exports, "default", () => $efdc2cfa145e1b28$export$2e2bcd8739ae039);

var $ayFD8 = parcelRequire("ayFD8");

var $9RGsf = parcelRequire("9RGsf");
/** Used for built-in method references. */ var $efdc2cfa145e1b28$var$objectProto = Object.prototype;
/** Built-in value references. */ var $efdc2cfa145e1b28$var$propertyIsEnumerable = $efdc2cfa145e1b28$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $efdc2cfa145e1b28$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $efdc2cfa145e1b28$var$getSymbols = !$efdc2cfa145e1b28$var$nativeGetSymbols ? (0, $9RGsf.default) : function(object) {
    if (object == null) return [];
    object = Object(object);
    return (0, $ayFD8.default)($efdc2cfa145e1b28$var$nativeGetSymbols(object), function(symbol) {
        return $efdc2cfa145e1b28$var$propertyIsEnumerable.call(object, symbol);
    });
};
var $efdc2cfa145e1b28$export$2e2bcd8739ae039 = $efdc2cfa145e1b28$var$getSymbols;

});
parcelRegister("ayFD8", function(module, exports) {

$parcel$export(module.exports, "default", () => $7afd5f3f4d5b8e56$export$2e2bcd8739ae039);
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $7afd5f3f4d5b8e56$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
var $7afd5f3f4d5b8e56$export$2e2bcd8739ae039 = $7afd5f3f4d5b8e56$var$arrayFilter;

});

parcelRegister("9RGsf", function(module, exports) {

$parcel$export(module.exports, "default", () => $72e9fee4b7156309$export$2e2bcd8739ae039);
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $72e9fee4b7156309$var$stubArray() {
    return [];
}
var $72e9fee4b7156309$export$2e2bcd8739ae039 = $72e9fee4b7156309$var$stubArray;

});



parcelRegister("170nJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0cf6bdb3007a3257$export$2e2bcd8739ae039);

var $9SYAA = parcelRequire("9SYAA");

var $c3zSs = parcelRequire("c3zSs");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $0cf6bdb3007a3257$var$copySymbolsIn(source, object) {
    return (0, $9SYAA.default)(source, (0, $c3zSs.default)(source), object);
}
var $0cf6bdb3007a3257$export$2e2bcd8739ae039 = $0cf6bdb3007a3257$var$copySymbolsIn;

});
parcelRegister("c3zSs", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c7198582d5f5065$export$2e2bcd8739ae039);

var $3NJ3g = parcelRequire("3NJ3g");

var $dkTWv = parcelRequire("dkTWv");

var $kALHS = parcelRequire("kALHS");

var $9RGsf = parcelRequire("9RGsf");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $8c7198582d5f5065$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $8c7198582d5f5065$var$getSymbolsIn = !$8c7198582d5f5065$var$nativeGetSymbols ? (0, $9RGsf.default) : function(object) {
    var result = [];
    while(object){
        (0, $3NJ3g.default)(result, (0, $kALHS.default)(object));
        object = (0, $dkTWv.default)(object);
    }
    return result;
};
var $8c7198582d5f5065$export$2e2bcd8739ae039 = $8c7198582d5f5065$var$getSymbolsIn;

});
parcelRegister("3NJ3g", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c48e50495c683b7$export$2e2bcd8739ae039);
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $2c48e50495c683b7$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
var $2c48e50495c683b7$export$2e2bcd8739ae039 = $2c48e50495c683b7$var$arrayPush;

});



parcelRegister("3tk8b", function(module, exports) {

$parcel$export(module.exports, "default", () => $2873b21a5e0737cb$export$2e2bcd8739ae039);

var $2QHMP = parcelRequire("2QHMP");

var $kALHS = parcelRequire("kALHS");

var $2jh9k = parcelRequire("2jh9k");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $2873b21a5e0737cb$var$getAllKeys(object) {
    return (0, $2QHMP.default)(object, (0, $2jh9k.default), (0, $kALHS.default));
}
var $2873b21a5e0737cb$export$2e2bcd8739ae039 = $2873b21a5e0737cb$var$getAllKeys;

});
parcelRegister("2QHMP", function(module, exports) {

$parcel$export(module.exports, "default", () => $2132672da0b0c39a$export$2e2bcd8739ae039);

var $3NJ3g = parcelRequire("3NJ3g");

var $5yaQN = parcelRequire("5yaQN");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $2132672da0b0c39a$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return (0, $5yaQN.default)(object) ? result : (0, $3NJ3g.default)(result, symbolsFunc(object));
}
var $2132672da0b0c39a$export$2e2bcd8739ae039 = $2132672da0b0c39a$var$baseGetAllKeys;

});


parcelRegister("8b64V", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f4410d750b52ee3$export$2e2bcd8739ae039);

var $2QHMP = parcelRequire("2QHMP");

var $c3zSs = parcelRequire("c3zSs");

var $2W5yf = parcelRequire("2W5yf");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $5f4410d750b52ee3$var$getAllKeysIn(object) {
    return (0, $2QHMP.default)(object, (0, $2W5yf.default), (0, $c3zSs.default));
}
var $5f4410d750b52ee3$export$2e2bcd8739ae039 = $5f4410d750b52ee3$var$getAllKeysIn;

});

parcelRegister("gbHlz", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc8f4c39200cff94$export$2e2bcd8739ae039);

var $78fz0 = parcelRequire("78fz0");

var $5atPJ = parcelRequire("5atPJ");

var $dB6DU = parcelRequire("dB6DU");

var $cHnJV = parcelRequire("cHnJV");

var $4aHBz = parcelRequire("4aHBz");

var $8X3vt = parcelRequire("8X3vt");

var $8Si7B = parcelRequire("8Si7B");
/** `Object#toString` result references. */ var $bc8f4c39200cff94$var$mapTag = '[object Map]', $bc8f4c39200cff94$var$objectTag = '[object Object]', $bc8f4c39200cff94$var$promiseTag = '[object Promise]', $bc8f4c39200cff94$var$setTag = '[object Set]', $bc8f4c39200cff94$var$weakMapTag = '[object WeakMap]';
var $bc8f4c39200cff94$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $bc8f4c39200cff94$var$dataViewCtorString = (0, $8Si7B.default)((0, $78fz0.default)), $bc8f4c39200cff94$var$mapCtorString = (0, $8Si7B.default)((0, $5atPJ.default)), $bc8f4c39200cff94$var$promiseCtorString = (0, $8Si7B.default)((0, $dB6DU.default)), $bc8f4c39200cff94$var$setCtorString = (0, $8Si7B.default)((0, $cHnJV.default)), $bc8f4c39200cff94$var$weakMapCtorString = (0, $8Si7B.default)((0, $4aHBz.default));
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $bc8f4c39200cff94$var$getTag = (0, $8X3vt.default);
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((0, $78fz0.default) && $bc8f4c39200cff94$var$getTag(new (0, $78fz0.default)(new ArrayBuffer(1))) != $bc8f4c39200cff94$var$dataViewTag || (0, $5atPJ.default) && $bc8f4c39200cff94$var$getTag(new (0, $5atPJ.default)) != $bc8f4c39200cff94$var$mapTag || (0, $dB6DU.default) && $bc8f4c39200cff94$var$getTag((0, $dB6DU.default).resolve()) != $bc8f4c39200cff94$var$promiseTag || (0, $cHnJV.default) && $bc8f4c39200cff94$var$getTag(new (0, $cHnJV.default)) != $bc8f4c39200cff94$var$setTag || (0, $4aHBz.default) && $bc8f4c39200cff94$var$getTag(new (0, $4aHBz.default)) != $bc8f4c39200cff94$var$weakMapTag) $bc8f4c39200cff94$var$getTag = function(value) {
    var result = (0, $8X3vt.default)(value), Ctor = result == $bc8f4c39200cff94$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? (0, $8Si7B.default)(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $bc8f4c39200cff94$var$dataViewCtorString:
            return $bc8f4c39200cff94$var$dataViewTag;
        case $bc8f4c39200cff94$var$mapCtorString:
            return $bc8f4c39200cff94$var$mapTag;
        case $bc8f4c39200cff94$var$promiseCtorString:
            return $bc8f4c39200cff94$var$promiseTag;
        case $bc8f4c39200cff94$var$setCtorString:
            return $bc8f4c39200cff94$var$setTag;
        case $bc8f4c39200cff94$var$weakMapCtorString:
            return $bc8f4c39200cff94$var$weakMapTag;
    }
    return result;
};
var $bc8f4c39200cff94$export$2e2bcd8739ae039 = $bc8f4c39200cff94$var$getTag;

});
parcelRegister("78fz0", function(module, exports) {

$parcel$export(module.exports, "default", () => $53155a5b51f6f1ea$export$2e2bcd8739ae039);

var $2h6lm = parcelRequire("2h6lm");

var $fRXcK = parcelRequire("fRXcK");
/* Built-in method references that are verified to be native. */ var $53155a5b51f6f1ea$var$DataView = (0, $2h6lm.default)((0, $fRXcK.default), 'DataView');
var $53155a5b51f6f1ea$export$2e2bcd8739ae039 = $53155a5b51f6f1ea$var$DataView;

});

parcelRegister("dB6DU", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e63e23025cefe66$export$2e2bcd8739ae039);

var $2h6lm = parcelRequire("2h6lm");

var $fRXcK = parcelRequire("fRXcK");
/* Built-in method references that are verified to be native. */ var $9e63e23025cefe66$var$Promise = (0, $2h6lm.default)((0, $fRXcK.default), 'Promise');
var $9e63e23025cefe66$export$2e2bcd8739ae039 = $9e63e23025cefe66$var$Promise;

});

parcelRegister("cHnJV", function(module, exports) {

$parcel$export(module.exports, "default", () => $93ebea6538da6b4a$export$2e2bcd8739ae039);

var $2h6lm = parcelRequire("2h6lm");

var $fRXcK = parcelRequire("fRXcK");
/* Built-in method references that are verified to be native. */ var $93ebea6538da6b4a$var$Set = (0, $2h6lm.default)((0, $fRXcK.default), 'Set');
var $93ebea6538da6b4a$export$2e2bcd8739ae039 = $93ebea6538da6b4a$var$Set;

});

parcelRegister("4aHBz", function(module, exports) {

$parcel$export(module.exports, "default", () => $3099eb9c8a2dad9e$export$2e2bcd8739ae039);

var $2h6lm = parcelRequire("2h6lm");

var $fRXcK = parcelRequire("fRXcK");
/* Built-in method references that are verified to be native. */ var $3099eb9c8a2dad9e$var$WeakMap = (0, $2h6lm.default)((0, $fRXcK.default), 'WeakMap');
var $3099eb9c8a2dad9e$export$2e2bcd8739ae039 = $3099eb9c8a2dad9e$var$WeakMap;

});


parcelRegister("izuBR", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8533d5198bb6125$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $d8533d5198bb6125$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d8533d5198bb6125$var$hasOwnProperty = $d8533d5198bb6125$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $d8533d5198bb6125$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $d8533d5198bb6125$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
var $d8533d5198bb6125$export$2e2bcd8739ae039 = $d8533d5198bb6125$var$initCloneArray;

});

parcelRegister("lBsJH", function(module, exports) {

$parcel$export(module.exports, "default", () => $fba35811d6335abb$export$2e2bcd8739ae039);

var $dHNs8 = parcelRequire("dHNs8");

var $3cCc2 = parcelRequire("3cCc2");

var $d9E6g = parcelRequire("d9E6g");

var $lfP7M = parcelRequire("lfP7M");

var $ji7F8 = parcelRequire("ji7F8");
/** `Object#toString` result references. */ var $fba35811d6335abb$var$boolTag = '[object Boolean]', $fba35811d6335abb$var$dateTag = '[object Date]', $fba35811d6335abb$var$mapTag = '[object Map]', $fba35811d6335abb$var$numberTag = '[object Number]', $fba35811d6335abb$var$regexpTag = '[object RegExp]', $fba35811d6335abb$var$setTag = '[object Set]', $fba35811d6335abb$var$stringTag = '[object String]', $fba35811d6335abb$var$symbolTag = '[object Symbol]';
var $fba35811d6335abb$var$arrayBufferTag = '[object ArrayBuffer]', $fba35811d6335abb$var$dataViewTag = '[object DataView]', $fba35811d6335abb$var$float32Tag = '[object Float32Array]', $fba35811d6335abb$var$float64Tag = '[object Float64Array]', $fba35811d6335abb$var$int8Tag = '[object Int8Array]', $fba35811d6335abb$var$int16Tag = '[object Int16Array]', $fba35811d6335abb$var$int32Tag = '[object Int32Array]', $fba35811d6335abb$var$uint8Tag = '[object Uint8Array]', $fba35811d6335abb$var$uint8ClampedTag = '[object Uint8ClampedArray]', $fba35811d6335abb$var$uint16Tag = '[object Uint16Array]', $fba35811d6335abb$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $fba35811d6335abb$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $fba35811d6335abb$var$arrayBufferTag:
            return (0, $dHNs8.default)(object);
        case $fba35811d6335abb$var$boolTag:
        case $fba35811d6335abb$var$dateTag:
            return new Ctor(+object);
        case $fba35811d6335abb$var$dataViewTag:
            return (0, $3cCc2.default)(object, isDeep);
        case $fba35811d6335abb$var$float32Tag:
        case $fba35811d6335abb$var$float64Tag:
        case $fba35811d6335abb$var$int8Tag:
        case $fba35811d6335abb$var$int16Tag:
        case $fba35811d6335abb$var$int32Tag:
        case $fba35811d6335abb$var$uint8Tag:
        case $fba35811d6335abb$var$uint8ClampedTag:
        case $fba35811d6335abb$var$uint16Tag:
        case $fba35811d6335abb$var$uint32Tag:
            return (0, $ji7F8.default)(object, isDeep);
        case $fba35811d6335abb$var$mapTag:
            return new Ctor;
        case $fba35811d6335abb$var$numberTag:
        case $fba35811d6335abb$var$stringTag:
            return new Ctor(object);
        case $fba35811d6335abb$var$regexpTag:
            return (0, $d9E6g.default)(object);
        case $fba35811d6335abb$var$setTag:
            return new Ctor;
        case $fba35811d6335abb$var$symbolTag:
            return (0, $lfP7M.default)(object);
    }
}
var $fba35811d6335abb$export$2e2bcd8739ae039 = $fba35811d6335abb$var$initCloneByTag;

});
parcelRegister("dHNs8", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fa5a6ce6bedeb19$export$2e2bcd8739ae039);

var $iwkKj = parcelRequire("iwkKj");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $9fa5a6ce6bedeb19$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new (0, $iwkKj.default)(result).set(new (0, $iwkKj.default)(arrayBuffer));
    return result;
}
var $9fa5a6ce6bedeb19$export$2e2bcd8739ae039 = $9fa5a6ce6bedeb19$var$cloneArrayBuffer;

});
parcelRegister("iwkKj", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7bb4edf6850e70d$export$2e2bcd8739ae039);

var $fRXcK = parcelRequire("fRXcK");
/** Built-in value references. */ var $d7bb4edf6850e70d$var$Uint8Array = (0, $fRXcK.default).Uint8Array;
var $d7bb4edf6850e70d$export$2e2bcd8739ae039 = $d7bb4edf6850e70d$var$Uint8Array;

});


parcelRegister("3cCc2", function(module, exports) {

$parcel$export(module.exports, "default", () => $25501e6e6f11ca9a$export$2e2bcd8739ae039);

var $dHNs8 = parcelRequire("dHNs8");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $25501e6e6f11ca9a$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? (0, $dHNs8.default)(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
var $25501e6e6f11ca9a$export$2e2bcd8739ae039 = $25501e6e6f11ca9a$var$cloneDataView;

});

parcelRegister("d9E6g", function(module, exports) {

$parcel$export(module.exports, "default", () => $993b38ade2f79fde$export$2e2bcd8739ae039);
/** Used to match `RegExp` flags from their coerced string values. */ var $993b38ade2f79fde$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $993b38ade2f79fde$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $993b38ade2f79fde$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
var $993b38ade2f79fde$export$2e2bcd8739ae039 = $993b38ade2f79fde$var$cloneRegExp;

});

parcelRegister("lfP7M", function(module, exports) {

$parcel$export(module.exports, "default", () => $f792a7f29df71491$export$2e2bcd8739ae039);

var $aYS7m = parcelRequire("aYS7m");
/** Used to convert symbols to primitives and strings. */ var $f792a7f29df71491$var$symbolProto = (0, $aYS7m.default) ? (0, $aYS7m.default).prototype : undefined, $f792a7f29df71491$var$symbolValueOf = $f792a7f29df71491$var$symbolProto ? $f792a7f29df71491$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $f792a7f29df71491$var$cloneSymbol(symbol) {
    return $f792a7f29df71491$var$symbolValueOf ? Object($f792a7f29df71491$var$symbolValueOf.call(symbol)) : {};
}
var $f792a7f29df71491$export$2e2bcd8739ae039 = $f792a7f29df71491$var$cloneSymbol;

});

parcelRegister("ji7F8", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0b5a45c50fd41c2$export$2e2bcd8739ae039);

var $dHNs8 = parcelRequire("dHNs8");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $e0b5a45c50fd41c2$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? (0, $dHNs8.default)(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
var $e0b5a45c50fd41c2$export$2e2bcd8739ae039 = $e0b5a45c50fd41c2$var$cloneTypedArray;

});


parcelRegister("kraA4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee0e895e26f45914$export$2e2bcd8739ae039);

var $6PSm0 = parcelRequire("6PSm0");

var $dkTWv = parcelRequire("dkTWv");

var $dU0PL = parcelRequire("dU0PL");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $ee0e895e26f45914$var$initCloneObject(object) {
    return typeof object.constructor == 'function' && !(0, $dU0PL.default)(object) ? (0, $6PSm0.default)((0, $dkTWv.default)(object)) : {};
}
var $ee0e895e26f45914$export$2e2bcd8739ae039 = $ee0e895e26f45914$var$initCloneObject;

});
parcelRegister("6PSm0", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fa1ab0ddeec3062$export$2e2bcd8739ae039);

var $frrTq = parcelRequire("frrTq");
/** Built-in value references. */ var $4fa1ab0ddeec3062$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $4fa1ab0ddeec3062$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!(0, $frrTq.default)(proto)) return {};
        if ($4fa1ab0ddeec3062$var$objectCreate) return $4fa1ab0ddeec3062$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
var $4fa1ab0ddeec3062$export$2e2bcd8739ae039 = $4fa1ab0ddeec3062$var$baseCreate;

});


parcelRegister("9pyJg", function(module, exports) {

$parcel$export(module.exports, "default", () => $6da16355e5b791d2$export$2e2bcd8739ae039);

var $262q8 = parcelRequire("262q8");

var $a1upq = parcelRequire("a1upq");

var $1wE0y = parcelRequire("1wE0y");
/* Node.js helper references. */ var $6da16355e5b791d2$var$nodeIsMap = (0, $1wE0y.default) && (0, $1wE0y.default).isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $6da16355e5b791d2$var$isMap = $6da16355e5b791d2$var$nodeIsMap ? (0, $a1upq.default)($6da16355e5b791d2$var$nodeIsMap) : (0, $262q8.default);
var $6da16355e5b791d2$export$2e2bcd8739ae039 = $6da16355e5b791d2$var$isMap;

});
parcelRegister("262q8", function(module, exports) {

$parcel$export(module.exports, "default", () => $186e04f8c1c2a2ec$export$2e2bcd8739ae039);

var $gbHlz = parcelRequire("gbHlz");

var $da1Ti = parcelRequire("da1Ti");
/** `Object#toString` result references. */ var $186e04f8c1c2a2ec$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $186e04f8c1c2a2ec$var$baseIsMap(value) {
    return (0, $da1Ti.default)(value) && (0, $gbHlz.default)(value) == $186e04f8c1c2a2ec$var$mapTag;
}
var $186e04f8c1c2a2ec$export$2e2bcd8739ae039 = $186e04f8c1c2a2ec$var$baseIsMap;

});


parcelRegister("19too", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d6d6e6fca5822f7$export$2e2bcd8739ae039);

var $lqe6R = parcelRequire("lqe6R");

var $a1upq = parcelRequire("a1upq");

var $1wE0y = parcelRequire("1wE0y");
/* Node.js helper references. */ var $0d6d6e6fca5822f7$var$nodeIsSet = (0, $1wE0y.default) && (0, $1wE0y.default).isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $0d6d6e6fca5822f7$var$isSet = $0d6d6e6fca5822f7$var$nodeIsSet ? (0, $a1upq.default)($0d6d6e6fca5822f7$var$nodeIsSet) : (0, $lqe6R.default);
var $0d6d6e6fca5822f7$export$2e2bcd8739ae039 = $0d6d6e6fca5822f7$var$isSet;

});
parcelRegister("lqe6R", function(module, exports) {

$parcel$export(module.exports, "default", () => $f986f8946c013d91$export$2e2bcd8739ae039);

var $gbHlz = parcelRequire("gbHlz");

var $da1Ti = parcelRequire("da1Ti");
/** `Object#toString` result references. */ var $f986f8946c013d91$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $f986f8946c013d91$var$baseIsSet(value) {
    return (0, $da1Ti.default)(value) && (0, $gbHlz.default)(value) == $f986f8946c013d91$var$setTag;
}
var $f986f8946c013d91$export$2e2bcd8739ae039 = $f986f8946c013d91$var$baseIsSet;

});




parcelRegister("gtGaO", function(module, exports) {
'use strict';
var $bff0118810130a42$var$isArray = Array.isArray;
var $bff0118810130a42$var$keyList = Object.keys;
var $bff0118810130a42$var$hasProp = Object.prototype.hasOwnProperty;
var $bff0118810130a42$var$hasElementType = typeof Element !== 'undefined';
function $bff0118810130a42$var$equal(a, b) {
    // fast-deep-equal index.js 2.0.1
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        var arrA = $bff0118810130a42$var$isArray(a), arrB = $bff0118810130a42$var$isArray(b), i, length, key;
        if (arrA && arrB) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$bff0118810130a42$var$equal(a[i], b[i])) return false;
            return true;
        }
        if (arrA != arrB) return false;
        var dateA = a instanceof Date, dateB = b instanceof Date;
        if (dateA != dateB) return false;
        if (dateA && dateB) return a.getTime() == b.getTime();
        var regexpA = a instanceof RegExp, regexpB = b instanceof RegExp;
        if (regexpA != regexpB) return false;
        if (regexpA && regexpB) return a.toString() == b.toString();
        var keys = $bff0118810130a42$var$keyList(a);
        length = keys.length;
        if (length !== $bff0118810130a42$var$keyList(b).length) return false;
        for(i = length; i-- !== 0;)if (!$bff0118810130a42$var$hasProp.call(b, keys[i])) return false;
        // end fast-deep-equal
        // start react-fast-compare
        // custom handling for DOM elements
        if ($bff0118810130a42$var$hasElementType && a instanceof Element && b instanceof Element) return a === b;
        // custom handling for React
        for(i = length; i-- !== 0;){
            key = keys[i];
            if (key === '_owner' && a.$$typeof) continue;
            else {
                // all other properties should be traversed as usual
                if (!$bff0118810130a42$var$equal(a[key], b[key])) return false;
            }
        }
        // end react-fast-compare
        // fast-deep-equal index.js 2.0.1
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function exportedEqual(a, b) {
    try {
        return $bff0118810130a42$var$equal(a, b);
    } catch (error) {
        if (error.message && error.message.match(/stack|recursion/i) || error.number === -2146828260) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});

parcelRegister("gRx9P", function(module, exports) {

$parcel$export(module.exports, "default", () => $c46b50f7a2993a99$export$2e2bcd8739ae039);
var $c46b50f7a2993a99$var$isProduction = true;
function $c46b50f7a2993a99$var$warning(condition, message) {
    if (!$c46b50f7a2993a99$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== 'undefined') console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $c46b50f7a2993a99$export$2e2bcd8739ae039 = $c46b50f7a2993a99$var$warning;

});

parcelRegister("1jWfM", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f64c0bf81a62130$export$2e2bcd8739ae039);

var $k0qEi = parcelRequire("k0qEi");
/** Used to compose bitmasks for cloning. */ var $0f64c0bf81a62130$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */ function $0f64c0bf81a62130$var$clone(value) {
    return (0, $k0qEi.default)(value, $0f64c0bf81a62130$var$CLONE_SYMBOLS_FLAG);
}
var $0f64c0bf81a62130$export$2e2bcd8739ae039 = $0f64c0bf81a62130$var$clone;

});

parcelRegister("gEK22", function(module, exports) {

$parcel$export(module.exports, "default", () => $0321192409cd131f$export$2e2bcd8739ae039);

var $2t6z1 = parcelRequire("2t6z1");

var $h3wcn = parcelRequire("h3wcn");

var $5yaQN = parcelRequire("5yaQN");

var $ezQL1 = parcelRequire("ezQL1");

var $43jPC = parcelRequire("43jPC");

var $4MtJK = parcelRequire("4MtJK");

var $cJCTt = parcelRequire("cJCTt");
/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */ function $0321192409cd131f$var$toPath(value) {
    if ((0, $5yaQN.default)(value)) return (0, $2t6z1.default)(value, (0, $4MtJK.default));
    return (0, $ezQL1.default)(value) ? [
        value
    ] : (0, $h3wcn.default)((0, $43jPC.default)((0, $cJCTt.default)(value)));
}
var $0321192409cd131f$export$2e2bcd8739ae039 = $0321192409cd131f$var$toPath;

});
parcelRegister("2t6z1", function(module, exports) {

$parcel$export(module.exports, "default", () => $1cc361a78917bf93$export$2e2bcd8739ae039);
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $1cc361a78917bf93$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
var $1cc361a78917bf93$export$2e2bcd8739ae039 = $1cc361a78917bf93$var$arrayMap;

});

parcelRegister("ezQL1", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9cd42161855db0d$export$2e2bcd8739ae039);

var $8X3vt = parcelRequire("8X3vt");

var $da1Ti = parcelRequire("da1Ti");
/** `Object#toString` result references. */ var $a9cd42161855db0d$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $a9cd42161855db0d$var$isSymbol(value) {
    return typeof value == 'symbol' || (0, $da1Ti.default)(value) && (0, $8X3vt.default)(value) == $a9cd42161855db0d$var$symbolTag;
}
var $a9cd42161855db0d$export$2e2bcd8739ae039 = $a9cd42161855db0d$var$isSymbol;

});

parcelRegister("43jPC", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f36d35e51d6821a$export$2e2bcd8739ae039);

var $adSRj = parcelRequire("adSRj");
/** Used to match property names within property paths. */ var $2f36d35e51d6821a$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $2f36d35e51d6821a$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $2f36d35e51d6821a$var$stringToPath = (0, $adSRj.default)(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($2f36d35e51d6821a$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($2f36d35e51d6821a$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
var $2f36d35e51d6821a$export$2e2bcd8739ae039 = $2f36d35e51d6821a$var$stringToPath;

});
parcelRegister("adSRj", function(module, exports) {

$parcel$export(module.exports, "default", () => $7715ac1b7b976a71$export$2e2bcd8739ae039);

var $fIPbB = parcelRequire("fIPbB");
/** Used as the maximum memoize cache size. */ var $7715ac1b7b976a71$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $7715ac1b7b976a71$var$memoizeCapped(func) {
    var result = (0, $fIPbB.default)(func, function(key) {
        if (cache.size === $7715ac1b7b976a71$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
var $7715ac1b7b976a71$export$2e2bcd8739ae039 = $7715ac1b7b976a71$var$memoizeCapped;

});
parcelRegister("fIPbB", function(module, exports) {

$parcel$export(module.exports, "default", () => $b722ab918bf9f4f5$export$2e2bcd8739ae039);

var $cPIJw = parcelRequire("cPIJw");
/** Error message constants. */ var $b722ab918bf9f4f5$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $b722ab918bf9f4f5$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($b722ab918bf9f4f5$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($b722ab918bf9f4f5$var$memoize.Cache || (0, $cPIJw.default));
    return memoized;
}
// Expose `MapCache`.
$b722ab918bf9f4f5$var$memoize.Cache = (0, $cPIJw.default);
var $b722ab918bf9f4f5$export$2e2bcd8739ae039 = $b722ab918bf9f4f5$var$memoize;

});



parcelRegister("4MtJK", function(module, exports) {

$parcel$export(module.exports, "default", () => $37b2b63aca8e513d$export$2e2bcd8739ae039);

var $ezQL1 = parcelRequire("ezQL1");
/** Used as references for various `Number` constants. */ var $37b2b63aca8e513d$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $37b2b63aca8e513d$var$toKey(value) {
    if (typeof value == 'string' || (0, $ezQL1.default)(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$37b2b63aca8e513d$var$INFINITY ? '-0' : result;
}
var $37b2b63aca8e513d$export$2e2bcd8739ae039 = $37b2b63aca8e513d$var$toKey;

});

parcelRegister("cJCTt", function(module, exports) {

$parcel$export(module.exports, "default", () => $9457db7e2e078153$export$2e2bcd8739ae039);

var $lmBhJ = parcelRequire("lmBhJ");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $9457db7e2e078153$var$toString(value) {
    return value == null ? '' : (0, $lmBhJ.default)(value);
}
var $9457db7e2e078153$export$2e2bcd8739ae039 = $9457db7e2e078153$var$toString;

});
parcelRegister("lmBhJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8d893110632a9ac$export$2e2bcd8739ae039);

var $aYS7m = parcelRequire("aYS7m");

var $2t6z1 = parcelRequire("2t6z1");

var $5yaQN = parcelRequire("5yaQN");

var $ezQL1 = parcelRequire("ezQL1");
/** Used as references for various `Number` constants. */ var $f8d893110632a9ac$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $f8d893110632a9ac$var$symbolProto = (0, $aYS7m.default) ? (0, $aYS7m.default).prototype : undefined, $f8d893110632a9ac$var$symbolToString = $f8d893110632a9ac$var$symbolProto ? $f8d893110632a9ac$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $f8d893110632a9ac$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ((0, $5yaQN.default)(value)) // Recursively convert values (susceptible to call stack limits).
    return (0, $2t6z1.default)(value, $f8d893110632a9ac$var$baseToString) + '';
    if ((0, $ezQL1.default)(value)) return $f8d893110632a9ac$var$symbolToString ? $f8d893110632a9ac$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$f8d893110632a9ac$var$INFINITY ? '-0' : result;
}
var $f8d893110632a9ac$export$2e2bcd8739ae039 = $f8d893110632a9ac$var$baseToString;

});



parcelRegister("7g5pF", function(module, exports) {
'use strict';

var $5M4sD = parcelRequire("5M4sD");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $548e39f24abb922b$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $548e39f24abb922b$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $548e39f24abb922b$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $548e39f24abb922b$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $548e39f24abb922b$var$TYPE_STATICS = {};
$548e39f24abb922b$var$TYPE_STATICS[$5M4sD.ForwardRef] = $548e39f24abb922b$var$FORWARD_REF_STATICS;
$548e39f24abb922b$var$TYPE_STATICS[$5M4sD.Memo] = $548e39f24abb922b$var$MEMO_STATICS;
function $548e39f24abb922b$var$getStatics(component) {
    // React v16.11 and below
    if ($5M4sD.isMemo(component)) return $548e39f24abb922b$var$MEMO_STATICS;
     // React v16.12 and above
    return $548e39f24abb922b$var$TYPE_STATICS[component['$$typeof']] || $548e39f24abb922b$var$REACT_STATICS;
}
var $548e39f24abb922b$var$defineProperty = Object.defineProperty;
var $548e39f24abb922b$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $548e39f24abb922b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $548e39f24abb922b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $548e39f24abb922b$var$getPrototypeOf = Object.getPrototypeOf;
var $548e39f24abb922b$var$objectPrototype = Object.prototype;
function $548e39f24abb922b$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($548e39f24abb922b$var$objectPrototype) {
            var inheritedComponent = $548e39f24abb922b$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $548e39f24abb922b$var$objectPrototype) $548e39f24abb922b$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $548e39f24abb922b$var$getOwnPropertyNames(sourceComponent);
        if ($548e39f24abb922b$var$getOwnPropertySymbols) keys = keys.concat($548e39f24abb922b$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $548e39f24abb922b$var$getStatics(targetComponent);
        var sourceStatics = $548e39f24abb922b$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$548e39f24abb922b$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $548e39f24abb922b$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $548e39f24abb922b$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $548e39f24abb922b$var$hoistNonReactStatics;

});
parcelRegister("5M4sD", function(module, exports) {
'use strict';

module.exports = (parcelRequire("bR9Ya"));

});



parcelRegister("lb2du", function(module, exports) {

/*!
 * Chart.js v2.9.4
 * https://www.chartjs.org
 * (c) 2020 Chart.js Contributors
 * Released under the MIT License
 */ (function(global, factory) {
    module.exports = factory(function() {
        try {
            return (parcelRequire("ejSM7"));
        } catch (e) {}
    }());
})(module.exports, function(moment) {
    'use strict';
    moment = moment && moment.hasOwnProperty('default') ? moment['default'] : moment;
    function createCommonjsModule(fn, module1) {
        return module1 = {
            exports: {}
        }, fn(module1, module1.exports), module1.exports;
    }
    function getCjsExportFromNamespace(n) {
        return n && n['default'] || n;
    }
    var colorName = {
        "aliceblue": [
            240,
            248,
            255
        ],
        "antiquewhite": [
            250,
            235,
            215
        ],
        "aqua": [
            0,
            255,
            255
        ],
        "aquamarine": [
            127,
            255,
            212
        ],
        "azure": [
            240,
            255,
            255
        ],
        "beige": [
            245,
            245,
            220
        ],
        "bisque": [
            255,
            228,
            196
        ],
        "black": [
            0,
            0,
            0
        ],
        "blanchedalmond": [
            255,
            235,
            205
        ],
        "blue": [
            0,
            0,
            255
        ],
        "blueviolet": [
            138,
            43,
            226
        ],
        "brown": [
            165,
            42,
            42
        ],
        "burlywood": [
            222,
            184,
            135
        ],
        "cadetblue": [
            95,
            158,
            160
        ],
        "chartreuse": [
            127,
            255,
            0
        ],
        "chocolate": [
            210,
            105,
            30
        ],
        "coral": [
            255,
            127,
            80
        ],
        "cornflowerblue": [
            100,
            149,
            237
        ],
        "cornsilk": [
            255,
            248,
            220
        ],
        "crimson": [
            220,
            20,
            60
        ],
        "cyan": [
            0,
            255,
            255
        ],
        "darkblue": [
            0,
            0,
            139
        ],
        "darkcyan": [
            0,
            139,
            139
        ],
        "darkgoldenrod": [
            184,
            134,
            11
        ],
        "darkgray": [
            169,
            169,
            169
        ],
        "darkgreen": [
            0,
            100,
            0
        ],
        "darkgrey": [
            169,
            169,
            169
        ],
        "darkkhaki": [
            189,
            183,
            107
        ],
        "darkmagenta": [
            139,
            0,
            139
        ],
        "darkolivegreen": [
            85,
            107,
            47
        ],
        "darkorange": [
            255,
            140,
            0
        ],
        "darkorchid": [
            153,
            50,
            204
        ],
        "darkred": [
            139,
            0,
            0
        ],
        "darksalmon": [
            233,
            150,
            122
        ],
        "darkseagreen": [
            143,
            188,
            143
        ],
        "darkslateblue": [
            72,
            61,
            139
        ],
        "darkslategray": [
            47,
            79,
            79
        ],
        "darkslategrey": [
            47,
            79,
            79
        ],
        "darkturquoise": [
            0,
            206,
            209
        ],
        "darkviolet": [
            148,
            0,
            211
        ],
        "deeppink": [
            255,
            20,
            147
        ],
        "deepskyblue": [
            0,
            191,
            255
        ],
        "dimgray": [
            105,
            105,
            105
        ],
        "dimgrey": [
            105,
            105,
            105
        ],
        "dodgerblue": [
            30,
            144,
            255
        ],
        "firebrick": [
            178,
            34,
            34
        ],
        "floralwhite": [
            255,
            250,
            240
        ],
        "forestgreen": [
            34,
            139,
            34
        ],
        "fuchsia": [
            255,
            0,
            255
        ],
        "gainsboro": [
            220,
            220,
            220
        ],
        "ghostwhite": [
            248,
            248,
            255
        ],
        "gold": [
            255,
            215,
            0
        ],
        "goldenrod": [
            218,
            165,
            32
        ],
        "gray": [
            128,
            128,
            128
        ],
        "green": [
            0,
            128,
            0
        ],
        "greenyellow": [
            173,
            255,
            47
        ],
        "grey": [
            128,
            128,
            128
        ],
        "honeydew": [
            240,
            255,
            240
        ],
        "hotpink": [
            255,
            105,
            180
        ],
        "indianred": [
            205,
            92,
            92
        ],
        "indigo": [
            75,
            0,
            130
        ],
        "ivory": [
            255,
            255,
            240
        ],
        "khaki": [
            240,
            230,
            140
        ],
        "lavender": [
            230,
            230,
            250
        ],
        "lavenderblush": [
            255,
            240,
            245
        ],
        "lawngreen": [
            124,
            252,
            0
        ],
        "lemonchiffon": [
            255,
            250,
            205
        ],
        "lightblue": [
            173,
            216,
            230
        ],
        "lightcoral": [
            240,
            128,
            128
        ],
        "lightcyan": [
            224,
            255,
            255
        ],
        "lightgoldenrodyellow": [
            250,
            250,
            210
        ],
        "lightgray": [
            211,
            211,
            211
        ],
        "lightgreen": [
            144,
            238,
            144
        ],
        "lightgrey": [
            211,
            211,
            211
        ],
        "lightpink": [
            255,
            182,
            193
        ],
        "lightsalmon": [
            255,
            160,
            122
        ],
        "lightseagreen": [
            32,
            178,
            170
        ],
        "lightskyblue": [
            135,
            206,
            250
        ],
        "lightslategray": [
            119,
            136,
            153
        ],
        "lightslategrey": [
            119,
            136,
            153
        ],
        "lightsteelblue": [
            176,
            196,
            222
        ],
        "lightyellow": [
            255,
            255,
            224
        ],
        "lime": [
            0,
            255,
            0
        ],
        "limegreen": [
            50,
            205,
            50
        ],
        "linen": [
            250,
            240,
            230
        ],
        "magenta": [
            255,
            0,
            255
        ],
        "maroon": [
            128,
            0,
            0
        ],
        "mediumaquamarine": [
            102,
            205,
            170
        ],
        "mediumblue": [
            0,
            0,
            205
        ],
        "mediumorchid": [
            186,
            85,
            211
        ],
        "mediumpurple": [
            147,
            112,
            219
        ],
        "mediumseagreen": [
            60,
            179,
            113
        ],
        "mediumslateblue": [
            123,
            104,
            238
        ],
        "mediumspringgreen": [
            0,
            250,
            154
        ],
        "mediumturquoise": [
            72,
            209,
            204
        ],
        "mediumvioletred": [
            199,
            21,
            133
        ],
        "midnightblue": [
            25,
            25,
            112
        ],
        "mintcream": [
            245,
            255,
            250
        ],
        "mistyrose": [
            255,
            228,
            225
        ],
        "moccasin": [
            255,
            228,
            181
        ],
        "navajowhite": [
            255,
            222,
            173
        ],
        "navy": [
            0,
            0,
            128
        ],
        "oldlace": [
            253,
            245,
            230
        ],
        "olive": [
            128,
            128,
            0
        ],
        "olivedrab": [
            107,
            142,
            35
        ],
        "orange": [
            255,
            165,
            0
        ],
        "orangered": [
            255,
            69,
            0
        ],
        "orchid": [
            218,
            112,
            214
        ],
        "palegoldenrod": [
            238,
            232,
            170
        ],
        "palegreen": [
            152,
            251,
            152
        ],
        "paleturquoise": [
            175,
            238,
            238
        ],
        "palevioletred": [
            219,
            112,
            147
        ],
        "papayawhip": [
            255,
            239,
            213
        ],
        "peachpuff": [
            255,
            218,
            185
        ],
        "peru": [
            205,
            133,
            63
        ],
        "pink": [
            255,
            192,
            203
        ],
        "plum": [
            221,
            160,
            221
        ],
        "powderblue": [
            176,
            224,
            230
        ],
        "purple": [
            128,
            0,
            128
        ],
        "rebeccapurple": [
            102,
            51,
            153
        ],
        "red": [
            255,
            0,
            0
        ],
        "rosybrown": [
            188,
            143,
            143
        ],
        "royalblue": [
            65,
            105,
            225
        ],
        "saddlebrown": [
            139,
            69,
            19
        ],
        "salmon": [
            250,
            128,
            114
        ],
        "sandybrown": [
            244,
            164,
            96
        ],
        "seagreen": [
            46,
            139,
            87
        ],
        "seashell": [
            255,
            245,
            238
        ],
        "sienna": [
            160,
            82,
            45
        ],
        "silver": [
            192,
            192,
            192
        ],
        "skyblue": [
            135,
            206,
            235
        ],
        "slateblue": [
            106,
            90,
            205
        ],
        "slategray": [
            112,
            128,
            144
        ],
        "slategrey": [
            112,
            128,
            144
        ],
        "snow": [
            255,
            250,
            250
        ],
        "springgreen": [
            0,
            255,
            127
        ],
        "steelblue": [
            70,
            130,
            180
        ],
        "tan": [
            210,
            180,
            140
        ],
        "teal": [
            0,
            128,
            128
        ],
        "thistle": [
            216,
            191,
            216
        ],
        "tomato": [
            255,
            99,
            71
        ],
        "turquoise": [
            64,
            224,
            208
        ],
        "violet": [
            238,
            130,
            238
        ],
        "wheat": [
            245,
            222,
            179
        ],
        "white": [
            255,
            255,
            255
        ],
        "whitesmoke": [
            245,
            245,
            245
        ],
        "yellow": [
            255,
            255,
            0
        ],
        "yellowgreen": [
            154,
            205,
            50
        ]
    };
    var conversions = createCommonjsModule(function(module1) {
        /* MIT license */ // NOTE: conversions should only return primitive values (i.e. arrays, or
        //       values that give correct `typeof` results).
        //       do not use box values types (i.e. Number(), String(), etc.)
        var reverseKeywords = {};
        for(var key in colorName)if (colorName.hasOwnProperty(key)) reverseKeywords[colorName[key]] = key;
        var convert = module1.exports = {
            rgb: {
                channels: 3,
                labels: 'rgb'
            },
            hsl: {
                channels: 3,
                labels: 'hsl'
            },
            hsv: {
                channels: 3,
                labels: 'hsv'
            },
            hwb: {
                channels: 3,
                labels: 'hwb'
            },
            cmyk: {
                channels: 4,
                labels: 'cmyk'
            },
            xyz: {
                channels: 3,
                labels: 'xyz'
            },
            lab: {
                channels: 3,
                labels: 'lab'
            },
            lch: {
                channels: 3,
                labels: 'lch'
            },
            hex: {
                channels: 1,
                labels: [
                    'hex'
                ]
            },
            keyword: {
                channels: 1,
                labels: [
                    'keyword'
                ]
            },
            ansi16: {
                channels: 1,
                labels: [
                    'ansi16'
                ]
            },
            ansi256: {
                channels: 1,
                labels: [
                    'ansi256'
                ]
            },
            hcg: {
                channels: 3,
                labels: [
                    'h',
                    'c',
                    'g'
                ]
            },
            apple: {
                channels: 3,
                labels: [
                    'r16',
                    'g16',
                    'b16'
                ]
            },
            gray: {
                channels: 1,
                labels: [
                    'gray'
                ]
            }
        };
        // hide .channels and .labels properties
        for(var model in convert)if (convert.hasOwnProperty(model)) {
            if (!('channels' in convert[model])) throw new Error('missing channels property: ' + model);
            if (!('labels' in convert[model])) throw new Error('missing channel labels property: ' + model);
            if (convert[model].labels.length !== convert[model].channels) throw new Error('channel and label counts mismatch: ' + model);
            var channels = convert[model].channels;
            var labels = convert[model].labels;
            delete convert[model].channels;
            delete convert[model].labels;
            Object.defineProperty(convert[model], 'channels', {
                value: channels
            });
            Object.defineProperty(convert[model], 'labels', {
                value: labels
            });
        }
        convert.rgb.hsl = function(rgb) {
            var r = rgb[0] / 255;
            var g = rgb[1] / 255;
            var b = rgb[2] / 255;
            var min = Math.min(r, g, b);
            var max = Math.max(r, g, b);
            var delta = max - min;
            var h;
            var s;
            var l;
            if (max === min) h = 0;
            else if (r === max) h = (g - b) / delta;
            else if (g === max) h = 2 + (b - r) / delta;
            else if (b === max) h = 4 + (r - g) / delta;
            h = Math.min(h * 60, 360);
            if (h < 0) h += 360;
            l = (min + max) / 2;
            if (max === min) s = 0;
            else if (l <= 0.5) s = delta / (max + min);
            else s = delta / (2 - max - min);
            return [
                h,
                s * 100,
                l * 100
            ];
        };
        convert.rgb.hsv = function(rgb) {
            var rdif;
            var gdif;
            var bdif;
            var h;
            var s;
            var r = rgb[0] / 255;
            var g = rgb[1] / 255;
            var b = rgb[2] / 255;
            var v = Math.max(r, g, b);
            var diff = v - Math.min(r, g, b);
            var diffc = function(c) {
                return (v - c) / 6 / diff + 0.5;
            };
            if (diff === 0) h = s = 0;
            else {
                s = diff / v;
                rdif = diffc(r);
                gdif = diffc(g);
                bdif = diffc(b);
                if (r === v) h = bdif - gdif;
                else if (g === v) h = 1 / 3 + rdif - bdif;
                else if (b === v) h = 2 / 3 + gdif - rdif;
                if (h < 0) h += 1;
                else if (h > 1) h -= 1;
            }
            return [
                h * 360,
                s * 100,
                v * 100
            ];
        };
        convert.rgb.hwb = function(rgb) {
            var r = rgb[0];
            var g = rgb[1];
            var b = rgb[2];
            var h = convert.rgb.hsl(rgb)[0];
            var w = 1 / 255 * Math.min(r, Math.min(g, b));
            b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));
            return [
                h,
                w * 100,
                b * 100
            ];
        };
        convert.rgb.cmyk = function(rgb) {
            var r = rgb[0] / 255;
            var g = rgb[1] / 255;
            var b = rgb[2] / 255;
            var c;
            var m;
            var y;
            var k;
            k = Math.min(1 - r, 1 - g, 1 - b);
            c = (1 - r - k) / (1 - k) || 0;
            m = (1 - g - k) / (1 - k) || 0;
            y = (1 - b - k) / (1 - k) || 0;
            return [
                c * 100,
                m * 100,
                y * 100,
                k * 100
            ];
        };
        /**
 * See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
 * */ function comparativeDistance(x, y) {
            return Math.pow(x[0] - y[0], 2) + Math.pow(x[1] - y[1], 2) + Math.pow(x[2] - y[2], 2);
        }
        convert.rgb.keyword = function(rgb) {
            var reversed = reverseKeywords[rgb];
            if (reversed) return reversed;
            var currentClosestDistance = Infinity;
            var currentClosestKeyword;
            for(var keyword in colorName)if (colorName.hasOwnProperty(keyword)) {
                var value = colorName[keyword];
                // Compute comparative distance
                var distance = comparativeDistance(rgb, value);
                // Check if its less, if so set as closest
                if (distance < currentClosestDistance) {
                    currentClosestDistance = distance;
                    currentClosestKeyword = keyword;
                }
            }
            return currentClosestKeyword;
        };
        convert.keyword.rgb = function(keyword) {
            return colorName[keyword];
        };
        convert.rgb.xyz = function(rgb) {
            var r = rgb[0] / 255;
            var g = rgb[1] / 255;
            var b = rgb[2] / 255;
            // assume sRGB
            r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
            g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
            b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
            var x = r * 0.4124 + g * 0.3576 + b * 0.1805;
            var y = r * 0.2126 + g * 0.7152 + b * 0.0722;
            var z = r * 0.0193 + g * 0.1192 + b * 0.9505;
            return [
                x * 100,
                y * 100,
                z * 100
            ];
        };
        convert.rgb.lab = function(rgb) {
            var xyz = convert.rgb.xyz(rgb);
            var x = xyz[0];
            var y = xyz[1];
            var z = xyz[2];
            var l;
            var a;
            var b;
            x /= 95.047;
            y /= 100;
            z /= 108.883;
            x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
            y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
            z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
            l = 116 * y - 16;
            a = 500 * (x - y);
            b = 200 * (y - z);
            return [
                l,
                a,
                b
            ];
        };
        convert.hsl.rgb = function(hsl) {
            var h = hsl[0] / 360;
            var s = hsl[1] / 100;
            var l = hsl[2] / 100;
            var t1;
            var t2;
            var t3;
            var rgb;
            var val;
            if (s === 0) {
                val = l * 255;
                return [
                    val,
                    val,
                    val
                ];
            }
            if (l < 0.5) t2 = l * (1 + s);
            else t2 = l + s - l * s;
            t1 = 2 * l - t2;
            rgb = [
                0,
                0,
                0
            ];
            for(var i = 0; i < 3; i++){
                t3 = h + 1 / 3 * -(i - 1);
                if (t3 < 0) t3++;
                if (t3 > 1) t3--;
                if (6 * t3 < 1) val = t1 + (t2 - t1) * 6 * t3;
                else if (2 * t3 < 1) val = t2;
                else if (3 * t3 < 2) val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
                else val = t1;
                rgb[i] = val * 255;
            }
            return rgb;
        };
        convert.hsl.hsv = function(hsl) {
            var h = hsl[0];
            var s = hsl[1] / 100;
            var l = hsl[2] / 100;
            var smin = s;
            var lmin = Math.max(l, 0.01);
            var sv;
            var v;
            l *= 2;
            s *= l <= 1 ? l : 2 - l;
            smin *= lmin <= 1 ? lmin : 2 - lmin;
            v = (l + s) / 2;
            sv = l === 0 ? 2 * smin / (lmin + smin) : 2 * s / (l + s);
            return [
                h,
                sv * 100,
                v * 100
            ];
        };
        convert.hsv.rgb = function(hsv) {
            var h = hsv[0] / 60;
            var s = hsv[1] / 100;
            var v = hsv[2] / 100;
            var hi = Math.floor(h) % 6;
            var f = h - Math.floor(h);
            var p = 255 * v * (1 - s);
            var q = 255 * v * (1 - s * f);
            var t = 255 * v * (1 - s * (1 - f));
            v *= 255;
            switch(hi){
                case 0:
                    return [
                        v,
                        t,
                        p
                    ];
                case 1:
                    return [
                        q,
                        v,
                        p
                    ];
                case 2:
                    return [
                        p,
                        v,
                        t
                    ];
                case 3:
                    return [
                        p,
                        q,
                        v
                    ];
                case 4:
                    return [
                        t,
                        p,
                        v
                    ];
                case 5:
                    return [
                        v,
                        p,
                        q
                    ];
            }
        };
        convert.hsv.hsl = function(hsv) {
            var h = hsv[0];
            var s = hsv[1] / 100;
            var v = hsv[2] / 100;
            var vmin = Math.max(v, 0.01);
            var lmin;
            var sl;
            var l;
            l = (2 - s) * v;
            lmin = (2 - s) * vmin;
            sl = s * vmin;
            sl /= lmin <= 1 ? lmin : 2 - lmin;
            sl = sl || 0;
            l /= 2;
            return [
                h,
                sl * 100,
                l * 100
            ];
        };
        // http://dev.w3.org/csswg/css-color/#hwb-to-rgb
        convert.hwb.rgb = function(hwb) {
            var h = hwb[0] / 360;
            var wh = hwb[1] / 100;
            var bl = hwb[2] / 100;
            var ratio = wh + bl;
            var i;
            var v;
            var f;
            var n;
            // wh + bl cant be > 1
            if (ratio > 1) {
                wh /= ratio;
                bl /= ratio;
            }
            i = Math.floor(6 * h);
            v = 1 - bl;
            f = 6 * h - i;
            if ((i & 0x01) !== 0) f = 1 - f;
            n = wh + f * (v - wh); // linear interpolation
            var r;
            var g;
            var b;
            switch(i){
                default:
                case 6:
                case 0:
                    r = v;
                    g = n;
                    b = wh;
                    break;
                case 1:
                    r = n;
                    g = v;
                    b = wh;
                    break;
                case 2:
                    r = wh;
                    g = v;
                    b = n;
                    break;
                case 3:
                    r = wh;
                    g = n;
                    b = v;
                    break;
                case 4:
                    r = n;
                    g = wh;
                    b = v;
                    break;
                case 5:
                    r = v;
                    g = wh;
                    b = n;
                    break;
            }
            return [
                r * 255,
                g * 255,
                b * 255
            ];
        };
        convert.cmyk.rgb = function(cmyk) {
            var c = cmyk[0] / 100;
            var m = cmyk[1] / 100;
            var y = cmyk[2] / 100;
            var k = cmyk[3] / 100;
            var r;
            var g;
            var b;
            r = 1 - Math.min(1, c * (1 - k) + k);
            g = 1 - Math.min(1, m * (1 - k) + k);
            b = 1 - Math.min(1, y * (1 - k) + k);
            return [
                r * 255,
                g * 255,
                b * 255
            ];
        };
        convert.xyz.rgb = function(xyz) {
            var x = xyz[0] / 100;
            var y = xyz[1] / 100;
            var z = xyz[2] / 100;
            var r;
            var g;
            var b;
            r = x * 3.2406 + y * -1.5372 + z * -0.4986;
            g = x * -0.9689 + y * 1.8758 + z * 0.0415;
            b = x * 0.0557 + y * -0.204 + z * 1.0570;
            // assume sRGB
            r = r > 0.0031308 ? 1.055 * Math.pow(r, 1.0 / 2.4) - 0.055 : r * 12.92;
            g = g > 0.0031308 ? 1.055 * Math.pow(g, 1.0 / 2.4) - 0.055 : g * 12.92;
            b = b > 0.0031308 ? 1.055 * Math.pow(b, 1.0 / 2.4) - 0.055 : b * 12.92;
            r = Math.min(Math.max(0, r), 1);
            g = Math.min(Math.max(0, g), 1);
            b = Math.min(Math.max(0, b), 1);
            return [
                r * 255,
                g * 255,
                b * 255
            ];
        };
        convert.xyz.lab = function(xyz) {
            var x = xyz[0];
            var y = xyz[1];
            var z = xyz[2];
            var l;
            var a;
            var b;
            x /= 95.047;
            y /= 100;
            z /= 108.883;
            x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
            y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
            z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
            l = 116 * y - 16;
            a = 500 * (x - y);
            b = 200 * (y - z);
            return [
                l,
                a,
                b
            ];
        };
        convert.lab.xyz = function(lab) {
            var l = lab[0];
            var a = lab[1];
            var b = lab[2];
            var x;
            var y;
            var z;
            y = (l + 16) / 116;
            x = a / 500 + y;
            z = y - b / 200;
            var y2 = Math.pow(y, 3);
            var x2 = Math.pow(x, 3);
            var z2 = Math.pow(z, 3);
            y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
            x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
            z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;
            x *= 95.047;
            y *= 100;
            z *= 108.883;
            return [
                x,
                y,
                z
            ];
        };
        convert.lab.lch = function(lab) {
            var l = lab[0];
            var a = lab[1];
            var b = lab[2];
            var hr;
            var h;
            var c;
            hr = Math.atan2(b, a);
            h = hr * 360 / 2 / Math.PI;
            if (h < 0) h += 360;
            c = Math.sqrt(a * a + b * b);
            return [
                l,
                c,
                h
            ];
        };
        convert.lch.lab = function(lch) {
            var l = lch[0];
            var c = lch[1];
            var h = lch[2];
            var a;
            var b;
            var hr;
            hr = h / 360 * 2 * Math.PI;
            a = c * Math.cos(hr);
            b = c * Math.sin(hr);
            return [
                l,
                a,
                b
            ];
        };
        convert.rgb.ansi16 = function(args) {
            var r = args[0];
            var g = args[1];
            var b = args[2];
            var value = 1 in arguments ? arguments[1] : convert.rgb.hsv(args)[2]; // hsv -> ansi16 optimization
            value = Math.round(value / 50);
            if (value === 0) return 30;
            var ansi = 30 + (Math.round(b / 255) << 2 | Math.round(g / 255) << 1 | Math.round(r / 255));
            if (value === 2) ansi += 60;
            return ansi;
        };
        convert.hsv.ansi16 = function(args) {
            // optimization here; we already know the value and don't need to get
            // it converted for us.
            return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
        };
        convert.rgb.ansi256 = function(args) {
            var r = args[0];
            var g = args[1];
            var b = args[2];
            // we use the extended greyscale palette here, with the exception of
            // black and white. normal palette only has 4 greyscale shades.
            if (r === g && g === b) {
                if (r < 8) return 16;
                if (r > 248) return 231;
                return Math.round((r - 8) / 247 * 24) + 232;
            }
            var ansi = 16 + 36 * Math.round(r / 255 * 5) + 6 * Math.round(g / 255 * 5) + Math.round(b / 255 * 5);
            return ansi;
        };
        convert.ansi16.rgb = function(args) {
            var color = args % 10;
            // handle greyscale
            if (color === 0 || color === 7) {
                if (args > 50) color += 3.5;
                color = color / 10.5 * 255;
                return [
                    color,
                    color,
                    color
                ];
            }
            var mult = (~~(args > 50) + 1) * 0.5;
            var r = (color & 1) * mult * 255;
            var g = (color >> 1 & 1) * mult * 255;
            var b = (color >> 2 & 1) * mult * 255;
            return [
                r,
                g,
                b
            ];
        };
        convert.ansi256.rgb = function(args) {
            // handle greyscale
            if (args >= 232) {
                var c = (args - 232) * 10 + 8;
                return [
                    c,
                    c,
                    c
                ];
            }
            args -= 16;
            var rem;
            var r = Math.floor(args / 36) / 5 * 255;
            var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
            var b = rem % 6 / 5 * 255;
            return [
                r,
                g,
                b
            ];
        };
        convert.rgb.hex = function(args) {
            var integer = ((Math.round(args[0]) & 0xFF) << 16) + ((Math.round(args[1]) & 0xFF) << 8) + (Math.round(args[2]) & 0xFF);
            var string = integer.toString(16).toUpperCase();
            return '000000'.substring(string.length) + string;
        };
        convert.hex.rgb = function(args) {
            var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
            if (!match) return [
                0,
                0,
                0
            ];
            var colorString = match[0];
            if (match[0].length === 3) colorString = colorString.split('').map(function(char) {
                return char + char;
            }).join('');
            var integer = parseInt(colorString, 16);
            var r = integer >> 16 & 0xFF;
            var g = integer >> 8 & 0xFF;
            var b = integer & 0xFF;
            return [
                r,
                g,
                b
            ];
        };
        convert.rgb.hcg = function(rgb) {
            var r = rgb[0] / 255;
            var g = rgb[1] / 255;
            var b = rgb[2] / 255;
            var max = Math.max(Math.max(r, g), b);
            var min = Math.min(Math.min(r, g), b);
            var chroma = max - min;
            var grayscale;
            var hue;
            if (chroma < 1) grayscale = min / (1 - chroma);
            else grayscale = 0;
            if (chroma <= 0) hue = 0;
            else if (max === r) hue = (g - b) / chroma % 6;
            else if (max === g) hue = 2 + (b - r) / chroma;
            else hue = 4 + (r - g) / chroma + 4;
            hue /= 6;
            hue %= 1;
            return [
                hue * 360,
                chroma * 100,
                grayscale * 100
            ];
        };
        convert.hsl.hcg = function(hsl) {
            var s = hsl[1] / 100;
            var l = hsl[2] / 100;
            var c = 1;
            var f = 0;
            if (l < 0.5) c = 2.0 * s * l;
            else c = 2.0 * s * (1.0 - l);
            if (c < 1.0) f = (l - 0.5 * c) / (1.0 - c);
            return [
                hsl[0],
                c * 100,
                f * 100
            ];
        };
        convert.hsv.hcg = function(hsv) {
            var s = hsv[1] / 100;
            var v = hsv[2] / 100;
            var c = s * v;
            var f = 0;
            if (c < 1.0) f = (v - c) / (1 - c);
            return [
                hsv[0],
                c * 100,
                f * 100
            ];
        };
        convert.hcg.rgb = function(hcg) {
            var h = hcg[0] / 360;
            var c = hcg[1] / 100;
            var g = hcg[2] / 100;
            if (c === 0.0) return [
                g * 255,
                g * 255,
                g * 255
            ];
            var pure = [
                0,
                0,
                0
            ];
            var hi = h % 1 * 6;
            var v = hi % 1;
            var w = 1 - v;
            var mg = 0;
            switch(Math.floor(hi)){
                case 0:
                    pure[0] = 1;
                    pure[1] = v;
                    pure[2] = 0;
                    break;
                case 1:
                    pure[0] = w;
                    pure[1] = 1;
                    pure[2] = 0;
                    break;
                case 2:
                    pure[0] = 0;
                    pure[1] = 1;
                    pure[2] = v;
                    break;
                case 3:
                    pure[0] = 0;
                    pure[1] = w;
                    pure[2] = 1;
                    break;
                case 4:
                    pure[0] = v;
                    pure[1] = 0;
                    pure[2] = 1;
                    break;
                default:
                    pure[0] = 1;
                    pure[1] = 0;
                    pure[2] = w;
            }
            mg = (1.0 - c) * g;
            return [
                (c * pure[0] + mg) * 255,
                (c * pure[1] + mg) * 255,
                (c * pure[2] + mg) * 255
            ];
        };
        convert.hcg.hsv = function(hcg) {
            var c = hcg[1] / 100;
            var g = hcg[2] / 100;
            var v = c + g * (1.0 - c);
            var f = 0;
            if (v > 0.0) f = c / v;
            return [
                hcg[0],
                f * 100,
                v * 100
            ];
        };
        convert.hcg.hsl = function(hcg) {
            var c = hcg[1] / 100;
            var g = hcg[2] / 100;
            var l = g * (1.0 - c) + 0.5 * c;
            var s = 0;
            if (l > 0.0 && l < 0.5) s = c / (2 * l);
            else if (l >= 0.5 && l < 1.0) s = c / (2 * (1 - l));
            return [
                hcg[0],
                s * 100,
                l * 100
            ];
        };
        convert.hcg.hwb = function(hcg) {
            var c = hcg[1] / 100;
            var g = hcg[2] / 100;
            var v = c + g * (1.0 - c);
            return [
                hcg[0],
                (v - c) * 100,
                (1 - v) * 100
            ];
        };
        convert.hwb.hcg = function(hwb) {
            var w = hwb[1] / 100;
            var b = hwb[2] / 100;
            var v = 1 - b;
            var c = v - w;
            var g = 0;
            if (c < 1) g = (v - c) / (1 - c);
            return [
                hwb[0],
                c * 100,
                g * 100
            ];
        };
        convert.apple.rgb = function(apple) {
            return [
                apple[0] / 65535 * 255,
                apple[1] / 65535 * 255,
                apple[2] / 65535 * 255
            ];
        };
        convert.rgb.apple = function(rgb) {
            return [
                rgb[0] / 255 * 65535,
                rgb[1] / 255 * 65535,
                rgb[2] / 255 * 65535
            ];
        };
        convert.gray.rgb = function(args) {
            return [
                args[0] / 100 * 255,
                args[0] / 100 * 255,
                args[0] / 100 * 255
            ];
        };
        convert.gray.hsl = convert.gray.hsv = function(args) {
            return [
                0,
                0,
                args[0]
            ];
        };
        convert.gray.hwb = function(gray) {
            return [
                0,
                100,
                gray[0]
            ];
        };
        convert.gray.cmyk = function(gray) {
            return [
                0,
                0,
                0,
                gray[0]
            ];
        };
        convert.gray.lab = function(gray) {
            return [
                gray[0],
                0,
                0
            ];
        };
        convert.gray.hex = function(gray) {
            var val = Math.round(gray[0] / 100 * 255) & 0xFF;
            var integer = (val << 16) + (val << 8) + val;
            var string = integer.toString(16).toUpperCase();
            return '000000'.substring(string.length) + string;
        };
        convert.rgb.gray = function(rgb) {
            var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
            return [
                val / 255 * 100
            ];
        };
    });
    var conversions_1 = conversions.rgb;
    var conversions_2 = conversions.hsl;
    var conversions_3 = conversions.hsv;
    var conversions_4 = conversions.hwb;
    var conversions_5 = conversions.cmyk;
    var conversions_6 = conversions.xyz;
    var conversions_7 = conversions.lab;
    var conversions_8 = conversions.lch;
    var conversions_9 = conversions.hex;
    var conversions_10 = conversions.keyword;
    var conversions_11 = conversions.ansi16;
    var conversions_12 = conversions.ansi256;
    var conversions_13 = conversions.hcg;
    var conversions_14 = conversions.apple;
    var conversions_15 = conversions.gray;
    /*
	this function routes a model to all other models.

	all functions that are routed have a property `.conversion` attached
	to the returned synthetic function. This property is an array
	of strings, each with the steps in between the 'from' and 'to'
	color models (inclusive).

	conversions that are not possible simply are not included.
*/ function buildGraph() {
        var graph = {};
        // https://jsperf.com/object-keys-vs-for-in-with-closure/3
        var models = Object.keys(conversions);
        for(var len = models.length, i = 0; i < len; i++)graph[models[i]] = {
            // http://jsperf.com/1-vs-infinity
            // micro-opt, but this is simple.
            distance: -1,
            parent: null
        };
        return graph;
    }
    // https://en.wikipedia.org/wiki/Breadth-first_search
    function deriveBFS(fromModel) {
        var graph = buildGraph();
        var queue = [
            fromModel
        ]; // unshift -> queue -> pop
        graph[fromModel].distance = 0;
        while(queue.length){
            var current = queue.pop();
            var adjacents = Object.keys(conversions[current]);
            for(var len = adjacents.length, i = 0; i < len; i++){
                var adjacent = adjacents[i];
                var node = graph[adjacent];
                if (node.distance === -1) {
                    node.distance = graph[current].distance + 1;
                    node.parent = current;
                    queue.unshift(adjacent);
                }
            }
        }
        return graph;
    }
    function link(from, to) {
        return function(args) {
            return to(from(args));
        };
    }
    function wrapConversion(toModel, graph) {
        var path = [
            graph[toModel].parent,
            toModel
        ];
        var fn = conversions[graph[toModel].parent][toModel];
        var cur = graph[toModel].parent;
        while(graph[cur].parent){
            path.unshift(graph[cur].parent);
            fn = link(conversions[graph[cur].parent][cur], fn);
            cur = graph[cur].parent;
        }
        fn.conversion = path;
        return fn;
    }
    var route = function(fromModel) {
        var graph = deriveBFS(fromModel);
        var conversion = {};
        var models = Object.keys(graph);
        for(var len = models.length, i = 0; i < len; i++){
            var toModel = models[i];
            var node = graph[toModel];
            if (node.parent === null) continue;
            conversion[toModel] = wrapConversion(toModel, graph);
        }
        return conversion;
    };
    var convert = {};
    var models = Object.keys(conversions);
    function wrapRaw(fn) {
        var wrappedFn = function(args) {
            if (args === undefined || args === null) return args;
            if (arguments.length > 1) args = Array.prototype.slice.call(arguments);
            return fn(args);
        };
        // preserve .conversion property if there is one
        if ('conversion' in fn) wrappedFn.conversion = fn.conversion;
        return wrappedFn;
    }
    function wrapRounded(fn) {
        var wrappedFn = function(args) {
            if (args === undefined || args === null) return args;
            if (arguments.length > 1) args = Array.prototype.slice.call(arguments);
            var result = fn(args);
            // we're assuming the result is an array here.
            // see notice in conversions.js; don't use box types
            // in conversion functions.
            if (typeof result === 'object') for(var len = result.length, i = 0; i < len; i++)result[i] = Math.round(result[i]);
            return result;
        };
        // preserve .conversion property if there is one
        if ('conversion' in fn) wrappedFn.conversion = fn.conversion;
        return wrappedFn;
    }
    models.forEach(function(fromModel) {
        convert[fromModel] = {};
        Object.defineProperty(convert[fromModel], 'channels', {
            value: conversions[fromModel].channels
        });
        Object.defineProperty(convert[fromModel], 'labels', {
            value: conversions[fromModel].labels
        });
        var routes = route(fromModel);
        var routeModels = Object.keys(routes);
        routeModels.forEach(function(toModel) {
            var fn = routes[toModel];
            convert[fromModel][toModel] = wrapRounded(fn);
            convert[fromModel][toModel].raw = wrapRaw(fn);
        });
    });
    var colorConvert = convert;
    var colorName$1 = {
        "aliceblue": [
            240,
            248,
            255
        ],
        "antiquewhite": [
            250,
            235,
            215
        ],
        "aqua": [
            0,
            255,
            255
        ],
        "aquamarine": [
            127,
            255,
            212
        ],
        "azure": [
            240,
            255,
            255
        ],
        "beige": [
            245,
            245,
            220
        ],
        "bisque": [
            255,
            228,
            196
        ],
        "black": [
            0,
            0,
            0
        ],
        "blanchedalmond": [
            255,
            235,
            205
        ],
        "blue": [
            0,
            0,
            255
        ],
        "blueviolet": [
            138,
            43,
            226
        ],
        "brown": [
            165,
            42,
            42
        ],
        "burlywood": [
            222,
            184,
            135
        ],
        "cadetblue": [
            95,
            158,
            160
        ],
        "chartreuse": [
            127,
            255,
            0
        ],
        "chocolate": [
            210,
            105,
            30
        ],
        "coral": [
            255,
            127,
            80
        ],
        "cornflowerblue": [
            100,
            149,
            237
        ],
        "cornsilk": [
            255,
            248,
            220
        ],
        "crimson": [
            220,
            20,
            60
        ],
        "cyan": [
            0,
            255,
            255
        ],
        "darkblue": [
            0,
            0,
            139
        ],
        "darkcyan": [
            0,
            139,
            139
        ],
        "darkgoldenrod": [
            184,
            134,
            11
        ],
        "darkgray": [
            169,
            169,
            169
        ],
        "darkgreen": [
            0,
            100,
            0
        ],
        "darkgrey": [
            169,
            169,
            169
        ],
        "darkkhaki": [
            189,
            183,
            107
        ],
        "darkmagenta": [
            139,
            0,
            139
        ],
        "darkolivegreen": [
            85,
            107,
            47
        ],
        "darkorange": [
            255,
            140,
            0
        ],
        "darkorchid": [
            153,
            50,
            204
        ],
        "darkred": [
            139,
            0,
            0
        ],
        "darksalmon": [
            233,
            150,
            122
        ],
        "darkseagreen": [
            143,
            188,
            143
        ],
        "darkslateblue": [
            72,
            61,
            139
        ],
        "darkslategray": [
            47,
            79,
            79
        ],
        "darkslategrey": [
            47,
            79,
            79
        ],
        "darkturquoise": [
            0,
            206,
            209
        ],
        "darkviolet": [
            148,
            0,
            211
        ],
        "deeppink": [
            255,
            20,
            147
        ],
        "deepskyblue": [
            0,
            191,
            255
        ],
        "dimgray": [
            105,
            105,
            105
        ],
        "dimgrey": [
            105,
            105,
            105
        ],
        "dodgerblue": [
            30,
            144,
            255
        ],
        "firebrick": [
            178,
            34,
            34
        ],
        "floralwhite": [
            255,
            250,
            240
        ],
        "forestgreen": [
            34,
            139,
            34
        ],
        "fuchsia": [
            255,
            0,
            255
        ],
        "gainsboro": [
            220,
            220,
            220
        ],
        "ghostwhite": [
            248,
            248,
            255
        ],
        "gold": [
            255,
            215,
            0
        ],
        "goldenrod": [
            218,
            165,
            32
        ],
        "gray": [
            128,
            128,
            128
        ],
        "green": [
            0,
            128,
            0
        ],
        "greenyellow": [
            173,
            255,
            47
        ],
        "grey": [
            128,
            128,
            128
        ],
        "honeydew": [
            240,
            255,
            240
        ],
        "hotpink": [
            255,
            105,
            180
        ],
        "indianred": [
            205,
            92,
            92
        ],
        "indigo": [
            75,
            0,
            130
        ],
        "ivory": [
            255,
            255,
            240
        ],
        "khaki": [
            240,
            230,
            140
        ],
        "lavender": [
            230,
            230,
            250
        ],
        "lavenderblush": [
            255,
            240,
            245
        ],
        "lawngreen": [
            124,
            252,
            0
        ],
        "lemonchiffon": [
            255,
            250,
            205
        ],
        "lightblue": [
            173,
            216,
            230
        ],
        "lightcoral": [
            240,
            128,
            128
        ],
        "lightcyan": [
            224,
            255,
            255
        ],
        "lightgoldenrodyellow": [
            250,
            250,
            210
        ],
        "lightgray": [
            211,
            211,
            211
        ],
        "lightgreen": [
            144,
            238,
            144
        ],
        "lightgrey": [
            211,
            211,
            211
        ],
        "lightpink": [
            255,
            182,
            193
        ],
        "lightsalmon": [
            255,
            160,
            122
        ],
        "lightseagreen": [
            32,
            178,
            170
        ],
        "lightskyblue": [
            135,
            206,
            250
        ],
        "lightslategray": [
            119,
            136,
            153
        ],
        "lightslategrey": [
            119,
            136,
            153
        ],
        "lightsteelblue": [
            176,
            196,
            222
        ],
        "lightyellow": [
            255,
            255,
            224
        ],
        "lime": [
            0,
            255,
            0
        ],
        "limegreen": [
            50,
            205,
            50
        ],
        "linen": [
            250,
            240,
            230
        ],
        "magenta": [
            255,
            0,
            255
        ],
        "maroon": [
            128,
            0,
            0
        ],
        "mediumaquamarine": [
            102,
            205,
            170
        ],
        "mediumblue": [
            0,
            0,
            205
        ],
        "mediumorchid": [
            186,
            85,
            211
        ],
        "mediumpurple": [
            147,
            112,
            219
        ],
        "mediumseagreen": [
            60,
            179,
            113
        ],
        "mediumslateblue": [
            123,
            104,
            238
        ],
        "mediumspringgreen": [
            0,
            250,
            154
        ],
        "mediumturquoise": [
            72,
            209,
            204
        ],
        "mediumvioletred": [
            199,
            21,
            133
        ],
        "midnightblue": [
            25,
            25,
            112
        ],
        "mintcream": [
            245,
            255,
            250
        ],
        "mistyrose": [
            255,
            228,
            225
        ],
        "moccasin": [
            255,
            228,
            181
        ],
        "navajowhite": [
            255,
            222,
            173
        ],
        "navy": [
            0,
            0,
            128
        ],
        "oldlace": [
            253,
            245,
            230
        ],
        "olive": [
            128,
            128,
            0
        ],
        "olivedrab": [
            107,
            142,
            35
        ],
        "orange": [
            255,
            165,
            0
        ],
        "orangered": [
            255,
            69,
            0
        ],
        "orchid": [
            218,
            112,
            214
        ],
        "palegoldenrod": [
            238,
            232,
            170
        ],
        "palegreen": [
            152,
            251,
            152
        ],
        "paleturquoise": [
            175,
            238,
            238
        ],
        "palevioletred": [
            219,
            112,
            147
        ],
        "papayawhip": [
            255,
            239,
            213
        ],
        "peachpuff": [
            255,
            218,
            185
        ],
        "peru": [
            205,
            133,
            63
        ],
        "pink": [
            255,
            192,
            203
        ],
        "plum": [
            221,
            160,
            221
        ],
        "powderblue": [
            176,
            224,
            230
        ],
        "purple": [
            128,
            0,
            128
        ],
        "rebeccapurple": [
            102,
            51,
            153
        ],
        "red": [
            255,
            0,
            0
        ],
        "rosybrown": [
            188,
            143,
            143
        ],
        "royalblue": [
            65,
            105,
            225
        ],
        "saddlebrown": [
            139,
            69,
            19
        ],
        "salmon": [
            250,
            128,
            114
        ],
        "sandybrown": [
            244,
            164,
            96
        ],
        "seagreen": [
            46,
            139,
            87
        ],
        "seashell": [
            255,
            245,
            238
        ],
        "sienna": [
            160,
            82,
            45
        ],
        "silver": [
            192,
            192,
            192
        ],
        "skyblue": [
            135,
            206,
            235
        ],
        "slateblue": [
            106,
            90,
            205
        ],
        "slategray": [
            112,
            128,
            144
        ],
        "slategrey": [
            112,
            128,
            144
        ],
        "snow": [
            255,
            250,
            250
        ],
        "springgreen": [
            0,
            255,
            127
        ],
        "steelblue": [
            70,
            130,
            180
        ],
        "tan": [
            210,
            180,
            140
        ],
        "teal": [
            0,
            128,
            128
        ],
        "thistle": [
            216,
            191,
            216
        ],
        "tomato": [
            255,
            99,
            71
        ],
        "turquoise": [
            64,
            224,
            208
        ],
        "violet": [
            238,
            130,
            238
        ],
        "wheat": [
            245,
            222,
            179
        ],
        "white": [
            255,
            255,
            255
        ],
        "whitesmoke": [
            245,
            245,
            245
        ],
        "yellow": [
            255,
            255,
            0
        ],
        "yellowgreen": [
            154,
            205,
            50
        ]
    };
    /* MIT license */ var colorString = {
        getRgba: getRgba,
        getHsla: getHsla,
        getRgb: getRgb,
        getHsl: getHsl,
        getHwb: getHwb,
        getAlpha: getAlpha,
        hexString: hexString,
        rgbString: rgbString,
        rgbaString: rgbaString,
        percentString: percentString,
        percentaString: percentaString,
        hslString: hslString,
        hslaString: hslaString,
        hwbString: hwbString,
        keyword: keyword
    };
    function getRgba(string) {
        if (!string) return;
        var abbr = /^#([a-fA-F0-9]{3,4})$/i, hex = /^#([a-fA-F0-9]{6}([a-fA-F0-9]{2})?)$/i, rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i, per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i, keyword = /(\w+)/;
        var rgb = [
            0,
            0,
            0
        ], a = 1, match = string.match(abbr), hexAlpha = "";
        if (match) {
            match = match[1];
            hexAlpha = match[3];
            for(var i = 0; i < rgb.length; i++)rgb[i] = parseInt(match[i] + match[i], 16);
            if (hexAlpha) a = Math.round(parseInt(hexAlpha + hexAlpha, 16) / 255 * 100) / 100;
        } else if (match = string.match(hex)) {
            hexAlpha = match[2];
            match = match[1];
            for(var i = 0; i < rgb.length; i++)rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
            if (hexAlpha) a = Math.round(parseInt(hexAlpha, 16) / 255 * 100) / 100;
        } else if (match = string.match(rgba)) {
            for(var i = 0; i < rgb.length; i++)rgb[i] = parseInt(match[i + 1]);
            a = parseFloat(match[4]);
        } else if (match = string.match(per)) {
            for(var i = 0; i < rgb.length; i++)rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
            a = parseFloat(match[4]);
        } else if (match = string.match(keyword)) {
            if (match[1] == "transparent") return [
                0,
                0,
                0,
                0
            ];
            rgb = colorName$1[match[1]];
            if (!rgb) return;
        }
        for(var i = 0; i < rgb.length; i++)rgb[i] = scale(rgb[i], 0, 255);
        if (!a && a != 0) a = 1;
        else a = scale(a, 0, 1);
        rgb[3] = a;
        return rgb;
    }
    function getHsla(string) {
        if (!string) return;
        var hsl = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
        var match = string.match(hsl);
        if (match) {
            var alpha = parseFloat(match[4]);
            var h = scale(parseInt(match[1]), 0, 360), s = scale(parseFloat(match[2]), 0, 100), l = scale(parseFloat(match[3]), 0, 100), a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
            return [
                h,
                s,
                l,
                a
            ];
        }
    }
    function getHwb(string) {
        if (!string) return;
        var hwb = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
        var match = string.match(hwb);
        if (match) {
            var alpha = parseFloat(match[4]);
            var h = scale(parseInt(match[1]), 0, 360), w = scale(parseFloat(match[2]), 0, 100), b = scale(parseFloat(match[3]), 0, 100), a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
            return [
                h,
                w,
                b,
                a
            ];
        }
    }
    function getRgb(string) {
        var rgba = getRgba(string);
        return rgba && rgba.slice(0, 3);
    }
    function getHsl(string) {
        var hsla = getHsla(string);
        return hsla && hsla.slice(0, 3);
    }
    function getAlpha(string) {
        var vals = getRgba(string);
        if (vals) return vals[3];
        else if (vals = getHsla(string)) return vals[3];
        else if (vals = getHwb(string)) return vals[3];
    }
    // generators
    function hexString(rgba, a) {
        var a = a !== undefined && rgba.length === 3 ? a : rgba[3];
        return "#" + hexDouble(rgba[0]) + hexDouble(rgba[1]) + hexDouble(rgba[2]) + (a >= 0 && a < 1 ? hexDouble(Math.round(a * 255)) : "");
    }
    function rgbString(rgba, alpha) {
        if (alpha < 1 || rgba[3] && rgba[3] < 1) return rgbaString(rgba, alpha);
        return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
    }
    function rgbaString(rgba, alpha) {
        if (alpha === undefined) alpha = rgba[3] !== undefined ? rgba[3] : 1;
        return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ", " + alpha + ")";
    }
    function percentString(rgba, alpha) {
        if (alpha < 1 || rgba[3] && rgba[3] < 1) return percentaString(rgba, alpha);
        var r = Math.round(rgba[0] / 255 * 100), g = Math.round(rgba[1] / 255 * 100), b = Math.round(rgba[2] / 255 * 100);
        return "rgb(" + r + "%, " + g + "%, " + b + "%)";
    }
    function percentaString(rgba, alpha) {
        var r = Math.round(rgba[0] / 255 * 100), g = Math.round(rgba[1] / 255 * 100), b = Math.round(rgba[2] / 255 * 100);
        return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
    }
    function hslString(hsla, alpha) {
        if (alpha < 1 || hsla[3] && hsla[3] < 1) return hslaString(hsla, alpha);
        return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
    }
    function hslaString(hsla, alpha) {
        if (alpha === undefined) alpha = hsla[3] !== undefined ? hsla[3] : 1;
        return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, " + alpha + ")";
    }
    // hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
    // (hwb have alpha optional & 1 is default value)
    function hwbString(hwb, alpha) {
        if (alpha === undefined) alpha = hwb[3] !== undefined ? hwb[3] : 1;
        return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%" + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
    }
    function keyword(rgb) {
        return reverseNames[rgb.slice(0, 3)];
    }
    // helpers
    function scale(num, min, max) {
        return Math.min(Math.max(min, num), max);
    }
    function hexDouble(num) {
        var str = num.toString(16).toUpperCase();
        return str.length < 2 ? "0" + str : str;
    }
    //create a list of reverse color names
    var reverseNames = {};
    for(var name in colorName$1)reverseNames[colorName$1[name]] = name;
    /* MIT license */ var Color = function(obj) {
        if (obj instanceof Color) return obj;
        if (!(this instanceof Color)) return new Color(obj);
        this.valid = false;
        this.values = {
            rgb: [
                0,
                0,
                0
            ],
            hsl: [
                0,
                0,
                0
            ],
            hsv: [
                0,
                0,
                0
            ],
            hwb: [
                0,
                0,
                0
            ],
            cmyk: [
                0,
                0,
                0,
                0
            ],
            alpha: 1
        };
        // parse Color() argument
        var vals;
        if (typeof obj === 'string') {
            vals = colorString.getRgba(obj);
            if (vals) this.setValues('rgb', vals);
            else if (vals = colorString.getHsla(obj)) this.setValues('hsl', vals);
            else if (vals = colorString.getHwb(obj)) this.setValues('hwb', vals);
        } else if (typeof obj === 'object') {
            vals = obj;
            if (vals.r !== undefined || vals.red !== undefined) this.setValues('rgb', vals);
            else if (vals.l !== undefined || vals.lightness !== undefined) this.setValues('hsl', vals);
            else if (vals.v !== undefined || vals.value !== undefined) this.setValues('hsv', vals);
            else if (vals.w !== undefined || vals.whiteness !== undefined) this.setValues('hwb', vals);
            else if (vals.c !== undefined || vals.cyan !== undefined) this.setValues('cmyk', vals);
        }
    };
    Color.prototype = {
        isValid: function() {
            return this.valid;
        },
        rgb: function() {
            return this.setSpace('rgb', arguments);
        },
        hsl: function() {
            return this.setSpace('hsl', arguments);
        },
        hsv: function() {
            return this.setSpace('hsv', arguments);
        },
        hwb: function() {
            return this.setSpace('hwb', arguments);
        },
        cmyk: function() {
            return this.setSpace('cmyk', arguments);
        },
        rgbArray: function() {
            return this.values.rgb;
        },
        hslArray: function() {
            return this.values.hsl;
        },
        hsvArray: function() {
            return this.values.hsv;
        },
        hwbArray: function() {
            var values = this.values;
            if (values.alpha !== 1) return values.hwb.concat([
                values.alpha
            ]);
            return values.hwb;
        },
        cmykArray: function() {
            return this.values.cmyk;
        },
        rgbaArray: function() {
            var values = this.values;
            return values.rgb.concat([
                values.alpha
            ]);
        },
        hslaArray: function() {
            var values = this.values;
            return values.hsl.concat([
                values.alpha
            ]);
        },
        alpha: function(val) {
            if (val === undefined) return this.values.alpha;
            this.setValues('alpha', val);
            return this;
        },
        red: function(val) {
            return this.setChannel('rgb', 0, val);
        },
        green: function(val) {
            return this.setChannel('rgb', 1, val);
        },
        blue: function(val) {
            return this.setChannel('rgb', 2, val);
        },
        hue: function(val) {
            if (val) {
                val %= 360;
                val = val < 0 ? 360 + val : val;
            }
            return this.setChannel('hsl', 0, val);
        },
        saturation: function(val) {
            return this.setChannel('hsl', 1, val);
        },
        lightness: function(val) {
            return this.setChannel('hsl', 2, val);
        },
        saturationv: function(val) {
            return this.setChannel('hsv', 1, val);
        },
        whiteness: function(val) {
            return this.setChannel('hwb', 1, val);
        },
        blackness: function(val) {
            return this.setChannel('hwb', 2, val);
        },
        value: function(val) {
            return this.setChannel('hsv', 2, val);
        },
        cyan: function(val) {
            return this.setChannel('cmyk', 0, val);
        },
        magenta: function(val) {
            return this.setChannel('cmyk', 1, val);
        },
        yellow: function(val) {
            return this.setChannel('cmyk', 2, val);
        },
        black: function(val) {
            return this.setChannel('cmyk', 3, val);
        },
        hexString: function() {
            return colorString.hexString(this.values.rgb);
        },
        rgbString: function() {
            return colorString.rgbString(this.values.rgb, this.values.alpha);
        },
        rgbaString: function() {
            return colorString.rgbaString(this.values.rgb, this.values.alpha);
        },
        percentString: function() {
            return colorString.percentString(this.values.rgb, this.values.alpha);
        },
        hslString: function() {
            return colorString.hslString(this.values.hsl, this.values.alpha);
        },
        hslaString: function() {
            return colorString.hslaString(this.values.hsl, this.values.alpha);
        },
        hwbString: function() {
            return colorString.hwbString(this.values.hwb, this.values.alpha);
        },
        keyword: function() {
            return colorString.keyword(this.values.rgb, this.values.alpha);
        },
        rgbNumber: function() {
            var rgb = this.values.rgb;
            return rgb[0] << 16 | rgb[1] << 8 | rgb[2];
        },
        luminosity: function() {
            // http://www.w3.org/TR/WCAG20/#relativeluminancedef
            var rgb = this.values.rgb;
            var lum = [];
            for(var i = 0; i < rgb.length; i++){
                var chan = rgb[i] / 255;
                lum[i] = chan <= 0.03928 ? chan / 12.92 : Math.pow((chan + 0.055) / 1.055, 2.4);
            }
            return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
        },
        contrast: function(color2) {
            // http://www.w3.org/TR/WCAG20/#contrast-ratiodef
            var lum1 = this.luminosity();
            var lum2 = color2.luminosity();
            if (lum1 > lum2) return (lum1 + 0.05) / (lum2 + 0.05);
            return (lum2 + 0.05) / (lum1 + 0.05);
        },
        level: function(color2) {
            var contrastRatio = this.contrast(color2);
            if (contrastRatio >= 7.1) return 'AAA';
            return contrastRatio >= 4.5 ? 'AA' : '';
        },
        dark: function() {
            // YIQ equation from http://24ways.org/2010/calculating-color-contrast
            var rgb = this.values.rgb;
            var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
            return yiq < 128;
        },
        light: function() {
            return !this.dark();
        },
        negate: function() {
            var rgb = [];
            for(var i = 0; i < 3; i++)rgb[i] = 255 - this.values.rgb[i];
            this.setValues('rgb', rgb);
            return this;
        },
        lighten: function(ratio) {
            var hsl = this.values.hsl;
            hsl[2] += hsl[2] * ratio;
            this.setValues('hsl', hsl);
            return this;
        },
        darken: function(ratio) {
            var hsl = this.values.hsl;
            hsl[2] -= hsl[2] * ratio;
            this.setValues('hsl', hsl);
            return this;
        },
        saturate: function(ratio) {
            var hsl = this.values.hsl;
            hsl[1] += hsl[1] * ratio;
            this.setValues('hsl', hsl);
            return this;
        },
        desaturate: function(ratio) {
            var hsl = this.values.hsl;
            hsl[1] -= hsl[1] * ratio;
            this.setValues('hsl', hsl);
            return this;
        },
        whiten: function(ratio) {
            var hwb = this.values.hwb;
            hwb[1] += hwb[1] * ratio;
            this.setValues('hwb', hwb);
            return this;
        },
        blacken: function(ratio) {
            var hwb = this.values.hwb;
            hwb[2] += hwb[2] * ratio;
            this.setValues('hwb', hwb);
            return this;
        },
        greyscale: function() {
            var rgb = this.values.rgb;
            // http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
            var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
            this.setValues('rgb', [
                val,
                val,
                val
            ]);
            return this;
        },
        clearer: function(ratio) {
            var alpha = this.values.alpha;
            this.setValues('alpha', alpha - alpha * ratio);
            return this;
        },
        opaquer: function(ratio) {
            var alpha = this.values.alpha;
            this.setValues('alpha', alpha + alpha * ratio);
            return this;
        },
        rotate: function(degrees) {
            var hsl = this.values.hsl;
            var hue = (hsl[0] + degrees) % 360;
            hsl[0] = hue < 0 ? 360 + hue : hue;
            this.setValues('hsl', hsl);
            return this;
        },
        /**
	 * Ported from sass implementation in C
	 * https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
	 */ mix: function(mixinColor, weight) {
            var color1 = this;
            var color2 = mixinColor;
            var p = weight === undefined ? 0.5 : weight;
            var w = 2 * p - 1;
            var a = color1.alpha() - color2.alpha();
            var w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
            var w2 = 1 - w1;
            return this.rgb(w1 * color1.red() + w2 * color2.red(), w1 * color1.green() + w2 * color2.green(), w1 * color1.blue() + w2 * color2.blue()).alpha(color1.alpha() * p + color2.alpha() * (1 - p));
        },
        toJSON: function() {
            return this.rgb();
        },
        clone: function() {
            // NOTE(SB): using node-clone creates a dependency to Buffer when using browserify,
            // making the final build way to big to embed in Chart.js. So let's do it manually,
            // assuming that values to clone are 1 dimension arrays containing only numbers,
            // except 'alpha' which is a number.
            var result = new Color();
            var source = this.values;
            var target = result.values;
            var value, type;
            for(var prop in source)if (source.hasOwnProperty(prop)) {
                value = source[prop];
                type = ({}).toString.call(value);
                if (type === '[object Array]') target[prop] = value.slice(0);
                else if (type === '[object Number]') target[prop] = value;
                else console.error('unexpected color value:', value);
            }
            return result;
        }
    };
    Color.prototype.spaces = {
        rgb: [
            'red',
            'green',
            'blue'
        ],
        hsl: [
            'hue',
            'saturation',
            'lightness'
        ],
        hsv: [
            'hue',
            'saturation',
            'value'
        ],
        hwb: [
            'hue',
            'whiteness',
            'blackness'
        ],
        cmyk: [
            'cyan',
            'magenta',
            'yellow',
            'black'
        ]
    };
    Color.prototype.maxes = {
        rgb: [
            255,
            255,
            255
        ],
        hsl: [
            360,
            100,
            100
        ],
        hsv: [
            360,
            100,
            100
        ],
        hwb: [
            360,
            100,
            100
        ],
        cmyk: [
            100,
            100,
            100,
            100
        ]
    };
    Color.prototype.getValues = function(space) {
        var values = this.values;
        var vals = {};
        for(var i = 0; i < space.length; i++)vals[space.charAt(i)] = values[space][i];
        if (values.alpha !== 1) vals.a = values.alpha;
        // {r: 255, g: 255, b: 255, a: 0.4}
        return vals;
    };
    Color.prototype.setValues = function(space, vals) {
        var values = this.values;
        var spaces = this.spaces;
        var maxes = this.maxes;
        var alpha = 1;
        var i;
        this.valid = true;
        if (space === 'alpha') alpha = vals;
        else if (vals.length) {
            // [10, 10, 10]
            values[space] = vals.slice(0, space.length);
            alpha = vals[space.length];
        } else if (vals[space.charAt(0)] !== undefined) {
            // {r: 10, g: 10, b: 10}
            for(i = 0; i < space.length; i++)values[space][i] = vals[space.charAt(i)];
            alpha = vals.a;
        } else if (vals[spaces[space][0]] !== undefined) {
            // {red: 10, green: 10, blue: 10}
            var chans = spaces[space];
            for(i = 0; i < space.length; i++)values[space][i] = vals[chans[i]];
            alpha = vals.alpha;
        }
        values.alpha = Math.max(0, Math.min(1, alpha === undefined ? values.alpha : alpha));
        if (space === 'alpha') return false;
        var capped;
        // cap values of the space prior converting all values
        for(i = 0; i < space.length; i++){
            capped = Math.max(0, Math.min(maxes[space][i], values[space][i]));
            values[space][i] = Math.round(capped);
        }
        // convert to all the other color spaces
        for(var sname in spaces)if (sname !== space) values[sname] = colorConvert[space][sname](values[space]);
        return true;
    };
    Color.prototype.setSpace = function(space, args) {
        var vals = args[0];
        if (vals === undefined) // color.rgb()
        return this.getValues(space);
        // color.rgb(10, 10, 10)
        if (typeof vals === 'number') vals = Array.prototype.slice.call(args);
        this.setValues(space, vals);
        return this;
    };
    Color.prototype.setChannel = function(space, index, val) {
        var svalues = this.values[space];
        if (val === undefined) // color.red()
        return svalues[index];
        else if (val === svalues[index]) // color.red(color.red())
        return this;
        // color.red(100)
        svalues[index] = val;
        this.setValues(space, svalues);
        return this;
    };
    if (typeof window !== 'undefined') window.Color = Color;
    var chartjsColor = Color;
    function isValidKey(key) {
        return [
            '__proto__',
            'prototype',
            'constructor'
        ].indexOf(key) === -1;
    }
    /**
 * @namespace Chart.helpers
 */ var helpers = {
        /**
	 * An empty function that can be used, for example, for optional callback.
	 */ noop: function() {},
        /**
	 * Returns a unique id, sequentially generated from a global variable.
	 * @returns {number}
	 * @function
	 */ uid: function() {
            var id = 0;
            return function() {
                return id++;
            };
        }(),
        /**
	 * Returns true if `value` is neither null nor undefined, else returns false.
	 * @param {*} value - The value to test.
	 * @returns {boolean}
	 * @since 2.7.0
	 */ isNullOrUndef: function(value) {
            return value === null || typeof value === 'undefined';
        },
        /**
	 * Returns true if `value` is an array (including typed arrays), else returns false.
	 * @param {*} value - The value to test.
	 * @returns {boolean}
	 * @function
	 */ isArray: function(value) {
            if (Array.isArray && Array.isArray(value)) return true;
            var type = Object.prototype.toString.call(value);
            if (type.substr(0, 7) === '[object' && type.substr(-6) === 'Array]') return true;
            return false;
        },
        /**
	 * Returns true if `value` is an object (excluding null), else returns false.
	 * @param {*} value - The value to test.
	 * @returns {boolean}
	 * @since 2.7.0
	 */ isObject: function(value) {
            return value !== null && Object.prototype.toString.call(value) === '[object Object]';
        },
        /**
	 * Returns true if `value` is a finite number, else returns false
	 * @param {*} value  - The value to test.
	 * @returns {boolean}
	 */ isFinite: function(value) {
            return (typeof value === 'number' || value instanceof Number) && isFinite(value);
        },
        /**
	 * Returns `value` if defined, else returns `defaultValue`.
	 * @param {*} value - The value to return if defined.
	 * @param {*} defaultValue - The value to return if `value` is undefined.
	 * @returns {*}
	 */ valueOrDefault: function(value, defaultValue) {
            return typeof value === 'undefined' ? defaultValue : value;
        },
        /**
	 * Returns value at the given `index` in array if defined, else returns `defaultValue`.
	 * @param {Array} value - The array to lookup for value at `index`.
	 * @param {number} index - The index in `value` to lookup for value.
	 * @param {*} defaultValue - The value to return if `value[index]` is undefined.
	 * @returns {*}
	 */ valueAtIndexOrDefault: function(value, index, defaultValue) {
            return helpers.valueOrDefault(helpers.isArray(value) ? value[index] : value, defaultValue);
        },
        /**
	 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
	 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
	 * @param {function} fn - The function to call.
	 * @param {Array|undefined|null} args - The arguments with which `fn` should be called.
	 * @param {object} [thisArg] - The value of `this` provided for the call to `fn`.
	 * @returns {*}
	 */ callback: function(fn, args, thisArg) {
            if (fn && typeof fn.call === 'function') return fn.apply(thisArg, args);
        },
        /**
	 * Note(SB) for performance sake, this method should only be used when loopable type
	 * is unknown or in none intensive code (not called often and small loopable). Else
	 * it's preferable to use a regular for() loop and save extra function calls.
	 * @param {object|Array} loopable - The object or array to be iterated.
	 * @param {function} fn - The function to call for each item.
	 * @param {object} [thisArg] - The value of `this` provided for the call to `fn`.
	 * @param {boolean} [reverse] - If true, iterates backward on the loopable.
	 */ each: function(loopable, fn, thisArg, reverse) {
            var i, len, keys;
            if (helpers.isArray(loopable)) {
                len = loopable.length;
                if (reverse) for(i = len - 1; i >= 0; i--)fn.call(thisArg, loopable[i], i);
                else for(i = 0; i < len; i++)fn.call(thisArg, loopable[i], i);
            } else if (helpers.isObject(loopable)) {
                keys = Object.keys(loopable);
                len = keys.length;
                for(i = 0; i < len; i++)fn.call(thisArg, loopable[keys[i]], keys[i]);
            }
        },
        /**
	 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
	 * @see https://stackoverflow.com/a/14853974
	 * @param {Array} a0 - The array to compare
	 * @param {Array} a1 - The array to compare
	 * @returns {boolean}
	 */ arrayEquals: function(a0, a1) {
            var i, ilen, v0, v1;
            if (!a0 || !a1 || a0.length !== a1.length) return false;
            for(i = 0, ilen = a0.length; i < ilen; ++i){
                v0 = a0[i];
                v1 = a1[i];
                if (v0 instanceof Array && v1 instanceof Array) {
                    if (!helpers.arrayEquals(v0, v1)) return false;
                } else if (v0 !== v1) // NOTE: two different object instances will never be equal: {x:20} != {x:20}
                return false;
            }
            return true;
        },
        /**
	 * Returns a deep copy of `source` without keeping references on objects and arrays.
	 * @param {*} source - The value to clone.
	 * @returns {*}
	 */ clone: function(source) {
            if (helpers.isArray(source)) return source.map(helpers.clone);
            if (helpers.isObject(source)) {
                var target = Object.create(source);
                var keys = Object.keys(source);
                var klen = keys.length;
                var k = 0;
                for(; k < klen; ++k)target[keys[k]] = helpers.clone(source[keys[k]]);
                return target;
            }
            return source;
        },
        /**
	 * The default merger when Chart.helpers.merge is called without merger option.
	 * Note(SB): also used by mergeConfig and mergeScaleConfig as fallback.
	 * @private
	 */ _merger: function(key, target, source, options) {
            if (!isValidKey(key)) // We want to ensure we do not copy prototypes over
            // as this can pollute global namespaces
            return;
            var tval = target[key];
            var sval = source[key];
            if (helpers.isObject(tval) && helpers.isObject(sval)) helpers.merge(tval, sval, options);
            else target[key] = helpers.clone(sval);
        },
        /**
	 * Merges source[key] in target[key] only if target[key] is undefined.
	 * @private
	 */ _mergerIf: function(key, target, source) {
            if (!isValidKey(key)) // We want to ensure we do not copy prototypes over
            // as this can pollute global namespaces
            return;
            var tval = target[key];
            var sval = source[key];
            if (helpers.isObject(tval) && helpers.isObject(sval)) helpers.mergeIf(tval, sval);
            else if (!target.hasOwnProperty(key)) target[key] = helpers.clone(sval);
        },
        /**
	 * Recursively deep copies `source` properties into `target` with the given `options`.
	 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
	 * @param {object} target - The target object in which all sources are merged into.
	 * @param {object|object[]} source - Object(s) to merge into `target`.
	 * @param {object} [options] - Merging options:
	 * @param {function} [options.merger] - The merge method (key, target, source, options)
	 * @returns {object} The `target` object.
	 */ merge: function(target, source, options) {
            var sources = helpers.isArray(source) ? source : [
                source
            ];
            var ilen = sources.length;
            var merge, i, keys, klen, k;
            if (!helpers.isObject(target)) return target;
            options = options || {};
            merge = options.merger || helpers._merger;
            for(i = 0; i < ilen; ++i){
                source = sources[i];
                if (!helpers.isObject(source)) continue;
                keys = Object.keys(source);
                for(k = 0, klen = keys.length; k < klen; ++k)merge(keys[k], target, source, options);
            }
            return target;
        },
        /**
	 * Recursively deep copies `source` properties into `target` *only* if not defined in target.
	 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
	 * @param {object} target - The target object in which all sources are merged into.
	 * @param {object|object[]} source - Object(s) to merge into `target`.
	 * @returns {object} The `target` object.
	 */ mergeIf: function(target, source) {
            return helpers.merge(target, source, {
                merger: helpers._mergerIf
            });
        },
        /**
	 * Applies the contents of two or more objects together into the first object.
	 * @param {object} target - The target object in which all objects are merged into.
	 * @param {object} arg1 - Object containing additional properties to merge in target.
	 * @param {object} argN - Additional objects containing properties to merge in target.
	 * @returns {object} The `target` object.
	 */ extend: Object.assign || function(target) {
            return helpers.merge(target, [].slice.call(arguments, 1), {
                merger: function(key, dst, src) {
                    dst[key] = src[key];
                }
            });
        },
        /**
	 * Basic javascript inheritance based on the model created in Backbone.js
	 */ inherits: function(extensions) {
            var me = this;
            var ChartElement = extensions && extensions.hasOwnProperty('constructor') ? extensions.constructor : function() {
                return me.apply(this, arguments);
            };
            var Surrogate = function() {
                this.constructor = ChartElement;
            };
            Surrogate.prototype = me.prototype;
            ChartElement.prototype = new Surrogate();
            ChartElement.extend = helpers.inherits;
            if (extensions) helpers.extend(ChartElement.prototype, extensions);
            ChartElement.__super__ = me.prototype;
            return ChartElement;
        },
        _deprecated: function(scope, value, previous, current) {
            if (value !== undefined) console.warn(scope + ': "' + previous + '" is deprecated. Please use "' + current + '" instead');
        }
    };
    var helpers_core = helpers;
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, use Chart.helpers.callback instead.
 * @function Chart.helpers.callCallback
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 * @private
 */ helpers.callCallback = helpers.callback;
    /**
 * Provided for backward compatibility, use Array.prototype.indexOf instead.
 * Array.prototype.indexOf compatibility: Chrome, Opera, Safari, FF1.5+, IE9+
 * @function Chart.helpers.indexOf
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers.indexOf = function(array, item, fromIndex) {
        return Array.prototype.indexOf.call(array, item, fromIndex);
    };
    /**
 * Provided for backward compatibility, use Chart.helpers.valueOrDefault instead.
 * @function Chart.helpers.getValueOrDefault
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers.getValueOrDefault = helpers.valueOrDefault;
    /**
 * Provided for backward compatibility, use Chart.helpers.valueAtIndexOrDefault instead.
 * @function Chart.helpers.getValueAtIndexOrDefault
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers.getValueAtIndexOrDefault = helpers.valueAtIndexOrDefault;
    /**
 * Easing functions adapted from Robert Penner's easing equations.
 * @namespace Chart.helpers.easingEffects
 * @see http://www.robertpenner.com/easing/
 */ var effects = {
        linear: function(t) {
            return t;
        },
        easeInQuad: function(t) {
            return t * t;
        },
        easeOutQuad: function(t) {
            return -t * (t - 2);
        },
        easeInOutQuad: function(t) {
            if ((t /= 0.5) < 1) return 0.5 * t * t;
            return -0.5 * (--t * (t - 2) - 1);
        },
        easeInCubic: function(t) {
            return t * t * t;
        },
        easeOutCubic: function(t) {
            return (t = t - 1) * t * t + 1;
        },
        easeInOutCubic: function(t) {
            if ((t /= 0.5) < 1) return 0.5 * t * t * t;
            return 0.5 * ((t -= 2) * t * t + 2);
        },
        easeInQuart: function(t) {
            return t * t * t * t;
        },
        easeOutQuart: function(t) {
            return -((t = t - 1) * t * t * t - 1);
        },
        easeInOutQuart: function(t) {
            if ((t /= 0.5) < 1) return 0.5 * t * t * t * t;
            return -0.5 * ((t -= 2) * t * t * t - 2);
        },
        easeInQuint: function(t) {
            return t * t * t * t * t;
        },
        easeOutQuint: function(t) {
            return (t = t - 1) * t * t * t * t + 1;
        },
        easeInOutQuint: function(t) {
            if ((t /= 0.5) < 1) return 0.5 * t * t * t * t * t;
            return 0.5 * ((t -= 2) * t * t * t * t + 2);
        },
        easeInSine: function(t) {
            return -Math.cos(t * (Math.PI / 2)) + 1;
        },
        easeOutSine: function(t) {
            return Math.sin(t * (Math.PI / 2));
        },
        easeInOutSine: function(t) {
            return -0.5 * (Math.cos(Math.PI * t) - 1);
        },
        easeInExpo: function(t) {
            return t === 0 ? 0 : Math.pow(2, 10 * (t - 1));
        },
        easeOutExpo: function(t) {
            return t === 1 ? 1 : -Math.pow(2, -10 * t) + 1;
        },
        easeInOutExpo: function(t) {
            if (t === 0) return 0;
            if (t === 1) return 1;
            if ((t /= 0.5) < 1) return 0.5 * Math.pow(2, 10 * (t - 1));
            return 0.5 * (-Math.pow(2, -10 * --t) + 2);
        },
        easeInCirc: function(t) {
            if (t >= 1) return t;
            return -(Math.sqrt(1 - t * t) - 1);
        },
        easeOutCirc: function(t) {
            return Math.sqrt(1 - (t = t - 1) * t);
        },
        easeInOutCirc: function(t) {
            if ((t /= 0.5) < 1) return -0.5 * (Math.sqrt(1 - t * t) - 1);
            return 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
        },
        easeInElastic: function(t) {
            var s = 1.70158;
            var p = 0;
            var a = 1;
            if (t === 0) return 0;
            if (t === 1) return 1;
            if (!p) p = 0.3;
            if (a < 1) {
                a = 1;
                s = p / 4;
            } else s = p / (2 * Math.PI) * Math.asin(1 / a);
            return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
        },
        easeOutElastic: function(t) {
            var s = 1.70158;
            var p = 0;
            var a = 1;
            if (t === 0) return 0;
            if (t === 1) return 1;
            if (!p) p = 0.3;
            if (a < 1) {
                a = 1;
                s = p / 4;
            } else s = p / (2 * Math.PI) * Math.asin(1 / a);
            return a * Math.pow(2, -10 * t) * Math.sin((t - s) * (2 * Math.PI) / p) + 1;
        },
        easeInOutElastic: function(t) {
            var s = 1.70158;
            var p = 0;
            var a = 1;
            if (t === 0) return 0;
            if ((t /= 0.5) === 2) return 1;
            if (!p) p = 0.45;
            if (a < 1) {
                a = 1;
                s = p / 4;
            } else s = p / (2 * Math.PI) * Math.asin(1 / a);
            if (t < 1) return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
            return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p) * 0.5 + 1;
        },
        easeInBack: function(t) {
            var s = 1.70158;
            return t * t * ((s + 1) * t - s);
        },
        easeOutBack: function(t) {
            var s = 1.70158;
            return (t = t - 1) * t * ((s + 1) * t + s) + 1;
        },
        easeInOutBack: function(t) {
            var s = 1.70158;
            if ((t /= 0.5) < 1) return 0.5 * (t * t * (((s *= 1.525) + 1) * t - s));
            return 0.5 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2);
        },
        easeInBounce: function(t) {
            return 1 - effects.easeOutBounce(1 - t);
        },
        easeOutBounce: function(t) {
            if (t < 1 / 2.75) return 7.5625 * t * t;
            if (t < 2 / 2.75) return 7.5625 * (t -= 1.5 / 2.75) * t + 0.75;
            if (t < 2.5 / 2.75) return 7.5625 * (t -= 2.25 / 2.75) * t + 0.9375;
            return 7.5625 * (t -= 2.625 / 2.75) * t + 0.984375;
        },
        easeInOutBounce: function(t) {
            if (t < 0.5) return effects.easeInBounce(t * 2) * 0.5;
            return effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5;
        }
    };
    var helpers_easing = {
        effects: effects
    };
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, use Chart.helpers.easing.effects instead.
 * @function Chart.helpers.easingEffects
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers_core.easingEffects = effects;
    var PI = Math.PI;
    var RAD_PER_DEG = PI / 180;
    var DOUBLE_PI = PI * 2;
    var HALF_PI = PI / 2;
    var QUARTER_PI = PI / 4;
    var TWO_THIRDS_PI = PI * 2 / 3;
    /**
 * @namespace Chart.helpers.canvas
 */ var exports$1 = {
        /**
	 * Clears the entire canvas associated to the given `chart`.
	 * @param {Chart} chart - The chart for which to clear the canvas.
	 */ clear: function(chart) {
            chart.ctx.clearRect(0, 0, chart.width, chart.height);
        },
        /**
	 * Creates a "path" for a rectangle with rounded corners at position (x, y) with a
	 * given size (width, height) and the same `radius` for all corners.
	 * @param {CanvasRenderingContext2D} ctx - The canvas 2D Context.
	 * @param {number} x - The x axis of the coordinate for the rectangle starting point.
	 * @param {number} y - The y axis of the coordinate for the rectangle starting point.
	 * @param {number} width - The rectangle's width.
	 * @param {number} height - The rectangle's height.
	 * @param {number} radius - The rounded amount (in pixels) for the four corners.
	 * @todo handle `radius` as top-left, top-right, bottom-right, bottom-left array/object?
	 */ roundedRect: function(ctx, x, y, width, height, radius) {
            if (radius) {
                var r = Math.min(radius, height / 2, width / 2);
                var left = x + r;
                var top = y + r;
                var right = x + width - r;
                var bottom = y + height - r;
                ctx.moveTo(x, top);
                if (left < right && top < bottom) {
                    ctx.arc(left, top, r, -PI, -HALF_PI);
                    ctx.arc(right, top, r, -HALF_PI, 0);
                    ctx.arc(right, bottom, r, 0, HALF_PI);
                    ctx.arc(left, bottom, r, HALF_PI, PI);
                } else if (left < right) {
                    ctx.moveTo(left, y);
                    ctx.arc(right, top, r, -HALF_PI, HALF_PI);
                    ctx.arc(left, top, r, HALF_PI, PI + HALF_PI);
                } else if (top < bottom) {
                    ctx.arc(left, top, r, -PI, 0);
                    ctx.arc(left, bottom, r, 0, PI);
                } else ctx.arc(left, top, r, -PI, PI);
                ctx.closePath();
                ctx.moveTo(x, y);
            } else ctx.rect(x, y, width, height);
        },
        drawPoint: function(ctx, style, radius, x, y, rotation) {
            var type, xOffset, yOffset, size, cornerRadius;
            var rad = (rotation || 0) * RAD_PER_DEG;
            if (style && typeof style === 'object') {
                type = style.toString();
                if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
                    ctx.save();
                    ctx.translate(x, y);
                    ctx.rotate(rad);
                    ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
                    ctx.restore();
                    return;
                }
            }
            if (isNaN(radius) || radius <= 0) return;
            ctx.beginPath();
            switch(style){
                // Default includes circle
                default:
                    ctx.arc(x, y, radius, 0, DOUBLE_PI);
                    ctx.closePath();
                    break;
                case 'triangle':
                    ctx.moveTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
                    rad += TWO_THIRDS_PI;
                    ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
                    rad += TWO_THIRDS_PI;
                    ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
                    ctx.closePath();
                    break;
                case 'rectRounded':
                    // NOTE: the rounded rect implementation changed to use `arc` instead of
                    // `quadraticCurveTo` since it generates better results when rect is
                    // almost a circle. 0.516 (instead of 0.5) produces results with visually
                    // closer proportion to the previous impl and it is inscribed in the
                    // circle with `radius`. For more details, see the following PRs:
                    // https://github.com/chartjs/Chart.js/issues/5597
                    // https://github.com/chartjs/Chart.js/issues/5858
                    cornerRadius = radius * 0.516;
                    size = radius - cornerRadius;
                    xOffset = Math.cos(rad + QUARTER_PI) * size;
                    yOffset = Math.sin(rad + QUARTER_PI) * size;
                    ctx.arc(x - xOffset, y - yOffset, cornerRadius, rad - PI, rad - HALF_PI);
                    ctx.arc(x + yOffset, y - xOffset, cornerRadius, rad - HALF_PI, rad);
                    ctx.arc(x + xOffset, y + yOffset, cornerRadius, rad, rad + HALF_PI);
                    ctx.arc(x - yOffset, y + xOffset, cornerRadius, rad + HALF_PI, rad + PI);
                    ctx.closePath();
                    break;
                case 'rect':
                    if (!rotation) {
                        size = Math.SQRT1_2 * radius;
                        ctx.rect(x - size, y - size, 2 * size, 2 * size);
                        break;
                    }
                    rad += QUARTER_PI;
                /* falls through */ case 'rectRot':
                    xOffset = Math.cos(rad) * radius;
                    yOffset = Math.sin(rad) * radius;
                    ctx.moveTo(x - xOffset, y - yOffset);
                    ctx.lineTo(x + yOffset, y - xOffset);
                    ctx.lineTo(x + xOffset, y + yOffset);
                    ctx.lineTo(x - yOffset, y + xOffset);
                    ctx.closePath();
                    break;
                case 'crossRot':
                    rad += QUARTER_PI;
                /* falls through */ case 'cross':
                    xOffset = Math.cos(rad) * radius;
                    yOffset = Math.sin(rad) * radius;
                    ctx.moveTo(x - xOffset, y - yOffset);
                    ctx.lineTo(x + xOffset, y + yOffset);
                    ctx.moveTo(x + yOffset, y - xOffset);
                    ctx.lineTo(x - yOffset, y + xOffset);
                    break;
                case 'star':
                    xOffset = Math.cos(rad) * radius;
                    yOffset = Math.sin(rad) * radius;
                    ctx.moveTo(x - xOffset, y - yOffset);
                    ctx.lineTo(x + xOffset, y + yOffset);
                    ctx.moveTo(x + yOffset, y - xOffset);
                    ctx.lineTo(x - yOffset, y + xOffset);
                    rad += QUARTER_PI;
                    xOffset = Math.cos(rad) * radius;
                    yOffset = Math.sin(rad) * radius;
                    ctx.moveTo(x - xOffset, y - yOffset);
                    ctx.lineTo(x + xOffset, y + yOffset);
                    ctx.moveTo(x + yOffset, y - xOffset);
                    ctx.lineTo(x - yOffset, y + xOffset);
                    break;
                case 'line':
                    xOffset = Math.cos(rad) * radius;
                    yOffset = Math.sin(rad) * radius;
                    ctx.moveTo(x - xOffset, y - yOffset);
                    ctx.lineTo(x + xOffset, y + yOffset);
                    break;
                case 'dash':
                    ctx.moveTo(x, y);
                    ctx.lineTo(x + Math.cos(rad) * radius, y + Math.sin(rad) * radius);
                    break;
            }
            ctx.fill();
            ctx.stroke();
        },
        /**
	 * Returns true if the point is inside the rectangle
	 * @param {object} point - The point to test
	 * @param {object} area - The rectangle
	 * @returns {boolean}
	 * @private
	 */ _isPointInArea: function(point, area) {
            var epsilon = 1e-6; // 1e-6 is margin in pixels for accumulated error.
            return point.x > area.left - epsilon && point.x < area.right + epsilon && point.y > area.top - epsilon && point.y < area.bottom + epsilon;
        },
        clipArea: function(ctx, area) {
            ctx.save();
            ctx.beginPath();
            ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
            ctx.clip();
        },
        unclipArea: function(ctx) {
            ctx.restore();
        },
        lineTo: function(ctx, previous, target, flip) {
            var stepped = target.steppedLine;
            if (stepped) {
                if (stepped === 'middle') {
                    var midpoint = (previous.x + target.x) / 2.0;
                    ctx.lineTo(midpoint, flip ? target.y : previous.y);
                    ctx.lineTo(midpoint, flip ? previous.y : target.y);
                } else if (stepped === 'after' && !flip || stepped !== 'after' && flip) ctx.lineTo(previous.x, target.y);
                else ctx.lineTo(target.x, previous.y);
                ctx.lineTo(target.x, target.y);
                return;
            }
            if (!target.tension) {
                ctx.lineTo(target.x, target.y);
                return;
            }
            ctx.bezierCurveTo(flip ? previous.controlPointPreviousX : previous.controlPointNextX, flip ? previous.controlPointPreviousY : previous.controlPointNextY, flip ? target.controlPointNextX : target.controlPointPreviousX, flip ? target.controlPointNextY : target.controlPointPreviousY, target.x, target.y);
        }
    };
    var helpers_canvas = exports$1;
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, use Chart.helpers.canvas.clear instead.
 * @namespace Chart.helpers.clear
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers_core.clear = exports$1.clear;
    /**
 * Provided for backward compatibility, use Chart.helpers.canvas.roundedRect instead.
 * @namespace Chart.helpers.drawRoundedRectangle
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers_core.drawRoundedRectangle = function(ctx) {
        ctx.beginPath();
        exports$1.roundedRect.apply(exports$1, arguments);
    };
    var defaults = {
        /**
	 * @private
	 */ _set: function(scope, values) {
            return helpers_core.merge(this[scope] || (this[scope] = {}), values);
        }
    };
    // TODO(v3): remove 'global' from namespace.  all default are global and
    // there's inconsistency around which options are under 'global'
    defaults._set('global', {
        defaultColor: 'rgba(0,0,0,0.1)',
        defaultFontColor: '#666',
        defaultFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        defaultFontSize: 12,
        defaultFontStyle: 'normal',
        defaultLineHeight: 1.2,
        showLines: true
    });
    var core_defaults = defaults;
    var valueOrDefault = helpers_core.valueOrDefault;
    /**
 * Converts the given font object into a CSS font string.
 * @param {object} font - A font object.
 * @return {string} The CSS font string. See https://developer.mozilla.org/en-US/docs/Web/CSS/font
 * @private
 */ function toFontString(font) {
        if (!font || helpers_core.isNullOrUndef(font.size) || helpers_core.isNullOrUndef(font.family)) return null;
        return (font.style ? font.style + ' ' : '') + (font.weight ? font.weight + ' ' : '') + font.size + 'px ' + font.family;
    }
    /**
 * @alias Chart.helpers.options
 * @namespace
 */ var helpers_options = {
        /**
	 * Converts the given line height `value` in pixels for a specific font `size`.
	 * @param {number|string} value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
	 * @param {number} size - The font size (in pixels) used to resolve relative `value`.
	 * @returns {number} The effective line height in pixels (size * 1.2 if value is invalid).
	 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
	 * @since 2.7.0
	 */ toLineHeight: function(value, size) {
            var matches = ('' + value).match(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
            if (!matches || matches[1] === 'normal') return size * 1.2;
            value = +matches[2];
            switch(matches[3]){
                case 'px':
                    return value;
                case '%':
                    value /= 100;
                    break;
            }
            return size * value;
        },
        /**
	 * Converts the given value into a padding object with pre-computed width/height.
	 * @param {number|object} value - If a number, set the value to all TRBL component,
	 *  else, if and object, use defined properties and sets undefined ones to 0.
	 * @returns {object} The padding values (top, right, bottom, left, width, height)
	 * @since 2.7.0
	 */ toPadding: function(value) {
            var t, r, b, l;
            if (helpers_core.isObject(value)) {
                t = +value.top || 0;
                r = +value.right || 0;
                b = +value.bottom || 0;
                l = +value.left || 0;
            } else t = r = b = l = +value || 0;
            return {
                top: t,
                right: r,
                bottom: b,
                left: l,
                height: t + b,
                width: l + r
            };
        },
        /**
	 * Parses font options and returns the font object.
	 * @param {object} options - A object that contains font options to be parsed.
	 * @return {object} The font object.
	 * @todo Support font.* options and renamed to toFont().
	 * @private
	 */ _parseFont: function(options) {
            var globalDefaults = core_defaults.global;
            var size = valueOrDefault(options.fontSize, globalDefaults.defaultFontSize);
            var font = {
                family: valueOrDefault(options.fontFamily, globalDefaults.defaultFontFamily),
                lineHeight: helpers_core.options.toLineHeight(valueOrDefault(options.lineHeight, globalDefaults.defaultLineHeight), size),
                size: size,
                style: valueOrDefault(options.fontStyle, globalDefaults.defaultFontStyle),
                weight: null,
                string: ''
            };
            font.string = toFontString(font);
            return font;
        },
        /**
	 * Evaluates the given `inputs` sequentially and returns the first defined value.
	 * @param {Array} inputs - An array of values, falling back to the last value.
	 * @param {object} [context] - If defined and the current value is a function, the value
	 * is called with `context` as first argument and the result becomes the new input.
	 * @param {number} [index] - If defined and the current value is an array, the value
	 * at `index` become the new input.
	 * @param {object} [info] - object to return information about resolution in
	 * @param {boolean} [info.cacheable] - Will be set to `false` if option is not cacheable.
	 * @since 2.7.0
	 */ resolve: function(inputs, context, index, info) {
            var cacheable = true;
            var i, ilen, value;
            for(i = 0, ilen = inputs.length; i < ilen; ++i){
                value = inputs[i];
                if (value === undefined) continue;
                if (context !== undefined && typeof value === 'function') {
                    value = value(context);
                    cacheable = false;
                }
                if (index !== undefined && helpers_core.isArray(value)) {
                    value = value[index];
                    cacheable = false;
                }
                if (value !== undefined) {
                    if (info && !cacheable) info.cacheable = false;
                    return value;
                }
            }
        }
    };
    /**
 * @alias Chart.helpers.math
 * @namespace
 */ var exports$2 = {
        /**
	 * Returns an array of factors sorted from 1 to sqrt(value)
	 * @private
	 */ _factorize: function(value) {
            var result = [];
            var sqrt = Math.sqrt(value);
            var i;
            for(i = 1; i < sqrt; i++)if (value % i === 0) {
                result.push(i);
                result.push(value / i);
            }
            if (sqrt === (sqrt | 0)) result.push(sqrt);
            result.sort(function(a, b) {
                return a - b;
            }).pop();
            return result;
        },
        log10: Math.log10 || function(x) {
            var exponent = Math.log(x) * Math.LOG10E; // Math.LOG10E = 1 / Math.LN10.
            // Check for whole powers of 10,
            // which due to floating point rounding error should be corrected.
            var powerOf10 = Math.round(exponent);
            var isPowerOf10 = x === Math.pow(10, powerOf10);
            return isPowerOf10 ? powerOf10 : exponent;
        }
    };
    var helpers_math = exports$2;
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, use Chart.helpers.math.log10 instead.
 * @namespace Chart.helpers.log10
 * @deprecated since version 2.9.0
 * @todo remove at version 3
 * @private
 */ helpers_core.log10 = exports$2.log10;
    var getRtlAdapter = function(rectX, width) {
        return {
            x: function(x) {
                return rectX + rectX + width - x;
            },
            setWidth: function(w) {
                width = w;
            },
            textAlign: function(align) {
                if (align === 'center') return align;
                return align === 'right' ? 'left' : 'right';
            },
            xPlus: function(x, value) {
                return x - value;
            },
            leftForLtr: function(x, itemWidth) {
                return x - itemWidth;
            }
        };
    };
    var getLtrAdapter = function() {
        return {
            x: function(x) {
                return x;
            },
            setWidth: function(w) {},
            textAlign: function(align) {
                return align;
            },
            xPlus: function(x, value) {
                return x + value;
            },
            leftForLtr: function(x, _itemWidth) {
                return x;
            }
        };
    };
    var getAdapter = function(rtl, rectX, width) {
        return rtl ? getRtlAdapter(rectX, width) : getLtrAdapter();
    };
    var overrideTextDirection = function(ctx, direction) {
        var style, original;
        if (direction === 'ltr' || direction === 'rtl') {
            style = ctx.canvas.style;
            original = [
                style.getPropertyValue('direction'),
                style.getPropertyPriority('direction')
            ];
            style.setProperty('direction', direction, 'important');
            ctx.prevTextDirection = original;
        }
    };
    var restoreTextDirection = function(ctx) {
        var original = ctx.prevTextDirection;
        if (original !== undefined) {
            delete ctx.prevTextDirection;
            ctx.canvas.style.setProperty('direction', original[0], original[1]);
        }
    };
    var helpers_rtl = {
        getRtlAdapter: getAdapter,
        overrideTextDirection: overrideTextDirection,
        restoreTextDirection: restoreTextDirection
    };
    var helpers$1 = helpers_core;
    var easing = helpers_easing;
    var canvas = helpers_canvas;
    var options = helpers_options;
    var math = helpers_math;
    var rtl = helpers_rtl;
    helpers$1.easing = easing;
    helpers$1.canvas = canvas;
    helpers$1.options = options;
    helpers$1.math = math;
    helpers$1.rtl = rtl;
    function interpolate(start, view, model, ease) {
        var keys = Object.keys(model);
        var i, ilen, key, actual, origin, target, type, c0, c1;
        for(i = 0, ilen = keys.length; i < ilen; ++i){
            key = keys[i];
            target = model[key];
            // if a value is added to the model after pivot() has been called, the view
            // doesn't contain it, so let's initialize the view to the target value.
            if (!view.hasOwnProperty(key)) view[key] = target;
            actual = view[key];
            if (actual === target || key[0] === '_') continue;
            if (!start.hasOwnProperty(key)) start[key] = actual;
            origin = start[key];
            type = typeof target;
            if (type === typeof origin) {
                if (type === 'string') {
                    c0 = chartjsColor(origin);
                    if (c0.valid) {
                        c1 = chartjsColor(target);
                        if (c1.valid) {
                            view[key] = c1.mix(c0, ease).rgbString();
                            continue;
                        }
                    }
                } else if (helpers$1.isFinite(origin) && helpers$1.isFinite(target)) {
                    view[key] = origin + (target - origin) * ease;
                    continue;
                }
            }
            view[key] = target;
        }
    }
    var Element = function(configuration) {
        helpers$1.extend(this, configuration);
        this.initialize.apply(this, arguments);
    };
    helpers$1.extend(Element.prototype, {
        _type: undefined,
        initialize: function() {
            this.hidden = false;
        },
        pivot: function() {
            var me = this;
            if (!me._view) me._view = helpers$1.extend({}, me._model);
            me._start = {};
            return me;
        },
        transition: function(ease) {
            var me = this;
            var model = me._model;
            var start = me._start;
            var view = me._view;
            // No animation -> No Transition
            if (!model || ease === 1) {
                me._view = helpers$1.extend({}, model);
                me._start = null;
                return me;
            }
            if (!view) view = me._view = {};
            if (!start) start = me._start = {};
            interpolate(start, view, model, ease);
            return me;
        },
        tooltipPosition: function() {
            return {
                x: this._model.x,
                y: this._model.y
            };
        },
        hasValue: function() {
            return helpers$1.isNumber(this._model.x) && helpers$1.isNumber(this._model.y);
        }
    });
    Element.extend = helpers$1.inherits;
    var core_element = Element;
    var exports$3 = core_element.extend({
        chart: null,
        currentStep: 0,
        numSteps: 60,
        easing: '',
        render: null,
        onAnimationProgress: null,
        onAnimationComplete: null
    });
    var core_animation = exports$3;
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, use Chart.Animation instead
 * @prop Chart.Animation#animationObject
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 */ Object.defineProperty(exports$3.prototype, 'animationObject', {
        get: function() {
            return this;
        }
    });
    /**
 * Provided for backward compatibility, use Chart.Animation#chart instead
 * @prop Chart.Animation#chartInstance
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 */ Object.defineProperty(exports$3.prototype, 'chartInstance', {
        get: function() {
            return this.chart;
        },
        set: function(value) {
            this.chart = value;
        }
    });
    core_defaults._set('global', {
        animation: {
            duration: 1000,
            easing: 'easeOutQuart',
            onProgress: helpers$1.noop,
            onComplete: helpers$1.noop
        }
    });
    var core_animations = {
        animations: [],
        request: null,
        /**
	 * @param {Chart} chart - The chart to animate.
	 * @param {Chart.Animation} animation - The animation that we will animate.
	 * @param {number} duration - The animation duration in ms.
	 * @param {boolean} lazy - if true, the chart is not marked as animating to enable more responsive interactions
	 */ addAnimation: function(chart, animation, duration, lazy) {
            var animations = this.animations;
            var i, ilen;
            animation.chart = chart;
            animation.startTime = Date.now();
            animation.duration = duration;
            if (!lazy) chart.animating = true;
            for(i = 0, ilen = animations.length; i < ilen; ++i)if (animations[i].chart === chart) {
                animations[i] = animation;
                return;
            }
            animations.push(animation);
            // If there are no animations queued, manually kickstart a digest, for lack of a better word
            if (animations.length === 1) this.requestAnimationFrame();
        },
        cancelAnimation: function(chart) {
            var index = helpers$1.findIndex(this.animations, function(animation) {
                return animation.chart === chart;
            });
            if (index !== -1) {
                this.animations.splice(index, 1);
                chart.animating = false;
            }
        },
        requestAnimationFrame: function() {
            var me = this;
            if (me.request === null) // Skip animation frame requests until the active one is executed.
            // This can happen when processing mouse events, e.g. 'mousemove'
            // and 'mouseout' events will trigger multiple renders.
            me.request = helpers$1.requestAnimFrame.call(window, function() {
                me.request = null;
                me.startDigest();
            });
        },
        /**
	 * @private
	 */ startDigest: function() {
            var me = this;
            me.advance();
            // Do we have more stuff to animate?
            if (me.animations.length > 0) me.requestAnimationFrame();
        },
        /**
	 * @private
	 */ advance: function() {
            var animations = this.animations;
            var animation, chart, numSteps, nextStep;
            var i = 0;
            // 1 animation per chart, so we are looping charts here
            while(i < animations.length){
                animation = animations[i];
                chart = animation.chart;
                numSteps = animation.numSteps;
                // Make sure that currentStep starts at 1
                // https://github.com/chartjs/Chart.js/issues/6104
                nextStep = Math.floor((Date.now() - animation.startTime) / animation.duration * numSteps) + 1;
                animation.currentStep = Math.min(nextStep, numSteps);
                helpers$1.callback(animation.render, [
                    chart,
                    animation
                ], chart);
                helpers$1.callback(animation.onAnimationProgress, [
                    animation
                ], chart);
                if (animation.currentStep >= numSteps) {
                    helpers$1.callback(animation.onAnimationComplete, [
                        animation
                    ], chart);
                    chart.animating = false;
                    animations.splice(i, 1);
                } else ++i;
            }
        }
    };
    var resolve = helpers$1.options.resolve;
    var arrayEvents = [
        'push',
        'pop',
        'shift',
        'splice',
        'unshift'
    ];
    /**
 * Hooks the array methods that add or remove values ('push', pop', 'shift', 'splice',
 * 'unshift') and notify the listener AFTER the array has been altered. Listeners are
 * called on the 'onData*' callbacks (e.g. onDataPush, etc.) with same arguments.
 */ function listenArrayEvents(array, listener) {
        if (array._chartjs) {
            array._chartjs.listeners.push(listener);
            return;
        }
        Object.defineProperty(array, '_chartjs', {
            configurable: true,
            enumerable: false,
            value: {
                listeners: [
                    listener
                ]
            }
        });
        arrayEvents.forEach(function(key) {
            var method = 'onData' + key.charAt(0).toUpperCase() + key.slice(1);
            var base = array[key];
            Object.defineProperty(array, key, {
                configurable: true,
                enumerable: false,
                value: function() {
                    var args = Array.prototype.slice.call(arguments);
                    var res = base.apply(this, args);
                    helpers$1.each(array._chartjs.listeners, function(object) {
                        if (typeof object[method] === 'function') object[method].apply(object, args);
                    });
                    return res;
                }
            });
        });
    }
    /**
 * Removes the given array event listener and cleanup extra attached properties (such as
 * the _chartjs stub and overridden methods) if array doesn't have any more listeners.
 */ function unlistenArrayEvents(array, listener) {
        var stub = array._chartjs;
        if (!stub) return;
        var listeners = stub.listeners;
        var index = listeners.indexOf(listener);
        if (index !== -1) listeners.splice(index, 1);
        if (listeners.length > 0) return;
        arrayEvents.forEach(function(key) {
            delete array[key];
        });
        delete array._chartjs;
    }
    // Base class for all dataset controllers (line, bar, etc)
    var DatasetController = function(chart, datasetIndex) {
        this.initialize(chart, datasetIndex);
    };
    helpers$1.extend(DatasetController.prototype, {
        /**
	 * Element type used to generate a meta dataset (e.g. Chart.element.Line).
	 * @type {Chart.core.element}
	 */ datasetElementType: null,
        /**
	 * Element type used to generate a meta data (e.g. Chart.element.Point).
	 * @type {Chart.core.element}
	 */ dataElementType: null,
        /**
	 * Dataset element option keys to be resolved in _resolveDatasetElementOptions.
	 * A derived controller may override this to resolve controller-specific options.
	 * The keys defined here are for backward compatibility for legend styles.
	 * @private
	 */ _datasetElementOptions: [
            'backgroundColor',
            'borderCapStyle',
            'borderColor',
            'borderDash',
            'borderDashOffset',
            'borderJoinStyle',
            'borderWidth'
        ],
        /**
	 * Data element option keys to be resolved in _resolveDataElementOptions.
	 * A derived controller may override this to resolve controller-specific options.
	 * The keys defined here are for backward compatibility for legend styles.
	 * @private
	 */ _dataElementOptions: [
            'backgroundColor',
            'borderColor',
            'borderWidth',
            'pointStyle'
        ],
        initialize: function(chart, datasetIndex) {
            var me = this;
            me.chart = chart;
            me.index = datasetIndex;
            me.linkScales();
            me.addElements();
            me._type = me.getMeta().type;
        },
        updateIndex: function(datasetIndex) {
            this.index = datasetIndex;
        },
        linkScales: function() {
            var me = this;
            var meta = me.getMeta();
            var chart = me.chart;
            var scales = chart.scales;
            var dataset = me.getDataset();
            var scalesOpts = chart.options.scales;
            if (meta.xAxisID === null || !(meta.xAxisID in scales) || dataset.xAxisID) meta.xAxisID = dataset.xAxisID || scalesOpts.xAxes[0].id;
            if (meta.yAxisID === null || !(meta.yAxisID in scales) || dataset.yAxisID) meta.yAxisID = dataset.yAxisID || scalesOpts.yAxes[0].id;
        },
        getDataset: function() {
            return this.chart.data.datasets[this.index];
        },
        getMeta: function() {
            return this.chart.getDatasetMeta(this.index);
        },
        getScaleForId: function(scaleID) {
            return this.chart.scales[scaleID];
        },
        /**
	 * @private
	 */ _getValueScaleId: function() {
            return this.getMeta().yAxisID;
        },
        /**
	 * @private
	 */ _getIndexScaleId: function() {
            return this.getMeta().xAxisID;
        },
        /**
	 * @private
	 */ _getValueScale: function() {
            return this.getScaleForId(this._getValueScaleId());
        },
        /**
	 * @private
	 */ _getIndexScale: function() {
            return this.getScaleForId(this._getIndexScaleId());
        },
        reset: function() {
            this._update(true);
        },
        /**
	 * @private
	 */ destroy: function() {
            if (this._data) unlistenArrayEvents(this._data, this);
        },
        createMetaDataset: function() {
            var me = this;
            var type = me.datasetElementType;
            return type && new type({
                _chart: me.chart,
                _datasetIndex: me.index
            });
        },
        createMetaData: function(index) {
            var me = this;
            var type = me.dataElementType;
            return type && new type({
                _chart: me.chart,
                _datasetIndex: me.index,
                _index: index
            });
        },
        addElements: function() {
            var me = this;
            var meta = me.getMeta();
            var data = me.getDataset().data || [];
            var metaData = meta.data;
            var i, ilen;
            for(i = 0, ilen = data.length; i < ilen; ++i)metaData[i] = metaData[i] || me.createMetaData(i);
            meta.dataset = meta.dataset || me.createMetaDataset();
        },
        addElementAndReset: function(index) {
            var element = this.createMetaData(index);
            this.getMeta().data.splice(index, 0, element);
            this.updateElement(element, index, true);
        },
        buildOrUpdateElements: function() {
            var me = this;
            var dataset = me.getDataset();
            var data = dataset.data || (dataset.data = []);
            // In order to correctly handle data addition/deletion animation (an thus simulate
            // real-time charts), we need to monitor these data modifications and synchronize
            // the internal meta data accordingly.
            if (me._data !== data) {
                if (me._data) // This case happens when the user replaced the data array instance.
                unlistenArrayEvents(me._data, me);
                if (data && Object.isExtensible(data)) listenArrayEvents(data, me);
                me._data = data;
            }
            // Re-sync meta data in case the user replaced the data array or if we missed
            // any updates and so make sure that we handle number of datapoints changing.
            me.resyncElements();
        },
        /**
	 * Returns the merged user-supplied and default dataset-level options
	 * @private
	 */ _configure: function() {
            var me = this;
            me._config = helpers$1.merge(Object.create(null), [
                me.chart.options.datasets[me._type],
                me.getDataset()
            ], {
                merger: function(key, target, source) {
                    if (key !== '_meta' && key !== 'data') helpers$1._merger(key, target, source);
                }
            });
        },
        _update: function(reset) {
            var me = this;
            me._configure();
            me._cachedDataOpts = null;
            me.update(reset);
        },
        update: helpers$1.noop,
        transition: function(easingValue) {
            var meta = this.getMeta();
            var elements = meta.data || [];
            var ilen = elements.length;
            var i = 0;
            for(; i < ilen; ++i)elements[i].transition(easingValue);
            if (meta.dataset) meta.dataset.transition(easingValue);
        },
        draw: function() {
            var meta = this.getMeta();
            var elements = meta.data || [];
            var ilen = elements.length;
            var i = 0;
            if (meta.dataset) meta.dataset.draw();
            for(; i < ilen; ++i)elements[i].draw();
        },
        /**
	 * Returns a set of predefined style properties that should be used to represent the dataset
	 * or the data if the index is specified
	 * @param {number} index - data index
	 * @return {IStyleInterface} style object
	 */ getStyle: function(index) {
            var me = this;
            var meta = me.getMeta();
            var dataset = meta.dataset;
            var style;
            me._configure();
            if (dataset && index === undefined) style = me._resolveDatasetElementOptions(dataset || {});
            else {
                index = index || 0;
                style = me._resolveDataElementOptions(meta.data[index] || {}, index);
            }
            if (style.fill === false || style.fill === null) style.backgroundColor = style.borderColor;
            return style;
        },
        /**
	 * @private
	 */ _resolveDatasetElementOptions: function(element, hover) {
            var me = this;
            var chart = me.chart;
            var datasetOpts = me._config;
            var custom = element.custom || {};
            var options = chart.options.elements[me.datasetElementType.prototype._type] || {};
            var elementOptions = me._datasetElementOptions;
            var values = {};
            var i, ilen, key, readKey;
            // Scriptable options
            var context = {
                chart: chart,
                dataset: me.getDataset(),
                datasetIndex: me.index,
                hover: hover
            };
            for(i = 0, ilen = elementOptions.length; i < ilen; ++i){
                key = elementOptions[i];
                readKey = hover ? 'hover' + key.charAt(0).toUpperCase() + key.slice(1) : key;
                values[key] = resolve([
                    custom[readKey],
                    datasetOpts[readKey],
                    options[readKey]
                ], context);
            }
            return values;
        },
        /**
	 * @private
	 */ _resolveDataElementOptions: function(element, index) {
            var me = this;
            var custom = element && element.custom;
            var cached = me._cachedDataOpts;
            if (cached && !custom) return cached;
            var chart = me.chart;
            var datasetOpts = me._config;
            var options = chart.options.elements[me.dataElementType.prototype._type] || {};
            var elementOptions = me._dataElementOptions;
            var values = {};
            // Scriptable options
            var context = {
                chart: chart,
                dataIndex: index,
                dataset: me.getDataset(),
                datasetIndex: me.index
            };
            // `resolve` sets cacheable to `false` if any option is indexed or scripted
            var info = {
                cacheable: !custom
            };
            var keys, i, ilen, key;
            custom = custom || {};
            if (helpers$1.isArray(elementOptions)) for(i = 0, ilen = elementOptions.length; i < ilen; ++i){
                key = elementOptions[i];
                values[key] = resolve([
                    custom[key],
                    datasetOpts[key],
                    options[key]
                ], context, index, info);
            }
            else {
                keys = Object.keys(elementOptions);
                for(i = 0, ilen = keys.length; i < ilen; ++i){
                    key = keys[i];
                    values[key] = resolve([
                        custom[key],
                        datasetOpts[elementOptions[key]],
                        datasetOpts[key],
                        options[key]
                    ], context, index, info);
                }
            }
            if (info.cacheable) me._cachedDataOpts = Object.freeze(values);
            return values;
        },
        removeHoverStyle: function(element) {
            helpers$1.merge(element._model, element.$previousStyle || {});
            delete element.$previousStyle;
        },
        setHoverStyle: function(element) {
            var dataset = this.chart.data.datasets[element._datasetIndex];
            var index = element._index;
            var custom = element.custom || {};
            var model = element._model;
            var getHoverColor = helpers$1.getHoverColor;
            element.$previousStyle = {
                backgroundColor: model.backgroundColor,
                borderColor: model.borderColor,
                borderWidth: model.borderWidth
            };
            model.backgroundColor = resolve([
                custom.hoverBackgroundColor,
                dataset.hoverBackgroundColor,
                getHoverColor(model.backgroundColor)
            ], undefined, index);
            model.borderColor = resolve([
                custom.hoverBorderColor,
                dataset.hoverBorderColor,
                getHoverColor(model.borderColor)
            ], undefined, index);
            model.borderWidth = resolve([
                custom.hoverBorderWidth,
                dataset.hoverBorderWidth,
                model.borderWidth
            ], undefined, index);
        },
        /**
	 * @private
	 */ _removeDatasetHoverStyle: function() {
            var element = this.getMeta().dataset;
            if (element) this.removeHoverStyle(element);
        },
        /**
	 * @private
	 */ _setDatasetHoverStyle: function() {
            var element = this.getMeta().dataset;
            var prev = {};
            var i, ilen, key, keys, hoverOptions, model;
            if (!element) return;
            model = element._model;
            hoverOptions = this._resolveDatasetElementOptions(element, true);
            keys = Object.keys(hoverOptions);
            for(i = 0, ilen = keys.length; i < ilen; ++i){
                key = keys[i];
                prev[key] = model[key];
                model[key] = hoverOptions[key];
            }
            element.$previousStyle = prev;
        },
        /**
	 * @private
	 */ resyncElements: function() {
            var me = this;
            var meta = me.getMeta();
            var data = me.getDataset().data;
            var numMeta = meta.data.length;
            var numData = data.length;
            if (numData < numMeta) meta.data.splice(numData, numMeta - numData);
            else if (numData > numMeta) me.insertElements(numMeta, numData - numMeta);
        },
        /**
	 * @private
	 */ insertElements: function(start, count) {
            for(var i = 0; i < count; ++i)this.addElementAndReset(start + i);
        },
        /**
	 * @private
	 */ onDataPush: function() {
            var count = arguments.length;
            this.insertElements(this.getDataset().data.length - count, count);
        },
        /**
	 * @private
	 */ onDataPop: function() {
            this.getMeta().data.pop();
        },
        /**
	 * @private
	 */ onDataShift: function() {
            this.getMeta().data.shift();
        },
        /**
	 * @private
	 */ onDataSplice: function(start, count) {
            this.getMeta().data.splice(start, count);
            this.insertElements(start, arguments.length - 2);
        },
        /**
	 * @private
	 */ onDataUnshift: function() {
            this.insertElements(0, arguments.length);
        }
    });
    DatasetController.extend = helpers$1.inherits;
    var core_datasetController = DatasetController;
    var TAU = Math.PI * 2;
    core_defaults._set('global', {
        elements: {
            arc: {
                backgroundColor: core_defaults.global.defaultColor,
                borderColor: '#fff',
                borderWidth: 2,
                borderAlign: 'center'
            }
        }
    });
    function clipArc(ctx, arc) {
        var startAngle = arc.startAngle;
        var endAngle = arc.endAngle;
        var pixelMargin = arc.pixelMargin;
        var angleMargin = pixelMargin / arc.outerRadius;
        var x = arc.x;
        var y = arc.y;
        // Draw an inner border by cliping the arc and drawing a double-width border
        // Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
        ctx.beginPath();
        ctx.arc(x, y, arc.outerRadius, startAngle - angleMargin, endAngle + angleMargin);
        if (arc.innerRadius > pixelMargin) {
            angleMargin = pixelMargin / arc.innerRadius;
            ctx.arc(x, y, arc.innerRadius - pixelMargin, endAngle + angleMargin, startAngle - angleMargin, true);
        } else ctx.arc(x, y, pixelMargin, endAngle + Math.PI / 2, startAngle - Math.PI / 2);
        ctx.closePath();
        ctx.clip();
    }
    function drawFullCircleBorders(ctx, vm, arc, inner) {
        var endAngle = arc.endAngle;
        var i;
        if (inner) {
            arc.endAngle = arc.startAngle + TAU;
            clipArc(ctx, arc);
            arc.endAngle = endAngle;
            if (arc.endAngle === arc.startAngle && arc.fullCircles) {
                arc.endAngle += TAU;
                arc.fullCircles--;
            }
        }
        ctx.beginPath();
        ctx.arc(arc.x, arc.y, arc.innerRadius, arc.startAngle + TAU, arc.startAngle, true);
        for(i = 0; i < arc.fullCircles; ++i)ctx.stroke();
        ctx.beginPath();
        ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.startAngle + TAU);
        for(i = 0; i < arc.fullCircles; ++i)ctx.stroke();
    }
    function drawBorder(ctx, vm, arc) {
        var inner = vm.borderAlign === 'inner';
        if (inner) {
            ctx.lineWidth = vm.borderWidth * 2;
            ctx.lineJoin = 'round';
        } else {
            ctx.lineWidth = vm.borderWidth;
            ctx.lineJoin = 'bevel';
        }
        if (arc.fullCircles) drawFullCircleBorders(ctx, vm, arc, inner);
        if (inner) clipArc(ctx, arc);
        ctx.beginPath();
        ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.endAngle);
        ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
        ctx.closePath();
        ctx.stroke();
    }
    var element_arc = core_element.extend({
        _type: 'arc',
        inLabelRange: function(mouseX) {
            var vm = this._view;
            if (vm) return Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hoverRadius, 2);
            return false;
        },
        inRange: function(chartX, chartY) {
            var vm = this._view;
            if (vm) {
                var pointRelativePosition = helpers$1.getAngleFromPoint(vm, {
                    x: chartX,
                    y: chartY
                });
                var angle = pointRelativePosition.angle;
                var distance = pointRelativePosition.distance;
                // Sanitise angle range
                var startAngle = vm.startAngle;
                var endAngle = vm.endAngle;
                while(endAngle < startAngle)endAngle += TAU;
                while(angle > endAngle)angle -= TAU;
                while(angle < startAngle)angle += TAU;
                // Check if within the range of the open/close angle
                var betweenAngles = angle >= startAngle && angle <= endAngle;
                var withinRadius = distance >= vm.innerRadius && distance <= vm.outerRadius;
                return betweenAngles && withinRadius;
            }
            return false;
        },
        getCenterPoint: function() {
            var vm = this._view;
            var halfAngle = (vm.startAngle + vm.endAngle) / 2;
            var halfRadius = (vm.innerRadius + vm.outerRadius) / 2;
            return {
                x: vm.x + Math.cos(halfAngle) * halfRadius,
                y: vm.y + Math.sin(halfAngle) * halfRadius
            };
        },
        getArea: function() {
            var vm = this._view;
            return Math.PI * ((vm.endAngle - vm.startAngle) / (2 * Math.PI)) * (Math.pow(vm.outerRadius, 2) - Math.pow(vm.innerRadius, 2));
        },
        tooltipPosition: function() {
            var vm = this._view;
            var centreAngle = vm.startAngle + (vm.endAngle - vm.startAngle) / 2;
            var rangeFromCentre = (vm.outerRadius - vm.innerRadius) / 2 + vm.innerRadius;
            return {
                x: vm.x + Math.cos(centreAngle) * rangeFromCentre,
                y: vm.y + Math.sin(centreAngle) * rangeFromCentre
            };
        },
        draw: function() {
            var ctx = this._chart.ctx;
            var vm = this._view;
            var pixelMargin = vm.borderAlign === 'inner' ? 0.33 : 0;
            var arc = {
                x: vm.x,
                y: vm.y,
                innerRadius: vm.innerRadius,
                outerRadius: Math.max(vm.outerRadius - pixelMargin, 0),
                pixelMargin: pixelMargin,
                startAngle: vm.startAngle,
                endAngle: vm.endAngle,
                fullCircles: Math.floor(vm.circumference / TAU)
            };
            var i;
            ctx.save();
            ctx.fillStyle = vm.backgroundColor;
            ctx.strokeStyle = vm.borderColor;
            if (arc.fullCircles) {
                arc.endAngle = arc.startAngle + TAU;
                ctx.beginPath();
                ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
                ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
                ctx.closePath();
                for(i = 0; i < arc.fullCircles; ++i)ctx.fill();
                arc.endAngle = arc.startAngle + vm.circumference % TAU;
            }
            ctx.beginPath();
            ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
            ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
            ctx.closePath();
            ctx.fill();
            if (vm.borderWidth) drawBorder(ctx, vm, arc);
            ctx.restore();
        }
    });
    var valueOrDefault$1 = helpers$1.valueOrDefault;
    var defaultColor = core_defaults.global.defaultColor;
    core_defaults._set('global', {
        elements: {
            line: {
                tension: 0.4,
                backgroundColor: defaultColor,
                borderWidth: 3,
                borderColor: defaultColor,
                borderCapStyle: 'butt',
                borderDash: [],
                borderDashOffset: 0.0,
                borderJoinStyle: 'miter',
                capBezierPoints: true,
                fill: true
            }
        }
    });
    var element_line = core_element.extend({
        _type: 'line',
        draw: function() {
            var me = this;
            var vm = me._view;
            var ctx = me._chart.ctx;
            var spanGaps = vm.spanGaps;
            var points = me._children.slice(); // clone array
            var globalDefaults = core_defaults.global;
            var globalOptionLineElements = globalDefaults.elements.line;
            var lastDrawnIndex = -1;
            var closePath = me._loop;
            var index, previous, currentVM;
            if (!points.length) return;
            if (me._loop) {
                for(index = 0; index < points.length; ++index){
                    previous = helpers$1.previousItem(points, index);
                    // If the line has an open path, shift the point array
                    if (!points[index]._view.skip && previous._view.skip) {
                        points = points.slice(index).concat(points.slice(0, index));
                        closePath = spanGaps;
                        break;
                    }
                }
                // If the line has a close path, add the first point again
                if (closePath) points.push(points[0]);
            }
            ctx.save();
            // Stroke Line Options
            ctx.lineCap = vm.borderCapStyle || globalOptionLineElements.borderCapStyle;
            // IE 9 and 10 do not support line dash
            if (ctx.setLineDash) ctx.setLineDash(vm.borderDash || globalOptionLineElements.borderDash);
            ctx.lineDashOffset = valueOrDefault$1(vm.borderDashOffset, globalOptionLineElements.borderDashOffset);
            ctx.lineJoin = vm.borderJoinStyle || globalOptionLineElements.borderJoinStyle;
            ctx.lineWidth = valueOrDefault$1(vm.borderWidth, globalOptionLineElements.borderWidth);
            ctx.strokeStyle = vm.borderColor || globalDefaults.defaultColor;
            // Stroke Line
            ctx.beginPath();
            // First point moves to it's starting position no matter what
            currentVM = points[0]._view;
            if (!currentVM.skip) {
                ctx.moveTo(currentVM.x, currentVM.y);
                lastDrawnIndex = 0;
            }
            for(index = 1; index < points.length; ++index){
                currentVM = points[index]._view;
                previous = lastDrawnIndex === -1 ? helpers$1.previousItem(points, index) : points[lastDrawnIndex];
                if (!currentVM.skip) {
                    if (lastDrawnIndex !== index - 1 && !spanGaps || lastDrawnIndex === -1) // There was a gap and this is the first point after the gap
                    ctx.moveTo(currentVM.x, currentVM.y);
                    else // Line to next point
                    helpers$1.canvas.lineTo(ctx, previous._view, currentVM);
                    lastDrawnIndex = index;
                }
            }
            if (closePath) ctx.closePath();
            ctx.stroke();
            ctx.restore();
        }
    });
    var valueOrDefault$2 = helpers$1.valueOrDefault;
    var defaultColor$1 = core_defaults.global.defaultColor;
    core_defaults._set('global', {
        elements: {
            point: {
                radius: 3,
                pointStyle: 'circle',
                backgroundColor: defaultColor$1,
                borderColor: defaultColor$1,
                borderWidth: 1,
                // Hover
                hitRadius: 1,
                hoverRadius: 4,
                hoverBorderWidth: 1
            }
        }
    });
    function xRange(mouseX) {
        var vm = this._view;
        return vm ? Math.abs(mouseX - vm.x) < vm.radius + vm.hitRadius : false;
    }
    function yRange(mouseY) {
        var vm = this._view;
        return vm ? Math.abs(mouseY - vm.y) < vm.radius + vm.hitRadius : false;
    }
    var element_point = core_element.extend({
        _type: 'point',
        inRange: function(mouseX, mouseY) {
            var vm = this._view;
            return vm ? Math.pow(mouseX - vm.x, 2) + Math.pow(mouseY - vm.y, 2) < Math.pow(vm.hitRadius + vm.radius, 2) : false;
        },
        inLabelRange: xRange,
        inXRange: xRange,
        inYRange: yRange,
        getCenterPoint: function() {
            var vm = this._view;
            return {
                x: vm.x,
                y: vm.y
            };
        },
        getArea: function() {
            return Math.PI * Math.pow(this._view.radius, 2);
        },
        tooltipPosition: function() {
            var vm = this._view;
            return {
                x: vm.x,
                y: vm.y,
                padding: vm.radius + vm.borderWidth
            };
        },
        draw: function(chartArea) {
            var vm = this._view;
            var ctx = this._chart.ctx;
            var pointStyle = vm.pointStyle;
            var rotation = vm.rotation;
            var radius = vm.radius;
            var x = vm.x;
            var y = vm.y;
            var globalDefaults = core_defaults.global;
            var defaultColor = globalDefaults.defaultColor; // eslint-disable-line no-shadow
            if (vm.skip) return;
            // Clipping for Points.
            if (chartArea === undefined || helpers$1.canvas._isPointInArea(vm, chartArea)) {
                ctx.strokeStyle = vm.borderColor || defaultColor;
                ctx.lineWidth = valueOrDefault$2(vm.borderWidth, globalDefaults.elements.point.borderWidth);
                ctx.fillStyle = vm.backgroundColor || defaultColor;
                helpers$1.canvas.drawPoint(ctx, pointStyle, radius, x, y, rotation);
            }
        }
    });
    var defaultColor$2 = core_defaults.global.defaultColor;
    core_defaults._set('global', {
        elements: {
            rectangle: {
                backgroundColor: defaultColor$2,
                borderColor: defaultColor$2,
                borderSkipped: 'bottom',
                borderWidth: 0
            }
        }
    });
    function isVertical(vm) {
        return vm && vm.width !== undefined;
    }
    /**
 * Helper function to get the bounds of the bar regardless of the orientation
 * @param bar {Chart.Element.Rectangle} the bar
 * @return {Bounds} bounds of the bar
 * @private
 */ function getBarBounds(vm) {
        var x1, x2, y1, y2, half;
        if (isVertical(vm)) {
            half = vm.width / 2;
            x1 = vm.x - half;
            x2 = vm.x + half;
            y1 = Math.min(vm.y, vm.base);
            y2 = Math.max(vm.y, vm.base);
        } else {
            half = vm.height / 2;
            x1 = Math.min(vm.x, vm.base);
            x2 = Math.max(vm.x, vm.base);
            y1 = vm.y - half;
            y2 = vm.y + half;
        }
        return {
            left: x1,
            top: y1,
            right: x2,
            bottom: y2
        };
    }
    function swap(orig, v1, v2) {
        return orig === v1 ? v2 : orig === v2 ? v1 : orig;
    }
    function parseBorderSkipped(vm) {
        var edge = vm.borderSkipped;
        var res = {};
        if (!edge) return res;
        if (vm.horizontal) {
            if (vm.base > vm.x) edge = swap(edge, 'left', 'right');
        } else if (vm.base < vm.y) edge = swap(edge, 'bottom', 'top');
        res[edge] = true;
        return res;
    }
    function parseBorderWidth(vm, maxW, maxH) {
        var value = vm.borderWidth;
        var skip = parseBorderSkipped(vm);
        var t, r, b, l;
        if (helpers$1.isObject(value)) {
            t = +value.top || 0;
            r = +value.right || 0;
            b = +value.bottom || 0;
            l = +value.left || 0;
        } else t = r = b = l = +value || 0;
        return {
            t: skip.top || t < 0 ? 0 : t > maxH ? maxH : t,
            r: skip.right || r < 0 ? 0 : r > maxW ? maxW : r,
            b: skip.bottom || b < 0 ? 0 : b > maxH ? maxH : b,
            l: skip.left || l < 0 ? 0 : l > maxW ? maxW : l
        };
    }
    function boundingRects(vm) {
        var bounds = getBarBounds(vm);
        var width = bounds.right - bounds.left;
        var height = bounds.bottom - bounds.top;
        var border = parseBorderWidth(vm, width / 2, height / 2);
        return {
            outer: {
                x: bounds.left,
                y: bounds.top,
                w: width,
                h: height
            },
            inner: {
                x: bounds.left + border.l,
                y: bounds.top + border.t,
                w: width - border.l - border.r,
                h: height - border.t - border.b
            }
        };
    }
    function inRange(vm, x, y) {
        var skipX = x === null;
        var skipY = y === null;
        var bounds = !vm || skipX && skipY ? false : getBarBounds(vm);
        return bounds && (skipX || x >= bounds.left && x <= bounds.right) && (skipY || y >= bounds.top && y <= bounds.bottom);
    }
    var element_rectangle = core_element.extend({
        _type: 'rectangle',
        draw: function() {
            var ctx = this._chart.ctx;
            var vm = this._view;
            var rects = boundingRects(vm);
            var outer = rects.outer;
            var inner = rects.inner;
            ctx.fillStyle = vm.backgroundColor;
            ctx.fillRect(outer.x, outer.y, outer.w, outer.h);
            if (outer.w === inner.w && outer.h === inner.h) return;
            ctx.save();
            ctx.beginPath();
            ctx.rect(outer.x, outer.y, outer.w, outer.h);
            ctx.clip();
            ctx.fillStyle = vm.borderColor;
            ctx.rect(inner.x, inner.y, inner.w, inner.h);
            ctx.fill('evenodd');
            ctx.restore();
        },
        height: function() {
            var vm = this._view;
            return vm.base - vm.y;
        },
        inRange: function(mouseX, mouseY) {
            return inRange(this._view, mouseX, mouseY);
        },
        inLabelRange: function(mouseX, mouseY) {
            var vm = this._view;
            return isVertical(vm) ? inRange(vm, mouseX, null) : inRange(vm, null, mouseY);
        },
        inXRange: function(mouseX) {
            return inRange(this._view, mouseX, null);
        },
        inYRange: function(mouseY) {
            return inRange(this._view, null, mouseY);
        },
        getCenterPoint: function() {
            var vm = this._view;
            var x, y;
            if (isVertical(vm)) {
                x = vm.x;
                y = (vm.y + vm.base) / 2;
            } else {
                x = (vm.x + vm.base) / 2;
                y = vm.y;
            }
            return {
                x: x,
                y: y
            };
        },
        getArea: function() {
            var vm = this._view;
            return isVertical(vm) ? vm.width * Math.abs(vm.y - vm.base) : vm.height * Math.abs(vm.x - vm.base);
        },
        tooltipPosition: function() {
            var vm = this._view;
            return {
                x: vm.x,
                y: vm.y
            };
        }
    });
    var elements = {};
    var Arc = element_arc;
    var Line = element_line;
    var Point = element_point;
    var Rectangle = element_rectangle;
    elements.Arc = Arc;
    elements.Line = Line;
    elements.Point = Point;
    elements.Rectangle = Rectangle;
    var deprecated = helpers$1._deprecated;
    var valueOrDefault$3 = helpers$1.valueOrDefault;
    core_defaults._set('bar', {
        hover: {
            mode: 'label'
        },
        scales: {
            xAxes: [
                {
                    type: 'category',
                    offset: true,
                    gridLines: {
                        offsetGridLines: true
                    }
                }
            ],
            yAxes: [
                {
                    type: 'linear'
                }
            ]
        }
    });
    core_defaults._set('global', {
        datasets: {
            bar: {
                categoryPercentage: 0.8,
                barPercentage: 0.9
            }
        }
    });
    /**
 * Computes the "optimal" sample size to maintain bars equally sized while preventing overlap.
 * @private
 */ function computeMinSampleSize(scale, pixels) {
        var min = scale._length;
        var prev, curr, i, ilen;
        for(i = 1, ilen = pixels.length; i < ilen; ++i)min = Math.min(min, Math.abs(pixels[i] - pixels[i - 1]));
        for(i = 0, ilen = scale.getTicks().length; i < ilen; ++i){
            curr = scale.getPixelForTick(i);
            min = i > 0 ? Math.min(min, Math.abs(curr - prev)) : min;
            prev = curr;
        }
        return min;
    }
    /**
 * Computes an "ideal" category based on the absolute bar thickness or, if undefined or null,
 * uses the smallest interval (see computeMinSampleSize) that prevents bar overlapping. This
 * mode currently always generates bars equally sized (until we introduce scriptable options?).
 * @private
 */ function computeFitCategoryTraits(index, ruler, options) {
        var thickness = options.barThickness;
        var count = ruler.stackCount;
        var curr = ruler.pixels[index];
        var min = helpers$1.isNullOrUndef(thickness) ? computeMinSampleSize(ruler.scale, ruler.pixels) : -1;
        var size, ratio;
        if (helpers$1.isNullOrUndef(thickness)) {
            size = min * options.categoryPercentage;
            ratio = options.barPercentage;
        } else {
            // When bar thickness is enforced, category and bar percentages are ignored.
            // Note(SB): we could add support for relative bar thickness (e.g. barThickness: '50%')
            // and deprecate barPercentage since this value is ignored when thickness is absolute.
            size = thickness * count;
            ratio = 1;
        }
        return {
            chunk: size / count,
            ratio: ratio,
            start: curr - size / 2
        };
    }
    /**
 * Computes an "optimal" category that globally arranges bars side by side (no gap when
 * percentage options are 1), based on the previous and following categories. This mode
 * generates bars with different widths when data are not evenly spaced.
 * @private
 */ function computeFlexCategoryTraits(index, ruler, options) {
        var pixels = ruler.pixels;
        var curr = pixels[index];
        var prev = index > 0 ? pixels[index - 1] : null;
        var next = index < pixels.length - 1 ? pixels[index + 1] : null;
        var percent = options.categoryPercentage;
        var start, size;
        if (prev === null) // first data: its size is double based on the next point or,
        // if it's also the last data, we use the scale size.
        prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
        if (next === null) // last data: its size is also double based on the previous point.
        next = curr + curr - prev;
        start = curr - (curr - Math.min(prev, next)) / 2 * percent;
        size = Math.abs(next - prev) / 2 * percent;
        return {
            chunk: size / ruler.stackCount,
            ratio: options.barPercentage,
            start: start
        };
    }
    var controller_bar = core_datasetController.extend({
        dataElementType: elements.Rectangle,
        /**
	 * @private
	 */ _dataElementOptions: [
            'backgroundColor',
            'borderColor',
            'borderSkipped',
            'borderWidth',
            'barPercentage',
            'barThickness',
            'categoryPercentage',
            'maxBarThickness',
            'minBarLength'
        ],
        initialize: function() {
            var me = this;
            var meta, scaleOpts;
            core_datasetController.prototype.initialize.apply(me, arguments);
            meta = me.getMeta();
            meta.stack = me.getDataset().stack;
            meta.bar = true;
            scaleOpts = me._getIndexScale().options;
            deprecated('bar chart', scaleOpts.barPercentage, 'scales.[x/y]Axes.barPercentage', 'dataset.barPercentage');
            deprecated('bar chart', scaleOpts.barThickness, 'scales.[x/y]Axes.barThickness', 'dataset.barThickness');
            deprecated('bar chart', scaleOpts.categoryPercentage, 'scales.[x/y]Axes.categoryPercentage', 'dataset.categoryPercentage');
            deprecated('bar chart', me._getValueScale().options.minBarLength, 'scales.[x/y]Axes.minBarLength', 'dataset.minBarLength');
            deprecated('bar chart', scaleOpts.maxBarThickness, 'scales.[x/y]Axes.maxBarThickness', 'dataset.maxBarThickness');
        },
        update: function(reset) {
            var me = this;
            var rects = me.getMeta().data;
            var i, ilen;
            me._ruler = me.getRuler();
            for(i = 0, ilen = rects.length; i < ilen; ++i)me.updateElement(rects[i], i, reset);
        },
        updateElement: function(rectangle, index, reset) {
            var me = this;
            var meta = me.getMeta();
            var dataset = me.getDataset();
            var options = me._resolveDataElementOptions(rectangle, index);
            rectangle._xScale = me.getScaleForId(meta.xAxisID);
            rectangle._yScale = me.getScaleForId(meta.yAxisID);
            rectangle._datasetIndex = me.index;
            rectangle._index = index;
            rectangle._model = {
                backgroundColor: options.backgroundColor,
                borderColor: options.borderColor,
                borderSkipped: options.borderSkipped,
                borderWidth: options.borderWidth,
                datasetLabel: dataset.label,
                label: me.chart.data.labels[index]
            };
            if (helpers$1.isArray(dataset.data[index])) rectangle._model.borderSkipped = null;
            me._updateElementGeometry(rectangle, index, reset, options);
            rectangle.pivot();
        },
        /**
	 * @private
	 */ _updateElementGeometry: function(rectangle, index, reset, options) {
            var me = this;
            var model = rectangle._model;
            var vscale = me._getValueScale();
            var base = vscale.getBasePixel();
            var horizontal = vscale.isHorizontal();
            var ruler = me._ruler || me.getRuler();
            var vpixels = me.calculateBarValuePixels(me.index, index, options);
            var ipixels = me.calculateBarIndexPixels(me.index, index, ruler, options);
            model.horizontal = horizontal;
            model.base = reset ? base : vpixels.base;
            model.x = horizontal ? reset ? base : vpixels.head : ipixels.center;
            model.y = horizontal ? ipixels.center : reset ? base : vpixels.head;
            model.height = horizontal ? ipixels.size : undefined;
            model.width = horizontal ? undefined : ipixels.size;
        },
        /**
	 * Returns the stacks based on groups and bar visibility.
	 * @param {number} [last] - The dataset index
	 * @returns {string[]} The list of stack IDs
	 * @private
	 */ _getStacks: function(last) {
            var me = this;
            var scale = me._getIndexScale();
            var metasets = scale._getMatchingVisibleMetas(me._type);
            var stacked = scale.options.stacked;
            var ilen = metasets.length;
            var stacks = [];
            var i, meta;
            for(i = 0; i < ilen; ++i){
                meta = metasets[i];
                // stacked   | meta.stack
                //           | found | not found | undefined
                // false     |   x   |     x     |     x
                // true      |       |     x     |
                // undefined |       |     x     |     x
                if (stacked === false || stacks.indexOf(meta.stack) === -1 || stacked === undefined && meta.stack === undefined) stacks.push(meta.stack);
                if (meta.index === last) break;
            }
            return stacks;
        },
        /**
	 * Returns the effective number of stacks based on groups and bar visibility.
	 * @private
	 */ getStackCount: function() {
            return this._getStacks().length;
        },
        /**
	 * Returns the stack index for the given dataset based on groups and bar visibility.
	 * @param {number} [datasetIndex] - The dataset index
	 * @param {string} [name] - The stack name to find
	 * @returns {number} The stack index
	 * @private
	 */ getStackIndex: function(datasetIndex, name) {
            var stacks = this._getStacks(datasetIndex);
            var index = name !== undefined ? stacks.indexOf(name) : -1; // indexOf returns -1 if element is not present
            return index === -1 ? stacks.length - 1 : index;
        },
        /**
	 * @private
	 */ getRuler: function() {
            var me = this;
            var scale = me._getIndexScale();
            var pixels = [];
            var i, ilen;
            for(i = 0, ilen = me.getMeta().data.length; i < ilen; ++i)pixels.push(scale.getPixelForValue(null, i, me.index));
            return {
                pixels: pixels,
                start: scale._startPixel,
                end: scale._endPixel,
                stackCount: me.getStackCount(),
                scale: scale
            };
        },
        /**
	 * Note: pixel values are not clamped to the scale area.
	 * @private
	 */ calculateBarValuePixels: function(datasetIndex, index, options) {
            var me = this;
            var chart = me.chart;
            var scale = me._getValueScale();
            var isHorizontal = scale.isHorizontal();
            var datasets = chart.data.datasets;
            var metasets = scale._getMatchingVisibleMetas(me._type);
            var value = scale._parseValue(datasets[datasetIndex].data[index]);
            var minBarLength = options.minBarLength;
            var stacked = scale.options.stacked;
            var stack = me.getMeta().stack;
            var start = value.start === undefined ? 0 : value.max >= 0 && value.min >= 0 ? value.min : value.max;
            var length = value.start === undefined ? value.end : value.max >= 0 && value.min >= 0 ? value.max - value.min : value.min - value.max;
            var ilen = metasets.length;
            var i, imeta, ivalue, base, head, size, stackLength;
            if (stacked || stacked === undefined && stack !== undefined) for(i = 0; i < ilen; ++i){
                imeta = metasets[i];
                if (imeta.index === datasetIndex) break;
                if (imeta.stack === stack) {
                    stackLength = scale._parseValue(datasets[imeta.index].data[index]);
                    ivalue = stackLength.start === undefined ? stackLength.end : stackLength.min >= 0 && stackLength.max >= 0 ? stackLength.max : stackLength.min;
                    if (value.min < 0 && ivalue < 0 || value.max >= 0 && ivalue > 0) start += ivalue;
                }
            }
            base = scale.getPixelForValue(start);
            head = scale.getPixelForValue(start + length);
            size = head - base;
            if (minBarLength !== undefined && Math.abs(size) < minBarLength) {
                size = minBarLength;
                if (length >= 0 && !isHorizontal || length < 0 && isHorizontal) head = base - minBarLength;
                else head = base + minBarLength;
            }
            return {
                size: size,
                base: base,
                head: head,
                center: head + size / 2
            };
        },
        /**
	 * @private
	 */ calculateBarIndexPixels: function(datasetIndex, index, ruler, options) {
            var me = this;
            var range = options.barThickness === 'flex' ? computeFlexCategoryTraits(index, ruler, options) : computeFitCategoryTraits(index, ruler, options);
            var stackIndex = me.getStackIndex(datasetIndex, me.getMeta().stack);
            var center = range.start + range.chunk * stackIndex + range.chunk / 2;
            var size = Math.min(valueOrDefault$3(options.maxBarThickness, Infinity), range.chunk * range.ratio);
            return {
                base: center - size / 2,
                head: center + size / 2,
                center: center,
                size: size
            };
        },
        draw: function() {
            var me = this;
            var chart = me.chart;
            var scale = me._getValueScale();
            var rects = me.getMeta().data;
            var dataset = me.getDataset();
            var ilen = rects.length;
            var i = 0;
            helpers$1.canvas.clipArea(chart.ctx, chart.chartArea);
            for(; i < ilen; ++i){
                var val = scale._parseValue(dataset.data[i]);
                if (!isNaN(val.min) && !isNaN(val.max)) rects[i].draw();
            }
            helpers$1.canvas.unclipArea(chart.ctx);
        },
        /**
	 * @private
	 */ _resolveDataElementOptions: function() {
            var me = this;
            var values = helpers$1.extend({}, core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments));
            var indexOpts = me._getIndexScale().options;
            var valueOpts = me._getValueScale().options;
            values.barPercentage = valueOrDefault$3(indexOpts.barPercentage, values.barPercentage);
            values.barThickness = valueOrDefault$3(indexOpts.barThickness, values.barThickness);
            values.categoryPercentage = valueOrDefault$3(indexOpts.categoryPercentage, values.categoryPercentage);
            values.maxBarThickness = valueOrDefault$3(indexOpts.maxBarThickness, values.maxBarThickness);
            values.minBarLength = valueOrDefault$3(valueOpts.minBarLength, values.minBarLength);
            return values;
        }
    });
    var valueOrDefault$4 = helpers$1.valueOrDefault;
    var resolve$1 = helpers$1.options.resolve;
    core_defaults._set('bubble', {
        hover: {
            mode: 'single'
        },
        scales: {
            xAxes: [
                {
                    type: 'linear',
                    position: 'bottom',
                    id: 'x-axis-0' // need an ID so datasets can reference the scale
                }
            ],
            yAxes: [
                {
                    type: 'linear',
                    position: 'left',
                    id: 'y-axis-0'
                }
            ]
        },
        tooltips: {
            callbacks: {
                title: function() {
                    // Title doesn't make sense for scatter since we format the data as a point
                    return '';
                },
                label: function(item, data) {
                    var datasetLabel = data.datasets[item.datasetIndex].label || '';
                    var dataPoint = data.datasets[item.datasetIndex].data[item.index];
                    return datasetLabel + ': (' + item.xLabel + ', ' + item.yLabel + ', ' + dataPoint.r + ')';
                }
            }
        }
    });
    var controller_bubble = core_datasetController.extend({
        /**
	 * @protected
	 */ dataElementType: elements.Point,
        /**
	 * @private
	 */ _dataElementOptions: [
            'backgroundColor',
            'borderColor',
            'borderWidth',
            'hoverBackgroundColor',
            'hoverBorderColor',
            'hoverBorderWidth',
            'hoverRadius',
            'hitRadius',
            'pointStyle',
            'rotation'
        ],
        /**
	 * @protected
	 */ update: function(reset) {
            var me = this;
            var meta = me.getMeta();
            var points = meta.data;
            // Update Points
            helpers$1.each(points, function(point, index) {
                me.updateElement(point, index, reset);
            });
        },
        /**
	 * @protected
	 */ updateElement: function(point, index, reset) {
            var me = this;
            var meta = me.getMeta();
            var custom = point.custom || {};
            var xScale = me.getScaleForId(meta.xAxisID);
            var yScale = me.getScaleForId(meta.yAxisID);
            var options = me._resolveDataElementOptions(point, index);
            var data = me.getDataset().data[index];
            var dsIndex = me.index;
            var x = reset ? xScale.getPixelForDecimal(0.5) : xScale.getPixelForValue(typeof data === 'object' ? data : NaN, index, dsIndex);
            var y = reset ? yScale.getBasePixel() : yScale.getPixelForValue(data, index, dsIndex);
            point._xScale = xScale;
            point._yScale = yScale;
            point._options = options;
            point._datasetIndex = dsIndex;
            point._index = index;
            point._model = {
                backgroundColor: options.backgroundColor,
                borderColor: options.borderColor,
                borderWidth: options.borderWidth,
                hitRadius: options.hitRadius,
                pointStyle: options.pointStyle,
                rotation: options.rotation,
                radius: reset ? 0 : options.radius,
                skip: custom.skip || isNaN(x) || isNaN(y),
                x: x,
                y: y
            };
            point.pivot();
        },
        /**
	 * @protected
	 */ setHoverStyle: function(point) {
            var model = point._model;
            var options = point._options;
            var getHoverColor = helpers$1.getHoverColor;
            point.$previousStyle = {
                backgroundColor: model.backgroundColor,
                borderColor: model.borderColor,
                borderWidth: model.borderWidth,
                radius: model.radius
            };
            model.backgroundColor = valueOrDefault$4(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
            model.borderColor = valueOrDefault$4(options.hoverBorderColor, getHoverColor(options.borderColor));
            model.borderWidth = valueOrDefault$4(options.hoverBorderWidth, options.borderWidth);
            model.radius = options.radius + options.hoverRadius;
        },
        /**
	 * @private
	 */ _resolveDataElementOptions: function(point, index) {
            var me = this;
            var chart = me.chart;
            var dataset = me.getDataset();
            var custom = point.custom || {};
            var data = dataset.data[index] || {};
            var values = core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments);
            // Scriptable options
            var context = {
                chart: chart,
                dataIndex: index,
                dataset: dataset,
                datasetIndex: me.index
            };
            // In case values were cached (and thus frozen), we need to clone the values
            if (me._cachedDataOpts === values) values = helpers$1.extend({}, values);
            // Custom radius resolution
            values.radius = resolve$1([
                custom.radius,
                data.r,
                me._config.radius,
                chart.options.elements.point.radius
            ], context, index);
            return values;
        }
    });
    var valueOrDefault$5 = helpers$1.valueOrDefault;
    var PI$1 = Math.PI;
    var DOUBLE_PI$1 = PI$1 * 2;
    var HALF_PI$1 = PI$1 / 2;
    core_defaults._set('doughnut', {
        animation: {
            // Boolean - Whether we animate the rotation of the Doughnut
            animateRotate: true,
            // Boolean - Whether we animate scaling the Doughnut from the centre
            animateScale: false
        },
        hover: {
            mode: 'single'
        },
        legendCallback: function(chart) {
            var list = document.createElement('ul');
            var data = chart.data;
            var datasets = data.datasets;
            var labels = data.labels;
            var i, ilen, listItem, listItemSpan;
            list.setAttribute('class', chart.id + '-legend');
            if (datasets.length) for(i = 0, ilen = datasets[0].data.length; i < ilen; ++i){
                listItem = list.appendChild(document.createElement('li'));
                listItemSpan = listItem.appendChild(document.createElement('span'));
                listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
                if (labels[i]) listItem.appendChild(document.createTextNode(labels[i]));
            }
            return list.outerHTML;
        },
        legend: {
            labels: {
                generateLabels: function(chart) {
                    var data = chart.data;
                    if (data.labels.length && data.datasets.length) return data.labels.map(function(label, i) {
                        var meta = chart.getDatasetMeta(0);
                        var style = meta.controller.getStyle(i);
                        return {
                            text: label,
                            fillStyle: style.backgroundColor,
                            strokeStyle: style.borderColor,
                            lineWidth: style.borderWidth,
                            hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,
                            // Extra data used for toggling the correct item
                            index: i
                        };
                    });
                    return [];
                }
            },
            onClick: function(e, legendItem) {
                var index = legendItem.index;
                var chart = this.chart;
                var i, ilen, meta;
                for(i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i){
                    meta = chart.getDatasetMeta(i);
                    // toggle visibility of index if exists
                    if (meta.data[index]) meta.data[index].hidden = !meta.data[index].hidden;
                }
                chart.update();
            }
        },
        // The percentage of the chart that we cut out of the middle.
        cutoutPercentage: 50,
        // The rotation of the chart, where the first data arc begins.
        rotation: -HALF_PI$1,
        // The total circumference of the chart.
        circumference: DOUBLE_PI$1,
        // Need to override these to give a nice default
        tooltips: {
            callbacks: {
                title: function() {
                    return '';
                },
                label: function(tooltipItem, data) {
                    var dataLabel = data.labels[tooltipItem.index];
                    var value = ': ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                    if (helpers$1.isArray(dataLabel)) {
                        // show value on first line of multiline label
                        // need to clone because we are changing the value
                        dataLabel = dataLabel.slice();
                        dataLabel[0] += value;
                    } else dataLabel += value;
                    return dataLabel;
                }
            }
        }
    });
    var controller_doughnut = core_datasetController.extend({
        dataElementType: elements.Arc,
        linkScales: helpers$1.noop,
        /**
	 * @private
	 */ _dataElementOptions: [
            'backgroundColor',
            'borderColor',
            'borderWidth',
            'borderAlign',
            'hoverBackgroundColor',
            'hoverBorderColor',
            'hoverBorderWidth'
        ],
        // Get index of the dataset in relation to the visible datasets. This allows determining the inner and outer radius correctly
        getRingIndex: function(datasetIndex) {
            var ringIndex = 0;
            for(var j = 0; j < datasetIndex; ++j)if (this.chart.isDatasetVisible(j)) ++ringIndex;
            return ringIndex;
        },
        update: function(reset) {
            var me = this;
            var chart = me.chart;
            var chartArea = chart.chartArea;
            var opts = chart.options;
            var ratioX = 1;
            var ratioY = 1;
            var offsetX = 0;
            var offsetY = 0;
            var meta = me.getMeta();
            var arcs = meta.data;
            var cutout = opts.cutoutPercentage / 100 || 0;
            var circumference = opts.circumference;
            var chartWeight = me._getRingWeight(me.index);
            var maxWidth, maxHeight, i, ilen;
            // If the chart's circumference isn't a full circle, calculate size as a ratio of the width/height of the arc
            if (circumference < DOUBLE_PI$1) {
                var startAngle = opts.rotation % DOUBLE_PI$1;
                startAngle += startAngle >= PI$1 ? -DOUBLE_PI$1 : startAngle < -PI$1 ? DOUBLE_PI$1 : 0;
                var endAngle = startAngle + circumference;
                var startX = Math.cos(startAngle);
                var startY = Math.sin(startAngle);
                var endX = Math.cos(endAngle);
                var endY = Math.sin(endAngle);
                var contains0 = startAngle <= 0 && endAngle >= 0 || endAngle >= DOUBLE_PI$1;
                var contains90 = startAngle <= HALF_PI$1 && endAngle >= HALF_PI$1 || endAngle >= DOUBLE_PI$1 + HALF_PI$1;
                var contains180 = startAngle === -PI$1 || endAngle >= PI$1;
                var contains270 = startAngle <= -HALF_PI$1 && endAngle >= -HALF_PI$1 || endAngle >= PI$1 + HALF_PI$1;
                var minX = contains180 ? -1 : Math.min(startX, startX * cutout, endX, endX * cutout);
                var minY = contains270 ? -1 : Math.min(startY, startY * cutout, endY, endY * cutout);
                var maxX = contains0 ? 1 : Math.max(startX, startX * cutout, endX, endX * cutout);
                var maxY = contains90 ? 1 : Math.max(startY, startY * cutout, endY, endY * cutout);
                ratioX = (maxX - minX) / 2;
                ratioY = (maxY - minY) / 2;
                offsetX = -(maxX + minX) / 2;
                offsetY = -(maxY + minY) / 2;
            }
            for(i = 0, ilen = arcs.length; i < ilen; ++i)arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
            chart.borderWidth = me.getMaxBorderWidth();
            maxWidth = (chartArea.right - chartArea.left - chart.borderWidth) / ratioX;
            maxHeight = (chartArea.bottom - chartArea.top - chart.borderWidth) / ratioY;
            chart.outerRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
            chart.innerRadius = Math.max(chart.outerRadius * cutout, 0);
            chart.radiusLength = (chart.outerRadius - chart.innerRadius) / (me._getVisibleDatasetWeightTotal() || 1);
            chart.offsetX = offsetX * chart.outerRadius;
            chart.offsetY = offsetY * chart.outerRadius;
            meta.total = me.calculateTotal();
            me.outerRadius = chart.outerRadius - chart.radiusLength * me._getRingWeightOffset(me.index);
            me.innerRadius = Math.max(me.outerRadius - chart.radiusLength * chartWeight, 0);
            for(i = 0, ilen = arcs.length; i < ilen; ++i)me.updateElement(arcs[i], i, reset);
        },
        updateElement: function(arc, index, reset) {
            var me = this;
            var chart = me.chart;
            var chartArea = chart.chartArea;
            var opts = chart.options;
            var animationOpts = opts.animation;
            var centerX = (chartArea.left + chartArea.right) / 2;
            var centerY = (chartArea.top + chartArea.bottom) / 2;
            var startAngle = opts.rotation; // non reset case handled later
            var endAngle = opts.rotation; // non reset case handled later
            var dataset = me.getDataset();
            var circumference = reset && animationOpts.animateRotate ? 0 : arc.hidden ? 0 : me.calculateCircumference(dataset.data[index]) * (opts.circumference / DOUBLE_PI$1);
            var innerRadius = reset && animationOpts.animateScale ? 0 : me.innerRadius;
            var outerRadius = reset && animationOpts.animateScale ? 0 : me.outerRadius;
            var options = arc._options || {};
            helpers$1.extend(arc, {
                // Utility
                _datasetIndex: me.index,
                _index: index,
                // Desired view properties
                _model: {
                    backgroundColor: options.backgroundColor,
                    borderColor: options.borderColor,
                    borderWidth: options.borderWidth,
                    borderAlign: options.borderAlign,
                    x: centerX + chart.offsetX,
                    y: centerY + chart.offsetY,
                    startAngle: startAngle,
                    endAngle: endAngle,
                    circumference: circumference,
                    outerRadius: outerRadius,
                    innerRadius: innerRadius,
                    label: helpers$1.valueAtIndexOrDefault(dataset.label, index, chart.data.labels[index])
                }
            });
            var model = arc._model;
            // Set correct angles if not resetting
            if (!reset || !animationOpts.animateRotate) {
                if (index === 0) model.startAngle = opts.rotation;
                else model.startAngle = me.getMeta().data[index - 1]._model.endAngle;
                model.endAngle = model.startAngle + model.circumference;
            }
            arc.pivot();
        },
        calculateTotal: function() {
            var dataset = this.getDataset();
            var meta = this.getMeta();
            var total = 0;
            var value;
            helpers$1.each(meta.data, function(element, index) {
                value = dataset.data[index];
                if (!isNaN(value) && !element.hidden) total += Math.abs(value);
            });
            /* if (total === 0) {
			total = NaN;
		}*/ return total;
        },
        calculateCircumference: function(value) {
            var total = this.getMeta().total;
            if (total > 0 && !isNaN(value)) return DOUBLE_PI$1 * (Math.abs(value) / total);
            return 0;
        },
        // gets the max border or hover width to properly scale pie charts
        getMaxBorderWidth: function(arcs) {
            var me = this;
            var max = 0;
            var chart = me.chart;
            var i, ilen, meta, arc, controller, options, borderWidth, hoverWidth;
            if (!arcs) {
                // Find the outmost visible dataset
                for(i = 0, ilen = chart.data.datasets.length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                    meta = chart.getDatasetMeta(i);
                    arcs = meta.data;
                    if (i !== me.index) controller = meta.controller;
                    break;
                }
            }
            if (!arcs) return 0;
            for(i = 0, ilen = arcs.length; i < ilen; ++i){
                arc = arcs[i];
                if (controller) {
                    controller._configure();
                    options = controller._resolveDataElementOptions(arc, i);
                } else options = arc._options;
                if (options.borderAlign !== 'inner') {
                    borderWidth = options.borderWidth;
                    hoverWidth = options.hoverBorderWidth;
                    max = borderWidth > max ? borderWidth : max;
                    max = hoverWidth > max ? hoverWidth : max;
                }
            }
            return max;
        },
        /**
	 * @protected
	 */ setHoverStyle: function(arc) {
            var model = arc._model;
            var options = arc._options;
            var getHoverColor = helpers$1.getHoverColor;
            arc.$previousStyle = {
                backgroundColor: model.backgroundColor,
                borderColor: model.borderColor,
                borderWidth: model.borderWidth
            };
            model.backgroundColor = valueOrDefault$5(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
            model.borderColor = valueOrDefault$5(options.hoverBorderColor, getHoverColor(options.borderColor));
            model.borderWidth = valueOrDefault$5(options.hoverBorderWidth, options.borderWidth);
        },
        /**
	 * Get radius length offset of the dataset in relation to the visible datasets weights. This allows determining the inner and outer radius correctly
	 * @private
	 */ _getRingWeightOffset: function(datasetIndex) {
            var ringWeightOffset = 0;
            for(var i = 0; i < datasetIndex; ++i)if (this.chart.isDatasetVisible(i)) ringWeightOffset += this._getRingWeight(i);
            return ringWeightOffset;
        },
        /**
	 * @private
	 */ _getRingWeight: function(dataSetIndex) {
            return Math.max(valueOrDefault$5(this.chart.data.datasets[dataSetIndex].weight, 1), 0);
        },
        /**
	 * Returns the sum of all visibile data set weights.  This value can be 0.
	 * @private
	 */ _getVisibleDatasetWeightTotal: function() {
            return this._getRingWeightOffset(this.chart.data.datasets.length);
        }
    });
    core_defaults._set('horizontalBar', {
        hover: {
            mode: 'index',
            axis: 'y'
        },
        scales: {
            xAxes: [
                {
                    type: 'linear',
                    position: 'bottom'
                }
            ],
            yAxes: [
                {
                    type: 'category',
                    position: 'left',
                    offset: true,
                    gridLines: {
                        offsetGridLines: true
                    }
                }
            ]
        },
        elements: {
            rectangle: {
                borderSkipped: 'left'
            }
        },
        tooltips: {
            mode: 'index',
            axis: 'y'
        }
    });
    core_defaults._set('global', {
        datasets: {
            horizontalBar: {
                categoryPercentage: 0.8,
                barPercentage: 0.9
            }
        }
    });
    var controller_horizontalBar = controller_bar.extend({
        /**
	 * @private
	 */ _getValueScaleId: function() {
            return this.getMeta().xAxisID;
        },
        /**
	 * @private
	 */ _getIndexScaleId: function() {
            return this.getMeta().yAxisID;
        }
    });
    var valueOrDefault$6 = helpers$1.valueOrDefault;
    var resolve$2 = helpers$1.options.resolve;
    var isPointInArea = helpers$1.canvas._isPointInArea;
    core_defaults._set('line', {
        showLines: true,
        spanGaps: false,
        hover: {
            mode: 'label'
        },
        scales: {
            xAxes: [
                {
                    type: 'category',
                    id: 'x-axis-0'
                }
            ],
            yAxes: [
                {
                    type: 'linear',
                    id: 'y-axis-0'
                }
            ]
        }
    });
    function scaleClip(scale, halfBorderWidth) {
        var tickOpts = scale && scale.options.ticks || {};
        var reverse = tickOpts.reverse;
        var min = tickOpts.min === undefined ? halfBorderWidth : 0;
        var max = tickOpts.max === undefined ? halfBorderWidth : 0;
        return {
            start: reverse ? max : min,
            end: reverse ? min : max
        };
    }
    function defaultClip(xScale, yScale, borderWidth) {
        var halfBorderWidth = borderWidth / 2;
        var x = scaleClip(xScale, halfBorderWidth);
        var y = scaleClip(yScale, halfBorderWidth);
        return {
            top: y.end,
            right: x.end,
            bottom: y.start,
            left: x.start
        };
    }
    function toClip(value) {
        var t, r, b, l;
        if (helpers$1.isObject(value)) {
            t = value.top;
            r = value.right;
            b = value.bottom;
            l = value.left;
        } else t = r = b = l = value;
        return {
            top: t,
            right: r,
            bottom: b,
            left: l
        };
    }
    var controller_line = core_datasetController.extend({
        datasetElementType: elements.Line,
        dataElementType: elements.Point,
        /**
	 * @private
	 */ _datasetElementOptions: [
            'backgroundColor',
            'borderCapStyle',
            'borderColor',
            'borderDash',
            'borderDashOffset',
            'borderJoinStyle',
            'borderWidth',
            'cubicInterpolationMode',
            'fill'
        ],
        /**
	 * @private
	 */ _dataElementOptions: {
            backgroundColor: 'pointBackgroundColor',
            borderColor: 'pointBorderColor',
            borderWidth: 'pointBorderWidth',
            hitRadius: 'pointHitRadius',
            hoverBackgroundColor: 'pointHoverBackgroundColor',
            hoverBorderColor: 'pointHoverBorderColor',
            hoverBorderWidth: 'pointHoverBorderWidth',
            hoverRadius: 'pointHoverRadius',
            pointStyle: 'pointStyle',
            radius: 'pointRadius',
            rotation: 'pointRotation'
        },
        update: function(reset) {
            var me = this;
            var meta = me.getMeta();
            var line = meta.dataset;
            var points = meta.data || [];
            var options = me.chart.options;
            var config = me._config;
            var showLine = me._showLine = valueOrDefault$6(config.showLine, options.showLines);
            var i, ilen;
            me._xScale = me.getScaleForId(meta.xAxisID);
            me._yScale = me.getScaleForId(meta.yAxisID);
            // Update Line
            if (showLine) {
                // Compatibility: If the properties are defined with only the old name, use those values
                if (config.tension !== undefined && config.lineTension === undefined) config.lineTension = config.tension;
                // Utility
                line._scale = me._yScale;
                line._datasetIndex = me.index;
                // Data
                line._children = points;
                // Model
                line._model = me._resolveDatasetElementOptions(line);
                line.pivot();
            }
            // Update Points
            for(i = 0, ilen = points.length; i < ilen; ++i)me.updateElement(points[i], i, reset);
            if (showLine && line._model.tension !== 0) me.updateBezierControlPoints();
            // Now pivot the point for animation
            for(i = 0, ilen = points.length; i < ilen; ++i)points[i].pivot();
        },
        updateElement: function(point, index, reset) {
            var me = this;
            var meta = me.getMeta();
            var custom = point.custom || {};
            var dataset = me.getDataset();
            var datasetIndex = me.index;
            var value = dataset.data[index];
            var xScale = me._xScale;
            var yScale = me._yScale;
            var lineModel = meta.dataset._model;
            var x, y;
            var options = me._resolveDataElementOptions(point, index);
            x = xScale.getPixelForValue(typeof value === 'object' ? value : NaN, index, datasetIndex);
            y = reset ? yScale.getBasePixel() : me.calculatePointY(value, index, datasetIndex);
            // Utility
            point._xScale = xScale;
            point._yScale = yScale;
            point._options = options;
            point._datasetIndex = datasetIndex;
            point._index = index;
            // Desired view properties
            point._model = {
                x: x,
                y: y,
                skip: custom.skip || isNaN(x) || isNaN(y),
                // Appearance
                radius: options.radius,
                pointStyle: options.pointStyle,
                rotation: options.rotation,
                backgroundColor: options.backgroundColor,
                borderColor: options.borderColor,
                borderWidth: options.borderWidth,
                tension: valueOrDefault$6(custom.tension, lineModel ? lineModel.tension : 0),
                steppedLine: lineModel ? lineModel.steppedLine : false,
                // Tooltip
                hitRadius: options.hitRadius
            };
        },
        /**
	 * @private
	 */ _resolveDatasetElementOptions: function(element) {
            var me = this;
            var config = me._config;
            var custom = element.custom || {};
            var options = me.chart.options;
            var lineOptions = options.elements.line;
            var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);
            // The default behavior of lines is to break at null values, according
            // to https://github.com/chartjs/Chart.js/issues/2435#issuecomment-216718158
            // This option gives lines the ability to span gaps
            values.spanGaps = valueOrDefault$6(config.spanGaps, options.spanGaps);
            values.tension = valueOrDefault$6(config.lineTension, lineOptions.tension);
            values.steppedLine = resolve$2([
                custom.steppedLine,
                config.steppedLine,
                lineOptions.stepped
            ]);
            values.clip = toClip(valueOrDefault$6(config.clip, defaultClip(me._xScale, me._yScale, values.borderWidth)));
            return values;
        },
        calculatePointY: function(value, index, datasetIndex) {
            var me = this;
            var chart = me.chart;
            var yScale = me._yScale;
            var sumPos = 0;
            var sumNeg = 0;
            var i, ds, dsMeta, stackedRightValue, rightValue, metasets, ilen;
            if (yScale.options.stacked) {
                rightValue = +yScale.getRightValue(value);
                metasets = chart._getSortedVisibleDatasetMetas();
                ilen = metasets.length;
                for(i = 0; i < ilen; ++i){
                    dsMeta = metasets[i];
                    if (dsMeta.index === datasetIndex) break;
                    ds = chart.data.datasets[dsMeta.index];
                    if (dsMeta.type === 'line' && dsMeta.yAxisID === yScale.id) {
                        stackedRightValue = +yScale.getRightValue(ds.data[index]);
                        if (stackedRightValue < 0) sumNeg += stackedRightValue || 0;
                        else sumPos += stackedRightValue || 0;
                    }
                }
                if (rightValue < 0) return yScale.getPixelForValue(sumNeg + rightValue);
                return yScale.getPixelForValue(sumPos + rightValue);
            }
            return yScale.getPixelForValue(value);
        },
        updateBezierControlPoints: function() {
            var me = this;
            var chart = me.chart;
            var meta = me.getMeta();
            var lineModel = meta.dataset._model;
            var area = chart.chartArea;
            var points = meta.data || [];
            var i, ilen, model, controlPoints;
            // Only consider points that are drawn in case the spanGaps option is used
            if (lineModel.spanGaps) points = points.filter(function(pt) {
                return !pt._model.skip;
            });
            function capControlPoint(pt, min, max) {
                return Math.max(Math.min(pt, max), min);
            }
            if (lineModel.cubicInterpolationMode === 'monotone') helpers$1.splineCurveMonotone(points);
            else for(i = 0, ilen = points.length; i < ilen; ++i){
                model = points[i]._model;
                controlPoints = helpers$1.splineCurve(helpers$1.previousItem(points, i)._model, model, helpers$1.nextItem(points, i)._model, lineModel.tension);
                model.controlPointPreviousX = controlPoints.previous.x;
                model.controlPointPreviousY = controlPoints.previous.y;
                model.controlPointNextX = controlPoints.next.x;
                model.controlPointNextY = controlPoints.next.y;
            }
            if (chart.options.elements.line.capBezierPoints) for(i = 0, ilen = points.length; i < ilen; ++i){
                model = points[i]._model;
                if (isPointInArea(model, area)) {
                    if (i > 0 && isPointInArea(points[i - 1]._model, area)) {
                        model.controlPointPreviousX = capControlPoint(model.controlPointPreviousX, area.left, area.right);
                        model.controlPointPreviousY = capControlPoint(model.controlPointPreviousY, area.top, area.bottom);
                    }
                    if (i < points.length - 1 && isPointInArea(points[i + 1]._model, area)) {
                        model.controlPointNextX = capControlPoint(model.controlPointNextX, area.left, area.right);
                        model.controlPointNextY = capControlPoint(model.controlPointNextY, area.top, area.bottom);
                    }
                }
            }
        },
        draw: function() {
            var me = this;
            var chart = me.chart;
            var meta = me.getMeta();
            var points = meta.data || [];
            var area = chart.chartArea;
            var canvas = chart.canvas;
            var i = 0;
            var ilen = points.length;
            var clip;
            if (me._showLine) {
                clip = meta.dataset._model.clip;
                helpers$1.canvas.clipArea(chart.ctx, {
                    left: clip.left === false ? 0 : area.left - clip.left,
                    right: clip.right === false ? canvas.width : area.right + clip.right,
                    top: clip.top === false ? 0 : area.top - clip.top,
                    bottom: clip.bottom === false ? canvas.height : area.bottom + clip.bottom
                });
                meta.dataset.draw();
                helpers$1.canvas.unclipArea(chart.ctx);
            }
            // Draw the points
            for(; i < ilen; ++i)points[i].draw(area);
        },
        /**
	 * @protected
	 */ setHoverStyle: function(point) {
            var model = point._model;
            var options = point._options;
            var getHoverColor = helpers$1.getHoverColor;
            point.$previousStyle = {
                backgroundColor: model.backgroundColor,
                borderColor: model.borderColor,
                borderWidth: model.borderWidth,
                radius: model.radius
            };
            model.backgroundColor = valueOrDefault$6(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
            model.borderColor = valueOrDefault$6(options.hoverBorderColor, getHoverColor(options.borderColor));
            model.borderWidth = valueOrDefault$6(options.hoverBorderWidth, options.borderWidth);
            model.radius = valueOrDefault$6(options.hoverRadius, options.radius);
        }
    });
    var resolve$3 = helpers$1.options.resolve;
    core_defaults._set('polarArea', {
        scale: {
            type: 'radialLinear',
            angleLines: {
                display: false
            },
            gridLines: {
                circular: true
            },
            pointLabels: {
                display: false
            },
            ticks: {
                beginAtZero: true
            }
        },
        // Boolean - Whether to animate the rotation of the chart
        animation: {
            animateRotate: true,
            animateScale: true
        },
        startAngle: -0.5 * Math.PI,
        legendCallback: function(chart) {
            var list = document.createElement('ul');
            var data = chart.data;
            var datasets = data.datasets;
            var labels = data.labels;
            var i, ilen, listItem, listItemSpan;
            list.setAttribute('class', chart.id + '-legend');
            if (datasets.length) for(i = 0, ilen = datasets[0].data.length; i < ilen; ++i){
                listItem = list.appendChild(document.createElement('li'));
                listItemSpan = listItem.appendChild(document.createElement('span'));
                listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
                if (labels[i]) listItem.appendChild(document.createTextNode(labels[i]));
            }
            return list.outerHTML;
        },
        legend: {
            labels: {
                generateLabels: function(chart) {
                    var data = chart.data;
                    if (data.labels.length && data.datasets.length) return data.labels.map(function(label, i) {
                        var meta = chart.getDatasetMeta(0);
                        var style = meta.controller.getStyle(i);
                        return {
                            text: label,
                            fillStyle: style.backgroundColor,
                            strokeStyle: style.borderColor,
                            lineWidth: style.borderWidth,
                            hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,
                            // Extra data used for toggling the correct item
                            index: i
                        };
                    });
                    return [];
                }
            },
            onClick: function(e, legendItem) {
                var index = legendItem.index;
                var chart = this.chart;
                var i, ilen, meta;
                for(i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i){
                    meta = chart.getDatasetMeta(i);
                    meta.data[index].hidden = !meta.data[index].hidden;
                }
                chart.update();
            }
        },
        // Need to override these to give a nice default
        tooltips: {
            callbacks: {
                title: function() {
                    return '';
                },
                label: function(item, data) {
                    return data.labels[item.index] + ': ' + item.yLabel;
                }
            }
        }
    });
    var controller_polarArea = core_datasetController.extend({
        dataElementType: elements.Arc,
        linkScales: helpers$1.noop,
        /**
	 * @private
	 */ _dataElementOptions: [
            'backgroundColor',
            'borderColor',
            'borderWidth',
            'borderAlign',
            'hoverBackgroundColor',
            'hoverBorderColor',
            'hoverBorderWidth'
        ],
        /**
	 * @private
	 */ _getIndexScaleId: function() {
            return this.chart.scale.id;
        },
        /**
	 * @private
	 */ _getValueScaleId: function() {
            return this.chart.scale.id;
        },
        update: function(reset) {
            var me = this;
            var dataset = me.getDataset();
            var meta = me.getMeta();
            var start = me.chart.options.startAngle || 0;
            var starts = me._starts = [];
            var angles = me._angles = [];
            var arcs = meta.data;
            var i, ilen, angle;
            me._updateRadius();
            meta.count = me.countVisibleElements();
            for(i = 0, ilen = dataset.data.length; i < ilen; i++){
                starts[i] = start;
                angle = me._computeAngle(i);
                angles[i] = angle;
                start += angle;
            }
            for(i = 0, ilen = arcs.length; i < ilen; ++i){
                arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
                me.updateElement(arcs[i], i, reset);
            }
        },
        /**
	 * @private
	 */ _updateRadius: function() {
            var me = this;
            var chart = me.chart;
            var chartArea = chart.chartArea;
            var opts = chart.options;
            var minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
            chart.outerRadius = Math.max(minSize / 2, 0);
            chart.innerRadius = Math.max(opts.cutoutPercentage ? chart.outerRadius / 100 * opts.cutoutPercentage : 1, 0);
            chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();
            me.outerRadius = chart.outerRadius - chart.radiusLength * me.index;
            me.innerRadius = me.outerRadius - chart.radiusLength;
        },
        updateElement: function(arc, index, reset) {
            var me = this;
            var chart = me.chart;
            var dataset = me.getDataset();
            var opts = chart.options;
            var animationOpts = opts.animation;
            var scale = chart.scale;
            var labels = chart.data.labels;
            var centerX = scale.xCenter;
            var centerY = scale.yCenter;
            // var negHalfPI = -0.5 * Math.PI;
            var datasetStartAngle = opts.startAngle;
            var distance = arc.hidden ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
            var startAngle = me._starts[index];
            var endAngle = startAngle + (arc.hidden ? 0 : me._angles[index]);
            var resetRadius = animationOpts.animateScale ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
            var options = arc._options || {};
            helpers$1.extend(arc, {
                // Utility
                _datasetIndex: me.index,
                _index: index,
                _scale: scale,
                // Desired view properties
                _model: {
                    backgroundColor: options.backgroundColor,
                    borderColor: options.borderColor,
                    borderWidth: options.borderWidth,
                    borderAlign: options.borderAlign,
                    x: centerX,
                    y: centerY,
                    innerRadius: 0,
                    outerRadius: reset ? resetRadius : distance,
                    startAngle: reset && animationOpts.animateRotate ? datasetStartAngle : startAngle,
                    endAngle: reset && animationOpts.animateRotate ? datasetStartAngle : endAngle,
                    label: helpers$1.valueAtIndexOrDefault(labels, index, labels[index])
                }
            });
            arc.pivot();
        },
        countVisibleElements: function() {
            var dataset = this.getDataset();
            var meta = this.getMeta();
            var count = 0;
            helpers$1.each(meta.data, function(element, index) {
                if (!isNaN(dataset.data[index]) && !element.hidden) count++;
            });
            return count;
        },
        /**
	 * @protected
	 */ setHoverStyle: function(arc) {
            var model = arc._model;
            var options = arc._options;
            var getHoverColor = helpers$1.getHoverColor;
            var valueOrDefault = helpers$1.valueOrDefault;
            arc.$previousStyle = {
                backgroundColor: model.backgroundColor,
                borderColor: model.borderColor,
                borderWidth: model.borderWidth
            };
            model.backgroundColor = valueOrDefault(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
            model.borderColor = valueOrDefault(options.hoverBorderColor, getHoverColor(options.borderColor));
            model.borderWidth = valueOrDefault(options.hoverBorderWidth, options.borderWidth);
        },
        /**
	 * @private
	 */ _computeAngle: function(index) {
            var me = this;
            var count = this.getMeta().count;
            var dataset = me.getDataset();
            var meta = me.getMeta();
            if (isNaN(dataset.data[index]) || meta.data[index].hidden) return 0;
            // Scriptable options
            var context = {
                chart: me.chart,
                dataIndex: index,
                dataset: dataset,
                datasetIndex: me.index
            };
            return resolve$3([
                me.chart.options.elements.arc.angle,
                2 * Math.PI / count
            ], context, index);
        }
    });
    core_defaults._set('pie', helpers$1.clone(core_defaults.doughnut));
    core_defaults._set('pie', {
        cutoutPercentage: 0
    });
    // Pie charts are Doughnut chart with different defaults
    var controller_pie = controller_doughnut;
    var valueOrDefault$7 = helpers$1.valueOrDefault;
    core_defaults._set('radar', {
        spanGaps: false,
        scale: {
            type: 'radialLinear'
        },
        elements: {
            line: {
                fill: 'start',
                tension: 0 // no bezier in radar
            }
        }
    });
    var controller_radar = core_datasetController.extend({
        datasetElementType: elements.Line,
        dataElementType: elements.Point,
        linkScales: helpers$1.noop,
        /**
	 * @private
	 */ _datasetElementOptions: [
            'backgroundColor',
            'borderWidth',
            'borderColor',
            'borderCapStyle',
            'borderDash',
            'borderDashOffset',
            'borderJoinStyle',
            'fill'
        ],
        /**
	 * @private
	 */ _dataElementOptions: {
            backgroundColor: 'pointBackgroundColor',
            borderColor: 'pointBorderColor',
            borderWidth: 'pointBorderWidth',
            hitRadius: 'pointHitRadius',
            hoverBackgroundColor: 'pointHoverBackgroundColor',
            hoverBorderColor: 'pointHoverBorderColor',
            hoverBorderWidth: 'pointHoverBorderWidth',
            hoverRadius: 'pointHoverRadius',
            pointStyle: 'pointStyle',
            radius: 'pointRadius',
            rotation: 'pointRotation'
        },
        /**
	 * @private
	 */ _getIndexScaleId: function() {
            return this.chart.scale.id;
        },
        /**
	 * @private
	 */ _getValueScaleId: function() {
            return this.chart.scale.id;
        },
        update: function(reset) {
            var me = this;
            var meta = me.getMeta();
            var line = meta.dataset;
            var points = meta.data || [];
            var scale = me.chart.scale;
            var config = me._config;
            var i, ilen;
            // Compatibility: If the properties are defined with only the old name, use those values
            if (config.tension !== undefined && config.lineTension === undefined) config.lineTension = config.tension;
            // Utility
            line._scale = scale;
            line._datasetIndex = me.index;
            // Data
            line._children = points;
            line._loop = true;
            // Model
            line._model = me._resolveDatasetElementOptions(line);
            line.pivot();
            // Update Points
            for(i = 0, ilen = points.length; i < ilen; ++i)me.updateElement(points[i], i, reset);
            // Update bezier control points
            me.updateBezierControlPoints();
            // Now pivot the point for animation
            for(i = 0, ilen = points.length; i < ilen; ++i)points[i].pivot();
        },
        updateElement: function(point, index, reset) {
            var me = this;
            var custom = point.custom || {};
            var dataset = me.getDataset();
            var scale = me.chart.scale;
            var pointPosition = scale.getPointPositionForValue(index, dataset.data[index]);
            var options = me._resolveDataElementOptions(point, index);
            var lineModel = me.getMeta().dataset._model;
            var x = reset ? scale.xCenter : pointPosition.x;
            var y = reset ? scale.yCenter : pointPosition.y;
            // Utility
            point._scale = scale;
            point._options = options;
            point._datasetIndex = me.index;
            point._index = index;
            // Desired view properties
            point._model = {
                x: x,
                y: y,
                skip: custom.skip || isNaN(x) || isNaN(y),
                // Appearance
                radius: options.radius,
                pointStyle: options.pointStyle,
                rotation: options.rotation,
                backgroundColor: options.backgroundColor,
                borderColor: options.borderColor,
                borderWidth: options.borderWidth,
                tension: valueOrDefault$7(custom.tension, lineModel ? lineModel.tension : 0),
                // Tooltip
                hitRadius: options.hitRadius
            };
        },
        /**
	 * @private
	 */ _resolveDatasetElementOptions: function() {
            var me = this;
            var config = me._config;
            var options = me.chart.options;
            var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);
            values.spanGaps = valueOrDefault$7(config.spanGaps, options.spanGaps);
            values.tension = valueOrDefault$7(config.lineTension, options.elements.line.tension);
            return values;
        },
        updateBezierControlPoints: function() {
            var me = this;
            var meta = me.getMeta();
            var area = me.chart.chartArea;
            var points = meta.data || [];
            var i, ilen, model, controlPoints;
            // Only consider points that are drawn in case the spanGaps option is used
            if (meta.dataset._model.spanGaps) points = points.filter(function(pt) {
                return !pt._model.skip;
            });
            function capControlPoint(pt, min, max) {
                return Math.max(Math.min(pt, max), min);
            }
            for(i = 0, ilen = points.length; i < ilen; ++i){
                model = points[i]._model;
                controlPoints = helpers$1.splineCurve(helpers$1.previousItem(points, i, true)._model, model, helpers$1.nextItem(points, i, true)._model, model.tension);
                // Prevent the bezier going outside of the bounds of the graph
                model.controlPointPreviousX = capControlPoint(controlPoints.previous.x, area.left, area.right);
                model.controlPointPreviousY = capControlPoint(controlPoints.previous.y, area.top, area.bottom);
                model.controlPointNextX = capControlPoint(controlPoints.next.x, area.left, area.right);
                model.controlPointNextY = capControlPoint(controlPoints.next.y, area.top, area.bottom);
            }
        },
        setHoverStyle: function(point) {
            var model = point._model;
            var options = point._options;
            var getHoverColor = helpers$1.getHoverColor;
            point.$previousStyle = {
                backgroundColor: model.backgroundColor,
                borderColor: model.borderColor,
                borderWidth: model.borderWidth,
                radius: model.radius
            };
            model.backgroundColor = valueOrDefault$7(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
            model.borderColor = valueOrDefault$7(options.hoverBorderColor, getHoverColor(options.borderColor));
            model.borderWidth = valueOrDefault$7(options.hoverBorderWidth, options.borderWidth);
            model.radius = valueOrDefault$7(options.hoverRadius, options.radius);
        }
    });
    core_defaults._set('scatter', {
        hover: {
            mode: 'single'
        },
        scales: {
            xAxes: [
                {
                    id: 'x-axis-1',
                    type: 'linear',
                    position: 'bottom'
                }
            ],
            yAxes: [
                {
                    id: 'y-axis-1',
                    type: 'linear',
                    position: 'left'
                }
            ]
        },
        tooltips: {
            callbacks: {
                title: function() {
                    return ''; // doesn't make sense for scatter since data are formatted as a point
                },
                label: function(item) {
                    return '(' + item.xLabel + ', ' + item.yLabel + ')';
                }
            }
        }
    });
    core_defaults._set('global', {
        datasets: {
            scatter: {
                showLine: false
            }
        }
    });
    // Scatter charts use line controllers
    var controller_scatter = controller_line;
    // NOTE export a map in which the key represents the controller type, not
    // the class, and so must be CamelCase in order to be correctly retrieved
    // by the controller in core.controller.js (`controllers[meta.type]`).
    var controllers = {
        bar: controller_bar,
        bubble: controller_bubble,
        doughnut: controller_doughnut,
        horizontalBar: controller_horizontalBar,
        line: controller_line,
        polarArea: controller_polarArea,
        pie: controller_pie,
        radar: controller_radar,
        scatter: controller_scatter
    };
    /**
 * Helper function to get relative position for an event
 * @param {Event|IEvent} event - The event to get the position for
 * @param {Chart} chart - The chart
 * @returns {object} the event position
 */ function getRelativePosition(e, chart) {
        if (e.native) return {
            x: e.x,
            y: e.y
        };
        return helpers$1.getRelativePosition(e, chart);
    }
    /**
 * Helper function to traverse all of the visible elements in the chart
 * @param {Chart} chart - the chart
 * @param {function} handler - the callback to execute for each visible item
 */ function parseVisibleItems(chart, handler) {
        var metasets = chart._getSortedVisibleDatasetMetas();
        var metadata, i, j, ilen, jlen, element;
        for(i = 0, ilen = metasets.length; i < ilen; ++i){
            metadata = metasets[i].data;
            for(j = 0, jlen = metadata.length; j < jlen; ++j){
                element = metadata[j];
                if (!element._view.skip) handler(element);
            }
        }
    }
    /**
 * Helper function to get the items that intersect the event position
 * @param {ChartElement[]} items - elements to filter
 * @param {object} position - the point to be nearest to
 * @return {ChartElement[]} the nearest items
 */ function getIntersectItems(chart, position) {
        var elements = [];
        parseVisibleItems(chart, function(element) {
            if (element.inRange(position.x, position.y)) elements.push(element);
        });
        return elements;
    }
    /**
 * Helper function to get the items nearest to the event position considering all visible items in teh chart
 * @param {Chart} chart - the chart to look at elements from
 * @param {object} position - the point to be nearest to
 * @param {boolean} intersect - if true, only consider items that intersect the position
 * @param {function} distanceMetric - function to provide the distance between points
 * @return {ChartElement[]} the nearest items
 */ function getNearestItems(chart, position, intersect, distanceMetric) {
        var minDistance = Number.POSITIVE_INFINITY;
        var nearestItems = [];
        parseVisibleItems(chart, function(element) {
            if (intersect && !element.inRange(position.x, position.y)) return;
            var center = element.getCenterPoint();
            var distance = distanceMetric(position, center);
            if (distance < minDistance) {
                nearestItems = [
                    element
                ];
                minDistance = distance;
            } else if (distance === minDistance) // Can have multiple items at the same distance in which case we sort by size
            nearestItems.push(element);
        });
        return nearestItems;
    }
    /**
 * Get a distance metric function for two points based on the
 * axis mode setting
 * @param {string} axis - the axis mode. x|y|xy
 */ function getDistanceMetricForAxis(axis) {
        var useX = axis.indexOf('x') !== -1;
        var useY = axis.indexOf('y') !== -1;
        return function(pt1, pt2) {
            var deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
            var deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
            return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
        };
    }
    function indexMode(chart, e, options) {
        var position = getRelativePosition(e, chart);
        // Default axis for index mode is 'x' to match old behaviour
        options.axis = options.axis || 'x';
        var distanceMetric = getDistanceMetricForAxis(options.axis);
        var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
        var elements = [];
        if (!items.length) return [];
        chart._getSortedVisibleDatasetMetas().forEach(function(meta) {
            var element = meta.data[items[0]._index];
            // don't count items that are skipped (null data)
            if (element && !element._view.skip) elements.push(element);
        });
        return elements;
    }
    /**
 * @interface IInteractionOptions
 */ /**
 * If true, only consider items that intersect the point
 * @name IInterfaceOptions#boolean
 * @type Boolean
 */ /**
 * Contains interaction related functions
 * @namespace Chart.Interaction
 */ var core_interaction = {
        // Helper function for different modes
        modes: {
            single: function(chart, e) {
                var position = getRelativePosition(e, chart);
                var elements = [];
                parseVisibleItems(chart, function(element) {
                    if (element.inRange(position.x, position.y)) {
                        elements.push(element);
                        return elements;
                    }
                });
                return elements.slice(0, 1);
            },
            /**
		 * @function Chart.Interaction.modes.label
		 * @deprecated since version 2.4.0
		 * @todo remove at version 3
		 * @private
		 */ label: indexMode,
            /**
		 * Returns items at the same index. If the options.intersect parameter is true, we only return items if we intersect something
		 * If the options.intersect mode is false, we find the nearest item and return the items at the same index as that item
		 * @function Chart.Interaction.modes.index
		 * @since v2.4.0
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use during interaction
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */ index: indexMode,
            /**
		 * Returns items in the same dataset. If the options.intersect parameter is true, we only return items if we intersect something
		 * If the options.intersect is false, we find the nearest item and return the items in that dataset
		 * @function Chart.Interaction.modes.dataset
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use during interaction
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */ dataset: function(chart, e, options) {
                var position = getRelativePosition(e, chart);
                options.axis = options.axis || 'xy';
                var distanceMetric = getDistanceMetricForAxis(options.axis);
                var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
                if (items.length > 0) items = chart.getDatasetMeta(items[0]._datasetIndex).data;
                return items;
            },
            /**
		 * @function Chart.Interaction.modes.x-axis
		 * @deprecated since version 2.4.0. Use index mode and intersect == true
		 * @todo remove at version 3
		 * @private
		 */ 'x-axis': function(chart, e) {
                return indexMode(chart, e, {
                    intersect: false
                });
            },
            /**
		 * Point mode returns all elements that hit test based on the event position
		 * of the event
		 * @function Chart.Interaction.modes.intersect
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */ point: function(chart, e) {
                var position = getRelativePosition(e, chart);
                return getIntersectItems(chart, position);
            },
            /**
		 * nearest mode returns the element closest to the point
		 * @function Chart.Interaction.modes.intersect
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */ nearest: function(chart, e, options) {
                var position = getRelativePosition(e, chart);
                options.axis = options.axis || 'xy';
                var distanceMetric = getDistanceMetricForAxis(options.axis);
                return getNearestItems(chart, position, options.intersect, distanceMetric);
            },
            /**
		 * x mode returns the elements that hit-test at the current x coordinate
		 * @function Chart.Interaction.modes.x
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */ x: function(chart, e, options) {
                var position = getRelativePosition(e, chart);
                var items = [];
                var intersectsItem = false;
                parseVisibleItems(chart, function(element) {
                    if (element.inXRange(position.x)) items.push(element);
                    if (element.inRange(position.x, position.y)) intersectsItem = true;
                });
                // If we want to trigger on an intersect and we don't have any items
                // that intersect the position, return nothing
                if (options.intersect && !intersectsItem) items = [];
                return items;
            },
            /**
		 * y mode returns the elements that hit-test at the current y coordinate
		 * @function Chart.Interaction.modes.y
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */ y: function(chart, e, options) {
                var position = getRelativePosition(e, chart);
                var items = [];
                var intersectsItem = false;
                parseVisibleItems(chart, function(element) {
                    if (element.inYRange(position.y)) items.push(element);
                    if (element.inRange(position.x, position.y)) intersectsItem = true;
                });
                // If we want to trigger on an intersect and we don't have any items
                // that intersect the position, return nothing
                if (options.intersect && !intersectsItem) items = [];
                return items;
            }
        }
    };
    var extend = helpers$1.extend;
    function filterByPosition(array, position) {
        return helpers$1.where(array, function(v) {
            return v.pos === position;
        });
    }
    function sortByWeight(array, reverse) {
        return array.sort(function(a, b) {
            var v0 = reverse ? b : a;
            var v1 = reverse ? a : b;
            return v0.weight === v1.weight ? v0.index - v1.index : v0.weight - v1.weight;
        });
    }
    function wrapBoxes(boxes) {
        var layoutBoxes = [];
        var i, ilen, box;
        for(i = 0, ilen = (boxes || []).length; i < ilen; ++i){
            box = boxes[i];
            layoutBoxes.push({
                index: i,
                box: box,
                pos: box.position,
                horizontal: box.isHorizontal(),
                weight: box.weight
            });
        }
        return layoutBoxes;
    }
    function setLayoutDims(layouts, params) {
        var i, ilen, layout;
        for(i = 0, ilen = layouts.length; i < ilen; ++i){
            layout = layouts[i];
            // store width used instead of chartArea.w in fitBoxes
            layout.width = layout.horizontal ? layout.box.fullWidth && params.availableWidth : params.vBoxMaxWidth;
            // store height used instead of chartArea.h in fitBoxes
            layout.height = layout.horizontal && params.hBoxMaxHeight;
        }
    }
    function buildLayoutBoxes(boxes) {
        var layoutBoxes = wrapBoxes(boxes);
        var left = sortByWeight(filterByPosition(layoutBoxes, 'left'), true);
        var right = sortByWeight(filterByPosition(layoutBoxes, 'right'));
        var top = sortByWeight(filterByPosition(layoutBoxes, 'top'), true);
        var bottom = sortByWeight(filterByPosition(layoutBoxes, 'bottom'));
        return {
            leftAndTop: left.concat(top),
            rightAndBottom: right.concat(bottom),
            chartArea: filterByPosition(layoutBoxes, 'chartArea'),
            vertical: left.concat(right),
            horizontal: top.concat(bottom)
        };
    }
    function getCombinedMax(maxPadding, chartArea, a, b) {
        return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
    }
    function updateDims(chartArea, params, layout) {
        var box = layout.box;
        var maxPadding = chartArea.maxPadding;
        var newWidth, newHeight;
        if (layout.size) // this layout was already counted for, lets first reduce old size
        chartArea[layout.pos] -= layout.size;
        layout.size = layout.horizontal ? box.height : box.width;
        chartArea[layout.pos] += layout.size;
        if (box.getPadding) {
            var boxPadding = box.getPadding();
            maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
            maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
            maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
            maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
        }
        newWidth = params.outerWidth - getCombinedMax(maxPadding, chartArea, 'left', 'right');
        newHeight = params.outerHeight - getCombinedMax(maxPadding, chartArea, 'top', 'bottom');
        if (newWidth !== chartArea.w || newHeight !== chartArea.h) {
            chartArea.w = newWidth;
            chartArea.h = newHeight;
            // return true if chart area changed in layout's direction
            var sizes = layout.horizontal ? [
                newWidth,
                chartArea.w
            ] : [
                newHeight,
                chartArea.h
            ];
            return sizes[0] !== sizes[1] && (!isNaN(sizes[0]) || !isNaN(sizes[1]));
        }
    }
    function handleMaxPadding(chartArea) {
        var maxPadding = chartArea.maxPadding;
        function updatePos(pos) {
            var change = Math.max(maxPadding[pos] - chartArea[pos], 0);
            chartArea[pos] += change;
            return change;
        }
        chartArea.y += updatePos('top');
        chartArea.x += updatePos('left');
        updatePos('right');
        updatePos('bottom');
    }
    function getMargins(horizontal, chartArea) {
        var maxPadding = chartArea.maxPadding;
        function marginForPositions(positions) {
            var margin = {
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            };
            positions.forEach(function(pos) {
                margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
            });
            return margin;
        }
        return horizontal ? marginForPositions([
            'left',
            'right'
        ]) : marginForPositions([
            'top',
            'bottom'
        ]);
    }
    function fitBoxes(boxes, chartArea, params) {
        var refitBoxes = [];
        var i, ilen, layout, box, refit, changed;
        for(i = 0, ilen = boxes.length; i < ilen; ++i){
            layout = boxes[i];
            box = layout.box;
            box.update(layout.width || chartArea.w, layout.height || chartArea.h, getMargins(layout.horizontal, chartArea));
            if (updateDims(chartArea, params, layout)) {
                changed = true;
                if (refitBoxes.length) // Dimensions changed and there were non full width boxes before this
                // -> we have to refit those
                refit = true;
            }
            if (!box.fullWidth) refitBoxes.push(layout);
        }
        return refit ? fitBoxes(refitBoxes, chartArea, params) || changed : changed;
    }
    function placeBoxes(boxes, chartArea, params) {
        var userPadding = params.padding;
        var x = chartArea.x;
        var y = chartArea.y;
        var i, ilen, layout, box;
        for(i = 0, ilen = boxes.length; i < ilen; ++i){
            layout = boxes[i];
            box = layout.box;
            if (layout.horizontal) {
                box.left = box.fullWidth ? userPadding.left : chartArea.left;
                box.right = box.fullWidth ? params.outerWidth - userPadding.right : chartArea.left + chartArea.w;
                box.top = y;
                box.bottom = y + box.height;
                box.width = box.right - box.left;
                y = box.bottom;
            } else {
                box.left = x;
                box.right = x + box.width;
                box.top = chartArea.top;
                box.bottom = chartArea.top + chartArea.h;
                box.height = box.bottom - box.top;
                x = box.right;
            }
        }
        chartArea.x = x;
        chartArea.y = y;
    }
    core_defaults._set('global', {
        layout: {
            padding: {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
            }
        }
    });
    /**
 * @interface ILayoutItem
 * @prop {string} position - The position of the item in the chart layout. Possible values are
 * 'left', 'top', 'right', 'bottom', and 'chartArea'
 * @prop {number} weight - The weight used to sort the item. Higher weights are further away from the chart area
 * @prop {boolean} fullWidth - if true, and the item is horizontal, then push vertical boxes down
 * @prop {function} isHorizontal - returns true if the layout item is horizontal (ie. top or bottom)
 * @prop {function} update - Takes two parameters: width and height. Returns size of item
 * @prop {function} getPadding -  Returns an object with padding on the edges
 * @prop {number} width - Width of item. Must be valid after update()
 * @prop {number} height - Height of item. Must be valid after update()
 * @prop {number} left - Left edge of the item. Set by layout system and cannot be used in update
 * @prop {number} top - Top edge of the item. Set by layout system and cannot be used in update
 * @prop {number} right - Right edge of the item. Set by layout system and cannot be used in update
 * @prop {number} bottom - Bottom edge of the item. Set by layout system and cannot be used in update
 */ // The layout service is very self explanatory.  It's responsible for the layout within a chart.
    // Scales, Legends and Plugins all rely on the layout service and can easily register to be placed anywhere they need
    // It is this service's responsibility of carrying out that layout.
    var core_layouts = {
        defaults: {},
        /**
	 * Register a box to a chart.
	 * A box is simply a reference to an object that requires layout. eg. Scales, Legend, Title.
	 * @param {Chart} chart - the chart to use
	 * @param {ILayoutItem} item - the item to add to be layed out
	 */ addBox: function(chart, item) {
            if (!chart.boxes) chart.boxes = [];
            // initialize item with default values
            item.fullWidth = item.fullWidth || false;
            item.position = item.position || 'top';
            item.weight = item.weight || 0;
            item._layers = item._layers || function() {
                return [
                    {
                        z: 0,
                        draw: function() {
                            item.draw.apply(item, arguments);
                        }
                    }
                ];
            };
            chart.boxes.push(item);
        },
        /**
	 * Remove a layoutItem from a chart
	 * @param {Chart} chart - the chart to remove the box from
	 * @param {ILayoutItem} layoutItem - the item to remove from the layout
	 */ removeBox: function(chart, layoutItem) {
            var index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
            if (index !== -1) chart.boxes.splice(index, 1);
        },
        /**
	 * Sets (or updates) options on the given `item`.
	 * @param {Chart} chart - the chart in which the item lives (or will be added to)
	 * @param {ILayoutItem} item - the item to configure with the given options
	 * @param {object} options - the new item options.
	 */ configure: function(chart, item, options) {
            var props = [
                'fullWidth',
                'position',
                'weight'
            ];
            var ilen = props.length;
            var i = 0;
            var prop;
            for(; i < ilen; ++i){
                prop = props[i];
                if (options.hasOwnProperty(prop)) item[prop] = options[prop];
            }
        },
        /**
	 * Fits boxes of the given chart into the given size by having each box measure itself
	 * then running a fitting algorithm
	 * @param {Chart} chart - the chart
	 * @param {number} width - the width to fit into
	 * @param {number} height - the height to fit into
	 */ update: function(chart, width, height) {
            if (!chart) return;
            var layoutOptions = chart.options.layout || {};
            var padding = helpers$1.options.toPadding(layoutOptions.padding);
            var availableWidth = width - padding.width;
            var availableHeight = height - padding.height;
            var boxes = buildLayoutBoxes(chart.boxes);
            var verticalBoxes = boxes.vertical;
            var horizontalBoxes = boxes.horizontal;
            // Essentially we now have any number of boxes on each of the 4 sides.
            // Our canvas looks like the following.
            // The areas L1 and L2 are the left axes. R1 is the right axis, T1 is the top axis and
            // B1 is the bottom axis
            // There are also 4 quadrant-like locations (left to right instead of clockwise) reserved for chart overlays
            // These locations are single-box locations only, when trying to register a chartArea location that is already taken,
            // an error will be thrown.
            //
            // |----------------------------------------------------|
            // |                  T1 (Full Width)                   |
            // |----------------------------------------------------|
            // |    |    |                 T2                  |    |
            // |    |----|-------------------------------------|----|
            // |    |    | C1 |                           | C2 |    |
            // |    |    |----|                           |----|    |
            // |    |    |                                     |    |
            // | L1 | L2 |           ChartArea (C0)            | R1 |
            // |    |    |                                     |    |
            // |    |    |----|                           |----|    |
            // |    |    | C3 |                           | C4 |    |
            // |    |----|-------------------------------------|----|
            // |    |    |                 B1                  |    |
            // |----------------------------------------------------|
            // |                  B2 (Full Width)                   |
            // |----------------------------------------------------|
            //
            var params = Object.freeze({
                outerWidth: width,
                outerHeight: height,
                padding: padding,
                availableWidth: availableWidth,
                vBoxMaxWidth: availableWidth / 2 / verticalBoxes.length,
                hBoxMaxHeight: availableHeight / 2
            });
            var chartArea = extend({
                maxPadding: extend({}, padding),
                w: availableWidth,
                h: availableHeight,
                x: padding.left,
                y: padding.top
            }, padding);
            setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
            // First fit vertical boxes
            fitBoxes(verticalBoxes, chartArea, params);
            // Then fit horizontal boxes
            if (fitBoxes(horizontalBoxes, chartArea, params)) // if the area changed, re-fit vertical boxes
            fitBoxes(verticalBoxes, chartArea, params);
            handleMaxPadding(chartArea);
            // Finally place the boxes to correct coordinates
            placeBoxes(boxes.leftAndTop, chartArea, params);
            // Move to opposite side of chart
            chartArea.x += chartArea.w;
            chartArea.y += chartArea.h;
            placeBoxes(boxes.rightAndBottom, chartArea, params);
            chart.chartArea = {
                left: chartArea.left,
                top: chartArea.top,
                right: chartArea.left + chartArea.w,
                bottom: chartArea.top + chartArea.h
            };
            // Finally update boxes in chartArea (radial scale for example)
            helpers$1.each(boxes.chartArea, function(layout) {
                var box = layout.box;
                extend(box, chart.chartArea);
                box.update(chartArea.w, chartArea.h);
            });
        }
    };
    /**
 * Platform fallback implementation (minimal).
 * @see https://github.com/chartjs/Chart.js/pull/4591#issuecomment-319575939
 */ var platform_basic = {
        acquireContext: function(item) {
            if (item && item.canvas) // Support for any object associated to a canvas (including a context2d)
            item = item.canvas;
            return item && item.getContext('2d') || null;
        }
    };
    var platform_dom = "/*\r\n * DOM element rendering detection\r\n * https://davidwalsh.name/detect-node-insertion\r\n */\r\n@keyframes chartjs-render-animation {\r\n\tfrom { opacity: 0.99; }\r\n\tto { opacity: 1; }\r\n}\r\n\r\n.chartjs-render-monitor {\r\n\tanimation: chartjs-render-animation 0.001s;\r\n}\r\n\r\n/*\r\n * DOM element resizing detection\r\n * https://github.com/marcj/css-element-queries\r\n */\r\n.chartjs-size-monitor,\r\n.chartjs-size-monitor-expand,\r\n.chartjs-size-monitor-shrink {\r\n\tposition: absolute;\r\n\tdirection: ltr;\r\n\tleft: 0;\r\n\ttop: 0;\r\n\tright: 0;\r\n\tbottom: 0;\r\n\toverflow: hidden;\r\n\tpointer-events: none;\r\n\tvisibility: hidden;\r\n\tz-index: -1;\r\n}\r\n\r\n.chartjs-size-monitor-expand > div {\r\n\tposition: absolute;\r\n\twidth: 1000000px;\r\n\theight: 1000000px;\r\n\tleft: 0;\r\n\ttop: 0;\r\n}\r\n\r\n.chartjs-size-monitor-shrink > div {\r\n\tposition: absolute;\r\n\twidth: 200%;\r\n\theight: 200%;\r\n\tleft: 0;\r\n\ttop: 0;\r\n}\r\n";
    var platform_dom$1 = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        'default': platform_dom
    });
    var stylesheet = getCjsExportFromNamespace(platform_dom$1);
    var EXPANDO_KEY = '$chartjs';
    var CSS_PREFIX = 'chartjs-';
    var CSS_SIZE_MONITOR = CSS_PREFIX + 'size-monitor';
    var CSS_RENDER_MONITOR = CSS_PREFIX + 'render-monitor';
    var CSS_RENDER_ANIMATION = CSS_PREFIX + 'render-animation';
    var ANIMATION_START_EVENTS = [
        'animationstart',
        'webkitAnimationStart'
    ];
    /**
 * DOM event types -> Chart.js event types.
 * Note: only events with different types are mapped.
 * @see https://developer.mozilla.org/en-US/docs/Web/Events
 */ var EVENT_TYPES = {
        touchstart: 'mousedown',
        touchmove: 'mousemove',
        touchend: 'mouseup',
        pointerenter: 'mouseenter',
        pointerdown: 'mousedown',
        pointermove: 'mousemove',
        pointerup: 'mouseup',
        pointerleave: 'mouseout',
        pointerout: 'mouseout'
    };
    /**
 * The "used" size is the final value of a dimension property after all calculations have
 * been performed. This method uses the computed style of `element` but returns undefined
 * if the computed style is not expressed in pixels. That can happen in some cases where
 * `element` has a size relative to its parent and this last one is not yet displayed,
 * for example because of `display: none` on a parent node.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
 * @returns {number} Size in pixels or undefined if unknown.
 */ function readUsedSize(element, property) {
        var value = helpers$1.getStyle(element, property);
        var matches = value && value.match(/^(\d+)(\.\d+)?px$/);
        return matches ? Number(matches[1]) : undefined;
    }
    /**
 * Initializes the canvas style and render size without modifying the canvas display size,
 * since responsiveness is handled by the controller.resize() method. The config is used
 * to determine the aspect ratio to apply in case no explicit height has been specified.
 */ function initCanvas(canvas, config) {
        var style = canvas.style;
        // NOTE(SB) canvas.getAttribute('width') !== canvas.width: in the first case it
        // returns null or '' if no explicit value has been set to the canvas attribute.
        var renderHeight = canvas.getAttribute('height');
        var renderWidth = canvas.getAttribute('width');
        // Chart.js modifies some canvas values that we want to restore on destroy
        canvas[EXPANDO_KEY] = {
            initial: {
                height: renderHeight,
                width: renderWidth,
                style: {
                    display: style.display,
                    height: style.height,
                    width: style.width
                }
            }
        };
        // Force canvas to display as block to avoid extra space caused by inline
        // elements, which would interfere with the responsive resize process.
        // https://github.com/chartjs/Chart.js/issues/2538
        style.display = style.display || 'block';
        if (renderWidth === null || renderWidth === '') {
            var displayWidth = readUsedSize(canvas, 'width');
            if (displayWidth !== undefined) canvas.width = displayWidth;
        }
        if (renderHeight === null || renderHeight === '') {
            if (canvas.style.height === '') // If no explicit render height and style height, let's apply the aspect ratio,
            // which one can be specified by the user but also by charts as default option
            // (i.e. options.aspectRatio). If not specified, use canvas aspect ratio of 2.
            canvas.height = canvas.width / (config.options.aspectRatio || 2);
            else {
                var displayHeight = readUsedSize(canvas, 'height');
                if (displayWidth !== undefined) canvas.height = displayHeight;
            }
        }
        return canvas;
    }
    /**
 * Detects support for options object argument in addEventListener.
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
 * @private
 */ var supportsEventListenerOptions = function() {
        var supports = false;
        try {
            var options = Object.defineProperty({}, 'passive', {
                // eslint-disable-next-line getter-return
                get: function() {
                    supports = true;
                }
            });
            window.addEventListener('e', null, options);
        } catch (e) {
        // continue regardless of error
        }
        return supports;
    }();
    // Default passive to true as expected by Chrome for 'touchstart' and 'touchend' events.
    // https://github.com/chartjs/Chart.js/issues/4287
    var eventListenerOptions = supportsEventListenerOptions ? {
        passive: true
    } : false;
    function addListener(node, type, listener) {
        node.addEventListener(type, listener, eventListenerOptions);
    }
    function removeListener(node, type, listener) {
        node.removeEventListener(type, listener, eventListenerOptions);
    }
    function createEvent(type, chart, x, y, nativeEvent) {
        return {
            type: type,
            chart: chart,
            native: nativeEvent || null,
            x: x !== undefined ? x : null,
            y: y !== undefined ? y : null
        };
    }
    function fromNativeEvent(event, chart) {
        var type = EVENT_TYPES[event.type] || event.type;
        var pos = helpers$1.getRelativePosition(event, chart);
        return createEvent(type, chart, pos.x, pos.y, event);
    }
    function throttled(fn, thisArg) {
        var ticking = false;
        var args = [];
        return function() {
            args = Array.prototype.slice.call(arguments);
            thisArg = thisArg || this;
            if (!ticking) {
                ticking = true;
                helpers$1.requestAnimFrame.call(window, function() {
                    ticking = false;
                    fn.apply(thisArg, args);
                });
            }
        };
    }
    function createDiv(cls) {
        var el = document.createElement('div');
        el.className = cls || '';
        return el;
    }
    // Implementation based on https://github.com/marcj/css-element-queries
    function createResizer(handler) {
        var maxSize = 1000000;
        // NOTE(SB) Don't use innerHTML because it could be considered unsafe.
        // https://github.com/chartjs/Chart.js/issues/5902
        var resizer = createDiv(CSS_SIZE_MONITOR);
        var expand = createDiv(CSS_SIZE_MONITOR + '-expand');
        var shrink = createDiv(CSS_SIZE_MONITOR + '-shrink');
        expand.appendChild(createDiv());
        shrink.appendChild(createDiv());
        resizer.appendChild(expand);
        resizer.appendChild(shrink);
        resizer._reset = function() {
            expand.scrollLeft = maxSize;
            expand.scrollTop = maxSize;
            shrink.scrollLeft = maxSize;
            shrink.scrollTop = maxSize;
        };
        var onScroll = function() {
            resizer._reset();
            handler();
        };
        addListener(expand, 'scroll', onScroll.bind(expand, 'expand'));
        addListener(shrink, 'scroll', onScroll.bind(shrink, 'shrink'));
        return resizer;
    }
    // https://davidwalsh.name/detect-node-insertion
    function watchForRender(node, handler) {
        var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
        var proxy = expando.renderProxy = function(e) {
            if (e.animationName === CSS_RENDER_ANIMATION) handler();
        };
        helpers$1.each(ANIMATION_START_EVENTS, function(type) {
            addListener(node, type, proxy);
        });
        // #4737: Chrome might skip the CSS animation when the CSS_RENDER_MONITOR class
        // is removed then added back immediately (same animation frame?). Accessing the
        // `offsetParent` property will force a reflow and re-evaluate the CSS animation.
        // https://gist.github.com/paulirish/5d52fb081b3570c81e3a#box-metrics
        // https://github.com/chartjs/Chart.js/issues/4737
        expando.reflow = !!node.offsetParent;
        node.classList.add(CSS_RENDER_MONITOR);
    }
    function unwatchForRender(node) {
        var expando = node[EXPANDO_KEY] || {};
        var proxy = expando.renderProxy;
        if (proxy) {
            helpers$1.each(ANIMATION_START_EVENTS, function(type) {
                removeListener(node, type, proxy);
            });
            delete expando.renderProxy;
        }
        node.classList.remove(CSS_RENDER_MONITOR);
    }
    function addResizeListener(node, listener, chart) {
        var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
        // Let's keep track of this added resizer and thus avoid DOM query when removing it.
        var resizer = expando.resizer = createResizer(throttled(function() {
            if (expando.resizer) {
                var container = chart.options.maintainAspectRatio && node.parentNode;
                var w = container ? container.clientWidth : 0;
                listener(createEvent('resize', chart));
                if (container && container.clientWidth < w && chart.canvas) // If the container size shrank during chart resize, let's assume
                // scrollbar appeared. So we resize again with the scrollbar visible -
                // effectively making chart smaller and the scrollbar hidden again.
                // Because we are inside `throttled`, and currently `ticking`, scroll
                // events are ignored during this whole 2 resize process.
                // If we assumed wrong and something else happened, we are resizing
                // twice in a frame (potential performance issue)
                listener(createEvent('resize', chart));
            }
        }));
        // The resizer needs to be attached to the node parent, so we first need to be
        // sure that `node` is attached to the DOM before injecting the resizer element.
        watchForRender(node, function() {
            if (expando.resizer) {
                var container = node.parentNode;
                if (container && container !== resizer.parentNode) container.insertBefore(resizer, container.firstChild);
                // The container size might have changed, let's reset the resizer state.
                resizer._reset();
            }
        });
    }
    function removeResizeListener(node) {
        var expando = node[EXPANDO_KEY] || {};
        var resizer = expando.resizer;
        delete expando.resizer;
        unwatchForRender(node);
        if (resizer && resizer.parentNode) resizer.parentNode.removeChild(resizer);
    }
    /**
 * Injects CSS styles inline if the styles are not already present.
 * @param {HTMLDocument|ShadowRoot} rootNode - the node to contain the <style>.
 * @param {string} css - the CSS to be injected.
 */ function injectCSS(rootNode, css) {
        // https://stackoverflow.com/q/3922139
        var expando = rootNode[EXPANDO_KEY] || (rootNode[EXPANDO_KEY] = {});
        if (!expando.containsStyles) {
            expando.containsStyles = true;
            css = '/* Chart.js */\n' + css;
            var style = document.createElement('style');
            style.setAttribute('type', 'text/css');
            style.appendChild(document.createTextNode(css));
            rootNode.appendChild(style);
        }
    }
    var platform_dom$2 = {
        /**
	 * When `true`, prevents the automatic injection of the stylesheet required to
	 * correctly detect when the chart is added to the DOM and then resized. This
	 * switch has been added to allow external stylesheet (`dist/Chart(.min)?.js`)
	 * to be manually imported to make this library compatible with any CSP.
	 * See https://github.com/chartjs/Chart.js/issues/5208
	 */ disableCSSInjection: false,
        /**
	 * This property holds whether this platform is enabled for the current environment.
	 * Currently used by platform.js to select the proper implementation.
	 * @private
	 */ _enabled: typeof window !== 'undefined' && typeof document !== 'undefined',
        /**
	 * Initializes resources that depend on platform options.
	 * @param {HTMLCanvasElement} canvas - The Canvas element.
	 * @private
	 */ _ensureLoaded: function(canvas) {
            if (!this.disableCSSInjection) {
                // If the canvas is in a shadow DOM, then the styles must also be inserted
                // into the same shadow DOM.
                // https://github.com/chartjs/Chart.js/issues/5763
                var root = canvas.getRootNode ? canvas.getRootNode() : document;
                var targetNode = root.host ? root : document.head;
                injectCSS(targetNode, stylesheet);
            }
        },
        acquireContext: function(item, config) {
            if (typeof item === 'string') item = document.getElementById(item);
            else if (item.length) // Support for array based queries (such as jQuery)
            item = item[0];
            if (item && item.canvas) // Support for any object associated to a canvas (including a context2d)
            item = item.canvas;
            // To prevent canvas fingerprinting, some add-ons undefine the getContext
            // method, for example: https://github.com/kkapsner/CanvasBlocker
            // https://github.com/chartjs/Chart.js/issues/2807
            var context = item && item.getContext && item.getContext('2d');
            // `instanceof HTMLCanvasElement/CanvasRenderingContext2D` fails when the item is
            // inside an iframe or when running in a protected environment. We could guess the
            // types from their toString() value but let's keep things flexible and assume it's
            // a sufficient condition if the item has a context2D which has item as `canvas`.
            // https://github.com/chartjs/Chart.js/issues/3887
            // https://github.com/chartjs/Chart.js/issues/4102
            // https://github.com/chartjs/Chart.js/issues/4152
            if (context && context.canvas === item) {
                // Load platform resources on first chart creation, to make it possible to
                // import the library before setting platform options.
                this._ensureLoaded(item);
                initCanvas(item, config);
                return context;
            }
            return null;
        },
        releaseContext: function(context) {
            var canvas = context.canvas;
            if (!canvas[EXPANDO_KEY]) return;
            var initial = canvas[EXPANDO_KEY].initial;
            [
                'height',
                'width'
            ].forEach(function(prop) {
                var value = initial[prop];
                if (helpers$1.isNullOrUndef(value)) canvas.removeAttribute(prop);
                else canvas.setAttribute(prop, value);
            });
            helpers$1.each(initial.style || {}, function(value, key) {
                canvas.style[key] = value;
            });
            // The canvas render size might have been changed (and thus the state stack discarded),
            // we can't use save() and restore() to restore the initial state. So make sure that at
            // least the canvas context is reset to the default state by setting the canvas width.
            // https://www.w3.org/TR/2011/WD-html5-20110525/the-canvas-element.html
            // eslint-disable-next-line no-self-assign
            canvas.width = canvas.width;
            delete canvas[EXPANDO_KEY];
        },
        addEventListener: function(chart, type, listener) {
            var canvas = chart.canvas;
            if (type === 'resize') {
                // Note: the resize event is not supported on all browsers.
                addResizeListener(canvas, listener, chart);
                return;
            }
            var expando = listener[EXPANDO_KEY] || (listener[EXPANDO_KEY] = {});
            var proxies = expando.proxies || (expando.proxies = {});
            var proxy = proxies[chart.id + '_' + type] = function(event) {
                listener(fromNativeEvent(event, chart));
            };
            addListener(canvas, type, proxy);
        },
        removeEventListener: function(chart, type, listener) {
            var canvas = chart.canvas;
            if (type === 'resize') {
                // Note: the resize event is not supported on all browsers.
                removeResizeListener(canvas);
                return;
            }
            var expando = listener[EXPANDO_KEY] || {};
            var proxies = expando.proxies || {};
            var proxy = proxies[chart.id + '_' + type];
            if (!proxy) return;
            removeListener(canvas, type, proxy);
        }
    };
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, use EventTarget.addEventListener instead.
 * EventTarget.addEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
 * @function Chart.helpers.addEvent
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers$1.addEvent = addListener;
    /**
 * Provided for backward compatibility, use EventTarget.removeEventListener instead.
 * EventTarget.removeEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/removeEventListener
 * @function Chart.helpers.removeEvent
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers$1.removeEvent = removeListener;
    // @TODO Make possible to select another platform at build time.
    var implementation = platform_dom$2._enabled ? platform_dom$2 : platform_basic;
    /**
 * @namespace Chart.platform
 * @see https://chartjs.gitbooks.io/proposals/content/Platform.html
 * @since 2.4.0
 */ var platform = helpers$1.extend({
        /**
	 * @since 2.7.0
	 */ initialize: function() {},
        /**
	 * Called at chart construction time, returns a context2d instance implementing
	 * the [W3C Canvas 2D Context API standard]{@link https://www.w3.org/TR/2dcontext/}.
	 * @param {*} item - The native item from which to acquire context (platform specific)
	 * @param {object} options - The chart options
	 * @returns {CanvasRenderingContext2D} context2d instance
	 */ acquireContext: function() {},
        /**
	 * Called at chart destruction time, releases any resources associated to the context
	 * previously returned by the acquireContext() method.
	 * @param {CanvasRenderingContext2D} context - The context2d instance
	 * @returns {boolean} true if the method succeeded, else false
	 */ releaseContext: function() {},
        /**
	 * Registers the specified listener on the given chart.
	 * @param {Chart} chart - Chart from which to listen for event
	 * @param {string} type - The ({@link IEvent}) type to listen for
	 * @param {function} listener - Receives a notification (an object that implements
	 * the {@link IEvent} interface) when an event of the specified type occurs.
	 */ addEventListener: function() {},
        /**
	 * Removes the specified listener previously registered with addEventListener.
	 * @param {Chart} chart - Chart from which to remove the listener
	 * @param {string} type - The ({@link IEvent}) type to remove
	 * @param {function} listener - The listener function to remove from the event target.
	 */ removeEventListener: function() {}
    }, implementation);
    core_defaults._set('global', {
        plugins: {}
    });
    /**
 * The plugin service singleton
 * @namespace Chart.plugins
 * @since 2.1.0
 */ var core_plugins = {
        /**
	 * Globally registered plugins.
	 * @private
	 */ _plugins: [],
        /**
	 * This identifier is used to invalidate the descriptors cache attached to each chart
	 * when a global plugin is registered or unregistered. In this case, the cache ID is
	 * incremented and descriptors are regenerated during following API calls.
	 * @private
	 */ _cacheId: 0,
        /**
	 * Registers the given plugin(s) if not already registered.
	 * @param {IPlugin[]|IPlugin} plugins plugin instance(s).
	 */ register: function(plugins) {
            var p = this._plugins;
            [].concat(plugins).forEach(function(plugin) {
                if (p.indexOf(plugin) === -1) p.push(plugin);
            });
            this._cacheId++;
        },
        /**
	 * Unregisters the given plugin(s) only if registered.
	 * @param {IPlugin[]|IPlugin} plugins plugin instance(s).
	 */ unregister: function(plugins) {
            var p = this._plugins;
            [].concat(plugins).forEach(function(plugin) {
                var idx = p.indexOf(plugin);
                if (idx !== -1) p.splice(idx, 1);
            });
            this._cacheId++;
        },
        /**
	 * Remove all registered plugins.
	 * @since 2.1.5
	 */ clear: function() {
            this._plugins = [];
            this._cacheId++;
        },
        /**
	 * Returns the number of registered plugins?
	 * @returns {number}
	 * @since 2.1.5
	 */ count: function() {
            return this._plugins.length;
        },
        /**
	 * Returns all registered plugin instances.
	 * @returns {IPlugin[]} array of plugin objects.
	 * @since 2.1.5
	 */ getAll: function() {
            return this._plugins;
        },
        /**
	 * Calls enabled plugins for `chart` on the specified hook and with the given args.
	 * This method immediately returns as soon as a plugin explicitly returns false. The
	 * returned value can be used, for instance, to interrupt the current action.
	 * @param {Chart} chart - The chart instance for which plugins should be called.
	 * @param {string} hook - The name of the plugin method to call (e.g. 'beforeUpdate').
	 * @param {Array} [args] - Extra arguments to apply to the hook call.
	 * @returns {boolean} false if any of the plugins return false, else returns true.
	 */ notify: function(chart, hook, args) {
            var descriptors = this.descriptors(chart);
            var ilen = descriptors.length;
            var i, descriptor, plugin, params, method;
            for(i = 0; i < ilen; ++i){
                descriptor = descriptors[i];
                plugin = descriptor.plugin;
                method = plugin[hook];
                if (typeof method === 'function') {
                    params = [
                        chart
                    ].concat(args || []);
                    params.push(descriptor.options);
                    if (method.apply(plugin, params) === false) return false;
                }
            }
            return true;
        },
        /**
	 * Returns descriptors of enabled plugins for the given chart.
	 * @returns {object[]} [{ plugin, options }]
	 * @private
	 */ descriptors: function(chart) {
            var cache = chart.$plugins || (chart.$plugins = {});
            if (cache.id === this._cacheId) return cache.descriptors;
            var plugins = [];
            var descriptors = [];
            var config = chart && chart.config || {};
            var options = config.options && config.options.plugins || {};
            this._plugins.concat(config.plugins || []).forEach(function(plugin) {
                var idx = plugins.indexOf(plugin);
                if (idx !== -1) return;
                var id = plugin.id;
                var opts = options[id];
                if (opts === false) return;
                if (opts === true) opts = helpers$1.clone(core_defaults.global.plugins[id]);
                plugins.push(plugin);
                descriptors.push({
                    plugin: plugin,
                    options: opts || {}
                });
            });
            cache.descriptors = descriptors;
            cache.id = this._cacheId;
            return descriptors;
        },
        /**
	 * Invalidates cache for the given chart: descriptors hold a reference on plugin option,
	 * but in some cases, this reference can be changed by the user when updating options.
	 * https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
	 * @private
	 */ _invalidate: function(chart) {
            delete chart.$plugins;
        }
    };
    var core_scaleService = {
        // Scale registration object. Extensions can register new scale types (such as log or DB scales) and then
        // use the new chart options to grab the correct scale
        constructors: {},
        // Use a registration function so that we can move to an ES6 map when we no longer need to support
        // old browsers
        // Scale config defaults
        defaults: {},
        registerScaleType: function(type, scaleConstructor, scaleDefaults) {
            this.constructors[type] = scaleConstructor;
            this.defaults[type] = helpers$1.clone(scaleDefaults);
        },
        getScaleConstructor: function(type) {
            return this.constructors.hasOwnProperty(type) ? this.constructors[type] : undefined;
        },
        getScaleDefaults: function(type) {
            // Return the scale defaults merged with the global settings so that we always use the latest ones
            return this.defaults.hasOwnProperty(type) ? helpers$1.merge(Object.create(null), [
                core_defaults.scale,
                this.defaults[type]
            ]) : {};
        },
        updateScaleDefaults: function(type, additions) {
            var me = this;
            if (me.defaults.hasOwnProperty(type)) me.defaults[type] = helpers$1.extend(me.defaults[type], additions);
        },
        addScalesToLayout: function(chart) {
            // Adds each scale to the chart.boxes array to be sized accordingly
            helpers$1.each(chart.scales, function(scale) {
                // Set ILayoutItem parameters for backwards compatibility
                scale.fullWidth = scale.options.fullWidth;
                scale.position = scale.options.position;
                scale.weight = scale.options.weight;
                core_layouts.addBox(chart, scale);
            });
        }
    };
    var valueOrDefault$8 = helpers$1.valueOrDefault;
    var getRtlHelper = helpers$1.rtl.getRtlAdapter;
    core_defaults._set('global', {
        tooltips: {
            enabled: true,
            custom: null,
            mode: 'nearest',
            position: 'average',
            intersect: true,
            backgroundColor: 'rgba(0,0,0,0.8)',
            titleFontStyle: 'bold',
            titleSpacing: 2,
            titleMarginBottom: 6,
            titleFontColor: '#fff',
            titleAlign: 'left',
            bodySpacing: 2,
            bodyFontColor: '#fff',
            bodyAlign: 'left',
            footerFontStyle: 'bold',
            footerSpacing: 2,
            footerMarginTop: 6,
            footerFontColor: '#fff',
            footerAlign: 'left',
            yPadding: 6,
            xPadding: 6,
            caretPadding: 2,
            caretSize: 5,
            cornerRadius: 6,
            multiKeyBackground: '#fff',
            displayColors: true,
            borderColor: 'rgba(0,0,0,0)',
            borderWidth: 0,
            callbacks: {
                // Args are: (tooltipItems, data)
                beforeTitle: helpers$1.noop,
                title: function(tooltipItems, data) {
                    var title = '';
                    var labels = data.labels;
                    var labelCount = labels ? labels.length : 0;
                    if (tooltipItems.length > 0) {
                        var item = tooltipItems[0];
                        if (item.label) title = item.label;
                        else if (item.xLabel) title = item.xLabel;
                        else if (labelCount > 0 && item.index < labelCount) title = labels[item.index];
                    }
                    return title;
                },
                afterTitle: helpers$1.noop,
                // Args are: (tooltipItems, data)
                beforeBody: helpers$1.noop,
                // Args are: (tooltipItem, data)
                beforeLabel: helpers$1.noop,
                label: function(tooltipItem, data) {
                    var label = data.datasets[tooltipItem.datasetIndex].label || '';
                    if (label) label += ': ';
                    if (!helpers$1.isNullOrUndef(tooltipItem.value)) label += tooltipItem.value;
                    else label += tooltipItem.yLabel;
                    return label;
                },
                labelColor: function(tooltipItem, chart) {
                    var meta = chart.getDatasetMeta(tooltipItem.datasetIndex);
                    var activeElement = meta.data[tooltipItem.index];
                    var view = activeElement._view;
                    return {
                        borderColor: view.borderColor,
                        backgroundColor: view.backgroundColor
                    };
                },
                labelTextColor: function() {
                    return this._options.bodyFontColor;
                },
                afterLabel: helpers$1.noop,
                // Args are: (tooltipItems, data)
                afterBody: helpers$1.noop,
                // Args are: (tooltipItems, data)
                beforeFooter: helpers$1.noop,
                footer: helpers$1.noop,
                afterFooter: helpers$1.noop
            }
        }
    });
    var positioners = {
        /**
	 * Average mode places the tooltip at the average position of the elements shown
	 * @function Chart.Tooltip.positioners.average
	 * @param elements {ChartElement[]} the elements being displayed in the tooltip
	 * @returns {object} tooltip position
	 */ average: function(elements) {
            if (!elements.length) return false;
            var i, len;
            var x = 0;
            var y = 0;
            var count = 0;
            for(i = 0, len = elements.length; i < len; ++i){
                var el = elements[i];
                if (el && el.hasValue()) {
                    var pos = el.tooltipPosition();
                    x += pos.x;
                    y += pos.y;
                    ++count;
                }
            }
            return {
                x: x / count,
                y: y / count
            };
        },
        /**
	 * Gets the tooltip position nearest of the item nearest to the event position
	 * @function Chart.Tooltip.positioners.nearest
	 * @param elements {Chart.Element[]} the tooltip elements
	 * @param eventPosition {object} the position of the event in canvas coordinates
	 * @returns {object} the tooltip position
	 */ nearest: function(elements, eventPosition) {
            var x = eventPosition.x;
            var y = eventPosition.y;
            var minDistance = Number.POSITIVE_INFINITY;
            var i, len, nearestElement;
            for(i = 0, len = elements.length; i < len; ++i){
                var el = elements[i];
                if (el && el.hasValue()) {
                    var center = el.getCenterPoint();
                    var d = helpers$1.distanceBetweenPoints(eventPosition, center);
                    if (d < minDistance) {
                        minDistance = d;
                        nearestElement = el;
                    }
                }
            }
            if (nearestElement) {
                var tp = nearestElement.tooltipPosition();
                x = tp.x;
                y = tp.y;
            }
            return {
                x: x,
                y: y
            };
        }
    };
    // Helper to push or concat based on if the 2nd parameter is an array or not
    function pushOrConcat(base, toPush) {
        if (toPush) {
            if (helpers$1.isArray(toPush)) // base = base.concat(toPush);
            Array.prototype.push.apply(base, toPush);
            else base.push(toPush);
        }
        return base;
    }
    /**
 * Returns array of strings split by newline
 * @param {string} value - The value to split by newline.
 * @returns {string[]} value if newline present - Returned from String split() method
 * @function
 */ function splitNewlines(str) {
        if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) return str.split('\n');
        return str;
    }
    /**
 * Private helper to create a tooltip item model
 * @param element - the chart element (point, arc, bar) to create the tooltip item for
 * @return new tooltip item
 */ function createTooltipItem(element) {
        var xScale = element._xScale;
        var yScale = element._yScale || element._scale; // handle radar || polarArea charts
        var index = element._index;
        var datasetIndex = element._datasetIndex;
        var controller = element._chart.getDatasetMeta(datasetIndex).controller;
        var indexScale = controller._getIndexScale();
        var valueScale = controller._getValueScale();
        return {
            xLabel: xScale ? xScale.getLabelForIndex(index, datasetIndex) : '',
            yLabel: yScale ? yScale.getLabelForIndex(index, datasetIndex) : '',
            label: indexScale ? '' + indexScale.getLabelForIndex(index, datasetIndex) : '',
            value: valueScale ? '' + valueScale.getLabelForIndex(index, datasetIndex) : '',
            index: index,
            datasetIndex: datasetIndex,
            x: element._model.x,
            y: element._model.y
        };
    }
    /**
 * Helper to get the reset model for the tooltip
 * @param tooltipOpts {object} the tooltip options
 */ function getBaseModel(tooltipOpts) {
        var globalDefaults = core_defaults.global;
        return {
            // Positioning
            xPadding: tooltipOpts.xPadding,
            yPadding: tooltipOpts.yPadding,
            xAlign: tooltipOpts.xAlign,
            yAlign: tooltipOpts.yAlign,
            // Drawing direction and text direction
            rtl: tooltipOpts.rtl,
            textDirection: tooltipOpts.textDirection,
            // Body
            bodyFontColor: tooltipOpts.bodyFontColor,
            _bodyFontFamily: valueOrDefault$8(tooltipOpts.bodyFontFamily, globalDefaults.defaultFontFamily),
            _bodyFontStyle: valueOrDefault$8(tooltipOpts.bodyFontStyle, globalDefaults.defaultFontStyle),
            _bodyAlign: tooltipOpts.bodyAlign,
            bodyFontSize: valueOrDefault$8(tooltipOpts.bodyFontSize, globalDefaults.defaultFontSize),
            bodySpacing: tooltipOpts.bodySpacing,
            // Title
            titleFontColor: tooltipOpts.titleFontColor,
            _titleFontFamily: valueOrDefault$8(tooltipOpts.titleFontFamily, globalDefaults.defaultFontFamily),
            _titleFontStyle: valueOrDefault$8(tooltipOpts.titleFontStyle, globalDefaults.defaultFontStyle),
            titleFontSize: valueOrDefault$8(tooltipOpts.titleFontSize, globalDefaults.defaultFontSize),
            _titleAlign: tooltipOpts.titleAlign,
            titleSpacing: tooltipOpts.titleSpacing,
            titleMarginBottom: tooltipOpts.titleMarginBottom,
            // Footer
            footerFontColor: tooltipOpts.footerFontColor,
            _footerFontFamily: valueOrDefault$8(tooltipOpts.footerFontFamily, globalDefaults.defaultFontFamily),
            _footerFontStyle: valueOrDefault$8(tooltipOpts.footerFontStyle, globalDefaults.defaultFontStyle),
            footerFontSize: valueOrDefault$8(tooltipOpts.footerFontSize, globalDefaults.defaultFontSize),
            _footerAlign: tooltipOpts.footerAlign,
            footerSpacing: tooltipOpts.footerSpacing,
            footerMarginTop: tooltipOpts.footerMarginTop,
            // Appearance
            caretSize: tooltipOpts.caretSize,
            cornerRadius: tooltipOpts.cornerRadius,
            backgroundColor: tooltipOpts.backgroundColor,
            opacity: 0,
            legendColorBackground: tooltipOpts.multiKeyBackground,
            displayColors: tooltipOpts.displayColors,
            borderColor: tooltipOpts.borderColor,
            borderWidth: tooltipOpts.borderWidth
        };
    }
    /**
 * Get the size of the tooltip
 */ function getTooltipSize(tooltip, model) {
        var ctx = tooltip._chart.ctx;
        var height = model.yPadding * 2; // Tooltip Padding
        var width = 0;
        // Count of all lines in the body
        var body = model.body;
        var combinedBodyLength = body.reduce(function(count, bodyItem) {
            return count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length;
        }, 0);
        combinedBodyLength += model.beforeBody.length + model.afterBody.length;
        var titleLineCount = model.title.length;
        var footerLineCount = model.footer.length;
        var titleFontSize = model.titleFontSize;
        var bodyFontSize = model.bodyFontSize;
        var footerFontSize = model.footerFontSize;
        height += titleLineCount * titleFontSize; // Title Lines
        height += titleLineCount ? (titleLineCount - 1) * model.titleSpacing : 0; // Title Line Spacing
        height += titleLineCount ? model.titleMarginBottom : 0; // Title's bottom Margin
        height += combinedBodyLength * bodyFontSize; // Body Lines
        height += combinedBodyLength ? (combinedBodyLength - 1) * model.bodySpacing : 0; // Body Line Spacing
        height += footerLineCount ? model.footerMarginTop : 0; // Footer Margin
        height += footerLineCount * footerFontSize; // Footer Lines
        height += footerLineCount ? (footerLineCount - 1) * model.footerSpacing : 0; // Footer Line Spacing
        // Title width
        var widthPadding = 0;
        var maxLineWidth = function(line) {
            width = Math.max(width, ctx.measureText(line).width + widthPadding);
        };
        ctx.font = helpers$1.fontString(titleFontSize, model._titleFontStyle, model._titleFontFamily);
        helpers$1.each(model.title, maxLineWidth);
        // Body width
        ctx.font = helpers$1.fontString(bodyFontSize, model._bodyFontStyle, model._bodyFontFamily);
        helpers$1.each(model.beforeBody.concat(model.afterBody), maxLineWidth);
        // Body lines may include some extra width due to the color box
        widthPadding = model.displayColors ? bodyFontSize + 2 : 0;
        helpers$1.each(body, function(bodyItem) {
            helpers$1.each(bodyItem.before, maxLineWidth);
            helpers$1.each(bodyItem.lines, maxLineWidth);
            helpers$1.each(bodyItem.after, maxLineWidth);
        });
        // Reset back to 0
        widthPadding = 0;
        // Footer width
        ctx.font = helpers$1.fontString(footerFontSize, model._footerFontStyle, model._footerFontFamily);
        helpers$1.each(model.footer, maxLineWidth);
        // Add padding
        width += 2 * model.xPadding;
        return {
            width: width,
            height: height
        };
    }
    /**
 * Helper to get the alignment of a tooltip given the size
 */ function determineAlignment(tooltip, size) {
        var model = tooltip._model;
        var chart = tooltip._chart;
        var chartArea = tooltip._chart.chartArea;
        var xAlign = 'center';
        var yAlign = 'center';
        if (model.y < size.height) yAlign = 'top';
        else if (model.y > chart.height - size.height) yAlign = 'bottom';
        var lf, rf; // functions to determine left, right alignment
        var olf, orf; // functions to determine if left/right alignment causes tooltip to go outside chart
        var yf; // function to get the y alignment if the tooltip goes outside of the left or right edges
        var midX = (chartArea.left + chartArea.right) / 2;
        var midY = (chartArea.top + chartArea.bottom) / 2;
        if (yAlign === 'center') {
            lf = function(x) {
                return x <= midX;
            };
            rf = function(x) {
                return x > midX;
            };
        } else {
            lf = function(x) {
                return x <= size.width / 2;
            };
            rf = function(x) {
                return x >= chart.width - size.width / 2;
            };
        }
        olf = function(x) {
            return x + size.width + model.caretSize + model.caretPadding > chart.width;
        };
        orf = function(x) {
            return x - size.width - model.caretSize - model.caretPadding < 0;
        };
        yf = function(y) {
            return y <= midY ? 'top' : 'bottom';
        };
        if (lf(model.x)) {
            xAlign = 'left';
            // Is tooltip too wide and goes over the right side of the chart.?
            if (olf(model.x)) {
                xAlign = 'center';
                yAlign = yf(model.y);
            }
        } else if (rf(model.x)) {
            xAlign = 'right';
            // Is tooltip too wide and goes outside left edge of canvas?
            if (orf(model.x)) {
                xAlign = 'center';
                yAlign = yf(model.y);
            }
        }
        var opts = tooltip._options;
        return {
            xAlign: opts.xAlign ? opts.xAlign : xAlign,
            yAlign: opts.yAlign ? opts.yAlign : yAlign
        };
    }
    /**
 * Helper to get the location a tooltip needs to be placed at given the initial position (via the vm) and the size and alignment
 */ function getBackgroundPoint(vm, size, alignment, chart) {
        // Background Position
        var x = vm.x;
        var y = vm.y;
        var caretSize = vm.caretSize;
        var caretPadding = vm.caretPadding;
        var cornerRadius = vm.cornerRadius;
        var xAlign = alignment.xAlign;
        var yAlign = alignment.yAlign;
        var paddingAndSize = caretSize + caretPadding;
        var radiusAndPadding = cornerRadius + caretPadding;
        if (xAlign === 'right') x -= size.width;
        else if (xAlign === 'center') {
            x -= size.width / 2;
            if (x + size.width > chart.width) x = chart.width - size.width;
            if (x < 0) x = 0;
        }
        if (yAlign === 'top') y += paddingAndSize;
        else if (yAlign === 'bottom') y -= size.height + paddingAndSize;
        else y -= size.height / 2;
        if (yAlign === 'center') {
            if (xAlign === 'left') x += paddingAndSize;
            else if (xAlign === 'right') x -= paddingAndSize;
        } else if (xAlign === 'left') x -= radiusAndPadding;
        else if (xAlign === 'right') x += radiusAndPadding;
        return {
            x: x,
            y: y
        };
    }
    function getAlignedX(vm, align) {
        return align === 'center' ? vm.x + vm.width / 2 : align === 'right' ? vm.x + vm.width - vm.xPadding : vm.x + vm.xPadding;
    }
    /**
 * Helper to build before and after body lines
 */ function getBeforeAfterBodyLines(callback) {
        return pushOrConcat([], splitNewlines(callback));
    }
    var exports$4 = core_element.extend({
        initialize: function() {
            this._model = getBaseModel(this._options);
            this._lastActive = [];
        },
        // Get the title
        // Args are: (tooltipItem, data)
        getTitle: function() {
            var me = this;
            var opts = me._options;
            var callbacks = opts.callbacks;
            var beforeTitle = callbacks.beforeTitle.apply(me, arguments);
            var title = callbacks.title.apply(me, arguments);
            var afterTitle = callbacks.afterTitle.apply(me, arguments);
            var lines = [];
            lines = pushOrConcat(lines, splitNewlines(beforeTitle));
            lines = pushOrConcat(lines, splitNewlines(title));
            lines = pushOrConcat(lines, splitNewlines(afterTitle));
            return lines;
        },
        // Args are: (tooltipItem, data)
        getBeforeBody: function() {
            return getBeforeAfterBodyLines(this._options.callbacks.beforeBody.apply(this, arguments));
        },
        // Args are: (tooltipItem, data)
        getBody: function(tooltipItems, data) {
            var me = this;
            var callbacks = me._options.callbacks;
            var bodyItems = [];
            helpers$1.each(tooltipItems, function(tooltipItem) {
                var bodyItem = {
                    before: [],
                    lines: [],
                    after: []
                };
                pushOrConcat(bodyItem.before, splitNewlines(callbacks.beforeLabel.call(me, tooltipItem, data)));
                pushOrConcat(bodyItem.lines, callbacks.label.call(me, tooltipItem, data));
                pushOrConcat(bodyItem.after, splitNewlines(callbacks.afterLabel.call(me, tooltipItem, data)));
                bodyItems.push(bodyItem);
            });
            return bodyItems;
        },
        // Args are: (tooltipItem, data)
        getAfterBody: function() {
            return getBeforeAfterBodyLines(this._options.callbacks.afterBody.apply(this, arguments));
        },
        // Get the footer and beforeFooter and afterFooter lines
        // Args are: (tooltipItem, data)
        getFooter: function() {
            var me = this;
            var callbacks = me._options.callbacks;
            var beforeFooter = callbacks.beforeFooter.apply(me, arguments);
            var footer = callbacks.footer.apply(me, arguments);
            var afterFooter = callbacks.afterFooter.apply(me, arguments);
            var lines = [];
            lines = pushOrConcat(lines, splitNewlines(beforeFooter));
            lines = pushOrConcat(lines, splitNewlines(footer));
            lines = pushOrConcat(lines, splitNewlines(afterFooter));
            return lines;
        },
        update: function(changed) {
            var me = this;
            var opts = me._options;
            // Need to regenerate the model because its faster than using extend and it is necessary due to the optimization in Chart.Element.transition
            // that does _view = _model if ease === 1. This causes the 2nd tooltip update to set properties in both the view and model at the same time
            // which breaks any animations.
            var existingModel = me._model;
            var model = me._model = getBaseModel(opts);
            var active = me._active;
            var data = me._data;
            // In the case where active.length === 0 we need to keep these at existing values for good animations
            var alignment = {
                xAlign: existingModel.xAlign,
                yAlign: existingModel.yAlign
            };
            var backgroundPoint = {
                x: existingModel.x,
                y: existingModel.y
            };
            var tooltipSize = {
                width: existingModel.width,
                height: existingModel.height
            };
            var tooltipPosition = {
                x: existingModel.caretX,
                y: existingModel.caretY
            };
            var i, len;
            if (active.length) {
                model.opacity = 1;
                var labelColors = [];
                var labelTextColors = [];
                tooltipPosition = positioners[opts.position].call(me, active, me._eventPosition);
                var tooltipItems = [];
                for(i = 0, len = active.length; i < len; ++i)tooltipItems.push(createTooltipItem(active[i]));
                // If the user provided a filter function, use it to modify the tooltip items
                if (opts.filter) tooltipItems = tooltipItems.filter(function(a) {
                    return opts.filter(a, data);
                });
                // If the user provided a sorting function, use it to modify the tooltip items
                if (opts.itemSort) tooltipItems = tooltipItems.sort(function(a, b) {
                    return opts.itemSort(a, b, data);
                });
                // Determine colors for boxes
                helpers$1.each(tooltipItems, function(tooltipItem) {
                    labelColors.push(opts.callbacks.labelColor.call(me, tooltipItem, me._chart));
                    labelTextColors.push(opts.callbacks.labelTextColor.call(me, tooltipItem, me._chart));
                });
                // Build the Text Lines
                model.title = me.getTitle(tooltipItems, data);
                model.beforeBody = me.getBeforeBody(tooltipItems, data);
                model.body = me.getBody(tooltipItems, data);
                model.afterBody = me.getAfterBody(tooltipItems, data);
                model.footer = me.getFooter(tooltipItems, data);
                // Initial positioning and colors
                model.x = tooltipPosition.x;
                model.y = tooltipPosition.y;
                model.caretPadding = opts.caretPadding;
                model.labelColors = labelColors;
                model.labelTextColors = labelTextColors;
                // data points
                model.dataPoints = tooltipItems;
                // We need to determine alignment of the tooltip
                tooltipSize = getTooltipSize(this, model);
                alignment = determineAlignment(this, tooltipSize);
                // Final Size and Position
                backgroundPoint = getBackgroundPoint(model, tooltipSize, alignment, me._chart);
            } else model.opacity = 0;
            model.xAlign = alignment.xAlign;
            model.yAlign = alignment.yAlign;
            model.x = backgroundPoint.x;
            model.y = backgroundPoint.y;
            model.width = tooltipSize.width;
            model.height = tooltipSize.height;
            // Point where the caret on the tooltip points to
            model.caretX = tooltipPosition.x;
            model.caretY = tooltipPosition.y;
            me._model = model;
            if (changed && opts.custom) opts.custom.call(me, model);
            return me;
        },
        drawCaret: function(tooltipPoint, size) {
            var ctx = this._chart.ctx;
            var vm = this._view;
            var caretPosition = this.getCaretPosition(tooltipPoint, size, vm);
            ctx.lineTo(caretPosition.x1, caretPosition.y1);
            ctx.lineTo(caretPosition.x2, caretPosition.y2);
            ctx.lineTo(caretPosition.x3, caretPosition.y3);
        },
        getCaretPosition: function(tooltipPoint, size, vm) {
            var x1, x2, x3, y1, y2, y3;
            var caretSize = vm.caretSize;
            var cornerRadius = vm.cornerRadius;
            var xAlign = vm.xAlign;
            var yAlign = vm.yAlign;
            var ptX = tooltipPoint.x;
            var ptY = tooltipPoint.y;
            var width = size.width;
            var height = size.height;
            if (yAlign === 'center') {
                y2 = ptY + height / 2;
                if (xAlign === 'left') {
                    x1 = ptX;
                    x2 = x1 - caretSize;
                    x3 = x1;
                    y1 = y2 + caretSize;
                    y3 = y2 - caretSize;
                } else {
                    x1 = ptX + width;
                    x2 = x1 + caretSize;
                    x3 = x1;
                    y1 = y2 - caretSize;
                    y3 = y2 + caretSize;
                }
            } else {
                if (xAlign === 'left') {
                    x2 = ptX + cornerRadius + caretSize;
                    x1 = x2 - caretSize;
                    x3 = x2 + caretSize;
                } else if (xAlign === 'right') {
                    x2 = ptX + width - cornerRadius - caretSize;
                    x1 = x2 - caretSize;
                    x3 = x2 + caretSize;
                } else {
                    x2 = vm.caretX;
                    x1 = x2 - caretSize;
                    x3 = x2 + caretSize;
                }
                if (yAlign === 'top') {
                    y1 = ptY;
                    y2 = y1 - caretSize;
                    y3 = y1;
                } else {
                    y1 = ptY + height;
                    y2 = y1 + caretSize;
                    y3 = y1;
                    // invert drawing order
                    var tmp = x3;
                    x3 = x1;
                    x1 = tmp;
                }
            }
            return {
                x1: x1,
                x2: x2,
                x3: x3,
                y1: y1,
                y2: y2,
                y3: y3
            };
        },
        drawTitle: function(pt, vm, ctx) {
            var title = vm.title;
            var length = title.length;
            var titleFontSize, titleSpacing, i;
            if (length) {
                var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);
                pt.x = getAlignedX(vm, vm._titleAlign);
                ctx.textAlign = rtlHelper.textAlign(vm._titleAlign);
                ctx.textBaseline = 'middle';
                titleFontSize = vm.titleFontSize;
                titleSpacing = vm.titleSpacing;
                ctx.fillStyle = vm.titleFontColor;
                ctx.font = helpers$1.fontString(titleFontSize, vm._titleFontStyle, vm._titleFontFamily);
                for(i = 0; i < length; ++i){
                    ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFontSize / 2);
                    pt.y += titleFontSize + titleSpacing; // Line Height and spacing
                    if (i + 1 === length) pt.y += vm.titleMarginBottom - titleSpacing; // If Last, add margin, remove spacing
                }
            }
        },
        drawBody: function(pt, vm, ctx) {
            var bodyFontSize = vm.bodyFontSize;
            var bodySpacing = vm.bodySpacing;
            var bodyAlign = vm._bodyAlign;
            var body = vm.body;
            var drawColorBoxes = vm.displayColors;
            var xLinePadding = 0;
            var colorX = drawColorBoxes ? getAlignedX(vm, 'left') : 0;
            var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);
            var fillLineOfText = function(line) {
                ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyFontSize / 2);
                pt.y += bodyFontSize + bodySpacing;
            };
            var bodyItem, textColor, labelColors, lines, i, j, ilen, jlen;
            var bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
            ctx.textAlign = bodyAlign;
            ctx.textBaseline = 'middle';
            ctx.font = helpers$1.fontString(bodyFontSize, vm._bodyFontStyle, vm._bodyFontFamily);
            pt.x = getAlignedX(vm, bodyAlignForCalculation);
            // Before body lines
            ctx.fillStyle = vm.bodyFontColor;
            helpers$1.each(vm.beforeBody, fillLineOfText);
            xLinePadding = drawColorBoxes && bodyAlignForCalculation !== 'right' ? bodyAlign === 'center' ? bodyFontSize / 2 + 1 : bodyFontSize + 2 : 0;
            // Draw body lines now
            for(i = 0, ilen = body.length; i < ilen; ++i){
                bodyItem = body[i];
                textColor = vm.labelTextColors[i];
                labelColors = vm.labelColors[i];
                ctx.fillStyle = textColor;
                helpers$1.each(bodyItem.before, fillLineOfText);
                lines = bodyItem.lines;
                for(j = 0, jlen = lines.length; j < jlen; ++j){
                    // Draw Legend-like boxes if needed
                    if (drawColorBoxes) {
                        var rtlColorX = rtlHelper.x(colorX);
                        // Fill a white rect so that colours merge nicely if the opacity is < 1
                        ctx.fillStyle = vm.legendColorBackground;
                        ctx.fillRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);
                        // Border
                        ctx.lineWidth = 1;
                        ctx.strokeStyle = labelColors.borderColor;
                        ctx.strokeRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);
                        // Inner square
                        ctx.fillStyle = labelColors.backgroundColor;
                        ctx.fillRect(rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), bodyFontSize - 2), pt.y + 1, bodyFontSize - 2, bodyFontSize - 2);
                        ctx.fillStyle = textColor;
                    }
                    fillLineOfText(lines[j]);
                }
                helpers$1.each(bodyItem.after, fillLineOfText);
            }
            // Reset back to 0 for after body
            xLinePadding = 0;
            // After body lines
            helpers$1.each(vm.afterBody, fillLineOfText);
            pt.y -= bodySpacing; // Remove last body spacing
        },
        drawFooter: function(pt, vm, ctx) {
            var footer = vm.footer;
            var length = footer.length;
            var footerFontSize, i;
            if (length) {
                var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);
                pt.x = getAlignedX(vm, vm._footerAlign);
                pt.y += vm.footerMarginTop;
                ctx.textAlign = rtlHelper.textAlign(vm._footerAlign);
                ctx.textBaseline = 'middle';
                footerFontSize = vm.footerFontSize;
                ctx.fillStyle = vm.footerFontColor;
                ctx.font = helpers$1.fontString(footerFontSize, vm._footerFontStyle, vm._footerFontFamily);
                for(i = 0; i < length; ++i){
                    ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFontSize / 2);
                    pt.y += footerFontSize + vm.footerSpacing;
                }
            }
        },
        drawBackground: function(pt, vm, ctx, tooltipSize) {
            ctx.fillStyle = vm.backgroundColor;
            ctx.strokeStyle = vm.borderColor;
            ctx.lineWidth = vm.borderWidth;
            var xAlign = vm.xAlign;
            var yAlign = vm.yAlign;
            var x = pt.x;
            var y = pt.y;
            var width = tooltipSize.width;
            var height = tooltipSize.height;
            var radius = vm.cornerRadius;
            ctx.beginPath();
            ctx.moveTo(x + radius, y);
            if (yAlign === 'top') this.drawCaret(pt, tooltipSize);
            ctx.lineTo(x + width - radius, y);
            ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
            if (yAlign === 'center' && xAlign === 'right') this.drawCaret(pt, tooltipSize);
            ctx.lineTo(x + width, y + height - radius);
            ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
            if (yAlign === 'bottom') this.drawCaret(pt, tooltipSize);
            ctx.lineTo(x + radius, y + height);
            ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
            if (yAlign === 'center' && xAlign === 'left') this.drawCaret(pt, tooltipSize);
            ctx.lineTo(x, y + radius);
            ctx.quadraticCurveTo(x, y, x + radius, y);
            ctx.closePath();
            ctx.fill();
            if (vm.borderWidth > 0) ctx.stroke();
        },
        draw: function() {
            var ctx = this._chart.ctx;
            var vm = this._view;
            if (vm.opacity === 0) return;
            var tooltipSize = {
                width: vm.width,
                height: vm.height
            };
            var pt = {
                x: vm.x,
                y: vm.y
            };
            // IE11/Edge does not like very small opacities, so snap to 0
            var opacity = Math.abs(vm.opacity < 1e-3) ? 0 : vm.opacity;
            // Truthy/falsey value for empty tooltip
            var hasTooltipContent = vm.title.length || vm.beforeBody.length || vm.body.length || vm.afterBody.length || vm.footer.length;
            if (this._options.enabled && hasTooltipContent) {
                ctx.save();
                ctx.globalAlpha = opacity;
                // Draw Background
                this.drawBackground(pt, vm, ctx, tooltipSize);
                // Draw Title, Body, and Footer
                pt.y += vm.yPadding;
                helpers$1.rtl.overrideTextDirection(ctx, vm.textDirection);
                // Titles
                this.drawTitle(pt, vm, ctx);
                // Body
                this.drawBody(pt, vm, ctx);
                // Footer
                this.drawFooter(pt, vm, ctx);
                helpers$1.rtl.restoreTextDirection(ctx, vm.textDirection);
                ctx.restore();
            }
        },
        /**
	 * Handle an event
	 * @private
	 * @param {IEvent} event - The event to handle
	 * @returns {boolean} true if the tooltip changed
	 */ handleEvent: function(e) {
            var me = this;
            var options = me._options;
            var changed = false;
            me._lastActive = me._lastActive || [];
            // Find Active Elements for tooltips
            if (e.type === 'mouseout') me._active = [];
            else {
                me._active = me._chart.getElementsAtEventForMode(e, options.mode, options);
                if (options.reverse) me._active.reverse();
            }
            // Remember Last Actives
            changed = !helpers$1.arrayEquals(me._active, me._lastActive);
            // Only handle target event on tooltip change
            if (changed) {
                me._lastActive = me._active;
                if (options.enabled || options.custom) {
                    me._eventPosition = {
                        x: e.x,
                        y: e.y
                    };
                    me.update(true);
                    me.pivot();
                }
            }
            return changed;
        }
    });
    /**
 * @namespace Chart.Tooltip.positioners
 */ var positioners_1 = positioners;
    var core_tooltip = exports$4;
    core_tooltip.positioners = positioners_1;
    var valueOrDefault$9 = helpers$1.valueOrDefault;
    core_defaults._set('global', {
        elements: {},
        events: [
            'mousemove',
            'mouseout',
            'click',
            'touchstart',
            'touchmove'
        ],
        hover: {
            onHover: null,
            mode: 'nearest',
            intersect: true,
            animationDuration: 400
        },
        onClick: null,
        maintainAspectRatio: true,
        responsive: true,
        responsiveAnimationDuration: 0
    });
    /**
 * Recursively merge the given config objects representing the `scales` option
 * by incorporating scale defaults in `xAxes` and `yAxes` array items, then
 * returns a deep copy of the result, thus doesn't alter inputs.
 */ function mergeScaleConfig() {
        return helpers$1.merge(Object.create(null), [].slice.call(arguments), {
            merger: function(key, target, source, options) {
                if (key === 'xAxes' || key === 'yAxes') {
                    var slen = source[key].length;
                    var i, type, scale;
                    if (!target[key]) target[key] = [];
                    for(i = 0; i < slen; ++i){
                        scale = source[key][i];
                        type = valueOrDefault$9(scale.type, key === 'xAxes' ? 'category' : 'linear');
                        if (i >= target[key].length) target[key].push({});
                        if (!target[key][i].type || scale.type && scale.type !== target[key][i].type) // new/untyped scale or type changed: let's apply the new defaults
                        // then merge source scale to correctly overwrite the defaults.
                        helpers$1.merge(target[key][i], [
                            core_scaleService.getScaleDefaults(type),
                            scale
                        ]);
                        else // scales type are the same
                        helpers$1.merge(target[key][i], scale);
                    }
                } else helpers$1._merger(key, target, source, options);
            }
        });
    }
    /**
 * Recursively merge the given config objects as the root options by handling
 * default scale options for the `scales` and `scale` properties, then returns
 * a deep copy of the result, thus doesn't alter inputs.
 */ function mergeConfig() {
        return helpers$1.merge(Object.create(null), [].slice.call(arguments), {
            merger: function(key, target, source, options) {
                var tval = target[key] || Object.create(null);
                var sval = source[key];
                if (key === 'scales') // scale config merging is complex. Add our own function here for that
                target[key] = mergeScaleConfig(tval, sval);
                else if (key === 'scale') // used in polar area & radar charts since there is only one scale
                target[key] = helpers$1.merge(tval, [
                    core_scaleService.getScaleDefaults(sval.type),
                    sval
                ]);
                else helpers$1._merger(key, target, source, options);
            }
        });
    }
    function initConfig(config) {
        config = config || Object.create(null);
        // Do NOT use mergeConfig for the data object because this method merges arrays
        // and so would change references to labels and datasets, preventing data updates.
        var data = config.data = config.data || {};
        data.datasets = data.datasets || [];
        data.labels = data.labels || [];
        config.options = mergeConfig(core_defaults.global, core_defaults[config.type], config.options || {});
        return config;
    }
    function updateConfig(chart) {
        var newOptions = chart.options;
        helpers$1.each(chart.scales, function(scale) {
            core_layouts.removeBox(chart, scale);
        });
        newOptions = mergeConfig(core_defaults.global, core_defaults[chart.config.type], newOptions);
        chart.options = chart.config.options = newOptions;
        chart.ensureScalesHaveIDs();
        chart.buildOrUpdateScales();
        // Tooltip
        chart.tooltip._options = newOptions.tooltips;
        chart.tooltip.initialize();
    }
    function nextAvailableScaleId(axesOpts, prefix, index) {
        var id;
        var hasId = function(obj) {
            return obj.id === id;
        };
        do id = prefix + index++;
        while (helpers$1.findIndex(axesOpts, hasId) >= 0);
        return id;
    }
    function positionIsHorizontal(position) {
        return position === 'top' || position === 'bottom';
    }
    function compare2Level(l1, l2) {
        return function(a, b) {
            return a[l1] === b[l1] ? a[l2] - b[l2] : a[l1] - b[l1];
        };
    }
    var Chart = function(item, config) {
        this.construct(item, config);
        return this;
    };
    helpers$1.extend(Chart.prototype, /** @lends Chart */ {
        /**
	 * @private
	 */ construct: function(item, config) {
            var me = this;
            config = initConfig(config);
            var context = platform.acquireContext(item, config);
            var canvas = context && context.canvas;
            var height = canvas && canvas.height;
            var width = canvas && canvas.width;
            me.id = helpers$1.uid();
            me.ctx = context;
            me.canvas = canvas;
            me.config = config;
            me.width = width;
            me.height = height;
            me.aspectRatio = height ? width / height : null;
            me.options = config.options;
            me._bufferedRender = false;
            me._layers = [];
            /**
		 * Provided for backward compatibility, Chart and Chart.Controller have been merged,
		 * the "instance" still need to be defined since it might be called from plugins.
		 * @prop Chart#chart
		 * @deprecated since version 2.6.0
		 * @todo remove at version 3
		 * @private
		 */ me.chart = me;
            me.controller = me; // chart.chart.controller #inception
            // Add the chart instance to the global namespace
            Chart.instances[me.id] = me;
            // Define alias to the config data: `chart.data === chart.config.data`
            Object.defineProperty(me, 'data', {
                get: function() {
                    return me.config.data;
                },
                set: function(value) {
                    me.config.data = value;
                }
            });
            if (!context || !canvas) {
                // The given item is not a compatible context2d element, let's return before finalizing
                // the chart initialization but after setting basic chart / controller properties that
                // can help to figure out that the chart is not valid (e.g chart.canvas !== null);
                // https://github.com/chartjs/Chart.js/issues/2807
                console.error("Failed to create chart: can't acquire context from the given item");
                return;
            }
            me.initialize();
            me.update();
        },
        /**
	 * @private
	 */ initialize: function() {
            var me = this;
            // Before init plugin notification
            core_plugins.notify(me, 'beforeInit');
            helpers$1.retinaScale(me, me.options.devicePixelRatio);
            me.bindEvents();
            if (me.options.responsive) // Initial resize before chart draws (must be silent to preserve initial animations).
            me.resize(true);
            me.initToolTip();
            // After init plugin notification
            core_plugins.notify(me, 'afterInit');
            return me;
        },
        clear: function() {
            helpers$1.canvas.clear(this);
            return this;
        },
        stop: function() {
            // Stops any current animation loop occurring
            core_animations.cancelAnimation(this);
            return this;
        },
        resize: function(silent) {
            var me = this;
            var options = me.options;
            var canvas = me.canvas;
            var aspectRatio = options.maintainAspectRatio && me.aspectRatio || null;
            // the canvas render width and height will be casted to integers so make sure that
            // the canvas display style uses the same integer values to avoid blurring effect.
            // Set to 0 instead of canvas.size because the size defaults to 300x150 if the element is collapsed
            var newWidth = Math.max(0, Math.floor(helpers$1.getMaximumWidth(canvas)));
            var newHeight = Math.max(0, Math.floor(aspectRatio ? newWidth / aspectRatio : helpers$1.getMaximumHeight(canvas)));
            if (me.width === newWidth && me.height === newHeight) return;
            canvas.width = me.width = newWidth;
            canvas.height = me.height = newHeight;
            canvas.style.width = newWidth + 'px';
            canvas.style.height = newHeight + 'px';
            helpers$1.retinaScale(me, options.devicePixelRatio);
            if (!silent) {
                // Notify any plugins about the resize
                var newSize = {
                    width: newWidth,
                    height: newHeight
                };
                core_plugins.notify(me, 'resize', [
                    newSize
                ]);
                // Notify of resize
                if (options.onResize) options.onResize(me, newSize);
                me.stop();
                me.update({
                    duration: options.responsiveAnimationDuration
                });
            }
        },
        ensureScalesHaveIDs: function() {
            var options = this.options;
            var scalesOptions = options.scales || {};
            var scaleOptions = options.scale;
            helpers$1.each(scalesOptions.xAxes, function(xAxisOptions, index) {
                if (!xAxisOptions.id) xAxisOptions.id = nextAvailableScaleId(scalesOptions.xAxes, 'x-axis-', index);
            });
            helpers$1.each(scalesOptions.yAxes, function(yAxisOptions, index) {
                if (!yAxisOptions.id) yAxisOptions.id = nextAvailableScaleId(scalesOptions.yAxes, 'y-axis-', index);
            });
            if (scaleOptions) scaleOptions.id = scaleOptions.id || 'scale';
        },
        /**
	 * Builds a map of scale ID to scale object for future lookup.
	 */ buildOrUpdateScales: function() {
            var me = this;
            var options = me.options;
            var scales = me.scales || {};
            var items = [];
            var updated = Object.keys(scales).reduce(function(obj, id) {
                obj[id] = false;
                return obj;
            }, {});
            if (options.scales) items = items.concat((options.scales.xAxes || []).map(function(xAxisOptions) {
                return {
                    options: xAxisOptions,
                    dtype: 'category',
                    dposition: 'bottom'
                };
            }), (options.scales.yAxes || []).map(function(yAxisOptions) {
                return {
                    options: yAxisOptions,
                    dtype: 'linear',
                    dposition: 'left'
                };
            }));
            if (options.scale) items.push({
                options: options.scale,
                dtype: 'radialLinear',
                isDefault: true,
                dposition: 'chartArea'
            });
            helpers$1.each(items, function(item) {
                var scaleOptions = item.options;
                var id = scaleOptions.id;
                var scaleType = valueOrDefault$9(scaleOptions.type, item.dtype);
                if (positionIsHorizontal(scaleOptions.position) !== positionIsHorizontal(item.dposition)) scaleOptions.position = item.dposition;
                updated[id] = true;
                var scale = null;
                if (id in scales && scales[id].type === scaleType) {
                    scale = scales[id];
                    scale.options = scaleOptions;
                    scale.ctx = me.ctx;
                    scale.chart = me;
                } else {
                    var scaleClass = core_scaleService.getScaleConstructor(scaleType);
                    if (!scaleClass) return;
                    scale = new scaleClass({
                        id: id,
                        type: scaleType,
                        options: scaleOptions,
                        ctx: me.ctx,
                        chart: me
                    });
                    scales[scale.id] = scale;
                }
                scale.mergeTicksOptions();
                // TODO(SB): I think we should be able to remove this custom case (options.scale)
                // and consider it as a regular scale part of the "scales"" map only! This would
                // make the logic easier and remove some useless? custom code.
                if (item.isDefault) me.scale = scale;
            });
            // clear up discarded scales
            helpers$1.each(updated, function(hasUpdated, id) {
                if (!hasUpdated) delete scales[id];
            });
            me.scales = scales;
            core_scaleService.addScalesToLayout(this);
        },
        buildOrUpdateControllers: function() {
            var me = this;
            var newControllers = [];
            var datasets = me.data.datasets;
            var i, ilen;
            for(i = 0, ilen = datasets.length; i < ilen; i++){
                var dataset = datasets[i];
                var meta = me.getDatasetMeta(i);
                var type = dataset.type || me.config.type;
                if (meta.type && meta.type !== type) {
                    me.destroyDatasetMeta(i);
                    meta = me.getDatasetMeta(i);
                }
                meta.type = type;
                meta.order = dataset.order || 0;
                meta.index = i;
                if (meta.controller) {
                    meta.controller.updateIndex(i);
                    meta.controller.linkScales();
                } else {
                    var ControllerClass = controllers[meta.type];
                    if (ControllerClass === undefined) throw new Error('"' + meta.type + '" is not a chart type.');
                    meta.controller = new ControllerClass(me, i);
                    newControllers.push(meta.controller);
                }
            }
            return newControllers;
        },
        /**
	 * Reset the elements of all datasets
	 * @private
	 */ resetElements: function() {
            var me = this;
            helpers$1.each(me.data.datasets, function(dataset, datasetIndex) {
                me.getDatasetMeta(datasetIndex).controller.reset();
            }, me);
        },
        /**
	* Resets the chart back to it's state before the initial animation
	*/ reset: function() {
            this.resetElements();
            this.tooltip.initialize();
        },
        update: function(config) {
            var me = this;
            var i, ilen;
            if (!config || typeof config !== 'object') // backwards compatibility
            config = {
                duration: config,
                lazy: arguments[1]
            };
            updateConfig(me);
            // plugins options references might have change, let's invalidate the cache
            // https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
            core_plugins._invalidate(me);
            if (core_plugins.notify(me, 'beforeUpdate') === false) return;
            // In case the entire data object changed
            me.tooltip._data = me.data;
            // Make sure dataset controllers are updated and new controllers are reset
            var newControllers = me.buildOrUpdateControllers();
            // Make sure all dataset controllers have correct meta data counts
            for(i = 0, ilen = me.data.datasets.length; i < ilen; i++)me.getDatasetMeta(i).controller.buildOrUpdateElements();
            me.updateLayout();
            // Can only reset the new controllers after the scales have been updated
            if (me.options.animation && me.options.animation.duration) helpers$1.each(newControllers, function(controller) {
                controller.reset();
            });
            me.updateDatasets();
            // Need to reset tooltip in case it is displayed with elements that are removed
            // after update.
            me.tooltip.initialize();
            // Last active contains items that were previously in the tooltip.
            // When we reset the tooltip, we need to clear it
            me.lastActive = [];
            // Do this before render so that any plugins that need final scale updates can use it
            core_plugins.notify(me, 'afterUpdate');
            me._layers.sort(compare2Level('z', '_idx'));
            if (me._bufferedRender) me._bufferedRequest = {
                duration: config.duration,
                easing: config.easing,
                lazy: config.lazy
            };
            else me.render(config);
        },
        /**
	 * Updates the chart layout unless a plugin returns `false` to the `beforeLayout`
	 * hook, in which case, plugins will not be called on `afterLayout`.
	 * @private
	 */ updateLayout: function() {
            var me = this;
            if (core_plugins.notify(me, 'beforeLayout') === false) return;
            core_layouts.update(this, this.width, this.height);
            me._layers = [];
            helpers$1.each(me.boxes, function(box) {
                // _configure is called twice, once in core.scale.update and once here.
                // Here the boxes are fully updated and at their final positions.
                if (box._configure) box._configure();
                me._layers.push.apply(me._layers, box._layers());
            }, me);
            me._layers.forEach(function(item, index) {
                item._idx = index;
            });
            /**
		 * Provided for backward compatibility, use `afterLayout` instead.
		 * @method IPlugin#afterScaleUpdate
		 * @deprecated since version 2.5.0
		 * @todo remove at version 3
		 * @private
		 */ core_plugins.notify(me, 'afterScaleUpdate');
            core_plugins.notify(me, 'afterLayout');
        },
        /**
	 * Updates all datasets unless a plugin returns `false` to the `beforeDatasetsUpdate`
	 * hook, in which case, plugins will not be called on `afterDatasetsUpdate`.
	 * @private
	 */ updateDatasets: function() {
            var me = this;
            if (core_plugins.notify(me, 'beforeDatasetsUpdate') === false) return;
            for(var i = 0, ilen = me.data.datasets.length; i < ilen; ++i)me.updateDataset(i);
            core_plugins.notify(me, 'afterDatasetsUpdate');
        },
        /**
	 * Updates dataset at index unless a plugin returns `false` to the `beforeDatasetUpdate`
	 * hook, in which case, plugins will not be called on `afterDatasetUpdate`.
	 * @private
	 */ updateDataset: function(index) {
            var me = this;
            var meta = me.getDatasetMeta(index);
            var args = {
                meta: meta,
                index: index
            };
            if (core_plugins.notify(me, 'beforeDatasetUpdate', [
                args
            ]) === false) return;
            meta.controller._update();
            core_plugins.notify(me, 'afterDatasetUpdate', [
                args
            ]);
        },
        render: function(config) {
            var me = this;
            if (!config || typeof config !== 'object') // backwards compatibility
            config = {
                duration: config,
                lazy: arguments[1]
            };
            var animationOptions = me.options.animation;
            var duration = valueOrDefault$9(config.duration, animationOptions && animationOptions.duration);
            var lazy = config.lazy;
            if (core_plugins.notify(me, 'beforeRender') === false) return;
            var onComplete = function(animation) {
                core_plugins.notify(me, 'afterRender');
                helpers$1.callback(animationOptions && animationOptions.onComplete, [
                    animation
                ], me);
            };
            if (animationOptions && duration) {
                var animation = new core_animation({
                    numSteps: duration / 16.66,
                    easing: config.easing || animationOptions.easing,
                    render: function(chart, animationObject) {
                        var easingFunction = helpers$1.easing.effects[animationObject.easing];
                        var currentStep = animationObject.currentStep;
                        var stepDecimal = currentStep / animationObject.numSteps;
                        chart.draw(easingFunction(stepDecimal), stepDecimal, currentStep);
                    },
                    onAnimationProgress: animationOptions.onProgress,
                    onAnimationComplete: onComplete
                });
                core_animations.addAnimation(me, animation, duration, lazy);
            } else {
                me.draw();
                // See https://github.com/chartjs/Chart.js/issues/3781
                onComplete(new core_animation({
                    numSteps: 0,
                    chart: me
                }));
            }
            return me;
        },
        draw: function(easingValue) {
            var me = this;
            var i, layers;
            me.clear();
            if (helpers$1.isNullOrUndef(easingValue)) easingValue = 1;
            me.transition(easingValue);
            if (me.width <= 0 || me.height <= 0) return;
            if (core_plugins.notify(me, 'beforeDraw', [
                easingValue
            ]) === false) return;
            // Because of plugin hooks (before/afterDatasetsDraw), datasets can't
            // currently be part of layers. Instead, we draw
            // layers <= 0 before(default, backward compat), and the rest after
            layers = me._layers;
            for(i = 0; i < layers.length && layers[i].z <= 0; ++i)layers[i].draw(me.chartArea);
            me.drawDatasets(easingValue);
            // Rest of layers
            for(; i < layers.length; ++i)layers[i].draw(me.chartArea);
            me._drawTooltip(easingValue);
            core_plugins.notify(me, 'afterDraw', [
                easingValue
            ]);
        },
        /**
	 * @private
	 */ transition: function(easingValue) {
            var me = this;
            for(var i = 0, ilen = (me.data.datasets || []).length; i < ilen; ++i)if (me.isDatasetVisible(i)) me.getDatasetMeta(i).controller.transition(easingValue);
            me.tooltip.transition(easingValue);
        },
        /**
	 * @private
	 */ _getSortedDatasetMetas: function(filterVisible) {
            var me = this;
            var datasets = me.data.datasets || [];
            var result = [];
            var i, ilen;
            for(i = 0, ilen = datasets.length; i < ilen; ++i)if (!filterVisible || me.isDatasetVisible(i)) result.push(me.getDatasetMeta(i));
            result.sort(compare2Level('order', 'index'));
            return result;
        },
        /**
	 * @private
	 */ _getSortedVisibleDatasetMetas: function() {
            return this._getSortedDatasetMetas(true);
        },
        /**
	 * Draws all datasets unless a plugin returns `false` to the `beforeDatasetsDraw`
	 * hook, in which case, plugins will not be called on `afterDatasetsDraw`.
	 * @private
	 */ drawDatasets: function(easingValue) {
            var me = this;
            var metasets, i;
            if (core_plugins.notify(me, 'beforeDatasetsDraw', [
                easingValue
            ]) === false) return;
            metasets = me._getSortedVisibleDatasetMetas();
            for(i = metasets.length - 1; i >= 0; --i)me.drawDataset(metasets[i], easingValue);
            core_plugins.notify(me, 'afterDatasetsDraw', [
                easingValue
            ]);
        },
        /**
	 * Draws dataset at index unless a plugin returns `false` to the `beforeDatasetDraw`
	 * hook, in which case, plugins will not be called on `afterDatasetDraw`.
	 * @private
	 */ drawDataset: function(meta, easingValue) {
            var me = this;
            var args = {
                meta: meta,
                index: meta.index,
                easingValue: easingValue
            };
            if (core_plugins.notify(me, 'beforeDatasetDraw', [
                args
            ]) === false) return;
            meta.controller.draw(easingValue);
            core_plugins.notify(me, 'afterDatasetDraw', [
                args
            ]);
        },
        /**
	 * Draws tooltip unless a plugin returns `false` to the `beforeTooltipDraw`
	 * hook, in which case, plugins will not be called on `afterTooltipDraw`.
	 * @private
	 */ _drawTooltip: function(easingValue) {
            var me = this;
            var tooltip = me.tooltip;
            var args = {
                tooltip: tooltip,
                easingValue: easingValue
            };
            if (core_plugins.notify(me, 'beforeTooltipDraw', [
                args
            ]) === false) return;
            tooltip.draw();
            core_plugins.notify(me, 'afterTooltipDraw', [
                args
            ]);
        },
        /**
	 * Get the single element that was clicked on
	 * @return An object containing the dataset index and element index of the matching element. Also contains the rectangle that was draw
	 */ getElementAtEvent: function(e) {
            return core_interaction.modes.single(this, e);
        },
        getElementsAtEvent: function(e) {
            return core_interaction.modes.label(this, e, {
                intersect: true
            });
        },
        getElementsAtXAxis: function(e) {
            return core_interaction.modes['x-axis'](this, e, {
                intersect: true
            });
        },
        getElementsAtEventForMode: function(e, mode, options) {
            var method = core_interaction.modes[mode];
            if (typeof method === 'function') return method(this, e, options);
            return [];
        },
        getDatasetAtEvent: function(e) {
            return core_interaction.modes.dataset(this, e, {
                intersect: true
            });
        },
        getDatasetMeta: function(datasetIndex) {
            var me = this;
            var dataset = me.data.datasets[datasetIndex];
            if (!dataset._meta) dataset._meta = {};
            var meta = dataset._meta[me.id];
            if (!meta) meta = dataset._meta[me.id] = {
                type: null,
                data: [],
                dataset: null,
                controller: null,
                hidden: null,
                xAxisID: null,
                yAxisID: null,
                order: dataset.order || 0,
                index: datasetIndex
            };
            return meta;
        },
        getVisibleDatasetCount: function() {
            var count = 0;
            for(var i = 0, ilen = this.data.datasets.length; i < ilen; ++i)if (this.isDatasetVisible(i)) count++;
            return count;
        },
        isDatasetVisible: function(datasetIndex) {
            var meta = this.getDatasetMeta(datasetIndex);
            // meta.hidden is a per chart dataset hidden flag override with 3 states: if true or false,
            // the dataset.hidden value is ignored, else if null, the dataset hidden state is returned.
            return typeof meta.hidden === 'boolean' ? !meta.hidden : !this.data.datasets[datasetIndex].hidden;
        },
        generateLegend: function() {
            return this.options.legendCallback(this);
        },
        /**
	 * @private
	 */ destroyDatasetMeta: function(datasetIndex) {
            var id = this.id;
            var dataset = this.data.datasets[datasetIndex];
            var meta = dataset._meta && dataset._meta[id];
            if (meta) {
                meta.controller.destroy();
                delete dataset._meta[id];
            }
        },
        destroy: function() {
            var me = this;
            var canvas = me.canvas;
            var i, ilen;
            me.stop();
            // dataset controllers need to cleanup associated data
            for(i = 0, ilen = me.data.datasets.length; i < ilen; ++i)me.destroyDatasetMeta(i);
            if (canvas) {
                me.unbindEvents();
                helpers$1.canvas.clear(me);
                platform.releaseContext(me.ctx);
                me.canvas = null;
                me.ctx = null;
            }
            core_plugins.notify(me, 'destroy');
            delete Chart.instances[me.id];
        },
        toBase64Image: function() {
            return this.canvas.toDataURL.apply(this.canvas, arguments);
        },
        initToolTip: function() {
            var me = this;
            me.tooltip = new core_tooltip({
                _chart: me,
                _chartInstance: me,
                _data: me.data,
                _options: me.options.tooltips
            }, me);
        },
        /**
	 * @private
	 */ bindEvents: function() {
            var me = this;
            var listeners = me._listeners = {};
            var listener = function() {
                me.eventHandler.apply(me, arguments);
            };
            helpers$1.each(me.options.events, function(type) {
                platform.addEventListener(me, type, listener);
                listeners[type] = listener;
            });
            // Elements used to detect size change should not be injected for non responsive charts.
            // See https://github.com/chartjs/Chart.js/issues/2210
            if (me.options.responsive) {
                listener = function() {
                    me.resize();
                };
                platform.addEventListener(me, 'resize', listener);
                listeners.resize = listener;
            }
        },
        /**
	 * @private
	 */ unbindEvents: function() {
            var me = this;
            var listeners = me._listeners;
            if (!listeners) return;
            delete me._listeners;
            helpers$1.each(listeners, function(listener, type) {
                platform.removeEventListener(me, type, listener);
            });
        },
        updateHoverStyle: function(elements, mode, enabled) {
            var prefix = enabled ? 'set' : 'remove';
            var element, i, ilen;
            for(i = 0, ilen = elements.length; i < ilen; ++i){
                element = elements[i];
                if (element) this.getDatasetMeta(element._datasetIndex).controller[prefix + 'HoverStyle'](element);
            }
            if (mode === 'dataset') this.getDatasetMeta(elements[0]._datasetIndex).controller['_' + prefix + 'DatasetHoverStyle']();
        },
        /**
	 * @private
	 */ eventHandler: function(e) {
            var me = this;
            var tooltip = me.tooltip;
            if (core_plugins.notify(me, 'beforeEvent', [
                e
            ]) === false) return;
            // Buffer any update calls so that renders do not occur
            me._bufferedRender = true;
            me._bufferedRequest = null;
            var changed = me.handleEvent(e);
            // for smooth tooltip animations issue #4989
            // the tooltip should be the source of change
            // Animation check workaround:
            // tooltip._start will be null when tooltip isn't animating
            if (tooltip) changed = tooltip._start ? tooltip.handleEvent(e) : changed | tooltip.handleEvent(e);
            core_plugins.notify(me, 'afterEvent', [
                e
            ]);
            var bufferedRequest = me._bufferedRequest;
            if (bufferedRequest) // If we have an update that was triggered, we need to do a normal render
            me.render(bufferedRequest);
            else if (changed && !me.animating) {
                // If entering, leaving, or changing elements, animate the change via pivot
                me.stop();
                // We only need to render at this point. Updating will cause scales to be
                // recomputed generating flicker & using more memory than necessary.
                me.render({
                    duration: me.options.hover.animationDuration,
                    lazy: true
                });
            }
            me._bufferedRender = false;
            me._bufferedRequest = null;
            return me;
        },
        /**
	 * Handle an event
	 * @private
	 * @param {IEvent} event the event to handle
	 * @return {boolean} true if the chart needs to re-render
	 */ handleEvent: function(e) {
            var me = this;
            var options = me.options || {};
            var hoverOptions = options.hover;
            var changed = false;
            me.lastActive = me.lastActive || [];
            // Find Active Elements for hover and tooltips
            if (e.type === 'mouseout') me.active = [];
            else me.active = me.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions);
            // Invoke onHover hook
            // Need to call with native event here to not break backwards compatibility
            helpers$1.callback(options.onHover || options.hover.onHover, [
                e.native,
                me.active
            ], me);
            if (e.type === 'mouseup' || e.type === 'click') {
                if (options.onClick) // Use e.native here for backwards compatibility
                options.onClick.call(me, e.native, me.active);
            }
            // Remove styling for last active (even if it may still be active)
            if (me.lastActive.length) me.updateHoverStyle(me.lastActive, hoverOptions.mode, false);
            // Built in hover styling
            if (me.active.length && hoverOptions.mode) me.updateHoverStyle(me.active, hoverOptions.mode, true);
            changed = !helpers$1.arrayEquals(me.active, me.lastActive);
            // Remember Last Actives
            me.lastActive = me.active;
            return changed;
        }
    });
    /**
 * NOTE(SB) We actually don't use this container anymore but we need to keep it
 * for backward compatibility. Though, it can still be useful for plugins that
 * would need to work on multiple charts?!
 */ Chart.instances = {};
    var core_controller = Chart;
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, use Chart instead.
 * @class Chart.Controller
 * @deprecated since version 2.6
 * @todo remove at version 3
 * @private
 */ Chart.Controller = Chart;
    /**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart
 * @deprecated since version 2.8
 * @todo remove at version 3
 * @private
 */ Chart.types = {};
    /**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart.helpers.configMerge
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */ helpers$1.configMerge = mergeConfig;
    /**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart.helpers.scaleMerge
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */ helpers$1.scaleMerge = mergeScaleConfig;
    var core_helpers = function() {
        // -- Basic js utility methods
        helpers$1.where = function(collection, filterCallback) {
            if (helpers$1.isArray(collection) && Array.prototype.filter) return collection.filter(filterCallback);
            var filtered = [];
            helpers$1.each(collection, function(item) {
                if (filterCallback(item)) filtered.push(item);
            });
            return filtered;
        };
        helpers$1.findIndex = Array.prototype.findIndex ? function(array, callback, scope) {
            return array.findIndex(callback, scope);
        } : function(array, callback, scope) {
            scope = scope === undefined ? array : scope;
            for(var i = 0, ilen = array.length; i < ilen; ++i){
                if (callback.call(scope, array[i], i, array)) return i;
            }
            return -1;
        };
        helpers$1.findNextWhere = function(arrayToSearch, filterCallback, startIndex) {
            // Default to start of the array
            if (helpers$1.isNullOrUndef(startIndex)) startIndex = -1;
            for(var i = startIndex + 1; i < arrayToSearch.length; i++){
                var currentItem = arrayToSearch[i];
                if (filterCallback(currentItem)) return currentItem;
            }
        };
        helpers$1.findPreviousWhere = function(arrayToSearch, filterCallback, startIndex) {
            // Default to end of the array
            if (helpers$1.isNullOrUndef(startIndex)) startIndex = arrayToSearch.length;
            for(var i = startIndex - 1; i >= 0; i--){
                var currentItem = arrayToSearch[i];
                if (filterCallback(currentItem)) return currentItem;
            }
        };
        // -- Math methods
        helpers$1.isNumber = function(n) {
            return !isNaN(parseFloat(n)) && isFinite(n);
        };
        helpers$1.almostEquals = function(x, y, epsilon) {
            return Math.abs(x - y) < epsilon;
        };
        helpers$1.almostWhole = function(x, epsilon) {
            var rounded = Math.round(x);
            return rounded - epsilon <= x && rounded + epsilon >= x;
        };
        helpers$1.max = function(array) {
            return array.reduce(function(max, value) {
                if (!isNaN(value)) return Math.max(max, value);
                return max;
            }, Number.NEGATIVE_INFINITY);
        };
        helpers$1.min = function(array) {
            return array.reduce(function(min, value) {
                if (!isNaN(value)) return Math.min(min, value);
                return min;
            }, Number.POSITIVE_INFINITY);
        };
        helpers$1.sign = Math.sign ? function(x) {
            return Math.sign(x);
        } : function(x) {
            x = +x; // convert to a number
            if (x === 0 || isNaN(x)) return x;
            return x > 0 ? 1 : -1;
        };
        helpers$1.toRadians = function(degrees) {
            return degrees * (Math.PI / 180);
        };
        helpers$1.toDegrees = function(radians) {
            return radians * (180 / Math.PI);
        };
        /**
	 * Returns the number of decimal places
	 * i.e. the number of digits after the decimal point, of the value of this Number.
	 * @param {number} x - A number.
	 * @returns {number} The number of decimal places.
	 * @private
	 */ helpers$1._decimalPlaces = function(x) {
            if (!helpers$1.isFinite(x)) return;
            var e = 1;
            var p = 0;
            while(Math.round(x * e) / e !== x){
                e *= 10;
                p++;
            }
            return p;
        };
        // Gets the angle from vertical upright to the point about a centre.
        helpers$1.getAngleFromPoint = function(centrePoint, anglePoint) {
            var distanceFromXCenter = anglePoint.x - centrePoint.x;
            var distanceFromYCenter = anglePoint.y - centrePoint.y;
            var radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
            var angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
            if (angle < -0.5 * Math.PI) angle += 2.0 * Math.PI; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
            return {
                angle: angle,
                distance: radialDistanceFromCenter
            };
        };
        helpers$1.distanceBetweenPoints = function(pt1, pt2) {
            return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
        };
        /**
	 * Provided for backward compatibility, not available anymore
	 * @function Chart.helpers.aliasPixel
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 */ helpers$1.aliasPixel = function(pixelWidth) {
            return pixelWidth % 2 === 0 ? 0 : 0.5;
        };
        /**
	 * Returns the aligned pixel value to avoid anti-aliasing blur
	 * @param {Chart} chart - The chart instance.
	 * @param {number} pixel - A pixel value.
	 * @param {number} width - The width of the element.
	 * @returns {number} The aligned pixel value.
	 * @private
	 */ helpers$1._alignPixel = function(chart, pixel, width) {
            var devicePixelRatio = chart.currentDevicePixelRatio;
            var halfWidth = width / 2;
            return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
        };
        helpers$1.splineCurve = function(firstPoint, middlePoint, afterPoint, t) {
            // Props to Rob Spencer at scaled innovation for his post on splining between points
            // http://scaledinnovation.com/analytics/splines/aboutSplines.html
            // This function must also respect "skipped" points
            var previous = firstPoint.skip ? middlePoint : firstPoint;
            var current = middlePoint;
            var next = afterPoint.skip ? middlePoint : afterPoint;
            var d01 = Math.sqrt(Math.pow(current.x - previous.x, 2) + Math.pow(current.y - previous.y, 2));
            var d12 = Math.sqrt(Math.pow(next.x - current.x, 2) + Math.pow(next.y - current.y, 2));
            var s01 = d01 / (d01 + d12);
            var s12 = d12 / (d01 + d12);
            // If all points are the same, s01 & s02 will be inf
            s01 = isNaN(s01) ? 0 : s01;
            s12 = isNaN(s12) ? 0 : s12;
            var fa = t * s01; // scaling factor for triangle Ta
            var fb = t * s12;
            return {
                previous: {
                    x: current.x - fa * (next.x - previous.x),
                    y: current.y - fa * (next.y - previous.y)
                },
                next: {
                    x: current.x + fb * (next.x - previous.x),
                    y: current.y + fb * (next.y - previous.y)
                }
            };
        };
        helpers$1.EPSILON = Number.EPSILON || 1e-14;
        helpers$1.splineCurveMonotone = function(points) {
            // This function calculates Bézier control points in a similar way than |splineCurve|,
            // but preserves monotonicity of the provided data and ensures no local extremums are added
            // between the dataset discrete points due to the interpolation.
            // See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation
            var pointsWithTangents = (points || []).map(function(point) {
                return {
                    model: point._model,
                    deltaK: 0,
                    mK: 0
                };
            });
            // Calculate slopes (deltaK) and initialize tangents (mK)
            var pointsLen = pointsWithTangents.length;
            var i, pointBefore, pointCurrent, pointAfter;
            for(i = 0; i < pointsLen; ++i){
                pointCurrent = pointsWithTangents[i];
                if (pointCurrent.model.skip) continue;
                pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
                pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
                if (pointAfter && !pointAfter.model.skip) {
                    var slopeDeltaX = pointAfter.model.x - pointCurrent.model.x;
                    // In the case of two points that appear at the same x pixel, slopeDeltaX is 0
                    pointCurrent.deltaK = slopeDeltaX !== 0 ? (pointAfter.model.y - pointCurrent.model.y) / slopeDeltaX : 0;
                }
                if (!pointBefore || pointBefore.model.skip) pointCurrent.mK = pointCurrent.deltaK;
                else if (!pointAfter || pointAfter.model.skip) pointCurrent.mK = pointBefore.deltaK;
                else if (this.sign(pointBefore.deltaK) !== this.sign(pointCurrent.deltaK)) pointCurrent.mK = 0;
                else pointCurrent.mK = (pointBefore.deltaK + pointCurrent.deltaK) / 2;
            }
            // Adjust tangents to ensure monotonic properties
            var alphaK, betaK, tauK, squaredMagnitude;
            for(i = 0; i < pointsLen - 1; ++i){
                pointCurrent = pointsWithTangents[i];
                pointAfter = pointsWithTangents[i + 1];
                if (pointCurrent.model.skip || pointAfter.model.skip) continue;
                if (helpers$1.almostEquals(pointCurrent.deltaK, 0, this.EPSILON)) {
                    pointCurrent.mK = pointAfter.mK = 0;
                    continue;
                }
                alphaK = pointCurrent.mK / pointCurrent.deltaK;
                betaK = pointAfter.mK / pointCurrent.deltaK;
                squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
                if (squaredMagnitude <= 9) continue;
                tauK = 3 / Math.sqrt(squaredMagnitude);
                pointCurrent.mK = alphaK * tauK * pointCurrent.deltaK;
                pointAfter.mK = betaK * tauK * pointCurrent.deltaK;
            }
            // Compute control points
            var deltaX;
            for(i = 0; i < pointsLen; ++i){
                pointCurrent = pointsWithTangents[i];
                if (pointCurrent.model.skip) continue;
                pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
                pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
                if (pointBefore && !pointBefore.model.skip) {
                    deltaX = (pointCurrent.model.x - pointBefore.model.x) / 3;
                    pointCurrent.model.controlPointPreviousX = pointCurrent.model.x - deltaX;
                    pointCurrent.model.controlPointPreviousY = pointCurrent.model.y - deltaX * pointCurrent.mK;
                }
                if (pointAfter && !pointAfter.model.skip) {
                    deltaX = (pointAfter.model.x - pointCurrent.model.x) / 3;
                    pointCurrent.model.controlPointNextX = pointCurrent.model.x + deltaX;
                    pointCurrent.model.controlPointNextY = pointCurrent.model.y + deltaX * pointCurrent.mK;
                }
            }
        };
        helpers$1.nextItem = function(collection, index, loop) {
            if (loop) return index >= collection.length - 1 ? collection[0] : collection[index + 1];
            return index >= collection.length - 1 ? collection[collection.length - 1] : collection[index + 1];
        };
        helpers$1.previousItem = function(collection, index, loop) {
            if (loop) return index <= 0 ? collection[collection.length - 1] : collection[index - 1];
            return index <= 0 ? collection[0] : collection[index - 1];
        };
        // Implementation of the nice number algorithm used in determining where axis labels will go
        helpers$1.niceNum = function(range, round) {
            var exponent = Math.floor(helpers$1.log10(range));
            var fraction = range / Math.pow(10, exponent);
            var niceFraction;
            if (round) {
                if (fraction < 1.5) niceFraction = 1;
                else if (fraction < 3) niceFraction = 2;
                else if (fraction < 7) niceFraction = 5;
                else niceFraction = 10;
            } else if (fraction <= 1.0) niceFraction = 1;
            else if (fraction <= 2) niceFraction = 2;
            else if (fraction <= 5) niceFraction = 5;
            else niceFraction = 10;
            return niceFraction * Math.pow(10, exponent);
        };
        // Request animation polyfill - https://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
        helpers$1.requestAnimFrame = function() {
            if (typeof window === 'undefined') return function(callback) {
                callback();
            };
            return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function(callback) {
                return window.setTimeout(callback, 1000 / 60);
            };
        }();
        // -- DOM methods
        helpers$1.getRelativePosition = function(evt, chart) {
            var mouseX, mouseY;
            var e = evt.originalEvent || evt;
            var canvas = evt.target || evt.srcElement;
            var boundingRect = canvas.getBoundingClientRect();
            var touches = e.touches;
            if (touches && touches.length > 0) {
                mouseX = touches[0].clientX;
                mouseY = touches[0].clientY;
            } else {
                mouseX = e.clientX;
                mouseY = e.clientY;
            }
            // Scale mouse coordinates into canvas coordinates
            // by following the pattern laid out by 'jerryj' in the comments of
            // https://www.html5canvastutorials.com/advanced/html5-canvas-mouse-coordinates/
            var paddingLeft = parseFloat(helpers$1.getStyle(canvas, 'padding-left'));
            var paddingTop = parseFloat(helpers$1.getStyle(canvas, 'padding-top'));
            var paddingRight = parseFloat(helpers$1.getStyle(canvas, 'padding-right'));
            var paddingBottom = parseFloat(helpers$1.getStyle(canvas, 'padding-bottom'));
            var width = boundingRect.right - boundingRect.left - paddingLeft - paddingRight;
            var height = boundingRect.bottom - boundingRect.top - paddingTop - paddingBottom;
            // We divide by the current device pixel ratio, because the canvas is scaled up by that amount in each direction. However
            // the backend model is in unscaled coordinates. Since we are going to deal with our model coordinates, we go back here
            mouseX = Math.round((mouseX - boundingRect.left - paddingLeft) / width * canvas.width / chart.currentDevicePixelRatio);
            mouseY = Math.round((mouseY - boundingRect.top - paddingTop) / height * canvas.height / chart.currentDevicePixelRatio);
            return {
                x: mouseX,
                y: mouseY
            };
        };
        // Private helper function to convert max-width/max-height values that may be percentages into a number
        function parseMaxStyle(styleValue, node, parentProperty) {
            var valueInPixels;
            if (typeof styleValue === 'string') {
                valueInPixels = parseInt(styleValue, 10);
                if (styleValue.indexOf('%') !== -1) // percentage * size in dimension
                valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
            } else valueInPixels = styleValue;
            return valueInPixels;
        }
        /**
	 * Returns if the given value contains an effective constraint.
	 * @private
	 */ function isConstrainedValue(value) {
            return value !== undefined && value !== null && value !== 'none';
        }
        /**
	 * Returns the max width or height of the given DOM node in a cross-browser compatible fashion
	 * @param {HTMLElement} domNode - the node to check the constraint on
	 * @param {string} maxStyle - the style that defines the maximum for the direction we are using ('max-width' / 'max-height')
	 * @param {string} percentageProperty - property of parent to use when calculating width as a percentage
	 * @see {@link https://www.nathanaeljones.com/blog/2013/reading-max-width-cross-browser}
	 */ function getConstraintDimension(domNode, maxStyle, percentageProperty) {
            var view = document.defaultView;
            var parentNode = helpers$1._getParentNode(domNode);
            var constrainedNode = view.getComputedStyle(domNode)[maxStyle];
            var constrainedContainer = view.getComputedStyle(parentNode)[maxStyle];
            var hasCNode = isConstrainedValue(constrainedNode);
            var hasCContainer = isConstrainedValue(constrainedContainer);
            var infinity = Number.POSITIVE_INFINITY;
            if (hasCNode || hasCContainer) return Math.min(hasCNode ? parseMaxStyle(constrainedNode, domNode, percentageProperty) : infinity, hasCContainer ? parseMaxStyle(constrainedContainer, parentNode, percentageProperty) : infinity);
            return 'none';
        }
        // returns Number or undefined if no constraint
        helpers$1.getConstraintWidth = function(domNode) {
            return getConstraintDimension(domNode, 'max-width', 'clientWidth');
        };
        // returns Number or undefined if no constraint
        helpers$1.getConstraintHeight = function(domNode) {
            return getConstraintDimension(domNode, 'max-height', 'clientHeight');
        };
        /**
	 * @private
 	 */ helpers$1._calculatePadding = function(container, padding, parentDimension) {
            padding = helpers$1.getStyle(container, padding);
            return padding.indexOf('%') > -1 ? parentDimension * parseInt(padding, 10) / 100 : parseInt(padding, 10);
        };
        /**
	 * @private
	 */ helpers$1._getParentNode = function(domNode) {
            var parent = domNode.parentNode;
            if (parent && parent.toString() === '[object ShadowRoot]') parent = parent.host;
            return parent;
        };
        helpers$1.getMaximumWidth = function(domNode) {
            var container = helpers$1._getParentNode(domNode);
            if (!container) return domNode.clientWidth;
            var clientWidth = container.clientWidth;
            var paddingLeft = helpers$1._calculatePadding(container, 'padding-left', clientWidth);
            var paddingRight = helpers$1._calculatePadding(container, 'padding-right', clientWidth);
            var w = clientWidth - paddingLeft - paddingRight;
            var cw = helpers$1.getConstraintWidth(domNode);
            return isNaN(cw) ? w : Math.min(w, cw);
        };
        helpers$1.getMaximumHeight = function(domNode) {
            var container = helpers$1._getParentNode(domNode);
            if (!container) return domNode.clientHeight;
            var clientHeight = container.clientHeight;
            var paddingTop = helpers$1._calculatePadding(container, 'padding-top', clientHeight);
            var paddingBottom = helpers$1._calculatePadding(container, 'padding-bottom', clientHeight);
            var h = clientHeight - paddingTop - paddingBottom;
            var ch = helpers$1.getConstraintHeight(domNode);
            return isNaN(ch) ? h : Math.min(h, ch);
        };
        helpers$1.getStyle = function(el, property) {
            return el.currentStyle ? el.currentStyle[property] : document.defaultView.getComputedStyle(el, null).getPropertyValue(property);
        };
        helpers$1.retinaScale = function(chart, forceRatio) {
            var pixelRatio = chart.currentDevicePixelRatio = forceRatio || typeof window !== 'undefined' && window.devicePixelRatio || 1;
            if (pixelRatio === 1) return;
            var canvas = chart.canvas;
            var height = chart.height;
            var width = chart.width;
            canvas.height = height * pixelRatio;
            canvas.width = width * pixelRatio;
            chart.ctx.scale(pixelRatio, pixelRatio);
            // If no style has been set on the canvas, the render size is used as display size,
            // making the chart visually bigger, so let's enforce it to the "correct" values.
            // See https://github.com/chartjs/Chart.js/issues/3575
            if (!canvas.style.height && !canvas.style.width) {
                canvas.style.height = height + 'px';
                canvas.style.width = width + 'px';
            }
        };
        // -- Canvas methods
        helpers$1.fontString = function(pixelSize, fontStyle, fontFamily) {
            return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
        };
        helpers$1.longestText = function(ctx, font, arrayOfThings, cache) {
            cache = cache || {};
            var data = cache.data = cache.data || {};
            var gc = cache.garbageCollect = cache.garbageCollect || [];
            if (cache.font !== font) {
                data = cache.data = {};
                gc = cache.garbageCollect = [];
                cache.font = font;
            }
            ctx.font = font;
            var longest = 0;
            var ilen = arrayOfThings.length;
            var i, j, jlen, thing, nestedThing;
            for(i = 0; i < ilen; i++){
                thing = arrayOfThings[i];
                // Undefined strings and arrays should not be measured
                if (thing !== undefined && thing !== null && helpers$1.isArray(thing) !== true) longest = helpers$1.measureText(ctx, data, gc, longest, thing);
                else if (helpers$1.isArray(thing)) // if it is an array lets measure each element
                // to do maybe simplify this function a bit so we can do this more recursively?
                for(j = 0, jlen = thing.length; j < jlen; j++){
                    nestedThing = thing[j];
                    // Undefined strings and arrays should not be measured
                    if (nestedThing !== undefined && nestedThing !== null && !helpers$1.isArray(nestedThing)) longest = helpers$1.measureText(ctx, data, gc, longest, nestedThing);
                }
            }
            var gcLen = gc.length / 2;
            if (gcLen > arrayOfThings.length) {
                for(i = 0; i < gcLen; i++)delete data[gc[i]];
                gc.splice(0, gcLen);
            }
            return longest;
        };
        helpers$1.measureText = function(ctx, data, gc, longest, string) {
            var textWidth = data[string];
            if (!textWidth) {
                textWidth = data[string] = ctx.measureText(string).width;
                gc.push(string);
            }
            if (textWidth > longest) longest = textWidth;
            return longest;
        };
        /**
	 * @deprecated
	 */ helpers$1.numberOfLabelLines = function(arrayOfThings) {
            var numberOfLines = 1;
            helpers$1.each(arrayOfThings, function(thing) {
                if (helpers$1.isArray(thing)) {
                    if (thing.length > numberOfLines) numberOfLines = thing.length;
                }
            });
            return numberOfLines;
        };
        helpers$1.color = !chartjsColor ? function(value) {
            console.error('Color.js not found!');
            return value;
        } : function(value) {
            /* global CanvasGradient */ if (value instanceof CanvasGradient) value = core_defaults.global.defaultColor;
            return chartjsColor(value);
        };
        helpers$1.getHoverColor = function(colorValue) {
            /* global CanvasPattern */ return colorValue instanceof CanvasPattern || colorValue instanceof CanvasGradient ? colorValue : helpers$1.color(colorValue).saturate(0.5).darken(0.1).rgbString();
        };
    };
    function abstract() {
        throw new Error("This method is not implemented: either no adapter can be found or an incomplete integration was provided.");
    }
    /**
 * Date adapter (current used by the time scale)
 * @namespace Chart._adapters._date
 * @memberof Chart._adapters
 * @private
 */ /**
 * Currently supported unit string values.
 * @typedef {('millisecond'|'second'|'minute'|'hour'|'day'|'week'|'month'|'quarter'|'year')}
 * @memberof Chart._adapters._date
 * @name Unit
 */ /**
 * @class
 */ function DateAdapter(options) {
        this.options = options || {};
    }
    helpers$1.extend(DateAdapter.prototype, /** @lends DateAdapter */ {
        /**
	 * Returns a map of time formats for the supported formatting units defined
	 * in Unit as well as 'datetime' representing a detailed date/time string.
	 * @returns {{string: string}}
	 */ formats: abstract,
        /**
	 * Parses the given `value` and return the associated timestamp.
	 * @param {any} value - the value to parse (usually comes from the data)
	 * @param {string} [format] - the expected data format
	 * @returns {(number|null)}
	 * @function
	 */ parse: abstract,
        /**
	 * Returns the formatted date in the specified `format` for a given `timestamp`.
	 * @param {number} timestamp - the timestamp to format
	 * @param {string} format - the date/time token
	 * @return {string}
	 * @function
	 */ format: abstract,
        /**
	 * Adds the specified `amount` of `unit` to the given `timestamp`.
	 * @param {number} timestamp - the input timestamp
	 * @param {number} amount - the amount to add
	 * @param {Unit} unit - the unit as string
	 * @return {number}
	 * @function
	 */ add: abstract,
        /**
	 * Returns the number of `unit` between the given timestamps.
	 * @param {number} max - the input timestamp (reference)
	 * @param {number} min - the timestamp to substract
	 * @param {Unit} unit - the unit as string
	 * @return {number}
	 * @function
	 */ diff: abstract,
        /**
	 * Returns start of `unit` for the given `timestamp`.
	 * @param {number} timestamp - the input timestamp
	 * @param {Unit} unit - the unit as string
	 * @param {number} [weekday] - the ISO day of the week with 1 being Monday
	 * and 7 being Sunday (only needed if param *unit* is `isoWeek`).
	 * @function
	 */ startOf: abstract,
        /**
	 * Returns end of `unit` for the given `timestamp`.
	 * @param {number} timestamp - the input timestamp
	 * @param {Unit} unit - the unit as string
	 * @function
	 */ endOf: abstract,
        // DEPRECATIONS
        /**
	 * Provided for backward compatibility for scale.getValueForPixel(),
	 * this method should be overridden only by the moment adapter.
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */ _create: function(value) {
            return value;
        }
    });
    DateAdapter.override = function(members) {
        helpers$1.extend(DateAdapter.prototype, members);
    };
    var _date = DateAdapter;
    var core_adapters = {
        _date: _date
    };
    /**
 * Namespace to hold static tick generation functions
 * @namespace Chart.Ticks
 */ var core_ticks = {
        /**
	 * Namespace to hold formatters for different types of ticks
	 * @namespace Chart.Ticks.formatters
	 */ formatters: {
            /**
		 * Formatter for value labels
		 * @method Chart.Ticks.formatters.values
		 * @param value the value to display
		 * @return {string|string[]} the label to display
		 */ values: function(value) {
                return helpers$1.isArray(value) ? value : '' + value;
            },
            /**
		 * Formatter for linear numeric ticks
		 * @method Chart.Ticks.formatters.linear
		 * @param tickValue {number} the value to be formatted
		 * @param index {number} the position of the tickValue parameter in the ticks array
		 * @param ticks {number[]} the list of ticks being converted
		 * @return {string} string representation of the tickValue parameter
		 */ linear: function(tickValue, index, ticks) {
                // If we have lots of ticks, don't use the ones
                var delta = ticks.length > 3 ? ticks[2] - ticks[1] : ticks[1] - ticks[0];
                // If we have a number like 2.5 as the delta, figure out how many decimal places we need
                if (Math.abs(delta) > 1) {
                    if (tickValue !== Math.floor(tickValue)) // not an integer
                    delta = tickValue - Math.floor(tickValue);
                }
                var logDelta = helpers$1.log10(Math.abs(delta));
                var tickString = '';
                if (tickValue !== 0) {
                    var maxTick = Math.max(Math.abs(ticks[0]), Math.abs(ticks[ticks.length - 1]));
                    if (maxTick < 1e-4) {
                        var logTick = helpers$1.log10(Math.abs(tickValue));
                        var numExponential = Math.floor(logTick) - Math.floor(logDelta);
                        numExponential = Math.max(Math.min(numExponential, 20), 0);
                        tickString = tickValue.toExponential(numExponential);
                    } else {
                        var numDecimal = -1 * Math.floor(logDelta);
                        numDecimal = Math.max(Math.min(numDecimal, 20), 0); // toFixed has a max of 20 decimal places
                        tickString = tickValue.toFixed(numDecimal);
                    }
                } else tickString = '0'; // never show decimal places for 0
                return tickString;
            },
            logarithmic: function(tickValue, index, ticks) {
                var remain = tickValue / Math.pow(10, Math.floor(helpers$1.log10(tickValue)));
                if (tickValue === 0) return '0';
                else if (remain === 1 || remain === 2 || remain === 5 || index === 0 || index === ticks.length - 1) return tickValue.toExponential();
                return '';
            }
        }
    };
    var isArray = helpers$1.isArray;
    var isNullOrUndef = helpers$1.isNullOrUndef;
    var valueOrDefault$a = helpers$1.valueOrDefault;
    var valueAtIndexOrDefault = helpers$1.valueAtIndexOrDefault;
    core_defaults._set('scale', {
        display: true,
        position: 'left',
        offset: false,
        // grid line settings
        gridLines: {
            display: true,
            color: 'rgba(0,0,0,0.1)',
            lineWidth: 1,
            drawBorder: true,
            drawOnChartArea: true,
            drawTicks: true,
            tickMarkLength: 10,
            zeroLineWidth: 1,
            zeroLineColor: 'rgba(0,0,0,0.25)',
            zeroLineBorderDash: [],
            zeroLineBorderDashOffset: 0.0,
            offsetGridLines: false,
            borderDash: [],
            borderDashOffset: 0.0
        },
        // scale label
        scaleLabel: {
            // display property
            display: false,
            // actual label
            labelString: '',
            // top/bottom padding
            padding: {
                top: 4,
                bottom: 4
            }
        },
        // label settings
        ticks: {
            beginAtZero: false,
            minRotation: 0,
            maxRotation: 50,
            mirror: false,
            padding: 0,
            reverse: false,
            display: true,
            autoSkip: true,
            autoSkipPadding: 0,
            labelOffset: 0,
            // We pass through arrays to be rendered as multiline labels, we convert Others to strings here.
            callback: core_ticks.formatters.values,
            minor: {},
            major: {}
        }
    });
    /** Returns a new array containing numItems from arr */ function sample(arr, numItems) {
        var result = [];
        var increment = arr.length / numItems;
        var i = 0;
        var len = arr.length;
        for(; i < len; i += increment)result.push(arr[Math.floor(i)]);
        return result;
    }
    function getPixelForGridLine(scale, index, offsetGridLines) {
        var length = scale.getTicks().length;
        var validIndex = Math.min(index, length - 1);
        var lineValue = scale.getPixelForTick(validIndex);
        var start = scale._startPixel;
        var end = scale._endPixel;
        var epsilon = 1e-6; // 1e-6 is margin in pixels for accumulated error.
        var offset;
        if (offsetGridLines) {
            if (length === 1) offset = Math.max(lineValue - start, end - lineValue);
            else if (index === 0) offset = (scale.getPixelForTick(1) - lineValue) / 2;
            else offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
            lineValue += validIndex < index ? offset : -offset;
            // Return undefined if the pixel is out of the range
            if (lineValue < start - epsilon || lineValue > end + epsilon) return;
        }
        return lineValue;
    }
    function garbageCollect(caches, length) {
        helpers$1.each(caches, function(cache) {
            var gc = cache.gc;
            var gcLen = gc.length / 2;
            var i;
            if (gcLen > length) {
                for(i = 0; i < gcLen; ++i)delete cache.data[gc[i]];
                gc.splice(0, gcLen);
            }
        });
    }
    /**
 * Returns {width, height, offset} objects for the first, last, widest, highest tick
 * labels where offset indicates the anchor point offset from the top in pixels.
 */ function computeLabelSizes(ctx, tickFonts, ticks, caches) {
        var length = ticks.length;
        var widths = [];
        var heights = [];
        var offsets = [];
        var widestLabelSize = 0;
        var highestLabelSize = 0;
        var i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel, widest, highest;
        for(i = 0; i < length; ++i){
            label = ticks[i].label;
            tickFont = ticks[i].major ? tickFonts.major : tickFonts.minor;
            ctx.font = fontString = tickFont.string;
            cache = caches[fontString] = caches[fontString] || {
                data: {},
                gc: []
            };
            lineHeight = tickFont.lineHeight;
            width = height = 0;
            // Undefined labels and arrays should not be measured
            if (!isNullOrUndef(label) && !isArray(label)) {
                width = helpers$1.measureText(ctx, cache.data, cache.gc, width, label);
                height = lineHeight;
            } else if (isArray(label)) // if it is an array let's measure each element
            for(j = 0, jlen = label.length; j < jlen; ++j){
                nestedLabel = label[j];
                // Undefined labels and arrays should not be measured
                if (!isNullOrUndef(nestedLabel) && !isArray(nestedLabel)) {
                    width = helpers$1.measureText(ctx, cache.data, cache.gc, width, nestedLabel);
                    height += lineHeight;
                }
            }
            widths.push(width);
            heights.push(height);
            offsets.push(lineHeight / 2);
            widestLabelSize = Math.max(width, widestLabelSize);
            highestLabelSize = Math.max(height, highestLabelSize);
        }
        garbageCollect(caches, length);
        widest = widths.indexOf(widestLabelSize);
        highest = heights.indexOf(highestLabelSize);
        function valueAt(idx) {
            return {
                width: widths[idx] || 0,
                height: heights[idx] || 0,
                offset: offsets[idx] || 0
            };
        }
        return {
            first: valueAt(0),
            last: valueAt(length - 1),
            widest: valueAt(widest),
            highest: valueAt(highest)
        };
    }
    function getTickMarkLength(options) {
        return options.drawTicks ? options.tickMarkLength : 0;
    }
    function getScaleLabelHeight(options) {
        var font, padding;
        if (!options.display) return 0;
        font = helpers$1.options._parseFont(options);
        padding = helpers$1.options.toPadding(options.padding);
        return font.lineHeight + padding.height;
    }
    function parseFontOptions(options, nestedOpts) {
        return helpers$1.extend(helpers$1.options._parseFont({
            fontFamily: valueOrDefault$a(nestedOpts.fontFamily, options.fontFamily),
            fontSize: valueOrDefault$a(nestedOpts.fontSize, options.fontSize),
            fontStyle: valueOrDefault$a(nestedOpts.fontStyle, options.fontStyle),
            lineHeight: valueOrDefault$a(nestedOpts.lineHeight, options.lineHeight)
        }), {
            color: helpers$1.options.resolve([
                nestedOpts.fontColor,
                options.fontColor,
                core_defaults.global.defaultFontColor
            ])
        });
    }
    function parseTickFontOptions(options) {
        var minor = parseFontOptions(options, options.minor);
        var major = options.major.enabled ? parseFontOptions(options, options.major) : minor;
        return {
            minor: minor,
            major: major
        };
    }
    function nonSkipped(ticksToFilter) {
        var filtered = [];
        var item, index, len;
        for(index = 0, len = ticksToFilter.length; index < len; ++index){
            item = ticksToFilter[index];
            if (typeof item._index !== 'undefined') filtered.push(item);
        }
        return filtered;
    }
    function getEvenSpacing(arr) {
        var len = arr.length;
        var i, diff;
        if (len < 2) return false;
        for(diff = arr[0], i = 1; i < len; ++i){
            if (arr[i] - arr[i - 1] !== diff) return false;
        }
        return diff;
    }
    function calculateSpacing(majorIndices, ticks, axisLength, ticksLimit) {
        var evenMajorSpacing = getEvenSpacing(majorIndices);
        var spacing = (ticks.length - 1) / ticksLimit;
        var factors, factor, i, ilen;
        // If the major ticks are evenly spaced apart, place the minor ticks
        // so that they divide the major ticks into even chunks
        if (!evenMajorSpacing) return Math.max(spacing, 1);
        factors = helpers$1.math._factorize(evenMajorSpacing);
        for(i = 0, ilen = factors.length - 1; i < ilen; i++){
            factor = factors[i];
            if (factor > spacing) return factor;
        }
        return Math.max(spacing, 1);
    }
    function getMajorIndices(ticks) {
        var result = [];
        var i, ilen;
        for(i = 0, ilen = ticks.length; i < ilen; i++)if (ticks[i].major) result.push(i);
        return result;
    }
    function skipMajors(ticks, majorIndices, spacing) {
        var count = 0;
        var next = majorIndices[0];
        var i, tick;
        spacing = Math.ceil(spacing);
        for(i = 0; i < ticks.length; i++){
            tick = ticks[i];
            if (i === next) {
                tick._index = i;
                count++;
                next = majorIndices[count * spacing];
            } else delete tick.label;
        }
    }
    function skip(ticks, spacing, majorStart, majorEnd) {
        var start = valueOrDefault$a(majorStart, 0);
        var end = Math.min(valueOrDefault$a(majorEnd, ticks.length), ticks.length);
        var count = 0;
        var length, i, tick, next;
        spacing = Math.ceil(spacing);
        if (majorEnd) {
            length = majorEnd - majorStart;
            spacing = length / Math.floor(length / spacing);
        }
        next = start;
        while(next < 0){
            count++;
            next = Math.round(start + count * spacing);
        }
        for(i = Math.max(start, 0); i < end; i++){
            tick = ticks[i];
            if (i === next) {
                tick._index = i;
                count++;
                next = Math.round(start + count * spacing);
            } else delete tick.label;
        }
    }
    var Scale = core_element.extend({
        zeroLineIndex: 0,
        /**
	 * Get the padding needed for the scale
	 * @method getPadding
	 * @private
	 * @returns {Padding} the necessary padding
	 */ getPadding: function() {
            var me = this;
            return {
                left: me.paddingLeft || 0,
                top: me.paddingTop || 0,
                right: me.paddingRight || 0,
                bottom: me.paddingBottom || 0
            };
        },
        /**
	 * Returns the scale tick objects ({label, major})
	 * @since 2.7
	 */ getTicks: function() {
            return this._ticks;
        },
        /**
	* @private
	*/ _getLabels: function() {
            var data = this.chart.data;
            return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
        },
        // These methods are ordered by lifecyle. Utilities then follow.
        // Any function defined here is inherited by all scale types.
        // Any function can be extended by the scale type
        /**
	 * Provided for backward compatibility, not available anymore
	 * @function Chart.Scale.mergeTicksOptions
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 */ mergeTicksOptions: function() {
        // noop
        },
        beforeUpdate: function() {
            helpers$1.callback(this.options.beforeUpdate, [
                this
            ]);
        },
        /**
	 * @param {number} maxWidth - the max width in pixels
	 * @param {number} maxHeight - the max height in pixels
	 * @param {object} margins - the space between the edge of the other scales and edge of the chart
	 *   This space comes from two sources:
	 *     - padding - space that's required to show the labels at the edges of the scale
	 *     - thickness of scales or legends in another orientation
	 */ update: function(maxWidth, maxHeight, margins) {
            var me = this;
            var tickOpts = me.options.ticks;
            var sampleSize = tickOpts.sampleSize;
            var i, ilen, labels, ticks, samplingEnabled;
            // Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
            me.beforeUpdate();
            // Absorb the master measurements
            me.maxWidth = maxWidth;
            me.maxHeight = maxHeight;
            me.margins = helpers$1.extend({
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
            }, margins);
            me._ticks = null;
            me.ticks = null;
            me._labelSizes = null;
            me._maxLabelLines = 0;
            me.longestLabelWidth = 0;
            me.longestTextCache = me.longestTextCache || {};
            me._gridLineItems = null;
            me._labelItems = null;
            // Dimensions
            me.beforeSetDimensions();
            me.setDimensions();
            me.afterSetDimensions();
            // Data min/max
            me.beforeDataLimits();
            me.determineDataLimits();
            me.afterDataLimits();
            // Ticks - `this.ticks` is now DEPRECATED!
            // Internal ticks are now stored as objects in the PRIVATE `this._ticks` member
            // and must not be accessed directly from outside this class. `this.ticks` being
            // around for long time and not marked as private, we can't change its structure
            // without unexpected breaking changes. If you need to access the scale ticks,
            // use scale.getTicks() instead.
            me.beforeBuildTicks();
            // New implementations should return an array of objects but for BACKWARD COMPAT,
            // we still support no return (`this.ticks` internally set by calling this method).
            ticks = me.buildTicks() || [];
            // Allow modification of ticks in callback.
            ticks = me.afterBuildTicks(ticks) || ticks;
            // Ensure ticks contains ticks in new tick format
            if ((!ticks || !ticks.length) && me.ticks) {
                ticks = [];
                for(i = 0, ilen = me.ticks.length; i < ilen; ++i)ticks.push({
                    value: me.ticks[i],
                    major: false
                });
            }
            me._ticks = ticks;
            // Compute tick rotation and fit using a sampled subset of labels
            // We generally don't need to compute the size of every single label for determining scale size
            samplingEnabled = sampleSize < ticks.length;
            labels = me._convertTicksToLabels(samplingEnabled ? sample(ticks, sampleSize) : ticks);
            // _configure is called twice, once here, once from core.controller.updateLayout.
            // Here we haven't been positioned yet, but dimensions are correct.
            // Variables set in _configure are needed for calculateTickRotation, and
            // it's ok that coordinates are not correct there, only dimensions matter.
            me._configure();
            // Tick Rotation
            me.beforeCalculateTickRotation();
            me.calculateTickRotation();
            me.afterCalculateTickRotation();
            me.beforeFit();
            me.fit();
            me.afterFit();
            // Auto-skip
            me._ticksToDraw = tickOpts.display && (tickOpts.autoSkip || tickOpts.source === 'auto') ? me._autoSkip(ticks) : ticks;
            if (samplingEnabled) // Generate labels using all non-skipped ticks
            labels = me._convertTicksToLabels(me._ticksToDraw);
            me.ticks = labels; // BACKWARD COMPATIBILITY
            // IMPORTANT: after this point, we consider that `this.ticks` will NEVER change!
            me.afterUpdate();
            // TODO(v3): remove minSize as a public property and return value from all layout boxes. It is unused
            // make maxWidth and maxHeight private
            return me.minSize;
        },
        /**
	 * @private
	 */ _configure: function() {
            var me = this;
            var reversePixels = me.options.ticks.reverse;
            var startPixel, endPixel;
            if (me.isHorizontal()) {
                startPixel = me.left;
                endPixel = me.right;
            } else {
                startPixel = me.top;
                endPixel = me.bottom;
                // by default vertical scales are from bottom to top, so pixels are reversed
                reversePixels = !reversePixels;
            }
            me._startPixel = startPixel;
            me._endPixel = endPixel;
            me._reversePixels = reversePixels;
            me._length = endPixel - startPixel;
        },
        afterUpdate: function() {
            helpers$1.callback(this.options.afterUpdate, [
                this
            ]);
        },
        //
        beforeSetDimensions: function() {
            helpers$1.callback(this.options.beforeSetDimensions, [
                this
            ]);
        },
        setDimensions: function() {
            var me = this;
            // Set the unconstrained dimension before label rotation
            if (me.isHorizontal()) {
                // Reset position before calculating rotation
                me.width = me.maxWidth;
                me.left = 0;
                me.right = me.width;
            } else {
                me.height = me.maxHeight;
                // Reset position before calculating rotation
                me.top = 0;
                me.bottom = me.height;
            }
            // Reset padding
            me.paddingLeft = 0;
            me.paddingTop = 0;
            me.paddingRight = 0;
            me.paddingBottom = 0;
        },
        afterSetDimensions: function() {
            helpers$1.callback(this.options.afterSetDimensions, [
                this
            ]);
        },
        // Data limits
        beforeDataLimits: function() {
            helpers$1.callback(this.options.beforeDataLimits, [
                this
            ]);
        },
        determineDataLimits: helpers$1.noop,
        afterDataLimits: function() {
            helpers$1.callback(this.options.afterDataLimits, [
                this
            ]);
        },
        //
        beforeBuildTicks: function() {
            helpers$1.callback(this.options.beforeBuildTicks, [
                this
            ]);
        },
        buildTicks: helpers$1.noop,
        afterBuildTicks: function(ticks) {
            var me = this;
            // ticks is empty for old axis implementations here
            if (isArray(ticks) && ticks.length) return helpers$1.callback(me.options.afterBuildTicks, [
                me,
                ticks
            ]);
            // Support old implementations (that modified `this.ticks` directly in buildTicks)
            me.ticks = helpers$1.callback(me.options.afterBuildTicks, [
                me,
                me.ticks
            ]) || me.ticks;
            return ticks;
        },
        beforeTickToLabelConversion: function() {
            helpers$1.callback(this.options.beforeTickToLabelConversion, [
                this
            ]);
        },
        convertTicksToLabels: function() {
            var me = this;
            // Convert ticks to strings
            var tickOpts = me.options.ticks;
            me.ticks = me.ticks.map(tickOpts.userCallback || tickOpts.callback, this);
        },
        afterTickToLabelConversion: function() {
            helpers$1.callback(this.options.afterTickToLabelConversion, [
                this
            ]);
        },
        //
        beforeCalculateTickRotation: function() {
            helpers$1.callback(this.options.beforeCalculateTickRotation, [
                this
            ]);
        },
        calculateTickRotation: function() {
            var me = this;
            var options = me.options;
            var tickOpts = options.ticks;
            var numTicks = me.getTicks().length;
            var minRotation = tickOpts.minRotation || 0;
            var maxRotation = tickOpts.maxRotation;
            var labelRotation = minRotation;
            var labelSizes, maxLabelWidth, maxLabelHeight, maxWidth, tickWidth, maxHeight, maxLabelDiagonal;
            if (!me._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !me.isHorizontal()) {
                me.labelRotation = minRotation;
                return;
            }
            labelSizes = me._getLabelSizes();
            maxLabelWidth = labelSizes.widest.width;
            maxLabelHeight = labelSizes.highest.height - labelSizes.highest.offset;
            // Estimate the width of each grid based on the canvas width, the maximum
            // label width and the number of tick intervals
            maxWidth = Math.min(me.maxWidth, me.chart.width - maxLabelWidth);
            tickWidth = options.offset ? me.maxWidth / numTicks : maxWidth / (numTicks - 1);
            // Allow 3 pixels x2 padding either side for label readability
            if (maxLabelWidth + 6 > tickWidth) {
                tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
                maxHeight = me.maxHeight - getTickMarkLength(options.gridLines) - tickOpts.padding - getScaleLabelHeight(options.scaleLabel);
                maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
                labelRotation = helpers$1.toDegrees(Math.min(Math.asin(Math.min((labelSizes.highest.height + 6) / tickWidth, 1)), Math.asin(Math.min(maxHeight / maxLabelDiagonal, 1)) - Math.asin(maxLabelHeight / maxLabelDiagonal)));
                labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
            }
            me.labelRotation = labelRotation;
        },
        afterCalculateTickRotation: function() {
            helpers$1.callback(this.options.afterCalculateTickRotation, [
                this
            ]);
        },
        //
        beforeFit: function() {
            helpers$1.callback(this.options.beforeFit, [
                this
            ]);
        },
        fit: function() {
            var me = this;
            // Reset
            var minSize = me.minSize = {
                width: 0,
                height: 0
            };
            var chart = me.chart;
            var opts = me.options;
            var tickOpts = opts.ticks;
            var scaleLabelOpts = opts.scaleLabel;
            var gridLineOpts = opts.gridLines;
            var display = me._isVisible();
            var isBottom = opts.position === 'bottom';
            var isHorizontal = me.isHorizontal();
            // Width
            if (isHorizontal) minSize.width = me.maxWidth;
            else if (display) minSize.width = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
            // height
            if (!isHorizontal) minSize.height = me.maxHeight; // fill all the height
            else if (display) minSize.height = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
            // Don't bother fitting the ticks if we are not showing the labels
            if (tickOpts.display && display) {
                var tickFonts = parseTickFontOptions(tickOpts);
                var labelSizes = me._getLabelSizes();
                var firstLabelSize = labelSizes.first;
                var lastLabelSize = labelSizes.last;
                var widestLabelSize = labelSizes.widest;
                var highestLabelSize = labelSizes.highest;
                var lineSpace = tickFonts.minor.lineHeight * 0.4;
                var tickPadding = tickOpts.padding;
                if (isHorizontal) {
                    // A horizontal axis is more constrained by the height.
                    var isRotated = me.labelRotation !== 0;
                    var angleRadians = helpers$1.toRadians(me.labelRotation);
                    var cosRotation = Math.cos(angleRadians);
                    var sinRotation = Math.sin(angleRadians);
                    var labelHeight = sinRotation * widestLabelSize.width + cosRotation * (highestLabelSize.height - (isRotated ? highestLabelSize.offset : 0)) + (isRotated ? 0 : lineSpace); // padding
                    minSize.height = Math.min(me.maxHeight, minSize.height + labelHeight + tickPadding);
                    var offsetLeft = me.getPixelForTick(0) - me.left;
                    var offsetRight = me.right - me.getPixelForTick(me.getTicks().length - 1);
                    var paddingLeft, paddingRight;
                    // Ensure that our ticks are always inside the canvas. When rotated, ticks are right aligned
                    // which means that the right padding is dominated by the font height
                    if (isRotated) {
                        paddingLeft = isBottom ? cosRotation * firstLabelSize.width + sinRotation * firstLabelSize.offset : sinRotation * (firstLabelSize.height - firstLabelSize.offset);
                        paddingRight = isBottom ? sinRotation * (lastLabelSize.height - lastLabelSize.offset) : cosRotation * lastLabelSize.width + sinRotation * lastLabelSize.offset;
                    } else {
                        paddingLeft = firstLabelSize.width / 2;
                        paddingRight = lastLabelSize.width / 2;
                    }
                    // Adjust padding taking into account changes in offsets
                    // and add 3 px to move away from canvas edges
                    me.paddingLeft = Math.max((paddingLeft - offsetLeft) * me.width / (me.width - offsetLeft), 0) + 3;
                    me.paddingRight = Math.max((paddingRight - offsetRight) * me.width / (me.width - offsetRight), 0) + 3;
                } else {
                    // A vertical axis is more constrained by the width. Labels are the
                    // dominant factor here, so get that length first and account for padding
                    var labelWidth = tickOpts.mirror ? 0 : // use lineSpace for consistency with horizontal axis
                    // tickPadding is not implemented for horizontal
                    widestLabelSize.width + tickPadding + lineSpace;
                    minSize.width = Math.min(me.maxWidth, minSize.width + labelWidth);
                    me.paddingTop = firstLabelSize.height / 2;
                    me.paddingBottom = lastLabelSize.height / 2;
                }
            }
            me.handleMargins();
            if (isHorizontal) {
                me.width = me._length = chart.width - me.margins.left - me.margins.right;
                me.height = minSize.height;
            } else {
                me.width = minSize.width;
                me.height = me._length = chart.height - me.margins.top - me.margins.bottom;
            }
        },
        /**
	 * Handle margins and padding interactions
	 * @private
	 */ handleMargins: function() {
            var me = this;
            if (me.margins) {
                me.margins.left = Math.max(me.paddingLeft, me.margins.left);
                me.margins.top = Math.max(me.paddingTop, me.margins.top);
                me.margins.right = Math.max(me.paddingRight, me.margins.right);
                me.margins.bottom = Math.max(me.paddingBottom, me.margins.bottom);
            }
        },
        afterFit: function() {
            helpers$1.callback(this.options.afterFit, [
                this
            ]);
        },
        // Shared Methods
        isHorizontal: function() {
            var pos = this.options.position;
            return pos === 'top' || pos === 'bottom';
        },
        isFullWidth: function() {
            return this.options.fullWidth;
        },
        // Get the correct value. NaN bad inputs, If the value type is object get the x or y based on whether we are horizontal or not
        getRightValue: function(rawValue) {
            // Null and undefined values first
            if (isNullOrUndef(rawValue)) return NaN;
            // isNaN(object) returns true, so make sure NaN is checking for a number; Discard Infinite values
            if ((typeof rawValue === 'number' || rawValue instanceof Number) && !isFinite(rawValue)) return NaN;
            // If it is in fact an object, dive in one more level
            if (rawValue) {
                if (this.isHorizontal()) {
                    if (rawValue.x !== undefined) return this.getRightValue(rawValue.x);
                } else if (rawValue.y !== undefined) return this.getRightValue(rawValue.y);
            }
            // Value is good, return it
            return rawValue;
        },
        _convertTicksToLabels: function(ticks) {
            var me = this;
            var labels, i, ilen;
            me.ticks = ticks.map(function(tick) {
                return tick.value;
            });
            me.beforeTickToLabelConversion();
            // New implementations should return the formatted tick labels but for BACKWARD
            // COMPAT, we still support no return (`this.ticks` internally changed by calling
            // this method and supposed to contain only string values).
            labels = me.convertTicksToLabels(ticks) || me.ticks;
            me.afterTickToLabelConversion();
            // BACKWARD COMPAT: synchronize `_ticks` with labels (so potentially `this.ticks`)
            for(i = 0, ilen = ticks.length; i < ilen; ++i)ticks[i].label = labels[i];
            return labels;
        },
        /**
	 * @private
	 */ _getLabelSizes: function() {
            var me = this;
            var labelSizes = me._labelSizes;
            if (!labelSizes) {
                me._labelSizes = labelSizes = computeLabelSizes(me.ctx, parseTickFontOptions(me.options.ticks), me.getTicks(), me.longestTextCache);
                me.longestLabelWidth = labelSizes.widest.width;
            }
            return labelSizes;
        },
        /**
	 * @private
	 */ _parseValue: function(value) {
            var start, end, min, max;
            if (isArray(value)) {
                start = +this.getRightValue(value[0]);
                end = +this.getRightValue(value[1]);
                min = Math.min(start, end);
                max = Math.max(start, end);
            } else {
                value = +this.getRightValue(value);
                start = undefined;
                end = value;
                min = value;
                max = value;
            }
            return {
                min: min,
                max: max,
                start: start,
                end: end
            };
        },
        /**
	* @private
	*/ _getScaleLabel: function(rawValue) {
            var v = this._parseValue(rawValue);
            if (v.start !== undefined) return '[' + v.start + ', ' + v.end + ']';
            return +this.getRightValue(rawValue);
        },
        /**
	 * Used to get the value to display in the tooltip for the data at the given index
	 * @param index
	 * @param datasetIndex
	 */ getLabelForIndex: helpers$1.noop,
        /**
	 * Returns the location of the given data point. Value can either be an index or a numerical value
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 * @param value
	 * @param index
	 * @param datasetIndex
	 */ getPixelForValue: helpers$1.noop,
        /**
	 * Used to get the data value from a given pixel. This is the inverse of getPixelForValue
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 * @param pixel
	 */ getValueForPixel: helpers$1.noop,
        /**
	 * Returns the location of the tick at the given index
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 */ getPixelForTick: function(index) {
            var me = this;
            var offset = me.options.offset;
            var numTicks = me._ticks.length;
            var tickWidth = 1 / Math.max(numTicks - (offset ? 0 : 1), 1);
            return index < 0 || index > numTicks - 1 ? null : me.getPixelForDecimal(index * tickWidth + (offset ? tickWidth / 2 : 0));
        },
        /**
	 * Utility for getting the pixel location of a percentage of scale
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 */ getPixelForDecimal: function(decimal) {
            var me = this;
            if (me._reversePixels) decimal = 1 - decimal;
            return me._startPixel + decimal * me._length;
        },
        getDecimalForPixel: function(pixel) {
            var decimal = (pixel - this._startPixel) / this._length;
            return this._reversePixels ? 1 - decimal : decimal;
        },
        /**
	 * Returns the pixel for the minimum chart value
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 */ getBasePixel: function() {
            return this.getPixelForValue(this.getBaseValue());
        },
        getBaseValue: function() {
            var me = this;
            var min = me.min;
            var max = me.max;
            return me.beginAtZero ? 0 : min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0;
        },
        /**
	 * Returns a subset of ticks to be plotted to avoid overlapping labels.
	 * @private
	 */ _autoSkip: function(ticks) {
            var me = this;
            var tickOpts = me.options.ticks;
            var axisLength = me._length;
            var ticksLimit = tickOpts.maxTicksLimit || axisLength / me._tickSize() + 1;
            var majorIndices = tickOpts.major.enabled ? getMajorIndices(ticks) : [];
            var numMajorIndices = majorIndices.length;
            var first = majorIndices[0];
            var last = majorIndices[numMajorIndices - 1];
            var i, ilen, spacing, avgMajorSpacing;
            // If there are too many major ticks to display them all
            if (numMajorIndices > ticksLimit) {
                skipMajors(ticks, majorIndices, numMajorIndices / ticksLimit);
                return nonSkipped(ticks);
            }
            spacing = calculateSpacing(majorIndices, ticks, axisLength, ticksLimit);
            if (numMajorIndices > 0) {
                for(i = 0, ilen = numMajorIndices - 1; i < ilen; i++)skip(ticks, spacing, majorIndices[i], majorIndices[i + 1]);
                avgMajorSpacing = numMajorIndices > 1 ? (last - first) / (numMajorIndices - 1) : null;
                skip(ticks, spacing, helpers$1.isNullOrUndef(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
                skip(ticks, spacing, last, helpers$1.isNullOrUndef(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
                return nonSkipped(ticks);
            }
            skip(ticks, spacing);
            return nonSkipped(ticks);
        },
        /**
	 * @private
	 */ _tickSize: function() {
            var me = this;
            var optionTicks = me.options.ticks;
            // Calculate space needed by label in axis direction.
            var rot = helpers$1.toRadians(me.labelRotation);
            var cos = Math.abs(Math.cos(rot));
            var sin = Math.abs(Math.sin(rot));
            var labelSizes = me._getLabelSizes();
            var padding = optionTicks.autoSkipPadding || 0;
            var w = labelSizes ? labelSizes.widest.width + padding : 0;
            var h = labelSizes ? labelSizes.highest.height + padding : 0;
            // Calculate space needed for 1 tick in axis direction.
            return me.isHorizontal() ? h * cos > w * sin ? w / cos : h / sin : h * sin < w * cos ? h / cos : w / sin;
        },
        /**
	 * @private
	 */ _isVisible: function() {
            var me = this;
            var chart = me.chart;
            var display = me.options.display;
            var i, ilen, meta;
            if (display !== 'auto') return !!display;
            // When 'auto', the scale is visible if at least one associated dataset is visible.
            for(i = 0, ilen = chart.data.datasets.length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                meta = chart.getDatasetMeta(i);
                if (meta.xAxisID === me.id || meta.yAxisID === me.id) return true;
            }
            return false;
        },
        /**
	 * @private
	 */ _computeGridLineItems: function(chartArea) {
            var me = this;
            var chart = me.chart;
            var options = me.options;
            var gridLines = options.gridLines;
            var position = options.position;
            var offsetGridLines = gridLines.offsetGridLines;
            var isHorizontal = me.isHorizontal();
            var ticks = me._ticksToDraw;
            var ticksLength = ticks.length + (offsetGridLines ? 1 : 0);
            var tl = getTickMarkLength(gridLines);
            var items = [];
            var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
            var axisHalfWidth = axisWidth / 2;
            var alignPixel = helpers$1._alignPixel;
            var alignBorderValue = function(pixel) {
                return alignPixel(chart, pixel, axisWidth);
            };
            var borderValue, i, tick, lineValue, alignedLineValue;
            var tx1, ty1, tx2, ty2, x1, y1, x2, y2, lineWidth, lineColor, borderDash, borderDashOffset;
            if (position === 'top') {
                borderValue = alignBorderValue(me.bottom);
                ty1 = me.bottom - tl;
                ty2 = borderValue - axisHalfWidth;
                y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
                y2 = chartArea.bottom;
            } else if (position === 'bottom') {
                borderValue = alignBorderValue(me.top);
                y1 = chartArea.top;
                y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
                ty1 = borderValue + axisHalfWidth;
                ty2 = me.top + tl;
            } else if (position === 'left') {
                borderValue = alignBorderValue(me.right);
                tx1 = me.right - tl;
                tx2 = borderValue - axisHalfWidth;
                x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
                x2 = chartArea.right;
            } else {
                borderValue = alignBorderValue(me.left);
                x1 = chartArea.left;
                x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
                tx1 = borderValue + axisHalfWidth;
                tx2 = me.left + tl;
            }
            for(i = 0; i < ticksLength; ++i){
                tick = ticks[i] || {};
                // autoskipper skipped this tick (#4635)
                if (isNullOrUndef(tick.label) && i < ticks.length) continue;
                if (i === me.zeroLineIndex && options.offset === offsetGridLines) {
                    // Draw the first index specially
                    lineWidth = gridLines.zeroLineWidth;
                    lineColor = gridLines.zeroLineColor;
                    borderDash = gridLines.zeroLineBorderDash || [];
                    borderDashOffset = gridLines.zeroLineBorderDashOffset || 0.0;
                } else {
                    lineWidth = valueAtIndexOrDefault(gridLines.lineWidth, i, 1);
                    lineColor = valueAtIndexOrDefault(gridLines.color, i, 'rgba(0,0,0,0.1)');
                    borderDash = gridLines.borderDash || [];
                    borderDashOffset = gridLines.borderDashOffset || 0.0;
                }
                lineValue = getPixelForGridLine(me, tick._index || i, offsetGridLines);
                // Skip if the pixel is out of the range
                if (lineValue === undefined) continue;
                alignedLineValue = alignPixel(chart, lineValue, lineWidth);
                if (isHorizontal) tx1 = tx2 = x1 = x2 = alignedLineValue;
                else ty1 = ty2 = y1 = y2 = alignedLineValue;
                items.push({
                    tx1: tx1,
                    ty1: ty1,
                    tx2: tx2,
                    ty2: ty2,
                    x1: x1,
                    y1: y1,
                    x2: x2,
                    y2: y2,
                    width: lineWidth,
                    color: lineColor,
                    borderDash: borderDash,
                    borderDashOffset: borderDashOffset
                });
            }
            items.ticksLength = ticksLength;
            items.borderValue = borderValue;
            return items;
        },
        /**
	 * @private
	 */ _computeLabelItems: function() {
            var me = this;
            var options = me.options;
            var optionTicks = options.ticks;
            var position = options.position;
            var isMirrored = optionTicks.mirror;
            var isHorizontal = me.isHorizontal();
            var ticks = me._ticksToDraw;
            var fonts = parseTickFontOptions(optionTicks);
            var tickPadding = optionTicks.padding;
            var tl = getTickMarkLength(options.gridLines);
            var rotation = -helpers$1.toRadians(me.labelRotation);
            var items = [];
            var i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
            if (position === 'top') {
                y = me.bottom - tl - tickPadding;
                textAlign = !rotation ? 'center' : 'left';
            } else if (position === 'bottom') {
                y = me.top + tl + tickPadding;
                textAlign = !rotation ? 'center' : 'right';
            } else if (position === 'left') {
                x = me.right - (isMirrored ? 0 : tl) - tickPadding;
                textAlign = isMirrored ? 'left' : 'right';
            } else {
                x = me.left + (isMirrored ? 0 : tl) + tickPadding;
                textAlign = isMirrored ? 'right' : 'left';
            }
            for(i = 0, ilen = ticks.length; i < ilen; ++i){
                tick = ticks[i];
                label = tick.label;
                // autoskipper skipped this tick (#4635)
                if (isNullOrUndef(label)) continue;
                pixel = me.getPixelForTick(tick._index || i) + optionTicks.labelOffset;
                font = tick.major ? fonts.major : fonts.minor;
                lineHeight = font.lineHeight;
                lineCount = isArray(label) ? label.length : 1;
                if (isHorizontal) {
                    x = pixel;
                    textOffset = position === 'top' ? ((!rotation ? 0.5 : 1) - lineCount) * lineHeight : (!rotation ? 0.5 : 0) * lineHeight;
                } else {
                    y = pixel;
                    textOffset = (1 - lineCount) * lineHeight / 2;
                }
                items.push({
                    x: x,
                    y: y,
                    rotation: rotation,
                    label: label,
                    font: font,
                    textOffset: textOffset,
                    textAlign: textAlign
                });
            }
            return items;
        },
        /**
	 * @private
	 */ _drawGrid: function(chartArea) {
            var me = this;
            var gridLines = me.options.gridLines;
            if (!gridLines.display) return;
            var ctx = me.ctx;
            var chart = me.chart;
            var alignPixel = helpers$1._alignPixel;
            var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
            var items = me._gridLineItems || (me._gridLineItems = me._computeGridLineItems(chartArea));
            var width, color, i, ilen, item;
            for(i = 0, ilen = items.length; i < ilen; ++i){
                item = items[i];
                width = item.width;
                color = item.color;
                if (width && color) {
                    ctx.save();
                    ctx.lineWidth = width;
                    ctx.strokeStyle = color;
                    if (ctx.setLineDash) {
                        ctx.setLineDash(item.borderDash);
                        ctx.lineDashOffset = item.borderDashOffset;
                    }
                    ctx.beginPath();
                    if (gridLines.drawTicks) {
                        ctx.moveTo(item.tx1, item.ty1);
                        ctx.lineTo(item.tx2, item.ty2);
                    }
                    if (gridLines.drawOnChartArea) {
                        ctx.moveTo(item.x1, item.y1);
                        ctx.lineTo(item.x2, item.y2);
                    }
                    ctx.stroke();
                    ctx.restore();
                }
            }
            if (axisWidth) {
                // Draw the line at the edge of the axis
                var firstLineWidth = axisWidth;
                var lastLineWidth = valueAtIndexOrDefault(gridLines.lineWidth, items.ticksLength - 1, 1);
                var borderValue = items.borderValue;
                var x1, x2, y1, y2;
                if (me.isHorizontal()) {
                    x1 = alignPixel(chart, me.left, firstLineWidth) - firstLineWidth / 2;
                    x2 = alignPixel(chart, me.right, lastLineWidth) + lastLineWidth / 2;
                    y1 = y2 = borderValue;
                } else {
                    y1 = alignPixel(chart, me.top, firstLineWidth) - firstLineWidth / 2;
                    y2 = alignPixel(chart, me.bottom, lastLineWidth) + lastLineWidth / 2;
                    x1 = x2 = borderValue;
                }
                ctx.lineWidth = axisWidth;
                ctx.strokeStyle = valueAtIndexOrDefault(gridLines.color, 0);
                ctx.beginPath();
                ctx.moveTo(x1, y1);
                ctx.lineTo(x2, y2);
                ctx.stroke();
            }
        },
        /**
	 * @private
	 */ _drawLabels: function() {
            var me = this;
            var optionTicks = me.options.ticks;
            if (!optionTicks.display) return;
            var ctx = me.ctx;
            var items = me._labelItems || (me._labelItems = me._computeLabelItems());
            var i, j, ilen, jlen, item, tickFont, label, y;
            for(i = 0, ilen = items.length; i < ilen; ++i){
                item = items[i];
                tickFont = item.font;
                // Make sure we draw text in the correct color and font
                ctx.save();
                ctx.translate(item.x, item.y);
                ctx.rotate(item.rotation);
                ctx.font = tickFont.string;
                ctx.fillStyle = tickFont.color;
                ctx.textBaseline = 'middle';
                ctx.textAlign = item.textAlign;
                label = item.label;
                y = item.textOffset;
                if (isArray(label)) for(j = 0, jlen = label.length; j < jlen; ++j){
                    // We just make sure the multiline element is a string here..
                    ctx.fillText('' + label[j], 0, y);
                    y += tickFont.lineHeight;
                }
                else ctx.fillText(label, 0, y);
                ctx.restore();
            }
        },
        /**
	 * @private
	 */ _drawTitle: function() {
            var me = this;
            var ctx = me.ctx;
            var options = me.options;
            var scaleLabel = options.scaleLabel;
            if (!scaleLabel.display) return;
            var scaleLabelFontColor = valueOrDefault$a(scaleLabel.fontColor, core_defaults.global.defaultFontColor);
            var scaleLabelFont = helpers$1.options._parseFont(scaleLabel);
            var scaleLabelPadding = helpers$1.options.toPadding(scaleLabel.padding);
            var halfLineHeight = scaleLabelFont.lineHeight / 2;
            var position = options.position;
            var rotation = 0;
            var scaleLabelX, scaleLabelY;
            if (me.isHorizontal()) {
                scaleLabelX = me.left + me.width / 2; // midpoint of the width
                scaleLabelY = position === 'bottom' ? me.bottom - halfLineHeight - scaleLabelPadding.bottom : me.top + halfLineHeight + scaleLabelPadding.top;
            } else {
                var isLeft = position === 'left';
                scaleLabelX = isLeft ? me.left + halfLineHeight + scaleLabelPadding.top : me.right - halfLineHeight - scaleLabelPadding.top;
                scaleLabelY = me.top + me.height / 2;
                rotation = isLeft ? -0.5 * Math.PI : 0.5 * Math.PI;
            }
            ctx.save();
            ctx.translate(scaleLabelX, scaleLabelY);
            ctx.rotate(rotation);
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.fillStyle = scaleLabelFontColor; // render in correct colour
            ctx.font = scaleLabelFont.string;
            ctx.fillText(scaleLabel.labelString, 0, 0);
            ctx.restore();
        },
        draw: function(chartArea) {
            var me = this;
            if (!me._isVisible()) return;
            me._drawGrid(chartArea);
            me._drawTitle();
            me._drawLabels();
        },
        /**
	 * @private
	 */ _layers: function() {
            var me = this;
            var opts = me.options;
            var tz = opts.ticks && opts.ticks.z || 0;
            var gz = opts.gridLines && opts.gridLines.z || 0;
            if (!me._isVisible() || tz === gz || me.draw !== me._draw) // backward compatibility: draw has been overridden by custom scale
            return [
                {
                    z: tz,
                    draw: function() {
                        me.draw.apply(me, arguments);
                    }
                }
            ];
            return [
                {
                    z: gz,
                    draw: function() {
                        me._drawGrid.apply(me, arguments);
                        me._drawTitle.apply(me, arguments);
                    }
                },
                {
                    z: tz,
                    draw: function() {
                        me._drawLabels.apply(me, arguments);
                    }
                }
            ];
        },
        /**
	 * @private
	 */ _getMatchingVisibleMetas: function(type) {
            var me = this;
            var isHorizontal = me.isHorizontal();
            return me.chart._getSortedVisibleDatasetMetas().filter(function(meta) {
                return (!type || meta.type === type) && (isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id);
            });
        }
    });
    Scale.prototype._draw = Scale.prototype.draw;
    var core_scale = Scale;
    var isNullOrUndef$1 = helpers$1.isNullOrUndef;
    var defaultConfig = {
        position: 'bottom'
    };
    var scale_category = core_scale.extend({
        determineDataLimits: function() {
            var me = this;
            var labels = me._getLabels();
            var ticksOpts = me.options.ticks;
            var min = ticksOpts.min;
            var max = ticksOpts.max;
            var minIndex = 0;
            var maxIndex = labels.length - 1;
            var findIndex;
            if (min !== undefined) {
                // user specified min value
                findIndex = labels.indexOf(min);
                if (findIndex >= 0) minIndex = findIndex;
            }
            if (max !== undefined) {
                // user specified max value
                findIndex = labels.indexOf(max);
                if (findIndex >= 0) maxIndex = findIndex;
            }
            me.minIndex = minIndex;
            me.maxIndex = maxIndex;
            me.min = labels[minIndex];
            me.max = labels[maxIndex];
        },
        buildTicks: function() {
            var me = this;
            var labels = me._getLabels();
            var minIndex = me.minIndex;
            var maxIndex = me.maxIndex;
            // If we are viewing some subset of labels, slice the original array
            me.ticks = minIndex === 0 && maxIndex === labels.length - 1 ? labels : labels.slice(minIndex, maxIndex + 1);
        },
        getLabelForIndex: function(index, datasetIndex) {
            var me = this;
            var chart = me.chart;
            if (chart.getDatasetMeta(datasetIndex).controller._getValueScaleId() === me.id) return me.getRightValue(chart.data.datasets[datasetIndex].data[index]);
            return me._getLabels()[index];
        },
        _configure: function() {
            var me = this;
            var offset = me.options.offset;
            var ticks = me.ticks;
            core_scale.prototype._configure.call(me);
            if (!me.isHorizontal()) // For backward compatibility, vertical category scale reverse is inverted.
            me._reversePixels = !me._reversePixels;
            if (!ticks) return;
            me._startValue = me.minIndex - (offset ? 0.5 : 0);
            me._valueRange = Math.max(ticks.length - (offset ? 0 : 1), 1);
        },
        // Used to get data value locations.  Value can either be an index or a numerical value
        getPixelForValue: function(value, index, datasetIndex) {
            var me = this;
            var valueCategory, labels, idx;
            if (!isNullOrUndef$1(index) && !isNullOrUndef$1(datasetIndex)) value = me.chart.data.datasets[datasetIndex].data[index];
            // If value is a data object, then index is the index in the data array,
            // not the index of the scale. We need to change that.
            if (!isNullOrUndef$1(value)) valueCategory = me.isHorizontal() ? value.x : value.y;
            if (valueCategory !== undefined || value !== undefined && isNaN(index)) {
                labels = me._getLabels();
                value = helpers$1.valueOrDefault(valueCategory, value);
                idx = labels.indexOf(value);
                index = idx !== -1 ? idx : index;
                if (isNaN(index)) index = value;
            }
            return me.getPixelForDecimal((index - me._startValue) / me._valueRange);
        },
        getPixelForTick: function(index) {
            var ticks = this.ticks;
            return index < 0 || index > ticks.length - 1 ? null : this.getPixelForValue(ticks[index], index + this.minIndex);
        },
        getValueForPixel: function(pixel) {
            var me = this;
            var value = Math.round(me._startValue + me.getDecimalForPixel(pixel) * me._valueRange);
            return Math.min(Math.max(value, 0), me.ticks.length - 1);
        },
        getBasePixel: function() {
            return this.bottom;
        }
    });
    // INTERNAL: static default options, registered in src/index.js
    var _defaults = defaultConfig;
    scale_category._defaults = _defaults;
    var noop = helpers$1.noop;
    var isNullOrUndef$2 = helpers$1.isNullOrUndef;
    /**
 * Generate a set of linear ticks
 * @param generationOptions the options used to generate the ticks
 * @param dataRange the range of the data
 * @returns {number[]} array of tick values
 */ function generateTicks(generationOptions, dataRange) {
        var ticks = [];
        // To get a "nice" value for the tick spacing, we will use the appropriately named
        // "nice number" algorithm. See https://stackoverflow.com/questions/8506881/nice-label-algorithm-for-charts-with-minimum-ticks
        // for details.
        var MIN_SPACING = 1e-14;
        var stepSize = generationOptions.stepSize;
        var unit = stepSize || 1;
        var maxNumSpaces = generationOptions.maxTicks - 1;
        var min = generationOptions.min;
        var max = generationOptions.max;
        var precision = generationOptions.precision;
        var rmin = dataRange.min;
        var rmax = dataRange.max;
        var spacing = helpers$1.niceNum((rmax - rmin) / maxNumSpaces / unit) * unit;
        var factor, niceMin, niceMax, numSpaces;
        // Beyond MIN_SPACING floating point numbers being to lose precision
        // such that we can't do the math necessary to generate ticks
        if (spacing < MIN_SPACING && isNullOrUndef$2(min) && isNullOrUndef$2(max)) return [
            rmin,
            rmax
        ];
        numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
        if (numSpaces > maxNumSpaces) // If the calculated num of spaces exceeds maxNumSpaces, recalculate it
        spacing = helpers$1.niceNum(numSpaces * spacing / maxNumSpaces / unit) * unit;
        if (stepSize || isNullOrUndef$2(precision)) // If a precision is not specified, calculate factor based on spacing
        factor = Math.pow(10, helpers$1._decimalPlaces(spacing));
        else {
            // If the user specified a precision, round to that number of decimal places
            factor = Math.pow(10, precision);
            spacing = Math.ceil(spacing * factor) / factor;
        }
        niceMin = Math.floor(rmin / spacing) * spacing;
        niceMax = Math.ceil(rmax / spacing) * spacing;
        // If min, max and stepSize is set and they make an evenly spaced scale use it.
        if (stepSize) {
            // If very close to our whole number, use it.
            if (!isNullOrUndef$2(min) && helpers$1.almostWhole(min / spacing, spacing / 1000)) niceMin = min;
            if (!isNullOrUndef$2(max) && helpers$1.almostWhole(max / spacing, spacing / 1000)) niceMax = max;
        }
        numSpaces = (niceMax - niceMin) / spacing;
        // If very close to our rounded value, use it.
        if (helpers$1.almostEquals(numSpaces, Math.round(numSpaces), spacing / 1000)) numSpaces = Math.round(numSpaces);
        else numSpaces = Math.ceil(numSpaces);
        niceMin = Math.round(niceMin * factor) / factor;
        niceMax = Math.round(niceMax * factor) / factor;
        ticks.push(isNullOrUndef$2(min) ? niceMin : min);
        for(var j = 1; j < numSpaces; ++j)ticks.push(Math.round((niceMin + j * spacing) * factor) / factor);
        ticks.push(isNullOrUndef$2(max) ? niceMax : max);
        return ticks;
    }
    var scale_linearbase = core_scale.extend({
        getRightValue: function(value) {
            if (typeof value === 'string') return +value;
            return core_scale.prototype.getRightValue.call(this, value);
        },
        handleTickRangeOptions: function() {
            var me = this;
            var opts = me.options;
            var tickOpts = opts.ticks;
            // If we are forcing it to begin at 0, but 0 will already be rendered on the chart,
            // do nothing since that would make the chart weird. If the user really wants a weird chart
            // axis, they can manually override it
            if (tickOpts.beginAtZero) {
                var minSign = helpers$1.sign(me.min);
                var maxSign = helpers$1.sign(me.max);
                if (minSign < 0 && maxSign < 0) // move the top up to 0
                me.max = 0;
                else if (minSign > 0 && maxSign > 0) // move the bottom down to 0
                me.min = 0;
            }
            var setMin = tickOpts.min !== undefined || tickOpts.suggestedMin !== undefined;
            var setMax = tickOpts.max !== undefined || tickOpts.suggestedMax !== undefined;
            if (tickOpts.min !== undefined) me.min = tickOpts.min;
            else if (tickOpts.suggestedMin !== undefined) {
                if (me.min === null) me.min = tickOpts.suggestedMin;
                else me.min = Math.min(me.min, tickOpts.suggestedMin);
            }
            if (tickOpts.max !== undefined) me.max = tickOpts.max;
            else if (tickOpts.suggestedMax !== undefined) {
                if (me.max === null) me.max = tickOpts.suggestedMax;
                else me.max = Math.max(me.max, tickOpts.suggestedMax);
            }
            if (setMin !== setMax) // We set the min or the max but not both.
            // So ensure that our range is good
            // Inverted or 0 length range can happen when
            // ticks.min is set, and no datasets are visible
            {
                if (me.min >= me.max) {
                    if (setMin) me.max = me.min + 1;
                    else me.min = me.max - 1;
                }
            }
            if (me.min === me.max) {
                me.max++;
                if (!tickOpts.beginAtZero) me.min--;
            }
        },
        getTickLimit: function() {
            var me = this;
            var tickOpts = me.options.ticks;
            var stepSize = tickOpts.stepSize;
            var maxTicksLimit = tickOpts.maxTicksLimit;
            var maxTicks;
            if (stepSize) maxTicks = Math.ceil(me.max / stepSize) - Math.floor(me.min / stepSize) + 1;
            else {
                maxTicks = me._computeTickLimit();
                maxTicksLimit = maxTicksLimit || 11;
            }
            if (maxTicksLimit) maxTicks = Math.min(maxTicksLimit, maxTicks);
            return maxTicks;
        },
        _computeTickLimit: function() {
            return Number.POSITIVE_INFINITY;
        },
        handleDirectionalChanges: noop,
        buildTicks: function() {
            var me = this;
            var opts = me.options;
            var tickOpts = opts.ticks;
            // Figure out what the max number of ticks we can support it is based on the size of
            // the axis area. For now, we say that the minimum tick spacing in pixels must be 40
            // We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
            // the graph. Make sure we always have at least 2 ticks
            var maxTicks = me.getTickLimit();
            maxTicks = Math.max(2, maxTicks);
            var numericGeneratorOptions = {
                maxTicks: maxTicks,
                min: tickOpts.min,
                max: tickOpts.max,
                precision: tickOpts.precision,
                stepSize: helpers$1.valueOrDefault(tickOpts.fixedStepSize, tickOpts.stepSize)
            };
            var ticks = me.ticks = generateTicks(numericGeneratorOptions, me);
            me.handleDirectionalChanges();
            // At this point, we need to update our max and min given the tick values since we have expanded the
            // range of the scale
            me.max = helpers$1.max(ticks);
            me.min = helpers$1.min(ticks);
            if (tickOpts.reverse) {
                ticks.reverse();
                me.start = me.max;
                me.end = me.min;
            } else {
                me.start = me.min;
                me.end = me.max;
            }
        },
        convertTicksToLabels: function() {
            var me = this;
            me.ticksAsNumbers = me.ticks.slice();
            me.zeroLineIndex = me.ticks.indexOf(0);
            core_scale.prototype.convertTicksToLabels.call(me);
        },
        _configure: function() {
            var me = this;
            var ticks = me.getTicks();
            var start = me.min;
            var end = me.max;
            var offset;
            core_scale.prototype._configure.call(me);
            if (me.options.offset && ticks.length) {
                offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
                start -= offset;
                end += offset;
            }
            me._startValue = start;
            me._endValue = end;
            me._valueRange = end - start;
        }
    });
    var defaultConfig$1 = {
        position: 'left',
        ticks: {
            callback: core_ticks.formatters.linear
        }
    };
    var DEFAULT_MIN = 0;
    var DEFAULT_MAX = 1;
    function getOrCreateStack(stacks, stacked, meta) {
        var key = [
            meta.type,
            // we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
            stacked === undefined && meta.stack === undefined ? meta.index : '',
            meta.stack
        ].join('.');
        if (stacks[key] === undefined) stacks[key] = {
            pos: [],
            neg: []
        };
        return stacks[key];
    }
    function stackData(scale, stacks, meta, data) {
        var opts = scale.options;
        var stacked = opts.stacked;
        var stack = getOrCreateStack(stacks, stacked, meta);
        var pos = stack.pos;
        var neg = stack.neg;
        var ilen = data.length;
        var i, value;
        for(i = 0; i < ilen; ++i){
            value = scale._parseValue(data[i]);
            if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) continue;
            pos[i] = pos[i] || 0;
            neg[i] = neg[i] || 0;
            if (opts.relativePoints) pos[i] = 100;
            else if (value.min < 0 || value.max < 0) neg[i] += value.min;
            else pos[i] += value.max;
        }
    }
    function updateMinMax(scale, meta, data) {
        var ilen = data.length;
        var i, value;
        for(i = 0; i < ilen; ++i){
            value = scale._parseValue(data[i]);
            if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) continue;
            scale.min = Math.min(scale.min, value.min);
            scale.max = Math.max(scale.max, value.max);
        }
    }
    var scale_linear = scale_linearbase.extend({
        determineDataLimits: function() {
            var me = this;
            var opts = me.options;
            var chart = me.chart;
            var datasets = chart.data.datasets;
            var metasets = me._getMatchingVisibleMetas();
            var hasStacks = opts.stacked;
            var stacks = {};
            var ilen = metasets.length;
            var i, meta, data, values;
            me.min = Number.POSITIVE_INFINITY;
            me.max = Number.NEGATIVE_INFINITY;
            if (hasStacks === undefined) for(i = 0; !hasStacks && i < ilen; ++i){
                meta = metasets[i];
                hasStacks = meta.stack !== undefined;
            }
            for(i = 0; i < ilen; ++i){
                meta = metasets[i];
                data = datasets[meta.index].data;
                if (hasStacks) stackData(me, stacks, meta, data);
                else updateMinMax(me, meta, data);
            }
            helpers$1.each(stacks, function(stackValues) {
                values = stackValues.pos.concat(stackValues.neg);
                me.min = Math.min(me.min, helpers$1.min(values));
                me.max = Math.max(me.max, helpers$1.max(values));
            });
            me.min = helpers$1.isFinite(me.min) && !isNaN(me.min) ? me.min : DEFAULT_MIN;
            me.max = helpers$1.isFinite(me.max) && !isNaN(me.max) ? me.max : DEFAULT_MAX;
            // Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
            me.handleTickRangeOptions();
        },
        // Returns the maximum number of ticks based on the scale dimension
        _computeTickLimit: function() {
            var me = this;
            var tickFont;
            if (me.isHorizontal()) return Math.ceil(me.width / 40);
            tickFont = helpers$1.options._parseFont(me.options.ticks);
            return Math.ceil(me.height / tickFont.lineHeight);
        },
        // Called after the ticks are built. We need
        handleDirectionalChanges: function() {
            if (!this.isHorizontal()) // We are in a vertical orientation. The top value is the highest. So reverse the array
            this.ticks.reverse();
        },
        getLabelForIndex: function(index, datasetIndex) {
            return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
        },
        // Utils
        getPixelForValue: function(value) {
            var me = this;
            return me.getPixelForDecimal((+me.getRightValue(value) - me._startValue) / me._valueRange);
        },
        getValueForPixel: function(pixel) {
            return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
        },
        getPixelForTick: function(index) {
            var ticks = this.ticksAsNumbers;
            if (index < 0 || index > ticks.length - 1) return null;
            return this.getPixelForValue(ticks[index]);
        }
    });
    // INTERNAL: static default options, registered in src/index.js
    var _defaults$1 = defaultConfig$1;
    scale_linear._defaults = _defaults$1;
    var valueOrDefault$b = helpers$1.valueOrDefault;
    var log10 = helpers$1.math.log10;
    /**
 * Generate a set of logarithmic ticks
 * @param generationOptions the options used to generate the ticks
 * @param dataRange the range of the data
 * @returns {number[]} array of tick values
 */ function generateTicks$1(generationOptions, dataRange) {
        var ticks = [];
        var tickVal = valueOrDefault$b(generationOptions.min, Math.pow(10, Math.floor(log10(dataRange.min))));
        var endExp = Math.floor(log10(dataRange.max));
        var endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
        var exp, significand;
        if (tickVal === 0) {
            exp = Math.floor(log10(dataRange.minNotZero));
            significand = Math.floor(dataRange.minNotZero / Math.pow(10, exp));
            ticks.push(tickVal);
            tickVal = significand * Math.pow(10, exp);
        } else {
            exp = Math.floor(log10(tickVal));
            significand = Math.floor(tickVal / Math.pow(10, exp));
        }
        var precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
        do {
            ticks.push(tickVal);
            ++significand;
            if (significand === 10) {
                significand = 1;
                ++exp;
                precision = exp >= 0 ? 1 : precision;
            }
            tickVal = Math.round(significand * Math.pow(10, exp) * precision) / precision;
        }while (exp < endExp || exp === endExp && significand < endSignificand);
        var lastTick = valueOrDefault$b(generationOptions.max, tickVal);
        ticks.push(lastTick);
        return ticks;
    }
    var defaultConfig$2 = {
        position: 'left',
        // label settings
        ticks: {
            callback: core_ticks.formatters.logarithmic
        }
    };
    // TODO(v3): change this to positiveOrDefault
    function nonNegativeOrDefault(value, defaultValue) {
        return helpers$1.isFinite(value) && value >= 0 ? value : defaultValue;
    }
    var scale_logarithmic = core_scale.extend({
        determineDataLimits: function() {
            var me = this;
            var opts = me.options;
            var chart = me.chart;
            var datasets = chart.data.datasets;
            var isHorizontal = me.isHorizontal();
            function IDMatches(meta) {
                return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
            }
            var datasetIndex, meta, value, data, i, ilen;
            // Calculate Range
            me.min = Number.POSITIVE_INFINITY;
            me.max = Number.NEGATIVE_INFINITY;
            me.minNotZero = Number.POSITIVE_INFINITY;
            var hasStacks = opts.stacked;
            if (hasStacks === undefined) for(datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++){
                meta = chart.getDatasetMeta(datasetIndex);
                if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) && meta.stack !== undefined) {
                    hasStacks = true;
                    break;
                }
            }
            if (opts.stacked || hasStacks) {
                var valuesPerStack = {};
                for(datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++){
                    meta = chart.getDatasetMeta(datasetIndex);
                    var key = [
                        meta.type,
                        // we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
                        opts.stacked === undefined && meta.stack === undefined ? datasetIndex : '',
                        meta.stack
                    ].join('.');
                    if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
                        if (valuesPerStack[key] === undefined) valuesPerStack[key] = [];
                        data = datasets[datasetIndex].data;
                        for(i = 0, ilen = data.length; i < ilen; i++){
                            var values = valuesPerStack[key];
                            value = me._parseValue(data[i]);
                            // invalid, hidden and negative values are ignored
                            if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) continue;
                            values[i] = values[i] || 0;
                            values[i] += value.max;
                        }
                    }
                }
                helpers$1.each(valuesPerStack, function(valuesForType) {
                    if (valuesForType.length > 0) {
                        var minVal = helpers$1.min(valuesForType);
                        var maxVal = helpers$1.max(valuesForType);
                        me.min = Math.min(me.min, minVal);
                        me.max = Math.max(me.max, maxVal);
                    }
                });
            } else for(datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++){
                meta = chart.getDatasetMeta(datasetIndex);
                if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
                    data = datasets[datasetIndex].data;
                    for(i = 0, ilen = data.length; i < ilen; i++){
                        value = me._parseValue(data[i]);
                        // invalid, hidden and negative values are ignored
                        if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) continue;
                        me.min = Math.min(value.min, me.min);
                        me.max = Math.max(value.max, me.max);
                        if (value.min !== 0) me.minNotZero = Math.min(value.min, me.minNotZero);
                    }
                }
            }
            me.min = helpers$1.isFinite(me.min) ? me.min : null;
            me.max = helpers$1.isFinite(me.max) ? me.max : null;
            me.minNotZero = helpers$1.isFinite(me.minNotZero) ? me.minNotZero : null;
            // Common base implementation to handle ticks.min, ticks.max
            this.handleTickRangeOptions();
        },
        handleTickRangeOptions: function() {
            var me = this;
            var tickOpts = me.options.ticks;
            var DEFAULT_MIN = 1;
            var DEFAULT_MAX = 10;
            me.min = nonNegativeOrDefault(tickOpts.min, me.min);
            me.max = nonNegativeOrDefault(tickOpts.max, me.max);
            if (me.min === me.max) {
                if (me.min !== 0 && me.min !== null) {
                    me.min = Math.pow(10, Math.floor(log10(me.min)) - 1);
                    me.max = Math.pow(10, Math.floor(log10(me.max)) + 1);
                } else {
                    me.min = DEFAULT_MIN;
                    me.max = DEFAULT_MAX;
                }
            }
            if (me.min === null) me.min = Math.pow(10, Math.floor(log10(me.max)) - 1);
            if (me.max === null) me.max = me.min !== 0 ? Math.pow(10, Math.floor(log10(me.min)) + 1) : DEFAULT_MAX;
            if (me.minNotZero === null) {
                if (me.min > 0) me.minNotZero = me.min;
                else if (me.max < 1) me.minNotZero = Math.pow(10, Math.floor(log10(me.max)));
                else me.minNotZero = DEFAULT_MIN;
            }
        },
        buildTicks: function() {
            var me = this;
            var tickOpts = me.options.ticks;
            var reverse = !me.isHorizontal();
            var generationOptions = {
                min: nonNegativeOrDefault(tickOpts.min),
                max: nonNegativeOrDefault(tickOpts.max)
            };
            var ticks = me.ticks = generateTicks$1(generationOptions, me);
            // At this point, we need to update our max and min given the tick values since we have expanded the
            // range of the scale
            me.max = helpers$1.max(ticks);
            me.min = helpers$1.min(ticks);
            if (tickOpts.reverse) {
                reverse = !reverse;
                me.start = me.max;
                me.end = me.min;
            } else {
                me.start = me.min;
                me.end = me.max;
            }
            if (reverse) ticks.reverse();
        },
        convertTicksToLabels: function() {
            this.tickValues = this.ticks.slice();
            core_scale.prototype.convertTicksToLabels.call(this);
        },
        // Get the correct tooltip label
        getLabelForIndex: function(index, datasetIndex) {
            return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
        },
        getPixelForTick: function(index) {
            var ticks = this.tickValues;
            if (index < 0 || index > ticks.length - 1) return null;
            return this.getPixelForValue(ticks[index]);
        },
        /**
	 * Returns the value of the first tick.
	 * @param {number} value - The minimum not zero value.
	 * @return {number} The first tick value.
	 * @private
	 */ _getFirstTickValue: function(value) {
            var exp = Math.floor(log10(value));
            var significand = Math.floor(value / Math.pow(10, exp));
            return significand * Math.pow(10, exp);
        },
        _configure: function() {
            var me = this;
            var start = me.min;
            var offset = 0;
            core_scale.prototype._configure.call(me);
            if (start === 0) {
                start = me._getFirstTickValue(me.minNotZero);
                offset = valueOrDefault$b(me.options.ticks.fontSize, core_defaults.global.defaultFontSize) / me._length;
            }
            me._startValue = log10(start);
            me._valueOffset = offset;
            me._valueRange = (log10(me.max) - log10(start)) / (1 - offset);
        },
        getPixelForValue: function(value) {
            var me = this;
            var decimal = 0;
            value = +me.getRightValue(value);
            if (value > me.min && value > 0) decimal = (log10(value) - me._startValue) / me._valueRange + me._valueOffset;
            return me.getPixelForDecimal(decimal);
        },
        getValueForPixel: function(pixel) {
            var me = this;
            var decimal = me.getDecimalForPixel(pixel);
            return decimal === 0 && me.min === 0 ? 0 : Math.pow(10, me._startValue + (decimal - me._valueOffset) * me._valueRange);
        }
    });
    // INTERNAL: static default options, registered in src/index.js
    var _defaults$2 = defaultConfig$2;
    scale_logarithmic._defaults = _defaults$2;
    var valueOrDefault$c = helpers$1.valueOrDefault;
    var valueAtIndexOrDefault$1 = helpers$1.valueAtIndexOrDefault;
    var resolve$4 = helpers$1.options.resolve;
    var defaultConfig$3 = {
        display: true,
        // Boolean - Whether to animate scaling the chart from the centre
        animate: true,
        position: 'chartArea',
        angleLines: {
            display: true,
            color: 'rgba(0,0,0,0.1)',
            lineWidth: 1,
            borderDash: [],
            borderDashOffset: 0.0
        },
        gridLines: {
            circular: false
        },
        // label settings
        ticks: {
            // Boolean - Show a backdrop to the scale label
            showLabelBackdrop: true,
            // String - The colour of the label backdrop
            backdropColor: 'rgba(255,255,255,0.75)',
            // Number - The backdrop padding above & below the label in pixels
            backdropPaddingY: 2,
            // Number - The backdrop padding to the side of the label in pixels
            backdropPaddingX: 2,
            callback: core_ticks.formatters.linear
        },
        pointLabels: {
            // Boolean - if true, show point labels
            display: true,
            // Number - Point label font size in pixels
            fontSize: 10,
            // Function - Used to convert point labels
            callback: function(label) {
                return label;
            }
        }
    };
    function getTickBackdropHeight(opts) {
        var tickOpts = opts.ticks;
        if (tickOpts.display && opts.display) return valueOrDefault$c(tickOpts.fontSize, core_defaults.global.defaultFontSize) + tickOpts.backdropPaddingY * 2;
        return 0;
    }
    function measureLabelSize(ctx, lineHeight, label) {
        if (helpers$1.isArray(label)) return {
            w: helpers$1.longestText(ctx, ctx.font, label),
            h: label.length * lineHeight
        };
        return {
            w: ctx.measureText(label).width,
            h: lineHeight
        };
    }
    function determineLimits(angle, pos, size, min, max) {
        if (angle === min || angle === max) return {
            start: pos - size / 2,
            end: pos + size / 2
        };
        else if (angle < min || angle > max) return {
            start: pos - size,
            end: pos
        };
        return {
            start: pos,
            end: pos + size
        };
    }
    /**
 * Helper function to fit a radial linear scale with point labels
 */ function fitWithPointLabels(scale) {
        // Right, this is really confusing and there is a lot of maths going on here
        // The gist of the problem is here: https://gist.github.com/nnnick/696cc9c55f4b0beb8fe9
        //
        // Reaction: https://dl.dropboxusercontent.com/u/34601363/toomuchscience.gif
        //
        // Solution:
        //
        // We assume the radius of the polygon is half the size of the canvas at first
        // at each index we check if the text overlaps.
        //
        // Where it does, we store that angle and that index.
        //
        // After finding the largest index and angle we calculate how much we need to remove
        // from the shape radius to move the point inwards by that x.
        //
        // We average the left and right distances to get the maximum shape radius that can fit in the box
        // along with labels.
        //
        // Once we have that, we can find the centre point for the chart, by taking the x text protrusion
        // on each side, removing that from the size, halving it and adding the left x protrusion width.
        //
        // This will mean we have a shape fitted to the canvas, as large as it can be with the labels
        // and position it in the most space efficient manner
        //
        // https://dl.dropboxusercontent.com/u/34601363/yeahscience.gif
        var plFont = helpers$1.options._parseFont(scale.options.pointLabels);
        // Get maximum radius of the polygon. Either half the height (minus the text width) or half the width.
        // Use this to calculate the offset + change. - Make sure L/R protrusion is at least 0 to stop issues with centre points
        var furthestLimits = {
            l: 0,
            r: scale.width,
            t: 0,
            b: scale.height - scale.paddingTop
        };
        var furthestAngles = {};
        var i, textSize, pointPosition;
        scale.ctx.font = plFont.string;
        scale._pointLabelSizes = [];
        var valueCount = scale.chart.data.labels.length;
        for(i = 0; i < valueCount; i++){
            pointPosition = scale.getPointPosition(i, scale.drawingArea + 5);
            textSize = measureLabelSize(scale.ctx, plFont.lineHeight, scale.pointLabels[i]);
            scale._pointLabelSizes[i] = textSize;
            // Add quarter circle to make degree 0 mean top of circle
            var angleRadians = scale.getIndexAngle(i);
            var angle = helpers$1.toDegrees(angleRadians) % 360;
            var hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
            var vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
            if (hLimits.start < furthestLimits.l) {
                furthestLimits.l = hLimits.start;
                furthestAngles.l = angleRadians;
            }
            if (hLimits.end > furthestLimits.r) {
                furthestLimits.r = hLimits.end;
                furthestAngles.r = angleRadians;
            }
            if (vLimits.start < furthestLimits.t) {
                furthestLimits.t = vLimits.start;
                furthestAngles.t = angleRadians;
            }
            if (vLimits.end > furthestLimits.b) {
                furthestLimits.b = vLimits.end;
                furthestAngles.b = angleRadians;
            }
        }
        scale.setReductions(scale.drawingArea, furthestLimits, furthestAngles);
    }
    function getTextAlignForAngle(angle) {
        if (angle === 0 || angle === 180) return 'center';
        else if (angle < 180) return 'left';
        return 'right';
    }
    function fillText(ctx, text, position, lineHeight) {
        var y = position.y + lineHeight / 2;
        var i, ilen;
        if (helpers$1.isArray(text)) for(i = 0, ilen = text.length; i < ilen; ++i){
            ctx.fillText(text[i], position.x, y);
            y += lineHeight;
        }
        else ctx.fillText(text, position.x, y);
    }
    function adjustPointPositionForLabelHeight(angle, textSize, position) {
        if (angle === 90 || angle === 270) position.y -= textSize.h / 2;
        else if (angle > 270 || angle < 90) position.y -= textSize.h;
    }
    function drawPointLabels(scale) {
        var ctx = scale.ctx;
        var opts = scale.options;
        var pointLabelOpts = opts.pointLabels;
        var tickBackdropHeight = getTickBackdropHeight(opts);
        var outerDistance = scale.getDistanceFromCenterForValue(opts.ticks.reverse ? scale.min : scale.max);
        var plFont = helpers$1.options._parseFont(pointLabelOpts);
        ctx.save();
        ctx.font = plFont.string;
        ctx.textBaseline = 'middle';
        for(var i = scale.chart.data.labels.length - 1; i >= 0; i--){
            // Extra pixels out for some label spacing
            var extra = i === 0 ? tickBackdropHeight / 2 : 0;
            var pointLabelPosition = scale.getPointPosition(i, outerDistance + extra + 5);
            // Keep this in loop since we may support array properties here
            var pointLabelFontColor = valueAtIndexOrDefault$1(pointLabelOpts.fontColor, i, core_defaults.global.defaultFontColor);
            ctx.fillStyle = pointLabelFontColor;
            var angleRadians = scale.getIndexAngle(i);
            var angle = helpers$1.toDegrees(angleRadians);
            ctx.textAlign = getTextAlignForAngle(angle);
            adjustPointPositionForLabelHeight(angle, scale._pointLabelSizes[i], pointLabelPosition);
            fillText(ctx, scale.pointLabels[i], pointLabelPosition, plFont.lineHeight);
        }
        ctx.restore();
    }
    function drawRadiusLine(scale, gridLineOpts, radius, index) {
        var ctx = scale.ctx;
        var circular = gridLineOpts.circular;
        var valueCount = scale.chart.data.labels.length;
        var lineColor = valueAtIndexOrDefault$1(gridLineOpts.color, index - 1);
        var lineWidth = valueAtIndexOrDefault$1(gridLineOpts.lineWidth, index - 1);
        var pointPosition;
        if (!circular && !valueCount || !lineColor || !lineWidth) return;
        ctx.save();
        ctx.strokeStyle = lineColor;
        ctx.lineWidth = lineWidth;
        if (ctx.setLineDash) {
            ctx.setLineDash(gridLineOpts.borderDash || []);
            ctx.lineDashOffset = gridLineOpts.borderDashOffset || 0.0;
        }
        ctx.beginPath();
        if (circular) // Draw circular arcs between the points
        ctx.arc(scale.xCenter, scale.yCenter, radius, 0, Math.PI * 2);
        else {
            // Draw straight lines connecting each index
            pointPosition = scale.getPointPosition(0, radius);
            ctx.moveTo(pointPosition.x, pointPosition.y);
            for(var i = 1; i < valueCount; i++){
                pointPosition = scale.getPointPosition(i, radius);
                ctx.lineTo(pointPosition.x, pointPosition.y);
            }
        }
        ctx.closePath();
        ctx.stroke();
        ctx.restore();
    }
    function numberOrZero(param) {
        return helpers$1.isNumber(param) ? param : 0;
    }
    var scale_radialLinear = scale_linearbase.extend({
        setDimensions: function() {
            var me = this;
            // Set the unconstrained dimension before label rotation
            me.width = me.maxWidth;
            me.height = me.maxHeight;
            me.paddingTop = getTickBackdropHeight(me.options) / 2;
            me.xCenter = Math.floor(me.width / 2);
            me.yCenter = Math.floor((me.height - me.paddingTop) / 2);
            me.drawingArea = Math.min(me.height - me.paddingTop, me.width) / 2;
        },
        determineDataLimits: function() {
            var me = this;
            var chart = me.chart;
            var min = Number.POSITIVE_INFINITY;
            var max = Number.NEGATIVE_INFINITY;
            helpers$1.each(chart.data.datasets, function(dataset, datasetIndex) {
                if (chart.isDatasetVisible(datasetIndex)) {
                    var meta = chart.getDatasetMeta(datasetIndex);
                    helpers$1.each(dataset.data, function(rawValue, index) {
                        var value = +me.getRightValue(rawValue);
                        if (isNaN(value) || meta.data[index].hidden) return;
                        min = Math.min(value, min);
                        max = Math.max(value, max);
                    });
                }
            });
            me.min = min === Number.POSITIVE_INFINITY ? 0 : min;
            me.max = max === Number.NEGATIVE_INFINITY ? 0 : max;
            // Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
            me.handleTickRangeOptions();
        },
        // Returns the maximum number of ticks based on the scale dimension
        _computeTickLimit: function() {
            return Math.ceil(this.drawingArea / getTickBackdropHeight(this.options));
        },
        convertTicksToLabels: function() {
            var me = this;
            scale_linearbase.prototype.convertTicksToLabels.call(me);
            // Point labels
            me.pointLabels = me.chart.data.labels.map(function() {
                var label = helpers$1.callback(me.options.pointLabels.callback, arguments, me);
                return label || label === 0 ? label : '';
            });
        },
        getLabelForIndex: function(index, datasetIndex) {
            return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
        },
        fit: function() {
            var me = this;
            var opts = me.options;
            if (opts.display && opts.pointLabels.display) fitWithPointLabels(me);
            else me.setCenterPoint(0, 0, 0, 0);
        },
        /**
	 * Set radius reductions and determine new radius and center point
	 * @private
	 */ setReductions: function(largestPossibleRadius, furthestLimits, furthestAngles) {
            var me = this;
            var radiusReductionLeft = furthestLimits.l / Math.sin(furthestAngles.l);
            var radiusReductionRight = Math.max(furthestLimits.r - me.width, 0) / Math.sin(furthestAngles.r);
            var radiusReductionTop = -furthestLimits.t / Math.cos(furthestAngles.t);
            var radiusReductionBottom = -Math.max(furthestLimits.b - (me.height - me.paddingTop), 0) / Math.cos(furthestAngles.b);
            radiusReductionLeft = numberOrZero(radiusReductionLeft);
            radiusReductionRight = numberOrZero(radiusReductionRight);
            radiusReductionTop = numberOrZero(radiusReductionTop);
            radiusReductionBottom = numberOrZero(radiusReductionBottom);
            me.drawingArea = Math.min(Math.floor(largestPossibleRadius - (radiusReductionLeft + radiusReductionRight) / 2), Math.floor(largestPossibleRadius - (radiusReductionTop + radiusReductionBottom) / 2));
            me.setCenterPoint(radiusReductionLeft, radiusReductionRight, radiusReductionTop, radiusReductionBottom);
        },
        setCenterPoint: function(leftMovement, rightMovement, topMovement, bottomMovement) {
            var me = this;
            var maxRight = me.width - rightMovement - me.drawingArea;
            var maxLeft = leftMovement + me.drawingArea;
            var maxTop = topMovement + me.drawingArea;
            var maxBottom = me.height - me.paddingTop - bottomMovement - me.drawingArea;
            me.xCenter = Math.floor((maxLeft + maxRight) / 2 + me.left);
            me.yCenter = Math.floor((maxTop + maxBottom) / 2 + me.top + me.paddingTop);
        },
        getIndexAngle: function(index) {
            var chart = this.chart;
            var angleMultiplier = 360 / chart.data.labels.length;
            var options = chart.options || {};
            var startAngle = options.startAngle || 0;
            // Start from the top instead of right, so remove a quarter of the circle
            var angle = (index * angleMultiplier + startAngle) % 360;
            return (angle < 0 ? angle + 360 : angle) * Math.PI * 2 / 360;
        },
        getDistanceFromCenterForValue: function(value) {
            var me = this;
            if (helpers$1.isNullOrUndef(value)) return NaN;
            // Take into account half font size + the yPadding of the top value
            var scalingFactor = me.drawingArea / (me.max - me.min);
            if (me.options.ticks.reverse) return (me.max - value) * scalingFactor;
            return (value - me.min) * scalingFactor;
        },
        getPointPosition: function(index, distanceFromCenter) {
            var me = this;
            var thisAngle = me.getIndexAngle(index) - Math.PI / 2;
            return {
                x: Math.cos(thisAngle) * distanceFromCenter + me.xCenter,
                y: Math.sin(thisAngle) * distanceFromCenter + me.yCenter
            };
        },
        getPointPositionForValue: function(index, value) {
            return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
        },
        getBasePosition: function(index) {
            var me = this;
            var min = me.min;
            var max = me.max;
            return me.getPointPositionForValue(index || 0, me.beginAtZero ? 0 : min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0);
        },
        /**
	 * @private
	 */ _drawGrid: function() {
            var me = this;
            var ctx = me.ctx;
            var opts = me.options;
            var gridLineOpts = opts.gridLines;
            var angleLineOpts = opts.angleLines;
            var lineWidth = valueOrDefault$c(angleLineOpts.lineWidth, gridLineOpts.lineWidth);
            var lineColor = valueOrDefault$c(angleLineOpts.color, gridLineOpts.color);
            var i, offset, position;
            if (opts.pointLabels.display) drawPointLabels(me);
            if (gridLineOpts.display) helpers$1.each(me.ticks, function(label, index) {
                if (index !== 0) {
                    offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
                    drawRadiusLine(me, gridLineOpts, offset, index);
                }
            });
            if (angleLineOpts.display && lineWidth && lineColor) {
                ctx.save();
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = lineColor;
                if (ctx.setLineDash) {
                    ctx.setLineDash(resolve$4([
                        angleLineOpts.borderDash,
                        gridLineOpts.borderDash,
                        []
                    ]));
                    ctx.lineDashOffset = resolve$4([
                        angleLineOpts.borderDashOffset,
                        gridLineOpts.borderDashOffset,
                        0.0
                    ]);
                }
                for(i = me.chart.data.labels.length - 1; i >= 0; i--){
                    offset = me.getDistanceFromCenterForValue(opts.ticks.reverse ? me.min : me.max);
                    position = me.getPointPosition(i, offset);
                    ctx.beginPath();
                    ctx.moveTo(me.xCenter, me.yCenter);
                    ctx.lineTo(position.x, position.y);
                    ctx.stroke();
                }
                ctx.restore();
            }
        },
        /**
	 * @private
	 */ _drawLabels: function() {
            var me = this;
            var ctx = me.ctx;
            var opts = me.options;
            var tickOpts = opts.ticks;
            if (!tickOpts.display) return;
            var startAngle = me.getIndexAngle(0);
            var tickFont = helpers$1.options._parseFont(tickOpts);
            var tickFontColor = valueOrDefault$c(tickOpts.fontColor, core_defaults.global.defaultFontColor);
            var offset, width;
            ctx.save();
            ctx.font = tickFont.string;
            ctx.translate(me.xCenter, me.yCenter);
            ctx.rotate(startAngle);
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            helpers$1.each(me.ticks, function(label, index) {
                if (index === 0 && !tickOpts.reverse) return;
                offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
                if (tickOpts.showLabelBackdrop) {
                    width = ctx.measureText(label).width;
                    ctx.fillStyle = tickOpts.backdropColor;
                    ctx.fillRect(-width / 2 - tickOpts.backdropPaddingX, -offset - tickFont.size / 2 - tickOpts.backdropPaddingY, width + tickOpts.backdropPaddingX * 2, tickFont.size + tickOpts.backdropPaddingY * 2);
                }
                ctx.fillStyle = tickFontColor;
                ctx.fillText(label, 0, -offset);
            });
            ctx.restore();
        },
        /**
	 * @private
	 */ _drawTitle: helpers$1.noop
    });
    // INTERNAL: static default options, registered in src/index.js
    var _defaults$3 = defaultConfig$3;
    scale_radialLinear._defaults = _defaults$3;
    var deprecated$1 = helpers$1._deprecated;
    var resolve$5 = helpers$1.options.resolve;
    var valueOrDefault$d = helpers$1.valueOrDefault;
    // Integer constants are from the ES6 spec.
    var MIN_INTEGER = Number.MIN_SAFE_INTEGER || -9007199254740991;
    var MAX_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;
    var INTERVALS = {
        millisecond: {
            common: true,
            size: 1,
            steps: 1000
        },
        second: {
            common: true,
            size: 1000,
            steps: 60
        },
        minute: {
            common: true,
            size: 60000,
            steps: 60
        },
        hour: {
            common: true,
            size: 3600000,
            steps: 24
        },
        day: {
            common: true,
            size: 86400000,
            steps: 30
        },
        week: {
            common: false,
            size: 604800000,
            steps: 4
        },
        month: {
            common: true,
            size: 2.628e9,
            steps: 12
        },
        quarter: {
            common: false,
            size: 7.884e9,
            steps: 4
        },
        year: {
            common: true,
            size: 3.154e10
        }
    };
    var UNITS = Object.keys(INTERVALS);
    function sorter(a, b) {
        return a - b;
    }
    function arrayUnique(items) {
        var hash = {};
        var out = [];
        var i, ilen, item;
        for(i = 0, ilen = items.length; i < ilen; ++i){
            item = items[i];
            if (!hash[item]) {
                hash[item] = true;
                out.push(item);
            }
        }
        return out;
    }
    function getMin(options) {
        return helpers$1.valueOrDefault(options.time.min, options.ticks.min);
    }
    function getMax(options) {
        return helpers$1.valueOrDefault(options.time.max, options.ticks.max);
    }
    /**
 * Returns an array of {time, pos} objects used to interpolate a specific `time` or position
 * (`pos`) on the scale, by searching entries before and after the requested value. `pos` is
 * a decimal between 0 and 1: 0 being the start of the scale (left or top) and 1 the other
 * extremity (left + width or top + height). Note that it would be more optimized to directly
 * store pre-computed pixels, but the scale dimensions are not guaranteed at the time we need
 * to create the lookup table. The table ALWAYS contains at least two items: min and max.
 *
 * @param {number[]} timestamps - timestamps sorted from lowest to highest.
 * @param {string} distribution - If 'linear', timestamps will be spread linearly along the min
 * and max range, so basically, the table will contains only two items: {min, 0} and {max, 1}.
 * If 'series', timestamps will be positioned at the same distance from each other. In this
 * case, only timestamps that break the time linearity are registered, meaning that in the
 * best case, all timestamps are linear, the table contains only min and max.
 */ function buildLookupTable(timestamps, min, max, distribution) {
        if (distribution === 'linear' || !timestamps.length) return [
            {
                time: min,
                pos: 0
            },
            {
                time: max,
                pos: 1
            }
        ];
        var table = [];
        var items = [
            min
        ];
        var i, ilen, prev, curr, next;
        for(i = 0, ilen = timestamps.length; i < ilen; ++i){
            curr = timestamps[i];
            if (curr > min && curr < max) items.push(curr);
        }
        items.push(max);
        for(i = 0, ilen = items.length; i < ilen; ++i){
            next = items[i + 1];
            prev = items[i - 1];
            curr = items[i];
            // only add points that breaks the scale linearity
            if (prev === undefined || next === undefined || Math.round((next + prev) / 2) !== curr) table.push({
                time: curr,
                pos: i / (ilen - 1)
            });
        }
        return table;
    }
    // @see adapted from https://www.anujgakhar.com/2014/03/01/binary-search-in-javascript/
    function lookup(table, key, value) {
        var lo = 0;
        var hi = table.length - 1;
        var mid, i0, i1;
        while(lo >= 0 && lo <= hi){
            mid = lo + hi >> 1;
            i0 = table[mid - 1] || null;
            i1 = table[mid];
            if (!i0) // given value is outside table (before first item)
            return {
                lo: null,
                hi: i1
            };
            else if (i1[key] < value) lo = mid + 1;
            else if (i0[key] > value) hi = mid - 1;
            else return {
                lo: i0,
                hi: i1
            };
        }
        // given value is outside table (after last item)
        return {
            lo: i1,
            hi: null
        };
    }
    /**
 * Linearly interpolates the given source `value` using the table items `skey` values and
 * returns the associated `tkey` value. For example, interpolate(table, 'time', 42, 'pos')
 * returns the position for a timestamp equal to 42. If value is out of bounds, values at
 * index [0, 1] or [n - 1, n] are used for the interpolation.
 */ function interpolate$1(table, skey, sval, tkey) {
        var range = lookup(table, skey, sval);
        // Note: the lookup table ALWAYS contains at least 2 items (min and max)
        var prev = !range.lo ? table[0] : !range.hi ? table[table.length - 2] : range.lo;
        var next = !range.lo ? table[1] : !range.hi ? table[table.length - 1] : range.hi;
        var span = next[skey] - prev[skey];
        var ratio = span ? (sval - prev[skey]) / span : 0;
        var offset = (next[tkey] - prev[tkey]) * ratio;
        return prev[tkey] + offset;
    }
    function toTimestamp(scale, input) {
        var adapter = scale._adapter;
        var options = scale.options.time;
        var parser = options.parser;
        var format = parser || options.format;
        var value = input;
        if (typeof parser === 'function') value = parser(value);
        // Only parse if its not a timestamp already
        if (!helpers$1.isFinite(value)) value = typeof format === 'string' ? adapter.parse(value, format) : adapter.parse(value);
        if (value !== null) return +value;
        // Labels are in an incompatible format and no `parser` has been provided.
        // The user might still use the deprecated `format` option for parsing.
        if (!parser && typeof format === 'function') {
            value = format(input);
            // `format` could return something else than a timestamp, if so, parse it
            if (!helpers$1.isFinite(value)) value = adapter.parse(value);
        }
        return value;
    }
    function parse(scale, input) {
        if (helpers$1.isNullOrUndef(input)) return null;
        var options = scale.options.time;
        var value = toTimestamp(scale, scale.getRightValue(input));
        if (value === null) return value;
        if (options.round) value = +scale._adapter.startOf(value, options.round);
        return value;
    }
    /**
 * Figures out what unit results in an appropriate number of auto-generated ticks
 */ function determineUnitForAutoTicks(minUnit, min, max, capacity) {
        var ilen = UNITS.length;
        var i, interval, factor;
        for(i = UNITS.indexOf(minUnit); i < ilen - 1; ++i){
            interval = INTERVALS[UNITS[i]];
            factor = interval.steps ? interval.steps : MAX_INTEGER;
            if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) return UNITS[i];
        }
        return UNITS[ilen - 1];
    }
    /**
 * Figures out what unit to format a set of ticks with
 */ function determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
        var i, unit;
        for(i = UNITS.length - 1; i >= UNITS.indexOf(minUnit); i--){
            unit = UNITS[i];
            if (INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) return unit;
        }
        return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
    }
    function determineMajorUnit(unit) {
        for(var i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i){
            if (INTERVALS[UNITS[i]].common) return UNITS[i];
        }
    }
    /**
 * Generates a maximum of `capacity` timestamps between min and max, rounded to the
 * `minor` unit using the given scale time `options`.
 * Important: this method can return ticks outside the min and max range, it's the
 * responsibility of the calling code to clamp values if needed.
 */ function generate(scale, min, max, capacity) {
        var adapter = scale._adapter;
        var options = scale.options;
        var timeOpts = options.time;
        var minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min, max, capacity);
        var stepSize = resolve$5([
            timeOpts.stepSize,
            timeOpts.unitStepSize,
            1
        ]);
        var weekday = minor === 'week' ? timeOpts.isoWeekday : false;
        var first = min;
        var ticks = [];
        var time;
        // For 'week' unit, handle the first day of week option
        if (weekday) first = +adapter.startOf(first, 'isoWeek', weekday);
        // Align first ticks on unit
        first = +adapter.startOf(first, weekday ? 'day' : minor);
        // Prevent browser from freezing in case user options request millions of milliseconds
        if (adapter.diff(max, min, minor) > 100000 * stepSize) throw min + ' and ' + max + ' are too far apart with stepSize of ' + stepSize + ' ' + minor;
        for(time = first; time < max; time = +adapter.add(time, stepSize, minor))ticks.push(time);
        if (time === max || options.bounds === 'ticks') ticks.push(time);
        return ticks;
    }
    /**
 * Returns the start and end offsets from edges in the form of {start, end}
 * where each value is a relative width to the scale and ranges between 0 and 1.
 * They add extra margins on the both sides by scaling down the original scale.
 * Offsets are added when the `offset` option is true.
 */ function computeOffsets(table, ticks, min, max, options) {
        var start = 0;
        var end = 0;
        var first, last;
        if (options.offset && ticks.length) {
            first = interpolate$1(table, 'time', ticks[0], 'pos');
            if (ticks.length === 1) start = 1 - first;
            else start = (interpolate$1(table, 'time', ticks[1], 'pos') - first) / 2;
            last = interpolate$1(table, 'time', ticks[ticks.length - 1], 'pos');
            if (ticks.length === 1) end = last;
            else end = (last - interpolate$1(table, 'time', ticks[ticks.length - 2], 'pos')) / 2;
        }
        return {
            start: start,
            end: end,
            factor: 1 / (start + 1 + end)
        };
    }
    function setMajorTicks(scale, ticks, map, majorUnit) {
        var adapter = scale._adapter;
        var first = +adapter.startOf(ticks[0].value, majorUnit);
        var last = ticks[ticks.length - 1].value;
        var major, index;
        for(major = first; major <= last; major = +adapter.add(major, 1, majorUnit)){
            index = map[major];
            if (index >= 0) ticks[index].major = true;
        }
        return ticks;
    }
    function ticksFromTimestamps(scale, values, majorUnit) {
        var ticks = [];
        var map = {};
        var ilen = values.length;
        var i, value;
        for(i = 0; i < ilen; ++i){
            value = values[i];
            map[value] = i;
            ticks.push({
                value: value,
                major: false
            });
        }
        // We set the major ticks separately from the above loop because calling startOf for every tick
        // is expensive when there is a large number of ticks
        return ilen === 0 || !majorUnit ? ticks : setMajorTicks(scale, ticks, map, majorUnit);
    }
    var defaultConfig$4 = {
        position: 'bottom',
        /**
	 * Data distribution along the scale:
	 * - 'linear': data are spread according to their time (distances can vary),
	 * - 'series': data are spread at the same distance from each other.
	 * @see https://github.com/chartjs/Chart.js/pull/4507
	 * @since 2.7.0
	 */ distribution: 'linear',
        /**
	 * Scale boundary strategy (bypassed by min/max time options)
	 * - `data`: make sure data are fully visible, ticks outside are removed
	 * - `ticks`: make sure ticks are fully visible, data outside are truncated
	 * @see https://github.com/chartjs/Chart.js/pull/4556
	 * @since 2.7.0
	 */ bounds: 'data',
        adapters: {},
        time: {
            parser: false,
            unit: false,
            round: false,
            displayFormat: false,
            isoWeekday: false,
            minUnit: 'millisecond',
            displayFormats: {}
        },
        ticks: {
            autoSkip: false,
            /**
		 * Ticks generation input values:
		 * - 'auto': generates "optimal" ticks based on scale size and time options.
		 * - 'data': generates ticks from data (including labels from data {t|x|y} objects).
		 * - 'labels': generates ticks from user given `data.labels` values ONLY.
		 * @see https://github.com/chartjs/Chart.js/pull/4507
		 * @since 2.7.0
		 */ source: 'auto',
            major: {
                enabled: false
            }
        }
    };
    var scale_time = core_scale.extend({
        initialize: function() {
            this.mergeTicksOptions();
            core_scale.prototype.initialize.call(this);
        },
        update: function() {
            var me = this;
            var options = me.options;
            var time = options.time || (options.time = {});
            var adapter = me._adapter = new core_adapters._date(options.adapters.date);
            // DEPRECATIONS: output a message only one time per update
            deprecated$1('time scale', time.format, 'time.format', 'time.parser');
            deprecated$1('time scale', time.min, 'time.min', 'ticks.min');
            deprecated$1('time scale', time.max, 'time.max', 'ticks.max');
            // Backward compatibility: before introducing adapter, `displayFormats` was
            // supposed to contain *all* unit/string pairs but this can't be resolved
            // when loading the scale (adapters are loaded afterward), so let's populate
            // missing formats on update
            helpers$1.mergeIf(time.displayFormats, adapter.formats());
            return core_scale.prototype.update.apply(me, arguments);
        },
        /**
	 * Allows data to be referenced via 't' attribute
	 */ getRightValue: function(rawValue) {
            if (rawValue && rawValue.t !== undefined) rawValue = rawValue.t;
            return core_scale.prototype.getRightValue.call(this, rawValue);
        },
        determineDataLimits: function() {
            var me = this;
            var chart = me.chart;
            var adapter = me._adapter;
            var options = me.options;
            var unit = options.time.unit || 'day';
            var min = MAX_INTEGER;
            var max = MIN_INTEGER;
            var timestamps = [];
            var datasets = [];
            var labels = [];
            var i, j, ilen, jlen, data, timestamp, labelsAdded;
            var dataLabels = me._getLabels();
            for(i = 0, ilen = dataLabels.length; i < ilen; ++i)labels.push(parse(me, dataLabels[i]));
            for(i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                data = chart.data.datasets[i].data;
                // Let's consider that all data have the same format.
                if (helpers$1.isObject(data[0])) {
                    datasets[i] = [];
                    for(j = 0, jlen = data.length; j < jlen; ++j){
                        timestamp = parse(me, data[j]);
                        timestamps.push(timestamp);
                        datasets[i][j] = timestamp;
                    }
                } else {
                    datasets[i] = labels.slice(0);
                    if (!labelsAdded) {
                        timestamps = timestamps.concat(labels);
                        labelsAdded = true;
                    }
                }
            } else datasets[i] = [];
            if (labels.length) {
                min = Math.min(min, labels[0]);
                max = Math.max(max, labels[labels.length - 1]);
            }
            if (timestamps.length) {
                timestamps = ilen > 1 ? arrayUnique(timestamps).sort(sorter) : timestamps.sort(sorter);
                min = Math.min(min, timestamps[0]);
                max = Math.max(max, timestamps[timestamps.length - 1]);
            }
            min = parse(me, getMin(options)) || min;
            max = parse(me, getMax(options)) || max;
            // In case there is no valid min/max, set limits based on unit time option
            min = min === MAX_INTEGER ? +adapter.startOf(Date.now(), unit) : min;
            max = max === MIN_INTEGER ? +adapter.endOf(Date.now(), unit) + 1 : max;
            // Make sure that max is strictly higher than min (required by the lookup table)
            me.min = Math.min(min, max);
            me.max = Math.max(min + 1, max);
            // PRIVATE
            me._table = [];
            me._timestamps = {
                data: timestamps,
                datasets: datasets,
                labels: labels
            };
        },
        buildTicks: function() {
            var me = this;
            var min = me.min;
            var max = me.max;
            var options = me.options;
            var tickOpts = options.ticks;
            var timeOpts = options.time;
            var timestamps = me._timestamps;
            var ticks = [];
            var capacity = me.getLabelCapacity(min);
            var source = tickOpts.source;
            var distribution = options.distribution;
            var i, ilen, timestamp;
            if (source === 'data' || source === 'auto' && distribution === 'series') timestamps = timestamps.data;
            else if (source === 'labels') timestamps = timestamps.labels;
            else timestamps = generate(me, min, max, capacity);
            if (options.bounds === 'ticks' && timestamps.length) {
                min = timestamps[0];
                max = timestamps[timestamps.length - 1];
            }
            // Enforce limits with user min/max options
            min = parse(me, getMin(options)) || min;
            max = parse(me, getMax(options)) || max;
            // Remove ticks outside the min/max range
            for(i = 0, ilen = timestamps.length; i < ilen; ++i){
                timestamp = timestamps[i];
                if (timestamp >= min && timestamp <= max) ticks.push(timestamp);
            }
            me.min = min;
            me.max = max;
            // PRIVATE
            // determineUnitForFormatting relies on the number of ticks so we don't use it when
            // autoSkip is enabled because we don't yet know what the final number of ticks will be
            me._unit = timeOpts.unit || (tickOpts.autoSkip ? determineUnitForAutoTicks(timeOpts.minUnit, me.min, me.max, capacity) : determineUnitForFormatting(me, ticks.length, timeOpts.minUnit, me.min, me.max));
            me._majorUnit = !tickOpts.major.enabled || me._unit === 'year' ? undefined : determineMajorUnit(me._unit);
            me._table = buildLookupTable(me._timestamps.data, min, max, distribution);
            me._offsets = computeOffsets(me._table, ticks, min, max, options);
            if (tickOpts.reverse) ticks.reverse();
            return ticksFromTimestamps(me, ticks, me._majorUnit);
        },
        getLabelForIndex: function(index, datasetIndex) {
            var me = this;
            var adapter = me._adapter;
            var data = me.chart.data;
            var timeOpts = me.options.time;
            var label = data.labels && index < data.labels.length ? data.labels[index] : '';
            var value = data.datasets[datasetIndex].data[index];
            if (helpers$1.isObject(value)) label = me.getRightValue(value);
            if (timeOpts.tooltipFormat) return adapter.format(toTimestamp(me, label), timeOpts.tooltipFormat);
            if (typeof label === 'string') return label;
            return adapter.format(toTimestamp(me, label), timeOpts.displayFormats.datetime);
        },
        /**
	 * Function to format an individual tick mark
	 * @private
	 */ tickFormatFunction: function(time, index, ticks, format) {
            var me = this;
            var adapter = me._adapter;
            var options = me.options;
            var formats = options.time.displayFormats;
            var minorFormat = formats[me._unit];
            var majorUnit = me._majorUnit;
            var majorFormat = formats[majorUnit];
            var tick = ticks[index];
            var tickOpts = options.ticks;
            var major = majorUnit && majorFormat && tick && tick.major;
            var label = adapter.format(time, format ? format : major ? majorFormat : minorFormat);
            var nestedTickOpts = major ? tickOpts.major : tickOpts.minor;
            var formatter = resolve$5([
                nestedTickOpts.callback,
                nestedTickOpts.userCallback,
                tickOpts.callback,
                tickOpts.userCallback
            ]);
            return formatter ? formatter(label, index, ticks) : label;
        },
        convertTicksToLabels: function(ticks) {
            var labels = [];
            var i, ilen;
            for(i = 0, ilen = ticks.length; i < ilen; ++i)labels.push(this.tickFormatFunction(ticks[i].value, i, ticks));
            return labels;
        },
        /**
	 * @private
	 */ getPixelForOffset: function(time) {
            var me = this;
            var offsets = me._offsets;
            var pos = interpolate$1(me._table, 'time', time, 'pos');
            return me.getPixelForDecimal((offsets.start + pos) * offsets.factor);
        },
        getPixelForValue: function(value, index, datasetIndex) {
            var me = this;
            var time = null;
            if (index !== undefined && datasetIndex !== undefined) time = me._timestamps.datasets[datasetIndex][index];
            if (time === null) time = parse(me, value);
            if (time !== null) return me.getPixelForOffset(time);
        },
        getPixelForTick: function(index) {
            var ticks = this.getTicks();
            return index >= 0 && index < ticks.length ? this.getPixelForOffset(ticks[index].value) : null;
        },
        getValueForPixel: function(pixel) {
            var me = this;
            var offsets = me._offsets;
            var pos = me.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
            var time = interpolate$1(me._table, 'pos', pos, 'time');
            // DEPRECATION, we should return time directly
            return me._adapter._create(time);
        },
        /**
	 * @private
	 */ _getLabelSize: function(label) {
            var me = this;
            var ticksOpts = me.options.ticks;
            var tickLabelWidth = me.ctx.measureText(label).width;
            var angle = helpers$1.toRadians(me.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
            var cosRotation = Math.cos(angle);
            var sinRotation = Math.sin(angle);
            var tickFontSize = valueOrDefault$d(ticksOpts.fontSize, core_defaults.global.defaultFontSize);
            return {
                w: tickLabelWidth * cosRotation + tickFontSize * sinRotation,
                h: tickLabelWidth * sinRotation + tickFontSize * cosRotation
            };
        },
        /**
	 * Crude approximation of what the label width might be
	 * @private
	 */ getLabelWidth: function(label) {
            return this._getLabelSize(label).w;
        },
        /**
	 * @private
	 */ getLabelCapacity: function(exampleTime) {
            var me = this;
            var timeOpts = me.options.time;
            var displayFormats = timeOpts.displayFormats;
            // pick the longest format (milliseconds) for guestimation
            var format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
            var exampleLabel = me.tickFormatFunction(exampleTime, 0, ticksFromTimestamps(me, [
                exampleTime
            ], me._majorUnit), format);
            var size = me._getLabelSize(exampleLabel);
            var capacity = Math.floor(me.isHorizontal() ? me.width / size.w : me.height / size.h);
            if (me.options.offset) capacity--;
            return capacity > 0 ? capacity : 1;
        }
    });
    // INTERNAL: static default options, registered in src/index.js
    var _defaults$4 = defaultConfig$4;
    scale_time._defaults = _defaults$4;
    var scales = {
        category: scale_category,
        linear: scale_linear,
        logarithmic: scale_logarithmic,
        radialLinear: scale_radialLinear,
        time: scale_time
    };
    var FORMATS = {
        datetime: 'MMM D, YYYY, h:mm:ss a',
        millisecond: 'h:mm:ss.SSS a',
        second: 'h:mm:ss a',
        minute: 'h:mm a',
        hour: 'hA',
        day: 'MMM D',
        week: 'll',
        month: 'MMM YYYY',
        quarter: '[Q]Q - YYYY',
        year: 'YYYY'
    };
    core_adapters._date.override(typeof moment === 'function' ? {
        _id: 'moment',
        formats: function() {
            return FORMATS;
        },
        parse: function(value, format) {
            if (typeof value === 'string' && typeof format === 'string') value = moment(value, format);
            else if (!(value instanceof moment)) value = moment(value);
            return value.isValid() ? value.valueOf() : null;
        },
        format: function(time, format) {
            return moment(time).format(format);
        },
        add: function(time, amount, unit) {
            return moment(time).add(amount, unit).valueOf();
        },
        diff: function(max, min, unit) {
            return moment(max).diff(moment(min), unit);
        },
        startOf: function(time, unit, weekday) {
            time = moment(time);
            if (unit === 'isoWeek') return time.isoWeekday(weekday).valueOf();
            return time.startOf(unit).valueOf();
        },
        endOf: function(time, unit) {
            return moment(time).endOf(unit).valueOf();
        },
        // DEPRECATIONS
        /**
	 * Provided for backward compatibility with scale.getValueForPixel().
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */ _create: function(time) {
            return moment(time);
        }
    } : {});
    core_defaults._set('global', {
        plugins: {
            filler: {
                propagate: true
            }
        }
    });
    var mappers = {
        dataset: function(source) {
            var index = source.fill;
            var chart = source.chart;
            var meta = chart.getDatasetMeta(index);
            var visible = meta && chart.isDatasetVisible(index);
            var points = visible && meta.dataset._children || [];
            var length = points.length || 0;
            return !length ? null : function(point, i) {
                return i < length && points[i]._view || null;
            };
        },
        boundary: function(source) {
            var boundary = source.boundary;
            var x = boundary ? boundary.x : null;
            var y = boundary ? boundary.y : null;
            if (helpers$1.isArray(boundary)) return function(point, i) {
                return boundary[i];
            };
            return function(point) {
                return {
                    x: x === null ? point.x : x,
                    y: y === null ? point.y : y
                };
            };
        }
    };
    // @todo if (fill[0] === '#')
    function decodeFill(el, index, count) {
        var model = el._model || {};
        var fill = model.fill;
        var target;
        if (fill === undefined) fill = !!model.backgroundColor;
        if (fill === false || fill === null) return false;
        if (fill === true) return 'origin';
        target = parseFloat(fill, 10);
        if (isFinite(target) && Math.floor(target) === target) {
            if (fill[0] === '-' || fill[0] === '+') target = index + target;
            if (target === index || target < 0 || target >= count) return false;
            return target;
        }
        switch(fill){
            // compatibility
            case 'bottom':
                return 'start';
            case 'top':
                return 'end';
            case 'zero':
                return 'origin';
            // supported boundaries
            case 'origin':
            case 'start':
            case 'end':
                return fill;
            // invalid fill values
            default:
                return false;
        }
    }
    function computeLinearBoundary(source) {
        var model = source.el._model || {};
        var scale = source.el._scale || {};
        var fill = source.fill;
        var target = null;
        var horizontal;
        if (isFinite(fill)) return null;
        // Backward compatibility: until v3, we still need to support boundary values set on
        // the model (scaleTop, scaleBottom and scaleZero) because some external plugins and
        // controllers might still use it (e.g. the Smith chart).
        if (fill === 'start') target = model.scaleBottom === undefined ? scale.bottom : model.scaleBottom;
        else if (fill === 'end') target = model.scaleTop === undefined ? scale.top : model.scaleTop;
        else if (model.scaleZero !== undefined) target = model.scaleZero;
        else if (scale.getBasePixel) target = scale.getBasePixel();
        if (target !== undefined && target !== null) {
            if (target.x !== undefined && target.y !== undefined) return target;
            if (helpers$1.isFinite(target)) {
                horizontal = scale.isHorizontal();
                return {
                    x: horizontal ? target : null,
                    y: horizontal ? null : target
                };
            }
        }
        return null;
    }
    function computeCircularBoundary(source) {
        var scale = source.el._scale;
        var options = scale.options;
        var length = scale.chart.data.labels.length;
        var fill = source.fill;
        var target = [];
        var start, end, center, i, point;
        if (!length) return null;
        start = options.ticks.reverse ? scale.max : scale.min;
        end = options.ticks.reverse ? scale.min : scale.max;
        center = scale.getPointPositionForValue(0, start);
        for(i = 0; i < length; ++i){
            point = fill === 'start' || fill === 'end' ? scale.getPointPositionForValue(i, fill === 'start' ? start : end) : scale.getBasePosition(i);
            if (options.gridLines.circular) {
                point.cx = center.x;
                point.cy = center.y;
                point.angle = scale.getIndexAngle(i) - Math.PI / 2;
            }
            target.push(point);
        }
        return target;
    }
    function computeBoundary(source) {
        var scale = source.el._scale || {};
        if (scale.getPointPositionForValue) return computeCircularBoundary(source);
        return computeLinearBoundary(source);
    }
    function resolveTarget(sources, index, propagate) {
        var source = sources[index];
        var fill = source.fill;
        var visited = [
            index
        ];
        var target;
        if (!propagate) return fill;
        while(fill !== false && visited.indexOf(fill) === -1){
            if (!isFinite(fill)) return fill;
            target = sources[fill];
            if (!target) return false;
            if (target.visible) return fill;
            visited.push(fill);
            fill = target.fill;
        }
        return false;
    }
    function createMapper(source) {
        var fill = source.fill;
        var type = 'dataset';
        if (fill === false) return null;
        if (!isFinite(fill)) type = 'boundary';
        return mappers[type](source);
    }
    function isDrawable(point) {
        return point && !point.skip;
    }
    function drawArea(ctx, curve0, curve1, len0, len1) {
        var i, cx, cy, r;
        if (!len0 || !len1) return;
        // building first area curve (normal)
        ctx.moveTo(curve0[0].x, curve0[0].y);
        for(i = 1; i < len0; ++i)helpers$1.canvas.lineTo(ctx, curve0[i - 1], curve0[i]);
        if (curve1[0].angle !== undefined) {
            cx = curve1[0].cx;
            cy = curve1[0].cy;
            r = Math.sqrt(Math.pow(curve1[0].x - cx, 2) + Math.pow(curve1[0].y - cy, 2));
            for(i = len1 - 1; i > 0; --i)ctx.arc(cx, cy, r, curve1[i].angle, curve1[i - 1].angle, true);
            return;
        }
        // joining the two area curves
        ctx.lineTo(curve1[len1 - 1].x, curve1[len1 - 1].y);
        // building opposite area curve (reverse)
        for(i = len1 - 1; i > 0; --i)helpers$1.canvas.lineTo(ctx, curve1[i], curve1[i - 1], true);
    }
    function doFill(ctx, points, mapper, view, color, loop) {
        var count = points.length;
        var span = view.spanGaps;
        var curve0 = [];
        var curve1 = [];
        var len0 = 0;
        var len1 = 0;
        var i, ilen, index, p0, p1, d0, d1, loopOffset;
        ctx.beginPath();
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i % count;
            p0 = points[index]._view;
            p1 = mapper(p0, index, view);
            d0 = isDrawable(p0);
            d1 = isDrawable(p1);
            if (loop && loopOffset === undefined && d0) {
                loopOffset = i + 1;
                ilen = count + loopOffset;
            }
            if (d0 && d1) {
                len0 = curve0.push(p0);
                len1 = curve1.push(p1);
            } else if (len0 && len1) {
                if (!span) {
                    drawArea(ctx, curve0, curve1, len0, len1);
                    len0 = len1 = 0;
                    curve0 = [];
                    curve1 = [];
                } else {
                    if (d0) curve0.push(p0);
                    if (d1) curve1.push(p1);
                }
            }
        }
        drawArea(ctx, curve0, curve1, len0, len1);
        ctx.closePath();
        ctx.fillStyle = color;
        ctx.fill();
    }
    var plugin_filler = {
        id: 'filler',
        afterDatasetsUpdate: function(chart, options) {
            var count = (chart.data.datasets || []).length;
            var propagate = options.propagate;
            var sources = [];
            var meta, i, el, source;
            for(i = 0; i < count; ++i){
                meta = chart.getDatasetMeta(i);
                el = meta.dataset;
                source = null;
                if (el && el._model && el instanceof elements.Line) source = {
                    visible: chart.isDatasetVisible(i),
                    fill: decodeFill(el, i, count),
                    chart: chart,
                    el: el
                };
                meta.$filler = source;
                sources.push(source);
            }
            for(i = 0; i < count; ++i){
                source = sources[i];
                if (!source) continue;
                source.fill = resolveTarget(sources, i, propagate);
                source.boundary = computeBoundary(source);
                source.mapper = createMapper(source);
            }
        },
        beforeDatasetsDraw: function(chart) {
            var metasets = chart._getSortedVisibleDatasetMetas();
            var ctx = chart.ctx;
            var meta, i, el, view, points, mapper, color;
            for(i = metasets.length - 1; i >= 0; --i){
                meta = metasets[i].$filler;
                if (!meta || !meta.visible) continue;
                el = meta.el;
                view = el._view;
                points = el._children || [];
                mapper = meta.mapper;
                color = view.backgroundColor || core_defaults.global.defaultColor;
                if (mapper && color && points.length) {
                    helpers$1.canvas.clipArea(ctx, chart.chartArea);
                    doFill(ctx, points, mapper, view, color, el._loop);
                    helpers$1.canvas.unclipArea(ctx);
                }
            }
        }
    };
    var getRtlHelper$1 = helpers$1.rtl.getRtlAdapter;
    var noop$1 = helpers$1.noop;
    var valueOrDefault$e = helpers$1.valueOrDefault;
    core_defaults._set('global', {
        legend: {
            display: true,
            position: 'top',
            align: 'center',
            fullWidth: true,
            reverse: false,
            weight: 1000,
            // a callback that will handle
            onClick: function(e, legendItem) {
                var index = legendItem.datasetIndex;
                var ci = this.chart;
                var meta = ci.getDatasetMeta(index);
                // See controller.isDatasetVisible comment
                meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;
                // We hid a dataset ... rerender the chart
                ci.update();
            },
            onHover: null,
            onLeave: null,
            labels: {
                boxWidth: 40,
                padding: 10,
                // Generates labels shown in the legend
                // Valid properties to return:
                // text : text to display
                // fillStyle : fill of coloured box
                // strokeStyle: stroke of coloured box
                // hidden : if this legend item refers to a hidden item
                // lineCap : cap style for line
                // lineDash
                // lineDashOffset :
                // lineJoin :
                // lineWidth :
                generateLabels: function(chart) {
                    var datasets = chart.data.datasets;
                    var options = chart.options.legend || {};
                    var usePointStyle = options.labels && options.labels.usePointStyle;
                    return chart._getSortedDatasetMetas().map(function(meta) {
                        var style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
                        return {
                            text: datasets[meta.index].label,
                            fillStyle: style.backgroundColor,
                            hidden: !chart.isDatasetVisible(meta.index),
                            lineCap: style.borderCapStyle,
                            lineDash: style.borderDash,
                            lineDashOffset: style.borderDashOffset,
                            lineJoin: style.borderJoinStyle,
                            lineWidth: style.borderWidth,
                            strokeStyle: style.borderColor,
                            pointStyle: style.pointStyle,
                            rotation: style.rotation,
                            // Below is extra data used for toggling the datasets
                            datasetIndex: meta.index
                        };
                    }, this);
                }
            }
        },
        legendCallback: function(chart) {
            var list = document.createElement('ul');
            var datasets = chart.data.datasets;
            var i, ilen, listItem, listItemSpan;
            list.setAttribute('class', chart.id + '-legend');
            for(i = 0, ilen = datasets.length; i < ilen; i++){
                listItem = list.appendChild(document.createElement('li'));
                listItemSpan = listItem.appendChild(document.createElement('span'));
                listItemSpan.style.backgroundColor = datasets[i].backgroundColor;
                if (datasets[i].label) listItem.appendChild(document.createTextNode(datasets[i].label));
            }
            return list.outerHTML;
        }
    });
    /**
 * Helper function to get the box width based on the usePointStyle option
 * @param {object} labelopts - the label options on the legend
 * @param {number} fontSize - the label font size
 * @return {number} width of the color box area
 */ function getBoxWidth(labelOpts, fontSize) {
        return labelOpts.usePointStyle && labelOpts.boxWidth > fontSize ? fontSize : labelOpts.boxWidth;
    }
    /**
 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
 */ var Legend = core_element.extend({
        initialize: function(config) {
            var me = this;
            helpers$1.extend(me, config);
            // Contains hit boxes for each dataset (in dataset order)
            me.legendHitBoxes = [];
            /**
 		 * @private
 		 */ me._hoveredItem = null;
            // Are we in doughnut mode which has a different data type
            me.doughnutMode = false;
        },
        // These methods are ordered by lifecycle. Utilities then follow.
        // Any function defined here is inherited by all legend types.
        // Any function can be extended by the legend type
        beforeUpdate: noop$1,
        update: function(maxWidth, maxHeight, margins) {
            var me = this;
            // Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
            me.beforeUpdate();
            // Absorb the master measurements
            me.maxWidth = maxWidth;
            me.maxHeight = maxHeight;
            me.margins = margins;
            // Dimensions
            me.beforeSetDimensions();
            me.setDimensions();
            me.afterSetDimensions();
            // Labels
            me.beforeBuildLabels();
            me.buildLabels();
            me.afterBuildLabels();
            // Fit
            me.beforeFit();
            me.fit();
            me.afterFit();
            //
            me.afterUpdate();
            return me.minSize;
        },
        afterUpdate: noop$1,
        //
        beforeSetDimensions: noop$1,
        setDimensions: function() {
            var me = this;
            // Set the unconstrained dimension before label rotation
            if (me.isHorizontal()) {
                // Reset position before calculating rotation
                me.width = me.maxWidth;
                me.left = 0;
                me.right = me.width;
            } else {
                me.height = me.maxHeight;
                // Reset position before calculating rotation
                me.top = 0;
                me.bottom = me.height;
            }
            // Reset padding
            me.paddingLeft = 0;
            me.paddingTop = 0;
            me.paddingRight = 0;
            me.paddingBottom = 0;
            // Reset minSize
            me.minSize = {
                width: 0,
                height: 0
            };
        },
        afterSetDimensions: noop$1,
        //
        beforeBuildLabels: noop$1,
        buildLabels: function() {
            var me = this;
            var labelOpts = me.options.labels || {};
            var legendItems = helpers$1.callback(labelOpts.generateLabels, [
                me.chart
            ], me) || [];
            if (labelOpts.filter) legendItems = legendItems.filter(function(item) {
                return labelOpts.filter(item, me.chart.data);
            });
            if (me.options.reverse) legendItems.reverse();
            me.legendItems = legendItems;
        },
        afterBuildLabels: noop$1,
        //
        beforeFit: noop$1,
        fit: function() {
            var me = this;
            var opts = me.options;
            var labelOpts = opts.labels;
            var display = opts.display;
            var ctx = me.ctx;
            var labelFont = helpers$1.options._parseFont(labelOpts);
            var fontSize = labelFont.size;
            // Reset hit boxes
            var hitboxes = me.legendHitBoxes = [];
            var minSize = me.minSize;
            var isHorizontal = me.isHorizontal();
            if (isHorizontal) {
                minSize.width = me.maxWidth; // fill all the width
                minSize.height = display ? 10 : 0;
            } else {
                minSize.width = display ? 10 : 0;
                minSize.height = me.maxHeight; // fill all the height
            }
            // Increase sizes here
            if (!display) {
                me.width = minSize.width = me.height = minSize.height = 0;
                return;
            }
            ctx.font = labelFont.string;
            if (isHorizontal) {
                // Labels
                // Width of each line of legend boxes. Labels wrap onto multiple lines when there are too many to fit on one
                var lineWidths = me.lineWidths = [
                    0
                ];
                var totalHeight = 0;
                ctx.textAlign = 'left';
                ctx.textBaseline = 'middle';
                helpers$1.each(me.legendItems, function(legendItem, i) {
                    var boxWidth = getBoxWidth(labelOpts, fontSize);
                    var width = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
                    if (i === 0 || lineWidths[lineWidths.length - 1] + width + 2 * labelOpts.padding > minSize.width) {
                        totalHeight += fontSize + labelOpts.padding;
                        lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
                    }
                    // Store the hitbox width and height here. Final position will be updated in `draw`
                    hitboxes[i] = {
                        left: 0,
                        top: 0,
                        width: width,
                        height: fontSize
                    };
                    lineWidths[lineWidths.length - 1] += width + labelOpts.padding;
                });
                minSize.height += totalHeight;
            } else {
                var vPadding = labelOpts.padding;
                var columnWidths = me.columnWidths = [];
                var columnHeights = me.columnHeights = [];
                var totalWidth = labelOpts.padding;
                var currentColWidth = 0;
                var currentColHeight = 0;
                helpers$1.each(me.legendItems, function(legendItem, i) {
                    var boxWidth = getBoxWidth(labelOpts, fontSize);
                    var itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
                    // If too tall, go to new column
                    if (i > 0 && currentColHeight + fontSize + 2 * vPadding > minSize.height) {
                        totalWidth += currentColWidth + labelOpts.padding;
                        columnWidths.push(currentColWidth); // previous column width
                        columnHeights.push(currentColHeight);
                        currentColWidth = 0;
                        currentColHeight = 0;
                    }
                    // Get max width
                    currentColWidth = Math.max(currentColWidth, itemWidth);
                    currentColHeight += fontSize + vPadding;
                    // Store the hitbox width and height here. Final position will be updated in `draw`
                    hitboxes[i] = {
                        left: 0,
                        top: 0,
                        width: itemWidth,
                        height: fontSize
                    };
                });
                totalWidth += currentColWidth;
                columnWidths.push(currentColWidth);
                columnHeights.push(currentColHeight);
                minSize.width += totalWidth;
            }
            me.width = minSize.width;
            me.height = minSize.height;
        },
        afterFit: noop$1,
        // Shared Methods
        isHorizontal: function() {
            return this.options.position === 'top' || this.options.position === 'bottom';
        },
        // Actually draw the legend on the canvas
        draw: function() {
            var me = this;
            var opts = me.options;
            var labelOpts = opts.labels;
            var globalDefaults = core_defaults.global;
            var defaultColor = globalDefaults.defaultColor;
            var lineDefault = globalDefaults.elements.line;
            var legendHeight = me.height;
            var columnHeights = me.columnHeights;
            var legendWidth = me.width;
            var lineWidths = me.lineWidths;
            if (!opts.display) return;
            var rtlHelper = getRtlHelper$1(opts.rtl, me.left, me.minSize.width);
            var ctx = me.ctx;
            var fontColor = valueOrDefault$e(labelOpts.fontColor, globalDefaults.defaultFontColor);
            var labelFont = helpers$1.options._parseFont(labelOpts);
            var fontSize = labelFont.size;
            var cursor;
            // Canvas setup
            ctx.textAlign = rtlHelper.textAlign('left');
            ctx.textBaseline = 'middle';
            ctx.lineWidth = 0.5;
            ctx.strokeStyle = fontColor; // for strikethrough effect
            ctx.fillStyle = fontColor; // render in correct colour
            ctx.font = labelFont.string;
            var boxWidth = getBoxWidth(labelOpts, fontSize);
            var hitboxes = me.legendHitBoxes;
            // current position
            var drawLegendBox = function(x, y, legendItem) {
                if (isNaN(boxWidth) || boxWidth <= 0) return;
                // Set the ctx for the box
                ctx.save();
                var lineWidth = valueOrDefault$e(legendItem.lineWidth, lineDefault.borderWidth);
                ctx.fillStyle = valueOrDefault$e(legendItem.fillStyle, defaultColor);
                ctx.lineCap = valueOrDefault$e(legendItem.lineCap, lineDefault.borderCapStyle);
                ctx.lineDashOffset = valueOrDefault$e(legendItem.lineDashOffset, lineDefault.borderDashOffset);
                ctx.lineJoin = valueOrDefault$e(legendItem.lineJoin, lineDefault.borderJoinStyle);
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = valueOrDefault$e(legendItem.strokeStyle, defaultColor);
                if (ctx.setLineDash) // IE 9 and 10 do not support line dash
                ctx.setLineDash(valueOrDefault$e(legendItem.lineDash, lineDefault.borderDash));
                if (labelOpts && labelOpts.usePointStyle) {
                    // Recalculate x and y for drawPoint() because its expecting
                    // x and y to be center of figure (instead of top left)
                    var radius = boxWidth * Math.SQRT2 / 2;
                    var centerX = rtlHelper.xPlus(x, boxWidth / 2);
                    var centerY = y + fontSize / 2;
                    // Draw pointStyle as legend symbol
                    helpers$1.canvas.drawPoint(ctx, legendItem.pointStyle, radius, centerX, centerY, legendItem.rotation);
                } else {
                    // Draw box as legend symbol
                    ctx.fillRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
                    if (lineWidth !== 0) ctx.strokeRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
                }
                ctx.restore();
            };
            var fillText = function(x, y, legendItem, textWidth) {
                var halfFontSize = fontSize / 2;
                var xLeft = rtlHelper.xPlus(x, boxWidth + halfFontSize);
                var yMiddle = y + halfFontSize;
                ctx.fillText(legendItem.text, xLeft, yMiddle);
                if (legendItem.hidden) {
                    // Strikethrough the text if hidden
                    ctx.beginPath();
                    ctx.lineWidth = 2;
                    ctx.moveTo(xLeft, yMiddle);
                    ctx.lineTo(rtlHelper.xPlus(xLeft, textWidth), yMiddle);
                    ctx.stroke();
                }
            };
            var alignmentOffset = function(dimension, blockSize) {
                switch(opts.align){
                    case 'start':
                        return labelOpts.padding;
                    case 'end':
                        return dimension - blockSize;
                    default:
                        return (dimension - blockSize + labelOpts.padding) / 2;
                }
            };
            // Horizontal
            var isHorizontal = me.isHorizontal();
            if (isHorizontal) cursor = {
                x: me.left + alignmentOffset(legendWidth, lineWidths[0]),
                y: me.top + labelOpts.padding,
                line: 0
            };
            else cursor = {
                x: me.left + labelOpts.padding,
                y: me.top + alignmentOffset(legendHeight, columnHeights[0]),
                line: 0
            };
            helpers$1.rtl.overrideTextDirection(me.ctx, opts.textDirection);
            var itemHeight = fontSize + labelOpts.padding;
            helpers$1.each(me.legendItems, function(legendItem, i) {
                var textWidth = ctx.measureText(legendItem.text).width;
                var width = boxWidth + fontSize / 2 + textWidth;
                var x = cursor.x;
                var y = cursor.y;
                rtlHelper.setWidth(me.minSize.width);
                // Use (me.left + me.minSize.width) and (me.top + me.minSize.height)
                // instead of me.right and me.bottom because me.width and me.height
                // may have been changed since me.minSize was calculated
                if (isHorizontal) {
                    if (i > 0 && x + width + labelOpts.padding > me.left + me.minSize.width) {
                        y = cursor.y += itemHeight;
                        cursor.line++;
                        x = cursor.x = me.left + alignmentOffset(legendWidth, lineWidths[cursor.line]);
                    }
                } else if (i > 0 && y + itemHeight > me.top + me.minSize.height) {
                    x = cursor.x = x + me.columnWidths[cursor.line] + labelOpts.padding;
                    cursor.line++;
                    y = cursor.y = me.top + alignmentOffset(legendHeight, columnHeights[cursor.line]);
                }
                var realX = rtlHelper.x(x);
                drawLegendBox(realX, y, legendItem);
                hitboxes[i].left = rtlHelper.leftForLtr(realX, hitboxes[i].width);
                hitboxes[i].top = y;
                // Fill the actual label
                fillText(realX, y, legendItem, textWidth);
                if (isHorizontal) cursor.x += width + labelOpts.padding;
                else cursor.y += itemHeight;
            });
            helpers$1.rtl.restoreTextDirection(me.ctx, opts.textDirection);
        },
        /**
	 * @private
	 */ _getLegendItemAt: function(x, y) {
            var me = this;
            var i, hitBox, lh;
            if (x >= me.left && x <= me.right && y >= me.top && y <= me.bottom) {
                // See if we are touching one of the dataset boxes
                lh = me.legendHitBoxes;
                for(i = 0; i < lh.length; ++i){
                    hitBox = lh[i];
                    if (x >= hitBox.left && x <= hitBox.left + hitBox.width && y >= hitBox.top && y <= hitBox.top + hitBox.height) // Touching an element
                    return me.legendItems[i];
                }
            }
            return null;
        },
        /**
	 * Handle an event
	 * @private
	 * @param {IEvent} event - The event to handle
	 */ handleEvent: function(e) {
            var me = this;
            var opts = me.options;
            var type = e.type === 'mouseup' ? 'click' : e.type;
            var hoveredItem;
            if (type === 'mousemove') {
                if (!opts.onHover && !opts.onLeave) return;
            } else if (type === 'click') {
                if (!opts.onClick) return;
            } else return;
            // Chart event already has relative position in it
            hoveredItem = me._getLegendItemAt(e.x, e.y);
            if (type === 'click') {
                if (hoveredItem && opts.onClick) // use e.native for backwards compatibility
                opts.onClick.call(me, e.native, hoveredItem);
            } else {
                if (opts.onLeave && hoveredItem !== me._hoveredItem) {
                    if (me._hoveredItem) opts.onLeave.call(me, e.native, me._hoveredItem);
                    me._hoveredItem = hoveredItem;
                }
                if (opts.onHover && hoveredItem) // use e.native for backwards compatibility
                opts.onHover.call(me, e.native, hoveredItem);
            }
        }
    });
    function createNewLegendAndAttach(chart, legendOpts) {
        var legend = new Legend({
            ctx: chart.ctx,
            options: legendOpts,
            chart: chart
        });
        core_layouts.configure(chart, legend, legendOpts);
        core_layouts.addBox(chart, legend);
        chart.legend = legend;
    }
    var plugin_legend = {
        id: 'legend',
        /**
	 * Backward compatibility: since 2.1.5, the legend is registered as a plugin, making
	 * Chart.Legend obsolete. To avoid a breaking change, we export the Legend as part of
	 * the plugin, which one will be re-exposed in the chart.js file.
	 * https://github.com/chartjs/Chart.js/pull/2640
	 * @private
	 */ _element: Legend,
        beforeInit: function(chart) {
            var legendOpts = chart.options.legend;
            if (legendOpts) createNewLegendAndAttach(chart, legendOpts);
        },
        beforeUpdate: function(chart) {
            var legendOpts = chart.options.legend;
            var legend = chart.legend;
            if (legendOpts) {
                helpers$1.mergeIf(legendOpts, core_defaults.global.legend);
                if (legend) {
                    core_layouts.configure(chart, legend, legendOpts);
                    legend.options = legendOpts;
                } else createNewLegendAndAttach(chart, legendOpts);
            } else if (legend) {
                core_layouts.removeBox(chart, legend);
                delete chart.legend;
            }
        },
        afterEvent: function(chart, e) {
            var legend = chart.legend;
            if (legend) legend.handleEvent(e);
        }
    };
    var noop$2 = helpers$1.noop;
    core_defaults._set('global', {
        title: {
            display: false,
            fontStyle: 'bold',
            fullWidth: true,
            padding: 10,
            position: 'top',
            text: '',
            weight: 2000 // by default greater than legend (1000) to be above
        }
    });
    /**
 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
 */ var Title = core_element.extend({
        initialize: function(config) {
            var me = this;
            helpers$1.extend(me, config);
            // Contains hit boxes for each dataset (in dataset order)
            me.legendHitBoxes = [];
        },
        // These methods are ordered by lifecycle. Utilities then follow.
        beforeUpdate: noop$2,
        update: function(maxWidth, maxHeight, margins) {
            var me = this;
            // Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
            me.beforeUpdate();
            // Absorb the master measurements
            me.maxWidth = maxWidth;
            me.maxHeight = maxHeight;
            me.margins = margins;
            // Dimensions
            me.beforeSetDimensions();
            me.setDimensions();
            me.afterSetDimensions();
            // Labels
            me.beforeBuildLabels();
            me.buildLabels();
            me.afterBuildLabels();
            // Fit
            me.beforeFit();
            me.fit();
            me.afterFit();
            //
            me.afterUpdate();
            return me.minSize;
        },
        afterUpdate: noop$2,
        //
        beforeSetDimensions: noop$2,
        setDimensions: function() {
            var me = this;
            // Set the unconstrained dimension before label rotation
            if (me.isHorizontal()) {
                // Reset position before calculating rotation
                me.width = me.maxWidth;
                me.left = 0;
                me.right = me.width;
            } else {
                me.height = me.maxHeight;
                // Reset position before calculating rotation
                me.top = 0;
                me.bottom = me.height;
            }
            // Reset padding
            me.paddingLeft = 0;
            me.paddingTop = 0;
            me.paddingRight = 0;
            me.paddingBottom = 0;
            // Reset minSize
            me.minSize = {
                width: 0,
                height: 0
            };
        },
        afterSetDimensions: noop$2,
        //
        beforeBuildLabels: noop$2,
        buildLabels: noop$2,
        afterBuildLabels: noop$2,
        //
        beforeFit: noop$2,
        fit: function() {
            var me = this;
            var opts = me.options;
            var minSize = me.minSize = {};
            var isHorizontal = me.isHorizontal();
            var lineCount, textSize;
            if (!opts.display) {
                me.width = minSize.width = me.height = minSize.height = 0;
                return;
            }
            lineCount = helpers$1.isArray(opts.text) ? opts.text.length : 1;
            textSize = lineCount * helpers$1.options._parseFont(opts).lineHeight + opts.padding * 2;
            me.width = minSize.width = isHorizontal ? me.maxWidth : textSize;
            me.height = minSize.height = isHorizontal ? textSize : me.maxHeight;
        },
        afterFit: noop$2,
        // Shared Methods
        isHorizontal: function() {
            var pos = this.options.position;
            return pos === 'top' || pos === 'bottom';
        },
        // Actually draw the title block on the canvas
        draw: function() {
            var me = this;
            var ctx = me.ctx;
            var opts = me.options;
            if (!opts.display) return;
            var fontOpts = helpers$1.options._parseFont(opts);
            var lineHeight = fontOpts.lineHeight;
            var offset = lineHeight / 2 + opts.padding;
            var rotation = 0;
            var top = me.top;
            var left = me.left;
            var bottom = me.bottom;
            var right = me.right;
            var maxWidth, titleX, titleY;
            ctx.fillStyle = helpers$1.valueOrDefault(opts.fontColor, core_defaults.global.defaultFontColor); // render in correct colour
            ctx.font = fontOpts.string;
            // Horizontal
            if (me.isHorizontal()) {
                titleX = left + (right - left) / 2; // midpoint of the width
                titleY = top + offset;
                maxWidth = right - left;
            } else {
                titleX = opts.position === 'left' ? left + offset : right - offset;
                titleY = top + (bottom - top) / 2;
                maxWidth = bottom - top;
                rotation = Math.PI * (opts.position === 'left' ? -0.5 : 0.5);
            }
            ctx.save();
            ctx.translate(titleX, titleY);
            ctx.rotate(rotation);
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            var text = opts.text;
            if (helpers$1.isArray(text)) {
                var y = 0;
                for(var i = 0; i < text.length; ++i){
                    ctx.fillText(text[i], 0, y, maxWidth);
                    y += lineHeight;
                }
            } else ctx.fillText(text, 0, 0, maxWidth);
            ctx.restore();
        }
    });
    function createNewTitleBlockAndAttach(chart, titleOpts) {
        var title = new Title({
            ctx: chart.ctx,
            options: titleOpts,
            chart: chart
        });
        core_layouts.configure(chart, title, titleOpts);
        core_layouts.addBox(chart, title);
        chart.titleBlock = title;
    }
    var plugin_title = {
        id: 'title',
        /**
	 * Backward compatibility: since 2.1.5, the title is registered as a plugin, making
	 * Chart.Title obsolete. To avoid a breaking change, we export the Title as part of
	 * the plugin, which one will be re-exposed in the chart.js file.
	 * https://github.com/chartjs/Chart.js/pull/2640
	 * @private
	 */ _element: Title,
        beforeInit: function(chart) {
            var titleOpts = chart.options.title;
            if (titleOpts) createNewTitleBlockAndAttach(chart, titleOpts);
        },
        beforeUpdate: function(chart) {
            var titleOpts = chart.options.title;
            var titleBlock = chart.titleBlock;
            if (titleOpts) {
                helpers$1.mergeIf(titleOpts, core_defaults.global.title);
                if (titleBlock) {
                    core_layouts.configure(chart, titleBlock, titleOpts);
                    titleBlock.options = titleOpts;
                } else createNewTitleBlockAndAttach(chart, titleOpts);
            } else if (titleBlock) {
                core_layouts.removeBox(chart, titleBlock);
                delete chart.titleBlock;
            }
        }
    };
    var plugins = {};
    var filler = plugin_filler;
    var legend = plugin_legend;
    var title = plugin_title;
    plugins.filler = filler;
    plugins.legend = legend;
    plugins.title = title;
    /**
 * @namespace Chart
 */ core_controller.helpers = helpers$1;
    // @todo dispatch these helpers into appropriated helpers/helpers.* file and write unit tests!
    core_helpers();
    core_controller._adapters = core_adapters;
    core_controller.Animation = core_animation;
    core_controller.animationService = core_animations;
    core_controller.controllers = controllers;
    core_controller.DatasetController = core_datasetController;
    core_controller.defaults = core_defaults;
    core_controller.Element = core_element;
    core_controller.elements = elements;
    core_controller.Interaction = core_interaction;
    core_controller.layouts = core_layouts;
    core_controller.platform = platform;
    core_controller.plugins = core_plugins;
    core_controller.Scale = core_scale;
    core_controller.scaleService = core_scaleService;
    core_controller.Ticks = core_ticks;
    core_controller.Tooltip = core_tooltip;
    // Register built-in scales
    core_controller.helpers.each(scales, function(scale, type) {
        core_controller.scaleService.registerScaleType(type, scale, scale._defaults);
    });
    // Load to register built-in adapters (as side effects)
    // Loading built-in plugins
    for(var k in plugins)if (plugins.hasOwnProperty(k)) core_controller.plugins.register(plugins[k]);
    core_controller.platform.initialize();
    var src = core_controller;
    if (typeof window !== 'undefined') window.Chart = core_controller;
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Chart
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */ core_controller.Chart = core_controller;
    /**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Legend
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */ core_controller.Legend = plugins.legend._element;
    /**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Title
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */ core_controller.Title = plugins.title._element;
    /**
 * Provided for backward compatibility, use Chart.plugins instead
 * @namespace Chart.pluginService
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */ core_controller.pluginService = core_controller.plugins;
    /**
 * Provided for backward compatibility, inheriting from Chart.PlugingBase has no
 * effect, instead simply create/register plugins via plain JavaScript objects.
 * @interface Chart.PluginBase
 * @deprecated since version 2.5.0
 * @todo remove at version 3
 * @private
 */ core_controller.PluginBase = core_controller.Element.extend({});
    /**
 * Provided for backward compatibility, use Chart.helpers.canvas instead.
 * @namespace Chart.canvasHelpers
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 * @private
 */ core_controller.canvasHelpers = core_controller.helpers.canvas;
    /**
 * Provided for backward compatibility, use Chart.layouts instead.
 * @namespace Chart.layoutService
 * @deprecated since version 2.7.3
 * @todo remove at version 3
 * @private
 */ core_controller.layoutService = core_controller.layouts;
    /**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart.LinearScaleBase
 * @deprecated since version 2.8
 * @todo remove at version 3
 * @private
 */ core_controller.LinearScaleBase = scale_linearbase;
    /**
 * Provided for backward compatibility, instead we should create a new Chart
 * by setting the type in the config (`new Chart(id, {type: '{chart-type}'}`).
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 */ core_controller.helpers.each([
        'Bar',
        'Bubble',
        'Doughnut',
        'Line',
        'PolarArea',
        'Radar',
        'Scatter'
    ], function(klass) {
        core_controller[klass] = function(ctx, cfg) {
            return new core_controller(ctx, core_controller.helpers.merge(cfg || {}, {
                type: klass.charAt(0).toLowerCase() + klass.slice(1)
            }));
        };
    });
    return src;
});

});

parcelRegister("a39iZ", function(module, exports) {

var $17m4Y = parcelRequire("17m4Y");
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $7511670e20115b97$var$isEqual(value, other) {
    return $17m4Y(value, other);
}
module.exports = $7511670e20115b97$var$isEqual;

});
parcelRegister("17m4Y", function(module, exports) {

var $45AKr = parcelRequire("45AKr");

var $3MU3q = parcelRequire("3MU3q");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $0d07925df627adcb$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$3MU3q(value) && !$3MU3q(other)) return value !== value && other !== other;
    return $45AKr(value, other, bitmask, customizer, $0d07925df627adcb$var$baseIsEqual, stack);
}
module.exports = $0d07925df627adcb$var$baseIsEqual;

});
parcelRegister("45AKr", function(module, exports) {

var $h0DYD = parcelRequire("h0DYD");

var $fUeeu = parcelRequire("fUeeu");

var $6uYaw = parcelRequire("6uYaw");

var $8MeZI = parcelRequire("8MeZI");

var $aUeNP = parcelRequire("aUeNP");

var $hVwEW = parcelRequire("hVwEW");

var $iIOJg = parcelRequire("iIOJg");

var $3fKiX = parcelRequire("3fKiX");
/** Used to compose bitmasks for value comparisons. */ var $2fa42274ee5e481c$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $2fa42274ee5e481c$var$argsTag = '[object Arguments]', $2fa42274ee5e481c$var$arrayTag = '[object Array]', $2fa42274ee5e481c$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $2fa42274ee5e481c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $2fa42274ee5e481c$var$hasOwnProperty = $2fa42274ee5e481c$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $2fa42274ee5e481c$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $hVwEW(object), othIsArr = $hVwEW(other), objTag = objIsArr ? $2fa42274ee5e481c$var$arrayTag : $aUeNP(object), othTag = othIsArr ? $2fa42274ee5e481c$var$arrayTag : $aUeNP(other);
    objTag = objTag == $2fa42274ee5e481c$var$argsTag ? $2fa42274ee5e481c$var$objectTag : objTag;
    othTag = othTag == $2fa42274ee5e481c$var$argsTag ? $2fa42274ee5e481c$var$objectTag : othTag;
    var objIsObj = objTag == $2fa42274ee5e481c$var$objectTag, othIsObj = othTag == $2fa42274ee5e481c$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $iIOJg(object)) {
        if (!$iIOJg(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $h0DYD);
        return objIsArr || $3fKiX(object) ? $fUeeu(object, other, bitmask, customizer, equalFunc, stack) : $6uYaw(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $2fa42274ee5e481c$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $2fa42274ee5e481c$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $2fa42274ee5e481c$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $h0DYD);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $h0DYD);
    return $8MeZI(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = $2fa42274ee5e481c$var$baseIsEqualDeep;

});
parcelRegister("h0DYD", function(module, exports) {

var $5bwrM = parcelRequire("5bwrM");

var $iN2Kf = parcelRequire("iN2Kf");

var $hdJY7 = parcelRequire("hdJY7");

var $aNBeD = parcelRequire("aNBeD");

var $4lO4C = parcelRequire("4lO4C");

var $buL7N = parcelRequire("buL7N");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $c6217260871fb595$var$Stack(entries) {
    var data = this.__data__ = new $5bwrM(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$c6217260871fb595$var$Stack.prototype.clear = $iN2Kf;
$c6217260871fb595$var$Stack.prototype['delete'] = $hdJY7;
$c6217260871fb595$var$Stack.prototype.get = $aNBeD;
$c6217260871fb595$var$Stack.prototype.has = $4lO4C;
$c6217260871fb595$var$Stack.prototype.set = $buL7N;
module.exports = $c6217260871fb595$var$Stack;

});
parcelRegister("5bwrM", function(module, exports) {

var $8oWQV = parcelRequire("8oWQV");

var $4JTG5 = parcelRequire("4JTG5");

var $lNRTV = parcelRequire("lNRTV");

var $GfzjQ = parcelRequire("GfzjQ");

var $azYRm = parcelRequire("azYRm");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $3c67262323ad5308$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$3c67262323ad5308$var$ListCache.prototype.clear = $8oWQV;
$3c67262323ad5308$var$ListCache.prototype['delete'] = $4JTG5;
$3c67262323ad5308$var$ListCache.prototype.get = $lNRTV;
$3c67262323ad5308$var$ListCache.prototype.has = $GfzjQ;
$3c67262323ad5308$var$ListCache.prototype.set = $azYRm;
module.exports = $3c67262323ad5308$var$ListCache;

});
parcelRegister("8oWQV", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $61de37874291156c$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $61de37874291156c$var$listCacheClear;

});

parcelRegister("4JTG5", function(module, exports) {

var $byLNd = parcelRequire("byLNd");
/** Used for built-in method references. */ var $37368dded2099760$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $37368dded2099760$var$splice = $37368dded2099760$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $37368dded2099760$var$listCacheDelete(key) {
    var data = this.__data__, index = $byLNd(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $37368dded2099760$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $37368dded2099760$var$listCacheDelete;

});
parcelRegister("byLNd", function(module, exports) {

var $kYVBW = parcelRequire("kYVBW");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $86a7f1531b2dfed9$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($kYVBW(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $86a7f1531b2dfed9$var$assocIndexOf;

});
parcelRegister("kYVBW", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $f4661991ceca792b$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $f4661991ceca792b$var$eq;

});



parcelRegister("lNRTV", function(module, exports) {

var $byLNd = parcelRequire("byLNd");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $fdf7fc38d2bf7e2c$var$listCacheGet(key) {
    var data = this.__data__, index = $byLNd(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $fdf7fc38d2bf7e2c$var$listCacheGet;

});

parcelRegister("GfzjQ", function(module, exports) {

var $byLNd = parcelRequire("byLNd");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $07effff88ed5dbb8$var$listCacheHas(key) {
    return $byLNd(this.__data__, key) > -1;
}
module.exports = $07effff88ed5dbb8$var$listCacheHas;

});

parcelRegister("azYRm", function(module, exports) {

var $byLNd = parcelRequire("byLNd");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $7b3c61b68b2283a4$var$listCacheSet(key, value) {
    var data = this.__data__, index = $byLNd(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $7b3c61b68b2283a4$var$listCacheSet;

});


parcelRegister("iN2Kf", function(module, exports) {

var $5bwrM = parcelRequire("5bwrM");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $dadeeeafa135390a$var$stackClear() {
    this.__data__ = new $5bwrM;
    this.size = 0;
}
module.exports = $dadeeeafa135390a$var$stackClear;

});

parcelRegister("hdJY7", function(module, exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $c8974f01c5dae82a$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
module.exports = $c8974f01c5dae82a$var$stackDelete;

});

parcelRegister("aNBeD", function(module, exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $7dcb5d14561891ea$var$stackGet(key) {
    return this.__data__.get(key);
}
module.exports = $7dcb5d14561891ea$var$stackGet;

});

parcelRegister("4lO4C", function(module, exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $32aff720036108c9$var$stackHas(key) {
    return this.__data__.has(key);
}
module.exports = $32aff720036108c9$var$stackHas;

});

parcelRegister("buL7N", function(module, exports) {

var $5bwrM = parcelRequire("5bwrM");

var $kpFsf = parcelRequire("kpFsf");

var $kekVz = parcelRequire("kekVz");
/** Used as the size to enable large array optimizations. */ var $85e70d0d67f0e9f7$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $85e70d0d67f0e9f7$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $5bwrM) {
        var pairs = data.__data__;
        if (!$kpFsf || pairs.length < $85e70d0d67f0e9f7$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $kekVz(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = $85e70d0d67f0e9f7$var$stackSet;

});
parcelRegister("kpFsf", function(module, exports) {

var $9O1f3 = parcelRequire("9O1f3");

var $cJGSv = parcelRequire("cJGSv");
/* Built-in method references that are verified to be native. */ var $03d5c76d5ec8a109$var$Map = $9O1f3($cJGSv, 'Map');
module.exports = $03d5c76d5ec8a109$var$Map;

});
parcelRegister("9O1f3", function(module, exports) {

var $2fRet = parcelRequire("2fRet");

var $4aEXc = parcelRequire("4aEXc");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $7239bf2cb5317263$var$getNative(object, key) {
    var value = $4aEXc(object, key);
    return $2fRet(value) ? value : undefined;
}
module.exports = $7239bf2cb5317263$var$getNative;

});
parcelRegister("2fRet", function(module, exports) {

var $2ObcV = parcelRequire("2ObcV");

var $cKa91 = parcelRequire("cKa91");

var $e4HlO = parcelRequire("e4HlO");

var $5oXjd = parcelRequire("5oXjd");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $1a464651bd16844e$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $1a464651bd16844e$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $1a464651bd16844e$var$funcProto = Function.prototype, $1a464651bd16844e$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $1a464651bd16844e$var$funcToString = $1a464651bd16844e$var$funcProto.toString;
/** Used to check objects for own properties. */ var $1a464651bd16844e$var$hasOwnProperty = $1a464651bd16844e$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $1a464651bd16844e$var$reIsNative = RegExp('^' + $1a464651bd16844e$var$funcToString.call($1a464651bd16844e$var$hasOwnProperty).replace($1a464651bd16844e$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $1a464651bd16844e$var$baseIsNative(value) {
    if (!$e4HlO(value) || $cKa91(value)) return false;
    var pattern = $2ObcV(value) ? $1a464651bd16844e$var$reIsNative : $1a464651bd16844e$var$reIsHostCtor;
    return pattern.test($5oXjd(value));
}
module.exports = $1a464651bd16844e$var$baseIsNative;

});
parcelRegister("2ObcV", function(module, exports) {

var $cOq2v = parcelRequire("cOq2v");

var $e4HlO = parcelRequire("e4HlO");
/** `Object#toString` result references. */ var $20b8f1dd381cbe87$var$asyncTag = '[object AsyncFunction]', $20b8f1dd381cbe87$var$funcTag = '[object Function]', $20b8f1dd381cbe87$var$genTag = '[object GeneratorFunction]', $20b8f1dd381cbe87$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $20b8f1dd381cbe87$var$isFunction(value) {
    if (!$e4HlO(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $cOq2v(value);
    return tag == $20b8f1dd381cbe87$var$funcTag || tag == $20b8f1dd381cbe87$var$genTag || tag == $20b8f1dd381cbe87$var$asyncTag || tag == $20b8f1dd381cbe87$var$proxyTag;
}
module.exports = $20b8f1dd381cbe87$var$isFunction;

});
parcelRegister("cOq2v", function(module, exports) {

var $4btfk = parcelRequire("4btfk");

var $fbw34 = parcelRequire("fbw34");

var $amC45 = parcelRequire("amC45");
/** `Object#toString` result references. */ var $953e5a69274a8f6d$var$nullTag = '[object Null]', $953e5a69274a8f6d$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $953e5a69274a8f6d$var$symToStringTag = $4btfk ? $4btfk.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $953e5a69274a8f6d$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $953e5a69274a8f6d$var$undefinedTag : $953e5a69274a8f6d$var$nullTag;
    return $953e5a69274a8f6d$var$symToStringTag && $953e5a69274a8f6d$var$symToStringTag in Object(value) ? $fbw34(value) : $amC45(value);
}
module.exports = $953e5a69274a8f6d$var$baseGetTag;

});
parcelRegister("4btfk", function(module, exports) {

var $cJGSv = parcelRequire("cJGSv");
/** Built-in value references. */ var $30bee03643085e94$var$Symbol = $cJGSv.Symbol;
module.exports = $30bee03643085e94$var$Symbol;

});
parcelRegister("cJGSv", function(module, exports) {

var $i5Mh4 = parcelRequire("i5Mh4");
/** Detect free variable `self`. */ var $945af2ba7076875b$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $945af2ba7076875b$var$root = $i5Mh4 || $945af2ba7076875b$var$freeSelf || Function('return this')();
module.exports = $945af2ba7076875b$var$root;

});
parcelRegister("i5Mh4", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $d2be23e5a2fdb3be$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $d2be23e5a2fdb3be$var$freeGlobal;

});



parcelRegister("fbw34", function(module, exports) {

var $4btfk = parcelRequire("4btfk");
/** Used for built-in method references. */ var $b0e0be3d4847e3a0$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b0e0be3d4847e3a0$var$hasOwnProperty = $b0e0be3d4847e3a0$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $b0e0be3d4847e3a0$var$nativeObjectToString = $b0e0be3d4847e3a0$var$objectProto.toString;
/** Built-in value references. */ var $b0e0be3d4847e3a0$var$symToStringTag = $4btfk ? $4btfk.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $b0e0be3d4847e3a0$var$getRawTag(value) {
    var isOwn = $b0e0be3d4847e3a0$var$hasOwnProperty.call(value, $b0e0be3d4847e3a0$var$symToStringTag), tag = value[$b0e0be3d4847e3a0$var$symToStringTag];
    try {
        value[$b0e0be3d4847e3a0$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $b0e0be3d4847e3a0$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$b0e0be3d4847e3a0$var$symToStringTag] = tag;
        else delete value[$b0e0be3d4847e3a0$var$symToStringTag];
    }
    return result;
}
module.exports = $b0e0be3d4847e3a0$var$getRawTag;

});

parcelRegister("amC45", function(module, exports) {
/** Used for built-in method references. */ var $78b97c56aff342cc$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $78b97c56aff342cc$var$nativeObjectToString = $78b97c56aff342cc$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $78b97c56aff342cc$var$objectToString(value) {
    return $78b97c56aff342cc$var$nativeObjectToString.call(value);
}
module.exports = $78b97c56aff342cc$var$objectToString;

});


parcelRegister("e4HlO", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $a3f310f54c06274b$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
module.exports = $a3f310f54c06274b$var$isObject;

});


parcelRegister("cKa91", function(module, exports) {

var $7ZykF = parcelRequire("7ZykF");
/** Used to detect methods masquerading as native. */ var $9471a66d256c10c8$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($7ZykF && $7ZykF.keys && $7ZykF.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $9471a66d256c10c8$var$isMasked(func) {
    return !!$9471a66d256c10c8$var$maskSrcKey && $9471a66d256c10c8$var$maskSrcKey in func;
}
module.exports = $9471a66d256c10c8$var$isMasked;

});
parcelRegister("7ZykF", function(module, exports) {

var $cJGSv = parcelRequire("cJGSv");
/** Used to detect overreaching core-js shims. */ var $5d18dc9e241077d3$var$coreJsData = $cJGSv["__core-js_shared__"];
module.exports = $5d18dc9e241077d3$var$coreJsData;

});


parcelRegister("5oXjd", function(module, exports) {
/** Used for built-in method references. */ var $3eed332edb5460ab$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $3eed332edb5460ab$var$funcToString = $3eed332edb5460ab$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $3eed332edb5460ab$var$toSource(func) {
    if (func != null) {
        try {
            return $3eed332edb5460ab$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
module.exports = $3eed332edb5460ab$var$toSource;

});


parcelRegister("4aEXc", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $3097dd2947b68257$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $3097dd2947b68257$var$getValue;

});



parcelRegister("kekVz", function(module, exports) {

var $f3oMr = parcelRequire("f3oMr");

var $9w52i = parcelRequire("9w52i");

var $7nCA5 = parcelRequire("7nCA5");

var $8MYRl = parcelRequire("8MYRl");

var $elbT0 = parcelRequire("elbT0");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $eba55936bdfe2d60$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$eba55936bdfe2d60$var$MapCache.prototype.clear = $f3oMr;
$eba55936bdfe2d60$var$MapCache.prototype['delete'] = $9w52i;
$eba55936bdfe2d60$var$MapCache.prototype.get = $7nCA5;
$eba55936bdfe2d60$var$MapCache.prototype.has = $8MYRl;
$eba55936bdfe2d60$var$MapCache.prototype.set = $elbT0;
module.exports = $eba55936bdfe2d60$var$MapCache;

});
parcelRegister("f3oMr", function(module, exports) {

var $4N0LH = parcelRequire("4N0LH");

var $5bwrM = parcelRequire("5bwrM");

var $kpFsf = parcelRequire("kpFsf");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $af5a5ba9bf70e002$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $4N0LH,
        'map': new ($kpFsf || $5bwrM),
        'string': new $4N0LH
    };
}
module.exports = $af5a5ba9bf70e002$var$mapCacheClear;

});
parcelRegister("4N0LH", function(module, exports) {

var $2K4AI = parcelRequire("2K4AI");

var $fMxt9 = parcelRequire("fMxt9");

var $jtbab = parcelRequire("jtbab");

var $bQMGX = parcelRequire("bQMGX");

var $3CFVH = parcelRequire("3CFVH");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $37cc5594a50bda04$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$37cc5594a50bda04$var$Hash.prototype.clear = $2K4AI;
$37cc5594a50bda04$var$Hash.prototype['delete'] = $fMxt9;
$37cc5594a50bda04$var$Hash.prototype.get = $jtbab;
$37cc5594a50bda04$var$Hash.prototype.has = $bQMGX;
$37cc5594a50bda04$var$Hash.prototype.set = $3CFVH;
module.exports = $37cc5594a50bda04$var$Hash;

});
parcelRegister("2K4AI", function(module, exports) {

var $guCrh = parcelRequire("guCrh");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $1ff3705be098df48$var$hashClear() {
    this.__data__ = $guCrh ? $guCrh(null) : {};
    this.size = 0;
}
module.exports = $1ff3705be098df48$var$hashClear;

});
parcelRegister("guCrh", function(module, exports) {

var $9O1f3 = parcelRequire("9O1f3");
/* Built-in method references that are verified to be native. */ var $c01d43dbf53f94c2$var$nativeCreate = $9O1f3(Object, 'create');
module.exports = $c01d43dbf53f94c2$var$nativeCreate;

});


parcelRegister("fMxt9", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $b7d54d008044c2ae$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $b7d54d008044c2ae$var$hashDelete;

});

parcelRegister("jtbab", function(module, exports) {

var $guCrh = parcelRequire("guCrh");
/** Used to stand-in for `undefined` hash values. */ var $e2c9628955b5d187$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $e2c9628955b5d187$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e2c9628955b5d187$var$hasOwnProperty = $e2c9628955b5d187$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $e2c9628955b5d187$var$hashGet(key) {
    var data = this.__data__;
    if ($guCrh) {
        var result = data[key];
        return result === $e2c9628955b5d187$var$HASH_UNDEFINED ? undefined : result;
    }
    return $e2c9628955b5d187$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $e2c9628955b5d187$var$hashGet;

});

parcelRegister("bQMGX", function(module, exports) {

var $guCrh = parcelRequire("guCrh");
/** Used for built-in method references. */ var $8a0a52402ec8bf0d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $8a0a52402ec8bf0d$var$hasOwnProperty = $8a0a52402ec8bf0d$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $8a0a52402ec8bf0d$var$hashHas(key) {
    var data = this.__data__;
    return $guCrh ? data[key] !== undefined : $8a0a52402ec8bf0d$var$hasOwnProperty.call(data, key);
}
module.exports = $8a0a52402ec8bf0d$var$hashHas;

});

parcelRegister("3CFVH", function(module, exports) {

var $guCrh = parcelRequire("guCrh");
/** Used to stand-in for `undefined` hash values. */ var $2a357215896f3611$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $2a357215896f3611$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $guCrh && value === undefined ? $2a357215896f3611$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $2a357215896f3611$var$hashSet;

});



parcelRegister("9w52i", function(module, exports) {

var $66oZ2 = parcelRequire("66oZ2");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $6edb0243d1d00ccf$var$mapCacheDelete(key) {
    var result = $66oZ2(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $6edb0243d1d00ccf$var$mapCacheDelete;

});
parcelRegister("66oZ2", function(module, exports) {

var $jdf0Y = parcelRequire("jdf0Y");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $4716aed6aa7162ba$var$getMapData(map, key) {
    var data = map.__data__;
    return $jdf0Y(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
module.exports = $4716aed6aa7162ba$var$getMapData;

});
parcelRegister("jdf0Y", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $dfcae0cf3fc90456$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
module.exports = $dfcae0cf3fc90456$var$isKeyable;

});



parcelRegister("7nCA5", function(module, exports) {

var $66oZ2 = parcelRequire("66oZ2");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $55f89bc7d5b79c06$var$mapCacheGet(key) {
    return $66oZ2(this, key).get(key);
}
module.exports = $55f89bc7d5b79c06$var$mapCacheGet;

});

parcelRegister("8MYRl", function(module, exports) {

var $66oZ2 = parcelRequire("66oZ2");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $666203d15d4c6154$var$mapCacheHas(key) {
    return $66oZ2(this, key).has(key);
}
module.exports = $666203d15d4c6154$var$mapCacheHas;

});

parcelRegister("elbT0", function(module, exports) {

var $66oZ2 = parcelRequire("66oZ2");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $a70c3f32a76d9cd1$var$mapCacheSet(key, value) {
    var data = $66oZ2(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $a70c3f32a76d9cd1$var$mapCacheSet;

});




parcelRegister("fUeeu", function(module, exports) {

var $Bkh6K = parcelRequire("Bkh6K");

var $k3K0i = parcelRequire("k3K0i");

var $erszz = parcelRequire("erszz");
/** Used to compose bitmasks for value comparisons. */ var $b9472047e72d053a$var$COMPARE_PARTIAL_FLAG = 1, $b9472047e72d053a$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $b9472047e72d053a$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $b9472047e72d053a$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $b9472047e72d053a$var$COMPARE_UNORDERED_FLAG ? new $Bkh6K : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$k3K0i(other, function(othValue, othIndex) {
                if (!$erszz(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
module.exports = $b9472047e72d053a$var$equalArrays;

});
parcelRegister("Bkh6K", function(module, exports) {

var $kekVz = parcelRequire("kekVz");

var $6eBJe = parcelRequire("6eBJe");

var $kxRUG = parcelRequire("kxRUG");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $07032efee1b42a30$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $kekVz;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$07032efee1b42a30$var$SetCache.prototype.add = $07032efee1b42a30$var$SetCache.prototype.push = $6eBJe;
$07032efee1b42a30$var$SetCache.prototype.has = $kxRUG;
module.exports = $07032efee1b42a30$var$SetCache;

});
parcelRegister("6eBJe", function(module, exports) {
/** Used to stand-in for `undefined` hash values. */ var $48a150fa0b493574$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $48a150fa0b493574$var$setCacheAdd(value) {
    this.__data__.set(value, $48a150fa0b493574$var$HASH_UNDEFINED);
    return this;
}
module.exports = $48a150fa0b493574$var$setCacheAdd;

});

parcelRegister("kxRUG", function(module, exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $ef50b5be366180eb$var$setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = $ef50b5be366180eb$var$setCacheHas;

});


parcelRegister("k3K0i", function(module, exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $e9a7c5da92886705$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = $e9a7c5da92886705$var$arraySome;

});

parcelRegister("erszz", function(module, exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $a839c03d71f897b2$var$cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = $a839c03d71f897b2$var$cacheHas;

});


parcelRegister("6uYaw", function(module, exports) {

var $4btfk = parcelRequire("4btfk");

var $7jtyp = parcelRequire("7jtyp");

var $kYVBW = parcelRequire("kYVBW");

var $fUeeu = parcelRequire("fUeeu");

var $6WQbY = parcelRequire("6WQbY");

var $gsNp6 = parcelRequire("gsNp6");
/** Used to compose bitmasks for value comparisons. */ var $4bb437acfd6df7d3$var$COMPARE_PARTIAL_FLAG = 1, $4bb437acfd6df7d3$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $4bb437acfd6df7d3$var$boolTag = '[object Boolean]', $4bb437acfd6df7d3$var$dateTag = '[object Date]', $4bb437acfd6df7d3$var$errorTag = '[object Error]', $4bb437acfd6df7d3$var$mapTag = '[object Map]', $4bb437acfd6df7d3$var$numberTag = '[object Number]', $4bb437acfd6df7d3$var$regexpTag = '[object RegExp]', $4bb437acfd6df7d3$var$setTag = '[object Set]', $4bb437acfd6df7d3$var$stringTag = '[object String]', $4bb437acfd6df7d3$var$symbolTag = '[object Symbol]';
var $4bb437acfd6df7d3$var$arrayBufferTag = '[object ArrayBuffer]', $4bb437acfd6df7d3$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $4bb437acfd6df7d3$var$symbolProto = $4btfk ? $4btfk.prototype : undefined, $4bb437acfd6df7d3$var$symbolValueOf = $4bb437acfd6df7d3$var$symbolProto ? $4bb437acfd6df7d3$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $4bb437acfd6df7d3$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $4bb437acfd6df7d3$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $4bb437acfd6df7d3$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $7jtyp(object), new $7jtyp(other))) return false;
            return true;
        case $4bb437acfd6df7d3$var$boolTag:
        case $4bb437acfd6df7d3$var$dateTag:
        case $4bb437acfd6df7d3$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $kYVBW(+object, +other);
        case $4bb437acfd6df7d3$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $4bb437acfd6df7d3$var$regexpTag:
        case $4bb437acfd6df7d3$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $4bb437acfd6df7d3$var$mapTag:
            var convert = $6WQbY;
        case $4bb437acfd6df7d3$var$setTag:
            var isPartial = bitmask & $4bb437acfd6df7d3$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $gsNp6);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $4bb437acfd6df7d3$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $fUeeu(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $4bb437acfd6df7d3$var$symbolTag:
            if ($4bb437acfd6df7d3$var$symbolValueOf) return $4bb437acfd6df7d3$var$symbolValueOf.call(object) == $4bb437acfd6df7d3$var$symbolValueOf.call(other);
    }
    return false;
}
module.exports = $4bb437acfd6df7d3$var$equalByTag;

});
parcelRegister("7jtyp", function(module, exports) {

var $cJGSv = parcelRequire("cJGSv");
/** Built-in value references. */ var $55313b957061afbf$var$Uint8Array = $cJGSv.Uint8Array;
module.exports = $55313b957061afbf$var$Uint8Array;

});

parcelRegister("6WQbY", function(module, exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $50f0a51ba99a7598$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = $50f0a51ba99a7598$var$mapToArray;

});

parcelRegister("gsNp6", function(module, exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $bfc595733a461cbc$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = $bfc595733a461cbc$var$setToArray;

});


parcelRegister("8MeZI", function(module, exports) {

var $HVyr8 = parcelRequire("HVyr8");
/** Used to compose bitmasks for value comparisons. */ var $663e70008af42a9c$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $663e70008af42a9c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $663e70008af42a9c$var$hasOwnProperty = $663e70008af42a9c$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $663e70008af42a9c$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $663e70008af42a9c$var$COMPARE_PARTIAL_FLAG, objProps = $HVyr8(object), objLength = objProps.length, othProps = $HVyr8(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $663e70008af42a9c$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
module.exports = $663e70008af42a9c$var$equalObjects;

});
parcelRegister("HVyr8", function(module, exports) {

var $lJBCD = parcelRequire("lJBCD");

var $aTaNu = parcelRequire("aTaNu");

var $8Tm1R = parcelRequire("8Tm1R");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $0840a960b8bb6e24$var$getAllKeys(object) {
    return $lJBCD(object, $8Tm1R, $aTaNu);
}
module.exports = $0840a960b8bb6e24$var$getAllKeys;

});
parcelRegister("lJBCD", function(module, exports) {

var $4jeh9 = parcelRequire("4jeh9");

var $hVwEW = parcelRequire("hVwEW");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $fd2afbec467b26ac$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $hVwEW(object) ? result : $4jeh9(result, symbolsFunc(object));
}
module.exports = $fd2afbec467b26ac$var$baseGetAllKeys;

});
parcelRegister("4jeh9", function(module, exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $323402976abbf43c$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = $323402976abbf43c$var$arrayPush;

});

parcelRegister("hVwEW", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $d0d117fd96cd52bf$var$isArray = Array.isArray;
module.exports = $d0d117fd96cd52bf$var$isArray;

});


parcelRegister("aTaNu", function(module, exports) {

var $9pnJu = parcelRequire("9pnJu");

var $erjea = parcelRequire("erjea");
/** Used for built-in method references. */ var $7ed76a88e56e36eb$var$objectProto = Object.prototype;
/** Built-in value references. */ var $7ed76a88e56e36eb$var$propertyIsEnumerable = $7ed76a88e56e36eb$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $7ed76a88e56e36eb$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $7ed76a88e56e36eb$var$getSymbols = !$7ed76a88e56e36eb$var$nativeGetSymbols ? $erjea : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $9pnJu($7ed76a88e56e36eb$var$nativeGetSymbols(object), function(symbol) {
        return $7ed76a88e56e36eb$var$propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = $7ed76a88e56e36eb$var$getSymbols;

});
parcelRegister("9pnJu", function(module, exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $6d98dbae82f68add$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = $6d98dbae82f68add$var$arrayFilter;

});

parcelRegister("erjea", function(module, exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $a83280780c41b306$var$stubArray() {
    return [];
}
module.exports = $a83280780c41b306$var$stubArray;

});


parcelRegister("8Tm1R", function(module, exports) {

var $gGS2i = parcelRequire("gGS2i");

var $hQdh7 = parcelRequire("hQdh7");

var $94r8E = parcelRequire("94r8E");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $67948c43049f1868$var$keys(object) {
    return $94r8E(object) ? $gGS2i(object) : $hQdh7(object);
}
module.exports = $67948c43049f1868$var$keys;

});
parcelRegister("gGS2i", function(module, exports) {

var $lwjOg = parcelRequire("lwjOg");

var $hnI0l = parcelRequire("hnI0l");

var $hVwEW = parcelRequire("hVwEW");

var $iIOJg = parcelRequire("iIOJg");

var $hlO9Y = parcelRequire("hlO9Y");

var $3fKiX = parcelRequire("3fKiX");
/** Used for built-in method references. */ var $c26a7c0414b0a058$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c26a7c0414b0a058$var$hasOwnProperty = $c26a7c0414b0a058$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $c26a7c0414b0a058$var$arrayLikeKeys(value, inherited) {
    var isArr = $hVwEW(value), isArg = !isArr && $hnI0l(value), isBuff = !isArr && !isArg && $iIOJg(value), isType = !isArr && !isArg && !isBuff && $3fKiX(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $lwjOg(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $c26a7c0414b0a058$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    $hlO9Y(key, length)))) result.push(key);
    return result;
}
module.exports = $c26a7c0414b0a058$var$arrayLikeKeys;

});
parcelRegister("lwjOg", function(module, exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $faabf3e7e7c994c0$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = $faabf3e7e7c994c0$var$baseTimes;

});

parcelRegister("hnI0l", function(module, exports) {

var $bB5NH = parcelRequire("bB5NH");

var $3MU3q = parcelRequire("3MU3q");
/** Used for built-in method references. */ var $ca76b80bfaff4ee8$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ca76b80bfaff4ee8$var$hasOwnProperty = $ca76b80bfaff4ee8$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $ca76b80bfaff4ee8$var$propertyIsEnumerable = $ca76b80bfaff4ee8$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $ca76b80bfaff4ee8$var$isArguments = $bB5NH(function() {
    return arguments;
}()) ? $bB5NH : function(value) {
    return $3MU3q(value) && $ca76b80bfaff4ee8$var$hasOwnProperty.call(value, 'callee') && !$ca76b80bfaff4ee8$var$propertyIsEnumerable.call(value, 'callee');
};
module.exports = $ca76b80bfaff4ee8$var$isArguments;

});
parcelRegister("bB5NH", function(module, exports) {

var $cOq2v = parcelRequire("cOq2v");

var $3MU3q = parcelRequire("3MU3q");
/** `Object#toString` result references. */ var $8717a64e0495ffa0$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $8717a64e0495ffa0$var$baseIsArguments(value) {
    return $3MU3q(value) && $cOq2v(value) == $8717a64e0495ffa0$var$argsTag;
}
module.exports = $8717a64e0495ffa0$var$baseIsArguments;

});
parcelRegister("3MU3q", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $2c215601c244dbd0$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = $2c215601c244dbd0$var$isObjectLike;

});



parcelRegister("iIOJg", function(module, exports) {

var $cJGSv = parcelRequire("cJGSv");

var $hxmPr = parcelRequire("hxmPr");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $cJGSv.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $hxmPr;
module.exports = isBuffer;

});
parcelRegister("hxmPr", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $cc473a0b8ba7add5$var$stubFalse() {
    return false;
}
module.exports = $cc473a0b8ba7add5$var$stubFalse;

});


parcelRegister("hlO9Y", function(module, exports) {
/** Used as references for various `Number` constants. */ var $ca1b4e8367836290$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $ca1b4e8367836290$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $ca1b4e8367836290$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $ca1b4e8367836290$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $ca1b4e8367836290$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $ca1b4e8367836290$var$isIndex;

});

parcelRegister("3fKiX", function(module, exports) {

var $j0ISX = parcelRequire("j0ISX");

var $2kbTI = parcelRequire("2kbTI");

var $aTlV2 = parcelRequire("aTlV2");
/* Node.js helper references. */ var $25e6b0fa2bac88eb$var$nodeIsTypedArray = $aTlV2 && $aTlV2.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $25e6b0fa2bac88eb$var$isTypedArray = $25e6b0fa2bac88eb$var$nodeIsTypedArray ? $2kbTI($25e6b0fa2bac88eb$var$nodeIsTypedArray) : $j0ISX;
module.exports = $25e6b0fa2bac88eb$var$isTypedArray;

});
parcelRegister("j0ISX", function(module, exports) {

var $cOq2v = parcelRequire("cOq2v");

var $5XGjw = parcelRequire("5XGjw");

var $3MU3q = parcelRequire("3MU3q");
/** `Object#toString` result references. */ var $dd70d5b791e30f2d$var$argsTag = '[object Arguments]', $dd70d5b791e30f2d$var$arrayTag = '[object Array]', $dd70d5b791e30f2d$var$boolTag = '[object Boolean]', $dd70d5b791e30f2d$var$dateTag = '[object Date]', $dd70d5b791e30f2d$var$errorTag = '[object Error]', $dd70d5b791e30f2d$var$funcTag = '[object Function]', $dd70d5b791e30f2d$var$mapTag = '[object Map]', $dd70d5b791e30f2d$var$numberTag = '[object Number]', $dd70d5b791e30f2d$var$objectTag = '[object Object]', $dd70d5b791e30f2d$var$regexpTag = '[object RegExp]', $dd70d5b791e30f2d$var$setTag = '[object Set]', $dd70d5b791e30f2d$var$stringTag = '[object String]', $dd70d5b791e30f2d$var$weakMapTag = '[object WeakMap]';
var $dd70d5b791e30f2d$var$arrayBufferTag = '[object ArrayBuffer]', $dd70d5b791e30f2d$var$dataViewTag = '[object DataView]', $dd70d5b791e30f2d$var$float32Tag = '[object Float32Array]', $dd70d5b791e30f2d$var$float64Tag = '[object Float64Array]', $dd70d5b791e30f2d$var$int8Tag = '[object Int8Array]', $dd70d5b791e30f2d$var$int16Tag = '[object Int16Array]', $dd70d5b791e30f2d$var$int32Tag = '[object Int32Array]', $dd70d5b791e30f2d$var$uint8Tag = '[object Uint8Array]', $dd70d5b791e30f2d$var$uint8ClampedTag = '[object Uint8ClampedArray]', $dd70d5b791e30f2d$var$uint16Tag = '[object Uint16Array]', $dd70d5b791e30f2d$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $dd70d5b791e30f2d$var$typedArrayTags = {};
$dd70d5b791e30f2d$var$typedArrayTags[$dd70d5b791e30f2d$var$float32Tag] = $dd70d5b791e30f2d$var$typedArrayTags[$dd70d5b791e30f2d$var$float64Tag] = $dd70d5b791e30f2d$var$typedArrayTags[$dd70d5b791e30f2d$var$int8Tag] = $dd70d5b791e30f2d$var$typedArrayTags[$dd70d5b791e30f2d$var$int16Tag] = $dd70d5b791e30f2d$var$typedArrayTags[$dd70d5b791e30f2d$var$int32Tag] = $dd70d5b791e30f2d$var$typedArrayTags[$dd70d5b791e30f2d$var$uint8Tag] = $dd70d5b791e30f2d$var$typedArrayTags[$dd70d5b791e30f2d$var$uint8ClampedTag] = $dd70d5b791e30f2d$var$typedArrayTags[$dd70d5b791e30f2d$var$uint16Tag] = $dd70d5b791e30f2d$var$typedArrayTags[$dd70d5b791e30f2d$var$uint32Tag] = true;
$dd70d5b791e30f2d$var$typedArrayTags[$dd70d5b791e30f2d$var$argsTag] = $dd70d5b791e30f2d$var$typedArrayTags[$dd70d5b791e30f2d$var$arrayTag] = $dd70d5b791e30f2d$var$typedArrayTags[$dd70d5b791e30f2d$var$arrayBufferTag] = $dd70d5b791e30f2d$var$typedArrayTags[$dd70d5b791e30f2d$var$boolTag] = $dd70d5b791e30f2d$var$typedArrayTags[$dd70d5b791e30f2d$var$dataViewTag] = $dd70d5b791e30f2d$var$typedArrayTags[$dd70d5b791e30f2d$var$dateTag] = $dd70d5b791e30f2d$var$typedArrayTags[$dd70d5b791e30f2d$var$errorTag] = $dd70d5b791e30f2d$var$typedArrayTags[$dd70d5b791e30f2d$var$funcTag] = $dd70d5b791e30f2d$var$typedArrayTags[$dd70d5b791e30f2d$var$mapTag] = $dd70d5b791e30f2d$var$typedArrayTags[$dd70d5b791e30f2d$var$numberTag] = $dd70d5b791e30f2d$var$typedArrayTags[$dd70d5b791e30f2d$var$objectTag] = $dd70d5b791e30f2d$var$typedArrayTags[$dd70d5b791e30f2d$var$regexpTag] = $dd70d5b791e30f2d$var$typedArrayTags[$dd70d5b791e30f2d$var$setTag] = $dd70d5b791e30f2d$var$typedArrayTags[$dd70d5b791e30f2d$var$stringTag] = $dd70d5b791e30f2d$var$typedArrayTags[$dd70d5b791e30f2d$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $dd70d5b791e30f2d$var$baseIsTypedArray(value) {
    return $3MU3q(value) && $5XGjw(value.length) && !!$dd70d5b791e30f2d$var$typedArrayTags[$cOq2v(value)];
}
module.exports = $dd70d5b791e30f2d$var$baseIsTypedArray;

});
parcelRegister("5XGjw", function(module, exports) {
/** Used as references for various `Number` constants. */ var $4573491ae9d8c150$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $4573491ae9d8c150$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $4573491ae9d8c150$var$MAX_SAFE_INTEGER;
}
module.exports = $4573491ae9d8c150$var$isLength;

});


parcelRegister("2kbTI", function(module, exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $1b16ada699dbe19d$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = $1b16ada699dbe19d$var$baseUnary;

});

parcelRegister("aTlV2", function(module, exports) {

var $i5Mh4 = parcelRequire("i5Mh4");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $i5Mh4.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

});



parcelRegister("hQdh7", function(module, exports) {

var $8dku9 = parcelRequire("8dku9");

var $cmIyZ = parcelRequire("cmIyZ");
/** Used for built-in method references. */ var $cfd19722e2a15c84$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $cfd19722e2a15c84$var$hasOwnProperty = $cfd19722e2a15c84$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $cfd19722e2a15c84$var$baseKeys(object) {
    if (!$8dku9(object)) return $cmIyZ(object);
    var result = [];
    for(var key in Object(object))if ($cfd19722e2a15c84$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
module.exports = $cfd19722e2a15c84$var$baseKeys;

});
parcelRegister("8dku9", function(module, exports) {
/** Used for built-in method references. */ var $5faf6d9199a41458$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $5faf6d9199a41458$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $5faf6d9199a41458$var$objectProto;
    return value === proto;
}
module.exports = $5faf6d9199a41458$var$isPrototype;

});

parcelRegister("cmIyZ", function(module, exports) {

var $goDPq = parcelRequire("goDPq");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $900a1b744e832046$var$nativeKeys = $goDPq(Object.keys, Object);
module.exports = $900a1b744e832046$var$nativeKeys;

});
parcelRegister("goDPq", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $befdc85895490d54$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = $befdc85895490d54$var$overArg;

});



parcelRegister("94r8E", function(module, exports) {

var $2ObcV = parcelRequire("2ObcV");

var $5XGjw = parcelRequire("5XGjw");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $69a989ec6219b3aa$var$isArrayLike(value) {
    return value != null && $5XGjw(value.length) && !$2ObcV(value);
}
module.exports = $69a989ec6219b3aa$var$isArrayLike;

});




parcelRegister("aUeNP", function(module, exports) {

var $9omvv = parcelRequire("9omvv");

var $kpFsf = parcelRequire("kpFsf");

var $femYG = parcelRequire("femYG");

var $49Hpk = parcelRequire("49Hpk");

var $dR5iQ = parcelRequire("dR5iQ");

var $cOq2v = parcelRequire("cOq2v");

var $5oXjd = parcelRequire("5oXjd");
/** `Object#toString` result references. */ var $7f0a9dd6e661847d$var$mapTag = '[object Map]', $7f0a9dd6e661847d$var$objectTag = '[object Object]', $7f0a9dd6e661847d$var$promiseTag = '[object Promise]', $7f0a9dd6e661847d$var$setTag = '[object Set]', $7f0a9dd6e661847d$var$weakMapTag = '[object WeakMap]';
var $7f0a9dd6e661847d$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $7f0a9dd6e661847d$var$dataViewCtorString = $5oXjd($9omvv), $7f0a9dd6e661847d$var$mapCtorString = $5oXjd($kpFsf), $7f0a9dd6e661847d$var$promiseCtorString = $5oXjd($femYG), $7f0a9dd6e661847d$var$setCtorString = $5oXjd($49Hpk), $7f0a9dd6e661847d$var$weakMapCtorString = $5oXjd($dR5iQ);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $7f0a9dd6e661847d$var$getTag = $cOq2v;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($9omvv && $7f0a9dd6e661847d$var$getTag(new $9omvv(new ArrayBuffer(1))) != $7f0a9dd6e661847d$var$dataViewTag || $kpFsf && $7f0a9dd6e661847d$var$getTag(new $kpFsf) != $7f0a9dd6e661847d$var$mapTag || $femYG && $7f0a9dd6e661847d$var$getTag($femYG.resolve()) != $7f0a9dd6e661847d$var$promiseTag || $49Hpk && $7f0a9dd6e661847d$var$getTag(new $49Hpk) != $7f0a9dd6e661847d$var$setTag || $dR5iQ && $7f0a9dd6e661847d$var$getTag(new $dR5iQ) != $7f0a9dd6e661847d$var$weakMapTag) $7f0a9dd6e661847d$var$getTag = function(value) {
    var result = $cOq2v(value), Ctor = result == $7f0a9dd6e661847d$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $5oXjd(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $7f0a9dd6e661847d$var$dataViewCtorString:
            return $7f0a9dd6e661847d$var$dataViewTag;
        case $7f0a9dd6e661847d$var$mapCtorString:
            return $7f0a9dd6e661847d$var$mapTag;
        case $7f0a9dd6e661847d$var$promiseCtorString:
            return $7f0a9dd6e661847d$var$promiseTag;
        case $7f0a9dd6e661847d$var$setCtorString:
            return $7f0a9dd6e661847d$var$setTag;
        case $7f0a9dd6e661847d$var$weakMapCtorString:
            return $7f0a9dd6e661847d$var$weakMapTag;
    }
    return result;
};
module.exports = $7f0a9dd6e661847d$var$getTag;

});
parcelRegister("9omvv", function(module, exports) {

var $9O1f3 = parcelRequire("9O1f3");

var $cJGSv = parcelRequire("cJGSv");
/* Built-in method references that are verified to be native. */ var $6d67d069615522ef$var$DataView = $9O1f3($cJGSv, 'DataView');
module.exports = $6d67d069615522ef$var$DataView;

});

parcelRegister("femYG", function(module, exports) {

var $9O1f3 = parcelRequire("9O1f3");

var $cJGSv = parcelRequire("cJGSv");
/* Built-in method references that are verified to be native. */ var $b169fcba1df6e015$var$Promise = $9O1f3($cJGSv, 'Promise');
module.exports = $b169fcba1df6e015$var$Promise;

});

parcelRegister("49Hpk", function(module, exports) {

var $9O1f3 = parcelRequire("9O1f3");

var $cJGSv = parcelRequire("cJGSv");
/* Built-in method references that are verified to be native. */ var $3069ac7e0d04a756$var$Set = $9O1f3($cJGSv, 'Set');
module.exports = $3069ac7e0d04a756$var$Set;

});

parcelRegister("dR5iQ", function(module, exports) {

var $9O1f3 = parcelRequire("9O1f3");

var $cJGSv = parcelRequire("cJGSv");
/* Built-in method references that are verified to be native. */ var $a16456a49992e222$var$WeakMap = $9O1f3($cJGSv, 'WeakMap');
module.exports = $a16456a49992e222$var$WeakMap;

});





parcelRegister("eKkfN", function(module, exports) {

var $1SQen = parcelRequire("1SQen");

var $83lTV = parcelRequire("83lTV");
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * var array = [
 *   { 'dir': 'left', 'code': 97 },
 *   { 'dir': 'right', 'code': 100 }
 * ];
 *
 * _.keyBy(array, function(o) {
 *   return String.fromCharCode(o.code);
 * });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * _.keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 */ var $abc5128b165396e3$var$keyBy = $83lTV(function(result, value, key) {
    $1SQen(result, key, value);
});
module.exports = $abc5128b165396e3$var$keyBy;

});
parcelRegister("1SQen", function(module, exports) {

var $5gcad = parcelRequire("5gcad");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $15f35991481f19c4$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && $5gcad) $5gcad(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
module.exports = $15f35991481f19c4$var$baseAssignValue;

});
parcelRegister("5gcad", function(module, exports) {

var $9O1f3 = parcelRequire("9O1f3");
var $3d47e1d21a965796$var$defineProperty = function() {
    try {
        var func = $9O1f3(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
module.exports = $3d47e1d21a965796$var$defineProperty;

});


parcelRegister("83lTV", function(module, exports) {

var $85COX = parcelRequire("85COX");

var $gqGWB = parcelRequire("gqGWB");

var $kTyAU = parcelRequire("kTyAU");

var $hVwEW = parcelRequire("hVwEW");
/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */ function $5dcf979e5a639cea$var$createAggregator(setter, initializer) {
    return function(collection, iteratee) {
        var func = $hVwEW(collection) ? $85COX : $gqGWB, accumulator = initializer ? initializer() : {};
        return func(collection, setter, $kTyAU(iteratee, 2), accumulator);
    };
}
module.exports = $5dcf979e5a639cea$var$createAggregator;

});
parcelRegister("85COX", function(module, exports) {
/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $5e3ce75e288faa12$var$arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        var value = array[index];
        setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
}
module.exports = $5e3ce75e288faa12$var$arrayAggregator;

});

parcelRegister("gqGWB", function(module, exports) {

var $NPR53 = parcelRequire("NPR53");
/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $bf6062e3813b1911$var$baseAggregator(collection, setter, iteratee, accumulator) {
    $NPR53(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
    });
    return accumulator;
}
module.exports = $bf6062e3813b1911$var$baseAggregator;

});
parcelRegister("NPR53", function(module, exports) {

var $aHH9J = parcelRequire("aHH9J");

var $i5HG0 = parcelRequire("i5HG0");
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $095ccd115503a6f3$var$baseEach = $i5HG0($aHH9J);
module.exports = $095ccd115503a6f3$var$baseEach;

});
parcelRegister("aHH9J", function(module, exports) {

var $lC9tT = parcelRequire("lC9tT");

var $8Tm1R = parcelRequire("8Tm1R");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $7caf656595371b57$var$baseForOwn(object, iteratee) {
    return object && $lC9tT(object, iteratee, $8Tm1R);
}
module.exports = $7caf656595371b57$var$baseForOwn;

});
parcelRegister("lC9tT", function(module, exports) {

var $6EM9o = parcelRequire("6EM9o");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $fbc4805485bb447f$var$baseFor = $6EM9o();
module.exports = $fbc4805485bb447f$var$baseFor;

});
parcelRegister("6EM9o", function(module, exports) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $4d8bd42a602d7b47$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = $4d8bd42a602d7b47$var$createBaseFor;

});



parcelRegister("i5HG0", function(module, exports) {

var $94r8E = parcelRequire("94r8E");
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $d2ba92de5f6d794f$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$94r8E(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = $d2ba92de5f6d794f$var$createBaseEach;

});



parcelRegister("kTyAU", function(module, exports) {

var $8z59r = parcelRequire("8z59r");

var $excbA = parcelRequire("excbA");

var $19t6w = parcelRequire("19t6w");

var $hVwEW = parcelRequire("hVwEW");

var $ihasg = parcelRequire("ihasg");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $f363c76e5dadb889$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return $19t6w;
    if (typeof value == 'object') return $hVwEW(value) ? $excbA(value[0], value[1]) : $8z59r(value);
    return $ihasg(value);
}
module.exports = $f363c76e5dadb889$var$baseIteratee;

});
parcelRegister("8z59r", function(module, exports) {

var $cQAfb = parcelRequire("cQAfb");

var $2QN7m = parcelRequire("2QN7m");

var $lHAUi = parcelRequire("lHAUi");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $63c596881b4a931b$var$baseMatches(source) {
    var matchData = $2QN7m(source);
    if (matchData.length == 1 && matchData[0][2]) return $lHAUi(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $cQAfb(object, source, matchData);
    };
}
module.exports = $63c596881b4a931b$var$baseMatches;

});
parcelRegister("cQAfb", function(module, exports) {

var $h0DYD = parcelRequire("h0DYD");

var $17m4Y = parcelRequire("17m4Y");
/** Used to compose bitmasks for value comparisons. */ var $95a674ab41e00922$var$COMPARE_PARTIAL_FLAG = 1, $95a674ab41e00922$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $95a674ab41e00922$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $h0DYD;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $17m4Y(srcValue, objValue, $95a674ab41e00922$var$COMPARE_PARTIAL_FLAG | $95a674ab41e00922$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = $95a674ab41e00922$var$baseIsMatch;

});

parcelRegister("2QN7m", function(module, exports) {

var $bsRMf = parcelRequire("bsRMf");

var $8Tm1R = parcelRequire("8Tm1R");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $213689da4e1ee288$var$getMatchData(object) {
    var result = $8Tm1R(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $bsRMf(value)
        ];
    }
    return result;
}
module.exports = $213689da4e1ee288$var$getMatchData;

});
parcelRegister("bsRMf", function(module, exports) {

var $e4HlO = parcelRequire("e4HlO");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $858c06417b460a11$var$isStrictComparable(value) {
    return value === value && !$e4HlO(value);
}
module.exports = $858c06417b460a11$var$isStrictComparable;

});


parcelRegister("lHAUi", function(module, exports) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $fcca3e1b08cf515c$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
module.exports = $fcca3e1b08cf515c$var$matchesStrictComparable;

});


parcelRegister("excbA", function(module, exports) {

var $17m4Y = parcelRequire("17m4Y");

var $PC5QH = parcelRequire("PC5QH");

var $h1LbN = parcelRequire("h1LbN");

var $5guOp = parcelRequire("5guOp");

var $bsRMf = parcelRequire("bsRMf");

var $lHAUi = parcelRequire("lHAUi");

var $bT5XG = parcelRequire("bT5XG");
/** Used to compose bitmasks for value comparisons. */ var $a94d999cadf3ccaa$var$COMPARE_PARTIAL_FLAG = 1, $a94d999cadf3ccaa$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $a94d999cadf3ccaa$var$baseMatchesProperty(path, srcValue) {
    if ($5guOp(path) && $bsRMf(srcValue)) return $lHAUi($bT5XG(path), srcValue);
    return function(object) {
        var objValue = $PC5QH(object, path);
        return objValue === undefined && objValue === srcValue ? $h1LbN(object, path) : $17m4Y(srcValue, objValue, $a94d999cadf3ccaa$var$COMPARE_PARTIAL_FLAG | $a94d999cadf3ccaa$var$COMPARE_UNORDERED_FLAG);
    };
}
module.exports = $a94d999cadf3ccaa$var$baseMatchesProperty;

});
parcelRegister("PC5QH", function(module, exports) {

var $krRFz = parcelRequire("krRFz");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $09b25013fd512c15$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $krRFz(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = $09b25013fd512c15$var$get;

});
parcelRegister("krRFz", function(module, exports) {

var $6hGcP = parcelRequire("6hGcP");

var $bT5XG = parcelRequire("bT5XG");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $ee2ff5e4f203d45b$var$baseGet(object, path) {
    path = $6hGcP(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$bT5XG(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = $ee2ff5e4f203d45b$var$baseGet;

});
parcelRegister("6hGcP", function(module, exports) {

var $hVwEW = parcelRequire("hVwEW");

var $5guOp = parcelRequire("5guOp");

var $4fM1S = parcelRequire("4fM1S");

var $62oCn = parcelRequire("62oCn");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $493511d2cb512e68$var$castPath(value, object) {
    if ($hVwEW(value)) return value;
    return $5guOp(value, object) ? [
        value
    ] : $4fM1S($62oCn(value));
}
module.exports = $493511d2cb512e68$var$castPath;

});
parcelRegister("5guOp", function(module, exports) {

var $hVwEW = parcelRequire("hVwEW");

var $6eEhe = parcelRequire("6eEhe");
/** Used to match property names within property paths. */ var $3d565903f56e0b5d$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $3d565903f56e0b5d$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $3d565903f56e0b5d$var$isKey(value, object) {
    if ($hVwEW(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $6eEhe(value)) return true;
    return $3d565903f56e0b5d$var$reIsPlainProp.test(value) || !$3d565903f56e0b5d$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = $3d565903f56e0b5d$var$isKey;

});
parcelRegister("6eEhe", function(module, exports) {

var $cOq2v = parcelRequire("cOq2v");

var $3MU3q = parcelRequire("3MU3q");
/** `Object#toString` result references. */ var $48a34b0e52848244$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $48a34b0e52848244$var$isSymbol(value) {
    return typeof value == 'symbol' || $3MU3q(value) && $cOq2v(value) == $48a34b0e52848244$var$symbolTag;
}
module.exports = $48a34b0e52848244$var$isSymbol;

});


parcelRegister("4fM1S", function(module, exports) {

var $gcb0x = parcelRequire("gcb0x");
/** Used to match property names within property paths. */ var $318dd1c33e26f88f$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $318dd1c33e26f88f$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $318dd1c33e26f88f$var$stringToPath = $gcb0x(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($318dd1c33e26f88f$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($318dd1c33e26f88f$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
module.exports = $318dd1c33e26f88f$var$stringToPath;

});
parcelRegister("gcb0x", function(module, exports) {

var $1cBPh = parcelRequire("1cBPh");
/** Used as the maximum memoize cache size. */ var $bca64e3c57a777c2$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $bca64e3c57a777c2$var$memoizeCapped(func) {
    var result = $1cBPh(func, function(key) {
        if (cache.size === $bca64e3c57a777c2$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = $bca64e3c57a777c2$var$memoizeCapped;

});
parcelRegister("1cBPh", function(module, exports) {

var $kekVz = parcelRequire("kekVz");
/** Error message constants. */ var $0e0440e81aa01ca2$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $0e0440e81aa01ca2$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($0e0440e81aa01ca2$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($0e0440e81aa01ca2$var$memoize.Cache || $kekVz);
    return memoized;
}
// Expose `MapCache`.
$0e0440e81aa01ca2$var$memoize.Cache = $kekVz;
module.exports = $0e0440e81aa01ca2$var$memoize;

});



parcelRegister("62oCn", function(module, exports) {

var $jkIZf = parcelRequire("jkIZf");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $4656069d2962907d$var$toString(value) {
    return value == null ? '' : $jkIZf(value);
}
module.exports = $4656069d2962907d$var$toString;

});
parcelRegister("jkIZf", function(module, exports) {

var $4btfk = parcelRequire("4btfk");

var $cRGCI = parcelRequire("cRGCI");

var $hVwEW = parcelRequire("hVwEW");

var $6eEhe = parcelRequire("6eEhe");
/** Used as references for various `Number` constants. */ var $e132c809fad01544$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $e132c809fad01544$var$symbolProto = $4btfk ? $4btfk.prototype : undefined, $e132c809fad01544$var$symbolToString = $e132c809fad01544$var$symbolProto ? $e132c809fad01544$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $e132c809fad01544$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($hVwEW(value)) // Recursively convert values (susceptible to call stack limits).
    return $cRGCI(value, $e132c809fad01544$var$baseToString) + '';
    if ($6eEhe(value)) return $e132c809fad01544$var$symbolToString ? $e132c809fad01544$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$e132c809fad01544$var$INFINITY ? '-0' : result;
}
module.exports = $e132c809fad01544$var$baseToString;

});
parcelRegister("cRGCI", function(module, exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $95db7f6b1a689d75$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = $95db7f6b1a689d75$var$arrayMap;

});




parcelRegister("bT5XG", function(module, exports) {

var $6eEhe = parcelRequire("6eEhe");
/** Used as references for various `Number` constants. */ var $8a79749b18a12424$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $8a79749b18a12424$var$toKey(value) {
    if (typeof value == 'string' || $6eEhe(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$8a79749b18a12424$var$INFINITY ? '-0' : result;
}
module.exports = $8a79749b18a12424$var$toKey;

});



parcelRegister("h1LbN", function(module, exports) {

var $cnjfS = parcelRequire("cnjfS");

var $jDUbG = parcelRequire("jDUbG");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $c6572275fbec34e3$var$hasIn(object, path) {
    return object != null && $jDUbG(object, path, $cnjfS);
}
module.exports = $c6572275fbec34e3$var$hasIn;

});
parcelRegister("cnjfS", function(module, exports) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $902691a9b85b7191$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = $902691a9b85b7191$var$baseHasIn;

});

parcelRegister("jDUbG", function(module, exports) {

var $6hGcP = parcelRequire("6hGcP");

var $hnI0l = parcelRequire("hnI0l");

var $hVwEW = parcelRequire("hVwEW");

var $hlO9Y = parcelRequire("hlO9Y");

var $5XGjw = parcelRequire("5XGjw");

var $bT5XG = parcelRequire("bT5XG");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $e4cd3e8514b20db6$var$hasPath(object, path, hasFunc) {
    path = $6hGcP(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $bT5XG(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $5XGjw(length) && $hlO9Y(key, length) && ($hVwEW(object) || $hnI0l(object));
}
module.exports = $e4cd3e8514b20db6$var$hasPath;

});



parcelRegister("19t6w", function(module, exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $0d6d35347db5b88b$var$identity(value) {
    return value;
}
module.exports = $0d6d35347db5b88b$var$identity;

});

parcelRegister("ihasg", function(module, exports) {

var $8nfve = parcelRequire("8nfve");

var $2YCT4 = parcelRequire("2YCT4");

var $5guOp = parcelRequire("5guOp");

var $bT5XG = parcelRequire("bT5XG");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $d4e1ecabb389b95b$var$property(path) {
    return $5guOp(path) ? $8nfve($bT5XG(path)) : $2YCT4(path);
}
module.exports = $d4e1ecabb389b95b$var$property;

});
parcelRegister("8nfve", function(module, exports) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $618c7f3d7c1649bd$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $618c7f3d7c1649bd$var$baseProperty;

});

parcelRegister("2YCT4", function(module, exports) {

var $krRFz = parcelRequire("krRFz");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $22af598ae7b95cce$var$basePropertyDeep(path) {
    return function(object) {
        return $krRFz(object, path);
    };
}
module.exports = $22af598ae7b95cce$var$basePropertyDeep;

});





parcelRegister("aBwLi", function(module, exports) {
'use strict';

var $1CXFK = parcelRequire("1CXFK");

var $1ATYy = parcelRequire("1ATYy");

var $kyx4g = parcelRequire("kyx4g");

var $4oqry = parcelRequire("4oqry");

var $azOvE = parcelRequire("azOvE");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $7b86c5e8875e8014$var$createInstance(defaultConfig) {
    var context = new $kyx4g(defaultConfig);
    var instance = $1ATYy($kyx4g.prototype.request, context);
    // Copy axios.prototype to instance
    $1CXFK.extend(instance, $kyx4g.prototype, context);
    // Copy context to instance
    $1CXFK.extend(instance, context);
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $7b86c5e8875e8014$var$createInstance($4oqry(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
var $7b86c5e8875e8014$var$axios = $7b86c5e8875e8014$var$createInstance($azOvE);
// Expose Axios class to allow class inheritance
$7b86c5e8875e8014$var$axios.Axios = $kyx4g;

// Expose Cancel & CancelToken
$7b86c5e8875e8014$var$axios.Cancel = (parcelRequire("dTUuc"));

$7b86c5e8875e8014$var$axios.CancelToken = (parcelRequire("5Kp50"));

$7b86c5e8875e8014$var$axios.isCancel = (parcelRequire("jTdk4"));

$7b86c5e8875e8014$var$axios.VERSION = (parcelRequire("hVO2C")).version;
// Expose all/spread
$7b86c5e8875e8014$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$7b86c5e8875e8014$var$axios.spread = (parcelRequire("id2qT"));

// Expose isAxiosError
$7b86c5e8875e8014$var$axios.isAxiosError = (parcelRequire("dhck8"));
module.exports = $7b86c5e8875e8014$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $7b86c5e8875e8014$var$axios;

});
parcelRegister("1CXFK", function(module, exports) {
'use strict';

var $1ATYy = parcelRequire("1ATYy");
// utils is a library of generic helper functions non-specific to axios
var $12f7a0b72a2c1357$var$toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $12f7a0b72a2c1357$var$isArray(val) {
    return Array.isArray(val);
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $12f7a0b72a2c1357$var$isUndefined(val) {
    return typeof val === 'undefined';
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $12f7a0b72a2c1357$var$isBuffer(val) {
    return val !== null && !$12f7a0b72a2c1357$var$isUndefined(val) && val.constructor !== null && !$12f7a0b72a2c1357$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function $12f7a0b72a2c1357$var$isArrayBuffer(val) {
    return $12f7a0b72a2c1357$var$toString.call(val) === '[object ArrayBuffer]';
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $12f7a0b72a2c1357$var$isFormData(val) {
    return $12f7a0b72a2c1357$var$toString.call(val) === '[object FormData]';
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $12f7a0b72a2c1357$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $12f7a0b72a2c1357$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $12f7a0b72a2c1357$var$isString(val) {
    return typeof val === 'string';
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $12f7a0b72a2c1357$var$isNumber(val) {
    return typeof val === 'number';
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $12f7a0b72a2c1357$var$isObject(val) {
    return val !== null && typeof val === 'object';
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function $12f7a0b72a2c1357$var$isPlainObject(val) {
    if ($12f7a0b72a2c1357$var$toString.call(val) !== '[object Object]') return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function $12f7a0b72a2c1357$var$isDate(val) {
    return $12f7a0b72a2c1357$var$toString.call(val) === '[object Date]';
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function $12f7a0b72a2c1357$var$isFile(val) {
    return $12f7a0b72a2c1357$var$toString.call(val) === '[object File]';
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function $12f7a0b72a2c1357$var$isBlob(val) {
    return $12f7a0b72a2c1357$var$toString.call(val) === '[object Blob]';
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $12f7a0b72a2c1357$var$isFunction(val) {
    return $12f7a0b72a2c1357$var$toString.call(val) === '[object Function]';
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $12f7a0b72a2c1357$var$isStream(val) {
    return $12f7a0b72a2c1357$var$isObject(val) && $12f7a0b72a2c1357$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function $12f7a0b72a2c1357$var$isURLSearchParams(val) {
    return $12f7a0b72a2c1357$var$toString.call(val) === '[object URLSearchParams]';
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $12f7a0b72a2c1357$var$trim(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $12f7a0b72a2c1357$var$isStandardBrowserEnv() {
    if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' || navigator.product === 'NativeScript' || navigator.product === 'NS')) return false;
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $12f7a0b72a2c1357$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($12f7a0b72a2c1357$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $12f7a0b72a2c1357$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if ($12f7a0b72a2c1357$var$isPlainObject(result[key]) && $12f7a0b72a2c1357$var$isPlainObject(val)) result[key] = $12f7a0b72a2c1357$var$merge(result[key], val);
        else if ($12f7a0b72a2c1357$var$isPlainObject(val)) result[key] = $12f7a0b72a2c1357$var$merge({}, val);
        else if ($12f7a0b72a2c1357$var$isArray(val)) result[key] = val.slice();
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$12f7a0b72a2c1357$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $12f7a0b72a2c1357$var$extend(a, b, thisArg) {
    $12f7a0b72a2c1357$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === 'function') a[key] = $1ATYy(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function $12f7a0b72a2c1357$var$stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
}
module.exports = {
    isArray: $12f7a0b72a2c1357$var$isArray,
    isArrayBuffer: $12f7a0b72a2c1357$var$isArrayBuffer,
    isBuffer: $12f7a0b72a2c1357$var$isBuffer,
    isFormData: $12f7a0b72a2c1357$var$isFormData,
    isArrayBufferView: $12f7a0b72a2c1357$var$isArrayBufferView,
    isString: $12f7a0b72a2c1357$var$isString,
    isNumber: $12f7a0b72a2c1357$var$isNumber,
    isObject: $12f7a0b72a2c1357$var$isObject,
    isPlainObject: $12f7a0b72a2c1357$var$isPlainObject,
    isUndefined: $12f7a0b72a2c1357$var$isUndefined,
    isDate: $12f7a0b72a2c1357$var$isDate,
    isFile: $12f7a0b72a2c1357$var$isFile,
    isBlob: $12f7a0b72a2c1357$var$isBlob,
    isFunction: $12f7a0b72a2c1357$var$isFunction,
    isStream: $12f7a0b72a2c1357$var$isStream,
    isURLSearchParams: $12f7a0b72a2c1357$var$isURLSearchParams,
    isStandardBrowserEnv: $12f7a0b72a2c1357$var$isStandardBrowserEnv,
    forEach: $12f7a0b72a2c1357$var$forEach,
    merge: $12f7a0b72a2c1357$var$merge,
    extend: $12f7a0b72a2c1357$var$extend,
    trim: $12f7a0b72a2c1357$var$trim,
    stripBOM: $12f7a0b72a2c1357$var$stripBOM
};

});
parcelRegister("1ATYy", function(module, exports) {
'use strict';
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRegister("kyx4g", function(module, exports) {
'use strict';

var $1CXFK = parcelRequire("1CXFK");

var $jjMyd = parcelRequire("jjMyd");

var $gSNBF = parcelRequire("gSNBF");

var $6Qs0m = parcelRequire("6Qs0m");

var $4oqry = parcelRequire("4oqry");

var $frybV = parcelRequire("frybV");
var $ef70a23721bc3e0c$var$validators = $frybV.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $ef70a23721bc3e0c$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $gSNBF(),
        response: new $gSNBF()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $ef70a23721bc3e0c$var$Axios.prototype.request = function request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === 'string') {
        config = config || {};
        config.url = configOrUrl;
    } else config = configOrUrl || {};
    if (!config.url) throw new Error('Provided config url is not valid');
    config = $4oqry(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = 'get';
    var transitional = config.transitional;
    if (transitional !== undefined) $frybV.assertOptions(transitional, {
        silentJSONParsing: $ef70a23721bc3e0c$var$validators.transitional($ef70a23721bc3e0c$var$validators.boolean),
        forcedJSONParsing: $ef70a23721bc3e0c$var$validators.transitional($ef70a23721bc3e0c$var$validators.boolean),
        clarifyTimeoutError: $ef70a23721bc3e0c$var$validators.transitional($ef70a23721bc3e0c$var$validators.boolean)
    }, false);
    // filter out skipped interceptors
    var requestInterceptorChain = [];
    var synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    var responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    var promise;
    if (!synchronousRequestInterceptors) {
        var chain = [
            $6Qs0m,
            undefined
        ];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while(chain.length)promise = promise.then(chain.shift(), chain.shift());
        return promise;
    }
    var newConfig = config;
    while(requestInterceptorChain.length){
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
            newConfig = onFulfilled(newConfig);
        } catch (error) {
            onRejected(error);
            break;
        }
    }
    try {
        promise = $6Qs0m(newConfig);
    } catch (error) {
        return Promise.reject(error);
    }
    while(responseInterceptorChain.length)promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
    return promise;
};
$ef70a23721bc3e0c$var$Axios.prototype.getUri = function getUri(config) {
    if (!config.url) throw new Error('Provided config url is not valid');
    config = $4oqry(this.defaults, config);
    return $jjMyd(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};
// Provide aliases for supported request methods
$1CXFK.forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $ef70a23721bc3e0c$var$Axios.prototype[method] = function(url, config) {
        return this.request($4oqry(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
$1CXFK.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ $ef70a23721bc3e0c$var$Axios.prototype[method] = function(url, data, config) {
        return this.request($4oqry(config || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});
module.exports = $ef70a23721bc3e0c$var$Axios;

});
parcelRegister("jjMyd", function(module, exports) {
'use strict';

var $1CXFK = parcelRequire("1CXFK");
function $e10573da251b51e8$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($1CXFK.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $1CXFK.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === 'undefined') return;
            if ($1CXFK.isArray(val)) key = key + '[]';
            else val = [
                val
            ];
            $1CXFK.forEach(val, function parseValue(v) {
                if ($1CXFK.isDate(v)) v = v.toISOString();
                else if ($1CXFK.isObject(v)) v = JSON.stringify(v);
                parts.push($e10573da251b51e8$var$encode(key) + '=' + $e10573da251b51e8$var$encode(v));
            });
        });
        serializedParams = parts.join('&');
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
};

});

parcelRegister("gSNBF", function(module, exports) {
'use strict';

var $1CXFK = parcelRequire("1CXFK");
function $c4a82b4f9efbda3e$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $c4a82b4f9efbda3e$var$InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $c4a82b4f9efbda3e$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $c4a82b4f9efbda3e$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $1CXFK.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $c4a82b4f9efbda3e$var$InterceptorManager;

});

parcelRegister("6Qs0m", function(module, exports) {
'use strict';

var $1CXFK = parcelRequire("1CXFK");

var $gQYaB = parcelRequire("gQYaB");

var $jTdk4 = parcelRequire("jTdk4");

var $azOvE = parcelRequire("azOvE");

var $dTUuc = parcelRequire("dTUuc");
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ function $4fbd52988827b1fd$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new $dTUuc('canceled');
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $4fbd52988827b1fd$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $gQYaB.call(config, config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $1CXFK.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $1CXFK.forEach([
        'delete',
        'get',
        'head',
        'post',
        'put',
        'patch',
        'common'
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $azOvE.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $4fbd52988827b1fd$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $gQYaB.call(config, response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$jTdk4(reason)) {
            $4fbd52988827b1fd$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $gQYaB.call(config, reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRegister("gQYaB", function(module, exports) {
'use strict';

var $1CXFK = parcelRequire("1CXFK");

var $azOvE = parcelRequire("azOvE");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    var context = this || $azOvE;
    /*eslint no-param-reassign:0*/ $1CXFK.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers);
    });
    return data;
};

});
parcelRegister("azOvE", function(module, exports) {
'use strict';

var $1CXFK = parcelRequire("1CXFK");

var $kj4t5 = parcelRequire("kj4t5");

var $2G1oX = parcelRequire("2G1oX");
var $7b345a63e52f4594$var$DEFAULT_CONTENT_TYPE = {
    'Content-Type': 'application/x-www-form-urlencoded'
};
function $7b345a63e52f4594$var$setContentTypeIfUnset(headers, value) {
    if (!$1CXFK.isUndefined(headers) && $1CXFK.isUndefined(headers['Content-Type'])) headers['Content-Type'] = value;
}

function $7b345a63e52f4594$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== 'undefined') // For browsers use XHR adapter
    adapter = (parcelRequire("1DRzM"));
    return adapter;
}
function $7b345a63e52f4594$var$stringifySafely(rawValue, parser, encoder) {
    if ($1CXFK.isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return $1CXFK.trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
var $7b345a63e52f4594$var$defaults = {
    transitional: {
        silentJSONParsing: true,
        forcedJSONParsing: true,
        clarifyTimeoutError: false
    },
    adapter: $7b345a63e52f4594$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $kj4t5(headers, 'Accept');
            $kj4t5(headers, 'Content-Type');
            if ($1CXFK.isFormData(data) || $1CXFK.isArrayBuffer(data) || $1CXFK.isBuffer(data) || $1CXFK.isStream(data) || $1CXFK.isFile(data) || $1CXFK.isBlob(data)) return data;
            if ($1CXFK.isArrayBufferView(data)) return data.buffer;
            if ($1CXFK.isURLSearchParams(data)) {
                $7b345a63e52f4594$var$setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
                return data.toString();
            }
            if ($1CXFK.isObject(data) || headers && headers['Content-Type'] === 'application/json') {
                $7b345a63e52f4594$var$setContentTypeIfUnset(headers, 'application/json');
                return $7b345a63e52f4594$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional || $7b345a63e52f4594$var$defaults.transitional;
            var silentJSONParsing = transitional && transitional.silentJSONParsing;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';
            if (strictJSONParsing || forcedJSONParsing && $1CXFK.isString(data) && data.length) try {
                return JSON.parse(data);
            } catch (e) {
                if (strictJSONParsing) {
                    if (e.name === 'SyntaxError') throw $2G1oX(e, this, 'E_JSON_PARSE');
                    throw e;
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            'Accept': 'application/json, text/plain, */*'
        }
    }
};
$1CXFK.forEach([
    'delete',
    'get',
    'head'
], function forEachMethodNoData(method) {
    $7b345a63e52f4594$var$defaults.headers[method] = {};
});
$1CXFK.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    $7b345a63e52f4594$var$defaults.headers[method] = $1CXFK.merge($7b345a63e52f4594$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $7b345a63e52f4594$var$defaults;

});
parcelRegister("kj4t5", function(module, exports) {
'use strict';

var $1CXFK = parcelRequire("1CXFK");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $1CXFK.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRegister("2G1oX", function(module, exports) {
'use strict';
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module.exports = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) error.code = code;
    error.request = request;
    error.response = response;
    error.isAxiosError = true;
    error.toJSON = function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    };
    return error;
};

});

parcelRegister("1DRzM", function(module, exports) {
'use strict';

var $1CXFK = parcelRequire("1CXFK");

var $hiqk5 = parcelRequire("hiqk5");

var $aK3HT = parcelRequire("aK3HT");

var $jjMyd = parcelRequire("jjMyd");

var $7TMUb = parcelRequire("7TMUb");

var $pMlbu = parcelRequire("pMlbu");

var $8XL79 = parcelRequire("8XL79");

var $1yUnH = parcelRequire("1yUnH");

var $azOvE = parcelRequire("azOvE");

var $dTUuc = parcelRequire("dTUuc");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        var onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener('abort', onCanceled);
        }
        if ($1CXFK.isFormData(requestData)) delete requestHeaders['Content-Type']; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || '';
            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
            requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
        }
        var fullPath = $7TMUb(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $jjMyd(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = 'getAllResponseHeaders' in request ? $pMlbu(request.getAllResponseHeaders()) : null;
            var responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $hiqk5(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject($1yUnH('Request aborted', config, 'ECONNABORTED', request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject($1yUnH('Network Error', config, null, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
            var transitional = config.transitional || $azOvE.transitional;
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject($1yUnH(timeoutErrorMessage, config, transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED', request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($1CXFK.isStandardBrowserEnv()) {
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $8XL79(fullPath)) && config.xsrfCookieName ? $aK3HT.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ('setRequestHeader' in request) $1CXFK.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$1CXFK.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === 'function') request.addEventListener('progress', config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === 'function' && request.upload) request.upload.addEventListener('progress', config.onUploadProgress);
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = function(cancel) {
                if (!request) return;
                reject(!cancel || cancel && cancel.type ? new $dTUuc('canceled') : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
        }
        if (!requestData) requestData = null;
        // Send the request
        request.send(requestData);
    });
};

});
parcelRegister("hiqk5", function(module, exports) {
'use strict';

var $1yUnH = parcelRequire("1yUnH");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject($1yUnH('Request failed with status code ' + response.status, response.config, null, response.request, response));
};

});
parcelRegister("1yUnH", function(module, exports) {
'use strict';

var $2G1oX = parcelRequire("2G1oX");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module.exports = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return $2G1oX(error, config, code, request, response);
};

});


parcelRegister("aK3HT", function(module, exports) {
'use strict';

var $1CXFK = parcelRequire("1CXFK");
module.exports = $1CXFK.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + '=' + encodeURIComponent(value));
            if ($1CXFK.isNumber(expires)) cookie.push('expires=' + new Date(expires).toGMTString());
            if ($1CXFK.isString(path)) cookie.push('path=' + path);
            if ($1CXFK.isString(domain)) cookie.push('domain=' + domain);
            if (secure === true) cookie.push('secure');
            document.cookie = cookie.join('; ');
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, '', Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});

parcelRegister("7TMUb", function(module, exports) {
'use strict';

var $g1o2z = parcelRequire("g1o2z");

var $12P60 = parcelRequire("12P60");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$g1o2z(requestedURL)) return $12P60(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRegister("g1o2z", function(module, exports) {
'use strict';
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};

});

parcelRegister("12P60", function(module, exports) {
'use strict';
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
};

});


parcelRegister("pMlbu", function(module, exports) {
'use strict';

var $1CXFK = parcelRequire("1CXFK");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $04d7d55dce07a0b9$var$ignoreDuplicateOf = [
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $1CXFK.forEach(headers.split('\n'), function parser(line) {
        i = line.indexOf(':');
        key = $1CXFK.trim(line.substr(0, i)).toLowerCase();
        val = $1CXFK.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $04d7d55dce07a0b9$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === 'set-cookie') parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
        }
    });
    return parsed;
};

});

parcelRegister("8XL79", function(module, exports) {
'use strict';

var $1CXFK = parcelRequire("1CXFK");
module.exports = $1CXFK.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute('href', href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute('href', href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $1CXFK.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});

parcelRegister("dTUuc", function(module, exports) {
'use strict';
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $a1ec3a669a3ca6c1$var$Cancel(message) {
    this.message = message;
}
$a1ec3a669a3ca6c1$var$Cancel.prototype.toString = function toString() {
    return 'Cancel' + (this.message ? ': ' + this.message : '');
};
$a1ec3a669a3ca6c1$var$Cancel.prototype.__CANCEL__ = true;
module.exports = $a1ec3a669a3ca6c1$var$Cancel;

});




parcelRegister("jTdk4", function(module, exports) {
'use strict';
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});


parcelRegister("4oqry", function(module, exports) {
'use strict';

var $1CXFK = parcelRequire("1CXFK");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    function getMergedValue(target, source) {
        if ($1CXFK.isPlainObject(target) && $1CXFK.isPlainObject(source)) return $1CXFK.merge(target, source);
        else if ($1CXFK.isPlainObject(source)) return $1CXFK.merge({}, source);
        else if ($1CXFK.isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(prop) {
        if (!$1CXFK.isUndefined(config2[prop])) return getMergedValue(config1[prop], config2[prop]);
        else if (!$1CXFK.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(prop) {
        if (!$1CXFK.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(prop) {
        if (!$1CXFK.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
        else if (!$1CXFK.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(prop) {
        if (prop in config2) return getMergedValue(config1[prop], config2[prop]);
        else if (prop in config1) return getMergedValue(undefined, config1[prop]);
    }
    var mergeMap = {
        'url': valueFromConfig2,
        'method': valueFromConfig2,
        'data': valueFromConfig2,
        'baseURL': defaultToConfig2,
        'transformRequest': defaultToConfig2,
        'transformResponse': defaultToConfig2,
        'paramsSerializer': defaultToConfig2,
        'timeout': defaultToConfig2,
        'timeoutMessage': defaultToConfig2,
        'withCredentials': defaultToConfig2,
        'adapter': defaultToConfig2,
        'responseType': defaultToConfig2,
        'xsrfCookieName': defaultToConfig2,
        'xsrfHeaderName': defaultToConfig2,
        'onUploadProgress': defaultToConfig2,
        'onDownloadProgress': defaultToConfig2,
        'decompress': defaultToConfig2,
        'maxContentLength': defaultToConfig2,
        'maxBodyLength': defaultToConfig2,
        'transport': defaultToConfig2,
        'httpAgent': defaultToConfig2,
        'httpsAgent': defaultToConfig2,
        'cancelToken': defaultToConfig2,
        'socketPath': defaultToConfig2,
        'responseEncoding': defaultToConfig2,
        'validateStatus': mergeDirectKeys
    };
    $1CXFK.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
        var merge = mergeMap[prop] || mergeDeepProperties;
        var configValue = merge(prop);
        $1CXFK.isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
};

});

parcelRegister("frybV", function(module, exports) {
'use strict';

var $hVO2C = parcelRequire("hVO2C");
var $b3e3e64f053008a2$require$VERSION = $hVO2C.version;
var $b3e3e64f053008a2$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach(function(type, i) {
    $b3e3e64f053008a2$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
var $b3e3e64f053008a2$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */ $b3e3e64f053008a2$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + $b3e3e64f053008a2$require$VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new Error(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')));
        if (version && !$b3e3e64f053008a2$var$deprecatedWarnings[opt]) {
            $b3e3e64f053008a2$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */ function $b3e3e64f053008a2$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new TypeError('options must be an object');
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new TypeError('option ' + opt + ' must be ' + result);
            continue;
        }
        if (allowUnknown !== true) throw Error('Unknown option ' + opt);
    }
}
module.exports = {
    assertOptions: $b3e3e64f053008a2$var$assertOptions,
    validators: $b3e3e64f053008a2$var$validators
};

});
parcelRegister("hVO2C", function(module, exports) {
module.exports = {
    "version": "0.25.0"
};

});



parcelRegister("5Kp50", function(module, exports) {
'use strict';

var $dTUuc = parcelRequire("dTUuc");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $42f4b3f3b90cbf78$var$CancelToken(executor) {
    if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    // eslint-disable-next-line func-names
    this.promise.then(function(cancel) {
        if (!token._listeners) return;
        var i;
        var l = token._listeners.length;
        for(i = 0; i < l; i++)token._listeners[i](cancel);
        token._listeners = null;
    });
    // eslint-disable-next-line func-names
    this.promise.then = function(onfulfilled) {
        var _resolve;
        // eslint-disable-next-line func-names
        var promise = new Promise(function(resolve) {
            token.subscribe(resolve);
            _resolve = resolve;
        }).then(onfulfilled);
        promise.cancel = function reject() {
            token.unsubscribe(_resolve);
        };
        return promise;
    };
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $dTUuc(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ $42f4b3f3b90cbf78$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Subscribe to the cancel signal
 */ $42f4b3f3b90cbf78$var$CancelToken.prototype.subscribe = function subscribe(listener) {
    if (this.reason) {
        listener(this.reason);
        return;
    }
    if (this._listeners) this._listeners.push(listener);
    else this._listeners = [
        listener
    ];
};
/**
 * Unsubscribe from the cancel signal
 */ $42f4b3f3b90cbf78$var$CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
    if (!this._listeners) return;
    var index = this._listeners.indexOf(listener);
    if (index !== -1) this._listeners.splice(index, 1);
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $42f4b3f3b90cbf78$var$CancelToken.source = function source() {
    var cancel;
    var token = new $42f4b3f3b90cbf78$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $42f4b3f3b90cbf78$var$CancelToken;

});

parcelRegister("id2qT", function(module, exports) {
'use strict';
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});

parcelRegister("dhck8", function(module, exports) {
'use strict';

var $1CXFK = parcelRequire("1CXFK");
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module.exports = function isAxiosError(payload) {
    return $1CXFK.isObject(payload) && payload.isAxiosError === true;
};

});


parcelRegister("jlsPO", function(module, exports) {
'use strict';
var $e1565877d96cb226$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $cJx3x = parcelRequire("cJx3x");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $e1565877d96cb226$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $e1565877d96cb226$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $cJx3x();
};

});
parcelRegister("cJx3x", function(module, exports) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("7LrRy", function(module, exports) {
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ (function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = '4.17.21';
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            'ary',
            WRAP_ARY_FLAG
        ],
        [
            'bind',
            WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            WRAP_FLIP_FLAG
        ],
        [
            'partial',
            WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
        rsNonAstral + rsCombo + '?',
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join('|') + ')';
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
            rsBreak,
            rsUpper,
            '$'
        ].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
            rsBreak,
            rsUpper + rsMiscLower,
            '$'
        ].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty('length');
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split('');
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, 'defineProperty');
                func({}, '', {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object1, 'create');
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)['delete'](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data['delete'](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                'configurable': true,
                'enumerable': true,
                'value': value,
                'writable': true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + '');
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case 'drop':
                        start += size;
                        break;
                    case 'dropRight':
                        end -= size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') return;
            if (key == '__proto__') return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + '';
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = '_.' + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [
                    interceptor
                ],
                'thisArg': undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                'done': done,
                'value': value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        reverse
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == 'object' || type == 'function');
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == 'object';
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
            }
            if (typeof value != 'string') return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst('toLowerCase');
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst('toUpperCase');
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            'func': func,
                            'args': arguments,
                            'thisArg': object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return '';
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            'chain': false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                });
                return result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            'head',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            'initial',
            'tail'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == 'function') return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        'func': thru,
                        'args': [
                            interceptor
                        ],
                        'thisArg': undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            'pop',
            'push',
            'shift',
            'sort',
            'splice',
            'unshift'
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

/* eslint-disable func-names */ /* eslint-disable no-extra-semi */ /* eslint-disable prefer-rest-params */ /* eslint-disable no-underscore-dangle */ /* eslint-disable prefer-destructuring */ /* eslint-disable no-inner-declarations */ var $8bbd0dc1ab5297af$exports = {};
'use strict';

$8bbd0dc1ab5297af$exports = (parcelRequire("dARHh"));


parcelRequire("tZqWC");
var $f419cfc3d92fe631$exports = {};
'use strict';
function $f419cfc3d92fe631$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($f419cfc3d92fe631$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$f419cfc3d92fe631$var$checkDCE();

$f419cfc3d92fe631$exports = (parcelRequire("bIn0m"));



parcelRequire("tZqWC");

parcelRequire("tZqWC");

var $tZqWC = parcelRequire("tZqWC");


var $tZqWC = parcelRequire("tZqWC");
var $c800aa184e4b129d$export$cc80c08dc91f1c00 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createContext(null);
var $c800aa184e4b129d$export$2e2bcd8739ae039 = $c800aa184e4b129d$export$cc80c08dc91f1c00;


// Default to a dummy "batch" implementation that just runs the callback
function $6d06c8b9e571b6e5$var$defaultNoopBatch(callback) {
    callback();
}
var $6d06c8b9e571b6e5$var$batch = $6d06c8b9e571b6e5$var$defaultNoopBatch; // Allow injecting another batching function later
var $6d06c8b9e571b6e5$export$4b9874722d0da7bc = function setBatch(newBatch) {
    return $6d06c8b9e571b6e5$var$batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings
var $6d06c8b9e571b6e5$export$fc47d4c0ba3bd2c6 = function getBatch() {
    return $6d06c8b9e571b6e5$var$batch;
};


// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $86ee9a46dd49bc62$var$createListenerCollection() {
    var batch = (0, $6d06c8b9e571b6e5$export$fc47d4c0ba3bd2c6)();
    var first = null;
    var last = null;
    return {
        clear: function clear() {
            first = null;
            last = null;
        },
        notify: function notify() {
            batch(function() {
                var listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get: function get() {
            var listeners = [];
            var listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe: function subscribe(callback) {
            var isSubscribed = true;
            var listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $86ee9a46dd49bc62$var$nullListeners = {
    notify: function notify() {},
    get: function get() {
        return [];
    }
};
function $86ee9a46dd49bc62$export$d567d2b9af322f8f(store, parentSub) {
    var unsubscribe;
    var listeners = $86ee9a46dd49bc62$var$nullListeners;
    function addNestedSub(listener) {
        trySubscribe();
        return listeners.subscribe(listener);
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return Boolean(unsubscribe);
    }
    function trySubscribe() {
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $86ee9a46dd49bc62$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        if (unsubscribe) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $86ee9a46dd49bc62$var$nullListeners;
        }
    }
    var subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribe,
        tryUnsubscribe: tryUnsubscribe,
        getListeners: function getListeners() {
            return listeners;
        }
    };
    return subscription;
}



var $tZqWC = parcelRequire("tZqWC");
var $ca9cd1747ebc2fbf$export$700979bc83e7db82 = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? (0, $tZqWC.useLayoutEffect) : (0, $tZqWC.useEffect);


function $44a4de761c3016e3$var$Provider(_ref) {
    var store = _ref.store, context = _ref.context, children = _ref.children;
    var contextValue = (0, $tZqWC.useMemo)(function() {
        var subscription = (0, $86ee9a46dd49bc62$export$d567d2b9af322f8f)(store);
        return {
            store: store,
            subscription: subscription
        };
    }, [
        store
    ]);
    var previousState = (0, $tZqWC.useMemo)(function() {
        return store.getState();
    }, [
        store
    ]);
    (0, $ca9cd1747ebc2fbf$export$700979bc83e7db82)(function() {
        var subscription = contextValue.subscription;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return function() {
            subscription.tryUnsubscribe();
            subscription.onStateChange = null;
        };
    }, [
        contextValue,
        previousState
    ]);
    var Context = context || (0, $c800aa184e4b129d$export$cc80c08dc91f1c00);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $44a4de761c3016e3$export$2e2bcd8739ae039 = $44a4de761c3016e3$var$Provider;


function $dda4d40cf5733033$export$2e2bcd8739ae039() {
    return $dda4d40cf5733033$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $dda4d40cf5733033$export$2e2bcd8739ae039.apply(null, arguments);
}


function $93b7456b56abf607$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}



var $7g5pF = parcelRequire("7g5pF");

var $tZqWC = parcelRequire("tZqWC");
var $59074d7e77493e4d$exports = {};
'use strict';

$59074d7e77493e4d$exports = (parcelRequire("1YBKS"));





var $16725376249d14af$var$_excluded = [
    "getDisplayName",
    "methodName",
    "renderCountProp",
    "shouldHandleStateChanges",
    "storeKey",
    "withRef",
    "forwardRef",
    "context"
], $16725376249d14af$var$_excluded2 = [
    "reactReduxForwardedRef"
];
var $16725376249d14af$var$EMPTY_ARRAY = [];
var $16725376249d14af$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $16725376249d14af$var$stringifyComponent = function stringifyComponent(Comp) {
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $16725376249d14af$var$storeStateUpdatesReducer(state, action) {
    var updateCount = state[1];
    return [
        action.payload,
        updateCount + 1
    ];
}
function $16725376249d14af$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $ca9cd1747ebc2fbf$export$700979bc83e7db82)(function() {
        return effectFunc.apply(void 0, effectArgs);
    }, dependencies);
}
function $16725376249d14af$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    lastChildProps.current = actualChildProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $16725376249d14af$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts
    var didUnsubscribe = false;
    var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    var checkForUpdates = function checkForUpdates() {
        if (didUnsubscribe) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
        var latestStoreState = store.getState();
        var newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render
            forceComponentUpdateDispatch({
                type: 'STORE_UPDATED',
                payload: {
                    error: error
                }
            });
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    var unsubscribeWrapper = function unsubscribeWrapper() {
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
}
var $16725376249d14af$var$initStateUpdates = function initStateUpdates() {
    return [
        null,
        0
    ];
};
function $16725376249d14af$export$2e2bcd8739ae039(/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
      export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
    Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
    Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/ selectorFactory, _ref) {
    if (_ref === void 0) _ref = {};
    var _ref2 = _ref, _ref2$getDisplayName = _ref2.getDisplayName, getDisplayName = _ref2$getDisplayName === void 0 ? function(name) {
        return "ConnectAdvanced(" + name + ")";
    } : _ref2$getDisplayName, _ref2$methodName = _ref2.methodName, methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName, _ref2$renderCountProp = _ref2.renderCountProp, renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp, _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges, shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta, _ref2$storeKey = _ref2.storeKey, storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey, _ref2$withRef = _ref2.withRef, withRef = _ref2$withRef === void 0 ? false : _ref2$withRef, _ref2$forwardRef = _ref2.forwardRef, forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef, _ref2$context = _ref2.context, context = _ref2$context === void 0 ? (0, $c800aa184e4b129d$export$cc80c08dc91f1c00) : _ref2$context, connectOptions = (0, $93b7456b56abf607$export$2e2bcd8739ae039)(_ref2, $16725376249d14af$var$_excluded);
    var customStoreWarningMessage;
    var Context = context;
    return function wrapWithConnect(WrappedComponent) {
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
        var displayName = getDisplayName(wrappedComponentName);
        var selectorFactoryOptions = (0, $dda4d40cf5733033$export$2e2bcd8739ae039)({}, connectOptions, {
            getDisplayName: getDisplayName,
            methodName: methodName,
            renderCountProp: renderCountProp,
            shouldHandleStateChanges: shouldHandleStateChanges,
            storeKey: storeKey,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent
        });
        var pure = connectOptions.pure;
        function createChildSelector(store) {
            return selectorFactory(store.dispatch, selectorFactoryOptions);
        } // If we aren't running in "pure" mode, we don't want to memoize values.
        // To avoid conditionally calling hooks, we fall back to a tiny wrapper
        // that just executes the given callback immediately.
        var usePureOnlyMemo = pure ? (0, $tZqWC.useMemo) : function(callback) {
            return callback();
        };
        function ConnectFunction(props) {
            var _useMemo = (0, $tZqWC.useMemo)(function() {
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                var reactReduxForwardedRef = props.reactReduxForwardedRef, wrapperProps = (0, $93b7456b56abf607$export$2e2bcd8739ae039)(props, $16725376249d14af$var$_excluded2);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]), propsContext = _useMemo[0], reactReduxForwardedRef = _useMemo[1], wrapperProps = _useMemo[2];
            var ContextToUse = (0, $tZqWC.useMemo)(function() {
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && (0, $59074d7e77493e4d$exports.isContextConsumer)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            var contextValue = (0, $tZqWC.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            var store = didStoreComeFromProps ? props.store : contextValue.store;
            var childPropsSelector = (0, $tZqWC.useMemo)(function() {
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return createChildSelector(store);
            }, [
                store
            ]);
            var _useMemo2 = (0, $tZqWC.useMemo)(function() {
                if (!shouldHandleStateChanges) return $16725376249d14af$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                var subscription = (0, $86ee9a46dd49bc62$export$d567d2b9af322f8f)(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]), subscription = _useMemo2[0], notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            var overriddenContextValue = (0, $tZqWC.useMemo)(function() {
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $dda4d40cf5733033$export$2e2bcd8739ae039)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // We need to force this wrapper component to re-render whenever a Redux store update
            // causes a change to the calculated child component props (or we caught an error in mapState)
            var _useReducer = (0, $tZqWC.useReducer)($16725376249d14af$var$storeStateUpdatesReducer, $16725376249d14af$var$EMPTY_ARRAY, $16725376249d14af$var$initStateUpdates), _useReducer$ = _useReducer[0], previousStateUpdateResult = _useReducer$[0], forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards
            if (previousStateUpdateResult && previousStateUpdateResult.error) throw previousStateUpdateResult.error;
             // Set up refs to coordinate values between the subscription effect and the render logic
            var lastChildProps = (0, $tZqWC.useRef)();
            var lastWrapperProps = (0, $tZqWC.useRef)(wrapperProps);
            var childPropsFromStoreUpdate = (0, $tZqWC.useRef)();
            var renderIsScheduled = (0, $tZqWC.useRef)(false);
            var actualChildProps = usePureOnlyMemo(function() {
                // Tricky logic here:
                // - This render may have been triggered by a Redux store update that produced new child props
                // - However, we may have gotten new wrapper props after that
                // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                 // TODO We're reading the store directly in render() here. Bad idea?
                // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                // to determine what the child props should be.
                return childPropsSelector(store.getState(), wrapperProps);
            }, [
                store,
                previousStateUpdateResult,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            $16725376249d14af$var$useIsomorphicLayoutEffectWithArgs($16725376249d14af$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                actualChildProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]); // Our re-subscribe logic only runs when the store/subscription setup changes
            $16725376249d14af$var$useIsomorphicLayoutEffectWithArgs($16725376249d14af$var$subscribeUpdates, [
                shouldHandleStateChanges,
                store,
                subscription,
                childPropsSelector,
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                childPropsFromStoreUpdate,
                notifyNestedSubs,
                forceComponentUpdateDispatch
            ], [
                store,
                subscription,
                childPropsSelector
            ]); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            var renderedWrappedComponent = (0, $tZqWC.useMemo)(function() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(WrappedComponent, (0, $dda4d40cf5733033$export$2e2bcd8739ae039)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                }));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            var renderedChild = (0, $tZqWC.useMemo)(function() {
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.
        var Connect = pure ? (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).memo(ConnectFunction) : ConnectFunction;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            var forwarded = (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).forwardRef(function forwardConnectRef(props, ref) {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Connect, (0, $dda4d40cf5733033$export$2e2bcd8739ae039)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($7g5pF)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($7g5pF)))(Connect, WrappedComponent);
    };
}






function $1a47d131d4cd13dc$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $1a47d131d4cd13dc$export$2e2bcd8739ae039(objA, objB) {
    if ($1a47d131d4cd13dc$var$is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$1a47d131d4cd13dc$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}


function $01b1486285ebb912$export$2e2bcd8739ae039(actionCreators, dispatch) {
    var boundActionCreators = {};
    var _loop = function _loop(key) {
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = function() {
            return dispatch(actionCreator.apply(void 0, arguments));
        };
    };
    for(var key in actionCreators)_loop(key);
    return boundActionCreators;
}


/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $abf642e35390d4b4$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}


/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $b2e34002d416f828$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }


function $87041fbcd492919e$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $abf642e35390d4b4$export$2e2bcd8739ae039)(value)) (0, $b2e34002d416f828$export$2e2bcd8739ae039)(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
}


function $ab176739fdd158e6$export$710f7c60f68acd3e(getConstant) {
    return function initConstantSelector(dispatch, options) {
        var constant = getConstant(dispatch, options);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $ab176739fdd158e6$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $ab176739fdd158e6$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, _ref) {
        var displayName = _ref.displayName;
        var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $ab176739fdd158e6$export$e561b938df936d57(mapToProps);
            var props = proxy(stateOrDispatch, ownProps);
            if (typeof props === 'function') {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $ab176739fdd158e6$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}


function $46ebfbaa36287ccd$export$a9f27b4b187c1166(mapDispatchToProps) {
    return typeof mapDispatchToProps === 'function' ? (0, $ab176739fdd158e6$export$8d46c7f53c8c602f)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function $46ebfbaa36287ccd$export$ba20d1a7aa0c4a90(mapDispatchToProps) {
    return !mapDispatchToProps ? (0, $ab176739fdd158e6$export$710f7c60f68acd3e)(function(dispatch) {
        return {
            dispatch: dispatch
        };
    }) : undefined;
}
function $46ebfbaa36287ccd$export$94a6e55709d4d961(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, $ab176739fdd158e6$export$710f7c60f68acd3e)(function(dispatch) {
        return (0, $01b1486285ebb912$export$2e2bcd8739ae039)(mapDispatchToProps, dispatch);
    }) : undefined;
}
var $46ebfbaa36287ccd$export$2e2bcd8739ae039 = [
    $46ebfbaa36287ccd$export$a9f27b4b187c1166,
    $46ebfbaa36287ccd$export$ba20d1a7aa0c4a90,
    $46ebfbaa36287ccd$export$94a6e55709d4d961
];



function $dcd801f855fc8e99$export$23fc470827b14aa(mapStateToProps) {
    return typeof mapStateToProps === 'function' ? (0, $ab176739fdd158e6$export$8d46c7f53c8c602f)(mapStateToProps, 'mapStateToProps') : undefined;
}
function $dcd801f855fc8e99$export$514bc8c1a53c1d66(mapStateToProps) {
    return !mapStateToProps ? (0, $ab176739fdd158e6$export$710f7c60f68acd3e)(function() {
        return {};
    }) : undefined;
}
var $dcd801f855fc8e99$export$2e2bcd8739ae039 = [
    $dcd801f855fc8e99$export$23fc470827b14aa,
    $dcd801f855fc8e99$export$514bc8c1a53c1d66
];




function $7c36ffa4fae85c0c$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    return (0, $dda4d40cf5733033$export$2e2bcd8739ae039)({}, ownProps, stateProps, dispatchProps);
}
function $7c36ffa4fae85c0c$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, _ref) {
        var displayName = _ref.displayName, pure = _ref.pure, areMergedPropsEqual = _ref.areMergedPropsEqual;
        var hasRunOnce = false;
        var mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $7c36ffa4fae85c0c$export$d61b680184bc3f00(mergeProps) {
    return typeof mergeProps === 'function' ? $7c36ffa4fae85c0c$export$5b105939c84b5234(mergeProps) : undefined;
}
function $7c36ffa4fae85c0c$export$a13ba70ef50dda6d(mergeProps) {
    return !mergeProps ? function() {
        return $7c36ffa4fae85c0c$export$691c327fc30bc857;
    } : undefined;
}
var $7c36ffa4fae85c0c$export$2e2bcd8739ae039 = [
    $7c36ffa4fae85c0c$export$d61b680184bc3f00,
    $7c36ffa4fae85c0c$export$a13ba70ef50dda6d
];




function $755b1351dba08002$var$verify(selector, methodName, displayName) {
    if (!selector) throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
    else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
        if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) (0, $b2e34002d416f828$export$2e2bcd8739ae039)("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
}
function $755b1351dba08002$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
    $755b1351dba08002$var$verify(mapStateToProps, 'mapStateToProps', displayName);
    $755b1351dba08002$var$verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
    $755b1351dba08002$var$verify(mergeProps, 'mergeProps', displayName);
}


var $e647c11232dc41f2$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $e647c11232dc41f2$export$68c2c73bda6aa4b0(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
    return function impureFinalPropsSelector(state, ownProps) {
        return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
    };
}
function $e647c11232dc41f2$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
    var areStatesEqual = _ref.areStatesEqual, areOwnPropsEqual = _ref.areOwnPropsEqual, areStatePropsEqual = _ref.areStatePropsEqual;
    var hasRunAtLeastOnce = false;
    var state;
    var ownProps;
    var stateProps;
    var dispatchProps;
    var mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        var nextStateProps = mapStateToProps(state, ownProps);
        var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        var stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
} // TODO: Add more comments
function $e647c11232dc41f2$export$2e2bcd8739ae039(dispatch, _ref2) {
    var initMapStateToProps = _ref2.initMapStateToProps, initMapDispatchToProps = _ref2.initMapDispatchToProps, initMergeProps = _ref2.initMergeProps, options = (0, $93b7456b56abf607$export$2e2bcd8739ae039)(_ref2, $e647c11232dc41f2$var$_excluded);
    var mapStateToProps = initMapStateToProps(dispatch, options);
    var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    var mergeProps = initMergeProps(dispatch, options);
    var selectorFactory = options.pure ? $e647c11232dc41f2$export$d20c0c2ca6eb2b6f : $e647c11232dc41f2$export$68c2c73bda6aa4b0;
    return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}


var $9a02dcf7eea7138a$var$_excluded = [
    "pure",
    "areStatesEqual",
    "areOwnPropsEqual",
    "areStatePropsEqual",
    "areMergedPropsEqual"
];
/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */ function $9a02dcf7eea7138a$var$match(arg, factories, name) {
    for(var i = factories.length - 1; i >= 0; i--){
        var result = factories[i](arg);
        if (result) return result;
    }
    return function(dispatch, options) {
        throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
    };
}
function $9a02dcf7eea7138a$var$strictEqual(a, b) {
    return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
function $9a02dcf7eea7138a$export$9f9feb656dec1fc4(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$connectHOC = _ref.connectHOC, connectHOC = _ref$connectHOC === void 0 ? (0, $16725376249d14af$export$2e2bcd8739ae039) : _ref$connectHOC, _ref$mapStateToPropsF = _ref.mapStateToPropsFactories, mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? (0, $dcd801f855fc8e99$export$2e2bcd8739ae039) : _ref$mapStateToPropsF, _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories, mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? (0, $46ebfbaa36287ccd$export$2e2bcd8739ae039) : _ref$mapDispatchToPro, _ref$mergePropsFactor = _ref.mergePropsFactories, mergePropsFactories = _ref$mergePropsFactor === void 0 ? (0, $7c36ffa4fae85c0c$export$2e2bcd8739ae039) : _ref$mergePropsFactor, _ref$selectorFactory = _ref.selectorFactory, selectorFactory = _ref$selectorFactory === void 0 ? (0, $e647c11232dc41f2$export$2e2bcd8739ae039) : _ref$selectorFactory;
    return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
        if (_ref2 === void 0) _ref2 = {};
        var _ref3 = _ref2, _ref3$pure = _ref3.pure, pure = _ref3$pure === void 0 ? true : _ref3$pure, _ref3$areStatesEqual = _ref3.areStatesEqual, areStatesEqual = _ref3$areStatesEqual === void 0 ? $9a02dcf7eea7138a$var$strictEqual : _ref3$areStatesEqual, _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual, areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? (0, $1a47d131d4cd13dc$export$2e2bcd8739ae039) : _ref3$areOwnPropsEqua, _ref3$areStatePropsEq = _ref3.areStatePropsEqual, areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? (0, $1a47d131d4cd13dc$export$2e2bcd8739ae039) : _ref3$areStatePropsEq, _ref3$areMergedPropsE = _ref3.areMergedPropsEqual, areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? (0, $1a47d131d4cd13dc$export$2e2bcd8739ae039) : _ref3$areMergedPropsE, extraOptions = (0, $93b7456b56abf607$export$2e2bcd8739ae039)(_ref3, $9a02dcf7eea7138a$var$_excluded);
        var initMapStateToProps = $9a02dcf7eea7138a$var$match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
        var initMapDispatchToProps = $9a02dcf7eea7138a$var$match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
        var initMergeProps = $9a02dcf7eea7138a$var$match(mergeProps, mergePropsFactories, 'mergeProps');
        return connectHOC(selectorFactory, (0, $dda4d40cf5733033$export$2e2bcd8739ae039)({
            // used in error messages
            methodName: 'connect',
            // used to compute Connect's displayName from the wrapped component's displayName.
            getDisplayName: function getDisplayName(name) {
                return "Connect(" + name + ")";
            },
            // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
            shouldHandleStateChanges: Boolean(mapStateToProps),
            // passed through to selectorFactory
            initMapStateToProps: initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            pure: pure,
            areStatesEqual: areStatesEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areStatePropsEqual: areStatePropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        }, extraOptions));
    };
}
var $9a02dcf7eea7138a$export$2e2bcd8739ae039 = /*#__PURE__*/ $9a02dcf7eea7138a$export$9f9feb656dec1fc4();




var $tZqWC = parcelRequire("tZqWC");


var $tZqWC = parcelRequire("tZqWC");

function $ce8742bf036ecb86$export$c1275ca9a6fd3ec5() {
    var contextValue = (0, $tZqWC.useContext)((0, $c800aa184e4b129d$export$cc80c08dc91f1c00));
    return contextValue;
}


function $36fea69f56ae8106$export$671dba69185d0304(context) {
    if (context === void 0) context = (0, $c800aa184e4b129d$export$cc80c08dc91f1c00);
    var useReduxContext = context === (0, $c800aa184e4b129d$export$cc80c08dc91f1c00) ? (0, $ce8742bf036ecb86$export$c1275ca9a6fd3ec5) : function() {
        return (0, $tZqWC.useContext)(context);
    };
    return function useStore() {
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store;
        return store;
    };
}
var $36fea69f56ae8106$export$6ccbb43953eebf8 = /*#__PURE__*/ $36fea69f56ae8106$export$671dba69185d0304();


function $a748bab419689843$export$bc9b55530897c558(context) {
    if (context === void 0) context = (0, $c800aa184e4b129d$export$cc80c08dc91f1c00);
    var useStore = context === (0, $c800aa184e4b129d$export$cc80c08dc91f1c00) ? (0, $36fea69f56ae8106$export$6ccbb43953eebf8) : (0, $36fea69f56ae8106$export$671dba69185d0304)(context);
    return function useDispatch() {
        var store = useStore();
        return store.dispatch;
    };
}
var $a748bab419689843$export$8ad76b76a4c905f8 = /*#__PURE__*/ $a748bab419689843$export$bc9b55530897c558();



var $tZqWC = parcelRequire("tZqWC");




var $d8c95896af7851e3$var$refEquality = function refEquality(a, b) {
    return a === b;
};
function $d8c95896af7851e3$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
    var _useReducer = (0, $tZqWC.useReducer)(function(s) {
        return s + 1;
    }, 0), forceRender = _useReducer[1];
    var subscription = (0, $tZqWC.useMemo)(function() {
        return (0, $86ee9a46dd49bc62$export$d567d2b9af322f8f)(store, contextSub);
    }, [
        store,
        contextSub
    ]);
    var latestSubscriptionCallbackError = (0, $tZqWC.useRef)();
    var latestSelector = (0, $tZqWC.useRef)();
    var latestStoreState = (0, $tZqWC.useRef)();
    var latestSelectedState = (0, $tZqWC.useRef)();
    var storeState = store.getState();
    var selectedState;
    try {
        if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
            var newSelectedState = selector(storeState); // ensure latest selected state is reused so that a custom equality function can result in identical references
            if (latestSelectedState.current === undefined || !equalityFn(newSelectedState, latestSelectedState.current)) selectedState = newSelectedState;
            else selectedState = latestSelectedState.current;
        } else selectedState = latestSelectedState.current;
    } catch (err) {
        if (latestSubscriptionCallbackError.current) err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
        throw err;
    }
    (0, $ca9cd1747ebc2fbf$export$700979bc83e7db82)(function() {
        latestSelector.current = selector;
        latestStoreState.current = storeState;
        latestSelectedState.current = selectedState;
        latestSubscriptionCallbackError.current = undefined;
    });
    (0, $ca9cd1747ebc2fbf$export$700979bc83e7db82)(function() {
        function checkForUpdates() {
            try {
                var newStoreState = store.getState(); // Avoid calling selector multiple times if the store's state has not changed
                if (newStoreState === latestStoreState.current) return;
                var _newSelectedState = latestSelector.current(newStoreState);
                if (equalityFn(_newSelectedState, latestSelectedState.current)) return;
                latestSelectedState.current = _newSelectedState;
                latestStoreState.current = newStoreState;
            } catch (err) {
                // we ignore all errors here, since when the component
                // is re-rendered, the selectors are called again, and
                // will throw again, if neither props nor store state
                // changed
                latestSubscriptionCallbackError.current = err;
            }
            forceRender();
        }
        subscription.onStateChange = checkForUpdates;
        subscription.trySubscribe();
        checkForUpdates();
        return function() {
            return subscription.tryUnsubscribe();
        };
    }, [
        store,
        subscription
    ]);
    return selectedState;
}
function $d8c95896af7851e3$export$2b53f90d2bd1cbfb(context) {
    if (context === void 0) context = (0, $c800aa184e4b129d$export$cc80c08dc91f1c00);
    var useReduxContext = context === (0, $c800aa184e4b129d$export$cc80c08dc91f1c00) ? (0, $ce8742bf036ecb86$export$c1275ca9a6fd3ec5) : function() {
        return (0, $tZqWC.useContext)(context);
    };
    return function useSelector(selector, equalityFn) {
        if (equalityFn === void 0) equalityFn = $d8c95896af7851e3$var$refEquality;
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store, contextSub = _useReduxContext.subscription;
        var selectedState = $d8c95896af7851e3$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
        (0, $tZqWC.useDebugValue)(selectedState);
        return selectedState;
    };
}
var $d8c95896af7851e3$export$2105062e25df4afe = /*#__PURE__*/ $d8c95896af7851e3$export$2b53f90d2bd1cbfb();






/* eslint-disable import/no-unresolved */ 



// with standard React renderers (ReactDOM, React Native)
(0, $6d06c8b9e571b6e5$export$4b9874722d0da7bc)((0, $f419cfc3d92fe631$exports.unstable_batchedUpdates));



var $6bvDC = parcelRequire("6bvDC");
function $5a91684feabc84d2$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $5a91684feabc84d2$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $5a91684feabc84d2$export$2e2bcd8739ae039(o);
}



function $5e2e43cfe12f42fb$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $5a91684feabc84d2$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $5a91684feabc84d2$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $a05dbe7ffa1b9ce3$export$2e2bcd8739ae039(t) {
    var i = (0, $5e2e43cfe12f42fb$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $5a91684feabc84d2$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $271d31b42c64d81e$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $a05dbe7ffa1b9ce3$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}


function $bfc31086a22cafcf$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bfc31086a22cafcf$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bfc31086a22cafcf$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $271d31b42c64d81e$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $bfc31086a22cafcf$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $5c178e598efca549$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}
// Inlined version of the `symbol-observable` polyfill
var $5c178e598efca549$var$$$observable = function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $5c178e598efca549$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split('').join('.');
};
var $5c178e598efca549$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $5c178e598efca549$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $5c178e598efca549$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $5c178e598efca549$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $5c178e598efca549$var$isPlainObject(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $5c178e598efca549$var$miniKindOf(val) {
    if (val === void 0) return 'undefined';
    if (val === null) return 'null';
    var type = typeof val;
    switch(type){
        case 'boolean':
        case 'string':
        case 'number':
        case 'symbol':
        case 'function':
            return type;
    }
    if (Array.isArray(val)) return 'array';
    if ($5c178e598efca549$var$isDate(val)) return 'date';
    if ($5c178e598efca549$var$isError(val)) return 'error';
    var constructorName = $5c178e598efca549$var$ctorName(val);
    switch(constructorName){
        case 'Symbol':
        case 'Promise':
        case 'WeakMap':
        case 'WeakSet':
        case 'Map':
        case 'Set':
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}
function $5c178e598efca549$var$ctorName(val) {
    return typeof val.constructor === 'function' ? val.constructor.name : null;
}
function $5c178e598efca549$var$isError(val) {
    return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}
function $5c178e598efca549$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}
function $5c178e598efca549$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $5c178e598efca549$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') throw new Error($5c178e598efca549$var$formatProdErrorMessage(0));
    if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== 'undefined') {
        if (typeof enhancer !== 'function') throw new Error($5c178e598efca549$var$formatProdErrorMessage(1));
        return enhancer($5c178e598efca549$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== 'function') throw new Error($5c178e598efca549$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($5c178e598efca549$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== 'function') throw new Error($5c178e598efca549$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($5c178e598efca549$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($5c178e598efca549$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$5c178e598efca549$var$isPlainObject(action)) throw new Error($5c178e598efca549$var$formatProdErrorMessage(7));
        if (typeof action.type === 'undefined') throw new Error($5c178e598efca549$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($5c178e598efca549$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== 'function') throw new Error($5c178e598efca549$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $5c178e598efca549$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) throw new Error($5c178e598efca549$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$5c178e598efca549$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $5c178e598efca549$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$5c178e598efca549$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $5c178e598efca549$export$8928921ea2d3b126 = $5c178e598efca549$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $5c178e598efca549$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $5c178e598efca549$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $5c178e598efca549$export$4219e499db7ca678.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$5c178e598efca549$var$isPlainObject(inputState)) return "The " + argumentName + " has unexpected type of \"" + $5c178e598efca549$var$kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $5c178e598efca549$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
}
function $5c178e598efca549$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $5c178e598efca549$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === 'undefined') throw new Error($5c178e598efca549$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $5c178e598efca549$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === 'undefined') throw new Error($5c178e598efca549$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $5c178e598efca549$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === 'function') finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $5c178e598efca549$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === 'undefined') {
                var actionType = action && action.type;
                throw new Error($5c178e598efca549$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $5c178e598efca549$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $5c178e598efca549$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === 'function') return $5c178e598efca549$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== 'object' || actionCreators === null) throw new Error($5c178e598efca549$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = $5c178e598efca549$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $5c178e598efca549$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $5c178e598efca549$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($5c178e598efca549$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $5c178e598efca549$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $bfc31086a22cafcf$export$2e2bcd8739ae039)((0, $bfc31086a22cafcf$export$2e2bcd8739ae039)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}


// Cache implementation based on Erik Rasmussen's `lru-memoize`:
// https://github.com/erikras/lru-memoize
var $f17c24e54e60b024$var$NOT_FOUND = 'NOT_FOUND';
function $f17c24e54e60b024$var$createSingletonCache(equals) {
    var entry;
    return {
        get: function get(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $f17c24e54e60b024$var$NOT_FOUND;
        },
        put: function put(key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries: function getEntries() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function clear() {
            entry = undefined;
        }
    };
}
function $f17c24e54e60b024$var$createLruCache(maxSize, equals) {
    var entries = [];
    function get(key) {
        var cacheIndex = entries.findIndex(function(entry) {
            return equals(key, entry.key);
        }); // We found a cached entry
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        } // No entry found in cache, return sentinel
        return $f17c24e54e60b024$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $f17c24e54e60b024$var$NOT_FOUND) {
            // TODO Is unshift slow?
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $f17c24e54e60b024$export$e0b28855d0126ccc = function defaultEqualityCheck(a, b) {
    return a === b;
};
function $f17c24e54e60b024$export$823674481ed171f9(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
         // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
        var length = prev.length;
        for(var i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $f17c24e54e60b024$export$281bff7f05488aa2(func, equalityCheckOrOptions) {
    var providedOptions = typeof equalityCheckOrOptions === 'object' ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions$equa = providedOptions.equalityCheck, equalityCheck = _providedOptions$equa === void 0 ? $f17c24e54e60b024$export$e0b28855d0126ccc : _providedOptions$equa, _providedOptions$maxS = providedOptions.maxSize, maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS, resultEqualityCheck = providedOptions.resultEqualityCheck;
    var comparator = $f17c24e54e60b024$export$823674481ed171f9(equalityCheck);
    var cache = maxSize === 1 ? $f17c24e54e60b024$var$createSingletonCache(comparator) : $f17c24e54e60b024$var$createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons
    function memoized() {
        var value = cache.get(arguments);
        if (value === $f17c24e54e60b024$var$NOT_FOUND) {
            // @ts-ignore
            value = func.apply(null, arguments);
            if (resultEqualityCheck) {
                var entries = cache.getEntries();
                var matchingEntry = entries.find(function(entry) {
                    return resultEqualityCheck(entry.value, value);
                });
                if (matchingEntry) value = matchingEntry.value;
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = function() {
        return cache.clear();
    };
    return memoized;
}


function $6730822c14f67805$var$getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === 'function';
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep === 'function' ? "function " + (dep.name || 'unnamed') + "()" : typeof dep;
        }).join(', ');
        throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
    }
    return dependencies;
}
function $6730822c14f67805$export$5943f4447f6ef248(memoize) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    var createSelector = function createSelector() {
        for(var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var _recomputations = 0;
        var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
        // So, start by declaring the default value here.
        // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)
        var directlyPassedOptions = {
            memoizeOptions: undefined
        }; // Normally, the result func or "output selector" is the last arg
        var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object
        if (typeof resultFunc === 'object') {
            directlyPassedOptions = resultFunc; // and pop the real result func off
            resultFunc = funcs.pop();
        }
        if (typeof resultFunc !== 'function') throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
         // Determine which set of options we're using. Prefer options passed directly,
        // but fall back to options given to createSelectorCreator.
        var _directlyPassedOption = directlyPassedOptions, _directlyPassedOption2 = _directlyPassedOption.memoizeOptions, memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
        // is an array. In most libs I've looked at, it's an equality function or options object.
        // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
        // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
        // we wrap it in an array so we can apply it.
        var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [
            memoizeOptions
        ];
        var dependencies = $6730822c14f67805$var$getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(void 0, [
            function recomputationWrapper() {
                _recomputations++; // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = memoize(function dependenciesChecker() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            // @ts-ignore
            params.push(dependencies[i].apply(null, arguments));
             // apply arguments instead of spreading for performance.
            _lastResult = memoizedResultFunc.apply(null, params);
            return _lastResult;
        });
        Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            lastResult: function lastResult() {
                return _lastResult;
            },
            recomputations: function recomputations() {
                return _recomputations;
            },
            resetRecomputations: function resetRecomputations() {
                return _recomputations = 0;
            }
        });
        return selector;
    }; // @ts-ignore
    return createSelector;
}
var $6730822c14f67805$export$595d22ed68ca2841 = /* #__PURE__ */ $6730822c14f67805$export$5943f4447f6ef248((0, $f17c24e54e60b024$export$281bff7f05488aa2));
var $6730822c14f67805$export$75979cfcd91bf38f = function createStructuredSelector(selectors, selectorCreator) {
    if (selectorCreator === void 0) selectorCreator = $6730822c14f67805$export$595d22ed68ca2841;
    if (typeof selectors !== 'object') throw new Error('createStructuredSelector expects first argument to be an object ' + ("where each property is a selector, instead received a " + typeof selectors));
    var objectKeys = Object.keys(selectors);
    var resultSelector = selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
    return resultSelector;
};


/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */ function $ccc44c8907518eb1$var$createThunkMiddleware(extraArgument) {
    // Standard Redux middleware definition pattern:
    // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
    var middleware = function middleware(_ref) {
        var dispatch = _ref.dispatch, getState = _ref.getState;
        return function(next) {
            return function(action) {
                // The thunk middleware looks for any functions that were passed to `store.dispatch`.
                // If this "action" is really a function, call it and return the result.
                if (typeof action === 'function') // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
                return action(dispatch, getState, extraArgument);
                 // Otherwise, pass the action down the middleware chain as usual
                return next(action);
            };
        };
    };
    return middleware;
}
var $ccc44c8907518eb1$var$thunk = $ccc44c8907518eb1$var$createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks
$ccc44c8907518eb1$var$thunk.withExtraArgument = $ccc44c8907518eb1$var$createThunkMiddleware;
var $ccc44c8907518eb1$export$2e2bcd8739ae039 = $ccc44c8907518eb1$var$thunk;


var $def02af5c61b0dea$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $def02af5c61b0dea$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $def02af5c61b0dea$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
var $def02af5c61b0dea$var$__defProp = Object.defineProperty;
var $def02af5c61b0dea$var$__defProps = Object.defineProperties;
var $def02af5c61b0dea$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $def02af5c61b0dea$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $def02af5c61b0dea$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $def02af5c61b0dea$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $def02af5c61b0dea$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $def02af5c61b0dea$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $def02af5c61b0dea$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($def02af5c61b0dea$var$__hasOwnProp.call(b, prop)) $def02af5c61b0dea$var$__defNormalProp(a, prop, b[prop]);
    if ($def02af5c61b0dea$var$__getOwnPropSymbols) for(var _i = 0, _c = $def02af5c61b0dea$var$__getOwnPropSymbols(b); _i < _c.length; _i++){
        var prop = _c[_i];
        if ($def02af5c61b0dea$var$__propIsEnum.call(b, prop)) $def02af5c61b0dea$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $def02af5c61b0dea$var$__spreadProps = function(a, b) {
    return $def02af5c61b0dea$var$__defProps(a, $def02af5c61b0dea$var$__getOwnPropDescs(b));
};
var $def02af5c61b0dea$var$__async = function(__this, __arguments, generator) {
    return new Promise(function(resolve, reject) {
        var fulfilled = function(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function(value) {
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function(x) {
            return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
var $def02af5c61b0dea$export$a5d3c27355e35910 = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var selector = (0, $6730822c14f67805$export$595d22ed68ca2841).apply(void 0, args);
    var wrappedSelector = function(value) {
        var rest = [];
        for(var _i = 1; _i < arguments.length; _i++)rest[_i - 1] = arguments[_i];
        return selector.apply(void 0, $def02af5c61b0dea$var$__spreadArray([
            (0, $6bvDC.isDraft)(value) ? (0, $6bvDC.current)(value) : value
        ], rest));
    };
    return wrappedSelector;
};
var $def02af5c61b0dea$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $5c178e598efca549$export$f672e0b6f7222cd7;
    return (0, $5c178e598efca549$export$f672e0b6f7222cd7).apply(null, arguments);
};
var $def02af5c61b0dea$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop2) {
        return noop2;
    };
};
// src/isPlainObject.ts
function $def02af5c61b0dea$export$53b83ca8eaab0383(value) {
    if (typeof value !== "object" || value === null) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/tsHelpers.ts
var $def02af5c61b0dea$var$hasMatchFunction = function(v) {
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $def02af5c61b0dea$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (prepareAction) {
            var prepared = prepareAction.apply(void 0, args);
            if (!prepared) throw new Error("prepareAction did not return an object");
            return $def02af5c61b0dea$var$__spreadValues($def02af5c61b0dea$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = function() {
        return "" + type;
    };
    actionCreator.type = type;
    actionCreator.match = function(action) {
        return action.type === type;
    };
    return actionCreator;
}
function $def02af5c61b0dea$export$b956e38827fca970(action) {
    return $def02af5c61b0dea$export$53b83ca8eaab0383(action) && "type" in action;
}
function $def02af5c61b0dea$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && $def02af5c61b0dea$var$hasMatchFunction(action);
}
function $def02af5c61b0dea$export$ebd532f9034651f3(action) {
    return $def02af5c61b0dea$export$b956e38827fca970(action) && typeof action.type === "string" && Object.keys(action).every($def02af5c61b0dea$var$isValidKey);
}
function $def02af5c61b0dea$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
function $def02af5c61b0dea$export$e2b5c5db9e2009fd(actionCreator) {
    return "" + actionCreator;
}
// src/actionCreatorInvariantMiddleware.ts
function $def02af5c61b0dea$var$getMessage(type) {
    var splitType = type ? ("" + type).split("/") : [];
    var actionName = splitType[splitType.length - 1] || "actionCreator";
    return "Detected an action creator with type \"" + (type || "unknown") + "\" being dispatched. \nMake sure you're calling the action creator before dispatching, i.e. `dispatch(" + actionName + "())` instead of `dispatch(" + actionName + ")`. This is necessary even if the action has no payload.";
}
function $def02af5c61b0dea$export$6a1fcb4ceef578f(options) {
    if (options === void 0) options = {};
    var _c, isActionCreator2;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
function $def02af5c61b0dea$var$getTimeMeasureUtils(maxDelay, fnName) {
    var elapsed = 0;
    return {
        measureTime: function(fn) {
            var started = Date.now();
            try {
                return fn();
            } finally{
                var finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded: function() {
            if (elapsed > maxDelay) console.warn(fnName + " took " + elapsed + "ms, which is more than the warning threshold of " + maxDelay + "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that.");
        }
    };
}
var $def02af5c61b0dea$export$20df1e9bd1a54f25 = /** @class */ function(_super) {
    $def02af5c61b0dea$var$__extends(MiddlewareArray, _super);
    function MiddlewareArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, MiddlewareArray.prototype);
        return _this;
    }
    Object.defineProperty(MiddlewareArray, Symbol.species, {
        get: function() {
            return MiddlewareArray;
        },
        enumerable: false,
        configurable: true
    });
    MiddlewareArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    MiddlewareArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (MiddlewareArray.bind.apply(MiddlewareArray, $def02af5c61b0dea$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (MiddlewareArray.bind.apply(MiddlewareArray, $def02af5c61b0dea$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return MiddlewareArray;
}(Array);
var $def02af5c61b0dea$export$490d10040a0cbe8a = /** @class */ function(_super) {
    $def02af5c61b0dea$var$__extends(EnhancerArray, _super);
    function EnhancerArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, EnhancerArray.prototype);
        return _this;
    }
    Object.defineProperty(EnhancerArray, Symbol.species, {
        get: function() {
            return EnhancerArray;
        },
        enumerable: false,
        configurable: true
    });
    EnhancerArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    EnhancerArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (EnhancerArray.bind.apply(EnhancerArray, $def02af5c61b0dea$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (EnhancerArray.bind.apply(EnhancerArray, $def02af5c61b0dea$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return EnhancerArray;
}(Array);
function $def02af5c61b0dea$var$freezeDraftable(val) {
    return (0, $6bvDC.isDraftable)(val) ? (0, $6bvDC.default)(val, function() {}) : val;
}
// src/immutableStateInvariantMiddleware.ts
var $def02af5c61b0dea$var$isProduction = true;
var $def02af5c61b0dea$var$prefix = "Invariant failed";
function $def02af5c61b0dea$var$invariant(condition, message) {
    if (condition) return;
    if ($def02af5c61b0dea$var$isProduction) throw new Error($def02af5c61b0dea$var$prefix);
    throw new Error($def02af5c61b0dea$var$prefix + ": " + (message || ""));
}
function $def02af5c61b0dea$var$stringify(obj, serializer, indent, decycler) {
    return JSON.stringify(obj, $def02af5c61b0dea$var$getSerialize(serializer, decycler), indent);
}
function $def02af5c61b0dea$var$getSerialize(serializer, decycler) {
    var stack = [], keys = [];
    if (!decycler) decycler = function(_, value) {
        if (stack[0] === value) return "[Circular ~]";
        return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
    };
    return function(key, value) {
        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
            ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
            if (~stack.indexOf(value)) value = decycler.call(this, key, value);
        } else stack.push(value);
        return serializer == null ? value : serializer.call(this, key, value);
    };
}
function $def02af5c61b0dea$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $def02af5c61b0dea$var$trackForMutations(isImmutable, ignorePaths, obj) {
    var trackedProperties = $def02af5c61b0dea$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations: function() {
            return $def02af5c61b0dea$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $def02af5c61b0dea$var$trackProperties(isImmutable, ignorePaths, obj, path, checkedObjects) {
    if (ignorePaths === void 0) ignorePaths = [];
    if (path === void 0) path = "";
    if (checkedObjects === void 0) checkedObjects = new Set();
    var tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(var key in obj){
            var childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $def02af5c61b0dea$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $def02af5c61b0dea$var$detectMutations(isImmutable, ignoredPaths, trackedProperty, obj, sameParentRef, path) {
    if (ignoredPaths === void 0) ignoredPaths = [];
    if (sameParentRef === void 0) sameParentRef = false;
    if (path === void 0) path = "";
    var prevObj = trackedProperty ? trackedProperty.value : void 0;
    var sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    var keysToDetect = {};
    for(var key in trackedProperty.children)keysToDetect[key] = true;
    for(var key in obj)keysToDetect[key] = true;
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_1 = function(key) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        var result = $def02af5c61b0dea$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return {
            value: result
        };
    };
    for(var key in keysToDetect){
        var state_1 = _loop_1(key);
        if (typeof state_1 === "object") return state_1.value;
    }
    return {
        wasMutated: false
    };
}
function $def02af5c61b0dea$export$9181bb1a5474289(options) {
    if (options === void 0) options = {};
    var _c, isImmutable, ignoredPaths, _d, warnAfter, ignore, track;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/serializableStateInvariantMiddleware.ts
function $def02af5c61b0dea$export$77670485918dab4e(val) {
    var type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || $def02af5c61b0dea$export$53b83ca8eaab0383(val);
}
function $def02af5c61b0dea$export$ada5dca0b571bc7(value, path, isSerializable, getEntries, ignoredPaths, cache) {
    if (path === void 0) path = "";
    if (isSerializable === void 0) isSerializable = $def02af5c61b0dea$export$77670485918dab4e;
    if (ignoredPaths === void 0) ignoredPaths = [];
    var foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    var entries = getEntries != null ? getEntries(value) : Object.entries(value);
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_2 = function(key, nestedValue) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        if (!isSerializable(nestedValue)) return {
            value: {
                keyPath: nestedPath,
                value: nestedValue
            }
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $def02af5c61b0dea$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return {
                value: foundNestedSerializable
            };
        }
    };
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _c = entries_1[_i], key = _c[0], nestedValue = _c[1];
        var state_2 = _loop_2(key, nestedValue);
        if (typeof state_2 === "object") return state_2.value;
    }
    if (cache && $def02af5c61b0dea$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $def02af5c61b0dea$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for(var _i = 0, _c = Object.values(value); _i < _c.length; _i++){
        var nestedValue = _c[_i];
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$def02af5c61b0dea$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $def02af5c61b0dea$export$6dea1aad6dac5ac2(options) {
    if (options === void 0) options = {};
    var _c, isSerializable, getEntries, _d, ignoredActions, _e, ignoredActionPaths, _f, ignoredPaths, _g, warnAfter, _h, ignoreState, _j, ignoreActions, _k, disableCache, cache;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/getDefaultMiddleware.ts
function $def02af5c61b0dea$var$isBoolean(x) {
    return typeof x === "boolean";
}
function $def02af5c61b0dea$var$curryGetDefaultMiddleware() {
    return function curriedGetDefaultMiddleware(options) {
        return $def02af5c61b0dea$export$36c1185aeee5b0a6(options);
    };
}
function $def02af5c61b0dea$export$36c1185aeee5b0a6(options) {
    if (options === void 0) options = {};
    var _c = options.thunk, thunk = _c === void 0 ? true : _c, _d = options.immutableCheck, immutableCheck = _d === void 0 ? true : _d, _e = options.serializableCheck, serializableCheck = _e === void 0 ? true : _e, _f = options.actionCreatorCheck, actionCreatorCheck = _f === void 0 ? true : _f;
    var middlewareArray = new $def02af5c61b0dea$export$20df1e9bd1a54f25();
    if (thunk) {
        if ($def02af5c61b0dea$var$isBoolean(thunk)) middlewareArray.push((0, $ccc44c8907518eb1$export$2e2bcd8739ae039));
        else middlewareArray.push((0, $ccc44c8907518eb1$export$2e2bcd8739ae039).withExtraArgument(thunk.extraArgument));
    }
    var immutableOptions, serializableOptions, actionCreatorOptions;
    return middlewareArray;
}
// src/configureStore.ts
var $def02af5c61b0dea$var$IS_PRODUCTION = true;
function $def02af5c61b0dea$export$7d8a5b498da695ac(options) {
    var curriedGetDefaultMiddleware = $def02af5c61b0dea$var$curryGetDefaultMiddleware();
    var _c = options || {}, _d = _c.reducer, reducer = _d === void 0 ? void 0 : _d, _e = _c.middleware, middleware = _e === void 0 ? curriedGetDefaultMiddleware() : _e, _f = _c.devTools, devTools = _f === void 0 ? true : _f, _g = _c.preloadedState, preloadedState = _g === void 0 ? void 0 : _g, _h = _c.enhancers, enhancers = _h === void 0 ? void 0 : _h;
    var rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ($def02af5c61b0dea$export$53b83ca8eaab0383(reducer)) rootReducer = (0, $5c178e598efca549$export$66e4520cdb265d18)(reducer);
    else throw new Error('"reducer" is a required argument, and must be a function or an object of functions that can be passed to combineReducers');
    var finalMiddleware = middleware;
    if (typeof finalMiddleware === "function") {
        finalMiddleware = finalMiddleware(curriedGetDefaultMiddleware);
        if (!$def02af5c61b0dea$var$IS_PRODUCTION && !Array.isArray(finalMiddleware)) throw new Error("when using a middleware builder function, an array of middleware must be returned");
    }
    if (!$def02af5c61b0dea$var$IS_PRODUCTION && finalMiddleware.some(function(item) {
        return typeof item !== "function";
    })) throw new Error("each middleware provided to configureStore must be a function");
    var middlewareEnhancer = (0, $5c178e598efca549$export$9ff26e0402cc7b7).apply(void 0, finalMiddleware);
    var finalCompose = (0, $5c178e598efca549$export$f672e0b6f7222cd7);
    if (devTools) finalCompose = $def02af5c61b0dea$var$composeWithDevTools($def02af5c61b0dea$var$__spreadValues({
        trace: !$def02af5c61b0dea$var$IS_PRODUCTION
    }, typeof devTools === "object" && devTools));
    var defaultEnhancers = new $def02af5c61b0dea$export$490d10040a0cbe8a(middlewareEnhancer);
    var storeEnhancers = defaultEnhancers;
    if (Array.isArray(enhancers)) storeEnhancers = $def02af5c61b0dea$var$__spreadArray([
        middlewareEnhancer
    ], enhancers);
    else if (typeof enhancers === "function") storeEnhancers = enhancers(defaultEnhancers);
    var composedEnhancer = finalCompose.apply(void 0, storeEnhancers);
    return (0, $5c178e598efca549$export$f51a9068ac82ea43)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $def02af5c61b0dea$var$executeReducerBuilderCallback(builderCallback) {
    var actionsMap = {};
    var actionMatchers = [];
    var defaultCaseReducer;
    var builder = {
        addCase: function(typeOrActionCreator, reducer) {
            var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error("`builder.addCase` cannot be called with an empty action type");
            if (type in actionsMap) throw new Error("`builder.addCase` cannot be called with two reducers for the same action type");
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher: function(matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase: function(reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $def02af5c61b0dea$var$isStateFunction(x) {
    return typeof x === "function";
}
var $def02af5c61b0dea$var$hasWarnedAboutObjectNotation = false;
function $def02af5c61b0dea$export$473eb76d322d0290(initialState, mapOrBuilderCallback, actionMatchers, defaultCaseReducer) {
    if (actionMatchers === void 0) actionMatchers = [];
    var _c = typeof mapOrBuilderCallback === "function" ? $def02af5c61b0dea$var$executeReducerBuilderCallback(mapOrBuilderCallback) : [
        mapOrBuilderCallback,
        actionMatchers,
        defaultCaseReducer
    ], actionsMap = _c[0], finalActionMatchers = _c[1], finalDefaultCaseReducer = _c[2];
    var getInitialState;
    if ($def02af5c61b0dea$var$isStateFunction(initialState)) getInitialState = function() {
        return $def02af5c61b0dea$var$freezeDraftable(initialState());
    };
    else {
        var frozenInitialState_1 = $def02af5c61b0dea$var$freezeDraftable(initialState);
        getInitialState = function() {
            return frozenInitialState_1;
        };
    }
    function reducer(state, action) {
        if (state === void 0) state = getInitialState();
        var caseReducers = $def02af5c61b0dea$var$__spreadArray([
            actionsMap[action.type]
        ], finalActionMatchers.filter(function(_c) {
            var matcher = _c.matcher;
            return matcher(action);
        }).map(function(_c) {
            var reducer2 = _c.reducer;
            return reducer2;
        }));
        if (caseReducers.filter(function(cr) {
            return !!cr;
        }).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce(function(previousState, caseReducer) {
            if (caseReducer) {
                if ((0, $6bvDC.isDraft)(previousState)) {
                    var draft = previousState;
                    var result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $6bvDC.isDraftable)(previousState)) {
                    var result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, $6bvDC.default)(previousState, function(draft) {
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/createSlice.ts
var $def02af5c61b0dea$var$hasWarnedAboutObjectNotation2 = false;
function $def02af5c61b0dea$var$getType2(slice, actionKey) {
    return slice + "/" + actionKey;
}
function $def02af5c61b0dea$export$4d8d9bd83c24ae8b(options) {
    var name = options.name;
    if (!name) throw new Error("`name` is a required option for createSlice");
    var initialState = typeof options.initialState == "function" ? options.initialState : $def02af5c61b0dea$var$freezeDraftable(options.initialState);
    var reducers = options.reducers || {};
    var reducerNames = Object.keys(reducers);
    var sliceCaseReducersByName = {};
    var sliceCaseReducersByType = {};
    var actionCreators = {};
    reducerNames.forEach(function(reducerName) {
        var maybeReducerWithPrepare = reducers[reducerName];
        var type = $def02af5c61b0dea$var$getType2(name, reducerName);
        var caseReducer;
        var prepareCallback;
        if ("reducer" in maybeReducerWithPrepare) {
            caseReducer = maybeReducerWithPrepare.reducer;
            prepareCallback = maybeReducerWithPrepare.prepare;
        } else caseReducer = maybeReducerWithPrepare;
        sliceCaseReducersByName[reducerName] = caseReducer;
        sliceCaseReducersByType[type] = caseReducer;
        actionCreators[reducerName] = prepareCallback ? $def02af5c61b0dea$export$309c7a02b0b0bc62(type, prepareCallback) : $def02af5c61b0dea$export$309c7a02b0b0bc62(type);
    });
    function buildReducer() {
        var _c = typeof options.extraReducers === "function" ? $def02af5c61b0dea$var$executeReducerBuilderCallback(options.extraReducers) : [
            options.extraReducers
        ], _d = _c[0], extraReducers = _d === void 0 ? {} : _d, _e = _c[1], actionMatchers = _e === void 0 ? [] : _e, _f = _c[2], defaultCaseReducer = _f === void 0 ? void 0 : _f;
        var finalCaseReducers = $def02af5c61b0dea$var$__spreadValues($def02af5c61b0dea$var$__spreadValues({}, extraReducers), sliceCaseReducersByType);
        return $def02af5c61b0dea$export$473eb76d322d0290(initialState, function(builder) {
            for(var key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
            for(var _i = 0, actionMatchers_1 = actionMatchers; _i < actionMatchers_1.length; _i++){
                var m = actionMatchers_1[_i];
                builder.addMatcher(m.matcher, m.reducer);
            }
            if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
        });
    }
    var _reducer;
    return {
        name: name,
        reducer: function(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        },
        actions: actionCreators,
        caseReducers: sliceCaseReducersByName,
        getInitialState: function() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
    };
}
// src/entities/entity_state.ts
function $def02af5c61b0dea$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $def02af5c61b0dea$var$createInitialStateFactory() {
    function getInitialState(additionalState) {
        if (additionalState === void 0) additionalState = {};
        return Object.assign($def02af5c61b0dea$var$getInitialEntityState(), additionalState);
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $def02af5c61b0dea$var$createSelectorsFactory() {
    function getSelectors(selectState) {
        var selectIds = function(state) {
            return state.ids;
        };
        var selectEntities = function(state) {
            return state.entities;
        };
        var selectAll = $def02af5c61b0dea$export$a5d3c27355e35910(selectIds, selectEntities, function(ids, entities) {
            return ids.map(function(id) {
                return entities[id];
            });
        });
        var selectId = function(_, id) {
            return id;
        };
        var selectById = function(entities, id) {
            return entities[id];
        };
        var selectTotal = $def02af5c61b0dea$export$a5d3c27355e35910(selectIds, function(ids) {
            return ids.length;
        });
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: $def02af5c61b0dea$export$a5d3c27355e35910(selectEntities, selectId, selectById)
        };
        var selectGlobalizedEntities = $def02af5c61b0dea$export$a5d3c27355e35910(selectState, selectEntities);
        return {
            selectIds: $def02af5c61b0dea$export$a5d3c27355e35910(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: $def02af5c61b0dea$export$a5d3c27355e35910(selectState, selectAll),
            selectTotal: $def02af5c61b0dea$export$a5d3c27355e35910(selectState, selectTotal),
            selectById: $def02af5c61b0dea$export$a5d3c27355e35910(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
function $def02af5c61b0dea$var$createSingleArgumentStateOperator(mutator) {
    var operator = $def02af5c61b0dea$var$createStateOperator(function(_, state) {
        return mutator(state);
    });
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $def02af5c61b0dea$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $def02af5c61b0dea$export$ebd532f9034651f3(arg2);
        }
        var runMutator = function(draft) {
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ((0, $6bvDC.isDraft)(state)) {
            runMutator(state);
            return state;
        } else return (0, $6bvDC.default)(state, runMutator);
    };
}
// src/entities/utils.ts
function $def02af5c61b0dea$var$selectIdValue(entity, selectId) {
    var key = selectId(entity);
    return key;
}
function $def02af5c61b0dea$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $def02af5c61b0dea$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $def02af5c61b0dea$var$ensureEntitiesArray(newEntities);
    var added = [];
    var updated = [];
    for(var _i = 0, newEntities_1 = newEntities; _i < newEntities_1.length; _i++){
        var entity = newEntities_1[_i];
        var id = $def02af5c61b0dea$var$selectIdValue(entity, selectId);
        if (id in state.entities) updated.push({
            id: id,
            changes: entity
        });
        else added.push(entity);
    }
    return [
        added,
        updated
    ];
}
// src/entities/unsorted_state_adapter.ts
function $def02af5c61b0dea$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        var key = $def02af5c61b0dea$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $def02af5c61b0dea$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_2 = newEntities; _i < newEntities_2.length; _i++){
            var entity = newEntities_2[_i];
            addOneMutably(entity, state);
        }
    }
    function setOneMutably(entity, state) {
        var key = $def02af5c61b0dea$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $def02af5c61b0dea$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_3 = newEntities; _i < newEntities_3.length; _i++){
            var entity = newEntities_3[_i];
            setOneMutably(entity, state);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $def02af5c61b0dea$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        var didMutate = false;
        keys.forEach(function(key) {
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter(function(id) {
            return id in state.entities;
        });
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        var original2 = state.entities[update.id];
        var updated = Object.assign({}, original2, update.changes);
        var newKey = $def02af5c61b0dea$var$selectIdValue(updated, selectId);
        var hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var newKeys = {};
        var updatesPerEntity = {};
        updates.forEach(function(update) {
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                changes: $def02af5c61b0dea$var$__spreadValues($def02af5c61b0dea$var$__spreadValues({}, updatesPerEntity[update.id] ? updatesPerEntity[update.id].changes : null), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        var didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            var didMutateIds = updates.filter(function(update) {
                return takeNewKey(newKeys, update, state);
            }).length > 0;
            if (didMutateIds) state.ids = Object.keys(state.entities);
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $def02af5c61b0dea$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $def02af5c61b0dea$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $def02af5c61b0dea$var$createStateOperator(addOneMutably),
        addMany: $def02af5c61b0dea$var$createStateOperator(addManyMutably),
        setOne: $def02af5c61b0dea$var$createStateOperator(setOneMutably),
        setMany: $def02af5c61b0dea$var$createStateOperator(setManyMutably),
        setAll: $def02af5c61b0dea$var$createStateOperator(setAllMutably),
        updateOne: $def02af5c61b0dea$var$createStateOperator(updateOneMutably),
        updateMany: $def02af5c61b0dea$var$createStateOperator(updateManyMutably),
        upsertOne: $def02af5c61b0dea$var$createStateOperator(upsertOneMutably),
        upsertMany: $def02af5c61b0dea$var$createStateOperator(upsertManyMutably),
        removeOne: $def02af5c61b0dea$var$createStateOperator(removeOneMutably),
        removeMany: $def02af5c61b0dea$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $def02af5c61b0dea$var$createSortedStateAdapter(selectId, sort) {
    var _c = $def02af5c61b0dea$var$createUnsortedStateAdapter(selectId), removeOne = _c.removeOne, removeMany = _c.removeMany, removeAll = _c.removeAll;
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state) {
        newEntities = $def02af5c61b0dea$var$ensureEntitiesArray(newEntities);
        var models = newEntities.filter(function(model) {
            return !($def02af5c61b0dea$var$selectIdValue(model, selectId) in state.entities);
        });
        if (models.length !== 0) merge(models, state);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $def02af5c61b0dea$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) merge(newEntities, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $def02af5c61b0dea$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var appliedUpdates = false;
        for(var _i = 0, updates_1 = updates; _i < updates_1.length; _i++){
            var update = updates_1[_i];
            var entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            var newId = selectId(entity);
            if (update.id !== newId) {
                delete state.entities[update.id];
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) resortEntities(state);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $def02af5c61b0dea$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(var i = 0; i < a.length && i < b.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    function merge(models, state) {
        models.forEach(function(model) {
            state.entities[selectId(model)] = model;
        });
        resortEntities(state);
    }
    function resortEntities(state) {
        var allEntities = Object.values(state.entities);
        allEntities.sort(sort);
        var newSortedIds = allEntities.map(selectId);
        var ids = state.ids;
        if (!areArraysEqual(ids, newSortedIds)) state.ids = newSortedIds;
    }
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $def02af5c61b0dea$var$createStateOperator(addOneMutably),
        updateOne: $def02af5c61b0dea$var$createStateOperator(updateOneMutably),
        upsertOne: $def02af5c61b0dea$var$createStateOperator(upsertOneMutably),
        setOne: $def02af5c61b0dea$var$createStateOperator(setOneMutably),
        setMany: $def02af5c61b0dea$var$createStateOperator(setManyMutably),
        setAll: $def02af5c61b0dea$var$createStateOperator(setAllMutably),
        addMany: $def02af5c61b0dea$var$createStateOperator(addManyMutably),
        updateMany: $def02af5c61b0dea$var$createStateOperator(updateManyMutably),
        upsertMany: $def02af5c61b0dea$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $def02af5c61b0dea$export$abcf4037b41e0df(options) {
    if (options === void 0) options = {};
    var _c = $def02af5c61b0dea$var$__spreadValues({
        sortComparer: false,
        selectId: function(instance) {
            return instance.id;
        }
    }, options), selectId = _c.selectId, sortComparer = _c.sortComparer;
    var stateFactory = $def02af5c61b0dea$var$createInitialStateFactory();
    var selectorsFactory = $def02af5c61b0dea$var$createSelectorsFactory();
    var stateAdapter = sortComparer ? $def02af5c61b0dea$var$createSortedStateAdapter(selectId, sortComparer) : $def02af5c61b0dea$var$createUnsortedStateAdapter(selectId);
    return $def02af5c61b0dea$var$__spreadValues($def02af5c61b0dea$var$__spreadValues($def02af5c61b0dea$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/nanoid.ts
var $def02af5c61b0dea$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $def02af5c61b0dea$export$ac4959f4f1338dfc = function(size) {
    if (size === void 0) size = 21;
    var id = "";
    var i = size;
    while(i--)id += $def02af5c61b0dea$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $def02af5c61b0dea$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $def02af5c61b0dea$var$RejectWithValue = /** @class */ function() {
    function RejectWithValue(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return RejectWithValue;
}();
var $def02af5c61b0dea$var$FulfillWithMeta = /** @class */ function() {
    function FulfillWithMeta(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return FulfillWithMeta;
}();
var $def02af5c61b0dea$export$c97c53d0b2d5d81e = function(value) {
    if (typeof value === "object" && value !== null) {
        var simpleError = {};
        for(var _i = 0, commonProperties_1 = $def02af5c61b0dea$var$commonProperties; _i < commonProperties_1.length; _i++){
            var property = commonProperties_1[_i];
            if (typeof value[property] === "string") simpleError[property] = value[property];
        }
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $def02af5c61b0dea$export$6abd22dc03e5063f = function() {
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        var fulfilled = $def02af5c61b0dea$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", function(payload, requestId, arg, meta) {
            return {
                payload: payload,
                meta: $def02af5c61b0dea$var$__spreadProps($def02af5c61b0dea$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            };
        });
        var pending = $def02af5c61b0dea$export$309c7a02b0b0bc62(typePrefix + "/pending", function(requestId, arg, meta) {
            return {
                payload: void 0,
                meta: $def02af5c61b0dea$var$__spreadProps($def02af5c61b0dea$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            };
        });
        var rejected = $def02af5c61b0dea$export$309c7a02b0b0bc62(typePrefix + "/rejected", function(error, requestId, arg, payload, meta) {
            return {
                payload: payload,
                error: (options && options.serializeError || $def02af5c61b0dea$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $def02af5c61b0dea$var$__spreadProps($def02af5c61b0dea$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            };
        });
        var displayedWarning = false;
        var AC = typeof AbortController !== "undefined" ? AbortController : /** @class */ function() {
            function class_1() {
                this.signal = {
                    aborted: false,
                    addEventListener: function() {},
                    dispatchEvent: function() {
                        return false;
                    },
                    onabort: function() {},
                    removeEventListener: function() {},
                    reason: void 0,
                    throwIfAborted: function() {}
                };
            }
            class_1.prototype.abort = function() {};
            return class_1;
        }();
        function actionCreator(arg) {
            return function(dispatch, getState, extra) {
                var requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $def02af5c61b0dea$export$ac4959f4f1338dfc();
                var abortController = new AC();
                var abortReason;
                var started = false;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                var promise2 = function() {
                    return $def02af5c61b0dea$var$__async(this, null, function() {
                        var _a, _b, finalAction, conditionResult, abortedPromise, err_1, skipDispatch;
                        return $def02af5c61b0dea$var$__generator(this, function(_c) {
                            switch(_c.label){
                                case 0:
                                    _c.trys.push([
                                        0,
                                        4,
                                        ,
                                        5
                                    ]);
                                    conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                                        getState: getState,
                                        extra: extra
                                    });
                                    if (!$def02af5c61b0dea$var$isThenable(conditionResult)) return [
                                        3 /*break*/ ,
                                        2
                                    ];
                                    return [
                                        4 /*yield*/ ,
                                        conditionResult
                                    ];
                                case 1:
                                    conditionResult = _c.sent();
                                    _c.label = 2;
                                case 2:
                                    if (conditionResult === false || abortController.signal.aborted) throw {
                                        name: "ConditionError",
                                        message: "Aborted due to condition callback returning false."
                                    };
                                    started = true;
                                    abortedPromise = new Promise(function(_, reject) {
                                        return abortController.signal.addEventListener("abort", function() {
                                            return reject({
                                                name: "AbortError",
                                                message: abortReason || "Aborted"
                                            });
                                        });
                                    });
                                    dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                                        requestId: requestId,
                                        arg: arg
                                    }, {
                                        getState: getState,
                                        extra: extra
                                    })));
                                    return [
                                        4 /*yield*/ ,
                                        Promise.race([
                                            abortedPromise,
                                            Promise.resolve(payloadCreator(arg, {
                                                dispatch: dispatch,
                                                getState: getState,
                                                extra: extra,
                                                requestId: requestId,
                                                signal: abortController.signal,
                                                abort: abort,
                                                rejectWithValue: function(value, meta) {
                                                    return new $def02af5c61b0dea$var$RejectWithValue(value, meta);
                                                },
                                                fulfillWithValue: function(value, meta) {
                                                    return new $def02af5c61b0dea$var$FulfillWithMeta(value, meta);
                                                }
                                            })).then(function(result) {
                                                if (result instanceof $def02af5c61b0dea$var$RejectWithValue) throw result;
                                                if (result instanceof $def02af5c61b0dea$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                                return fulfilled(result, requestId, arg);
                                            })
                                        ])
                                    ];
                                case 3:
                                    finalAction = _c.sent();
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 4:
                                    err_1 = _c.sent();
                                    finalAction = err_1 instanceof $def02af5c61b0dea$var$RejectWithValue ? rejected(null, requestId, arg, err_1.payload, err_1.meta) : rejected(err_1, requestId, arg);
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 5:
                                    skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                                    if (!skipDispatch) dispatch(finalAction);
                                    return [
                                        2 /*return*/ ,
                                        finalAction
                                    ];
                            }
                        });
                    });
                }();
                return Object.assign(promise2, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap: function() {
                        return promise2.then($def02af5c61b0dea$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = function() {
        return createAsyncThunk2;
    };
    return createAsyncThunk2;
}();
function $def02af5c61b0dea$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $def02af5c61b0dea$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/matchers.ts
var $def02af5c61b0dea$var$matches = function(matcher, action) {
    if ($def02af5c61b0dea$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $def02af5c61b0dea$export$2c3435c7647f7b0d() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.some(function(matcher) {
            return $def02af5c61b0dea$var$matches(matcher, action);
        });
    };
}
function $def02af5c61b0dea$export$9dd1fb32974da385() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.every(function(matcher) {
            return $def02af5c61b0dea$var$matches(matcher, action);
        });
    };
}
function $def02af5c61b0dea$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    var hasValidRequestId = typeof action.meta.requestId === "string";
    var hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $def02af5c61b0dea$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $def02af5c61b0dea$export$872dec21e9a69476() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $def02af5c61b0dea$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    };
    if (!$def02af5c61b0dea$var$isAsyncThunkArray(asyncThunks)) return $def02af5c61b0dea$export$872dec21e9a69476()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.pending;
        });
        var combinedMatcher = $def02af5c61b0dea$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $def02af5c61b0dea$export$a5c5d27e3994c5be() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $def02af5c61b0dea$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    };
    if (!$def02af5c61b0dea$var$isAsyncThunkArray(asyncThunks)) return $def02af5c61b0dea$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.rejected;
        });
        var combinedMatcher = $def02af5c61b0dea$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $def02af5c61b0dea$export$fcc3388fb56de601() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    var hasFlag = function(action) {
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return function(action) {
        var combinedMatcher = $def02af5c61b0dea$export$9dd1fb32974da385($def02af5c61b0dea$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
    if (!$def02af5c61b0dea$var$isAsyncThunkArray(asyncThunks)) return $def02af5c61b0dea$export$fcc3388fb56de601()(asyncThunks[0]);
    return function(action) {
        var combinedMatcher = $def02af5c61b0dea$export$9dd1fb32974da385($def02af5c61b0dea$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
}
function $def02af5c61b0dea$export$1da80a6ef1307441() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $def02af5c61b0dea$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    };
    if (!$def02af5c61b0dea$var$isAsyncThunkArray(asyncThunks)) return $def02af5c61b0dea$export$1da80a6ef1307441()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.fulfilled;
        });
        var combinedMatcher = $def02af5c61b0dea$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $def02af5c61b0dea$export$6aa4142d99c1abce() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $def02af5c61b0dea$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    };
    if (!$def02af5c61b0dea$var$isAsyncThunkArray(asyncThunks)) return $def02af5c61b0dea$export$6aa4142d99c1abce()(asyncThunks[0]);
    return function(action) {
        var matchers = [];
        for(var _i = 0, asyncThunks_1 = asyncThunks; _i < asyncThunks_1.length; _i++){
            var asyncThunk = asyncThunks_1[_i];
            matchers.push(asyncThunk.pending, asyncThunk.rejected, asyncThunk.fulfilled);
        }
        var combinedMatcher = $def02af5c61b0dea$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
// src/listenerMiddleware/utils.ts
var $def02af5c61b0dea$var$assertFunction = function(func, expected) {
    if (typeof func !== "function") throw new TypeError(expected + " is not a function");
};
var $def02af5c61b0dea$var$noop = function() {};
var $def02af5c61b0dea$var$catchRejection = function(promise2, onError) {
    if (onError === void 0) onError = $def02af5c61b0dea$var$noop;
    promise2.catch(onError);
    return promise2;
};
var $def02af5c61b0dea$var$addAbortSignalListener = function(abortSignal, callback) {
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return function() {
        return abortSignal.removeEventListener("abort", callback);
    };
};
var $def02af5c61b0dea$var$abortControllerWithReason = function(abortController, reason) {
    var signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/exceptions.ts
var $def02af5c61b0dea$var$task = "task";
var $def02af5c61b0dea$var$listener = "listener";
var $def02af5c61b0dea$var$completed = "completed";
var $def02af5c61b0dea$var$cancelled = "cancelled";
var $def02af5c61b0dea$var$taskCancelled = "task-" + $def02af5c61b0dea$var$cancelled;
var $def02af5c61b0dea$var$taskCompleted = "task-" + $def02af5c61b0dea$var$completed;
var $def02af5c61b0dea$var$listenerCancelled = $def02af5c61b0dea$var$listener + "-" + $def02af5c61b0dea$var$cancelled;
var $def02af5c61b0dea$var$listenerCompleted = $def02af5c61b0dea$var$listener + "-" + $def02af5c61b0dea$var$completed;
var $def02af5c61b0dea$export$cb1bdac908fed7f = /** @class */ function() {
    function TaskAbortError(code) {
        this.code = code;
        this.name = "TaskAbortError";
        this.message = $def02af5c61b0dea$var$task + " " + $def02af5c61b0dea$var$cancelled + " (reason: " + code + ")";
    }
    return TaskAbortError;
}();
// src/listenerMiddleware/task.ts
var $def02af5c61b0dea$var$validateActive = function(signal) {
    if (signal.aborted) throw new $def02af5c61b0dea$export$cb1bdac908fed7f(signal.reason);
};
function $def02af5c61b0dea$var$raceWithSignal(signal, promise2) {
    var cleanup = $def02af5c61b0dea$var$noop;
    return new Promise(function(resolve, reject) {
        var notifyRejection = function() {
            return reject(new $def02af5c61b0dea$export$cb1bdac908fed7f(signal.reason));
        };
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $def02af5c61b0dea$var$addAbortSignalListener(signal, notifyRejection);
        promise2.finally(function() {
            return cleanup();
        }).then(resolve, reject);
    }).finally(function() {
        cleanup = $def02af5c61b0dea$var$noop;
    });
}
var $def02af5c61b0dea$var$runTask = function(task2, cleanUp) {
    return $def02af5c61b0dea$var$__async(void 0, null, function() {
        var value, error_1;
        return $def02af5c61b0dea$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    _c.trys.push([
                        0,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        Promise.resolve()
                    ];
                case 1:
                    _c.sent();
                    return [
                        4 /*yield*/ ,
                        task2()
                    ];
                case 2:
                    value = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: "ok",
                            value: value
                        }
                    ];
                case 3:
                    error_1 = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: error_1 instanceof $def02af5c61b0dea$export$cb1bdac908fed7f ? "cancelled" : "rejected",
                            error: error_1
                        }
                    ];
                case 4:
                    cleanUp == null || cleanUp();
                    return [
                        7 /*endfinally*/ 
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
};
var $def02af5c61b0dea$var$createPause = function(signal) {
    return function(promise2) {
        return $def02af5c61b0dea$var$catchRejection($def02af5c61b0dea$var$raceWithSignal(signal, promise2).then(function(output) {
            $def02af5c61b0dea$var$validateActive(signal);
            return output;
        }));
    };
};
var $def02af5c61b0dea$var$createDelay = function(signal) {
    var pause = $def02af5c61b0dea$var$createPause(signal);
    return function(timeoutMs) {
        return pause(new Promise(function(resolve) {
            return setTimeout(resolve, timeoutMs);
        }));
    };
};
// src/listenerMiddleware/index.ts
var $def02af5c61b0dea$var$assign = Object.assign;
var $def02af5c61b0dea$var$INTERNAL_NIL_TOKEN = {};
var $def02af5c61b0dea$var$alm = "listenerMiddleware";
var $def02af5c61b0dea$var$createFork = function(parentAbortSignal, parentBlockingPromises) {
    var linkControllers = function(controller) {
        return $def02af5c61b0dea$var$addAbortSignalListener(parentAbortSignal, function() {
            return $def02af5c61b0dea$var$abortControllerWithReason(controller, parentAbortSignal.reason);
        });
    };
    return function(taskExecutor, opts) {
        $def02af5c61b0dea$var$assertFunction(taskExecutor, "taskExecutor");
        var childAbortController = new AbortController();
        linkControllers(childAbortController);
        var result = $def02af5c61b0dea$var$runTask(function() {
            return $def02af5c61b0dea$var$__async(void 0, null, function() {
                var result2;
                return $def02af5c61b0dea$var$__generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            $def02af5c61b0dea$var$validateActive(parentAbortSignal);
                            $def02af5c61b0dea$var$validateActive(childAbortController.signal);
                            return [
                                4 /*yield*/ ,
                                taskExecutor({
                                    pause: $def02af5c61b0dea$var$createPause(childAbortController.signal),
                                    delay: $def02af5c61b0dea$var$createDelay(childAbortController.signal),
                                    signal: childAbortController.signal
                                })
                            ];
                        case 1:
                            result2 = _c.sent();
                            $def02af5c61b0dea$var$validateActive(childAbortController.signal);
                            return [
                                2 /*return*/ ,
                                result2
                            ];
                    }
                });
            });
        }, function() {
            return $def02af5c61b0dea$var$abortControllerWithReason(childAbortController, $def02af5c61b0dea$var$taskCompleted);
        });
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result);
        return {
            result: $def02af5c61b0dea$var$createPause(parentAbortSignal)(result),
            cancel: function() {
                $def02af5c61b0dea$var$abortControllerWithReason(childAbortController, $def02af5c61b0dea$var$taskCancelled);
            }
        };
    };
};
var $def02af5c61b0dea$var$createTakePattern = function(startListening, signal) {
    var take = function(predicate, timeout) {
        return $def02af5c61b0dea$var$__async(void 0, null, function() {
            var unsubscribe, tuplePromise, promises, output;
            return $def02af5c61b0dea$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        $def02af5c61b0dea$var$validateActive(signal);
                        unsubscribe = function() {};
                        tuplePromise = new Promise(function(resolve, reject) {
                            var stopListening = startListening({
                                predicate: predicate,
                                effect: function(action, listenerApi) {
                                    listenerApi.unsubscribe();
                                    resolve([
                                        action,
                                        listenerApi.getState(),
                                        listenerApi.getOriginalState()
                                    ]);
                                }
                            });
                            unsubscribe = function() {
                                stopListening();
                                reject();
                            };
                        });
                        promises = [
                            tuplePromise
                        ];
                        if (timeout != null) promises.push(new Promise(function(resolve) {
                            return setTimeout(resolve, timeout, null);
                        }));
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            $def02af5c61b0dea$var$raceWithSignal(signal, Promise.race(promises))
                        ];
                    case 2:
                        output = _c.sent();
                        $def02af5c61b0dea$var$validateActive(signal);
                        return [
                            2 /*return*/ ,
                            output
                        ];
                    case 3:
                        unsubscribe();
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return function(predicate, timeout) {
        return $def02af5c61b0dea$var$catchRejection(take(predicate, timeout));
    };
};
var $def02af5c61b0dea$var$getListenerEntryPropsFrom = function(options) {
    var type = options.type, actionCreator = options.actionCreator, matcher = options.matcher, predicate = options.predicate, effect = options.effect;
    if (type) predicate = $def02af5c61b0dea$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error("Creating or removing a listener requires one of the known fields for matching an action");
    $def02af5c61b0dea$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $def02af5c61b0dea$var$createListenerEntry = function(options) {
    var _c = $def02af5c61b0dea$var$getListenerEntryPropsFrom(options), type = _c.type, predicate = _c.predicate, effect = _c.effect;
    var id = $def02af5c61b0dea$export$ac4959f4f1338dfc();
    var entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: new Set(),
        unsubscribe: function() {
            throw new Error("Unsubscribe not initialized");
        }
    };
    return entry;
};
var $def02af5c61b0dea$var$cancelActiveListeners = function(entry) {
    entry.pending.forEach(function(controller) {
        $def02af5c61b0dea$var$abortControllerWithReason(controller, $def02af5c61b0dea$var$listenerCancelled);
    });
};
var $def02af5c61b0dea$var$createClearListenerMiddleware = function(listenerMap) {
    return function() {
        listenerMap.forEach($def02af5c61b0dea$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $def02af5c61b0dea$var$safelyNotifyError = function(errorHandler, errorToNotify, errorInfo) {
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(function() {
            throw errorHandlerError;
        }, 0);
    }
};
var $def02af5c61b0dea$export$f03a6b845d3fb58b = $def02af5c61b0dea$export$309c7a02b0b0bc62($def02af5c61b0dea$var$alm + "/add");
var $def02af5c61b0dea$export$b1b8022855fb2b71 = $def02af5c61b0dea$export$309c7a02b0b0bc62($def02af5c61b0dea$var$alm + "/removeAll");
var $def02af5c61b0dea$export$b03e9483f936dccb = $def02af5c61b0dea$export$309c7a02b0b0bc62($def02af5c61b0dea$var$alm + "/remove");
var $def02af5c61b0dea$var$defaultErrorHandler = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    console.error.apply(console, $def02af5c61b0dea$var$__spreadArray([
        $def02af5c61b0dea$var$alm + "/error"
    ], args));
};
function $def02af5c61b0dea$export$1228acebbbcb485b(middlewareOptions) {
    var _this = this;
    if (middlewareOptions === void 0) middlewareOptions = {};
    var listenerMap = new Map();
    var extra = middlewareOptions.extra, _c = middlewareOptions.onError, onError = _c === void 0 ? $def02af5c61b0dea$var$defaultErrorHandler : _c;
    $def02af5c61b0dea$var$assertFunction(onError, "onError");
    var insertEntry = function(entry) {
        entry.unsubscribe = function() {
            return listenerMap.delete(entry.id);
        };
        listenerMap.set(entry.id, entry);
        return function(cancelOptions) {
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $def02af5c61b0dea$var$cancelActiveListeners(entry);
        };
    };
    var findListenerEntry = function(comparator) {
        for(var _i = 0, _c = Array.from(listenerMap.values()); _i < _c.length; _i++){
            var entry = _c[_i];
            if (comparator(entry)) return entry;
        }
        return void 0;
    };
    var startListening = function(options) {
        var entry = findListenerEntry(function(existingEntry) {
            return existingEntry.effect === options.effect;
        });
        if (!entry) entry = $def02af5c61b0dea$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    var stopListening = function(options) {
        var _c = $def02af5c61b0dea$var$getListenerEntryPropsFrom(options), type = _c.type, effect = _c.effect, predicate = _c.predicate;
        var entry = findListenerEntry(function(entry2) {
            var matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $def02af5c61b0dea$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    var notifyListener = function(entry, action, api, getOriginalState) {
        return $def02af5c61b0dea$var$__async(_this, null, function() {
            var internalTaskController, take, autoJoinPromises, listenerError_1;
            return $def02af5c61b0dea$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        internalTaskController = new AbortController();
                        take = $def02af5c61b0dea$var$createTakePattern(startListening, internalTaskController.signal);
                        autoJoinPromises = [];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            3,
                            4,
                            6
                        ]);
                        entry.pending.add(internalTaskController);
                        return [
                            4 /*yield*/ ,
                            Promise.resolve(entry.effect(action, $def02af5c61b0dea$var$assign({}, api, {
                                getOriginalState: getOriginalState,
                                condition: function(predicate, timeout) {
                                    return take(predicate, timeout).then(Boolean);
                                },
                                take: take,
                                delay: $def02af5c61b0dea$var$createDelay(internalTaskController.signal),
                                pause: $def02af5c61b0dea$var$createPause(internalTaskController.signal),
                                extra: extra,
                                signal: internalTaskController.signal,
                                fork: $def02af5c61b0dea$var$createFork(internalTaskController.signal, autoJoinPromises),
                                unsubscribe: entry.unsubscribe,
                                subscribe: function() {
                                    listenerMap.set(entry.id, entry);
                                },
                                cancelActiveListeners: function() {
                                    entry.pending.forEach(function(controller, _, set) {
                                        if (controller !== internalTaskController) {
                                            $def02af5c61b0dea$var$abortControllerWithReason(controller, $def02af5c61b0dea$var$listenerCancelled);
                                            set.delete(controller);
                                        }
                                    });
                                }
                            })))
                        ];
                    case 2:
                        _c.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 3:
                        listenerError_1 = _c.sent();
                        if (!(listenerError_1 instanceof $def02af5c61b0dea$export$cb1bdac908fed7f)) $def02af5c61b0dea$var$safelyNotifyError(onError, listenerError_1, {
                            raisedBy: "effect"
                        });
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 4:
                        return [
                            4 /*yield*/ ,
                            Promise.allSettled(autoJoinPromises)
                        ];
                    case 5:
                        _c.sent();
                        $def02af5c61b0dea$var$abortControllerWithReason(internalTaskController, $def02af5c61b0dea$var$listenerCompleted);
                        entry.pending.delete(internalTaskController);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var clearListenerMiddleware = $def02af5c61b0dea$var$createClearListenerMiddleware(listenerMap);
    var middleware = function(api) {
        return function(next) {
            return function(action) {
                if (!$def02af5c61b0dea$export$b956e38827fca970(action)) return next(action);
                if ($def02af5c61b0dea$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($def02af5c61b0dea$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($def02af5c61b0dea$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                var originalState = api.getState();
                var getOriginalState = function() {
                    if (originalState === $def02af5c61b0dea$var$INTERNAL_NIL_TOKEN) throw new Error($def02af5c61b0dea$var$alm + ": getOriginalState can only be called synchronously");
                    return originalState;
                };
                var result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        var currentState = api.getState();
                        var listenerEntries = Array.from(listenerMap.values());
                        for(var _i = 0, listenerEntries_1 = listenerEntries; _i < listenerEntries_1.length; _i++){
                            var entry = listenerEntries_1[_i];
                            var runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $def02af5c61b0dea$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $def02af5c61b0dea$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
        };
    };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
}
// src/autoBatchEnhancer.ts
var $def02af5c61b0dea$export$8fb31c0f05df007b = "RTK_autoBatch";
var $def02af5c61b0dea$export$39fcd5145ec5e4e2 = function() {
    return function(payload) {
        var _c;
        return {
            payload: payload,
            meta: (_c = {}, _c[$def02af5c61b0dea$export$8fb31c0f05df007b] = true, _c)
        };
    };
};
var $def02af5c61b0dea$var$promise;
var $def02af5c61b0dea$var$queueMicrotaskShim = typeof queueMicrotask === "function" ? queueMicrotask.bind(typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : globalThis) : function(cb) {
    return ($def02af5c61b0dea$var$promise || ($def02af5c61b0dea$var$promise = Promise.resolve())).then(cb).catch(function(err) {
        return setTimeout(function() {
            throw err;
        }, 0);
    });
};
var $def02af5c61b0dea$var$createQueueWithTimer = function(timeout) {
    return function(notify) {
        setTimeout(notify, timeout);
    };
};
var $def02af5c61b0dea$var$rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $def02af5c61b0dea$var$createQueueWithTimer(10);
var $def02af5c61b0dea$export$676277d7dca0f396 = function(options) {
    if (options === void 0) options = {
        type: "raf"
    };
    return function(next) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var store = next.apply(void 0, args);
            var notifying = true;
            var shouldNotifyAtEndOfTick = false;
            var notificationQueued = false;
            var listeners = new Set();
            var queueCallback = options.type === "tick" ? $def02af5c61b0dea$var$queueMicrotaskShim : options.type === "raf" ? $def02af5c61b0dea$var$rAF : options.type === "callback" ? options.queueNotification : $def02af5c61b0dea$var$createQueueWithTimer(options.timeout);
            var notifyListeners = function() {
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach(function(l) {
                        return l();
                    });
                }
            };
            return Object.assign({}, store, {
                subscribe: function(listener2) {
                    var wrappedListener = function() {
                        return notifying && listener2();
                    };
                    var unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return function() {
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                dispatch: function(action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$def02af5c61b0dea$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
    };
};
// src/index.ts
(0, $6bvDC.enableES5)();


var $3e9167b9503b8931$export$711117ad6ad27992 = 'persist:';
var $3e9167b9503b8931$export$2aaee4793dd13a52 = 'persist/FLUSH';
var $3e9167b9503b8931$export$1647ef958242c4e2 = 'persist/REHYDRATE';
var $3e9167b9503b8931$export$dd1033c27a16bbd3 = 'persist/PAUSE';
var $3e9167b9503b8931$export$913fe0e161ed92a2 = 'persist/PERSIST';
var $3e9167b9503b8931$export$5514fc3b4067675f = 'persist/PURGE';
var $3e9167b9503b8931$export$51e82cdd7353a0e1 = 'persist/REGISTER';
var $3e9167b9503b8931$export$363ebe89e6e7aeef = -1;


function $cb7f7e5c31054b73$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $cb7f7e5c31054b73$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $cb7f7e5c31054b73$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $cb7f7e5c31054b73$var$_typeof(obj);
}
function $cb7f7e5c31054b73$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $cb7f7e5c31054b73$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $cb7f7e5c31054b73$var$ownKeys(source, true).forEach(function(key) {
            $cb7f7e5c31054b73$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $cb7f7e5c31054b73$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $cb7f7e5c31054b73$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $cb7f7e5c31054b73$export$2e2bcd8739ae039(inboundState, originalState, reducedState, _ref) {
    var debug = _ref.debug;
    var newState = $cb7f7e5c31054b73$var$_objectSpread({}, reducedState); // only rehydrate if inboundState exists and is an object
    if (inboundState && $cb7f7e5c31054b73$var$_typeof(inboundState) === 'object') Object.keys(inboundState).forEach(function(key) {
        // ignore _persist data
        if (key === '_persist') return; // if reducer modifies substate, skip auto rehydration
        if (originalState[key] !== reducedState[key]) return;
         // otherwise hard set the new value
        newState[key] = inboundState[key];
    });
    return newState;
}



function $28ee1925742e823a$export$2e2bcd8739ae039(config) {
    // defaults
    var blacklist = config.blacklist || null;
    var whitelist = config.whitelist || null;
    var transforms = config.transforms || [];
    var throttle = config.throttle || 0;
    var storageKey = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : (0, $3e9167b9503b8931$export$711117ad6ad27992)).concat(config.key);
    var storage = config.storage;
    var serialize;
    if (config.serialize === false) serialize = function serialize(x) {
        return x;
    };
    else if (typeof config.serialize === 'function') serialize = config.serialize;
    else serialize = $28ee1925742e823a$var$defaultSerialize;
    var writeFailHandler = config.writeFailHandler || null; // initialize stateful values
    var lastState = {};
    var stagedState = {};
    var keysToProcess = [];
    var timeIterator = null;
    var writePromise = null;
    var update = function update(state) {
        // add any changed keys to the queue
        Object.keys(state).forEach(function(key) {
            if (!passWhitelistBlacklist(key)) return; // is keyspace ignored? noop
            if (lastState[key] === state[key]) return; // value unchanged? noop
            if (keysToProcess.indexOf(key) !== -1) return; // is key already queued? noop
            keysToProcess.push(key); // add key to queue
        }); //if any key is missing in the new state which was present in the lastState,
        //add it for processing too
        Object.keys(lastState).forEach(function(key) {
            if (state[key] === undefined && passWhitelistBlacklist(key) && keysToProcess.indexOf(key) === -1 && lastState[key] !== undefined) keysToProcess.push(key);
        }); // start the time iterator if not running (read: throttle)
        if (timeIterator === null) timeIterator = setInterval(processNextKey, throttle);
        lastState = state;
    };
    function processNextKey() {
        if (keysToProcess.length === 0) {
            if (timeIterator) clearInterval(timeIterator);
            timeIterator = null;
            return;
        }
        var key = keysToProcess.shift();
        var endState = transforms.reduce(function(subState, transformer) {
            return transformer.in(subState, key, lastState);
        }, lastState[key]);
        if (endState !== undefined) try {
            stagedState[key] = serialize(endState);
        } catch (err) {
            console.error('redux-persist/createPersistoid: error serializing state', err);
        }
        else //if the endState is undefined, no need to persist the existing serialized content
        delete stagedState[key];
        if (keysToProcess.length === 0) writeStagedState();
    }
    function writeStagedState() {
        // cleanup any removed keys just before write.
        Object.keys(stagedState).forEach(function(key) {
            if (lastState[key] === undefined) delete stagedState[key];
        });
        writePromise = storage.setItem(storageKey, serialize(stagedState)).catch(onWriteFail);
    }
    function passWhitelistBlacklist(key) {
        if (whitelist && whitelist.indexOf(key) === -1 && key !== '_persist') return false;
        if (blacklist && blacklist.indexOf(key) !== -1) return false;
        return true;
    }
    function onWriteFail(err) {
        // @TODO add fail handlers (typically storage full)
        if (writeFailHandler) writeFailHandler(err);
    }
    var flush = function flush() {
        while(keysToProcess.length !== 0)processNextKey();
        return writePromise || Promise.resolve();
    }; // return `persistoid`
    return {
        update: update,
        flush: flush
    };
} // @NOTE in the future this may be exposed via config
function $28ee1925742e823a$var$defaultSerialize(data) {
    return JSON.stringify(data);
}



function $57b27d8f7859db32$export$2e2bcd8739ae039(config) {
    var transforms = config.transforms || [];
    var storageKey = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : (0, $3e9167b9503b8931$export$711117ad6ad27992)).concat(config.key);
    var storage = config.storage;
    var debug = config.debug;
    var deserialize;
    if (config.deserialize === false) deserialize = function deserialize(x) {
        return x;
    };
    else if (typeof config.deserialize === 'function') deserialize = config.deserialize;
    else deserialize = $57b27d8f7859db32$var$defaultDeserialize;
    return storage.getItem(storageKey).then(function(serialized) {
        if (!serialized) return undefined;
        else try {
            var state = {};
            var rawState = deserialize(serialized);
            Object.keys(rawState).forEach(function(key) {
                state[key] = transforms.reduceRight(function(subState, transformer) {
                    return transformer.out(subState, key, rawState);
                }, deserialize(rawState[key]));
            });
            return state;
        } catch (err) {
            throw err;
        }
    });
}
function $57b27d8f7859db32$var$defaultDeserialize(serial) {
    return JSON.parse(serial);
}



function $b70b1670a07cb2cb$export$2e2bcd8739ae039(config) {
    var storage = config.storage;
    var storageKey = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : (0, $3e9167b9503b8931$export$711117ad6ad27992)).concat(config.key);
    return storage.removeItem(storageKey, $b70b1670a07cb2cb$var$warnIfRemoveError);
}
function $b70b1670a07cb2cb$var$warnIfRemoveError(err) {}


function $a48ed584738bab49$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a48ed584738bab49$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $a48ed584738bab49$var$ownKeys(source, true).forEach(function(key) {
            $a48ed584738bab49$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $a48ed584738bab49$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a48ed584738bab49$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a48ed584738bab49$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $a48ed584738bab49$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $a48ed584738bab49$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $a48ed584738bab49$var$DEFAULT_TIMEOUT = 5000;
function $a48ed584738bab49$export$2e2bcd8739ae039(config, baseReducer) {
    var version = config.version !== undefined ? config.version : (0, $3e9167b9503b8931$export$363ebe89e6e7aeef);
    var debug = config.debug || false;
    var stateReconciler = config.stateReconciler === undefined ? (0, $cb7f7e5c31054b73$export$2e2bcd8739ae039) : config.stateReconciler;
    var getStoredState = config.getStoredState || (0, $57b27d8f7859db32$export$2e2bcd8739ae039);
    var timeout = config.timeout !== undefined ? config.timeout : $a48ed584738bab49$var$DEFAULT_TIMEOUT;
    var _persistoid = null;
    var _purge = false;
    var _paused = true;
    var conditionalUpdate = function conditionalUpdate(state) {
        // update the persistoid only if we are rehydrated and not paused
        state._persist.rehydrated && _persistoid && !_paused && _persistoid.update(state);
        return state;
    };
    return function(state, action) {
        var _ref = state || {}, _persist = _ref._persist, rest = $a48ed584738bab49$var$_objectWithoutProperties(_ref, [
            "_persist"
        ]); // $FlowIgnore need to update State type
        var restState = rest;
        if (action.type === (0, $3e9167b9503b8931$export$913fe0e161ed92a2)) {
            var _sealed = false;
            var _rehydrate = function _rehydrate(payload, err) {
                if (!_sealed) {
                    action.rehydrate(config.key, payload, err);
                    _sealed = true;
                }
            };
            timeout && setTimeout(function() {
                !_sealed && _rehydrate(undefined, new Error("redux-persist: persist timed out for persist key \"".concat(config.key, "\"")));
            }, timeout); // @NOTE PERSIST resumes if paused.
            _paused = false; // @NOTE only ever create persistoid once, ensure we call it at least once, even if _persist has already been set
            if (!_persistoid) _persistoid = (0, $28ee1925742e823a$export$2e2bcd8739ae039)(config); // @NOTE PERSIST can be called multiple times, noop after the first
            if (_persist) // We still need to call the base reducer because there might be nested
            // uses of persistReducer which need to be aware of the PERSIST action
            return $a48ed584738bab49$var$_objectSpread({}, baseReducer(restState, action), {
                _persist: _persist
            });
            if (typeof action.rehydrate !== 'function' || typeof action.register !== 'function') throw new Error('redux-persist: either rehydrate or register is not a function on the PERSIST action. This can happen if the action is being replayed. This is an unexplored use case, please open an issue and we will figure out a resolution.');
            action.register(config.key);
            getStoredState(config).then(function(restoredState) {
                var migrate = config.migrate || function(s, v) {
                    return Promise.resolve(s);
                };
                migrate(restoredState, version).then(function(migratedState) {
                    _rehydrate(migratedState);
                }, function(migrateErr) {
                    _rehydrate(undefined, migrateErr);
                });
            }, function(err) {
                _rehydrate(undefined, err);
            });
            return $a48ed584738bab49$var$_objectSpread({}, baseReducer(restState, action), {
                _persist: {
                    version: version,
                    rehydrated: false
                }
            });
        } else if (action.type === (0, $3e9167b9503b8931$export$5514fc3b4067675f)) {
            _purge = true;
            action.result((0, $b70b1670a07cb2cb$export$2e2bcd8739ae039)(config));
            return $a48ed584738bab49$var$_objectSpread({}, baseReducer(restState, action), {
                _persist: _persist
            });
        } else if (action.type === (0, $3e9167b9503b8931$export$2aaee4793dd13a52)) {
            action.result(_persistoid && _persistoid.flush());
            return $a48ed584738bab49$var$_objectSpread({}, baseReducer(restState, action), {
                _persist: _persist
            });
        } else if (action.type === (0, $3e9167b9503b8931$export$dd1033c27a16bbd3)) _paused = true;
        else if (action.type === (0, $3e9167b9503b8931$export$1647ef958242c4e2)) {
            // noop on restState if purging
            if (_purge) return $a48ed584738bab49$var$_objectSpread({}, restState, {
                _persist: $a48ed584738bab49$var$_objectSpread({}, _persist, {
                    rehydrated: true
                }) // @NOTE if key does not match, will continue to default else below
            });
            if (action.key === config.key) {
                var reducedState = baseReducer(restState, action);
                var inboundState = action.payload; // only reconcile state if stateReconciler and inboundState are both defined
                var reconciledRest = stateReconciler !== false && inboundState !== undefined ? stateReconciler(inboundState, state, reducedState, config) : reducedState;
                var _newState = $a48ed584738bab49$var$_objectSpread({}, reconciledRest, {
                    _persist: $a48ed584738bab49$var$_objectSpread({}, _persist, {
                        rehydrated: true
                    })
                });
                return conditionalUpdate(_newState);
            }
        } // if we have not already handled PERSIST, straight passthrough
        if (!_persist) return baseReducer(state, action); // run base reducer:
        // is state modified ? return original : return updated
        var newState = baseReducer(restState, action);
        if (newState === restState) return state;
        return conditionalUpdate($a48ed584738bab49$var$_objectSpread({}, newState, {
            _persist: _persist
        }));
    };
}




function $d3a3251829fe7871$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $d3a3251829fe7871$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $d3a3251829fe7871$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $d3a3251829fe7871$var$_typeof(obj);
}
function $d3a3251829fe7871$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d3a3251829fe7871$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $d3a3251829fe7871$var$ownKeys(source, true).forEach(function(key) {
            $d3a3251829fe7871$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $d3a3251829fe7871$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $d3a3251829fe7871$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d3a3251829fe7871$export$2e2bcd8739ae039(inboundState, originalState, reducedState, _ref) {
    var debug = _ref.debug;
    var newState = $d3a3251829fe7871$var$_objectSpread({}, reducedState); // only rehydrate if inboundState exists and is an object
    if (inboundState && $d3a3251829fe7871$var$_typeof(inboundState) === 'object') Object.keys(inboundState).forEach(function(key) {
        // ignore _persist data
        if (key === '_persist') return; // if reducer modifies substate, skip auto rehydration
        if (originalState[key] !== reducedState[key]) return;
        if ($d3a3251829fe7871$var$isPlainEnoughObject(reducedState[key])) {
            // if object is plain enough shallow merge the new values (hence "Level2")
            newState[key] = $d3a3251829fe7871$var$_objectSpread({}, newState[key], {}, inboundState[key]);
            return;
        } // otherwise hard set
        newState[key] = inboundState[key];
    });
    return newState;
}
function $d3a3251829fe7871$var$isPlainEnoughObject(o) {
    return o !== null && !Array.isArray(o) && $d3a3251829fe7871$var$_typeof(o) === 'object';
}


function $228d6bb06fb0e924$export$2e2bcd8739ae039(config, reducers) {
    config.stateReconciler = config.stateReconciler === undefined ? (0, $d3a3251829fe7871$export$2e2bcd8739ae039) : config.stateReconciler;
    return (0, $a48ed584738bab49$export$2e2bcd8739ae039)(config, (0, $5c178e598efca549$export$66e4520cdb265d18)(reducers));
}




function $b0e8dc2b8938c053$var$_toConsumableArray(arr) {
    return $b0e8dc2b8938c053$var$_arrayWithoutHoles(arr) || $b0e8dc2b8938c053$var$_iterableToArray(arr) || $b0e8dc2b8938c053$var$_nonIterableSpread();
}
function $b0e8dc2b8938c053$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function $b0e8dc2b8938c053$var$_iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function $b0e8dc2b8938c053$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    }
}
function $b0e8dc2b8938c053$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b0e8dc2b8938c053$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $b0e8dc2b8938c053$var$ownKeys(source, true).forEach(function(key) {
            $b0e8dc2b8938c053$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $b0e8dc2b8938c053$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $b0e8dc2b8938c053$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $b0e8dc2b8938c053$var$initialState = {
    registry: [],
    bootstrapped: false
};
var $b0e8dc2b8938c053$var$persistorReducer = function persistorReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $b0e8dc2b8938c053$var$initialState;
    var action = arguments.length > 1 ? arguments[1] : undefined;
    switch(action.type){
        case 0, $3e9167b9503b8931$export$51e82cdd7353a0e1:
            return $b0e8dc2b8938c053$var$_objectSpread({}, state, {
                registry: [].concat($b0e8dc2b8938c053$var$_toConsumableArray(state.registry), [
                    action.key
                ])
            });
        case 0, $3e9167b9503b8931$export$1647ef958242c4e2:
            var firstIndex = state.registry.indexOf(action.key);
            var registry = $b0e8dc2b8938c053$var$_toConsumableArray(state.registry);
            registry.splice(firstIndex, 1);
            return $b0e8dc2b8938c053$var$_objectSpread({}, state, {
                registry: registry,
                bootstrapped: registry.length === 0
            });
        default:
            return state;
    }
};
function $b0e8dc2b8938c053$export$2e2bcd8739ae039(store, options, cb) {
    var optionsToTest, bannedKeys;
    var boostrappedCb = cb || false;
    var _pStore = (0, $5c178e598efca549$export$f51a9068ac82ea43)($b0e8dc2b8938c053$var$persistorReducer, $b0e8dc2b8938c053$var$initialState, options && options.enhancer ? options.enhancer : undefined);
    var register = function register(key) {
        _pStore.dispatch({
            type: (0, $3e9167b9503b8931$export$51e82cdd7353a0e1),
            key: key
        });
    };
    var rehydrate = function rehydrate(key, payload, err) {
        var rehydrateAction = {
            type: (0, $3e9167b9503b8931$export$1647ef958242c4e2),
            payload: payload,
            err: err,
            key: key // dispatch to `store` to rehydrate and `persistor` to track result
        };
        store.dispatch(rehydrateAction);
        _pStore.dispatch(rehydrateAction);
        if (boostrappedCb && persistor.getState().bootstrapped) {
            boostrappedCb();
            boostrappedCb = false;
        }
    };
    var persistor = $b0e8dc2b8938c053$var$_objectSpread({}, _pStore, {
        purge: function purge() {
            var results = [];
            store.dispatch({
                type: (0, $3e9167b9503b8931$export$5514fc3b4067675f),
                result: function result(purgeResult) {
                    results.push(purgeResult);
                }
            });
            return Promise.all(results);
        },
        flush: function flush() {
            var results = [];
            store.dispatch({
                type: (0, $3e9167b9503b8931$export$2aaee4793dd13a52),
                result: function result(flushResult) {
                    results.push(flushResult);
                }
            });
            return Promise.all(results);
        },
        pause: function pause() {
            store.dispatch({
                type: (0, $3e9167b9503b8931$export$dd1033c27a16bbd3)
            });
        },
        persist: function persist() {
            store.dispatch({
                type: (0, $3e9167b9503b8931$export$913fe0e161ed92a2),
                register: register,
                rehydrate: rehydrate
            });
        }
    });
    if (!(options && options.manualPersist)) persistor.persist();
    return persistor;
}



function $4efebc71d7ca038f$export$2e2bcd8739ae039(migrations, config) {
    var _ref = config || {}, debug = _ref.debug;
    return function(state, currentVersion) {
        if (!state) return Promise.resolve(undefined);
        var inboundVersion = state._persist && state._persist.version !== undefined ? state._persist.version : (0, $3e9167b9503b8931$export$363ebe89e6e7aeef);
        if (inboundVersion === currentVersion) return Promise.resolve(state);
        if (inboundVersion > currentVersion) return Promise.resolve(state);
        var migrationKeys = Object.keys(migrations).map(function(ver) {
            return parseInt(ver);
        }).filter(function(key) {
            return currentVersion >= key && key > inboundVersion;
        }).sort(function(a, b) {
            return a - b;
        });
        try {
            var migratedState = migrationKeys.reduce(function(state, versionKey) {
                return migrations[versionKey](state);
            }, state);
            return Promise.resolve(migratedState);
        } catch (err) {
            return Promise.reject(err);
        }
    };
}


function $247c4c3fa6d98096$export$2e2bcd8739ae039(inbound, outbound) {
    var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var whitelist = config.whitelist || null;
    var blacklist = config.blacklist || null;
    function whitelistBlacklistCheck(key) {
        if (whitelist && whitelist.indexOf(key) === -1) return true;
        if (blacklist && blacklist.indexOf(key) !== -1) return true;
        return false;
    }
    return {
        in: function _in(state, key, fullState) {
            return !whitelistBlacklistCheck(key) && inbound ? inbound(state, key, fullState) : state;
        },
        out: function out(state, key, fullState) {
            return !whitelistBlacklistCheck(key) && outbound ? outbound(state, key, fullState) : state;
        }
    };
}









var $tZqWC = parcelRequire("tZqWC");
function $13ecfebde8ebdf60$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $13ecfebde8ebdf60$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $13ecfebde8ebdf60$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $13ecfebde8ebdf60$var$_typeof(obj);
}
function $13ecfebde8ebdf60$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $13ecfebde8ebdf60$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $13ecfebde8ebdf60$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $13ecfebde8ebdf60$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $13ecfebde8ebdf60$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $13ecfebde8ebdf60$var$_possibleConstructorReturn(self, call) {
    if (call && ($13ecfebde8ebdf60$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $13ecfebde8ebdf60$var$_assertThisInitialized(self);
}
function $13ecfebde8ebdf60$var$_getPrototypeOf(o) {
    $13ecfebde8ebdf60$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $13ecfebde8ebdf60$var$_getPrototypeOf(o);
}
function $13ecfebde8ebdf60$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $13ecfebde8ebdf60$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $13ecfebde8ebdf60$var$_setPrototypeOf(subClass, superClass);
}
function $13ecfebde8ebdf60$var$_setPrototypeOf(o, p) {
    $13ecfebde8ebdf60$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $13ecfebde8ebdf60$var$_setPrototypeOf(o, p);
}
function $13ecfebde8ebdf60$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $13ecfebde8ebdf60$export$311ca220e7478cda = /*#__PURE__*/ function(_PureComponent) {
    $13ecfebde8ebdf60$var$_inherits(PersistGate, _PureComponent);
    function PersistGate() {
        var _getPrototypeOf2;
        var _this;
        $13ecfebde8ebdf60$var$_classCallCheck(this, PersistGate);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $13ecfebde8ebdf60$var$_possibleConstructorReturn(this, (_getPrototypeOf2 = $13ecfebde8ebdf60$var$_getPrototypeOf(PersistGate)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        $13ecfebde8ebdf60$var$_defineProperty($13ecfebde8ebdf60$var$_assertThisInitialized(_this), "state", {
            bootstrapped: false
        });
        $13ecfebde8ebdf60$var$_defineProperty($13ecfebde8ebdf60$var$_assertThisInitialized(_this), "_unsubscribe", void 0);
        $13ecfebde8ebdf60$var$_defineProperty($13ecfebde8ebdf60$var$_assertThisInitialized(_this), "handlePersistorState", function() {
            var persistor = _this.props.persistor;
            var _persistor$getState = persistor.getState(), bootstrapped = _persistor$getState.bootstrapped;
            if (bootstrapped) {
                if (_this.props.onBeforeLift) Promise.resolve(_this.props.onBeforeLift()).finally(function() {
                    return _this.setState({
                        bootstrapped: true
                    });
                });
                else _this.setState({
                    bootstrapped: true
                });
                _this._unsubscribe && _this._unsubscribe();
            }
        });
        return _this;
    }
    $13ecfebde8ebdf60$var$_createClass(PersistGate, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this._unsubscribe = this.props.persistor.subscribe(this.handlePersistorState);
                this.handlePersistorState();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this._unsubscribe && this._unsubscribe();
            }
        },
        {
            key: "render",
            value: function render() {
                if (typeof this.props.children === 'function') return this.props.children(this.state.bootstrapped);
                return this.state.bootstrapped ? this.props.children : this.props.loading;
            }
        }
    ]);
    return PersistGate;
}((0, $tZqWC.PureComponent));
$13ecfebde8ebdf60$var$_defineProperty($13ecfebde8ebdf60$export$311ca220e7478cda, "defaultProps", {
    children: null,
    loading: null
});


var $fb9370d62a468f4f$export$1e511d4a378977f5;
var $fb9370d62a468f4f$export$2e2bcd8739ae039;
"use strict";
$fb9370d62a468f4f$export$1e511d4a378977f5 = true;
$fb9370d62a468f4f$export$2e2bcd8739ae039 = void 0;

var $fb9370d62a468f4f$var$_createWebStorage = $fb9370d62a468f4f$var$_interopRequireDefault((parcelRequire("hrvvF")));
function $fb9370d62a468f4f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $fb9370d62a468f4f$var$_default = (0, $fb9370d62a468f4f$var$_createWebStorage.default)('local');
$fb9370d62a468f4f$export$2e2bcd8739ae039 = $fb9370d62a468f4f$var$_default;



var $4L3zM = parcelRequire("4L3zM");


const $60681f6b40aafbc7$var$initialState = {
    documentToDeleteID: null
};
const $60681f6b40aafbc7$var$store = (0, $def02af5c61b0dea$export$4d8d9bd83c24ae8b)({
    name: 'ai',
    initialState: $60681f6b40aafbc7$var$initialState,
    reducers: {
        setDocumentToDeleteID: (state, { payload: payload })=>{
            if (payload) state.documentToDeleteID = payload;
            else state.documentToDeleteID = null;
        }
    }
});
var $60681f6b40aafbc7$export$2e2bcd8739ae039 = $60681f6b40aafbc7$var$store;



const $92860901d8aca1fe$var$initialState = {
    isLoggedIn: true,
    hasAccessToFeatures: true,
    userToDeact: {},
    apiKeyToDelete: {}
};
const $92860901d8aca1fe$var$store = (0, $def02af5c61b0dea$export$4d8d9bd83c24ae8b)({
    name: 'auth',
    initialState: $92860901d8aca1fe$var$initialState,
    reducers: {
        updateRole: (state)=>{
            state.role = 'dev';
        },
        updateAccessToFeatures: (state, { payload: payload })=>{
            if (payload) state.hasAccessToFeatures = payload;
            else state.hasAccessToFeatures = true;
        },
        setUserToDeact: (state, { payload: payload })=>{
            if (payload) state.userToDeact = payload;
            else state.userToDeact = null;
        },
        setApiKeyToDelete: (state, { payload: payload })=>{
            if (payload) state.apiKeyToDelete = payload;
            else state.apiKeyToDelete = null;
        }
    }
});
var $92860901d8aca1fe$export$2e2bcd8739ae039 = $92860901d8aca1fe$var$store;



const $4f3a43474747e760$var$initialState = {
    addressHistoryDetails: {
        address_id: '',
        address: '',
        chain: ''
    },
    addressReportDetails: {
        address_id: '',
        address: '',
        chain: ''
    },
    addressLinkDetails: {
        link_id: '',
        link_type: ''
    },
    addressSearchDetails: {
        link_id: '',
        link_type: ''
    },
    addressLinkData: {
        account_id: ''
    },
    addressRemove: {
        address_id: ''
    },
    addressDetails: {
        address_id: '',
        address: '',
        chain: '',
        integration_id: ''
    },
    scannedAddress: {
        address: '',
        chain: '',
        symbol: '',
        symbol_icon: '',
        financial_data: {
            provider_name: '',
            balance: 0,
            balance_usd: 0,
            spent: 0,
            spent_usd: 0,
            received: 0,
            received_usd: 0,
            transaction_count: 0,
            latest_activity: '',
            tokens: []
        },
        risk_data: {
            provider_name: '',
            risk_score: 0,
            risk_descriptors: [
                ''
            ],
            vasp_name_legal: '',
            vasp_name_business: '',
            vasp_website: '',
            vasp_category: '',
            api_result_id: ''
        },
        request_tz: ''
    },
    scannedAddressDetails: {},
    addressChains: null,
    defaultAddressProvider: {
    }
};
const $4f3a43474747e760$var$store = (0, $def02af5c61b0dea$export$4d8d9bd83c24ae8b)({
    name: 'address',
    initialState: $4f3a43474747e760$var$initialState,
    reducers: {
        setAddressHistoryDetails: (state, { payload: payload })=>{
            const { address_id: address_id, address: address, chain: chain } = payload;
            const payloadToAppend = {
                address_id: address_id,
                address: address,
                chain: chain
            };
            state.addressHistoryDetails = payloadToAppend;
        },
        setAddressReportDetails: (state, { payload: payload })=>{
            const { address_id: address_id, address: address, chain: chain } = payload;
            const payloadToAppend = {
                address_id: address_id,
                address: address,
                chain: chain
            };
            state.addressReportDetails = payloadToAppend;
        },
        setAddressLinkDetails: (state, { payload: payload })=>{
            // const { address_id, address, chain } = payload
            // const payloadToAppend = { address_id, address, chain }
            state.addressLinkDetails = payload;
        },
        setAddressLinkData: (state, { payload: payload })=>{
            // const { address_id, address, chain } = payload
            // const payloadToAppend = { address_id, address, chain }
            state.addressLinkData = payload;
        },
        setAddressRemove: (state, { payload: payload })=>{
            const { address_id: address_id } = payload;
            const payloadToAppend = {
                address_id: address_id
            };
            state.addressRemove = payloadToAppend;
        },
        setAddressDetails: (state, { payload: payload })=>{
            const { address_id: address_id, address: address, chain: chain } = payload;
            const payloadToAppend = {
                address_id: address_id,
                address: address,
                chain: chain
            };
            state.addressDetails = payloadToAppend;
        },
        setScannedAddress: (state, { payload: payload })=>{
            if (payload) state.scannedAddress = payload;
            else state.scannedAddress = null;
        },
        setScannedAddressDetails: (state, { payload: payload })=>{
            if (payload) state.scannedAddressDetails = payload;
            else state.scannedAddressDetails = null;
        },
        setAddressChains: (state, { payload: payload })=>{
            if (payload) state.addressChains = payload;
            else state.addressChains = null;
        },
        setDefaultAddressProvider: (state, { payload: payload })=>{
            if (payload) state.defaultAddressProvider = payload;
            else state.defaultAddressProvider = null;
        },
        setAddressSearchDetails: (state, { payload: payload })=>{
            if (payload) state.addressSearchDetails = payload;
            else state.addressSearchDetails = null;
        }
    }
});
var $4f3a43474747e760$export$2e2bcd8739ae039 = $4f3a43474747e760$var$store;



const $2c740eeaca2a0a2c$var$initialState = {
    transactionHistoryDetails: {
        transaction_id: '',
        transaction: '',
        chain: ''
    },
    transactionReportDetails: {
        transaction_id: '',
        transaction: '',
        chain: ''
    },
    transactionLinkDetails: {
        link_id: '',
        link_type: ''
    },
    transactionLinkData: {
        account_id: ''
    },
    transactionRemove: {
        transaction_id: ''
    },
    transactionDetails: {
        transaction_id: '',
        transaction: '',
        chain: '',
        integration_id: ''
    },
    transactionModalDetails: {},
    scannedTransaction: {
    },
    scannedTransactionDetails: {},
    transactionChains: {
    },
    defaultTransactionProvider: {
    }
};
const $2c740eeaca2a0a2c$var$store = (0, $def02af5c61b0dea$export$4d8d9bd83c24ae8b)({
    name: 'transaction',
    initialState: $2c740eeaca2a0a2c$var$initialState,
    reducers: {
        setTransactionHistoryDetails: (state, { payload: payload })=>{
            const { transaction_id: transaction_id, transaction: transaction, chain: chain } = payload;
            const payloadToAppend = {
                transaction_id: transaction_id,
                transaction: transaction,
                chain: chain
            };
            state.transactionHistoryDetails = payloadToAppend;
        },
        setTransactionReportDetails: (state, { payload: payload })=>{
            const { transaction_id: transaction_id, transaction: transaction, chain: chain } = payload;
            const payloadToAppend = {
                transaction_id: transaction_id,
                transaction: transaction,
                chain: chain
            };
            state.transactionReportDetails = payloadToAppend;
        },
        setTransactionLinkDetails: (state, { payload: payload })=>{
            // const { transaction_id, transaction, chain } = payload
            // const payloadToAppend = { transaction_id, transaction, chain }
            state.transactionLinkDetails = payload;
        },
        setTransactionLinkData: (state, { payload: payload })=>{
            // const { transaction_id, transaction, chain } = payload
            // const payloadToAppend = { transaction_id, transaction, chain }
            state.transactionLinkData = payload;
        },
        setTransactionRemove: (state, { payload: payload })=>{
            const { transaction_id: transaction_id } = payload;
            const payloadToAppend = {
                transaction_id: transaction_id
            };
            state.transactionRemove = payloadToAppend;
        },
        setTransactionDetails: (state, { payload: payload })=>{
            const { transaction_id: transaction_id, transaction: transaction, chain: chain } = payload;
            const payloadToAppend = {
                transaction_id: transaction_id,
                transaction: transaction,
                chain: chain
            };
            state.transactionDetails = payloadToAppend;
        },
        setTransactionModalDetails: (state, { payload: payload })=>{
            if (payload) state.transactionModalDetails = payload;
            else state.transactionModalDetails = null;
        },
        setScannedTransaction: (state, { payload: payload })=>{
            if (payload) state.scannedTransaction = payload;
            else state.scannedTransaction = null;
        },
        setScannedTransactionDetails: (state, { payload: payload })=>{
            if (payload) state.scannedTransactionDetails = payload;
            else state.scannedTransactionDetails = null;
        },
        setTransactionChains: (state, { payload: payload })=>{
            if (payload) state.transactionChains = payload;
            else state.transactionChains = null;
        },
        setDefaultTransactionProvider: (state, { payload: payload })=>{
            if (payload) state.defaultTransactionProvider = payload;
            else state.defaultTransactionProvider = null;
        }
    }
});
var $2c740eeaca2a0a2c$export$2e2bcd8739ae039 = $2c740eeaca2a0a2c$var$store;



const $9d0ec60b729f5908$var$initialState = {
    activeModule: '',
    activePage: '',
    activeInvestigationModule: '',
    showHeaderLoader: false,
    infoModalDetails: {
        title: '',
        content: '',
        loading: false
    },
    approveVaspDetails: {
        vasp_id: '',
        vasp_name: ''
    },
    rejectVaspDetails: {
        vasp_id: '',
        vasp_name: ''
    },
    updateTransferModalStatus: {
        confirmed: false
    },
    updateTransferModalData: {
        title: '',
        content: ''
    },
    isRemoveUserModalOpen: false,
    isRemoveApiKeyModalOpen: false,
    isCreateApiKeyModalOpen: false,
    isDeleteAddressModalOpen: false,
    isDeleteAddressNoteModalOpen: false,
    isDeleteTransactionModalOpen: false,
    isDeleteTransactionNoteModalOpen: false,
    isDeleteAiDocModalOpen: false,
    isChooseKYCUploadModalOpen: false,
    isAddressHistoryModalOpen: false,
    isAddressReportModalOpen: false,
    isTransactionHistoryModalOpen: false,
    isTransactionReportModalOpen: false,
    isTransferReportModalOpen: false,
    isInfoModalOpen: false,
    isApproveVaspModalOpen: false,
    isRejectVaspModalOpen: false,
    isUpdateTransferModalOpen: false,
    isTransactionDetailsModalOpen: false,
    isExploreAccountModalOpen: false,
    isUpgradeModalOpen: false,
    isAddressSearchModalOpen: false,
    isAiDocumentUploadModalOpen: false,
    isRecordUpdated: false,
    isPageTableUpdated: false,
    isProfileUpdated: false,
    isNotifUpdated: false,
    isAppSidebarDrawerOpen: false,
    isIndividualAccountDrawerOpen: false,
    isEntityAccountDrawerOpen: false,
    isIndividualRecipientDrawerOpen: false,
    isEntityRecipientDrawerOpen: false,
    isVaspDrawerOpen: false,
    isTransferDrawerOpen: false,
    isLinkAddressDrawerOpen: false,
    isLinkTransactionDrawerOpen: false,
    isUserDrawerOpen: false,
    isRequestVaspModalOpen: false
};
const $9d0ec60b729f5908$var$store = (0, $def02af5c61b0dea$export$4d8d9bd83c24ae8b)({
    name: 'ui',
    initialState: $9d0ec60b729f5908$var$initialState,
    reducers: {
        setActiveModule: (state, { payload: payload })=>{
            state.activeModule = payload;
        },
        setActivePage: (state, { payload: payload })=>{
            state.activePage = payload;
        },
        setInfoModalDetails: (state, { payload: payload })=>{
            if (payload) {
                const { title: title, content: content, loading: loading } = payload;
                state.infoModalDetails = {
                    title: title,
                    content: content,
                    loading: loading
                };
            } else state.infoModalDetails = {
                title: '',
                content: '',
                loading: false
            };
        },
        setActiveInvestigationModule: (state, { payload: payload })=>{
            state.activeInvestigationModule = payload;
        },
        setShowHeaderLoader: (state, { payload: payload })=>{
            state.showHeaderLoader = payload;
        },
        setApproveVaspDetails: (state, { payload: payload })=>{
            state.approveVaspDetails = payload || {
                vasp_id: '',
                vasp_name: ''
            };
        },
        setRejectVaspDetails: (state, { payload: payload })=>{
            state.rejectVaspDetails = payload || {
                vasp_id: '',
                vasp_name: ''
            };
        },
        setUpdateTransferModalStatus: (state, { payload: payload })=>{
            state.updateTransferModalStatus = payload || {
                confirmed: false
            };
        },
        setUpdateTransferModalData: (state, { payload: payload })=>{
            state.updateTransferModalData = payload || {
                title: '',
                content: ''
            };
        },
        //*
        toggleRemoveUserModal: (state)=>{
            state.isRemoveUserModalOpen = !state.isRemoveUserModalOpen;
        },
        toggleRemoveApiKeyModal: (state)=>{
            state.isRemoveApiKeyModalOpen = !state.isRemoveApiKeyModalOpen;
        },
        toggleCreateApiKeyModal: (state)=>{
            state.isCreateApiKeyModalOpen = !state.isCreateApiKeyModalOpen;
        },
        toggleDeleteAddressModal: (state)=>{
            state.isDeleteAddressModalOpen = !state.isDeleteAddressModalOpen;
        },
        toggleDeleteAddressNoteModal: (state)=>{
            state.isDeleteAddressNoteModalOpen = !state.isDeleteAddressNoteModalOpen;
        },
        toggleDeleteTransactionModal: (state)=>{
            state.isDeleteTransactionModalOpen = !state.isDeleteTransactionModalOpen;
        },
        toggleDeleteTransactionNoteModal: (state)=>{
            state.isDeleteTransactionNoteModalOpen = !state.isDeleteTransactionNoteModalOpen;
        },
        toggleDeleteAiDocModalOpen: (state)=>{
            state.isDeleteAiDocModalOpen = !state.isDeleteAiDocModalOpen;
        },
        toggleChooseKYCUploadModal: (state)=>{
            state.isChooseKYCUploadModalOpen = !state.isChooseKYCUploadModalOpen;
        },
        toggleAddressHistoryModal: (state)=>{
            state.isAddressHistoryModalOpen = !state.isAddressHistoryModalOpen;
        },
        toggleAddressReportModal: (state)=>{
            state.isAddressReportModalOpen = !state.isAddressReportModalOpen;
        },
        toggleTransactionHistoryModal: (state)=>{
            state.isTransactionHistoryModalOpen = !state.isTransactionHistoryModalOpen;
        },
        toggleTransactionReportModal: (state)=>{
            state.isTransactionReportModalOpen = !state.isTransactionReportModalOpen;
        },
        toggleTransferReportModal: (state)=>{
            state.isTransferReportModalOpen = !state.isTransferReportModalOpen;
        },
        toggleInfoModal: (state, { payload: payload })=>{
            if (payload !== undefined || payload !== null) state.isInfoModalOpen = payload;
            else state.isInfoModalOpen = !state.isInfoModalOpen;
        },
        setApproveVaspModal: (state, { payload: payload })=>{
            if (payload !== undefined || payload !== null) state.isApproveVaspModalOpen = payload;
            else state.isApproveVaspModalOpen = !state.isApproveVaspModalOpen;
        },
        setRejectVaspModal: (state, { payload: payload })=>{
            if (payload !== undefined || payload !== null) state.isRejectVaspModalOpen = payload;
            else state.isRejectVaspModalOpen = !state.isRejectVaspModalOpen;
        },
        toggleUpdateTransferModal: (state)=>{
            state.isUpdateTransferModalOpen = !state.isUpdateTransferModalOpen;
        },
        toggleTransactionDetailsModalOpen: (state)=>{
            state.isTransactionDetailsModalOpen = !state.isTransactionDetailsModalOpen;
        },
        toggleExploreAccountModalOpen: (state)=>{
            state.isExploreAccountModalOpen = !state.isExploreAccountModalOpen;
        },
        toggleUpgradeModal: (state)=>{
            state.isUpgradeModalOpen = !state.isUpgradeModalOpen;
        },
        setIsAddressSearchModalOpen: (state, { payload: payload })=>{
            if (payload !== undefined || payload !== null) state.isAddressSearchModalOpen = payload;
            else state.isAddressSearchModalOpen = !state.isAddressSearchModalOpen;
        },
        //*
        setIsRecordUpdated: (state, { payload: payload })=>{
            state.isRecordUpdated = payload;
        },
        setIsPageTableUpdated: (state, { payload: payload })=>{
            state.isPageTableUpdated = payload;
        },
        setIsProfileUpdated: (state, { payload: payload })=>{
            state.isProfileUpdated = payload;
        },
        setIsNotifUpdated: (state, { payload: payload })=>{
            state.isNotifUpdated = payload;
        },
        //*
        openAppSidebarDrawer: (state)=>{
            state.isAppSidebarDrawerOpen = true;
        },
        closeAppSidebarDrawer: (state)=>{
            state.isAppSidebarDrawerOpen = false;
        },
        //*
        setIsIndividualAccountDrawerOpen: (state, { payload: payload })=>{
            state.isIndividualAccountDrawerOpen = payload || false;
        },
        setIsEntityAccountDrawerOpen: (state, { payload: payload })=>{
            state.isEntityAccountDrawerOpen = payload || false;
        },
        setIsIndividualRecipientDrawerOpen: (state, { payload: payload })=>{
            state.isIndividualRecipientDrawerOpen = payload || false;
        },
        setIsEntityRecipientDrawerOpen: (state, { payload: payload })=>{
            state.isEntityRecipientDrawerOpen = payload || false;
        },
        setIsVaspDrawerOpen: (state, { payload: payload })=>{
            state.isVaspDrawerOpen = payload || false;
        },
        setIsTransferDrawerOpen: (state, { payload: payload })=>{
            state.isTransferDrawerOpen = payload || false;
        },
        setIsLinkAddressDrawerOpen: (state, { payload: payload })=>{
            state.isLinkAddressDrawerOpen = payload || false;
        },
        setIsLinkTransactionDrawerOpen: (state, { payload: payload })=>{
            state.isLinkTransactionDrawerOpen = payload || false;
        },
        setIsUserDrawerOpen: (state, { payload: payload })=>{
            state.isUserDrawerOpen = payload || false;
        },
        setIsRequestVaspModalOpen: (state, { payload: payload })=>{
            state.isRequestVaspModalOpen = payload || false;
        },
        setIsAiDocumentUploadModalOpen: (state, { payload: payload })=>{
            state.isAiDocumentUploadModalOpen = payload || false;
        }
    }
});
var $9d0ec60b729f5908$export$2e2bcd8739ae039 = $9d0ec60b729f5908$var$store;



const $b5bf28f73c1093a8$var$initialState = {
    countryListOptions: [],
    activityToRemove: {
        type: '',
        hash: ''
    },
    addressOrTransactionIdToAssign: {
        type: '',
        id: '',
        caseId: ''
    },
    createdAccount: null,
    createdRecipient: null,
    createdVasp: null,
    toBeUpdatedAccount: null,
    toBeUpdatedRecipient: null,
    toBeUpdatedVasp: null
};
const $b5bf28f73c1093a8$var$store = (0, $def02af5c61b0dea$export$4d8d9bd83c24ae8b)({
    name: 'form',
    initialState: $b5bf28f73c1093a8$var$initialState,
    reducers: {
        setCountryListOptions: (state, { payload: payload })=>{
            console.trace();
            state.countryListOptions = payload;
        },
        setActivityToRemove: (state, { payload: payload })=>{
            state.activityToRemove = payload;
        },
        setAddressOrTransactionIdToAssign: (state, { payload: payload })=>{
            state.addressOrTransactionIdToAssign = payload;
        },
        setCreatedAccount: (state, { payload: payload })=>{
            state.createdAccount = payload || null;
        },
        setCreatedRecipient: (state, { payload: payload })=>{
            state.createdRecipient = payload || null;
        },
        setCreatedVasp: (state, { payload: payload })=>{
            state.createdVasp = payload || null;
        },
        setToBeUpdatedAccount: (state, { payload: payload })=>{
            state.toBeUpdatedAccount = payload || null;
        },
        setToBeUpdatedRecipient: (state, { payload: payload })=>{
            state.toBeUpdatedRecipient = payload || null;
        },
        setToBeUpdatedVasp: (state, { payload: payload })=>{
            state.toBeUpdatedVasp = payload || undefined;
        }
    }
});
var $b5bf28f73c1093a8$export$2e2bcd8739ae039 = $b5bf28f73c1093a8$var$store;



const $af39ee0d70d31cfb$var$initialState = {
    initialNodeData: {
        type: '',
        hash: '',
        chain: '',
        asset: '',
        value: '',
        valueUsd: '',
        riskScore: '',
        color: '',
        flag: '',
        lastActivity: '',
        children: []
    }
};
const $af39ee0d70d31cfb$var$store = (0, $def02af5c61b0dea$export$4d8d9bd83c24ae8b)({
    name: 'investigation',
    initialState: $af39ee0d70d31cfb$var$initialState,
    reducers: {
        setInitialNodeData: (state, { payload: payload })=>{
            state.initialNodeData = payload;
        }
    }
});
var $af39ee0d70d31cfb$export$2e2bcd8739ae039 = $af39ee0d70d31cfb$var$store;



const $1ddcddfb6f1887a6$var$initialState = {
    alertList: {
        open: false,
        message: 'None',
        type: 'error',
        duration: 3000
    }
};
const $1ddcddfb6f1887a6$var$store = (0, $def02af5c61b0dea$export$4d8d9bd83c24ae8b)({
    name: 'alert',
    initialState: $1ddcddfb6f1887a6$var$initialState,
    reducers: {
        showAlert: (state, { payload: payload })=>{
            const { message: message, type: type } = payload;
            const payloadToAppend = {
                open: true,
                message: message,
                type: type,
                duration: 3000
            };
            state.alertList = payloadToAppend;
        },
        showPersistentAlert: (state, { payload: payload })=>{
            const { message: message, type: type } = payload;
            const payloadToAppend = {
                open: true,
                message: message,
                type: type,
                duration: 60000
            };
            state.alertList = payloadToAppend;
        },
        closeAlert: (state)=>{
            state.alertList = {};
        }
    }
});
var $1ddcddfb6f1887a6$export$2e2bcd8739ae039 = $1ddcddfb6f1887a6$var$store;




var $ejSM7 = parcelRequire("ejSM7");
const $41a9e38e6be32f35$export$1bceb808939a9f0c = 'YYYY-MM-DD';
const $41a9e38e6be32f35$export$c003002ffeb9f3c0 = 'YYYY MM DD';
const $41a9e38e6be32f35$export$859ef203c4495ed2 = 'YYYY-MM-DD, hh:mm';
const $41a9e38e6be32f35$export$67a03cd247c60132 = 'YYYY-MM-DD';


// Assets




const $f398806f8c37b1c3$export$d631eb4fd6125e2b = [
    {
        value: true,
        label: 'Yes'
    },
    {
        value: false,
        label: 'No'
    }
];
const $f398806f8c37b1c3$export$c12542e899d17513 = [
    {
        value: 10,
        label: '10 Per Page'
    },
    {
        value: 20,
        label: '20 Per Page'
    },
    {
        value: 30,
        label: '30 Per Page'
    },
    {
        value: 40,
        label: '40 Per Page'
    },
    {
        value: 50,
        label: '50 Per Page'
    },
    {
        value: 100,
        label: '100 Per Page'
    }
];
const $f398806f8c37b1c3$export$1602228db68db5a2 = [
    {
        value: 'customer',
        label: 'Customer'
    },
    {
        value: 'non-customer',
        label: 'Non-Customer'
    }
];
const $f398806f8c37b1c3$export$e7143bbefb1abdd7 = [
    {
        value: 'all',
        label: 'All'
    },
    {
        value: 'customer',
        label: 'Customer'
    },
    {
        value: 'non-customer',
        label: 'Non-Customer'
    }
];
const $f398806f8c37b1c3$export$ba280eda23443882 = {
    customer: {
        value: 'customer',
        label: 'Customer'
    },
    nonCustomer: {
        value: 'non-customer',
        label: 'Non-Customer'
    },
    all: {
        value: 'all',
        label: 'All'
    }
};
const $f398806f8c37b1c3$export$788d60523da67a3d = [
    {
        value: 0,
        label: 'Overview'
    }
];
const $f398806f8c37b1c3$export$969ddde627a04710 = [
    {
        value: 0,
        label: 'Activity'
    },
    {
        value: 1,
        label: 'Account Details'
    }
];
const $f398806f8c37b1c3$export$a1047fed33151c40 = [
    // { value: 0, label: 'Activity' },
    {
        value: 0,
        label: 'Transactions'
    },
    {
        value: 1,
        label: 'Travel Rule'
    },
    {
        value: 2,
        label: 'Alerts'
    }
];
const $f398806f8c37b1c3$export$480784e1043d360 = [
    {
        value: 1,
        label: 'User'
    },
    {
        value: 1,
        label: 'Super User'
    },
    {
        value: 2,
        label: 'Admin'
    }
];
const $f398806f8c37b1c3$export$6096865e4aa58c8a = [
    {
        value: 1,
        label: 'Individual'
    },
    {
        value: 2,
        label: 'Entity'
    }
];
const $f398806f8c37b1c3$export$e4493caf40597bf1 = [
    {
        value: 0,
        label: 'Inactive'
    },
    {
        value: 1,
        label: 'Active'
    },
    {
        value: 2,
        label: 'On Hold'
    },
    {
        value: 3,
        label: 'Dormant'
    }
];
const $f398806f8c37b1c3$export$ac88620a652f8304 = [
    {
        value: 0,
        label: '-'
    },
    {
        value: 1,
        label: 'Low'
    },
    {
        value: 2,
        label: 'Medium'
    },
    {
        value: 3,
        label: 'High'
    }
];
const $f398806f8c37b1c3$export$25da77dc5a049837 = [
    {
        value: 1,
        label: 'No'
    },
    {
        value: 2,
        label: 'Yes'
    }
];
const $f398806f8c37b1c3$export$387652efbf140906 = [
    {
        value: 1,
        label: 'Bank'
    },
    {
        value: 2,
        label: 'Asset Provider'
    }
];
const $f398806f8c37b1c3$export$e15fc428f51df618 = [
    {
        value: 1,
        label: 'Teacher'
    },
    {
        value: 2,
        label: 'Software Developer'
    }
];
const $f398806f8c37b1c3$export$879b0a313b10655e = [
    {
        value: false,
        label: 'Account'
    },
    {
        value: true,
        label: 'Non-Customer'
    }
];
const $f398806f8c37b1c3$export$390dad8ed933960f = [
    {
        value: 'Case_Since',
        label: 'Case Since'
    },
    {
        value: 'AddressCount',
        label: 'Address Count'
    },
    {
        value: 'TxCount',
        label: 'Transaction Count'
    }
];
const $f398806f8c37b1c3$export$b5af4da0b7df094e = [
    {
        value: 0,
        label: 'Not Available'
    },
    {
        value: 1,
        label: 'No'
    },
    {
        value: 2,
        label: 'Yes'
    }
];
const $f398806f8c37b1c3$export$9f6eacc7441dfea9 = [
    {
        value: 'bitcoin',
        label: 'Bitcoin',
        abrv: 'BTC',
        icon: (0, {}),
        regex: {
            transaction: /^[a-fA-F0-9]{64}$/,
            address: /^[13][a-km-zA-HJ-NP-Z1-9]{25,34}$/
        }
    },
    {
        value: 'ethereum',
        label: 'Ethereum',
        abrv: 'ETH',
        icon: (0, {}),
        regex: {
            transaction: /^0x([A-Fa-f0-9]{64})$/,
            address: /^(0x){1}[0-9a-fA-F]{40}/
        }
    },
    {
        value: 'bitcoin-cash',
        label: 'Bitcoin Cash',
        abrv: 'BCH',
        icon: (0, {}),
        regex: {
            /* transaction id regex identifies any SHA256 hash */ transaction: /[0-9a-f]{64}/,
            address: /[13][a-km-zA-HJ-NP-Z1-9]{33}/
        }
    },
    {
        value: 'litecoin',
        label: 'Litecoin',
        abrv: 'LTC',
        icon: (0, {}),
        regex: {
            /* transaction id regex identifies any Scrypt hash */ transaction: /^\\$s0\\$[0-9a-f]{5,6}\\$[a-zA-Z0-9/+]+[=]*\\$[a-zA-Z0-9/+]+[=]*$/,
            address: /[lm3][a-zA-Z0-9]{26,42}|[LM3][a-km-zA-HJ-NP-Z1-9]{26,33}/
        }
    }
];
const $f398806f8c37b1c3$export$cfce4cc2a24073 = [
    {
        value: 'BTC',
        label: 'BTC'
    },
    {
        value: 'ETH',
        label: 'ETH'
    },
    {
        value: 'BCH',
        label: 'BCH'
    },
    {
        value: 'LTC',
        label: 'LTC'
    },
    {
        value: 'BSV',
        label: 'BSV'
    },
    {
        value: 'DOGE',
        label: 'DOGE'
    },
    {
        value: 'ZEC',
        label: 'ZEC'
    },
    {
        value: 'XRP',
        label: 'XRP'
    },
    {
        value: 'XLM',
        label: 'XLM'
    },
    {
        value: 'XDC',
        label: 'XDC'
    },
    {
        value: 'SOL',
        label: 'SOL'
    },
    {
        value: 'ALGO',
        label: 'ALGO'
    },
    {
        value: 'MATIC',
        label: 'MATIC'
    },
    {
        value: 'DOT',
        label: 'DOT'
    },
    {
        value: 'XTZ',
        label: 'XTZ'
    },
    {
        value: 'NEAR',
        label: 'NEAR'
    }
];
const $f398806f8c37b1c3$export$53c0b7944743072a = {
    ALGO: {
        dti: 'M8Z9JSG9Q',
        chain: 'ALGO',
        chain_name: 'algorand'
    },
    BTC: {
        dti: '4H95J0R2X',
        chain: 'BTC',
        chain_name: 'bitcoin'
    },
    BCH: {
        dti: 'J9K583ZGG',
        chain: 'BCH',
        chain_name: 'bitcoin-cash'
    },
    BSV: {
        dti: '2L8HS2MNP',
        chain: 'BSV',
        chain_name: 'bitcoin-sv'
    },
    DASH: {
        dti: 'M5D76SHV5',
        chain: 'DASH',
        chain_name: 'dash'
    },
    DOGE: {
        dti: '820B7G1NL',
        chain: 'DOGE',
        chain_name: 'doge'
    },
    ETH: {
        dti: 'X9J9K872S',
        chain: 'ETH',
        chain_name: 'ethereum'
    },
    LTC: {
        dti: 'WTX0G7K46',
        chain: 'LTC',
        chain_name: 'litecoin'
    },
    NEAR: {
        dti: 'DC83NXWML',
        chain: 'NEAR',
        chain_name: 'near'
    },
    ROSE: {
        dti: 'NVD7LRM61',
        chain: 'ROSE',
        chain_name: 'oasis'
    },
    OP: {
        dti: '9NRMM2RC4',
        chain: 'OP',
        chain_name: 'optimism'
    },
    DOT: {
        dti: 'P5B46MFPP',
        chain: 'DOT',
        chain_name: 'polkadot'
    },
    MATIC: {
        dti: 'RQWW6J6K0',
        chain: 'MATIC',
        chain_name: 'polygon'
    },
    XRP: {
        dti: 'L6GTZC9G4',
        chain: 'XRP',
        chain_name: 'ripple'
    },
    SOL: {
        dti: '20J63Z4N3',
        chain: 'SOL',
        chain_name: 'solana'
    },
    XLM: {
        dti: 'C4SRNZD8K',
        chain: 'XLM',
        chain_name: 'stellar'
    },
    XTZ: {
        dti: '7VTRKSC7S',
        chain: 'XTZ',
        chain_name: 'tezos'
    },
    XDC: {
        dti: 'CCQZQXFDC',
        chain: 'XDC',
        chain_name: 'xdc'
    },
    ZEC: {
        dti: '3DHMJ5Q02',
        chain: 'ZEC',
        chain_name: 'zcash'
    }
};
const $f398806f8c37b1c3$export$7000f41a852f3e5 = {
    bitcoin: 'bitcoin',
    ethereum: 'ethereum',
    litecoin: 'litecoin',
    'bitcoin-cash': 'bitcoin-cash',
    'bitcoin-sv': 'bitcoin-sv',
    doge: 'doge',
    zcash: 'zcash',
    ripple: 'ripple',
    stellar: 'stellar',
    xdc: 'xdc',
    solana: 'solana',
    algorand: 'algorand',
    polygon: 'polygon',
    polkadot: 'polkadot',
    tezos: 'tezos',
    near: 'near'
};
const $f398806f8c37b1c3$export$2078812dcc559f01 = {
    BTC: 'bitcoin',
    ETH: 'ethereum',
    LTC: 'litecoin',
    BCH: 'bitcoin-cash',
    BSV: 'bitcoin-sv',
    DOGE: 'doge',
    ZEC: 'zcash',
    XRP: 'ripple',
    XLM: 'stellar',
    XDC: 'xdc',
    SOL: 'solana',
    ALGO: 'algorand',
    MATIC: 'polygon',
    DOT: 'polkadot',
    XTZ: 'tezos',
    NEAR: 'near'
};
const $f398806f8c37b1c3$export$ee40726984762919 = {
    address: 1,
    transaction: 2,
    directory: 3
};
const $f398806f8c37b1c3$export$8b2bc8759ae1fa3a = [
    {
        value: 'scores',
        label: 'Risk Scores'
    },
    {
        value: 'financials',
        label: 'Financial Details'
    },
    {
        value: 'link_id',
        label: 'Associated Account'
    }
];
const $f398806f8c37b1c3$export$22efbd5ad1f2c0ec = [
    {
        value: 'inputs',
        label: 'Input Events'
    },
    {
        value: 'outputs',
        label: 'Output Events'
    }
];
const $f398806f8c37b1c3$export$4b0b8bccc82aecb4 = [
    {
        value: 'last_month',
        label: 'Last month'
    },
    {
        value: 'last_6_months',
        label: 'Last 6 months'
    },
    {
        value: 'last_12_months',
        label: 'Last 12 months'
    }
];
const $f398806f8c37b1c3$export$1e0b44d7c26be259 = {
    last_month: {
        value: 'last_month',
        label: 'Last month'
    },
    last_6_months: {
        value: 'last_6_months',
        label: 'Last 6 months'
    },
    last_12_months: {
        value: 'last_12_months',
        label: 'Last 12 months'
    }
};
const $f398806f8c37b1c3$export$b56212d6dd5ac0d7 = [
    {
        value: 'csv',
        label: 'CSV'
    },
    {
        value: 'pdf',
        label: 'PDF'
    }
];
const $f398806f8c37b1c3$export$48abd99a9d2a7899 = {
    bitcoin: {
        disabled: false,
        value: 'bitcoin',
        label: 'bitcoin'
    },
    ethereum: {
        disabled: false,
        value: 'ethereum',
        label: 'ethereum'
    },
    litecoin: {
        disabled: false,
        value: 'litecoin',
        label: 'litecoin'
    },
    bitcoin_cash: {
        disabled: true,
        value: 'bitcoin-cash',
        label: 'bitcoin-cash'
    },
    bitcoin_sv: {
        disabled: true,
        value: 'bitcoin-sv',
        label: 'bitcoin-sv'
    },
    doge: {
        disabled: true,
        value: 'doge',
        label: 'doge'
    },
    dash: {
        disabled: true,
        value: 'dash',
        label: 'dash'
    },
    zcash: {
        disabled: true,
        value: 'zcash',
        label: 'zcash'
    },
    groestlcoin: {
        disabled: true,
        value: 'groestlcoin',
        label: 'groestlcoin'
    },
    cardano: {
        disabled: true,
        value: 'cardano',
        label: 'cardano'
    },
    solana: {
        disabled: true,
        value: 'solana',
        label: 'solana'
    },
    eos: {
        disabled: true,
        value: 'eos',
        label: 'eos'
    },
    ethereum_classic: {
        disabled: true,
        value: 'ethereum-classic',
        label: 'ethereum-classic'
    },
    ripple: {
        disabled: true,
        value: 'ripple',
        label: 'ripple'
    },
    xdc: {
        disabled: true,
        value: 'xdc',
        label: 'xdc'
    },
    stellar: {
        disabled: true,
        value: 'stellar',
        label: 'stellar'
    },
    algorand: {
        disabled: true,
        value: 'algorand',
        label: 'algorand'
    },
    tron: {
        disabled: true,
        value: 'tron',
        label: 'tron'
    },
    polygon: {
        disabled: true,
        value: 'polygon',
        label: 'polygon'
    },
    syscoin: {
        disabled: true,
        value: 'syscoin',
        label: 'syscoin'
    },
    xinfin: {
        disabled: true,
        value: 'xinfin',
        label: 'xinfin'
    }
};
const $f398806f8c37b1c3$export$5dcccb4958458517 = [
    {
        value: '0183c0fe-3f2b-7d4f-8a02-941b8a4f3442',
        label: 'RDBIG'
    },
    {
        value: '0183c0fe-3f3a-76f7-9cf4-af0b628d068c',
        label: 'RDCFI'
    },
    {
        value: '018379b8-a215-71bd-a8e8-001e812812c1',
        label: 'RDCSL'
    },
    {
        value: '0183c15e-8d17-7c8d-ae5c-c6a645d8fd7a',
        label: 'RDCTR'
    }
];
const $f398806f8c37b1c3$export$77157746a83277ad = [
    {
        value: '01836485-906e-7d3f-a6aa-c6134d6384b8',
        label: 'FDBLC'
    },
    {
        value: '0183c101-f0e6-7a1e-84d1-ecdddd045437',
        label: 'Crypto Compare'
    }
];
const $f398806f8c37b1c3$export$aa3828c5134f3b80 = {
    '018379b8-a215-71bd-a8e8-001e812812c1': 'RDCSL',
    '0183c0fe-3f2b-7d4f-8a02-941b8a4f3442': 'RDBIG',
    '0183c15e-8d17-7c8d-ae5c-c6a645d8fd7a': 'RDCTR',
    '0183c0fe-3f3a-76f7-9cf4-af0b628d068c': 'RDCFI'
};
const $f398806f8c37b1c3$export$896b6d2be20bb187 = {
    bitcoin: '^[13][a-km-zA-HJ-NP-Z1-9]{25,34}$',
    ethereum: '/(\b0x[a-f0-9]{40}\b)/g',
    litecoin: '/^L[a-zA-Z0-9]{26,33}$/'
};
const $f398806f8c37b1c3$export$36a704e1fcbca502 = [
    {
        chain: 'bitcoin',
        regex: '^[13][a-km-zA-HJ-NP-Z1-9]{25,34}$'
    },
    {
        chain: 'ethereum',
        regex: '/(\b0x[a-f0-9]{40}\b)/g'
    },
    {
        chain: 'litecoin',
        regex: '/^L[a-zA-Z0-9]{26,33}$/'
    }
];
const $f398806f8c37b1c3$export$240fb83e234eca1c = [
    {
        disabled: false,
        value: 'bitcoin',
        label: 'bitcoin'
    },
    {
        disabled: false,
        value: 'ethereum',
        label: 'ethereum'
    },
    {
        disabled: false,
        value: 'litecoin',
        label: 'litecoin'
    },
    {
        disabled: false,
        value: 'bitcoin-cash',
        label: 'bitcoin-cash'
    },
    {
        disabled: false,
        value: 'doge',
        label: 'doge'
    },
    {
        disabled: false,
        value: 'solana',
        label: 'solana'
    },
    {
        disabled: false,
        value: 'ripple',
        label: 'ripple'
    },
    {
        disabled: false,
        value: 'xdc',
        label: 'xdc'
    },
    {
        disabled: false,
        value: 'stellar',
        label: 'stellar'
    },
    {
        disabled: false,
        value: 'algorand',
        label: 'algorand'
    },
    {
        disabled: false,
        value: 'polygon',
        label: 'polygon'
    },
    {
        disabled: false,
        value: 'polkadot',
        label: 'polkadot'
    },
    {
        disabled: false,
        value: 'tezos',
        label: 'tezos'
    },
    {
        disabled: false,
        value: 'near',
        label: 'near'
    },
    {
        disabled: false,
        value: 'xinfin',
        label: 'xinfin'
    }
];
const $f398806f8c37b1c3$export$57f5ee0e57b5098e = [
    {
        disabled: false,
        value: 'bitcoin',
        label: 'bitcoin'
    },
    {
        disabled: false,
        value: 'ethereum',
        label: 'ethereum'
    },
    {
        disabled: false,
        value: 'litecoin',
        label: 'litecoin'
    },
    {
        disabled: false,
        value: 'bitcoin-cash',
        label: 'bitcoin-cash'
    },
    {
        disabled: false,
        value: 'doge',
        label: 'doge'
    },
    {
        disabled: false,
        value: 'solana',
        label: 'solana'
    },
    {
        disabled: false,
        value: 'ripple',
        label: 'ripple'
    },
    {
        disabled: false,
        value: 'xdc',
        label: 'xdc'
    },
    {
        disabled: false,
        value: 'stellar',
        label: 'stellar'
    },
    {
        disabled: true,
        value: 'algorand',
        label: 'algorand'
    },
    {
        disabled: true,
        value: 'polygon',
        label: 'polygon'
    },
    {
        disabled: true,
        value: 'polkadot',
        label: 'polkadot'
    },
    {
        disabled: true,
        value: 'tezos',
        label: 'tezos'
    },
    {
        disabled: true,
        value: 'near',
        label: 'near'
    },
    {
        disabled: true,
        value: 'xinfin',
        label: 'xinfin'
    }
];
const $f398806f8c37b1c3$export$bd7ef7143357c357 = {
    bitcoin: true,
    ethereum: true,
    litecoin: true,
    'bitcoin-cash': true,
    'bitcoin-sv': true,
    doge: true,
    zcash: true,
    ripple: true,
    stellar: true,
    xdc: true
};
const $f398806f8c37b1c3$export$139deef207d16f27 = {
    bitcoin: true,
    ethereum: true,
    litecoin: true,
    'bitcoin-cash': true,
    'bitcoin-sv': true,
    doge: true,
    zcash: true,
    solana: true,
    ripple: true,
    stellar: true,
    algorand: true,
    polygon: true,
    polkadot: true,
    tezos: true,
    near: true
};
const $f398806f8c37b1c3$export$e40ddf4c9d6fc9cc = {
    bitcoin: '0183c0fe-3f2b-7d4f-8a02-941b8a4f3442',
    ethereum: '0183c0fe-3f2b-7d4f-8a02-941b8a4f3442',
    litecoin: '0183c0fe-3f2b-7d4f-8a02-941b8a4f3442',
    'bitcoin-cash': '0183c0fe-3f2b-7d4f-8a02-941b8a4f3442',
    'bitcoin-sv': '0183c0fe-3f2b-7d4f-8a02-941b8a4f3442',
    doge: '0183c0fe-3f2b-7d4f-8a02-941b8a4f3442',
    zcash: '0183c0fe-3f2b-7d4f-8a02-941b8a4f3442',
    ripple: '0183c0fe-3f2b-7d4f-8a02-941b8a4f3442',
    stellar: '0183c0fe-3f2b-7d4f-8a02-941b8a4f3442',
    //
    solana: '0183c0fe-3f3a-76f7-9cf4-af0b628d068c',
    algorand: '0183c0fe-3f3a-76f7-9cf4-af0b628d068c',
    polygon: '0183c0fe-3f3a-76f7-9cf4-af0b628d068c',
    polkadot: '0183c0fe-3f3a-76f7-9cf4-af0b628d068c',
    tezos: '0183c0fe-3f3a-76f7-9cf4-af0b628d068c',
    near: '0183c0fe-3f3a-76f7-9cf4-af0b628d068c'
};
const $f398806f8c37b1c3$export$504a2eb15af43985 = {
    RDBIG: $f398806f8c37b1c3$export$bd7ef7143357c357,
    RDCFI: $f398806f8c37b1c3$export$139deef207d16f27
};
const $f398806f8c37b1c3$export$a1293b6f12329fc4 = [
    {
        zoneName: 'Pacific/Pago_Pago',
        value: 'GMT-11',
        label: '(GMT-11:00) Pacific/Pago_Pago'
    },
    {
        zoneName: 'Pacific/Midway',
        value: 'GMT-11',
        label: '(GMT-11:00) Pacific/Midway'
    },
    {
        zoneName: 'Pacific/Honolulu',
        value: 'GMT-10',
        label: '(GMT-10:00) Pacific/Honolulu'
    },
    {
        zoneName: 'Pacific/Rarotonga',
        value: 'GMT-10',
        label: '(GMT-10:00) Pacific/Rarotonga'
    },
    {
        zoneName: 'Pacific/Tahiti',
        value: 'GMT-10',
        label: '(GMT-10:00) Pacific/Tahiti'
    },
    {
        zoneName: 'Pacific/Marquesas',
        value: 'GMT-9',
        label: '(GMT-09:30) Pacific/Marquesas'
    },
    {
        zoneName: 'America/Anchorage',
        value: 'GMT-8',
        label: '(GMT-08:00) America/Anchorage'
    },
    {
        zoneName: 'America/Los_Angeles',
        value: 'GMT-7',
        label: '(GMT-07:00) America/Los_Angeles'
    },
    {
        zoneName: 'America/Denver',
        value: 'GMT-6',
        label: '(GMT-06:00) America/Denver'
    },
    {
        zoneName: 'America/Chicago',
        value: 'GMT-5',
        label: '(GMT-05:00) America/Chicago'
    },
    {
        zoneName: 'America/New_York',
        value: 'GMT-4',
        label: '(GMT-04:00) America/New_York'
    },
    {
        zoneName: 'America/Caracas',
        value: 'GMT-4',
        label: '(GMT-04:00) America/Caracas'
    },
    {
        zoneName: 'America/Sao_Paulo',
        value: 'GMT-3',
        label: '(GMT-03:00) America/Sao_Paulo'
    },
    {
        zoneName: 'America/Argentina/Buenos_Aires',
        value: 'GMT-3',
        label: '(GMT-03:00) America/Argentina/Buenos_Aires'
    },
    {
        zoneName: 'Atlantic/South_Georgia',
        value: 'GMT-2',
        label: '(GMT-02:00) Atlantic/South_Georgia'
    },
    {
        zoneName: 'Atlantic/Azores',
        value: 'GMT-1',
        label: '(GMT-01:00) Atlantic/Azores'
    },
    {
        zoneName: 'Europe/London',
        value: 'GMT+0',
        label: '(GMT+00:00) Europe/London'
    },
    {
        zoneName: 'Europe/Paris',
        value: 'GMT+1',
        label: '(GMT+01:00) Europe/Paris'
    },
    {
        zoneName: 'Europe/Athens',
        value: 'GMT+2',
        label: '(GMT+02:00) Europe/Athens'
    },
    {
        zoneName: 'Europe/Moscow',
        value: 'GMT+3',
        label: '(GMT+03:00) Europe/Moscow'
    },
    {
        zoneName: 'Asia/Dubai',
        value: 'GMT+4',
        label: '(GMT+04:00) Asia/Dubai'
    },
    {
        zoneName: 'Asia/Kolkata',
        value: 'GMT+5',
        label: '(GMT+05:30) Asia/Kolkata'
    },
    {
        zoneName: 'Asia/Kathmandu',
        value: 'GMT+5',
        label: '(GMT+05:45) Asia/Kathmandu'
    },
    {
        zoneName: 'Asia/Dhaka',
        value: 'GMT+6',
        label: '(GMT+06:00) Asia/Dhaka'
    },
    {
        zoneName: 'Asia/Bangkok',
        value: 'GMT+7',
        label: '(GMT+07:00) Asia/Bangkok'
    },
    {
        zoneName: 'Asia/Hong_Kong',
        value: 'GMT+8',
        label: '(GMT+08:00) Asia/Hong_Kong'
    },
    {
        zoneName: 'Asia/Tokyo',
        value: 'GMT+9',
        label: '(GMT+09:00) Asia/Tokyo'
    },
    {
        zoneName: 'Australia/Sydney',
        value: 'GMT+10',
        label: '(GMT+10:00) Australia/Sydney'
    },
    {
        zoneName: 'Pacific/Noumea',
        value: 'GMT+11',
        label: '(GMT+11:00) Pacific/Noumea'
    },
    {
        zoneName: 'Pacific/Auckland',
        value: 'GMT+12',
        label: '(GMT+12:00) Pacific/Auckland'
    }
];
const $f398806f8c37b1c3$export$71c31dec0f381b7e = [
    {
        value: 'flow',
        label: 'Flow',
        disabled: false
    },
    {
        value: 'trisa',
        label: 'TRISA',
        disabled: false
    },
    {
        value: 'trp',
        label: 'TRP',
        disabled: true
    },
    {
        value: 'gtr',
        label: 'GTR',
        disabled: true
    }
];
const $f398806f8c37b1c3$export$81d62d4c398740e0 = [
    {
        value: 'ARNU',
        label: 'ARNU'
    },
    {
        value: 'CCPT',
        label: 'CCPT'
    },
    {
        value: 'DRLC',
        label: 'DRLC'
    },
    {
        value: 'FIIN',
        label: 'FIIN'
    },
    {
        value: 'SOCS',
        label: 'SOCS'
    },
    {
        value: 'IDCD',
        label: 'IDCD'
    },
    {
        value: 'MISC',
        label: 'MISC'
    }
];
const $f398806f8c37b1c3$export$4f81732cc85b5d1d = [
    {
        value: 'RAID',
        label: 'RAID'
    },
    {
        value: 'TXID',
        label: 'TXID'
    },
    {
        value: 'LEIX',
        label: 'LEIX'
    },
    {
        value: 'MISC',
        label: 'MISC'
    }
];
const $f398806f8c37b1c3$export$1d9e1f0caa6e0145 = [
    {
        value: 'ARNU',
        label: 'ARNU'
    },
    {
        value: 'CCPT',
        label: 'CCPT'
    },
    {
        value: 'RAID',
        label: 'RAID'
    },
    {
        value: 'DRLC',
        label: 'DRLC'
    },
    {
        value: 'FIIN',
        label: 'FIIN'
    },
    {
        value: 'TXID',
        label: 'TXID'
    },
    {
        value: 'SOCS',
        label: 'SOCS'
    },
    {
        value: 'IDCD',
        label: 'IDCD'
    },
    {
        value: 'LEIX',
        label: 'LEIX'
    },
    {
        value: 'MISC',
        label: 'MISC'
    }
];
const $f398806f8c37b1c3$export$43fbb932cb09c7d = [
    {
        label: 'Manager',
        value: 1
    },
    {
        label: 'Basic User',
        value: 2
    }
];
const $f398806f8c37b1c3$export$d34134843134085a = {
    1: {
        label: 'Manager',
        value: 1
    },
    2: {
        label: 'Basic User',
        value: 2
    }
};


const $5f79b5b8d60834c3$var$initialState = {
    accountDirectoryFilters: {
        sort: '-created',
        page: 1,
        size: 10,
        account_type_id: undefined,
        status_id: undefined,
        account_category: (0, $f398806f8c37b1c3$export$ba280eda23443882).all.value
    },
    vaspDirectoryFilters: {
        sort: '-created',
        page: 1,
        size: 10
    },
    travelRuleFilters: {
        sort: '-last_modified',
        page: 1,
        size: 10,
        transfer_status_id: undefined,
        asset_code: undefined,
        protocol_code: undefined,
        direction: undefined,
        in_account_id: undefined,
        out_account_id: undefined,
        start_range: (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))('Jan 1 2008').format((0, $41a9e38e6be32f35$export$1bceb808939a9f0c)),
        end_range: (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))().add(1, 'days').format((0, $41a9e38e6be32f35$export$1bceb808939a9f0c))
    },
    addressFilters: {
        sort: '-last_modified',
        page: 1,
        size: 10,
        start_range: (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))('Jan 1 2008').format((0, $41a9e38e6be32f35$export$1bceb808939a9f0c)),
        end_range: (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))().format((0, $41a9e38e6be32f35$export$1bceb808939a9f0c))
    },
    transactionFilters: {
        sort: '-last_modified',
        page: 1,
        size: 10,
        start_range: (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))('Jan 1 2008').format((0, $41a9e38e6be32f35$export$1bceb808939a9f0c)),
        end_range: (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))().add(1, 'days').format((0, $41a9e38e6be32f35$export$1bceb808939a9f0c))
    },
    transactionEventsFilters: {
        page: 1,
        size: 10
    },
    addressDetailsFilters: {
        sort: '-last_modified',
        page: 1,
        size: 10,
        start_range: (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))('Jan 1 2008').format((0, $41a9e38e6be32f35$export$1bceb808939a9f0c)),
        end_range: (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))().format((0, $41a9e38e6be32f35$export$1bceb808939a9f0c))
    },
    addressHistoryFilters: {
        address: '',
        address_id: '',
        sort: '-last_modified',
        page: 1,
        size: 10,
        start_range: (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))('Jan 1 2008').format((0, $41a9e38e6be32f35$export$1bceb808939a9f0c)),
        end_range: (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))().format((0, $41a9e38e6be32f35$export$1bceb808939a9f0c))
    },
    reportsAddressFilters: {
        sort: '-created',
        page: 1,
        size: 10,
        start_range: (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))().subtract(30, 'days').format((0, $41a9e38e6be32f35$export$1bceb808939a9f0c)),
        end_range: (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))().format((0, $41a9e38e6be32f35$export$1bceb808939a9f0c))
    },
    reportsTransactionFilters: {
        sort: '-created',
        page: 1,
        size: 10,
        start_range: (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))().subtract(30, 'days').format((0, $41a9e38e6be32f35$export$1bceb808939a9f0c)),
        end_range: (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))().add(1, 'days').format((0, $41a9e38e6be32f35$export$1bceb808939a9f0c))
    },
    reportsTravelRuleFilters: {
        page: 1,
        size: 10
    },
    aiDocumentFilters: {
        page: 1,
        size: 10
    },
    aiDocumentChunkFilters: {
        page: 1,
        size: 10
    }
};
const $5f79b5b8d60834c3$var$store = (0, $def02af5c61b0dea$export$4d8d9bd83c24ae8b)({
    name: 'filters',
    initialState: $5f79b5b8d60834c3$var$initialState,
    reducers: {
        setAccountDirectoryFilters: (state, { payload: payload })=>{
            if (payload) state.accountDirectoryFilters = {
                ...state.accountDirectoryFilters,
                ...payload
            };
            else state.accountDirectoryFilters = $5f79b5b8d60834c3$var$initialState.accountDirectoryFilters;
        },
        setVaspDirectoryFilters: (state, { payload: payload })=>{
            if (payload) state.vaspDirectoryFilters = {
                ...state.vaspDirectoryFilters,
                ...payload
            };
            else state.vaspDirectoryFilters = $5f79b5b8d60834c3$var$initialState.vaspDirectoryFilters;
        },
        setTravelRuleFilters: (state, { payload: payload })=>{
            if (payload) state.travelRuleFilters = {
                ...state.travelRuleFilters,
                ...payload
            };
            else state.travelRuleFilters = $5f79b5b8d60834c3$var$initialState.travelRuleFilters;
        },
        setAddressFilters: (state, { payload: payload })=>{
            if (payload) state.addressFilters = {
                ...state.addressFilters,
                ...payload
            };
            else state.addressFilters = $5f79b5b8d60834c3$var$initialState.addressFilters;
        },
        setTransactionFilters: (state, { payload: payload })=>{
            if (payload) state.transactionFilters = {
                ...state.transactionFilters,
                ...payload
            };
            else state.transactionFilters = $5f79b5b8d60834c3$var$initialState.transactionFilters;
        },
        setTransactionEventsFilters: (state, { payload: payload })=>{
            if (payload) state.transactionEventsFilters = {
                ...state.transactionEventsFilters,
                ...payload
            };
            else state.transactionEventsFilters = $5f79b5b8d60834c3$var$initialState.transactionEventsFilters;
        },
        setAddressDetailsFilters: (state, { payload: payload })=>{
            if (payload) state.addressDetailsFilters = {
                ...state.addressDetailsFilters,
                ...payload
            };
            else state.addressDetailsFilters = $5f79b5b8d60834c3$var$initialState.addressDetailsFilters;
        },
        setAddressHistoryFilters: (state, { payload: payload })=>{
            if (payload) state.addressHistoryFilters = {
                ...state.addressHistoryFilters,
                ...payload
            };
            else state.addressHistoryFilters = $5f79b5b8d60834c3$var$initialState.addressHistoryFilters;
        },
        setReportsAddressFilters: (state, { payload: payload })=>{
            if (payload) state.reportsAddressFilters = {
                ...state.reportsAddressFilters,
                ...payload
            };
            else state.reportsAddressFilters = $5f79b5b8d60834c3$var$initialState.reportsAddressFilters;
        },
        setReportsTransactionFilters: (state, { payload: payload })=>{
            if (payload) state.reportsTransactionFilters = {
                ...state.reportsTransactionFilters,
                ...payload
            };
            else state.reportsTransactionFilters = $5f79b5b8d60834c3$var$initialState.reportsTransactionFilters;
        },
        setReportsTravelRuleFilters: (state, { payload: payload })=>{
            if (payload) state.reportsTravelRuleFilters = {
                ...state.reportsTravelRuleFilters,
                ...payload
            };
            else state.reportsTravelRuleFilters = $5f79b5b8d60834c3$var$initialState.reportsTravelRuleFilters;
        },
        setAiDocumentFilters: (state, { payload: payload })=>{
            if (payload) state.aiDocumentFilters = {
                ...state.aiDocumentFilters,
                ...payload
            };
            else state.aiDocumentFilters = $5f79b5b8d60834c3$var$initialState.aiDocumentFilters;
        },
        setAiDocumentChunkFilters: (state, { payload: payload })=>{
            if (payload) state.aiDocumentChunkFilters = {
                ...state.aiDocumentChunkFilters,
                ...payload
            };
            else state.aiDocumentChunkFilters = $5f79b5b8d60834c3$var$initialState.aiDocumentChunkFilters;
        }
    }
});
var $5f79b5b8d60834c3$export$2e2bcd8739ae039 = $5f79b5b8d60834c3$var$store;


const $2154a4c08d887b32$var$actionList = {
    ...(0, $60681f6b40aafbc7$export$2e2bcd8739ae039).actions,
    ...(0, $92860901d8aca1fe$export$2e2bcd8739ae039).actions,
    ...(0, $4f3a43474747e760$export$2e2bcd8739ae039).actions,
    ...(0, $2c740eeaca2a0a2c$export$2e2bcd8739ae039).actions,
    ...(0, $9d0ec60b729f5908$export$2e2bcd8739ae039).actions,
    ...(0, $b5bf28f73c1093a8$export$2e2bcd8739ae039).actions,
    ...(0, $af39ee0d70d31cfb$export$2e2bcd8739ae039).actions,
    ...(0, $1ddcddfb6f1887a6$export$2e2bcd8739ae039).actions,
    ...(0, $5f79b5b8d60834c3$export$2e2bcd8739ae039).actions
};
const $2154a4c08d887b32$var$reducerList = {
    ai: (0, $60681f6b40aafbc7$export$2e2bcd8739ae039).reducer,
    auth: (0, $92860901d8aca1fe$export$2e2bcd8739ae039).reducer,
    address: (0, $4f3a43474747e760$export$2e2bcd8739ae039).reducer,
    transaction: (0, $2c740eeaca2a0a2c$export$2e2bcd8739ae039).reducer,
    ui: (0, $9d0ec60b729f5908$export$2e2bcd8739ae039).reducer,
    form: (0, $b5bf28f73c1093a8$export$2e2bcd8739ae039).reducer,
    investigation: (0, $af39ee0d70d31cfb$export$2e2bcd8739ae039).reducer,
    alert: (0, $1ddcddfb6f1887a6$export$2e2bcd8739ae039).reducer,
    filters: (0, $5f79b5b8d60834c3$export$2e2bcd8739ae039).reducer
};
const $2154a4c08d887b32$export$76bc82b2dd65d969 = (0, $5c178e598efca549$export$66e4520cdb265d18)($2154a4c08d887b32$var$reducerList);
const $2154a4c08d887b32$export$e324594224ef24da = (dispatch)=>({
        actions: (0, $5c178e598efca549$export$aea084d96e84da92)($2154a4c08d887b32$var$actionList, dispatch)
    });


function $ea5d2799a316b2c2$var$AppStoreProvider(props) {
    // Destructure
    const { children: children } = props;
    // Variables
    const persistConfig = {
        key: 'root',
        blacklist: [
            'alert',
            'ui',
            'filters',
            'address',
            'transaction'
        ],
        storage: $fb9370d62a468f4f$export$2e2bcd8739ae039
    };
    const persistedReducer = (0, $a48ed584738bab49$export$2e2bcd8739ae039)(persistConfig, (0, $2154a4c08d887b32$export$76bc82b2dd65d969));
    const store = (0, $def02af5c61b0dea$export$7d8a5b498da695ac)({
        reducer: persistedReducer,
        middleware: (0, $def02af5c61b0dea$export$36c1185aeee5b0a6)({
            serializableCheck: false
        })
    });
    const persistor = (0, $b0e8dc2b8938c053$export$2e2bcd8739ae039)(store);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $44a4de761c3016e3$export$2e2bcd8739ae039), {
        store: store,
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $13ecfebde8ebdf60$export$311ca220e7478cda), {
            loading: null,
            persistor: persistor,
            children: children
        })
    });
}
var $ea5d2799a316b2c2$export$2e2bcd8739ae039 = $ea5d2799a316b2c2$var$AppStoreProvider;
// Proptypes Validation
$ea5d2799a316b2c2$var$AppStoreProvider.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ]).isRequired
};



parcelRequire("tZqWC");


var $3ff4724ea894d7ab$export$6acf61af03e62db = typeof window === 'undefined';
function $3ff4724ea894d7ab$export$8793edee2d425525() {
    return undefined;
}
function $3ff4724ea894d7ab$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === 'function' ? updater(input) : updater;
}
function $3ff4724ea894d7ab$export$e539f754e934e270(value) {
    return typeof value === 'number' && value >= 0 && value !== Infinity;
}
function $3ff4724ea894d7ab$export$4d32d63f64b825b9(value) {
    return Array.isArray(value) ? value : [
        value
    ];
}
function $3ff4724ea894d7ab$export$acaf96a27438246b(array1, array2) {
    return array1.filter(function(x) {
        return array2.indexOf(x) === -1;
    });
}
function $3ff4724ea894d7ab$export$224e3b7078227b8a(array, index, value) {
    var copy = array.slice(0);
    copy[index] = value;
    return copy;
}
function $3ff4724ea894d7ab$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $3ff4724ea894d7ab$export$8a11fbc2c8ea08fd(arg1, arg2, arg3) {
    if (!$3ff4724ea894d7ab$export$aaae5295ec3351c9(arg1)) return arg1;
    if (typeof arg2 === 'function') return (0, $dda4d40cf5733033$export$2e2bcd8739ae039)({}, arg3, {
        queryKey: arg1,
        queryFn: arg2
    });
    return (0, $dda4d40cf5733033$export$2e2bcd8739ae039)({}, arg2, {
        queryKey: arg1
    });
}
function $3ff4724ea894d7ab$export$b646c531ea475334(arg1, arg2, arg3) {
    if ($3ff4724ea894d7ab$export$aaae5295ec3351c9(arg1)) {
        if (typeof arg2 === 'function') return (0, $dda4d40cf5733033$export$2e2bcd8739ae039)({}, arg3, {
            mutationKey: arg1,
            mutationFn: arg2
        });
        return (0, $dda4d40cf5733033$export$2e2bcd8739ae039)({}, arg2, {
            mutationKey: arg1
        });
    }
    if (typeof arg1 === 'function') return (0, $dda4d40cf5733033$export$2e2bcd8739ae039)({}, arg2, {
        mutationFn: arg1
    });
    return (0, $dda4d40cf5733033$export$2e2bcd8739ae039)({}, arg1);
}
function $3ff4724ea894d7ab$export$18e8f4b987e6c111(arg1, arg2, arg3) {
    return $3ff4724ea894d7ab$export$aaae5295ec3351c9(arg1) ? [
        (0, $dda4d40cf5733033$export$2e2bcd8739ae039)({}, arg2, {
            queryKey: arg1
        }),
        arg3
    ] : [
        arg1 || {},
        arg2
    ];
}
function $3ff4724ea894d7ab$export$42387eeaac09cf54(arg1, arg2) {
    return $3ff4724ea894d7ab$export$aaae5295ec3351c9(arg1) ? (0, $dda4d40cf5733033$export$2e2bcd8739ae039)({}, arg2, {
        mutationKey: arg1
    }) : arg1;
}
function $3ff4724ea894d7ab$export$eafbe052e989494f(active, inactive) {
    if (active === true && inactive === true || active == null && inactive == null) return 'all';
    else if (active === false && inactive === false) return 'none';
    else {
        // At this point, active|inactive can only be true|false or false|true
        // so, when only one value is provided, the missing one has to be the negated value
        var isActive = active != null ? active : !inactive;
        return isActive ? 'active' : 'inactive';
    }
}
function $3ff4724ea894d7ab$export$c5d1efe363797780(filters, query) {
    var active = filters.active, exact = filters.exact, fetching = filters.fetching, inactive = filters.inactive, predicate = filters.predicate, queryKey = filters.queryKey, stale = filters.stale;
    if ($3ff4724ea894d7ab$export$aaae5295ec3351c9(queryKey)) {
        if (exact) {
            if (query.queryHash !== $3ff4724ea894d7ab$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$3ff4724ea894d7ab$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    var queryStatusFilter = $3ff4724ea894d7ab$export$eafbe052e989494f(active, inactive);
    if (queryStatusFilter === 'none') return false;
    else if (queryStatusFilter !== 'all') {
        var isActive = query.isActive();
        if (queryStatusFilter === 'active' && !isActive) return false;
        if (queryStatusFilter === 'inactive' && isActive) return false;
    }
    if (typeof stale === 'boolean' && query.isStale() !== stale) return false;
    if (typeof fetching === 'boolean' && query.isFetching() !== fetching) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $3ff4724ea894d7ab$export$a1ea5fb559f63ae3(filters, mutation) {
    var exact = filters.exact, fetching = filters.fetching, predicate = filters.predicate, mutationKey = filters.mutationKey;
    if ($3ff4724ea894d7ab$export$aaae5295ec3351c9(mutationKey)) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($3ff4724ea894d7ab$export$5fcb678681417b54(mutation.options.mutationKey) !== $3ff4724ea894d7ab$export$5fcb678681417b54(mutationKey)) return false;
        } else if (!$3ff4724ea894d7ab$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (typeof fetching === 'boolean' && mutation.state.status === 'loading' !== fetching) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $3ff4724ea894d7ab$export$cc90ca97bc0d73fd(queryKey, options) {
    var hashFn = (options == null ? void 0 : options.queryKeyHashFn) || $3ff4724ea894d7ab$export$5fcb678681417b54;
    return hashFn(queryKey);
}
function $3ff4724ea894d7ab$export$5fcb678681417b54(queryKey) {
    var asArray = $3ff4724ea894d7ab$export$4d32d63f64b825b9(queryKey);
    return $3ff4724ea894d7ab$export$e7f2f041280beb00(asArray);
}
function $3ff4724ea894d7ab$export$e7f2f041280beb00(value) {
    return JSON.stringify(value, function(_, val) {
        return $3ff4724ea894d7ab$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce(function(result, key) {
            result[key] = val[key];
            return result;
        }, {}) : val;
    });
}
function $3ff4724ea894d7ab$export$2f07189bb9fa26a7(a, b) {
    return $3ff4724ea894d7ab$export$3bc9138b70293839($3ff4724ea894d7ab$export$4d32d63f64b825b9(a), $3ff4724ea894d7ab$export$4d32d63f64b825b9(b));
}
function $3ff4724ea894d7ab$export$3bc9138b70293839(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === 'object' && typeof b === 'object') return !Object.keys(b).some(function(key) {
        return !$3ff4724ea894d7ab$export$3bc9138b70293839(a[key], b[key]);
    });
    return false;
}
function $3ff4724ea894d7ab$export$77a71fc411098696(a, b) {
    if (a === b) return a;
    var array = Array.isArray(a) && Array.isArray(b);
    if (array || $3ff4724ea894d7ab$export$53b83ca8eaab0383(a) && $3ff4724ea894d7ab$export$53b83ca8eaab0383(b)) {
        var aSize = array ? a.length : Object.keys(a).length;
        var bItems = array ? b : Object.keys(b);
        var bSize = bItems.length;
        var copy = array ? [] : {};
        var equalItems = 0;
        for(var i = 0; i < bSize; i++){
            var key = array ? i : bItems[i];
            copy[key] = $3ff4724ea894d7ab$export$77a71fc411098696(a[key], b[key]);
            if (copy[key] === a[key]) equalItems++;
        }
        return aSize === bSize && equalItems === aSize ? a : copy;
    }
    return b;
}
function $3ff4724ea894d7ab$export$3e67810a3f0e9f1c(a, b) {
    if (a && !b || b && !a) return false;
    for(var key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
} // Copied from: https://github.com/jonschlinkert/is-plain-object
function $3ff4724ea894d7ab$export$53b83ca8eaab0383(o) {
    if (!$3ff4724ea894d7ab$var$hasObjectPrototype(o)) return false;
     // If has modified constructor
    var ctor = o.constructor;
    if (typeof ctor === 'undefined') return true;
     // If has modified prototype
    var prot = ctor.prototype;
    if (!$3ff4724ea894d7ab$var$hasObjectPrototype(prot)) return false;
     // If constructor does not have an Object-specific method
    if (!prot.hasOwnProperty('isPrototypeOf')) return false;
     // Most likely a plain Object
    return true;
}
function $3ff4724ea894d7ab$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === '[object Object]';
}
function $3ff4724ea894d7ab$export$aaae5295ec3351c9(value) {
    return typeof value === 'string' || Array.isArray(value);
}
function $3ff4724ea894d7ab$export$e6127cc7fe7395c3(value) {
    return value instanceof Error;
}
function $3ff4724ea894d7ab$export$e772c8ff12451969(timeout) {
    return new Promise(function(resolve) {
        setTimeout(resolve, timeout);
    });
}
function $3ff4724ea894d7ab$export$4304cb76768ca134(callback) {
    Promise.resolve().then(callback).catch(function(error) {
        return setTimeout(function() {
            throw error;
        });
    });
}
function $3ff4724ea894d7ab$export$382ca5d13a8f252c() {
    if (typeof AbortController === 'function') return new AbortController();
}


function $f59fca9f0da9b49e$export$2e2bcd8739ae039(t, e) {
    return $f59fca9f0da9b49e$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $f59fca9f0da9b49e$export$2e2bcd8739ae039(t, e);
}


function $0ec1659a3a380451$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $f59fca9f0da9b49e$export$2e2bcd8739ae039)(t, o);
}






var $290db3e0ce227fd3$export$c3ab47f7c70c8aa4 = /*#__PURE__*/ function() {
    function NotifyManager() {
        this.queue = [];
        this.transactions = 0;
        this.notifyFn = function(callback) {
            callback();
        };
        this.batchNotifyFn = function(callback) {
            callback();
        };
    }
    var _proto = NotifyManager.prototype;
    _proto.batch = function batch(callback) {
        var result;
        this.transactions++;
        try {
            result = callback();
        } finally{
            this.transactions--;
            if (!this.transactions) this.flush();
        }
        return result;
    };
    _proto.schedule = function schedule(callback) {
        var _this = this;
        if (this.transactions) this.queue.push(callback);
        else (0, $3ff4724ea894d7ab$export$4304cb76768ca134)(function() {
            _this.notifyFn(callback);
        });
    };
    _proto.batchCalls = function batchCalls(callback) {
        var _this2 = this;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this2.schedule(function() {
                callback.apply(void 0, args);
            });
        };
    };
    _proto.flush = function flush() {
        var _this3 = this;
        var queue = this.queue;
        this.queue = [];
        if (queue.length) (0, $3ff4724ea894d7ab$export$4304cb76768ca134)(function() {
            _this3.batchNotifyFn(function() {
                queue.forEach(function(callback) {
                    _this3.notifyFn(callback);
                });
            });
        });
    };
    _proto.setNotifyFunction = function setNotifyFunction(fn) {
        this.notifyFn = fn;
    };
    _proto.setBatchNotifyFunction = function setBatchNotifyFunction(fn) {
        this.batchNotifyFn = fn;
    };
    return NotifyManager;
}(); // SINGLETON
var $290db3e0ce227fd3$export$520687f44db6e1ab = new $290db3e0ce227fd3$export$c3ab47f7c70c8aa4();


// TYPES
// FUNCTIONS
var $9489c5e76e62cc56$var$logger = console;
function $9489c5e76e62cc56$export$2b1d391cd05230fd() {
    return $9489c5e76e62cc56$var$logger;
}
function $9489c5e76e62cc56$export$3abbd92f765bee58(newLogger) {
    $9489c5e76e62cc56$var$logger = newLogger;
}



var $8d9dbc58b3471196$export$d26086b469ecdbcc = /*#__PURE__*/ function() {
    function Subscribable() {
        this.listeners = [];
    }
    var _proto = Subscribable.prototype;
    _proto.subscribe = function subscribe(listener) {
        var _this = this;
        var callback = listener || function() {
            return undefined;
        };
        this.listeners.push(callback);
        this.onSubscribe();
        return function() {
            _this.listeners = _this.listeners.filter(function(x) {
                return x !== callback;
            });
            _this.onUnsubscribe();
        };
    };
    _proto.hasListeners = function hasListeners() {
        return this.listeners.length > 0;
    };
    _proto.onSubscribe = function onSubscribe() {};
    _proto.onUnsubscribe = function onUnsubscribe() {};
    return Subscribable;
}();



var $3fbc886baa2b733b$export$86f1af424b2ca4de = /*#__PURE__*/ function(_Subscribable) {
    (0, $0ec1659a3a380451$export$2e2bcd8739ae039)(FocusManager, _Subscribable);
    function FocusManager() {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.setup = function(onFocus) {
            var _window;
            if (!(0, $3ff4724ea894d7ab$export$6acf61af03e62db) && ((_window = window) == null ? void 0 : _window.addEventListener)) {
                var listener = function listener() {
                    return onFocus();
                }; // Listen to visibillitychange and focus
                window.addEventListener('visibilitychange', listener, false);
                window.addEventListener('focus', listener, false);
                return function() {
                    // Be sure to unsubscribe if a new handler is set
                    window.removeEventListener('visibilitychange', listener);
                    window.removeEventListener('focus', listener);
                };
            }
        };
        return _this;
    }
    var _proto = FocusManager.prototype;
    _proto.onSubscribe = function onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    };
    _proto.onUnsubscribe = function onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    };
    _proto.setEventListener = function setEventListener(setup) {
        var _this$cleanup2, _this2 = this;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup(function(focused) {
            if (typeof focused === 'boolean') _this2.setFocused(focused);
            else _this2.onFocus();
        });
    };
    _proto.setFocused = function setFocused(focused) {
        this.focused = focused;
        if (focused) this.onFocus();
    };
    _proto.onFocus = function onFocus() {
        this.listeners.forEach(function(listener) {
            listener();
        });
    };
    _proto.isFocused = function isFocused() {
        if (typeof this.focused === 'boolean') return this.focused;
         // document global can be unavailable in react native
        if (typeof document === 'undefined') return true;
        return [
            undefined,
            'visible',
            'prerender'
        ].includes(document.visibilityState);
    };
    return FocusManager;
}((0, $8d9dbc58b3471196$export$d26086b469ecdbcc));
var $3fbc886baa2b733b$export$6bf54661be5b02cf = new $3fbc886baa2b733b$export$86f1af424b2ca4de();





var $e9ce68e672abc0c9$export$58774fb55d5ff7fc = /*#__PURE__*/ function(_Subscribable) {
    (0, $0ec1659a3a380451$export$2e2bcd8739ae039)(OnlineManager, _Subscribable);
    function OnlineManager() {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.setup = function(onOnline) {
            var _window;
            if (!(0, $3ff4724ea894d7ab$export$6acf61af03e62db) && ((_window = window) == null ? void 0 : _window.addEventListener)) {
                var listener = function listener() {
                    return onOnline();
                }; // Listen to online
                window.addEventListener('online', listener, false);
                window.addEventListener('offline', listener, false);
                return function() {
                    // Be sure to unsubscribe if a new handler is set
                    window.removeEventListener('online', listener);
                    window.removeEventListener('offline', listener);
                };
            }
        };
        return _this;
    }
    var _proto = OnlineManager.prototype;
    _proto.onSubscribe = function onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    };
    _proto.onUnsubscribe = function onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    };
    _proto.setEventListener = function setEventListener(setup) {
        var _this$cleanup2, _this2 = this;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup(function(online) {
            if (typeof online === 'boolean') _this2.setOnline(online);
            else _this2.onOnline();
        });
    };
    _proto.setOnline = function setOnline(online) {
        this.online = online;
        if (online) this.onOnline();
    };
    _proto.onOnline = function onOnline() {
        this.listeners.forEach(function(listener) {
            listener();
        });
    };
    _proto.isOnline = function isOnline() {
        if (typeof this.online === 'boolean') return this.online;
        if (typeof navigator === 'undefined' || typeof navigator.onLine === 'undefined') return true;
        return navigator.onLine;
    };
    return OnlineManager;
}((0, $8d9dbc58b3471196$export$d26086b469ecdbcc));
var $e9ce68e672abc0c9$export$b113e788b2dd3fdc = new $e9ce68e672abc0c9$export$58774fb55d5ff7fc();



function $23ca15fd0fb4402b$var$defaultRetryDelay(failureCount) {
    return Math.min(1000 * Math.pow(2, failureCount), 30000);
}
function $23ca15fd0fb4402b$export$22e08d49843051be(value) {
    return typeof (value == null ? void 0 : value.cancel) === 'function';
}
var $23ca15fd0fb4402b$export$a8430ed4188f35a9 = function CancelledError(options) {
    this.revert = options == null ? void 0 : options.revert;
    this.silent = options == null ? void 0 : options.silent;
};
function $23ca15fd0fb4402b$export$986cc6445c1d323(value) {
    return value instanceof $23ca15fd0fb4402b$export$a8430ed4188f35a9;
} // CLASS
var $23ca15fd0fb4402b$export$586a619a4618a582 = function Retryer(config) {
    var _this = this;
    var cancelRetry = false;
    var cancelFn;
    var continueFn;
    var promiseResolve;
    var promiseReject;
    this.abort = config.abort;
    this.cancel = function(cancelOptions) {
        return cancelFn == null ? void 0 : cancelFn(cancelOptions);
    };
    this.cancelRetry = function() {
        cancelRetry = true;
    };
    this.continueRetry = function() {
        cancelRetry = false;
    };
    this.continue = function() {
        return continueFn == null ? void 0 : continueFn();
    };
    this.failureCount = 0;
    this.isPaused = false;
    this.isResolved = false;
    this.isTransportCancelable = false;
    this.promise = new Promise(function(outerResolve, outerReject) {
        promiseResolve = outerResolve;
        promiseReject = outerReject;
    });
    var resolve = function resolve(value) {
        if (!_this.isResolved) {
            _this.isResolved = true;
            config.onSuccess == null || config.onSuccess(value);
            continueFn == null || continueFn();
            promiseResolve(value);
        }
    };
    var reject = function reject(value) {
        if (!_this.isResolved) {
            _this.isResolved = true;
            config.onError == null || config.onError(value);
            continueFn == null || continueFn();
            promiseReject(value);
        }
    };
    var pause = function pause() {
        return new Promise(function(continueResolve) {
            continueFn = continueResolve;
            _this.isPaused = true;
            config.onPause == null || config.onPause();
        }).then(function() {
            continueFn = undefined;
            _this.isPaused = false;
            config.onContinue == null || config.onContinue();
        });
    }; // Create loop function
    var run = function run() {
        // Do nothing if already resolved
        if (_this.isResolved) return;
        var promiseOrValue; // Execute query
        try {
            promiseOrValue = config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        } // Create callback to cancel this fetch
        cancelFn = function cancelFn(cancelOptions) {
            if (!_this.isResolved) {
                reject(new $23ca15fd0fb4402b$export$a8430ed4188f35a9(cancelOptions));
                _this.abort == null || _this.abort(); // Cancel transport if supported
                if ($23ca15fd0fb4402b$export$22e08d49843051be(promiseOrValue)) try {
                    promiseOrValue.cancel();
                } catch (_unused) {}
            }
        }; // Check if the transport layer support cancellation
        _this.isTransportCancelable = $23ca15fd0fb4402b$export$22e08d49843051be(promiseOrValue);
        Promise.resolve(promiseOrValue).then(resolve).catch(function(error) {
            var _config$retry, _config$retryDelay;
            // Stop if the fetch is already resolved
            if (_this.isResolved) return;
             // Do we need to retry the request?
            var retry = (_config$retry = config.retry) != null ? _config$retry : 3;
            var retryDelay = (_config$retryDelay = config.retryDelay) != null ? _config$retryDelay : $23ca15fd0fb4402b$var$defaultRetryDelay;
            var delay = typeof retryDelay === 'function' ? retryDelay(_this.failureCount, error) : retryDelay;
            var shouldRetry = retry === true || typeof retry === 'number' && _this.failureCount < retry || typeof retry === 'function' && retry(_this.failureCount, error);
            if (cancelRetry || !shouldRetry) {
                // We are done if the query does not need to be retried
                reject(error);
                return;
            }
            _this.failureCount++; // Notify on fail
            config.onFail == null || config.onFail(_this.failureCount, error); // Delay
            (0, $3ff4724ea894d7ab$export$e772c8ff12451969)(delay) // Pause if the document is not visible or when the device is offline
            .then(function() {
                if (!(0, $3fbc886baa2b733b$export$6bf54661be5b02cf).isFocused() || !(0, $e9ce68e672abc0c9$export$b113e788b2dd3fdc).isOnline()) return pause();
            }).then(function() {
                if (cancelRetry) reject(error);
                else run();
            });
        });
    }; // Start loop
    run();
};


var $165e83600d2914fb$export$62297b13309008b2 = /*#__PURE__*/ function() {
    function Query(config) {
        this.abortSignalConsumed = false;
        this.hadObservers = false;
        this.defaultOptions = config.defaultOptions;
        this.setOptions(config.options);
        this.observers = [];
        this.cache = config.cache;
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        this.initialState = config.state || this.getDefaultState(this.options);
        this.state = this.initialState;
        this.meta = config.meta;
        this.scheduleGc();
    }
    var _proto = Query.prototype;
    _proto.setOptions = function setOptions(options) {
        var _this$options$cacheTi;
        this.options = (0, $dda4d40cf5733033$export$2e2bcd8739ae039)({}, this.defaultOptions, options);
        this.meta = options == null ? void 0 : options.meta; // Default to 5 minutes if not cache time is set
        this.cacheTime = Math.max(this.cacheTime || 0, (_this$options$cacheTi = this.options.cacheTime) != null ? _this$options$cacheTi : 300000);
    };
    _proto.setDefaultOptions = function setDefaultOptions(options) {
        this.defaultOptions = options;
    };
    _proto.scheduleGc = function scheduleGc() {
        var _this = this;
        this.clearGcTimeout();
        if ((0, $3ff4724ea894d7ab$export$e539f754e934e270)(this.cacheTime)) this.gcTimeout = setTimeout(function() {
            _this.optionalRemove();
        }, this.cacheTime);
    };
    _proto.clearGcTimeout = function clearGcTimeout() {
        if (this.gcTimeout) {
            clearTimeout(this.gcTimeout);
            this.gcTimeout = undefined;
        }
    };
    _proto.optionalRemove = function optionalRemove() {
        if (!this.observers.length) {
            if (this.state.isFetching) {
                if (this.hadObservers) this.scheduleGc();
            } else this.cache.remove(this);
        }
    };
    _proto.setData = function setData(updater, options) {
        var _this$options$isDataE, _this$options;
        var prevData = this.state.data; // Get the new data
        var data = (0, $3ff4724ea894d7ab$export$7f095f455ad5af3f)(updater, prevData); // Use prev data if an isDataEqual function is defined and returns `true`
        if ((_this$options$isDataE = (_this$options = this.options).isDataEqual) == null ? void 0 : _this$options$isDataE.call(_this$options, prevData, data)) data = prevData;
        else if (this.options.structuralSharing !== false) // Structurally share data between prev and new data if needed
        data = (0, $3ff4724ea894d7ab$export$77a71fc411098696)(prevData, data);
         // Set data and mark it as cached
        this.dispatch({
            data: data,
            type: 'success',
            dataUpdatedAt: options == null ? void 0 : options.updatedAt
        });
        return data;
    };
    _proto.setState = function setState(state, setStateOptions) {
        this.dispatch({
            type: 'setState',
            state: state,
            setStateOptions: setStateOptions
        });
    };
    _proto.cancel = function cancel(options) {
        var _this$retryer;
        var promise = this.promise;
        (_this$retryer = this.retryer) == null || _this$retryer.cancel(options);
        return promise ? promise.then((0, $3ff4724ea894d7ab$export$8793edee2d425525)).catch((0, $3ff4724ea894d7ab$export$8793edee2d425525)) : Promise.resolve();
    };
    _proto.destroy = function destroy() {
        this.clearGcTimeout();
        this.cancel({
            silent: true
        });
    };
    _proto.reset = function reset() {
        this.destroy();
        this.setState(this.initialState);
    };
    _proto.isActive = function isActive() {
        return this.observers.some(function(observer) {
            return observer.options.enabled !== false;
        });
    };
    _proto.isFetching = function isFetching() {
        return this.state.isFetching;
    };
    _proto.isStale = function isStale() {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some(function(observer) {
            return observer.getCurrentResult().isStale;
        });
    };
    _proto.isStaleByTime = function isStaleByTime(staleTime) {
        if (staleTime === void 0) staleTime = 0;
        return this.state.isInvalidated || !this.state.dataUpdatedAt || !(0, $3ff4724ea894d7ab$export$811b83d62bcf47f0)(this.state.dataUpdatedAt, staleTime);
    };
    _proto.onFocus = function onFocus() {
        var _this$retryer2;
        var observer = this.observers.find(function(x) {
            return x.shouldFetchOnWindowFocus();
        });
        if (observer) observer.refetch();
         // Continue fetch if currently paused
        (_this$retryer2 = this.retryer) == null || _this$retryer2.continue();
    };
    _proto.onOnline = function onOnline() {
        var _this$retryer3;
        var observer = this.observers.find(function(x) {
            return x.shouldFetchOnReconnect();
        });
        if (observer) observer.refetch();
         // Continue fetch if currently paused
        (_this$retryer3 = this.retryer) == null || _this$retryer3.continue();
    };
    _proto.addObserver = function addObserver(observer) {
        if (this.observers.indexOf(observer) === -1) {
            this.observers.push(observer);
            this.hadObservers = true; // Stop the query from being garbage collected
            this.clearGcTimeout();
            this.cache.notify({
                type: 'observerAdded',
                query: this,
                observer: observer
            });
        }
    };
    _proto.removeObserver = function removeObserver(observer) {
        if (this.observers.indexOf(observer) !== -1) {
            this.observers = this.observers.filter(function(x) {
                return x !== observer;
            });
            if (!this.observers.length) {
                // If the transport layer does not support cancellation
                // we'll let the query continue so the result can be cached
                if (this.retryer) {
                    if (this.retryer.isTransportCancelable || this.abortSignalConsumed) this.retryer.cancel({
                        revert: true
                    });
                    else this.retryer.cancelRetry();
                }
                if (this.cacheTime) this.scheduleGc();
                else this.cache.remove(this);
            }
            this.cache.notify({
                type: 'observerRemoved',
                query: this,
                observer: observer
            });
        }
    };
    _proto.getObserversCount = function getObserversCount() {
        return this.observers.length;
    };
    _proto.invalidate = function invalidate() {
        if (!this.state.isInvalidated) this.dispatch({
            type: 'invalidate'
        });
    };
    _proto.fetch = function fetch(options, fetchOptions) {
        var _this2 = this, _this$options$behavio, _context$fetchOptions, _abortController$abor;
        if (this.state.isFetching) {
            if (this.state.dataUpdatedAt && (fetchOptions == null ? void 0 : fetchOptions.cancelRefetch)) // Silently cancel current fetch if the user wants to cancel refetches
            this.cancel({
                silent: true
            });
            else if (this.promise) {
                var _this$retryer4;
                // make sure that retries that were potentially cancelled due to unmounts can continue
                (_this$retryer4 = this.retryer) == null || _this$retryer4.continueRetry(); // Return current promise if we are already fetching
                return this.promise;
            }
        } // Update config if passed, otherwise the config from the last execution is used
        if (options) this.setOptions(options);
         // Use the options from the first observer with a query function if no function is found.
        // This can happen when the query is hydrated or created with setQueryData.
        if (!this.options.queryFn) {
            var observer = this.observers.find(function(x) {
                return x.options.queryFn;
            });
            if (observer) this.setOptions(observer.options);
        }
        var queryKey = (0, $3ff4724ea894d7ab$export$4d32d63f64b825b9)(this.queryKey);
        var abortController = (0, $3ff4724ea894d7ab$export$382ca5d13a8f252c)(); // Create query function context
        var queryFnContext = {
            queryKey: queryKey,
            pageParam: undefined,
            meta: this.meta
        };
        Object.defineProperty(queryFnContext, 'signal', {
            enumerable: true,
            get: function get() {
                if (abortController) {
                    _this2.abortSignalConsumed = true;
                    return abortController.signal;
                }
                return undefined;
            }
        }); // Create fetch function
        var fetchFn = function fetchFn() {
            if (!_this2.options.queryFn) return Promise.reject('Missing queryFn');
            _this2.abortSignalConsumed = false;
            return _this2.options.queryFn(queryFnContext);
        }; // Trigger behavior hook
        var context = {
            fetchOptions: fetchOptions,
            options: this.options,
            queryKey: queryKey,
            state: this.state,
            fetchFn: fetchFn,
            meta: this.meta
        };
        if ((_this$options$behavio = this.options.behavior) == null ? void 0 : _this$options$behavio.onFetch) {
            var _this$options$behavio2;
            (_this$options$behavio2 = this.options.behavior) == null || _this$options$behavio2.onFetch(context);
        } // Store state in case the current fetch needs to be reverted
        this.revertState = this.state; // Set to fetching state if not already in it
        if (!this.state.isFetching || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) == null ? void 0 : _context$fetchOptions.meta)) {
            var _context$fetchOptions2;
            this.dispatch({
                type: 'fetch',
                meta: (_context$fetchOptions2 = context.fetchOptions) == null ? void 0 : _context$fetchOptions2.meta
            });
        } // Try to fetch the data
        this.retryer = new (0, $23ca15fd0fb4402b$export$586a619a4618a582)({
            fn: context.fetchFn,
            abort: abortController == null ? void 0 : (_abortController$abor = abortController.abort) == null ? void 0 : _abortController$abor.bind(abortController),
            onSuccess: function onSuccess(data) {
                _this2.setData(data); // Notify cache callback
                _this2.cache.config.onSuccess == null || _this2.cache.config.onSuccess(data, _this2); // Remove query after fetching if cache time is 0
                if (_this2.cacheTime === 0) _this2.optionalRemove();
            },
            onError: function onError(error) {
                // Optimistically update state if needed
                if (!((0, $23ca15fd0fb4402b$export$986cc6445c1d323)(error) && error.silent)) _this2.dispatch({
                    type: 'error',
                    error: error
                });
                if (!(0, $23ca15fd0fb4402b$export$986cc6445c1d323)(error)) {
                    // Notify cache callback
                    _this2.cache.config.onError == null || _this2.cache.config.onError(error, _this2); // Log error
                    (0, $9489c5e76e62cc56$export$2b1d391cd05230fd)().error(error);
                } // Remove query after fetching if cache time is 0
                if (_this2.cacheTime === 0) _this2.optionalRemove();
            },
            onFail: function onFail() {
                _this2.dispatch({
                    type: 'failed'
                });
            },
            onPause: function onPause() {
                _this2.dispatch({
                    type: 'pause'
                });
            },
            onContinue: function onContinue() {
                _this2.dispatch({
                    type: 'continue'
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay
        });
        this.promise = this.retryer.promise;
        return this.promise;
    };
    _proto.dispatch = function dispatch(action) {
        var _this3 = this;
        this.state = this.reducer(this.state, action);
        (0, $290db3e0ce227fd3$export$520687f44db6e1ab).batch(function() {
            _this3.observers.forEach(function(observer) {
                observer.onQueryUpdate(action);
            });
            _this3.cache.notify({
                query: _this3,
                type: 'queryUpdated',
                action: action
            });
        });
    };
    _proto.getDefaultState = function getDefaultState(options) {
        var data = typeof options.initialData === 'function' ? options.initialData() : options.initialData;
        var hasInitialData = typeof options.initialData !== 'undefined';
        var initialDataUpdatedAt = hasInitialData ? typeof options.initialDataUpdatedAt === 'function' ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
        var hasData = typeof data !== 'undefined';
        return {
            data: data,
            dataUpdateCount: 0,
            dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
            error: null,
            errorUpdateCount: 0,
            errorUpdatedAt: 0,
            fetchFailureCount: 0,
            fetchMeta: null,
            isFetching: false,
            isInvalidated: false,
            isPaused: false,
            status: hasData ? 'success' : 'idle'
        };
    };
    _proto.reducer = function reducer(state, action) {
        var _action$meta, _action$dataUpdatedAt;
        switch(action.type){
            case 'failed':
                return (0, $dda4d40cf5733033$export$2e2bcd8739ae039)({}, state, {
                    fetchFailureCount: state.fetchFailureCount + 1
                });
            case 'pause':
                return (0, $dda4d40cf5733033$export$2e2bcd8739ae039)({}, state, {
                    isPaused: true
                });
            case 'continue':
                return (0, $dda4d40cf5733033$export$2e2bcd8739ae039)({}, state, {
                    isPaused: false
                });
            case 'fetch':
                return (0, $dda4d40cf5733033$export$2e2bcd8739ae039)({}, state, {
                    fetchFailureCount: 0,
                    fetchMeta: (_action$meta = action.meta) != null ? _action$meta : null,
                    isFetching: true,
                    isPaused: false
                }, !state.dataUpdatedAt && {
                    error: null,
                    status: 'loading'
                });
            case 'success':
                return (0, $dda4d40cf5733033$export$2e2bcd8739ae039)({}, state, {
                    data: action.data,
                    dataUpdateCount: state.dataUpdateCount + 1,
                    dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) != null ? _action$dataUpdatedAt : Date.now(),
                    error: null,
                    fetchFailureCount: 0,
                    isFetching: false,
                    isInvalidated: false,
                    isPaused: false,
                    status: 'success'
                });
            case 'error':
                var error = action.error;
                if ((0, $23ca15fd0fb4402b$export$986cc6445c1d323)(error) && error.revert && this.revertState) return (0, $dda4d40cf5733033$export$2e2bcd8739ae039)({}, this.revertState);
                return (0, $dda4d40cf5733033$export$2e2bcd8739ae039)({}, state, {
                    error: error,
                    errorUpdateCount: state.errorUpdateCount + 1,
                    errorUpdatedAt: Date.now(),
                    fetchFailureCount: state.fetchFailureCount + 1,
                    isFetching: false,
                    isPaused: false,
                    status: 'error'
                });
            case 'invalidate':
                return (0, $dda4d40cf5733033$export$2e2bcd8739ae039)({}, state, {
                    isInvalidated: true
                });
            case 'setState':
                return (0, $dda4d40cf5733033$export$2e2bcd8739ae039)({}, state, action.state);
            default:
                return state;
        }
    };
    return Query;
}();




var $bd39afbd0bca7de1$export$5dde0cd941da8468 = /*#__PURE__*/ function(_Subscribable) {
    (0, $0ec1659a3a380451$export$2e2bcd8739ae039)(QueryCache, _Subscribable);
    function QueryCache(config) {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.config = config || {};
        _this.queries = [];
        _this.queriesMap = {};
        return _this;
    }
    var _proto = QueryCache.prototype;
    _proto.build = function build(client, options, state) {
        var _options$queryHash;
        var queryKey = options.queryKey;
        var queryHash = (_options$queryHash = options.queryHash) != null ? _options$queryHash : (0, $3ff4724ea894d7ab$export$cc90ca97bc0d73fd)(queryKey, options);
        var query = this.get(queryHash);
        if (!query) {
            query = new (0, $165e83600d2914fb$export$62297b13309008b2)({
                cache: this,
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey),
                meta: options.meta
            });
            this.add(query);
        }
        return query;
    };
    _proto.add = function add(query) {
        if (!this.queriesMap[query.queryHash]) {
            this.queriesMap[query.queryHash] = query;
            this.queries.push(query);
            this.notify({
                type: 'queryAdded',
                query: query
            });
        }
    };
    _proto.remove = function remove(query) {
        var queryInMap = this.queriesMap[query.queryHash];
        if (queryInMap) {
            query.destroy();
            this.queries = this.queries.filter(function(x) {
                return x !== query;
            });
            if (queryInMap === query) delete this.queriesMap[query.queryHash];
            this.notify({
                type: 'queryRemoved',
                query: query
            });
        }
    };
    _proto.clear = function clear() {
        var _this2 = this;
        (0, $290db3e0ce227fd3$export$520687f44db6e1ab).batch(function() {
            _this2.queries.forEach(function(query) {
                _this2.remove(query);
            });
        });
    };
    _proto.get = function get(queryHash) {
        return this.queriesMap[queryHash];
    };
    _proto.getAll = function getAll() {
        return this.queries;
    };
    _proto.find = function find(arg1, arg2) {
        var _parseFilterArgs = (0, $3ff4724ea894d7ab$export$18e8f4b987e6c111)(arg1, arg2), filters = _parseFilterArgs[0];
        if (typeof filters.exact === 'undefined') filters.exact = true;
        return this.queries.find(function(query) {
            return (0, $3ff4724ea894d7ab$export$c5d1efe363797780)(filters, query);
        });
    };
    _proto.findAll = function findAll(arg1, arg2) {
        var _parseFilterArgs2 = (0, $3ff4724ea894d7ab$export$18e8f4b987e6c111)(arg1, arg2), filters = _parseFilterArgs2[0];
        return Object.keys(filters).length > 0 ? this.queries.filter(function(query) {
            return (0, $3ff4724ea894d7ab$export$c5d1efe363797780)(filters, query);
        }) : this.queries;
    };
    _proto.notify = function notify(event) {
        var _this3 = this;
        (0, $290db3e0ce227fd3$export$520687f44db6e1ab).batch(function() {
            _this3.listeners.forEach(function(listener) {
                listener(event);
            });
        });
    };
    _proto.onFocus = function onFocus() {
        var _this4 = this;
        (0, $290db3e0ce227fd3$export$520687f44db6e1ab).batch(function() {
            _this4.queries.forEach(function(query) {
                query.onFocus();
            });
        });
    };
    _proto.onOnline = function onOnline() {
        var _this5 = this;
        (0, $290db3e0ce227fd3$export$520687f44db6e1ab).batch(function() {
            _this5.queries.forEach(function(query) {
                query.onOnline();
            });
        });
    };
    return QueryCache;
}((0, $8d9dbc58b3471196$export$d26086b469ecdbcc));









var $74a5e2e6477d55b9$export$17b8b19c814bcf56 = /*#__PURE__*/ function() {
    function Mutation(config) {
        this.options = (0, $dda4d40cf5733033$export$2e2bcd8739ae039)({}, config.defaultOptions, config.options);
        this.mutationId = config.mutationId;
        this.mutationCache = config.mutationCache;
        this.observers = [];
        this.state = config.state || $74a5e2e6477d55b9$export$a1659b54bac3252a();
        this.meta = config.meta;
    }
    var _proto = Mutation.prototype;
    _proto.setState = function setState(state) {
        this.dispatch({
            type: 'setState',
            state: state
        });
    };
    _proto.addObserver = function addObserver(observer) {
        if (this.observers.indexOf(observer) === -1) this.observers.push(observer);
    };
    _proto.removeObserver = function removeObserver(observer) {
        this.observers = this.observers.filter(function(x) {
            return x !== observer;
        });
    };
    _proto.cancel = function cancel() {
        if (this.retryer) {
            this.retryer.cancel();
            return this.retryer.promise.then((0, $3ff4724ea894d7ab$export$8793edee2d425525)).catch((0, $3ff4724ea894d7ab$export$8793edee2d425525));
        }
        return Promise.resolve();
    };
    _proto.continue = function _continue() {
        if (this.retryer) {
            this.retryer.continue();
            return this.retryer.promise;
        }
        return this.execute();
    };
    _proto.execute = function execute() {
        var _this = this;
        var data;
        var restored = this.state.status === 'loading';
        var promise = Promise.resolve();
        if (!restored) {
            this.dispatch({
                type: 'loading',
                variables: this.options.variables
            });
            promise = promise.then(function() {
                // Notify cache callback
                _this.mutationCache.config.onMutate == null || _this.mutationCache.config.onMutate(_this.state.variables, _this);
            }).then(function() {
                return _this.options.onMutate == null ? void 0 : _this.options.onMutate(_this.state.variables);
            }).then(function(context) {
                if (context !== _this.state.context) _this.dispatch({
                    type: 'loading',
                    context: context,
                    variables: _this.state.variables
                });
            });
        }
        return promise.then(function() {
            return _this.executeMutation();
        }).then(function(result) {
            data = result; // Notify cache callback
            _this.mutationCache.config.onSuccess == null || _this.mutationCache.config.onSuccess(data, _this.state.variables, _this.state.context, _this);
        }).then(function() {
            return _this.options.onSuccess == null ? void 0 : _this.options.onSuccess(data, _this.state.variables, _this.state.context);
        }).then(function() {
            return _this.options.onSettled == null ? void 0 : _this.options.onSettled(data, null, _this.state.variables, _this.state.context);
        }).then(function() {
            _this.dispatch({
                type: 'success',
                data: data
            });
            return data;
        }).catch(function(error) {
            // Notify cache callback
            _this.mutationCache.config.onError == null || _this.mutationCache.config.onError(error, _this.state.variables, _this.state.context, _this); // Log error
            (0, $9489c5e76e62cc56$export$2b1d391cd05230fd)().error(error);
            return Promise.resolve().then(function() {
                return _this.options.onError == null ? void 0 : _this.options.onError(error, _this.state.variables, _this.state.context);
            }).then(function() {
                return _this.options.onSettled == null ? void 0 : _this.options.onSettled(undefined, error, _this.state.variables, _this.state.context);
            }).then(function() {
                _this.dispatch({
                    type: 'error',
                    error: error
                });
                throw error;
            });
        });
    };
    _proto.executeMutation = function executeMutation() {
        var _this2 = this, _this$options$retry;
        this.retryer = new (0, $23ca15fd0fb4402b$export$586a619a4618a582)({
            fn: function fn() {
                if (!_this2.options.mutationFn) return Promise.reject('No mutationFn found');
                return _this2.options.mutationFn(_this2.state.variables);
            },
            onFail: function onFail() {
                _this2.dispatch({
                    type: 'failed'
                });
            },
            onPause: function onPause() {
                _this2.dispatch({
                    type: 'pause'
                });
            },
            onContinue: function onContinue() {
                _this2.dispatch({
                    type: 'continue'
                });
            },
            retry: (_this$options$retry = this.options.retry) != null ? _this$options$retry : 0,
            retryDelay: this.options.retryDelay
        });
        return this.retryer.promise;
    };
    _proto.dispatch = function dispatch(action) {
        var _this3 = this;
        this.state = $74a5e2e6477d55b9$var$reducer(this.state, action);
        (0, $290db3e0ce227fd3$export$520687f44db6e1ab).batch(function() {
            _this3.observers.forEach(function(observer) {
                observer.onMutationUpdate(action);
            });
            _this3.mutationCache.notify(_this3);
        });
    };
    return Mutation;
}();
function $74a5e2e6477d55b9$export$a1659b54bac3252a() {
    return {
        context: undefined,
        data: undefined,
        error: null,
        failureCount: 0,
        isPaused: false,
        status: 'idle',
        variables: undefined
    };
}
function $74a5e2e6477d55b9$var$reducer(state, action) {
    switch(action.type){
        case 'failed':
            return (0, $dda4d40cf5733033$export$2e2bcd8739ae039)({}, state, {
                failureCount: state.failureCount + 1
            });
        case 'pause':
            return (0, $dda4d40cf5733033$export$2e2bcd8739ae039)({}, state, {
                isPaused: true
            });
        case 'continue':
            return (0, $dda4d40cf5733033$export$2e2bcd8739ae039)({}, state, {
                isPaused: false
            });
        case 'loading':
            return (0, $dda4d40cf5733033$export$2e2bcd8739ae039)({}, state, {
                context: action.context,
                data: undefined,
                error: null,
                isPaused: false,
                status: 'loading',
                variables: action.variables
            });
        case 'success':
            return (0, $dda4d40cf5733033$export$2e2bcd8739ae039)({}, state, {
                data: action.data,
                error: null,
                status: 'success',
                isPaused: false
            });
        case 'error':
            return (0, $dda4d40cf5733033$export$2e2bcd8739ae039)({}, state, {
                data: undefined,
                error: action.error,
                failureCount: state.failureCount + 1,
                isPaused: false,
                status: 'error'
            });
        case 'setState':
            return (0, $dda4d40cf5733033$export$2e2bcd8739ae039)({}, state, action.state);
        default:
            return state;
    }
}




var $a6932dd7526bd65a$export$1fcfd9a244434844 = /*#__PURE__*/ function(_Subscribable) {
    (0, $0ec1659a3a380451$export$2e2bcd8739ae039)(MutationCache, _Subscribable);
    function MutationCache(config) {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.config = config || {};
        _this.mutations = [];
        _this.mutationId = 0;
        return _this;
    }
    var _proto = MutationCache.prototype;
    _proto.build = function build(client, options, state) {
        var mutation = new (0, $74a5e2e6477d55b9$export$17b8b19c814bcf56)({
            mutationCache: this,
            mutationId: ++this.mutationId,
            options: client.defaultMutationOptions(options),
            state: state,
            defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : undefined,
            meta: options.meta
        });
        this.add(mutation);
        return mutation;
    };
    _proto.add = function add(mutation) {
        this.mutations.push(mutation);
        this.notify(mutation);
    };
    _proto.remove = function remove(mutation) {
        this.mutations = this.mutations.filter(function(x) {
            return x !== mutation;
        });
        mutation.cancel();
        this.notify(mutation);
    };
    _proto.clear = function clear() {
        var _this2 = this;
        (0, $290db3e0ce227fd3$export$520687f44db6e1ab).batch(function() {
            _this2.mutations.forEach(function(mutation) {
                _this2.remove(mutation);
            });
        });
    };
    _proto.getAll = function getAll() {
        return this.mutations;
    };
    _proto.find = function find(filters) {
        if (typeof filters.exact === 'undefined') filters.exact = true;
        return this.mutations.find(function(mutation) {
            return (0, $3ff4724ea894d7ab$export$a1ea5fb559f63ae3)(filters, mutation);
        });
    };
    _proto.findAll = function findAll(filters) {
        return this.mutations.filter(function(mutation) {
            return (0, $3ff4724ea894d7ab$export$a1ea5fb559f63ae3)(filters, mutation);
        });
    };
    _proto.notify = function notify(mutation) {
        var _this3 = this;
        (0, $290db3e0ce227fd3$export$520687f44db6e1ab).batch(function() {
            _this3.listeners.forEach(function(listener) {
                listener(mutation);
            });
        });
    };
    _proto.onFocus = function onFocus() {
        this.resumePausedMutations();
    };
    _proto.onOnline = function onOnline() {
        this.resumePausedMutations();
    };
    _proto.resumePausedMutations = function resumePausedMutations() {
        var pausedMutations = this.mutations.filter(function(x) {
            return x.state.isPaused;
        });
        return (0, $290db3e0ce227fd3$export$520687f44db6e1ab).batch(function() {
            return pausedMutations.reduce(function(promise, mutation) {
                return promise.then(function() {
                    return mutation.continue().catch((0, $3ff4724ea894d7ab$export$8793edee2d425525));
                });
            }, Promise.resolve());
        });
    };
    return MutationCache;
}((0, $8d9dbc58b3471196$export$d26086b469ecdbcc));







function $615235d24e9a8762$export$84470d1367601e8d() {
    return {
        onFetch: function onFetch(context) {
            context.fetchFn = function() {
                var _context$fetchOptions, _context$fetchOptions2, _context$fetchOptions3, _context$fetchOptions4, _context$state$data, _context$state$data2;
                var refetchPage = (_context$fetchOptions = context.fetchOptions) == null ? void 0 : (_context$fetchOptions2 = _context$fetchOptions.meta) == null ? void 0 : _context$fetchOptions2.refetchPage;
                var fetchMore = (_context$fetchOptions3 = context.fetchOptions) == null ? void 0 : (_context$fetchOptions4 = _context$fetchOptions3.meta) == null ? void 0 : _context$fetchOptions4.fetchMore;
                var pageParam = fetchMore == null ? void 0 : fetchMore.pageParam;
                var isFetchingNextPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'forward';
                var isFetchingPreviousPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'backward';
                var oldPages = ((_context$state$data = context.state.data) == null ? void 0 : _context$state$data.pages) || [];
                var oldPageParams = ((_context$state$data2 = context.state.data) == null ? void 0 : _context$state$data2.pageParams) || [];
                var abortController = (0, $3ff4724ea894d7ab$export$382ca5d13a8f252c)();
                var abortSignal = abortController == null ? void 0 : abortController.signal;
                var newPageParams = oldPageParams;
                var cancelled = false; // Get query function
                var queryFn = context.options.queryFn || function() {
                    return Promise.reject('Missing queryFn');
                };
                var buildNewPages = function buildNewPages(pages, param, page, previous) {
                    newPageParams = previous ? [
                        param
                    ].concat(newPageParams) : [].concat(newPageParams, [
                        param
                    ]);
                    return previous ? [
                        page
                    ].concat(pages) : [].concat(pages, [
                        page
                    ]);
                }; // Create function to fetch a page
                var fetchPage = function fetchPage(pages, manual, param, previous) {
                    if (cancelled) return Promise.reject('Cancelled');
                    if (typeof param === 'undefined' && !manual && pages.length) return Promise.resolve(pages);
                    var queryFnContext = {
                        queryKey: context.queryKey,
                        signal: abortSignal,
                        pageParam: param,
                        meta: context.meta
                    };
                    var queryFnResult = queryFn(queryFnContext);
                    var promise = Promise.resolve(queryFnResult).then(function(page) {
                        return buildNewPages(pages, param, page, previous);
                    });
                    if ((0, $23ca15fd0fb4402b$export$22e08d49843051be)(queryFnResult)) {
                        var promiseAsAny = promise;
                        promiseAsAny.cancel = queryFnResult.cancel;
                    }
                    return promise;
                };
                var promise; // Fetch first page?
                if (!oldPages.length) promise = fetchPage([]);
                else if (isFetchingNextPage) {
                    var manual = typeof pageParam !== 'undefined';
                    var param = manual ? pageParam : $615235d24e9a8762$export$1186159d57de7255(context.options, oldPages);
                    promise = fetchPage(oldPages, manual, param);
                } else if (isFetchingPreviousPage) {
                    var _manual = typeof pageParam !== 'undefined';
                    var _param = _manual ? pageParam : $615235d24e9a8762$export$48efda17d8ac7ac7(context.options, oldPages);
                    promise = fetchPage(oldPages, _manual, _param, true);
                } else (function() {
                    newPageParams = [];
                    var manual = typeof context.options.getNextPageParam === 'undefined';
                    var shouldFetchFirstPage = refetchPage && oldPages[0] ? refetchPage(oldPages[0], 0, oldPages) : true; // Fetch first page
                    promise = shouldFetchFirstPage ? fetchPage([], manual, oldPageParams[0]) : Promise.resolve(buildNewPages([], oldPageParams[0], oldPages[0])); // Fetch remaining pages
                    var _loop = function _loop(i) {
                        promise = promise.then(function(pages) {
                            var shouldFetchNextPage = refetchPage && oldPages[i] ? refetchPage(oldPages[i], i, oldPages) : true;
                            if (shouldFetchNextPage) {
                                var _param2 = manual ? oldPageParams[i] : $615235d24e9a8762$export$1186159d57de7255(context.options, pages);
                                return fetchPage(pages, manual, _param2);
                            }
                            return Promise.resolve(buildNewPages(pages, oldPageParams[i], oldPages[i]));
                        });
                    };
                    for(var i = 1; i < oldPages.length; i++)_loop(i);
                })();
                var finalPromise = promise.then(function(pages) {
                    return {
                        pages: pages,
                        pageParams: newPageParams
                    };
                });
                var finalPromiseAsAny = finalPromise;
                finalPromiseAsAny.cancel = function() {
                    cancelled = true;
                    abortController == null || abortController.abort();
                    if ((0, $23ca15fd0fb4402b$export$22e08d49843051be)(promise)) promise.cancel();
                };
                return finalPromise;
            };
        }
    };
}
function $615235d24e9a8762$export$1186159d57de7255(options, pages) {
    return options.getNextPageParam == null ? void 0 : options.getNextPageParam(pages[pages.length - 1], pages);
}
function $615235d24e9a8762$export$48efda17d8ac7ac7(options, pages) {
    return options.getPreviousPageParam == null ? void 0 : options.getPreviousPageParam(pages[0], pages);
}
function $615235d24e9a8762$export$b9c88add8b8b5e6a(options, pages) {
    if (options.getNextPageParam && Array.isArray(pages)) {
        var nextPageParam = $615235d24e9a8762$export$1186159d57de7255(options, pages);
        return typeof nextPageParam !== 'undefined' && nextPageParam !== null && nextPageParam !== false;
    }
}
function $615235d24e9a8762$export$db1663b730a8e6e4(options, pages) {
    if (options.getPreviousPageParam && Array.isArray(pages)) {
        var previousPageParam = $615235d24e9a8762$export$48efda17d8ac7ac7(options, pages);
        return typeof previousPageParam !== 'undefined' && previousPageParam !== null && previousPageParam !== false;
    }
}


var $97b75e8fb286a5f4$export$405d0624ed55a03f = /*#__PURE__*/ function() {
    function QueryClient(config) {
        if (config === void 0) config = {};
        this.queryCache = config.queryCache || new (0, $bd39afbd0bca7de1$export$5dde0cd941da8468)();
        this.mutationCache = config.mutationCache || new (0, $a6932dd7526bd65a$export$1fcfd9a244434844)();
        this.defaultOptions = config.defaultOptions || {};
        this.queryDefaults = [];
        this.mutationDefaults = [];
    }
    var _proto = QueryClient.prototype;
    _proto.mount = function mount() {
        var _this = this;
        this.unsubscribeFocus = (0, $3fbc886baa2b733b$export$6bf54661be5b02cf).subscribe(function() {
            if ((0, $3fbc886baa2b733b$export$6bf54661be5b02cf).isFocused() && (0, $e9ce68e672abc0c9$export$b113e788b2dd3fdc).isOnline()) {
                _this.mutationCache.onFocus();
                _this.queryCache.onFocus();
            }
        });
        this.unsubscribeOnline = (0, $e9ce68e672abc0c9$export$b113e788b2dd3fdc).subscribe(function() {
            if ((0, $3fbc886baa2b733b$export$6bf54661be5b02cf).isFocused() && (0, $e9ce68e672abc0c9$export$b113e788b2dd3fdc).isOnline()) {
                _this.mutationCache.onOnline();
                _this.queryCache.onOnline();
            }
        });
    };
    _proto.unmount = function unmount() {
        var _this$unsubscribeFocu, _this$unsubscribeOnli;
        (_this$unsubscribeFocu = this.unsubscribeFocus) == null || _this$unsubscribeFocu.call(this);
        (_this$unsubscribeOnli = this.unsubscribeOnline) == null || _this$unsubscribeOnli.call(this);
    };
    _proto.isFetching = function isFetching(arg1, arg2) {
        var _parseFilterArgs = (0, $3ff4724ea894d7ab$export$18e8f4b987e6c111)(arg1, arg2), filters = _parseFilterArgs[0];
        filters.fetching = true;
        return this.queryCache.findAll(filters).length;
    };
    _proto.isMutating = function isMutating(filters) {
        return this.mutationCache.findAll((0, $dda4d40cf5733033$export$2e2bcd8739ae039)({}, filters, {
            fetching: true
        })).length;
    };
    _proto.getQueryData = function getQueryData(queryKey, filters) {
        var _this$queryCache$find;
        return (_this$queryCache$find = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find.state.data;
    };
    _proto.getQueriesData = function getQueriesData(queryKeyOrFilters) {
        return this.getQueryCache().findAll(queryKeyOrFilters).map(function(_ref) {
            var queryKey = _ref.queryKey, state = _ref.state;
            var data = state.data;
            return [
                queryKey,
                data
            ];
        });
    };
    _proto.setQueryData = function setQueryData(queryKey, updater, options) {
        var parsedOptions = (0, $3ff4724ea894d7ab$export$8a11fbc2c8ea08fd)(queryKey);
        var defaultedOptions = this.defaultQueryOptions(parsedOptions);
        return this.queryCache.build(this, defaultedOptions).setData(updater, options);
    };
    _proto.setQueriesData = function setQueriesData(queryKeyOrFilters, updater, options) {
        var _this2 = this;
        return (0, $290db3e0ce227fd3$export$520687f44db6e1ab).batch(function() {
            return _this2.getQueryCache().findAll(queryKeyOrFilters).map(function(_ref2) {
                var queryKey = _ref2.queryKey;
                return [
                    queryKey,
                    _this2.setQueryData(queryKey, updater, options)
                ];
            });
        });
    };
    _proto.getQueryState = function getQueryState(queryKey, filters) {
        var _this$queryCache$find2;
        return (_this$queryCache$find2 = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find2.state;
    };
    _proto.removeQueries = function removeQueries(arg1, arg2) {
        var _parseFilterArgs2 = (0, $3ff4724ea894d7ab$export$18e8f4b987e6c111)(arg1, arg2), filters = _parseFilterArgs2[0];
        var queryCache = this.queryCache;
        (0, $290db3e0ce227fd3$export$520687f44db6e1ab).batch(function() {
            queryCache.findAll(filters).forEach(function(query) {
                queryCache.remove(query);
            });
        });
    };
    _proto.resetQueries = function resetQueries(arg1, arg2, arg3) {
        var _this3 = this;
        var _parseFilterArgs3 = (0, $3ff4724ea894d7ab$export$18e8f4b987e6c111)(arg1, arg2, arg3), filters = _parseFilterArgs3[0], options = _parseFilterArgs3[1];
        var queryCache = this.queryCache;
        var refetchFilters = (0, $dda4d40cf5733033$export$2e2bcd8739ae039)({}, filters, {
            active: true
        });
        return (0, $290db3e0ce227fd3$export$520687f44db6e1ab).batch(function() {
            queryCache.findAll(filters).forEach(function(query) {
                query.reset();
            });
            return _this3.refetchQueries(refetchFilters, options);
        });
    };
    _proto.cancelQueries = function cancelQueries(arg1, arg2, arg3) {
        var _this4 = this;
        var _parseFilterArgs4 = (0, $3ff4724ea894d7ab$export$18e8f4b987e6c111)(arg1, arg2, arg3), filters = _parseFilterArgs4[0], _parseFilterArgs4$ = _parseFilterArgs4[1], cancelOptions = _parseFilterArgs4$ === void 0 ? {} : _parseFilterArgs4$;
        if (typeof cancelOptions.revert === 'undefined') cancelOptions.revert = true;
        var promises = (0, $290db3e0ce227fd3$export$520687f44db6e1ab).batch(function() {
            return _this4.queryCache.findAll(filters).map(function(query) {
                return query.cancel(cancelOptions);
            });
        });
        return Promise.all(promises).then((0, $3ff4724ea894d7ab$export$8793edee2d425525)).catch((0, $3ff4724ea894d7ab$export$8793edee2d425525));
    };
    _proto.invalidateQueries = function invalidateQueries(arg1, arg2, arg3) {
        var _ref3, _filters$refetchActiv, _filters$refetchInact, _this5 = this;
        var _parseFilterArgs5 = (0, $3ff4724ea894d7ab$export$18e8f4b987e6c111)(arg1, arg2, arg3), filters = _parseFilterArgs5[0], options = _parseFilterArgs5[1];
        var refetchFilters = (0, $dda4d40cf5733033$export$2e2bcd8739ae039)({}, filters, {
            // if filters.refetchActive is not provided and filters.active is explicitly false,
            // e.g. invalidateQueries({ active: false }), we don't want to refetch active queries
            active: (_ref3 = (_filters$refetchActiv = filters.refetchActive) != null ? _filters$refetchActiv : filters.active) != null ? _ref3 : true,
            inactive: (_filters$refetchInact = filters.refetchInactive) != null ? _filters$refetchInact : false
        });
        return (0, $290db3e0ce227fd3$export$520687f44db6e1ab).batch(function() {
            _this5.queryCache.findAll(filters).forEach(function(query) {
                query.invalidate();
            });
            return _this5.refetchQueries(refetchFilters, options);
        });
    };
    _proto.refetchQueries = function refetchQueries(arg1, arg2, arg3) {
        var _this6 = this;
        var _parseFilterArgs6 = (0, $3ff4724ea894d7ab$export$18e8f4b987e6c111)(arg1, arg2, arg3), filters = _parseFilterArgs6[0], options = _parseFilterArgs6[1];
        var promises = (0, $290db3e0ce227fd3$export$520687f44db6e1ab).batch(function() {
            return _this6.queryCache.findAll(filters).map(function(query) {
                return query.fetch(undefined, (0, $dda4d40cf5733033$export$2e2bcd8739ae039)({}, options, {
                    meta: {
                        refetchPage: filters == null ? void 0 : filters.refetchPage
                    }
                }));
            });
        });
        var promise = Promise.all(promises).then((0, $3ff4724ea894d7ab$export$8793edee2d425525));
        if (!(options == null ? void 0 : options.throwOnError)) promise = promise.catch((0, $3ff4724ea894d7ab$export$8793edee2d425525));
        return promise;
    };
    _proto.fetchQuery = function fetchQuery(arg1, arg2, arg3) {
        var parsedOptions = (0, $3ff4724ea894d7ab$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
        var defaultedOptions = this.defaultQueryOptions(parsedOptions); // https://github.com/tannerlinsley/react-query/issues/652
        if (typeof defaultedOptions.retry === 'undefined') defaultedOptions.retry = false;
        var query = this.queryCache.build(this, defaultedOptions);
        return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    };
    _proto.prefetchQuery = function prefetchQuery(arg1, arg2, arg3) {
        return this.fetchQuery(arg1, arg2, arg3).then((0, $3ff4724ea894d7ab$export$8793edee2d425525)).catch((0, $3ff4724ea894d7ab$export$8793edee2d425525));
    };
    _proto.fetchInfiniteQuery = function fetchInfiniteQuery(arg1, arg2, arg3) {
        var parsedOptions = (0, $3ff4724ea894d7ab$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
        parsedOptions.behavior = (0, $615235d24e9a8762$export$84470d1367601e8d)();
        return this.fetchQuery(parsedOptions);
    };
    _proto.prefetchInfiniteQuery = function prefetchInfiniteQuery(arg1, arg2, arg3) {
        return this.fetchInfiniteQuery(arg1, arg2, arg3).then((0, $3ff4724ea894d7ab$export$8793edee2d425525)).catch((0, $3ff4724ea894d7ab$export$8793edee2d425525));
    };
    _proto.cancelMutations = function cancelMutations() {
        var _this7 = this;
        var promises = (0, $290db3e0ce227fd3$export$520687f44db6e1ab).batch(function() {
            return _this7.mutationCache.getAll().map(function(mutation) {
                return mutation.cancel();
            });
        });
        return Promise.all(promises).then((0, $3ff4724ea894d7ab$export$8793edee2d425525)).catch((0, $3ff4724ea894d7ab$export$8793edee2d425525));
    };
    _proto.resumePausedMutations = function resumePausedMutations() {
        return this.getMutationCache().resumePausedMutations();
    };
    _proto.executeMutation = function executeMutation(options) {
        return this.mutationCache.build(this, options).execute();
    };
    _proto.getQueryCache = function getQueryCache() {
        return this.queryCache;
    };
    _proto.getMutationCache = function getMutationCache() {
        return this.mutationCache;
    };
    _proto.getDefaultOptions = function getDefaultOptions() {
        return this.defaultOptions;
    };
    _proto.setDefaultOptions = function setDefaultOptions(options) {
        this.defaultOptions = options;
    };
    _proto.setQueryDefaults = function setQueryDefaults(queryKey, options) {
        var result = this.queryDefaults.find(function(x) {
            return (0, $3ff4724ea894d7ab$export$5fcb678681417b54)(queryKey) === (0, $3ff4724ea894d7ab$export$5fcb678681417b54)(x.queryKey);
        });
        if (result) result.defaultOptions = options;
        else this.queryDefaults.push({
            queryKey: queryKey,
            defaultOptions: options
        });
    };
    _proto.getQueryDefaults = function getQueryDefaults(queryKey) {
        var _this$queryDefaults$f;
        return queryKey ? (_this$queryDefaults$f = this.queryDefaults.find(function(x) {
            return (0, $3ff4724ea894d7ab$export$2f07189bb9fa26a7)(queryKey, x.queryKey);
        })) == null ? void 0 : _this$queryDefaults$f.defaultOptions : undefined;
    };
    _proto.setMutationDefaults = function setMutationDefaults(mutationKey, options) {
        var result = this.mutationDefaults.find(function(x) {
            return (0, $3ff4724ea894d7ab$export$5fcb678681417b54)(mutationKey) === (0, $3ff4724ea894d7ab$export$5fcb678681417b54)(x.mutationKey);
        });
        if (result) result.defaultOptions = options;
        else this.mutationDefaults.push({
            mutationKey: mutationKey,
            defaultOptions: options
        });
    };
    _proto.getMutationDefaults = function getMutationDefaults(mutationKey) {
        var _this$mutationDefault;
        return mutationKey ? (_this$mutationDefault = this.mutationDefaults.find(function(x) {
            return (0, $3ff4724ea894d7ab$export$2f07189bb9fa26a7)(mutationKey, x.mutationKey);
        })) == null ? void 0 : _this$mutationDefault.defaultOptions : undefined;
    };
    _proto.defaultQueryOptions = function defaultQueryOptions(options) {
        if (options == null ? void 0 : options._defaulted) return options;
        var defaultedOptions = (0, $dda4d40cf5733033$export$2e2bcd8739ae039)({}, this.defaultOptions.queries, this.getQueryDefaults(options == null ? void 0 : options.queryKey), options, {
            _defaulted: true
        });
        if (!defaultedOptions.queryHash && defaultedOptions.queryKey) defaultedOptions.queryHash = (0, $3ff4724ea894d7ab$export$cc90ca97bc0d73fd)(defaultedOptions.queryKey, defaultedOptions);
        return defaultedOptions;
    };
    _proto.defaultQueryObserverOptions = function defaultQueryObserverOptions(options) {
        return this.defaultQueryOptions(options);
    };
    _proto.defaultMutationOptions = function defaultMutationOptions(options) {
        if (options == null ? void 0 : options._defaulted) return options;
        return (0, $dda4d40cf5733033$export$2e2bcd8739ae039)({}, this.defaultOptions.mutations, this.getMutationDefaults(options == null ? void 0 : options.mutationKey), options, {
            _defaulted: true
        });
    };
    _proto.clear = function clear() {
        this.queryCache.clear();
        this.mutationCache.clear();
    };
    return QueryClient;
}();


// Side effects


var $bb92ec142e53873a$export$c78a37762a8d58e1 = (0, (/*@__PURE__*/$parcel$interopDefault($f419cfc3d92fe631$exports))).unstable_batchedUpdates;


(0, $290db3e0ce227fd3$export$520687f44db6e1ab).setBatchNotifyFunction((0, $bb92ec142e53873a$export$c78a37762a8d58e1));



var $cb0a650327a3197a$export$af88d00dbe7f521 = console;


(0, $9489c5e76e62cc56$export$3abbd92f765bee58)((0, $cb0a650327a3197a$export$af88d00dbe7f521));



var $tZqWC = parcelRequire("tZqWC");
var $9d2791931b06a49b$var$defaultContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createContext(undefined);
var $9d2791931b06a49b$var$QueryClientSharingContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createContext(false); // if contextSharing is on, we share the first and at least one
// instance of the context across the window
// to ensure that if React Query is used across
// different bundles or microfrontends they will
// all use the same **instance** of context, regardless
// of module scoping.
function $9d2791931b06a49b$var$getQueryClientContext(contextSharing) {
    if (contextSharing && typeof window !== 'undefined') {
        if (!window.ReactQueryClientContext) window.ReactQueryClientContext = $9d2791931b06a49b$var$defaultContext;
        return window.ReactQueryClientContext;
    }
    return $9d2791931b06a49b$var$defaultContext;
}
var $9d2791931b06a49b$export$22e77b9572c4fded = function useQueryClient() {
    var queryClient = (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).useContext($9d2791931b06a49b$var$getQueryClientContext((0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).useContext($9d2791931b06a49b$var$QueryClientSharingContext)));
    if (!queryClient) throw new Error('No QueryClient set, use QueryClientProvider to set one');
    return queryClient;
};
var $9d2791931b06a49b$export$45604f0cc8ae667b = function QueryClientProvider(_ref) {
    var client = _ref.client, _ref$contextSharing = _ref.contextSharing, contextSharing = _ref$contextSharing === void 0 ? false : _ref$contextSharing, children = _ref.children;
    (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).useEffect(function() {
        client.mount();
        return function() {
            client.unmount();
        };
    }, [
        client
    ]);
    var Context = $9d2791931b06a49b$var$getQueryClientContext(contextSharing);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($9d2791931b06a49b$var$QueryClientSharingContext.Provider, {
        value: contextSharing
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Context.Provider, {
        value: client
    }, children));
};







var $tZqWC = parcelRequire("tZqWC");







var $9d7be58e553793c5$export$d3c1860ee66f291a = /*#__PURE__*/ function(_Subscribable) {
    (0, $0ec1659a3a380451$export$2e2bcd8739ae039)(MutationObserver, _Subscribable);
    function MutationObserver(client, options) {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.client = client;
        _this.setOptions(options);
        _this.bindMethods();
        _this.updateResult();
        return _this;
    }
    var _proto = MutationObserver.prototype;
    _proto.bindMethods = function bindMethods() {
        this.mutate = this.mutate.bind(this);
        this.reset = this.reset.bind(this);
    };
    _proto.setOptions = function setOptions(options) {
        this.options = this.client.defaultMutationOptions(options);
    };
    _proto.onUnsubscribe = function onUnsubscribe() {
        if (!this.listeners.length) {
            var _this$currentMutation;
            (_this$currentMutation = this.currentMutation) == null || _this$currentMutation.removeObserver(this);
        }
    };
    _proto.onMutationUpdate = function onMutationUpdate(action) {
        this.updateResult(); // Determine which callbacks to trigger
        var notifyOptions = {
            listeners: true
        };
        if (action.type === 'success') notifyOptions.onSuccess = true;
        else if (action.type === 'error') notifyOptions.onError = true;
        this.notify(notifyOptions);
    };
    _proto.getCurrentResult = function getCurrentResult() {
        return this.currentResult;
    };
    _proto.reset = function reset() {
        this.currentMutation = undefined;
        this.updateResult();
        this.notify({
            listeners: true
        });
    };
    _proto.mutate = function mutate(variables, options) {
        this.mutateOptions = options;
        if (this.currentMutation) this.currentMutation.removeObserver(this);
        this.currentMutation = this.client.getMutationCache().build(this.client, (0, $dda4d40cf5733033$export$2e2bcd8739ae039)({}, this.options, {
            variables: typeof variables !== 'undefined' ? variables : this.options.variables
        }));
        this.currentMutation.addObserver(this);
        return this.currentMutation.execute();
    };
    _proto.updateResult = function updateResult() {
        var state = this.currentMutation ? this.currentMutation.state : (0, $74a5e2e6477d55b9$export$a1659b54bac3252a)();
        var result = (0, $dda4d40cf5733033$export$2e2bcd8739ae039)({}, state, {
            isLoading: state.status === 'loading',
            isSuccess: state.status === 'success',
            isError: state.status === 'error',
            isIdle: state.status === 'idle',
            mutate: this.mutate,
            reset: this.reset
        });
        this.currentResult = result;
    };
    _proto.notify = function notify(options) {
        var _this2 = this;
        (0, $290db3e0ce227fd3$export$520687f44db6e1ab).batch(function() {
            // First trigger the mutate callbacks
            if (_this2.mutateOptions) {
                if (options.onSuccess) {
                    _this2.mutateOptions.onSuccess == null || _this2.mutateOptions.onSuccess(_this2.currentResult.data, _this2.currentResult.variables, _this2.currentResult.context);
                    _this2.mutateOptions.onSettled == null || _this2.mutateOptions.onSettled(_this2.currentResult.data, null, _this2.currentResult.variables, _this2.currentResult.context);
                } else if (options.onError) {
                    _this2.mutateOptions.onError == null || _this2.mutateOptions.onError(_this2.currentResult.error, _this2.currentResult.variables, _this2.currentResult.context);
                    _this2.mutateOptions.onSettled == null || _this2.mutateOptions.onSettled(undefined, _this2.currentResult.error, _this2.currentResult.variables, _this2.currentResult.context);
                }
            } // Then trigger the listeners
            if (options.listeners) _this2.listeners.forEach(function(listener) {
                listener(_this2.currentResult);
            });
        });
    };
    return MutationObserver;
}((0, $8d9dbc58b3471196$export$d26086b469ecdbcc));



function $645ff6dc65a1374e$export$2072f68e6c3507cf(suspense, _useErrorBoundary, params) {
    // Allow useErrorBoundary function to override throwing behavior on a per-error basis
    if (typeof _useErrorBoundary === 'function') return _useErrorBoundary.apply(void 0, params);
     // Allow useErrorBoundary to override suspense's throwing behavior
    if (typeof _useErrorBoundary === 'boolean') return _useErrorBoundary; // If suspense is enabled default to throwing errors
    return !!suspense;
}


function $38e130c204b159d1$export$609860bf8b0084c(arg1, arg2, arg3) {
    var mountedRef = (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).useRef(false);
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).useState(0), forceUpdate = _React$useState[1];
    var options = (0, $3ff4724ea894d7ab$export$b646c531ea475334)(arg1, arg2, arg3);
    var queryClient = (0, $9d2791931b06a49b$export$22e77b9572c4fded)();
    var obsRef = (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).useRef();
    if (!obsRef.current) obsRef.current = new (0, $9d7be58e553793c5$export$d3c1860ee66f291a)(queryClient, options);
    else obsRef.current.setOptions(options);
    var currentResult = obsRef.current.getCurrentResult();
    (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).useEffect(function() {
        mountedRef.current = true;
        var unsubscribe = obsRef.current.subscribe((0, $290db3e0ce227fd3$export$520687f44db6e1ab).batchCalls(function() {
            if (mountedRef.current) forceUpdate(function(x) {
                return x + 1;
            });
        }));
        return function() {
            mountedRef.current = false;
            unsubscribe();
        };
    }, []);
    var mutate = (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).useCallback(function(variables, mutateOptions) {
        obsRef.current.mutate(variables, mutateOptions).catch((0, $3ff4724ea894d7ab$export$8793edee2d425525));
    }, []);
    if (currentResult.error && (0, $645ff6dc65a1374e$export$2072f68e6c3507cf)(undefined, obsRef.current.options.useErrorBoundary, [
        currentResult.error
    ])) throw currentResult.error;
    return (0, $dda4d40cf5733033$export$2e2bcd8739ae039)({}, currentResult, {
        mutate: mutate,
        mutateAsync: currentResult.mutate
    });
}












var $4L3zM = parcelRequire("4L3zM");
function $6829791a091ca67a$var$AppReactQueryProvider(props) {
    // Destructure
    const { children: children } = props;
    // Variables
    const queryClient = new (0, $97b75e8fb286a5f4$export$405d0624ed55a03f)();
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d2791931b06a49b$export$45604f0cc8ae667b), {
        client: queryClient,
        children: children
    });
}
var $6829791a091ca67a$export$2e2bcd8739ae039 = $6829791a091ca67a$var$AppReactQueryProvider;
// Proptypes Validation
$6829791a091ca67a$var$AppReactQueryProvider.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ]).isRequired
};



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

var $5M4sD = parcelRequire("5M4sD");

var $tZqWC = parcelRequire("tZqWC");
var $c5a0bc5372e756ee$exports = {};
//
$c5a0bc5372e756ee$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


function $68d249255e56b2cd$var$stylis_min(W) {
    function M(d, c, e, h, a) {
        for(var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;){
            g = e.charCodeAt(l);
            l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
            if (0 === b + n + v + m) {
                if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
                    switch(g){
                        case 32:
                        case 9:
                        case 59:
                        case 13:
                        case 10:
                            break;
                        default:
                            f += e.charAt(l);
                    }
                    g = 59;
                }
                switch(g){
                    case 123:
                        f = f.trim();
                        q = f.charCodeAt(0);
                        k = 1;
                        for(t = ++l; l < B;){
                            switch(g = e.charCodeAt(l)){
                                case 123:
                                    k++;
                                    break;
                                case 125:
                                    k--;
                                    break;
                                case 47:
                                    switch(g = e.charCodeAt(l + 1)){
                                        case 42:
                                        case 47:
                                            a: {
                                                for(u = l + 1; u < J; ++u)switch(e.charCodeAt(u)){
                                                    case 47:
                                                        if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                        break;
                                                    case 10:
                                                        if (47 === g) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                }
                                                l = u;
                                            }
                                    }
                                    break;
                                case 91:
                                    g++;
                                case 40:
                                    g++;
                                case 34:
                                case 39:
                                    for(; l++ < J && e.charCodeAt(l) !== g;);
                            }
                            if (0 === k) break;
                            l++;
                        }
                        k = e.substring(t, l);
                        0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));
                        switch(q){
                            case 64:
                                0 < r && (f = f.replace(N, ''));
                                g = f.charCodeAt(1);
                                switch(g){
                                    case 100:
                                    case 109:
                                    case 115:
                                    case 45:
                                        r = c;
                                        break;
                                    default:
                                        r = O;
                                }
                                k = M(c, r, k, g, a + 1);
                                t = k.length;
                                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                                if (0 < t) switch(g){
                                    case 115:
                                        f = f.replace(da, ea);
                                    case 100:
                                    case 109:
                                    case 45:
                                        k = f + '{' + k + '}';
                                        break;
                                    case 107:
                                        f = f.replace(fa, '$1 $2');
                                        k = f + '{' + k + '}';
                                        k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                                        break;
                                    default:
                                        k = f + k, 112 === h && (k = (p += k, ''));
                                }
                                else k = '';
                                break;
                            default:
                                k = M(c, X(c, f, I), k, h, a + 1);
                        }
                        F += k;
                        k = I = r = u = q = 0;
                        f = '';
                        g = e.charCodeAt(++l);
                        break;
                    case 125:
                    case 59:
                        f = (0 < r ? f.replace(N, '') : f).trim();
                        if (1 < (t = f.length)) switch(0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q){
                            case 0:
                                break;
                            case 64:
                                if (105 === g || 99 === g) {
                                    G += f + e.charAt(l);
                                    break;
                                }
                            default:
                                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
                        }
                        I = r = u = q = 0;
                        f = '';
                        g = e.charCodeAt(++l);
                }
            }
            switch(g){
                case 13:
                case 10:
                    47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
                    0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
                    z = 1;
                    D++;
                    break;
                case 59:
                case 125:
                    if (0 === b + n + v + m) {
                        z++;
                        break;
                    }
                default:
                    z++;
                    y = e.charAt(l);
                    switch(g){
                        case 9:
                        case 32:
                            if (0 === n + m + b) switch(x){
                                case 44:
                                case 58:
                                case 9:
                                case 32:
                                    y = '';
                                    break;
                                default:
                                    32 !== g && (y = ' ');
                            }
                            break;
                        case 0:
                            y = '\\0';
                            break;
                        case 12:
                            y = '\\f';
                            break;
                        case 11:
                            y = '\\v';
                            break;
                        case 38:
                            0 === n + b + m && (r = I = 1, y = '\f' + y);
                            break;
                        case 108:
                            if (0 === n + b + m + E && 0 < u) switch(l - u){
                                case 2:
                                    112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
                                case 8:
                                    111 === K && (E = K);
                            }
                            break;
                        case 58:
                            0 === n + b + m && (u = l);
                            break;
                        case 44:
                            0 === b + v + n + m && (r = 1, y += '\r');
                            break;
                        case 34:
                        case 39:
                            0 === b && (n = n === g ? 0 : 0 === n ? g : n);
                            break;
                        case 91:
                            0 === n + b + v && m++;
                            break;
                        case 93:
                            0 === n + b + v && m--;
                            break;
                        case 41:
                            0 === n + b + m && v--;
                            break;
                        case 40:
                            if (0 === n + b + m) {
                                if (0 === q) switch(2 * x + 3 * K){
                                    case 533:
                                        break;
                                    default:
                                        q = 1;
                                }
                                v++;
                            }
                            break;
                        case 64:
                            0 === b + v + n + m + u + k && (k = 1);
                            break;
                        case 42:
                        case 47:
                            if (!(0 < n + m + v)) switch(b){
                                case 0:
                                    switch(2 * g + 3 * e.charCodeAt(l + 1)){
                                        case 235:
                                            b = 47;
                                            break;
                                        case 220:
                                            t = l, b = 42;
                                    }
                                    break;
                                case 42:
                                    47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
                            }
                    }
                    0 === b && (f += y);
            }
            K = x;
            x = g;
            l++;
        }
        t = p.length;
        if (0 < t) {
            r = c;
            if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
            p = r.join(',') + '{' + p + '}';
            if (0 !== w * E) {
                2 !== w || L(p, 2) || (E = 0);
                switch(E){
                    case 111:
                        p = p.replace(ha, ':-moz-$1') + p;
                        break;
                    case 112:
                        p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
                }
                E = 0;
            }
        }
        return G + p + F;
    }
    function X(d, c, e) {
        var h = c.trim().split(ia);
        c = h;
        var a = h.length, m = d.length;
        switch(m){
            case 0:
            case 1:
                var b = 0;
                for(d = 0 === m ? '' : d[0] + ' '; b < a; ++b)c[b] = Z(d, c[b], e).trim();
                break;
            default:
                var v = b = 0;
                for(c = []; b < a; ++b)for(var n = 0; n < m; ++n)c[v++] = Z(d[n] + ' ', h[b], e).trim();
        }
        return c;
    }
    function Z(d, c, e) {
        var h = c.charCodeAt(0);
        33 > h && (h = (c = c.trim()).charCodeAt(0));
        switch(h){
            case 38:
                return c.replace(F, '$1' + d.trim());
            case 58:
                return d.trim() + c.replace(F, '$1' + d.trim());
            default:
                if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
        }
        return d + c;
    }
    function P(d, c, e, h) {
        var a = d + ';', m = 2 * c + 3 * e + 4 * h;
        if (944 === m) {
            d = a.indexOf(':', 9) + 1;
            var b = a.substring(d, a.length - 1).trim();
            b = a.substring(0, d).trim() + b + ';';
            return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
        }
        if (0 === w || 2 === w && !L(a, 1)) return a;
        switch(m){
            case 1015:
                return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;
            case 951:
                return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;
            case 963:
                return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;
            case 1009:
                if (100 !== a.charCodeAt(4)) break;
            case 969:
            case 942:
                return '-webkit-' + a + a;
            case 978:
                return '-webkit-' + a + '-moz-' + a + a;
            case 1019:
            case 983:
                return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;
            case 883:
                if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
                if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
                break;
            case 932:
                if (45 === a.charCodeAt(4)) switch(a.charCodeAt(5)){
                    case 103:
                        return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;
                    case 115:
                        return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;
                    case 98:
                        return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
                }
                return '-webkit-' + a + '-ms-' + a + a;
            case 964:
                return '-webkit-' + a + '-ms-flex-' + a + a;
            case 1023:
                if (99 !== a.charCodeAt(8)) break;
                b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
                return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;
            case 1005:
                return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;
            case 1e3:
                b = a.substring(13).trim();
                c = b.indexOf('-') + 1;
                switch(b.charCodeAt(0) + b.charCodeAt(c)){
                    case 226:
                        b = a.replace(G, 'tb');
                        break;
                    case 232:
                        b = a.replace(G, 'tb-rl');
                        break;
                    case 220:
                        b = a.replace(G, 'lr');
                        break;
                    default:
                        return a;
                }
                return '-webkit-' + a + '-ms-' + b + a;
            case 1017:
                if (-1 === a.indexOf('sticky', 9)) break;
            case 975:
                c = (a = d).length - 10;
                b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();
                switch(m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)){
                    case 203:
                        if (111 > b.charCodeAt(8)) break;
                    case 115:
                        a = a.replace(b, '-webkit-' + b) + ';' + a;
                        break;
                    case 207:
                    case 102:
                        a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
                }
                return a + ';';
            case 938:
                if (45 === a.charCodeAt(5)) switch(a.charCodeAt(6)){
                    case 105:
                        return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;
                    case 115:
                        return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;
                    default:
                        return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
                }
                break;
            case 973:
            case 989:
                if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
            case 931:
            case 953:
                if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
                break;
            case 962:
                if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
        }
        return a;
    }
    function L(d, c) {
        var e = d.indexOf(1 === c ? ':' : '{'), h = d.substring(0, 3 !== c ? e : 10);
        e = d.substring(e + 1, d.length - 1);
        return R(2 !== c ? h : h.replace(na, '$1'), e, c);
    }
    function ea(d, c) {
        var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
        return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
    }
    function H(d, c, e, h, a, m, b, v, n, q) {
        for(var g = 0, x = c, w; g < A; ++g)switch(w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)){
            case void 0:
            case !1:
            case !0:
            case null:
                break;
            default:
                x = w;
        }
        if (x !== c) return x;
    }
    function T(d) {
        switch(d){
            case void 0:
            case null:
                A = S.length = 0;
                break;
            default:
                if ('function' === typeof d) S[A++] = d;
                else if ('object' === typeof d) for(var c = 0, e = d.length; c < e; ++c)T(d[c]);
                else Y = !!d | 0;
        }
        return T;
    }
    function U(d) {
        d = d.prefix;
        void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
        return U;
    }
    function B(d, c) {
        var e = d;
        33 > e.charCodeAt(0) && (e = e.trim());
        V = e;
        e = [
            V
        ];
        if (0 < A) {
            var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
            void 0 !== h && 'string' === typeof h && (c = h);
        }
        var a = M(O, e, c, 0, 0);
        0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
        V = '';
        E = 0;
        z = D = 1;
        return a;
    }
    var ca = /^\0+/g, N = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q = /::(place)/g, ha = /:(read-only)/g, G = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z = 1, D = 1, E = 0, w = 1, O = [], S = [], A = 0, R = null, Y = 0, V = '';
    B.use = T;
    B.set = U;
    void 0 !== W && U(W);
    return B;
}
var $68d249255e56b2cd$export$2e2bcd8739ae039 = $68d249255e56b2cd$var$stylis_min;


var $87b1d4e5408c6cd9$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $87b1d4e5408c6cd9$export$2e2bcd8739ae039 = $87b1d4e5408c6cd9$var$unitlessKeys;


function $b898e7e508b9051b$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


// eslint-disable-next-line no-undef
var $b8af5ec90e8faa44$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $b8af5ec90e8faa44$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $b898e7e508b9051b$export$2e2bcd8739ae039)(function(prop) {
    return $b8af5ec90e8faa44$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});



var $7g5pF = parcelRequire("7g5pF");
function $a778141486c79bc3$var$y() {
    return ($a778141486c79bc3$var$y = Object.assign || function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
    }).apply(this, arguments);
}
var $a778141486c79bc3$var$v = function(e, t) {
    for(var n = [
        e[0]
    ], r = 0, o = t.length; r < o; r += 1)n.push(t[r], e[r + 1]);
    return n;
}, $a778141486c79bc3$var$g = function(t) {
    return null !== t && "object" == typeof t && "[object Object]" === (t.toString ? t.toString() : Object.prototype.toString.call(t)) && !(0, $5M4sD.typeOf)(t);
}, $a778141486c79bc3$var$S = Object.freeze([]), $a778141486c79bc3$var$w = Object.freeze({});
function $a778141486c79bc3$var$E(e) {
    return "function" == typeof e;
}
function $a778141486c79bc3$var$b(e) {
    return e.displayName || e.name || "Component";
}
function $a778141486c79bc3$export$7ba318d8d2f06c76(e) {
    return e && "string" == typeof e.styledComponentId;
}
var $a778141486c79bc3$var$N = "data-styled", $a778141486c79bc3$export$83d89fbfd8236492 = "5.3.11", $a778141486c79bc3$var$C = "undefined" != typeof window && "HTMLElement" in window, $a778141486c79bc3$var$I = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : false), $a778141486c79bc3$var$P = {}, $a778141486c79bc3$var$O = {};
function $a778141486c79bc3$var$R() {
    for(var e = arguments.length <= 0 ? void 0 : arguments[0], t = [], n = 1, r = arguments.length; n < r; n += 1)t.push(n < 0 || arguments.length <= n ? void 0 : arguments[n]);
    return t.forEach(function(t) {
        e = e.replace(/%[a-z]/, t);
    }), e;
}
function $a778141486c79bc3$var$D(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    throw new Error("An error occurred. See https://git.io/JUIaE#" + e + " for more information." + (n.length > 0 ? " Args: " + n.join(", ") : ""));
}
var $a778141486c79bc3$var$j = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    var t = e.prototype;
    return t.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, t.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, r = n.length, o = r; e >= o;)(o <<= 1) < 0 && $a778141486c79bc3$var$D(16, "" + e);
            this.groupSizes = new Uint32Array(o), this.groupSizes.set(n), this.length = o;
            for(var s = r; s < o; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = 0, c = t.length; a < c; a++)this.tag.insertRule(i, t[a]) && (this.groupSizes[e]++, i++);
    }, t.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), r = n + t;
            this.groupSizes[e] = 0;
            for(var o = n; o < r; o++)this.tag.deleteRule(n);
        }
    }, t.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], r = this.indexOfGroup(e), o = r + n, s = r; s < o; s++)t += this.tag.getRule(s) + "/*!sc*/\n";
        return t;
    }, e;
}(), $a778141486c79bc3$var$T = new Map, $a778141486c79bc3$var$x = new Map, $a778141486c79bc3$var$k = 1, $a778141486c79bc3$var$V = function(e) {
    if ($a778141486c79bc3$var$T.has(e)) return $a778141486c79bc3$var$T.get(e);
    for(; $a778141486c79bc3$var$x.has($a778141486c79bc3$var$k);)$a778141486c79bc3$var$k++;
    var t = $a778141486c79bc3$var$k++;
    return $a778141486c79bc3$var$T.set(e, t), $a778141486c79bc3$var$x.set(t, e), t;
}, $a778141486c79bc3$var$B = function(e) {
    return $a778141486c79bc3$var$x.get(e);
}, $a778141486c79bc3$var$z = function(e, t) {
    t >= $a778141486c79bc3$var$k && ($a778141486c79bc3$var$k = t + 1), $a778141486c79bc3$var$T.set(e, t), $a778141486c79bc3$var$x.set(t, e);
}, $a778141486c79bc3$var$M = "style[" + $a778141486c79bc3$var$N + '][data-styled-version="5.3.11"]', $a778141486c79bc3$var$G = new RegExp("^" + $a778141486c79bc3$var$N + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'), $a778141486c79bc3$var$L = function(e, t, n) {
    for(var r, o = n.split(","), s = 0, i = o.length; s < i; s++)(r = o[s]) && e.registerName(t, r);
}, $a778141486c79bc3$var$F = function(e, t) {
    for(var n = (t.textContent || "").split("/*!sc*/\n"), r = [], o = 0, s = n.length; o < s; o++){
        var i = n[o].trim();
        if (i) {
            var a = i.match($a778141486c79bc3$var$G);
            if (a) {
                var c = 0 | parseInt(a[1], 10), u = a[2];
                0 !== c && ($a778141486c79bc3$var$z(u, c), $a778141486c79bc3$var$L(e, u, a[3]), e.getTag().insertRules(c, r)), r.length = 0;
            } else r.push(i);
        }
    }
}, $a778141486c79bc3$var$Y = function() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}, $a778141486c79bc3$var$q = function(e) {
    var t = document.head, n = e || t, r = document.createElement("style"), o = function(e) {
        for(var t = e.childNodes, n = t.length; n >= 0; n--){
            var r = t[n];
            if (r && 1 === r.nodeType && r.hasAttribute($a778141486c79bc3$var$N)) return r;
        }
    }(n), s = void 0 !== o ? o.nextSibling : null;
    r.setAttribute($a778141486c79bc3$var$N, "active"), r.setAttribute("data-styled-version", "5.3.11");
    var i = $a778141486c79bc3$var$Y();
    return i && r.setAttribute("nonce", i), n.insertBefore(r, s), r;
}, $a778141486c79bc3$var$H = function() {
    function e(e) {
        var t = this.element = $a778141486c79bc3$var$q(e);
        t.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, r = t.length; n < r; n++){
                var o = t[n];
                if (o.ownerNode === e) return o;
            }
            $a778141486c79bc3$var$D(17);
        }(t), this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, t.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, t.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return void 0 !== t && "string" == typeof t.cssText ? t.cssText : "";
    }, e;
}(), $a778141486c79bc3$var$$ = function() {
    function e(e) {
        var t = this.element = $a778141486c79bc3$var$q(e);
        this.nodes = t.childNodes, this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t), r = this.nodes[e];
            return this.element.insertBefore(n, r || null), this.length++, !0;
        }
        return !1;
    }, t.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $a778141486c79bc3$var$W = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, t.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $a778141486c79bc3$var$U = $a778141486c79bc3$var$C, $a778141486c79bc3$var$J = {
    isServer: !$a778141486c79bc3$var$C,
    useCSSOMInjection: !$a778141486c79bc3$var$I
}, $a778141486c79bc3$var$X = function() {
    function e(e, t, n) {
        void 0 === e && (e = $a778141486c79bc3$var$w), void 0 === t && (t = {}), this.options = $a778141486c79bc3$var$y({}, $a778141486c79bc3$var$J, {}, e), this.gs = t, this.names = new Map(n), this.server = !!e.isServer, !this.server && $a778141486c79bc3$var$C && $a778141486c79bc3$var$U && ($a778141486c79bc3$var$U = !1, function(e) {
            for(var t = document.querySelectorAll($a778141486c79bc3$var$M), n = 0, r = t.length; n < r; n++){
                var o = t[n];
                o && "active" !== o.getAttribute($a778141486c79bc3$var$N) && ($a778141486c79bc3$var$F(e, o), o.parentNode && o.parentNode.removeChild(o));
            }
        }(this));
    }
    e.registerId = function(e) {
        return $a778141486c79bc3$var$V(e);
    };
    var t = e.prototype;
    return t.reconstructWithOptions = function(t, n) {
        return void 0 === n && (n = !0), new e($a778141486c79bc3$var$y({}, this.options, {}, t), this.gs, n && this.names || void 0);
    }, t.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, t.getTag = function() {
        var e, t, n, r, o;
        return this.tag || (this.tag = (n = (t = this.options).isServer, r = t.useCSSOMInjection, o = t.target, e = n ? new $a778141486c79bc3$var$W(o) : r ? new $a778141486c79bc3$var$H(o) : new $a778141486c79bc3$var$$(o), new $a778141486c79bc3$var$j(e)));
    }, t.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, t.registerName = function(e, t) {
        if ($a778141486c79bc3$var$V(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, t.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($a778141486c79bc3$var$V(e), n);
    }, t.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, t.clearRules = function(e) {
        this.getTag().clearGroup($a778141486c79bc3$var$V(e)), this.clearNames(e);
    }, t.clearTag = function() {
        this.tag = void 0;
    }, t.toString = function() {
        return function(e) {
            for(var t = e.getTag(), n = t.length, r = "", o = 0; o < n; o++){
                var s = $a778141486c79bc3$var$B(o);
                if (void 0 !== s) {
                    var i = e.names.get(s), a = t.getGroup(o);
                    if (i && a && i.size) {
                        var c = $a778141486c79bc3$var$N + ".g" + o + '[id="' + s + '"]', u = "";
                        void 0 !== i && i.forEach(function(e) {
                            e.length > 0 && (u += e + ",");
                        }), r += "" + a + c + '{content:"' + u + '"}/*!sc*/\n';
                    }
                }
            }
            return r;
        }(this);
    }, e;
}(), $a778141486c79bc3$var$Z = /(a)(d)/gi, $a778141486c79bc3$var$K = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $a778141486c79bc3$var$Q(e) {
    var t, n = "";
    for(t = Math.abs(e); t > 52; t = t / 52 | 0)n = $a778141486c79bc3$var$K(t % 52) + n;
    return ($a778141486c79bc3$var$K(t % 52) + n).replace($a778141486c79bc3$var$Z, "$1-$2");
}
var $a778141486c79bc3$var$ee = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $a778141486c79bc3$var$te = function(e) {
    return $a778141486c79bc3$var$ee(5381, e);
};
function $a778141486c79bc3$var$ne(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($a778141486c79bc3$var$E(n) && !$a778141486c79bc3$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $a778141486c79bc3$var$re = $a778141486c79bc3$var$te("5.3.11"), $a778141486c79bc3$var$oe = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && $a778141486c79bc3$var$ne(e), this.componentId = t, this.baseHash = $a778141486c79bc3$var$ee($a778141486c79bc3$var$re, t), this.baseStyle = n, $a778141486c79bc3$var$X.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var r = this.componentId, o = [];
        if (this.baseStyle && o.push(this.baseStyle.generateAndInjectStyles(e, t, n)), this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(r, this.staticRulesId)) o.push(this.staticRulesId);
            else {
                var s = $a778141486c79bc3$var$_e(this.rules, e, t, n).join(""), i = $a778141486c79bc3$var$Q($a778141486c79bc3$var$ee(this.baseHash, s) >>> 0);
                if (!t.hasNameForId(r, i)) {
                    var a = n(s, "." + i, void 0, r);
                    t.insertRules(r, i, a);
                }
                o.push(i), this.staticRulesId = i;
            }
        } else {
            for(var c = this.rules.length, u = $a778141486c79bc3$var$ee(this.baseHash, n.hash), l = "", d = 0; d < c; d++){
                var h = this.rules[d];
                if ("string" == typeof h) l += h;
                else if (h) {
                    var p = $a778141486c79bc3$var$_e(h, e, t, n), f = Array.isArray(p) ? p.join("") : p;
                    u = $a778141486c79bc3$var$ee(u, f + d), l += f;
                }
            }
            if (l) {
                var m = $a778141486c79bc3$var$Q(u >>> 0);
                if (!t.hasNameForId(r, m)) {
                    var y = n(l, "." + m, void 0, r);
                    t.insertRules(r, m, y);
                }
                o.push(m);
            }
        }
        return o.join(" ");
    }, e;
}(), $a778141486c79bc3$var$se = /^\s*\/\/.*$/gm, $a778141486c79bc3$var$ie = [
    ":",
    "[",
    ".",
    "#"
];
function $a778141486c79bc3$var$ae(e) {
    var t, n, r, o, s = void 0 === e ? $a778141486c79bc3$var$w : e, i = s.options, a = void 0 === i ? $a778141486c79bc3$var$w : i, c = s.plugins, u = void 0 === c ? $a778141486c79bc3$var$S : c, l = new (0, $68d249255e56b2cd$export$2e2bcd8739ae039)(a), d = [], p = function(e) {
        function t(t) {
            if (t) try {
                e(t + "}");
            } catch (e) {}
        }
        return function(n, r, o, s, i, a, c, u, l, d) {
            switch(n){
                case 1:
                    if (0 === l && 64 === r.charCodeAt(0)) return e(r + ";"), "";
                    break;
                case 2:
                    if (0 === u) return r + "/*|*/";
                    break;
                case 3:
                    switch(u){
                        case 102:
                        case 112:
                            return e(o[0] + r), "";
                        default:
                            return r + (0 === d ? "/*|*/" : "");
                    }
                case -2:
                    r.split("/*|*/}").forEach(t);
            }
        };
    }(function(e) {
        d.push(e);
    }), f = function(e, r, s) {
        return 0 === r && -1 !== $a778141486c79bc3$var$ie.indexOf(s[n.length]) || s.match(o) ? e : "." + t;
    };
    function m(e, s, i, a) {
        void 0 === a && (a = "&");
        var c = e.replace($a778141486c79bc3$var$se, ""), u = s && i ? i + " " + s + " { " + c + " }" : c;
        return t = a, n = s, r = new RegExp("\\" + n + "\\b", "g"), o = new RegExp("(\\" + n + "\\b){2,}"), l(i || !s ? "" : s, u);
    }
    return l.use([].concat(u, [
        function(e, t, o) {
            2 === e && o.length && o[0].lastIndexOf(n) > 0 && (o[0] = o[0].replace(r, f));
        },
        p,
        function(e) {
            if (-2 === e) {
                var t = d;
                return d = [], t;
            }
        }
    ])), m.hash = u.length ? u.reduce(function(e, t) {
        return t.name || $a778141486c79bc3$var$D(15), $a778141486c79bc3$var$ee(e, t.name);
    }, 5381).toString() : "", m;
}
var $a778141486c79bc3$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createContext(), $a778141486c79bc3$export$91317688fc694efa = $a778141486c79bc3$export$8c190ef828af4c86.Consumer, $a778141486c79bc3$var$le = (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createContext(), $a778141486c79bc3$var$de = ($a778141486c79bc3$var$le.Consumer, new $a778141486c79bc3$var$X), $a778141486c79bc3$var$he = $a778141486c79bc3$var$ae();
function $a778141486c79bc3$var$pe() {
    return (0, $tZqWC.useContext)($a778141486c79bc3$export$8c190ef828af4c86) || $a778141486c79bc3$var$de;
}
function $a778141486c79bc3$var$fe() {
    return (0, $tZqWC.useContext)($a778141486c79bc3$var$le) || $a778141486c79bc3$var$he;
}
function $a778141486c79bc3$export$a473771da2f0ff7c(e) {
    var t = (0, $tZqWC.useState)(e.stylisPlugins), n = t[0], s = t[1], c = $a778141486c79bc3$var$pe(), u = (0, $tZqWC.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target
    ]), l = (0, $tZqWC.useMemo)(function() {
        return $a778141486c79bc3$var$ae({
            options: {
                prefix: !e.disableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.disableVendorPrefixes,
        n
    ]);
    return (0, $tZqWC.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($c5a0bc5372e756ee$exports)))(n, e.stylisPlugins) || s(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($a778141486c79bc3$export$8c190ef828af4c86.Provider, {
        value: u
    }, (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($a778141486c79bc3$var$le.Provider, {
        value: l
    }, (0, e.children)));
}
var $a778141486c79bc3$var$ye = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $a778141486c79bc3$var$he);
            var r = n.name + t.hash;
            e.hasNameForId(n.id, r) || e.insertRules(n.id, r, t(n.rules, r, "@keyframes"));
        }, this.toString = function() {
            return $a778141486c79bc3$var$D(12, String(n.name));
        }, this.name = e, this.id = "sc-keyframes-" + e, this.rules = t;
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $a778141486c79bc3$var$he), this.name + e.hash;
    }, e;
}(), $a778141486c79bc3$var$ve = /([A-Z])/, $a778141486c79bc3$var$ge = /([A-Z])/g, $a778141486c79bc3$var$Se = /^ms-/, $a778141486c79bc3$var$we = function(e) {
    return "-" + e.toLowerCase();
};
function $a778141486c79bc3$var$Ee(e) {
    return $a778141486c79bc3$var$ve.test(e) ? e.replace($a778141486c79bc3$var$ge, $a778141486c79bc3$var$we).replace($a778141486c79bc3$var$Se, "-ms-") : e;
}
var $a778141486c79bc3$var$be = function(e) {
    return null == e || !1 === e || "" === e;
};
function $a778141486c79bc3$var$_e(e, n, r, o) {
    if (Array.isArray(e)) {
        for(var s, i = [], a = 0, c = e.length; a < c; a += 1)"" !== (s = $a778141486c79bc3$var$_e(e[a], n, r, o)) && (Array.isArray(s) ? i.push.apply(i, s) : i.push(s));
        return i;
    }
    if ($a778141486c79bc3$var$be(e)) return "";
    if ($a778141486c79bc3$export$7ba318d8d2f06c76(e)) return "." + e.styledComponentId;
    if ($a778141486c79bc3$var$E(e)) {
        if ("function" != typeof (l = e) || l.prototype && l.prototype.isReactComponent || !n) return e;
        var u = e(n);
        return $a778141486c79bc3$var$_e(u, n, r, o);
    }
    var l;
    return e instanceof $a778141486c79bc3$var$ye ? r ? (e.inject(r, o), e.getName(o)) : e : $a778141486c79bc3$var$g(e) ? function e(t, n) {
        var r, o, s = [];
        for(var i in t)t.hasOwnProperty(i) && !$a778141486c79bc3$var$be(t[i]) && (Array.isArray(t[i]) && t[i].isCss || $a778141486c79bc3$var$E(t[i]) ? s.push($a778141486c79bc3$var$Ee(i) + ":", t[i], ";") : $a778141486c79bc3$var$g(t[i]) ? s.push.apply(s, e(t[i], i)) : s.push($a778141486c79bc3$var$Ee(i) + ": " + (r = i, null == (o = t[i]) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || r in (0, $87b1d4e5408c6cd9$export$2e2bcd8739ae039) || r.startsWith("--") ? String(o).trim() : o + "px") + ";"));
        return n ? [
            n + " {"
        ].concat(s, [
            "}"
        ]) : s;
    }(e) : e.toString();
}
var $a778141486c79bc3$var$Ne = function(e) {
    return Array.isArray(e) && (e.isCss = !0), e;
};
function $a778141486c79bc3$export$dbf350e5966cf602(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    return $a778141486c79bc3$var$E(e) || $a778141486c79bc3$var$g(e) ? $a778141486c79bc3$var$Ne($a778141486c79bc3$var$_e($a778141486c79bc3$var$v($a778141486c79bc3$var$S, [
        e
    ].concat(n)))) : 0 === n.length && 1 === e.length && "string" == typeof e[0] ? e : $a778141486c79bc3$var$Ne($a778141486c79bc3$var$_e($a778141486c79bc3$var$v(e, n)));
}
var $a778141486c79bc3$var$Ce = /invalid hook call/i, $a778141486c79bc3$var$Ie = new Set, $a778141486c79bc3$var$Pe = function(e, t) {
    var n, r, o, e1;
}, $a778141486c79bc3$var$Oe = function(e, t, n) {
    return void 0 === n && (n = $a778141486c79bc3$var$w), e.theme !== n.theme && e.theme || t || n.theme;
}, $a778141486c79bc3$var$Re = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $a778141486c79bc3$var$De = /(^-|-$)/g;
function $a778141486c79bc3$var$je(e) {
    return e.replace($a778141486c79bc3$var$Re, "-").replace($a778141486c79bc3$var$De, "");
}
var $a778141486c79bc3$var$Te = function(e) {
    return $a778141486c79bc3$var$Q($a778141486c79bc3$var$te(e) >>> 0);
};
function $a778141486c79bc3$var$xe(e) {
    return "string" == typeof e && true;
}
var $a778141486c79bc3$var$ke = function(e) {
    return "function" == typeof e || "object" == typeof e && null !== e && !Array.isArray(e);
}, $a778141486c79bc3$var$Ve = function(e) {
    return "__proto__" !== e && "constructor" !== e && "prototype" !== e;
};
function $a778141486c79bc3$var$Be(e, t, n) {
    var r = e[n];
    $a778141486c79bc3$var$ke(t) && $a778141486c79bc3$var$ke(r) ? $a778141486c79bc3$var$ze(r, t) : e[n] = t;
}
function $a778141486c79bc3$var$ze(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    for(var o = 0, s = n; o < s.length; o++){
        var i = s[o];
        if ($a778141486c79bc3$var$ke(i)) for(var a in i)$a778141486c79bc3$var$Ve(a) && $a778141486c79bc3$var$Be(e, i[a], a);
    }
    return e;
}
var $a778141486c79bc3$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createContext(), $a778141486c79bc3$export$b631efc24e9d5e2f = $a778141486c79bc3$export$2c657da244d00bd6.Consumer;
function $a778141486c79bc3$export$d8964aec282183a3(e) {
    var t = (0, $tZqWC.useContext)($a778141486c79bc3$export$2c657da244d00bd6), n = (0, $tZqWC.useMemo)(function() {
        return function(e, t) {
            if (!e) return $a778141486c79bc3$var$D(14);
            if ($a778141486c79bc3$var$E(e)) {
                var n = e(t);
                return n;
            }
            return Array.isArray(e) || "object" != typeof e ? $a778141486c79bc3$var$D(8) : t ? $a778141486c79bc3$var$y({}, t, {}, e) : e;
        }(e.theme, t);
    }, [
        e.theme,
        t
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($a778141486c79bc3$export$2c657da244d00bd6.Provider, {
        value: n
    }, e.children) : null;
}
var $a778141486c79bc3$var$Fe = {};
function $a778141486c79bc3$var$Ye(e, t, n) {
    var o = $a778141486c79bc3$export$7ba318d8d2f06c76(e), i = !$a778141486c79bc3$var$xe(e), a = t.attrs, c = void 0 === a ? $a778141486c79bc3$var$S : a, l = t.componentId, d = void 0 === l ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $a778141486c79bc3$var$je(e);
        $a778141486c79bc3$var$Fe[n] = ($a778141486c79bc3$var$Fe[n] || 0) + 1;
        var r = n + "-" + $a778141486c79bc3$var$Te("5.3.11" + n + $a778141486c79bc3$var$Fe[n]);
        return t ? t + "-" + r : r;
    }(t.displayName, t.parentComponentId) : l, h = t.displayName, p = void 0 === h ? function(e) {
        return $a778141486c79bc3$var$xe(e) ? "styled." + e : "Styled(" + $a778141486c79bc3$var$b(e) + ")";
    }(e) : h, v = t.displayName && t.componentId ? $a778141486c79bc3$var$je(t.displayName) + "-" + t.componentId : t.componentId || d, g = o && e.attrs ? Array.prototype.concat(e.attrs, c).filter(Boolean) : c, N = t.shouldForwardProp;
    o && e.shouldForwardProp && (N = t.shouldForwardProp ? function(n, r, o) {
        return e.shouldForwardProp(n, r, o) && t.shouldForwardProp(n, r, o);
    } : e.shouldForwardProp);
    var A, C = new $a778141486c79bc3$var$oe(n, v, o ? e.componentStyle : void 0), I = C.isStatic && 0 === c.length, P = function(e, t) {
        return function(e, t, n, r) {
            var o = e.attrs, i = e.componentStyle, a = e.defaultProps, c = e.foldedComponentIds, l = e.shouldForwardProp, d = e.styledComponentId, h = e.target, p = function(e, t, n) {
                void 0 === e && (e = $a778141486c79bc3$var$w);
                var r = $a778141486c79bc3$var$y({}, t, {
                    theme: e
                }), o = {};
                return n.forEach(function(e) {
                    var t, n, s, i = e;
                    for(t in $a778141486c79bc3$var$E(i) && (i = i(r)), i)r[t] = o[t] = "className" === t ? (n = o[t], s = i[t], n && s ? n + " " + s : n || s) : i[t];
                }), [
                    r,
                    o
                ];
            }($a778141486c79bc3$var$Oe(t, (0, $tZqWC.useContext)($a778141486c79bc3$export$2c657da244d00bd6), a) || $a778141486c79bc3$var$w, t, o), m = p[0], v = p[1], g = function(e, t, n, r) {
                var o = $a778141486c79bc3$var$pe(), s = $a778141486c79bc3$var$fe(), i = t ? e.generateAndInjectStyles($a778141486c79bc3$var$w, o, s) : e.generateAndInjectStyles(n, o, s);
                return i;
            }(i, r, m, void 0), S = n, b = v.$as || t.$as || v.as || t.as || h, _ = $a778141486c79bc3$var$xe(b), N = v !== t ? $a778141486c79bc3$var$y({}, t, {}, v) : t, A = {};
            for(var C in N)"$" !== C[0] && "as" !== C && ("forwardedAs" === C ? A.as = N[C] : (l ? l(C, (0, $b8af5ec90e8faa44$export$2e2bcd8739ae039), b) : !_ || (0, $b8af5ec90e8faa44$export$2e2bcd8739ae039)(C)) && (A[C] = N[C]));
            return t.style && v.style !== t.style && (A.style = $a778141486c79bc3$var$y({}, t.style, {}, v.style)), A.className = Array.prototype.concat(c, d, g !== d ? g : null, t.className, v.className).filter(Boolean).join(" "), A.ref = S, (0, $tZqWC.createElement)(b, A);
        }(A, e, t, I);
    };
    return P.displayName = p, (A = (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).forwardRef(P)).attrs = g, A.componentStyle = C, A.displayName = p, A.shouldForwardProp = N, A.foldedComponentIds = o ? Array.prototype.concat(e.foldedComponentIds, e.styledComponentId) : $a778141486c79bc3$var$S, A.styledComponentId = v, A.target = o ? e.target : e, A.withComponent = function(e) {
        var r = t.componentId, o = function(e, t) {
            if (null == e) return {};
            var n, r, o = {}, s = Object.keys(e);
            for(r = 0; r < s.length; r++)n = s[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
            return o;
        }(t, [
            "componentId"
        ]), s = r && r + "-" + ($a778141486c79bc3$var$xe(e) ? e : $a778141486c79bc3$var$je($a778141486c79bc3$var$b(e)));
        return $a778141486c79bc3$var$Ye(e, $a778141486c79bc3$var$y({}, o, {
            attrs: g,
            componentId: s
        }), n);
    }, Object.defineProperty(A, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(t) {
            this._foldedDefaultProps = o ? $a778141486c79bc3$var$ze({}, e.defaultProps, t) : t;
        }
    }), Object.defineProperty(A, "toString", {
        value: function() {
            return "." + A.styledComponentId;
        }
    }), i && (0, (/*@__PURE__*/$parcel$interopDefault($7g5pF)))(A, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0,
        withComponent: !0
    }), A;
}
var $a778141486c79bc3$var$qe = function(e) {
    return function e(t, r, o) {
        if (void 0 === o && (o = $a778141486c79bc3$var$w), !(0, $5M4sD.isValidElementType)(r)) return $a778141486c79bc3$var$D(1, String(r));
        var s = function() {
            return t(r, o, $a778141486c79bc3$export$dbf350e5966cf602.apply(void 0, arguments));
        };
        return s.withConfig = function(n) {
            return e(t, r, $a778141486c79bc3$var$y({}, o, {}, n));
        }, s.attrs = function(n) {
            return e(t, r, $a778141486c79bc3$var$y({}, o, {
                attrs: Array.prototype.concat(o.attrs, n).filter(Boolean)
            }));
        }, s;
    }($a778141486c79bc3$var$Ye, e);
};
[
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "textPath",
    "tspan"
].forEach(function(e) {
    $a778141486c79bc3$var$qe[e] = $a778141486c79bc3$var$qe(e);
});
var $a778141486c79bc3$var$He = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $a778141486c79bc3$var$ne(e), $a778141486c79bc3$var$X.registerId(this.componentId + 1);
    }
    var t = e.prototype;
    return t.createStyles = function(e, t, n, r) {
        var o = r($a778141486c79bc3$var$_e(this.rules, t, n, r).join(""), ""), s = this.componentId + e;
        n.insertRules(s, s, o);
    }, t.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, t.renderStyles = function(e, t, n, r) {
        e > 2 && $a778141486c79bc3$var$X.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, r);
    }, e;
}();
function $a778141486c79bc3$export$f0f03736edb61697(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)n[o - 1] = arguments[o];
    var i = $a778141486c79bc3$export$dbf350e5966cf602.apply(void 0, [
        e
    ].concat(n)), a = "sc-global-" + $a778141486c79bc3$var$Te(JSON.stringify(i)), u = new $a778141486c79bc3$var$He(i, a);
    function d(e) {
        var t = $a778141486c79bc3$var$pe(), n = $a778141486c79bc3$var$fe(), o = (0, $tZqWC.useContext)($a778141486c79bc3$export$2c657da244d00bd6), d = (0, $tZqWC.useRef)(t.allocateGSInstance(a)).current;
        return t.server && h(d, e, t, o, n), (0, $tZqWC.useLayoutEffect)(function() {
            if (!t.server) return h(d, e, t, o, n), function() {
                return u.removeStyles(d, t);
            };
        }, [
            d,
            e,
            t,
            o,
            n
        ]), null;
    }
    function h(e, t, n, r, o) {
        if (u.isStatic) u.renderStyles(e, $a778141486c79bc3$var$P, n, o);
        else {
            var s = $a778141486c79bc3$var$y({}, t, {
                theme: $a778141486c79bc3$var$Oe(t, r, d.defaultProps)
            });
            u.renderStyles(e, s, n, o);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).memo(d);
}
function $a778141486c79bc3$export$d25ddfdf17c3ad3e(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    var o = $a778141486c79bc3$export$dbf350e5966cf602.apply(void 0, [
        e
    ].concat(n)).join(""), s = $a778141486c79bc3$var$Te(o);
    return new $a778141486c79bc3$var$ye(s, o);
}
var $a778141486c79bc3$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString();
            if (!t) return "";
            var n = $a778141486c79bc3$var$Y();
            return "<style " + [
                n && 'nonce="' + n + '"',
                $a778141486c79bc3$var$N + '="true"',
                'data-styled-version="5.3.11"'
            ].filter(Boolean).join(" ") + ">" + t + "</style>";
        }, this.getStyleTags = function() {
            return e.sealed ? $a778141486c79bc3$var$D(2) : e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var t;
            if (e.sealed) return $a778141486c79bc3$var$D(2);
            var n = ((t = {})[$a778141486c79bc3$var$N] = "", t["data-styled-version"] = "5.3.11", t.dangerouslySetInnerHTML = {
                __html: e.instance.toString()
            }, t), o = $a778141486c79bc3$var$Y();
            return o && (n.nonce = o), [
                (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement("style", $a778141486c79bc3$var$y({}, n, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new $a778141486c79bc3$var$X({
            isServer: !0
        }), this.sealed = !1;
    }
    var t = e.prototype;
    return t.collectStyles = function(e) {
        return this.sealed ? $a778141486c79bc3$var$D(2) : (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($a778141486c79bc3$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, t.interleaveWithNodeStream = function(e) {
        return $a778141486c79bc3$var$D(3);
    }, e;
}(), $a778141486c79bc3$export$e8748c6a27b910dc = function(e) {
    var t = (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).forwardRef(function(t, n) {
        var o = (0, $tZqWC.useContext)($a778141486c79bc3$export$2c657da244d00bd6), i = e.defaultProps, a = $a778141486c79bc3$var$Oe(t, o, i);
        return (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(e, $a778141486c79bc3$var$y({}, t, {
            theme: a,
            ref: n
        }));
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($7g5pF)))(t, e), t.displayName = "WithTheme(" + $a778141486c79bc3$var$b(e) + ")", t;
}, $a778141486c79bc3$export$93d4e7f90805808f = function() {
    return (0, $tZqWC.useContext)($a778141486c79bc3$export$2c657da244d00bd6);
}, $a778141486c79bc3$export$5c87cfe6c475f500 = {
    StyleSheet: $a778141486c79bc3$var$X,
    masterSheet: $a778141486c79bc3$var$de
};
var $a778141486c79bc3$export$2e2bcd8739ae039 = $a778141486c79bc3$var$qe;


var $c9613c5a00d57ada$exports = {};

$parcel$export($c9613c5a00d57ada$exports, "colors", () => $c9613c5a00d57ada$export$8f45430ccf837300);
$parcel$export($c9613c5a00d57ada$exports, "fonts", () => $c9613c5a00d57ada$export$f45fbea8fe20ca8a);
$parcel$export($c9613c5a00d57ada$exports, "functions", () => $c9613c5a00d57ada$export$18af1f934c132a41);
$parcel$export($c9613c5a00d57ada$exports, "layout", () => $c9613c5a00d57ada$export$b3219800bda33a1f);
const $06b9a6a3a837f924$var$mobileFirst = true;
// List of Breakpoints
const $06b9a6a3a837f924$var$breakpoints = {
    verySmall: '320px',
    mobileSmall: '430px',
    mobileMedium: '500px',
    mobile: '600px',
    tabletPortraitUp: '768px',
    tabletLandscapeUp: '920px',
    laptop: '1024px',
    laptopMedium: '1200px',
    laptopLarge: '1320px',
    bigDesktop: '1600px',
    bigDesktopUp: '1800px',
    wideScreen: '4000px'
};
/**
 * Returns media query rule per property breakpoint
 *
 * @param  {} width Max width of media query rule
 * @param  {} content Property : values; for an element
 */ const $06b9a6a3a837f924$var$mediaQuery = (width, content)=>{
    const breakpointWidth = width;
    return `@media screen and (max-width: ${breakpointWidth}) {
    ${content}
  }`;
};
/**
 * Fills property values for unassigned breakpoint
 *
 * @param  {} values Assigned values per property breakpoint
 */ const $06b9a6a3a837f924$var$fillValues = (values)=>{
    const argsMissingValueLength = Object.keys($06b9a6a3a837f924$var$breakpoints).length - values.length;
    const lastArgsValue = values[values.length - 1];
    const updatedValues = values;
    for(let index = 0; index < argsMissingValueLength; index++)updatedValues.push(lastArgsValue);
    return updatedValues;
};
/**
 * Generates media query breakpoint rules for a property
 *
 * @param  {} property Css property
 * @param  {} values Set of values for a property per breakpoint
 */ const $06b9a6a3a837f924$var$generateMediaQuery = (property, values)=>{
    const breakpointWidths = Object.values($06b9a6a3a837f924$var$breakpoints);
    const breakpointLength = breakpointWidths.length;
    const propertyValues = $06b9a6a3a837f924$var$fillValues(values);
    let generatedMediaQueryRule = '';
    if ($06b9a6a3a837f924$var$mobileFirst) {
        // Generates media query breakpoint rules for mobile first approach
        let count = breakpointLength - 1;
        while(count >= 0){
            generatedMediaQueryRule += $06b9a6a3a837f924$var$mediaQuery(breakpointWidths[count], `${property}: ${propertyValues[count]};`);
            count--;
        }
    } else {
        // Generates media query breakpoint rules for desktop first approach
        let count = 0;
        while(count < breakpointLength){
            generatedMediaQueryRule += $06b9a6a3a837f924$var$mediaQuery(breakpointWidths[breakpointLength - count - 1], `${property}: ${propertyValues[count]};`);
            count++;
        }
    }
    return generatedMediaQueryRule;
};
var $06b9a6a3a837f924$export$2e2bcd8739ae039 = $06b9a6a3a837f924$var$generateMediaQuery;


var $b0f150cd91be6a72$exports = {};

$parcel$export($b0f150cd91be6a72$exports, "onEvent", () => $b0f150cd91be6a72$export$4d067148c1e8c84d);
$parcel$export($b0f150cd91be6a72$exports, "transition", () => $b0f150cd91be6a72$export$66bb15e2994e6a26);
$parcel$export($b0f150cd91be6a72$exports, "transform", () => $b0f150cd91be6a72$export$51186ad6e864892a);
$parcel$export($b0f150cd91be6a72$exports, "animation", () => $b0f150cd91be6a72$export$ecad260a8a5fef4f);
$parcel$export($b0f150cd91be6a72$exports, "boxShadow", () => $b0f150cd91be6a72$export$16e1fc8de5cd9687);
$parcel$export($b0f150cd91be6a72$exports, "textShadow", () => $b0f150cd91be6a72$export$2c6941d40bcfb11a);
const $b0f150cd91be6a72$export$4d067148c1e8c84d = (content)=>`
    &:active,
    &:focus,
    &:hover {
     ${content}
    }`;
const $b0f150cd91be6a72$export$66bb15e2994e6a26 = (value)=>`
    -webkit-transition: ${value};
    -moz-transition: ${value};
    -ms-transition: ${value};
    -o-transform: ${value};
    transition: ${value};`;
const $b0f150cd91be6a72$export$51186ad6e864892a = (value)=>`
    -webkit-transform: ${value};
    -moz-transform: ${value};
    -ms-transform: ${value};
    -o-transform: ${value};
    transform: ${value};`;
const $b0f150cd91be6a72$export$ecad260a8a5fef4f = (value)=>`
    -webkit-animation: ${value};
    -moz-animation: ${value};
    -ms-animation: ${value};
    -o-transform: ${value};
    animation: ${value};`;
const $b0f150cd91be6a72$export$16e1fc8de5cd9687 = (value)=>`
    -webkit-box-shadow: ${value};
    -moz-box-shadow: ${value};
    -ms-box-shadow: ${value};
    -o-box-shadow: ${value};
    box-shadow: ${value};`;
const $b0f150cd91be6a72$export$2c6941d40bcfb11a = (value)=>`
    -webkit-text-shadow: ${value};
    -moz-text-shadow: ${value};
    -ms-text-shadow: ${value};
    -o-text-shadow: ${value};
    text-shadow: ${value};`;


const $c9613c5a00d57ada$export$8f45430ccf837300 = {
    white: '#ffffff',
    black: '#000000',
    lightBlack: '#282828',
    darkGray: '#31353e',
    lightBlue: '#e6fafa',
    darkBlue: '#405264',
    brightBlue: '#2e4ad4',
    blueGray: '#727F97',
    navyBlue: '#0b037a',
    royalBlue: '#4436eb',
    aliceBlue: '#f3f5f7',
    paleNavy: '#eef9fe',
    orange: '#ffa800',
    red: '#F45C65',
    brightRed: '#fd4a71',
    mediumPurple: '#7068df',
    lightPurple: '#b7b3ee',
    lightYellow: '#f8ffdd',
    yellowGreen: '#CAFF0A',
    green: '#89CF82',
    brand: '#00CACD',
    primary: '#e9e9e9',
    secondary: '#8E8E8C',
    background: '#202121',
    backgroundLite: '#1a1a1a',
    borderColor: '#ece6e71a',
    // darkGray: '#e9e9e9',
    // gray: '#727F97',
    // white: '#3c4351',
    // lightGray: '#393D46',
    // ash: '#474f5f',
    warning: '#fd4a71',
    success: '#3cb371',
    info: '#0275d8'
};
const $c9613c5a00d57ada$export$f45fbea8fe20ca8a = {
    code: "'Courier New', 'DejaVu Sans Mono', 'Bitstream Vera Sans Mono', 'Monaco', monospace !default",
    text: "'Open Sans', 'Helvetica Neue Light', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif !default"
};
const $c9613c5a00d57ada$export$18af1f934c132a41 = {
    mediaQuery: $06b9a6a3a837f924$export$2e2bcd8739ae039,
    mixins: $b0f150cd91be6a72$exports
};
const $c9613c5a00d57ada$export$b3219800bda33a1f = {
    sidebar: false
};


var $ecad517a7fda3a3e$export$2e2bcd8739ae039 = $c9613c5a00d57ada$exports;


var $30e2084c8ceb2f43$exports = {};

$parcel$export($30e2084c8ceb2f43$exports, "colors", () => $30e2084c8ceb2f43$export$8f45430ccf837300);
$parcel$export($30e2084c8ceb2f43$exports, "fonts", () => $30e2084c8ceb2f43$export$f45fbea8fe20ca8a);
$parcel$export($30e2084c8ceb2f43$exports, "functions", () => $30e2084c8ceb2f43$export$18af1f934c132a41);
$parcel$export($30e2084c8ceb2f43$exports, "layout", () => $30e2084c8ceb2f43$export$b3219800bda33a1f);


const $30e2084c8ceb2f43$export$8f45430ccf837300 = {
    white: '#ffffff',
    black: '#000000',
    lightBlack: '#282828',
    darkGray: '#31353e',
    lightBlue: '#e6fafa',
    darkBlue: '#405264',
    brightBlue: '#2e4ad4',
    blueGray: '#727F97',
    navyBlue: '#0b037a',
    royalBlue: '#4436eb',
    aliceBlue: '#f3f5f7',
    paleNavy: '#eef9fe',
    orange: '#ffa800',
    red: '#F45C65',
    brightRed: '#fd4a71',
    mediumPurple: '#7068df',
    lightPurple: '#b7b3ee',
    lightYellow: '#f8ffdd',
    yellowGreen: '#CAFF0A',
    green: '#89CF82',
    brand: '#00a3a6ff',
    primary: '#3a3a3aff',
    secondary: '#576c70',
    background: '#fcfcf9',
    backgroundLite: '#f3f3ed',
    borderColor: '#dde1df',
    // darkGray: '#e9e9e9',
    // gray: '#727F97',
    // white: '#3c4351',
    // lightGray: '#393D46',
    // ash: '#474f5f',
    warning: '#fd4a71',
    success: '#3cb371',
    info: '#0275d8'
};
const $30e2084c8ceb2f43$export$f45fbea8fe20ca8a = {
    code: "'Courier New', 'DejaVu Sans Mono', 'Bitstream Vera Sans Mono', 'Monaco', monospace !default",
    text: "'Open Sans', 'Helvetica Neue Light', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif !default"
};
const $30e2084c8ceb2f43$export$18af1f934c132a41 = {
    mediaQuery: $06b9a6a3a837f924$export$2e2bcd8739ae039,
    mixins: $b0f150cd91be6a72$exports
};
const $30e2084c8ceb2f43$export$b3219800bda33a1f = {
    sidebar: false
};


var $699e4332635b25bd$export$2e2bcd8739ae039 = $30e2084c8ceb2f43$exports;



var $0903e567898849b2$exports = {};

$parcel$export($0903e567898849b2$exports, "colors", () => $0903e567898849b2$export$8f45430ccf837300);
$parcel$export($0903e567898849b2$exports, "fonts", () => $0903e567898849b2$export$f45fbea8fe20ca8a);
$parcel$export($0903e567898849b2$exports, "functions", () => $0903e567898849b2$export$18af1f934c132a41);
$parcel$export($0903e567898849b2$exports, "layout", () => $0903e567898849b2$export$b3219800bda33a1f);


const $0903e567898849b2$export$8f45430ccf837300 = {
    white: '#ffffff',
    black: '#000000',
    lightBlack: '#282828',
    darkGray: '#31353e',
    lightBlue: '#e6fafa',
    darkBlue: '#405264',
    brightBlue: '#2e4ad4',
    blueGray: '#727F97',
    navyBlue: '#0b037a',
    royalBlue: '#4436eb',
    aliceBlue: '#f3f5f7',
    paleNavy: '#eef9fe',
    orange: '#ffa800',
    red: '#F45C65',
    brightRed: '#fd4a71',
    mediumPurple: '#7068df',
    lightPurple: '#b7b3ee',
    lightYellow: '#f8ffdd',
    yellowGreen: '#CAFF0A',
    green: '#89CF82',
    brand: '#00CACD',
    primary: '#e9e9e9',
    secondary: '#909bb5ff',
    background: '#3c4351',
    backgroundLite: '#393D46',
    borderColor: '#515a6bff',
    warning: '#fd4a71',
    success: '#3cb371',
    info: '#0275d8'
};
const $0903e567898849b2$export$f45fbea8fe20ca8a = {
    code: "'Courier New', 'DejaVu Sans Mono', 'Bitstream Vera Sans Mono', 'Monaco', monospace !default",
    text: "'Open Sans', 'Helvetica Neue Light', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif !default"
};
const $0903e567898849b2$export$18af1f934c132a41 = {
    mediaQuery: $06b9a6a3a837f924$export$2e2bcd8739ae039,
    mixins: $b0f150cd91be6a72$exports
};
const $0903e567898849b2$export$b3219800bda33a1f = {
    sidebar: false
};


var $03ce01cd50e0607a$export$2e2bcd8739ae039 = $0903e567898849b2$exports;


const $930c68f0cade991f$export$ce0e5beb5efeb79 = {
    light: (0, $699e4332635b25bd$export$2e2bcd8739ae039),
    dark: (0, $ecad517a7fda3a3e$export$2e2bcd8739ae039),
    gray: (0, $03ce01cd50e0607a$export$2e2bcd8739ae039)
};



var $tZqWC = parcelRequire("tZqWC");
const $a9c50ebe96619b20$var$getValue = (key, initialValue)=>{
    const value = JSON.parse(localStorage.getItem(key));
    if (value) return value;
    if (initialValue instanceof Function) return initialValue();
    if (initialValue !== undefined) return initialValue;
};
const $a9c50ebe96619b20$var$useLocalStorage = (key, initialValue)=>{
    const [localStorageValue, setLocalStorageValue] = (0, $tZqWC.useState)(()=>$a9c50ebe96619b20$var$getValue(key, initialValue));
    (0, $tZqWC.useEffect)(()=>{
        if (localStorageValue !== undefined) localStorage.setItem(key, JSON.stringify(localStorageValue));
    }, [
        localStorageValue
    ]);
    return [
        localStorageValue,
        setLocalStorageValue
    ];
};
var $a9c50ebe96619b20$export$2e2bcd8739ae039 = $a9c50ebe96619b20$var$useLocalStorage;




function $114cb5fd5cac8cce$var$AppThemeProvider(props) {
    // Destructure
    const { children: children } = props;
    const [theme] = (0, $a9c50ebe96619b20$export$2e2bcd8739ae039)('theme', 'dark');
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a778141486c79bc3$export$d8964aec282183a3), {
        theme: (0, $930c68f0cade991f$export$ce0e5beb5efeb79)?.[theme] ? (0, $930c68f0cade991f$export$ce0e5beb5efeb79)?.[theme] : (0, $ecad517a7fda3a3e$export$2e2bcd8739ae039),
        children: children
    });
}
var $114cb5fd5cac8cce$export$2e2bcd8739ae039 = $114cb5fd5cac8cce$var$AppThemeProvider;
// Proptypes Validation
$114cb5fd5cac8cce$var$AppThemeProvider.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ]).isRequired
};


/* eslint-disable wrap-iife */ /* eslint-disable prefer-rest-params */ /* eslint-disable no-extra-semi */ /* eslint-disable func-names */ /* eslint-disable no-underscore-dangle */ /* eslint-disable prefer-destructuring */ 

var $tZqWC = parcelRequire("tZqWC");


var $tZqWC = parcelRequire("tZqWC");


function $d8d4e3a3233599a5$var$isAbsolute(pathname) {
    return pathname.charAt(0) === '/';
}
// About 1.5x faster than the two-arg version of Array#splice()
function $d8d4e3a3233599a5$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function $d8d4e3a3233599a5$var$resolvePathname(to, from) {
    if (from === undefined) from = '';
    var toParts = to && to.split('/') || [];
    var fromParts = from && from.split('/') || [];
    var isToAbs = to && $d8d4e3a3233599a5$var$isAbsolute(to);
    var isFromAbs = from && $d8d4e3a3233599a5$var$isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && $d8d4e3a3233599a5$var$isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return '/';
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === '.' || last === '..' || last === '';
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === '.') $d8d4e3a3233599a5$var$spliceOne(fromParts, i);
        else if (part === '..') {
            $d8d4e3a3233599a5$var$spliceOne(fromParts, i);
            up++;
        } else if (up) {
            $d8d4e3a3233599a5$var$spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift('..');
    if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !$d8d4e3a3233599a5$var$isAbsolute(fromParts[0]))) fromParts.unshift('');
    var result = fromParts.join('/');
    if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
    return result;
}
var $d8d4e3a3233599a5$export$2e2bcd8739ae039 = $d8d4e3a3233599a5$var$resolvePathname;


function $64e65a4a41a6b92b$var$valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function $64e65a4a41a6b92b$var$valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $64e65a4a41a6b92b$var$valueEqual(item, b[index]);
    });
    if (typeof a === 'object' || typeof b === 'object') {
        var aValue = $64e65a4a41a6b92b$var$valueOf(a);
        var bValue = $64e65a4a41a6b92b$var$valueOf(b);
        if (aValue !== a || bValue !== b) return $64e65a4a41a6b92b$var$valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return $64e65a4a41a6b92b$var$valueEqual(a[key], b[key]);
        });
    }
    return false;
}
var $64e65a4a41a6b92b$export$2e2bcd8739ae039 = $64e65a4a41a6b92b$var$valueEqual;



var $8097209926f5b57c$var$isProduction = true;
var $8097209926f5b57c$var$prefix = 'Invariant failed';
function $8097209926f5b57c$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($8097209926f5b57c$var$isProduction) throw new Error($8097209926f5b57c$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($8097209926f5b57c$var$prefix, ": ").concat(provided) : $8097209926f5b57c$var$prefix;
    throw new Error(value);
}


function $de6afe589b6eae99$var$addLeadingSlash(path) {
    return path.charAt(0) === '/' ? path : '/' + path;
}
function $de6afe589b6eae99$var$stripLeadingSlash(path) {
    return path.charAt(0) === '/' ? path.substr(1) : path;
}
function $de6afe589b6eae99$var$hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function $de6afe589b6eae99$var$stripBasename(path, prefix) {
    return $de6afe589b6eae99$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function $de6afe589b6eae99$var$stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function $de6afe589b6eae99$export$8ccf933b0513f8d0(path) {
    var pathname = path || '/';
    var search = '';
    var hash = '';
    var hashIndex = pathname.indexOf('#');
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf('?');
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === '?' ? '' : search,
        hash: hash === '#' ? '' : hash
    };
}
function $de6afe589b6eae99$export$fe53371bee54353d(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || '/';
    if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
    if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
    return path;
}
function $de6afe589b6eae99$export$90c043f1c57770b8(path, state, key, currentLocation) {
    var location;
    if (typeof path === 'string') {
        // Two-arg form: push(path, state)
        location = $de6afe589b6eae99$export$8ccf933b0513f8d0(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, $dda4d40cf5733033$export$2e2bcd8739ae039)({}, path);
        if (location.pathname === undefined) location.pathname = '';
        if (location.search) {
            if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
        } else location.search = '';
        if (location.hash) {
            if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
        } else location.hash = '';
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== '/') location.pathname = (0, $d8d4e3a3233599a5$export$2e2bcd8739ae039)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = '/';
    return location;
}
function $de6afe589b6eae99$export$c3e8bb440bd55b18(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $64e65a4a41a6b92b$export$2e2bcd8739ae039)(a.state, b.state);
}
function $de6afe589b6eae99$var$createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
            if (typeof result === 'string') {
                if (typeof getUserConfirmation === 'function') getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var $de6afe589b6eae99$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $de6afe589b6eae99$var$getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function $de6afe589b6eae99$var$supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
    return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function $de6afe589b6eae99$var$supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function $de6afe589b6eae99$var$supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function $de6afe589b6eae99$var$isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}
var $de6afe589b6eae99$var$PopStateEvent = 'popstate';
var $de6afe589b6eae99$var$HashChangeEvent = 'hashchange';
function $de6afe589b6eae99$var$getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function $de6afe589b6eae99$export$719fc203c4e16dee(props) {
    if (props === void 0) props = {};
    !$de6afe589b6eae99$var$canUseDOM && (0, $8097209926f5b57c$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canUseHistory = $de6afe589b6eae99$var$supportsHistory();
    var needsHashChangeListener = !$de6afe589b6eae99$var$supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $de6afe589b6eae99$var$getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? $de6afe589b6eae99$var$stripTrailingSlash($de6afe589b6eae99$var$addLeadingSlash(props.basename)) : '';
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = $de6afe589b6eae99$var$stripBasename(path, basename);
        return $de6afe589b6eae99$export$90c043f1c57770b8(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = $de6afe589b6eae99$var$createTransitionManager();
    function setState(nextState) {
        (0, $dda4d40cf5733033$export$2e2bcd8739ae039)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ($de6afe589b6eae99$var$isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation($de6afe589b6eae99$var$getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation($de6afe589b6eae99$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + $de6afe589b6eae99$export$fe53371bee54353d(location);
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $de6afe589b6eae99$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $de6afe589b6eae99$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener($de6afe589b6eae99$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener($de6afe589b6eae99$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener($de6afe589b6eae99$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener($de6afe589b6eae99$var$HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var $de6afe589b6eae99$var$HashChangeEvent$1 = 'hashchange';
var $de6afe589b6eae99$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === '!' ? path : '!/' + $de6afe589b6eae99$var$stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === '!' ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: $de6afe589b6eae99$var$stripLeadingSlash,
        decodePath: $de6afe589b6eae99$var$addLeadingSlash
    },
    slash: {
        encodePath: $de6afe589b6eae99$var$addLeadingSlash,
        decodePath: $de6afe589b6eae99$var$addLeadingSlash
    }
};
function $de6afe589b6eae99$var$stripHash(url) {
    var hashIndex = url.indexOf('#');
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function $de6afe589b6eae99$var$getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf('#');
    return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}
function $de6afe589b6eae99$var$pushHashPath(path) {
    window.location.hash = path;
}
function $de6afe589b6eae99$var$replaceHashPath(path) {
    window.location.replace($de6afe589b6eae99$var$stripHash(window.location.href) + '#' + path);
}
function $de6afe589b6eae99$export$b71fdd3798280242(props) {
    if (props === void 0) props = {};
    !$de6afe589b6eae99$var$canUseDOM && (0, $8097209926f5b57c$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = $de6afe589b6eae99$var$supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $de6afe589b6eae99$var$getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
    var basename = props.basename ? $de6afe589b6eae99$var$stripTrailingSlash($de6afe589b6eae99$var$addLeadingSlash(props.basename)) : '';
    var _HashPathCoders$hashT = $de6afe589b6eae99$var$HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath($de6afe589b6eae99$var$getHashPath());
        if (basename) path = $de6afe589b6eae99$var$stripBasename(path, basename);
        return $de6afe589b6eae99$export$90c043f1c57770b8(path);
    }
    var transitionManager = $de6afe589b6eae99$var$createTransitionManager();
    function setState(nextState) {
        (0, $dda4d40cf5733033$export$2e2bcd8739ae039)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = $de6afe589b6eae99$var$getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        $de6afe589b6eae99$var$replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === $de6afe589b6eae99$export$fe53371bee54353d(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf($de6afe589b6eae99$export$fe53371bee54353d(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf($de6afe589b6eae99$export$fe53371bee54353d(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = $de6afe589b6eae99$var$getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) $de6afe589b6eae99$var$replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        $de6afe589b6eae99$export$fe53371bee54353d(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector('base');
        var href = '';
        if (baseTag && baseTag.getAttribute('href')) href = $de6afe589b6eae99$var$stripHash(window.location.href);
        return href + '#' + encodePath(basename + $de6afe589b6eae99$export$fe53371bee54353d(location));
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $de6afe589b6eae99$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $de6afe589b6eae99$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $de6afe589b6eae99$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $de6afe589b6eae99$var$pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf($de6afe589b6eae99$export$fe53371bee54353d(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $de6afe589b6eae99$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $de6afe589b6eae99$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $de6afe589b6eae99$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $de6afe589b6eae99$var$replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf($de6afe589b6eae99$export$fe53371bee54353d(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener($de6afe589b6eae99$var$HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener($de6afe589b6eae99$var$HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function $de6afe589b6eae99$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function $de6afe589b6eae99$export$2b76ad033c6e6d08(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        '/'
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = $de6afe589b6eae99$var$createTransitionManager();
    function setState(nextState) {
        (0, $dda4d40cf5733033$export$2e2bcd8739ae039)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = $de6afe589b6eae99$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === 'string' ? $de6afe589b6eae99$export$90c043f1c57770b8(entry, undefined, createKey()) : $de6afe589b6eae99$export$90c043f1c57770b8(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = $de6afe589b6eae99$export$fe53371bee54353d;
    function push(path, state) {
        var action = 'PUSH';
        var location = $de6afe589b6eae99$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $de6afe589b6eae99$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = $de6afe589b6eae99$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = 'POP';
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: 'POP',
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}




var $tZqWC = parcelRequire("tZqWC");


var $4L3zM = parcelRequire("4L3zM");

var $5655354bf4d09baf$var$MAX_SIGNED_31_BIT_INT = 1073741823;
var $5655354bf4d09baf$var$commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : {};
function $5655354bf4d09baf$var$getUniqueId() {
    var key = '__global_unique_id__';
    return $5655354bf4d09baf$var$commonjsGlobal[key] = ($5655354bf4d09baf$var$commonjsGlobal[key] || 0) + 1;
}
function $5655354bf4d09baf$var$objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $5655354bf4d09baf$var$createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function $5655354bf4d09baf$var$onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function $5655354bf4d09baf$var$createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = '__create-react-context-' + $5655354bf4d09baf$var$getUniqueId() + '__';
    var Provider = /*#__PURE__*/ function(_Component) {
        (0, $0ec1659a3a380451$export$2e2bcd8739ae039)(Provider, _Component);
        function Provider() {
            var _this;
            _this = _Component.apply(this, arguments) || this;
            _this.emitter = $5655354bf4d09baf$var$createEventEmitter(_this.props.value);
            return _this;
        }
        var _proto = Provider.prototype;
        _proto.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits;
                if ($5655354bf4d09baf$var$objectIs(oldValue, newValue)) changedBits = 0;
                else {
                    changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : $5655354bf4d09baf$var$MAX_SIGNED_31_BIT_INT;
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        _proto.render = function render() {
            return this.props.children;
        };
        return Provider;
    }((0, $tZqWC.Component));
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object.isRequired, _Provider$childContex);
    var Consumer = /*#__PURE__*/ function(_Component2) {
        (0, $0ec1659a3a380451$export$2e2bcd8739ae039)(Consumer, _Component2);
        function Consumer() {
            var _this2;
            _this2 = _Component2.apply(this, arguments) || this;
            _this2.state = {
                value: _this2.getValue()
            };
            _this2.onUpdate = function(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            };
            return _this2;
        }
        var _proto2 = Consumer.prototype;
        _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $5655354bf4d09baf$var$MAX_SIGNED_31_BIT_INT : observedBits;
        };
        _proto2.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $5655354bf4d09baf$var$MAX_SIGNED_31_BIT_INT : observedBits;
        };
        _proto2.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        _proto2.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        _proto2.render = function render() {
            return $5655354bf4d09baf$var$onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }((0, $tZqWC.Component));
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
var $5655354bf4d09baf$var$index = (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createContext || $5655354bf4d09baf$var$createReactContext;
var $5655354bf4d09baf$export$2e2bcd8739ae039 = $5655354bf4d09baf$var$index;




var $869213495fe808a0$exports = {};
var $e0a2cde2d71b7e87$exports = {};
$e0a2cde2d71b7e87$exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == '[object Array]';
};


/**
 * Expose `pathToRegexp`.
 */ $869213495fe808a0$exports = $869213495fe808a0$var$pathToRegexp;
$869213495fe808a0$exports.parse = $869213495fe808a0$var$parse;
$869213495fe808a0$exports.compile = $869213495fe808a0$var$compile;
$869213495fe808a0$exports.tokensToFunction = $869213495fe808a0$var$tokensToFunction;
$869213495fe808a0$exports.tokensToRegExp = $869213495fe808a0$var$tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $869213495fe808a0$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    '(\\\\.)',
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $869213495fe808a0$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = '';
    var defaultDelimiter = options && options.delimiter || '/';
    var res;
    while((res = $869213495fe808a0$var$PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = '';
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === '+' || modifier === '*';
        var optional = modifier === '?' || modifier === '*';
        var delimiter = prefix || defaultDelimiter;
        var pattern = capture || group;
        var prevText = prefix || (typeof tokens[tokens.length - 1] === 'string' ? tokens[tokens.length - 1] : '');
        tokens.push({
            name: name || key++,
            prefix: prefix || '',
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? $869213495fe808a0$var$escapeGroup(pattern) : asterisk ? '.*' : $869213495fe808a0$var$restrictBacktrack(delimiter, prevText)
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
function $869213495fe808a0$var$restrictBacktrack(delimiter, prevText) {
    if (!prevText || prevText.indexOf(delimiter) > -1) return '[^' + $869213495fe808a0$var$escapeString(delimiter) + ']+?';
    return $869213495fe808a0$var$escapeString(prevText) + '|(?:(?!' + $869213495fe808a0$var$escapeString(prevText) + ')[^' + $869213495fe808a0$var$escapeString(delimiter) + '])+?';
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $869213495fe808a0$var$compile(str, options) {
    return $869213495fe808a0$var$tokensToFunction($869213495fe808a0$var$parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function $869213495fe808a0$var$encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function $869213495fe808a0$var$encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $869213495fe808a0$var$tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === 'object') matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', $869213495fe808a0$var$flags(options));
    return function(obj, opts) {
        var path = '';
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? $869213495fe808a0$var$encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === 'string') {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if ($e0a2cde2d71b7e87$exports(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`');
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`');
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? $869213495fe808a0$var$encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $869213495fe808a0$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1');
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $869213495fe808a0$var$escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, '\\$1');
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function $869213495fe808a0$var$attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $869213495fe808a0$var$flags(options) {
    return options && options.sensitive ? '' : 'i';
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function $869213495fe808a0$var$regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return $869213495fe808a0$var$attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $869213495fe808a0$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($869213495fe808a0$var$pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp('(?:' + parts.join('|') + ')', $869213495fe808a0$var$flags(options));
    return $869213495fe808a0$var$attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $869213495fe808a0$var$stringToRegexp(path, keys, options) {
    return $869213495fe808a0$var$tokensToRegExp($869213495fe808a0$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function $869213495fe808a0$var$tokensToRegExp(tokens, keys, options) {
    if (!$e0a2cde2d71b7e87$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = '';
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === 'string') route += $869213495fe808a0$var$escapeString(token);
        else {
            var prefix = $869213495fe808a0$var$escapeString(token.prefix);
            var capture = '(?:' + token.pattern + ')';
            keys.push(token);
            if (token.repeat) capture += '(?:' + prefix + capture + ')*';
            if (token.optional) {
                if (!token.partial) capture = '(?:' + prefix + '(' + capture + '))?';
                else capture = prefix + '(' + capture + ')?';
            } else capture = prefix + '(' + capture + ')';
            route += capture;
        }
    }
    var delimiter = $869213495fe808a0$var$escapeString(options.delimiter || '/');
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
    if (end) route += '$';
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
    return $869213495fe808a0$var$attachKeys(new RegExp('^' + route, $869213495fe808a0$var$flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $869213495fe808a0$var$pathToRegexp(path, keys, options) {
    if (!$e0a2cde2d71b7e87$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return $869213495fe808a0$var$regexpToRegexp(path, /** @type {!Array} */ keys);
    if ($e0a2cde2d71b7e87$exports(path)) return $869213495fe808a0$var$arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return $869213495fe808a0$var$stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}


parcelRequire("5M4sD");


var $7g5pF = parcelRequire("7g5pF");
// TODO: Replace with React.createContext once we can assume React 16+
var $a0d5c3f2fe524011$var$createNamedContext = function createNamedContext(name) {
    var context = (0, $5655354bf4d09baf$export$2e2bcd8739ae039)();
    context.displayName = name;
    return context;
};
var $a0d5c3f2fe524011$export$c213558b66925821 = /*#__PURE__*/ $a0d5c3f2fe524011$var$createNamedContext("Router-History");
// TODO: Replace with React.createContext once we can assume React 16+
var $a0d5c3f2fe524011$var$createNamedContext$1 = function createNamedContext(name) {
    var context = (0, $5655354bf4d09baf$export$2e2bcd8739ae039)();
    context.displayName = name;
    return context;
};
var $a0d5c3f2fe524011$export$63baa8ccbe60bb07 = /*#__PURE__*/ $a0d5c3f2fe524011$var$createNamedContext$1("Router");
/**
 * The public API for putting history on context.
 */ var $a0d5c3f2fe524011$export$55185c17a0fcbe46 = /*#__PURE__*/ function(_React$Component) {
    (0, $0ec1659a3a380451$export$2e2bcd8739ae039)(Router, _React$Component);
    Router.computeRootMatch = function computeRootMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    function Router(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            location: props.history.location
        }; // This is a bit of a hack. We have to start listening for location
        // changes here in the constructor in case there are any <Redirect>s
        // on the initial render. If there are, they will replace/push when
        // they mount and since cDM fires in children before parents, we may
        // get a new location before the <Router> is mounted.
        _this._isMounted = false;
        _this._pendingLocation = null;
        if (!props.staticContext) _this.unlisten = props.history.listen(function(location) {
            if (_this._isMounted) _this.setState({
                location: location
            });
            else _this._pendingLocation = location;
        });
        return _this;
    }
    var _proto = Router.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this._isMounted = true;
        if (this._pendingLocation) this.setState({
            location: this._pendingLocation
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unlisten) this.unlisten();
    };
    _proto.render = function render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($a0d5c3f2fe524011$export$63baa8ccbe60bb07.Provider, {
            value: {
                history: this.props.history,
                location: this.state.location,
                match: Router.computeRootMatch(this.state.location.pathname),
                staticContext: this.props.staticContext
            }
        }, (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($a0d5c3f2fe524011$export$c213558b66925821.Provider, {
            children: this.props.children || null,
            value: this.props.history
        }));
    };
    return Router;
}((0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).Component);
/**
 * The public API for a <Router> that stores location in memory.
 */ var $a0d5c3f2fe524011$export$ae46f04cfaffe093 = /*#__PURE__*/ function(_React$Component) {
    (0, $0ec1659a3a380451$export$2e2bcd8739ae039)(MemoryRouter, _React$Component);
    function MemoryRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $de6afe589b6eae99$export$2b76ad033c6e6d08)(_this.props);
        return _this;
    }
    var _proto = MemoryRouter.prototype;
    _proto.render = function render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($a0d5c3f2fe524011$export$55185c17a0fcbe46, {
            history: this.history,
            children: this.props.children
        });
    };
    return MemoryRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).Component);
var $a0d5c3f2fe524011$var$Lifecycle = /*#__PURE__*/ function(_React$Component) {
    (0, $0ec1659a3a380451$export$2e2bcd8739ae039)(Lifecycle, _React$Component);
    function Lifecycle() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Lifecycle.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.onMount) this.props.onMount.call(this, this);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.props.onUnmount) this.props.onUnmount.call(this, this);
    };
    _proto.render = function render() {
        return null;
    };
    return Lifecycle;
}((0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).Component);
/**
 * The public API for prompting the user before navigating away from a screen.
 */ function $a0d5c3f2fe524011$export$83716a4aa1642908(_ref) {
    var message = _ref.message, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    return (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($a0d5c3f2fe524011$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $8097209926f5b57c$export$2e2bcd8739ae039)(false);
        if (!when || context.staticContext) return null;
        var method = context.history.block;
        return (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($a0d5c3f2fe524011$var$Lifecycle, {
            onMount: function onMount(self) {
                self.release = method(message);
            },
            onUpdate: function onUpdate(self, prevProps) {
                if (prevProps.message !== message) {
                    self.release();
                    self.release = method(message);
                }
            },
            onUnmount: function onUnmount(self) {
                self.release();
            },
            message: message
        });
    });
}
var $a0d5c3f2fe524011$var$messageType;
var $a0d5c3f2fe524011$var$cache = {};
var $a0d5c3f2fe524011$var$cacheLimit = 10000;
var $a0d5c3f2fe524011$var$cacheCount = 0;
function $a0d5c3f2fe524011$var$compilePath(path) {
    if ($a0d5c3f2fe524011$var$cache[path]) return $a0d5c3f2fe524011$var$cache[path];
    var generator = (0, (/*@__PURE__*/$parcel$interopDefault($869213495fe808a0$exports))).compile(path);
    if ($a0d5c3f2fe524011$var$cacheCount < $a0d5c3f2fe524011$var$cacheLimit) {
        $a0d5c3f2fe524011$var$cache[path] = generator;
        $a0d5c3f2fe524011$var$cacheCount++;
    }
    return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */ function $a0d5c3f2fe524011$export$82476f982757e71e(path, params) {
    if (path === void 0) path = "/";
    if (params === void 0) params = {};
    return path === "/" ? path : $a0d5c3f2fe524011$var$compilePath(path)(params, {
        pretty: true
    });
}
/**
 * The public API for navigating programmatically with a component.
 */ function $a0d5c3f2fe524011$export$2d8d895a0a0f636e(_ref) {
    var computedMatch = _ref.computedMatch, to = _ref.to, _ref$push = _ref.push, push = _ref$push === void 0 ? false : _ref$push;
    return (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($a0d5c3f2fe524011$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $8097209926f5b57c$export$2e2bcd8739ae039)(false);
        var history = context.history, staticContext = context.staticContext;
        var method = push ? history.push : history.replace;
        var location = (0, $de6afe589b6eae99$export$90c043f1c57770b8)(computedMatch ? typeof to === "string" ? $a0d5c3f2fe524011$export$82476f982757e71e(to, computedMatch.params) : (0, $dda4d40cf5733033$export$2e2bcd8739ae039)({}, to, {
            pathname: $a0d5c3f2fe524011$export$82476f982757e71e(to.pathname, computedMatch.params)
        }) : to); // When rendering in a static context,
        // set the new location immediately.
        if (staticContext) {
            method(location);
            return null;
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($a0d5c3f2fe524011$var$Lifecycle, {
            onMount: function onMount() {
                method(location);
            },
            onUpdate: function onUpdate(self, prevProps) {
                var prevLocation = (0, $de6afe589b6eae99$export$90c043f1c57770b8)(prevProps.to);
                if (!(0, $de6afe589b6eae99$export$c3e8bb440bd55b18)(prevLocation, (0, $dda4d40cf5733033$export$2e2bcd8739ae039)({}, location, {
                    key: prevLocation.key
                }))) method(location);
            },
            to: to
        });
    });
}
var $a0d5c3f2fe524011$var$cache$1 = {};
var $a0d5c3f2fe524011$var$cacheLimit$1 = 10000;
var $a0d5c3f2fe524011$var$cacheCount$1 = 0;
function $a0d5c3f2fe524011$var$compilePath$1(path, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var pathCache = $a0d5c3f2fe524011$var$cache$1[cacheKey] || ($a0d5c3f2fe524011$var$cache$1[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    var keys = [];
    var regexp = (0, (/*@__PURE__*/$parcel$interopDefault($869213495fe808a0$exports)))(path, keys, options);
    var result = {
        regexp: regexp,
        keys: keys
    };
    if ($a0d5c3f2fe524011$var$cacheCount$1 < $a0d5c3f2fe524011$var$cacheLimit$1) {
        pathCache[path] = result;
        $a0d5c3f2fe524011$var$cacheCount$1++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */ function $a0d5c3f2fe524011$export$81336c211d5ff295(pathname, options) {
    if (options === void 0) options = {};
    if (typeof options === "string" || Array.isArray(options)) options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === void 0 ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === void 0 ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
    var paths = [].concat(path);
    return paths.reduce(function(matched, path) {
        if (!path && path !== "") return null;
        if (matched) return matched;
        var _compilePath = $a0d5c3f2fe524011$var$compilePath$1(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        }), regexp = _compilePath.regexp, keys = _compilePath.keys;
        var match = regexp.exec(pathname);
        if (!match) return null;
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === "/" && url === "" ? "/" : url,
            // the matched portion of the URL
            isExact: isExact,
            // whether or not we matched exactly
            params: keys.reduce(function(memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
function $a0d5c3f2fe524011$var$isEmptyChildren(children) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).Children.count(children) === 0;
}
function $a0d5c3f2fe524011$var$evalChildrenDev(children, props, path) {
    var value = children(props);
    return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */ var $a0d5c3f2fe524011$export$e7b0ac011bb776c6 = /*#__PURE__*/ function(_React$Component) {
    (0, $0ec1659a3a380451$export$2e2bcd8739ae039)(Route, _React$Component);
    function Route() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Route.prototype;
    _proto.render = function render() {
        var _this = this;
        return (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($a0d5c3f2fe524011$export$63baa8ccbe60bb07.Consumer, null, function(context$1) {
            !context$1 && (0, $8097209926f5b57c$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context$1.location;
            var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
             : _this.props.path ? $a0d5c3f2fe524011$export$81336c211d5ff295(location.pathname, _this.props) : context$1.match;
            var props = (0, $dda4d40cf5733033$export$2e2bcd8739ae039)({}, context$1, {
                location: location,
                match: match
            });
            var _this$props = _this.props, children = _this$props.children, component = _this$props.component, render = _this$props.render; // Preact uses an empty array as children by
            // default, so use null if that's the case.
            if (Array.isArray(children) && children.length === 0) children = null;
            return (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($a0d5c3f2fe524011$export$63baa8ccbe60bb07.Provider, {
                value: props
            }, props.match ? children ? typeof children === "function" ? children(props) : children : component ? (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(component, props) : render ? render(props) : null : typeof children === "function" ? children(props) : null);
        });
    };
    return Route;
}((0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).Component);
function $a0d5c3f2fe524011$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $a0d5c3f2fe524011$var$addBasename(basename, location) {
    if (!basename) return location;
    return (0, $dda4d40cf5733033$export$2e2bcd8739ae039)({}, location, {
        pathname: $a0d5c3f2fe524011$var$addLeadingSlash(basename) + location.pathname
    });
}
function $a0d5c3f2fe524011$var$stripBasename(basename, location) {
    if (!basename) return location;
    var base = $a0d5c3f2fe524011$var$addLeadingSlash(basename);
    if (location.pathname.indexOf(base) !== 0) return location;
    return (0, $dda4d40cf5733033$export$2e2bcd8739ae039)({}, location, {
        pathname: location.pathname.substr(base.length)
    });
}
function $a0d5c3f2fe524011$var$createURL(location) {
    return typeof location === "string" ? location : (0, $de6afe589b6eae99$export$fe53371bee54353d)(location);
}
function $a0d5c3f2fe524011$var$staticHandler(methodName) {
    return function() {
        (0, $8097209926f5b57c$export$2e2bcd8739ae039)(false);
    };
}
function $a0d5c3f2fe524011$var$noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */ var $a0d5c3f2fe524011$export$cac06da4d76d935b = /*#__PURE__*/ function(_React$Component) {
    (0, $0ec1659a3a380451$export$2e2bcd8739ae039)(StaticRouter, _React$Component);
    function StaticRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handlePush = function(location) {
            return _this.navigateTo(location, "PUSH");
        };
        _this.handleReplace = function(location) {
            return _this.navigateTo(location, "REPLACE");
        };
        _this.handleListen = function() {
            return $a0d5c3f2fe524011$var$noop;
        };
        _this.handleBlock = function() {
            return $a0d5c3f2fe524011$var$noop;
        };
        return _this;
    }
    var _proto = StaticRouter.prototype;
    _proto.navigateTo = function navigateTo(location, action) {
        var _this$props = this.props, _this$props$basename = _this$props.basename, basename = _this$props$basename === void 0 ? "" : _this$props$basename, _this$props$context = _this$props.context, context = _this$props$context === void 0 ? {} : _this$props$context;
        context.action = action;
        context.location = $a0d5c3f2fe524011$var$addBasename(basename, (0, $de6afe589b6eae99$export$90c043f1c57770b8)(location));
        context.url = $a0d5c3f2fe524011$var$createURL(context.location);
    };
    _proto.render = function render() {
        var _this$props2 = this.props, _this$props2$basename = _this$props2.basename, basename = _this$props2$basename === void 0 ? "" : _this$props2$basename, _this$props2$context = _this$props2.context, context = _this$props2$context === void 0 ? {} : _this$props2$context, _this$props2$location = _this$props2.location, location = _this$props2$location === void 0 ? "/" : _this$props2$location, rest = (0, $93b7456b56abf607$export$2e2bcd8739ae039)(_this$props2, [
            "basename",
            "context",
            "location"
        ]);
        var history = {
            createHref: function createHref(path) {
                return $a0d5c3f2fe524011$var$addLeadingSlash(basename + $a0d5c3f2fe524011$var$createURL(path));
            },
            action: "POP",
            location: $a0d5c3f2fe524011$var$stripBasename(basename, (0, $de6afe589b6eae99$export$90c043f1c57770b8)(location)),
            push: this.handlePush,
            replace: this.handleReplace,
            go: $a0d5c3f2fe524011$var$staticHandler("go"),
            goBack: $a0d5c3f2fe524011$var$staticHandler("goBack"),
            goForward: $a0d5c3f2fe524011$var$staticHandler("goForward"),
            listen: this.handleListen,
            block: this.handleBlock
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($a0d5c3f2fe524011$export$55185c17a0fcbe46, (0, $dda4d40cf5733033$export$2e2bcd8739ae039)({}, rest, {
            history: history,
            staticContext: context
        }));
    };
    return StaticRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).Component);
/**
 * The public API for rendering the first <Route> that matches.
 */ var $a0d5c3f2fe524011$export$b5d5cf8927ab7262 = /*#__PURE__*/ function(_React$Component) {
    (0, $0ec1659a3a380451$export$2e2bcd8739ae039)(Switch, _React$Component);
    function Switch() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Switch.prototype;
    _proto.render = function render() {
        var _this = this;
        return (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($a0d5c3f2fe524011$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $8097209926f5b57c$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context.location;
            var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
            // here because toArray adds keys to all child elements and we do not want
            // to trigger an unmount/remount for two <Route>s that render the same
            // component at different URLs.
            (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).Children.forEach(_this.props.children, function(child) {
                if (match == null && (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).isValidElement(child)) {
                    element = child;
                    var path = child.props.path || child.props.from;
                    match = path ? $a0d5c3f2fe524011$export$81336c211d5ff295(location.pathname, (0, $dda4d40cf5733033$export$2e2bcd8739ae039)({}, child.props, {
                        path: path
                    })) : context.match;
                }
            });
            return match ? (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).cloneElement(element, {
                location: location,
                computedMatch: match
            }) : null;
        });
    };
    return Switch;
}((0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).Component);
/**
 * A public higher-order component to access the imperative API
 */ function $a0d5c3f2fe524011$export$369b6b2b30582e8e(Component) {
    var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
    var C = function C(props) {
        var wrappedComponentRef = props.wrappedComponentRef, remainingProps = (0, $93b7456b56abf607$export$2e2bcd8739ae039)(props, [
            "wrappedComponentRef"
        ]);
        return (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($a0d5c3f2fe524011$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $8097209926f5b57c$export$2e2bcd8739ae039)(false);
            return (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(Component, (0, $dda4d40cf5733033$export$2e2bcd8739ae039)({}, remainingProps, context, {
                ref: wrappedComponentRef
            }));
        });
    };
    C.displayName = displayName;
    C.WrappedComponent = Component;
    return (0, (/*@__PURE__*/$parcel$interopDefault($7g5pF)))(C, Component);
}
var $a0d5c3f2fe524011$var$useContext = (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).useContext;
function $a0d5c3f2fe524011$export$3420e1dc2c4a518c() {
    return $a0d5c3f2fe524011$var$useContext($a0d5c3f2fe524011$export$c213558b66925821);
}
function $a0d5c3f2fe524011$export$45d76561a5302f2b() {
    return $a0d5c3f2fe524011$var$useContext($a0d5c3f2fe524011$export$63baa8ccbe60bb07).location;
}
function $a0d5c3f2fe524011$export$99eaa27ddbbb95ef() {
    var match = $a0d5c3f2fe524011$var$useContext($a0d5c3f2fe524011$export$63baa8ccbe60bb07).match;
    return match ? match.params : {};
}
function $a0d5c3f2fe524011$export$632be4bb944c1bc7(path) {
    var location = $a0d5c3f2fe524011$export$45d76561a5302f2b();
    var match = $a0d5c3f2fe524011$var$useContext($a0d5c3f2fe524011$export$63baa8ccbe60bb07).match;
    return path ? $a0d5c3f2fe524011$export$81336c211d5ff295(location.pathname, path) : match;
}
var $a0d5c3f2fe524011$var$global, $a0d5c3f2fe524011$var$key, $a0d5c3f2fe524011$var$buildNames, $a0d5c3f2fe524011$var$initialBuildName, $a0d5c3f2fe524011$var$secondaryBuildName;




var $tZqWC = parcelRequire("tZqWC");






/**
 * The public API for a <Router> that uses HTML5 history.
 */ var $12b33660068e86aa$export$9ba4e89fdfa1fc54 = /*#__PURE__*/ function(_React$Component) {
    (0, $0ec1659a3a380451$export$2e2bcd8739ae039)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $de6afe589b6eae99$export$719fc203c4e16dee)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement((0, $a0d5c3f2fe524011$export$55185c17a0fcbe46), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).Component);
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var $12b33660068e86aa$export$7221d69dcfc8e36b = /*#__PURE__*/ function(_React$Component) {
    (0, $0ec1659a3a380451$export$2e2bcd8739ae039)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $de6afe589b6eae99$export$b71fdd3798280242)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement((0, $a0d5c3f2fe524011$export$55185c17a0fcbe46), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).Component);
var $12b33660068e86aa$var$resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var $12b33660068e86aa$var$normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, $de6afe589b6eae99$export$90c043f1c57770b8)(to, null, null, currentLocation) : to;
};
var $12b33660068e86aa$var$forwardRefShim = function forwardRefShim(C) {
    return C;
};
var $12b33660068e86aa$var$forwardRef = (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).forwardRef;
if (typeof $12b33660068e86aa$var$forwardRef === "undefined") $12b33660068e86aa$var$forwardRef = $12b33660068e86aa$var$forwardRefShim;
function $12b33660068e86aa$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $12b33660068e86aa$var$LinkAnchor = $12b33660068e86aa$var$forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, $93b7456b56abf607$export$2e2bcd8739ae039)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, $dda4d40cf5733033$export$2e2bcd8739ae039)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !$12b33660068e86aa$var$isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if ($12b33660068e86aa$var$forwardRefShim !== $12b33660068e86aa$var$forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement("a", props);
});
/**
 * The public API for rendering a history-aware <a>.
 */ var $12b33660068e86aa$export$a6c7ac8248d6e38a = $12b33660068e86aa$var$forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? $12b33660068e86aa$var$LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, $93b7456b56abf607$export$2e2bcd8739ae039)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement((0, $a0d5c3f2fe524011$export$63baa8ccbe60bb07).Consumer, null, function(context) {
        !context && (0, $8097209926f5b57c$export$2e2bcd8739ae039)(false);
        var history = context.history;
        var location = $12b33660068e86aa$var$normalizeToLocation($12b33660068e86aa$var$resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, $dda4d40cf5733033$export$2e2bcd8739ae039)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = $12b33660068e86aa$var$resolveToLocation(to, context.location);
                var method = replace ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if ($12b33660068e86aa$var$forwardRefShim !== $12b33660068e86aa$var$forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(component, props);
    });
});
var $12b33660068e86aa$var$toType, $12b33660068e86aa$var$refType;
var $12b33660068e86aa$var$forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var $12b33660068e86aa$var$forwardRef$1 = (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).forwardRef;
if (typeof $12b33660068e86aa$var$forwardRef$1 === "undefined") $12b33660068e86aa$var$forwardRef$1 = $12b33660068e86aa$var$forwardRefShim$1;
function $12b33660068e86aa$var$joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var $12b33660068e86aa$export$b0d92dbee9b5b60d = $12b33660068e86aa$var$forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, $93b7456b56abf607$export$2e2bcd8739ae039)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement((0, $a0d5c3f2fe524011$export$63baa8ccbe60bb07).Consumer, null, function(context) {
        !context && (0, $8097209926f5b57c$export$2e2bcd8739ae039)(false);
        var currentLocation = locationProp || context.location;
        var toLocation = $12b33660068e86aa$var$normalizeToLocation($12b33660068e86aa$var$resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, $a0d5c3f2fe524011$export$81336c211d5ff295)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = isActive ? $12b33660068e86aa$var$joinClassnames(classNameProp, activeClassName) : classNameProp;
        var style = isActive ? (0, $dda4d40cf5733033$export$2e2bcd8739ae039)({}, styleProp, {}, activeStyle) : styleProp;
        var props = (0, $dda4d40cf5733033$export$2e2bcd8739ae039)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if ($12b33660068e86aa$var$forwardRefShim$1 !== $12b33660068e86aa$var$forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement($12b33660068e86aa$export$a6c7ac8248d6e38a, props);
    });
});
var $12b33660068e86aa$var$ariaCurrentType;


// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var $e9a590d0e6dc1a35$var$getRandomValues;
var $e9a590d0e6dc1a35$var$rnds8 = new Uint8Array(16);
function $e9a590d0e6dc1a35$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$e9a590d0e6dc1a35$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
        // find the complete implementation of crypto (msCrypto) on IE11.
        $e9a590d0e6dc1a35$var$getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);
        if (!$e9a590d0e6dc1a35$var$getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    return $e9a590d0e6dc1a35$var$getRandomValues($e9a590d0e6dc1a35$var$rnds8);
}


var $0e1a6deb19c25dd4$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;


function $5ed09d944b6ac18f$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $0e1a6deb19c25dd4$export$2e2bcd8739ae039).test(uuid);
}
var $5ed09d944b6ac18f$export$2e2bcd8739ae039 = $5ed09d944b6ac18f$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $6161f3955c61bad2$var$byteToHex = [];
for(var $6161f3955c61bad2$var$i = 0; $6161f3955c61bad2$var$i < 256; ++$6161f3955c61bad2$var$i)$6161f3955c61bad2$var$byteToHex.push(($6161f3955c61bad2$var$i + 0x100).toString(16).substr(1));
function $6161f3955c61bad2$var$stringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    var uuid = ($6161f3955c61bad2$var$byteToHex[arr[offset + 0]] + $6161f3955c61bad2$var$byteToHex[arr[offset + 1]] + $6161f3955c61bad2$var$byteToHex[arr[offset + 2]] + $6161f3955c61bad2$var$byteToHex[arr[offset + 3]] + '-' + $6161f3955c61bad2$var$byteToHex[arr[offset + 4]] + $6161f3955c61bad2$var$byteToHex[arr[offset + 5]] + '-' + $6161f3955c61bad2$var$byteToHex[arr[offset + 6]] + $6161f3955c61bad2$var$byteToHex[arr[offset + 7]] + '-' + $6161f3955c61bad2$var$byteToHex[arr[offset + 8]] + $6161f3955c61bad2$var$byteToHex[arr[offset + 9]] + '-' + $6161f3955c61bad2$var$byteToHex[arr[offset + 10]] + $6161f3955c61bad2$var$byteToHex[arr[offset + 11]] + $6161f3955c61bad2$var$byteToHex[arr[offset + 12]] + $6161f3955c61bad2$var$byteToHex[arr[offset + 13]] + $6161f3955c61bad2$var$byteToHex[arr[offset + 14]] + $6161f3955c61bad2$var$byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $5ed09d944b6ac18f$export$2e2bcd8739ae039)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $6161f3955c61bad2$export$2e2bcd8739ae039 = $6161f3955c61bad2$var$stringify;


function $5d7f1dba4fbacab8$var$v4(options, buf, offset) {
    options = options || {};
    var rnds = options.random || (options.rng || (0, $e9a590d0e6dc1a35$export$2e2bcd8739ae039))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $6161f3955c61bad2$export$2e2bcd8739ae039)(rnds);
}
var $5d7f1dba4fbacab8$export$2e2bcd8739ae039 = $5d7f1dba4fbacab8$var$v4;


/* eslint-disable max-len */ // Route Components
// Auth/Accounts Pages

parcelRequire("tZqWC");
/* eslint-disable react/prop-types */ 
parcelRequire("tZqWC");
function $8cbc17364ca8973d$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: props?.size || '24',
        height: props?.size || '24',
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "#727F97",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "feather feather-briefcase",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("rect", {
                x: "2",
                y: "7",
                width: "20",
                height: "14",
                rx: "2",
                ry: "2"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"
            })
        ]
    });
}


/* eslint-disable react/prop-types */ /* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $c03295d715f2cab9$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: props?.size || '16',
        height: props?.size || '15',
        viewBox: "0 0 16 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M12.0143 2.5H3.26434C2.57399 2.5 2.01434 3.05964 2.01434 3.75V12.5C2.01434 13.1904 2.57399 13.75 3.26434 13.75H12.0143C12.7047 13.75 13.2643 13.1904 13.2643 12.5V3.75C13.2643 3.05964 12.7047 2.5 12.0143 2.5Z",
                stroke: "#606167",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M10.1393 1.25V3.75",
                stroke: "#606167",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M5.13934 1.25V3.75",
                stroke: "#606167",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M2.01434 6.25H13.2643",
                stroke: "#606167",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}


/* eslint-disable react/prop-types */ 
parcelRequire("tZqWC");
function $8c389a0d83e0230c$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: props?.size || '10',
        height: props?.size || '10',
        viewBox: "0 0 10 10",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M8 1L9 2.71429L8 4.42857",
                stroke: "#727F97",
                strokeWidth: "0.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M4 5.00056V4.23865C4 3.83451 4.11706 3.44693 4.32544 3.16116C4.53381 2.87539 4.81643 2.71484 5.11111 2.71484H9",
                stroke: "#727F97",
                strokeWidth: "0.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M2 8.99986L1 7.28557L2 5.57129",
                stroke: "#727F97",
                strokeWidth: "0.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M6 5V5.7619C6 6.16604 5.88294 6.55363 5.67456 6.8394C5.46619 7.12517 5.18357 7.28571 4.88889 7.28571H1",
                stroke: "#727F97",
                strokeWidth: "0.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}


/* eslint-disable react/prop-types */ /* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $d2d07bb75c367a07$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("svg", {
        width: props?.size || '16',
        height: props?.size || '16',
        viewBox: "0 0 25 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
            d: "M24.6899 2.9707V22.9707C24.6899 24.0707 23.7899 24.9707 22.6899 24.9707H13.6899C13.1399 24.9707 12.6899 24.5207 12.6899 23.9707C12.6899 23.4207 13.1399 22.9707 13.6899 22.9707H22.6899V2.9707H2.68994V14.9707C2.68994 15.5207 2.23994 15.9707 1.68994 15.9707C1.13994 15.9707 0.689941 15.5207 0.689941 14.9707V2.9707C0.689941 1.8707 1.58994 0.970703 2.68994 0.970703H22.6899C23.7899 0.970703 24.6899 1.8707 24.6899 2.9707ZM12.3999 16.2707C12.0099 15.8807 11.3799 15.8807 10.9899 16.2707L4.69995 22.5607L2.40994 20.2707C2.01994 19.8807 1.38993 19.8807 0.989929 20.2707C0.589929 20.6607 0.599929 21.2907 0.989929 21.6907L3.98993 24.6907C4.37993 25.0807 5.00993 25.0807 5.39993 24.6907L12.3999 17.6907C12.7899 17.3007 12.7899 16.6707 12.3999 16.2807V16.2707Z",
            fill: "#FFFFFF"
        })
    });
}


/* eslint-disable react/prop-types */ /* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $b77b5de3fb591045$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("svg", {
        width: props?.size || '19',
        height: props?.size || '19',
        viewBox: "0 0 19 19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3.84391 2.3144C3.42564 1.89566 2.74695 1.89513 2.32802 2.31322C1.9091 2.73132 1.90857 3.40971 2.32684 3.82845L7.98529 9.49325L2.31336 15.1715C1.89509 15.5903 1.89561 16.2687 2.31454 16.6868C2.73347 17.1049 3.41215 17.1043 3.83043 16.6856L9.49325 11.0164L15.1561 16.6856C15.5744 17.1043 16.2531 17.1049 16.672 16.6868C17.0909 16.2687 17.0914 15.5903 16.6731 15.1715L11.0147 9.50675L16.6866 3.82845C17.1049 3.40971 17.1044 2.73132 16.6855 2.31322C16.2665 1.89513 15.5879 1.89566 15.1696 2.3144L9.50674 7.98359L3.84391 2.3144Z",
            fill: "white"
        })
    });
}


/* eslint-disable react/prop-types */ /* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $c43eb4ee7dedc1da$export$2e2bcd8739ae039(props) {
    const { ...rest } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: props?.size || '24',
        height: props?.size || '24',
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "feather feather-copy",
        ...rest,
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("rect", {
                x: "9",
                y: "9",
                width: "13",
                height: "13",
                rx: "2",
                ry: "2"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"
            })
        ]
    });
}


/* eslint-disable react/prop-types */ 
parcelRequire("tZqWC");
function $ec0fe6bec41c92eb$var$DocumentIcon(props) {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: props?.size || '24',
        height: props?.size || '24',
        fill: "none",
        viewBox: "0 0 24 24",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                stroke: "#fff",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2",
                d: "M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6z"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                stroke: "#fff",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2",
                d: "M14 2v6h6M16 13H8M16 17H8M10 9H8"
            })
        ]
    });
}
var $ec0fe6bec41c92eb$export$2e2bcd8739ae039 = $ec0fe6bec41c92eb$var$DocumentIcon;


/* eslint-disable react/prop-types */ 
parcelRequire("tZqWC");
function $462cc6e9cac360f1$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: props?.size || '12',
        height: props?.size || '12',
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M1 11H11",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M6 1L6 8",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M6 9L9.5 5.5H2.5L6 9Z",
                stroke: "white",
                strokeLinejoin: "round"
            })
        ]
    });
}


/* eslint-disable react/prop-types */ /* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $fdc5d4d606744379$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: props?.size || '4',
        height: props?.size || '14',
        viewBox: "0 0 4 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("ellipse", {
                cx: "1.95982",
                cy: "2",
                rx: "1.48911",
                ry: "1.5",
                fill: "#727F97"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("ellipse", {
                cx: "1.95982",
                cy: "7",
                rx: "1.48911",
                ry: "1.5",
                fill: "#727F97"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("ellipse", {
                cx: "1.95982",
                cy: "12",
                rx: "1.48911",
                ry: "1.5",
                fill: "#727F97"
            })
        ]
    });
}


/* eslint-disable react/prop-types */ /* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $7e5282d83c21f92a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: props?.size || '71',
        height: props?.size || '78',
        viewBox: "0 0 71 78",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M68.667 48.668H48.667L42 58.668H28.667L22 48.668H2",
                stroke: "white",
                strokeWidth: "4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M13.5 25.7L2 48.667V68.667C2 70.435 2.702 72.13 3.953 73.381C5.203 74.631 6.89899 75.333 8.66699 75.333H62C63.768 75.333 65.464 74.631 66.714 73.381C67.964 72.13 68.667 70.435 68.667 68.667V48.667L57.167 25.7C56.615 24.589 55.764 23.655 54.71 23.001C53.656 22.347 52.44 22.001 51.2 22H19.467C18.226 22.001 17.011 22.347 15.957 23.001C14.903 23.655 14.052 24.589 13.5 25.7Z",
                stroke: "white",
                strokeWidth: "4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M34.75 2V10",
                stroke: "white",
                strokeWidth: "4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M49.2319 4.73602L45.2319 11.664",
                stroke: "white",
                strokeWidth: "4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M25.2681 11.659L21.2681 4.72998",
                stroke: "white",
                strokeWidth: "4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}


/* eslint-disable react/prop-types */ /* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $2aac7bf62453042d$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: props?.size || '24',
        height: props?.size || '24',
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "#fff",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "feather feather-external-link",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("polyline", {
                points: "15 3 21 3 21 9"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("line", {
                x1: "10",
                y1: "14",
                x2: "21",
                y2: "3"
            })
        ]
    });
}


/* eslint-disable react/prop-types */ /* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $3a687fb5156bce3a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: props?.size || '19',
        height: props?.size || '14',
        viewBox: "0 0 19 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M1.33337 6.99999C1.33337 6.99999 4.30308 1.28571 9.50004 1.28571C14.697 1.28571 17.6667 6.99999 17.6667 6.99999C17.6667 6.99999 14.697 12.7143 9.50004 12.7143C4.30308 12.7143 1.33337 6.99999 1.33337 6.99999Z",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M9.50004 8.14283C10.1444 8.14283 10.6667 7.63115 10.6667 6.99997C10.6667 6.3688 10.1444 5.85712 9.50004 5.85712C8.85571 5.85712 8.33337 6.3688 8.33337 6.99997C8.33337 7.63115 8.85571 8.14283 9.50004 8.14283Z",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}


/* eslint-disable react/prop-types */ 
parcelRequire("tZqWC");
function $163f23491e8bc756$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: props?.size || '15',
        height: props?.size || '11',
        viewBox: "0 0 15 11",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M1 1.9231H13.9874",
                stroke: "#00CACD",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M1 6H9.51935",
                stroke: "#00CACD",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("line", {
                x1: "1",
                y1: "10",
                x2: "3.46808",
                y2: "10",
                stroke: "#00CACD",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}


/* eslint-disable react/destructuring-assignment */ /* eslint-disable react/prop-types */ /* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $b7c251a6b5f784dd$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: props?.size || '11px',
        height: props?.size || '11px',
        viewBox: "0 0 11 11",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M5.50033 10.0846C8.03163 10.0846 10.0837 8.03261 10.0837 5.5013C10.0837 2.97 8.03163 0.917969 5.50033 0.917969C2.96902 0.917969 0.916992 2.97 0.916992 5.5013C0.916992 8.03261 2.96902 10.0846 5.50033 10.0846Z",
                fill: "#F3F4F7"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M4.16602 4.12575C4.27377 3.81943 4.48646 3.56113 4.76641 3.3966C5.04636 3.23207 5.37551 3.17193 5.69555 3.22683C6.0156 3.28172 6.30589 3.44811 6.51501 3.69653C6.72413 3.94495 6.83858 4.25936 6.8381 4.58408C6.8381 5.50075 5.4631 5.95908 5.4631 5.95908",
                stroke: "#393D46",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M5.5 7.79297H5.50609",
                stroke: "#393D46",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}


/* eslint-disable react/destructuring-assignment */ /* eslint-disable react/prop-types */ /* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $9523a1ca65c68678$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: props?.size || '15',
        height: props?.size || '15',
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M3.96566 11.0355H11.0367V3.96447",
                stroke: "white",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M3.96567 3.96409L11.0367 11.0352",
                stroke: "white",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}


/* eslint-disable react/prop-types */ /* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $ef7aaa91ec87194a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: props?.size || '16',
        height: props?.size || '16',
        viewBox: "0 0 19 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M8.33337 8.85527C8.66898 9.25462 9.09714 9.58508 9.58882 9.82418C10.0805 10.0633 10.6242 10.2055 11.1831 10.2411C11.7419 10.2767 12.3028 10.205 12.8278 10.0307C13.3527 9.85636 13.8294 9.58359 14.2255 9.23088L16.5699 7.14412C17.2816 6.48818 17.6755 5.60962 17.6666 4.69772C17.6577 3.78581 17.2467 2.91351 16.5223 2.26866C15.7978 1.62383 14.8179 1.25805 13.7934 1.25013C12.7689 1.2422 11.7819 1.59276 11.045 2.22629L9.70092 3.41576",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M10.6667 7.14473C10.3311 6.74537 9.90295 6.41494 9.41127 6.17581C8.91959 5.9367 8.37587 5.7945 7.81704 5.75888C7.25818 5.72327 6.69725 5.79502 6.17232 5.96933C5.64737 6.14363 5.17067 6.4164 4.77456 6.76911L2.43019 8.85587C1.71845 9.51182 1.32463 10.3904 1.33352 11.3023C1.34243 12.2142 1.75336 13.0865 2.47779 13.7313C3.20224 14.3762 4.18222 14.7419 5.20669 14.7499C6.23117 14.7578 7.21814 14.4072 7.95508 13.7737L9.29136 12.5842",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}


/* eslint-disable react/destructuring-assignment */ /* eslint-disable react/prop-types */ /* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $40d2b22b972563c2$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: props?.width ? props.width : '30',
        height: props?.height ? props.height : '30',
        viewBox: "0 0 25 25",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M24.5 12.5001C24.5 19.127 19.1275 24.5 12.5001 24.5C5.8729 24.5 0.5 19.127 0.5 12.5001C0.5 5.8726 5.87289 0.5 12.5001 0.5C19.1276 0.5 24.5 5.87249 24.5 12.5001Z",
                fill: "white",
                fillOpacity: "0.1",
                stroke: "#393D46"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M10 10.6654V8.91536C10 8.53234 10.0754 8.15307 10.222 7.7992C10.3686 7.44534 10.5834 7.12381 10.8543 6.85297C11.1251 6.58213 11.4466 6.36729 11.8005 6.22071C12.1544 6.07414 12.5336 5.9987 12.9167 5.9987C13.2997 5.9987 13.679 6.07414 14.0328 6.22071C14.3867 6.36729 14.7082 6.58213 14.9791 6.85297C15.2499 7.12381 15.4647 7.44534 15.6113 7.7992C15.7579 8.15307 15.8333 8.53234 15.8333 8.91536V10.6654M15.8333 14.1654V15.9154C15.8333 16.2984 15.7579 16.6777 15.6113 17.0315C15.4647 17.3854 15.2499 17.7069 14.9791 17.9778C14.4321 18.5247 13.6902 18.832 12.9167 18.832C12.1431 18.832 11.4013 18.5247 10.8543 17.9778C10.3073 17.4308 10 16.6889 10 15.9154V14.1654",
                stroke: "#393D46",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M13 14.832V10.1654",
                stroke: "#393D46",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}


/* eslint-disable react/destructuring-assignment */ /* eslint-disable react/prop-types */ /* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $f5fc3c6481bdb5b2$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: props?.size || '23',
        height: props?.size || '23',
        fill: "none",
        viewBox: "0 0 23 23",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("circle", {
                cx: "11.142",
                cy: "11.145",
                r: "5",
                stroke: "#D5D6D8",
                strokeWidth: "2",
                transform: "rotate(-45 11.142 11.145)"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                stroke: "#D5D6D8",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2",
                d: "M18.213 18.216c3.905-3.906 3.905-10.237 0-14.143C14.308.168 7.976.168 4.071 4.073.166 7.98.166 14.31 4.071 18.216c3.905 3.905 10.237 3.905 14.142 0zM18.215 4.074l-2.828 2.828M6.899 15.386L4.07 18.215M6.899 6.903L4.07 4.074M18.215 18.215l-2.828-2.828"
            })
        ]
    });
}


/* eslint-disable react/prop-types */ /* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $4b4e040b317bb2f3$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: props?.size || '22',
        height: props?.size || '23',
        viewBox: "0 0 22 23",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M12.3714 20.3857C12.1902 20.6995 11.9302 20.96 11.6174 21.1411C11.3046 21.3222 10.95 21.4175 10.589 21.4175C10.228 21.4175 9.87337 21.3222 9.56056 21.1411C9.24776 20.96 8.98777 20.6995 8.80664 20.3857",
                stroke: "#727F97",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M17.3387 7.71235C17.3387 6.06473 16.6875 4.4846 15.5282 3.31955C14.3689 2.15451 12.7966 1.5 11.1571 1.5C9.51769 1.5 7.94538 2.15451 6.78611 3.31955C5.62683 4.4846 4.97556 6.06473 4.97556 7.71235C4.97556 14.9601 1.88477 17.0309 1.88477 17.0309H20.4295C20.4295 17.0309 17.3387 14.9601 17.3387 7.71235Z",
                stroke: "#727F97",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}


/* eslint-disable react/prop-types */ /* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $a25394adb640e26c$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: props?.size || '70',
        height: props?.size || '18',
        viewBox: "0 0 70 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M0 6.41901C0 2.8721 2.96803 0 6.62969 0C10.289 0 13.2617 2.8721 13.2617 6.41901C13.2617 9.9648 10.2936 12.838 6.62969 12.838C2.96803 12.838 0 9.9648 0 6.41901ZM3.28143 7.77085C3.41508 8.07758 3.59022 8.362 3.80222 8.61742C4.46588 9.41827 5.48441 9.93134 6.62969 9.93134C8.6368 9.93134 10.2591 8.35531 10.2591 6.41901C10.2591 4.48271 8.6368 2.90668 6.62969 2.90668C4.63179 2.90668 3.0026 4.47713 3.0026 6.41901C3.0026 6.89751 3.10169 7.3537 3.28143 7.77085Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M18.859 4.87644C19.5411 5.18763 20.1195 5.49659 20.5919 5.80221C21.0389 6.0922 21.3915 6.37774 21.645 6.65882C21.9353 6.98897 22.1497 7.37489 22.281 7.80989C22.387 8.15566 22.44 8.53266 22.44 8.93754C22.44 10.0797 22.0091 11.0278 21.1611 11.7472C20.3177 12.461 19.2185 12.8269 17.905 12.8269C17.1422 12.8269 16.4048 12.6841 15.7043 12.3919C15.0084 12.1008 14.377 11.7182 13.8216 11.136L15.3909 8.69215L15.5453 8.81708C15.9878 9.17735 16.3933 9.43388 16.7643 9.5878C17.1307 9.74284 17.5271 9.83988 17.9442 9.86777C18.352 9.88003 18.67 9.8053 18.889 9.64581C19.0134 9.55434 19.101 9.44727 19.1517 9.32123C19.1862 9.23423 19.2024 9.13942 19.2024 9.03458C19.2024 8.78919 19.0848 8.56612 18.8475 8.34304C18.594 8.10881 18.0916 7.82327 17.3542 7.49201C16.9625 7.32693 16.6007 7.15516 16.2735 6.97893C15.8679 6.76032 15.5131 6.5339 15.2112 6.30078C15.1144 6.22605 15.0222 6.15132 14.937 6.07547C14.8517 6.00074 14.7733 5.9249 14.6996 5.84794C14.3263 5.46425 14.0705 5.02479 13.9369 4.53737C13.8608 4.26187 13.8216 3.97075 13.8216 3.66625C13.8216 3.29595 13.87 2.94795 13.9645 2.62337C14.1489 1.99207 14.513 1.44999 15.0545 1.00496C15.3149 0.79192 15.6006 0.612344 15.9117 0.466229C16.2735 0.295576 16.6698 0.172884 17.0962 0.0959227C17.4464 0.032346 17.8174 0 18.2115 0C19.207 0 20.3038 0.27996 21.4676 0.839881L21.6081 0.907919L20.1863 3.66068C19.7278 3.37514 19.3383 3.16991 19.0249 3.04387C18.723 2.92341 18.4396 2.86095 18.1815 2.86095C17.8497 2.86095 17.5847 2.9301 17.3957 3.0606C17.2206 3.18106 17.1376 3.34614 17.1376 3.56922C17.1376 3.72871 17.2552 3.90606 17.4902 4.10014C17.7621 4.31764 18.2161 4.57975 18.859 4.87644Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M29.9384 0C28.5858 0 27.3299 0.393729 26.2791 1.06742V0.405998H23.2834V18H26.2791V11.7695C27.3299 12.4432 28.5858 12.838 29.9384 12.838C33.6001 12.838 36.5681 9.9648 36.5681 6.41901C36.5681 2.8721 33.6001 0 29.9384 0ZM29.9384 9.93134C27.9313 9.93134 26.309 8.35531 26.309 6.41901C26.309 6.24167 26.3229 6.06767 26.3482 5.89813C26.3759 5.71632 26.4197 5.54009 26.475 5.36944C26.6547 4.81063 26.975 4.31206 27.3967 3.91275C27.6272 3.69414 27.8875 3.50564 28.1687 3.35283C28.4475 3.20114 28.7517 3.08403 29.0697 3.00818C29.3485 2.94126 29.6389 2.90668 29.9384 2.90668C31.9432 2.90668 33.5655 4.48271 33.5655 6.41901C33.5655 6.89416 33.4664 7.34812 33.2913 7.76193C33.2452 7.869 33.1945 7.97385 33.1369 8.07535C33.054 8.22258 32.9618 8.36423 32.8604 8.49808C32.2013 9.36696 31.139 9.93134 29.9384 9.93134Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M37.4069 6.40786C37.4069 2.86095 40.375 0 44.0366 0C44.4214 0 44.7994 0.0345768 45.1588 0.0914612L44.38 2.91783C44.2624 2.90668 44.1495 2.9011 44.032 2.9011C42.0249 2.9011 40.4026 4.46598 40.4026 6.40786V12.838H37.4069V6.40786Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M53.5721 9.02342C52.9292 9.5878 52.0789 9.93134 51.141 9.93134C49.6731 9.93134 48.4057 9.08588 47.8388 7.869H56.9088C57.5886 10.7132 60.2225 12.838 63.368 12.838C65.0802 12.838 66.6379 12.2101 67.8108 11.1817L65.7991 9.02342C65.1562 9.5878 64.3059 9.93134 63.368 9.93134C62.7297 9.93134 62.1283 9.77073 61.6052 9.48965C60.9277 9.12492 60.3861 8.55608 60.0658 7.869H69.8295C69.9401 7.40166 70 6.91536 70 6.41901C70 2.8721 67.032 0 63.368 0C60.6189 0 58.2592 1.61953 57.2545 3.92837C56.2498 1.61953 53.8924 0 51.141 0C47.4793 0 44.5113 2.8721 44.5113 6.41901C44.5113 9.95923 47.4793 12.838 51.141 12.838C52.8531 12.838 54.4109 12.2101 55.5838 11.1817L53.5721 9.02342ZM51.141 2.9011C52.6112 2.9011 53.8786 3.74656 54.4455 4.96233H47.8319C48.4103 3.74656 49.6731 2.9011 51.141 2.9011ZM66.6725 4.96233C66.1056 3.74656 64.8382 2.9011 63.368 2.9011C61.9001 2.9011 60.6373 3.74656 60.0589 4.96233H66.6725Z",
                fill: "white"
            })
        ]
    });
}


/* eslint-disable react/destructuring-assignment */ /* eslint-disable react/prop-types */ /* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $76ab1dfa1f4ba16c$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: props?.size || '15',
        height: props?.size || '15',
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M11.0368 11.0353V3.96425H3.96569",
                stroke: "white",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M3.96567 11.0349L11.0367 3.96387",
                stroke: "white",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}


/* eslint-disable react/prop-types */ 
parcelRequire("tZqWC");
function $6417d0fa9c066aa3$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: props?.size || '13',
        height: props?.size || '13',
        viewBox: "0 0 13 13",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M1 6.4209H12",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M6.5 11.4863L6.5 1.35475",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round"
            })
        ]
    });
}


/* eslint-disable react/prop-types */ 
parcelRequire("tZqWC");
function $8adab9613853c9a0$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: props?.size || '24',
        height: props?.size || '24',
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "feather feather-file-plus",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("polyline", {
                points: "14 2 14 8 20 8"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("line", {
                x1: "12",
                y1: "18",
                x2: "12",
                y2: "12"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("line", {
                x1: "9",
                y1: "15",
                x2: "15",
                y2: "15"
            })
        ]
    });
}


/* eslint-disable react/prop-types */ /* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $4244d0ab0887339f$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: props?.size || '30',
        height: props?.size || '31',
        viewBox: "0 0 30 31",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M28.9836 15.5C28.9836 23.2389 22.7574 29.5 15.0924 29.5C7.42732 29.5 1.20117 23.2389 1.20117 15.5C1.20117 7.76114 7.42732 1.5 15.0924 1.5C22.7574 1.5 28.9836 7.76114 28.9836 15.5Z",
                stroke: "#727F97",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M15.0921 16.5C17.2852 16.5 19.0631 14.7091 19.0631 12.5C19.0631 10.2909 17.2852 8.5 15.0921 8.5C12.899 8.5 11.1211 10.2909 11.1211 12.5C11.1211 14.7091 12.899 16.5 15.0921 16.5Z",
                stroke: "#727F97",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M23.0343 25.5V23.5C23.0343 22.4391 22.616 21.4217 21.8713 20.6716C21.1266 19.9214 20.1165 19.5 19.0633 19.5H11.1214C10.0682 19.5 9.05817 19.9214 8.31347 20.6716C7.56876 21.4217 7.15039 22.4391 7.15039 23.5V25.5",
                stroke: "#727F97",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}


/* eslint-disable react/prop-types */ /* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $e41fedd3ab89e73c$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: props?.size || '27',
        height: props?.size || '27',
        viewBox: "0 0 27 27",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M13.5 26C20.4036 26 26 20.4036 26 13.5C26 6.59644 20.4036 1 13.5 1C6.59644 1 1 6.59644 1 13.5C1 20.4036 6.59644 26 13.5 26Z",
                stroke: "#212123",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M9.96566 17.0357H17.0367V9.96459",
                stroke: "#212123",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M9.96604 9.96458L17.0371 17.0356",
                stroke: "#212123",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}


/* eslint-disable react/prop-types */ /* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $2232f33a3cdf9fa0$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("svg", {
        width: props?.size || '23',
        height: props?.size || '24',
        viewBox: "0 0 23 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
            d: "M7.07524 1.48828H3.74191C3.15254 1.48828 2.58731 1.73247 2.17056 2.16712C1.75381 2.60178 1.51968 3.1913 1.51968 3.80599V7.28255M21.5197 7.28255V3.80599C21.5197 3.1913 21.2856 2.60178 20.8688 2.16712C20.4521 1.73247 19.8868 1.48828 19.2975 1.48828H15.9641M15.9641 22.3477H19.2975C19.8868 22.3477 20.4521 22.1035 20.8688 21.6688C21.2856 21.2342 21.5197 20.6446 21.5197 20.0299V16.5534M1.51968 16.5534V20.0299C1.51968 20.6446 1.75381 21.2342 2.17056 21.6688C2.58731 22.1035 3.15254 22.3477 3.74191 22.3477H7.07524",
            stroke: "white",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
}


/* eslint-disable react/prop-types */ 
parcelRequire("tZqWC");
function $b36636a5d09c33a7$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: props?.size || '20',
        height: props?.size || '20',
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z",
                stroke: "#303D4B",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M19.0004 19L14.6504 14.65",
                stroke: "#303D4B",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}


/* eslint-disable react/prop-types */ /* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $4557f77f1cb1ac6e$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: props?.size || '27',
        height: props?.size || '27',
        viewBox: "0 0 27 27",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M13.5 26C20.4036 26 26 20.4036 26 13.5C26 6.59644 20.4036 1 13.5 1C6.59644 1 1 6.59644 1 13.5C1 20.4036 6.59644 26 13.5 26Z",
                stroke: "#212123",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M17.0355 17.0358V9.96473H9.96447",
                stroke: "#212123",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M9.96409 17.0357L17.0352 9.9646",
                stroke: "#212123",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}


/* eslint-disable react/prop-types */ /* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $e058efc2e539884c$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: props?.size || '23',
        height: props?.size || '23',
        viewBox: "0 0 23 23",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M11.5023 14.364C13.0839 14.364 14.3659 13.0819 14.3659 11.5004C14.3659 9.91881 13.0839 8.63672 11.5023 8.63672C9.92077 8.63672 8.63867 9.91881 8.63867 11.5004C8.63867 13.0819 9.92077 14.364 11.5023 14.364Z",
                stroke: "#727F97",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M18.5636 14.3636C18.4366 14.6515 18.3987 14.9709 18.4548 15.2806C18.511 15.5902 18.6586 15.8759 18.8786 16.1009L18.9359 16.1582C19.1134 16.3355 19.2542 16.546 19.3503 16.7778C19.4464 17.0096 19.4958 17.258 19.4958 17.5089C19.4958 17.7597 19.4464 18.0082 19.3503 18.2399C19.2542 18.4717 19.1134 18.6822 18.9359 18.8595C18.7586 19.037 18.5481 19.1779 18.3163 19.2739C18.0845 19.37 17.8361 19.4195 17.5852 19.4195C17.3343 19.4195 17.0859 19.37 16.8542 19.2739C16.6224 19.1779 16.4118 19.037 16.2345 18.8595L16.1773 18.8023C15.9523 18.5822 15.6666 18.4346 15.3569 18.3785C15.0473 18.3223 14.7279 18.3602 14.44 18.4873C14.1577 18.6083 13.9169 18.8092 13.7473 19.0653C13.5777 19.3214 13.4867 19.6215 13.4855 19.9286V20.0909C13.4855 20.5972 13.2843 21.0828 12.9263 21.4408C12.5683 21.7989 12.0827 22 11.5764 22C11.07 22 10.5845 21.7989 10.2264 21.4408C9.86841 21.0828 9.66727 20.5972 9.66727 20.0909V20.005C9.65988 19.689 9.55761 19.3826 9.37376 19.1256C9.18991 18.8685 8.93297 18.6727 8.63636 18.5636C8.34846 18.4366 8.02909 18.3987 7.71944 18.4548C7.40979 18.511 7.12406 18.6586 6.89909 18.8786L6.84182 18.9359C6.66451 19.1134 6.45396 19.2542 6.2222 19.3503C5.99044 19.4464 5.74202 19.4958 5.49114 19.4958C5.24025 19.4958 4.99183 19.4464 4.76007 19.3503C4.52831 19.2542 4.31776 19.1134 4.14045 18.9359C3.96295 18.7586 3.82214 18.5481 3.72607 18.3163C3.62999 18.0845 3.58054 17.8361 3.58054 17.5852C3.58054 17.3343 3.62999 17.0859 3.72607 16.8542C3.82214 16.6224 3.96295 16.4118 4.14045 16.2345L4.19773 16.1773C4.41779 15.9523 4.5654 15.6666 4.62155 15.3569C4.67769 15.0473 4.63979 14.7279 4.51273 14.44C4.39173 14.1577 4.19081 13.9169 3.93472 13.7473C3.67862 13.5777 3.37852 13.4867 3.07136 13.4855H2.90909C2.40277 13.4855 1.91718 13.2843 1.55916 12.9263C1.20114 12.5683 1 12.0827 1 11.5764C1 11.07 1.20114 10.5845 1.55916 10.2264C1.91718 9.86841 2.40277 9.66727 2.90909 9.66727H2.995C3.31095 9.65988 3.61737 9.55761 3.87442 9.37376C4.13148 9.18991 4.32727 8.93297 4.43636 8.63636C4.56343 8.34846 4.60133 8.02909 4.54519 7.71944C4.48904 7.40979 4.34142 7.12406 4.12136 6.89909L4.06409 6.84182C3.88659 6.66451 3.74578 6.45396 3.6497 6.2222C3.55363 5.99044 3.50418 5.74202 3.50418 5.49114C3.50418 5.24025 3.55363 4.99183 3.6497 4.76007C3.74578 4.52831 3.88659 4.31776 4.06409 4.14045C4.24139 3.96295 4.45194 3.82214 4.6837 3.72607C4.91546 3.62999 5.16389 3.58054 5.41477 3.58054C5.66566 3.58054 5.91408 3.62999 6.14584 3.72607C6.3776 3.82214 6.58815 3.96295 6.76545 4.14045L6.82273 4.19773C7.04769 4.41779 7.33342 4.5654 7.64307 4.62155C7.95272 4.67769 8.27209 4.63979 8.56 4.51273H8.63636C8.91869 4.39173 9.15947 4.19081 9.32907 3.93472C9.49867 3.67862 9.58968 3.37852 9.59091 3.07136V2.90909C9.59091 2.40277 9.79205 1.91718 10.1501 1.55916C10.5081 1.20114 10.9937 1 11.5 1C12.0063 1 12.4919 1.20114 12.8499 1.55916C13.208 1.91718 13.4091 2.40277 13.4091 2.90909V2.995C13.4103 3.30216 13.5013 3.60226 13.6709 3.85835C13.8405 4.11445 14.0813 4.31536 14.3636 4.43636C14.6515 4.56343 14.9709 4.60133 15.2806 4.54519C15.5902 4.48904 15.8759 4.34142 16.1009 4.12136L16.1582 4.06409C16.3355 3.88659 16.546 3.74578 16.7778 3.6497C17.0096 3.55363 17.258 3.50418 17.5089 3.50418C17.7597 3.50418 18.0082 3.55363 18.2399 3.6497C18.4717 3.74578 18.6822 3.88659 18.8595 4.06409C19.037 4.24139 19.1779 4.45194 19.2739 4.6837C19.37 4.91546 19.4195 5.16389 19.4195 5.41477C19.4195 5.66566 19.37 5.91408 19.2739 6.14584C19.1779 6.3776 19.037 6.58815 18.8595 6.76545L18.8023 6.82273C18.5822 7.04769 18.4346 7.33342 18.3785 7.64307C18.3223 7.95272 18.3602 8.27209 18.4873 8.56V8.63636C18.6083 8.91869 18.8092 9.15947 19.0653 9.32907C19.3214 9.49867 19.6215 9.58968 19.9286 9.59091H20.0909C20.5972 9.59091 21.0828 9.79205 21.4408 10.1501C21.7989 10.5081 22 10.9937 22 11.5C22 12.0063 21.7989 12.4919 21.4408 12.8499C21.0828 13.208 20.5972 13.4091 20.0909 13.4091H20.005C19.6978 13.4103 19.3977 13.5013 19.1416 13.6709C18.8856 13.8405 18.6846 14.0813 18.5636 14.3636V14.3636Z",
                stroke: "#727F97",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}


/* eslint-disable react/prop-types */ 
parcelRequire("tZqWC");
function $1342190f9cc1e022$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: props?.size || '25',
        height: props?.size || '25',
        viewBox: "0 0 25 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("circle", {
                cx: "12.5",
                cy: "12.5",
                r: "12.5",
                fill: "#00C481"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M18.75 7.8125L10.1562 16.4062L6.25 12.5",
                stroke: "white",
                strokeWidth: "3",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}


/* eslint-disable react/prop-types */ 
parcelRequire("tZqWC");
function $1191a6d6a91e21fc$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: props?.size || '24',
        height: props?.size || '24',
        fill: "none",
        viewBox: "0 0 24 24",
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("g", {
            id: "24 / basic / menu",
            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                id: "icon",
                fill: "#fff",
                fillRule: "evenodd",
                d: "M22 8V5H2v3zm0 3v3H2v-3zm0 6v3H2v-3z",
                clipRule: "evenodd"
            })
        })
    });
}


/* eslint-disable react/prop-types */ 
parcelRequire("tZqWC");
function $bacab6cf84c015d6$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: props?.size || '24',
        height: props?.size || '24',
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "#727F97",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "feather feather-user",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("circle", {
                cx: "12",
                cy: "7",
                r: "4"
            })
        ]
    });
}


/* eslint-disable react/prop-types */ /* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $35f1f2050cee5a12$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: props?.size || '3',
        height: props?.size || '13',
        viewBox: "0 0 3 13",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("ellipse", {
                cx: "1.48911",
                cy: "1.5",
                rx: "1.48911",
                ry: "1.5",
                fill: "#727F97"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("ellipse", {
                cx: "1.48911",
                cy: "6.5",
                rx: "1.48911",
                ry: "1.5",
                fill: "#727F97"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("ellipse", {
                cx: "1.48911",
                cy: "11.5",
                rx: "1.48911",
                ry: "1.5",
                fill: "#727F97"
            })
        ]
    });
}


/* eslint-disable max-len */ /* eslint-disable react/prop-types */ 
parcelRequire("tZqWC");
function $8c8be8322e8f63e7$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: props?.size || 24,
        height: props?.size || 24,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: props?.color || '#e9e9e9',
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        ...props,
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
            d: "M13 2 3 14h9l-1 8 10-12h-9l1-8z"
        })
    });
}


/* eslint-disable react/prop-types */ /* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $e077a6e0b1eee790$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: props?.size || '25',
        height: props?.size || '25',
        viewBox: "0 0 25 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M24.5 12.5001C24.5 19.127 19.1275 24.5 12.5001 24.5C5.8729 24.5 0.5 19.127 0.5 12.5001C0.5 5.8726 5.87289 0.5 12.5001 0.5C19.1276 0.5 24.5 5.87249 24.5 12.5001Z",
                fill: "#00CACD",
                fillOpacity: "0.1",
                stroke: "#00CACD"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M9 13H18.125",
                stroke: "#00CACD",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M14.4746 16.5L18.1246 13L14.4746 9.5",
                stroke: "#00CACD",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("circle", {
                cx: "6",
                cy: "13",
                r: "2",
                fill: "#00CACD"
            })
        ]
    });
}


/* eslint-disable react/prop-types */ /* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $88ea5362fe9c0bb7$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: props?.size || '25',
        height: props?.size || '25',
        viewBox: "0 0 25 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M24.5 12.5001C24.5 19.127 19.1275 24.5 12.5001 24.5C5.8729 24.5 0.5 19.127 0.5 12.5001C0.5 5.8726 5.87289 0.5 12.5001 0.5C19.1276 0.5 24.5 5.87249 24.5 12.5001Z",
                fill: "#00CACD",
                fillOpacity: "0.1",
                stroke: "#00CACD"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M4 13H13.125",
                stroke: "#00CACD",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M9.47461 16.5L13.1246 13L9.47461 9.5",
                stroke: "#00CACD",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("circle", {
                cx: "18",
                cy: "13",
                r: "2",
                fill: "#00CACD"
            })
        ]
    });
}


/* eslint-disable max-len */ /* eslint-disable react/prop-types */ 
parcelRequire("tZqWC");
function $132b84168f6c7aad$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: props?.size || 50,
        height: props?.size || 50,
        viewBox: "0 0 375 375",
        ...props,
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("clipPath", {
                        id: "a",
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                            d: "M53.063 69H322v268.5H53.062Zm0 0"
                        })
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("clipPath", {
                        id: "b",
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                            d: "M162 37.5h123V160H162Zm0 0"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("g", {
                clipPath: "url(#a)",
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                    fill: props?.color || '#b1b3b8',
                    d: "m318.652 309.129-66.718-66.91c.035-.031.066-.063.097-.094 9.602-13.34 15.953-28.3 18.918-44.48 2.875-15.633 2.301-32.032-1.656-47.348a7.933 7.933 0 0 0-4.723-5.39c-2.394-.958-5.011-.766-7.242.605-3.031 1.851-4.5 5.39-3.605 8.836 4.02 15.605 3.957 32.132-.192 47.765-4.277 16.114-12.828 30.887-24.695 42.692-17.805 17.707-41.414 27.468-66.461 27.504h-.129c-25.016 0-48.434-9.7-65.95-27.313-36.312-36.469-35.894-95.941.891-132.539 14.743-14.68 33.407-23.867 53.958-26.644 4.242-.575 7.273-4.372 6.89-8.676-.191-2.203-1.277-4.18-3-5.586-1.722-1.371-3.89-1.977-6.062-1.656-23.993 3.285-45.786 14.07-63.047 31.234-20.867 20.773-32.45 48.34-32.672 77.66-.191 29.324 11.008 56.86 31.621 77.566a108.71 108.71 0 0 0 69.266 31.747 110.433 110.433 0 0 0 72.813-20.773c.03-.032.062-.063.093-.063l66.621 66.812c2.074 2.106 4.883 3.254 7.848 3.285a11.278 11.278 0 0 0 8.136-3.316l8.934-8.934c2.14-2.14 3.32-4.98 3.351-8.008-.03-3-1.18-5.84-3.285-7.976Zm0 0"
                })
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("g", {
                clipPath: "url(#b)",
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                    fill: props?.color || '#b1b3b8',
                    d: "m280.969 93.824-6.606-2.457c-5.008-1.851-9.824-4.277-14.324-7.148a75.566 75.566 0 0 1-12.348-9.953 74.374 74.374 0 0 1-9.953-12.348 73.13 73.13 0 0 1-7.148-14.328l-2.457-6.606c-.735-2.007-2.68-3.379-4.883-3.379-2.168 0-4.148 1.372-4.879 3.415l-2.457 6.601c-1.851 5.012-4.277 9.828-7.148 14.328a75.566 75.566 0 0 1-9.953 12.348 74.573 74.573 0 0 1-12.348 9.953 73.238 73.238 0 0 1-14.328 7.148l-6.606 2.457c-2.039.766-3.414 2.711-3.414 4.883 0 2.168 1.375 4.145 3.414 4.88l6.606 2.456c5.008 1.852 9.828 4.278 14.328 7.149a75.361 75.361 0 0 1 12.347 9.953 74.574 74.574 0 0 1 9.954 12.347 73.347 73.347 0 0 1 7.148 14.329l2.457 6.605c.766 2.04 2.711 3.41 4.879 3.41 2.172 0 4.148-1.37 4.883-3.41l2.457-6.605c1.851-5.012 4.273-9.829 7.148-14.329a75.361 75.361 0 0 1 9.953-12.347 74.413 74.413 0 0 1 12.348-9.953 73.424 73.424 0 0 1 14.324-7.149l6.606-2.457c2.043-.765 3.414-2.71 3.414-4.879a5.277 5.277 0 0 0-3.414-4.914Zm-27.278 4.914c-.703.446-1.437.86-2.14 1.34a88.733 88.733 0 0 0-14.93 12.027 88.628 88.628 0 0 0-12.031 14.934c-.445.7-.89 1.402-1.34 2.137-.445-.703-.86-1.438-1.34-2.137a88.606 88.606 0 0 0-12.027-14.934 88.606 88.606 0 0 0-14.934-12.027c-.699-.45-1.402-.894-2.137-1.34.704-.449 1.438-.863 2.137-1.343a88.606 88.606 0 0 0 14.934-12.028 88.606 88.606 0 0 0 12.027-14.933c.45-.7.895-1.403 1.34-2.137.45.703.863 1.437 1.34 2.137a88.628 88.628 0 0 0 12.031 14.933 88.733 88.733 0 0 0 14.93 12.028c.703.449 1.406.894 2.14 1.343Zm0 0"
                })
            })
        ]
    });
}


/* eslint-disable react/prop-types */ 
parcelRequire("tZqWC");
function $2d68211da31cd8b8$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: props?.size || '22',
        height: props?.size || '22',
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21Z",
                stroke: "white",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M11 7L7 11L11 15",
                stroke: "white",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M15 11H7",
                stroke: "white",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}


/* eslint-disable react/prop-types */ 
parcelRequire("tZqWC");
function $738b185bd23471f4$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: props?.size || '22',
        height: props?.size || '22',
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21Z",
                stroke: "white",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M11 15L15 11L11 7",
                stroke: "white",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M7 11H15",
                stroke: "white",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}


/* eslint-disable react/destructuring-assignment */ /* eslint-disable react/prop-types */ 
parcelRequire("tZqWC");
function $9cadc73f9b5b2fc9$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: props?.size || '22',
        height: props?.size || '22',
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M11 7L7 11L11 15",
                stroke: "white",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M15 11H7",
                stroke: "white",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}


/* eslint-disable react/destructuring-assignment */ /* eslint-disable react/prop-types */ 
parcelRequire("tZqWC");
function $ce96cd4d0e43c777$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: props?.size || '22',
        height: props?.size || '22',
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M11 15L15 11L11 7",
                stroke: "white",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M7 11H15",
                stroke: "white",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}


/* eslint-disable react/prop-types */ 
parcelRequire("tZqWC");
function $4319efa3b26da07e$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("svg", {
        width: props?.size || '14',
        height: props?.size || '8',
        viewBox: "0 0 14 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
            d: "M1 1L6.85858 6.85858C6.93668 6.93668 7.06332 6.93668 7.14142 6.85858L13 1",
            stroke: "#727F97",
            strokeLinecap: "round"
        })
    });
}


/* eslint-disable react/prop-types */ 
parcelRequire("tZqWC");
function $5e06cd459ff3823a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: props?.size || '16',
        height: props?.size || '15',
        viewBox: "0 0 16 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M1.75 13.75L14.25 1.25",
                stroke: "#727F97",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M1.75 1.25H14.25V13.75",
                stroke: "#727F97",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}


/* eslint-disable react/prop-types */ 
parcelRequire("tZqWC");
function $233d6aa1443d2fba$var$ArrowRight2Icon(props) {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: props?.size || 24,
        height: props?.size || 24,
        viewBox: "0 0 24 24",
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
            stroke: "#292D32",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: 10,
            strokeWidth: 1.5,
            d: "m8.91 19.92 6.52-6.52c.77-.77.77-2.03 0-2.8L8.91 4.08"
        })
    });
}
var $233d6aa1443d2fba$export$2e2bcd8739ae039 = $233d6aa1443d2fba$var$ArrowRight2Icon;


/* eslint-disable react/prop-types */ /* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $19d59dfd9935476a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: props?.size || '14',
        height: props?.size || '18',
        viewBox: "0 0 14 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M13 17V10",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M7 17V1",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M1 17V6",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}


/* eslint-disable react/prop-types */ /* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $d66df05e45dee7de$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: props?.size || '24',
        height: props?.size || '21',
        viewBox: "0 0 24 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M13.4344 20C18.7171 20 22.9996 15.7467 22.9996 10.5C22.9996 5.25329 18.7171 1 13.4344 1C8.15163 1 3.86914 5.25329 3.86914 10.5C3.86914 15.7467 8.15163 20 13.4344 20Z",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M5.78261 20C8.42397 20 10.5652 17.8734 10.5652 15.25C10.5652 12.6266 8.42397 10.5 5.78261 10.5C3.14125 10.5 1 12.6266 1 15.25C1 17.8734 3.14125 20 5.78261 20Z",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}


/* eslint-disable react/prop-types */ /* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $6873fe941a1f44db$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: props?.size || '24',
        height: props?.size || '20',
        viewBox: "0 0 24 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M17 19V17C17 15.9391 16.5786 14.9217 15.8284 14.1716C15.0783 13.4214 14.0609 13 13 13H5C3.93913 13 2.92172 13.4214 2.17157 14.1716C1.42143 14.9217 1 15.9391 1 17V19",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M9 9C11.2091 9 13 7.20914 13 5C13 2.79086 11.2091 1 9 1C6.79086 1 5 2.79086 5 5C5 7.20914 6.79086 9 9 9Z",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M23 18.9999V16.9999C22.9993 16.1136 22.7044 15.2527 22.1614 14.5522C21.6184 13.8517 20.8581 13.3515 20 13.1299",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M16 1.12988C16.8604 1.35018 17.623 1.85058 18.1676 2.55219C18.7122 3.2538 19.0078 4.11671 19.0078 5.00488C19.0078 5.89305 18.7122 6.75596 18.1676 7.45757C17.623 8.15918 16.8604 8.65958 16 8.87988",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}


/* eslint-disable react/prop-types */ /* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $13f215a46c77bbdb$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: props?.size || '20',
        height: props?.size || '20',
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M15.5 18.25C17.0188 18.25 18.25 17.0188 18.25 15.5C18.25 13.9812 17.0188 12.75 15.5 12.75C13.9812 12.75 12.75 13.9812 12.75 15.5C12.75 17.0188 13.9812 18.25 15.5 18.25Z",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M4.5 7.25C6.01878 7.25 7.25 6.01878 7.25 4.5C7.25 2.98122 6.01878 1.75 4.5 1.75C2.98122 1.75 1.75 2.98122 1.75 4.5C1.75 6.01878 2.98122 7.25 4.5 7.25Z",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M10.916 4.5H13.666C14.1522 4.5 14.6186 4.69315 14.9624 5.03697C15.3062 5.38079 15.4993 5.8471 15.4993 6.33333V12.75",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M4.5 7.25V18.25",
                stroke: "white",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}





const $56f847eb01f717d3$export$bfe2969d9faaaa94 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  min-height: 100vh;
  background: ${({ theme: theme })=>theme.colors.brand};
  background: ${({ theme: theme })=>`linear-gradient(25deg, ${theme.colors.backgroundLite} 65%, ${theme.colors.brand} 130%)`};
`;
const $56f847eb01f717d3$export$6aac6cd983aa9a8d = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const $56f847eb01f717d3$export$c316e7f3abbfa73a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  flex: 1;
  display: flex;
  justify-content: center;
`;
const $56f847eb01f717d3$export$1d8d8cae37810421 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  max-width: 500px;
  width: 100%;
`;
const $56f847eb01f717d3$export$cac169cfa0d556b7 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 40px;
  width: 100%;

  border-radius: 10px;
`;
const $56f847eb01f717d3$export$842695ea3d5549d = (0, $a778141486c79bc3$export$2e2bcd8739ae039).a`
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
  & svg {
    width: 150px;
    height: 50px;
    & path {
      fill: ${({ theme: theme })=>theme.colors.primary};
    }
  }
`;
const $56f847eb01f717d3$export$23f1dea7e159c283 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h1`
  display: flex;
  justify-content: center;
  font-size: 18px;
  color: ${({ theme: theme })=>theme.colors.primary};
  margin: 0 0 30px 0;
`;
const $56f847eb01f717d3$export$4008c5a771d31562 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  min-height: 100vh;
`;
const $56f847eb01f717d3$export$e33979aaf48f984a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  align-self: center;

  //TODO: Style Variable
  color: ${({ theme: theme })=>theme.colors.background};
`;
const $56f847eb01f717d3$export$fdd773f48aebb8ab = (0, $a778141486c79bc3$export$2e2bcd8739ae039).a`
  display: block;
  margin: 20px 0px 0px 0px;
  width: 100%;

  font-weight: 400;
  font-size: 12px;
  text-decoration: underline;
  text-align: center;

  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $56f847eb01f717d3$export$3f9c8c13edb92928 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  display: flex;
  justify-content: flex-end;
  margin: 5px 0 0 0;

  font-size: 12px;
  color: ${({ theme: theme })=>theme.colors.primary};
  text-align: right;
  margin-top: 30px;
`;
const $56f847eb01f717d3$export$fb3d2bca71e46662 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).a`
  font-weight: 500;
  color: ${({ theme: theme })=>theme.colors.primary};
`;


/* eslint-disable max-len */ // Common

parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $be1298c1561b3bf4$export$6cd5d5c1dae69a36 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: 100%;
  height: 100%;
  min-height: 100vh;

  padding: 50px 0 0 80px;
  /* overflow-x: hidden; */
  background-color: ${({ theme: theme })=>theme.colors.backgroundLite};
`;


function $6089f7d2f7406f87$var$App(props) {
    // Destructure
    const { children: children } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $be1298c1561b3bf4$export$6cd5d5c1dae69a36), {
        children: children
    });
}
// Default Props
$6089f7d2f7406f87$var$App.defaultProps = {
    children: ''
};
// Proptypes Validation
$6089f7d2f7406f87$var$App.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ])
};
var $6089f7d2f7406f87$export$2e2bcd8739ae039 = $6089f7d2f7406f87$var$App;


var $7873b6261a2b1051$export$2e2bcd8739ae039 = (0, $6089f7d2f7406f87$export$2e2bcd8739ae039);


/* eslint-disable jsx-a11y/click-events-have-key-events */ /* eslint-disable jsx-a11y/anchor-is-valid */ /* eslint-disable jsx-a11y/no-static-element-interactions */ 

var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");





const $72532679acd937a3$export$960a49cc3d27a090 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div.attrs(({ theme: theme })=>({
        display: theme.layout.header || theme.layout.header === undefined ? 'block' : 'none'
    }))`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 4;

  padding: 0 100px;
  height: fit-content;
  width: 100%;
  background-color: ${({ theme: theme })=>theme.colors.backgroundLite};
  border-bottom: 1px solid ${({ theme: theme })=>theme.colors.borderColor};
  line-height: unset;
  font-weight: 500;

  // Themed Properties
  display: ${({ display: display })=>display};
  display: flex;
  align-items: flex-end;
  justify-content: 'space-between';
  height: 50px;
`;
const $72532679acd937a3$export$daae9aa8d814389a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  line-height: unset;
  padding: 12px ;
`;
const $72532679acd937a3$export$edb76fdb8665f52 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 10px;

  & button {
    font-size: 20px;
    font-weight: 600;
    color: ${({ theme: theme })=>theme.colors.primary};

    padding: 0;
    background: transparent;
    border: 0px;
    & svg {
      max-width: none !important;
      max-height: none !important;
    }
    & svg > path {
      stroke: ${({ theme: theme })=>theme.colors.brand};
    }
  }
  & button:hover {
    background: transparent;
    border: 0px;
    & svg > path {
      stroke: ${({ theme: theme })=>theme.colors.brand};
    }
  }

  font-size: 16px;
  font-weight: 600; 
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $72532679acd937a3$export$93cda7378d158ea0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  & svg path {
    stroke: ${({ theme: theme })=>theme.colors.secondary};
  }
`;
const $72532679acd937a3$export$6eaa4d78e3725d73 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  flex: 1;
  height: 100%;
  display: flex;
  justify-content: flex-start;  
  align-items: flex-end;
  background-color: ${({ theme: theme })=>theme.colors.backgroundLite};
`;
const $72532679acd937a3$export$8589018110795d47 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  max-width: 1080px;
 
`;


// Common

parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $a1d1bb5849939e9b$export$1312e4658e616d9d = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0px 24px 24px 24px;
  max-width: 1440px;
  height: 100%;
`;


function $3f5354c803b4cbf9$var$Container(props) {
    // Destructure
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a1d1bb5849939e9b$export$1312e4658e616d9d), {
        ...rest,
        children: children
    });
}
// Default Props
$3f5354c803b4cbf9$var$Container.defaultProps = {
    children: ''
};
// Proptypes Validation
$3f5354c803b4cbf9$var$Container.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ])
};
var $3f5354c803b4cbf9$export$2e2bcd8739ae039 = $3f5354c803b4cbf9$var$Container;


var $d9a5995c1b70ae93$export$2e2bcd8739ae039 = (0, $3f5354c803b4cbf9$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $160bf94c41225418$export$4a6e9fd3dfec8158 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  margin: 0 auto;
  padding: 0px 20px;
`;


function $c3dcb4cae378007b$var$ContainerFluid(props) {
    // Destructure
    const { children: children } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $160bf94c41225418$export$4a6e9fd3dfec8158), {
        children: children
    });
}
// Default Props
$c3dcb4cae378007b$var$ContainerFluid.defaultProps = {
    children: ''
};
// Proptypes Validation
$c3dcb4cae378007b$var$ContainerFluid.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ])
};
var $c3dcb4cae378007b$export$2e2bcd8739ae039 = $c3dcb4cae378007b$var$ContainerFluid;


var $57ef4024e9f043d0$export$2e2bcd8739ae039 = (0, $c3dcb4cae378007b$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $d49bca50a279c44c$export$75f07c36086c2c81 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).img`
  width: 100%;
  height: 100%;

  font-weight: inherit;
  font-size: inherit;

  // Conditional Props
  ${({ width: width })=>width && `width:${width}px;`}
  ${({ height: height })=>height && `height:${height}px;`}
`;


function $c135de98a880dc0a$var$Image(props) {
    // Destructure
    const { src: src, alt: alt, width: width, height: height, ...rest } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d49bca50a279c44c$export$75f07c36086c2c81), {
        src: src,
        alt: alt,
        width: width,
        height: height,
        ...rest
    });
}
// Default Props
$c135de98a880dc0a$var$Image.defaultProps = {
    src: null,
    alt: '',
    width: '',
    height: ''
};
// Proptypes Validation
$c135de98a880dc0a$var$Image.propTypes = {
    src: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    alt: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    width: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number
    ]),
    height: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number
    ])
};
var $c135de98a880dc0a$export$2e2bcd8739ae039 = $c135de98a880dc0a$var$Image;


var $65f0d7ff3fd922b2$export$2e2bcd8739ae039 = (0, $c135de98a880dc0a$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $90d8a7fe28bd27db$export$e620df7ec292c807 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  width: fit-content;
  color: ${({ theme: theme })=>theme.colors.primary} !important;
  font-size: 14px;
  border-radius: 10px;
  background-color: ${({ theme: theme })=>`${theme.colors.background}`};
`;
const $90d8a7fe28bd27db$export$9456d3a121d4b39 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 8px;
  padding: 4px;
  border-radius: 10px;
  background-color: ${({ theme: theme })=>`${theme.colors.secondary}20`};
`;
const $90d8a7fe28bd27db$export$47d673d6549649b6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $90d8a7fe28bd27db$export$6d702cd3660ac20b = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 8px 24px;
  border-radius: 7px;
  font-weight: 600;
  cursor: pointer;
  &.active {
    background-color: ${({ theme: theme })=>theme.colors.backgroundLite};
    color: ${({ theme: theme })=>theme.colors.brand};
  }
`;


function $6615b71bf0a9dcf3$var$Tabs(props) {
    // Destructure
    const { page: page, setPage: setPage, pages: pages } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $90d8a7fe28bd27db$export$e620df7ec292c807), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $90d8a7fe28bd27db$export$9456d3a121d4b39), {
            children: pages && pages?.map((item)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $90d8a7fe28bd27db$export$47d673d6549649b6), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $90d8a7fe28bd27db$export$6d702cd3660ac20b), {
                        className: page === item.value && 'active',
                        onClick: ()=>{
                            setPage(item.value);
                        },
                        children: item.label
                    })
                }, item.value))
        })
    });
}
// Default Props
$6615b71bf0a9dcf3$var$Tabs.defaultProps = {
    page: '',
    setPage: ()=>{},
    pages: []
};
// Proptypes Validation
$6615b71bf0a9dcf3$var$Tabs.propTypes = {
    page: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    setPage: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    pages: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        value: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        label: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    }))
};
var $6615b71bf0a9dcf3$export$2e2bcd8739ae039 = $6615b71bf0a9dcf3$var$Tabs;


var $9943dd893d8bba32$export$2e2bcd8739ae039 = (0, $6615b71bf0a9dcf3$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

var $krg3S = parcelRequire("krg3S");
function $46830b05731d72d3$var$Form(props) {
    // Destructure
    const { children: children, initialValues: initialValues, onSubmit: onSubmit, validationSchema: validationSchema, formRef: formRef, autoComplete: autoComplete, ...rest } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $krg3S.Formik), {
        autoComplete: "off",
        initialValues: initialValues,
        onSubmit: onSubmit,
        validationSchema: validationSchema,
        innerRef: formRef,
        ...rest,
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $krg3S.Form), {
            autoComplete: "off",
            children: children
        })
    });
}
// Default Props
$46830b05731d72d3$var$Form.defaultProps = {
    children: '',
    initialValues: {},
    onSubmit: ()=>{},
    validationSchema: {},
    formRef: /*#__PURE__*/ (0, $tZqWC.createRef)(),
    autoComplete: 'on'
};
// Proptypes Validation
$46830b05731d72d3$var$Form.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ]),
    initialValues: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        root: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    }),
    onSubmit: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    validationSchema: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        root: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    }),
    formRef: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        root: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    }),
    autoComplete: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
};
var $46830b05731d72d3$export$2e2bcd8739ae039 = $46830b05731d72d3$var$Form;


var $506ef65bbb4994b7$export$2e2bcd8739ae039 = (0, $46830b05731d72d3$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $57e87faffac03b42$export$6aa22a823032b784 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  border-radius: 5px;

  // Themed Properties
  border: 1px solid ${({ theme: theme })=>theme.colors.borderColor};
  background-color: ${({ theme: theme })=>theme.colors.background};
`;
const $57e87faffac03b42$export$5665775b26e26c5d = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  padding: 15px 15px 15px 20px;

  // Themed Properties
  border-bottom: 1px solid ${({ theme: theme })=>theme.colors.borderColor};
`;
const $57e87faffac03b42$export$fc7d07610936a2e3 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: table-cell;
  width: 30px;
  min-width: 30px;
  vertical-align: middle;
`;
const $57e87faffac03b42$export$3d29e566b93fc027 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: table-cell;
  font-weight: 500;
  white-space: nowrap;
  padding-left: 10px;
  vertical-align: middle;

  // Themed Properties
  color: ${({ theme: theme })=>theme.colors.primary};

  // Responsive Properties
  ${({ theme: theme })=>theme.functions.mediaQuery('font-size', [
        '14px',
        '14px',
        '14px',
        '14px',
        '14px',
        '14px',
        '17px',
        '17px'
    ])}
`;
const $57e87faffac03b42$export$851de33184ecdac4 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  display: flex;
  align-items: center;
  padding: 15px;
`;
const $57e87faffac03b42$export$e9897d434e0741ee = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;


function $0620e7d3969b2377$var$Card(props) {
    // Destructure
    const { children: children, titleIcon: titleIcon, title: title, footer: footer } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $57e87faffac03b42$export$6aa22a823032b784), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $57e87faffac03b42$export$5665775b26e26c5d), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $57e87faffac03b42$export$fc7d07610936a2e3), {
                        children: titleIcon
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $57e87faffac03b42$export$3d29e566b93fc027), {
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $57e87faffac03b42$export$851de33184ecdac4), {
                children: children
            }),
            footer && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $57e87faffac03b42$export$e9897d434e0741ee), {
                children: footer
            })
        ]
    });
}
// Default Props
$0620e7d3969b2377$var$Card.defaultProps = {
    title: '',
    titleIcon: '',
    footer: '',
    children: ''
};
// Proptypes Validation
$0620e7d3969b2377$var$Card.propTypes = {
    title: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    titleIcon: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ]),
    footer: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ]),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ])
};
var $0620e7d3969b2377$export$2e2bcd8739ae039 = $0620e7d3969b2377$var$Card;


var $fda44ae20bb64b6c$export$2e2bcd8739ae039 = (0, $0620e7d3969b2377$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $e71f38b40042922b$export$e6dfd72ab29f8598 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;

  border-radius: 10px;
  width: 100%;
  transition: 0.3s;
  cursor: pointer;

  background-color: ${({ theme: theme })=>theme.colors.background};
  border: 1px solid ${({ active: active, theme: theme })=>active ? theme.colors.brand : theme.colors.secondary};
  color: ${({ theme: theme })=>theme.colors.primary};
  padding: 20px;

  &:hover {
    border: 1px solid ${({ theme: theme })=>theme.colors.brand};
  }
`;
const $e71f38b40042922b$export$35e09ba17cc51c69 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  gap: 16px;

  & svg path {
    stroke: ${({ theme: theme })=>theme.colors.primary};
  }
`;
const $e71f38b40042922b$export$f99233281efd08a0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 15px;
  font-weight: 500;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $e71f38b40042922b$export$8f314e512d92575f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 7px;
  border-radius: 100%;
  border: 1px solid ${({ theme: theme })=>theme.colors.primary};
  height: 35px;
  width: 35px;
`;
const $e71f38b40042922b$export$d7a54cba636a8cd6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding-top: 30px;
  width: 100%;
`;
const $e71f38b40042922b$export$2580bc860330613c = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 60px;
`;
const $e71f38b40042922b$export$5ec4077fbf8c4ba6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 0;
`;
const $e71f38b40042922b$export$2b4a904504ac8010 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  color: ${({ theme: theme })=>theme.colors.secondary};
  font-size: 12px;
`;
const $e71f38b40042922b$export$4354e6bdd4f3551a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  color: ${({ theme: theme })=>theme.colors.brand};
  font-size: 20px !important;
  font-weight: 600 !important;
`;


function $2e45d4d2cf64e7ff$var$CardInfo(props) {
    // Destructure
    const { title: title, icon: icon, data: data, active: active, ...rest } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $e71f38b40042922b$export$e6dfd72ab29f8598), {
        active: active,
        ...rest,
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $e71f38b40042922b$export$35e09ba17cc51c69), {
                children: [
                    icon && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e71f38b40042922b$export$8f314e512d92575f), {
                        children: icon
                    }),
                    title && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e71f38b40042922b$export$f99233281efd08a0), {
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e71f38b40042922b$export$d7a54cba636a8cd6), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e71f38b40042922b$export$2580bc860330613c), {
                children: data && data?.map((item)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $e71f38b40042922b$export$5ec4077fbf8c4ba6), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $e71f38b40042922b$export$2b4a904504ac8010), {
                                children: [
                                    item?.label,
                                    ": "
                                ]
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e71f38b40042922b$export$4354e6bdd4f3551a), {
                                children: item?.value
                            })
                        ]
                    }, item?.label))
            })
        ]
    });
}
// Default Props
$2e45d4d2cf64e7ff$var$CardInfo.defaultProps = {
    title: '',
    data: [],
    active: false
};
// Proptypes Validation
$2e45d4d2cf64e7ff$var$CardInfo.propTypes = {
    title: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
    data: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({})),
    active: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
};
var $2e45d4d2cf64e7ff$export$2e2bcd8739ae039 = $2e45d4d2cf64e7ff$var$CardInfo;


var $97b5b998d9c9faaf$export$2e2bcd8739ae039 = (0, $2e45d4d2cf64e7ff$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $ba9a4b3ec47cf4f4$export$89d116ece15bc5b6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).span`
  display: flex;
  cursor: pointer;
  padding: 6px;

  // TODO: Use theme function
  &:hover {
    background-color: #e9e9e9;
    border-radius: 50%;
  }
`;


function $aa172c93a6433d02$var$IconButton(props) {
    // Destructure
    const { children: children, onClick: onClick } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ba9a4b3ec47cf4f4$export$89d116ece15bc5b6), {
        onClick: onClick,
        children: children
    });
}
// Default Props
$aa172c93a6433d02$var$IconButton.defaultProps = {
    onClick: ()=>{},
    children: ''
};
// Proptypes Validation
$aa172c93a6433d02$var$IconButton.propTypes = {
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ])
};
var $aa172c93a6433d02$export$2e2bcd8739ae039 = $aa172c93a6433d02$var$IconButton;


var $1ae7df2396c7235c$export$2e2bcd8739ae039 = (0, $aa172c93a6433d02$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");



const $aaf622d5f68ae696$export$3e5e12dc01f20a43 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  gap: 20px;
  padding: 10px;

  * {
    color: ${({ theme: theme })=>theme.colors.primary} !important;
    font-size: 13px !important;
    min-height: 0 !important;
  }
`;
const $aaf622d5f68ae696$export$92df4ffe22cfff47 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  gap: 10px;
`;
const $aaf622d5f68ae696$export$2ee8f3d9e1be0b9a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  gap: 5px;
`;
const $aaf622d5f68ae696$export$6e8f258e6fada449 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: 100%;
`;
const $aaf622d5f68ae696$export$a2c8d9fea6ba956e = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: fit-content;
  padding: 5px 10px;
  border-radius: 8px;
  border: 1px solid ${({ theme: theme })=>theme.colors.secondary};
`;
const $aaf622d5f68ae696$export$bd55427d3650a1b0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-end;
  text-align: end;
  padding: 5px 10px;
`;



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $d885bb434a8631da$export$d53c836cccbb0d90 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).button`
  cursor: pointer;
  width: fit-content;
  height: fit-content;
  font-weight: 400;
  font-size: 16px;
  padding: 5px 15px;
  border-radius: 7px;
  transition: 0.3s;

  display: flex;
  justify-content: center;
  align-items: center;
  gap: 7px;
  /*-------------------------------
    Events Properties
  -------------------------------*/
  &:focus {
    outline: none;
  }
  &:hover {
    color: ${({ theme: theme })=>theme.colors.primary};
    background: transparent;
    border: 1px solid ${({ theme: theme })=>`${theme.colors.brand}40`};
    & svg > path {
      stroke: ${({ theme: theme })=>theme.colors.brand};
      ${({ theme: theme, variant: variant })=>variant === 'outlined' && `stroke: ${theme.colors.primary} ;`}
      ${({ theme: theme, color: color })=>color === 'default' && `stroke: ${theme.colors.background} ;`}
      ${({ theme: theme, color: color })=>color === 'primary' && `stroke: ${theme.colors.brand} ;`}
      ${({ theme: theme, color: color })=>color === 'secondary' && `stroke: ${theme.colors.red} ;`}
      ${({ theme: theme, color: color })=>color === 'secondary-default' && `stroke: ${theme.colors.background} ;`}
      ${({ theme: theme, color: color })=>color === 'tertiary' && `stroke: ${theme.colors.background} ;`}
    }
    & svg > line {
      stroke: ${({ theme: theme })=>theme.colors.brand};
      ${({ theme: theme, variant: variant })=>variant === 'outlined' && `stroke: ${theme.colors.primary} ;`}
      ${({ theme: theme, color: color })=>color === 'default' && `stroke: ${theme.colors.background} ;`}
      ${({ theme: theme, color: color })=>color === 'primary' && `stroke: ${theme.colors.brand} ;`}
      ${({ theme: theme, color: color })=>color === 'secondary' && `stroke: ${theme.colors.red} ;`}
      ${({ theme: theme, color: color })=>color === 'secondary-default' && `stroke: ${theme.colors.background} ;`}
      ${({ theme: theme, color: color })=>color === 'tertiary' && `stroke: ${theme.colors.background} ;`}
    }
    outline: none;

    ${({ theme: theme, variant: variant })=>variant === 'outlined' && `border: 1px solid ${theme.colors.brand}40;`}
    ${({ theme: theme, variant: variant })=>variant === 'outlined' && `background: ${theme.colors.background};`}
    ${({ theme: theme, variant: variant })=>variant === 'outlined' && `color: ${theme.colors.primary};`}

    ${({ theme: theme, variant: variant })=>variant === 'transparent' && `border: 1px solid ${theme.colors.brand}40;`}
    ${({ theme: theme, variant: variant })=>variant === 'transparent' && `background: ${theme.colors.background}00;`}
    ${({ theme: theme, variant: variant })=>variant === 'transparent' && `color: ${theme.colors.primary};`}
    
    ${({ theme: theme, color: color })=>color === 'default' && `background: ${theme.colors.brand}00;`}
    ${({ theme: theme, color: color })=>color === 'default' && `color: ${theme.colors.primary};`}
    ${({ theme: theme, color: color })=>color === 'default' && `border: 1px solid ${theme.colors.brand}40;`}
    
    ${({ theme: theme, color: color })=>color === 'primary' && `background: ${theme.colors.background};`}
    ${({ theme: theme, color: color })=>color === 'primary' && `border: 1px solid ${theme.colors.background};`}
    
    ${({ theme: theme, color: color })=>color === 'secondary' && `background: ${theme.colors.background};`}
    ${({ theme: theme, color: color })=>color === 'secondary' && `color: ${theme.colors.red};`}
    ${({ theme: theme, color: color })=>color === 'secondary' && `border: 1px solid ${theme.colors.red};`}
    
    ${({ theme: theme, color: color })=>color === 'secondary-default' && `background: ${theme.colors.red};`}
    ${({ theme: theme, color: color })=>color === 'secondary-default' && `color: ${theme.colors.background};`}
    ${({ theme: theme, color: color })=>color === 'secondary-default' && `border: 1px solid ${theme.colors.red};`}
    
    ${({ theme: theme, color: color })=>color === 'tertiary' && `background: ${theme.colors.brand};`}
    ${({ theme: theme, color: color })=>color === 'tertiary' && `color: ${theme.colors.background};`}
    ${({ theme: theme, color: color })=>color === 'tertiary' && `border: 1px solid ${theme.colors.brand};`}
  }
  &:disabled {
    color: ${({ theme: theme })=>theme.colors.primary} !important;
    background-color: ${({ theme: theme })=>theme.colors.backgroundLite} !important;
    border: 1px solid ${({ theme: theme })=>theme.colors.backgroundLite} !important;
    cursor: not-allowed !important;
    &:hover {
      background-color: ${({ theme: theme })=>theme.colors.backgroundLite} !important;
      border: 1px solid ${({ theme: theme })=>theme.colors.backgroundLite} !important;

      & svg > path {
        stroke: ${({ theme: theme })=>theme.colors.primary};
      }
      & svg > line {
        stroke: ${({ theme: theme })=>theme.colors.primary};
      }
    }
  }
  /*-------------------------------
    Themed Properties
  -------------------------------*/
  border: 1px solid ${({ theme: theme })=>theme.colors.brand};
  color: ${({ theme: theme })=>theme.colors.primary};
  background: ${({ theme: theme })=>`${theme.colors.brand}40`};
  /* & svg {
    max-height: 20px;
    max-width: 20px;
    ${({ size: size })=>size === 'tiny' && 'max-height: 8px !important; max-width: 8px !important;'}
    ${({ size: size })=>size === 'small' && 'max-height: 10px !important; max-width: 10px !important;'} 
    ${({ size: size })=>size === 'medium' && 'max-height: 15px !important; max-width: 15px !important;'}
  } */
  & svg > path {
    stroke: ${({ theme: theme })=>theme.colors.white};
    ${({ theme: theme, variant: variant })=>variant === 'outlined' && `stroke: ${theme.colors.primary} ;`}
    ${({ theme: theme, variant: variant })=>variant === 'transparent' && `stroke: ${theme.colors.primary} ;`}
    ${({ theme: theme, color: color })=>color === 'default' && `stroke: ${theme.colors.primary} ;`}
    ${({ theme: theme, color: color })=>color === 'primary' && `stroke: ${theme.colors.background} ;`}
    ${({ theme: theme, color: color })=>color === 'secondary' && `stroke: ${theme.colors.background} ;`}
    ${({ theme: theme, color: color })=>color === 'secondary-default' && `stroke: ${theme.colors.red} ;`}
    ${({ theme: theme, color: color })=>color === 'tertiary' && `stroke: ${theme.colors.brand} ;`}
  }
  & svg > line {
    stroke: ${({ theme: theme })=>theme.colors.white};
    ${({ theme: theme, variant: variant })=>variant === 'outlined' && `stroke: ${theme.colors.primary} ;`}
    ${({ theme: theme, variant: variant })=>variant === 'transparent' && `stroke: ${theme.colors.primary} ;`}
    ${({ theme: theme, color: color })=>color === 'default' && `stroke: ${theme.colors.primary} ;`}
    ${({ theme: theme, color: color })=>color === 'primary' && `stroke: ${theme.colors.background} ;`}
    ${({ theme: theme, color: color })=>color === 'secondary' && `stroke: ${theme.colors.background} ;`}
    ${({ theme: theme, color: color })=>color === 'secondary-default' && `stroke: ${theme.colors.red} ;`}
    ${({ theme: theme, color: color })=>color === 'tertiary' && `stroke: ${theme.colors.brand} ;`}
  }

  /*-------------------------------
    Variant Colors
  -------------------------------*/
  ${({ theme: theme, variant: variant })=>variant === 'outlined' && `border: 1px solid ${theme.colors.borderColor};`}
  ${({ theme: theme, variant: variant })=>variant === 'outlined' && `color: ${theme.colors.primary};`}
  ${({ variant: variant })=>variant === 'outlined' && 'background: transparent;'}

  ${({ variant: variant })=>variant === 'transparent' && 'border: 1px solid #00000000;'}
  ${({ theme: theme, variant: variant })=>variant === 'transparent' && `color: ${theme.colors.primary};`}
  ${({ variant: variant })=>variant === 'transparent' && 'background: transparent;'}

  ${({ theme: theme, color: color })=>color === 'default' && `background: ${theme.colors.brand}40;`}
  ${({ theme: theme, color: color })=>color === 'default' && `color: ${theme.colors.primary};`}
  ${({ theme: theme, color: color })=>color === 'default' && `border: 1px solid ${theme.colors.brand};`}
    
  ${({ theme: theme, color: color })=>color === 'primary' && `background: ${theme.colors.primary};`}
  ${({ theme: theme, color: color })=>color === 'primary' && `border: 1px solid ${theme.colors.primary};`}
  ${({ theme: theme, color: color })=>color === 'primary' && `color: ${theme.colors.background};`}

  ${({ theme: theme, color: color })=>color === 'secondary' && `background: ${theme.colors.red};`}
  ${({ theme: theme, color: color })=>color === 'secondary' && `color: ${theme.colors.white};`}
  ${({ theme: theme, color: color })=>color === 'secondary' && `border: 1px solid ${theme.colors.red};`}

  ${({ theme: theme, color: color })=>color === 'secondary-default' && `background: ${theme.colors.background};`}
  ${({ theme: theme, color: color })=>color === 'secondary-default' && `color: ${theme.colors.red};`}
  ${({ theme: theme, color: color })=>color === 'secondary-default' && `border: 1px solid ${theme.colors.red};`}
    
  ${({ theme: theme, color: color })=>color === 'tertiary' && `background: ${theme.colors.backgroundLite};`}
  ${({ theme: theme, color: color })=>color === 'tertiary' && `color: ${theme.colors.primary};`}
  ${({ theme: theme, color: color })=>color === 'tertiary' && `border: 1px solid ${theme.colors.backgroundLite};`}
  /*-------------------------------
    Variant Sizes
  -------------------------------*/
  ${({ size: size })=>size === 'tiny' && 'padding: 0 5px !important; border-radius: 3px; font-size: 8px !important;'} 
  ${({ size: size })=>size === 'small' && 'font-size: 13px !important;'} 
  ${({ size: size })=>size === 'medium' && 'font-size: 16px !important;'} 

  /*-------------------------------
    Conditional Properties
  -------------------------------*/
  ${({ fullWidth: fullWidth })=>fullWidth && 'width: 100%;'}
`;


function $e99593d75dd35a7e$var$Button(props) {
    // Destructure
    const { type: type, size: size, value: value, children: children, onClick: onClick, variant: variant, startIcon: startIcon, endIcon: endIcon, color: color, fullWidth: fullWidth, disabled: disabled, id: id, ...rest } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $d885bb434a8631da$export$d53c836cccbb0d90), {
        id: id,
        type: type,
        size: size,
        onClick: onClick,
        variant: variant,
        color: color,
        fullWidth: fullWidth,
        disabled: disabled,
        ...rest,
        children: [
            startIcon && startIcon,
            value || children,
            endIcon && endIcon
        ]
    });
}
// Default Props
$e99593d75dd35a7e$var$Button.defaultProps = {
    onClick: ()=>{},
    type: 'primary',
    size: 'medium',
    value: '',
    children: '',
    startIcon: '',
    endIcon: '',
    variant: 'contained',
    color: '',
    fullWidth: false,
    disabled: false
};
// Proptypes Validation
$e99593d75dd35a7e$var$Button.propTypes = {
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ]),
    startIcon: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ]),
    endIcon: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ]),
    variant: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    fullWidth: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
};
var $e99593d75dd35a7e$export$2e2bcd8739ae039 = $e99593d75dd35a7e$var$Button;


var $9f02f87ab33cad18$export$2e2bcd8739ae039 = (0, $e99593d75dd35a7e$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");


const $03d2db516d68681e$export$d586e0ae81c7b89b = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: fit-content;
  min-height: 35.5px;
  display: flex;
  gap: ${({ vertical: vertical })=>vertical ? '0px' : '5px'};
  margin: 0 !important;
  flex-direction: ${({ vertical: vertical })=>vertical ? 'column' : 'row'};
  align-items: ${({ vertical: vertical })=>vertical ? 'flex-start' : 'center'};
`;
const $03d2db516d68681e$export$8f1ff89fa1ec9605 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  margin: 0 !important;
  width: fit-content;
`;
const $03d2db516d68681e$export$b04be29aa201d4f5 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).label`
  position: relative;
  z-index: 1;
  padding: ${({ vertical: vertical })=>vertical ? '0 20px 0 0' : '0'};

  width: fit-content;
  color: ${({ theme: theme })=>theme.colors.primary};
  margin: 0 !important;
  font-size: 12px;
  font-weight: 200;
  word-break: keep-all;
`;
const $03d2db516d68681e$export$d6701e98ab1a6725 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).select`
  display: none;
`;
const $03d2db516d68681e$export$11a8a1ea41bf55d8 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).option`
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $03d2db516d68681e$export$37cdf0d06bb542b5 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  cursor: ${(props)=>props.disabled ? 'default' : 'pointer'};

  position: relative;
  // TODO: Use theme functions
  &:after {
    content: '';

    position: absolute;
    top: 42%;
    right: 0px;

    display: ${({ disabled: disabled })=>disabled ? 'none' : 'inline-block'};
    margin-left: 0.255em;
    vertical-align: 0.255em;

    border-top: 0.3em solid;
    border-right: 0.3em solid transparent;
    border-bottom: 0;
    border-left: 0.3em solid transparent;
    color: ${({ theme: theme })=>theme.colors.primary};
  }

  background-color: ${({ disabled: disabled, theme: theme })=>disabled ? theme.colors.backgroundLite : 'transparent'};
  height: fit-content;
  width: fit-content;

  font-size: 12px;
  font-weight: 400;
  box-shadow: none;
  padding: 0 20px 0 0;
`;
const $03d2db516d68681e$export$a6151309bfd46137 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: absolute;
  display: flex;
  flex-direction: column;
  color: ${({ theme: theme })=>theme.colors.primary};

  padding: 5px;
  width: fit-content;
  max-height: 300px;
  min-width: 100px;
  overflow-y: auto;

  font-size: 14px;
  border-radius: 8px;
  font-weight: 400;
  background-color: ${({ theme: theme })=>theme.colors.background};
  border: ${({ theme: theme })=>`1px solid ${theme.colors.borderColor}`};
  user-select: none;
  z-index: 2;

  ${({ position: position })=>position === 'bottom' && 'top: 110%'};
  ${({ position: position })=>position === 'top' && 'bottom: 110%'};
`;
const $03d2db516d68681e$export$ba141e9a22070242 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: 100%;
  padding: 2px 10px;
  gap: 10px;
  word-break: keep-all;
  white-space: nowrap;

  color: ${({ theme: theme })=>theme.colors.primary};

  cursor: pointer;
  transition: 0.4s;

  border-radius: 6px;
  border: 1px solid rgba(0, 0, 0, 0);

  &:hover {
    border: ${({ theme: theme })=>`1px solid ${theme.colors.brand}`};
    color: ${({ theme: theme })=>`${theme.colors.brand}`};
  }
`;
const $03d2db516d68681e$export$8a186fdbfc12f934 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  color: ${(props)=>props.disabled ? props.theme.colors.primary : props.theme.colors.brand};
  font-weight: 400;
  margin: 0 !important;
  font-size: 14px;
  word-break: keep-all;
`;
const $03d2db516d68681e$export$a11e67ac8be84bf9 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  color: ${({ theme: theme })=>theme.colors.backgroundLite};
`;


// Function that listens to oustide clicks of given ref
const $c5892724db161e9a$var$useOutsideAlerter = (ref, setShowOptions)=>{
    (0, $tZqWC.useEffect)(()=>{
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) setShowOptions(false);
        }
        document.addEventListener('mousedown', handleClickOutside);
        return ()=>{
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [
        ref
    ]);
};
function $c5892724db161e9a$var$SimpleSelect(props) {
    // Destructure
    const { id: id, label: label, placeholder: placeholder, options: options, onChange: onChange, value: value, disabled: disabled, vertical: vertical, ...rest } = props;
    // Variables
    const withOptions = options && options?.length > 0;
    const wrapperRef = (0, $tZqWC.useRef)();
    // States
    const [formValue, setFormValue] = (0, $tZqWC.useState)('');
    const [valueLabel, setValueLabel] = (0, $tZqWC.useState)('');
    const [showOptions, setShowOptions] = (0, $tZqWC.useState)(false);
    const [position, setPosition] = (0, $tZqWC.useState)('bottom');
    // Functions
    const handleOnChange = (value, label)=>{
        onChange(value);
        if (value === undefined) {
            setFormValue(value);
            setValueLabel(placeholder || '');
            return setShowOptions(false);
        }
        setFormValue(value);
        setValueLabel(label);
        setShowOptions(false);
    };
    // Closing options on click away
    $c5892724db161e9a$var$useOutsideAlerter(wrapperRef, setShowOptions);
    // UseEffects
    (0, $tZqWC.useEffect)(()=>{
        // setting the value and label on initial load
        if (value === undefined || value === null) {
            setValueLabel(placeholder);
            return;
        }
        setFormValue(value);
        const currentLabel = options.find((data)=>{
            if (typeof data.value === 'number') return data.value === Number(value);
            return data.value === value;
        });
        if (currentLabel?.label) setValueLabel(currentLabel.label);
        else if (!currentLabel?.label) setValueLabel(placeholder || '');
    }, [
        value
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (showOptions && wrapperRef.current) {
            const rect = wrapperRef.current.getBoundingClientRect();
            const spaceBelow = window.innerHeight - rect.bottom;
            const menuHeight = 300;
            if (spaceBelow < menuHeight) setPosition('top');
            else setPosition('bottom');
        }
    }, [
        showOptions
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $03d2db516d68681e$export$d586e0ae81c7b89b), {
        ref: wrapperRef,
        id: id,
        vertical: vertical,
        children: [
            label && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $03d2db516d68681e$export$b04be29aa201d4f5), {
                disabled: disabled,
                children: label
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $03d2db516d68681e$export$8f1ff89fa1ec9605), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $03d2db516d68681e$export$d6701e98ab1a6725), {
                        disabled: disabled,
                        type: "select",
                        value: `${formValue}`,
                        onChange: ()=>{},
                        ...rest
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $03d2db516d68681e$export$37cdf0d06bb542b5), {
                        className: "simpleSelectInputLabel",
                        disabled: disabled,
                        onClick: ()=>{
                            if (!disabled) setShowOptions((prevState)=>!prevState);
                        },
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $03d2db516d68681e$export$8a186fdbfc12f934), {
                            vertical: vertical,
                            disabled: disabled,
                            children: [
                                ' ',
                                !valueLabel ? placeholder : valueLabel,
                                ' '
                            ]
                        })
                    }),
                    showOptions && options?.length > 0 && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $03d2db516d68681e$export$a6151309bfd46137), {
                        vertical: vertical,
                        position: position,
                        children: withOptions && options.map(({ value: value, label: label, abrv: abrv, icon: icon, SVG: SVG })=>{
                            if (label !== valueLabel) return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $03d2db516d68681e$export$ba141e9a22070242), {
                                onClick: ()=>{
                                    handleOnChange(value, label);
                                },
                                value: value,
                                children: [
                                    icon && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $65f0d7ff3fd922b2$export$2e2bcd8739ae039), {
                                        src: icon,
                                        width: 30,
                                        height: 30
                                    }),
                                    SVG && SVG,
                                    label,
                                    abrv && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $03d2db516d68681e$export$a11e67ac8be84bf9), {
                                        children: [
                                            " ",
                                            abrv,
                                            " "
                                        ]
                                    })
                                ]
                            }, label);
                        })
                    })
                ]
            })
        ]
    });
}
// Default Props
$c5892724db161e9a$var$SimpleSelect.defaultProps = {
    id: '',
    label: '',
    value: undefined,
    placeholder: '',
    options: [],
    onChange: ()=>{},
    disabled: false,
    vertical: false
};
// Proptypes Validation
$c5892724db161e9a$var$SimpleSelect.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number
    ]),
    placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    options: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Array),
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    vertical: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
};
var $c5892724db161e9a$export$2e2bcd8739ae039 = $c5892724db161e9a$var$SimpleSelect;


var $430484cb816801bc$export$2e2bcd8739ae039 = (0, $c5892724db161e9a$export$2e2bcd8739ae039);


function $c109a2490e8ecf9c$var$Pagination(props) {
    // Destructure
    const { onChange: onChange, itemsCountPerPage: itemsCountPerPage, totalItemsCount: totalItemsCount, pageRangeDisplayed: pageRangeDisplayed, page: page } = props;
    // States
    const [size, setSize] = (0, $tZqWC.useState)(10);
    const [pageRange, setPageRange] = (0, $tZqWC.useState)();
    const [totalPages, setTotalPages] = (0, $tZqWC.useState)(Math.floor(totalItemsCount / itemsCountPerPage));
    const [pages, setPages] = (0, $tZqWC.useState)([]);
    // Functions
    const handlePageChange = (page)=>{
        onChange({
            page: +page,
            size: size
        });
    };
    const handlePages = ()=>{
        let tempPages = [];
        tempPages.push(page);
        let before = page - 1;
        let after = page + 1;
        let { length: length } = tempPages;
        while(length < pageRange){
            if (before > 0) {
                tempPages = [
                    before,
                    ...tempPages
                ];
                before -= 1;
                length += 1;
            }
            if (after <= totalPages) {
                tempPages = [
                    ...tempPages,
                    after
                ];
                after += 1;
                length += 1;
            }
        }
        // Only update if changed
        const newPages = JSON.stringify(tempPages);
        const oldPages = JSON.stringify(pages);
        if (newPages !== oldPages) setPages(tempPages);
    };
    const handleOnSelectChange = (value)=>{
        setSize(+value);
        onChange({
            page: 1,
            size: +value
        });
    };
    const handlePageRange = ()=>{
        const currTotalPages = Math.ceil(totalItemsCount / itemsCountPerPage);
        if (currTotalPages !== totalPages) setTotalPages(currTotalPages);
        const newPageRange = Math.min(pageRangeDisplayed, currTotalPages);
        if (newPageRange !== pageRange) setPageRange(newPageRange);
    };
    // UseEffects
    (0, $tZqWC.useEffect)(()=>{
        handlePageRange();
    }, [
        pageRangeDisplayed,
        totalItemsCount,
        itemsCountPerPage
    ]);
    (0, $tZqWC.useEffect)(()=>{
        handlePages();
    }, [
        pageRange,
        page
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $aaf622d5f68ae696$export$3e5e12dc01f20a43), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $aaf622d5f68ae696$export$6e8f258e6fada449), {
                children: totalItemsCount > 0 && pages?.length > 0 && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $aaf622d5f68ae696$export$a2c8d9fea6ba956e), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $430484cb816801bc$export$2e2bcd8739ae039), {
                        options: (0, $f398806f8c37b1c3$export$c12542e899d17513),
                        onChange: handleOnSelectChange,
                        value: itemsCountPerPage
                    })
                })
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $aaf622d5f68ae696$export$92df4ffe22cfff47), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                        style: {
                            marginRight: '20px',
                            padding: '2px 5px'
                        },
                        onClick: ()=>{
                            handlePageChange(page - 1);
                        },
                        disabled: page === 1 || !pages || pages?.length < 1 || totalItemsCount < 1,
                        variant: "outlined",
                        size: "small",
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9cadc73f9b5b2fc9$export$2e2bcd8739ae039), {
                            size: 25
                        })
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $aaf622d5f68ae696$export$2ee8f3d9e1be0b9a), {
                        children: [
                            (!pages || pages?.length < 1 || totalItemsCount < 1) && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                variant: "transparent",
                                size: "small",
                                disabled: true,
                                children: "..."
                            }),
                            pages && totalItemsCount > 0 && pages?.length > 0 && pages?.map((i)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                    style: {
                                        maxWidth: '30px'
                                    },
                                    onClick: ()=>{
                                        handlePageChange(i);
                                    },
                                    variant: page === i ? '' : 'transparent',
                                    size: "small",
                                    children: i
                                }, i))
                        ]
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                        style: {
                            marginLeft: '20px',
                            padding: '2px 5px'
                        },
                        onClick: ()=>{
                            handlePageChange(page + 1);
                        },
                        disabled: page >= totalPages || !pages || pages?.length < 1 || totalItemsCount < 1,
                        variant: "outlined",
                        size: "small",
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ce96cd4d0e43c777$export$2e2bcd8739ae039), {
                            size: 25
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $aaf622d5f68ae696$export$6e8f258e6fada449), {
                children: totalItemsCount > 0 && pages?.length > 0 && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $aaf622d5f68ae696$export$bd55427d3650a1b0), {
                    children: `Displayed: ${itemsCountPerPage * page} / ${totalItemsCount}`
                })
            })
        ]
    });
}
// Default Props
$c109a2490e8ecf9c$var$Pagination.defaultProps = {
    onChange: ()=>{},
    itemsCountPerPage: 10,
    totalItemsCount: 10,
    pageRangeDisplayed: 5,
    page: 0
};
// Proptypes Validation
$c109a2490e8ecf9c$var$Pagination.propTypes = {
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    itemsCountPerPage: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
    totalItemsCount: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
    pageRangeDisplayed: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
    page: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number
};
var $c109a2490e8ecf9c$export$2e2bcd8739ae039 = $c109a2490e8ecf9c$var$Pagination;


var $9deaec2f043c7dfd$export$2e2bcd8739ae039 = (0, $c109a2490e8ecf9c$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");



const $f68fcb2fcd9c6103$export$304c5d81524150ee = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  width: 100%;
  height: 100%;

  padding: 30px;
  border-radius: 15px;
  border: 1px solid ${({ theme: theme })=>theme.colors.secondary}50;
`;
const $f68fcb2fcd9c6103$export$6a861cde3ab663c8 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  width: 200px;
`;
const $f68fcb2fcd9c6103$export$99d9fbaae75677b8 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: 100%;

  // Themed Properties
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $f68fcb2fcd9c6103$export$46a8c87cc0d102d6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 20px;
  font-weight: 600;

  text-align: center;
`;
const $f68fcb2fcd9c6103$export$c67cd974b35e2ed8 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 16px;
  font-weight: 400;

  text-align: center;
`;
const $f68fcb2fcd9c6103$export$d53c836cccbb0d90 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  padding-top: 30px;
`;


function $9c4e8fb083423408$var$EmptyTablePlaceholder(props) {
    const { setFilter: setFilter, title: title, content: content } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $f68fcb2fcd9c6103$export$304c5d81524150ee), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f68fcb2fcd9c6103$export$6a861cde3ab663c8), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7e5282d83c21f92a$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $f68fcb2fcd9c6103$export$99d9fbaae75677b8), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f68fcb2fcd9c6103$export$46a8c87cc0d102d6), {
                        children: title || 'No search result'
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f68fcb2fcd9c6103$export$c67cd974b35e2ed8), {
                        children: content || 'Please, try a different combination of filters'
                    }),
                    setFilter && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f68fcb2fcd9c6103$export$d53c836cccbb0d90), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                            onClick: ()=>setFilter(),
                            children: "Reset Filters"
                        })
                    })
                ]
            })
        ]
    });
}
// Default Props
$9c4e8fb083423408$var$EmptyTablePlaceholder.defaultProps = {
    setFilter: null,
    title: '',
    content: ''
};
// Proptypes Validation
$9c4e8fb083423408$var$EmptyTablePlaceholder.propTypes = {
    setFilter: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    content: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
};
var $9c4e8fb083423408$export$2e2bcd8739ae039 = $9c4e8fb083423408$var$EmptyTablePlaceholder;


var $a6ea3b0f3caed586$export$2e2bcd8739ae039 = (0, $9c4e8fb083423408$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

const $8b917fb29beb5fce$export$a966b54425251788 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 140px 0px;
`;



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $0c5f83a232eda52f$export$d720433ce0720d73 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
const $0c5f83a232eda52f$export$3b0d6d7590275603 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div.attrs((props)=>({
        // Props
        width: props.width || '80px',
        height: props.height || '80px',
        thickness: props.thickness || '8px'
    }))`

  display: inline-block;
  position: relative;
  height: ${(props)=>props.height};
  width: ${(props)=>props.width};
  margin: 15px;

  & div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    border: ${(props)=>props.thickness} solid ${({ theme: theme })=>theme.colors.brand};
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: ${({ theme: theme })=>theme.colors.brand} transparent transparent transparent;
  }
  & div:nth-child(1) {
    animation-delay: -0.45s;
  }
  & div:nth-child(2) {
    animation-delay: -0.3s;
  }
  & div:nth-child(3) {
    animation-delay: -0.15s;
  }
  @keyframes lds-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;


function $55844bc5a65b0bca$var$LoaderCircle(props) {
    // Destructure
    const { height: height, width: width, thickness: thickness } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $0c5f83a232eda52f$export$d720433ce0720d73), {
        height: height,
        width: width,
        thickness: thickness,
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $0c5f83a232eda52f$export$3b0d6d7590275603), {
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("div", {}),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("div", {}),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("div", {}),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("div", {})
            ]
        })
    });
}
// Default Props
$55844bc5a65b0bca$var$LoaderCircle.defaultProps = {
    height: '',
    width: '',
    thickness: ''
};
// Proptypes Validation
$55844bc5a65b0bca$var$LoaderCircle.propTypes = {
    height: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    width: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    thickness: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
};
var $55844bc5a65b0bca$export$2e2bcd8739ae039 = $55844bc5a65b0bca$var$LoaderCircle;


var $a6fa6c8d0625529f$export$2e2bcd8739ae039 = (0, $55844bc5a65b0bca$export$2e2bcd8739ae039);


function $80b568fc662f2449$var$LoadingTablePlaceholder(props) {
    const { ...rest } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $8b917fb29beb5fce$export$a966b54425251788), {
        ...rest,
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a6fa6c8d0625529f$export$2e2bcd8739ae039), {})
    });
}
// Default Props
$80b568fc662f2449$var$LoadingTablePlaceholder.defaultProps = {};
// Proptypes Validation
$80b568fc662f2449$var$LoadingTablePlaceholder.propTypes = {};
var $80b568fc662f2449$export$2e2bcd8739ae039 = $80b568fc662f2449$var$LoadingTablePlaceholder;


var $647b8bc68ebce54f$export$2e2bcd8739ae039 = (0, $80b568fc662f2449$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");


const $b66eab9ddb05db46$var$fadeIn = (0, $a778141486c79bc3$export$d25ddfdf17c3ad3e)`
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
`;
const $b66eab9ddb05db46$export$f1129e9be7945b65 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: ${({ open: open })=>open ? 'flex' : 'none'};
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  max-width: 300px;
  padding: 10px 15px;

  position: fixed;
  bottom: 25px;
  right: 25px;
  z-index: 10;

  border-radius: 8px;
  font-size: 14px;
  color: white;
  animation: ${$b66eab9ddb05db46$var$fadeIn} 0.3s ease;

  ${({ type: type, theme: theme })=>{
    const colors = {
        success: theme.colors.success,
        warning: theme.colors.warning,
        error: theme.colors.red,
        info: theme.colors.brandGray
    };
    return (0, $a778141486c79bc3$export$dbf350e5966cf602)`
      background-color: ${colors[type] || theme.colors.primary};
    `;
}}
`;
const $b66eab9ddb05db46$export$f69c19e57285b83a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  color: ${({ theme: theme })=>`${theme.colors.primary}`};
`;
const $b66eab9ddb05db46$export$e19cd5f9376f8cee = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  cursor: pointer;
  transition: 0.3s;
  &:hover {
    opacity: 0.7;
  }
`;


function $60eeb3e26491a187$var$Alert(props) {
    // Destructure
    const { open: open, message: message, onClose: onClose, anchorOrigin: anchorOrigin, color: color, autoHideDuration: autoHideDuration, ...rest } = props;
    // Functions
    const handleOnClose = (e)=>{
        onClose(e);
    };
    // UseEffects
    (0, $tZqWC.useEffect)(()=>{
        setTimeout(()=>{
            handleOnClose();
        }, autoHideDuration);
    }, [
        open
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $b66eab9ddb05db46$export$f1129e9be7945b65), {
        anchorOrigin: anchorOrigin,
        open: open,
        onClose: handleOnClose,
        autoHideDuration: autoHideDuration,
        message: message,
        ...rest,
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b66eab9ddb05db46$export$f69c19e57285b83a), {
                children: message
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b66eab9ddb05db46$export$e19cd5f9376f8cee), {
                onClick: handleOnClose,
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b77b5de3fb591045$export$2e2bcd8739ae039), {
                    size: 18
                })
            })
        ]
    });
}
// Default Props
$60eeb3e26491a187$var$Alert.defaultProps = {
    anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right'
    },
    open: false,
    autoHideDuration: 3000,
    onClose: ()=>{},
    color: '',
    message: ''
};
// Proptypes Validation
$60eeb3e26491a187$var$Alert.propTypes = {
    anchorOrigin: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        vertical: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        horizontal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    }),
    open: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    autoHideDuration: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    message: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
};
var $60eeb3e26491a187$export$2e2bcd8739ae039 = $60eeb3e26491a187$var$Alert;


var $ffd80d6545166898$export$2e2bcd8739ae039 = (0, $60eeb3e26491a187$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");
/* eslint-disable no-confusing-arrow */ 
const $0100016f6f3c6d02$export$9ed13ab9159d3f31 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  background-color: ${({ theme: theme })=>theme.colors.black}70;

  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 10;

  transition: ${({ isOpen: isOpen })=>isOpen ? 'opacity 0.3s ease, visibility 0.3s ease' : 'opacity 0.3s ease 0.1s, visibility 0.3s ease 0.1s'};
  opacity: ${({ isOpen: isOpen })=>isOpen ? 1 : 0};
  visibility: ${({ isOpen: isOpen })=>isOpen ? 'visible' : 'hidden'};
`;
const $0100016f6f3c6d02$export$75f51cf067955710 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 0;
  color: ${({ theme: theme })=>theme.colors.primary};

  display: flex;
  flex-direction: column;
  height: 100%;
  border-radius: 10px;

  position: fixed;
  top: 0;
  right: 0;

  transition: transform 0.2s ease-in-out;
  transform: ${({ isOpen: isOpen })=>isOpen ? 'translateX(0)' : 'translateX(100%)'};
  z-index: 11; /* Above backdrop */
`;
const $0100016f6f3c6d02$export$4773d9579357e082 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  height: 100%;
  padding: 0;
  margin: 10px;
  background-color: ${({ theme: theme })=>theme.colors.background};
  border: 1px solid ${({ theme: theme })=>`${theme.colors.secondary}80`};
  border-radius: 15px;
`;



var $tZqWC = parcelRequire("tZqWC");
const $54f47a39f461db48$export$50ec7b7ff742aae5 = (ref, setShowOptions)=>{
    (0, $tZqWC.useEffect)(()=>{
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) setShowOptions(false);
        }
        document.addEventListener('mousedown', handleClickOutside);
        return ()=>{
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [
        ref,
        setShowOptions
    ]);
};



var $tZqWC = parcelRequire("tZqWC");
const $f42ea022c558e18e$export$c080a84d0ed0727d = (open, animationDuration = 300)=>{
    const [shouldRender, setShouldRender] = (0, $tZqWC.useState)(false);
    const [animateIn, setAnimateIn] = (0, $tZqWC.useState)(false);
    (0, $tZqWC.useEffect)(()=>{
        if (open) {
            setShouldRender(true);
            requestAnimationFrame(()=>{
                setAnimateIn(true);
            });
        } else {
            setAnimateIn(false);
            const timeout = setTimeout(()=>{
                setShouldRender(false);
            }, animationDuration);
            return ()=>clearTimeout(timeout);
        }
    }, [
        open,
        animationDuration
    ]);
    return {
        shouldRender: shouldRender,
        animateIn: animateIn
    };
};


function $138a899e4916a8f5$var$Drawer(props) {
    // Destructure
    const { anchor: anchor, open: open, onClose: onClose, children: children } = props;
    // Refs
    const wrapperRef = (0, $tZqWC.useRef)();
    // Hooks
    (0, $54f47a39f461db48$export$50ec7b7ff742aae5)(wrapperRef, ()=>{
        if (open === true) onClose();
    });
    const { shouldRender: shouldRender, animateIn: animateIn } = (0, $f42ea022c558e18e$export$c080a84d0ed0727d)(open, 300);
    return shouldRender ? /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $0100016f6f3c6d02$export$9ed13ab9159d3f31), {
        isOpen: animateIn,
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $0100016f6f3c6d02$export$75f51cf067955710), {
            anchor: anchor,
            isOpen: animateIn,
            ref: wrapperRef,
            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $0100016f6f3c6d02$export$4773d9579357e082), {
                isOpen: animateIn,
                children: children
            })
        })
    }) : null;
}
// Default Props
$138a899e4916a8f5$var$Drawer.defaultProps = {
    anchor: 'right',
    open: false,
    onClose: ()=>{},
    children: ''
};
// Proptypes Validation
$138a899e4916a8f5$var$Drawer.propTypes = {
    anchor: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    open: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ])
};
var $138a899e4916a8f5$export$2e2bcd8739ae039 = $138a899e4916a8f5$var$Drawer;


var $7c0b6d1401667fb6$export$2e2bcd8739ae039 = (0, $138a899e4916a8f5$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $2c2d134138b35d93$export$e6dfd72ab29f8598 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  width: 100%;
`;
const $2c2d134138b35d93$export$68c28438b26ae806 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: absolute;
  z-index: 0;
  width: 100%;
  top: 18px;
  left: 0;
  border-bottom: 2px solid ${({ theme: theme })=>theme.colors.backgroundLite};
`;
const $2c2d134138b35d93$export$305694ba63064ba1 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: absolute;
  z-index: 0;
  max-width: 325px;
  top: 18px;
  left: 0;
  border-bottom: 2px solid ${({ theme: theme })=>theme.colors.brand};
  width: ${({ width: width })=>width && `${width}%;`};
  transition: 0.5s;
`;
const $2c2d134138b35d93$export$960a49cc3d27a090 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(52px, 1fr));

  /* cursor: pointer; */
`;
const $2c2d134138b35d93$export$1e86fd0e1db89578 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  color: ${({ theme: theme })=>theme.colors.primary};
  position: relative;
`;
const $2c2d134138b35d93$export$a71e0d665206bf82 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  z-index: 1;

  display: flex;
  justify-content: center;
  align-items: center;

  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: ${({ theme: theme })=>theme.colors.background};
  border: 2px solid ${({ theme: theme })=>theme.colors.backgroundLite};
  color: ${({ theme: theme })=>theme.colors.secondary};

  font-size: 14px;
  font-weight: 500;

  ${({ theme: theme, active: active })=>active && `background-color: ${theme.colors.brand} !important;`};
  ${({ theme: theme, active: active })=>active && `color: ${theme.colors.background} !important;`};
  ${({ theme: theme, active: active })=>active && `border: 2px solid ${theme.colors.brand} !important;`};

  ${({ theme: theme, completed: completed })=>completed && `color: ${theme.colors.brand} !important;`};
  ${({ theme: theme, completed: completed })=>completed && `border: 2px solid ${theme.colors.brand} !important;`};
  transition: 0.5s;
`;
const $2c2d134138b35d93$export$f5ae33f1b01a6402 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 12px;
  font-weight: 400;

  color: ${({ theme: theme })=>theme.colors.secondary};

  ${({ theme: theme, active: active })=>active && `color: ${theme.colors.brand} !important;`};
  ${({ theme: theme, completed: completed })=>completed && `color: ${theme.colors.brand} !important;`};
`;


function $40ae36cec30433fb$var$FormNavigation(props) {
    // Destructure
    const { headers: headers, pageNumber: pageNumber, setPageNumber: setPageNumber } = props;
    const handlePageChange = (value)=>{
        if (setPageNumber) setPageNumber(value);
    };
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $2c2d134138b35d93$export$e6dfd72ab29f8598), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2c2d134138b35d93$export$68c28438b26ae806), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2c2d134138b35d93$export$960a49cc3d27a090), {
                children: headers.map((header, i)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $2c2d134138b35d93$export$1e86fd0e1db89578), {
                        onClick: ()=>{
                            handlePageChange(i + 1);
                        },
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2c2d134138b35d93$export$a71e0d665206bf82), {
                                active: pageNumber === i + 1,
                                completed: pageNumber > i + 1,
                                children: i + 1
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2c2d134138b35d93$export$305694ba63064ba1), {
                                width: pageNumber === i + 1 || pageNumber > i + 1 ? '100' : 0
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2c2d134138b35d93$export$f5ae33f1b01a6402), {
                                active: pageNumber === i + 1,
                                completed: pageNumber > i + 1,
                                children: header.label
                            })
                        ]
                    }, header.label))
            })
        ]
    });
}
// Default Props
$40ae36cec30433fb$var$FormNavigation.defaultProps = {
    headers: {},
    pageNumber: 0,
    setPageNumber: ()=>{}
};
// Proptypes Validation
$40ae36cec30433fb$var$FormNavigation.propTypes = {
    headers: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        label: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    })),
    pageNumber: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
    setPageNumber: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
};
var $40ae36cec30433fb$export$2e2bcd8739ae039 = $40ae36cec30433fb$var$FormNavigation;


var $ef69c736ae57a14f$export$2e2bcd8739ae039 = (0, $40ae36cec30433fb$export$2e2bcd8739ae039);


/* eslint-disable react/no-array-index-key */ 
parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");
/* eslint-disable no-confusing-arrow */ 
const $2047c5ef9f3cc53c$export$e6dfd72ab29f8598 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  width: 100%;
  min-width: 500px;
  margin-top: 10px;
  margin-bottom: -20px;
`;
const $2047c5ef9f3cc53c$export$960a49cc3d27a090 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  width: 100%;
`;
const $2047c5ef9f3cc53c$export$6ca7af6973c1582a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: 0;
  margin: 0;
`;
const $2047c5ef9f3cc53c$export$b99cc8e24b997903 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 13px;
  text-align: right;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $2047c5ef9f3cc53c$export$d4c1f8c9b1ee31f6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  min-width: 100px;

  padding: 0 40px 30px 0;
  color: ${({ theme: theme })=>theme.colors.primary};
  transform: translateY(5px);
`;
const $2047c5ef9f3cc53c$export$eb10258d8c8e0230 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: 0;
  margin: 0;
`;
const $2047c5ef9f3cc53c$export$ebb989c117bbb2e8 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  text-align: left;
  font-size: 13px;
  color: ${({ theme: theme, disabled: disabled })=>disabled ? theme.colors.secondary : theme.colors.primary};
  transform: translateY(5px);
`;
const $2047c5ef9f3cc53c$export$ce17eabc850a52ae = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  min-width: 100px;

  padding: 30px 0 0 40px;
  border-left: 2px solid ${({ theme: theme, active: active })=>active ? `${theme.colors.brand}` : `${theme.colors.secondary}`};
  border-left: ${({ theme: theme, failed: failed })=>failed && `2px solid ${theme.colors.red} !important`};
  border-left: ${({ theme: theme, disabled: disabled })=>disabled && `2px solid ${theme.colors.secondary}50 !important`};
  &:first-child {
    padding: 0 0 0 40px;
    border-left: 2px solid transparent !important;
  }
  ::before {
    content: '.';
    color: transparent;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    position: absolute;
    left: -6.5px;
    bottom: 0px;

    background-color: ${({ theme: theme, active: active })=>active ? `${theme.colors.brand}` : `${theme.colors.secondary}`};
    background-color: ${({ theme: theme, failed: failed })=>failed && `${theme.colors.red} !important`};
    background-color: ${({ theme: theme, disabled: disabled })=>disabled && `${theme.colors.secondary}50 !important`};
  }
  ::after {
    content: '.';
    color: transparent;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    position: absolute;
    left: -14px;
    bottom: -7px;

    background-color: ${({ theme: theme, active: active })=>active ? `${theme.colors.brand}4f` : `${theme.colors.secondary}4f`};
    background-color: ${({ theme: theme, failed: failed })=>failed && `${theme.colors.red}4f !important`};
  }
`;


function $854a5791180d8a91$var$VerticalDotProgress(props) {
    // Destructure
    const { headers: headers } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2047c5ef9f3cc53c$export$e6dfd72ab29f8598), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $2047c5ef9f3cc53c$export$960a49cc3d27a090), {
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2047c5ef9f3cc53c$export$6ca7af6973c1582a), {
                    children: headers.map(({ leftLabel: leftLabel }, i)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2047c5ef9f3cc53c$export$d4c1f8c9b1ee31f6), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2047c5ef9f3cc53c$export$b99cc8e24b997903), {
                                children: leftLabel && leftLabel
                            })
                        }, i))
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2047c5ef9f3cc53c$export$eb10258d8c8e0230), {
                    children: headers.map(({ rightLabel: rightLabel, leftLabel: leftLabel, disabled: disabled, failed: failed }, i)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2047c5ef9f3cc53c$export$ce17eabc850a52ae), {
                            failed: failed,
                            disabled: disabled,
                            active: leftLabel !== null,
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2047c5ef9f3cc53c$export$ebb989c117bbb2e8), {
                                disabled: disabled,
                                children: rightLabel && rightLabel
                            })
                        }, i))
                })
            ]
        })
    });
}
// Default Props
$854a5791180d8a91$var$VerticalDotProgress.defaultProps = {
    headers: {}
};
// Proptypes Validation
$854a5791180d8a91$var$VerticalDotProgress.propTypes = {
    headers: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        leftLabel: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        rightLabel: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
        failed: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
        success: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }))
};
var $854a5791180d8a91$export$2e2bcd8739ae039 = $854a5791180d8a91$var$VerticalDotProgress;


var $1388d6ff56865309$export$2e2bcd8739ae039 = (0, $854a5791180d8a91$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $2c7d236c973f6897$export$e6dfd72ab29f8598 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  overflow: hidden;
  width: 100%;
  padding-top: 56.25%;

  & iframe {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
  }
`;


function $77d8038ac1b98a79$var$YoutubeEmbed(props) {
    // Destructure
    const { embedId: embedId, ...rest } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2c7d236c973f6897$export$e6dfd72ab29f8598), {
        ...rest,
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("iframe", {
            src: `https://www.youtube.com/embed/${embedId}`,
            frameBorder: "0",
            allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
            allowFullScreen: true,
            title: "Video"
        })
    });
}
// Default Props
$77d8038ac1b98a79$var$YoutubeEmbed.defaultProps = {
    embedId: ''
};
// Proptypes Validation
$77d8038ac1b98a79$var$YoutubeEmbed.propTypes = {
    embedId: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
};
var $77d8038ac1b98a79$export$2e2bcd8739ae039 = $77d8038ac1b98a79$var$YoutubeEmbed;


var $85a23adae7b840a5$export$2e2bcd8739ae039 = (0, $77d8038ac1b98a79$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $c14566d5a0b3e6c3$export$e6dfd72ab29f8598 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  max-width: ${({ maxWidth: maxWidth })=>maxWidth || '320px'};
  min-width: 260px;
  position: relative;
  width: 100%;
`;
const $c14566d5a0b3e6c3$export$e7797fd764838308 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  background-color: ${({ theme: theme })=>theme.colors.backgroundLite};
  height: 10px;
  width: 100%;
  border-radius: 15px;
`;
const $c14566d5a0b3e6c3$export$407ded98a8f28593 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: absolute;
  top: 0;
  left: 0;
  height: 10px;
  background-color: ${({ theme: theme, failed: failed })=>failed ? theme.colors.red : theme.colors.brand};
  border-radius: 15px;

  width: ${({ width: width })=>width || '0%'};
  transition: 0.4s ease;
`;


function $679483085e9c66a3$var$ProgressBar(props) {
    // Destructure
    const { width: width, failed: failed, maxWidth: maxWidth } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $c14566d5a0b3e6c3$export$e6dfd72ab29f8598), {
        maxWidth: maxWidth,
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c14566d5a0b3e6c3$export$e7797fd764838308), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c14566d5a0b3e6c3$export$407ded98a8f28593), {
                failed: failed,
                width: width
            })
        ]
    });
}
// Default Props
$679483085e9c66a3$var$ProgressBar.defaultProps = {
    width: '',
    maxWidth: ''
};
// Proptypes Validation
$679483085e9c66a3$var$ProgressBar.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    ]),
    maxWidth: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    ]),
    failed: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
};
var $679483085e9c66a3$export$2e2bcd8739ae039 = $679483085e9c66a3$var$ProgressBar;


var $badb5a82015e7095$export$2e2bcd8739ae039 = (0, $679483085e9c66a3$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $de72560b32eeea1d$export$e6dfd72ab29f8598 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  max-width: 400px;
  min-width: 260px;
  position: relative;
  width: 100%;
`;
const $de72560b32eeea1d$export$407ded98a8f28593 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  background: linear-gradient(45deg, #caff0a, #caff0a 30%, #ec8800 50%, #cb5300 100%);
  height: ${({ height: height })=>height ? `${height}px` : '8px'};
  width: 100%;
  border-radius: 5px;
  width: 100%;
`;
const $de72560b32eeea1d$export$e7797fd764838308 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: absolute;
  top: 0;
  right: 0;
  height: ${({ height: height })=>height ? `${height}px` : '8px'};
  background-color: ${({ theme: theme })=>theme.colors.backgroundLite};
  border-radius: 0 5px 5px 0;

  width: ${({ width: width })=>width || '0%'};
  transition: 0.4s ease;
`;


function $44e40bfc1d5457a6$var$RiskBar(props) {
    // Destructure
    const { width: width, height: height } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $de72560b32eeea1d$export$e6dfd72ab29f8598), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $de72560b32eeea1d$export$e7797fd764838308), {
                height: height,
                width: `${(parseInt(width, 10) - 100) * -1}%`
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $de72560b32eeea1d$export$407ded98a8f28593), {
                height: height
            })
        ]
    });
}
// Default Props
$44e40bfc1d5457a6$var$RiskBar.defaultProps = {
    width: '',
    height: 0
};
// Proptypes Validation
$44e40bfc1d5457a6$var$RiskBar.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    ]),
    height: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number
};
var $44e40bfc1d5457a6$export$2e2bcd8739ae039 = $44e40bfc1d5457a6$var$RiskBar;


var $9f598a52270fcc8c$export$2e2bcd8739ae039 = (0, $44e40bfc1d5457a6$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $ebb592c91ace2df2$export$e6dfd72ab29f8598 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  width: 100%;
`;
const $ebb592c91ace2df2$export$e7797fd764838308 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  background-color: ${({ theme: theme })=>theme.colors.backgroundLite};
  height: 13px;
  width: 100%;
  border-radius: 3px;
`;
const $ebb592c91ace2df2$export$407ded98a8f28593 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: absolute;
  top: 0;
  left: 0;
  height: 13px;
  background-color: ${({ theme: theme })=>`${theme.colors.primary}20`};
  border-right: 2px solid ${({ theme: theme })=>theme.colors.primary};
  border-radius: 3px 0 0 3px;
`;


function $73260deb129c6edd$var$MoneyBar(props) {
    // Destructure
    const { width: width, ...rest } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $ebb592c91ace2df2$export$e6dfd72ab29f8598), {
        ...rest,
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ebb592c91ace2df2$export$e7797fd764838308), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ebb592c91ace2df2$export$407ded98a8f28593), {
                style: {
                    width: width
                }
            })
        ]
    });
}
// Default Props
$73260deb129c6edd$var$MoneyBar.defaultProps = {
    width: ''
};
// Proptypes Validation
$73260deb129c6edd$var$MoneyBar.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    ])
};
var $73260deb129c6edd$export$2e2bcd8739ae039 = $73260deb129c6edd$var$MoneyBar;


var $0c49f31014f9f4a2$export$2e2bcd8739ae039 = (0, $73260deb129c6edd$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $986db810922f0c4d$export$e6dfd72ab29f8598 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: 100%;
`;
const $986db810922f0c4d$export$e7797fd764838308 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  background-color: ${({ theme: theme })=>theme.colors.backgroundLite};
  height: 10px;
  width: 100%;
  border-radius: 15px;
`;
const $986db810922f0c4d$export$460e3f9bbf2f34ce = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme: theme })=>`${theme.colors.background}`};
  height: 85px;
  width: 85px;
  border-radius: 100%;
  border: 5px solid ${({ theme: theme })=>theme.colors.background};
`;
const $986db810922f0c4d$export$698223c589197ab7 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme: theme })=>`${theme.colors.primary}20`};
  color: ${({ theme: theme })=>theme.colors.primary};
  height: 100%;
  width: 100%;
  border-radius: 100%;
`;
const $986db810922f0c4d$export$407ded98a8f28593 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 110px;
  width: 110px;
  border-radius: 100% !important;
  background: ${({ theme: theme, deg: deg })=>`conic-gradient(${theme.colors.yellowGreen} ${deg}deg, ${theme.colors.primary}20 0deg)`};
  border-radius: 15px;
`;


function $9b9f2ab0bdeb97b4$var$CircleProgressBar(props) {
    // Destructure
    const { width: width, children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $986db810922f0c4d$export$e6dfd72ab29f8598), {
        ...rest,
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $986db810922f0c4d$export$407ded98a8f28593), {
            deg: width / 100 * 360,
            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $986db810922f0c4d$export$460e3f9bbf2f34ce), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $986db810922f0c4d$export$698223c589197ab7), {
                    children: children && children
                })
            })
        })
    });
}
// Default Props
$9b9f2ab0bdeb97b4$var$CircleProgressBar.defaultProps = {
    width: '',
    children: ''
};
// Proptypes Validation
$9b9f2ab0bdeb97b4$var$CircleProgressBar.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    ]),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ])
};
var $9b9f2ab0bdeb97b4$export$2e2bcd8739ae039 = $9b9f2ab0bdeb97b4$var$CircleProgressBar;


var $cfa79532d2a0741d$export$2e2bcd8739ae039 = (0, $9b9f2ab0bdeb97b4$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $572a842dec10b615$export$e6dfd72ab29f8598 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: center;

  position: relative;

  & g {
    & #foreground {
      stroke: ${({ theme: theme })=>theme.colors.backgroundLite};
    }
  }
`;
const $572a842dec10b615$export$d9eb77d8aa91d4c8 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: center;

  position: absolute;
  width: 100%;
  height: 100%;
`;
const $572a842dec10b615$export$7c3018f441722857 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: center;

  position: absolute;
  width: 100%;
  height: 100%;
`;
const $572a842dec10b615$export$762240c6611b6ed2 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;

  width: ${({ size: size })=>`${size}px`};
  height: ${({ size: size })=>`${size}px`};
`;
const $572a842dec10b615$export$5f1af8db9871e1d6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 12px;
  color: ${({ theme: theme })=>theme.colors.secondary};
`;


function $a11b5c3f100394ce$var$CircularProgressBar(props) {
    const { size: sizeProp, progress: progressProp, id: id, children: children, ...rest } = props;
    // Usestates
    const [size, setSize] = (0, $tZqWC.useState)(sizeProp);
    const [progress, setProgress] = (0, $tZqWC.useState)(progressProp);
    // Advanced
    const strokeWidth = (0, $tZqWC.useMemo)(()=>size * 0.12, [
        size
    ]);
    const center = (0, $tZqWC.useMemo)(()=>size / 2, [
        size
    ]);
    const radius = (0, $tZqWC.useMemo)(()=>size / 2 - strokeWidth / 2, [
        strokeWidth
    ]);
    const circumference = (0, $tZqWC.useMemo)(()=>2 * Math.PI * radius, [
        radius
    ]);
    const maskValue = (0, $tZqWC.useMemo)(()=>(100 - progress) * 0.7, [
        progress
    ]);
    // UseEffects
    (0, $tZqWC.useEffect)(()=>{
        setSize(sizeProp);
    }, [
        sizeProp
    ]);
    (0, $tZqWC.useEffect)(()=>{
        setProgress(progressProp);
    }, [
        progressProp
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $572a842dec10b615$export$e6dfd72ab29f8598), {
        ...rest,
        children: [
            strokeWidth && center && radius && circumference && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
                height: size,
                width: size,
                fill: "none",
                ...props,
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("g", {
                        transform: `rotate(216 ${center} ${center})`,
                        origin: center,
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("circle", {
                                id: "background",
                                cx: center,
                                cy: center,
                                r: radius,
                                strokeWidth: strokeWidth,
                                stroke: `url(#gradient${id})`,
                                strokeDasharray: circumference,
                                strokeDashoffset: circumference - circumference * 70 / 100,
                                transform: `translate(${2 * center},0) scale(-1, 1) `,
                                mask: `url(#circleMask${id})`
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("circle", {
                                id: "foreground",
                                transform: `translate(${2 * center},0) scale(-1, 1) `,
                                cx: center,
                                cy: center,
                                r: radius,
                                strokeWidth: strokeWidth + 1,
                                strokeDasharray: circumference,
                                strokeDashoffset: circumference - circumference * maskValue / 100
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("defs", {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("mask", {
                                id: `#circleMask${id}`,
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("rect", {
                                        x: "0",
                                        y: "0",
                                        width: "100%",
                                        height: "100%",
                                        fill: "white"
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("circle", {
                                        cx: center,
                                        cy: center,
                                        r: radius,
                                        strokeWidth: strokeWidth + 20,
                                        stroke: "black",
                                        fill: "none",
                                        strokeDasharray: circumference,
                                        strokeDashoffset: circumference - circumference * maskValue / 100
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("linearGradient", {
                                id: `gradient${id}`,
                                x1: "0%",
                                y1: "0%",
                                x2: "100%",
                                y2: "100%",
                                gradientUnits: "userSpaceOnUse",
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("stop", {
                                        stopColor: "#CAFF0A"
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("stop", {
                                        offset: "30%",
                                        stopColor: "#CAFF0A"
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("stop", {
                                        offset: "50%",
                                        stopColor: "#EC8800"
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("stop", {
                                        offset: "100%",
                                        stopColor: "#CB5300"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $572a842dec10b615$export$d9eb77d8aa91d4c8), {
                children: [
                    children,
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $572a842dec10b615$export$7c3018f441722857), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $572a842dec10b615$export$762240c6611b6ed2), {
                            size: size,
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $572a842dec10b615$export$5f1af8db9871e1d6), {
                                    children: "Low"
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $572a842dec10b615$export$5f1af8db9871e1d6), {
                                    children: "High"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
// Default Props
$a11b5c3f100394ce$var$CircularProgressBar.defaultProps = {
    size: 100,
    progress: 0,
    children: '',
    id: ''
};
// Proptypes Validation
$a11b5c3f100394ce$var$CircularProgressBar.propTypes = {
    size: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    progress: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ])
};
var $a11b5c3f100394ce$export$2e2bcd8739ae039 = $a11b5c3f100394ce$var$CircularProgressBar;


var $ba8982a7854b309f$export$2e2bcd8739ae039 = (0, $a11b5c3f100394ce$export$2e2bcd8739ae039);



/* eslint-disable react/forbid-prop-types */ 

var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $1bc4b33b919eb7b6$export$64761ff3688f328 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  width: 100%;
  margin-top: ${({ label: label })=>label ? '-5px;' : '40px;'};
  /* background: ${({ theme: theme })=>theme.colors.background};

  border-radius: ${({ open: open })=>open ? '10px 10px 0 0' : '10px'};
  box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.07); */
`;
const $1bc4b33b919eb7b6$export$ca4b1fc43afa0212 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  gap: 20px;
`;
const $1bc4b33b919eb7b6$export$2f96f6f204f87534 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 20px;
  width: 100%;
  max-height: 35.5px;

  opacity: 1;
  transition: 0.3s;

  max-width: ${({ collapseFilter: collapseFilter })=>collapseFilter ? '0px' : '2000px'};
  overflow: ${({ collapseFilter: collapseFilter })=>collapseFilter ? 'hidden' : 'visible'};
`;




// Function that listens to oustide clicks of given ref
const $3a8b1bf51a4fb7a5$var$useOutsideAlerter = (ref, handleClose)=>{
    (0, $tZqWC.useEffect)(()=>{
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) handleClose();
        }
        document.addEventListener('mousedown', handleClickOutside);
        return ()=>{
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [
        ref
    ]);
};
function $3a8b1bf51a4fb7a5$var$ButtonFilter(props) {
    // Destructure
    const { filter: // label,
    // options,
    // disabledOptions,
    // setOptions,
    // placeholder,
    filter, id: // bottomOptions,
    // onInputChange,
    // disabled,
    // onSelect,
    // isLoading,
    // value,
    id, ...rest } = props;
    // Variables
    const wrapperRef = (0, $tZqWC.useRef)();
    // States
    const [collapseFilter, setCollapseFilter] = (0, $tZqWC.useState)(true);
    // Functions
    const handleCollapseFilter = ()=>{
        setCollapseFilter((prevState)=>!prevState);
    };
    // Closing options on click away
    $3a8b1bf51a4fb7a5$var$useOutsideAlerter(wrapperRef, handleCollapseFilter);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1bc4b33b919eb7b6$export$64761ff3688f328), {
        children: filter && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $1bc4b33b919eb7b6$export$ca4b1fc43afa0212), {
            id: id,
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e99593d75dd35a7e$export$2e2bcd8739ae039), {
                    size: "small",
                    onClick: handleCollapseFilter,
                    startIcon: collapseFilter ? /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $163f23491e8bc756$export$2e2bcd8739ae039), {
                        size: 14
                    }) : /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b77b5de3fb591045$export$2e2bcd8739ae039), {
                        size: 14
                    }),
                    variant: "outlined",
                    ...rest,
                    children: collapseFilter ? 'Filters' : 'Close'
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1bc4b33b919eb7b6$export$2f96f6f204f87534), {
                    collapseFilter: collapseFilter,
                    children: filter
                })
            ]
        })
    });
}
// Default Props
$3a8b1bf51a4fb7a5$var$ButtonFilter.defaultProps = {
    id: '',
    label: '',
    placeholder: '',
    options: [],
    setOptions: ()=>{},
    onSelect: ()=>{},
    onInputChange: ()=>{},
    isLoading: false,
    disabled: false,
    value: ''
};
// Proptypes Validation
$3a8b1bf51a4fb7a5$var$ButtonFilter.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    options: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Array),
    setOptions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    onSelect: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    onInputChange: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    disabledOptions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    filter: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).any,
    bottomOptions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).any
};
var $3a8b1bf51a4fb7a5$export$2e2bcd8739ae039 = $3a8b1bf51a4fb7a5$var$ButtonFilter;


var $246a616d3a63a7c1$export$2e2bcd8739ae039 = (0, $3a8b1bf51a4fb7a5$export$2e2bcd8739ae039);


/* eslint-disable react/no-array-index-key */ 

var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");




const $99184e4597f6f950$export$d53c836cccbb0d90 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  display: flex;
`;
const $99184e4597f6f950$export$eddf54ea3db8d0f0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  background-color: ${({ theme: theme })=>theme.colors.background};
  border: ${({ theme: theme })=>`2px solid ${theme.colors.backgroundLite}`};
  color: ${({ theme: theme })=>theme.colors.primary};
  padding: 5px;
  border-radius: 10px;

  & button:first-child {
    padding: 3px 10px;
    border-radius: 0;
    border-right: 1px solid ${({ theme: theme })=>theme.colors.background};
  }
  & button:last-child {
    padding: 3px 5px;
  }

  & button {
    background-color: ${({ theme: theme })=>theme.colors.background};
    border: ${({ theme: theme })=>`2px solid ${theme.colors.background}`};
    color: ${({ theme: theme })=>theme.colors.primary};
    & svg > * {
      stroke: ${({ theme: theme })=>theme.colors.primary};
    }
  }
  & button:hover {
    opacity: 0.8;
    background-color: ${({ theme: theme })=>theme.colors.backgroundLite};
    border: ${({ theme: theme })=>`2px solid ${theme.colors.backgroundLite}`};
    color: ${({ theme: theme })=>theme.colors.primary};

    & svg > * {
      stroke: ${({ theme: theme })=>theme.colors.primary};
    }

    &:last-child {
      border-radius: 0 5px 5px 0;
    }
    &:first-child {
      border-radius: 5px 0 0 5px;
    }
  }
`;
const $99184e4597f6f950$export$8ddf75262614729 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: absolute;
  margin-top: 5px;
  top: 100%;
  right: 0;
  width: 100%;
  z-index: 1;

  display: flex;
  flex-direction: column;
  padding: 10px;

  background-color: ${({ theme: theme })=>theme.colors.background};
  border: ${({ theme: theme })=>`2px solid ${theme.colors.backgroundLite}`};
  border-radius: 10px;

  & button {
    width: 100%;
    background-color: transparent;
    border: none;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  & button:hover {
    background-color: transparent;
    color: ${({ theme: theme })=>theme.colors.brand};
    border: none;
  }
`;
const $99184e4597f6f950$export$9405ec469c396699 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: 100%;
  border-top: ${({ theme: theme })=>`2px solid ${theme.colors.backgroundLite}`};
  height: 2px;
`;


function $6f099a07cd068522$var$ButtonSplitSelect(props) {
    // Destructure
    const { type: type, value: value, onClick: onClick, variant: variant, fullWidth: fullWidth, disabled: disabled, options: options, children: children } = props;
    // Hooks
    const [isExpanded, setIsExpanded] = (0, $tZqWC.useState)(false);
    // Refs
    const btnRef = (0, $tZqWC.useRef)();
    // utils
    (0, $54f47a39f461db48$export$50ec7b7ff742aae5)(btnRef, setIsExpanded);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $99184e4597f6f950$export$d53c836cccbb0d90), {
        ref: btnRef,
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $99184e4597f6f950$export$eddf54ea3db8d0f0), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e99593d75dd35a7e$export$2e2bcd8739ae039), {
                        type: type,
                        size: "small",
                        onClick: onClick,
                        variant: variant,
                        fullWidth: fullWidth,
                        disabled: disabled,
                        value: value,
                        children: children && children
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e99593d75dd35a7e$export$2e2bcd8739ae039), {
                        type: "button",
                        size: "small",
                        onClick: ()=>{
                            setIsExpanded(!isExpanded);
                        },
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $4319efa3b26da07e$export$2e2bcd8739ae039), {})
                    })
                ]
            }),
            isExpanded && options && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $99184e4597f6f950$export$8ddf75262614729), {
                children: options.map((item, i)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $99184e4597f6f950$export$9405ec469c396699), {}),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e99593d75dd35a7e$export$2e2bcd8739ae039), {
                                color: "tertiary",
                                size: "small",
                                onClick: ()=>{
                                    setIsExpanded(!isExpanded);
                                    item.onClick();
                                },
                                value: item.value,
                                endIcon: item.endIcon
                            }, i)
                        ]
                    }))
            })
        ]
    });
}
// Default Props
$6f099a07cd068522$var$ButtonSplitSelect.defaultProps = {
    onClick: ()=>{},
    type: 'primary',
    value: '',
    variant: 'contained',
    fullWidth: false,
    disabled: false,
    options: []
};
// Proptypes Validation
$6f099a07cd068522$var$ButtonSplitSelect.propTypes = {
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    variant: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    fullWidth: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ]),
    options: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        value: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        onClick: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        endIcon: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
            (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
        ])
    }))
};
var $6f099a07cd068522$export$2e2bcd8739ae039 = $6f099a07cd068522$var$ButtonSplitSelect;


var $431db40ca57b78c9$export$2e2bcd8739ae039 = (0, $6f099a07cd068522$export$2e2bcd8739ae039);


/* eslint-disable react/no-array-index-key */ 
parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $a3c4b54c08f1ad26$export$1a39e1dbc61f7b9a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: 100%;
  padding-bottom: 31px;
  border-collapse: collapse;
`;
const $a3c4b54c08f1ad26$export$b19f7435132f3c6e = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  // Themed Properties
  border-bottom: ${({ theme: theme })=>`2px solid ${theme.colors.primary}`};

  // Conditional Properties
  ${({ withHeader: withHeader })=>!withHeader && 'display: none;'}
`;
const $a3c4b54c08f1ad26$export$36573e250be9fa34 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  padding: 5px 0;
`;
const $a3c4b54c08f1ad26$export$d26ce3ae0eb07079 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  padding: 5px 0;
`;
const $a3c4b54c08f1ad26$export$13cdc9bdf71ffbf7 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 14px;
  font-weight: 400;
  font-family: Roboto;

  text-align: right;
  -webkit-font-smoothing: antialiased;

  // TODO: Use theme functions
  &:first-of-type {
    text-align: left;
  }

  // Themed Properties
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $a3c4b54c08f1ad26$export$b2ec8499d4fe8ec = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  // Conditional Properties
  ${({ withData: withData })=>!withData && 'display: none;'}
`;
const $a3c4b54c08f1ad26$export$a090da186c207e1c = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  padding: 5px 0;

  // Themed Properties
  border-bottom: ${({ theme: theme })=>`1px solid ${theme.colors.backgroundLite}`};
`;
const $a3c4b54c08f1ad26$export$6ca34208ed16a999 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  padding: 5px 0;

  // Themed Properties
  border-bottom: ${({ theme: theme })=>`1px solid ${theme.colors.backgroundLite}`};
`;
const $a3c4b54c08f1ad26$export$65215521ba8e46f8 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 14px;
  font-weight: 400;
  font-family: Roboto;

  text-align: right;
  -webkit-font-smoothing: antialiased;

  // TODO: Use theme functions
  &:first-of-type {
    text-align: left;
    font-weight: 100;
  }

  // Themed Properties
  color: ${({ theme: theme })=>theme.colors.primary};
`;


function $2e06e4f767ae86c4$var$DataBreakdownTable(props) {
    // Destructure
    const { headers: headers, data: data } = props;
    // Variable
    const withHeader = headers.length;
    const withData = data.length;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $a3c4b54c08f1ad26$export$1a39e1dbc61f7b9a), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3c4b54c08f1ad26$export$b19f7435132f3c6e), {
                withHeader: withHeader,
                children: headers?.length > 2 ? /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3c4b54c08f1ad26$export$d26ce3ae0eb07079), {
                    children: headers && headers.map((name, i)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3c4b54c08f1ad26$export$13cdc9bdf71ffbf7), {
                            children: name
                        }, i))
                }) : /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3c4b54c08f1ad26$export$36573e250be9fa34), {
                    children: headers && headers.map((name, i)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3c4b54c08f1ad26$export$13cdc9bdf71ffbf7), {
                            children: name
                        }, i))
                })
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3c4b54c08f1ad26$export$b2ec8499d4fe8ec), {
                withData: withData,
                children: data && headers?.length > 2 ? data.map(({ name: name, data: data }, i)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $a3c4b54c08f1ad26$export$6ca34208ed16a999), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3c4b54c08f1ad26$export$65215521ba8e46f8), {
                                children: name
                            }),
                            data.map((value, i)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3c4b54c08f1ad26$export$65215521ba8e46f8), {
                                    children: value
                                }, i))
                        ]
                    }, i)) : data.map(({ name: name, data: data }, i)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $a3c4b54c08f1ad26$export$a090da186c207e1c), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3c4b54c08f1ad26$export$65215521ba8e46f8), {
                                children: name
                            }),
                            data.map((value, i)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3c4b54c08f1ad26$export$65215521ba8e46f8), {
                                    children: value
                                }, i))
                        ]
                    }, i))
            })
        ]
    });
}
// Default Props
$2e06e4f767ae86c4$var$DataBreakdownTable.defaultProps = {
    headers: [],
    data: []
};
// Proptypes Validation
$2e06e4f767ae86c4$var$DataBreakdownTable.propTypes = {
    headers: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Array),
    data: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Array)
};
var $2e06e4f767ae86c4$export$2e2bcd8739ae039 = $2e06e4f767ae86c4$var$DataBreakdownTable;


var $a327d89f9c78791e$export$2e2bcd8739ae039 = (0, $2e06e4f767ae86c4$export$2e2bcd8739ae039);


/* eslint-disable react/no-array-index-key */ 
parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $53cdb4ba6311901f$export$8be2fd478ca98928 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 0 0 30px 0;
`;
const $53cdb4ba6311901f$export$8be602f50b4943be = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 5px 0;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 2.3fr;
  
  font-size: 14px;
  font-weight: 300;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $53cdb4ba6311901f$export$91aee0d5fc0a4b2f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  text-align: right;
  &:first-child {
    text-align: left;
  }
`;
const $53cdb4ba6311901f$export$4b2dccc09b8448ee = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 5px 0px 10px 0px;

  border-top: ${({ theme: theme })=>`2px solid ${theme.colors.primary}`};
  border-bottom: ${({ theme: theme })=>`2px solid ${theme.colors.primary}`};

  max-height: 120px;
  min-height: 120px;
  overflow-y: auto;
`;
const $53cdb4ba6311901f$export$ad417a3002a11c59 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).span`
  padding-right: 5px;
  
  font-weight: 300;
`;
const $53cdb4ba6311901f$export$ac8475813a60081e = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  padding: 5px 0;
  grid-template-columns: 1fr 1fr 1fr 2.3fr;

  border-bottom: ${({ theme: theme })=>`1px solid ${theme.colors.backgroundLite}`};
  
  font-size: 14px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $53cdb4ba6311901f$export$d7ffd008943baa91 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  text-align: right;
  &:first-child {
    text-align: left;
  }
`;


const $ecf1d77ac1b82678$export$a2db1876938cd11d = (value)=>value ? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : value;
const $ecf1d77ac1b82678$export$36d5e0d2b514f546 = (value, decimalPlace = 0)=>{
    const si = [
        {
            value: 1,
            symbol: ''
        },
        {
            value: 1e3,
            symbol: ' k'
        },
        {
            value: 1e6,
            symbol: ' M'
        },
        {
            value: 1e9,
            symbol: ' B'
        },
        {
            value: 1e12,
            symbol: ' T'
        }
    ];
    const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    let i;
    for(i = si.length - 1; i > 0; i--){
        if (Number.isNaN(value) ? 0 : value >= si[i].value) break;
    }
    const safeValue = value / si[i].value || 0;
    return $ecf1d77ac1b82678$export$a2db1876938cd11d(safeValue.toFixed(decimalPlace).replace(rx, '$1')) + si[i].symbol;
};
const $ecf1d77ac1b82678$export$24f8d0049300de03 = (value)=>value.replace('-', ' ');
const $ecf1d77ac1b82678$export$866ef2858852149a = Intl.NumberFormat('en', {
    notation: 'compact'
});
const $ecf1d77ac1b82678$export$b45ea3e8106087a8 = Intl.NumberFormat('en');
const $ecf1d77ac1b82678$export$7dac1d63a1a3adff = (str)=>str.split(' ').map((word)=>word.charAt(0).toUpperCase() + word.slice(1)).join(' ');


function $1f039e24a84dc549$var$DataBreakdownTableScroll(props) {
    // Destructure
    const { headers: headers, data: data } = props;
    // Variable
    const withHeader = headers.length;
    const withData = data.length;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $53cdb4ba6311901f$export$8be2fd478ca98928), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $53cdb4ba6311901f$export$8be602f50b4943be), {
                children: withHeader && headers.map((name, i)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $53cdb4ba6311901f$export$91aee0d5fc0a4b2f), {
                        children: name
                    }, i))
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $53cdb4ba6311901f$export$4b2dccc09b8448ee), {
                children: withData && data.map((item, i)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $53cdb4ba6311901f$export$ac8475813a60081e), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $53cdb4ba6311901f$export$d7ffd008943baa91), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $53cdb4ba6311901f$export$ad417a3002a11c59), {
                                        children: item.token_symbol
                                    }),
                                    item.token_name
                                ]
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $53cdb4ba6311901f$export$d7ffd008943baa91), {
                                title: `${(0, $ecf1d77ac1b82678$export$a2db1876938cd11d)(item.balance_usd)}`,
                                children: [
                                    "$",
                                    (0, $ecf1d77ac1b82678$export$36d5e0d2b514f546)(item.balance_usd)
                                ]
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $53cdb4ba6311901f$export$d7ffd008943baa91), {
                                title: `${(0, $ecf1d77ac1b82678$export$a2db1876938cd11d)(item.balance)}`,
                                children: (0, $ecf1d77ac1b82678$export$36d5e0d2b514f546)(item.balance)
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $53cdb4ba6311901f$export$d7ffd008943baa91), {
                                children: item.token_address
                            })
                        ]
                    }, i))
            })
        ]
    });
}
// Default Props
$1f039e24a84dc549$var$DataBreakdownTableScroll.defaultProps = {
    headers: [],
    data: []
};
// Proptypes Validation
$1f039e24a84dc549$var$DataBreakdownTableScroll.propTypes = {
    headers: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Array),
    data: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Array)
};
var $1f039e24a84dc549$export$2e2bcd8739ae039 = $1f039e24a84dc549$var$DataBreakdownTableScroll;


var $0ebbffae0cb1277a$export$2e2bcd8739ae039 = (0, $1f039e24a84dc549$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $e43d514ba8169b10$export$aa2701f40b51de05 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 10px;
  width: 100%;
`;
const $e43d514ba8169b10$export$8e997029ddacd4cf = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 62px;

  padding: 10px 10px 0px 10px;
  border-radius: 5px;

  background-color: ${({ theme: theme })=>theme.colors.background};
  color: ${({ theme: theme })=>theme.colors.primary};
  border: ${({ theme: theme })=>`solid 1px ${theme.colors.backgroundLite}`};
`;
const $e43d514ba8169b10$export$85f6abbce7b266fb = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 12px;
  font-weight: 500;
`;
const $e43d514ba8169b10$export$4e5b825bf7b8903c = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 30px;
  font-weight: 500;
`;
const $e43d514ba8169b10$export$97092a2fc35766fa = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 12px;
  position: absolute;
  bottom: 7px;
  right: 7px;

`;


function $a9d13c554082a3aa$var$AlertBreakDownBoxes(props) {
    // Destructure
    const { data: data } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e43d514ba8169b10$export$aa2701f40b51de05), {
        children: data?.length > 0 && data.map((item)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $e43d514ba8169b10$export$8e997029ddacd4cf), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $e43d514ba8169b10$export$85f6abbce7b266fb), {
                        children: [
                            item.alert_status,
                            " Alerts"
                        ]
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e43d514ba8169b10$export$4e5b825bf7b8903c), {
                        children: item.alert_count
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $e43d514ba8169b10$export$97092a2fc35766fa), {
                        children: [
                            item.percent,
                            "%"
                        ]
                    })
                ]
            }, item.alert_status))
    });
}
// Default Props
$a9d13c554082a3aa$var$AlertBreakDownBoxes.defaultProps = {
    data: []
};
// Proptypes Validation
$a9d13c554082a3aa$var$AlertBreakDownBoxes.propTypes = {
    data: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        alert_status: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        alert_count: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        percent: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number
    }))
};
var $a9d13c554082a3aa$export$2e2bcd8739ae039 = $a9d13c554082a3aa$var$AlertBreakDownBoxes;


var $b31c725c94cb80b7$export$2e2bcd8739ae039 = (0, $a9d13c554082a3aa$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $f0bb4b958e2c14ca$export$5f7211d21bfdae05 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 500px;
`;


function $45c3eac682169e84$var$Dropdown(props) {
    // Destructure
    const { children: children, direction: direction, isOpen: isOpen, toggle: toggle, ...rest } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f0bb4b958e2c14ca$export$5f7211d21bfdae05), {
        isOpen: isOpen,
        toggle: toggle,
        direction: direction,
        ...rest,
        children: children
    });
}
// Default Props
$45c3eac682169e84$var$Dropdown.defaultProps = {
    children: '',
    direction: '',
    isOpen: false,
    toggle: ()=>{}
};
// Proptypes Validation
$45c3eac682169e84$var$Dropdown.propTypes = {
    direction: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    toggle: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ])
};
var $45c3eac682169e84$export$2e2bcd8739ae039 = $45c3eac682169e84$var$Dropdown;


var $3d924f0f94116478$export$2e2bcd8739ae039 = (0, $45c3eac682169e84$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $6131ff7b0912a79b$export$f713b95536ce1a73 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  position: relative;
`;



// DropdownContext.js

var $tZqWC = parcelRequire("tZqWC");
const $f18b2b41e533080d$export$df140987c38a308d = /*#__PURE__*/ (0, $tZqWC.createContext)();
const $f18b2b41e533080d$export$8c32fdb3462273b4 = ()=>(0, $tZqWC.useContext)($f18b2b41e533080d$export$df140987c38a308d);


function $89b7e4c0bcb049ea$var$UncontrolledDropdown(props) {
    // Destructure
    const { children: children, direction: direction, ...rest } = props;
    // Local State
    const [isOpen, setIsOpen] = (0, $tZqWC.useState)(false);
    const toggle = (0, $tZqWC.useCallback)(()=>setIsOpen((prevValue)=>!prevValue), []);
    const close = (0, $tZqWC.useCallback)(()=>setIsOpen(false), []);
    const contextValue = (0, $tZqWC.useMemo)(()=>({
            isOpen: isOpen,
            toggle: toggle,
            close: close,
            direction: direction
        }), [
        isOpen,
        toggle,
        close,
        direction
    ]);
    // Refs
    const btnRef = (0, $tZqWC.useRef)();
    // utils
    (0, $54f47a39f461db48$export$50ec7b7ff742aae5)(btnRef, close);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f18b2b41e533080d$export$df140987c38a308d).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6131ff7b0912a79b$export$f713b95536ce1a73), {
            direction: direction,
            ...rest,
            ref: btnRef,
            children: children
        })
    });
}
// Default Props
$89b7e4c0bcb049ea$var$UncontrolledDropdown.defaultProps = {
    children: '',
    direction: ''
};
// Proptypes Validation
$89b7e4c0bcb049ea$var$UncontrolledDropdown.propTypes = {
    direction: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ])
};
var $89b7e4c0bcb049ea$export$2e2bcd8739ae039 = $89b7e4c0bcb049ea$var$UncontrolledDropdown;


var $ca6f920a36c82944$export$2e2bcd8739ae039 = (0, $89b7e4c0bcb049ea$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $1662035c760adcc4$export$145fd9ebbc372ed1 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  padding: 0 5px;
  text-align: center;
  border-radius: 5px;
  cursor: pointer;

  // Themed Properties
  ${({ theme: theme })=>theme.functions.mixins.onEvent(`
    box-shadow: none;
    outline: 0;
  `)}
`;



function $76b4630bf899438e$var$DropdownToggle(props) {
    // Destructure
    const { children: children, caret: caret, color: color } = props;
    // Context
    const { toggle: toggle } = (0, $f18b2b41e533080d$export$8c32fdb3462273b4)();
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1662035c760adcc4$export$145fd9ebbc372ed1), {
        onClick: toggle,
        caret: caret,
        color: color,
        children: children
    });
}
// Default Props
$76b4630bf899438e$var$DropdownToggle.defaultProps = {
    caret: false,
    color: '',
    children: ''
};
// Proptypes Validation
$76b4630bf899438e$var$DropdownToggle.propTypes = {
    caret: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ])
};
var $76b4630bf899438e$export$2e2bcd8739ae039 = $76b4630bf899438e$var$DropdownToggle;


var $478ff5739380e08c$export$2e2bcd8739ae039 = (0, $76b4630bf899438e$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");
/* eslint-disable max-len */ 
const $a8d803bdab3860a6$export$830205478e704534 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: absolute;
  z-index: 3;

  ${({ direction: direction })=>direction === 'down' && 'top: 100%;'}
  ${({ direction: direction })=>direction === 'up' && 'bottom: 100%;'}
  
  ${({ end: end })=>!end && 'left: 0;'}
  ${({ end: end })=>end && 'right: 0;'}
  
  ${({ isOpen: isOpen, theme: theme })=>isOpen && `max-height: 700px; 
    padding: 5px; 
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.15); 
    overflow: visible;
    border: 1px solid ${theme.colors.borderColor};`}
  ${({ isOpen: isOpen, theme: theme })=>!isOpen && `
    max-height: 0; 
    padding: 0px; 
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0); 
    overflow: hidden;
    border: 0px solid ${theme.colors.borderColor};`}


  margin: 5px 0;
  background: ${({ theme: theme })=>theme.colors.background};
  border-radius: 10px;
  min-width: 230px;

  transition: 0.2s;
`;



function $9a31681822d9be3d$var$DropdownMenu(props) {
    // Destructure
    const { children: children, left: left, ...rest } = props;
    // Context
    const { isOpen: isOpen, direction: direction } = (0, $f18b2b41e533080d$export$8c32fdb3462273b4)();
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a8d803bdab3860a6$export$830205478e704534), {
        direction: direction,
        isOpen: isOpen,
        end: left,
        ...rest,
        children: children
    });
}
// Default Props
$9a31681822d9be3d$var$DropdownMenu.defaultProps = {
    left: false,
    children: ''
};
// Proptypes Validation
$9a31681822d9be3d$var$DropdownMenu.propTypes = {
    left: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    ]),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ])
};
var $9a31681822d9be3d$export$2e2bcd8739ae039 = $9a31681822d9be3d$var$DropdownMenu;


var $7a68433660fee9cb$export$2e2bcd8739ae039 = (0, $9a31681822d9be3d$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $8f5f74328f70d5cb$export$9483a234b63f52ae = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;

  padding: 8px 20px;

  font-weight: 300;
  font-size: 16px;
  color: ${({ theme: theme, disabled: disabled })=>disabled ? theme.colors.brand : theme.colors.primary};

  transition: 0.3s;
  cursor: pointer;

  & svg {
    max-width: 20px;
  }
  & svg > path {
    stroke: ${({ theme: theme })=>theme.colors.primary};
  }
  & svg > ellipse {
    fill: ${({ theme: theme })=>theme.colors.primary};
  }
  & svg > circle {
    stroke: ${({ theme: theme })=>theme.colors.primary};
  }
  & svg > rect {
    stroke: ${({ theme: theme })=>theme.colors.primary};
  }
  &:not(:last-child) {
    border-bottom: 2px solid ${({ theme: theme })=>theme.colors.backgroundLite};
  }
  &:first-child {
    border-radius: 7px 7px 0 0;
  }
  &:last-child {
    border-radius: 0 0 7px 7px;
  }
  &:only-child {
    border-radius: 7px;
  }

  &:hover {
    background-color: ${({ theme: theme, disabled: disabled })=>!disabled && theme.colors.backgroundLite};
  }

  &:focus {
    background-color: unset;
    color: inherit;
  }

  cursor: ${({ disabled: disabled })=>disabled && 'not-allowed'};

  & p {
    color: ${({ theme: theme, disabled: disabled })=>disabled ? theme.colors.secondary : theme.colors.primary};
  }
  & a {
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-width: 200px;

    padding: 5px 0px;
    font-size: 15px;
    font-weight: 400;
    color: ${({ theme: theme, disabled: disabled })=>disabled ? theme.colors.secondary : theme.colors.primary};

    & > svg {
      height: 12px;
      width: 12px;
    }
  }
`;


function $59b3f17000547f94$var$DropdownItem(props) {
    // Destructure
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $8f5f74328f70d5cb$export$9483a234b63f52ae), {
        ...rest,
        children: children
    });
}
// Default Props
$59b3f17000547f94$var$DropdownItem.defaultProps = {
    children: ''
};
// Proptypes Validation
$59b3f17000547f94$var$DropdownItem.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ])
};
var $59b3f17000547f94$export$2e2bcd8739ae039 = $59b3f17000547f94$var$DropdownItem;


var $c7b007afae0a2778$export$2e2bcd8739ae039 = (0, $59b3f17000547f94$export$2e2bcd8739ae039);


/* eslint-disable no-nested-ternary */ 
parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");



const $5155947f39a5fc97$export$4267411171632d35 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: 100%;
  height: fit-content;

  font-size: 18px;

  display: flex;
  flex-direction: column;
  gap: 10px;
`;
const $5155947f39a5fc97$export$3613a8ca9911582e = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 20px;
  border-radius: 15px;

  // Themed Properties
  background: ${({ theme: theme })=>theme.colors.background};
  border: 1px solid ${({ theme: theme })=>theme.colors.backgroundLite};
`;
const $5155947f39a5fc97$export$95894068160c7b16 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-self: flex-end;
`;
const $5155947f39a5fc97$export$a8c98c079905a0dd = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  gap: 5px;
`;
const $5155947f39a5fc97$export$ca4b1fc43afa0212 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-end;

  height: 0px;
  width: 100%;
  padding: 0px 20px;
  border: 1px solid ${({ theme: theme })=>theme.colors.background};
  border-top: none;
  border-radius: 0 0 15px 15px;
  transform: translateY(-22px);

  transition: all 0.3s;

  // Themed Properties
  background: ${({ theme: theme })=>theme.colors.background};

  // Responsive Properties
  ${({ theme: theme })=>theme.functions.mediaQuery('display', [
        'none',
        'none',
        'none',
        'none',
        'none',
        'flex'
    ])}

  // Conditional Properties
  ${({ collapseFilter: collapseFilter, withFilter: withFilter })=>!collapseFilter && withFilter ? 'height: auto;' : 'height: 0;'}
  ${({ collapseFilter: collapseFilter, withFilter: withFilter })=>!collapseFilter && withFilter && 'padding: 20px;'}
  ${({ collapseFilter: collapseFilter, withFilter: withFilter })=>!collapseFilter && withFilter ? 'overflow: visible;' : 'overflow: hidden;'}
  ${({ theme: theme, collapseFilter: collapseFilter, withFilter: withFilter })=>!collapseFilter && withFilter && `border: 1px solid ${theme.colors.backgroundLite}; border-top: none;`}
`;
const $5155947f39a5fc97$export$bdc7a021372550df = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  overflow-x: visible;
`;
const $5155947f39a5fc97$export$e69b868dadc3d68f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  ${({ minWidth: minWidth })=>minWidth && `min-width: ${minWidth}px;`}
`;
const $5155947f39a5fc97$export$f8fabc1369b3b337 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: none;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: ${(props)=>props.gap ? `${props.gap}px` : '10px'};

  padding: ${(props)=>props.headerPadding ? `${props.headerPadding}` : '20px'};
  border: 1px solid ${({ theme: theme })=>theme.colors.backgroundLite};
  background: ${({ theme: theme })=>theme.colors.background};
  border-radius: 15px;

  // Conditional Properties
  ${({ showHeader: showHeader })=>showHeader && 'display: flex;'}
`;
const $5155947f39a5fc97$export$7c49f4ee92af794 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  flex: 1;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  white-space: nowrap;

  text-align: left;
  font-weight: 400;
  font-size: 15px;
  font-family: Roboto;

  // Themed Properties
  color: ${({ theme: theme })=>theme.colors.primary};

  // Conditional Properties
  ${({ sortable: sortable })=>sortable && 'cursor: pointer;'}
  ${({ width: width })=>width && `width: ${width}px;`}
  ${({ width: width })=>width && 'flex: none;'}
`;
const $5155947f39a5fc97$export$7afd0841c5547fb9 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $5155947f39a5fc97$export$6facde1b466086d6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  text-align: left;
  font-size: 12px;
  font-weight: 300;
`;
const $5155947f39a5fc97$export$cd1a4d589804f400 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).span`
  display: none;

  margin: 0px 0px 0px 6px;
  transition: all 0.1s ease-in;

  // Conditional Properties
  ${({ active: active })=>active && 'display: flex;'}
  ${({ sortDirection: sortDirection })=>sortDirection === 'DESC' && 'transform: rotate(180deg);'}
`;
const $5155947f39a5fc97$export$58cbaf49f81d530a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;



// Map Redux Props
const $0fc581bc3bb7f47f$var$mapStateToProps = ({ filters: filters })=>({
        filters: filters
    });
const $0fc581bc3bb7f47f$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $0fc581bc3bb7f47f$var$Table(props) {
    // Destructure
    const { totalItems: totalItems, filterComponents: filterComponents, tableFilters: tableFilters, hidePagination: hidePagination, setTableFilters: setTableFilters, children: children, minWidth: minWidth } = props;
    // States
    const { size: size, page: page } = tableFilters;
    // Functions
    const handlePageChange = async ({ page: page, size: size })=>{
        await setTableFilters({
            ...tableFilters,
            page: page,
            size: size
        });
    };
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $5155947f39a5fc97$export$4267411171632d35), {
                allowZeroExpanded: true,
                children: [
                    filterComponents && filterComponents,
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5155947f39a5fc97$export$bdc7a021372550df), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5155947f39a5fc97$export$e69b868dadc3d68f), {
                            minWidth: minWidth,
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5155947f39a5fc97$export$58cbaf49f81d530a), {
                                children: children
                            })
                        })
                    })
                ]
            }),
            !hidePagination && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9deaec2f043c7dfd$export$2e2bcd8739ae039), {
                itemsCountPerPage: size,
                totalItemsCount: totalItems,
                page: page,
                pageRangeDisplayed: 5,
                onChange: handlePageChange
            })
        ]
    });
}
// Default Props
$0fc581bc3bb7f47f$var$Table.defaultProps = {
    totalItems: 0,
    filterComponents: '',
    filters: {},
    actions: {}
};
// Proptypes Validation
$0fc581bc3bb7f47f$var$Table.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ]),
    minWidth: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
    totalItems: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
    filterComponents: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ]),
    tableFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        sortBy: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        sortDirection: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        page: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        size: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number
    }),
    setTableFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({}),
    hidePagination: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({})
};
var $0fc581bc3bb7f47f$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($0fc581bc3bb7f47f$var$mapStateToProps, $0fc581bc3bb7f47f$var$mapDispatchToProps)($0fc581bc3bb7f47f$var$Table);


var $06a400f584629957$export$2e2bcd8739ae039 = (0, $0fc581bc3bb7f47f$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $4806464c0fb19f25$export$70e76e17cbdfd358 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  padding: 10px 20px;

  // TODO: Use theme functions
  &:focus {
    outline: none;
  }

  border-radius: 10px;
  background: ${({ theme: theme })=>theme.colors.background};
  border: 1px solid ${({ theme: theme })=>theme.colors.backgroundLite};

  transition: 0.3s;
  border: 1px solid ${({ theme: theme })=>`${theme.colors.backgroundLite}`};
  &:hover {
    border: 1px solid ${({ theme: theme })=>`${theme.colors.brand}40`};
  }
`;
const $4806464c0fb19f25$export$97f72a458f7f2793 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  gap: 10px;
`;
const $4806464c0fb19f25$export$c8ac3ff7edb21922 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  flex: 1;
  font-weight: 100;
  font-size: 15px;
`;
const $4806464c0fb19f25$export$1bc4a606727dc98c = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  max-height: 30px;
  max-width: 30px;

  transition: all 0.15s ease-in;
`;
const $4806464c0fb19f25$export$b31430871ee3a3a7 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  max-height: 30px;
  max-width: 30px;

  transition: all 0.15s ease-in;
`;


function $10726a98b7d7fa02$var$TableItem(props) {
    // Destructure
    const { children: children, startIcon: startIcon, endIcon: endIcon } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $4806464c0fb19f25$export$70e76e17cbdfd358), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $4806464c0fb19f25$export$97f72a458f7f2793), {
            children: [
                startIcon && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $4806464c0fb19f25$export$1bc4a606727dc98c), {
                    children: startIcon
                }),
                children && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $4806464c0fb19f25$export$c8ac3ff7edb21922), {
                    children: children
                }),
                endIcon && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $4806464c0fb19f25$export$b31430871ee3a3a7), {
                    children: endIcon
                })
            ]
        })
    });
}
// Default Props
$10726a98b7d7fa02$var$TableItem.defaultProps = {
    children: '',
    endIcon: '',
    startIcon: ''
};
// Proptypes Validation
$10726a98b7d7fa02$var$TableItem.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ]),
    endIcon: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ]),
    startIcon: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ])
};
var $10726a98b7d7fa02$export$2e2bcd8739ae039 = $10726a98b7d7fa02$var$TableItem;


var $f32a2c939d2829ea$export$2e2bcd8739ae039 = (0, $10726a98b7d7fa02$export$2e2bcd8739ae039);


/* eslint-disable react/forbid-prop-types */ /* eslint-disable no-nested-ternary */ 

var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $6baa47136ba9474d$export$4267411171632d35 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: 100%;
  height: fit-content;
  height: 100%;

  font-size: 18px;
`;
const $6baa47136ba9474d$export$95894068160c7b16 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  margin-bottom: 20px;
`;
const $6baa47136ba9474d$export$a8c98c079905a0dd = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-end;
  gap: 5px;
  margin-bottom: -20px;
`;
const $6baa47136ba9474d$export$e69b868dadc3d68f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding-top: 40px;
  width: 100%;
`;
const $6baa47136ba9474d$export$58cbaf49f81d530a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  ${({ length: length, cardWidth: cardWidth })=>length > 1 && `grid-template-columns: repeat(auto-fill, minmax(${cardWidth}px, 1fr))`};
  ${({ length: length })=>!(length > 1) && 'grid-template-columns: 1fr'};
  gap: 20px;
`;



// Map Redux Props
function $b35d29c6fded8c5e$var$Table(props) {
    // Destructure
    const { headerOptions: headerOptions, children: children, totalItems: totalItems, minWidth: minWidth, filterComponents: filterComponents, tableFilters: tableFilters, setTableFilters: setTableFilters, tableKey: tableKey, cardWidth: cardWidth } = props;
    const { size: size, page: page } = tableFilters;
    const handlePageChange = async ({ page: page, size: size })=>{
        await setTableFilters({
            ...tableFilters,
            page: page,
            size: size
        });
    };
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6baa47136ba9474d$export$4267411171632d35), {
                allowZeroExpanded: true,
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6baa47136ba9474d$export$95894068160c7b16), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6baa47136ba9474d$export$a8c98c079905a0dd), {
                            children: headerOptions
                        })
                    }),
                    filterComponents && filterComponents,
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6baa47136ba9474d$export$e69b868dadc3d68f), {
                        minWidth: minWidth,
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6baa47136ba9474d$export$58cbaf49f81d530a), {
                            length: (0, $tZqWC.Children).count(children),
                            cardWidth: cardWidth || 300,
                            children: children
                        }, tableKey)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9deaec2f043c7dfd$export$2e2bcd8739ae039), {
                itemsCountPerPage: size,
                totalItemsCount: totalItems,
                page: page,
                pageRangeDisplayed: 5,
                onChange: handlePageChange
            })
        ]
    });
}
// Default Props
$b35d29c6fded8c5e$var$Table.defaultProps = {
    tableKey: undefined,
    headerOptions: '',
    children: '',
    minWidth: 0,
    totalItems: 0,
    filterComponents: '',
    tableFilters: {},
    actions: {}
};
// Proptypes Validation
$b35d29c6fded8c5e$var$Table.propTypes = {
    tableKey: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).any,
    headerOptions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ]),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ]),
    minWidth: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
    totalItems: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
    filterComponents: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ]),
    setTableFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    tableFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        page: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        size: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({}),
    cardWidth: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number
};
var $b35d29c6fded8c5e$export$2e2bcd8739ae039 = $b35d29c6fded8c5e$var$Table;


var $7139282abdeb8ca4$export$2e2bcd8739ae039 = (0, $b35d29c6fded8c5e$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $f2fd2af94c5311d7$export$70e76e17cbdfd358 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  border-radius: 10px;
  width: 100%;
  height: 100%;
  /* max-width: 450px; */
  transition: 0.3s;
  cursor: pointer;

  /* display: flex;
  justify-content: center;
  align-items: center; */

  // Themed Properties
  background-color: ${({ theme: theme })=>theme.colors.background};
  border: 1px solid ${({ theme: theme })=>theme.colors.backgroundLite};
  color: ${({ theme: theme })=>theme.colors.primary};
  border: 1px solid ${({ theme: theme })=>`${theme.colors.backgroundLite}`};
  &:hover {
    border: 1px solid ${({ theme: theme })=>`${theme.colors.brand}40`};
  }
`;


function $7d6426b4158f873d$var$CardTableItem(props) {
    // Destructure
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f2fd2af94c5311d7$export$70e76e17cbdfd358), {
        ...rest,
        children: children && children
    });
}
// Default Props
$7d6426b4158f873d$var$CardTableItem.defaultProps = {
    children: ''
};
// Proptypes Validation
$7d6426b4158f873d$var$CardTableItem.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ])
};
var $7d6426b4158f873d$export$2e2bcd8739ae039 = $7d6426b4158f873d$var$CardTableItem;


var $37202d75ee8521c4$export$2e2bcd8739ae039 = (0, $7d6426b4158f873d$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");
const $60e52eb6c2680325$export$96c4cef8dff1bd45 = ()=>{
    const token = localStorage.getItem('userCredentials');
    if (!token) return null;
    try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = atob(base64);
        const credentials = JSON.parse(jsonPayload);
        if (credentials?.csi !== undefined && credentials?.csi !== null) return credentials?.csi;
        return null;
    } catch (error) {
        return null;
    }
};
const $60e52eb6c2680325$export$7ca4b19155f576fa = (toggleUpgradeModal)=>{
    toggleUpgradeModal(true);
};



const $e96331e94b302397$export$e6dfd72ab29f8598 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: 100%;
  height: fit-content;

  font-size: 18px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
const $e96331e94b302397$export$ee4732a561d65ad3 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex: 1;
`;
const $e96331e94b302397$export$14966827497f4695 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  // Conditional Properties
  ${({ minWidth: minWidth })=>minWidth && `min-width: ${minWidth}px;`}
`;
const $e96331e94b302397$export$95894068160c7b16 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  margin-bottom: -20px;
`;
const $e96331e94b302397$export$a8c98c079905a0dd = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  gap: 5px;
  width: 100%;
`;
const $e96331e94b302397$export$db7e3192f4fa5264 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  height: 100%;
  width: 100%;
`;



function $354ef3273ec6220e$var$AccordionTable(props) {
    // Destructure
    const { headerOptions: headerOptions, children: children, minWidth: minWidth, totalItems: totalItems, filterComponents: filterComponents, tableFilters: tableFilters, setTableFilters: setTableFilters } = props;
    // States
    const { size: size, page: page } = tableFilters;
    const [csi] = (0, $tZqWC.useState)((0, $60e52eb6c2680325$export$96c4cef8dff1bd45)());
    // Variables
    // Functions
    const handlePageChange = async ({ page: page, size: size })=>{
        await setTableFilters({
            ...tableFilters,
            page: page,
            size: size
        });
    };
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $e96331e94b302397$export$e6dfd72ab29f8598), {
                allowZeroExpanded: true,
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e96331e94b302397$export$95894068160c7b16), {
                        children: headerOptions && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e96331e94b302397$export$a8c98c079905a0dd), {
                            children: headerOptions
                        })
                    }),
                    filterComponents && filterComponents,
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e96331e94b302397$export$ee4732a561d65ad3), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e96331e94b302397$export$14966827497f4695), {
                            minWidth: minWidth,
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e96331e94b302397$export$db7e3192f4fa5264), {
                                children: children
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9deaec2f043c7dfd$export$2e2bcd8739ae039), {
                itemsCountPerPage: size,
                totalItemsCount: totalItems,
                page: page,
                pageRangeDisplayed: 5,
                onChange: handlePageChange
            })
        ]
    });
}
// Default Props
$354ef3273ec6220e$var$AccordionTable.defaultProps = {
    headerOptions: '',
    children: '',
    minWidth: 0,
    totalItems: 0,
    filterComponents: '',
    tableFilters: {},
    setTableFilters: ()=>{}
};
// Proptypes Validation
$354ef3273ec6220e$var$AccordionTable.propTypes = {
    headerOptions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ]),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ]),
    minWidth: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
    totalItems: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
    filterComponents: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ]),
    tableFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        sortBy: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        sortDirection: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        page: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        size: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number
    }),
    setTableFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
};
var $354ef3273ec6220e$export$2e2bcd8739ae039 = $354ef3273ec6220e$var$AccordionTable;


var $d2b0b55dc8f66a40$export$2e2bcd8739ae039 = (0, $354ef3273ec6220e$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");


const $27ae8f806736fbfc$export$d99097c13d4dac9f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  margin-bottom: 5px;
`;
const $27ae8f806736fbfc$export$9837e16d1af48a7e = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  cursor: pointer;
`;
const $27ae8f806736fbfc$export$b341db839aa4fe47 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  padding: 5px 20px;
  transition: all 0.3s;
  -webkit-font-smoothing: antialiased;

  // TODO: Use theme functions
  &:focus {
    outline: none;
  }

  border: 1px solid ${({ theme: theme })=>theme.colors.backgroundLite};
  color: ${({ theme: theme })=>theme.colors.primary};
  border-radius: 10px;
  background: ${({ theme: theme })=>theme.colors.background};
  ${({ expanded: expanded })=>expanded && 'border-radius: 10px 10px 0 0'};

  &:hover {
    border: 1px solid ${({ theme: theme })=>`${theme.colors.brand}40`};
  }
`;
const $27ae8f806736fbfc$export$be2ca760d2eb1165 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  position: relative;
`;
const $27ae8f806736fbfc$export$f2abb93903ae27ea = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  flex: 1;
  padding: 0;
  font-size: 15px;
  font-weight: 100;
`;
const $27ae8f806736fbfc$export$2abe7b6f8bf4f242 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 50%;
  right: 0px;
  transform: translateY(-50%);
  height: 40px;
  width: 40px;
  cursor: pointer;
  border-radius: 50%;

  transition: all 0.3s;
  & svg > path {
    stroke: ${({ theme: theme })=>theme.colors.primary};
  }
  &:hover {
    background-color: ${({ theme: theme })=>theme.colors.backgroundLite};
  }

  // Conditional Properties
  ${({ withExpandIcon: withExpandIcon })=>!withExpandIcon && 'display: none;'}
  ${({ expanded: expanded })=>expanded && 'transform: rotate(180deg) translateY(50%);'};
`;
const $27ae8f806736fbfc$export$94c75639e734cc35 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 0 20px;
  height: 0px;
  ${({ expanded: expanded })=>expanded ? 'overflow: visible;' : 'overflow: hidden;'}

  transition: all 0.3s;
  background: ${({ theme: theme })=>theme.colors.background};
  border: 1px solid ${({ theme: theme })=>theme.colors.backgroundLite};
  border-top: none;
  border-bottom: none;
  border-radius: 0 0 10px 10px;

  ${({ expanded: expanded })=>expanded && 'height: auto; padding: 20px;'}
  ${({ expanded: expanded, theme: theme })=>expanded && `border-bottom: 1px solid ${theme.colors.backgroundLite};`}
`;


function $1761af5eb4bcf74d$var$AccordionTableItem(props) {
    // Destructure
    const { button: button, panel: panel, withExpandIcon: withExpandIcon, expandIcon: expandIcon, setIsExpanded: setIsExpanded, expandPanel: expandPanel, ...rest } = props;
    const wrapperRef = (0, $tZqWC.useRef)();
    // TODO ADD THIS FEATURE BACK BUT NOT AN OUTSIDE ALERTER
    // TODO make the item close only when clicking another item. not on click away
    // useOutsideAlerter(wrapperRef, setIsExpanded)
    // Functions
    const handleExpand = (event)=>{
        if (event.target.className?.baseVal && event.target.className?.baseVal === 'hashWrapper') return;
        if (typeof event.target.className === 'string' && event.target.className !== '') {
            const classnames = event.target.className.split(' ');
            if (classnames.indexOf('hashWrapper') > -1) return;
        }
        setIsExpanded((prevState)=>!prevState);
    };
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $27ae8f806736fbfc$export$d99097c13d4dac9f), {
        ref: wrapperRef,
        ...rest,
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $27ae8f806736fbfc$export$9837e16d1af48a7e), {
                onClick: handleExpand,
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $27ae8f806736fbfc$export$b341db839aa4fe47), {
                    expanded: expandPanel ? 1 : 0,
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $27ae8f806736fbfc$export$be2ca760d2eb1165), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $27ae8f806736fbfc$export$f2abb93903ae27ea), {
                                children: /*#__PURE__*/ (0, $tZqWC.cloneElement)(button, {
                                    expanded: expandPanel
                                })
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $27ae8f806736fbfc$export$2abe7b6f8bf4f242), {
                                withExpandIcon: withExpandIcon ? 1 : 0,
                                expanded: expandPanel ? 1 : 0,
                                children: expandIcon || /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $4319efa3b26da07e$export$2e2bcd8739ae039), {
                                    size: 18
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $27ae8f806736fbfc$export$94c75639e734cc35), {
                expanded: expandPanel ? 1 : 0,
                children: /*#__PURE__*/ (0, $tZqWC.cloneElement)(panel, {
                    expanded: expandPanel
                })
            })
        ]
    });
}
// Default Props
$1761af5eb4bcf74d$var$AccordionTableItem.defaultProps = {
    button: '',
    panel: '',
    withExpandIcon: true,
    expandIcon: '',
    expandPanel: false
};
// Proptypes Validation
$1761af5eb4bcf74d$var$AccordionTableItem.propTypes = {
    button: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ]),
    panel: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ]),
    withExpandIcon: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    expandIcon: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ]),
    setIsExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    expandPanel: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
};
var $1761af5eb4bcf74d$export$2e2bcd8739ae039 = $1761af5eb4bcf74d$var$AccordionTableItem;


var $b3f7dc6528742bb0$export$2e2bcd8739ae039 = (0, $1761af5eb4bcf74d$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $b62c33fdd70157e1$export$946f6311cdbdcb12 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  height: 19px;
  margin-left: 1px;
  margin-right: 1px;
  width: 12px;
  background-color: ${({ theme: theme })=>theme.colors.borderColor};
  font-weight: inherit;
  font-size: inherit;

  // Conditional Properties
  ${({ height: height })=>height && `height: ${height}px;`}
  ${({ width: width })=>width && `width: ${width}px;`};
  ${({ color: color })=>color && `background-color: ${color};`};
`;


function $66b880b88d16fd6c$var$TextBlur(props) {
    // Destructure
    const { width: width, height: height, color: color } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b62c33fdd70157e1$export$946f6311cdbdcb12), {
        width: width,
        height: height,
        color: color
    });
}
// Default Props
$66b880b88d16fd6c$var$TextBlur.defaultProps = {
    width: '',
    height: '',
    color: ''
};
// Proptypes Validation
$66b880b88d16fd6c$var$TextBlur.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    ]),
    height: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
};
var $66b880b88d16fd6c$export$2e2bcd8739ae039 = $66b880b88d16fd6c$var$TextBlur;


var $5a5c430251b9911a$export$2e2bcd8739ae039 = (0, $66b880b88d16fd6c$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $8b96c3eee706cc13$export$7d27b64f88bc73bf = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-weight: inherit;
  font-size: inherit;
`;
const $8b96c3eee706cc13$export$11148202a11b3cc8 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).span`
  margin-right: 5px;
  font-size: 10px;
  text-transform: uppercase;
  line-height: 10px;
  opacity: 0.9;

  // Conditional Properties
  ${({ withCurrency: withCurrency })=>!withCurrency && 'display: none;'}
`;


function $00ac925e04093214$var$NumericText(props) {
    // Destructure
    const { currency: currency, children: children, title: title } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8b96c3eee706cc13$export$7d27b64f88bc73bf), {
        title: title,
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $8b96c3eee706cc13$export$11148202a11b3cc8), {
                withCurrency: currency,
                children: currency
            }),
            children
        ]
    });
}
// Default Props
$00ac925e04093214$var$NumericText.defaultProps = {
    children: '',
    currency: '',
    title: ''
};
// Proptypes Validation
$00ac925e04093214$var$NumericText.propTypes = {
    currency: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
};
var $00ac925e04093214$export$2e2bcd8739ae039 = $00ac925e04093214$var$NumericText;


var $78de70d994ef00b4$export$2e2bcd8739ae039 = (0, $00ac925e04093214$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $ef5e6ca39e35870f$export$49e91462178ac8af = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display:flex;
  justify-content: center;
  align-items: center;
  padding: 2px 10px;

  margin-left: 1px;
  margin-right: 1px;
  width: fit-content;
  border-radius: 5px;
  font-weight: inherit;
  font-size: inherit;

  // Conditional Properties
  ${({ height: height })=>height && `height: ${height}px;`}
  ${({ width: width })=>width && `width: ${width}px;`};
  ${({ color: color })=>color && `background-color: ${color}33;`};
`;
const $ef5e6ca39e35870f$export$b53d3ce74888dbe0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  min-width: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ color: color })=>color && `color: ${color};`};
`;


function $ed61d5ee88edd3fd$var$BadgeText(props) {
    // Destructure
    const { width: width, height: height, color: color, children: children } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ef5e6ca39e35870f$export$49e91462178ac8af), {
        width: width,
        height: height,
        color: color,
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ef5e6ca39e35870f$export$b53d3ce74888dbe0), {
            color: color,
            children: children
        })
    });
}
// Default Props
$ed61d5ee88edd3fd$var$BadgeText.defaultProps = {
    width: '',
    height: '',
    color: '',
    children: ''
};
// Proptypes Validation
$ed61d5ee88edd3fd$var$BadgeText.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    ]),
    height: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    ])
};
var $ed61d5ee88edd3fd$export$2e2bcd8739ae039 = $ed61d5ee88edd3fd$var$BadgeText;


var $f04f9a686e885cbf$export$2e2bcd8739ae039 = (0, $ed61d5ee88edd3fd$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $c5967a79296dd557$export$d451e87453299184 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-weight: inherit;
  font-size: inherit;
`;
const $c5967a79296dd557$export$9640911fd10d701c = (0, $a778141486c79bc3$export$2e2bcd8739ae039).span`
  margin-right: 15px;
  width: 8px;
  height: 8px;

  // Conditional Properties
  ${({ color: color })=>color && `background-color: ${color};`}
`;


function $d90acdfdee272f08$var$LegendText(props) {
    // Destructure
    const { color: color, children: children } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $c5967a79296dd557$export$d451e87453299184), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c5967a79296dd557$export$9640911fd10d701c), {
                color: color
            }),
            children
        ]
    });
}
// Default Props
$d90acdfdee272f08$var$LegendText.defaultProps = {
    children: '',
    color: ''
};
// Proptypes Validation
$d90acdfdee272f08$var$LegendText.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number
    ]),
    color: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
};
var $d90acdfdee272f08$export$2e2bcd8739ae039 = $d90acdfdee272f08$var$LegendText;


var $1d507f2e862cde19$export$2e2bcd8739ae039 = (0, $d90acdfdee272f08$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $ab5e0feb4e45d9de$export$f99233281efd08a0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  margin-bottom: 11px;
  font-size: 17px;
  font-weight: 500;

  color: ${({ theme: theme })=>theme.colors.primary};
`;


function $c81884aec2374b6b$var$FormTitle(props) {
    // Destructure
    const { children: children } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ab5e0feb4e45d9de$export$f99233281efd08a0), {
        children: children
    });
}
// Default Props
$c81884aec2374b6b$var$FormTitle.defaultProps = {
    children: ''
};
// Proptypes Validation
$c81884aec2374b6b$var$FormTitle.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ])
};
var $c81884aec2374b6b$export$2e2bcd8739ae039 = $c81884aec2374b6b$var$FormTitle;


var $759b853456fe110f$export$2e2bcd8739ae039 = (0, $c81884aec2374b6b$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $102fce3f5bc6a163$export$37c7bf7739d54f18 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  gap: 7px;
`;
const $102fce3f5bc6a163$export$762240c6611b6ed2 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 15px;
  font-weight: 400;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $102fce3f5bc6a163$export$37d9a66f155fa89d = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  height: 7px;
  width: 7px;
  background-color: ${({ theme: theme })=>theme.colors.primary};
  border-radius: 2px;
`;


function $8d9ae1b5ba780168$var$TextSliced(props) {
    // Destructure
    const { text: text, sliceLength: sliceLength } = props;
    const startText = text.slice(0, sliceLength);
    const endText = text.slice(sliceLength * -1);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $102fce3f5bc6a163$export$37c7bf7739d54f18), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $102fce3f5bc6a163$export$762240c6611b6ed2), {
                children: startText
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $102fce3f5bc6a163$export$37d9a66f155fa89d), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $102fce3f5bc6a163$export$37d9a66f155fa89d), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $102fce3f5bc6a163$export$37d9a66f155fa89d), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $102fce3f5bc6a163$export$762240c6611b6ed2), {
                children: endText
            })
        ]
    });
}
// Default Props
$8d9ae1b5ba780168$var$TextSliced.defaultProps = {
    text: '',
    sliceLength: ''
};
// Proptypes Validation
$8d9ae1b5ba780168$var$TextSliced.propTypes = {
    text: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    sliceLength: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number
};
var $8d9ae1b5ba780168$export$2e2bcd8739ae039 = $8d9ae1b5ba780168$var$TextSliced;


var $a6f961941b47e982$export$2e2bcd8739ae039 = (0, $8d9ae1b5ba780168$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $646ee85e8ecd7f3b$export$ee096d6f521202b9 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: 300px;
  height: 20px;
  background: #474f5f;

  border-radius: 5px;

  // Conditional Properties
  ${({ borderRadius: borderRadius })=>borderRadius && `border-radius: ${borderRadius}px;`}
  ${({ height: height })=>height && `height: ${height}px;`}
  ${({ width: width })=>width && `width: ${width}px;`};
`;


function $f860ddaa299fdc69$var$SkeletonText(props) {
    // Destructure
    const { width: width, height: height, borderRadius: borderRadius, children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $646ee85e8ecd7f3b$export$ee096d6f521202b9), {
        width: width,
        height: height,
        borderRadius: borderRadius,
        ...rest,
        children: children
    });
}
// Default Props
$f860ddaa299fdc69$var$SkeletonText.defaultProps = {
    width: '',
    height: '',
    borderRadius: '',
    children: ''
};
// Proptypes Validation
$f860ddaa299fdc69$var$SkeletonText.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    ]),
    height: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    ]),
    borderRadius: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    ]),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    ])
};
var $f860ddaa299fdc69$export$2e2bcd8739ae039 = $f860ddaa299fdc69$var$SkeletonText;


var $bc65e302a570aac6$export$2e2bcd8739ae039 = (0, $f860ddaa299fdc69$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $7eeb0932f90e5786$export$ee096d6f521202b9 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: 300px;
  height: 20px;
  background: #474f5f;

  border-radius: 5px;

  // Conditional Properties
  ${({ borderRadius: borderRadius })=>borderRadius && `border-radius: ${borderRadius}px;`}
  ${({ height: height })=>height && `height: ${height}px;`}
  ${({ width: width })=>width && `width: ${width}px;`};

  background: linear-gradient(
      100deg,
      rgba(255, 255, 255, 0) 40%,
      rgba(255, 255, 255, 0.5) 50%,
      rgba(255, 255, 255, 0) 60%
    )
    #474f5f;
  background-size: 200% 100%;
  background-position-x: 180%;
  animation: 1s loading ease-out infinite;

  @keyframes loading {
    to {
      background-position-x: -20%;
    }
  }
`;


function $cb49e031ae113b47$var$TextLoading(props) {
    // Destructure
    const { width: width, height: height, borderRadius: borderRadius, children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7eeb0932f90e5786$export$ee096d6f521202b9), {
        width: width,
        height: height,
        borderRadius: borderRadius,
        ...rest,
        children: children
    });
}
// Default Props
$cb49e031ae113b47$var$TextLoading.defaultProps = {
    width: '',
    height: '',
    borderRadius: '',
    children: ''
};
// Proptypes Validation
$cb49e031ae113b47$var$TextLoading.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    ]),
    height: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    ]),
    borderRadius: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    ]),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    ])
};
var $cb49e031ae113b47$export$2e2bcd8739ae039 = $cb49e031ae113b47$var$TextLoading;


var $5facfc7bc5a170d3$export$2e2bcd8739ae039 = (0, $cb49e031ae113b47$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $12495b1bc67dc6fb$export$e6dfd72ab29f8598 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: 100%;
  position: relative;
`;
const $12495b1bc67dc6fb$export$b04be29aa201d4f5 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).label`
  display: block;
  position: relative;
  z-index: 1;
  color: ${({ theme: theme })=>theme.colors.primary};
  font-size: 12px;
  padding: 0 8px;
  transform: translate(15px, 15px);

  background-color: ${({ theme: theme })=>theme.colors.background};
  border-radius: 5px;
  width: fit-content;
`;
const $12495b1bc67dc6fb$export$185a8afe504e8fca = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  margin-left: 20px;
  color: ${({ theme: theme })=>theme.colors.brightRed};
  font-size: 14px;
`;



const $b4bbcb147d3e6263$export$85ac2b26e5942195 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).input`
  padding: 15px 20px;
  font-size: 16px;
  border-radius: 10px;
  width: 100%;
  font-weight: 400;
  outline: none;
  color: ${({ theme: theme })=>theme.colors.primary};
  -webkit-font-smoothing: antialiased;

  background-color: ${({ disabled: disabled, theme: theme })=>disabled ? 'transparent' : theme.colors.backgroundLite};
  border: ${({ theme: theme })=>`1px solid ${theme.colors.backgroundLite}`};

  &::placeholder {
    color: ${({ theme: theme })=>theme.colors.primary};
  }
`;


function $6d10f696a066d428$var$TextField(props) {
    // Destructure
    const { id: id, type: type, label: label, disabled: disabled, ...rest } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $12495b1bc67dc6fb$export$e6dfd72ab29f8598), {
        label: label,
        children: [
            label && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $12495b1bc67dc6fb$export$b04be29aa201d4f5), {
                disabled: disabled,
                children: label
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b4bbcb147d3e6263$export$85ac2b26e5942195), {
                disabled: disabled,
                id: id,
                type: type,
                ...rest
            })
        ]
    });
}
// Default Props
$6d10f696a066d428$var$TextField.defaultProps = {
    id: '',
    type: '',
    label: '',
    disabled: false
};
// Proptypes Validation
$6d10f696a066d428$var$TextField.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
};
var $6d10f696a066d428$export$2e2bcd8739ae039 = $6d10f696a066d428$var$TextField;


var $ae78f1d128dc50d5$export$2e2bcd8739ae039 = (0, $6d10f696a066d428$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $d7939b1b294ff43d$export$a8cf7e2c856df78d = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  width: 100%;
  margin-top: ${({ label: label })=>label && '-5px;'};
`;
const $d7939b1b294ff43d$export$b04be29aa201d4f5 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).label`
  position: relative;
  z-index: 1;
  color: ${({ theme: theme })=>theme.colors.primary};
  font-size: 12px;
  padding: 0 7px;
  transform: translate(15px, 15px);

  background-color: ${({ theme: theme })=>theme.colors.background};
  border-radius: 5px;
`;
const $d7939b1b294ff43d$export$c9719dfad4306c45 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).input`
  transition: 0.4s;

  position: relative;

  min-height: 54px;
  height: fit-content;
  width: 100%;

  padding: 15px 20px;

  font-size: 16px;
  border-radius: 10px;
  font-weight: 400;
  box-shadow: none;
  outline: none;
  color: ${({ theme: theme })=>theme.colors.primary};

  border: ${({ theme: theme })=>`1px solid ${theme.colors.backgroundLite}`};

  background-color: ${({ disabled: disabled, theme: theme })=>disabled ? 'transparent' : theme.colors.backgroundLite};

  &::placeholder {
    color: ${({ theme: theme })=>theme.colors.primary};
  }
`;
const $d7939b1b294ff43d$export$a6151309bfd46137 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: absolute;
  top: 110%;
  left: 0;
  display: flex;
  flex-direction: column;
  color: ${({ theme: theme })=>theme.colors.primary};

  padding: 10px;
  width: 100%;
  max-height: 300px;
  overflow-y: auto;

  font-size: 16px;
  border-radius: 10px;
  font-weight: 400;
  background-color: ${({ theme: theme })=>theme.colors.background};
  border: ${({ theme: theme })=>`1px solid ${theme.colors.backgroundLite}`};
  user-select: none;
  z-index: 2;
`;
const $d7939b1b294ff43d$export$ba141e9a22070242 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 10px;
  gap: 10px;

  color: ${({ theme: theme })=>theme.colors.primary};

  cursor: pointer;
  transition: 0.4s;

  border-radius: 10px;
  border: 1px solid rgba(0, 0, 0, 0);

  &:hover {
    border: ${({ theme: theme })=>`1px solid ${theme.colors.backgroundLite}`};
  }
`;
const $d7939b1b294ff43d$export$97a3b778b1052a22 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 16px;
`;
const $d7939b1b294ff43d$export$ea5e76b5dd06c221 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 12px;

  color: ${({ theme: theme })=>theme.colors.secondary};
`;


// Function that listens to oustide clicks of given ref
const $18408de06d61c793$var$useOutsideAlerter = (ref, setShowOptions)=>{
    (0, $tZqWC.useEffect)(()=>{
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) setShowOptions(false);
        }
        document.addEventListener('mousedown', handleClickOutside);
        return ()=>{
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [
        ref
    ]);
};
function $18408de06d61c793$var$AutoComplete(props) {
    // Destructure
    const { label: label, options: options, placeholder: placeholder, onInputChange: onInputChange, disabled: disabled, onSelect: onSelect, isLoading: isLoading, value: value, ...rest } = props;
    // Variables
    const withOptions = options && options?.length > 0;
    const wrapperRef = (0, $tZqWC.useRef)();
    // States
    const [inputValue, setInputValue] = (0, $tZqWC.useState)(value || '');
    const [showOptions, setShowOptions] = (0, $tZqWC.useState)(false);
    // Functions
    const handleOnSelect = ({ value: value, label: label })=>{
        setInputValue(label || value);
        onSelect(value);
        setShowOptions(false);
    };
    const handleOnChange = (e)=>{
        setInputValue(e.target.value);
        onInputChange(e.target.value);
    };
    // Closing options on click away
    $18408de06d61c793$var$useOutsideAlerter(wrapperRef, setShowOptions);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $d7939b1b294ff43d$export$a8cf7e2c856df78d), {
        ref: wrapperRef,
        label: label,
        children: [
            label && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d7939b1b294ff43d$export$b04be29aa201d4f5), {
                disabled: disabled,
                children: label
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d7939b1b294ff43d$export$c9719dfad4306c45), {
                value: inputValue,
                onChange: handleOnChange,
                placeholder: placeholder,
                onFocus: ()=>{
                    setShowOptions(true);
                },
                type: "search",
                autoComplete: "off",
                disabled: disabled,
                ...rest
            }),
            showOptions && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d7939b1b294ff43d$export$a6151309bfd46137), {
                children: withOptions ? options.map(({ value: value, label: label, subLabel: subLabel })=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $d7939b1b294ff43d$export$ba141e9a22070242), {
                        onClick: ()=>{
                            handleOnSelect({
                                value: value,
                                label: label
                            });
                        },
                        value: value,
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d7939b1b294ff43d$export$97a3b778b1052a22), {
                                children: label
                            }),
                            subLabel && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d7939b1b294ff43d$export$ea5e76b5dd06c221), {
                                children: subLabel
                            })
                        ]
                    }, label)) : /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("div", {
                    children: isLoading ? 'loading...' : 'No results found'
                })
            })
        ]
    });
}
// Default Props
$18408de06d61c793$var$AutoComplete.defaultProps = {
    label: '',
    placeholder: '',
    options: [],
    onSelect: ()=>{},
    onInputChange: ()=>{},
    isLoading: false,
    disabled: false,
    value: ''
};
// Proptypes Validation
$18408de06d61c793$var$AutoComplete.propTypes = {
    label: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    options: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Array),
    onSelect: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    onInputChange: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
};
var $18408de06d61c793$export$2e2bcd8739ae039 = $18408de06d61c793$var$AutoComplete;


var $0fe6a5346271ecbe$export$2e2bcd8739ae039 = (0, $18408de06d61c793$export$2e2bcd8739ae039);


/* eslint-disable react/forbid-prop-types */ 

var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");


const $21b941bab2c8afc0$export$fdd500c294eff378 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  width: 100%;
  padding: 10px;
  margin-top: ${({ label: label })=>label ? '-5px;' : '20px;'};
  background: ${({ theme: theme })=>theme.colors.background};

  border-radius: ${({ open: open })=>open ? '10px 10px 0 0' : '10px'};
  transition: 0.3s;
  border: 1px solid ${({ theme: theme })=>`${theme.colors.backgroundLite}`};
  &:hover {
    border: 1px solid ${({ theme: theme })=>`${theme.colors.brand}40`};
  }
`;
const $21b941bab2c8afc0$export$be58b4326e23250f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: absolute;
  z-index: 2;
  top: 17px;
  left: 10px;

  & svg {
    min-width: 20px;
    margin: 0 0 0 10px;
    & > path {
      stroke: ${({ theme: theme })=>theme.colors.primary};
    }
  }
`;
const $21b941bab2c8afc0$export$c636d9aa34eb47a6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 10px;
  background: ${({ theme: theme })=>theme.colors.backgroundLite};
  margin: 0;
`;
const $21b941bab2c8afc0$export$b8aa00b0e772c98a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  margin: 10px 10px 10px 40px;
  padding: 10px 20px;
`;
const $21b941bab2c8afc0$export$ca4b1fc43afa0212 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 2;

  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;

  // Themed Properties
  background: ${({ theme: theme })=>theme.colors.background};
/* 
  & button > svg > path {
    stroke: ${({ theme: theme })=>theme.colors.brand};
  }
  & button > svg > line {
    stroke: ${({ theme: theme })=>theme.colors.brand};
  } */
`;
const $21b941bab2c8afc0$export$2f96f6f204f87534 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  max-height: 35.5px;
  gap: 20px;

  opacity: 1;
  transition: 0.3s;

  max-width: ${({ collapseFilter: collapseFilter })=>collapseFilter ? '0px' : '2000px'};
  overflow: ${({ collapseFilter: collapseFilter })=>collapseFilter ? 'hidden' : 'visible'};
`;
const $21b941bab2c8afc0$export$55d7609a8f1eccd2 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).input`
  transition: 0.4s;

  position: relative;

  min-height: 35.5px;
  height: fit-content;
  width: 100%;

  padding: 0 12px 0 50px;

  font-size: 16px;
  font-weight: 400;
  box-shadow: none;
  outline: none;
  border: none;

  color: ${({ theme: theme })=>theme.colors.primary};
  border-radius: ${({ open: open })=>open ? '0 0 10px 10px' : '10px'};

  background-color: ${({ disabled: disabled, theme: theme })=>disabled ? 'transparent' : theme.colors.background};

  &:hover {
    box-shadow: none;
  }

  &::placeholder {
    color: ${({ theme: theme })=>theme.colors.primary};
  }
`;
const $21b941bab2c8afc0$export$a6151309bfd46137 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: absolute;
  top: 100%;
  left: 0;
  display: flex;
  flex-direction: column;

  width: 100%;
  max-height: 300px;
  overflow-y: auto;

  font-size: 16px;
  border-radius: 10px;
  font-weight: 400;
  color: ${({ theme: theme })=>theme.colors.primary};

  background-color: ${({ theme: theme })=>theme.colors.background};
  user-select: none;
  z-index: 2;

  border-top: ${({ theme: theme })=>`1px solid ${theme.colors.backgroundLite}`};
  border-radius: 0 0 10px 10px;
  box-shadow: 0px 3px 7px rgba(0, 0, 0, 0.07);
`;
const $21b941bab2c8afc0$export$ba141e9a22070242 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 10px 20px;
  gap: 10px;

  color: ${({ theme: theme })=>theme.colors.primary};

  cursor: pointer;
  transition: 0.4s;

  border-radius: 10px;
  border: 1px solid rgba(0, 0, 0, 0);

  margin: 0 10px 0 40px;

  &:first-child {
    margin: 10px 10px 0 40px;
  }
  &:last-child {
    margin: 0 10px 10px 40px;
  }
  &:only-child {
    margin: 10px 10px 10px 40px;
  }
  &:hover {
    background: ${({ theme: theme })=>theme.colors.backgroundLite};
  }
`;
const $21b941bab2c8afc0$export$97a3b778b1052a22 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 16px;
  min-width: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const $21b941bab2c8afc0$export$ea5e76b5dd06c221 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 12px;
  min-width: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  color: ${({ theme: theme })=>theme.colors.secondary};
`;




// Function that listens to oustide clicks of given ref
const $9af919c9e7b333f7$var$useOutsideAlerter = (ref, handleClose)=>{
    (0, $tZqWC.useEffect)(()=>{
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) handleClose();
        }
        document.addEventListener('mousedown', handleClickOutside);
        return ()=>{
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [
        ref
    ]);
};
function $9af919c9e7b333f7$var$Search(props) {
    // Destructure
    const { label: label, options: options, disabledOptions: disabledOptions, setOptions: setOptions, placeholder: placeholder, filter: filter, bottomOptions: bottomOptions, onInputChange: onInputChange, disabled: disabled, onSelect: onSelect, isLoading: isLoading, value: value, ...rest } = props;
    // Variables
    const withOptions = options && options?.length > 0;
    const wrapperRef = (0, $tZqWC.useRef)();
    // States
    const [inputValue, setInputValue] = (0, $tZqWC.useState)(value || '');
    const [showOptions, setShowOptions] = (0, $tZqWC.useState)(false);
    const [collapseFilter, setCollapseFilter] = (0, $tZqWC.useState)(true);
    // Functions
    const handleOnSelect = ({ value: value, label: label })=>{
        setInputValue(label || value);
        onSelect(value);
        setShowOptions(false);
    };
    const handleOnChange = (e)=>{
        setInputValue(e.target.value);
        onInputChange(e.target.value);
        if (!disabledOptions) setShowOptions(true);
    };
    const handleCollapseFilter = ()=>{
        setCollapseFilter((prevState)=>!prevState);
        setShowOptions(false);
    };
    const handleCloseOptions = ()=>{
        setShowOptions(false);
    };
    // Closing options on click away
    $9af919c9e7b333f7$var$useOutsideAlerter(wrapperRef, handleCloseOptions);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $21b941bab2c8afc0$export$fdd500c294eff378), {
        ref: wrapperRef,
        label: label,
        open: showOptions,
        children: [
            label && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $12495b1bc67dc6fb$export$b04be29aa201d4f5), {
                disabled: disabled,
                children: label
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $21b941bab2c8afc0$export$be58b4326e23250f), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b36636a5d09c33a7$export$2e2bcd8739ae039), {
                    size: 18
                })
            }),
            filter && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $21b941bab2c8afc0$export$ca4b1fc43afa0212), {
                onClick: ()=>setShowOptions(false),
                children: filter
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $21b941bab2c8afc0$export$55d7609a8f1eccd2), {
                value: inputValue,
                onChange: handleOnChange,
                placeholder: placeholder,
                onFocus: ()=>{
                    if (!disabledOptions) setShowOptions(true);
                    setCollapseFilter(true);
                },
                type: "search",
                autoComplete: "off",
                disabled: disabled,
                ...rest
            }),
            showOptions && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $21b941bab2c8afc0$export$a6151309bfd46137), {
                children: withOptions ? options.map(({ value: value, label: label, subLabel: subLabel })=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $21b941bab2c8afc0$export$ba141e9a22070242), {
                        onClick: ()=>{
                            handleOnSelect({
                                value: value,
                                label: label
                            });
                        },
                        value: value,
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $21b941bab2c8afc0$export$97a3b778b1052a22), {
                                children: label
                            }),
                            subLabel && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $21b941bab2c8afc0$export$ea5e76b5dd06c221), {
                                children: subLabel
                            })
                        ]
                    }, label)) : /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("div", {
                    children: isLoading ? /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $21b941bab2c8afc0$export$b8aa00b0e772c98a), {
                        children: "loading..."
                    }) : /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $21b941bab2c8afc0$export$b8aa00b0e772c98a), {
                                children: "No results found"
                            }),
                            bottomOptions && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $21b941bab2c8afc0$export$c636d9aa34eb47a6), {
                                children: bottomOptions
                            })
                        ]
                    })
                })
            })
        ]
    });
}
// Default Props
$9af919c9e7b333f7$var$Search.defaultProps = {
    label: '',
    placeholder: '',
    options: [],
    setOptions: ()=>{},
    onSelect: ()=>{},
    onInputChange: ()=>{},
    isLoading: false,
    disabled: false,
    value: ''
};
// Proptypes Validation
$9af919c9e7b333f7$var$Search.propTypes = {
    label: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    options: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Array),
    setOptions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    onSelect: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    onInputChange: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    disabledOptions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    filter: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).any,
    bottomOptions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).any
};
var $9af919c9e7b333f7$export$2e2bcd8739ae039 = $9af919c9e7b333f7$var$Search;


var $69a991355976a1a9$export$2e2bcd8739ae039 = (0, $9af919c9e7b333f7$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");



const $382056b345e884a9$export$d586e0ae81c7b89b = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: 100%;
  min-height: 48px;
  margin-top: ${({ label: label })=>label && '-5px;'};
`;
const $382056b345e884a9$export$d6701e98ab1a6725 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).select`
  display: none;
`;
const $382056b345e884a9$export$11a8a1ea41bf55d8 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).option`
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $382056b345e884a9$export$37cdf0d06bb542b5 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  color: ${({ theme: theme })=>theme.colors.primary};
  cursor: ${(props)=>props.disabled ? 'default' : 'pointer'};
  transition: 0.4s;

  position: relative;
  // TODO: Use theme functions
  &:after {
    content: '';

    position: absolute;
    top: 42%;
    right: 15px;

    display: ${({ disabled: disabled })=>disabled ? 'none' : 'inline-block'};
    margin-left: 0.255em;
    vertical-align: 0.255em;

    border-top: 0.3em solid;
    border-right: 0.3em solid transparent;
    border-bottom: 0;
    border-left: 0.3em solid transparent;
    color: ${({ theme: theme })=>theme.colors.primary};
  }

  min-height: 54px;
  height: fit-content;
  width: 100%;

  padding: 15px 20px;

  font-size: 16px;
  border-radius: 10px;
  font-weight: 400;
  box-shadow: none;

  border: ${({ theme: theme })=>`1px solid ${theme.colors.borderColor}`};

  background-color: ${({ disabled: disabled, theme: theme })=>disabled ? 'transparent' : theme.colors.background};
  border-radius: ${({ open: open })=>open ? '10px 10px 0 0' : '10px'};
  box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.07);
`;
const $382056b345e884a9$export$a6151309bfd46137 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  z-index: 3;
  position: absolute;
  top: 100%;
  display: flex;
  flex-direction: column;
  color: ${({ theme: theme })=>theme.colors.primary};

  padding: 10px;
  width: 100%;
  max-height: 300px;
  overflow-y: auto;

  font-size: 16px;
  font-weight: 400;
  background-color: ${({ theme: theme })=>theme.colors.background};
  border-left: ${({ theme: theme })=>`1px solid ${theme.colors.backgroundLite}`};
  border-right: ${({ theme: theme })=>`1px solid ${theme.colors.backgroundLite}`};
  border-bottom: ${({ theme: theme })=>`1px solid ${theme.colors.backgroundLite}`};
  border-radius: ${({ open: open })=>open ? '0 0 10px 10px' : '10px'};
  box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.07);
  user-select: none;
`;
const $382056b345e884a9$export$ba141e9a22070242 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 10px;
  gap: 10px;

  transition: 0.4s;

  border-radius: 8px;
  border: ${({ disabled: disabled })=>!disabled && '1px solid rgba(0, 0, 0, 0)'};
  color: ${(props)=>props.theme.colors.primary};
  cursor: ${({ disabled: disabled })=>disabled ? 'not-allowed' : 'pointer'};

  &:hover {
    background: ${({ theme: theme, disabled: disabled })=>!disabled && theme.colors.backgroundLite};
  }
`;
const $382056b345e884a9$export$8a186fdbfc12f934 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  color: ${(props)=>props.theme.colors.primary};
  font-weight: 400;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const $382056b345e884a9$export$a11e67ac8be84bf9 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  color: ${({ theme: theme })=>theme.colors.backgroundLite};
  min-width: 40px;
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const $382056b345e884a9$export$5f1af8db9871e1d6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  min-width: 40px;
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;


// Function that listens to oustide clicks of given ref
const $afe5329dc5514fbe$var$useOutsideAlerter = (ref, setShowOptions)=>{
    (0, $tZqWC.useEffect)(()=>{
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) setShowOptions(false);
        }
        document.addEventListener('mousedown', handleClickOutside);
        return ()=>{
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [
        ref
    ]);
};
function $afe5329dc5514fbe$var$Select(props) {
    // Destructure
    const { id: id, label: label, placeholder: placeholder, options: options, onChange: onChange, value: value, disabled: disabled, ...rest } = props;
    // Variables
    const withOptions = options && options?.length > 0;
    const wrapperRef = (0, $tZqWC.useRef)();
    // States
    const [formValue, setFormValue] = (0, $tZqWC.useState)('');
    const [valueLabel, setValueLabel] = (0, $tZqWC.useState)('');
    const [showOptions, setShowOptions] = (0, $tZqWC.useState)(false);
    // Functions
    const handleOnChange = (value, label)=>{
        onChange(value);
        if (value === undefined) {
            setFormValue(value);
            setValueLabel(placeholder || '');
            return setShowOptions(false);
        }
        setFormValue(value);
        setValueLabel(label);
        setShowOptions(false);
    };
    // Closing options on click away
    $afe5329dc5514fbe$var$useOutsideAlerter(wrapperRef, setShowOptions);
    // UseEffects
    (0, $tZqWC.useEffect)(()=>{
        // setting the value and label on initial load
        if (value !== undefined && value !== null) {
            setFormValue(value);
            const currentLabel = options.find((data)=>{
                if (typeof data.value === 'number') return data.value === Number(value);
                return data.value === value;
            });
            if (currentLabel?.label) setValueLabel(currentLabel.label);
            else if (!currentLabel?.label) setValueLabel(placeholder || '');
        }
    }, [
        value
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $382056b345e884a9$export$d586e0ae81c7b89b), {
        ref: wrapperRef,
        label: label,
        children: [
            label && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $12495b1bc67dc6fb$export$b04be29aa201d4f5), {
                disabled: disabled,
                children: label
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $12495b1bc67dc6fb$export$e6dfd72ab29f8598), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $382056b345e884a9$export$d6701e98ab1a6725), {
                        id: id,
                        type: "select",
                        value: `${formValue}`,
                        onChange: ()=>{},
                        ...rest
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $382056b345e884a9$export$37cdf0d06bb542b5), {
                        open: showOptions,
                        disabled: disabled,
                        onClick: ()=>{
                            if (!disabled) setShowOptions((prevState)=>!prevState);
                        },
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $382056b345e884a9$export$8a186fdbfc12f934), {
                            disabled: disabled,
                            children: [
                                " ",
                                !valueLabel ? placeholder : valueLabel,
                                " "
                            ]
                        })
                    }),
                    showOptions && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $382056b345e884a9$export$a6151309bfd46137), {
                        open: showOptions,
                        children: withOptions && options.map(({ value: value, label: label, disabled: disabled, abrv: abrv, icon: icon })=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("div", {
                                children: label !== valueLabel && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $382056b345e884a9$export$ba141e9a22070242), {
                                    disabled: disabled,
                                    onClick: ()=>{
                                        if (!disabled) handleOnChange(value, label);
                                    },
                                    value: value,
                                    children: [
                                        icon && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $65f0d7ff3fd922b2$export$2e2bcd8739ae039), {
                                            src: icon,
                                            width: 30,
                                            height: 30
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $382056b345e884a9$export$5f1af8db9871e1d6), {
                                            children: label
                                        }),
                                        abrv && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $382056b345e884a9$export$a11e67ac8be84bf9), {
                                            children: [
                                                " ",
                                                abrv,
                                                " "
                                            ]
                                        })
                                    ]
                                })
                            }, label))
                    })
                ]
            })
        ]
    });
}
// Default Props
$afe5329dc5514fbe$var$Select.defaultProps = {
    id: '',
    label: '',
    value: '',
    placeholder: '',
    options: [],
    onChange: ()=>{},
    disabled: false
};
// Proptypes Validation
$afe5329dc5514fbe$var$Select.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    ]),
    placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    options: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Array),
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
};
var $afe5329dc5514fbe$export$2e2bcd8739ae039 = $afe5329dc5514fbe$var$Select;


var $47c62aa7410890bd$export$2e2bcd8739ae039 = (0, $afe5329dc5514fbe$export$2e2bcd8739ae039);




parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $23f6dd882885821b$export$ce9b1cc0c34506d0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).textarea`
  padding: 15px 20px;
  font-size: 16px;
  border-radius: 10px;
  width: 100%;
  height: 100%;
  font-weight: 400;
  outline: none;
  color: ${({ theme: theme })=>theme.colors.primary};

  border: ${({ theme: theme })=>`1px solid ${theme.colors.backgroundLite}`};
  background-color: ${({ disabled: disabled, theme: theme })=>disabled ? 'transparent' : theme.colors.backgroundLite};

  ${({ resize: resize })=>!resize && 'resize: none;'}

  &::placeholder {
    color: ${({ theme: theme })=>theme.colors.primary};
  }
`;
const $23f6dd882885821b$export$256c1f58b9340d4e = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: center;

  position: absolute;
  top: 10px;
  right: 10px;
`;
const $23f6dd882885821b$export$42f892acd431d334 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  cursor: default;
  font-size: 10px;
  color: ${({ theme: theme })=>theme.colors.backgroundLite};
`;




function $71f083882eba2781$var$TextArea(props) {
    // Destructure
    const { type: type, label: label, resize: resize, saveLoading: saveLoading, disabled: disabled, ...rest } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $12495b1bc67dc6fb$export$e6dfd72ab29f8598), {
        label: label,
        children: [
            label && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $12495b1bc67dc6fb$export$b04be29aa201d4f5), {
                disabled: disabled,
                children: label
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $23f6dd882885821b$export$ce9b1cc0c34506d0), {
                disabled: disabled,
                type: type,
                resize: resize,
                ...rest
            }),
            saveLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $23f6dd882885821b$export$256c1f58b9340d4e), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $23f6dd882885821b$export$42f892acd431d334), {
                        children: "Saving..."
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $462cc6e9cac360f1$export$2e2bcd8739ae039), {
                        size: 18
                    })
                ]
            })
        ]
    });
}
// Default Props
$71f083882eba2781$var$TextArea.defaultProps = {
    type: '',
    label: '',
    resize: true,
    saveLoading: false,
    disabled: false
};
// Proptypes Validation
$71f083882eba2781$var$TextArea.propTypes = {
    type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    resize: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    saveLoading: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
};
var $71f083882eba2781$export$2e2bcd8739ae039 = $71f083882eba2781$var$TextArea;


var $d03facd9d698d253$export$2e2bcd8739ae039 = (0, $71f083882eba2781$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $0f292754b80fe50c$export$e6dfd72ab29f8598 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;

  font-size: 15px;
  color: ${({ theme: theme, isChecked: isChecked })=>isChecked ? theme.colors.brand : theme.colors.primary};
`;
const $0f292754b80fe50c$export$f99233281efd08a0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h2`
  font-size: 15px;
  font-weight: 600;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $0f292754b80fe50c$export$bc7adc8ef74607f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
`;
const $0f292754b80fe50c$export$d4e232ca161ccdd3 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).input`
  display: none;

  &:checked ~ label > div > span {
    background: ${({ theme: theme })=>theme.colors.brand};
  }
`;
const $0f292754b80fe50c$export$fc9014afe1b6db0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).label`
  display: flex;
  align-items: center;
  gap: 10px;
`;
const $0f292754b80fe50c$export$60bffc6e2a50e7f9 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 20px;
  width: 20px;
  border-radius: 5px;
  background: ${({ theme: theme })=>theme.colors.primary};
`;
const $0f292754b80fe50c$export$d046b3c4a416f60d = (0, $a778141486c79bc3$export$2e2bcd8739ae039).span`
  display: flex;
  height: 10px;
  width: 10px;
  border-radius: 2px;
  background: ${({ theme: theme })=>theme.colors.primary};
`;


function $bd53d24aaa482d5a$var$Checkbox(props) {
    // Destructure
    const { id: id, name: name, type: type, label: label, options: options, onChange: onChange, value: value, disabled: disabled, ...rest } = props;
    function handleChange(selectedValue, checked) {
        let newItems = [
            ...value
        ];
        if (checked) newItems.push(selectedValue);
        if (!checked) {
            newItems = [];
            value.forEach((item)=>{
                if (item !== selectedValue) newItems.push(item);
            });
        }
        onChange(newItems);
    }
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $0f292754b80fe50c$export$e6dfd72ab29f8598), {
        ...rest,
        children: [
            label && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $0f292754b80fe50c$export$f99233281efd08a0), {
                children: label
            }),
            options && options.map((item)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $0f292754b80fe50c$export$bc7adc8ef74607f), {
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $0f292754b80fe50c$export$d4e232ca161ccdd3), {
                            name: name,
                            id: item.value,
                            type: "checkbox",
                            onChange: (e)=>handleChange(item.value, e.target.checked)
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $0f292754b80fe50c$export$fc9014afe1b6db0), {
                            for: item.value,
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $0f292754b80fe50c$export$60bffc6e2a50e7f9), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $0f292754b80fe50c$export$d046b3c4a416f60d), {})
                                }),
                                item.label
                            ]
                        })
                    ]
                }, item.value))
        ]
    });
}
// Default Props
$bd53d24aaa482d5a$var$Checkbox.defaultProps = {
    id: '',
    name: '',
    type: '',
    label: '',
    disabled: false,
    options: [],
    onChange: ()=>{},
    value: []
};
// Proptypes Validation
$bd53d24aaa482d5a$var$Checkbox.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string),
    options: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Array)
};
var $bd53d24aaa482d5a$export$2e2bcd8739ae039 = $bd53d24aaa482d5a$var$Checkbox;


var $d05da0d1610c883b$export$2e2bcd8739ae039 = (0, $bd53d24aaa482d5a$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");
const $f10bd86847f61f53$var$buildCalendarDays = (value)=>{
    const startDay = value.clone().startOf('month').startOf('week');
    const endDay = value.clone().endOf('month').endOf('week');
    const day = startDay.clone().subtract(1, 'day');
    const days = [];
    while(day.isBefore(endDay, 'day'))days.push(Array(7).fill(0).map(()=>day.add(1, 'day').clone()));
    return days;
};
var $f10bd86847f61f53$export$2e2bcd8739ae039 = $f10bd86847f61f53$var$buildCalendarDays;



var $ejSM7 = parcelRequire("ejSM7");






const $9dafb53491fb7bd6$export$a915f81916d25a71 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  position: relative;
`;
const $9dafb53491fb7bd6$export$abb4b0be5cbfc1e9 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  z-index: 0;
  position: relative;
  display: flex;
  gap: 20px;
  width: 100%;

  padding: 15px 20px;

  font-size: 16px;
  border-radius: 10px;
  font-weight: 400;
  box-shadow: none;

  border: ${({ theme: theme })=>`1px solid ${theme.colors.borderColor}`};

  background-color: ${({ disabled: disabled, theme: theme })=>disabled ? 'transparent' : theme.colors.backgroundLite};
  cursor: ${({ disabled: disabled })=>disabled ? 'not-allowed' : 'pointer'};
  border-radius: ${({ open: open })=>open ? '10px 10px 0 0' : '10px'};
  /* box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.07); */
`;
const $9dafb53491fb7bd6$export$dc52754310de90ca = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $9dafb53491fb7bd6$export$b04be29aa201d4f5 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).label`
  position: relative;
  z-index: 1;
  color: ${({ theme: theme })=>theme.colors.primary};
  font-size: 12px;
  padding: 0 8px;
  transform: translate(15px, 15px);

  background-color: ${({ theme: theme })=>theme.colors.background};
  border-radius: 5px;
  width: fit-content;
`;
const $9dafb53491fb7bd6$export$fae74ea16922dfbd = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  z-index: ${({ open: open })=>open ? 10 : 0} !important;
  top: 100%;
  position: absolute;
  height: ${({ open: open })=>open ? 'fit-content' : 0} !important;
  padding: ${({ open: open })=>open ? '20px' : '0 20px'} !important;
  overflow: ${({ open: open })=>open ? 'visible' : 'hidden'} !important;
  border-width: 1px;
  border-style: solid;
  border-color: ${({ open: open, theme: theme })=>open ? `${theme.colors.backgroundLite}` : `${theme.colors.backgroundLite}00`};
  transition: 0.3s;

  display: flex;
  flex-direction: column;
  background-color: ${({ theme: theme })=>theme.colors.background};
  width: fit-content;
  border-radius: 10px;
  box-shadow: ${({ open: open })=>open && '0px 0px 7px rgb(0 0 0 / 10%)'};
`;
const $9dafb53491fb7bd6$export$8c0fb40c2053deb9 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  height: fit-content;

  & button {
    min-height: 30px;
    min-width: 30px;
    padding: 5px;
    border: none;
    & svg {
      max-width: 100% !important;
      max-height: 100% !important;
    }
    &:hover {
      border: none;
      background-color: ${({ theme: theme })=>theme.colors.brand};
    }
  }
`;
const $9dafb53491fb7bd6$export$f4924b24ba81735c = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 10px;
  width: 100%;

  & div {
    margin: 0 !important;
    font-size: 12px !important;
  }
`;
const $9dafb53491fb7bd6$export$80ddb20a2792901 = (0, $a778141486c79bc3$export$2e2bcd8739ae039)((0, $c5892724db161e9a$export$2e2bcd8739ae039))``;
const $9dafb53491fb7bd6$export$9b1eb6d1773fc30b = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  width: 100%;

  & > div > div > div:last-child {
    max-height: 200px;
    & div > div {
      padding: 3px 5px;
    }
  }
`;
const $9dafb53491fb7bd6$export$ced7e5994573e44b = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 30px;
`;
const $9dafb53491fb7bd6$export$38995e55f23dbe5b = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px 0 0 0;
`;
const $9dafb53491fb7bd6$export$eb9874e3f5c4acea = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 12px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $9dafb53491fb7bd6$export$49c3657ed19fd125 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 10px !important;
`;
const $9dafb53491fb7bd6$export$c4485302f8878b91 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid !important;
  grid-template-columns: repeat(7, minmax(20px, 1fr)) !important;
  gap: 10px !important;
`;
const $9dafb53491fb7bd6$export$56537c841c97711f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 12px;
  text-align: center;
  color: ${({ theme: theme, disabled: disabled })=>disabled ? `${theme.colors.secondary} !important` : theme.colors.primary};
  color: ${({ theme: theme, active: active })=>active && theme.colors.background};
  cursor: pointer;

  padding: 3px 5px;
  border-radius: 5px;
  text-decoration: ${({ forbidden: forbidden })=>forbidden && 'line-through'};

  background-color: ${({ active: active, theme: theme })=>active && theme.colors.brand};
  background-color: ${({ disabled: disabled })=>disabled && 'transparent !important'};
  &:hover {
    background-color: ${({ disabled: disabled, theme: theme })=>!disabled && theme.colors.secondary};
  }
`;


function $c4b62a3a7f68834b$var$DatePicker(props) {
    // props
    const { onApply: onApply, disabled: disabled, placeholder: placeholder, defaultDate: defaultDate, maxDate: maxDate, label: label, ...rest } = props;
    const [open, setOpen] = (0, $tZqWC.useState)(false);
    const [days, setDays] = (0, $tZqWC.useState)([]);
    const [currDay, setCurrDay] = (0, $tZqWC.useState)((0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))());
    const [selectedDate, setSelectedDate] = (0, $tZqWC.useState)(defaultDate ? (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(defaultDate) : null);
    const pickerRef = (0, $tZqWC.useRef)();
    // functions
    const handleOpen = ()=>{
        if (!disabled) setOpen((prevValue)=>!prevValue);
    };
    const handleCancel = ()=>{
        if (selectedDate) {
            setCurrDay(selectedDate);
            setOpen(false);
        } else setOpen(false);
    };
    const moveBack = ()=>{
        setCurrDay(currDay.clone().subtract(1, 'month'));
    };
    const moveNext = ()=>{
        if (!currDay.isAfter((0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))().subtract(1, 'month'), 'month')) setCurrDay(currDay.clone().add(1, 'month'));
    };
    const getYears = (back)=>{
        const year = new Date().getFullYear();
        let reversedYears = [];
        Array.from({
            length: back
        }, (v, i)=>{
            reversedYears = [
                {
                    value: year - back + i + 1,
                    label: year - back + i + 1
                },
                ...reversedYears
            ];
        });
        return reversedYears;
    };
    const handleMonthChange = (value)=>{
        setCurrDay((prevValue)=>prevValue.clone().set('month', value));
    };
    const handleYearChange = (value)=>{
        setCurrDay((prevValue)=>prevValue.clone().set('year', value));
    };
    const handleClick = (value)=>{
        setSelectedDate(value);
        onApply(value.format((0, $41a9e38e6be32f35$export$1bceb808939a9f0c)));
        setOpen(false);
    };
    // UseEffect
    (0, $tZqWC.useEffect)(()=>{
        setDays((0, $f10bd86847f61f53$export$2e2bcd8739ae039)(currDay));
    }, [
        currDay
    ]);
    (0, $54f47a39f461db48$export$50ec7b7ff742aae5)(pickerRef, handleCancel);
    (0, $tZqWC.useEffect)(()=>{
        if (defaultDate) setSelectedDate((0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(defaultDate));
    }, [
        defaultDate
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9dafb53491fb7bd6$export$a915f81916d25a71), {
        ...rest,
        ref: pickerRef,
        children: [
            label && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9dafb53491fb7bd6$export$b04be29aa201d4f5), {
                children: label
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9dafb53491fb7bd6$export$abb4b0be5cbfc1e9), {
                onClick: handleOpen,
                disabled: disabled,
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9dafb53491fb7bd6$export$dc52754310de90ca), {
                    children: selectedDate ? selectedDate.format('MMMM DD YYYY') : placeholder || 'Select Date'
                })
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9dafb53491fb7bd6$export$fae74ea16922dfbd), {
                open: open,
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9dafb53491fb7bd6$export$8c0fb40c2053deb9), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                onClick: moveBack,
                                variant: "outlined",
                                type: "button",
                                startIcon: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2d68211da31cd8b8$export$2e2bcd8739ae039), {
                                    size: 18
                                })
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9dafb53491fb7bd6$export$f4924b24ba81735c), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9dafb53491fb7bd6$export$9b1eb6d1773fc30b), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9dafb53491fb7bd6$export$80ddb20a2792901), {
                                            options: (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7))).months().map((item)=>({
                                                    value: item,
                                                    label: item
                                                })),
                                            onChange: handleMonthChange,
                                            value: currDay.format('MMMM'),
                                            placeholder: currDay.format('MMMM')
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9dafb53491fb7bd6$export$9b1eb6d1773fc30b), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9dafb53491fb7bd6$export$80ddb20a2792901), {
                                            options: getYears(100),
                                            onChange: handleYearChange,
                                            value: currDay.format('YYYY'),
                                            placeholder: currDay.format('YYYY')
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                onClick: moveNext,
                                disabled: currDay.isAfter((0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))().subtract(1, 'month'), 'month') || maxDate && currDay.isAfter((0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(maxDate), 'day'),
                                variant: "outlined",
                                startIcon: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $738b185bd23471f4$export$2e2bcd8739ae039), {
                                    size: 18
                                }),
                                type: "button"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9dafb53491fb7bd6$export$ced7e5994573e44b), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9dafb53491fb7bd6$export$38995e55f23dbe5b), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9dafb53491fb7bd6$export$eb9874e3f5c4acea), {
                                    children: currDay.format('MMMM YYYY')
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9dafb53491fb7bd6$export$49c3657ed19fd125), {
                                    children: days.map((week)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9dafb53491fb7bd6$export$c4485302f8878b91), {
                                            style: {
                                                display: 'flex',
                                                gap: '20px'
                                            },
                                            children: week.map((day)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9dafb53491fb7bd6$export$56537c841c97711f), {
                                                    onClick: ()=>!day.isAfter((0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(), 'day') && handleClick(day),
                                                    forbidden: day.isAfter((0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(), 'day'),
                                                    disabled: day.isAfter((0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(), 'day') || !day.isSame(currDay, 'month') || maxDate && day.isAfter((0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(maxDate), 'day'),
                                                    active: day.isSame(selectedDate),
                                                    children: day.format('D')
                                                }, day.format('MM/DD')))
                                        }, week))
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
// Default Props
$c4b62a3a7f68834b$var$DatePicker.defaultProps = {
    onApply: ()=>{},
    defaultDate: '',
    simplifiedDate: false,
    disabled: false,
    placeholder: '',
    maxDate: ''
};
// Proptypes Validation
$c4b62a3a7f68834b$var$DatePicker.propTypes = {
    onApply: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    defaultDate: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    maxDate: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    simplifiedDate: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
};
var $c4b62a3a7f68834b$export$2e2bcd8739ae039 = $c4b62a3a7f68834b$var$DatePicker;


var $0c99b953747ef22f$export$2e2bcd8739ae039 = (0, $c4b62a3a7f68834b$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");
const $64ea9a635dce1326$var$buildCalendarDays = (value)=>{
    const startDay = value.clone().startOf('month').startOf('week');
    const endDay = value.clone().endOf('month').endOf('week');
    const day = startDay.clone().subtract(1, 'day');
    const days = [];
    while(day.isBefore(endDay, 'day'))days.push(Array(7).fill(0).map(()=>day.add(1, 'day').clone()));
    return days;
};
var $64ea9a635dce1326$export$2e2bcd8739ae039 = $64ea9a635dce1326$var$buildCalendarDays;



var $ejSM7 = parcelRequire("ejSM7");






const $824ad0e1cbe6fe7f$export$a915f81916d25a71 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  position: relative;
`;
const $824ad0e1cbe6fe7f$export$abb4b0be5cbfc1e9 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  z-index: 0;
  position: relative;
  display: flex;
  gap: 20px;
  width: 100%;

  padding: 15px 20px;

  font-size: 16px;
  border-radius: 10px;
  font-weight: 400;
  box-shadow: none;

  border: ${({ theme: theme })=>`1px solid ${theme.colors.borderColor}`};

  background-color: ${({ disabled: disabled, theme: theme })=>disabled ? 'transparent' : theme.colors.backgroundLite};
  cursor: ${({ disabled: disabled })=>disabled ? 'not-allowed' : 'pointer'};
  border-radius: ${({ open: open })=>open ? '10px 10px 0 0' : '10px'};
  /* box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.07); */
`;
const $824ad0e1cbe6fe7f$export$dc52754310de90ca = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $824ad0e1cbe6fe7f$export$b04be29aa201d4f5 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).label`
  position: relative;
  z-index: 1;
  color: ${({ theme: theme })=>theme.colors.primary};
  font-size: 12px;
  padding: 0 8px;
  transform: translate(15px, 15px);

  background-color: ${({ theme: theme })=>theme.colors.background};
  border-radius: 5px;
  width: fit-content;
`;
const $824ad0e1cbe6fe7f$export$fae74ea16922dfbd = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  z-index: ${({ open: open })=>open ? 10 : 0} !important;
  top: 100%;
  position: absolute;
  height: ${({ open: open })=>open ? 'fit-content' : 0} !important;
  padding: ${({ open: open })=>open ? '20px' : '0 20px'} !important;
  overflow: ${({ open: open })=>open ? 'visible' : 'hidden'} !important;
  border-width: 1px;
  border-style: solid;
  border-color: ${({ open: open, theme: theme })=>open ? `${theme.colors.backgroundLite}` : `${theme.colors.backgroundLite}00`};
  transition: 0.3s;

  display: flex;
  flex-direction: column;
  background-color: ${({ theme: theme })=>theme.colors.background};
  width: fit-content;
  border-radius: 10px;
  box-shadow: ${({ open: open })=>open && '0px 0px 7px rgb(0 0 0 / 10%)'};
`;
const $824ad0e1cbe6fe7f$export$8c0fb40c2053deb9 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  height: fit-content;

  & button {
    min-height: 30px;
    min-width: 30px;
    padding: 5px;
    border: none;
    & svg {
      max-width: 100% !important;
      max-height: 100% !important;
    }
    &:hover {
      border: none;
      background-color: ${({ theme: theme })=>theme.colors.brand};
    }
  }
`;
const $824ad0e1cbe6fe7f$export$f4924b24ba81735c = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 10px;
  width: 100%;

  & div {
    margin: 0 !important;
    font-size: 12px !important;
  }
`;
const $824ad0e1cbe6fe7f$export$80ddb20a2792901 = (0, $a778141486c79bc3$export$2e2bcd8739ae039)((0, $c5892724db161e9a$export$2e2bcd8739ae039))``;
const $824ad0e1cbe6fe7f$export$9b1eb6d1773fc30b = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  width: 100%;

  & > div > div > div:last-child {
    max-height: 200px;
    & div > div {
      padding: 3px 5px;
    }
  }
`;
const $824ad0e1cbe6fe7f$export$ced7e5994573e44b = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 30px;
`;
const $824ad0e1cbe6fe7f$export$38995e55f23dbe5b = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px 0 0 0;
`;
const $824ad0e1cbe6fe7f$export$eb9874e3f5c4acea = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 12px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $824ad0e1cbe6fe7f$export$49c3657ed19fd125 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 10px !important;
`;
const $824ad0e1cbe6fe7f$export$c4485302f8878b91 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid !important;
  grid-template-columns: repeat(7, minmax(20px, 1fr)) !important;
  gap: 10px !important;
`;
const $824ad0e1cbe6fe7f$export$56537c841c97711f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 12px;
  text-align: center;
  color: ${({ theme: theme, disabled: disabled })=>disabled ? `${theme.colors.secondary} !important` : theme.colors.primary};
  color: ${({ theme: theme, active: active })=>active && theme.colors.background};
  cursor: pointer;

  padding: 3px 5px;
  border-radius: 5px;
  text-decoration: ${({ forbidden: forbidden })=>forbidden && 'line-through'};

  background-color: ${({ active: active, theme: theme })=>active && theme.colors.brand};
  background-color: ${({ disabled: disabled })=>disabled && 'transparent !important'};
  &:hover {
    background-color: ${({ disabled: disabled, theme: theme })=>!disabled && theme.colors.secondary};
  }
`;


function $4c5ddcea99c574db$var$FutureDatePicker(props) {
    // props
    const { onApply: onApply, disabled: disabled, placeholder: placeholder, defaultDate: defaultDate, maxDate: maxDate, label: label, ...rest } = props;
    const [open, setOpen] = (0, $tZqWC.useState)(false);
    const [days, setDays] = (0, $tZqWC.useState)([]);
    const [currDay, setCurrDay] = (0, $tZqWC.useState)((0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))());
    const [selectedDate, setSelectedDate] = (0, $tZqWC.useState)(defaultDate ? (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(defaultDate) : null);
    const pickerRef = (0, $tZqWC.useRef)();
    // functions
    const handleOpen = ()=>{
        if (!disabled) setOpen((prevValue)=>!prevValue);
    };
    const handleCancel = ()=>{
        if (selectedDate) {
            setCurrDay(selectedDate);
            setOpen(false);
        } else setOpen(false);
    };
    const moveBack = ()=>{
        if (!currDay.isBefore((0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))().subtract(1, 'month'), 'month')) setCurrDay(currDay.clone().subtract(1, 'month'));
    };
    const moveNext = ()=>{
        setCurrDay(currDay.clone().add(1, 'month'));
    };
    const getYears = (forward)=>{
        const year = new Date().getFullYear();
        let reversedYears = [];
        Array.from({
            length: forward
        }, (v, i)=>{
            reversedYears = [
                ...reversedYears,
                {
                    value: year + i + 1,
                    label: year + i + 1
                }
            ];
        });
        return reversedYears;
    };
    const handleMonthChange = (value)=>{
        setCurrDay((prevValue)=>prevValue.clone().set('month', value));
    };
    const handleYearChange = (value)=>{
        setCurrDay((prevValue)=>prevValue.clone().set('year', value));
    };
    const handleClick = (value)=>{
        setSelectedDate(value);
        onApply(value.format((0, $41a9e38e6be32f35$export$1bceb808939a9f0c)));
        setOpen(false);
    };
    // UseEffect
    (0, $tZqWC.useEffect)(()=>{
        setDays((0, $64ea9a635dce1326$export$2e2bcd8739ae039)(currDay));
    }, [
        currDay
    ]);
    (0, $54f47a39f461db48$export$50ec7b7ff742aae5)(pickerRef, handleCancel);
    (0, $tZqWC.useEffect)(()=>{
        if (defaultDate) setSelectedDate((0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(defaultDate));
    }, [
        defaultDate
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $824ad0e1cbe6fe7f$export$a915f81916d25a71), {
        ...rest,
        ref: pickerRef,
        children: [
            label && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $824ad0e1cbe6fe7f$export$b04be29aa201d4f5), {
                children: label
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $824ad0e1cbe6fe7f$export$abb4b0be5cbfc1e9), {
                onClick: handleOpen,
                disabled: disabled,
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $824ad0e1cbe6fe7f$export$dc52754310de90ca), {
                    children: selectedDate ? selectedDate.format('MMMM DD YYYY') : placeholder || 'Select Date'
                })
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $824ad0e1cbe6fe7f$export$fae74ea16922dfbd), {
                open: open,
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $824ad0e1cbe6fe7f$export$8c0fb40c2053deb9), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                onClick: moveBack,
                                disabled: currDay.isBefore((0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))().subtract(1, 'month'), 'month'),
                                variant: "outlined",
                                type: "button",
                                startIcon: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2d68211da31cd8b8$export$2e2bcd8739ae039), {
                                    size: 18
                                })
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $824ad0e1cbe6fe7f$export$f4924b24ba81735c), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $824ad0e1cbe6fe7f$export$9b1eb6d1773fc30b), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $824ad0e1cbe6fe7f$export$80ddb20a2792901), {
                                            options: (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7))).months().map((item)=>({
                                                    value: item,
                                                    label: item
                                                })),
                                            onChange: handleMonthChange,
                                            value: currDay.format('MMMM'),
                                            placeholder: currDay.format('MMMM')
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $824ad0e1cbe6fe7f$export$9b1eb6d1773fc30b), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $824ad0e1cbe6fe7f$export$80ddb20a2792901), {
                                            options: getYears(100),
                                            onChange: handleYearChange,
                                            value: currDay.format('YYYY'),
                                            placeholder: currDay.format('YYYY')
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                onClick: moveNext,
                                variant: "outlined",
                                startIcon: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $738b185bd23471f4$export$2e2bcd8739ae039), {
                                    size: 18
                                }),
                                type: "button"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $824ad0e1cbe6fe7f$export$ced7e5994573e44b), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $824ad0e1cbe6fe7f$export$38995e55f23dbe5b), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $824ad0e1cbe6fe7f$export$eb9874e3f5c4acea), {
                                    children: currDay.format('MMMM YYYY')
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $824ad0e1cbe6fe7f$export$49c3657ed19fd125), {
                                    children: days.map((week)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $824ad0e1cbe6fe7f$export$c4485302f8878b91), {
                                            style: {
                                                display: 'flex',
                                                gap: '20px'
                                            },
                                            children: week.map((day)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $824ad0e1cbe6fe7f$export$56537c841c97711f), {
                                                    onClick: ()=>!day.isBefore((0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(), 'day') && (maxDate ? day.isBefore((0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(maxDate), 'day') : true) && handleClick(day),
                                                    forbidden: day.isBefore((0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(), 'day') || maxDate && day.isAfter((0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(maxDate), 'day'),
                                                    disabled: day.isBefore((0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(), 'day') || !day.isSame(currDay, 'month') || maxDate && day.isAfter((0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(maxDate), 'day'),
                                                    active: day.isSame(selectedDate),
                                                    children: day.format('D')
                                                }, day.format('MM/DD')))
                                        }, week))
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
// Default Props
$4c5ddcea99c574db$var$FutureDatePicker.defaultProps = {
    onApply: ()=>{},
    defaultDate: '',
    maxDate: '',
    simplifiedDate: false,
    disabled: false,
    placeholder: ''
};
// Proptypes Validation
$4c5ddcea99c574db$var$FutureDatePicker.propTypes = {
    onApply: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    defaultDate: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    maxDate: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    simplifiedDate: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
};
var $4c5ddcea99c574db$export$2e2bcd8739ae039 = $4c5ddcea99c574db$var$FutureDatePicker;


var $9a4a1b0113243ef0$export$2e2bcd8739ae039 = (0, $4c5ddcea99c574db$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");
const $95ee0b2ba7b2a3be$var$buildCalendarDays = (value)=>{
    const startDay = value.clone().startOf('month').startOf('week');
    const endDay = value.clone().endOf('month').endOf('week');
    const day = startDay.clone().subtract(1, 'day');
    const days = [];
    while(day.isBefore(endDay, 'day'))days.push(Array(7).fill(0).map(()=>day.add(1, 'day').clone()));
    return days;
};
var $95ee0b2ba7b2a3be$export$2e2bcd8739ae039 = $95ee0b2ba7b2a3be$var$buildCalendarDays;



var $ejSM7 = parcelRequire("ejSM7");






const $cbcb1fcd71709087$export$acf2d8d0e9d6a367 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  z-index: 2;
  display: flex;
  flex-direction: column;
  position: relative;
`;
const $cbcb1fcd71709087$export$efd2ee3668abe4a5 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 20px;
`;
const $cbcb1fcd71709087$export$15e68730ccc59c2 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: ${({ vertical: vertical })=>vertical ? 'column' : 'row'};
  align-items: ${({ vertical: vertical })=>vertical ? 'flex-start' : 'center'};
  font-size: 12px;
  color: ${({ theme: theme })=>theme.colors.primary};
  gap: ${({ vertical: vertical })=>vertical ? '0px' : '5px'};
  cursor: pointer;
  min-width: 90px;
`;
const $cbcb1fcd71709087$export$7fea8804b551b679 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  color: ${({ theme: theme })=>theme.colors.brand};
  font-size: 14px;
  font-weight: 400;
`;
const $cbcb1fcd71709087$export$b04be29aa201d4f5 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-weight: 200;
`;
const $cbcb1fcd71709087$export$a915f81916d25a71 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  min-width: 490px;
  top: 100%;
  margin-top: 15px;
  position: absolute;
  z-index: inherit;
  height: ${({ open: open })=>open ? 'fit-content' : 0} !important;
  padding: ${({ open: open })=>open ? '20px' : '0 20px'} !important;
  overflow: ${({ open: open })=>open ? 'visible' : 'hidden'} !important;
  transition: 0.3s;

  display: flex;
  flex-direction: column;
  background-color: ${({ theme: theme })=>theme.colors.background};
  width: fit-content;
  border-radius: 10px;
  border: ${({ theme: theme, open: open })=>open ? `1px solid ${theme.colors.borderColor}` : '0px'};
  box-shadow: 0px 0px 7px rgb(0 0 0 / 10%);
`;
const $cbcb1fcd71709087$export$abb4b0be5cbfc1e9 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  min-width: 490px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  height: fit-content;

  & button {
    height: 40px;
    width: 40px;
    padding: 5px;
    border: none;
    & svg {
      max-width: 100% !important;
      max-height: 100% !important;
    }
    &:hover {
      border: none;
      background-color: ${({ theme: theme })=>theme.colors.brand};
    }
  }
`;
const $cbcb1fcd71709087$export$f4924b24ba81735c = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  min-width: 290px;
  display: flex;
  gap: 10px;
  width: 100%;

  & div {
    margin: 0 !important;
    font-size: 12px !important;
  }
`;
const $cbcb1fcd71709087$export$80ddb20a2792901 = (0, $a778141486c79bc3$export$2e2bcd8739ae039)((0, $afe5329dc5514fbe$export$2e2bcd8739ae039))``;
const $cbcb1fcd71709087$export$9b1eb6d1773fc30b = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  width: 100%;

  & > div > div > div:last-child {
    max-height: 200px;
    & div > div {
      padding: 3px 5px;
    }
  }
`;
const $cbcb1fcd71709087$export$ced7e5994573e44b = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 30px;
  min-width: 490px;
`;
const $cbcb1fcd71709087$export$38995e55f23dbe5b = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px 0 0 0;
  min-width: 230px;
`;
const $cbcb1fcd71709087$export$eb9874e3f5c4acea = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 12px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $cbcb1fcd71709087$export$49c3657ed19fd125 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 10px !important;
  min-width: 230px;
`;
const $cbcb1fcd71709087$export$c4485302f8878b91 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid !important;
  grid-template-columns: repeat(7, minmax(20px, 1fr)) !important;
  gap: 10px !important;
  min-width: 230px;
`;
const $cbcb1fcd71709087$export$56537c841c97711f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 12px;
  text-align: center;
  color: ${({ theme: theme, disabled: disabled })=>disabled ? `${theme.colors.secondary} !important` : theme.colors.primary};
  color: ${({ theme: theme, active: active })=>active && theme.colors.background};
  cursor: pointer;

  padding: 3px 5px;
  border-radius: 5px;
  text-decoration: ${({ forbidden: forbidden })=>forbidden && 'line-through'};

  background-color: ${({ active: active, theme: theme })=>active && theme.colors.brand};
  background-color: ${({ disabled: disabled })=>disabled && 'transparent !important'};
  &:hover {
    background-color: ${({ disabled: disabled, theme: theme })=>!disabled && theme.colors.secondary};
  }
`;
const $cbcb1fcd71709087$export$46b05479ef2711b = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  min-width: 490px;
  padding: 20px 0 0 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  height: fit-content;

  & button {
    font-size: 14px !important;
    padding: 5px 10px !important;
    border: 1px solid ${({ theme: theme })=>theme.colors.borderColor};
    box-shadow: none;
  }
`;
const $cbcb1fcd71709087$export$46b753c3e7a7fae9 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 10px;
  max-width: none !important;
`;


function $2e0cdb33df239c28$var$DateRangePicker(props) {
    // props
    const { onApply: onApply, start: start, end: end, simplifiedDate: simplifiedDate, vertical: vertical, ...rest } = props;
    const [open, setOpen] = (0, $tZqWC.useState)(false);
    const [days, setDays] = (0, $tZqWC.useState)([]);
    const [days2, setDays2] = (0, $tZqWC.useState)([]);
    const [currDay, setCurrDay] = (0, $tZqWC.useState)((0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))());
    const [currDay2, setCurrDay2] = (0, $tZqWC.useState)((0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))().subtract(1, 'month'));
    const [selectedStart, setSelectedStart] = (0, $tZqWC.useState)(start ? (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(start) : (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))().subtract(1, 'month'));
    const [selectedEnd, setSelectedEnd] = (0, $tZqWC.useState)(end ? (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(end) : (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))());
    const pickerRef = (0, $tZqWC.useRef)();
    // functions
    const handleOpen = ()=>{
        setOpen((prevValue)=>!prevValue);
    };
    const handleCancel = ()=>{
        if (start && end) {
            setSelectedStart((0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(start));
            setSelectedEnd((0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(end));
        } else {
            setSelectedStart((0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))().subtract(1, 'month'));
            setSelectedEnd((0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))());
        }
        setOpen(false);
    };
    const handleApply = ()=>{
        if (selectedStart && selectedEnd) {
            onApply({
                start: selectedStart.format((0, $41a9e38e6be32f35$export$1bceb808939a9f0c)),
                end: selectedEnd.format((0, $41a9e38e6be32f35$export$1bceb808939a9f0c))
            });
            setOpen(false);
        }
    };
    const moveBack = ()=>{
        setCurrDay(currDay.clone().subtract(1, 'month'));
        setCurrDay2(currDay2.clone().subtract(1, 'month'));
    };
    const moveNext = ()=>{
        if (!currDay.isAfter((0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))().subtract(1, 'month'), 'month')) {
            setCurrDay(currDay.clone().add(1, 'month'));
            setCurrDay2(currDay2.clone().add(1, 'month'));
        }
    };
    const getYears = (back)=>{
        const year = new Date().getFullYear();
        let reversedYears = [];
        Array.from({
            length: back
        }, (v, i)=>{
            reversedYears = [
                {
                    value: year - back + i + 1,
                    label: year - back + i + 1
                },
                ...reversedYears
            ];
        });
        return reversedYears;
    };
    const handleMonthChange = (value)=>{
        setCurrDay((prevValue)=>prevValue.clone().set('month', value));
        setCurrDay2((prevValue)=>prevValue.clone().set('month', value).subtract(1, 'month'));
    };
    const handleYearChange = (value)=>{
        setCurrDay((prevValue)=>prevValue.clone().set('year', value));
        setCurrDay2((prevValue)=>prevValue.clone().set('year', value));
    };
    const handleClick = (value)=>{
        if (!selectedStart) return setSelectedStart(value);
        if (selectedStart) {
            if (value.isSame(selectedStart)) return;
            if (!selectedEnd) {
                if (value.isAfter(selectedStart)) return setSelectedEnd(value);
                setSelectedStart(value);
            }
            if (selectedEnd) {
                setSelectedStart(value);
                setSelectedEnd();
            }
        }
    };
    // UseEffect
    (0, $tZqWC.useEffect)(()=>{
        setDays((0, $95ee0b2ba7b2a3be$export$2e2bcd8739ae039)(currDay));
        setDays2((0, $95ee0b2ba7b2a3be$export$2e2bcd8739ae039)(currDay2));
    }, [
        currDay,
        currDay2
    ]);
    (0, $54f47a39f461db48$export$50ec7b7ff742aae5)(pickerRef, handleCancel);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $cbcb1fcd71709087$export$acf2d8d0e9d6a367), {
        ...rest,
        ref: pickerRef,
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $cbcb1fcd71709087$export$efd2ee3668abe4a5), {
                onClick: handleOpen,
                vertical: vertical,
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $cbcb1fcd71709087$export$15e68730ccc59c2), {
                        vertical: vertical,
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $cbcb1fcd71709087$export$b04be29aa201d4f5), {
                                children: "From: "
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $cbcb1fcd71709087$export$7fea8804b551b679), {
                                children: selectedStart && (simplifiedDate ? selectedStart.format('MMM. DD, YYYY') : selectedStart.format('MMMM DD YYYY'))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $cbcb1fcd71709087$export$15e68730ccc59c2), {
                        vertical: vertical,
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $cbcb1fcd71709087$export$b04be29aa201d4f5), {
                                children: "To: "
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $cbcb1fcd71709087$export$7fea8804b551b679), {
                                children: selectedEnd && (simplifiedDate ? selectedEnd.format('MMM. DD, YYYY') : selectedEnd.format('MMMM DD YYYY'))
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $cbcb1fcd71709087$export$a915f81916d25a71), {
                open: open,
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $cbcb1fcd71709087$export$abb4b0be5cbfc1e9), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                onClick: moveBack,
                                variant: "outlined",
                                startIcon: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2d68211da31cd8b8$export$2e2bcd8739ae039), {
                                    size: 18
                                })
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $cbcb1fcd71709087$export$f4924b24ba81735c), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $cbcb1fcd71709087$export$9b1eb6d1773fc30b), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $cbcb1fcd71709087$export$80ddb20a2792901), {
                                            options: (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7))).months().map((item)=>({
                                                    value: item,
                                                    label: item
                                                })),
                                            onChange: handleMonthChange,
                                            value: currDay.format('MMMM'),
                                            placeholder: currDay.format('MMMM')
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $cbcb1fcd71709087$export$9b1eb6d1773fc30b), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $cbcb1fcd71709087$export$80ddb20a2792901), {
                                            options: getYears(20),
                                            onChange: handleYearChange,
                                            value: currDay.format('YYYY'),
                                            placeholder: currDay.format('YYYY')
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                onClick: moveNext,
                                disabled: currDay.isAfter((0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))().subtract(1, 'month'), 'month'),
                                variant: "outlined",
                                startIcon: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $738b185bd23471f4$export$2e2bcd8739ae039), {
                                    size: 18
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $cbcb1fcd71709087$export$ced7e5994573e44b), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $cbcb1fcd71709087$export$38995e55f23dbe5b), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $cbcb1fcd71709087$export$eb9874e3f5c4acea), {
                                        children: currDay2.format('MMMM YYYY')
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $cbcb1fcd71709087$export$49c3657ed19fd125), {
                                        children: days2.map((week)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $cbcb1fcd71709087$export$c4485302f8878b91), {
                                                style: {
                                                    display: 'flex',
                                                    gap: '20px'
                                                },
                                                children: week.map((day)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $cbcb1fcd71709087$export$56537c841c97711f), {
                                                        onClick: ()=>!day.isAfter((0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(), 'day') && handleClick(day),
                                                        forbidden: day.isAfter((0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(), 'day'),
                                                        disabled: day.isAfter((0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(), 'day') || !day.isSame(currDay2, 'month'),
                                                        active: day.isSame(selectedStart) || !!selectedEnd && !!selectedStart && day.isSameOrBefore(selectedEnd) && day.isSameOrAfter(selectedStart),
                                                        children: day.format('D')
                                                    }, day.format('MM/DD')))
                                            }, week))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $cbcb1fcd71709087$export$38995e55f23dbe5b), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $cbcb1fcd71709087$export$eb9874e3f5c4acea), {
                                        children: currDay.format('MMMM YYYY')
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $cbcb1fcd71709087$export$49c3657ed19fd125), {
                                        children: days.map((week)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $cbcb1fcd71709087$export$c4485302f8878b91), {
                                                style: {
                                                    display: 'flex',
                                                    gap: '20px'
                                                },
                                                children: week.map((day)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $cbcb1fcd71709087$export$56537c841c97711f), {
                                                        onClick: ()=>!day.isAfter((0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(), 'day') && handleClick(day),
                                                        forbidden: day.isAfter((0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(), 'day'),
                                                        disabled: day.isAfter((0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(), 'day') || !day.isSame(currDay, 'month'),
                                                        active: day.isSame(selectedStart) || !!selectedEnd && !!selectedStart && day.isSameOrBefore(selectedEnd) && day.isSameOrAfter(selectedStart),
                                                        children: day.format('D')
                                                    }, day.format('MM/DD')))
                                            }, week))
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $cbcb1fcd71709087$export$46b05479ef2711b), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $cbcb1fcd71709087$export$46b753c3e7a7fae9), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $cbcb1fcd71709087$export$15e68730ccc59c2), {
                                        children: [
                                            "From: ",
                                            selectedStart && selectedStart.format('MMMM DD YYYY')
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $cbcb1fcd71709087$export$15e68730ccc59c2), {
                                        children: [
                                            "To: ",
                                            selectedEnd && selectedEnd.format('MMMM DD YYYY')
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $cbcb1fcd71709087$export$46b753c3e7a7fae9), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                        variant: "outlined",
                                        onClick: handleCancel,
                                        children: "Cancel"
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                        id: "apply",
                                        onClick: handleApply,
                                        disabled: !selectedStart || !selectedEnd,
                                        children: "Apply"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
// Default Props
$2e0cdb33df239c28$var$DateRangePicker.defaultProps = {
    onApply: ()=>{},
    start: '',
    end: '',
    simplifiedDate: false,
    vertical: false
};
// Proptypes Validation
$2e0cdb33df239c28$var$DateRangePicker.propTypes = {
    onApply: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    start: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    end: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    simplifiedDate: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    vertical: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
};
var $2e0cdb33df239c28$export$2e2bcd8739ae039 = $2e0cdb33df239c28$var$DateRangePicker;


var $1a3a6d4b17c02c87$export$2e2bcd8739ae039 = (0, $2e0cdb33df239c28$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $eb96aaaf4ffa5364$export$e6dfd72ab29f8598 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;

  font-size: 15px;
  color: ${({ theme: theme, isChecked: isChecked })=>isChecked ? theme.colors.brand : theme.colors.primary};
  cursor: ${({ disabled: disabled })=>disabled ? 'not-allowed' : 'pointer'};

  ${({ horizontal: horizontal })=>horizontal ? 'flex-direction: row; gap: 15px !important;' : 'flex-direction: column;'};
`;
const $eb96aaaf4ffa5364$export$f99233281efd08a0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h2`
  font-size: 15px;
  font-weight: 600;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $eb96aaaf4ffa5364$export$bc7adc8ef74607f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
`;
const $eb96aaaf4ffa5364$export$83a1b8e4fcf0dd8e = (0, $a778141486c79bc3$export$2e2bcd8739ae039).input`
  display: none;

  cursor: ${({ disabled: disabled })=>disabled ? 'not-allowed' : 'pointer'};
  &:checked ~ label > div > span {
    background: ${({ theme: theme })=>theme.colors.brand};
  }
`;
const $eb96aaaf4ffa5364$export$53bebd46e4b5307b = (0, $a778141486c79bc3$export$2e2bcd8739ae039).label`
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: ${({ disabled: disabled })=>disabled ? 'not-allowed' : 'pointer'};
`;
const $eb96aaaf4ffa5364$export$ebd6c85e02a47789 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 20px;
  width: 20px;
  border-radius: 100%;
  background: ${({ theme: theme })=>theme.colors.primary};
`;
const $eb96aaaf4ffa5364$export$53a79cbe5c6b97c1 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).span`
  display: flex;
  height: 18px;
  width: 18px;
  border-radius: 100%;
  background: ${({ theme: theme })=>theme.colors.primary};
`;


function $75dbfd197a98b412$var$Radio(props) {
    // Destructure
    const { id: id, name: name, type: type, label: label, options: options, onChange: onChange, value: value, disabled: disabled, horizontal: horizontal, ...rest } = props;
    const [inputValue, setInputValue] = (0, $tZqWC.useState)(value);
    function handleChange(selectedValue) {
        setInputValue(selectedValue);
        onChange(selectedValue);
    }
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $eb96aaaf4ffa5364$export$e6dfd72ab29f8598), {
        horizontal: horizontal,
        ...rest,
        children: [
            label && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eb96aaaf4ffa5364$export$f99233281efd08a0), {
                children: label
            }),
            options && options.map((item)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $eb96aaaf4ffa5364$export$bc7adc8ef74607f), {
                    onClick: ()=>{
                        if (!item?.disabled) handleChange(item.value);
                    },
                    disabled: item?.disabled,
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eb96aaaf4ffa5364$export$83a1b8e4fcf0dd8e), {
                            name: name,
                            id: item.value,
                            type: "radio",
                            value: item.value,
                            checked: item.value === inputValue,
                            disabled: item?.disabled
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $eb96aaaf4ffa5364$export$53bebd46e4b5307b), {
                            for: item.value,
                            disabled: item?.disabled,
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eb96aaaf4ffa5364$export$ebd6c85e02a47789), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eb96aaaf4ffa5364$export$53a79cbe5c6b97c1), {})
                                }),
                                item.label
                            ]
                        })
                    ]
                }, item.value))
        ]
    });
}
// Default Props
$75dbfd197a98b412$var$Radio.defaultProps = {
    id: '',
    name: '',
    type: '',
    label: '',
    disabled: false,
    options: [],
    onChange: ()=>{},
    value: ''
};
// Proptypes Validation
$75dbfd197a98b412$var$Radio.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    horizontal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number
    ]),
    options: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Array)
};
var $75dbfd197a98b412$export$2e2bcd8739ae039 = $75dbfd197a98b412$var$Radio;


var $b6cab7af1259ed03$export$2e2bcd8739ae039 = (0, $75dbfd197a98b412$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");


const $cdc0764b2f961fb0$export$453a279176869c4d = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
`;
const $cdc0764b2f961fb0$export$cf94744166906111 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).input`
  display: none;
`;
const $cdc0764b2f961fb0$export$abd321670035168b = (0, $a778141486c79bc3$export$2e2bcd8739ae039).label`
  display: inline-block;
  padding: 15px 20px;
  font-size: 16px;
  border-radius: 10px;
  width: 100%;
  font-weight: 400;
  cursor: pointer;
  color: ${({ theme: theme })=>theme.colors.primary};
  background-color: ${({ disabled: disabled, theme: theme })=>disabled ? 'transparent' : theme.colors.backgroundLite};
  border: ${({ theme: theme })=>`1px solid ${theme.colors.backgroundLite}`};
  text-align: center;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${({ theme: theme, disabled: disabled })=>disabled ? 'transparent' : theme.colors.secondary};
  }
`;
const $cdc0764b2f961fb0$export$2a0b83121174119c = (0, $a778141486c79bc3$export$2e2bcd8739ae039).span`
  margin-top: 10px;
  font-size: 14px;
  color: ${({ theme: theme })=>theme.colors.primary};
  word-break: break-all;
`;


function $404745a14917ea59$var$FileField({ id: id, label: label, disabled: disabled, onChange: onChange, accept: accept, ...rest }) {
    const [fileName, setFileName] = (0, $tZqWC.useState)('');
    const handleFileChange = (event)=>{
        const file = event.target.files?.[0];
        if (file) setFileName(file.name);
        else setFileName('');
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $12495b1bc67dc6fb$export$e6dfd72ab29f8598), {
        label: label,
        children: [
            label && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $12495b1bc67dc6fb$export$b04be29aa201d4f5), {
                disabled: disabled,
                children: label
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $cdc0764b2f961fb0$export$453a279176869c4d), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $cdc0764b2f961fb0$export$abd321670035168b), {
                        htmlFor: id,
                        disabled: disabled,
                        children: fileName || 'Choose a file'
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $cdc0764b2f961fb0$export$cf94744166906111), {
                        id: id,
                        type: "file",
                        accept: accept,
                        disabled: disabled,
                        onChange: handleFileChange,
                        ...rest
                    }),
                    fileName && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $cdc0764b2f961fb0$export$2a0b83121174119c), {
                        children: fileName
                    })
                ]
            })
        ]
    });
}
$404745a14917ea59$var$FileField.defaultProps = {
    id: '',
    label: '',
    disabled: false,
    accept: '',
    onChange: ()=>{}
};
$404745a14917ea59$var$FileField.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    accept: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
};
var $404745a14917ea59$export$2e2bcd8739ae039 = $404745a14917ea59$var$FileField;


var $ae3239882ade3d6d$export$2e2bcd8739ae039 = (0, $404745a14917ea59$export$2e2bcd8739ae039);


// JsonField.js


var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

// JsonEditor.elements.js

const $c32070a5a0c2ca4e$export$858f6ee7d95cdaf3 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).textarea`
  padding: 15px 20px;
  font-size: 16px;
  border-radius: 10px;
  width: 100%;
  font-weight: 400;
  outline: none;
  resize: vertical;
  color: ${({ theme: theme })=>theme.colors.primary};
  -webkit-font-smoothing: antialiased;

  background-color: ${({ disabled: disabled, theme: theme })=>disabled ? 'transparent' : theme.colors.backgroundLite};
  border: ${({ theme: theme, error: error })=>error ? `2px solid ${theme.colors.error}` : `1px solid ${theme.colors.backgroundLite}`};

  font-family: monospace;

  &::placeholder {
    color: ${({ theme: theme })=>theme.colors.primary};
  }
`;
const $c32070a5a0c2ca4e$export$7f714e6c560938e5 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  color: ${({ theme: theme })=>theme.colors.error};
  font-size: 14px;
  margin-top: 5px;
`;


function $ca6ae436f472b77b$var$JsonField({ id: id, label: label, disabled: disabled, initialValue: initialValue, onChange: onChange, rows: rows }) {
    const [value, setValue] = (0, $tZqWC.useState)();
    const [error, setError] = (0, $tZqWC.useState)('');
    const handleChange = (e)=>{
        const text = e.target.value;
        setValue(text);
        onChange(text);
        try {
            JSON.parse(text);
            setError('');
        } catch  {
            setError('Invalid JSON');
        }
    };
    (0, $tZqWC.useEffect)(()=>{
        if (initialValue && Object.keys(initialValue).length > 0 && !value) setValue(JSON.stringify(initialValue, null, 2));
    }, [
        initialValue
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $12495b1bc67dc6fb$export$e6dfd72ab29f8598), {
        label: label,
        children: [
            label && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $12495b1bc67dc6fb$export$b04be29aa201d4f5), {
                disabled: disabled,
                children: label
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c32070a5a0c2ca4e$export$858f6ee7d95cdaf3), {
                rows: rows,
                id: id,
                disabled: disabled,
                value: value,
                onChange: handleChange,
                error: !!error
            }),
            error && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c32070a5a0c2ca4e$export$7f714e6c560938e5), {
                children: error
            })
        ]
    });
}
$ca6ae436f472b77b$var$JsonField.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    rows: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    // eslint-disable-next-line react/forbid-prop-types
    initialValue: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).object,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
};
$ca6ae436f472b77b$var$JsonField.defaultProps = {
    id: '',
    label: '',
    rows: '5',
    disabled: false,
    initialValue: {},
    onChange: ()=>{}
};
var $ca6ae436f472b77b$export$2e2bcd8739ae039 = $ca6ae436f472b77b$var$JsonField;


var $278bd1e80972f508$export$2e2bcd8739ae039 = (0, $ca6ae436f472b77b$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

var $krg3S = parcelRequire("krg3S");

const $9ff3e42c05e89a77$export$e6dfd72ab29f8598 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: 100%;
  position: relative;
`;
const $9ff3e42c05e89a77$export$842aba50ed0ce9d7 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).label`
  display: block;
  position: relative;
  z-index: 1;
  color: ${({ theme: theme })=>theme.colors.primary};
  font-size: 12px;
  padding: 0 8px;
  transform: translate(15px, 15px);

  background-color: ${({ theme: theme })=>theme.colors.background};
  border-radius: 5px;
  width: fit-content;
`;
const $9ff3e42c05e89a77$export$185a8afe504e8fca = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  margin-left: 20px;
  color: ${({ theme: theme })=>theme.colors.brightRed};
  font-size: 14px;
`;



const $b8a4f37823867cae$export$a2dc1e79bfbe1301 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).input`
  padding: 15px 20px;
  font-size: 16px;
  border-radius: 10px;
  width: 100%;
  font-weight: 400;
  outline: none;
  -webkit-font-smoothing: antialiased;
  color: ${({ theme: theme })=>theme.colors.primary};

  border: ${({ theme: theme })=>`1px solid ${theme.colors.backgroundLite}`};

  background-color: ${({ disabled: disabled, theme: theme })=>disabled ? 'transparent;' : theme.colors.backgroundLite};

  &::placeholder {
    color: ${({ theme: theme })=>theme.colors.primary};
  }
`;


function $5f372565ec15d92d$var$FormTextField(props) {
    // Destructure
    const { type: type, label: label, disabled: disabled, ...rest } = props;
    // Hooks
    const [fields] = (0, $krg3S.useField)(props);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9ff3e42c05e89a77$export$e6dfd72ab29f8598), {
        label: label,
        children: [
            label && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9ff3e42c05e89a77$export$842aba50ed0ce9d7), {
                disabled: disabled,
                children: label
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b8a4f37823867cae$export$a2dc1e79bfbe1301), {
                disabled: disabled,
                type: type,
                ...fields,
                ...rest
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9ff3e42c05e89a77$export$185a8afe504e8fca), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $krg3S.ErrorMessage), {
                    ...fields
                })
            })
        ]
    });
}
// Default Props
$5f372565ec15d92d$var$FormTextField.defaultProps = {
    type: '',
    label: '',
    disabled: false
};
// Proptypes Validation
$5f372565ec15d92d$var$FormTextField.propTypes = {
    type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
};
var $5f372565ec15d92d$export$2e2bcd8739ae039 = $5f372565ec15d92d$var$FormTextField;


var $9d75ef3d13fecbc2$export$2e2bcd8739ae039 = (0, $5f372565ec15d92d$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

var $krg3S = parcelRequire("krg3S");

const $ae547c30c95b2eea$export$a8cf7e2c856df78d = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  width: 100%;
  margin-top: ${({ label: label })=>label && '-5px;'};
`;
const $ae547c30c95b2eea$export$b04be29aa201d4f5 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).label`
  position: absolute;
  z-index: 1;
  color: ${({ theme: theme })=>theme.colors.primary};
  font-size: 12px;
  padding: 0 8px;
  top: -10px;
  left: 15px;

  border-radius: 5px;
  width: fit-content;
  background-color: ${({ disabled: disabled, theme: theme })=>disabled ? theme.colors.background : 'transparent'};
`;
const $ae547c30c95b2eea$export$c9719dfad4306c45 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).input`
  transition: 0.4s;

  position: relative;

  min-height: 54px;
  height: fit-content;
  width: 100%;

  padding: 15px 20px;

  font-size: 16px;
  border-radius: 10px;
  font-weight: 400;
  box-shadow: none;
  outline: none;
  color: ${({ theme: theme })=>theme.colors.backgroundLite};

  border: ${({ theme: theme })=>`1px solid ${theme.colors.backgroundLite}`};

  background-color: ${({ disabled: disabled, theme: theme })=>disabled ? 'transparent' : theme.colors.backgroundLite};

  &::placeholder {
    color: ${({ theme: theme })=>theme.colors.primary};
  }
`;
const $ae547c30c95b2eea$export$a6151309bfd46137 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: absolute;
  top: 110%;
  display: flex;
  flex-direction: column;

  padding: 10px;
  width: 100%;
  max-height: 300px;
  overflow-y: auto;

  font-size: 16px;
  border-radius: 10px;
  font-weight: 400;

  border: ${({ theme: theme })=>`1px solid ${theme.colors.backgroundLite}`};
  background-color: ${({ disabled: disabled, theme: theme })=>disabled ? theme.colors.backgroundLite : 'transparent'};
  user-select: none;
  z-index: 2;
`;
const $ae547c30c95b2eea$export$ba141e9a22070242 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 10px;
  gap: 10px;
  color: ${({ theme: theme })=>theme.colors.primary};

  cursor: pointer;
  transition: 0.4s;

  border-radius: 10px;
  border: 1px solid rgba(0, 0, 0, 0);

  &:hover {
    border: ${({ theme: theme })=>`1px solid ${theme.colors.backgroundLite}`};
  }
`;
const $ae547c30c95b2eea$export$98321245064bc252 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).input`
  display: none;
`;


// Function that listens to oustide clicks of given ref
const $02ac069fe8061d02$var$useOutsideAlerter = (ref, setShowOptions)=>{
    (0, $tZqWC.useEffect)(()=>{
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) setShowOptions(false);
        }
        document.addEventListener('mousedown', handleClickOutside);
        return ()=>{
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [
        ref
    ]);
};
function $02ac069fe8061d02$var$FormAutoComplete(props) {
    // Destructure
    const { label: label, options: options, placeholder: placeholder, onInputChange: onInputChange, onSelect: onSelect, isLoading: isLoading, disabled: disabled, ...rest } = props;
    // Variables
    const withOptions = options && options?.length > 0;
    // Refs
    const inputRef = (0, $tZqWC.useRef)();
    const wrapperRef = (0, $tZqWC.useRef)();
    // Hooks
    const [{ name: name }, , { setValue: setValue }] = (0, $krg3S.useField)(props);
    // States
    const [inputValue, setInputValue] = (0, $tZqWC.useState)('');
    const [showOptions, setShowOptions] = (0, $tZqWC.useState)(false);
    // Functions
    const handleOnSelect = (e)=>{
        onSelect(e);
    };
    const handleOnClick = async (value)=>{
        await setValue(value);
        await setInputValue(value);
        await setShowOptions(false);
        inputRef.current.click();
    };
    const handleOnChange = (e)=>{
        setInputValue(e.target.value);
        onInputChange(e);
    };
    // Closing options on click away
    $02ac069fe8061d02$var$useOutsideAlerter(wrapperRef, setShowOptions);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $ae547c30c95b2eea$export$a8cf7e2c856df78d), {
        label: label,
        ref: wrapperRef,
        children: [
            label && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ae547c30c95b2eea$export$b04be29aa201d4f5), {
                disabled: disabled,
                children: label
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ae547c30c95b2eea$export$98321245064bc252), {
                ref: inputRef,
                value: inputValue,
                onChange: ()=>{},
                onClick: handleOnSelect
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ae547c30c95b2eea$export$c9719dfad4306c45), {
                name: name,
                value: inputValue,
                onChange: handleOnChange,
                placeholder: placeholder,
                onFocus: ()=>{
                    setShowOptions(true);
                },
                type: "search",
                autoComplete: "off",
                disabled: disabled,
                ...rest
            }),
            showOptions && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ae547c30c95b2eea$export$a6151309bfd46137), {
                children: withOptions ? options.map(({ value: value, label: label })=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ae547c30c95b2eea$export$ba141e9a22070242), {
                        onClick: ()=>{
                            handleOnClick(value);
                        },
                        value: value,
                        children: label
                    }, label)) : /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                    children: [
                        isLoading && 'loading...',
                        !isLoading && 'No results found'
                    ]
                })
            })
        ]
    });
}
// Default Props
$02ac069fe8061d02$var$FormAutoComplete.defaultProps = {
    type: '',
    label: '',
    placeholder: '',
    variant: 'outlined',
    options: [],
    onSelect: ()=>{},
    onInputChange: ()=>{},
    getOptionSelected: ()=>{},
    getOptionLabel: ()=>{},
    isLoading: false,
    disabled: false
};
// Proptypes Validation
$02ac069fe8061d02$var$FormAutoComplete.propTypes = {
    type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    variant: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    options: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Array),
    onSelect: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    onInputChange: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    getOptionSelected: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    getOptionLabel: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
};
var $02ac069fe8061d02$export$2e2bcd8739ae039 = $02ac069fe8061d02$var$FormAutoComplete;


var $477398b21fbfc3ae$export$2e2bcd8739ae039 = (0, $02ac069fe8061d02$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

var $krg3S = parcelRequire("krg3S");



const $a72bd2775d62c5a0$export$8f1ff89fa1ec9605 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  min-height: 48px;
`;
const $a72bd2775d62c5a0$export$d6701e98ab1a6725 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).input`
  display: none;
`;
const $a72bd2775d62c5a0$export$37cdf0d06bb542b5 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  cursor: ${(props)=>props.disabled ? 'default' : 'pointer'};
  color: ${({ theme: theme })=>theme.colors.primary};
  background-color: ${({ disabled: disabled, theme: theme })=>disabled ? 'transparent' : theme.colors.backgroundLite};
  transition: 0.4s;

  position: relative;
  // TODO: Use theme functions
  &:after {
    content: '';

    position: absolute;
    top: 42%;
    right: 15px;

    display: ${({ disabled: disabled })=>disabled ? 'none' : 'inline-block'};
    margin-left: 0.255em;
    vertical-align: 0.255em;

    border-top: 0.3em solid;
    border-right: 0.3em solid transparent;
    border-bottom: 0;
    border-left: 0.3em solid transparent;
    color: ${({ theme: theme })=>theme.colors.primary};
  }

  min-height: 54px;
  height: fit-content;
  width: 100%;

  padding: 15px 20px;

  font-size: 16px;
  border-radius: 10px;
  font-weight: 400;
  box-shadow: none;

  border: ${({ theme: theme })=>`1px solid ${theme.colors.borderColor}`};
`;
const $a72bd2775d62c5a0$export$a6151309bfd46137 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: absolute;
  top: 100%;
  display: flex;
  flex-direction: column;
  max-height: 300px;
  overflow-y: auto;

  padding: 10px 15px;
  width: 100%;

  font-size: 14px;
  border-radius: 10px;
  font-weight: 400;
  color: ${({ theme: theme })=>theme.colors.primary};
  background-color: ${({ theme: theme })=>theme.colors.background};
  border: ${({ theme: theme })=>`1px solid ${theme.colors.borderColor}`};
  user-select: none;
  z-index: 4;
`;
const $a72bd2775d62c5a0$export$ba141e9a22070242 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  padding: 10px;

  cursor: pointer;
  transition: 0.4s;

  border: 1px solid rgba(0, 0, 0, 0);
  border-radius: 10px;

  min-width: 40px;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  &:hover {
    border: ${({ theme: theme })=>`1px solid ${theme.colors.borderColor}`};
  }
`;
const $a72bd2775d62c5a0$export$a11e67ac8be84bf9 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  color: ${({ theme: theme })=>theme.colors.backgroundLite};
  min-width: 40px;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;


// Function that listens to oustide clicks of given ref
const $71bdcd7c0fde8ceb$var$useOutsideAlerter = (ref, setShowOptions)=>{
    (0, $tZqWC.useEffect)(()=>{
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) setShowOptions(false);
        }
        document.addEventListener('mousedown', handleClickOutside);
        return ()=>{
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [
        ref
    ]);
};
function $71bdcd7c0fde8ceb$var$FormSelect(props) {
    // Destructure
    const { label: label, placeholder: placeholder, options: options, disabled: disabled, type: type, ...rest } = props;
    const [fields] = (0, $krg3S.useField)(props);
    // Variables
    const withOptions = options && options?.length > 0;
    const wrapperRef = (0, $tZqWC.useRef)();
    const inputRef = (0, $tZqWC.useRef)(null);
    const { name: name, value: value, onChange: onChange } = fields;
    // Hooks
    const [formValue, setValue] = (0, $tZqWC.useState)('');
    const [valueLabel, setValueLabel] = (0, $tZqWC.useState)(placeholder || '');
    const [showOptions, setShowOptions] = (0, $tZqWC.useState)(false);
    // Functions
    const handleOnChange = async (elValue, elLabel)=>{
        await setValue(elValue);
        if (elValue === undefined) {
            await setValueLabel(placeholder || '');
            return setShowOptions(false);
        }
        await setValueLabel(elLabel);
        onChange({
            target: {
                name: name,
                value: elValue
            }
        });
        setShowOptions(false);
    };
    // UseEffects
    (0, $tZqWC.useEffect)(()=>{
        // setting the value and label on initial load
        if (value !== undefined && value !== null) {
            setValue(value);
            const currentLabel = options.find((data)=>{
                if (typeof data.value === 'number') return data.value === Number(value);
                return data.value === value;
            });
            if (currentLabel?.label) setValueLabel(currentLabel.label);
            else if (!currentLabel?.label) setValueLabel(placeholder || '');
        }
    }, [
        value
    ]);
    // Closing options on click away
    $71bdcd7c0fde8ceb$var$useOutsideAlerter(wrapperRef, setShowOptions);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9ff3e42c05e89a77$export$e6dfd72ab29f8598), {
        label: label,
        ref: wrapperRef,
        children: [
            label && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9ff3e42c05e89a77$export$842aba50ed0ce9d7), {
                disabled: disabled,
                children: label
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $a72bd2775d62c5a0$export$8f1ff89fa1ec9605), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a72bd2775d62c5a0$export$d6701e98ab1a6725), {
                        ref: inputRef,
                        type: type,
                        name: name,
                        onChange: ()=>{},
                        value: formValue,
                        ...rest
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a72bd2775d62c5a0$export$37cdf0d06bb542b5), {
                        disabled: disabled,
                        onClick: ()=>{
                            if (!disabled) setShowOptions((prevState)=>!prevState);
                        },
                        children: valueLabel !== undefined ? valueLabel : placeholder
                    }),
                    showOptions && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a72bd2775d62c5a0$export$a6151309bfd46137), {
                        children: withOptions && options.map(({ value: value, label: label, abrv: abrv, icon: icon })=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("div", {
                                children: label !== valueLabel && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $a72bd2775d62c5a0$export$ba141e9a22070242), {
                                    onClick: ()=>{
                                        handleOnChange(value, label);
                                    },
                                    value: value,
                                    children: [
                                        icon && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $65f0d7ff3fd922b2$export$2e2bcd8739ae039), {
                                            src: icon,
                                            width: 30,
                                            height: 30
                                        }),
                                        label,
                                        abrv && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $a72bd2775d62c5a0$export$a11e67ac8be84bf9), {
                                            children: [
                                                " ",
                                                abrv,
                                                " "
                                            ]
                                        })
                                    ]
                                })
                            }, label))
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9ff3e42c05e89a77$export$185a8afe504e8fca), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $krg3S.ErrorMessage), {
                            ...fields
                        })
                    })
                ]
            })
        ]
    });
}
// Default Props
$71bdcd7c0fde8ceb$var$FormSelect.defaultProps = {
    label: '',
    placeholder: '',
    type: '',
    options: []
};
// Proptypes Validation
$71bdcd7c0fde8ceb$var$FormSelect.propTypes = {
    label: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    options: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Array)
};
var $71bdcd7c0fde8ceb$export$2e2bcd8739ae039 = $71bdcd7c0fde8ceb$var$FormSelect;


var $99b5eccf8ae49d07$export$2e2bcd8739ae039 = (0, $71bdcd7c0fde8ceb$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

var $krg3S = parcelRequire("krg3S");



const $8dac84b60b4d7b1d$export$8f1ff89fa1ec9605 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  min-height: 48px;
`;
const $8dac84b60b4d7b1d$export$d6701e98ab1a6725 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).input`
  display: none;
`;
const $8dac84b60b4d7b1d$export$11a8a1ea41bf55d8 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).option`
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $8dac84b60b4d7b1d$export$37cdf0d06bb542b5 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).input`
  color: ${({ theme: theme })=>theme.colors.primary};
  background-color: ${({ disabled: disabled, theme: theme })=>disabled ? 'transparent' : theme.colors.backgroundLite};
  transition: 0.4s;

  position: relative;
  // TODO: Use theme functions
  &:after {
    content: '';

    position: absolute;
    top: 42%;
    right: 15px;

    display: ${({ disabled: disabled })=>disabled ? 'none' : 'inline-block'};
    margin-left: 0.255em;
    vertical-align: 0.255em;

    border-top: 0.3em solid;
    border-right: 0.3em solid transparent;
    border-bottom: 0;
    border-left: 0.3em solid transparent;
    color: ${({ theme: theme })=>theme.colors.primary};
  }

  min-height: 54px;
  height: fit-content;
  width: 100%;

  padding: 15px 20px;

  font-size: 16px;
  border-radius: 10px;
  font-weight: 400;
  box-shadow: none;

  border: ${({ theme: theme })=>`1px solid ${theme.colors.borderColor}`};
  cursor: pointer;

  &:focus {
    outline: none;
  }
`;
const $8dac84b60b4d7b1d$export$a6151309bfd46137 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: absolute;
  top: 100%;
  display: flex;
  flex-direction: column;
  max-height: 300px;
  overflow-y: auto;

  padding: 10px 15px;
  width: 100%;

  font-size: 14px;
  border-radius: 10px;
  font-weight: 400;
  color: ${({ theme: theme })=>theme.colors.primary};
  background-color: ${({ theme: theme })=>theme.colors.background};
  border: ${({ theme: theme })=>`1px solid ${theme.colors.borderColor}`};
  user-select: none;
  z-index: 4;
`;
const $8dac84b60b4d7b1d$export$ba141e9a22070242 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  padding: 10px;

  cursor: pointer;
  transition: 0.4s;

  border: 1px solid rgba(0, 0, 0, 0);
  border-radius: 10px;

  &:hover {
    border: ${({ theme: theme })=>`1px solid ${theme.colors.borderColor}`};
  }
`;
const $8dac84b60b4d7b1d$export$a11e67ac8be84bf9 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  color: ${({ theme: theme })=>theme.colors.backgroundLite};
`;


// Function that listens to oustide clicks of given ref
const $410e5da9cf493fe8$var$useOutsideAlerter = (ref, setShowOptions)=>{
    (0, $tZqWC.useEffect)(()=>{
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) setShowOptions(false);
        }
        document.addEventListener('mousedown', handleClickOutside);
        return ()=>{
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [
        ref
    ]);
};
function $410e5da9cf493fe8$var$FormSearchSelect(props) {
    // Destructure
    const { label: label, placeholder: placeholder, options: options, disabled: disabled, type: type, ...rest } = props;
    const [fields] = (0, $krg3S.useField)(props);
    // Variables
    const wrapperRef = (0, $tZqWC.useRef)();
    const inputRef = (0, $tZqWC.useRef)(null);
    const { name: name, value: value, onChange: onChange } = fields;
    // Hooks
    const [formValue, setValue] = (0, $tZqWC.useState)('');
    const [formValueChanged, setFormValueChanged] = (0, $tZqWC.useState)(false);
    const [valueLabel, setValueLabel] = (0, $tZqWC.useState)(placeholder || '');
    const [showOptions, setShowOptions] = (0, $tZqWC.useState)(false);
    const [optionState, setOptionState] = (0, $tZqWC.useState)(options);
    // Functions
    const handleOnChange = (inputValue, inputLabel)=>{
        setValue(inputValue);
        if (inputValue === undefined) {
            setValueLabel(placeholder || '');
            setFormValueChanged(true);
            return setShowOptions(false);
        }
        setValueLabel(inputLabel);
        setFormValueChanged(true);
        setShowOptions(false);
    };
    const handleOnSearch = (inputValue)=>{
        if (!showOptions) setShowOptions(true);
        setValueLabel(inputValue);
        if (!inputValue) {
            setOptionState(options);
            setValue('');
            return setFormValueChanged(true);
        }
        const newOptions = [];
        options.forEach((option)=>{
            if (option?.label.toLowerCase().startsWith(inputValue.toLowerCase())) newOptions.push(option);
        });
        if (newOptions.length < 1) return setOptionState([]);
        setOptionState(newOptions);
    };
    // UseEffects
    (0, $tZqWC.useEffect)(()=>{
        // setting the value and label on initial load
        if (value !== undefined && value !== null) {
            setValue(value);
            const currentLabel = options.find((data)=>{
                if (typeof data.value === 'number') return data.value === Number(value);
                return data.value === value;
            });
            if (currentLabel?.label) setValueLabel(currentLabel.label);
            else if (!currentLabel?.label) setValueLabel(placeholder || '');
        }
    }, [
        value
    ]);
    // manually calling onchange event of formik input through onClick
    (0, $tZqWC.useEffect)(()=>{
        if (formValueChanged) {
            inputRef.current.click();
            setFormValueChanged(false);
        }
    }, [
        formValueChanged
    ]);
    (0, $tZqWC.useEffect)(()=>setOptionState(options), [
        options
    ]);
    // Closing options on click away
    $410e5da9cf493fe8$var$useOutsideAlerter(wrapperRef, setShowOptions);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9ff3e42c05e89a77$export$e6dfd72ab29f8598), {
        label: label,
        children: [
            label && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9ff3e42c05e89a77$export$842aba50ed0ce9d7), {
                disabled: disabled,
                children: label
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8dac84b60b4d7b1d$export$8f1ff89fa1ec9605), {
                ref: wrapperRef,
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $8dac84b60b4d7b1d$export$d6701e98ab1a6725), {
                        autoComplete: "form-search-select",
                        ref: inputRef,
                        type: "search",
                        onClick: (e)=>{
                            onChange(e);
                        },
                        name: name,
                        onChange: ()=>{},
                        value: formValue,
                        ...rest
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $8dac84b60b4d7b1d$export$37cdf0d06bb542b5), {
                        autoComplete: "form-search-select",
                        disabled: disabled,
                        value: valueLabel !== undefined ? valueLabel : placeholder,
                        type: "search",
                        onChange: (e)=>handleOnSearch(e.target.value),
                        onClick: ()=>{
                            if (!disabled) setShowOptions(true);
                        }
                    }),
                    showOptions && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8dac84b60b4d7b1d$export$a6151309bfd46137), {
                        children: [
                            optionState.length > 0 && optionState.map(({ value: value, label: label, abrv: abrv, icon: icon })=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("div", {
                                    children: label !== valueLabel && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8dac84b60b4d7b1d$export$ba141e9a22070242), {
                                        onClick: ()=>{
                                            handleOnChange(value, label);
                                        },
                                        value: value,
                                        children: [
                                            icon && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $65f0d7ff3fd922b2$export$2e2bcd8739ae039), {
                                                src: icon,
                                                width: 30,
                                                height: 30
                                            }),
                                            label,
                                            abrv && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8dac84b60b4d7b1d$export$a11e67ac8be84bf9), {
                                                children: [
                                                    " ",
                                                    abrv,
                                                    " "
                                                ]
                                            })
                                        ]
                                    })
                                }, label)),
                            optionState.length < 1 && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("div", {
                                children: " No Options Found"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9ff3e42c05e89a77$export$185a8afe504e8fca), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $krg3S.ErrorMessage), {
                            ...fields
                        })
                    })
                ]
            })
        ]
    });
}
// Default Props
$410e5da9cf493fe8$var$FormSearchSelect.defaultProps = {
    label: '',
    placeholder: '',
    type: '',
    options: []
};
// Proptypes Validation
$410e5da9cf493fe8$var$FormSearchSelect.propTypes = {
    label: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    options: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Array)
};
var $410e5da9cf493fe8$export$2e2bcd8739ae039 = $410e5da9cf493fe8$var$FormSearchSelect;


var $6e833112b656c531$export$2e2bcd8739ae039 = (0, $410e5da9cf493fe8$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

var $krg3S = parcelRequire("krg3S");


const $5dbcf21c9661f74b$export$60f0a624ce7f4c8e = (0, $a778141486c79bc3$export$2e2bcd8739ae039).textarea`
  padding: 15px 20px;
  font-size: 16px;
  border-radius: 10px;
  width: 100%;
  height: 100%;
  font-weight: 400;
  outline: none;
  color: ${({ theme: theme })=>theme.colors.primary};

  border: ${({ theme: theme })=>`1px solid ${theme.colors.backgroundLite}`};
  background-color: ${({ disabled: disabled, theme: theme })=>disabled ? 'transparent' : theme.colors.backgroundLite};

  ${({ resize: resize })=>!resize && 'resize: none;'}

  &::placeholder {
    color: ${({ theme: theme })=>theme.colors.primary};
  }
`;


function $82245cdcedb5ed12$var$FormTextArea(props) {
    // Destructure
    const { type: type, label: label, resize: resize, disabled: disabled, ...rest } = props;
    // Hooks
    const [fields] = (0, $krg3S.useField)(props);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9ff3e42c05e89a77$export$e6dfd72ab29f8598), {
        label: label,
        children: [
            label && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9ff3e42c05e89a77$export$842aba50ed0ce9d7), {
                disabled: disabled,
                children: label
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5dbcf21c9661f74b$export$60f0a624ce7f4c8e), {
                disabled: disabled,
                type: type,
                resize: resize,
                ...fields,
                ...rest
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9ff3e42c05e89a77$export$185a8afe504e8fca), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $krg3S.ErrorMessage), {
                    ...fields
                })
            })
        ]
    });
}
// Default Props
$82245cdcedb5ed12$var$FormTextArea.defaultProps = {
    type: '',
    label: '',
    resize: true,
    disabled: false
};
// Proptypes Validation
$82245cdcedb5ed12$var$FormTextArea.propTypes = {
    type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    resize: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
};
var $82245cdcedb5ed12$export$2e2bcd8739ae039 = $82245cdcedb5ed12$var$FormTextArea;


var $dfc171aac0fd6ec5$export$2e2bcd8739ae039 = (0, $82245cdcedb5ed12$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

var $krg3S = parcelRequire("krg3S");


const $88815f1cf6dffe6d$export$a915f81916d25a71 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: 100%;
  background-color: ${({ disabled: disabled, theme: theme })=>disabled ? theme.colors.backgroundLite : 'transparent'};
`;
const $88815f1cf6dffe6d$export$8f1ff89fa1ec9605 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  min-height: 48px;
`;
const $88815f1cf6dffe6d$export$7edc06cf1783b30f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).input`
  display: none;
`;
const $88815f1cf6dffe6d$export$11a8a1ea41bf55d8 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).option`
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $88815f1cf6dffe6d$export$ced7ae022d0f5ee5 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  cursor: pointer;
  transition: 0.4s;
  color: ${({ theme: theme })=>theme.colors.primary};

  position: relative;
  // TODO: Use theme functions
  &:after {
    content: '';

    position: absolute;
    top: 42%;
    right: 15px;

    display: inline-block;
    margin-left: 0.255em;
    vertical-align: 0.255em;

    border-top: 0.3em solid;
    border-right: 0.3em solid transparent;
    border-bottom: 0;
    border-left: 0.3em solid transparent;
    color: ${({ theme: theme })=>theme.colors.primary};
  }

  min-height: 48px;
  height: fit-content;
  width: 100%;

  padding: 15px 20px;

  font-size: 16px;
  border-radius: 10px;
  font-weight: 400;
  box-shadow: none;

  border: ${({ theme: theme })=>`1px solid ${theme.colors.backgroundLite}`};

  &:hover {
    box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, 0.1);
  }
`;
const $88815f1cf6dffe6d$export$a6151309bfd46137 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: absolute;
  top: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 300px;
  overflow-y: auto;

  padding: 10px;
  width: 100%;

  font-size: 14px;
  border-radius: 10px;
  font-weight: 400;
  background-color: ${({ theme: theme })=>theme.colors.background};
  border: ${({ theme: theme })=>`1px solid ${theme.colors.backgroundLite}`};
  user-select: none;
  z-index: 2;
`;
const $88815f1cf6dffe6d$export$ba141e9a22070242 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  padding: 10px;
  color: ${({ theme: theme })=>theme.colors.primary};

  cursor: pointer;
  transition: 0.4s;

  border: ${({ theme: theme })=>`1px solid ${theme.colors.backgroundLite}`};
  border-radius: 10px;

  &:hover {
    background: ${({ theme: theme })=>theme.colors.borderColor};
  }
`;




function $d2e044837429ccb8$var$FormDatePicker(props) {
    // Destructure
    const { label: label, disabled: disabled, placeholder: placeholder, options: options, future: future, maxDate: maxDate, ...rest } = props;
    const [fields] = (0, $krg3S.useField)(props);
    // Variables
    const wrapperRef = (0, $tZqWC.useRef)();
    const inputRef = (0, $tZqWC.useRef)(null);
    const { name: name, value: value, onChange: onChange } = fields;
    // Hooks
    const [formValue, setFormValue] = (0, $tZqWC.useState)(value || '');
    // Functions
    const handleOnChange = async (elValue)=>{
        await setFormValue(elValue);
        // manually calling onchange event of formik input through onClick
        inputRef.current.click();
    };
    // UseEffects
    (0, $tZqWC.useEffect)(()=>{
        // setting the value on initial load
        if (value) setFormValue(value);
    }, [
        value
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $88815f1cf6dffe6d$export$a915f81916d25a71), {
        label: label,
        ref: wrapperRef,
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $88815f1cf6dffe6d$export$8f1ff89fa1ec9605), {
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $88815f1cf6dffe6d$export$7edc06cf1783b30f), {
                    ref: inputRef,
                    onClick: (e)=>{
                        onChange(e);
                    },
                    name: name,
                    onChange: ()=>{},
                    value: formValue,
                    type: "date",
                    disabled: disabled,
                    ...rest
                }),
                future ? /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9a4a1b0113243ef0$export$2e2bcd8739ae039), {
                    label: label,
                    disabled: disabled,
                    defaultDate: formValue,
                    onApply: handleOnChange,
                    maxDate: maxDate
                }) : /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $0c99b953747ef22f$export$2e2bcd8739ae039), {
                    label: label,
                    disabled: disabled,
                    defaultDate: formValue,
                    onApply: handleOnChange
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9ff3e42c05e89a77$export$185a8afe504e8fca), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $krg3S.ErrorMessage), {
                        ...fields
                    })
                })
            ]
        })
    });
}
// Default Props
$d2e044837429ccb8$var$FormDatePicker.defaultProps = {
    label: '',
    placeholder: '',
    maxDate: '',
    disabled: false,
    future: false,
    options: []
};
// Proptypes Validation
$d2e044837429ccb8$var$FormDatePicker.propTypes = {
    label: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    maxDate: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    future: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    options: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Array)
};
var $d2e044837429ccb8$export$2e2bcd8739ae039 = $d2e044837429ccb8$var$FormDatePicker;


var $a5484141b8231e9a$export$2e2bcd8739ae039 = (0, $d2e044837429ccb8$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

var $krg3S = parcelRequire("krg3S");


const $8a4bd29b024b94e1$export$4169eb6d571e3f08 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).input`
  padding: 15px 20px;
  font-size: 16px;
  border-radius: 10px;
  width: 100%;
  font-weight: 400;
  outline: none;
  -webkit-font-smoothing: antialiased;
  color: ${({ theme: theme })=>theme.colors.primary};

  border: ${({ theme: theme })=>`1px solid ${theme.colors.backgroundLite}`};

  background-color: ${({ disabled: disabled, theme: theme })=>disabled ? 'transparent;' : theme.colors.backgroundLite};

  &::placeholder {
    color: ${({ theme: theme })=>theme.colors.primary};
  }
`;


function $09e9ae62fda31228$var$FormFileField(props) {
    // Destructure
    const { label: label, disabled: disabled, ...rest } = props;
    // Hooks
    const [fields] = (0, $krg3S.useField)(props);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9ff3e42c05e89a77$export$e6dfd72ab29f8598), {
        label: label,
        children: [
            label && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9ff3e42c05e89a77$export$842aba50ed0ce9d7), {
                disabled: disabled,
                children: label
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $8a4bd29b024b94e1$export$4169eb6d571e3f08), {
                disabled: disabled,
                type: "file",
                ...fields,
                ...rest
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9ff3e42c05e89a77$export$185a8afe504e8fca), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $krg3S.ErrorMessage), {
                    ...fields
                })
            })
        ]
    });
}
// Default Props
$09e9ae62fda31228$var$FormFileField.defaultProps = {
    type: '',
    label: '',
    disabled: false
};
// Proptypes Validation
$09e9ae62fda31228$var$FormFileField.propTypes = {
    type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
};
var $09e9ae62fda31228$export$2e2bcd8739ae039 = $09e9ae62fda31228$var$FormFileField;


var $069cc8c79970f9b0$export$2e2bcd8739ae039 = (0, $09e9ae62fda31228$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");
var $70bae84a94585e38$exports = {};
"use strict";
Object.defineProperty($70bae84a94585e38$exports, "__esModule", {
    value: true
});
Object.defineProperty($70bae84a94585e38$exports, "Chart", {
    enumerable: true,
    get: function get() {
        return $70bae84a94585e38$var$_chart["default"];
    }
});
$70bae84a94585e38$exports.defaults = $70bae84a94585e38$exports.Scatter = $70bae84a94585e38$exports.Bubble = $70bae84a94585e38$exports.Polar = $70bae84a94585e38$exports.Radar = $70bae84a94585e38$exports.HorizontalBar = $70bae84a94585e38$exports.Bar = $70bae84a94585e38$exports.Line = $70bae84a94585e38$exports.Pie = $70bae84a94585e38$exports.Doughnut = $70bae84a94585e38$exports["default"] = void 0;

var $70bae84a94585e38$var$_react = $70bae84a94585e38$var$_interopRequireDefault((parcelRequire("tZqWC")));

var $70bae84a94585e38$var$_propTypes = $70bae84a94585e38$var$_interopRequireDefault((parcelRequire("4L3zM")));

var $70bae84a94585e38$var$_chart = $70bae84a94585e38$var$_interopRequireDefault((parcelRequire("lb2du")));

var $70bae84a94585e38$var$_isEqual = $70bae84a94585e38$var$_interopRequireDefault((parcelRequire("a39iZ")));

var $70bae84a94585e38$var$_keyBy = $70bae84a94585e38$var$_interopRequireDefault((parcelRequire("eKkfN")));
function $70bae84a94585e38$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $70bae84a94585e38$var$_extends() {
    $70bae84a94585e38$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $70bae84a94585e38$var$_extends.apply(this, arguments);
}
function $70bae84a94585e38$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $70bae84a94585e38$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $70bae84a94585e38$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $70bae84a94585e38$var$_typeof(obj);
}
function $70bae84a94585e38$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $70bae84a94585e38$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $70bae84a94585e38$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $70bae84a94585e38$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $70bae84a94585e38$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $70bae84a94585e38$var$ownKeys(Object(source), true).forEach(function(key) {
            $70bae84a94585e38$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $70bae84a94585e38$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $70bae84a94585e38$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $70bae84a94585e38$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $70bae84a94585e38$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $70bae84a94585e38$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $70bae84a94585e38$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $70bae84a94585e38$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $70bae84a94585e38$var$_setPrototypeOf(subClass, superClass);
}
function $70bae84a94585e38$var$_setPrototypeOf(o, p) {
    $70bae84a94585e38$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $70bae84a94585e38$var$_setPrototypeOf(o, p);
}
function $70bae84a94585e38$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $70bae84a94585e38$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $70bae84a94585e38$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $70bae84a94585e38$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $70bae84a94585e38$var$_possibleConstructorReturn(this, result);
    };
}
function $70bae84a94585e38$var$_possibleConstructorReturn(self, call) {
    if (call && ($70bae84a94585e38$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $70bae84a94585e38$var$_assertThisInitialized(self);
}
function $70bae84a94585e38$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $70bae84a94585e38$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $70bae84a94585e38$var$_getPrototypeOf(o) {
    $70bae84a94585e38$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $70bae84a94585e38$var$_getPrototypeOf(o);
}
function $70bae84a94585e38$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $70bae84a94585e38$var$NODE_ENV = false;
var $70bae84a94585e38$var$ChartComponent = /*#__PURE__*/ function(_React$Component) {
    $70bae84a94585e38$var$_inherits(ChartComponent, _React$Component);
    var _super = $70bae84a94585e38$var$_createSuper(ChartComponent);
    function ChartComponent() {
        var _this;
        $70bae84a94585e38$var$_classCallCheck(this, ChartComponent);
        _this = _super.call(this);
        $70bae84a94585e38$var$_defineProperty($70bae84a94585e38$var$_assertThisInitialized(_this), "handleOnClick", function(event) {
            var instance = _this.chartInstance;
            var _this$props = _this.props, getDatasetAtEvent = _this$props.getDatasetAtEvent, getElementAtEvent = _this$props.getElementAtEvent, getElementsAtEvent = _this$props.getElementsAtEvent, onElementsClick = _this$props.onElementsClick;
            getDatasetAtEvent && getDatasetAtEvent(instance.getDatasetAtEvent(event), event);
            getElementAtEvent && getElementAtEvent(instance.getElementAtEvent(event), event);
            getElementsAtEvent && getElementsAtEvent(instance.getElementsAtEvent(event), event);
            onElementsClick && onElementsClick(instance.getElementsAtEvent(event), event); // Backward compatibility
        });
        $70bae84a94585e38$var$_defineProperty($70bae84a94585e38$var$_assertThisInitialized(_this), "ref", function(element) {
            _this.element = element;
        });
        _this.chartInstance = undefined;
        return _this;
    }
    $70bae84a94585e38$var$_createClass(ChartComponent, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.renderChart();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                if (this.props.redraw) {
                    this.destroyChart();
                    this.renderChart();
                    return;
                }
                this.updateChart();
            }
        },
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                var _this$props2 = this.props, redraw = _this$props2.redraw, type = _this$props2.type, options = _this$props2.options, plugins = _this$props2.plugins, legend = _this$props2.legend, height = _this$props2.height, width = _this$props2.width;
                if (nextProps.redraw === true) return true;
                if (height !== nextProps.height || width !== nextProps.width) return true;
                if (type !== nextProps.type) return true;
                if (!(0, $70bae84a94585e38$var$_isEqual["default"])(legend, nextProps.legend)) return true;
                if (!(0, $70bae84a94585e38$var$_isEqual["default"])(options, nextProps.options)) return true;
                var nextData = this.transformDataProp(nextProps);
                if (!(0, $70bae84a94585e38$var$_isEqual["default"])(this.shadowDataProp, nextData)) return true;
                return !(0, $70bae84a94585e38$var$_isEqual["default"])(plugins, nextProps.plugins);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.destroyChart();
            }
        },
        {
            key: "transformDataProp",
            value: function transformDataProp(props) {
                var data = props.data;
                if (typeof data == 'function') {
                    var node = this.element;
                    return data(node);
                } else return data;
            } // Chart.js directly mutates the data.dataset objects by adding _meta proprerty
        },
        {
            key: "memoizeDataProps",
            value: function memoizeDataProps() {
                if (!this.props.data) return;
                var data = this.transformDataProp(this.props);
                this.shadowDataProp = $70bae84a94585e38$var$_objectSpread($70bae84a94585e38$var$_objectSpread({}, data), {}, {
                    datasets: data.datasets && data.datasets.map(function(set) {
                        return $70bae84a94585e38$var$_objectSpread({}, set);
                    })
                });
                this.saveCurrentDatasets(); // to remove the dataset metadata from this chart when the chart is destroyed
                return data;
            }
        },
        {
            key: "checkDatasets",
            value: function checkDatasets(datasets) {
                var isDev = $70bae84a94585e38$var$NODE_ENV !== 'production' && $70bae84a94585e38$var$NODE_ENV !== 'prod';
                var usingCustomKeyProvider = this.props.datasetKeyProvider !== ChartComponent.getLabelAsKey;
                var multipleDatasets = datasets.length > 1;
                if (isDev && multipleDatasets && !usingCustomKeyProvider) {
                    var shouldWarn = false;
                    datasets.forEach(function(dataset) {
                        if (!dataset.label) shouldWarn = true;
                    });
                    if (shouldWarn) console.error('[react-chartjs-2] Warning: Each dataset needs a unique key. By default, the "label" property on each dataset is used. Alternatively, you may provide a "datasetKeyProvider" as a prop that returns a unique key.');
                }
            }
        },
        {
            key: "getCurrentDatasets",
            value: function getCurrentDatasets() {
                return this.chartInstance && this.chartInstance.config.data && this.chartInstance.config.data.datasets || [];
            }
        },
        {
            key: "saveCurrentDatasets",
            value: function saveCurrentDatasets() {
                var _this2 = this;
                this.datasets = this.datasets || {};
                var currentDatasets = this.getCurrentDatasets();
                currentDatasets.forEach(function(d) {
                    _this2.datasets[_this2.props.datasetKeyProvider(d)] = d;
                });
            }
        },
        {
            key: "updateChart",
            value: function updateChart() {
                var _this3 = this;
                var options = this.props.options;
                var data = this.memoizeDataProps(this.props);
                if (!this.chartInstance) return;
                if (options) this.chartInstance.options = $70bae84a94585e38$var$_chart["default"].helpers.configMerge(this.chartInstance.options, options);
                 // Pipe datasets to chart instance datasets enabling
                // seamless transitions
                var currentDatasets = this.getCurrentDatasets();
                var nextDatasets = data.datasets || [];
                this.checkDatasets(currentDatasets);
                var currentDatasetsIndexed = (0, $70bae84a94585e38$var$_keyBy["default"])(currentDatasets, this.props.datasetKeyProvider); // We can safely replace the dataset array, as long as we retain the _meta property
                // on each dataset.
                this.chartInstance.config.data.datasets = nextDatasets.map(function(next) {
                    var current = currentDatasetsIndexed[_this3.props.datasetKeyProvider(next)];
                    if (current && current.type === next.type && next.data) {
                        // Be robust to no data. Relevant for other update mechanisms as in chartjs-plugin-streaming.
                        // The data array must be edited in place. As chart.js adds listeners to it.
                        current.data.splice(next.data.length);
                        next.data.forEach(function(point, pid) {
                            current.data[pid] = next.data[pid];
                        });
                        var _data = next.data, otherProps = $70bae84a94585e38$var$_objectWithoutProperties(next, [
                            "data"
                        ]); // Merge properties. Notice a weakness here. If a property is removed
                        // from next, it will be retained by current and never disappears.
                        // Workaround is to set value to null or undefined in next.
                        return $70bae84a94585e38$var$_objectSpread($70bae84a94585e38$var$_objectSpread({}, current), otherProps);
                    } else return next;
                });
                var datasets = data.datasets, rest = $70bae84a94585e38$var$_objectWithoutProperties(data, [
                    "datasets"
                ]);
                this.chartInstance.config.data = $70bae84a94585e38$var$_objectSpread($70bae84a94585e38$var$_objectSpread({}, this.chartInstance.config.data), rest);
                this.chartInstance.update();
            }
        },
        {
            key: "renderChart",
            value: function renderChart() {
                var _this$props3 = this.props, options = _this$props3.options, legend = _this$props3.legend, type = _this$props3.type, plugins = _this$props3.plugins;
                var node = this.element;
                var data = this.memoizeDataProps();
                if (typeof legend !== 'undefined' && !(0, $70bae84a94585e38$var$_isEqual["default"])(ChartComponent.defaultProps.legend, legend)) options.legend = legend;
                this.chartInstance = new $70bae84a94585e38$var$_chart["default"](node, {
                    type: type,
                    data: data,
                    options: options,
                    plugins: plugins
                });
            }
        },
        {
            key: "destroyChart",
            value: function destroyChart() {
                if (!this.chartInstance) return;
                 // Put all of the datasets that have existed in the chart back on the chart
                // so that the metadata associated with this chart get destroyed.
                // This allows the datasets to be used in another chart. This can happen,
                // for example, in a tabbed UI where the chart gets created each time the
                // tab gets switched to the chart and uses the same data).
                this.saveCurrentDatasets();
                var datasets = Object.values(this.datasets);
                this.chartInstance.config.data.datasets = datasets;
                this.chartInstance.destroy();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, height = _this$props4.height, width = _this$props4.width, id = _this$props4.id;
                return /*#__PURE__*/ $70bae84a94585e38$var$_react["default"].createElement("canvas", {
                    ref: this.ref,
                    height: height,
                    width: width,
                    id: id,
                    onClick: this.handleOnClick
                });
            }
        }
    ]);
    return ChartComponent;
}($70bae84a94585e38$var$_react["default"].Component);
$70bae84a94585e38$var$_defineProperty($70bae84a94585e38$var$ChartComponent, "getLabelAsKey", function(d) {
    return d.label;
});
$70bae84a94585e38$var$_defineProperty($70bae84a94585e38$var$ChartComponent, "propTypes", {
    data: $70bae84a94585e38$var$_propTypes["default"].oneOfType([
        $70bae84a94585e38$var$_propTypes["default"].object,
        $70bae84a94585e38$var$_propTypes["default"].func
    ]).isRequired,
    getDatasetAtEvent: $70bae84a94585e38$var$_propTypes["default"].func,
    getElementAtEvent: $70bae84a94585e38$var$_propTypes["default"].func,
    getElementsAtEvent: $70bae84a94585e38$var$_propTypes["default"].func,
    height: $70bae84a94585e38$var$_propTypes["default"].number,
    legend: $70bae84a94585e38$var$_propTypes["default"].object,
    onElementsClick: $70bae84a94585e38$var$_propTypes["default"].func,
    options: $70bae84a94585e38$var$_propTypes["default"].object,
    plugins: $70bae84a94585e38$var$_propTypes["default"].arrayOf($70bae84a94585e38$var$_propTypes["default"].object),
    redraw: $70bae84a94585e38$var$_propTypes["default"].bool,
    type: function type(props, propName, componentName) {
        if (!$70bae84a94585e38$var$_chart["default"].controllers[props[propName]]) return new Error('Invalid chart type `' + props[propName] + '` supplied to' + ' `' + componentName + '`.');
    },
    width: $70bae84a94585e38$var$_propTypes["default"].number,
    datasetKeyProvider: $70bae84a94585e38$var$_propTypes["default"].func
});
$70bae84a94585e38$var$_defineProperty($70bae84a94585e38$var$ChartComponent, "defaultProps", {
    legend: {
        display: true,
        position: 'bottom'
    },
    type: 'doughnut',
    height: 150,
    width: 300,
    redraw: false,
    options: {},
    datasetKeyProvider: $70bae84a94585e38$var$ChartComponent.getLabelAsKey
});
var $70bae84a94585e38$var$_default = $70bae84a94585e38$var$ChartComponent;
$70bae84a94585e38$exports["default"] = $70bae84a94585e38$var$_default;
var $70bae84a94585e38$var$Doughnut = /*#__PURE__*/ function(_React$Component2) {
    $70bae84a94585e38$var$_inherits(Doughnut, _React$Component2);
    var _super2 = $70bae84a94585e38$var$_createSuper(Doughnut);
    function Doughnut() {
        $70bae84a94585e38$var$_classCallCheck(this, Doughnut);
        return _super2.apply(this, arguments);
    }
    $70bae84a94585e38$var$_createClass(Doughnut, [
        {
            key: "render",
            value: function render() {
                var _this4 = this;
                return /*#__PURE__*/ $70bae84a94585e38$var$_react["default"].createElement($70bae84a94585e38$var$ChartComponent, $70bae84a94585e38$var$_extends({}, this.props, {
                    ref: function ref(_ref) {
                        return _this4.chartInstance = _ref && _ref.chartInstance;
                    },
                    type: "doughnut"
                }));
            }
        }
    ]);
    return Doughnut;
}($70bae84a94585e38$var$_react["default"].Component);
$70bae84a94585e38$exports.Doughnut = $70bae84a94585e38$var$Doughnut;
var $70bae84a94585e38$var$Pie = /*#__PURE__*/ function(_React$Component3) {
    $70bae84a94585e38$var$_inherits(Pie, _React$Component3);
    var _super3 = $70bae84a94585e38$var$_createSuper(Pie);
    function Pie() {
        $70bae84a94585e38$var$_classCallCheck(this, Pie);
        return _super3.apply(this, arguments);
    }
    $70bae84a94585e38$var$_createClass(Pie, [
        {
            key: "render",
            value: function render() {
                var _this5 = this;
                return /*#__PURE__*/ $70bae84a94585e38$var$_react["default"].createElement($70bae84a94585e38$var$ChartComponent, $70bae84a94585e38$var$_extends({}, this.props, {
                    ref: function ref(_ref2) {
                        return _this5.chartInstance = _ref2 && _ref2.chartInstance;
                    },
                    type: "pie"
                }));
            }
        }
    ]);
    return Pie;
}($70bae84a94585e38$var$_react["default"].Component);
$70bae84a94585e38$exports.Pie = $70bae84a94585e38$var$Pie;
var $70bae84a94585e38$var$Line = /*#__PURE__*/ function(_React$Component4) {
    $70bae84a94585e38$var$_inherits(Line, _React$Component4);
    var _super4 = $70bae84a94585e38$var$_createSuper(Line);
    function Line() {
        $70bae84a94585e38$var$_classCallCheck(this, Line);
        return _super4.apply(this, arguments);
    }
    $70bae84a94585e38$var$_createClass(Line, [
        {
            key: "render",
            value: function render() {
                var _this6 = this;
                return /*#__PURE__*/ $70bae84a94585e38$var$_react["default"].createElement($70bae84a94585e38$var$ChartComponent, $70bae84a94585e38$var$_extends({}, this.props, {
                    ref: function ref(_ref3) {
                        return _this6.chartInstance = _ref3 && _ref3.chartInstance;
                    },
                    type: "line"
                }));
            }
        }
    ]);
    return Line;
}($70bae84a94585e38$var$_react["default"].Component);
$70bae84a94585e38$exports.Line = $70bae84a94585e38$var$Line;
var $70bae84a94585e38$var$Bar = /*#__PURE__*/ function(_React$Component5) {
    $70bae84a94585e38$var$_inherits(Bar, _React$Component5);
    var _super5 = $70bae84a94585e38$var$_createSuper(Bar);
    function Bar() {
        $70bae84a94585e38$var$_classCallCheck(this, Bar);
        return _super5.apply(this, arguments);
    }
    $70bae84a94585e38$var$_createClass(Bar, [
        {
            key: "render",
            value: function render() {
                var _this7 = this;
                return /*#__PURE__*/ $70bae84a94585e38$var$_react["default"].createElement($70bae84a94585e38$var$ChartComponent, $70bae84a94585e38$var$_extends({}, this.props, {
                    ref: function ref(_ref4) {
                        return _this7.chartInstance = _ref4 && _ref4.chartInstance;
                    },
                    type: "bar"
                }));
            }
        }
    ]);
    return Bar;
}($70bae84a94585e38$var$_react["default"].Component);
$70bae84a94585e38$exports.Bar = $70bae84a94585e38$var$Bar;
var $70bae84a94585e38$var$HorizontalBar = /*#__PURE__*/ function(_React$Component6) {
    $70bae84a94585e38$var$_inherits(HorizontalBar, _React$Component6);
    var _super6 = $70bae84a94585e38$var$_createSuper(HorizontalBar);
    function HorizontalBar() {
        $70bae84a94585e38$var$_classCallCheck(this, HorizontalBar);
        return _super6.apply(this, arguments);
    }
    $70bae84a94585e38$var$_createClass(HorizontalBar, [
        {
            key: "render",
            value: function render() {
                var _this8 = this;
                return /*#__PURE__*/ $70bae84a94585e38$var$_react["default"].createElement($70bae84a94585e38$var$ChartComponent, $70bae84a94585e38$var$_extends({}, this.props, {
                    ref: function ref(_ref5) {
                        return _this8.chartInstance = _ref5 && _ref5.chartInstance;
                    },
                    type: "horizontalBar"
                }));
            }
        }
    ]);
    return HorizontalBar;
}($70bae84a94585e38$var$_react["default"].Component);
$70bae84a94585e38$exports.HorizontalBar = $70bae84a94585e38$var$HorizontalBar;
var $70bae84a94585e38$var$Radar = /*#__PURE__*/ function(_React$Component7) {
    $70bae84a94585e38$var$_inherits(Radar, _React$Component7);
    var _super7 = $70bae84a94585e38$var$_createSuper(Radar);
    function Radar() {
        $70bae84a94585e38$var$_classCallCheck(this, Radar);
        return _super7.apply(this, arguments);
    }
    $70bae84a94585e38$var$_createClass(Radar, [
        {
            key: "render",
            value: function render() {
                var _this9 = this;
                return /*#__PURE__*/ $70bae84a94585e38$var$_react["default"].createElement($70bae84a94585e38$var$ChartComponent, $70bae84a94585e38$var$_extends({}, this.props, {
                    ref: function ref(_ref6) {
                        return _this9.chartInstance = _ref6 && _ref6.chartInstance;
                    },
                    type: "radar"
                }));
            }
        }
    ]);
    return Radar;
}($70bae84a94585e38$var$_react["default"].Component);
$70bae84a94585e38$exports.Radar = $70bae84a94585e38$var$Radar;
var $70bae84a94585e38$var$Polar = /*#__PURE__*/ function(_React$Component8) {
    $70bae84a94585e38$var$_inherits(Polar, _React$Component8);
    var _super8 = $70bae84a94585e38$var$_createSuper(Polar);
    function Polar() {
        $70bae84a94585e38$var$_classCallCheck(this, Polar);
        return _super8.apply(this, arguments);
    }
    $70bae84a94585e38$var$_createClass(Polar, [
        {
            key: "render",
            value: function render() {
                var _this10 = this;
                return /*#__PURE__*/ $70bae84a94585e38$var$_react["default"].createElement($70bae84a94585e38$var$ChartComponent, $70bae84a94585e38$var$_extends({}, this.props, {
                    ref: function ref(_ref7) {
                        return _this10.chartInstance = _ref7 && _ref7.chartInstance;
                    },
                    type: "polarArea"
                }));
            }
        }
    ]);
    return Polar;
}($70bae84a94585e38$var$_react["default"].Component);
$70bae84a94585e38$exports.Polar = $70bae84a94585e38$var$Polar;
var $70bae84a94585e38$var$Bubble = /*#__PURE__*/ function(_React$Component9) {
    $70bae84a94585e38$var$_inherits(Bubble, _React$Component9);
    var _super9 = $70bae84a94585e38$var$_createSuper(Bubble);
    function Bubble() {
        $70bae84a94585e38$var$_classCallCheck(this, Bubble);
        return _super9.apply(this, arguments);
    }
    $70bae84a94585e38$var$_createClass(Bubble, [
        {
            key: "render",
            value: function render() {
                var _this11 = this;
                return /*#__PURE__*/ $70bae84a94585e38$var$_react["default"].createElement($70bae84a94585e38$var$ChartComponent, $70bae84a94585e38$var$_extends({}, this.props, {
                    ref: function ref(_ref8) {
                        return _this11.chartInstance = _ref8 && _ref8.chartInstance;
                    },
                    type: "bubble"
                }));
            }
        }
    ]);
    return Bubble;
}($70bae84a94585e38$var$_react["default"].Component);
$70bae84a94585e38$exports.Bubble = $70bae84a94585e38$var$Bubble;
var $70bae84a94585e38$var$Scatter = /*#__PURE__*/ function(_React$Component10) {
    $70bae84a94585e38$var$_inherits(Scatter, _React$Component10);
    var _super10 = $70bae84a94585e38$var$_createSuper(Scatter);
    function Scatter() {
        $70bae84a94585e38$var$_classCallCheck(this, Scatter);
        return _super10.apply(this, arguments);
    }
    $70bae84a94585e38$var$_createClass(Scatter, [
        {
            key: "render",
            value: function render() {
                var _this12 = this;
                return /*#__PURE__*/ $70bae84a94585e38$var$_react["default"].createElement($70bae84a94585e38$var$ChartComponent, $70bae84a94585e38$var$_extends({}, this.props, {
                    ref: function ref(_ref9) {
                        return _this12.chartInstance = _ref9 && _ref9.chartInstance;
                    },
                    type: "scatter"
                }));
            }
        }
    ]);
    return Scatter;
}($70bae84a94585e38$var$_react["default"].Component);
$70bae84a94585e38$exports.Scatter = $70bae84a94585e38$var$Scatter;
var $70bae84a94585e38$var$defaults = $70bae84a94585e38$var$_chart["default"].defaults;
$70bae84a94585e38$exports.defaults = $70bae84a94585e38$var$defaults;



const $f9f6294eaa038b13$export$cd4324e55f792afb = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
	position: relative;
	height: 100%;
	width: 100%;
`;


function $5018f20743ac426f$var$DoughnutChart(props) {
    // Destructure
    const { data: data, width: width, height: height, options: options } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f9f6294eaa038b13$export$cd4324e55f792afb), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $70bae84a94585e38$exports.Doughnut), {
            data: data,
            width: width,
            height: height,
            options: options
        })
    });
}
// Default Props
$5018f20743ac426f$var$DoughnutChart.defaultProps = {
    data: {
        label: [],
        datasets: []
    },
    width: '',
    height: '',
    options: {}
};
// Proptypes Validation
$5018f20743ac426f$var$DoughnutChart.propTypes = {
    data: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        labels: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Array),
        datasets: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Array)
    }),
    width: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
    height: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
    options: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        root: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    })
};
var $5018f20743ac426f$export$2e2bcd8739ae039 = $5018f20743ac426f$var$DoughnutChart;


var $7b658d9b90651bd3$export$2e2bcd8739ae039 = (0, $5018f20743ac426f$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");


const $228500a065751d1b$export$898f5ec6036845f7 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
	min-height: 230px;
	position: relative;
	height: 100%;
	width: 100%;
`;


function $59172335196825eb$var$BarChart(props) {
    // Destructure
    const { data: data, width: width, height: height, options: options, ...rest } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $228500a065751d1b$export$898f5ec6036845f7), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $70bae84a94585e38$exports.Bar), {
            data: data,
            width: width,
            height: height,
            options: options,
            ...rest
        })
    });
}
// Default Props
$59172335196825eb$var$BarChart.defaultProps = {
    data: {},
    width: 200,
    height: 90,
    options: {}
};
// Proptypes Validation
$59172335196825eb$var$BarChart.propTypes = {
    data: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        root: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    }),
    width: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    ]),
    height: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    ]),
    options: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        root: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    })
};
var $59172335196825eb$export$2e2bcd8739ae039 = $59172335196825eb$var$BarChart;


var $bff95e0871fbe022$export$2e2bcd8739ae039 = (0, $59172335196825eb$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");


const $5ed367a705090257$export$ec7c7d6f0ed2fed1 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
	position: relative;
	height: 100%;
	width: 100%;
`;


function $b606c2edd7083662$var$LineChart(props) {
    // Destructure
    const { data: data, width: width, height: height, options: options } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5ed367a705090257$export$ec7c7d6f0ed2fed1), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $70bae84a94585e38$exports.Line), {
            data: data,
            width: width,
            height: height,
            options: options
        })
    });
}
// Default Props
$b606c2edd7083662$var$LineChart.defaultProps = {
    data: {},
    width: 200,
    height: 90,
    options: {}
};
// Proptypes Validation
$b606c2edd7083662$var$LineChart.propTypes = {
    data: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        root: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    }),
    width: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
    height: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
    options: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        root: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    })
};
var $b606c2edd7083662$export$2e2bcd8739ae039 = $b606c2edd7083662$var$LineChart;


var $1b9c00692a27807c$export$2e2bcd8739ae039 = (0, $b606c2edd7083662$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");


const $dccfc3fa5541d693$export$473cf89ff8915e5f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
	position: relative;
	height: 100%;
	width: 100%;
`;


function $f70b79b6de73f405$var$HorizontalBarChart(props) {
    const { data: data, options: options } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $dccfc3fa5541d693$export$473cf89ff8915e5f), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $70bae84a94585e38$exports.HorizontalBar), {
            options: options,
            data: data
        })
    });
}
// Default Props
$f70b79b6de73f405$var$HorizontalBarChart.defaultProps = {
    data: {},
    options: {}
};
// Proptypes Validation
$f70b79b6de73f405$var$HorizontalBarChart.propTypes = {
    data: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        root: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    }),
    options: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        root: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    })
};
var $f70b79b6de73f405$export$2e2bcd8739ae039 = $f70b79b6de73f405$var$HorizontalBarChart;


var $17a3afb6e0e3a44f$export$2e2bcd8739ae039 = (0, $f70b79b6de73f405$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $a37399d110c5e175$export$ac319665d120df29 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 5px;
`;
const $a37399d110c5e175$export$56d3f3c43edacc7b = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 28px;
  width: 28px;
  border: 1px solid ${({ theme: theme })=>theme.colors.primary};
  color: ${({ theme: theme })=>theme.colors.primary};
  border-radius: 5px;
  font-size: 15px;

  ${({ theme: theme, isActive: isActive })=>isActive && `color: ${theme.colors.yellowGreen};`}
  ${({ theme: theme, isActive: isActive })=>isActive && `border: 1px solid ${theme.colors.yellowGreen};`}
  ${({ isActive: isActive })=>isActive && 'font-weight: 700;'}
`;


function $7765cf63393968ba$var$NumberedChart(props) {
    // Destructure
    const { numOfBlocks: numOfBlocks, activeNumber: activeNumber } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $a37399d110c5e175$export$ac319665d120df29), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a37399d110c5e175$export$56d3f3c43edacc7b), {
                isActive: activeNumber === 0,
                children: "0"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a37399d110c5e175$export$56d3f3c43edacc7b), {
                isActive: activeNumber === 1,
                children: "1"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a37399d110c5e175$export$56d3f3c43edacc7b), {
                isActive: activeNumber === 2,
                children: "2"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a37399d110c5e175$export$56d3f3c43edacc7b), {
                isActive: activeNumber === 3,
                children: "3"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a37399d110c5e175$export$56d3f3c43edacc7b), {
                isActive: activeNumber === 4,
                children: "4"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a37399d110c5e175$export$56d3f3c43edacc7b), {
                isActive: activeNumber > 4,
                children: "+"
            })
        ]
    });
}
// Default Props
$7765cf63393968ba$var$NumberedChart.defaultProps = {
    activeNumber: 0,
    numOfBlocks: 3
};
// Proptypes Validation
$7765cf63393968ba$var$NumberedChart.propTypes = {
    activeNumber: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
    numOfBlocks: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number
};
var $7765cf63393968ba$export$2e2bcd8739ae039 = $7765cf63393968ba$var$NumberedChart;


var $7a1b412fc5fb14d1$export$2e2bcd8739ae039 = (0, $7765cf63393968ba$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");


/* eslint-disable no-confusing-arrow */ 
const $ad7b6c38afb49dfc$export$3dc3a9199b4bd348 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  background-color: ${({ theme: theme })=>theme.colors.black}70;

  display: flex;
  justify-content: center;
  align-items: center;

  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 10;

  transition: opacity 0.3s ease, visibility 0.3s ease;
  opacity: ${({ isOpen: isOpen })=>isOpen ? 1 : 0};
  visibility: ${({ isOpen: isOpen })=>isOpen ? 'visible' : 'hidden'};
  pointer-events: ${({ isOpen: isOpen })=>isOpen ? 'all' : 'none'};
`;
const $ad7b6c38afb49dfc$export$858bfd02c3f2fba5 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 0;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $ad7b6c38afb49dfc$export$c9554889b3e706cd = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 0;
  background-color: ${({ theme: theme })=>theme.colors.background};
  border: 1px solid ${({ theme: theme })=>`${theme.colors.secondary}80`};
  border-radius: 15px;

  transition: opacity 0.3s ease, transform 0.3s ease;
  opacity: ${({ isOpen: isOpen })=>isOpen ? 1 : 0};
  transform: ${({ isOpen: isOpen })=>isOpen ? 'translateY(0) scale(1)' : 'translateY(20px) scale(0.95)'};
`;


function $77d58b2f532fb38c$var$Modal(props) {
    // Destructure
    const { children: children, isOpen: isOpen, toggle: toggle, ...rest } = props;
    // Refs
    const wrapperRef = (0, $tZqWC.useRef)();
    // Hooks
    (0, $54f47a39f461db48$export$50ec7b7ff742aae5)(wrapperRef, ()=>{
        if (isOpen === true) toggle();
    });
    const { shouldRender: shouldRender, animateIn: animateIn } = (0, $f42ea022c558e18e$export$c080a84d0ed0727d)(isOpen, 300);
    return shouldRender ? /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ad7b6c38afb49dfc$export$3dc3a9199b4bd348), {
        isOpen: animateIn,
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ad7b6c38afb49dfc$export$858bfd02c3f2fba5), {
            ...rest,
            isOpen: animateIn,
            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ad7b6c38afb49dfc$export$c9554889b3e706cd), {
                ref: wrapperRef,
                isOpen: animateIn,
                children: children
            })
        })
    }) : null;
}
// Default Props
$77d58b2f532fb38c$var$Modal.defaultProps = {
    children: '',
    isOpen: false,
    toggle: ()=>{}
};
// Proptypes Validation
$77d58b2f532fb38c$var$Modal.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ]),
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    toggle: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
};
var $77d58b2f532fb38c$export$2e2bcd8739ae039 = $77d58b2f532fb38c$var$Modal;


var $0cb604e8ac00d438$export$2e2bcd8739ae039 = (0, $77d58b2f532fb38c$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $605c81e7e5c62281$export$e833dfe35f2086ee = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 20px 10px;
  max-height: 60vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 450px;
`;


function $1e2098883e348366$var$ModalBody(props) {
    // Destructure
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $605c81e7e5c62281$export$e833dfe35f2086ee), {
        ...rest,
        children: children
    });
}
// Default Props
$1e2098883e348366$var$ModalBody.defaultProps = {
    children: ''
};
// Proptypes Validation
$1e2098883e348366$var$ModalBody.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ])
};
var $1e2098883e348366$export$2e2bcd8739ae039 = $1e2098883e348366$var$ModalBody;


var $5a83d1c72fcd9217$export$2e2bcd8739ae039 = (0, $1e2098883e348366$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $e4c5b774e0c4b7b6$export$47042699470e17dd = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 10px;
  border-top: 1px solid ${({ theme: theme })=>theme.colors.backgroundLite};

  display: flex;
  align-items: center;
  gap: 10px;

  width: 100%;

  & * {
    text-align: center;
  }
`;


function $79f0f322df77dafe$var$ModalFooter(props) {
    // Destructure
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e4c5b774e0c4b7b6$export$47042699470e17dd), {
        ...rest,
        children: children
    });
}
// Default Props
$79f0f322df77dafe$var$ModalFooter.defaultProps = {
    children: ''
};
// Proptypes Validation
$79f0f322df77dafe$var$ModalFooter.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ])
};
var $79f0f322df77dafe$export$2e2bcd8739ae039 = $79f0f322df77dafe$var$ModalFooter;


var $b07759276f5d7f2d$export$2e2bcd8739ae039 = (0, $79f0f322df77dafe$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $8d60fac67d76c212$export$6033693e6adc1906 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  border: none;
  padding: 20px;
  border-bottom: 1px solid ${({ theme: theme })=>theme.colors.backgroundLite};
`;
const $8d60fac67d76c212$export$6bbe9e2fb05afc62 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 18px;
  font-weight: 700;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  & * {
    text-align: center;
  }
`;
const $8d60fac67d76c212$export$799d5582e2c9544c = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  transition: 0.4s;
  cursor: pointer;
  position: absolute;
  right: 20px;
  top: 20px;

  & svg {
    fill: ${({ theme: theme })=>theme.colors.secondary};
  }
  & svg * path {
    fill: ${({ theme: theme })=>theme.colors.secondary};
  }
  &:hover {
    transform: scale(1.2);
  }
`;



function $a3e720aafa7043e8$var$ModalHeader(props) {
    // Destructure
    const { children: children, close: close, toggle: toggle, ...rest } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8d60fac67d76c212$export$6033693e6adc1906), {
        ...rest,
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $8d60fac67d76c212$export$6bbe9e2fb05afc62), {
                children: children
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $8d60fac67d76c212$export$799d5582e2c9544c), {
                onClick: toggle,
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b77b5de3fb591045$export$2e2bcd8739ae039), {
                    size: 18
                })
            })
        ]
    });
}
// Default Props
$a3e720aafa7043e8$var$ModalHeader.defaultProps = {
    children: '',
    close: '',
    toggle: ()=>{}
};
// Proptypes Validation
$a3e720aafa7043e8$var$ModalHeader.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ]),
    close: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ]),
    toggle: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
};
var $a3e720aafa7043e8$export$2e2bcd8739ae039 = $a3e720aafa7043e8$var$ModalHeader;


var $6e660ada3ebfb268$export$2e2bcd8739ae039 = (0, $a3e720aafa7043e8$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $7eb18ad25584009a$export$abd0141a73cbad48 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  transition: all 0.5s ease-in-out;
`;
const $7eb18ad25584009a$export$3b0d6d7590275603 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 6px;
  background: ${({ theme: theme })=>theme.colors.primary};
  overflow: hidden;

  &:before {
    content: '';
    position: absolute;
    top: 0px;
    left: 0px;
    bottom: 0px;
    background: ${({ theme: theme })=>theme.colors.brand};
    animation: box-1 1500ms cubic-bezier(0.65, 0.81, 0.73, 0.4) infinite;
  }

  &:after {
    content: '';
    position: absolute;
    top: 0px;
    left: 0px;
    bottom: 0px;
    background: ${({ theme: theme })=>theme.colors.brand};
    animation: box-2 1500ms cubic-bezier(0.16, 0.84, 0.44, 1) infinite;
    animation-delay: 9000ms;
  }

  @keyframes box-1 {
    0% {
      left: -35%;
      right: 100%;
    }
    60%,
    100% {
      left: 100%;
      right: -90%;
    }
  }
  @keyframes box-2 {
    0% {
      left: -200%;
      right: 100%;
    }
    60%,
    100% {
      left: 107%;
      right: -8%;
    }
  }
`;


function $5b2507d91b5598e9$var$LoaderLine(props) {
    // Destructure
    const { show: show } = props;
    return show && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7eb18ad25584009a$export$abd0141a73cbad48), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7eb18ad25584009a$export$3b0d6d7590275603), {})
    });
}
// Default Props
$5b2507d91b5598e9$var$LoaderLine.defaultProps = {
    show: false
};
// Proptypes Validation
$5b2507d91b5598e9$var$LoaderLine.propTypes = {
    show: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
};
var $5b2507d91b5598e9$export$2e2bcd8739ae039 = $5b2507d91b5598e9$var$LoaderLine;


var $715f0d2ea48e4c84$export$2e2bcd8739ae039 = (0, $5b2507d91b5598e9$export$2e2bcd8739ae039);




parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $a6e603242055fdb5$export$e6dfd72ab29f8598 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;


function $ac7f5e87e63c8d1f$var$LoaderWrapper(props) {
    const { children: children } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $a6e603242055fdb5$export$e6dfd72ab29f8598), {
        children: [
            " ",
            children
        ]
    });
}
// Default Props
$ac7f5e87e63c8d1f$var$LoaderWrapper.defaultProps = {
    children: ''
};
// Proptypes Validation
$ac7f5e87e63c8d1f$var$LoaderWrapper.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ])
};
var $ac7f5e87e63c8d1f$export$2e2bcd8739ae039 = $ac7f5e87e63c8d1f$var$LoaderWrapper;


var $0167b1f2e06350fb$export$2e2bcd8739ae039 = (0, $ac7f5e87e63c8d1f$export$2e2bcd8739ae039);





// Map Redux Props
const $680905ea04c94aac$var$mapStateToProps = (state)=>state;
const $680905ea04c94aac$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $680905ea04c94aac$var$Header(props) {
    // Destructure
    const { ui: ui, actions: actions, subHeader: subHeader, pageTitle: pageTitle, link: link } = props;
    // Store States
    const { showHeaderLoader: showHeaderLoader, isProfileUpdated: isProfileUpdated } = ui;
    // Store Actions
    const { setIsProfileUpdated: setIsProfileUpdated } = actions;
    // Hooks
    const history = (0, $a0d5c3f2fe524011$export$3420e1dc2c4a518c)();
    const [userCredentials, setUserCredentials] = (0, $a9c50ebe96619b20$export$2e2bcd8739ae039)('userCredentials', false);
    // Functions
    (0, $tZqWC.useEffect)(()=>{
        if (isProfileUpdated) {
            // Updating profile header
            setUserCredentials(JSON.parse(localStorage.getItem('userCredentials')));
            setIsProfileUpdated(false);
        }
    }, [
        isProfileUpdated
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $72532679acd937a3$export$960a49cc3d27a090), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $715f0d2ea48e4c84$export$2e2bcd8739ae039), {
                show: showHeaderLoader
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $72532679acd937a3$export$daae9aa8d814389a), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $72532679acd937a3$export$edb76fdb8665f52), {
                    children: link ? /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                        onClick: ()=>history.push(link),
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9cadc73f9b5b2fc9$export$2e2bcd8739ae039), {
                                size: 30
                            }),
                            pageTitle || ''
                        ]
                    }) : pageTitle || ''
                })
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $72532679acd937a3$export$6eaa4d78e3725d73), {
                children: subHeader && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $72532679acd937a3$export$93cda7378d158ea0), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $233d6aa1443d2fba$export$2e2bcd8739ae039), {
                                size: 16
                            })
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $72532679acd937a3$export$8589018110795d47), {
                            children: subHeader
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $72532679acd937a3$export$daae9aa8d814389a), {})
        ]
    });
}
// Default Props
$680905ea04c94aac$var$Header.defaultProps = {
    subHeader: '',
    ui: {},
    actions: {},
    pageTitle: ''
};
// Proptypes Validation
$680905ea04c94aac$var$Header.propTypes = {
    subHeader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ]),
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        showHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
        isProfileUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
        isNotifUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        openAppSidebarDrawer: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsProfileUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsNotifUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    pageTitle: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    link: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
};
var $680905ea04c94aac$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($680905ea04c94aac$var$mapStateToProps, $680905ea04c94aac$var$mapDispatchToProps)($680905ea04c94aac$var$Header);


var $5387bf8dccf722e4$export$2e2bcd8739ae039 = (0, $680905ea04c94aac$export$2e2bcd8739ae039);


/* eslint-disable max-len */ /* eslint-disable react/prop-types */ 

var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");





/* eslint-disable no-confusing-arrow */ 

const $561ec2a14046c706$export$d9b764b921677bb1 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 5;

  width: 100%;

  transition: .1s;
  max-width:  ${({ display: display, hovered: hovered })=>hovered && display ? '270px' : '80px'};
  height: 100vh;
  background-color: ${({ theme: theme })=>theme.colors.background};
  border-right: ${({ display: display, hovered: hovered, theme: theme })=>hovered && display ? `1px ${theme.colors.borderColor}` : '1px #00000000'} solid; 
  display: flex;
`;
const $561ec2a14046c706$export$1c4ef261db9bc206 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;

  height: 100%;
  width: 80px; 
`;
const $561ec2a14046c706$export$5a0be810dad713a0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;

  height: 100%;
  width: 100%;
  &:first-child {
    justify-content: flex-start;
  }
  &:last-child {
    padding: 0 0 20px 0;
  }
`;
const $561ec2a14046c706$export$fb912d881d4e6ab8 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: 100%;
  display: flex;
  justify-content: center;

  padding: 15px 0 20px 0;
  text-align: left;
`;
const $561ec2a14046c706$export$2716aa0b0403677e = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 6px 0 0 0; 
  & svg  {
    width: 60px;
  }
  & svg > path {
    fill: ${({ theme: theme })=>theme.colors.primary};
  }
`;
const $561ec2a14046c706$export$970362a869c2626d = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 0px;
  align-items: center;
  width: 100%;
  transition: 0.1s; 
`;
const $561ec2a14046c706$export$6bb03ae86fd00b78 = (0, $a778141486c79bc3$export$2e2bcd8739ae039)((0, $12b33660068e86aa$export$b0d92dbee9b5b60d))`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 8px;

  text-align: center;
  line-height: 1.2;
  font-size: 10px;
  color: ${({ theme: theme })=>theme.colors.secondary};
  text-decoration: none;
  white-space: pre-wrap;
  padding: 8px 10px !important;

  transition: 0.3s;
  max-width: 80px;
  min-height: 80px;
  max-height: 80px;

  & > img {
    width: 25px;
    height: 25px;
  }
  & > svg {
    width: 20px;
    height: 20px;
    & path {
      stroke: ${({ theme: theme })=>theme.colors.secondary};
    }
    & g path{
      fill: ${({ theme: theme })=>theme.colors.secondary} !important;
    }
  } 

  &:hover {
    background-color: ${({ theme: theme })=>theme.colors.borderColor};
    color: ${({ theme: theme })=>theme.colors.primary};
    & div {
      font-weight: 600;
      color: ${({ theme: theme })=>theme.colors.primary};
    }
    & path {stroke: ${({ theme: theme })=>theme.colors.primary};}
    & g path{fill: ${({ theme: theme })=>theme.colors.primary} !important;}
    color: ${({ theme: theme })=>theme.colors.primary};
  }

  &.active, &.activeHover {
    & div {
      font-weight: 700;
      color: ${({ theme: theme })=>theme.colors.primary};
    }
    & path {stroke: ${({ theme: theme })=>theme.colors.primary};}
    & g path{fill: ${({ theme: theme })=>theme.colors.primary} !important;}
    color: ${({ theme: theme })=>theme.colors.primary};
    
    /* &.active {
      border-left: 6px solid ${({ theme: theme })=>`${theme.colors.brand}`}; 
    } */
    &.activeHover {
      background-color: ${({ theme: theme })=>theme.colors.borderColor};
    }
  }

  & > div { 
    line-height: 1.3 !important;
    color: ${({ theme: theme })=>theme.colors.secondary};
  }
`;
const $561ec2a14046c706$export$2d26e2ad7ef090e6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 5px;

  text-align: center;
  line-height: 1.2;
  font-size: 10px;
  color: ${({ theme: theme })=>theme.colors.primary};
  text-decoration: none;
  white-space: pre-wrap;

  padding: 10px 35px !important;
  transition: 0.3s;
  max-width: 80px;
  min-height: 80px;
  max-height: 80px;

  & > img {
    width: 25px;
    height: 25px;
  }
  & > svg {
    width: 20px;
    height: 20px;
    & path {
      stroke: ${({ theme: theme })=>theme.colors.primary};
    }
  }

  // Media Query Properties
  ${({ theme: theme })=>theme.functions.mediaQuery('padding', [
        '25px 125px',
        '25px 125px',
        '25px 125px',
        '25px 125px',
        '25px 125px',
        '25px 32px'
    ])}

  &:hover {
    background-color: ${({ theme: theme })=>theme.colors.borderColor};
    color: ${({ theme: theme })=>theme.colors.primary};
  }

  &.active {
    font-weight: 700;
    border-left: 6px solid ${({ theme: theme })=>`${theme.colors.brand}`};
    background-color: ${({ theme: theme })=>theme.colors.borderColor};
  }
`;
const $561ec2a14046c706$export$d03a642b4bc74017 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $561ec2a14046c706$export$c554d08d8051ae38 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  background-color: ${({ theme: theme })=>theme.colors.backgroundLite};

  height: 100%;
  transition: .1s;
  overflow: hidden;
  width:  ${({ hovered: hovered, display: display })=>hovered && display ? '190px' : '0px'};
`;


/* eslint-disable max-len */ /* eslint-disable react/prop-types */ 
parcelRequire("tZqWC");

// Auth

var $f3d855b3ff65dabd$exports = {};

$f3d855b3ff65dabd$exports = (parcelRequire("aBwLi"));


// export const BASE_URL = 'https://api.ospree.io'
// export const BASE_URL = 'https://sandbox.ospree.io'
// export const DEMO_URL = 'https://gdev-api.ospree.io'
// TODO Switch back to original url
const $78597906e6a0205e$export$ca6dda5263526f75 = "https://gdev-api.ospree.io";
const $78597906e6a0205e$export$6c927ce26c6dc103 = "wss://gdev-api.ospree.io";
const $78597906e6a0205e$export$7ee62d82c1b5ddae = "https://gdev-api.ospree.io";
const $78597906e6a0205e$export$6c611141e7030bb8 = "https://gdev-api.ospree.io";
const $78597906e6a0205e$export$a675fe6880411505 = "https://gdev-api.ospree.io";
const $78597906e6a0205e$export$e8ee8b3bd696a3a5 = "https://gdev-api.ospree.io";
const $78597906e6a0205e$export$1deab063ed687beb = "https://gdev-api.ospree.io";
const $78597906e6a0205e$export$91dfeeea81b01f2f = "https://gdev-api.ospree.io";
const $78597906e6a0205e$export$2a267d68982d9895 = "https://gdev-api.ospree.io";
const $78597906e6a0205e$export$1736ebf7cf11dd7a = "https://gdev-api.ospree.io";
const $78597906e6a0205e$export$831d83b74773cc50 = "https://gdev-api.ospree.io";
const $78597906e6a0205e$export$d7aecfa4e6635ed0 = {
    NOTIFY_VASP: '/api/ui/users/confirm_vasp',
    REJECT_VASP: '/api/ui/users/reject_vasp'
};
const $78597906e6a0205e$export$e9d870d86e0dc706 = {
    CREATE_DOCUMENT: '/api/ui/ai/document/upload',
    GET_DOCUMENTS: '/api/ui/ai/document',
    GET_DOCUMENT_CHUNKS: '/api/ui/ai/document',
    UPDATE_DOCUMENT: '/api/ui/ai/document',
    UPDATE_DOCUMENT_CHUNK: '/api/ui/ai/document',
    DANGEROUSLY_DELETE_DOCUMENT: '/api/ui/ai/document',
    // Websocket
    TR_CHAT: '/api/ui/ai/assistant/tr_chat',
    regulatory_chat: '/api/ui/ai/assistant/regulatory_chat',
    oapp_docs_chat: '/api/ui/ai/assistant/oapp_docs_chat'
};
const $78597906e6a0205e$export$eb187b828ac95891 = {
    LOGIN: '/api/ui/auth/user/login',
    LOGIN_TWOFA: '/api/ui/auth/user/login/',
    REFRESH: '/api/ui/auth/user/refresh_token',
    LOGOUT: '/api/ui/auth/user/logout',
    GENERATE_INTEGRATION_TOKEN: '/api/ui/auth/integration/token',
    LIST_INTEGRATION_TOKENS: '/api/ui/auth/integration/tokens',
    REVOKE_INTEGRATION_TOKEN: '/api/ui/auth/integration/token/revoke',
    ROTATE_INTEGRATION_TOKEN: '/api/ui/auth/integration/token/rotate'
};
const $78597906e6a0205e$export$b402d7362f47010f = {
    GET_USER: '/api/ui/users/',
    UPDATE_USER: '/api/ui/users/profile/',
    UPDATE_USER_PASSWORD: '/api/ui/users/password',
    RESET_PASSWORD: '/api/ui/users/password/reset',
    RESET_PASSWORD_CONFIRM: '/api/ui/users/password/reset/',
    REGISTER: '/api/ui/users/register',
    VASP_INFO: '/api/ui/directory/vasp_info',
    CONFIRM_VASP_EMAIL: '/api/ui/users/confirm_email',
    CONFIRM_VASP_USER_EMAIL: '/api/ui/users/confirm_vasp_user',
    GET_USER_AUTH: '/api/ui/users/user_auth/',
    SIGNUP_TRIAL: '/api/ui/users/signup/trial',
    CONFIRMATION_TRIAL: '/api/ui/users/signup/trial/verification'
};
const $78597906e6a0205e$export$3a1c062261e8cd49 = {
    REQUEST_VASP: '/api/ui/users/business/request',
    PUSH_REQUEST_VASP: '/api/ui/users/business/push_request',
    REGISTER_VASP: '/api/ui/users/business/register/',
    APPROVE_VASP: '/api/ui/users/business/approve/',
    REJECT_VASP: '/api/ui/users/business/reject/',
    GET_ALL_PROVIDERS: '/api/ui/users/business/providers',
    GET_VASP_PROVIDERS: '/api/ui/users/business/providers/',
    DELETE_VASP_PROVIDERS: '/api/ui/users/business/providers/',
    ADD_VASP_PROVIDERS: '/api/ui/users/business/providers/',
    GET_VASP_USERS: '/api/ui/users/business/users/',
    ADD_VASP_USER: '/api/ui/users/business/users/',
    UPDATE_VASP_USER: '/api/ui/users/business/users/',
    CREATE_VASP_USER_ACTIVATION: '/api/ui/users/business/users/activation/'
};
const $78597906e6a0205e$export$533507b0b47a2d2e = {
    GET_GLEIF: '/api/ui/gleif'
};
const $78597906e6a0205e$export$4d0e600765299d44 = {
    CREATE_NOTE: '/ui/notes',
    GET_NOTE: '/ui/notes'
};
const $78597906e6a0205e$export$36dac04bc644e0bf = {
    CREATE_OR_UPDATE_ADDRESS: '/api/ui/analytics/address',
    LINK_ADDRESS: '/api/ui/analytics/addresses',
    DELETE_ADDRESS: '/api/ui/analytics/addresses',
    UPDATE_ADDRESS_HOSTED: '/api/ui/analytics/addresses/self_hosted',
    GET_ADDRESSES: '/api/ui/analytics/addresses',
    GET_ADDRESS_DETAILS: '/api/ui/analytics/addresses',
    GET_ADDRESS_HISTORY: '/api/ui/analytics/addresses',
    POST_ADDRESS_REPORT: '/api/ui/analytics/addresses',
    GET_ADDRESS_VERIFICATION: '/api/ui/analytics/addresses',
    GET_ADDRESS_CHAIN_RECOMMENDATION: '/api/ui/analytics/addresses',
    GET_ADDRESS_ACCOUNT_SUMMARY: '/api/ui/analytics/addresses/account/summary',
    GET_ADDRESSES_LINKED: '/api/ui/analytics/addresses/account/linked',
    GET_ADDRESS_CHAINS: '/api/ui/analytics/addresses/chains'
};
const $78597906e6a0205e$export$c78ee076f149ce6c = {
    CREATE_OR_UPDATE_TRANSACTION: '/api/ui/analytics/transaction',
    LINK_TRANSACTION: '/api/ui/analytics/transactions',
    DELETE_TRANSACTION: '/api/ui/analytics/transactions',
    GET_TRANSACTIONS: '/api/ui/analytics/transactions',
    GET_TRANSACTION_DETAILS: '/api/ui/analytics/transactions',
    GET_TRANSACTION_HISTORY: '/api/ui/analytics/transactions',
    POST_TRANSACTION_REPORT: '/api/ui/analytics/transactions',
    GET_TRANSACTION_EVENTS: '/api/ui/analytics/transactions',
    GET_TRANSACTION_CHAINS: '/api/ui/analytics/transactions/chains'
};
const $78597906e6a0205e$export$52fc864b1319068d = {
    GET_REPORTS: '/api/ui/reports',
    GET_REPORT: '/api/ui/reports',
    GET_REPORTS_TRANSACTION: '/api/ui/reports/transactions',
    GET_REPORTS_TRAVELRULE: '/api/ui/travelrule/reports'
};
const $78597906e6a0205e$export$b0b514a7d9a48bfa = {
    GET_ALL_ACCOUNTS: '/api/ui/directory/accounts',
    GET_ACCOUNT: '/api/ui/directory/accounts/',
    SEARCH_ACCOUNT: '/api/ui/directory/accounts/search',
    CREATE_ACCOUNT_ENTITY: '/api/ui/directory/accounts/entity',
    CREATE_ACCOUNT_INDIVIDUAL: '/api/ui/directory/accounts/individual',
    UPDATE_ACCOUNT_ENTITY: '/api/ui/directory/accounts/entity/',
    UPDATE_ACCOUNT_INDIVIDUAL: '/api/ui/directory/accounts/individual/'
};
const $78597906e6a0205e$export$aa699c9a0b9a0cb4 = {
    GET_ALL_VASPS: '/api/ui/directory/vasps',
    GET_ALL_MID_PROSPECTS: '/api/ui/directory/vasps/mid_prospects',
    GET_VASP: '/api/ui/directory/vasps/',
    SEARCH_VASP: '/api/ui/directory/vasps/search',
    SEARCH_MID_PROSPECT: '/api/ui/directory/vasps/search/mid_prospects',
    CREATE_VASP: '/api/ui/directory/vasps',
    UPDATE_VASP: '/api/ui/directory/vasps'
};
const $78597906e6a0205e$export$5d38483e7d27dad5 = {
    GET_ASSET_CONVERSION: '/api/ui/travelrule/conversion',
    GET_ALL_TRANSFERS: '/api/ui/travelrule/transfers',
    GET_TRANSFER: '/api/ui/travelrule/transfers/',
    CREATE_TRANSFER: '/api/ui/travelrule/transfers/start',
    UPDATE_TRANSFER: '/api/ui/travelrule/transfers/',
    SEARCH_TRANSFER: '/api/ui/travelrule/transfers/search',
    GET_RECIPIENT_VASP: '/api/ui/travelrule/transfers/analyzer',
    POST_TRANSFER_REPORT: '/api/ui/travelrule/reports',
    GET_ACCOUNT_SUMMARY: '/api/ui/travelrule/transfers/account/summary'
};
const $78597906e6a0205e$export$dfd61605b4fbe9ff = {
    PAGED_TABLE_DATA: '/api/whitelist/paged-table',
    RISK_BUCKET: '/api/whitelist/risk-bucket',
    ADDRESS_HISTORY: '/api/whitelist/address-hist',
    ADDRESS_COUNT: '/api/whitelist/count-address',
    ASSIGN_ADDRESS: '/api/whitelist/assign-address',
    SEARCH_ADDRESS: '/api/whitelist/search-address?',
    REMOVE_ADDRESS: '/api/whitelist/remove-address',
    GET_ADDRESS_REPORT: '/api/reporting/address',
    UPDATE_ADDRESS_NOTES: '/api/whitelist/notes'
};
const $78597906e6a0205e$export$3a1bab43d9aad7a = {
    PAGED_TABLE_DATA: '/api/monitoring/paged-table',
    RISK_BUCKET: '/api/monitoring/risk-bucket',
    TRANSACTION_HISTORY: '/api/monitoring/transaction-hist',
    TRANSACTION_COUNT: '/api/monitoring/count-transaction',
    ASSIGN_TRANSACTION: '/api/monitoring/assign-transaction',
    SEARCH_TRANSACTION: '/api/monitoring/search-transaction?',
    REMOVE_TRANSACTION: '/api/monitoring/remove-transaction',
    GET_TRANSACTION_REPORT: '/api/reporting/transaction',
    UPDATE_TRANSACTION_NOTES: '/api/monitoring/notes'
};
const $78597906e6a0205e$export$a6e37b2331bd3fc6 = {
    // Read
    READ_ALL_ALERTS: '/api/alerts/get_alerts',
    READ_ALERT_DETAILS: '/api/alerts/get_alert_details',
    READ_DAILY_ALERTS: '/api/alerts/get_daily_alerts',
    READ_ALERTS_BY_SEVERITY: '/api/alerts/get_alerts_by_severity',
    READ_ALERTS_BY_STATUS: '/api/alerts/get_alerts_by_status'
};
const $78597906e6a0205e$export$f14b72fcf3d169b9 = {
    READ_PROFILE: '/api/ui/users',
    UPDATE_PROFILE: '/api/ui/users/profile',
    REQUEST_EMAIL_VERIFICATION: '/api/ui/users/email/verification',
    GET_ACTIVATION_LINK: '/api/ui/users/activation/',
    ACTIVATE_USER: '/api/ui/users/activation/'
};
const $78597906e6a0205e$export$b3355532f3f0b578 = {
    GET_USERS: '/api/ui/users/manager/users',
    CREATE_USER: '/api/ui/users/manager/user',
    CREATE_USER_ACTIVATION_LINK: '/api/ui/users/manager/user/activation/',
    UPDATE_USER: '/api/ui/users/manager/user/'
};
const $78597906e6a0205e$export$e1b54834f9622113 = {
    MAIN_SITE: 'https://www.ospree.io/',
    GET_STARTED: 'https://www.ospree.io/get-demo',
    FEEDBACK: 'https://ospree.io/help',
    PRIVACY_POLICY: 'https://www.ospree.io/legal/privacy-policy',
    TERMS_OF_SERVICE: 'https://www.ospree.io/legal/terms-and-conditions',
    OSPREE_VERSION_2: 'https://ospree.io/blog/ospree-version-2/'
};
const $78597906e6a0205e$export$37c0b20aa8a4ae01 = {
    ADDRESSES: '/api/case/batch-address',
    TRANSACTIONS: '/api/case/batch-transaction'
};


const $e29db2de9829c254$var$REFRESH_URL = (0, $78597906e6a0205e$export$ca6dda5263526f75) + (0, $78597906e6a0205e$export$eb187b828ac95891).REFRESH;
const $e29db2de9829c254$var$clearUserCredentials = ()=>{
    localStorage.removeItem('userCredentials');
};
const $e29db2de9829c254$export$456995facc43eda = (baseURL)=>{
    const instance = (0, (/*@__PURE__*/$parcel$interopDefault($f3d855b3ff65dabd$exports))).create({
        baseURL: baseURL,
        withCredentials: true
    });
    // Always attach the latest access token
    instance.interceptors.request.use((config)=>{
        const accessToken = JSON.parse(localStorage.getItem('userCredentials') || '{}')?.access_token;
        if (accessToken) config.headers.Authorization = `Bearer ${accessToken}`;
        return config;
    });
    let refreshPromise = null;
    instance.interceptors.response.use((response)=>response, async (error)=>{
        const status = error?.response?.status;
        const originalRequest = error?.config;
        if (!originalRequest) return Promise.reject(error);
        // Don't refresh on 404
        if (status !== 401 && status !== 403) return Promise.reject(error);
        // Never try to refresh if the refresh endpoint itself failed
        if (originalRequest.url?.includes((0, $78597906e6a0205e$export$eb187b828ac95891).REFRESH)) {
            $e29db2de9829c254$var$clearUserCredentials();
            window.location.reload();
            return Promise.reject(error);
        }
        // Retry guard
        if (originalRequest.retry) return Promise.reject(error);
        originalRequest.retry = true;
        try {
            // Deduplicate concurrent refresh calls
            refreshPromise = refreshPromise || (0, (/*@__PURE__*/$parcel$interopDefault($f3d855b3ff65dabd$exports))).post($e29db2de9829c254$var$REFRESH_URL, {}, {
                baseURL: (0, $78597906e6a0205e$export$ca6dda5263526f75),
                withCredentials: true
            });
            const resp = await refreshPromise;
            refreshPromise = null;
            const newAccessToken = resp?.data?.data?.access_token;
            if (!newAccessToken) throw new Error('No access token returned from refresh');
            const userCred = JSON.parse(localStorage.getItem('userCredentials') || '{}');
            localStorage.setItem('userCredentials', JSON.stringify({
                ...userCred,
                access_token: newAccessToken
            }));
            // Replay original request with new token
            originalRequest.headers = originalRequest.headers || {};
            originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
            return $e29db2de9829c254$export$38b0b8222efbc769(originalRequest);
        } catch (refreshErr) {
            refreshPromise = null;
            $e29db2de9829c254$var$clearUserCredentials();
            window.location.reload();
            return Promise.reject(refreshErr);
        }
    });
    return instance;
};
const $e29db2de9829c254$export$38b0b8222efbc769 = $e29db2de9829c254$export$456995facc43eda((0, $78597906e6a0205e$export$ca6dda5263526f75));
const $e29db2de9829c254$export$170e87424a0d64a3 = (0, (/*@__PURE__*/$parcel$interopDefault($f3d855b3ff65dabd$exports))).create({
    baseURL: (0, $78597906e6a0205e$export$ca6dda5263526f75),
    withCredentials: true
});



var $0162588c1b9666d4$exports = {};
'use strict';
var $3399a7ea5d40d8d8$exports = {};
'use strict';
var $7e2b00aa2e6a83f2$exports = {};
'use strict';
var $dc13161a3c098f6a$exports = {};
'use strict';
/** @type {import('./type')} */ $dc13161a3c098f6a$exports = TypeError;


var $25ad6d8cff92dbf8$exports = {};
var $25ad6d8cff92dbf8$var$hasMap = typeof Map === 'function' && Map.prototype;
var $25ad6d8cff92dbf8$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $25ad6d8cff92dbf8$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var $25ad6d8cff92dbf8$var$mapSize = $25ad6d8cff92dbf8$var$hasMap && $25ad6d8cff92dbf8$var$mapSizeDescriptor && typeof $25ad6d8cff92dbf8$var$mapSizeDescriptor.get === 'function' ? $25ad6d8cff92dbf8$var$mapSizeDescriptor.get : null;
var $25ad6d8cff92dbf8$var$mapForEach = $25ad6d8cff92dbf8$var$hasMap && Map.prototype.forEach;
var $25ad6d8cff92dbf8$var$hasSet = typeof Set === 'function' && Set.prototype;
var $25ad6d8cff92dbf8$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $25ad6d8cff92dbf8$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var $25ad6d8cff92dbf8$var$setSize = $25ad6d8cff92dbf8$var$hasSet && $25ad6d8cff92dbf8$var$setSizeDescriptor && typeof $25ad6d8cff92dbf8$var$setSizeDescriptor.get === 'function' ? $25ad6d8cff92dbf8$var$setSizeDescriptor.get : null;
var $25ad6d8cff92dbf8$var$setForEach = $25ad6d8cff92dbf8$var$hasSet && Set.prototype.forEach;
var $25ad6d8cff92dbf8$var$hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var $25ad6d8cff92dbf8$var$weakMapHas = $25ad6d8cff92dbf8$var$hasWeakMap ? WeakMap.prototype.has : null;
var $25ad6d8cff92dbf8$var$hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var $25ad6d8cff92dbf8$var$weakSetHas = $25ad6d8cff92dbf8$var$hasWeakSet ? WeakSet.prototype.has : null;
var $25ad6d8cff92dbf8$var$hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var $25ad6d8cff92dbf8$var$weakRefDeref = $25ad6d8cff92dbf8$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $25ad6d8cff92dbf8$var$booleanValueOf = Boolean.prototype.valueOf;
var $25ad6d8cff92dbf8$var$objectToString = Object.prototype.toString;
var $25ad6d8cff92dbf8$var$functionToString = Function.prototype.toString;
var $25ad6d8cff92dbf8$var$$match = String.prototype.match;
var $25ad6d8cff92dbf8$var$$slice = String.prototype.slice;
var $25ad6d8cff92dbf8$var$$replace = String.prototype.replace;
var $25ad6d8cff92dbf8$var$$toUpperCase = String.prototype.toUpperCase;
var $25ad6d8cff92dbf8$var$$toLowerCase = String.prototype.toLowerCase;
var $25ad6d8cff92dbf8$var$$test = RegExp.prototype.test;
var $25ad6d8cff92dbf8$var$$concat = Array.prototype.concat;
var $25ad6d8cff92dbf8$var$$join = Array.prototype.join;
var $25ad6d8cff92dbf8$var$$arrSlice = Array.prototype.slice;
var $25ad6d8cff92dbf8$var$$floor = Math.floor;
var $25ad6d8cff92dbf8$var$bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var $25ad6d8cff92dbf8$var$gOPS = Object.getOwnPropertySymbols;
var $25ad6d8cff92dbf8$var$symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var $25ad6d8cff92dbf8$var$hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var $25ad6d8cff92dbf8$var$toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === $25ad6d8cff92dbf8$var$hasShammedSymbols ? 'object' : 'symbol') ? Symbol.toStringTag : null;
var $25ad6d8cff92dbf8$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $25ad6d8cff92dbf8$var$gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function $25ad6d8cff92dbf8$var$addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $25ad6d8cff92dbf8$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$25ad6d8cff92dbf8$var$$floor(-num) : $25ad6d8cff92dbf8$var$$floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $25ad6d8cff92dbf8$var$$slice.call(str, intStr.length + 1);
            return $25ad6d8cff92dbf8$var$$replace.call(intStr, sepRegex, '$&_') + '.' + $25ad6d8cff92dbf8$var$$replace.call($25ad6d8cff92dbf8$var$$replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $25ad6d8cff92dbf8$var$$replace.call(str, sepRegex, '$&_');
}
var $913fd7d8eddc8c4a$exports = {};
"use strict";


var $25ad6d8cff92dbf8$var$inspectCustom = $913fd7d8eddc8c4a$exports.custom;
var $25ad6d8cff92dbf8$var$inspectSymbol = $25ad6d8cff92dbf8$var$isSymbol($25ad6d8cff92dbf8$var$inspectCustom) ? $25ad6d8cff92dbf8$var$inspectCustom : null;
var $25ad6d8cff92dbf8$var$quotes = {
    __proto__: null,
    'double': '"',
    single: "'"
};
var $25ad6d8cff92dbf8$var$quoteREs = {
    __proto__: null,
    'double': /(["\\])/g,
    single: /(['\\])/g
};
$25ad6d8cff92dbf8$exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($25ad6d8cff92dbf8$var$has(opts, 'quoteStyle') && !$25ad6d8cff92dbf8$var$has($25ad6d8cff92dbf8$var$quotes, opts.quoteStyle)) throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($25ad6d8cff92dbf8$var$has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number' ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $25ad6d8cff92dbf8$var$has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    if ($25ad6d8cff92dbf8$var$has(opts, 'indent') && opts.indent !== null && opts.indent !== '\t' && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($25ad6d8cff92dbf8$var$has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === 'undefined') return 'undefined';
    if (obj === null) return 'null';
    if (typeof obj === 'boolean') return obj ? 'true' : 'false';
    if (typeof obj === 'string') return $25ad6d8cff92dbf8$var$inspectString(obj, opts);
    if (typeof obj === 'number') {
        if (obj === 0) return Infinity / obj > 0 ? '0' : '-0';
        var str = String(obj);
        return numericSeparator ? $25ad6d8cff92dbf8$var$addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? $25ad6d8cff92dbf8$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') return $25ad6d8cff92dbf8$var$isArray(obj) ? '[Array]' : '[Object]';
    var indent = $25ad6d8cff92dbf8$var$getIndent(opts, depth);
    if (typeof seen === 'undefined') seen = [];
    else if ($25ad6d8cff92dbf8$var$indexOf(seen, obj) >= 0) return '[Circular]';
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $25ad6d8cff92dbf8$var$$arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($25ad6d8cff92dbf8$var$has(opts, 'quoteStyle')) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === 'function' && !$25ad6d8cff92dbf8$var$isRegExp(obj)) {
        var name = $25ad6d8cff92dbf8$var$nameOf(obj);
        var keys = $25ad6d8cff92dbf8$var$arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $25ad6d8cff92dbf8$var$$join.call(keys, ', ') + ' }' : '');
    }
    if ($25ad6d8cff92dbf8$var$isSymbol(obj)) {
        var symString = $25ad6d8cff92dbf8$var$hasShammedSymbols ? $25ad6d8cff92dbf8$var$$replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : $25ad6d8cff92dbf8$var$symToString.call(obj);
        return typeof obj === 'object' && !$25ad6d8cff92dbf8$var$hasShammedSymbols ? $25ad6d8cff92dbf8$var$markBoxed(symString) : symString;
    }
    if ($25ad6d8cff92dbf8$var$isElement(obj)) {
        var s = '<' + $25ad6d8cff92dbf8$var$$toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += ' ' + attrs[i].name + '=' + $25ad6d8cff92dbf8$var$wrapQuotes($25ad6d8cff92dbf8$var$quote(attrs[i].value), 'double', opts);
        s += '>';
        if (obj.childNodes && obj.childNodes.length) s += '...';
        s += '</' + $25ad6d8cff92dbf8$var$$toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if ($25ad6d8cff92dbf8$var$isArray(obj)) {
        if (obj.length === 0) return '[]';
        var xs = $25ad6d8cff92dbf8$var$arrObjKeys(obj, inspect);
        if (indent && !$25ad6d8cff92dbf8$var$singleLineValues(xs)) return '[' + $25ad6d8cff92dbf8$var$indentedJoin(xs, indent) + ']';
        return '[ ' + $25ad6d8cff92dbf8$var$$join.call(xs, ', ') + ' ]';
    }
    if ($25ad6d8cff92dbf8$var$isError(obj)) {
        var parts = $25ad6d8cff92dbf8$var$arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !$25ad6d8cff92dbf8$var$isEnumerable.call(obj, 'cause')) return '{ [' + String(obj) + '] ' + $25ad6d8cff92dbf8$var$$join.call($25ad6d8cff92dbf8$var$$concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        if (parts.length === 0) return '[' + String(obj) + ']';
        return '{ [' + String(obj) + '] ' + $25ad6d8cff92dbf8$var$$join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if ($25ad6d8cff92dbf8$var$inspectSymbol && typeof obj[$25ad6d8cff92dbf8$var$inspectSymbol] === 'function' && $913fd7d8eddc8c4a$exports) return $913fd7d8eddc8c4a$exports(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') return obj.inspect();
    }
    if ($25ad6d8cff92dbf8$var$isMap(obj)) {
        var mapParts = [];
        if ($25ad6d8cff92dbf8$var$mapForEach) $25ad6d8cff92dbf8$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
        });
        return $25ad6d8cff92dbf8$var$collectionOf('Map', $25ad6d8cff92dbf8$var$mapSize.call(obj), mapParts, indent);
    }
    if ($25ad6d8cff92dbf8$var$isSet(obj)) {
        var setParts = [];
        if ($25ad6d8cff92dbf8$var$setForEach) $25ad6d8cff92dbf8$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $25ad6d8cff92dbf8$var$collectionOf('Set', $25ad6d8cff92dbf8$var$setSize.call(obj), setParts, indent);
    }
    if ($25ad6d8cff92dbf8$var$isWeakMap(obj)) return $25ad6d8cff92dbf8$var$weakCollectionOf('WeakMap');
    if ($25ad6d8cff92dbf8$var$isWeakSet(obj)) return $25ad6d8cff92dbf8$var$weakCollectionOf('WeakSet');
    if ($25ad6d8cff92dbf8$var$isWeakRef(obj)) return $25ad6d8cff92dbf8$var$weakCollectionOf('WeakRef');
    if ($25ad6d8cff92dbf8$var$isNumber(obj)) return $25ad6d8cff92dbf8$var$markBoxed(inspect(Number(obj)));
    if ($25ad6d8cff92dbf8$var$isBigInt(obj)) return $25ad6d8cff92dbf8$var$markBoxed(inspect($25ad6d8cff92dbf8$var$bigIntValueOf.call(obj)));
    if ($25ad6d8cff92dbf8$var$isBoolean(obj)) return $25ad6d8cff92dbf8$var$markBoxed($25ad6d8cff92dbf8$var$booleanValueOf.call(obj));
    if ($25ad6d8cff92dbf8$var$isString(obj)) return $25ad6d8cff92dbf8$var$markBoxed(inspect(String(obj)));
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */ if (typeof window !== 'undefined' && obj === window) return '{ [object Window] }';
    if (typeof globalThis !== 'undefined' && obj === globalThis || typeof $parcel$global !== 'undefined' && obj === $parcel$global) return '{ [object globalThis] }';
    if (!$25ad6d8cff92dbf8$var$isDate(obj) && !$25ad6d8cff92dbf8$var$isRegExp(obj)) {
        var ys = $25ad6d8cff92dbf8$var$arrObjKeys(obj, inspect);
        var isPlainObject = $25ad6d8cff92dbf8$var$gPO ? $25ad6d8cff92dbf8$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && $25ad6d8cff92dbf8$var$toStringTag && Object(obj) === obj && $25ad6d8cff92dbf8$var$toStringTag in obj ? $25ad6d8cff92dbf8$var$$slice.call($25ad6d8cff92dbf8$var$toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $25ad6d8cff92dbf8$var$$join.call($25ad6d8cff92dbf8$var$$concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) return tag + '{}';
        if (indent) return tag + '{' + $25ad6d8cff92dbf8$var$indentedJoin(ys, indent) + '}';
        return tag + '{ ' + $25ad6d8cff92dbf8$var$$join.call(ys, ', ') + ' }';
    }
    return String(obj);
};
function $25ad6d8cff92dbf8$var$wrapQuotes(s, defaultStyle, opts) {
    var style = opts.quoteStyle || defaultStyle;
    var quoteChar = $25ad6d8cff92dbf8$var$quotes[style];
    return quoteChar + s + quoteChar;
}
function $25ad6d8cff92dbf8$var$quote(s) {
    return $25ad6d8cff92dbf8$var$$replace.call(String(s), /"/g, '&quot;');
}
function $25ad6d8cff92dbf8$var$canTrustToString(obj) {
    return !$25ad6d8cff92dbf8$var$toStringTag || !(typeof obj === 'object' && ($25ad6d8cff92dbf8$var$toStringTag in obj || typeof obj[$25ad6d8cff92dbf8$var$toStringTag] !== 'undefined'));
}
function $25ad6d8cff92dbf8$var$isArray(obj) {
    return $25ad6d8cff92dbf8$var$toStr(obj) === '[object Array]' && $25ad6d8cff92dbf8$var$canTrustToString(obj);
}
function $25ad6d8cff92dbf8$var$isDate(obj) {
    return $25ad6d8cff92dbf8$var$toStr(obj) === '[object Date]' && $25ad6d8cff92dbf8$var$canTrustToString(obj);
}
function $25ad6d8cff92dbf8$var$isRegExp(obj) {
    return $25ad6d8cff92dbf8$var$toStr(obj) === '[object RegExp]' && $25ad6d8cff92dbf8$var$canTrustToString(obj);
}
function $25ad6d8cff92dbf8$var$isError(obj) {
    return $25ad6d8cff92dbf8$var$toStr(obj) === '[object Error]' && $25ad6d8cff92dbf8$var$canTrustToString(obj);
}
function $25ad6d8cff92dbf8$var$isString(obj) {
    return $25ad6d8cff92dbf8$var$toStr(obj) === '[object String]' && $25ad6d8cff92dbf8$var$canTrustToString(obj);
}
function $25ad6d8cff92dbf8$var$isNumber(obj) {
    return $25ad6d8cff92dbf8$var$toStr(obj) === '[object Number]' && $25ad6d8cff92dbf8$var$canTrustToString(obj);
}
function $25ad6d8cff92dbf8$var$isBoolean(obj) {
    return $25ad6d8cff92dbf8$var$toStr(obj) === '[object Boolean]' && $25ad6d8cff92dbf8$var$canTrustToString(obj);
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $25ad6d8cff92dbf8$var$isSymbol(obj) {
    if ($25ad6d8cff92dbf8$var$hasShammedSymbols) return obj && typeof obj === 'object' && obj instanceof Symbol;
    if (typeof obj === 'symbol') return true;
    if (!obj || typeof obj !== 'object' || !$25ad6d8cff92dbf8$var$symToString) return false;
    try {
        $25ad6d8cff92dbf8$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $25ad6d8cff92dbf8$var$isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !$25ad6d8cff92dbf8$var$bigIntValueOf) return false;
    try {
        $25ad6d8cff92dbf8$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $25ad6d8cff92dbf8$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $25ad6d8cff92dbf8$var$has(obj, key) {
    return $25ad6d8cff92dbf8$var$hasOwn.call(obj, key);
}
function $25ad6d8cff92dbf8$var$toStr(obj) {
    return $25ad6d8cff92dbf8$var$objectToString.call(obj);
}
function $25ad6d8cff92dbf8$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $25ad6d8cff92dbf8$var$$match.call($25ad6d8cff92dbf8$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $25ad6d8cff92dbf8$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $25ad6d8cff92dbf8$var$isMap(x) {
    if (!$25ad6d8cff92dbf8$var$mapSize || !x || typeof x !== 'object') return false;
    try {
        $25ad6d8cff92dbf8$var$mapSize.call(x);
        try {
            $25ad6d8cff92dbf8$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $25ad6d8cff92dbf8$var$isWeakMap(x) {
    if (!$25ad6d8cff92dbf8$var$weakMapHas || !x || typeof x !== 'object') return false;
    try {
        $25ad6d8cff92dbf8$var$weakMapHas.call(x, $25ad6d8cff92dbf8$var$weakMapHas);
        try {
            $25ad6d8cff92dbf8$var$weakSetHas.call(x, $25ad6d8cff92dbf8$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $25ad6d8cff92dbf8$var$isWeakRef(x) {
    if (!$25ad6d8cff92dbf8$var$weakRefDeref || !x || typeof x !== 'object') return false;
    try {
        $25ad6d8cff92dbf8$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $25ad6d8cff92dbf8$var$isSet(x) {
    if (!$25ad6d8cff92dbf8$var$setSize || !x || typeof x !== 'object') return false;
    try {
        $25ad6d8cff92dbf8$var$setSize.call(x);
        try {
            $25ad6d8cff92dbf8$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $25ad6d8cff92dbf8$var$isWeakSet(x) {
    if (!$25ad6d8cff92dbf8$var$weakSetHas || !x || typeof x !== 'object') return false;
    try {
        $25ad6d8cff92dbf8$var$weakSetHas.call(x, $25ad6d8cff92dbf8$var$weakSetHas);
        try {
            $25ad6d8cff92dbf8$var$weakMapHas.call(x, $25ad6d8cff92dbf8$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $25ad6d8cff92dbf8$var$isElement(x) {
    if (!x || typeof x !== 'object') return false;
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) return true;
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}
function $25ad6d8cff92dbf8$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return $25ad6d8cff92dbf8$var$inspectString($25ad6d8cff92dbf8$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    var quoteRE = $25ad6d8cff92dbf8$var$quoteREs[opts.quoteStyle || 'single'];
    quoteRE.lastIndex = 0;
    // eslint-disable-next-line no-control-regex
    var s = $25ad6d8cff92dbf8$var$$replace.call($25ad6d8cff92dbf8$var$$replace.call(str, quoteRE, '\\$1'), /[\x00-\x1f]/g, $25ad6d8cff92dbf8$var$lowbyte);
    return $25ad6d8cff92dbf8$var$wrapQuotes(s, 'single', opts);
}
function $25ad6d8cff92dbf8$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) return '\\' + x;
    return '\\x' + (n < 0x10 ? '0' : '') + $25ad6d8cff92dbf8$var$$toUpperCase.call(n.toString(16));
}
function $25ad6d8cff92dbf8$var$markBoxed(str) {
    return 'Object(' + str + ')';
}
function $25ad6d8cff92dbf8$var$weakCollectionOf(type) {
    return type + ' { ? }';
}
function $25ad6d8cff92dbf8$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $25ad6d8cff92dbf8$var$indentedJoin(entries, indent) : $25ad6d8cff92dbf8$var$$join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}
function $25ad6d8cff92dbf8$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($25ad6d8cff92dbf8$var$indexOf(xs[i], '\n') >= 0) return false;
    }
    return true;
}
function $25ad6d8cff92dbf8$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') baseIndent = '\t';
    else if (typeof opts.indent === 'number' && opts.indent > 0) baseIndent = $25ad6d8cff92dbf8$var$$join.call(Array(opts.indent + 1), ' ');
    else return null;
    return {
        base: baseIndent,
        prev: $25ad6d8cff92dbf8$var$$join.call(Array(depth + 1), baseIndent)
    };
}
function $25ad6d8cff92dbf8$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return '';
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $25ad6d8cff92dbf8$var$$join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}
function $25ad6d8cff92dbf8$var$arrObjKeys(obj, inspect) {
    var isArr = $25ad6d8cff92dbf8$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $25ad6d8cff92dbf8$var$has(obj, i) ? inspect(obj[i], obj) : '';
    }
    var syms = typeof $25ad6d8cff92dbf8$var$gOPS === 'function' ? $25ad6d8cff92dbf8$var$gOPS(obj) : [];
    var symMap;
    if ($25ad6d8cff92dbf8$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap['$' + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!$25ad6d8cff92dbf8$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if ($25ad6d8cff92dbf8$var$hasShammedSymbols && symMap['$' + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($25ad6d8cff92dbf8$var$$test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        else xs.push(key + ': ' + inspect(obj[key], obj));
    }
    if (typeof $25ad6d8cff92dbf8$var$gOPS === 'function') {
        for(var j = 0; j < syms.length; j++)if ($25ad6d8cff92dbf8$var$isEnumerable.call(obj, syms[j])) xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
    }
    return xs;
}


var $9f7a21e35ed54df2$exports = {};
'use strict';


/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list.
* By doing so, all the recently used nodes can be accessed relatively quickly.
*/ /** @type {import('./list.d.ts').listGetNode} */ // eslint-disable-next-line consistent-return
var $9f7a21e35ed54df2$var$listGetNode = function(list, key, isDelete) {
    /** @type {typeof list | NonNullable<(typeof list)['next']>} */ var prev = list;
    /** @type {(typeof list)['next']} */ var curr;
    // eslint-disable-next-line eqeqeq
    for(; (curr = prev.next) != null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        if (!isDelete) {
            // eslint-disable-next-line no-extra-parens
            curr.next = /** @type {NonNullable<typeof list.next>} */ list.next;
            list.next = curr; // eslint-disable-line no-param-reassign
        }
        return curr;
    }
};
/** @type {import('./list.d.ts').listGet} */ var $9f7a21e35ed54df2$var$listGet = function(objects, key) {
    if (!objects) return void 0;
    var node = $9f7a21e35ed54df2$var$listGetNode(objects, key);
    return node && node.value;
};
/** @type {import('./list.d.ts').listSet} */ var $9f7a21e35ed54df2$var$listSet = function(objects, key, value) {
    var node = $9f7a21e35ed54df2$var$listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */ {
        key: key,
        next: objects.next,
        value: value
    };
};
/** @type {import('./list.d.ts').listHas} */ var $9f7a21e35ed54df2$var$listHas = function(objects, key) {
    if (!objects) return false;
    return !!$9f7a21e35ed54df2$var$listGetNode(objects, key);
};
/** @type {import('./list.d.ts').listDelete} */ // eslint-disable-next-line consistent-return
var $9f7a21e35ed54df2$var$listDelete = function(objects, key) {
    if (objects) return $9f7a21e35ed54df2$var$listGetNode(objects, key, true);
};
/** @type {import('.')} */ $9f7a21e35ed54df2$exports = function getSideChannelList() {
    /** @typedef {ReturnType<typeof getSideChannelList>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {import('./list.d.ts').RootNode<V, K> | undefined} */ var $o;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $dc13161a3c098f6a$exports('Side channel does not contain ' + $25ad6d8cff92dbf8$exports(key));
        },
        'delete': function(key) {
            var root = $o && $o.next;
            var deletedNode = $9f7a21e35ed54df2$var$listDelete($o, key);
            if (deletedNode && root && root === deletedNode) $o = void 0;
            return !!deletedNode;
        },
        get: function(key) {
            return $9f7a21e35ed54df2$var$listGet($o, key);
        },
        has: function(key) {
            return $9f7a21e35ed54df2$var$listHas($o, key);
        },
        set: function(key, value) {
            if (!$o) // Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
            $o = {
                next: void 0
            };
            // eslint-disable-next-line no-extra-parens
            $9f7a21e35ed54df2$var$listSet(/** @type {NonNullable<typeof $o>} */ $o, key, value);
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
};


var $c78e98e0207f6b0c$exports = {};
'use strict';
var $8a6f70dce0df97e8$exports = {};
'use strict';
var $8a6f70dce0df97e8$var$undefined1;
var $f0361049cce222aa$exports = {};
'use strict';
/** @type {import('.')} */ $f0361049cce222aa$exports = Object;


var $6e421d4bc1c8bcd0$exports = {};
'use strict';
/** @type {import('.')} */ $6e421d4bc1c8bcd0$exports = Error;


var $bc0d04d9bb73d400$exports = {};
'use strict';
/** @type {import('./eval')} */ $bc0d04d9bb73d400$exports = EvalError;


var $4425330b90d6b012$exports = {};
'use strict';
/** @type {import('./range')} */ $4425330b90d6b012$exports = RangeError;


var $0875821aec9241d0$exports = {};
'use strict';
/** @type {import('./ref')} */ $0875821aec9241d0$exports = ReferenceError;


var $384225cd8772b722$exports = {};
'use strict';
/** @type {import('./syntax')} */ $384225cd8772b722$exports = SyntaxError;



var $b49a2d46dd9165c2$exports = {};
'use strict';
/** @type {import('./uri')} */ $b49a2d46dd9165c2$exports = URIError;


var $e615c4ad12e511de$exports = {};
'use strict';
/** @type {import('./abs')} */ $e615c4ad12e511de$exports = Math.abs;


var $0123e78bec494613$exports = {};
'use strict';
/** @type {import('./floor')} */ $0123e78bec494613$exports = Math.floor;


var $b66bcc8fa2db1933$exports = {};
'use strict';
/** @type {import('./max')} */ $b66bcc8fa2db1933$exports = Math.max;


var $f301460bc4dd47c7$exports = {};
'use strict';
/** @type {import('./min')} */ $f301460bc4dd47c7$exports = Math.min;


var $f345c338a8b70604$exports = {};
'use strict';
/** @type {import('./pow')} */ $f345c338a8b70604$exports = Math.pow;


var $1ae931659abad4ff$exports = {};
'use strict';
/** @type {import('./round')} */ $1ae931659abad4ff$exports = Math.round;


var $9d6c0a76c63af4b5$exports = {};
'use strict';
var $74182fe441d25b31$exports = {};
'use strict';
/** @type {import('./isNaN')} */ $74182fe441d25b31$exports = Number.isNaN || function isNaN(a) {
    return a !== a;
};


/** @type {import('./sign')} */ $9d6c0a76c63af4b5$exports = function sign(number) {
    if ($74182fe441d25b31$exports(number) || number === 0) return number;
    return number < 0 ? -1 : 1;
};


var $8a6f70dce0df97e8$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $8a6f70dce0df97e8$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $8a6f70dce0df97e8$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};
var $9141a380a62c3b5d$exports = {};
'use strict';
var $54fcb549d16732c0$exports = {};
'use strict';
/** @type {import('./gOPD')} */ $54fcb549d16732c0$exports = Object.getOwnPropertyDescriptor;


var $9141a380a62c3b5d$require$$gOPD = $54fcb549d16732c0$exports;
if ($9141a380a62c3b5d$require$$gOPD) try {
    $9141a380a62c3b5d$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $9141a380a62c3b5d$require$$gOPD = null;
}
$9141a380a62c3b5d$exports = $9141a380a62c3b5d$require$$gOPD;


var $4e539c68e49b4e05$exports = {};
'use strict';
/** @type {import('.')} */ var $4e539c68e49b4e05$var$$defineProperty = Object.defineProperty || false;
if ($4e539c68e49b4e05$var$$defineProperty) try {
    $4e539c68e49b4e05$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $4e539c68e49b4e05$var$$defineProperty = false;
}
$4e539c68e49b4e05$exports = $4e539c68e49b4e05$var$$defineProperty;


var $8a6f70dce0df97e8$var$throwTypeError = function() {
    throw new $dc13161a3c098f6a$exports();
};
var $8a6f70dce0df97e8$var$ThrowTypeError = $9141a380a62c3b5d$exports ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $8a6f70dce0df97e8$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $9141a380a62c3b5d$exports(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $8a6f70dce0df97e8$var$throwTypeError;
        }
    }
}() : $8a6f70dce0df97e8$var$throwTypeError;

var $8a6f70dce0df97e8$var$hasSymbols = (parcelRequire("jlsPO"))();
var $5bc25b50a7b49e56$exports = {};
'use strict';
var $b121e6a4fc6a0a4c$exports = {};
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ $b121e6a4fc6a0a4c$exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;


var $17399b1c908b9505$exports = {};
'use strict';

/** @type {import('./Object.getPrototypeOf')} */ $17399b1c908b9505$exports = $f0361049cce222aa$exports.getPrototypeOf || null;


var $9f11de46d43358be$exports = {};
'use strict';
var $498ac5278b191a7c$exports = {};
'use strict';
var $8f94c933dae6b5a6$exports = {};
'use strict';
var $25ebd9c62117c316$exports = {};
'use strict';
/* eslint no-invalid-this: 1 */ var $25ebd9c62117c316$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $25ebd9c62117c316$var$toStr = Object.prototype.toString;
var $25ebd9c62117c316$var$max = Math.max;
var $25ebd9c62117c316$var$funcType = '[object Function]';
var $25ebd9c62117c316$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $25ebd9c62117c316$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $25ebd9c62117c316$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
$25ebd9c62117c316$exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $25ebd9c62117c316$var$toStr.apply(target) !== $25ebd9c62117c316$var$funcType) throw new TypeError($25ebd9c62117c316$var$ERROR_MESSAGE + target);
    var args = $25ebd9c62117c316$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $25ebd9c62117c316$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $25ebd9c62117c316$var$concatty(args, arguments));
    };
    var boundLength = $25ebd9c62117c316$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $25ebd9c62117c316$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};


$8f94c933dae6b5a6$exports = Function.prototype.bind || $25ebd9c62117c316$exports;



var $efe3ff5b25ce4487$exports = {};
'use strict';
/** @type {import('./functionCall')} */ $efe3ff5b25ce4487$exports = Function.prototype.call;


var $2cb98f6bb8bdb083$exports = {};
'use strict';

var $7a600103296d3973$exports = {};
'use strict';
/** @type {import('./functionApply')} */ $7a600103296d3973$exports = Function.prototype.apply;



var $408b0deddd240d41$exports = {};
'use strict';
/** @type {import('./reflectApply')} */ $408b0deddd240d41$exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;


/** @type {import('./actualApply')} */ $2cb98f6bb8bdb083$exports = $408b0deddd240d41$exports || $8f94c933dae6b5a6$exports.call($efe3ff5b25ce4487$exports, $7a600103296d3973$exports);


/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */ $498ac5278b191a7c$exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $dc13161a3c098f6a$exports('a function is required');
    return $2cb98f6bb8bdb083$exports($8f94c933dae6b5a6$exports, $efe3ff5b25ce4487$exports, args);
};



var $9f11de46d43358be$var$hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    $9f11de46d43358be$var$hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var $9f11de46d43358be$var$desc = !!$9f11de46d43358be$var$hasProtoAccessor && $9141a380a62c3b5d$exports && $9141a380a62c3b5d$exports(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $9f11de46d43358be$var$$Object = Object;
var $9f11de46d43358be$var$$getPrototypeOf = $9f11de46d43358be$var$$Object.getPrototypeOf;
/** @type {import('./get')} */ $9f11de46d43358be$exports = $9f11de46d43358be$var$desc && typeof $9f11de46d43358be$var$desc.get === 'function' ? $498ac5278b191a7c$exports([
    $9f11de46d43358be$var$desc.get
]) : typeof $9f11de46d43358be$var$$getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $9f11de46d43358be$var$$getPrototypeOf(value == null ? value : $9f11de46d43358be$var$$Object(value));
} : false;


/** @type {import('.')} */ $5bc25b50a7b49e56$exports = $b121e6a4fc6a0a4c$exports ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $b121e6a4fc6a0a4c$exports(O);
} : $17399b1c908b9505$exports ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $17399b1c908b9505$exports(O);
} : $9f11de46d43358be$exports ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $9f11de46d43358be$exports(O);
} : null;






var $8a6f70dce0df97e8$var$needsEval = {};
var $8a6f70dce0df97e8$var$TypedArray = typeof Uint8Array === 'undefined' || !$5bc25b50a7b49e56$exports ? undefined : $5bc25b50a7b49e56$exports(Uint8Array);
var $8a6f70dce0df97e8$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $8a6f70dce0df97e8$var$hasSymbols && $5bc25b50a7b49e56$exports ? $5bc25b50a7b49e56$exports([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $8a6f70dce0df97e8$var$needsEval,
    '%AsyncGenerator%': $8a6f70dce0df97e8$var$needsEval,
    '%AsyncGeneratorFunction%': $8a6f70dce0df97e8$var$needsEval,
    '%AsyncIteratorPrototype%': $8a6f70dce0df97e8$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $6e421d4bc1c8bcd0$exports,
    '%eval%': eval,
    '%EvalError%': $bc0d04d9bb73d400$exports,
    '%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $8a6f70dce0df97e8$var$$Function,
    '%GeneratorFunction%': $8a6f70dce0df97e8$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $8a6f70dce0df97e8$var$hasSymbols && $5bc25b50a7b49e56$exports ? $5bc25b50a7b49e56$exports($5bc25b50a7b49e56$exports([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$8a6f70dce0df97e8$var$hasSymbols || !$5bc25b50a7b49e56$exports ? undefined : $5bc25b50a7b49e56$exports(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $f0361049cce222aa$exports,
    '%Object.getOwnPropertyDescriptor%': $9141a380a62c3b5d$exports,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $4425330b90d6b012$exports,
    '%ReferenceError%': $0875821aec9241d0$exports,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$8a6f70dce0df97e8$var$hasSymbols || !$5bc25b50a7b49e56$exports ? undefined : $5bc25b50a7b49e56$exports(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $8a6f70dce0df97e8$var$hasSymbols && $5bc25b50a7b49e56$exports ? $5bc25b50a7b49e56$exports(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $8a6f70dce0df97e8$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $384225cd8772b722$exports,
    '%ThrowTypeError%': $8a6f70dce0df97e8$var$ThrowTypeError,
    '%TypedArray%': $8a6f70dce0df97e8$var$TypedArray,
    '%TypeError%': $dc13161a3c098f6a$exports,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $b49a2d46dd9165c2$exports,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $efe3ff5b25ce4487$exports,
    '%Function.prototype.apply%': $7a600103296d3973$exports,
    '%Object.defineProperty%': $4e539c68e49b4e05$exports,
    '%Object.getPrototypeOf%': $17399b1c908b9505$exports,
    '%Math.abs%': $e615c4ad12e511de$exports,
    '%Math.floor%': $0123e78bec494613$exports,
    '%Math.max%': $b66bcc8fa2db1933$exports,
    '%Math.min%': $f301460bc4dd47c7$exports,
    '%Math.pow%': $f345c338a8b70604$exports,
    '%Math.round%': $1ae931659abad4ff$exports,
    '%Math.sign%': $9d6c0a76c63af4b5$exports,
    '%Reflect.getPrototypeOf%': $b121e6a4fc6a0a4c$exports
};
if ($5bc25b50a7b49e56$exports) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $8a6f70dce0df97e8$var$errorProto = $5bc25b50a7b49e56$exports($5bc25b50a7b49e56$exports(e));
    $8a6f70dce0df97e8$var$INTRINSICS['%Error.prototype%'] = $8a6f70dce0df97e8$var$errorProto;
}
var $8a6f70dce0df97e8$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $8a6f70dce0df97e8$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $8a6f70dce0df97e8$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $8a6f70dce0df97e8$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $5bc25b50a7b49e56$exports) value = $5bc25b50a7b49e56$exports(gen.prototype);
    }
    $8a6f70dce0df97e8$var$INTRINSICS[name] = value;
    return value;
};
var $8a6f70dce0df97e8$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $891960028b2c358a$exports = {};
'use strict';
var $891960028b2c358a$var$call = Function.prototype.call;
var $891960028b2c358a$var$$hasOwn = Object.prototype.hasOwnProperty;

/** @type {import('.')} */ $891960028b2c358a$exports = $8f94c933dae6b5a6$exports.call($891960028b2c358a$var$call, $891960028b2c358a$var$$hasOwn);


var $8a6f70dce0df97e8$var$$concat = $8f94c933dae6b5a6$exports.call($efe3ff5b25ce4487$exports, Array.prototype.concat);
var $8a6f70dce0df97e8$var$$spliceApply = $8f94c933dae6b5a6$exports.call($7a600103296d3973$exports, Array.prototype.splice);
var $8a6f70dce0df97e8$var$$replace = $8f94c933dae6b5a6$exports.call($efe3ff5b25ce4487$exports, String.prototype.replace);
var $8a6f70dce0df97e8$var$$strSlice = $8f94c933dae6b5a6$exports.call($efe3ff5b25ce4487$exports, String.prototype.slice);
var $8a6f70dce0df97e8$var$$exec = $8f94c933dae6b5a6$exports.call($efe3ff5b25ce4487$exports, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $8a6f70dce0df97e8$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $8a6f70dce0df97e8$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $8a6f70dce0df97e8$var$stringToPath = function stringToPath(string) {
    var first = $8a6f70dce0df97e8$var$$strSlice(string, 0, 1);
    var last = $8a6f70dce0df97e8$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $384225cd8772b722$exports('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $384225cd8772b722$exports('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $8a6f70dce0df97e8$var$$replace(string, $8a6f70dce0df97e8$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $8a6f70dce0df97e8$var$$replace(subString, $8a6f70dce0df97e8$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $8a6f70dce0df97e8$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($891960028b2c358a$exports($8a6f70dce0df97e8$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $8a6f70dce0df97e8$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($891960028b2c358a$exports($8a6f70dce0df97e8$var$INTRINSICS, intrinsicName)) {
        var value = $8a6f70dce0df97e8$var$INTRINSICS[intrinsicName];
        if (value === $8a6f70dce0df97e8$var$needsEval) value = $8a6f70dce0df97e8$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $dc13161a3c098f6a$exports('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $384225cd8772b722$exports('intrinsic ' + name + ' does not exist!');
};
$8a6f70dce0df97e8$exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $dc13161a3c098f6a$exports('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $dc13161a3c098f6a$exports('"allowMissing" argument must be a boolean');
    if ($8a6f70dce0df97e8$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $384225cd8772b722$exports('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $8a6f70dce0df97e8$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $8a6f70dce0df97e8$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $8a6f70dce0df97e8$var$$spliceApply(parts, $8a6f70dce0df97e8$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $8a6f70dce0df97e8$var$$strSlice(part, 0, 1);
        var last = $8a6f70dce0df97e8$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $384225cd8772b722$exports('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($891960028b2c358a$exports($8a6f70dce0df97e8$var$INTRINSICS, intrinsicRealName)) value = $8a6f70dce0df97e8$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $dc13161a3c098f6a$exports('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($9141a380a62c3b5d$exports && i + 1 >= parts.length) {
                var desc = $9141a380a62c3b5d$exports(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $891960028b2c358a$exports(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $8a6f70dce0df97e8$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};


var $56ab543db247e074$exports = {};
'use strict';


/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $56ab543db247e074$var$$indexOf = $498ac5278b191a7c$exports([
    $8a6f70dce0df97e8$exports('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ $56ab543db247e074$exports = function callBoundIntrinsic(name, allowMissing) {
    /* eslint no-extra-parens: 0 */ var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ $8a6f70dce0df97e8$exports(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $56ab543db247e074$var$$indexOf(name, '.prototype.') > -1) return $498ac5278b191a7c$exports(/** @type {const} */ [
        intrinsic
    ]);
    return intrinsic;
};




var $c78e98e0207f6b0c$var$$Map = $8a6f70dce0df97e8$exports('%Map%', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => V} */ var $c78e98e0207f6b0c$var$$mapGet = $56ab543db247e074$exports('Map.prototype.get', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K, value: V) => void} */ var $c78e98e0207f6b0c$var$$mapSet = $56ab543db247e074$exports('Map.prototype.set', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $c78e98e0207f6b0c$var$$mapHas = $56ab543db247e074$exports('Map.prototype.has', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $c78e98e0207f6b0c$var$$mapDelete = $56ab543db247e074$exports('Map.prototype.delete', true);
/** @type {<K, V>(thisArg: Map<K, V>) => number} */ var $c78e98e0207f6b0c$var$$mapSize = $56ab543db247e074$exports('Map.prototype.size', true);
/** @type {import('.')} */ $c78e98e0207f6b0c$exports = !!$c78e98e0207f6b0c$var$$Map && /** @type {Exclude<import('.'), false>} */ function getSideChannelMap() {
    /** @typedef {ReturnType<typeof getSideChannelMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {Map<K, V> | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $dc13161a3c098f6a$exports('Side channel does not contain ' + $25ad6d8cff92dbf8$exports(key));
        },
        'delete': function(key) {
            if ($m) {
                var result = $c78e98e0207f6b0c$var$$mapDelete($m, key);
                if ($c78e98e0207f6b0c$var$$mapSize($m) === 0) $m = void 0;
                return result;
            }
            return false;
        },
        get: function(key) {
            if ($m) return $c78e98e0207f6b0c$var$$mapGet($m, key);
        },
        has: function(key) {
            if ($m) return $c78e98e0207f6b0c$var$$mapHas($m, key);
            return false;
        },
        set: function(key, value) {
            if (!$m) // @ts-expect-error TS can't handle narrowing a variable inside a closure
            $m = new $c78e98e0207f6b0c$var$$Map();
            $c78e98e0207f6b0c$var$$mapSet($m, key, value);
        }
    };
    // @ts-expect-error TODO: figure out why TS is erroring here
    return channel;
};


var $066e8d7761046118$exports = {};
'use strict';





var $066e8d7761046118$var$$WeakMap = $8a6f70dce0df97e8$exports('%WeakMap%', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => V} */ var $066e8d7761046118$var$$weakMapGet = $56ab543db247e074$exports('WeakMap.prototype.get', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K, value: V) => void} */ var $066e8d7761046118$var$$weakMapSet = $56ab543db247e074$exports('WeakMap.prototype.set', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $066e8d7761046118$var$$weakMapHas = $56ab543db247e074$exports('WeakMap.prototype.has', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $066e8d7761046118$var$$weakMapDelete = $56ab543db247e074$exports('WeakMap.prototype.delete', true);
/** @type {import('.')} */ $066e8d7761046118$exports = $066e8d7761046118$var$$WeakMap ? /** @type {Exclude<import('.'), false>} */ function getSideChannelWeakMap() {
    /** @typedef {ReturnType<typeof getSideChannelWeakMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {WeakMap<K & object, V> | undefined} */ var $wm;
    /** @type {Channel | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $dc13161a3c098f6a$exports('Side channel does not contain ' + $25ad6d8cff92dbf8$exports(key));
        },
        'delete': function(key) {
            if ($066e8d7761046118$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $066e8d7761046118$var$$weakMapDelete($wm, key);
            } else if ($c78e98e0207f6b0c$exports) {
                if ($m) return $m['delete'](key);
            }
            return false;
        },
        get: function(key) {
            if ($066e8d7761046118$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $066e8d7761046118$var$$weakMapGet($wm, key);
            }
            return $m && $m.get(key);
        },
        has: function(key) {
            if ($066e8d7761046118$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $066e8d7761046118$var$$weakMapHas($wm, key);
            }
            return !!$m && $m.has(key);
        },
        set: function(key, value) {
            if ($066e8d7761046118$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if (!$wm) $wm = new $066e8d7761046118$var$$WeakMap();
                $066e8d7761046118$var$$weakMapSet($wm, key, value);
            } else if ($c78e98e0207f6b0c$exports) {
                if (!$m) $m = $c78e98e0207f6b0c$exports();
                // eslint-disable-next-line no-extra-parens
                /** @type {NonNullable<typeof $m>} */ $m.set(key, value);
            }
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
} : $c78e98e0207f6b0c$exports;


var $7e2b00aa2e6a83f2$var$makeChannel = $066e8d7761046118$exports || $c78e98e0207f6b0c$exports || $9f7a21e35ed54df2$exports;
/** @type {import('.')} */ $7e2b00aa2e6a83f2$exports = function getSideChannel() {
    /** @typedef {ReturnType<typeof getSideChannel>} Channel */ /** @type {Channel | undefined} */ var $channelData;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $dc13161a3c098f6a$exports('Side channel does not contain ' + $25ad6d8cff92dbf8$exports(key));
        },
        'delete': function(key) {
            return !!$channelData && $channelData['delete'](key);
        },
        get: function(key) {
            return $channelData && $channelData.get(key);
        },
        has: function(key) {
            return !!$channelData && $channelData.has(key);
        },
        set: function(key, value) {
            if (!$channelData) $channelData = $7e2b00aa2e6a83f2$var$makeChannel();
            $channelData.set(key, value);
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
};


var $58464918b7a3708a$exports = {};
'use strict';
var $c60b95175c1115d7$exports = {};
'use strict';
var $c60b95175c1115d7$var$replace = String.prototype.replace;
var $c60b95175c1115d7$var$percentTwenties = /%20/g;
var $c60b95175c1115d7$var$Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};
$c60b95175c1115d7$exports = {
    'default': $c60b95175c1115d7$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $c60b95175c1115d7$var$replace.call(value, $c60b95175c1115d7$var$percentTwenties, '+');
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: $c60b95175c1115d7$var$Format.RFC1738,
    RFC3986: $c60b95175c1115d7$var$Format.RFC3986
};


var $58464918b7a3708a$var$has = Object.prototype.hasOwnProperty;
var $58464918b7a3708a$var$isArray = Array.isArray;
var $58464918b7a3708a$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    return array;
}();
var $58464918b7a3708a$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($58464918b7a3708a$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== 'undefined') compacted.push(obj[j]);
            item.obj[item.prop] = compacted;
        }
    }
};
var $58464918b7a3708a$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? {
        __proto__: null
    } : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== 'undefined') obj[i] = source[i];
    return obj;
};
var $58464918b7a3708a$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== 'object' && typeof source !== 'function') {
        if ($58464918b7a3708a$var$isArray(target)) target.push(source);
        else if (target && typeof target === 'object') {
            if (options && (options.plainObjects || options.allowPrototypes) || !$58464918b7a3708a$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== 'object') return [
        target
    ].concat(source);
    var mergeTarget = target;
    if ($58464918b7a3708a$var$isArray(target) && !$58464918b7a3708a$var$isArray(source)) mergeTarget = $58464918b7a3708a$var$arrayToObject(target, options);
    if ($58464918b7a3708a$var$isArray(target) && $58464918b7a3708a$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($58464918b7a3708a$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') target[i] = merge(targetItem, item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($58464918b7a3708a$var$has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
};
var $58464918b7a3708a$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var $58464918b7a3708a$var$decode = function(str, defaultDecoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $58464918b7a3708a$var$limit = 1024;
/* eslint operator-linebreak: [2, "before"] */ var $58464918b7a3708a$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === 'symbol') string = Symbol.prototype.toString.call(str);
    else if (typeof str !== 'string') string = String(str);
    if (charset === 'iso-8859-1') return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
    });
    var out = '';
    for(var j = 0; j < string.length; j += $58464918b7a3708a$var$limit){
        var segment = string.length >= $58464918b7a3708a$var$limit ? string.slice(j, j + $58464918b7a3708a$var$limit) : string;
        var arr = [];
        for(var i = 0; i < segment.length; ++i){
            var c = segment.charCodeAt(i);
            if (c === 0x2D // -
             || c === 0x2E // .
             || c === 0x5F // _
             || c === 0x7E // ~
             || c >= 0x30 && c <= 0x39 // 0-9
             || c >= 0x41 && c <= 0x5A // a-z
             || c >= 0x61 && c <= 0x7A // A-Z
             || format === $c60b95175c1115d7$exports.RFC1738 && (c === 0x28 || c === 0x29) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }
            if (c < 0x80) {
                arr[arr.length] = $58464918b7a3708a$var$hexTable[c];
                continue;
            }
            if (c < 0x800) {
                arr[arr.length] = $58464918b7a3708a$var$hexTable[0xC0 | c >> 6] + $58464918b7a3708a$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = $58464918b7a3708a$var$hexTable[0xE0 | c >> 12] + $58464918b7a3708a$var$hexTable[0x80 | c >> 6 & 0x3F] + $58464918b7a3708a$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            i += 1;
            c = 0x10000 + ((c & 0x3FF) << 10 | segment.charCodeAt(i) & 0x3FF);
            arr[arr.length] = $58464918b7a3708a$var$hexTable[0xF0 | c >> 18] + $58464918b7a3708a$var$hexTable[0x80 | c >> 12 & 0x3F] + $58464918b7a3708a$var$hexTable[0x80 | c >> 6 & 0x3F] + $58464918b7a3708a$var$hexTable[0x80 | c & 0x3F];
        }
        out += arr.join('');
    }
    return out;
};
var $58464918b7a3708a$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: 'o'
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                    obj: obj,
                    prop: key
                });
                refs.push(val);
            }
        }
    }
    $58464918b7a3708a$var$compactQueue(queue);
    return value;
};
var $58464918b7a3708a$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};
var $58464918b7a3708a$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $58464918b7a3708a$var$combine = function combine(a, b) {
    return [].concat(a, b);
};
var $58464918b7a3708a$var$maybeMap = function maybeMap(val, fn) {
    if ($58464918b7a3708a$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped.push(fn(val[i]));
        return mapped;
    }
    return fn(val);
};
$58464918b7a3708a$exports = {
    arrayToObject: $58464918b7a3708a$var$arrayToObject,
    assign: $58464918b7a3708a$var$assign,
    combine: $58464918b7a3708a$var$combine,
    compact: $58464918b7a3708a$var$compact,
    decode: $58464918b7a3708a$var$decode,
    encode: $58464918b7a3708a$var$encode,
    isBuffer: $58464918b7a3708a$var$isBuffer,
    isRegExp: $58464918b7a3708a$var$isRegExp,
    maybeMap: $58464918b7a3708a$var$maybeMap,
    merge: $58464918b7a3708a$var$merge
};



var $3399a7ea5d40d8d8$var$has = Object.prototype.hasOwnProperty;
var $3399a7ea5d40d8d8$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $3399a7ea5d40d8d8$var$isArray = Array.isArray;
var $3399a7ea5d40d8d8$var$push = Array.prototype.push;
var $3399a7ea5d40d8d8$var$pushToArray = function(arr, valueOrArray) {
    $3399a7ea5d40d8d8$var$push.apply(arr, $3399a7ea5d40d8d8$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $3399a7ea5d40d8d8$var$toISO = Date.prototype.toISOString;
var $3399a7ea5d40d8d8$var$defaultFormat = $c60b95175c1115d7$exports.default;
var $3399a7ea5d40d8d8$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: 'indices',
    charset: 'utf-8',
    charsetSentinel: false,
    commaRoundTrip: false,
    delimiter: '&',
    encode: true,
    encodeDotInKeys: false,
    encoder: $58464918b7a3708a$exports.encode,
    encodeValuesOnly: false,
    filter: void 0,
    format: $3399a7ea5d40d8d8$var$defaultFormat,
    formatter: $c60b95175c1115d7$exports.formatters[$3399a7ea5d40d8d8$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $3399a7ea5d40d8d8$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $3399a7ea5d40d8d8$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean' || typeof v === 'symbol' || typeof v === 'bigint';
};
var $3399a7ea5d40d8d8$var$sentinel = {};
var $3399a7ea5d40d8d8$var$stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    var obj = object;
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get($3399a7ea5d40d8d8$var$sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) throw new RangeError('Cyclic object value');
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get($3399a7ea5d40d8d8$var$sentinel) === 'undefined') step = 0;
    }
    if (typeof filter === 'function') obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === 'comma' && $3399a7ea5d40d8d8$var$isArray(obj)) obj = $58464918b7a3708a$exports.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, $3399a7ea5d40d8d8$var$defaults.encoder, charset, 'key', format) : prefix;
        obj = '';
    }
    if ($3399a7ea5d40d8d8$var$isNonNullishPrimitive(obj) || $58464918b7a3708a$exports.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $3399a7ea5d40d8d8$var$defaults.encoder, charset, 'key', format);
            return [
                formatter(keyValue) + '=' + formatter(encoder(obj, $3399a7ea5d40d8d8$var$defaults.encoder, charset, 'value', format))
            ];
        }
        return [
            formatter(prefix) + '=' + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === 'undefined') return values;
    var objKeys;
    if (generateArrayPrefix === 'comma' && $3399a7ea5d40d8d8$var$isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) obj = $58464918b7a3708a$exports.maybeMap(obj, encoder);
        objKeys = [
            {
                value: obj.length > 0 ? obj.join(',') || null : void 0
            }
        ];
    } else if ($3399a7ea5d40d8d8$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    var encodedPrefix = encodeDotInKeys ? String(prefix).replace(/\./g, '%2E') : String(prefix);
    var adjustedPrefix = commaRoundTrip && $3399a7ea5d40d8d8$var$isArray(obj) && obj.length === 1 ? encodedPrefix + '[]' : encodedPrefix;
    if (allowEmptyArrays && $3399a7ea5d40d8d8$var$isArray(obj) && obj.length === 0) return adjustedPrefix + '[]';
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === 'object' && key && typeof key.value !== 'undefined' ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var encodedKey = allowDots && encodeDotInKeys ? String(key).replace(/\./g, '%2E') : String(key);
        var keyPrefix = $3399a7ea5d40d8d8$var$isArray(obj) ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix : adjustedPrefix + (allowDots ? '.' + encodedKey : '[' + encodedKey + ']');
        sideChannel.set(object, step);
        var valueSideChannel = $7e2b00aa2e6a83f2$exports();
        valueSideChannel.set($3399a7ea5d40d8d8$var$sentinel, sideChannel);
        $3399a7ea5d40d8d8$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, generateArrayPrefix === 'comma' && encodeValuesOnly && $3399a7ea5d40d8d8$var$isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }
    return values;
};
var $3399a7ea5d40d8d8$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $3399a7ea5d40d8d8$var$defaults;
    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    if (typeof opts.encodeDotInKeys !== 'undefined' && typeof opts.encodeDotInKeys !== 'boolean') throw new TypeError('`encodeDotInKeys` option can only be `true` or `false`, when provided');
    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') throw new TypeError('Encoder has to be a function.');
    var charset = opts.charset || $3399a7ea5d40d8d8$var$defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    var format = $c60b95175c1115d7$exports.default;
    if (typeof opts.format !== 'undefined') {
        if (!$3399a7ea5d40d8d8$var$has.call($c60b95175c1115d7$exports.formatters, opts.format)) throw new TypeError('Unknown format option provided.');
        format = opts.format;
    }
    var formatter = $c60b95175c1115d7$exports.formatters[format];
    var filter = $3399a7ea5d40d8d8$var$defaults.filter;
    if (typeof opts.filter === 'function' || $3399a7ea5d40d8d8$var$isArray(opts.filter)) filter = opts.filter;
    var arrayFormat;
    if (opts.arrayFormat in $3399a7ea5d40d8d8$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if ('indices' in opts) arrayFormat = opts.indices ? 'indices' : 'repeat';
    else arrayFormat = $3399a7ea5d40d8d8$var$defaults.arrayFormat;
    if ('commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    var allowDots = typeof opts.allowDots === 'undefined' ? opts.encodeDotInKeys === true ? true : $3399a7ea5d40d8d8$var$defaults.allowDots : !!opts.allowDots;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : $3399a7ea5d40d8d8$var$defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : $3399a7ea5d40d8d8$var$defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $3399a7ea5d40d8d8$var$defaults.charsetSentinel,
        commaRoundTrip: !!opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === 'undefined' ? $3399a7ea5d40d8d8$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : $3399a7ea5d40d8d8$var$defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === 'boolean' ? opts.encodeDotInKeys : $3399a7ea5d40d8d8$var$defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : $3399a7ea5d40d8d8$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : $3399a7ea5d40d8d8$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : $3399a7ea5d40d8d8$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : $3399a7ea5d40d8d8$var$defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $3399a7ea5d40d8d8$var$defaults.strictNullHandling
    };
};
$3399a7ea5d40d8d8$exports = function(object, opts) {
    var obj = object;
    var options = $3399a7ea5d40d8d8$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if ($3399a7ea5d40d8d8$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== 'object' || obj === null) return '';
    var generateArrayPrefix = $3399a7ea5d40d8d8$var$arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === 'comma' && options.commaRoundTrip;
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = $7e2b00aa2e6a83f2$exports();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        var value = obj[key];
        if (options.skipNulls && value === null) continue;
        $3399a7ea5d40d8d8$var$pushToArray(keys, $3399a7ea5d40d8d8$var$stringify(value, key, generateArrayPrefix, commaRoundTrip, options.allowEmptyArrays, options.strictNullHandling, options.skipNulls, options.encodeDotInKeys, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';
    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += 'utf8=%26%2310003%3B&';
        else // encodeURIComponent('✓')
        prefix += 'utf8=%E2%9C%93&';
    }
    return joined.length > 0 ? prefix + joined : '';
};


var $df670f1b11fadf59$exports = {};
'use strict';

var $df670f1b11fadf59$var$has = Object.prototype.hasOwnProperty;
var $df670f1b11fadf59$var$isArray = Array.isArray;
var $df670f1b11fadf59$var$defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: $58464918b7a3708a$exports.decode,
    delimiter: '&',
    depth: 5,
    duplicates: 'combine',
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictDepth: false,
    strictNullHandling: false,
    throwOnLimitExceeded: false
};
var $df670f1b11fadf59$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $df670f1b11fadf59$var$parseArrayValue = function(val, options, currentArrayLength) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) return val.split(',');
    if (options.throwOnLimitExceeded && currentArrayLength >= options.arrayLimit) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $df670f1b11fadf59$var$isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $df670f1b11fadf59$var$charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')
var $df670f1b11fadf59$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {
        __proto__: null
    };
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    cleanStr = cleanStr.replace(/%5B/gi, '[').replace(/%5D/gi, ']');
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, options.throwOnLimitExceeded ? limit + 1 : limit);
    if (options.throwOnLimitExceeded && parts.length > limit) throw new RangeError('Parameter limit exceeded. Only ' + limit + ' parameter' + (limit === 1 ? '' : 's') + ' allowed.');
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf('utf8=') === 0) {
            if (parts[i] === $df670f1b11fadf59$var$charsetSentinel) charset = 'utf-8';
            else if (parts[i] === $df670f1b11fadf59$var$isoSentinel) charset = 'iso-8859-1';
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
        var key;
        var val;
        if (pos === -1) {
            key = options.decoder(part, $df670f1b11fadf59$var$defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), $df670f1b11fadf59$var$defaults.decoder, charset, 'key');
            val = $58464918b7a3708a$exports.maybeMap($df670f1b11fadf59$var$parseArrayValue(part.slice(pos + 1), options, $df670f1b11fadf59$var$isArray(obj[key]) ? obj[key].length : 0), function(encodedVal) {
                return options.decoder(encodedVal, $df670f1b11fadf59$var$defaults.decoder, charset, 'value');
            });
        }
        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') val = $df670f1b11fadf59$var$interpretNumericEntities(String(val));
        if (part.indexOf('[]=') > -1) val = $df670f1b11fadf59$var$isArray(val) ? [
            val
        ] : val;
        var existing = $df670f1b11fadf59$var$has.call(obj, key);
        if (existing && options.duplicates === 'combine') obj[key] = $58464918b7a3708a$exports.combine(obj[key], val);
        else if (!existing || options.duplicates === 'last') obj[key] = val;
    }
    return obj;
};
var $df670f1b11fadf59$var$parseObject = function(chain, val, options, valuesParsed) {
    var currentArrayLength = 0;
    if (chain.length > 0 && chain[chain.length - 1] === '[]') {
        var parentKey = chain.slice(0, -1).join('');
        currentArrayLength = Array.isArray(val) && val[parentKey] ? val[parentKey].length : 0;
    }
    var leaf = valuesParsed ? val : $df670f1b11fadf59$var$parseArrayValue(val, options, currentArrayLength);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === '[]' && options.parseArrays) obj = options.allowEmptyArrays && (leaf === '' || options.strictNullHandling && leaf === null) ? [] : $58464918b7a3708a$exports.combine([], leaf);
        else {
            obj = options.plainObjects ? {
                __proto__: null
            } : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, '.') : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            if (!options.parseArrays && decodedRoot === '') obj = {
                0: leaf
            };
            else if (!isNaN(index) && root !== decodedRoot && String(index) === decodedRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (decodedRoot !== '__proto__') obj[decodedRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var $df670f1b11fadf59$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;
    // The regex chunks
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    // Get the parent
    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    // Stash the parent if it exists
    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && $df670f1b11fadf59$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(parent);
    }
    // Loop through children appending to the array until we hit depth
    var i = 0;
    while(options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        if (!options.plainObjects && $df670f1b11fadf59$var$has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) return;
        }
        keys.push(segment[1]);
    }
    // If there's a remainder, check strictDepth option for throw, else just add whatever is left
    if (segment) {
        if (options.strictDepth === true) throw new RangeError('Input depth exceeded depth option of ' + options.depth + ' and strictDepth is true');
        keys.push('[' + key.slice(segment.index) + ']');
    }
    return $df670f1b11fadf59$var$parseObject(keys, val, options, valuesParsed);
};
var $df670f1b11fadf59$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $df670f1b11fadf59$var$defaults;
    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    if (typeof opts.decodeDotInKeys !== 'undefined' && typeof opts.decodeDotInKeys !== 'boolean') throw new TypeError('`decodeDotInKeys` option can only be `true` or `false`, when provided');
    if (opts.decoder !== null && typeof opts.decoder !== 'undefined' && typeof opts.decoder !== 'function') throw new TypeError('Decoder has to be a function.');
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    if (typeof opts.throwOnLimitExceeded !== 'undefined' && typeof opts.throwOnLimitExceeded !== 'boolean') throw new TypeError('`throwOnLimitExceeded` option must be a boolean');
    var charset = typeof opts.charset === 'undefined' ? $df670f1b11fadf59$var$defaults.charset : opts.charset;
    var duplicates = typeof opts.duplicates === 'undefined' ? $df670f1b11fadf59$var$defaults.duplicates : opts.duplicates;
    if (duplicates !== 'combine' && duplicates !== 'first' && duplicates !== 'last') throw new TypeError('The duplicates option must be either combine, first, or last');
    var allowDots = typeof opts.allowDots === 'undefined' ? opts.decodeDotInKeys === true ? true : $df670f1b11fadf59$var$defaults.allowDots : !!opts.allowDots;
    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : $df670f1b11fadf59$var$defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : $df670f1b11fadf59$var$defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : $df670f1b11fadf59$var$defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : $df670f1b11fadf59$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $df670f1b11fadf59$var$defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : $df670f1b11fadf59$var$defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === 'boolean' ? opts.decodeDotInKeys : $df670f1b11fadf59$var$defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : $df670f1b11fadf59$var$defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || $58464918b7a3708a$exports.isRegExp(opts.delimiter) ? opts.delimiter : $df670f1b11fadf59$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === 'number' || opts.depth === false ? +opts.depth : $df670f1b11fadf59$var$defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : $df670f1b11fadf59$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : $df670f1b11fadf59$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : $df670f1b11fadf59$var$defaults.plainObjects,
        strictDepth: typeof opts.strictDepth === 'boolean' ? !!opts.strictDepth : $df670f1b11fadf59$var$defaults.strictDepth,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $df670f1b11fadf59$var$defaults.strictNullHandling,
        throwOnLimitExceeded: typeof opts.throwOnLimitExceeded === 'boolean' ? opts.throwOnLimitExceeded : false
    };
};
$df670f1b11fadf59$exports = function(str, opts) {
    var options = $df670f1b11fadf59$var$normalizeParseOptions(opts);
    if (str === '' || str === null || typeof str === 'undefined') return options.plainObjects ? {
        __proto__: null
    } : {};
    var tempObj = typeof str === 'string' ? $df670f1b11fadf59$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? {
        __proto__: null
    } : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $df670f1b11fadf59$var$parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = $58464918b7a3708a$exports.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return $58464918b7a3708a$exports.compact(obj);
};



$0162588c1b9666d4$exports = {
    formats: $c60b95175c1115d7$exports,
    parse: $df670f1b11fadf59$exports,
    stringify: $3399a7ea5d40d8d8$exports
};



const $6ad26d2c5d8aa841$export$ca8561d2f81b8b2f = (0, $e29db2de9829c254$export$456995facc43eda)((0, $78597906e6a0205e$export$e8ee8b3bd696a3a5));
const $6ad26d2c5d8aa841$var$handler = $6ad26d2c5d8aa841$export$ca8561d2f81b8b2f;
const $6ad26d2c5d8aa841$export$21a94553ffa41578 = async ({ username: username, password: password })=>{
    const options = {
        method: 'POST',
        headers: {
            'content-type': 'application/x-www-form-urlencoded',
            Accept: 'application/x-www-form-urlencoded'
        },
        data: (0, (/*@__PURE__*/$parcel$interopDefault($0162588c1b9666d4$exports))).stringify({
            email: username,
            password: password
        }),
        url: (0, $78597906e6a0205e$export$e8ee8b3bd696a3a5) + (0, $78597906e6a0205e$export$eb187b828ac95891).LOGIN,
        withCredentials: true
    };
    const response = await (0, (/*@__PURE__*/$parcel$interopDefault($f3d855b3ff65dabd$exports)))(options);
    const { data: data } = response.data;
    // Adding expiry date to credentials
    // const expDate = new Date()
    // expDate.setHours(expDate.getHours() + 8)
    const dataWithExpDate = {
        ...data
    };
    return dataWithExpDate;
};
const $6ad26d2c5d8aa841$export$b56c02103a352e06 = async ({ auth_hash: auth_hash })=>{
    const options = {
        method: 'POST',
        headers: {
            'content-type': 'application/x-www-form-urlencoded',
            Accept: 'application/x-www-form-urlencoded'
        },
        url: (0, $78597906e6a0205e$export$e8ee8b3bd696a3a5) + (0, $78597906e6a0205e$export$eb187b828ac95891).LOGIN_TWOFA + auth_hash,
        withCredentials: true
    };
    const response = await (0, (/*@__PURE__*/$parcel$interopDefault($f3d855b3ff65dabd$exports)))(options);
    const { data: data } = response;
    // Adding expiry date to credentials
    const expDate = new Date();
    expDate.setHours(expDate.getHours() + 8);
    const dataWithExpDate = {
        ...data,
        expiry: expDate
    };
    return dataWithExpDate;
};
const $6ad26d2c5d8aa841$export$2b57438882a34a35 = async ({ label: label, scopes: scopes, allowed_ips: allowed_ips, expires: expires })=>{
    let allowedIPs = [];
    if (allowed_ips) allowedIPs = allowed_ips?.split(',');
    const response = await $6ad26d2c5d8aa841$var$handler.post((0, $78597906e6a0205e$export$eb187b828ac95891).GENERATE_INTEGRATION_TOKEN, {
        label: label,
        scopes: scopes,
        allowed_ips: allowedIPs,
        expires: expires
    });
    const { data: data } = response.data;
    return data;
};
const $6ad26d2c5d8aa841$export$a1374b603f3ed5e1 = async ()=>{
    const response = await $6ad26d2c5d8aa841$var$handler.get((0, $78597906e6a0205e$export$eb187b828ac95891).LIST_INTEGRATION_TOKENS);
    const { data: data } = response.data;
    return data;
};
const $6ad26d2c5d8aa841$export$50141a532c4047df = async ({ jti: jti })=>{
    const response = await $6ad26d2c5d8aa841$var$handler.post((0, $78597906e6a0205e$export$eb187b828ac95891).REVOKE_INTEGRATION_TOKEN, {
        jti: jti
    });
    const { data: data } = response.data;
    return data;
};
const $6ad26d2c5d8aa841$export$cc8b22ac490785da = async ({ token: token })=>{
    const response = await $6ad26d2c5d8aa841$var$handler.post((0, $78597906e6a0205e$export$eb187b828ac95891).ROTATE_INTEGRATION_TOKEN, {
        token: token
    });
    const { data: data } = response.data;
    return data;
};


var $60a1a1e5035aa390$export$2e2bcd8739ae039 = ()=>{
    const { mutate: loginUser, data: loginUserData, error: loginUserError, isLoading: isLoginUserLoading, isSuccess: isLoginUserSuccess, isError: isLoginUserError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $6ad26d2c5d8aa841$export$21a94553ffa41578));
    // credentials and isloggedin are set in the loginform component
    return {
        loginUser: loginUser,
        loginUserData: loginUserData,
        loginUserError: loginUserError,
        isLoginUserLoading: isLoginUserLoading,
        isLoginUserSuccess: isLoginUserSuccess,
        isLoginUserError: isLoginUserError
    };
};




var $62a96b9abbbbd0e0$export$2e2bcd8739ae039 = ()=>{
    const { mutate: loginUserTwoFa, data: loginUserTwoFaData, error: loginUserTwoFaError, isLoading: isLoginUserTwoFaLoading, isSuccess: isLoginUserTwoFaSuccess, isError: isLoginUserTwoFaError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $6ad26d2c5d8aa841$export$b56c02103a352e06));
    // credentials and isloggedin are set in the loginform component
    return {
        loginUserTwoFa: loginUserTwoFa,
        loginUserTwoFaData: loginUserTwoFaData,
        loginUserTwoFaError: loginUserTwoFaError,
        isLoginUserTwoFaLoading: isLoginUserTwoFaLoading,
        isLoginUserTwoFaSuccess: isLoginUserTwoFaSuccess,
        isLoginUserTwoFaError: isLoginUserTwoFaError
    };
};


var $0deb6bc4614da688$export$2e2bcd8739ae039 = ()=>{
    const logoutUser = async ()=>{
        await localStorage.setItem('isLoggedIn', 'false');
        await localStorage.setItem('userCredentials', '{}');
        await localStorage.setItem('reportStrings', '[]');
        await localStorage.setItem('reportTitles', '[]');
        window.location.replace(window.location.origin);
    };
    return {
        logoutUser: logoutUser
    };
};




var $11eaeccab69ae654$export$2e2bcd8739ae039 = ()=>{
    const { mutate: generateIntegrationToken, data: generateIntegrationTokenData, error: generateIntegrationTokenError, isLoading: isGenerateIntegrationTokenLoading, isSuccess: isGenerateIntegrationTokenSuccess, isError: isGenerateIntegrationTokenError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $6ad26d2c5d8aa841$export$2b57438882a34a35));
    // credentials and isloggedin are set in the loginform component
    return {
        generateIntegrationToken: generateIntegrationToken,
        generateIntegrationTokenData: generateIntegrationTokenData,
        generateIntegrationTokenError: generateIntegrationTokenError,
        isGenerateIntegrationTokenLoading: isGenerateIntegrationTokenLoading,
        isGenerateIntegrationTokenSuccess: isGenerateIntegrationTokenSuccess,
        isGenerateIntegrationTokenError: isGenerateIntegrationTokenError
    };
};




var $6b4647dec9d64fa3$export$2e2bcd8739ae039 = ()=>{
    const { mutate: listIntegrationToken, data: listIntegrationTokenData, error: listIntegrationTokenError, isLoading: isListIntegrationTokenLoading, isSuccess: isListIntegrationTokenSuccess, isError: isListIntegrationTokenError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $6ad26d2c5d8aa841$export$a1374b603f3ed5e1));
    // credentials and isloggedin are set in the loginform component
    return {
        listIntegrationToken: listIntegrationToken,
        listIntegrationTokenData: listIntegrationTokenData,
        listIntegrationTokenError: listIntegrationTokenError,
        isListIntegrationTokenLoading: isListIntegrationTokenLoading,
        isListIntegrationTokenSuccess: isListIntegrationTokenSuccess,
        isListIntegrationTokenError: isListIntegrationTokenError
    };
};




var $6e0dfcacffe2f6c7$export$2e2bcd8739ae039 = ()=>{
    const { mutate: revokeIntegrationToken, data: revokeIntegrationTokenData, error: revokeIntegrationTokenError, isLoading: isRevokeIntegrationTokenLoading, isSuccess: isRevokeIntegrationTokenSuccess, isError: isRevokeIntegrationTokenError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $6ad26d2c5d8aa841$export$50141a532c4047df));
    // credentials and isloggedin are set in the loginform component
    return {
        revokeIntegrationToken: revokeIntegrationToken,
        revokeIntegrationTokenData: revokeIntegrationTokenData,
        revokeIntegrationTokenError: revokeIntegrationTokenError,
        isRevokeIntegrationTokenLoading: isRevokeIntegrationTokenLoading,
        isRevokeIntegrationTokenSuccess: isRevokeIntegrationTokenSuccess,
        isRevokeIntegrationTokenError: isRevokeIntegrationTokenError
    };
};




var $5e81b66a2caf1984$export$2e2bcd8739ae039 = ()=>{
    const { mutate: rotateIntegrationToken, data: rotateIntegrationTokenData, error: rotateIntegrationTokenError, isLoading: isRotateIntegrationTokenLoading, isSuccess: isRotateIntegrationTokenSuccess, isError: isRotateIntegrationTokenError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $6ad26d2c5d8aa841$export$cc8b22ac490785da));
    // credentials and isloggedin are set in the loginform component
    return {
        rotateIntegrationToken: rotateIntegrationToken,
        rotateIntegrationTokenData: rotateIntegrationTokenData,
        rotateIntegrationTokenError: rotateIntegrationTokenError,
        isRotateIntegrationTokenLoading: isRotateIntegrationTokenLoading,
        isRotateIntegrationTokenSuccess: isRotateIntegrationTokenSuccess,
        isRotateIntegrationTokenError: isRotateIntegrationTokenError
    };
};





const $ea63ca8fb15c18da$export$ca8561d2f81b8b2f = (0, $e29db2de9829c254$export$456995facc43eda)((0, $78597906e6a0205e$export$a675fe6880411505));
const $ea63ca8fb15c18da$var$handler = $ea63ca8fb15c18da$export$ca8561d2f81b8b2f;
const $ea63ca8fb15c18da$export$e60dde0f38d571d2 = async ({ old_password: old_password, new_password: new_password })=>{
    const response = await $ea63ca8fb15c18da$var$handler.patch((0, $78597906e6a0205e$export$b402d7362f47010f).UPDATE_USER_PASSWORD, {
        old_password: old_password,
        new_password: new_password
    });
    const { data: data } = response.data;
    return data;
};
const $ea63ca8fb15c18da$export$a4c3d56613a57187 = async ({ email: email })=>{
    const response = await (0, $e29db2de9829c254$export$170e87424a0d64a3).get((0, $78597906e6a0205e$export$b402d7362f47010f).RESET_PASSWORD, {
        params: {
            email: email
        }
    });
    const { data: data } = response.data;
    return data;
};
const $ea63ca8fb15c18da$export$6cf5d5fc48c35236 = async ({ password: password, token: token })=>{
    const response = await (0, $e29db2de9829c254$export$170e87424a0d64a3).post(`${(0, $78597906e6a0205e$export$b402d7362f47010f).RESET_PASSWORD_CONFIRM}${token}`, {
        password: password
    });
    const { data: data } = response.data;
    return data;
};
const $ea63ca8fb15c18da$export$434542c5c5548d18 = async ({ user_id: user_id })=>{
    // const customAuthAxios = createAxiosInstance(BASE_URL)
    const response = await $ea63ca8fb15c18da$export$ca8561d2f81b8b2f.get((0, $78597906e6a0205e$export$b402d7362f47010f).GET_USER + user_id);
    const { data: data } = response.data;
    return data;
};
const $ea63ca8fb15c18da$export$eab417cdc13a30c0 = async ({ token: token, email: email, password: password, phone: phone, name_first: name_first, name_last: name_last, timezone_code: timezone_code })=>{
    const response = await (0, $e29db2de9829c254$export$170e87424a0d64a3).post(`${(0, $78597906e6a0205e$export$b402d7362f47010f).REGISTER}/${token}`, {
        token: token,
        email: email,
        password: password,
        phone: phone,
        name_first: name_first,
        name_last: name_last,
        timezone_code: timezone_code
    });
    const { data: data } = response.data;
    return data;
};
const $ea63ca8fb15c18da$export$29548a0b1170c98 = async ({ email: email, password: password, name_first: name_first, name_last: name_last })=>{
    const response = await (0, $e29db2de9829c254$export$170e87424a0d64a3).post(`${(0, $78597906e6a0205e$export$b402d7362f47010f).SIGNUP_TRIAL}`, {
        email: email,
        password: password,
        name_first: name_first,
        name_last: name_last
    });
    const { data: data } = response.data;
    return data;
};
const $ea63ca8fb15c18da$export$9db89bdfbf54cda1 = async ({ hash: hash })=>{
    const response = await (0, $e29db2de9829c254$export$170e87424a0d64a3).post(`${(0, $78597906e6a0205e$export$b402d7362f47010f).CONFIRMATION_TRIAL}/${hash}`);
    const { data: data } = response.data;
    return data;
};
const $ea63ca8fb15c18da$export$22ad4736ebe3cd69 = async (hash)=>{
    const response = await (0, $e29db2de9829c254$export$170e87424a0d64a3).get(`${(0, $78597906e6a0205e$export$b402d7362f47010f).VASP_INFO}/${hash}`);
    const { data: data } = response.data;
    return data;
};
const $ea63ca8fb15c18da$export$f33ddeeedd351784 = async ({ hash: hash })=>{
    const response = await (0, $e29db2de9829c254$export$170e87424a0d64a3).post(`${(0, $78597906e6a0205e$export$b402d7362f47010f).CONFIRM_VASP_EMAIL}/${hash}`, {
        hash: hash
    });
    const { data: data } = response.data;
    return data;
};
const $ea63ca8fb15c18da$export$cad67211ead0a330 = async ({ hash: hash })=>{
    const response = await (0, $e29db2de9829c254$export$170e87424a0d64a3).post(`${(0, $78597906e6a0205e$export$b402d7362f47010f).CONFIRM_VASP_USER_EMAIL}/${hash}`, {
        hash: hash
    });
    const { data: data } = response.data;
    return data;
};
const $ea63ca8fb15c18da$export$21aa6c0d341cf72c = async ({ hash: hash })=>{
    const response = await (0, $e29db2de9829c254$export$170e87424a0d64a3).get(`${(0, $78597906e6a0205e$export$b402d7362f47010f).GET_USER_AUTH}${hash}`);
    const { data: data } = response.data;
    return data;
};


var $a936c5d5952f6da8$export$2e2bcd8739ae039 = ()=>{
    const { mutate: updatePassword, data: updatePasswordData, error: updatePasswordError, isLoading: isUpdatePasswordLoading, isSuccess: isUpdatePasswordSuccess, isError: isUpdatePasswordError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $ea63ca8fb15c18da$export$e60dde0f38d571d2));
    return {
        updatePassword: updatePassword,
        updatePasswordData: updatePasswordData,
        updatePasswordError: updatePasswordError,
        isUpdatePasswordLoading: isUpdatePasswordLoading,
        isUpdatePasswordSuccess: isUpdatePasswordSuccess,
        isUpdatePasswordError: isUpdatePasswordError
    };
};




var $89db55cadf8da1af$export$2e2bcd8739ae039 = ()=>{
    const { mutate: getUser, data: getUserData, error: getUserError, isLoading: isGetUserLoading, isSuccess: isGetUserSuccess, isError: isGetUserError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $ea63ca8fb15c18da$export$434542c5c5548d18));
    return {
        getUser: getUser,
        getUserData: getUserData,
        getUserError: getUserError,
        isGetUserLoading: isGetUserLoading,
        isGetUserSuccess: isGetUserSuccess,
        isGetUserError: isGetUserError
    };
};




var $bba0636364ff0ea7$export$2e2bcd8739ae039 = ()=>{
    const { mutate: getUserAuth, data: getUserAuthData, error: getUserAuthError, isLoading: isGetUserAuthLoading, isSuccess: isGetUserAuthSuccess, isError: isGetUserAuthError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $ea63ca8fb15c18da$export$21aa6c0d341cf72c));
    return {
        getUserAuth: getUserAuth,
        getUserAuthData: getUserAuthData,
        getUserAuthError: getUserAuthError,
        isGetUserAuthLoading: isGetUserAuthLoading,
        isGetUserAuthSuccess: isGetUserAuthSuccess,
        isGetUserAuthError: isGetUserAuthError
    };
};




var $48192aaec7d40b32$export$2e2bcd8739ae039 = ()=>{
    const { mutate: signupVasp, data: signupVaspData, error: signupVaspError, isLoading: isSignupVaspLoading, isSuccess: isSignupVaspSuccess, isError: isSignupVaspError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $ea63ca8fb15c18da$export$eab417cdc13a30c0));
    return {
        signupVasp: signupVasp,
        signupVaspData: signupVaspData,
        signupVaspError: signupVaspError,
        isSignupVaspLoading: isSignupVaspLoading,
        isSignupVaspSuccess: isSignupVaspSuccess,
        isSignupVaspError: isSignupVaspError
    };
};




var $1750dcd47d6b0418$export$2e2bcd8739ae039 = ()=>{
    const { mutate: signupTrial, data: signupTrialData, error: signupTrialError, isLoading: isSignupTrialLoading, isSuccess: isSignupTrialSuccess, isError: isSignupTrialError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $ea63ca8fb15c18da$export$29548a0b1170c98));
    return {
        signupTrial: signupTrial,
        signupTrialData: signupTrialData,
        signupTrialError: signupTrialError,
        isSignupTrialLoading: isSignupTrialLoading,
        isSignupTrialSuccess: isSignupTrialSuccess,
        isSignupTrialError: isSignupTrialError
    };
};




var $c03088c2ae29c40a$export$2e2bcd8739ae039 = ()=>{
    const { mutate: getVaspInfo, data: getVaspInfoData, error: getVaspInfoError, isLoading: isGetVaspInfoLoading, isSuccess: isGetVaspInfoSuccess, isError: isGetVaspInfoError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $ea63ca8fb15c18da$export$22ad4736ebe3cd69));
    return {
        getVaspInfo: getVaspInfo,
        getVaspInfoData: getVaspInfoData,
        getVaspInfoError: getVaspInfoError,
        isGetVaspInfoLoading: isGetVaspInfoLoading,
        isGetVaspInfoSuccess: isGetVaspInfoSuccess,
        isGetVaspInfoError: isGetVaspInfoError
    };
};




var $d538b04748fc7bbd$export$2e2bcd8739ae039 = ()=>{
    const { mutate: confirmVaspEmail, data: confirmVaspEmailData, error: confirmVaspEmailError, isLoading: isConfirmVaspEmailLoading, isSuccess: isConfirmVaspEmailSuccess, isError: isConfirmVaspEmailError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $ea63ca8fb15c18da$export$f33ddeeedd351784));
    return {
        confirmVaspEmail: confirmVaspEmail,
        confirmVaspEmailData: confirmVaspEmailData,
        confirmVaspEmailError: confirmVaspEmailError,
        isConfirmVaspEmailLoading: isConfirmVaspEmailLoading,
        isConfirmVaspEmailSuccess: isConfirmVaspEmailSuccess,
        isConfirmVaspEmailError: isConfirmVaspEmailError
    };
};




var $975bad910b51ddbd$export$2e2bcd8739ae039 = ()=>{
    const { mutate: confirmVaspUserEmail, data: confirmVaspUserEmailData, error: confirmVaspUserEmailError, isLoading: isConfirmVaspUserEmailLoading, isSuccess: isConfirmVaspUserEmailSuccess, isError: isConfirmVaspUserEmailError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $ea63ca8fb15c18da$export$cad67211ead0a330));
    return {
        confirmVaspUserEmail: confirmVaspUserEmail,
        confirmVaspUserEmailData: confirmVaspUserEmailData,
        confirmVaspUserEmailError: confirmVaspUserEmailError,
        isConfirmVaspUserEmailLoading: isConfirmVaspUserEmailLoading,
        isConfirmVaspUserEmailSuccess: isConfirmVaspUserEmailSuccess,
        isConfirmVaspUserEmailError: isConfirmVaspUserEmailError
    };
};




var $29611548b91f6074$export$2e2bcd8739ae039 = ()=>{
    const { mutate: confirmTrialAccount, data: confirmTrialAccountData, error: confirmTrialAccountError, isLoading: isConfirmTrialAccountLoading, isSuccess: isConfirmTrialAccountSuccess, isError: isConfirmTrialAccountError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $ea63ca8fb15c18da$export$9db89bdfbf54cda1));
    return {
        confirmTrialAccount: confirmTrialAccount,
        confirmTrialAccountData: confirmTrialAccountData,
        confirmTrialAccountError: confirmTrialAccountError,
        isConfirmTrialAccountLoading: isConfirmTrialAccountLoading,
        isConfirmTrialAccountSuccess: isConfirmTrialAccountSuccess,
        isConfirmTrialAccountError: isConfirmTrialAccountError
    };
};




var $5e0e8fcf70b29f3d$export$2e2bcd8739ae039 = ()=>{
    const { mutate: resetPassword, data: resetPasswordData, error: resetPasswordError, isLoading: isResetPasswordLoading, isSuccess: isResetPasswordSuccess, isError: isResetPasswordError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $ea63ca8fb15c18da$export$a4c3d56613a57187));
    return {
        resetPassword: resetPassword,
        resetPasswordData: resetPasswordData,
        resetPasswordError: resetPasswordError,
        isResetPasswordLoading: isResetPasswordLoading,
        isResetPasswordSuccess: isResetPasswordSuccess,
        isResetPasswordError: isResetPasswordError
    };
};




var $27afff305f9efdee$export$2e2bcd8739ae039 = ()=>{
    const { mutate: resetPasswordConfirm, data: resetPasswordConfirmData, error: resetPasswordConfirmError, isLoading: isResetPasswordConfirmLoading, isSuccess: isResetPasswordConfirmSuccess, isError: isResetPasswordConfirmError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $ea63ca8fb15c18da$export$6cf5d5fc48c35236));
    return {
        resetPasswordConfirm: resetPasswordConfirm,
        resetPasswordConfirmData: resetPasswordConfirmData,
        resetPasswordConfirmError: resetPasswordConfirmError,
        isResetPasswordConfirmLoading: isResetPasswordConfirmLoading,
        isResetPasswordConfirmSuccess: isResetPasswordConfirmSuccess,
        isResetPasswordConfirmError: isResetPasswordConfirmError
    };
};





const $fccb717fbbb21a6a$export$ca8561d2f81b8b2f = (0, $e29db2de9829c254$export$456995facc43eda)((0, $78597906e6a0205e$export$6c611141e7030bb8));
const $fccb717fbbb21a6a$var$handler = $fccb717fbbb21a6a$export$ca8561d2f81b8b2f;
const $fccb717fbbb21a6a$export$32040ca454c75ac1 = async (values)=>{
    const response = await $fccb717fbbb21a6a$var$handler.post((0, $78597906e6a0205e$export$3a1c062261e8cd49).REQUEST_VASP, values);
    const { data: data } = response.data;
    return data;
};
const $fccb717fbbb21a6a$export$1731df2aab66fe4e = async (values)=>{
    const response = await $fccb717fbbb21a6a$var$handler.post((0, $78597906e6a0205e$export$3a1c062261e8cd49).PUSH_REQUEST_VASP, values);
    const { data: data } = response.data;
    return data;
};
const $fccb717fbbb21a6a$export$643a37a4364956db = async ({ token: token, ...rest })=>{
    const response = await (0, $e29db2de9829c254$export$170e87424a0d64a3).post(`${(0, $78597906e6a0205e$export$3a1c062261e8cd49).REGISTER_VASP}${token}`, {
        ...rest
    });
    const { data: data } = response.data;
    return data;
};
const $fccb717fbbb21a6a$export$67855005f01db386 = async ({ vasp_id: vasp_id })=>{
    const response = await $fccb717fbbb21a6a$var$handler.post(`${(0, $78597906e6a0205e$export$3a1c062261e8cd49).APPROVE_VASP}${vasp_id}`);
    const { data: data } = response.data;
    return data;
};
const $fccb717fbbb21a6a$export$b1fd3d71c31ef03d = async ({ vasp_id: vasp_id })=>{
    const response = await $fccb717fbbb21a6a$var$handler.post(`${(0, $78597906e6a0205e$export$3a1c062261e8cd49).REJECT_VASP}${vasp_id}`);
    const { data: data } = response.data;
    return data;
};
const $fccb717fbbb21a6a$export$1e9bf50bcfb77cab = async ()=>{
    const response = await $fccb717fbbb21a6a$var$handler.get((0, $78597906e6a0205e$export$3a1c062261e8cd49).GET_ALL_PROVIDERS);
    const { data: data } = response.data;
    return data;
};
const $fccb717fbbb21a6a$export$162684d6af9fc6eb = async ({ vasp_id: vasp_id })=>{
    const response = await $fccb717fbbb21a6a$var$handler.get(`${(0, $78597906e6a0205e$export$3a1c062261e8cd49).GET_VASP_PROVIDERS}${vasp_id}`);
    const { data: data } = response.data;
    return data;
};
const $fccb717fbbb21a6a$export$69c4c5e8e00435ee = async ({ vasp_id: vasp_id, ...rest })=>{
    const response = await $fccb717fbbb21a6a$var$handler.delete(`${(0, $78597906e6a0205e$export$3a1c062261e8cd49).DELETE_VASP_PROVIDERS}${vasp_id}`, {
        data: {
            ...rest
        }
    });
    const { data: data } = response.data;
    return data;
};
const $fccb717fbbb21a6a$export$180814ee19e74705 = async ({ vasp_id: vasp_id, ...rest })=>{
    const response = await $fccb717fbbb21a6a$var$handler.post(`${(0, $78597906e6a0205e$export$3a1c062261e8cd49).ADD_VASP_PROVIDERS}${vasp_id}`, {
        ...rest
    });
    const { data: data } = response.data;
    return data;
};
const $fccb717fbbb21a6a$export$5e6d7f741e66c1fc = async ({ vasp_id: vasp_id })=>{
    const response = await $fccb717fbbb21a6a$var$handler.get(`${(0, $78597906e6a0205e$export$3a1c062261e8cd49).GET_VASP_USERS}${vasp_id}`);
    const { data: data } = response.data;
    return data;
};
const $fccb717fbbb21a6a$export$65a6c2d819f88845 = async ({ vasp_id: vasp_id, ...rest })=>{
    const response = await $fccb717fbbb21a6a$var$handler.post(`${(0, $78597906e6a0205e$export$3a1c062261e8cd49).ADD_VASP_USER}${vasp_id}`, {
        ...rest
    });
    const { data: data } = response.data;
    return data;
};
const $fccb717fbbb21a6a$export$e8860436069f342 = async ({ vasp_id: vasp_id, ...rest })=>{
    const response = await $fccb717fbbb21a6a$var$handler.patch(`${(0, $78597906e6a0205e$export$3a1c062261e8cd49).UPDATE_VASP_USER}${vasp_id}`, {
        ...rest
    });
    const { data: data } = response.data;
    return data;
};
const $fccb717fbbb21a6a$export$8542c4b8da819ee1 = async ({ user_id: user_id, ...rest })=>{
    const response = await $fccb717fbbb21a6a$var$handler.post(`${(0, $78597906e6a0205e$export$3a1c062261e8cd49).ADD_VASP_USER}${user_id}`, {
        ...rest
    });
    const { data: data } = response.data;
    return data;
};


var $03c84b7634cfc367$export$2e2bcd8739ae039 = ()=>{
    const { mutate: requestVasp, data: requestVaspData, error: requestVaspError, isLoading: isRequestVaspLoading, isSuccess: isRequestVaspSuccess, isError: isRequestVaspError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $fccb717fbbb21a6a$export$32040ca454c75ac1));
    return {
        requestVasp: requestVasp,
        requestVaspData: requestVaspData,
        requestVaspError: requestVaspError,
        isRequestVaspLoading: isRequestVaspLoading,
        isRequestVaspSuccess: isRequestVaspSuccess,
        isRequestVaspError: isRequestVaspError
    };
};




var $96e283598ec52e72$export$2e2bcd8739ae039 = ()=>{
    const { mutate: pushRequestVasp, data: pushRequestVaspData, error: pushRequestVaspError, isLoading: isPushRequestVaspLoading, isSuccess: isPushRequestVaspSuccess, isError: isPushRequestVaspError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $fccb717fbbb21a6a$export$1731df2aab66fe4e));
    return {
        pushRequestVasp: pushRequestVasp,
        pushRequestVaspData: pushRequestVaspData,
        pushRequestVaspError: pushRequestVaspError,
        isPushRequestVaspLoading: isPushRequestVaspLoading,
        isPushRequestVaspSuccess: isPushRequestVaspSuccess,
        isPushRequestVaspError: isPushRequestVaspError
    };
};




var $e8d6aa5db028d98b$export$2e2bcd8739ae039 = ()=>{
    const { mutate: registerVasp, data: registerVaspData, error: registerVaspError, isLoading: isRegisterVaspLoading, isSuccess: isRegisterVaspSuccess, isError: isRegisterVaspError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $fccb717fbbb21a6a$export$643a37a4364956db));
    return {
        registerVasp: registerVasp,
        registerVaspData: registerVaspData,
        registerVaspError: registerVaspError,
        isRegisterVaspLoading: isRegisterVaspLoading,
        isRegisterVaspSuccess: isRegisterVaspSuccess,
        isRegisterVaspError: isRegisterVaspError
    };
};




var $793140d42d08c801$export$2e2bcd8739ae039 = ()=>{
    const { mutate: approveVasp, data: approveVaspData, error: approveVaspError, isLoading: isApproveVaspLoading, isSuccess: isApproveVaspSuccess, isError: isApproveVaspError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $fccb717fbbb21a6a$export$67855005f01db386));
    return {
        approveVasp: approveVasp,
        approveVaspData: approveVaspData,
        approveVaspError: approveVaspError,
        isApproveVaspLoading: isApproveVaspLoading,
        isApproveVaspSuccess: isApproveVaspSuccess,
        isApproveVaspError: isApproveVaspError
    };
};




var $8c0350c33d943d3c$export$2e2bcd8739ae039 = ()=>{
    const { mutate: rejectVasp, data: rejectVaspData, error: rejectVaspError, isLoading: isRejectVaspLoading, isSuccess: isRejectVaspSuccess, isError: isRejectVaspError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $fccb717fbbb21a6a$export$b1fd3d71c31ef03d));
    return {
        rejectVasp: rejectVasp,
        rejectVaspData: rejectVaspData,
        rejectVaspError: rejectVaspError,
        isRejectVaspLoading: isRejectVaspLoading,
        isRejectVaspSuccess: isRejectVaspSuccess,
        isRejectVaspError: isRejectVaspError
    };
};




var $76ba91f6851a4875$export$2e2bcd8739ae039 = ()=>{
    const { mutate: getAllProviders, data: getAllProvidersData, error: getAllProvidersError, isLoading: isGetAllProvidersLoading, isSuccess: isGetAllProvidersSuccess, isError: isGetAllProvidersError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $fccb717fbbb21a6a$export$1e9bf50bcfb77cab));
    return {
        getAllProviders: getAllProviders,
        getAllProvidersData: getAllProvidersData,
        getAllProvidersError: getAllProvidersError,
        isGetAllProvidersLoading: isGetAllProvidersLoading,
        isGetAllProvidersSuccess: isGetAllProvidersSuccess,
        isGetAllProvidersError: isGetAllProvidersError
    };
};




var $2fb338d0bab8cd56$export$2e2bcd8739ae039 = ()=>{
    const { mutate: getVaspProviders, data: getVaspProvidersData, error: getVaspProvidersError, isLoading: isGetVaspProvidersLoading, isSuccess: isGetVaspProvidersSuccess, isError: isGetVaspProvidersError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $fccb717fbbb21a6a$export$162684d6af9fc6eb));
    return {
        getVaspProviders: getVaspProviders,
        getVaspProvidersData: getVaspProvidersData,
        getVaspProvidersError: getVaspProvidersError,
        isGetVaspProvidersLoading: isGetVaspProvidersLoading,
        isGetVaspProvidersSuccess: isGetVaspProvidersSuccess,
        isGetVaspProvidersError: isGetVaspProvidersError
    };
};




var $9e4de34bf0e02b0b$export$2e2bcd8739ae039 = ()=>{
    const { mutate: deleteVaspProvider, data: deleteVaspProviderData, error: deleteVaspProviderError, isLoading: isDeleteVaspProviderLoading, isSuccess: isDeleteVaspProviderSuccess, isError: isDeleteVaspProviderError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $fccb717fbbb21a6a$export$69c4c5e8e00435ee));
    return {
        deleteVaspProvider: deleteVaspProvider,
        deleteVaspProviderData: deleteVaspProviderData,
        deleteVaspProviderError: deleteVaspProviderError,
        isDeleteVaspProviderLoading: isDeleteVaspProviderLoading,
        isDeleteVaspProviderSuccess: isDeleteVaspProviderSuccess,
        isDeleteVaspProviderError: isDeleteVaspProviderError
    };
};




var $2cb7e6b685ccc7d0$export$2e2bcd8739ae039 = ()=>{
    const { mutate: addVaspProvider, data: addVaspProviderData, error: addVaspProviderError, isLoading: isAddVaspProviderLoading, isSuccess: isAddVaspProviderSuccess, isError: isAddVaspProviderError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $fccb717fbbb21a6a$export$180814ee19e74705));
    return {
        addVaspProvider: addVaspProvider,
        addVaspProviderData: addVaspProviderData,
        addVaspProviderError: addVaspProviderError,
        isAddVaspProviderLoading: isAddVaspProviderLoading,
        isAddVaspProviderSuccess: isAddVaspProviderSuccess,
        isAddVaspProviderError: isAddVaspProviderError
    };
};




var $6c23fdd432274929$export$2e2bcd8739ae039 = ()=>{
    const { mutate: getVaspUsers, data: getVaspUsersData, error: getVaspUsersError, isLoading: isGetVaspUsersLoading, isSuccess: isGetVaspUsersSuccess, isError: isGetVaspUsersError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $fccb717fbbb21a6a$export$5e6d7f741e66c1fc));
    return {
        getVaspUsers: getVaspUsers,
        getVaspUsersData: getVaspUsersData,
        getVaspUsersError: getVaspUsersError,
        isGetVaspUsersLoading: isGetVaspUsersLoading,
        isGetVaspUsersSuccess: isGetVaspUsersSuccess,
        isGetVaspUsersError: isGetVaspUsersError
    };
};




var $a5d10b67cb12f506$export$2e2bcd8739ae039 = ()=>{
    const { mutate: addVaspUser, data: addVaspUserData, error: addVaspUserError, isLoading: isAddVaspUserLoading, isSuccess: isAddVaspUserSuccess, isError: isAddVaspUserError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $fccb717fbbb21a6a$export$65a6c2d819f88845));
    return {
        addVaspUser: addVaspUser,
        addVaspUserData: addVaspUserData,
        addVaspUserError: addVaspUserError,
        isAddVaspUserLoading: isAddVaspUserLoading,
        isAddVaspUserSuccess: isAddVaspUserSuccess,
        isAddVaspUserError: isAddVaspUserError
    };
};




var $bf926cd3de297aa0$export$2e2bcd8739ae039 = ()=>{
    const { mutate: updateVaspUser, data: updateVaspUserData, error: updateVaspUserError, isLoading: isUpdateVaspUserLoading, isSuccess: isUpdateVaspUserSuccess, isError: isUpdateVaspUserError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $fccb717fbbb21a6a$export$e8860436069f342));
    return {
        updateVaspUser: updateVaspUser,
        updateVaspUserData: updateVaspUserData,
        updateVaspUserError: updateVaspUserError,
        isUpdateVaspUserLoading: isUpdateVaspUserLoading,
        isUpdateVaspUserSuccess: isUpdateVaspUserSuccess,
        isUpdateVaspUserError: isUpdateVaspUserError
    };
};




var $53a6bf5de5d0cf2f$export$2e2bcd8739ae039 = ()=>{
    const { mutate: createVaspUserActivation, data: createVaspUserActivationData, error: createVaspUserActivationError, isLoading: isCreateVaspUserActivationLoading, isSuccess: isCreateVaspUserActivationSuccess, isError: isCreateVaspUserActivationError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $fccb717fbbb21a6a$export$8542c4b8da819ee1));
    return {
        createVaspUserActivation: createVaspUserActivation,
        createVaspUserActivationData: createVaspUserActivationData,
        createVaspUserActivationError: createVaspUserActivationError,
        isCreateVaspUserActivationLoading: isCreateVaspUserActivationLoading,
        isCreateVaspUserActivationSuccess: isCreateVaspUserActivationSuccess,
        isCreateVaspUserActivationError: isCreateVaspUserActivationError
    };
};





const $e391d90756f8e9ae$export$ca8561d2f81b8b2f = (0, $e29db2de9829c254$export$456995facc43eda)((0, $78597906e6a0205e$export$1deab063ed687beb));
const $e391d90756f8e9ae$var$handler = $e391d90756f8e9ae$export$ca8561d2f81b8b2f;
const $e391d90756f8e9ae$export$ee3b55f8f1d5b147 = async ({ vasp_id: vasp_id })=>{
    const response = await $e391d90756f8e9ae$var$handler.post(`${(0, $78597906e6a0205e$export$d7aecfa4e6635ed0).NOTIFY_VASP}/${vasp_id}`, {
        vasp_id: vasp_id
    });
    const { data: data } = response.data;
    return data;
};
const $e391d90756f8e9ae$export$b1fd3d71c31ef03d = async ({ vasp_id: vasp_id })=>{
    const response = await $e391d90756f8e9ae$var$handler.post(`${(0, $78597906e6a0205e$export$d7aecfa4e6635ed0).REJECT_VASP}/${vasp_id}`, {
        vasp_id: vasp_id
    });
    const { data: data } = response.data;
    return data;
};


var $16f5b51671181002$export$2e2bcd8739ae039 = ()=>{
    const { mutate: notifyVasp, data: notifyVaspData, error: notifyVaspError, isLoading: isNotifyVaspLoading, isSuccess: isNotifyVaspSuccess, isError: isNotifyVaspError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $e391d90756f8e9ae$export$ee3b55f8f1d5b147));
    return {
        notifyVasp: notifyVasp,
        notifyVaspData: notifyVaspData,
        notifyVaspError: notifyVaspError,
        isNotifyVaspLoading: isNotifyVaspLoading,
        isNotifyVaspSuccess: isNotifyVaspSuccess,
        isNotifyVaspError: isNotifyVaspError
    };
};





const { CREATE_DOCUMENT: $3b3dc4976115d601$var$CREATE_DOCUMENT, GET_DOCUMENTS: $3b3dc4976115d601$var$GET_DOCUMENTS, GET_DOCUMENT_CHUNKS: $3b3dc4976115d601$var$GET_DOCUMENT_CHUNKS, UPDATE_DOCUMENT: $3b3dc4976115d601$var$UPDATE_DOCUMENT, UPDATE_DOCUMENT_CHUNK: $3b3dc4976115d601$var$UPDATE_DOCUMENT_CHUNK, DANGEROUSLY_DELETE_DOCUMENT: $3b3dc4976115d601$var$DANGEROUSLY_DELETE_DOCUMENT } = (0, $78597906e6a0205e$export$e9d870d86e0dc706);
const $3b3dc4976115d601$export$ca8561d2f81b8b2f = (0, $e29db2de9829c254$export$456995facc43eda)((0, $78597906e6a0205e$export$831d83b74773cc50));
const $3b3dc4976115d601$var$handler = $3b3dc4976115d601$export$ca8561d2f81b8b2f;
const $3b3dc4976115d601$export$d101061a57448642 = async ({ title: title, summary: summary, core_metadata: core_metadata, web_url: web_url, file: file })=>{
    const newForm = new FormData();
    if (file) newForm.append('file', file);
    if (title) newForm.append('title', title);
    if (summary) newForm.append('summary', summary);
    if (web_url) newForm.append('web_url', web_url);
    if (core_metadata) newForm.append('core_metadata', core_metadata);
    const response = await $3b3dc4976115d601$var$handler.post($3b3dc4976115d601$var$CREATE_DOCUMENT, newForm, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
    const { data: data } = response.data;
    return data;
};
const $3b3dc4976115d601$export$d8547e4d6e39f0da = async ({ page: page, size: size, sort: sort, document_id: document_id })=>{
    const params = {
        page: page && page,
        size: size && size,
        sort: sort && sort,
        document_id: document_id && document_id
    };
    const response = await $3b3dc4976115d601$var$handler.get($3b3dc4976115d601$var$GET_DOCUMENTS, {
        params: params
    });
    const { data: data } = response.data;
    return data;
};
const $3b3dc4976115d601$export$c13d6c69dccfb4b1 = async ({ page: page, size: size, sort: sort, document_id: document_id })=>{
    const params = {
        page: page && page,
        size: size && size,
        sort: sort && sort
    };
    const response = await $3b3dc4976115d601$var$handler.get(`${$3b3dc4976115d601$var$GET_DOCUMENT_CHUNKS}/${document_id}/chunks`, {
        params: params
    });
    const { data: data } = response.data;
    return data;
};
const $3b3dc4976115d601$export$7487591b773cdefe = async ({ id: id, title: title, summary: summary, core_metadata: core_metadata })=>{
    const response = await $3b3dc4976115d601$var$handler.patch($3b3dc4976115d601$var$UPDATE_DOCUMENT, {
        id: id,
        title: title,
        summary: summary,
        core_metadata: core_metadata
    });
    const { data: data } = response.data;
    return data;
};
const $3b3dc4976115d601$export$39b7914d0545250a = async ({ id: id, content: content, metadata: metadata, document_id: document_id })=>{
    const response = await $3b3dc4976115d601$var$handler.patch(`${$3b3dc4976115d601$var$UPDATE_DOCUMENT_CHUNK}/${document_id}/chunk`, {
        id: id,
        content: content,
        metadata: metadata
    });
    const { data: data } = response.data;
    return data;
};
const $3b3dc4976115d601$export$d7a8bc90ddc1c060 = async ({ document_id: document_id })=>{
    const response = await $3b3dc4976115d601$var$handler.delete(`${$3b3dc4976115d601$var$DANGEROUSLY_DELETE_DOCUMENT}/${document_id}`);
    const { data: data } = response.data;
    return data;
};


var $6e4f895631b3d5ff$export$2e2bcd8739ae039 = ()=>{
    const { mutate: createDocument, data: createDocumentData, error: createDocumentError, isLoading: isCreateDocumentLoading, isSuccess: isCreateDocumentSuccess, isError: isCreateDocumentError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $3b3dc4976115d601$export$d101061a57448642));
    return {
        createDocument: createDocument,
        createDocumentData: createDocumentData,
        createDocumentError: createDocumentError,
        isCreateDocumentLoading: isCreateDocumentLoading,
        isCreateDocumentSuccess: isCreateDocumentSuccess,
        isCreateDocumentError: isCreateDocumentError
    };
};




var $389edad6e0f22d98$export$2e2bcd8739ae039 = ()=>{
    const { mutate: deleteDocument, data: deleteDocumentData, error: deleteDocumentError, isLoading: isDeleteDocumentLoading, isSuccess: isDeleteDocumentSuccess, isError: isDeleteDocumentError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $3b3dc4976115d601$export$d7a8bc90ddc1c060));
    return {
        deleteDocument: deleteDocument,
        deleteDocumentData: deleteDocumentData,
        deleteDocumentError: deleteDocumentError,
        isDeleteDocumentLoading: isDeleteDocumentLoading,
        isDeleteDocumentSuccess: isDeleteDocumentSuccess,
        isDeleteDocumentError: isDeleteDocumentError
    };
};




var $553b74c795a3ef57$export$2e2bcd8739ae039 = ()=>{
    const { mutate: getDocuments, data: getDocumentsData, error: getDocumentsError, isLoading: isGetDocumentsLoading, isSuccess: isGetDocumentsSuccess, isError: isGetDocumentsError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $3b3dc4976115d601$export$d8547e4d6e39f0da));
    return {
        getDocuments: getDocuments,
        getDocumentsData: getDocumentsData,
        getDocumentsError: getDocumentsError,
        isGetDocumentsLoading: isGetDocumentsLoading,
        isGetDocumentsSuccess: isGetDocumentsSuccess,
        isGetDocumentsError: isGetDocumentsError
    };
};




var $f6c9e03fe2eac6b5$export$2e2bcd8739ae039 = ()=>{
    const { mutate: getDocumentChunks, data: getDocumentChunksData, error: getDocumentChunksError, isLoading: isGetDocumentChunksLoading, isSuccess: isGetDocumentChunksSuccess, isError: isGetDocumentChunksError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $3b3dc4976115d601$export$c13d6c69dccfb4b1));
    return {
        getDocumentChunks: getDocumentChunks,
        getDocumentChunksData: getDocumentChunksData,
        getDocumentChunksError: getDocumentChunksError,
        isGetDocumentChunksLoading: isGetDocumentChunksLoading,
        isGetDocumentChunksSuccess: isGetDocumentChunksSuccess,
        isGetDocumentChunksError: isGetDocumentChunksError
    };
};




var $7330d2aed83e7e66$export$2e2bcd8739ae039 = ()=>{
    const { mutate: updateDocument, data: updateDocumentData, error: updateDocumentError, isLoading: isUpdateDocumentLoading, isSuccess: isUpdateDocumentSuccess, isError: isUpdateDocumentError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $3b3dc4976115d601$export$7487591b773cdefe));
    return {
        updateDocument: updateDocument,
        updateDocumentData: updateDocumentData,
        updateDocumentError: updateDocumentError,
        isUpdateDocumentLoading: isUpdateDocumentLoading,
        isUpdateDocumentSuccess: isUpdateDocumentSuccess,
        isUpdateDocumentError: isUpdateDocumentError
    };
};




var $7ff639a4c5bea165$export$2e2bcd8739ae039 = ()=>{
    const { mutate: updateDocumentChunk, data: updateDocumentChunkData, error: updateDocumentChunkError, isLoading: isUpdateDocumentChunkLoading, isSuccess: isUpdateDocumentChunkSuccess, isError: isUpdateDocumentChunkError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $3b3dc4976115d601$export$39b7914d0545250a));
    return {
        updateDocumentChunk: updateDocumentChunk,
        updateDocumentChunkData: updateDocumentChunkData,
        updateDocumentChunkError: updateDocumentChunkError,
        isUpdateDocumentChunkLoading: isUpdateDocumentChunkLoading,
        isUpdateDocumentChunkSuccess: isUpdateDocumentChunkSuccess,
        isUpdateDocumentChunkError: isUpdateDocumentChunkError
    };
};





const { CREATE_NOTE: $8ce3c5f33c38d6b3$var$CREATE_NOTE, GET_NOTE: $8ce3c5f33c38d6b3$var$GET_NOTE } = (0, $78597906e6a0205e$export$4d0e600765299d44);
const $8ce3c5f33c38d6b3$export$4900fa576f1e8ef5 = async ({ note: note, module_id: module_id, record_id: record_id, business_id: business_id, created_by: created_by })=>{
    const response = await (0, $e29db2de9829c254$export$38b0b8222efbc769).post($8ce3c5f33c38d6b3$var$CREATE_NOTE, {
        note: note,
        module_id: module_id,
        record_id: record_id,
        business_id: business_id,
        created_by: created_by
    });
    const { data: data } = response.data;
    return data;
};
const $8ce3c5f33c38d6b3$export$249c158d1b7d65d = async ({ module_id: module_id, start_range: start_range, end_range: end_range, page: page, size: size, sort: sort })=>{
    const response = await (0, $e29db2de9829c254$export$38b0b8222efbc769).get($8ce3c5f33c38d6b3$var$GET_NOTE, {
        params: {
            module_id: module_id && module_id,
            start_range: start_range && start_range,
            end_range: end_range && end_range,
            page: page && page,
            size: size && size,
            sort: sort && sort
        }
    });
    const { data: data } = response.data;
    return data;
};


var $fc08522a804fd3d8$export$2e2bcd8739ae039 = ()=>{
    const { mutate: createNote, data: createNoteData, error: createNoteError, isLoading: isCreateNoteLoading, isSuccess: isCreateNoteSuccess, isError: isCreateNoteError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $8ce3c5f33c38d6b3$export$4900fa576f1e8ef5));
    return {
        createNote: createNote,
        createNoteData: createNoteData,
        createNoteError: createNoteError,
        isCreateNoteLoading: isCreateNoteLoading,
        isCreateNoteSuccess: isCreateNoteSuccess,
        isCreateNoteError: isCreateNoteError
    };
};




var $bacf39a42db46a90$export$2e2bcd8739ae039 = ()=>{
    const { mutate: getNote, data: getNoteData, error: getNoteError, isLoading: isGetNoteLoading, isSuccess: isGetNoteSuccess, isError: isGetNoteError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $8ce3c5f33c38d6b3$export$249c158d1b7d65d));
    return {
        getNote: getNote,
        getNoteData: getNoteData,
        getNoteError: getNoteError,
        isGetNoteLoading: isGetNoteLoading,
        isGetNoteSuccess: isGetNoteSuccess,
        isGetNoteError: isGetNoteError
    };
};





const $a14cbf3828353974$export$ca8561d2f81b8b2f = (0, $e29db2de9829c254$export$456995facc43eda)((0, $78597906e6a0205e$export$1deab063ed687beb));
const $a14cbf3828353974$var$handler = $a14cbf3828353974$export$ca8561d2f81b8b2f;
const $a14cbf3828353974$export$a828b150d921ad91 = async (values)=>{
    const response = await $a14cbf3828353974$var$handler.get((0, $78597906e6a0205e$export$b0b514a7d9a48bfa).GET_ALL_ACCOUNTS, {
        params: {
            ...values
        }
    });
    const { data: data } = response.data;
    return data;
};
const $a14cbf3828353974$export$2fdc6653346cb7d8 = async ({ account_id: account_id })=>{
    const response = await $a14cbf3828353974$var$handler.get(`${(0, $78597906e6a0205e$export$b0b514a7d9a48bfa).GET_ACCOUNT}${account_id}`);
    const { data: data } = response.data;
    return data;
};
const $a14cbf3828353974$export$7777637197226c93 = async ({ search_term: search_term, account_category: account_category })=>{
    const response = await $a14cbf3828353974$var$handler.get((0, $78597906e6a0205e$export$b0b514a7d9a48bfa).SEARCH_ACCOUNT, {
        params: {
            search_term: search_term,
            account_category: account_category
        }
    });
    const { data: data } = response.data;
    return data;
};
const $a14cbf3828353974$export$8ccad3a282ed2d07 = async (values)=>{
    const response = await $a14cbf3828353974$var$handler.post((0, $78597906e6a0205e$export$b0b514a7d9a48bfa).CREATE_ACCOUNT_ENTITY, {
        ...values
    });
    const { data: data } = response.data;
    return data;
};
const $a14cbf3828353974$export$121e9a75830c0249 = async (values)=>{
    const response = await $a14cbf3828353974$var$handler.post((0, $78597906e6a0205e$export$b0b514a7d9a48bfa).CREATE_ACCOUNT_INDIVIDUAL, {
        ...values
    });
    const { data: data } = response.data;
    return data;
};
const $a14cbf3828353974$export$f39911c5d98150de = async ({ account_id: account_id, values: values })=>{
    const response = await $a14cbf3828353974$var$handler.patch(`${(0, $78597906e6a0205e$export$b0b514a7d9a48bfa).UPDATE_ACCOUNT_ENTITY}${account_id}`, {
        ...values
    });
    const { data: data } = response.data;
    return data;
};
const $a14cbf3828353974$export$a8b0606442a72bab = async ({ account_id: account_id, values: values })=>{
    const response = await $a14cbf3828353974$var$handler.patch(`${(0, $78597906e6a0205e$export$b0b514a7d9a48bfa).UPDATE_ACCOUNT_INDIVIDUAL}${account_id}`, {
        ...values
    });
    const { data: data } = response.data;
    return data;
};


var $e5d00bc69bf8a3af$export$2e2bcd8739ae039 = ()=>{
    const { mutate: createAccountEntity, data: accountEntityCreateData, error: accountEntityCreateError, isLoading: isAccountEntityCreateLoading, isSuccess: isAccountEntityCreateSuccess, isError: isAccountEntityCreateError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $a14cbf3828353974$export$8ccad3a282ed2d07));
    return {
        createAccountEntity: createAccountEntity,
        accountEntityCreateData: accountEntityCreateData,
        accountEntityCreateError: accountEntityCreateError,
        isAccountEntityCreateLoading: isAccountEntityCreateLoading,
        isAccountEntityCreateSuccess: isAccountEntityCreateSuccess,
        isAccountEntityCreateError: isAccountEntityCreateError
    };
};




var $29f36fafb5a1782d$export$2e2bcd8739ae039 = ()=>{
    const { mutate: createAccountIndividual, data: accountIndividualCreateData, error: accountIndividualCreateError, isLoading: isAccountIndividualCreateLoading, isSuccess: isAccountIndividualCreateSuccess, isError: isAccountIndividualCreateError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $a14cbf3828353974$export$121e9a75830c0249));
    return {
        createAccountIndividual: createAccountIndividual,
        accountIndividualCreateData: accountIndividualCreateData,
        accountIndividualCreateError: accountIndividualCreateError,
        isAccountIndividualCreateLoading: isAccountIndividualCreateLoading,
        isAccountIndividualCreateSuccess: isAccountIndividualCreateSuccess,
        isAccountIndividualCreateError: isAccountIndividualCreateError
    };
};




var $aa9aabe79903a329$export$2e2bcd8739ae039 = ()=>{
    const { mutate: getAccount, data: accountData, error: accountError, isLoading: isAccountLoading, isSuccess: isAccountSuccess, isError: isAccountError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $a14cbf3828353974$export$2fdc6653346cb7d8));
    return {
        getAccount: getAccount,
        accountData: accountData,
        accountError: accountError,
        isAccountLoading: isAccountLoading,
        isAccountSuccess: isAccountSuccess,
        isAccountError: isAccountError
    };
};




var $f37bbf346099fbd9$export$2e2bcd8739ae039 = ()=>{
    const { mutate: getAllAccounts, data: allAccountsData, error: allAccountsError, isLoading: isAllAccountsLoading, isSuccess: isAllAccountsSuccess, isError: isAllAccountsError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $a14cbf3828353974$export$a828b150d921ad91));
    return {
        getAllAccounts: getAllAccounts,
        allAccountsData: allAccountsData,
        allAccountsError: allAccountsError,
        isAllAccountsLoading: isAllAccountsLoading,
        isAllAccountsSuccess: isAllAccountsSuccess,
        isAllAccountsError: isAllAccountsError
    };
};




var $c374fc425c48cdb0$export$2e2bcd8739ae039 = ()=>{
    const { mutate: searchAccount, data: accountSearchData, error: accountSearchError, isLoading: isAccountSearchLoading, isSuccess: isAccountSearchSuccess, isError: isAccountSearchError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $a14cbf3828353974$export$7777637197226c93));
    return {
        searchAccount: searchAccount,
        accountSearchData: accountSearchData,
        accountSearchError: accountSearchError,
        isAccountSearchLoading: isAccountSearchLoading,
        isAccountSearchSuccess: isAccountSearchSuccess,
        isAccountSearchError: isAccountSearchError
    };
};




var $d50484ab2e32d4d8$export$2e2bcd8739ae039 = ()=>{
    const { mutate: updateAccountEntity, data: accountEntityUpdateData, error: accountEntityUpdateError, isLoading: isAccountEntityUpdateLoading, isSuccess: isAccountEntityUpdateSuccess, isError: isAccountEntityUpdateError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $a14cbf3828353974$export$f39911c5d98150de));
    return {
        updateAccountEntity: updateAccountEntity,
        accountEntityUpdateData: accountEntityUpdateData,
        accountEntityUpdateError: accountEntityUpdateError,
        isAccountEntityUpdateLoading: isAccountEntityUpdateLoading,
        isAccountEntityUpdateSuccess: isAccountEntityUpdateSuccess,
        isAccountEntityUpdateError: isAccountEntityUpdateError
    };
};




var $ead9c70d2f240d34$export$2e2bcd8739ae039 = ()=>{
    const { mutate: updateAccountIndividual, data: accountIndividualUpdateData, error: accountIndividualUpdateError, isLoading: isAccountIndividualUpdateLoading, isSuccess: isAccountIndividualUpdateSuccess, isError: isAccountIndividualUpdateError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $a14cbf3828353974$export$a8b0606442a72bab));
    return {
        updateAccountIndividual: updateAccountIndividual,
        accountIndividualUpdateData: accountIndividualUpdateData,
        accountIndividualUpdateError: accountIndividualUpdateError,
        isAccountIndividualUpdateLoading: isAccountIndividualUpdateLoading,
        isAccountIndividualUpdateSuccess: isAccountIndividualUpdateSuccess,
        isAccountIndividualUpdateError: isAccountIndividualUpdateError
    };
};





const $8532b3fa04972deb$export$ca8561d2f81b8b2f = (0, $e29db2de9829c254$export$456995facc43eda)((0, $78597906e6a0205e$export$1deab063ed687beb));
const $8532b3fa04972deb$var$handler = $8532b3fa04972deb$export$ca8561d2f81b8b2f;
const $8532b3fa04972deb$export$b29135df24fd4400 = async (values)=>{
    const response = await $8532b3fa04972deb$var$handler.get((0, $78597906e6a0205e$export$aa699c9a0b9a0cb4).GET_ALL_VASPS, {
        params: {
            ...values
        }
    });
    const { data: data } = response.data;
    return data;
};
const $8532b3fa04972deb$export$15617afd0948df13 = async (values)=>{
    const response = await $8532b3fa04972deb$var$handler.get((0, $78597906e6a0205e$export$aa699c9a0b9a0cb4).GET_ALL_MID_PROSPECTS, {
        params: {
            ...values
        }
    });
    const { data: data } = response.data;
    return data;
};
const $8532b3fa04972deb$export$cded27fccc2a887c = async ({ vasp_id: vasp_id })=>{
    const response = await $8532b3fa04972deb$var$handler.get(`${(0, $78597906e6a0205e$export$aa699c9a0b9a0cb4).GET_VASP}${vasp_id}`);
    const { data: data } = response.data;
    return data;
};
const $8532b3fa04972deb$export$19ec0d0adaa281af = async ({ search_term: search_term, ...rest })=>{
    const response = await $8532b3fa04972deb$var$handler.get((0, $78597906e6a0205e$export$aa699c9a0b9a0cb4).SEARCH_VASP, {
        params: {
            search_term: search_term,
            ...rest
        }
    });
    const { data: data } = response.data;
    return data;
};
const $8532b3fa04972deb$export$1a20f6e3efa23843 = async ({ search_term: search_term })=>{
    const response = await $8532b3fa04972deb$var$handler.get((0, $78597906e6a0205e$export$aa699c9a0b9a0cb4).SEARCH_MID_PROSPECT, {
        params: {
            search_term: search_term
        }
    });
    const { data: data } = response.data;
    return data;
};
const $8532b3fa04972deb$export$85f08913c0f564a0 = async (values)=>{
    const response = await $8532b3fa04972deb$var$handler.post((0, $78597906e6a0205e$export$aa699c9a0b9a0cb4).CREATE_VASP, values);
    const { data: data } = response.data;
    return data;
};
const $8532b3fa04972deb$export$15784a7d68658191 = async ({ vasp_id: vasp_id, values: values })=>{
    const response = await $8532b3fa04972deb$var$handler.patch(`${(0, $78597906e6a0205e$export$aa699c9a0b9a0cb4).UPDATE_VASP}/${vasp_id}`, {
        vasp_id: vasp_id,
        ...values
    });
    const { data: data } = response.data;
    return data;
};


var $21aa17491474595c$export$2e2bcd8739ae039 = ()=>{
    const { mutate: createVasp, data: vaspCreateData, error: vaspCreateError, isLoading: isVaspCreateLoading, isSuccess: isVaspCreateSuccess, isError: isVaspCreateError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $8532b3fa04972deb$export$85f08913c0f564a0));
    return {
        createVasp: createVasp,
        vaspCreateData: vaspCreateData,
        vaspCreateError: vaspCreateError,
        isVaspCreateLoading: isVaspCreateLoading,
        isVaspCreateSuccess: isVaspCreateSuccess,
        isVaspCreateError: isVaspCreateError
    };
};




var $40506d7d94723792$export$2e2bcd8739ae039 = ()=>{
    const { mutate: getAllVasps, data: allVaspsData, error: allVaspsError, isLoading: isAllVaspsLoading, isSuccess: isAllVaspsSuccess, isError: isAllVaspsError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $8532b3fa04972deb$export$b29135df24fd4400));
    return {
        getAllVasps: getAllVasps,
        allVaspsData: allVaspsData,
        allVaspsError: allVaspsError,
        isAllVaspsLoading: isAllVaspsLoading,
        isAllVaspsSuccess: isAllVaspsSuccess,
        isAllVaspsError: isAllVaspsError
    };
};




var $877da4f36404856e$export$2e2bcd8739ae039 = ()=>{
    const { mutate: getAllMidProspects, data: allMidProspectsData, error: allMidProspectsError, isLoading: isAllMidProspectsLoading, isSuccess: isAllMidProspectsSuccess, isError: isAllMidProspectsError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $8532b3fa04972deb$export$15617afd0948df13));
    return {
        getAllMidProspects: getAllMidProspects,
        allMidProspectsData: allMidProspectsData,
        allMidProspectsError: allMidProspectsError,
        isAllMidProspectsLoading: isAllMidProspectsLoading,
        isAllMidProspectsSuccess: isAllMidProspectsSuccess,
        isAllMidProspectsError: isAllMidProspectsError
    };
};




var $462c3808bdeaeab0$export$2e2bcd8739ae039 = ()=>{
    const { mutate: getVasp, data: vaspData, error: vaspError, isLoading: isVaspLoading, isSuccess: isVaspSuccess, isError: isVaspError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $8532b3fa04972deb$export$cded27fccc2a887c));
    return {
        getVasp: getVasp,
        vaspData: vaspData,
        vaspError: vaspError,
        isVaspLoading: isVaspLoading,
        isVaspSuccess: isVaspSuccess,
        isVaspError: isVaspError
    };
};




var $dc7df1083c6c90ef$export$2e2bcd8739ae039 = ()=>{
    const { mutate: searchVasp, data: vaspSearchData, error: vaspSearchError, isLoading: isVaspSearchLoading, isSuccess: isVaspSearchSuccess, isError: isVaspSearchError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $8532b3fa04972deb$export$19ec0d0adaa281af));
    return {
        searchVasp: searchVasp,
        vaspSearchData: vaspSearchData,
        vaspSearchError: vaspSearchError,
        isVaspSearchLoading: isVaspSearchLoading,
        isVaspSearchSuccess: isVaspSearchSuccess,
        isVaspSearchError: isVaspSearchError
    };
};




var $b3824b62e003fe5e$export$2e2bcd8739ae039 = ()=>{
    const { mutate: searchMidProspect, data: midProspectSearchData, error: midProspectSearchError, isLoading: isMidProspectSearchLoading, isSuccess: isMidProspectSearchSuccess, isError: isMidProspectSearchError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $8532b3fa04972deb$export$1a20f6e3efa23843));
    return {
        searchMidProspect: searchMidProspect,
        midProspectSearchData: midProspectSearchData,
        midProspectSearchError: midProspectSearchError,
        isMidProspectSearchLoading: isMidProspectSearchLoading,
        isMidProspectSearchSuccess: isMidProspectSearchSuccess,
        isMidProspectSearchError: isMidProspectSearchError
    };
};




var $05f6f04b561b761e$export$2e2bcd8739ae039 = ()=>{
    const { mutate: updateVasp, data: vaspUpdateData, error: vaspUpdateError, isLoading: isVaspUpdateLoading, isSuccess: isVaspUpdateSuccess, isError: isVaspUpdateError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $8532b3fa04972deb$export$15784a7d68658191));
    return {
        updateVasp: updateVasp,
        vaspUpdateData: vaspUpdateData,
        vaspUpdateError: vaspUpdateError,
        isVaspUpdateLoading: isVaspUpdateLoading,
        isVaspUpdateSuccess: isVaspUpdateSuccess,
        isVaspUpdateError: isVaspUpdateError
    };
};





const $8f7fd483d379aa21$export$ca8561d2f81b8b2f = (0, $e29db2de9829c254$export$456995facc43eda)((0, $78597906e6a0205e$export$1736ebf7cf11dd7a));
const $8f7fd483d379aa21$var$handler = $8f7fd483d379aa21$export$ca8561d2f81b8b2f;
const $8f7fd483d379aa21$export$27b54e08fafcc6f7 = async (values)=>{
    const response = await $8f7fd483d379aa21$var$handler.get((0, $78597906e6a0205e$export$5d38483e7d27dad5).GET_ASSET_CONVERSION, {
        params: {
            ...values
        }
    });
    const { data: data } = response;
    return data;
};
const $8f7fd483d379aa21$export$22c84a9d36115c0a = async (values)=>{
    const response = await $8f7fd483d379aa21$var$handler.get((0, $78597906e6a0205e$export$5d38483e7d27dad5).GET_ALL_TRANSFERS, {
        params: {
            ...values
        }
    });
    const { data: data } = response;
    return data;
};
const $8f7fd483d379aa21$export$1c0ad7b4ce3c0a20 = async (values)=>{
    const response = await $8f7fd483d379aa21$var$handler.get((0, $78597906e6a0205e$export$5d38483e7d27dad5).GET_ACCOUNT_SUMMARY, {
        params: {
            ...values
        }
    });
    const { data: data } = response;
    return data;
};
const $8f7fd483d379aa21$export$62258028e9a2e708 = async ({ transfer_id: transfer_id })=>{
    const response = await $8f7fd483d379aa21$var$handler.get(`${(0, $78597906e6a0205e$export$5d38483e7d27dad5).GET_TRANSFER}${transfer_id}`);
    const { data: data } = response;
    return data;
};
const $8f7fd483d379aa21$export$373c0569724bb486 = async (values)=>{
    const response = await $8f7fd483d379aa21$var$handler.get((0, $78597906e6a0205e$export$5d38483e7d27dad5).SEARCH_TRANSFER, {
        params: {
            ...values
        }
    });
    const { data: data } = response;
    return data;
};
const $8f7fd483d379aa21$export$6edceab07a74a096 = async ({ out_hash_address: out_hash_address, asset_code: asset_code })=>{
    const response = await $8f7fd483d379aa21$var$handler.get(`${(0, $78597906e6a0205e$export$5d38483e7d27dad5).GET_RECIPIENT_VASP}`, {
        params: {
            out_hash_address: out_hash_address,
            asset_code: asset_code
        }
    });
    const { data: data } = response;
    return data;
};
const $8f7fd483d379aa21$export$f69be264527620e9 = async (values)=>{
    const response = await $8f7fd483d379aa21$var$handler.post((0, $78597906e6a0205e$export$5d38483e7d27dad5).CREATE_TRANSFER, values);
    const { data: data } = response;
    return data;
};
const $8f7fd483d379aa21$export$ea313a923a76975b = async ({ transfer_id: transfer_id, status_id: status_id })=>{
    const response = await $8f7fd483d379aa21$var$handler.patch(`${(0, $78597906e6a0205e$export$5d38483e7d27dad5).UPDATE_TRANSFER}${transfer_id}/status/${status_id}`);
    const { data: data } = response;
    return data;
};
const $8f7fd483d379aa21$export$c2ef9d0258e44fd8 = async (values)=>{
    const response = await $8f7fd483d379aa21$var$handler.post((0, $78597906e6a0205e$export$5d38483e7d27dad5).POST_TRANSFER_REPORT, values);
    const { data: data } = response;
    return data;
};


var $885aa14bb7e86d78$export$2e2bcd8739ae039 = ()=>{
    const { mutate: createTransfer, data: transferCreateData, error: transferCreateError, isLoading: isTransferCreateLoading, isSuccess: isTransferCreateSuccess, isError: isTransferCreateError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $8f7fd483d379aa21$export$f69be264527620e9));
    return {
        createTransfer: createTransfer,
        transferCreateData: transferCreateData,
        transferCreateError: transferCreateError,
        isTransferCreateLoading: isTransferCreateLoading,
        isTransferCreateSuccess: isTransferCreateSuccess,
        isTransferCreateError: isTransferCreateError
    };
};




var $13d8d2c7cd726551$export$2e2bcd8739ae039 = ()=>{
    const { mutate: getAllTransfers, data: allTransferData, error: allTransferError, isLoading: isAllTransferLoading, isSuccess: isAllTransferSuccess, isError: isAllTransferError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $8f7fd483d379aa21$export$22c84a9d36115c0a));
    return {
        getAllTransfers: getAllTransfers,
        allTransferData: allTransferData,
        allTransferError: allTransferError,
        isAllTransferLoading: isAllTransferLoading,
        isAllTransferSuccess: isAllTransferSuccess,
        isAllTransferError: isAllTransferError
    };
};




var $59e92218d3a75836$export$2e2bcd8739ae039 = ()=>{
    const { mutate: getTransfer, data: transferData, error: transferError, isLoading: isTransferLoading, isSuccess: isTransferSuccess, isError: isTransferError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $8f7fd483d379aa21$export$62258028e9a2e708));
    return {
        getTransfer: getTransfer,
        transferData: transferData,
        transferError: transferError,
        isTransferLoading: isTransferLoading,
        isTransferSuccess: isTransferSuccess,
        isTransferError: isTransferError
    };
};




var $f3a1fe9f31d5b5de$export$2e2bcd8739ae039 = ()=>{
    const { mutate: updateTransfer, data: transferUpdateData, error: transferUpdateError, isLoading: isTransferUpdateLoading, isSuccess: isTransferUpdateSuccess, isError: isTransferUpdateError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $8f7fd483d379aa21$export$ea313a923a76975b));
    return {
        updateTransfer: updateTransfer,
        transferUpdateData: transferUpdateData,
        transferUpdateError: transferUpdateError,
        isTransferUpdateLoading: isTransferUpdateLoading,
        isTransferUpdateSuccess: isTransferUpdateSuccess,
        isTransferUpdateError: isTransferUpdateError
    };
};




var $5169c7c2902b6229$export$2e2bcd8739ae039 = ()=>{
    const { mutate: getAssetConversion, data: assetConversionData, error: assetConversionError, isLoading: isAssetConversionLoading, isSuccess: isAssetConversionSuccess, isError: isAssetConversionError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $8f7fd483d379aa21$export$27b54e08fafcc6f7));
    return {
        getAssetConversion: getAssetConversion,
        assetConversionData: assetConversionData,
        assetConversionError: assetConversionError,
        isAssetConversionLoading: isAssetConversionLoading,
        isAssetConversionSuccess: isAssetConversionSuccess,
        isAssetConversionError: isAssetConversionError
    };
};




var $171915c4daff5625$export$2e2bcd8739ae039 = ()=>{
    const { mutate: getRecipientVasp, data: recipientVaspData, error: recipientVaspError, isLoading: isRecipientVaspLoading, isSuccess: isRecipientVaspSuccess, isError: isRecipientVaspError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $8f7fd483d379aa21$export$6edceab07a74a096));
    return {
        getRecipientVasp: getRecipientVasp,
        recipientVaspData: recipientVaspData,
        recipientVaspError: recipientVaspError,
        isRecipientVaspLoading: isRecipientVaspLoading,
        isRecipientVaspSuccess: isRecipientVaspSuccess,
        isRecipientVaspError: isRecipientVaspError
    };
};




var $47163b3c3a1eda62$export$2e2bcd8739ae039 = ()=>{
    const { mutate: searchTransfer, data: transferSearchData, error: transferSearchError, isLoading: isTransferSearchLoading, isSuccess: isTransferSearchSuccess, isError: isTransferSearchError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $8f7fd483d379aa21$export$373c0569724bb486));
    return {
        searchTransfer: searchTransfer,
        transferSearchData: transferSearchData,
        transferSearchError: transferSearchError,
        isTransferSearchLoading: isTransferSearchLoading,
        isTransferSearchSuccess: isTransferSearchSuccess,
        isTransferSearchError: isTransferSearchError
    };
};




var $cf559f1f25c4f1b3$export$2e2bcd8739ae039 = ()=>{
    const { mutate: createTransferReport, data: transferReportCreateData, error: transferReportCreateError, isLoading: isTransferReportCreateLoading, isSuccess: isTransferReportCreateSuccess, isError: isTransferReportCreateError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $8f7fd483d379aa21$export$c2ef9d0258e44fd8));
    return {
        createTransferReport: createTransferReport,
        transferReportCreateData: transferReportCreateData,
        transferReportCreateError: transferReportCreateError,
        isTransferReportCreateLoading: isTransferReportCreateLoading,
        isTransferReportCreateSuccess: isTransferReportCreateSuccess,
        isTransferReportCreateError: isTransferReportCreateError
    };
};




var $23b3944e12cd9c57$export$2e2bcd8739ae039 = ()=>{
    const { mutate: getAccountTransferSummary, data: getAccountTransferSummaryData, error: getAccountTransferSummaryError, isLoading: isGetAccountTransferSummaryLoading, isSuccess: isGetAccountTransferSummarySuccess, isError: isGetAccountTransferSummaryError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $8f7fd483d379aa21$export$1c0ad7b4ce3c0a20));
    return {
        getAccountTransferSummary: getAccountTransferSummary,
        getAccountTransferSummaryData: getAccountTransferSummaryData,
        getAccountTransferSummaryError: getAccountTransferSummaryError,
        isGetAccountTransferSummaryLoading: isGetAccountTransferSummaryLoading,
        isGetAccountTransferSummarySuccess: isGetAccountTransferSummarySuccess,
        isGetAccountTransferSummaryError: isGetAccountTransferSummaryError
    };
};





const { CREATE_OR_UPDATE_ADDRESS: $8c9c17926a9c04e3$var$CREATE_OR_UPDATE_ADDRESS, LINK_ADDRESS: $8c9c17926a9c04e3$var$LINK_ADDRESS, DELETE_ADDRESS: $8c9c17926a9c04e3$var$DELETE_ADDRESS, GET_ADDRESSES: $8c9c17926a9c04e3$var$GET_ADDRESSES, GET_ADDRESS_DETAILS: $8c9c17926a9c04e3$var$GET_ADDRESS_DETAILS, GET_ADDRESS_HISTORY: $8c9c17926a9c04e3$var$GET_ADDRESS_HISTORY, POST_ADDRESS_REPORT: $8c9c17926a9c04e3$var$POST_ADDRESS_REPORT, GET_ADDRESS_VERIFICATION: $8c9c17926a9c04e3$var$GET_ADDRESS_VERIFICATION, GET_ADDRESS_CHAIN_RECOMMENDATION: $8c9c17926a9c04e3$var$GET_ADDRESS_CHAIN_RECOMMENDATION, GET_ADDRESS_ACCOUNT_SUMMARY: $8c9c17926a9c04e3$var$GET_ADDRESS_ACCOUNT_SUMMARY, GET_ADDRESS_CHAINS: $8c9c17926a9c04e3$var$GET_ADDRESS_CHAINS, UPDATE_ADDRESS_HOSTED: $8c9c17926a9c04e3$var$UPDATE_ADDRESS_HOSTED } = (0, $78597906e6a0205e$export$36dac04bc644e0bf);
const $8c9c17926a9c04e3$export$ca8561d2f81b8b2f = (0, $e29db2de9829c254$export$456995facc43eda)((0, $78597906e6a0205e$export$2a267d68982d9895));
const $8c9c17926a9c04e3$var$handler = $8c9c17926a9c04e3$export$ca8561d2f81b8b2f;
const $8c9c17926a9c04e3$export$7a7bb47e405c30b6 = async ({ address: address, chain: chain, type: type, provider_id: provider_id, name_first: name_first, name_last: name_last, is_self_hosted: is_self_hosted, scan_for_risk: scan_for_risk, link_id: link_id, link_type: link_type })=>{
    const response = await $8c9c17926a9c04e3$var$handler.post($8c9c17926a9c04e3$var$CREATE_OR_UPDATE_ADDRESS, {
        address: address,
        chain: chain,
        type: type,
        provider_id: provider_id,
        name_first: name_first,
        name_last: name_last,
        is_self_hosted: is_self_hosted,
        scan_for_risk: provider_id ? true : scan_for_risk || false,
        link_id: link_id,
        link_type: link_type
    });
    const { data: data } = response.data;
    return data;
};
const $8c9c17926a9c04e3$export$fe7afea86920739e = async ({ link_id: link_id, link_type: link_type, address_id: address_id })=>{
    const response = await $8c9c17926a9c04e3$var$handler.patch(`${$8c9c17926a9c04e3$var$LINK_ADDRESS}/${address_id}/link`, {
        link_id: link_id,
        link_type: link_type
    });
    const { data: data } = response.data;
    return data;
};
const $8c9c17926a9c04e3$export$7d7ea842e5e4a7f5 = async ({ address_id: address_id })=>{
    const response = await $8c9c17926a9c04e3$var$handler.patch(`${$8c9c17926a9c04e3$var$DELETE_ADDRESS}/${address_id}`);
    const { data: data } = response.data;
    return data;
};
const $8c9c17926a9c04e3$export$e2511a51425367e7 = async ({ address_id: address_id, is_self_hosted: is_self_hosted })=>{
    const response = await $8c9c17926a9c04e3$var$handler.patch(`${$8c9c17926a9c04e3$var$UPDATE_ADDRESS_HOSTED}/${address_id}`, {
        is_self_hosted: is_self_hosted
    });
    const { data: data } = response.data;
    return data;
};
const $8c9c17926a9c04e3$export$5dda237efd9a0304 = async ({ start_range: start_range, end_range: end_range, page: page, size: size, sort: sort, link_id: link_id })=>{
    const params = {
        start_range: start_range && start_range,
        end_range: end_range && end_range,
        start_range_create: start_range && start_range,
        end_range_create: end_range && end_range,
        page: page && page,
        size: size && size,
        sort: sort && sort,
        link_id: link_id && link_id
    };
    const response = await $8c9c17926a9c04e3$var$handler.get($8c9c17926a9c04e3$var$GET_ADDRESSES, {
        params: params
    });
    const { data: data } = response.data;
    return data;
};
const $8c9c17926a9c04e3$export$a86f4f50d46cc37e = async ({ address_id: address_id, start_range: start_range, end_range: end_range, page: page, size: size, sort: sort })=>{
    const response = await $8c9c17926a9c04e3$var$handler.get(`${$8c9c17926a9c04e3$var$GET_ADDRESS_DETAILS}/${address_id}`, {
        params: {
            start_range: start_range && start_range,
            end_range: end_range && end_range,
            page: page && page,
            size: size && size,
            sort: sort && sort
        }
    });
    const { data: data } = response.data;
    return data;
};
const $8c9c17926a9c04e3$export$5e4f1d8dec5c725 = async ({ address_id: address_id, start_range: start_range, end_range: end_range, page: page, size: size, sort: sort })=>{
    const response = await $8c9c17926a9c04e3$var$handler.get(`${$8c9c17926a9c04e3$var$GET_ADDRESS_HISTORY}/${address_id}/history`, {
        params: {
            start_range: start_range && start_range,
            end_range: end_range && end_range,
            page: page && page,
            size: size && size,
            sort: sort && sort
        }
    });
    const { data: data } = response.data;
    return data;
};
const $8c9c17926a9c04e3$export$752b6d3e37d95ba7 = async ({ address_id: address_id, sections: sections, start_range: start_range, end_range: end_range })=>{
    const response = await $8c9c17926a9c04e3$var$handler.post(`${$8c9c17926a9c04e3$var$POST_ADDRESS_REPORT}/${address_id}/reports?sections=${sections.join(',')}&start_range=${start_range}&end_range=${end_range}`);
    const { data: data } = response.data;
    return data;
};
const $8c9c17926a9c04e3$export$430f6593c0173bc3 = async ({ address: address, chain: chain })=>{
    const response = await $8c9c17926a9c04e3$var$handler.get(`${$8c9c17926a9c04e3$var$GET_ADDRESS_VERIFICATION}/${address}/chains/${chain}`);
    const { data: data } = response.data;
    return data;
};
const $8c9c17926a9c04e3$export$d358ca153889ac32 = async ({ address: address })=>{
    const response = await $8c9c17926a9c04e3$var$handler.get(`${$8c9c17926a9c04e3$var$GET_ADDRESS_CHAIN_RECOMMENDATION}/${address}/chain_discovery`);
    const { data: data } = response.data;
    return data;
};
const $8c9c17926a9c04e3$export$3d7eb20b694016e4 = async ({ account_id: account_id, identified: identified })=>{
    const response = await $8c9c17926a9c04e3$var$handler.get($8c9c17926a9c04e3$var$GET_ADDRESS_ACCOUNT_SUMMARY, {
        params: {
            account_id: account_id,
            identified: identified
        }
    });
    const { data: data } = response.data;
    return data;
};
const $8c9c17926a9c04e3$export$94787a1ce1810c2d = async (props)=>{
    const params = {};
    if (props?.provider_name) params.provider_name = props?.provider_name;
    const response = await $8c9c17926a9c04e3$var$handler.get($8c9c17926a9c04e3$var$GET_ADDRESS_CHAINS, {
        params: params
    });
    const { data: data } = response.data;
    return data;
};


var $b297ef53431cfca8$export$2e2bcd8739ae039 = ()=>{
    const { mutate: createOrUpdateAddress, data: createOrUpdateAddressData, error: createOrUpdateAddressError, isLoading: isCreateOrUpdateAddressLoading, isSuccess: isCreateOrUpdateAddressSuccess, isError: isCreateOrUpdateAddressError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $8c9c17926a9c04e3$export$7a7bb47e405c30b6));
    return {
        createOrUpdateAddress: createOrUpdateAddress,
        createOrUpdateAddressData: createOrUpdateAddressData,
        createOrUpdateAddressError: createOrUpdateAddressError,
        isCreateOrUpdateAddressLoading: isCreateOrUpdateAddressLoading,
        isCreateOrUpdateAddressSuccess: isCreateOrUpdateAddressSuccess,
        isCreateOrUpdateAddressError: isCreateOrUpdateAddressError
    };
};




var $6ce007ee53db4e92$export$2e2bcd8739ae039 = ()=>{
    const { mutate: deleteAddress, data: deleteAddressData, error: deleteAddressError, isLoading: isDeleteAddressLoading, isSuccess: isDeleteAddressSuccess, isError: isDeleteAddressError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $8c9c17926a9c04e3$export$7d7ea842e5e4a7f5));
    return {
        deleteAddress: deleteAddress,
        deleteAddressData: deleteAddressData,
        deleteAddressError: deleteAddressError,
        isDeleteAddressLoading: isDeleteAddressLoading,
        isDeleteAddressSuccess: isDeleteAddressSuccess,
        isDeleteAddressError: isDeleteAddressError
    };
};




var $d3447c5e6b8a84bc$export$2e2bcd8739ae039 = ()=>{
    const { mutate: getAddresses, data: getAddressesData, error: getAddressesError, isLoading: isGetAddressesLoading, isSuccess: isGetAddressesSuccess, isError: isGetAddressesError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $8c9c17926a9c04e3$export$5dda237efd9a0304));
    return {
        getAddresses: getAddresses,
        getAddressesData: getAddressesData,
        getAddressesError: getAddressesError,
        isGetAddressesLoading: isGetAddressesLoading,
        isGetAddressesSuccess: isGetAddressesSuccess,
        isGetAddressesError: isGetAddressesError
    };
};




var $8aa3c72c70de01d3$export$2e2bcd8739ae039 = ()=>{
    const { mutate: getAddressDetails, data: getAddressDetailsData, error: getAddressDetailsError, isLoading: isGetAddressDetailsLoading, isSuccess: isGetAddressDetailsSuccess, isError: isGetAddressDetailsError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $8c9c17926a9c04e3$export$a86f4f50d46cc37e));
    return {
        getAddressDetails: getAddressDetails,
        getAddressDetailsData: getAddressDetailsData,
        getAddressDetailsError: getAddressDetailsError,
        isGetAddressDetailsLoading: isGetAddressDetailsLoading,
        isGetAddressDetailsSuccess: isGetAddressDetailsSuccess,
        isGetAddressDetailsError: isGetAddressDetailsError
    };
};




var $40ec4c0bc93edec7$export$2e2bcd8739ae039 = ()=>{
    const { mutate: getAddressHistory, data: getAddressHistoryData, error: getAddressHistoryError, isLoading: isGetAddressHistoryLoading, isSuccess: isGetAddressHistorySuccess, isError: isGetAddressHistoryError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $8c9c17926a9c04e3$export$5e4f1d8dec5c725));
    return {
        getAddressHistory: getAddressHistory,
        getAddressHistoryData: getAddressHistoryData,
        getAddressHistoryError: getAddressHistoryError,
        isGetAddressHistoryLoading: isGetAddressHistoryLoading,
        isGetAddressHistorySuccess: isGetAddressHistorySuccess,
        isGetAddressHistoryError: isGetAddressHistoryError
    };
};




var $df04c260c150084f$export$2e2bcd8739ae039 = ()=>{
    const { mutate: postAddressReport, data: postAddressReportData, error: postAddressReportError, isLoading: isPostAddressReportLoading, isSuccess: isPostAddressReportSuccess, isError: isPostAddressReportError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $8c9c17926a9c04e3$export$752b6d3e37d95ba7));
    return {
        postAddressReport: postAddressReport,
        postAddressReportData: postAddressReportData,
        postAddressReportError: postAddressReportError,
        isPostAddressReportLoading: isPostAddressReportLoading,
        isPostAddressReportSuccess: isPostAddressReportSuccess,
        isPostAddressReportError: isPostAddressReportError
    };
};




var $67ddf601e136650e$export$2e2bcd8739ae039 = ()=>{
    const { mutate: linkAddress, data: linkAddressData, error: linkAddressError, isLoading: isLinkAddressLoading, isSuccess: isLinkAddressSuccess, isError: isLinkAddressError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $8c9c17926a9c04e3$export$fe7afea86920739e));
    return {
        linkAddress: linkAddress,
        linkAddressData: linkAddressData,
        linkAddressError: linkAddressError,
        isLinkAddressLoading: isLinkAddressLoading,
        isLinkAddressSuccess: isLinkAddressSuccess,
        isLinkAddressError: isLinkAddressError
    };
};




var $cd7e926fe9cb8d98$export$2e2bcd8739ae039 = ()=>{
    const { mutate: getAddressVerification, data: getAddressVerificationData, error: getAddressVerificationError, isLoading: isGetAddressVerificationLoading, isSuccess: isGetAddressVerificationSuccess, isError: isGetAddressVerificationError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $8c9c17926a9c04e3$export$430f6593c0173bc3));
    return {
        getAddressVerification: getAddressVerification,
        getAddressVerificationData: getAddressVerificationData,
        getAddressVerificationError: getAddressVerificationError,
        isGetAddressVerificationLoading: isGetAddressVerificationLoading,
        isGetAddressVerificationSuccess: isGetAddressVerificationSuccess,
        isGetAddressVerificationError: isGetAddressVerificationError
    };
};




var $4e4c457ff7bc7e24$export$2e2bcd8739ae039 = ()=>{
    const { mutate: getAddressChainRecommendation, data: getAddressChainRecommendationData, error: getAddressChainRecommendationError, isLoading: isGetAddressChainRecommendationLoading, isSuccess: isGetAddressChainRecommendationSuccess, isError: isGetAddressChainRecommendationError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $8c9c17926a9c04e3$export$d358ca153889ac32));
    return {
        getAddressChainRecommendation: getAddressChainRecommendation,
        getAddressChainRecommendationData: getAddressChainRecommendationData,
        getAddressChainRecommendationError: getAddressChainRecommendationError,
        isGetAddressChainRecommendationLoading: isGetAddressChainRecommendationLoading,
        isGetAddressChainRecommendationSuccess: isGetAddressChainRecommendationSuccess,
        isGetAddressChainRecommendationError: isGetAddressChainRecommendationError
    };
};




var $03181c6720d5bf98$export$2e2bcd8739ae039 = ()=>{
    const { mutate: getAddressAccountSummary, data: getAddressAccountSummaryData, error: getAddressAccountSummaryError, isLoading: isGetAddressAccountSummaryLoading, isSuccess: isGetAddressAccountSummarySuccess, isError: isGetAddressAccountSummaryError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $8c9c17926a9c04e3$export$3d7eb20b694016e4));
    return {
        getAddressAccountSummary: getAddressAccountSummary,
        getAddressAccountSummaryData: getAddressAccountSummaryData,
        getAddressAccountSummaryError: getAddressAccountSummaryError,
        isGetAddressAccountSummaryLoading: isGetAddressAccountSummaryLoading,
        isGetAddressAccountSummarySuccess: isGetAddressAccountSummarySuccess,
        isGetAddressAccountSummaryError: isGetAddressAccountSummaryError
    };
};




var $2a86427d3edf9a86$export$2e2bcd8739ae039 = ()=>{
    const { mutate: getAddressChains, data: getAddressChainsData, error: getAddressChainsError, isLoading: isGetAddressChainsLoading, isSuccess: isGetAddressChainsSuccess, isError: isGetAddressChainsError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $8c9c17926a9c04e3$export$94787a1ce1810c2d));
    return {
        getAddressChains: getAddressChains,
        getAddressChainsData: getAddressChainsData,
        getAddressChainsError: getAddressChainsError,
        isGetAddressChainsLoading: isGetAddressChainsLoading,
        isGetAddressChainsSuccess: isGetAddressChainsSuccess,
        isGetAddressChainsError: isGetAddressChainsError
    };
};




var $2290198e2bfa0bad$export$2e2bcd8739ae039 = ()=>{
    const { mutate: updateAddressHosted, data: updateAddressHostedData, error: updateAddressHostedError, isLoading: isUpdateAddressHostedLoading, isSuccess: isUpdateAddressHostedSuccess, isError: isUpdateAddressHostedError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $8c9c17926a9c04e3$export$e2511a51425367e7));
    return {
        updateAddressHosted: updateAddressHosted,
        updateAddressHostedData: updateAddressHostedData,
        updateAddressHostedError: updateAddressHostedError,
        isUpdateAddressHostedLoading: isUpdateAddressHostedLoading,
        isUpdateAddressHostedSuccess: isUpdateAddressHostedSuccess,
        isUpdateAddressHostedError: isUpdateAddressHostedError
    };
};






const { CREATE_OR_UPDATE_TRANSACTION: $d8ece7ca134df21e$var$CREATE_OR_UPDATE_TRANSACTION, LINK_TRANSACTION: $d8ece7ca134df21e$var$LINK_TRANSACTION, DELETE_TRANSACTION: $d8ece7ca134df21e$var$DELETE_TRANSACTION, GET_TRANSACTIONS: $d8ece7ca134df21e$var$GET_TRANSACTIONS, GET_TRANSACTION_DETAILS: $d8ece7ca134df21e$var$GET_TRANSACTION_DETAILS, GET_TRANSACTION_HISTORY: $d8ece7ca134df21e$var$GET_TRANSACTION_HISTORY, POST_TRANSACTION_REPORT: $d8ece7ca134df21e$var$POST_TRANSACTION_REPORT, GET_TRANSACTION_EVENTS: $d8ece7ca134df21e$var$GET_TRANSACTION_EVENTS, GET_TRANSACTION_CHAINS: $d8ece7ca134df21e$var$GET_TRANSACTION_CHAINS } = (0, $78597906e6a0205e$export$c78ee076f149ce6c);
const $d8ece7ca134df21e$export$ca8561d2f81b8b2f = (0, $e29db2de9829c254$export$456995facc43eda)((0, $78597906e6a0205e$export$6c611141e7030bb8));
const $d8ece7ca134df21e$var$handler = (0, $e29db2de9829c254$export$38b0b8222efbc769);
const $d8ece7ca134df21e$export$c082062b1c45296b = async ({ transaction: transaction, chain: chain, type: type, integration_id: integration_id, link_id: link_id, name_first: name_first, name_last: name_last })=>{
    const response = await $d8ece7ca134df21e$var$handler.post($d8ece7ca134df21e$var$CREATE_OR_UPDATE_TRANSACTION, {
        transaction: transaction,
        chain: chain,
        type: type,
        integration_id: integration_id,
        link_id: link_id,
        name_first: name_first,
        name_last: name_last
    });
    const { data: data } = response.data;
    return data;
};
const $d8ece7ca134df21e$export$afadc640ea143d7d = async ({ sender_link_id: sender_link_id, sender_link_type: sender_link_type, recipient_link_id: recipient_link_id, recipient_link_type: recipient_link_type, transaction_id: transaction_id })=>{
    const response = await $d8ece7ca134df21e$var$handler.patch(`${$d8ece7ca134df21e$var$LINK_TRANSACTION}/${transaction_id}/link`, {
        sender_link_id: sender_link_id,
        sender_link_type: sender_link_type,
        recipient_link_id: recipient_link_id,
        recipient_link_type: recipient_link_type
    });
    const { data: data } = response.data;
    return data;
};
const $d8ece7ca134df21e$export$eb0748c24dfdbd93 = async ({ transaction_id: transaction_id })=>{
    const response = await $d8ece7ca134df21e$var$handler.patch(`${$d8ece7ca134df21e$var$DELETE_TRANSACTION}/${transaction_id}`);
    const { data: data } = response.data;
    return data;
};
const $d8ece7ca134df21e$export$35f28d4d8e992719 = async ({ start_range: start_range, end_range: end_range, page: page, size: size, sort: sort, link_id: link_id, identified: identified })=>{
    const params = {
        start_range: start_range && start_range,
        end_range: end_range && end_range,
        start_range_create: start_range && start_range,
        end_range_create: end_range && end_range,
        page: page && page,
        size: size && size,
        sort: sort && sort
    };
    if (link_id) params.link_id = link_id;
    if (identified === false || identified === true) params.identified = identified;
    const response = await $d8ece7ca134df21e$var$handler.get($d8ece7ca134df21e$var$GET_TRANSACTIONS, {
        params: params
    });
    const { data: data } = response.data;
    return data;
};
const $d8ece7ca134df21e$export$e40815f9459d2159 = async ({ transaction_id: transaction_id, start_range: start_range, end_range: end_range, page: page, size: size, sort: sort })=>{
    const response = await $d8ece7ca134df21e$var$handler.get(`${$d8ece7ca134df21e$var$GET_TRANSACTION_DETAILS}/${transaction_id}`, {
        params: {
            start_range: start_range && start_range,
            end_range: end_range && end_range,
            page: page && page,
            size: size && size,
            sort: sort && sort
        }
    });
    const { data: data } = response.data;
    return data;
};
const $d8ece7ca134df21e$export$a5d733078d9d30f8 = async ({ transaction_id: transaction_id, start_range: start_range, end_range: end_range, page: page, size: size, sort: sort })=>{
    const response = await $d8ece7ca134df21e$var$handler.get(`${$d8ece7ca134df21e$var$GET_TRANSACTION_HISTORY}/${transaction_id}/history`, {
        params: {
            start_range: start_range && start_range,
            end_range: end_range && end_range,
            page: page && page,
            size: size && size,
            sort: sort && sort
        }
    });
    const { data: data } = response.data;
    return data;
};
const $d8ece7ca134df21e$export$ffb8cda401c1854f = async ({ transaction_id: transaction_id, sections: sections })=>{
    let url = `${$d8ece7ca134df21e$var$POST_TRANSACTION_REPORT}/${transaction_id}/`;
    if (sections?.length > 0) url += `reports?sections=${sections.join(',')}`;
    const response = await $d8ece7ca134df21e$var$handler.post(url);
    const { data: data } = response.data;
    return data;
};
const $d8ece7ca134df21e$export$3dd51e9f3226208b = async ({ transaction_id: transaction_id, page: page, type: type, linked: linked, risk_integration_id: risk_integration_id })=>{
    const params = {
        sort: '-amount_usd',
        size: 10,
        page: page,
        type: type
    };
    if (risk_integration_id) params.risk_integration_id = risk_integration_id;
    if (linked) params.linked = linked;
    const response = await $d8ece7ca134df21e$var$handler.get(`${$d8ece7ca134df21e$var$GET_TRANSACTION_EVENTS}/${transaction_id}/events`, {
        params: params
    });
    const { data: data } = response.data;
    return data;
};
const $d8ece7ca134df21e$export$f2b7aedf132c7f00 = async (props)=>{
    const params = {};
    if (props?.provider_name) params.provider_name = props?.provider_name;
    const response = await $d8ece7ca134df21e$var$handler.get($d8ece7ca134df21e$var$GET_TRANSACTION_CHAINS, {
        params: params
    });
    const { data: data } = response.data;
    return data;
};


var $aefb40a6e68b4bb6$export$2e2bcd8739ae039 = ()=>{
    const { mutate: createOrUpdateTransaction, data: createOrUpdateTransactionData, error: createOrUpdateTransactionError, isLoading: isCreateOrUpdateTransactionLoading, isSuccess: isCreateOrUpdateTransactionSuccess, isError: isCreateOrUpdateTransactionError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $d8ece7ca134df21e$export$c082062b1c45296b));
    return {
        createOrUpdateTransaction: createOrUpdateTransaction,
        createOrUpdateTransactionData: createOrUpdateTransactionData,
        createOrUpdateTransactionError: createOrUpdateTransactionError,
        isCreateOrUpdateTransactionLoading: isCreateOrUpdateTransactionLoading,
        isCreateOrUpdateTransactionSuccess: isCreateOrUpdateTransactionSuccess,
        isCreateOrUpdateTransactionError: isCreateOrUpdateTransactionError
    };
};




var $0827fde0dd8ade0d$export$2e2bcd8739ae039 = ()=>{
    const { mutate: deleteTransaction, data: deleteTransactionData, error: deleteTransactionError, isLoading: isDeleteTransactionLoading, isSuccess: isDeleteTransactionSuccess, isError: isDeleteTransactionError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $d8ece7ca134df21e$export$eb0748c24dfdbd93));
    return {
        deleteTransaction: deleteTransaction,
        deleteTransactionData: deleteTransactionData,
        deleteTransactionError: deleteTransactionError,
        isDeleteTransactionLoading: isDeleteTransactionLoading,
        isDeleteTransactionSuccess: isDeleteTransactionSuccess,
        isDeleteTransactionError: isDeleteTransactionError
    };
};




var $a3ec4001c3088a08$export$2e2bcd8739ae039 = ()=>{
    const { mutate: getTransactions, data: getTransactionsData, error: getTransactionsError, isLoading: isGetTransactionsLoading, isSuccess: isGetTransactionsSuccess, isError: isGetTransactionsError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $d8ece7ca134df21e$export$35f28d4d8e992719));
    return {
        getTransactions: getTransactions,
        getTransactionsData: getTransactionsData,
        getTransactionsError: getTransactionsError,
        isGetTransactionsLoading: isGetTransactionsLoading,
        isGetTransactionsSuccess: isGetTransactionsSuccess,
        isGetTransactionsError: isGetTransactionsError
    };
};




var $d2d7bca3caa22367$export$2e2bcd8739ae039 = ()=>{
    const { mutate: getTransactionDetails, data: getTransactionDetailsData, error: getTransactionDetailsError, isLoading: isGetTransactionDetailsLoading, isSuccess: isGetTransactionDetailsSuccess, isError: isGetTransactionDetailsError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $d8ece7ca134df21e$export$e40815f9459d2159));
    return {
        getTransactionDetails: getTransactionDetails,
        getTransactionDetailsData: getTransactionDetailsData,
        getTransactionDetailsError: getTransactionDetailsError,
        isGetTransactionDetailsLoading: isGetTransactionDetailsLoading,
        isGetTransactionDetailsSuccess: isGetTransactionDetailsSuccess,
        isGetTransactionDetailsError: isGetTransactionDetailsError
    };
};




var $a3bb46046c50a087$export$2e2bcd8739ae039 = ()=>{
    const { mutate: postTransactionReport, data: postTransactionReportData, error: postTransactionReportError, isLoading: isPostTransactionReportLoading, isSuccess: isPostTransactionReportSuccess, isError: isPostTransactionReportError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $d8ece7ca134df21e$export$ffb8cda401c1854f));
    return {
        postTransactionReport: postTransactionReport,
        postTransactionReportData: postTransactionReportData,
        postTransactionReportError: postTransactionReportError,
        isPostTransactionReportLoading: isPostTransactionReportLoading,
        isPostTransactionReportSuccess: isPostTransactionReportSuccess,
        isPostTransactionReportError: isPostTransactionReportError
    };
};




var $26785fe260154fd9$export$2e2bcd8739ae039 = ()=>{
    const { mutate: getTransactionHistory, data: getTransactionHistoryData, error: getTransactionHistoryError, isLoading: isGetTransactionHistoryLoading, isSuccess: isGetTransactionHistorySuccess, isError: isGetTransactionHistoryError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $d8ece7ca134df21e$export$a5d733078d9d30f8));
    return {
        getTransactionHistory: getTransactionHistory,
        getTransactionHistoryData: getTransactionHistoryData,
        getTransactionHistoryError: getTransactionHistoryError,
        isGetTransactionHistoryLoading: isGetTransactionHistoryLoading,
        isGetTransactionHistorySuccess: isGetTransactionHistorySuccess,
        isGetTransactionHistoryError: isGetTransactionHistoryError
    };
};




var $71a492bad1b3f350$export$2e2bcd8739ae039 = ()=>{
    const { mutate: getTransactionEvents, data: getTransactionEventsData, error: getTransactionEventsError, isLoading: isGetTransactionEventsLoading, isSuccess: isGetTransactionEventsSuccess, isError: isGetTransactionEventsError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $d8ece7ca134df21e$export$3dd51e9f3226208b));
    return {
        getTransactionEvents: getTransactionEvents,
        getTransactionEventsData: getTransactionEventsData,
        getTransactionEventsError: getTransactionEventsError,
        isGetTransactionEventsLoading: isGetTransactionEventsLoading,
        isGetTransactionEventsSuccess: isGetTransactionEventsSuccess,
        isGetTransactionEventsError: isGetTransactionEventsError
    };
};




var $13b0a53fe27a5cf7$export$2e2bcd8739ae039 = ()=>{
    const { mutate: linkTransaction, data: linkTransactionData, error: linkTransactionError, isLoading: isLinkTransactionLoading, isSuccess: isLinkTransactionSuccess, isError: isLinkTransactionError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $d8ece7ca134df21e$export$afadc640ea143d7d));
    return {
        linkTransaction: linkTransaction,
        linkTransactionData: linkTransactionData,
        linkTransactionError: linkTransactionError,
        isLinkTransactionLoading: isLinkTransactionLoading,
        isLinkTransactionSuccess: isLinkTransactionSuccess,
        isLinkTransactionError: isLinkTransactionError
    };
};




var $df6fa9f2dd2e4bb8$export$2e2bcd8739ae039 = ()=>{
    const { mutate: getTransactionChains, data: getTransactionChainsData, error: getTransactionChainsError, isLoading: isGetTransactionChainsLoading, isSuccess: isGetTransactionChainsSuccess, isError: isGetTransactionChainsError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $d8ece7ca134df21e$export$f2b7aedf132c7f00));
    return {
        getTransactionChains: getTransactionChains,
        getTransactionChainsData: getTransactionChainsData,
        getTransactionChainsError: getTransactionChainsError,
        isGetTransactionChainsLoading: isGetTransactionChainsLoading,
        isGetTransactionChainsSuccess: isGetTransactionChainsSuccess,
        isGetTransactionChainsError: isGetTransactionChainsError
    };
};






const { GET_REPORTS: $5b7482b0efa357b8$var$GET_REPORTS, GET_REPORT: $5b7482b0efa357b8$var$GET_REPORT, GET_REPORTS_TRANSACTION: $5b7482b0efa357b8$var$GET_REPORTS_TRANSACTION, GET_REPORTS_TRAVELRULE: $5b7482b0efa357b8$var$GET_REPORTS_TRAVELRULE } = (0, $78597906e6a0205e$export$52fc864b1319068d);
const $5b7482b0efa357b8$export$ca8561d2f81b8b2f = (0, $e29db2de9829c254$export$456995facc43eda)((0, $78597906e6a0205e$export$6c611141e7030bb8));
const $5b7482b0efa357b8$var$handler = (0, $e29db2de9829c254$export$38b0b8222efbc769);
const $5b7482b0efa357b8$export$dcb5a43ba25be454 = async ({ start_range: start_range, end_range: end_range, sort: sort, page: page, size: size })=>{
    const response = await $5b7482b0efa357b8$var$handler.get($5b7482b0efa357b8$var$GET_REPORTS, {
        params: {
            start_range: start_range,
            end_range: end_range,
            sort: sort,
            page: page,
            size: size
        }
    });
    const { data: data } = response.data;
    return data;
};
const $5b7482b0efa357b8$export$bb922762d8d3c4a2 = async ({ format: format, report_id: report_id })=>{
    const response = await $5b7482b0efa357b8$var$handler.get(`${$5b7482b0efa357b8$var$GET_REPORT}/${report_id}`, {
        params: {
            format: format
        }
    });
    return response.data;
};
const $5b7482b0efa357b8$export$514e2610526b91bb = async ({ start_range: start_range, end_range: end_range, sort: sort, page: page, size: size })=>{
    const response = await $5b7482b0efa357b8$var$handler.get($5b7482b0efa357b8$var$GET_REPORTS_TRANSACTION, {
        params: {
            start_range: start_range,
            end_range: end_range,
            sort: sort,
            page: page,
            size: size
        }
    });
    const { data: data } = response.data;
    return data;
};
const $5b7482b0efa357b8$export$d4d083a3d1e6bf3b = async ({ page: page, size: size })=>{
    const response = await $5b7482b0efa357b8$var$handler.get($5b7482b0efa357b8$var$GET_REPORTS_TRAVELRULE, {
        params: {
            page: page,
            size: size
        }
    });
    const { data: data } = response.data;
    return data;
};
const $5b7482b0efa357b8$export$bd612a653bebf9af = async ({ id: id, format: format })=>{
    const response = await $5b7482b0efa357b8$var$handler.get(`${$5b7482b0efa357b8$var$GET_REPORTS_TRAVELRULE}/${id}`, {
        params: {
            format: format
        }
    });
    const { data: data } = response;
    return data;
};


var $36ce18437b7b3465$export$2e2bcd8739ae039 = ()=>{
    const { mutate: getReports, data: getReportsData, error: getReportsError, isLoading: isGetReportsLoading, isSuccess: isGetReportsSuccess, isError: isGetReportsError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $5b7482b0efa357b8$export$dcb5a43ba25be454));
    return {
        getReports: getReports,
        getReportsData: getReportsData,
        getReportsError: getReportsError,
        isGetReportsLoading: isGetReportsLoading,
        isGetReportsSuccess: isGetReportsSuccess,
        isGetReportsError: isGetReportsError
    };
};




var $103aa3f158259fba$export$2e2bcd8739ae039 = ()=>{
    const { mutate: getReport, data: getReportData, error: getReportError, isLoading: isGetReportLoading, isSuccess: isGetReportSuccess, isError: isGetReportError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $5b7482b0efa357b8$export$bb922762d8d3c4a2));
    return {
        getReport: getReport,
        getReportData: getReportData,
        getReportError: getReportError,
        isGetReportLoading: isGetReportLoading,
        isGetReportSuccess: isGetReportSuccess,
        isGetReportError: isGetReportError
    };
};




var $d1ff954cbafe08bf$export$2e2bcd8739ae039 = ()=>{
    const { mutate: getReportsTransaction, data: getReportsTransactionData, error: getReportsTransactionError, isLoading: isGetReportsTransactionLoading, isSuccess: isGetReportsTransactionSuccess, isError: isGetReportsTransactionError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $5b7482b0efa357b8$export$514e2610526b91bb));
    return {
        getReportsTransaction: getReportsTransaction,
        getReportsTransactionData: getReportsTransactionData,
        getReportsTransactionError: getReportsTransactionError,
        isGetReportsTransactionLoading: isGetReportsTransactionLoading,
        isGetReportsTransactionSuccess: isGetReportsTransactionSuccess,
        isGetReportsTransactionError: isGetReportsTransactionError
    };
};




var $f8d91779561de169$export$2e2bcd8739ae039 = ()=>{
    const { mutate: getReportsTravelRule, data: getReportsTravelRuleData, error: getReportsTravelRuleError, isLoading: isGetReportsTravelRuleLoading, isSuccess: isGetReportsTravelRuleSuccess, isError: isGetReportsTravelRuleError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $5b7482b0efa357b8$export$d4d083a3d1e6bf3b));
    return {
        getReportsTravelRule: getReportsTravelRule,
        getReportsTravelRuleData: getReportsTravelRuleData,
        getReportsTravelRuleError: getReportsTravelRuleError,
        isGetReportsTravelRuleLoading: isGetReportsTravelRuleLoading,
        isGetReportsTravelRuleSuccess: isGetReportsTravelRuleSuccess,
        isGetReportsTravelRuleError: isGetReportsTravelRuleError
    };
};




var $b9f6cf529e1dcb94$export$2e2bcd8739ae039 = ()=>{
    const { mutate: downloadReportsTravelRule, data: downloadReportsTravelRuleData, error: downloadReportsTravelRuleError, isLoading: isDownloadReportsTravelRuleLoading, isSuccess: isDownloadReportsTravelRuleSuccess, isError: isDownloadReportsTravelRuleError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $5b7482b0efa357b8$export$bd612a653bebf9af));
    return {
        downloadReportsTravelRule: downloadReportsTravelRule,
        downloadReportsTravelRuleData: downloadReportsTravelRuleData,
        downloadReportsTravelRuleError: downloadReportsTravelRuleError,
        isDownloadReportsTravelRuleLoading: isDownloadReportsTravelRuleLoading,
        isDownloadReportsTravelRuleSuccess: isDownloadReportsTravelRuleSuccess,
        isDownloadReportsTravelRuleError: isDownloadReportsTravelRuleError
    };
};





const $3cc5fe7407baafa2$var$accessToken = JSON.parse(localStorage.getItem('userCredentials'))?.access_token;
const $3cc5fe7407baafa2$export$38b0b8222efbc769 = (0, (/*@__PURE__*/$parcel$interopDefault($f3d855b3ff65dabd$exports))).create({
    baseURL: 'https://dev-detect.ospree.io/',
    headers: {
        Authorization: `Bearer ${$3cc5fe7407baafa2$var$accessToken}`
    }
});
const $3cc5fe7407baafa2$var$handler = $3cc5fe7407baafa2$export$38b0b8222efbc769;
const $3cc5fe7407baafa2$export$16591a4cc1bc205f = async ({ business_id: business_id })=>{
    const response = await $3cc5fe7407baafa2$var$handler.get(`${(0, $78597906e6a0205e$export$a6e37b2331bd3fc6).READ_ALL_ALERTS}/${business_id}`);
    const data = response.data.content;
    return data;
};
const $3cc5fe7407baafa2$export$b9046d3166780bcc = async ({ alert_id: alert_id })=>{
    const response = await $3cc5fe7407baafa2$var$handler.get(`${(0, $78597906e6a0205e$export$a6e37b2331bd3fc6).READ_ALERT_DETAILS}/${alert_id}`);
    const data = response.data.content;
    return data;
};
const $3cc5fe7407baafa2$export$5132985ff71870a7 = async ()=>{
    const response = await $3cc5fe7407baafa2$var$handler.get((0, $78597906e6a0205e$export$a6e37b2331bd3fc6).READ_DAILY_ALERTS, {});
    const data = response.data.content;
    return data;
};
const $3cc5fe7407baafa2$export$a345c542129bae55 = async ()=>{
    const response = await $3cc5fe7407baafa2$var$handler.get((0, $78597906e6a0205e$export$a6e37b2331bd3fc6).READ_ALERTS_BY_SEVERITY, {});
    const data = response.data.content;
    return data;
};
const $3cc5fe7407baafa2$export$ac451cdc27812c1f = async ()=>{
    const response = await $3cc5fe7407baafa2$var$handler.get((0, $78597906e6a0205e$export$a6e37b2331bd3fc6).READ_ALERTS_BY_STATUS, {});
    const data = response.data.content;
    return data;
};


var $e163b79ea15b549c$export$2e2bcd8739ae039 = ()=>{
    const { mutate: getAlertDetails, data: alertDetailsData, error: alertDetailsError, isLoading: isAlertDetailsLoading, isSuccess: isAlertDetailsSuccess, isError: isAlertDetailsError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $3cc5fe7407baafa2$export$b9046d3166780bcc));
    return {
        getAlertDetails: getAlertDetails,
        alertDetailsData: alertDetailsData,
        alertDetailsError: alertDetailsError,
        isAlertDetailsLoading: isAlertDetailsLoading,
        isAlertDetailsSuccess: isAlertDetailsSuccess,
        isAlertDetailsError: isAlertDetailsError
    };
};



var $tZqWC = parcelRequire("tZqWC");


var $3fb08023856b302d$export$2e2bcd8739ae039 = ()=>{
    // States
    const [alertsBySeverityData, setAlertsBySeverityData] = (0, $tZqWC.useState)({});
    const { mutate: getAlertsBySeverity, error: alertsBySeverityError, isLoading: isAlertsBySeverityLoading, isSuccess: isAlertsBySeveritySuccess, isError: isAlertsBySeverityError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $3cc5fe7407baafa2$export$a345c542129bae55), {
        onSuccess: (data)=>{
            formatData(data);
        }
    });
    // Functions
    const formatData = (data)=>{
        let finalData = {
            uiData: [],
            chartData: {
                labels: [
                    'High',
                    'Medium',
                    'Low'
                ],
                datasets: [
                    {
                        backgroundColor: [
                            '#F45C65cc',
                            '#FFB502cc',
                            '#89CF82cc'
                        ],
                        data: [
                            0,
                            0,
                            0
                        ]
                    }
                ]
            }
        };
        const formattedData = [
            {
                alert_count: 0,
                severity: 'High',
                percent: 0
            },
            {
                alert_count: 0,
                severity: 'Medium',
                percent: 0
            },
            {
                alert_count: 0,
                severity: 'Low',
                percent: 0
            }
        ];
        let totalCount = 0;
        data.forEach((item)=>{
            if (item) totalCount += item.alert_count;
        });
        data.forEach((item)=>{
            formattedData.forEach((alert, i)=>{
                if (item.severity === alert.severity) {
                    const currentItem = {
                        ...item,
                        percent: Math.round(item.alert_count / totalCount * 100)
                    };
                    formattedData[i] = currentItem;
                    finalData.chartData.datasets[0].data[i] = item.alert_count;
                }
            });
        });
        finalData = {
            ...finalData,
            uiData: formattedData
        };
        setAlertsBySeverityData(finalData);
    };
    return {
        getAlertsBySeverity: getAlertsBySeverity,
        alertsBySeverityData: alertsBySeverityData,
        alertsBySeverityError: alertsBySeverityError,
        isAlertsBySeverityLoading: isAlertsBySeverityLoading,
        isAlertsBySeveritySuccess: isAlertsBySeveritySuccess,
        isAlertsBySeverityError: isAlertsBySeverityError
    };
};



var $tZqWC = parcelRequire("tZqWC");


var $c6d9ef260a4e75a1$export$2e2bcd8739ae039 = ()=>{
    // States
    const [alertsByStatusData, setAlertStatusData] = (0, $tZqWC.useState)([]);
    const { mutate: getAlertsByStatus, error: alertsByStatusError, isLoading: isAlertsByStatusLoading, isSuccess: isAlertsByStatusSuccess, isError: isAlertsByStatusError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $3cc5fe7407baafa2$export$ac451cdc27812c1f), {
        onSuccess: (data)=>{
            const finalData = formatData(data);
            setAlertStatusData(finalData);
        }
    });
    // Functions
    const formatData = (data)=>{
        const formattedData = [
            {
                alert_count: 0,
                alert_status: 'Open',
                percent: 0
            },
            {
                alert_count: 0,
                alert_status: 'Pending',
                percent: 0
            },
            {
                alert_count: 0,
                alert_status: 'Closed',
                percent: 0
            }
        ];
        let totalCount = 0;
        data.forEach((item)=>{
            if (item) totalCount += item.alert_count;
        });
        data.forEach((item)=>{
            formattedData.forEach((alert, i)=>{
                if (item.alert_status === alert.alert_status) {
                    const currentItem = {
                        ...item,
                        percent: Math.round(item.alert_count / totalCount * 100)
                    };
                    formattedData[i] = currentItem;
                }
            });
        });
        return formattedData;
    };
    return {
        getAlertsByStatus: getAlertsByStatus,
        alertsByStatusData: alertsByStatusData,
        alertsByStatusError: alertsByStatusError,
        isAlertsByStatusLoading: isAlertsByStatusLoading,
        isAlertsByStatusSuccess: isAlertsByStatusSuccess,
        isAlertsByStatusError: isAlertsByStatusError
    };
};




var $5b4146384469fdfb$export$2e2bcd8739ae039 = ()=>{
    const { mutate: getAllAlerts, data: allAlertsData, error: allAlertsError, isLoading: isAllAlertsLoading, isSuccess: isAllAlertsSuccess, isError: isAllAlertsError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $3cc5fe7407baafa2$export$16591a4cc1bc205f));
    return {
        getAllAlerts: getAllAlerts,
        allAlertsData: allAlertsData,
        allAlertsError: allAlertsError,
        isAllAlertsLoading: isAllAlertsLoading,
        isAllAlertsSuccess: isAllAlertsSuccess,
        isAllAlertsError: isAllAlertsError
    };
};



var $tZqWC = parcelRequire("tZqWC");

var $ejSM7 = parcelRequire("ejSM7");



var $27f148c4d90fd606$export$2e2bcd8739ae039 = ()=>{
    // States
    const [dailyAlertsData, setDailyAlertsData] = (0, $tZqWC.useState)({
        labels: [],
        datasets: [
            {
                backgroundColor: '#cbcbcb',
                data: [],
                label: 'Daily Activity'
            }
        ]
    });
    // Hooks
    const { mutate: getDailyAlerts, error: dailyAlertsError, isLoading: isDailyAlertsLoading, isSuccess: isDailyAlertsSuccess, isError: isDailyAlertsError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $3cc5fe7407baafa2$export$5132985ff71870a7), {
        onSuccess: (data, params)=>{
            const chartData = getDates(data, params);
            const labels = chartData.map((o)=>o.label);
            const values = chartData.map((o)=>o.count);
            setDailyAlertsData({
                labels: labels,
                datasets: [
                    {
                        label: 'Daily Activity',
                        data: values,
                        backgroundColor: '#cbcbcb'
                    }
                ]
            });
        }
    });
    // Functions
    const getDates = (data, params)=>{
        const { start_range: start_range, end_range: end_range } = params;
        const days = [];
        let currentDate = (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(start_range || (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))().subtract(30, 'days'));
        const stopDate = (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(end_range || (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))().add(1, 'days'));
        while(currentDate <= stopDate){
            days.push({
                label: (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(currentDate).format((0, $41a9e38e6be32f35$export$1bceb808939a9f0c))
            });
            currentDate = (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(currentDate).add(1, 'days');
        }
        const copyArr = days;
        data.forEach((result)=>{
            copyArr.forEach((item, i)=>{
                if (result.alert_date === item.label) days[i].count = result.alert_count;
            });
        });
        days.forEach((item, i)=>{
            if (item.count === undefined) days[i].count = 0;
        });
        return days;
    };
    return {
        getDailyAlerts: getDailyAlerts,
        dailyAlertsData: dailyAlertsData,
        dailyAlertsError: dailyAlertsError,
        isDailyAlertsLoading: isDailyAlertsLoading,
        isDailyAlertsSuccess: isDailyAlertsSuccess,
        isDailyAlertsError: isDailyAlertsError
    };
};





const $239355283cc4ab66$export$ca8561d2f81b8b2f = (0, $e29db2de9829c254$export$456995facc43eda)((0, $78597906e6a0205e$export$a675fe6880411505));
const $239355283cc4ab66$var$handler = $239355283cc4ab66$export$ca8561d2f81b8b2f;
const $239355283cc4ab66$export$996fb761eb4d2bcf = async ({ user_id: user_id })=>{
    const response = await $239355283cc4ab66$var$handler.get((0, $78597906e6a0205e$export$f14b72fcf3d169b9).READ_PROFILE, {
        params: {
            user_id: user_id
        }
    });
    const { data: data } = response;
    return data;
};
const $239355283cc4ab66$export$461d57057689c456 = async ({ data: data })=>{
    const response = await $239355283cc4ab66$var$handler.patch(`${(0, $78597906e6a0205e$export$f14b72fcf3d169b9).UPDATE_PROFILE}`, data);
    const { data: result } = response.data;
    return result;
};
const $239355283cc4ab66$export$3da287ea6ff827dd = async ()=>{
    const response = await $239355283cc4ab66$var$handler.get((0, $78597906e6a0205e$export$f14b72fcf3d169b9).REQUEST_EMAIL_VERIFICATION);
    const { data: result } = response.data;
    return result;
};
const $239355283cc4ab66$export$3d3197b723615cc = async ({ auth_hash: auth_hash })=>{
    const response = await (0, $e29db2de9829c254$export$170e87424a0d64a3).post(`${(0, $78597906e6a0205e$export$f14b72fcf3d169b9).REQUEST_EMAIL_VERIFICATION}/${auth_hash}`);
    const { data: result } = response.data;
    return result;
};
const $239355283cc4ab66$export$d5f357cbc0d5adc1 = async ({ auth_hash: auth_hash })=>{
    const response = await (0, $e29db2de9829c254$export$170e87424a0d64a3).get(`${(0, $78597906e6a0205e$export$f14b72fcf3d169b9).GET_ACTIVATION_LINK}${auth_hash}`);
    const { data: result } = response.data;
    return result;
};
const $239355283cc4ab66$export$bebba8e7426b8898 = async ({ auth_hash: auth_hash, password: password })=>{
    const response = await (0, $e29db2de9829c254$export$170e87424a0d64a3).post(`${(0, $78597906e6a0205e$export$f14b72fcf3d169b9).ACTIVATE_USER}${auth_hash}`, {
        password: password
    });
    const { data: result } = response.data;
    return result;
};


var $be08dd052e274e7c$export$2e2bcd8739ae039 = ()=>{
    const { mutate: getUserProfile, data: userProfileData, error: userProfileError, isLoading: isUserProfileLoading, isSuccess: isUserProfileSuccess, isError: isUserProfileError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $239355283cc4ab66$export$996fb761eb4d2bcf));
    return {
        getUserProfile: getUserProfile,
        userProfileData: userProfileData,
        userProfileError: userProfileError,
        isUserProfileLoading: isUserProfileLoading,
        isUserProfileSuccess: isUserProfileSuccess,
        isUserProfileError: isUserProfileError
    };
};




var $60d2f030b368f304$export$2e2bcd8739ae039 = ()=>{
    const { mutate: updateProfile, data: updateProfileData, error: updateProfileError, isLoading: isUpdateProfileLoading, isSuccess: isUpdateProfileSuccess, isError: isUpdateProfileError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $239355283cc4ab66$export$461d57057689c456));
    return {
        updateProfile: updateProfile,
        updateProfileData: updateProfileData,
        updateProfileError: updateProfileError,
        isUpdateProfileLoading: isUpdateProfileLoading,
        isUpdateProfileSuccess: isUpdateProfileSuccess,
        isUpdateProfileError: isUpdateProfileError
    };
};




var $f418456b89a69838$export$2e2bcd8739ae039 = ()=>{
    const { mutate: requestEmailVerification, data: requestEmailVerificationData, error: requestEmailVerificationError, isLoading: isRequestEmailVerificationLoading, isSuccess: isRequestEmailVerificationSuccess, isError: isRequestEmailVerificationError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $239355283cc4ab66$export$3da287ea6ff827dd));
    return {
        requestEmailVerification: requestEmailVerification,
        requestEmailVerificationData: requestEmailVerificationData,
        requestEmailVerificationError: requestEmailVerificationError,
        isRequestEmailVerificationLoading: isRequestEmailVerificationLoading,
        isRequestEmailVerificationSuccess: isRequestEmailVerificationSuccess,
        isRequestEmailVerificationError: isRequestEmailVerificationError
    };
};




var $806601e89d0fc801$export$2e2bcd8739ae039 = ()=>{
    const { mutate: verifyEmail, data: verifyEmailData, error: verifyEmailError, isLoading: isVerifyEmailLoading, isSuccess: isVerifyEmailSuccess, isError: isVerifyEmailError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $239355283cc4ab66$export$3d3197b723615cc));
    return {
        verifyEmail: verifyEmail,
        verifyEmailData: verifyEmailData,
        verifyEmailError: verifyEmailError,
        isVerifyEmailLoading: isVerifyEmailLoading,
        isVerifyEmailSuccess: isVerifyEmailSuccess,
        isVerifyEmailError: isVerifyEmailError
    };
};




var $ddeab5e5a8dbefdf$export$2e2bcd8739ae039 = ()=>{
    const { mutate: activateUser, data: activateUserData, error: activateUserError, isLoading: isActivateUserLoading, isSuccess: isActivateUserSuccess, isError: isActivateUserError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $239355283cc4ab66$export$bebba8e7426b8898));
    return {
        activateUser: activateUser,
        activateUserData: activateUserData,
        activateUserError: activateUserError,
        isActivateUserLoading: isActivateUserLoading,
        isActivateUserSuccess: isActivateUserSuccess,
        isActivateUserError: isActivateUserError
    };
};




var $1a57e7fc5478509b$export$2e2bcd8739ae039 = ()=>{
    const { mutate: getActivationLink, data: getActivationLinkData, error: getActivationLinkError, isLoading: isGetActivationLinkLoading, isSuccess: isGetActivationLinkSuccess, isError: isGetActivationLinkError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $239355283cc4ab66$export$d5f357cbc0d5adc1));
    return {
        getActivationLink: getActivationLink,
        getActivationLinkData: getActivationLinkData,
        getActivationLinkError: getActivationLinkError,
        isGetActivationLinkLoading: isGetActivationLinkLoading,
        isGetActivationLinkSuccess: isGetActivationLinkSuccess,
        isGetActivationLinkError: isGetActivationLinkError
    };
};





const $d6dc53ba8b614394$export$ca8561d2f81b8b2f = (0, $e29db2de9829c254$export$456995facc43eda)((0, $78597906e6a0205e$export$a675fe6880411505));
const $d6dc53ba8b614394$var$handler = $d6dc53ba8b614394$export$ca8561d2f81b8b2f;
const $d6dc53ba8b614394$export$a9a8d20715d131a1 = async ()=>{
    const response = await $d6dc53ba8b614394$var$handler.get((0, $78597906e6a0205e$export$b3355532f3f0b578).GET_USERS);
    const { data: data } = response.data;
    return data;
};
const $d6dc53ba8b614394$export$15164433f3c92f6 = async ({ email: email, role_id: role_id, name_first: name_first, name_last: name_last })=>{
    const response = await $d6dc53ba8b614394$var$handler.post((0, $78597906e6a0205e$export$b3355532f3f0b578).CREATE_USER, {
        email: email,
        role_id: role_id,
        name_first: name_first,
        name_last: name_last
    });
    const { data: data } = response.data;
    return data;
};
const $d6dc53ba8b614394$export$ec57c8e3efb4453d = async ({ user_id: user_id })=>{
    const response = await $d6dc53ba8b614394$var$handler.post(`${(0, $78597906e6a0205e$export$b3355532f3f0b578).CREATE_USER_ACTIVATION_LINK}${user_id}`);
    const { data: data } = response.data;
    return data;
};
const $d6dc53ba8b614394$export$75543167ef08d8e5 = async ({ user_id: user_id, ...values })=>{
    const response = await $d6dc53ba8b614394$var$handler.patch(`${(0, $78597906e6a0205e$export$b3355532f3f0b578).UPDATE_USER}${user_id}`, {
        ...values
    });
    const { data: data } = response.data;
    return data;
};


var $3f6edbf78d1f8fb8$export$2e2bcd8739ae039 = ()=>{
    const { mutate: createUser, data: createUserData, error: createUserError, isLoading: isCreateUserLoading, isSuccess: isCreateUserSuccess, isError: isCreateUserError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $d6dc53ba8b614394$export$15164433f3c92f6));
    return {
        createUser: createUser,
        createUserData: createUserData,
        createUserError: createUserError,
        isCreateUserLoading: isCreateUserLoading,
        isCreateUserSuccess: isCreateUserSuccess,
        isCreateUserError: isCreateUserError
    };
};




var $53f9d00d6955a0cf$export$2e2bcd8739ae039 = ()=>{
    const { mutate: createUserActivationLink, data: createUserActivationLinkData, error: createUserActivationLinkError, isLoading: isCreateUserActivationLinkLoading, isSuccess: isCreateUserActivationLinkSuccess, isError: isCreateUserActivationLinkError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $d6dc53ba8b614394$export$ec57c8e3efb4453d));
    return {
        createUserActivationLink: createUserActivationLink,
        createUserActivationLinkData: createUserActivationLinkData,
        createUserActivationLinkError: createUserActivationLinkError,
        isCreateUserActivationLinkLoading: isCreateUserActivationLinkLoading,
        isCreateUserActivationLinkSuccess: isCreateUserActivationLinkSuccess,
        isCreateUserActivationLinkError: isCreateUserActivationLinkError
    };
};




var $ac762e7709953823$export$2e2bcd8739ae039 = ()=>{
    const { mutate: getUsers, data: getUsersData, error: getUsersError, isLoading: isGetUsersLoading, isSuccess: isGetUsersSuccess, isError: isGetUsersError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $d6dc53ba8b614394$export$a9a8d20715d131a1));
    return {
        getUsers: getUsers,
        getUsersData: getUsersData,
        getUsersError: getUsersError,
        isGetUsersLoading: isGetUsersLoading,
        isGetUsersSuccess: isGetUsersSuccess,
        isGetUsersError: isGetUsersError
    };
};




var $006abbba5bd33f8a$export$2e2bcd8739ae039 = ()=>{
    const { mutate: updateUser, data: updateUserData, error: updateUserError, isLoading: isUpdateUserLoading, isSuccess: isUpdateUserSuccess, isError: isUpdateUserError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $d6dc53ba8b614394$export$75543167ef08d8e5));
    return {
        updateUser: updateUser,
        updateUserData: updateUserData,
        updateUserError: updateUserError,
        isUpdateUserLoading: isUpdateUserLoading,
        isUpdateUserSuccess: isUpdateUserSuccess,
        isUpdateUserError: isUpdateUserError
    };
};





const $dd8e00f3e31f90cd$export$11799acb78619fcd = async (payload)=>{
    const response = await (0, $e29db2de9829c254$export$38b0b8222efbc769).post((0, $78597906e6a0205e$export$37c0b20aa8a4ae01).ADDRESSES, payload);
    const data = response.data.content[0];
    return data;
};
const $dd8e00f3e31f90cd$export$8768c4016d0207d3 = async (payload)=>{
    const response = await (0, $e29db2de9829c254$export$38b0b8222efbc769).post((0, $78597906e6a0205e$export$37c0b20aa8a4ae01).TRANSACTIONS, payload);
    const data = response.data.content[0];
    return data;
};


var $0d7f926a5433859f$export$2e2bcd8739ae039 = ()=>{
    const { mutate: batchUploadAddresses, data: batchUploadAddressesData, error: batchUploadAddressesError, isLoading: isBatchUploadAddressesLoading, isSuccess: isBatchUploadAddressesSuccess, isError: isBatchUploadAddressesError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $dd8e00f3e31f90cd$export$11799acb78619fcd));
    return {
        batchUploadAddresses: batchUploadAddresses,
        batchUploadAddressesData: batchUploadAddressesData,
        batchUploadAddressesError: batchUploadAddressesError,
        isBatchUploadAddressesLoading: isBatchUploadAddressesLoading,
        isBatchUploadAddressesSuccess: isBatchUploadAddressesSuccess,
        isBatchUploadAddressesError: isBatchUploadAddressesError
    };
};




var $924bf655f73f35fa$export$2e2bcd8739ae039 = ()=>{
    const { mutate: batchUploadTransactions, data: batchUploadTransactionsData, error: batchUploadTransactionsError, isLoading: isBatchUploadTransactionsLoading, isSuccess: isBatchUploadTransactionsSuccess, isError: isBatchUploadTransactionsError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $dd8e00f3e31f90cd$export$8768c4016d0207d3));
    return {
        batchUploadTransactions: batchUploadTransactions,
        batchUploadTransactionsData: batchUploadTransactionsData,
        batchUploadTransactionsError: batchUploadTransactionsError,
        isBatchUploadTransactionsLoading: isBatchUploadTransactionsLoading,
        isBatchUploadTransactionsSuccess: isBatchUploadTransactionsSuccess,
        isBatchUploadTransactionsError: isBatchUploadTransactionsError
    };
};





const $271f427d899afea6$export$ca8561d2f81b8b2f = (0, $e29db2de9829c254$export$456995facc43eda)((0, $78597906e6a0205e$export$6c611141e7030bb8));
const $271f427d899afea6$var$handler = (0, $e29db2de9829c254$export$38b0b8222efbc769);
const $271f427d899afea6$export$9713b263c0670a7c = async ()=>{
    const response = await (0, $e29db2de9829c254$export$170e87424a0d64a3).get((0, $78597906e6a0205e$export$533507b0b47a2d2e).GET_GLEIF);
    const { data: data } = response.data;
    return data;
};


var $e5f414d24a30f093$export$2e2bcd8739ae039 = ()=>{
    const { mutate: getGleif, data: getGleifData, error: getGleifError, isLoading: isGetGleifLoading, isSuccess: isGetGleifSuccess, isError: isGetGleifError } = (0, $38e130c204b159d1$export$609860bf8b0084c)((0, $271f427d899afea6$export$9713b263c0670a7c));
    return {
        getGleif: getGleif,
        getGleifData: getGleifData,
        getGleifError: getGleifError,
        isGetGleifLoading: isGetGleifLoading,
        isGetGleifSuccess: isGetGleifSuccess,
        isGetGleifError: isGetGleifError
    };
};




/* eslint-disable no-confusing-arrow */ 

const $a3bd0edf159f904e$export$326b3d1afc15e2c7 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: flex-start; 
  height: 100%;
  padding: 20px 0; 
  width: 100%;
  min-width: 190px;

  & svg { 
    & path { stroke: ${({ theme: theme })=>theme.colors.primary}}
    & line  {stroke: ${({ theme: theme })=>theme.colors.primary}}
    & polyline  {stroke: ${({ theme: theme })=>theme.colors.primary}}
    & g path{fill: ${({ theme: theme })=>theme.colors.primary} !important}
  }
`;
const $a3bd0edf159f904e$export$2e0a83ec2e27ecbb = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: 100%;
  padding: 0 20px;
  height: 1px;
  background-color: ${({ theme: theme })=>theme.colors.borderColor};
`;
const $a3bd0edf159f904e$export$8b251419efc915eb = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  line-height: 120%;
  font-size: 18px;
  font-weight: 600;
  color: ${({ theme: theme })=>theme.colors.primary};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const $a3bd0edf159f904e$export$5f1af8db9871e1d6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 12px;
  font-weight: 400;
  color: ${({ theme: theme })=>theme.colors.secondary};
`;
const $a3bd0edf159f904e$export$ab6fd764fbeac7f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  width: 100%;
`;
const $a3bd0edf159f904e$export$5aefda72e8cd52f8 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
const $a3bd0edf159f904e$export$a60a4d1b8a1a2eb6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039)((0, $12b33660068e86aa$export$b0d92dbee9b5b60d))`
  width: 100%;
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme: theme })=>theme.colors.primary};
  transition: .3s;
  padding: 8px 16px;
  border-radius: 8px;

  &:hover{
    font-weight: 600; 
    color: ${({ theme: theme })=>theme.colors.primary};
    background-color: ${({ theme: theme })=>theme.colors.borderColor};
  }
`;
const $a3bd0edf159f904e$export$37f54d0b7407611f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  cursor: pointer;
  width: 100%;
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme: theme })=>theme.colors.primary};
  transition: .3s;
  padding: 8px 16px;
  border-radius: 8px;

  &:hover{
    font-weight: 600; 
    color: ${({ theme: theme })=>theme.colors.primary};
    background-color: ${({ theme: theme })=>theme.colors.borderColor};
  }
`;


// Map Redux Props
function $20bc38fdac640bdc$var$ProfileSidebar() {
    // Hooks
    const [userCredentials] = (0, $a9c50ebe96619b20$export$2e2bcd8739ae039)('userCredentials', {});
    const { logoutUser: logoutUser } = (0, $0deb6bc4614da688$export$2e2bcd8739ae039)();
    // Functions
    const handleLogout = async ()=>{
        await logoutUser();
    };
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3bd0edf159f904e$export$326b3d1afc15e2c7), {
        style: {
            flexDirection: 'column-reverse',
            paddingBottom: '40px'
        },
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3bd0edf159f904e$export$5aefda72e8cd52f8), {
            style: {
                gap: '8px'
            },
            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $a3bd0edf159f904e$export$5aefda72e8cd52f8), {
                style: {
                    padding: '0 8px'
                },
                children: [
                    userCredentials?.role_id === 1 && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3bd0edf159f904e$export$a60a4d1b8a1a2eb6), {
                        to: "/business-details",
                        children: "Business Details"
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3bd0edf159f904e$export$a60a4d1b8a1a2eb6), {
                        to: `/user-details/${userCredentials.user_id}`,
                        children: "Profile"
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3bd0edf159f904e$export$a60a4d1b8a1a2eb6), {
                        to: "/settings?page=0",
                        children: "Settings"
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3bd0edf159f904e$export$37f54d0b7407611f), {
                        onClick: handleLogout,
                        children: "Logout"
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3bd0edf159f904e$export$ab6fd764fbeac7f), {
                        style: {
                            padding: '8px 15px 15px 15px'
                        },
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3bd0edf159f904e$export$2e0a83ec2e27ecbb), {})
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3bd0edf159f904e$export$5aefda72e8cd52f8), {
                        style: {
                            gap: '8px',
                            padding: '0 15px'
                        },
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3bd0edf159f904e$export$ab6fd764fbeac7f), {
                            style: {
                                alignItems: 'center',
                                gap: '12px'
                            },
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $a3bd0edf159f904e$export$5aefda72e8cd52f8), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3bd0edf159f904e$export$8b251419efc915eb), {
                                        children: `${userCredentials?.name_first} ${userCredentials?.name_last}`
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3bd0edf159f904e$export$5f1af8db9871e1d6), {
                                        children: `${userCredentials?.role_desc}`
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        })
    });
}
var $20bc38fdac640bdc$export$2e2bcd8739ae039 = $20bc38fdac640bdc$var$ProfileSidebar;


/* eslint-disable max-len */ /* eslint-disable react/prop-types */ 
parcelRequire("tZqWC");

// Map Redux Props
function $826bbcd47908a9b7$var$DirectorySidebar() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3bd0edf159f904e$export$326b3d1afc15e2c7), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $a3bd0edf159f904e$export$5aefda72e8cd52f8), {
            style: {
                gap: '8px'
            },
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3bd0edf159f904e$export$5aefda72e8cd52f8), {
                    style: {
                        gap: '8px',
                        padding: '0 20px'
                    },
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3bd0edf159f904e$export$ab6fd764fbeac7f), {
                        style: {
                            alignItems: 'center',
                            gap: '12px'
                        },
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3bd0edf159f904e$export$8b251419efc915eb), {
                            children: "Directory"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3bd0edf159f904e$export$ab6fd764fbeac7f), {
                    style: {
                        padding: '8px 20px'
                    },
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3bd0edf159f904e$export$2e0a83ec2e27ecbb), {})
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $a3bd0edf159f904e$export$5aefda72e8cd52f8), {
                    style: {
                        padding: '0 8px'
                    },
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3bd0edf159f904e$export$a60a4d1b8a1a2eb6), {
                            to: "/directory",
                            children: "Accounts"
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3bd0edf159f904e$export$a60a4d1b8a1a2eb6), {
                            to: "/directory/vasps",
                            children: "VASPs"
                        })
                    ]
                })
            ]
        })
    });
}
var $826bbcd47908a9b7$export$2e2bcd8739ae039 = $826bbcd47908a9b7$var$DirectorySidebar;


var $52d892da0b4ff4ea$export$2e2bcd8739ae039 = (0, $826bbcd47908a9b7$export$2e2bcd8739ae039);


/* eslint-disable max-len */ /* eslint-disable react/prop-types */ 
parcelRequire("tZqWC");

// Map Redux Props
function $43f5e012bee49899$var$ReportsSidebar() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3bd0edf159f904e$export$326b3d1afc15e2c7), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $a3bd0edf159f904e$export$5aefda72e8cd52f8), {
            style: {
                gap: '8px'
            },
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3bd0edf159f904e$export$5aefda72e8cd52f8), {
                    style: {
                        gap: '8px',
                        padding: '0 20px'
                    },
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3bd0edf159f904e$export$ab6fd764fbeac7f), {
                        style: {
                            alignItems: 'center',
                            gap: '12px'
                        },
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3bd0edf159f904e$export$8b251419efc915eb), {
                            children: "Reports"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3bd0edf159f904e$export$ab6fd764fbeac7f), {
                    style: {
                        padding: '8px 20px'
                    },
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3bd0edf159f904e$export$2e0a83ec2e27ecbb), {})
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $a3bd0edf159f904e$export$5aefda72e8cd52f8), {
                    style: {
                        padding: '0 8px'
                    },
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3bd0edf159f904e$export$a60a4d1b8a1a2eb6), {
                            to: "/reports",
                            children: "Blockchain Analytics"
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3bd0edf159f904e$export$a60a4d1b8a1a2eb6), {
                            to: "/reports/travelrule",
                            children: "Travel Rule"
                        })
                    ]
                })
            ]
        })
    });
}
var $43f5e012bee49899$export$2e2bcd8739ae039 = $43f5e012bee49899$var$ReportsSidebar;


var $8ca3ccb34933ba21$export$2e2bcd8739ae039 = (0, $43f5e012bee49899$export$2e2bcd8739ae039);


/* eslint-disable max-len */ /* eslint-disable react/prop-types */ 
parcelRequire("tZqWC");

// Map Redux Props
function $9761fc73c78fcac3$var$AiCatalystSidebar() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3bd0edf159f904e$export$326b3d1afc15e2c7), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $a3bd0edf159f904e$export$5aefda72e8cd52f8), {
            style: {
                gap: '8px'
            },
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3bd0edf159f904e$export$5aefda72e8cd52f8), {
                    style: {
                        gap: '8px',
                        padding: '0 20px'
                    },
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3bd0edf159f904e$export$ab6fd764fbeac7f), {
                        style: {
                            alignItems: 'center',
                            gap: '12px'
                        },
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3bd0edf159f904e$export$5aefda72e8cd52f8), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3bd0edf159f904e$export$8b251419efc915eb), {
                                children: "AI Catalyst"
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3bd0edf159f904e$export$ab6fd764fbeac7f), {
                    style: {
                        padding: '8px 20px'
                    },
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3bd0edf159f904e$export$2e0a83ec2e27ecbb), {})
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $a3bd0edf159f904e$export$5aefda72e8cd52f8), {
                    style: {
                        padding: '0 8px'
                    },
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3bd0edf159f904e$export$a60a4d1b8a1a2eb6), {
                            to: "/ai-catalyst/regulatory_chat",
                            children: "Regulatory Insights"
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3bd0edf159f904e$export$a60a4d1b8a1a2eb6), {
                            to: "/ai-catalyst/oapp_docs_chat",
                            children: "Ospree Get Started"
                        })
                    ]
                })
            ]
        })
    });
}
var $9761fc73c78fcac3$export$2e2bcd8739ae039 = $9761fc73c78fcac3$var$AiCatalystSidebar;


var $1612a2695046f0a5$export$2e2bcd8739ae039 = (0, $9761fc73c78fcac3$export$2e2bcd8739ae039);


/* eslint-disable max-len */ /* eslint-disable react/prop-types */ 
parcelRequire("tZqWC");


// Map Redux Props
function $d1708858421ea475$var$MoreSidebar() {
    // Hooks
    const [userCredentials] = (0, $a9c50ebe96619b20$export$2e2bcd8739ae039)('userCredentials', {});
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3bd0edf159f904e$export$326b3d1afc15e2c7), {
        style: {
            flexDirection: 'column-reverse',
            paddingBottom: '40px'
        },
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3bd0edf159f904e$export$5aefda72e8cd52f8), {
            style: {
                gap: '8px'
            },
            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $a3bd0edf159f904e$export$5aefda72e8cd52f8), {
                style: {
                    padding: '0 8px'
                },
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3bd0edf159f904e$export$a60a4d1b8a1a2eb6), {
                        to: "#",
                        onClick: (e)=>{
                            e.preventDefault();
                            window.open('https://docs.ospree.io/ospree-api/overview', '_blank');
                        },
                        children: "API Documentation"
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3bd0edf159f904e$export$a60a4d1b8a1a2eb6), {
                        to: "#",
                        onClick: (e)=>{
                            e.preventDefault();
                            window.open('https://www.ospree.io/legal/terms-and-conditions', '_blank');
                        },
                        children: "Terms of Use"
                    }),
                    userCredentials?.role_id === 0 && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3bd0edf159f904e$export$a60a4d1b8a1a2eb6), {
                        to: "/admin/ai/documents",
                        children: "AI Documents"
                    }),
                    userCredentials?.role_id === 0 && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3bd0edf159f904e$export$a60a4d1b8a1a2eb6), {
                        to: "/admin/vasps",
                        children: "Admin Vasps"
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3bd0edf159f904e$export$ab6fd764fbeac7f), {
                        style: {
                            padding: '8px 15px 15px 15px'
                        },
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3bd0edf159f904e$export$2e0a83ec2e27ecbb), {})
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3bd0edf159f904e$export$5aefda72e8cd52f8), {
                        style: {
                            gap: '8px',
                            padding: '0 15px'
                        },
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3bd0edf159f904e$export$ab6fd764fbeac7f), {
                            style: {
                                alignItems: 'center',
                                gap: '12px'
                            },
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3bd0edf159f904e$export$8b251419efc915eb), {
                                children: "More Options"
                            })
                        })
                    })
                ]
            })
        })
    });
}
var $d1708858421ea475$export$2e2bcd8739ae039 = $d1708858421ea475$var$MoreSidebar;


var $0d3fa2875461c1d4$export$2e2bcd8739ae039 = (0, $d1708858421ea475$export$2e2bcd8739ae039);


// Map Redux Props
const $204e23974c86c480$var$mapStateToProps = (state)=>state;
const $204e23974c86c480$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $204e23974c86c480$var$Sidebar(props) {
    // Destructure
    const { children: children } = props;
    // Local State
    const [isHovered, setIsHovered] = (0, $tZqWC.useState)(false);
    const [hoveredTitle, setHovered] = (0, $tZqWC.useState)('');
    // Hooks
    const [userCredentials] = (0, $a9c50ebe96619b20$export$2e2bcd8739ae039)('userCredentials', {});
    // Refs
    const wrapperRef = (0, $tZqWC.useRef)();
    const hoverWrapperRef = (0, $tZqWC.useRef)();
    const hoverTimeout = (0, $tZqWC.useRef)(null);
    // Functions
    const handleMouseEnter = (title)=>{
        clearTimeout(hoverTimeout.current);
        hoverTimeout.current = setTimeout(()=>{
            setHovered(title);
        }, 150) // delay in ms
        ;
    };
    const handleMouseLeave = ()=>{
        clearTimeout(hoverTimeout.current);
    };
    // Closing options on click away
    $204e23974c86c480$var$useOutsideHoverAlerter(hoverWrapperRef, setIsHovered);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $561ec2a14046c706$export$d9b764b921677bb1), {
        ref: hoverWrapperRef,
        hovered: isHovered,
        display: hoveredTitle !== '',
        onMouseLeave: ()=>{
            setHovered('');
        },
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $561ec2a14046c706$export$1c4ef261db9bc206), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $561ec2a14046c706$export$5a0be810dad713a0), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $561ec2a14046c706$export$fb912d881d4e6ab8), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $12b33660068e86aa$export$b0d92dbee9b5b60d), {
                                    to: "/",
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $561ec2a14046c706$export$2716aa0b0403677e), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a25394adb640e26c$export$2e2bcd8739ae039), {})
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $561ec2a14046c706$export$970362a869c2626d), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $561ec2a14046c706$export$6bb03ae86fd00b78), {
                                    activeClassName: "active",
                                    to: "/travelrule",
                                    children: [
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $13f215a46c77bbdb$export$2e2bcd8739ae039), {}),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $561ec2a14046c706$export$d03a642b4bc74017), {
                                            children: "Travel Rule"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $561ec2a14046c706$export$970362a869c2626d), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $561ec2a14046c706$export$6bb03ae86fd00b78), {
                                    activeClassName: "active",
                                    to: "/blockchain-analytics",
                                    children: [
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $19d59dfd9935476a$export$2e2bcd8739ae039), {}),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $561ec2a14046c706$export$d03a642b4bc74017), {
                                            children: "Blockchain Analytics"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $561ec2a14046c706$export$970362a869c2626d), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $561ec2a14046c706$export$6bb03ae86fd00b78), {
                                    activeClassName: "active",
                                    to: "/directory",
                                    className: hoveredTitle === 'directory' && 'activeHover',
                                    onMouseEnter: ()=>handleMouseEnter('directory'),
                                    onMouseLeave: handleMouseLeave,
                                    children: [
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6873fe941a1f44db$export$2e2bcd8739ae039), {}),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $561ec2a14046c706$export$d03a642b4bc74017), {
                                            children: "Directory"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $561ec2a14046c706$export$970362a869c2626d), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $561ec2a14046c706$export$6bb03ae86fd00b78), {
                                    activeClassName: "active",
                                    to: "/reports",
                                    className: hoveredTitle === 'reports' && 'activeHover',
                                    onMouseEnter: ()=>handleMouseEnter('reports'),
                                    onMouseLeave: handleMouseLeave,
                                    children: [
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $8adab9613853c9a0$export$2e2bcd8739ae039), {}),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $561ec2a14046c706$export$d03a642b4bc74017), {
                                            children: "Reports"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $561ec2a14046c706$export$970362a869c2626d), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $561ec2a14046c706$export$6bb03ae86fd00b78), {
                                    activeClassName: "active",
                                    to: "/ai-catalyst/ospree",
                                    className: hoveredTitle === 'ai-catalyst' && 'activeHover',
                                    onMouseEnter: ()=>handleMouseEnter('ai-catalyst'),
                                    onMouseLeave: handleMouseLeave,
                                    children: [
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $8c8be8322e8f63e7$export$2e2bcd8739ae039), {}),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $561ec2a14046c706$export$d03a642b4bc74017), {
                                            children: "AI Catalyst"
                                        })
                                    ]
                                })
                            }),
                            children
                        ]
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $561ec2a14046c706$export$5a0be810dad713a0), {
                        ref: wrapperRef,
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $561ec2a14046c706$export$970362a869c2626d), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $561ec2a14046c706$export$6bb03ae86fd00b78), {
                                    to: "#",
                                    activeClassName: "active",
                                    className: hoveredTitle === 'more' && 'activeHover',
                                    onMouseEnter: ()=>handleMouseEnter('more'),
                                    onMouseLeave: handleMouseLeave,
                                    children: [
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f5fc3c6481bdb5b2$export$2e2bcd8739ae039), {}),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $561ec2a14046c706$export$d03a642b4bc74017), {
                                            children: "More"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $561ec2a14046c706$export$970362a869c2626d), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $561ec2a14046c706$export$6bb03ae86fd00b78), {
                                    exact: true,
                                    to: `/user-details/${userCredentials?.id}`,
                                    className: hoveredTitle === 'profile' && 'activeHover',
                                    onMouseEnter: ()=>handleMouseEnter('profile'),
                                    onMouseLeave: handleMouseLeave,
                                    children: [
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $4244d0ab0887339f$export$2e2bcd8739ae039), {}),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $561ec2a14046c706$export$d03a642b4bc74017), {
                                            children: "Profile"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $561ec2a14046c706$export$c554d08d8051ae38), {
                hovered: isHovered,
                display: hoveredTitle !== '',
                children: [
                    hoveredTitle === 'more' && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $0d3fa2875461c1d4$export$2e2bcd8739ae039), {}),
                    hoveredTitle === 'profile' && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $20bc38fdac640bdc$export$2e2bcd8739ae039), {}),
                    hoveredTitle === 'directory' && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $52d892da0b4ff4ea$export$2e2bcd8739ae039), {}),
                    hoveredTitle === 'reports' && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $8ca3ccb34933ba21$export$2e2bcd8739ae039), {}),
                    hoveredTitle === 'ai-catalyst' && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1612a2695046f0a5$export$2e2bcd8739ae039), {})
                ]
            })
        ]
    });
}
// Default Props
$204e23974c86c480$var$Sidebar.defaultProps = {
    children: ''
};
// Proptypes Validation
$204e23974c86c480$var$Sidebar.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ])
};
var $204e23974c86c480$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($204e23974c86c480$var$mapStateToProps, $204e23974c86c480$var$mapDispatchToProps)($204e23974c86c480$var$Sidebar);
// Function that listens to oustide clicks of given ref
const $204e23974c86c480$var$useOutsideHoverAlerter = (ref, setShowOptions)=>{
    (0, $tZqWC.useEffect)(()=>{
        function handleHoverOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) setShowOptions(false);
            else setShowOptions(true);
        }
        document.addEventListener('mouseover', handleHoverOutside);
        return ()=>{
            document.removeEventListener('mouseover', handleHoverOutside);
        };
    }, [
        ref
    ]);
};


var $802ca450e3f2144f$export$2e2bcd8739ae039 = (0, $204e23974c86c480$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $6cfe515b8fe4ba1c$export$6ce170286acaa8d3 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 0px 0px 0px 0px;
  width: 100%;
  height: fit-content;
  background-color: ${({ theme: theme })=>theme.colors.backgroundLite};
`;


function $db2e79bc686da229$var$Content(props) {
    // Destructure
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6cfe515b8fe4ba1c$export$6ce170286acaa8d3), {
        ...rest,
        children: children
    });
}
// Default Props
$db2e79bc686da229$var$Content.defaultProps = {
    children: ''
};
// Proptypes Validation
$db2e79bc686da229$var$Content.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ])
};
var $db2e79bc686da229$export$2e2bcd8739ae039 = $db2e79bc686da229$var$Content;


var $b27722fc7d4f5ccf$export$2e2bcd8739ae039 = (0, $db2e79bc686da229$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");



// Map Redux Props
const $b964e26e0f7cc194$var$mapStateToProps = (state)=>state;
const $b964e26e0f7cc194$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $b964e26e0f7cc194$var$Alerts(props) {
    // Destructure
    const { alert: alert, actions: actions } = props;
    // Store States
    const { alertList: { open: open, message: message, type: type, duration: duration } } = alert;
    // Store Actions
    const { closeAlert: closeAlert } = actions;
    // Functions
    const handleOnCloseAlert = ()=>closeAlert();
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ffd80d6545166898$export$2e2bcd8739ae039), {
        open: open,
        autoHideDuration: duration,
        type: type,
        message: message,
        onClose: handleOnCloseAlert
    });
}
// Default Props
$b964e26e0f7cc194$var$Alerts.defaultProps = {
    alert: ''
};
// Proptypes Validation
$b964e26e0f7cc194$var$Alerts.propTypes = {
    alert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        alertList: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object)
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        closeAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $b964e26e0f7cc194$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($b964e26e0f7cc194$var$mapStateToProps, $b964e26e0f7cc194$var$mapDispatchToProps)($b964e26e0f7cc194$var$Alerts);


var $0b050a2b7a31f127$export$2e2bcd8739ae039 = (0, $b964e26e0f7cc194$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");


const $cbf51f915a3b696e$export$6eaa4d78e3725d73 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $cbf51f915a3b696e$export$900eb51494311d89 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).ul`
  display: flex;
  gap: 20px;
  padding: 10px 40px 0 40px;
  margin: 0;
  list-style: none;
  border-bottom: 2px solid ${({ theme: theme })=>theme.colors.backgroundLite};
`;
const $cbf51f915a3b696e$export$252f28a9c2dbb35d = (0, $a778141486c79bc3$export$2e2bcd8739ae039).li`
  padding: 0px;
`;
const $cbf51f915a3b696e$export$874959254c7a97f4 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  display: block;
  padding: 12px 0;
  margin: 0 0 -2px 0;
  font-weight: 400;
  font-size: 14px;
  cursor: pointer;

  // TODO: Use theme mixins
  &.active {
    font-weight: 700;
  }

  &.active,
  &:hover {
    color: ${({ theme: theme })=>theme.colors.brand};

    border-bottom: 3px solid ${({ theme: theme })=>theme.colors.brand};
  }

  // Themed Properties
  color: ${({ theme: theme })=>theme.colors.primary};
`;


function $815be29d073f2891$var$SettingsSubHeader(props) {
    // Hooks
    const { page: page, setPage: setPage } = props;
    const [currentUser] = (0, $a9c50ebe96619b20$export$2e2bcd8739ae039)('userCredentials', {});
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $cbf51f915a3b696e$export$6eaa4d78e3725d73), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $cbf51f915a3b696e$export$900eb51494311d89), {
            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $cbf51f915a3b696e$export$252f28a9c2dbb35d), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $cbf51f915a3b696e$export$874959254c7a97f4), {
                    className: page === 0 && 'active',
                    onClick: ()=>{
                        setPage(0);
                    },
                    children: "General"
                })
            })
        })
    });
}
// Default Props
$815be29d073f2891$var$SettingsSubHeader.defaultProps = {
    page: 0,
    setPage: ()=>{}
};
// Proptypes Validation
$815be29d073f2891$var$SettingsSubHeader.propTypes = {
    page: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
    setPage: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
};
var $815be29d073f2891$export$2e2bcd8739ae039 = $815be29d073f2891$var$SettingsSubHeader;


var $c3442c06a63b86ff$export$2e2bcd8739ae039 = (0, $815be29d073f2891$export$2e2bcd8739ae039);



parcelRequire("tZqWC");


const $eb7199dcfd16c58a$export$6eaa4d78e3725d73 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $eb7199dcfd16c58a$export$900eb51494311d89 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).ul`
  padding: 0;
  margin: 0;
  display: flex;
  list-style: none;
`;
const $eb7199dcfd16c58a$export$252f28a9c2dbb35d = (0, $a778141486c79bc3$export$2e2bcd8739ae039).li`
  padding: 0px; 
`;
const $eb7199dcfd16c58a$export$874959254c7a97f4 = (0, $a778141486c79bc3$export$2e2bcd8739ae039)((0, $12b33660068e86aa$export$b0d92dbee9b5b60d))`
  position: relative;
  display: block;
  padding: 0 10px 10px 10px;
  margin: 0px;
  font-weight: 400;
  font-size: 12px;
  transition: .3s;
  border-bottom: 3px solid ${({ theme: theme })=>theme.colors.brand}00;

  // TODO: Use theme mixins
  &.active {
    font-weight: 600;
  }

  &.active,
  &:hover {
    color: ${({ theme: theme })=>theme.colors.brand};

    border-bottom: 3px solid ${({ theme: theme })=>theme.colors.brand};
  }

  // Themed Properties
  color: ${({ theme: theme })=>theme.colors.primary};
`;


function $d0d5e40bcb122769$var$DirectorySubHeader() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eb7199dcfd16c58a$export$6eaa4d78e3725d73), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $eb7199dcfd16c58a$export$900eb51494311d89), {
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eb7199dcfd16c58a$export$252f28a9c2dbb35d), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eb7199dcfd16c58a$export$874959254c7a97f4), {
                        exact: true,
                        activeClassName: "active",
                        to: "/directory",
                        children: "Accounts"
                    })
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eb7199dcfd16c58a$export$252f28a9c2dbb35d), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eb7199dcfd16c58a$export$874959254c7a97f4), {
                        exact: true,
                        activeClassName: "active",
                        to: "/directory/vasps",
                        children: "VASPs"
                    })
                })
            ]
        })
    });
}
var $d0d5e40bcb122769$export$2e2bcd8739ae039 = $d0d5e40bcb122769$var$DirectorySubHeader;


var $61ee040a7ed48adf$export$2e2bcd8739ae039 = (0, $d0d5e40bcb122769$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $37856c1cc10cac3d$export$6eaa4d78e3725d73 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $37856c1cc10cac3d$export$900eb51494311d89 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).ul`
  padding: 0;
  margin: 0;
  display: flex;
  gap: ${({ isButton: isButton })=>isButton ? '10px' : '20px'};
  list-style: none;
  border-bottom: ${({ theme: theme, isButton: isButton })=>!isButton && ` 2px solid ${theme.colors.background}`};
`;
const $37856c1cc10cac3d$export$252f28a9c2dbb35d = (0, $a778141486c79bc3$export$2e2bcd8739ae039).li`
  padding: 0px;
  margin: 0;
`;
const $37856c1cc10cac3d$export$874959254c7a97f4 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  display: flex;
  align-items: center;
  height: 100%;
  padding: ${({ isButton: isButton })=>isButton ? '5px 15px' : '0 0 8px 0'};
  border: ${({ theme: theme, isButton: isButton })=>isButton && ` 2px solid ${theme.colors.background}`};
  border-radius: 8px;
  margin: 0px;
  font-weight: 400;
  font-size: 14px;
  cursor: pointer;
  transition: 0.3s;
  box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.07);

  &:hover {
    box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.15);
  }

  // TODO: Use theme mixins
  &.active {
    font-weight: 700;
    border: ${({ isButton: isButton })=>isButton && 'none'};
  }

  &.active,
  &:hover {
    color: ${({ theme: theme })=>theme.colors.brand};
    background-color: ${({ theme: theme, isButton: isButton })=>isButton && theme.colors.background};

    &:before {
      ${({ isButton: isButton, theme: theme })=>!isButton && `content: '';
        position: absolute;
        bottom: -1px;
        left: 0;
        width: 100%;
        height: 2px;
        background-color: ${theme.colors.brand}
      `};
    }
  }

  // Themed Properties
  color: ${({ theme: theme })=>theme.colors.primary};
`;


function $32b963ac398adfd9$var$AccountDetailsSubHeader(props) {
    // Hooks
    const { page: page, setPage: setPage, pages: pages, isButton: isButton } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $37856c1cc10cac3d$export$6eaa4d78e3725d73), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $37856c1cc10cac3d$export$900eb51494311d89), {
            isButton: isButton,
            children: pages && pages.map((item)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $37856c1cc10cac3d$export$252f28a9c2dbb35d), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $37856c1cc10cac3d$export$874959254c7a97f4), {
                        isButton: isButton,
                        className: page === item.value && 'active',
                        onClick: ()=>{
                            setPage(item.value);
                        },
                        children: item.label
                    })
                }, item.value))
        })
    });
}
// Default Props
$32b963ac398adfd9$var$AccountDetailsSubHeader.defaultProps = {
    isButton: false,
    page: 0,
    setPage: ()=>{},
    pages: []
};
// Proptypes Validation
$32b963ac398adfd9$var$AccountDetailsSubHeader.propTypes = {
    isButton: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    page: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
    setPage: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    pages: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({}))
};
var $32b963ac398adfd9$export$2e2bcd8739ae039 = $32b963ac398adfd9$var$AccountDetailsSubHeader;


var $c6cc9151de134171$export$2e2bcd8739ae039 = (0, $32b963ac398adfd9$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $18bb9c6d680a7c36$export$6eaa4d78e3725d73 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $18bb9c6d680a7c36$export$900eb51494311d89 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).ul`
  padding: 0;
  margin: 0;
  display: flex;
  gap: 20px;
  list-style: none;
  border-bottom: 2px solid ${({ theme: theme })=>theme.colors.backgroundLite};
`;
const $18bb9c6d680a7c36$export$252f28a9c2dbb35d = (0, $a778141486c79bc3$export$2e2bcd8739ae039).li`
  padding: 0px;
  margin: 0;
`;
const $18bb9c6d680a7c36$export$874959254c7a97f4 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  display: block;
  padding: 0 0 8px 0;
  margin: 0px;
  font-weight: 400;
  font-size: 14px;
  cursor: pointer;

  // TODO: Use theme mixins
  &.active {
    font-weight: 700;
  }

  &.active,
  &:hover {
    color: ${({ theme: theme })=>theme.colors.brand};

    &:before {
      content: '';
      position: absolute;
      bottom: -1px;
      left: 0;
      width: 100%;
      height: 2px;
      background-color: ${({ theme: theme })=>theme.colors.brand};
    }
  }

  // Themed Properties
  color: ${({ theme: theme })=>theme.colors.primary};
`;


function $1b7f7b17b2ffebb5$var$DirectoryDetailsSubHeader(props) {
    // Hooks
    const { page: page, setPage: setPage } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $18bb9c6d680a7c36$export$6eaa4d78e3725d73), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $18bb9c6d680a7c36$export$900eb51494311d89), {
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $18bb9c6d680a7c36$export$252f28a9c2dbb35d), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $18bb9c6d680a7c36$export$874959254c7a97f4), {
                        className: page === 0 && 'active',
                        onClick: ()=>{
                            setPage(0);
                        },
                        children: "Details"
                    })
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $18bb9c6d680a7c36$export$252f28a9c2dbb35d), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $18bb9c6d680a7c36$export$874959254c7a97f4), {
                        className: page === 1 && 'active',
                        onClick: ()=>{
                            setPage(1);
                        },
                        children: "Activity"
                    })
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $18bb9c6d680a7c36$export$252f28a9c2dbb35d), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $18bb9c6d680a7c36$export$874959254c7a97f4), {
                        className: page === 2 && 'active',
                        onClick: ()=>{
                            setPage(2);
                        },
                        children: "Risk and Verification"
                    })
                })
            ]
        })
    });
}
// Default Props
$1b7f7b17b2ffebb5$var$DirectoryDetailsSubHeader.defaultProps = {
    page: 0,
    setPage: ()=>{}
};
// Proptypes Validation
$1b7f7b17b2ffebb5$var$DirectoryDetailsSubHeader.propTypes = {
    page: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
    setPage: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
};
var $1b7f7b17b2ffebb5$export$2e2bcd8739ae039 = $1b7f7b17b2ffebb5$var$DirectoryDetailsSubHeader;


var $d76d2d414e9cbd9f$export$2e2bcd8739ae039 = (0, $1b7f7b17b2ffebb5$export$2e2bcd8739ae039);



parcelRequire("tZqWC");


const $d70cab4ca0227163$export$6eaa4d78e3725d73 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 10px 0 0 0;
`;
const $d70cab4ca0227163$export$900eb51494311d89 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).ul`
  padding: 0;
  margin: 0;
  display: flex;
  list-style: none;
`;
const $d70cab4ca0227163$export$252f28a9c2dbb35d = (0, $a778141486c79bc3$export$2e2bcd8739ae039).li`
  padding: 0px; 
`;
const $d70cab4ca0227163$export$874959254c7a97f4 = (0, $a778141486c79bc3$export$2e2bcd8739ae039)((0, $12b33660068e86aa$export$b0d92dbee9b5b60d))`
  position: relative;
  display: block;
  padding: 0 10px 10px 10px;
  margin: 0px;
  font-weight: 400;
  font-size: 12px;
  transition: .3s;
  border-bottom: 3px solid ${({ theme: theme })=>theme.colors.brand}00;

  // TODO: Use theme mixins
  &.active {
    font-weight: 600;
  }

  &.active,
  &:hover {
    color: ${({ theme: theme })=>theme.colors.brand};

    border-bottom: 3px solid ${({ theme: theme })=>theme.colors.brand};
  }

  // Themed Properties
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $d70cab4ca0227163$export$8b58ade6e09dee1e = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: absolute;
  font-size: 10px;
  font-weight: 700;
  color: ${({ theme: theme })=>theme.colors.primary};

  top: -2px;
  right: -25px;
`;


function $86ce13424f9468b5$var$BlockchainAnalyticsSubHeader() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d70cab4ca0227163$export$6eaa4d78e3725d73), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d70cab4ca0227163$export$900eb51494311d89), {
            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d70cab4ca0227163$export$252f28a9c2dbb35d), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d70cab4ca0227163$export$874959254c7a97f4), {
                    exact: true,
                    activeClassName: "active",
                    to: "/blockchain-analytics",
                    children: "Address"
                })
            })
        })
    });
}
var $86ce13424f9468b5$export$2e2bcd8739ae039 = $86ce13424f9468b5$var$BlockchainAnalyticsSubHeader;


var $d556ea73ca4389e2$export$2e2bcd8739ae039 = (0, $86ce13424f9468b5$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $21d2dd384db151d7$export$6eaa4d78e3725d73 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $21d2dd384db151d7$export$900eb51494311d89 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).ul`
  display: flex;
  padding: 0;
  margin: 0;
  gap: 50px;
  list-style: none;
  border-bottom: 2px solid ${({ theme: theme })=>theme.colors.backgroundLite};
`;
const $21d2dd384db151d7$export$252f28a9c2dbb35d = (0, $a778141486c79bc3$export$2e2bcd8739ae039).li`
  display: flex;
  justify-content: flex-start;
  padding: 0px;
  margin: 0;

  &:first-child {
    justify-content: flex-end;
  }
`;
const $21d2dd384db151d7$export$874959254c7a97f4 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  display: block;
  padding: 0 0 8px 0;
  margin: 0px;
  font-weight: 400;
  font-size: 14px;
  cursor: pointer;

  // TODO: Use theme mixins
  &.active {
    font-weight: 700;
  }

  &.active,
  &:hover {
    color: ${({ theme: theme })=>theme.colors.brand};

    &:before {
      content: '';
      position: absolute;
      bottom: -1px;
      left: 0;
      width: 100%;
      height: 2px;
      background-color: ${({ theme: theme })=>theme.colors.brand};
    }
  }

  // Themed Properties
  color: ${({ theme: theme })=>theme.colors.primary};
`;


function $3875f56b8b5b2ace$var$TravelRuleTableItemSubHeader(props) {
    // Hooks
    const { page: page, setPage: setPage } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $21d2dd384db151d7$export$6eaa4d78e3725d73), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $21d2dd384db151d7$export$900eb51494311d89), {
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $21d2dd384db151d7$export$252f28a9c2dbb35d), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $21d2dd384db151d7$export$874959254c7a97f4), {
                        className: page === 0 && 'active',
                        onClick: ()=>{
                            setPage(0);
                        },
                        children: "Transfer flow"
                    })
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $21d2dd384db151d7$export$252f28a9c2dbb35d), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $21d2dd384db151d7$export$874959254c7a97f4), {
                        className: page === 1 && 'active',
                        onClick: ()=>{
                            setPage(1);
                        },
                        children: "Transfer details"
                    })
                })
            ]
        })
    });
}
// Default Props
$3875f56b8b5b2ace$var$TravelRuleTableItemSubHeader.defaultProps = {
    page: 0,
    setPage: ()=>{}
};
// Proptypes Validation
$3875f56b8b5b2ace$var$TravelRuleTableItemSubHeader.propTypes = {
    page: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
    setPage: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
};
var $3875f56b8b5b2ace$export$2e2bcd8739ae039 = $3875f56b8b5b2ace$var$TravelRuleTableItemSubHeader;


var $61931cc7babf29b2$export$2e2bcd8739ae039 = (0, $3875f56b8b5b2ace$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $5fc1bdce12551c00$export$6eaa4d78e3725d73 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 5px 0 15px 15px;
`;
const $5fc1bdce12551c00$export$900eb51494311d89 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).ul`
  display: flex;
  padding: 0;
  margin: 0;
  gap: 30px;
  list-style: none;
`;
const $5fc1bdce12551c00$export$252f28a9c2dbb35d = (0, $a778141486c79bc3$export$2e2bcd8739ae039).li`
  display: flex;
  justify-content: flex-start;
  padding: 0px;
  margin: 0;

  &:first-child {
    justify-content: flex-end;
  }
`;
const $5fc1bdce12551c00$export$874959254c7a97f4 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  display: block;
  padding: 0 0 8px 0;
  margin: 0px;
  font-weight: 400;
  font-size: 14px;
  cursor: pointer;

  // TODO: Use theme mixins
  &.active {
    font-weight: 700;
  }

  &.active,
  &:hover {
    color: ${({ theme: theme })=>theme.colors.brand};

    &:before {
      content: '';
      position: absolute;
      bottom: -1px;
      left: 0;
      width: 100%;
      height: 2px;
      background-color: ${({ theme: theme })=>theme.colors.brand};
    }
  }

  // Themed Properties
  color: ${({ theme: theme })=>theme.colors.primary};
`;


function $c8d088047409ad6e$var$AddressDetailsSubHeader(props) {
    // Hooks
    const { page: page, setPage: setPage } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5fc1bdce12551c00$export$6eaa4d78e3725d73), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $5fc1bdce12551c00$export$900eb51494311d89), {
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5fc1bdce12551c00$export$252f28a9c2dbb35d), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5fc1bdce12551c00$export$874959254c7a97f4), {
                        className: page === 0 && 'active',
                        onClick: ()=>{
                            setPage(0);
                        },
                        children: "Summary"
                    })
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5fc1bdce12551c00$export$252f28a9c2dbb35d), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5fc1bdce12551c00$export$874959254c7a97f4), {
                        className: page === 1 && 'active',
                        onClick: ()=>{
                            setPage(1);
                        },
                        children: "Linkage"
                    })
                })
            ]
        })
    });
}
// Default Props
$c8d088047409ad6e$var$AddressDetailsSubHeader.defaultProps = {
    page: 0,
    setPage: ()=>{}
};
// Proptypes Validation
$c8d088047409ad6e$var$AddressDetailsSubHeader.propTypes = {
    page: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
    setPage: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
};
var $c8d088047409ad6e$export$2e2bcd8739ae039 = $c8d088047409ad6e$var$AddressDetailsSubHeader;


var $b34cad56374d5647$export$2e2bcd8739ae039 = (0, $c8d088047409ad6e$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $c7f5090b47579f74$export$6eaa4d78e3725d73 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 5px 0 15px 15px;
`;
const $c7f5090b47579f74$export$900eb51494311d89 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).ul`
  display: flex;
  padding: 0;
  margin: 0;
  gap: 30px;
  list-style: none;
`;
const $c7f5090b47579f74$export$252f28a9c2dbb35d = (0, $a778141486c79bc3$export$2e2bcd8739ae039).li`
  display: flex;
  justify-content: flex-start;
  padding: 0px;
  margin: 0;

  &:first-child {
    justify-content: flex-end;
  }
`;
const $c7f5090b47579f74$export$874959254c7a97f4 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  display: block;
  padding: 0 0 8px 0;
  margin: 0px;
  font-weight: 400;
  font-size: 14px;
  cursor: pointer;

  // TODO: Use theme mixins
  &.active {
    font-weight: 700;
  }

  &.active,
  &:hover {
    color: ${({ theme: theme })=>theme.colors.brand};

    &:before {
      content: '';
      position: absolute;
      bottom: -1px;
      left: 0;
      width: 100%;
      height: 2px;
      background-color: ${({ theme: theme })=>theme.colors.brand};
    }
  }

  // Themed Properties
  color: ${({ theme: theme })=>theme.colors.primary};
`;


function $ffc6e039b460ad93$var$TransactionDetailsSubHeader(props) {
    // Hooks
    const { page: page, setPage: setPage } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c7f5090b47579f74$export$6eaa4d78e3725d73), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $c7f5090b47579f74$export$900eb51494311d89), {
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c7f5090b47579f74$export$252f28a9c2dbb35d), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c7f5090b47579f74$export$874959254c7a97f4), {
                        className: page === 0 && 'active',
                        onClick: ()=>{
                            setPage(0);
                        },
                        children: "Summary"
                    })
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c7f5090b47579f74$export$252f28a9c2dbb35d), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c7f5090b47579f74$export$874959254c7a97f4), {
                        className: page === 1 && 'active',
                        onClick: ()=>{
                            setPage(1);
                        },
                        children: "Linkage"
                    })
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c7f5090b47579f74$export$252f28a9c2dbb35d), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c7f5090b47579f74$export$874959254c7a97f4), {
                        className: page === 2 && 'active',
                        onClick: ()=>{
                            setPage(2);
                        },
                        children: "Events"
                    })
                })
            ]
        })
    });
}
// Default Props
$ffc6e039b460ad93$var$TransactionDetailsSubHeader.defaultProps = {
    page: 0,
    setPage: ()=>{}
};
// Proptypes Validation
$ffc6e039b460ad93$var$TransactionDetailsSubHeader.propTypes = {
    page: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
    setPage: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
};
var $ffc6e039b460ad93$export$2e2bcd8739ae039 = $ffc6e039b460ad93$var$TransactionDetailsSubHeader;


var $cdd87f56ac91e7cf$export$2e2bcd8739ae039 = (0, $ffc6e039b460ad93$export$2e2bcd8739ae039);



parcelRequire("tZqWC");


const $52e231a65b0c164b$export$6eaa4d78e3725d73 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $52e231a65b0c164b$export$900eb51494311d89 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).ul`
  padding: 0;
  margin: 0;
  display: flex;
  list-style: none;
`;
const $52e231a65b0c164b$export$252f28a9c2dbb35d = (0, $a778141486c79bc3$export$2e2bcd8739ae039).li`
  padding: 0px; 
`;
const $52e231a65b0c164b$export$874959254c7a97f4 = (0, $a778141486c79bc3$export$2e2bcd8739ae039)((0, $12b33660068e86aa$export$b0d92dbee9b5b60d))`
  position: relative;
  display: block;
  padding: 0 10px 10px 10px;
  margin: 0px;
  font-weight: 400;
  font-size: 12px;
  transition: .3s;
  border-bottom: 3px solid ${({ theme: theme })=>theme.colors.brand}00;

  // TODO: Use theme mixins
  &.active {
    font-weight: 600;
  }

  &.active,
  &:hover {
    color: ${({ theme: theme })=>theme.colors.brand};

    border-bottom: 3px solid ${({ theme: theme })=>theme.colors.brand};
  }

  // Themed Properties
  color: ${({ theme: theme })=>theme.colors.primary};
`;


function $322d0a683f63341d$var$ReportsSubHeader() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $52e231a65b0c164b$export$6eaa4d78e3725d73), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $52e231a65b0c164b$export$900eb51494311d89), {
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $52e231a65b0c164b$export$252f28a9c2dbb35d), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $52e231a65b0c164b$export$874959254c7a97f4), {
                        exact: true,
                        activeClassName: "active",
                        to: "/reports",
                        children: "Addresses"
                    })
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $52e231a65b0c164b$export$252f28a9c2dbb35d), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $52e231a65b0c164b$export$874959254c7a97f4), {
                        exact: true,
                        activeClassName: "active",
                        to: "/reports/travelrule",
                        children: "Travel Rule"
                    })
                })
            ]
        })
    });
}
var $322d0a683f63341d$export$2e2bcd8739ae039 = $322d0a683f63341d$var$ReportsSubHeader;


var $9376591085d0c38d$export$2e2bcd8739ae039 = (0, $322d0a683f63341d$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $f361ebef6164b2d8$export$6eaa4d78e3725d73 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $f361ebef6164b2d8$export$900eb51494311d89 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).ul`
  display: flex;
  gap: 20px;
  padding: 0 40px 0 0px;
  margin: 0 0 20px 0;
  list-style: none;
  border-bottom: 2px solid ${({ theme: theme })=>theme.colors.backgroundLite};
`;
const $f361ebef6164b2d8$export$252f28a9c2dbb35d = (0, $a778141486c79bc3$export$2e2bcd8739ae039).li`
  padding: 0px;
`;
const $f361ebef6164b2d8$export$874959254c7a97f4 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  display: block;
  padding: 12px 0;
  margin: 0 0 -2px 0;
  font-weight: 400;
  font-size: 14px;
  cursor: pointer;

  // TODO: Use theme mixins
  &.active {
    font-weight: 700;
  }

  &.active,
  &:hover {
    color: ${({ theme: theme })=>theme.colors.brand};

    border-bottom: 3px solid ${({ theme: theme })=>theme.colors.brand};
  }

  // Themed Properties
  color: ${({ theme: theme })=>theme.colors.primary};
`;


function $3fa08beb0c0c672b$var$UserDetailsSubHeader(props) {
    // Hooks
    const { page: page, setPage: setPage } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f361ebef6164b2d8$export$6eaa4d78e3725d73), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $f361ebef6164b2d8$export$900eb51494311d89), {
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f361ebef6164b2d8$export$252f28a9c2dbb35d), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f361ebef6164b2d8$export$874959254c7a97f4), {
                        className: page === 0 && 'active',
                        onClick: ()=>{
                            setPage(0);
                        },
                        children: "Personal Information"
                    })
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f361ebef6164b2d8$export$252f28a9c2dbb35d), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f361ebef6164b2d8$export$874959254c7a97f4), {
                        className: page === 1 && 'active',
                        onClick: ()=>{
                            setPage(1);
                        },
                        children: "Security"
                    })
                })
            ]
        })
    });
}
// Default Props
$3fa08beb0c0c672b$var$UserDetailsSubHeader.defaultProps = {
    page: 0,
    setPage: ()=>{}
};
// Proptypes Validation
$3fa08beb0c0c672b$var$UserDetailsSubHeader.propTypes = {
    page: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
    setPage: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
};
var $3fa08beb0c0c672b$export$2e2bcd8739ae039 = $3fa08beb0c0c672b$var$UserDetailsSubHeader;


var $6873d084d47f7441$export$2e2bcd8739ae039 = (0, $3fa08beb0c0c672b$export$2e2bcd8739ae039);



parcelRequire("tZqWC");


const $25426859e2887c3b$export$6eaa4d78e3725d73 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $25426859e2887c3b$export$900eb51494311d89 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).ul`
  padding: 0;
  margin: 0;
  display: flex;
  list-style: none;
`;
const $25426859e2887c3b$export$252f28a9c2dbb35d = (0, $a778141486c79bc3$export$2e2bcd8739ae039).li`
  padding: 0px;
  margin: 0 10px;
`;
const $25426859e2887c3b$export$874959254c7a97f4 = (0, $a778141486c79bc3$export$2e2bcd8739ae039)((0, $12b33660068e86aa$export$b0d92dbee9b5b60d))`
  position: relative;
  display: block;
  padding: 0 0 12px 0;
  margin: 0px;
  font-weight: 400;
  font-size: 14px;

  // TODO: Use theme mixins
  &.active {
    font-weight: 700;
  }

  &.active,
  &:hover {
    color: ${({ theme: theme })=>theme.colors.brand};

    border-bottom: 3px solid ${({ theme: theme })=>theme.colors.brand};
  }

  // Themed Properties
  color: ${({ theme: theme })=>theme.colors.primary};
`;


function $41a3a91b8c1916ba$var$AdminVaspsSubHeader() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $25426859e2887c3b$export$6eaa4d78e3725d73), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $25426859e2887c3b$export$900eb51494311d89), {
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $25426859e2887c3b$export$252f28a9c2dbb35d), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $25426859e2887c3b$export$874959254c7a97f4), {
                        exact: true,
                        activeClassName: "active",
                        to: "/admin/vasps",
                        children: "Visible VASPs"
                    })
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $25426859e2887c3b$export$252f28a9c2dbb35d), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $25426859e2887c3b$export$874959254c7a97f4), {
                        exact: true,
                        activeClassName: "active",
                        to: "/admin/vasps/requested",
                        children: "Requested VASPs"
                    })
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $25426859e2887c3b$export$252f28a9c2dbb35d), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $25426859e2887c3b$export$874959254c7a97f4), {
                        exact: true,
                        activeClassName: "active",
                        to: "/admin/vasps/customers",
                        children: "Customer VASPs"
                    })
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $25426859e2887c3b$export$252f28a9c2dbb35d), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $25426859e2887c3b$export$874959254c7a97f4), {
                        exact: true,
                        activeClassName: "active",
                        to: "/admin/vasps/midprospects",
                        children: "Mid-Prospect VASPs"
                    })
                })
            ]
        })
    });
}
var $41a3a91b8c1916ba$export$2e2bcd8739ae039 = $41a3a91b8c1916ba$var$AdminVaspsSubHeader;


var $55f63aca8e1944fc$export$2e2bcd8739ae039 = (0, $41a3a91b8c1916ba$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $2a128996cd19b98c$export$6eaa4d78e3725d73 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $2a128996cd19b98c$export$900eb51494311d89 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).ul`
  padding: 0;
  margin: 0;
  display: flex;
  gap: 20px;
  list-style: none;
  border-bottom: 2px solid ${({ theme: theme })=>theme.colors.backgroundLite};
`;
const $2a128996cd19b98c$export$252f28a9c2dbb35d = (0, $a778141486c79bc3$export$2e2bcd8739ae039).li`
  padding: 0px;
  margin: 0;
`;
const $2a128996cd19b98c$export$874959254c7a97f4 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  display: block;
  padding: 0 0 8px 0;
  margin: 0px;
  font-weight: 400;
  font-size: 14px;
  cursor: pointer;

  // TODO: Use theme mixins
  &.active {
    font-weight: 700;
  }

  &.active,
  &:hover {
    color: ${({ theme: theme })=>theme.colors.brand};

    &:before {
      content: '';
      position: absolute;
      bottom: -1px;
      left: 0;
      width: 100%;
      height: 2px;
      background-color: ${({ theme: theme })=>theme.colors.brand};
    }
  }

  // Themed Properties
  color: ${({ theme: theme })=>theme.colors.primary};
`;


function $3b8443f4b079860b$var$AdminVaspDetailsSubHeader(props) {
    // Hooks
    const { page: page, setPage: setPage } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2a128996cd19b98c$export$6eaa4d78e3725d73), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $2a128996cd19b98c$export$900eb51494311d89), {
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2a128996cd19b98c$export$252f28a9c2dbb35d), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2a128996cd19b98c$export$874959254c7a97f4), {
                        className: page === 0 && 'active',
                        onClick: ()=>{
                            setPage(0);
                        },
                        children: "Details"
                    })
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2a128996cd19b98c$export$252f28a9c2dbb35d), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2a128996cd19b98c$export$874959254c7a97f4), {
                        className: page === 1 && 'active',
                        onClick: ()=>{
                            setPage(1);
                        },
                        children: "Users"
                    })
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2a128996cd19b98c$export$252f28a9c2dbb35d), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2a128996cd19b98c$export$874959254c7a97f4), {
                        className: page === 2 && 'active',
                        onClick: ()=>{
                            setPage(2);
                        },
                        children: "Providers"
                    })
                })
            ]
        })
    });
}
// Default Props
$3b8443f4b079860b$var$AdminVaspDetailsSubHeader.defaultProps = {
    page: 0,
    setPage: ()=>{}
};
// Proptypes Validation
$3b8443f4b079860b$var$AdminVaspDetailsSubHeader.propTypes = {
    page: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
    setPage: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
};
var $3b8443f4b079860b$export$2e2bcd8739ae039 = $3b8443f4b079860b$var$AdminVaspDetailsSubHeader;


var $7a41226ac8681faa$export$2e2bcd8739ae039 = (0, $3b8443f4b079860b$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $0cddaada351bcb8b$export$6eaa4d78e3725d73 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $0cddaada351bcb8b$export$900eb51494311d89 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).ul`
  display: flex;
  gap: 20px;
  padding: 10px 40px 0 40px;
  margin: 0;
  list-style: none;
  border-bottom: 2px solid ${({ theme: theme })=>theme.colors.backgroundLite};
`;
const $0cddaada351bcb8b$export$252f28a9c2dbb35d = (0, $a778141486c79bc3$export$2e2bcd8739ae039).li`
  padding: 0px;
`;
const $0cddaada351bcb8b$export$874959254c7a97f4 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  display: block;
  padding: 12px 0;
  margin: 0 0 -2px 0;
  font-weight: 400;
  font-size: 14px;
  cursor: pointer;

  // TODO: Use theme mixins
  &.active {
    font-weight: 700;
  }

  &.active,
  &:hover {
    color: ${({ theme: theme })=>theme.colors.brand};

    border-bottom: 3px solid ${({ theme: theme })=>theme.colors.brand};
  }

  // Themed Properties
  color: ${({ theme: theme })=>theme.colors.primary};
`;


function $cd7447b607a5a256$var$BusinessDetailsSubHeader(props) {
    // Hooks
    const { page: page, setPage: setPage } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $0cddaada351bcb8b$export$6eaa4d78e3725d73), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $0cddaada351bcb8b$export$900eb51494311d89), {
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $0cddaada351bcb8b$export$252f28a9c2dbb35d), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $0cddaada351bcb8b$export$874959254c7a97f4), {
                        className: page === 0 && 'active',
                        onClick: ()=>{
                            setPage(0);
                        },
                        children: "Details"
                    })
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $0cddaada351bcb8b$export$252f28a9c2dbb35d), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $0cddaada351bcb8b$export$874959254c7a97f4), {
                        className: page === 1 && 'active',
                        onClick: ()=>{
                            setPage(1);
                        },
                        children: "Users"
                    })
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $0cddaada351bcb8b$export$252f28a9c2dbb35d), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $0cddaada351bcb8b$export$874959254c7a97f4), {
                        className: page === 2 && 'active',
                        onClick: ()=>{
                            setPage(2);
                        },
                        children: "API Keys"
                    })
                })
            ]
        })
    });
}
// Default Props
$cd7447b607a5a256$var$BusinessDetailsSubHeader.defaultProps = {
    page: 0,
    setPage: ()=>{}
};
// Proptypes Validation
$cd7447b607a5a256$var$BusinessDetailsSubHeader.propTypes = {
    page: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
    setPage: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
};
var $cd7447b607a5a256$export$2e2bcd8739ae039 = $cd7447b607a5a256$var$BusinessDetailsSubHeader;


var $8598ac15cd4ceb60$export$2e2bcd8739ae039 = (0, $cd7447b607a5a256$export$2e2bcd8739ae039);



parcelRequire("tZqWC");


const $611d87587efbf0e3$export$6eaa4d78e3725d73 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 10px 0 0 0;
`;
const $611d87587efbf0e3$export$900eb51494311d89 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).ul`
  padding: 0;
  margin: 0;
  display: flex;
  list-style: none;
`;
const $611d87587efbf0e3$export$252f28a9c2dbb35d = (0, $a778141486c79bc3$export$2e2bcd8739ae039).li`
  padding: 0px; 
`;
const $611d87587efbf0e3$export$874959254c7a97f4 = (0, $a778141486c79bc3$export$2e2bcd8739ae039)((0, $12b33660068e86aa$export$b0d92dbee9b5b60d))`
  position: relative;
  display: block;
  padding: 0 10px 10px 10px;
  margin: 0px;
  font-weight: 400;
  font-size: 12px;
  transition: .3s;
  border-bottom: 3px solid ${({ theme: theme })=>theme.colors.brand}00;

  // TODO: Use theme mixins
  &.active {
    font-weight: 600;
  }

  &.active,
  &:hover {
    color: ${({ theme: theme })=>theme.colors.brand};

    border-bottom: 3px solid ${({ theme: theme })=>theme.colors.brand};
  }

  // Themed Properties
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $611d87587efbf0e3$export$8b58ade6e09dee1e = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: absolute;
  font-size: 10px;
  font-weight: 700;
  color: ${({ theme: theme })=>theme.colors.primary};

  top: -2px;
  right: -25px;
`;


function $09442cbdd1818bcd$var$AICatalystSubHeader() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $611d87587efbf0e3$export$6eaa4d78e3725d73), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $611d87587efbf0e3$export$900eb51494311d89), {
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $611d87587efbf0e3$export$252f28a9c2dbb35d), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $611d87587efbf0e3$export$874959254c7a97f4), {
                        exact: true,
                        activeClassName: "active",
                        to: "/ai-catalyst/regulatory_chat",
                        children: "Regulatory Insights"
                    })
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $611d87587efbf0e3$export$252f28a9c2dbb35d), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $611d87587efbf0e3$export$874959254c7a97f4), {
                        exact: true,
                        activeClassName: "active",
                        to: "/ai-catalyst/oapp_docs_chat",
                        children: "Ospree Get Started"
                    })
                })
            ]
        })
    });
}
var $09442cbdd1818bcd$export$2e2bcd8739ae039 = $09442cbdd1818bcd$var$AICatalystSubHeader;


var $30b91c47bbb7ea48$export$2e2bcd8739ae039 = (0, $09442cbdd1818bcd$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");


const $76e4413de76a5c84$export$6073fa687f1cf1c5 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: 100%;

  margin: auto;
`;
const $76e4413de76a5c84$export$898f5ec6036845f7 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: 100%;
  margin: auto;

  // Responsive Properties
  ${({ theme: theme })=>theme.functions.mediaQuery('height', [
        'unset',
        'unset',
        'unset',
        'unset',
        'unset',
        '230px'
    ])}
`;


function $5ca7294fe7e10072$var$ActivityChart(props) {
    // Destructure
    const { title: title, titleIcon: titleIcon, data: data } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $76e4413de76a5c84$export$6073fa687f1cf1c5), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $fda44ae20bb64b6c$export$2e2bcd8739ae039), {
            title: title,
            titleIcon: titleIcon,
            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $76e4413de76a5c84$export$898f5ec6036845f7), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bff95e0871fbe022$export$2e2bcd8739ae039), {
                    data: data,
                    redraw: true,
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        legend: {
                            position: 'top',
                            align: 'end'
                        },
                        scales: {
                            xAxes: [
                                {
                                    gridLines: {
                                        drawBorder: false,
                                        display: false
                                    },
                                    type: 'time',
                                    position: 'bottom',
                                    time: {
                                        displayFormats: {
                                            week: 'MMM D'
                                        },
                                        tooltipFormat: 'YYYY-MM-DD',
                                        unit: 'week'
                                    }
                                }
                            ],
                            yAxes: [
                                {
                                    gridLines: {
                                        color: '#CED4DA',
                                        drawBorder: false
                                    },
                                    ticks: {
                                        min: 0,
                                        padding: 5,
                                        suggestedMax: 5
                                    }
                                }
                            ]
                        }
                    }
                })
            })
        })
    });
}
// Default Props
$5ca7294fe7e10072$var$ActivityChart.defaultProps = {
    title: '',
    titleIcon: '',
    data: {
        labels: [],
        datasets: []
    }
};
// Proptypes Validation
$5ca7294fe7e10072$var$ActivityChart.propTypes = {
    title: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    titleIcon: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element
    ]),
    data: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        labels: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Array),
        datasets: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Array)
    })
};
var $5ca7294fe7e10072$export$2e2bcd8739ae039 = $5ca7294fe7e10072$var$ActivityChart;


var $8177be1aebf62e79$export$2e2bcd8739ae039 = (0, $5ca7294fe7e10072$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $210d0eb03af8d027$export$b26e771d5d1de3ef = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: 100%;
`;
const $210d0eb03af8d027$export$ceb0a1bad7a1b4d0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  width: 100%;
  height: fit-content;

  // Responsive Properties
  ${({ theme: theme })=>theme.functions.mediaQuery('padding', [
        '0px',
        '0px',
        '15px',
        '15px',
        '15px',
        '15px',
        '15px',
        '15px'
    ])}
`;
const $210d0eb03af8d027$export$cd4324e55f792afb = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  width: 100%;
  height: fit-content;

  // Responsive Properties
  ${({ theme: theme })=>theme.functions.mediaQuery('width', [
        '140px',
        '150px',
        '180px',
        '200px',
        '200px',
        '160px',
        '160px',
        '180px'
    ])}
  ${({ theme: theme })=>theme.functions.mediaQuery('flex', [
        '.5',
        '.5',
        '.5',
        '.5',
        '1.3',
        'none',
        'none',
        'none'
    ])}
`;
const $210d0eb03af8d027$export$7346e6483601ca15 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  // Responsive Properties
  ${({ theme: theme })=>theme.functions.mediaQuery('margin', [
        '0px 0px 0px 10px',
        '0px 10px',
        '0px 0px 0px 20px',
        '0px 0px 0px 40px',
        '0px 30px',
        '0px 0px 0px 20px',
        '0px 0px 0px 20px',
        '0px 0px 0px 20px'
    ])}
`;
const $210d0eb03af8d027$export$b26ca271b1446f3d = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-family: Roboto;
  position: absolute;
  top: 50%;
  left: 50%;
  text-align: center;
  transition: 2s ease-in;
  transform: translate(-50%, -50%);
`;
const $210d0eb03af8d027$export$d787f1d54e170b4e = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  padding: 0;
  margin: 0 0 5px 0;
  line-height: 25px;
  font-size: 25px;

  color:  ${({ theme: theme })=>theme.colors.primary};
`;
const $210d0eb03af8d027$export$719aec78a93f7f08 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  line-height: 11.2px;
  padding: 0px;
  margin: 0px;
  font-size: 13px;
  color: ${({ theme: theme })=>theme.colors.secondary};
`;
const $210d0eb03af8d027$export$7023f4dd34b4909c = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`;
const $210d0eb03af8d027$export$21b9d78ba9f3c456 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: fit-content;
  font-weight: 400;
  font-size: 13px;
  width: fit-content;
  padding: 2px 0px;
  color: ${({ theme: theme })=>theme.colors.secondary};

  // Responsive Properties
  ${({ theme: theme })=>theme.functions.mediaQuery('font-size', [
        '10px',
        '11px',
        '13px',
        '13px',
        '13px',
        '13px',
        '13px',
        '13px'
    ])}
`;



function $a4fe42e0ca2e138d$var$RiskScoreChart(props) {
    // Destructure
    const { title: title, summaryValue: summaryValue, summaryText: summaryText, titleIcon: titleIcon, data: data } = props;
    const { datasets: datasets } = data;
    data.datasets[0].backgroundColor = [
        '#a1d99b',
        '#ffc435',
        '#f67d84'
    ];
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $210d0eb03af8d027$export$b26e771d5d1de3ef), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $fda44ae20bb64b6c$export$2e2bcd8739ae039), {
            title: title,
            titleIcon: titleIcon,
            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $210d0eb03af8d027$export$ceb0a1bad7a1b4d0), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $210d0eb03af8d027$export$cd4324e55f792afb), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $210d0eb03af8d027$export$b26ca271b1446f3d), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $210d0eb03af8d027$export$d787f1d54e170b4e), {
                                        children: summaryValue
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $210d0eb03af8d027$export$719aec78a93f7f08), {
                                        children: summaryText
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7b658d9b90651bd3$export$2e2bcd8739ae039), {
                                data: data,
                                width: 200,
                                height: 200,
                                options: {
                                    responsive: true,
                                    maintainAspectRatio: false,
                                    legend: {
                                        display: false
                                    }
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $210d0eb03af8d027$export$7346e6483601ca15), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $210d0eb03af8d027$export$7023f4dd34b4909c), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $210d0eb03af8d027$export$21b9d78ba9f3c456), {
                                        children: "Score Ranges"
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $210d0eb03af8d027$export$21b9d78ba9f3c456), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1d507f2e862cde19$export$2e2bcd8739ae039), {
                                            color: "#9bdbc1",
                                            children: "0-5"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $210d0eb03af8d027$export$21b9d78ba9f3c456), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1d507f2e862cde19$export$2e2bcd8739ae039), {
                                            color: "#ffda81",
                                            children: "6-7"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $210d0eb03af8d027$export$21b9d78ba9f3c456), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1d507f2e862cde19$export$2e2bcd8739ae039), {
                                            color: "#f5a4a3",
                                            children: "8-10"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $210d0eb03af8d027$export$7023f4dd34b4909c), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $210d0eb03af8d027$export$21b9d78ba9f3c456), {
                                        children: "Results"
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $210d0eb03af8d027$export$21b9d78ba9f3c456), {
                                        children: datasets[0].data[0]
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $210d0eb03af8d027$export$21b9d78ba9f3c456), {
                                        children: datasets[0].data[1]
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $210d0eb03af8d027$export$21b9d78ba9f3c456), {
                                        children: datasets[0].data[2]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}
// Default Props
$a4fe42e0ca2e138d$var$RiskScoreChart.defaultProps = {
    title: '',
    titleIcon: '',
    summaryValue: '',
    summaryText: '',
    data: {
        label: [],
        datasets: []
    }
};
// Proptypes Validation
$a4fe42e0ca2e138d$var$RiskScoreChart.propTypes = {
    title: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    titleIcon: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element
    ]),
    summaryValue: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number
    ]),
    summaryText: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    data: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        labels: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Array),
        datasets: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Array)
    })
};
var $a4fe42e0ca2e138d$export$2e2bcd8739ae039 = $a4fe42e0ca2e138d$var$RiskScoreChart;


var $bb35a469562832f3$export$2e2bcd8739ae039 = (0, $a4fe42e0ca2e138d$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");


const $85d828c84821e513$export$324e31927cdce384 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;

  width: 100%;
  max-height: 210px;
  padding: 10px;
  border-radius: 5px;

  font-size: 15px;
  font-weight: 100;

  background-color: white;
  border: ${({ theme: theme })=>`solid 1px ${theme.colors.backgroundLite}`}
`;
const $85d828c84821e513$export$f6e328cdd35fc0a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  height: 130px;
  display: flex;
  gap: 10px;
  padding: 0 20px;
  width: 90%;
  flex: 1 1 auto;
`;
const $85d828c84821e513$export$18905376b593f802 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 10px;
`;
const $85d828c84821e513$export$e13153c55bb9aac2 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-evenly;
  flex-direction: column;
  flex: 1 1 auto;

  gap: 10px;
  width: 100%;
  max-width: 50px;
  padding: 10px 0;

  text-align: right;
`;
const $85d828c84821e513$export$6380f7c8889d475d = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 12px;
  font-weight: 500;

  margin-bottom: 5px;

  color: ${({ theme: theme })=>theme.colors.primary}
`;
const $85d828c84821e513$export$aff3d949dcd13c9b = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 12px;
`;


function $9022fb7dbe44790f$var$SeverityChart(props) {
    // Destructure
    const { data: data } = props;
    const { uiData: uiData, chartData: chartData } = data;
    const options = {
        indexAxis: 'y',
        elements: {
            bar: {
                borderWidth: 2
            }
        },
        responsive: true,
        layout: {
            padding: {
                left: 60,
                right: 20
            }
        },
        clip: false,
        maintainAspectRatio: false,
        legend: {
            display: false
        },
        tooltips: {
            enabled: true
        },
        scales: {
            xAxes: [
                {
                    gridLines: {
                        display: false
                    },
                    ticks: {
                        display: false,
                        beginAtZero: true
                    }
                }
            ],
            yAxes: [
                {
                    gridLines: {
                        display: false
                    },
                    ticks: {
                        mirror: true,
                        padding: 60,
                        beginAtZero: true
                    }
                }
            ]
        }
    };
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $85d828c84821e513$export$324e31927cdce384), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $85d828c84821e513$export$6380f7c8889d475d), {
                children: "Alert Severity"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $85d828c84821e513$export$f6e328cdd35fc0a), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $17a3afb6e0e3a44f$export$2e2bcd8739ae039), {
                        data: chartData,
                        options: options
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $85d828c84821e513$export$18905376b593f802), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $85d828c84821e513$export$e13153c55bb9aac2), {
                                children: uiData && uiData.map((item)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $85d828c84821e513$export$aff3d949dcd13c9b), {
                                        children: item.alert_count
                                    }, item.severity))
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $85d828c84821e513$export$e13153c55bb9aac2), {
                                children: uiData && uiData.map((item)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $85d828c84821e513$export$aff3d949dcd13c9b), {
                                        children: [
                                            item.percent,
                                            "%"
                                        ]
                                    }, item.severity))
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
// Default Props
$9022fb7dbe44790f$var$SeverityChart.defaultProps = {
    data: {
        chartData: {},
        uiData: [
            {
                alert_count: 0,
                severity: 'High',
                percent: 0
            },
            {
                alert_count: 0,
                severity: 'Medium',
                percent: 0
            },
            {
                alert_count: 0,
                severity: 'Low',
                percent: 0
            }
        ]
    }
};
// Proptypes Validation
$9022fb7dbe44790f$var$SeverityChart.propTypes = {
    data: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        chartData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            datasets: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Array),
            labels: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Array)
        }),
        uiData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            alert_count: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
            severity: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            percent: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number
        }))
    })
};
var $9022fb7dbe44790f$export$2e2bcd8739ae039 = $9022fb7dbe44790f$var$SeverityChart;


var $cb6b630c8bd96a38$export$2e2bcd8739ae039 = (0, $9022fb7dbe44790f$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $0de7c92496a83817$export$b9dcbe7159acfdce = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: 100%;
`;
const $0de7c92496a83817$export$87ad169bde460ddf = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
`;



function $684c32ba6f594257$var$RiskLineChart(props) {
    // Destructure
    const { data: data, options: options } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $0de7c92496a83817$export$b9dcbe7159acfdce), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $0de7c92496a83817$export$87ad169bde460ddf), {
            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1b9c00692a27807c$export$2e2bcd8739ae039), {
                data: data,
                width: 200,
                height: 200,
                options: options
            })
        })
    });
}
// Default Props
$684c32ba6f594257$var$RiskLineChart.defaultProps = {
    data: {
        label: [],
        datasets: []
    },
    options: {}
};
// Proptypes Validation
$684c32ba6f594257$var$RiskLineChart.propTypes = {
    data: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({}),
    options: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({})
};
var $684c32ba6f594257$export$2e2bcd8739ae039 = $684c32ba6f594257$var$RiskLineChart;


var $4acb425a46e5b624$export$2e2bcd8739ae039 = (0, $684c32ba6f594257$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $2dc53a53b7226c5d$export$b9dcbe7159acfdce = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: 100%;
`;
const $2dc53a53b7226c5d$export$87ad169bde460ddf = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
`;



function $c21681cc9c7c17b5$var$FinancialLineChart(props) {
    // Destructure
    const { data: data, options: options } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2dc53a53b7226c5d$export$b9dcbe7159acfdce), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2dc53a53b7226c5d$export$87ad169bde460ddf), {
            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1b9c00692a27807c$export$2e2bcd8739ae039), {
                data: data,
                width: 200,
                height: 200,
                options: options
            })
        })
    });
}
// Default Props
$c21681cc9c7c17b5$var$FinancialLineChart.defaultProps = {
    data: {
        label: [],
        datasets: []
    },
    options: {}
};
// Proptypes Validation
$c21681cc9c7c17b5$var$FinancialLineChart.propTypes = {
    data: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({}),
    options: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({})
};
var $c21681cc9c7c17b5$export$2e2bcd8739ae039 = $c21681cc9c7c17b5$var$FinancialLineChart;


var $159d1ecded702fec$export$2e2bcd8739ae039 = (0, $c21681cc9c7c17b5$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");
// ES6 Map
var $3eb1dbb6edd78a80$var$map;
try {
    $3eb1dbb6edd78a80$var$map = Map;
} catch (_) {}
var $3eb1dbb6edd78a80$var$set;
// ES6 Set
try {
    $3eb1dbb6edd78a80$var$set = Set;
} catch (_) {}
function $3eb1dbb6edd78a80$var$baseClone(src, circulars, clones) {
    // Null/undefined/functions/etc
    if (!src || typeof src !== 'object' || typeof src === 'function') return src;
    // DOM Node
    if (src.nodeType && 'cloneNode' in src) return src.cloneNode(true);
    // Date
    if (src instanceof Date) return new Date(src.getTime());
    // RegExp
    if (src instanceof RegExp) return new RegExp(src);
    // Arrays
    if (Array.isArray(src)) return src.map($3eb1dbb6edd78a80$export$2e2bcd8739ae039);
    // ES6 Maps
    if ($3eb1dbb6edd78a80$var$map && src instanceof $3eb1dbb6edd78a80$var$map) return new Map(Array.from(src.entries()));
    // ES6 Sets
    if ($3eb1dbb6edd78a80$var$set && src instanceof $3eb1dbb6edd78a80$var$set) return new Set(Array.from(src.values()));
    // Object
    if (src instanceof Object) {
        circulars.push(src);
        var obj = Object.create(src);
        clones.push(obj);
        for(var key in src){
            var idx = circulars.findIndex(function(i) {
                return i === src[key];
            });
            obj[key] = idx > -1 ? clones[idx] : $3eb1dbb6edd78a80$var$baseClone(src[key], circulars, clones);
        }
        return obj;
    }
    // ???
    return src;
}
function $3eb1dbb6edd78a80$export$2e2bcd8739ae039(src) {
    return $3eb1dbb6edd78a80$var$baseClone(src, [], []);
}


const $147ef32bdcaf021e$var$toString = Object.prototype.toString;
const $147ef32bdcaf021e$var$errorToString = Error.prototype.toString;
const $147ef32bdcaf021e$var$regExpToString = RegExp.prototype.toString;
const $147ef32bdcaf021e$var$symbolToString = typeof Symbol !== 'undefined' ? Symbol.prototype.toString : ()=>'';
const $147ef32bdcaf021e$var$SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;
function $147ef32bdcaf021e$var$printNumber(val) {
    if (val != +val) return 'NaN';
    const isNegativeZero = val === 0 && 1 / val < 0;
    return isNegativeZero ? '-0' : '' + val;
}
function $147ef32bdcaf021e$var$printSimpleValue(val, quoteStrings = false) {
    if (val == null || val === true || val === false) return '' + val;
    const typeOf = typeof val;
    if (typeOf === 'number') return $147ef32bdcaf021e$var$printNumber(val);
    if (typeOf === 'string') return quoteStrings ? `"${val}"` : val;
    if (typeOf === 'function') return '[Function ' + (val.name || 'anonymous') + ']';
    if (typeOf === 'symbol') return $147ef32bdcaf021e$var$symbolToString.call(val).replace($147ef32bdcaf021e$var$SYMBOL_REGEXP, 'Symbol($1)');
    const tag = $147ef32bdcaf021e$var$toString.call(val).slice(8, -1);
    if (tag === 'Date') return isNaN(val.getTime()) ? '' + val : val.toISOString(val);
    if (tag === 'Error' || val instanceof Error) return '[' + $147ef32bdcaf021e$var$errorToString.call(val) + ']';
    if (tag === 'RegExp') return $147ef32bdcaf021e$var$regExpToString.call(val);
    return null;
}
function $147ef32bdcaf021e$export$2e2bcd8739ae039(value, quoteStrings) {
    let result = $147ef32bdcaf021e$var$printSimpleValue(value, quoteStrings);
    if (result !== null) return result;
    return JSON.stringify(value, function(key, value) {
        let result = $147ef32bdcaf021e$var$printSimpleValue(this[key], quoteStrings);
        if (result !== null) return result;
        return value;
    }, 2);
}


let $1c1b592314ddf558$export$9b30b6294c1449a8 = {
    default: '${path} is invalid',
    required: '${path} is a required field',
    oneOf: '${path} must be one of the following values: ${values}',
    notOneOf: '${path} must not be one of the following values: ${values}',
    notType: ({ path: path, type: type, value: value, originalValue: originalValue })=>{
        let isCast = originalValue != null && originalValue !== value;
        let msg = `${path} must be a \`${type}\` type, ` + `but the final value was: \`${(0, $147ef32bdcaf021e$export$2e2bcd8739ae039)(value, true)}\`` + (isCast ? ` (cast from the value \`${(0, $147ef32bdcaf021e$export$2e2bcd8739ae039)(originalValue, true)}\`).` : '.');
        if (value === null) msg += `\n If "null" is intended as an empty value be sure to mark the schema as \`.nullable()\``;
        return msg;
    },
    defined: '${path} must be defined'
};
let $1c1b592314ddf558$export$22b082955e083ec3 = {
    length: '${path} must be exactly ${length} characters',
    min: '${path} must be at least ${min} characters',
    max: '${path} must be at most ${max} characters',
    matches: '${path} must match the following: "${regex}"',
    email: '${path} must be a valid email',
    url: '${path} must be a valid URL',
    uuid: '${path} must be a valid UUID',
    trim: '${path} must be a trimmed string',
    lowercase: '${path} must be a lowercase string',
    uppercase: '${path} must be a upper case string'
};
let $1c1b592314ddf558$export$98e628dec113755e = {
    min: '${path} must be greater than or equal to ${min}',
    max: '${path} must be less than or equal to ${max}',
    lessThan: '${path} must be less than ${less}',
    moreThan: '${path} must be greater than ${more}',
    positive: '${path} must be a positive number',
    negative: '${path} must be a negative number',
    integer: '${path} must be an integer'
};
let $1c1b592314ddf558$export$324d90190a8b822a = {
    min: '${path} field must be later than ${min}',
    max: '${path} field must be at earlier than ${max}'
};
let $1c1b592314ddf558$export$4a21f16c33752377 = {
    isValue: '${path} field must be ${value}'
};
let $1c1b592314ddf558$export$be5493f9613cbbe = {
    noUnknown: '${path} field has unspecified keys: ${unknown}'
};
let $1c1b592314ddf558$export$2f23118c22fb2630 = {
    min: '${path} field must have at least ${min} items',
    max: '${path} field must have less than or equal to ${max} items',
    length: '${path} must have ${length} items'
};
var $1c1b592314ddf558$export$2e2bcd8739ae039 = Object.assign(Object.create(null), {
    mixed: $1c1b592314ddf558$export$9b30b6294c1449a8,
    string: $1c1b592314ddf558$export$22b082955e083ec3,
    number: $1c1b592314ddf558$export$98e628dec113755e,
    date: $1c1b592314ddf558$export$324d90190a8b822a,
    object: $1c1b592314ddf558$export$be5493f9613cbbe,
    array: $1c1b592314ddf558$export$2f23118c22fb2630,
    boolean: $1c1b592314ddf558$export$4a21f16c33752377
});


var $c850356d1a91f7ad$exports = {};
var $269de41f43b10f94$exports = {};
/** Used for built-in method references. */ var $269de41f43b10f94$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $269de41f43b10f94$var$hasOwnProperty = $269de41f43b10f94$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $269de41f43b10f94$var$baseHas(object, key) {
    return object != null && $269de41f43b10f94$var$hasOwnProperty.call(object, key);
}
$269de41f43b10f94$exports = $269de41f43b10f94$var$baseHas;



var $jDUbG = parcelRequire("jDUbG");
/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */ function $c850356d1a91f7ad$var$has(object, path) {
    return object != null && $jDUbG(object, path, $269de41f43b10f94$exports);
}
$c850356d1a91f7ad$exports = $c850356d1a91f7ad$var$has;


const $67d1903890dc06a4$var$isSchema = (obj)=>obj && obj.__isYupSchema__;
var $67d1903890dc06a4$export$2e2bcd8739ae039 = $67d1903890dc06a4$var$isSchema;


class $b1f3b3a30361c155$var$Condition {
    constructor(refs, options){
        this.fn = void 0;
        this.refs = refs;
        this.refs = refs;
        if (typeof options === 'function') {
            this.fn = options;
            return;
        }
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($c850356d1a91f7ad$exports)))(options, 'is')) throw new TypeError('`is:` is required for `when()` conditions');
        if (!options.then && !options.otherwise) throw new TypeError('either `then:` or `otherwise:` is required for `when()` conditions');
        let { is: is, then: then, otherwise: otherwise } = options;
        let check = typeof is === 'function' ? is : (...values)=>values.every((value)=>value === is);
        this.fn = function(...args) {
            let options = args.pop();
            let schema = args.pop();
            let branch = check(...args) ? then : otherwise;
            if (!branch) return undefined;
            if (typeof branch === 'function') return branch(schema);
            return schema.concat(branch.resolve(options));
        };
    }
    resolve(base, options) {
        let values = this.refs.map((ref)=>ref.getValue(options == null ? void 0 : options.value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context));
        let schema = this.fn.apply(base, values.concat(base, options));
        if (schema === undefined || schema === base) return base;
        if (!(0, $67d1903890dc06a4$export$2e2bcd8739ae039)(schema)) throw new TypeError('conditions must return a schema object');
        return schema.resolve(options);
    }
}
var $b1f3b3a30361c155$export$2e2bcd8739ae039 = $b1f3b3a30361c155$var$Condition;



function $5e43bb636954bef9$export$2e2bcd8739ae039(value) {
    return value == null ? [] : [].concat(value);
}


function $949d4e507ad2aa7e$var$_extends() {
    $949d4e507ad2aa7e$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $949d4e507ad2aa7e$var$_extends.apply(this, arguments);
}
let $949d4e507ad2aa7e$var$strReg = /\$\{\s*(\w+)\s*\}/g;
class $949d4e507ad2aa7e$export$2e2bcd8739ae039 extends Error {
    static formatError(message, params) {
        const path = params.label || params.path || 'this';
        if (path !== params.path) params = $949d4e507ad2aa7e$var$_extends({}, params, {
            path: path
        });
        if (typeof message === 'string') return message.replace($949d4e507ad2aa7e$var$strReg, (_, key)=>(0, $147ef32bdcaf021e$export$2e2bcd8739ae039)(params[key]));
        if (typeof message === 'function') return message(params);
        return message;
    }
    static isError(err) {
        return err && err.name === 'ValidationError';
    }
    constructor(errorOrErrors, value, field, type){
        super();
        this.value = void 0;
        this.path = void 0;
        this.type = void 0;
        this.errors = void 0;
        this.params = void 0;
        this.inner = void 0;
        this.name = 'ValidationError';
        this.value = value;
        this.path = field;
        this.type = type;
        this.errors = [];
        this.inner = [];
        (0, $5e43bb636954bef9$export$2e2bcd8739ae039)(errorOrErrors).forEach((err)=>{
            if ($949d4e507ad2aa7e$export$2e2bcd8739ae039.isError(err)) {
                this.errors.push(...err.errors);
                this.inner = this.inner.concat(err.inner.length ? err.inner : err);
            } else this.errors.push(err);
        });
        this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
        if (Error.captureStackTrace) Error.captureStackTrace(this, $949d4e507ad2aa7e$export$2e2bcd8739ae039);
    }
}


const $059aabe9e1543cf3$var$once = (cb)=>{
    let fired = false;
    return (...args)=>{
        if (fired) return;
        fired = true;
        cb(...args);
    };
};
function $059aabe9e1543cf3$export$2e2bcd8739ae039(options, cb) {
    let { endEarly: endEarly, tests: tests, args: args, value: value, errors: errors, sort: sort, path: path } = options;
    let callback = $059aabe9e1543cf3$var$once(cb);
    let count = tests.length;
    const nestedErrors = [];
    errors = errors ? errors : [];
    if (!count) return errors.length ? callback(new (0, $949d4e507ad2aa7e$export$2e2bcd8739ae039)(errors, value, path)) : callback(null, value);
    for(let i = 0; i < tests.length; i++){
        const test = tests[i];
        test(args, function finishTestRun(err) {
            if (err) {
                // always return early for non validation errors
                if (!(0, $949d4e507ad2aa7e$export$2e2bcd8739ae039).isError(err)) return callback(err, value);
                if (endEarly) {
                    err.value = value;
                    return callback(err, value);
                }
                nestedErrors.push(err);
            }
            if (--count <= 0) {
                if (nestedErrors.length) {
                    if (sort) nestedErrors.sort(sort); //show parent errors after the nested ones: name.first, name
                    if (errors.length) nestedErrors.push(...errors);
                    errors = nestedErrors;
                }
                if (errors.length) {
                    callback(new (0, $949d4e507ad2aa7e$export$2e2bcd8739ae039)(errors, value, path), value);
                    return;
                }
                callback(null, value);
            }
        });
    }
}


var $6f464387334652ee$exports = {};

var $1SQen = parcelRequire("1SQen");

var $aHH9J = parcelRequire("aHH9J");

var $kTyAU = parcelRequire("kTyAU");
/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $6f464387334652ee$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $kTyAU(iteratee, 3);
    $aHH9J(object, function(value, key, object) {
        $1SQen(result, key, iteratee(value, key, object));
    });
    return result;
}
$6f464387334652ee$exports = $6f464387334652ee$var$mapValues;



var $931f785505603eb5$exports = {};
/**
 * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
 */ 'use strict';
function $931f785505603eb5$var$Cache(maxSize) {
    this._maxSize = maxSize;
    this.clear();
}
$931f785505603eb5$var$Cache.prototype.clear = function() {
    this._size = 0;
    this._values = Object.create(null);
};
$931f785505603eb5$var$Cache.prototype.get = function(key) {
    return this._values[key];
};
$931f785505603eb5$var$Cache.prototype.set = function(key, value) {
    this._size >= this._maxSize && this.clear();
    if (!(key in this._values)) this._size++;
    return this._values[key] = value;
};
var $931f785505603eb5$var$SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g, $931f785505603eb5$var$DIGIT_REGEX = /^\d+$/, $931f785505603eb5$var$LEAD_DIGIT_REGEX = /^\d/, $931f785505603eb5$var$SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, $931f785505603eb5$var$CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/, $931f785505603eb5$var$MAX_CACHE_SIZE = 512;
var $931f785505603eb5$var$pathCache = new $931f785505603eb5$var$Cache($931f785505603eb5$var$MAX_CACHE_SIZE), $931f785505603eb5$var$setCache = new $931f785505603eb5$var$Cache($931f785505603eb5$var$MAX_CACHE_SIZE), $931f785505603eb5$var$getCache = new $931f785505603eb5$var$Cache($931f785505603eb5$var$MAX_CACHE_SIZE);
var $931f785505603eb5$var$config;
$931f785505603eb5$exports = {
    Cache: $931f785505603eb5$var$Cache,
    split: $931f785505603eb5$var$split,
    normalizePath: $931f785505603eb5$var$normalizePath,
    setter: function(path) {
        var parts = $931f785505603eb5$var$normalizePath(path);
        return $931f785505603eb5$var$setCache.get(path) || $931f785505603eb5$var$setCache.set(path, function setter(obj, value) {
            var index = 0;
            var len = parts.length;
            var data = obj;
            while(index < len - 1){
                var part = parts[index];
                if (part === '__proto__' || part === 'constructor' || part === 'prototype') return obj;
                data = data[parts[index++]];
            }
            data[parts[index]] = value;
        });
    },
    getter: function(path, safe) {
        var parts = $931f785505603eb5$var$normalizePath(path);
        return $931f785505603eb5$var$getCache.get(path) || $931f785505603eb5$var$getCache.set(path, function getter(data) {
            var index = 0, len = parts.length;
            while(index < len){
                if (data != null || !safe) data = data[parts[index++]];
                else return;
            }
            return data;
        });
    },
    join: function(segments) {
        return segments.reduce(function(path, part) {
            return path + ($931f785505603eb5$var$isQuoted(part) || $931f785505603eb5$var$DIGIT_REGEX.test(part) ? '[' + part + ']' : (path ? '.' : '') + part);
        }, '');
    },
    forEach: function(path, cb, thisArg) {
        $931f785505603eb5$var$forEach(Array.isArray(path) ? path : $931f785505603eb5$var$split(path), cb, thisArg);
    }
};
function $931f785505603eb5$var$normalizePath(path) {
    return $931f785505603eb5$var$pathCache.get(path) || $931f785505603eb5$var$pathCache.set(path, $931f785505603eb5$var$split(path).map(function(part) {
        return part.replace($931f785505603eb5$var$CLEAN_QUOTES_REGEX, '$2');
    }));
}
function $931f785505603eb5$var$split(path) {
    return path.match($931f785505603eb5$var$SPLIT_REGEX) || [
        ''
    ];
}
function $931f785505603eb5$var$forEach(parts, iter, thisArg) {
    var len = parts.length, part, idx, isArray, isBracket;
    for(idx = 0; idx < len; idx++){
        part = parts[idx];
        if (part) {
            if ($931f785505603eb5$var$shouldBeQuoted(part)) part = '"' + part + '"';
            isBracket = $931f785505603eb5$var$isQuoted(part);
            isArray = !isBracket && /^\d+$/.test(part);
            iter.call(thisArg, part, isBracket, isArray, idx, parts);
        }
    }
}
function $931f785505603eb5$var$isQuoted(str) {
    return typeof str === 'string' && str && [
        "'",
        '"'
    ].indexOf(str.charAt(0)) !== -1;
}
function $931f785505603eb5$var$hasLeadingNumber(part) {
    return part.match($931f785505603eb5$var$LEAD_DIGIT_REGEX) && !part.match($931f785505603eb5$var$DIGIT_REGEX);
}
function $931f785505603eb5$var$hasSpecialChars(part) {
    return $931f785505603eb5$var$SPEC_CHAR_REGEX.test(part);
}
function $931f785505603eb5$var$shouldBeQuoted(part) {
    return !$931f785505603eb5$var$isQuoted(part) && ($931f785505603eb5$var$hasLeadingNumber(part) || $931f785505603eb5$var$hasSpecialChars(part));
}


const $2af0df923a102911$var$prefixes = {
    context: '$',
    value: '.'
};
function $2af0df923a102911$export$185802fd694ee1f5(key, options) {
    return new $2af0df923a102911$export$2e2bcd8739ae039(key, options);
}
class $2af0df923a102911$export$2e2bcd8739ae039 {
    constructor(key, options = {}){
        this.key = void 0;
        this.isContext = void 0;
        this.isValue = void 0;
        this.isSibling = void 0;
        this.path = void 0;
        this.getter = void 0;
        this.map = void 0;
        if (typeof key !== 'string') throw new TypeError('ref must be a string, got: ' + key);
        this.key = key.trim();
        if (key === '') throw new TypeError('ref must be a non-empty string');
        this.isContext = this.key[0] === $2af0df923a102911$var$prefixes.context;
        this.isValue = this.key[0] === $2af0df923a102911$var$prefixes.value;
        this.isSibling = !this.isContext && !this.isValue;
        let prefix = this.isContext ? $2af0df923a102911$var$prefixes.context : this.isValue ? $2af0df923a102911$var$prefixes.value : '';
        this.path = this.key.slice(prefix.length);
        this.getter = this.path && (0, $931f785505603eb5$exports.getter)(this.path, true);
        this.map = options.map;
    }
    getValue(value, parent, context) {
        let result = this.isContext ? context : this.isValue ? value : parent;
        if (this.getter) result = this.getter(result || {});
        if (this.map) result = this.map(result);
        return result;
    }
    /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */ cast(value, options) {
        return this.getValue(value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
    }
    resolve() {
        return this;
    }
    describe() {
        return {
            type: 'ref',
            key: this.key
        };
    }
    toString() {
        return `Ref(${this.key})`;
    }
    static isRef(value) {
        return value && value.__isYupRef;
    }
} // @ts-ignore
$2af0df923a102911$export$2e2bcd8739ae039.prototype.__isYupRef = true;


function $1e42d4ff626221af$var$_extends() {
    $1e42d4ff626221af$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1e42d4ff626221af$var$_extends.apply(this, arguments);
}
function $1e42d4ff626221af$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $1e42d4ff626221af$export$2e2bcd8739ae039(config) {
    function validate(_ref, cb) {
        let { value: value, path: path = '', label: label, options: options, originalValue: originalValue, sync: sync } = _ref, rest = $1e42d4ff626221af$var$_objectWithoutPropertiesLoose(_ref, [
            "value",
            "path",
            "label",
            "options",
            "originalValue",
            "sync"
        ]);
        const { name: name, test: test, params: params, message: message } = config;
        let { parent: parent, context: context } = options;
        function resolve(item) {
            return (0, $2af0df923a102911$export$2e2bcd8739ae039).isRef(item) ? item.getValue(value, parent, context) : item;
        }
        function createError(overrides = {}) {
            const nextParams = (0, (/*@__PURE__*/$parcel$interopDefault($6f464387334652ee$exports)))($1e42d4ff626221af$var$_extends({
                value: value,
                originalValue: originalValue,
                label: label,
                path: overrides.path || path
            }, params, overrides.params), resolve);
            const error = new (0, $949d4e507ad2aa7e$export$2e2bcd8739ae039)((0, $949d4e507ad2aa7e$export$2e2bcd8739ae039).formatError(overrides.message || message, nextParams), value, nextParams.path, overrides.type || name);
            error.params = nextParams;
            return error;
        }
        let ctx = $1e42d4ff626221af$var$_extends({
            path: path,
            parent: parent,
            type: name,
            createError: createError,
            resolve: resolve,
            options: options,
            originalValue: originalValue
        }, rest);
        if (!sync) {
            try {
                Promise.resolve(test.call(ctx, value, ctx)).then((validOrError)=>{
                    if ((0, $949d4e507ad2aa7e$export$2e2bcd8739ae039).isError(validOrError)) cb(validOrError);
                    else if (!validOrError) cb(createError());
                    else cb(null, validOrError);
                }).catch(cb);
            } catch (err) {
                cb(err);
            }
            return;
        }
        let result;
        try {
            var _ref2;
            result = test.call(ctx, value, ctx);
            if (typeof ((_ref2 = result) == null ? void 0 : _ref2.then) === 'function') throw new Error(`Validation test of type: "${ctx.type}" returned a Promise during a synchronous validate. ` + `This test will finish after the validate call has returned`);
        } catch (err) {
            cb(err);
            return;
        }
        if ((0, $949d4e507ad2aa7e$export$2e2bcd8739ae039).isError(result)) cb(result);
        else if (!result) cb(createError());
        else cb(null, result);
    }
    validate.OPTIONS = config;
    return validate;
}





let $7b29ff6b8a6cad95$var$trim = (part)=>part.substr(0, part.length - 1).substr(1);
function $7b29ff6b8a6cad95$export$c52e5867d5879e24(schema, path, value, context = value) {
    let parent, lastPart, lastPartDebug; // root path: ''
    if (!path) return {
        parent: parent,
        parentPath: path,
        schema: schema
    };
    (0, $931f785505603eb5$exports.forEach)(path, (_part, isBracket, isArray)=>{
        let part = isBracket ? $7b29ff6b8a6cad95$var$trim(_part) : _part;
        schema = schema.resolve({
            context: context,
            parent: parent,
            value: value
        });
        if (schema.innerType) {
            let idx = isArray ? parseInt(part, 10) : 0;
            if (value && idx >= value.length) throw new Error(`Yup.reach cannot resolve an array item at index: ${_part}, in the path: ${path}. ` + `because there is no value at that index. `);
            parent = value;
            value = value && value[idx];
            schema = schema.innerType;
        } // sometimes the array index part of a path doesn't exist: "nested.arr.child"
        // in these cases the current part is the next schema and should be processed
        // in this iteration. For cases where the index signature is included this
        // check will fail and we'll handle the `child` part on the next iteration like normal
        if (!isArray) {
            if (!schema.fields || !schema.fields[part]) throw new Error(`The schema does not contain the path: ${path}. ` + `(failed at: ${lastPartDebug} which is a type: "${schema._type}")`);
            parent = value;
            value = value && value[part];
            schema = schema.fields[part];
        }
        lastPart = part;
        lastPartDebug = isBracket ? '[' + _part + ']' : '.' + _part;
    });
    return {
        schema: schema,
        parent: parent,
        parentPath: lastPart
    };
}
const $7b29ff6b8a6cad95$var$reach = (obj, path, value, context)=>$7b29ff6b8a6cad95$export$c52e5867d5879e24(obj, path, value, context).schema;
var $7b29ff6b8a6cad95$export$2e2bcd8739ae039 = $7b29ff6b8a6cad95$var$reach;




class $6de14c55607b65a5$export$2e2bcd8739ae039 {
    constructor(){
        this.list = void 0;
        this.refs = void 0;
        this.list = new Set();
        this.refs = new Map();
    }
    get size() {
        return this.list.size + this.refs.size;
    }
    describe() {
        const description = [];
        for (const item of this.list)description.push(item);
        for (const [, ref] of this.refs)description.push(ref.describe());
        return description;
    }
    toArray() {
        return Array.from(this.list).concat(Array.from(this.refs.values()));
    }
    resolveAll(resolve) {
        return this.toArray().reduce((acc, e)=>acc.concat((0, $2af0df923a102911$export$2e2bcd8739ae039).isRef(e) ? resolve(e) : e), []);
    }
    add(value) {
        (0, $2af0df923a102911$export$2e2bcd8739ae039).isRef(value) ? this.refs.set(value.key, value) : this.list.add(value);
    }
    delete(value) {
        (0, $2af0df923a102911$export$2e2bcd8739ae039).isRef(value) ? this.refs.delete(value.key) : this.list.delete(value);
    }
    clone() {
        const next = new $6de14c55607b65a5$export$2e2bcd8739ae039();
        next.list = new Set(this.list);
        next.refs = new Map(this.refs);
        return next;
    }
    merge(newItems, removeItems) {
        const next = this.clone();
        newItems.list.forEach((value)=>next.add(value));
        newItems.refs.forEach((value)=>next.add(value));
        removeItems.list.forEach((value)=>next.delete(value));
        removeItems.refs.forEach((value)=>next.delete(value));
        return next;
    }
}



function $d03abb749a9a9e99$var$_extends() {
    $d03abb749a9a9e99$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d03abb749a9a9e99$var$_extends.apply(this, arguments);
}
class $d03abb749a9a9e99$export$2e2bcd8739ae039 {
    constructor(options){
        this.deps = [];
        this.tests = void 0;
        this.transforms = void 0;
        this.conditions = [];
        this._mutate = void 0;
        this._typeError = void 0;
        this._whitelist = new (0, $6de14c55607b65a5$export$2e2bcd8739ae039)();
        this._blacklist = new (0, $6de14c55607b65a5$export$2e2bcd8739ae039)();
        this.exclusiveTests = Object.create(null);
        this.spec = void 0;
        this.tests = [];
        this.transforms = [];
        this.withMutation(()=>{
            this.typeError((0, $1c1b592314ddf558$export$9b30b6294c1449a8).notType);
        });
        this.type = (options == null ? void 0 : options.type) || 'mixed';
        this.spec = $d03abb749a9a9e99$var$_extends({
            strip: false,
            strict: false,
            abortEarly: true,
            recursive: true,
            nullable: false,
            presence: 'optional'
        }, options == null ? void 0 : options.spec);
    }
    get _type() {
        return this.type;
    }
    _typeCheck(_value) {
        return true;
    }
    clone(spec) {
        if (this._mutate) {
            if (spec) Object.assign(this.spec, spec);
            return this;
        } // if the nested value is a schema we can skip cloning, since
        // they are already immutable
        const next = Object.create(Object.getPrototypeOf(this)); // @ts-expect-error this is readonly
        next.type = this.type;
        next._typeError = this._typeError;
        next._whitelistError = this._whitelistError;
        next._blacklistError = this._blacklistError;
        next._whitelist = this._whitelist.clone();
        next._blacklist = this._blacklist.clone();
        next.exclusiveTests = $d03abb749a9a9e99$var$_extends({}, this.exclusiveTests); // @ts-expect-error this is readonly
        next.deps = [
            ...this.deps
        ];
        next.conditions = [
            ...this.conditions
        ];
        next.tests = [
            ...this.tests
        ];
        next.transforms = [
            ...this.transforms
        ];
        next.spec = (0, $3eb1dbb6edd78a80$export$2e2bcd8739ae039)($d03abb749a9a9e99$var$_extends({}, this.spec, spec));
        return next;
    }
    label(label) {
        let next = this.clone();
        next.spec.label = label;
        return next;
    }
    meta(...args) {
        if (args.length === 0) return this.spec.meta;
        let next = this.clone();
        next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
        return next;
    }
    //   TCast,
    //   TContext,
    //   TOutput
    // > {
    //   return this as any;
    // }
    withMutation(fn) {
        let before = this._mutate;
        this._mutate = true;
        let result = fn(this);
        this._mutate = before;
        return result;
    }
    concat(schema) {
        if (!schema || schema === this) return this;
        if (schema.type !== this.type && this.type !== 'mixed') throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${schema.type}`);
        let base = this;
        let combined = schema.clone();
        const mergedSpec = $d03abb749a9a9e99$var$_extends({}, base.spec, combined.spec); // if (combined.spec.nullable === UNSET)
        //   mergedSpec.nullable = base.spec.nullable;
        // if (combined.spec.presence === UNSET)
        //   mergedSpec.presence = base.spec.presence;
        combined.spec = mergedSpec;
        combined._typeError || (combined._typeError = base._typeError);
        combined._whitelistError || (combined._whitelistError = base._whitelistError);
        combined._blacklistError || (combined._blacklistError = base._blacklistError); // manually merge the blacklist/whitelist (the other `schema` takes
        // precedence in case of conflicts)
        combined._whitelist = base._whitelist.merge(schema._whitelist, schema._blacklist);
        combined._blacklist = base._blacklist.merge(schema._blacklist, schema._whitelist); // start with the current tests
        combined.tests = base.tests;
        combined.exclusiveTests = base.exclusiveTests; // manually add the new tests to ensure
        // the deduping logic is consistent
        combined.withMutation((next)=>{
            schema.tests.forEach((fn)=>{
                next.test(fn.OPTIONS);
            });
        });
        combined.transforms = [
            ...base.transforms,
            ...combined.transforms
        ];
        return combined;
    }
    isType(v) {
        if (this.spec.nullable && v === null) return true;
        return this._typeCheck(v);
    }
    resolve(options) {
        let schema = this;
        if (schema.conditions.length) {
            let conditions = schema.conditions;
            schema = schema.clone();
            schema.conditions = [];
            schema = conditions.reduce((schema, condition)=>condition.resolve(schema, options), schema);
            schema = schema.resolve(options);
        }
        return schema;
    }
    /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {*=} options.parent
   * @param {*=} options.context
   */ cast(value, options = {}) {
        let resolvedSchema = this.resolve($d03abb749a9a9e99$var$_extends({
            value: value
        }, options));
        let result = resolvedSchema._cast(value, options);
        if (value !== undefined && options.assert !== false && resolvedSchema.isType(result) !== true) {
            let formattedValue = (0, $147ef32bdcaf021e$export$2e2bcd8739ae039)(value);
            let formattedResult = (0, $147ef32bdcaf021e$export$2e2bcd8739ae039)(result);
            throw new TypeError(`The value of ${options.path || 'field'} could not be cast to a value ` + `that satisfies the schema type: "${resolvedSchema._type}". \n\n` + `attempted value: ${formattedValue} \n` + (formattedResult !== formattedValue ? `result of cast: ${formattedResult}` : ''));
        }
        return result;
    }
    _cast(rawValue, _options) {
        let value = rawValue === undefined ? rawValue : this.transforms.reduce((value, fn)=>fn.call(this, value, rawValue, this), rawValue);
        if (value === undefined) value = this.getDefault();
        return value;
    }
    _validate(_value, options = {}, cb) {
        let { sync: sync, path: path, from: from = [], originalValue: originalValue = _value, strict: strict = this.spec.strict, abortEarly: abortEarly = this.spec.abortEarly } = options;
        let value = _value;
        if (!strict) // this._validating = true;
        value = this._cast(value, $d03abb749a9a9e99$var$_extends({
            assert: false
        }, options)); // this._validating = false;
         // value is cast, we can check if it meets type requirements
        let args = {
            value: value,
            path: path,
            options: options,
            originalValue: originalValue,
            schema: this,
            label: this.spec.label,
            sync: sync,
            from: from
        };
        let initialTests = [];
        if (this._typeError) initialTests.push(this._typeError);
        let finalTests = [];
        if (this._whitelistError) finalTests.push(this._whitelistError);
        if (this._blacklistError) finalTests.push(this._blacklistError);
        (0, $059aabe9e1543cf3$export$2e2bcd8739ae039)({
            args: args,
            value: value,
            path: path,
            sync: sync,
            tests: initialTests,
            endEarly: abortEarly
        }, (err)=>{
            if (err) return void cb(err, value);
            (0, $059aabe9e1543cf3$export$2e2bcd8739ae039)({
                tests: this.tests.concat(finalTests),
                args: args,
                path: path,
                sync: sync,
                value: value,
                endEarly: abortEarly
            }, cb);
        });
    }
    validate(value, options, maybeCb) {
        let schema = this.resolve($d03abb749a9a9e99$var$_extends({}, options, {
            value: value
        })); // callback case is for nested validations
        return typeof maybeCb === 'function' ? schema._validate(value, options, maybeCb) : new Promise((resolve, reject)=>schema._validate(value, options, (err, value)=>{
                if (err) reject(err);
                else resolve(value);
            }));
    }
    validateSync(value, options) {
        let schema = this.resolve($d03abb749a9a9e99$var$_extends({}, options, {
            value: value
        }));
        let result;
        schema._validate(value, $d03abb749a9a9e99$var$_extends({}, options, {
            sync: true
        }), (err, value)=>{
            if (err) throw err;
            result = value;
        });
        return result;
    }
    isValid(value, options) {
        return this.validate(value, options).then(()=>true, (err)=>{
            if ((0, $949d4e507ad2aa7e$export$2e2bcd8739ae039).isError(err)) return false;
            throw err;
        });
    }
    isValidSync(value, options) {
        try {
            this.validateSync(value, options);
            return true;
        } catch (err) {
            if ((0, $949d4e507ad2aa7e$export$2e2bcd8739ae039).isError(err)) return false;
            throw err;
        }
    }
    _getDefault() {
        let defaultValue = this.spec.default;
        if (defaultValue == null) return defaultValue;
        return typeof defaultValue === 'function' ? defaultValue.call(this) : (0, $3eb1dbb6edd78a80$export$2e2bcd8739ae039)(defaultValue);
    }
    getDefault(options) {
        let schema = this.resolve(options || {});
        return schema._getDefault();
    }
    default(def) {
        if (arguments.length === 0) return this._getDefault();
        let next = this.clone({
            default: def
        });
        return next;
    }
    strict(isStrict = true) {
        let next = this.clone();
        next.spec.strict = isStrict;
        return next;
    }
    _isPresent(value) {
        return value != null;
    }
    defined(message = (0, $1c1b592314ddf558$export$9b30b6294c1449a8).defined) {
        return this.test({
            message: message,
            name: 'defined',
            exclusive: true,
            test (value) {
                return value !== undefined;
            }
        });
    }
    required(message = (0, $1c1b592314ddf558$export$9b30b6294c1449a8).required) {
        return this.clone({
            presence: 'required'
        }).withMutation((s)=>s.test({
                message: message,
                name: 'required',
                exclusive: true,
                test (value) {
                    return this.schema._isPresent(value);
                }
            }));
    }
    notRequired() {
        let next = this.clone({
            presence: 'optional'
        });
        next.tests = next.tests.filter((test)=>test.OPTIONS.name !== 'required');
        return next;
    }
    nullable(isNullable = true) {
        let next = this.clone({
            nullable: isNullable !== false
        });
        return next;
    }
    transform(fn) {
        let next = this.clone();
        next.transforms.push(fn);
        return next;
    }
    /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */ test(...args) {
        let opts;
        if (args.length === 1) {
            if (typeof args[0] === 'function') opts = {
                test: args[0]
            };
            else opts = args[0];
        } else if (args.length === 2) opts = {
            name: args[0],
            test: args[1]
        };
        else opts = {
            name: args[0],
            message: args[1],
            test: args[2]
        };
        if (opts.message === undefined) opts.message = (0, $1c1b592314ddf558$export$9b30b6294c1449a8).default;
        if (typeof opts.test !== 'function') throw new TypeError('`test` is a required parameters');
        let next = this.clone();
        let validate = (0, $1e42d4ff626221af$export$2e2bcd8739ae039)(opts);
        let isExclusive = opts.exclusive || opts.name && next.exclusiveTests[opts.name] === true;
        if (opts.exclusive) {
            if (!opts.name) throw new TypeError('Exclusive tests must provide a unique `name` identifying the test');
        }
        if (opts.name) next.exclusiveTests[opts.name] = !!opts.exclusive;
        next.tests = next.tests.filter((fn)=>{
            if (fn.OPTIONS.name === opts.name) {
                if (isExclusive) return false;
                if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
            }
            return true;
        });
        next.tests.push(validate);
        return next;
    }
    when(keys, options) {
        if (!Array.isArray(keys) && typeof keys !== 'string') {
            options = keys;
            keys = '.';
        }
        let next = this.clone();
        let deps = (0, $5e43bb636954bef9$export$2e2bcd8739ae039)(keys).map((key)=>new (0, $2af0df923a102911$export$2e2bcd8739ae039)(key));
        deps.forEach((dep)=>{
            // @ts-ignore
            if (dep.isSibling) next.deps.push(dep.key);
        });
        next.conditions.push(new (0, $b1f3b3a30361c155$export$2e2bcd8739ae039)(deps, options));
        return next;
    }
    typeError(message) {
        let next = this.clone();
        next._typeError = (0, $1e42d4ff626221af$export$2e2bcd8739ae039)({
            message: message,
            name: 'typeError',
            test (value) {
                if (value !== undefined && !this.schema.isType(value)) return this.createError({
                    params: {
                        type: this.schema._type
                    }
                });
                return true;
            }
        });
        return next;
    }
    oneOf(enums, message = (0, $1c1b592314ddf558$export$9b30b6294c1449a8).oneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._whitelist.add(val);
            next._blacklist.delete(val);
        });
        next._whitelistError = (0, $1e42d4ff626221af$export$2e2bcd8739ae039)({
            message: message,
            name: 'oneOf',
            test (value) {
                if (value === undefined) return true;
                let valids = this.schema._whitelist;
                let resolved = valids.resolveAll(this.resolve);
                return resolved.includes(value) ? true : this.createError({
                    params: {
                        values: valids.toArray().join(', '),
                        resolved: resolved
                    }
                });
            }
        });
        return next;
    }
    notOneOf(enums, message = (0, $1c1b592314ddf558$export$9b30b6294c1449a8).notOneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._blacklist.add(val);
            next._whitelist.delete(val);
        });
        next._blacklistError = (0, $1e42d4ff626221af$export$2e2bcd8739ae039)({
            message: message,
            name: 'notOneOf',
            test (value) {
                let invalids = this.schema._blacklist;
                let resolved = invalids.resolveAll(this.resolve);
                if (resolved.includes(value)) return this.createError({
                    params: {
                        values: invalids.toArray().join(', '),
                        resolved: resolved
                    }
                });
                return true;
            }
        });
        return next;
    }
    strip(strip = true) {
        let next = this.clone();
        next.spec.strip = strip;
        return next;
    }
    describe() {
        const next = this.clone();
        const { label: label, meta: meta } = next.spec;
        const description = {
            meta: meta,
            label: label,
            type: next.type,
            oneOf: next._whitelist.describe(),
            notOneOf: next._blacklist.describe(),
            tests: next.tests.map((fn)=>({
                    name: fn.OPTIONS.name,
                    params: fn.OPTIONS.params
                })).filter((n, idx, list)=>list.findIndex((c)=>c.name === n.name) === idx)
        };
        return description;
    }
} // eslint-disable-next-line @typescript-eslint/no-unused-vars
// @ts-expect-error
$d03abb749a9a9e99$export$2e2bcd8739ae039.prototype.__isYupSchema__ = true;
for (const method of [
    'validate',
    'validateSync'
])$d03abb749a9a9e99$export$2e2bcd8739ae039.prototype[`${method}At`] = function(path, value, options = {}) {
    const { parent: parent, parentPath: parentPath, schema: schema } = (0, $7b29ff6b8a6cad95$export$c52e5867d5879e24)(this, path, value, options.context);
    return schema[method](parent && parent[parentPath], $d03abb749a9a9e99$var$_extends({}, options, {
        parent: parent,
        path: path
    }));
};
for (const alias of [
    'equals',
    'is'
])$d03abb749a9a9e99$export$2e2bcd8739ae039.prototype[alias] = $d03abb749a9a9e99$export$2e2bcd8739ae039.prototype.oneOf;
for (const alias of [
    'not',
    'nope'
])$d03abb749a9a9e99$export$2e2bcd8739ae039.prototype[alias] = $d03abb749a9a9e99$export$2e2bcd8739ae039.prototype.notOneOf;
$d03abb749a9a9e99$export$2e2bcd8739ae039.prototype.optional = $d03abb749a9a9e99$export$2e2bcd8739ae039.prototype.notRequired;


const $765ac6576a95acd2$var$Mixed = (0, $d03abb749a9a9e99$export$2e2bcd8739ae039);
var $765ac6576a95acd2$export$2e2bcd8739ae039 = $765ac6576a95acd2$var$Mixed;
function $765ac6576a95acd2$export$185802fd694ee1f5() {
    return new $765ac6576a95acd2$var$Mixed();
} // XXX: this is using the Base schema so that `addMethod(mixed)` works as a base class
$765ac6576a95acd2$export$185802fd694ee1f5.prototype = $765ac6576a95acd2$var$Mixed.prototype;




const $3705f1549d5e3fb7$var$isAbsent = (value)=>value == null;
var $3705f1549d5e3fb7$export$2e2bcd8739ae039 = $3705f1549d5e3fb7$var$isAbsent;


function $b84f09f6970af0be$export$185802fd694ee1f5() {
    return new $b84f09f6970af0be$export$2e2bcd8739ae039();
}
class $b84f09f6970af0be$export$2e2bcd8739ae039 extends (0, $d03abb749a9a9e99$export$2e2bcd8739ae039) {
    constructor(){
        super({
            type: 'boolean'
        });
        this.withMutation(()=>{
            this.transform(function(value) {
                if (!this.isType(value)) {
                    if (/^(true|1)$/i.test(String(value))) return true;
                    if (/^(false|0)$/i.test(String(value))) return false;
                }
                return value;
            });
        });
    }
    _typeCheck(v) {
        if (v instanceof Boolean) v = v.valueOf();
        return typeof v === 'boolean';
    }
    isTrue(message = (0, $1c1b592314ddf558$export$4a21f16c33752377).isValue) {
        return this.test({
            message: message,
            name: 'is-value',
            exclusive: true,
            params: {
                value: 'true'
            },
            test (value) {
                return (0, $3705f1549d5e3fb7$export$2e2bcd8739ae039)(value) || value === true;
            }
        });
    }
    isFalse(message = (0, $1c1b592314ddf558$export$4a21f16c33752377).isValue) {
        return this.test({
            message: message,
            name: 'is-value',
            exclusive: true,
            params: {
                value: 'false'
            },
            test (value) {
                return (0, $3705f1549d5e3fb7$export$2e2bcd8739ae039)(value) || value === false;
            }
        });
    }
}
$b84f09f6970af0be$export$185802fd694ee1f5.prototype = $b84f09f6970af0be$export$2e2bcd8739ae039.prototype;





let $7092ea25693c72ef$var$rEmail = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i; // eslint-disable-next-line
let $7092ea25693c72ef$var$rUrl = /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i; // eslint-disable-next-line
let $7092ea25693c72ef$var$rUUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
let $7092ea25693c72ef$var$isTrimmed = (value)=>(0, $3705f1549d5e3fb7$export$2e2bcd8739ae039)(value) || value === value.trim();
let $7092ea25693c72ef$var$objStringTag = ({}).toString();
function $7092ea25693c72ef$export$185802fd694ee1f5() {
    return new $7092ea25693c72ef$export$2e2bcd8739ae039();
}
class $7092ea25693c72ef$export$2e2bcd8739ae039 extends (0, $d03abb749a9a9e99$export$2e2bcd8739ae039) {
    constructor(){
        super({
            type: 'string'
        });
        this.withMutation(()=>{
            this.transform(function(value) {
                if (this.isType(value)) return value;
                if (Array.isArray(value)) return value;
                const strValue = value != null && value.toString ? value.toString() : value;
                if (strValue === $7092ea25693c72ef$var$objStringTag) return value;
                return strValue;
            });
        });
    }
    _typeCheck(value) {
        if (value instanceof String) value = value.valueOf();
        return typeof value === 'string';
    }
    _isPresent(value) {
        return super._isPresent(value) && !!value.length;
    }
    length(length, message = (0, $1c1b592314ddf558$export$22b082955e083ec3).length) {
        return this.test({
            message: message,
            name: 'length',
            exclusive: true,
            params: {
                length: length
            },
            test (value) {
                return (0, $3705f1549d5e3fb7$export$2e2bcd8739ae039)(value) || value.length === this.resolve(length);
            }
        });
    }
    min(min, message = (0, $1c1b592314ddf558$export$22b082955e083ec3).min) {
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            test (value) {
                return (0, $3705f1549d5e3fb7$export$2e2bcd8739ae039)(value) || value.length >= this.resolve(min);
            }
        });
    }
    max(max, message = (0, $1c1b592314ddf558$export$22b082955e083ec3).max) {
        return this.test({
            name: 'max',
            exclusive: true,
            message: message,
            params: {
                max: max
            },
            test (value) {
                return (0, $3705f1549d5e3fb7$export$2e2bcd8739ae039)(value) || value.length <= this.resolve(max);
            }
        });
    }
    matches(regex, options) {
        let excludeEmptyString = false;
        let message;
        let name;
        if (options) {
            if (typeof options === 'object') ({ excludeEmptyString: excludeEmptyString = false, message: message, name: name } = options);
            else message = options;
        }
        return this.test({
            name: name || 'matches',
            message: message || (0, $1c1b592314ddf558$export$22b082955e083ec3).matches,
            params: {
                regex: regex
            },
            test: (value)=>(0, $3705f1549d5e3fb7$export$2e2bcd8739ae039)(value) || value === '' && excludeEmptyString || value.search(regex) !== -1
        });
    }
    email(message = (0, $1c1b592314ddf558$export$22b082955e083ec3).email) {
        return this.matches($7092ea25693c72ef$var$rEmail, {
            name: 'email',
            message: message,
            excludeEmptyString: true
        });
    }
    url(message = (0, $1c1b592314ddf558$export$22b082955e083ec3).url) {
        return this.matches($7092ea25693c72ef$var$rUrl, {
            name: 'url',
            message: message,
            excludeEmptyString: true
        });
    }
    uuid(message = (0, $1c1b592314ddf558$export$22b082955e083ec3).uuid) {
        return this.matches($7092ea25693c72ef$var$rUUID, {
            name: 'uuid',
            message: message,
            excludeEmptyString: false
        });
    }
    ensure() {
        return this.default('').transform((val)=>val === null ? '' : val);
    }
    trim(message = (0, $1c1b592314ddf558$export$22b082955e083ec3).trim) {
        return this.transform((val)=>val != null ? val.trim() : val).test({
            message: message,
            name: 'trim',
            test: $7092ea25693c72ef$var$isTrimmed
        });
    }
    lowercase(message = (0, $1c1b592314ddf558$export$22b082955e083ec3).lowercase) {
        return this.transform((value)=>!(0, $3705f1549d5e3fb7$export$2e2bcd8739ae039)(value) ? value.toLowerCase() : value).test({
            message: message,
            name: 'string_case',
            exclusive: true,
            test: (value)=>(0, $3705f1549d5e3fb7$export$2e2bcd8739ae039)(value) || value === value.toLowerCase()
        });
    }
    uppercase(message = (0, $1c1b592314ddf558$export$22b082955e083ec3).uppercase) {
        return this.transform((value)=>!(0, $3705f1549d5e3fb7$export$2e2bcd8739ae039)(value) ? value.toUpperCase() : value).test({
            message: message,
            name: 'string_case',
            exclusive: true,
            test: (value)=>(0, $3705f1549d5e3fb7$export$2e2bcd8739ae039)(value) || value === value.toUpperCase()
        });
    }
}
$7092ea25693c72ef$export$185802fd694ee1f5.prototype = $7092ea25693c72ef$export$2e2bcd8739ae039.prototype; //
 // String Interfaces
 //





let $add935e52327df44$var$isNaN = (value)=>value != +value;
function $add935e52327df44$export$185802fd694ee1f5() {
    return new $add935e52327df44$export$2e2bcd8739ae039();
}
class $add935e52327df44$export$2e2bcd8739ae039 extends (0, $d03abb749a9a9e99$export$2e2bcd8739ae039) {
    constructor(){
        super({
            type: 'number'
        });
        this.withMutation(()=>{
            this.transform(function(value) {
                let parsed = value;
                if (typeof parsed === 'string') {
                    parsed = parsed.replace(/\s/g, '');
                    if (parsed === '') return NaN; // don't use parseFloat to avoid positives on alpha-numeric strings
                    parsed = +parsed;
                }
                if (this.isType(parsed)) return parsed;
                return parseFloat(parsed);
            });
        });
    }
    _typeCheck(value) {
        if (value instanceof Number) value = value.valueOf();
        return typeof value === 'number' && !$add935e52327df44$var$isNaN(value);
    }
    min(min, message = (0, $1c1b592314ddf558$export$98e628dec113755e).min) {
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            test (value) {
                return (0, $3705f1549d5e3fb7$export$2e2bcd8739ae039)(value) || value >= this.resolve(min);
            }
        });
    }
    max(max, message = (0, $1c1b592314ddf558$export$98e628dec113755e).max) {
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                max: max
            },
            test (value) {
                return (0, $3705f1549d5e3fb7$export$2e2bcd8739ae039)(value) || value <= this.resolve(max);
            }
        });
    }
    lessThan(less, message = (0, $1c1b592314ddf558$export$98e628dec113755e).lessThan) {
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                less: less
            },
            test (value) {
                return (0, $3705f1549d5e3fb7$export$2e2bcd8739ae039)(value) || value < this.resolve(less);
            }
        });
    }
    moreThan(more, message = (0, $1c1b592314ddf558$export$98e628dec113755e).moreThan) {
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                more: more
            },
            test (value) {
                return (0, $3705f1549d5e3fb7$export$2e2bcd8739ae039)(value) || value > this.resolve(more);
            }
        });
    }
    positive(msg = (0, $1c1b592314ddf558$export$98e628dec113755e).positive) {
        return this.moreThan(0, msg);
    }
    negative(msg = (0, $1c1b592314ddf558$export$98e628dec113755e).negative) {
        return this.lessThan(0, msg);
    }
    integer(message = (0, $1c1b592314ddf558$export$98e628dec113755e).integer) {
        return this.test({
            name: 'integer',
            message: message,
            test: (val)=>(0, $3705f1549d5e3fb7$export$2e2bcd8739ae039)(val) || Number.isInteger(val)
        });
    }
    truncate() {
        return this.transform((value)=>!(0, $3705f1549d5e3fb7$export$2e2bcd8739ae039)(value) ? value | 0 : value);
    }
    round(method) {
        var _method;
        let avail = [
            'ceil',
            'floor',
            'round',
            'trunc'
        ];
        method = ((_method = method) == null ? void 0 : _method.toLowerCase()) || 'round'; // this exists for symemtry with the new Math.trunc
        if (method === 'trunc') return this.truncate();
        if (avail.indexOf(method.toLowerCase()) === -1) throw new TypeError('Only valid options for round() are: ' + avail.join(', '));
        return this.transform((value)=>!(0, $3705f1549d5e3fb7$export$2e2bcd8739ae039)(value) ? Math[method](value) : value);
    }
}
$add935e52327df44$export$185802fd694ee1f5.prototype = $add935e52327df44$export$2e2bcd8739ae039.prototype; //
 // Number Interfaces
 //


// @ts-ignore
/* eslint-disable */ /**
 *
 * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
 * NON-CONFORMANT EDITION.
 * © 2011 Colin Snover <http://zetafleet.com>
 * Released under MIT license.
 */ //              1 YYYY                 2 MM        3 DD              4 HH     5 mm        6 ss            7 msec         8 Z 9 ±    10 tzHH    11 tzmm
var $ac7af69004279ed0$var$isoReg = /^(\d{4}|[+\-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
function $ac7af69004279ed0$export$2e2bcd8739ae039(date) {
    var numericKeys = [
        1,
        4,
        5,
        6,
        7,
        10,
        11
    ], minutesOffset = 0, timestamp, struct;
    if (struct = $ac7af69004279ed0$var$isoReg.exec(date)) {
        // avoid NaN timestamps caused by “undefined” values being passed to Date.UTC
        for(var i = 0, k; k = numericKeys[i]; ++i)struct[k] = +struct[k] || 0; // allow undefined days and months
        struct[2] = (+struct[2] || 1) - 1;
        struct[3] = +struct[3] || 1; // allow arbitrary sub-second precision beyond milliseconds
        struct[7] = struct[7] ? String(struct[7]).substr(0, 3) : 0; // timestamps without timezone identifiers should be considered local time
        if ((struct[8] === undefined || struct[8] === '') && (struct[9] === undefined || struct[9] === '')) timestamp = +new Date(struct[1], struct[2], struct[3], struct[4], struct[5], struct[6], struct[7]);
        else {
            if (struct[8] !== 'Z' && struct[9] !== undefined) {
                minutesOffset = struct[10] * 60 + struct[11];
                if (struct[9] === '+') minutesOffset = 0 - minutesOffset;
            }
            timestamp = Date.UTC(struct[1], struct[2], struct[3], struct[4], struct[5] + minutesOffset, struct[6], struct[7]);
        }
    } else timestamp = Date.parse ? Date.parse(date) : NaN;
    return timestamp;
}






let $e039e5cb92bd30b2$var$invalidDate = new Date('');
let $e039e5cb92bd30b2$var$isDate = (obj)=>Object.prototype.toString.call(obj) === '[object Date]';
function $e039e5cb92bd30b2$export$185802fd694ee1f5() {
    return new $e039e5cb92bd30b2$export$2e2bcd8739ae039();
}
class $e039e5cb92bd30b2$export$2e2bcd8739ae039 extends (0, $d03abb749a9a9e99$export$2e2bcd8739ae039) {
    constructor(){
        super({
            type: 'date'
        });
        this.withMutation(()=>{
            this.transform(function(value) {
                if (this.isType(value)) return value;
                value = (0, $ac7af69004279ed0$export$2e2bcd8739ae039)(value); // 0 is a valid timestamp equivalent to 1970-01-01T00:00:00Z(unix epoch) or before.
                return !isNaN(value) ? new Date(value) : $e039e5cb92bd30b2$var$invalidDate;
            });
        });
    }
    _typeCheck(v) {
        return $e039e5cb92bd30b2$var$isDate(v) && !isNaN(v.getTime());
    }
    prepareParam(ref, name) {
        let param;
        if (!(0, $2af0df923a102911$export$2e2bcd8739ae039).isRef(ref)) {
            let cast = this.cast(ref);
            if (!this._typeCheck(cast)) throw new TypeError(`\`${name}\` must be a Date or a value that can be \`cast()\` to a Date`);
            param = cast;
        } else param = ref;
        return param;
    }
    min(min, message = (0, $1c1b592314ddf558$export$324d90190a8b822a).min) {
        let limit = this.prepareParam(min, 'min');
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            test (value) {
                return (0, $3705f1549d5e3fb7$export$2e2bcd8739ae039)(value) || value >= this.resolve(limit);
            }
        });
    }
    max(max, message = (0, $1c1b592314ddf558$export$324d90190a8b822a).max) {
        let limit = this.prepareParam(max, 'max');
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                max: max
            },
            test (value) {
                return (0, $3705f1549d5e3fb7$export$2e2bcd8739ae039)(value) || value <= this.resolve(limit);
            }
        });
    }
}
$e039e5cb92bd30b2$export$2e2bcd8739ae039.INVALID_DATE = $e039e5cb92bd30b2$var$invalidDate;
$e039e5cb92bd30b2$export$185802fd694ee1f5.prototype = $e039e5cb92bd30b2$export$2e2bcd8739ae039.prototype;
$e039e5cb92bd30b2$export$185802fd694ee1f5.INVALID_DATE = $e039e5cb92bd30b2$var$invalidDate;



var $e82568bd4998d68e$exports = {};
var $cb4dd6d760f06921$exports = {};
var $ef7ac61a0d361e26$exports = {};
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $ef7ac61a0d361e26$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
$ef7ac61a0d361e26$exports = $ef7ac61a0d361e26$var$arrayReduce;


var $20055183c04e4752$exports = {};
var $3b68ce0b399e8be1$exports = {};
var $a555aa81d5487f8a$exports = {};
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function $a555aa81d5487f8a$var$basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
$a555aa81d5487f8a$exports = $a555aa81d5487f8a$var$basePropertyOf;


/** Used to map Latin Unicode letters to basic Latin letters. */ var $3b68ce0b399e8be1$var$deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',
    '\xc1': 'A',
    '\xc2': 'A',
    '\xc3': 'A',
    '\xc4': 'A',
    '\xc5': 'A',
    '\xe0': 'a',
    '\xe1': 'a',
    '\xe2': 'a',
    '\xe3': 'a',
    '\xe4': 'a',
    '\xe5': 'a',
    '\xc7': 'C',
    '\xe7': 'c',
    '\xd0': 'D',
    '\xf0': 'd',
    '\xc8': 'E',
    '\xc9': 'E',
    '\xca': 'E',
    '\xcb': 'E',
    '\xe8': 'e',
    '\xe9': 'e',
    '\xea': 'e',
    '\xeb': 'e',
    '\xcc': 'I',
    '\xcd': 'I',
    '\xce': 'I',
    '\xcf': 'I',
    '\xec': 'i',
    '\xed': 'i',
    '\xee': 'i',
    '\xef': 'i',
    '\xd1': 'N',
    '\xf1': 'n',
    '\xd2': 'O',
    '\xd3': 'O',
    '\xd4': 'O',
    '\xd5': 'O',
    '\xd6': 'O',
    '\xd8': 'O',
    '\xf2': 'o',
    '\xf3': 'o',
    '\xf4': 'o',
    '\xf5': 'o',
    '\xf6': 'o',
    '\xf8': 'o',
    '\xd9': 'U',
    '\xda': 'U',
    '\xdb': 'U',
    '\xdc': 'U',
    '\xf9': 'u',
    '\xfa': 'u',
    '\xfb': 'u',
    '\xfc': 'u',
    '\xdd': 'Y',
    '\xfd': 'y',
    '\xff': 'y',
    '\xc6': 'Ae',
    '\xe6': 'ae',
    '\xde': 'Th',
    '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',
    '\u0102': 'A',
    '\u0104': 'A',
    '\u0101': 'a',
    '\u0103': 'a',
    '\u0105': 'a',
    '\u0106': 'C',
    '\u0108': 'C',
    '\u010a': 'C',
    '\u010c': 'C',
    '\u0107': 'c',
    '\u0109': 'c',
    '\u010b': 'c',
    '\u010d': 'c',
    '\u010e': 'D',
    '\u0110': 'D',
    '\u010f': 'd',
    '\u0111': 'd',
    '\u0112': 'E',
    '\u0114': 'E',
    '\u0116': 'E',
    '\u0118': 'E',
    '\u011a': 'E',
    '\u0113': 'e',
    '\u0115': 'e',
    '\u0117': 'e',
    '\u0119': 'e',
    '\u011b': 'e',
    '\u011c': 'G',
    '\u011e': 'G',
    '\u0120': 'G',
    '\u0122': 'G',
    '\u011d': 'g',
    '\u011f': 'g',
    '\u0121': 'g',
    '\u0123': 'g',
    '\u0124': 'H',
    '\u0126': 'H',
    '\u0125': 'h',
    '\u0127': 'h',
    '\u0128': 'I',
    '\u012a': 'I',
    '\u012c': 'I',
    '\u012e': 'I',
    '\u0130': 'I',
    '\u0129': 'i',
    '\u012b': 'i',
    '\u012d': 'i',
    '\u012f': 'i',
    '\u0131': 'i',
    '\u0134': 'J',
    '\u0135': 'j',
    '\u0136': 'K',
    '\u0137': 'k',
    '\u0138': 'k',
    '\u0139': 'L',
    '\u013b': 'L',
    '\u013d': 'L',
    '\u013f': 'L',
    '\u0141': 'L',
    '\u013a': 'l',
    '\u013c': 'l',
    '\u013e': 'l',
    '\u0140': 'l',
    '\u0142': 'l',
    '\u0143': 'N',
    '\u0145': 'N',
    '\u0147': 'N',
    '\u014a': 'N',
    '\u0144': 'n',
    '\u0146': 'n',
    '\u0148': 'n',
    '\u014b': 'n',
    '\u014c': 'O',
    '\u014e': 'O',
    '\u0150': 'O',
    '\u014d': 'o',
    '\u014f': 'o',
    '\u0151': 'o',
    '\u0154': 'R',
    '\u0156': 'R',
    '\u0158': 'R',
    '\u0155': 'r',
    '\u0157': 'r',
    '\u0159': 'r',
    '\u015a': 'S',
    '\u015c': 'S',
    '\u015e': 'S',
    '\u0160': 'S',
    '\u015b': 's',
    '\u015d': 's',
    '\u015f': 's',
    '\u0161': 's',
    '\u0162': 'T',
    '\u0164': 'T',
    '\u0166': 'T',
    '\u0163': 't',
    '\u0165': 't',
    '\u0167': 't',
    '\u0168': 'U',
    '\u016a': 'U',
    '\u016c': 'U',
    '\u016e': 'U',
    '\u0170': 'U',
    '\u0172': 'U',
    '\u0169': 'u',
    '\u016b': 'u',
    '\u016d': 'u',
    '\u016f': 'u',
    '\u0171': 'u',
    '\u0173': 'u',
    '\u0174': 'W',
    '\u0175': 'w',
    '\u0176': 'Y',
    '\u0177': 'y',
    '\u0178': 'Y',
    '\u0179': 'Z',
    '\u017b': 'Z',
    '\u017d': 'Z',
    '\u017a': 'z',
    '\u017c': 'z',
    '\u017e': 'z',
    '\u0132': 'IJ',
    '\u0133': 'ij',
    '\u0152': 'Oe',
    '\u0153': 'oe',
    '\u0149': "'n",
    '\u017f': 's'
};
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var $3b68ce0b399e8be1$var$deburrLetter = $a555aa81d5487f8a$exports($3b68ce0b399e8be1$var$deburredLetters);
$3b68ce0b399e8be1$exports = $3b68ce0b399e8be1$var$deburrLetter;



var $62oCn = parcelRequire("62oCn");
/** Used to match Latin Unicode letters (excluding mathematical operators). */ var $20055183c04e4752$var$reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var $20055183c04e4752$var$rsComboMarksRange = '\\u0300-\\u036f', $20055183c04e4752$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $20055183c04e4752$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $20055183c04e4752$var$rsComboRange = $20055183c04e4752$var$rsComboMarksRange + $20055183c04e4752$var$reComboHalfMarksRange + $20055183c04e4752$var$rsComboSymbolsRange;
/** Used to compose unicode capture groups. */ var $20055183c04e4752$var$rsCombo = '[' + $20055183c04e4752$var$rsComboRange + ']';
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var $20055183c04e4752$var$reComboMark = RegExp($20055183c04e4752$var$rsCombo, 'g');
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function $20055183c04e4752$var$deburr(string) {
    string = $62oCn(string);
    return string && string.replace($20055183c04e4752$var$reLatin, $3b68ce0b399e8be1$exports).replace($20055183c04e4752$var$reComboMark, '');
}
$20055183c04e4752$exports = $20055183c04e4752$var$deburr;


var $d82e354158a6e93a$exports = {};
var $8e0af69fd7b975bc$exports = {};
/** Used to match words composed of alphanumeric characters. */ var $8e0af69fd7b975bc$var$reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $8e0af69fd7b975bc$var$asciiWords(string) {
    return string.match($8e0af69fd7b975bc$var$reAsciiWord) || [];
}
$8e0af69fd7b975bc$exports = $8e0af69fd7b975bc$var$asciiWords;


var $b5f4ebcdd215f288$exports = {};
/** Used to detect strings that need a more robust regexp to match words. */ var $b5f4ebcdd215f288$var$reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */ function $b5f4ebcdd215f288$var$hasUnicodeWord(string) {
    return $b5f4ebcdd215f288$var$reHasUnicodeWord.test(string);
}
$b5f4ebcdd215f288$exports = $b5f4ebcdd215f288$var$hasUnicodeWord;



var $62oCn = parcelRequire("62oCn");
var $493a830696a14eb4$exports = {};
/** Used to compose unicode character classes. */ var $493a830696a14eb4$var$rsAstralRange = '\\ud800-\\udfff', $493a830696a14eb4$var$rsComboMarksRange = '\\u0300-\\u036f', $493a830696a14eb4$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $493a830696a14eb4$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $493a830696a14eb4$var$rsComboRange = $493a830696a14eb4$var$rsComboMarksRange + $493a830696a14eb4$var$reComboHalfMarksRange + $493a830696a14eb4$var$rsComboSymbolsRange, $493a830696a14eb4$var$rsDingbatRange = '\\u2700-\\u27bf', $493a830696a14eb4$var$rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', $493a830696a14eb4$var$rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', $493a830696a14eb4$var$rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', $493a830696a14eb4$var$rsPunctuationRange = '\\u2000-\\u206f', $493a830696a14eb4$var$rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', $493a830696a14eb4$var$rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', $493a830696a14eb4$var$rsVarRange = '\\ufe0e\\ufe0f', $493a830696a14eb4$var$rsBreakRange = $493a830696a14eb4$var$rsMathOpRange + $493a830696a14eb4$var$rsNonCharRange + $493a830696a14eb4$var$rsPunctuationRange + $493a830696a14eb4$var$rsSpaceRange;
/** Used to compose unicode capture groups. */ var $493a830696a14eb4$var$rsApos = "['\u2019]", $493a830696a14eb4$var$rsBreak = '[' + $493a830696a14eb4$var$rsBreakRange + ']', $493a830696a14eb4$var$rsCombo = '[' + $493a830696a14eb4$var$rsComboRange + ']', $493a830696a14eb4$var$rsDigits = '\\d+', $493a830696a14eb4$var$rsDingbat = '[' + $493a830696a14eb4$var$rsDingbatRange + ']', $493a830696a14eb4$var$rsLower = '[' + $493a830696a14eb4$var$rsLowerRange + ']', $493a830696a14eb4$var$rsMisc = '[^' + $493a830696a14eb4$var$rsAstralRange + $493a830696a14eb4$var$rsBreakRange + $493a830696a14eb4$var$rsDigits + $493a830696a14eb4$var$rsDingbatRange + $493a830696a14eb4$var$rsLowerRange + $493a830696a14eb4$var$rsUpperRange + ']', $493a830696a14eb4$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $493a830696a14eb4$var$rsModifier = '(?:' + $493a830696a14eb4$var$rsCombo + '|' + $493a830696a14eb4$var$rsFitz + ')', $493a830696a14eb4$var$rsNonAstral = '[^' + $493a830696a14eb4$var$rsAstralRange + ']', $493a830696a14eb4$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $493a830696a14eb4$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $493a830696a14eb4$var$rsUpper = '[' + $493a830696a14eb4$var$rsUpperRange + ']', $493a830696a14eb4$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $493a830696a14eb4$var$rsMiscLower = '(?:' + $493a830696a14eb4$var$rsLower + '|' + $493a830696a14eb4$var$rsMisc + ')', $493a830696a14eb4$var$rsMiscUpper = '(?:' + $493a830696a14eb4$var$rsUpper + '|' + $493a830696a14eb4$var$rsMisc + ')', $493a830696a14eb4$var$rsOptContrLower = '(?:' + $493a830696a14eb4$var$rsApos + '(?:d|ll|m|re|s|t|ve))?', $493a830696a14eb4$var$rsOptContrUpper = '(?:' + $493a830696a14eb4$var$rsApos + '(?:D|LL|M|RE|S|T|VE))?', $493a830696a14eb4$var$reOptMod = $493a830696a14eb4$var$rsModifier + '?', $493a830696a14eb4$var$rsOptVar = '[' + $493a830696a14eb4$var$rsVarRange + ']?', $493a830696a14eb4$var$rsOptJoin = '(?:' + $493a830696a14eb4$var$rsZWJ + '(?:' + [
    $493a830696a14eb4$var$rsNonAstral,
    $493a830696a14eb4$var$rsRegional,
    $493a830696a14eb4$var$rsSurrPair
].join('|') + ')' + $493a830696a14eb4$var$rsOptVar + $493a830696a14eb4$var$reOptMod + ')*', $493a830696a14eb4$var$rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', $493a830696a14eb4$var$rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', $493a830696a14eb4$var$rsSeq = $493a830696a14eb4$var$rsOptVar + $493a830696a14eb4$var$reOptMod + $493a830696a14eb4$var$rsOptJoin, $493a830696a14eb4$var$rsEmoji = '(?:' + [
    $493a830696a14eb4$var$rsDingbat,
    $493a830696a14eb4$var$rsRegional,
    $493a830696a14eb4$var$rsSurrPair
].join('|') + ')' + $493a830696a14eb4$var$rsSeq;
/** Used to match complex or compound words. */ var $493a830696a14eb4$var$reUnicodeWord = RegExp([
    $493a830696a14eb4$var$rsUpper + '?' + $493a830696a14eb4$var$rsLower + '+' + $493a830696a14eb4$var$rsOptContrLower + '(?=' + [
        $493a830696a14eb4$var$rsBreak,
        $493a830696a14eb4$var$rsUpper,
        '$'
    ].join('|') + ')',
    $493a830696a14eb4$var$rsMiscUpper + '+' + $493a830696a14eb4$var$rsOptContrUpper + '(?=' + [
        $493a830696a14eb4$var$rsBreak,
        $493a830696a14eb4$var$rsUpper + $493a830696a14eb4$var$rsMiscLower,
        '$'
    ].join('|') + ')',
    $493a830696a14eb4$var$rsUpper + '?' + $493a830696a14eb4$var$rsMiscLower + '+' + $493a830696a14eb4$var$rsOptContrLower,
    $493a830696a14eb4$var$rsUpper + '+' + $493a830696a14eb4$var$rsOptContrUpper,
    $493a830696a14eb4$var$rsOrdUpper,
    $493a830696a14eb4$var$rsOrdLower,
    $493a830696a14eb4$var$rsDigits,
    $493a830696a14eb4$var$rsEmoji
].join('|'), 'g');
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $493a830696a14eb4$var$unicodeWords(string) {
    return string.match($493a830696a14eb4$var$reUnicodeWord) || [];
}
$493a830696a14eb4$exports = $493a830696a14eb4$var$unicodeWords;


/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */ function $d82e354158a6e93a$var$words(string, pattern, guard) {
    string = $62oCn(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) return $b5f4ebcdd215f288$exports(string) ? $493a830696a14eb4$exports(string) : $8e0af69fd7b975bc$exports(string);
    return string.match(pattern) || [];
}
$d82e354158a6e93a$exports = $d82e354158a6e93a$var$words;


/** Used to compose unicode capture groups. */ var $cb4dd6d760f06921$var$rsApos = "['\u2019]";
/** Used to match apostrophes. */ var $cb4dd6d760f06921$var$reApos = RegExp($cb4dd6d760f06921$var$rsApos, 'g');
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */ function $cb4dd6d760f06921$var$createCompounder(callback) {
    return function(string) {
        return $ef7ac61a0d361e26$exports($d82e354158a6e93a$exports($20055183c04e4752$exports(string).replace($cb4dd6d760f06921$var$reApos, '')), callback, '');
    };
}
$cb4dd6d760f06921$exports = $cb4dd6d760f06921$var$createCompounder;


/**
 * Converts `string` to
 * [snake case](https://en.wikipedia.org/wiki/Snake_case).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the snake cased string.
 * @example
 *
 * _.snakeCase('Foo Bar');
 * // => 'foo_bar'
 *
 * _.snakeCase('fooBar');
 * // => 'foo_bar'
 *
 * _.snakeCase('--FOO-BAR--');
 * // => 'foo_bar'
 */ var $e82568bd4998d68e$var$snakeCase = $cb4dd6d760f06921$exports(function(result, word, index) {
    return result + (index ? '_' : '') + word.toLowerCase();
});
$e82568bd4998d68e$exports = $e82568bd4998d68e$var$snakeCase;


var $f5b247de9cbc3d9d$exports = {};
var $2533f51685bbcae1$exports = {};

var $62oCn = parcelRequire("62oCn");
var $69cacff06e7b505c$exports = {};
var $24466b0ccd3aaa84$exports = {};
var $b8714cfb87aa972a$exports = {};
var $a74781887e7d9153$exports = {};
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $a74781887e7d9153$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
$a74781887e7d9153$exports = $a74781887e7d9153$var$baseSlice;


/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $b8714cfb87aa972a$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $a74781887e7d9153$exports(array, start, end);
}
$b8714cfb87aa972a$exports = $b8714cfb87aa972a$var$castSlice;


var $0a47e4200f6d0e3f$exports = {};
/** Used to compose unicode character classes. */ var $0a47e4200f6d0e3f$var$rsAstralRange = '\\ud800-\\udfff', $0a47e4200f6d0e3f$var$rsComboMarksRange = '\\u0300-\\u036f', $0a47e4200f6d0e3f$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $0a47e4200f6d0e3f$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $0a47e4200f6d0e3f$var$rsComboRange = $0a47e4200f6d0e3f$var$rsComboMarksRange + $0a47e4200f6d0e3f$var$reComboHalfMarksRange + $0a47e4200f6d0e3f$var$rsComboSymbolsRange, $0a47e4200f6d0e3f$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $0a47e4200f6d0e3f$var$rsZWJ = '\\u200d';
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $0a47e4200f6d0e3f$var$reHasUnicode = RegExp('[' + $0a47e4200f6d0e3f$var$rsZWJ + $0a47e4200f6d0e3f$var$rsAstralRange + $0a47e4200f6d0e3f$var$rsComboRange + $0a47e4200f6d0e3f$var$rsVarRange + ']');
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $0a47e4200f6d0e3f$var$hasUnicode(string) {
    return $0a47e4200f6d0e3f$var$reHasUnicode.test(string);
}
$0a47e4200f6d0e3f$exports = $0a47e4200f6d0e3f$var$hasUnicode;


var $0b4cb0c23b775313$exports = {};
var $20b5503f3585263b$exports = {};
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $20b5503f3585263b$var$asciiToArray(string) {
    return string.split('');
}
$20b5503f3585263b$exports = $20b5503f3585263b$var$asciiToArray;



var $094b9a8884ea88d7$exports = {};
/** Used to compose unicode character classes. */ var $094b9a8884ea88d7$var$rsAstralRange = '\\ud800-\\udfff', $094b9a8884ea88d7$var$rsComboMarksRange = '\\u0300-\\u036f', $094b9a8884ea88d7$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $094b9a8884ea88d7$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $094b9a8884ea88d7$var$rsComboRange = $094b9a8884ea88d7$var$rsComboMarksRange + $094b9a8884ea88d7$var$reComboHalfMarksRange + $094b9a8884ea88d7$var$rsComboSymbolsRange, $094b9a8884ea88d7$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $094b9a8884ea88d7$var$rsAstral = '[' + $094b9a8884ea88d7$var$rsAstralRange + ']', $094b9a8884ea88d7$var$rsCombo = '[' + $094b9a8884ea88d7$var$rsComboRange + ']', $094b9a8884ea88d7$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $094b9a8884ea88d7$var$rsModifier = '(?:' + $094b9a8884ea88d7$var$rsCombo + '|' + $094b9a8884ea88d7$var$rsFitz + ')', $094b9a8884ea88d7$var$rsNonAstral = '[^' + $094b9a8884ea88d7$var$rsAstralRange + ']', $094b9a8884ea88d7$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $094b9a8884ea88d7$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $094b9a8884ea88d7$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $094b9a8884ea88d7$var$reOptMod = $094b9a8884ea88d7$var$rsModifier + '?', $094b9a8884ea88d7$var$rsOptVar = '[' + $094b9a8884ea88d7$var$rsVarRange + ']?', $094b9a8884ea88d7$var$rsOptJoin = '(?:' + $094b9a8884ea88d7$var$rsZWJ + '(?:' + [
    $094b9a8884ea88d7$var$rsNonAstral,
    $094b9a8884ea88d7$var$rsRegional,
    $094b9a8884ea88d7$var$rsSurrPair
].join('|') + ')' + $094b9a8884ea88d7$var$rsOptVar + $094b9a8884ea88d7$var$reOptMod + ')*', $094b9a8884ea88d7$var$rsSeq = $094b9a8884ea88d7$var$rsOptVar + $094b9a8884ea88d7$var$reOptMod + $094b9a8884ea88d7$var$rsOptJoin, $094b9a8884ea88d7$var$rsSymbol = '(?:' + [
    $094b9a8884ea88d7$var$rsNonAstral + $094b9a8884ea88d7$var$rsCombo + '?',
    $094b9a8884ea88d7$var$rsCombo,
    $094b9a8884ea88d7$var$rsRegional,
    $094b9a8884ea88d7$var$rsSurrPair,
    $094b9a8884ea88d7$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $094b9a8884ea88d7$var$reUnicode = RegExp($094b9a8884ea88d7$var$rsFitz + '(?=' + $094b9a8884ea88d7$var$rsFitz + ')|' + $094b9a8884ea88d7$var$rsSymbol + $094b9a8884ea88d7$var$rsSeq, 'g');
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $094b9a8884ea88d7$var$unicodeToArray(string) {
    return string.match($094b9a8884ea88d7$var$reUnicode) || [];
}
$094b9a8884ea88d7$exports = $094b9a8884ea88d7$var$unicodeToArray;


/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $0b4cb0c23b775313$var$stringToArray(string) {
    return $0a47e4200f6d0e3f$exports(string) ? $094b9a8884ea88d7$exports(string) : $20b5503f3585263b$exports(string);
}
$0b4cb0c23b775313$exports = $0b4cb0c23b775313$var$stringToArray;



var $62oCn = parcelRequire("62oCn");
/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $24466b0ccd3aaa84$var$createCaseFirst(methodName) {
    return function(string) {
        string = $62oCn(string);
        var strSymbols = $0a47e4200f6d0e3f$exports(string) ? $0b4cb0c23b775313$exports(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $b8714cfb87aa972a$exports(strSymbols, 1).join('') : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
$24466b0ccd3aaa84$exports = $24466b0ccd3aaa84$var$createCaseFirst;


/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $69cacff06e7b505c$var$upperFirst = $24466b0ccd3aaa84$exports('toUpperCase');
$69cacff06e7b505c$exports = $69cacff06e7b505c$var$upperFirst;


/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */ function $2533f51685bbcae1$var$capitalize(string) {
    return $69cacff06e7b505c$exports($62oCn(string).toLowerCase());
}
$2533f51685bbcae1$exports = $2533f51685bbcae1$var$capitalize;



/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */ var $f5b247de9cbc3d9d$var$camelCase = $cb4dd6d760f06921$exports(function(result, word, index) {
    word = word.toLowerCase();
    return result + (index ? $2533f51685bbcae1$exports(word) : word);
});
$f5b247de9cbc3d9d$exports = $f5b247de9cbc3d9d$var$camelCase;


var $2cdf4d62056adbe5$exports = {};

var $1SQen = parcelRequire("1SQen");

var $aHH9J = parcelRequire("aHH9J");

var $kTyAU = parcelRequire("kTyAU");
/**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */ function $2cdf4d62056adbe5$var$mapKeys(object, iteratee) {
    var result = {};
    iteratee = $kTyAU(iteratee, 3);
    $aHH9J(object, function(value, key, object) {
        $1SQen(result, iteratee(value, key, object), value);
    });
    return result;
}
$2cdf4d62056adbe5$exports = $2cdf4d62056adbe5$var$mapKeys;






var $256d8808869563bc$exports = {};
/**
 * Topological sorting function
 *
 * @param {Array} edges
 * @returns {Array}
 */ $256d8808869563bc$exports = function(edges) {
    return $256d8808869563bc$var$toposort($256d8808869563bc$var$uniqueNodes(edges), edges);
};
$256d8808869563bc$exports.array = $256d8808869563bc$var$toposort;
function $256d8808869563bc$var$toposort(nodes, edges) {
    var cursor = nodes.length, sorted = new Array(cursor), visited = {}, i = cursor, outgoingEdges = $256d8808869563bc$var$makeOutgoingEdges(edges), nodesHash = $256d8808869563bc$var$makeNodesHash(nodes);
    // check for unknown nodes
    edges.forEach(function(edge) {
        if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) throw new Error('Unknown node. There is an unknown node in the supplied edges.');
    });
    while(i--)if (!visited[i]) visit(nodes[i], i, new Set());
    return sorted;
    function visit(node, i, predecessors) {
        if (predecessors.has(node)) {
            var nodeRep;
            try {
                nodeRep = ", node was:" + JSON.stringify(node);
            } catch (e) {
                nodeRep = "";
            }
            throw new Error('Cyclic dependency' + nodeRep);
        }
        if (!nodesHash.has(node)) throw new Error('Found unknown node. Make sure to provided all involved nodes. Unknown node: ' + JSON.stringify(node));
        if (visited[i]) return;
        visited[i] = true;
        var outgoing = outgoingEdges.get(node) || new Set();
        outgoing = Array.from(outgoing);
        if (i = outgoing.length) {
            predecessors.add(node);
            do {
                var child = outgoing[--i];
                visit(child, nodesHash.get(child), predecessors);
            }while (i);
            predecessors.delete(node);
        }
        sorted[--cursor] = node;
    }
}
function $256d8808869563bc$var$uniqueNodes(arr) {
    var res = new Set();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        res.add(edge[0]);
        res.add(edge[1]);
    }
    return Array.from(res);
}
function $256d8808869563bc$var$makeOutgoingEdges(arr) {
    var edges = new Map();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        if (!edges.has(edge[0])) edges.set(edge[0], new Set());
        if (!edges.has(edge[1])) edges.set(edge[1], new Set());
        edges.get(edge[0]).add(edge[1]);
    }
    return edges;
}
function $256d8808869563bc$var$makeNodesHash(arr) {
    var res = new Map();
    for(var i = 0, len = arr.length; i < len; i++)res.set(arr[i], i);
    return res;
}





function $532415c90bedb71c$export$2e2bcd8739ae039(fields, excludedEdges = []) {
    let edges = [];
    let nodes = new Set();
    let excludes = new Set(excludedEdges.map(([a, b])=>`${a}-${b}`));
    function addNode(depPath, key) {
        let node = (0, $931f785505603eb5$exports.split)(depPath)[0];
        nodes.add(node);
        if (!excludes.has(`${key}-${node}`)) edges.push([
            key,
            node
        ]);
    }
    for(const key in fields)if ((0, (/*@__PURE__*/$parcel$interopDefault($c850356d1a91f7ad$exports)))(fields, key)) {
        let value = fields[key];
        nodes.add(key);
        if ((0, $2af0df923a102911$export$2e2bcd8739ae039).isRef(value) && value.isSibling) addNode(value.path, key);
        else if ((0, $67d1903890dc06a4$export$2e2bcd8739ae039)(value) && 'deps' in value) value.deps.forEach((path)=>addNode(path, key));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($256d8808869563bc$exports))).array(Array.from(nodes), edges).reverse();
}


function $de29228069c87152$var$findIndex(arr, err) {
    let idx = Infinity;
    arr.some((key, ii)=>{
        var _err$path;
        if (((_err$path = err.path) == null ? void 0 : _err$path.indexOf(key)) !== -1) {
            idx = ii;
            return true;
        }
    });
    return idx;
}
function $de29228069c87152$export$2e2bcd8739ae039(keys) {
    return (a, b)=>{
        return $de29228069c87152$var$findIndex(keys, a) - $de29228069c87152$var$findIndex(keys, b);
    };
}





function $84bdfb0f595586e8$var$_extends() {
    $84bdfb0f595586e8$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $84bdfb0f595586e8$var$_extends.apply(this, arguments);
}
let $84bdfb0f595586e8$var$isObject = (obj)=>Object.prototype.toString.call(obj) === '[object Object]';
function $84bdfb0f595586e8$var$unknown(ctx, value) {
    let known = Object.keys(ctx.fields);
    return Object.keys(value).filter((key)=>known.indexOf(key) === -1);
}
const $84bdfb0f595586e8$var$defaultSort = (0, $de29228069c87152$export$2e2bcd8739ae039)([]);
class $84bdfb0f595586e8$export$2e2bcd8739ae039 extends (0, $d03abb749a9a9e99$export$2e2bcd8739ae039) {
    constructor(spec){
        super({
            type: 'object'
        });
        this.fields = Object.create(null);
        this._sortErrors = $84bdfb0f595586e8$var$defaultSort;
        this._nodes = [];
        this._excludedEdges = [];
        this.withMutation(()=>{
            this.transform(function coerce(value) {
                if (typeof value === 'string') try {
                    value = JSON.parse(value);
                } catch (err) {
                    value = null;
                }
                if (this.isType(value)) return value;
                return null;
            });
            if (spec) this.shape(spec);
        });
    }
    _typeCheck(value) {
        return $84bdfb0f595586e8$var$isObject(value) || typeof value === 'function';
    }
    _cast(_value, options = {}) {
        var _options$stripUnknown;
        let value = super._cast(_value, options); //should ignore nulls here
        if (value === undefined) return this.getDefault();
        if (!this._typeCheck(value)) return value;
        let fields = this.fields;
        let strip = (_options$stripUnknown = options.stripUnknown) != null ? _options$stripUnknown : this.spec.noUnknown;
        let props = this._nodes.concat(Object.keys(value).filter((v)=>this._nodes.indexOf(v) === -1));
        let intermediateValue = {}; // is filled during the transform below
        let innerOptions = $84bdfb0f595586e8$var$_extends({}, options, {
            parent: intermediateValue,
            __validating: options.__validating || false
        });
        let isChanged = false;
        for (const prop of props){
            let field = fields[prop];
            let exists = (0, (/*@__PURE__*/$parcel$interopDefault($c850356d1a91f7ad$exports)))(value, prop);
            if (field) {
                let fieldValue;
                let inputValue = value[prop]; // safe to mutate since this is fired in sequence
                innerOptions.path = (options.path ? `${options.path}.` : '') + prop; // innerOptions.value = value[prop];
                field = field.resolve({
                    value: inputValue,
                    context: options.context,
                    parent: intermediateValue
                });
                let fieldSpec = 'spec' in field ? field.spec : undefined;
                let strict = fieldSpec == null ? void 0 : fieldSpec.strict;
                if (fieldSpec == null ? void 0 : fieldSpec.strip) {
                    isChanged = isChanged || prop in value;
                    continue;
                }
                fieldValue = !options.__validating || !strict ? field.cast(value[prop], innerOptions) : value[prop];
                if (fieldValue !== undefined) intermediateValue[prop] = fieldValue;
            } else if (exists && !strip) intermediateValue[prop] = value[prop];
            if (intermediateValue[prop] !== value[prop]) isChanged = true;
        }
        return isChanged ? intermediateValue : value;
    }
    _validate(_value, opts = {}, callback) {
        let errors = [];
        let { sync: sync, from: from = [], originalValue: originalValue = _value, abortEarly: abortEarly = this.spec.abortEarly, recursive: recursive = this.spec.recursive } = opts;
        from = [
            {
                schema: this,
                value: originalValue
            },
            ...from
        ]; // this flag is needed for handling `strict` correctly in the context of
        // validation vs just casting. e.g strict() on a field is only used when validating
        opts.__validating = true;
        opts.originalValue = originalValue;
        opts.from = from;
        super._validate(_value, opts, (err, value)=>{
            if (err) {
                if (!(0, $949d4e507ad2aa7e$export$2e2bcd8739ae039).isError(err) || abortEarly) return void callback(err, value);
                errors.push(err);
            }
            if (!recursive || !$84bdfb0f595586e8$var$isObject(value)) {
                callback(errors[0] || null, value);
                return;
            }
            originalValue = originalValue || value;
            let tests = this._nodes.map((key)=>(_, cb)=>{
                    let path = key.indexOf('.') === -1 ? (opts.path ? `${opts.path}.` : '') + key : `${opts.path || ''}["${key}"]`;
                    let field = this.fields[key];
                    if (field && 'validate' in field) {
                        field.validate(value[key], $84bdfb0f595586e8$var$_extends({}, opts, {
                            path: // @ts-ignore
                            path,
                            from: from,
                            // inner fields are always strict:
                            // 1. this isn't strict so the casting will also have cast inner values
                            // 2. this is strict in which case the nested values weren't cast either
                            strict: true,
                            parent: value,
                            originalValue: originalValue[key]
                        }), cb);
                        return;
                    }
                    cb(null);
                });
            (0, $059aabe9e1543cf3$export$2e2bcd8739ae039)({
                sync: sync,
                tests: tests,
                value: value,
                errors: errors,
                endEarly: abortEarly,
                sort: this._sortErrors,
                path: opts.path
            }, callback);
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        next.fields = $84bdfb0f595586e8$var$_extends({}, this.fields);
        next._nodes = this._nodes;
        next._excludedEdges = this._excludedEdges;
        next._sortErrors = this._sortErrors;
        return next;
    }
    concat(schema) {
        let next = super.concat(schema);
        let nextFields = next.fields;
        for (let [field, schemaOrRef] of Object.entries(this.fields)){
            const target = nextFields[field];
            if (target === undefined) nextFields[field] = schemaOrRef;
            else if (target instanceof (0, $d03abb749a9a9e99$export$2e2bcd8739ae039) && schemaOrRef instanceof (0, $d03abb749a9a9e99$export$2e2bcd8739ae039)) nextFields[field] = schemaOrRef.concat(target);
        }
        return next.withMutation(()=>next.shape(nextFields, this._excludedEdges));
    }
    getDefaultFromShape() {
        let dft = {};
        this._nodes.forEach((key)=>{
            const field = this.fields[key];
            dft[key] = 'default' in field ? field.getDefault() : undefined;
        });
        return dft;
    }
    _getDefault() {
        if ('default' in this.spec) return super._getDefault();
         // if there is no default set invent one
        if (!this._nodes.length) return undefined;
        return this.getDefaultFromShape();
    }
    shape(additions, excludes = []) {
        let next = this.clone();
        let fields = Object.assign(next.fields, additions);
        next.fields = fields;
        next._sortErrors = (0, $de29228069c87152$export$2e2bcd8739ae039)(Object.keys(fields));
        if (excludes.length) {
            // this is a convenience for when users only supply a single pair
            if (!Array.isArray(excludes[0])) excludes = [
                excludes
            ];
            next._excludedEdges = [
                ...next._excludedEdges,
                ...excludes
            ];
        }
        next._nodes = (0, $532415c90bedb71c$export$2e2bcd8739ae039)(fields, next._excludedEdges);
        return next;
    }
    pick(keys) {
        const picked = {};
        for (const key of keys)if (this.fields[key]) picked[key] = this.fields[key];
        return this.clone().withMutation((next)=>{
            next.fields = {};
            return next.shape(picked);
        });
    }
    omit(keys) {
        const next = this.clone();
        const fields = next.fields;
        next.fields = {};
        for (const key of keys)delete fields[key];
        return next.withMutation(()=>next.shape(fields));
    }
    from(from, to, alias) {
        let fromGetter = (0, $931f785505603eb5$exports.getter)(from, true);
        return this.transform((obj)=>{
            if (obj == null) return obj;
            let newObj = obj;
            if ((0, (/*@__PURE__*/$parcel$interopDefault($c850356d1a91f7ad$exports)))(obj, from)) {
                newObj = $84bdfb0f595586e8$var$_extends({}, obj);
                if (!alias) delete newObj[from];
                newObj[to] = fromGetter(obj);
            }
            return newObj;
        });
    }
    noUnknown(noAllow = true, message = (0, $1c1b592314ddf558$export$be5493f9613cbbe).noUnknown) {
        if (typeof noAllow === 'string') {
            message = noAllow;
            noAllow = true;
        }
        let next = this.test({
            name: 'noUnknown',
            exclusive: true,
            message: message,
            test (value) {
                if (value == null) return true;
                const unknownKeys = $84bdfb0f595586e8$var$unknown(this.schema, value);
                return !noAllow || unknownKeys.length === 0 || this.createError({
                    params: {
                        unknown: unknownKeys.join(', ')
                    }
                });
            }
        });
        next.spec.noUnknown = noAllow;
        return next;
    }
    unknown(allow = true, message = (0, $1c1b592314ddf558$export$be5493f9613cbbe).noUnknown) {
        return this.noUnknown(!allow, message);
    }
    transformKeys(fn) {
        return this.transform((obj)=>obj && (0, (/*@__PURE__*/$parcel$interopDefault($2cdf4d62056adbe5$exports)))(obj, (_, key)=>fn(key)));
    }
    camelCase() {
        return this.transformKeys((0, (/*@__PURE__*/$parcel$interopDefault($f5b247de9cbc3d9d$exports))));
    }
    snakeCase() {
        return this.transformKeys((0, (/*@__PURE__*/$parcel$interopDefault($e82568bd4998d68e$exports))));
    }
    constantCase() {
        return this.transformKeys((key)=>(0, (/*@__PURE__*/$parcel$interopDefault($e82568bd4998d68e$exports)))(key).toUpperCase());
    }
    describe() {
        let base = super.describe();
        base.fields = (0, (/*@__PURE__*/$parcel$interopDefault($6f464387334652ee$exports)))(this.fields, (value)=>value.describe());
        return base;
    }
}
function $84bdfb0f595586e8$export$185802fd694ee1f5(spec) {
    return new $84bdfb0f595586e8$export$2e2bcd8739ae039(spec);
}
$84bdfb0f595586e8$export$185802fd694ee1f5.prototype = $84bdfb0f595586e8$export$2e2bcd8739ae039.prototype;









function $33f80b88f26b4a6f$var$_extends() {
    $33f80b88f26b4a6f$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $33f80b88f26b4a6f$var$_extends.apply(this, arguments);
}
function $33f80b88f26b4a6f$export$185802fd694ee1f5(type) {
    return new $33f80b88f26b4a6f$export$2e2bcd8739ae039(type);
}
class $33f80b88f26b4a6f$export$2e2bcd8739ae039 extends (0, $d03abb749a9a9e99$export$2e2bcd8739ae039) {
    constructor(type){
        super({
            type: 'array'
        }); // `undefined` specifically means uninitialized, as opposed to
        // "no subtype"
        this.innerType = void 0;
        this.innerType = type;
        this.withMutation(()=>{
            this.transform(function(values) {
                if (typeof values === 'string') try {
                    values = JSON.parse(values);
                } catch (err) {
                    values = null;
                }
                return this.isType(values) ? values : null;
            });
        });
    }
    _typeCheck(v) {
        return Array.isArray(v);
    }
    get _subType() {
        return this.innerType;
    }
    _cast(_value, _opts) {
        const value = super._cast(_value, _opts); //should ignore nulls here
        if (!this._typeCheck(value) || !this.innerType) return value;
        let isChanged = false;
        const castArray = value.map((v, idx)=>{
            const castElement = this.innerType.cast(v, $33f80b88f26b4a6f$var$_extends({}, _opts, {
                path: `${_opts.path || ''}[${idx}]`
            }));
            if (castElement !== v) isChanged = true;
            return castElement;
        });
        return isChanged ? castArray : value;
    }
    _validate(_value, options = {}, callback) {
        var _options$abortEarly, _options$recursive;
        let errors = [];
        let sync = options.sync;
        let path = options.path;
        let innerType = this.innerType;
        let endEarly = (_options$abortEarly = options.abortEarly) != null ? _options$abortEarly : this.spec.abortEarly;
        let recursive = (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive;
        let originalValue = options.originalValue != null ? options.originalValue : _value;
        super._validate(_value, options, (err, value)=>{
            if (err) {
                if (!(0, $949d4e507ad2aa7e$export$2e2bcd8739ae039).isError(err) || endEarly) return void callback(err, value);
                errors.push(err);
            }
            if (!recursive || !innerType || !this._typeCheck(value)) {
                callback(errors[0] || null, value);
                return;
            }
            originalValue = originalValue || value; // #950 Ensure that sparse array empty slots are validated
            let tests = new Array(value.length);
            for(let idx = 0; idx < value.length; idx++){
                let item = value[idx];
                let path = `${options.path || ''}[${idx}]`; // object._validate note for isStrict explanation
                let innerOptions = $33f80b88f26b4a6f$var$_extends({}, options, {
                    path: path,
                    strict: true,
                    parent: value,
                    index: idx,
                    originalValue: originalValue[idx]
                });
                tests[idx] = (_, cb)=>innerType.validate(item, innerOptions, cb);
            }
            (0, $059aabe9e1543cf3$export$2e2bcd8739ae039)({
                sync: sync,
                path: path,
                value: value,
                errors: errors,
                endEarly: endEarly,
                tests: tests
            }, callback);
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        next.innerType = this.innerType;
        return next;
    }
    concat(schema) {
        let next = super.concat(schema);
        next.innerType = this.innerType;
        if (schema.innerType) next.innerType = next.innerType ? next.innerType.concat(schema.innerType) : schema.innerType;
        return next;
    }
    of(schema) {
        // FIXME: this should return a new instance of array without the default to be
        let next = this.clone();
        if (!(0, $67d1903890dc06a4$export$2e2bcd8739ae039)(schema)) throw new TypeError('`array.of()` sub-schema must be a valid yup schema not: ' + (0, $147ef32bdcaf021e$export$2e2bcd8739ae039)(schema)); // FIXME(ts):
        next.innerType = schema;
        return next;
    }
    length(length, message = (0, $1c1b592314ddf558$export$2f23118c22fb2630).length) {
        return this.test({
            message: message,
            name: 'length',
            exclusive: true,
            params: {
                length: length
            },
            test (value) {
                return (0, $3705f1549d5e3fb7$export$2e2bcd8739ae039)(value) || value.length === this.resolve(length);
            }
        });
    }
    min(min, message) {
        message = message || (0, $1c1b592314ddf558$export$2f23118c22fb2630).min;
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            // FIXME(ts): Array<typeof T>
            test (value) {
                return (0, $3705f1549d5e3fb7$export$2e2bcd8739ae039)(value) || value.length >= this.resolve(min);
            }
        });
    }
    max(max, message) {
        message = message || (0, $1c1b592314ddf558$export$2f23118c22fb2630).max;
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                max: max
            },
            test (value) {
                return (0, $3705f1549d5e3fb7$export$2e2bcd8739ae039)(value) || value.length <= this.resolve(max);
            }
        });
    }
    ensure() {
        return this.default(()=>[]).transform((val, original)=>{
            // We don't want to return `null` for nullable schema
            if (this._typeCheck(val)) return val;
            return original == null ? [] : [].concat(original);
        });
    }
    compact(rejector) {
        let reject = !rejector ? (v)=>!!v : (v, i, a)=>!rejector(v, i, a);
        return this.transform((values)=>values != null ? values.filter(reject) : values);
    }
    describe() {
        let base = super.describe();
        if (this.innerType) base.innerType = this.innerType.describe();
        return base;
    }
    nullable(isNullable = true) {
        return super.nullable(isNullable);
    }
    defined() {
        return super.defined();
    }
    required(msg) {
        return super.required(msg);
    }
}
$33f80b88f26b4a6f$export$185802fd694ee1f5.prototype = $33f80b88f26b4a6f$export$2e2bcd8739ae039.prototype; //
 // Interfaces
 //




function $775190454b213f30$export$185802fd694ee1f5(builder) {
    return new $775190454b213f30$var$Lazy(builder);
}
class $775190454b213f30$var$Lazy {
    constructor(builder){
        this.type = 'lazy';
        this.__isYupSchema__ = true;
        this.__inputType = void 0;
        this.__outputType = void 0;
        this._resolve = (value, options = {})=>{
            let schema = this.builder(value, options);
            if (!(0, $67d1903890dc06a4$export$2e2bcd8739ae039)(schema)) throw new TypeError('lazy() functions must return a valid schema');
            return schema.resolve(options);
        };
        this.builder = builder;
    }
    resolve(options) {
        return this._resolve(options.value, options);
    }
    cast(value, options) {
        return this._resolve(value, options).cast(value, options);
    }
    validate(value, options, maybeCb) {
        // @ts-expect-error missing public callback on type
        return this._resolve(value, options).validate(value, options, maybeCb);
    }
    validateSync(value, options) {
        return this._resolve(value, options).validateSync(value, options);
    }
    validateAt(path, value, options) {
        return this._resolve(value, options).validateAt(path, value, options);
    }
    validateSyncAt(path, value, options) {
        return this._resolve(value, options).validateSyncAt(path, value, options);
    }
    describe() {
        return null;
    }
    isValid(value, options) {
        return this._resolve(value, options).isValid(value, options);
    }
    isValidSync(value, options) {
        return this._resolve(value, options).isValidSync(value, options);
    }
}
var $775190454b213f30$export$2e2bcd8739ae039 = $775190454b213f30$var$Lazy;






function $37f42de643ec4297$export$2e2bcd8739ae039(custom) {
    Object.keys(custom).forEach((type)=>{
        // @ts-ignore
        Object.keys(custom[type]).forEach((method)=>{
            // @ts-ignore
            (0, $1c1b592314ddf558$export$2e2bcd8739ae039)[type][method] = custom[type][method];
        });
    });
}



function $825ccff588a09ff7$export$20be359f745f973c(schemaType, name, fn) {
    if (!schemaType || !(0, $67d1903890dc06a4$export$2e2bcd8739ae039)(schemaType.prototype)) throw new TypeError('You must provide a yup schema constructor function');
    if (typeof name !== 'string') throw new TypeError('A Method name must be provided');
    if (typeof fn !== 'function') throw new TypeError('Method function must be provided');
    schemaType.prototype[name] = fn;
}







const $848ba2c44ae670a7$export$ff5d8ff4a4cd918b = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $848ba2c44ae670a7$export$10e6aa1991a6e74a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $848ba2c44ae670a7$export$e151f1d86035b485 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  margin: 0px 0px 20px 0px;
`;



// Map Redux Props
const $321a36d10733eddc$var$mapStateToProps = (state)=>state;
const $321a36d10733eddc$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $321a36d10733eddc$var$ProfilePersonalInformationForm(props) {
    // Destructure
    const { formRef: formRef, userProfileData: userProfileData, actions: actions } = props;
    const { FullName: FullName, User_Role: User_Role, User_TimeZone: User_TimeZone, User_ID: User_ID, User_Name: User_Name, Business_Name: Business_Name } = userProfileData;
    // Store Actions
    const { setShowHeaderLoader: setShowHeaderLoader, setIsProfileUpdated: setIsProfileUpdated } = actions;
    // Hooks
    const { updateProfile: updateProfile, updateProfileData: updateProfileData, isUpdateProfileLoading: isUpdateProfileLoading } = (0, $60d2f030b368f304$export$2e2bcd8739ae039)();
    const [userCredentials, setUserCredentials] = (0, $a9c50ebe96619b20$export$2e2bcd8739ae039)('userCredentials', {});
    const [savedFullname, setSavedFullname] = (0, $tZqWC.useState)('');
    // Variables
    const initialValues = {
        fullName: FullName,
        role: User_Role,
        timezone: User_TimeZone
    };
    const validationSchema = $84bdfb0f595586e8$export$185802fd694ee1f5().shape({
        fullName: $7092ea25693c72ef$export$185802fd694ee1f5().required('Full Name is required')
    });
    // Functions
    const handleOnSubmit = (values)=>{
        const { fullName: fullName, role: role, timezone: timezone } = values;
        const payload = {
            business_name: Business_Name,
            fullname: fullName,
            user_email: User_Name,
            user_id: User_ID,
            user_role: role,
            user_timezone: timezone
        };
        setSavedFullname(fullName);
        updateProfile(payload);
    };
    // useEffects
    (0, $tZqWC.useEffect)(()=>{
        if (updateProfileData) {
            setUserCredentials({
                ...userCredentials,
                FullName: savedFullname
            });
            setIsProfileUpdated(true);
        }
    }, [
        updateProfileData
    ]);
    (0, $tZqWC.useEffect)(()=>isUpdateProfileLoading ? setShowHeaderLoader(true) : setShowHeaderLoader(false), [
        isUpdateProfileLoading
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $848ba2c44ae670a7$export$ff5d8ff4a4cd918b), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $506ef65bbb4994b7$export$2e2bcd8739ae039), {
            formRef: formRef,
            initialValues: initialValues,
            validationSchema: validationSchema,
            onSubmit: handleOnSubmit,
            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $848ba2c44ae670a7$export$10e6aa1991a6e74a), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $848ba2c44ae670a7$export$e151f1d86035b485), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                            label: "Full Name",
                            type: "text",
                            name: "fullName"
                        })
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $848ba2c44ae670a7$export$e151f1d86035b485), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                            label: "Role",
                            type: "text",
                            name: "role",
                            disabled: true
                        })
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $848ba2c44ae670a7$export$e151f1d86035b485), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                            label: "Timezone",
                            type: "text",
                            name: "timezone",
                            disabled: true
                        })
                    })
                ]
            })
        })
    });
}
// Default Props
$321a36d10733eddc$var$ProfilePersonalInformationForm.defaultProps = {
    formRef: /*#__PURE__*/ (0, $tZqWC.createRef)(),
    userProfileData: {},
    actions: {}
};
// Proptypes Validation
$321a36d10733eddc$var$ProfilePersonalInformationForm.propTypes = {
    formRef: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        root: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    }),
    userProfileData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        FullName: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        User_Role: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        User_TimeZone: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        User_ID: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        User_Name: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        Business_Name: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsProfileUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $321a36d10733eddc$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($321a36d10733eddc$var$mapStateToProps, $321a36d10733eddc$var$mapDispatchToProps)($321a36d10733eddc$var$ProfilePersonalInformationForm);


var $d736e26e3c54b7ee$export$2e2bcd8739ae039 = (0, $321a36d10733eddc$export$2e2bcd8739ae039);



parcelRequire("tZqWC");


var $4L3zM = parcelRequire("4L3zM");


const $a2c155be3c3bdf2a$export$67483fc27e8f5de1 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $a2c155be3c3bdf2a$export$842aba50ed0ce9d7 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).label`
  display: block;
`;
const $a2c155be3c3bdf2a$export$10e6aa1991a6e74a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $a2c155be3c3bdf2a$export$e151f1d86035b485 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  margin: 0px 0px 20px 0px;
`;



function $23d6900d8b075c04$var$ProfileAccountInformationForm(props) {
    // Destructure
    const { userProfileData: userProfileData } = props;
    const { User_ID: User_ID, User_Name: User_Name } = userProfileData;
    // Variables
    const initialValues = {
        userId: User_ID,
        userName: User_Name
    };
    const validationSchema = $84bdfb0f595586e8$export$185802fd694ee1f5().shape({
        userId: $7092ea25693c72ef$export$185802fd694ee1f5().required('User ID is required'),
        userName: $7092ea25693c72ef$export$185802fd694ee1f5().required('User Name is required')
    });
    // Functions
    const handleOnSubmit = ()=>{};
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a2c155be3c3bdf2a$export$67483fc27e8f5de1), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $506ef65bbb4994b7$export$2e2bcd8739ae039), {
            initialValues: initialValues,
            validationSchema: validationSchema,
            onSubmit: handleOnSubmit,
            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $a2c155be3c3bdf2a$export$10e6aa1991a6e74a), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a2c155be3c3bdf2a$export$e151f1d86035b485), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                            label: "User Id",
                            type: "text",
                            name: "userId",
                            disabled: true
                        })
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a2c155be3c3bdf2a$export$e151f1d86035b485), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                            label: "User Name",
                            type: "text",
                            name: "userName",
                            disabled: true
                        })
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $a2c155be3c3bdf2a$export$e151f1d86035b485), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a2c155be3c3bdf2a$export$842aba50ed0ce9d7), {
                                children: "Password"
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $12b33660068e86aa$export$b0d92dbee9b5b60d), {
                                    to: "reset-password",
                                    children: "Change Password"
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
}
// Default Props
$23d6900d8b075c04$var$ProfileAccountInformationForm.defaultProps = {
    userProfileData: {}
};
// Proptypes Validation
$23d6900d8b075c04$var$ProfileAccountInformationForm.propTypes = {
    userProfileData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        User_ID: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        User_Name: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    })
};
var $23d6900d8b075c04$export$2e2bcd8739ae039 = $23d6900d8b075c04$var$ProfileAccountInformationForm;


var $907d1353f9359030$export$2e2bcd8739ae039 = (0, $23d6900d8b075c04$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");


const $8c916d89d0fea315$export$8fde595741768115 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $8c916d89d0fea315$export$10e6aa1991a6e74a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $8c916d89d0fea315$export$e151f1d86035b485 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  margin: 0px 0px 20px 0px;
`;



function $83518409efbec688$var$ProfileOrganizationDetailsForm(props) {
    // Destructure
    const { userProfileData: userProfileData } = props;
    const { Business_Activity: Business_Activity, Business_Address_1: Business_Address_1, Business_Address_2: Business_Address_2, Business_Country: Business_Country, Business_Name: Business_Name, Plan: Plan } = userProfileData;
    // Variables
    const initialValues = {
        businessName: Business_Name,
        businessActivity: Business_Activity,
        businessPlan: Plan,
        addressLine1: Business_Address_1,
        addressLine2: Business_Address_2,
        country: Business_Country
    };
    const validationSchema = $84bdfb0f595586e8$export$185802fd694ee1f5().shape({
        businessName: $7092ea25693c72ef$export$185802fd694ee1f5().required('Business Name is required'),
        businessActivity: $7092ea25693c72ef$export$185802fd694ee1f5().required('Business Activity is required'),
        businessPlan: $7092ea25693c72ef$export$185802fd694ee1f5().required('Business Plan is required'),
        addressLine1: $7092ea25693c72ef$export$185802fd694ee1f5().required('Address Line 1 is required'),
        addressLine2: $7092ea25693c72ef$export$185802fd694ee1f5().required('Address Line 2 is required'),
        country: $7092ea25693c72ef$export$185802fd694ee1f5().required('Country is required')
    });
    // Functions
    const handleOnSubmit = (values)=>{};
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $8c916d89d0fea315$export$8fde595741768115), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $506ef65bbb4994b7$export$2e2bcd8739ae039), {
            initialValues: initialValues,
            validationSchema: validationSchema,
            onSubmit: handleOnSubmit,
            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8c916d89d0fea315$export$10e6aa1991a6e74a), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $8c916d89d0fea315$export$e151f1d86035b485), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                            label: "Business Name",
                            type: "text",
                            name: "businessName",
                            disabled: true
                        })
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $8c916d89d0fea315$export$e151f1d86035b485), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                            label: "Business Activity",
                            type: "text",
                            name: "businessActivity",
                            disabled: true
                        })
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $8c916d89d0fea315$export$e151f1d86035b485), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                            label: "Business Plan",
                            type: "text",
                            name: "businessPlan",
                            disabled: true
                        })
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $8c916d89d0fea315$export$e151f1d86035b485), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                            label: "Address Line 1",
                            type: "text",
                            name: "addressLine1",
                            disabled: true
                        })
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $8c916d89d0fea315$export$e151f1d86035b485), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                            label: "Address Line 2",
                            type: "text",
                            name: "addressLine2",
                            disabled: true
                        })
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $8c916d89d0fea315$export$e151f1d86035b485), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                            label: "Country",
                            type: "text",
                            name: "country",
                            disabled: true
                        })
                    })
                ]
            })
        })
    });
}
// Default Props
$83518409efbec688$var$ProfileOrganizationDetailsForm.defaultProps = {
    userProfileData: {}
};
// Proptypes Validation
$83518409efbec688$var$ProfileOrganizationDetailsForm.propTypes = {
    userProfileData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        Business_Activity: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        Business_Address_1: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        Business_Address_2: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        Business_Country: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        Business_Name: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        Plan: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    })
};
var $83518409efbec688$export$2e2bcd8739ae039 = $83518409efbec688$var$ProfileOrganizationDetailsForm;


var $176ad270ea3babf6$export$2e2bcd8739ae039 = (0, $83518409efbec688$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");


var $7LrRy = parcelRequire("7LrRy");


const $da3b6b6cf62c89db$export$84c7b01c0bdfd5bf = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  height: 100%;
`;
const $da3b6b6cf62c89db$export$ac7496df4f1f837a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
const $da3b6b6cf62c89db$export$8f1ff89fa1ec9605 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
`;
const $da3b6b6cf62c89db$export$842aba50ed0ce9d7 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).label`
  text-align: center;
  font-size: 14px;
  color: ${({ theme: theme })=>theme.colors.primary};
  margin: 30px 0 0 0;
`;
const $da3b6b6cf62c89db$export$2cf7ef1e2dd6c6b1 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).label`
  text-align: center;
  font-size: 14px;
  color: ${({ theme: theme })=>theme.colors.primary};
  margin: 0 0 10px 0;
`;
const $da3b6b6cf62c89db$export$e151f1d86035b485 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  gap: 10px;
  width: 100%;

  & button {
    background: ${({ theme: theme })=>theme.colors.background};
  }
`;




// Map Redux Props
const $40a8f73efc2eb91b$var$mapStateToProps = (state)=>state;
const $40a8f73efc2eb91b$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $40a8f73efc2eb91b$var$LinkAddressForm(props) {
    // Destructure
    const { formData: formData, setFormData: setFormData, actions: actions, ui: ui } = props;
    // Store
    const { isLinkAddressDrawerOpen: isLinkAddressDrawerOpen } = ui;
    const { setIsIndividualAccountDrawerOpen: setIsIndividualAccountDrawerOpen, setIsEntityAccountDrawerOpen: setIsEntityAccountDrawerOpen, setShowHeaderLoader: setShowHeaderLoader, setToBeUpdatedAccount: setToBeUpdatedAccount } = actions;
    // hooks
    const { searchAccount: searchAccount, accountSearchData: accountSearchData, isAccountSearchLoading: isAccountSearchLoading } = (0, $c374fc425c48cdb0$export$2e2bcd8739ae039)();
    const { getAccount: getAccount, accountData: accountData, isAccountLoading: isAccountLoading } = (0, $aa9aabe79903a329$export$2e2bcd8739ae039)();
    // Internal State
    const [searchResults, setSearchResults] = (0, $tZqWC.useState)([]);
    // functions
    const handleSearch = (0, $7LrRy.debounce)((value)=>{
        if (!value) return setSearchResults([]);
        if (value) return searchAccount({
            search_term: value
        });
    }, 500);
    const handleOnAutoCompleteSelect = (value)=>{
        getAccount({
            account_id: value
        });
    };
    // useEffects
    (0, $tZqWC.useEffect)(()=>{
        if (accountData) setFormData({
            ...formData,
            account: {
                ...formData.account,
                ...accountData
            }
        });
    }, [
        accountData
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (accountSearchData) setSearchResults(()=>accountSearchData.map(({ reference_id: reference_id, is_customer: is_customer, id: id })=>({
                    label: reference_id,
                    subLabel: is_customer ? 'Customer' : 'Non-Customer',
                    value: id
                })));
        if (!accountSearchData) setSearchResults([]);
    }, [
        accountSearchData
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (isAccountLoading) {
            setShowHeaderLoader(true);
            setFormData({
                ...formData,
                account: null
            });
        }
        if (!isAccountLoading) setShowHeaderLoader(false);
    }, [
        isAccountLoading
    ]);
    (0, $tZqWC.useEffect)(()=>!isLinkAddressDrawerOpen && setSearchResults([]), [
        isLinkAddressDrawerOpen
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $da3b6b6cf62c89db$export$84c7b01c0bdfd5bf), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $da3b6b6cf62c89db$export$ac7496df4f1f837a), {
            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $da3b6b6cf62c89db$export$8f1ff89fa1ec9605), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $da3b6b6cf62c89db$export$e151f1d86035b485), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $69a991355976a1a9$export$2e2bcd8739ae039), {
                            placeholder: "Search for account",
                            onInputChange: handleSearch,
                            options: searchResults,
                            setOptions: setSearchResults,
                            onSelect: handleOnAutoCompleteSelect,
                            isLoading: isAccountSearchLoading,
                            bottomOptions: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $da3b6b6cf62c89db$export$8f1ff89fa1ec9605), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $da3b6b6cf62c89db$export$2cf7ef1e2dd6c6b1), {
                                        children: "Create New Account"
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $da3b6b6cf62c89db$export$e151f1d86035b485), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                                variant: "outlined",
                                                onClick: ()=>{
                                                    setToBeUpdatedAccount(null);
                                                    setIsIndividualAccountDrawerOpen(true);
                                                },
                                                children: "Individual"
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                                variant: "outlined",
                                                onClick: ()=>{
                                                    setToBeUpdatedAccount(null);
                                                    setIsEntityAccountDrawerOpen(true);
                                                },
                                                children: "Business"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    formData.account && !isAccountLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $da3b6b6cf62c89db$export$842aba50ed0ce9d7), {
                                children: "Selected Account"
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $da3b6b6cf62c89db$export$e151f1d86035b485), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ae78f1d128dc50d5$export$2e2bcd8739ae039), {
                                    label: "Reference ID",
                                    disabled: true,
                                    value: formData.account.reference_id
                                })
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $da3b6b6cf62c89db$export$e151f1d86035b485), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ae78f1d128dc50d5$export$2e2bcd8739ae039), {
                                    label: "Is Customer",
                                    disabled: true,
                                    value: formData.account.is_customer ? 'Yes' : 'No'
                                })
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $da3b6b6cf62c89db$export$e151f1d86035b485), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ae78f1d128dc50d5$export$2e2bcd8739ae039), {
                                    label: "Account Type",
                                    disabled: true,
                                    value: formData.account.account_type_desc
                                })
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $da3b6b6cf62c89db$export$e151f1d86035b485), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ae78f1d128dc50d5$export$2e2bcd8739ae039), {
                                    label: "Name",
                                    disabled: true,
                                    value: formData.account.display_name
                                })
                            })
                        ]
                    }),
                    isAccountLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $da3b6b6cf62c89db$export$842aba50ed0ce9d7), {
                        children: "Loading..."
                    })
                ]
            })
        })
    });
}
// Default Props
$40a8f73efc2eb91b$var$LinkAddressForm.defaultProps = {
    ui: {},
    formData: {},
    setFormData: ()=>{},
    actions: {},
    form: {}
};
// Proptypes Validation
$40a8f73efc2eb91b$var$LinkAddressForm.propTypes = {
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isLinkAddressDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    formData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        transfer: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            in_hash_address: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
        }),
        account: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            reference_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            account_type_desc: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            display_name: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            is_customer: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
        })
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setIsIndividualAccountDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsEntityAccountDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setToBeUpdatedAccount: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    form: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        createdAccount: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({})
    }),
    setFormData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
};
var $40a8f73efc2eb91b$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($40a8f73efc2eb91b$var$mapStateToProps, $40a8f73efc2eb91b$var$mapDispatchToProps)($40a8f73efc2eb91b$var$LinkAddressForm);


var $42b0f37ae1b62244$export$2e2bcd8739ae039 = (0, $40a8f73efc2eb91b$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");


var $7LrRy = parcelRequire("7LrRy");


const $dfa76988bed11d4c$export$84c7b01c0bdfd5bf = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $dfa76988bed11d4c$export$ac7496df4f1f837a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
const $dfa76988bed11d4c$export$8f1ff89fa1ec9605 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
`;
const $dfa76988bed11d4c$export$842aba50ed0ce9d7 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).label`
  text-align: center;
  font-size: 14px;
  color: ${({ theme: theme })=>theme.colors.primary};
  margin: 30px 0 0 0;
`;
const $dfa76988bed11d4c$export$71c7816ee3a5a527 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h3`
  text-align: start;
  font-size: 16px;
  font-weight: 500;
  color: ${({ theme: theme })=>theme.colors.primary};
  margin: 30px 0 0 0;
`;
const $dfa76988bed11d4c$export$2cf7ef1e2dd6c6b1 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).label`
  text-align: center;
  font-size: 14px;
  color: ${({ theme: theme })=>theme.colors.primary};
  margin: 0 0 10px 0;
`;
const $dfa76988bed11d4c$export$e151f1d86035b485 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  gap: 10px;
  width: 100%;

  & button {
    background: ${({ theme: theme })=>theme.colors.background};
  }
`;




// Map Redux Props
const $2cfdd2eb62d76252$var$mapStateToProps = (state)=>state;
const $2cfdd2eb62d76252$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $2cfdd2eb62d76252$var$LinkTransactionForm(props) {
    // Destructure
    const { formData: formData, title: title, label: label, setFormData: setFormData, actions: actions, ui: ui } = props;
    // Store
    const { isLinkTransactionDrawerOpen: isLinkTransactionDrawerOpen } = ui;
    const { setIsIndividualAccountDrawerOpen: setIsIndividualAccountDrawerOpen, setIsEntityAccountDrawerOpen: setIsEntityAccountDrawerOpen, setShowHeaderLoader: setShowHeaderLoader } = actions;
    // hooks
    const { searchAccount: searchAccount, accountSearchData: accountSearchData, isAccountSearchLoading: isAccountSearchLoading } = (0, $c374fc425c48cdb0$export$2e2bcd8739ae039)();
    const { getAccount: getAccount, accountData: accountData, isAccountLoading: isAccountLoading } = (0, $aa9aabe79903a329$export$2e2bcd8739ae039)();
    // Internal State
    const [searchResults, setSearchResults] = (0, $tZqWC.useState)([]);
    // functions
    const handleAccountSearch = (0, $7LrRy.debounce)((value)=>{
        if (!value) return setSearchResults([]);
        if (value) return searchAccount({
            search_term: value
        });
    }, 500);
    const handleOnAutoCompleteSelect = (value)=>{
        getAccount({
            account_id: value
        });
    };
    // useEffects
    (0, $tZqWC.useEffect)(()=>{
        if (accountData) setFormData({
            ...formData,
            account: {
                ...formData.account,
                ...accountData
            }
        });
    }, [
        accountData
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (accountSearchData) setSearchResults(()=>accountSearchData.map(({ external_id: external_id, display_name: display_name, account_id: account_id })=>({
                    label: external_id,
                    subLabel: display_name,
                    value: account_id
                })));
        if (!accountSearchData) setSearchResults([]);
    }, [
        accountSearchData
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (isAccountLoading) {
            setShowHeaderLoader(true);
            setFormData({
                ...formData,
                account: null
            });
        }
        if (!isAccountLoading) setShowHeaderLoader(false);
    }, [
        isAccountLoading
    ]);
    (0, $tZqWC.useEffect)(()=>!isLinkTransactionDrawerOpen && setSearchResults([]), [
        isLinkTransactionDrawerOpen
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $dfa76988bed11d4c$export$84c7b01c0bdfd5bf), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $dfa76988bed11d4c$export$ac7496df4f1f837a), {
            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $dfa76988bed11d4c$export$8f1ff89fa1ec9605), {
                children: [
                    label && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $dfa76988bed11d4c$export$71c7816ee3a5a527), {
                        children: label
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $dfa76988bed11d4c$export$e151f1d86035b485), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $69a991355976a1a9$export$2e2bcd8739ae039), {
                            placeholder: "Search for account",
                            onInputChange: handleAccountSearch,
                            options: searchResults,
                            setOptions: setSearchResults,
                            onSelect: handleOnAutoCompleteSelect,
                            isLoading: isAccountSearchLoading,
                            bottomOptions: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $dfa76988bed11d4c$export$8f1ff89fa1ec9605), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $dfa76988bed11d4c$export$2cf7ef1e2dd6c6b1), {
                                        children: "Create New Account"
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $dfa76988bed11d4c$export$e151f1d86035b485), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                                variant: "outlined",
                                                onClick: ()=>{
                                                    setIsIndividualAccountDrawerOpen(true);
                                                },
                                                children: "Individual"
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                                variant: "outlined",
                                                onClick: ()=>{
                                                    setIsEntityAccountDrawerOpen(true);
                                                },
                                                children: "Business"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    formData.account && !isAccountLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $dfa76988bed11d4c$export$842aba50ed0ce9d7), {
                                children: title || 'Selected Account'
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $dfa76988bed11d4c$export$e151f1d86035b485), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ae78f1d128dc50d5$export$2e2bcd8739ae039), {
                                    label: "External ID",
                                    disabled: true,
                                    value: formData.account.external_id
                                })
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $dfa76988bed11d4c$export$e151f1d86035b485), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ae78f1d128dc50d5$export$2e2bcd8739ae039), {
                                    label: "Account Type",
                                    disabled: true,
                                    value: formData.account.account_type_desc
                                })
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $dfa76988bed11d4c$export$e151f1d86035b485), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ae78f1d128dc50d5$export$2e2bcd8739ae039), {
                                    label: "Name",
                                    disabled: true,
                                    value: formData.account.display_name
                                })
                            })
                        ]
                    }),
                    isAccountLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $dfa76988bed11d4c$export$842aba50ed0ce9d7), {
                        children: "Loading..."
                    })
                ]
            })
        })
    });
}
// Default Props
$2cfdd2eb62d76252$var$LinkTransactionForm.defaultProps = {
    ui: {},
    formData: {},
    setFormData: ()=>{},
    actions: {},
    form: {},
    title: '',
    label: ''
};
// Proptypes Validation
$2cfdd2eb62d76252$var$LinkTransactionForm.propTypes = {
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isLinkTransactionDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    formData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        transfer: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            originator_hash_transaction: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
        }),
        account: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            external_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            account_type_desc: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            display_name: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
        })
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setIsIndividualAccountDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsEntityAccountDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    form: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        createdAccount: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({})
    }),
    setFormData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
};
var $2cfdd2eb62d76252$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($2cfdd2eb62d76252$var$mapStateToProps, $2cfdd2eb62d76252$var$mapDispatchToProps)($2cfdd2eb62d76252$var$LinkTransactionForm);


var $6359c052d65b722c$export$2e2bcd8739ae039 = (0, $2cfdd2eb62d76252$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");


const $ec4d1a62b8fa659d$export$83cd1f1503eb19c0 = (token)=>{
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(window.atob(base64).split('').map((c)=>`%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`).join(''));
    return JSON.parse(jsonPayload);
};






const $25f815199b49c8fd$export$c316e7f3abbfa73a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  & button {
    min-height: 56px;
  }
`;
const $25f815199b49c8fd$export$44f991de2746d2b2 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h1`
  display: flex;
  justify-content: center;
  font-size: 18px;
  color: ${({ theme: theme })=>theme.colors.brand};
  margin: 0 0 30px 0;
`;
const $25f815199b49c8fd$export$bec0e3280b84c170 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).label`
  margin-bottom: 5px;
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $25f815199b49c8fd$export$10e6aa1991a6e74a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  margin: 0px 0px 30px 0px;
`;
const $25f815199b49c8fd$export$e151f1d86035b485 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  margin: 0px 0px 20px 0px;
  & input {
    background-color: ${({ theme: theme })=>theme.colors.background};
  }
  & label {
    background-color: ${({ theme: theme })=>theme.colors.backgroundLite};
    padding: 3px 10px;
  }
`;
const $25f815199b49c8fd$export$c261c83b81138b10 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).a`
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: flex-end;

  margin: 0 0 -20px 0;
  font-size: 12px;
  font-weight: 500;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $25f815199b49c8fd$export$2e0a83ec2e27ecbb = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: 100%;
  height: 1px;
  background-color: ${({ theme: theme })=>theme.colors.secondary};
  margin: 30px 0;
`;



// Map Redux Props
const $6052378cf01b26a1$var$mapStateToProps = (state)=>state;
const $6052378cf01b26a1$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $6052378cf01b26a1$var$LoginForm(props) {
    // Destructure
    const { actions: actions } = props;
    // Store Actions
    const { showAlert: showAlert } = actions;
    // Hooks
    const { loginUser: loginUser, loginUserData: loginUserData, loginUserError: loginUserError, isLoginUserLoading: isLoginUserLoading } = (0, $60a1a1e5035aa390$export$2e2bcd8739ae039)();
    const { getUser: getUser, getUserData: getUserData, isGetUserLoading: isGetUserLoading } = (0, $89db55cadf8da1af$export$2e2bcd8739ae039)();
    const [isLoggedIn, setIsloggedIn] = (0, $a9c50ebe96619b20$export$2e2bcd8739ae039)('isLoggedIn', false);
    const [userCredentials, setUserCredentials] = (0, $a9c50ebe96619b20$export$2e2bcd8739ae039)('userCredentials', {});
    const [, setTheme] = (0, $a9c50ebe96619b20$export$2e2bcd8739ae039)('theme', 'light');
    const [TwoFactorAuthMsg, setTwoFactorAuthMsg] = (0, $tZqWC.useState)();
    const [userData, setUserData] = (0, $tZqWC.useState)();
    // Variables
    const formRef = (0, $tZqWC.useRef)();
    const initialFormValues = {
        username: '',
        password: ''
    };
    const validationSchema = $84bdfb0f595586e8$export$185802fd694ee1f5().shape({
        username: $7092ea25693c72ef$export$185802fd694ee1f5().email('Invalid Email Format').required('Email is required'),
        password: $7092ea25693c72ef$export$185802fd694ee1f5().required('Password is required')
    });
    // Functions
    const handleOnSubmit = (values)=>{
        loginUser(values);
    };
    const handleLoginSuccess = (data)=>{
        if (data?.has_2fa && !data?.access_token) {
            setTwoFactorAuthMsg('The sign in link was sent to your email.');
            return;
        }
        setUserData(data);
        localStorage.setItem('userCredentials', JSON.stringify(data));
        const { uid: uid } = (0, $ec4d1a62b8fa659d$export$83cd1f1503eb19c0)(data.access_token);
        if (uid) getUser({
            user_id: uid
        });
    };
    const login = async ()=>{
        // setting the data in order to make user logged in
        if (loginUserData && !loginUserError) {
            await setTheme('dark');
            await setUserCredentials({
                ...userData,
                ...getUserData
            });
            await setIsloggedIn(true);
        }
    };
    const checkIfSessionExpired = async ()=>{
        // Checking if user session is expired
        if (isLoggedIn && !userCredentials?.access_token) {
            await localStorage.setItem('isLoggedIn', 'false');
            await localStorage.setItem('userCredentials', '{}');
            await localStorage.setItem('reportStrings', '[]');
            await localStorage.setItem('reportTitles', '[]');
            showAlert({
                type: 'error',
                message: 'Session Expired'
            });
        }
    };
    // useEffect
    (0, $tZqWC.useEffect)(()=>loginUserData && handleLoginSuccess(loginUserData), [
        loginUserData
    ]);
    (0, $tZqWC.useEffect)(()=>getUserData && login(), [
        getUserData
    ]);
    (0, $tZqWC.useEffect)(()=>isLoggedIn && window.location.replace(window.location.origin), [
        isLoggedIn
    ]);
    (0, $tZqWC.useEffect)(()=>checkIfSessionExpired(), []);
    (0, $tZqWC.useEffect)(()=>{
        if (!loginUserError) return;
        if (loginUserError?.response?.status === 400) showAlert({
            type: 'error',
            message: 'Username and password did not match'
        });
        else showAlert({
            type: 'error',
            message: 'An error occurred in logging in'
        });
    }, [
        loginUserError
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $25f815199b49c8fd$export$c316e7f3abbfa73a), {
        children: [
            TwoFactorAuthMsg && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $25f815199b49c8fd$export$44f991de2746d2b2), {
                        children: TwoFactorAuthMsg
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                        fullWidth: true,
                        onClick: ()=>{
                            if (formRef.current) formRef.current.resetForm();
                            setTwoFactorAuthMsg();
                        },
                        children: "Sign in with a different account"
                    })
                ]
            }),
            !TwoFactorAuthMsg && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $506ef65bbb4994b7$export$2e2bcd8739ae039), {
                formRef: formRef,
                initialValues: initialFormValues,
                validationSchema: validationSchema,
                onSubmit: handleOnSubmit,
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $25f815199b49c8fd$export$10e6aa1991a6e74a), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $25f815199b49c8fd$export$e151f1d86035b485), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                    label: "Email Address",
                                    type: "email",
                                    name: "username"
                                })
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $25f815199b49c8fd$export$c261c83b81138b10), {
                                href: "/reset_password",
                                children: "Forgot Password?"
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $25f815199b49c8fd$export$e151f1d86035b485), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                    label: "Password",
                                    type: "password",
                                    name: "password"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                        fullWidth: true,
                        type: "submit",
                        disabled: isLoginUserLoading || isGetUserLoading,
                        children: isLoginUserLoading || isGetUserLoading ? 'Logging in...' : 'Sign in'
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $25f815199b49c8fd$export$2e0a83ec2e27ecbb), {}),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $25f815199b49c8fd$export$c261c83b81138b10), {
                                href: "/signup/trial",
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                    fullWidth: true,
                                    variant: "outlined",
                                    type: "button",
                                    children: "Sign up For a Trial Account"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
// Default Props
$6052378cf01b26a1$var$LoginForm.defaultProps = {
    actions: {}
};
// Proptypes Validation
$6052378cf01b26a1$var$LoginForm.propTypes = {
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $6052378cf01b26a1$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($6052378cf01b26a1$var$mapStateToProps, $6052378cf01b26a1$var$mapDispatchToProps)($6052378cf01b26a1$var$LoginForm);


var $d2f304e3909f8828$export$2e2bcd8739ae039 = (0, $6052378cf01b26a1$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");







const $a255ca9762d430e2$export$c316e7f3abbfa73a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  & button {
    min-height: 56px;
  }
`;
const $a255ca9762d430e2$export$44f991de2746d2b2 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h1`
  display: flex;
  justify-content: center;
  text-align: center;
  font-size: 18px;
  color: ${({ theme: theme })=>theme.colors.brand};
  margin: 0 0 30px 0;
`;
const $a255ca9762d430e2$export$ed7753698ef54f84 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h1`
  display: flex;
  justify-content: center;
  text-align: center;
  font-size: 18px;
  color: ${({ theme: theme })=>theme.colors.primary};
  margin: 0 0 30px 0;
`;
const $a255ca9762d430e2$export$bec0e3280b84c170 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).label`
  margin-bottom: 5px;
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $a255ca9762d430e2$export$10e6aa1991a6e74a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  margin: 0px 0px 60px 0px;
`;
const $a255ca9762d430e2$export$e151f1d86035b485 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  margin: 0px 0px 20px 0px;
  & input {
    background-color: ${({ theme: theme })=>theme.colors.background};
  }
  & label {
    background-color: ${({ theme: theme })=>theme.colors.backgroundLite};
    padding: 3px 10px;
  }
`;
const $a255ca9762d430e2$export$c261c83b81138b10 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).a`
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: flex-end;

  margin: 0 0 -20px 0;
  font-size: 12px;
  font-weight: 500;
  color: ${({ theme: theme })=>theme.colors.primary};
`;



// Map Redux Props
const $8aeebeabcd3bbbcb$var$mapStateToProps = (state)=>state;
const $8aeebeabcd3bbbcb$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $8aeebeabcd3bbbcb$var$ResetPasswordForm(props) {
    // Destructure
    const { actions: actions } = props;
    // Store Actions
    const { showAlert: showAlert } = actions;
    // Hooks
    const { resetPassword: resetPassword, resetPasswordData: resetPasswordData, resetPasswordError: resetPasswordError, isResetPasswordLoading: isResetPasswordLoading } = (0, $5e0e8fcf70b29f3d$export$2e2bcd8739ae039)();
    // const { getUserAuth, getUserAuthData, isGetUserAuthLoading } = useGetUserAuth()
    // const [userCredentials, setUserCredentials] = useLocalStorage('userCredentials', {})
    // const [, setTheme] = useLocalStorage('theme', 'light')
    // const [TwoFactorAuthMsg, setTwoFactorAuthMsg] = useState()
    // const [userData, setUserData] = useState()
    // Variables
    const formRef = (0, $tZqWC.useRef)();
    const initialFormValues = {
        email: '',
        password: ''
    };
    const validationSchema = $84bdfb0f595586e8$export$185802fd694ee1f5().shape({
        email: $7092ea25693c72ef$export$185802fd694ee1f5().email('Invalid Email Format').required('Email is required')
    });
    // Functions
    const handleOnSubmit = (values)=>{
        resetPassword(values);
    };
    // const handleLoginSuccess = (data) => {
    //   if (data?.has_2fa && !data?.access_token) {
    //     setTwoFactorAuthMsg('The sign in link was sent to your email.')
    //     return
    //   }
    //   setUserData(data)
    //   localStorage.setItem('userCredentials', JSON.stringify(data))
    //   const { uid } = parseJwt(data.access_token)
    //   if (uid) {
    //     getUserAuth({ user_id: uid })
    //   }
    // }
    (0, $tZqWC.useEffect)(()=>{
        if (resetPasswordError) showAlert({
            type: 'error',
            message: 'An error occurred in sending reset password link'
        });
    }, [
        resetPasswordData
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a255ca9762d430e2$export$c316e7f3abbfa73a), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $506ef65bbb4994b7$export$2e2bcd8739ae039), {
            formRef: formRef,
            initialValues: initialFormValues,
            validationSchema: validationSchema,
            onSubmit: handleOnSubmit,
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $a255ca9762d430e2$export$10e6aa1991a6e74a), {
                    children: [
                        !resetPasswordData && !resetPasswordError && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a255ca9762d430e2$export$ed7753698ef54f84), {
                            children: "Forgot your password? Enter your email to reset your password"
                        }),
                        resetPasswordData && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a255ca9762d430e2$export$44f991de2746d2b2), {
                            children: "Successfully sent reset password link. You may check your email"
                        }),
                        !resetPasswordData && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a255ca9762d430e2$export$e151f1d86035b485), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                label: "Email Address",
                                type: "email",
                                name: "email",
                                disabled: isResetPasswordLoading
                            })
                        })
                    ]
                }),
                !resetPasswordData && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                    fullWidth: true,
                    type: "submit",
                    disabled: isResetPasswordLoading,
                    children: isResetPasswordLoading ? 'Sending email...' : 'Reset Password'
                })
            ]
        })
    });
}
// Default Props
$8aeebeabcd3bbbcb$var$ResetPasswordForm.defaultProps = {
    actions: {}
};
// Proptypes Validation
$8aeebeabcd3bbbcb$var$ResetPasswordForm.propTypes = {
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $8aeebeabcd3bbbcb$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($8aeebeabcd3bbbcb$var$mapStateToProps, $8aeebeabcd3bbbcb$var$mapDispatchToProps)($8aeebeabcd3bbbcb$var$ResetPasswordForm);


var $fde1b0c5eccb6a06$export$2e2bcd8739ae039 = (0, $8aeebeabcd3bbbcb$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");








const $4fa4310c70723e8b$export$c316e7f3abbfa73a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  & button {
    min-height: 56px;
  }
`;
const $4fa4310c70723e8b$export$44f991de2746d2b2 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h1`
  display: flex;
  justify-content: center;
  text-align: center;
  font-size: 18px;
  color: ${({ theme: theme })=>theme.colors.brand};
  margin: 0 0 30px 0;
`;
const $4fa4310c70723e8b$export$44372e1cb49a874d = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h1`
  display: flex;
  justify-content: center;
  text-align: center;
  font-size: 18px;
  color: ${({ theme: theme })=>theme.colors.red};
  margin: 0 0 30px 0;
`;
const $4fa4310c70723e8b$export$bec0e3280b84c170 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).label`
  margin-bottom: 5px;
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $4fa4310c70723e8b$export$10e6aa1991a6e74a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  margin: 0px 0px 60px 0px;
`;
const $4fa4310c70723e8b$export$e151f1d86035b485 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  margin: 0px 0px 20px 0px;
  & input {
    background-color: ${({ theme: theme })=>theme.colors.background};
  }
  & label {
    background-color: ${({ theme: theme })=>theme.colors.backgroundLite};
    padding: 3px 10px;
  }
`;
const $4fa4310c70723e8b$export$c261c83b81138b10 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).a`
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: flex-end;

  margin: 0 0 -20px 0;
  font-size: 12px;
  font-weight: 500;
  color: ${({ theme: theme })=>theme.colors.primary};
`;



// Map Redux Props
const $501e172d11a1adf2$var$mapStateToProps = (state)=>state;
const $501e172d11a1adf2$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $501e172d11a1adf2$var$ResetPasswordConfirmForm(props) {
    // Destructure
    const { actions: actions } = props;
    // Store Actions
    const { showAlert: showAlert, showPersistentAlert: showPersistentAlert } = actions;
    const { auth_hash: auth_hash } = (0, $a0d5c3f2fe524011$export$99eaa27ddbbb95ef)();
    // Hooks
    const { resetPasswordConfirm: resetPasswordConfirm, resetPasswordConfirmData: resetPasswordConfirmData, resetPasswordConfirmError: resetPasswordConfirmError, isResetPasswordConfirmLoading: isResetPasswordConfirmLoading } = (0, $27afff305f9efdee$export$2e2bcd8739ae039)();
    const { getUserAuth: getUserAuth, getUserAuthData: getUserAuthData, getUserAuthError: getUserAuthError, isGetUserAuthLoading: isGetUserAuthLoading } = (0, $bba0636364ff0ea7$export$2e2bcd8739ae039)();
    // const [userCredentials, setUserCredentials] = useLocalStorage('userCredentials', {})
    // const [, setTheme] = useLocalStorage('theme', 'light')
    // const [TwoFactorAuthMsg, setTwoFactorAuthMsg] = useState()
    const [userData, setUserData] = (0, $tZqWC.useState)();
    // Variables
    const formRef = (0, $tZqWC.useRef)();
    const initialFormValues = {
        password: ''
    };
    const validationSchema = $84bdfb0f595586e8$export$185802fd694ee1f5().shape({
        password: $7092ea25693c72ef$export$185802fd694ee1f5().required('Password is required').min(8, 'Password must be at least 8 characters').matches(/[A-Z]/, 'Password must contain at least one uppercase letter').matches(/[a-z]/, 'Password must contain at least one lowercase letter').matches(/[0-9]/, 'Password must contain at least one number').matches(/[!@#$%^&*(),.?":{}|<>]/, 'Password must contain at least one special character')
    });
    // Functions
    const handleOnSubmit = (values)=>{
        resetPasswordConfirm({
            ...values,
            token: auth_hash
        });
    };
    const fetchUserAuth = ()=>{
        getUserAuth({
            hash: auth_hash
        });
    };
    (0, $tZqWC.useEffect)(()=>{
        if (resetPasswordConfirmError) {
            if (resetPasswordConfirmError?.response?.data?.context) showPersistentAlert({
                type: 'error',
                message: resetPasswordConfirmError?.response?.data?.context
            });
            else showPersistentAlert({
                type: 'error',
                message: 'An error occurred in resetting password'
            });
        }
    }, [
        resetPasswordConfirmError
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (resetPasswordConfirmData) showAlert({
            type: 'success',
            message: 'Successfully reset password, try logging in.'
        });
    }, [
        resetPasswordConfirmData
    ]);
    (0, $tZqWC.useEffect)(()=>{
        fetchUserAuth();
    }, []);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $4fa4310c70723e8b$export$c316e7f3abbfa73a), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $506ef65bbb4994b7$export$2e2bcd8739ae039), {
            formRef: formRef,
            initialValues: initialFormValues,
            validationSchema: validationSchema,
            onSubmit: handleOnSubmit,
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $4fa4310c70723e8b$export$10e6aa1991a6e74a), {
                    children: [
                        getUserAuthError && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $4fa4310c70723e8b$export$44372e1cb49a874d), {
                            children: "Link has expired."
                        }),
                        resetPasswordConfirmData && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $4fa4310c70723e8b$export$44f991de2746d2b2), {
                            children: "Successfully reset password, try logging in."
                        }),
                        !resetPasswordConfirmData && !isGetUserAuthLoading && !getUserAuthError && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $4fa4310c70723e8b$export$e151f1d86035b485), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                label: "New Password",
                                type: "password",
                                name: "password",
                                disabled: isResetPasswordConfirmLoading
                            })
                        })
                    ]
                }),
                !resetPasswordConfirmData && !getUserAuthError && !isGetUserAuthLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                    fullWidth: true,
                    type: "submit",
                    disabled: isResetPasswordConfirmLoading,
                    children: isResetPasswordConfirmLoading ? 'Saving password...' : 'Save Password'
                }),
                resetPasswordConfirmData && !resetPasswordConfirmError && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $4fa4310c70723e8b$export$c261c83b81138b10), {
                    href: "/login",
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                        fullWidth: true,
                        type: "button",
                        children: "Go to Login"
                    })
                })
            ]
        })
    });
}
// Default Props
$501e172d11a1adf2$var$ResetPasswordConfirmForm.defaultProps = {
    actions: {}
};
// Proptypes Validation
$501e172d11a1adf2$var$ResetPasswordConfirmForm.propTypes = {
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showPersistentAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $501e172d11a1adf2$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($501e172d11a1adf2$var$mapStateToProps, $501e172d11a1adf2$var$mapDispatchToProps)($501e172d11a1adf2$var$ResetPasswordConfirmForm);


var $464ed6b5b17fc61c$export$2e2bcd8739ae039 = (0, $501e172d11a1adf2$export$2e2bcd8739ae039);


/* eslint-disable no-nested-ternary */ 

var $tZqWC = parcelRequire("tZqWC");


var $4L3zM = parcelRequire("4L3zM");







const $b5213dda071fb478$export$ac7496df4f1f837a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $b5213dda071fb478$export$e151f1d86035b485 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;

  & > div > div {
    margin-bottom: 0 !important;
  }

  & > div {
    width: 100%;
  }
`;
const $b5213dda071fb478$export$8f1ff89fa1ec9605 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  align-items: start;
  grid-template-columns: repeat(auto-fill, minmax(500px, 1fr));
  gap: 0 20px;
`;
const $b5213dda071fb478$export$71c7816ee3a5a527 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h4`
  font-size: 15px;
  font-weight: 600;
  margin: 20px 0 0 10px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;



// Map Redux Props
const $22c2e72b779431a1$var$mapStateToProps = (state)=>state;
const $22c2e72b779431a1$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $22c2e72b779431a1$var$UserDetailsForm(props) {
    // Destructure
    const { values: values, viewMode: viewMode, formRef: formRef, actions: actions } = props;
    const { showAlert: showAlert } = actions;
    // Hooks
    const { requestEmailVerification: requestEmailVerification, isRequestEmailVerificationLoading: isRequestEmailVerificationLoading, isRequestEmailVerificationSuccess: isRequestEmailVerificationSuccess, isRequestEmailVerificationError: isRequestEmailVerificationError } = (0, $f418456b89a69838$export$2e2bcd8739ae039)();
    const [currentUser] = (0, $a9c50ebe96619b20$export$2e2bcd8739ae039)('userCredentials', {});
    // Internal State
    const [initialData, setInitialData] = (0, $tZqWC.useState)();
    const [csi] = (0, $tZqWC.useState)((0, $60e52eb6c2680325$export$96c4cef8dff1bd45)());
    // Variables
    const validationSchema = $84bdfb0f595586e8$export$185802fd694ee1f5().shape({
        name_first: $7092ea25693c72ef$export$185802fd694ee1f5(),
        name_last: $7092ea25693c72ef$export$185802fd694ee1f5(),
        email: $7092ea25693c72ef$export$185802fd694ee1f5().email(),
        phone: $7092ea25693c72ef$export$185802fd694ee1f5(),
        role: $7092ea25693c72ef$export$185802fd694ee1f5(),
        timezone: $7092ea25693c72ef$export$185802fd694ee1f5(),
        role_id: $add935e52327df44$export$185802fd694ee1f5().nullable(),
        is_active: $b84f09f6970af0be$export$185802fd694ee1f5(),
        is_verified: $b84f09f6970af0be$export$185802fd694ee1f5()
    });
    // UseEffects
    (0, $tZqWC.useEffect)(()=>{
        setInitialData(values);
    }, [
        values
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (!isRequestEmailVerificationLoading) {
            if (isRequestEmailVerificationSuccess) showAlert({
                type: 'success',
                message: 'A link was sent to your email'
            });
            else if (isRequestEmailVerificationError) showAlert({
                type: 'error',
                message: 'An error occurred, please try again later.'
            });
        }
    }, [
        isRequestEmailVerificationSuccess,
        isRequestEmailVerificationError
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b5213dda071fb478$export$ac7496df4f1f837a), {
        children: initialData && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $506ef65bbb4994b7$export$2e2bcd8739ae039), {
            formRef: formRef,
            initialValues: initialData,
            validationSchema: validationSchema,
            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $b5213dda071fb478$export$8f1ff89fa1ec9605), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b5213dda071fb478$export$e151f1d86035b485), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                            disabled: viewMode,
                            label: "First Name",
                            name: "name_first"
                        })
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b5213dda071fb478$export$e151f1d86035b485), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                            disabled: viewMode,
                            label: "Last Name",
                            name: "name_last"
                        })
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b5213dda071fb478$export$e151f1d86035b485), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $99b5eccf8ae49d07$export$2e2bcd8739ae039), {
                            disabled: viewMode || currentUser?.role_id !== 1,
                            label: "User Role",
                            options: (0, $f398806f8c37b1c3$export$43fbb932cb09c7d),
                            name: "role_id"
                        })
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $b5213dda071fb478$export$e151f1d86035b485), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                disabled: viewMode || csi !== 1,
                                label: initialData?.is_verified ? 'Email (Verified)' : 'Email (Unverified)',
                                type: "email",
                                name: "email"
                            }),
                            !initialData?.is_verified && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                onClick: ()=>requestEmailVerification(),
                                disabled: isRequestEmailVerificationLoading,
                                children: isRequestEmailVerificationLoading ? 'Loading...' : 'Verify'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b5213dda071fb478$export$e151f1d86035b485), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                            disabled: viewMode,
                            label: "Phone Number",
                            type: "tel",
                            name: "phone"
                        })
                    })
                ]
            })
        })
    });
}
// Default Props
$22c2e72b779431a1$var$UserDetailsForm.defaultProps = {
    formRef: {},
    form: {},
    actions: {},
    values: {},
    viewMode: true
};
// Proptypes Validation
$22c2e72b779431a1$var$UserDetailsForm.propTypes = {
    formRef: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        root: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    }),
    form: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        COUNTRIES_LIST: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Array),
        toBeUpdatedAccount: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setCountryListOptions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsEntityAccountDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setToBeUpdatedAccount: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    values: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        name_first: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        name_last: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        email: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        phone: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        role: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        timezone: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        is_active: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
        is_verified: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    viewMode: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
};
var $22c2e72b779431a1$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($22c2e72b779431a1$var$mapStateToProps, $22c2e72b779431a1$var$mapDispatchToProps)($22c2e72b779431a1$var$UserDetailsForm);


var $32fbb81f19fb7caa$export$2e2bcd8739ae039 = (0, $22c2e72b779431a1$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");


var $4L3zM = parcelRequire("4L3zM");








const $4c37a5dba5d33cfc$export$a7fed597f4b8afd8 = (0, $a778141486c79bc3$export$2e2bcd8739ae039)((0, $506ef65bbb4994b7$export$2e2bcd8739ae039))`
  background-color: ${({ theme: theme })=>theme.colors.background};
`;
const $4c37a5dba5d33cfc$export$ac7496df4f1f837a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  & button {
    min-height: 56px;
    margin: 20px 0px 0px 0px;
  }
`;
const $4c37a5dba5d33cfc$export$e151f1d86035b485 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  & input {
    background-color: ${({ theme: theme })=>theme.colors.background};
  }
  & label {
    background-color: ${({ theme: theme })=>theme.colors.backgroundLite};
    padding: 3px 10px;
  }
`;
const $4c37a5dba5d33cfc$export$a00c291d15f683bf = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  & > div > div > div {
    background-color: ${({ theme: theme })=>theme.colors.background};
    min-height: 58px;
  }
  & label {
    background-color: ${({ theme: theme })=>theme.colors.backgroundLite};
    padding: 3px 10px;
  }

  & > div > div :nth-child(1) {
    max-width: none;
  }
`;
const $4c37a5dba5d33cfc$export$8f1ff89fa1ec9605 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  max-height: 500px;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
  margin-top: 20px;
`;
const $4c37a5dba5d33cfc$export$8b649ad7cf2be885 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  &:first-child {
    position: ${({ page: page })=>page !== 1 && 'absolute'};
    height: ${({ page: page })=>page !== 1 && '50%'};
    transform: ${({ page: page })=>page !== 1 && 'translateX(-500px)'};
  }
  &:last-child {
    position: ${({ page: page })=>page !== 2 && 'absolute'};
    height: ${({ page: page })=>page !== 2 && '50%'};
    transform: ${({ page: page })=>page !== 2 && 'translateX(500px)'};
  }
  transition: 0.5s;
`;
const $4c37a5dba5d33cfc$export$71c7816ee3a5a527 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h2`
  font-size: 18px;
  font-weight: 600;
  text-align: center;
  color: ${({ theme: theme })=>theme.colors.primary};
  padding: 15px 20px;
  border-radius: 7px;
`;
const $4c37a5dba5d33cfc$export$942b2219c902021e = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h2`
  font-size: 18px;
  font-weight: 600;
  text-align: center;
  color: ${({ theme: theme })=>theme.colors.red};
  padding: 15px 20px;
  border-radius: 7px;
`;
const $4c37a5dba5d33cfc$export$d53c836cccbb0d90 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 20px;
  width: 100%;
`;
const $4c37a5dba5d33cfc$export$eddf54ea3db8d0f0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).a`
  margin: 0;
  padding: 0;
`;


// Map Redux Props
const $091d2f9df5139690$var$mapStateToProps = (state)=>state;
const $091d2f9df5139690$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $091d2f9df5139690$var$VaspSignupForm(props) {
    // Destructure
    const { actions: actions } = props;
    // Store Actions
    const { showAlert: showAlert } = actions;
    // Refs
    const formRef = (0, $tZqWC.useRef)();
    // Hooks
    const { registerVasp: registerVasp, registerVaspData: registerVaspData, registerVaspError: registerVaspError, isRegisterVaspSuccess: isRegisterVaspSuccess, isRegisterVaspLoading: isRegisterVaspLoading } = (0, $e8d6aa5db028d98b$export$2e2bcd8739ae039)();
    const { getUserAuth: getUserAuth, getUserAuthData: getUserAuthData, getUserAuthError: getUserAuthError, isGetUserAuthLoading: isGetUserAuthLoading } = (0, $bba0636364ff0ea7$export$2e2bcd8739ae039)();
    const { getGleif: getGleif, getGleifData: getGleifData } = (0, $e5f414d24a30f093$export$2e2bcd8739ae039)();
    const { token: token } = (0, $a0d5c3f2fe524011$export$99eaa27ddbbb95ef)();
    const timezoneZoneNames = (0, $tZqWC.useMemo)(()=>(0, $f398806f8c37b1c3$export$a1293b6f12329fc4).map(({ zoneName: zoneName })=>zoneName), []);
    const defaultTimezoneCode = (0, $tZqWC.useMemo)(()=>{
        let browserTimezone;
        if (typeof Intl !== 'undefined' && typeof Intl.DateTimeFormat === 'function') browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        if (browserTimezone && timezoneZoneNames.includes(browserTimezone)) return browserTimezone;
        if (timezoneZoneNames.includes('Europe/London')) return 'Europe/London';
        return timezoneZoneNames[0] || 'UTC';
    }, [
        timezoneZoneNames
    ]);
    const ensureValidTimezoneCode = (value)=>timezoneZoneNames.includes(value) ? value : defaultTimezoneCode;
    const [initialValues, setInitialValues] = (0, $tZqWC.useState)();
    const [page, setPage] = (0, $tZqWC.useState)(1);
    const [formError, setFormError] = (0, $tZqWC.useState)('');
    const [gleifCountryListOptions, setGleifCountryListOptions] = (0, $tZqWC.useState)();
    const [gleifList, setGleifList] = (0, $tZqWC.useState)();
    const [, forceUpdate] = (0, $tZqWC.useState)(0);
    // Variables
    const validationSchema = $84bdfb0f595586e8$export$185802fd694ee1f5().shape({
        name_legal: $7092ea25693c72ef$export$185802fd694ee1f5().required('Legal Name is required'),
        national_id: $7092ea25693c72ef$export$185802fd694ee1f5().required('Business ID is required'),
        national_id_issue_country: $7092ea25693c72ef$export$185802fd694ee1f5().required('Registration Country is required'),
        national_id_registration_authority: $7092ea25693c72ef$export$185802fd694ee1f5().required('Registration Authority is required'),
        website: $7092ea25693c72ef$export$185802fd694ee1f5().required('Website is required'),
        address_line: $7092ea25693c72ef$export$185802fd694ee1f5().required('Address Line is required'),
        email_contact: $7092ea25693c72ef$export$185802fd694ee1f5().email().required('Email is required'),
        password: $7092ea25693c72ef$export$185802fd694ee1f5().required('Password is required').min(8, 'Password must be at least 8 characters').matches(/[A-Z]/, 'Password must contain at least one uppercase letter').matches(/[a-z]/, 'Password must contain at least one lowercase letter').matches(/[0-9]/, 'Password must contain at least one number').matches(/[!@#$%^&*(),.?":{}|<>]/, 'Password must contain at least one special character'),
        confirm_password: $7092ea25693c72ef$export$185802fd694ee1f5().when('password', {
            is: (val)=>!!(val && val.length > 0),
            then: $7092ea25693c72ef$export$185802fd694ee1f5().oneOf([
                $2af0df923a102911$export$185802fd694ee1f5('password')
            ], 'Both password need to be the same')
        }),
        name_first: $7092ea25693c72ef$export$185802fd694ee1f5().required('First Name is required'),
        name_last: $7092ea25693c72ef$export$185802fd694ee1f5().required('Last Name is required'),
        timezone_code: $7092ea25693c72ef$export$185802fd694ee1f5().required('Timezone is required'),
        token: $7092ea25693c72ef$export$185802fd694ee1f5()
    });
    // Functions
    const handleOnSubmit = (values)=>{
        const timezoneCode = ensureValidTimezoneCode(values?.timezone_code);
        registerVasp({
            token: token,
            user: {
                email: values?.email_contact,
                password: values?.password,
                phone: values?.phone,
                name_first: values?.name_first,
                name_last: values?.name_last,
                timezone_code: timezoneCode
            },
            vasp: {
                email_contact: values?.email_contact,
                name_business: values?.name_business,
                name_legal: values?.name_legal,
                national_id: values?.national_id,
                national_id_issue_country: values?.national_id_issue_country,
                national_id_registration_authority: values?.national_id_registration_authority,
                website: values?.website,
                address_line: values?.address_line
            }
        });
    };
    const handleUserAuthData = ()=>{
        setInitialValues({
            email_contact: getUserAuthData?.email,
            password: '',
            phone: '',
            name_first: '',
            name_last: '',
            timezone_code: ensureValidTimezoneCode(getUserAuthData?.timezone_code),
            token: token,
            name_business: '',
            name_legal: '',
            website: '',
            address_street: '',
            address_city: '',
            address_region: '',
            address_postcode: '',
            address_country_code: ''
        });
    };
    const handleNext = async ()=>{
        const validationSchema = $84bdfb0f595586e8$export$185802fd694ee1f5().shape({
            name_legal: $7092ea25693c72ef$export$185802fd694ee1f5().required('Legal Name is required'),
            national_id: $7092ea25693c72ef$export$185802fd694ee1f5().required('Business ID is required'),
            national_id_issue_country: $7092ea25693c72ef$export$185802fd694ee1f5().required('Registration Country is required'),
            national_id_registration_authority: $7092ea25693c72ef$export$185802fd694ee1f5().required('Registration Authority is required'),
            website: $7092ea25693c72ef$export$185802fd694ee1f5().required('Website is required'),
            address_line: $7092ea25693c72ef$export$185802fd694ee1f5().required('Address Line is required')
        });
        const res = formRef.current.values;
        validationSchema.validate(res, {
            abortEarly: false
        }).then(()=>{
            setPage(2);
            setFormError('');
        }).catch(()=>{
            setFormError('Error: Missing or invalid fields');
        });
    };
    const handleGleifData = (data)=>{
        const countryList = [];
        const tempGleifList = {};
        if (data && data?.length > 0) data?.forEach((item)=>{
            if (item?.country_code) {
                if (tempGleifList[item?.country_code]) tempGleifList[item?.country_code] = [
                    ...tempGleifList[item?.country_code],
                    item
                ];
                else tempGleifList[item?.country_code] = [
                    item
                ];
            }
        });
        Object.keys(tempGleifList).forEach((key)=>{
            countryList.push({
                value: tempGleifList[key]?.[0]?.country_code,
                label: tempGleifList[key]?.[0]?.country
            });
        });
        setGleifCountryListOptions(countryList);
        setGleifList(tempGleifList);
    };
    // UseEffects
    (0, $tZqWC.useEffect)(()=>{
        if (registerVaspError) {
            if (registerVaspError?.response?.status < 500) showAlert({
                type: 'error',
                message: registerVaspError?.response?.data?.context
            });
            else showAlert({
                type: 'error',
                message: 'An error occurred in registering'
            });
        }
    }, [
        registerVaspError
    ]);
    (0, $tZqWC.useEffect)(()=>{
        getUserAuth({
            hash: token
        });
        getGleif();
    }, []);
    (0, $tZqWC.useEffect)(()=>{
        if (getUserAuthData) handleUserAuthData();
    }, [
        getUserAuthData
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (getGleifData) handleGleifData(getGleifData);
    }, [
        getGleifData
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $4c37a5dba5d33cfc$export$ac7496df4f1f837a), {
        children: [
            getUserAuthError && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $4c37a5dba5d33cfc$export$942b2219c902021e), {
                children: "Link has expired."
            }),
            isRegisterVaspSuccess && !registerVaspError && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $4c37a5dba5d33cfc$export$71c7816ee3a5a527), {
                        children: "Thank you for signing up! The Ospree team will verify your registration. We will get back to you as soon as possible."
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $4c37a5dba5d33cfc$export$eddf54ea3db8d0f0), {
                        href: "/login",
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                            fullWidth: true,
                            children: "Go Back"
                        })
                    })
                ]
            }),
            registerVaspData && registerVaspError && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $4c37a5dba5d33cfc$export$942b2219c902021e), {
                children: "An error occurred in signing up."
            }),
            isGetUserAuthLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a6fa6c8d0625529f$export$2e2bcd8739ae039), {}),
            !isGetUserAuthLoading && !isRegisterVaspSuccess && !getUserAuthError && initialValues && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $4c37a5dba5d33cfc$export$a7fed597f4b8afd8), {
                initialValues: initialValues,
                formRef: formRef,
                validationSchema: validationSchema,
                onSubmit: handleOnSubmit,
                children: [
                    !registerVaspData && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $4c37a5dba5d33cfc$export$71c7816ee3a5a527), {
                        children: "Sign up to Ospree"
                    }),
                    formError && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $4c37a5dba5d33cfc$export$942b2219c902021e), {
                        children: formError
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ef69c736ae57a14f$export$2e2bcd8739ae039), {
                        pageNumber: page,
                        headers: [
                            {
                                label: 'VASP Details'
                            },
                            {
                                label: 'User Credentials'
                            }
                        ]
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $4c37a5dba5d33cfc$export$8f1ff89fa1ec9605), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $4c37a5dba5d33cfc$export$8b649ad7cf2be885), {
                                page: page,
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $4c37a5dba5d33cfc$export$e151f1d86035b485), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                            label: "Legal Name *",
                                            name: "name_legal"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $4c37a5dba5d33cfc$export$e151f1d86035b485), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                            label: "Business ID *",
                                            name: "national_id"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $4c37a5dba5d33cfc$export$e151f1d86035b485), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6e833112b656c531$export$2e2bcd8739ae039), {
                                            label: "Registration Country *",
                                            name: "national_id_issue_country",
                                            options: gleifCountryListOptions
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $4c37a5dba5d33cfc$export$e151f1d86035b485), {
                                        onClick: forceUpdate,
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6e833112b656c531$export$2e2bcd8739ae039), {
                                            label: "Registration Authority *",
                                            name: "national_id_registration_authority",
                                            options: gleifList?.[formRef?.current?.values?.national_id_issue_country]?.map((item)=>({
                                                    label: item?.display_name,
                                                    value: item?.registration_authority_code
                                                }))
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $4c37a5dba5d33cfc$export$e151f1d86035b485), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                            label: "Website *",
                                            name: "website"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $4c37a5dba5d33cfc$export$e151f1d86035b485), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                            label: "Address Line *",
                                            name: "address_line"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $4c37a5dba5d33cfc$export$8b649ad7cf2be885), {
                                page: page,
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $4c37a5dba5d33cfc$export$e151f1d86035b485), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                            label: "Email *",
                                            type: "email",
                                            name: "email_contact",
                                            disabled: true
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $4c37a5dba5d33cfc$export$e151f1d86035b485), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                            label: "First Name *",
                                            name: "name_first"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $4c37a5dba5d33cfc$export$e151f1d86035b485), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                            label: "Last Name *",
                                            name: "name_last"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $4c37a5dba5d33cfc$export$e151f1d86035b485), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                            label: "Password *",
                                            type: "password",
                                            name: "password"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $4c37a5dba5d33cfc$export$e151f1d86035b485), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                            label: "Confirm Password *",
                                            type: "password",
                                            name: "confirm_password"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    page === 1 && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                        fullWidth: true,
                        onClick: handleNext,
                        children: "Next"
                    }),
                    page === 2 && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $4c37a5dba5d33cfc$export$d53c836cccbb0d90), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                fullWidth: true,
                                disabled: isRegisterVaspLoading,
                                onClick: ()=>setPage(1),
                                variant: "outlined",
                                children: "Back"
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                fullWidth: true,
                                type: "submit",
                                disabled: isRegisterVaspLoading,
                                children: isRegisterVaspLoading ? 'Submitting...' : 'Signup'
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
// Default Props
$091d2f9df5139690$var$VaspSignupForm.defaultProps = {
    formRef: {},
    form: {},
    actions: {},
    values: {
        external_id: '',
        email: '',
        name_first: '',
        name_last: '',
        incorporation_country: '',
        inc_date: '',
        primary_activity_id: 0,
        created: '',
        last_modified: '',
        address_street: '',
        address_city: '',
        address_region: '',
        address_postcode: '',
        timezone_code: ''
    }
};
// Proptypes Validation
$091d2f9df5139690$var$VaspSignupForm.propTypes = {
    formRef: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        root: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    }),
    form: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        TIMEZONES: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Array),
        toBeUpdatedAccount: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setCountryListOptions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsEntityAccountDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setToBeUpdatedAccount: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    values: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        external_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        email: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        name_first: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        name_last: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        incorporation_country: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        inc_date: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        primary_activity_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        created: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        last_modified: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        address_street: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        address_city: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        address_region: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        address_postcode: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        timezone_code: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    })
};
var $091d2f9df5139690$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($091d2f9df5139690$var$mapStateToProps, $091d2f9df5139690$var$mapDispatchToProps)($091d2f9df5139690$var$VaspSignupForm);


var $c59efdfa8ed48def$export$2e2bcd8739ae039 = (0, $091d2f9df5139690$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");


var $4L3zM = parcelRequire("4L3zM");





const $4f64e6de73dd1024$export$ac7496df4f1f837a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  & button {
    min-height: 56px;
    margin: 20px 0px 0px 0px;
  }
`;
const $4f64e6de73dd1024$export$e151f1d86035b485 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  & input {
    background-color: ${({ theme: theme })=>theme.colors.background};
  }
  & label {
    background-color: ${({ theme: theme })=>theme.colors.backgroundLite};
    padding: 3px 10px;
  }
`;
const $4f64e6de73dd1024$export$a00c291d15f683bf = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  & > div > div > div {
    background-color: ${({ theme: theme })=>theme.colors.background};
    min-height: 58px;
  }
  & label {
    background-color: ${({ theme: theme })=>theme.colors.backgroundLite};
    padding: 3px 10px;
  }

  & > div > div :nth-child(1) {
    max-width: none;
  }
`;
const $4f64e6de73dd1024$export$8f1ff89fa1ec9605 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  gap: 15px;
  margin-bottom: 40px;
`;
const $4f64e6de73dd1024$export$71c7816ee3a5a527 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h4`
  font-size: 15px;
  font-weight: 600;
  margin: 20px 0 0 10px;
  text-align: center;
  color: ${({ theme: theme })=>theme.colors.primary};
  background-color: ${({ theme: theme })=>theme.colors.background};
  padding: 15px 20px;
  border-radius: 7px;
`;
const $4f64e6de73dd1024$export$b065fd053267ec81 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h4`
  font-size: 15px;
  font-weight: 600;
  margin: 20px 0 0 10px;
  text-align: center;
  color: ${({ theme: theme })=>theme.colors.red};
  background-color: ${({ theme: theme })=>theme.colors.background};
  padding: 15px 20px;
  border-radius: 7px;
`;
const $4f64e6de73dd1024$export$d53c836cccbb0d90 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).a``;



// Map Redux Props
const $8426792d6ce4fd1c$var$mapStateToProps = (state)=>state;
const $8426792d6ce4fd1c$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $8426792d6ce4fd1c$var$UserSignupForm(props) {
    // Destructure
    const { actions: actions } = props;
    // Store Actions
    const { showAlert: showAlert } = actions;
    // Hooks
    const { activateUser: activateUser, activateUserData: activateUserData, activateUserError: activateUserError, isActivateUserLoading: isActivateUserLoading } = (0, $ddeab5e5a8dbefdf$export$2e2bcd8739ae039)();
    const { getActivationLink: getActivationLink, getActivationLinkData: getActivationLinkData, getActivationLinkError: getActivationLinkError, isGetActivationLinkLoading: isGetActivationLinkLoading } = (0, $1a57e7fc5478509b$export$2e2bcd8739ae039)();
    const { auth_hash: auth_hash } = (0, $a0d5c3f2fe524011$export$99eaa27ddbbb95ef)();
    // const token = jwt(jwttoken)
    // Ref
    const formRef = (0, $tZqWC.useRef)();
    // Local State
    const [formValues, setFormValues] = (0, $tZqWC.useState)({
        email: '',
        password: '',
        confirm_password: ''
    });
    // Variables
    const validationSchema = $84bdfb0f595586e8$export$185802fd694ee1f5().shape({
        email: $7092ea25693c72ef$export$185802fd694ee1f5().email().required('Email is required'),
        password: $7092ea25693c72ef$export$185802fd694ee1f5().required('Password is required').min(8, 'Password must be at least 8 characters').matches(/[A-Z]/, 'Password must contain at least one uppercase letter').matches(/[a-z]/, 'Password must contain at least one lowercase letter').matches(/[0-9]/, 'Password must contain at least one number').matches(/[!@#$%^&*(),.?":{}|<>]/, 'Password must contain at least one special character'),
        confirm_password: $7092ea25693c72ef$export$185802fd694ee1f5().when('password', {
            is: (val)=>!!(val && val.length > 0),
            then: $7092ea25693c72ef$export$185802fd694ee1f5().oneOf([
                $2af0df923a102911$export$185802fd694ee1f5('password')
            ], 'Both password need to be the same')
        })
    });
    // Functions
    const handleOnSubmit = (values)=>{
        if (values?.password) activateUser({
            auth_hash: auth_hash,
            password: values?.password
        });
    };
    // UseEffects
    (0, $tZqWC.useEffect)(()=>{
        if (activateUserError) showAlert({
            type: 'error',
            message: 'An error occurred in registering'
        });
    }, [
        activateUserError
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (auth_hash) getActivationLink({
            auth_hash: auth_hash
        });
    }, [
        auth_hash
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (getActivationLinkData && getActivationLinkData?.email) setFormValues((prevValues)=>({
                ...prevValues,
                email: getActivationLinkData.email
            }));
    }, [
        getActivationLinkData
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $4f64e6de73dd1024$export$ac7496df4f1f837a), {
        children: [
            activateUserData && !activateUserError && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $4f64e6de73dd1024$export$71c7816ee3a5a527), {
                children: "Successfully activated account, you may now login."
            }),
            !isGetActivationLinkLoading && getActivationLinkError && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $4f64e6de73dd1024$export$b065fd053267ec81), {
                children: "Activation link is invalid or expired"
            }),
            activateUserData && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $4f64e6de73dd1024$export$d53c836cccbb0d90), {
                href: "/login",
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                    fullWidth: true,
                    children: "Go to Login"
                })
            }),
            isGetActivationLinkLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a6fa6c8d0625529f$export$2e2bcd8739ae039), {}),
            !activateUserData && formValues?.email && !isGetActivationLinkLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $506ef65bbb4994b7$export$2e2bcd8739ae039), {
                initialValues: formValues,
                formRef: formRef,
                validationSchema: validationSchema,
                onSubmit: handleOnSubmit,
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $4f64e6de73dd1024$export$8f1ff89fa1ec9605), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $4f64e6de73dd1024$export$e151f1d86035b485), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                    label: "Email",
                                    type: "email",
                                    name: "email",
                                    disabled: true
                                })
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $4f64e6de73dd1024$export$e151f1d86035b485), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                    label: "Password",
                                    type: "password",
                                    name: "password"
                                })
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $4f64e6de73dd1024$export$e151f1d86035b485), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                    label: "Confirm Password",
                                    type: "password",
                                    name: "confirm_password"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                        fullWidth: true,
                        type: "submit",
                        disabled: isActivateUserLoading,
                        children: isActivateUserLoading ? 'Activating...' : 'Signup'
                    })
                ]
            })
        ]
    });
}
// Default Props
$8426792d6ce4fd1c$var$UserSignupForm.defaultProps = {
    formRef: {},
    form: {},
    actions: {}
};
// Proptypes Validation
$8426792d6ce4fd1c$var$UserSignupForm.propTypes = {
    formRef: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        root: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    }),
    form: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        TIMEZONES: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Array),
        toBeUpdatedAccount: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setCountryListOptions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsEntityAccountDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setToBeUpdatedAccount: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $8426792d6ce4fd1c$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($8426792d6ce4fd1c$var$mapStateToProps, $8426792d6ce4fd1c$var$mapDispatchToProps)($8426792d6ce4fd1c$var$UserSignupForm);


var $db40a2c7abdc997f$export$2e2bcd8739ae039 = (0, $8426792d6ce4fd1c$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");


var $4L3zM = parcelRequire("4L3zM");

const $1e3a524226c6c631$export$8102ef712e262dd0 = [
    'gmail.com',
    'outlook.com',
    'yahoo.com',
    'protonmail.com',
    'zoho.com',
    'aol.com',
    'gmx.com',
    'mail.com',
    'notabene.id',
    'sumsub.com',
    '21analytics.ch'
];






const $3e0bca75668afbee$export$ac7496df4f1f837a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  & button {
    min-height: 56px;
    margin: 20px 0px 0px 0px;
  }
`;
const $3e0bca75668afbee$export$e151f1d86035b485 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  & input {
    background-color: ${({ theme: theme })=>theme.colors.background};
  }
  & label {
    background-color: ${({ theme: theme })=>theme.colors.backgroundLite};
    padding: 3px 10px;
  }
`;
const $3e0bca75668afbee$export$a00c291d15f683bf = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  & > div > div > div {
    background-color: ${({ theme: theme })=>theme.colors.background};
    min-height: 58px;
  }
  & label {
    background-color: ${({ theme: theme })=>theme.colors.backgroundLite};
    padding: 3px 10px;
  }

  & > div > div :nth-child(1) {
    max-width: none;
  }
`;
const $3e0bca75668afbee$export$8f1ff89fa1ec9605 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
`;
const $3e0bca75668afbee$export$71c7816ee3a5a527 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h2`
  font-size: 18px;
  font-weight: 600;
  margin: 10px 0 0 0;
  text-align: center;
  color: ${({ theme: theme })=>theme.colors.primary};
  padding: 15px 20px;
  border-radius: 7px;
`;
const $3e0bca75668afbee$export$f25e790a6345b4c7 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h2`
  font-size: 18px;
  font-weight: 700;
  margin: 10px 0;
  text-align: center;
  color: ${({ theme: theme })=>theme.colors.brand};
`;
const $3e0bca75668afbee$export$ab5c3400dd78d1c7 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  font-size: 14px;
  font-weight: 400;
  margin: 0 0 40px 0;
  text-align: center;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $3e0bca75668afbee$export$942b2219c902021e = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h2`
  font-size: 18px;
  font-weight: 600;
  margin: 10px 0 0 0;
  text-align: center;
  color: ${({ theme: theme })=>theme.colors.red};
  padding: 15px 20px;
  border-radius: 7px;
`;
const $3e0bca75668afbee$export$eddf54ea3db8d0f0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).a`
  margin: 0;
  padding: 0;
`;


// Map Redux Props
const $8e50f2b50597239a$var$mapStateToProps = (state)=>state;
const $8e50f2b50597239a$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $8e50f2b50597239a$var$TrialSignupForm(props) {
    // Destructure
    const { formRef: formRef, actions: actions } = props;
    // Store Actions
    const { showAlert: showAlert } = actions;
    // Hooks
    const { signupTrial: signupTrial, signupTrialData: signupTrialData, signupTrialError: signupTrialError, isSignupTrialLoading: isSignupTrialLoading } = (0, $1750dcd47d6b0418$export$2e2bcd8739ae039)();
    const [initialValues] = (0, $tZqWC.useState)({
        email: '',
        password: '',
        name_first: '',
        name_last: ''
    });
    // Variables
    const validationSchema = $84bdfb0f595586e8$export$185802fd694ee1f5().shape({
        email: $7092ea25693c72ef$export$185802fd694ee1f5().email().required('Email is required').test('restricted-domain', 'Email domain is not allowed', (value)=>{
            if (!value) return true;
            const domain = value.split('@')[1];
            return !(0, $1e3a524226c6c631$export$8102ef712e262dd0).includes(domain);
        }),
        password: $7092ea25693c72ef$export$185802fd694ee1f5().required('Password is required').min(8, 'Password must be at least 8 characters').matches(/[A-Z]/, 'Password must contain at least one uppercase letter').matches(/[a-z]/, 'Password must contain at least one lowercase letter').matches(/[0-9]/, 'Password must contain at least one number').matches(/[!@#$%^&*(),.?":{}|<>]/, 'Password must contain at least one special character'),
        confirm_password: $7092ea25693c72ef$export$185802fd694ee1f5().when('password', {
            is: (val)=>!!(val && val.length > 0),
            then: $7092ea25693c72ef$export$185802fd694ee1f5().oneOf([
                $2af0df923a102911$export$185802fd694ee1f5('password')
            ], 'Both password need to be the same')
        }),
        name_first: $7092ea25693c72ef$export$185802fd694ee1f5().required('First Name is required'),
        name_last: $7092ea25693c72ef$export$185802fd694ee1f5().required('Last Name is required')
    });
    // Functions
    const handleOnSubmit = (values)=>{
        signupTrial(values);
    };
    // UseEffects
    (0, $tZqWC.useEffect)(()=>{
        if (signupTrialError?.response?.data?.message) {
            showAlert({
                type: 'error',
                message: `Error: ${signupTrialError?.response?.data?.message}`
            });
            return;
        }
        if (signupTrialError) showAlert({
            type: 'error',
            message: 'An error occured in signing up.'
        });
    }, [
        signupTrialError
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3e0bca75668afbee$export$ac7496df4f1f837a), {
        children: [
            !signupTrialData && !signupTrialError && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3e0bca75668afbee$export$71c7816ee3a5a527), {
                children: "Sign up For a Trial Account"
            }),
            signupTrialData && !signupTrialError && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3e0bca75668afbee$export$f25e790a6345b4c7), {
                        children: "A link was sent to your email!"
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3e0bca75668afbee$export$ab5c3400dd78d1c7), {
                        children: "Verify your business email in order to access Ospree"
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3e0bca75668afbee$export$eddf54ea3db8d0f0), {
                        href: "/login",
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                            fullWidth: true,
                            variant: "outlined",
                            children: "Go back"
                        })
                    })
                ]
            }),
            signupTrialError && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3e0bca75668afbee$export$942b2219c902021e), {
                children: signupTrialError?.response?.data?.message ? signupTrialError?.response?.data?.message : 'An error occurred in signing up.'
            }),
            !signupTrialData && initialValues && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $506ef65bbb4994b7$export$2e2bcd8739ae039), {
                initialValues: initialValues,
                formRef: formRef,
                validationSchema: validationSchema,
                onSubmit: handleOnSubmit,
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3e0bca75668afbee$export$8f1ff89fa1ec9605), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3e0bca75668afbee$export$e151f1d86035b485), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                    label: "Business Email",
                                    type: "email",
                                    name: "email",
                                    disabled: isSignupTrialLoading
                                })
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3e0bca75668afbee$export$e151f1d86035b485), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                    label: "First Name",
                                    name: "name_first",
                                    disabled: isSignupTrialLoading
                                })
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3e0bca75668afbee$export$e151f1d86035b485), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                    label: "Last Name",
                                    name: "name_last",
                                    disabled: isSignupTrialLoading
                                })
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3e0bca75668afbee$export$e151f1d86035b485), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                    label: "Password",
                                    type: "password",
                                    name: "password",
                                    disabled: isSignupTrialLoading
                                })
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3e0bca75668afbee$export$e151f1d86035b485), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                    label: "Confirm Password",
                                    type: "password",
                                    name: "confirm_password",
                                    disabled: isSignupTrialLoading
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                        fullWidth: true,
                        type: "submit",
                        disabled: isSignupTrialLoading,
                        children: isSignupTrialLoading ? 'Submitting...' : 'Signup'
                    })
                ]
            })
        ]
    });
}
// Default Props
$8e50f2b50597239a$var$TrialSignupForm.defaultProps = {
    formRef: {},
    form: {},
    actions: {},
    values: {
        external_id: '',
        email: '',
        name_first: '',
        name_last: '',
        incorporation_country: '',
        inc_date: '',
        primary_activity_id: 0,
        created: '',
        last_modified: '',
        address_street: '',
        address_city: '',
        address_region: '',
        address_postcode: '',
        timezone_code: ''
    }
};
// Proptypes Validation
$8e50f2b50597239a$var$TrialSignupForm.propTypes = {
    formRef: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        root: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    }),
    form: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        TIMEZONES: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Array),
        toBeUpdatedAccount: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setCountryListOptions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsEntityAccountDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setToBeUpdatedAccount: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    values: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        external_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        email: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        name_first: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        name_last: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        incorporation_country: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        inc_date: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        primary_activity_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        created: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        last_modified: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        address_street: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        address_city: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        address_region: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        address_postcode: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        timezone_code: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    })
};
var $8e50f2b50597239a$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($8e50f2b50597239a$var$mapStateToProps, $8e50f2b50597239a$var$mapDispatchToProps)($8e50f2b50597239a$var$TrialSignupForm);


var $84d0ea2e58939b9d$export$2e2bcd8739ae039 = (0, $8e50f2b50597239a$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");


var $4L3zM = parcelRequire("4L3zM");




const $2b6bd739fac69495$export$ac7496df4f1f837a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  & button {
    min-height: 56px;
    margin: 20px 0px 0px 0px;
  }
`;
const $2b6bd739fac69495$export$e151f1d86035b485 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  & input {
    background-color: ${({ theme: theme })=>theme.colors.background};
  }
  & label {
    background-color: ${({ theme: theme })=>theme.colors.backgroundLite};
    padding: 3px 10px;
  }
`;
const $2b6bd739fac69495$export$a00c291d15f683bf = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  & > div > div > div {
    background-color: ${({ theme: theme })=>theme.colors.background};
    min-height: 58px;
  }
  & label {
    background-color: ${({ theme: theme })=>theme.colors.backgroundLite};
    padding: 3px 10px;
  }

  & > div > div :nth-child(1) {
    max-width: none;
  }
`;
const $2b6bd739fac69495$export$8f1ff89fa1ec9605 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  gap: 15px;
  margin-bottom: 40px;
`;
const $2b6bd739fac69495$export$71c7816ee3a5a527 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h4`
  font-size: 15px;
  font-weight: 600;
  margin: 20px 0 0 10px;
  text-align: center;
  color: ${({ theme: theme })=>theme.colors.primary};
  background-color: ${({ theme: theme })=>theme.colors.background};
  padding: 15px 20px;
  border-radius: 7px;
`;
const $2b6bd739fac69495$export$b065fd053267ec81 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h4`
  font-size: 15px;
  font-weight: 600;
  margin: 20px 0 0 10px;
  text-align: center;
  color: ${({ theme: theme })=>theme.colors.red};
  background-color: ${({ theme: theme })=>theme.colors.background};
  padding: 15px 20px;
  border-radius: 7px;
`;
const $2b6bd739fac69495$export$d53c836cccbb0d90 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).a``;



// Map Redux Props
const $e82627c4b6bde422$var$mapStateToProps = (state)=>state;
const $e82627c4b6bde422$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $e82627c4b6bde422$var$UpdatePasswordForm(props) {
    // Destructure
    const { actions: actions } = props;
    // Store Actions
    const { showAlert: showAlert } = actions;
    // Hooks
    const { updatePassword: updatePassword, updatePasswordData: updatePasswordData, updatePasswordError: updatePasswordError, isUpdatePasswordLoading: isUpdatePasswordLoading } = (0, $a936c5d5952f6da8$export$2e2bcd8739ae039)();
    // Ref
    const formRef = (0, $tZqWC.useRef)();
    // Local State
    const [formValues] = (0, $tZqWC.useState)({
        old_password: '',
        new_password: '',
        confirm_password: ''
    });
    // Variables
    const validationSchema = $84bdfb0f595586e8$export$185802fd694ee1f5().shape({
        old_password: $7092ea25693c72ef$export$185802fd694ee1f5().required('Old Password is required'),
        new_password: $7092ea25693c72ef$export$185802fd694ee1f5().required('Password is required').min(8, 'Password must be at least 8 characters').matches(/[A-Z]/, 'Password must contain at least one uppercase letter').matches(/[a-z]/, 'Password must contain at least one lowercase letter').matches(/[0-9]/, 'Password must contain at least one number').matches(/[!@#$%^&*(),.?":{}|<>]/, 'Password must contain at least one special character'),
        confirm_password: $7092ea25693c72ef$export$185802fd694ee1f5().when('new_password', {
            is: (val)=>!!(val && val.length > 0),
            then: $7092ea25693c72ef$export$185802fd694ee1f5().oneOf([
                $2af0df923a102911$export$185802fd694ee1f5('new_password')
            ], 'Both password need to be the same')
        })
    });
    // Functions
    const handleOnSubmit = (values)=>{
        if (values?.old_password) updatePassword({
            old_password: values?.old_password,
            new_password: values?.new_password
        });
    };
    // UseEffects
    (0, $tZqWC.useEffect)(()=>{
        if (updatePasswordError) showAlert({
            type: 'error',
            message: 'An error occurred in updating password'
        });
    }, [
        updatePasswordError
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $2b6bd739fac69495$export$ac7496df4f1f837a), {
        children: [
            updatePasswordData && !updatePasswordError && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2b6bd739fac69495$export$71c7816ee3a5a527), {
                children: "Successfully updated password."
            }),
            updatePasswordData && !updatePasswordError && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2b6bd739fac69495$export$d53c836cccbb0d90), {
                href: "/",
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                    fullWidth: true,
                    type: "button",
                    children: "Go back"
                })
            }),
            isUpdatePasswordLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a6fa6c8d0625529f$export$2e2bcd8739ae039), {}),
            !updatePasswordData && !isUpdatePasswordLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $506ef65bbb4994b7$export$2e2bcd8739ae039), {
                initialValues: formValues,
                formRef: formRef,
                validationSchema: validationSchema,
                onSubmit: handleOnSubmit,
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $2b6bd739fac69495$export$8f1ff89fa1ec9605), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2b6bd739fac69495$export$e151f1d86035b485), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                    label: "Old Password",
                                    type: "password",
                                    name: "old_password"
                                })
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2b6bd739fac69495$export$e151f1d86035b485), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                    label: "New Password",
                                    type: "password",
                                    name: "new_password"
                                })
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2b6bd739fac69495$export$e151f1d86035b485), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                    label: "Confirm Password",
                                    type: "password",
                                    name: "confirm_password"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                        fullWidth: true,
                        type: "submit",
                        disabled: isUpdatePasswordLoading,
                        children: isUpdatePasswordLoading ? 'Updating...' : 'Update'
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2b6bd739fac69495$export$d53c836cccbb0d90), {
                        href: "/",
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                            fullWidth: true,
                            variant: "outlined",
                            type: "button",
                            children: "Go back"
                        })
                    })
                ]
            })
        ]
    });
}
// Default Props
$e82627c4b6bde422$var$UpdatePasswordForm.defaultProps = {
    formRef: {},
    form: {},
    actions: {}
};
// Proptypes Validation
$e82627c4b6bde422$var$UpdatePasswordForm.propTypes = {
    formRef: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        root: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    }),
    form: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        TIMEZONES: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Array),
        toBeUpdatedAccount: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setCountryListOptions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsEntityAccountDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setToBeUpdatedAccount: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $e82627c4b6bde422$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($e82627c4b6bde422$var$mapStateToProps, $e82627c4b6bde422$var$mapDispatchToProps)($e82627c4b6bde422$var$UpdatePasswordForm);


var $d8c7888e21f80618$export$2e2bcd8739ae039 = (0, $e82627c4b6bde422$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");


var $4L3zM = parcelRequire("4L3zM");


var $ejSM7 = parcelRequire("ejSM7");




const $907cb73d9dab9fec$export$ac7496df4f1f837a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 100%;

  & form {
    height: 100%;
  }
`;
const $907cb73d9dab9fec$export$f06621d9ad29af97 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;

  width: 100%;
  height: 100%;
  padding: 0 0 20px 0;
`;
const $907cb73d9dab9fec$export$e151f1d86035b485 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $907cb73d9dab9fec$export$71c7816ee3a5a527 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h1`
  margin: 0;
  font-size: 20px;
  font-weight: 500;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $907cb73d9dab9fec$export$f4d831db7f57f05 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  text-align: center;
  color: ${({ theme: theme })=>theme.colors.brand};
`;
const $907cb73d9dab9fec$export$942b2219c902021e = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  text-align: center;
  color: ${({ theme: theme })=>theme.colors.red};
`;
const $907cb73d9dab9fec$export$ae4fd97bdbe491c1 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  text-align: center;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $907cb73d9dab9fec$export$97ee2cbf37e5ebfe = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 0 20px 0;
`;
const $907cb73d9dab9fec$export$e7277fd05612133d = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  padding: 20px 0 0 0;
  gap: 20px;
`;
const $907cb73d9dab9fec$export$fd2299f554be8993 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: 1fr 25px;
  gap: 50px;
  align-items: center;

  padding: 10px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $907cb73d9dab9fec$export$9f515a68dfaeb9ef = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  gap: 20px;
`;
const $907cb73d9dab9fec$export$85524e8d4e82fc69 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;


// Map Redux Props
const $276b34298da608dd$var$mapStateToProps = (state)=>state;
const $276b34298da608dd$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $276b34298da608dd$var$CreateApiKeyForm(props) {
    // Destructure
    const { setResponse: setResponse } = props;
    // Hooks
    const { generateIntegrationToken: generateIntegrationToken, generateIntegrationTokenData: generateIntegrationTokenData, generateIntegrationTokenError: generateIntegrationTokenError, isGenerateIntegrationTokenLoading: isGenerateIntegrationTokenLoading } = (0, $11eaeccab69ae654$export$2e2bcd8739ae039)();
    // Store Actions
    // const {} = actions
    // Internal State
    // Variables
    const formRef = (0, $tZqWC.useRef)();
    const validationSchema = $84bdfb0f595586e8$export$185802fd694ee1f5().shape({
        label: $7092ea25693c72ef$export$185802fd694ee1f5().required('Label is required'),
        expires: $7092ea25693c72ef$export$185802fd694ee1f5().required('Expiry Date is required'),
        allowed_ips: $7092ea25693c72ef$export$185802fd694ee1f5().matches(/^(?:\d{1,3}\.){3}\d{1,3}(?:,(?:\d{1,3}\.){3}\d{1,3})*$/, 'Must be comma-separated IP addresses with no spaces').test('valid-ip-range', 'Must be valid IP addresses', (value)=>{
            if (!value) return true // optional field
            ;
            const ips = value.split(',');
            return ips.every((ip)=>{
                const parts = ip.split('.');
                return parts.every((part)=>{
                    const num = Number(part);
                    return num >= 0 && num <= 255;
                });
            });
        })
    });
    // Functions
    const triggerSubmit = ()=>{
        formRef.current.submitForm();
    };
    const handleOnSubmit = (values)=>{
        const payload = {
            ...values
        };
        generateIntegrationToken(payload);
    };
    // UseEffects
    (0, $tZqWC.useEffect)(()=>{
        if (setResponse) setResponse(generateIntegrationTokenData);
    }, [
        generateIntegrationTokenData
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $907cb73d9dab9fec$export$ac7496df4f1f837a), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $506ef65bbb4994b7$export$2e2bcd8739ae039), {
            formRef: formRef,
            validationSchema: validationSchema,
            onSubmit: handleOnSubmit,
            children: [
                generateIntegrationTokenError && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $907cb73d9dab9fec$export$ae4fd97bdbe491c1), {
                    children: "Could not generate an API Key"
                }),
                !generateIntegrationTokenError && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $907cb73d9dab9fec$export$f06621d9ad29af97), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $907cb73d9dab9fec$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                        label: "Label",
                                        name: "label"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $907cb73d9dab9fec$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a5484141b8231e9a$export$2e2bcd8739ae039), {
                                        label: "Expiry Date",
                                        name: "expires",
                                        future: true,
                                        maxDate: (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))().add(1, 'years').format('MMM DD YYYY')
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $907cb73d9dab9fec$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                        label: "Allowed IPs (comma-separated)",
                                        name: "allowed_ips"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $907cb73d9dab9fec$export$e7277fd05612133d), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                size: "medium",
                                type: "button",
                                onClick: triggerSubmit,
                                disabled: isGenerateIntegrationTokenLoading,
                                fullWidth: true,
                                children: isGenerateIntegrationTokenLoading ? 'Generating an API Key...' : 'Create Key'
                            })
                        })
                    ]
                })
            ]
        })
    });
}
// Default Props
$276b34298da608dd$var$CreateApiKeyForm.defaultProps = {
    formRef: {},
    form: {
        toBeUpdatedVasp: null
    },
    actions: {}
};
// Proptypes Validation
$276b34298da608dd$var$CreateApiKeyForm.propTypes = {
    formRef: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        root: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    }),
    form: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        countryListOptions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Array),
        toBeUpdatedVasp: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            vasp_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
        })
    }),
    setResponse: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setToBeUpdatedVasp: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setCreatedVasp: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        toggleCreateApiKeyModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsRecordUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $276b34298da608dd$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($276b34298da608dd$var$mapStateToProps, $276b34298da608dd$var$mapDispatchToProps)($276b34298da608dd$var$CreateApiKeyForm);


var $6efa72a86165ef17$export$2e2bcd8739ae039 = (0, $276b34298da608dd$export$2e2bcd8739ae039);


/* eslint-disable react/prop-types */ /* eslint-disable react/jsx-no-useless-fragment */ 

var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");


var $7LrRy = parcelRequire("7LrRy");



parcelRequire("tZqWC");
/* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $49013d5f2a966e04$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: "25",
        height: "25",
        viewBox: "0 0 25 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M0.859428 9.59853L0.859453 9.59843C2.46161 3.16918 8.97341 -0.743507 15.4015 0.859207L15.4015 0.859213C21.8312 2.46194 25.744 8.97413 24.1411 15.403C22.5382 21.8314 16.0261 25.7435 9.5959 24.1407C3.16893 22.538 -0.743847 16.0266 0.859428 9.59853Z",
                fill: "#00CACD",
                fillOpacity: "0.1",
                stroke: "#00CACD"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M18.0122 10.7194C18.2607 9.05608 16.9941 8.16194 15.2623 7.56546L15.8241 5.31235L14.4521 4.97055L13.9051 7.16429C13.5449 7.07445 13.1746 6.98968 12.8066 6.9057L13.3574 4.69751L11.9866 4.35571L11.4244 6.60805C11.1259 6.54008 10.8329 6.47289 10.5485 6.40219L10.5501 6.39516L8.65844 5.92289L8.29356 7.38773C8.29356 7.38773 9.31125 7.62093 9.28976 7.63538C9.8453 7.77406 9.94609 8.14163 9.9289 8.43304L9.28898 10.9998C9.32727 11.0096 9.37688 11.0236 9.43158 11.0455L9.28703 11.0096L8.38966 14.6053C8.32169 14.774 8.1494 15.0271 7.76108 14.9311C7.77475 14.951 6.76409 14.6822 6.76409 14.6822L6.08315 16.2525L7.86851 16.6974C8.20058 16.7807 8.52601 16.8678 8.84596 16.9498L8.27832 19.2291L9.6484 19.5709L10.211 17.3162C10.5848 17.4178 10.9482 17.5115 11.3037 17.5998L10.7434 19.8439L12.1151 20.1857L12.6827 17.9111C15.0217 18.3537 16.7808 18.1752 17.5204 16.0603C18.1169 14.3572 17.4911 13.3748 16.2605 12.7338C17.1567 12.5264 17.8317 11.9369 18.0118 10.7194H18.0122ZM14.8779 15.1135C14.4536 16.8166 11.5861 15.8963 10.6559 15.665L11.4091 12.6459C12.3389 12.8779 15.3201 13.3373 14.8783 15.1135H14.8779ZM15.3018 10.6947C14.915 12.244 12.528 11.4568 11.7533 11.2639L12.4362 8.52561C13.2109 8.71858 15.7049 9.07874 15.3018 10.6947V10.6947Z",
                fill: "#00CACD"
            })
        ]
    });
}


/* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $10b6063c29a39aa7$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: "25",
        height: "25",
        viewBox: "0 0 25 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M24.5 12.5001C24.5 19.127 19.1275 24.5 12.5001 24.5C5.8729 24.5 0.5 19.127 0.5 12.5001C0.5 5.8726 5.87289 0.5 12.5001 0.5C19.1276 0.5 24.5 5.87249 24.5 12.5001Z",
                fill: "#00CACD",
                fillOpacity: "0.1",
                stroke: "#00CACD"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M11.7697 15.9533L12.5816 12.8961L14.5038 12.1938L14.982 10.3971L14.9656 10.3525L13.0735 11.0438L14.4368 5.9104H10.5704L8.78753 12.6096L7.29895 13.1534L6.80708 15.0057L8.29453 14.4623L7.24375 18.4105H17.5337L18.1934 15.9533H11.7697Z",
                fill: "#00CACD"
            })
        ]
    });
}


/* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $693a897af321fbd0$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: "25",
        height: "25",
        viewBox: "0 0 25 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M24.5 12.5001C24.5 19.127 19.1275 24.5 12.5001 24.5C5.8729 24.5 0.5 19.127 0.5 12.5001C0.5 5.8726 5.87289 0.5 12.5001 0.5C19.1276 0.5 24.5 5.87249 24.5 12.5001Z",
                fill: "#00CACD",
                fillOpacity: "0.1",
                stroke: "#00CACD"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("g", {
                opacity: "0.6",
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                    d: "M12.5116 10.4548L7.95 12.6468L12.5116 15.4943L17.0714 12.6468L12.5116 10.4548Z",
                    fill: "#00CACD"
                })
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("g", {
                opacity: "0.45",
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                    d: "M7.95 12.6467L12.5116 15.4942V4.6499L7.95 12.6467Z",
                    fill: "#00CACD"
                })
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("g", {
                opacity: "0.8",
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                    d: "M12.5116 4.6499V15.4942L17.0714 12.6467L12.5116 4.6499Z",
                    fill: "#00CACD"
                })
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("g", {
                opacity: "0.45",
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                    d: "M7.95 13.5601L12.5116 20.3501V16.4075L7.95 13.5601Z",
                    fill: "#00CACD"
                })
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("g", {
                opacity: "0.8",
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                    d: "M12.5116 16.4075V20.3501L17.075 13.5601L12.5116 16.4075Z",
                    fill: "#00CACD"
                })
            })
        ]
    });
}


/* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $f324264db230fc4b$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: "25",
        height: "25",
        viewBox: "0 0 500 500",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M332.838 167.716C320.274 139.226 291.404 133.135 256.061 139.036L244.703 95L217.926 101.916L229.094 145.825C222.051 147.602 214.817 149.124 207.647 151.155L196.48 107.5L169.703 114.416L181.061 158.452C175.287 160.102 127 172.475 127 172.475L134.36 201.155C134.36 201.155 154.03 195.635 153.84 196.079C164.754 193.223 169.893 198.68 172.305 203.82L203.523 324.505C203.904 327.995 203.269 333.959 195.782 335.99C196.226 336.244 176.302 341.003 176.302 341.003L179.221 374.442C179.221 374.442 227.063 362.195 233.345 360.609L244.83 405.152L271.607 398.236L260.122 353.376C267.482 351.662 274.652 349.886 281.632 348.046L293.053 392.652L319.83 385.736L308.345 341.256C349.589 331.231 378.713 305.216 372.749 265.431C368.942 241.447 342.736 221.777 320.972 219.556C334.36 207.69 341.15 190.368 332.838 167.716ZM319.957 272.728C325.287 312.132 270.528 316.954 252.444 321.713L236.708 262.766C254.855 258.008 310.947 238.02 319.957 272.728ZM286.962 192.462C292.609 227.487 245.782 231.548 230.68 235.419L216.34 181.929C231.505 178.185 275.477 160.038 286.962 192.462Z",
                fill: "#00CACD"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M490 250C490 382.548 382.548 490 250 490C117.452 490 10 382.548 10 250C10 117.452 117.452 10 250 10C382.548 10 490 117.452 490 250Z",
                fill: "#00CACD",
                fillOpacity: "0.1",
                stroke: "#00CACD",
                strokeWidth: "20"
            })
        ]
    });
}


/* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $246469410de6a91b$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: "25",
        height: "25",
        viewBox: "0 0 500 500",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M490 250C490 382.548 382.548 490 250 490C117.452 490 10 382.548 10 250C10 117.452 117.452 10 250 10C382.548 10 490 117.452 490 250Z",
                fill: "#00CACD",
                fillOpacity: "0.1",
                stroke: "#00CACD",
                strokeWidth: "20"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M343.773 191.36C340.552 157.88 311.648 146.66 275.122 143.46V97H246.857V142.22C239.436 142.22 231.835 142.36 224.294 142.52V97H196.029L196.009 143.42C189.888 143.54 183.867 143.66 178.006 143.66V143.52L139.02 143.5V173.7C139.02 173.7 159.903 173.3 159.543 173.68C171.005 173.68 174.726 180.32 175.806 186.06V238.98C176.606 238.98 177.626 239.02 178.786 239.18H175.806L175.786 313.32C175.286 316.92 173.165 322.66 165.164 322.68C165.524 323 144.621 322.68 144.621 322.68L139 356.44H175.806C182.647 356.44 189.388 356.56 195.989 356.6L196.009 403.58H224.254V357.1C231.995 357.26 239.496 357.32 246.837 357.32L246.817 403.58H275.082V356.7C322.609 353.98 355.915 342 360.035 297.36C363.376 261.42 346.473 245.36 319.489 238.88C335.911 230.56 346.173 215.86 343.773 191.36ZM304.206 291.8C304.206 326.9 244.097 322.92 224.914 322.92V260.66C244.097 260.7 304.206 255.2 304.206 291.8ZM291.044 203.98C291.044 235.92 240.876 232.18 224.914 232.2V175.76C240.896 175.76 291.064 170.68 291.044 203.98Z",
                fill: "#00CACD"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M175.848 237.74H180.048V240.84H175.848V237.74Z",
                fill: "#00CACD"
            })
        ]
    });
}


/* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $5f1c58de93ea5b96$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: "25",
        height: "25",
        viewBox: "0 0 500 500",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M490 250C490 382.548 382.548 490 250 490C117.452 490 10 382.548 10 250C10 117.452 117.452 10 250 10C382.548 10 490 117.452 490 250Z",
                fill: "#00CACD",
                fillOpacity: "0.1",
                stroke: "#00CACD",
                strokeWidth: "20"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M148.74 306.866C150.551 305.056 153.04 304 155.68 304H395.082C399.457 304 401.644 309.28 398.552 312.372L351.26 359.664C349.449 361.475 346.96 362.531 344.32 362.531H104.918C100.543 362.531 98.3558 357.251 101.448 354.158L148.74 306.866Z",
                fill: "#00CACD"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M148.74 140.866C150.626 139.056 153.115 138 155.68 138H395.082C399.457 138 401.644 143.28 398.552 146.372L351.26 193.664C349.449 195.475 346.96 196.531 344.32 196.531H104.918C100.543 196.531 98.3558 191.251 101.448 188.158L148.74 140.866Z",
                fill: "#00CACD"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M351.26 223.866C349.449 222.056 346.96 221 344.32 221H104.918C100.543 221 98.3558 226.28 101.448 229.372L148.74 276.664C150.551 278.475 153.04 279.531 155.68 279.531H395.082C399.457 279.531 401.644 274.251 398.552 271.158L351.26 223.866Z",
                fill: "#00CACD"
            })
        ]
    });
}


/* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $0ddebe1ec41e0909$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: "25",
        height: "25",
        viewBox: "0 0 500 500",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M332.838 167.716C320.274 139.226 291.404 133.135 256.061 139.036L244.703 95L217.926 101.916L229.094 145.825C222.051 147.602 214.817 149.124 207.647 151.155L196.48 107.5L169.703 114.416L181.061 158.452C175.287 160.102 127 172.475 127 172.475L134.36 201.155C134.36 201.155 154.03 195.635 153.84 196.079C164.754 193.223 169.893 198.68 172.305 203.82L203.523 324.505C203.904 327.995 203.269 333.959 195.782 335.99C196.226 336.244 176.302 341.003 176.302 341.003L179.221 374.442C179.221 374.442 227.063 362.195 233.345 360.609L244.83 405.152L271.607 398.236L260.122 353.376C267.482 351.662 274.652 349.886 281.632 348.046L293.053 392.652L319.83 385.736L308.345 341.256C349.589 331.231 378.713 305.216 372.749 265.431C368.942 241.447 342.736 221.777 320.972 219.556C334.36 207.69 341.15 190.368 332.838 167.716ZM319.957 272.728C325.287 312.132 270.528 316.954 252.444 321.713L236.708 262.766C254.855 258.008 310.947 238.02 319.957 272.728ZM286.962 192.462C292.609 227.487 245.782 231.548 230.68 235.419L216.34 181.929C231.505 178.185 275.477 160.038 286.962 192.462Z",
                fill: "#00CACD"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M490 250C490 382.548 382.548 490 250 490C117.452 490 10 382.548 10 250C10 117.452 117.452 10 250 10C382.548 10 490 117.452 490 250Z",
                fill: "#00CACD",
                fillOpacity: "0.1",
                stroke: "#00CACD",
                strokeWidth: "20"
            })
        ]
    });
}


/* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $5288db72d8c52b99$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: "25",
        height: "25",
        viewBox: "0 0 500 500",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M490 250C490 382.548 382.548 490 250 490C117.452 490 10 382.548 10 250C10 117.452 117.452 10 250 10C382.548 10 490 117.452 490 250Z",
                fill: "#00CACD",
                fillOpacity: "0.1",
                stroke: "#00CACD",
                strokeWidth: "20"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M115 160.484V345.488L235.084 388.569V202.063L365 154.18L247.092 112L115 160.484Z",
                fill: "#00CACD"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M244.914 207.392V308.562L364.998 351.643V162.96L244.914 207.392Z",
                fill: "#00CACD"
            })
        ]
    });
}


/* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $96050c0d7fe3900b$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: "25",
        height: "25",
        viewBox: "0 0 500 500",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M490 250C490 382.548 382.548 490 250 490C117.452 490 10 382.548 10 250C10 117.452 117.452 10 250 10C382.548 10 490 117.452 490 250Z",
                fill: "#00CACD",
                fillOpacity: "0.1",
                stroke: "#00CACD",
                strokeWidth: "20"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M250 148C283.137 148 310 131.658 310 111.5C310 91.3416 283.137 75 250 75C216.863 75 190 91.3416 190 111.5C190 131.658 216.863 148 250 148Z",
                fill: "#00CACD"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M250 425C283.137 425 310 408.435 310 388C310 367.565 283.137 351 250 351C216.863 351 190 367.565 190 388C190 408.435 216.863 425 250 425Z",
                fill: "#00CACD"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M165.954 199.227C182.609 169.04 182.501 136.346 165.713 126.203C148.924 116.06 121.812 132.308 105.157 162.495C88.5018 192.681 88.6099 225.375 105.399 235.519C122.187 245.662 149.299 229.414 165.954 199.227Z",
                fill: "#00CACD"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M394.827 337.503C411.482 307.316 411.383 274.628 394.606 264.491C377.829 254.355 350.726 270.609 334.071 300.795C317.416 330.982 317.515 363.67 334.292 373.807C351.069 383.943 378.172 367.69 394.827 337.503Z",
                fill: "#00CACD"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M165.72 373.799C182.509 363.656 182.617 330.962 165.962 300.775C149.307 270.588 122.195 254.34 105.406 264.483C88.6177 274.627 88.5096 307.321 105.165 337.507C121.82 367.694 148.932 383.942 165.72 373.799Z",
                fill: "#00CACD"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M394.622 235.527C411.399 225.39 411.498 192.702 394.843 162.515C378.187 132.328 351.085 116.075 334.308 126.211C317.53 136.348 317.431 169.036 334.087 199.223C350.742 229.409 377.845 245.663 394.622 235.527Z",
                fill: "#00CACD"
            })
        ]
    });
}


/* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $81d76cb7e7c41ae8$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: "25",
        height: "25",
        viewBox: "0 0 500 500",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M490 250C490 382.548 382.548 490 250 490C117.452 490 10 382.548 10 250C10 117.452 117.452 10 250 10C382.548 10 490 117.452 490 250Z",
                fill: "#00CACD",
                fillOpacity: "0.1",
                stroke: "#00CACD",
                strokeWidth: "20"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M356.055 126H399.414L309.18 215.344C276.502 247.682 223.521 247.682 190.82 215.344L100.551 126H143.945L212.5 193.869C222.488 203.714 235.949 209.232 249.974 209.232C263.998 209.232 277.459 203.714 287.447 193.869L356.055 126Z",
                fill: "#00CACD"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M143.389 374.438H100L190.82 284.543C223.498 252.205 276.479 252.205 309.18 284.543L400 374.438H356.641L287.5 306.018C277.512 296.173 264.051 290.655 250.026 290.655C236.002 290.655 222.541 296.173 212.553 306.018L143.389 374.438Z",
                fill: "#00CACD"
            })
        ]
    });
}


/* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $0fb15270830db67a$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: "25",
        height: "25",
        viewBox: "0 0 500 500",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M490 250C490 382.548 382.548 490 250 490C117.452 490 10 382.548 10 250C10 117.452 117.452 10 250 10C382.548 10 490 117.452 490 250Z",
                fill: "#00CACD",
                fillOpacity: "0.1",
                stroke: "#00CACD",
                strokeWidth: "20"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M148.74 306.866C150.551 305.056 153.04 304 155.68 304H395.082C399.457 304 401.644 309.28 398.552 312.372L351.26 359.664C349.449 361.475 346.96 362.531 344.32 362.531H104.918C100.543 362.531 98.3558 357.251 101.448 354.158L148.74 306.866Z",
                fill: "#00CACD"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M148.74 140.866C150.626 139.056 153.115 138 155.68 138H395.082C399.457 138 401.644 143.28 398.552 146.372L351.26 193.664C349.449 195.475 346.96 196.531 344.32 196.531H104.918C100.543 196.531 98.3558 191.251 101.448 188.158L148.74 140.866Z",
                fill: "#00CACD"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M351.26 223.866C349.449 222.056 346.96 221 344.32 221H104.918C100.543 221 98.3558 226.28 101.448 229.372L148.74 276.664C150.551 278.475 153.04 279.531 155.68 279.531H395.082C399.457 279.531 401.644 274.251 398.552 271.158L351.26 223.866Z",
                fill: "#00CACD"
            })
        ]
    });
}


/* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $7d0256990b04896e$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: "25",
        height: "25",
        viewBox: "0 0 500 500",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M490 250C490 382.548 382.548 490 250 490C117.452 490 10 382.548 10 250C10 117.452 117.452 10 250 10C382.548 10 490 117.452 490 250Z",
                fill: "#00CACD",
                fillOpacity: "0.1",
                stroke: "#00CACD",
                strokeWidth: "20"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M357.658 156.217L321.535 174.621L147.102 263.468C146.512 258.97 146.215 254.437 146.213 249.9C146.237 231.797 150.99 214.014 160.002 198.312C169.013 182.611 181.97 169.536 197.589 160.383C213.208 151.23 230.948 146.317 249.05 146.129C267.152 145.941 284.99 150.486 300.795 159.314L321.471 148.779L324.556 147.205C305.615 133.458 283.242 125.215 259.91 123.388C236.578 121.56 213.194 126.22 192.344 136.851C171.495 147.482 153.99 163.671 141.766 183.628C129.541 203.586 123.073 226.534 123.075 249.938C123.075 253.171 123.198 256.39 123.443 259.597C123.787 264.139 122.78 268.68 120.548 272.651C118.317 276.621 114.961 279.843 110.903 281.911L100 287.47V313.401L132.099 297.04L142.494 291.735L152.737 286.518L336.626 192.822L357.29 182.3L400 160.532V134.614L357.658 156.217Z",
                fill: "#00CACD"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M400 186.476L163.183 307.054L142.52 317.602L100 339.268V365.173L142.228 343.66L178.351 325.255L352.962 236.281C353.552 240.809 353.849 245.371 353.85 249.938C353.839 268.062 349.087 285.869 340.067 301.589C331.047 317.31 318.072 330.397 302.43 339.553C286.789 348.709 269.024 353.615 250.901 353.783C232.777 353.951 214.925 349.376 199.116 340.512L197.846 341.185L175.432 352.608C194.368 366.356 216.736 374.601 240.065 376.433C263.393 378.264 286.775 373.611 307.624 362.987C328.474 352.363 345.981 336.182 358.211 316.232C370.441 296.282 376.917 273.339 376.925 249.938C376.925 246.676 376.798 243.414 376.557 240.19C376.214 235.65 377.22 231.11 379.449 227.14C381.678 223.17 385.03 219.948 389.084 217.877L400 212.318V186.476Z",
                fill: "#00CACD"
            })
        ]
    });
}


/* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $764d9e0e87ef607d$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: "25",
        height: "25",
        viewBox: "0 0 500 500",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M490 250C490 382.548 382.548 490 250 490C117.452 490 10 382.548 10 250C10 117.452 117.452 10 250 10C382.548 10 490 117.452 490 250Z",
                fill: "#00CACD",
                fillOpacity: "0.1",
                stroke: "#00CACD",
                strokeWidth: "20"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M283.569 406.189C261.22 406.189 244.908 400.806 234.633 390.04C225.113 380.926 219.589 368.415 219.268 355.241C219.152 351.239 220.08 347.275 221.959 343.74C223.713 340.685 226.245 338.15 229.299 336.395C232.848 334.624 236.759 333.703 240.725 333.703C244.691 333.703 248.603 334.624 252.152 336.395C255.2 338.143 257.721 340.681 259.45 343.74C261.384 347.258 262.346 351.228 262.238 355.241C262.437 360.034 261.062 364.76 258.323 368.698C256.04 371.913 252.776 374.301 249.022 375.505C252.694 380.179 257.889 383.418 263.702 384.657C270.207 386.546 276.943 387.517 283.716 387.543C292.684 387.621 301.467 384.995 308.919 380.007C316.65 374.545 322.416 366.738 325.361 357.742C329.095 347.035 330.917 335.755 330.744 324.417C331.045 312.597 329.051 300.831 324.871 289.77C321.728 280.924 315.761 273.357 307.891 268.238C300.576 263.609 292.084 261.18 283.427 261.241C275.884 261.88 268.611 264.349 262.238 268.435L246.525 276.313V268.435L317.139 173.706H219.268V272.007C218.991 279.101 220.868 286.112 224.651 292.12C226.481 294.737 228.957 296.838 231.837 298.218C234.718 299.598 237.906 300.211 241.093 299.997C246.981 299.878 252.676 297.871 257.338 294.272C262.623 290.399 267.222 285.669 270.943 280.276C271.278 279.331 271.896 278.511 272.713 277.929C273.368 277.362 274.205 277.05 275.072 277.048C276.772 277.203 278.381 277.887 279.672 279.004C281.308 280.832 282.198 283.207 282.167 285.659C281.978 287.307 281.684 288.942 281.286 290.553C277.81 298.968 271.982 306.203 264.5 311.393C257.552 316.094 249.345 318.587 240.955 318.545C219.765 318.545 205.086 314.369 196.916 306.017C192.717 301.401 189.481 295.994 187.397 290.112C185.313 284.23 184.423 277.991 184.78 271.761V173.706H135V155.441H185.012V113.797L173.562 102.339V93H206.788L219.268 99.4604V155.441L348.554 155.048L361.426 167.967L282.15 247.628C286.939 245.702 291.983 244.482 297.123 244.007C307.296 244.452 317.222 247.286 326.098 252.278C336.376 257.163 345.038 264.893 351.057 274.551C356.45 282.727 360.267 291.839 362.312 301.417C363.994 308.972 364.896 316.68 365.004 324.419C365.056 339.19 361.708 353.773 355.217 367.041C349.062 379.889 338.702 390.248 325.854 396.404C312.703 402.884 298.23 406.233 283.569 406.189Z",
                fill: "#00CACD"
            })
        ]
    });
}


/* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $14554b83f65116d4$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: "25",
        height: "25",
        viewBox: "0 0 500 500",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M490 250C490 382.548 382.548 490 250 490C117.452 490 10 382.548 10 250C10 117.452 117.452 10 250 10C382.548 10 490 117.452 490 250Z",
                fill: "#00CACD",
                fillOpacity: "0.1",
                stroke: "#00CACD",
                strokeWidth: "20"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M318.758 286.665C318.758 250.208 296.883 237.708 253.133 232.5C221.883 228.333 215.633 220 215.633 205.415C215.633 190.83 226.051 181.458 246.883 181.458C265.633 181.458 276.051 187.708 281.258 203.333C282.301 206.458 285.426 208.54 288.551 208.54H305.216C309.383 208.54 312.508 205.415 312.508 201.25V200.208C308.341 177.29 289.591 159.583 265.633 157.5V132.5C265.633 128.333 262.508 125.208 257.301 124.165H241.676C237.508 124.165 234.383 127.29 233.341 132.5V156.458C202.091 160.625 182.301 181.458 182.301 207.5C182.301 241.875 203.133 255.415 246.883 260.625C276.051 265.833 285.426 272.083 285.426 288.75C285.426 305.418 270.841 316.875 251.051 316.875C223.966 316.875 214.591 305.415 211.466 289.79C210.426 285.625 207.301 283.54 204.176 283.54H186.466C182.301 283.54 179.176 286.665 179.176 290.833V291.875C183.341 317.915 200.008 336.665 234.383 341.875V366.875C234.383 371.04 237.508 374.165 242.716 375.208H258.341C262.508 375.208 265.633 372.083 266.676 366.875V341.875C297.926 336.665 318.758 314.79 318.758 286.665Z",
                fill: "#00CACD"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M196.884 396.04C115.634 366.875 73.9661 276.25 104.176 196.04C119.801 152.29 154.176 118.957 196.884 103.332C201.051 101.25 203.134 98.125 203.134 92.915V78.3325C203.134 74.165 201.051 71.04 196.884 70C195.841 70 193.759 70 192.716 71.04C93.7586 102.29 39.5911 207.5 70.8411 306.457C89.5911 364.79 134.384 409.582 192.716 428.332C196.884 430.415 201.051 428.332 202.091 424.165C203.134 423.125 203.134 422.082 203.134 420V405.415C203.134 402.29 200.009 398.125 196.884 396.04ZM307.301 71.04C303.134 68.9575 298.966 71.04 297.926 75.2075C296.884 76.25 296.884 77.29 296.884 79.375V93.9575C296.884 98.125 300.009 102.29 303.134 104.375C384.384 133.54 426.051 224.165 395.841 304.375C380.216 348.125 345.841 381.457 303.134 397.082C298.966 399.165 296.884 402.29 296.884 407.5V422.082C296.884 426.25 298.966 429.375 303.134 430.415C304.176 430.415 306.259 430.415 307.301 429.375C406.259 398.125 460.426 292.915 429.176 193.957C410.426 134.582 364.591 89.79 307.301 71.04Z",
                fill: "#00CACD"
            })
        ]
    });
}


/* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $08e688c4253948d5$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: "25",
        height: "25",
        viewBox: "0 0 500 500",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M490 250C490 382.548 382.548 490 250 490C117.452 490 10 382.548 10 250C10 117.452 117.452 10 250 10C382.548 10 490 117.452 490 250Z",
                fill: "#00CACD",
                fillOpacity: "0.1",
                stroke: "#00CACD",
                strokeWidth: "20"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M161.832 385.956L201.018 318.097L240.204 250.478L279.15 182.619L285.602 171.867L288.469 182.619L300.416 227.301L287.035 250.478L247.85 318.097L208.903 385.956H255.735L294.92 318.097L315.23 282.973L324.788 318.097L342.947 385.956H385L366.841 318.097L348.681 250.478L343.903 233.035L373.053 182.619H330.522L329.088 177.602L314.274 122.168L312.363 115H271.504L270.549 116.434L232.319 182.619L193.133 250.478L154.186 318.097L115 385.956H161.832Z",
                fill: "#00CACD"
            })
        ]
    });
}


/* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $d97a97257806af92$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: "25",
        height: "25",
        viewBox: "0 0 500 500",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M490 250C490 382.548 382.548 490 250 490C117.452 490 10 382.548 10 250C10 117.452 117.452 10 250 10C382.548 10 490 117.452 490 250Z",
                fill: "#00CACD",
                fillOpacity: "0.1",
                stroke: "#00CACD",
                strokeWidth: "20"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M325.333 137.764L273.169 215.178C269.562 220.45 276.498 226.831 281.493 222.392L332.825 177.719C334.212 176.609 336.154 177.442 336.154 179.384V318.951C336.154 320.893 333.657 321.726 332.547 320.339L177.164 134.434C172.17 128.33 164.956 125 156.909 125H151.36C136.931 125 125 136.931 125 151.637V348.085C125 362.791 136.931 374.723 151.637 374.723C160.794 374.723 169.395 370.006 174.39 361.959L226.554 284.545C230.161 279.273 223.224 272.891 218.23 277.331L166.898 321.726C165.511 322.836 163.568 322.003 163.568 320.061V180.771C163.568 178.829 166.065 177.997 167.175 179.384L322.558 365.289C327.553 371.393 335.044 374.723 342.814 374.723H348.363C363.069 374.723 375 362.791 375 348.085V151.637C375 136.931 363.069 125 348.363 125C338.929 125 330.327 129.717 325.333 137.764Z",
                fill: "#00CACD"
            })
        ]
    });
}


/* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $6958b70b6fa7ab9a$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: "25",
        height: "25",
        viewBox: "0 0 500 500",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M490 250C490 382.548 382.548 490 250 490C117.452 490 10 382.548 10 250C10 117.452 117.452 10 250 10C382.548 10 490 117.452 490 250Z",
                fill: "#00CACD",
                fillOpacity: "0.1",
                stroke: "#00CACD",
                strokeWidth: "20"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M154.051 172.385V234.77H137.026H120L120.276 250.491L120.551 266.212L137.301 266.486L154.051 266.759V328.621V390.483L201.801 390.733C272.669 391.103 276.491 390.85 297.505 384.38C341.393 370.868 369.101 337.801 378.209 288.07C381.348 270.932 381.368 234.642 378.247 217.624C372.973 188.864 362.876 167.441 346.31 149.864C325.494 127.777 297.367 115.155 259.84 111.06C254.358 110.461 229.212 110 202.09 110H154.051V172.385ZM266.551 164.845C277.163 167.717 291.145 174.593 298.527 180.57C310.986 190.659 320.575 206.365 325.222 224.289C327.315 232.364 327.544 235.396 327.486 254.234C327.429 272.426 327.139 276.211 325.29 282.88C317.629 310.508 300.874 327.776 274.051 335.688C267.231 337.701 263.854 337.94 236.801 338.328L207.051 338.757V302.734V266.711H236.051H265.051V250.741V234.77H236.051H207.051V198.228V161.687L232.801 162.184C255.079 162.614 259.63 162.972 266.551 164.845Z",
                fill: "#00CACD"
            })
        ]
    });
}


/* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $e4b2dc73b6b2f3ce$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: "25",
        height: "25",
        viewBox: "0 0 500 500",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M490 250C490 382.548 382.548 490 250 490C117.452 490 10 382.548 10 250C10 117.452 117.452 10 250 10C382.548 10 490 117.452 490 250Z",
                fill: "#00CACD",
                fillOpacity: "0.1",
                stroke: "#00CACD",
                strokeWidth: "20"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M326.562 198.469C321.094 195.344 314.062 195.344 307.812 198.469L264.062 224.25L234.375 240.656L191.406 266.438C185.937 269.563 178.906 269.563 172.656 266.438L139.062 246.125C133.594 243 129.687 236.75 129.687 229.719V190.656C129.687 184.406 132.812 178.156 139.062 174.25L172.656 154.719C178.125 151.594 185.156 151.594 191.406 154.719L225 175.031C230.469 178.156 234.375 184.406 234.375 191.438V217.219L264.062 200.031V173.469C264.062 167.219 260.937 160.969 254.687 157.062L192.187 120.344C186.719 117.219 179.687 117.219 173.437 120.344L109.375 157.844C103.125 160.969 100 167.219 100 173.469V246.906C100 253.156 103.125 259.406 109.375 263.313L172.656 300.031C178.125 303.156 185.156 303.156 191.406 300.031L234.375 275.031L264.062 257.844L307.031 232.844C312.5 229.719 319.531 229.719 325.781 232.844L359.375 252.375C364.844 255.5 368.75 261.75 368.75 268.781V307.844C368.75 314.094 365.625 320.344 359.375 324.25L326.562 343.781C321.094 346.906 314.062 346.906 307.812 343.781L274.219 324.25C268.75 321.125 264.844 314.875 264.844 307.844V282.844L235.156 300.031V325.813C235.156 332.063 238.281 338.313 244.531 342.219L307.812 378.937C313.281 382.062 320.312 382.062 326.562 378.937L389.844 342.219C395.312 339.094 399.219 332.844 399.219 325.813V251.594C399.219 245.344 396.094 239.094 389.844 235.188L326.562 198.469Z",
                fill: "#00CACD"
            })
        ]
    });
}


/* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $c25f9c757c4815db$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: "25",
        height: "25",
        viewBox: "0 0 500 500",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M490 250C490 382.548 382.548 490 250 490C117.452 490 10 382.548 10 250C10 117.452 117.452 10 250 10C382.548 10 490 117.452 490 250Z",
                fill: "#00CACD",
                fillOpacity: "0.1",
                stroke: "#00CACD",
                strokeWidth: "20"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M196.767 148.364L249.267 233.08H250.858L303.358 148.364H332.392L268.358 250.182L332.392 352H303.358L250.858 268.875H249.267L196.767 352H167.733L233.358 250.182L167.733 148.364H196.767Z",
                fill: "#00CACD"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M433 250L493 215.359V284.641L433 250Z",
                fill: "#00CACD"
            })
        ]
    });
}


/* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $7d14ce0847df1b02$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "25",
        height: "25",
        fill: "none",
        viewBox: "0 0 500 500",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                fill: "#00CACD",
                stroke: "#00CACD",
                strokeWidth: "3",
                d: "M370.582 198.346l.016.015.017.014a8.407 8.407 0 012.793 7.578 37.391 37.391 0 01-3.829 5.627l-.012.014-.011.014c-6.007 7.668-38.756 47.575-70.028 85.594a80942.578 80942.578 0 01-59.677 72.467l-.998 1.21-.255.31-.065.078-.016.02-.004.005c-.001.001-.001.001 1.156.956l-1.157-.955-.02.025-.019.024v.001h-.001l-.003.005-.014.017-.054.072-.21.274a111.597 111.597 0 01-3.192 3.966c-.92 1.087-1.862 2.144-2.655 2.919-.4.391-.728.677-.974.855-.056.04-.1.07-.135.092h-.367c-.625-.081-1.387-.704-2.199-2.181-.778-1.416-1.334-3.128-1.752-4.424l-.008-.026-.01-.026c-6.264-17.245-24.208-60.199-43.481-106.336l-5.325-12.75c-21.16-50.675-42.778-102.689-51.593-127.18v-2.831l.106-.274.009-.025.009-.026a7.671 7.671 0 011.725-2.823l.652-.515a4.27 4.27 0 011.627-.624l.029.002c.089.006.221.019.403.04.362.042.87.111 1.522.207 1.303.193 3.139.488 5.445.874 4.612.772 11.075 1.904 18.857 3.292 15.561 2.777 36.377 6.579 58.146 10.589 38.958 7.175 80.964 15.013 101.37 18.821l6.143 1.146a14.205 14.205 0 014.017 2.265l.039.031.04.029.751.525c6.902 6.13 14.593 13.514 22.112 20.803 1.267 1.227 2.529 2.453 3.781 3.669 6.195 6.014 12.156 11.803 17.299 16.551zm-101.333 14.553l-4.409 3.657 5.635-1.026 80.597-14.673 2.961-.539-2.213-2.04-29.798-27.455-.964-.888-1.01.837-50.799 42.127zm-19.722-.438l.965.79.953-.804 54.047-45.58 2.426-2.046-3.121-.576-141.507-26.098-1.223 2.635 87.46 71.679zm8.604 16.141l-1.119.18-.132 1.126-12.824 108.873-.592 5.033 3.236-3.899 102.339-123.3 2.552-3.075-3.945.636-89.515 14.426zM152.11 145.63l-2.359 1.712 78.707 192.265 2.878-.394 13.316-114.176.093-.798-.612-.519-92.023-78.09z"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                fill: "#00CACD",
                fillOpacity: "0.1",
                stroke: "#00CACD",
                strokeWidth: "20",
                d: "M490 250c0 132.548-107.452 240-240 240S10 382.548 10 250 117.452 10 250 10s240 107.452 240 240z"
            })
        ]
    });
}


/* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $83bf7d60990a7dc4$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "25",
        height: "25",
        fill: "none",
        viewBox: "0 0 500 500",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                fill: "#00CACD",
                fillOpacity: "0.1",
                stroke: "#00CACD",
                strokeWidth: "20",
                d: "M490 250c0 132.548-107.452 240-240 240S10 382.548 10 250 117.452 10 250 10s240 107.452 240 240z"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                fill: "#00CACD",
                stroke: "#00CACD",
                strokeWidth: "9",
                d: "M238.82 110.818l.004-.002c2.898-1.479 6.801-2.316 10.899-2.316 4.097 0 8 .837 10.899 2.316l.005.003 75.064 38.184c3.445 1.758 4.668 3.962 4.871 5.63l.053.428v190.885c-.056 1.721-1.205 4.144-4.925 6.051l-.006.003-75.057 38.181-.005.003c-2.899 1.479-6.802 2.316-10.899 2.316-4.098 0-8.001-.837-10.899-2.316l-.006-.003-75.068-38.186-.002-.001c-3.511-1.785-4.659-4.186-4.747-6.076v0-97.022l5.819 3.743.128.082.232.149.248.12.123.059 74.872 38.275c.744.389 1.523.697 2.325.935l5.781 1.716v-90.242l-5.781 1.716c-.78.231-1.548.578-1.918.745a5.927 5.927 0 01-.144.065l-.122.053-.119.061-74.893 38.286c-.063.03-.177.087-.294.151l-.007.004c-.025.014-.067.037-.121.069l-6.129 2.956v-92.351l5.819 3.743.128.082.232.149.248.12.125.06 74.981 38.246.004.002c2.789 1.42 6.304 1.971 9.462 1.971 3.158 0 6.673-.551 9.462-1.971l.004-.002 74.98-38.245c.062-.03.177-.088.296-.153l.007-.004a4.887 4.887 0 001.035-.76h.001l.042-.041 4.093-3.948-4.783-3.076-.128-.082-.231-.149-.248-.119-.125-.061-74.938-38.245-.005-.002c-2.789-1.42-6.304-1.971-9.462-1.971-3.158 0-6.673.551-9.462 1.971l-.004.002-74.98 38.245c-.062.03-.178.087-.296.153l-.007.003c-.025.014-.067.037-.121.069l-6.09 2.937c.21-1.596 1.323-3.639 4.713-5.367l75.067-38.227zm98.852 149.969v-7.349l-6.546 3.341-70.547 36.005h0c-2.9 1.481-6.793 2.317-10.883 2.317-4.086 0-7.991-.835-10.918-2.318l-.006-.003-70.367-35.919-6.546-3.341v94.673l2.463 1.25 70.363 35.71.003.002c4.007 2.051 9.237 4.706 14.67 4.812l.044.001h.299c4.988 0 9.676-2.219 13.325-3.947l.993-.468.073-.034.072-.037 71.059-36.375 2.449-1.254V260.787zM135.614 346.35h2.693c.312 5.416 1.239 9.67 2.956 13.107l.009.018.009.018c1.926 3.77 4.77 6.416 8.975 9.224l.089.068.112.087.118.08c.78.526 1.664 1.06 2.531 1.583l.637.386.007.003.006.004 1.365.823.026.016.026.015.246.144-1.293 2.096-.904-.526-.772-.471-.009-.005-.009-.006c-1.382-.833-2.424-1.468-3.325-2.083l-.036-.025-.036-.024c-5.219-3.419-8.411-6.734-10.415-10.831-1.686-3.445-2.685-7.756-3.006-13.701zm121.638-140.901l-5.781-1.716v90.242l5.781-1.716c.78-.231 1.548-.578 1.917-.745l.145-.065.122-.053.119-.061 74.894-38.286a7.05 7.05 0 00.293-.151l.007-.004c.119-.066.576-.317 1.035-.76h.001l.042-.041 4.093-3.948-4.783-3.076-.128-.082-.231-.149-.248-.119-.124-.06-74.894-38.286-.046-.024-.047-.022-.056-.028c-.41-.197-1.202-.58-2.111-.85zm80.42-37.658v-7.326l-6.534 3.312-67.391 34.153-7.92 4.014 7.92 4.014 67.391 34.154 6.534 3.311v-75.632zm-169.236-4.014l-6.535-3.312v82.958l6.535-3.311 67.39-34.154 7.921-4.014-7.921-4.014-67.39-34.153zm179.114-35.802l.009.005.009.006c1.382.833 2.424 1.468 3.325 2.083l.036.025.036.024c5.219 3.419 8.411 6.734 10.415 10.831 1.686 3.445 2.685 7.756 3.006 13.701h-2.693c-.312-5.416-1.239-9.67-2.956-13.107l-.009-.018-.009-.018c-1.926-3.77-4.77-6.416-8.975-9.224l-.088-.068-.113-.087-.118-.08c-.78-.526-1.664-1.06-2.532-1.584l-.636-.385-.007-.003-.006-.004-1.365-.823-.026-.016-.026-.015-.246-.144 1.293-2.096.904.526.772.471z"
            })
        ]
    });
}


/* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $9d3e353b41855c12$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "25",
        height: "25",
        fill: "none",
        viewBox: "0 0 500 500",
        ...props,
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                fill: "#00CACD",
                fillOpacity: "0.1",
                stroke: "#00CACD",
                strokeWidth: "20",
                d: "M490 250c0 132.548-107.452 240-240 240S10 382.548 10 250 117.452 10 250 10s240 107.452 240 240Z"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                fill: "#00CACD",
                d: "M172.7 317.1q-22.35 0-36.6-10.5c-9.4-7.1-14.1-17.3-14.1-30.4 0-2.8.3-6.1.9-10.1 1.6-9 3.9-19.8 6.9-32.5 8.5-34.4 30.5-51.6 65.9-51.6 9.6 0 18.3 1.6 25.9 4.9 7.6 3.1 13.6 7.9 18 14.3q6.6 9.45 6.6 22.5 0 3.9-.9 9.9c-1.9 11.1-4.1 22-6.8 32.5-4.4 17.1-11.9 30-22.7 38.5-10.7 8.4-25.1 12.5-43.1 12.5m2.7-27c7 0 12.9-2.1 17.8-6.2 5-4.1 8.6-10.4 10.7-19 2.9-11.8 5.1-22 6.6-30.8.5-2.6.8-5.3.8-8.1 0-11.4-5.9-17.1-17.8-17.1-7 0-13 2.1-18 6.2-4.9 4.1-8.4 10.4-10.5 19-2.3 8.4-4.5 18.6-6.8 30.8-.5 2.5-.8 5.1-.8 7.9-.1 11.6 6 17.3 18 17.3M254.899 315.3c-1.4 0-2.4-.4-3.2-1.3-.6-1-.8-2.1-.6-3.4l25.9-122c.2-1.4.9-2.5 2.1-3.4 1.1-.9 2.3-1.3 3.6-1.3h49.9c13.9 0 25 2.9 33.4 8.6 8.5 5.8 12.8 14.1 12.8 25 0 3.1-.4 6.4-1.1 9.8-3.1 14.4-9.4 25-19 31.9-9.4 6.9-22.3 10.3-38.7 10.3h-25.3l-8.6 41.1c-.3 1.4-.9 2.5-2.1 3.4-1.1.9-2.3 1.3-3.6 1.3zm66.4-71.7c5.3 0 9.8-1.4 13.7-4.3 4-2.9 6.6-7 7.9-12.4.4-2.1.6-4 .6-5.6 0-3.6-1.1-6.4-3.2-8.3-2.1-2-5.8-3-10.9-3h-22.5l-7.1 33.6z"
            })
        ]
    });
}


/* eslint-disable react/prop-types */ /* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $6daa55d4a67fd1f4$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: props?.size || '25',
        height: props?.size || '25',
        viewBox: "0 0 500 500",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                d: "M250 10C382.548 10 490 117.452 490 250C490 382.548 382.548 490 250 490C117.452 490 10 382.548 10 250C10 117.452 117.452 10 250 10Z",
                fill: "#00CACD",
                fillOpacity: "0.1",
                stroke: "#00CACD",
                strokeWidth: "20"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("g", {
                clipPath: "url(#clip0_1421_3052)",
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("g", {
                    filter: "url(#filter0_d_1421_3052)",
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                            d: "M249.841 80L354.018 183.934L315.517 222.436L249.841 156.699L184.165 222.777L145.665 184.274L249.841 80ZM118.478 211.475L156.628 250L118.501 288.185L80 250L118.478 211.475ZM249.841 211.497L288.319 249.66L249.83 288.185L211.34 250L249.83 211.497H249.841ZM381.193 211.475L420 250L381.533 288.525L343.044 250L381.193 211.475ZM315.506 277.223L354.007 315.726L249.83 420L145.653 315.749L184.154 277.223L249.83 343.301L315.506 277.223Z",
                            fill: "#00CACD"
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                            d: "M353.3 315.726L249.829 419.292L146.359 315.749L184.153 277.931L249.476 343.653L249.83 344.01L250.185 343.653L315.506 277.931L353.3 315.726ZM419.291 250.001L381.532 287.817L343.749 249.998L381.195 212.181L419.291 250.001ZM155.922 249.998L118.499 287.479L80.708 249.997L118.477 212.184L155.922 249.998ZM287.611 249.661L249.828 287.479L212.048 249.998L249.837 212.197L287.611 249.661ZM353.31 183.934L315.518 221.729L250.195 156.346L249.841 155.991L249.486 156.347L184.164 222.068L146.371 184.273L249.842 80.7061L353.31 183.934Z",
                            stroke: "#00CACD"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("filter", {
                        id: "filter0_d_1421_3052",
                        x: "76",
                        y: "80",
                        width: "348",
                        height: "348",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("feOffset", {
                                dy: "4"
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("feGaussianBlur", {
                                stdDeviation: "2"
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_1421_3052"
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_1421_3052",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("clipPath", {
                        id: "clip0_1421_3052",
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("rect", {
                            width: "340",
                            height: "340",
                            fill: "white",
                            transform: "translate(80 80)"
                        })
                    })
                ]
            })
        ]
    });
}


/* eslint-disable react/prop-types */ /* eslint-disable max-len */ 
parcelRequire("tZqWC");
function $6b97a77f5d9cc344$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("svg", {
        width: props?.size || '25',
        height: props?.size || '25',
        viewBox: "0 0 500 500",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("g", {
                clipPath: "url(#clip0_4723_2)",
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                        d: "M250 10C382.548 10 490 117.452 490 250C490 382.548 382.548 490 250 490C117.452 490 10 382.548 10 250C10 117.452 117.452 10 250 10Z",
                        fill: "#00CACD",
                        fillOpacity: "0.1",
                        stroke: "#00CACD",
                        strokeWidth: "20"
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                        d: "M250.201 274.226V267.73C250.201 246.691 264.928 235.553 279.654 226.58C294.029 217.917 308.402 206.78 308.402 186.36C308.402 157.896 282.457 135 250.201 135C217.945 135 192 157.896 192 186.36",
                        stroke: "#00CACD",
                        strokeWidth: "35",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("path", {
                        d: "M250.047 348.404H250.355",
                        stroke: "#00CACD",
                        strokeWidth: "35",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("clipPath", {
                    id: "clip0_4723_2",
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("rect", {
                        width: "500",
                        height: "500",
                        fill: "white"
                    })
                })
            })
        ]
    });
}




const $df4784c9100a83b7$export$c25425c0b9a3de13 = {
    unknown: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6b97a77f5d9cc344$export$2e2bcd8739ae039), {}),
    bitcoin: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $49013d5f2a966e04$export$2e2bcd8739ae039), {}),
    ethereum: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $693a897af321fbd0$export$2e2bcd8739ae039), {}),
    litecoin: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $10b6063c29a39aa7$export$2e2bcd8739ae039), {}),
    'bitcoin-cash': /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f324264db230fc4b$export$2e2bcd8739ae039), {}),
    'bitcoin-sv': /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $246469410de6a91b$export$2e2bcd8739ae039), {}),
    cardano: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5f1c58de93ea5b96$export$2e2bcd8739ae039), {}),
    dash: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $0ddebe1ec41e0909$export$2e2bcd8739ae039), {}),
    neo: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5288db72d8c52b99$export$2e2bcd8739ae039), {}),
    polkadot: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $96050c0d7fe3900b$export$2e2bcd8739ae039), {}),
    ripple: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $81d76cb7e7c41ae8$export$2e2bcd8739ae039), {}),
    solana: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $0fb15270830db67a$export$2e2bcd8739ae039), {}),
    stellar: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7d0256990b04896e$export$2e2bcd8739ae039), {}),
    tezos: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $764d9e0e87ef607d$export$2e2bcd8739ae039), {}),
    usdc: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $14554b83f65116d4$export$2e2bcd8739ae039), {}),
    algorand: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $08e688c4253948d5$export$2e2bcd8739ae039), {}),
    near: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d97a97257806af92$export$2e2bcd8739ae039), {}),
    doge: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6958b70b6fa7ab9a$export$2e2bcd8739ae039), {}),
    polygon: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e4b2dc73b6b2f3ce$export$2e2bcd8739ae039), {}),
    'xdc-network': /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c25f9c757c4815db$export$2e2bcd8739ae039), {}),
    tron: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7d14ce0847df1b02$export$2e2bcd8739ae039), {}),
    fantom: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83bf7d60990a7dc4$export$2e2bcd8739ae039), {}),
    optimism: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d3e353b41855c12$export$2e2bcd8739ae039), {}),
    'bnb-smart-chain': /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6daa55d4a67fd1f4$export$2e2bcd8739ae039), {})
};
const $df4784c9100a83b7$export$73b53978386f314 = {
    UNKNOWN: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6b97a77f5d9cc344$export$2e2bcd8739ae039), {}),
    BTC: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $49013d5f2a966e04$export$2e2bcd8739ae039), {}),
    ETH: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $693a897af321fbd0$export$2e2bcd8739ae039), {}),
    LTC: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $10b6063c29a39aa7$export$2e2bcd8739ae039), {}),
    BCH: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f324264db230fc4b$export$2e2bcd8739ae039), {}),
    BSV: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $246469410de6a91b$export$2e2bcd8739ae039), {}),
    ADA: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5f1c58de93ea5b96$export$2e2bcd8739ae039), {}),
    DASH: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $0ddebe1ec41e0909$export$2e2bcd8739ae039), {}),
    NEO: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5288db72d8c52b99$export$2e2bcd8739ae039), {}),
    DOT: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $96050c0d7fe3900b$export$2e2bcd8739ae039), {}),
    XRP: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $81d76cb7e7c41ae8$export$2e2bcd8739ae039), {}),
    SOL: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $0fb15270830db67a$export$2e2bcd8739ae039), {}),
    XLM: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7d0256990b04896e$export$2e2bcd8739ae039), {}),
    XTZ: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $764d9e0e87ef607d$export$2e2bcd8739ae039), {}),
    USDC: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $14554b83f65116d4$export$2e2bcd8739ae039), {}),
    ALGO: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $08e688c4253948d5$export$2e2bcd8739ae039), {}),
    NEAR: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d97a97257806af92$export$2e2bcd8739ae039), {}),
    DOGE: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6958b70b6fa7ab9a$export$2e2bcd8739ae039), {}),
    MATIC: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e4b2dc73b6b2f3ce$export$2e2bcd8739ae039), {}),
    XDC: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c25f9c757c4815db$export$2e2bcd8739ae039), {}),
    TRX: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7d14ce0847df1b02$export$2e2bcd8739ae039), {}),
    FTM: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83bf7d60990a7dc4$export$2e2bcd8739ae039), {}),
    OP: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d3e353b41855c12$export$2e2bcd8739ae039), {}),
    BNB: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6daa55d4a67fd1f4$export$2e2bcd8739ae039), {})
};






const $fd114fe1ba1b5e5e$export$84c7b01c0bdfd5bf = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  height: 100%;
`;
const $fd114fe1ba1b5e5e$export$ac7496df4f1f837a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
const $fd114fe1ba1b5e5e$export$8f1ff89fa1ec9605 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  padding: 0 0 20px 0;

  #txhashinput {
    grid-template-columns: 1fr !important;
  }

  & #txhashinput > div > input {
    padding: 15px 20px !important;
  }
`;
const $fd114fe1ba1b5e5e$export$842aba50ed0ce9d7 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).label`
  font-size: 14px;
  color: ${({ theme: theme })=>theme.colors.primary};
  margin-top: 30px;

  &#selected-account {
    margin-bottom: -15px;
  }
`;
const $fd114fe1ba1b5e5e$export$7e070b4df62d9e83 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: absolute;
  bottom: 15px;
  left: 15px;
  border-radius: 4px;
  cursor: default;
  &:hover {
    #ConversionModal {
      display: block;
    }
    #ConversionModal:hover {
      display: block;
    }
  }
  & a {
    color: ${({ theme: theme })=>theme.colors.brand};
  }
`;
const $fd114fe1ba1b5e5e$export$858bfd02c3f2fba5 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: none;
  position: relative;
`;
const $fd114fe1ba1b5e5e$export$c9554889b3e706cd = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  min-width: 200px !important;
  z-index: 2;
  position: absolute;
  top: 0;
  background-color: ${({ theme: theme })=>theme.colors.background};
  border: 1px solid ${({ theme: theme })=>theme.colors.secondary};
  border-radius: 8px;
`;
const $fd114fe1ba1b5e5e$export$b26fae16ba5468aa = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  color: ${({ theme: theme })=>theme.colors.primary};
  padding: 8px 12px;
  border-bottom: 1px solid ${({ theme: theme })=>theme.colors.secondary};
  text-align: center;
`;
const $fd114fe1ba1b5e5e$export$6da19a24bf249f17 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 8px 12px;
  border-bottom: 1px solid ${({ theme: theme })=>theme.colors.secondary};
`;
const $fd114fe1ba1b5e5e$export$d9c7360290a9084c = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: 35px 1fr;
`;
const $fd114fe1ba1b5e5e$export$cb540d8b0ef7906c = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 12px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $fd114fe1ba1b5e5e$export$e151f1d86035b485 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  display: grid;
  grid-template-columns: 1fr 140px;
  align-items: center;
  gap: 10px;
  width: 100%;

  background-color: transparent;
  border-radius: 10px;
  border: 2px solid ${({ theme: theme })=>theme.colors.backgroundLite};

  & input {
    background-color: transparent;
    border: none;
    padding: 15px 20px 45px 15px;
    border-radius: 0;
  }
  & > div > div > div {
    & > div {
      font-size: 16px;
    }
  }
  & input::-webkit-outer-spin-button,
  & input::-webkit-inner-spin-button {
    /* display: none; <- Crashes Chrome on hover */
    -webkit-appearance: none;
    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
  }

  & input[type='number'] {
    -moz-appearance: textfield; /* Firefox */
  }
`;
const $fd114fe1ba1b5e5e$export$48f9e24643604975 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $fd114fe1ba1b5e5e$export$8bb8d1d0452e3b79 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  gap: 15px;

  & svg {
    height: 35px !important;
    width: 35px !important;
  }
  & #addressSearchOptionsChain {
    & > div > div:nth-child(3) {
      min-width: 160px;
      right: 0;
      border-radius: 10px;
      & > div > div {
        padding: 8px 12px;
        & svg {
          min-width: 25px;
          stroke: transparent;
          & path {
            stroke: ${({ theme: theme })=>theme.colors.brand};
          }
        }
      }
    }
  }
`;



// Map Redux Props
const $ffb5b1d355e1ee25$var$mapStateToProps = (state)=>state;
const $ffb5b1d355e1ee25$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $ffb5b1d355e1ee25$var$AmountTransferForm(props) {
    // Destructure
    const { formData: formData, setFormData: setFormData, address: address } = props;
    // Store
    const { addressChains: addressChains } = address;
    // Hooks
    const { getAssetConversion: getAssetConversion, assetConversionData: assetConversionData, isAssetConversionLoading: isAssetConversionLoading } = (0, $5169c7c2902b6229$export$2e2bcd8739ae039)();
    // Internal State
    const [currencyConversion, setCurrencyConversion] = (0, $tZqWC.useState)([
        ''
    ]);
    const [isAmountUsdLoading, setIsAmountUsdLoading] = (0, $tZqWC.useState)(false);
    const [availableChains, setAvailableChains] = (0, $tZqWC.useState)();
    // functions
    const debouncedFunctionRef = (0, $tZqWC.useRef)();
    debouncedFunctionRef.current = ()=>{
        if (formData?.transfer?.amount && !formData?.transfer?.asset_code) getAssetConversion({
            from_symbols: (0, $f398806f8c37b1c3$export$cfce4cc2a24073)[0].value,
            to_symbols: 'USD,EUR,GBP,JPY,CAD,AUD,SGD,AED'
        });
        if (formData?.transfer?.amount && formData?.transfer?.asset_code) getAssetConversion({
            from_symbols: formData?.transfer?.asset_code,
            to_symbols: 'USD,EUR,GBP,JPY,CAD,AUD,SGD,AED'
        });
    };
    function handleAvailableChains() {
        const providers = {
            ...addressChains?.financial
        };
        let allChains = {};
        Object.keys(providers).forEach((item)=>{
            if (item === 'FDBDM') allChains = {
                ...allChains,
                ...providers[item]
            };
        });
        setAvailableChains(allChains);
    }
    const debounceFetch = (0, $tZqWC.useCallback)((0, $7LrRy.debounce)((...args)=>debouncedFunctionRef.current(...args), 500), []);
    function handleAssetConversion() {
        const newConversionData = [];
        Object.keys(assetConversionData.data).forEach((asset)=>{
            Object.keys(assetConversionData.data[asset]).forEach((currency)=>{
                if (currency === 'USD') setFormData({
                    ...formData,
                    transfer: {
                        ...formData.transfer,
                        amount: Number(formData.transfer.amount),
                        amount_usd: assetConversionData.data[asset][currency] * formData.transfer.amount
                    }
                });
                newConversionData.push(`${currency} ${(0, $ecf1d77ac1b82678$export$a2db1876938cd11d)(Math.round(assetConversionData.data[asset][currency] * formData.transfer.amount * 100) / 100)}`);
            });
        });
        setCurrencyConversion(newConversionData);
        setIsAmountUsdLoading(false);
    }
    const handleTransactionChange = (value)=>{
        // Handle amount validation
        if (value.amount !== undefined) {
            // Allow empty string for clearing the field
            if (value.amount === '') ;
            else {
                const numericAmount = parseFloat(value.amount);
                if (numericAmount < 0 || Number.isNaN(numericAmount)) // Don't update if negative or invalid (but allow 0)
                return;
                // Convert to positive number if it's a valid positive value
                value.amount = Math.abs(numericAmount);
            }
        }
        setIsAmountUsdLoading(true);
        setFormData({
            ...formData,
            transfer: {
                ...formData.transfer,
                ...value
            }
        });
    };
    const handleAssetChange = (value)=>{
        setIsAmountUsdLoading(true);
        setFormData({
            ...formData,
            transfer: {
                ...formData.transfer,
                ...value
            }
        });
    };
    // useEffect
    (0, $tZqWC.useEffect)(()=>{
        handleAvailableChains();
    }, [
        addressChains
    ]);
    (0, $tZqWC.useEffect)(()=>assetConversionData && handleAssetConversion(), [
        assetConversionData
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (!formData.transfer.amount_usd) setIsAmountUsdLoading(true);
        else if (formData.transfer.amount_usd) {
            setCurrencyConversion([
                `${(0, $ecf1d77ac1b82678$export$a2db1876938cd11d)(Math.round(formData.transfer.amount_usd * 100) / 100)} USD`
            ]);
            setIsAmountUsdLoading(false);
        }
    }, []);
    (0, $tZqWC.useEffect)(()=>{
        if (isAmountUsdLoading) setFormData({
            ...formData,
            transfer: {
                ...formData.transfer,
                amount_usd: null
            }
        });
    }, [
        isAmountUsdLoading
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $fd114fe1ba1b5e5e$export$84c7b01c0bdfd5bf), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $fd114fe1ba1b5e5e$export$ac7496df4f1f837a), {
            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $fd114fe1ba1b5e5e$export$8f1ff89fa1ec9605), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $fd114fe1ba1b5e5e$export$842aba50ed0ce9d7), {
                        children: "Please enter transfer amount"
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $fd114fe1ba1b5e5e$export$e151f1d86035b485), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ae78f1d128dc50d5$export$2e2bcd8739ae039), {
                                placeholder: "Amount e.g. 1.5",
                                type: "number",
                                min: "0",
                                step: "0.1",
                                value: formData?.transfer?.amount || '',
                                onChange: (e)=>{
                                    const inputValue = e.target.value;
                                    // Allow empty string for clearing the field
                                    if (inputValue === '') {
                                        handleTransactionChange({
                                            amount: ''
                                        });
                                        return;
                                    }
                                    // Convert to number and check if positive
                                    const numericValue = parseFloat(inputValue);
                                    if (!Number.isNaN(numericValue) && numericValue >= 0) {
                                        handleTransactionChange({
                                            amount: numericValue
                                        });
                                        debounceFetch();
                                    }
                                },
                                onKeyDown: (e)=>{
                                    // Prevent typing negative sign
                                    if (e.key === '-' || e.key === 'e' || e.key === 'E') e.preventDefault();
                                }
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $fd114fe1ba1b5e5e$export$8bb8d1d0452e3b79), {
                                children: [
                                    (0, $df4784c9100a83b7$export$73b53978386f314)[formData?.transfer?.asset_code || (0, $f398806f8c37b1c3$export$cfce4cc2a24073)[0].label] && /*#__PURE__*/ (0, $tZqWC.cloneElement)((0, $df4784c9100a83b7$export$73b53978386f314)[formData?.transfer?.asset_code || (0, $f398806f8c37b1c3$export$cfce4cc2a24073)[0].label]),
                                    availableChains && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $430484cb816801bc$export$2e2bcd8739ae039), {
                                        id: "addressSearchOptionsChain",
                                        placeholder: "Chain",
                                        options: Object.keys(availableChains).map((item)=>({
                                                value: availableChains[item]?.symbol,
                                                label: availableChains[item]?.symbol
                                            })),
                                        value: formData?.transfer?.asset_code || addressChains?.[Object.keys(addressChains)[0]]?.symbol,
                                        onChange: (value)=>{
                                            handleAssetChange({
                                                asset_code: value,
                                                dti: availableChains[value]?.dti
                                            });
                                            debounceFetch();
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $fd114fe1ba1b5e5e$export$7e070b4df62d9e83), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $fd114fe1ba1b5e5e$export$48f9e24643604975), {
                                        children: [
                                            isAssetConversionLoading && 'Loading...',
                                            !isAssetConversionLoading && currencyConversion?.length > 1 && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                                                children: [
                                                    currencyConversion[0],
                                                    " ",
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b7c251a6b5f784dd$export$2e2bcd8739ae039), {
                                                        size: 18
                                                    })
                                                ]
                                            }),
                                            !isAssetConversionLoading && !assetConversionData && !formData.transfer.amount_usd && ' No Data'
                                        ]
                                    }),
                                    currencyConversion?.length > 1 && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $fd114fe1ba1b5e5e$export$858bfd02c3f2fba5), {
                                        id: "ConversionModal",
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $fd114fe1ba1b5e5e$export$c9554889b3e706cd), {
                                            children: [
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $fd114fe1ba1b5e5e$export$b26fae16ba5468aa), {
                                                    children: "Conversion Rate"
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $fd114fe1ba1b5e5e$export$6da19a24bf249f17), {
                                                    children: currencyConversion.map((item)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $fd114fe1ba1b5e5e$export$d9c7360290a9084c), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $fd114fe1ba1b5e5e$export$cb540d8b0ef7906c), {
                                                                    children: item?.split(' ')[0]
                                                                }),
                                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $fd114fe1ba1b5e5e$export$cb540d8b0ef7906c), {
                                                                    children: item?.split(' ')[1]
                                                                })
                                                            ]
                                                        }, `conversion-${item?.split(' ')[0]}`))
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $fd114fe1ba1b5e5e$export$6da19a24bf249f17), {
                                                    style: {
                                                        border: 'none'
                                                    },
                                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $fd114fe1ba1b5e5e$export$cb540d8b0ef7906c), {
                                                        children: [
                                                            "Conversion rates are calculated based on CCCAGG methodology.",
                                                            ' ',
                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("a", {
                                                                target: "_blank",
                                                                href: "https://www.cryptocompare.com/media/12318004/cccagg.pdf",
                                                                rel: "noreferrer",
                                                                children: "Learn more about this index."
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $fd114fe1ba1b5e5e$export$842aba50ed0ce9d7), {
                        children: "Please enter transaction hash (Optional)"
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $fd114fe1ba1b5e5e$export$e151f1d86035b485), {
                        id: "txhashinput",
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ae78f1d128dc50d5$export$2e2bcd8739ae039), {
                            placeholder: "transaction hash",
                            value: formData?.transfer?.tx_hash,
                            onChange: (e)=>{
                                setFormData({
                                    ...formData,
                                    transfer: {
                                        ...formData.transfer,
                                        tx_hash: e.target.value
                                    }
                                });
                            }
                        })
                    })
                ]
            })
        })
    });
}
// Default Props
$ffb5b1d355e1ee25$var$AmountTransferForm.defaultProps = {
    formData: {},
    setFormData: ()=>{},
    actions: {},
    form: {}
};
// Proptypes Validation
$ffb5b1d355e1ee25$var$AmountTransferForm.propTypes = {
    formData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        transfer: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            tx_hash: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            amount: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
                (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOf([
                    ''
                ]) // Only allow empty string
            ]),
            amount_usd: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
            asset_code: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            protocol_code: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
        })
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setIsVaspDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    form: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        createdVasp: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({})
    }),
    setFormData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
};
var $ffb5b1d355e1ee25$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($ffb5b1d355e1ee25$var$mapStateToProps, $ffb5b1d355e1ee25$var$mapDispatchToProps)($ffb5b1d355e1ee25$var$AmountTransferForm);


var $ce9dd9f3122a87a0$export$2e2bcd8739ae039 = (0, $ffb5b1d355e1ee25$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");


var $7LrRy = parcelRequire("7LrRy");


const $a91afab9c99848cc$export$84c7b01c0bdfd5bf = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  height: 100%;
`;
const $a91afab9c99848cc$export$ac7496df4f1f837a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
const $a91afab9c99848cc$export$8f1ff89fa1ec9605 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
`;
const $a91afab9c99848cc$export$842aba50ed0ce9d7 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).label`
  font-size: 14px;
  color: ${({ theme: theme })=>theme.colors.primary};
  margin: 30px 0 0 0;
`;
const $a91afab9c99848cc$export$6593ac2583e007ee = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  text-align: left;
  font-size: 12px;
  color: ${({ theme: theme })=>theme.colors.primary};
  margin: 5px 0 0 0;
`;
const $a91afab9c99848cc$export$2cf7ef1e2dd6c6b1 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).label`
  text-align: center;
  font-size: 14px;
  color: ${({ theme: theme })=>theme.colors.primary};
  margin: 0 0 10px 0;
`;
const $a91afab9c99848cc$export$e151f1d86035b485 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  gap: 10px;
  width: 100%;

  & button {
    background: ${({ theme: theme })=>theme.colors.background};
  }
`;





// Map Redux Props
const $abac40fcc25ca60c$var$mapStateToProps = (state)=>state;
const $abac40fcc25ca60c$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $abac40fcc25ca60c$var$VaspTransferForm(props) {
    // Destructure
    const { formData: formData, setFormData: setFormData, actions: actions, recipientAddress: recipientAddress, setRecipientAddress: setRecipientAddress, recipientVaspOptions: recipientVaspOptions, setRecipientVaspOptions: setRecipientVaspOptions } = props;
    // Store Actions
    const { setShowHeaderLoader: setShowHeaderLoader } = actions;
    // hooks
    const { searchVasp: searchVasp, vaspSearchData: vaspSearchData, isVaspSearchLoading: isVaspSearchLoading } = (0, $dc7df1083c6c90ef$export$2e2bcd8739ae039)();
    const { getVasp: getVasp, vaspData: vaspData, isVaspLoading: isVaspLoading } = (0, $462c3808bdeaeab0$export$2e2bcd8739ae039)();
    const { recipientVaspData: // getRecipientVasp,
    recipientVaspData, isRecipientVaspLoading: isRecipientVaspLoading, recipientVaspError: recipientVaspError } = (0, $171915c4daff5625$export$2e2bcd8739ae039)();
    // Internal State
    const [searchResults, setSearchResults] = (0, $tZqWC.useState)([]);
    const [isVaspNotInList, setIsVaspNotInList] = (0, $tZqWC.useState)(false);
    const [csi] = (0, $tZqWC.useState)((0, $60e52eb6c2680325$export$96c4cef8dff1bd45)());
    // functions
    const handleVaspSearch = (0, $7LrRy.debounce)((value)=>{
        if (!value) return setSearchResults([]);
        if (value) return searchVasp({
            search_term: value,
            is_customer_only: csi !== 1
        });
    }, 500);
    const handleOnAutoCompleteSelect = (value)=>{
        getVasp({
            vasp_id: value
        });
    };
    const handleVaspUpdate = ()=>{
        setFormData({
            ...formData,
            vasp: {
                ...formData.vasp,
                ...vaspData
            }
        });
    };
    const handleVaspSelect = (value)=>{
        if (value === null) setIsVaspNotInList(true);
        if (value !== null) setIsVaspNotInList(false);
        setFormData({
            ...formData,
            vasp: value
        });
    };
    // useEffects
    (0, $tZqWC.useEffect)(()=>{
        if (vaspSearchData) setSearchResults(()=>vaspSearchData.map(({ name_legal: name_legal, name_business: name_business, id: id })=>({
                    label: name_legal,
                    subLabel: name_business,
                    value: id
                })));
        if (!vaspSearchData) setSearchResults([]);
    }, [
        vaspSearchData
    ]);
    (0, $tZqWC.useEffect)(()=>vaspData && handleVaspUpdate(), [
        vaspData
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (isVaspLoading) {
            setShowHeaderLoader(true);
            setFormData({
                ...formData,
                vasp: null
            });
        }
        if (!isVaspLoading) setShowHeaderLoader(false);
    }, [
        isVaspLoading
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (recipientAddress !== formData.transfer.out_hash_address) {
            setFormData({
                ...formData,
                vasp: null
            });
            setRecipientAddress(formData.transfer.out_hash_address);
        // getRecipientVasp({
        //   out_hash_address: formData.transfer.out_hash_address,
        //   asset_code: formData.transfer.asset_code,
        // })
        }
    }, [
        formData.transfer.out_hash_address
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (recipientVaspData) {
            const formattedOptions = [];
            recipientVaspData?.map((item)=>{
                formattedOptions.push({
                    value: item,
                    label: item.name_legal
                });
            });
            formattedOptions.push({
                value: null,
                label: 'My VASP is not on this list'
            });
            setRecipientVaspOptions(formattedOptions);
        }
        if (recipientVaspError) setRecipientVaspOptions(null);
    }, [
        recipientVaspData,
        recipientVaspError
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a91afab9c99848cc$export$84c7b01c0bdfd5bf), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a91afab9c99848cc$export$ac7496df4f1f837a), {
            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $a91afab9c99848cc$export$8f1ff89fa1ec9605), {
                children: [
                    isRecipientVaspLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a91afab9c99848cc$export$842aba50ed0ce9d7), {
                        children: "Loading..."
                    }),
                    recipientVaspOptions && !isRecipientVaspLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a91afab9c99848cc$export$e151f1d86035b485), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $47c62aa7410890bd$export$2e2bcd8739ae039), {
                            placeholder: "Select VASP",
                            options: recipientVaspOptions,
                            onChange: handleVaspSelect
                        })
                    }),
                    !isRecipientVaspLoading && isVaspNotInList && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $a91afab9c99848cc$export$8f1ff89fa1ec9605), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a91afab9c99848cc$export$6593ac2583e007ee), {
                                children: "Suggestions:"
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a91afab9c99848cc$export$6593ac2583e007ee), {
                                children: "\u2219 Use the search bar below to find the recipient VASP "
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $69a991355976a1a9$export$2e2bcd8739ae039), {
                                placeholder: "Search for VASP",
                                onInputChange: handleVaspSearch,
                                options: searchResults,
                                setOptions: setSearchResults,
                                onSelect: handleOnAutoCompleteSelect,
                                isLoading: isVaspSearchLoading
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a91afab9c99848cc$export$8f1ff89fa1ec9605), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $69a991355976a1a9$export$2e2bcd8739ae039), {
                            placeholder: "Search for VASP",
                            onInputChange: handleVaspSearch,
                            options: searchResults,
                            setOptions: setSearchResults,
                            onSelect: handleOnAutoCompleteSelect,
                            isLoading: isVaspSearchLoading
                        })
                    }),
                    formData.vasp && !isVaspLoading && !isRecipientVaspLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a91afab9c99848cc$export$842aba50ed0ce9d7), {
                                children: "Selected VASP"
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a91afab9c99848cc$export$e151f1d86035b485), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ae78f1d128dc50d5$export$2e2bcd8739ae039), {
                                    label: "VASP Name",
                                    disabled: true,
                                    value: formData.vasp.name_legal
                                })
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a91afab9c99848cc$export$e151f1d86035b485), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ae78f1d128dc50d5$export$2e2bcd8739ae039), {
                                    label: "Website",
                                    disabled: true,
                                    value: formData.vasp.website
                                })
                            })
                        ]
                    }),
                    formData.vasp && formData.vasp?.tr_protocol?.length > 0 && !isVaspLoading && !isRecipientVaspLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a91afab9c99848cc$export$842aba50ed0ce9d7), {
                                style: {
                                    marginBottom: 14
                                },
                                children: "Please select transfer method"
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $47c62aa7410890bd$export$2e2bcd8739ae039), {
                                options: formData.vasp?.tr_protocol?.map((item)=>({
                                        value: item,
                                        label: item
                                    })),
                                onChange: (v)=>{
                                    setFormData({
                                        ...formData,
                                        transfer: {
                                            ...formData.transfer,
                                            protocol_code: v
                                        }
                                    });
                                },
                                value: formData?.transfer?.protocol_code ? formData.transfer.protocol_code : null
                            })
                        ]
                    }),
                    isVaspLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a91afab9c99848cc$export$842aba50ed0ce9d7), {
                        children: "Loading..."
                    })
                ]
            })
        })
    });
}
// Default Props
$abac40fcc25ca60c$var$VaspTransferForm.defaultProps = {
    formData: {},
    setFormData: ()=>{},
    actions: {},
    form: {}
};
// Proptypes Validation
$abac40fcc25ca60c$var$VaspTransferForm.propTypes = {
    formData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        transfer: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            tx_hash: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            amount: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
            amount_usd: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
            protocol_code: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            out_hash_address: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            asset_code: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
        }),
        vasp: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            tr_protocol: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string),
            name_legal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            website: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
        })
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsVaspDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setToBeUpdatedVasp: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    form: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        createdVasp: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({})
    }),
    recipientAddress: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    setRecipientAddress: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    setFormData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    recipientVaspOptions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).arrayOf([]),
    setRecipientVaspOptions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
};
var $abac40fcc25ca60c$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($abac40fcc25ca60c$var$mapStateToProps, $abac40fcc25ca60c$var$mapDispatchToProps)($abac40fcc25ca60c$var$VaspTransferForm);


var $8a2f3408ab47d487$export$2e2bcd8739ae039 = (0, $abac40fcc25ca60c$export$2e2bcd8739ae039);




var $ejSM7 = parcelRequire("ejSM7");

var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");


var $7LrRy = parcelRequire("7LrRy");





const $b03d624f5a4a0c00$export$84c7b01c0bdfd5bf = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  height: 100%;
`;
const $b03d624f5a4a0c00$export$ac7496df4f1f837a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
const $b03d624f5a4a0c00$export$8f1ff89fa1ec9605 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  padding-bottom: 30px;
`;
const $b03d624f5a4a0c00$export$842aba50ed0ce9d7 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).label`
  text-align: center;
  font-size: 14px;
  color: ${({ theme: theme })=>theme.colors.primary};
  margin: 30px 0 0 0;
`;
const $b03d624f5a4a0c00$export$2cf7ef1e2dd6c6b1 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).label`
  text-align: center;
  font-size: 14px;
  color: ${({ theme: theme })=>theme.colors.primary};
  margin: 0 0 10px 0;
`;
const $b03d624f5a4a0c00$export$e151f1d86035b485 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  gap: 10px;
  width: 100%;

  & button {
    background: ${({ theme: theme })=>theme.colors.background};
  }
`;




// Map Redux Props
const $3b2bb881be097687$var$mapStateToProps = (state)=>state;
const $3b2bb881be097687$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $3b2bb881be097687$var$AccountTransferForm(props) {
    // Destructure
    const { formData: formData, setFormData: setFormData, actions: actions } = props;
    // Store Actions
    const { setIsIndividualAccountDrawerOpen: setIsIndividualAccountDrawerOpen, setIsEntityAccountDrawerOpen: setIsEntityAccountDrawerOpen, setShowHeaderLoader: setShowHeaderLoader, setToBeUpdatedRecipient: setToBeUpdatedRecipient } = actions;
    // hooks
    const { searchAccount: searchAccount, accountSearchData: accountSearchData, isAccountSearchLoading: isAccountSearchLoading } = (0, $c374fc425c48cdb0$export$2e2bcd8739ae039)();
    const { getAccount: getAccount, accountData: accountData, isAccountLoading: isAccountLoading } = (0, $aa9aabe79903a329$export$2e2bcd8739ae039)();
    const { getAddresses: getAddresses, getAddressesData: getAddressesData, isGetAddressesLoading: isGetAddressesLoading } = (0, $d3447c5e6b8a84bc$export$2e2bcd8739ae039)();
    // Internal State
    const [searchResults, setSearchResults] = (0, $tZqWC.useState)([]);
    const [addresses, setAddresses] = (0, $tZqWC.useState)();
    const [addressesMap, setAddressesMap] = (0, $tZqWC.useState)();
    // Constants
    const filter = {
        sort: '-last_modified',
        page: 1,
        size: 100,
        start_range: (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))('Jan 1 2008').format((0, $41a9e38e6be32f35$export$1bceb808939a9f0c)),
        end_range: (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))().add(1, 'days').format((0, $41a9e38e6be32f35$export$1bceb808939a9f0c))
    };
    // functions
    const handleTransactionChange = (value)=>{
        setFormData({
            ...formData,
            transfer: {
                ...formData.transfer,
                ...value
            }
        });
    };
    const handleAccountSearch = (0, $7LrRy.debounce)((value)=>{
        if (!value) return setSearchResults([]);
        if (value) return searchAccount({
            search_term: value,
            account_category: (0, $f398806f8c37b1c3$export$ba280eda23443882).all.value
        });
    }, 500);
    const handleOnAutoCompleteSelect = (value)=>{
        getAccount({
            account_id: value
        });
    };
    function formatAddressOptions(items) {
        if (items) {
            const newArr = [];
            const newMap = {};
            const selectedAssetCode = formData?.transfer?.asset_code?.toUpperCase() || '';
            const expectedChain = (0, $f398806f8c37b1c3$export$2078812dcc559f01)?.[selectedAssetCode]?.toLowerCase() || '';
            const selectedAssetDti = (formData?.transfer?.dti || (0, $f398806f8c37b1c3$export$53c0b7944743072a)?.[selectedAssetCode]?.dti || '').toUpperCase();
            items.forEach((item)=>{
                newMap[item?.address] = item;
                // Filter out addresses that are not of the same chain as the selected asset
                const normalizedItemChain = item?.chain?.toLowerCase() || '';
                const symbolMatches = selectedAssetCode && item?.symbol?.toUpperCase() === selectedAssetCode;
                const chainMatches = expectedChain && normalizedItemChain === expectedChain;
                const dtiMatches = selectedAssetDti && item?.dti?.toUpperCase() === selectedAssetDti;
                const shouldIncludeAddress = dtiMatches || chainMatches || symbolMatches;
                if (shouldIncludeAddress) newArr.push({
                    value: item?.address,
                    label: item?.address,
                    data: item
                });
            });
            setAddressesMap(newMap);
            setAddresses(newArr);
        }
    }
    // NOTE: move this function to a common utility file
    const shortenAddress = (address)=>{
        if (!address) return '';
        // Arbitrary value to filter out non wallet address strings like 'None'
        if (address.length < 10) return address;
        return `${address.slice(0, 5)}...${address.slice(-5)}`;
    };
    // useEffects
    (0, $tZqWC.useEffect)(()=>{
        if (accountData) {
            setFormData({
                ...formData,
                account: {
                    ...formData.account,
                    ...accountData
                },
                transfer: {
                    ...formData.transfer,
                    in_hash_address: null,
                    selected_account_address: null
                }
            });
            getAddresses({
                ...filter,
                chain: (0, $f398806f8c37b1c3$export$2078812dcc559f01)?.[formData?.transfer?.asset_code],
                link_id: accountData.id
            });
            setAddresses([]);
            setAddressesMap();
        }
    }, [
        accountData
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (getAddressesData?.items) formatAddressOptions(getAddressesData.items);
    }, [
        getAddressesData
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (accountSearchData) setSearchResults(()=>accountSearchData.map(({ reference_id: reference_id, is_customer: is_customer, id: id })=>({
                    label: reference_id,
                    subLabel: is_customer ? 'Customer' : 'Non-Customer',
                    value: id
                })));
        if (!accountSearchData) setSearchResults([]);
    }, [
        accountSearchData
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (isAccountLoading) {
            setShowHeaderLoader(true);
            setFormData({
                ...formData,
                account: null
            });
        }
        if (!isAccountLoading) setShowHeaderLoader(false);
    }, [
        isAccountLoading
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b03d624f5a4a0c00$export$84c7b01c0bdfd5bf), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b03d624f5a4a0c00$export$ac7496df4f1f837a), {
            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $b03d624f5a4a0c00$export$8f1ff89fa1ec9605), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b03d624f5a4a0c00$export$e151f1d86035b485), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $69a991355976a1a9$export$2e2bcd8739ae039), {
                            placeholder: formData?.account ? formData?.account?.reference_id : 'Search for account',
                            onInputChange: handleAccountSearch,
                            options: searchResults,
                            setOptions: setSearchResults,
                            onSelect: handleOnAutoCompleteSelect,
                            isLoading: isAccountSearchLoading,
                            bottomOptions: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $b03d624f5a4a0c00$export$8f1ff89fa1ec9605), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b03d624f5a4a0c00$export$2cf7ef1e2dd6c6b1), {
                                        children: "Create New Account"
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $b03d624f5a4a0c00$export$e151f1d86035b485), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                                variant: "outlined",
                                                onClick: ()=>{
                                                    setToBeUpdatedRecipient(null);
                                                    setIsIndividualAccountDrawerOpen(true);
                                                },
                                                children: "Individual"
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                                variant: "outlined",
                                                onClick: ()=>{
                                                    setToBeUpdatedRecipient(null);
                                                    setIsEntityAccountDrawerOpen(true);
                                                },
                                                children: "Business"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $b03d624f5a4a0c00$export$e151f1d86035b485), {
                        children: [
                            isGetAddressesLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b03d624f5a4a0c00$export$842aba50ed0ce9d7), {
                                children: "Loading..."
                            }),
                            !isGetAddressesLoading && addresses && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $47c62aa7410890bd$export$2e2bcd8739ae039), {
                                longValue: false,
                                placeholder: addresses.length > 0 ? 'Address Hash' : "Account isn't linked with any address",
                                label: addresses && 'Select address',
                                onChange: (v)=>{
                                    if (addressesMap[v]) handleTransactionChange({
                                        in_hash_address: v,
                                        selected_account_address: addressesMap[v]
                                    });
                                },
                                value: formData.transfer.in_hash_address ? formData.transfer.in_hash_address : null,
                                options: addresses.map((item)=>({
                                        value: item.value,
                                        label: shortenAddress(item.label),
                                        data: item.data
                                    })),
                                disabled: addresses.length === 0
                            }, formData.account)
                        ]
                    }),
                    formData.account && !isAccountLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b03d624f5a4a0c00$export$842aba50ed0ce9d7), {
                                children: "Selected Account"
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b03d624f5a4a0c00$export$e151f1d86035b485), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ae78f1d128dc50d5$export$2e2bcd8739ae039), {
                                    label: "External ID",
                                    disabled: true,
                                    value: formData.account.reference_id
                                })
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b03d624f5a4a0c00$export$e151f1d86035b485), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ae78f1d128dc50d5$export$2e2bcd8739ae039), {
                                    label: "Account Type",
                                    disabled: true,
                                    value: formData.account.account_type_desc
                                })
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b03d624f5a4a0c00$export$e151f1d86035b485), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ae78f1d128dc50d5$export$2e2bcd8739ae039), {
                                    label: "Name",
                                    disabled: true,
                                    value: formData.account.display_name
                                })
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b03d624f5a4a0c00$export$e151f1d86035b485), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ae78f1d128dc50d5$export$2e2bcd8739ae039), {
                                    label: "Is Customer",
                                    disabled: true,
                                    value: formData.account.is_customer ? 'Yes' : 'No'
                                })
                            })
                        ]
                    }),
                    formData?.transfer?.selected_account_address && !isGetAddressesLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b03d624f5a4a0c00$export$842aba50ed0ce9d7), {
                                children: "Selected address"
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b03d624f5a4a0c00$export$e151f1d86035b485), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ae78f1d128dc50d5$export$2e2bcd8739ae039), {
                                    label: "Chain",
                                    disabled: true,
                                    value: (0, $ecf1d77ac1b82678$export$7dac1d63a1a3adff)(formData?.transfer?.selected_account_address?.chain || '')
                                })
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b03d624f5a4a0c00$export$e151f1d86035b485), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ae78f1d128dc50d5$export$2e2bcd8739ae039), {
                                    label: "Address",
                                    disabled: true,
                                    value: shortenAddress(formData?.transfer?.selected_account_address?.address)
                                })
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b03d624f5a4a0c00$export$e151f1d86035b485), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ae78f1d128dc50d5$export$2e2bcd8739ae039), {
                                    label: "Self Hosted Wallet",
                                    disabled: true,
                                    value: formData?.transfer?.selected_account_address?.is_self_hosted ? 'Yes' : 'No'
                                })
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b03d624f5a4a0c00$export$e151f1d86035b485), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ae78f1d128dc50d5$export$2e2bcd8739ae039), {
                                    label: "Risk Score",
                                    disabled: true,
                                    value: formData?.transfer?.selected_account_address?.risk_ratio
                                })
                            })
                        ]
                    }),
                    (isAccountLoading || isGetAddressesLoading) && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b03d624f5a4a0c00$export$842aba50ed0ce9d7), {
                        children: "Loading..."
                    })
                ]
            })
        })
    });
}
// Default Props
$3b2bb881be097687$var$AccountTransferForm.defaultProps = {
    formData: {},
    setFormData: ()=>{},
    actions: {},
    form: {}
};
// Proptypes Validation
$3b2bb881be097687$var$AccountTransferForm.propTypes = {
    formData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        transfer: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            in_hash_address: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            asset_code: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            dti: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            selected_account_address: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
                chain: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
                address: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
                risk_ratio: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
                is_self_hosted: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
            })
        }),
        account: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            reference_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            account_type_desc: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            display_name: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            is_customer: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
        })
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setIsIndividualAccountDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsEntityAccountDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setToBeUpdatedRecipient: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    form: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        createdAccount: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({})
    }),
    setFormData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
};
var $3b2bb881be097687$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($3b2bb881be097687$var$mapStateToProps, $3b2bb881be097687$var$mapDispatchToProps)($3b2bb881be097687$var$AccountTransferForm);


var $cf1241f5b0acd923$export$2e2bcd8739ae039 = (0, $3b2bb881be097687$export$2e2bcd8739ae039);




var $ejSM7 = parcelRequire("ejSM7");

var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");


var $7LrRy = parcelRequire("7LrRy");





const $7e6a8325a41f9020$export$84c7b01c0bdfd5bf = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  height: 100%;
`;
const $7e6a8325a41f9020$export$ac7496df4f1f837a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
const $7e6a8325a41f9020$export$8f1ff89fa1ec9605 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
`;
const $7e6a8325a41f9020$export$842aba50ed0ce9d7 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).label`
  text-align: center;
  font-size: 14px;
  color: ${({ theme: theme })=>theme.colors.primary};
  margin: 30px 0 0 0;
`;
const $7e6a8325a41f9020$export$2cf7ef1e2dd6c6b1 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).label`
  text-align: center;
  font-size: 14px;
  color: ${({ theme: theme })=>theme.colors.primary};
  margin: 0 0 10px 0;
`;
const $7e6a8325a41f9020$export$e151f1d86035b485 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  gap: 10px;
  width: 100%;

  & button {
    background: ${({ theme: theme })=>theme.colors.background};
  }
`;




// Map Redux Props
const $dd1a8f739af13159$var$mapStateToProps = (state)=>state;
const $dd1a8f739af13159$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $dd1a8f739af13159$var$RecipientTransferForm(props) {
    // Destructure
    const { formData: formData, setFormData: setFormData, actions: actions } = props;
    // Store Actions
    const { setIsIndividualAccountDrawerOpen: setIsIndividualAccountDrawerOpen, setIsEntityAccountDrawerOpen: setIsEntityAccountDrawerOpen, setShowHeaderLoader: setShowHeaderLoader, setToBeUpdatedAccount: setToBeUpdatedAccount } = actions;
    // hooks
    const { searchAccount: searchAccount, accountSearchData: accountSearchData, isAccountSearchLoading: isAccountSearchLoading } = (0, $c374fc425c48cdb0$export$2e2bcd8739ae039)();
    const { getAccount: getAccount, accountData: accountData, isAccountLoading: isAccountLoading } = (0, $aa9aabe79903a329$export$2e2bcd8739ae039)();
    const { getAddresses: getAddresses, getAddressesData: getAddressesData, isGetAddressesLoading: isGetAddressesLoading } = (0, $d3447c5e6b8a84bc$export$2e2bcd8739ae039)();
    // Internal State
    const [searchResults, setSearchResults] = (0, $tZqWC.useState)([]);
    const [addresses, setAddresses] = (0, $tZqWC.useState)();
    const [addressesMap, setAddressesMap] = (0, $tZqWC.useState)();
    // Constants
    const filter = {
        sort: '-last_modified',
        page: 1,
        size: 100,
        start_range: (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))('Jan 1 2008').format((0, $41a9e38e6be32f35$export$1bceb808939a9f0c)),
        end_range: (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))().add(1, 'days').format((0, $41a9e38e6be32f35$export$1bceb808939a9f0c))
    };
    // functions
    const handleTransactionChange = (value)=>{
        setFormData({
            ...formData,
            transfer: {
                ...formData.transfer,
                ...value
            }
        });
    };
    const handleAccountSearch = (0, $7LrRy.debounce)((value)=>{
        if (!value) return setSearchResults([]);
        if (value) return searchAccount({
            search_term: value
        });
    }, 500);
    const handleOnAutoCompleteSelect = (value)=>{
        getAccount({
            account_id: value
        });
    };
    function formatAddressOptions(items) {
        if (items) {
            const newArr = [];
            const newMap = {};
            const selectedAssetCode = formData?.transfer?.asset_code?.toUpperCase() || '';
            const expectedChain = (0, $f398806f8c37b1c3$export$2078812dcc559f01)?.[selectedAssetCode]?.toLowerCase() || '';
            const selectedAssetDti = (formData?.transfer?.dti || (0, $f398806f8c37b1c3$export$53c0b7944743072a)?.[selectedAssetCode]?.dti || '').toUpperCase();
            items.forEach((item)=>{
                newMap[item?.address] = item;
                // Filter out addresses that are not of the same chain as the selected asset
                const normalizedItemChain = item?.chain?.toLowerCase() || '';
                const symbolMatches = selectedAssetCode && item?.symbol?.toUpperCase() === selectedAssetCode;
                const chainMatches = expectedChain && normalizedItemChain === expectedChain;
                const dtiMatches = selectedAssetDti && item?.dti?.toUpperCase() === selectedAssetDti;
                const shouldIncludeAddress = dtiMatches || chainMatches || symbolMatches;
                if (shouldIncludeAddress) newArr.push({
                    value: item?.address,
                    label: item?.address,
                    data: item
                });
            });
            setAddressesMap(newMap);
            setAddresses(newArr);
        }
    }
    // NOTE: move this function to a common utility file
    const shortenAddress = (address)=>{
        if (!address) return '';
        // Arbitrary value to filter out non wallet address strings like 'None'
        if (address.length < 10) return address;
        return `${address.slice(0, 5)}...${address.slice(-5)}`;
    };
    // useEffects
    (0, $tZqWC.useEffect)(()=>{
        if (accountData) {
            setFormData({
                ...formData,
                recipient: {
                    ...formData.recipient,
                    ...accountData
                },
                transfer: {
                    ...formData.transfer,
                    out_hash_address: null,
                    selected_recipient_address: null
                }
            });
            getAddresses({
                ...filter,
                chain: (0, $f398806f8c37b1c3$export$2078812dcc559f01)?.[formData?.transfer?.asset_code],
                link_id: accountData.id
            });
            setAddresses([]);
            setAddressesMap();
        }
    }, [
        accountData
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (getAddressesData?.items) formatAddressOptions(getAddressesData.items);
    }, [
        getAddressesData
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (accountSearchData) setSearchResults(()=>accountSearchData.map(({ reference_id: reference_id, is_customer: is_customer, id: id })=>({
                    label: reference_id,
                    subLabel: is_customer ? 'Customer' : 'Non-Customer',
                    value: id
                })));
        if (!accountSearchData) setSearchResults([]);
    }, [
        accountSearchData
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (isAccountLoading) {
            setShowHeaderLoader(true);
            setFormData({
                ...formData,
                recipient: null
            });
        }
        if (!isAccountLoading) setShowHeaderLoader(false);
    }, [
        isAccountLoading
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7e6a8325a41f9020$export$84c7b01c0bdfd5bf), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7e6a8325a41f9020$export$ac7496df4f1f837a), {
            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $7e6a8325a41f9020$export$8f1ff89fa1ec9605), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7e6a8325a41f9020$export$e151f1d86035b485), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $69a991355976a1a9$export$2e2bcd8739ae039), {
                            placeholder: formData?.recipient ? formData?.recipient?.reference_id : 'Search for Account',
                            onInputChange: handleAccountSearch,
                            options: searchResults,
                            setOptions: setSearchResults,
                            onSelect: handleOnAutoCompleteSelect,
                            isLoading: isAccountSearchLoading,
                            bottomOptions: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $7e6a8325a41f9020$export$8f1ff89fa1ec9605), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7e6a8325a41f9020$export$2cf7ef1e2dd6c6b1), {
                                        children: "Create New Account"
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $7e6a8325a41f9020$export$e151f1d86035b485), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                                variant: "outlined",
                                                onClick: ()=>{
                                                    setToBeUpdatedAccount(null);
                                                    setIsIndividualAccountDrawerOpen(true);
                                                },
                                                children: "Individual"
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                                variant: "outlined",
                                                onClick: ()=>{
                                                    setToBeUpdatedAccount(null);
                                                    setIsEntityAccountDrawerOpen(true);
                                                },
                                                children: "Business"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $7e6a8325a41f9020$export$e151f1d86035b485), {
                        children: [
                            isGetAddressesLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7e6a8325a41f9020$export$842aba50ed0ce9d7), {
                                children: "Loading..."
                            }),
                            !isGetAddressesLoading && addresses && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $47c62aa7410890bd$export$2e2bcd8739ae039), {
                                longValue: false,
                                placeholder: addresses.length > 0 ? 'Address Hash' : "Account isn't linked with any address",
                                label: addresses && 'Select address',
                                onChange: (v)=>{
                                    if (addressesMap[v]) handleTransactionChange({
                                        out_hash_address: v,
                                        selected_recipient_address: addressesMap[v]
                                    });
                                },
                                value: formData.transfer.out_hash_address ? formData.transfer.out_hash_address : null,
                                options: addresses.map((item)=>({
                                        value: item.value,
                                        label: shortenAddress(item.label),
                                        data: item.data
                                    })),
                                disabled: addresses.length === 0
                            }, formData.recipient)
                        ]
                    }),
                    formData.recipient && !isAccountLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7e6a8325a41f9020$export$842aba50ed0ce9d7), {
                                children: "Selected Account"
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7e6a8325a41f9020$export$e151f1d86035b485), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ae78f1d128dc50d5$export$2e2bcd8739ae039), {
                                    label: "External ID",
                                    disabled: true,
                                    value: formData.recipient.reference_id
                                })
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7e6a8325a41f9020$export$e151f1d86035b485), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ae78f1d128dc50d5$export$2e2bcd8739ae039), {
                                    label: "Account Type",
                                    disabled: true,
                                    value: formData.recipient.account_type_desc
                                })
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7e6a8325a41f9020$export$e151f1d86035b485), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ae78f1d128dc50d5$export$2e2bcd8739ae039), {
                                    label: "Name",
                                    disabled: true,
                                    value: formData.recipient.display_name
                                })
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7e6a8325a41f9020$export$e151f1d86035b485), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ae78f1d128dc50d5$export$2e2bcd8739ae039), {
                                    label: "Is Customer",
                                    disabled: true,
                                    value: formData.recipient.is_customer ? 'Yes' : 'No'
                                })
                            })
                        ]
                    }),
                    formData?.transfer?.selected_recipient_address && !isGetAddressesLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7e6a8325a41f9020$export$842aba50ed0ce9d7), {
                                children: "Selected address"
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7e6a8325a41f9020$export$e151f1d86035b485), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ae78f1d128dc50d5$export$2e2bcd8739ae039), {
                                    label: "Chain",
                                    disabled: true,
                                    value: (0, $ecf1d77ac1b82678$export$7dac1d63a1a3adff)(formData?.transfer?.selected_recipient_address?.chain || '')
                                })
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7e6a8325a41f9020$export$e151f1d86035b485), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ae78f1d128dc50d5$export$2e2bcd8739ae039), {
                                    label: "Address",
                                    disabled: true,
                                    value: shortenAddress(formData?.transfer?.selected_recipient_address?.address)
                                })
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7e6a8325a41f9020$export$e151f1d86035b485), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ae78f1d128dc50d5$export$2e2bcd8739ae039), {
                                    label: "Self Hosted Wallet",
                                    disabled: true,
                                    value: formData?.transfer?.selected_recipient_address?.is_self_hosted ? 'Yes' : 'No'
                                })
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7e6a8325a41f9020$export$e151f1d86035b485), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ae78f1d128dc50d5$export$2e2bcd8739ae039), {
                                    label: "Risk Score",
                                    disabled: true,
                                    value: formData?.transfer?.selected_recipient_address?.risk_ratio
                                })
                            })
                        ]
                    }),
                    (isAccountLoading || isGetAddressesLoading) && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7e6a8325a41f9020$export$842aba50ed0ce9d7), {
                        children: "Loading..."
                    })
                ]
            })
        })
    });
}
// Default Props
$dd1a8f739af13159$var$RecipientTransferForm.defaultProps = {
    formData: {},
    setFormData: ()=>{},
    actions: {},
    form: {}
};
// Proptypes Validation
$dd1a8f739af13159$var$RecipientTransferForm.propTypes = {
    formData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        transfer: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            out_hash_address: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            asset_code: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            dti: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            selected_recipient_address: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
                chain: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
                address: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
                risk_ratio: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
                is_self_hosted: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
            })
        }),
        recipient: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            reference_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            account_type_desc: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            display_name: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            is_customer: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
        })
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setIsIndividualAccountDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsEntityAccountDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setToBeUpdatedAccount: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    form: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        createdAccount: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({})
    }),
    setFormData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
};
var $dd1a8f739af13159$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($dd1a8f739af13159$var$mapStateToProps, $dd1a8f739af13159$var$mapDispatchToProps)($dd1a8f739af13159$var$RecipientTransferForm);


var $dc99d1da8f8a575d$export$2e2bcd8739ae039 = (0, $dd1a8f739af13159$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");



const $836635a5e3f6bd1a$export$84c7b01c0bdfd5bf = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  height: 100%;
`;
const $836635a5e3f6bd1a$export$ac7496df4f1f837a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
const $836635a5e3f6bd1a$export$8f1ff89fa1ec9605 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;

  padding: 15px;
  border-radius: 8px;
  background-color: ${({ theme: theme })=>theme.colors.background};
  border: 2px solid ${({ theme: theme })=>theme.colors.backgroundLite};
`;
const $836635a5e3f6bd1a$export$fad6f9b8c5623e9c = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  gap: 10px;

  & button {
    font-size: 10px !important;
    width: auto;
  }
  & > div:last-child {
    text-align: right;
  }
`;
const $836635a5e3f6bd1a$export$8d54fdd5d1be79e3 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 15px;
  font-weight: 700;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $836635a5e3f6bd1a$export$e124c143185e49e4 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 12px;
  color: ${({ theme: theme })=>theme.colors.primary};

  min-width: 40px;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const $836635a5e3f6bd1a$export$c3bd497a498280ed = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 10px;
`;



// Map Redux Props
const $146f0b8435a24c6d$var$mapStateToProps = (state)=>state;
const $146f0b8435a24c6d$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $146f0b8435a24c6d$var$SummaryTransferForm(props) {
    // Destructure
    const { formData: formData, setFormData: setFormData, actions: actions, setFormPage: setFormPage, form: form } = props;
    const { createdAccount: createdAccount, createdRecipient: createdRecipient, createdVasp: createdVasp } = form;
    // Store Actions
    const { setToBeUpdatedAccount: setToBeUpdatedAccount, setToBeUpdatedRecipient: setToBeUpdatedRecipient, setCreatedAccount: setCreatedAccount, setCreatedRecipient: setCreatedRecipient, setCreatedVasp: setCreatedVasp, setIsIndividualAccountDrawerOpen: setIsIndividualAccountDrawerOpen, setIsEntityAccountDrawerOpen: setIsEntityAccountDrawerOpen, setIsIndividualRecipientDrawerOpen: setIsIndividualRecipientDrawerOpen, setIsEntityRecipientDrawerOpen: setIsEntityRecipientDrawerOpen } = actions;
    // Internal State
    const [formState, setFormState] = (0, $tZqWC.useState)(formData);
    // functions
    const handleEditAccount = ()=>{
        setToBeUpdatedAccount(formData.account);
        if (formState.account.account_type_id === 1) setIsIndividualAccountDrawerOpen(true);
        else if (formState.account.account_type_id === 2) setIsEntityAccountDrawerOpen(true);
    };
    const handleEditRecipient = ()=>{
        setToBeUpdatedRecipient(formState.recipient);
        if (formState.recipient.account_type_id === 1) setIsIndividualRecipientDrawerOpen(true);
        else if (formState.recipient.account_type_id === 2) setIsEntityRecipientDrawerOpen(true);
    };
    // NOTE: move this function to a common utility file
    const shortenAddress = (address)=>{
        if (!address) return '';
        return `${address.slice(0, 5)}...${address.slice(-5)}`;
    };
    // useEffect
    (0, $tZqWC.useEffect)(()=>setFormState(formData), [
        formData
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (createdAccount) {
            setFormData({
                ...formData,
                account: createdAccount
            });
            setCreatedAccount(null);
        }
        if (createdRecipient) {
            setFormData({
                ...formData,
                account: createdRecipient
            });
            setCreatedRecipient(null);
        }
        if (createdVasp) {
            setFormData({
                ...formData,
                account: createdVasp
            });
            setCreatedVasp(null);
        }
    }, [
        createdAccount,
        createdRecipient,
        createdVasp
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $836635a5e3f6bd1a$export$84c7b01c0bdfd5bf), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $836635a5e3f6bd1a$export$ac7496df4f1f837a), {
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $836635a5e3f6bd1a$export$8f1ff89fa1ec9605), {
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $836635a5e3f6bd1a$export$fad6f9b8c5623e9c), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $836635a5e3f6bd1a$export$8d54fdd5d1be79e3), {
                                    children: "Amount"
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $836635a5e3f6bd1a$export$c3bd497a498280ed), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                        size: "tiny",
                                        variant: "outlined",
                                        onClick: ()=>setFormPage(1),
                                        children: "Change"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $836635a5e3f6bd1a$export$fad6f9b8c5623e9c), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $836635a5e3f6bd1a$export$e124c143185e49e4), {
                                    children: "Amount: "
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $836635a5e3f6bd1a$export$e124c143185e49e4), {
                                    children: formState.transfer?.amount
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $836635a5e3f6bd1a$export$fad6f9b8c5623e9c), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $836635a5e3f6bd1a$export$e124c143185e49e4), {
                                    children: "Asset: "
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $836635a5e3f6bd1a$export$e124c143185e49e4), {
                                    children: formState.transfer?.asset_code
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $836635a5e3f6bd1a$export$fad6f9b8c5623e9c), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $836635a5e3f6bd1a$export$e124c143185e49e4), {
                                    children: "Transfer Method: "
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $836635a5e3f6bd1a$export$e124c143185e49e4), {
                                    children: formState.transfer?.protocol_code
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $836635a5e3f6bd1a$export$8f1ff89fa1ec9605), {
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $836635a5e3f6bd1a$export$fad6f9b8c5623e9c), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $836635a5e3f6bd1a$export$8d54fdd5d1be79e3), {
                                    children: "Sender"
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $836635a5e3f6bd1a$export$c3bd497a498280ed), {
                                    children: [
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                            size: "tiny",
                                            variant: "outlined",
                                            onClick: handleEditAccount,
                                            disabled: !formState.account,
                                            children: "Edit"
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                            size: "tiny",
                                            variant: "outlined",
                                            onClick: ()=>setFormPage(2),
                                            children: "Change"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $836635a5e3f6bd1a$export$fad6f9b8c5623e9c), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $836635a5e3f6bd1a$export$e124c143185e49e4), {
                                    children: "Sender Address Hash: "
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $836635a5e3f6bd1a$export$e124c143185e49e4), {
                                    children: shortenAddress(formState.transfer?.in_hash_address)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $836635a5e3f6bd1a$export$fad6f9b8c5623e9c), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $836635a5e3f6bd1a$export$e124c143185e49e4), {
                                    children: formState.account?.account_type_id === 1 ? 'First Name: ' : 'Business Name: '
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $836635a5e3f6bd1a$export$e124c143185e49e4), {
                                    children: formState.account?.account_type_id === 1 ? formState.account?.name_first : formState.account?.name_business
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $836635a5e3f6bd1a$export$fad6f9b8c5623e9c), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $836635a5e3f6bd1a$export$e124c143185e49e4), {
                                    children: formState.account?.account_type_id === 1 ? 'Last Name: ' : 'Legal Name: '
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $836635a5e3f6bd1a$export$e124c143185e49e4), {
                                    children: formState.account?.account_type_id === 1 ? formState.account?.name_last : formState.account?.name_legal
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $836635a5e3f6bd1a$export$fad6f9b8c5623e9c), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $836635a5e3f6bd1a$export$e124c143185e49e4), {
                                    children: "Address: "
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $836635a5e3f6bd1a$export$e124c143185e49e4), {
                                    children: `${formState.account?.address_line ? ` ${formState.account?.address_line}, ` : ''}${formState.account?.address_street_no ? ` ${formState.account?.address_street_no}, ` : ''}${formState.account?.address_street_name ? `${formState.account?.address_street_name}, ` : ''}${formState.account?.address_building_name ? `${formState.account?.address_building_name}, ` : ''}${formState.account?.address_floor ? `${formState.account?.address_floor}, ` : ''}${formState.account?.address_room ? `${formState.account?.address_room}, ` : ''}${formState.account?.address_department ? `${formState.account?.address_department}, ` : ''}${formState.account?.address_postbox ? `${formState.account?.address_postbox}, ` : ''}${formState.account?.address_city_location ? `${formState.account?.address_city_location}, ` : ''}${formState.account?.address_city ? `${formState.account?.address_city}, ` : ''}${formState.account?.address_region ? `${formState.account?.address_region}, ` : ''}${formState.account?.address_district ? `${formState.account?.address_district}, ` : ''}${formState.account?.address_postcode ? `${formState.account?.address_postcode}, ` : ''}${formState.account?.address_country_code ? `${formState.account?.address_country_code}, ` : ''}${formState.account?.address_country_desc ? `${formState.account?.address_country_desc} ` : ''}`
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $836635a5e3f6bd1a$export$8f1ff89fa1ec9605), {
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $836635a5e3f6bd1a$export$fad6f9b8c5623e9c), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $836635a5e3f6bd1a$export$8d54fdd5d1be79e3), {
                                    children: "Recipient"
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $836635a5e3f6bd1a$export$c3bd497a498280ed), {
                                    children: [
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                            size: "tiny",
                                            variant: "outlined",
                                            onClick: handleEditRecipient,
                                            disabled: !formState.recipient,
                                            children: "Edit"
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                            size: "tiny",
                                            variant: "outlined",
                                            onClick: ()=>setFormPage(3),
                                            children: "Change"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $836635a5e3f6bd1a$export$fad6f9b8c5623e9c), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $836635a5e3f6bd1a$export$e124c143185e49e4), {
                                    children: "Recipient Address Hash: "
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $836635a5e3f6bd1a$export$e124c143185e49e4), {
                                    children: shortenAddress(formState.transfer?.out_hash_address)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $836635a5e3f6bd1a$export$fad6f9b8c5623e9c), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $836635a5e3f6bd1a$export$e124c143185e49e4), {
                                    children: formState.recipient?.account_type_id === 1 ? 'First Name: ' : 'Business Name: '
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $836635a5e3f6bd1a$export$e124c143185e49e4), {
                                    children: formState.recipient?.account_type_id === 1 ? formState.recipient?.name_first : formState.recipient?.name_business
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $836635a5e3f6bd1a$export$fad6f9b8c5623e9c), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $836635a5e3f6bd1a$export$e124c143185e49e4), {
                                    children: formState.recipient?.account_type_id === 1 ? 'Last Name: ' : 'Legal Name: '
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $836635a5e3f6bd1a$export$e124c143185e49e4), {
                                    children: formState.recipient?.account_type_id === 1 ? formState.recipient?.name_last : formState.recipient?.name_legal
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $836635a5e3f6bd1a$export$fad6f9b8c5623e9c), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $836635a5e3f6bd1a$export$e124c143185e49e4), {
                                    children: "Address: "
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $836635a5e3f6bd1a$export$e124c143185e49e4), {
                                    children: `${formState.recipient?.address_line ? ` ${formState.recipient?.address_line}, ` : ''}${formState.recipient?.address_street_no ? ` ${formState.recipient?.address_street_no}, ` : ''}${formState.recipient?.address_street_name ? `${formState.recipient?.address_street_name}, ` : ''}${formState.recipient?.address_building_name ? `${formState.recipient?.address_building_name}, ` : ''}${formState.recipient?.address_floor ? `${formState.recipient?.address_floor}, ` : ''}${formState.recipient?.address_room ? `${formState.recipient?.address_room}, ` : ''}${formState.recipient?.address_department ? `${formState.recipient?.address_department}, ` : ''}${formState.recipient?.address_postbox ? `${formState.recipient?.address_postbox}, ` : ''}${formState.recipient?.address_city_location ? `${formState.recipient?.address_city_location}, ` : ''}${formState.recipient?.address_city ? `${formState.recipient?.address_city}, ` : ''}${formState.recipient?.address_region ? `${formState.recipient?.address_region}, ` : ''}${formState.recipient?.address_district ? `${formState.recipient?.address_district}, ` : ''}${formState.recipient?.address_postcode ? `${formState.recipient?.address_postcode}, ` : ''}${formState.recipient?.address_country_code ? `${formState.recipient?.address_country_code}, ` : ''}${formState.recipient?.address_country_desc ? `${formState.recipient?.address_country_desc} ` : ''}`
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $836635a5e3f6bd1a$export$8f1ff89fa1ec9605), {
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $836635a5e3f6bd1a$export$fad6f9b8c5623e9c), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $836635a5e3f6bd1a$export$8d54fdd5d1be79e3), {
                                    children: "Counterparty VASP"
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $836635a5e3f6bd1a$export$c3bd497a498280ed), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                        size: "tiny",
                                        variant: "outlined",
                                        onClick: ()=>setFormPage(4),
                                        children: "Change"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $836635a5e3f6bd1a$export$fad6f9b8c5623e9c), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $836635a5e3f6bd1a$export$e124c143185e49e4), {
                                    children: "Beneficiary VASP Name: "
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $836635a5e3f6bd1a$export$e124c143185e49e4), {
                                    children: formState.vasp?.name_legal
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $836635a5e3f6bd1a$export$fad6f9b8c5623e9c), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $836635a5e3f6bd1a$export$e124c143185e49e4), {
                                    children: "Website: "
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $836635a5e3f6bd1a$export$e124c143185e49e4), {
                                    children: formState.vasp?.website
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $836635a5e3f6bd1a$export$fad6f9b8c5623e9c), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $836635a5e3f6bd1a$export$e124c143185e49e4), {
                                    children: "Legal Name: "
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $836635a5e3f6bd1a$export$e124c143185e49e4), {
                                    children: formState.vasp?.name_legal
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $836635a5e3f6bd1a$export$fad6f9b8c5623e9c), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $836635a5e3f6bd1a$export$e124c143185e49e4), {
                                    children: "Country: "
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $836635a5e3f6bd1a$export$e124c143185e49e4), {
                                    children: formState.vasp?.address_country_code
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
// Default Props
$146f0b8435a24c6d$var$SummaryTransferForm.defaultProps = {
    formData: {},
    actions: {},
    form: {}
};
// Proptypes Validation
$146f0b8435a24c6d$var$SummaryTransferForm.propTypes = {
    formData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        account: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({}),
        recipient: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({}),
        vasp: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({})
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setToBeUpdatedAccount: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setToBeUpdatedRecipient: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setToBeUpdatedVasp: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setCreatedAccount: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setCreatedRecipient: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setCreatedVasp: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsIndividualAccountDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsEntityAccountDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsIndividualRecipientDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsEntityRecipientDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsVaspDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    form: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        createdAccount: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({}),
        createdRecipient: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({}),
        createdVasp: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({})
    }),
    setFormData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    setFormPage: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
};
var $146f0b8435a24c6d$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($146f0b8435a24c6d$var$mapStateToProps, $146f0b8435a24c6d$var$mapDispatchToProps)($146f0b8435a24c6d$var$SummaryTransferForm);


var $cde84a77709d3001$export$2e2bcd8739ae039 = (0, $146f0b8435a24c6d$export$2e2bcd8739ae039);


/* eslint-disable react/no-this-in-sfc */ 

var $tZqWC = parcelRequire("tZqWC");


var $4L3zM = parcelRequire("4L3zM");

const $735b35f584baaf3c$export$df7943177b16f2f3 = [
    {
        id: 0,
        label: 'None',
        value: null,
        default_timezone: null,
        sort_order: 0
    },
    {
        id: 1,
        label: 'Afghanistan',
        value: 'AF',
        default_timezone: 86,
        sort_order: 1
    },
    {
        id: 2,
        label: 'Aland Islands',
        value: 'AX',
        default_timezone: 64,
        sort_order: 2
    },
    {
        id: 3,
        label: 'Albania',
        value: 'AL',
        default_timezone: 52,
        sort_order: 3
    },
    {
        id: 4,
        label: 'Algeria',
        value: 'DZ',
        default_timezone: 55,
        sort_order: 4
    },
    {
        id: 5,
        label: 'American Samoa',
        value: 'AS',
        default_timezone: 2,
        sort_order: 5
    },
    {
        id: 6,
        label: 'Andorra',
        value: 'AD',
        default_timezone: 51,
        sort_order: 6
    },
    {
        id: 7,
        label: 'Angola',
        value: 'AO',
        default_timezone: 55,
        sort_order: 7
    },
    {
        id: 8,
        label: 'Anguilla',
        value: 'AI',
        default_timezone: 30,
        sort_order: 8
    },
    {
        id: 9,
        label: 'Antarctica',
        value: 'AQ',
        default_timezone: 31,
        sort_order: 9
    },
    {
        id: 10,
        label: 'Antigua and Barbuda',
        value: 'AG',
        default_timezone: 30,
        sort_order: 10
    },
    {
        id: 11,
        label: 'Argentina',
        value: 'AR',
        default_timezone: 36,
        sort_order: 11
    },
    {
        id: 12,
        label: 'Armenia',
        value: 'AM',
        default_timezone: 85,
        sort_order: 12
    },
    {
        id: 13,
        label: 'Aruba',
        value: 'AW',
        default_timezone: 30,
        sort_order: 13
    },
    {
        id: 14,
        label: 'Australia',
        value: 'AU',
        default_timezone: 119,
        sort_order: 14
    },
    {
        id: 15,
        label: 'Austria',
        value: 'AT',
        default_timezone: 51,
        sort_order: 15
    },
    {
        id: 16,
        label: 'Azerbaijan',
        value: 'AZ',
        default_timezone: 79,
        sort_order: 16
    },
    {
        id: 17,
        label: 'Bahamas',
        value: 'BS',
        default_timezone: 21,
        sort_order: 17
    },
    {
        id: 18,
        label: 'Bahrain',
        value: 'BH',
        default_timezone: 72,
        sort_order: 18
    },
    {
        id: 19,
        label: 'Bangladesh',
        value: 'BD',
        default_timezone: 95,
        sort_order: 19
    },
    {
        id: 20,
        label: 'Barbados',
        value: 'BB',
        default_timezone: 30,
        sort_order: 20
    },
    {
        id: 21,
        label: 'Belarus',
        value: 'BY',
        default_timezone: 73,
        sort_order: 21
    },
    {
        id: 22,
        label: 'Belgium',
        value: 'BE',
        default_timezone: 53,
        sort_order: 22
    },
    {
        id: 23,
        label: 'Belize',
        value: 'BZ',
        default_timezone: 14,
        sort_order: 23
    },
    {
        id: 24,
        label: 'Benin',
        value: 'BJ',
        default_timezone: 55,
        sort_order: 24
    },
    {
        id: 25,
        label: 'Bermuda',
        value: 'BM',
        default_timezone: 27,
        sort_order: 25
    },
    {
        id: 26,
        label: 'Bhutan',
        value: 'BT',
        default_timezone: 95,
        sort_order: 26
    },
    {
        id: 27,
        label: 'Bolivia',
        value: 'BO',
        default_timezone: 30,
        sort_order: 27
    },
    {
        id: 28,
        label: 'Bonaire, Sint Eustatius and Saba',
        value: 'BQ',
        default_timezone: 30,
        sort_order: 28
    },
    {
        id: 29,
        label: 'Bosnia and Herzegovina',
        value: 'BA',
        default_timezone: 54,
        sort_order: 29
    },
    {
        id: 30,
        label: 'Botswana',
        value: 'BW',
        default_timezone: 63,
        sort_order: 30
    },
    {
        id: 31,
        label: 'Bouvet Island',
        value: 'BV',
        default_timezone: 46,
        sort_order: 31
    },
    {
        id: 32,
        label: 'Brazil',
        value: 'BR',
        default_timezone: 34,
        sort_order: 32
    },
    {
        id: 33,
        label: 'British Indian Ocean Territory',
        value: 'IO',
        default_timezone: 94,
        sort_order: 33
    },
    {
        id: 34,
        label: 'Brunei Darussalam',
        value: 'BN',
        default_timezone: 106,
        sort_order: 34
    },
    {
        id: 35,
        label: 'Bulgaria',
        value: 'BG',
        default_timezone: 64,
        sort_order: 35
    },
    {
        id: 36,
        label: 'Burkina Faso',
        value: 'BF',
        default_timezone: 48,
        sort_order: 36
    },
    {
        id: 37,
        label: 'Burundi',
        value: 'BI',
        default_timezone: 63,
        sort_order: 37
    },
    {
        id: 38,
        label: 'Cambodia',
        value: 'KH',
        default_timezone: 98,
        sort_order: 38
    },
    {
        id: 39,
        label: 'Cameroon',
        value: 'CM',
        default_timezone: 55,
        sort_order: 39
    },
    {
        id: 40,
        label: 'Canada',
        value: 'CA',
        default_timezone: 21,
        sort_order: 40
    },
    {
        id: 41,
        label: 'Cape Verde',
        value: 'CV',
        default_timezone: 45,
        sort_order: 41
    },
    {
        id: 42,
        label: 'Cayman Islands',
        value: 'KY',
        default_timezone: 19,
        sort_order: 42
    },
    {
        id: 43,
        label: 'Central African Republic',
        value: 'CF',
        default_timezone: 55,
        sort_order: 43
    },
    {
        id: 44,
        label: 'Chad',
        value: 'TD',
        default_timezone: 55,
        sort_order: 44
    },
    {
        id: 45,
        label: 'Chile',
        value: 'CL',
        default_timezone: 31,
        sort_order: 45
    },
    {
        id: 46,
        label: 'China',
        value: 'CN',
        default_timezone: 104,
        sort_order: 46
    },
    {
        id: 47,
        label: 'Christmas Island',
        value: 'CX',
        default_timezone: 98,
        sort_order: 47
    },
    {
        id: 48,
        label: 'Cocos (Keeling) Islands',
        value: 'CC',
        default_timezone: 97,
        sort_order: 48
    },
    {
        id: 49,
        label: 'Colombia',
        value: 'CO',
        default_timezone: 19,
        sort_order: 49
    },
    {
        id: 50,
        label: 'Comoros',
        value: 'KM',
        default_timezone: 75,
        sort_order: 50
    },
    {
        id: 51,
        label: 'Congo',
        value: 'CG',
        default_timezone: 55,
        sort_order: 51
    },
    {
        id: 52,
        label: 'Congo, Democratic Republic',
        value: 'CD',
        default_timezone: 55,
        sort_order: 52
    },
    {
        id: 53,
        label: 'Cook Islands',
        value: 'CK',
        default_timezone: 4,
        sort_order: 53
    },
    {
        id: 54,
        label: 'Costa Rica',
        value: 'CR',
        default_timezone: 14,
        sort_order: 54
    },
    {
        id: 55,
        label: "C\xf4te d'Ivoire",
        value: 'CI',
        default_timezone: 48,
        sort_order: 55
    },
    {
        id: 56,
        label: 'Croatia',
        value: 'HR',
        default_timezone: 54,
        sort_order: 56
    },
    {
        id: 57,
        label: 'Cuba',
        value: 'CU',
        default_timezone: 21,
        sort_order: 57
    },
    {
        id: 58,
        label: "Cura\xe7ao",
        value: 'CW',
        default_timezone: 30,
        sort_order: 58
    },
    {
        id: 59,
        label: 'Cyprus',
        value: 'CY',
        default_timezone: 60,
        sort_order: 59
    },
    {
        id: 60,
        label: 'Czech Republic',
        value: 'CZ',
        default_timezone: 52,
        sort_order: 60
    },
    {
        id: 61,
        label: 'Denmark',
        value: 'DK',
        default_timezone: 53,
        sort_order: 61
    },
    {
        id: 62,
        label: 'Djibouti',
        value: 'DJ',
        default_timezone: 75,
        sort_order: 62
    },
    {
        id: 63,
        label: 'Dominica',
        value: 'DM',
        default_timezone: 30,
        sort_order: 63
    },
    {
        id: 64,
        label: 'Dominican Republic',
        value: 'DO',
        default_timezone: 30,
        sort_order: 64
    },
    {
        id: 65,
        label: 'Ecuador',
        value: 'EC',
        default_timezone: 19,
        sort_order: 65
    },
    {
        id: 66,
        label: 'Egypt',
        value: 'EG',
        default_timezone: 59,
        sort_order: 66
    },
    {
        id: 67,
        label: 'El Salvador',
        value: 'SV',
        default_timezone: 14,
        sort_order: 67
    },
    {
        id: 68,
        label: 'Equatorial Guinea',
        value: 'GQ',
        default_timezone: 55,
        sort_order: 68
    },
    {
        id: 69,
        label: 'Eritrea',
        value: 'ER',
        default_timezone: 75,
        sort_order: 69
    },
    {
        id: 70,
        label: 'Estonia',
        value: 'EE',
        default_timezone: 64,
        sort_order: 70
    },
    {
        id: 71,
        label: 'Ethiopia',
        value: 'ET',
        default_timezone: 75,
        sort_order: 71
    },
    {
        id: 72,
        label: 'Falkland Islands (Malvinas)',
        value: 'FK',
        default_timezone: 35,
        sort_order: 72
    },
    {
        id: 73,
        label: 'Faroe Islands',
        value: 'FO',
        default_timezone: 47,
        sort_order: 73
    },
    {
        id: 74,
        label: 'Fiji',
        value: 'FJ',
        default_timezone: 133,
        sort_order: 74
    },
    {
        id: 75,
        label: 'Finland',
        value: 'FI',
        default_timezone: 64,
        sort_order: 75
    },
    {
        id: 76,
        label: 'France',
        value: 'FR',
        default_timezone: 53,
        sort_order: 76
    },
    {
        id: 77,
        label: 'French Guiana',
        value: 'GF',
        default_timezone: 35,
        sort_order: 77
    },
    {
        id: 78,
        label: 'French Polynesia',
        value: 'PF',
        default_timezone: 4,
        sort_order: 78
    },
    {
        id: 79,
        label: 'French Southern Territories',
        value: 'TF',
        default_timezone: 87,
        sort_order: 79
    },
    {
        id: 80,
        label: 'Gabon',
        value: 'GA',
        default_timezone: 55,
        sort_order: 80
    },
    {
        id: 81,
        label: 'Gambia',
        value: 'GM',
        default_timezone: 48,
        sort_order: 81
    },
    {
        id: 82,
        label: 'Georgia',
        value: 'GE',
        default_timezone: 83,
        sort_order: 82
    },
    {
        id: 83,
        label: 'Germany',
        value: 'DE',
        default_timezone: 51,
        sort_order: 83
    },
    {
        id: 84,
        label: 'Ghana',
        value: 'GH',
        default_timezone: 48,
        sort_order: 84
    },
    {
        id: 85,
        label: 'Gibraltar',
        value: 'GI',
        default_timezone: 51,
        sort_order: 85
    },
    {
        id: 86,
        label: 'Greece',
        value: 'GR',
        default_timezone: 57,
        sort_order: 86
    },
    {
        id: 87,
        label: 'Greenland',
        value: 'GL',
        default_timezone: 37,
        sort_order: 87
    },
    {
        id: 88,
        label: 'Grenada',
        value: 'GD',
        default_timezone: 30,
        sort_order: 88
    },
    {
        id: 89,
        label: 'Guadeloupe',
        value: 'GP',
        default_timezone: 30,
        sort_order: 89
    },
    {
        id: 90,
        label: 'Guam',
        value: 'GU',
        default_timezone: 120,
        sort_order: 90
    },
    {
        id: 91,
        label: 'Guatemala',
        value: 'GT',
        default_timezone: 14,
        sort_order: 91
    },
    {
        id: 92,
        label: 'Guernsey',
        value: 'GG',
        default_timezone: 47,
        sort_order: 92
    },
    {
        id: 93,
        label: 'Guinea',
        value: 'GN',
        default_timezone: 48,
        sort_order: 93
    },
    {
        id: 94,
        label: 'Guinea-Bissau',
        value: 'GW',
        default_timezone: 48,
        sort_order: 94
    },
    {
        id: 95,
        label: 'Guyana',
        value: 'GY',
        default_timezone: 30,
        sort_order: 95
    },
    {
        id: 96,
        label: 'Haiti',
        value: 'HT',
        default_timezone: 21,
        sort_order: 96
    },
    {
        id: 97,
        label: 'Heard Island and McDonald Islands',
        value: 'HM',
        default_timezone: 81,
        sort_order: 97
    },
    {
        id: 98,
        label: 'Holy See (Vatican City State)',
        value: 'VA',
        default_timezone: 51,
        sort_order: 98
    },
    {
        id: 99,
        label: 'Honduras',
        value: 'HN',
        default_timezone: 14,
        sort_order: 99
    },
    {
        id: 100,
        label: 'Hong Kong',
        value: 'HK',
        default_timezone: 104,
        sort_order: 100
    },
    {
        id: 101,
        label: 'Hungary',
        value: 'HU',
        default_timezone: 52,
        sort_order: 101
    },
    {
        id: 102,
        label: 'Iceland',
        value: 'IS',
        default_timezone: 48,
        sort_order: 102
    },
    {
        id: 103,
        label: 'India',
        value: 'IN',
        default_timezone: 91,
        sort_order: 103
    },
    {
        id: 104,
        label: 'Indonesia',
        value: 'id',
        default_timezone: 98,
        sort_order: 104
    },
    {
        id: 105,
        label: 'Iran, Islamic Republic of',
        value: 'IR',
        default_timezone: 76,
        sort_order: 105
    },
    {
        id: 106,
        label: 'Iraq',
        value: 'IQ',
        default_timezone: 70,
        sort_order: 106
    },
    {
        id: 107,
        label: 'Ireland',
        value: 'IE',
        default_timezone: 47,
        sort_order: 107
    },
    {
        id: 108,
        label: 'Isle of Man',
        value: 'IM',
        default_timezone: 47,
        sort_order: 108
    },
    {
        id: 109,
        label: 'Israel',
        value: 'IL',
        default_timezone: 65,
        sort_order: 109
    },
    {
        id: 110,
        label: 'Italy',
        value: 'IT',
        default_timezone: 51,
        sort_order: 110
    },
    {
        id: 111,
        label: 'Jamaica',
        value: 'JM',
        default_timezone: 19,
        sort_order: 111
    },
    {
        id: 112,
        label: 'Japan',
        value: 'JP',
        default_timezone: 112,
        sort_order: 112
    },
    {
        id: 113,
        label: 'Jersey',
        value: 'JE',
        default_timezone: 47,
        sort_order: 113
    },
    {
        id: 114,
        label: 'Jordan',
        value: 'JO',
        default_timezone: 56,
        sort_order: 114
    },
    {
        id: 115,
        label: 'Kazakhstan',
        value: 'KZ',
        default_timezone: 94,
        sort_order: 115
    },
    {
        id: 116,
        label: 'Kenya',
        value: 'KE',
        default_timezone: 75,
        sort_order: 116
    },
    {
        id: 117,
        label: 'Kiribati',
        value: 'KI',
        default_timezone: 132,
        sort_order: 117
    },
    {
        id: 118,
        label: "Korea, Democratic People's Republic of",
        value: 'KP',
        default_timezone: 114,
        sort_order: 118
    },
    {
        id: 119,
        label: 'Korea, Republic of',
        value: 'KR',
        default_timezone: 114,
        sort_order: 119
    },
    {
        id: 120,
        label: 'Kuwait',
        value: 'KW',
        default_timezone: 72,
        sort_order: 120
    },
    {
        id: 121,
        label: 'Kyrgyzstan',
        value: 'KG',
        default_timezone: 94,
        sort_order: 121
    },
    {
        id: 122,
        label: "Lao People's Democratic Republic",
        value: 'LA',
        default_timezone: 98,
        sort_order: 122
    },
    {
        id: 123,
        label: 'Latvia',
        value: 'LV',
        default_timezone: 64,
        sort_order: 123
    },
    {
        id: 124,
        label: 'Lebanon',
        value: 'LB',
        default_timezone: 58,
        sort_order: 124
    },
    {
        id: 125,
        label: 'Lesotho',
        value: 'LS',
        default_timezone: 63,
        sort_order: 125
    },
    {
        id: 126,
        label: 'Liberia',
        value: 'LR',
        default_timezone: 48,
        sort_order: 126
    },
    {
        id: 127,
        label: 'Libya',
        value: 'LY',
        default_timezone: 60,
        sort_order: 127
    },
    {
        id: 128,
        label: 'Liechtenstein',
        value: 'LI',
        default_timezone: 51,
        sort_order: 128
    },
    {
        id: 129,
        label: 'Lithuania',
        value: 'LT',
        default_timezone: 64,
        sort_order: 129
    },
    {
        id: 130,
        label: 'Luxembourg',
        value: 'LU',
        default_timezone: 51,
        sort_order: 130
    },
    {
        id: 131,
        label: 'Macao',
        value: 'MO',
        default_timezone: 104,
        sort_order: 131
    },
    {
        id: 132,
        label: 'Macedonia',
        value: 'MK',
        default_timezone: 54,
        sort_order: 132
    },
    {
        id: 133,
        label: 'Madagascar',
        value: 'MG',
        default_timezone: 75,
        sort_order: 133
    },
    {
        id: 134,
        label: 'Malawi',
        value: 'MW',
        default_timezone: 63,
        sort_order: 134
    },
    {
        id: 135,
        label: 'Malaysia',
        value: 'MY',
        default_timezone: 106,
        sort_order: 135
    },
    {
        id: 136,
        label: 'Maldives',
        value: 'MV',
        default_timezone: 87,
        sort_order: 136
    },
    {
        id: 137,
        label: 'Mali',
        value: 'ML',
        default_timezone: 48,
        sort_order: 137
    },
    {
        id: 138,
        label: 'Malta',
        value: 'MT',
        default_timezone: 51,
        sort_order: 138
    },
    {
        id: 139,
        label: 'Marshall Islands',
        value: 'MH',
        default_timezone: 132,
        sort_order: 139
    },
    {
        id: 140,
        label: 'Martinique',
        value: 'MQ',
        default_timezone: 30,
        sort_order: 140
    },
    {
        id: 141,
        label: 'Mauritania',
        value: 'MR',
        default_timezone: 48,
        sort_order: 141
    },
    {
        id: 142,
        label: 'Mauritius',
        value: 'MU',
        default_timezone: 81,
        sort_order: 142
    },
    {
        id: 143,
        label: 'Mayotte',
        value: 'YT',
        default_timezone: 75,
        sort_order: 143
    },
    {
        id: 144,
        label: 'Mexico',
        value: 'MX',
        default_timezone: 17,
        sort_order: 144
    },
    {
        id: 145,
        label: 'Micronesia, Federated States of',
        value: 'FM',
        default_timezone: 120,
        sort_order: 145
    },
    {
        id: 146,
        label: 'Moldova, Republic of',
        value: 'MD',
        default_timezone: 57,
        sort_order: 146
    },
    {
        id: 147,
        label: 'Monaco',
        value: 'MC',
        default_timezone: 51,
        sort_order: 147
    },
    {
        id: 148,
        label: 'Mongolia',
        value: 'MN',
        default_timezone: 109,
        sort_order: 148
    },
    {
        id: 149,
        label: 'Montenegro',
        value: 'ME',
        default_timezone: 54,
        sort_order: 149
    },
    {
        id: 150,
        label: 'Montserrat',
        value: 'MS',
        default_timezone: 30,
        sort_order: 150
    },
    {
        id: 151,
        label: 'Morocco',
        value: 'MA',
        default_timezone: 50,
        sort_order: 151
    },
    {
        id: 152,
        label: 'Mozambique',
        value: 'MZ',
        default_timezone: 63,
        sort_order: 152
    },
    {
        id: 153,
        label: 'Myanmar',
        value: 'MM',
        default_timezone: 97,
        sort_order: 153
    },
    {
        id: 154,
        label: 'Namibia',
        value: 'NA',
        default_timezone: 69,
        sort_order: 154
    },
    {
        id: 155,
        label: 'Nauru',
        value: 'NR',
        default_timezone: 132,
        sort_order: 155
    },
    {
        id: 156,
        label: 'Nepal',
        value: 'NP',
        default_timezone: 93,
        sort_order: 156
    },
    {
        id: 157,
        label: 'Netherlands',
        value: 'NL',
        default_timezone: 51,
        sort_order: 157
    },
    {
        id: 158,
        label: 'New Caledonia',
        value: 'NC',
        default_timezone: 129,
        sort_order: 158
    },
    {
        id: 159,
        label: 'New Zealand',
        value: 'NZ',
        default_timezone: 131,
        sort_order: 159
    },
    {
        id: 160,
        label: 'Nicaragua',
        value: 'NI',
        default_timezone: 14,
        sort_order: 160
    },
    {
        id: 161,
        label: 'Niger',
        value: 'NE',
        default_timezone: 55,
        sort_order: 161
    },
    {
        id: 162,
        label: 'Nigeria',
        value: 'NG',
        default_timezone: 55,
        sort_order: 162
    },
    {
        id: 163,
        label: 'Niue',
        value: 'NU',
        default_timezone: 2,
        sort_order: 163
    },
    {
        id: 164,
        label: 'Norfolk Island',
        value: 'NF',
        default_timezone: 129,
        sort_order: 164
    },
    {
        id: 165,
        label: 'Northern Mariana Islands',
        value: 'MP',
        default_timezone: 120,
        sort_order: 165
    },
    {
        id: 166,
        label: 'Norway',
        value: 'NO',
        default_timezone: 51,
        sort_order: 166
    },
    {
        id: 167,
        label: 'Oman',
        value: 'OM',
        default_timezone: 77,
        sort_order: 167
    },
    {
        id: 168,
        label: 'Pakistan',
        value: 'PK',
        default_timezone: 89,
        sort_order: 168
    },
    {
        id: 169,
        label: 'Palau',
        value: 'PW',
        default_timezone: 112,
        sort_order: 169
    },
    {
        id: 170,
        label: 'Palestine, State of',
        value: 'PS',
        default_timezone: 59,
        sort_order: 170
    },
    {
        id: 171,
        label: 'Panama',
        value: 'PA',
        default_timezone: 19,
        sort_order: 171
    },
    {
        id: 172,
        label: 'Papua New Guinea',
        value: 'PG',
        default_timezone: 120,
        sort_order: 172
    },
    {
        id: 173,
        label: 'Paraguay',
        value: 'PY',
        default_timezone: 26,
        sort_order: 173
    },
    {
        id: 174,
        label: 'Peru',
        value: 'PE',
        default_timezone: 19,
        sort_order: 174
    },
    {
        id: 175,
        label: 'Philippines',
        value: 'PH',
        default_timezone: 106,
        sort_order: 175
    },
    {
        id: 176,
        label: 'Pitcairn',
        value: 'PN',
        default_timezone: 10,
        sort_order: 176
    },
    {
        id: 177,
        label: 'Poland',
        value: 'PL',
        default_timezone: 54,
        sort_order: 177
    },
    {
        id: 178,
        label: 'Portugal',
        value: 'PT',
        default_timezone: 47,
        sort_order: 178
    },
    {
        id: 179,
        label: 'Puerto Rico',
        value: 'PR',
        default_timezone: 30,
        sort_order: 179
    },
    {
        id: 180,
        label: 'Qatar',
        value: 'QA',
        default_timezone: 72,
        sort_order: 180
    },
    {
        id: 181,
        label: "R\xe9union",
        value: 'RE',
        default_timezone: 81,
        sort_order: 181
    },
    {
        id: 182,
        label: 'Romania',
        value: 'RO',
        default_timezone: 57,
        sort_order: 182
    },
    {
        id: 183,
        label: 'Russian Federation',
        value: 'RU',
        default_timezone: 74,
        sort_order: 183
    },
    {
        id: 184,
        label: 'Rwanda',
        value: 'RW',
        default_timezone: 63,
        sort_order: 184
    },
    {
        id: 185,
        label: "Saint Barth\xe9lemy",
        value: 'BL',
        default_timezone: 30,
        sort_order: 185
    },
    {
        id: 186,
        label: 'Saint Helena, Ascension and Tristan da Cunha',
        value: 'SH',
        default_timezone: 48,
        sort_order: 186
    },
    {
        id: 187,
        label: 'Saint Kitts and Nevis',
        value: 'KN',
        default_timezone: 30,
        sort_order: 187
    },
    {
        id: 188,
        label: 'Saint Lucia',
        value: 'LC',
        default_timezone: 30,
        sort_order: 188
    },
    {
        id: 189,
        label: 'Saint Martin (French part)',
        value: 'MF',
        default_timezone: 30,
        sort_order: 189
    },
    {
        id: 190,
        label: 'Saint Pierre and Miquelon',
        value: 'PM',
        default_timezone: 37,
        sort_order: 190
    },
    {
        id: 191,
        label: 'Saint Vincent and the Grenadines',
        value: 'VC',
        default_timezone: 30,
        sort_order: 191
    },
    {
        id: 192,
        label: 'Samoa',
        value: 'WS',
        default_timezone: 138,
        sort_order: 192
    },
    {
        id: 193,
        label: 'San Marino',
        value: 'SM',
        default_timezone: 51,
        sort_order: 193
    },
    {
        id: 194,
        label: 'Sao Tome and Principe',
        value: 'ST',
        default_timezone: 48,
        sort_order: 194
    },
    {
        id: 195,
        label: 'Saudi Arabia',
        value: 'SA',
        default_timezone: 72,
        sort_order: 195
    },
    {
        id: 196,
        label: 'Senegal',
        value: 'SN',
        default_timezone: 48,
        sort_order: 196
    },
    {
        id: 197,
        label: 'Serbia',
        value: 'RS',
        default_timezone: 52,
        sort_order: 197
    },
    {
        id: 198,
        label: 'Seychelles',
        value: 'SC',
        default_timezone: 81,
        sort_order: 198
    },
    {
        id: 199,
        label: 'Sierra Leone',
        value: 'SL',
        default_timezone: 48,
        sort_order: 199
    },
    {
        id: 200,
        label: 'Singapore',
        value: 'SG',
        default_timezone: 106,
        sort_order: 200
    },
    {
        id: 201,
        label: 'Sint Maarten (Dutch part)',
        value: 'SX',
        default_timezone: 30,
        sort_order: 201
    },
    {
        id: 202,
        label: 'Slovakia',
        value: 'SK',
        default_timezone: 52,
        sort_order: 202
    },
    {
        id: 203,
        label: 'Slovenia',
        value: 'SI',
        default_timezone: 52,
        sort_order: 203
    },
    {
        id: 204,
        label: 'Solomon Islands',
        value: 'SB',
        default_timezone: 129,
        sort_order: 204
    },
    {
        id: 205,
        label: 'Somalia',
        value: 'SO',
        default_timezone: 75,
        sort_order: 205
    },
    {
        id: 206,
        label: 'South Africa',
        value: 'ZA',
        default_timezone: 63,
        sort_order: 206
    },
    {
        id: 207,
        label: 'South Georgia and the South Sandwich Islands',
        value: 'GS',
        default_timezone: 42,
        sort_order: 207
    },
    {
        id: 208,
        label: 'South Sudan',
        value: 'SS',
        default_timezone: 75,
        sort_order: 208
    },
    {
        id: 209,
        label: 'Spain',
        value: 'ES',
        default_timezone: 53,
        sort_order: 209
    },
    {
        id: 210,
        label: 'Sri Lanka',
        value: 'LK',
        default_timezone: 92,
        sort_order: 210
    },
    {
        id: 211,
        label: 'Sudan',
        value: 'SD',
        default_timezone: 75,
        sort_order: 211
    },
    {
        id: 212,
        label: 'Suriname',
        value: 'SR',
        default_timezone: 35,
        sort_order: 212
    },
    {
        id: 213,
        label: 'Svalbard and Jan Mayen',
        value: 'SJ',
        default_timezone: 51,
        sort_order: 213
    },
    {
        id: 214,
        label: 'Swaziland',
        value: 'SZ',
        default_timezone: 63,
        sort_order: 214
    },
    {
        id: 215,
        label: 'Sweden',
        value: 'SE',
        default_timezone: 51,
        sort_order: 215
    },
    {
        id: 216,
        label: 'Switzerland',
        value: 'CH',
        default_timezone: 51,
        sort_order: 216
    },
    {
        id: 217,
        label: 'Syrian Arab Republic',
        value: 'SY',
        default_timezone: 61,
        sort_order: 217
    },
    {
        id: 218,
        label: 'Taiwan, Province of China',
        value: 'TW',
        default_timezone: 108,
        sort_order: 218
    },
    {
        id: 219,
        label: 'Tajikistan',
        value: 'TJ',
        default_timezone: 87,
        sort_order: 219
    },
    {
        id: 220,
        label: 'Tanzania, United Republic of',
        value: 'TZ',
        default_timezone: 75,
        sort_order: 220
    },
    {
        id: 221,
        label: 'Thailand',
        value: 'TH',
        default_timezone: 98,
        sort_order: 221
    },
    {
        id: 222,
        label: 'Timor-Leste',
        value: 'TL',
        default_timezone: 112,
        sort_order: 222
    },
    {
        id: 223,
        label: 'Togo',
        value: 'TG',
        default_timezone: 48,
        sort_order: 223
    },
    {
        id: 224,
        label: 'Tokelau',
        value: 'TK',
        default_timezone: 137,
        sort_order: 224
    },
    {
        id: 225,
        label: 'Tonga',
        value: 'TO',
        default_timezone: 137,
        sort_order: 225
    },
    {
        id: 226,
        label: 'Trinidad and Tobago',
        value: 'TT',
        default_timezone: 30,
        sort_order: 226
    },
    {
        id: 227,
        label: 'Tunisia',
        value: 'TN',
        default_timezone: 55,
        sort_order: 227
    },
    {
        id: 228,
        label: 'Turkey',
        value: 'TR',
        default_timezone: 71,
        sort_order: 228
    },
    {
        id: 229,
        label: 'Turkmenistan',
        value: 'TM',
        default_timezone: 87,
        sort_order: 229
    },
    {
        id: 230,
        label: 'Turks and Caicos Islands',
        value: 'TC',
        default_timezone: 21,
        sort_order: 230
    },
    {
        id: 231,
        label: 'Tuvalu',
        value: 'TV',
        default_timezone: 132,
        sort_order: 231
    },
    {
        id: 232,
        label: 'Uganda',
        value: 'UG',
        default_timezone: 75,
        sort_order: 232
    },
    {
        id: 233,
        label: 'Ukraine',
        value: 'UA',
        default_timezone: 64,
        sort_order: 233
    },
    {
        id: 234,
        label: 'United Arab Emirates',
        value: 'AE',
        default_timezone: 77,
        sort_order: 234
    },
    {
        id: 235,
        label: 'United Kingdom',
        value: 'UK',
        default_timezone: 47,
        sort_order: 235
    },
    {
        id: 236,
        label: 'United States',
        value: 'US',
        default_timezone: 10,
        sort_order: 236
    },
    {
        id: 237,
        label: 'United States Minor Outlying Islands',
        value: 'UM',
        default_timezone: 2,
        sort_order: 237
    },
    {
        id: 238,
        label: 'Uruguay',
        value: 'UY',
        default_timezone: 38,
        sort_order: 238
    },
    {
        id: 239,
        label: 'Uzbekistan',
        value: 'UZ',
        default_timezone: 87,
        sort_order: 239
    },
    {
        id: 240,
        label: 'Vanuatu',
        value: 'VU',
        default_timezone: 129,
        sort_order: 240
    },
    {
        id: 241,
        label: 'Venezuela, Bolivarian Republic of',
        value: 'VE',
        default_timezone: 28,
        sort_order: 241
    },
    {
        id: 242,
        label: 'Viet Nam',
        value: 'VN',
        default_timezone: 98,
        sort_order: 242
    },
    {
        id: 243,
        label: 'Virgin Islands, British',
        value: 'VG',
        default_timezone: 30,
        sort_order: 243
    },
    {
        id: 244,
        label: 'Virgin Islands, U.S.',
        value: 'VI',
        default_timezone: 30,
        sort_order: 244
    },
    {
        id: 245,
        label: 'Wallis and Futuna',
        value: 'WF',
        default_timezone: 132,
        sort_order: 245
    },
    {
        id: 246,
        label: 'Western Sahara',
        value: 'EH',
        default_timezone: 55,
        sort_order: 246
    },
    {
        id: 247,
        label: 'Yemen',
        value: 'YE',
        default_timezone: 72,
        sort_order: 247
    },
    {
        id: 248,
        label: 'Zambia',
        value: 'ZM',
        default_timezone: 63,
        sort_order: 248
    },
    {
        id: 249,
        label: 'Zimbabwe',
        value: 'ZW',
        default_timezone: 63,
        sort_order: 249
    }
];







const $eeb0130f69d5f5f9$export$ac7496df4f1f837a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 100%;

  & form {
    height: 100%;
  }
`;
const $eeb0130f69d5f5f9$export$f06621d9ad29af97 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;

  width: 100%;
  height: 100%;
  max-height: 80vh;
  overflow-y: auto;
`;
const $eeb0130f69d5f5f9$export$e151f1d86035b485 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $eeb0130f69d5f5f9$export$71c7816ee3a5a527 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h1`
  margin: 0;
  font-size: 20px;
  font-weight: 500;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $eeb0130f69d5f5f9$export$f4d831db7f57f05 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  text-align: center;
  color: ${({ theme: theme })=>theme.colors.brand};
`;
const $eeb0130f69d5f5f9$export$942b2219c902021e = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  text-align: center;
  color: ${({ theme: theme })=>theme.colors.red};
`;
const $eeb0130f69d5f5f9$export$ae4fd97bdbe491c1 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  text-align: center;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $eeb0130f69d5f5f9$export$97ee2cbf37e5ebfe = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 0 20px 0;
`;
const $eeb0130f69d5f5f9$export$e7277fd05612133d = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  padding: 20px 0 0 0;
  gap: 20px;
`;
const $eeb0130f69d5f5f9$export$fd2299f554be8993 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: 1fr 25px;
  gap: 50px;
  align-items: center;

  padding: 10px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $eeb0130f69d5f5f9$export$9f515a68dfaeb9ef = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  gap: 20px;
`;
const $eeb0130f69d5f5f9$export$85524e8d4e82fc69 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;



// Map Redux Props
const $0ed841cad82fe453$var$mapStateToProps = (state)=>state;
const $0ed841cad82fe453$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $0ed841cad82fe453$var$IndividualAccountForm(props) {
    // Destructure
    const { form: form, actions: actions } = props;
    // Hooks
    const [userCredentials] = (0, $a9c50ebe96619b20$export$2e2bcd8739ae039)('userCredentials');
    const { createAccountIndividual: createAccountIndividual, accountIndividualCreateData: accountIndividualCreateData, accountIndividualCreateError: accountIndividualCreateError, isAccountIndividualCreateLoading: isAccountIndividualCreateLoading, isAccountIndividualCreateSuccess: isAccountIndividualCreateSuccess } = (0, $29f36fafb5a1782d$export$2e2bcd8739ae039)();
    const { updateAccountIndividual: updateAccountIndividual, accountIndividualUpdateData: accountIndividualUpdateData, accountIndividualUpdateError: accountIndividualUpdateError, isAccountIndividualUpdateLoading: isAccountIndividualUpdateLoading, isAccountIndividualUpdateSuccess: isAccountIndividualUpdateSuccess } = (0, $ead9c70d2f240d34$export$2e2bcd8739ae039)();
    // Store State
    const { toBeUpdatedAccount: toBeUpdatedAccount } = form;
    // Store Actions
    const { setIsIndividualAccountDrawerOpen: setIsIndividualAccountDrawerOpen, setToBeUpdatedAccount: setToBeUpdatedAccount, showAlert: showAlert, setShowHeaderLoader: setShowHeaderLoader, setCreatedAccount: setCreatedAccount, setIsPageTableUpdated: setIsPageTableUpdated, setIsRecordUpdated: setIsRecordUpdated } = actions;
    // Internal State
    const [isCreateAccount, setIsCreateAccount] = (0, $tZqWC.useState)(true);
    const [initialData, setInitialData] = (0, $tZqWC.useState)();
    const [isFreeFormExpanded, setIsFreeFormExpanded] = (0, $tZqWC.useState)(true);
    const [isStructuredExpanded, setIsStructuredExpanded] = (0, $tZqWC.useState)(false);
    const [isNationalIDExpanded, setIsNationalIDExpanded] = (0, $tZqWC.useState)(false);
    // Variables
    const formRef = (0, $tZqWC.useRef)();
    const initialValues = {
        reference_id: '',
        customer_id: '',
        is_customer: undefined,
        email: '',
        name_first: '',
        name_middle: '',
        name_last: '',
        date_of_birth: '',
        place_of_birth: '',
        nationality_country_code: '',
        address_line: '',
        address_street_no: '',
        address_street_name: '',
        address_building_name: '',
        address_floor: '',
        address_room: '',
        address_department: '',
        address_postbox: '',
        address_city_location: '',
        address_city: '',
        address_region: '',
        address_district: '',
        address_postcode: '',
        address_country_code: '',
        national_id_type_code: '',
        national_id: '',
        national_id_issue_country: ''
    };
    const validationSchema = $84bdfb0f595586e8$export$185802fd694ee1f5().shape({
        reference_id: $7092ea25693c72ef$export$185802fd694ee1f5().max(50).required('Reference ID is required'),
        customer_id: $7092ea25693c72ef$export$185802fd694ee1f5().max(50).nullable().test('required-identifiers', 'Customer ID, Date & Place of Birth, National ID, or Address is required', (value, context)=>validateRequiredAccountFields(context)),
        email: $7092ea25693c72ef$export$185802fd694ee1f5().email().nullable(),
        name_first: $7092ea25693c72ef$export$185802fd694ee1f5().max(50).nullable(),
        name_middle: $7092ea25693c72ef$export$185802fd694ee1f5().max(50).nullable(),
        name_last: $7092ea25693c72ef$export$185802fd694ee1f5().max(50).required('Last Name is required'),
        is_customer: $b84f09f6970af0be$export$185802fd694ee1f5().required('Specify if account is a customer'),
        date_of_birth: $e039e5cb92bd30b2$export$185802fd694ee1f5().max(new Date(Date.now() - 567648000000), 'Must be atleast 18 years').nullable().test('required-identifiers', 'Customer ID, Date & Place of Birth, National ID, or Address is required', (value, context)=>validateRequiredAccountFields(context)).test('date_of_birth_with_place', 'Date of birth is required when place of birth is provided', (value, context)=>{
            const placeOfBirth = context.parent.place_of_birth;
            if (placeOfBirth && !value) return false // Fail if place is provided but date isn't
            ;
            return true;
        }),
        place_of_birth: $7092ea25693c72ef$export$185802fd694ee1f5().max(50).nullable().test('required-identifiers', 'Customer ID, Date & Place of Birth, National ID, or Address is required', (value, context)=>validateRequiredAccountFields(context)).test('place_of_birth_with_date', 'Place of birth is required when date of birth is provided', (value, context)=>{
            const dateOfBirth = context.parent.date_of_birth;
            if (dateOfBirth && !value) return false // Fail if date is provided but place isn't
            ;
            return true;
        }),
        nationality_country_code: $7092ea25693c72ef$export$185802fd694ee1f5().max(2).nullable(),
        address_line: $7092ea25693c72ef$export$185802fd694ee1f5().max(256).nullable().test('required-identifiers', 'Customer ID, Date & Place of Birth, National ID, or Address is required', (value, context)=>validateRequiredAccountFields(context)).test('address_line', 'Required if street number, street name, and building name are not specified', (value, context)=>hasRequiredAddressFields(context)),
        address_street_no: $7092ea25693c72ef$export$185802fd694ee1f5().max(10).nullable().test('required-identifiers', 'Customer ID, Date & Place of Birth, National ID, or Address is required', (value, context)=>validateRequiredAccountFields(context)).test('address_street_no', 'Required with street name if address line is not specified', (value, context)=>hasRequiredAddressFields(context)),
        address_street_name: $7092ea25693c72ef$export$185802fd694ee1f5().max(100).nullable().test('required-identifiers', 'Customer ID, Date & Place of Birth, National ID, or Address is required', (value, context)=>validateRequiredAccountFields(context)).test('address_street_name', 'Required with building name if address line is not specified', (value, context)=>hasRequiredAddressFields(context)),
        address_building_name: $7092ea25693c72ef$export$185802fd694ee1f5().max(20).nullable().test('required-identifiers', 'Customer ID, Date & Place of Birth, National ID, or Address is required', (value, context)=>validateRequiredAccountFields(context)).test('address_building_name', 'Required with street name if address line is not specified', (value, context)=>hasRequiredAddressFields(context)),
        address_floor: $7092ea25693c72ef$export$185802fd694ee1f5().max(20).nullable(),
        address_room: $7092ea25693c72ef$export$185802fd694ee1f5().max(20).nullable(),
        address_department: $7092ea25693c72ef$export$185802fd694ee1f5().max(20).nullable(),
        address_postbox: $7092ea25693c72ef$export$185802fd694ee1f5().max(20).nullable(),
        address_city_location: $7092ea25693c72ef$export$185802fd694ee1f5().max(50).nullable(),
        address_city: $7092ea25693c72ef$export$185802fd694ee1f5().max(50).nullable().test('address_city', 'Required if address is provided', (value, context)=>hasAddress(value, context)),
        address_region: $7092ea25693c72ef$export$185802fd694ee1f5().max(50).nullable(),
        address_district: $7092ea25693c72ef$export$185802fd694ee1f5().max(50).nullable(),
        address_postcode: $7092ea25693c72ef$export$185802fd694ee1f5().max(25).nullable(),
        address_country_code: $7092ea25693c72ef$export$185802fd694ee1f5().max(2).nullable().test('address_country_code', 'Required if address is provided', (value, context)=>hasAddress(value, context)),
        national_id_type_code: $7092ea25693c72ef$export$185802fd694ee1f5().max(10).nullable().test('required-identifiers', 'Customer ID, Date & Place of Birth, National ID, or Address is required', (value, context)=>validateRequiredAccountFields(context)).test('national_id_type_required', 'ID Type is required when National ID or Country Issuer is provided', (value, context)=>{
            const hasNationalId = Boolean(context.parent.national_id);
            const hasIssueCountry = Boolean(context.parent.national_id_issue_country);
            // If any other National ID fields are provided, this field is required
            if ((hasNationalId || hasIssueCountry) && !value) return false;
            return true;
        }),
        national_id: $7092ea25693c72ef$export$185802fd694ee1f5().max(35).nullable().test('required-identifiers', 'Customer ID, Date & Place of Birth, National ID, or Address is required', (value, context)=>validateRequiredAccountFields(context)).test('national_id_required', 'National ID is required when ID Type or Country Issuer is provided', (value, context)=>{
            const hasIdType = Boolean(context.parent.national_id_type_code);
            const hasIssueCountry = Boolean(context.parent.national_id_issue_country);
            // If any other National ID fields are provided, this field is required
            if ((hasIdType || hasIssueCountry) && !value) return false;
            return true;
        }),
        national_id_issue_country: $7092ea25693c72ef$export$185802fd694ee1f5().max(2).nullable()
    });
    // Functions
    const triggerSubmit = ()=>{
        formRef.current.submitForm();
    };
    const handleOnSubmit = (values)=>{
        // Create a copy of values to modify
        const formValues = {
            ...values
        };
        // Check if any address fields are filled
        const hasAddressLine = Boolean(formValues.address_line);
        const hasStreetNo = Boolean(formValues.address_street_no);
        const hasStreetName = Boolean(formValues.address_street_name);
        const hasBuildingName = Boolean(formValues.address_building_name);
        // If any core address fields are provided, add address_type = 'GEOG'
        const hasAddress = hasAddressLine || hasStreetName && (hasStreetNo || hasBuildingName);
        if (hasAddress) formValues.address_type_code = 'GEOG';
        const payload = {
            biz_id: userCredentials.Business_ID,
            ...formValues
        };
        // removing empty fields on object
        Object.keys(payload).forEach((k)=>payload[k] === '' && delete payload[k]);
        if (isCreateAccount) createAccountIndividual(payload);
        else if (!isCreateAccount) updateAccountIndividual({
            account_id: toBeUpdatedAccount.id,
            values: payload
        });
    };
    const handleLoadingChange = ()=>{
        if (isAccountIndividualCreateLoading || isAccountIndividualUpdateLoading) setShowHeaderLoader(true);
        if (!isAccountIndividualCreateLoading && !isAccountIndividualUpdateLoading) {
            setShowHeaderLoader(false);
            if (initialData) {
                if (isCreateAccount) {
                    if (isAccountIndividualCreateSuccess) {
                        setCreatedAccount(accountIndividualCreateData);
                        setIsIndividualAccountDrawerOpen(false);
                        setIsPageTableUpdated(true);
                        showAlert({
                            type: 'success',
                            message: 'Successfully created record'
                        });
                    } else if (!isAccountIndividualCreateSuccess) {
                        if (typeof accountIndividualCreateError?.response?.data?.data === 'string') {
                            showAlert({
                                type: 'error',
                                message: accountIndividualCreateError?.response?.data?.data
                            });
                            return;
                        }
                        showAlert({
                            type: 'error',
                            message: 'An error occurred in creating record'
                        });
                    }
                } else if (!isCreateAccount) {
                    if (isAccountIndividualUpdateSuccess) {
                        setCreatedAccount(accountIndividualUpdateData);
                        setToBeUpdatedAccount(null);
                        setIsIndividualAccountDrawerOpen(false);
                        setIsRecordUpdated(true);
                        showAlert({
                            type: 'success',
                            message: 'Successfully updated record'
                        });
                    } else if (!isAccountIndividualUpdateSuccess) {
                        if (typeof accountIndividualUpdateError?.response?.data?.data === 'string') {
                            showAlert({
                                type: 'error',
                                message: accountIndividualUpdateError?.response?.data?.data
                            });
                            return;
                        }
                        showAlert({
                            type: 'error',
                            message: 'An error occurred in updating record'
                        });
                    }
                }
            }
        }
    };
    function hasRequiredAddressFields(context) {
        const parent = context?.parent;
        /*
      If the form already has required account fields
      (date and place of birth, customer id, or national id),
      skip required address fields validation
    */ const hasRequiredAccountFields = validateRequiredAccountFields(context);
        if (hasRequiredAccountFields) return true;
        // Check if any address fields are filled
        const hasAddressLine = Boolean(parent?.address_line);
        const hasStreetNo = Boolean(parent?.address_street_no);
        const hasBuildingName = Boolean(parent?.address_building_name);
        const hasStreetName = Boolean(parent?.address_street_name);
        const hasAddress = hasAddressLine || hasStreetName && (hasStreetNo || hasBuildingName);
        return hasAddress;
    }
    function hasAddress(value, context) {
        const parent = context?.parent;
        // Check if any address fields are filled
        const hasAddressLine = Boolean(parent?.address_line);
        const hasStreetNo = Boolean(parent?.address_street_no);
        const hasBuildingName = Boolean(parent?.address_building_name);
        const hasStreetName = Boolean(parent?.address_street_name);
        // If no address info is provided, value is optional
        if (!hasAddressLine && !hasStreetNo && !hasStreetName && !hasBuildingName) return true;
        // If we have validated address information, value is required
        return Boolean(value);
    }
    /*
    Validates if at least one of:
    - Date and Place of Birth
    - National ID
    - Address
    - Customer ID
    is provided.

    If an attempt to provide one of these identifiers is made,
    even if the identifier is incomplete
    (e.g. specifying incomplete address, national ID, or date and place of birth),
    the validation will pass.
  */ function validateRequiredAccountFields(context) {
        const parent = context?.parent;
        // Check if at least date or place of birth is provided
        // The validation here is more relaxed, since we also require the other field if one is provided
        const hasDateOfBirth = Boolean(parent?.date_of_birth);
        const hasPlaceOfBirth = Boolean(parent?.place_of_birth);
        const hasBirthInfo = hasDateOfBirth || hasPlaceOfBirth;
        // Check if any national ID fields are provided
        // The validation here is more relaxed, since we also require the other field if one is provided
        const hasNationalIdType = Boolean(parent?.national_id_type_code);
        const hasNationalID = Boolean(parent?.national_id);
        const hasNationalIDIssueCountry = Boolean(parent?.national_id_issue_country);
        const hasNationalIDInfo = hasNationalIdType || hasNationalID || hasNationalIDIssueCountry;
        // Check if customer ID is provided
        const hasCustomerID = Boolean(parent?.customer_id);
        // Check if any required address is provided
        const hasAddressLine = Boolean(parent?.address_line);
        const hasStreetNo = Boolean(parent?.address_street_no);
        const hasStreetName = Boolean(parent?.address_street_name);
        const hasBuildingName = Boolean(parent?.address_building_name);
        const hasAddress = hasAddressLine || hasStreetName || hasStreetNo || hasBuildingName;
        // Return true if at least one identifier method is provided
        return hasBirthInfo || hasNationalIDInfo || hasAddress || hasCustomerID;
    }
    // UseEffects
    (0, $tZqWC.useEffect)(()=>{
        if (!toBeUpdatedAccount) {
            setIsCreateAccount(true);
            // TODO REMOVE HARD CODED VALUE
            setInitialData({
                ...initialValues,
                address_type_code: 'GEOG'
            });
            setInitialData(initialValues);
        } else {
            setIsCreateAccount(false);
            setInitialData({
                ...toBeUpdatedAccount,
                address_type_code: 'GEOG'
            });
        }
    }, []);
    (0, $tZqWC.useEffect)(()=>handleLoadingChange(), [
        isAccountIndividualCreateLoading,
        isAccountIndividualUpdateLoading
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$ac7496df4f1f837a), {
        children: initialData && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $506ef65bbb4994b7$export$2e2bcd8739ae039), {
            formRef: formRef,
            initialValues: initialData,
            validationSchema: validationSchema,
            onSubmit: handleOnSubmit,
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $eeb0130f69d5f5f9$export$97ee2cbf37e5ebfe), {
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$71c7816ee3a5a527), {
                            children: isCreateAccount ? 'Create Individual Account' : 'Edit Individual Account'
                        }),
                        (accountIndividualCreateError || accountIndividualUpdateData) && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$942b2219c902021e), {
                            children: accountIndividualCreateError?.response?.data?.message || accountIndividualUpdateData?.response?.data?.message
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $eeb0130f69d5f5f9$export$f06621d9ad29af97), {
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                label: "Reference ID*",
                                name: "reference_id"
                            })
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                label: "Customer ID*",
                                name: "customer_id"
                            })
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $99b5eccf8ae49d07$export$2e2bcd8739ae039), {
                                label: "Is Customer*",
                                name: "is_customer",
                                options: (0, $f398806f8c37b1c3$export$d631eb4fd6125e2b)
                            })
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                label: "Email",
                                type: "email",
                                name: "email"
                            })
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                label: "First Name",
                                name: "name_first"
                            })
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                label: "Middle Name",
                                name: "name_middle"
                            })
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                label: "Last Name*",
                                name: "name_last"
                            })
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a5484141b8231e9a$export$2e2bcd8739ae039), {
                                label: "Birthdate",
                                name: "date_of_birth"
                            })
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                label: "Place of Birth",
                                name: "place_of_birth"
                            })
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6e833112b656c531$export$2e2bcd8739ae039), {
                                label: "Nationality",
                                name: "nationality_country_code",
                                options: (0, $735b35f584baaf3c$export$df7943177b16f2f3)
                            })
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b3f7dc6528742bb0$export$2e2bcd8739ae039), {
                            style: {
                                marginTop: '20px'
                            },
                            setIsExpanded: setIsStructuredExpanded,
                            expandPanel: isStructuredExpanded,
                            button: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$fd2299f554be8993), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$9f515a68dfaeb9ef), {
                                    isExpanded: isStructuredExpanded,
                                    children: "Structured Address (preferred)"
                                })
                            }),
                            panel: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $eeb0130f69d5f5f9$export$85524e8d4e82fc69), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                            label: "Street Number*",
                                            name: "address_street_no"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                            label: "Street Name*",
                                            name: "address_street_name"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                            label: "Building Name",
                                            name: "address_building_name"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                            label: "Floor",
                                            name: "address_floor"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                            label: "Room",
                                            name: "address_room"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                            label: "Department",
                                            name: "address_department"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                            label: "Postbox",
                                            name: "address_postbox"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                            label: "City Location",
                                            name: "address_city_location"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                            label: "City*",
                                            name: "address_city"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                            label: "Region",
                                            name: "address_region"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                            label: "District",
                                            name: "address_district"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                            label: "Zipcode",
                                            name: "address_postcode"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6e833112b656c531$export$2e2bcd8739ae039), {
                                            label: "Country*",
                                            name: "address_country_code",
                                            options: (0, $735b35f584baaf3c$export$df7943177b16f2f3)
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b3f7dc6528742bb0$export$2e2bcd8739ae039), {
                            style: {
                                marginTop: '20px'
                            },
                            setIsExpanded: (val)=>{
                                setIsFreeFormExpanded(val);
                            },
                            expandPanel: isFreeFormExpanded,
                            button: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$fd2299f554be8993), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$9f515a68dfaeb9ef), {
                                    isExpanded: isFreeFormExpanded,
                                    children: "Free Form Address"
                                })
                            }),
                            panel: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $eeb0130f69d5f5f9$export$85524e8d4e82fc69), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $dfc171aac0fd6ec5$export$2e2bcd8739ae039), {
                                            label: "Address Line",
                                            name: "address_line"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                            label: "City",
                                            name: "address_city"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6e833112b656c531$export$2e2bcd8739ae039), {
                                            label: "Country",
                                            name: "address_country_code",
                                            options: (0, $735b35f584baaf3c$export$df7943177b16f2f3)
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b3f7dc6528742bb0$export$2e2bcd8739ae039), {
                            style: {
                                marginTop: '20px'
                            },
                            setIsExpanded: (val)=>{
                                setIsNationalIDExpanded(val);
                            },
                            expandPanel: isNationalIDExpanded,
                            button: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$fd2299f554be8993), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$9f515a68dfaeb9ef), {
                                    isExpanded: isNationalIDExpanded,
                                    children: "National ID"
                                })
                            }),
                            panel: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $eeb0130f69d5f5f9$export$85524e8d4e82fc69), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $99b5eccf8ae49d07$export$2e2bcd8739ae039), {
                                            label: "National ID Type",
                                            name: "national_id_type_code",
                                            options: (0, $f398806f8c37b1c3$export$81d62d4c398740e0)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                            label: "National ID",
                                            name: "national_id"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $99b5eccf8ae49d07$export$2e2bcd8739ae039), {
                                            label: "National ID Country Issuer",
                                            name: "national_id_issue_country",
                                            options: (0, $735b35f584baaf3c$export$df7943177b16f2f3)
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e7277fd05612133d), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                        type: "button",
                        onClick: triggerSubmit,
                        children: isCreateAccount ? 'Create Individual Account' : 'Save Individual Account'
                    })
                })
            ]
        })
    });
}
// Default Props
$0ed841cad82fe453$var$IndividualAccountForm.defaultProps = {
    formRef: {},
    form: {},
    actions: {}
};
// Proptypes Validation
$0ed841cad82fe453$var$IndividualAccountForm.propTypes = {
    formRef: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        root: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    }),
    form: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        COUNTRIES_LIST: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Array),
        toBeUpdatedAccount: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
        })
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setCountryListOptions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsIndividualAccountDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setToBeUpdatedAccount: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setCreatedAccount: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsRecordUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $0ed841cad82fe453$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($0ed841cad82fe453$var$mapStateToProps, $0ed841cad82fe453$var$mapDispatchToProps)($0ed841cad82fe453$var$IndividualAccountForm);


var $4baf9c62a5e83223$export$2e2bcd8739ae039 = (0, $0ed841cad82fe453$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");


var $4L3zM = parcelRequire("4L3zM");








// Map Redux Props
const $13e515d9270dd94e$var$mapStateToProps = (state)=>state;
const $13e515d9270dd94e$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $13e515d9270dd94e$var$EntityAccountForm(props) {
    // Destructure
    const { form: form, actions: actions } = props;
    // Hooks
    const [userCredentials] = (0, $a9c50ebe96619b20$export$2e2bcd8739ae039)('userCredentials');
    const { createAccountEntity: createAccountEntity, accountEntityCreateData: accountEntityCreateData, accountEntityCreateError: accountEntityCreateError, isAccountEntityCreateLoading: isAccountEntityCreateLoading, isAccountEntityCreateSuccess: isAccountEntityCreateSuccess } = (0, $e5d00bc69bf8a3af$export$2e2bcd8739ae039)();
    const { updateAccountEntity: updateAccountEntity, accountEntityUpdateData: accountEntityUpdateData, accountEntityUpdateError: accountEntityUpdateError, isAccountEntityUpdateLoading: isAccountEntityUpdateLoading, isAccountEntityUpdateSuccess: isAccountEntityUpdateSuccess } = (0, $d50484ab2e32d4d8$export$2e2bcd8739ae039)();
    // Store State
    const { toBeUpdatedAccount: toBeUpdatedAccount } = form;
    // Store Actions
    const { setIsEntityAccountDrawerOpen: setIsEntityAccountDrawerOpen, setToBeUpdatedAccount: setToBeUpdatedAccount, showAlert: showAlert, setShowHeaderLoader: setShowHeaderLoader, setCreatedAccount: setCreatedAccount, setIsPageTableUpdated: setIsPageTableUpdated, setIsRecordUpdated: setIsRecordUpdated } = actions;
    // Internal State
    const [isCreateAccount, setIsCreateAccount] = (0, $tZqWC.useState)(true);
    const [initialData, setInitialData] = (0, $tZqWC.useState)();
    const [isFreeFormExpanded, setIsFreeFormExpanded] = (0, $tZqWC.useState)(true);
    const [isStructuredExpanded, setIsStructuredExpanded] = (0, $tZqWC.useState)(false);
    const [isNationalIDExpanded, setIsNationalIDExpanded] = (0, $tZqWC.useState)(false);
    // Variables
    const formRef = (0, $tZqWC.useRef)();
    const initialValues = {
        reference_id: '',
        customer_id: '',
        is_customer: undefined,
        email: '',
        name_legal: '',
        name_business: '',
        registration_country_code: '',
        address_line: '',
        address_street_no: '',
        address_street_name: '',
        address_building_name: '',
        address_floor: '',
        address_room: '',
        address_department: '',
        address_postbox: '',
        address_city_location: '',
        address_city: '',
        address_region: '',
        address_district: '',
        address_postcode: '',
        address_country_code: '',
        national_id_type_code: '',
        national_id: '',
        national_id_issue_country: '',
        national_id_registration_authority: ''
    };
    const validationSchema = $84bdfb0f595586e8$export$185802fd694ee1f5().shape({
        reference_id: $7092ea25693c72ef$export$185802fd694ee1f5().max(50).required('Reference ID is required'),
        customer_id: $7092ea25693c72ef$export$185802fd694ee1f5().max(50).nullable().test('required-identifiers', 'Customer ID, National ID, or Address is required', (value, context)=>validateRequiredAccountFields(context)),
        email: $7092ea25693c72ef$export$185802fd694ee1f5().email().nullable(),
        name_legal: $7092ea25693c72ef$export$185802fd694ee1f5().max(100).required('Legal Name is required'),
        name_business: $7092ea25693c72ef$export$185802fd694ee1f5().max(100).nullable(),
        is_customer: $b84f09f6970af0be$export$185802fd694ee1f5().required('Specify if account is a customer'),
        registration_country_code: $7092ea25693c72ef$export$185802fd694ee1f5().max(2).nullable(),
        address_line: $7092ea25693c72ef$export$185802fd694ee1f5().max(256).nullable().test('required-identifiers', 'Customer ID, National ID, or Address is required', (value, context)=>validateRequiredAccountFields(context)).test('address_line', 'Required if street number, street name, and building name are not specified', (value, context)=>hasRequiredAddressFields(context)),
        address_street_no: $7092ea25693c72ef$export$185802fd694ee1f5().max(10).nullable().test('required-identifiers', 'Customer ID, National ID, or Address is required', (value, context)=>validateRequiredAccountFields(context)).test('address_street_no', 'Required with street name if address line is not specified', (value, context)=>hasRequiredAddressFields(context)),
        address_street_name: $7092ea25693c72ef$export$185802fd694ee1f5().max(100).nullable().test('required-identifiers', 'Customer ID, National ID, or Address is required', (value, context)=>validateRequiredAccountFields(context)).test('address_street_name', 'Required with building name if address line is not specified', (value, context)=>hasRequiredAddressFields(context)),
        address_building_name: $7092ea25693c72ef$export$185802fd694ee1f5().max(20).nullable().test('required-identifiers', 'Customer ID, National ID, or Address is required', (value, context)=>validateRequiredAccountFields(context)).test('address_building_name', 'Required with street name if address line is not specified', (value, context)=>hasRequiredAddressFields(context)),
        address_floor: $7092ea25693c72ef$export$185802fd694ee1f5().max(20).nullable(),
        address_room: $7092ea25693c72ef$export$185802fd694ee1f5().max(20).nullable(),
        address_department: $7092ea25693c72ef$export$185802fd694ee1f5().max(20).nullable(),
        address_postbox: $7092ea25693c72ef$export$185802fd694ee1f5().max(20).nullable(),
        address_city_location: $7092ea25693c72ef$export$185802fd694ee1f5().max(50).nullable(),
        address_city: $7092ea25693c72ef$export$185802fd694ee1f5().max(50).nullable().test('address_city', 'Required if address fields are defined', (value, context)=>hasAddress(value, context)),
        address_region: $7092ea25693c72ef$export$185802fd694ee1f5().max(50).nullable(),
        address_district: $7092ea25693c72ef$export$185802fd694ee1f5().max(50).nullable(),
        address_postcode: $7092ea25693c72ef$export$185802fd694ee1f5().max(25).nullable(),
        address_country_code: $7092ea25693c72ef$export$185802fd694ee1f5().max(2).nullable().test('address_country_code', 'Required if address fields are defined', (value, context)=>hasAddress(value, context)),
        national_id_type_code: $7092ea25693c72ef$export$185802fd694ee1f5().max(10).nullable().test('required-identifiers', 'Customer ID, National ID, or Address is required', (value, context)=>validateRequiredAccountFields(context)).test('national_id_type_required', 'ID Type is required when National ID is provided', (value, context)=>{
            const hasNationalId = Boolean(context.parent.national_id);
            // If any other National ID fields are provided, this field is required
            if (hasNationalId && !value) return false;
            return true;
        }),
        national_id: $7092ea25693c72ef$export$185802fd694ee1f5().max(35).nullable().test('required-identifiers', 'Customer ID, National ID, or Address is required', (value, context)=>validateRequiredAccountFields(context)).test('national_id_required', 'National ID is required when ID Type is provided', (value, context)=>{
            const hasIdType = Boolean(context.parent.national_id_type_code);
            // If any other National ID fields are provided, this field is required
            if (hasIdType && !value) return false;
            return true;
        }),
        national_id_issue_country: $7092ea25693c72ef$export$185802fd694ee1f5().max(2).nullable().test('required-identifiers', 'Customer ID, National ID, or Address is required', (value, context)=>validateRequiredAccountFields(context)).test('issue_country_not_required', 'Country Issuer must not be specified for entity accounts', (value)=>{
            if (value) return false;
            return true;
        }),
        national_id_registration_authority: $7092ea25693c72ef$export$185802fd694ee1f5().max(10).nullable().test('required-identifiers', 'Customer ID, National ID, or Address is required', (value, context)=>validateRequiredAccountFields(context)).test('registration_authority_conditional', (value, context)=>{
            const idType = context.parent.national_id_type_code;
            // Skip validation if ID Type is not provided
            if (!idType) return true;
            // For LEIX type, registration authority must NOT be provided
            if (idType === 'LEIX') {
                if (value) return context.createError({
                    path: context.path,
                    message: 'Registration Authority must not be specified for national ID type "LEIX"'
                });
                return true;
            }
            // For all other ID types, registration authority is required
            if (!value) return context.createError({
                path: context.path,
                message: `Registration Authority is required for national ID type "${idType}"`
            });
            return true;
        })
    });
    // Functions
    const triggerSubmit = ()=>{
        formRef.current.submitForm();
    };
    const handleOnSubmit = (values)=>{
        // Create a copy of values to modify
        const formValues = {
            ...values
        };
        // Check if any address fields are filled
        const hasAddressLine = Boolean(formValues.address_line);
        const hasStreetNo = Boolean(formValues.address_street_no);
        const hasStreetName = Boolean(formValues.address_street_name);
        const hasBuildingName = Boolean(formValues.address_building_name);
        // If any core address fields are provided, add address_type = 'GEOG'
        const hasAddress = hasAddressLine || hasStreetName && (hasStreetNo || hasBuildingName);
        if (hasAddress) formValues.address_type_code = 'GEOG';
        const payload = {
            biz_id: userCredentials.Business_ID,
            ...formValues
        };
        // removing empty fields on object
        Object.keys(payload).forEach((k)=>payload[k] === '' && delete payload[k]);
        if (isCreateAccount) createAccountEntity(payload);
        else if (!isCreateAccount) updateAccountEntity({
            account_id: toBeUpdatedAccount.id,
            values: payload
        });
    };
    const handleLoadingChange = ()=>{
        if (isAccountEntityCreateLoading || isAccountEntityUpdateLoading) setShowHeaderLoader(true);
        if (!isAccountEntityCreateLoading && !isAccountEntityUpdateLoading) {
            setShowHeaderLoader(false);
            if (initialData) {
                if (isCreateAccount) {
                    if (isAccountEntityCreateSuccess) {
                        setCreatedAccount(accountEntityCreateData);
                        setIsEntityAccountDrawerOpen(false);
                        setIsPageTableUpdated(true);
                        showAlert({
                            type: 'success',
                            message: 'Successfully created record'
                        });
                    } else if (!isAccountEntityCreateSuccess) {
                        if (typeof accountEntityCreateError?.response?.data?.data === 'string') {
                            showAlert({
                                type: 'error',
                                message: accountEntityCreateError?.response?.data?.data
                            });
                            return;
                        }
                        showAlert({
                            type: 'error',
                            message: 'An error occurred in creating record'
                        });
                    }
                } else if (!isCreateAccount) {
                    if (isAccountEntityUpdateSuccess) {
                        setCreatedAccount(accountEntityUpdateData);
                        setToBeUpdatedAccount(null);
                        setIsEntityAccountDrawerOpen(false);
                        setIsRecordUpdated(true);
                        showAlert({
                            type: 'success',
                            message: 'Successfully updated record'
                        });
                    } else if (!isAccountEntityUpdateSuccess) {
                        if (typeof accountEntityUpdateError?.response?.data?.data === 'string') {
                            showAlert({
                                type: 'error',
                                message: accountEntityUpdateError?.response?.data?.data
                            });
                            return;
                        }
                        showAlert({
                            type: 'error',
                            message: 'An error occurred in updating record'
                        });
                    }
                }
            }
        }
    };
    function hasRequiredAddressFields(context) {
        const parent = context?.parent;
        /*
      If the form already has required account fields
      (date and place of birth, customer id, or national id),
      skip required address fields validation
    */ const hasRequiredAccountFields = validateRequiredAccountFields(context);
        if (hasRequiredAccountFields) return true;
        // Check if any address fields are filled
        const hasAddressLine = Boolean(parent?.address_line);
        const hasStreetNo = Boolean(parent?.address_street_no);
        const hasBuildingName = Boolean(parent?.address_building_name);
        const hasStreetName = Boolean(parent?.address_street_name);
        const hasAddress = hasAddressLine || hasStreetName && (hasStreetNo || hasBuildingName);
        return hasAddress;
    }
    function hasAddress(value, context) {
        const parent = context?.parent;
        // Check if any address fields are filled
        const hasAddressLine = Boolean(parent?.address_line);
        const hasStreetNo = Boolean(parent?.address_street_no);
        const hasBuildingName = Boolean(parent?.address_building_name);
        const hasStreetName = Boolean(parent?.address_street_name);
        // If no address info is provided, value is optional
        if (!hasAddressLine && !hasStreetNo && !hasStreetName && !hasBuildingName) return true;
        // If we have validated address information, value is required
        return Boolean(value);
    }
    /*
    Validates if at least one of:
    - National ID
    - Address
    - Customer ID
    is provided.

    If an attempt to provide one of these identifiers is made,
    even if the identifier is incomplete
    (e.g. specifying incomplete address, national ID, or date and place of birth),
    the validation will pass.
  */ function validateRequiredAccountFields(context) {
        const parent = context?.parent;
        // Check if any national ID fields are provided
        // The validation here is more relaxed, since we also require the other field if one is provided
        const hasNationalIdType = Boolean(parent?.national_id_type_code);
        const hasNationalID = Boolean(parent?.national_id);
        const hasNationalIDIssueCountry = Boolean(parent?.national_id_issue_country);
        const hasNationalIDRegistrationAuthority = Boolean(parent?.national_id_registration_authority);
        const hasNationalIDInfo = hasNationalID || hasNationalIdType || hasNationalIDIssueCountry || hasNationalIDRegistrationAuthority;
        // Check if customer ID is provided
        const hasCustomerID = Boolean(parent?.customer_id);
        // Check if any required address is provided
        const hasAddressLine = Boolean(parent?.address_line);
        const hasStreetNo = Boolean(parent?.address_street_no);
        const hasStreetName = Boolean(parent?.address_street_name);
        const hasBuildingName = Boolean(parent?.address_building_name);
        const hasAddress = hasAddressLine || hasStreetName || hasStreetNo || hasBuildingName;
        // Return true if at least one identifier method is provided
        return hasNationalIDInfo || hasAddress || hasCustomerID;
    }
    // UseEffects
    (0, $tZqWC.useEffect)(()=>{
        if (!toBeUpdatedAccount) {
            setIsCreateAccount(true);
            // TODO REMOVE HARD CODED VALUE
            setInitialData({
                ...initialValues,
                address_type_code: 'GEOG'
            });
            setInitialData(initialValues);
        } else {
            setIsCreateAccount(false);
            setInitialData({
                ...toBeUpdatedAccount,
                address_type_code: 'GEOG'
            });
        }
    }, []);
    (0, $tZqWC.useEffect)(()=>handleLoadingChange(), [
        isAccountEntityCreateLoading,
        isAccountEntityUpdateLoading
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$ac7496df4f1f837a), {
        children: initialData && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $506ef65bbb4994b7$export$2e2bcd8739ae039), {
            formRef: formRef,
            initialValues: initialData,
            validationSchema: validationSchema,
            onSubmit: handleOnSubmit,
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $eeb0130f69d5f5f9$export$97ee2cbf37e5ebfe), {
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$71c7816ee3a5a527), {
                            children: isCreateAccount ? 'Create Entity Account' : 'Edit Entity Account'
                        }),
                        (accountEntityCreateError || accountEntityUpdateData) && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$942b2219c902021e), {
                            children: accountEntityCreateError?.response?.data?.message || accountEntityUpdateData?.response?.data?.message
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $eeb0130f69d5f5f9$export$f06621d9ad29af97), {
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                label: "Reference ID e.g. ID0001",
                                name: "reference_id"
                            })
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                label: "Customer ID",
                                name: "customer_id"
                            })
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $99b5eccf8ae49d07$export$2e2bcd8739ae039), {
                                label: "Is Customer",
                                name: "is_customer",
                                options: (0, $f398806f8c37b1c3$export$d631eb4fd6125e2b)
                            })
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                label: "Email",
                                type: "email",
                                name: "email"
                            })
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                label: "Legal Name",
                                name: "name_legal"
                            })
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                label: "Business Name",
                                name: "name_business"
                            })
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6e833112b656c531$export$2e2bcd8739ae039), {
                                label: "Registration Country",
                                name: "registration_country_code",
                                options: (0, $735b35f584baaf3c$export$df7943177b16f2f3)
                            })
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b3f7dc6528742bb0$export$2e2bcd8739ae039), {
                            style: {
                                marginTop: '20px'
                            },
                            setIsExpanded: setIsStructuredExpanded,
                            expandPanel: isStructuredExpanded,
                            button: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$fd2299f554be8993), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$9f515a68dfaeb9ef), {
                                    isExpanded: isStructuredExpanded,
                                    children: "Structured Address (preferred)"
                                })
                            }),
                            panel: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $eeb0130f69d5f5f9$export$85524e8d4e82fc69), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                            label: "Street Number*",
                                            name: "address_street_no"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                            label: "Street Name*",
                                            name: "address_street_name"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                            label: "Building Name",
                                            name: "address_building_name"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                            label: "Floor",
                                            name: "address_floor"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                            label: "Room",
                                            name: "address_room"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                            label: "Department",
                                            name: "address_department"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                            label: "Postbox",
                                            name: "address_postbox"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                            label: "City Location",
                                            name: "address_city_location"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                            label: "City*",
                                            name: "address_city"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                            label: "Region",
                                            name: "address_region"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                            label: "District",
                                            name: "address_district"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                            label: "Zipcode",
                                            name: "address_postcode"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6e833112b656c531$export$2e2bcd8739ae039), {
                                            label: "Country*",
                                            name: "address_country_code",
                                            options: (0, $735b35f584baaf3c$export$df7943177b16f2f3)
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b3f7dc6528742bb0$export$2e2bcd8739ae039), {
                            style: {
                                marginTop: '20px'
                            },
                            setIsExpanded: (val)=>{
                                setIsFreeFormExpanded(val);
                            },
                            expandPanel: isFreeFormExpanded,
                            button: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$fd2299f554be8993), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$9f515a68dfaeb9ef), {
                                    isExpanded: isFreeFormExpanded,
                                    children: "Free Form Address"
                                })
                            }),
                            panel: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $eeb0130f69d5f5f9$export$85524e8d4e82fc69), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $dfc171aac0fd6ec5$export$2e2bcd8739ae039), {
                                            label: "Address Line",
                                            name: "address_line"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                            label: "City",
                                            name: "address_city"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6e833112b656c531$export$2e2bcd8739ae039), {
                                            label: "Country",
                                            name: "address_country_code",
                                            options: (0, $735b35f584baaf3c$export$df7943177b16f2f3)
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b3f7dc6528742bb0$export$2e2bcd8739ae039), {
                            style: {
                                marginTop: '20px'
                            },
                            setIsExpanded: (val)=>{
                                setIsNationalIDExpanded(val);
                            },
                            expandPanel: isNationalIDExpanded,
                            button: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$fd2299f554be8993), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$9f515a68dfaeb9ef), {
                                    isExpanded: isNationalIDExpanded,
                                    children: "National ID"
                                })
                            }),
                            panel: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $eeb0130f69d5f5f9$export$85524e8d4e82fc69), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $99b5eccf8ae49d07$export$2e2bcd8739ae039), {
                                            label: "National ID Type",
                                            name: "national_id_type_code",
                                            options: (0, $f398806f8c37b1c3$export$4f81732cc85b5d1d)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                            label: "National ID",
                                            name: "national_id"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                            label: "National ID Registration Authority",
                                            name: "national_id_registration_authority"
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e7277fd05612133d), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                        type: "button",
                        onClick: triggerSubmit,
                        children: isCreateAccount ? 'Create Entity Account' : 'Save Entity Account'
                    })
                })
            ]
        })
    });
}
// Default Props
$13e515d9270dd94e$var$EntityAccountForm.defaultProps = {
    formRef: {},
    form: {},
    actions: {}
};
// Proptypes Validation
$13e515d9270dd94e$var$EntityAccountForm.propTypes = {
    formRef: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        root: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    }),
    form: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        COUNTRIES_LIST: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Array),
        toBeUpdatedAccount: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
        })
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setCountryListOptions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsRecordUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsEntityAccountDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setToBeUpdatedAccount: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setCreatedAccount: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $13e515d9270dd94e$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($13e515d9270dd94e$var$mapStateToProps, $13e515d9270dd94e$var$mapDispatchToProps)($13e515d9270dd94e$var$EntityAccountForm);


var $ed8bd66562284064$export$2e2bcd8739ae039 = (0, $13e515d9270dd94e$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");


var $4L3zM = parcelRequire("4L3zM");








// Map Redux Props
const $dec5bce9738b22bd$var$mapStateToProps = (state)=>state;
const $dec5bce9738b22bd$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $dec5bce9738b22bd$var$VaspForm(props) {
    // Destructure
    const { form: form, actions: actions } = props;
    // Hooks
    const [userCredentials] = (0, $a9c50ebe96619b20$export$2e2bcd8739ae039)('userCredentials');
    const { createVasp: createVasp, vaspCreateData: vaspCreateData, isVaspCreateLoading: isVaspCreateLoading, isVaspCreateSuccess: isVaspCreateSuccess } = (0, $21aa17491474595c$export$2e2bcd8739ae039)();
    const { updateVasp: updateVasp, vaspUpdateData: vaspUpdateData, isVaspUpdateLoading: isVaspUpdateLoading, isVaspUpdateSuccess: isVaspUpdateSuccess } = (0, $05f6f04b561b761e$export$2e2bcd8739ae039)();
    // Store State
    const { toBeUpdatedVasp: toBeUpdatedVasp } = form;
    // Store Actions
    const { setIsVaspDrawerOpen: setIsVaspDrawerOpen, setToBeUpdatedVasp: setToBeUpdatedVasp, showAlert: showAlert, setShowHeaderLoader: setShowHeaderLoader, setCreatedVasp: setCreatedVasp, setIsPageTableUpdated: setIsPageTableUpdated, setIsRecordUpdated: setIsRecordUpdated } = actions;
    // Internal State
    const [isCreateVasp, setIsCreateVasp] = (0, $tZqWC.useState)(true);
    const [initialData, setInitialData] = (0, $tZqWC.useState)();
    // Variables
    const formRef = (0, $tZqWC.useRef)();
    const initialValues = {
        vasp_id: '',
        name_business: '',
        name_legal: '',
        email: '',
        website: '',
        address_street: '',
        address_city: '',
        address_region: '',
        address_postcode: '',
        address_country_code: '',
        summary: '',
        vasp_risk_value: 0
    };
    const validationSchema = $84bdfb0f595586e8$export$185802fd694ee1f5().shape({
        vasp_id: $7092ea25693c72ef$export$185802fd694ee1f5().required('VASP ID is required'),
        name_business: $7092ea25693c72ef$export$185802fd694ee1f5().required('Business Name is required'),
        name_legal: $7092ea25693c72ef$export$185802fd694ee1f5().required('Legal Name is required'),
        email: $7092ea25693c72ef$export$185802fd694ee1f5().email().required('Email is required'),
        website: $7092ea25693c72ef$export$185802fd694ee1f5().required('Website is required'),
        address_street: $7092ea25693c72ef$export$185802fd694ee1f5().required('Address Street is required'),
        address_city: $7092ea25693c72ef$export$185802fd694ee1f5().required('Address City is required'),
        address_region: $7092ea25693c72ef$export$185802fd694ee1f5().required('Address Region is required'),
        address_postcode: $7092ea25693c72ef$export$185802fd694ee1f5().required('Address Postcode is required'),
        address_country_code: $7092ea25693c72ef$export$185802fd694ee1f5().required('Address Country is required'),
        summary: $7092ea25693c72ef$export$185802fd694ee1f5(),
        vasp_risk_value: $add935e52327df44$export$185802fd694ee1f5()
    });
    // Functions
    const triggerSubmit = ()=>{
        formRef.current.submitForm();
    };
    const handleOnSubmit = (values)=>{
        const payload = {
            biz_id: userCredentials.Business_ID,
            ...values
        };
        // removing empty fields on object
        Object.keys(payload).forEach((k)=>payload[k] === '' && delete payload[k]);
        if (isCreateVasp) createVasp(payload);
        else if (!isCreateVasp) updateVasp({
            vasp_id: toBeUpdatedVasp.vasp_id,
            values: payload
        });
    };
    const handleLoadingChange = ()=>{
        if (isVaspCreateLoading || isVaspUpdateLoading) setShowHeaderLoader(true);
        if (!isVaspCreateLoading && !isVaspUpdateLoading) {
            setShowHeaderLoader(false);
            if (initialData) {
                if (isCreateVasp) {
                    if (isVaspCreateSuccess) {
                        setCreatedVasp(vaspCreateData);
                        setIsVaspDrawerOpen(false);
                        setIsPageTableUpdated(true);
                        showAlert({
                            type: 'success',
                            message: 'Successfully created record'
                        });
                    } else if (!isVaspCreateSuccess) showAlert({
                        type: 'error',
                        message: 'An error occurred in creating record'
                    });
                } else if (!isCreateVasp) {
                    if (isVaspUpdateSuccess) {
                        setCreatedVasp(vaspUpdateData);
                        setToBeUpdatedVasp(null);
                        setIsVaspDrawerOpen(false);
                        setIsRecordUpdated(true);
                        showAlert({
                            type: 'success',
                            message: 'Successfully updated record'
                        });
                    } else if (!isVaspUpdateSuccess) showAlert({
                        type: 'error',
                        message: 'An error occurred in updating record'
                    });
                }
            }
        }
    };
    // UseEffects
    (0, $tZqWC.useEffect)(()=>{
        if (!toBeUpdatedVasp) {
            setIsCreateVasp(true);
            setInitialData(initialValues);
        } else {
            setIsCreateVasp(false);
            setInitialData(toBeUpdatedVasp);
        }
    }, []);
    (0, $tZqWC.useEffect)(()=>handleLoadingChange(), [
        isVaspCreateLoading,
        isVaspUpdateLoading
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$ac7496df4f1f837a), {
        children: initialData && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $506ef65bbb4994b7$export$2e2bcd8739ae039), {
            formRef: formRef,
            initialValues: initialData,
            validationSchema: validationSchema,
            onSubmit: handleOnSubmit,
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$97ee2cbf37e5ebfe), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$71c7816ee3a5a527), {
                        children: isCreateVasp ? 'Create VASP' : 'Edit VASP'
                    })
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $eeb0130f69d5f5f9$export$f06621d9ad29af97), {
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                label: "VASP ID e.g. ID0001",
                                name: "vasp_id"
                            })
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                label: "Legal Name",
                                name: "name_legal"
                            })
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                label: "Business Name",
                                name: "name_business"
                            })
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                label: "Email",
                                type: "email",
                                name: "email"
                            })
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                label: "Website",
                                name: "website"
                            })
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                label: "Street",
                                name: "address_street"
                            })
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                label: "City",
                                name: "address_city"
                            })
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                label: "Region",
                                name: "address_region"
                            })
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                label: "Zipcode",
                                name: "address_postcode"
                            })
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6e833112b656c531$export$2e2bcd8739ae039), {
                                label: "Country",
                                name: "address_country_code",
                                options: (0, $735b35f584baaf3c$export$df7943177b16f2f3)
                            })
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                label: "Summary",
                                name: "summary"
                            })
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $99b5eccf8ae49d07$export$2e2bcd8739ae039), {
                                type: "number",
                                label: "VASP Risk",
                                name: "vasp_risk_value",
                                options: (0, $f398806f8c37b1c3$export$ac88620a652f8304)
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e7277fd05612133d), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                        type: "button",
                        onClick: triggerSubmit,
                        children: isCreateVasp ? 'Create VASP' : 'Save VASP'
                    })
                })
            ]
        })
    });
}
// Default Props
$dec5bce9738b22bd$var$VaspForm.defaultProps = {
    formRef: {},
    form: {
        toBeUpdatedVasp: null
    },
    actions: {}
};
// Proptypes Validation
$dec5bce9738b22bd$var$VaspForm.propTypes = {
    formRef: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        root: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    }),
    form: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        countryListOptions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Array),
        toBeUpdatedVasp: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            vasp_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
        })
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setToBeUpdatedVasp: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setCreatedVasp: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsVaspDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsRecordUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $dec5bce9738b22bd$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($dec5bce9738b22bd$var$mapStateToProps, $dec5bce9738b22bd$var$mapDispatchToProps)($dec5bce9738b22bd$var$VaspForm);


var $fc74ce71b32b91d5$export$2e2bcd8739ae039 = (0, $dec5bce9738b22bd$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");


var $4L3zM = parcelRequire("4L3zM");





// Map Redux Props
const $5275e3ed950ad537$var$mapStateToProps = (state)=>state;
const $5275e3ed950ad537$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $5275e3ed950ad537$var$RequestVaspForm(props) {
    // Destructure
    const { actions: actions, setIsPushRequest: setIsPushRequest, setEmail: setEmail } = props;
    // Hooks
    const { requestVasp: requestVasp, requestVaspError: requestVaspError, isRequestVaspLoading: isRequestVaspLoading, isRequestVaspSuccess: isRequestVaspSuccess } = (0, $03c84b7634cfc367$export$2e2bcd8739ae039)();
    // Store Actions
    const { setIsRequestVaspModalOpen: setIsRequestVaspModalOpen, showAlert: showAlert } = actions;
    // Internal State
    const [initialData, setInitialData] = (0, $tZqWC.useState)();
    const [errorMessage, setErrorMessage] = (0, $tZqWC.useState)();
    const [isExisting, setIsExisting] = (0, $tZqWC.useState)();
    // Variables
    const formRef = (0, $tZqWC.useRef)();
    const initialValues = {
        email: ''
    };
    const validationSchema = $84bdfb0f595586e8$export$185802fd694ee1f5().shape({
        email: $7092ea25693c72ef$export$185802fd694ee1f5().email().required('Email is required')
    });
    // Functions
    const triggerSubmit = ()=>{
        formRef.current.submitForm();
    };
    const handleOnSubmit = (values)=>{
        const payload = {
            ...values
        };
        requestVasp(payload);
    };
    const handleLoadingChange = ()=>{
        if (isRequestVaspLoading) return;
        if (!isRequestVaspLoading && initialData) {
            if (isRequestVaspSuccess) {
                setIsRequestVaspModalOpen(false);
                showAlert({
                    type: 'success',
                    message: 'Successfully Requested for VASP!'
                });
            } else if (requestVaspError) {
                if (requestVaspError?.response?.status === 429) {
                    setErrorMessage('VASP has already been requested within the past 10 days. Do you wish to push through with the request?');
                    setIsExisting(true);
                    return;
                }
                if (requestVaspError?.response?.data?.context?.message) {
                    setErrorMessage(requestVaspError?.response?.data?.context?.message);
                    return;
                }
                setErrorMessage('An occurred in Requesting for VASP');
            }
        }
    };
    // UseEffects
    (0, $tZqWC.useEffect)(()=>{
        setInitialData(initialValues);
    }, []);
    (0, $tZqWC.useEffect)(()=>handleLoadingChange(), [
        isRequestVaspLoading
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$ac7496df4f1f837a), {
        children: initialData && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $506ef65bbb4994b7$export$2e2bcd8739ae039), {
            formRef: formRef,
            initialValues: initialData,
            validationSchema: validationSchema,
            onSubmit: handleOnSubmit,
            children: [
                errorMessage && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$ae4fd97bdbe491c1), {
                    children: errorMessage
                }),
                !errorMessage && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$f06621d9ad29af97), {
                            style: {
                                minHeight: '110px'
                            },
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e151f1d86035b485), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                    label: "Email",
                                    type: "email",
                                    name: "email"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$e7277fd05612133d), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                type: "button",
                                onClick: triggerSubmit,
                                disabled: isRequestVaspLoading,
                                fullWidth: true,
                                children: isRequestVaspLoading ? 'Sending Request...' : 'Submit'
                            })
                        })
                    ]
                }),
                isExisting && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $eeb0130f69d5f5f9$export$e7277fd05612133d), {
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                            type: "button",
                            onClick: ()=>setIsRequestVaspModalOpen(false),
                            variant: "outlined",
                            fullWidth: true,
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                            type: "button",
                            fullWidth: true,
                            onClick: ()=>{
                                if (setIsPushRequest && setEmail) {
                                    setEmail(formRef.current?.values?.email);
                                    setIsPushRequest(true);
                                }
                            },
                            children: "Push Request"
                        })
                    ]
                })
            ]
        })
    });
}
// Default Props
$5275e3ed950ad537$var$RequestVaspForm.defaultProps = {
    formRef: {},
    form: {
        toBeUpdatedVasp: null
    },
    actions: {}
};
// Proptypes Validation
$5275e3ed950ad537$var$RequestVaspForm.propTypes = {
    formRef: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        root: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    }),
    form: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        countryListOptions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Array),
        toBeUpdatedVasp: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            vasp_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
        })
    }),
    setIsPushRequest: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    setEmail: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setToBeUpdatedVasp: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setCreatedVasp: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsRequestVaspModalOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsRecordUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $5275e3ed950ad537$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($5275e3ed950ad537$var$mapStateToProps, $5275e3ed950ad537$var$mapDispatchToProps)($5275e3ed950ad537$var$RequestVaspForm);


var $97ac3898fcb3436a$export$2e2bcd8739ae039 = (0, $5275e3ed950ad537$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");





// Map Redux Props
const $82b014b9cf39a896$var$mapStateToProps = (state)=>state;
const $82b014b9cf39a896$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $82b014b9cf39a896$var$PushRequestVaspForm(props) {
    // Destructure
    const { actions: actions, email: email } = props;
    // Hooks
    const { pushRequestVasp: pushRequestVasp, pushRequestVaspError: pushRequestVaspError, isPushRequestVaspLoading: isPushRequestVaspLoading, isPushRequestVaspSuccess: isPushRequestVaspSuccess } = (0, $96e283598ec52e72$export$2e2bcd8739ae039)();
    // Store Actions
    const { setIsRequestVaspModalOpen: setIsRequestVaspModalOpen, showAlert: showAlert } = actions;
    // Internal State
    const [errorMessage, setErrorMessage] = (0, $tZqWC.useState)();
    // Functions
    const handleOnSubmit = ()=>{
        const payload = {
            email: email
        };
        pushRequestVasp(payload);
    };
    const handleLoadingChange = ()=>{
        if (isPushRequestVaspLoading) return;
        if (!isPushRequestVaspLoading) {
            if (isPushRequestVaspSuccess) {
                setIsRequestVaspModalOpen(false);
                showAlert({
                    type: 'success',
                    message: 'Successfully Requested for VASP!'
                });
            } else if (pushRequestVaspError) setErrorMessage('An occurred in Requesting for VASP');
        }
    };
    // UseEffects
    (0, $tZqWC.useEffect)(()=>handleLoadingChange(), [
        isPushRequestVaspLoading
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$ac7496df4f1f837a), {
        style: {
            padding: '25px'
        },
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $506ef65bbb4994b7$export$2e2bcd8739ae039), {
            children: [
                errorMessage && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$942b2219c902021e), {
                    children: errorMessage
                }),
                !errorMessage && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eeb0130f69d5f5f9$export$942b2219c902021e), {
                            children: "Pushing through with this request will invalidate previous requests. Are you sure you want to push through with requesting this VASP?"
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $eeb0130f69d5f5f9$export$e7277fd05612133d), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                    type: "button",
                                    onClick: ()=>setIsRequestVaspModalOpen,
                                    disabled: isPushRequestVaspLoading,
                                    variant: "outlined",
                                    fullWidth: true,
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                    type: "button",
                                    onClick: handleOnSubmit,
                                    disabled: isPushRequestVaspLoading,
                                    fullWidth: true,
                                    children: isPushRequestVaspLoading ? 'Pushing Request...' : 'Push Request'
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
// Default Props
$82b014b9cf39a896$var$PushRequestVaspForm.defaultProps = {
    formRef: {},
    form: {
        toBeUpdatedVasp: null
    },
    actions: {}
};
// Proptypes Validation
$82b014b9cf39a896$var$PushRequestVaspForm.propTypes = {
    formRef: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        root: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    }),
    form: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        countryListOptions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Array),
        toBeUpdatedVasp: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            vasp_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
        })
    }),
    email: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setToBeUpdatedVasp: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setCreatedVasp: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsRequestVaspModalOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsRecordUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $82b014b9cf39a896$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($82b014b9cf39a896$var$mapStateToProps, $82b014b9cf39a896$var$mapDispatchToProps)($82b014b9cf39a896$var$PushRequestVaspForm);


var $076ca81696c49923$export$2e2bcd8739ae039 = (0, $82b014b9cf39a896$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");


var $4L3zM = parcelRequire("4L3zM");





const $e86554204a0d8e9d$export$ac7496df4f1f837a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding-top: 40px;
`;
const $e86554204a0d8e9d$export$e151f1d86035b485 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  & > div > div {
    margin-bottom: 0 !important;
  }
`;
const $e86554204a0d8e9d$export$8f1ff89fa1ec9605 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(500px, 1fr));
  gap: 10px 60px;
`;
const $e86554204a0d8e9d$export$71c7816ee3a5a527 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h4`
  font-size: 15px;
  font-weight: 600;
  margin: 20px 0 0 10px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $e86554204a0d8e9d$export$fd2299f554be8993 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: 1fr 25px;
  gap: 50px;
  align-items: center;

  padding: 10px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $e86554204a0d8e9d$export$9f515a68dfaeb9ef = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  gap: 20px;
`;
const $e86554204a0d8e9d$export$85524e8d4e82fc69 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;



// Map Redux Props
const $da43fa6add5baf18$var$mapStateToProps = (state)=>state;
const $da43fa6add5baf18$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $da43fa6add5baf18$var$AccountEntityDetailsForm(props) {
    // Destructure
    const { values: values, viewMode: viewMode, formRef: formRef, onSubmit: onSubmit } = props;
    // Internal State
    const [initialData, setInitialData] = (0, $tZqWC.useState)();
    // Forms
    const [isDetailsExpanded, setIsDetailsExpanded] = (0, $tZqWC.useState)(true);
    const [isAddressExpanded, setIsAddressExpanded] = (0, $tZqWC.useState)(false);
    const [isFreeFormAddressExpanded, setIsFreeFormAddressExpanded] = (0, $tZqWC.useState)(false);
    const [isNationalIDExpanded, setIsNationalIDExpanded] = (0, $tZqWC.useState)(false);
    // Variables
    const validationSchema = $84bdfb0f595586e8$export$185802fd694ee1f5().shape({
        reference_id: $7092ea25693c72ef$export$185802fd694ee1f5().max(50).required('Reference ID is required'),
        customer_id: $7092ea25693c72ef$export$185802fd694ee1f5().max(50).nullable().test('required-identifiers', 'Customer ID, National ID, or Address is required', (value, context)=>validateRequiredAccountFields(context)),
        email: $7092ea25693c72ef$export$185802fd694ee1f5().email().nullable(),
        name_legal: $7092ea25693c72ef$export$185802fd694ee1f5().max(100).required('Legal Name is required'),
        name_business: $7092ea25693c72ef$export$185802fd694ee1f5().max(100).nullable(),
        is_customer: $b84f09f6970af0be$export$185802fd694ee1f5().required('Specify if account is a customer'),
        registration_country_code: $7092ea25693c72ef$export$185802fd694ee1f5().max(2).nullable(),
        address_line: $7092ea25693c72ef$export$185802fd694ee1f5().max(256).nullable().test('required-identifiers', 'Customer ID, National ID, or Address is required', (value, context)=>validateRequiredAccountFields(context)).test('address_line', 'Required if street number, street name, and building name are not specified', (value, context)=>hasRequiredAddressFields(context)),
        address_street_no: $7092ea25693c72ef$export$185802fd694ee1f5().max(10).nullable().test('required-identifiers', 'Customer ID, National ID, or Address is required', (value, context)=>validateRequiredAccountFields(context)).test('address_street_no', 'Required with street name if address line is not specified', (value, context)=>hasRequiredAddressFields(context)),
        address_street_name: $7092ea25693c72ef$export$185802fd694ee1f5().max(100).nullable().test('required-identifiers', 'Customer ID, National ID, or Address is required', (value, context)=>validateRequiredAccountFields(context)).test('address_street_name', 'Required with building name if address line is not specified', (value, context)=>hasRequiredAddressFields(context)),
        address_building_name: $7092ea25693c72ef$export$185802fd694ee1f5().max(20).nullable().test('required-identifiers', 'Customer ID, National ID, or Address is required', (value, context)=>validateRequiredAccountFields(context)).test('address_building_name', 'Required with street name if address line is not specified', (value, context)=>hasRequiredAddressFields(context)),
        address_floor: $7092ea25693c72ef$export$185802fd694ee1f5().max(20).nullable(),
        address_room: $7092ea25693c72ef$export$185802fd694ee1f5().max(20).nullable(),
        address_department: $7092ea25693c72ef$export$185802fd694ee1f5().max(20).nullable(),
        address_postbox: $7092ea25693c72ef$export$185802fd694ee1f5().max(20).nullable(),
        address_city_location: $7092ea25693c72ef$export$185802fd694ee1f5().max(50).nullable(),
        address_city: $7092ea25693c72ef$export$185802fd694ee1f5().max(50).nullable().test('address_city', 'Required if address fields are defined', (value, context)=>hasAddress(value, context)),
        address_region: $7092ea25693c72ef$export$185802fd694ee1f5().max(50).nullable(),
        address_district: $7092ea25693c72ef$export$185802fd694ee1f5().max(50).nullable(),
        address_postcode: $7092ea25693c72ef$export$185802fd694ee1f5().max(25).nullable(),
        address_country_code: $7092ea25693c72ef$export$185802fd694ee1f5().max(2).nullable().test('address_country_code', 'Required if address fields are defined', (value, context)=>hasAddress(value, context)),
        national_id_type_code: $7092ea25693c72ef$export$185802fd694ee1f5().max(10).nullable().test('required-identifiers', 'Customer ID, National ID, or Address is required', (value, context)=>validateRequiredAccountFields(context)).test('national_id_type_required', 'ID Type is required when National ID is provided', (value, context)=>{
            const hasNationalId = Boolean(context.parent.national_id);
            // If any other National ID fields are provided, this field is required
            if (hasNationalId && !value) return false;
            return true;
        }),
        national_id: $7092ea25693c72ef$export$185802fd694ee1f5().max(35).nullable().test('required-identifiers', 'Customer ID, National ID, or Address is required', (value, context)=>validateRequiredAccountFields(context)).test('national_id_required', 'National ID is required when ID Type is provided', (value, context)=>{
            const hasIdType = Boolean(context.parent.national_id_type_code);
            // If any other National ID fields are provided, this field is required
            if (hasIdType && !value) return false;
            return true;
        }),
        national_id_issue_country: $7092ea25693c72ef$export$185802fd694ee1f5().max(2).nullable().test('required-identifiers', 'Customer ID, National ID, or Address is required', (value, context)=>validateRequiredAccountFields(context)).test('issue_country_not_required', 'Country Issuer must not be specified for entity accounts', (value)=>{
            if (value) return false;
            return true;
        }),
        national_id_registration_authority: $7092ea25693c72ef$export$185802fd694ee1f5().max(10).nullable().test('required-identifiers', 'Customer ID, National ID, or Address is required', (value, context)=>validateRequiredAccountFields(context)).test('registration_authority_conditional', (value, context)=>{
            const idType = context.parent.national_id_type_code;
            // Skip validation if ID Type is not provided
            if (!idType) return true;
            // For LEIX type, registration authority must NOT be provided
            if (idType === 'LEIX') {
                if (value) return context.createError({
                    path: context.path,
                    message: 'Registration Authority must not be specified for national ID type "LEIX"'
                });
                return true;
            }
            // For all other ID types, registration authority is required
            if (!value) return context.createError({
                path: context.path,
                message: `Registration Authority is required for national ID type "${idType}"`
            });
            return true;
        })
    });
    // Functions
    function hasRequiredAddressFields(context) {
        const parent = context?.parent;
        /*
      If the form already has required account fields
      (date and place of birth, customer id, or national id),
      skip required address fields validation
    */ const hasRequiredAccountFields = validateRequiredAccountFields(context);
        if (hasRequiredAccountFields) return true;
        // Check if any address fields are filled
        const hasAddressLine = Boolean(parent?.address_line);
        const hasStreetNo = Boolean(parent?.address_street_no);
        const hasBuildingName = Boolean(parent?.address_building_name);
        const hasStreetName = Boolean(parent?.address_street_name);
        const hasAddress = hasAddressLine || hasStreetName && (hasStreetNo || hasBuildingName);
        return hasAddress;
    }
    function hasAddress(value, context) {
        const parent = context?.parent;
        // Check if any address fields are filled
        const hasAddressLine = Boolean(parent?.address_line);
        const hasStreetNo = Boolean(parent?.address_street_no);
        const hasBuildingName = Boolean(parent?.address_building_name);
        const hasStreetName = Boolean(parent?.address_street_name);
        // If no address info is provided, value is optional
        if (!hasAddressLine && !hasStreetNo && !hasStreetName && !hasBuildingName) return true;
        // If we have validated address information, value is required
        return Boolean(value);
    }
    /*
    Validates if at least one of:
    - National ID
    - Address
    - Customer ID
    is provided.

    If an attempt to provide one of these identifiers is made,
    even if the identifier is incomplete
    (e.g. specifying incomplete address, national ID, or date and place of birth),
    the validation will pass.
  */ function validateRequiredAccountFields(context) {
        const parent = context?.parent;
        // Check if any national ID fields are provided
        // The validation here is more relaxed, since we also require the other field if one is provided
        const hasNationalIdType = Boolean(parent?.national_id_type_code);
        const hasNationalID = Boolean(parent?.national_id);
        const hasNationalIDIssueCountry = Boolean(parent?.national_id_issue_country);
        const hasNationalIDRegistrationAuthority = Boolean(parent?.national_id_registration_authority);
        const hasNationalIDInfo = hasNationalID || hasNationalIdType || hasNationalIDIssueCountry || hasNationalIDRegistrationAuthority;
        // Check if customer ID is provided
        const hasCustomerID = Boolean(parent?.customer_id);
        // Check if any required address is provided
        const hasAddressLine = Boolean(parent?.address_line);
        const hasStreetNo = Boolean(parent?.address_street_no);
        const hasStreetName = Boolean(parent?.address_street_name);
        const hasBuildingName = Boolean(parent?.address_building_name);
        const hasAddress = hasAddressLine || hasStreetName || hasStreetNo || hasBuildingName;
        // Return true if at least one identifier method is provided
        return hasNationalIDInfo || hasAddress || hasCustomerID;
    }
    // UseEffects
    (0, $tZqWC.useEffect)(()=>{
        // TODO REMOVE HARD CODED VALUE
        setInitialData({
            ...values,
            address_type_code: 'GEOG'
        });
    }, [
        values
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e86554204a0d8e9d$export$ac7496df4f1f837a), {
        children: initialData && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $506ef65bbb4994b7$export$2e2bcd8739ae039), {
            formRef: formRef,
            initialValues: initialData,
            validationSchema: validationSchema,
            onSubmit: onSubmit,
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b3f7dc6528742bb0$export$2e2bcd8739ae039), {
                    style: {
                        marginTop: '20px'
                    },
                    setIsExpanded: (val)=>{
                        setIsDetailsExpanded(val);
                    },
                    expandPanel: isDetailsExpanded,
                    button: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e86554204a0d8e9d$export$fd2299f554be8993), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e86554204a0d8e9d$export$9f515a68dfaeb9ef), {
                            isExpanded: isDetailsExpanded,
                            children: "Business information"
                        })
                    }),
                    panel: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e86554204a0d8e9d$export$85524e8d4e82fc69), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $e86554204a0d8e9d$export$8f1ff89fa1ec9605), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e86554204a0d8e9d$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "Reference ID*",
                                        name: "reference_id"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e86554204a0d8e9d$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $99b5eccf8ae49d07$export$2e2bcd8739ae039), {
                                        disabled: true,
                                        label: "Account Type*",
                                        name: "account_type_id",
                                        options: (0, $f398806f8c37b1c3$export$6096865e4aa58c8a)
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e86554204a0d8e9d$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "Customer ID*",
                                        name: "customer_id"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e86554204a0d8e9d$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $99b5eccf8ae49d07$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "Is Customer*",
                                        name: "is_customer",
                                        options: (0, $f398806f8c37b1c3$export$d631eb4fd6125e2b)
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e86554204a0d8e9d$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $99b5eccf8ae49d07$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "Status",
                                        name: "status_id",
                                        options: (0, $f398806f8c37b1c3$export$e4493caf40597bf1)
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e86554204a0d8e9d$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "Email",
                                        type: "email",
                                        name: "email"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e86554204a0d8e9d$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "Business Name",
                                        name: "name_business"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e86554204a0d8e9d$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "Legal Name*",
                                        name: "name_legal"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e86554204a0d8e9d$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6e833112b656c531$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "Registration Country",
                                        name: "registration_country_code",
                                        options: (0, $735b35f584baaf3c$export$df7943177b16f2f3)
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e86554204a0d8e9d$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a5484141b8231e9a$export$2e2bcd8739ae039), {
                                        disabled: true,
                                        label: "Created",
                                        name: "created"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e86554204a0d8e9d$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a5484141b8231e9a$export$2e2bcd8739ae039), {
                                        disabled: true,
                                        label: "Last Modified",
                                        name: "last_modified"
                                    })
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b3f7dc6528742bb0$export$2e2bcd8739ae039), {
                    style: {
                        marginTop: '20px'
                    },
                    setIsExpanded: (val)=>{
                        setIsAddressExpanded(val);
                    },
                    expandPanel: isAddressExpanded,
                    button: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e86554204a0d8e9d$export$fd2299f554be8993), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e86554204a0d8e9d$export$9f515a68dfaeb9ef), {
                            isExpanded: isAddressExpanded,
                            children: "Structured address"
                        })
                    }),
                    panel: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e86554204a0d8e9d$export$85524e8d4e82fc69), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $e86554204a0d8e9d$export$8f1ff89fa1ec9605), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e86554204a0d8e9d$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "Street Number*",
                                        name: "address_street_no"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e86554204a0d8e9d$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "Street Name*",
                                        name: "address_street_name"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e86554204a0d8e9d$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "Building Name*",
                                        name: "address_building_name"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e86554204a0d8e9d$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "Floor",
                                        name: "address_floor"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e86554204a0d8e9d$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "Room",
                                        name: "address_room"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e86554204a0d8e9d$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "Department",
                                        name: "address_department"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e86554204a0d8e9d$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "Postbox",
                                        name: "address_postbox"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e86554204a0d8e9d$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "City Location",
                                        name: "address_city_location"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e86554204a0d8e9d$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "City*",
                                        name: "address_city"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e86554204a0d8e9d$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "Region",
                                        name: "address_region"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e86554204a0d8e9d$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "District",
                                        name: "address_district"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e86554204a0d8e9d$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "Zipcode",
                                        name: "address_postcode"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e86554204a0d8e9d$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6e833112b656c531$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "Country*",
                                        name: "address_country_code",
                                        options: (0, $735b35f584baaf3c$export$df7943177b16f2f3)
                                    })
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b3f7dc6528742bb0$export$2e2bcd8739ae039), {
                    style: {
                        marginTop: '20px'
                    },
                    setIsExpanded: (val)=>{
                        setIsFreeFormAddressExpanded(val);
                    },
                    expandPanel: isFreeFormAddressExpanded,
                    button: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e86554204a0d8e9d$export$fd2299f554be8993), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e86554204a0d8e9d$export$9f515a68dfaeb9ef), {
                            isExpanded: isFreeFormAddressExpanded,
                            children: "Free form address"
                        })
                    }),
                    panel: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e86554204a0d8e9d$export$85524e8d4e82fc69), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e86554204a0d8e9d$export$8f1ff89fa1ec9605), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e86554204a0d8e9d$export$e151f1d86035b485), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $dfc171aac0fd6ec5$export$2e2bcd8739ae039), {
                                    disabled: viewMode,
                                    label: "Address Line",
                                    name: "address_line"
                                })
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b3f7dc6528742bb0$export$2e2bcd8739ae039), {
                    style: {
                        marginTop: '20px'
                    },
                    setIsExpanded: (val)=>{
                        setIsNationalIDExpanded(val);
                    },
                    expandPanel: isNationalIDExpanded,
                    button: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e86554204a0d8e9d$export$fd2299f554be8993), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e86554204a0d8e9d$export$9f515a68dfaeb9ef), {
                            isExpanded: isNationalIDExpanded,
                            children: "National ID"
                        })
                    }),
                    panel: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e86554204a0d8e9d$export$85524e8d4e82fc69), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $e86554204a0d8e9d$export$8f1ff89fa1ec9605), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e86554204a0d8e9d$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $99b5eccf8ae49d07$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "National ID Type",
                                        name: "national_id_type_code",
                                        options: (0, $f398806f8c37b1c3$export$1d9e1f0caa6e0145)
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e86554204a0d8e9d$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "National ID",
                                        name: "national_id"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e86554204a0d8e9d$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "National ID Registration Authority",
                                        name: "national_id_registration_authority"
                                    })
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
}
// Default Props
$da43fa6add5baf18$var$AccountEntityDetailsForm.defaultProps = {
    formRef: {},
    form: {},
    actions: {},
    values: {
        reference_id: '',
        account_type_id: 0,
        status_id: 0,
        email: '',
        name_business: '',
        name_legal: '',
        incorporation_country: '',
        inc_date: '',
        primary_activity_code: 0,
        created: '',
        last_modified: '',
        address_street_name: '',
        address_city: '',
        address_region: '',
        address_postcode: '',
        address_country_code: ''
    },
    viewMode: true
};
// Proptypes Validation
$da43fa6add5baf18$var$AccountEntityDetailsForm.propTypes = {
    formRef: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        root: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    }),
    form: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        COUNTRIES_LIST: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Array),
        toBeUpdatedAccount: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({})
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setCountryListOptions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsEntityAccountDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setToBeUpdatedAccount: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    values: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        reference_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        account_type_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        status_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        email: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        name_business: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        name_legal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        incorporation_country: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        inc_date: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        primary_activity_code: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        created: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        last_modified: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        address_street_name: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        address_city: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        address_region: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        address_postcode: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        address_country_code: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    }),
    viewMode: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    onSubmit: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
};
var $da43fa6add5baf18$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($da43fa6add5baf18$var$mapStateToProps, $da43fa6add5baf18$var$mapDispatchToProps)($da43fa6add5baf18$var$AccountEntityDetailsForm);


var $52d701a051d389bb$export$2e2bcd8739ae039 = (0, $da43fa6add5baf18$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");


var $4L3zM = parcelRequire("4L3zM");





const $2bc57b1052be9e99$export$ac7496df4f1f837a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding-top: 40px;
`;
const $2bc57b1052be9e99$export$e151f1d86035b485 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  & > div > div {
    margin-bottom: 0 !important;
  }
`;
const $2bc57b1052be9e99$export$8f1ff89fa1ec9605 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(550px, 1fr));
  gap: 10px 60px;
`;
const $2bc57b1052be9e99$export$71c7816ee3a5a527 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h4`
  font-size: 15px;
  font-weight: 600;
  margin: 20px 0 0 10px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $2bc57b1052be9e99$export$fd2299f554be8993 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: 1fr 25px;
  gap: 50px;
  align-items: center;

  padding: 10px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $2bc57b1052be9e99$export$9f515a68dfaeb9ef = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  gap: 20px;
`;
const $2bc57b1052be9e99$export$85524e8d4e82fc69 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;



// Map Redux Props
const $14039f3abedba732$var$mapStateToProps = (state)=>state;
const $14039f3abedba732$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $14039f3abedba732$var$AccountIndividualDetailsForm(props) {
    // Destructure
    const { values: values, viewMode: viewMode, formRef: formRef, onSubmit: onSubmit } = props;
    // Internal State
    const [initialData, setInitialData] = (0, $tZqWC.useState)();
    // Forms
    const [isDetailsExpanded, setIsDetailsExpanded] = (0, $tZqWC.useState)(true);
    const [isAddressExpanded, setIsAddressExpanded] = (0, $tZqWC.useState)(false);
    const [isFreeFormAddressExpanded, setIsFreeFormAddressExpanded] = (0, $tZqWC.useState)(false);
    const [isNationalIDExpanded, setIsNationalIDExpanded] = (0, $tZqWC.useState)(false);
    // Variables
    const validationSchema = $84bdfb0f595586e8$export$185802fd694ee1f5().shape({
        reference_id: $7092ea25693c72ef$export$185802fd694ee1f5().max(50).required('Reference ID is required'),
        customer_id: $7092ea25693c72ef$export$185802fd694ee1f5().max(50).nullable().test('required-identifiers', 'Customer ID, Date & Place of Birth, National ID, or Address is required', (value, context)=>validateRequiredAccountFields(context)),
        email: $7092ea25693c72ef$export$185802fd694ee1f5().email().nullable(),
        name_first: $7092ea25693c72ef$export$185802fd694ee1f5().max(50).nullable(),
        name_middle: $7092ea25693c72ef$export$185802fd694ee1f5().max(50).nullable(),
        name_last: $7092ea25693c72ef$export$185802fd694ee1f5().max(50).required('Last Name is required'),
        is_customer: $b84f09f6970af0be$export$185802fd694ee1f5().required('Specify if account is a customer'),
        date_of_birth: $e039e5cb92bd30b2$export$185802fd694ee1f5().max(new Date(Date.now() - 567648000000), 'Must be atleast 18 years').nullable().test('required-identifiers', 'Customer ID, Date & Place of Birth, National ID, or Address is required', (value, context)=>validateRequiredAccountFields(context)).test('date_of_birth_with_place', 'Date of birth is required when place of birth is provided', (value, context)=>{
            const placeOfBirth = context.parent.place_of_birth;
            if (placeOfBirth && !value) return false // Fail if place is provided but date isn't
            ;
            return true;
        }),
        place_of_birth: $7092ea25693c72ef$export$185802fd694ee1f5().max(50).nullable().test('required-identifiers', 'Customer ID, Date & Place of Birth, National ID, or Address is required', (value, context)=>validateRequiredAccountFields(context)).test('place_of_birth_with_date', 'Place of birth is required when date of birth is provided', (value, context)=>{
            const dateOfBirth = context.parent.date_of_birth;
            if (dateOfBirth && !value) return false // Fail if date is provided but place isn't
            ;
            return true;
        }),
        nationality_country_code: $7092ea25693c72ef$export$185802fd694ee1f5().max(2).nullable(),
        address_line: $7092ea25693c72ef$export$185802fd694ee1f5().max(256).nullable().test('required-identifiers', 'Customer ID, Date & Place of Birth, National ID, or Address is required', (value, context)=>validateRequiredAccountFields(context)).test('address_line', 'Required if street number, street name, and building name are not specified', (value, context)=>hasRequiredAddressFields(context)),
        address_street_no: $7092ea25693c72ef$export$185802fd694ee1f5().max(10).nullable().test('required-identifiers', 'Customer ID, Date & Place of Birth, National ID, or Address is required', (value, context)=>validateRequiredAccountFields(context)).test('address_street_no', 'Required with street name if address line is not specified', (value, context)=>hasRequiredAddressFields(context)),
        address_street_name: $7092ea25693c72ef$export$185802fd694ee1f5().max(100).nullable().test('required-identifiers', 'Customer ID, Date & Place of Birth, National ID, or Address is required', (value, context)=>validateRequiredAccountFields(context)).test('address_street_name', 'Required with building name if address line is not specified', (value, context)=>hasRequiredAddressFields(context)),
        address_building_name: $7092ea25693c72ef$export$185802fd694ee1f5().max(20).nullable().test('required-identifiers', 'Customer ID, Date & Place of Birth, National ID, or Address is required', (value, context)=>validateRequiredAccountFields(context)).test('address_building_name', 'Required with street name if address line is not specified', (value, context)=>hasRequiredAddressFields(context)),
        address_floor: $7092ea25693c72ef$export$185802fd694ee1f5().max(20).nullable(),
        address_room: $7092ea25693c72ef$export$185802fd694ee1f5().max(20).nullable(),
        address_department: $7092ea25693c72ef$export$185802fd694ee1f5().max(20).nullable(),
        address_postbox: $7092ea25693c72ef$export$185802fd694ee1f5().max(20).nullable(),
        address_city_location: $7092ea25693c72ef$export$185802fd694ee1f5().max(50).nullable(),
        address_city: $7092ea25693c72ef$export$185802fd694ee1f5().max(50).nullable().test('address_city', 'Required if address is provided', (value, context)=>hasAddress(value, context)),
        address_region: $7092ea25693c72ef$export$185802fd694ee1f5().max(50).nullable(),
        address_district: $7092ea25693c72ef$export$185802fd694ee1f5().max(50).nullable(),
        address_postcode: $7092ea25693c72ef$export$185802fd694ee1f5().max(25).nullable(),
        address_country_code: $7092ea25693c72ef$export$185802fd694ee1f5().max(2).nullable().test('address_country_code', 'Required if address is provided', (value, context)=>hasAddress(value, context)),
        national_id_type_code: $7092ea25693c72ef$export$185802fd694ee1f5().max(10).nullable().test('required-identifiers', 'Customer ID, Date & Place of Birth, National ID, or Address is required', (value, context)=>validateRequiredAccountFields(context)).test('national_id_type_required', 'ID Type is required when National ID or Country Issuer is provided', (value, context)=>{
            const hasNationalId = Boolean(context.parent.national_id);
            const hasIssueCountry = Boolean(context.parent.national_id_issue_country);
            // If any other National ID fields are provided, this field is required
            if ((hasNationalId || hasIssueCountry) && !value) return false;
            return true;
        }),
        national_id: $7092ea25693c72ef$export$185802fd694ee1f5().max(35).nullable().test('required-identifiers', 'Customer ID, Date & Place of Birth, National ID, or Address is required', (value, context)=>validateRequiredAccountFields(context)).test('national_id_required', 'National ID is required when ID Type or Country Issuer is provided', (value, context)=>{
            const hasIdType = Boolean(context.parent.national_id_type_code);
            const hasIssueCountry = Boolean(context.parent.national_id_issue_country);
            // If any other National ID fields are provided, this field is required
            if ((hasIdType || hasIssueCountry) && !value) return false;
            return true;
        }),
        national_id_issue_country: $7092ea25693c72ef$export$185802fd694ee1f5().max(2).nullable()
    });
    // Functions
    function hasRequiredAddressFields(context) {
        const parent = context?.parent;
        /*
      If the form already has required account fields
      (date and place of birth, customer id, or national id),
      skip required address fields validation
    */ const hasRequiredAccountFields = validateRequiredAccountFields(context);
        if (hasRequiredAccountFields) return true;
        // Check if any address fields are filled
        const hasAddressLine = Boolean(parent?.address_line);
        const hasStreetNo = Boolean(parent?.address_street_no);
        const hasBuildingName = Boolean(parent?.address_building_name);
        const hasStreetName = Boolean(parent?.address_street_name);
        const hasAddress = hasAddressLine || hasStreetName && (hasStreetNo || hasBuildingName);
        return hasAddress;
    }
    function hasAddress(value, context) {
        const parent = context?.parent;
        // Check if any address fields are filled
        const hasAddressLine = Boolean(parent?.address_line);
        const hasStreetNo = Boolean(parent?.address_street_no);
        const hasBuildingName = Boolean(parent?.address_building_name);
        const hasStreetName = Boolean(parent?.address_street_name);
        // If no address info is provided, value is optional
        if (!hasAddressLine && !hasStreetNo && !hasStreetName && !hasBuildingName) return true;
        // If we have validated address information, value is required
        return Boolean(value);
    }
    /*
    Validates if at least one of:
    - Date and Place of Birth
    - National ID
    - Address
    - Customer ID
    is provided.

    If an attempt to provide one of these identifiers is made,
    even if the identifier is incomplete
    (e.g. specifying incomplete address, national ID, or date and place of birth),
    the validation will pass.
  */ function validateRequiredAccountFields(context) {
        const parent = context?.parent;
        // Check if at least date or place of birth is provided
        // The validation here is more relaxed, since we also require the other field if one is provided
        const hasDateOfBirth = Boolean(parent?.date_of_birth);
        const hasPlaceOfBirth = Boolean(parent?.place_of_birth);
        const hasBirthInfo = hasDateOfBirth || hasPlaceOfBirth;
        // Check if any national ID fields are provided
        // The validation here is more relaxed, since we also require the other field if one is provided
        const hasNationalIdType = Boolean(parent?.national_id_type_code);
        const hasNationalID = Boolean(parent?.national_id);
        const hasNationalIDIssueCountry = Boolean(parent?.national_id_issue_country);
        const hasNationalIDInfo = hasNationalIdType || hasNationalID || hasNationalIDIssueCountry;
        // Check if customer ID is provided
        const hasCustomerID = Boolean(parent?.customer_id);
        // Check if any required address is provided
        const hasAddressLine = Boolean(parent?.address_line);
        const hasStreetNo = Boolean(parent?.address_street_no);
        const hasStreetName = Boolean(parent?.address_street_name);
        const hasBuildingName = Boolean(parent?.address_building_name);
        const hasAddress = hasAddressLine || hasStreetName || hasStreetNo || hasBuildingName;
        // Return true if at least one identifier method is provided
        return hasBirthInfo || hasNationalIDInfo || hasAddress || hasCustomerID;
    }
    // UseEffects
    (0, $tZqWC.useEffect)(()=>{
        // TODO REMOVE HARD CODED VALUE
        setInitialData({
            ...values,
            address_type_code: 'GEOG'
        });
    }, [
        values
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2bc57b1052be9e99$export$ac7496df4f1f837a), {
        children: initialData && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $506ef65bbb4994b7$export$2e2bcd8739ae039), {
            formRef: formRef,
            initialValues: initialData,
            validationSchema: validationSchema,
            onSubmit: onSubmit,
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b3f7dc6528742bb0$export$2e2bcd8739ae039), {
                    style: {
                        marginTop: '20px'
                    },
                    setIsExpanded: (val)=>{
                        setIsDetailsExpanded(val);
                    },
                    expandPanel: isDetailsExpanded,
                    button: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2bc57b1052be9e99$export$fd2299f554be8993), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2bc57b1052be9e99$export$9f515a68dfaeb9ef), {
                            isExpanded: isDetailsExpanded,
                            children: "Personal information"
                        })
                    }),
                    panel: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2bc57b1052be9e99$export$85524e8d4e82fc69), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $2bc57b1052be9e99$export$8f1ff89fa1ec9605), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2bc57b1052be9e99$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "Reference ID*",
                                        name: "reference_id"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2bc57b1052be9e99$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $99b5eccf8ae49d07$export$2e2bcd8739ae039), {
                                        disabled: true,
                                        label: "Account Type",
                                        name: "account_type_id",
                                        options: (0, $f398806f8c37b1c3$export$6096865e4aa58c8a)
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2bc57b1052be9e99$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "Customer ID*",
                                        name: "customer_id"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2bc57b1052be9e99$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $99b5eccf8ae49d07$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "Is Customer*",
                                        name: "is_customer",
                                        options: (0, $f398806f8c37b1c3$export$d631eb4fd6125e2b)
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2bc57b1052be9e99$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $99b5eccf8ae49d07$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "Status",
                                        name: "status_id",
                                        options: (0, $f398806f8c37b1c3$export$e4493caf40597bf1)
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2bc57b1052be9e99$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "Email",
                                        type: "email",
                                        name: "email"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2bc57b1052be9e99$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6e833112b656c531$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "Nationality",
                                        name: "nationality_country_code",
                                        options: (0, $735b35f584baaf3c$export$df7943177b16f2f3)
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2bc57b1052be9e99$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "First Name",
                                        name: "name_first"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2bc57b1052be9e99$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "Middle Name",
                                        name: "name_middle"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2bc57b1052be9e99$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "Last Name*",
                                        name: "name_last"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2bc57b1052be9e99$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a5484141b8231e9a$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "Date of Birth",
                                        name: "date_of_birth"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2bc57b1052be9e99$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "Place of Birth",
                                        name: "place_of_birth"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2bc57b1052be9e99$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a5484141b8231e9a$export$2e2bcd8739ae039), {
                                        disabled: true,
                                        label: "Created",
                                        name: "created"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2bc57b1052be9e99$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a5484141b8231e9a$export$2e2bcd8739ae039), {
                                        disabled: true,
                                        label: "Last Modified",
                                        name: "last_modified"
                                    })
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b3f7dc6528742bb0$export$2e2bcd8739ae039), {
                    style: {
                        marginTop: '20px'
                    },
                    setIsExpanded: (val)=>{
                        setIsAddressExpanded(val);
                    },
                    expandPanel: isAddressExpanded,
                    button: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2bc57b1052be9e99$export$fd2299f554be8993), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2bc57b1052be9e99$export$9f515a68dfaeb9ef), {
                            isExpanded: isAddressExpanded,
                            children: "Structured address"
                        })
                    }),
                    panel: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2bc57b1052be9e99$export$85524e8d4e82fc69), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $2bc57b1052be9e99$export$8f1ff89fa1ec9605), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2bc57b1052be9e99$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "Street Number",
                                        name: "address_street_no"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2bc57b1052be9e99$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "Street Name",
                                        name: "address_street_name"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2bc57b1052be9e99$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "Building Name",
                                        name: "address_building_name"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2bc57b1052be9e99$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "Floor",
                                        name: "address_floor"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2bc57b1052be9e99$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "Room",
                                        name: "address_room"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2bc57b1052be9e99$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "Department",
                                        name: "address_department"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2bc57b1052be9e99$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "Postbox",
                                        name: "address_postbox"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2bc57b1052be9e99$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "City Location",
                                        name: "address_city_location"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2bc57b1052be9e99$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "City",
                                        name: "address_city"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2bc57b1052be9e99$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "Region",
                                        name: "address_region"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2bc57b1052be9e99$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "District",
                                        name: "address_district"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2bc57b1052be9e99$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "Zipcode",
                                        name: "address_postcode"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2bc57b1052be9e99$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6e833112b656c531$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "Country",
                                        name: "address_country_code",
                                        options: (0, $735b35f584baaf3c$export$df7943177b16f2f3)
                                    })
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b3f7dc6528742bb0$export$2e2bcd8739ae039), {
                    style: {
                        marginTop: '20px'
                    },
                    setIsExpanded: (val)=>{
                        setIsFreeFormAddressExpanded(val);
                    },
                    expandPanel: isFreeFormAddressExpanded,
                    button: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2bc57b1052be9e99$export$fd2299f554be8993), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2bc57b1052be9e99$export$9f515a68dfaeb9ef), {
                            isExpanded: isFreeFormAddressExpanded,
                            children: "Free Form address"
                        })
                    }),
                    panel: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2bc57b1052be9e99$export$85524e8d4e82fc69), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2bc57b1052be9e99$export$8f1ff89fa1ec9605), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2bc57b1052be9e99$export$e151f1d86035b485), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $dfc171aac0fd6ec5$export$2e2bcd8739ae039), {
                                    disabled: viewMode,
                                    label: "Address Line",
                                    name: "address_line"
                                })
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b3f7dc6528742bb0$export$2e2bcd8739ae039), {
                    style: {
                        marginTop: '20px'
                    },
                    setIsExpanded: (val)=>{
                        setIsNationalIDExpanded(val);
                    },
                    expandPanel: isNationalIDExpanded,
                    button: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2bc57b1052be9e99$export$fd2299f554be8993), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2bc57b1052be9e99$export$9f515a68dfaeb9ef), {
                            isExpanded: isNationalIDExpanded,
                            children: "National ID"
                        })
                    }),
                    panel: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2bc57b1052be9e99$export$85524e8d4e82fc69), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $2bc57b1052be9e99$export$8f1ff89fa1ec9605), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2bc57b1052be9e99$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $99b5eccf8ae49d07$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "National ID Type",
                                        name: "national_id_type_code",
                                        options: (0, $f398806f8c37b1c3$export$1d9e1f0caa6e0145)
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2bc57b1052be9e99$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "National ID",
                                        name: "national_id"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2bc57b1052be9e99$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $99b5eccf8ae49d07$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "National ID Country Issuer",
                                        name: "national_id_issue_country",
                                        options: (0, $735b35f584baaf3c$export$df7943177b16f2f3)
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2bc57b1052be9e99$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "National ID Registration Authority",
                                        name: "national_id_registration_authority"
                                    })
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
}
// Default Props
$14039f3abedba732$var$AccountIndividualDetailsForm.defaultProps = {
    formRef: {},
    form: {},
    actions: {},
    values: {
        reference_id: '',
        account_type_id: 0,
        status_id: 0,
        email: '',
        primary_activity_code: 0,
        nationality_country_code: '',
        name_first: '',
        name_middle: '',
        name_last: '',
        date_of_birth: '',
        created: '',
        last_modified: '',
        address_street_name: '',
        address_city: '',
        address_region: '',
        address_postcode: '',
        address_country_code: ''
    },
    viewMode: true
};
// Proptypes Validation
$14039f3abedba732$var$AccountIndividualDetailsForm.propTypes = {
    formRef: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        root: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    }),
    form: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        COUNTRIES_LIST: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Array),
        toBeUpdatedAccount: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({})
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setCountryListOptions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsEntityAccountDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setToBeUpdatedAccount: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    values: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        reference_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        account_type_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        status_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        email: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        primary_activity_code: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        nationality_country_code: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        name_first: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        name_middle: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        name_last: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        date_of_birth: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        created: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        last_modified: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        address_street_name: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        address_city: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        address_region: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        address_postcode: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        address_country_code: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    }),
    viewMode: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    onSubmit: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
};
var $14039f3abedba732$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($14039f3abedba732$var$mapStateToProps, $14039f3abedba732$var$mapDispatchToProps)($14039f3abedba732$var$AccountIndividualDetailsForm);


var $8b8273179d9c47a1$export$2e2bcd8739ae039 = (0, $14039f3abedba732$export$2e2bcd8739ae039);


/* eslint-disable no-extra-boolean-cast */ 

var $tZqWC = parcelRequire("tZqWC");


var $4L3zM = parcelRequire("4L3zM");




const $d62413ffbaaad415$export$ac7496df4f1f837a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $d62413ffbaaad415$export$e151f1d86035b485 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  margin-bottom: 15px;
`;
const $d62413ffbaaad415$export$8f1ff89fa1ec9605 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(500px, 1fr));
  gap: 10px 60px;
`;
const $d62413ffbaaad415$export$71c7816ee3a5a527 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h4`
  font-size: 15px;
  font-weight: 600;
  margin: 20px 0 0 10px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $d62413ffbaaad415$export$fd2299f554be8993 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: 1fr 25px;
  gap: 50px;
  align-items: center;

  padding: 10px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $d62413ffbaaad415$export$9f515a68dfaeb9ef = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  gap: 20px;
`;
const $d62413ffbaaad415$export$85524e8d4e82fc69 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;



// Map Redux Props
const $5ecb81150034d4f6$var$mapStateToProps = (state)=>state;
const $5ecb81150034d4f6$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $5ecb81150034d4f6$var$RiskDetailsForm(props) {
    // Destructure
    const { formRef: formRef, values: values, viewMode: viewMode, onSubmit: onSubmit } = props;
    // Internal State
    const [initialData, setInitialData] = (0, $tZqWC.useState)();
    const [isRiskExpanded, setIsRiskExpanded] = (0, $tZqWC.useState)(false);
    // Variables
    const validationSchema = $84bdfb0f595586e8$export$185802fd694ee1f5().shape({
        account_risk_value: $add935e52327df44$export$185802fd694ee1f5().nullable(),
        pep_id: $add935e52327df44$export$185802fd694ee1f5().nullable(),
        sanction_id: $add935e52327df44$export$185802fd694ee1f5().nullable(),
        adverse_media_id: $add935e52327df44$export$185802fd694ee1f5().nullable(),
        comments: $7092ea25693c72ef$export$185802fd694ee1f5().nullable()
    });
    // UseEffects
    (0, $tZqWC.useEffect)(()=>{
        setInitialData(values);
    }, [
        values
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d62413ffbaaad415$export$ac7496df4f1f837a), {
        children: initialData && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $506ef65bbb4994b7$export$2e2bcd8739ae039), {
            formRef: formRef,
            initialValues: initialData,
            validationSchema: validationSchema,
            onSubmit: onSubmit,
            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b3f7dc6528742bb0$export$2e2bcd8739ae039), {
                style: {
                    marginTop: '20px'
                },
                setIsExpanded: (val)=>{
                    setIsRiskExpanded(val);
                },
                expandPanel: isRiskExpanded,
                button: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d62413ffbaaad415$export$fd2299f554be8993), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d62413ffbaaad415$export$9f515a68dfaeb9ef), {
                        isExpanded: isRiskExpanded,
                        children: "Risk and Verification"
                    })
                }),
                panel: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $d62413ffbaaad415$export$85524e8d4e82fc69), {
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $d62413ffbaaad415$export$8f1ff89fa1ec9605), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d62413ffbaaad415$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $99b5eccf8ae49d07$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        type: "number",
                                        label: "Account Risk",
                                        name: "account_risk_value",
                                        options: (0, $f398806f8c37b1c3$export$ac88620a652f8304)
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d62413ffbaaad415$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $99b5eccf8ae49d07$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        type: "number",
                                        label: "PEP",
                                        name: "pep_id",
                                        options: (0, $f398806f8c37b1c3$export$25da77dc5a049837)
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d62413ffbaaad415$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $99b5eccf8ae49d07$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        type: "number",
                                        label: "Sanction",
                                        name: "sanction_id",
                                        options: (0, $f398806f8c37b1c3$export$25da77dc5a049837)
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d62413ffbaaad415$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $99b5eccf8ae49d07$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        type: "number",
                                        label: "Adverse Media",
                                        name: "adverse_media_id",
                                        options: (0, $f398806f8c37b1c3$export$25da77dc5a049837)
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d62413ffbaaad415$export$8f1ff89fa1ec9605), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d62413ffbaaad415$export$e151f1d86035b485), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $dfc171aac0fd6ec5$export$2e2bcd8739ae039), {
                                    disabled: viewMode,
                                    label: "Comments",
                                    name: "comments",
                                    rows: "4"
                                })
                            })
                        })
                    ]
                })
            })
        })
    });
}
// Default Props
$5ecb81150034d4f6$var$RiskDetailsForm.defaultProps = {
    formRef: {},
    form: {},
    actions: {},
    values: {
        account_risk_value: 0,
        pep_id: '',
        sanction_id: '',
        adverse_media_id: '',
        comments: ''
    },
    viewMode: true
};
// Proptypes Validation
$5ecb81150034d4f6$var$RiskDetailsForm.propTypes = {
    formRef: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        root: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    }),
    onSubmit: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    form: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        countryListOptions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Array),
        toBeUpdatedAccount: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setCountryListOptions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsEntityAccountDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setToBeUpdatedAccount: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    values: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        account_risk_value: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        account_type_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        pep_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        sanction_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        adverse_media_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        comments: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    }),
    viewMode: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
};
var $5ecb81150034d4f6$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($5ecb81150034d4f6$var$mapStateToProps, $5ecb81150034d4f6$var$mapDispatchToProps)($5ecb81150034d4f6$var$RiskDetailsForm);


var $d9b5ab15e6992d28$export$2e2bcd8739ae039 = (0, $5ecb81150034d4f6$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");


var $4L3zM = parcelRequire("4L3zM");



const $6513bd8c592cec6e$export$6300bf49fafd172 = {
    '-2': {
        value: -2,
        label: 'Requested'
    },
    '-1': {
        value: -1,
        label: 'Rejected'
    },
    0: {
        value: 0,
        label: 'Non-Customer'
    },
    1: {
        value: 1,
        label: 'Customer'
    },
    2: {
        value: 2,
        label: 'Mid Prospect'
    },
    3: {
        value: 3,
        label: 'Trial Account'
    },
    4: {
        value: 4,
        label: 'Inactive Customer'
    }
};
const $6513bd8c592cec6e$export$9dfee4db1c22f5c3 = {
    Requested: -2,
    Rejected: -1,
    NonCustomer: 0,
    Customer: 1,
    MidProspect: 2,
    TrialAccount: 3,
    InactiveCustomer: 4
};
const $6513bd8c592cec6e$export$9bccc92e05b934b3 = [
    {
        value: -2,
        label: 'Requested'
    },
    {
        value: -1,
        label: 'Rejected'
    },
    {
        value: 0,
        label: 'Non-Customer'
    },
    {
        value: 1,
        label: 'Customer'
    },
    {
        value: 2,
        label: 'Mid Prospect'
    },
    {
        value: 3,
        label: 'Trial Account'
    },
    {
        value: 4,
        label: 'Inactive Customer'
    }
];




const $3e39c3dc0d4f21bb$export$ac7496df4f1f837a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $3e39c3dc0d4f21bb$export$e151f1d86035b485 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  & > div > div {
    margin-bottom: 0 !important;
  }
`;
const $3e39c3dc0d4f21bb$export$8f1ff89fa1ec9605 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  align-items: start;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  gap: 10px 60px;
`;
const $3e39c3dc0d4f21bb$export$71c7816ee3a5a527 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h4`
  font-size: 15px;
  font-weight: 600;
  margin: 20px 0 0 10px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $3e39c3dc0d4f21bb$export$fd2299f554be8993 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: 1fr 25px;
  gap: 50px;
  align-items: center;

  padding: 10px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $3e39c3dc0d4f21bb$export$9f515a68dfaeb9ef = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  gap: 20px;
`;
const $3e39c3dc0d4f21bb$export$85524e8d4e82fc69 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;



// Map Redux Props
const $32f48de2673b3bd4$var$mapStateToProps = (state)=>state;
const $32f48de2673b3bd4$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $32f48de2673b3bd4$var$VaspDetailsForm(props) {
    // Destructure
    const { values: values, viewMode: viewMode, formRef: formRef, ...rest } = props;
    // Internal State
    const [initialData, setInitialData] = (0, $tZqWC.useState)();
    // Forms
    const [isDetailsExpanded, setIsDetailsExpanded] = (0, $tZqWC.useState)(true);
    const [isAddressExpanded, setIsAddressExpanded] = (0, $tZqWC.useState)(false);
    const [isFreeFormAddressExpanded, setIsFreeFormAddressExpanded] = (0, $tZqWC.useState)(false);
    const [isNationalIDExpanded, setIsNationalIDExpanded] = (0, $tZqWC.useState)(false);
    // Variables
    const BooleanOptions = [
        {
            value: true,
            label: 'True'
        },
        {
            value: false,
            label: 'False'
        }
    ];
    const userCredentials = JSON.parse(localStorage.getItem('userCredentials'));
    const validationSchema = $84bdfb0f595586e8$export$185802fd694ee1f5().shape({
        vasp_id: $7092ea25693c72ef$export$185802fd694ee1f5().nullable(),
        customer_status_id: $add935e52327df44$export$185802fd694ee1f5(),
        email: $7092ea25693c72ef$export$185802fd694ee1f5().email().nullable(),
        website: $7092ea25693c72ef$export$185802fd694ee1f5().nullable(),
        name_business: $7092ea25693c72ef$export$185802fd694ee1f5().nullable(),
        name_legal: $7092ea25693c72ef$export$185802fd694ee1f5().nullable(),
        summary: $7092ea25693c72ef$export$185802fd694ee1f5().nullable(),
        created: $e039e5cb92bd30b2$export$185802fd694ee1f5().nullable(),
        last_modified: $e039e5cb92bd30b2$export$185802fd694ee1f5().nullable(),
        address_line: $7092ea25693c72ef$export$185802fd694ee1f5(),
        address_street_no: $7092ea25693c72ef$export$185802fd694ee1f5(),
        address_street_name: $7092ea25693c72ef$export$185802fd694ee1f5(),
        address_building_name: $7092ea25693c72ef$export$185802fd694ee1f5(),
        address_floor: $7092ea25693c72ef$export$185802fd694ee1f5().max(20).nullable(),
        address_room: $7092ea25693c72ef$export$185802fd694ee1f5().max(20).nullable(),
        address_department: $7092ea25693c72ef$export$185802fd694ee1f5().max(20).nullable(),
        address_postbox: $7092ea25693c72ef$export$185802fd694ee1f5().max(20).nullable(),
        address_city_location: $7092ea25693c72ef$export$185802fd694ee1f5().max(50).nullable(),
        address_city: $7092ea25693c72ef$export$185802fd694ee1f5().max(50).nullable(),
        address_region: $7092ea25693c72ef$export$185802fd694ee1f5().max(50).nullable(),
        address_district: $7092ea25693c72ef$export$185802fd694ee1f5().max(50).nullable(),
        address_postcode: $7092ea25693c72ef$export$185802fd694ee1f5().max(25).nullable(),
        address_country_code: $7092ea25693c72ef$export$185802fd694ee1f5().max(2).nullable(),
        national_id_type_code: $7092ea25693c72ef$export$185802fd694ee1f5().max(10).nullable(),
        national_id: $7092ea25693c72ef$export$185802fd694ee1f5().max(35).nullable(),
        national_id_issue_country: $7092ea25693c72ef$export$185802fd694ee1f5().max(2).nullable(),
        national_id_registration_authority: $7092ea25693c72ef$export$185802fd694ee1f5().max(10).nullable()
    });
    // Functions
    // UseEffects
    (0, $tZqWC.useEffect)(()=>{
        setInitialData(values);
    }, [
        values
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3e39c3dc0d4f21bb$export$ac7496df4f1f837a), {
        ...rest,
        children: initialData && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $506ef65bbb4994b7$export$2e2bcd8739ae039), {
            formRef: formRef,
            initialValues: initialData,
            validationSchema: validationSchema,
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b3f7dc6528742bb0$export$2e2bcd8739ae039), {
                    style: {
                        marginTop: '20px'
                    },
                    setIsExpanded: (val)=>{
                        setIsDetailsExpanded(val);
                    },
                    expandPanel: isDetailsExpanded,
                    button: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3e39c3dc0d4f21bb$export$fd2299f554be8993), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3e39c3dc0d4f21bb$export$9f515a68dfaeb9ef), {
                            isExpanded: isDetailsExpanded,
                            children: "Business information"
                        })
                    }),
                    panel: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3e39c3dc0d4f21bb$export$85524e8d4e82fc69), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3e39c3dc0d4f21bb$export$8f1ff89fa1ec9605), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3e39c3dc0d4f21bb$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                        disabled: true,
                                        label: "Vasp ID",
                                        name: "vasp_id"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3e39c3dc0d4f21bb$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "Business Name",
                                        name: "name_business"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3e39c3dc0d4f21bb$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "Legal Name",
                                        name: "name_legal"
                                    })
                                }),
                                userCredentials?.role_id === 0 && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3e39c3dc0d4f21bb$export$e151f1d86035b485), {
                                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $99b5eccf8ae49d07$export$2e2bcd8739ae039), {
                                                disabled: viewMode,
                                                label: "Customer Status",
                                                options: (0, $6513bd8c592cec6e$export$9bccc92e05b934b3),
                                                name: "customer_status_id"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3e39c3dc0d4f21bb$export$e151f1d86035b485), {
                                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $99b5eccf8ae49d07$export$2e2bcd8739ae039), {
                                                disabled: viewMode,
                                                label: "Is Active Customer",
                                                options: BooleanOptions,
                                                name: "is_active_customer"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3e39c3dc0d4f21bb$export$e151f1d86035b485), {
                                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $99b5eccf8ae49d07$export$2e2bcd8739ae039), {
                                                disabled: viewMode,
                                                label: "Is Active VASP",
                                                options: BooleanOptions,
                                                name: "is_active_vasp"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3e39c3dc0d4f21bb$export$e151f1d86035b485), {
                                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $99b5eccf8ae49d07$export$2e2bcd8739ae039), {
                                                disabled: viewMode,
                                                label: "Is VASP",
                                                options: BooleanOptions,
                                                name: "is_vasp"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3e39c3dc0d4f21bb$export$e151f1d86035b485), {
                                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $99b5eccf8ae49d07$export$2e2bcd8739ae039), {
                                                disabled: viewMode,
                                                label: "Is Verified VASP",
                                                options: BooleanOptions,
                                                name: "is_verified_vasp"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3e39c3dc0d4f21bb$export$e151f1d86035b485), {
                                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                                disabled: viewMode,
                                                label: "Contact Email",
                                                type: "email",
                                                name: "email_contact"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3e39c3dc0d4f21bb$export$e151f1d86035b485), {
                                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                                disabled: viewMode,
                                                label: "Notification Email",
                                                type: "email",
                                                name: "email_notification"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3e39c3dc0d4f21bb$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "Website",
                                        name: "website"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3e39c3dc0d4f21bb$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a5484141b8231e9a$export$2e2bcd8739ae039), {
                                        disabled: true,
                                        label: "Created",
                                        name: "created"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3e39c3dc0d4f21bb$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a5484141b8231e9a$export$2e2bcd8739ae039), {
                                        disabled: true,
                                        label: "Last Modified",
                                        name: "last_modified"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3e39c3dc0d4f21bb$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $dfc171aac0fd6ec5$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "Summary",
                                        name: "summary",
                                        rows: "4"
                                    })
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b3f7dc6528742bb0$export$2e2bcd8739ae039), {
                    style: {
                        marginTop: '20px'
                    },
                    setIsExpanded: (val)=>{
                        setIsAddressExpanded(val);
                    },
                    expandPanel: isAddressExpanded,
                    button: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3e39c3dc0d4f21bb$export$fd2299f554be8993), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3e39c3dc0d4f21bb$export$9f515a68dfaeb9ef), {
                            isExpanded: isAddressExpanded,
                            children: "Structured address"
                        })
                    }),
                    panel: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3e39c3dc0d4f21bb$export$85524e8d4e82fc69), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3e39c3dc0d4f21bb$export$8f1ff89fa1ec9605), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3e39c3dc0d4f21bb$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "Street Number",
                                        name: "address_street_no"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3e39c3dc0d4f21bb$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "Street Name",
                                        name: "address_street_name"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3e39c3dc0d4f21bb$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "Building Name",
                                        name: "address_building_name"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3e39c3dc0d4f21bb$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "Floor",
                                        name: "address_floor"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3e39c3dc0d4f21bb$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "Room",
                                        name: "address_room"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3e39c3dc0d4f21bb$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "Department",
                                        name: "address_department"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3e39c3dc0d4f21bb$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "Postbox",
                                        name: "address_postbox"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3e39c3dc0d4f21bb$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "City Location",
                                        name: "address_city_location"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3e39c3dc0d4f21bb$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "City",
                                        name: "address_city"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3e39c3dc0d4f21bb$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "Region",
                                        name: "address_region"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3e39c3dc0d4f21bb$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "District",
                                        name: "address_district"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3e39c3dc0d4f21bb$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "Zipcode",
                                        name: "address_postcode"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3e39c3dc0d4f21bb$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6e833112b656c531$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "Country",
                                        name: "address_country_code",
                                        options: (0, $735b35f584baaf3c$export$df7943177b16f2f3)
                                    })
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b3f7dc6528742bb0$export$2e2bcd8739ae039), {
                    style: {
                        marginTop: '20px'
                    },
                    setIsExpanded: (val)=>{
                        setIsFreeFormAddressExpanded(val);
                    },
                    expandPanel: isFreeFormAddressExpanded,
                    button: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3e39c3dc0d4f21bb$export$fd2299f554be8993), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3e39c3dc0d4f21bb$export$9f515a68dfaeb9ef), {
                            isExpanded: isFreeFormAddressExpanded,
                            children: "Free form address"
                        })
                    }),
                    panel: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3e39c3dc0d4f21bb$export$85524e8d4e82fc69), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3e39c3dc0d4f21bb$export$8f1ff89fa1ec9605), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3e39c3dc0d4f21bb$export$e151f1d86035b485), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $dfc171aac0fd6ec5$export$2e2bcd8739ae039), {
                                    disabled: viewMode,
                                    label: "Address Line",
                                    name: "address_line"
                                })
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b3f7dc6528742bb0$export$2e2bcd8739ae039), {
                    style: {
                        marginTop: '20px'
                    },
                    setIsExpanded: (val)=>{
                        setIsNationalIDExpanded(val);
                    },
                    expandPanel: isNationalIDExpanded,
                    button: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3e39c3dc0d4f21bb$export$fd2299f554be8993), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3e39c3dc0d4f21bb$export$9f515a68dfaeb9ef), {
                            isExpanded: isNationalIDExpanded,
                            children: "National ID"
                        })
                    }),
                    panel: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3e39c3dc0d4f21bb$export$85524e8d4e82fc69), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3e39c3dc0d4f21bb$export$8f1ff89fa1ec9605), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3e39c3dc0d4f21bb$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $99b5eccf8ae49d07$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "National ID Type",
                                        name: "national_id_type_code",
                                        options: (0, $f398806f8c37b1c3$export$1d9e1f0caa6e0145)
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3e39c3dc0d4f21bb$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "National ID",
                                        name: "national_id"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3e39c3dc0d4f21bb$export$e151f1d86035b485), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                        disabled: viewMode,
                                        label: "National ID Registration Authority",
                                        name: "national_id_registration_authority"
                                    })
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
}
// Default Props
$32f48de2673b3bd4$var$VaspDetailsForm.defaultProps = {
    formRef: {},
    form: {},
    actions: {},
    values: {
        external_id: '',
        email: '',
        name_business: '',
        name_legal: '',
        incorporation_country: '',
        inc_date: '',
        primary_activity_id: 0,
        created: '',
        last_modified: '',
        address_street: '',
        address_city: '',
        address_region: '',
        address_postcode: '',
        address_country_code: ''
    },
    viewMode: true
};
// Proptypes Validation
$32f48de2673b3bd4$var$VaspDetailsForm.propTypes = {
    formRef: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        root: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    }),
    form: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        COUNTRIES_LIST: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Array),
        toBeUpdatedAccount: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setCountryListOptions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsEntityAccountDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setToBeUpdatedAccount: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    values: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        external_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        email: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        name_business: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        name_legal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        incorporation_country: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        inc_date: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        primary_activity_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        created: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        last_modified: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        address_street: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        address_city: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        address_region: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        address_postcode: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        address_country_code: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    }),
    viewMode: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
};
var $32f48de2673b3bd4$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($32f48de2673b3bd4$var$mapStateToProps, $32f48de2673b3bd4$var$mapDispatchToProps)($32f48de2673b3bd4$var$VaspDetailsForm);


var $31c31aa6819313d7$export$2e2bcd8739ae039 = (0, $32f48de2673b3bd4$export$2e2bcd8739ae039);



parcelRequire("tZqWC");


var $4L3zM = parcelRequire("4L3zM");




const $e7588abebcb4cc9b$export$ac7496df4f1f837a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $e7588abebcb4cc9b$export$e151f1d86035b485 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  & > div > div {
    margin-bottom: 0 !important;
  }
`;
const $e7588abebcb4cc9b$export$8f1ff89fa1ec9605 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  align-items: start;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  gap: 10px 60px;
`;
const $e7588abebcb4cc9b$export$71c7816ee3a5a527 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h4`
  font-size: 15px;
  font-weight: 600;
  margin: 20px 0 0 10px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $e7588abebcb4cc9b$export$fd2299f554be8993 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: 1fr 25px;
  gap: 50px;
  align-items: center;

  padding: 10px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $e7588abebcb4cc9b$export$9f515a68dfaeb9ef = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  gap: 20px;
`;
const $e7588abebcb4cc9b$export$85524e8d4e82fc69 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
const $e7588abebcb4cc9b$export$d53c836cccbb0d90 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
`;



// Map Redux Props
const $c23273fabb93eeaa$var$mapStateToProps = (state)=>state;
const $c23273fabb93eeaa$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $c23273fabb93eeaa$var$AdminUserDetailsForm(props) {
    // Destructure
    const { values: values, viewMode: viewMode, formRef: formRef } = props;
    // Variables
    const BooleanOptions = [
        {
            value: true,
            label: 'True'
        },
        {
            value: false,
            label: 'False'
        }
    ];
    const validationSchema = $84bdfb0f595586e8$export$185802fd694ee1f5().shape({
        user_id: $7092ea25693c72ef$export$185802fd694ee1f5().nullable(),
        role_id: $add935e52327df44$export$185802fd694ee1f5(),
        email: $7092ea25693c72ef$export$185802fd694ee1f5().email().nullable(),
        name_first: $7092ea25693c72ef$export$185802fd694ee1f5().nullable(),
        name_last: $7092ea25693c72ef$export$185802fd694ee1f5().nullable(),
        phone: $7092ea25693c72ef$export$185802fd694ee1f5().nullable(),
        timezone_code: $7092ea25693c72ef$export$185802fd694ee1f5().nullable(),
        business_id: $7092ea25693c72ef$export$185802fd694ee1f5().nullable(),
        is_active: $b84f09f6970af0be$export$185802fd694ee1f5().nullable(),
        is_verified: $b84f09f6970af0be$export$185802fd694ee1f5().nullable(),
        is_external: $b84f09f6970af0be$export$185802fd694ee1f5().nullable(),
        has_2fa: $b84f09f6970af0be$export$185802fd694ee1f5().nullable()
    });
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $506ef65bbb4994b7$export$2e2bcd8739ae039), {
        formRef: formRef,
        initialValues: values,
        validationSchema: validationSchema,
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e7588abebcb4cc9b$export$85524e8d4e82fc69), {
            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $e7588abebcb4cc9b$export$8f1ff89fa1ec9605), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e7588abebcb4cc9b$export$e151f1d86035b485), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $99b5eccf8ae49d07$export$2e2bcd8739ae039), {
                            disabled: viewMode,
                            label: "User Role",
                            options: (0, $f398806f8c37b1c3$export$43fbb932cb09c7d),
                            name: "role_id"
                        })
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e7588abebcb4cc9b$export$e151f1d86035b485), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                            disabled: viewMode,
                            label: "First Name",
                            name: "name_first"
                        })
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e7588abebcb4cc9b$export$e151f1d86035b485), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                            disabled: viewMode,
                            label: "Last Name",
                            name: "name_last"
                        })
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e7588abebcb4cc9b$export$e151f1d86035b485), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                            disabled: viewMode,
                            label: "Email",
                            type: "email",
                            name: "email"
                        })
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e7588abebcb4cc9b$export$e151f1d86035b485), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                            disabled: viewMode,
                            label: "Phone",
                            name: "phone"
                        })
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e7588abebcb4cc9b$export$e151f1d86035b485), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                            disabled: viewMode,
                            label: "Timezone Code",
                            name: "timezone_code"
                        })
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e7588abebcb4cc9b$export$e151f1d86035b485), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $99b5eccf8ae49d07$export$2e2bcd8739ae039), {
                            disabled: viewMode,
                            label: "Is Active",
                            options: BooleanOptions,
                            name: "is_active"
                        })
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e7588abebcb4cc9b$export$e151f1d86035b485), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $99b5eccf8ae49d07$export$2e2bcd8739ae039), {
                            disabled: true,
                            label: "Is Verified",
                            options: BooleanOptions,
                            name: "is_verified"
                        })
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e7588abebcb4cc9b$export$e151f1d86035b485), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $99b5eccf8ae49d07$export$2e2bcd8739ae039), {
                            disabled: viewMode,
                            label: "Is External",
                            options: BooleanOptions,
                            name: "is_external"
                        })
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e7588abebcb4cc9b$export$e151f1d86035b485), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $99b5eccf8ae49d07$export$2e2bcd8739ae039), {
                            disabled: true,
                            label: "Has Two-Factor Authentication",
                            options: BooleanOptions,
                            name: "has_2fa"
                        })
                    })
                ]
            })
        })
    });
}
// Default Props
$c23273fabb93eeaa$var$AdminUserDetailsForm.defaultProps = {
    formRef: {},
    form: {},
    actions: {},
    values: {},
    viewMode: true
};
// Proptypes Validation
$c23273fabb93eeaa$var$AdminUserDetailsForm.propTypes = {
    formRef: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        root: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    }),
    form: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        COUNTRIES_LIST: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Array),
        toBeUpdatedAccount: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setCountryListOptions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsEntityAccountDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setToBeUpdatedAccount: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    values: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        user_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        role_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        email: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        name_first: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        name_last: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        phone: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        timezone_code: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        business_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        is_active: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
        is_verified: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
        is_external: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
        has_2fa: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    viewMode: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
};
var $c23273fabb93eeaa$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($c23273fabb93eeaa$var$mapStateToProps, $c23273fabb93eeaa$var$mapDispatchToProps)($c23273fabb93eeaa$var$AdminUserDetailsForm);


var $da8de0476a978994$export$2e2bcd8739ae039 = (0, $c23273fabb93eeaa$export$2e2bcd8739ae039);


/* eslint-disable react/prop-types */ 
parcelRequire("tZqWC");


var $4L3zM = parcelRequire("4L3zM");



const $6a3a8ba857bbe8a8$export$ac7496df4f1f837a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $6a3a8ba857bbe8a8$export$e151f1d86035b485 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  & > div > div {
    margin-bottom: 0 !important;
  }
`;
const $6a3a8ba857bbe8a8$export$8f1ff89fa1ec9605 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  align-items: start;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  gap: 10px 60px;
`;
const $6a3a8ba857bbe8a8$export$71c7816ee3a5a527 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h4`
  font-size: 15px;
  font-weight: 600;
  margin: 20px 0 0 10px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $6a3a8ba857bbe8a8$export$fd2299f554be8993 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: 1fr 25px;
  gap: 50px;
  align-items: center;

  padding: 10px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $6a3a8ba857bbe8a8$export$9f515a68dfaeb9ef = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  gap: 20px;
`;
const $6a3a8ba857bbe8a8$export$85524e8d4e82fc69 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
const $6a3a8ba857bbe8a8$export$d53c836cccbb0d90 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
`;



// Map Redux Props
const $b3f5ee7495ad8dda$var$mapStateToProps = (state)=>state;
const $b3f5ee7495ad8dda$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $b3f5ee7495ad8dda$var$AiDocumentUploadForm(props) {
    // Destructure
    const { values: values, viewMode: viewMode, formRef: formRef, onSubmit: onSubmit } = props;
    // Variables
    const validationSchema = $84bdfb0f595586e8$export$185802fd694ee1f5().shape({
        title: $7092ea25693c72ef$export$185802fd694ee1f5().required(),
        summary: $7092ea25693c72ef$export$185802fd694ee1f5().required(),
        web_url: $7092ea25693c72ef$export$185802fd694ee1f5().nullable(),
        file: $765ac6576a95acd2$export$185802fd694ee1f5().nullable()
    });
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $506ef65bbb4994b7$export$2e2bcd8739ae039), {
        formRef: formRef,
        initialValues: values,
        validationSchema: validationSchema,
        onSubmit: onSubmit,
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6a3a8ba857bbe8a8$export$85524e8d4e82fc69), {
            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6a3a8ba857bbe8a8$export$8f1ff89fa1ec9605), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6a3a8ba857bbe8a8$export$e151f1d86035b485), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                            disabled: viewMode,
                            label: "Title",
                            name: "title"
                        })
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6a3a8ba857bbe8a8$export$e151f1d86035b485), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                            disabled: viewMode,
                            label: "Summary",
                            name: "summary"
                        })
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6a3a8ba857bbe8a8$export$e151f1d86035b485), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                            disabled: viewMode,
                            label: "Web URL (optional)",
                            name: "web_url"
                        })
                    })
                ]
            })
        })
    });
}
// Default Props
$b3f5ee7495ad8dda$var$AiDocumentUploadForm.defaultProps = {
    formRef: {},
    values: {},
    viewMode: true
};
// Proptypes Validation
$b3f5ee7495ad8dda$var$AiDocumentUploadForm.propTypes = {
    formRef: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        root: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    }),
    values: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        title: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        summary: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        web_url: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        // eslint-disable-next-line react/forbid-prop-types
        file: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).any
    }),
    viewMode: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    onSubmit: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
};
var $b3f5ee7495ad8dda$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($b3f5ee7495ad8dda$var$mapStateToProps, $b3f5ee7495ad8dda$var$mapDispatchToProps)($b3f5ee7495ad8dda$var$AiDocumentUploadForm);


var $32de1bcd4e009194$export$2e2bcd8739ae039 = (0, $b3f5ee7495ad8dda$export$2e2bcd8739ae039);



parcelRequire("tZqWC");


var $4L3zM = parcelRequire("4L3zM");





const $77fca4483f76fa8b$export$e151f1d86035b485 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  & > div > div {
    margin-bottom: 0 !important;
  }
`;
const $77fca4483f76fa8b$export$8f1ff89fa1ec9605 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  margin: 0 0 40px 0;
`;



// Map Redux Props
const $b3ddd4bf1c5a974c$var$mapStateToProps = (state)=>state;
const $b3ddd4bf1c5a974c$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $b3ddd4bf1c5a974c$var$UserForm(props) {
    // Destructure
    const { formRef: formRef, handleSubmit: handleSubmit } = props;
    // Hooks
    const [userCredentials] = (0, $a9c50ebe96619b20$export$2e2bcd8739ae039)('userCredentials');
    // Variables
    const validationSchema = $84bdfb0f595586e8$export$185802fd694ee1f5().shape({
        email: $7092ea25693c72ef$export$185802fd694ee1f5().email().required('Email is required.'),
        name_first: $7092ea25693c72ef$export$185802fd694ee1f5().max(100).required('First name is required.'),
        name_last: $7092ea25693c72ef$export$185802fd694ee1f5().max(100).required('Last name is required.'),
        role_id: $add935e52327df44$export$185802fd694ee1f5().required('Role is required.'),
        password: $7092ea25693c72ef$export$185802fd694ee1f5().min(8, 'Password must be at least 8 characters').matches(/[A-Z]/, 'Password must contain at least one uppercase letter').matches(/[a-z]/, 'Password must contain at least one lowercase letter').matches(/[0-9]/, 'Password must contain at least one number').matches(/[!@#$%^&*(),.?":{}|<>]/, 'Password must contain at least one special character'),
        confirm_password: $7092ea25693c72ef$export$185802fd694ee1f5().when('password', {
            is: (val)=>!!(val && val.length > 0),
            then: $7092ea25693c72ef$export$185802fd694ee1f5().oneOf([
                $2af0df923a102911$export$185802fd694ee1f5('password')
            ], 'Both password need to be the same')
        })
    });
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $506ef65bbb4994b7$export$2e2bcd8739ae039), {
        formRef: formRef,
        validationSchema: validationSchema,
        onSubmit: handleSubmit,
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $77fca4483f76fa8b$export$8f1ff89fa1ec9605), {
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $77fca4483f76fa8b$export$e151f1d86035b485), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                        label: "Email (Required)",
                        type: "email",
                        name: "email"
                    })
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $77fca4483f76fa8b$export$e151f1d86035b485), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                        label: "First Name (Required)",
                        name: "name_first"
                    })
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $77fca4483f76fa8b$export$e151f1d86035b485), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                        label: "Last Name (Required)",
                        name: "name_last"
                    })
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $77fca4483f76fa8b$export$e151f1d86035b485), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $99b5eccf8ae49d07$export$2e2bcd8739ae039), {
                        label: "Role Type (Required)",
                        name: "role_id",
                        options: (0, $f398806f8c37b1c3$export$43fbb932cb09c7d)
                    })
                }),
                userCredentials?.role_id === 0 && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $77fca4483f76fa8b$export$e151f1d86035b485), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                label: "Password",
                                type: "password",
                                name: "password"
                            })
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $77fca4483f76fa8b$export$e151f1d86035b485), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                label: "Confirm Password",
                                type: "password",
                                name: "confirm_password"
                            })
                        })
                    ]
                })
            ]
        })
    });
}
// Default Props
$b3ddd4bf1c5a974c$var$UserForm.defaultProps = {
    formRef: {},
    form: {},
    actions: {},
    values: {
        external_id: '',
        account_type_id: 0,
        status_id: 0,
        email: '',
        primary_activity_code: 0,
        nationality_code: '',
        name_first: '',
        name_middle: '',
        name_last: '',
        dob: '',
        created: '',
        last_modified: '',
        address_street: '',
        address_city: '',
        address_region: '',
        address_postcode: '',
        address_country_code: ''
    }
};
// Proptypes Validation
$b3ddd4bf1c5a974c$var$UserForm.propTypes = {
    formRef: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        root: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    }),
    form: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        COUNTRIES_LIST: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Array),
        toBeUpdatedAccount: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({})
    }),
    handleSubmit: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setCountryListOptions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsEntityAccountDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsUserDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    values: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        external_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        account_type_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        status_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        email: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        primary_activity_code: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        nationality_code: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        name_first: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        name_middle: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        name_last: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        dob: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        created: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        last_modified: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        address_street: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        address_city: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        address_region: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        address_postcode: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        address_country_code: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    })
};
var $b3ddd4bf1c5a974c$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($b3ddd4bf1c5a974c$var$mapStateToProps, $b3ddd4bf1c5a974c$var$mapDispatchToProps)($b3ddd4bf1c5a974c$var$UserForm);


var $29f9c1b9bfe7b1a8$export$2e2bcd8739ae039 = (0, $b3ddd4bf1c5a974c$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");
var $e6f80c3bb3fc9ef9$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $e6f80c3bb3fc9ef9$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used as references for various `Number` constants. */ var $e6f80c3bb3fc9ef9$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $e6f80c3bb3fc9ef9$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $e6f80c3bb3fc9ef9$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $e6f80c3bb3fc9ef9$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $e6f80c3bb3fc9ef9$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $e6f80c3bb3fc9ef9$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $e6f80c3bb3fc9ef9$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $e6f80c3bb3fc9ef9$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $e6f80c3bb3fc9ef9$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $e6f80c3bb3fc9ef9$var$root = $e6f80c3bb3fc9ef9$var$freeGlobal || $e6f80c3bb3fc9ef9$var$freeSelf || Function('return this')();
/** Used for built-in method references. */ var $e6f80c3bb3fc9ef9$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $e6f80c3bb3fc9ef9$var$objectToString = $e6f80c3bb3fc9ef9$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $e6f80c3bb3fc9ef9$var$nativeMax = Math.max, $e6f80c3bb3fc9ef9$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $e6f80c3bb3fc9ef9$var$now = function() {
    return $e6f80c3bb3fc9ef9$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $e6f80c3bb3fc9ef9$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($e6f80c3bb3fc9ef9$var$FUNC_ERROR_TEXT);
    wait = $e6f80c3bb3fc9ef9$var$toNumber(wait) || 0;
    if ($e6f80c3bb3fc9ef9$var$isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $e6f80c3bb3fc9ef9$var$nativeMax($e6f80c3bb3fc9ef9$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $e6f80c3bb3fc9ef9$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $e6f80c3bb3fc9ef9$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($e6f80c3bb3fc9ef9$var$now());
    }
    function debounced() {
        var time = $e6f80c3bb3fc9ef9$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $e6f80c3bb3fc9ef9$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $e6f80c3bb3fc9ef9$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $e6f80c3bb3fc9ef9$var$isSymbol(value) {
    return typeof value == 'symbol' || $e6f80c3bb3fc9ef9$var$isObjectLike(value) && $e6f80c3bb3fc9ef9$var$objectToString.call(value) == $e6f80c3bb3fc9ef9$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $e6f80c3bb3fc9ef9$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($e6f80c3bb3fc9ef9$var$isSymbol(value)) return $e6f80c3bb3fc9ef9$var$NAN;
    if ($e6f80c3bb3fc9ef9$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $e6f80c3bb3fc9ef9$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($e6f80c3bb3fc9ef9$var$reTrim, '');
    var isBinary = $e6f80c3bb3fc9ef9$var$reIsBinary.test(value);
    return isBinary || $e6f80c3bb3fc9ef9$var$reIsOctal.test(value) ? $e6f80c3bb3fc9ef9$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $e6f80c3bb3fc9ef9$var$reIsBadHex.test(value) ? $e6f80c3bb3fc9ef9$var$NAN : +value;
}
$e6f80c3bb3fc9ef9$exports = $e6f80c3bb3fc9ef9$var$debounce;




// * Accounts
const $1d84337a7f0d29d8$export$6c56a740ce3e4ebf = [
    {
        label: 'All',
        value: undefined
    },
    {
        label: 'Inactive',
        value: 0
    },
    {
        label: 'Active',
        value: 1
    },
    {
        label: 'On Hold',
        value: 2
    },
    {
        label: 'Dormant',
        value: 3
    }
];
const $1d84337a7f0d29d8$export$c6cd43238830f06a = [
    {
        label: 'All',
        value: undefined
    },
    {
        label: 'Individual',
        value: 1
    },
    {
        label: 'Entity',
        value: 2
    }
];
const $1d84337a7f0d29d8$export$2d9f9e1a89baccd1 = [
    {
        label: 'Newest',
        value: '-created'
    },
    {
        label: 'Oldest',
        value: 'created'
    }
];
const $1d84337a7f0d29d8$export$67cdc1b213fb68fd = [
    {
        value: 'customer',
        label: 'Customer'
    },
    {
        value: 'non-customer',
        label: 'Non-Customer'
    },
    {
        value: 'all',
        label: 'All'
    }
];
const $1d84337a7f0d29d8$export$28744492cdd1c1a0 = [
    {
        label: 'Oldest',
        value: 'created'
    },
    {
        label: 'Newest',
        value: '-created'
    },
    {
        label: 'Name (A-Z)',
        value: 'name_legal'
    },
    {
        label: 'Name (Z-A)',
        value: '-name_legal'
    }
];
const $1d84337a7f0d29d8$export$641ab1eef3e226d9 = [
    {
        label: 'Amount (Highest)',
        value: '-amount'
    },
    {
        label: 'Amount (Lowest)',
        value: 'amount'
    },
    {
        label: 'Date (Newest)',
        value: '-last_modified'
    },
    {
        label: 'Date (Oldest)',
        value: 'last_modified'
    }
];
const $1d84337a7f0d29d8$export$bd15dd234c4e5fbf = [
    {
        label: 'All',
        value: undefined
    },
    {
        label: 'Rejected',
        value: -3
    },
    {
        label: 'Cancelled',
        value: -2
    },
    {
        label: 'Accepted',
        value: -1
    },
    {
        label: 'Initiated',
        value: 0
    }
];
const $1d84337a7f0d29d8$export$193172eccc50b684 = [
    {
        label: 'All',
        value: undefined
    },
    {
        label: 'Flow',
        value: 'flow'
    },
    {
        label: 'Trisa',
        value: 'trisa'
    },
    {
        label: 'GTR',
        value: 'gtr',
        disabled: true
    },
    {
        label: 'TRP',
        value: 'trp',
        disabled: true
    }
];
const $1d84337a7f0d29d8$export$56d03de8326511b7 = [
    {
        label: 'All',
        value: undefined
    },
    {
        value: 'BTC',
        label: 'Bitcoin'
    },
    {
        value: 'ETH',
        label: 'Ethereum'
    },
    {
        value: 'BCH',
        label: 'Bitcoin Cash'
    },
    {
        value: 'LTC',
        label: 'Litecoin'
    },
    {
        value: 'BSV',
        label: 'Bitcoin SV'
    },
    {
        value: 'DOGE',
        label: 'Doge Coin'
    },
    {
        value: 'ZEC',
        label: 'Zcash'
    },
    {
        value: 'XRP',
        label: 'Ripple'
    },
    {
        value: 'XLM',
        label: 'Stellar'
    },
    {
        value: 'XDC',
        label: 'XDC'
    },
    {
        value: 'SOL',
        label: 'Solana'
    },
    {
        value: 'ALGO',
        label: 'Algorand'
    },
    {
        value: 'MATIC',
        label: 'Polygon'
    },
    {
        value: 'DOT',
        label: 'Polkadot'
    },
    {
        value: 'XTZ',
        label: 'Tezos'
    },
    {
        value: 'NEAR',
        label: 'Near'
    }
];
const $1d84337a7f0d29d8$export$b044187dc1421fe0 = [
    {
        label: 'All',
        value: undefined
    },
    {
        label: 'In',
        value: 1
    },
    {
        label: 'Out',
        value: 2
    }
];
const $1d84337a7f0d29d8$export$4aeee6426382b532 = [
    {
        label: 'Date (Newest)',
        value: '-last_modified'
    },
    {
        label: 'Date (Oldest)',
        value: 'last_modified'
    },
    {
        label: 'Risk Score (Highest)',
        value: '-risk_ratio'
    },
    {
        label: 'Risk Score (Lowest)',
        value: 'risk_ratio'
    }
];
const $1d84337a7f0d29d8$export$dd9399c090cf91ef = [
    {
        label: 'Date (Newest)',
        value: '-last_modified'
    },
    {
        label: 'Date (Oldest)',
        value: 'last_modified'
    },
    {
        label: 'Risk Score (Highest)',
        value: '-risk_ratio'
    },
    {
        label: 'Risk Score (Lowest)',
        value: 'risk_ratio'
    },
    {
        label: 'Amount (Highest)',
        value: '-in_usd'
    },
    {
        label: 'Amount (Lowest)',
        value: 'in_usd'
    }
];
const $1d84337a7f0d29d8$export$5f4edf7e4413448f = [
    {
        label: 'Newest',
        value: '-created'
    },
    {
        label: 'Oldest',
        value: 'created'
    }
];
const $1d84337a7f0d29d8$export$2d9ec0da2fe4a5eb = [
    {
        label: 'Newest',
        value: '-created'
    },
    {
        label: 'Oldest',
        value: 'created'
    }
];






const $c38009935841b156$export$d052f996153b966 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  width: 100%;

  // If there is space then it's for the child
  // If there is no space then it's for the current component
  &#accountAddressTableFilter {
    & > div {
      padding: 0 !important;
      margin: 0 !important;
    }
  }
  & #travelruleDateFilter {
    justify-content: center;
    & > div {
      max-width: none !important;
    }
  }
  & #addressDateFilter {
    & > div {
      max-width: none !important;
      padding: 0;
      height: 100%;
      gap: 10px;

      & p {
        font-size: 12px !important;
        margin: 0;
        display: flex;
        align-items: center;
        gap: 5px;
      }
    }
  }
`;
const $c38009935841b156$export$ca4b1fc43afa0212 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $c38009935841b156$export$c16c38052d2b0214 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  transition: 0.3s ease-in-out;
  max-width: ${({ active: active })=>active ? '2000px' : '0'};
  max-height: 40px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 30px;
  overflow: ${({ active: active })=>active ? 'visible' : 'hidden'};
  `;
const $c38009935841b156$export$2d48b21c447d881f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 15px;
  width: 100%;
  
  & > div {
    margin: 0;
  }
  `;
const $c38009935841b156$export$7e39671946ef1a18 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 14px;
`;
const $c38009935841b156$export$2e0a83ec2e27ecbb = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: 100%;
  border-bottom: 1px solid ${({ theme: theme })=>theme.colors.borderColor}
`;



// Map Redux Props
const $a27b7f67bc6d1866$var$mapStateToProps = (state)=>state;
const $a27b7f67bc6d1866$var$mapDispatchToProps = (dispatch)=>(0, $2154a4c08d887b32$export$e324594224ef24da)(dispatch);
function $a27b7f67bc6d1866$var$AccountTableFilter(props) {
    // Destructure
    const { filters: filters, actions: actions } = props;
    const { accountDirectoryFilters: accountDirectoryFilters } = filters;
    const { sort: sort, account_type_id: account_type_id, status_id: status_id } = accountDirectoryFilters;
    // Store Actions
    const { setShowHeaderLoader: setShowHeaderLoader, setAccountDirectoryFilters: setAccountDirectoryFilters } = actions;
    // States
    const [searchResults, setSearchResults] = (0, $tZqWC.useState)([]);
    // Hooks
    const { searchAccount: searchAccount, accountSearchData: accountSearchData, isAccountSearchLoading: isAccountSearchLoading } = (0, $c374fc425c48cdb0$export$2e2bcd8739ae039)();
    const history = (0, $a0d5c3f2fe524011$export$3420e1dc2c4a518c)();
    // Functions
    // Filter Functions
    const handleStatusSelect = async (value)=>{
        if (status_id !== value) await setAccountDirectoryFilters({
            ...accountDirectoryFilters,
            status_id: Number.isNaN(+value) ? undefined : +value
        });
    };
    const handleTypeSelect = async (value)=>{
        if (account_type_id !== value) await setAccountDirectoryFilters({
            ...accountDirectoryFilters,
            account_type_id: Number.isNaN(+value) ? undefined : +value
        });
    };
    const handleSortSelect = async (value)=>{
        if (sort !== value) await setAccountDirectoryFilters({
            ...accountDirectoryFilters,
            sort: value
        });
    };
    // Search Functions
    const handleOnAutoCompleteSelect = (value)=>{
        history.push(`/directory/accounts/details/${value}`);
    };
    const handleOnAutoCompleteInputChange = (0, (/*@__PURE__*/$parcel$interopDefault($e6f80c3bb3fc9ef9$exports)))((value)=>{
        if (!value) return setSearchResults([]);
        if (value) return searchAccount({
            search_term: value,
            account_category: accountDirectoryFilters?.account_category
        });
    }, 500);
    // useEffect
    (0, $tZqWC.useEffect)(()=>{
        if (accountSearchData) setSearchResults(()=>accountSearchData.map(({ reference_id: reference_id, display_name: display_name, id: id })=>({
                    label: reference_id,
                    subLabel: display_name,
                    value: id
                })));
        if (!accountSearchData) setSearchResults([]);
    }, [
        accountSearchData
    ]);
    (0, $tZqWC.useEffect)(()=>{
        setSearchResults([]);
    }, [
        accountDirectoryFilters?.account_category
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (isAccountSearchLoading) setShowHeaderLoader(true);
        else if (!isAccountSearchLoading) setShowHeaderLoader(false);
    }, [
        isAccountSearchLoading
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c38009935841b156$export$d052f996153b966), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $69a991355976a1a9$export$2e2bcd8739ae039), {
            options: searchResults,
            placeholder: "Search ID or Name...",
            onInputChange: handleOnAutoCompleteInputChange,
            onSelect: handleOnAutoCompleteSelect,
            isLoading: isAccountSearchLoading,
            filter: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $ca6f920a36c82944$export$2e2bcd8739ae039), {
                direction: "down",
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $478ff5739380e08c$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                            variant: "outlined",
                            size: "small",
                            startIcon: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $163f23491e8bc756$export$2e2bcd8739ae039), {
                                size: 14
                            }),
                            children: "Filter"
                        })
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7a68433660fee9cb$export$2e2bcd8739ae039), {
                        left: true,
                        style: {
                            minWidth: '150px'
                        },
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $c38009935841b156$export$7e39671946ef1a18), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $430484cb816801bc$export$2e2bcd8739ae039), {
                                    label: "Filter By: ",
                                    placeholder: "Type",
                                    options: (0, $1d84337a7f0d29d8$export$c6cd43238830f06a),
                                    onChange: handleTypeSelect,
                                    value: account_type_id,
                                    vertical: true
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c38009935841b156$export$2e0a83ec2e27ecbb), {}),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $430484cb816801bc$export$2e2bcd8739ae039), {
                                    label: "Filter By: ",
                                    placeholder: "Status",
                                    options: (0, $1d84337a7f0d29d8$export$6c56a740ce3e4ebf),
                                    onChange: handleStatusSelect,
                                    value: status_id,
                                    vertical: true
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c38009935841b156$export$2e0a83ec2e27ecbb), {}),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $430484cb816801bc$export$2e2bcd8739ae039), {
                                    label: "Sort By: ",
                                    options: (0, $1d84337a7f0d29d8$export$2d9f9e1a89baccd1),
                                    onChange: handleSortSelect,
                                    value: sort,
                                    vertical: true
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
}
// Default Props
$a27b7f67bc6d1866$var$AccountTableFilter.defaultProps = {
    filters: {},
    actions: {}
};
// Proptypes Validation
$a27b7f67bc6d1866$var$AccountTableFilter.propTypes = {
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        accountDirectoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            sort: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            account_category: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            account_type_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
            status_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number
        })
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAccountDirectoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        toggleInfoModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setInfoModalDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $a27b7f67bc6d1866$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($a27b7f67bc6d1866$var$mapStateToProps, $a27b7f67bc6d1866$var$mapDispatchToProps)($a27b7f67bc6d1866$var$AccountTableFilter);


var $18e1459be341ac87$export$2e2bcd8739ae039 = (0, $a27b7f67bc6d1866$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");









// Map Redux Props
const $0a80dcd3cd57626c$var$mapStateToProps = (state)=>state;
const $0a80dcd3cd57626c$var$mapDispatchToProps = (dispatch)=>(0, $2154a4c08d887b32$export$e324594224ef24da)(dispatch);
function $0a80dcd3cd57626c$var$VaspTableFilter(props) {
    // Destructure
    const { filters: filters, actions: actions } = props;
    const { vaspDirectoryFilters: vaspDirectoryFilters } = filters;
    const { sort: sort } = vaspDirectoryFilters;
    // Store Actions
    const { setShowHeaderLoader: setShowHeaderLoader, setVaspDirectoryFilters: setVaspDirectoryFilters } = actions;
    // States
    const [searchResults, setSearchResults] = (0, $tZqWC.useState)([]);
    // Hooks
    const { searchVasp: searchVasp, vaspSearchData: vaspSearchData, isVaspSearchLoading: isVaspSearchLoading } = (0, $dc7df1083c6c90ef$export$2e2bcd8739ae039)();
    const history = (0, $a0d5c3f2fe524011$export$3420e1dc2c4a518c)();
    // Functions
    // Filter Functions
    const handleSortSelect = async (value)=>{
        if (sort !== value) await setVaspDirectoryFilters({
            ...vaspDirectoryFilters,
            sort: value
        });
    };
    // Search Functions
    const handleOnAutoCompleteSelect = (value)=>{
        history.push(`/directory/vasps/details/${value}`);
    };
    const handleOnAutoCompleteInputChange = (0, (/*@__PURE__*/$parcel$interopDefault($e6f80c3bb3fc9ef9$exports)))((value)=>{
        if (!value) return setSearchResults([]);
        if (value) return searchVasp({
            search_term: value
        });
    }, 500);
    // useEffect
    (0, $tZqWC.useEffect)(()=>{
        if (vaspSearchData) setSearchResults(()=>vaspSearchData.map(({ name_business: name_business, name_legal: name_legal, id: id })=>({
                    label: name_legal,
                    subLabel: name_business,
                    value: id
                })));
        if (!vaspSearchData) setSearchResults([]);
    }, [
        vaspSearchData
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (isVaspSearchLoading) setShowHeaderLoader(true);
        else if (!isVaspSearchLoading) setShowHeaderLoader(false);
    }, [
        isVaspSearchLoading
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c38009935841b156$export$d052f996153b966), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $69a991355976a1a9$export$2e2bcd8739ae039), {
            options: searchResults,
            placeholder: "Search ID or Name...",
            onInputChange: handleOnAutoCompleteInputChange,
            onSelect: handleOnAutoCompleteSelect,
            isLoading: isVaspSearchLoading,
            filter: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $ca6f920a36c82944$export$2e2bcd8739ae039), {
                direction: "down",
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $478ff5739380e08c$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                            variant: "outlined",
                            size: "small",
                            startIcon: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $163f23491e8bc756$export$2e2bcd8739ae039), {
                                size: 14
                            }),
                            children: "Filter"
                        })
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7a68433660fee9cb$export$2e2bcd8739ae039), {
                        left: true,
                        style: {
                            minWidth: '180px'
                        },
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c38009935841b156$export$7e39671946ef1a18), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $430484cb816801bc$export$2e2bcd8739ae039), {
                                id: "VASPSort",
                                label: "Sort By: ",
                                options: (0, $1d84337a7f0d29d8$export$28744492cdd1c1a0),
                                onChange: handleSortSelect,
                                value: sort
                            })
                        })
                    })
                ]
            })
        })
    });
}
// Default Props
$0a80dcd3cd57626c$var$VaspTableFilter.defaultProps = {
    filters: {},
    actions: {}
};
// Proptypes Validation
$0a80dcd3cd57626c$var$VaspTableFilter.propTypes = {
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        vaspDirectoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            sort: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            vasp_type_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
            vasp_status_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number
        })
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setVaspDirectoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $0a80dcd3cd57626c$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($0a80dcd3cd57626c$var$mapStateToProps, $0a80dcd3cd57626c$var$mapDispatchToProps)($0a80dcd3cd57626c$var$VaspTableFilter);


var $d3cd0ff9e1046ed5$export$2e2bcd8739ae039 = (0, $0a80dcd3cd57626c$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");









// Map Redux Props
const $5eadc583cd579f76$var$mapStateToProps = (state)=>state;
const $5eadc583cd579f76$var$mapDispatchToProps = (dispatch)=>(0, $2154a4c08d887b32$export$e324594224ef24da)(dispatch);
function $5eadc583cd579f76$var$RequestedVaspTableFilter(props) {
    // Destructure
    const { filters: filters, actions: actions } = props;
    const { vaspDirectoryFilters: vaspDirectoryFilters } = filters;
    const { sort: sort } = vaspDirectoryFilters;
    // Store Actions
    const { setShowHeaderLoader: setShowHeaderLoader, setVaspDirectoryFilters: setVaspDirectoryFilters } = actions;
    // States
    const [searchResults, setSearchResults] = (0, $tZqWC.useState)([]);
    // Hooks
    const { searchMidProspect: searchMidProspect, midProspectSearchData: midProspectSearchData, isVaspSearchLoading: isVaspSearchLoading } = (0, $b3824b62e003fe5e$export$2e2bcd8739ae039)();
    const history = (0, $a0d5c3f2fe524011$export$3420e1dc2c4a518c)();
    // Functions
    // Filter Functions
    const handleSortSelect = async (value)=>{
        if (sort !== value) await setVaspDirectoryFilters({
            ...vaspDirectoryFilters,
            sort: value
        });
    };
    // Search Functions
    const handleOnAutoCompleteSelect = (value)=>{
        history.push(`/directory/vasps/details/${value}`);
    };
    const handleOnAutoCompleteInputChange = (0, (/*@__PURE__*/$parcel$interopDefault($e6f80c3bb3fc9ef9$exports)))((value)=>{
        if (!value) return setSearchResults([]);
        if (value) return searchMidProspect({
            search_term: value
        });
    }, 500);
    // useEffect
    (0, $tZqWC.useEffect)(()=>{
        if (midProspectSearchData) setSearchResults(()=>midProspectSearchData.map(({ name_business: name_business, name_legal: name_legal, id: id })=>({
                    label: name_legal,
                    subLabel: name_business,
                    value: id
                })));
        if (!midProspectSearchData) setSearchResults([]);
    }, [
        midProspectSearchData
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (isVaspSearchLoading) setShowHeaderLoader(true);
        else if (!isVaspSearchLoading) setShowHeaderLoader(false);
    }, [
        isVaspSearchLoading
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c38009935841b156$export$d052f996153b966), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $69a991355976a1a9$export$2e2bcd8739ae039), {
            options: searchResults,
            placeholder: "Search ID or Name...",
            onInputChange: handleOnAutoCompleteInputChange,
            onSelect: handleOnAutoCompleteSelect,
            isLoading: isVaspSearchLoading,
            filter: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $ca6f920a36c82944$export$2e2bcd8739ae039), {
                direction: "down",
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $478ff5739380e08c$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                            variant: "outlined",
                            size: "small",
                            startIcon: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $163f23491e8bc756$export$2e2bcd8739ae039), {
                                size: 14
                            }),
                            children: "Filter"
                        })
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7a68433660fee9cb$export$2e2bcd8739ae039), {
                        left: true,
                        style: {
                            minWidth: '180px'
                        },
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c38009935841b156$export$7e39671946ef1a18), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $430484cb816801bc$export$2e2bcd8739ae039), {
                                id: "VASPSort",
                                label: "Sort By: ",
                                options: (0, $1d84337a7f0d29d8$export$28744492cdd1c1a0),
                                onChange: handleSortSelect,
                                value: sort
                            })
                        })
                    })
                ]
            })
        })
    });
}
// Default Props
$5eadc583cd579f76$var$RequestedVaspTableFilter.defaultProps = {
    filters: {},
    actions: {}
};
// Proptypes Validation
$5eadc583cd579f76$var$RequestedVaspTableFilter.propTypes = {
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        vaspDirectoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            sort: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            vasp_type_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
            vasp_customer_status_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number
        })
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setVaspDirectoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $5eadc583cd579f76$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($5eadc583cd579f76$var$mapStateToProps, $5eadc583cd579f76$var$mapDispatchToProps)($5eadc583cd579f76$var$RequestedVaspTableFilter);


var $b6d9d515100cd1b1$export$2e2bcd8739ae039 = (0, $5eadc583cd579f76$export$2e2bcd8739ae039);


/* eslint-disable react/prop-types */ 

var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");






// Map Redux Props
const $0d3747c3e5958e8a$var$mapStateToProps = (state)=>state;
const $0d3747c3e5958e8a$var$mapDispatchToProps = (dispatch)=>(0, $2154a4c08d887b32$export$e324594224ef24da)(dispatch);
function $0d3747c3e5958e8a$var$TravelRuleTableFilter(props) {
    // Destructure
    const { filters: filters, actions: actions, address: address } = props;
    const { travelRuleFilters: travelRuleFilters } = filters;
    const { sort: sort, transfer_status_id: transfer_status_id, protocol_code: protocol_code, dti: dti, start_date: start_date, end_date: end_date, direction_id: direction_id } = travelRuleFilters;
    // Store Actions
    const { setTravelRuleFilters: setTravelRuleFilters } = actions;
    const { addressChains: addressChains } = address;
    // Hooks
    const [availableChains, setAvailableChains] = (0, $tZqWC.useState)();
    // Functions
    // Filter Functions
    const handleDateSelect = async ({ start: start, end: end })=>{
        await setTravelRuleFilters({
            ...travelRuleFilters,
            start_date: start,
            end_date: end,
            page: 1
        });
    };
    const handleAssetSelect = async (value)=>{
        await setTravelRuleFilters({
            ...travelRuleFilters,
            dti: value
        });
    };
    const handleDirectionSelect = async (value)=>{
        await setTravelRuleFilters({
            ...travelRuleFilters,
            direction_id: value
        });
    };
    const handleProtocolSelect = async (value)=>{
        await setTravelRuleFilters({
            ...travelRuleFilters,
            protocol_code: value
        });
    };
    const handleStatusSelect = async (value)=>{
        await setTravelRuleFilters({
            ...travelRuleFilters,
            transfer_status_id: Number.isNaN(+value) ? undefined : +value
        });
    };
    const handleSortSelect = async (value)=>{
        await setTravelRuleFilters({
            ...travelRuleFilters,
            sort: value
        });
    };
    // Search Functions
    function handleAvailableChains() {
        const providers = {
            ...addressChains?.financial
        };
        let allChains = {};
        Object.keys(providers).forEach((item)=>{
            if (item === 'FDBDM') allChains = {
                ...allChains,
                ...providers[item]
            };
        });
        setAvailableChains({
            ALL: {
                symbol: undefined,
                label: 'All'
            },
            ...allChains
        });
    }
    // useEffect
    (0, $tZqWC.useEffect)(()=>{
        handleAvailableChains();
    }, [
        addressChains
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c38009935841b156$export$d052f996153b966), {
        id: "travelRuleTableFilter",
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $ca6f920a36c82944$export$2e2bcd8739ae039), {
            direction: "down",
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $478ff5739380e08c$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                        variant: "outlined",
                        size: "small",
                        startIcon: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $163f23491e8bc756$export$2e2bcd8739ae039), {
                            size: 14
                        }),
                        children: "Filter"
                    })
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7a68433660fee9cb$export$2e2bcd8739ae039), {
                    style: {
                        minWidth: '260px'
                    },
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $c38009935841b156$export$7e39671946ef1a18), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1a3a6d4b17c02c87$export$2e2bcd8739ae039), {
                                id: "travelruleDateFilter",
                                onApply: handleDateSelect,
                                start: start_date,
                                end: end_date,
                                simplifiedDate: true,
                                vertical: true
                            }, start_date),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c38009935841b156$export$2e0a83ec2e27ecbb), {}),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $430484cb816801bc$export$2e2bcd8739ae039), {
                                label: "Direction: ",
                                placeholder: "All",
                                options: (0, $1d84337a7f0d29d8$export$b044187dc1421fe0),
                                onChange: handleDirectionSelect,
                                value: direction_id,
                                vertical: true
                            }),
                            availableChains && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c38009935841b156$export$2e0a83ec2e27ecbb), {}),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $430484cb816801bc$export$2e2bcd8739ae039), {
                                        id: "travelRuleAssetSort",
                                        label: "Asset: ",
                                        placeholder: "All",
                                        options: Object.keys(availableChains).map((item)=>({
                                                value: availableChains[item]?.dti || undefined,
                                                label: availableChains[item]?.symbol || availableChains[item]?.label
                                            })),
                                        onChange: handleAssetSelect,
                                        value: dti,
                                        vertical: true
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c38009935841b156$export$2e0a83ec2e27ecbb), {}),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $430484cb816801bc$export$2e2bcd8739ae039), {
                                label: "Status: ",
                                placeholder: "All",
                                options: (0, $1d84337a7f0d29d8$export$bd15dd234c4e5fbf),
                                onChange: handleStatusSelect,
                                value: transfer_status_id,
                                vertical: true
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c38009935841b156$export$2e0a83ec2e27ecbb), {}),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $430484cb816801bc$export$2e2bcd8739ae039), {
                                label: "Protocol: ",
                                placeholder: "All",
                                options: (0, $1d84337a7f0d29d8$export$193172eccc50b684),
                                onChange: handleProtocolSelect,
                                value: protocol_code,
                                vertical: true
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c38009935841b156$export$2e0a83ec2e27ecbb), {}),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $430484cb816801bc$export$2e2bcd8739ae039), {
                                id: "travelRuleSort",
                                label: "Sort By: ",
                                placeholder: "Amount or Date",
                                options: (0, $1d84337a7f0d29d8$export$641ab1eef3e226d9),
                                onChange: handleSortSelect,
                                value: sort,
                                vertical: true
                            })
                        ]
                    })
                })
            ]
        })
    });
}
// Default Props
$0d3747c3e5958e8a$var$TravelRuleTableFilter.defaultProps = {
    filters: {},
    actions: {}
};
// Proptypes Validation
$0d3747c3e5958e8a$var$TravelRuleTableFilter.propTypes = {
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        travelRuleFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            sort: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            start_date: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            end_date: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            direction_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            dti: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
            transfer_status_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number
        })
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setTravelRuleFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    address: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        addressChains: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({})
    })
};
var $0d3747c3e5958e8a$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($0d3747c3e5958e8a$var$mapStateToProps, $0d3747c3e5958e8a$var$mapDispatchToProps)($0d3747c3e5958e8a$var$TravelRuleTableFilter);


var $a69d8405428f2206$export$2e2bcd8739ae039 = (0, $0d3747c3e5958e8a$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");






// Map Redux Props
const $34f01fca3f35a54c$var$mapStateToProps = (state)=>state;
const $34f01fca3f35a54c$var$mapDispatchToProps = (dispatch)=>(0, $2154a4c08d887b32$export$e324594224ef24da)(dispatch);
function $34f01fca3f35a54c$var$AddressTableFilter(props) {
    // Destructure
    const { filters: filters, actions: actions, ...rest } = props;
    const { addressFilters: addressFilters } = filters;
    const { sort: sort, start_range: start_range, end_range: end_range } = addressFilters;
    const { setAddressFilters: setAddressFilters } = actions;
    // Functions
    // Filter Functions
    const handleDateSelect = async ({ start: start, end: end })=>{
        await setAddressFilters({
            ...addressFilters,
            start_range: start,
            end_range: end,
            page: 1
        });
    };
    const handleSortSelect = async (value)=>{
        if (sort !== value) await setAddressFilters({
            ...addressFilters,
            sort: value
        });
    };
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c38009935841b156$export$d052f996153b966), {
        ...rest,
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $ca6f920a36c82944$export$2e2bcd8739ae039), {
            direction: "down",
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $478ff5739380e08c$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                        variant: "outlined",
                        size: "small",
                        startIcon: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $163f23491e8bc756$export$2e2bcd8739ae039), {
                            size: 14
                        }),
                        children: "Filter"
                    })
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7a68433660fee9cb$export$2e2bcd8739ae039), {
                    style: {
                        minWidth: '300px'
                    },
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $c38009935841b156$export$7e39671946ef1a18), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1a3a6d4b17c02c87$export$2e2bcd8739ae039), {
                                id: "addressDateFilter",
                                onApply: handleDateSelect,
                                start: start_range,
                                end: end_range,
                                vertical: true
                            }, start_range),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c38009935841b156$export$2e0a83ec2e27ecbb), {}),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $430484cb816801bc$export$2e2bcd8739ae039), {
                                label: "Sort By: ",
                                options: (0, $1d84337a7f0d29d8$export$4aeee6426382b532),
                                onChange: handleSortSelect,
                                value: sort,
                                vertical: true
                            })
                        ]
                    })
                })
            ]
        })
    });
}
// Default Props
$34f01fca3f35a54c$var$AddressTableFilter.defaultProps = {
    filters: {},
    actions: {}
};
// Proptypes Validation
$34f01fca3f35a54c$var$AddressTableFilter.propTypes = {
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        addressFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            sort: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            account_type_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
            page_index: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
            start_range: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            end_range: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
        })
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAddressFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        toggleUpgradeModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setInfoModalDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $34f01fca3f35a54c$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($34f01fca3f35a54c$var$mapStateToProps, $34f01fca3f35a54c$var$mapDispatchToProps)($34f01fca3f35a54c$var$AddressTableFilter);


var $7e43e1df6e75bbbe$export$2e2bcd8739ae039 = (0, $34f01fca3f35a54c$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");






// Map Redux Props
const $47ed4a7ad74a254c$var$mapStateToProps = (state)=>state;
const $47ed4a7ad74a254c$var$mapDispatchToProps = (dispatch)=>(0, $2154a4c08d887b32$export$e324594224ef24da)(dispatch);
function $47ed4a7ad74a254c$var$ReportsAddressTableFilter(props) {
    // Destructure
    const { filters: filters, actions: actions } = props;
    const { reportsAddressFilters: reportsAddressFilters } = filters;
    const { sort: sort, start_range: start_range, end_range: end_range } = reportsAddressFilters;
    // Store Actions
    const { setReportsAddressFilters: setReportsAddressFilters } = actions;
    // Functions
    // Filter Functions
    const handleDateSelect = async ({ start: start, end: end })=>{
        await setReportsAddressFilters({
            ...reportsAddressFilters,
            start_range: start,
            end_range: end
        });
    };
    const handleSortSelect = async (value)=>{
        if (sort !== value) await setReportsAddressFilters({
            ...reportsAddressFilters,
            sort: value
        });
    };
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c38009935841b156$export$d052f996153b966), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $ca6f920a36c82944$export$2e2bcd8739ae039), {
            direction: "down",
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $478ff5739380e08c$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                        variant: "outlined",
                        size: "small",
                        startIcon: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $163f23491e8bc756$export$2e2bcd8739ae039), {
                            size: 14
                        }),
                        children: "Filter"
                    })
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7a68433660fee9cb$export$2e2bcd8739ae039), {
                    style: {
                        minWidth: '300px'
                    },
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $c38009935841b156$export$7e39671946ef1a18), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1a3a6d4b17c02c87$export$2e2bcd8739ae039), {
                                id: "addressDateFilter",
                                onApply: handleDateSelect,
                                start: start_range,
                                end: end_range,
                                vertical: true
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c38009935841b156$export$2e0a83ec2e27ecbb), {}),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $430484cb816801bc$export$2e2bcd8739ae039), {
                                label: "Sort By: ",
                                options: (0, $1d84337a7f0d29d8$export$5f4edf7e4413448f),
                                onChange: handleSortSelect,
                                value: sort,
                                vertical: true
                            })
                        ]
                    })
                })
            ]
        })
    });
}
// Default Props
$47ed4a7ad74a254c$var$ReportsAddressTableFilter.defaultProps = {
    filters: {},
    actions: {}
};
// Proptypes Validation
$47ed4a7ad74a254c$var$ReportsAddressTableFilter.propTypes = {
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        reportsAddressFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            sort: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            account_type_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
            page_index: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
            start_range: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            end_range: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
        })
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setReportsAddressFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        toggleUpgradeModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setInfoModalDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $47ed4a7ad74a254c$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($47ed4a7ad74a254c$var$mapStateToProps, $47ed4a7ad74a254c$var$mapDispatchToProps)($47ed4a7ad74a254c$var$ReportsAddressTableFilter);


var $1d305625439d79ac$export$2e2bcd8739ae039 = (0, $47ed4a7ad74a254c$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");






// Map Redux Props
const $bbcf9fb57e1f83b7$var$mapStateToProps = (state)=>state;
const $bbcf9fb57e1f83b7$var$mapDispatchToProps = (dispatch)=>(0, $2154a4c08d887b32$export$e324594224ef24da)(dispatch);
function $bbcf9fb57e1f83b7$var$ReportsTransactionTableFilter(props) {
    // Destructure
    const { filters: filters, actions: actions } = props;
    const { reportsTransactionFilters: reportsTransactionFilters } = filters;
    const { sort: sort, start_range: start_range, end_range: end_range } = reportsTransactionFilters;
    // Store Actions
    const { setReportsTransactionFilters: setReportsTransactionFilters } = actions;
    // Functions
    // Filter Functions
    const handleDateSelect = async ({ start: start, end: end })=>{
        await setReportsTransactionFilters({
            ...reportsTransactionFilters,
            start_range: start,
            end_range: end
        });
    };
    const handleSortSelect = async (value)=>{
        if (sort !== value) await setReportsTransactionFilters({
            ...reportsTransactionFilters,
            sort: value
        });
    };
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c38009935841b156$export$d052f996153b966), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $ca6f920a36c82944$export$2e2bcd8739ae039), {
            direction: "down",
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $478ff5739380e08c$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                        variant: "outlined",
                        size: "small",
                        startIcon: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $163f23491e8bc756$export$2e2bcd8739ae039), {
                            size: 14
                        }),
                        children: "Filter"
                    })
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7a68433660fee9cb$export$2e2bcd8739ae039), {
                    style: {
                        minWidth: '300px'
                    },
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $c38009935841b156$export$7e39671946ef1a18), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1a3a6d4b17c02c87$export$2e2bcd8739ae039), {
                                id: "TransactionDateFilter",
                                onApply: handleDateSelect,
                                start: start_range,
                                end: end_range,
                                style: {
                                    minWidth: '300px'
                                }
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c38009935841b156$export$2e0a83ec2e27ecbb), {}),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $430484cb816801bc$export$2e2bcd8739ae039), {
                                label: "Sort By: ",
                                options: (0, $1d84337a7f0d29d8$export$2d9ec0da2fe4a5eb),
                                onChange: handleSortSelect,
                                value: sort
                            })
                        ]
                    })
                })
            ]
        })
    });
}
// Default Props
$bbcf9fb57e1f83b7$var$ReportsTransactionTableFilter.defaultProps = {
    filters: {},
    actions: {}
};
// Proptypes Validation
$bbcf9fb57e1f83b7$var$ReportsTransactionTableFilter.propTypes = {
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        reportsTransactionFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            sort: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            account_type_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
            page_index: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
            start_range: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            end_range: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
        })
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setReportsTransactionFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $bbcf9fb57e1f83b7$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($bbcf9fb57e1f83b7$var$mapStateToProps, $bbcf9fb57e1f83b7$var$mapDispatchToProps)($bbcf9fb57e1f83b7$var$ReportsTransactionTableFilter);


var $a56f24cb7abf86e4$export$2e2bcd8739ae039 = (0, $bbcf9fb57e1f83b7$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");






// Map Redux Props
const $3f08e0d758cf9486$var$mapStateToProps = (state)=>state;
const $3f08e0d758cf9486$var$mapDispatchToProps = (dispatch)=>(0, $2154a4c08d887b32$export$e324594224ef24da)(dispatch);
function $3f08e0d758cf9486$var$TransactionTableFilter(props) {
    // Destructure
    const { filters: filters, actions: actions } = props;
    const { transactionFilters: transactionFilters } = filters;
    const { sort: sort, start_range: start_range, end_range: end_range } = transactionFilters;
    // Store Actions
    const { setTransactionFilters: setTransactionFilters } = actions;
    // Functions
    // Filter Functions
    const handleDateSelect = async ({ start: start, end: end })=>{
        await setTransactionFilters({
            ...transactionFilters,
            start_range: start,
            end_range: end,
            page: 1
        });
    };
    const handleSortSelect = async (value)=>{
        if (sort !== value) await setTransactionFilters({
            ...transactionFilters,
            sort: value
        });
    };
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c38009935841b156$export$d052f996153b966), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $ca6f920a36c82944$export$2e2bcd8739ae039), {
            direction: "down",
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $478ff5739380e08c$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                        variant: "outlined",
                        size: "small",
                        startIcon: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $163f23491e8bc756$export$2e2bcd8739ae039), {
                            size: 14
                        }),
                        children: "Filter"
                    })
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7a68433660fee9cb$export$2e2bcd8739ae039), {
                    style: {
                        minWidth: '300px'
                    },
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $c38009935841b156$export$7e39671946ef1a18), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1a3a6d4b17c02c87$export$2e2bcd8739ae039), {
                                id: "addressDateFilter",
                                onApply: handleDateSelect,
                                start: start_range,
                                end: end_range,
                                vertical: true
                            }, start_range),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c38009935841b156$export$2e0a83ec2e27ecbb), {}),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $430484cb816801bc$export$2e2bcd8739ae039), {
                                id: "travelRuleSort",
                                label: "Sort By: ",
                                options: (0, $1d84337a7f0d29d8$export$dd9399c090cf91ef),
                                onChange: handleSortSelect,
                                value: sort,
                                vertical: true
                            })
                        ]
                    })
                })
            ]
        })
    });
}
// Default Props
$3f08e0d758cf9486$var$TransactionTableFilter.defaultProps = {
    filters: {},
    actions: {}
};
// Proptypes Validation
$3f08e0d758cf9486$var$TransactionTableFilter.propTypes = {
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        transactionFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            sort: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            account_type_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
            page_index: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
            start_range: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            end_range: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
        })
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setTransactionFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        toggleUpgradeModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setInfoModalDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $3f08e0d758cf9486$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($3f08e0d758cf9486$var$mapStateToProps, $3f08e0d758cf9486$var$mapDispatchToProps)($3f08e0d758cf9486$var$TransactionTableFilter);


var $9748c87c1e73ab49$export$2e2bcd8739ae039 = (0, $3f08e0d758cf9486$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");






const $af92f933e9978e03$export$2e74f2ef1cd3ebe0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 300px;
  height: 100%;
`;
const $af92f933e9978e03$export$a361ef8023206e76 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).ul`
  padding: 50px 0px;
`;
const $af92f933e9978e03$export$5e94b591777d7dc2 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).li``;
const $af92f933e9978e03$export$b2abc8114d01f646 = (0, $a778141486c79bc3$export$2e2bcd8739ae039)((0, $12b33660068e86aa$export$b0d92dbee9b5b60d))`
  display: flex;
  align-items: center;

  margin: 0px 20px 0px 0px;
  padding: 10px 30px;
  font-size: 16px;

  color: ${({ theme: theme })=>theme.colors.background};

  // TODO: Use theme functions
  &:hover {
    color: #fff;
  }
`;
const $af92f933e9978e03$export$ad575f47c660843a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  margin: 0px 20px 0px 0px;
`;



// Map Redux Props
const $d77f10b77730cc3b$var$mapStateToProps = (state)=>state;
const $d77f10b77730cc3b$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $d77f10b77730cc3b$var$AppSidebarDrawer(props) {
    // Destructure
    const { ui: ui, actions: actions } = props;
    // Store State
    const { isAppSidebarDrawerOpen: isAppSidebarDrawerOpen } = ui;
    // Store Actions
    const { closeAppSidebarDrawer: closeAppSidebarDrawer } = actions;
    // Hooks
    const { logoutUser: logoutUser } = (0, $0deb6bc4614da688$export$2e2bcd8739ae039)();
    // Functions
    const handleCloseDrawer = ()=>{
        closeAppSidebarDrawer();
    };
    const handleClickSidebarNav = ()=>{
        closeAppSidebarDrawer();
    };
    const handleClickLogout = ()=>{
        logoutUser();
    };
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7c0b6d1401667fb6$export$2e2bcd8739ae039), {
        open: isAppSidebarDrawerOpen,
        anchor: "right",
        onClose: handleCloseDrawer,
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $af92f933e9978e03$export$2e74f2ef1cd3ebe0), {
            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $af92f933e9978e03$export$a361ef8023206e76), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $af92f933e9978e03$export$5e94b591777d7dc2), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $af92f933e9978e03$export$b2abc8114d01f646), {
                        to: "/travelrule",
                        onClick: handleClickSidebarNav,
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $af92f933e9978e03$export$ad575f47c660843a), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $13f215a46c77bbdb$export$2e2bcd8739ae039), {
                                    size: 25
                                })
                            }),
                            "Travel Rule"
                        ]
                    })
                })
            })
        })
    });
}
// Default Props
$d77f10b77730cc3b$var$AppSidebarDrawer.defaultProps = {
    ui: {},
    actions: {}
};
// Proptypes Validation
$d77f10b77730cc3b$var$AppSidebarDrawer.propTypes = {
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isAppSidebarDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        closeAppSidebarDrawer: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $d77f10b77730cc3b$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($d77f10b77730cc3b$var$mapStateToProps, $d77f10b77730cc3b$var$mapDispatchToProps)($d77f10b77730cc3b$var$AppSidebarDrawer);


var $55024b2d0828f9e5$export$2e2bcd8739ae039 = (0, $d77f10b77730cc3b$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");




const $512afc28dec7ded8$export$75f51cf067955710 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  display: flex;
  flex-direction: column;

  height: 100%;
  width: 400px;
  padding: 20px;
`;
const $512afc28dec7ded8$export$7c43b8aad8dcf5c4 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: absolute;
  top: 20px;
  right: 20px;

  cursor: pointer;

  // TODO: Use Theme Functions
  &:hover {
    opacity: 0.7;
  }
  & svg > path {
    stroke: ${({ theme: theme })=>theme.colors.primary};
  }
`;




// Map Redux Props
const $794c5553e4325606$var$mapStateToProps = (state)=>state;
const $794c5553e4325606$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $794c5553e4325606$var$IndividualAccountDrawer(props) {
    // Destructure
    const { ui: ui, actions: actions } = props;
    //  Store State
    const { isIndividualAccountDrawerOpen: isIndividualAccountDrawerOpen } = ui;
    // Store Actions
    const { setIsIndividualAccountDrawerOpen: setIsIndividualAccountDrawerOpen } = actions;
    const handleCloseDrawer = ()=>{
        setIsIndividualAccountDrawerOpen();
    };
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7c0b6d1401667fb6$export$2e2bcd8739ae039), {
        open: isIndividualAccountDrawerOpen,
        anchor: "right",
        onClose: handleCloseDrawer,
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $512afc28dec7ded8$export$75f51cf067955710), {
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $512afc28dec7ded8$export$7c43b8aad8dcf5c4), {
                    onClick: handleCloseDrawer,
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b77b5de3fb591045$export$2e2bcd8739ae039), {
                        size: 18
                    })
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $4baf9c62a5e83223$export$2e2bcd8739ae039), {})
            ]
        })
    });
}
// Default Props
$794c5553e4325606$var$IndividualAccountDrawer.defaultProps = {
    ui: {},
    actions: {}
};
// Proptypes Validation
$794c5553e4325606$var$IndividualAccountDrawer.propTypes = {
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isIndividualAccountDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setIsIndividualAccountDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $794c5553e4325606$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($794c5553e4325606$var$mapStateToProps, $794c5553e4325606$var$mapDispatchToProps)($794c5553e4325606$var$IndividualAccountDrawer);


var $c8d1bfe51ed09424$export$2e2bcd8739ae039 = (0, $794c5553e4325606$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");






// Map Redux Props
const $8cf17217152bffbd$var$mapStateToProps = (state)=>state;
const $8cf17217152bffbd$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $8cf17217152bffbd$var$EntityAccountDrawer(props) {
    // Destructure
    const { ui: ui, actions: actions } = props;
    // Store State
    const { isEntityAccountDrawerOpen: isEntityAccountDrawerOpen } = ui;
    // Store Actions
    const { setIsEntityAccountDrawerOpen: setIsEntityAccountDrawerOpen } = actions;
    const handleCloseDrawer = ()=>{
        setIsEntityAccountDrawerOpen(false);
    };
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7c0b6d1401667fb6$export$2e2bcd8739ae039), {
        open: isEntityAccountDrawerOpen,
        anchor: "right",
        onClose: handleCloseDrawer,
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $512afc28dec7ded8$export$75f51cf067955710), {
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $512afc28dec7ded8$export$7c43b8aad8dcf5c4), {
                    onClick: handleCloseDrawer,
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b77b5de3fb591045$export$2e2bcd8739ae039), {
                        size: 18
                    })
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ed8bd66562284064$export$2e2bcd8739ae039), {})
            ]
        })
    });
}
// Default Props
$8cf17217152bffbd$var$EntityAccountDrawer.defaultProps = {
    ui: {},
    actions: {}
};
// Proptypes Validation
$8cf17217152bffbd$var$EntityAccountDrawer.propTypes = {
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isEntityAccountDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setIsEntityAccountDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $8cf17217152bffbd$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($8cf17217152bffbd$var$mapStateToProps, $8cf17217152bffbd$var$mapDispatchToProps)($8cf17217152bffbd$var$EntityAccountDrawer);


var $00d8a2ddb487d42e$export$2e2bcd8739ae039 = (0, $8cf17217152bffbd$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");






// Map Redux Props
const $4cbad3b8e5b8c7e2$var$mapStateToProps = (state)=>state;
const $4cbad3b8e5b8c7e2$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $4cbad3b8e5b8c7e2$var$VaspDrawer(props) {
    // Destructure
    const { ui: ui, actions: actions } = props;
    // Store State
    const { isVaspDrawerOpen: isVaspDrawerOpen } = ui;
    // Store Actions
    const { setIsVaspDrawerOpen: setIsVaspDrawerOpen } = actions;
    const handleCloseDrawer = ()=>{
        setIsVaspDrawerOpen(false);
    };
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7c0b6d1401667fb6$export$2e2bcd8739ae039), {
        open: isVaspDrawerOpen,
        anchor: "right",
        onClose: handleCloseDrawer,
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $512afc28dec7ded8$export$75f51cf067955710), {
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $512afc28dec7ded8$export$7c43b8aad8dcf5c4), {
                    onClick: handleCloseDrawer,
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b77b5de3fb591045$export$2e2bcd8739ae039), {
                        size: 18
                    })
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $fc74ce71b32b91d5$export$2e2bcd8739ae039), {})
            ]
        })
    });
}
// Default Props
$4cbad3b8e5b8c7e2$var$VaspDrawer.defaultProps = {
    ui: {},
    actions: {}
};
// Proptypes Validation
$4cbad3b8e5b8c7e2$var$VaspDrawer.propTypes = {
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isVaspDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setIsVaspDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $4cbad3b8e5b8c7e2$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($4cbad3b8e5b8c7e2$var$mapStateToProps, $4cbad3b8e5b8c7e2$var$mapDispatchToProps)($4cbad3b8e5b8c7e2$var$VaspDrawer);


var $19281fb4a54057c2$export$2e2bcd8739ae039 = (0, $4cbad3b8e5b8c7e2$export$2e2bcd8739ae039);


/* eslint-disable react/jsx-no-useless-fragment */ 

var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");



const $3a4edad937503233$export$e90647e0c7f398be = [
    {
        label: 'Amount'
    },
    {
        label: 'Sender'
    },
    {
        label: 'Recipient'
    },
    {
        label: 'VASP'
    },
    {
        label: 'Confirm'
    }
];






const $226bdec20dbecb91$export$75aecd7833c0d03e = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;

  height: 100%;
  width: 400px;

  & button {
    width: 100%;
  }
`;
const $226bdec20dbecb91$export$85123f7bee08d0ef = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;

  padding: 16px 20px;
`;
const $226bdec20dbecb91$export$bb68d554ded258ea = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 20px;

  padding: 0 20px 16px 20px;
`;
const $226bdec20dbecb91$export$5e12c88e3c0628b7 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-start;
  & button {
    display: flex;
    align-items: center;
    gap: 10px;

    max-height: 20px;
    font-size: 15px;
    text-align: left;
    border: none !important;
    padding: 0 !important;
    background-color: transparent !important;
    color: ${({ theme: theme })=>theme.colors.primary} !important;
    & svg {
      max-height: none !important;
      max-width: none !important;
    }
  }
  & button:hover {
    color: ${({ theme: theme })=>theme.colors.brand} !important;
    & svg > path {
      stroke: ${({ theme: theme })=>theme.colors.brand} !important;
    }
  }
`;
const $226bdec20dbecb91$export$57ca055474bc0056 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  flex: 1;

  overflow-y: auto;

  width: 100%;
  padding: 20px;
`;
const $226bdec20dbecb91$export$d05a7d25ec5abf06 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  width: 100%;
  padding: 20px;

  border-top: 1px solid ${({ theme: theme })=>theme.colors.backgroundLite};

  & button {
    width: ${({ formPage: formPage })=>formPage === 5 ? '100%' : 'auto'};
  }
`;
const $226bdec20dbecb91$export$7c43b8aad8dcf5c4 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-end;
  cursor: pointer;

  // TODO: Use Theme Functions
  &:hover {
    opacity: 0.7;
  }
  & svg > path {
    stroke: ${({ theme: theme })=>theme.colors.primary};
  }
`;
const $226bdec20dbecb91$export$ef709dfaef303e38 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  margin: 0;

  font-size: 20px;
  font-weight: 500;
  text-align: center;

  // TODO: Use Theme Color
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $226bdec20dbecb91$export$7287ece93560589d = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  margin: 0;

  font-size: 16px;
  font-weight: 500;
  text-align: center;

  // TODO: Use Theme Color
  color: ${({ theme: theme })=>theme.colors.red};
`;








// Map Redux Props
const $0c31e108007cf5c7$var$mapStateToProps = (state)=>state;
const $0c31e108007cf5c7$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
const $0c31e108007cf5c7$var$defaultFormData = {
    transfer: {
        asset_code: (0, $f398806f8c37b1c3$export$cfce4cc2a24073)[0].value,
        dti: (0, $f398806f8c37b1c3$export$53c0b7944743072a)?.[(0, $f398806f8c37b1c3$export$cfce4cc2a24073)[0].value]?.dti,
        protocol_code: (0, $f398806f8c37b1c3$export$71c31dec0f381b7e)[0].value
    },
    account: null,
    recipient: null,
    vasp: null
};
function $0c31e108007cf5c7$var$TransferDrawer(props) {
    // Destructure
    const { ui: ui, actions: actions, form: form } = props;
    // Store State
    const { isTransferDrawerOpen: isTransferDrawerOpen } = ui;
    const { createdAccount: createdAccount, createdRecipient: createdRecipient, createdVasp: createdVasp } = form;
    // Store Actions
    const { setCreatedAccount: setCreatedAccount, setCreatedRecipient: setCreatedRecipient, setCreatedVasp: setCreatedVasp, setIsTransferDrawerOpen: setIsTransferDrawerOpen, setIsPageTableUpdated: setIsPageTableUpdated, showAlert: showAlert } = actions;
    // Hooks
    const { createTransfer: createTransfer, isTransferCreateSuccess: isTransferCreateSuccess, isTransferCreateError: isTransferCreateError, isTransferCreateLoading: isTransferCreateLoading, transferCreateError: transferCreateError } = (0, $885aa14bb7e86d78$export$2e2bcd8739ae039)();
    const { getVasp: getVasp, vaspData: vaspData, isVaspLoading: isVaspLoading } = (0, $462c3808bdeaeab0$export$2e2bcd8739ae039)();
    // State
    const [disabledContinue, setDisabledContinue] = (0, $tZqWC.useState)(true);
    const [formPage, setFormPage] = (0, $tZqWC.useState)(1);
    const [recipientAddress, setRecipientAddress] = (0, $tZqWC.useState)();
    const [recipientVaspOptions, setRecipientVaspOptions] = (0, $tZqWC.useState)();
    const [formData, setFormData] = (0, $tZqWC.useState)($0c31e108007cf5c7$var$defaultFormData);
    const [errorMsg, setErrorMsg] = (0, $tZqWC.useState)();
    const [isInvalidTransfer, setIsInvalidTransfer] = (0, $tZqWC.useState)(false);
    const [userCredentials] = (0, $a9c50ebe96619b20$export$2e2bcd8739ae039)('userCredentials', false);
    // Functions
    const handleBack = ()=>{
        if (formPage <= 1) return;
        if (formPage === 5 && (formData?.transfer?.selected_account_address?.is_self_hosted || formData?.transfer?.selected_recipient_address?.is_self_hosted)) {
            setFormPage(3);
            return;
        }
        setFormPage((prevState)=>prevState - 1);
    };
    const handleContinue = ()=>{
        if (formPage >= 5) {
            createTransfer({
                amount: Number(formData.transfer.amount),
                amount_usd: formData.transfer.amount_usd,
                dti: formData.transfer.dti,
                // reference_id: '', # NOTE: reference_id is optional, and should have separate form input
                protocol_code: formData.transfer.protocol_code,
                tx_hash: formData.transfer.tx_hash,
                in_address_id: formData.transfer.selected_account_address.id,
                out_address_id: formData.transfer.selected_recipient_address.id,
                in_account_id: formData.account.id,
                out_account_id: formData.recipient.id,
                out_business_id: formData.vasp.id
            });
            return;
        }
        if (formPage === 3 && (formData?.transfer?.selected_account_address?.is_self_hosted || formData?.transfer?.selected_recipient_address?.is_self_hosted)) {
            getVasp({
                vasp_id: userCredentials?.business_id
            });
            return;
        }
        setFormPage((prevState)=>prevState + 1);
    };
    const handleCloseDrawer = ()=>{
        setFormData({
            transfer: {},
            account: null,
            recipient: null,
            vasp: null
        });
        setFormPage(1);
        setIsTransferDrawerOpen(false);
    };
    const handleSelfhostedTransfer = ()=>{
        if (formData?.transfer?.selected_account_address?.is_self_hosted && formData?.transfer?.selected_recipient_address?.is_self_hosted) {
            setErrorMsg('Both addresses cannot be self-hosted');
            setIsInvalidTransfer(true);
            return;
        }
        if (formData?.transfer?.selected_account_address?.is_self_hosted) {
            setFormData({
                ...formData,
                transfer: {
                    ...formData?.transfer,
                    protocol_code: 'flow'
                },
                vasp: {
                    ...vaspData
                }
            });
            setFormPage(5);
            return;
        }
        if (formData?.transfer?.selected_recipient_address?.is_self_hosted) {
            setFormData({
                ...formData,
                transfer: {
                    ...formData?.transfer,
                    protocol_code: 'flow'
                },
                vasp: {
                    id: undefined,
                    name_legal: 'SELF-HOSTED',
                    website: '-',
                    address_country_code: '-',
                    address_country_desc: '-'
                }
            });
            setFormPage(5);
        }
    };
    // UseEffects
    (0, $tZqWC.useEffect)(()=>{
        // for self-hosted transfers
        handleSelfhostedTransfer();
    }, [
        vaspData
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (createdAccount) {
            setFormData({
                ...formData,
                account: createdAccount,
                transfer: {
                    ...formData.transfer,
                    account_id: createdAccount.id
                }
            });
            setCreatedAccount(null);
        }
        if (createdRecipient) {
            setFormData({
                ...formData,
                recipient: createdRecipient,
                transfer: {
                    ...formData.transfer,
                    out_account_id: createdRecipient.id
                }
            });
            setCreatedRecipient(null);
        }
        if (createdVasp) {
            setFormData({
                ...formData,
                vasp: createdVasp
            });
            setCreatedVasp(null);
        }
    }, [
        createdAccount,
        createdRecipient,
        createdVasp
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (formPage !== 5) setDisabledContinue(true);
        if (formPage === 1) {
            if (!formData.transfer?.amount || !formData.transfer?.asset_code || !formData.transfer?.amount_usd) setDisabledContinue(true);
            else setDisabledContinue(false);
        }
        if (formPage === 2) {
            if (!formData.account || !formData.transfer?.in_hash_address) setDisabledContinue(true);
            else setDisabledContinue(false);
        }
        if (formPage === 3) {
            if (!formData.recipient || !formData.transfer?.out_hash_address) setDisabledContinue(true);
            else setDisabledContinue(false);
        }
        if (formPage === 4) {
            if (!formData.vasp || !formData?.transfer.protocol_code) setDisabledContinue(true);
            else setDisabledContinue(false);
        }
        // Disabling transfers between self hosted wallets
        if (formData?.transfer?.selected_account_address?.is_self_hosted && formData?.transfer?.selected_recipient_address?.is_self_hosted) {
            setIsInvalidTransfer(true);
            setErrorMsg('Both addresses cannot be self-hosted');
        } else if (!formData?.transfer?.selected_account_address?.is_self_hosted || !formData?.transfer?.selected_recipient_address?.is_self_hosted) {
            setIsInvalidTransfer(false);
            setErrorMsg();
        }
    }, [
        formData,
        formPage
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (formPage < 5) return;
        if (isTransferCreateSuccess) {
            setIsPageTableUpdated(true);
            showAlert({
                type: 'success',
                message: 'Successfully created transfer'
            });
            setIsTransferDrawerOpen(false);
            setFormPage(1);
            setFormData({
                transfer: {},
                account: null,
                recipient: null,
                vasp: null
            });
        } else if (isTransferCreateError) {
            if (transferCreateError?.response?.status === 402) showAlert({
                type: 'error',
                message: 'Interaction between free-tier VASPs is restricted. Upgrade to a paid plan to enable this feature.'
            });
            else showAlert({
                type: 'error',
                message: 'An unexpected error occurred while creating the transfer'
            });
        }
    }, [
        isTransferCreateSuccess,
        isTransferCreateError
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (isTransferDrawerOpen) setFormData($0c31e108007cf5c7$var$defaultFormData);
    }, [
        isTransferDrawerOpen
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7c0b6d1401667fb6$export$2e2bcd8739ae039), {
        open: isTransferDrawerOpen,
        anchor: "right",
        onClose: handleCloseDrawer,
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $226bdec20dbecb91$export$75aecd7833c0d03e), {
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $226bdec20dbecb91$export$85123f7bee08d0ef), {
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $226bdec20dbecb91$export$5e12c88e3c0628b7), {
                            children: formPage > 1 && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                startIcon: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9cadc73f9b5b2fc9$export$2e2bcd8739ae039), {
                                    size: 30
                                }),
                                variant: "outlined",
                                onClick: handleBack,
                                children: "Back"
                            })
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $226bdec20dbecb91$export$7c43b8aad8dcf5c4), {
                            onClick: handleCloseDrawer,
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b77b5de3fb591045$export$2e2bcd8739ae039), {
                                size: 18
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $226bdec20dbecb91$export$bb68d554ded258ea), {
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $226bdec20dbecb91$export$ef709dfaef303e38), {
                            children: [
                                formPage === 1 && 'Amount',
                                formPage === 2 && 'Sender',
                                formPage === 3 && 'Recipient',
                                formPage === 4 && 'Counterparty VASP',
                                formPage === 5 && 'Confirm'
                            ]
                        }),
                        errorMsg && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $226bdec20dbecb91$export$7287ece93560589d), {
                            children: errorMsg
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ef69c736ae57a14f$export$2e2bcd8739ae039), {
                            pageNumber: formPage,
                            // setPageNumber={setFormPage}
                            headers: (0, $3a4edad937503233$export$e90647e0c7f398be)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $226bdec20dbecb91$export$57ca055474bc0056), {
                    children: [
                        formPage === 1 && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ce9dd9f3122a87a0$export$2e2bcd8739ae039), {
                            formData: formData,
                            setFormData: setFormData,
                            setErrorMsg: setErrorMsg
                        }),
                        formPage === 2 && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $cf1241f5b0acd923$export$2e2bcd8739ae039), {
                            formData: formData,
                            setFormData: setFormData,
                            setErrorMsg: setErrorMsg
                        }),
                        formPage === 3 && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $dc99d1da8f8a575d$export$2e2bcd8739ae039), {
                            formData: formData,
                            setFormData: setFormData,
                            setErrorMsg: setErrorMsg
                        }),
                        formPage === 4 && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $8a2f3408ab47d487$export$2e2bcd8739ae039), {
                            formData: formData,
                            setFormData: setFormData,
                            setErrorMsg: setErrorMsg,
                            recipientAddress: recipientAddress,
                            setRecipientAddress: setRecipientAddress,
                            recipientVaspOptions: recipientVaspOptions,
                            setRecipientVaspOptions: setRecipientVaspOptions
                        }),
                        formPage === 5 && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                            children: isTransferCreateLoading ? /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $226bdec20dbecb91$export$ef709dfaef303e38), {
                                children: formPage === 5 && isTransferCreateLoading && 'Loading...'
                            }) : /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $cde84a77709d3001$export$2e2bcd8739ae039), {
                                formData: formData,
                                setFormData: setFormData,
                                setErrorMsg: setErrorMsg,
                                setFormPage: setFormPage
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $226bdec20dbecb91$export$d05a7d25ec5abf06), {
                    formPage: formPage,
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                        disabled: disabledContinue || isTransferCreateLoading || isInvalidTransfer || isVaspLoading,
                        onClick: handleContinue,
                        children: [
                            isTransferCreateLoading && 'Creating Transfer...',
                            !isTransferCreateLoading && !isVaspLoading && formPage === 5 && 'Confirm',
                            !isTransferCreateLoading && !isVaspLoading && formPage !== 5 && 'Continue',
                            isVaspLoading && 'Loading...'
                        ]
                    })
                })
            ]
        })
    });
}
// Default Props
$0c31e108007cf5c7$var$TransferDrawer.defaultProps = {
    ui: {},
    actions: {},
    form: {}
};
// Proptypes Validation
$0c31e108007cf5c7$var$TransferDrawer.propTypes = {
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isTransferDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setIsTransferDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setCreatedAccount: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setCreatedRecipient: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setCreatedVasp: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showPersistentAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    form: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        createdAccount: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
        }),
        createdRecipient: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
        }),
        createdVasp: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({})
    })
};
var $0c31e108007cf5c7$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($0c31e108007cf5c7$var$mapStateToProps, $0c31e108007cf5c7$var$mapDispatchToProps)($0c31e108007cf5c7$var$TransferDrawer);


var $9c514ece6161cc09$export$2e2bcd8739ae039 = (0, $0c31e108007cf5c7$export$2e2bcd8739ae039);


/* eslint-disable react/jsx-no-useless-fragment */ 

var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");





const $d49344222404dc1a$export$75aecd7833c0d03e = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  display: flex;
  flex-direction: column;

  height: 100%;
  width: 400px;

  & button {
    width: 100%;
  }
`;
const $d49344222404dc1a$export$85123f7bee08d0ef = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  position: absolute;
  top: 25px;
  left: 20px;
`;
const $d49344222404dc1a$export$bb68d554ded258ea = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 20px;

  padding: 20px;
`;
const $d49344222404dc1a$export$5e12c88e3c0628b7 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-start;
  & button {
    display: flex;
    align-items: center;
    gap: 10px;

    max-height: 20px;
    font-size: 15px;
    text-align: left;
    border: none !important;
    padding: 0 !important;
    background-color: transparent !important;
    color: ${({ theme: theme })=>theme.colors.primary} !important;
  }
  & button:hover {
    color: ${({ theme: theme })=>theme.colors.brand} !important;
    & svg > path {
      stroke: ${({ theme: theme })=>theme.colors.brand} !important;
    }
  }
`;
const $d49344222404dc1a$export$57ca055474bc0056 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  flex: 1;

  overflow-y: auto;

  width: 100%;
  padding: 20px;
`;
const $d49344222404dc1a$export$d05a7d25ec5abf06 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  width: 100%;
  padding: 20px;

  border-top: 1px solid ${({ theme: theme })=>theme.colors.backgroundLite};

  & button {
    width: ${({ formPage: formPage })=>formPage === 5 ? '100%' : 'auto'};
  }
`;
const $d49344222404dc1a$export$7c43b8aad8dcf5c4 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-end;
  cursor: pointer;

  // TODO: Use Theme Functions
  &:hover {
    opacity: 0.7;
  }
  & svg {
    fill: ${({ theme: theme })=>theme.colors.primary};
  }
  & svg > path {
    fill: ${({ theme: theme })=>theme.colors.primary};
  }
`;
const $d49344222404dc1a$export$ef709dfaef303e38 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  margin: 0;

  font-size: 20px;
  font-weight: 500;
  text-align: center;

  // TODO: Use Theme Color
  color: ${({ theme: theme })=>theme.colors.primary};
`;




// Map Redux Props
const $71728c45dc8317bd$var$mapStateToProps = (state)=>state;
const $71728c45dc8317bd$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $71728c45dc8317bd$var$LinkAccountDrawer(props) {
    // Destructure
    const { ui: ui, actions: actions, address: address } = props;
    // Store State
    const { isLinkAddressDrawerOpen: isLinkAddressDrawerOpen } = ui;
    const { addressLinkDetails: addressLinkDetails } = address;
    // Store Actions
    const { setIsLinkAddressDrawerOpen: setIsLinkAddressDrawerOpen, showAlert: showAlert, setAddressLinkData: setAddressLinkData } = actions;
    // Hooks
    const { linkAddress: linkAddress, linkAddressData: linkAddressData, linkAddressError: linkAddressError, isLinkAddressLoading: isLinkAddressLoading } = (0, $67ddf601e136650e$export$2e2bcd8739ae039)();
    // State
    const [formData, setFormData] = (0, $tZqWC.useState)({
        account: null
    });
    // Functions
    const handleSubmit = ()=>{
        const { address_id: address_id } = addressLinkDetails;
        linkAddress({
            address_id: address_id,
            link_id: formData.account.id,
            link_type: 1
        });
    };
    const handleCloseDrawer = ()=>{
        setFormData({
            account: null
        });
        setIsLinkAddressDrawerOpen(false);
    };
    // UseEffects
    (0, $tZqWC.useEffect)(()=>{
        if (linkAddressData) {
            setAddressLinkData(formData.account);
            handleCloseDrawer();
        }
    }, [
        linkAddressData
    ]);
    (0, $tZqWC.useEffect)(()=>{
        // TODO ADD PROPER ERROR MSG SENT FROM SERVER
        if (linkAddressError) showAlert({
            type: 'error',
            message: 'An error occurred in linking address'
        });
    }, [
        linkAddressError
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7c0b6d1401667fb6$export$2e2bcd8739ae039), {
        open: isLinkAddressDrawerOpen,
        anchor: "right",
        onClose: handleCloseDrawer,
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $d49344222404dc1a$export$75aecd7833c0d03e), {
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d49344222404dc1a$export$85123f7bee08d0ef), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d49344222404dc1a$export$7c43b8aad8dcf5c4), {
                        onClick: handleCloseDrawer,
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b77b5de3fb591045$export$2e2bcd8739ae039), {
                            size: 18
                        })
                    })
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d49344222404dc1a$export$bb68d554ded258ea), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d49344222404dc1a$export$ef709dfaef303e38), {
                        children: "Link Address To An Account"
                    })
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $d49344222404dc1a$export$57ca055474bc0056), {
                    children: [
                        isLinkAddressLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $647b8bc68ebce54f$export$2e2bcd8739ae039), {}),
                        !isLinkAddressLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $42b0f37ae1b62244$export$2e2bcd8739ae039), {
                            formData: formData,
                            setFormData: setFormData
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d49344222404dc1a$export$d05a7d25ec5abf06), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                        disabled: formData.account === null || isLinkAddressLoading,
                        onClick: handleSubmit,
                        children: "Confirm"
                    })
                })
            ]
        })
    });
}
// Default Props
$71728c45dc8317bd$var$LinkAccountDrawer.defaultProps = {
    ui: {},
    actions: {},
    address: {}
};
// Proptypes Validation
$71728c45dc8317bd$var$LinkAccountDrawer.propTypes = {
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isLinkAddressDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setIsLinkAddressDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setCreatedAccount: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setCreatedVasp: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAddressLinkDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAddressLinkData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    address: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        addressLinkDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            address_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
        })
    })
};
var $71728c45dc8317bd$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($71728c45dc8317bd$var$mapStateToProps, $71728c45dc8317bd$var$mapDispatchToProps)($71728c45dc8317bd$var$LinkAccountDrawer);


var $110a85a156da9048$export$2e2bcd8739ae039 = (0, $71728c45dc8317bd$export$2e2bcd8739ae039);


/* eslint-disable react/jsx-no-useless-fragment */ 

var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");





const $bb8a84d8ffa2a54e$export$75aecd7833c0d03e = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  display: flex;
  flex-direction: column;

  height: 100%;
  width: 400px;

  & button {
    width: 100%;
  }
`;
const $bb8a84d8ffa2a54e$export$85123f7bee08d0ef = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  position: absolute;
  top: 25px;
  left: 20px;
`;
const $bb8a84d8ffa2a54e$export$bb68d554ded258ea = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 20px;

  padding: 20px;
`;
const $bb8a84d8ffa2a54e$export$5e12c88e3c0628b7 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-start;
  & button {
    display: flex;
    align-items: center;
    gap: 10px;

    max-height: 20px;
    font-size: 15px;
    text-align: left;
    border: none !important;
    padding: 0 !important;
    background-color: transparent !important;
    color: ${({ theme: theme })=>theme.colors.primary} !important;
  }
  & button:hover {
    color: ${({ theme: theme })=>theme.colors.brand} !important;
    & svg > path {
      stroke: ${({ theme: theme })=>theme.colors.brand} !important;
    }
  }
`;
const $bb8a84d8ffa2a54e$export$57ca055474bc0056 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  flex: 1;

  overflow-y: auto;

  width: 100%;
  padding: 20px;
`;
const $bb8a84d8ffa2a54e$export$d05a7d25ec5abf06 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  width: 100%;
  padding: 20px;

  border-top: 1px solid ${({ theme: theme })=>theme.colors.backgroundLite};

  & button {
    width: ${({ formPage: formPage })=>formPage === 5 ? '100%' : 'auto'};
  }
`;
const $bb8a84d8ffa2a54e$export$7c43b8aad8dcf5c4 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-end;
  cursor: pointer;

  // TODO: Use Theme Functions
  &:hover {
    opacity: 0.7;
  }
  & svg {
    fill: ${({ theme: theme })=>theme.colors.primary};
  }
  & svg > path {
    fill: ${({ theme: theme })=>theme.colors.primary};
  }
`;
const $bb8a84d8ffa2a54e$export$ef709dfaef303e38 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  margin: 0;

  font-size: 20px;
  font-weight: 500;
  text-align: center;

  // TODO: Use Theme Color
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $bb8a84d8ffa2a54e$export$2e0a83ec2e27ecbb = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: 100%;
  height: 2px;
  background-color: ${({ theme: theme })=>theme.colors.backgroundLite};
  margin-top: 30px;
`;




// Map Redux Props
const $409fe8b5dc6544ef$var$mapStateToProps = (state)=>state;
const $409fe8b5dc6544ef$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $409fe8b5dc6544ef$var$LinkAccountDrawer(props) {
    // Destructure
    const { ui: ui, actions: actions, transaction: transaction } = props;
    // Store State
    const { isLinkTransactionDrawerOpen: isLinkTransactionDrawerOpen } = ui;
    const { transactionLinkDetails: transactionLinkDetails } = transaction;
    // Store Actions
    const { setIsLinkTransactionDrawerOpen: setIsLinkTransactionDrawerOpen, showAlert: showAlert, setTransactionLinkData: setTransactionLinkData } = actions;
    // Hooks
    const { linkTransaction: linkTransaction, linkTransactionData: linkTransactionData, linkTransactionError: linkTransactionError, isLinkTransactionLoading: isLinkTransactionLoading } = (0, $13b0a53fe27a5cf7$export$2e2bcd8739ae039)();
    // State
    const [formData, setFormData] = (0, $tZqWC.useState)({
        account: null
    });
    const [formData2, setFormData2] = (0, $tZqWC.useState)({
        account: null
    });
    // Functions
    const handleSubmit = ()=>{
        const { transaction_id: transaction_id } = transactionLinkDetails;
        linkTransaction({
            transaction_id: transaction_id,
            sender_link_id: formData.account ? formData.account.account_id : null,
            sender_link_type: formData.account ? 1 : null,
            recipient_link_id: formData2.account ? formData2.account.account_id : null,
            recipient_link_type: formData2.account ? 1 : null
        });
    };
    const handleCloseDrawer = ()=>{
        setFormData({
            account: null
        });
        setFormData2({
            account: null
        });
        setIsLinkTransactionDrawerOpen(false);
    };
    // UseEffects
    (0, $tZqWC.useEffect)(()=>{
        if (linkTransactionData) {
            setTransactionLinkData({
                sender: formData?.account,
                recipient: formData2?.account
            });
            handleCloseDrawer();
        }
    }, [
        linkTransactionData
    ]);
    (0, $tZqWC.useEffect)(()=>{
        // TODO ADD PROPER ERROR MSG SENT FROM SERVER
        if (linkTransactionError) showAlert({
            type: 'error',
            message: 'An error occurred in linking transaction'
        });
    }, [
        linkTransactionError
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7c0b6d1401667fb6$export$2e2bcd8739ae039), {
        open: isLinkTransactionDrawerOpen,
        anchor: "right",
        onClose: handleCloseDrawer,
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $bb8a84d8ffa2a54e$export$75aecd7833c0d03e), {
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bb8a84d8ffa2a54e$export$85123f7bee08d0ef), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bb8a84d8ffa2a54e$export$7c43b8aad8dcf5c4), {
                        onClick: handleCloseDrawer,
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b77b5de3fb591045$export$2e2bcd8739ae039), {
                            size: 18
                        })
                    })
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bb8a84d8ffa2a54e$export$bb68d554ded258ea), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bb8a84d8ffa2a54e$export$ef709dfaef303e38), {
                        children: "Link Transaction To An Account"
                    })
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $bb8a84d8ffa2a54e$export$57ca055474bc0056), {
                    children: [
                        isLinkTransactionLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $647b8bc68ebce54f$export$2e2bcd8739ae039), {}),
                        !isLinkTransactionLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6359c052d65b722c$export$2e2bcd8739ae039), {
                            label: "Link Sender to an Account",
                            title: "Selected Sender Account",
                            formData: formData,
                            setFormData: setFormData
                        }),
                        !isLinkTransactionLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bb8a84d8ffa2a54e$export$2e0a83ec2e27ecbb), {}),
                        !isLinkTransactionLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6359c052d65b722c$export$2e2bcd8739ae039), {
                            label: "Link Recipient to an Account",
                            title: "Selected Recipient Account",
                            formData: formData2,
                            setFormData: setFormData2
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bb8a84d8ffa2a54e$export$d05a7d25ec5abf06), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                        disabled: formData?.account === null && formData2?.account === null || isLinkTransactionLoading,
                        onClick: handleSubmit,
                        children: "Confirm"
                    })
                })
            ]
        })
    });
}
// Default Props
$409fe8b5dc6544ef$var$LinkAccountDrawer.defaultProps = {
    ui: {},
    actions: {},
    transaction: {}
};
// Proptypes Validation
$409fe8b5dc6544ef$var$LinkAccountDrawer.propTypes = {
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isLinkTransactionDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setIsLinkTransactionDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setCreatedAccount: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setCreatedRecipient: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setCreatedVasp: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setTransactionLinkDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setTransactionLinkData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    transaction: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        transactionLinkDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            transaction_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
        })
    })
};
var $409fe8b5dc6544ef$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($409fe8b5dc6544ef$var$mapStateToProps, $409fe8b5dc6544ef$var$mapDispatchToProps)($409fe8b5dc6544ef$var$LinkAccountDrawer);


var $3434805d4cb42c0f$export$2e2bcd8739ae039 = (0, $409fe8b5dc6544ef$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");







const $a9376ebbead9e8c1$export$75f51cf067955710 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  display: flex;
  flex-direction: column;

  height: 100%;
  width: 400px;
  padding: 20px;
`;
const $a9376ebbead9e8c1$export$7c43b8aad8dcf5c4 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: absolute;
  top: 20px;
  right: 20px;

  cursor: pointer;

  // TODO: Use Theme Functions
  &:hover {
    opacity: 0.7;
  }
  & svg > path {
    stroke: ${({ theme: theme })=>theme.colors.primary};
  }
`;
const $a9376ebbead9e8c1$export$ac7496df4f1f837a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding-bottom: 40px;
`;
const $a9376ebbead9e8c1$export$71c7816ee3a5a527 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h4`
  font-size: 15px;
  font-weight: 600;
  margin: 20px 0 0 10px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $a9376ebbead9e8c1$export$b7544c113151846d = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 14px;
  font-weight: 500;
  margin: 10px 0 10px 10px;
  color: ${({ theme: theme })=>theme.colors.red};
`;




// Map Redux Props
const $33087da43462947b$var$mapStateToProps = (state)=>state;
const $33087da43462947b$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $33087da43462947b$var$UserDrawer(props) {
    // Destructure
    const { ui: ui, actions: actions } = props;
    const { vasp_id: vasp_id } = (0, $a0d5c3f2fe524011$export$99eaa27ddbbb95ef)();
    //  Store State
    const { isUserDrawerOpen: isUserDrawerOpen } = ui;
    // Store Actions
    const { setIsPageTableUpdated: setIsPageTableUpdated, showAlert: showAlert, setIsUserDrawerOpen: setIsUserDrawerOpen } = actions;
    //  Refs
    const formRef = (0, $tZqWC.useRef)();
    // Functions
    const handleCloseDrawer = ()=>{
        setIsUserDrawerOpen();
    };
    // Internal State
    const [errorMsg, setErrorMsg] = (0, $tZqWC.useState)();
    // Hooks
    const [userCredentials] = (0, $a9c50ebe96619b20$export$2e2bcd8739ae039)('userCredentials');
    const { createUser: createUser, createUserData: createUserData, createUserError: createUserError, isCreateUserLoading: isCreateUserLoading } = (0, $3f6edbf78d1f8fb8$export$2e2bcd8739ae039)();
    const { addVaspUser: addVaspUser, addVaspUserData: addVaspUserData, addVaspUserError: addVaspUserError, isAddVaspUserLoading: isAddVaspUserLoading } = (0, $a5d10b67cb12f506$export$2e2bcd8739ae039)() // Admin Endpoint
    ;
    // Functions
    const triggerSubmit = ()=>{
        formRef.current.submitForm();
    };
    const handleSubmit = (values)=>{
        if (userCredentials?.role_id === 0) addVaspUser({
            ...values,
            vasp_id: vasp_id
        });
        else if (userCredentials?.role_id === 1) createUser(values);
    };
    const handleSuccess = ()=>{
        setIsPageTableUpdated(true);
        showAlert({
            type: 'success',
            message: 'Successfully created user'
        });
        setIsUserDrawerOpen();
    };
    const handleErr = ()=>{
        if (createUserError?.response?.data?.context && !createUserError?.response?.data?.context?.error) {
            setErrorMsg(createUserError?.response?.data?.context);
            return;
        }
        showAlert({
            type: 'error',
            message: 'Error: Could not create user'
        });
    };
    // UseEffects
    (0, $tZqWC.useEffect)(()=>{
        if (isCreateUserLoading) return;
        if (createUserError) {
            handleErr();
            return;
        }
        if (createUserData) handleSuccess();
    }, [
        createUserData,
        createUserError
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (isAddVaspUserLoading) return;
        if (addVaspUserError) {
            handleErr();
            return;
        }
        if (addVaspUserData) handleSuccess();
    }, [
        addVaspUserData,
        addVaspUserError
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7c0b6d1401667fb6$export$2e2bcd8739ae039), {
        open: isUserDrawerOpen,
        anchor: "right",
        onClose: handleCloseDrawer,
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $a9376ebbead9e8c1$export$75f51cf067955710), {
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a9376ebbead9e8c1$export$7c43b8aad8dcf5c4), {
                    onClick: handleCloseDrawer,
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b77b5de3fb591045$export$2e2bcd8739ae039), {
                        size: 18
                    })
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $a9376ebbead9e8c1$export$ac7496df4f1f837a), {
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a9376ebbead9e8c1$export$71c7816ee3a5a527), {
                            children: "Create User"
                        }),
                        errorMsg && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a9376ebbead9e8c1$export$b7544c113151846d), {
                            children: errorMsg
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $29f9c1b9bfe7b1a8$export$2e2bcd8739ae039), {
                            formRef: formRef,
                            handleSubmit: handleSubmit
                        }),
                        isCreateUserLoading ? /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                            disabled: true,
                            children: "Creating user..."
                        }) : /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                            type: "button",
                            onClick: triggerSubmit,
                            children: "Submit"
                        })
                    ]
                })
            ]
        })
    });
}
// Default Props
$33087da43462947b$var$UserDrawer.defaultProps = {
    ui: {},
    actions: {}
};
// Proptypes Validation
$33087da43462947b$var$UserDrawer.propTypes = {
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isUserDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setIsUserDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $33087da43462947b$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($33087da43462947b$var$mapStateToProps, $33087da43462947b$var$mapDispatchToProps)($33087da43462947b$var$UserDrawer);


var $3f16d287ce546a6e$export$2e2bcd8739ae039 = (0, $33087da43462947b$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");



const $1887fadf18cfa3e8$export$e833dfe35f2086ee = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 14.5px;
  font-weight: 400;
  padding: 0px 0px 20px 0px;
  max-width: 400px;
`;




// Map Redux Props
const $52b6e1b6099dc2f5$var$mapStateToProps = (state)=>state;
const $52b6e1b6099dc2f5$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $52b6e1b6099dc2f5$var$RemoveUserModal(props) {
    // Destructure
    const { ui: ui, actions: actions, auth: auth } = props;
    // Store State
    const { isRemoveUserModalOpen: isRemoveUserModalOpen } = ui;
    const { userToDeact: userToDeact } = auth;
    // Store Actions
    const { toggleRemoveUserModal: toggleRemoveUserModal, setIsPageTableUpdated: setIsPageTableUpdated, setUserToDeact: setUserToDeact } = actions;
    // Hooks
    const { updateUser: updateUser, updateUserError: updateUserError, isUpdateUserLoading: isUpdateUserLoading } = (0, $006abbba5bd33f8a$export$2e2bcd8739ae039)();
    // Functions
    const toggleModal = ()=>{
        toggleRemoveUserModal();
    };
    const handleDeact = ()=>{
        updateUser({
            user_id: userToDeact.user_id,
            is_active: userToDeact.is_active
        });
    };
    // UseEffect
    (0, $tZqWC.useEffect)(()=>{
        if (isRemoveUserModalOpen) {
            if (!isUpdateUserLoading && !updateUserError) {
                setIsPageTableUpdated(true);
                setUserToDeact();
                toggleRemoveUserModal();
            }
        }
    }, [
        isUpdateUserLoading
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $0cb604e8ac00d438$export$2e2bcd8739ae039), {
        isOpen: isRemoveUserModalOpen,
        toggle: toggleModal,
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6e660ada3ebfb268$export$2e2bcd8739ae039), {
                toggle: toggleModal,
                children: "Remove User"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $5a83d1c72fcd9217$export$2e2bcd8739ae039), {
                children: [
                    isUpdateUserLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1887fadf18cfa3e8$export$e833dfe35f2086ee), {
                        children: "Removing User..."
                    }),
                    !isUpdateUserLoading && !updateUserError && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1887fadf18cfa3e8$export$e833dfe35f2086ee), {
                        children: "Are you sure you want to remove this user?"
                    }),
                    !isUpdateUserLoading && updateUserError && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1887fadf18cfa3e8$export$e833dfe35f2086ee), {
                        children: "An error occurred in removing user, please try again later."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $b07759276f5d7f2d$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                        fullWidth: true,
                        type: "button",
                        onClick: toggleModal,
                        variant: "outlined",
                        disabled: isUpdateUserLoading,
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                        fullWidth: true,
                        type: "button",
                        onClick: handleDeact,
                        color: "secondary",
                        disabled: isUpdateUserLoading,
                        children: "Remove"
                    })
                ]
            })
        ]
    });
}
// Default Props
$52b6e1b6099dc2f5$var$RemoveUserModal.defaultProps = {
    ui: {},
    form: {},
    actions: {}
};
// Proptypes Validation
$52b6e1b6099dc2f5$var$RemoveUserModal.propTypes = {
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isRemoveUserModalOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    form: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        activityToRemove: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            hash: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
        })
    }),
    auth: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        userToDeact: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            user_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            is_active: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
        })
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        toggleRemoveUserModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setUserToDeact: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $52b6e1b6099dc2f5$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($52b6e1b6099dc2f5$var$mapStateToProps, $52b6e1b6099dc2f5$var$mapDispatchToProps)($52b6e1b6099dc2f5$var$RemoveUserModal);


var $02caa3170cb7f4b1$export$2e2bcd8739ae039 = (0, $52b6e1b6099dc2f5$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");



const $6bb1320a29b8e4b7$export$e833dfe35f2086ee = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 14.5px;
  font-weight: 400;
  padding: 0px 0px 20px 0px;
  max-width: 400px;
`;




// Map Redux Props
const $80b6aae4e740a748$var$mapStateToProps = (state)=>state;
const $80b6aae4e740a748$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $80b6aae4e740a748$var$RemoveUserModal(props) {
    // Destructure
    const { ui: ui, actions: actions, auth: auth } = props;
    // Store State
    const { isRemoveApiKeyModalOpen: isRemoveApiKeyModalOpen } = ui;
    const { apiKeyToDelete: apiKeyToDelete } = auth;
    // Store Actions
    const { toggleRemoveApiKeyModal: toggleRemoveApiKeyModal, setIsPageTableUpdated: setIsPageTableUpdated, setApiKeyToDelete: setApiKeyToDelete } = actions;
    // Hooks
    const { revokeIntegrationToken: revokeIntegrationToken, revokeIntegrationTokenError: revokeIntegrationTokenError, isRevokeIntegrationTokenLoading: isRevokeIntegrationTokenLoading } = (0, $6e0dfcacffe2f6c7$export$2e2bcd8739ae039)();
    // Functions
    const toggleModal = ()=>{
        toggleRemoveApiKeyModal();
    };
    const handleDeact = ()=>{
        revokeIntegrationToken({
            jti: apiKeyToDelete.jti
        });
    };
    // UseEffect
    (0, $tZqWC.useEffect)(()=>{
        if (isRemoveApiKeyModalOpen) {
            if (!isRevokeIntegrationTokenLoading && !revokeIntegrationTokenError) {
                setIsPageTableUpdated(true);
                setApiKeyToDelete();
                toggleRemoveApiKeyModal();
            }
        }
    }, [
        isRevokeIntegrationTokenLoading
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $0cb604e8ac00d438$export$2e2bcd8739ae039), {
        isOpen: isRemoveApiKeyModalOpen,
        toggle: toggleModal,
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6e660ada3ebfb268$export$2e2bcd8739ae039), {
                toggle: toggleModal,
                children: "Remove API Key"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $5a83d1c72fcd9217$export$2e2bcd8739ae039), {
                children: [
                    isRevokeIntegrationTokenLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6bb1320a29b8e4b7$export$e833dfe35f2086ee), {
                        children: "Removing API Key..."
                    }),
                    !isRevokeIntegrationTokenLoading && !revokeIntegrationTokenError && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6bb1320a29b8e4b7$export$e833dfe35f2086ee), {
                        children: "Are you sure you want to remove this API Key?"
                    }),
                    !isRevokeIntegrationTokenLoading && revokeIntegrationTokenError && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6bb1320a29b8e4b7$export$e833dfe35f2086ee), {
                        children: "An error occurred in removing API Key, please try again later."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $b07759276f5d7f2d$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                        fullWidth: true,
                        type: "button",
                        onClick: toggleModal,
                        variant: "outlined",
                        disabled: isRevokeIntegrationTokenLoading,
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                        fullWidth: true,
                        type: "button",
                        onClick: handleDeact,
                        color: "secondary",
                        disabled: isRevokeIntegrationTokenLoading,
                        children: "Remove"
                    })
                ]
            })
        ]
    });
}
// Default Props
$80b6aae4e740a748$var$RemoveUserModal.defaultProps = {
    ui: {},
    form: {},
    actions: {}
};
// Proptypes Validation
$80b6aae4e740a748$var$RemoveUserModal.propTypes = {
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isRemoveApiKeyModalOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    form: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        activityToRemove: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            hash: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
        })
    }),
    auth: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        apiKeyToDelete: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            jti: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
        })
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        toggleRemoveApiKeyModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setApiKeyToDelete: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $80b6aae4e740a748$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($80b6aae4e740a748$var$mapStateToProps, $80b6aae4e740a748$var$mapDispatchToProps)($80b6aae4e740a748$var$RemoveUserModal);


var $cf1c5a197e1a201a$export$2e2bcd8739ae039 = (0, $80b6aae4e740a748$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");






const $d59e53547803d4ac$export$47042699470e17dd = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-end;
`;
const $d59e53547803d4ac$export$e833dfe35f2086ee = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 14.5px;
  font-weight: 400;
  padding: 0px 0px 20px 0px;
`;
const $d59e53547803d4ac$export$7316ba21c2af33a0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  margin: 0px 0px 0px 10px;
`;
const $d59e53547803d4ac$export$87ad169bde460ddf = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
const $d59e53547803d4ac$export$9eb4983a4c53e067 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
const $d59e53547803d4ac$export$d971b98a124cabfc = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $d59e53547803d4ac$export$bc5d3d47471a2a87 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $d59e53547803d4ac$export$62418a83a560b23a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  gap: 12px;
  padding: 20px;
  background-color: ${({ theme: theme })=>theme.colors.backgroundLite};
`;
const $d59e53547803d4ac$export$ab35601bed9ca017 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $d59e53547803d4ac$export$ebf46abec8fcda8b = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;
const $d59e53547803d4ac$export$b543744be639a33d = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 12px;
`;
const $d59e53547803d4ac$export$b30c94aee60c7d6b = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: absolute;
  top: 100%;
  margin-top: 10px;

  font-size: 15px;
  font-weight: 400;
  padding: 10px 20px;
  border-radius: 10px;
  background-color: ${({ theme: theme })=>theme.colors.background};

  transition: 0.1s;
  opacity: ${({ display: display })=>display ? 1 : 0};
  box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.15);
`;


// Map Redux Props
const $caace80b1a2c0b27$var$mapStateToProps = (state)=>state;
const $caace80b1a2c0b27$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $caace80b1a2c0b27$var$CreateApiKeyModal(props) {
    // Destructure
    const { ui: ui, actions: actions } = props;
    // Store State
    const { isCreateApiKeyModalOpen: isCreateApiKeyModalOpen } = ui;
    // Store Actions
    const { toggleCreateApiKeyModal: toggleCreateApiKeyModal, setIsPageTableUpdated: setIsPageTableUpdated } = actions;
    // Local State
    const [token, setToken] = (0, $tZqWC.useState)();
    const [copyNotification, setCopyNotification] = (0, $tZqWC.useState)('');
    // Functions
    const toggleModal = ()=>{
        toggleCreateApiKeyModal();
    };
    const handleExit = ()=>{
        setToken();
        setIsPageTableUpdated(true);
    };
    const copyHash = ()=>{
        navigator.clipboard.writeText(token).then(()=>setCopyNotification('Copied!'), ()=>setCopyNotification('Error: Could not copy'));
        setTimeout(()=>setCopyNotification(''), 700);
    };
    // UseEffect
    (0, $tZqWC.useEffect)(()=>{
        if (!isCreateApiKeyModalOpen && token) handleExit();
    }, [
        isCreateApiKeyModalOpen
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $0cb604e8ac00d438$export$2e2bcd8739ae039), {
        isOpen: isCreateApiKeyModalOpen,
        toggle: toggleModal,
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6e660ada3ebfb268$export$2e2bcd8739ae039), {
                toggle: toggleModal,
                children: token ? 'Successfully generated API Key' : 'Store your API Key'
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $5a83d1c72fcd9217$export$2e2bcd8739ae039), {
                style: {
                    maxWidth: '600px',
                    overflow: 'visible'
                },
                children: [
                    !token && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6efa72a86165ef17$export$2e2bcd8739ae039), {
                        setResponse: setToken
                    }),
                    token && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $d59e53547803d4ac$export$9eb4983a4c53e067), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d59e53547803d4ac$export$87ad169bde460ddf), {
                                style: {
                                    padding: '0 12px'
                                },
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d59e53547803d4ac$export$bc5d3d47471a2a87), {
                                    children: "Please store your API key securely, as it will not be shown again. Anyone with access to this key can make requests on your behalf. If it is lost, you will need to generate a new one."
                                })
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $d59e53547803d4ac$export$62418a83a560b23a), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d59e53547803d4ac$export$ebf46abec8fcda8b), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $d59e53547803d4ac$export$b543744be639a33d), {
                                            onClick: copyHash,
                                            children: [
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d59e53547803d4ac$export$bc5d3d47471a2a87), {
                                                    children: "Copy to Clipboard"
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c43eb4ee7dedc1da$export$2e2bcd8739ae039), {
                                                    size: 18,
                                                    className: "hashWrapper"
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d59e53547803d4ac$export$b30c94aee60c7d6b), {
                                                    display: copyNotification,
                                                    children: copyNotification
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d59e53547803d4ac$export$ab35601bed9ca017), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d59e53547803d4ac$export$bc5d3d47471a2a87), {
                                            style: {
                                                wordBreak: 'break-all',
                                                fontSize: 12
                                            },
                                            children: token
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
// Default Props
$caace80b1a2c0b27$var$CreateApiKeyModal.defaultProps = {
    ui: {},
    form: {},
    actions: {}
};
// Proptypes Validation
$caace80b1a2c0b27$var$CreateApiKeyModal.propTypes = {
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isCreateApiKeyModalOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
        approveVaspDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            vasp_name: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            vasp_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
        })
    }),
    form: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        activityToRemove: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            hash: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
        })
    }),
    address: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        addressRemove: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            address_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
        })
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        toggleCreateApiKeyModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAddressRemove: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $caace80b1a2c0b27$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($caace80b1a2c0b27$var$mapStateToProps, $caace80b1a2c0b27$var$mapDispatchToProps)($caace80b1a2c0b27$var$CreateApiKeyModal);


var $d3be7dba4fa37a9c$export$2e2bcd8739ae039 = (0, $caace80b1a2c0b27$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");



const $507419869d469413$export$e833dfe35f2086ee = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 15px;
  font-weight: 400;
  padding: 20px;
  max-width: 400px;
`;




// Map Redux Props
const $c829037a0be7107d$var$mapStateToProps = (state)=>state;
const $c829037a0be7107d$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $c829037a0be7107d$var$DeleteAddressModal(props) {
    // Destructure
    const { ui: ui, actions: actions, address: address } = props;
    // Store State
    const { isDeleteAddressModalOpen: isDeleteAddressModalOpen } = ui;
    const { addressRemove: addressRemove } = address;
    // Store Actions
    const { toggleDeleteAddressModal: toggleDeleteAddressModal, setIsPageTableUpdated: setIsPageTableUpdated, setAddressRemove: setAddressRemove } = actions;
    // Hooks
    const { deleteAddress: deleteAddress, deleteAddressData: deleteAddressData, deleteAddressError: deleteAddressError, isDeleteAddressLoading: isDeleteAddressLoading } = (0, $6ce007ee53db4e92$export$2e2bcd8739ae039)();
    // Functions
    const toggleModal = ()=>{
        toggleDeleteAddressModal();
    };
    const handleDelete = ()=>{
        deleteAddress({
            address_id: addressRemove.address_id
        });
    };
    // UseEffect
    (0, $tZqWC.useEffect)(()=>{
        if (isDeleteAddressModalOpen) {
            if (!isDeleteAddressLoading && !!deleteAddressData && !deleteAddressError) {
                setIsPageTableUpdated(true);
                setAddressRemove({
                    addressRemove: ''
                });
                toggleDeleteAddressModal();
            }
        }
    }, [
        isDeleteAddressLoading
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $0cb604e8ac00d438$export$2e2bcd8739ae039), {
        isOpen: isDeleteAddressModalOpen,
        toggle: toggleModal,
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6e660ada3ebfb268$export$2e2bcd8739ae039), {
                toggle: toggleModal,
                children: "Delete Address"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $5a83d1c72fcd9217$export$2e2bcd8739ae039), {
                children: [
                    isDeleteAddressLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $507419869d469413$export$e833dfe35f2086ee), {
                        children: "Deleting..."
                    }),
                    !deleteAddressData && !isDeleteAddressLoading && !deleteAddressError && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $507419869d469413$export$e833dfe35f2086ee), {
                        children: "Are you sure you want to delete this address? This action is irreversible."
                    }),
                    !isDeleteAddressLoading && deleteAddressError && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $507419869d469413$export$e833dfe35f2086ee), {
                        children: "An error occurred in removing address, please try again later."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $b07759276f5d7f2d$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                        fullWidth: true,
                        type: "button",
                        onClick: toggleModal,
                        variant: "outlined",
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                        fullWidth: true,
                        type: "button",
                        onClick: handleDelete,
                        color: "secondary",
                        children: "Delete"
                    })
                ]
            })
        ]
    });
}
// Default Props
$c829037a0be7107d$var$DeleteAddressModal.defaultProps = {
    ui: {},
    form: {},
    actions: {}
};
// Proptypes Validation
$c829037a0be7107d$var$DeleteAddressModal.propTypes = {
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isDeleteAddressModalOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    form: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        activityToRemove: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            hash: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
        })
    }),
    address: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        addressRemove: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            address_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
        })
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        toggleDeleteAddressModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAddressRemove: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $c829037a0be7107d$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($c829037a0be7107d$var$mapStateToProps, $c829037a0be7107d$var$mapDispatchToProps)($c829037a0be7107d$var$DeleteAddressModal);


var $69d9caa7ff6e60d3$export$2e2bcd8739ae039 = (0, $c829037a0be7107d$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");


var $ejSM7 = parcelRequire("ejSM7");








const $f962e544a1be9401$export$87ad169bde460ddf = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  width: 100%;
`;
const $f962e544a1be9401$export$bc7adc8ef74607f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
`;
const $f962e544a1be9401$export$a9754b3c8daa5172 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  gap: 10px;
`;
const $f962e544a1be9401$export$4e8a51dfb7785a56 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  align-items: center;
  grid-template-columns: 1.5fr 1fr 1fr 2fr;
  gap: 10px;
  width: 100%;
`;
const $f962e544a1be9401$export$f99233281efd08a0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h2`
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  text-transform: uppercase;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $f962e544a1be9401$export$5f1af8db9871e1d6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  margin: 0;
  font-size: 15px;
  font-weight: 400;
`;
const $f962e544a1be9401$export$34028d8930504f65 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).span`
  margin: 0;
  font-size: 8px;
  font-weight: 400;
`;
const $f962e544a1be9401$export$9ce5373cfda0847e = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  margin: 0;
  font-size: 12px;
  font-weight: 400;
`;



// Map Redux Props
const $079dd66f383aa237$var$mapStateToProps = (state)=>state;
const $079dd66f383aa237$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $079dd66f383aa237$var$AddressHistoryModal(props) {
    // Destructure
    const { ui: ui, actions: actions, filters: filters } = props;
    // Store State
    const { isAddressHistoryModalOpen: isAddressHistoryModalOpen } = ui;
    const { addressHistoryFilters: addressHistoryFilters } = filters;
    const { start_range: start_range, end_range: end_range } = addressHistoryFilters;
    // Store Actions
    const { toggleAddressHistoryModal: toggleAddressHistoryModal, setAddressHistoryFilters: setAddressHistoryFilters } = actions;
    // Constant Variables
    const dayCap = 13;
    const weekCap = 103;
    // Local State
    const [riskData, setRiskData] = (0, $tZqWC.useState)();
    const [financialData, setFinancialData] = (0, $tZqWC.useState)();
    const [historyData, setHistoryData] = (0, $tZqWC.useState)();
    const [totalItems, setTotalItems] = (0, $tZqWC.useState)();
    const [pageSize, setPageSize] = (0, $tZqWC.useState)();
    const [activePage, setActivePage] = (0, $tZqWC.useState)(1);
    // Hooks
    const { getAddressHistory: getAddressHistory, getAddressHistoryData: getAddressHistoryData, isGetAddressHistoryLoading: isGetAddressHistoryLoading } = (0, $40ec4c0bc93edec7$export$2e2bcd8739ae039)();
    const [theme] = (0, $a9c50ebe96619b20$export$2e2bcd8739ae039)('theme', 'light');
    // Functions
    const toggleModal = ()=>{
        toggleAddressHistoryModal();
        setAddressHistoryFilters({});
    };
    function invertData(data) {
        let invertedData = [];
        data.forEach((item)=>{
            invertedData = [
                item,
                ...invertedData
            ];
        });
        return invertedData;
    }
    function formatHistoryData(data) {
        const newHistoryData = [];
        data.forEach((item)=>{
            const newData = {
                address: item.address,
                request_time: item.request_time,
                risk_score: item.risk_data.risk_ratio,
                balance_usd: item?.financial_data?.balance_usd ? Math.round(item.financial_data.balance_usd * 10) / 10 : null,
                balance: item?.financial_data?.balance,
                symbol: item.symbol,
                chain: item.chain
            };
            newHistoryData.push(newData);
        });
        return newHistoryData;
    }
    function formatToDays(data) {
        const datasets = [];
        const labels = [];
        const oldestTime = (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(data[data.length - 1].request_time);
        let latestTime = (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(data[0].request_time);
        while((0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(latestTime).diff(oldestTime, 'day') >= 0){
            // pushing every single day to the dataset
            labels.push(`${latestTime.format('MMM DD').toString()}`);
            if (datasets.length < 1) datasets.push(data[0].value * 1.0);
            // Looping through the data
            for(let i = 0; i < data.length; i++)// checking if there is data for the latest date
            if ((0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(latestTime).diff((0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(data[i].request_time), 'day') === 0) {
                // checking if the latest date data exists in the dataset
                if (datasets.length < labels.length) datasets.push(data[i].value * 1.0);
                else if (datasets[datasets.length - 1] < data[i].value) datasets[datasets.length - 1] = data[i].value * 1.0;
            }
            // checking if the latest date data exists in the dataset
            if (datasets.length < labels.length) // using the last risk ratio as the risk ratio
            // of the day if it doesnt have one
            datasets.push(datasets[datasets.length - 1] * 1.0);
            latestTime = (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(latestTime).subtract(1, 'day');
        }
        return {
            datasets: datasets,
            labels: labels
        };
    }
    function formatToWeeks(data) {
        const datasets = [];
        const labels = [];
        const oldestTime = (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(data[data.length - 1].request_time);
        let latestTime = (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(data[0].request_time);
        while((0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(latestTime).diff(oldestTime, 'week') >= 0){
            if (datasets.length > 10) break;
            // pushing every single week to the dataset
            labels.push(`${latestTime.clone().weekday(1).format('MMM DD').toString()} - ${latestTime.clone().weekday(7).format('MMM DD').toString()}`);
            if (datasets.length < 1) datasets.push(data[0].value * 1.0);
            // Looping through the data
            for(let i = 0; i < data.length; i++)// checking if there is data for the latest date
            if ((0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(latestTime).diff((0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(data[i].request_time), 'week') === 0) {
                // checking if the latest date data exists in the dataset
                if (datasets.length < labels.length) datasets.push(data[i].value * 1.0);
                else if (datasets[datasets.length - 1] < data[i].value) datasets[datasets.length - 1] = data[i].value * 1.0;
            }
            // checking if the latest date data exists in the dataset
            if (datasets.length < labels.length) // using the last risk ratio as the risk ratio
            // of the week if it doesnt have one
            datasets.push(datasets[datasets.length - 1] * 1.0);
            latestTime = (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(latestTime).subtract(7, 'days');
        }
        return {
            datasets: datasets,
            labels: labels
        };
    }
    function formatToMonths(data) {
        const datasets = [];
        const labels = [];
        const oldestTime = (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(data[data.length - 1].request_time);
        let latestTime = (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(data[0].request_time);
        while((0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(latestTime).diff(oldestTime, 'month') >= 0){
            // pushing every single month to the dataset
            labels.push(`${latestTime.format('MMMM').toString()}`);
            if (datasets.length < 1) datasets.push(data[0].value * 1.0);
            // Looping through the data
            for(let i = 0; i < data.length; i++)// checking if there is data for the latest date
            if ((0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(latestTime).diff((0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(data[i].request_time), 'month') === 0) {
                // checking if the latest date data exists in the dataset
                if (datasets.length < labels.length) datasets.push(data[i].value * 1.0);
                else if (datasets[datasets.length - 1] < data[i].value) datasets[datasets.length - 1] = data[i].value * 1.0;
            }
            // checking if the latest date data exists in the dataset
            if (datasets.length < labels.length) // using the last risk ratio as the risk ratio
            // of the month if it doesnt have one
            datasets.push(datasets[datasets.length - 1] * 1.0);
            latestTime = (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(latestTime).subtract(1, 'month');
        }
        return {
            datasets: datasets,
            labels: labels
        };
    }
    function formatRiskData(data) {
        if (data) {
            let datasets = [];
            let labels = [];
            const formattedData = [];
            data.forEach((item)=>{
                formattedData.push({
                    request_time: item.request_time,
                    value: item.risk_score
                });
            });
            const oldestTime = (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(data[data.length - 1].request_time);
            const latestTime = (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(data[0].request_time);
            const diff = (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(latestTime).diff(oldestTime, 'day');
            if (diff <= dayCap) {
                const newData = formatToDays(formattedData);
                datasets = invertData(newData.datasets);
                labels = invertData(newData.labels);
            } else if (diff <= weekCap && diff > dayCap) {
                const newData = formatToWeeks(formattedData);
                datasets = invertData(newData.datasets);
                labels = invertData(newData.labels);
            } else if (diff > weekCap) {
                const newData = formatToMonths(formattedData);
                datasets = invertData(newData.datasets);
                labels = invertData(newData.labels);
            }
            setRiskData({
                labels: labels,
                datasets: [
                    {
                        data: datasets,
                        fill: false,
                        borderColor: '#DCFE54',
                        pointColor: '#DCFE54',
                        fillColor: '#DCFE54',
                        tension: 0.1,
                        pointRadius: 5,
                        pointHoverRadius: 7
                    }
                ]
            });
            return formattedData;
        }
    }
    function formatFinancialData(data) {
        if (data) {
            let datasets = [];
            let labels = [];
            const formattedData = [];
            data.forEach((item)=>{
                formattedData.push({
                    request_time: item.request_time,
                    value: item.balance
                });
            });
            const oldestTime = (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(data[data.length - 1].request_time);
            const latestTime = (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(data[0].request_time);
            const diff = (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(latestTime).diff(oldestTime, 'day');
            if (diff <= dayCap) {
                const newData = formatToDays(formattedData);
                datasets = invertData(newData.datasets);
                labels = invertData(newData.labels);
            } else if (diff <= weekCap && diff > dayCap) {
                const newData = formatToWeeks(formattedData);
                datasets = invertData(newData.datasets);
                labels = invertData(newData.labels);
            } else if (diff > weekCap) {
                const newData = formatToMonths(formattedData);
                datasets = invertData(newData.datasets);
                labels = invertData(newData.labels);
            }
            setFinancialData({
                labels: labels,
                datasets: [
                    {
                        data: datasets,
                        fill: false,
                        borderColor: theme === 'light' ? '#26A3F5' : '#00CACD',
                        pointColor: theme === 'light' ? '#26A3F5' : '#00CACD',
                        fillColor: theme === 'light' ? '#26A3F5' : '#00CACD',
                        tension: 0.1,
                        pointRadius: 5,
                        pointHoverRadius: 7
                    }
                ]
            });
            return formattedData;
        }
    }
    const handleDateSelect = ({ start: start, end: end })=>{
        if (start !== start_range && end !== end_range) setAddressHistoryFilters({
            ...addressHistoryFilters,
            start_range: start,
            end_range: end
        });
        setActivePage(1);
    };
    const handleFilterReset = ()=>{
        setAddressHistoryFilters({
            ...addressHistoryFilters,
            start_range: (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))().subtract(30, 'days').format((0, $41a9e38e6be32f35$export$1bceb808939a9f0c)),
            end_range: (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))().format((0, $41a9e38e6be32f35$export$1bceb808939a9f0c))
        });
    };
    (0, $tZqWC.useEffect)(()=>{
        if (isAddressHistoryModalOpen && addressHistoryFilters?.address_id) getAddressHistory(addressHistoryFilters);
        if (isAddressHistoryModalOpen && !addressHistoryFilters?.address_id) setHistoryData();
    }, [
        isAddressHistoryModalOpen,
        addressHistoryFilters
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (getAddressHistoryData) {
            setTotalItems(getAddressHistoryData.pagination.total);
            setPageSize(getAddressHistoryData.pagination.size);
            const newHistoryData = formatHistoryData(getAddressHistoryData.items);
            setHistoryData(newHistoryData);
            formatRiskData(newHistoryData);
            formatFinancialData(newHistoryData);
        } else {
            setHistoryData();
            setTotalItems(0);
            setPageSize(0);
            setRiskData();
            setFinancialData();
        }
    }, [
        getAddressHistoryData
    ]);
    (0, $tZqWC.useEffect)(()=>{
        setAddressHistoryFilters({
            ...addressHistoryFilters,
            page: activePage
        });
    }, [
        activePage
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $0cb604e8ac00d438$export$2e2bcd8739ae039), {
        isOpen: isAddressHistoryModalOpen,
        toggle: toggleModal,
        style: {
            maxWidth: '1000px'
        },
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6e660ada3ebfb268$export$2e2bcd8739ae039), {
                toggle: toggleModal,
                close: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b77b5de3fb591045$export$2e2bcd8739ae039), {
                    size: 18
                }),
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $f962e544a1be9401$export$bc7adc8ef74607f), {
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $f962e544a1be9401$export$87ad169bde460ddf), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f962e544a1be9401$export$f99233281efd08a0), {
                                    children: "Wallet Address History"
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f962e544a1be9401$export$9ce5373cfda0847e), {
                                    style: {
                                        textTransform: 'uppercase'
                                    },
                                    children: addressHistoryFilters.address && addressHistoryFilters.address
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f962e544a1be9401$export$a9754b3c8daa5172), {
                            style: {
                                paddingRight: '30px',
                                alignItems: 'flex-end'
                            },
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1a3a6d4b17c02c87$export$2e2bcd8739ae039), {
                                onApply: handleDateSelect,
                                start: start_range,
                                end: end_range,
                                style: {
                                    minWidth: '300px'
                                }
                            }, start_range)
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5a83d1c72fcd9217$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $f962e544a1be9401$export$87ad169bde460ddf), {
                    children: [
                        !isGetAddressHistoryLoading && historyData && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $f962e544a1be9401$export$4e8a51dfb7785a56), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f962e544a1be9401$export$5f1af8db9871e1d6), {
                                    style: {
                                        textAlign: 'left'
                                    },
                                    children: "Wallet Address"
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f962e544a1be9401$export$5f1af8db9871e1d6), {
                                    style: {
                                        textAlign: 'left'
                                    },
                                    children: "Timestamp"
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f962e544a1be9401$export$5f1af8db9871e1d6), {
                                    style: {
                                        textAlign: 'right'
                                    },
                                    children: "Risk Score"
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f962e544a1be9401$export$5f1af8db9871e1d6), {
                                    style: {
                                        textAlign: 'right'
                                    },
                                    children: "Balance"
                                })
                            ]
                        }),
                        isGetAddressHistoryLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f962e544a1be9401$export$87ad169bde460ddf), {
                            style: {
                                alignItems: 'center'
                            },
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $647b8bc68ebce54f$export$2e2bcd8739ae039), {})
                        }),
                        !isGetAddressHistoryLoading && !historyData && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a6ea3b0f3caed586$export$2e2bcd8739ae039), {
                            setFilter: handleFilterReset
                        }),
                        !isGetAddressHistoryLoading && historyData && historyData.map((item)=>{
                            const chainIcon = (0, $df4784c9100a83b7$export$c25425c0b9a3de13)[item.chain];
                            return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $f962e544a1be9401$export$4e8a51dfb7785a56), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $f962e544a1be9401$export$a9754b3c8daa5172), {
                                        style: {
                                            justifyContent: 'flex-start'
                                        },
                                        children: [
                                            chainIcon && chainIcon,
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a6f961941b47e982$export$2e2bcd8739ae039), {
                                                text: item.address,
                                                sliceLength: 5
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f962e544a1be9401$export$5f1af8db9871e1d6), {
                                        children: (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(item.request_time).format((0, $41a9e38e6be32f35$export$859ef203c4495ed2))
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f962e544a1be9401$export$5f1af8db9871e1d6), {
                                        style: {
                                            textAlign: 'right'
                                        },
                                        children: item?.risk_score !== null && item?.risk_score !== undefined ? /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                                            children: [
                                                item.risk_score,
                                                " ",
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f962e544a1be9401$export$34028d8930504f65), {
                                                    children: "/ 100"
                                                })
                                            ]
                                        }) : '-'
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f962e544a1be9401$export$5f1af8db9871e1d6), {
                                        style: {
                                            fontWeight: '500',
                                            textAlign: 'right'
                                        },
                                        children: item?.balance !== null && item?.balance !== undefined ? `${(0, $ecf1d77ac1b82678$export$a2db1876938cd11d)(Math.round(item.balance * 100) / 100)} ${item?.symbol?.toUpperCase()}` : `- ${item?.symbol.toUpperCase()}`
                                    })
                                ]
                            }, item.request_time);
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b07759276f5d7f2d$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9deaec2f043c7dfd$export$2e2bcd8739ae039), {
                    itemsCountPerPage: pageSize,
                    totalItemsCount: totalItems,
                    page: activePage,
                    pageRangeDisplayed: 3,
                    onChange: ({ page: page, size: size })=>{
                        setActivePage(page);
                        setPageSize(size);
                    }
                })
            })
        ]
    });
}
// Default Props
$079dd66f383aa237$var$AddressHistoryModal.defaultProps = {
    ui: {},
    filters: {},
    address: {},
    actions: {}
};
// Proptypes Validation
$079dd66f383aa237$var$AddressHistoryModal.propTypes = {
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isAddressHistoryModalOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        addressHistoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            address: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            address_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            sort: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            page: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
            size: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
            start_range: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            end_range: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
        })
    }),
    address: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        addressHistoryDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({})
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        toggleAddressHistoryModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAddressHistoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $079dd66f383aa237$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($079dd66f383aa237$var$mapStateToProps, $079dd66f383aa237$var$mapDispatchToProps)($079dd66f383aa237$var$AddressHistoryModal);


var $f5b59232fc5c3635$export$2e2bcd8739ae039 = (0, $079dd66f383aa237$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");


var $ejSM7 = parcelRequire("ejSM7");




const $97861a65c3fc1f9c$export$e833dfe35f2086ee = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  font-size: 14.5px;
  font-weight: 400;
  width: 100%;
`;
const $97861a65c3fc1f9c$export$a9754b3c8daa5172 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 15px;
  border: 1px solid ${({ theme: theme })=>theme.colors.backgroundLite};
  border-radius: 10px;

  & div {
    flex: 1;
  }
`;
const $97861a65c3fc1f9c$export$4e8a51dfb7785a56 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
  padding: 10px 0;
  gap: 20px;
`;
const $97861a65c3fc1f9c$export$b04be29aa201d4f5 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-weight: 700;
  ${({ error: error, theme: theme })=>error && `color: ${theme.colors.red}`}
`;




// Map Redux Props
const $4da5ecdfc312752c$var$mapStateToProps = (state)=>state;
const $4da5ecdfc312752c$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $4da5ecdfc312752c$var$ReportAddressModal(props) {
    // Destructure
    const { ui: ui, address: address, actions: actions } = props;
    // Store Actions
    const { toggleAddressReportModal: toggleAddressReportModal, setAddressReportDetails: setAddressReportDetails } = actions;
    // Store State
    const { isAddressReportModalOpen: isAddressReportModalOpen } = ui;
    const { addressReportDetails: addressReportDetails } = address;
    // Hooks
    const { postAddressReport: postAddressReport, postAddressReportData: postAddressReportData, isPostAddressReportError: isPostAddressReportError, isPostAddressReportLoading: isPostAddressReportLoading } = (0, $df04c260c150084f$export$2e2bcd8739ae039)();
    const { getAddressHistory: getAddressHistory, getAddressHistoryData: getAddressHistoryData, isGetAddressHistoryLoading: isGetAddressHistoryLoading, isGetAddressHistoryError: isGetAddressHistoryError } = (0, $40ec4c0bc93edec7$export$2e2bcd8739ae039)();
    // Local State
    const [formValue, setFormValue] = (0, $tZqWC.useState)({
        sections: [],
        date_range: ''
    });
    const [isError, setIsError] = (0, $tZqWC.useState)(false);
    const [isSuccess, setIsSuccess] = (0, $tZqWC.useState)(false);
    const [totalAddresses, setTotalAddresses] = (0, $tZqWC.useState)(null);
    // Functions
    const toggleModal = ()=>{
        toggleAddressReportModal();
        setAddressReportDetails({});
    };
    const handleSubmit = ()=>{
        let start_range = (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))().subtract(30, 'days').format((0, $41a9e38e6be32f35$export$1bceb808939a9f0c));
        const end_range = (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))().add(1, 'days').format((0, $41a9e38e6be32f35$export$1bceb808939a9f0c));
        if ((0, $f398806f8c37b1c3$export$4b0b8bccc82aecb4)[0].value === formValue.date_range) start_range = (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))().subtract(30, 'days').format((0, $41a9e38e6be32f35$export$1bceb808939a9f0c));
        if ((0, $f398806f8c37b1c3$export$4b0b8bccc82aecb4)[1].value === formValue.date_range) start_range = (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))().subtract(180, 'days').format((0, $41a9e38e6be32f35$export$1bceb808939a9f0c));
        if ((0, $f398806f8c37b1c3$export$4b0b8bccc82aecb4)[2].value === formValue.date_range) start_range = (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))().subtract(365, 'days').format((0, $41a9e38e6be32f35$export$1bceb808939a9f0c));
        postAddressReport({
            address_id: addressReportDetails.address_id,
            sections: formValue.sections,
            start_range: start_range,
            end_range: end_range
        });
    };
    function handleValueChange() {
        if (!formValue?.date_range || !formValue?.sections) return;
        let start_range = (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))().subtract(30, 'days').format((0, $41a9e38e6be32f35$export$1bceb808939a9f0c));
        const end_range = (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))().add(1, 'days').format((0, $41a9e38e6be32f35$export$1bceb808939a9f0c));
        if ((0, $f398806f8c37b1c3$export$4b0b8bccc82aecb4)[0].value === formValue.date_range) start_range = (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))().subtract(30, 'days').format((0, $41a9e38e6be32f35$export$1bceb808939a9f0c));
        if ((0, $f398806f8c37b1c3$export$4b0b8bccc82aecb4)[1].value === formValue.date_range) start_range = (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))().subtract(180, 'days').format((0, $41a9e38e6be32f35$export$1bceb808939a9f0c));
        if ((0, $f398806f8c37b1c3$export$4b0b8bccc82aecb4)[2].value === formValue.date_range) start_range = (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))().subtract(365, 'days').format((0, $41a9e38e6be32f35$export$1bceb808939a9f0c));
        getAddressHistory({
            address_id: addressReportDetails.address_id,
            size: 10,
            page: 1,
            sort: '-last_modified',
            start_range: start_range,
            end_range: end_range
        });
    }
    function handleHistoryData() {
        if (getAddressHistoryData?.pagination) setTotalAddresses(getAddressHistoryData?.pagination?.total);
    }
    // UseEffects
    (0, $tZqWC.useEffect)(()=>{
        handleHistoryData();
    }, [
        getAddressHistoryData
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (isGetAddressHistoryError) setTotalAddresses(0);
    }, [
        isGetAddressHistoryError
    ]);
    (0, $tZqWC.useEffect)(()=>{
        handleValueChange();
    }, [
        formValue
    ]);
    (0, $tZqWC.useEffect)(()=>postAddressReportData && setIsSuccess(true), [
        postAddressReportData
    ]);
    (0, $tZqWC.useEffect)(()=>isPostAddressReportError && setIsError(true), [
        isPostAddressReportError
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (isAddressReportModalOpen) {
            setFormValue({
                sections: [],
                date_range: '',
                format: ''
            });
            setIsError(false);
            setIsSuccess(false);
            setTotalAddresses(null);
        }
    }, [
        isAddressReportModalOpen
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $0cb604e8ac00d438$export$2e2bcd8739ae039), {
        isOpen: isAddressReportModalOpen,
        toggle: toggleModal,
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6e660ada3ebfb268$export$2e2bcd8739ae039), {
                toggle: toggleModal,
                children: "REQUEST REPORT"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $5a83d1c72fcd9217$export$2e2bcd8739ae039), {
                children: [
                    isError && !isPostAddressReportLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $97861a65c3fc1f9c$export$e833dfe35f2086ee), {
                        style: {
                            display: 'flex',
                            justifyContent: 'center',
                            padding: 0
                        },
                        children: "An error occurred in generating a report. Please try again later."
                    }),
                    isSuccess && !isPostAddressReportLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $97861a65c3fc1f9c$export$e833dfe35f2086ee), {
                        style: {
                            display: 'flex',
                            justifyContent: 'center',
                            padding: 0
                        },
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("span", {
                            children: [
                                "Successfully requested for report, generating the report may take a few minutes. Please view the progress in the ",
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("a", {
                                    href: "/reports",
                                    children: "reports tab"
                                }),
                                "."
                            ]
                        })
                    }),
                    isPostAddressReportLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $97861a65c3fc1f9c$export$e833dfe35f2086ee), {
                        style: {
                            display: 'flex',
                            justifyContent: 'center',
                            padding: 0
                        },
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $647b8bc68ebce54f$export$2e2bcd8739ae039), {
                            style: {
                                padding: '45px 0'
                            }
                        })
                    }),
                    !isPostAddressReportLoading && !isError && !isSuccess && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $97861a65c3fc1f9c$export$e833dfe35f2086ee), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $97861a65c3fc1f9c$export$a9754b3c8daa5172), {
                                style: {
                                    justifyContent: 'flex-start',
                                    gap: '25px'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d05da0d1610c883b$export$2e2bcd8739ae039), {
                                        value: formValue.sections,
                                        onChange: (value)=>setFormValue({
                                                ...formValue,
                                                sections: value
                                            }),
                                        label: "DATA TYPE",
                                        options: (0, $f398806f8c37b1c3$export$8b2bc8759ae1fa3a),
                                        name: "sections"
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b6cab7af1259ed03$export$2e2bcd8739ae039), {
                                        value: formValue.date_range,
                                        onChange: (value)=>setFormValue({
                                                ...formValue,
                                                date_range: value
                                            }),
                                        label: "DATA RANGE",
                                        options: (0, $f398806f8c37b1c3$export$4b0b8bccc82aecb4),
                                        name: "date_range"
                                    })
                                ]
                            }),
                            totalAddresses !== null && !isGetAddressHistoryLoading && totalAddresses > 0 && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $97861a65c3fc1f9c$export$a9754b3c8daa5172), {
                                style: {
                                    justifyContent: 'flex-start',
                                    gap: '50px'
                                },
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $97861a65c3fc1f9c$export$b04be29aa201d4f5), {
                                    children: [
                                        "Total Number of Records: ",
                                        totalAddresses
                                    ]
                                })
                            }),
                            totalAddresses < 1 && totalAddresses !== null && !isGetAddressHistoryLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $97861a65c3fc1f9c$export$a9754b3c8daa5172), {
                                style: {
                                    justifyContent: 'flex-start',
                                    gap: '50px'
                                },
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $97861a65c3fc1f9c$export$b04be29aa201d4f5), {
                                    error: true,
                                    children: "Given Date Range Does Not Have Any Record"
                                })
                            }),
                            isGetAddressHistoryLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $97861a65c3fc1f9c$export$a9754b3c8daa5172), {
                                style: {
                                    justifyContent: 'flex-start',
                                    gap: '50px'
                                },
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $97861a65c3fc1f9c$export$b04be29aa201d4f5), {
                                    children: "Fetching Total Number of Addresses"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b07759276f5d7f2d$export$2e2bcd8739ae039), {
                children: !isPostAddressReportLoading && !isError && !isSuccess && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                            fullWidth: true,
                            type: "button",
                            variant: "outlined",
                            onClick: toggleModal,
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                            fullWidth: true,
                            type: "button",
                            onClick: handleSubmit,
                            disabled: !totalAddresses || totalAddresses < 1 || formValue.sections.length < 1 || !formValue.date_range,
                            children: "Request"
                        })
                    ]
                })
            })
        ]
    });
}
// Default Props
$4da5ecdfc312752c$var$ReportAddressModal.defaultProps = {
    ui: {},
    address: {},
    actions: {}
};
// Proptypes Validation
$4da5ecdfc312752c$var$ReportAddressModal.propTypes = {
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isAddressReportModalOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    address: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        addressReportDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            address_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            address: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            chain: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
        })
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        toggleAddressReportModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAddressReportDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $4da5ecdfc312752c$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($4da5ecdfc312752c$var$mapStateToProps, $4da5ecdfc312752c$var$mapDispatchToProps)($4da5ecdfc312752c$var$ReportAddressModal);


var $9da9c61b29795f47$export$2e2bcd8739ae039 = (0, $4da5ecdfc312752c$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");



const $a6d952f7c334b74f$export$47042699470e17dd = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-end;
`;
const $a6d952f7c334b74f$export$e833dfe35f2086ee = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 14.5px;
  font-weight: 400;
  padding: 0px 0px 20px 0px;
`;
const $a6d952f7c334b74f$export$7316ba21c2af33a0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  margin: 0px 0px 0px 10px;
`;



// Map Redux Props
const $70add15d51d271fb$var$mapStateToProps = (state)=>state;
const $70add15d51d271fb$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $70add15d51d271fb$var$DeleteAddressNoteModal(props) {
    // Destructure
    const { ui: ui, actions: actions } = props;
    // Store State
    const { isDeleteAddressNoteModalOpen: isDeleteAddressNoteModalOpen } = ui;
    // Store Actions
    const { toggleDeleteAddressNoteModal: toggleDeleteAddressNoteModal } = actions;
    // Functions
    const toggleModal = ()=>{
        toggleDeleteAddressNoteModal();
    };
    const handleDelete = ()=>{};
    // UseEffect
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $0cb604e8ac00d438$export$2e2bcd8739ae039), {
        isOpen: isDeleteAddressNoteModalOpen,
        toggle: toggleModal,
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6e660ada3ebfb268$export$2e2bcd8739ae039), {
                toggle: toggleModal,
                children: "Delete note"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5a83d1c72fcd9217$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a6d952f7c334b74f$export$e833dfe35f2086ee), {
                    children: "Are you sure you want to delete this note? This action is irreversible."
                })
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b07759276f5d7f2d$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $a6d952f7c334b74f$export$47042699470e17dd), {
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a6d952f7c334b74f$export$7316ba21c2af33a0), {
                            onClick: handleDelete,
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                color: "secondary",
                                children: "Delete"
                            })
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a6d952f7c334b74f$export$7316ba21c2af33a0), {
                            onClick: toggleModal,
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                color: "default",
                                children: "Cancel"
                            })
                        })
                    ]
                })
            })
        ]
    });
}
// Default Props
$70add15d51d271fb$var$DeleteAddressNoteModal.defaultProps = {
    ui: {},
    form: {},
    actions: {}
};
// Proptypes Validation
$70add15d51d271fb$var$DeleteAddressNoteModal.propTypes = {
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isDeleteAddressNoteModalOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    form: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        activityToRemove: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            hash: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
        })
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        toggleDeleteAddressNoteModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setActivityToRemove: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $70add15d51d271fb$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($70add15d51d271fb$var$mapStateToProps, $70add15d51d271fb$var$mapDispatchToProps)($70add15d51d271fb$var$DeleteAddressNoteModal);


var $9486cd6f5d724c09$export$2e2bcd8739ae039 = (0, $70add15d51d271fb$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");




const $2d8686091caa805e$export$47042699470e17dd = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-end;
`;
const $2d8686091caa805e$export$e833dfe35f2086ee = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  font-size: 14.5px;
  font-weight: 400;
  padding: 0px 0px 20px 0px;
`;
const $2d8686091caa805e$export$7316ba21c2af33a0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  margin: 0px 0px 0px 10px;
`;
const $2d8686091caa805e$export$a9754b3c8daa5172 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
`;
const $2d8686091caa805e$export$4e8a51dfb7785a56 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  padding: 10px 0;
  gap: 20px;
`;




// Map Redux Props
const $fedf230a4ae28b12$var$mapStateToProps = (state)=>state;
const $fedf230a4ae28b12$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $fedf230a4ae28b12$var$ReportTransactionModal(props) {
    // Destructure
    const { ui: ui, transaction: transaction, actions: actions } = props;
    // Store Actions
    const { toggleTransactionReportModal: toggleTransactionReportModal, setTransactionReportDetails: setTransactionReportDetails } = actions;
    // Store State
    const { isTransactionReportModalOpen: isTransactionReportModalOpen } = ui;
    const { transactionReportDetails: transactionReportDetails } = transaction;
    // Hooks
    const { postTransactionReport: postTransactionReport, postTransactionReportData: postTransactionReportData, isPostTransactionReportError: isPostTransactionReportError, isPostTransactionReportLoading: isPostTransactionReportLoading } = (0, $a3bb46046c50a087$export$2e2bcd8739ae039)();
    // Local State
    const [formValue, setFormValue] = (0, $tZqWC.useState)({
        sections: []
    });
    const [isError, setIsError] = (0, $tZqWC.useState)(false);
    const [isSuccess, setIsSuccess] = (0, $tZqWC.useState)(false);
    // Functions
    const toggleModal = ()=>{
        toggleTransactionReportModal();
        setTransactionReportDetails({});
    };
    const handleSubmit = ()=>{
        // let start_range = moment().subtract(30, 'days').format(DASHED_DATE_FORMAT)
        // const end_range = moment().add(1, 'days').format(DASHED_DATE_FORMAT)
        // if (REPORT_DATE_RANGE_OPTIONS[0].value === formValue.date_range) {
        //   start_range = moment().subtract(30, 'days').format(DASHED_DATE_FORMAT)
        // }
        // if (REPORT_DATE_RANGE_OPTIONS[1].value === formValue.date_range) {
        //   start_range = moment().subtract(180, 'days').format(DASHED_DATE_FORMAT)
        // }
        // if (REPORT_DATE_RANGE_OPTIONS[2].value === formValue.date_range) {
        //   start_range = moment().subtract(365, 'days').format(DASHED_DATE_FORMAT)
        // }
        postTransactionReport({
            transaction_id: transactionReportDetails.transaction_id,
            sections: formValue.sections
        });
    };
    // UseEffects
    (0, $tZqWC.useEffect)(()=>postTransactionReportData && setIsSuccess(true), [
        postTransactionReportData
    ]);
    (0, $tZqWC.useEffect)(()=>isPostTransactionReportError && setIsError(true), [
        isPostTransactionReportError
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (isTransactionReportModalOpen) {
            setFormValue({
                sections: [],
                format: ''
            });
            setIsError(false);
            setIsSuccess(false);
        }
    }, [
        isTransactionReportModalOpen
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $0cb604e8ac00d438$export$2e2bcd8739ae039), {
        isOpen: isTransactionReportModalOpen,
        toggle: toggleModal,
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6e660ada3ebfb268$export$2e2bcd8739ae039), {
                toggle: toggleModal,
                children: "REQUEST REPORT"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $5a83d1c72fcd9217$export$2e2bcd8739ae039), {
                children: [
                    isError && !isPostTransactionReportLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2d8686091caa805e$export$e833dfe35f2086ee), {
                        style: {
                            display: 'flex',
                            justifyContent: 'center',
                            padding: 0
                        },
                        children: "An error occurred in generating a report. Please try again later."
                    }),
                    isSuccess && !isPostTransactionReportLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2d8686091caa805e$export$e833dfe35f2086ee), {
                        style: {
                            display: 'flex',
                            justifyContent: 'center',
                            padding: 0
                        },
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("span", {
                            children: [
                                "Successfully requested for report, generating the report may take a few minutes. Please view the progress in the ",
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("a", {
                                    href: "/reports/transaction",
                                    children: "reports tab"
                                }),
                                "."
                            ]
                        })
                    }),
                    isPostTransactionReportLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2d8686091caa805e$export$e833dfe35f2086ee), {
                        style: {
                            display: 'flex',
                            justifyContent: 'center',
                            padding: 0
                        },
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $647b8bc68ebce54f$export$2e2bcd8739ae039), {
                            style: {
                                padding: '45px 0'
                            }
                        })
                    }),
                    !isPostTransactionReportLoading && !isError && !isSuccess && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2d8686091caa805e$export$e833dfe35f2086ee), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2d8686091caa805e$export$a9754b3c8daa5172), {
                            style: {
                                justifyContent: 'flex-start',
                                gap: '50px'
                            },
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d05da0d1610c883b$export$2e2bcd8739ae039), {
                                value: formValue.sections,
                                onChange: (value)=>setFormValue({
                                        ...formValue,
                                        sections: value
                                    }),
                                label: "DATA TYPE",
                                options: (0, $f398806f8c37b1c3$export$22efbd5ad1f2c0ec),
                                name: "sections"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b07759276f5d7f2d$export$2e2bcd8739ae039), {
                children: !isPostTransactionReportLoading && !isError && !isSuccess && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $2d8686091caa805e$export$47042699470e17dd), {
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2d8686091caa805e$export$7316ba21c2af33a0), {
                            onClick: toggleModal,
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                variant: "outlined",
                                children: "Cancel"
                            })
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2d8686091caa805e$export$7316ba21c2af33a0), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                onClick: handleSubmit,
                                variant: "outlined",
                                disabled: formValue.sections.length < 1,
                                children: "Request"
                            })
                        })
                    ]
                })
            })
        ]
    });
}
// Default Props
$fedf230a4ae28b12$var$ReportTransactionModal.defaultProps = {
    ui: {},
    transaction: {},
    actions: {}
};
// Proptypes Validation
$fedf230a4ae28b12$var$ReportTransactionModal.propTypes = {
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isTransactionReportModalOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    transaction: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        transactionReportDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            transaction_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            transaction: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            chain: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
        })
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        toggleTransactionReportModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setTransactionReportDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $fedf230a4ae28b12$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($fedf230a4ae28b12$var$mapStateToProps, $fedf230a4ae28b12$var$mapDispatchToProps)($fedf230a4ae28b12$var$ReportTransactionModal);


var $8f1528e0bd56ff87$export$2e2bcd8739ae039 = (0, $fedf230a4ae28b12$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");


var $ejSM7 = parcelRequire("ejSM7");



const $7967bad0b9cc1346$export$e833dfe35f2086ee = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  font-size: 15px;
  font-weight: 400;
  padding: 20px;
  max-width: 400px;
`;
const $7967bad0b9cc1346$export$a9754b3c8daa5172 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
`;



// constants
// import { REPORT_DATA_TYPE_OPTIONS } from 'common/constants/formOptions'
// Map Redux Props
const $d1477db2ce682fa9$var$mapStateToProps = (state)=>state;
const $d1477db2ce682fa9$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $d1477db2ce682fa9$var$ReportTransferModal(props) {
    // Destructure
    const { ui: ui, actions: actions } = props;
    // Store Actions
    const { toggleTransferReportModal: toggleTransferReportModal } = actions;
    // Store State
    const { isTransferReportModalOpen: isTransferReportModalOpen } = ui;
    // Hooks
    const { createTransferReport: createTransferReport, transferReportCreateData: transferReportCreateData, isTransferReportCreateError: isTransferReportCreateError, isTransferReportCreateLoading: isTransferReportCreateLoading } = (0, $cf559f1f25c4f1b3$export$2e2bcd8739ae039)();
    // Local State
    const [formValue, setFormValue] = (0, $tZqWC.useState)({
        start_range: (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))().subtract(30, 'days'),
        end_range: (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))().add(1, 'days')
    });
    const [isError, setIsError] = (0, $tZqWC.useState)(false);
    const [isSuccess, setIsSuccess] = (0, $tZqWC.useState)(false);
    // Functions
    const handleDateSelect = async ({ start: start, end: end })=>{
        setFormValue({
            start_range: start,
            end_range: end
        });
    };
    const toggleModal = ()=>{
        toggleTransferReportModal();
    };
    const handleSubmit = ()=>{
        createTransferReport(formValue);
    };
    // UseEffects
    (0, $tZqWC.useEffect)(()=>transferReportCreateData && setIsSuccess(true), [
        transferReportCreateData
    ]);
    (0, $tZqWC.useEffect)(()=>isTransferReportCreateError && setIsError(true), [
        isTransferReportCreateError
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (isTransferReportModalOpen) {
            setFormValue({
                start_range: (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))().subtract(30, 'days'),
                end_range: (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))().add(1, 'days')
            });
            setIsError(false);
            setIsSuccess(false);
        }
    }, [
        isTransferReportModalOpen
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $0cb604e8ac00d438$export$2e2bcd8739ae039), {
        isOpen: isTransferReportModalOpen,
        toggle: toggleModal,
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6e660ada3ebfb268$export$2e2bcd8739ae039), {
                toggle: toggleModal,
                children: "REQUEST REPORT"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $5a83d1c72fcd9217$export$2e2bcd8739ae039), {
                style: {
                    maxHeight: 'none',
                    overflow: 'visible'
                },
                children: [
                    isError && !isTransferReportCreateLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7967bad0b9cc1346$export$e833dfe35f2086ee), {
                        style: {
                            display: 'flex',
                            justifyContent: 'center',
                            padding: 0
                        },
                        children: "An error occurred in generating a report. Please try again later."
                    }),
                    isSuccess && !isTransferReportCreateLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7967bad0b9cc1346$export$e833dfe35f2086ee), {
                        style: {
                            display: 'flex',
                            justifyContent: 'center',
                            padding: 0
                        },
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)("span", {
                            children: [
                                "Successfully requested for report, generating the report may take a few minutes. Please view the progress in the ",
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("a", {
                                    href: "/reports",
                                    children: "reports tab"
                                }),
                                "."
                            ]
                        })
                    }),
                    isTransferReportCreateLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7967bad0b9cc1346$export$e833dfe35f2086ee), {
                        style: {
                            display: 'flex',
                            justifyContent: 'center',
                            padding: 0
                        },
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $647b8bc68ebce54f$export$2e2bcd8739ae039), {
                            style: {
                                padding: '45px 0'
                            }
                        })
                    }),
                    !isTransferReportCreateLoading && !isError && !isSuccess && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7967bad0b9cc1346$export$e833dfe35f2086ee), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7967bad0b9cc1346$export$a9754b3c8daa5172), {
                            style: {
                                justifyContent: 'center'
                            },
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1a3a6d4b17c02c87$export$2e2bcd8739ae039), {
                                onApply: handleDateSelect,
                                start: formValue?.start_range,
                                end: formValue?.end_range,
                                style: {
                                    minWidth: '270px'
                                }
                            }, formValue?.start_range)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b07759276f5d7f2d$export$2e2bcd8739ae039), {
                children: !isTransferReportCreateLoading && !isError && !isSuccess && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                            fullWidth: true,
                            type: "button",
                            onClick: toggleModal,
                            variant: "outlined",
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                            fullWidth: true,
                            type: "button",
                            onClick: handleSubmit,
                            disabled: !formValue?.start_range || !formValue?.end_range,
                            children: "Request"
                        })
                    ]
                })
            })
        ]
    });
}
// Default Props
$d1477db2ce682fa9$var$ReportTransferModal.defaultProps = {
    ui: {},
    address: {},
    actions: {}
};
// Proptypes Validation
$d1477db2ce682fa9$var$ReportTransferModal.propTypes = {
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isTransferReportModalOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    address: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        addressReportDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            address_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            address: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            chain: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
        })
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        toggleTransferReportModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setTransferReportDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $d1477db2ce682fa9$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($d1477db2ce682fa9$var$mapStateToProps, $d1477db2ce682fa9$var$mapDispatchToProps)($d1477db2ce682fa9$var$ReportTransferModal);


var $36092b4a99a9312b$export$2e2bcd8739ae039 = (0, $d1477db2ce682fa9$export$2e2bcd8739ae039);


/* eslint-disable jsx-a11y/anchor-is-valid */ /* eslint-disable react/prop-types */ 
parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");



const $a133af7732822401$export$47042699470e17dd = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-end;
`;
const $a133af7732822401$export$e833dfe35f2086ee = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 14.5px;
  font-weight: 400;
  padding: 10px 0px;
  max-width: 400px;
`;
const $a133af7732822401$export$7316ba21c2af33a0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  margin: 0px 0px 0px 10px;
`;
const $a133af7732822401$export$a6c7ac8248d6e38a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).a`
  color: ${({ theme: theme })=>theme.colors.brand};
`;



// Map Redux Props
const $22b577d321ab4152$var$mapStateToProps = (state)=>state;
const $22b577d321ab4152$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $22b577d321ab4152$var$InfoModal(props) {
    // Destructure
    const { ui: ui, actions: actions } = props;
    // Store State
    const { isInfoModalOpen: isInfoModalOpen, infoModalDetails: infoModalDetails } = ui;
    const { title: title, content: content, loading: loading } = infoModalDetails;
    // Store Actions
    const { toggleInfoModal: toggleInfoModal, setInfoModalDetails: setInfoModalDetails } = actions;
    // Functions
    const toggleModal = ()=>{
        setInfoModalDetails({
            title: '',
            content: '',
            loading: false
        });
        toggleInfoModal();
    };
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $0cb604e8ac00d438$export$2e2bcd8739ae039), {
        isOpen: isInfoModalOpen,
        toggle: !loading && toggleModal,
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6e660ada3ebfb268$export$2e2bcd8739ae039), {
                toggle: toggleModal,
                children: title
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $5a83d1c72fcd9217$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a133af7732822401$export$e833dfe35f2086ee), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)($22b577d321ab4152$var$LinkText, {
                            content: content
                        })
                    }),
                    loading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $647b8bc68ebce54f$export$2e2bcd8739ae039), {})
                ]
            })
        ]
    });
}
function $22b577d321ab4152$var$LinkText(props) {
    const { content: content } = props;
    const convertText = ()=>{
        const parts = content?.split('|');
        return parts?.map((item, idx)=>{
            const uniqueKey = `${item.substr(0, 10)}-${idx}`;
            if (!item?.includes('>')) return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("span", {
                children: item
            }, uniqueKey);
            if (item?.split('>')?.length > 1) {
                const linkData = item?.split('>');
                return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a133af7732822401$export$a6c7ac8248d6e38a), {
                    onClick: ()=>{
                        window.open(linkData[1], '_blank');
                    },
                    children: linkData[0]
                }, uniqueKey);
            }
            return null // Return null for items that don't match conditions
            ;
        });
    };
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("div", {
        children: convertText()
    });
}
// Default Props
$22b577d321ab4152$var$InfoModal.defaultProps = {
    ui: {},
    form: {},
    actions: {}
};
// Proptypes Validation
$22b577d321ab4152$var$InfoModal.propTypes = {
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isInfoModalOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
        infoModalDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            title: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            content: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            loading: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
        })
    }),
    form: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        activityToRemove: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            hash: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
        })
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        toggleInfoModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setInfoModalDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $22b577d321ab4152$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($22b577d321ab4152$var$mapStateToProps, $22b577d321ab4152$var$mapDispatchToProps)($22b577d321ab4152$var$InfoModal);


var $214523f7703887b7$export$2e2bcd8739ae039 = (0, $22b577d321ab4152$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");



const $f2b5bd3508bba9e3$export$47042699470e17dd = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-end;
`;
const $f2b5bd3508bba9e3$export$e833dfe35f2086ee = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 14.5px;
  font-weight: 400;
  padding: 12px 0;
`;
const $f2b5bd3508bba9e3$export$7316ba21c2af33a0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  margin: 0px 0px 0px 10px;
`;




// Map Redux Props
const $bcb9bcf364ad4bd5$var$mapStateToProps = (state)=>state;
const $bcb9bcf364ad4bd5$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $bcb9bcf364ad4bd5$var$ApproveVaspModal(props) {
    // Destructure
    const { ui: ui, actions: actions } = props;
    // Store State
    const { isApproveVaspModalOpen: isApproveVaspModalOpen, approveVaspDetails: approveVaspDetails } = ui;
    // Store Actions
    const { setApproveVaspModal: setApproveVaspModal, showAlert: showAlert, setIsPageTableUpdated: setIsPageTableUpdated } = actions;
    // Hooks
    const { approveVasp: approveVasp, approveVaspData: approveVaspData, isApproveVaspLoading: isApproveVaspLoading, isApproveVaspError: isApproveVaspError, isApproveVaspSuccess: isApproveVaspSuccess } = (0, $793140d42d08c801$export$2e2bcd8739ae039)();
    // Functions
    const toggleModal = ()=>{
        setApproveVaspModal();
    };
    const handleNotify = ()=>{
        approveVasp({
            vasp_id: approveVaspDetails.vasp_id
        });
    };
    // UseEffect
    (0, $tZqWC.useEffect)(()=>{
        if (approveVaspData && !isApproveVaspError) {
            showAlert({
                type: 'success',
                message: 'Successfully approved VASP'
            });
            toggleModal();
            setIsPageTableUpdated(true);
        }
    }, [
        approveVaspData
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (isApproveVaspError) {
            showAlert({
                type: 'error',
                message: 'An error occurred in approving VASP'
            });
            toggleModal();
        }
    }, [
        isApproveVaspError
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $0cb604e8ac00d438$export$2e2bcd8739ae039), {
        isOpen: isApproveVaspModalOpen,
        toggle: toggleModal,
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6e660ada3ebfb268$export$2e2bcd8739ae039), {
                toggle: toggleModal,
                children: "Notify Vasp"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $5a83d1c72fcd9217$export$2e2bcd8739ae039), {
                children: [
                    isApproveVaspLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f2b5bd3508bba9e3$export$e833dfe35f2086ee), {
                        children: "Approving..."
                    }),
                    approveVaspDetails?.vasp_id && !isApproveVaspLoading && !isApproveVaspError && !isApproveVaspSuccess && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $f2b5bd3508bba9e3$export$e833dfe35f2086ee), {
                        children: [
                            "Are you sure you want to approve this VASP: ",
                            approveVaspDetails.vasp_name,
                            "?"
                        ]
                    }),
                    !isApproveVaspLoading && isApproveVaspError && !isApproveVaspSuccess && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f2b5bd3508bba9e3$export$e833dfe35f2086ee), {
                        children: "An error occurred in approving VASP, please try again later."
                    }),
                    !isApproveVaspLoading && isApproveVaspSuccess && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f2b5bd3508bba9e3$export$e833dfe35f2086ee), {
                        children: "Congratulations! VASP has been approved"
                    })
                ]
            }),
            !isApproveVaspError && !isApproveVaspSuccess && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b07759276f5d7f2d$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $f2b5bd3508bba9e3$export$47042699470e17dd), {
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f2b5bd3508bba9e3$export$7316ba21c2af33a0), {
                            onClick: toggleModal,
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                color: "secondary",
                                disabled: isApproveVaspLoading,
                                children: "Cancel"
                            })
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f2b5bd3508bba9e3$export$7316ba21c2af33a0), {
                            onClick: handleNotify,
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                color: "default",
                                disabled: isApproveVaspLoading,
                                children: "Approve"
                            })
                        })
                    ]
                })
            })
        ]
    });
}
// Default Props
$bcb9bcf364ad4bd5$var$ApproveVaspModal.defaultProps = {
    ui: {},
    form: {},
    actions: {}
};
// Proptypes Validation
$bcb9bcf364ad4bd5$var$ApproveVaspModal.propTypes = {
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isApproveVaspModalOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
        approveVaspDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            vasp_name: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            vasp_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
        })
    }),
    form: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        activityToRemove: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            hash: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
        })
    }),
    address: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        addressRemove: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            address_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
        })
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setApproveVaspModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAddressRemove: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $bcb9bcf364ad4bd5$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($bcb9bcf364ad4bd5$var$mapStateToProps, $bcb9bcf364ad4bd5$var$mapDispatchToProps)($bcb9bcf364ad4bd5$var$ApproveVaspModal);


var $ec8159c76f8fc419$export$2e2bcd8739ae039 = (0, $bcb9bcf364ad4bd5$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");



const $12250f5521e3a37e$export$e833dfe35f2086ee = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 14.5px;
  font-weight: 400;
  padding: 12px 0;
  max-width: 400px;
`;




// Map Redux Props
const $f77e36f8ab330460$var$mapStateToProps = (state)=>state;
const $f77e36f8ab330460$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $f77e36f8ab330460$var$RejectVaspModal(props) {
    // Destructure
    const { ui: ui, actions: actions } = props;
    // Store State
    const { isRejectVaspModalOpen: isRejectVaspModalOpen, rejectVaspDetails: rejectVaspDetails } = ui;
    // Store Actions
    const { setRejectVaspModal: setRejectVaspModal, showAlert: showAlert, setRejectVaspDetails: setRejectVaspDetails } = actions;
    // Hooks
    const { rejectVasp: rejectVasp, rejectVaspData: rejectVaspData, isRejectVaspLoading: isRejectVaspLoading, isRejectVaspError: isRejectVaspError, isRejectVaspSuccess: isRejectVaspSuccess } = (0, $8c0350c33d943d3c$export$2e2bcd8739ae039)();
    // Functions
    const toggleModal = ()=>{
        setRejectVaspModal();
    };
    const handleReject = ()=>{
        rejectVasp({
            vasp_id: rejectVaspDetails.vasp_id
        });
    };
    // UseEffect
    (0, $tZqWC.useEffect)(()=>{
        if (rejectVaspData && isRejectVaspSuccess) {
            showAlert({
                type: 'success',
                message: 'Successfully rejected VASP'
            });
            toggleModal();
            setRejectVaspDetails({
                ...rejectVaspDetails,
                customer_status_id: -1
            });
        }
    }, [
        rejectVaspData
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (isRejectVaspError) {
            showAlert({
                type: 'error',
                message: 'An error occurred in rejecting VASP'
            });
            toggleModal();
        }
    }, [
        isRejectVaspError
    ]);
    (0, $tZqWC.useEffect)(()=>{}, []);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $0cb604e8ac00d438$export$2e2bcd8739ae039), {
        isOpen: isRejectVaspModalOpen,
        toggle: toggleModal,
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6e660ada3ebfb268$export$2e2bcd8739ae039), {
                toggle: toggleModal,
                children: "Reject Vasp"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $5a83d1c72fcd9217$export$2e2bcd8739ae039), {
                children: [
                    isRejectVaspLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $12250f5521e3a37e$export$e833dfe35f2086ee), {
                        children: "Rejecting..."
                    }),
                    rejectVaspDetails?.vasp_id && !isRejectVaspLoading && !isRejectVaspError && !isRejectVaspSuccess && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $12250f5521e3a37e$export$e833dfe35f2086ee), {
                        children: [
                            "Are you sure you want to reject this vasp: ",
                            rejectVaspDetails.vasp_name,
                            "?"
                        ]
                    }),
                    !isRejectVaspLoading && !isRejectVaspSuccess && isRejectVaspError && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $12250f5521e3a37e$export$e833dfe35f2086ee), {
                        children: "An error occurred in rejecting vasp, please try again later."
                    }),
                    !isRejectVaspLoading && isRejectVaspSuccess && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $12250f5521e3a37e$export$e833dfe35f2086ee), {
                        children: "Vasp has been rejected."
                    })
                ]
            }),
            !isRejectVaspSuccess && !isRejectVaspError && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $b07759276f5d7f2d$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                        fullWidth: true,
                        type: "button",
                        onClick: toggleModal,
                        disabled: isRejectVaspLoading,
                        variant: "outlined",
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                        fullWidth: true,
                        type: "button",
                        onClick: handleReject,
                        disabled: isRejectVaspLoading,
                        color: "default",
                        children: "Reject"
                    })
                ]
            })
        ]
    });
}
// Default Props
$f77e36f8ab330460$var$RejectVaspModal.defaultProps = {
    ui: {},
    form: {},
    actions: {}
};
// Proptypes Validation
$f77e36f8ab330460$var$RejectVaspModal.propTypes = {
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isRejectVaspModalOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
        rejectVaspDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            vasp_name: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            vasp_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
        })
    }),
    form: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        activityToRemove: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            hash: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
        })
    }),
    address: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        addressRemove: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            address_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
        })
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setRejectVaspModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAddressRemove: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setRejectVaspDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $f77e36f8ab330460$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($f77e36f8ab330460$var$mapStateToProps, $f77e36f8ab330460$var$mapDispatchToProps)($f77e36f8ab330460$var$RejectVaspModal);


var $6368f279d4295f50$export$2e2bcd8739ae039 = (0, $f77e36f8ab330460$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");



const $12bf1e20f0366f42$export$e833dfe35f2086ee = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 15px;
  font-weight: 400;
  padding: 20px;
`;



// Map Redux Props
const $9a2e7417957e891d$var$mapStateToProps = (state)=>state;
const $9a2e7417957e891d$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $9a2e7417957e891d$var$UpdateTransferModal(props) {
    // Destructure
    const { ui: ui, actions: actions } = props;
    // Store State
    const { isUpdateTransferModalOpen: isUpdateTransferModalOpen, updateTransferModalData: updateTransferModalData } = ui;
    // Store Actions
    const { toggleUpdateTransferModal: toggleUpdateTransferModal, setUpdateTransferModalStatus: setUpdateTransferModalStatus, setUpdateTransferModalData: setUpdateTransferModalData } = actions;
    // Functions
    const cancel = ()=>{
        toggleUpdateTransferModal();
        setUpdateTransferModalStatus();
        setUpdateTransferModalData();
    };
    const handleConfirm = ()=>{
        setUpdateTransferModalStatus({
            confirmed: true
        });
        toggleUpdateTransferModal();
    };
    // UseEffect
    (0, $tZqWC.useEffect)(()=>{}, []);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $0cb604e8ac00d438$export$2e2bcd8739ae039), {
        isOpen: isUpdateTransferModalOpen,
        toggle: cancel,
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6e660ada3ebfb268$export$2e2bcd8739ae039), {
                toggle: cancel,
                children: updateTransferModalData?.title
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5a83d1c72fcd9217$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $12bf1e20f0366f42$export$e833dfe35f2086ee), {
                    children: updateTransferModalData?.content
                })
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $b07759276f5d7f2d$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                        fullWidth: true,
                        onClick: cancel,
                        type: "button",
                        variant: "outlined",
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                        fullWidth: true,
                        onClick: handleConfirm,
                        type: "button",
                        color: "secondary",
                        children: "Confirm"
                    })
                ]
            })
        ]
    });
}
// Default Props
$9a2e7417957e891d$var$UpdateTransferModal.defaultProps = {
    ui: {},
    form: {},
    actions: {}
};
// Proptypes Validation
$9a2e7417957e891d$var$UpdateTransferModal.propTypes = {
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isUpdateTransferModalOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
        updateTransferModalStatus: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            confirmed: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
        }),
        updateTransferModalData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            title: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            content: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
        })
    }),
    form: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        activityToRemove: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            hash: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
        })
    }),
    address: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        addressRemove: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            address_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
        })
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        toggleUpdateTransferModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setUpdateTransferModalStatus: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setUpdateTransferModalData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $9a2e7417957e891d$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($9a2e7417957e891d$var$mapStateToProps, $9a2e7417957e891d$var$mapDispatchToProps)($9a2e7417957e891d$var$UpdateTransferModal);


var $a1ac23dc25f8fd23$export$2e2bcd8739ae039 = (0, $9a2e7417957e891d$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");



const $d823d76b58a2c211$export$e833dfe35f2086ee = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 15px;
  font-weight: 400;
  padding: 20px;
  max-width: 400px;
`;




// Map Redux Props
const $1700cc15bb86a0c4$var$mapStateToProps = (state)=>state;
const $1700cc15bb86a0c4$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $1700cc15bb86a0c4$var$DeleteTransactionModal(props) {
    // Destructure
    const { ui: ui, actions: actions, transaction: transaction } = props;
    // Store State
    const { isDeleteTransactionModalOpen: isDeleteTransactionModalOpen } = ui;
    const { transactionRemove: transactionRemove } = transaction;
    // Store Actions
    const { toggleDeleteTransactionModal: toggleDeleteTransactionModal, setIsPageTableUpdated: setIsPageTableUpdated, setTransactionRemove: setTransactionRemove } = actions;
    // Hooks
    const { deleteTransaction: deleteTransaction, deleteTransactionData: deleteTransactionData, deleteTransactionError: deleteTransactionError, isDeleteTransactionLoading: isDeleteTransactionLoading } = (0, $0827fde0dd8ade0d$export$2e2bcd8739ae039)();
    // Functions
    const toggleModal = ()=>{
        toggleDeleteTransactionModal();
    };
    const handleDelete = ()=>{
        deleteTransaction({
            transaction_id: transactionRemove.transaction_id
        });
    };
    // UseEffect
    (0, $tZqWC.useEffect)(()=>{
        if (isDeleteTransactionModalOpen) {
            if (!isDeleteTransactionLoading && !!deleteTransactionData && !deleteTransactionError) {
                setIsPageTableUpdated(true);
                setTransactionRemove({
                    transaction_id: ''
                });
                toggleDeleteTransactionModal();
            }
        }
    }, [
        isDeleteTransactionLoading
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $0cb604e8ac00d438$export$2e2bcd8739ae039), {
        isOpen: isDeleteTransactionModalOpen,
        toggle: toggleModal,
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6e660ada3ebfb268$export$2e2bcd8739ae039), {
                toggle: toggleModal,
                children: "Delete transaction"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $5a83d1c72fcd9217$export$2e2bcd8739ae039), {
                children: [
                    isDeleteTransactionLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d823d76b58a2c211$export$e833dfe35f2086ee), {
                        children: "Deleting..."
                    }),
                    !deleteTransactionData && !isDeleteTransactionLoading && !deleteTransactionError && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d823d76b58a2c211$export$e833dfe35f2086ee), {
                        children: "Are you sure you want to delete this transaction? This action is irreversible."
                    }),
                    !isDeleteTransactionLoading && deleteTransactionError && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d823d76b58a2c211$export$e833dfe35f2086ee), {
                        children: "An error occurred in removing transaction, please try again later."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $b07759276f5d7f2d$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                        onClick: toggleModal,
                        fullWidth: true,
                        type: "button",
                        variant: "outlined",
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                        onClick: handleDelete,
                        fullWidth: true,
                        type: "button",
                        color: "secondary",
                        children: "Delete"
                    })
                ]
            })
        ]
    });
}
// Default Props
$1700cc15bb86a0c4$var$DeleteTransactionModal.defaultProps = {
    ui: {},
    form: {},
    actions: {}
};
// Proptypes Validation
$1700cc15bb86a0c4$var$DeleteTransactionModal.propTypes = {
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isDeleteTransactionModalOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    form: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        activityToRemove: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            hash: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
        })
    }),
    transaction: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        transactionRemove: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            transaction_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
        })
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        toggleDeleteTransactionModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setTransactionRemove: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $1700cc15bb86a0c4$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($1700cc15bb86a0c4$var$mapStateToProps, $1700cc15bb86a0c4$var$mapDispatchToProps)($1700cc15bb86a0c4$var$DeleteTransactionModal);


var $e7d8993ff401f9b8$export$2e2bcd8739ae039 = (0, $1700cc15bb86a0c4$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");



const $b4966cd4b026b623$export$87ad169bde460ddf = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  width: 100%;
  padding: 20px;
  margin: 20px 0;
  background-color: ${({ theme: theme })=>theme.colors.background};
  border-radius: 10px;
`;





var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");


var $ejSM7 = parcelRequire("ejSM7");





const $1e56078dc6c85ba0$export$5f1af8db9871e1d6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  margin: 0;
  padding: 0;
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $1e56078dc6c85ba0$export$f99233281efd08a0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h2`
  margin: 0;
  padding: 0;
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme: theme })=>theme.colors.primary};
  text-transform: uppercase;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;
const $1e56078dc6c85ba0$export$d747b2abe71e53f5 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 100%;

  & > div:last-child {
    border: none;
    padding-bottom: 0;
  }
`;
const $1e56078dc6c85ba0$export$bc7adc8ef74607f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding-top: 10px;
  display: flex;
  justify-content: space-between;
  gap: 10px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $1e56078dc6c85ba0$export$a9754b3c8daa5172 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  gap: 10px;
`;
const $1e56078dc6c85ba0$export$4e8a51dfb7785a56 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  width: 100%;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 40px;
`;
const $1e56078dc6c85ba0$export$cd1f041fcaf00d90 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 10px;
  padding: 5px 0 10px 0;
  border-bottom: 1px solid ${({ theme: theme })=>theme.colors.backgroundLite};
`;
const $1e56078dc6c85ba0$export$dc8558b9a49863a4 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h2`
  margin: 0;
  padding: 0;
  font-size: 15px;
  font-weight: 400;
  color: ${({ theme: theme })=>theme.colors.primary};

  font-size: 14px;
  font-weight: 400;
  padding-top: 5px;
  display: flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;
`;
const $1e56078dc6c85ba0$export$87de03758d2d03db = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  & #rsSubTitle {
    color: ${({ theme: theme })=>theme.colors.secondary};
  }
`;



// Map Redux Props
const $796ad943af40a68d$var$mapStateToProps = (state)=>state;
const $796ad943af40a68d$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $796ad943af40a68d$var$TransactionRisk(props) {
    // Destructure
    const { actions: actions, riskData: risk_data, transactionData: transaction_data } = props;
    // Store Actions
    const { setInfoModalDetails: setInfoModalDetails, toggleInfoModal: toggleInfoModal } = actions;
    // Local State
    const [riskData, setRiskData] = (0, $tZqWC.useState)();
    const [transactionData, setTransactionData] = (0, $tZqWC.useState)();
    // Functions
    const handleToggleInfo = (title, content)=>{
        setInfoModalDetails({
            title: title,
            content: content
        });
        toggleInfoModal(true);
    };
    const formatValue = (number)=>{
        if (number < 0.01) return number;
        return (0, $ecf1d77ac1b82678$export$a2db1876938cd11d)(Math.round(number * 100) / 100);
    };
    // UseEffects
    (0, $tZqWC.useEffect)(()=>{
        setRiskData(risk_data);
    }, [
        risk_data
    ]);
    (0, $tZqWC.useEffect)(()=>{
        setTransactionData(transaction_data);
    }, [
        transaction_data
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $1e56078dc6c85ba0$export$4e8a51dfb7785a56), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $1e56078dc6c85ba0$export$a9754b3c8daa5172), {
                style: {
                    gap: '20px'
                },
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1e56078dc6c85ba0$export$a9754b3c8daa5172), {
                        style: {
                            maxWidth: '160px',
                            alignItems: 'center'
                        },
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1e56078dc6c85ba0$export$87de03758d2d03db), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ba8982a7854b309f$export$2e2bcd8739ae039), {
                                id: `${riskData?.id}${riskData?.id}1`,
                                size: 110,
                                progress: riskData?.in_risk_ratio && riskData.in_risk_ratio,
                                children: riskData?.in_risk_ratio && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $1e56078dc6c85ba0$export$d747b2abe71e53f5), {
                                    style: {
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        gap: 0
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1e56078dc6c85ba0$export$5f1af8db9871e1d6), {
                                            style: {
                                                fontSize: '18px',
                                                fontWeight: 600
                                            },
                                            children: `${riskData.in_risk_ratio}%`
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1e56078dc6c85ba0$export$5f1af8db9871e1d6), {
                                            style: {
                                                fontSize: '12px',
                                                fontWeight: 400
                                            },
                                            id: "rsSubTitle",
                                            children: "Risk"
                                        })
                                    ]
                                })
                            }, `${riskData?.id}${riskData?.id}1`)
                        })
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1e56078dc6c85ba0$export$a9754b3c8daa5172), {
                        style: {
                            flex: 1
                        },
                        children: riskData?.in_risk_ratio !== null || riskData?.out_risk_ratio !== null ? /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $1e56078dc6c85ba0$export$a9754b3c8daa5172), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $1e56078dc6c85ba0$export$cd1f041fcaf00d90), {
                                    children: [
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $1e56078dc6c85ba0$export$dc8558b9a49863a4), {
                                            onClick: ()=>handleToggleInfo('Risk Score Information', riskData?.risk_score_desc),
                                            children: [
                                                "Risk Score",
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b7c251a6b5f784dd$export$2e2bcd8739ae039), {
                                                    size: 18
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1e56078dc6c85ba0$export$5f1af8db9871e1d6), {
                                            style: {
                                                border: 'none',
                                                fontSize: 15
                                            },
                                            children: `${riskData?.in_risk_score ? riskData?.in_risk_score : ''} / ${riskData?.max_score !== null && riskData?.max_score !== undefined ? riskData?.max_score : ''}`
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $1e56078dc6c85ba0$export$cd1f041fcaf00d90), {
                                    children: [
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1e56078dc6c85ba0$export$dc8558b9a49863a4), {
                                            style: {
                                                cursor: 'default'
                                            },
                                            children: "Timestamp"
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1e56078dc6c85ba0$export$5f1af8db9871e1d6), {
                                            style: {
                                                border: 'none',
                                                fontSize: 15
                                            },
                                            children: riskData?.created && (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(riskData.created).format((0, $41a9e38e6be32f35$export$67a03cd247c60132))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $1e56078dc6c85ba0$export$cd1f041fcaf00d90), {
                                    children: [
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $1e56078dc6c85ba0$export$dc8558b9a49863a4), {
                                            onClick: ()=>handleToggleInfo('Risk Score Source Information', riskData?.risk_provider_desc),
                                            children: [
                                                "Source",
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b7c251a6b5f784dd$export$2e2bcd8739ae039), {
                                                    size: 18
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1e56078dc6c85ba0$export$5f1af8db9871e1d6), {
                                            style: {
                                                border: 'none',
                                                fontSize: 15
                                            },
                                            children: riskData?.risk_provider_code || 'unknown'
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $1e56078dc6c85ba0$export$f99233281efd08a0), {
                            style: {
                                textAlign: 'center'
                            },
                            children: [
                                "Input Risk (Unavailable) ",
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2d68211da31cd8b8$export$2e2bcd8739ae039), {
                                    size: 18
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1e56078dc6c85ba0$export$a9754b3c8daa5172), {
                        style: {
                            flex: 1,
                            minWidth: '250px'
                        },
                        children: riskData?.in_risk_ratio !== null || riskData?.out_risk_ratio !== null ? /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $1e56078dc6c85ba0$export$a9754b3c8daa5172), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $1e56078dc6c85ba0$export$cd1f041fcaf00d90), {
                                    children: [
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1e56078dc6c85ba0$export$dc8558b9a49863a4), {
                                            style: {
                                                cursor: 'default'
                                            },
                                            children: "Input USD:"
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1e56078dc6c85ba0$export$5f1af8db9871e1d6), {
                                            style: {
                                                border: 'none',
                                                fontSize: 15
                                            },
                                            children: transactionData?.in_usd ? `$ ${formatValue(transactionData.in_usd)}` : '-'
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $1e56078dc6c85ba0$export$cd1f041fcaf00d90), {
                                    children: [
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1e56078dc6c85ba0$export$dc8558b9a49863a4), {
                                            style: {
                                                cursor: 'default'
                                            },
                                            children: "Input Events"
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1e56078dc6c85ba0$export$5f1af8db9871e1d6), {
                                            style: {
                                                border: 'none',
                                                fontSize: 15
                                            },
                                            children: transactionData?.in_count
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $1e56078dc6c85ba0$export$cd1f041fcaf00d90), {
                                    children: [
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1e56078dc6c85ba0$export$dc8558b9a49863a4), {
                                            style: {
                                                cursor: 'default'
                                            },
                                            children: "Fee"
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1e56078dc6c85ba0$export$5f1af8db9871e1d6), {
                                            style: {
                                                border: 'none',
                                                fontSize: 15
                                            },
                                            children: transactionData?.fee_amount_usd ? `$ ${formatValue(transactionData.fee_amount_usd)}` : '-'
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $1e56078dc6c85ba0$export$f99233281efd08a0), {
                            style: {
                                textAlign: 'center'
                            },
                            children: [
                                "Input Risk (Unavailable) ",
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2d68211da31cd8b8$export$2e2bcd8739ae039), {
                                    size: 18
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $1e56078dc6c85ba0$export$a9754b3c8daa5172), {
                style: {
                    gap: '20px'
                },
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1e56078dc6c85ba0$export$a9754b3c8daa5172), {
                        style: {
                            maxWidth: '160px',
                            alignItems: 'center'
                        },
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1e56078dc6c85ba0$export$87de03758d2d03db), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ba8982a7854b309f$export$2e2bcd8739ae039), {
                                id: `${riskData?.id}${riskData?.id}2`,
                                size: 110,
                                progress: riskData?.out_risk_ratio && riskData.out_risk_ratio,
                                children: riskData?.out_risk_ratio && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $1e56078dc6c85ba0$export$d747b2abe71e53f5), {
                                    style: {
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        gap: 0
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1e56078dc6c85ba0$export$5f1af8db9871e1d6), {
                                            style: {
                                                fontSize: '18px',
                                                fontWeight: 600
                                            },
                                            children: `${riskData.out_risk_ratio}%`
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1e56078dc6c85ba0$export$5f1af8db9871e1d6), {
                                            style: {
                                                fontSize: '12px',
                                                fontWeight: 400
                                            },
                                            id: "rsSubTitle",
                                            children: "Risk"
                                        })
                                    ]
                                })
                            }, `${riskData?.id}${riskData?.id}2`)
                        })
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1e56078dc6c85ba0$export$a9754b3c8daa5172), {
                        style: {
                            flex: 1
                        },
                        children: riskData?.in_risk_ratio !== null || riskData?.out_risk_ratio !== null ? /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $1e56078dc6c85ba0$export$a9754b3c8daa5172), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $1e56078dc6c85ba0$export$cd1f041fcaf00d90), {
                                    children: [
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $1e56078dc6c85ba0$export$dc8558b9a49863a4), {
                                            onClick: ()=>handleToggleInfo('Risk Score Information', riskData?.risk_score_desc),
                                            children: [
                                                "Risk Score",
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b7c251a6b5f784dd$export$2e2bcd8739ae039), {
                                                    size: 18
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1e56078dc6c85ba0$export$5f1af8db9871e1d6), {
                                            style: {
                                                border: 'none',
                                                fontSize: 15
                                            },
                                            children: `${riskData?.out_risk_score ? riskData?.out_risk_score : ''} / ${riskData?.max_score !== null && riskData?.max_score !== undefined ? riskData?.max_score : ''}`
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $1e56078dc6c85ba0$export$cd1f041fcaf00d90), {
                                    children: [
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1e56078dc6c85ba0$export$dc8558b9a49863a4), {
                                            style: {
                                                cursor: 'default'
                                            },
                                            children: "Timestamp"
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1e56078dc6c85ba0$export$5f1af8db9871e1d6), {
                                            style: {
                                                border: 'none',
                                                fontSize: 15
                                            },
                                            children: riskData?.created && (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(riskData.created).format((0, $41a9e38e6be32f35$export$67a03cd247c60132))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $1e56078dc6c85ba0$export$cd1f041fcaf00d90), {
                                    children: [
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $1e56078dc6c85ba0$export$dc8558b9a49863a4), {
                                            onClick: ()=>handleToggleInfo('Risk Score Source Information', riskData?.risk_provider_desc),
                                            children: [
                                                "Source",
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b7c251a6b5f784dd$export$2e2bcd8739ae039), {
                                                    size: 18
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1e56078dc6c85ba0$export$5f1af8db9871e1d6), {
                                            style: {
                                                border: 'none',
                                                fontSize: 15
                                            },
                                            children: riskData?.risk_provider_code || 'unknown'
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $1e56078dc6c85ba0$export$f99233281efd08a0), {
                            style: {
                                textAlign: 'center'
                            },
                            children: [
                                "Output Risk (Unavailable) ",
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $738b185bd23471f4$export$2e2bcd8739ae039), {
                                    size: 18
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1e56078dc6c85ba0$export$a9754b3c8daa5172), {
                        style: {
                            flex: 1,
                            minWidth: '250px'
                        },
                        children: riskData?.in_risk_ratio !== null || riskData?.out_risk_ratio !== null ? /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $1e56078dc6c85ba0$export$a9754b3c8daa5172), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $1e56078dc6c85ba0$export$cd1f041fcaf00d90), {
                                    children: [
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1e56078dc6c85ba0$export$dc8558b9a49863a4), {
                                            style: {
                                                cursor: 'default'
                                            },
                                            children: "Output USD:"
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1e56078dc6c85ba0$export$5f1af8db9871e1d6), {
                                            style: {
                                                border: 'none',
                                                fontSize: 15
                                            },
                                            children: transactionData?.out_usd ? `$ ${formatValue(transactionData.out_usd)}` : '-'
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $1e56078dc6c85ba0$export$cd1f041fcaf00d90), {
                                    children: [
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1e56078dc6c85ba0$export$dc8558b9a49863a4), {
                                            style: {
                                                cursor: 'default'
                                            },
                                            children: "Output Events"
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1e56078dc6c85ba0$export$5f1af8db9871e1d6), {
                                            style: {
                                                border: 'none',
                                                fontSize: 15
                                            },
                                            children: transactionData?.out_count
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $1e56078dc6c85ba0$export$cd1f041fcaf00d90), {
                                    children: [
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1e56078dc6c85ba0$export$dc8558b9a49863a4), {
                                            style: {
                                                cursor: 'default'
                                            },
                                            children: "Fee"
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1e56078dc6c85ba0$export$5f1af8db9871e1d6), {
                                            style: {
                                                border: 'none',
                                                fontSize: 15
                                            },
                                            children: transactionData?.fee_amount_usd ? `$ ${formatValue(transactionData.fee_amount_usd)}` : '-'
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $1e56078dc6c85ba0$export$f99233281efd08a0), {
                            style: {
                                textAlign: 'center'
                            },
                            children: [
                                "Output Risk (Unavailable) ",
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2d68211da31cd8b8$export$2e2bcd8739ae039), {
                                    size: 18
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
// Default Props
$796ad943af40a68d$var$TransactionRisk.defaultProps = {
    riskData: {},
    transactionData: {},
    actions: {}
};
// Proptypes Validation
$796ad943af40a68d$var$TransactionRisk.propTypes = {
    riskData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({}),
    transactionData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({}),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setInfoModalDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        toggleInfoModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $796ad943af40a68d$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($796ad943af40a68d$var$mapStateToProps, $796ad943af40a68d$var$mapDispatchToProps)($796ad943af40a68d$var$TransactionRisk);


var $d52a159be131e730$export$2e2bcd8739ae039 = (0, $796ad943af40a68d$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");








const $6a68458cd919653e$export$5f1af8db9871e1d6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  margin: 0;
  padding: 0;
  font-weight: 400;
  font-size: 14px;
  color: ${({ theme: theme })=>theme.colors.primary};
  text-align: right;
`;
const $6a68458cd919653e$export$f99233281efd08a0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h2`
  margin: 0;
  padding: 10px 0 0 0;
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme: theme })=>theme.colors.primary};
  text-transform: uppercase;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;
const $6a68458cd919653e$export$d747b2abe71e53f5 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 5px;
  border: 0px solid ${({ theme: theme })=>theme.colors.backgroundLite};
`;
const $6a68458cd919653e$export$bc7adc8ef74607f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding-top: 10px;
  display: flex;
  justify-content: space-between;
  gap: 10px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $6a68458cd919653e$export$a9754b3c8daa5172 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  flex: 1;
  gap: 10px;
  width: 100%;
`;
const $6a68458cd919653e$export$a4fff7f2f85c4c81 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  padding: 20px;
  width: 100%;
  height: 100%;
  border-radius: 7px;
  border: 1px solid ${({ theme: theme })=>theme.colors.backgroundLite};
  & > div:last-child {
    border: none;
  }
`;
const $6a68458cd919653e$export$dc8558b9a49863a4 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h2`
  margin: 0;
  padding: 0;
  color: ${({ theme: theme })=>theme.colors.primary};

  font-size: 14px;
  font-weight: 400;
  display: flex;
  align-items: center;
  gap: 5px;
`;
const $6a68458cd919653e$export$8f314e512d92575f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  cursor: pointer;
  & > svg > path:first-child {
    fill: ${({ theme: theme, active: active })=>active ? theme.colors.brand : theme.colors.primary};
    fill-opacity: ${({ active: active })=>active ? 1 : 0.3};
  }
`;
const $6a68458cd919653e$export$b2bf131c9f9cce5d = (0, $a778141486c79bc3$export$2e2bcd8739ae039)((0, $12b33660068e86aa$export$b0d92dbee9b5b60d))`
  margin: 0;
  padding: 0;
  font-weight: 600;
  font-size: 12px;
  color: ${({ theme: theme })=>theme.colors.primary};
  text-align: right;
  display: flex;
  align-items: center;

  & svg {
    height: 100%;
    max-height: 15px;
  }
`;


// Map Redux Props
const $c2a9da6739913cfc$var$mapStateToProps = (state)=>state;
const $c2a9da6739913cfc$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $c2a9da6739913cfc$var$TransactionEvents(props) {
    const { transactionData: transactionData, currentIpUsed: currentIpUsed, isExpanded: isExpanded, eventDetails: eventDetails, setEventDetails: setEventDetails } = props;
    // Input Refs
    const inputContainerRef = (0, $tZqWC.useRef)(null);
    const outputContainerRef = (0, $tZqWC.useRef)(null);
    // UseStates
    const [isInputLoading, setIsInputLoading] = (0, $tZqWC.useState)(false);
    const [isOutputLoading, setIsOutputLoading] = (0, $tZqWC.useState)(false);
    const [isLinked, setIsLinked] = (0, $tZqWC.useState)(false);
    const [isLoaded, setIsLoaded] = (0, $tZqWC.useState)(false);
    const [isResetLoading, setIsResetLoading] = (0, $tZqWC.useState)(false);
    const [isInputBottom, setIsInputBottom] = (0, $tZqWC.useState)(false);
    const [isOutputBottom, setIsOutputBottom] = (0, $tZqWC.useState)(false);
    // Functions
    async function fetchInputEvents(page) {
        if (isInputBottom) {
            setIsInputLoading(false);
            return;
        }
        if (isInputLoading) return;
        const data = await (0, $d8ece7ca134df21e$export$3dd51e9f3226208b)({
            transaction_id: transactionData.id,
            risk_integration_id: currentIpUsed && currentIpUsed,
            page: page || eventDetails.inputs.page + 1,
            type: 'in'
        });
        if (data?.items && data?.items?.length > -1) setEventDetails((prevValue)=>({
                ...prevValue,
                inputs: {
                    page: page || eventDetails.inputs.page + 1,
                    events: [
                        ...prevValue.inputs.events,
                        ...data.items
                    ]
                }
            }));
        if (data?.items?.length < 1) setIsInputBottom(true);
        setIsInputLoading(false);
    }
    async function fetchOutputEvents(page) {
        if (isOutputBottom) {
            setIsOutputLoading(false);
            return;
        }
        if (isOutputLoading) return;
        const data = await (0, $d8ece7ca134df21e$export$3dd51e9f3226208b)({
            transaction_id: transactionData.id,
            risk_integration_id: currentIpUsed && currentIpUsed,
            page: page || eventDetails.outputs.page + 1,
            type: 'out'
        });
        if (data?.items && data?.items?.length > -1) setEventDetails((prevValue)=>({
                ...prevValue,
                outputs: {
                    page: page || eventDetails.outputs.page + 1,
                    events: [
                        ...prevValue.outputs.events,
                        ...data.items
                    ]
                }
            }));
        if (data?.items?.length < 1) setIsOutputBottom(true);
        setIsOutputLoading(false);
    }
    async function resetEvents(linked) {
        const data_in = await (0, $d8ece7ca134df21e$export$3dd51e9f3226208b)({
            transaction_id: transactionData.id,
            risk_integration_id: currentIpUsed && currentIpUsed,
            page: 1,
            type: 'in',
            linked: linked && 'in'
        });
        const data_out = await (0, $d8ece7ca134df21e$export$3dd51e9f3226208b)({
            transaction_id: transactionData.id,
            risk_integration_id: currentIpUsed && currentIpUsed,
            page: 1,
            type: 'out',
            linked: linked && 'out'
        });
        if (data_in?.items?.length >= 0 && data_out?.items?.length >= 0) setEventDetails(()=>({
                outputs: {
                    page: 1,
                    events: [
                        ...data_out.items
                    ]
                },
                inputs: {
                    page: 1,
                    events: [
                        ...data_in.items
                    ]
                }
            }));
        setIsResetLoading(false);
        setIsInputBottom(false);
        setIsOutputBottom(false);
    }
    function formatValue(number) {
        if (number < 0.01) return number;
        return (0, $ecf1d77ac1b82678$export$a2db1876938cd11d)(Math.round(number * 100) / 100);
    }
    function convertAmount(amount, decimals) {
        decimals = Math.max(0, Math.floor(decimals));
        const multiplier = 10 ** decimals;
        const convertedAmount = amount / multiplier;
        return convertedAmount;
    }
    function formatEvents(rawEvents) {
        const inputs = [];
        const outputs = [];
        if (rawEvents?.length > 0) rawEvents.forEach((item)=>{
            if (item?.source) inputs.push(item);
            if (item?.destination) outputs.push(item);
        });
        setEventDetails({
            inputs: {
                events: inputs,
                page: 1
            },
            outputs: {
                events: outputs,
                page: 1
            }
        });
    }
    // UseEffects
    (0, $tZqWC.useEffect)(()=>{
        if (transactionData?.financial_data?.events) {
            formatEvents(transactionData?.financial_data?.events);
            return;
        }
        if (!isLoaded && (eventDetails?.inputs?.events?.length > 0 || eventDetails?.outputs?.events?.length > 0)) {
            setIsLoaded(true);
            return;
        }
        if (isExpanded && !isLoaded && transactionData.id) {
            setIsInputLoading(true);
            setIsOutputLoading(true);
            fetchInputEvents(1);
            fetchOutputEvents(1);
            setIsLoaded(true);
        }
    }, [
        isExpanded,
        transactionData
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (!isExpanded) return;
        if (!isLoaded) return;
        setIsResetLoading(true);
        resetEvents(isLinked);
    }, [
        isLinked
    ]);
    (0, $tZqWC.useEffect)(()=>{
        const handleScroll = ()=>{
            const container = inputContainerRef.current;
            const { clientHeight: clientHeight, scrollHeight: scrollHeight, scrollTop: scrollTop } = container;
            if (clientHeight + scrollTop >= scrollHeight && transactionData.id) {
                setIsInputLoading(true);
                fetchInputEvents();
            }
        };
        const container = inputContainerRef.current;
        if (container) {
            container.addEventListener('scroll', handleScroll);
            return ()=>{
                container.removeEventListener('scroll', handleScroll);
            };
        }
    }, [
        isInputBottom,
        isInputLoading,
        isResetLoading
    ]);
    (0, $tZqWC.useEffect)(()=>{
        const handleScroll = ()=>{
            const container = outputContainerRef.current;
            const { clientHeight: clientHeight, scrollHeight: scrollHeight, scrollTop: scrollTop } = container;
            if (clientHeight + scrollTop >= scrollHeight && transactionData.id) {
                setIsOutputLoading(true);
                fetchOutputEvents();
            }
        };
        const container = outputContainerRef.current;
        if (container) {
            container.addEventListener('scroll', handleScroll);
            return ()=>{
                container.removeEventListener('scroll', handleScroll);
            };
        }
    }, [
        isOutputBottom,
        isOutputLoading,
        isResetLoading
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6a68458cd919653e$export$a4fff7f2f85c4c81), {
        style: {
            marginTop: '20px',
            padding: '20px 0',
            borderWidth: '0',
            borderTopWidth: '1px',
            borderRadius: 0
        },
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6a68458cd919653e$export$bc7adc8ef74607f), {
            style: {
                padding: 0
            },
            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6a68458cd919653e$export$a9754b3c8daa5172), {
                style: {
                    gap: '15px'
                },
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6a68458cd919653e$export$d747b2abe71e53f5), {
                        style: {
                            height: '100%'
                        },
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6a68458cd919653e$export$a9754b3c8daa5172), {
                                style: {
                                    paddingLeft: '20px',
                                    flex: 0
                                },
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6a68458cd919653e$export$f99233281efd08a0), {
                                    children: "Input Events"
                                })
                            }),
                            !isResetLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6a68458cd919653e$export$d747b2abe71e53f5), {
                                ref: inputContainerRef,
                                style: {
                                    height: '100%',
                                    width: '100%',
                                    maxHeight: '330px',
                                    overflowY: 'auto'
                                },
                                children: [
                                    eventDetails?.inputs?.events && eventDetails?.inputs?.events?.length > 0 && eventDetails?.inputs?.events.map((item)=>{
                                        if (item?.type !== 'fee') return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6a68458cd919653e$export$a4fff7f2f85c4c81), {
                                            style: {
                                                height: 'fit-content'
                                            },
                                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6a68458cd919653e$export$d747b2abe71e53f5), {
                                                children: [
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6a68458cd919653e$export$a9754b3c8daa5172), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6a68458cd919653e$export$dc8558b9a49863a4), {
                                                                children: "Address: "
                                                            }),
                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6a68458cd919653e$export$5f1af8db9871e1d6), {
                                                                children: item?.source
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6a68458cd919653e$export$a9754b3c8daa5172), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6a68458cd919653e$export$d747b2abe71e53f5), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6a68458cd919653e$export$a9754b3c8daa5172), {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6a68458cd919653e$export$dc8558b9a49863a4), {
                                                                                children: "Amount Native: "
                                                                            }),
                                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6a68458cd919653e$export$5f1af8db9871e1d6), {
                                                                                children: [
                                                                                    item?.denomination && `${item?.denomination} `,
                                                                                    item?.amount && item?.decimals && `${formatValue(convertAmount(item.amount, item.decimals))}`
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6a68458cd919653e$export$a9754b3c8daa5172), {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6a68458cd919653e$export$dc8558b9a49863a4), {
                                                                                children: "Amount USD: "
                                                                            }),
                                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6a68458cd919653e$export$5f1af8db9871e1d6), {
                                                                                children: item?.amount_usd && `$ ${formatValue(item.amount_usd)}`
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6a68458cd919653e$export$d747b2abe71e53f5), {
                                                                style: {
                                                                    borderLeftWidth: '1px',
                                                                    paddingLeft: '10px',
                                                                    marginLeft: '-10px'
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6a68458cd919653e$export$a9754b3c8daa5172), {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6a68458cd919653e$export$dc8558b9a49863a4), {
                                                                                children: "Linked to: "
                                                                            }),
                                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6a68458cd919653e$export$b2bf131c9f9cce5d), {
                                                                                exact: true,
                                                                                target: "_blank",
                                                                                to: `/directory/accounts/details/${item.in_account_id}`,
                                                                                children: item?.in_account_reference_id ? /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                                                                                    children: [
                                                                                        item.in_account_reference_id,
                                                                                        " ",
                                                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2aac7bf62453042d$export$2e2bcd8739ae039), {
                                                                                            size: 18
                                                                                        }),
                                                                                        ' '
                                                                                    ]
                                                                                }) : '-'
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6a68458cd919653e$export$a9754b3c8daa5172), {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6a68458cd919653e$export$dc8558b9a49863a4), {
                                                                                children: "Type: "
                                                                            }),
                                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6a68458cd919653e$export$5f1af8db9871e1d6), {
                                                                                children: "Sender"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    item?.in_risk_ratio && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6a68458cd919653e$export$a9754b3c8daa5172), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6a68458cd919653e$export$dc8558b9a49863a4), {
                                                                children: "Risk Score: "
                                                            }),
                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6a68458cd919653e$export$5f1af8db9871e1d6), {
                                                                children: item?.in_risk_ratio && `${item.in_risk_ratio}%`
                                                            }),
                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f598a52270fcc8c$export$2e2bcd8739ae039), {
                                                                height: 6,
                                                                width: item?.in_risk_ratio !== null || undefined ? `${item.in_risk_ratio}%` : '0%'
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }, item?.transaction_event_id);
                                    }),
                                    eventDetails?.inputs?.events && eventDetails?.inputs?.events?.length < 1 && !isInputLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a6ea3b0f3caed586$export$2e2bcd8739ae039), {
                                        title: "No linked Addresses found",
                                        content: "Addresses that were linked to an account were not found",
                                        setFilter: ()=>setIsLinked(false)
                                    }),
                                    isInputLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6a68458cd919653e$export$a4fff7f2f85c4c81), {
                                        style: {
                                            padding: '10px 0'
                                        },
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $647b8bc68ebce54f$export$2e2bcd8739ae039), {
                                            style: {
                                                padding: 0
                                            }
                                        })
                                    })
                                ]
                            }),
                            isResetLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6a68458cd919653e$export$a4fff7f2f85c4c81), {
                                style: {
                                    padding: '10px 0'
                                },
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $647b8bc68ebce54f$export$2e2bcd8739ae039), {
                                    style: {
                                        padding: 0
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6a68458cd919653e$export$d747b2abe71e53f5), {
                        style: {
                            height: '100%'
                        },
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6a68458cd919653e$export$a9754b3c8daa5172), {
                                style: {
                                    padding: '0 20px 0 10px',
                                    flex: 0,
                                    justifyContent: 'space-between'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6a68458cd919653e$export$f99233281efd08a0), {
                                        children: "Output Events"
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6a68458cd919653e$export$8f314e512d92575f), {
                                        active: isLinked,
                                        onClick: ()=>setIsLinked((v)=>!v),
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $40d2b22b972563c2$export$2e2bcd8739ae039), {
                                            size: 18
                                        })
                                    })
                                ]
                            }),
                            !isResetLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6a68458cd919653e$export$d747b2abe71e53f5), {
                                ref: outputContainerRef,
                                style: {
                                    height: '100%',
                                    width: '100%',
                                    maxHeight: '330px',
                                    overflowY: 'auto'
                                },
                                children: [
                                    eventDetails?.outputs?.events && eventDetails?.outputs?.events?.length > 0 && eventDetails?.outputs?.events.map((item)=>{
                                        if (item?.type !== 'fee') return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6a68458cd919653e$export$a4fff7f2f85c4c81), {
                                            style: {
                                                height: 'fit-content'
                                            },
                                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6a68458cd919653e$export$d747b2abe71e53f5), {
                                                children: [
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6a68458cd919653e$export$a9754b3c8daa5172), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6a68458cd919653e$export$dc8558b9a49863a4), {
                                                                children: "Address: "
                                                            }),
                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6a68458cd919653e$export$5f1af8db9871e1d6), {
                                                                children: item?.destination
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6a68458cd919653e$export$a9754b3c8daa5172), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6a68458cd919653e$export$d747b2abe71e53f5), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6a68458cd919653e$export$a9754b3c8daa5172), {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6a68458cd919653e$export$dc8558b9a49863a4), {
                                                                                children: "Amount Native: "
                                                                            }),
                                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6a68458cd919653e$export$5f1af8db9871e1d6), {
                                                                                children: [
                                                                                    item?.denomination && `${item?.denomination} `,
                                                                                    item?.amount && item?.decimals && `${formatValue(convertAmount(item.amount, item.decimals))}`
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6a68458cd919653e$export$a9754b3c8daa5172), {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6a68458cd919653e$export$dc8558b9a49863a4), {
                                                                                children: "Amount USD: "
                                                                            }),
                                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6a68458cd919653e$export$5f1af8db9871e1d6), {
                                                                                children: item?.amount_usd && `$ ${formatValue(item.amount_usd)}`
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6a68458cd919653e$export$d747b2abe71e53f5), {
                                                                style: {
                                                                    borderLeftWidth: '1px',
                                                                    paddingLeft: '10px',
                                                                    marginLeft: '-10px'
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6a68458cd919653e$export$a9754b3c8daa5172), {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6a68458cd919653e$export$dc8558b9a49863a4), {
                                                                                children: "Linked to: "
                                                                            }),
                                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6a68458cd919653e$export$b2bf131c9f9cce5d), {
                                                                                exact: true,
                                                                                target: "_blank",
                                                                                to: `/directory/accounts/details/${item.in_account_id}`,
                                                                                children: item?.out_account_reference_id ? /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                                                                                    children: [
                                                                                        item.out_account_reference_id,
                                                                                        " ",
                                                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2aac7bf62453042d$export$2e2bcd8739ae039), {
                                                                                            size: 18
                                                                                        }),
                                                                                        ' '
                                                                                    ]
                                                                                }) : '-'
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6a68458cd919653e$export$a9754b3c8daa5172), {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6a68458cd919653e$export$dc8558b9a49863a4), {
                                                                                children: "Type: "
                                                                            }),
                                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6a68458cd919653e$export$5f1af8db9871e1d6), {
                                                                                children: "Receiver"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    item?.out_risk_ratio && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6a68458cd919653e$export$a9754b3c8daa5172), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6a68458cd919653e$export$dc8558b9a49863a4), {
                                                                children: "Risk Score: "
                                                            }),
                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6a68458cd919653e$export$5f1af8db9871e1d6), {
                                                                children: item?.out_risk_ratio && `${item.out_risk_ratio}%`
                                                            }),
                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f598a52270fcc8c$export$2e2bcd8739ae039), {
                                                                height: 6,
                                                                width: item?.out_risk_ratio !== null || undefined ? `${item.out_risk_ratio}%` : '0%'
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }, item?.transaction_event_id);
                                    }),
                                    eventDetails?.outputs?.events && eventDetails?.outputs?.events?.length < 1 && !isInputLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a6ea3b0f3caed586$export$2e2bcd8739ae039), {
                                        title: "No linked Addresses found",
                                        content: "Addresses that were linked to an account were not found",
                                        setFilter: ()=>setIsLinked(false)
                                    }),
                                    isOutputLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6a68458cd919653e$export$a4fff7f2f85c4c81), {
                                        style: {
                                            padding: '10px 0'
                                        },
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $647b8bc68ebce54f$export$2e2bcd8739ae039), {
                                            style: {
                                                padding: 0
                                            }
                                        })
                                    })
                                ]
                            }),
                            isResetLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6a68458cd919653e$export$a4fff7f2f85c4c81), {
                                style: {
                                    padding: '10px 0'
                                },
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $647b8bc68ebce54f$export$2e2bcd8739ae039), {
                                    style: {
                                        padding: 0
                                    }
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
}
// Default Props
$c2a9da6739913cfc$var$TransactionEvents.defaultProps = {
    actions: {},
    transactionData: {}
};
// Proptypes Validation
$c2a9da6739913cfc$var$TransactionEvents.propTypes = {
    currentIpUsed: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        toggleInfoModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setInfoModalDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    transactionData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        chain: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        symbol: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        risk_score: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        risk_ratio: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        in_usd: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        out_usd: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        fee_amount_usd: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        balance: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        last_modified: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        created: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        in_count: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        out_count: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        asset_count: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        financial_data: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            events: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).arrayOf({
                id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
                type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
            })
        }),
        risk_events: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
        }))
    }),
    isExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    eventDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        inputs: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            events: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({})),
            page: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number
        }),
        outputs: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            events: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({})),
            page: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number
        })
    }),
    setEventDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
};
var $c2a9da6739913cfc$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($c2a9da6739913cfc$var$mapStateToProps, $c2a9da6739913cfc$var$mapDispatchToProps)($c2a9da6739913cfc$var$TransactionEvents);


var $b710de37560a74d2$export$2e2bcd8739ae039 = (0, $c2a9da6739913cfc$export$2e2bcd8739ae039);


// Map Redux Props
const $8e4b8648391b92f2$var$mapStateToProps = (state)=>state;
const $8e4b8648391b92f2$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $8e4b8648391b92f2$var$TransactionDetailsModal(props) {
    // Destructure
    const { transaction: transaction, actions: actions, ui: ui } = props;
    // Store State
    const { transactionModalDetails: transactionModalDetails } = transaction;
    const { isTransactionDetailsModalOpen: isTransactionDetailsModalOpen } = ui;
    // Store Actions
    const { toggleTransactionDetailsModalOpen: toggleTransactionDetailsModalOpen, setTransactionModalDetails: setTransactionModalDetails } = actions;
    // Constants
    const defaultEvents = {
        inputs: {
            events: [],
            page: 1
        },
        outputs: {
            events: [],
            page: 1
        }
    };
    // Local State
    const [riskData, setRiskData] = (0, $tZqWC.useState)();
    const [eventDetails, setEventDetails] = (0, $tZqWC.useState)(defaultEvents);
    // Hooks
    // const { getAddressHistory, getAddressHistoryData, isGetAddressHistoryLoading } = useGetAddressHistory()
    // Functions
    const toggleModal = ()=>{
        toggleTransactionDetailsModalOpen();
        setTransactionModalDetails();
        setRiskData(null);
        setEventDetails(defaultEvents);
    };
    // UseEffects
    (0, $tZqWC.useEffect)(()=>{
        if (isTransactionDetailsModalOpen) setRiskData(transactionModalDetails?.riskData);
    }, [
        isTransactionDetailsModalOpen
    ]);
    // useEffect(() => {
    //   if (isTransactionDetailsModalOpen) handleToggleInfo('TEST', 'TEST')
    // }, [isTransactionDetailsModalOpen])
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $0cb604e8ac00d438$export$2e2bcd8739ae039), {
        isOpen: isTransactionDetailsModalOpen,
        toggle: toggleModal,
        style: {
            maxWidth: '1440px'
        },
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6e660ada3ebfb268$export$2e2bcd8739ae039), {
                toggle: toggleModal,
                style: {
                    border: 'none'
                }
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5a83d1c72fcd9217$export$2e2bcd8739ae039), {
                style: {
                    maxHeight: '80vh'
                },
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $b4966cd4b026b623$export$87ad169bde460ddf), {
                    children: [
                        riskData && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d52a159be131e730$export$2e2bcd8739ae039), {
                            riskData: riskData,
                            transactionData: {
                                ...transactionModalDetails,
                                riskData: null
                            }
                        }),
                        riskData && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b710de37560a74d2$export$2e2bcd8739ae039), {
                            transactionData: {
                                ...transactionModalDetails,
                                riskData: null
                            },
                            currentIpUsed: riskData?.risk_integration_id,
                            isExpanded: isTransactionDetailsModalOpen,
                            eventDetails: eventDetails,
                            setEventDetails: setEventDetails
                        })
                    ]
                })
            })
        ]
    });
}
// Default Props
$8e4b8648391b92f2$var$TransactionDetailsModal.defaultProps = {
    ui: {},
    filters: {},
    transaction: {},
    actions: {}
};
// Proptypes Validation
$8e4b8648391b92f2$var$TransactionDetailsModal.propTypes = {
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isTransactionDetailsModalOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({}),
    transaction: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        transactionModalDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            riskData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({}),
            financial_data: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
                events: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).arrayOf()
            }),
            risk_events: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).arrayOf()
        })
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        toggleTransactionDetailsModalOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setTransactionModalDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setInfoModalDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        toggleInfoModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $8e4b8648391b92f2$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($8e4b8648391b92f2$var$mapStateToProps, $8e4b8648391b92f2$var$mapDispatchToProps)($8e4b8648391b92f2$var$TransactionDetailsModal);


var $f1fd0152aa1d17c3$export$2e2bcd8739ae039 = (0, $8e4b8648391b92f2$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");





const $7100960ba4ee1f97$export$47042699470e17dd = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-end;
`;
const $7100960ba4ee1f97$export$e833dfe35f2086ee = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 14.5px;
  font-weight: 400;
  padding: 0 20px 30px 20px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 10px;
`;
const $7100960ba4ee1f97$export$7316ba21c2af33a0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  margin: 0px 0px 0px 10px;
`;
const $7100960ba4ee1f97$export$f99233281efd08a0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 24px;
`;
const $7100960ba4ee1f97$export$5f1af8db9871e1d6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 14px;
`;
const $7100960ba4ee1f97$export$d6f6a072cce04542 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  width: 100%;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  margin: 20px 0;
  gap: 20px;
`;
const $7100960ba4ee1f97$export$ee0e52d575fd6e30 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  gap: 15px;

  padding: 10px 15px;
  border-radius: 12px;
  border: 2px solid ${({ theme: theme, active: active })=>active ? theme.colors.brand : theme.colors.background};
  width: 100%;

  transition: 0.3s;
  cursor: pointer;
  &:hover {
    border: 2px solid ${({ theme: theme })=>theme.colors.brand};
  }
`;
const $7100960ba4ee1f97$export$cbe66ba5a24d87ce = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;

  & svg {
    width: 30px;
    height: 30px;

    & path {
      stroke: ${({ theme: theme })=>theme.colors.primary};
    }
  }
`;
const $7100960ba4ee1f97$export$b381d9a2f3b4390b = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;
const $7100960ba4ee1f97$export$41ac0950c7d0e9ed = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 16px;
  font-weight: 600;
  text-transform: uppercase;
`;
const $7100960ba4ee1f97$export$b774ce8d8a47645 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 12px;
  font-weight: 300;
`;


// Map Redux Props
const $8bdc7d9cd8082343$var$mapStateToProps = (state)=>state;
const $8bdc7d9cd8082343$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $8bdc7d9cd8082343$var$ExploreAccountModal(props) {
    // Destructure
    const { ui: ui, actions: actions } = props;
    // Store State
    const { isExploreAccountModalOpen: isExploreAccountModalOpen } = ui;
    // Store Actions
    const { toggleExploreAccountModalOpen: toggleExploreAccountModalOpen } = actions;
    // Local State
    const [currentOption, setCurrentOption] = (0, $tZqWC.useState)('TravelRule');
    const [isLoading, setIsLoading] = (0, $tZqWC.useState)(false);
    // Variables
    const IdMapping = {
        TravelRule: 'jAIoDa7RyIY',
        AccountsDirectory: 'A5XYfjs-vPI',
        BlockchainAnalytics: 'A5XYfjs-vPI',
        RestAPI: 'A5XYfjs-vPI',
        ReportingHub: 'ToPxo1H_IGg'
    };
    // Functions
    const toggleModal = ()=>{
        toggleExploreAccountModalOpen();
    };
    const handleClick = (value)=>{
        if (isLoading) return;
        if (value === 'TravelRule' || value === 'ReportingHub') setCurrentOption(value);
    };
    (0, $tZqWC.useEffect)(()=>{
        setIsLoading(true);
        // Create a timer reference
        const timer = setTimeout(()=>{
            setIsLoading(false);
        }, 500);
        // Return cleanup function to clear the timeout if component unmounts
        return ()=>{
            clearTimeout(timer);
        };
    }, [
        currentOption
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $0cb604e8ac00d438$export$2e2bcd8739ae039), {
        isOpen: isExploreAccountModalOpen,
        toggle: toggleModal,
        style: {
            maxWidth: '1080px',
            width: '100%'
        },
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6e660ada3ebfb268$export$2e2bcd8739ae039), {
                toggle: toggleModal,
                close: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b77b5de3fb591045$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $7100960ba4ee1f97$export$e833dfe35f2086ee), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7100960ba4ee1f97$export$f99233281efd08a0), {
                        children: "Explore Ospree Account"
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7100960ba4ee1f97$export$5f1af8db9871e1d6), {
                        children: "This comprehensive guide provides detailed information for businesses using Ospree, covering essential tasks across the platform modules to help you effectively manage your operations."
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $7100960ba4ee1f97$export$d6f6a072cce04542), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $7100960ba4ee1f97$export$ee0e52d575fd6e30), {
                                active: currentOption === 'TravelRule',
                                onClick: ()=>handleClick('TravelRule'),
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7100960ba4ee1f97$export$cbe66ba5a24d87ce), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $13f215a46c77bbdb$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $7100960ba4ee1f97$export$b381d9a2f3b4390b), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7100960ba4ee1f97$export$41ac0950c7d0e9ed), {
                                                children: "Travel Rule"
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7100960ba4ee1f97$export$b774ce8d8a47645), {
                                                children: "Transfer originator and beneficiary information during crypto transactions."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $7100960ba4ee1f97$export$ee0e52d575fd6e30), {
                                active: currentOption === 'AccountsDirectory',
                                onClick: ()=>handleClick('AccountsDirectory'),
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7100960ba4ee1f97$export$cbe66ba5a24d87ce), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6873fe941a1f44db$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $7100960ba4ee1f97$export$b381d9a2f3b4390b), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7100960ba4ee1f97$export$41ac0950c7d0e9ed), {
                                                children: "Accounts Directory"
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7100960ba4ee1f97$export$b774ce8d8a47645), {
                                                children: "Ensure standardized data exchange between modules using unique reference IDs."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $7100960ba4ee1f97$export$ee0e52d575fd6e30), {
                                active: currentOption === 'BlockchainAnalytics',
                                onClick: ()=>handleClick('BlockchainAnalytics'),
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7100960ba4ee1f97$export$cbe66ba5a24d87ce), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $19d59dfd9935476a$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $7100960ba4ee1f97$export$b381d9a2f3b4390b), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7100960ba4ee1f97$export$41ac0950c7d0e9ed), {
                                                children: "Blockchain Analytics"
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7100960ba4ee1f97$export$b774ce8d8a47645), {
                                                children: "Identify, assess, and mitigate associated financial crime risks."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $7100960ba4ee1f97$export$ee0e52d575fd6e30), {
                                active: currentOption === 'RestAPI',
                                onClick: ()=>handleClick('RestAPI'),
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7100960ba4ee1f97$export$cbe66ba5a24d87ce), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e058efc2e539884c$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $7100960ba4ee1f97$export$b381d9a2f3b4390b), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7100960ba4ee1f97$export$41ac0950c7d0e9ed), {
                                                children: "Rest API"
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7100960ba4ee1f97$export$b774ce8d8a47645), {
                                                children: "Integrate a variety of crypto compliance modules with diverse capabilities."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $7100960ba4ee1f97$export$ee0e52d575fd6e30), {
                                active: currentOption === 'ReportingHub',
                                onClick: ()=>handleClick('ReportingHub'),
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7100960ba4ee1f97$export$cbe66ba5a24d87ce), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ec0fe6bec41c92eb$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $7100960ba4ee1f97$export$b381d9a2f3b4390b), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7100960ba4ee1f97$export$41ac0950c7d0e9ed), {
                                                children: "Reporting Hub"
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7100960ba4ee1f97$export$b774ce8d8a47645), {
                                                children: "Generate audit-ready reports by reconciling necessary information across modules."
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    !isLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $85a23adae7b840a5$export$2e2bcd8739ae039), {
                        embedId: IdMapping[currentOption]
                    })
                ]
            }),
            isLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $647b8bc68ebce54f$export$2e2bcd8739ae039), {})
        ]
    });
}
// Default Props
$8bdc7d9cd8082343$var$ExploreAccountModal.defaultProps = {
    ui: {},
    form: {},
    actions: {}
};
// Proptypes Validation
$8bdc7d9cd8082343$var$ExploreAccountModal.propTypes = {
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isExploreAccountModalOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
        infoModalDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            title: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            content: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            loading: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
        })
    }),
    form: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        activityToRemove: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            hash: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
        })
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        toggleExploreAccountModalOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setInfoModalDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $8bdc7d9cd8082343$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($8bdc7d9cd8082343$var$mapStateToProps, $8bdc7d9cd8082343$var$mapDispatchToProps)($8bdc7d9cd8082343$var$ExploreAccountModal);


var $2277dfca698709e1$export$2e2bcd8739ae039 = (0, $8bdc7d9cd8082343$export$2e2bcd8739ae039);


/* eslint-disable jsx-a11y/anchor-is-valid */ /* eslint-disable react/prop-types */ 
parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");






const $1e5c55298bb0cb75$export$47042699470e17dd = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-end;
`;
const $1e5c55298bb0cb75$export$e833dfe35f2086ee = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;
const $1e5c55298bb0cb75$export$6ce170286acaa8d3 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 30px;
  width: 100%;
  max-width: 350px;
  min-height: 550px;
  height: 100%;
  padding: 30px;
  background-color: ${({ theme: theme })=>theme.colors.background};
  border-radius: 0 15px 15px 0;
`;
const $1e5c55298bb0cb75$export$f99233281efd08a0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h2`
  font-size: 22px;
  font-weight: 700;
  color: ${({ theme: theme })=>theme.colors.primary};
  margin: 0 0 0px 0;
`;
const $1e5c55298bb0cb75$export$5f1af8db9871e1d6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  font-size: 14px;
  font-weight: 400;
  margin: 0;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $1e5c55298bb0cb75$export$bc861d1d309c6919 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin: 20px 0 30px 0;
`;
const $1e5c55298bb0cb75$export$d90f6020cde09c5e = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  gap: 10px;
`;
const $1e5c55298bb0cb75$export$d53c836cccbb0d90 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: flex-start;
  gap: 15px;
  width: 100%;

  & a {
    width: 100%;
  }
`;
const $1e5c55298bb0cb75$export$a6c7ac8248d6e38a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).a`
  color: ${({ theme: theme })=>theme.colors.brand};

  & button {
    min-height: 40px;
    margin: 20px 0px 0px 0px;
  }
`;


// Map Redux Props
const $efa2db4d1415568f$var$mapStateToProps = (state)=>state;
const $efa2db4d1415568f$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $efa2db4d1415568f$var$UpgradeModal(props) {
    // Destructure
    const { ui: ui, actions: actions } = props;
    // Store State
    const { isUpgradeModalOpen: isUpgradeModalOpen } = ui;
    // Store Actions
    const { toggleUpgradeModal: toggleUpgradeModal } = actions;
    // Functions
    const toggleModal = ()=>{
        toggleUpgradeModal();
    };
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $0cb604e8ac00d438$export$2e2bcd8739ae039), {
        isOpen: isUpgradeModalOpen,
        toggle: toggleModal,
        style: {
            maxWidth: '800px',
            width: '100%'
        },
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1e5c55298bb0cb75$export$e833dfe35f2086ee), {
            style: {
                backgroundImage: `url(${(0, {})})`,
                borderRadius: '15px'
            },
            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $1e5c55298bb0cb75$export$6ce170286acaa8d3), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1e5c55298bb0cb75$export$f99233281efd08a0), {
                        children: "Simplify compliance in one-click"
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1e5c55298bb0cb75$export$5f1af8db9871e1d6), {
                        children: "Upgrade to one of our plans to streamline compliance management and unlock powerful tools designed for digital asset businesses."
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $1e5c55298bb0cb75$export$bc861d1d309c6919), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $1e5c55298bb0cb75$export$d90f6020cde09c5e), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d2d07bb75c367a07$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1e5c55298bb0cb75$export$5f1af8db9871e1d6), {
                                        children: "Multiple users"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $1e5c55298bb0cb75$export$d90f6020cde09c5e), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d2d07bb75c367a07$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1e5c55298bb0cb75$export$5f1af8db9871e1d6), {
                                        children: "Automated Travel Rule compliance"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $1e5c55298bb0cb75$export$d90f6020cde09c5e), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d2d07bb75c367a07$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1e5c55298bb0cb75$export$5f1af8db9871e1d6), {
                                        children: "Blockchain Analytics Integration"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $1e5c55298bb0cb75$export$d90f6020cde09c5e), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d2d07bb75c367a07$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1e5c55298bb0cb75$export$5f1af8db9871e1d6), {
                                        children: "Custom Reporting Hub"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $1e5c55298bb0cb75$export$d90f6020cde09c5e), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d2d07bb75c367a07$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1e5c55298bb0cb75$export$5f1af8db9871e1d6), {
                                        children: "Accounts Directory Access"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $1e5c55298bb0cb75$export$d90f6020cde09c5e), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d2d07bb75c367a07$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1e5c55298bb0cb75$export$5f1af8db9871e1d6), {
                                        children: "API Support"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $1e5c55298bb0cb75$export$d53c836cccbb0d90), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1e5c55298bb0cb75$export$a6c7ac8248d6e38a), {
                                href: "https://www.ospree.io/contact/sales#contactsales",
                                target: "_blank",
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                    variant: "outlined",
                                    fullWidth: true,
                                    children: "Contact Sales"
                                })
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1e5c55298bb0cb75$export$a6c7ac8248d6e38a), {
                                href: "https://www.ospree.io/contact/sales#calendly",
                                target: "_blank",
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                    fullWidth: true,
                                    children: "Upgrade"
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
}
// Default Props
$efa2db4d1415568f$var$UpgradeModal.defaultProps = {
    ui: {},
    actions: {}
};
// Proptypes Validation
$efa2db4d1415568f$var$UpgradeModal.propTypes = {
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isUpgradeModalOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        toggleUpgradeModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $efa2db4d1415568f$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($efa2db4d1415568f$var$mapStateToProps, $efa2db4d1415568f$var$mapDispatchToProps)($efa2db4d1415568f$var$UpgradeModal);


var $ffe00bd7b05a71fe$export$2e2bcd8739ae039 = (0, $efa2db4d1415568f$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");





// Map Redux Props
const $dded0b3c6e71f899$var$mapStateToProps = (state)=>state;
const $dded0b3c6e71f899$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $dded0b3c6e71f899$var$RequestVaspModal(props) {
    // Destructure
    const { ui: ui, actions: actions } = props;
    // Store State
    const { isRequestVaspModalOpen: isRequestVaspModalOpen } = ui;
    // Store Actions
    const { setIsRequestVaspModalOpen: setIsRequestVaspModalOpen } = actions;
    // Local State
    const [isPushRequest, setIsPushRequest] = (0, $tZqWC.useState)(false);
    const [email, setEmail] = (0, $tZqWC.useState)();
    // Functions
    const toggleModal = ()=>{
        setIsRequestVaspModalOpen();
    };
    (0, $tZqWC.useEffect)(()=>{
        if (!isRequestVaspModalOpen) {
            setIsPushRequest(false);
            setEmail('');
        }
    }, [
        isRequestVaspModalOpen
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $0cb604e8ac00d438$export$2e2bcd8739ae039), {
        isOpen: isRequestVaspModalOpen,
        toggle: toggleModal,
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6e660ada3ebfb268$export$2e2bcd8739ae039), {
                toggle: toggleModal,
                children: "Request for VASP"
            }),
            !isPushRequest && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5a83d1c72fcd9217$export$2e2bcd8739ae039), {
                style: {
                    maxWidth: '400px'
                },
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $97ac3898fcb3436a$export$2e2bcd8739ae039), {
                    setIsPushRequest: setIsPushRequest,
                    setEmail: setEmail
                })
            }),
            isPushRequest && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5a83d1c72fcd9217$export$2e2bcd8739ae039), {
                style: {
                    maxWidth: '400px'
                },
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $076ca81696c49923$export$2e2bcd8739ae039), {
                    setIsPushRequest: setIsPushRequest,
                    email: email
                })
            })
        ]
    });
}
// Default Props
$dded0b3c6e71f899$var$RequestVaspModal.defaultProps = {
    ui: {},
    form: {},
    actions: {}
};
// Proptypes Validation
$dded0b3c6e71f899$var$RequestVaspModal.propTypes = {
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isRequestVaspModalOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
        approveVaspDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            vasp_name: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            vasp_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
        })
    }),
    form: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        activityToRemove: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            hash: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
        })
    }),
    address: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        addressRemove: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            address_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
        })
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setIsRequestVaspModalOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAddressRemove: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $dded0b3c6e71f899$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($dded0b3c6e71f899$var$mapStateToProps, $dded0b3c6e71f899$var$mapDispatchToProps)($dded0b3c6e71f899$var$RequestVaspModal);


var $4d4ef17600b059b2$export$2e2bcd8739ae039 = (0, $dded0b3c6e71f899$export$2e2bcd8739ae039);


/* eslint-disable jsx-a11y/anchor-is-valid */ /* eslint-disable react/prop-types */ 

var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");





const $3321a36e6fafabc9$export$e6dfd72ab29f8598 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 20px;
  width: 100%;
`;
const $3321a36e6fafabc9$export$cf345ef34cd72655 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 16px;
`;
const $3321a36e6fafabc9$export$97ddd2af6308ba2 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  color: ${({ theme: theme })=>theme.colors.primary};
  width: 100%;
`;
const $3321a36e6fafabc9$export$b1d97b9d6e698468 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: ${({ theme: theme })=>theme.colors.primary};
  // Themed Properties
`;
const $3321a36e6fafabc9$export$9fc98b514229b55b = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: 100%;
  display: grid;
  grid-template-columns: 30px 1fr 5px;
  justify-content: center;
  align-items: center;
  background: ${({ theme: theme })=>theme.colors.backgroundLite};
  border-radius: 10px;
  padding: 5px 20px 5px 20px;

  transition: 0.3s;
  border: 1px solid ${({ theme: theme })=>`${theme.colors.backgroundLite}`};
  &:hover {
    border: 1px solid ${({ theme: theme })=>`${theme.colors.brand}40`};
  }
  & input {
    background: ${({ theme: theme })=>theme.colors.backgroundLite};
    border: none;
    padding: 15px 20px 15px 15px;
  }
  & svg {
    stroke: ${({ theme: theme })=>theme.colors.primary};
  }
  & svg > path {
    stroke: ${({ theme: theme })=>theme.colors.primary};
  }
  & #addressSearchOptionsProvider {
    & > div > div:nth-child(3) {
      min-width: 160px;
      border-radius: 10px;
      & > div > div {
        padding: 8px 12px;
      }
    }
  }
  & #addressSearchOptionsChain {
    & > div > div:nth-child(3) {
      min-width: 160px;
      border-radius: 10px;
      & > div > div {
        padding: 8px 12px;
        & svg {
          min-width: 25px;
          stroke: transparent;
          & path {
            stroke: ${({ theme: theme })=>theme.colors.brand};
          }
        }
      }
    }
  }
`;
const $3321a36e6fafabc9$export$a694082daf370b76 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-end;
`;
const $3321a36e6fafabc9$export$550fc938a73ef6b7 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 5px;

  background-color: ${({ theme: theme })=>theme.colors.background};
  border: 1px solid ${({ theme: theme })=>theme.colors.backgroundLite};
  padding: 20px 10px;
  border-radius: 10px;
  max-height: 600px;
  overflow-y: auto;
  margin-top: 15px;
`;
const $3321a36e6fafabc9$export$4b7e9f77c6f037f1 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  cursor: pointer;
  font-weight: 400;
  padding: 5px 10px;
  border-radius: 7px;

  &:hover {
    background-color: ${({ theme: theme, disabled: disabled })=>!disabled && theme.colors.backgroundLite};
  }
  border: ${({ theme: theme, active: active })=>active && `1px solid ${theme.colors.brand}`};
  border-radius: 8px;
`;
const $3321a36e6fafabc9$export$f99233281efd08a0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h2`
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  /* margin: 15px 0 0 15px; */
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $3321a36e6fafabc9$export$67706c264edf13ca = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px 20px;
`;
const $3321a36e6fafabc9$export$b5fbeb65832ce537 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  /* display: flex;
  max-width: 100%;
  overflow-x: auto; */
  padding: 10px 0;
  gap: 5px;

  & button {
    white-space: nowrap;
    word-break: keep-all;
    overflow-wrap: normal;
    text-transform: capitalize;
    font-size: 14px !important;
    padding: 5px 15px;
    width: 100%;
  }
`;
const $3321a36e6fafabc9$export$bc7adc8ef74607f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex: 1;

  & > div {
    width: 100%;
  }
`;





// Map Redux Props
const $6a39c9f81726c579$var$mapStateToProps = (state)=>state;
const $6a39c9f81726c579$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $6a39c9f81726c579$var$AddressSearchModal(props) {
    // Destructure
    const { ui: ui, actions: actions, address: address } = props;
    // Store State
    const { isAddressSearchModalOpen: isAddressSearchModalOpen } = ui;
    const { addressSearchDetails: addressSearchDetails, addressChains: addressChains } = address;
    // Store Actions
    const { setIsAddressSearchModalOpen: setIsAddressSearchModalOpen, setAddressSearchDetails: setAddressSearchDetails, showAlert: showAlert, setScannedAddress: setScannedAddress } = actions;
    // local states
    const [addressInput, setAddressInput] = (0, $tZqWC.useState)('');
    const [chain, setChain] = (0, $tZqWC.useState)('');
    const [chainSymbol, setChainSymbol] = (0, $tZqWC.useState)('');
    const [selectedProvider, setSelectedProvider] = (0, $tZqWC.useState)();
    const [allChains, setAllChains] = (0, $tZqWC.useState)();
    const [availableChains, setAvailableChains] = (0, $tZqWC.useState)();
    const [isSelfHosted, setIsSelfHosted] = (0, $tZqWC.useState)(false);
    const [scanForRisk, setScanForRisk] = (0, $tZqWC.useState)();
    const [isForcedRender, forceRender] = (0, $tZqWC.useState)();
    const isModal = !!addressSearchDetails?.link_id;
    // Refs
    const textInputRef = (0, $tZqWC.useRef)();
    // hooks
    const { createOrUpdateAddress: createOrUpdateAddress, createOrUpdateAddressData: createOrUpdateAddressData, createOrUpdateAddressError: createOrUpdateAddressError, isCreateOrUpdateAddressLoading: isCreateOrUpdateAddressLoading } = (0, $b297ef53431cfca8$export$2e2bcd8739ae039)();
    const [userCredentials] = (0, $a9c50ebe96619b20$export$2e2bcd8739ae039)('userCredentials', {});
    const [csi] = (0, $tZqWC.useState)((0, $60e52eb6c2680325$export$96c4cef8dff1bd45)());
    // Functions
    const toggleModal = ()=>{
        setAddressSearchDetails({
            link_id: null,
            link_type: null
        });
        setIsAddressSearchModalOpen();
    };
    function handleSubmit() {
        const firstChild = Object.keys(availableChains?.[selectedProvider])[0];
        const firstChain = availableChains?.[selectedProvider]?.[firstChild];
        const provider_id = firstChain?.provider_id;
        const requestData = {
            address: addressInput,
            chain: chain,
            name_first: userCredentials.name_first,
            name_last: userCredentials.name_last,
            provider_id: provider_id,
            is_self_hosted: isSelfHosted
        };
        if (scanForRisk === false) requestData.scan_for_risk = scanForRisk;
        if (addressSearchDetails?.link_id && addressSearchDetails?.link_type) {
            requestData.link_id = addressSearchDetails?.link_id;
            requestData.link_type = addressSearchDetails?.link_type;
        }
        createOrUpdateAddress(requestData);
        setAddressInput('');
        setChain('');
        setChainSymbol();
        setSelectedProvider();
        setIsSelfHosted();
        setScanForRisk();
    }
    function handleRegister() {
        const requestData = {
            address: addressInput,
            chain: chain,
            name_first: userCredentials.name_first,
            name_last: userCredentials.name_last,
            is_self_hosted: isSelfHosted,
            scan_for_risk: false
        };
        if (addressSearchDetails?.link_id && addressSearchDetails?.link_type) {
            requestData.link_id = addressSearchDetails?.link_id;
            requestData.link_type = addressSearchDetails?.link_type;
        }
        createOrUpdateAddress(requestData);
        setAddressInput('');
        setChain('');
        setChainSymbol();
        setSelectedProvider();
        setIsSelfHosted();
        setScanForRisk();
    }
    function handleAddressChange(inputValue) {
        setAddressInput(inputValue);
    }
    function handleAvailableChains() {
        const providers = {
            FDBDM: {
                ...addressChains?.financial?.FDBDM
            },
            ...addressChains?.risk
        };
        const allChains = {};
        let literallyAllChains = {};
        Object.keys(providers).forEach((providerCode)=>{
            Object.keys(providers[providerCode]).forEach((chainCode)=>{
                if (providers?.FDBDM?.[chainCode] && providerCode !== 'FDBDM') {
                    allChains[providerCode] = {
                        ...allChains[providerCode],
                        [chainCode]: providers[providerCode][chainCode]
                    };
                    literallyAllChains = {
                        ...literallyAllChains,
                        [chainCode]: providers[providerCode][chainCode]
                    };
                }
            });
        });
        setAvailableChains(allChains);
        setAllChains(literallyAllChains);
    }
    // UseEffects
    (0, $tZqWC.useEffect)(()=>{
        handleAvailableChains();
    }, [
        addressChains
    ]);
    (0, $tZqWC.useEffect)(()=>chain && selectedProvider && addressInput && handleSubmit(), [
        selectedProvider
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (!isAddressSearchModalOpen) {
            setAddressInput('');
            setChain();
            setChainSymbol();
            setIsSelfHosted();
            setScanForRisk();
        }
        if (isAddressSearchModalOpen) forceRender(true);
    }, [
        isAddressSearchModalOpen
    ]);
    (0, $tZqWC.useEffect)(()=>{
        // This is to auto focus to input once modal is opened
        if (isForcedRender) {
            if (textInputRef.current) {
                const inputElement = textInputRef.current?.querySelector('input');
                inputElement?.focus();
            }
            forceRender(null);
        }
    }, [
        isForcedRender
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (createOrUpdateAddressData) {
            setScannedAddress(createOrUpdateAddressData);
            setIsAddressSearchModalOpen();
        }
    }, [
        createOrUpdateAddressData
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (createOrUpdateAddressError) {
            setIsSelfHosted();
            setScanForRisk();
        }
        if (createOrUpdateAddressError?.response?.data?.message) showAlert({
            type: 'error',
            message: createOrUpdateAddressError?.response?.data?.message
        });
        else if (createOrUpdateAddressError) showAlert({
            type: 'error',
            message: 'An error occurred in screening address'
        });
    }, [
        createOrUpdateAddressError
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $0cb604e8ac00d438$export$2e2bcd8739ae039), {
        isOpen: isAddressSearchModalOpen,
        toggle: toggleModal,
        style: {
            width: '100%',
            maxWidth: '900px'
        },
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3321a36e6fafabc9$export$e6dfd72ab29f8598), {
            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3321a36e6fafabc9$export$97ddd2af6308ba2), {
                children: [
                    !isCreateOrUpdateAddressLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3321a36e6fafabc9$export$b1d97b9d6e698468), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3321a36e6fafabc9$export$9fc98b514229b55b), {
                                ref: textInputRef,
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2232f33a3cdf9fa0$export$2e2bcd8739ae039), {
                                        size: 18
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ae78f1d128dc50d5$export$2e2bcd8739ae039), {
                                        placeholder: isCreateOrUpdateAddressLoading ? 'loading...' : 'Screen a wallet address',
                                        value: addressInput,
                                        disabled: isCreateOrUpdateAddressLoading,
                                        onChange: (e)=>handleAddressChange(e.currentTarget.value)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3321a36e6fafabc9$export$550fc938a73ef6b7), {
                                children: [
                                    allChains && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3321a36e6fafabc9$export$67706c264edf13ca), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3321a36e6fafabc9$export$f99233281efd08a0), {
                                                children: "Select Chain"
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3321a36e6fafabc9$export$b5fbeb65832ce537), {
                                                children: Object.keys(allChains)?.map((key)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                                        onClick: ()=>{
                                                            setChainSymbol(key);
                                                            setChain(allChains[key]?.chain_name);
                                                        },
                                                        variant: chainSymbol === key ? 'primary' : 'outlined',
                                                        disabled: !addressInput?.trim(),
                                                        children: allChains[key]?.chain_name
                                                    }, key))
                                            })
                                        ]
                                    }),
                                    allChains && chain && addressInput && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3321a36e6fafabc9$export$bc7adc8ef74607f), {
                                        children: [
                                            isModal && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3321a36e6fafabc9$export$67706c264edf13ca), {
                                                children: [
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3321a36e6fafabc9$export$f99233281efd08a0), {
                                                        children: "Scan For Risk?"
                                                    }),
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3321a36e6fafabc9$export$b5fbeb65832ce537), {
                                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b6cab7af1259ed03$export$2e2bcd8739ae039), {
                                                            onChange: (v)=>{
                                                                if (v === true) setScanForRisk(v);
                                                                else if (v === false) {
                                                                    setScanForRisk(false);
                                                                    handleRegister();
                                                                }
                                                            },
                                                            value: scanForRisk,
                                                            horizontal: true,
                                                            options: [
                                                                {
                                                                    label: 'Yes',
                                                                    value: true,
                                                                    disabled: csi !== 1
                                                                },
                                                                {
                                                                    label: 'No',
                                                                    value: false,
                                                                    disabled: false
                                                                }
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3321a36e6fafabc9$export$67706c264edf13ca), {
                                                children: [
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3321a36e6fafabc9$export$f99233281efd08a0), {
                                                        children: "Is Wallet Self-Hosted?"
                                                    }),
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3321a36e6fafabc9$export$b5fbeb65832ce537), {
                                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b6cab7af1259ed03$export$2e2bcd8739ae039), {
                                                            onChange: (v)=>setIsSelfHosted(v),
                                                            value: isSelfHosted,
                                                            horizontal: true,
                                                            options: [
                                                                {
                                                                    label: 'Yes',
                                                                    value: true
                                                                },
                                                                {
                                                                    label: 'No',
                                                                    value: false
                                                                }
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    allChains && chain && addressInput && (!isModal || scanForRisk) && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3321a36e6fafabc9$export$67706c264edf13ca), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3321a36e6fafabc9$export$f99233281efd08a0), {
                                                children: "Select Provider"
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3321a36e6fafabc9$export$b5fbeb65832ce537), {
                                                children: Object.keys(availableChains)?.map((key)=>{
                                                    if (availableChains?.[key]?.[chainSymbol]) return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                                        onClick: ()=>{
                                                            setSelectedProvider(key);
                                                        },
                                                        variant: selectedProvider === key ? 'primary' : 'outlined',
                                                        children: key
                                                    }, key);
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    isCreateOrUpdateAddressLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3321a36e6fafabc9$export$b1d97b9d6e698468), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a6fa6c8d0625529f$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3321a36e6fafabc9$export$cf345ef34cd72655), {
                                style: {
                                    marginTop: '20px'
                                },
                                children: "This process may take over 60 seconds, depending on the volume of data."
                            })
                        ]
                    })
                ]
            })
        })
    });
}
// Default Props
$6a39c9f81726c579$var$AddressSearchModal.defaultProps = {
    ui: {},
    form: {},
    actions: {}
};
// Proptypes Validation
$6a39c9f81726c579$var$AddressSearchModal.propTypes = {
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isAddressSearchModalOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
        infoModalDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            title: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            content: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            loading: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
        })
    }),
    form: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        activityToRemove: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            hash: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
        })
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setIsAddressSearchModalOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAddressSearchDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $6a39c9f81726c579$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($6a39c9f81726c579$var$mapStateToProps, $6a39c9f81726c579$var$mapDispatchToProps)($6a39c9f81726c579$var$AddressSearchModal);


var $ee40469a5048d704$export$2e2bcd8739ae039 = (0, $6a39c9f81726c579$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");




const $2f71a1adfa2ceedc$export$e833dfe35f2086ee = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  /* grid-template-columns: 1fr 1fr; */
  gap: 30px;
  font-size: 14.5px;
  font-weight: 400;
  width: 100%;
`;
const $2f71a1adfa2ceedc$export$87ad169bde460ddf = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  font-size: 14.5px;
  font-weight: 400;
  width: 100%;
`;
const $2f71a1adfa2ceedc$export$d53c836cccbb0d90 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-end;
  gap: 5px;
  width: 100%;
`;
const $2f71a1adfa2ceedc$export$f99233281efd08a0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  color: ${({ theme: theme })=>theme.colors.primary};
  width: 100%;
  font-size: 20px;
`;
const $2f71a1adfa2ceedc$export$edf27be85e5f6da0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  color: ${({ theme: theme })=>theme.colors.red};
  width: 100%;
  font-size: 20px;
`;
const $2f71a1adfa2ceedc$export$5f1af8db9871e1d6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  color: ${({ theme: theme })=>theme.colors.primary};
  width: 100%;
  font-size: 14px;
`;




// constants
// Map Redux Props
const $cabae64e7abcf97e$var$mapStateToProps = (state)=>state;
const $cabae64e7abcf97e$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $cabae64e7abcf97e$var$AiDocumentUploadModal(props) {
    // Destructure
    const { ui: ui, actions: actions } = props;
    // Store Actions
    const { setIsAiDocumentUploadModalOpen: setIsAiDocumentUploadModalOpen } = actions;
    // Store State
    const { isAiDocumentUploadModalOpen: isAiDocumentUploadModalOpen } = ui;
    // Local State
    const [file, setFile] = (0, $tZqWC.useState)();
    const [didSucceed, setDidSuceed] = (0, $tZqWC.useState)();
    const [didFail, setDidFail] = (0, $tZqWC.useState)();
    const [metadata, setMetadata] = (0, $tZqWC.useState)({
        key: 'value'
    });
    // Refs
    const formRef = (0, $tZqWC.useRef)();
    // Hooks
    const { createDocument: createDocument, createDocumentData: createDocumentData, createDocumentError: createDocumentError, isCreateDocumentLoading: isCreateDocumentLoading } = (0, $6e4f895631b3d5ff$export$2e2bcd8739ae039)();
    // Functions
    const toggleModal = ()=>{
        setIsAiDocumentUploadModalOpen();
    };
    const handleSubmit = ()=>{
        createDocument({
            ...formRef.current?.values,
            file: file
        });
    };
    const handleUploaded = (response)=>{
        if (response) {
            window.location.reload();
            setDidSuceed(true);
        }
    };
    const handleErr = (response)=>{
        if (response) setDidFail(true);
    };
    // UseEffects
    (0, $tZqWC.useEffect)(()=>{
        if (!isAiDocumentUploadModalOpen) setTimeout(()=>{
            setFile();
            setDidSuceed();
            setDidFail();
            setMetadata({
                key: 'value'
            });
            if (formRef?.current) formRef.current.values = '';
        }, 200);
    }, [
        isAiDocumentUploadModalOpen
    ]);
    (0, $tZqWC.useEffect)(()=>{
        handleUploaded(createDocumentData);
    }, [
        createDocumentData
    ]);
    (0, $tZqWC.useEffect)(()=>{
        handleErr(createDocumentError);
    }, [
        createDocumentError
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $0cb604e8ac00d438$export$2e2bcd8739ae039), {
        isOpen: isAiDocumentUploadModalOpen,
        toggle: toggleModal,
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6e660ada3ebfb268$export$2e2bcd8739ae039), {
                toggle: toggleModal,
                children: "CREATE DOCUMENT"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $5a83d1c72fcd9217$export$2e2bcd8739ae039), {
                children: [
                    isCreateDocumentLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2f71a1adfa2ceedc$export$e833dfe35f2086ee), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $647b8bc68ebce54f$export$2e2bcd8739ae039), {})
                    }),
                    !didSucceed && !isCreateDocumentLoading && !didFail && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2f71a1adfa2ceedc$export$e833dfe35f2086ee), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $2f71a1adfa2ceedc$export$87ad169bde460ddf), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $32de1bcd4e009194$export$2e2bcd8739ae039), {
                                    formRef: formRef,
                                    viewMode: false
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ae3239882ade3d6d$export$2e2bcd8739ae039), {
                                    id: "document",
                                    label: "Document",
                                    accept: ".pdf",
                                    onChange: (e)=>setFile(e.target.files[0])
                                })
                            ]
                        })
                    }),
                    didSucceed && !isCreateDocumentLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $2f71a1adfa2ceedc$export$e833dfe35f2086ee), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2f71a1adfa2ceedc$export$f99233281efd08a0), {
                                children: "Successfully Uploaded Document"
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2f71a1adfa2ceedc$export$5f1af8db9871e1d6), {
                                children: "Please refresh the page"
                            })
                        ]
                    }),
                    didFail && !isCreateDocumentLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $2f71a1adfa2ceedc$export$e833dfe35f2086ee), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2f71a1adfa2ceedc$export$edf27be85e5f6da0), {
                                children: "An Error Occurred"
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2f71a1adfa2ceedc$export$5f1af8db9871e1d6), {
                                children: "Please try again later"
                            })
                        ]
                    })
                ]
            }),
            !didSucceed && !isCreateDocumentLoading && !didFail && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b07759276f5d7f2d$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $2f71a1adfa2ceedc$export$d53c836cccbb0d90), {
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                            type: "button",
                            variant: "outlined",
                            onClick: toggleModal,
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                            type: "button",
                            onClick: handleSubmit,
                            children: "Save"
                        })
                    ]
                })
            })
        ]
    });
}
// Default Props
$cabae64e7abcf97e$var$AiDocumentUploadModal.defaultProps = {
    ui: {},
    address: {},
    actions: {}
};
// Proptypes Validation
$cabae64e7abcf97e$var$AiDocumentUploadModal.propTypes = {
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isAiDocumentUploadModalOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    address: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        addressReportDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            address_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            address: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            chain: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
        })
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setIsAiDocumentUploadModalOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAddressReportDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $cabae64e7abcf97e$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($cabae64e7abcf97e$var$mapStateToProps, $cabae64e7abcf97e$var$mapDispatchToProps)($cabae64e7abcf97e$var$AiDocumentUploadModal);


var $69d1d8fa475eba28$export$2e2bcd8739ae039 = (0, $cabae64e7abcf97e$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");



const $01461f9f53168a3e$export$e833dfe35f2086ee = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 14.5px;
  font-weight: 400;
  padding: 0px 0px 20px 0px;
  max-width: 400px;
`;





// Map Redux Props
const $0a48a76d035bef01$var$mapStateToProps = (state)=>state;
const $0a48a76d035bef01$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $0a48a76d035bef01$var$DeleteAiDocModal(props) {
    // Destructure
    const { ui: ui, actions: actions, ai: ai } = props;
    // Store State
    const { isDeleteAiDocModalOpen: isDeleteAiDocModalOpen } = ui;
    const { documentToDeleteID: documentToDeleteID } = ai;
    // Store Actions
    const { toggleDeleteAiDocModalOpen: toggleDeleteAiDocModalOpen, setDocumentToDeleteID: setDocumentToDeleteID } = actions;
    // Hooks
    const { deleteDocument: deleteDocument, deleteDocumentError: deleteDocumentError, isDeleteDocumentLoading: isDeleteDocumentLoading } = (0, $389edad6e0f22d98$export$2e2bcd8739ae039)();
    const history = (0, $a0d5c3f2fe524011$export$3420e1dc2c4a518c)();
    // Functions
    const toggleModal = ()=>{
        toggleDeleteAiDocModalOpen();
    };
    const handleDelete = ()=>{
        deleteDocument({
            document_id: documentToDeleteID
        });
    };
    // UseEffect
    (0, $tZqWC.useEffect)(()=>{
        if (isDeleteAiDocModalOpen) {
            if (!isDeleteDocumentLoading && !deleteDocumentError) {
                setDocumentToDeleteID();
                toggleDeleteAiDocModalOpen();
                history.push('/admin/ai/documents');
            }
        }
    }, [
        isDeleteDocumentLoading
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $0cb604e8ac00d438$export$2e2bcd8739ae039), {
        isOpen: isDeleteAiDocModalOpen,
        toggle: toggleModal,
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6e660ada3ebfb268$export$2e2bcd8739ae039), {
                toggle: toggleModal,
                children: "Delete Document"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $5a83d1c72fcd9217$export$2e2bcd8739ae039), {
                children: [
                    isDeleteDocumentLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $01461f9f53168a3e$export$e833dfe35f2086ee), {
                        children: "Deleting Document..."
                    }),
                    !isDeleteDocumentLoading && !deleteDocumentError && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $01461f9f53168a3e$export$e833dfe35f2086ee), {
                        children: "Are you sure you want to delete this document?"
                    }),
                    !isDeleteDocumentLoading && deleteDocumentError && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $01461f9f53168a3e$export$e833dfe35f2086ee), {
                        children: "An error occurred in deleting document, please try again later."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $b07759276f5d7f2d$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                        fullWidth: true,
                        type: "button",
                        onClick: toggleModal,
                        variant: "outlined",
                        disabled: isDeleteDocumentLoading,
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                        fullWidth: true,
                        type: "button",
                        onClick: handleDelete,
                        color: "secondary",
                        disabled: isDeleteDocumentLoading,
                        children: "Delete"
                    })
                ]
            })
        ]
    });
}
// Default Props
$0a48a76d035bef01$var$DeleteAiDocModal.defaultProps = {
    ui: {},
    form: {},
    actions: {}
};
// Proptypes Validation
$0a48a76d035bef01$var$DeleteAiDocModal.propTypes = {
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isDeleteAiDocModalOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    form: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        activityToRemove: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            hash: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
        })
    }),
    ai: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        documentToDeleteID: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            user_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            is_active: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
        })
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        toggleDeleteAiDocModalOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setDocumentToDeleteID: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $0a48a76d035bef01$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($0a48a76d035bef01$var$mapStateToProps, $0a48a76d035bef01$var$mapDispatchToProps)($0a48a76d035bef01$var$DeleteAiDocModal);


var $549b1e336ae89b24$export$2e2bcd8739ae039 = (0, $0a48a76d035bef01$export$2e2bcd8739ae039);



parcelRequire("tZqWC");


const $66db7561c1b80723$export$eb14d77622ea348d = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: fixed;
  height: 100vh;
  width: 100vw;
  top: 0;

  display: flex;
  justify-content: center;
  align-items: center;
`;
const $66db7561c1b80723$export$5a30a9425f4ff973 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 18px;
  padding: 15px 35px;

  border-radius: 5px;
  background-color: white;
  border: ${({ theme: theme })=>`solid 1px ${theme.colors.backgroundLite}`};
`;


function $7708429b3625dac4$var$LoadingPage() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $66db7561c1b80723$export$eb14d77622ea348d), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $66db7561c1b80723$export$5a30a9425f4ff973), {
            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a6fa6c8d0625529f$export$2e2bcd8739ae039), {})
        })
    });
}
var $7708429b3625dac4$export$2e2bcd8739ae039 = $7708429b3625dac4$var$LoadingPage;


var $120944b12d5f4a62$export$2e2bcd8739ae039 = (0, $7708429b3625dac4$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

const $14d469e3b50c8c0d$export$b685374fb421789a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: fixed;
  height: 100vh;
  width: 100vw;
  top: 0;
  left: 0;

  display: flex;
  justify-content: center;
  align-items: center;
`;
const $14d469e3b50c8c0d$export$195f5480bcc8c49d = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  max-width: 500px;
  border-radius: 10px;
  background-color: ${({ theme: theme })=>theme.colors.background};
  border: ${({ theme: theme })=>`solid 1px ${theme.colors.secondary}`};
`;
const $14d469e3b50c8c0d$export$7a4750f19a624026 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 10px 30px;
  border-bottom: ${({ theme: theme })=>`solid 1px ${theme.colors.secondary}`};
`;
const $14d469e3b50c8c0d$export$ee377b57e77bfb9b = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 50px 30px;
`;
const $14d469e3b50c8c0d$export$288b095a729ca5f8 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  text-align: center;
  font-size: 15px;

  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $14d469e3b50c8c0d$export$e98d2e18340017d2 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  text-align: center;
  font-size: 22px;

  color: ${({ theme: theme })=>theme.colors.primary};
`;


function $bbed925ea79855e0$var$NoAccess() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $14d469e3b50c8c0d$export$b685374fb421789a), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $14d469e3b50c8c0d$export$195f5480bcc8c49d), {
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $14d469e3b50c8c0d$export$7a4750f19a624026), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $14d469e3b50c8c0d$export$e98d2e18340017d2), {
                        children: "Authorization Needed"
                    })
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $14d469e3b50c8c0d$export$ee377b57e77bfb9b), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $14d469e3b50c8c0d$export$288b095a729ca5f8), {
                        children: [
                            "You currently do not have access to this feature. Please contact",
                            ' ',
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("a", {
                                href: "sales@ospree.io",
                                children: "(sales@ospree.io)"
                            }),
                            " for more information."
                        ]
                    })
                })
            ]
        })
    });
}
var $bbed925ea79855e0$export$2e2bcd8739ae039 = $bbed925ea79855e0$var$NoAccess;


var $bb6cb7de1cdd9d3b$export$2e2bcd8739ae039 = (0, $bbed925ea79855e0$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $5795c30de138bdef$export$6ce170286acaa8d3 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: 100%;
  height: fit-content;
  padding: 20px 0 0 0;

  display: flex;
  justify-content: center;
  background-color: ${({ theme: theme })=>theme.colors.backgroundLite};
`;


function $ba9b69b62334fc5f$var$PageWrapper(props) {
    // Destructure
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5795c30de138bdef$export$6ce170286acaa8d3), {
        ...rest,
        children: children
    });
}
// Default Props
$ba9b69b62334fc5f$var$PageWrapper.defaultProps = {
    children: ''
};
// Proptypes Validation
$ba9b69b62334fc5f$var$PageWrapper.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).node
    ])
};
var $ba9b69b62334fc5f$export$2e2bcd8739ae039 = $ba9b69b62334fc5f$var$PageWrapper;


var $14870abc08ac0dc0$export$2e2bcd8739ae039 = (0, $ba9b69b62334fc5f$export$2e2bcd8739ae039);




function $b51c0f66872acd76$var$Login() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $56f847eb01f717d3$export$bfe2969d9faaaa94), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $56f847eb01f717d3$export$6aac6cd983aa9a8d), {
            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $56f847eb01f717d3$export$c316e7f3abbfa73a), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $56f847eb01f717d3$export$1d8d8cae37810421), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $56f847eb01f717d3$export$cac169cfa0d556b7), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $56f847eb01f717d3$export$842695ea3d5549d), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a25394adb640e26c$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $56f847eb01f717d3$export$23f1dea7e159c283), {
                                children: "Sign in to Ospree"
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d2f304e3909f8828$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $56f847eb01f717d3$export$3f9c8c13edb92928), {
                                children: [
                                    "Want to get started?\xa0\xa0",
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $56f847eb01f717d3$export$fb3d2bca71e46662), {
                                        href: "https://ospree.io/",
                                        children: "Contact us here"
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        })
    });
}
// Default Props
$b51c0f66872acd76$var$Login.defaultProps = {};
// Proptypes Validation
$b51c0f66872acd76$var$Login.propTypes = {};
var $b51c0f66872acd76$export$2e2bcd8739ae039 = $b51c0f66872acd76$var$Login;


var $dd22bf1c377d691b$export$2e2bcd8739ae039 = (0, $b51c0f66872acd76$export$2e2bcd8739ae039);



parcelRequire("tZqWC");


const $98df2b1776857cf4$export$3763cdd84c6ceb2b = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  min-height: 100vh;
  background: ${({ theme: theme })=>theme.colors.brand};
  background: ${({ theme: theme })=>`linear-gradient(25deg, ${theme.colors.backgroundLite} 65%, ${theme.colors.brand} 130%)`};
`;
const $98df2b1776857cf4$export$1e20b427c093fd18 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const $98df2b1776857cf4$export$4dce4db2db3643ed = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  flex: 1;
  display: flex;
  justify-content: center;
`;
const $98df2b1776857cf4$export$14506397c75c0051 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  max-width: 500px;
  width: 100%;
`;
const $98df2b1776857cf4$export$b7b387941c80a521 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 40px;
  width: 100%;

  border-radius: 10px;
`;
const $98df2b1776857cf4$export$7dd195deab256116 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).a`
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
  & svg {
    width: 150px;
    height: 50px;
    & path {
      fill: ${({ theme: theme })=>theme.colors.primary};
    }
  }
`;
const $98df2b1776857cf4$export$d2147604fa7962f4 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h1`
  display: flex;
  justify-content: center;
  font-size: 18px;
  color: ${({ theme: theme })=>theme.colors.primary};
  margin: 0 0 30px 0;
`;
const $98df2b1776857cf4$export$db36f0b3f55af1d = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  min-height: 100vh;
`;
const $98df2b1776857cf4$export$f8e03ef01883c36c = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  align-self: center;

  //TODO: Style Variable
  color: ${({ theme: theme })=>theme.colors.background};
`;
const $98df2b1776857cf4$export$fdd773f48aebb8ab = (0, $a778141486c79bc3$export$2e2bcd8739ae039).a`
  display: block;
  margin: 20px 0px 0px 0px;
  width: 100%;

  font-weight: 400;
  font-size: 12px;
  text-decoration: underline;
  text-align: center;

  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $98df2b1776857cf4$export$c69382c1ccda0fe3 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  display: flex;
  justify-content: flex-end;
  margin: 5px 0 0 0;

  font-size: 12px;
  color: ${({ theme: theme })=>theme.colors.primary};
  text-align: right;
`;
const $98df2b1776857cf4$export$69bb84e1d7048334 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).a`
  font-weight: 500;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $98df2b1776857cf4$export$6593ac2583e007ee = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  margin: 0;
  font-size: 16px;
  color: ${({ theme: theme })=>theme.colors.primary};
  text-align: center;
  margin: 0 0 30px 0;
`;



function $4cae849d90bcda8e$var$ResetPassword() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $98df2b1776857cf4$export$3763cdd84c6ceb2b), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $98df2b1776857cf4$export$1e20b427c093fd18), {
            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $98df2b1776857cf4$export$4dce4db2db3643ed), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $98df2b1776857cf4$export$14506397c75c0051), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $98df2b1776857cf4$export$b7b387941c80a521), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $98df2b1776857cf4$export$7dd195deab256116), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a25394adb640e26c$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $98df2b1776857cf4$export$d2147604fa7962f4), {
                                children: "Reset Password"
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $fde1b0c5eccb6a06$export$2e2bcd8739ae039), {})
                        ]
                    })
                })
            })
        })
    });
}
// Default Props
$4cae849d90bcda8e$var$ResetPassword.defaultProps = {};
// Proptypes Validation
$4cae849d90bcda8e$var$ResetPassword.propTypes = {};
var $4cae849d90bcda8e$export$2e2bcd8739ae039 = $4cae849d90bcda8e$var$ResetPassword;


var $c0fe5e608582cef7$export$2e2bcd8739ae039 = (0, $4cae849d90bcda8e$export$2e2bcd8739ae039);



parcelRequire("tZqWC");


const $a88b389a4b2557b6$export$66da6640486c89ec = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  min-height: 100vh;
  background: ${({ theme: theme })=>theme.colors.brand};
  background: ${({ theme: theme })=>`linear-gradient(25deg, ${theme.colors.backgroundLite} 65%, ${theme.colors.brand} 130%)`};
`;
const $a88b389a4b2557b6$export$986c39d712b74ff5 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const $a88b389a4b2557b6$export$b273d0d511b6c12f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  flex: 1;
  display: flex;
  justify-content: center;
`;
const $a88b389a4b2557b6$export$96638f488ffabe83 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  max-width: 500px;
  width: 100%;
`;
const $a88b389a4b2557b6$export$f314756fd443d3df = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 40px;
  width: 100%;

  border-radius: 10px;
`;
const $a88b389a4b2557b6$export$3b755af8e8c34628 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).a`
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
  & svg {
    width: 150px;
    height: 50px;
    & path {
      fill: ${({ theme: theme })=>theme.colors.primary};
    }
  }
`;
const $a88b389a4b2557b6$export$12f28ef8a45f7850 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h1`
  display: flex;
  justify-content: center;
  font-size: 18px;
  color: ${({ theme: theme })=>theme.colors.primary};
  margin: 0 0 30px 0;
`;
const $a88b389a4b2557b6$export$375959c29404a9b5 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  min-height: 100vh;
`;
const $a88b389a4b2557b6$export$cee3b4ce817de6ef = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  align-self: center;

  //TODO: Style Variable
  color: ${({ theme: theme })=>theme.colors.background};
`;
const $a88b389a4b2557b6$export$fdd773f48aebb8ab = (0, $a778141486c79bc3$export$2e2bcd8739ae039).a`
  display: block;
  margin: 20px 0px 0px 0px;
  width: 100%;

  font-weight: 400;
  font-size: 12px;
  text-decoration: underline;
  text-align: center;

  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $a88b389a4b2557b6$export$56419e5665352fd4 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  display: flex;
  justify-content: flex-end;
  margin: 5px 0 0 0;

  font-size: 12px;
  color: ${({ theme: theme })=>theme.colors.primary};
  text-align: right;
`;
const $a88b389a4b2557b6$export$8f64cec52b385445 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).a`
  font-weight: 500;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $a88b389a4b2557b6$export$6593ac2583e007ee = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  margin: 0;
  font-size: 16px;
  color: ${({ theme: theme })=>theme.colors.primary};
  text-align: center;
  margin: 0 0 30px 0;
`;



function $66ab103b940e3bac$var$ResetPasswordConfirm() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a88b389a4b2557b6$export$66da6640486c89ec), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a88b389a4b2557b6$export$986c39d712b74ff5), {
            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a88b389a4b2557b6$export$b273d0d511b6c12f), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a88b389a4b2557b6$export$96638f488ffabe83), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $a88b389a4b2557b6$export$f314756fd443d3df), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a88b389a4b2557b6$export$3b755af8e8c34628), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a25394adb640e26c$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a88b389a4b2557b6$export$12f28ef8a45f7850), {
                                children: "Reset Password"
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $464ed6b5b17fc61c$export$2e2bcd8739ae039), {})
                        ]
                    })
                })
            })
        })
    });
}
// Default Props
$66ab103b940e3bac$var$ResetPasswordConfirm.defaultProps = {};
// Proptypes Validation
$66ab103b940e3bac$var$ResetPasswordConfirm.propTypes = {};
var $66ab103b940e3bac$export$2e2bcd8739ae039 = $66ab103b940e3bac$var$ResetPasswordConfirm;


var $344dbf985b87386c$export$2e2bcd8739ae039 = (0, $66ab103b940e3bac$export$2e2bcd8739ae039);



parcelRequire("tZqWC");



const $7286a4f30ed6f8f7$export$c59ec66ce0f5a28f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: fixed;
  top: 0;
  width: 100vw;
  height: 100vh;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme: theme })=>theme.colors.backgroundLite};
`;
const $7286a4f30ed6f8f7$export$47b6a1ddefa0a04 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  color: ${({ theme: theme })=>theme.colors.brand};
  font-size: 24px;
  font-weight: 600;
`;
const $7286a4f30ed6f8f7$export$f6e751b25abbfdbb = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 14px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $7286a4f30ed6f8f7$export$73cc7b3e8ae70e11 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
`;
const $7286a4f30ed6f8f7$export$14da99dbf3cc1278 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 35px;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;

  border: 1px solid ${({ theme: theme })=>theme.colors.backgroundLite};
  border-radius: 10px;
  background-color: ${({ theme: theme })=>theme.colors.background};
`;


function $721e18df88e49b9c$var$NotFound() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $7286a4f30ed6f8f7$export$c59ec66ce0f5a28f), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $12b33660068e86aa$export$b0d92dbee9b5b60d), {
                to: "/",
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7286a4f30ed6f8f7$export$73cc7b3e8ae70e11), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a25394adb640e26c$export$2e2bcd8739ae039), {})
                })
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7286a4f30ed6f8f7$export$f6e751b25abbfdbb), {
                style: {
                    marginTop: '10px'
                },
                children: "Error 404: The destination you are trying to access does not exist."
            })
        ]
    });
}
// Default Props
$721e18df88e49b9c$var$NotFound.defaultProps = {};
// Proptypes Validation
$721e18df88e49b9c$var$NotFound.propTypes = {};
var $721e18df88e49b9c$export$2e2bcd8739ae039 = $721e18df88e49b9c$var$NotFound;


var $d549f3728d941dad$export$2e2bcd8739ae039 = (0, $721e18df88e49b9c$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");






const $7fe5eb48fc2c123b$export$e6dfd72ab29f8598 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: 100%;
  padding: 20px 30px 35px 30px;
  border-radius: 10px;
  background-color: ${({ theme: theme })=>theme.colors.background};
`;
const $7fe5eb48fc2c123b$export$2d9f66e60a04069a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: 100%;
`;
const $7fe5eb48fc2c123b$export$f7572adddafd5ab7 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-end;
  gap: 20px;
  margin-top: 40px;
`;
const $7fe5eb48fc2c123b$export$bc7adc8ef74607f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  min-height: 80px;
  padding: 0 40px 0 0;
  border-bottom: 2px solid ${({ theme: theme })=>theme.colors.backgroundLite};

  & button {
    border-radius: 5px;
  }
`;
const $7fe5eb48fc2c123b$export$a9754b3c8daa5172 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 25px;
  min-width: 200px;

  // overwriting select component
  & div > div {
    margin: 0 !important;
  }
  & button {
    padding: 12px;
    border-radius: 10px;
  }
`;
const $7fe5eb48fc2c123b$export$87ad169bde460ddf = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
const $7fe5eb48fc2c123b$export$f99233281efd08a0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h2`
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $7fe5eb48fc2c123b$export$5f1af8db9871e1d6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  margin: 0;
  font-size: 11px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $7fe5eb48fc2c123b$export$d53c836cccbb0d90 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).a`
  width: 100%;
`;




// Map Redux Props
const $52c1cc12d0a88b4c$var$mapStateToProps = (state)=>state;
const $52c1cc12d0a88b4c$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $52c1cc12d0a88b4c$var$UserDetails(props) {
    // Destructure
    const { actions: actions } = props;
    const { user_id: user_id } = (0, $a0d5c3f2fe524011$export$99eaa27ddbbb95ef)();
    // store actions
    const { setShowHeaderLoader: setShowHeaderLoader, showAlert: showAlert } = actions;
    // refs
    const formRef = (0, $tZqWC.useRef)();
    // hooks
    const { getUser: getUser, getUserData: getUserData, isGetUserLoading: isGetUserLoading } = (0, $89db55cadf8da1af$export$2e2bcd8739ae039)();
    const { updateProfile: updateProfile, updateProfileData: updateProfileData, isUpdateProfileLoading: isUpdateProfileLoading, isUpdateProfileSuccess: isUpdateProfileSuccess, isUpdateProfileError: isUpdateProfileError } = (0, $60d2f030b368f304$export$2e2bcd8739ae039)();
    // state
    const [userDataState, setUserDataState] = (0, $tZqWC.useState)();
    const [viewMode, setViewMode] = (0, $tZqWC.useState)(true);
    const [page, setPage] = (0, $tZqWC.useState)(0);
    const [csi] = (0, $tZqWC.useState)((0, $60e52eb6c2680325$export$96c4cef8dff1bd45)());
    // functions
    const fetchData = ()=>{
        getUser({
            user_id: user_id
        });
    };
    const handleSave = ()=>{
        setViewMode(true);
        const newPayload = formRef.current.values;
        setUserDataState({
            ...userDataState,
            ...newPayload
        });
        updateProfile({
            user_id: user_id,
            data: newPayload
        });
    };
    const handle2faSave = (value)=>{
        updateProfile({
            user_id: user_id,
            data: {
                ...userDataState,
                has_2fa: value
            }
        });
    };
    const handleCancel = ()=>{
        setViewMode(true);
        if (updateProfileData) setUserDataState(updateProfileData);
        else if (getUserData) setUserDataState(getUserData);
    };
    const handleLoadingUpdateChange = ()=>{
        if (isUpdateProfileLoading) {
            setShowHeaderLoader(true);
            setUserDataState();
        }
        if (!isUpdateProfileLoading) {
            if (updateProfileData) setUserDataState(updateProfileData);
            if (isUpdateProfileError) showAlert({
                type: 'error',
                message: 'An error occurred, please refresh the page.'
            });
            if (isUpdateProfileSuccess) showAlert({
                type: 'success',
                message: 'Successfully updated record.'
            });
            setShowHeaderLoader(false);
        }
    };
    const handleLoadingUser = ()=>{
        if (isGetUserLoading) setShowHeaderLoader(true);
        if (!isGetUserLoading) setShowHeaderLoader(false);
    };
    // useEffect
    (0, $tZqWC.useEffect)(()=>fetchData(), []);
    (0, $tZqWC.useEffect)(()=>{
        if (getUserData) setUserDataState(getUserData);
    }, [
        getUserData
    ]);
    (0, $tZqWC.useEffect)(()=>handleLoadingUser(), [
        isGetUserLoading
    ]);
    (0, $tZqWC.useEffect)(()=>handleLoadingUpdateChange(), [
        isUpdateProfileLoading
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $7873b6261a2b1051$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $802ca450e3f2144f$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5387bf8dccf722e4$export$2e2bcd8739ae039), {
                pageTitle: "User Profile"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b27722fc7d4f5ccf$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $14870abc08ac0dc0$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d9a5995c1b70ae93$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $7fe5eb48fc2c123b$export$e6dfd72ab29f8598), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6873d084d47f7441$export$2e2bcd8739ae039), {
                                    page: page,
                                    setPage: setPage
                                }),
                                isUpdateProfileLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $647b8bc68ebce54f$export$2e2bcd8739ae039), {}),
                                page === 0 && !isGetUserLoading && userDataState && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $7fe5eb48fc2c123b$export$2d9f66e60a04069a), {
                                    children: [
                                        !isUpdateProfileLoading && userDataState && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $32fbb81f19fb7caa$export$2e2bcd8739ae039), {
                                            viewMode: viewMode,
                                            formRef: formRef,
                                            values: userDataState
                                        }),
                                        viewMode === true && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7fe5eb48fc2c123b$export$f7572adddafd5ab7), {
                                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                                color: "primary",
                                                onClick: ()=>setViewMode(false),
                                                children: "Edit"
                                            })
                                        }),
                                        viewMode === false && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $7fe5eb48fc2c123b$export$f7572adddafd5ab7), {
                                            children: [
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                                    onClick: handleCancel,
                                                    variant: "outlined",
                                                    children: "Cancel"
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                                    onClick: handleSave,
                                                    children: "save"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                page === 1 && !isGetUserLoading && userDataState && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $7fe5eb48fc2c123b$export$2d9f66e60a04069a), {
                                    style: {
                                        marginTop: '-20px'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $7fe5eb48fc2c123b$export$bc7adc8ef74607f), {
                                            children: [
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $7fe5eb48fc2c123b$export$87ad169bde460ddf), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7fe5eb48fc2c123b$export$f99233281efd08a0), {
                                                            children: "Enable Two Factor Authentication"
                                                        }),
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $7fe5eb48fc2c123b$export$5f1af8db9871e1d6), {
                                                            children: [
                                                                !userDataState?.is_verified && 'Email needs to be verified.',
                                                                " A login link will be sent to your email every login attempt."
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7fe5eb48fc2c123b$export$a9754b3c8daa5172), {
                                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $47c62aa7410890bd$export$2e2bcd8739ae039), {
                                                        value: userDataState?.has_2fa,
                                                        placeholder: userDataState?.has_2fa ? 'On' : 'Off',
                                                        onChange: (value)=>{
                                                            handle2faSave(value);
                                                        },
                                                        disabled: !userDataState?.is_verified || csi !== 1,
                                                        options: [
                                                            {
                                                                value: true,
                                                                label: 'On'
                                                            },
                                                            {
                                                                value: false,
                                                                label: 'Off'
                                                            }
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $7fe5eb48fc2c123b$export$bc7adc8ef74607f), {
                                            children: [
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $7fe5eb48fc2c123b$export$87ad169bde460ddf), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7fe5eb48fc2c123b$export$f99233281efd08a0), {
                                                            children: "Password"
                                                        }),
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7fe5eb48fc2c123b$export$5f1af8db9871e1d6), {
                                                            children: "Update your password"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7fe5eb48fc2c123b$export$a9754b3c8daa5172), {
                                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7fe5eb48fc2c123b$export$d53c836cccbb0d90), {
                                                        href: "/update_password",
                                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                                            fullWidth: true,
                                                            children: "Update"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
}
// Default Props
$52c1cc12d0a88b4c$var$UserDetails.defaultProps = {
    actions: {},
    filters: {},
    ui: {}
};
// Proptypes Validation
$52c1cc12d0a88b4c$var$UserDetails.propTypes = {
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        userDirectoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object)
    }),
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setUserDirectoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsIndividualUserDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsEntityUserDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $52c1cc12d0a88b4c$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($52c1cc12d0a88b4c$var$mapStateToProps, $52c1cc12d0a88b4c$var$mapDispatchToProps)($52c1cc12d0a88b4c$var$UserDetails);


var $cd03c9b9c8639b1e$export$2e2bcd8739ae039 = (0, $52c1cc12d0a88b4c$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");



var $ejSM7 = parcelRequire("ejSM7");





const $cc15483875f6c75e$export$e6dfd72ab29f8598 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: 100%;
  border-radius: 10px;
  background-color: ${({ theme: theme })=>theme.colors.background};
`;
const $cc15483875f6c75e$export$17b77c57254421ac = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $cc15483875f6c75e$export$bc7adc8ef74607f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  min-height: 80px;
  padding: 0 40px;
  border-bottom: 2px solid ${({ theme: theme })=>theme.colors.backgroundLite};

  & button {
    border-radius: 5px;
  }
`;
const $cc15483875f6c75e$export$a9754b3c8daa5172 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 25px;
  min-width: 200px;

  // overwriting select component
  & div > div {
    margin: 0 !important;
  }
`;
const $cc15483875f6c75e$export$87ad169bde460ddf = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
const $cc15483875f6c75e$export$f99233281efd08a0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h2`
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $cc15483875f6c75e$export$5f1af8db9871e1d6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  margin: 0;
  font-size: 11px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;




// Map Redux Props
const $bc165f8493106cf0$var$mapStateToProps = (state)=>state;
const $bc165f8493106cf0$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $bc165f8493106cf0$var$Settings(props) {
    const { actions: actions } = props;
    // destructuring
    const { toggleInfoModal: toggleInfoModal, setInfoModalDetails: setInfoModalDetails, setIsUserDrawerOpen: setIsUserDrawerOpen } = actions;
    // hooks
    const [page, setPage] = (0, $tZqWC.useState)(0);
    const { search: search } = (0, $a0d5c3f2fe524011$export$45d76561a5302f2b)();
    const [csi] = (0, $tZqWC.useState)((0, $60e52eb6c2680325$export$96c4cef8dff1bd45)());
    const [theme, setTheme] = (0, $a9c50ebe96619b20$export$2e2bcd8739ae039)('theme', 'light');
    const [currentUser] = (0, $a9c50ebe96619b20$export$2e2bcd8739ae039)('userCredentials', {});
    const handleToggleInfo = (title, content)=>{
        setInfoModalDetails({
            title: title,
            content: content
        });
        toggleInfoModal(true);
    };
    const handlePageQuery = ()=>{
        const urlStr = search.split('=');
        if (urlStr.length === 2) setPage(Number(urlStr[1]));
    };
    (0, $tZqWC.useEffect)(()=>handlePageQuery(), [
        search
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $7873b6261a2b1051$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $802ca450e3f2144f$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5387bf8dccf722e4$export$2e2bcd8739ae039), {
                pageTitle: "Settings"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b27722fc7d4f5ccf$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $14870abc08ac0dc0$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d9a5995c1b70ae93$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $cc15483875f6c75e$export$e6dfd72ab29f8598), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c3442c06a63b86ff$export$2e2bcd8739ae039), {
                                    page: page,
                                    setPage: setPage
                                }),
                                page === 0 && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $cc15483875f6c75e$export$17b77c57254421ac), {
                                    children: [
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $cc15483875f6c75e$export$bc7adc8ef74607f), {
                                            children: [
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $cc15483875f6c75e$export$87ad169bde460ddf), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $cc15483875f6c75e$export$f99233281efd08a0), {
                                                            children: "Theme"
                                                        }),
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $cc15483875f6c75e$export$5f1af8db9871e1d6), {
                                                            children: "Select the theme."
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $cc15483875f6c75e$export$a9754b3c8daa5172), {
                                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $47c62aa7410890bd$export$2e2bcd8739ae039), {
                                                        value: theme,
                                                        placeholder: "Select",
                                                        options: [
                                                            {
                                                                value: 'light',
                                                                label: 'Light',
                                                                disabled: true
                                                            },
                                                            {
                                                                value: 'dark',
                                                                label: 'Dark'
                                                            },
                                                            {
                                                                value: 'gray',
                                                                label: 'Gray'
                                                            }
                                                        ],
                                                        onChange: async (value)=>{
                                                            await setTheme(value);
                                                            window.location.reload();
                                                        }
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $cc15483875f6c75e$export$bc7adc8ef74607f), {
                                            children: [
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $cc15483875f6c75e$export$87ad169bde460ddf), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $cc15483875f6c75e$export$f99233281efd08a0), {
                                                            children: "Plan"
                                                        }),
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $cc15483875f6c75e$export$5f1af8db9871e1d6), {
                                                            children: "Business plan."
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $cc15483875f6c75e$export$a9754b3c8daa5172), {
                                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $47c62aa7410890bd$export$2e2bcd8739ae039), {
                                                        value: csi === 1 ? 'active' : 'trial',
                                                        options: [
                                                            {
                                                                value: 'active',
                                                                label: 'Active',
                                                                disabled: true
                                                            },
                                                            {
                                                                value: 'trial',
                                                                label: 'Trial',
                                                                disabled: true
                                                            },
                                                            {
                                                                value: 'inactive',
                                                                label: 'Inactive',
                                                                disabled: true
                                                            }
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $cc15483875f6c75e$export$bc7adc8ef74607f), {
                                            children: [
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $cc15483875f6c75e$export$87ad169bde460ddf), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $cc15483875f6c75e$export$f99233281efd08a0), {
                                                            children: "Terms use"
                                                        }),
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $cc15483875f6c75e$export$5f1af8db9871e1d6), {
                                                            children: "Review the terms and conditions for using Ospree's platform."
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                                    onClick: ()=>window.open((0, $78597906e6a0205e$export$e1b54834f9622113).TERMS_OF_SERVICE, '_blank'),
                                                    children: "Read "
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $cc15483875f6c75e$export$bc7adc8ef74607f), {
                                            children: [
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $cc15483875f6c75e$export$87ad169bde460ddf), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $cc15483875f6c75e$export$f99233281efd08a0), {
                                                            children: "Privacy Policy"
                                                        }),
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $cc15483875f6c75e$export$5f1af8db9871e1d6), {
                                                            children: "Review our Privacy Policy to understand what data we collect, why we collect it, and how it is used."
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                                    onClick: ()=>window.open((0, $78597906e6a0205e$export$e1b54834f9622113).PRIVACY_POLICY, '_blank'),
                                                    children: "Read "
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $cc15483875f6c75e$export$bc7adc8ef74607f), {
                                            children: [
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $cc15483875f6c75e$export$87ad169bde460ddf), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $cc15483875f6c75e$export$f99233281efd08a0), {
                                                            children: "Version"
                                                        }),
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $cc15483875f6c75e$export$5f1af8db9871e1d6), {
                                                            children: "Ospree 2.0.0"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                                    onClick: ()=>handleToggleInfo('Ospree 2.0.0', `Ospree | Version 2.0.0 | \xa9${(0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))().format('YYYY')} Ospree Pte. Ltd. | All Rights Reserved.`),
                                                    children: [
                                                        "Read",
                                                        ' '
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
}
// Default Props
$bc165f8493106cf0$var$Settings.defaultProps = {
    actions: {}
};
// Proptypes Validation
$bc165f8493106cf0$var$Settings.propTypes = {
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setIsUserDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsIndividualUserDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsEntityUserDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        toggleInfoModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setInfoModalDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $bc165f8493106cf0$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($bc165f8493106cf0$var$mapStateToProps, $bc165f8493106cf0$var$mapDispatchToProps)($bc165f8493106cf0$var$Settings);


var $fb0348774b8b6d81$export$2e2bcd8739ae039 = (0, $bc165f8493106cf0$export$2e2bcd8739ae039);



parcelRequire("tZqWC");


const $92662b1bd767bad4$export$517a298bb9b7c4c7 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  height: 100%;
  background: ${({ theme: theme })=>theme.colors.brand};
  background: ${({ theme: theme })=>`linear-gradient(25deg, ${theme.colors.backgroundLite} 65%, ${theme.colors.brand} 130%)`};
`;
const $92662b1bd767bad4$export$c00cbce4d5144962 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
`;
const $92662b1bd767bad4$export$1efa829f084c4936 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  flex: 1;
  display: flex;
  justify-content: center;
`;
const $92662b1bd767bad4$export$5e15da4dae1ac6ff = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  max-width: 500px;
  width: 100%;
`;
const $92662b1bd767bad4$export$1a76d9bfc16d25e3 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 40px;
  width: 100%;

  border-radius: 10px;
`;
const $92662b1bd767bad4$export$fb5f805193b80e2a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).a`
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
  & svg {
    width: 150px;
    height: 50px;
    & path {
      fill: ${({ theme: theme })=>theme.colors.primary};
    }
  }
`;
const $92662b1bd767bad4$export$e8181822af9e90f7 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h1`
  display: flex;
  justify-content: center;
  font-size: 18px;
  color: ${({ theme: theme })=>theme.colors.primary};
  margin: 0 0 30px 0;
`;
const $92662b1bd767bad4$export$64e47c5e1eb9ee2b = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  min-height: 100vh;
`;
const $92662b1bd767bad4$export$f255f562d09704df = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  align-self: center;

  //TODO: Style Variable
  color: ${({ theme: theme })=>theme.colors.background};
`;
const $92662b1bd767bad4$export$fdd773f48aebb8ab = (0, $a778141486c79bc3$export$2e2bcd8739ae039).a`
  display: block;
  margin: 20px 0px 0px 0px;
  width: 100%;

  font-weight: 400;
  font-size: 12px;
  text-decoration: underline;
  text-align: center;

  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $92662b1bd767bad4$export$18cb045afd9fc9fc = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  display: flex;
  justify-content: flex-end;
  margin: 5px 0 0 0;

  font-size: 12px;
  color: ${({ theme: theme })=>theme.colors.primary};
  text-align: right;
`;
const $92662b1bd767bad4$export$a05b2d8703371f85 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).a`
  font-weight: 500;
  color: ${({ theme: theme })=>theme.colors.primary};
`;



function $19abc48a3a0016d5$var$TrialSignup() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $92662b1bd767bad4$export$517a298bb9b7c4c7), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $92662b1bd767bad4$export$c00cbce4d5144962), {
            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $92662b1bd767bad4$export$1efa829f084c4936), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $92662b1bd767bad4$export$5e15da4dae1ac6ff), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $92662b1bd767bad4$export$1a76d9bfc16d25e3), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $92662b1bd767bad4$export$fb5f805193b80e2a), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a25394adb640e26c$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $84d0ea2e58939b9d$export$2e2bcd8739ae039), {})
                        ]
                    })
                })
            })
        })
    });
}
// Default Props
$19abc48a3a0016d5$var$TrialSignup.defaultProps = {};
// Proptypes Validation
$19abc48a3a0016d5$var$TrialSignup.propTypes = {};
var $19abc48a3a0016d5$export$2e2bcd8739ae039 = $19abc48a3a0016d5$var$TrialSignup;


var $66cd7c85b7eacc31$export$2e2bcd8739ae039 = (0, $19abc48a3a0016d5$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");




const $8dfebc43d8dbf6f1$export$e6dfd72ab29f8598 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  height: 100%;
  background: ${({ theme: theme })=>theme.colors.brand};
  background: ${({ theme: theme })=>`linear-gradient(25deg, ${theme.colors.backgroundLite} 65%, ${theme.colors.brand} 130%)`};
`;
const $8dfebc43d8dbf6f1$export$f185744748c379a7 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
`;
const $8dfebc43d8dbf6f1$export$ac7496df4f1f837a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  flex: 1;
  display: flex;
  justify-content: center;
`;
const $8dfebc43d8dbf6f1$export$df9c5d09fda498af = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  max-width: 500px;
  width: 100%;
`;
const $8dfebc43d8dbf6f1$export$6ed20265bd6496f6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 40px;
  width: 100%;

  border-radius: 10px;
`;
const $8dfebc43d8dbf6f1$export$9c9ee2e156b54bfb = (0, $a778141486c79bc3$export$2e2bcd8739ae039).a`
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
  & svg {
    width: 150px;
    height: 50px;
    & path {
      fill: ${({ theme: theme })=>theme.colors.primary};
    }
  }
`;
const $8dfebc43d8dbf6f1$export$f99233281efd08a0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h1`
  display: flex;
  justify-content: center;
  font-size: 18px;
  color: ${({ theme: theme })=>theme.colors.primary};
  margin: 0 0 30px 0;
`;
const $8dfebc43d8dbf6f1$export$edf27be85e5f6da0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h1`
  display: flex;
  justify-content: center;
  font-size: 18px;
  color: ${({ theme: theme })=>theme.colors.red};
  margin: 0 0 30px 0;
`;
const $8dfebc43d8dbf6f1$export$dbc874c9002e4ed3 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  min-height: 100vh;
`;
const $8dfebc43d8dbf6f1$export$193005078f73716a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  align-self: center;

  //TODO: Style Variable
  color: ${({ theme: theme })=>theme.colors.background};
`;
const $8dfebc43d8dbf6f1$export$fdd773f48aebb8ab = (0, $a778141486c79bc3$export$2e2bcd8739ae039).a`
  display: block;
  margin: 20px 0px 0px 0px;
  width: 100%;

  font-weight: 400;
  font-size: 12px;
  text-decoration: underline;
  text-align: center;

  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $8dfebc43d8dbf6f1$export$fa3eaf96da1f4a82 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  display: flex;
  justify-content: flex-end;
  margin: 5px 0 0 0;

  font-size: 12px;
  color: ${({ theme: theme })=>theme.colors.primary};
  text-align: right;
`;
const $8dfebc43d8dbf6f1$export$14e5fcad6a4cc969 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).a`
  font-weight: 500;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $8dfebc43d8dbf6f1$export$f25e790a6345b4c7 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h2`
  font-size: 18px;
  font-weight: 700;
  margin: 10px 0;
  text-align: center;
  color: ${({ theme: theme })=>theme.colors.brand};
`;
const $8dfebc43d8dbf6f1$export$ab5c3400dd78d1c7 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  font-size: 14px;
  font-weight: 400;
  margin: 0 0 40px 0;
  text-align: center;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $8dfebc43d8dbf6f1$export$eddf54ea3db8d0f0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).a`
  margin: 0;
  padding: 0;

  & button {
    min-height: 56px;
    margin: 20px 0px 0px 0px;
  }
`;



function $c719f1a14e8faf2c$var$TrialEmailConfirmation() {
    // Hooks
    const { confirmTrialAccount: confirmTrialAccount, confirmTrialAccountData: confirmTrialAccountData, confirmTrialAccountError: confirmTrialAccountError, isConfirmTrialAccountLoading: isConfirmTrialAccountLoading } = (0, $29611548b91f6074$export$2e2bcd8739ae039)();
    const { hash: hash } = (0, $a0d5c3f2fe524011$export$99eaa27ddbbb95ef)();
    (0, $tZqWC.useEffect)(()=>{
        confirmTrialAccount({
            hash: hash
        });
    }, []);
    // useEffect(() => {
    // }, [confirmTrialAccountData])
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $8dfebc43d8dbf6f1$export$e6dfd72ab29f8598), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $8dfebc43d8dbf6f1$export$f185744748c379a7), {
            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $8dfebc43d8dbf6f1$export$ac7496df4f1f837a), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $8dfebc43d8dbf6f1$export$df9c5d09fda498af), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8dfebc43d8dbf6f1$export$6ed20265bd6496f6), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $8dfebc43d8dbf6f1$export$9c9ee2e156b54bfb), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a25394adb640e26c$export$2e2bcd8739ae039), {})
                            }),
                            isConfirmTrialAccountLoading && !confirmTrialAccountData && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $8dfebc43d8dbf6f1$export$f99233281efd08a0), {
                                children: "Confirming Email"
                            }),
                            isConfirmTrialAccountLoading && !confirmTrialAccountData && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $647b8bc68ebce54f$export$2e2bcd8739ae039), {}),
                            !isConfirmTrialAccountLoading && confirmTrialAccountData && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $8dfebc43d8dbf6f1$export$f25e790a6345b4c7), {
                                        children: "Successfully confirmed your email!"
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $8dfebc43d8dbf6f1$export$ab5c3400dd78d1c7), {
                                        children: "Log in to your new account to access Ospree"
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $8dfebc43d8dbf6f1$export$eddf54ea3db8d0f0), {
                                        href: "/login",
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                            fullWidth: true,
                                            variant: "outlined",
                                            children: "Login"
                                        })
                                    })
                                ]
                            }),
                            confirmTrialAccountError && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $8dfebc43d8dbf6f1$export$edf27be85e5f6da0), {
                                children: "An error occurred in confirming email"
                            })
                        ]
                    })
                })
            })
        })
    });
}
// Default Props
$c719f1a14e8faf2c$var$TrialEmailConfirmation.defaultProps = {};
// Proptypes Validation
$c719f1a14e8faf2c$var$TrialEmailConfirmation.propTypes = {};
var $c719f1a14e8faf2c$export$2e2bcd8739ae039 = $c719f1a14e8faf2c$var$TrialEmailConfirmation;


var $52af1cc490135e49$export$2e2bcd8739ae039 = (0, $c719f1a14e8faf2c$export$2e2bcd8739ae039);



parcelRequire("tZqWC");


const $224164a8612c2709$export$565946c9adc3f09a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  height: 100%;
  background: ${({ theme: theme })=>theme.colors.brand};
  background: ${({ theme: theme })=>`linear-gradient(25deg, ${theme.colors.backgroundLite} 65%, ${theme.colors.brand} 130%)`};
`;
const $224164a8612c2709$export$8e7ad1b63d2a2fd = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
`;
const $224164a8612c2709$export$35607fc5db7d0cc6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  flex: 1;
  display: flex;
  justify-content: center;
`;
const $224164a8612c2709$export$4e5dbe5158148e06 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  max-width: 500px;
  width: 100%;
`;
const $224164a8612c2709$export$be1a93ec16b55ec9 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 30px;
  width: 100%;

  border-radius: 20px;
  background-color: ${({ theme: theme })=>theme.colors.backgroundLite};
  border: 1px solid ${({ theme: theme })=>theme.colors.secondary};
`;
const $224164a8612c2709$export$8aa80638dd5bf240 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).a`
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
  & svg {
    width: 150px;
    height: 50px;
    & path {
      fill: ${({ theme: theme })=>theme.colors.primary};
    }
  }
`;
const $224164a8612c2709$export$dfbcddfff27d5b1c = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h1`
  display: flex;
  justify-content: center;
  font-size: 18px;
  color: ${({ theme: theme })=>theme.colors.primary};
  margin: 0 0 30px 0;
`;
const $224164a8612c2709$export$7be743d52d262205 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  min-height: 100vh;
`;
const $224164a8612c2709$export$643551d5745d45f0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  align-self: center;

  //TODO: Style Variable
  color: ${({ theme: theme })=>theme.colors.background};
`;
const $224164a8612c2709$export$fdd773f48aebb8ab = (0, $a778141486c79bc3$export$2e2bcd8739ae039).a`
  display: block;
  margin: 20px 0px 0px 0px;
  width: 100%;

  font-weight: 400;
  font-size: 12px;
  text-decoration: underline;
  text-align: center;

  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $224164a8612c2709$export$e9ee7e22e4219643 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  display: flex;
  justify-content: flex-end;
  margin: 5px 0 0 0;

  font-size: 12px;
  color: ${({ theme: theme })=>theme.colors.primary};
  text-align: right;
`;
const $224164a8612c2709$export$cb2a379c34bd8a71 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).a`
  font-weight: 500;
  color: ${({ theme: theme })=>theme.colors.primary};
`;



function $4b9edc5a42868b04$var$VaspSignup() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $224164a8612c2709$export$565946c9adc3f09a), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $224164a8612c2709$export$8e7ad1b63d2a2fd), {
            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $224164a8612c2709$export$35607fc5db7d0cc6), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $224164a8612c2709$export$4e5dbe5158148e06), {
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $224164a8612c2709$export$8aa80638dd5bf240), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a25394adb640e26c$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $224164a8612c2709$export$be1a93ec16b55ec9), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c59efdfa8ed48def$export$2e2bcd8739ae039), {})
                        })
                    ]
                })
            })
        })
    });
}
// Default Props
$4b9edc5a42868b04$var$VaspSignup.defaultProps = {};
// Proptypes Validation
$4b9edc5a42868b04$var$VaspSignup.propTypes = {};
var $4b9edc5a42868b04$export$2e2bcd8739ae039 = $4b9edc5a42868b04$var$VaspSignup;


var $ca0cc3a52dcdb38b$export$2e2bcd8739ae039 = (0, $4b9edc5a42868b04$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");




const $8181fde889245665$export$e6dfd72ab29f8598 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  height: 100%;
  background: ${({ theme: theme })=>theme.colors.brand};
  background: ${({ theme: theme })=>`linear-gradient(25deg, ${theme.colors.backgroundLite} 65%, ${theme.colors.brand} 130%)`};
`;
const $8181fde889245665$export$f185744748c379a7 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
`;
const $8181fde889245665$export$ac7496df4f1f837a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  flex: 1;
  display: flex;
  justify-content: center;
`;
const $8181fde889245665$export$df9c5d09fda498af = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  max-width: 500px;
  width: 100%;
`;
const $8181fde889245665$export$6ed20265bd6496f6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 40px;
  width: 100%;

  border-radius: 10px;
`;
const $8181fde889245665$export$9c9ee2e156b54bfb = (0, $a778141486c79bc3$export$2e2bcd8739ae039).a`
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
  & svg {
    width: 150px;
    height: 50px;
    & path {
      fill: ${({ theme: theme })=>theme.colors.primary};
    }
  }
`;
const $8181fde889245665$export$f99233281efd08a0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h1`
  display: flex;
  justify-content: center;
  font-size: 18px;
  color: ${({ theme: theme })=>theme.colors.primary};
  margin: 0 0 30px 0;
`;
const $8181fde889245665$export$edf27be85e5f6da0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h1`
  display: flex;
  justify-content: center;
  font-size: 18px;
  color: ${({ theme: theme })=>theme.colors.red};
  margin: 0 0 30px 0;
`;
const $8181fde889245665$export$dbc874c9002e4ed3 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  min-height: 100vh;
`;
const $8181fde889245665$export$193005078f73716a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  align-self: center;

  //TODO: Style Variable
  color: ${({ theme: theme })=>theme.colors.background};
`;
const $8181fde889245665$export$fdd773f48aebb8ab = (0, $a778141486c79bc3$export$2e2bcd8739ae039).a`
  display: block;
  margin: 20px 0px 0px 0px;
  width: 100%;

  font-weight: 400;
  font-size: 12px;
  text-decoration: underline;
  text-align: center;

  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $8181fde889245665$export$fa3eaf96da1f4a82 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  display: flex;
  justify-content: flex-end;
  margin: 5px 0 0 0;

  font-size: 12px;
  color: ${({ theme: theme })=>theme.colors.primary};
  text-align: right;
`;
const $8181fde889245665$export$14e5fcad6a4cc969 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).a`
  font-weight: 500;
  color: ${({ theme: theme })=>theme.colors.primary};
`;



function $58d63077aea35f70$var$VaspEmailConfirmation() {
    // Hooks
    const { confirmVaspEmail: confirmVaspEmail, confirmVaspEmailData: confirmVaspEmailData, confirmVaspEmailError: confirmVaspEmailError, isConfirmVaspEmailLoading: isConfirmVaspEmailLoading } = (0, $d538b04748fc7bbd$export$2e2bcd8739ae039)();
    const { hash: hash } = (0, $a0d5c3f2fe524011$export$99eaa27ddbbb95ef)();
    (0, $tZqWC.useEffect)(()=>{
        confirmVaspEmail({
            hash: hash
        });
    }, []);
    // useEffect(() => {
    // }, [confirmVaspEmailData])
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $8181fde889245665$export$e6dfd72ab29f8598), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $8181fde889245665$export$f185744748c379a7), {
            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $8181fde889245665$export$ac7496df4f1f837a), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $8181fde889245665$export$df9c5d09fda498af), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8181fde889245665$export$6ed20265bd6496f6), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $8181fde889245665$export$9c9ee2e156b54bfb), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a25394adb640e26c$export$2e2bcd8739ae039), {})
                            }),
                            isConfirmVaspEmailLoading && !confirmVaspEmailData && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $8181fde889245665$export$f99233281efd08a0), {
                                children: "Confirming Email"
                            }),
                            isConfirmVaspEmailLoading && !confirmVaspEmailData && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $647b8bc68ebce54f$export$2e2bcd8739ae039), {}),
                            !isConfirmVaspEmailLoading && confirmVaspEmailData && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $8181fde889245665$export$f99233281efd08a0), {
                                children: "Successfully confirmed email"
                            }),
                            confirmVaspEmailError && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $8181fde889245665$export$edf27be85e5f6da0), {
                                children: "An error occurred in confirming email"
                            })
                        ]
                    })
                })
            })
        })
    });
}
// Default Props
$58d63077aea35f70$var$VaspEmailConfirmation.defaultProps = {};
// Proptypes Validation
$58d63077aea35f70$var$VaspEmailConfirmation.propTypes = {};
var $58d63077aea35f70$export$2e2bcd8739ae039 = $58d63077aea35f70$var$VaspEmailConfirmation;


var $550831ac8e233add$export$2e2bcd8739ae039 = (0, $58d63077aea35f70$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");




const $c14372b37c665b1a$export$e6dfd72ab29f8598 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  height: 100%;
  background: ${({ theme: theme })=>theme.colors.brand};
  background: ${({ theme: theme })=>`linear-gradient(25deg, ${theme.colors.backgroundLite} 65%, ${theme.colors.brand} 130%)`};
`;
const $c14372b37c665b1a$export$f185744748c379a7 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
`;
const $c14372b37c665b1a$export$ac7496df4f1f837a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  flex: 1;
  display: flex;
  justify-content: center;
`;
const $c14372b37c665b1a$export$df9c5d09fda498af = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  max-width: 500px;
  width: 100%;
`;
const $c14372b37c665b1a$export$6ed20265bd6496f6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 40px;
  width: 100%;

  border-radius: 10px;
`;
const $c14372b37c665b1a$export$9c9ee2e156b54bfb = (0, $a778141486c79bc3$export$2e2bcd8739ae039).a`
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
  & svg {
    width: 150px;
    height: 50px;
    & path {
      fill: ${({ theme: theme })=>theme.colors.primary};
    }
  }
`;
const $c14372b37c665b1a$export$f99233281efd08a0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h1`
  display: flex;
  justify-content: center;
  font-size: 18px;
  color: ${({ theme: theme })=>theme.colors.primary};
  margin: 0 0 30px 0;
`;
const $c14372b37c665b1a$export$edf27be85e5f6da0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h1`
  display: flex;
  justify-content: center;
  font-size: 18px;
  color: ${({ theme: theme })=>theme.colors.red};
  margin: 0 0 30px 0;
`;
const $c14372b37c665b1a$export$dbc874c9002e4ed3 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  min-height: 100vh;
`;
const $c14372b37c665b1a$export$193005078f73716a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  align-self: center;

  //TODO: Style Variable
  color: ${({ theme: theme })=>theme.colors.background};
`;
const $c14372b37c665b1a$export$fdd773f48aebb8ab = (0, $a778141486c79bc3$export$2e2bcd8739ae039).a`
  display: block;
  margin: 20px 0px 0px 0px;
  width: 100%;

  font-weight: 400;
  font-size: 12px;
  text-decoration: underline;
  text-align: center;

  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $c14372b37c665b1a$export$fa3eaf96da1f4a82 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  display: flex;
  justify-content: flex-end;
  margin: 5px 0 0 0;

  font-size: 12px;
  color: ${({ theme: theme })=>theme.colors.primary};
  text-align: right;
`;
const $c14372b37c665b1a$export$14e5fcad6a4cc969 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).a`
  font-weight: 500;
  color: ${({ theme: theme })=>theme.colors.primary};
`;



function $389b1efe5f30636d$var$VaspUserEmailConfirmation() {
    // Hooks
    const { confirmVaspUserEmail: confirmVaspUserEmail, confirmVaspUserEmailData: confirmVaspUserEmailData, confirmVaspUserEmailError: confirmVaspUserEmailError, isConfirmVaspUserEmailLoading: isConfirmVaspUserEmailLoading } = (0, $975bad910b51ddbd$export$2e2bcd8739ae039)();
    const { hash: hash } = (0, $a0d5c3f2fe524011$export$99eaa27ddbbb95ef)();
    (0, $tZqWC.useEffect)(()=>{
        confirmVaspUserEmail({
            hash: hash
        });
    }, []);
    // useEffect(() => {
    // }, [confirmVaspUserEmailData])
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c14372b37c665b1a$export$e6dfd72ab29f8598), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c14372b37c665b1a$export$f185744748c379a7), {
            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c14372b37c665b1a$export$ac7496df4f1f837a), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c14372b37c665b1a$export$df9c5d09fda498af), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $c14372b37c665b1a$export$6ed20265bd6496f6), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c14372b37c665b1a$export$9c9ee2e156b54bfb), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a25394adb640e26c$export$2e2bcd8739ae039), {})
                            }),
                            isConfirmVaspUserEmailLoading && !confirmVaspUserEmailData && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c14372b37c665b1a$export$f99233281efd08a0), {
                                children: "Confirming Email"
                            }),
                            isConfirmVaspUserEmailLoading && !confirmVaspUserEmailData && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $647b8bc68ebce54f$export$2e2bcd8739ae039), {}),
                            !isConfirmVaspUserEmailLoading && confirmVaspUserEmailData && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c14372b37c665b1a$export$f99233281efd08a0), {
                                children: "Successfully confirmed email"
                            }),
                            confirmVaspUserEmailError && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c14372b37c665b1a$export$edf27be85e5f6da0), {
                                children: "An error occurred in confirming email"
                            })
                        ]
                    })
                })
            })
        })
    });
}
// Default Props
$389b1efe5f30636d$var$VaspUserEmailConfirmation.defaultProps = {};
// Proptypes Validation
$389b1efe5f30636d$var$VaspUserEmailConfirmation.propTypes = {};
var $389b1efe5f30636d$export$2e2bcd8739ae039 = $389b1efe5f30636d$var$VaspUserEmailConfirmation;


var $c9ee35e7a4200ef9$export$2e2bcd8739ae039 = (0, $389b1efe5f30636d$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");


var $4L3zM = parcelRequire("4L3zM");








const $33b7b0688220fb3c$export$bfe2969d9faaaa94 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  min-height: 100vh;
  background: ${({ theme: theme })=>theme.colors.brand};
  background: ${({ theme: theme })=>`linear-gradient(25deg, ${theme.colors.backgroundLite} 65%, ${theme.colors.brand} 130%)`};
`;
const $33b7b0688220fb3c$export$6aac6cd983aa9a8d = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const $33b7b0688220fb3c$export$c316e7f3abbfa73a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  flex: 1;
  display: flex;
  justify-content: center;
`;
const $33b7b0688220fb3c$export$1d8d8cae37810421 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  max-width: 500px;
  width: 100%;
`;
const $33b7b0688220fb3c$export$cac169cfa0d556b7 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  padding: 40px;
  width: 100%;

  border-radius: 10px;
`;
const $33b7b0688220fb3c$export$842695ea3d5549d = (0, $a778141486c79bc3$export$2e2bcd8739ae039).a`
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
  & svg {
    width: 150px;
    height: 50px;
    & path {
      fill: ${({ theme: theme })=>theme.colors.primary};
    }
  }
`;
const $33b7b0688220fb3c$export$23f1dea7e159c283 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h1`
  display: flex;
  justify-content: center;
  font-size: 18px;
  color: ${({ theme: theme })=>theme.colors.primary};
  margin: 0 0 30px 0;
`;
const $33b7b0688220fb3c$export$4008c5a771d31562 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  min-height: 100vh;
`;
const $33b7b0688220fb3c$export$e33979aaf48f984a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  align-self: center;

  //TODO: Style Variable
  color: ${({ theme: theme })=>theme.colors.background};
`;
const $33b7b0688220fb3c$export$fdd773f48aebb8ab = (0, $a778141486c79bc3$export$2e2bcd8739ae039).a`
  display: block;
  margin: 20px 0px 0px 0px;
  width: 100%;

  font-weight: 400;
  font-size: 12px;
  text-decoration: underline;
  text-align: center;

  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $33b7b0688220fb3c$export$3f9c8c13edb92928 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  display: flex;
  justify-content: flex-end;
  margin: 5px 0 0 0;

  font-size: 12px;
  color: ${({ theme: theme })=>theme.colors.primary};
  text-align: right;
`;
const $33b7b0688220fb3c$export$fb3d2bca71e46662 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).a`
  font-weight: 500;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $33b7b0688220fb3c$export$d53c836cccbb0d90 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).a`
  width: 100%;

  min-height: 56px;
  & button {
    min-height: 56px;
  }
`;
const $33b7b0688220fb3c$export$43a792a870d28db2 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 50px 0;
`;
const $33b7b0688220fb3c$export$5e64a9683d127ef6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h1`
  display: flex;
  justify-content: center;
  font-size: 18px;
  color: ${({ theme: theme })=>theme.colors.red};
  margin: 0 0 30px 0;
`;


// Map Redux Props
const $b5e67df66de1de8f$var$mapStateToProps = (state)=>state;
const $b5e67df66de1de8f$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $b5e67df66de1de8f$var$LoginTwoFa(props) {
    // Props
    const { actions: actions } = props;
    // Store Actions
    const { showAlert: showAlert } = actions;
    // Hooks
    const { loginUserTwoFa: loginUserTwoFa, loginUserTwoFaData: loginUserTwoFaData, loginUserTwoFaError: loginUserTwoFaError, isLoginUserTwoFaLoading: isLoginUserTwoFaLoading } = (0, $62a96b9abbbbd0e0$export$2e2bcd8739ae039)();
    const { getUser: getUser, getUserData: getUserData, isGetUserLoading: isGetUserLoading } = (0, $89db55cadf8da1af$export$2e2bcd8739ae039)();
    const { auth_hash: auth_hash } = (0, $a0d5c3f2fe524011$export$99eaa27ddbbb95ef)();
    // Local States
    const [isLoggedIn, setIsloggedIn] = (0, $a9c50ebe96619b20$export$2e2bcd8739ae039)('isLoggedIn', false);
    const [userCredentials, setUserCredentials] = (0, $a9c50ebe96619b20$export$2e2bcd8739ae039)('userCredentials', {});
    const [, setTheme] = (0, $a9c50ebe96619b20$export$2e2bcd8739ae039)('theme', 'light');
    const [userData, setUserData] = (0, $tZqWC.useState)();
    const handleOnSubmit = (auth_hash)=>{
        loginUserTwoFa({
            auth_hash: auth_hash
        });
    };
    const getUserInfo = ()=>{
        setUserData(loginUserTwoFaData);
        localStorage.setItem('userCredentials', JSON.stringify(loginUserTwoFaData));
        const { uid: uid } = (0, $ec4d1a62b8fa659d$export$83cd1f1503eb19c0)(loginUserTwoFaData.access_token);
        if (uid) getUser({
            user_id: uid
        });
    };
    const login = async ()=>{
        // setting the data in order to make user logged in
        if (loginUserTwoFaData && !loginUserTwoFaError) {
            await setTheme('dark');
            await setUserCredentials({
                ...userData,
                ...getUserData
            });
            await setIsloggedIn(true);
        }
    };
    const checkIfSessionExpired = async ()=>{
        // Checking if user session is expired
        if (isLoggedIn && !userCredentials?.access_token) {
            await localStorage.setItem('isLoggedIn', 'false');
            await localStorage.setItem('userCredentials', '{}');
            await localStorage.setItem('reportStrings', '[]');
            await localStorage.setItem('reportTitles', '[]');
            showAlert({
                type: 'error',
                message: 'Session Expired'
            });
        }
    };
    // useEffect
    (0, $tZqWC.useEffect)(()=>loginUserTwoFaData && getUserInfo(), [
        loginUserTwoFaData
    ]);
    (0, $tZqWC.useEffect)(()=>getUserData && login(), [
        getUserData
    ]);
    (0, $tZqWC.useEffect)(()=>isLoggedIn && window.location.replace(window.location.origin), [
        isLoggedIn
    ]);
    (0, $tZqWC.useEffect)(()=>checkIfSessionExpired(), []);
    (0, $tZqWC.useEffect)(()=>{
        if (!loginUserTwoFaError) return;
        if (loginUserTwoFaError?.response?.status === 400) showAlert({
            type: 'error',
            message: 'Username and password did not match'
        });
        else showAlert({
            type: 'error',
            message: 'An error occurred in logging in'
        });
    }, [
        loginUserTwoFaError
    ]);
    (0, $tZqWC.useEffect)(()=>{
        handleOnSubmit(auth_hash);
    }, [
        auth_hash
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $33b7b0688220fb3c$export$bfe2969d9faaaa94), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $33b7b0688220fb3c$export$6aac6cd983aa9a8d), {
            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $33b7b0688220fb3c$export$c316e7f3abbfa73a), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $33b7b0688220fb3c$export$1d8d8cae37810421), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $33b7b0688220fb3c$export$cac169cfa0d556b7), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $33b7b0688220fb3c$export$842695ea3d5549d), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a25394adb640e26c$export$2e2bcd8739ae039), {})
                            }),
                            (isLoginUserTwoFaLoading || isGetUserLoading) && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $33b7b0688220fb3c$export$43a792a870d28db2), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $33b7b0688220fb3c$export$23f1dea7e159c283), {
                                        children: "Signing in..."
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a6fa6c8d0625529f$export$2e2bcd8739ae039), {})
                                ]
                            }),
                            !isLoginUserTwoFaLoading && loginUserTwoFaError && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $33b7b0688220fb3c$export$5e64a9683d127ef6), {
                                        children: "The sign in link is invalid."
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $33b7b0688220fb3c$export$d53c836cccbb0d90), {
                                        href: "/login",
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                            fullWidth: true,
                                            children: "Get a new link"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        })
    });
}
// Default Props
$b5e67df66de1de8f$var$LoginTwoFa.defaultProps = {
    actions: {}
};
// Proptypes Validation
$b5e67df66de1de8f$var$LoginTwoFa.propTypes = {
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $b5e67df66de1de8f$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($b5e67df66de1de8f$var$mapStateToProps, $b5e67df66de1de8f$var$mapDispatchToProps)($b5e67df66de1de8f$var$LoginTwoFa);


var $7b764510d8a0ab8e$export$2e2bcd8739ae039 = (0, $b5e67df66de1de8f$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");


var $4L3zM = parcelRequire("4L3zM");






const $28cc4227d314140d$export$bfe2969d9faaaa94 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  min-height: 100vh;
  background: ${({ theme: theme })=>theme.colors.brand};
  background: ${({ theme: theme })=>`linear-gradient(25deg, ${theme.colors.backgroundLite} 65%, ${theme.colors.brand} 130%)`};
`;
const $28cc4227d314140d$export$6aac6cd983aa9a8d = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const $28cc4227d314140d$export$c316e7f3abbfa73a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  flex: 1;
  display: flex;
  justify-content: center;
`;
const $28cc4227d314140d$export$1d8d8cae37810421 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  max-width: 500px;
  width: 100%;
`;
const $28cc4227d314140d$export$cac169cfa0d556b7 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  padding: 40px;
  width: 100%;

  border-radius: 10px;
`;
const $28cc4227d314140d$export$842695ea3d5549d = (0, $a778141486c79bc3$export$2e2bcd8739ae039).a`
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
  & svg {
    width: 150px;
    height: 50px;
    & path {
      fill: ${({ theme: theme })=>theme.colors.primary};
    }
  }
`;
const $28cc4227d314140d$export$23f1dea7e159c283 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h1`
  display: flex;
  justify-content: center;
  font-size: 18px;
  color: ${({ theme: theme })=>theme.colors.primary};
  margin: 0 0 30px 0;
`;
const $28cc4227d314140d$export$4008c5a771d31562 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  min-height: 100vh;
`;
const $28cc4227d314140d$export$e33979aaf48f984a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  align-self: center;

  //TODO: Style Variable
  color: ${({ theme: theme })=>theme.colors.background};
`;
const $28cc4227d314140d$export$fdd773f48aebb8ab = (0, $a778141486c79bc3$export$2e2bcd8739ae039).a`
  display: block;
  margin: 20px 0px 0px 0px;
  width: 100%;

  font-weight: 400;
  font-size: 12px;
  text-decoration: underline;
  text-align: center;

  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $28cc4227d314140d$export$3f9c8c13edb92928 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  display: flex;
  justify-content: flex-end;
  margin: 5px 0 0 0;

  font-size: 12px;
  color: ${({ theme: theme })=>theme.colors.primary};
  text-align: right;
`;
const $28cc4227d314140d$export$fb3d2bca71e46662 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).a`
  font-weight: 500;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $28cc4227d314140d$export$d53c836cccbb0d90 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).a`
  width: 100%;

  min-height: 56px;
  & button {
    min-height: 56px;
  }
`;
const $28cc4227d314140d$export$43a792a870d28db2 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 50px 0;
`;
const $28cc4227d314140d$export$5e64a9683d127ef6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h1`
  display: flex;
  justify-content: center;
  font-size: 18px;
  color: ${({ theme: theme })=>theme.colors.red};
  margin: 0 0 30px 0;
`;
const $28cc4227d314140d$export$fc7c1bf53d3a6a78 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h1`
  display: flex;
  justify-content: center;
  font-size: 18px;
  color: ${({ theme: theme })=>theme.colors.brand};
  margin: 0 0 30px 0;
`;


// Map Redux Props
const $799c4f8201faa078$var$mapStateToProps = (state)=>state;
const $799c4f8201faa078$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $799c4f8201faa078$var$EmailVerification() {
    // Hooks
    const { verifyEmail: verifyEmail, isVerifyEmailLoading: isVerifyEmailLoading, isVerifyEmailSuccess: isVerifyEmailSuccess, isVerifyEmailError: isVerifyEmailError } = (0, $806601e89d0fc801$export$2e2bcd8739ae039)();
    const { auth_hash: auth_hash } = (0, $a0d5c3f2fe524011$export$99eaa27ddbbb95ef)();
    // Local States
    const handleOnSubmit = (auth_hash)=>{
        verifyEmail({
            auth_hash: auth_hash
        });
    };
    (0, $tZqWC.useEffect)(()=>{
        handleOnSubmit(auth_hash);
    }, [
        auth_hash
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $28cc4227d314140d$export$bfe2969d9faaaa94), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $28cc4227d314140d$export$6aac6cd983aa9a8d), {
            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $28cc4227d314140d$export$c316e7f3abbfa73a), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $28cc4227d314140d$export$1d8d8cae37810421), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $28cc4227d314140d$export$cac169cfa0d556b7), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $28cc4227d314140d$export$842695ea3d5549d), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a25394adb640e26c$export$2e2bcd8739ae039), {})
                            }),
                            isVerifyEmailLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $28cc4227d314140d$export$43a792a870d28db2), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $28cc4227d314140d$export$23f1dea7e159c283), {
                                        children: "Verifying Email"
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a6fa6c8d0625529f$export$2e2bcd8739ae039), {})
                                ]
                            }),
                            isVerifyEmailSuccess && !isVerifyEmailLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $28cc4227d314140d$export$fc7c1bf53d3a6a78), {
                                        children: "Email has been verified."
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $28cc4227d314140d$export$d53c836cccbb0d90), {
                                        href: "/",
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                            fullWidth: true,
                                            children: "Go back"
                                        })
                                    })
                                ]
                            }),
                            isVerifyEmailError && !isVerifyEmailLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $28cc4227d314140d$export$5e64a9683d127ef6), {
                                        children: "The link is invalid."
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $28cc4227d314140d$export$d53c836cccbb0d90), {
                                        href: "/",
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                            fullWidth: true,
                                            children: "Go back"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        })
    });
}
// Default Props
$799c4f8201faa078$var$EmailVerification.defaultProps = {
    actions: {}
};
// Proptypes Validation
$799c4f8201faa078$var$EmailVerification.propTypes = {
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $799c4f8201faa078$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($799c4f8201faa078$var$mapStateToProps, $799c4f8201faa078$var$mapDispatchToProps)($799c4f8201faa078$var$EmailVerification);


var $546bd80c347f47f6$export$2e2bcd8739ae039 = (0, $799c4f8201faa078$export$2e2bcd8739ae039);



parcelRequire("tZqWC");


const $cb1e4816cc6b7cbc$export$6de372b03df6a0c3 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  height: 100%;
  background: ${({ theme: theme })=>theme.colors.brand};
  background: ${({ theme: theme })=>`linear-gradient(25deg, ${theme.colors.backgroundLite} 65%, ${theme.colors.brand} 130%)`};
`;
const $cb1e4816cc6b7cbc$export$7aa3aa004161e6df = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
`;
const $cb1e4816cc6b7cbc$export$46071b68e1641783 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  flex: 1;
  display: flex;
  justify-content: center;
`;
const $cb1e4816cc6b7cbc$export$369a2ef34738de34 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  max-width: 500px;
  width: 100%;
`;
const $cb1e4816cc6b7cbc$export$13cf8a719da326e8 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 40px;
  width: 100%;

  border-radius: 10px;
`;
const $cb1e4816cc6b7cbc$export$53e7d02d01c504c2 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).a`
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
  & svg {
    width: 150px;
    height: 50px;
    & path {
      fill: ${({ theme: theme })=>theme.colors.primary};
    }
  }
`;
const $cb1e4816cc6b7cbc$export$cba9d9f429dd71c8 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h1`
  display: flex;
  justify-content: center;
  font-size: 18px;
  color: ${({ theme: theme })=>theme.colors.primary};
  margin: 0 0 30px 0;
`;
const $cb1e4816cc6b7cbc$export$d3efae44a12c8734 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  min-height: 100vh;
`;
const $cb1e4816cc6b7cbc$export$c24114010526dbed = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  align-self: center;

  //TODO: Style Variable
  color: ${({ theme: theme })=>theme.colors.background};
`;
const $cb1e4816cc6b7cbc$export$fdd773f48aebb8ab = (0, $a778141486c79bc3$export$2e2bcd8739ae039).a`
  display: block;
  margin: 20px 0px 0px 0px;
  width: 100%;

  font-weight: 400;
  font-size: 12px;
  text-decoration: underline;
  text-align: center;

  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $cb1e4816cc6b7cbc$export$1e6aa088dbd84062 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  display: flex;
  justify-content: flex-end;
  margin: 5px 0 0 0;

  font-size: 12px;
  color: ${({ theme: theme })=>theme.colors.primary};
  text-align: right;
`;
const $cb1e4816cc6b7cbc$export$487e0fe94ad0474 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).a`
  font-weight: 500;
  color: ${({ theme: theme })=>theme.colors.primary};
`;



function $f7456b6b225a3337$var$UserSignup() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $cb1e4816cc6b7cbc$export$6de372b03df6a0c3), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $cb1e4816cc6b7cbc$export$7aa3aa004161e6df), {
            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $cb1e4816cc6b7cbc$export$46071b68e1641783), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $cb1e4816cc6b7cbc$export$369a2ef34738de34), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $cb1e4816cc6b7cbc$export$13cf8a719da326e8), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $cb1e4816cc6b7cbc$export$53e7d02d01c504c2), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a25394adb640e26c$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $cb1e4816cc6b7cbc$export$cba9d9f429dd71c8), {
                                children: "Activate Account"
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $db40a2c7abdc997f$export$2e2bcd8739ae039), {})
                        ]
                    })
                })
            })
        })
    });
}
// Default Props
$f7456b6b225a3337$var$UserSignup.defaultProps = {};
// Proptypes Validation
$f7456b6b225a3337$var$UserSignup.propTypes = {};
var $f7456b6b225a3337$export$2e2bcd8739ae039 = $f7456b6b225a3337$var$UserSignup;


var $d8708d366d43ba58$export$2e2bcd8739ae039 = (0, $f7456b6b225a3337$export$2e2bcd8739ae039);



parcelRequire("tZqWC");


const $e73bfddb32fbc01b$export$e6dfd72ab29f8598 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  min-height: 100vh;
  background: ${({ theme: theme })=>theme.colors.brand};
  background: ${({ theme: theme })=>`linear-gradient(25deg, ${theme.colors.backgroundLite} 65%, ${theme.colors.brand} 130%)`};
`;
const $e73bfddb32fbc01b$export$f185744748c379a7 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const $e73bfddb32fbc01b$export$ac7496df4f1f837a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  flex: 1;
  display: flex;
  justify-content: center;
`;
const $e73bfddb32fbc01b$export$df9c5d09fda498af = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  max-width: 500px;
  width: 100%;
`;
const $e73bfddb32fbc01b$export$6ed20265bd6496f6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 40px;
  width: 100%;

  border-radius: 10px;
`;
const $e73bfddb32fbc01b$export$9c9ee2e156b54bfb = (0, $a778141486c79bc3$export$2e2bcd8739ae039).a`
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
  & svg {
    width: 150px;
    height: 50px;
    & path {
      fill: ${({ theme: theme })=>theme.colors.primary};
    }
  }
`;
const $e73bfddb32fbc01b$export$f99233281efd08a0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h1`
  display: flex;
  justify-content: center;
  font-size: 18px;
  color: ${({ theme: theme })=>theme.colors.primary};
  margin: 0 0 30px 0;
`;
const $e73bfddb32fbc01b$export$dbc874c9002e4ed3 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  min-height: 100vh;
`;
const $e73bfddb32fbc01b$export$193005078f73716a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  align-self: center;

  //TODO: Style Variable
  color: ${({ theme: theme })=>theme.colors.background};
`;
const $e73bfddb32fbc01b$export$fdd773f48aebb8ab = (0, $a778141486c79bc3$export$2e2bcd8739ae039).a`
  display: block;
  margin: 20px 0px 0px 0px;
  width: 100%;

  font-weight: 400;
  font-size: 12px;
  text-decoration: underline;
  text-align: center;

  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $e73bfddb32fbc01b$export$fa3eaf96da1f4a82 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  display: flex;
  justify-content: flex-end;
  margin: 5px 0 0 0;

  font-size: 12px;
  color: ${({ theme: theme })=>theme.colors.primary};
  text-align: right;
`;
const $e73bfddb32fbc01b$export$14e5fcad6a4cc969 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).a`
  font-weight: 500;
  color: ${({ theme: theme })=>theme.colors.primary};
`;



function $b04b316b8760d528$var$UpdatePassword() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e73bfddb32fbc01b$export$e6dfd72ab29f8598), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e73bfddb32fbc01b$export$f185744748c379a7), {
            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e73bfddb32fbc01b$export$ac7496df4f1f837a), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e73bfddb32fbc01b$export$df9c5d09fda498af), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $e73bfddb32fbc01b$export$6ed20265bd6496f6), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e73bfddb32fbc01b$export$9c9ee2e156b54bfb), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a25394adb640e26c$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e73bfddb32fbc01b$export$f99233281efd08a0), {
                                children: "Update Password"
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d8c7888e21f80618$export$2e2bcd8739ae039), {})
                        ]
                    })
                })
            })
        })
    });
}
// Default Props
$b04b316b8760d528$var$UpdatePassword.defaultProps = {};
// Proptypes Validation
$b04b316b8760d528$var$UpdatePassword.propTypes = {};
var $b04b316b8760d528$export$2e2bcd8739ae039 = $b04b316b8760d528$var$UpdatePassword;


var $68cf2bde4ec542a4$export$2e2bcd8739ae039 = (0, $b04b316b8760d528$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");





const $eb59b21762ea71e4$export$e6dfd72ab29f8598 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: 100%;
  border-radius: 10px;
  background-color: ${({ theme: theme })=>theme.colors.background};
`;
const $eb59b21762ea71e4$export$17b77c57254421ac = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $eb59b21762ea71e4$export$bc7adc8ef74607f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  min-height: 80px;
  padding: 0 40px;
  border-bottom: 2px solid ${({ theme: theme })=>theme.colors.backgroundLite};

  & button {
    border-radius: 5px;
  }
`;
const $eb59b21762ea71e4$export$a9754b3c8daa5172 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 25px;
  min-width: 200px;

  // overwriting select component
  & div > div {
    margin: 0 !important;
  }
`;
const $eb59b21762ea71e4$export$87ad169bde460ddf = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
const $eb59b21762ea71e4$export$f99233281efd08a0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h2`
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $eb59b21762ea71e4$export$5f1af8db9871e1d6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  margin: 0;
  font-size: 11px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;



/* eslint-disable max-len */ // Admin Layouts


var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");





const $3f0fc2678641bcda$export$4267411171632d35 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $3f0fc2678641bcda$export$cbf11d5f692bc726 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
`;
const $3f0fc2678641bcda$export$97d84ed62ab03b3f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  margin: 0px 0px 0px 16px;

  font-weight: inherit;
  font-size: inherit;
`;





/* eslint-disable no-unsafe-optional-chaining */ 

var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

var $ejSM7 = parcelRequire("ejSM7");






const $29cc45482f452abc$export$5f1af8db9871e1d6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  font-size: 13px;
  margin: 0;
  text-align: right;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $29cc45482f452abc$export$b04be29aa201d4f5 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  font-size: 13px;
  margin: 0;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $29cc45482f452abc$export$f99233281efd08a0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h3`
  margin: 0;
  font-size: 40px;
  font-weight: 700;
  padding-right: 15px;
  margin-right: 15px;
  border-right: 1px solid ${({ theme: theme })=>theme.colors.secondary};
  color: ${({ theme: theme })=>theme.colors.primary};
  text-transform: capitalize;
`;
const $29cc45482f452abc$export$d5c56664638992a4 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h4`
  font-size: 16px;
  margin: 0;
  color: ${({ theme: theme })=>theme.colors.primary};
  font-weight: 400;

  max-width: 260px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;
const $29cc45482f452abc$export$987cac99e7a31168 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: 1fr 1fr;
`;
const $29cc45482f452abc$export$2157c074a0891857 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  text-transform: uppercase;
`;
const $29cc45482f452abc$export$6f4a084cc8e379b6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 20px;
  &:last-child {
    background-color: ${({ theme: theme })=>theme.colors.background};
    border-radius: 0 0 10px 10px;
  }
`;
const $29cc45482f452abc$export$9f515a68dfaeb9ef = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  padding: 20px;
  background-color: ${({ theme: theme })=>theme.colors.borderColor};
  border-bottom: 2px solid ${({ theme: theme })=>theme.colors.backgroundLite};
  border-radius: 10px 10px 0 0;
`;
const $29cc45482f452abc$export$fd2299f554be8993 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  padding: 20px;
  gap: 20px;
  justify-content: center;
  width: 100%;

  & button {
    width: 100% !important;
  }
`;
const $29cc45482f452abc$export$15529022dcaf3eec = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-end;
`;
const $29cc45482f452abc$export$5a7f9a6004988d01 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  font-size: 13px;
  margin: 0 0 4px 0;
  width: fit-content;
  padding: 2px 18px;
  ${({ theme: theme, customer_status_id: customer_status_id })=>`
    ${customer_status_id === -1 && `
      ;color: ${theme.colors.red};
      background-color: transparent;
      border: 1px solid ${theme.colors.red};
      border-radius: 8px;
    `}
    ${(customer_status_id === -2 || customer_status_id === 0 || customer_status_id === 4) && `
      ;color: ${theme.colors.primary};
      background-color: transparent;
      border: 1px solid ${theme.colors.primary};
      border-radius: 8px;
    `}
    ${customer_status_id > 0 && `
      ;color: ${theme.colors.brand};
      background-color: transparent;
      border: 1px solid ${theme.colors.brand};
      border-radius: 8px;
    `}
  `};
`;



// Map Redux Props
const $1eb2fc81b7038786$var$mapStateToProps = (state)=>state;
const $1eb2fc81b7038786$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $1eb2fc81b7038786$var$AdminVaspsTableItem(props) {
    // Destructure
    const { vaspDetails: vasp_detail, ui: ui } = props;
    // Store State
    const { rejectVaspDetails: rejectVaspDetails } = ui;
    // State
    const [cardName, setCardName] = (0, $tZqWC.useState)({});
    const [vaspDetails, setVaspDetails] = (0, $tZqWC.useState)(vasp_detail);
    // UseEffect
    (0, $tZqWC.useEffect)(()=>{
        if (vaspDetails?.name_legal) {
            const nameArr = vaspDetails?.name_legal.split(' ');
            const firstNameLength = Math.floor(nameArr.length / 2);
            const firstName = [];
            for(let i = 0; i < firstNameLength; i++)firstName.push(nameArr[i]);
            nameArr.splice(0, firstNameLength);
            setCardName({
                initials: vaspDetails?.name_legal[0] + vaspDetails?.name_legal[1],
                fullname: [
                    firstName.join(' '),
                    nameArr.join(' ')
                ]
            });
        }
    }, [
        vaspDetails?.external_id
    ]);
    (0, $tZqWC.useEffect)(()=>{
        setVaspDetails(vasp_detail);
    }, [
        vasp_detail
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (rejectVaspDetails && rejectVaspDetails?.vasp_id === vaspDetails?.id) setVaspDetails({
            ...vaspDetails,
            ...rejectVaspDetails
        });
    }, [
        rejectVaspDetails
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $12b33660068e86aa$export$b0d92dbee9b5b60d), {
        to: `/admin/vasps/details/${vaspDetails?.id}`,
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $37202d75ee8521c4$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $29cc45482f452abc$export$9f515a68dfaeb9ef), {
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $29cc45482f452abc$export$f99233281efd08a0), {
                            children: cardName?.initials || 'NA'
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $29cc45482f452abc$export$2157c074a0891857), {
                            children: cardName.fullname?.[0] || cardName.fullname?.[1] ? /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $29cc45482f452abc$export$d5c56664638992a4), {
                                        children: cardName.fullname?.[0] || '-'
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $29cc45482f452abc$export$d5c56664638992a4), {
                                        children: cardName.fullname?.[1] || '-'
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $29cc45482f452abc$export$d5c56664638992a4), {
                                        children: "To Be"
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $29cc45482f452abc$export$d5c56664638992a4), {
                                        children: "Registered"
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $29cc45482f452abc$export$6f4a084cc8e379b6), {
                    children: [
                        vaspDetails?.customer_status_id !== null && vaspDetails?.customer_status_id !== undefined && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $29cc45482f452abc$export$987cac99e7a31168), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $29cc45482f452abc$export$b04be29aa201d4f5), {
                                    children: "Status: "
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $29cc45482f452abc$export$15529022dcaf3eec), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $29cc45482f452abc$export$5a7f9a6004988d01), {
                                        customer_status_id: vaspDetails.customer_status_id,
                                        children: (0, $6513bd8c592cec6e$export$6300bf49fafd172)?.[vaspDetails?.customer_status_id]?.label || 'N/A'
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $29cc45482f452abc$export$987cac99e7a31168), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $29cc45482f452abc$export$b04be29aa201d4f5), {
                                    children: "Website: "
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $29cc45482f452abc$export$5f1af8db9871e1d6), {
                                    children: vaspDetails?.website || 'NA'
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $29cc45482f452abc$export$987cac99e7a31168), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $29cc45482f452abc$export$b04be29aa201d4f5), {
                                    children: "Email: "
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $29cc45482f452abc$export$5f1af8db9871e1d6), {
                                    children: vaspDetails?.email_contact || 'NA'
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $29cc45482f452abc$export$987cac99e7a31168), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $29cc45482f452abc$export$b04be29aa201d4f5), {
                                    children: "Latest update: "
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $29cc45482f452abc$export$5f1af8db9871e1d6), {
                                    children: (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(vaspDetails?.created).format((0, $41a9e38e6be32f35$export$859ef203c4495ed2))
                                })
                            ]
                        })
                    ]
                })
            ]
        }, vaspDetails?.external_id)
    });
}
// Default Props
$1eb2fc81b7038786$var$AdminVaspsTableItem.defaultProps = {};
// Proptypes Validation
$1eb2fc81b7038786$var$AdminVaspsTableItem.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    vaspDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).any,
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setApproveVaspModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setApproveVaspDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setRejectVaspModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setRejectVaspDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isRejectVaspModalOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
        rejectVaspDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            vasp_name: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            vasp_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
        })
    })
};
var $1eb2fc81b7038786$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($1eb2fc81b7038786$var$mapStateToProps, $1eb2fc81b7038786$var$mapDispatchToProps)($1eb2fc81b7038786$var$AdminVaspsTableItem);


var $b404bb7a7ddf5362$export$2e2bcd8739ae039 = (0, $1eb2fc81b7038786$export$2e2bcd8739ae039);


// Map Redux Props
const $ca092c7434c48be5$var$mapStateToProps = (state)=>state;
const $ca092c7434c48be5$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $ca092c7434c48be5$var$AdminVaspsTable(props) {
    // Destructure
    const { filters: filters, ui: ui, actions: actions } = props;
    // Store States
    const { vaspDirectoryFilters: vaspDirectoryFilters } = filters;
    const { isPageTableUpdated: isPageTableUpdated } = ui;
    // Store Actions
    const { setVaspDirectoryFilters: setVaspDirectoryFilters, setIsPageTableUpdated: setIsPageTableUpdated, setIsVaspDrawerOpen: setIsVaspDrawerOpen } = actions;
    // Variables
    const { sort: sort, page: page, size: size } = vaspDirectoryFilters;
    // States
    const [vaspsDataState, setVaspsDataState] = (0, $tZqWC.useState)({
        items: [],
        total: 0
    });
    // Hooks
    const [userCredentials] = (0, $a9c50ebe96619b20$export$2e2bcd8739ae039)('userCredentials', false);
    const { allVaspsData: allVaspsData, getAllVasps: getAllVasps, isAllVaspsLoading: isAllVaspsLoading } = (0, $40506d7d94723792$export$2e2bcd8739ae039)();
    // Functions
    const fetchVasps = ()=>{
        getAllVasps({
            biz_id: userCredentials.Business_ID,
            sort: sort,
            page: page,
            size: size
        });
    };
    // UseEffects
    (0, $tZqWC.useEffect)(()=>{
        if (allVaspsData) setVaspsDataState(allVaspsData);
    }, [
        allVaspsData
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (vaspDirectoryFilters || isPageTableUpdated) {
            fetchVasps();
            setIsPageTableUpdated(false);
        }
    }, [
        vaspDirectoryFilters,
        isPageTableUpdated
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3f0fc2678641bcda$export$4267411171632d35), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7139282abdeb8ca4$export$2e2bcd8739ae039), {
            totalItems: vaspsDataState.total,
            minWidth: 900,
            filterComponents: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d3cd0ff9e1046ed5$export$2e2bcd8739ae039), {}),
            tableFilters: vaspDirectoryFilters,
            setTableFilters: setVaspDirectoryFilters,
            headerOptions: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                size: "small",
                startIcon: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6417d0fa9c066aa3$export$2e2bcd8739ae039), {
                    size: 18
                }),
                onClick: ()=>setIsVaspDrawerOpen(true),
                children: "Vasp"
            }),
            children: vaspsDataState.items.length > 0 && !isAllVaspsLoading ? vaspsDataState.items.map((vaspDetails)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b404bb7a7ddf5362$export$2e2bcd8739ae039), {
                    vaspDetails: vaspDetails
                }, vaspDetails?.id)) : /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("div", {
                children: isAllVaspsLoading ? /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $647b8bc68ebce54f$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a6ea3b0f3caed586$export$2e2bcd8739ae039), {
                    setFilter: setVaspDirectoryFilters
                })
            })
        })
    });
}
// Default Props
$ca092c7434c48be5$var$AdminVaspsTable.defaultProps = {
    actions: {},
    filters: {},
    ui: {}
};
// Proptypes Validation
$ca092c7434c48be5$var$AdminVaspsTable.propTypes = {
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        vaspDirectoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object)
    }),
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setVaspDirectoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setToBeUpdatedVasp: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsVaspDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsEntityVaspDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $ca092c7434c48be5$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($ca092c7434c48be5$var$mapStateToProps, $ca092c7434c48be5$var$mapDispatchToProps)($ca092c7434c48be5$var$AdminVaspsTable);


var $56c27cbcc0484062$export$2e2bcd8739ae039 = (0, $ca092c7434c48be5$export$2e2bcd8739ae039);





var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");



const $a15489b787ecfdd3$export$e6dfd72ab29f8598 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
`;
const $a15489b787ecfdd3$export$518140168539ec9f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-end;
  margin: 0 0 -40px 0;
`;
const $a15489b787ecfdd3$export$f7572adddafd5ab7 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-end;
  gap: 20px;
  margin-top: 40px;
`;
const $a15489b787ecfdd3$export$f99233281efd08a0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h1`
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  text-transform: uppercase;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $a15489b787ecfdd3$export$cf345ef34cd72655 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  margin: 0;
  font-size: 10px;
  font-weight: 400;
  letter-spacing: 0.5px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $a15489b787ecfdd3$export$42a852a2b6b56249 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  margin-top: 20px;
  padding: 30px;
  border-radius: 10px;
  background: ${({ theme: theme })=>theme.colors.background};
`;
const $a15489b787ecfdd3$export$33203cad3bced98c = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  padding-top: 40px;
  max-width: 500px;
`;
const $a15489b787ecfdd3$export$b59bdbef9ce70de2 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 2px solid ${({ theme: theme })=>theme.colors.backgroundLite};

  &:last-child {
    border: none;
    padding: 10px 0 0 0;
  }
`;
const $a15489b787ecfdd3$export$99836757d2dc7b18 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 15px;
  font-weight: 600;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $a15489b787ecfdd3$export$5f1af8db9871e1d6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 15px;
  font-weight: 400;
  color: ${({ theme: theme })=>theme.colors.primary};
`;





var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");


const $e446f427009a34b7$export$6f9bd4784b79a579 = (obj1, obj2)=>{
    /** *
   * @description ! The order in the params for this function matters!
   * The first one will be the final result
   * the second param is the basis of what needs to be removed
   * * */ const result = {};
    Object.entries(obj1).forEach(([key, value])=>{
        if (obj2[key] !== value) result[key] = value;
    });
    return result;
};







const $babe25dab89141f6$export$e6dfd72ab29f8598 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
`;
const $babe25dab89141f6$export$518140168539ec9f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  margin: 0 0 -40px 0;
`;
const $babe25dab89141f6$export$61a3ae60c82d8e12 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 16px;
`;
const $babe25dab89141f6$export$f99233281efd08a0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h1`
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  text-transform: uppercase;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $babe25dab89141f6$export$cf345ef34cd72655 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  margin: 0;
  font-size: 10px;
  font-weight: 400;
  letter-spacing: 0.5px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $babe25dab89141f6$export$42a852a2b6b56249 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  margin-top: 20px;
  padding: 30px;
  border-radius: 10px;
  background: ${({ theme: theme })=>theme.colors.background};
`;
const $babe25dab89141f6$export$33203cad3bced98c = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  padding-top: 40px;
  max-width: 500px;
`;
const $babe25dab89141f6$export$b59bdbef9ce70de2 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 2px solid ${({ theme: theme })=>theme.colors.backgroundLite};

  &:last-child {
    border: none;
    padding: 10px 0 0 0;
  }
`;
const $babe25dab89141f6$export$99836757d2dc7b18 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 15px;
  font-weight: 600;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $babe25dab89141f6$export$5f1af8db9871e1d6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 15px;
  font-weight: 400;
  color: ${({ theme: theme })=>theme.colors.primary};
`;




// Map Redux Props
const $b8777ad2ec572318$var$mapStateToProps = (state)=>state;
const $b8777ad2ec572318$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $b8777ad2ec572318$var$DetailsTab(props) {
    // Destructure
    const { actions: actions, ui: ui } = props;
    const { vasp_id: vasp_id } = (0, $a0d5c3f2fe524011$export$99eaa27ddbbb95ef)();
    const { isPageTableUpdated: isPageTableUpdated } = ui;
    // store actions
    const { setShowHeaderLoader: setShowHeaderLoader, showAlert: showAlert, setApproveVaspModal: setApproveVaspModal, setApproveVaspDetails: setApproveVaspDetails, setRejectVaspModal: setRejectVaspModal, setRejectVaspDetails: setRejectVaspDetails, setIsPageTableUpdated: setIsPageTableUpdated } = actions;
    // refs
    const formRef = (0, $tZqWC.useRef)();
    // hooks
    const { getVasp: getVasp, vaspData: vaspData, isVaspLoading: isVaspLoading } = (0, $462c3808bdeaeab0$export$2e2bcd8739ae039)();
    const { updateVasp: updateVasp, vaspUpdateError: vaspUpdateError, isVaspUpdateSuccess: isVaspUpdateSuccess, isVaspUpdateError: isVaspUpdateError, isVaspUpdateLoading: isVaspUpdateLoading } = (0, $05f6f04b561b761e$export$2e2bcd8739ae039)();
    // state
    const [vaspDataState, setVaspDataState] = (0, $tZqWC.useState)();
    const [viewMode, setViewMode] = (0, $tZqWC.useState)(true);
    // Functions
    const handleNotifyVasp = ()=>{
        setApproveVaspDetails({
            vasp_id: vaspDataState?.id,
            vasp_name: vaspDataState?.name_legal
        });
        setApproveVaspModal(true);
    };
    const handleRejectVasp = ()=>{
        setRejectVaspDetails({
            vasp_id: vaspDataState?.id,
            vasp_name: vaspDataState?.name_legal,
            customer_status_id: vaspDataState?.customer_status_id
        });
        setRejectVaspModal(true);
    };
    const fetchData = ()=>{
        getVasp({
            vasp_id: vasp_id
        });
    };
    const handleSave = ()=>{
        const finalValues = (0, $e446f427009a34b7$export$6f9bd4784b79a579)(formRef?.current?.values, vaspDataState);
        updateVasp({
            vasp_id: vasp_id,
            values: finalValues
        });
    };
    const handleCancel = ()=>{
        setViewMode(true);
        if (formRef.current) formRef.current.resetForm();
    };
    const handleSuccess = ()=>{
        if (formRef.current) formRef.current.resetForm({
            values: formRef.current?.values
        });
        setVaspDataState(formRef.current?.values);
        showAlert({
            type: 'success',
            message: 'Successfully updated details'
        });
        setViewMode(true);
    };
    const handleFailure = ()=>{
        if (vaspUpdateError?.response?.data?.context?.error) showAlert({
            type: 'error',
            message: vaspUpdateError?.response?.data?.context?.error
        });
        else showAlert({
            type: 'error',
            message: 'An error occurred in updating details'
        });
    };
    const loading = isVaspLoading || isVaspUpdateLoading;
    const handleLoading = ()=>{
        if (loading) setShowHeaderLoader(true);
        if (!loading) setShowHeaderLoader(false);
    };
    // useEffect
    (0, $tZqWC.useEffect)(()=>fetchData(), []);
    (0, $tZqWC.useEffect)(()=>{
        if (isPageTableUpdated) {
            fetchData();
            setIsPageTableUpdated(false);
        }
    }, [
        isPageTableUpdated
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (vaspData) setVaspDataState(vaspData);
    }, [
        vaspData
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (isVaspUpdateSuccess) handleSuccess();
    }, [
        isVaspUpdateSuccess
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (isVaspUpdateError) handleFailure();
    }, [
        isVaspUpdateError
    ]);
    (0, $tZqWC.useEffect)(()=>handleLoading(), [
        loading
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $babe25dab89141f6$export$42a852a2b6b56249), {
        children: !isVaspLoading && vaspDataState && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
            children: [
                viewMode === true && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $babe25dab89141f6$export$518140168539ec9f), {
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $babe25dab89141f6$export$f99233281efd08a0), {
                            children: vaspDataState.name_legal
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $babe25dab89141f6$export$61a3ae60c82d8e12), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                    color: "primary",
                                    disabled: loading,
                                    onClick: ()=>setViewMode(false),
                                    children: "Edit"
                                }),
                                vaspDataState?.customer_status_id === (0, $6513bd8c592cec6e$export$9dfee4db1c22f5c3).Requested && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                            color: "secondary",
                                            disabled: loading,
                                            onClick: handleRejectVasp,
                                            children: "Reject"
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                            variant: "primary",
                                            disabled: loading,
                                            onClick: handleNotifyVasp,
                                            children: "Approve"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                viewMode === false && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $babe25dab89141f6$export$518140168539ec9f), {
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $babe25dab89141f6$export$f99233281efd08a0), {
                            children: vaspDataState.name_legal
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $babe25dab89141f6$export$61a3ae60c82d8e12), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                    type: "button",
                                    disabled: loading,
                                    onClick: handleCancel,
                                    variant: "outlined",
                                    startIcon: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b77b5de3fb591045$export$2e2bcd8739ae039), {
                                        size: 18
                                    }),
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                    type: "button",
                                    disabled: loading,
                                    onClick: handleSave,
                                    startIcon: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $462cc6e9cac360f1$export$2e2bcd8739ae039), {
                                        size: 18
                                    }),
                                    children: "Save Changes"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $31c31aa6819313d7$export$2e2bcd8739ae039), {
                    style: {
                        paddingTop: '50px'
                    },
                    values: vaspDataState,
                    viewMode: viewMode,
                    formRef: formRef
                })
            ]
        })
    });
}
// Default Props
$b8777ad2ec572318$var$DetailsTab.defaultProps = {
    actions: {},
    filters: {},
    ui: {}
};
// Proptypes Validation
$b8777ad2ec572318$var$DetailsTab.propTypes = {
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        vaspDirectoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object)
    }),
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setVaspDirectoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsIndividualVaspDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsEntityVaspDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setApproveVaspModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setApproveVaspDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setRejectVaspModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setRejectVaspDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $b8777ad2ec572318$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($b8777ad2ec572318$var$mapStateToProps, $b8777ad2ec572318$var$mapDispatchToProps)($b8777ad2ec572318$var$DetailsTab);


var $26688999865a4a0a$export$2e2bcd8739ae039 = (0, $b8777ad2ec572318$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");





const $633085a10464645c$export$42a852a2b6b56249 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-end;
  width: 100%;

  & button {
    margin-bottom: 20px;
  }
`;





var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");







const $9c3e0e1e441f36ac$export$ac7496df4f1f837a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: 100%;
`;
const $9c3e0e1e441f36ac$export$e151f1d86035b485 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  & > div > div {
    margin-bottom: 0 !important;
  }
`;
const $9c3e0e1e441f36ac$export$8f1ff89fa1ec9605 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  align-items: start;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  gap: 10px 60px;
`;
const $9c3e0e1e441f36ac$export$71c7816ee3a5a527 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h4`
  font-size: 15px;
  font-weight: 600;
  margin: 20px 0 0 10px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $9c3e0e1e441f36ac$export$fd2299f554be8993 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: 1fr 25px;
  gap: 50px;
  align-items: center;

  padding: 10px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $9c3e0e1e441f36ac$export$9f515a68dfaeb9ef = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  align-items: center;

  width: 100%;

  gap: 20px;

  & :first-child {
    align-items: flex-start;
  }
  & :last-child {
    align-items: flex-end;
  }
`;
const $9c3e0e1e441f36ac$export$85524e8d4e82fc69 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
const $9c3e0e1e441f36ac$export$d53c836cccbb0d90 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
`;
const $9c3e0e1e441f36ac$export$f99233281efd08a0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-weight: 600;
`;
const $9c3e0e1e441f36ac$export$d5c56664638992a4 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 12px;
  font-weight: 300;
`;
const $9c3e0e1e441f36ac$export$87ad169bde460ddf = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;




// Map Redux Props
const $1511b386c1af8223$var$mapStateToProps = (state)=>state;
const $1511b386c1af8223$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $1511b386c1af8223$var$UsersTabItem(props) {
    // Destructure
    const { actions: actions, values: values } = props;
    const { vasp_id: vasp_id } = (0, $a0d5c3f2fe524011$export$99eaa27ddbbb95ef)();
    // Store Actions
    const { showAlert: showAlert } = actions;
    const { updateVaspUser: updateVaspUser, updateVaspUserError: updateVaspUserError, isUpdateVaspUserLoading: isUpdateVaspUserLoading, isUpdateVaspUserSuccess: isUpdateVaspUserSuccess, isUpdateVaspUserError: isUpdateVaspUserError } = (0, $bf926cd3de297aa0$export$2e2bcd8739ae039)();
    const { createUserActivationLink: createUserActivationLink, createUserActivationLinkError: createUserActivationLinkError, isCreateUserActivationLinkLoading: isCreateUserActivationLinkLoading, isCreateUserActivationLinkSuccess: isCreateUserActivationLinkSuccess } = (0, $53f9d00d6955a0cf$export$2e2bcd8739ae039)();
    // Variables
    const isLoading = isCreateUserActivationLinkLoading || isUpdateVaspUserLoading;
    // state
    const [initialData, setInitialData] = (0, $tZqWC.useState)();
    const [viewMode, setViewMode] = (0, $tZqWC.useState)(true);
    const [isDetailsExpanded, setIsDetailsExpanded] = (0, $tZqWC.useState)(false);
    // Refs
    const formRef = (0, $tZqWC.useRef)();
    // Functions
    const handleCancel = ()=>{
        setViewMode(true);
        if (formRef.current) formRef.current.resetForm();
    };
    const handleSave = (initial)=>{
        const finalValues = (0, $e446f427009a34b7$export$6f9bd4784b79a579)(formRef?.current?.values, initial);
        finalValues.id = formRef?.current?.values?.id;
        updateVaspUser({
            vasp_id: vasp_id,
            ...finalValues
        });
    };
    const handleSuccess = ()=>{
        if (formRef.current) formRef.current.resetForm({
            values: formRef.current?.values
        });
        setInitialData(formRef.current?.values);
        showAlert({
            type: 'success',
            message: 'Successfully updated record'
        });
        setViewMode(true);
    };
    const handleFailure = ()=>{
        if (updateVaspUserError?.response?.data?.context?.error) showAlert({
            type: 'error',
            message: updateVaspUserError?.response?.data?.context?.error
        });
        else showAlert({
            type: 'error',
            message: 'An error occurred in updating record'
        });
    };
    // UseEffects
    (0, $tZqWC.useEffect)(()=>{
        setInitialData(values);
    }, []);
    (0, $tZqWC.useEffect)(()=>{
        if (isUpdateVaspUserSuccess) handleSuccess();
    }, [
        isUpdateVaspUserSuccess
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (isUpdateVaspUserError) handleFailure();
    }, [
        isUpdateVaspUserError
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (createUserActivationLinkError) showAlert({
            type: 'error',
            message: 'An error occurred in sending activation link'
        });
    }, [
        createUserActivationLinkError
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (isCreateUserActivationLinkSuccess) showAlert({
            type: 'success',
            message: 'Successfully sent activation link'
        });
    }, [
        isCreateUserActivationLinkSuccess
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9c3e0e1e441f36ac$export$ac7496df4f1f837a), {
        children: initialData && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b3f7dc6528742bb0$export$2e2bcd8739ae039), {
            setIsExpanded: (val)=>{
                setIsDetailsExpanded(val);
            },
            expandPanel: isDetailsExpanded,
            button: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9c3e0e1e441f36ac$export$fd2299f554be8993), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9c3e0e1e441f36ac$export$9f515a68dfaeb9ef), {
                    isExpanded: isDetailsExpanded,
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9c3e0e1e441f36ac$export$87ad169bde460ddf), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9c3e0e1e441f36ac$export$f99233281efd08a0), {
                                    children: `${initialData?.name_first || 'First Name'} ${initialData?.name_last || 'Last Name'} `
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9c3e0e1e441f36ac$export$d5c56664638992a4), {
                                    children: "Name of User"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9c3e0e1e441f36ac$export$87ad169bde460ddf), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9c3e0e1e441f36ac$export$f99233281efd08a0), {
                                    children: `${(0, $f398806f8c37b1c3$export$d34134843134085a)?.[initialData?.role_id]?.label || 'User Role'}`
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9c3e0e1e441f36ac$export$d5c56664638992a4), {
                                    children: "User Role"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9c3e0e1e441f36ac$export$87ad169bde460ddf), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9c3e0e1e441f36ac$export$f99233281efd08a0), {
                                    children: `${initialData?.is_active ? 'Active' : 'Inactive'}`
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9c3e0e1e441f36ac$export$d5c56664638992a4), {
                                    children: "Status"
                                })
                            ]
                        })
                    ]
                })
            }),
            panel: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $da8de0476a978994$export$2e2bcd8739ae039), {
                        formRef: formRef,
                        values: initialData,
                        viewMode: viewMode
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9c3e0e1e441f36ac$export$d53c836cccbb0d90), {
                        children: [
                            initialData?.is_active === false && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                onClick: ()=>createUserActivationLink({
                                        user_id: initialData?.user_id
                                    }),
                                disabled: isLoading,
                                children: "Send Activation"
                            }),
                            viewMode && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                color: "primary",
                                onClick: ()=>setViewMode(false),
                                children: "Edit"
                            }),
                            !viewMode && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                        variant: "outlined",
                                        onClick: handleCancel,
                                        disabled: isLoading,
                                        children: "Cancel"
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                        onClick: ()=>handleSave(initialData),
                                        disabled: isLoading,
                                        children: "Save"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}
// Default Props
$1511b386c1af8223$var$UsersTabItem.defaultProps = {
    actions: {},
    values: {}
};
// Proptypes Validation
$1511b386c1af8223$var$UsersTabItem.propTypes = {
    values: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({}),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setVaspDirectoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsIndividualVaspDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsEntityVaspDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setApproveVaspModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setApproveVaspDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setRejectVaspModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setRejectVaspDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $1511b386c1af8223$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($1511b386c1af8223$var$mapStateToProps, $1511b386c1af8223$var$mapDispatchToProps)($1511b386c1af8223$var$UsersTabItem);


var $0abdfc1c2cfcd3cf$export$2e2bcd8739ae039 = (0, $1511b386c1af8223$export$2e2bcd8739ae039);


// Map Redux Props
const $8daca969055cb1ac$var$mapStateToProps = (state)=>state;
const $8daca969055cb1ac$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $8daca969055cb1ac$var$UsersTab(props) {
    // Destructure
    const { actions: actions, ui: ui } = props;
    const { isPageTableUpdated: isPageTableUpdated } = ui;
    const { setIsUserDrawerOpen: setIsUserDrawerOpen, setIsPageTableUpdated: setIsPageTableUpdated } = actions;
    const { vasp_id: vasp_id } = (0, $a0d5c3f2fe524011$export$99eaa27ddbbb95ef)();
    // hooks
    const { getVaspUsers: getVaspUsers, getVaspUsersData: getVaspUsersData, isGetVaspUsersLoading: isGetVaspUsersLoading } = (0, $6c23fdd432274929$export$2e2bcd8739ae039)();
    // state
    const [vaspUsers, setVaspUsers] = (0, $tZqWC.useState)();
    // Functions
    const fetchData = ()=>{
        getVaspUsers({
            vasp_id: vasp_id
        });
    };
    // UseEffects
    (0, $tZqWC.useEffect)(()=>fetchData(), []);
    (0, $tZqWC.useEffect)(()=>{
        if (isPageTableUpdated) {
            fetchData();
            setIsPageTableUpdated(false);
        }
    }, [
        isPageTableUpdated
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (getVaspUsersData) setVaspUsers(getVaspUsersData);
    }, [
        getVaspUsersData
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $633085a10464645c$export$42a852a2b6b56249), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                onClick: ()=>setIsUserDrawerOpen(true),
                children: "Add User"
            }),
            !isGetVaspUsersLoading && vaspUsers && vaspUsers?.map((item)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $0abdfc1c2cfcd3cf$export$2e2bcd8739ae039), {
                    values: item
                }, item?.id))
        ]
    });
}
// Default Props
$8daca969055cb1ac$var$UsersTab.defaultProps = {
    actions: {},
    filters: {},
    ui: {}
};
// Proptypes Validation
$8daca969055cb1ac$var$UsersTab.propTypes = {
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        vaspDirectoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object)
    }),
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setIsUserDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsEntityVaspDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setApproveVaspModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setApproveVaspDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setRejectVaspModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setRejectVaspDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $8daca969055cb1ac$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($8daca969055cb1ac$var$mapStateToProps, $8daca969055cb1ac$var$mapDispatchToProps)($8daca969055cb1ac$var$UsersTab);


// Map Redux Props
const $0c144c7ac0a997d3$var$mapStateToProps = (state)=>state;
const $0c144c7ac0a997d3$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $0c144c7ac0a997d3$var$AdminVaspDetails() {
    // state
    const [page, setPage] = (0, $tZqWC.useState)(0);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $a15489b787ecfdd3$export$e6dfd72ab29f8598), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7a41226ac8681faa$export$2e2bcd8739ae039), {
                page: page,
                setPage: setPage
            }),
            page === 0 && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $26688999865a4a0a$export$2e2bcd8739ae039), {}),
            page === 1 && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $8daca969055cb1ac$export$2e2bcd8739ae039), {})
        ]
    });
}
// Default Props
$0c144c7ac0a997d3$var$AdminVaspDetails.defaultProps = {
    actions: {},
    filters: {},
    ui: {}
};
// Proptypes Validation
$0c144c7ac0a997d3$var$AdminVaspDetails.propTypes = {
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        vaspDirectoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object)
    }),
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setVaspDirectoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsIndividualVaspDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsEntityVaspDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $0c144c7ac0a997d3$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($0c144c7ac0a997d3$var$mapStateToProps, $0c144c7ac0a997d3$var$mapDispatchToProps)($0c144c7ac0a997d3$var$AdminVaspDetails);


var $036da670f35f4334$export$2e2bcd8739ae039 = (0, $0c144c7ac0a997d3$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");





const $480076819f75a1d1$export$4267411171632d35 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $480076819f75a1d1$export$cbf11d5f692bc726 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
`;
const $480076819f75a1d1$export$97d84ed62ab03b3f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  margin: 0px 0px 0px 16px;

  font-weight: inherit;
  font-size: inherit;
`;





// Map Redux Props
const $a6c28510a069f110$var$mapStateToProps = (state)=>state;
const $a6c28510a069f110$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $a6c28510a069f110$var$AdminRequestedVaspsTable(props) {
    // Destructure
    const { filters: filters, ui: ui, actions: actions } = props;
    // Store States
    const { vaspDirectoryFilters: vaspDirectoryFilters } = filters;
    const { isPageTableUpdated: isPageTableUpdated } = ui;
    // Store Actions
    const { setVaspDirectoryFilters: setVaspDirectoryFilters, setIsPageTableUpdated: setIsPageTableUpdated } = actions;
    // Variables
    const { sort: sort, page: page, size: size } = vaspDirectoryFilters;
    // States
    const [vaspsDataState, setVaspsDataState] = (0, $tZqWC.useState)({
        items: [],
        total: 0
    });
    // Hooks
    const [userCredentials] = (0, $a9c50ebe96619b20$export$2e2bcd8739ae039)('userCredentials', false);
    const { allVaspsData: allVaspsData, getAllVasps: getAllVasps, isAllVaspsLoading: isAllVaspsLoading } = (0, $40506d7d94723792$export$2e2bcd8739ae039)();
    // Functions
    const fetchVasps = ()=>{
        getAllVasps({
            biz_id: userCredentials.Business_ID,
            sort: sort,
            page: page,
            size: size,
            customer_status_id: -1
        });
    };
    // UseEffects
    (0, $tZqWC.useEffect)(()=>{
        if (allVaspsData) setVaspsDataState(allVaspsData);
    }, [
        allVaspsData
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (vaspDirectoryFilters || isPageTableUpdated) {
            fetchVasps();
            setIsPageTableUpdated(false);
        }
    }, [
        vaspDirectoryFilters,
        isPageTableUpdated
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $480076819f75a1d1$export$4267411171632d35), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7139282abdeb8ca4$export$2e2bcd8739ae039), {
            totalItems: vaspsDataState.total,
            minWidth: 900,
            filterComponents: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b6d9d515100cd1b1$export$2e2bcd8739ae039), {}),
            tableFilters: vaspDirectoryFilters,
            setTableFilters: setVaspDirectoryFilters,
            children: vaspsDataState.items.length > 0 && !isAllVaspsLoading ? vaspsDataState.items.map((vaspDetails)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b404bb7a7ddf5362$export$2e2bcd8739ae039), {
                    vaspDetails: vaspDetails,
                    isRequestedVasp: true
                }, vaspDetails?.id)) : /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("div", {
                children: isAllVaspsLoading ? /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $647b8bc68ebce54f$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a6ea3b0f3caed586$export$2e2bcd8739ae039), {
                    setFilter: setVaspDirectoryFilters
                })
            })
        })
    });
}
// Default Props
$a6c28510a069f110$var$AdminRequestedVaspsTable.defaultProps = {
    actions: {},
    filters: {},
    ui: {}
};
// Proptypes Validation
$a6c28510a069f110$var$AdminRequestedVaspsTable.propTypes = {
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        vaspDirectoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object)
    }),
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setVaspDirectoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setToBeUpdatedVasp: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsVaspDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsEntityVaspDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $a6c28510a069f110$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($a6c28510a069f110$var$mapStateToProps, $a6c28510a069f110$var$mapDispatchToProps)($a6c28510a069f110$var$AdminRequestedVaspsTable);


var $39c621e1ae69d168$export$2e2bcd8739ae039 = (0, $a6c28510a069f110$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");





const $fc11d70a2cf58dea$export$4267411171632d35 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $fc11d70a2cf58dea$export$cbf11d5f692bc726 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
`;
const $fc11d70a2cf58dea$export$97d84ed62ab03b3f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  margin: 0px 0px 0px 16px;

  font-weight: inherit;
  font-size: inherit;
`;




// Map Redux Props
const $8a83dc56043bf79b$var$mapStateToProps = (state)=>state;
const $8a83dc56043bf79b$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $8a83dc56043bf79b$var$AdminCustomerVaspsTable(props) {
    // Destructure
    const { filters: filters, ui: ui, actions: actions } = props;
    // Store States
    const { vaspDirectoryFilters: vaspDirectoryFilters } = filters;
    const { isPageTableUpdated: isPageTableUpdated } = ui;
    // Store Actions
    const { setVaspDirectoryFilters: setVaspDirectoryFilters, setIsPageTableUpdated: setIsPageTableUpdated } = actions;
    // Variables
    const { sort: sort, page: page, size: size } = vaspDirectoryFilters;
    // States
    const [vaspsDataState, setVaspsDataState] = (0, $tZqWC.useState)({
        items: [],
        total: 0
    });
    // Hooks
    const [userCredentials] = (0, $a9c50ebe96619b20$export$2e2bcd8739ae039)('userCredentials', false);
    const { allVaspsData: allVaspsData, getAllVasps: getAllVasps, isAllVaspsLoading: isAllVaspsLoading } = (0, $40506d7d94723792$export$2e2bcd8739ae039)();
    // Functions
    const fetchVasps = ()=>{
        getAllVasps({
            biz_id: userCredentials.Business_ID,
            sort: sort,
            page: page,
            size: size,
            customer_status_id: 1
        });
    };
    // UseEffects
    (0, $tZqWC.useEffect)(()=>{
        if (allVaspsData) setVaspsDataState(allVaspsData);
    }, [
        allVaspsData
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (vaspDirectoryFilters || isPageTableUpdated) {
            fetchVasps();
            setIsPageTableUpdated(false);
        }
    }, [
        vaspDirectoryFilters,
        isPageTableUpdated
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $fc11d70a2cf58dea$export$4267411171632d35), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7139282abdeb8ca4$export$2e2bcd8739ae039), {
            totalItems: vaspsDataState.total,
            minWidth: 900,
            tableFilters: vaspDirectoryFilters,
            setTableFilters: setVaspDirectoryFilters,
            children: vaspsDataState.items.length > 0 && !isAllVaspsLoading ? vaspsDataState.items.map((vaspDetails)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b404bb7a7ddf5362$export$2e2bcd8739ae039), {
                    vaspDetails: vaspDetails,
                    isRequestedVasp: true
                }, vaspDetails?.id)) : /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("div", {
                children: isAllVaspsLoading ? /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $647b8bc68ebce54f$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a6ea3b0f3caed586$export$2e2bcd8739ae039), {
                    setFilter: setVaspDirectoryFilters
                })
            })
        })
    });
}
// Default Props
$8a83dc56043bf79b$var$AdminCustomerVaspsTable.defaultProps = {
    actions: {},
    filters: {},
    ui: {}
};
// Proptypes Validation
$8a83dc56043bf79b$var$AdminCustomerVaspsTable.propTypes = {
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        vaspDirectoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object)
    }),
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setVaspDirectoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setToBeUpdatedVasp: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsVaspDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsEntityVaspDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $8a83dc56043bf79b$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($8a83dc56043bf79b$var$mapStateToProps, $8a83dc56043bf79b$var$mapDispatchToProps)($8a83dc56043bf79b$var$AdminCustomerVaspsTable);


var $ce8438c9ffc053f6$export$2e2bcd8739ae039 = (0, $8a83dc56043bf79b$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");





const $e62e2b2ea8b264ac$export$4267411171632d35 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $e62e2b2ea8b264ac$export$cbf11d5f692bc726 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
`;
const $e62e2b2ea8b264ac$export$97d84ed62ab03b3f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  margin: 0px 0px 0px 16px;

  font-weight: inherit;
  font-size: inherit;
`;




// Map Redux Props
const $4a3ef6c95539874a$var$mapStateToProps = (state)=>state;
const $4a3ef6c95539874a$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $4a3ef6c95539874a$var$AdminMidProspectVaspsTable(props) {
    // Destructure
    const { filters: filters, ui: ui, actions: actions } = props;
    // Store States
    const { vaspDirectoryFilters: vaspDirectoryFilters } = filters;
    const { isPageTableUpdated: isPageTableUpdated } = ui;
    // Store Actions
    const { setVaspDirectoryFilters: setVaspDirectoryFilters, setIsPageTableUpdated: setIsPageTableUpdated } = actions;
    // Variables
    const { sort: sort, page: page, size: size } = vaspDirectoryFilters;
    // States
    const [vaspsDataState, setVaspsDataState] = (0, $tZqWC.useState)({
        items: [],
        total: 0
    });
    // Hooks
    const [userCredentials] = (0, $a9c50ebe96619b20$export$2e2bcd8739ae039)('userCredentials', false);
    const { allVaspsData: allVaspsData, getAllVasps: getAllVasps, isAllVaspsLoading: isAllVaspsLoading } = (0, $40506d7d94723792$export$2e2bcd8739ae039)();
    // Functions
    const fetchVasps = ()=>{
        getAllVasps({
            biz_id: userCredentials.Business_ID,
            sort: sort,
            page: page,
            size: size,
            customer_status_id: 2
        });
    };
    // UseEffects
    (0, $tZqWC.useEffect)(()=>{
        if (allVaspsData) setVaspsDataState(allVaspsData);
    }, [
        allVaspsData
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (vaspDirectoryFilters || isPageTableUpdated) {
            fetchVasps();
            setIsPageTableUpdated(false);
        }
    }, [
        vaspDirectoryFilters,
        isPageTableUpdated
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e62e2b2ea8b264ac$export$4267411171632d35), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7139282abdeb8ca4$export$2e2bcd8739ae039), {
            totalItems: vaspsDataState.total,
            minWidth: 900,
            tableFilters: vaspDirectoryFilters,
            setTableFilters: setVaspDirectoryFilters,
            children: vaspsDataState.items.length > 0 && !isAllVaspsLoading ? vaspsDataState.items.map((vaspDetails)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b404bb7a7ddf5362$export$2e2bcd8739ae039), {
                    vaspDetails: vaspDetails,
                    isRequestedVasp: true
                }, vaspDetails?.id)) : /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("div", {
                children: isAllVaspsLoading ? /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $647b8bc68ebce54f$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a6ea3b0f3caed586$export$2e2bcd8739ae039), {
                    setFilter: setVaspDirectoryFilters
                })
            })
        })
    });
}
// Default Props
$4a3ef6c95539874a$var$AdminMidProspectVaspsTable.defaultProps = {
    actions: {},
    filters: {},
    ui: {}
};
// Proptypes Validation
$4a3ef6c95539874a$var$AdminMidProspectVaspsTable.propTypes = {
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        vaspDirectoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object)
    }),
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setVaspDirectoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setToBeUpdatedVasp: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsVaspDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsEntityVaspDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $4a3ef6c95539874a$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($4a3ef6c95539874a$var$mapStateToProps, $4a3ef6c95539874a$var$mapDispatchToProps)($4a3ef6c95539874a$var$AdminMidProspectVaspsTable);


var $69078ec0630cc6d2$export$2e2bcd8739ae039 = (0, $4a3ef6c95539874a$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");





const $595f4f5ef06dda44$export$e6dfd72ab29f8598 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
`;
const $595f4f5ef06dda44$export$b13648308b87115 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  background-color: ${({ theme: theme })=>theme.colors.background};
  padding: 0 20px 20px 20px;
  border-radius: 16px;
`;
const $595f4f5ef06dda44$export$ac7496df4f1f837a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
  font-size: 14.5px;
  font-weight: 400;
  width: 100%;
`;
const $595f4f5ef06dda44$export$87ad169bde460ddf = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  font-size: 14.5px;
  font-weight: 400;
  width: 100%;
`;
const $595f4f5ef06dda44$export$d53c836cccbb0d90 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-end;
  gap: 5px;
  width: 100%;
`;
const $595f4f5ef06dda44$export$f99233281efd08a0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  color: ${({ theme: theme })=>theme.colors.primary};
  width: 100%;
  font-size: 20px;
`;
const $595f4f5ef06dda44$export$edf27be85e5f6da0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  color: ${({ theme: theme })=>theme.colors.red};
  width: 100%;
  font-size: 20px;
`;
const $595f4f5ef06dda44$export$5f1af8db9871e1d6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  color: ${({ theme: theme })=>theme.colors.primary};
  width: 100%;
  font-size: 14px;
`;






var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");






/* eslint-disable react/no-unstable-nested-components */ 

var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");




const $30719f968e028273$export$fd2299f554be8993 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 50px;
  align-items: center;

  padding: 10px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $30719f968e028273$export$9f515a68dfaeb9ef = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  gap: 20px;

  &:last-child > div:first-child {
    visibility: ${({ isExpanded: isExpanded })=>isExpanded && 'hidden'};
  }
`;
const $30719f968e028273$export$987cac99e7a31168 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  width: 100%;

  gap: 20px;
`;
const $30719f968e028273$export$6f4a084cc8e379b6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
`;
const $30719f968e028273$export$49316f37c3b5fade = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 15px;
  font-weight: 400;
  padding-right: 40px;
`;
const $30719f968e028273$export$85524e8d4e82fc69 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  & textarea {
    resize: vertical;
  }
`;



// Map Redux Props
const $bddeb3fc39aa1578$var$mapStateToProps = (state)=>state;
const $bddeb3fc39aa1578$var$mapDispatchToProps = (dispatch)=>(0, $2154a4c08d887b32$export$e324594224ef24da)(dispatch);
function $bddeb3fc39aa1578$var$AiDocumentChunkTableItem(props) {
    // Destructure
    const { data: data } = props;
    // States
    const [isExpanded, setIsExpanded] = (0, $tZqWC.useState)(false);
    // Hooks
    const { updateDocumentChunk: updateDocumentChunk, updateDocumentChunkData: updateDocumentChunkData, updateDocumentChunkError: updateDocumentChunkError, isUpdateDocumentChunkLoading: isUpdateDocumentChunkLoading } = (0, $7ff639a4c5bea165$export$2e2bcd8739ae039)();
    // Component States
    const [content, setContent] = (0, $tZqWC.useState)();
    const [metadata, setMetadata] = (0, $tZqWC.useState)();
    const [disabled, setDisabled] = (0, $tZqWC.useState)(true);
    // Functions
    const handleUpdate = ()=>{
        let payload = {
            id: data.id,
            document_id: data.document_id
        };
        if (content !== data.content) payload = {
            ...payload,
            content: content
        };
        if (metadata !== data.chunk_metadata) payload = {
            ...payload,
            chunk_metadata: metadata
        };
        updateDocumentChunk(payload);
    };
    // UseEffects
    (0, $tZqWC.useEffect)(()=>{
        setContent(data?.content);
        setMetadata(data?.chunk_metadata);
    }, [
        data
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (updateDocumentChunkData && !updateDocumentChunkError && !isUpdateDocumentChunkLoading) window.location.reload();
    }, [
        updateDocumentChunkData
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b3f7dc6528742bb0$export$2e2bcd8739ae039), {
        setIsExpanded: (val)=>{
            setIsExpanded(val);
        },
        expandPanel: isExpanded,
        button: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $30719f968e028273$export$fd2299f554be8993), {
            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $30719f968e028273$export$9f515a68dfaeb9ef), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $30719f968e028273$export$987cac99e7a31168), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $30719f968e028273$export$49316f37c3b5fade), {
                        children: `${data?.content?.slice(0, 150)}...`
                    })
                })
            })
        }),
        panel: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $30719f968e028273$export$85524e8d4e82fc69), {
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d03facd9d698d253$export$2e2bcd8739ae039), {
                    rows: "8",
                    label: "Content",
                    value: content,
                    onChange: (e)=>{
                        console.log(e.target.value);
                        setContent(e.target.value);
                    },
                    disabled: disabled
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $278bd1e80972f508$export$2e2bcd8739ae039), {
                    rows: "8",
                    label: "Metadata",
                    initialValue: metadata,
                    onChange: setMetadata,
                    disabled: disabled
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $30719f968e028273$export$9f515a68dfaeb9ef), {
                    style: {
                        justifyContent: 'flex-end',
                        paddingTop: '20px'
                    },
                    children: [
                        disabled && !isUpdateDocumentChunkLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                            onClick: ()=>setDisabled(false),
                            children: "Edit"
                        }),
                        !disabled && !isUpdateDocumentChunkLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $30719f968e028273$export$987cac99e7a31168), {
                            style: {
                                justifyContent: 'flex-end'
                            },
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                    onClick: ()=>setDisabled(true),
                                    variant: "outlined",
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                    onClick: ()=>handleUpdate(),
                                    children: "Save"
                                })
                            ]
                        }),
                        isUpdateDocumentChunkLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                            disabled: true,
                            children: "Loading..."
                        })
                    ]
                })
            ]
        })
    });
}
// Default Props
$bddeb3fc39aa1578$var$AiDocumentChunkTableItem.defaultProps = {
    data: {
        id: '',
        document_id: '',
        content: '',
        embedding: '',
        chunk_metadata: ''
    }
};
// Proptypes Validation
$bddeb3fc39aa1578$var$AiDocumentChunkTableItem.propTypes = {
    data: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        document_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        content: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        embedding: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        chunk_metadata: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    })
};
var $bddeb3fc39aa1578$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($bddeb3fc39aa1578$var$mapStateToProps, $bddeb3fc39aa1578$var$mapDispatchToProps)($bddeb3fc39aa1578$var$AiDocumentChunkTableItem);



const $bd001ab18a636e28$export$4267411171632d35 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $bd001ab18a636e28$export$cbf11d5f692bc726 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
`;
const $bd001ab18a636e28$export$97d84ed62ab03b3f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  margin: 0px 0px 0px 16px;

  font-weight: inherit;
  font-size: inherit;
`;


// Map Redux Props
const $c00dd4be9fbf3065$var$mapStateToProps = (state)=>state;
const $c00dd4be9fbf3065$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $c00dd4be9fbf3065$var$AiDocumentChunkTable(props) {
    // Destructure
    const { filters: filters, actions: actions, ui: ui } = props;
    const { document_id: document_id } = (0, $a0d5c3f2fe524011$export$99eaa27ddbbb95ef)();
    // Store States
    const { aiDocumentChunkFilters: aiDocumentChunkFilters } = filters;
    const { isPageTableUpdated: isPageTableUpdated } = ui;
    // Store Actions
    const { setAiDocumentChunkFilters: setAiDocumentChunkFilters, setIsPageTableUpdated: setIsPageTableUpdated } = actions;
    // Variables
    const { page: page, size: size } = aiDocumentChunkFilters;
    // States
    const [docChunks, setDocChunks] = (0, $tZqWC.useState)({
        items: [],
        total: 0
    });
    // Hooks
    const [userCredentials] = (0, $a9c50ebe96619b20$export$2e2bcd8739ae039)('userCredentials', false);
    const { getDocumentChunksData: getDocumentChunksData, getDocumentChunks: getDocumentChunks, isGetDocumentChunksLoading: isGetDocumentChunksLoading } = (0, $f6c9e03fe2eac6b5$export$2e2bcd8739ae039)();
    // Functions
    const fetchDocs = ()=>{
        getDocumentChunks({
            biz_id: userCredentials.Business_ID,
            document_id: document_id,
            page: page,
            size: size
        });
    };
    // UseEffects
    (0, $tZqWC.useEffect)(()=>{
        if (getDocumentChunksData) setDocChunks({
            ...getDocumentChunksData,
            ...getDocumentChunksData?.pagination
        });
    }, [
        getDocumentChunksData
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (aiDocumentChunkFilters || isPageTableUpdated) {
            fetchDocs();
            setIsPageTableUpdated(false);
        }
    }, [
        aiDocumentChunkFilters,
        isPageTableUpdated
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bd001ab18a636e28$export$4267411171632d35), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d2b0b55dc8f66a40$export$2e2bcd8739ae039), {
            totalItems: docChunks?.total,
            minWidth: 900,
            tableFilters: aiDocumentChunkFilters,
            setTableFilters: setAiDocumentChunkFilters,
            children: docChunks.items.length > 0 && !isGetDocumentChunksLoading ? docChunks.items.map((details)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bddeb3fc39aa1578$export$2e2bcd8739ae039), {
                    data: details
                }, details?.id)) : /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("div", {
                children: isGetDocumentChunksLoading ? /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $647b8bc68ebce54f$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a6ea3b0f3caed586$export$2e2bcd8739ae039), {
                    setFilter: setAiDocumentChunkFilters
                })
            })
        })
    });
}
// Default Props
$c00dd4be9fbf3065$var$AiDocumentChunkTable.defaultProps = {
    actions: {},
    filters: {},
    ui: {}
};
// Proptypes Validation
$c00dd4be9fbf3065$var$AiDocumentChunkTable.propTypes = {
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        aiDocumentChunkFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object)
    }),
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setAiDocumentChunkFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setToBeUpdatedVasp: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsAiDocumentUploadModalOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsEntityVaspDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $c00dd4be9fbf3065$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($c00dd4be9fbf3065$var$mapStateToProps, $c00dd4be9fbf3065$var$mapDispatchToProps)($c00dd4be9fbf3065$var$AiDocumentChunkTable);


var $dc063333d1454c38$export$2e2bcd8739ae039 = (0, $c00dd4be9fbf3065$export$2e2bcd8739ae039);


// constants
// Map Redux Props
const $3c15e0ba58d9fd5d$var$mapStateToProps = (state)=>state;
const $3c15e0ba58d9fd5d$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $3c15e0ba58d9fd5d$var$AiDocumentSummary(props) {
    const { actions: actions } = props;
    // Store
    const { setDocumentToDeleteID: setDocumentToDeleteID, toggleDeleteAiDocModalOpen: toggleDeleteAiDocModalOpen } = actions;
    // Local State
    const [disabled, setDisabled] = (0, $tZqWC.useState)(true);
    const [origDocument, setOrigDocument] = (0, $tZqWC.useState)();
    const [didSucceed, setDidSuceed] = (0, $tZqWC.useState)();
    const [didFail, setDidFail] = (0, $tZqWC.useState)();
    const [metadata, setMetadata] = (0, $tZqWC.useState)({
        key: 'value'
    });
    // Refs
    const formRef = (0, $tZqWC.useRef)();
    // Hooks
    const { updateDocument: updateDocument, updateDocumentData: updateDocumentData, updateDocumentError: updateDocumentError, isUpdateDocumentLoading: isUpdateDocumentLoading } = (0, $7330d2aed83e7e66$export$2e2bcd8739ae039)();
    const { getDocuments: getDocuments, getDocumentsData: getDocumentsData, isGetDocumentsLoading: isGetDocumentsLoading } = (0, $553b74c795a3ef57$export$2e2bcd8739ae039)();
    const { document_id: document_id } = (0, $a0d5c3f2fe524011$export$99eaa27ddbbb95ef)();
    // Functions
    const handleDelete = ()=>{
        setDocumentToDeleteID(document_id);
        toggleDeleteAiDocModalOpen();
    };
    const handleDocument = (data)=>{
        if (data?.items?.length > 0) {
            const item = data?.items[0];
            setOrigDocument({
                ...item
            });
            setMetadata(item?.core_metadata);
        }
    };
    const handleSubmit = ()=>{
        updateDocument({
            ...formRef.current?.values,
            core_metadata: JSON.parse(metadata)
        });
    };
    const handleUploaded = (response)=>{
        if (response) setDidSuceed(true);
    };
    const handleErr = (response)=>{
        if (response) setDidFail(true);
    };
    const handleCancel = ()=>{
        setDisabled(true);
        formRef.current.setValues(origDocument);
        setMetadata(origDocument?.core_metadata);
    };
    // UseEffects
    (0, $tZqWC.useEffect)(()=>{
        getDocuments({
            document_id: document_id
        });
    }, []);
    (0, $tZqWC.useEffect)(()=>{
        handleDocument(getDocumentsData);
    }, [
        getDocumentsData
    ]);
    (0, $tZqWC.useEffect)(()=>{
        handleUploaded(updateDocumentData);
    }, [
        updateDocumentData
    ]);
    (0, $tZqWC.useEffect)(()=>{
        handleErr(updateDocumentError);
    }, [
        updateDocumentError
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $595f4f5ef06dda44$export$e6dfd72ab29f8598), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $595f4f5ef06dda44$export$b13648308b87115), {
                children: [
                    isUpdateDocumentLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $595f4f5ef06dda44$export$ac7496df4f1f837a), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $647b8bc68ebce54f$export$2e2bcd8739ae039), {})
                    }),
                    !didSucceed && !isUpdateDocumentLoading && !isGetDocumentsLoading && !didFail && origDocument && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $595f4f5ef06dda44$export$ac7496df4f1f837a), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $595f4f5ef06dda44$export$87ad169bde460ddf), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $32de1bcd4e009194$export$2e2bcd8739ae039), {
                                    formRef: formRef,
                                    viewMode: disabled,
                                    values: origDocument
                                })
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $595f4f5ef06dda44$export$87ad169bde460ddf), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $278bd1e80972f508$export$2e2bcd8739ae039), {
                                    rows: "7",
                                    label: "Metadata",
                                    id: "metadata",
                                    initialValue: metadata,
                                    onChange: setMetadata,
                                    disabled: disabled
                                })
                            })
                        ]
                    }),
                    didSucceed && !isUpdateDocumentLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $595f4f5ef06dda44$export$ac7496df4f1f837a), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $595f4f5ef06dda44$export$f99233281efd08a0), {
                                children: "Successfully Uploaded Document"
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $595f4f5ef06dda44$export$5f1af8db9871e1d6), {
                                children: "Please refresh the page"
                            })
                        ]
                    }),
                    didFail && !isUpdateDocumentLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $595f4f5ef06dda44$export$ac7496df4f1f837a), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $595f4f5ef06dda44$export$edf27be85e5f6da0), {
                                children: "An Error Occurred"
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $595f4f5ef06dda44$export$5f1af8db9871e1d6), {
                                children: "Please try again later"
                            })
                        ]
                    }),
                    !didSucceed && !isUpdateDocumentLoading && !didFail && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $595f4f5ef06dda44$export$d53c836cccbb0d90), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                type: "button",
                                color: "secondary",
                                onClick: handleDelete,
                                children: "Delete"
                            }),
                            disabled && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                type: "button",
                                variant: "outlined",
                                onClick: ()=>setDisabled(false),
                                children: "Edit"
                            }),
                            !disabled && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                        type: "button",
                                        variant: "outlined",
                                        onClick: handleCancel,
                                        children: "Cancel"
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                        type: "button",
                                        onClick: handleSubmit,
                                        children: "Save"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $dc063333d1454c38$export$2e2bcd8739ae039), {})
        ]
    });
}
// Default Props
$3c15e0ba58d9fd5d$var$AiDocumentSummary.defaultProps = {
    ui: {},
    address: {},
    actions: {}
};
// Proptypes Validation
$3c15e0ba58d9fd5d$var$AiDocumentSummary.propTypes = {
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isAiDocumentUploadModalOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    address: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        addressReportDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            address_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            address: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            chain: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
        })
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        toggleDeleteAiDocModalOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setDocumentToDeleteID: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $3c15e0ba58d9fd5d$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($3c15e0ba58d9fd5d$var$mapStateToProps, $3c15e0ba58d9fd5d$var$mapDispatchToProps)($3c15e0ba58d9fd5d$var$AiDocumentSummary);


var $62669a44b4e7d09f$export$2e2bcd8739ae039 = (0, $3c15e0ba58d9fd5d$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");





const $c0f130d5073f6a20$export$4267411171632d35 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $c0f130d5073f6a20$export$cbf11d5f692bc726 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
`;
const $c0f130d5073f6a20$export$97d84ed62ab03b3f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  margin: 0px 0px 0px 16px;

  font-weight: inherit;
  font-size: inherit;
`;




/* eslint-disable no-unsafe-optional-chaining */ 
parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");




const $13f6f1499111891b$export$5f1af8db9871e1d6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  font-size: 13px;
  margin: 0;
  text-align: right;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $13f6f1499111891b$export$b04be29aa201d4f5 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  font-size: 13px;
  margin: 0;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $13f6f1499111891b$export$f99233281efd08a0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h3`
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $13f6f1499111891b$export$d5c56664638992a4 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h4`
  font-size: 16px;
  margin: 0;
  color: ${({ theme: theme })=>theme.colors.primary};
  font-weight: 400;

  max-width: 260px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;
const $13f6f1499111891b$export$987cac99e7a31168 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: 1fr 1fr;
`;
const $13f6f1499111891b$export$2157c074a0891857 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  text-transform: uppercase;
`;
const $13f6f1499111891b$export$6f4a084cc8e379b6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 20px;
  &:last-child {
    background-color: ${({ theme: theme })=>theme.colors.background};
    border-radius: 0 0 10px 10px;
  }
`;
const $13f6f1499111891b$export$9f515a68dfaeb9ef = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  padding: 20px;
  background-color: ${({ theme: theme })=>theme.colors.borderColor};
  border-bottom: 2px solid ${({ theme: theme })=>theme.colors.backgroundLite};
  border-radius: 10px 10px 0 0;
`;
const $13f6f1499111891b$export$fd2299f554be8993 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  padding: 20px;
  gap: 20px;
  justify-content: center;
  width: 100%;

  & button {
    width: 100% !important;
  }
`;
const $13f6f1499111891b$export$15529022dcaf3eec = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-end;
`;
const $13f6f1499111891b$export$5a7f9a6004988d01 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  font-size: 13px;
  margin: 0 0 4px 0;
  width: fit-content;
  padding: 2px 18px;
  ${({ theme: theme, customer_status_id: customer_status_id })=>`
    ${customer_status_id === -1 && `
      ;color: ${theme.colors.red};
      background-color: transparent;
      border: 1px solid ${theme.colors.red};
      border-radius: 8px;
    `}
    ${(customer_status_id === -2 || customer_status_id === 0 || customer_status_id === 4) && `
      ;color: ${theme.colors.primary};
      background-color: transparent;
      border: 1px solid ${theme.colors.primary};
      border-radius: 8px;
    `}
    ${customer_status_id > 0 && `
      ;color: ${theme.colors.brand};
      background-color: transparent;
      border: 1px solid ${theme.colors.brand};
      border-radius: 8px;
    `}
  `};
`;



// Map Redux Props
const $5660138dea3b1d82$var$mapStateToProps = (state)=>state;
const $5660138dea3b1d82$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $5660138dea3b1d82$var$AiDocumentTableItem(props) {
    // Destructure
    const { details: details } = props;
    const { title: title, summary: summary, core_metadata: core_metadata, id: id } = details;
    // State
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $12b33660068e86aa$export$b0d92dbee9b5b60d), {
        to: `/admin/ai/documents/${id}`,
        style: {
            cursor: 'pointer'
        },
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $37202d75ee8521c4$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $13f6f1499111891b$export$9f515a68dfaeb9ef), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $13f6f1499111891b$export$f99233281efd08a0), {
                        children: title
                    })
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $13f6f1499111891b$export$6f4a084cc8e379b6), {
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $13f6f1499111891b$export$987cac99e7a31168), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $13f6f1499111891b$export$b04be29aa201d4f5), {
                                    children: "Summary: "
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $13f6f1499111891b$export$5f1af8db9871e1d6), {
                                    children: summary
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $13f6f1499111891b$export$987cac99e7a31168), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $13f6f1499111891b$export$b04be29aa201d4f5), {
                                    children: "Core Metadata: "
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $13f6f1499111891b$export$5f1af8db9871e1d6), {
                                    children: JSON.stringify(core_metadata)
                                })
                            ]
                        })
                    ]
                })
            ]
        }, title)
    });
}
// Default Props
$5660138dea3b1d82$var$AiDocumentTableItem.defaultProps = {};
// Proptypes Validation
$5660138dea3b1d82$var$AiDocumentTableItem.propTypes = {
    details: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        title: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        summary: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        core_metadata: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    })
};
var $5660138dea3b1d82$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($5660138dea3b1d82$var$mapStateToProps, $5660138dea3b1d82$var$mapDispatchToProps)($5660138dea3b1d82$var$AiDocumentTableItem);


var $5c39ed08a73b7204$export$2e2bcd8739ae039 = (0, $5660138dea3b1d82$export$2e2bcd8739ae039);


// Map Redux Props
const $d160e0fd30622ff1$var$mapStateToProps = (state)=>state;
const $d160e0fd30622ff1$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $d160e0fd30622ff1$var$AiDocumentTable(props) {
    // Destructure
    const { filters: filters, actions: actions, ui: ui } = props;
    // Store States
    const { aiDocumentFilters: aiDocumentFilters } = filters;
    const { isPageTableUpdated: isPageTableUpdated } = ui;
    // Store Actions
    const { setAiDocumentFilters: setAiDocumentFilters, setIsPageTableUpdated: setIsPageTableUpdated, setIsAiDocumentUploadModalOpen: setIsAiDocumentUploadModalOpen } = actions;
    // Variables
    const { sort: sort, page: page, size: size } = aiDocumentFilters;
    // States
    const [documents, setDocs] = (0, $tZqWC.useState)({
        items: [],
        total: 0
    });
    // Hooks
    const [userCredentials] = (0, $a9c50ebe96619b20$export$2e2bcd8739ae039)('userCredentials', false);
    const { getDocumentsData: getDocumentsData, getDocuments: getDocuments, isGetDocumentsLoading: isGetDocumentsLoading } = (0, $553b74c795a3ef57$export$2e2bcd8739ae039)();
    // Functions
    const fetchDocs = ()=>{
        getDocuments({
            biz_id: userCredentials.Business_ID,
            sort: sort,
            page: page,
            size: size
        });
    };
    // UseEffects
    (0, $tZqWC.useEffect)(()=>{
        if (getDocumentsData) setDocs({
            items: getDocumentsData?.items,
            total: getDocumentsData?.pagination?.total
        });
    }, [
        getDocumentsData
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (aiDocumentFilters || isPageTableUpdated) {
            fetchDocs();
            setIsPageTableUpdated(false);
        }
    }, [
        aiDocumentFilters,
        isPageTableUpdated
    ]);
    console.log('CALLED');
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c0f130d5073f6a20$export$4267411171632d35), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7139282abdeb8ca4$export$2e2bcd8739ae039), {
            totalItems: documents.total,
            minWidth: 900,
            cardWidth: 500,
            // filterComponents={<VaspTableFilter />}
            tableFilters: aiDocumentFilters,
            setTableFilters: setAiDocumentFilters,
            headerOptions: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                size: "small",
                startIcon: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6417d0fa9c066aa3$export$2e2bcd8739ae039), {
                    size: 18
                }),
                onClick: ()=>setIsAiDocumentUploadModalOpen(true),
                children: "Document"
            }),
            children: documents.items.length > 0 && !isGetDocumentsLoading ? documents.items.map((details)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5c39ed08a73b7204$export$2e2bcd8739ae039), {
                    details: details
                }, details?.id)) : /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("div", {
                children: isGetDocumentsLoading ? /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $647b8bc68ebce54f$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a6ea3b0f3caed586$export$2e2bcd8739ae039), {
                    setFilter: setAiDocumentFilters
                })
            })
        })
    });
}
// Default Props
$d160e0fd30622ff1$var$AiDocumentTable.defaultProps = {
    actions: {},
    filters: {},
    ui: {}
};
// Proptypes Validation
$d160e0fd30622ff1$var$AiDocumentTable.propTypes = {
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        aiDocumentFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object)
    }),
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setAiDocumentFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setToBeUpdatedVasp: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsAiDocumentUploadModalOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsEntityVaspDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $d160e0fd30622ff1$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($d160e0fd30622ff1$var$mapStateToProps, $d160e0fd30622ff1$var$mapDispatchToProps)($d160e0fd30622ff1$var$AiDocumentTable);


var $604230100f422599$export$2e2bcd8739ae039 = (0, $d160e0fd30622ff1$export$2e2bcd8739ae039);





var $ee5d941afa634f6c$export$2e2bcd8739ae039 = (0, $bddeb3fc39aa1578$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");







const $479065ba2eaaca9a$export$e6dfd72ab29f8598 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
`;
const $479065ba2eaaca9a$export$518140168539ec9f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  margin: 0 0 -40px 0;
`;
const $479065ba2eaaca9a$export$61a3ae60c82d8e12 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 16px;
`;
const $479065ba2eaaca9a$export$f99233281efd08a0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h1`
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  text-transform: uppercase;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $479065ba2eaaca9a$export$cf345ef34cd72655 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  margin: 0;
  font-size: 10px;
  font-weight: 400;
  letter-spacing: 0.5px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $479065ba2eaaca9a$export$42a852a2b6b56249 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 30px;
  border-radius: 10px;
  background: ${({ theme: theme })=>theme.colors.background};
`;
const $479065ba2eaaca9a$export$33203cad3bced98c = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  padding-top: 40px;
  max-width: 500px;
`;
const $479065ba2eaaca9a$export$b59bdbef9ce70de2 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 2px solid ${({ theme: theme })=>theme.colors.backgroundLite};

  &:last-child {
    border: none;
    padding: 10px 0 0 0;
  }
`;
const $479065ba2eaaca9a$export$99836757d2dc7b18 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 15px;
  font-weight: 600;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $479065ba2eaaca9a$export$5f1af8db9871e1d6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 15px;
  font-weight: 400;
  color: ${({ theme: theme })=>theme.colors.primary};
`;




// Map Redux Props
const $1c98032cd497c25c$var$mapStateToProps = (state)=>state;
const $1c98032cd497c25c$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $1c98032cd497c25c$var$BusinessDetailsTab(props) {
    // Destructure
    const { actions: actions } = props;
    // store actions
    const { setShowHeaderLoader: setShowHeaderLoader, showAlert: showAlert } = actions;
    // refs
    const formRef = (0, $tZqWC.useRef)();
    // hooks
    const { getVasp: getVasp, vaspData: vaspData, isVaspLoading: isVaspLoading } = (0, $462c3808bdeaeab0$export$2e2bcd8739ae039)();
    const { updateVasp: updateVasp, vaspUpdateError: vaspUpdateError, isVaspUpdateSuccess: isVaspUpdateSuccess, isVaspUpdateError: isVaspUpdateError, isVaspUpdateLoading: isVaspUpdateLoading } = (0, $05f6f04b561b761e$export$2e2bcd8739ae039)();
    const [currentUser] = (0, $a9c50ebe96619b20$export$2e2bcd8739ae039)('userCredentials', {});
    const vasp_id = currentUser?.business_id;
    // state
    const [vaspDataState, setVaspDataState] = (0, $tZqWC.useState)();
    const [viewMode, setViewMode] = (0, $tZqWC.useState)(true);
    // Functions
    const fetchData = ()=>{
        getVasp({
            vasp_id: vasp_id
        });
    };
    const handleSave = ()=>{
        const finalValues = (0, $e446f427009a34b7$export$6f9bd4784b79a579)(formRef?.current?.values, vaspDataState);
        updateVasp({
            vasp_id: vasp_id,
            values: finalValues
        });
    };
    const handleCancel = ()=>{
        setViewMode(true);
        if (formRef.current) formRef.current.resetForm();
    };
    const handleSuccess = ()=>{
        if (formRef.current) formRef.current.resetForm({
            values: formRef.current?.values
        });
        setVaspDataState(formRef.current?.values);
        showAlert({
            type: 'success',
            message: 'Successfully updated details'
        });
        setViewMode(true);
    };
    const handleFailure = ()=>{
        if (vaspUpdateError?.response?.data?.context?.error) showAlert({
            type: 'error',
            message: vaspUpdateError?.response?.data?.context?.error
        });
        else showAlert({
            type: 'error',
            message: 'An error occurred in updating details'
        });
    };
    const loading = isVaspLoading || isVaspUpdateLoading;
    const handleLoading = ()=>{
        if (loading) setShowHeaderLoader(true);
        if (!loading) setShowHeaderLoader(false);
    };
    // useEffect
    (0, $tZqWC.useEffect)(()=>fetchData(), []);
    (0, $tZqWC.useEffect)(()=>{
        if (vaspData) setVaspDataState(vaspData);
    }, [
        vaspData
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (isVaspUpdateSuccess) handleSuccess();
    }, [
        isVaspUpdateSuccess
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (isVaspUpdateError) handleFailure();
    }, [
        isVaspUpdateError
    ]);
    (0, $tZqWC.useEffect)(()=>handleLoading(), [
        loading
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $479065ba2eaaca9a$export$42a852a2b6b56249), {
        children: !isVaspLoading && vaspDataState && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
            children: [
                viewMode === true && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $479065ba2eaaca9a$export$518140168539ec9f), {
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $479065ba2eaaca9a$export$f99233281efd08a0), {
                            children: vaspDataState.name_legal
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $479065ba2eaaca9a$export$61a3ae60c82d8e12), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                color: "primary",
                                onClick: ()=>setViewMode(false),
                                children: "Edit"
                            })
                        })
                    ]
                }),
                viewMode === false && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $479065ba2eaaca9a$export$518140168539ec9f), {
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $479065ba2eaaca9a$export$f99233281efd08a0), {
                            children: vaspDataState.name_legal
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $479065ba2eaaca9a$export$61a3ae60c82d8e12), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                    type: "button",
                                    disabled: loading,
                                    onClick: handleCancel,
                                    variant: "outlined",
                                    startIcon: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b77b5de3fb591045$export$2e2bcd8739ae039), {
                                        size: 18
                                    }),
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                    type: "button",
                                    disabled: loading,
                                    onClick: handleSave,
                                    startIcon: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $462cc6e9cac360f1$export$2e2bcd8739ae039), {
                                        size: 18
                                    }),
                                    children: "Save Changes"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $31c31aa6819313d7$export$2e2bcd8739ae039), {
                    style: {
                        paddingTop: '50px'
                    },
                    values: vaspDataState,
                    viewMode: viewMode,
                    formRef: formRef
                })
            ]
        })
    });
}
// Default Props
$1c98032cd497c25c$var$BusinessDetailsTab.defaultProps = {
    actions: {},
    filters: {},
    ui: {}
};
// Proptypes Validation
$1c98032cd497c25c$var$BusinessDetailsTab.propTypes = {
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        vaspDirectoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object)
    }),
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setVaspDirectoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsIndividualVaspDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsEntityVaspDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setApproveVaspModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setApproveVaspDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setRejectVaspModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setRejectVaspDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $1c98032cd497c25c$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($1c98032cd497c25c$var$mapStateToProps, $1c98032cd497c25c$var$mapDispatchToProps)($1c98032cd497c25c$var$BusinessDetailsTab);


var $86a277d387878008$export$2e2bcd8739ae039 = (0, $1c98032cd497c25c$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");




const $6704b83cbb68575c$export$4267411171632d35 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: 100%;
  padding: 20px;
`;
const $6704b83cbb68575c$export$cbf11d5f692bc726 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
`;
const $6704b83cbb68575c$export$97d84ed62ab03b3f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  margin: 0px 0px 0px 16px;

  font-weight: inherit;
  font-size: inherit;
`;





var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");







const $cf90dc1d5fbaae5a$export$ac7496df4f1f837a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: 100%;
`;
const $cf90dc1d5fbaae5a$export$e151f1d86035b485 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  & > div > div {
    margin-bottom: 0 !important;
  }
`;
const $cf90dc1d5fbaae5a$export$8f1ff89fa1ec9605 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  align-items: start;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  gap: 10px 60px;
`;
const $cf90dc1d5fbaae5a$export$71c7816ee3a5a527 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h4`
  font-size: 15px;
  font-weight: 600;
  margin: 20px 0 0 10px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $cf90dc1d5fbaae5a$export$fd2299f554be8993 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: 1fr 25px;
  gap: 50px;
  align-items: center;

  padding: 10px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $cf90dc1d5fbaae5a$export$9f515a68dfaeb9ef = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  align-items: center;

  width: 100%;

  gap: 20px;

  & :first-child {
    align-items: flex-start;
  }
  & :last-child {
    align-items: flex-end;
  }
`;
const $cf90dc1d5fbaae5a$export$85524e8d4e82fc69 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
const $cf90dc1d5fbaae5a$export$d53c836cccbb0d90 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 12px;
  margin-top: 24px;
  justify-content: flex-end;
`;
const $cf90dc1d5fbaae5a$export$f99233281efd08a0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-weight: 600;
`;
const $cf90dc1d5fbaae5a$export$d5c56664638992a4 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 12px;
  font-weight: 300;
`;
const $cf90dc1d5fbaae5a$export$87ad169bde460ddf = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;




// Map Redux Props
const $e3224f3cd1452d6f$var$mapStateToProps = (state)=>state;
const $e3224f3cd1452d6f$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $e3224f3cd1452d6f$var$UsersTableItem(props) {
    // Destructure
    const { actions: actions, values: values } = props;
    // Store Actions
    const { showAlert: showAlert, toggleRemoveUserModal: toggleRemoveUserModal, setUserToDeact: setUserToDeact } = actions;
    // Hooks
    const { updateUser: updateUser, updateUserData: updateUserData, updateUserError: updateUserError, isUpdateUserLoading: isUpdateUserLoading, isUpdateUserSuccess: isUpdateUserSuccess, isUpdateUserError: isUpdateUserError } = (0, $006abbba5bd33f8a$export$2e2bcd8739ae039)();
    const { createUserActivationLink: createUserActivationLink, createUserActivationLinkError: createUserActivationLinkError, isCreateUserActivationLinkLoading: isCreateUserActivationLinkLoading, isCreateUserActivationLinkSuccess: isCreateUserActivationLinkSuccess } = (0, $53f9d00d6955a0cf$export$2e2bcd8739ae039)();
    // Local State
    const [initialData, setInitialData] = (0, $tZqWC.useState)();
    const [viewMode, setViewMode] = (0, $tZqWC.useState)(true);
    const [isDetailsExpanded, setIsDetailsExpanded] = (0, $tZqWC.useState)(false);
    console.log(initialData);
    // Local storage
    const [userCredentials] = (0, $a9c50ebe96619b20$export$2e2bcd8739ae039)('userCredentials', false);
    // Refs
    const formRef = (0, $tZqWC.useRef)();
    // Variables
    const isLoading = isCreateUserActivationLinkLoading || isUpdateUserLoading;
    // Functions
    const handleCancel = ()=>{
        setViewMode(true);
        if (formRef.current) formRef.current.resetForm();
    };
    const handleSave = (initial)=>{
        const finalValues = (0, $e446f427009a34b7$export$6f9bd4784b79a579)(formRef?.current?.values, initial);
        delete finalValues.is_active;
        delete finalValues.is_verified;
        updateUser({
            user_id: initialData?.user_id,
            ...finalValues
        });
    };
    const handleSuccess = ()=>{
        if (formRef.current) formRef.current.resetForm({
            values: updateUserData
        });
        setInitialData(updateUserData);
        showAlert({
            type: 'success',
            message: 'Successfully updated record'
        });
        setViewMode(true);
    };
    const handleFailure = ()=>{
        const errorMessage = updateUserError?.response?.data?.context || 'An error occurred in updating record';
        showAlert({
            type: 'error',
            message: errorMessage
        });
    };
    const handleSendActivation = ()=>{
        createUserActivationLink({
            user_id: initialData?.user_id
        });
    };
    const handleRemoveUser = ()=>{
        toggleRemoveUserModal();
        setUserToDeact({
            user_id: initialData?.user_id,
            is_active: false
        });
    };
    // UseEffects
    (0, $tZqWC.useEffect)(()=>{
        setInitialData(values);
        if (formRef.current) formRef.current.values = values;
    }, [
        values
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (isUpdateUserSuccess) handleSuccess();
    }, [
        isUpdateUserSuccess
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (isUpdateUserError) handleFailure();
    }, [
        isUpdateUserError
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (createUserActivationLinkError) showAlert({
            type: 'error',
            message: 'An error occurred in sending activation link'
        });
    }, [
        createUserActivationLinkError
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (isCreateUserActivationLinkSuccess) showAlert({
            type: 'success',
            message: 'Successfully sent activation link'
        });
    }, [
        isCreateUserActivationLinkSuccess
    ]);
    if (!initialData) return null;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $cf90dc1d5fbaae5a$export$ac7496df4f1f837a), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b3f7dc6528742bb0$export$2e2bcd8739ae039), {
            setIsExpanded: setIsDetailsExpanded,
            expandPanel: isDetailsExpanded,
            button: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $cf90dc1d5fbaae5a$export$fd2299f554be8993), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $cf90dc1d5fbaae5a$export$9f515a68dfaeb9ef), {
                    isExpanded: isDetailsExpanded,
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $cf90dc1d5fbaae5a$export$87ad169bde460ddf), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $cf90dc1d5fbaae5a$export$f99233281efd08a0), {
                                    children: `${initialData?.name_first || 'First Name'} ${initialData?.name_last || 'Last Name'}`
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $cf90dc1d5fbaae5a$export$d5c56664638992a4), {
                                    children: "Name of User"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $cf90dc1d5fbaae5a$export$87ad169bde460ddf), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $cf90dc1d5fbaae5a$export$f99233281efd08a0), {
                                    children: (0, $f398806f8c37b1c3$export$d34134843134085a)?.[initialData?.role_id]?.label || 'User Role'
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $cf90dc1d5fbaae5a$export$d5c56664638992a4), {
                                    children: "User Role"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $cf90dc1d5fbaae5a$export$87ad169bde460ddf), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $cf90dc1d5fbaae5a$export$f99233281efd08a0), {
                                    children: initialData?.is_verified ? 'Verified' : 'Unverified'
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $cf90dc1d5fbaae5a$export$d5c56664638992a4), {
                                    children: "Status"
                                })
                            ]
                        })
                    ]
                })
            }),
            panel: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $32fbb81f19fb7caa$export$2e2bcd8739ae039), {
                        formRef: formRef,
                        values: initialData,
                        viewMode: viewMode
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $cf90dc1d5fbaae5a$export$d53c836cccbb0d90), {
                        children: [
                            !initialData?.is_verified && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                onClick: handleSendActivation,
                                disabled: isLoading,
                                children: "Send Activation"
                            }),
                            initialData?.is_active && userCredentials?.id !== initialData.user_id && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                onClick: handleRemoveUser,
                                disabled: isLoading,
                                color: "secondary",
                                children: "Remove User"
                            }),
                            viewMode ? /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                color: "primary",
                                onClick: ()=>setViewMode(false),
                                children: "Edit"
                            }) : /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                        variant: "outlined",
                                        onClick: handleCancel,
                                        disabled: isLoading,
                                        children: "Cancel"
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                        onClick: ()=>handleSave(initialData),
                                        disabled: isLoading,
                                        children: "Save"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}
// Default Props
$e3224f3cd1452d6f$var$UsersTableItem.defaultProps = {
    actions: {},
    values: {}
};
// Proptypes Validation
$e3224f3cd1452d6f$var$UsersTableItem.propTypes = {
    values: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        name_first: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        name_last: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        role_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        is_verified: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
        is_active: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setUserToDeact: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        toggleRemoveUserModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $e3224f3cd1452d6f$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($e3224f3cd1452d6f$var$mapStateToProps, $e3224f3cd1452d6f$var$mapDispatchToProps)($e3224f3cd1452d6f$var$UsersTableItem);


// Map Redux Props
const $4bea86fe332242dd$var$mapStateToProps = (state)=>state;
const $4bea86fe332242dd$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $4bea86fe332242dd$var$UsersTable(props) {
    // Destructure
    const { setUsersLength: setUsersLength, ui: ui, actions: actions } = props;
    // Store States
    const { isPageTableUpdated: isPageTableUpdated } = ui;
    const { setIsPageTableUpdated: setIsPageTableUpdated } = actions;
    // Hooks
    const { getUsers: getUsers, getUsersData: getUsersData, isGetUsersLoading: isGetUsersLoading } = (0, $ac762e7709953823$export$2e2bcd8739ae039)();
    // const [currentUser] = useLocalStorage('userCredentials', {})
    // Local states
    const [users, setUsers] = (0, $tZqWC.useState)([]);
    // UseEffects
    (0, $tZqWC.useEffect)(()=>{
        getUsers();
    }, []);
    (0, $tZqWC.useEffect)(()=>{
        if (getUsersData) {
            setUsersLength(getUsersData.length);
            setUsers(getUsersData);
        }
    }, [
        getUsersData
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (isPageTableUpdated) {
            getUsers(getUsers);
            setIsPageTableUpdated(false);
        }
    }, [
        isPageTableUpdated
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6704b83cbb68575c$export$4267411171632d35), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $06a400f584629957$export$2e2bcd8739ae039), {
            hidePagination: true,
            tableFilters: {
                size: 0,
                page: 0
            },
            minWidth: 900,
            children: [
                isGetUsersLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $647b8bc68ebce54f$export$2e2bcd8739ae039), {}),
                !isGetUsersLoading && users.length > 0 && users.map((data, i)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e3224f3cd1452d6f$export$2e2bcd8739ae039), {
                        values: data,
                        setIsUpdated: setIsPageTableUpdated
                    }, `${data.email} ${i + 1}`))
            ]
        })
    });
}
// Default Props
$4bea86fe332242dd$var$UsersTable.defaultProps = {
    actions: {},
    filters: {},
    ui: {},
    setUsersLength: ()=>{}
};
// Proptypes Validation
$4bea86fe332242dd$var$UsersTable.propTypes = {
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        reportsFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object)
    }),
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    setUsersLength: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setToBeUpdatedAccount: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAccountDirectoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsIndividualAccountDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsEntityAccountDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setReportsFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $4bea86fe332242dd$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($4bea86fe332242dd$var$mapStateToProps, $4bea86fe332242dd$var$mapDispatchToProps)($4bea86fe332242dd$var$UsersTable);


var $0f2f86ad44d6281a$export$2e2bcd8739ae039 = (0, $4bea86fe332242dd$export$2e2bcd8739ae039);



var $138ca05aca425ad8$export$2e2bcd8739ae039 = (0, $e3224f3cd1452d6f$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");




const $2565ced071ddb1ab$export$4267411171632d35 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: 100%;
  padding: 20px 40px;
`;
const $2565ced071ddb1ab$export$cbf11d5f692bc726 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
`;
const $2565ced071ddb1ab$export$97d84ed62ab03b3f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  margin: 0px 0px 0px 16px;

  font-weight: inherit;
  font-size: inherit;
`;



/* eslint-disable react/no-array-index-key */ 
parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");


var $ejSM7 = parcelRequire("ejSM7");




const $966fac0d9596285a$export$fd2299f554be8993 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  align-items: center;

  color: ${({ theme: theme })=>theme.colors.primary};
  margin-top: 20px;
`;
const $966fac0d9596285a$export$9f515a68dfaeb9ef = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: 1fr 2fr 1fr 1fr 1fr;
  align-items: center;
  justify-content: 'flex-start';

  width: 100%;

  gap: 20px;

  & :first-child {
    align-items: flex-start;
  }
  & :last-child {
    align-items: flex-end;
  }
`;
const $966fac0d9596285a$export$f99233281efd08a0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 14px;
`;
const $966fac0d9596285a$export$d5c56664638992a4 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 12px;
  font-weight: 300;
`;
const $966fac0d9596285a$export$87ad169bde460ddf = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const $966fac0d9596285a$export$4a2f3d80739991ec = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  border-radius: 8px;
  gap: 8px;
  padding: 10px 20px;
  background-color: ${({ theme: theme })=>theme.colors.backgroundLite};
`;


// Map Redux Props
const $be8f46ca8d0fe9af$var$mapStateToProps = (state)=>state;
const $be8f46ca8d0fe9af$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $be8f46ca8d0fe9af$var$ApiKeysTableItem(props) {
    // Destructure
    const { actions: actions, data: data } = props;
    // Store Actions
    const { toggleRemoveApiKeyModal: toggleRemoveApiKeyModal, setApiKeyToDelete: setApiKeyToDelete } = actions;
    // Functions
    const handleRemove = ()=>{
        setApiKeyToDelete(data);
        toggleRemoveApiKeyModal();
    };
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $966fac0d9596285a$export$fd2299f554be8993), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $966fac0d9596285a$export$9f515a68dfaeb9ef), {
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $966fac0d9596285a$export$87ad169bde460ddf), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $966fac0d9596285a$export$f99233281efd08a0), {
                        children: data.label
                    })
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $966fac0d9596285a$export$87ad169bde460ddf), {
                    children: data?.allowed_ips && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $966fac0d9596285a$export$4a2f3d80739991ec), {
                        children: data?.allowed_ips?.split(',')?.map((item, i)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $966fac0d9596285a$export$f99233281efd08a0), {
                                children: `${item}${i !== data.allowed_ips.split(',').length - 1 ? ',' : ''}`
                            }, `${item}${i}`))
                    })
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $966fac0d9596285a$export$87ad169bde460ddf), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $966fac0d9596285a$export$f99233281efd08a0), {
                        children: (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(data.created).format('MMM D, YYYY')
                    })
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $966fac0d9596285a$export$87ad169bde460ddf), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $966fac0d9596285a$export$f99233281efd08a0), {
                        children: (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(data.expires).format('MMM D, YYYY')
                    })
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $966fac0d9596285a$export$87ad169bde460ddf), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                        style: {
                            alignItems: 'center'
                        },
                        variant: "outlined",
                        onClick: handleRemove,
                        size: "small",
                        endIcon: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b77b5de3fb591045$export$2e2bcd8739ae039), {
                            size: 10
                        }),
                        children: "Remove"
                    })
                })
            ]
        })
    });
}
// Default Props
$be8f46ca8d0fe9af$var$ApiKeysTableItem.defaultProps = {
    actions: {},
    data: {}
};
// Proptypes Validation
$be8f46ca8d0fe9af$var$ApiKeysTableItem.propTypes = {
    data: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        label: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        allowed_ips: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        created: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        expires: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setApiKeyToDelete: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        toggleRemoveApiKeyModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $be8f46ca8d0fe9af$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($be8f46ca8d0fe9af$var$mapStateToProps, $be8f46ca8d0fe9af$var$mapDispatchToProps)($be8f46ca8d0fe9af$var$ApiKeysTableItem);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");



const $5bb8bf29c26a9f2d$export$fd2299f554be8993 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  align-items: center;

  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $5bb8bf29c26a9f2d$export$9f515a68dfaeb9ef = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: 1fr 2fr 1fr 1fr 1fr;
  align-items: center;
  justify-content: 'flex-start';

  width: 100%;

  gap: 20px;

  & :first-child {
    align-items: flex-start;
  }
  & :last-child {
    align-items: flex-end;
  }
`;
const $5bb8bf29c26a9f2d$export$f99233281efd08a0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 14px;
`;
const $5bb8bf29c26a9f2d$export$d5c56664638992a4 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 12px;
  font-weight: 300;
`;
const $5bb8bf29c26a9f2d$export$87ad169bde460ddf = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;


// Map Redux Props
const $21f8e69c88a76df4$var$mapStateToProps = (state)=>state;
const $21f8e69c88a76df4$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $21f8e69c88a76df4$var$ApiKeysTableHeader() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5bb8bf29c26a9f2d$export$fd2299f554be8993), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $5bb8bf29c26a9f2d$export$9f515a68dfaeb9ef), {
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5bb8bf29c26a9f2d$export$87ad169bde460ddf), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5bb8bf29c26a9f2d$export$f99233281efd08a0), {
                        children: "LABEL"
                    })
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5bb8bf29c26a9f2d$export$87ad169bde460ddf), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5bb8bf29c26a9f2d$export$f99233281efd08a0), {
                        children: "ALLOWED IPs"
                    })
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5bb8bf29c26a9f2d$export$87ad169bde460ddf), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5bb8bf29c26a9f2d$export$f99233281efd08a0), {
                        children: "CREATED"
                    })
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5bb8bf29c26a9f2d$export$87ad169bde460ddf), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5bb8bf29c26a9f2d$export$f99233281efd08a0), {
                        children: "EXPIRES"
                    })
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5bb8bf29c26a9f2d$export$87ad169bde460ddf), {})
            ]
        })
    });
}
// Default Props
$21f8e69c88a76df4$var$ApiKeysTableHeader.defaultProps = {
    actions: {},
    data: {}
};
// Proptypes Validation
$21f8e69c88a76df4$var$ApiKeysTableHeader.propTypes = {
    data: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        label: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        created: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        expires: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setApiKeyToDelete: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        toggleRemoveApiKeyModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $21f8e69c88a76df4$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($21f8e69c88a76df4$var$mapStateToProps, $21f8e69c88a76df4$var$mapDispatchToProps)($21f8e69c88a76df4$var$ApiKeysTableHeader);


var $14e024f6f2147a87$export$2e2bcd8739ae039 = (0, $21f8e69c88a76df4$export$2e2bcd8739ae039);


// Map Redux Props
const $3060aa720dc4c12e$var$mapStateToProps = (state)=>state;
const $3060aa720dc4c12e$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $3060aa720dc4c12e$var$ApiKeysTable(props) {
    // Destructure
    const { ui: ui, actions: actions } = props;
    // Store States
    const { isPageTableUpdated: isPageTableUpdated } = ui;
    const { setIsPageTableUpdated: setIsPageTableUpdated } = actions;
    // Hooks
    const { listIntegrationToken: listIntegrationToken, listIntegrationTokenData: listIntegrationTokenData, isListIntegrationTokenLoading: isListIntegrationTokenLoading } = (0, $6b4647dec9d64fa3$export$2e2bcd8739ae039)();
    // const [currentUser] = useLocalStorage('userCredentials', {})
    // Local states
    const [apiKeys, setApiKeys] = (0, $tZqWC.useState)([]);
    // UseEffects
    (0, $tZqWC.useEffect)(()=>{
        listIntegrationToken();
    }, []);
    (0, $tZqWC.useEffect)(()=>{
        if (listIntegrationTokenData) setApiKeys(listIntegrationTokenData);
    }, [
        listIntegrationTokenData
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (isPageTableUpdated) {
            listIntegrationToken(listIntegrationToken);
            setIsPageTableUpdated(false);
        }
    }, [
        isPageTableUpdated
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2565ced071ddb1ab$export$4267411171632d35), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $06a400f584629957$export$2e2bcd8739ae039), {
            hidePagination: true,
            tableFilters: {
                size: 0,
                page: 0
            },
            minWidth: 900,
            children: [
                isListIntegrationTokenLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $647b8bc68ebce54f$export$2e2bcd8739ae039), {}),
                !isListIntegrationTokenLoading && apiKeys.length > 0 && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $14e024f6f2147a87$export$2e2bcd8739ae039), {}),
                !isListIntegrationTokenLoading && apiKeys.length > 0 && apiKeys.map((data)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $be8f46ca8d0fe9af$export$2e2bcd8739ae039), {
                        data: data,
                        setIsUpdated: setIsPageTableUpdated
                    }, data.id))
            ]
        })
    });
}
// Default Props
$3060aa720dc4c12e$var$ApiKeysTable.defaultProps = {
    actions: {},
    filters: {},
    ui: {}
};
// Proptypes Validation
$3060aa720dc4c12e$var$ApiKeysTable.propTypes = {
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        reportsFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object)
    }),
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setToBeUpdatedAccount: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAccountDirectoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsIndividualAccountDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsEntityAccountDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setReportsFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $3060aa720dc4c12e$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($3060aa720dc4c12e$var$mapStateToProps, $3060aa720dc4c12e$var$mapDispatchToProps)($3060aa720dc4c12e$var$ApiKeysTable);


var $4eb647ade053420f$export$2e2bcd8739ae039 = (0, $3060aa720dc4c12e$export$2e2bcd8739ae039);



var $4769e146a2b2e796$export$2e2bcd8739ae039 = (0, $be8f46ca8d0fe9af$export$2e2bcd8739ae039);


/* eslint-disable react/no-array-index-key */ 

var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");




const $5e2018fa25f91cb0$export$4267411171632d35 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div` 
`;
const $5e2018fa25f91cb0$export$cbf11d5f692bc726 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: 200px 1fr 200px;
  padding: 5px 0 30px 0;
`;
const $5e2018fa25f91cb0$export$97d84ed62ab03b3f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  margin: 0px 0px 0px 16px;

  font-weight: inherit;
  font-size: inherit;
`;




/* eslint-disable react/prop-types */ 

var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");






const $02775561781e5334$export$e6dfd72ab29f8598 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $02775561781e5334$export$97ddd2af6308ba2 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  color: ${({ theme: theme })=>theme.colors.primary};
  // Themed Properties
`;
const $02775561781e5334$export$b1d97b9d6e698468 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  z-index: 3;
  position: relative;
  width: 100%;
  max-width: 700px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme: theme })=>theme.colors.primary};
  // Themed Properties
`;
const $02775561781e5334$export$9fc98b514229b55b = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  z-index: ${({ isActive: isActive })=>isActive ? 7 : 0};
  display: grid;
  width: 100%;
  background: ${({ theme: theme, isActive: isActive })=>isActive ? theme.colors.backgroundLite : theme.colors.background};
  border-radius: 10px;

  transition: 0.3s;
  border: 1px solid ${({ theme: theme })=>`${theme.colors.borderColor}`};
  &:hover {
    border: 1px solid ${({ theme: theme })=>`${theme.colors.brand}40`};
  }
  & input {
    background: ${({ theme: theme, isActive: isActive })=>isActive ? theme.colors.backgroundLite : theme.colors.background};
    border: none;
    padding: 18px 40px 18px 60px;
  }
  & svg {
    z-index: ${({ isActive: isActive })=>isActive ? 8 : 1};
    stroke: ${({ theme: theme })=>theme.colors.primary};
    position: absolute;
    top: 22px;
    left: 20px;
  }
  & svg > path {
    stroke: ${({ theme: theme })=>theme.colors.primary};
  }
  & #addressSearchOptionsProvider {
    & > div > div:nth-child(3) {
      min-width: 160px;
      border-radius: 10px;
      & > div > div {
        padding: 8px 12px;
      }
    }
  }
  & #addressSearchOptionsChain {
    & > div > div:nth-child(3) {
      min-width: 160px;
      border-radius: 10px;
      & > div > div {
        padding: 8px 12px;
        & svg {
          min-width: 25px;
          stroke: transparent;
          & path {
            stroke: ${({ theme: theme })=>theme.colors.brand};
          }
        }
      }
    }
  }
`;
const $02775561781e5334$export$a694082daf370b76 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-end;
`;
const $02775561781e5334$export$698223c589197ab7 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: fixed;
  z-index: 0;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background: ${({ theme: theme })=>`${theme.colors.background}`};
  transition: 0.3s;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 20px;
`;
const $02775561781e5334$export$94756becb802e330 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: absolute;
  top: 0px;
  right: -5px;
  cursor: pointer;
  & svg {
    fill: ${({ theme: theme })=>theme.colors.primary};
  }
  & svg > path {
    fill: ${({ theme: theme })=>theme.colors.primary};
  }
`;
const $02775561781e5334$export$550fc938a73ef6b7 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  z-index: ${({ isActive: isActive })=>isActive ? 6 : 0};
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  margin-top: -10px;
  display: flex;
  flex-direction: column;
  gap: 5px;

  background-color: ${({ theme: theme })=>theme.colors.background};
  border: 1px solid ${({ theme: theme })=>theme.colors.borderColor};
  padding: 20px 10px;
  border-radius: 0 0 10px 10px;
  box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.07);
  max-height: 600px;
  overflow-y: auto;
`;
const $02775561781e5334$export$4b7e9f77c6f037f1 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  cursor: pointer;
  font-weight: 400;
  padding: 5px 10px;
  border-radius: 7px;

  &:hover {
    background-color: ${({ theme: theme, disabled: disabled })=>!disabled && theme.colors.backgroundLite};
  }
  border: ${({ theme: theme, active: active })=>active && `1px solid ${theme.colors.brand}`};
  border-radius: 8px;
`;
const $02775561781e5334$export$f99233281efd08a0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h2`
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  /* margin: 15px 0 0 15px; */
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $02775561781e5334$export$67706c264edf13ca = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px 20px;
`;
const $02775561781e5334$export$b5fbeb65832ce537 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  /* display: flex;
  max-width: 100%;
  overflow-x: auto; */
  padding: 10px 0;
  gap: 5px;

  & button {
    white-space: nowrap;
    word-break: keep-all;
    overflow-wrap: normal;
    text-transform: capitalize;
    font-size: 14px !important;
    padding: 5px 15px;
    width: 100%;
  }
`;




// Map Redux Props
const $2239f2bfba5f319d$var$mapStateToProps = (state)=>state;
const $2239f2bfba5f319d$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $2239f2bfba5f319d$var$AddressSearchBar(props) {
    // props
    const { actions: actions, address: address } = props;
    // destructure
    const { showAlert: showAlert, setScannedAddress: setScannedAddress, toggleInfoModal: toggleInfoModal, setInfoModalDetails: setInfoModalDetails } = actions;
    const { addressChains: addressChains } = address;
    // local states
    const [isActive, setIsActive] = (0, $tZqWC.useState)(false);
    const [addressInput, setAddressInput] = (0, $tZqWC.useState)('');
    const [chain, setChain] = (0, $tZqWC.useState)('');
    const [chainSymbol, setChainSymbol] = (0, $tZqWC.useState)('');
    const [selectedProvider, setSelectedProvider] = (0, $tZqWC.useState)();
    const [allChains, setAllChains] = (0, $tZqWC.useState)();
    const [availableChains, setAvailableChains] = (0, $tZqWC.useState)();
    const [isSelfHosted, setIsSelfHosted] = (0, $tZqWC.useState)(false);
    // hooks
    const { createOrUpdateAddress: createOrUpdateAddress, createOrUpdateAddressData: createOrUpdateAddressData, createOrUpdateAddressError: createOrUpdateAddressError, isCreateOrUpdateAddressLoading: isCreateOrUpdateAddressLoading } = (0, $b297ef53431cfca8$export$2e2bcd8739ae039)();
    const [userCredentials] = (0, $a9c50ebe96619b20$export$2e2bcd8739ae039)('userCredentials', {});
    // Refs
    const barRef = (0, $tZqWC.useRef)();
    // utils
    (0, $54f47a39f461db48$export$50ec7b7ff742aae5)(barRef, setIsActive);
    // Functions
    function handleSubmit() {
        const firstChild = Object.keys(availableChains?.[selectedProvider])[0];
        const firstChain = availableChains?.[selectedProvider]?.[firstChild];
        const provider_id = firstChain?.provider_id;
        createOrUpdateAddress({
            address: addressInput,
            chain: chain,
            name_first: userCredentials.name_first,
            name_last: userCredentials.name_last,
            provider_id: provider_id,
            is_self_hosted: isSelfHosted
        });
        setAddressInput('');
        setChain('');
        setChainSymbol();
        setSelectedProvider();
    }
    function handleAddressChange(inputValue) {
        setAddressInput(inputValue);
    }
    function handleAvailableChains() {
        const providers = {
            FDBDM: {
                ...addressChains?.financial?.FDBDM
            },
            ...addressChains?.risk
        };
        const allChains = {};
        let literallyAllChains = {};
        Object.keys(providers).forEach((providerCode)=>{
            Object.keys(providers[providerCode]).forEach((chainCode)=>{
                if (providers?.FDBDM?.[chainCode] && providerCode !== 'FDBDM') {
                    allChains[providerCode] = {
                        ...allChains[providerCode],
                        [chainCode]: providers[providerCode][chainCode]
                    };
                    literallyAllChains = {
                        ...literallyAllChains,
                        [chainCode]: providers[providerCode][chainCode]
                    };
                }
            });
        });
        setAvailableChains(allChains);
        setAllChains(literallyAllChains);
    }
    (0, $tZqWC.useEffect)(()=>{
        handleAvailableChains();
    }, [
        addressChains
    ]);
    (0, $tZqWC.useEffect)(()=>chain && selectedProvider && addressInput && handleSubmit(), [
        selectedProvider
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (!isActive) {
            setIsSelfHosted();
            setAddressInput('');
            setChain();
            setChainSymbol();
        }
    }, [
        isActive
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (createOrUpdateAddressData) {
            setScannedAddress(createOrUpdateAddressData);
            setIsActive(false);
        }
    }, [
        createOrUpdateAddressData
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (createOrUpdateAddressError?.response?.data?.message) showAlert({
            type: 'error',
            message: createOrUpdateAddressError?.response?.data?.message
        });
        else if (createOrUpdateAddressError) showAlert({
            type: 'error',
            message: 'An error occurred in screening address'
        });
    }, [
        createOrUpdateAddressError
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (isCreateOrUpdateAddressLoading) {
            toggleInfoModal(true);
            setInfoModalDetails({
                title: 'Scanning Address',
                content: 'This process may take over 60 seconds, depending on the volume of data.',
                loading: true
            });
        } else {
            toggleInfoModal(false);
            setInfoModalDetails();
        }
    }, [
        isCreateOrUpdateAddressLoading
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $02775561781e5334$export$e6dfd72ab29f8598), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $02775561781e5334$export$97ddd2af6308ba2), {
            isActive: isActive,
            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $02775561781e5334$export$b1d97b9d6e698468), {
                ref: barRef,
                isActive: isActive,
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $02775561781e5334$export$9fc98b514229b55b), {
                        isActive: isActive,
                        children: [
                            isActive && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $02775561781e5334$export$94756becb802e330), {
                                onClick: ()=>setIsActive(false),
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b77b5de3fb591045$export$2e2bcd8739ae039), {
                                    size: 18
                                })
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2232f33a3cdf9fa0$export$2e2bcd8739ae039), {
                                size: 18
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ae78f1d128dc50d5$export$2e2bcd8739ae039), {
                                placeholder: isCreateOrUpdateAddressLoading ? 'loading...' : !isActive && 'Screen a wallet address',
                                onClick: ()=>{
                                    setIsActive(true);
                                },
                                value: addressInput,
                                onChange: (e)=>handleAddressChange(e.currentTarget.value)
                            })
                        ]
                    }),
                    isActive && addressInput?.trim() && !isCreateOrUpdateAddressLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $02775561781e5334$export$550fc938a73ef6b7), {
                        isActive: isActive,
                        children: [
                            allChains && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $02775561781e5334$export$67706c264edf13ca), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $02775561781e5334$export$f99233281efd08a0), {
                                        children: "Select Chain"
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $02775561781e5334$export$b5fbeb65832ce537), {
                                        children: Object.keys(allChains)?.map((key)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                                onClick: ()=>{
                                                    setChainSymbol(key);
                                                    setChain(allChains[key]?.chain_name);
                                                },
                                                variant: chainSymbol === key ? 'primary' : 'outlined',
                                                children: allChains[key]?.chain_name
                                            }, key))
                                    })
                                ]
                            }),
                            allChains && chain && addressInput && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $02775561781e5334$export$67706c264edf13ca), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $02775561781e5334$export$f99233281efd08a0), {
                                        children: "Is Wallet Self-Hosted?"
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $02775561781e5334$export$b5fbeb65832ce537), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b6cab7af1259ed03$export$2e2bcd8739ae039), {
                                            onChange: (v)=>setIsSelfHosted(v),
                                            value: isSelfHosted,
                                            horizontal: true,
                                            options: [
                                                {
                                                    label: 'Yes',
                                                    value: true
                                                },
                                                {
                                                    label: 'No',
                                                    value: false
                                                }
                                            ]
                                        })
                                    })
                                ]
                            }),
                            allChains && chain && addressInput && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $02775561781e5334$export$67706c264edf13ca), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $02775561781e5334$export$f99233281efd08a0), {
                                        children: "Select Provider"
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $02775561781e5334$export$b5fbeb65832ce537), {
                                        children: Object.keys(availableChains)?.map((key)=>{
                                            if (availableChains?.[key]?.[chainSymbol]) return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                                onClick: ()=>{
                                                    setSelectedProvider(key);
                                                },
                                                variant: selectedProvider === key ? 'primary' : 'outlined',
                                                children: key
                                            }, key);
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}
// Default Props
$2239f2bfba5f319d$var$AddressSearchBar.defaultProps = {
    actions: {}
};
// Proptypes Validation
$2239f2bfba5f319d$var$AddressSearchBar.propTypes = {
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setScannedAddress: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        toggleInfoModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setInfoModalDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    address: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        addressChains: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({}),
        defaultAddressProvider: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({})
    })
};
var $2239f2bfba5f319d$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($2239f2bfba5f319d$var$mapStateToProps, $2239f2bfba5f319d$var$mapDispatchToProps)($2239f2bfba5f319d$var$AddressSearchBar);


var $e166a664f096c85c$export$2e2bcd8739ae039 = (0, $2239f2bfba5f319d$export$2e2bcd8739ae039);


/* eslint-disable react/no-unstable-nested-components */ 

var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");


var $ejSM7 = parcelRequire("ejSM7");






const $60f7fcdba0ad955c$export$fd2299f554be8993 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: 1fr 1.8fr;
  gap: 50px;
  align-items: center;

  padding: 10px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $60f7fcdba0ad955c$export$9f515a68dfaeb9ef = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  gap: 20px;

  &:last-child > div:last-child {
    max-width: 150px;
  }
  &:last-child > div:first-child {
    justify-content: flex-end;
    max-width: 535px;
  }

  &:first-child > div:last-child {
    justify-content: flex-end;
    visibility: ${({ isExpanded: isExpanded })=>isExpanded && 'hidden'};
  }
  &:last-child > div:first-child {
    visibility: ${({ isExpanded: isExpanded })=>isExpanded && 'hidden'};
  }
`;
const $60f7fcdba0ad955c$export$987cac99e7a31168 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  width: 100%;

  gap: 20px;
`;
const $60f7fcdba0ad955c$export$6f4a084cc8e379b6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
`;
const $60f7fcdba0ad955c$export$49316f37c3b5fade = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 15px;
  font-weight: 400;

  max-width: 250px;

  &:first-child {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  &.address_item_amount {
    max-width: 100px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
`;
const $60f7fcdba0ad955c$export$edc246bee1ec68d2 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;

  & svg {
    height: 20px;
    width: 20px;
  }
`;
const $60f7fcdba0ad955c$export$829b0583f0fe5152 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 15px;
  font-weight: 400;
`;
const $60f7fcdba0ad955c$export$b30c94aee60c7d6b = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: absolute;
  top: 100%;
  margin-top: 10px;

  font-size: 15px;
  font-weight: 400;
  padding: 10px 20px;
  border-radius: 10px;
  background-color: ${({ theme: theme })=>theme.colors.background};

  transition: 0.1s;
  opacity: ${({ display: display })=>display ? 1 : 0};
  box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.15);
`;
const $60f7fcdba0ad955c$export$b502300b413480 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).span`
  font-size: 8px;
  font-weight: 400;
`;
const $60f7fcdba0ad955c$export$65b9fe47bb7b64b0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 10px;
  font-weight: 400;
`;
const $60f7fcdba0ad955c$export$85524e8d4e82fc69 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;



/* eslint-disable react/forbid-prop-types */ 

var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");




const $903e8682de7d89eb$export$e6dfd72ab29f8598 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
`;
const $903e8682de7d89eb$export$d53c836cccbb0d90 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: absolute;
  top: 0;
  right: 0;

  display: flex;
  gap: 10px;
`;
const $903e8682de7d89eb$export$42a852a2b6b56249 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $903e8682de7d89eb$export$f5ec1ee0b77895e7 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $903e8682de7d89eb$export$b2e35077a5c7bc77 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-start;

  width: 100%;
`;
const $903e8682de7d89eb$export$f6e382949408c1f3 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  min-width: 300px;
  gap: 8px;
  max-width: 470px;
`;
const $903e8682de7d89eb$export$bc7adc8ef74607f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding-top: 10px;
  display: flex;
  justify-content: space-between;
  gap: 10px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $903e8682de7d89eb$export$4e8a51dfb7785a56 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  width: 100%;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 10px;
`;
const $903e8682de7d89eb$export$a9754b3c8daa5172 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  gap: 10px;
`;
const $903e8682de7d89eb$export$cd1f041fcaf00d90 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 10px;
  padding: 10px 0;
  border-bottom: 1px solid ${({ theme: theme })=>theme.colors.backgroundLite};
`;
const $903e8682de7d89eb$export$acefde28a3cb7b20 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 10px;
  border-color: ${({ theme: theme })=>theme.colors.backgroundLite};
  border-style: solid;
  border-width: 0;
`;
const $903e8682de7d89eb$export$a4fff7f2f85c4c81 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  padding: 20px;
  width: 100%;
  height: 100%;
  border-radius: 7px;
  border: 1px solid ${({ theme: theme })=>theme.colors.backgroundLite};
  transition: 0.3s;
  /* &:hover {
    background-color: ${({ theme: theme })=>`${theme.colors.secondary}10`};
  } */

  & > div:last-child {
    border: none;
    padding-bottom: 0;
  }
`;
const $903e8682de7d89eb$export$87ad169bde460ddf = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 100%;

  border-color: ${({ theme: theme })=>theme.colors.backgroundLite};
  border-style: solid;
  border-width: 0;
`;
const $903e8682de7d89eb$export$d747b2abe71e53f5 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 100%;

  & > div:last-child {
    border: none;
    padding-bottom: 0;
  }
`;
const $903e8682de7d89eb$export$5f1af8db9871e1d6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  margin: 0;
  padding: 0;
  font-size: 14px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $903e8682de7d89eb$export$c1dd341a97aad245 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).span`
  margin: 0;
  padding: 5px 15px;
  font-size: 12px;
  color: ${({ theme: theme })=>theme.colors.primary};
  background-color: ${({ theme: theme })=>`${theme.colors.secondary}30`};
  border: 1px solid ${({ theme: theme, color: color })=>color === 'darkGray' ? theme.colors.primary : theme.colors.backgroundLite};
  border-radius: 8px;
`;
const $903e8682de7d89eb$export$f99233281efd08a0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h2`
  margin: 0;
  padding: 0;
  font-size: 15px;
  font-weight: 400;
  color: ${({ theme: theme })=>theme.colors.primary};
  text-transform: uppercase;
  margin-bottom: 10px;
`;
const $903e8682de7d89eb$export$ae133abb7f01f500 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 20px 0 0 0;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(520px, 1fr));
  gap: 60px;
`;
const $903e8682de7d89eb$export$8f314e512d92575f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  width: 40px;

  font-size: 20px;
  border: 1px solid ${({ theme: theme })=>theme.colors.primary};
  border-radius: 100%;
`;
const $903e8682de7d89eb$export$87de03758d2d03db = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 20px 20px 0 20px;

  & #rsSubTitle {
    color: ${({ theme: theme })=>theme.colors.secondary};
  }
`;
const $903e8682de7d89eb$export$71237909d9ca197d = (0, $a778141486c79bc3$export$2e2bcd8739ae039).hr`
  width: 100%;
  height: 2px !important;

  color: ${({ theme: theme })=>theme.colors.secondary};
  margin: 20px 0;
`;
const $903e8682de7d89eb$export$dc8558b9a49863a4 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h2`
  margin: 0;
  padding: 0;
  font-size: 12px;
  font-weight: 400;
  color: ${({ theme: theme })=>theme.colors.secondary};
  text-transform: uppercase;
  margin-bottom: -7px;

  font-weight: 300;
  font-size: 10px;
  padding-top: 5px;
  display: flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;
`;
const $903e8682de7d89eb$export$b2bf131c9f9cce5d = (0, $a778141486c79bc3$export$2e2bcd8739ae039)((0, $12b33660068e86aa$export$b0d92dbee9b5b60d))`
  display: flex;
  align-items: center;
  gap: 5px;
  height: 100%;

  & svg {
    height: 100%;
    max-height: 15px;
  }
`;
const $903e8682de7d89eb$export$6fea5cf6191c0ed2 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  z-index: 2;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  backdrop-filter: blur(5px);
  background-color: rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
`;



/* eslint-disable no-nested-ternary */ /* eslint-disable react/jsx-no-useless-fragment */ /* eslint-disable react/no-array-index-key */ /* eslint-disable react/forbid-prop-types */ 
parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");


var $ejSM7 = parcelRequire("ejSM7");





// Map Redux Props
const $24fc72fe456c8bf1$var$mapStateToProps = (state)=>state;
const $24fc72fe456c8bf1$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $24fc72fe456c8bf1$var$RiskDataSection(props) {
    // Destructure
    const { actions: actions, riskData: riskData, isLoading: isLoading, currentIpUsed: currentIpUsed } = props;
    // Store Actions
    const { toggleInfoModal: toggleInfoModal, setInfoModalDetails: setInfoModalDetails } = actions;
    // Functions
    const formatVaspNames = (vaspName)=>{
        let nameArray = vaspName.split(',').join(', ').split('_').join(' ');
        if (nameArray[nameArray.length - 2] === ',') nameArray = nameArray.substring(0, nameArray.length - 2);
        return nameArray;
    };
    const handleToggleInfo = (title, content)=>{
        setInfoModalDetails({
            title: title,
            content: content
        });
        toggleInfoModal(true);
    };
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$f5ec1ee0b77895e7), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$bc7adc8ef74607f), {
                style: {
                    gap: '10px',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    padding: '20px 10px 10px 10px',
                    cursor: 'pointer',
                    width: 'fit-content'
                },
                onClick: ()=>{
                    handleToggleInfo('Wallet Address Risk', // eslint-disable-next-line max-len
                    'Evaluates the potential risk of a blockchain address based on transaction behavior, links to illicit activities, and regulatory compliance.');
                },
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$f99233281efd08a0), {
                        style: {
                            fontWeight: '600',
                            fontSize: '15px',
                            cursor: 'pointer',
                            margin: 0
                        },
                        children: "Wallet Address Risk"
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b7c251a6b5f784dd$export$2e2bcd8739ae039), {
                        size: 16
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$a4fff7f2f85c4c81), {
                style: {
                    padding: '10px',
                    borderWidth: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '10px'
                },
                children: [
                    isLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$a4fff7f2f85c4c81), {
                        style: {
                            padding: '10px',
                            borderWidth: 1
                        },
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$4e8a51dfb7785a56), {
                            style: {
                                gridTemplateColumns: '320px 1fr 0.79fr'
                            },
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$a9754b3c8daa5172), {
                                    style: {
                                        maxWidth: '320px',
                                        alignItems: 'center'
                                    },
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$a4fff7f2f85c4c81), {
                                        style: {
                                            display: 'flex',
                                            padding: 0
                                        },
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$87ad169bde460ddf), {
                                            children: [
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$87de03758d2d03db), {
                                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ba8982a7854b309f$export$2e2bcd8739ae039), {
                                                        id: "LoadingRisk123",
                                                        size: 120,
                                                        progress: 0,
                                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$d747b2abe71e53f5), {
                                                            style: {
                                                                justifyContent: 'center',
                                                                alignItems: 'center',
                                                                gap: 5
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5facfc7bc5a170d3$export$2e2bcd8739ae039), {
                                                                    height: 24,
                                                                    width: 40
                                                                }),
                                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5facfc7bc5a170d3$export$2e2bcd8739ae039), {
                                                                    height: 14,
                                                                    width: 60
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$acefde28a3cb7b20), {
                                                    style: {
                                                        padding: '20px'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$d747b2abe71e53f5), {
                                                            style: {
                                                                gap: 10
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$dc8558b9a49863a4), {
                                                                    children: [
                                                                        "Risk Score",
                                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b7c251a6b5f784dd$export$2e2bcd8739ae039), {})
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5facfc7bc5a170d3$export$2e2bcd8739ae039), {
                                                                    height: 14,
                                                                    width: 80,
                                                                    borderRadius: 4
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$d747b2abe71e53f5), {
                                                            style: {
                                                                alignItems: 'center',
                                                                gap: 10
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$dc8558b9a49863a4), {
                                                                    style: {
                                                                        cursor: 'default'
                                                                    },
                                                                    children: "Timestamp"
                                                                }),
                                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5facfc7bc5a170d3$export$2e2bcd8739ae039), {
                                                                    height: 14,
                                                                    width: 80,
                                                                    borderRadius: 4
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$d747b2abe71e53f5), {
                                                            style: {
                                                                alignItems: 'flex-end',
                                                                gap: 10
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$dc8558b9a49863a4), {
                                                                    children: [
                                                                        "Source",
                                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b7c251a6b5f784dd$export$2e2bcd8739ae039), {})
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5facfc7bc5a170d3$export$2e2bcd8739ae039), {
                                                                    height: 14,
                                                                    width: 80,
                                                                    borderRadius: 4
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$a9754b3c8daa5172), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$a4fff7f2f85c4c81), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$d747b2abe71e53f5), {
                                            children: [
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$f99233281efd08a0), {
                                                    children: "Risk Score Descriptors: "
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$a9754b3c8daa5172), {
                                                    style: {
                                                        gap: 5,
                                                        maxHeight: '150px',
                                                        overflowY: 'auto',
                                                        paddingRight: '20px'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5facfc7bc5a170d3$export$2e2bcd8739ae039), {
                                                            width: 100
                                                        }),
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5facfc7bc5a170d3$export$2e2bcd8739ae039), {
                                                            width: 70
                                                        }),
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5facfc7bc5a170d3$export$2e2bcd8739ae039), {
                                                            width: 170
                                                        }),
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5facfc7bc5a170d3$export$2e2bcd8739ae039), {
                                                            width: 140
                                                        }),
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5facfc7bc5a170d3$export$2e2bcd8739ae039), {
                                                            width: 130
                                                        }),
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5facfc7bc5a170d3$export$2e2bcd8739ae039), {
                                                            width: 80
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$a9754b3c8daa5172), {
                                    style: {
                                        maxWidth: '443px'
                                    },
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$a4fff7f2f85c4c81), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$d747b2abe71e53f5), {
                                            children: [
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$f99233281efd08a0), {
                                                    children: "Controlling Entity: "
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$cd1f041fcaf00d90), {
                                                    style: {
                                                        padding: '0 0 10px 0'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                                            children: "Name: "
                                                        }),
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5facfc7bc5a170d3$export$2e2bcd8739ae039), {
                                                            width: 180
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$cd1f041fcaf00d90), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                                            children: "Website: "
                                                        }),
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5facfc7bc5a170d3$export$2e2bcd8739ae039), {
                                                            width: 180
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$cd1f041fcaf00d90), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                                            children: "Type: "
                                                        }),
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5facfc7bc5a170d3$export$2e2bcd8739ae039), {
                                                            width: 180
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    riskData && riskData.map((data, i)=>{
                        if (data?.provider_name !== currentIpUsed && data?.risk_ratio !== null) return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$a4fff7f2f85c4c81), {
                            style: {
                                padding: '10px',
                                borderWidth: 1
                            },
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$4e8a51dfb7785a56), {
                                style: {
                                    gridTemplateColumns: '320px 1fr 0.79fr'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$a9754b3c8daa5172), {
                                        style: {
                                            maxWidth: '320px',
                                            alignItems: 'center'
                                        },
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$a4fff7f2f85c4c81), {
                                            style: {
                                                display: 'flex',
                                                padding: 0
                                            },
                                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$87ad169bde460ddf), {
                                                children: [
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$87de03758d2d03db), {
                                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ba8982a7854b309f$export$2e2bcd8739ae039), {
                                                            id: `${data?.id || data?.address_id}-${i}`,
                                                            size: 120,
                                                            progress: !Number.isNaN(data.risk_ratio) && data.risk_ratio,
                                                            children: !Number.isNaN(data.risk_ratio) && data.risk_ratio !== null ? /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$d747b2abe71e53f5), {
                                                                style: {
                                                                    justifyContent: 'center',
                                                                    alignItems: 'center',
                                                                    gap: 0
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                                                        style: {
                                                                            fontSize: '18px',
                                                                            fontWeight: 600
                                                                        },
                                                                        children: `${data.risk_ratio}%`
                                                                    }),
                                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                                                        style: {
                                                                            fontSize: '12px',
                                                                            fontWeight: 400
                                                                        },
                                                                        id: "rsSubTitle",
                                                                        children: "Risk"
                                                                    })
                                                                ]
                                                            }) : /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$d747b2abe71e53f5), {
                                                                style: {
                                                                    justifyContent: 'center',
                                                                    alignItems: 'center',
                                                                    gap: 0
                                                                },
                                                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                                                    style: {
                                                                        fontSize: '12px',
                                                                        fontWeight: 400
                                                                    },
                                                                    id: "rsSubTitle",
                                                                    children: "No Score"
                                                                })
                                                            })
                                                        }, data?.id || data?.address_id)
                                                    }),
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$acefde28a3cb7b20), {
                                                        style: {
                                                            padding: '20px'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$d747b2abe71e53f5), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$dc8558b9a49863a4), {
                                                                        onClick: ()=>handleToggleInfo('Risk Score Information', data.risk_score_desc),
                                                                        children: [
                                                                            "Risk Score",
                                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b7c251a6b5f784dd$export$2e2bcd8739ae039), {})
                                                                        ]
                                                                    }),
                                                                    !Number.isNaN(data?.risk_score) && data.risk_ratio !== null ? /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                                                        style: {
                                                                            border: 'none',
                                                                            fontWeight: 600,
                                                                            fontSize: 15
                                                                        },
                                                                        children: `${data?.risk_score ? data?.risk_score : ''} / ${!Number.isNaN(data?.max_score) ? data?.max_score : ''}`
                                                                    }) : /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                                                        style: {
                                                                            border: 'none',
                                                                            fontWeight: 600,
                                                                            fontSize: 15
                                                                        },
                                                                        children: "No Score"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$d747b2abe71e53f5), {
                                                                style: {
                                                                    alignItems: 'center'
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$dc8558b9a49863a4), {
                                                                        style: {
                                                                            cursor: 'default'
                                                                        },
                                                                        children: "Timestamp"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                                                        style: {
                                                                            border: 'none',
                                                                            fontWeight: 600,
                                                                            fontSize: 15
                                                                        },
                                                                        children: data.request_time && (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(data.request_time).format((0, $41a9e38e6be32f35$export$67a03cd247c60132))
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$d747b2abe71e53f5), {
                                                                style: {
                                                                    alignItems: 'flex-end'
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$dc8558b9a49863a4), {
                                                                        onClick: ()=>handleToggleInfo('Risk Score Source Information', data.risk_provider_desc),
                                                                        children: [
                                                                            "Source",
                                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b7c251a6b5f784dd$export$2e2bcd8739ae039), {})
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                                                        style: {
                                                                            border: 'none',
                                                                            fontWeight: 600,
                                                                            fontSize: 15
                                                                        },
                                                                        children: data.provider_name && data.provider_name
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$a9754b3c8daa5172), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$a4fff7f2f85c4c81), {
                                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$d747b2abe71e53f5), {
                                                children: [
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$f99233281efd08a0), {
                                                        children: "Risk Score Descriptors: "
                                                    }),
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$a9754b3c8daa5172), {
                                                        style: {
                                                            gap: 5,
                                                            maxHeight: '150px',
                                                            overflowY: 'auto',
                                                            paddingRight: '20px'
                                                        },
                                                        children: data.risk_descriptors?.length > 0 && data.risk_descriptors.map((descriptor, i)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$c1dd341a97aad245), {
                                                                children: descriptor
                                                            }, i))
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$a9754b3c8daa5172), {
                                        style: {
                                            maxWidth: '443px'
                                        },
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$a4fff7f2f85c4c81), {
                                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$d747b2abe71e53f5), {
                                                children: [
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$f99233281efd08a0), {
                                                        children: "Controlling Entity: "
                                                    }),
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$cd1f041fcaf00d90), {
                                                        style: {
                                                            padding: '0 0 10px 0'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                                                children: "Name: "
                                                            }),
                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                                                style: {
                                                                    textAlign: 'right',
                                                                    textTransform: 'capitalize'
                                                                },
                                                                children: data.vasp_name_business ? formatVaspNames(data.vasp_name_business) : '-'
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$cd1f041fcaf00d90), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                                                children: "Website: "
                                                            }),
                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                                                style: {
                                                                    textAlign: 'right',
                                                                    textTransform: 'lowercase'
                                                                },
                                                                children: data.vasp_website ? formatVaspNames(data.vasp_website) : '-'
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$cd1f041fcaf00d90), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                                                children: "Type: "
                                                            }),
                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                                                style: {
                                                                    textAlign: 'right',
                                                                    textTransform: 'capitalize'
                                                                },
                                                                children: data.vasp_category ? formatVaspNames(data.vasp_category) : '-'
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        }, data?.id || data?.address_id);
                    }),
                    !riskData && !isLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$a4fff7f2f85c4c81), {
                        style: {
                            padding: '10px',
                            borderWidth: 1,
                            position: 'relative'
                        },
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$6fea5cf6191c0ed2), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$f99233281efd08a0), {
                                    children: "No Risk Data Available"
                                })
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$4e8a51dfb7785a56), {
                                style: {
                                    gridTemplateColumns: '320px 1fr 0.79fr'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$a9754b3c8daa5172), {
                                        style: {
                                            maxWidth: '320px',
                                            alignItems: 'center'
                                        },
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$a4fff7f2f85c4c81), {
                                            style: {
                                                display: 'flex',
                                                padding: 0
                                            },
                                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$87ad169bde460ddf), {
                                                children: [
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$87de03758d2d03db), {
                                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ba8982a7854b309f$export$2e2bcd8739ae039), {
                                                            id: "LoadingRisk123",
                                                            size: 120,
                                                            progress: 0,
                                                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$d747b2abe71e53f5), {
                                                                style: {
                                                                    justifyContent: 'center',
                                                                    alignItems: 'center',
                                                                    gap: 5
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                                        height: 24,
                                                                        width: 40
                                                                    }),
                                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                                        height: 14,
                                                                        width: 60
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$acefde28a3cb7b20), {
                                                        style: {
                                                            padding: '20px'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$d747b2abe71e53f5), {
                                                                style: {
                                                                    gap: 10
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$dc8558b9a49863a4), {
                                                                        children: [
                                                                            "Risk Score",
                                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b7c251a6b5f784dd$export$2e2bcd8739ae039), {})
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                                        height: 14,
                                                                        width: 80,
                                                                        borderRadius: 4
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$d747b2abe71e53f5), {
                                                                style: {
                                                                    alignItems: 'center',
                                                                    gap: 10
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$dc8558b9a49863a4), {
                                                                        style: {
                                                                            cursor: 'default'
                                                                        },
                                                                        children: "Timestamp"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                                        height: 14,
                                                                        width: 80,
                                                                        borderRadius: 4
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$d747b2abe71e53f5), {
                                                                style: {
                                                                    alignItems: 'flex-end',
                                                                    gap: 10
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$dc8558b9a49863a4), {
                                                                        children: [
                                                                            "Source",
                                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b7c251a6b5f784dd$export$2e2bcd8739ae039), {})
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                                        height: 14,
                                                                        width: 80,
                                                                        borderRadius: 4
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$a9754b3c8daa5172), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$a4fff7f2f85c4c81), {
                                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$d747b2abe71e53f5), {
                                                children: [
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$f99233281efd08a0), {
                                                        children: "Risk Score Descriptors: "
                                                    }),
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$a9754b3c8daa5172), {
                                                        style: {
                                                            gap: 5,
                                                            maxHeight: '150px',
                                                            overflowY: 'auto',
                                                            paddingRight: '20px'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                                width: 100
                                                            }),
                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                                width: 70
                                                            }),
                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                                width: 170
                                                            }),
                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                                width: 140
                                                            }),
                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                                width: 130
                                                            }),
                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                                width: 80
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$a9754b3c8daa5172), {
                                        style: {
                                            maxWidth: '443px'
                                        },
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$a4fff7f2f85c4c81), {
                                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$d747b2abe71e53f5), {
                                                children: [
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$f99233281efd08a0), {
                                                        children: "Controlling Entity: "
                                                    }),
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$cd1f041fcaf00d90), {
                                                        style: {
                                                            padding: '0 0 10px 0'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                                                children: "Name: "
                                                            }),
                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                                width: 180
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$cd1f041fcaf00d90), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                                                children: "Website: "
                                                            }),
                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                                width: 180
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$cd1f041fcaf00d90), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                                                children: "Type: "
                                                            }),
                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                                width: 180
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("div", {})
                ]
            })
        ]
    });
}
// Default Props
$24fc72fe456c8bf1$var$RiskDataSection.defaultProps = {
    riskData: null,
    isLoading: false,
    currentIpUsed: ''
};
// Proptypes Validation
$24fc72fe456c8bf1$var$RiskDataSection.propTypes = {
    riskData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object),
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    currentIpUsed: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        toggleAddressHistoryModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        toggleAddressReportModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAddressReportDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAddressHistoryDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        toggleDeleteAddressModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsLinkAddressDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAddressLinkDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAddressHistoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAddressRemove: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        toggleInfoModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setInfoModalDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $24fc72fe456c8bf1$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($24fc72fe456c8bf1$var$mapStateToProps, $24fc72fe456c8bf1$var$mapDispatchToProps)($24fc72fe456c8bf1$var$RiskDataSection);


var $fbd1da6e276e6a0a$export$2e2bcd8739ae039 = (0, $24fc72fe456c8bf1$export$2e2bcd8739ae039);


/* eslint-disable react/forbid-prop-types */ 

var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");





// Map Redux Props
const $07f2698a49796e51$var$mapStateToProps = (state)=>state;
const $07f2698a49796e51$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $07f2698a49796e51$var$LinkedAccount(props) {
    // Destructure
    const { actions: actions, accountDataProp: accountDataProp, setAccountDataProp: setAccountDataProp, isLoading: isLoading, isFetchError: isFetchError, address: address } = props;
    const { addressLinkData: addressLinkData } = address;
    // Store
    const { toggleInfoModal: toggleInfoModal, setInfoModalDetails: setInfoModalDetails, showAlert: showAlert, setAddressLinkData: setAddressLinkData } = actions;
    // Functions
    const handleToggleInfo = (title, content)=>{
        setInfoModalDetails({
            title: title,
            content: content
        });
        toggleInfoModal(true);
    };
    // UseEffects
    (0, $tZqWC.useEffect)(()=>{
        // TODO ADD PROPER ERROR MSG SENT FROM SERVER
        if (isFetchError) showAlert({
            type: 'error',
            message: 'An error occurred in fetching linkage'
        });
    }, [
        isFetchError
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (addressLinkData) {
            setAddressLinkData();
            setAccountDataProp(addressLinkData);
        }
    }, [
        addressLinkData
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$f5ec1ee0b77895e7), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$bc7adc8ef74607f), {
                style: {
                    gap: '10px',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    padding: '20px 10px 10px 10px',
                    cursor: 'pointer',
                    width: 'fit-content'
                },
                onClick: ()=>{
                    handleToggleInfo('Account Information', // eslint-disable-next-line max-len
                    'Identifies the owner or controller of an account, including its type, linked addresses, and compliance status.');
                },
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$f99233281efd08a0), {
                        style: {
                            fontWeight: '600',
                            fontSize: '15px',
                            cursor: 'pointer',
                            margin: 0
                        },
                        children: "Account Information"
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b7c251a6b5f784dd$export$2e2bcd8739ae039), {
                        size: 16
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$a4fff7f2f85c4c81), {
                style: {
                    padding: '10px',
                    borderWidth: 2
                },
                children: [
                    !isLoading && accountDataProp && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$bc7adc8ef74607f), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$a4fff7f2f85c4c81), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$cd1f041fcaf00d90), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                                children: "Reference ID: "
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$b2bf131c9f9cce5d), {
                                                    exact: true,
                                                    target: "_blank",
                                                    to: `/directory/accounts/details/${accountDataProp.id}`,
                                                    children: [
                                                        accountDataProp.reference_id,
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2aac7bf62453042d$export$2e2bcd8739ae039), {
                                                            size: 18
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$cd1f041fcaf00d90), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                                children: "Account Type: "
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                                children: accountDataProp.account_type_id === 1 ? 'Individual' : 'Entity'
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$cd1f041fcaf00d90), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                                children: "Status: "
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                                children: accountDataProp.status_id === 1 ? 'Active' : 'Inactive'
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$cd1f041fcaf00d90), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                                children: "Email: "
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                                children: accountDataProp.email
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$a4fff7f2f85c4c81), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$cd1f041fcaf00d90), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                                children: [
                                                    accountDataProp.account_type_id === 1 ? 'First Name' : 'Business Name',
                                                    ": "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                                children: accountDataProp.account_type_id === 1 ? accountDataProp.name_first : accountDataProp.name_business
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$cd1f041fcaf00d90), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                                children: [
                                                    accountDataProp.account_type_id === 1 ? 'Last Name' : 'Legal Name',
                                                    ": "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                                children: accountDataProp.account_type_id === 1 ? accountDataProp.name_last : accountDataProp.name_legal
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$cd1f041fcaf00d90), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                                children: [
                                                    accountDataProp.account_type_id === 1 ? 'Nationality' : 'Country of Incorporation',
                                                    ": "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                                children: accountDataProp?.display_country && accountDataProp.display_country
                                            })
                                        ]
                                    }),
                                    accountDataProp.account_type_id === 1 && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$cd1f041fcaf00d90), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                                children: "Date of Birth: "
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                                children: accountDataProp?.date_of_birth && accountDataProp.date_of_birth
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$a4fff7f2f85c4c81), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$cd1f041fcaf00d90), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                                children: "Street: "
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                                children: accountDataProp.address_street_name
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$cd1f041fcaf00d90), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                                children: "City: "
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                                children: accountDataProp.address_city
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$cd1f041fcaf00d90), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                                children: "Region: "
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                                children: accountDataProp.address_region
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$cd1f041fcaf00d90), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                                children: "Postcode: "
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                                children: accountDataProp.address_postcode
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    isLoading && !accountDataProp && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$bc7adc8ef74607f), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$a4fff7f2f85c4c81), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$cd1f041fcaf00d90), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                                children: "Reference ID: "
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5facfc7bc5a170d3$export$2e2bcd8739ae039), {
                                                width: 180
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$cd1f041fcaf00d90), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                                children: "Account Type: "
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5facfc7bc5a170d3$export$2e2bcd8739ae039), {
                                                width: 120
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$cd1f041fcaf00d90), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                                children: "Status: "
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5facfc7bc5a170d3$export$2e2bcd8739ae039), {
                                                width: 80
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$cd1f041fcaf00d90), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                                children: "Email: "
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5facfc7bc5a170d3$export$2e2bcd8739ae039), {
                                                width: 150
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$a4fff7f2f85c4c81), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$cd1f041fcaf00d90), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5facfc7bc5a170d3$export$2e2bcd8739ae039), {
                                                width: 120,
                                                height: 16
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5facfc7bc5a170d3$export$2e2bcd8739ae039), {
                                                width: 130
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$cd1f041fcaf00d90), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5facfc7bc5a170d3$export$2e2bcd8739ae039), {
                                                width: 120,
                                                height: 16
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5facfc7bc5a170d3$export$2e2bcd8739ae039), {
                                                width: 140
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$cd1f041fcaf00d90), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5facfc7bc5a170d3$export$2e2bcd8739ae039), {
                                                width: 120,
                                                height: 16
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5facfc7bc5a170d3$export$2e2bcd8739ae039), {
                                                width: 100
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$cd1f041fcaf00d90), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5facfc7bc5a170d3$export$2e2bcd8739ae039), {
                                                width: 120,
                                                height: 16
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5facfc7bc5a170d3$export$2e2bcd8739ae039), {
                                                width: 150
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$a4fff7f2f85c4c81), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$cd1f041fcaf00d90), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                                children: "Street: "
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5facfc7bc5a170d3$export$2e2bcd8739ae039), {
                                                width: 180
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$cd1f041fcaf00d90), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                                children: "City: "
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5facfc7bc5a170d3$export$2e2bcd8739ae039), {
                                                width: 180
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$cd1f041fcaf00d90), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                                children: "Region: "
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5facfc7bc5a170d3$export$2e2bcd8739ae039), {
                                                width: 180
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$cd1f041fcaf00d90), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                                children: "Postcode: "
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5facfc7bc5a170d3$export$2e2bcd8739ae039), {
                                                width: 180
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    !isLoading && !accountDataProp && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$bc7adc8ef74607f), {
                        style: {
                            position: 'relative'
                        },
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$6fea5cf6191c0ed2), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$f99233281efd08a0), {
                                    children: "Address is not Linked to an Account"
                                })
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$a4fff7f2f85c4c81), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$cd1f041fcaf00d90), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                                children: "Reference ID: "
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                width: 180
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$cd1f041fcaf00d90), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                                children: "Account Type: "
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                width: 120
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$cd1f041fcaf00d90), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                                children: "Status: "
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                width: 80
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$cd1f041fcaf00d90), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                                children: "Email: "
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                width: 150
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$a4fff7f2f85c4c81), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$cd1f041fcaf00d90), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                width: 120,
                                                height: 16
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                width: 130
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$cd1f041fcaf00d90), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                width: 120,
                                                height: 16
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                width: 140
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$cd1f041fcaf00d90), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                width: 120,
                                                height: 16
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                width: 100
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$cd1f041fcaf00d90), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                width: 120,
                                                height: 16
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                width: 150
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$a4fff7f2f85c4c81), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$cd1f041fcaf00d90), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                                children: "Street: "
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                width: 180
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$cd1f041fcaf00d90), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                                children: "City: "
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                width: 180
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$cd1f041fcaf00d90), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                                children: "Region: "
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                width: 180
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$cd1f041fcaf00d90), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                                children: "Postcode: "
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                width: 180
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
// Default Props
$07f2698a49796e51$var$LinkedAccount.defaultProps = {
    actions: {},
    address_data: {},
    address: {}
};
// Proptypes Validation
$07f2698a49796e51$var$LinkedAccount.propTypes = {
    setAccountDataProp: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        toggleInfoModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setInfoModalDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAddressLinkData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    address: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        addressLinkData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({})
    }),
    accountDataProp: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        reference_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        business_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        account_type_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        name_first: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        name_middle: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        name_last: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        date_of_birth: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        nationality_code: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        display_country: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        name_legal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        name_business: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        inc_country_code: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        inc_date: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        email: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        address_street_name: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        address_city: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        address_region: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        address_postcode: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        address_country_code: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        primary_activity_code: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        account_risk_value: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        sanction_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        pep_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        adverse_media_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        comments: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        status_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        created: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        last_modified: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        is_customer: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    address_data: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        address: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        chain: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        symbol: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        risk_score: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        balance_usd: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        balance: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        modify_tz: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        link_type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        link_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    }),
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    isFetchError: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
};
var $07f2698a49796e51$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($07f2698a49796e51$var$mapStateToProps, $07f2698a49796e51$var$mapDispatchToProps)($07f2698a49796e51$var$LinkedAccount);


var $14ee0b1772684b7d$export$2e2bcd8739ae039 = (0, $07f2698a49796e51$export$2e2bcd8739ae039);


/* eslint-disable no-nested-ternary */ /* eslint-disable react/jsx-no-useless-fragment */ /* eslint-disable react/no-array-index-key */ /* eslint-disable react/forbid-prop-types */ 
parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");







var $ejSM7 = parcelRequire("ejSM7");
// Map Redux Props
const $6ba6b7bee56b0913$var$mapStateToProps = (state)=>state;
const $6ba6b7bee56b0913$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $6ba6b7bee56b0913$var$SummarySection(props) {
    // Destructure
    const { actions: actions, financialData: financialData, addressData: addressData } = props;
    // Store Actions
    const { toggleInfoModal: toggleInfoModal, setInfoModalDetails: setInfoModalDetails } = actions;
    // Functions
    const handleToggleInfo = (title, content)=>{
        setInfoModalDetails({
            title: title,
            content: content
        });
        toggleInfoModal(true);
    };
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$f5ec1ee0b77895e7), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$bc7adc8ef74607f), {
                style: {
                    gap: '10px',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    padding: '20px 10px 10px 10px',
                    cursor: 'pointer',
                    width: 'fit-content'
                },
                onClick: ()=>{
                    handleToggleInfo('Wallet Address Information', // eslint-disable-next-line max-len
                    'Details about a specific blockchain address, including its balance, associated blockchain, and whether it is self-hosted.');
                },
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$f99233281efd08a0), {
                        style: {
                            fontWeight: '600',
                            fontSize: '15px',
                            margin: 0
                        },
                        children: "Wallet Address Information"
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b7c251a6b5f784dd$export$2e2bcd8739ae039), {
                        size: 16
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$a4fff7f2f85c4c81), {
                style: {
                    padding: '10px',
                    borderWidth: 2
                },
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$4e8a51dfb7785a56), {
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$a4fff7f2f85c4c81), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$cd1f041fcaf00d90), {
                                    children: [
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                            children: "Balance: "
                                        }),
                                        financialData && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                            children: financialData?.balance !== null && financialData?.balance !== undefined && addressData?.symbol ? `${financialData.balance > 1 ? (0, $ecf1d77ac1b82678$export$a2db1876938cd11d)(Math.round(financialData.balance * 100) / 100) : Number(financialData.balance?.toFixed(6))} ${addressData?.symbol && addressData.symbol.toUpperCase()}` : '-'
                                        }),
                                        !financialData && addressData && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                            children: addressData?.balance !== null && addressData?.balance !== undefined && addressData?.symbol ? `${addressData.balance > 1 ? (0, $ecf1d77ac1b82678$export$a2db1876938cd11d)(Math.round(addressData.balance * 100) / 100) : Number(addressData.balance?.toFixed(6))} ${addressData?.symbol && addressData.symbol.toUpperCase()}` : '-'
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$cd1f041fcaf00d90), {
                                    children: [
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                            children: "Blockchain: "
                                        }),
                                        addressData?.chain && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                            children: [
                                                addressData?.chain !== 'xdc' ? (0, $ecf1d77ac1b82678$export$7dac1d63a1a3adff)(addressData.chain) : addressData.chain?.toUpperCase(),
                                                addressData?.is_validated === true ? '' : ' (Unvalidated)'
                                            ]
                                        }),
                                        !addressData?.chain && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                            children: "-"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$cd1f041fcaf00d90), {
                                    children: [
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                            children: "Self-hosted Wallet: "
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                            children: [
                                                addressData?.is_self_hosted ? 'Yes' : 'No',
                                                " ",
                                                addressData?.is_verified === true ? '' : ' (Unverified)'
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$a4fff7f2f85c4c81), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$cd1f041fcaf00d90), {
                                    children: [
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                            children: "Transfers Sent: "
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                            children: Number.isInteger(addressData?.out_transfers_count) ? addressData?.out_transfers_count : '-'
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$cd1f041fcaf00d90), {
                                    children: [
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                            children: "Transfers Received: "
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                            children: Number.isInteger(addressData?.in_transfers_count) ? addressData?.in_transfers_count : '-'
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$a4fff7f2f85c4c81), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$cd1f041fcaf00d90), {
                                    children: [
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                            children: "Last Modified: "
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                            children: addressData?.last_modified ? (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(addressData?.last_modified).format((0, $41a9e38e6be32f35$export$859ef203c4495ed2)) : '-'
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$cd1f041fcaf00d90), {
                                    children: [
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                            children: "Last Modified By: "
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                            children: [
                                                " ",
                                                addressData?.modified_by_name ? addressData.modified_by_name : '-'
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
// Default Props
$6ba6b7bee56b0913$var$SummarySection.defaultProps = {};
// Proptypes Validation
$6ba6b7bee56b0913$var$SummarySection.propTypes = {
    financialData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object),
    addressData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        address: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        is_self_hosted: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
        is_validated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
        is_verified: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
        chain: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        symbol: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        risk_score: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        risk_ratio: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        balance_usd: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        balance: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        modify_tz: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        create_tz: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        link_type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        out_transfers_count: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        in_transfers_count: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        link_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        modified_by_name: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        last_modified: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        toggleAddressHistoryModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        toggleAddressReportModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAddressReportDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAddressHistoryDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        toggleDeleteAddressModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsLinkAddressDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAddressLinkDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAddressHistoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAddressRemove: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        toggleInfoModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setInfoModalDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $6ba6b7bee56b0913$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($6ba6b7bee56b0913$var$mapStateToProps, $6ba6b7bee56b0913$var$mapDispatchToProps)($6ba6b7bee56b0913$var$SummarySection);


var $cb019efa4c77f834$export$2e2bcd8739ae039 = (0, $6ba6b7bee56b0913$export$2e2bcd8739ae039);


/* eslint-disable react/forbid-prop-types */ 

var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");


var $ejSM7 = parcelRequire("ejSM7");







// Map Redux Props
const $e91705c4916acf38$var$mapStateToProps = (state)=>state;
const $e91705c4916acf38$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $e91705c4916acf38$var$FooterSection(props) {
    // Destructure
    const { addressData: addressData, setAddressData: setAddressData, setCurrentIpUsed: setCurrentIpUsed, setIsLoading: setIsLoading, actions: actions, address: address, createOrUpdateAddress: createOrUpdateAddress, createOrUpdateAddressError: createOrUpdateAddressError, isCreateOrUpdateAddressLoading: isCreateOrUpdateAddressLoading } = props;
    const { toggleAddressHistoryModal: toggleAddressHistoryModal, toggleAddressReportModal: toggleAddressReportModal, setAddressReportDetails: setAddressReportDetails, toggleDeleteAddressModal: toggleDeleteAddressModal, setIsLinkAddressDrawerOpen: setIsLinkAddressDrawerOpen, showAlert: showAlert, setAddressLinkDetails: setAddressLinkDetails, setAddressHistoryFilters: setAddressHistoryFilters, setAddressRemove: setAddressRemove, toggleInfoModal: toggleInfoModal, setInfoModalDetails: setInfoModalDetails } = actions;
    const { addressChains: addressChains } = address;
    // Hooks
    const { updateAddressHosted: updateAddressHosted, updateAddressHostedData: updateAddressHostedData, updateAddressHostedError: updateAddressHostedError, isUpdateAddressHostedLoading: isUpdateAddressHostedLoading } = (0, $2290198e2bfa0bad$export$2e2bcd8739ae039)();
    // local state
    const [csi] = (0, $tZqWC.useState)((0, $60e52eb6c2680325$export$96c4cef8dff1bd45)());
    // Functions
    const handleDeleteAddress = ()=>{
        setAddressRemove({
            address_id: addressData.id
        });
        toggleDeleteAddressModal();
    };
    const handleLink = ()=>{
        setAddressLinkDetails({
            address: addressData.address,
            address_id: addressData.id,
            chain: addressData.chain
        });
        setIsLinkAddressDrawerOpen(true);
    };
    const handleScan = (ip)=>{
        setCurrentIpUsed(ip);
        createOrUpdateAddress({
            address: addressData.address,
            chain: addressData.chain,
            provider_id: addressChains?.risk?.[ip]?.[addressData?.symbol]?.provider_id
        });
    };
    const handleCreateReport = ()=>{
        setAddressReportDetails({
            address: addressData.address,
            address_id: addressData.id,
            chain: addressData.chain
        });
        toggleAddressReportModal();
    };
    const handleHistoryToggle = ()=>{
        setAddressHistoryFilters({
            address: addressData.address,
            address_id: addressData.id,
            sort: '-last_modified',
            page: 1,
            size: 10,
            start_range: (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))('Jan 1 2008').format((0, $41a9e38e6be32f35$export$1bceb808939a9f0c)),
            end_range: (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))().format((0, $41a9e38e6be32f35$export$1bceb808939a9f0c))
        });
        toggleAddressHistoryModal();
    };
    const handleToggleInfo = (title, content)=>{
        setInfoModalDetails({
            title: title,
            content: content
        });
        toggleInfoModal(true);
    };
    // UseEffect
    (0, $tZqWC.useEffect)(()=>{
        if (createOrUpdateAddressError?.response?.data?.message) showAlert({
            type: 'error',
            message: createOrUpdateAddressError?.response?.data?.message
        });
        else if (createOrUpdateAddressError) showAlert({
            type: 'error',
            message: 'An error occurred in screening address'
        });
    }, [
        createOrUpdateAddressError
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (isCreateOrUpdateAddressLoading) setIsLoading(true);
        else setIsLoading(false);
    }, [
        isCreateOrUpdateAddressLoading
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (updateAddressHostedData && !updateAddressHostedError) setAddressData({
            ...addressData,
            is_self_hosted: updateAddressHostedData?.is_self_hosted
        });
    }, [
        updateAddressHostedData
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$f5ec1ee0b77895e7), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$bc7adc8ef74607f), {
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$a9754b3c8daa5172), {
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                            variant: "outlined",
                            size: "small",
                            onClick: handleHistoryToggle,
                            disabled: csi !== 1,
                            children: "See History"
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                            variant: "outlined",
                            size: "small",
                            onClick: handleCreateReport,
                            disabled: csi !== 1,
                            children: "Create Report"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$a9754b3c8daa5172), {
                    style: {
                        justifyContent: 'flex-end'
                    },
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                            variant: "outlined",
                            size: "small",
                            endIcon: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b77b5de3fb591045$export$2e2bcd8739ae039), {
                                size: 10
                            }),
                            onClick: handleDeleteAddress,
                            children: "Remove"
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $ca6f920a36c82944$export$2e2bcd8739ae039), {
                            direction: "down",
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $478ff5739380e08c$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                        variant: "outlined",
                                        size: "small",
                                        endIcon: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d2d07bb75c367a07$export$2e2bcd8739ae039), {
                                            size: 10
                                        }),
                                        children: isUpdateAddressHostedLoading ? 'Updating...' : 'Is Wallet Self-Hosted'
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $7a68433660fee9cb$export$2e2bcd8739ae039), {
                                    left: true,
                                    style: {
                                        maxWidth: '155px',
                                        minWidth: '125px',
                                        padding: '0 12px'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c7b007afae0a2778$export$2e2bcd8739ae039), {
                                            disabled: isUpdateAddressHostedLoading || addressData?.is_self_hosted === true,
                                            onClick: ()=>{
                                                updateAddressHosted({
                                                    is_self_hosted: true,
                                                    address_id: addressData?.id
                                                });
                                            },
                                            style: {
                                                borderRadius: 0,
                                                justifyContent: 'center',
                                                padding: '9px'
                                            },
                                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                                children: "Yes"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c7b007afae0a2778$export$2e2bcd8739ae039), {
                                            disabled: isUpdateAddressHostedLoading || addressData?.is_self_hosted === false,
                                            onClick: ()=>{
                                                updateAddressHosted({
                                                    is_self_hosted: false,
                                                    address_id: addressData?.id
                                                });
                                            },
                                            style: {
                                                borderRadius: 0,
                                                justifyContent: 'center',
                                                padding: '9px'
                                            },
                                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                                children: "No"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        addressData.id && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                            variant: "outlined",
                            size: "small",
                            endIcon: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ef7aaa91ec87194a$export$2e2bcd8739ae039), {
                                size: 10
                            }),
                            onClick: handleLink,
                            children: "Link"
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $ca6f920a36c82944$export$2e2bcd8739ae039), {
                            direction: "down",
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $478ff5739380e08c$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                        variant: "outlined",
                                        size: "small",
                                        endIcon: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6417d0fa9c066aa3$export$2e2bcd8739ae039), {
                                            size: 10
                                        }),
                                        children: "Add score"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7a68433660fee9cb$export$2e2bcd8739ae039), {
                                    left: true,
                                    style: {
                                        maxWidth: '155px',
                                        minWidth: '125px',
                                        padding: '0 12px'
                                    },
                                    children: Object?.keys(addressChains?.risk || {})?.length > 0 && Object.keys(addressChains?.risk)?.map((key)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c7b007afae0a2778$export$2e2bcd8739ae039), {
                                            disabled: isCreateOrUpdateAddressLoading || !addressChains?.risk?.[key]?.[addressData?.symbol],
                                            onClick: ()=>{
                                                if (isCreateOrUpdateAddressLoading || !addressChains?.risk?.[key]?.[addressData?.symbol]) return;
                                                if (addressChains?.risk?.[key]?.[addressData?.symbol]) handleScan(key);
                                                else handleToggleInfo('Authorization Needed', 'You currently do not have access to this feature.');
                                            },
                                            style: {
                                                borderRadius: 0,
                                                justifyContent: 'center',
                                                padding: '9px'
                                            },
                                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$5f1af8db9871e1d6), {
                                                children: key
                                            })
                                        }, key))
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
// Default Props
$e91705c4916acf38$var$FooterSection.defaultProps = {};
// Proptypes Validation
$e91705c4916acf38$var$FooterSection.propTypes = {
    addressData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        address: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        chain: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        symbol: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        risk_score: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        risk_ratio: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        balance_usd: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        balance: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        modify_tz: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        create_tz: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        link_type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        link_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        is_self_hosted: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
        modified_by_name: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    }),
    setCurrentIpUsed: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    createOrUpdateAddress: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    createOrUpdateAddressError: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        response: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            data: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
                message: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
            })
        })
    }),
    isCreateOrUpdateAddressLoading: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    accountDataProp: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({}),
    setAddressData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        accountDirectoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object)
    }),
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    setIsLoading: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        toggleAddressHistoryModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        toggleAddressReportModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAddressReportDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAddressHistoryDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        toggleDeleteAddressModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsLinkAddressDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAddressLinkDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAddressHistoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAddressRemove: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        toggleInfoModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setInfoModalDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    address: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object)
};
var $e91705c4916acf38$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($e91705c4916acf38$var$mapStateToProps, $e91705c4916acf38$var$mapDispatchToProps)($e91705c4916acf38$var$FooterSection);


var $96fed3066773a748$export$2e2bcd8739ae039 = (0, $e91705c4916acf38$export$2e2bcd8739ae039);


// Map Redux Props
const $8eab5175bf22cbcb$var$mapStateToProps = (state)=>state;
const $8eab5175bf22cbcb$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $8eab5175bf22cbcb$var$AddressesTableItemDetails(props) {
    // Destructure
    const { isExpanded: isExpanded, financialData: financialData, setFinancialData: setFinancialData, riskData: riskData, setRiskData: setRiskData, addressData: addressData, setAddressData: setAddressData, accountDataProp: accountDataProp, setAccountData: setAccountData, actions: actions, address: address } = props;
    const { showAlert: showAlert } = actions;
    const { addressChains: addressChains } = address;
    // Hooks
    const { getAddressDetails: getAddressDetails, getAddressDetailsData: getAddressDetailsData, getAddressDetailsError: getAddressDetailsError, isGetAddressDetailsLoading: isGetAddressDetailsLoading } = (0, $8aa3c72c70de01d3$export$2e2bcd8739ae039)();
    const { getAccount: getAccount, accountData: accountData, accountError: accountError, isAccountLoading: isAccountLoading } = (0, $aa9aabe79903a329$export$2e2bcd8739ae039)();
    const { createOrUpdateAddress: createOrUpdateAddress, createOrUpdateAddressData: createOrUpdateAddressData, createOrUpdateAddressError: createOrUpdateAddressError, isCreateOrUpdateAddressLoading: isCreateOrUpdateAddressLoading } = (0, $b297ef53431cfca8$export$2e2bcd8739ae039)();
    // local state
    const [currentIpUsed, setCurrentIpUsed] = (0, $tZqWC.useState)();
    const [availableIps, setAvailableIps] = (0, $tZqWC.useState)(null);
    const [isLoading, setIsLoading] = (0, $tZqWC.useState)(false);
    // Functions
    const fetchData = ()=>{
        getAccount({
            account_id: addressData.link_id
        });
    };
    const handleData = ()=>{
        if (accountData) setAccountData(accountData);
    };
    const handleAvailableIps = ()=>{
        if (availableIps) return;
        if (!addressChains?.risk) return;
        let newAvailableIps = {};
        Object.keys(addressChains?.risk).forEach((item)=>{
            const ip = addressChains?.risk[item];
            Object.keys(ip).forEach((ipChain)=>{
                if (ip[ipChain]?.chain_name === addressData?.chain) newAvailableIps = {
                    ...newAvailableIps,
                    [ip[ipChain]?.provider_code]: {
                        integration_id: ip[ipChain]?.integration_id,
                        provider_code: ip[ipChain]?.provider_code
                    }
                };
            });
        });
        setAvailableIps(newAvailableIps);
    };
    const handleCreateOrUpdateAddress = ()=>{
        if (createOrUpdateAddressData) {
            if (createOrUpdateAddressData?.risk_data) setRiskData((prevValue)=>{
                if (!prevValue && !!createOrUpdateAddressData.risk_data) return [
                    createOrUpdateAddressData.risk_data
                ];
                const newRiskData = [];
                const oldRiskData = [];
                prevValue.forEach((item)=>{
                    if (item.provider_name === currentIpUsed && createOrUpdateAddressData.risk_data !== null) newRiskData.push(createOrUpdateAddressData.risk_data);
                    else oldRiskData.push(item);
                });
                if (newRiskData?.length < 1) return [
                    createOrUpdateAddressData.risk_data,
                    ...prevValue
                ];
                return [
                    ...newRiskData,
                    ...oldRiskData
                ];
            });
            setFinancialData(createOrUpdateAddressData.financial_data);
            const newAddressData = {
                ...addressData
            };
            if (createOrUpdateAddressData.financial_data?.balance_usd !== null && createOrUpdateAddressData.financial_data?.balance_usd !== undefined) newAddressData.balance_usd = createOrUpdateAddressData.financial_data.balance_usd;
            if (createOrUpdateAddressData.financial_data?.balance !== null && createOrUpdateAddressData.financial_data?.balance !== undefined) newAddressData.balance = createOrUpdateAddressData.financial_data.balance;
            if (createOrUpdateAddressData.risk_data?.risk_score !== null && createOrUpdateAddressData.risk_data?.risk_score !== undefined) newAddressData.risk_score = createOrUpdateAddressData.risk_data.risk_score;
            setAddressData(newAddressData);
            setCurrentIpUsed();
        }
    };
    // UseEffect
    (0, $tZqWC.useEffect)(()=>handleData(), [
        accountData
    ]);
    (0, $tZqWC.useEffect)(()=>addressData.link_id && isExpanded && !accountDataProp && fetchData(), [
        isExpanded
    ]);
    (0, $tZqWC.useEffect)(()=>{
        handleAvailableIps();
    }, []);
    (0, $tZqWC.useEffect)(()=>{
        if (isExpanded && !financialData && !riskData && Number.isInteger(addressData?.risk_score)) getAddressDetails({
            address_id: addressData.id
        });
    }, [
        isExpanded
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (getAddressDetailsData) {
            setAddressData({
                ...addressData,
                modified_by_name: getAddressDetailsData?.modified_by_name
            });
            setRiskData(getAddressDetailsData.risk_data);
            setFinancialData(getAddressDetailsData.financial_data);
        }
    }, [
        getAddressDetailsData
    ]);
    (0, $tZqWC.useEffect)(()=>{
        // TODO ADD PROPER ERROR MSG SENT FROM SERVER
        if (getAddressDetailsError) showAlert({
            type: 'error',
            message: 'An error occurred in fetching addresses'
        });
    }, [
        getAddressDetailsError
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (isGetAddressDetailsLoading) setIsLoading(true);
        else setIsLoading(false);
    }, [
        isGetAddressDetailsLoading
    ]);
    (0, $tZqWC.useEffect)(()=>{
        handleCreateOrUpdateAddress();
    }, [
        createOrUpdateAddressData
    ]);
    (0, $tZqWC.useEffect)(()=>{
        console.log('ERROR: ', createOrUpdateAddressError?.response);
    }, [
        createOrUpdateAddressError
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$e6dfd72ab29f8598), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $903e8682de7d89eb$export$42a852a2b6b56249), {
            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $903e8682de7d89eb$export$f5ec1ee0b77895e7), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $cb019efa4c77f834$export$2e2bcd8739ae039), {
                        financialData: financialData,
                        addressData: addressData
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $14ee0b1772684b7d$export$2e2bcd8739ae039), {
                        accountDataProp: accountDataProp,
                        setAccountDataProp: setAccountData,
                        address_data: addressData,
                        isExpanded: isExpanded,
                        isLoading: isAccountLoading,
                        isFetchError: accountError
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $fbd1da6e276e6a0a$export$2e2bcd8739ae039), {
                        riskData: riskData,
                        currentIpUsed: currentIpUsed,
                        isLoading: isLoading
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $96fed3066773a748$export$2e2bcd8739ae039), {
                        setFinancialData: setFinancialData,
                        setRiskData: setRiskData,
                        addressData: addressData,
                        setAddressData: setAddressData,
                        currentIpUsed: currentIpUsed,
                        setCurrentIpUsed: setCurrentIpUsed,
                        setIsLoading: setIsLoading,
                        createOrUpdateAddress: createOrUpdateAddress,
                        createOrUpdateAddressData: createOrUpdateAddressData,
                        createOrUpdateAddressError: createOrUpdateAddressError,
                        isCreateOrUpdateAddressLoading: isCreateOrUpdateAddressLoading
                    })
                ]
            }, currentIpUsed)
        })
    });
}
// Default Props
$8eab5175bf22cbcb$var$AddressesTableItemDetails.defaultProps = {
    financialData: null,
    setFinancialData: ()=>{},
    riskData: null,
    setRiskData: ()=>{},
    addressData: null,
    setAddressData: ()=>{},
    actions: {},
    filters: {},
    address: {},
    ui: {},
    isExpanded: false
};
// Proptypes Validation
$8eab5175bf22cbcb$var$AddressesTableItemDetails.propTypes = {
    financialData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object),
    setFinancialData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    riskData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object),
    setRiskData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    addressData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        address: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        chain: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        symbol: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        risk_score: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        risk_ratio: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        balance_usd: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        balance: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        modify_tz: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        create_tz: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        link_type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        link_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        modified_by_name: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    }),
    accountDataProp: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({}),
    setAccountData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    // businessNotes: PropTypes.arrayOf({}),
    // setBusinessNotes: PropTypes.func,
    setAddressData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        accountDirectoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object)
    }),
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        toggleAddressHistoryModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        toggleAddressReportModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAddressReportDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAddressHistoryDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        toggleDeleteAddressModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsLinkAddressDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAddressLinkDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAddressHistoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAddressRemove: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        toggleInfoModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setInfoModalDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    address: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object),
    isExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
};
var $8eab5175bf22cbcb$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($8eab5175bf22cbcb$var$mapStateToProps, $8eab5175bf22cbcb$var$mapDispatchToProps)($8eab5175bf22cbcb$var$AddressesTableItemDetails);


var $41a088f1b8c211a9$export$2e2bcd8739ae039 = (0, $8eab5175bf22cbcb$export$2e2bcd8739ae039);


// Map Redux Props
const $6a35ffe3ec31bfb8$var$mapStateToProps = (state)=>state;
const $6a35ffe3ec31bfb8$var$mapDispatchToProps = (dispatch)=>(0, $2154a4c08d887b32$export$e324594224ef24da)(dispatch);
function $6a35ffe3ec31bfb8$var$AddressesTableItem(props) {
    // Destructure
    const { data: data, address: address, actions: actions, getAddressesError: getAddressesError, openedTab: openedTab, setOpenedTab: setOpenedTab } = props;
    const { addressLinkData: addressLinkData, addressLinkDetails: addressLinkDetails, scannedAddressDetails: scannedAddressDetails } = address;
    const { setAddressLinkData: setAddressLinkData, setAddressLinkDetails: setAddressLinkDetails, setScannedAddressDetails: setScannedAddressDetails, setAddressFilters: setAddressFilters, setIsPageTableUpdated: setIsPageTableUpdated } = actions;
    // States
    const [barWidth, setBarWidth] = (0, $tZqWC.useState)('0%');
    const [isExpanded, setIsExpanded] = (0, $tZqWC.useState)(false);
    const [chainIcon, setChainIcon] = (0, $tZqWC.useState)();
    // Component States
    const [addressData, setAddressData] = (0, $tZqWC.useState)({
        id: data.id,
        address: data.address,
        chain: data.chain,
        symbol: data.symbol,
        risk_score: data?.risk_score,
        risk_ratio: data?.risk_ratio,
        balance_usd: data?.balance_usd,
        balance: data?.balance,
        is_validated: data?.is_validated,
        is_verified: data?.is_verified,
        last_modified: data.last_modified,
        link_id: data.link_id,
        link_type: data.link_type
    });
    const { chain: chain, symbol: symbol, balance: balance, last_modified: last_modified, risk_ratio: risk_ratio, is_validated: is_validated } = addressData;
    const [financialData, setFinancialData] = (0, $tZqWC.useState)();
    const [riskData, setRiskData] = (0, $tZqWC.useState)();
    const [accountData, setAccountData] = (0, $tZqWC.useState)();
    const [businessNotes, setBusinessNotes] = (0, $tZqWC.useState)();
    const [copyNotification, setCopyNotification] = (0, $tZqWC.useState)('');
    function handleScannedAddress() {
        if (scannedAddressDetails?.risk_data) setRiskData((prevValue)=>{
            const newRiskData = [
                scannedAddressDetails.risk_data
            ];
            if (prevValue) prevValue.forEach((item)=>{
                if (item.provider_name !== scannedAddressDetails.risk_data.provider_name) newRiskData.push(item);
            });
            return newRiskData;
        });
        setFinancialData(scannedAddressDetails.financial_data);
        setOpenedTab(scannedAddressDetails.address);
        setScannedAddressDetails(null);
    }
    function formatValue(number) {
        if (number < 1000000) return (0, $ecf1d77ac1b82678$export$a2db1876938cd11d)(Math.round(number * 100) / 100);
        return (0, $ecf1d77ac1b82678$export$866ef2858852149a).format(number);
    }
    const copyHash = ()=>{
        navigator.clipboard.writeText(addressData.address).then(()=>setCopyNotification('Copied!'), ()=>setCopyNotification('Error: Could not copy'));
        setTimeout(()=>setCopyNotification(''), 700);
    };
    (0, $tZqWC.useEffect)(()=>{
        if (chain && is_validated) setChainIcon((0, $df4784c9100a83b7$export$c25425c0b9a3de13)[chain?.toLowerCase()]);
        if (!chain || !is_validated) setChainIcon((0, $df4784c9100a83b7$export$c25425c0b9a3de13).unknown);
        if (risk_ratio) setBarWidth(`${risk_ratio}%`);
    }, []);
    (0, $tZqWC.useEffect)(()=>{
        if (addressLinkData) {
            if (addressLinkDetails.address_id === addressData.id) {
                setAccountData(addressLinkData);
                setAddressLinkData();
                setAddressLinkDetails();
            }
        }
    }, [
        addressLinkData
    ]);
    (0, $tZqWC.useEffect)(()=>scannedAddressDetails && scannedAddressDetails?.address === data.address && handleScannedAddress(), [
        scannedAddressDetails
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (!isExpanded && !addressData.id && !scannedAddressDetails && !getAddressesError) {
            setAddressFilters();
            setIsPageTableUpdated(true);
            setOpenedTab();
        }
    }, [
        isExpanded
    ]);
    // !This doesnt work when the item was opened before
    (0, $tZqWC.useEffect)(()=>{
        if (openedTab !== data.address) setIsExpanded(false);
        if (openedTab === data.address) setIsExpanded(true);
    }, [
        openedTab
    ]);
    (0, $tZqWC.useEffect)(()=>setAddressData(data), [
        data
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b3f7dc6528742bb0$export$2e2bcd8739ae039), {
        setIsExpanded: (val)=>{
            setIsExpanded(val);
            setOpenedTab(addressData.address);
        },
        expandPanel: isExpanded,
        button: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $60f7fcdba0ad955c$export$fd2299f554be8993), {
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $60f7fcdba0ad955c$export$9f515a68dfaeb9ef), {
                    isExpanded: isExpanded,
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $60f7fcdba0ad955c$export$987cac99e7a31168), {
                            children: [
                                chainIcon && /*#__PURE__*/ (0, $tZqWC.cloneElement)(chainIcon),
                                isExpanded ? /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $60f7fcdba0ad955c$export$edc246bee1ec68d2), {
                                    className: "hashWrapper",
                                    onClick: copyHash,
                                    children: [
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $60f7fcdba0ad955c$export$829b0583f0fe5152), {
                                            className: "hashWrapper",
                                            children: addressData.address
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c43eb4ee7dedc1da$export$2e2bcd8739ae039), {
                                            size: 18,
                                            className: "hashWrapper"
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $60f7fcdba0ad955c$export$b30c94aee60c7d6b), {
                                            display: copyNotification,
                                            children: copyNotification
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a6f961941b47e982$export$2e2bcd8739ae039), {
                                    text: addressData.address,
                                    sliceLength: 7
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $60f7fcdba0ad955c$export$987cac99e7a31168), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $60f7fcdba0ad955c$export$49316f37c3b5fade), {
                                children: (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(last_modified?.split('T')[0]).format((0, $41a9e38e6be32f35$export$859ef203c4495ed2))
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $60f7fcdba0ad955c$export$9f515a68dfaeb9ef), {
                    isExpanded: isExpanded,
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $60f7fcdba0ad955c$export$987cac99e7a31168), {
                            children: risk_ratio !== null && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $60f7fcdba0ad955c$export$49316f37c3b5fade), {
                                        children: `${risk_ratio}%`
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f598a52270fcc8c$export$2e2bcd8739ae039), {
                                        width: barWidth
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $60f7fcdba0ad955c$export$987cac99e7a31168), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $60f7fcdba0ad955c$export$6f4a084cc8e379b6), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $60f7fcdba0ad955c$export$49316f37c3b5fade), {
                                        className: "address_item_amount",
                                        children: [
                                            balance !== null && balance !== undefined && (symbol || chain) && `${(symbol || chain)?.toUpperCase()}: ${balance > 1 ? formatValue(balance) : Number(balance?.toFixed(6))}`,
                                            balance === null && (symbol || chain) && `${(symbol || chain)?.toUpperCase()}: -`
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $60f7fcdba0ad955c$export$65b9fe47bb7b64b0), {
                                        children: chain && chain?.toLowerCase()
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        }),
        panel: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $60f7fcdba0ad955c$export$85524e8d4e82fc69), {
            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $41a088f1b8c211a9$export$2e2bcd8739ae039), {
                isExpanded: isExpanded,
                // Details state
                financialData: financialData,
                setFinancialData: setFinancialData,
                riskData: riskData,
                setRiskData: setRiskData,
                addressData: addressData,
                setAddressData: setAddressData,
                accountDataProp: accountData,
                setAccountData: setAccountData,
                businessNotes: businessNotes,
                setBusinessNotes: setBusinessNotes
            })
        })
    });
}
// Default Props
$6a35ffe3ec31bfb8$var$AddressesTableItem.defaultProps = {
    address: {},
    actions: {},
    data: {
        id: '',
        address: '',
        chain: '',
        symbol: '',
        risk_score: 0,
        balance_usd: 0,
        balance: 0,
        last_modified: '',
        link_type: 1,
        link_id: ''
    }
};
// Proptypes Validation
$6a35ffe3ec31bfb8$var$AddressesTableItem.propTypes = {
    getAddressesError: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    openedTab: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    setOpenedTab: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    address: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        addressLinkDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            address_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
        }),
        addressLinkData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({}),
        scannedAddressDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            address: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            chain: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            symbol: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            symbol_icon: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            is_validated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
            is_verified: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
            financial_data: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
                provider_name: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
                balance: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
                balance_usd: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
                spent: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
                spent_usd: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
                received: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
                received_usd: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
                transaction_count: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
                latest_activity: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
            }),
            risk_data: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
                provider_name: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
                risk_score: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
                vasp_name_legal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
                vasp_name_business: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
                vasp_website: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
                vasp_category: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
                api_result_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
            }),
            request_tz: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            link_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            link_type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number
        })
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setAddressLinkData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAddressLinkDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setScannedAddressDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAddressFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    data: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        address: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        chain: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        symbol: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        risk_score: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        risk_ratio: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        balance_usd: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        balance: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        last_modified: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        link_type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        link_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        modified_by_name: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        is_validated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
        is_verified: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    })
};
var $6a35ffe3ec31bfb8$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($6a35ffe3ec31bfb8$var$mapStateToProps, $6a35ffe3ec31bfb8$var$mapDispatchToProps)($6a35ffe3ec31bfb8$var$AddressesTableItem);


/* eslint-disable react/no-unstable-nested-components */ 
parcelRequire("tZqWC");



const $9e243c8210b54b4b$export$fd2299f554be8993 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: 1fr 1.8fr;
  gap: 50px;
  align-items: center;

  padding: 10px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $9e243c8210b54b4b$export$9f515a68dfaeb9ef = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  gap: 20px;

  &:last-child > div:last-child {
    max-width: 150px;
  }
  &:last-child > div:first-child {
    justify-content: flex-end;
    max-width: 535px;
  }

  &:first-child > div:last-child {
    justify-content: flex-end;
    visibility: ${({ isExpanded: isExpanded })=>isExpanded && 'hidden'};
  }
  &:last-child > div:first-child {
    visibility: ${({ isExpanded: isExpanded })=>isExpanded && 'hidden'};
  }
`;
const $9e243c8210b54b4b$export$987cac99e7a31168 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  width: 100%;

  gap: 20px;
`;
const $9e243c8210b54b4b$export$6f4a084cc8e379b6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
`;
const $9e243c8210b54b4b$export$49316f37c3b5fade = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 15px;
  font-weight: 400;

  max-width: 250px;

  &:first-child {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  &.address_item_amount {
    max-width: 100px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
`;
const $9e243c8210b54b4b$export$7c901fb2027bd1cd = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background: ${({ theme: theme })=>theme.colors.backgroundLite};
`;



// Map Redux Props
const $c02e22f88a6b4c0c$var$mapStateToProps = (state)=>state;
const $c02e22f88a6b4c0c$var$mapDispatchToProps = (dispatch)=>(0, $2154a4c08d887b32$export$e324594224ef24da)(dispatch);
function $c02e22f88a6b4c0c$var$AddressesTableItemLoading() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b3f7dc6528742bb0$export$2e2bcd8739ae039), {
        setIsExpanded: ()=>{},
        expandPanel: false,
        button: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9e243c8210b54b4b$export$fd2299f554be8993), {
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9e243c8210b54b4b$export$9f515a68dfaeb9ef), {
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9e243c8210b54b4b$export$987cac99e7a31168), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9e243c8210b54b4b$export$7c901fb2027bd1cd), {}),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5facfc7bc5a170d3$export$2e2bcd8739ae039), {
                                    height: 18,
                                    width: 150
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9e243c8210b54b4b$export$987cac99e7a31168), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5facfc7bc5a170d3$export$2e2bcd8739ae039), {
                                height: 18,
                                width: 120
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9e243c8210b54b4b$export$9f515a68dfaeb9ef), {
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9e243c8210b54b4b$export$987cac99e7a31168), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5facfc7bc5a170d3$export$2e2bcd8739ae039), {
                                    height: 18,
                                    width: 50
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f598a52270fcc8c$export$2e2bcd8739ae039), {
                                    width: 0
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9e243c8210b54b4b$export$987cac99e7a31168), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9e243c8210b54b4b$export$6f4a084cc8e379b6), {
                                style: {
                                    gap: '5px'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5facfc7bc5a170d3$export$2e2bcd8739ae039), {
                                        height: 17,
                                        width: 50
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5facfc7bc5a170d3$export$2e2bcd8739ae039), {
                                        height: 12,
                                        width: 30
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        }),
        panel: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("div", {})
    });
}
// Default Props
$c02e22f88a6b4c0c$var$AddressesTableItemLoading.defaultProps = {};
// Proptypes Validation
$c02e22f88a6b4c0c$var$AddressesTableItemLoading.propTypes = {};
var $c02e22f88a6b4c0c$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($c02e22f88a6b4c0c$var$mapStateToProps, $c02e22f88a6b4c0c$var$mapDispatchToProps)($c02e22f88a6b4c0c$var$AddressesTableItemLoading);


// Map Redux Props
const $844de0b5cc0e2cc3$var$mapStateToProps = (state)=>state;
const $844de0b5cc0e2cc3$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $844de0b5cc0e2cc3$var$AddressesTable(props) {
    // Destructure
    const { filters: filters, ui: ui, actions: actions, address: address } = props;
    // Store States
    const { addressFilters: addressFilters } = filters;
    const { scannedAddress: scannedAddress } = address;
    const { isPageTableUpdated: isPageTableUpdated } = ui;
    const { setIsPageTableUpdated: setIsPageTableUpdated, setAddressFilters: setAddressFilters, showAlert: showAlert, setScannedAddress: setScannedAddress, setScannedAddressDetails: setScannedAddressDetails } = actions;
    // Hooks
    const { getAddresses: getAddresses, getAddressesData: getAddressesData, getAddressesError: getAddressesError, isGetAddressesLoading: isGetAddressesLoading } = (0, $d3447c5e6b8a84bc$export$2e2bcd8739ae039)();
    // Local states
    const [addresses, setAddresses] = (0, $tZqWC.useState)([]);
    const [pagination, setPagination] = (0, $tZqWC.useState)();
    const [openedTab, setOpenedTab] = (0, $tZqWC.useState)();
    // Functions
    function handleScannedAddress() {
        const newAddress = {
            id: scannedAddress.address_id,
            address: scannedAddress.address,
            chain: scannedAddress.chain,
            symbol: scannedAddress.symbol,
            risk_score: scannedAddress.risk_data?.risk_score,
            risk_ratio: scannedAddress.risk_data?.risk_ratio,
            balance_usd: scannedAddress.financial_data?.balance_usd,
            balance: scannedAddress.financial_data?.balance,
            modify_tz: scannedAddress.request_tz,
            link_id: scannedAddress.link_id,
            link_type: scannedAddress.link_type,
            is_self_hosted: scannedAddress.is_self_hosted,
            is_validated: scannedAddress?.is_validated,
            is_verified: scannedAddress?.is_verified,
            modified_by_name: scannedAddress.modified_by_name
        };
        const newAddressList = [
            newAddress
        ];
        addresses.forEach((item)=>{
            if (item.address !== scannedAddress.address) newAddressList.push(item);
        });
        // Changing it back to null
        setScannedAddress(null);
        setAddresses(newAddressList);
        setScannedAddressDetails(scannedAddress);
    }
    function fetchAddresses() {
        getAddresses(addressFilters);
    }
    // UseEffects
    (0, $tZqWC.useEffect)(()=>{
        setAddressFilters();
    }, []);
    (0, $tZqWC.useEffect)(()=>fetchAddresses(), [
        addressFilters
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (isPageTableUpdated) {
            fetchAddresses();
            setIsPageTableUpdated(false);
        }
    }, [
        isPageTableUpdated
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (getAddressesData) {
            setAddresses(getAddressesData.items);
            setPagination(getAddressesData.pagination);
        }
    }, [
        getAddressesData
    ]);
    (0, $tZqWC.useEffect)(()=>{
        // TODO ADD PROPER ERROR MSG SENT FROM SERVER
        if (getAddressesError) showAlert({
            type: 'error',
            message: 'An error occurred in fetching addresses'
        });
    }, [
        getAddressesError
    ]);
    (0, $tZqWC.useEffect)(()=>{
        // TODO ADD PROPER ERROR MSG SENT FROM SERVER
        if (scannedAddress) handleScannedAddress();
    }, [
        scannedAddress
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $5e2018fa25f91cb0$export$4267411171632d35), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $5e2018fa25f91cb0$export$cbf11d5f692bc726), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7e43e1df6e75bbbe$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e166a664f096c85c$export$2e2bcd8739ae039), {})
                ]
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $d2b0b55dc8f66a40$export$2e2bcd8739ae039), {
                totalItems: pagination?.total && pagination.total,
                minWidth: 900,
                tableFilters: addressFilters,
                setTableFilters: setAddressFilters,
                children: [
                    addresses.length > 0 && !isGetAddressesLoading && addresses.map((data, i)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6a35ffe3ec31bfb8$export$2e2bcd8739ae039), {
                            openedTab: openedTab,
                            setOpenedTab: setOpenedTab,
                            data: data,
                            getAddressesError: getAddressesError
                        }, `${data?.id}${i}`)),
                    isGetAddressesLoading && Array.from({
                        length: addressFilters?.size || 10
                    }).map((_, index)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c02e22f88a6b4c0c$export$2e2bcd8739ae039), {}, index)),
                    addresses.length < 1 && !isGetAddressesLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a6ea3b0f3caed586$export$2e2bcd8739ae039), {
                        setFilter: setAddressFilters
                    })
                ]
            })
        ]
    });
}
// Default Props
$844de0b5cc0e2cc3$var$AddressesTable.defaultProps = {
    actions: {},
    filters: {},
    ui: {},
    address: {
        addressChains: null
    }
};
// Proptypes Validation
$844de0b5cc0e2cc3$var$AddressesTable.propTypes = {
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        addressFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object)
    }),
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setToBeUpdatedAccount: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAccountDirectoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsIndividualAccountDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsEntityAccountDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAddressFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setScannedAddress: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setScannedAddressDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAddressChains: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setDefaultAddressProvider: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    address: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        scannedAddress: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            address_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            address: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            chain: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            symbol: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            symbol_icon: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            financial_data: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
                provider_name: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
                balance: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
                balance_usd: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
                spent: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
                spent_usd: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
                received: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
                received_usd: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
                transaction_count: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
                latest_activity: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
            }),
            risk_data: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
                provider_name: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
                risk_score: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
                risk_ratio: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
                vasp_name_legal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
                vasp_name_business: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
                vasp_website: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
                vasp_category: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
                api_result_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
            }),
            request_tz: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            modified_by_name: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            link_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            link_type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
            is_self_hosted: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
            is_validated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
            is_verified: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
        }),
        addressChains: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({}),
        defaultAddressProvider: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({})
    })
};
var $844de0b5cc0e2cc3$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($844de0b5cc0e2cc3$var$mapStateToProps, $844de0b5cc0e2cc3$var$mapDispatchToProps)($844de0b5cc0e2cc3$var$AddressesTable);


var $9f7e8f2f16ba1f2b$export$2e2bcd8739ae039 = (0, $844de0b5cc0e2cc3$export$2e2bcd8739ae039);



var $b49ad3ba05b75678$export$2e2bcd8739ae039 = (0, $6a35ffe3ec31bfb8$export$2e2bcd8739ae039);




var $2f96b51918581e7d$export$2e2bcd8739ae039 = (0, $c02e22f88a6b4c0c$export$2e2bcd8739ae039);



/* eslint-disable react/no-array-index-key */ 

var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");




const $8e657a986efe297e$export$4267411171632d35 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 10px 0 0 0;
`;
const $8e657a986efe297e$export$cbf11d5f692bc726 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
`;
const $8e657a986efe297e$export$97d84ed62ab03b3f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  margin: 0px 0px 0px 16px;

  font-weight: inherit;
  font-size: inherit;
`;




/* eslint-disable react/no-unstable-nested-components */ 

var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");


var $ejSM7 = parcelRequire("ejSM7");






const $bc38f7c8ae5583a7$export$fd2299f554be8993 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: 1fr 1.8fr;
  gap: 50px;
  align-items: center;

  padding: 10px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $bc38f7c8ae5583a7$export$9f515a68dfaeb9ef = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  gap: 20px;

  &:last-child > div:last-child {
    max-width: 150px;
  }
  &:last-child > div:first-child {
    justify-content: flex-end;
    max-width: 550px;
  }

  &:first-child > div:last-child {
    justify-content: flex-end;
    visibility: ${({ isExpanded: isExpanded })=>isExpanded && 'hidden'};
    width: ${({ isExpanded: isExpanded })=>isExpanded && 0};
  }
  &:last-child > div:first-child {
    visibility: ${({ isExpanded: isExpanded })=>isExpanded && 'hidden'};
    width: ${({ isExpanded: isExpanded })=>isExpanded && 0};
  }
`;
const $bc38f7c8ae5583a7$export$987cac99e7a31168 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  width: 100%;

  gap: 20px;
`;
const $bc38f7c8ae5583a7$export$6f4a084cc8e379b6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
`;
const $bc38f7c8ae5583a7$export$49316f37c3b5fade = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 15px;
  font-weight: 400;

  max-width: 250px;

  &:first-child {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
`;
const $bc38f7c8ae5583a7$export$edc246bee1ec68d2 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;

  & svg {
    height: 20px;
    width: 20px;
  }
`;
const $bc38f7c8ae5583a7$export$829b0583f0fe5152 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 15px;
  font-weight: 400;
`;
const $bc38f7c8ae5583a7$export$b30c94aee60c7d6b = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: absolute;
  top: 100%;
  margin-top: 10px;

  font-size: 15px;
  font-weight: 400;
  padding: 10px 20px;
  border-radius: 10px;
  background-color: ${({ theme: theme })=>theme.colors.background};

  transition: 0.1s;
  opacity: ${({ display: display })=>display ? 1 : 0};
  box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.15);
`;
const $bc38f7c8ae5583a7$export$b502300b413480 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).span`
  font-size: 8px;
  font-weight: 400;
`;
const $bc38f7c8ae5583a7$export$65b9fe47bb7b64b0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 10px;
  font-weight: 400;
`;
const $bc38f7c8ae5583a7$export$85524e8d4e82fc69 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;



/* eslint-disable react/forbid-prop-types */ 

var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");




const $9518101ed4013f4a$export$e6dfd72ab29f8598 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
`;
const $9518101ed4013f4a$export$d53c836cccbb0d90 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: absolute;
  top: 0;
  right: 0;

  display: flex;
  gap: 10px;
`;
const $9518101ed4013f4a$export$42a852a2b6b56249 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $9518101ed4013f4a$export$f5ec1ee0b77895e7 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $9518101ed4013f4a$export$b2e35077a5c7bc77 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-start;

  width: 100%;
`;
const $9518101ed4013f4a$export$f6e382949408c1f3 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  min-width: 300px;
  gap: 8px;
  max-width: 470px;
`;
const $9518101ed4013f4a$export$bc7adc8ef74607f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding-top: 10px;
  display: flex;
  justify-content: space-between;
  gap: 10px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $9518101ed4013f4a$export$4e8a51dfb7785a56 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  width: 100%;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 10px;
`;
const $9518101ed4013f4a$export$a9754b3c8daa5172 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  gap: 10px;
`;
const $9518101ed4013f4a$export$cd1f041fcaf00d90 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 10px;
  padding: 10px 0;
  border-bottom: 1px solid ${({ theme: theme })=>theme.colors.backgroundLite};
`;
const $9518101ed4013f4a$export$acefde28a3cb7b20 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 10px;
  border-color: ${({ theme: theme })=>theme.colors.backgroundLite};
  border-style: solid;
  border-width: 0;
`;
const $9518101ed4013f4a$export$a4fff7f2f85c4c81 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  padding: 20px;
  width: 100%;
  height: 100%;
  border-radius: 7px;
  border: 1px solid ${({ theme: theme })=>theme.colors.backgroundLite};

  background-color: ${({ theme: theme })=>`${theme.colors.secondary}10`};
  & > div:last-child {
    border: none;
  }
`;
const $9518101ed4013f4a$export$87ad169bde460ddf = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 100%;

  border-color: ${({ theme: theme })=>theme.colors.backgroundLite};
  border-style: solid;
  border-width: 0;
`;
const $9518101ed4013f4a$export$d747b2abe71e53f5 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 100%;

  & > div:last-child {
    border: none;
    padding-bottom: 0;
  }
`;
const $9518101ed4013f4a$export$5f1af8db9871e1d6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  margin: 0;
  padding: 0;
  font-size: 14px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $9518101ed4013f4a$export$6d028b688a5b0ff9 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).span`
  /* color: ${({ theme: theme })=>theme.colors.brand}; */
  font-weight: 600;
`;
const $9518101ed4013f4a$export$c1dd341a97aad245 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).span`
  margin: 0;
  padding: 0;
  font-size: 12px;
  color: ${({ theme: theme, color: color })=>color === 'darkGray' ? theme.colors.primary : theme.colors.yellowGreen};
  border: 1px solid ${({ theme: theme, color: color })=>color === 'darkGray' ? theme.colors.primary : theme.colors.yellowGreen};
  border-radius: 5px;
`;
const $9518101ed4013f4a$export$f99233281efd08a0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h2`
  margin: 0;
  padding: 0;
  font-size: 15px;
  font-weight: 400;
  color: ${({ theme: theme })=>theme.colors.primary};
  text-transform: uppercase;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;
const $9518101ed4013f4a$export$ae133abb7f01f500 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 20px 0 0 0;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(520px, 1fr));
  gap: 60px;
`;
const $9518101ed4013f4a$export$8f314e512d92575f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  width: 40px;

  font-size: 20px;
  border: 1px solid ${({ theme: theme })=>theme.colors.primary};
  border-radius: 100%;
`;
const $9518101ed4013f4a$export$71237909d9ca197d = (0, $a778141486c79bc3$export$2e2bcd8739ae039).hr`
  width: 100%;
  height: 2px !important;

  color: ${({ theme: theme })=>theme.colors.secondary};
  margin: 20px 0;
`;
const $9518101ed4013f4a$export$dc8558b9a49863a4 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h2`
  margin: 0;
  padding: 0;
  font-size: 15px;
  font-weight: 400;
  color: ${({ theme: theme })=>theme.colors.primary};
  text-transform: uppercase;
  margin-bottom: -7px;

  font-weight: 300;
  font-size: 10px;
  padding-top: 5px;
  display: flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;
`;
const $9518101ed4013f4a$export$b2bf131c9f9cce5d = (0, $a778141486c79bc3$export$2e2bcd8739ae039)((0, $12b33660068e86aa$export$b0d92dbee9b5b60d))`
  display: flex;
  align-items: center;
  gap: 5px;
  height: 100%;

  & svg {
    height: 100%;
    max-height: 15px;
  }
`;
const $9518101ed4013f4a$export$87de03758d2d03db = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 20px 20px 0 20px;

  & #rsSubTitle {
    color: ${({ theme: theme })=>theme.colors.secondary};
  }
`;
const $9518101ed4013f4a$export$f2ab17920c9d243 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  justify-content: center;
  align-items: center;
  width: fit-content;
  padding: 20px 20px 20px 0;
  border-right: 1px solid ${({ theme: theme })=>theme.colors.backgroundLite};
`;



/* eslint-disable no-undef */ /* eslint-disable no-nested-ternary */ /* eslint-disable react/jsx-no-useless-fragment */ /* eslint-disable react/no-array-index-key */ /* eslint-disable react/forbid-prop-types */ 

var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");


var $ejSM7 = parcelRequire("ejSM7");









parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");


var $ejSM7 = parcelRequire("ejSM7");





const $9bf059c0c997aa70$export$5f1af8db9871e1d6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  margin: 0;
  padding: 0;
  font-size: 14px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $9bf059c0c997aa70$export$f99233281efd08a0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h2`
  margin: 0;
  padding: 0;
  font-size: 15px;
  font-weight: 400;
  color: ${({ theme: theme })=>theme.colors.primary};
  text-transform: uppercase;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;
const $9bf059c0c997aa70$export$d747b2abe71e53f5 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 100%;

  & > div:last-child {
    border: none;
    padding-bottom: 0;
  }
`;
const $9bf059c0c997aa70$export$bc7adc8ef74607f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding-top: 10px;
  display: flex;
  justify-content: space-between;
  gap: 10px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $9bf059c0c997aa70$export$a9754b3c8daa5172 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  gap: 10px;
`;
const $9bf059c0c997aa70$export$4e8a51dfb7785a56 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  width: 100%;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 10px;
`;
const $9bf059c0c997aa70$export$cd1f041fcaf00d90 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 10px;
  padding: 10px 0;
  border-bottom: 1px solid ${({ theme: theme })=>theme.colors.backgroundLite};
`;
const $9bf059c0c997aa70$export$a4fff7f2f85c4c81 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  padding: 20px;
  width: 100%;
  height: 100%;
  border-radius: 7px;
  border: 1px solid ${({ theme: theme })=>theme.colors.backgroundLite};
  transition: 0.3s;

  /* background-color: ${({ theme: theme })=>`${theme.colors.secondary}10`}; */
  & > div:last-child {
    border: none;
  }
  &#riskBlock:hover {
    cursor: pointer;
    border: 1px solid ${({ theme: theme })=>theme.colors.brand};
    background-color: ${({ theme: theme })=>`${theme.colors.brand}10`};
  }
`;
const $9bf059c0c997aa70$export$dc8558b9a49863a4 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h2`
  margin: 0;
  padding: 0;
  font-weight: 400;
  color: ${({ theme: theme })=>theme.colors.primary};

  font-size: 14px;
  padding-top: 5px;
  display: flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;
`;
const $9bf059c0c997aa70$export$87de03758d2d03db = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  & #rsSubTitle {
    color: ${({ theme: theme })=>theme.colors.secondary};
  }
`;


// Map Redux Props
const $67f71a9c4f35efe3$var$mapStateToProps = (state)=>state;
const $67f71a9c4f35efe3$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $67f71a9c4f35efe3$var$RiskDetails(props) {
    const { riskData: riskData, isGetTransactionDetailsLoading: isGetTransactionDetailsLoading, isCreateOrUpdateTransactionLoading: isCreateOrUpdateTransactionLoading, currentIpUsed: currentIpUsed, onClick: onClick } = props;
    // Actions
    // Functions
    const handleClick = (index)=>{
        if (onClick && !(riskData[index]?.in_risk_ratio === null || riskData[index]?.out_risk_ratio === null)) onClick(index);
    };
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
        children: [
            riskData && !isGetTransactionDetailsLoading && riskData.map((data, i)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9bf059c0c997aa70$export$a4fff7f2f85c4c81), {
                    id: "riskBlock",
                    onClick: ()=>handleClick(i),
                    style: {
                        marginTop: '15px',
                        padding: '10px',
                        borderWidth: 2
                    },
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9bf059c0c997aa70$export$bc7adc8ef74607f), {
                        style: {
                            padding: 0
                        },
                        children: [
                            isCreateOrUpdateTransactionLoading && data.risk_provider_id === currentIpUsed && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9bf059c0c997aa70$export$a9754b3c8daa5172), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9bf059c0c997aa70$export$a4fff7f2f85c4c81), {
                                    style: {
                                        display: 'flex',
                                        justifyContent: 'center',
                                        padding: 0,
                                        borderWidth: 2
                                    },
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $647b8bc68ebce54f$export$2e2bcd8739ae039), {
                                        style: {
                                            padding: '45px 0'
                                        }
                                    })
                                })
                            }),
                            !isCreateOrUpdateTransactionLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9bf059c0c997aa70$export$4e8a51dfb7785a56), {
                                style: {
                                    gap: '15px'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9bf059c0c997aa70$export$a9754b3c8daa5172), {
                                        style: {
                                            gap: '10px'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9bf059c0c997aa70$export$a9754b3c8daa5172), {
                                                style: {
                                                    maxWidth: '250px',
                                                    alignItems: 'center'
                                                },
                                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9bf059c0c997aa70$export$a4fff7f2f85c4c81), {
                                                    style: {
                                                        display: 'flex',
                                                        padding: '30px 0'
                                                    },
                                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9bf059c0c997aa70$export$87de03758d2d03db), {
                                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ba8982a7854b309f$export$2e2bcd8739ae039), {
                                                            id: `${data?.id}-${i}`,
                                                            size: 130,
                                                            progress: data?.in_risk_ratio && data.in_risk_ratio,
                                                            children: data?.in_risk_ratio && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9bf059c0c997aa70$export$d747b2abe71e53f5), {
                                                                style: {
                                                                    justifyContent: 'center',
                                                                    alignItems: 'center',
                                                                    gap: 0
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9bf059c0c997aa70$export$5f1af8db9871e1d6), {
                                                                        style: {
                                                                            fontSize: '18px',
                                                                            fontWeight: 600
                                                                        },
                                                                        children: `${data.in_risk_ratio}%`
                                                                    }),
                                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9bf059c0c997aa70$export$5f1af8db9871e1d6), {
                                                                        style: {
                                                                            fontSize: '12px',
                                                                            fontWeight: 400
                                                                        },
                                                                        id: "rsSubTitle",
                                                                        children: "Risk"
                                                                    })
                                                                ]
                                                            })
                                                        }, data?.id)
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9bf059c0c997aa70$export$a9754b3c8daa5172), {
                                                style: {
                                                    flex: 1
                                                },
                                                children: data?.in_risk_ratio !== null || data?.out_risk_ratio !== null ? /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9bf059c0c997aa70$export$a4fff7f2f85c4c81), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9bf059c0c997aa70$export$f99233281efd08a0), {
                                                            style: {
                                                                textAlign: 'center'
                                                            },
                                                            children: [
                                                                "Input Risk ",
                                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2d68211da31cd8b8$export$2e2bcd8739ae039), {
                                                                    size: 18
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9bf059c0c997aa70$export$cd1f041fcaf00d90), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9bf059c0c997aa70$export$dc8558b9a49863a4), {
                                                                    children: "Risk Score"
                                                                }),
                                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9bf059c0c997aa70$export$5f1af8db9871e1d6), {
                                                                    style: {
                                                                        border: 'none',
                                                                        fontSize: 15
                                                                    },
                                                                    children: `${data?.in_risk_score !== null && data?.in_risk_score !== undefined ? data?.in_risk_score : ''} / ${data?.max_score !== null && data?.max_score !== undefined ? data?.max_score : ''}`
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9bf059c0c997aa70$export$cd1f041fcaf00d90), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9bf059c0c997aa70$export$dc8558b9a49863a4), {
                                                                    style: {
                                                                        cursor: 'default'
                                                                    },
                                                                    children: "Timestamp"
                                                                }),
                                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9bf059c0c997aa70$export$5f1af8db9871e1d6), {
                                                                    style: {
                                                                        border: 'none',
                                                                        fontSize: 15
                                                                    },
                                                                    children: data?.created && (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(data.created).format((0, $41a9e38e6be32f35$export$67a03cd247c60132))
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9bf059c0c997aa70$export$cd1f041fcaf00d90), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9bf059c0c997aa70$export$dc8558b9a49863a4), {
                                                                    children: "Source"
                                                                }),
                                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9bf059c0c997aa70$export$5f1af8db9871e1d6), {
                                                                    style: {
                                                                        border: 'none',
                                                                        fontSize: 15
                                                                    },
                                                                    children: data?.risk_provider_code || 'unknown'
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }) : /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9bf059c0c997aa70$export$a4fff7f2f85c4c81), {
                                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9bf059c0c997aa70$export$f99233281efd08a0), {
                                                        style: {
                                                            textAlign: 'center'
                                                        },
                                                        children: [
                                                            "Input Risk (Unavailable) ",
                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2d68211da31cd8b8$export$2e2bcd8739ae039), {
                                                                size: 18
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9bf059c0c997aa70$export$a9754b3c8daa5172), {
                                        style: {
                                            gap: '10px'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9bf059c0c997aa70$export$a9754b3c8daa5172), {
                                                style: {
                                                    maxWidth: '250px',
                                                    alignItems: 'center'
                                                },
                                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9bf059c0c997aa70$export$a4fff7f2f85c4c81), {
                                                    style: {
                                                        display: 'flex',
                                                        padding: '30px 0'
                                                    },
                                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9bf059c0c997aa70$export$87de03758d2d03db), {
                                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ba8982a7854b309f$export$2e2bcd8739ae039), {
                                                            id: `${data?.id}-${i}`,
                                                            size: 130,
                                                            progress: data?.out_risk_ratio && data.out_risk_ratio,
                                                            children: data?.out_risk_ratio && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9bf059c0c997aa70$export$d747b2abe71e53f5), {
                                                                style: {
                                                                    justifyContent: 'center',
                                                                    alignItems: 'center',
                                                                    gap: 0
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9bf059c0c997aa70$export$5f1af8db9871e1d6), {
                                                                        style: {
                                                                            fontSize: '18px',
                                                                            fontWeight: 600
                                                                        },
                                                                        children: `${data.out_risk_ratio}%`
                                                                    }),
                                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9bf059c0c997aa70$export$5f1af8db9871e1d6), {
                                                                        style: {
                                                                            fontSize: '12px',
                                                                            fontWeight: 400
                                                                        },
                                                                        id: "rsSubTitle",
                                                                        children: "Risk"
                                                                    })
                                                                ]
                                                            })
                                                        }, data?.id)
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9bf059c0c997aa70$export$a9754b3c8daa5172), {
                                                style: {
                                                    flex: 1
                                                },
                                                children: data?.in_risk_ratio !== null || data?.out_risk_ratio !== null ? /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9bf059c0c997aa70$export$a4fff7f2f85c4c81), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9bf059c0c997aa70$export$f99233281efd08a0), {
                                                            style: {
                                                                textAlign: 'center'
                                                            },
                                                            children: [
                                                                "Output Risk ",
                                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $738b185bd23471f4$export$2e2bcd8739ae039), {
                                                                    size: 18
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9bf059c0c997aa70$export$cd1f041fcaf00d90), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9bf059c0c997aa70$export$dc8558b9a49863a4), {
                                                                    children: "Risk Score"
                                                                }),
                                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9bf059c0c997aa70$export$5f1af8db9871e1d6), {
                                                                    style: {
                                                                        border: 'none',
                                                                        fontSize: 15
                                                                    },
                                                                    children: `${data?.out_risk_score !== null && data?.out_risk_score !== undefined ? data?.out_risk_score : ''} / ${data?.max_score !== null && data?.max_score !== undefined ? data?.max_score : ''}`
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9bf059c0c997aa70$export$cd1f041fcaf00d90), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9bf059c0c997aa70$export$dc8558b9a49863a4), {
                                                                    style: {
                                                                        cursor: 'default'
                                                                    },
                                                                    children: "Timestamp"
                                                                }),
                                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9bf059c0c997aa70$export$5f1af8db9871e1d6), {
                                                                    style: {
                                                                        border: 'none',
                                                                        fontSize: 15
                                                                    },
                                                                    children: data?.created && (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(data.created).format((0, $41a9e38e6be32f35$export$67a03cd247c60132))
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9bf059c0c997aa70$export$cd1f041fcaf00d90), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9bf059c0c997aa70$export$dc8558b9a49863a4), {
                                                                    children: "Source"
                                                                }),
                                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9bf059c0c997aa70$export$5f1af8db9871e1d6), {
                                                                    style: {
                                                                        border: 'none',
                                                                        fontSize: 15
                                                                    },
                                                                    children: data?.risk_provider_code || 'unknown'
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }) : /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9bf059c0c997aa70$export$a4fff7f2f85c4c81), {
                                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9bf059c0c997aa70$export$f99233281efd08a0), {
                                                        style: {
                                                            textAlign: 'center'
                                                        },
                                                        children: [
                                                            "Output Risk (Unavailable) ",
                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $738b185bd23471f4$export$2e2bcd8739ae039), {
                                                                size: 18
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }, data?.id || i)),
            (!riskData || riskData?.length < 1) && isCreateOrUpdateTransactionLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9bf059c0c997aa70$export$a4fff7f2f85c4c81), {
                style: {
                    marginTop: '15px'
                },
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9bf059c0c997aa70$export$bc7adc8ef74607f), {
                    style: {
                        padding: 0
                    },
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9bf059c0c997aa70$export$a9754b3c8daa5172), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9bf059c0c997aa70$export$a4fff7f2f85c4c81), {
                            style: {
                                display: 'flex',
                                justifyContent: 'center',
                                padding: 0
                            },
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $647b8bc68ebce54f$export$2e2bcd8739ae039), {
                                style: {
                                    padding: '45px 0'
                                }
                            })
                        })
                    })
                })
            })
        ]
    });
}
// Default Props
$67f71a9c4f35efe3$var$RiskDetails.defaultProps = {
    riskData: null,
    isGetTransactionDetailsLoading: false,
    isCreateOrUpdateTransactionLoading: false,
    currentIpUsed: null,
    actions: {}
};
// Proptypes Validation
$67f71a9c4f35efe3$var$RiskDetails.propTypes = {
    riskData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object),
    isGetTransactionDetailsLoading: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    isCreateOrUpdateTransactionLoading: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    currentIpUsed: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        toggleInfoModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setInfoModalDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $67f71a9c4f35efe3$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($67f71a9c4f35efe3$var$mapStateToProps, $67f71a9c4f35efe3$var$mapDispatchToProps)($67f71a9c4f35efe3$var$RiskDetails);


var $d7262e42ecba02f5$export$2e2bcd8739ae039 = (0, $67f71a9c4f35efe3$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");


var $ejSM7 = parcelRequire("ejSM7");




const $444855e5a1cd0615$export$5f1af8db9871e1d6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  margin: 0;
  padding: 0;
  font-size: 14px;
  color: ${({ theme: theme })=>theme.colors.primary};
  text-align: right;
`;
const $444855e5a1cd0615$export$d747b2abe71e53f5 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  flex: 1;

  & > div:last-child {
    border: none;
    padding-bottom: 0;
  }
`;
const $444855e5a1cd0615$export$bc7adc8ef74607f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding-top: 10px;
  display: flex;
  justify-content: space-between;
  gap: 10px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $444855e5a1cd0615$export$a9754b3c8daa5172 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex: 1;
  gap: 20px;
`;
const $444855e5a1cd0615$export$cd1f041fcaf00d90 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 10px;
  padding: 10px 0;
  border-bottom: 1px solid ${({ theme: theme })=>theme.colors.backgroundLite};
`;
const $444855e5a1cd0615$export$a4fff7f2f85c4c81 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  padding: 20px;
  width: 100%;
  height: 100%;
  border-radius: 7px;
  border: 1px solid ${({ theme: theme })=>theme.colors.backgroundLite};

  /* background-color: ${({ theme: theme })=>`${theme.colors.secondary}10`}; */
  & > div:last-child {
    border: none;
  }
`;
const $444855e5a1cd0615$export$dc8558b9a49863a4 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h2`
  margin: 0;
  padding: 0;
  font-weight: 400;
  color: ${({ theme: theme })=>theme.colors.primary};

  font-size: 14px;
  padding-top: 5px;
  display: flex;
  align-items: center;
  gap: 5px;
`;


// Map Redux Props
const $a3aec34af2134efb$var$mapStateToProps = (state)=>state;
const $a3aec34af2134efb$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $a3aec34af2134efb$var$FinancialDetails(props) {
    const { transactionData: transactionData, isGetTransactionDetailsLoading: isGetTransactionDetailsLoading, txDescription: txDescription } = props;
    // Functions
    function formatValue(number) {
        if (number < 0.01) return number;
        return (0, $ecf1d77ac1b82678$export$a2db1876938cd11d)(Math.round(number * 100) / 100);
    }
    if (transactionData && !isGetTransactionDetailsLoading) return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $444855e5a1cd0615$export$a4fff7f2f85c4c81), {
        style: {
            marginTop: '15px',
            padding: '10px',
            borderWidth: 2
        },
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $444855e5a1cd0615$export$bc7adc8ef74607f), {
            style: {
                padding: 0
            },
            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $444855e5a1cd0615$export$a9754b3c8daa5172), {
                style: {
                    gap: '15px'
                },
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $444855e5a1cd0615$export$a9754b3c8daa5172), {
                    style: {
                        gap: '15px'
                    },
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $444855e5a1cd0615$export$a4fff7f2f85c4c81), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $444855e5a1cd0615$export$a9754b3c8daa5172), {
                                style: {
                                    flex: 1
                                },
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $444855e5a1cd0615$export$d747b2abe71e53f5), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $444855e5a1cd0615$export$cd1f041fcaf00d90), {
                                                children: [
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $444855e5a1cd0615$export$dc8558b9a49863a4), {
                                                        children: "Digital Assets: "
                                                    }),
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $444855e5a1cd0615$export$5f1af8db9871e1d6), {
                                                        children: [
                                                            transactionData?.symbol,
                                                            transactionData?.asset_count > 1 && `, +${transactionData.asset_count - 1}`
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $444855e5a1cd0615$export$cd1f041fcaf00d90), {
                                                children: [
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $444855e5a1cd0615$export$dc8558b9a49863a4), {
                                                        children: "Blockchain:"
                                                    }),
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $444855e5a1cd0615$export$5f1af8db9871e1d6), {
                                                        children: transactionData?.chain
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $444855e5a1cd0615$export$cd1f041fcaf00d90), {
                                                children: [
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $444855e5a1cd0615$export$dc8558b9a49863a4), {
                                                        children: "Fee Amount USD: "
                                                    }),
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $444855e5a1cd0615$export$5f1af8db9871e1d6), {
                                                        children: transactionData?.fee_amount_usd ? `$ ${formatValue(transactionData.fee_amount_usd)}` : '-'
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $444855e5a1cd0615$export$cd1f041fcaf00d90), {
                                                children: [
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $444855e5a1cd0615$export$dc8558b9a49863a4), {
                                                        children: "Timestamp:"
                                                    }),
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $444855e5a1cd0615$export$5f1af8db9871e1d6), {
                                                        children: transactionData?.created && (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(transactionData?.created).format((0, $41a9e38e6be32f35$export$67a03cd247c60132))
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $444855e5a1cd0615$export$d747b2abe71e53f5), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $444855e5a1cd0615$export$cd1f041fcaf00d90), {
                                                children: [
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $444855e5a1cd0615$export$dc8558b9a49863a4), {
                                                        children: "Input Amount USD:"
                                                    }),
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $444855e5a1cd0615$export$5f1af8db9871e1d6), {
                                                        children: transactionData?.in_usd ? `$ ${formatValue(transactionData.in_usd)}` : '-'
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $444855e5a1cd0615$export$cd1f041fcaf00d90), {
                                                children: [
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $444855e5a1cd0615$export$dc8558b9a49863a4), {
                                                        children: "Input Events: "
                                                    }),
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $444855e5a1cd0615$export$5f1af8db9871e1d6), {
                                                        children: transactionData?.in_count
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $444855e5a1cd0615$export$cd1f041fcaf00d90), {
                                                children: [
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $444855e5a1cd0615$export$dc8558b9a49863a4), {
                                                        children: "Output Amount USD: "
                                                    }),
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $444855e5a1cd0615$export$5f1af8db9871e1d6), {
                                                        children: transactionData?.out_usd ? `$ ${formatValue(transactionData.out_usd)}` : '-'
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $444855e5a1cd0615$export$cd1f041fcaf00d90), {
                                                children: [
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $444855e5a1cd0615$export$dc8558b9a49863a4), {
                                                        children: "Output Events: "
                                                    }),
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $444855e5a1cd0615$export$5f1af8db9871e1d6), {
                                                        children: transactionData?.out_count
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $444855e5a1cd0615$export$a4fff7f2f85c4c81), {
                            children: txDescription && txDescription
                        })
                    ]
                })
            })
        })
    });
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $444855e5a1cd0615$export$a4fff7f2f85c4c81), {});
}
// Default Props
$a3aec34af2134efb$var$FinancialDetails.defaultProps = {
    isGetTransactionDetailsLoading: false,
    actions: {},
    transactionData: {}
};
// Proptypes Validation
$a3aec34af2134efb$var$FinancialDetails.propTypes = {
    txDescription: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).element,
    isGetTransactionDetailsLoading: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        toggleInfoModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setInfoModalDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    transactionData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        chain: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        symbol: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        risk_score: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        risk_ratio: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        in_usd: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        out_usd: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        fee_amount_usd: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        balance: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        last_modified: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        created: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        in_count: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        out_count: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        asset_count: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number
    })
};
var $a3aec34af2134efb$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($a3aec34af2134efb$var$mapStateToProps, $a3aec34af2134efb$var$mapDispatchToProps)($a3aec34af2134efb$var$FinancialDetails);


var $bf8a49925f64f472$export$2e2bcd8739ae039 = (0, $a3aec34af2134efb$export$2e2bcd8739ae039);


// Map Redux Props
const $1890b1337feb407a$var$mapStateToProps = (state)=>state;
const $1890b1337feb407a$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $1890b1337feb407a$var$DetailsSummary(props) {
    // Destructure
    const { actions: actions, riskData: // setFinancialData,
    riskData, setRiskData: setRiskData, transactionData: transactionData, setTransactionData: setTransactionData, isGetTransactionDetailsLoading: isGetTransactionDetailsLoading, transaction: transaction } = props;
    const { toggleTransactionReportModal: toggleTransactionReportModal, setTransactionReportDetails: setTransactionReportDetails, toggleDeleteTransactionModal: toggleDeleteTransactionModal, showAlert: showAlert, setTransactionRemove: setTransactionRemove, toggleInfoModal: toggleInfoModal, setInfoModalDetails: setInfoModalDetails, toggleTransactionDetailsModalOpen: toggleTransactionDetailsModalOpen, setTransactionModalDetails: setTransactionModalDetails } = actions;
    const { transactionChains: transactionChains } = transaction;
    // hooks
    const { createOrUpdateTransaction: createOrUpdateTransaction, createOrUpdateTransactionData: createOrUpdateTransactionData, createOrUpdateTransactionError: createOrUpdateTransactionError, isCreateOrUpdateTransactionLoading: isCreateOrUpdateTransactionLoading } = (0, $aefb40a6e68b4bb6$export$2e2bcd8739ae039)();
    const [userCredentials] = (0, $a9c50ebe96619b20$export$2e2bcd8739ae039)('userCredentials', {});
    // local state
    const [currentIpUsed, setCurrentIpUsed] = (0, $tZqWC.useState)();
    const [txDescription, setTxDescription] = (0, $tZqWC.useState)();
    const [availableIps, setAvailableIps] = (0, $tZqWC.useState)(null);
    // !THIS FUNCTION RELLIES ON FINANCIAL DATA
    const handleDeleteTransaction = ()=>{
        setTransactionRemove({
            transaction_id: transactionData.id
        });
        toggleDeleteTransactionModal(true);
    };
    const handleScan = (ip)=>{
        setCurrentIpUsed(ip);
        createOrUpdateTransaction({
            transaction: transactionData.hash,
            chain: transactionData.chain,
            name_first: userCredentials.name_first,
            name_last: userCredentials.name_last,
            integration_id: ip
        });
    };
    const handleCreateReport = ()=>{
        setTransactionReportDetails({
            transaction_id: transactionData.id,
            chain: transactionData.chain
        });
        toggleTransactionReportModal();
    };
    const handleCreateOrUpdateTransaction = ()=>{
        if (createOrUpdateTransactionData) {
            setRiskData((prevValue)=>{
                const newRiskData = [
                    ...prevValue
                ];
                let found = false;
                prevValue.forEach((item, i)=>{
                    if (item?.risk_integration_id === createOrUpdateTransactionData?.risk_data?.risk_integration_id) newRiskData[i] = createOrUpdateTransactionData.risk_data;
                    found = true;
                });
                if (found === false) newRiskData.push(createOrUpdateTransactionData.risk_data);
                return newRiskData;
            });
            setTransactionData({
                ...transactionData,
                risk_ratio: createOrUpdateTransactionData?.risk_data?.risk_ratio
            });
        }
    };
    const handleToggleInfo = (title, content)=>{
        setInfoModalDetails({
            title: title,
            content: content
        });
        toggleInfoModal(true);
    };
    const formatRiskDescriptor = (risk)=>{
        if (risk?.risk_descriptors?.split(',')?.length > 1) {
            const desc = /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9518101ed4013f4a$export$5f1af8db9871e1d6), {
                children: [
                    "On ",
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9518101ed4013f4a$export$6d028b688a5b0ff9), {
                        children: (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(transactionData?.created).format((0, $41a9e38e6be32f35$export$67a03cd247c60132))
                    }),
                    ", a(n)",
                    ' ',
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9518101ed4013f4a$export$6d028b688a5b0ff9), {
                        children: transactionData?.chain
                    }),
                    " transaction with the hash",
                    ' ',
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9518101ed4013f4a$export$6d028b688a5b0ff9), {
                        children: transactionData?.hash
                    }),
                    " was analysed. The transaction involves",
                    ' ',
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9518101ed4013f4a$export$6d028b688a5b0ff9), {
                        children: transactionData?.in_count
                    }),
                    " input(s) with a value of",
                    ' ',
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9518101ed4013f4a$export$6d028b688a5b0ff9), {
                        children: [
                            "USD $",
                            (0, $ecf1d77ac1b82678$export$a2db1876938cd11d)(Math.round(transactionData.in_usd * 100) / 100)
                        ]
                    }),
                    " and",
                    ' ',
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9518101ed4013f4a$export$6d028b688a5b0ff9), {
                        children: transactionData?.out_count
                    }),
                    " output(s) amounting",
                    ' ',
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9518101ed4013f4a$export$6d028b688a5b0ff9), {
                        children: [
                            "USD $",
                            (0, $ecf1d77ac1b82678$export$a2db1876938cd11d)(Math.round(transactionData.out_usd * 100) / 100)
                        ]
                    }),
                    " including digital assets such as ",
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9518101ed4013f4a$export$6d028b688a5b0ff9), {
                        children: transactionData?.symbol
                    }),
                    ". This transaction, carries an input risk score of ",
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9518101ed4013f4a$export$6d028b688a5b0ff9), {
                        children: [
                            risk?.in_risk_ratio,
                            "%"
                        ]
                    }),
                    ", while the output has a risk score of",
                    ' ',
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9518101ed4013f4a$export$6d028b688a5b0ff9), {
                        children: [
                            risk?.out_risk_ratio,
                            "%"
                        ]
                    }),
                    ", sourced from",
                    ' ',
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9518101ed4013f4a$export$6d028b688a5b0ff9), {
                        children: risk?.provider_name || 'a risk provider'
                    }),
                    ". Risk descriptor(s) linked to the transaction encompass ",
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9518101ed4013f4a$export$6d028b688a5b0ff9), {
                        children: risk.risk_descriptors?.split(',').join(', ')
                    }),
                    ", indicative of potential association with the transaction."
                ]
            });
            return desc;
        }
        if (risk?.risk_descriptors?.split(',')?.length < 2 || !risk?.risk_descriptors) {
            const desc = /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9518101ed4013f4a$export$5f1af8db9871e1d6), {
                children: [
                    "On ",
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9518101ed4013f4a$export$6d028b688a5b0ff9), {
                        children: (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(transactionData?.created).format((0, $41a9e38e6be32f35$export$67a03cd247c60132))
                    }),
                    ", a(n)",
                    ' ',
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9518101ed4013f4a$export$6d028b688a5b0ff9), {
                        children: transactionData?.chain
                    }),
                    " transaction with the hash",
                    ' ',
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9518101ed4013f4a$export$6d028b688a5b0ff9), {
                        children: transactionData?.hash
                    }),
                    " was analysed. The transaction involves",
                    ' ',
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9518101ed4013f4a$export$6d028b688a5b0ff9), {
                        children: transactionData?.in_count
                    }),
                    " input(s) with a value of",
                    ' ',
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9518101ed4013f4a$export$6d028b688a5b0ff9), {
                        children: [
                            "USD $",
                            (0, $ecf1d77ac1b82678$export$a2db1876938cd11d)(Math.round(transactionData.in_usd * 100) / 100)
                        ]
                    }),
                    " and",
                    ' ',
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9518101ed4013f4a$export$6d028b688a5b0ff9), {
                        children: transactionData?.out_count
                    }),
                    " output(s) amounting",
                    ' ',
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9518101ed4013f4a$export$6d028b688a5b0ff9), {
                        children: [
                            "USD $",
                            (0, $ecf1d77ac1b82678$export$a2db1876938cd11d)(Math.round(transactionData.out_usd * 100) / 100)
                        ]
                    }),
                    " including digital assets such as ",
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9518101ed4013f4a$export$6d028b688a5b0ff9), {
                        children: transactionData?.symbol
                    }),
                    ". This transaction, carries an input risk score of ",
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9518101ed4013f4a$export$6d028b688a5b0ff9), {
                        children: [
                            risk?.in_risk_ratio,
                            "%"
                        ]
                    }),
                    ", while the output has a risk score of",
                    ' ',
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9518101ed4013f4a$export$6d028b688a5b0ff9), {
                        children: [
                            risk?.out_risk_ratio,
                            "%"
                        ]
                    }),
                    ", sourced from",
                    ' ',
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9518101ed4013f4a$export$6d028b688a5b0ff9), {
                        children: risk?.provider_name || 'a risk provider'
                    }),
                    "."
                ]
            });
            return desc;
        }
    };
    const handleRiskClick = (index)=>{
        if (!Number.isNaN(index) && (transactionData?.in_count > 0 || transactionData?.out_count > 0)) {
            toggleTransactionDetailsModalOpen();
            setTransactionModalDetails({
                ...transactionData,
                riskData: riskData[index]
            });
        }
    };
    const handleAvailableIps = ()=>{
        if (availableIps) return;
        if (!transactionChains?.risk) return;
        let newAvailableIps = {};
        Object.keys(transactionChains?.risk).forEach((item)=>{
            const ip = transactionChains?.risk[item];
            Object.keys(ip).forEach((ipChain)=>{
                if (ip[ipChain]?.chain_name === transactionData?.chain) newAvailableIps = {
                    ...newAvailableIps,
                    [ip[ipChain]?.provider_code]: {
                        integration_id: ip[ipChain]?.integration_id,
                        provider_code: ip[ipChain]?.provider_code
                    }
                };
            });
        });
        setAvailableIps(newAvailableIps);
    };
    // UseEffects
    (0, $tZqWC.useEffect)(()=>{
        handleAvailableIps();
    }, []);
    (0, $tZqWC.useEffect)(()=>handleCreateOrUpdateTransaction(), [
        createOrUpdateTransactionData
    ]);
    (0, $tZqWC.useEffect)(()=>{
        // TODO ADD PROPER ERROR MSG SENT FROM SERVER
        if (createOrUpdateTransactionError) showAlert({
            type: 'error',
            message: 'An error occurred in scanning transaction'
        });
    }, [
        createOrUpdateTransactionError
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (!currentIpUsed && riskData?.length > 0) {
            if (riskData[0]?.risk_integration_id) setCurrentIpUsed(riskData[0].risk_integration_id);
            setTxDescription(formatRiskDescriptor(riskData[0]));
        } else if (currentIpUsed && riskData?.length > 0) riskData.forEach((v)=>{
            if (v?.risk_integration_id === currentIpUsed) setTxDescription(formatRiskDescriptor(v));
        });
    }, [
        riskData
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9518101ed4013f4a$export$f5ec1ee0b77895e7), {
        children: [
            isGetTransactionDetailsLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $647b8bc68ebce54f$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bf8a49925f64f472$export$2e2bcd8739ae039), {
                transactionData: transactionData,
                isGetTransactionDetailsLoading: isGetTransactionDetailsLoading,
                txDescription: txDescription
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d7262e42ecba02f5$export$2e2bcd8739ae039), {
                onClick: handleRiskClick,
                riskData: riskData,
                isGetTransactionDetailsLoading: isGetTransactionDetailsLoading,
                isCreateOrUpdateTransactionLoading: isCreateOrUpdateTransactionLoading,
                currentIpUsed: currentIpUsed
            }, riskData),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9518101ed4013f4a$export$bc7adc8ef74607f), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9518101ed4013f4a$export$a9754b3c8daa5172), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                            variant: "outlined",
                            size: "small",
                            onClick: handleCreateReport,
                            disabled: true,
                            children: "Create Report"
                        })
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9518101ed4013f4a$export$a9754b3c8daa5172), {
                        style: {
                            justifyContent: 'flex-end'
                        },
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                variant: "outlined",
                                size: "small",
                                endIcon: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b77b5de3fb591045$export$2e2bcd8739ae039), {
                                    size: 12
                                }),
                                onClick: handleDeleteTransaction,
                                children: "Remove"
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $ca6f920a36c82944$export$2e2bcd8739ae039), {
                                direction: "down",
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $478ff5739380e08c$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                            variant: "outlined",
                                            size: "small",
                                            endIcon: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6417d0fa9c066aa3$export$2e2bcd8739ae039), {
                                                size: 12
                                            }),
                                            children: "Add score"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7a68433660fee9cb$export$2e2bcd8739ae039), {
                                        left: true,
                                        style: {
                                            maxWidth: '155px',
                                            minWidth: '125px',
                                            padding: '0 12px'
                                        },
                                        children: Object.keys(transactionChains?.risk || {})?.length > 0 && Object.keys(transactionChains?.risk)?.map((key)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c7b007afae0a2778$export$2e2bcd8739ae039), {
                                                disabled: isCreateOrUpdateTransactionLoading || !transactionChains?.risk?.[key]?.[transactionData?.symbol],
                                                onClick: ()=>{
                                                    if (isCreateOrUpdateTransactionLoading || !transactionChains?.risk?.[key]?.[transactionData?.symbol]) return;
                                                    if (transactionChains?.risk?.[key]?.[transactionData?.symbol]) handleScan(transactionChains?.risk?.[key]?.[transactionData?.symbol]?.provider_id);
                                                    else handleToggleInfo('Authorization Needed', 'You currently do not have access to this feature.');
                                                },
                                                style: {
                                                    borderRadius: 0,
                                                    justifyContent: 'center',
                                                    padding: '9px'
                                                },
                                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9518101ed4013f4a$export$5f1af8db9871e1d6), {
                                                    children: key
                                                })
                                            }, key))
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
// Default Props
$1890b1337feb407a$var$DetailsSummary.defaultProps = {
    // setFinancialData: () => {},
    riskData: null,
    setRiskData: ()=>{},
    transactionData: null,
    setTransactionData: ()=>{},
    actions: {},
    filters: {},
    ui: {},
    isGetTransactionDetailsLoading: false
};
// Proptypes Validation
$1890b1337feb407a$var$DetailsSummary.propTypes = {
    // setFinancialData: PropTypes.func,
    transaction: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object),
    riskData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object),
    setRiskData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        accountDirectoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object)
    }),
    transactionData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        chain: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        symbol: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        risk_score: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        risk_ratio: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        in_usd: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        out_usd: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        fee_amount_usd: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        balance: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        last_modified: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        created: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        in_count: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        out_count: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        asset_count: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number
    }),
    setTransactionData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        toggleTransactionReportModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setTransactionReportDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAddressHistoryDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        toggleDeleteTransactionModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsLinkTransactionDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setTransactionLinkDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAddressHistoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setTransactionRemove: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        toggleInfoModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setInfoModalDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        toggleTransactionDetailsModalOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setTransactionModalDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    address_data: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        address: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        chain: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        symbol: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        risk_score: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        balance_usd: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        balance: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        modify_tz: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    }),
    isGetTransactionDetailsLoading: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    eventDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        inputs: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            events: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({})),
            page: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number
        }),
        outputs: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            events: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({})),
            page: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number
        })
    })
};
var $1890b1337feb407a$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($1890b1337feb407a$var$mapStateToProps, $1890b1337feb407a$var$mapDispatchToProps)($1890b1337feb407a$var$DetailsSummary);


var $54fcb56520d11f1d$export$2e2bcd8739ae039 = (0, $1890b1337feb407a$export$2e2bcd8739ae039);


/* eslint-disable react/forbid-prop-types */ 

var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");








// Map Redux Props
const $0f3480134d29701d$var$mapStateToProps = (state)=>state;
const $0f3480134d29701d$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $0f3480134d29701d$var$BusinessNotes(props) {
    // Destructure
    const { address_data: address_data, actions: actions, businessNotes: businessNotes, setBusinessNotes: setBusinessNotes, isLoading: isLoading, isFetchError: isFetchError } = props;
    const { toggleDeleteAddressNoteModal: toggleDeleteAddressNoteModal, showAlert: showAlert } = actions;
    // Local state
    const [isAddNoteActive, setIsAddNoteActive] = (0, $tZqWC.useState)(false);
    const [notesValue, setNotesValue] = (0, $tZqWC.useState)('');
    // Hooks
    const { createNote: createNote, createNoteData: createNoteData, createNoteError: createNoteError, isCreateNoteLoading: isCreateNoteLoading } = (0, $fc08522a804fd3d8$export$2e2bcd8739ae039)();
    const [credentials] = (0, $a9c50ebe96619b20$export$2e2bcd8739ae039)('userCredentials', {});
    function saveNote() {
        createNote({
            note: notesValue,
            module_id: (0, $f398806f8c37b1c3$export$ee40726984762919).address,
            record_id: address_data.id,
            business_id: credentials.business_id,
            created_by: `${credentials.name_first} ${credentials.name_last}`
        });
    }
    function handleSavedNote() {
        setNotesValue('');
        setIsAddNoteActive(false);
        setBusinessNotes((prevValue)=>// ! DATA IS HARDCODED
            [
                createNoteData,
                ...prevValue
            ]);
    }
    // UseEffects
    (0, $tZqWC.useEffect)(()=>createNoteData && handleSavedNote(), [
        createNoteData
    ]);
    (0, $tZqWC.useEffect)(()=>{
        // TODO ADD PROPER ERROR MSG SENT FROM SERVER
        if (isFetchError) showAlert({
            type: 'error',
            message: 'An error occurred in fetching notes'
        });
    }, [
        isFetchError
    ]);
    (0, $tZqWC.useEffect)(()=>{
        // TODO ADD PROPER ERROR MSG SENT FROM SERVER
        if (createNoteError) showAlert({
            type: 'error',
            message: 'An error occurred in creating note'
        });
    }, [
        createNoteError
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9518101ed4013f4a$export$f5ec1ee0b77895e7), {
        children: [
            (isLoading || isCreateNoteLoading) && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $647b8bc68ebce54f$export$2e2bcd8739ae039), {}),
            !isAddNoteActive && !isLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9518101ed4013f4a$export$bc7adc8ef74607f), {
                style: {
                    justifyContent: 'flex-end',
                    margin: '-50px 0 20px 0'
                },
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                    variant: "outlined",
                    size: "medium",
                    endIcon: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6417d0fa9c066aa3$export$2e2bcd8739ae039), {
                        size: 18
                    }),
                    onClick: ()=>setIsAddNoteActive(true),
                    children: "Add note"
                })
            }),
            isAddNoteActive && !isLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9518101ed4013f4a$export$bc7adc8ef74607f), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9518101ed4013f4a$export$87ad169bde460ddf), {
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9518101ed4013f4a$export$a4fff7f2f85c4c81), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d03facd9d698d253$export$2e2bcd8739ae039), {
                                style: {
                                    background: 'transparent',
                                    padding: '0',
                                    border: 'none'
                                },
                                value: notesValue,
                                onChange: (e)=>setNotesValue(e.currentTarget.value)
                            })
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9518101ed4013f4a$export$a9754b3c8daa5172), {
                            style: {
                                justifyContent: 'flex-end',
                                padding: '10px 0 20px 0'
                            },
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                    variant: "outlined",
                                    size: "medium",
                                    endIcon: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b77b5de3fb591045$export$2e2bcd8739ae039), {
                                        size: 18
                                    }),
                                    onClick: ()=>{
                                        setNotesValue('');
                                        setIsAddNoteActive(false);
                                    },
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                    variant: "outlined",
                                    size: "medium",
                                    endIcon: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6417d0fa9c066aa3$export$2e2bcd8739ae039), {
                                        size: 18
                                    }),
                                    onClick: ()=>saveNote(),
                                    children: "Save"
                                })
                            ]
                        })
                    ]
                })
            }),
            businessNotes[0] && !isLoading && businessNotes.map((data)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9518101ed4013f4a$export$bc7adc8ef74607f), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9518101ed4013f4a$export$a4fff7f2f85c4c81), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9518101ed4013f4a$export$a9754b3c8daa5172), {
                                style: {
                                    paddingBottom: '20px'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9518101ed4013f4a$export$8f314e512d92575f), {
                                        children: data.created_by && `${data.created_by[0]}${data.created_by[1]}`
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9518101ed4013f4a$export$d747b2abe71e53f5), {
                                        style: {
                                            width: 'auto',
                                            justifyContent: 'center'
                                        },
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9518101ed4013f4a$export$f99233281efd08a0), {
                                            style: {
                                                margin: '0'
                                            },
                                            children: data.created_by
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9518101ed4013f4a$export$a9754b3c8daa5172), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9518101ed4013f4a$export$5f1af8db9871e1d6), {
                                    children: data.note
                                })
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $ca6f920a36c82944$export$2e2bcd8739ae039), {
                                direction: "down",
                                style: {
                                    position: 'absolute',
                                    top: '20px',
                                    right: '20px'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $478ff5739380e08c$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                            variant: "outlined",
                                            size: "small",
                                            endIcon: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $35f1f2050cee5a12$export$2e2bcd8739ae039), {
                                                size: 18
                                            }),
                                            style: {
                                                padding: '5px',
                                                borderRadius: '4px'
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7a68433660fee9cb$export$2e2bcd8739ae039), {
                                        left: true,
                                        style: {
                                            boxShadow: ' 0px 0px 10px rgb(0 0 0 / 15%)'
                                        },
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c7b007afae0a2778$export$2e2bcd8739ae039), {
                                            onClick: toggleDeleteAddressNoteModal,
                                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9518101ed4013f4a$export$5f1af8db9871e1d6), {
                                                children: "Delete Note"
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }, data.id))
        ]
    });
}
// Default Props
$0f3480134d29701d$var$BusinessNotes.defaultProps = {
    actions: {},
    address_data: {}
};
// Proptypes Validation
$0f3480134d29701d$var$BusinessNotes.propTypes = {
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        toggleDeleteAddressNoteModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    address_data: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        address: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        chain: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        symbol: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        risk_score: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        balance_usd: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        balance: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        modify_tz: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        create_tz: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    }),
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    isFetchError: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    businessNotes: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).arrayOf({}),
    setBusinessNotes: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
};
var $0f3480134d29701d$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($0f3480134d29701d$var$mapStateToProps, $0f3480134d29701d$var$mapDispatchToProps)($0f3480134d29701d$var$BusinessNotes);


var $6a18a00ca086a8ed$export$2e2bcd8739ae039 = (0, $0f3480134d29701d$export$2e2bcd8739ae039);




// Map Redux Props
const $3f4baec3b45ca6ca$var$mapStateToProps = (state)=>state;
const $3f4baec3b45ca6ca$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $3f4baec3b45ca6ca$var$TransactionsTableItemDetails(props) {
    // Destructure
    const { actions: actions, isExpanded: isExpanded, eventDetails: eventDetails, setEventDetails: setEventDetails, riskData: riskData, setRiskData: setRiskData, transactionData: transactionData, setTransactionData: setTransactionData, senderAccountData: senderAccountData, recipientAccountData: // setSenderAccountData,
    recipientAccountData } = props;
    const { showAlert: showAlert } = actions;
    // Hooks
    const { getTransactionDetails: getTransactionDetails, getTransactionDetailsData: getTransactionDetailsData, getTransactionDetailsError: getTransactionDetailsError, isGetTransactionDetailsLoading: isGetTransactionDetailsLoading } = (0, $d2d7bca3caa22367$export$2e2bcd8739ae039)();
    // Local state
    // const [page, setPage] = useState(0)
    // Functions
    // UseEffect
    (0, $tZqWC.useEffect)(()=>{
        if (isExpanded && !riskData) getTransactionDetails({
            transaction_id: transactionData.id
        });
    }, [
        isExpanded
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (getTransactionDetailsData) {
            setRiskData(getTransactionDetailsData.risk_data);
            setTransactionData({
                ...transactionData,
                ...getTransactionDetailsData,
                risk_data: null
            });
        }
    }, [
        getTransactionDetailsData
    ]);
    (0, $tZqWC.useEffect)(()=>{
        // TODO ADD PROPER ERROR MSG SENT FROM SERVER
        if (getTransactionDetailsError) showAlert({
            type: 'error',
            message: 'An error occurred in fetching transactions'
        });
    }, [
        getTransactionDetailsError
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9518101ed4013f4a$export$e6dfd72ab29f8598), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9518101ed4013f4a$export$42a852a2b6b56249), {
            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $54fcb56520d11f1d$export$2e2bcd8739ae039), {
                riskData: riskData,
                setRiskData: setRiskData,
                transactionData: transactionData,
                setTransactionData: setTransactionData,
                senderAccountData: senderAccountData,
                recipientAccountData: recipientAccountData,
                isGetTransactionDetailsLoading: isGetTransactionDetailsLoading,
                isExpanded: isExpanded,
                eventDetails: eventDetails,
                setEventDetails: setEventDetails
            })
        })
    });
}
// Default Props
$3f4baec3b45ca6ca$var$TransactionsTableItemDetails.defaultProps = {
    riskData: null,
    setRiskData: ()=>{},
    transactionData: null,
    setTransactionData: ()=>{},
    actions: {},
    filters: {},
    ui: {},
    isExpanded: false
};
// Proptypes Validation
$3f4baec3b45ca6ca$var$TransactionsTableItemDetails.propTypes = {
    eventDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        inputs: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            events: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({})),
            page: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number
        }),
        outputs: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            events: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({})),
            page: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number
        })
    }),
    setEventDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    riskData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object),
    setRiskData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    transactionData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        address: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        chain: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        symbol: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        risk_score: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        risk_ratio: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        input_usd: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        output_usd: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        fee_amount_usd: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        balance: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        modify_tz: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        create_tz: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        sender_link_type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        sender_link_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        recipient_link_type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        recipient_link_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setTransactionEventsFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    senderAccountData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({}),
    recipientAccountData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({}),
    // businessNotes: PropTypes.arrayOf({}),
    // setBusinessNotes: PropTypes.func,
    setTransactionData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        transactionEventsFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object)
    }),
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    isExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
};
var $3f4baec3b45ca6ca$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($3f4baec3b45ca6ca$var$mapStateToProps, $3f4baec3b45ca6ca$var$mapDispatchToProps)($3f4baec3b45ca6ca$var$TransactionsTableItemDetails);


var $7279ed16566b6758$export$2e2bcd8739ae039 = (0, $3f4baec3b45ca6ca$export$2e2bcd8739ae039);


// Map Redux Props
const $7257ea2e0d4856fd$var$mapStateToProps = (state)=>state;
const $7257ea2e0d4856fd$var$mapDispatchToProps = (dispatch)=>(0, $2154a4c08d887b32$export$e324594224ef24da)(dispatch);
function $7257ea2e0d4856fd$var$TransactionsTableItem(props) {
    // Destructure
    const { data: data, transaction: transaction, actions: actions, openedTab: openedTab, setOpenedTab: setOpenedTab } = props;
    const { transactionLinkData: transactionLinkData, transactionLinkDetails: transactionLinkDetails, scannedTransactionDetails: scannedTransactionDetails } = transaction;
    const { setTransactionLinkData: setTransactionLinkData, setTransactionFilters: setTransactionFilters, setTransactionLinkDetails: setTransactionLinkDetails, setScannedTransactionDetails: setScannedTransactionDetails, setIsPageTableUpdated: setIsPageTableUpdated } = actions;
    // States
    const [barWidth, setBarWidth] = (0, $tZqWC.useState)('0%');
    const [isExpanded, setIsExpanded] = (0, $tZqWC.useState)(false);
    const [chainIcon, setChainIcon] = (0, $tZqWC.useState)();
    // Component States
    const [transactionData, setTransactionData] = (0, $tZqWC.useState)({
        ...data
    });
    const { chain_name: chain_name, in_usd: in_usd, last_modified: last_modified, risk_ratio: risk_ratio } = transactionData;
    const [eventDetails, setEventDetails] = (0, $tZqWC.useState)({
        inputs: {
            events: [],
            page: 1
        },
        outputs: {
            events: [],
            page: 1
        }
    });
    const [riskData, setRiskData] = (0, $tZqWC.useState)();
    const [senderAccountData, setSenderAccountData] = (0, $tZqWC.useState)();
    const [recipientAccountData, setRecipientAccountData] = (0, $tZqWC.useState)();
    const [businessNotes, setBusinessNotes] = (0, $tZqWC.useState)();
    const [copyNotification, setCopyNotification] = (0, $tZqWC.useState)('');
    // Functions
    function formatValue(number) {
        if (number < 1000000) return (0, $ecf1d77ac1b82678$export$a2db1876938cd11d)(Math.round(number * 100) / 100);
        return (0, $ecf1d77ac1b82678$export$866ef2858852149a).format(number);
    }
    const copyHash = ()=>{
        navigator.clipboard.writeText(transactionData.hash).then(()=>setCopyNotification('Copied!'), ()=>setCopyNotification('Error: Could not copy'));
        setTimeout(()=>setCopyNotification(''), 700);
    };
    function handleScannedTransaction() {
        setRiskData((prevValue)=>{
            const newRiskData = [
                scannedTransactionDetails.risk_data
            ];
            if (prevValue) prevValue.forEach((item)=>{
                if (item?.provider_name !== scannedTransactionDetails?.risk_data?.provider_name) newRiskData.push(item);
            });
            return newRiskData;
        });
        setEventDetails(formatTransactionEvents(scannedTransactionDetails));
        setOpenedTab(scannedTransactionDetails.hash);
        setScannedTransactionDetails(null);
    }
    const formatTransactionEvents = (value)=>{
        if (!value?.financial_data?.events) return {
            input: [],
            output: [],
            page: 0,
            size: 0,
            total: 0
        };
        const events = [
            ...value.financial_data.events
        ];
        const newEvents = {
            inputs: {
                events: [],
                page: 1
            },
            outputs: {
                events: [],
                page: 1
            }
        };
        events.forEach((item)=>{
            if (item?.type !== 'fee' && item?.source) newEvents.inputs.events.push(item);
            if (item?.type !== 'fee' && item?.destination) newEvents.outputs.events.push(item);
        });
        return newEvents;
    };
    // UseEffects
    (0, $tZqWC.useEffect)(()=>{
        if (chain_name) setChainIcon((0, $df4784c9100a83b7$export$c25425c0b9a3de13)[chain_name?.toLowerCase()]);
        if (risk_ratio) setBarWidth(`${risk_ratio}%`);
    }, [
        risk_ratio
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (transactionLinkData) {
            if (transactionLinkDetails.transaction_id === transactionData.id) {
                if (transactionLinkData?.sender) setSenderAccountData(transactionLinkData?.sender);
                if (transactionLinkData?.recipient) setRecipientAccountData(transactionLinkData?.recipient);
                setTransactionLinkData();
                setTransactionLinkDetails();
            }
        }
    }, [
        transactionLinkData
    ]);
    (0, $tZqWC.useEffect)(()=>scannedTransactionDetails && scannedTransactionDetails?.hash === data.hash && handleScannedTransaction(), [
        scannedTransactionDetails
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (!isExpanded && !transactionData.id && !scannedTransactionDetails) {
            setTransactionFilters();
            setIsPageTableUpdated(true);
            setOpenedTab();
        }
    }, [
        isExpanded
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (openedTab !== data.id) setIsExpanded(false);
        if (openedTab === data.id) setIsExpanded(true);
    }, [
        openedTab
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b3f7dc6528742bb0$export$2e2bcd8739ae039), {
        setIsExpanded: (val)=>{
            setIsExpanded(val);
            setOpenedTab(data.id);
        },
        expandPanel: isExpanded,
        button: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $bc38f7c8ae5583a7$export$fd2299f554be8993), {
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $bc38f7c8ae5583a7$export$9f515a68dfaeb9ef), {
                    isExpanded: isExpanded,
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $bc38f7c8ae5583a7$export$987cac99e7a31168), {
                            children: [
                                chainIcon && /*#__PURE__*/ (0, $tZqWC.cloneElement)(chainIcon),
                                isExpanded ? /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $bc38f7c8ae5583a7$export$edc246bee1ec68d2), {
                                    className: "hashWrapper",
                                    onClick: copyHash,
                                    children: [
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc38f7c8ae5583a7$export$829b0583f0fe5152), {
                                            className: "hashWrapper",
                                            children: transactionData.hash
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c43eb4ee7dedc1da$export$2e2bcd8739ae039), {
                                            size: 18,
                                            className: "hashWrapper"
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc38f7c8ae5583a7$export$b30c94aee60c7d6b), {
                                            display: copyNotification,
                                            children: copyNotification
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a6f961941b47e982$export$2e2bcd8739ae039), {
                                    text: transactionData.hash,
                                    sliceLength: 7
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc38f7c8ae5583a7$export$987cac99e7a31168), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc38f7c8ae5583a7$export$49316f37c3b5fade), {
                                children: (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(last_modified).format((0, $41a9e38e6be32f35$export$859ef203c4495ed2))
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $bc38f7c8ae5583a7$export$9f515a68dfaeb9ef), {
                    isExpanded: isExpanded,
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $bc38f7c8ae5583a7$export$987cac99e7a31168), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc38f7c8ae5583a7$export$49316f37c3b5fade), {
                                    children: risk_ratio && `${risk_ratio}%`
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f598a52270fcc8c$export$2e2bcd8739ae039), {
                                    width: barWidth
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc38f7c8ae5583a7$export$987cac99e7a31168), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $bc38f7c8ae5583a7$export$6f4a084cc8e379b6), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc38f7c8ae5583a7$export$49316f37c3b5fade), {
                                        style: {
                                            textTransform: 'uppercase'
                                        },
                                        children: !!chain_name && chain_name
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $bc38f7c8ae5583a7$export$65b9fe47bb7b64b0), {
                                        children: [
                                            in_usd ? `USD $${formatValue(in_usd)}` : 'USD -',
                                            " "
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        }),
        panel: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc38f7c8ae5583a7$export$85524e8d4e82fc69), {
            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7279ed16566b6758$export$2e2bcd8739ae039), {
                isExpanded: isExpanded,
                // Details state
                eventDetails: eventDetails,
                setEventDetails: setEventDetails,
                riskData: riskData,
                setRiskData: setRiskData,
                transactionData: transactionData,
                setTransactionData: setTransactionData,
                senderAccountData: senderAccountData,
                setSenderAccountData: setSenderAccountData,
                recipientAccountData: recipientAccountData,
                setRecipientAccountData: setRecipientAccountData,
                businessNotes: businessNotes,
                setBusinessNotes: setBusinessNotes
            })
        })
    });
}
// Default Props
$7257ea2e0d4856fd$var$TransactionsTableItem.defaultProps = {
    transaction: {},
    actions: {},
    data: {
        id: '',
        hash: '',
        chain_name: '',
        symbol: '',
        risk_score: 0,
        in_usd: 0,
        last_modified: '',
        link_type: 1,
        link_id: ''
    }
};
// Proptypes Validation
$7257ea2e0d4856fd$var$TransactionsTableItem.propTypes = {
    openedTab: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    setOpenedTab: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    transaction: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        transactionLinkDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            transaction_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
        }),
        transactionLinkData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            sender: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({}),
            recipient: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({})
        }),
        scannedTransactionDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object)
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setTransactionLinkData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setTransactionLinkDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setTransactionFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setTransactionDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setScannedTransactionDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    data: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        chain_name: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        symbol: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        risk_score: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        risk_ratio: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        out_usd: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        in_usd: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        fee_amount_usd: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        last_modified: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        sender_link_type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        sender_link_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        recipient_link_type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        recipient_link_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    })
};
var $7257ea2e0d4856fd$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($7257ea2e0d4856fd$var$mapStateToProps, $7257ea2e0d4856fd$var$mapDispatchToProps)($7257ea2e0d4856fd$var$TransactionsTableItem);


var $1346713816b99a5e$export$2e2bcd8739ae039 = (0, $7257ea2e0d4856fd$export$2e2bcd8739ae039);


/* eslint-disable react/no-unstable-nested-components */ 
parcelRequire("tZqWC");



const $2582299387787f82$export$fd2299f554be8993 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: 1fr 1.8fr;
  gap: 50px;
  align-items: center;

  padding: 10px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $2582299387787f82$export$9f515a68dfaeb9ef = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  gap: 20px;

  &:last-child > div:last-child {
    max-width: 150px;
  }
  &:last-child > div:first-child {
    justify-content: flex-end;
    max-width: 535px;
  }

  &:first-child > div:last-child {
    justify-content: flex-end;
    visibility: ${({ isExpanded: isExpanded })=>isExpanded && 'hidden'};
  }
  &:last-child > div:first-child {
    visibility: ${({ isExpanded: isExpanded })=>isExpanded && 'hidden'};
  }
`;
const $2582299387787f82$export$987cac99e7a31168 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  width: 100%;

  gap: 20px;
`;
const $2582299387787f82$export$6f4a084cc8e379b6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
`;
const $2582299387787f82$export$49316f37c3b5fade = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 15px;
  font-weight: 400;

  max-width: 250px;

  &:first-child {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  &.address_item_amount {
    max-width: 100px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
`;
const $2582299387787f82$export$7c901fb2027bd1cd = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background: ${({ theme: theme })=>theme.colors.backgroundLite};
`;



// Map Redux Props
const $a1775c83fdf12891$var$mapStateToProps = (state)=>state;
const $a1775c83fdf12891$var$mapDispatchToProps = (dispatch)=>(0, $2154a4c08d887b32$export$e324594224ef24da)(dispatch);
function $a1775c83fdf12891$var$TransactionsTableItemLoading() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b3f7dc6528742bb0$export$2e2bcd8739ae039), {
        setIsExpanded: ()=>{},
        expandPanel: false,
        button: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $2582299387787f82$export$fd2299f554be8993), {
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $2582299387787f82$export$9f515a68dfaeb9ef), {
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $2582299387787f82$export$987cac99e7a31168), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2582299387787f82$export$7c901fb2027bd1cd), {}),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5facfc7bc5a170d3$export$2e2bcd8739ae039), {
                                    height: 18,
                                    width: 150
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2582299387787f82$export$987cac99e7a31168), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5facfc7bc5a170d3$export$2e2bcd8739ae039), {
                                height: 18,
                                width: 120
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $2582299387787f82$export$9f515a68dfaeb9ef), {
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $2582299387787f82$export$987cac99e7a31168), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5facfc7bc5a170d3$export$2e2bcd8739ae039), {
                                    height: 18,
                                    width: 50
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f598a52270fcc8c$export$2e2bcd8739ae039), {
                                    width: 0
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2582299387787f82$export$987cac99e7a31168), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $2582299387787f82$export$6f4a084cc8e379b6), {
                                style: {
                                    gap: '5px'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5facfc7bc5a170d3$export$2e2bcd8739ae039), {
                                        height: 17,
                                        width: 50
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5facfc7bc5a170d3$export$2e2bcd8739ae039), {
                                        height: 12,
                                        width: 30
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        }),
        panel: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("div", {})
    });
}
// Default Props
$a1775c83fdf12891$var$TransactionsTableItemLoading.defaultProps = {};
// Proptypes Validation
$a1775c83fdf12891$var$TransactionsTableItemLoading.propTypes = {};
var $a1775c83fdf12891$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($a1775c83fdf12891$var$mapStateToProps, $a1775c83fdf12891$var$mapDispatchToProps)($a1775c83fdf12891$var$TransactionsTableItemLoading);


var $5a6a7c76fb5d55f2$export$2e2bcd8739ae039 = (0, $a1775c83fdf12891$export$2e2bcd8739ae039);


// Map Redux Props
const $f91790e47c58437f$var$mapStateToProps = (state)=>state;
const $f91790e47c58437f$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $f91790e47c58437f$var$TransactionsTable(props) {
    // Destructure
    const { filters: filters, ui: ui, actions: actions, transaction: transaction } = props;
    // Store States
    const { transactionFilters: transactionFilters } = filters;
    const { scannedTransaction: scannedTransaction, transactionChains: transactionChains } = transaction;
    const { isPageTableUpdated: isPageTableUpdated } = ui;
    const { setIsPageTableUpdated: setIsPageTableUpdated, setTransactionFilters: setTransactionFilters, showAlert: showAlert, setScannedTransaction: setScannedTransaction, setScannedTransactionDetails: setScannedTransactionDetails, setTransactionChains: setTransactionChains, setDefaultTransactionProvider: setDefaultTransactionProvider } = actions;
    // Hooks
    const { getTransactions: getTransactions, getTransactionsData: getTransactionsData, getTransactionsError: getTransactionsError, isGetTransactionsLoading: isGetTransactionsLoading } = (0, $a3ec4001c3088a08$export$2e2bcd8739ae039)();
    const { getTransactionChains: getTransactionChains, getTransactionChainsData: getTransactionChainsData } = (0, $df6fa9f2dd2e4bb8$export$2e2bcd8739ae039)();
    // Local states
    const [transactions, setTransactions] = (0, $tZqWC.useState)([]);
    const [pagination, setPagination] = (0, $tZqWC.useState)();
    const [openedTab, setOpenedTab] = (0, $tZqWC.useState)();
    // Functions
    function handleScannedAddress() {
        const newTransaction = {
            ...scannedTransaction,
            ...scannedTransaction.risk_data,
            ...scannedTransaction.financial_data,
            events: null,
            risk_partner_desc: null,
            risk_score_desc: null
        };
        const newTransactionList = [
            newTransaction
        ];
        transactions.forEach((item)=>{
            if (item.hash !== scannedTransaction.hash) newTransactionList.push(item);
        });
        // Changing it back to null
        setScannedTransaction(null);
        setTransactions(newTransactionList);
        setScannedTransactionDetails(scannedTransaction);
    }
    function handleTransactionChains() {
        if (!getTransactionChainsData) return;
        // !Idk why but this is causing some bugs but we need this to optimize the process
        // if (transactionChains && defaultTransactionProvider) return
        const newTransactionChains = {};
        const newDefaultTransactionProvider = {};
        getTransactionChainsData.forEach((item)=>{
            // Destructure with default values
            const { data_type: data_type = '', provider_code: provider_code = '', symbol: symbol = '', is_user_default: is_user_default = false, integration_id: integration_id = '' } = item || {};
            // Initialize the data_type and provider_code if they don't exist
            if (!newTransactionChains[data_type]) newTransactionChains[data_type] = {};
            if (!newTransactionChains[data_type][provider_code]) newTransactionChains[data_type][provider_code] = {};
            // Insert the item directly
            newTransactionChains[data_type][provider_code][symbol] = item;
            // Handle the default address provider
            if (is_user_default && !newDefaultTransactionProvider[data_type]) newDefaultTransactionProvider[data_type] = {
                provider_code: provider_code,
                integration_id: integration_id,
                data_type: data_type
            };
        });
        // Sorting by symbol using .sort()
        Object.keys(newTransactionChains).forEach((data_type)=>{
            Object.keys(newTransactionChains[data_type]).forEach((provider_code)=>{
                // Get the symbols and sort them
                const symbols = Object.keys(newTransactionChains[data_type][provider_code]);
                const sortedSymbols = symbols.sort() // Sort the symbols
                ;
                // Create a new object to store sorted entries
                const sortedPartner = {};
                sortedSymbols.forEach((symbol)=>{
                    sortedPartner[symbol] = newTransactionChains[data_type][provider_code][symbol];
                });
                // Replace the unsorted partner object with the sorted one
                newTransactionChains[data_type][provider_code] = sortedPartner;
            });
        });
        setTransactionChains(newTransactionChains);
        setDefaultTransactionProvider(newDefaultTransactionProvider);
    }
    function fetchTransactions() {
        getTransactions(transactionFilters);
    }
    // UseEffects
    (0, $tZqWC.useEffect)(()=>{
        if (!transactionChains || Object.keys(transactionChains || {})?.length < 1) getTransactionChains();
    }, []);
    (0, $tZqWC.useEffect)(()=>handleTransactionChains(), [
        getTransactionChainsData
    ]);
    (0, $tZqWC.useEffect)(()=>fetchTransactions(), [
        transactionFilters
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (isPageTableUpdated) {
            fetchTransactions();
            setIsPageTableUpdated(false);
        }
    }, [
        isPageTableUpdated
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (getTransactionsData) {
            setTransactions(getTransactionsData.items);
            setPagination(getTransactionsData.pagination);
        }
    }, [
        getTransactionsData
    ]);
    (0, $tZqWC.useEffect)(()=>{
        // TODO ADD PROPER ERROR MSG SENT FROM SERVER
        if (getTransactionsError) showAlert({
            type: 'error',
            message: 'An error occurred in fetching transactions'
        });
    }, [
        getTransactionsError
    ]);
    (0, $tZqWC.useEffect)(()=>{
        // TODO ADD PROPER ERROR MSG SENT FROM SERVER
        if (scannedTransaction) handleScannedAddress();
    }, [
        scannedTransaction
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $8e657a986efe297e$export$4267411171632d35), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $d2b0b55dc8f66a40$export$2e2bcd8739ae039), {
            totalItems: pagination?.total && pagination.total,
            minWidth: 900,
            filterComponents: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9748c87c1e73ab49$export$2e2bcd8739ae039), {}),
            tableFilters: transactionFilters,
            setTableFilters: setTransactionFilters,
            children: [
                isGetTransactionsLoading && Array.from({
                    length: transactionFilters?.size || 10
                }).map((_, index)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5a6a7c76fb5d55f2$export$2e2bcd8739ae039), {}, index)),
                transactions.length > 0 && !isGetTransactionsLoading && transactions.map((data, index)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1346713816b99a5e$export$2e2bcd8739ae039), {
                        openedTab: openedTab,
                        setOpenedTab: setOpenedTab,
                        data: data
                    }, data?.hash || data?.id || `transaction-${index}`)),
                transactions.length < 1 && !isGetTransactionsLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a6ea3b0f3caed586$export$2e2bcd8739ae039), {
                    setFilter: setTransactionFilters
                })
            ]
        })
    });
}
// Default Props
$f91790e47c58437f$var$TransactionsTable.defaultProps = {
    actions: {},
    filters: {},
    ui: {}
};
// Proptypes Validation
$f91790e47c58437f$var$TransactionsTable.propTypes = {
    transaction: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        scannedTransaction: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object),
        transactionChains: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({}),
        defaultTransactionProvider: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({})
    }),
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        transactionFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object)
    }),
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setToBeUpdatedAccount: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAccountDirectoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsIndividualAccountDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsEntityAccountDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setTransactionFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setScannedTransaction: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setScannedTransactionDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setTransactionChains: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setDefaultTransactionProvider: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $f91790e47c58437f$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($f91790e47c58437f$var$mapStateToProps, $f91790e47c58437f$var$mapDispatchToProps)($f91790e47c58437f$var$TransactionsTable);


var $d57ee0a18b1e1a5c$export$2e2bcd8739ae039 = (0, $f91790e47c58437f$export$2e2bcd8739ae039);





/* eslint-disable react/prop-types */ 

var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");






const $a804046d7d77c8bb$export$e6dfd72ab29f8598 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $a804046d7d77c8bb$export$97ddd2af6308ba2 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  z-index: 6;
  position: fixed;
  top: 0;
  left: 0;
  height: 0;
  width: 100vw;

  display: flex;
  justify-content: center;
  align-items: flex-start;
  color: ${({ theme: theme })=>theme.colors.primary};
  // Themed Properties
`;
const $a804046d7d77c8bb$export$b1d97b9d6e698468 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding-top: 20px;
  z-index: 7;
  position: relative;
  width: 100%;
  max-width: 700px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme: theme })=>theme.colors.primary};
  // Themed Properties
`;
const $a804046d7d77c8bb$export$9fc98b514229b55b = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  z-index: ${({ isActive: isActive })=>isActive ? 7 : 0};
  width: 100%;
  display: grid;
  grid-template-columns: 30px 1fr 5px;
  justify-content: center;
  align-items: center;
  background: ${({ theme: theme, isActive: isActive })=>isActive ? theme.colors.backgroundLite : theme.colors.background};
  border-radius: 10px;
  padding: 5px 20px 5px 20px;

  transition: 0.3s;
  border: 1px solid ${({ theme: theme })=>`${theme.colors.backgroundLite}`};
  &:hover {
    border: 1px solid ${({ theme: theme })=>`${theme.colors.brand}40`};
  }
  & input {
    background: ${({ theme: theme, isActive: isActive })=>isActive ? theme.colors.backgroundLite : theme.colors.background};
    border: none;
    padding: 15px 20px 15px 15px;
  }
  & svg {
    stroke: ${({ theme: theme })=>theme.colors.primary};
  }
  & svg > path {
    stroke: ${({ theme: theme })=>theme.colors.primary};
  }

  & #transactionSearchOptionsProvider {
    & > div > div:nth-child(3) {
      min-width: 160px;
      border-radius: 10px;
      & > div > div {
        padding: 8px 12px;
      }
    }
  }
  & #transactionSearchOptionsChain {
    & > div > div:nth-child(3) {
      min-width: 160px;
      border-radius: 10px;
      & > div > div {
        padding: 8px 12px;
        & svg {
          min-width: 25px;
          stroke: transparent;
          & path {
            stroke: ${({ theme: theme })=>theme.colors.brand};
          }
        }
      }
    }
  }
`;
const $a804046d7d77c8bb$export$a694082daf370b76 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-end;
`;
const $a804046d7d77c8bb$export$698223c589197ab7 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background: ${({ theme: theme })=>`${theme.colors.background}`};
  transition: 0.3s;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 20px;
`;
const $a804046d7d77c8bb$export$94756becb802e330 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: absolute;
  top: 39px;
  right: -60px;
  cursor: pointer;
  & svg {
    fill: ${({ theme: theme })=>theme.colors.primary};
  }
  & svg > path {
    fill: ${({ theme: theme })=>theme.colors.primary};
  }
`;
const $a804046d7d77c8bb$export$550fc938a73ef6b7 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  z-index: ${({ isActive: isActive })=>isActive ? 6 : 0};
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  margin-top: -10px;
  display: flex;
  flex-direction: column;
  gap: 5px;

  background-color: ${({ theme: theme })=>theme.colors.background};
  padding: 20px 10px;
  border-radius: 0 0 10px 10px;
  box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.07);
  max-height: 400px;
  overflow-y: auto;
`;
const $a804046d7d77c8bb$export$4b7e9f77c6f037f1 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  cursor: pointer;
  font-weight: 400;
  padding: 5px 10px;
  border-radius: 7px;

  &:hover {
    background-color: ${({ theme: theme, disabled: disabled })=>!disabled && theme.colors.backgroundLite};
  }
  border: ${({ theme: theme, active: active })=>active && `1px solid ${theme.colors.brand}`};
  border-radius: 8px;
`;
const $a804046d7d77c8bb$export$f99233281efd08a0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h2`
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  /* margin: 15px 0 0 15px; */
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $a804046d7d77c8bb$export$67706c264edf13ca = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px 20px;
`;
const $a804046d7d77c8bb$export$b5fbeb65832ce537 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  /* display: flex;
  max-width: 100%;
  overflow-x: auto; */
  padding: 10px 0;
  gap: 5px;

  & button {
    white-space: nowrap;
    word-break: keep-all;
    overflow-wrap: normal;
    text-transform: capitalize;
    font-size: 14px !important;
    padding: 5px 15px;
    width: 100%;
  }
`;




// Map Redux Props
const $182253dde64dd2c0$var$mapStateToProps = (state)=>state;
const $182253dde64dd2c0$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $182253dde64dd2c0$var$TransactionsSearchBar(props) {
    // props
    const { actions: actions, transaction: transaction } = props;
    // destructure
    const { showAlert: showAlert, setScannedTransaction: setScannedTransaction, toggleInfoModal: toggleInfoModal, setInfoModalDetails: setInfoModalDetails } = actions;
    const { transactionChains: transactionChains } = transaction;
    // local states
    const [isActive, setIsActive] = (0, $tZqWC.useState)(false);
    const [transactionInput, setTransactionInput] = (0, $tZqWC.useState)('');
    const [chain, setChain] = (0, $tZqWC.useState)('');
    const [chainSymbol, setChainSymbol] = (0, $tZqWC.useState)('');
    const [selectedProvider, setSelectedProvider] = (0, $tZqWC.useState)();
    const [availableChains, setAvailableChains] = (0, $tZqWC.useState)();
    const [allChains, setAllChains] = (0, $tZqWC.useState)();
    // const [defaultProvider, setDefaultProvider] = useState()
    // const [matchedChains, setMatchedChains] = useState([])
    // const [otherChains, setOtherChains] = useState([])
    // hooks
    const { createOrUpdateTransaction: createOrUpdateTransaction, createOrUpdateTransactionData: createOrUpdateTransactionData, createOrUpdateTransactionError: createOrUpdateTransactionError, isCreateOrUpdateTransactionLoading: isCreateOrUpdateTransactionLoading } = (0, $aefb40a6e68b4bb6$export$2e2bcd8739ae039)();
    // const {
    //   getTransactionChainRecommendation,
    //   getTransactionChainRecommendationData,
    //   // getTransactionChainRecommendationError,
    //   // isGetTransactionChainRecommendationLoading,
    // } = useGetTransactionChainRecommendation()
    const [userCredentials] = (0, $a9c50ebe96619b20$export$2e2bcd8739ae039)('userCredentials', {});
    // Functions
    function handleSubmit() {
        const firstChild = Object.keys(availableChains?.[selectedProvider])[0];
        const firstChain = availableChains?.[selectedProvider]?.[firstChild];
        const provider_id = firstChain?.provider_id;
        createOrUpdateTransaction({
            transaction: transactionInput,
            chain: chain,
            name_first: userCredentials.name_first,
            name_last: userCredentials.name_last,
            provider_id: provider_id
        });
        setTransactionInput('');
        setChain('');
        setChainSymbol();
        setSelectedProvider();
    }
    // function handleChainRecommendation(data) {
    //   const currentMatchedChains = []
    //   if (data?.length > 0) {
    //     data.map((item) => {
    //       currentMatchedChains.push({ disabled: false, value: item, label: item })
    //     })
    //   }
    //   if (currentMatchedChains.length === 1) {
    //     if (currentMatchedChains[0]?.value === 'near') {
    //       return setMatchedChains([])
    //     }
    //   }
    //   if (currentMatchedChains.length < 1) return setMatchedChains([])
    //   if (currentMatchedChains.length > 1) return setMatchedChains(currentMatchedChains)
    // }
    function handleTransactionChange(inputValue) {
        setTransactionInput(inputValue);
    // getTransactionChainRecommendation({ transaction: inputValue, chain })
    // handleChainMatch(inputValue)
    }
    function handleAvailableChains() {
        const providers = {
            FDBDM: {
                ...transactionChains?.financial?.FDBDM
            },
            ...transactionChains?.risk
        };
        const allChains = {};
        let literallyAllChains = {};
        Object.keys(providers).forEach((providerCode)=>{
            Object.keys(providers[providerCode]).forEach((chainCode)=>{
                if (providers?.FDBDM?.[chainCode] && providerCode !== 'FDBDM') {
                    allChains[providerCode] = {
                        ...allChains[providerCode],
                        [chainCode]: providers[providerCode][chainCode]
                    };
                    literallyAllChains = {
                        ...literallyAllChains,
                        [chainCode]: providers[providerCode][chainCode]
                    };
                }
            });
        });
        setAvailableChains(allChains);
        setAllChains(literallyAllChains);
    }
    // useEffect(() => {
    //   if (getTransactionChainRecommendationData) handleChainRecommendation(getTransactionChainRecommendationData)
    // }, [getTransactionChainRecommendationData])
    // useEffect(() => chain && handleSubmit(), [chain])
    (0, $tZqWC.useEffect)(()=>{
        handleAvailableChains();
    }, [
        transactionChains
    ]);
    // useEffect(() => {
    //   if (defaultTransactionProvider) {
    //     setDefaultProvider(defaultTransactionProvider?.risk)
    //     setSelectedProvider(defaultTransactionProvider?.risk?.provider_code)
    //   }
    // }, [defaultTransactionProvider])
    (0, $tZqWC.useEffect)(()=>chain && selectedProvider && transactionInput && handleSubmit(), [
        selectedProvider
    ]);
    (0, $tZqWC.useEffect)(()=>!isActive && setTransactionInput(''), [
        isActive
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (createOrUpdateTransactionData) {
            setScannedTransaction(createOrUpdateTransactionData);
            setIsActive(false);
        }
    }, [
        createOrUpdateTransactionData
    ]);
    (0, $tZqWC.useEffect)(()=>{
        // TODO ADD PROPER ERROR MSG SENT FROM SERVER
        if (createOrUpdateTransactionError) showAlert({
            type: 'error',
            message: 'An error occurred in screening transaction'
        });
    }, [
        createOrUpdateTransactionError
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (isCreateOrUpdateTransactionLoading) {
            toggleInfoModal(true);
            setInfoModalDetails({
                title: 'Scanning Transaction',
                content: 'This process may take over 60 seconds, depending on the volume of data.',
                loading: true
            });
        } else {
            toggleInfoModal(false);
            setInfoModalDetails();
        }
    }, [
        isCreateOrUpdateTransactionLoading
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $a804046d7d77c8bb$export$e6dfd72ab29f8598), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a804046d7d77c8bb$export$97ddd2af6308ba2), {
                isActive: isActive,
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $a804046d7d77c8bb$export$b1d97b9d6e698468), {
                    isActive: isActive,
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $a804046d7d77c8bb$export$9fc98b514229b55b), {
                            isActive: isActive,
                            children: [
                                isActive && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a804046d7d77c8bb$export$94756becb802e330), {
                                    onClick: ()=>setIsActive(false),
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b77b5de3fb591045$export$2e2bcd8739ae039), {
                                        size: 18
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2232f33a3cdf9fa0$export$2e2bcd8739ae039), {
                                    size: 18
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ae78f1d128dc50d5$export$2e2bcd8739ae039), {
                                    placeholder: isCreateOrUpdateTransactionLoading ? 'loading...' : !isActive && "Screen a transaction hash\u2026",
                                    onClick: ()=>{
                                        setIsActive(true);
                                    },
                                    value: transactionInput,
                                    onChange: (e)=>handleTransactionChange(e.currentTarget.value)
                                })
                            ]
                        }),
                        isActive && transactionInput?.trim() && !isCreateOrUpdateTransactionLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $a804046d7d77c8bb$export$550fc938a73ef6b7), {
                            isActive: isActive,
                            children: [
                                allChains && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $a804046d7d77c8bb$export$67706c264edf13ca), {
                                    children: [
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a804046d7d77c8bb$export$f99233281efd08a0), {
                                            children: "Select Chain"
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a804046d7d77c8bb$export$b5fbeb65832ce537), {
                                            children: Object.keys(allChains)?.map((key)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                                    onClick: ()=>{
                                                        setChainSymbol(key);
                                                        setChain(allChains[key]?.chain_name);
                                                    },
                                                    variant: chainSymbol === key ? 'primary' : 'outlined',
                                                    children: allChains[key]?.chain_name
                                                }, key))
                                        })
                                    ]
                                }),
                                allChains && chain && transactionInput && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $a804046d7d77c8bb$export$67706c264edf13ca), {
                                    children: [
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a804046d7d77c8bb$export$f99233281efd08a0), {
                                            children: "Select Provider"
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a804046d7d77c8bb$export$b5fbeb65832ce537), {
                                            children: Object.keys(availableChains)?.map((key)=>{
                                                if (availableChains?.[key]?.[chainSymbol]) return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                                    onClick: ()=>{
                                                        setSelectedProvider(key);
                                                    },
                                                    variant: selectedProvider === key ? 'primary' : 'outlined',
                                                    children: key
                                                }, key);
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a804046d7d77c8bb$export$698223c589197ab7), {
                onClick: ()=>setIsActive(false),
                style: {
                    zIndex: isActive ? '5' : '-1',
                    opacity: isActive ? '0.5' : '0'
                }
            })
        ]
    });
}
// Default Props
$182253dde64dd2c0$var$TransactionsSearchBar.defaultProps = {
    actions: {}
};
// Proptypes Validation
$182253dde64dd2c0$var$TransactionsSearchBar.propTypes = {
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setScannedTransaction: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        toggleInfoModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setInfoModalDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $182253dde64dd2c0$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($182253dde64dd2c0$var$mapStateToProps, $182253dde64dd2c0$var$mapDispatchToProps)($182253dde64dd2c0$var$TransactionsSearchBar);


var $d0b9a7370378da49$export$2e2bcd8739ae039 = (0, $182253dde64dd2c0$export$2e2bcd8739ae039);


/* eslint-disable react/no-array-index-key */ 

var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");





const $84ec1d689a59fe81$export$603ae81ab9412b1f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $84ec1d689a59fe81$export$bdc91e8a04f1a933 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;
const $84ec1d689a59fe81$export$7d2474b4a873c7fc = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 15px;
`;




/* eslint-disable react/no-unstable-nested-components */ 

var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");


var $ejSM7 = parcelRequire("ejSM7");






const $13a868538889f3f5$export$fd2299f554be8993 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 50px;
  align-items: center;

  padding: 10px;
  color: ${({ theme: theme })=>theme.colors.primary};
  & svg > path {
    stroke: ${({ theme: theme })=>theme.colors.primary};
  }
`;
const $13a868538889f3f5$export$9f515a68dfaeb9ef = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  gap: 40px;

  &:last-child > div:last-child {
    max-width: 150px;
  }
  &:last-child > div:first-child {
    justify-content: flex-end;
    max-width: 500px;
  }

  &:first-child > div:last-child {
    justify-content: flex-end;
    visibility: ${({ isExpanded: isExpanded })=>isExpanded && 'hidden'};
  }
  &:last-child > div:first-child {
    visibility: ${({ isExpanded: isExpanded })=>isExpanded && 'hidden'};
  }
`;
const $13a868538889f3f5$export$987cac99e7a31168 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  width: 100%;

  gap: 20px;
`;
const $13a868538889f3f5$export$6f4a084cc8e379b6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
`;
const $13a868538889f3f5$export$49316f37c3b5fade = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 15px;
  font-weight: 400;

  max-width: 250px;

  ${({ overflowHidden: overflowHidden })=>overflowHidden && `max-width: 100px;
    min-width: 100px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  `}
  &.transfer_item_amount {
    max-width: 100px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
`;
const $13a868538889f3f5$export$65b9fe47bb7b64b0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 10px;
  font-weight: 400;
  color: ${({ theme: theme })=>theme.colors.primary}90;

  ${({ overflowHidden: overflowHidden })=>overflowHidden && `max-width: 100px;
    min-width: 100px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  `}
`;
const $13a868538889f3f5$export$85524e8d4e82fc69 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $13a868538889f3f5$export$be58b4326e23250f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2px;
  & svg {
    border: 1px solid ${({ theme: theme })=>theme.colors.primary};
    border-radius: 8px;
    padding: 2px;
  }
`;



/* eslint-disable react/forbid-prop-types */ 

var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");





const $83291a110b3531b3$export$e6dfd72ab29f8598 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  padding: 20px;
`;
const $83291a110b3531b3$export$d53c836cccbb0d90 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: absolute;
  top: 0;
  right: 0;

  display: flex;
  gap: 10px;
`;
const $83291a110b3531b3$export$42a852a2b6b56249 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $83291a110b3531b3$export$f5ec1ee0b77895e7 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: 1fr 1fr;

  margin-top: 20px;
  gap: 20px;
  padding-bottom: 20px;
`;
const $83291a110b3531b3$export$b2e35077a5c7bc77 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-start;

  width: 100%;
`;
const $83291a110b3531b3$export$f6e382949408c1f3 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  min-width: 300px;
  gap: 8px;
  height: fit-content;
`;
const $83291a110b3531b3$export$bc7adc8ef74607f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  gap: 20px;
  & p:nth-child(2) {
    text-align: right;
  }
  & p:first-child {
    min-width: 150px;
  }
`;
const $83291a110b3531b3$export$87ad169bde460ddf = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
`;
const $83291a110b3531b3$export$d747b2abe71e53f5 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 100%;
`;
const $83291a110b3531b3$export$5f1af8db9871e1d6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  margin: 0;
  padding: 0;
  font-size: 13px;
  color: ${({ theme: theme })=>theme.colors.primary};
  word-break: break-all;
`;
const $83291a110b3531b3$export$f99233281efd08a0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h2`
  margin: 0;
  padding: 0;
  font-size: 13px;
  font-weight: 700;
  color: ${({ theme: theme })=>theme.colors.primary};
  margin-bottom: 10px;
`;
const $83291a110b3531b3$export$ae133abb7f01f500 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 20px 0 0 0;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(520px, 1fr));
  gap: 20px;
`;
const $83291a110b3531b3$export$71237909d9ca197d = (0, $a778141486c79bc3$export$2e2bcd8739ae039).hr`
  width: 100%;
  height: 2px !important;

  color: ${({ theme: theme })=>theme.colors.secondary};
  margin: 20px 0;
`;
const $83291a110b3531b3$export$b2bf131c9f9cce5d = (0, $a778141486c79bc3$export$2e2bcd8739ae039)((0, $12b33660068e86aa$export$b0d92dbee9b5b60d))`
  display: flex;
  align-items: center;
  gap: 5px;
  height: 100%;

  & svg {
    height: 100%;
    max-height: 15px;
  }
`;
const $83291a110b3531b3$export$a4fff7f2f85c4c81 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  padding: 20px;
  width: 100%;
  border-radius: 7px;
  border: 1px solid ${({ theme: theme })=>theme.colors.backgroundLite};
  transition: 0.3s;
  height: fit-content;
`;






var $ejSM7 = parcelRequire("ejSM7");
// Map Redux Props
const $7d10c4ae1cb01c21$var$mapStateToProps = (state)=>state;
const $7d10c4ae1cb01c21$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $7d10c4ae1cb01c21$var$TravelRuleTableItemDetails(props) {
    // Destructure
    const { transfer_status: transfer_status, transfer_details: transfer_details, isLoading: isLoading, actions: actions, table_data: table_data, ui: ui, setTableData: setTableData, getTransfer: getTransfer } = props;
    const { updateTransferModalStatus: updateTransferModalStatus } = ui;
    const { showAlert: // setIsIndividualRecipientDrawerOpen,
    // setIsEntityRecipientDrawerOpen,
    // setToBeUpdatedRecipient,
    // setIsPageTableUpdated,
    showAlert, toggleUpdateTransferModal: toggleUpdateTransferModal, setUpdateTransferModalStatus: setUpdateTransferModalStatus, setUpdateTransferModalData: setUpdateTransferModalData } = actions;
    // hooks
    const [page, setPage] = (0, $tZqWC.useState)(0);
    const [formattedFlow, setFormattedFlow] = (0, $tZqWC.useState)(null);
    const [newStatus, setNewStatus] = (0, $tZqWC.useState)();
    const [inAddress, setInAddress] = (0, $tZqWC.useState)();
    const [outAddress, setOutAddress] = (0, $tZqWC.useState)();
    const [inVaspAddress, setInVaspAddress] = (0, $tZqWC.useState)();
    const [outVaspAddress, setOutVaspAddress] = (0, $tZqWC.useState)();
    const { updateTransfer: updateTransfer, transferUpdateData: transferUpdateData, isTransferUpdateSuccess: isTransferUpdateSuccess } = (0, $f3a1fe9f31d5b5de$export$2e2bcd8739ae039)();
    // Constants
    const internal_transfer = (transfer_details?.in_vasp.id === transfer_details?.out_vasp.id || transfer_details?.out_vasp.id === "SLFHST" || transfer_details?.in_vasp.id === "SLFHST") && table_data.transfer_status_id > -1;
    const received_transfer = table_data.direction_id === 1 && table_data.transfer_status_id > -1 && !(transfer_details?.in_vasp.id === transfer_details?.out_vasp.id || transfer_details?.out_vasp.id === "SLFHST" || transfer_details?.in_vasp.id === "SLFHST");
    const sent_transfer = table_data.direction_id !== 1 && table_data.transfer_status_id > -1 && !(transfer_details?.in_vasp.id === transfer_details?.out_vasp.id || transfer_details?.out_vasp.id === "SLFHST" || transfer_details?.in_vasp.id === "SLFHST");
    // Functions
    // const handleUpdateRecipient = () => {
    //   setToBeUpdatedRecipient(transfer_details.out_record)
    //   if (transfer_details.out_record.recipient_type_id === 1) return setIsIndividualRecipientDrawerOpen(true)
    //   if (transfer_details.out_record.recipient_type_id === 2) return setIsEntityRecipientDrawerOpen(true)
    // }
    const formatFlow = ()=>{
        const steps = [];
        let updated = false;
        transfer_status.transfer_steps.forEach((item)=>{
            const newItem = {
                leftLabel: item.date,
                rightLabel: item.label,
                disabled: false,
                failed: false
            };
            if (item?.date !== null) newItem.leftLabel = (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7))).utc(item?.date).format((0, $41a9e38e6be32f35$export$859ef203c4495ed2));
            if (steps.length > 0) {
                if (steps[steps.length - 1].leftLabel !== null && item.date === null && table_data.transfer_status_id < 0) {
                    updated = true;
                    const newerItem = {
                        leftLabel: item.date,
                        rightLabel: table_data.transfer_status_desc,
                        disabled: false,
                        failed: false
                    };
                    newerItem.leftLabel = (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7))).utc(table_data.last_modified).format((0, $41a9e38e6be32f35$export$859ef203c4495ed2));
                    // const date = new Date(table_data.last_modified)
                    // newerItem.leftLabel = `${date.getUTCFullYear()}-${String(date.getUTCMonth() + 1).padStart(2, '0')}-${String(
                    //   date.getUTCDate()
                    // ).padStart(2, '0')}, ${String(date.getUTCHours()).padStart(2, '0')}:${String(date.getUTCMinutes()).padStart(
                    //   2,
                    //   '0'
                    // )}`
                    if (table_data.transfer_status_id === -3 || table_data.transfer_status_id === -2) {
                        newerItem.failed = true;
                        steps.push(newerItem);
                    }
                }
            }
            if (updated && newItem.failed === false) newItem.disabled = true;
            steps.push(newItem);
        });
        setFormattedFlow(steps);
    };
    const handleUpdateTransferReq = (status_id)=>{
        setNewStatus(status_id);
        toggleUpdateTransferModal();
        if (status_id === -3) setUpdateTransferModalData({
            title: 'Reject Transfer',
            content: 'Are you sure you want to reject this transfer? This action is irreversible.'
        });
        if (status_id === -2) setUpdateTransferModalData({
            title: 'Cancel Transfer',
            content: 'Are you sure you want to cancel this transfer? This action is irreversible.'
        });
        if (status_id === -1) setUpdateTransferModalData({
            title: 'Accept Transfer',
            content: 'Are you sure you want to accept this transfer? This action is irreversible.'
        });
    };
    const handleUpdateTransfer = ()=>{
        setUpdateTransferModalStatus();
        updateTransfer({
            transfer_id: transfer_status.id,
            status_id: newStatus
        });
        setNewStatus();
    };
    const handleTransferUpdateData = ()=>{
        if (transferUpdateData && isTransferUpdateSuccess) {
            setTableData({
                table_data: table_data,
                ...transferUpdateData
            });
            showAlert({
                type: 'success',
                message: 'Successfully updated transfer'
            });
            getTransfer({
                transfer_id: transfer_status.id
            });
        }
        if (transferUpdateData && !isTransferUpdateSuccess) showAlert({
            type: 'error',
            message: 'An error occurred in updating record'
        });
    };
    function handleInAddress() {
        let inAddressRaw = `${transfer_details.in_record?.address_street_no ? ` ${transfer_details.in_record?.address_street_no?.trim()}, ` : ''}${transfer_details.in_record?.address_street_name ? `${transfer_details.in_record?.address_street_name?.trim()}, ` : ''}${transfer_details.in_record?.address_building_name ? `${transfer_details.in_record?.address_building_name?.trim()}, ` : ''}${transfer_details.in_record?.address_floor ? `${transfer_details.in_record?.address_floor?.trim()}, ` : ''}${transfer_details.in_record?.address_room ? `${transfer_details.in_record?.address_room?.trim()}, ` : ''}${transfer_details.in_record?.address_department ? `${transfer_details.in_record?.address_department?.trim()}, ` : ''}${transfer_details.in_record?.address_postbox ? `${transfer_details.in_record?.address_postbox?.trim()}, ` : ''}${transfer_details.in_record?.address_city_location ? `${transfer_details.in_record?.address_city_location?.trim()}, ` : ''}${transfer_details.in_record?.address_city ? `${transfer_details.in_record?.address_city?.trim()}, ` : ''}${transfer_details.in_record?.address_region ? `${transfer_details.in_record?.address_region?.trim()}, ` : ''}${transfer_details.in_record?.address_district ? `${transfer_details.in_record?.address_district?.trim()}, ` : ''}${transfer_details.in_record?.address_postcode ? `${transfer_details.in_record?.address_postcode?.trim()}, ` : ''}${transfer_details.in_record?.address_country_code ? `${transfer_details.in_record?.address_country_code?.trim()}, ` : ''}${transfer_details.in_record?.address_country_desc ? `${transfer_details.in_record?.address_country_desc?.trim()} ` : ''}`;
        if (inAddressRaw[inAddressRaw.length - 2] === ',') inAddressRaw = inAddressRaw.slice(0, -2);
        setInAddress(inAddressRaw);
    }
    function handleOutAddress() {
        let outAddressRaw = `${transfer_details.out_record?.address_street_no ? ` ${transfer_details.out_record?.address_street_no?.trim()}, ` : ''}${transfer_details.out_record?.address_street_name ? `${transfer_details.out_record?.address_street_name?.trim()}, ` : ''}${transfer_details.out_record?.address_building_name ? `${transfer_details.out_record?.address_building_name?.trim()}, ` : ''}${transfer_details.out_record?.address_floor?.trim() ? `${transfer_details.out_record?.address_floor?.trim()}, ` : ''}${transfer_details.out_record?.address_room ? `${transfer_details.out_record?.address_room?.trim()}, ` : ''}${transfer_details.out_record?.address_department?.trim() ? `${transfer_details.out_record?.address_department?.trim()}, ` : ''}${transfer_details.out_record?.address_postbox ? `${transfer_details.out_record?.address_postbox?.trim()}, ` : ''}${transfer_details.out_record?.address_city_location ? `${transfer_details.out_record?.address_city_location?.trim()}, ` : ''}${transfer_details.out_record?.address_city?.trim() ? `${transfer_details.out_record?.address_city?.trim()}, ` : ''}${transfer_details.out_record?.address_region ? `${transfer_details.out_record?.address_region?.trim()}, ` : ''}${transfer_details.out_record?.address_district?.trim() ? `${transfer_details.out_record?.address_district?.trim()}, ` : ''}${transfer_details.out_record?.address_postcode ? `${transfer_details.out_record?.address_postcode?.trim()}, ` : ''}${transfer_details.out_record?.address_country_code ? `${transfer_details.out_record?.address_country_code?.trim()}, ` : ''}${transfer_details.out_record?.address_country_desc ? `${transfer_details.out_record?.address_country_desc?.trim()} ` : ''}`;
        if (outAddressRaw[outAddressRaw.length - 2] === ',') outAddressRaw = outAddressRaw.slice(0, -2);
        setOutAddress(outAddressRaw);
    }
    function handleInVaspAddress() {
        let inAddressRaw = `${transfer_details.in_vasp?.address_street_no ? ` ${transfer_details.in_vasp?.address_street_no?.trim()}, ` : ''}${transfer_details.in_vasp?.address_street_name ? `${transfer_details.in_vasp?.address_street_name?.trim()}, ` : ''}${transfer_details.in_vasp?.address_building_name ? `${transfer_details.in_vasp?.address_building_name?.trim()}, ` : ''}${transfer_details.in_vasp?.address_floor ? `${transfer_details.in_vasp?.address_floor?.trim()}, ` : ''}${transfer_details.in_vasp?.address_city ? `${transfer_details.in_vasp?.address_city?.trim()}, ` : ''}${transfer_details.in_vasp?.address_region ? `${transfer_details.in_vasp?.address_region?.trim()}, ` : ''}${transfer_details.in_vasp?.address_postcode ? `${transfer_details.in_vasp?.address_postcode?.trim()}, ` : ''}${transfer_details.in_vasp?.address_country_code ? `${transfer_details.in_vasp?.address_country_code?.trim()}, ` : ''}`;
        if (inAddressRaw[inAddressRaw.length - 2] === ',') inAddressRaw = inAddressRaw.slice(0, -2);
        setInVaspAddress(inAddressRaw);
    }
    function handleOutVaspAddress() {
        let outAddressRaw = `${transfer_details.out_vasp?.address_street_no ? ` ${transfer_details.out_vasp?.address_street_no?.trim()}, ` : ''}${transfer_details.out_vasp?.address_street_name ? `${transfer_details.out_vasp?.address_street_name?.trim()}, ` : ''}${transfer_details.out_vasp?.address_building_name ? `${transfer_details.out_vasp?.address_building_name?.trim()}, ` : ''}${transfer_details.out_vasp?.address_floor ? `${transfer_details.out_vasp?.address_floor?.trim()}, ` : ''}${transfer_details.out_vasp?.address_city ? `${transfer_details.out_vasp?.address_city?.trim()}, ` : ''}${transfer_details.out_vasp?.address_region ? `${transfer_details.out_vasp?.address_region?.trim()}, ` : ''}${transfer_details.out_vasp?.address_postcode ? `${transfer_details.out_vasp?.address_postcode?.trim()}, ` : ''}${transfer_details.out_vasp?.address_country_code ? `${transfer_details.out_vasp?.address_country_code?.trim()}, ` : ''}`;
        if (outAddressRaw[outAddressRaw.length - 2] === ',') outAddressRaw = outAddressRaw.slice(0, -2);
        setOutVaspAddress(outAddressRaw);
    }
    // UseEffects
    (0, $tZqWC.useEffect)(()=>{
        if (transfer_details) {
            handleInAddress();
            handleOutAddress();
            handleInVaspAddress();
            handleOutVaspAddress();
        }
    }, [
        transfer_details
    ]);
    (0, $tZqWC.useEffect)(()=>handleTransferUpdateData(), [
        transferUpdateData,
        isTransferUpdateSuccess
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (!isLoading && transfer_status) formatFlow();
    }, [
        transfer_status,
        isLoading
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (updateTransferModalStatus?.confirmed) handleUpdateTransfer();
    }, [
        updateTransferModalStatus
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$e6dfd72ab29f8598), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $83291a110b3531b3$export$42a852a2b6b56249), {
            children: [
                isLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $0167b1f2e06350fb$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a6fa6c8d0625529f$export$2e2bcd8739ae039), {})
                }),
                !isLoading && transfer_status && transfer_details && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                    children: [
                        internal_transfer && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $83291a110b3531b3$export$d53c836cccbb0d90), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                    size: "small",
                                    variant: "outlined",
                                    onClick: ()=>{
                                        handleUpdateTransferReq(-2);
                                    },
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                    size: "small",
                                    variant: "outlined",
                                    onClick: ()=>{
                                        handleUpdateTransferReq(-3);
                                    },
                                    children: "Reject"
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                    value: "Accept",
                                    onClick: ()=>{
                                        handleUpdateTransferReq(-1);
                                    }
                                })
                            ]
                        }),
                        received_transfer && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $83291a110b3531b3$export$d53c836cccbb0d90), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                    size: "small",
                                    variant: "outlined",
                                    onClick: ()=>{
                                        handleUpdateTransferReq(-3);
                                    },
                                    children: "Reject"
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                    value: "Accept",
                                    onClick: ()=>{
                                        handleUpdateTransferReq(-1);
                                    }
                                })
                            ]
                        }),
                        sent_transfer && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$d53c836cccbb0d90), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                size: "small",
                                variant: "outlined",
                                onClick: ()=>{
                                    handleUpdateTransferReq(-2);
                                },
                                children: "Cancel"
                            })
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $61931cc7babf29b2$export$2e2bcd8739ae039), {
                            page: page,
                            setPage: setPage
                        }),
                        page === 0 && transfer_status && formattedFlow !== null && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $83291a110b3531b3$export$f5ec1ee0b77895e7), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$b2e35077a5c7bc77), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$a4fff7f2f85c4c81), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $83291a110b3531b3$export$f6e382949408c1f3), {
                                            children: [
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $83291a110b3531b3$export$bc7adc8ef74607f), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$5f1af8db9871e1d6), {
                                                            children: "Date Initiated:"
                                                        }),
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$5f1af8db9871e1d6), {
                                                            children: (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7))).utc(transfer_status?.created).format((0, $41a9e38e6be32f35$export$67a03cd247c60132))
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $83291a110b3531b3$export$bc7adc8ef74607f), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$5f1af8db9871e1d6), {
                                                            children: "Transfer Number:"
                                                        }),
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$5f1af8db9871e1d6), {
                                                            children: transfer_status?.transfer_id
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $83291a110b3531b3$export$bc7adc8ef74607f), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$5f1af8db9871e1d6), {
                                                            children: "Asset: "
                                                        }),
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$5f1af8db9871e1d6), {
                                                            children: table_data?.dti_name_long
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $83291a110b3531b3$export$bc7adc8ef74607f), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$5f1af8db9871e1d6), {
                                                            children: "Amount:"
                                                        }),
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$5f1af8db9871e1d6), {
                                                            children: transfer_status?.amount || '-'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $83291a110b3531b3$export$bc7adc8ef74607f), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$5f1af8db9871e1d6), {
                                                            children: "Amount USD:"
                                                        }),
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$5f1af8db9871e1d6), {
                                                            children: transfer_status?.amount_usd || '-'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $83291a110b3531b3$export$bc7adc8ef74607f), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$5f1af8db9871e1d6), {
                                                            children: "Transfer Protocol:"
                                                        }),
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$5f1af8db9871e1d6), {
                                                            style: {
                                                                textTransform: 'uppercase'
                                                            },
                                                            children: table_data?.protocol_code || '-'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $83291a110b3531b3$export$bc7adc8ef74607f), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$5f1af8db9871e1d6), {
                                                            children: "Transaction Hash:"
                                                        }),
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$5f1af8db9871e1d6), {
                                                            style: {
                                                                textTransform: 'uppercase'
                                                            },
                                                            children: table_data?.tx_hash || '-'
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$b2e35077a5c7bc77), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$a4fff7f2f85c4c81), {
                                        style: {
                                            paddingBottom: '60px'
                                        },
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1388d6ff56865309$export$2e2bcd8739ae039), {
                                            headers: formattedFlow
                                        })
                                    })
                                })
                            ]
                        }),
                        page === 1 && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$ae133abb7f01f500), {
                            style: {
                                gridTemplateColumns: '1fr'
                            },
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$bc7adc8ef74607f), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $83291a110b3531b3$export$87ad169bde460ddf), {
                                    style: {
                                        display: 'grid',
                                        gridTemplateColumns: 'repeat(auto-fill, minmax(500px, 1fr))'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $83291a110b3531b3$export$a4fff7f2f85c4c81), {
                                            style: {
                                                height: '100%',
                                                gap: '8px',
                                                display: 'flex',
                                                flexDirection: 'column'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$f99233281efd08a0), {
                                                    children: "Beneficiary"
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $83291a110b3531b3$export$bc7adc8ef74607f), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$5f1af8db9871e1d6), {
                                                            children: "Reference ID: "
                                                        }),
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$5f1af8db9871e1d6), {
                                                            children: transfer_details.out_record?.reference_id
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $83291a110b3531b3$export$bc7adc8ef74607f), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$5f1af8db9871e1d6), {
                                                            children: "Customer ID: "
                                                        }),
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$5f1af8db9871e1d6), {
                                                            children: transfer_details.out_record?.customer_id || '-'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $83291a110b3531b3$export$bc7adc8ef74607f), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$5f1af8db9871e1d6), {
                                                            children: "Name: "
                                                        }),
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$5f1af8db9871e1d6), {
                                                            children: transfer_details?.out_record?.display_name || '-'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $83291a110b3531b3$export$bc7adc8ef74607f), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$5f1af8db9871e1d6), {
                                                            children: "Wallet Address: "
                                                        }),
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$5f1af8db9871e1d6), {
                                                            children: transfer_status?.out_address_hash || '-'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $83291a110b3531b3$export$bc7adc8ef74607f), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$5f1af8db9871e1d6), {
                                                            children: "Is Wallet Address Self-Hosted: "
                                                        }),
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$5f1af8db9871e1d6), {
                                                            children: transfer_status?.out_address_is_self_hosted ? 'Yes' : 'No'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $83291a110b3531b3$export$bc7adc8ef74607f), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$5f1af8db9871e1d6), {
                                                            children: "Physical Address: "
                                                        }),
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$5f1af8db9871e1d6), {
                                                            children: outAddress || '-'
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $83291a110b3531b3$export$a4fff7f2f85c4c81), {
                                            style: {
                                                height: '100%',
                                                gap: '8px',
                                                display: 'flex',
                                                flexDirection: 'column'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$f99233281efd08a0), {
                                                    children: "Beneficiary VASP"
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $83291a110b3531b3$export$bc7adc8ef74607f), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$5f1af8db9871e1d6), {
                                                            children: "Legal Name: "
                                                        }),
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$5f1af8db9871e1d6), {
                                                            children: transfer_details.out_vasp?.name_legal || '-'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $83291a110b3531b3$export$bc7adc8ef74607f), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$5f1af8db9871e1d6), {
                                                            children: "Website: "
                                                        }),
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$5f1af8db9871e1d6), {
                                                            children: transfer_details.out_vasp?.website || '-'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $83291a110b3531b3$export$bc7adc8ef74607f), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$5f1af8db9871e1d6), {
                                                            children: "National ID: "
                                                        }),
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$5f1af8db9871e1d6), {
                                                            children: transfer_details.out_vasp?.national_id || '-'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $83291a110b3531b3$export$bc7adc8ef74607f), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$5f1af8db9871e1d6), {
                                                            children: "Registration Country: "
                                                        }),
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$5f1af8db9871e1d6), {
                                                            children: transfer_details.out_vasp?.national_id_issue_country || '-'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $83291a110b3531b3$export$bc7adc8ef74607f), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$5f1af8db9871e1d6), {
                                                            children: "Physical Address: "
                                                        }),
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$5f1af8db9871e1d6), {
                                                            children: outVaspAddress || '-'
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $83291a110b3531b3$export$a4fff7f2f85c4c81), {
                                            style: {
                                                height: '100%',
                                                gap: '8px',
                                                display: 'flex',
                                                flexDirection: 'column'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$f99233281efd08a0), {
                                                    children: "Originator"
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $83291a110b3531b3$export$bc7adc8ef74607f), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$5f1af8db9871e1d6), {
                                                            children: "Reference ID: "
                                                        }),
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$5f1af8db9871e1d6), {
                                                            children: transfer_details.in_record?.reference_id
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $83291a110b3531b3$export$bc7adc8ef74607f), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$5f1af8db9871e1d6), {
                                                            children: "Customer ID: "
                                                        }),
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$5f1af8db9871e1d6), {
                                                            children: transfer_details.in_record?.customer_id || '-'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $83291a110b3531b3$export$bc7adc8ef74607f), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$5f1af8db9871e1d6), {
                                                            children: "Name: "
                                                        }),
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$5f1af8db9871e1d6), {
                                                            children: transfer_details.in_record?.display_name
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $83291a110b3531b3$export$bc7adc8ef74607f), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $83291a110b3531b3$export$5f1af8db9871e1d6), {
                                                            children: [
                                                                transfer_details?.in_account?.type_id === 2 ? 'National ID' : 'National ID',
                                                                ": "
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$5f1af8db9871e1d6), {
                                                            children: transfer_details.in_record?.national_id || '-'
                                                        })
                                                    ]
                                                }),
                                                transfer_details?.in_account?.type_id === 1 && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $83291a110b3531b3$export$bc7adc8ef74607f), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$5f1af8db9871e1d6), {
                                                                    children: "Date of Birth: "
                                                                }),
                                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$5f1af8db9871e1d6), {
                                                                    children: transfer_details.in_record?.date_of_birth || '-'
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $83291a110b3531b3$export$bc7adc8ef74607f), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$5f1af8db9871e1d6), {
                                                                    children: "Place of Birth: "
                                                                }),
                                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$5f1af8db9871e1d6), {
                                                                    children: transfer_details.in_record?.place_of_birth || '-'
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                transfer_details?.in_account?.type_id === 2 && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $83291a110b3531b3$export$bc7adc8ef74607f), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$5f1af8db9871e1d6), {
                                                            children: "Registration Country: "
                                                        }),
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$5f1af8db9871e1d6), {
                                                            children: transfer_details.in_record?.registration_country_code || '-'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $83291a110b3531b3$export$bc7adc8ef74607f), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$5f1af8db9871e1d6), {
                                                            children: "Wallet Address: "
                                                        }),
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$5f1af8db9871e1d6), {
                                                            children: transfer_status?.in_address_hash || '-'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $83291a110b3531b3$export$bc7adc8ef74607f), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$5f1af8db9871e1d6), {
                                                            children: "Is Wallet Address Self-Hosted: "
                                                        }),
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$5f1af8db9871e1d6), {
                                                            children: transfer_status?.in_address_is_self_hosted ? 'Yes' : 'No'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $83291a110b3531b3$export$bc7adc8ef74607f), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$5f1af8db9871e1d6), {
                                                            children: "Physical Address: "
                                                        }),
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$5f1af8db9871e1d6), {
                                                            children: inAddress || '-'
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $83291a110b3531b3$export$a4fff7f2f85c4c81), {
                                            style: {
                                                height: '100%',
                                                gap: '8px',
                                                display: 'flex',
                                                flexDirection: 'column'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$f99233281efd08a0), {
                                                    children: "Originator VASP"
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $83291a110b3531b3$export$bc7adc8ef74607f), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$5f1af8db9871e1d6), {
                                                            children: "Legal Name: "
                                                        }),
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$5f1af8db9871e1d6), {
                                                            children: transfer_details.in_vasp?.name_legal || '-'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $83291a110b3531b3$export$bc7adc8ef74607f), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$5f1af8db9871e1d6), {
                                                            children: "Website: "
                                                        }),
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$5f1af8db9871e1d6), {
                                                            children: transfer_details.in_vasp?.website || '-'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $83291a110b3531b3$export$bc7adc8ef74607f), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$5f1af8db9871e1d6), {
                                                            children: "National ID: "
                                                        }),
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$5f1af8db9871e1d6), {
                                                            children: transfer_details.in_vasp?.national_id || '-'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $83291a110b3531b3$export$bc7adc8ef74607f), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$5f1af8db9871e1d6), {
                                                            children: "Registration Country: "
                                                        }),
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$5f1af8db9871e1d6), {
                                                            children: transfer_details.in_vasp?.national_id_issue_country || '-'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $83291a110b3531b3$export$bc7adc8ef74607f), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$5f1af8db9871e1d6), {
                                                            children: "Physical Address: "
                                                        }),
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $83291a110b3531b3$export$5f1af8db9871e1d6), {
                                                            children: inVaspAddress || '-'
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
}
// Default Props
$7d10c4ae1cb01c21$var$TravelRuleTableItemDetails.defaultProps = {
    actions: {},
    filters: {},
    ui: {},
    transfer_status: {}
};
// Proptypes Validation
$7d10c4ae1cb01c21$var$TravelRuleTableItemDetails.propTypes = {
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        accountDirectoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object)
    }),
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        updateTransferModalStatus: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            confirmed: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
        })
    }),
    table_data: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        direction_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        transfer_status_desc: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        last_modified: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        dti_name_long: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        transfer_status_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        protocol_code: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        tx_hash: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setToBeUpdatedRecipient: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsIndividualRecipientDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsEntityRecipientDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        toggleUpdateTransferModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setUpdateTransferModalStatus: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setUpdateTransferModalData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    transfer_status: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        amount: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        amount_usd: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        created: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        created_by_desc: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        dti: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        dti_name_long: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        dti_name_short: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string),
        id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        in_address_hash: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        in_address_is_self_hosted: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
        out_address_hash: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        out_address_is_self_hosted: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
        transfer_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        transfer_steps: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            date: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            label: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
        }))
    }),
    transfer_details: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).any,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    setTableData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    getTransfer: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
};
var $7d10c4ae1cb01c21$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($7d10c4ae1cb01c21$var$mapStateToProps, $7d10c4ae1cb01c21$var$mapDispatchToProps)($7d10c4ae1cb01c21$var$TravelRuleTableItemDetails);


var $70d024f10cc3d170$export$2e2bcd8739ae039 = (0, $7d10c4ae1cb01c21$export$2e2bcd8739ae039);


// Map Redux Props
const $05784bca7fc29d7e$var$mapStateToProps = (state)=>state;
const $05784bca7fc29d7e$var$mapDispatchToProps = (dispatch)=>(0, $2154a4c08d887b32$export$e324594224ef24da)(dispatch);
function $05784bca7fc29d7e$var$TravelRuleTableItem(props) {
    // Destructure
    const { data: data, ui: ui, actions: actions } = props;
    const { isRecordUpdated: isRecordUpdated } = ui;
    const { setIsRecordUpdated: setIsRecordUpdated } = actions;
    // Hooks
    const { getTransfer: getTransfer, transferData: transferData, isTransferLoading: isTransferLoading } = (0, $59e92218d3a75836$export$2e2bcd8739ae039)();
    // States
    const [barWidth, setBarWidth] = (0, $tZqWC.useState)('0%');
    const [isExpanded, setIsExpanded] = (0, $tZqWC.useState)(false);
    const [details, setDetails] = (0, $tZqWC.useState)({
        transfer_status: null,
        transfer_details: null
    });
    const [localData, setLocalData] = (0, $tZqWC.useState)(data);
    const { direction_id: direction_id, dti_name_short: dti_name_short, amount: amount, amount_usd: amount_usd, last_modified: last_modified, in_record_name: in_record_name, account_name: account_name, out_record_name: out_record_name, transfer_status_id: transfer_status_id, transfer_status_desc: transfer_status_desc, id: id, protocol_code: protocol_code, in_address_is_self_hosted: in_address_is_self_hosted, out_address_is_self_hosted: out_address_is_self_hosted, table_data: table_data } = localData;
    // NOTE: this is a temporary fix. API should return `direction_id` in the response or better state handling.
    // currently when updating status of transfer, 'direction_id' is not included in the response,
    // so we need to use the 'table_data' to get the direction_id in this scenario.
    const actual_direction_id = direction_id || table_data?.direction_id;
    // Functions
    const fetchData = ()=>getTransfer({
            transfer_id: id
        });
    // useEffects
    (0, $tZqWC.useEffect)(()=>isExpanded && !details.transfer_status && !details.transfer_details && fetchData(), [
        isExpanded
    ]);
    (0, $tZqWC.useEffect)(()=>transferData && setDetails(transferData), [
        transferData
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (isRecordUpdated && isExpanded) {
            fetchData();
            setIsRecordUpdated(false);
        }
    }, [
        isRecordUpdated
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (transfer_status_id + 1 === 1) return setBarWidth('20%');
        if (transfer_status_id + 1 === 2) return setBarWidth('40%');
        if (transfer_status_id + 1 === 3) return setBarWidth('60%');
        if (transfer_status_id + 1 === 4) return setBarWidth('80%');
        if (transfer_status_id + 1 === 5) return setBarWidth('100%');
        if (transfer_status_id < 0) return setBarWidth('100%');
    }, [
        localData
    ]);
    (0, $tZqWC.useEffect)(()=>data && setLocalData(data), [
        data
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b3f7dc6528742bb0$export$2e2bcd8739ae039), {
        setIsExpanded: setIsExpanded,
        expandPanel: isExpanded,
        button: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $13a868538889f3f5$export$fd2299f554be8993), {
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $13a868538889f3f5$export$9f515a68dfaeb9ef), {
                    isExpanded: isExpanded,
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $13a868538889f3f5$export$987cac99e7a31168), {
                            style: {
                                maxWidth: '80px',
                                gap: '10px'
                            },
                            children: [
                                actual_direction_id === 1 ? /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $13a868538889f3f5$export$be58b4326e23250f), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9523a1ca65c68678$export$2e2bcd8739ae039), {
                                        size: 24
                                    })
                                }) : /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $13a868538889f3f5$export$be58b4326e23250f), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $76ab1dfa1f4ba16c$export$2e2bcd8739ae039), {
                                        size: 24
                                    })
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $13a868538889f3f5$export$6f4a084cc8e379b6), {
                                    children: [
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $13a868538889f3f5$export$49316f37c3b5fade), {
                                            children: actual_direction_id === 1 ? 'In' : 'Out'
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $13a868538889f3f5$export$65b9fe47bb7b64b0), {
                                            children: protocol_code?.toUpperCase()
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $13a868538889f3f5$export$987cac99e7a31168), {
                            children: [
                                actual_direction_id === 1 ? /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $13a868538889f3f5$export$6f4a084cc8e379b6), {
                                    children: [
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $13a868538889f3f5$export$49316f37c3b5fade), {
                                            overflowHidden: true,
                                            children: out_record_name || '-'
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $13a868538889f3f5$export$65b9fe47bb7b64b0), {
                                            children: out_address_is_self_hosted ? 'Self-Hosted' : 'VASP'
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $13a868538889f3f5$export$6f4a084cc8e379b6), {
                                    children: [
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $13a868538889f3f5$export$49316f37c3b5fade), {
                                            overflowHidden: true,
                                            children: in_record_name || account_name || '-'
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $13a868538889f3f5$export$65b9fe47bb7b64b0), {
                                            children: in_address_is_self_hosted ? 'Self-Hosted' : 'VASP'
                                        })
                                    ]
                                }),
                                actual_direction_id === 1 ? /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9cadc73f9b5b2fc9$export$2e2bcd8739ae039), {
                                    size: 24
                                }) : /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ce96cd4d0e43c777$export$2e2bcd8739ae039), {
                                    size: 24
                                }),
                                actual_direction_id === 1 ? /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $13a868538889f3f5$export$6f4a084cc8e379b6), {
                                    children: [
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $13a868538889f3f5$export$49316f37c3b5fade), {
                                            overflowHidden: true,
                                            children: in_record_name || account_name || '-'
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $13a868538889f3f5$export$65b9fe47bb7b64b0), {
                                            children: in_address_is_self_hosted ? 'Self-Hosted' : 'VASP'
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $13a868538889f3f5$export$6f4a084cc8e379b6), {
                                    children: [
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $13a868538889f3f5$export$49316f37c3b5fade), {
                                            overflowHidden: true,
                                            children: out_record_name || '-'
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $13a868538889f3f5$export$65b9fe47bb7b64b0), {
                                            children: out_address_is_self_hosted ? 'Self-Hosted' : 'VASP'
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $13a868538889f3f5$export$987cac99e7a31168), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $13a868538889f3f5$export$49316f37c3b5fade), {
                                children: (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7))).utc(last_modified).format((0, $41a9e38e6be32f35$export$859ef203c4495ed2))
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $13a868538889f3f5$export$9f515a68dfaeb9ef), {
                    isExpanded: isExpanded,
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $13a868538889f3f5$export$987cac99e7a31168), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $13a868538889f3f5$export$49316f37c3b5fade), {
                                    children: transfer_status_desc
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $badb5a82015e7095$export$2e2bcd8739ae039), {
                                    failed: transfer_status_id < -1,
                                    width: barWidth,
                                    maxWidth: "280px"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $13a868538889f3f5$export$987cac99e7a31168), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $13a868538889f3f5$export$6f4a084cc8e379b6), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $13a868538889f3f5$export$49316f37c3b5fade), {
                                        className: "transfer_item_amount",
                                        children: [
                                            dti_name_short?.[0],
                                            ": ",
                                            amount
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $13a868538889f3f5$export$65b9fe47bb7b64b0), {
                                        children: `USD ${(0, $ecf1d77ac1b82678$export$a2db1876938cd11d)(Math.round(amount_usd * 100) / 100)}`
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        }),
        panel: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $13a868538889f3f5$export$85524e8d4e82fc69), {
            children: details && isExpanded && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $70d024f10cc3d170$export$2e2bcd8739ae039), {
                isLoading: isTransferLoading,
                transfer_status: details.transfer_status,
                transfer_details: details.transfer_details,
                table_data: localData,
                setTableData: setLocalData,
                getTransfer: getTransfer
            }, localData)
        })
    });
}
// Default Props
$05784bca7fc29d7e$var$TravelRuleTableItem.defaultProps = {
    actions: {},
    data: {
        direction_id: 0,
        dti_name_short: [
            ''
        ],
        amount: 0,
        amount_usd: 0,
        last_modified: '',
        in_record_name: '',
        account_name: '',
        out_record_name: '',
        transfer_status_id: 0,
        transfer_status_desc: '',
        id: '',
        protocol_code: '',
        in_address_is_self_hosted: false,
        out_address_is_self_hosted: false
    }
};
// Proptypes Validation
$05784bca7fc29d7e$var$TravelRuleTableItem.propTypes = {
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setIsRecordUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isRecordUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    data: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        direction_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        dti_name_short: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string),
        amount: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        amount_usd: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        last_modified: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        in_record_name: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        account_name: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        out_record_name: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        transfer_status_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        transfer_status_desc: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        protocol_code: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        in_address_is_self_hosted: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
        out_address_is_self_hosted: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
        id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    })
};
var $05784bca7fc29d7e$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($05784bca7fc29d7e$var$mapStateToProps, $05784bca7fc29d7e$var$mapDispatchToProps)($05784bca7fc29d7e$var$TravelRuleTableItem);


var $b4994cef654503eb$export$2e2bcd8739ae039 = (0, $05784bca7fc29d7e$export$2e2bcd8739ae039);


/* eslint-disable react/prop-types */ 

var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");





const $9970c6bc3889eb81$export$d052f996153b966 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  width: 100%;

  // If there is space then it's for the child
  // If there is no space then it's for the current component
  &#travelRuleTableFilter {
    flex-direction: column;
  }
  &#accountAddressTableFilter {
    & > div {
      padding: 0 !important;
      margin: 0 !important;
    }
  }
  & #travelruleDateFilter {
    justify-content: center;
    & > div {
      max-width: none !important;
    }
  }
  & #travelRuleSort {
    min-width: 245px;
    & .simpleSelectInputLabel {
      min-width: 165px;
    }
  }
  & #travelRuleAssetSort {
    & .simpleSelectInputLabel {
      min-width: 130px;
    }
  }
  & #addressDateFilter {
    & > div {
      max-width: none !important;
      padding: 0;
      height: 100%;
      gap: 10px;

      & p {
        font-size: 12px !important;
        margin: 0;
        display: flex;
        align-items: center;
        gap: 5px;
      }
    }
  }
  & #VASPSort {
    min-width: 200px;
    & .simpleSelectInputLabel {
      min-width: 120px;
    }
  }
`;
const $9970c6bc3889eb81$export$ca4b1fc43afa0212 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $9970c6bc3889eb81$export$c16c38052d2b0214 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  transition: 0.6s;
  max-height: ${({ active: active })=>active ? '2000px' : '0'};
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 15px;
  overflow: ${({ active: active })=>active ? 'auto' : 'hidden'};
`;
const $9970c6bc3889eb81$export$2d48b21c447d881f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 15px;
  width: 100%;
  margin-top: 20px;

  & > div {
    margin: 0;
  }
`;



// Map Redux Props
const $716326f4c263f39f$var$mapStateToProps = (state)=>state;
const $716326f4c263f39f$var$mapDispatchToProps = (dispatch)=>(0, $2154a4c08d887b32$export$e324594224ef24da)(dispatch);
function $716326f4c263f39f$var$TravelRuleSearchInput(props) {
    // Destructure
    const { onTransferSearch: onTransferSearch, setIsTransferLoading: setIsTransferLoading, actions: actions } = props;
    // Store Actions
    const { setShowHeaderLoader: setShowHeaderLoader } = actions;
    // Hooks
    const { transferSearchData: transferSearchData, searchTransfer: searchTransfer, isTransferSearchLoading: isTransferSearchLoading } = (0, $47163b3c3a1eda62$export$2e2bcd8739ae039)();
    // Functions
    // Search Functions
    const handleOnAutoCompleteInputChange = (0, (/*@__PURE__*/$parcel$interopDefault($e6f80c3bb3fc9ef9$exports)))((value)=>{
        if (!value) return onTransferSearch();
        if (value) return searchTransfer({
            search_term: value
        });
    }, 500);
    // useEffect
    (0, $tZqWC.useEffect)(()=>{
        if (transferSearchData) onTransferSearch(transferSearchData);
        if (!transferSearchData) onTransferSearch([]);
    }, [
        transferSearchData
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (isTransferSearchLoading) {
            setIsTransferLoading(true);
            setShowHeaderLoader(true);
        } else if (!isTransferSearchLoading) {
            setIsTransferLoading(false);
            setShowHeaderLoader(false);
        }
    }, [
        isTransferSearchLoading
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9970c6bc3889eb81$export$d052f996153b966), {
        id: "travelRuleTableFilter",
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9970c6bc3889eb81$export$2d48b21c447d881f), {
            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $69a991355976a1a9$export$2e2bcd8739ae039), {
                disabledOptions: true,
                placeholder: "Search Transfer Number or Transaction Hash...",
                onInputChange: handleOnAutoCompleteInputChange,
                isLoading: isTransferSearchLoading
            })
        })
    });
}
// Default Props
$716326f4c263f39f$var$TravelRuleSearchInput.defaultProps = {
    onTransferSearch: ()=>{},
    filters: {},
    actions: {}
};
// Proptypes Validation
$716326f4c263f39f$var$TravelRuleSearchInput.propTypes = {
    onTransferSearch: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        travelRuleFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            sort: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            start_date: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            end_date: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            direction_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            asset_code: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
            transfer_status_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number
        })
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setTravelRuleFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    setIsTransferLoading: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    address: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        addressChains: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({})
    })
};
var $716326f4c263f39f$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($716326f4c263f39f$var$mapStateToProps, $716326f4c263f39f$var$mapDispatchToProps)($716326f4c263f39f$var$TravelRuleSearchInput);


var $b63243f30a47d10a$export$2e2bcd8739ae039 = (0, $716326f4c263f39f$export$2e2bcd8739ae039);


/* eslint-disable react/no-unstable-nested-components */ 
parcelRequire("tZqWC");



const $6adc93cd961eb658$export$fd2299f554be8993 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 50px;
  align-items: center;

  padding: 10px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $6adc93cd961eb658$export$9f515a68dfaeb9ef = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  gap: 40px;

  &:last-child > div:last-child {
    max-width: 150px;
  }
  &:last-child > div:first-child {
    justify-content: flex-end;
    max-width: 535px;
  }

  &:first-child > div:last-child {
    justify-content: flex-end;
    visibility: ${({ isExpanded: isExpanded })=>isExpanded && 'hidden'};
  }
  &:last-child > div:first-child {
    visibility: ${({ isExpanded: isExpanded })=>isExpanded && 'hidden'};
  }
`;
const $6adc93cd961eb658$export$987cac99e7a31168 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  width: 100%;

  gap: 20px;
`;
const $6adc93cd961eb658$export$6f4a084cc8e379b6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
`;
const $6adc93cd961eb658$export$49316f37c3b5fade = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 15px;
  font-weight: 400;

  max-width: 250px;

  &:first-child {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  &.address_item_amount {
    max-width: 100px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
`;
const $6adc93cd961eb658$export$7c901fb2027bd1cd = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background: ${({ theme: theme })=>theme.colors.backgroundLite};
`;



// Map Redux Props
const $12ae6e68b484fb91$var$mapStateToProps = (state)=>state;
const $12ae6e68b484fb91$var$mapDispatchToProps = (dispatch)=>(0, $2154a4c08d887b32$export$e324594224ef24da)(dispatch);
function $12ae6e68b484fb91$var$TravelRuleTableItemLoading() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b3f7dc6528742bb0$export$2e2bcd8739ae039), {
        setIsExpanded: ()=>{},
        expandPanel: false,
        button: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6adc93cd961eb658$export$fd2299f554be8993), {
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6adc93cd961eb658$export$9f515a68dfaeb9ef), {
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6adc93cd961eb658$export$987cac99e7a31168), {
                            style: {
                                gap: '10px',
                                maxWidth: '80px'
                            },
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6adc93cd961eb658$export$7c901fb2027bd1cd), {}),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6adc93cd961eb658$export$6f4a084cc8e379b6), {
                                    style: {
                                        gap: '5px'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5facfc7bc5a170d3$export$2e2bcd8739ae039), {
                                            height: 18,
                                            width: 30
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5facfc7bc5a170d3$export$2e2bcd8739ae039), {
                                            height: 10,
                                            width: 40
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6adc93cd961eb658$export$987cac99e7a31168), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6adc93cd961eb658$export$6f4a084cc8e379b6), {
                                    style: {
                                        gap: '5px'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5facfc7bc5a170d3$export$2e2bcd8739ae039), {
                                            height: 18,
                                            width: 95
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5facfc7bc5a170d3$export$2e2bcd8739ae039), {
                                            height: 10,
                                            width: 50
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6adc93cd961eb658$export$7c901fb2027bd1cd), {
                                    style: {
                                        height: '24px',
                                        width: '24px',
                                        borderRadius: '6px'
                                    }
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6adc93cd961eb658$export$6f4a084cc8e379b6), {
                                    style: {
                                        gap: '5px'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5facfc7bc5a170d3$export$2e2bcd8739ae039), {
                                            height: 18,
                                            width: 95
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5facfc7bc5a170d3$export$2e2bcd8739ae039), {
                                            height: 10,
                                            width: 50
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6adc93cd961eb658$export$987cac99e7a31168), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5facfc7bc5a170d3$export$2e2bcd8739ae039), {
                                height: 20,
                                width: 130
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6adc93cd961eb658$export$9f515a68dfaeb9ef), {
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6adc93cd961eb658$export$987cac99e7a31168), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5facfc7bc5a170d3$export$2e2bcd8739ae039), {
                                    height: 20,
                                    width: 80
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $badb5a82015e7095$export$2e2bcd8739ae039), {
                                    width: 0,
                                    maxWidth: "280px"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6adc93cd961eb658$export$987cac99e7a31168), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6adc93cd961eb658$export$6f4a084cc8e379b6), {
                                style: {
                                    gap: '5px'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5facfc7bc5a170d3$export$2e2bcd8739ae039), {
                                        height: 17,
                                        width: 50
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5facfc7bc5a170d3$export$2e2bcd8739ae039), {
                                        height: 12,
                                        width: 30
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        }),
        panel: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("div", {})
    });
}
// Default Props
$12ae6e68b484fb91$var$TravelRuleTableItemLoading.defaultProps = {};
// Proptypes Validation
$12ae6e68b484fb91$var$TravelRuleTableItemLoading.propTypes = {};
var $12ae6e68b484fb91$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($12ae6e68b484fb91$var$mapStateToProps, $12ae6e68b484fb91$var$mapDispatchToProps)($12ae6e68b484fb91$var$TravelRuleTableItemLoading);


var $3840c8da3aaea1ec$export$2e2bcd8739ae039 = (0, $12ae6e68b484fb91$export$2e2bcd8739ae039);


// Map Redux Props
const $62703ab2d5236f89$var$mapStateToProps = (state)=>state;
const $62703ab2d5236f89$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $62703ab2d5236f89$var$TravelRuleTable(props) {
    // Destructure
    const { actions: actions, filters: filters, ui: ui } = props;
    const { travelRuleFilters: travelRuleFilters } = filters;
    const { isPageTableUpdated: isPageTableUpdated } = ui;
    const { setIsTransferDrawerOpen: setIsTransferDrawerOpen, setTravelRuleFilters: setTravelRuleFilters, setIsPageTableUpdated: setIsPageTableUpdated, toggleTransferReportModal: toggleTransferReportModal } = actions;
    // Hooks
    const [transfersData, setTransfersData] = (0, $tZqWC.useState)({
        items: [],
        total: 0
    });
    const { getAllTransfers: getAllTransfers, allTransferData: allTransferData, isAllTransferLoading: isAllTransferLoading } = (0, $13d8d2c7cd726551$export$2e2bcd8739ae039)();
    // State
    const [isTransferLoading, setIsTransferLoading] = (0, $tZqWC.useState)(false);
    // Functions
    const fetchData = async ()=>{
        getAllTransfers(travelRuleFilters);
    };
    const handleOnTransferSearch = (data)=>{
        if (!data) return getAllTransfers(travelRuleFilters);
        setTransfersData({
            items: data,
            total: 0
        });
    };
    // UseEffects
    (0, $tZqWC.useEffect)(()=>{
        setTravelRuleFilters();
    }, []);
    (0, $tZqWC.useEffect)(()=>fetchData(), [
        travelRuleFilters
    ]);
    (0, $tZqWC.useEffect)(()=>allTransferData && setTransfersData(allTransferData), [
        allTransferData
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (isPageTableUpdated) {
            fetchData();
            setIsPageTableUpdated(false);
        }
    }, [
        isPageTableUpdated
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $84ec1d689a59fe81$export$603ae81ab9412b1f), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $d2b0b55dc8f66a40$export$2e2bcd8739ae039), {
            minWidth: 700,
            totalItems: transfersData.total,
            tableFilters: travelRuleFilters,
            setTableFilters: setTravelRuleFilters,
            filterComponents: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b63243f30a47d10a$export$2e2bcd8739ae039), {
                setIsTransferLoading: setIsTransferLoading,
                onTransferSearch: handleOnTransferSearch
            }),
            headerOptions: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $84ec1d689a59fe81$export$bdc91e8a04f1a933), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a69d8405428f2206$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $84ec1d689a59fe81$export$7d2474b4a873c7fc), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                size: "small",
                                variant: "outlined",
                                startIcon: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6417d0fa9c066aa3$export$2e2bcd8739ae039), {
                                    size: 12
                                }),
                                onClick: ()=>{
                                    toggleTransferReportModal();
                                },
                                children: "Report"
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                size: "small",
                                variant: "outlined",
                                startIcon: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6417d0fa9c066aa3$export$2e2bcd8739ae039), {
                                    size: 12
                                }),
                                onClick: ()=>{
                                    setIsTransferDrawerOpen(true);
                                },
                                children: "Transfer"
                            })
                        ]
                    })
                ]
            }),
            children: [
                (isAllTransferLoading || isTransferLoading) && Array.from({
                    length: travelRuleFilters?.size || 10
                }).map((_, index)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3840c8da3aaea1ec$export$2e2bcd8739ae039), {}, index)),
                transfersData.items.length > 0 && !isAllTransferLoading && !isTransferLoading && transfersData.items.map((singleData)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b4994cef654503eb$export$2e2bcd8739ae039), {
                        data: singleData
                    }, singleData?.id)),
                transfersData?.items?.length < 1 && !isAllTransferLoading && !isTransferLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a6ea3b0f3caed586$export$2e2bcd8739ae039), {
                    setFilter: setTravelRuleFilters
                })
            ]
        })
    });
}
// Default Props
$62703ab2d5236f89$var$TravelRuleTable.defaultProps = {
    actions: {},
    ui: {},
    filters: {}
};
// Proptypes Validation
$62703ab2d5236f89$var$TravelRuleTable.propTypes = {
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setAddressChains: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setTravelRuleFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsTransferDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        toggleTransferReportModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        toggleUpgradeModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setInfoModalDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        travelRuleFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object)
    }),
    address: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        addressChains: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({})
    })
};
var $62703ab2d5236f89$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($62703ab2d5236f89$var$mapStateToProps, $62703ab2d5236f89$var$mapDispatchToProps)($62703ab2d5236f89$var$TravelRuleTable);


var $bdd1dc21fad1c965$export$2e2bcd8739ae039 = (0, $62703ab2d5236f89$export$2e2bcd8739ae039);






/* eslint-disable no-unsafe-optional-chaining */ /* eslint-disable react/no-array-index-key */ 

var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");




/* eslint-disable max-len */ const $cde4eb7a2bc4524b$export$aa546e9d53b6efe1 = {
    title: 'Regulatory Insights',
    description: 'Ask jurisdiction-specific compliance questions and receive instant, AI-generated insights. Just include your question and specify the jurisdiction for tailored responses. Disclaimer: This feature provides general informational guidance and does not constitute legal advice.',
    preprompts: [
        'What is the Travel Rule?',
        'What is a VASP or CASP?',
        'What is the Sunrise Issue in Travel Rule compliance?',
        'Do all businesses need to comply with the Travel Rule?',
        'How does the Travel Rule apply in European Union (EU)?',
        'How does the Travel Rule apply in United Kingdom (UK)?',
        'How does the Travel Rule apply in United States (USA)?',
        'How does the Travel Rule apply in United Arab Emirates (UAE)?',
        'How does the Travel Rule apply in Canada?'
    ]
};
const $cde4eb7a2bc4524b$export$1d6a7a97d7287b25 = {
    title: 'Get Started with Ospree',
    description: "Maximize your experience with Ospree. Share your compliance goals or operational tasks to receive guided support\u2014whether you're navigating the platform or designing custom API queries. ",
    preprompts: [
        'What are the available products Ospree provides?',
        'How do I authenticate with the Ospree API?',
        'How can I submit a Travel Rule transfer?',
        'How should I handle transfers to self-hosted wallets?',
        'Write my first Travel Rule API request!'
    ]
};
const $cde4eb7a2bc4524b$export$a38a862015dba646 = {
    regulatory_chat: $cde4eb7a2bc4524b$export$aa546e9d53b6efe1,
    oapp_docs_chat: $cde4eb7a2bc4524b$export$1d6a7a97d7287b25
};




const $d8dc3a663c1bdf0f$export$e6dfd72ab29f8598 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  height: 100%;
  min-height: 85vh;
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
`;
const $d8dc3a663c1bdf0f$export$42a852a2b6b56249 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  height: 100%;
  width: 100%;
  max-width: 800px;
`;
const $d8dc3a663c1bdf0f$export$616d763e306cba45 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  height: 100%;
  width: 100%;
  padding: 0 0 90px 0;
  gap: 36px;

  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;


/* eslint-disable react/no-array-index-key */ 
parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");


var $tZqWC = parcelRequire("tZqWC");
function $d57dfefb446d909b$var$n() {
    return $d57dfefb446d909b$var$n = Object.assign ? Object.assign.bind() : function(r) {
        for(var n = 1; n < arguments.length; n++){
            var e = arguments[n];
            for(var t in e)Object.prototype.hasOwnProperty.call(e, t) && (r[t] = e[t]);
        }
        return r;
    }, $d57dfefb446d909b$var$n.apply(this, arguments);
}
var $d57dfefb446d909b$var$e = [
    "children",
    "options"
], $d57dfefb446d909b$export$e0aa44767d8750d5 = {
    blockQuote: "0",
    breakLine: "1",
    breakThematic: "2",
    codeBlock: "3",
    codeFenced: "4",
    codeInline: "5",
    footnote: "6",
    footnoteReference: "7",
    gfmTask: "8",
    heading: "9",
    headingSetext: "10",
    htmlBlock: "11",
    htmlComment: "12",
    htmlSelfClosing: "13",
    image: "14",
    link: "15",
    linkAngleBraceStyleDetector: "16",
    linkBareUrlDetector: "17",
    linkMailtoDetector: "18",
    newlineCoalescer: "19",
    orderedList: "20",
    paragraph: "21",
    ref: "22",
    refImage: "23",
    refLink: "24",
    table: "25",
    tableSeparator: "26",
    text: "27",
    textBolded: "28",
    textEmphasized: "29",
    textEscaped: "30",
    textMarked: "31",
    textStrikethroughed: "32",
    unorderedList: "33"
}, $d57dfefb446d909b$var$u = [
    "allowFullScreen",
    "allowTransparency",
    "autoComplete",
    "autoFocus",
    "autoPlay",
    "cellPadding",
    "cellSpacing",
    "charSet",
    "classId",
    "colSpan",
    "contentEditable",
    "contextMenu",
    "crossOrigin",
    "encType",
    "formAction",
    "formEncType",
    "formMethod",
    "formNoValidate",
    "formTarget",
    "frameBorder",
    "hrefLang",
    "inputMode",
    "keyParams",
    "keyType",
    "marginHeight",
    "marginWidth",
    "maxLength",
    "mediaGroup",
    "minLength",
    "noValidate",
    "radioGroup",
    "readOnly",
    "rowSpan",
    "spellCheck",
    "srcDoc",
    "srcLang",
    "srcSet",
    "tabIndex",
    "useMap"
].reduce(function(r, n) {
    return r[n.toLowerCase()] = n, r;
}, {
    class: "className",
    for: "htmlFor"
}), $d57dfefb446d909b$var$a = {
    amp: "&",
    apos: "'",
    gt: ">",
    lt: "<",
    nbsp: "\xa0",
    quot: "\u201C"
}, $d57dfefb446d909b$var$i = [
    "style",
    "script",
    "pre"
], $d57dfefb446d909b$var$o = [
    "src",
    "href",
    "data",
    "formAction",
    "srcDoc",
    "action"
], $d57dfefb446d909b$var$c = /([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi, $d57dfefb446d909b$var$f = /mailto:/i, $d57dfefb446d909b$var$l = /\n{2,}$/, $d57dfefb446d909b$var$_ = /^(\s*>[\s\S]*?)(?=\n\n|$)/, $d57dfefb446d909b$var$d = /^ *> ?/gm, $d57dfefb446d909b$var$s = /^(?:\[!([^\]]*)\]\n)?([\s\S]*)/, $d57dfefb446d909b$var$p = /^ {2,}\n/, $d57dfefb446d909b$var$v = /^(?:( *[-*_])){3,} *(?:\n *)+\n/, $d57dfefb446d909b$var$y = /^(?: {1,3})?(`{3,}|~{3,}) *(\S+)? *([^\n]*?)?\n([\s\S]*?)(?:\1\n?|$)/, $d57dfefb446d909b$var$h = /^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/, $d57dfefb446d909b$var$g = /^(`+)((?:\\`|(?!\1)`|[^`])+)\1/, $d57dfefb446d909b$var$m = /^(?:\n *)*\n/, $d57dfefb446d909b$var$k = /\r\n?/g, $d57dfefb446d909b$var$x = /^\[\^([^\]]+)](:(.*)((\n+ {4,}.*)|(\n(?!\[\^).+))*)/, $d57dfefb446d909b$var$q = /^\[\^([^\]]+)]/, $d57dfefb446d909b$var$b = /\f/g, $d57dfefb446d909b$var$S = /^---[ \t]*\n(.|\n)*\n---[ \t]*\n/, $d57dfefb446d909b$var$z = /^\s*?\[(x|\s)\]/, $d57dfefb446d909b$var$$ = /^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $d57dfefb446d909b$var$E = /^ *(#{1,6}) +([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $d57dfefb446d909b$var$A = /^([^\n]+)\n *(=|-){3,} *\n/, $d57dfefb446d909b$var$R = /^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?((?:[^>]*[^/])?)>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1\b)[\s\S])*?)<\/\1>(?!<\/\1>)\n*/i, $d57dfefb446d909b$var$B = /&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/gi, $d57dfefb446d909b$var$L = /^<!--[\s\S]*?(?:-->)/, $d57dfefb446d909b$var$O = /^(data|aria|x)-[a-z_][a-z\d_.-]*$/, $d57dfefb446d909b$var$j = /^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i, $d57dfefb446d909b$var$C = /^\{.*\}$/, $d57dfefb446d909b$var$I = /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/, $d57dfefb446d909b$var$T = /^<([^ >]+@[^ >]+)>/, $d57dfefb446d909b$var$M = /^<([^ >]+:\/[^ >]+)>/, $d57dfefb446d909b$var$w = /-([a-z])?/gi, $d57dfefb446d909b$var$D = /^(\|.*)\n(?: *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*))?\n?/, $d57dfefb446d909b$var$F = /^[^\n]+(?:  \n|\n{2,})/, $d57dfefb446d909b$var$P = /^\[([^\]]*)\]:\s+<?([^\s>]+)>?\s*("([^"]*)")?/, $d57dfefb446d909b$var$Z = /^!\[([^\]]*)\] ?\[([^\]]*)\]/, $d57dfefb446d909b$var$N = /^\[([^\]]*)\] ?\[([^\]]*)\]/, $d57dfefb446d909b$var$G = /(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/, $d57dfefb446d909b$var$U = /\t/g, $d57dfefb446d909b$var$V = /(^ *\||\| *$)/g, $d57dfefb446d909b$var$H = /^ *:-+: *$/, $d57dfefb446d909b$var$Q = /^ *:-+ *$/, $d57dfefb446d909b$var$W = /^ *-+: *$/, $d57dfefb446d909b$var$J = function(r) {
    return "(?=[\\s\\S]+?\\1" + (r ? "\\1" : "") + ")";
}, $d57dfefb446d909b$var$K = "((?:\\[.*?\\][([].*?[)\\]]|<.*?>(?:.*?<.*?>)?|`.*?`|\\\\\\1|[\\s\\S])+?)", $d57dfefb446d909b$var$X = RegExp("^([*_])\\1" + $d57dfefb446d909b$var$J(1) + $d57dfefb446d909b$var$K + "\\1\\1(?!\\1)"), $d57dfefb446d909b$var$Y = RegExp("^([*_])" + $d57dfefb446d909b$var$J(0) + $d57dfefb446d909b$var$K + "\\1(?!\\1)"), $d57dfefb446d909b$var$rr = RegExp("^(==)" + $d57dfefb446d909b$var$J(0) + $d57dfefb446d909b$var$K + "\\1"), $d57dfefb446d909b$var$nr = RegExp("^(~~)" + $d57dfefb446d909b$var$J(0) + $d57dfefb446d909b$var$K + "\\1"), $d57dfefb446d909b$var$er = /^(:[a-zA-Z0-9-_]+:)/, $d57dfefb446d909b$var$tr = /^\\([^0-9A-Za-z\s])/, $d57dfefb446d909b$var$ur = /\\([^0-9A-Za-z\s])/g, $d57dfefb446d909b$var$ar = /^[\s\S](?:(?!  \n|[0-9]\.|http)[^=*_~\-\n:<`\\\[!])*/, $d57dfefb446d909b$var$ir = /^\n+/, $d57dfefb446d909b$var$or = /^([ \t]*)/, $d57dfefb446d909b$var$cr = /(?:^|\n)( *)$/, $d57dfefb446d909b$var$fr = "(?:\\d+\\.)", $d57dfefb446d909b$var$lr = "(?:[*+-])";
function $d57dfefb446d909b$var$_r(r) {
    return "( *)(" + (1 === r ? $d57dfefb446d909b$var$fr : $d57dfefb446d909b$var$lr) + ") +";
}
var $d57dfefb446d909b$var$dr = $d57dfefb446d909b$var$_r(1), $d57dfefb446d909b$var$sr = $d57dfefb446d909b$var$_r(2);
function $d57dfefb446d909b$var$pr(r) {
    return RegExp("^" + (1 === r ? $d57dfefb446d909b$var$dr : $d57dfefb446d909b$var$sr));
}
var $d57dfefb446d909b$var$vr = $d57dfefb446d909b$var$pr(1), $d57dfefb446d909b$var$yr = $d57dfefb446d909b$var$pr(2);
function $d57dfefb446d909b$var$hr(r) {
    return RegExp("^" + (1 === r ? $d57dfefb446d909b$var$dr : $d57dfefb446d909b$var$sr) + "[^\\n]*(?:\\n(?!\\1" + (1 === r ? $d57dfefb446d909b$var$fr : $d57dfefb446d909b$var$lr) + " )[^\\n]*)*(\\n|$)", "gm");
}
var $d57dfefb446d909b$var$gr = $d57dfefb446d909b$var$hr(1), $d57dfefb446d909b$var$mr = $d57dfefb446d909b$var$hr(2);
function $d57dfefb446d909b$var$kr(r) {
    var n = 1 === r ? $d57dfefb446d909b$var$fr : $d57dfefb446d909b$var$lr;
    return RegExp("^( *)(" + n + ") [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1" + n + " (?!" + n + " ))\\n*|\\s*\\n*$)");
}
var $d57dfefb446d909b$var$xr = $d57dfefb446d909b$var$kr(1), $d57dfefb446d909b$var$qr = $d57dfefb446d909b$var$kr(2);
function $d57dfefb446d909b$var$br(r, n) {
    var e = 1 === n, t = e ? $d57dfefb446d909b$var$xr : $d57dfefb446d909b$var$qr, u = e ? $d57dfefb446d909b$var$gr : $d57dfefb446d909b$var$mr, a = e ? $d57dfefb446d909b$var$vr : $d57dfefb446d909b$var$yr;
    return {
        t: function(r) {
            return a.test(r);
        },
        u: $d57dfefb446d909b$var$Cr(function(r, n) {
            var e = $d57dfefb446d909b$var$cr.exec(n.prevCapture);
            return e && (n.list || !n.inline && !n.simple) ? t.exec(r = e[1] + r) : null;
        }),
        i: 1,
        o: function(r, n, t) {
            var i = e ? +r[2] : void 0, o = r[0].replace($d57dfefb446d909b$var$l, "\n").match(u), c = !1;
            return {
                items: o.map(function(r, e) {
                    var u = a.exec(r)[0].length, i = RegExp("^ {1," + u + "}", "gm"), f = r.replace(i, "").replace(a, ""), l = e === o.length - 1, _ = -1 !== f.indexOf("\n\n") || l && c;
                    c = _;
                    var d, s = t.inline, p = t.list;
                    t.list = !0, _ ? (t.inline = !1, d = $d57dfefb446d909b$var$$r(f) + "\n\n") : (t.inline = !0, d = $d57dfefb446d909b$var$$r(f));
                    var v = n(d, t);
                    return t.inline = s, t.list = p, v;
                }),
                ordered: e,
                start: i
            };
        },
        l: function(n, e, t) {
            return r(n.ordered ? "ol" : "ul", {
                key: t.key,
                start: "20" === n.type ? n.start : void 0
            }, n.items.map(function(n, u) {
                return r("li", {
                    key: u
                }, e(n, t));
            }));
        }
    };
}
var $d57dfefb446d909b$var$Sr = RegExp("^\\[((?:\\[[^\\[\\]]*(?:\\[[^\\[\\]]*\\][^\\[\\]]*)*\\]|[^\\[\\]])*)\\]\\(\\s*<?((?:\\([^)]*\\)|[^\\s\\\\]|\\\\.)*?)>?(?:\\s+['\"]([\\s\\S]*?)['\"])?\\s*\\)"), $d57dfefb446d909b$var$zr = /^!\[(.*?)\]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/;
function $d57dfefb446d909b$var$$r(r) {
    for(var n = r.length; n > 0 && r[n - 1] <= " ";)n--;
    return r.slice(0, n);
}
function $d57dfefb446d909b$var$Er(r, n) {
    return r.startsWith(n);
}
function $d57dfefb446d909b$var$Ar(r, n, e) {
    if (Array.isArray(e)) {
        for(var t = 0; t < e.length; t++)if ($d57dfefb446d909b$var$Er(r, e[t])) return !0;
        return !1;
    }
    return e(r, n);
}
function $d57dfefb446d909b$export$c383cdd2a518017a(r) {
    return r.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g, "a").replace(/[çÇ]/g, "c").replace(/[ðÐ]/g, "d").replace(/[ÈÉÊËéèêë]/g, "e").replace(/[ÏïÎîÍíÌì]/g, "i").replace(/[Ññ]/g, "n").replace(/[øØœŒÕõÔôÓóÒò]/g, "o").replace(/[ÜüÛûÚúÙù]/g, "u").replace(/[ŸÿÝý]/g, "y").replace(/[^a-z0-9- ]/gi, "").replace(/ /gi, "-").toLowerCase();
}
function $d57dfefb446d909b$var$Br(r) {
    return $d57dfefb446d909b$var$W.test(r) ? "right" : $d57dfefb446d909b$var$H.test(r) ? "center" : $d57dfefb446d909b$var$Q.test(r) ? "left" : null;
}
function $d57dfefb446d909b$var$Lr(r, n, e, t) {
    var u = e.inTable;
    e.inTable = !0;
    var a = [
        []
    ], i = "";
    function o() {
        if (i) {
            var r = a[a.length - 1];
            r.push.apply(r, n(i, e)), i = "";
        }
    }
    return r.trim().split(/(`[^`]*`|\\\||\|)/).filter(Boolean).forEach(function(r, n, e) {
        "|" === r.trim() && (o(), t) ? 0 !== n && n !== e.length - 1 && a.push([]) : i += r;
    }), o(), e.inTable = u, a;
}
function $d57dfefb446d909b$var$Or(r, n, e) {
    e.inline = !0;
    var t = r[2] ? r[2].replace($d57dfefb446d909b$var$V, "").split("|").map($d57dfefb446d909b$var$Br) : [], u = r[3] ? function(r, n, e) {
        return r.trim().split("\n").map(function(r) {
            return $d57dfefb446d909b$var$Lr(r, n, e, !0);
        });
    }(r[3], n, e) : [], a = $d57dfefb446d909b$var$Lr(r[1], n, e, !!u.length);
    return e.inline = !1, u.length ? {
        align: t,
        cells: u,
        header: a,
        type: "25"
    } : {
        children: a,
        type: "21"
    };
}
function $d57dfefb446d909b$var$jr(r, n) {
    return null == r.align[n] ? {} : {
        textAlign: r.align[n]
    };
}
function $d57dfefb446d909b$var$Cr(r) {
    return r.inline = 1, r;
}
function $d57dfefb446d909b$var$Ir(r) {
    return $d57dfefb446d909b$var$Cr(function(n, e) {
        return e.inline ? r.exec(n) : null;
    });
}
function $d57dfefb446d909b$var$Tr(r) {
    return $d57dfefb446d909b$var$Cr(function(n, e) {
        return e.inline || e.simple ? r.exec(n) : null;
    });
}
function $d57dfefb446d909b$var$Mr(r) {
    return function(n, e) {
        return e.inline || e.simple ? null : r.exec(n);
    };
}
function $d57dfefb446d909b$var$wr(r) {
    return $d57dfefb446d909b$var$Cr(function(n) {
        return r.exec(n);
    });
}
var $d57dfefb446d909b$var$Dr = /(javascript|vbscript|data(?!:image)):/i;
function $d57dfefb446d909b$export$3e2338ea76b578c9(r) {
    try {
        var n = decodeURIComponent(r).replace(/[^A-Za-z0-9/:]/g, "");
        if ($d57dfefb446d909b$var$Dr.test(n)) return null;
    } catch (r) {
        return null;
    }
    return r;
}
function $d57dfefb446d909b$var$Pr(r) {
    return r ? r.replace($d57dfefb446d909b$var$ur, "$1") : r;
}
function $d57dfefb446d909b$var$Zr(r, n, e) {
    var t = e.inline || !1, u = e.simple || !1;
    e.inline = !0, e.simple = !0;
    var a = r(n, e);
    return e.inline = t, e.simple = u, a;
}
function $d57dfefb446d909b$var$Nr(r, n, e) {
    var t = e.inline || !1, u = e.simple || !1;
    e.inline = !1, e.simple = !0;
    var a = r(n, e);
    return e.inline = t, e.simple = u, a;
}
function $d57dfefb446d909b$var$Gr(r, n, e) {
    var t = e.inline || !1;
    e.inline = !1;
    var u = r(n, e);
    return e.inline = t, u;
}
var $d57dfefb446d909b$var$Ur = function(r, n, e) {
    return {
        children: $d57dfefb446d909b$var$Zr(n, r[2], e)
    };
};
function $d57dfefb446d909b$var$Vr() {
    return {};
}
function $d57dfefb446d909b$var$Hr() {
    return null;
}
function $d57dfefb446d909b$var$Qr() {
    return [].slice.call(arguments).filter(Boolean).join(" ");
}
function $d57dfefb446d909b$var$Wr(r, n, e) {
    for(var t = r, u = n.split("."); u.length && void 0 !== (t = t[u[0]]);)u.shift();
    return t || e;
}
function $d57dfefb446d909b$var$Jr(r, n) {
    var e = $d57dfefb446d909b$var$Wr(n, r);
    return e ? "function" == typeof e || "object" == typeof e && "render" in e ? e : $d57dfefb446d909b$var$Wr(n, r + ".component", r) : r;
}
function $d57dfefb446d909b$export$69f434acfbdb0b32(e, t) {
    var l;
    void 0 === e && (e = ""), void 0 === t && (t = {}), t.overrides = t.overrides || {}, t.namedCodesToUnicode = t.namedCodesToUnicode ? $d57dfefb446d909b$var$n({}, $d57dfefb446d909b$var$a, t.namedCodesToUnicode) : $d57dfefb446d909b$var$a;
    var V = t.slugify || $d57dfefb446d909b$export$c383cdd2a518017a, H = t.sanitizer || $d57dfefb446d909b$export$3e2338ea76b578c9, Q = t.createElement || $tZqWC.createElement, W = [
        $d57dfefb446d909b$var$_,
        $d57dfefb446d909b$var$y,
        $d57dfefb446d909b$var$h,
        t.enforceAtxHeadings ? $d57dfefb446d909b$var$E : $d57dfefb446d909b$var$$,
        $d57dfefb446d909b$var$A,
        $d57dfefb446d909b$var$D,
        $d57dfefb446d909b$var$xr,
        $d57dfefb446d909b$var$qr
    ], J = [].concat(W, [
        $d57dfefb446d909b$var$F,
        $d57dfefb446d909b$var$R,
        $d57dfefb446d909b$var$L,
        $d57dfefb446d909b$var$j
    ]);
    function K(r, e) {
        var u = $d57dfefb446d909b$var$Wr(t.overrides, r + ".props", {});
        return Q.apply(void 0, [
            $d57dfefb446d909b$var$Jr(r, t.overrides),
            $d57dfefb446d909b$var$n({}, e, u, {
                className: $d57dfefb446d909b$var$Qr(null == e ? void 0 : e.className, u.className) || void 0
            })
        ].concat([].slice.call(arguments, 2)));
    }
    function ur(r) {
        r = r.replace($d57dfefb446d909b$var$S, "");
        var n = !1;
        t.forceInline ? n = !0 : t.forceBlock || (n = !1 === $d57dfefb446d909b$var$G.test(r));
        for(var e = pr(sr(n ? r : $d57dfefb446d909b$var$$r(r).replace($d57dfefb446d909b$var$ir, "") + "\n\n", {
            inline: n
        })); "string" == typeof e[e.length - 1] && !e[e.length - 1].trim();)e.pop();
        if (null === t.wrapper) return e;
        var u, a = t.wrapper || (n ? "span" : "div");
        if (e.length > 1 || t.forceWrapper) u = e;
        else {
            if (1 === e.length) return "string" == typeof (u = e[0]) ? K("span", {
                key: "outer"
            }, u) : u;
            u = null;
        }
        return Q(a, {
            key: "outer"
        }, u);
    }
    function cr(r, n) {
        if (!n || !n.trim()) return null;
        var e = n.match($d57dfefb446d909b$var$c);
        return e ? e.reduce(function(n, e) {
            var t = e.indexOf("=");
            if (-1 !== t) {
                var a = (function(r) {
                    return -1 !== r.indexOf("-") && null === r.match($d57dfefb446d909b$var$O) && (r = r.replace($d57dfefb446d909b$var$w, function(r, n) {
                        return n.toUpperCase();
                    })), r;
                })(e.slice(0, t)).trim(), i = function(r) {
                    var n = r[0];
                    return ('"' === n || "'" === n) && r.length >= 2 && r[r.length - 1] === n ? r.slice(1, -1) : r;
                }(e.slice(t + 1).trim()), c = $d57dfefb446d909b$var$u[a] || a;
                if ("ref" === c) return n;
                var f = n[c] = function(r, n, e, t) {
                    return "style" === n ? (function(r) {
                        var n = [], e = "", t = !1, u = !1, a = "";
                        if (!r) return n;
                        for(var i = 0; i < r.length; i++){
                            var o = r[i];
                            if ('"' !== o && "'" !== o || t || (u ? o === a && (u = !1, a = "") : (u = !0, a = o)), "(" === o && e.endsWith("url") ? t = !0 : ")" === o && t && (t = !1), ";" !== o || u || t) e += o;
                            else {
                                var c = e.trim();
                                if (c) {
                                    var f = c.indexOf(":");
                                    if (f > 0) {
                                        var l = c.slice(0, f).trim(), _ = c.slice(f + 1).trim();
                                        n.push([
                                            l,
                                            _
                                        ]);
                                    }
                                }
                                e = "";
                            }
                        }
                        var d = e.trim();
                        if (d) {
                            var s = d.indexOf(":");
                            if (s > 0) {
                                var p = d.slice(0, s).trim(), v = d.slice(s + 1).trim();
                                n.push([
                                    p,
                                    v
                                ]);
                            }
                        }
                        return n;
                    })(e).reduce(function(n, e) {
                        var u = e[0], a = e[1];
                        return n[u.replace(/(-[a-z])/g, function(r) {
                            return r[1].toUpperCase();
                        })] = t(a, r, u), n;
                    }, {}) : -1 !== $d57dfefb446d909b$var$o.indexOf(n) ? t($d57dfefb446d909b$var$Pr(e), r, n) : (e.match($d57dfefb446d909b$var$C) && (e = $d57dfefb446d909b$var$Pr(e.slice(1, e.length - 1))), "true" === e || "false" !== e && e);
                }(r, a, i, H);
                "string" == typeof f && ($d57dfefb446d909b$var$R.test(f) || $d57dfefb446d909b$var$j.test(f)) && (n[c] = ur(f.trim()));
            } else "style" !== e && (n[$d57dfefb446d909b$var$u[e] || e] = !0);
            return n;
        }, {}) : null;
    }
    var fr = [], lr = {}, _r = ((l = {})[0] = {
        t: [
            ">"
        ],
        u: $d57dfefb446d909b$var$Mr($d57dfefb446d909b$var$_),
        i: 1,
        o: function(r, n, e) {
            var t = r[0].replace($d57dfefb446d909b$var$d, "").match($d57dfefb446d909b$var$s);
            return {
                alert: t[1],
                children: n(t[2], e)
            };
        },
        l: function(r, n, e) {
            var t = {
                key: e.key
            };
            return r.alert && (t.className = "markdown-alert-" + V(r.alert.toLowerCase(), $d57dfefb446d909b$export$c383cdd2a518017a), r.children.unshift({
                attrs: {},
                children: [
                    {
                        type: "27",
                        text: r.alert
                    }
                ],
                noInnerParse: !0,
                type: "11",
                tag: "header"
            })), K("blockquote", t, n(r.children, e));
        }
    }, l[1] = {
        u: $d57dfefb446d909b$var$wr($d57dfefb446d909b$var$p),
        i: 1,
        o: $d57dfefb446d909b$var$Vr,
        l: function(r, n, e) {
            return K("br", {
                key: e.key
            });
        }
    }, l[2] = {
        t: function(r) {
            var n = r[0];
            return "-" === n || "*" === n || "_" === n;
        },
        u: $d57dfefb446d909b$var$Mr($d57dfefb446d909b$var$v),
        i: 1,
        o: $d57dfefb446d909b$var$Vr,
        l: function(r, n, e) {
            return K("hr", {
                key: e.key
            });
        }
    }, l[3] = {
        t: [
            "    "
        ],
        u: $d57dfefb446d909b$var$Mr($d57dfefb446d909b$var$h),
        i: 0,
        o: function(r) {
            return {
                lang: void 0,
                text: $d57dfefb446d909b$var$Pr($d57dfefb446d909b$var$$r(r[0].replace(/^ {4}/gm, "")))
            };
        },
        l: function(r, e, t) {
            return K("pre", {
                key: t.key
            }, K("code", $d57dfefb446d909b$var$n({}, r.attrs, {
                className: r.lang ? "lang-" + r.lang : ""
            }), r.text));
        }
    }, l[4] = {
        t: [
            "```",
            "~~~"
        ],
        u: $d57dfefb446d909b$var$Mr($d57dfefb446d909b$var$y),
        i: 0,
        o: function(r) {
            return {
                attrs: cr("code", r[3] || ""),
                lang: r[2] || void 0,
                text: r[4],
                type: "3"
            };
        }
    }, l[5] = {
        t: [
            "`"
        ],
        u: $d57dfefb446d909b$var$Tr($d57dfefb446d909b$var$g),
        i: 3,
        o: function(r) {
            return {
                text: $d57dfefb446d909b$var$Pr(r[2])
            };
        },
        l: function(r, n, e) {
            return K("code", {
                key: e.key
            }, r.text);
        }
    }, l[6] = {
        t: [
            "[^"
        ],
        u: $d57dfefb446d909b$var$Mr($d57dfefb446d909b$var$x),
        i: 0,
        o: function(r) {
            return fr.push({
                footnote: r[2],
                identifier: r[1]
            }), {};
        },
        l: $d57dfefb446d909b$var$Hr
    }, l[7] = {
        t: [
            "[^"
        ],
        u: $d57dfefb446d909b$var$Ir($d57dfefb446d909b$var$q),
        i: 1,
        o: function(r) {
            return {
                target: "#" + V(r[1], $d57dfefb446d909b$export$c383cdd2a518017a),
                text: r[1]
            };
        },
        l: function(r, n, e) {
            return K("a", {
                key: e.key,
                href: H(r.target, "a", "href")
            }, K("sup", {
                key: e.key
            }, r.text));
        }
    }, l[8] = {
        t: [
            "[ ]",
            "[x]"
        ],
        u: $d57dfefb446d909b$var$Ir($d57dfefb446d909b$var$z),
        i: 1,
        o: function(r) {
            return {
                completed: "x" === r[1].toLowerCase()
            };
        },
        l: function(r, n, e) {
            return K("input", {
                checked: r.completed,
                key: e.key,
                readOnly: !0,
                type: "checkbox"
            });
        }
    }, l[9] = {
        t: [
            "#"
        ],
        u: $d57dfefb446d909b$var$Mr(t.enforceAtxHeadings ? $d57dfefb446d909b$var$E : $d57dfefb446d909b$var$$),
        i: 1,
        o: function(r, n, e) {
            return {
                children: $d57dfefb446d909b$var$Zr(n, r[2], e),
                id: V(r[2], $d57dfefb446d909b$export$c383cdd2a518017a),
                level: r[1].length
            };
        },
        l: function(r, n, e) {
            return K("h" + r.level, {
                id: r.id,
                key: e.key
            }, n(r.children, e));
        }
    }, l[10] = {
        u: $d57dfefb446d909b$var$Mr($d57dfefb446d909b$var$A),
        i: 0,
        o: function(r, n, e) {
            return {
                children: $d57dfefb446d909b$var$Zr(n, r[1], e),
                level: "=" === r[2] ? 1 : 2,
                type: "9"
            };
        }
    }, l[11] = {
        t: [
            "<"
        ],
        u: $d57dfefb446d909b$var$wr($d57dfefb446d909b$var$R),
        i: 1,
        o: function(r, n, e) {
            var t, u = r[3].match($d57dfefb446d909b$var$or), a = RegExp("^" + u[1], "gm"), o = r[3].replace(a, ""), c = (t = o, J.some(function(r) {
                return r.test(t);
            }) ? $d57dfefb446d909b$var$Gr : $d57dfefb446d909b$var$Zr), f = r[1].toLowerCase(), l = -1 !== $d57dfefb446d909b$var$i.indexOf(f), _ = (l ? f : r[1]).trim(), d = {
                attrs: cr(_, r[2]),
                noInnerParse: l,
                tag: _
            };
            if (e.inAnchor = e.inAnchor || "a" === f, l) d.text = r[3];
            else {
                var s = e.inHTML;
                e.inHTML = !0, d.children = c(n, o, e), e.inHTML = s;
            }
            return e.inAnchor = !1, d;
        },
        l: function(r, e, t) {
            return K(r.tag, $d57dfefb446d909b$var$n({
                key: t.key
            }, r.attrs), r.text || (r.children ? e(r.children, t) : ""));
        }
    }, l[13] = {
        t: [
            "<"
        ],
        u: $d57dfefb446d909b$var$wr($d57dfefb446d909b$var$j),
        i: 1,
        o: function(r) {
            var n = r[1].trim();
            return {
                attrs: cr(n, r[2] || ""),
                tag: n
            };
        },
        l: function(r, e, t) {
            return K(r.tag, $d57dfefb446d909b$var$n({}, r.attrs, {
                key: t.key
            }));
        }
    }, l[12] = {
        t: [
            "\x3c!--"
        ],
        u: $d57dfefb446d909b$var$wr($d57dfefb446d909b$var$L),
        i: 1,
        o: function() {
            return {};
        },
        l: $d57dfefb446d909b$var$Hr
    }, l[14] = {
        t: [
            "!["
        ],
        u: $d57dfefb446d909b$var$Tr($d57dfefb446d909b$var$zr),
        i: 1,
        o: function(r) {
            return {
                alt: $d57dfefb446d909b$var$Pr(r[1]),
                target: $d57dfefb446d909b$var$Pr(r[2]),
                title: $d57dfefb446d909b$var$Pr(r[3])
            };
        },
        l: function(r, n, e) {
            return K("img", {
                key: e.key,
                alt: r.alt || void 0,
                title: r.title || void 0,
                src: H(r.target, "img", "src")
            });
        }
    }, l[15] = {
        t: [
            "["
        ],
        u: $d57dfefb446d909b$var$Ir($d57dfefb446d909b$var$Sr),
        i: 3,
        o: function(r, n, e) {
            return {
                children: $d57dfefb446d909b$var$Nr(n, r[1], e),
                target: $d57dfefb446d909b$var$Pr(r[2]),
                title: $d57dfefb446d909b$var$Pr(r[3])
            };
        },
        l: function(r, n, e) {
            return K("a", {
                key: e.key,
                href: H(r.target, "a", "href"),
                title: r.title
            }, n(r.children, e));
        }
    }, l[16] = {
        t: [
            "<"
        ],
        u: $d57dfefb446d909b$var$Ir($d57dfefb446d909b$var$M),
        i: 0,
        o: function(r) {
            return {
                children: [
                    {
                        text: r[1],
                        type: "27"
                    }
                ],
                target: r[1],
                type: "15"
            };
        }
    }, l[17] = {
        t: function(r, n) {
            return !n.inAnchor && !t.disableAutoLink && ($d57dfefb446d909b$var$Er(r, "http://") || $d57dfefb446d909b$var$Er(r, "https://"));
        },
        u: $d57dfefb446d909b$var$Ir($d57dfefb446d909b$var$I),
        i: 0,
        o: function(r) {
            return {
                children: [
                    {
                        text: r[1],
                        type: "27"
                    }
                ],
                target: r[1],
                title: void 0,
                type: "15"
            };
        }
    }, l[18] = {
        t: [
            "<"
        ],
        u: $d57dfefb446d909b$var$Ir($d57dfefb446d909b$var$T),
        i: 0,
        o: function(r) {
            var n = r[1], e = r[1];
            return $d57dfefb446d909b$var$f.test(e) || (e = "mailto:" + e), {
                children: [
                    {
                        text: n.replace("mailto:", ""),
                        type: "27"
                    }
                ],
                target: e,
                type: "15"
            };
        }
    }, l[20] = $d57dfefb446d909b$var$br(K, 1), l[33] = $d57dfefb446d909b$var$br(K, 2), l[19] = {
        u: $d57dfefb446d909b$var$Mr($d57dfefb446d909b$var$m),
        i: 3,
        o: $d57dfefb446d909b$var$Vr,
        l: function() {
            return "\n";
        }
    }, l[21] = {
        u: $d57dfefb446d909b$var$Cr(function(r, n) {
            if (n.inline || n.simple || n.inHTML && -1 === r.indexOf("\n\n") && -1 === n.prevCapture.indexOf("\n\n")) return null;
            var e = "";
            r.split("\n").every(function(r) {
                return r += "\n", !W.some(function(n) {
                    return n.test(r);
                }) && (e += r, !!r.trim());
            });
            var t = $d57dfefb446d909b$var$$r(e);
            return "" === t ? null : [
                e,
                ,
                t
            ];
        }),
        i: 3,
        o: $d57dfefb446d909b$var$Ur,
        l: function(r, n, e) {
            return K("p", {
                key: e.key
            }, n(r.children, e));
        }
    }, l[22] = {
        t: [
            "["
        ],
        u: $d57dfefb446d909b$var$Ir($d57dfefb446d909b$var$P),
        i: 0,
        o: function(r) {
            return lr[r[1]] = {
                target: r[2],
                title: r[4]
            }, {};
        },
        l: $d57dfefb446d909b$var$Hr
    }, l[23] = {
        t: [
            "!["
        ],
        u: $d57dfefb446d909b$var$Tr($d57dfefb446d909b$var$Z),
        i: 0,
        o: function(r) {
            return {
                alt: r[1] ? $d57dfefb446d909b$var$Pr(r[1]) : void 0,
                ref: r[2]
            };
        },
        l: function(r, n, e) {
            return lr[r.ref] ? K("img", {
                key: e.key,
                alt: r.alt,
                src: H(lr[r.ref].target, "img", "src"),
                title: lr[r.ref].title
            }) : null;
        }
    }, l[24] = {
        t: function(r) {
            return "[" === r[0] && -1 === r.indexOf("](");
        },
        u: $d57dfefb446d909b$var$Ir($d57dfefb446d909b$var$N),
        i: 0,
        o: function(r, n, e) {
            return {
                children: n(r[1], e),
                fallbackChildren: r[0],
                ref: r[2]
            };
        },
        l: function(r, n, e) {
            return lr[r.ref] ? K("a", {
                key: e.key,
                href: H(lr[r.ref].target, "a", "href"),
                title: lr[r.ref].title
            }, n(r.children, e)) : K("span", {
                key: e.key
            }, r.fallbackChildren);
        }
    }, l[25] = {
        t: [
            "|"
        ],
        u: $d57dfefb446d909b$var$Mr($d57dfefb446d909b$var$D),
        i: 1,
        o: $d57dfefb446d909b$var$Or,
        l: function(r, n, e) {
            var t = r;
            return K("table", {
                key: e.key
            }, K("thead", null, K("tr", null, t.header.map(function(r, u) {
                return K("th", {
                    key: u,
                    style: $d57dfefb446d909b$var$jr(t, u)
                }, n(r, e));
            }))), K("tbody", null, t.cells.map(function(r, u) {
                return K("tr", {
                    key: u
                }, r.map(function(r, u) {
                    return K("td", {
                        key: u,
                        style: $d57dfefb446d909b$var$jr(t, u)
                    }, n(r, e));
                }));
            })));
        }
    }, l[27] = {
        u: $d57dfefb446d909b$var$Cr(function(r, n) {
            var e;
            return $d57dfefb446d909b$var$Er(r, ":") && (e = $d57dfefb446d909b$var$er.exec(r)), e || $d57dfefb446d909b$var$ar.exec(r);
        }),
        i: 4,
        o: function(r) {
            var n = r[0];
            return {
                text: -1 === n.indexOf("&") ? n : n.replace($d57dfefb446d909b$var$B, function(r, n) {
                    return t.namedCodesToUnicode[n] || r;
                })
            };
        },
        l: function(r) {
            return r.text;
        }
    }, l[28] = {
        t: [
            "**",
            "__"
        ],
        u: $d57dfefb446d909b$var$Tr($d57dfefb446d909b$var$X),
        i: 2,
        o: function(r, n, e) {
            return {
                children: n(r[2], e)
            };
        },
        l: function(r, n, e) {
            return K("strong", {
                key: e.key
            }, n(r.children, e));
        }
    }, l[29] = {
        t: function(r) {
            var n = r[0];
            return ("*" === n || "_" === n) && r[1] !== n;
        },
        u: $d57dfefb446d909b$var$Tr($d57dfefb446d909b$var$Y),
        i: 3,
        o: function(r, n, e) {
            return {
                children: n(r[2], e)
            };
        },
        l: function(r, n, e) {
            return K("em", {
                key: e.key
            }, n(r.children, e));
        }
    }, l[30] = {
        t: [
            "\\"
        ],
        u: $d57dfefb446d909b$var$Tr($d57dfefb446d909b$var$tr),
        i: 1,
        o: function(r) {
            return {
                text: r[1],
                type: "27"
            };
        }
    }, l[31] = {
        t: [
            "=="
        ],
        u: $d57dfefb446d909b$var$Tr($d57dfefb446d909b$var$rr),
        i: 3,
        o: $d57dfefb446d909b$var$Ur,
        l: function(r, n, e) {
            return K("mark", {
                key: e.key
            }, n(r.children, e));
        }
    }, l[32] = {
        t: [
            "~~"
        ],
        u: $d57dfefb446d909b$var$Tr($d57dfefb446d909b$var$nr),
        i: 3,
        o: $d57dfefb446d909b$var$Ur,
        l: function(r, n, e) {
            return K("del", {
                key: e.key
            }, n(r.children, e));
        }
    }, l);
    !0 === t.disableParsingRawHTML && (delete _r[11], delete _r[13]);
    var dr, sr = function(r) {
        var n = Object.keys(r);
        function e(t, u) {
            var a = [];
            if (u.prevCapture = u.prevCapture || "", t.trim()) for(; t;)for(var i = 0; i < n.length;){
                var o = n[i], c = r[o];
                if (!c.t || $d57dfefb446d909b$var$Ar(t, u, c.t)) {
                    var f = c.u(t, u);
                    if (f && f[0]) {
                        t = t.substring(f[0].length);
                        var l = c.o(f, e, u);
                        u.prevCapture += f[0], l.type || (l.type = o), a.push(l);
                        break;
                    }
                    i++;
                } else i++;
            }
            return u.prevCapture = "", a;
        }
        return n.sort(function(n, e) {
            return r[n].i - r[e].i || (n < e ? -1 : 1);
        }), function(r, n) {
            return e(function(r) {
                return r.replace($d57dfefb446d909b$var$k, "\n").replace($d57dfefb446d909b$var$b, "").replace($d57dfefb446d909b$var$U, "    ");
            }(r), n);
        };
    }(_r), pr = (dr = function(r, n) {
        return function(e, t, u) {
            var a = r[e.type].l;
            return n ? n(function() {
                return a(e, t, u);
            }, e, t, u) : a(e, t, u);
        };
    }(_r, t.renderRule), function r(n, e) {
        if (void 0 === e && (e = {}), Array.isArray(n)) {
            for(var t = e.key, u = [], a = !1, i = 0; i < n.length; i++){
                e.key = i;
                var o = r(n[i], e), c = "string" == typeof o;
                c && a ? u[u.length - 1] += o : null !== o && u.push(o), a = c;
            }
            return e.key = t, u;
        }
        return dr(n, r, e);
    }), vr = ur(e);
    return fr.length ? K("div", null, vr, K("footer", {
        key: "footer"
    }, fr.map(function(r) {
        return K("div", {
            id: V(r.identifier, $d57dfefb446d909b$export$c383cdd2a518017a),
            key: r.identifier
        }, r.identifier, pr(sr(r.footnote, {
            inline: !0
        })));
    }))) : vr;
}
function $d57dfefb446d909b$export$2e2bcd8739ae039(n) {
    var t = n.children, u = void 0 === t ? "" : t, a = n.options, i = function(r, n) {
        if (null == r) return {};
        var e, t, u = {}, a = Object.keys(r);
        for(t = 0; t < a.length; t++)n.indexOf(e = a[t]) >= 0 || (u[e] = r[e]);
        return u;
    }(n, $d57dfefb446d909b$var$e);
    return $tZqWC.cloneElement($d57dfefb446d909b$export$69f434acfbdb0b32(u, a), i);
}




const $abf0b20840b25b18$export$e6dfd72ab29f8598 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  width: 100%;
  display: flex;
  justify-content: ${({ role: role })=>role === 'ai' ? 'flex-start' : 'flex-end'};
  padding: ${({ role: role })=>role === 'ai' ? '0 80px 0 0' : '0 0 0 80px'};
`;
const $abf0b20840b25b18$export$42a852a2b6b56249 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: fit-content;
  max-width: 800px;
  padding: 10px 14px;
  border-radius: ${({ role: role })=>role === 'ai' ? '14px 14px 14px 3px' : '14px 14px 3px 14px'};
  color: ${({ theme: theme })=>theme.colors.primary};
  background-color: ${({ theme: theme, role: role })=>role === 'ai' ? theme.colors.backgroundLite : theme.colors.background};
  border: 0.5px solid
    ${({ theme: theme, role: role })=>role === 'ai' ? `${theme.colors.secondary}30` : `${theme.colors.secondary}50`};
  font-size: 15px;
  word-wrap: break-word;

  & p {
    margin: 0.3em 0;
    &:first-child {
      margin-top: 0;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }

  & strong {
    font-weight: 500;
  }

  & h1,
  & h2,
  & h3,
  & h4,
  & h5,
  & h6 {
    font-weight: 500;
    margin: 20px 12px 0px 0;
    &:first-child {
      margin-top: 0;
    }
  }

  & em {
    font-style: italic;
  }

  & code {
    font-family: 'DM Mono', 'Fira Code', monospace;
    font-size: 12px;
    background-color: ${({ theme: theme })=>theme.colors.background};
    border: 0.5px solid ${({ theme: theme })=>`${theme.colors.secondary}30`};
    color: ${({ theme: theme })=>theme.colors.primary};
    padding: 2px 4px;
    border-radius: 4px;

    white-space: pre-wrap;
    overflow-wrap: anywhere;
  }

  & pre {
    background-color: ${({ theme: theme })=>theme.colors.background};
    border: 0.5px solid ${({ theme: theme })=>`${theme.colors.secondary}30`};
    border-radius: 8px;
    padding: 10px 12px;
    font-family: 'DM Mono', 'Fira Code', monospace;
    font-size: 12px;
    margin: 0.6em 0;

    /* ✅ FIX WRAPPING */
    white-space: pre-wrap; /* allows wrapping */
    word-break: break-word; /* breaks long tokens */
    overflow-wrap: anywhere; /* strongest fallback */

    overflow-x: auto;
  }

  & pre code {
    background: none;
    border: none;
    padding: 0;
    color: ${({ theme: theme })=>theme.colors.primary};
  }

  & ul,
  & ol {
    margin: 8px 0 8px 28px;
    padding: 0;
  }

  & li {
    margin: 6px 0;
  }

  & a {
    color: ${({ theme: theme })=>theme.colors.primary};
    text-decoration: underline;
    text-underline-offset: 2px;
    &:hover {
      opacity: 0.7;
    }
  }

  & blockquote {
    border-left: 2px solid ${({ theme: theme })=>`${theme.colors.secondary}60`};
    padding-left: 12px;
    margin: 0.5em 0;
    color: ${({ theme: theme })=>theme.colors.secondaryDark};
    font-style: italic;
    border-radius: 0;
  }

  & hr {
    border: none;
    border-top: 0.5px solid ${({ theme: theme })=>`${theme.colors.secondary}30`};
    margin: 1em 0;
  }

  & table {
    width: 100%;
    border-collapse: collapse;
    margin: 15px 0;
    font-size: 14px;
    border-radius: 10px;
    overflow: hidden;
    border: 0.5px solid ${({ theme: theme })=>`${theme.colors.secondary}30`};
  }

  & th {
    background-color: ${({ theme: theme })=>theme.colors.backgroundLite};
    color: ${({ theme: theme })=>theme.colors.primary};
    padding: 8px 10px;
    text-align: left;
    font-weight: 500;
    font-size: 14px;
    border-bottom: 0.5px solid ${({ theme: theme })=>`${theme.colors.secondary}30`};
  }

  & td {
    padding: 7px 10px;
    border-bottom: 0.5px solid ${({ theme: theme })=>`${theme.colors.secondary}20`};
    background-color: ${({ theme: theme })=>theme.colors.background};
    font-size: 14px;
  }

  & tr:last-child td {
    border-bottom: none;
  }
`;
const $abf0b20840b25b18$var$blink = (0, $a778141486c79bc3$export$d25ddfdf17c3ad3e)`
  0%, 100% { opacity: 1; }
  50% { opacity: 0; }
`;
const $abf0b20840b25b18$export$b6a79797ad180576 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).span`
  display: inline-block;
  width: 2px;
  height: 0.85em;
  background-color: ${({ theme: theme })=>theme?.colors?.primary};
  margin-left: 2px;
  animation: ${$abf0b20840b25b18$var$blink} 1s step-start infinite;
  vertical-align: text-bottom;
  border-radius: 1px;
  opacity: 0.7;
`;


// Map Redux Props
const $50e89faacc1bbfa3$var$mapStateToProps = (state)=>state;
const $50e89faacc1bbfa3$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $50e89faacc1bbfa3$var$AICatalystMessage(props) {
    // Destructure
    const { message: message } = props;
    const { role: role, content: content } = message;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $abf0b20840b25b18$export$e6dfd72ab29f8598), {
        role: role,
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $abf0b20840b25b18$export$42a852a2b6b56249), {
            role: role,
            children: [
                role === 'ai' && !content && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $abf0b20840b25b18$export$b6a79797ad180576), {}),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d57dfefb446d909b$export$2e2bcd8739ae039), {
                    children: content
                })
            ]
        })
    });
}
// Default Props
$50e89faacc1bbfa3$var$AICatalystMessage.defaultProps = {
    message: {}
};
// Proptypes Validation
$50e89faacc1bbfa3$var$AICatalystMessage.propTypes = {
    message: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        role: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        content: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    })
};
var $50e89faacc1bbfa3$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($50e89faacc1bbfa3$var$mapStateToProps, $50e89faacc1bbfa3$var$mapDispatchToProps)($50e89faacc1bbfa3$var$AICatalystMessage);


var $9f708ca589f0e5cb$export$2e2bcd8739ae039 = (0, $50e89faacc1bbfa3$export$2e2bcd8739ae039);


/* eslint-disable max-len */ /* eslint-disable react/no-array-index-key */ 

var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");





const $0746788b5b935b60$export$e6dfd72ab29f8598 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: fixed;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 30px;
  ${({ centered: centered })=>centered && 'bottom: 50%; transform: translateY(40%);'};
  ${({ centered: centered })=>!centered && 'bottom: 40px;'};
  left: 0;

  width: 100%;
  padding-left: 100px;

  & form {
    width: 100%;
    display: flex;
    justify-content: center;
  }
`;
const $0746788b5b935b60$export$bc7adc8ef74607f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  max-width: 800px;
  flex-wrap: wrap;

  & button {
    padding: 8px 24px;
    border-radius: 12px;
    border: 1px solid ${({ theme: theme })=>`${theme.colors.secondary}50`};
  }
`;
const $0746788b5b935b60$export$a9754b3c8daa5172 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: flex-start; 
`;
const $0746788b5b935b60$export$d747b2abe71e53f5 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column; 
  max-width: 800px;
`;
const $0746788b5b935b60$export$f99233281efd08a0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding-right: 30px;

  font-size: 24px;
  font-weight: 600;
  color: ${({ theme: theme })=>`${theme.colors.primary}`};
`;
const $0746788b5b935b60$export$5f1af8db9871e1d6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`  
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme: theme })=>`${theme.colors.primary}`};
`;
const $0746788b5b935b60$export$42a852a2b6b56249 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  max-width: 800px;
  width: 100%;
  border-radius: 18px;

  display: flex;
  align-items: center;
  padding-right: 10px;
  background-color: ${({ theme: theme })=>theme.colors.background};
  border: 1px solid ${({ theme: theme })=>`${theme.colors.secondary}50`};

  & input {
    background-color: ${({ theme: theme })=>theme.colors.background};
    border-radius: 50px;
    border: none;
    padding: 16px 25px;
  }
  & button {
    padding: 12px;
    border-radius: 12px;
  }
`;



// Map Redux Props
const $901d22b5e83e160a$var$mapStateToProps = (state)=>state;
const $901d22b5e83e160a$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $901d22b5e83e160a$var$AICatalystInput(props) {
    // Destructure
    const { onSubmit: onSubmit, centered: centered, title: title, description: description, prompts: prompts, disabled: disabled } = props;
    console.log(disabled);
    // Ref
    const formRef = (0, $tZqWC.useRef)();
    // Variables
    const initialFormValues = {
        message: ''
    };
    const validationSchema = $84bdfb0f595586e8$export$185802fd694ee1f5().shape({
        message: $7092ea25693c72ef$export$185802fd694ee1f5()
    });
    // Functions
    const handleDefaultSubmit = (msg)=>{
        formRef.current.message = msg;
        onSubmit(formRef.current);
    };
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $0746788b5b935b60$export$e6dfd72ab29f8598), {
        centered: centered,
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $0746788b5b935b60$export$d747b2abe71e53f5), {
            style: {
                gap: '42px',
                width: '100%'
            },
            children: [
                centered && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $0746788b5b935b60$export$a9754b3c8daa5172), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $0746788b5b935b60$export$d747b2abe71e53f5), {
                        style: {
                            gap: '8px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $0746788b5b935b60$export$f99233281efd08a0), {
                                children: title || 'AI Catalyst'
                            }),
                            description && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $0746788b5b935b60$export$5f1af8db9871e1d6), {
                                children: description
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $506ef65bbb4994b7$export$2e2bcd8739ae039), {
                    style: {
                        width: '100%'
                    },
                    formRef: formRef,
                    initialValues: initialFormValues,
                    validationSchema: validationSchema,
                    onSubmit: (v, { resetForm: resetForm })=>{
                        if (!disabled) {
                            onSubmit(v);
                            resetForm();
                        }
                    },
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $0746788b5b935b60$export$42a852a2b6b56249), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9d75ef3d13fecbc2$export$2e2bcd8739ae039), {
                                name: "message",
                                placeholder: "Ask Anything",
                                disabled: disabled
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                variant: "outlined",
                                disabled: disabled,
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5e06cd459ff3823a$export$2e2bcd8739ae039), {})
                            })
                        ]
                    })
                }),
                centered && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $0746788b5b935b60$export$bc7adc8ef74607f), {
                    children: [
                        prompts && prompts?.map((text, i)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                size: "small",
                                variant: "outlined",
                                onClick: ()=>{
                                    if (!disabled) handleDefaultSubmit(text);
                                },
                                children: text
                            }, i)),
                        !prompts && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                    size: "small",
                                    variant: "outlined",
                                    onClick: ()=>handleDefaultSubmit('What is Travel Rule Atlas?'),
                                    children: "What is Travel Rule Atlas?"
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                    size: "small",
                                    variant: "outlined",
                                    onClick: ()=>handleDefaultSubmit('How are self-hosted wallets handled?'),
                                    children: "How are self-hosted wallets handled?"
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                    size: "small",
                                    variant: "outlined",
                                    onClick: ()=>handleDefaultSubmit('What are the Travel Rule thresholds?'),
                                    children: "What are the Travel Rule thresholds?"
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                    size: "small",
                                    variant: "outlined",
                                    onClick: ()=>handleDefaultSubmit('What Travel Rule data must be collected?'),
                                    children: "What Travel Rule data must be collected?"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
// Default Props
$901d22b5e83e160a$var$AICatalystInput.defaultProps = {
    onSubmit: ()=>{},
    centered: false,
    disabled: false
};
// Proptypes Validation
$901d22b5e83e160a$var$AICatalystInput.propTypes = {
    onSubmit: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    description: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    prompts: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string),
    centered: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
};
var $901d22b5e83e160a$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($901d22b5e83e160a$var$mapStateToProps, $901d22b5e83e160a$var$mapDispatchToProps)($901d22b5e83e160a$var$AICatalystInput);


var $f7f65a6091036931$export$2e2bcd8739ae039 = (0, $901d22b5e83e160a$export$2e2bcd8739ae039);


// Map Redux Props
const $bc690cf3e54b4eaf$var$mapStateToProps = (state)=>state;
const $bc690cf3e54b4eaf$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $bc690cf3e54b4eaf$var$AICatalystWrapper(props) {
    // Destructure
    const { model: model } = props;
    // State
    const [messages, setMessages] = (0, $tZqWC.useState)({});
    const [isNearBottom, setIsNearBottom] = (0, $tZqWC.useState)(false);
    const [isLoading, setIsLoading] = (0, $tZqWC.useState)(false);
    const [connectionStatus, setConnectionStatus] = (0, $tZqWC.useState)('disconnected');
    // Refs
    const ws = (0, $tZqWC.useRef)(null);
    const pendingMsgRef = (0, $tZqWC.useRef)(null);
    // Hooks
    const [userCredentials] = (0, $a9c50ebe96619b20$export$2e2bcd8739ae039)('userCredentials', false);
    // Functions
    const handleOpen = (e)=>{
        console.log(e);
        console.log('Connected to ospree websocket.');
        // Send initial message to authenticate
        const msg = {
            id: (0, $5d7f1dba4fbacab8$export$2e2bcd8739ae039)(),
            token: userCredentials.access_token,
            context: null,
            content: '',
            role: 'user'
        };
        msg.type = pendingMsgRef.current ? 'reconnect' : 'connect';
        ws.current.send(JSON.stringify(msg));
        setConnectionStatus('connected');
    };
    const handleClose = (e)=>{
        console.log(e);
        console.log('Connection has been closed.');
        setConnectionStatus('disconnected');
    };
    const handleError = (e)=>{
        console.log(e);
        console.log(`Websocket error: ${e}.`);
        setConnectionStatus('disconnected');
    };
    const handleMessage = (e)=>{
        try {
            const data = JSON.parse(e.data);
            // For reconnection
            if (data.type === 'reconnect') {
                const msg = {
                    id: (0, $5d7f1dba4fbacab8$export$2e2bcd8739ae039)(),
                    token: userCredentials.access_token,
                    context: null,
                    content: '',
                    role: 'user',
                    type: 'request'
                };
                const context_messages = [];
                Object.keys(messages)?.forEach((key)=>{
                    context_messages.push(messages[key]);
                });
                msg.context = context_messages;
                msg.content = pendingMsgRef.current;
                setMessages((prevValue)=>({
                        ...prevValue,
                        [msg.id]: {
                            ...msg,
                            token: null
                        }
                    }));
                pendingMsgRef.current = null;
                ws.current.send(JSON.stringify(msg));
                return;
            }
            if (data.type === 'ack') {
                setMessages((prevValue)=>({
                        ...prevValue,
                        [data?.id]: data
                    }));
                return;
            }
            if (data.type === 'chunk') {
                setMessages((prevValue)=>{
                    if (!prevValue[data?.id]) return {
                        ...prevValue,
                        [data?.id]: data
                    };
                    return {
                        ...prevValue,
                        [data?.id]: {
                            ...prevValue[data?.id],
                            content: `${prevValue[data?.id]?.content}${data?.content}`
                        }
                    };
                });
                return;
            }
            if (data.type === 'response') {
                setIsLoading(false);
                setMessages((prevValue)=>({
                        ...prevValue,
                        [data?.id]: data
                    }));
            }
        } catch (err) {
            console.error('Error parsing message:', err);
        }
    };
    const connect = (0, $tZqWC.useCallback)(()=>{
        ws.current = new WebSocket((0, $78597906e6a0205e$export$6c927ce26c6dc103) + (0, $78597906e6a0205e$export$e9d870d86e0dc706)?.[model]);
        console.log((0, $78597906e6a0205e$export$6c927ce26c6dc103), (0, $78597906e6a0205e$export$e9d870d86e0dc706)?.[model]);
        ws.current.onopen = handleOpen;
        ws.current.onmessage = handleMessage;
        ws.current.onclose = handleClose;
        ws.current.onerror = handleError;
        if (ws.current?.readyState === WebSocket.CONNECTING) setConnectionStatus('connecting');
    }, [
        handleMessage,
        setConnectionStatus
    ]);
    const handleSubmit = (v)=>{
        // Handle when disconnected
        if (ws.current?.readyState === WebSocket.OPEN) {
            setIsLoading(true);
            const msg = {
                token: userCredentials.access_token,
                content: v.message,
                role: 'user',
                type: 'request',
                id: (0, $5d7f1dba4fbacab8$export$2e2bcd8739ae039)()
            };
            setMessages((prevValue)=>({
                    ...prevValue,
                    [msg.id]: {
                        ...msg,
                        token: null
                    }
                }));
            ws.current.send(JSON.stringify(msg));
        } else if (!ws.current || ws.current.readyState === WebSocket.CLOSED) {
            pendingMsgRef.current = v.message;
            connect();
        }
    };
    // UseEffects
    (0, $tZqWC.useEffect)(()=>{
        connect();
        return ()=>{
            if (ws.current) ws.current.close();
        };
    }, []);
    // Listen for page scroll
    (0, $tZqWC.useEffect)(()=>{
        const handleScroll = ()=>{
            const scrollTop = window.scrollY || document.documentElement.scrollTop;
            const windowHeight = window.innerHeight;
            const docHeight = document.documentElement.scrollHeight;
            const distanceFromBottom = docHeight - (scrollTop + windowHeight);
            setIsNearBottom(distanceFromBottom <= 60) // within 60px of bottom
            ;
        };
        window.addEventListener('scroll', handleScroll);
        handleScroll() // initialize
        ;
        return ()=>window.removeEventListener('scroll', handleScroll);
    }, []);
    // When new messages come in, scroll if near bottom
    (0, $tZqWC.useEffect)(()=>{
        if (isNearBottom) window.scrollTo({
            top: document.documentElement.scrollHeight,
            behavior: 'smooth'
        });
    }, [
        messages,
        isNearBottom
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (!!model && Object.keys(messages).length > 0) window.location.reload();
    }, [
        model
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d8dc3a663c1bdf0f$export$e6dfd72ab29f8598), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $d8dc3a663c1bdf0f$export$42a852a2b6b56249), {
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d8dc3a663c1bdf0f$export$616d763e306cba45), {
                    children: Object.values(messages).map((item)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f708ca589f0e5cb$export$2e2bcd8739ae039), {
                            message: item
                        }, item?.id))
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f7f65a6091036931$export$2e2bcd8739ae039), {
                    title: (0, $cde4eb7a2bc4524b$export$a38a862015dba646)?.[model]?.title,
                    description: (0, $cde4eb7a2bc4524b$export$a38a862015dba646)?.[model]?.description,
                    prompts: (0, $cde4eb7a2bc4524b$export$a38a862015dba646)?.[model]?.preprompts,
                    onSubmit: handleSubmit,
                    disabled: isLoading,
                    centered: Object.keys(messages)?.length < 1
                })
            ]
        })
    });
}
// Default Props
$bc690cf3e54b4eaf$var$AICatalystWrapper.defaultProps = {
    model: ''
};
// Proptypes Validation
$bc690cf3e54b4eaf$var$AICatalystWrapper.propTypes = {
    model: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
};
var $bc690cf3e54b4eaf$export$2e2bcd8739ae039 // const sample_messages = [
 //   {
 //     type: 'request',
 //     role: 'user',
 //     content: 'Could you explain that in detail?',
 //   },
 //   {
 //     type: 'response',
 //     role: 'ai',
 //     content: 'The novel 1984 was written by George Orwell',
 //   },
 // ]
 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($bc690cf3e54b4eaf$var$mapStateToProps, $bc690cf3e54b4eaf$var$mapDispatchToProps)($bc690cf3e54b4eaf$var$AICatalystWrapper);


var $a3f7d9681e9ab863$export$2e2bcd8739ae039 = (0, $bc690cf3e54b4eaf$export$2e2bcd8739ae039);


/* eslint-disable no-nested-ternary */ 
parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $6e8e7f63fa6de7bd$export$fa57f9eaf9b75d4f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-start;

  padding: 20px;
  border-radius: 5px;

  // Themed Properties
  border: 1px solid ${({ theme: theme })=>theme.colors.backgroundLite};
  background-color: ${({ theme: theme })=>theme.colors.background};
`;
const $6e8e7f63fa6de7bd$export$a77315949bf04380 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 0px 50px 0px 20px;

  // Themed Properties
  border-right: 1px solid ${({ theme: theme })=>theme.colors.backgroundLite};

  // Responsive Properties
  ${({ theme: theme })=>theme.functions.mediaQuery('border-right', [
        'none',
        'none',
        'none',
        'none',
        'none',
        `1px solid ${theme.colors.backgroundLite} `,
        `1px solid ${theme.colors.backgroundLite}`
    ])}

  ${({ theme: theme })=>theme.functions.mediaQuery('padding', [
        '0px 20px 0px 0px',
        '0px 20px 0px 0px',
        '0px 20px 0px 0px',
        '0px 20px 0px 0px',
        '0px 20px 0px 0px',
        '0px 50px 0px 20px',
        '0px 50px 0px 20px'
    ])}

  // TODO: Use theme functions
  &:last-child {
    border-right: none;
  }

  &:first-child {
    /* padding: 0px 50px 0px 0px; */

    // Responsive Properties
    ${({ theme: theme })=>theme.functions.mediaQuery('padding', [
        '0px 20px 0px 0px',
        '0px 20px 0px 0px',
        '0px 20px 0px 0px',
        '0px 20px 0px 0px',
        '0px 20px 0px 0px',
        '0px 50px 0px 0px',
        '0px 50px 0px 0px'
    ])}
  }
`;
const $6e8e7f63fa6de7bd$export$56add7b5a94d1b2b = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 14px;

  // Themed Properties
  color: ${({ theme: theme })=>theme.colors.secondary};
`;


function $ed6ed8c755d4caf7$var$DirectoryStatusSummary(props) {
    // Destructure
    const { customerId: customerId, total: total, status: status, type: type, caseType: caseType } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6e8e7f63fa6de7bd$export$fa57f9eaf9b75d4f), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6e8e7f63fa6de7bd$export$a77315949bf04380), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6e8e7f63fa6de7bd$export$56add7b5a94d1b2b), {
                        children: [
                            "ID:\xa0",
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("strong", {
                                children: customerId
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6e8e7f63fa6de7bd$export$56add7b5a94d1b2b), {
                        children: [
                            "Total\xa0",
                            `${type === 'address' ? 'Addresses' : type === 'alerts' ? 'Alerts' : 'Transactions'}:`,
                            "\xa0",
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("strong", {
                                children: total
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6e8e7f63fa6de7bd$export$a77315949bf04380), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6e8e7f63fa6de7bd$export$56add7b5a94d1b2b), {
                        children: [
                            "Status:\xa0",
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("strong", {
                                children: status
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6e8e7f63fa6de7bd$export$56add7b5a94d1b2b), {
                        children: [
                            "Type:\xa0",
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("strong", {
                                children: caseType === 'Legal Person' ? 'Entity' : 'Individual'
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
// Default Props
$ed6ed8c755d4caf7$var$DirectoryStatusSummary.defaultProps = {
    customerId: '',
    total: 0,
    status: '',
    type: '',
    caseType: ''
};
// Proptypes Validation
$ed6ed8c755d4caf7$var$DirectoryStatusSummary.propTypes = {
    customerId: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    total: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
    status: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    caseType: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
};
var $ed6ed8c755d4caf7$export$2e2bcd8739ae039 = $ed6ed8c755d4caf7$var$DirectoryStatusSummary;


var $e4dd432aea684c06$export$2e2bcd8739ae039 = (0, $ed6ed8c755d4caf7$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");






const $cd9ab219b74917c8$export$4267411171632d35 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $cd9ab219b74917c8$export$cbf11d5f692bc726 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
`;
const $cd9ab219b74917c8$export$97d84ed62ab03b3f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  margin: 0px 0px 0px 16px;

  font-weight: inherit;
  font-size: inherit;
`;





parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");


const $f7b5c917c7c96624$export$5f1af8db9871e1d6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  font-size: 13px;
  margin: 0;
  text-align: right;
`;
const $f7b5c917c7c96624$export$b04be29aa201d4f5 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  font-size: 13px;
  margin: 0;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $f7b5c917c7c96624$export$f99233281efd08a0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h3`
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 2px;
  color: ${({ theme: theme })=>theme.colors.primary};

  max-width: 260px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;
const $f7b5c917c7c96624$export$d5c56664638992a4 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h4`
  font-size: 10px;
  margin: 0;
  font-weight: 400;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $f7b5c917c7c96624$export$987cac99e7a31168 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: 1.3fr 1fr;
`;
const $f7b5c917c7c96624$export$6f4a084cc8e379b6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 15px;

  &:first-child {
    background-color: ${({ theme: theme })=>`${theme.colors.secondary}10`};
    border-bottom: 2px solid ${({ theme: theme })=>theme.colors.backgroundLite};
    border-radius: 10px 10px 0 0;
    gap: 5px;
    & button {
      visibility: ${({ pending: pending })=>!pending && 'hidden'};
      color: ${({ theme: theme })=>theme.colors.brand} !important;
      border-color: ${({ theme: theme })=>theme.colors.brand} !important;
    }
  }
  &:last-child {
    background-color: ${({ theme: theme })=>theme.colors.background};
    border-radius: 0 0 10px 10px;
  }

  &:last-child {
    border-top: 2px solid ${({ theme: theme })=>theme.colors.backgroundLite};
    & div > p {
      font-size: 13px;
      font-weight: 100;
      color: ${({ theme: theme })=>theme.colors.primary};
    }
  }
`;




function $3335d4d024d72ac4$var$AccountsTableItem(props) {
    // Destructure
    const { accountDetails: accountDetails } = props;
    const { reference_id: reference_id, id: id, account_risk_value: // account_risk_desc,
    account_risk_value, account_type_id: account_type_id, address_country_desc: // address_country_code,
    address_country_desc, display_country: // created,
    display_country, display_date: display_date, display_name: display_name, transfers_in: transfers_in, transfers_out: transfers_out, status_desc: status_desc, is_customer: is_customer } = accountDetails;
    // Functions
    // useEffect
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $12b33660068e86aa$export$b0d92dbee9b5b60d), {
        to: `/directory/accounts/details/${id}`,
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $37202d75ee8521c4$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $f7b5c917c7c96624$export$6f4a084cc8e379b6), {
                    pending: transfers_out > 0 || transfers_in > 0,
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $f7b5c917c7c96624$export$f99233281efd08a0), {
                            children: [
                                "ID: ",
                                reference_id
                            ]
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $f7b5c917c7c96624$export$d5c56664638992a4), {
                            children: [
                                account_type_id === 1 ? 'Individual ' : 'Business ',
                                is_customer ? 'Customer' : 'Non-Customer'
                            ]
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                            variant: "outlined",
                            disabled: transfers_out < 1 && transfers_in < 1,
                            size: "tiny",
                            children: "PENDING TRANSFERS"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $f7b5c917c7c96624$export$6f4a084cc8e379b6), {
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $f7b5c917c7c96624$export$987cac99e7a31168), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f7b5c917c7c96624$export$b04be29aa201d4f5), {
                                    children: account_type_id === 1 ? 'Name: ' : 'Company Name: '
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f7b5c917c7c96624$export$5f1af8db9871e1d6), {
                                    children: display_name || '-'
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $f7b5c917c7c96624$export$987cac99e7a31168), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f7b5c917c7c96624$export$b04be29aa201d4f5), {
                                    children: "Country of Domicile: "
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f7b5c917c7c96624$export$5f1af8db9871e1d6), {
                                    children: address_country_desc || '-'
                                })
                            ]
                        }),
                        account_type_id === 1 && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $f7b5c917c7c96624$export$987cac99e7a31168), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $f7b5c917c7c96624$export$b04be29aa201d4f5), {
                                    children: [
                                        'Date of Birth: ',
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f7b5c917c7c96624$export$5f1af8db9871e1d6), {
                                    children: display_date || '-'
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $f7b5c917c7c96624$export$987cac99e7a31168), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $f7b5c917c7c96624$export$b04be29aa201d4f5), {
                                    children: [
                                        account_type_id === 1 ? 'Nationality: ' : 'Country of Incorporation: ',
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f7b5c917c7c96624$export$5f1af8db9871e1d6), {
                                    children: display_country || '-'
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $f7b5c917c7c96624$export$6f4a084cc8e379b6), {
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $f7b5c917c7c96624$export$987cac99e7a31168), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f7b5c917c7c96624$export$b04be29aa201d4f5), {
                                    children: "Status: "
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f7b5c917c7c96624$export$5f1af8db9871e1d6), {
                                    children: status_desc
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $f7b5c917c7c96624$export$987cac99e7a31168), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f7b5c917c7c96624$export$b04be29aa201d4f5), {
                                    children: "Account Risk: "
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f7b5c917c7c96624$export$5f1af8db9871e1d6), {
                                    children: account_risk_value ? (0, $f398806f8c37b1c3$export$ac88620a652f8304)[account_risk_value].label : '-'
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $f7b5c917c7c96624$export$987cac99e7a31168), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f7b5c917c7c96624$export$b04be29aa201d4f5), {
                                    children: "Transfers In: "
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f7b5c917c7c96624$export$5f1af8db9871e1d6), {
                                    children: transfers_in
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $f7b5c917c7c96624$export$987cac99e7a31168), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f7b5c917c7c96624$export$b04be29aa201d4f5), {
                                    children: "Transfers Out: "
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f7b5c917c7c96624$export$5f1af8db9871e1d6), {
                                    children: transfers_out
                                })
                            ]
                        })
                    ]
                })
            ]
        }, reference_id)
    });
}
// Default Props
$3335d4d024d72ac4$var$AccountsTableItem.defaultProps = {};
// Proptypes Validation
$3335d4d024d72ac4$var$AccountsTableItem.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    accountDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).any
};
var $3335d4d024d72ac4$export$2e2bcd8739ae039 = $3335d4d024d72ac4$var$AccountsTableItem;


var $7be4edb826aa1d4e$export$2e2bcd8739ae039 = (0, $3335d4d024d72ac4$export$2e2bcd8739ae039);


// Map Redux Props
const $6152a32f25b173bc$var$mapStateToProps = (state)=>state;
const $6152a32f25b173bc$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $6152a32f25b173bc$var$AccountsTable(props) {
    // Destructure
    const { filters: filters, ui: ui, actions: actions } = props;
    // Store States
    const { accountDirectoryFilters: accountDirectoryFilters } = filters;
    const { isPageTableUpdated: isPageTableUpdated } = ui;
    // Store Actions
    const { setAccountDirectoryFilters: setAccountDirectoryFilters, setIsIndividualAccountDrawerOpen: setIsIndividualAccountDrawerOpen, setIsEntityAccountDrawerOpen: setIsEntityAccountDrawerOpen, setToBeUpdatedAccount: setToBeUpdatedAccount, setIsPageTableUpdated: setIsPageTableUpdated } = actions;
    // Variables
    const { sort: sort, page: page, size: size, account_type_id: account_type_id, status_id: status_id, account_category: account_category } = accountDirectoryFilters;
    // States
    const [accountsDataState, setAccountsDataState] = (0, $tZqWC.useState)({
        items: [],
        total: 0,
        page: 1
    });
    // Hooks
    const [userCredentials] = (0, $a9c50ebe96619b20$export$2e2bcd8739ae039)('userCredentials', false);
    const { allAccountsData: allAccountsData, getAllAccounts: getAllAccounts, isAllAccountsLoading: isAllAccountsLoading } = (0, $f37bbf346099fbd9$export$2e2bcd8739ae039)();
    // Functions
    const fetchAccounts = ()=>{
        getAllAccounts({
            biz_id: userCredentials.Business_ID,
            sort: sort,
            size: size,
            page: page,
            account_type_id: account_type_id,
            status_id: status_id,
            account_category: account_category
        });
    };
    // UseEffects
    (0, $tZqWC.useEffect)(()=>{
        if (allAccountsData) setAccountsDataState(allAccountsData);
    }, [
        allAccountsData
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (accountDirectoryFilters || isPageTableUpdated) {
            fetchAccounts();
            setIsPageTableUpdated(false);
        }
    }, [
        accountDirectoryFilters,
        isPageTableUpdated
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $cd9ab219b74917c8$export$4267411171632d35), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7139282abdeb8ca4$export$2e2bcd8739ae039), {
            tableKey: accountsDataState?.page,
            totalItems: accountsDataState.total,
            headerOptions: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $ca6f920a36c82944$export$2e2bcd8739ae039), {
                direction: "down",
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $478ff5739380e08c$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                            size: "small",
                            variant: "outlined",
                            startIcon: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6417d0fa9c066aa3$export$2e2bcd8739ae039), {
                                size: 14
                            }),
                            children: "Account"
                        })
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $7a68433660fee9cb$export$2e2bcd8739ae039), {
                        left: true,
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $c7b007afae0a2778$export$2e2bcd8739ae039), {
                                onClick: ()=>{
                                    setToBeUpdatedAccount(null);
                                    setIsIndividualAccountDrawerOpen(true);
                                },
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bacab6cf84c015d6$export$2e2bcd8739ae039), {
                                        size: 18
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $cd9ab219b74917c8$export$97d84ed62ab03b3f), {
                                        children: "Individual Account"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $c7b007afae0a2778$export$2e2bcd8739ae039), {
                                onClick: ()=>{
                                    setToBeUpdatedAccount(null);
                                    setIsEntityAccountDrawerOpen(true);
                                },
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $8cbc17364ca8973d$export$2e2bcd8739ae039), {
                                        size: 18
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $cd9ab219b74917c8$export$97d84ed62ab03b3f), {
                                        children: "Entity Account"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            minWidth: 900,
            filterComponents: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $18e1459be341ac87$export$2e2bcd8739ae039), {}),
            tableFilters: accountDirectoryFilters,
            setTableFilters: setAccountDirectoryFilters,
            children: accountsDataState.items.length > 0 && !isAllAccountsLoading ? accountsDataState.items.map((accountDetails)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7be4edb826aa1d4e$export$2e2bcd8739ae039), {
                    accountDetails: accountDetails
                }, accountDetails.id)) : /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                children: [
                    isAllAccountsLoading ? /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $647b8bc68ebce54f$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a6ea3b0f3caed586$export$2e2bcd8739ae039), {
                        setFilter: setAccountDirectoryFilters
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("div", {})
                ]
            })
        })
    });
}
// Default Props
$6152a32f25b173bc$var$AccountsTable.defaultProps = {
    actions: {},
    filters: {},
    ui: {}
};
// Proptypes Validation
$6152a32f25b173bc$var$AccountsTable.propTypes = {
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        accountDirectoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object)
    }),
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setToBeUpdatedAccount: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAccountDirectoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsIndividualAccountDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsEntityAccountDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        toggleUpgradeModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setInfoModalDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $6152a32f25b173bc$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($6152a32f25b173bc$var$mapStateToProps, $6152a32f25b173bc$var$mapDispatchToProps)($6152a32f25b173bc$var$AccountsTable);


var $75c7e53cbfc5e98f$export$2e2bcd8739ae039 = (0, $6152a32f25b173bc$export$2e2bcd8739ae039);



/* eslint-disable react/jsx-indent */ 

var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");



var $ejSM7 = parcelRequire("ejSM7");






const $e8aad90d70d3b625$export$e6dfd72ab29f8598 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
`;
const $e8aad90d70d3b625$export$518140168539ec9f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-end;
  margin: 20px 0 -40px 0;
`;
const $e8aad90d70d3b625$export$f7572adddafd5ab7 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-end;
  gap: 20px;
  margin-top: 40px;
`;
const $e8aad90d70d3b625$export$f99233281efd08a0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h1`
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  text-transform: uppercase;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $e8aad90d70d3b625$export$cf345ef34cd72655 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  margin: 0;
  font-size: 10px;
  font-weight: 400;
  letter-spacing: 0.5px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $e8aad90d70d3b625$export$42a852a2b6b56249 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  margin-top: 20px;
  padding: 20px;
  border-radius: 10px;
  background: ${({ theme: theme })=>theme.colors.background};
`;
const $e8aad90d70d3b625$export$d7a54cba636a8cd6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding-top: 20px;
  width: 100%;
`;
const $e8aad90d70d3b625$export$ca4b1fc43afa0212 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: 1fr, 200px;
`;






var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");





const $90a35fa208f1f367$export$4267411171632d35 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 10px 0 0 0;
`;
const $90a35fa208f1f367$export$cbf11d5f692bc726 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
`;
const $90a35fa208f1f367$export$97d84ed62ab03b3f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  margin: 0px 0px 0px 16px;

  font-weight: inherit;
  font-size: inherit;
`;




// Map Redux Props
const $8e419df4fdcfac1a$var$mapStateToProps = (state)=>state;
const $8e419df4fdcfac1a$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $8e419df4fdcfac1a$var$AccountAddressesTable(props) {
    // Destructure
    const { filters: filters, ui: ui, actions: actions, address: address } = props;
    const { account_id: account_id } = (0, $a0d5c3f2fe524011$export$99eaa27ddbbb95ef)();
    // Store States
    const { addressFilters: addressFilters } = filters;
    const { scannedAddress: scannedAddress } = address;
    const { isPageTableUpdated: isPageTableUpdated } = ui;
    const { setIsPageTableUpdated: setIsPageTableUpdated, setAddressFilters: setAddressFilters, showAlert: showAlert, setScannedAddress: setScannedAddress, setScannedAddressDetails: setScannedAddressDetails } = actions;
    // Hooks
    const { getAddresses: getAddresses, getAddressesData: getAddressesData, getAddressesError: getAddressesError, isGetAddressesLoading: isGetAddressesLoading } = (0, $d3447c5e6b8a84bc$export$2e2bcd8739ae039)();
    // Local states
    const [addresses, setAddresses] = (0, $tZqWC.useState)([]);
    const [pagination, setPagination] = (0, $tZqWC.useState)();
    const [openedTab, setOpenedTab] = (0, $tZqWC.useState)();
    // Functions
    function handleScannedAddress() {
        const newAddress = {
            id: scannedAddress?.address_id,
            address: scannedAddress?.address,
            chain: scannedAddress?.chain,
            symbol: scannedAddress?.symbol,
            risk_score: scannedAddress?.risk_data?.risk_score,
            risk_ratio: scannedAddress?.risk_data?.risk_ratio,
            balance_usd: scannedAddress?.financial_data?.balance_usd,
            balance: scannedAddress?.financial_data?.balance,
            modify_tz: scannedAddress?.request_tz,
            link_id: scannedAddress?.link_id,
            link_type: scannedAddress?.link_type,
            is_self_hosted: scannedAddress?.is_self_hosted,
            modified_by_name: scannedAddress?.modified_by_name
        };
        const newAddressList = [
            newAddress
        ];
        addresses.forEach((item)=>{
            if (item.address !== scannedAddress.address) newAddressList.push(item);
        });
        // Changing it back to null
        setScannedAddress(null);
        setAddresses(newAddressList);
        setScannedAddressDetails(scannedAddress);
    }
    // UseEffects
    (0, $tZqWC.useEffect)(()=>{
        if (isPageTableUpdated) {
            getAddresses({
                ...addressFilters,
                link_id: account_id
            });
            setIsPageTableUpdated(false);
        } else if (addressFilters) getAddresses({
            ...addressFilters,
            link_id: account_id
        });
    }, [
        isPageTableUpdated,
        addressFilters
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (getAddressesData) {
            setAddresses(getAddressesData.items);
            setPagination(getAddressesData.pagination);
        }
    }, [
        getAddressesData
    ]);
    (0, $tZqWC.useEffect)(()=>{
        // TODO ADD PROPER ERROR MSG SENT FROM SERVER
        if (getAddressesError) showAlert({
            type: 'error',
            message: 'An error occurred in fetching addresses'
        });
    }, [
        getAddressesError
    ]);
    (0, $tZqWC.useEffect)(()=>{
        // TODO ADD PROPER ERROR MSG SENT FROM SERVER
        if (scannedAddress) handleScannedAddress();
    }, [
        scannedAddress
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $90a35fa208f1f367$export$4267411171632d35), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $d2b0b55dc8f66a40$export$2e2bcd8739ae039), {
            totalItems: pagination?.total && pagination.total,
            minWidth: 900,
            tableFilters: addressFilters,
            setTableFilters: setAddressFilters,
            children: [
                addresses.length > 0 && !isGetAddressesLoading && addresses.map((data)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b49ad3ba05b75678$export$2e2bcd8739ae039), {
                        openedTab: openedTab,
                        setOpenedTab: setOpenedTab,
                        data: data,
                        getAddressesError: getAddressesError
                    }, `${data.id}${data.address}`)),
                isGetAddressesLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $647b8bc68ebce54f$export$2e2bcd8739ae039), {}),
                (addresses?.length < 1 || !addresses) && !isGetAddressesLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a6ea3b0f3caed586$export$2e2bcd8739ae039), {
                    setFilter: ()=>setAddressFilters({
                            link_id: account_id
                        })
                })
            ]
        })
    });
}
// Default Props
$8e419df4fdcfac1a$var$AccountAddressesTable.defaultProps = {
    actions: {},
    filters: {},
    ui: {}
};
// Proptypes Validation
$8e419df4fdcfac1a$var$AccountAddressesTable.propTypes = {
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        addressFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object)
    }),
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setToBeUpdatedAccount: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAccountDirectoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsIndividualAccountDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsEntityAccountDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAddressFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setScannedAddress: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setScannedAddressDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    address: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        scannedAddress: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            address_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            address: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            chain: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            symbol: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            symbol_icon: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            financial_data: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
                provider_name: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
                balance: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
                balance_usd: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
                spent: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
                spent_usd: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
                received: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
                received_usd: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
                transaction_count: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
                latest_activity: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
            }),
            risk_data: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
                provider_name: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
                risk_score: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
                risk_ratio: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
                vasp_name_legal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
                vasp_name_business: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
                vasp_website: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
                vasp_category: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
                api_result_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
            }),
            request_tz: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            modified_by_name: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            link_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            link_type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
            is_self_hosted: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
        })
    })
};
var $8e419df4fdcfac1a$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($8e419df4fdcfac1a$var$mapStateToProps, $8e419df4fdcfac1a$var$mapDispatchToProps)($8e419df4fdcfac1a$var$AccountAddressesTable);


var $bf8087a9914394f3$export$2e2bcd8739ae039 = (0, $8e419df4fdcfac1a$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");


var $ejSM7 = parcelRequire("ejSM7");








const $2fefd3847296b8a9$export$e6dfd72ab29f8598 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
const $2fefd3847296b8a9$export$42a852a2b6b56249 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 20px;
`;
const $2fefd3847296b8a9$export$bc7adc8ef74607f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 15px;
  & button {
    width: fit-content;
    font-weight: 400;
    font-size: 16px !important;
    padding: 5px 15px;
    border-radius: 7px;
  }
`;


// Map Redux Props
const $aa69d65e2a6a855f$var$mapStateToProps = (state)=>state;
const $aa69d65e2a6a855f$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $aa69d65e2a6a855f$var$AccountSummaryFilters(props) {
    // Destructure
    const { actions: actions, account_id: account_id, account_data: account_data, activeTable: activeTable, setActiveTable: setActiveTable } = props;
    // Local state
    const [addressSummary, setAddressSummary] = (0, $tZqWC.useState)();
    const [inAccountSummary, setInAccountSummary] = (0, $tZqWC.useState)();
    const [outAccountSummary, setOutAccountSummary] = (0, $tZqWC.useState)();
    // store actions
    const { setAddressFilters: setAddressFilters, setIsAddressSearchModalOpen: setIsAddressSearchModalOpen, setAddressSearchDetails: setAddressSearchDetails, setTravelRuleFilters: setTravelRuleFilters } = actions;
    // Variables
    const defaultTransferFilters = {
        sort: '-last_modified',
        page: 1,
        size: 10,
        transfer_status_id: undefined,
        asset_code: undefined,
        direction: undefined,
        start_range: (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))('Jan 1 2008').format((0, $41a9e38e6be32f35$export$1bceb808939a9f0c)),
        end_range: (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))().add(1, 'days').format((0, $41a9e38e6be32f35$export$1bceb808939a9f0c))
    };
    // functions
    const fetchData = async ()=>{
        const allAddress = await (0, $8c9c17926a9c04e3$export$3d7eb20b694016e4)({
            account_id: account_id
        });
        const allInAccount = await (0, $8f7fd483d379aa21$export$1c0ad7b4ce3c0a20)({
            in_account_id: account_id
        });
        const allOutAccount = await (0, $8f7fd483d379aa21$export$1c0ad7b4ce3c0a20)({
            out_account_id: account_id
        });
        if (allAddress) setAddressSummary(allAddress);
        if (allInAccount) setInAccountSummary(allInAccount);
        if (allOutAccount) setOutAccountSummary(allOutAccount);
    };
    const handleAddressFilter = ()=>{
        setAddressFilters({
            sort: '-last_modified',
            page: 1,
            size: 10,
            start_range: (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))('Jan 1 2008').format((0, $41a9e38e6be32f35$export$1bceb808939a9f0c)),
            end_range: (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))().format((0, $41a9e38e6be32f35$export$1bceb808939a9f0c)),
            link_id: account_id,
            identified: undefined
        });
        setActiveTable(0);
    };
    const handleTransfersIn = ()=>{
        setTravelRuleFilters({
            ...defaultTransferFilters,
            in_account_id: account_id,
            out_account_id: undefined
        });
        setActiveTable(1);
    };
    const handleTransfersOut = ()=>{
        setTravelRuleFilters({
            ...defaultTransferFilters,
            in_account_id: undefined,
            out_account_id: account_id
        });
        setActiveTable(2);
    };
    const handleAddWallet = ()=>{
        setIsAddressSearchModalOpen(true);
        setAddressSearchDetails({
            link_id: account_data?.id,
            link_type: account_data?.account_type_id
        });
    };
    // useEffects
    (0, $tZqWC.useEffect)(()=>{
        fetchData();
    }, []);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $2fefd3847296b8a9$export$e6dfd72ab29f8598), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $2fefd3847296b8a9$export$42a852a2b6b56249), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $97b5b998d9c9faaf$export$2e2bcd8739ae039), {
                        data: [
                            {
                                label: 'Today',
                                value: addressSummary?.today ? addressSummary?.today : '-'
                            },
                            {
                                label: 'Last 30 Days',
                                value: addressSummary?.days_30 ? addressSummary?.days_30 : '-'
                            },
                            {
                                label: 'All Time',
                                value: addressSummary?.all_time ? addressSummary?.all_time : '-'
                            }
                        ],
                        title: "All Linked Addresses",
                        icon: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $19d59dfd9935476a$export$2e2bcd8739ae039), {
                            size: 18
                        }),
                        active: activeTable === 0,
                        onClick: handleAddressFilter
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $97b5b998d9c9faaf$export$2e2bcd8739ae039), {
                        data: [
                            {
                                label: 'Today',
                                value: inAccountSummary?.today ? inAccountSummary?.today : '-'
                            },
                            {
                                label: 'Last 30 Days',
                                value: inAccountSummary?.days_30 ? inAccountSummary?.days_30 : '-'
                            },
                            {
                                label: 'All Time',
                                value: inAccountSummary?.all_time ? inAccountSummary?.all_time : '-'
                            }
                        ],
                        title: "Transfers Sent",
                        icon: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $76ab1dfa1f4ba16c$export$2e2bcd8739ae039), {
                            size: 30
                        }),
                        active: activeTable === 1,
                        onClick: handleTransfersIn
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $97b5b998d9c9faaf$export$2e2bcd8739ae039), {
                        data: [
                            {
                                label: 'Today',
                                value: outAccountSummary?.today ? outAccountSummary?.today : '-'
                            },
                            {
                                label: 'Last 30 Days',
                                value: outAccountSummary?.days_30 ? outAccountSummary?.days_30 : '-'
                            },
                            {
                                label: 'All Time',
                                value: outAccountSummary?.all_time ? outAccountSummary?.all_time : '-'
                            }
                        ],
                        title: "Transfers Received",
                        icon: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9523a1ca65c68678$export$2e2bcd8739ae039), {
                            size: 30
                        }),
                        active: activeTable === 2,
                        onClick: handleTransfersOut
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $2fefd3847296b8a9$export$bc7adc8ef74607f), {
                children: [
                    activeTable === 0 && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7e43e1df6e75bbbe$export$2e2bcd8739ae039), {
                        id: "accountAddressTableFilter"
                    }),
                    (activeTable === 1 || activeTable === 2) && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("div", {}),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                        onClick: handleAddWallet,
                        children: "Add New Wallet"
                    })
                ]
            })
        ]
    });
}
// Default Props
$aa69d65e2a6a855f$var$AccountSummaryFilters.defaultProps = {
    actions: {},
    filters: {},
    ui: {},
    account_id: ''
};
// Proptypes Validation
$aa69d65e2a6a855f$var$AccountSummaryFilters.propTypes = {
    account_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        addressFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object)
    }),
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setAccountDirectoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsIndividualAccountDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsEntityAccountDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAddressFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsAddressSearchModalOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAddressSearchDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setTravelRuleFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    activeTable: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
    setActiveTable: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
    account_data: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        account_type_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number
    })
};
var $aa69d65e2a6a855f$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($aa69d65e2a6a855f$var$mapStateToProps, $aa69d65e2a6a855f$var$mapDispatchToProps)($aa69d65e2a6a855f$var$AccountSummaryFilters);


var $6a72c94d19cb5e60$export$2e2bcd8739ae039 = (0, $aa69d65e2a6a855f$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");




const $ec7c638594e717b5$export$603ae81ab9412b1f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding-top: 10px;
`;




// Map Redux Props
const $326807e2e83da71b$var$mapStateToProps = (state)=>state;
const $326807e2e83da71b$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $326807e2e83da71b$var$AccountTransfersTable(props) {
    // Destructure
    const { actions: actions, filters: filters, ui: ui, activeTable: activeTable } = props;
    const { travelRuleFilters: travelRuleFilters } = filters;
    const { isPageTableUpdated: isPageTableUpdated } = ui;
    const { setTravelRuleFilters: setTravelRuleFilters, setIsPageTableUpdated: setIsPageTableUpdated } = actions;
    // Hooks
    const [transfersData, setTransfersData] = (0, $tZqWC.useState)({
        items: [],
        total: 0
    });
    const { getAllTransfers: getAllTransfers, allTransferData: allTransferData, isAllTransferLoading: isAllTransferLoading } = (0, $13d8d2c7cd726551$export$2e2bcd8739ae039)();
    // Functions
    const fetchData = async ()=>{
        getAllTransfers(travelRuleFilters);
    };
    // MANUALLY UPDATING DIRECTION ID FOR TRANSFERS THAT HAVE BEEN SENT
    // TO SELF (i.e Kraken -> Kraken)
    const updateData = (data)=>{
        if (data?.items && activeTable === 2) {
            const items = [];
            data?.items?.forEach((v)=>{
                items.push({
                    ...v,
                    direction_id: 1
                });
            });
            setTransfersData({
                ...data,
                items: items
            });
            return;
        }
        setTransfersData(data);
    };
    // UseEffects
    (0, $tZqWC.useEffect)(()=>fetchData(), [
        travelRuleFilters
    ]);
    (0, $tZqWC.useEffect)(()=>allTransferData && updateData(allTransferData), [
        allTransferData
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (isPageTableUpdated) {
            fetchData();
            setIsPageTableUpdated(false);
        }
    }, [
        isPageTableUpdated
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ec7c638594e717b5$export$603ae81ab9412b1f), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $d2b0b55dc8f66a40$export$2e2bcd8739ae039), {
            minWidth: 700,
            totalItems: transfersData.total,
            tableFilters: travelRuleFilters,
            setTableFilters: setTravelRuleFilters,
            children: [
                transfersData.items.length > 0 && !isAllTransferLoading && transfersData.items.map((singleData)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b4994cef654503eb$export$2e2bcd8739ae039), {
                        data: singleData
                    }, singleData?.id)),
                isAllTransferLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $647b8bc68ebce54f$export$2e2bcd8739ae039), {}),
                transfersData?.items?.length < 1 && !isAllTransferLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a6ea3b0f3caed586$export$2e2bcd8739ae039), {})
            ]
        })
    });
}
// Default Props
$326807e2e83da71b$var$AccountTransfersTable.defaultProps = {
    actions: {},
    ui: {},
    filters: {}
};
// Proptypes Validation
$326807e2e83da71b$var$AccountTransfersTable.propTypes = {
    activeTable: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setAddressChains: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setTravelRuleFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsTransferDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        toggleTransferReportModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        toggleUpgradeModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setInfoModalDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        travelRuleFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object)
    }),
    address: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        addressChains: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({})
    })
};
var $326807e2e83da71b$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($326807e2e83da71b$var$mapStateToProps, $326807e2e83da71b$var$mapDispatchToProps)($326807e2e83da71b$var$AccountTransfersTable);


var $d15d184f094f52f8$export$2e2bcd8739ae039 = (0, $326807e2e83da71b$export$2e2bcd8739ae039);


// Map Redux Props
const $db625bee87814325$var$mapStateToProps = (state)=>state;
const $db625bee87814325$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $db625bee87814325$var$AccountDetails(props) {
    // Destructure
    const { actions: actions } = props;
    const { account_id: account_id } = (0, $a0d5c3f2fe524011$export$99eaa27ddbbb95ef)();
    // store actions
    const { setShowHeaderLoader: setShowHeaderLoader, showAlert: showAlert, setAddressFilters: setAddressFilters } = actions;
    // refs
    const accountFormRef = (0, $tZqWC.useRef)(null);
    const riskFormRef = (0, $tZqWC.useRef)(null);
    // hooks
    const { getAccount: getAccount, accountData: accountData, isAccountLoading: isAccountLoading } = (0, $aa9aabe79903a329$export$2e2bcd8739ae039)();
    const { accountEntityUpdateData: accountEntityUpdateData, updateAccountEntity: updateAccountEntity, accountEntityUpdateError: accountEntityUpdateError, isAccountEntityUpdateLoading: isAccountEntityUpdateLoading, isAccountEntityUpdateSuccess: isAccountEntityUpdateSuccess } = (0, $d50484ab2e32d4d8$export$2e2bcd8739ae039)();
    const { accountIndividualUpdateData: accountIndividualUpdateData, updateAccountIndividual: updateAccountIndividual, accountIndividualUpdateError: accountIndividualUpdateError, isAccountIndividualUpdateLoading: isAccountIndividualUpdateLoading, isAccountIndividualUpdateSuccess: isAccountIndividualUpdateSuccess } = (0, $ead9c70d2f240d34$export$2e2bcd8739ae039)();
    // state
    const [accountDataState, setAccountDataState] = (0, $tZqWC.useState)();
    const [viewMode, setViewMode] = (0, $tZqWC.useState)(true);
    const [fakeLoading, setFakeLoading] = (0, $tZqWC.useState)(false);
    // const [accountDetailsPage, setAccountDetailsPage] = useState(0)
    const [overviewPage, setOverviewPage] = (0, $tZqWC.useState)(0);
    // const [activityPage, setActivityPage] = useState(0)
    const [activeTable, setActiveTable] = (0, $tZqWC.useState)(0);
    // functions
    const fetchData = ()=>{
        getAccount({
            account_id: account_id
        });
    };
    const setAccountAddressFitlers = ()=>{
        setAddressFilters({
            sort: '-last_modified',
            page: 1,
            size: 10,
            start_range: (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))('Jan 1 2008').format((0, $41a9e38e6be32f35$export$1bceb808939a9f0c)),
            end_range: (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))().add(1, 'days').format((0, $41a9e38e6be32f35$export$1bceb808939a9f0c)),
            link_id: account_id,
            identified: undefined
        });
    };
    const handleOnSubmit = ()=>{
        const accountPayload = accountFormRef.current.values;
        const riskPayload = riskFormRef.current.values;
        const newPayload = {
            ...accountPayload,
            account_risk_value: riskPayload.account_risk_value,
            recipient_risk_value: riskPayload.recipient_risk_value,
            pep_id: riskPayload.pep_id,
            sanction_id: riskPayload.sanction_id,
            adverse_media_id: riskPayload.adverse_media_id,
            comments: riskPayload.comments
        };
        if (!accountPayload && !riskPayload) return;
        if (accountDataState.account_type_id === 1) updateAccountIndividual({
            account_id: account_id,
            values: newPayload
        });
        if (accountDataState.account_type_id === 2) updateAccountEntity({
            account_id: account_id,
            values: newPayload
        });
    };
    const handleCancel = ()=>{
        setViewMode(true);
        setFakeLoading(true);
        if (accountEntityUpdateData) return setAccountDataState(accountEntityUpdateData);
        if (accountIndividualUpdateData) return setAccountDataState(accountIndividualUpdateData);
        return setAccountDataState(accountData);
    };
    const handleLoadingUpdateChange = ()=>{
        if (isAccountEntityUpdateLoading || isAccountIndividualUpdateLoading) setShowHeaderLoader(true);
        if (!isAccountEntityUpdateLoading && !isAccountIndividualUpdateLoading) {
            setShowHeaderLoader(false);
            if (accountDataState) {
                if (accountDataState?.account_type_id === 1) {
                    if (isAccountIndividualUpdateSuccess) // setAccountDataState(accountIndividualUpdateData)
                    showAlert({
                        type: 'success',
                        message: 'Successfully updated record'
                    });
                    else if (!isAccountIndividualUpdateSuccess) {
                        if (typeof accountIndividualUpdateError?.response?.data?.data === 'string') {
                            showAlert({
                                type: 'error',
                                message: accountIndividualUpdateError?.response?.data?.data
                            });
                            return;
                        }
                        handleCancel();
                        showAlert({
                            type: 'error',
                            message: 'An error occurred in updating record'
                        });
                    }
                } else if (accountDataState?.account_type_id === 2) {
                    if (isAccountEntityUpdateSuccess) // setAccountDataState(accountEntityUpdateData)
                    showAlert({
                        type: 'success',
                        message: 'Successfully updated record'
                    });
                    else if (!isAccountEntityUpdateSuccess) {
                        if (typeof accountEntityUpdateError?.response?.data?.data === 'string') {
                            showAlert({
                                type: 'error',
                                message: accountEntityUpdateError?.response?.data?.data
                            });
                            return;
                        }
                        handleCancel();
                        showAlert({
                            type: 'error',
                            message: 'An error occurred in updating record'
                        });
                    }
                }
                setViewMode(true);
            }
        }
    };
    const handleLoadingAccount = ()=>{
        if (isAccountLoading) setShowHeaderLoader(true);
        if (!isAccountLoading) setShowHeaderLoader(false);
    };
    // useEffect
    (0, $tZqWC.useEffect)(()=>{
        fetchData();
        setAccountAddressFitlers();
    }, []);
    // useEffect(() => handleCancel(), [accountDetailsPage, overviewPage])
    (0, $tZqWC.useEffect)(()=>accountData && setAccountDataState(accountData), [
        accountData
    ]);
    (0, $tZqWC.useEffect)(()=>handleLoadingAccount(), [
        isAccountLoading
    ]);
    (0, $tZqWC.useEffect)(()=>fakeLoading && setFakeLoading(false), [
        fakeLoading
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (accountFormRef?.current && riskFormRef?.current) handleLoadingUpdateChange();
    }, [
        isAccountEntityUpdateLoading,
        isAccountIndividualUpdateLoading
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e8aad90d70d3b625$export$e6dfd72ab29f8598), {
        children: !isAccountLoading && accountDataState && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $e8aad90d70d3b625$export$f99233281efd08a0), {
                    children: [
                        "ID: ",
                        accountDataState.reference_id
                    ]
                }),
                ' ',
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $e8aad90d70d3b625$export$cf345ef34cd72655), {
                    children: [
                        accountDataState.account_type_id === 1 ? 'Individual' : 'Business',
                        ' ',
                        accountDataState.is_customer ? 'Customer' : 'Non-Customer'
                    ]
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $e8aad90d70d3b625$export$42a852a2b6b56249), {
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c6cc9151de134171$export$2e2bcd8739ae039), {
                            isButton: true,
                            page: overviewPage,
                            setPage: setOverviewPage,
                            pages: (0, $f398806f8c37b1c3$export$969ddde627a04710)
                        }),
                        overviewPage === 0 && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e8aad90d70d3b625$export$d7a54cba636a8cd6), {}),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6a72c94d19cb5e60$export$2e2bcd8739ae039), {
                                    account_id: account_id,
                                    account_data: accountDataState,
                                    activeTable: activeTable,
                                    setActiveTable: setActiveTable
                                })
                            ]
                        }),
                        overviewPage === 1 && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                            children: [
                                viewMode === true && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e8aad90d70d3b625$export$518140168539ec9f), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                        color: "primary",
                                        onClick: ()=>setViewMode(false),
                                        children: "Edit"
                                    })
                                }),
                                accountDataState.account_type_id === 1 ? !fakeLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $8b8273179d9c47a1$export$2e2bcd8739ae039), {
                                            values: accountDataState,
                                            viewMode: viewMode,
                                            formRef: accountFormRef,
                                            onSubmit: handleOnSubmit
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d9b5ab15e6992d28$export$2e2bcd8739ae039), {
                                            values: accountDataState,
                                            viewMode: viewMode,
                                            formRef: riskFormRef,
                                            onSubmit: handleOnSubmit
                                        })
                                    ]
                                }) : !fakeLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $52d701a051d389bb$export$2e2bcd8739ae039), {
                                            values: accountDataState,
                                            viewMode: viewMode,
                                            formRef: accountFormRef,
                                            onSubmit: handleOnSubmit
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d9b5ab15e6992d28$export$2e2bcd8739ae039), {
                                            values: accountDataState,
                                            viewMode: viewMode,
                                            formRef: riskFormRef,
                                            onSubmit: handleOnSubmit
                                        })
                                    ]
                                }),
                                viewMode === false && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $e8aad90d70d3b625$export$f7572adddafd5ab7), {
                                    children: [
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                            type: "button",
                                            onClick: handleCancel,
                                            variant: "outlined",
                                            startIcon: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b77b5de3fb591045$export$2e2bcd8739ae039), {
                                                size: 14
                                            }),
                                            children: "Cancel"
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                            type: "button",
                                            onClick: ()=>accountFormRef.current.submitForm(),
                                            startIcon: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $462cc6e9cac360f1$export$2e2bcd8739ae039), {
                                                size: 14
                                            }),
                                            children: "Save Changes"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                overviewPage === 0 && activeTable === 0 && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bf8087a9914394f3$export$2e2bcd8739ae039), {}),
                overviewPage === 0 && (activeTable === 1 || activeTable === 2) && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d15d184f094f52f8$export$2e2bcd8739ae039), {
                    activeTable: activeTable
                })
            ]
        })
    });
}
// Default Props
$db625bee87814325$var$AccountDetails.defaultProps = {
    actions: {},
    filters: {},
    ui: {}
};
// Proptypes Validation
$db625bee87814325$var$AccountDetails.propTypes = {
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        accountDirectoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object)
    }),
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setAccountDirectoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsIndividualAccountDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsEntityAccountDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAddressFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $db625bee87814325$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($db625bee87814325$var$mapStateToProps, $db625bee87814325$var$mapDispatchToProps)($db625bee87814325$var$AccountDetails);


var $62a694e1d6159301$export$2e2bcd8739ae039 = (0, $db625bee87814325$export$2e2bcd8739ae039);







var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");






const $9b91c0812b93d0fd$export$4267411171632d35 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $9b91c0812b93d0fd$export$cbf11d5f692bc726 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
`;
const $9b91c0812b93d0fd$export$97d84ed62ab03b3f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  margin: 0px 0px 0px 16px;

  font-weight: inherit;
  font-size: inherit;
`;






var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");


var $ejSM7 = parcelRequire("ejSM7");

const $d398ccce7d473b82$export$5f1af8db9871e1d6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  font-size: 13px;
  margin: 0;
  text-align: right;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $d398ccce7d473b82$export$b04be29aa201d4f5 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  font-size: 13px;
  margin: 0;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $d398ccce7d473b82$export$f99233281efd08a0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h3`
  margin: 0;
  font-size: 40px;
  font-weight: 700;
  padding-right: 15px;
  margin-right: 15px;
  border-right: 1px solid ${({ theme: theme })=>theme.colors.secondary};
  color: ${({ theme: theme })=>theme.colors.primary};
  text-transform: capitalize;
`;
const $d398ccce7d473b82$export$d5c56664638992a4 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h4`
  font-size: 16px;
  margin: 0;
  color: ${({ theme: theme })=>theme.colors.primary};
  font-weight: 400;

  max-width: 260px;
  width: 190px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;
const $d398ccce7d473b82$export$987cac99e7a31168 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: 1fr 1fr;
`;
const $d398ccce7d473b82$export$2157c074a0891857 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  text-transform: uppercase;
`;
const $d398ccce7d473b82$export$6f4a084cc8e379b6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 20px;
  &:last-child {
    background-color: ${({ theme: theme })=>theme.colors.background};
    border-radius: 0 0 10px 10px;
  }
`;
const $d398ccce7d473b82$export$9f515a68dfaeb9ef = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  padding: 20px;
  background-color: ${({ theme: theme })=>`${theme.colors.secondary}10`};
  border-bottom: 2px solid ${({ theme: theme })=>theme.colors.backgroundLite};
  border-radius: 10px 10px 0 0;
`;
const $d398ccce7d473b82$export$15529022dcaf3eec = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-end;
`;
const $d398ccce7d473b82$export$5a7f9a6004988d01 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  font-size: 13px;
  margin: 0 0 4px 0;
  width: fit-content;
  padding: 2px 28px;
  ${({ theme: theme, customer_status_id: customer_status_id })=>`
    ${customer_status_id === -1 && `
      color: ${theme.colors.red};
      background-color: transparent;
      border: 1px solid ${theme.colors.red};
      border-radius: 8px;
    `}
  `};
  ${({ theme: theme, customer_status_id: customer_status_id })=>`
    ${customer_status_id === -2 && `
      color: ${theme.colors.primary};
      background-color: transparent;
      border: 1px solid ${theme.colors.primary};
      border-radius: 8px;
    `}
  `};
`;




function $d0698680ab618173$var$VaspsTableItem(props) {
    // Destructure
    const { vaspDetails: vaspDetails } = props;
    const { external_id: external_id, name_business: name_business, name_legal: name_legal, id: id, website: website, created: created, vasp_id: vasp_id } = vaspDetails;
    // State
    const [cardName, setCardName] = (0, $tZqWC.useState)({});
    // Functions
    function handleName() {
        let name = name_business || name_legal;
        if (!name) name = '-';
        const nameArr = name?.split(' ');
        const firstNameLength = Math.floor(nameArr.length / 2);
        const firstName = [];
        for(let i = 0; i < firstNameLength; i++)firstName.push(nameArr[i]);
        nameArr.splice(0, firstNameLength);
        setCardName({
            initials: (name[0] || '') + (name[1] || ''),
            fullname: [
                firstName.join(' '),
                nameArr.join(' ')
            ]
        });
    }
    // useEffect
    (0, $tZqWC.useEffect)(()=>{
        handleName();
    }, [
        external_id
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $12b33660068e86aa$export$b0d92dbee9b5b60d), {
        to: `/directory/vasps/details/${id}`,
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $37202d75ee8521c4$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $d398ccce7d473b82$export$9f515a68dfaeb9ef), {
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d398ccce7d473b82$export$f99233281efd08a0), {
                            children: cardName.initials || ''
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $d398ccce7d473b82$export$2157c074a0891857), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d398ccce7d473b82$export$d5c56664638992a4), {
                                    children: cardName.fullname && cardName.fullname[0]
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d398ccce7d473b82$export$d5c56664638992a4), {
                                    children: cardName.fullname && cardName.fullname[1]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $d398ccce7d473b82$export$6f4a084cc8e379b6), {
                    children: [
                        vaspDetails?.customer_status_id !== null && vaspDetails?.customer_status_id !== undefined && (vaspDetails?.customer_status_id === -1 || vaspDetails?.customer_status_id === -2) && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $d398ccce7d473b82$export$987cac99e7a31168), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d398ccce7d473b82$export$b04be29aa201d4f5), {
                                    children: "Status: "
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d398ccce7d473b82$export$15529022dcaf3eec), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $d398ccce7d473b82$export$5a7f9a6004988d01), {
                                        customer_status_id: vaspDetails.customer_status_id,
                                        children: [
                                            vaspDetails?.customer_status_id === -1 && 'Rejected',
                                            vaspDetails?.customer_status_id === -2 && 'Requested'
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $d398ccce7d473b82$export$987cac99e7a31168), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d398ccce7d473b82$export$b04be29aa201d4f5), {
                                    children: "Vasp ID: "
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d398ccce7d473b82$export$5f1af8db9871e1d6), {
                                    children: vasp_id || '-'
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $d398ccce7d473b82$export$987cac99e7a31168), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d398ccce7d473b82$export$b04be29aa201d4f5), {
                                    children: "Website: "
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d398ccce7d473b82$export$5f1af8db9871e1d6), {
                                    children: website || '-'
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $d398ccce7d473b82$export$987cac99e7a31168), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d398ccce7d473b82$export$b04be29aa201d4f5), {
                                    children: "Latest update: "
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d398ccce7d473b82$export$5f1af8db9871e1d6), {
                                    children: (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(created).format((0, $41a9e38e6be32f35$export$859ef203c4495ed2))
                                })
                            ]
                        })
                    ]
                })
            ]
        }, external_id)
    });
}
// Default Props
$d0698680ab618173$var$VaspsTableItem.defaultProps = {};
// Proptypes Validation
$d0698680ab618173$var$VaspsTableItem.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    vaspDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).any
};
var $d0698680ab618173$export$2e2bcd8739ae039 = $d0698680ab618173$var$VaspsTableItem;


var $70ee8851925af7a1$export$2e2bcd8739ae039 = (0, $d0698680ab618173$export$2e2bcd8739ae039);


// Map Redux Props
const $d4ab8b37eb4d2578$var$mapStateToProps = (state)=>state;
const $d4ab8b37eb4d2578$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $d4ab8b37eb4d2578$var$VaspsTable(props) {
    // Destructure
    const { filters: filters, ui: ui, actions: actions } = props;
    // Store States
    const { vaspDirectoryFilters: vaspDirectoryFilters } = filters;
    const { isPageTableUpdated: isPageTableUpdated } = ui;
    // Store Actions
    const { setVaspDirectoryFilters: setVaspDirectoryFilters, setIsRequestVaspModalOpen: setIsRequestVaspModalOpen, setToBeUpdatedVasp: setToBeUpdatedVasp, setIsPageTableUpdated: setIsPageTableUpdated } = actions;
    // Variables
    const { sort: sort, page: page, size: size } = vaspDirectoryFilters;
    // States
    const [vaspsDataState, setVaspsDataState] = (0, $tZqWC.useState)({
        items: [],
        total: 0,
        page: 1
    });
    // Hooks
    const [userCredentials] = (0, $a9c50ebe96619b20$export$2e2bcd8739ae039)('userCredentials', false);
    const { allVaspsData: allVaspsData, getAllVasps: getAllVasps, isAllVaspsLoading: isAllVaspsLoading } = (0, $40506d7d94723792$export$2e2bcd8739ae039)();
    // Functions
    const fetchVasps = ()=>{
        getAllVasps({
            biz_id: userCredentials.Business_ID,
            sort: sort,
            page: page,
            size: size
        });
    };
    // UseEffects
    (0, $tZqWC.useEffect)(()=>{
        if (allVaspsData) setVaspsDataState(allVaspsData);
    }, [
        allVaspsData
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (vaspDirectoryFilters || isPageTableUpdated) {
            fetchVasps();
            setIsPageTableUpdated(false);
        }
    }, [
        vaspDirectoryFilters,
        isPageTableUpdated
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9b91c0812b93d0fd$export$4267411171632d35), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7139282abdeb8ca4$export$2e2bcd8739ae039), {
            totalItems: vaspsDataState.total,
            headerOptions: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                onClick: ()=>{
                    setToBeUpdatedVasp(null);
                    setIsRequestVaspModalOpen(true);
                },
                size: "small",
                startIcon: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6417d0fa9c066aa3$export$2e2bcd8739ae039), {
                    size: 12
                }),
                variant: "outlined",
                children: "Request Vasp"
            }),
            minWidth: 900,
            filterComponents: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d3cd0ff9e1046ed5$export$2e2bcd8739ae039), {}),
            tableFilters: vaspDirectoryFilters,
            setTableFilters: setVaspDirectoryFilters,
            children: vaspsDataState.items.length > 0 && !isAllVaspsLoading ? vaspsDataState.items.map((vaspDetails)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $70ee8851925af7a1$export$2e2bcd8739ae039), {
                    vaspDetails: vaspDetails
                }, vaspDetails.id)) : /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                children: [
                    isAllVaspsLoading ? /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $647b8bc68ebce54f$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a6ea3b0f3caed586$export$2e2bcd8739ae039), {
                        setFilter: setVaspDirectoryFilters
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("div", {})
                ]
            })
        }, vaspsDataState?.page)
    });
}
// Default Props
$d4ab8b37eb4d2578$var$VaspsTable.defaultProps = {
    actions: {},
    filters: {},
    ui: {}
};
// Proptypes Validation
$d4ab8b37eb4d2578$var$VaspsTable.propTypes = {
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        vaspDirectoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object)
    }),
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setVaspDirectoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setToBeUpdatedVasp: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsRequestVaspModalOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsEntityVaspDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        toggleUpgradeModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setInfoModalDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $d4ab8b37eb4d2578$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($d4ab8b37eb4d2578$var$mapStateToProps, $d4ab8b37eb4d2578$var$mapDispatchToProps)($d4ab8b37eb4d2578$var$VaspsTable);


var $f90c01f719bc4742$export$2e2bcd8739ae039 = (0, $d4ab8b37eb4d2578$export$2e2bcd8739ae039);





var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");






const $c1e88b4e306c9912$export$e6dfd72ab29f8598 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
`;
const $c1e88b4e306c9912$export$518140168539ec9f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-end;
  margin: 0 0 -40px 0;
`;
const $c1e88b4e306c9912$export$f7572adddafd5ab7 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-end;
  gap: 20px;
  margin-top: 40px;
`;
const $c1e88b4e306c9912$export$f99233281efd08a0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h1`
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  text-transform: uppercase;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $c1e88b4e306c9912$export$cf345ef34cd72655 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  margin: 0;
  font-size: 10px;
  font-weight: 400;
  letter-spacing: 0.5px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $c1e88b4e306c9912$export$42a852a2b6b56249 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  margin-top: 20px;
  padding: 30px;
  border-radius: 10px;
  background: ${({ theme: theme })=>theme.colors.background};
`;
const $c1e88b4e306c9912$export$33203cad3bced98c = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  padding-top: 40px;
  max-width: 500px;
`;
const $c1e88b4e306c9912$export$b59bdbef9ce70de2 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 2px solid ${({ theme: theme })=>theme.colors.backgroundLite};

  &:last-child {
    border: none;
    padding: 10px 0 0 0;
  }
`;
const $c1e88b4e306c9912$export$99836757d2dc7b18 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 15px;
  font-weight: 600;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $c1e88b4e306c9912$export$5f1af8db9871e1d6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 15px;
  font-weight: 400;
  color: ${({ theme: theme })=>theme.colors.primary};
`;




// Map Redux Props
const $ccdeb451d4e14780$var$mapStateToProps = (state)=>state;
const $ccdeb451d4e14780$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $ccdeb451d4e14780$var$VaspDetails(props) {
    // Destructure
    const { actions: actions } = props;
    const { vasp_id: vasp_id } = (0, $a0d5c3f2fe524011$export$99eaa27ddbbb95ef)();
    // store actions
    const { setShowHeaderLoader: setShowHeaderLoader, showAlert: showAlert } = actions;
    // refs
    const formRef = (0, $tZqWC.useRef)();
    // hooks
    const { getVasp: getVasp, vaspData: vaspData, isVaspLoading: isVaspLoading } = (0, $462c3808bdeaeab0$export$2e2bcd8739ae039)();
    const { updateVasp: updateVasp, isVaspUpdateLoading: isVaspUpdateLoading, isVaspUpdateSuccess: isVaspUpdateSuccess } = (0, $05f6f04b561b761e$export$2e2bcd8739ae039)();
    // state
    const [vaspDataState, setVaspDataState] = (0, $tZqWC.useState)();
    const [viewMode, setViewMode] = (0, $tZqWC.useState)(true);
    // functions
    const fetchData = ()=>{
        getVasp({
            vasp_id: vasp_id
        });
    };
    const handleSave = ()=>{
        setViewMode(true);
        const newPayload = formRef.current.values;
        updateVasp({
            vasp_id: vasp_id,
            values: newPayload
        });
    };
    const handleCancel = ()=>{
        setViewMode(true);
        setVaspDataState(vaspData);
    };
    const handleLoadingUpdateChange = ()=>{
        if (isVaspUpdateLoading) setShowHeaderLoader(true);
        if (!isVaspUpdateLoading) {
            setShowHeaderLoader(false);
            if (vaspDataState) {
                if (isVaspUpdateSuccess) showAlert({
                    type: 'success',
                    message: 'Successfully updated record'
                });
                else if (!isVaspUpdateSuccess) showAlert({
                    type: 'error',
                    message: 'An error occurred in updating record'
                });
            }
        }
    };
    const handleLoadingVasp = ()=>{
        if (isVaspLoading) setShowHeaderLoader(true);
        if (!isVaspLoading) setShowHeaderLoader(false);
    };
    // useEffect
    (0, $tZqWC.useEffect)(()=>fetchData(), []);
    (0, $tZqWC.useEffect)(()=>{
        if (vaspData) setVaspDataState(vaspData);
    }, [
        vaspData
    ]);
    (0, $tZqWC.useEffect)(()=>handleLoadingVasp(), [
        isVaspLoading
    ]);
    (0, $tZqWC.useEffect)(()=>handleLoadingUpdateChange(), [
        isVaspUpdateLoading
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c1e88b4e306c9912$export$e6dfd72ab29f8598), {
        children: !isVaspLoading && vaspDataState && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c1e88b4e306c9912$export$f99233281efd08a0), {
                    children: vaspDataState.name_business
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $c1e88b4e306c9912$export$42a852a2b6b56249), {
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $31c31aa6819313d7$export$2e2bcd8739ae039), {
                            values: vaspDataState,
                            viewMode: viewMode,
                            formRef: formRef
                        }),
                        viewMode === false && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $c1e88b4e306c9912$export$f7572adddafd5ab7), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                    type: "button",
                                    onClick: handleCancel,
                                    variant: "outlined",
                                    startIcon: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b77b5de3fb591045$export$2e2bcd8739ae039), {
                                        size: 18
                                    }),
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                    type: "button",
                                    onClick: handleSave,
                                    startIcon: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $462cc6e9cac360f1$export$2e2bcd8739ae039), {
                                        size: 18
                                    }),
                                    children: "Save Changes"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
// Default Props
$ccdeb451d4e14780$var$VaspDetails.defaultProps = {
    actions: {},
    filters: {},
    ui: {}
};
// Proptypes Validation
$ccdeb451d4e14780$var$VaspDetails.propTypes = {
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        vaspDirectoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object)
    }),
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setVaspDirectoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsIndividualVaspDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsEntityVaspDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $ccdeb451d4e14780$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($ccdeb451d4e14780$var$mapStateToProps, $ccdeb451d4e14780$var$mapDispatchToProps)($ccdeb451d4e14780$var$VaspDetails);


var $947a021aba7686cf$export$2e2bcd8739ae039 = (0, $ccdeb451d4e14780$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");





const $8b9c6916177e1008$export$4267411171632d35 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  margin-top: 12px;
`;
const $8b9c6916177e1008$export$cbf11d5f692bc726 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
`;
const $8b9c6916177e1008$export$97d84ed62ab03b3f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  margin: 0px 0px 0px 16px;

  font-weight: inherit;
  font-size: inherit;
`;





// Map Redux Props
const $03f4dd46041dbb4c$var$mapStateToProps = (state)=>state;
const $03f4dd46041dbb4c$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $03f4dd46041dbb4c$var$RequestedVaspsTable(props) {
    // Destructure
    const { filters: filters, ui: ui, actions: actions } = props;
    // Store States
    const { vaspDirectoryFilters: vaspDirectoryFilters } = filters;
    const { isPageTableUpdated: isPageTableUpdated } = ui;
    // Store Actions
    const { setVaspDirectoryFilters: setVaspDirectoryFilters, setIsPageTableUpdated: setIsPageTableUpdated } = actions;
    // Variables
    const { sort: sort, page: page, size: size } = vaspDirectoryFilters;
    // States
    const [vaspsDataState, setVaspsDataState] = (0, $tZqWC.useState)({
        items: [],
        total: 0,
        page: 1
    });
    // Hooks
    const [userCredentials] = (0, $a9c50ebe96619b20$export$2e2bcd8739ae039)('userCredentials', false);
    const { allVaspsData: allVaspsData, getAllVasps: getAllVasps, isAllVaspsLoading: isAllVaspsLoading } = (0, $40506d7d94723792$export$2e2bcd8739ae039)();
    // Functions
    const fetchVasps = ()=>{
        getAllVasps({
            biz_id: userCredentials.Business_ID,
            sort: sort,
            page: page,
            size: size,
            customer_status_id: -1
        });
    };
    // UseEffects
    (0, $tZqWC.useEffect)(()=>{
        if (allVaspsData) setVaspsDataState(allVaspsData);
    }, [
        allVaspsData
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (vaspDirectoryFilters || isPageTableUpdated) {
            fetchVasps();
            setIsPageTableUpdated(false);
        }
    }, [
        vaspDirectoryFilters,
        isPageTableUpdated
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $8b9c6916177e1008$export$4267411171632d35), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7139282abdeb8ca4$export$2e2bcd8739ae039), {
            totalItems: vaspsDataState.total,
            minWidth: 900,
            filterComponents: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b6d9d515100cd1b1$export$2e2bcd8739ae039), {}),
            tableFilters: vaspDirectoryFilters,
            setTableFilters: setVaspDirectoryFilters,
            children: vaspsDataState.items.length > 0 && !isAllVaspsLoading ? vaspsDataState.items.map((vaspDetails)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $70ee8851925af7a1$export$2e2bcd8739ae039), {
                    vaspDetails: vaspDetails
                }, vaspDetails.id)) : /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                children: [
                    isAllVaspsLoading ? /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $647b8bc68ebce54f$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a6ea3b0f3caed586$export$2e2bcd8739ae039), {
                        setFilter: setVaspDirectoryFilters
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("div", {})
                ]
            })
        }, vaspsDataState?.page)
    });
}
// Default Props
$03f4dd46041dbb4c$var$RequestedVaspsTable.defaultProps = {
    actions: {},
    filters: {},
    ui: {}
};
// Proptypes Validation
$03f4dd46041dbb4c$var$RequestedVaspsTable.propTypes = {
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        vaspDirectoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object)
    }),
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setVaspDirectoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setToBeUpdatedVasp: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsVaspDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsEntityVaspDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        toggleUpgradeModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setInfoModalDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $03f4dd46041dbb4c$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($03f4dd46041dbb4c$var$mapStateToProps, $03f4dd46041dbb4c$var$mapDispatchToProps)($03f4dd46041dbb4c$var$RequestedVaspsTable);


var $135d46179e8e3c5a$export$2e2bcd8739ae039 = (0, $03f4dd46041dbb4c$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");





const $a0ed0c0f1f6a89f5$export$e6dfd72ab29f8598 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
`;
const $a0ed0c0f1f6a89f5$export$518140168539ec9f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-end;
  margin: 0 0 -40px 0;
`;
const $a0ed0c0f1f6a89f5$export$f7572adddafd5ab7 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-end;
  gap: 20px;
  margin-top: 40px;
`;
const $a0ed0c0f1f6a89f5$export$f99233281efd08a0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h1`
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  text-transform: uppercase;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $a0ed0c0f1f6a89f5$export$cf345ef34cd72655 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  margin: 0;
  font-size: 10px;
  font-weight: 400;
  letter-spacing: 0.5px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $a0ed0c0f1f6a89f5$export$42a852a2b6b56249 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  margin-top: 20px;
  padding: 30px;
  border-radius: 10px;
  background: ${({ theme: theme })=>theme.colors.background};
`;
const $a0ed0c0f1f6a89f5$export$33203cad3bced98c = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  padding-top: 40px;
  max-width: 500px;
`;
const $a0ed0c0f1f6a89f5$export$b59bdbef9ce70de2 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 2px solid ${({ theme: theme })=>theme.colors.backgroundLite};

  &:last-child {
    border: none;
    padding: 10px 0 0 0;
  }
`;
const $a0ed0c0f1f6a89f5$export$99836757d2dc7b18 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 15px;
  font-weight: 600;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $a0ed0c0f1f6a89f5$export$5f1af8db9871e1d6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 15px;
  font-weight: 400;
  color: ${({ theme: theme })=>theme.colors.primary};
`;



// Map Redux Props
const $5f3935d0940d0e93$var$mapStateToProps = (state)=>state;
const $5f3935d0940d0e93$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $5f3935d0940d0e93$var$RequestedVaspDetails(props) {
    // Destructure
    const { actions: actions } = props;
    const { vasp_id: vasp_id } = (0, $a0d5c3f2fe524011$export$99eaa27ddbbb95ef)();
    // store actions
    const { setShowHeaderLoader: setShowHeaderLoader, showAlert: showAlert } = actions;
    // refs
    const formRef = (0, $tZqWC.useRef)();
    // hooks
    const { getVasp: getVasp, vaspData: vaspData, isVaspLoading: isVaspLoading } = (0, $462c3808bdeaeab0$export$2e2bcd8739ae039)();
    const { isVaspUpdateLoading: // updateVasp,
    isVaspUpdateLoading, isVaspUpdateSuccess: isVaspUpdateSuccess } = (0, $05f6f04b561b761e$export$2e2bcd8739ae039)();
    // state
    const [vaspDataState, setVaspDataState] = (0, $tZqWC.useState)();
    const [viewMode] = (0, $tZqWC.useState)(true);
    // functions
    const fetchData = ()=>{
        getVasp({
            vasp_id: vasp_id
        });
    };
    // const handleSave = () => {
    //   setViewMode(true)
    //   const newPayload = formRef.current.values
    //   updateVasp({ vasp_id, values: newPayload })
    // }
    // const handleCancel = () => {
    //   setViewMode(true)
    //   setVaspDataState(vaspData)
    // }
    const handleLoadingUpdateChange = ()=>{
        if (isVaspUpdateLoading) setShowHeaderLoader(true);
        if (!isVaspUpdateLoading) {
            setShowHeaderLoader(false);
            if (vaspDataState) {
                if (isVaspUpdateSuccess) showAlert({
                    type: 'success',
                    message: 'Successfully updated record'
                });
                else if (!isVaspUpdateSuccess) showAlert({
                    type: 'error',
                    message: 'An error occurred in updating record'
                });
            }
        }
    };
    const handleLoadingVasp = ()=>{
        if (isVaspLoading) setShowHeaderLoader(true);
        if (!isVaspLoading) setShowHeaderLoader(false);
    };
    // useEffect
    (0, $tZqWC.useEffect)(()=>fetchData(), []);
    (0, $tZqWC.useEffect)(()=>{
        if (vaspData) setVaspDataState(vaspData);
    }, [
        vaspData
    ]);
    (0, $tZqWC.useEffect)(()=>handleLoadingVasp(), [
        isVaspLoading
    ]);
    (0, $tZqWC.useEffect)(()=>handleLoadingUpdateChange(), [
        isVaspUpdateLoading
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a0ed0c0f1f6a89f5$export$e6dfd72ab29f8598), {
        children: !isVaspLoading && vaspDataState && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a0ed0c0f1f6a89f5$export$f99233281efd08a0), {
                    children: vaspDataState.name_legal
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a0ed0c0f1f6a89f5$export$42a852a2b6b56249), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $31c31aa6819313d7$export$2e2bcd8739ae039), {
                        values: vaspDataState,
                        viewMode: viewMode,
                        formRef: formRef
                    })
                })
            ]
        })
    });
}
// Default Props
$5f3935d0940d0e93$var$RequestedVaspDetails.defaultProps = {
    actions: {},
    filters: {},
    ui: {}
};
// Proptypes Validation
$5f3935d0940d0e93$var$RequestedVaspDetails.propTypes = {
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        vaspDirectoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object)
    }),
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setVaspDirectoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsIndividualVaspDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsEntityVaspDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $5f3935d0940d0e93$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($5f3935d0940d0e93$var$mapStateToProps, $5f3935d0940d0e93$var$mapDispatchToProps)($5f3935d0940d0e93$var$RequestedVaspDetails);


var $bf6e3e8e85268ed6$export$2e2bcd8739ae039 = (0, $5f3935d0940d0e93$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");




const $84c675c4d0173e63$export$4267411171632d35 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $84c675c4d0173e63$export$cbf11d5f692bc726 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
`;
const $84c675c4d0173e63$export$97d84ed62ab03b3f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  margin: 0px 0px 0px 16px;

  font-weight: inherit;
  font-size: inherit;
`;




/* eslint-disable react/no-unstable-nested-components */ 

var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");


var $ejSM7 = parcelRequire("ejSM7");
var $33c7f0b526e1c5e7$exports = {};
(function(a, b) {
    if ("function" == typeof define && define.amd) define([], b);
    else b();
})($33c7f0b526e1c5e7$exports, function() {
    "use strict";
    function b(a, b) {
        return "undefined" == typeof b ? b = {
            autoBom: !1
        } : "object" != typeof b && (console.warn("Deprecated: Expected third argument to be a object"), b = {
            autoBom: !b
        }), b.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type) ? new Blob([
            "\uFEFF",
            a
        ], {
            type: a.type
        }) : a;
    }
    function c(a, b, c) {
        var d = new XMLHttpRequest;
        d.open("GET", a), d.responseType = "blob", d.onload = function() {
            g(d.response, b, c);
        }, d.onerror = function() {
            console.error("could not download file");
        }, d.send();
    }
    function d(a) {
        var b = new XMLHttpRequest;
        b.open("HEAD", a, !1);
        try {
            b.send();
        } catch (a) {}
        return 200 <= b.status && 299 >= b.status;
    }
    function e(a) {
        try {
            a.dispatchEvent(new MouseEvent("click"));
        } catch (c) {
            var b = document.createEvent("MouseEvents");
            b.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), a.dispatchEvent(b);
        }
    }
    var f = "object" == typeof window && window.window === window ? window : "object" == typeof self && self.self === self ? self : "object" == typeof $parcel$global && $parcel$global.global === $parcel$global ? $parcel$global : void 0, a = f.navigator && /Macintosh/.test(navigator.userAgent) && /AppleWebKit/.test(navigator.userAgent) && !/Safari/.test(navigator.userAgent), g = f.saveAs || ("object" != typeof window || window !== f ? function() {} : "download" in HTMLAnchorElement.prototype && !a ? function(b, g, h) {
        var i = f.URL || f.webkitURL, j = document.createElement("a");
        g = g || b.name || "download", j.download = g, j.rel = "noopener", "string" == typeof b ? (j.href = b, j.origin === location.origin ? e(j) : d(j.href) ? c(b, g, h) : e(j, j.target = "_blank")) : (j.href = i.createObjectURL(b), setTimeout(function() {
            i.revokeObjectURL(j.href);
        }, 4E4), setTimeout(function() {
            e(j);
        }, 0));
    } : "msSaveOrOpenBlob" in navigator ? function(f, g, h) {
        if (g = g || f.name || "download", "string" != typeof f) navigator.msSaveOrOpenBlob(b(f, h), g);
        else if (d(f)) c(f, g, h);
        else {
            var i = document.createElement("a");
            i.href = f, i.target = "_blank", setTimeout(function() {
                e(i);
            });
        }
    } : function(b, d, e, g) {
        if (g = g || open("", "_blank"), g && (g.document.title = g.document.body.innerText = "downloading..."), "string" == typeof b) return c(b, d, e);
        var h = "application/octet-stream" === b.type, i = /constructor/i.test(f.HTMLElement) || f.safari, j = /CriOS\/[\d]+/.test(navigator.userAgent);
        if ((j || h && i || a) && "undefined" != typeof FileReader) {
            var k = new FileReader;
            k.onloadend = function() {
                var a = k.result;
                a = j ? a : a.replace(/^data:[^;]*;/, "data:attachment/file;"), g ? g.location.href = a : location = a, g = null;
            }, k.readAsDataURL(b);
        } else {
            var l = f.URL || f.webkitURL, m = l.createObjectURL(b);
            g ? g.location = m : location.href = m, g = null, setTimeout(function() {
                l.revokeObjectURL(m);
            }, 4E4);
        }
    });
    f.saveAs = g.saveAs = g, $33c7f0b526e1c5e7$exports = g;
});





const $ac912f62971842fa$export$fd2299f554be8993 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: 1.8fr 1fr;
  gap: 50px;
  align-items: center;

  padding: 2px 10px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $ac912f62971842fa$export$9f515a68dfaeb9ef = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  gap: 20px;

  &:last-child > div:last-child {
    max-width: 250px;
    justify-content: flex-end;
  }
  &:last-child > div:first-child {
    justify-content: flex-end;
    max-width: 550px;
  }
`;
const $ac912f62971842fa$export$987cac99e7a31168 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  width: 100%;

  gap: 20px;
`;
const $ac912f62971842fa$export$6f4a084cc8e379b6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
`;
const $ac912f62971842fa$export$49316f37c3b5fade = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 15px;
  font-weight: 400;
  text-transform: capitalize;
  max-width: 250px;

  &:first-child {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
`;
const $ac912f62971842fa$export$b502300b413480 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).span`
  font-size: 8px;
  font-weight: 400;
`;
const $ac912f62971842fa$export$65b9fe47bb7b64b0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 10px;
  font-weight: 400;
`;
const $ac912f62971842fa$export$85524e8d4e82fc69 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $ac912f62971842fa$export$ccff7fe96c96c97 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 5px 30px;
  border-radius: 10px;
  width: 100%;
  text-align: center;
  ${({ theme: theme, status: status })=>status === 'Completed' && `color: ${theme.colors.brand}; border: 1px solid ${theme.colors.brand};`}
  ${({ theme: theme, status: status })=>status === 'Pending' && `color: ${theme.colors.yellowGreen}; border: 1px solid ${theme.colors.yellowGreen};`}
`;




// Map Redux Props
const $90be0d8206ccbf9a$var$mapStateToProps = (state)=>state;
const $90be0d8206ccbf9a$var$mapDispatchToProps = (dispatch)=>(0, $2154a4c08d887b32$export$e324594224ef24da)(dispatch);
function $90be0d8206ccbf9a$var$ReportsAddressTableItem(props) {
    // Destructure
    const { data: data, actions: actions } = props;
    const { showAlert: showAlert } = actions;
    const { id: id, created: created, report_type: report_type, sections: sections, status_name: status_name } = data;
    // Hooks
    const { getReport: getReport, getReportData: getReportData, getReportError: getReportError, isGetReportLoading: isGetReportLoading } = (0, $103aa3f158259fba$export$2e2bcd8739ae039)();
    // States
    const [format, setFormat] = (0, $tZqWC.useState)('CSV');
    // function formatValue(number) {
    //   if (number < 1_000_000) {
    //     return numberWithCommas(Math.round(number * 100) / 100)
    //   }
    //   return compactNumberFormatter.format(number)
    // }
    // Constants
    const FORMAT_OPTIONS = [
        {
            value: 'CSV',
            onClick: ()=>setFormat('CSV')
        },
        // {
        //   value: 'PDF',
        //   onClick: () => setFormat('PDF'),
        // },
        {
            value: 'JSON',
            onClick: ()=>setFormat('JSON')
        }
    ];
    // Functions
    const handleDownload = ()=>{
        getReport({
            format: format.toLowerCase(),
            report_id: id
        });
    };
    const downloadFile = (data, inputFormat)=>{
        let blob;
        if (inputFormat === 'CSV') blob = new Blob([
            data
        ], {
            type: `text/${inputFormat.toLowerCase()}; charset=utf-8`
        });
        if (inputFormat === 'JSON') blob = new Blob([
            JSON.stringify(data)
        ], {
            type: 'text/plain;charset=utf-8'
        });
        (0, $33c7f0b526e1c5e7$exports.saveAs)(blob, `Ospree_Report.${format.toLowerCase()}`);
    };
    // UseEffect
    (0, $tZqWC.useEffect)(()=>getReportData && downloadFile(getReportData, format), [
        getReportData
    ]);
    (0, $tZqWC.useEffect)(()=>{
        // TODO ADD PROPER ERROR MSG SENT FROM SERVER
        if (getReportError) showAlert({
            type: 'error',
            message: 'An error occurred in fetching reports'
        });
    }, [
        getReportError
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f32a2c939d2829ea$export$2e2bcd8739ae039), {
        children: isGetReportLoading ? /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ac912f62971842fa$export$fd2299f554be8993), {
            style: {
                display: 'flex',
                justifyContent: 'center'
            },
            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ac912f62971842fa$export$49316f37c3b5fade), {
                children: "Downloading..."
            })
        }) : /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $ac912f62971842fa$export$fd2299f554be8993), {
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $ac912f62971842fa$export$9f515a68dfaeb9ef), {
                    style: {
                        gridTemplateColumns: '1fr 0.7fr 2fr'
                    },
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ac912f62971842fa$export$987cac99e7a31168), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ac912f62971842fa$export$49316f37c3b5fade), {
                                children: created && (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(created).format((0, $41a9e38e6be32f35$export$859ef203c4495ed2))
                            })
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ac912f62971842fa$export$987cac99e7a31168), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ac912f62971842fa$export$49316f37c3b5fade), {
                                children: report_type && report_type
                            })
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ac912f62971842fa$export$987cac99e7a31168), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ac912f62971842fa$export$49316f37c3b5fade), {
                                children: sections && sections.split(',').join(', ').split('_').join(' ')
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $ac912f62971842fa$export$9f515a68dfaeb9ef), {
                    style: {
                        gridTemplateColumns: '150px 1fr'
                    },
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ac912f62971842fa$export$987cac99e7a31168), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ac912f62971842fa$export$ccff7fe96c96c97), {
                                status: status_name,
                                children: status_name
                            })
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ac912f62971842fa$export$987cac99e7a31168), {
                            children: status_name === 'Completed' ? /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $431db40ca57b78c9$export$2e2bcd8739ae039), {
                                onClick: handleDownload,
                                options: FORMAT_OPTIONS,
                                children: `Download (${format})`
                            }) : /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ac912f62971842fa$export$49316f37c3b5fade), {
                                children: "Available in a few minutes"
                            })
                        })
                    ]
                })
            ]
        })
    });
}
// Default Props
$90be0d8206ccbf9a$var$ReportsAddressTableItem.defaultProps = {
    address: {},
    actions: {},
    data: {
        id: '',
        created: '',
        report_type: '',
        sections: [],
        status_name: ''
    }
};
// Proptypes Validation
$90be0d8206ccbf9a$var$ReportsAddressTableItem.propTypes = {
    address: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        addressLinkDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            address_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
        }),
        addressLinkData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({})
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAddressLinkDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    data: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        created: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        report_type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        sections: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        status_name: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    })
};
var $90be0d8206ccbf9a$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($90be0d8206ccbf9a$var$mapStateToProps, $90be0d8206ccbf9a$var$mapDispatchToProps)($90be0d8206ccbf9a$var$ReportsAddressTableItem);


var $b865dd450b067975$export$2e2bcd8739ae039 = (0, $90be0d8206ccbf9a$export$2e2bcd8739ae039);


/* eslint-disable react/no-unstable-nested-components */ 
parcelRequire("tZqWC");

const $6d418a09946e7173$export$fd2299f554be8993 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  padding: 20px 30px 10px 30px;
  border-radius: 15px;
  display: grid;
  grid-template-columns: 1.8fr 1fr;
  gap: 50px;
  align-items: center;

  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $6d418a09946e7173$export$9f515a68dfaeb9ef = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  align-items: center;
  justify-content: space-between;
  width: 100%;

  gap: 20px;

  &:last-child > div:last-child {
    max-width: 250px;
    justify-content: flex-end;
  }
  &:last-child > div:first-child {
    justify-content: flex-end;
    max-width: 550px;
  }
`;
const $6d418a09946e7173$export$987cac99e7a31168 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  width: 100%;

  gap: 20px;
`;
const $6d418a09946e7173$export$6f4a084cc8e379b6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
`;
const $6d418a09946e7173$export$49316f37c3b5fade = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 15px;
  font-weight: 400;

  max-width: 250px;

  &:first-child {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
`;
const $6d418a09946e7173$export$b502300b413480 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).span`
  font-size: 8px;
  font-weight: 400;
`;
const $6d418a09946e7173$export$65b9fe47bb7b64b0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 10px;
  font-weight: 400;
`;
const $6d418a09946e7173$export$85524e8d4e82fc69 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;


function $7467b846008cafaf$var$ReportsAddressTableHeader() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6d418a09946e7173$export$fd2299f554be8993), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6d418a09946e7173$export$9f515a68dfaeb9ef), {
                style: {
                    gridTemplateColumns: '1fr 0.7fr 2fr'
                },
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6d418a09946e7173$export$987cac99e7a31168), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6d418a09946e7173$export$49316f37c3b5fade), {
                            children: "Requested At"
                        })
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6d418a09946e7173$export$987cac99e7a31168), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6d418a09946e7173$export$49316f37c3b5fade), {
                            children: "Name"
                        })
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6d418a09946e7173$export$987cac99e7a31168), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6d418a09946e7173$export$49316f37c3b5fade), {
                            children: "Sections"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6d418a09946e7173$export$9f515a68dfaeb9ef), {
                style: {
                    gridTemplateColumns: '150px 1fr'
                },
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6d418a09946e7173$export$987cac99e7a31168), {
                        style: {
                            justifyContent: 'center'
                        },
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6d418a09946e7173$export$49316f37c3b5fade), {
                            children: "Status"
                        })
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6d418a09946e7173$export$987cac99e7a31168), {})
                ]
            })
        ]
    });
}
// Default Props
$7467b846008cafaf$var$ReportsAddressTableHeader.defaultProps = {};
// Proptypes Validation
$7467b846008cafaf$var$ReportsAddressTableHeader.propTypes = {};
var $7467b846008cafaf$export$2e2bcd8739ae039 = $7467b846008cafaf$var$ReportsAddressTableHeader;


var $c2793ae25ec908bb$export$2e2bcd8739ae039 = (0, $7467b846008cafaf$export$2e2bcd8739ae039);


// Map Redux Props
const $7786c18ecd959b7d$var$mapStateToProps = (state)=>state;
const $7786c18ecd959b7d$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $7786c18ecd959b7d$var$ReportsAddressTable(props) {
    // Destructure
    const { filters: filters, ui: ui, actions: actions } = props;
    // Store States
    const { reportsAddressFilters: reportsAddressFilters } = filters;
    const { isPageTableUpdated: isPageTableUpdated } = ui;
    const { setIsPageTableUpdated: setIsPageTableUpdated, setReportsAddressFilters: setReportsAddressFilters, showAlert: showAlert } = actions;
    // Hooks
    const { getReports: getReports, getReportsData: getReportsData, getReportsError: getReportsError, isGetReportsLoading: isGetReportsLoading } = (0, $36ce18437b7b3465$export$2e2bcd8739ae039)();
    // Local states
    const [reports, setReports] = (0, $tZqWC.useState)([]);
    const [pagination, setPagination] = (0, $tZqWC.useState)();
    // Functions
    const fetchData = ()=>{
        getReports(reportsAddressFilters);
    };
    // UseEffects
    (0, $tZqWC.useEffect)(()=>fetchData(), [
        reportsAddressFilters
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (isPageTableUpdated) {
            fetchData();
            setIsPageTableUpdated(false);
        }
    }, [
        isPageTableUpdated
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (getReportsData) {
            setReports(getReportsData.items);
            setPagination(getReportsData.pagination);
        }
    }, [
        getReportsData
    ]);
    (0, $tZqWC.useEffect)(()=>{
        // TODO ADD PROPER ERROR MSG SENT FROM SERVER
        if (getReportsError) showAlert({
            type: 'error',
            message: 'An error occurred in fetching reports'
        });
    }, [
        getReportsError
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $84c675c4d0173e63$export$4267411171632d35), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $06a400f584629957$export$2e2bcd8739ae039), {
            totalItems: pagination?.total && pagination.total,
            minWidth: 900,
            tableFilters: reportsAddressFilters,
            setTableFilters: setReportsAddressFilters,
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1d305625439d79ac$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c2793ae25ec908bb$export$2e2bcd8739ae039), {}),
                reports.length > 0 && !isGetReportsLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                    children: reports.map((data)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b865dd450b067975$export$2e2bcd8739ae039), {
                            data: data
                        }, data.id))
                }),
                reports.length < 1 && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("div", {
                    children: isGetReportsLoading ? /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $647b8bc68ebce54f$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a6ea3b0f3caed586$export$2e2bcd8739ae039), {
                        setFilter: setReportsAddressFilters
                    })
                })
            ]
        })
    });
}
// Default Props
$7786c18ecd959b7d$var$ReportsAddressTable.defaultProps = {
    actions: {},
    filters: {},
    ui: {}
};
// Proptypes Validation
$7786c18ecd959b7d$var$ReportsAddressTable.propTypes = {
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        reportsAddressFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object)
    }),
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setToBeUpdatedAccount: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAccountDirectoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsIndividualAccountDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsEntityAccountDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setReportsAddressFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        toggleUpgradeModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setInfoModalDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $7786c18ecd959b7d$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($7786c18ecd959b7d$var$mapStateToProps, $7786c18ecd959b7d$var$mapDispatchToProps)($7786c18ecd959b7d$var$ReportsAddressTable);


var $3b0006ef62aeb4f4$export$2e2bcd8739ae039 = (0, $7786c18ecd959b7d$export$2e2bcd8739ae039);






var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");




const $748f812d51c740b5$export$4267411171632d35 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $748f812d51c740b5$export$cbf11d5f692bc726 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
`;
const $748f812d51c740b5$export$97d84ed62ab03b3f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  margin: 0px 0px 0px 16px;

  font-weight: inherit;
  font-size: inherit;
`;




/* eslint-disable react/no-unstable-nested-components */ 
parcelRequire("tZqWC");

const $db1fa880a06c4a43$export$fd2299f554be8993 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  padding: 20px 30px 10px 30px;
  border-radius: 15px;
  display: grid;
  grid-template-columns: 1.8fr 1fr;
  gap: 50px;
  align-items: center;

  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $db1fa880a06c4a43$export$9f515a68dfaeb9ef = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  align-items: center;
  justify-content: space-between;
  width: 100%;

  gap: 20px;

  &:last-child > div:last-child {
    max-width: 250px;
    justify-content: flex-end;
  }
  &:last-child > div:first-child {
    justify-content: flex-end;
    max-width: 550px;
  }
`;
const $db1fa880a06c4a43$export$987cac99e7a31168 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  width: 100%;

  gap: 20px;
`;
const $db1fa880a06c4a43$export$6f4a084cc8e379b6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
`;
const $db1fa880a06c4a43$export$49316f37c3b5fade = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 15px;
  font-weight: 400;

  max-width: 250px;

  &:first-child {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
`;
const $db1fa880a06c4a43$export$b502300b413480 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).span`
  font-size: 8px;
  font-weight: 400;
`;
const $db1fa880a06c4a43$export$65b9fe47bb7b64b0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 10px;
  font-weight: 400;
`;
const $db1fa880a06c4a43$export$85524e8d4e82fc69 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;


function $9b2c62f906ee7fc8$var$ReportsTransactionTableHeader() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $db1fa880a06c4a43$export$fd2299f554be8993), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $db1fa880a06c4a43$export$9f515a68dfaeb9ef), {
                style: {
                    gridTemplateColumns: '1fr 0.7fr 2fr'
                },
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $db1fa880a06c4a43$export$987cac99e7a31168), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $db1fa880a06c4a43$export$49316f37c3b5fade), {
                            children: "Requested At"
                        })
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $db1fa880a06c4a43$export$987cac99e7a31168), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $db1fa880a06c4a43$export$49316f37c3b5fade), {
                            children: "Name"
                        })
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $db1fa880a06c4a43$export$987cac99e7a31168), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $db1fa880a06c4a43$export$49316f37c3b5fade), {
                            children: "Sections"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $db1fa880a06c4a43$export$9f515a68dfaeb9ef), {
                style: {
                    gridTemplateColumns: '150px 1fr'
                },
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $db1fa880a06c4a43$export$987cac99e7a31168), {
                        style: {
                            justifyContent: 'center'
                        },
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $db1fa880a06c4a43$export$49316f37c3b5fade), {
                            children: "Status"
                        })
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $db1fa880a06c4a43$export$987cac99e7a31168), {})
                ]
            })
        ]
    });
}
// Default Props
$9b2c62f906ee7fc8$var$ReportsTransactionTableHeader.defaultProps = {};
// Proptypes Validation
$9b2c62f906ee7fc8$var$ReportsTransactionTableHeader.propTypes = {};
var $9b2c62f906ee7fc8$export$2e2bcd8739ae039 = $9b2c62f906ee7fc8$var$ReportsTransactionTableHeader;


var $57eff661e74dc188$export$2e2bcd8739ae039 = (0, $9b2c62f906ee7fc8$export$2e2bcd8739ae039);


/* eslint-disable react/no-unstable-nested-components */ 

var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");


var $ejSM7 = parcelRequire("ejSM7");



const $d9c5af3759e63875$export$fd2299f554be8993 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: 1.8fr 1fr;
  gap: 50px;
  align-items: center;

  padding: 2px 10px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $d9c5af3759e63875$export$9f515a68dfaeb9ef = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  gap: 20px;

  &:last-child > div:last-child {
    max-width: 250px;
    justify-content: flex-end;
  }
  &:last-child > div:first-child {
    justify-content: flex-end;
    max-width: 550px;
  }
`;
const $d9c5af3759e63875$export$987cac99e7a31168 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  width: 100%;

  gap: 20px;
`;
const $d9c5af3759e63875$export$6f4a084cc8e379b6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
`;
const $d9c5af3759e63875$export$49316f37c3b5fade = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 15px;
  font-weight: 400;
  text-transform: capitalize;
  max-width: 250px;

  &:first-child {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
`;
const $d9c5af3759e63875$export$b502300b413480 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).span`
  font-size: 8px;
  font-weight: 400;
`;
const $d9c5af3759e63875$export$65b9fe47bb7b64b0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 10px;
  font-weight: 400;
`;
const $d9c5af3759e63875$export$85524e8d4e82fc69 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $d9c5af3759e63875$export$ccff7fe96c96c97 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 5px 30px;
  border-radius: 10px;
  width: 100%;
  text-align: center;
  ${({ theme: theme, status: status })=>status === 'Completed' && `color: ${theme.colors.brand}; border: 1px solid ${theme.colors.brand};`}
  ${({ theme: theme, status: status })=>status === 'Pending' && `color: ${theme.colors.yellowGreen}; border: 1px solid ${theme.colors.yellowGreen};`}
`;



// Map Redux Props
const $2a14d2557482c562$var$mapStateToProps = (state)=>state;
const $2a14d2557482c562$var$mapDispatchToProps = (dispatch)=>(0, $2154a4c08d887b32$export$e324594224ef24da)(dispatch);
function $2a14d2557482c562$var$ReportsTransactionTableItem(props) {
    // Destructure
    const { data: data } = props;
    // const { showAlert } = actions
    const { created: created, sections: sections, status_name: status_name } = data;
    // Hooks
    // const { getReport, getReportData, getReportError, isGetReportLoading } = useGetReport()
    // States
    const [format, setFormat] = (0, $tZqWC.useState)('PDF');
    // function formatValue(number) {
    //   if (number < 1_000_000) {
    //     return numberWithCommas(Math.round(number * 100) / 100)
    //   }
    //   return compactNumberFormatter.format(number)
    // }
    // Constants
    const FORMAT_OPTIONS = [
        // {
        //   value: 'CSV',
        //   onClick: () => setFormat('CSV'),
        // },
        {
            value: 'PDF',
            onClick: ()=>setFormat('PDF')
        }
    ];
    // Functions
    const handleDownload = async ()=>{
        // getReport({ format: format.toLowerCase(), report_id: id })
        if (format.toLowerCase() === 'pdf') {
            let report_url = data?.report_url;
            if (report_url.split('https')?.length < 2) report_url = report_url.split('http').join('https');
            const response = await fetch(report_url);
            const blob = await response.blob();
            const report = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = report;
            a.download = `Ospree-Report${created && ` (${(0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(created).format((0, $41a9e38e6be32f35$export$859ef203c4495ed2))})`}.pdf`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(report);
        }
    };
    // const downloadFile = (data, inputFormat) => {
    //   let blob
    //   // if (inputFormat === 'CSV') {
    //   //   blob = new Blob([data], { type: `text/${inputFormat.toLowerCase()}; charset=utf-8` })
    //   // }
    //   // if (inputFormat === 'JSON') {
    //   //   blob = new Blob([JSON.stringify(data)], { type: 'text/plain;charset=utf-8' })
    //   // }
    //   if (inputFormat === 'PDF') {
    //     blob = new Blob([JSON.stringify(data)], { type: 'text/plain;charset=utf-8' })
    //   }
    //   saveAs(blob, `Ospree_Report.${format.toLowerCase()}`)
    // }
    // UseEffect
    // useEffect(() => getReportData && downloadFile(getReportData, format), [getReportData])
    // useEffect(() => {
    //   // TODO ADD PROPER ERROR MSG SENT FROM SERVER
    //   if (getReportError) showAlert({ type: 'error', message: 'An error occurred in fetching reports' })
    // }, [getReportError])
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f32a2c939d2829ea$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $d9c5af3759e63875$export$fd2299f554be8993), {
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $d9c5af3759e63875$export$9f515a68dfaeb9ef), {
                    style: {
                        gridTemplateColumns: '1fr 0.7fr 2fr'
                    },
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d9c5af3759e63875$export$987cac99e7a31168), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d9c5af3759e63875$export$49316f37c3b5fade), {
                                children: created && (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(created).format((0, $41a9e38e6be32f35$export$859ef203c4495ed2))
                            })
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d9c5af3759e63875$export$987cac99e7a31168), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d9c5af3759e63875$export$49316f37c3b5fade), {
                                children: "Transaction"
                            })
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d9c5af3759e63875$export$987cac99e7a31168), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d9c5af3759e63875$export$49316f37c3b5fade), {
                                children: sections && sections.split(',').join(', ').split('_').join(' ')
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $d9c5af3759e63875$export$9f515a68dfaeb9ef), {
                    style: {
                        gridTemplateColumns: '150px 1fr'
                    },
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d9c5af3759e63875$export$987cac99e7a31168), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d9c5af3759e63875$export$ccff7fe96c96c97), {
                                status: status_name,
                                children: status_name
                            })
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d9c5af3759e63875$export$987cac99e7a31168), {
                            children: status_name === 'Completed' ? /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $431db40ca57b78c9$export$2e2bcd8739ae039), {
                                onClick: handleDownload,
                                options: FORMAT_OPTIONS,
                                children: `Download (${format})`
                            }) : /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d9c5af3759e63875$export$49316f37c3b5fade), {
                                children: "Available in a few minutes"
                            })
                        })
                    ]
                })
            ]
        })
    });
}
// Default Props
$2a14d2557482c562$var$ReportsTransactionTableItem.defaultProps = {
    address: {},
    actions: {},
    data: {
        id: '',
        created: '',
        report_type: '',
        sections: [],
        status_name: ''
    }
};
// Proptypes Validation
$2a14d2557482c562$var$ReportsTransactionTableItem.propTypes = {
    address: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        addressLinkDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            address_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
        }),
        addressLinkData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({})
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAddressLinkDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    data: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        report_url: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        created: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        report_type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        sections: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        status_name: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    })
};
var $2a14d2557482c562$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($2a14d2557482c562$var$mapStateToProps, $2a14d2557482c562$var$mapDispatchToProps)($2a14d2557482c562$var$ReportsTransactionTableItem);


var $626e2ff218c52f07$export$2e2bcd8739ae039 = (0, $2a14d2557482c562$export$2e2bcd8739ae039);


// Map Redux Props
const $de973c905c720df6$var$mapStateToProps = (state)=>state;
const $de973c905c720df6$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $de973c905c720df6$var$ReportsTransactionTable(props) {
    // Destructure
    const { filters: filters, ui: ui, actions: actions } = props;
    // Store States
    const { reportsTransactionFilters: reportsTransactionFilters } = filters;
    const { isPageTableUpdated: isPageTableUpdated } = ui;
    const { setIsPageTableUpdated: setIsPageTableUpdated, setReportsTransactionFilters: setReportsTransactionFilters, showAlert: showAlert } = actions;
    // Hooks
    const { getReportsTransaction: getReportsTransaction, getReportsTransactionData: getReportsTransactionData, getReportsTransactionError: getReportsTransactionError, isGetReportsTransactionLoading: isGetReportsTransactionLoading } = (0, $d1ff954cbafe08bf$export$2e2bcd8739ae039)();
    // Local states
    const [reports, setReports] = (0, $tZqWC.useState)([]);
    const [pagination, setPagination] = (0, $tZqWC.useState)();
    // Functions
    const fetchData = ()=>{
        getReportsTransaction(reportsTransactionFilters);
    };
    (0, $tZqWC.useEffect)(()=>fetchData(), [
        reportsTransactionFilters
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (isPageTableUpdated) {
            fetchData();
            setIsPageTableUpdated(false);
        }
    }, [
        isPageTableUpdated
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (getReportsTransactionData) {
            setReports(getReportsTransactionData.items);
            setPagination(getReportsTransactionData.pagination);
        }
    }, [
        getReportsTransactionData
    ]);
    (0, $tZqWC.useEffect)(()=>{
        // TODO ADD PROPER ERROR MSG SENT FROM SERVER
        if (getReportsTransactionError) showAlert({
            type: 'error',
            message: 'An error occurred in fetching reports'
        });
    }, [
        getReportsTransactionError
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $748f812d51c740b5$export$4267411171632d35), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $06a400f584629957$export$2e2bcd8739ae039), {
            totalItems: pagination?.total && pagination.total,
            minWidth: 900,
            tableFilters: reportsTransactionFilters,
            setTableFilters: setReportsTransactionFilters,
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a56f24cb7abf86e4$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $57eff661e74dc188$export$2e2bcd8739ae039), {}),
                reports.length > 0 && !isGetReportsTransactionLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                    children: reports.map((data)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $626e2ff218c52f07$export$2e2bcd8739ae039), {
                            data: data
                        }, data.id))
                }),
                reports.length < 1 && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("div", {
                    children: isGetReportsTransactionLoading ? /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $647b8bc68ebce54f$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a6ea3b0f3caed586$export$2e2bcd8739ae039), {
                        setFilter: setReportsTransactionFilters
                    })
                })
            ]
        })
    });
}
// Default Props
$de973c905c720df6$var$ReportsTransactionTable.defaultProps = {
    actions: {},
    filters: {},
    ui: {}
};
// Proptypes Validation
$de973c905c720df6$var$ReportsTransactionTable.propTypes = {
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        reportsTransactionFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object)
    }),
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setToBeUpdatedAccount: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAccountDirectoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsIndividualAccountDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsEntityAccountDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setReportsTransactionFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        toggleUpgradeModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setInfoModalDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $de973c905c720df6$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($de973c905c720df6$var$mapStateToProps, $de973c905c720df6$var$mapDispatchToProps)($de973c905c720df6$var$ReportsTransactionTable);


var $c4d217c591f0c4d1$export$2e2bcd8739ae039 = (0, $de973c905c720df6$export$2e2bcd8739ae039);






var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");




const $6751dbd00e180160$export$4267411171632d35 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding-top: 81px;
`;
const $6751dbd00e180160$export$cbf11d5f692bc726 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
`;
const $6751dbd00e180160$export$97d84ed62ab03b3f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  margin: 0px 0px 0px 16px;

  font-weight: inherit;
  font-size: inherit;
`;



/* eslint-disable react/no-unstable-nested-components */ 

var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");


var $ejSM7 = parcelRequire("ejSM7");




const $2898156b76c363ba$export$fd2299f554be8993 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: 1.8fr 1fr;
  gap: 50px;
  align-items: center;

  padding: 2px 10px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $2898156b76c363ba$export$9f515a68dfaeb9ef = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  gap: 20px;

  &:last-child > div:last-child {
    max-width: 250px;
    justify-content: flex-end;
  }
  &:last-child > div:first-child {
    justify-content: flex-end;
    max-width: 550px;
  }
`;
const $2898156b76c363ba$export$987cac99e7a31168 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  width: 100%;

  gap: 20px;
`;
const $2898156b76c363ba$export$6f4a084cc8e379b6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
`;
const $2898156b76c363ba$export$49316f37c3b5fade = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 15px;
  font-weight: 400;
  text-transform: capitalize;
  max-width: 250px;

  &:first-child {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
`;
const $2898156b76c363ba$export$b502300b413480 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).span`
  font-size: 8px;
  font-weight: 400;
`;
const $2898156b76c363ba$export$65b9fe47bb7b64b0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 10px;
  font-weight: 400;
`;
const $2898156b76c363ba$export$85524e8d4e82fc69 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $2898156b76c363ba$export$ccff7fe96c96c97 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 5px 30px;
  border-radius: 10px;
  width: 100%;
  text-align: center;
  ${({ theme: theme, status: status })=>status === 'Completed' && `color: ${theme.colors.brand}; border: 1px solid ${theme.colors.brand};`}
  ${({ theme: theme, status: status })=>status === 'Pending' && `color: ${theme.colors.yellowGreen}; border: 1px solid ${theme.colors.yellowGreen};`}
`;




// Map Redux Props
const $8bdaf71ec55af3a5$var$mapStateToProps = (state)=>state;
const $8bdaf71ec55af3a5$var$mapDispatchToProps = (dispatch)=>(0, $2154a4c08d887b32$export$e324594224ef24da)(dispatch);
function $8bdaf71ec55af3a5$var$ReportsTravelRuleTableItem(props) {
    // Destructure
    const { data: data } = props;
    const { showAlert: showAlert } = (0, $2154a4c08d887b32$export$e324594224ef24da);
    const { created: created, start_range: start_range, end_range: end_range, status: status, id: id } = data;
    // Hooks
    const { downloadReportsTravelRule: downloadReportsTravelRule, downloadReportsTravelRuleData: downloadReportsTravelRuleData, downloadReportsTravelRuleError: downloadReportsTravelRuleError, isDownloadReportsTravelRuleLoading: isDownloadReportsTravelRuleLoading } = (0, $b9f6cf529e1dcb94$export$2e2bcd8739ae039)();
    // States
    const [format, setFormat] = (0, $tZqWC.useState)('CSV');
    // function formatValue(number) {
    //   if (number < 1_000_000) {
    //     return numberWithCommas(Math.round(number * 100) / 100)
    //   }
    //   return compactNumberFormatter.format(number)
    // }
    // Constants
    const FORMAT_OPTIONS = [
        {
            value: 'CSV',
            onClick: ()=>setFormat('CSV')
        },
        {
            value: 'JSON',
            onClick: ()=>setFormat('JSON')
        }
    ];
    // Functions
    const handleDownload = ()=>{
        downloadReportsTravelRule({
            format: format.toLowerCase(),
            id: id
        });
    };
    const downloadFile = (data, inputFormat)=>{
        let blob;
        if (inputFormat === 'CSV') blob = new Blob([
            data
        ], {
            type: `text/${inputFormat.toLowerCase()}; charset=utf-8`
        });
        if (inputFormat === 'JSON') blob = new Blob([
            JSON.stringify(data)
        ], {
            type: 'text/plain;charset=utf-8'
        });
        (0, $33c7f0b526e1c5e7$exports.saveAs)(blob, `Ospree_Report.${format.toLowerCase()}`);
    };
    // const downloadFile = (data, inputFormat) => {
    //   let blob
    //   // if (inputFormat === 'CSV') {
    //   //   blob = new Blob([data], { type: `text/${inputFormat.toLowerCase()}; charset=utf-8` })
    //   // }
    //   // if (inputFormat === 'JSON') {
    //   //   blob = new Blob([JSON.stringify(data)], { type: 'text/plain;charset=utf-8' })
    //   // }
    //   if (inputFormat === 'PDF') {
    //     blob = new Blob([JSON.stringify(data)], { type: 'text/plain;charset=utf-8' })
    //   }
    //   saveAs(blob, `Ospree_Report.${format.toLowerCase()}`)
    // }
    // UseEffect
    (0, $tZqWC.useEffect)(()=>{
        if (downloadReportsTravelRuleData) downloadFile(downloadReportsTravelRuleData, format);
    }, [
        downloadReportsTravelRuleData
    ]);
    (0, $tZqWC.useEffect)(()=>{
        // TODO ADD PROPER ERROR MSG SENT FROM SERVER
        if (downloadReportsTravelRuleError) showAlert({
            type: 'error',
            message: 'An error occurred in fetching reports'
        });
    }, [
        downloadReportsTravelRuleError
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f32a2c939d2829ea$export$2e2bcd8739ae039), {
        children: isDownloadReportsTravelRuleLoading ? /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2898156b76c363ba$export$fd2299f554be8993), {
            style: {
                display: 'flex',
                justifyContent: 'center'
            },
            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2898156b76c363ba$export$49316f37c3b5fade), {
                children: "Downloading..."
            })
        }) : /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $2898156b76c363ba$export$fd2299f554be8993), {
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $2898156b76c363ba$export$9f515a68dfaeb9ef), {
                    style: {
                        gridTemplateColumns: '1fr 0.7fr 2fr'
                    },
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2898156b76c363ba$export$987cac99e7a31168), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2898156b76c363ba$export$49316f37c3b5fade), {
                                children: created && (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(created).format((0, $41a9e38e6be32f35$export$859ef203c4495ed2))
                            })
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2898156b76c363ba$export$987cac99e7a31168), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2898156b76c363ba$export$49316f37c3b5fade), {
                                children: "TravelRule"
                            })
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2898156b76c363ba$export$987cac99e7a31168), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2898156b76c363ba$export$49316f37c3b5fade), {
                                children: start_range && end_range && `${(0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(start_range).format((0, $41a9e38e6be32f35$export$67a03cd247c60132))} - ${(0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))(end_range).format((0, $41a9e38e6be32f35$export$67a03cd247c60132))}`
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $2898156b76c363ba$export$9f515a68dfaeb9ef), {
                    style: {
                        gridTemplateColumns: '150px 1fr'
                    },
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2898156b76c363ba$export$987cac99e7a31168), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2898156b76c363ba$export$ccff7fe96c96c97), {
                                status: status === 2 && 'Completed',
                                children: status === 2 && 'Completed'
                            })
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2898156b76c363ba$export$987cac99e7a31168), {
                            children: status === 2 ? /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $431db40ca57b78c9$export$2e2bcd8739ae039), {
                                onClick: handleDownload,
                                options: FORMAT_OPTIONS,
                                children: `Download (${format})`
                            }) : /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2898156b76c363ba$export$49316f37c3b5fade), {
                                children: "Available in a few minutes"
                            })
                        })
                    ]
                })
            ]
        })
    });
}
// Default Props
$8bdaf71ec55af3a5$var$ReportsTravelRuleTableItem.defaultProps = {
    address: {},
    actions: {},
    data: {
        id: '',
        created: '',
        report_type: '',
        start_range: '',
        end_range: '',
        status_name: '',
        status: 0
    }
};
// Proptypes Validation
$8bdaf71ec55af3a5$var$ReportsTravelRuleTableItem.propTypes = {
    address: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        addressLinkDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            address_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
        }),
        addressLinkData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({})
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAddressLinkDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    data: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        report_url: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        created: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        report_type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        start_range: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        end_range: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        status_name: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        status: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number
    })
};
var $8bdaf71ec55af3a5$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($8bdaf71ec55af3a5$var$mapStateToProps, $8bdaf71ec55af3a5$var$mapDispatchToProps)($8bdaf71ec55af3a5$var$ReportsTravelRuleTableItem);


var $462918f903bbbde0$export$2e2bcd8739ae039 = (0, $8bdaf71ec55af3a5$export$2e2bcd8739ae039);


/* eslint-disable react/no-unstable-nested-components */ 
parcelRequire("tZqWC");

const $d0ec00410adf7cc7$export$fd2299f554be8993 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  padding: 20px 30px 10px 30px;
  border-radius: 15px;
  display: grid;
  grid-template-columns: 1.8fr 1fr;
  gap: 50px;
  align-items: center;

  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $d0ec00410adf7cc7$export$9f515a68dfaeb9ef = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  align-items: center;
  justify-content: space-between;
  width: 100%;

  gap: 20px;

  &:last-child > div:last-child {
    max-width: 250px;
    justify-content: flex-end;
  }
  &:last-child > div:first-child {
    justify-content: flex-end;
    max-width: 550px;
  }
`;
const $d0ec00410adf7cc7$export$987cac99e7a31168 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  width: 100%;

  gap: 20px;
`;
const $d0ec00410adf7cc7$export$6f4a084cc8e379b6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
`;
const $d0ec00410adf7cc7$export$49316f37c3b5fade = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 15px;
  font-weight: 400;

  max-width: 250px;

  &:first-child {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
`;
const $d0ec00410adf7cc7$export$b502300b413480 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).span`
  font-size: 8px;
  font-weight: 400;
`;
const $d0ec00410adf7cc7$export$65b9fe47bb7b64b0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 10px;
  font-weight: 400;
`;
const $d0ec00410adf7cc7$export$85524e8d4e82fc69 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;


function $454bda52ba4353e0$var$ReportsTravelRuleTableHeader() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $d0ec00410adf7cc7$export$fd2299f554be8993), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $d0ec00410adf7cc7$export$9f515a68dfaeb9ef), {
                style: {
                    gridTemplateColumns: '1fr 0.7fr 2fr'
                },
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d0ec00410adf7cc7$export$987cac99e7a31168), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d0ec00410adf7cc7$export$49316f37c3b5fade), {
                            children: "Requested At"
                        })
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d0ec00410adf7cc7$export$987cac99e7a31168), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d0ec00410adf7cc7$export$49316f37c3b5fade), {
                            children: "Name"
                        })
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d0ec00410adf7cc7$export$987cac99e7a31168), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d0ec00410adf7cc7$export$49316f37c3b5fade), {
                            children: "Date Range"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $d0ec00410adf7cc7$export$9f515a68dfaeb9ef), {
                style: {
                    gridTemplateColumns: '150px 1fr'
                },
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d0ec00410adf7cc7$export$987cac99e7a31168), {
                        style: {
                            justifyContent: 'center'
                        },
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d0ec00410adf7cc7$export$49316f37c3b5fade), {
                            children: "Status"
                        })
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d0ec00410adf7cc7$export$987cac99e7a31168), {})
                ]
            })
        ]
    });
}
// Default Props
$454bda52ba4353e0$var$ReportsTravelRuleTableHeader.defaultProps = {};
// Proptypes Validation
$454bda52ba4353e0$var$ReportsTravelRuleTableHeader.propTypes = {};
var $454bda52ba4353e0$export$2e2bcd8739ae039 = $454bda52ba4353e0$var$ReportsTravelRuleTableHeader;


var $536b8b87d6ee5aec$export$2e2bcd8739ae039 = (0, $454bda52ba4353e0$export$2e2bcd8739ae039);


// Map Redux Props
const $ef507e7b7d7b68b8$var$mapStateToProps = (state)=>state;
const $ef507e7b7d7b68b8$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $ef507e7b7d7b68b8$var$ReportsTravelRuleTable(props) {
    // Destructure
    const { filters: filters, ui: ui, actions: actions } = props;
    // Store States
    const { reportsTravelRuleFilters: reportsTravelRuleFilters } = filters;
    const { isPageTableUpdated: isPageTableUpdated } = ui;
    const { setIsPageTableUpdated: setIsPageTableUpdated, setReportsTravelRuleFilters: setReportsTravelRuleFilters, showAlert: showAlert } = actions;
    // Hooks
    const { getReportsTravelRule: getReportsTravelRule, getReportsTravelRuleData: getReportsTravelRuleData, getReportsTravelRuleError: getReportsTravelRuleError, isGetReportsTravelRuleLoading: isGetReportsTravelRuleLoading } = (0, $f8d91779561de169$export$2e2bcd8739ae039)();
    // Local states
    const [reports, setReports] = (0, $tZqWC.useState)([]);
    const [pagination, setPagination] = (0, $tZqWC.useState)();
    // Functions
    const fetchData = ()=>{
        getReportsTravelRule(reportsTravelRuleFilters);
    };
    (0, $tZqWC.useEffect)(()=>fetchData(), [
        reportsTravelRuleFilters
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (isPageTableUpdated) {
            fetchData();
            setIsPageTableUpdated(false);
        }
    }, [
        isPageTableUpdated
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (getReportsTravelRuleData) {
            setReports(getReportsTravelRuleData.items);
            setPagination(getReportsTravelRuleData.pagination);
        }
    }, [
        getReportsTravelRuleData
    ]);
    (0, $tZqWC.useEffect)(()=>{
        // TODO ADD PROPER ERROR MSG SENT FROM SERVER
        if (getReportsTravelRuleError) showAlert({
            type: 'error',
            message: 'An error occurred in fetching reports'
        });
    }, [
        getReportsTravelRuleError
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6751dbd00e180160$export$4267411171632d35), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $06a400f584629957$export$2e2bcd8739ae039), {
            totalItems: pagination?.total && pagination.total,
            minWidth: 900,
            tableFilters: reportsTravelRuleFilters,
            setTableFilters: setReportsTravelRuleFilters,
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $536b8b87d6ee5aec$export$2e2bcd8739ae039), {}),
                reports.length > 0 && !isGetReportsTravelRuleLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                    children: reports.map((data)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $462918f903bbbde0$export$2e2bcd8739ae039), {
                            data: data
                        }, data.id))
                }),
                reports.length < 1 && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("div", {
                    children: isGetReportsTravelRuleLoading ? /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $647b8bc68ebce54f$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a6ea3b0f3caed586$export$2e2bcd8739ae039), {
                        setFilter: setReportsTravelRuleFilters
                    })
                })
            ]
        })
    });
}
// Default Props
$ef507e7b7d7b68b8$var$ReportsTravelRuleTable.defaultProps = {
    actions: {},
    filters: {},
    ui: {}
};
// Proptypes Validation
$ef507e7b7d7b68b8$var$ReportsTravelRuleTable.propTypes = {
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        reportsTravelRuleFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object)
    }),
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setToBeUpdatedAccount: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAccountDirectoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsIndividualAccountDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsEntityAccountDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setReportsTravelRuleFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        toggleUpgradeModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setInfoModalDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $ef507e7b7d7b68b8$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($ef507e7b7d7b68b8$var$mapStateToProps, $ef507e7b7d7b68b8$var$mapDispatchToProps)($ef507e7b7d7b68b8$var$ReportsTravelRuleTable);


var $45fd8d9b60dccc63$export$2e2bcd8739ae039 = (0, $ef507e7b7d7b68b8$export$2e2bcd8739ae039);




/* eslint-disable react/no-array-index-key */ 

var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");



const $0f74268e2eba9440$export$4267411171632d35 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 10px 0 0 0;
`;
const $0f74268e2eba9440$export$cbf11d5f692bc726 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
`;
const $0f74268e2eba9440$export$97d84ed62ab03b3f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  margin: 0px 0px 0px 16px;

  font-weight: inherit;
  font-size: inherit;
`;




parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");




const $309fc4417f9e861e$export$d052f996153b966 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  width: 100%;

  // If there is space then it's for the child
  // If there is no space then it's for the current component
  &#accountAddressTableFilter {
    & > div {
      padding: 0 !important;
      margin: 0 !important;
    }
  }
  & #travelruleDateFilter {
    justify-content: center;
    & > div {
      max-width: none !important;
    }
  }
  & #travelRuleSort {
    min-width: 245px;
    & .simpleSelectInputLabel {
      min-width: 165px;
    }
  }
  & #travelRuleAssetSort {
    & .simpleSelectInputLabel {
      min-width: 130px;
    }
  }
  & #addressDateFilter {
    & > div {
      max-width: none !important;
      padding: 0;
      height: 100%;
      gap: 10px;

      & p {
        font-size: 12px !important;
        margin: 0;
        display: flex;
        align-items: center;
        gap: 5px;
      }
    }
  }
  & #VASPSort {
    min-width: 200px;
    & .simpleSelectInputLabel {
      min-width: 120px;
    }
  }
`;
const $309fc4417f9e861e$export$ca4b1fc43afa0212 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;



// Map Redux Props
const $7124d16946ef5f91$var$mapStateToProps = (state)=>state;
const $7124d16946ef5f91$var$mapDispatchToProps = (dispatch)=>(0, $2154a4c08d887b32$export$e324594224ef24da)(dispatch);
function $7124d16946ef5f91$var$DemoAddressTableFilter(props) {
    // Destructure
    const { actions: actions } = props;
    const { toggleUpgradeModal: toggleUpgradeModal } = actions;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $309fc4417f9e861e$export$d052f996153b966), {
        onClick: ()=>{
            (0, $60e52eb6c2680325$export$7ca4b19155f576fa)(toggleUpgradeModal);
        },
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $246a616d3a63a7c1$export$2e2bcd8739ae039), {
            filter: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("div", {})
        })
    });
}
// Default Props
$7124d16946ef5f91$var$DemoAddressTableFilter.defaultProps = {
    filters: {},
    actions: {}
};
// Proptypes Validation
$7124d16946ef5f91$var$DemoAddressTableFilter.propTypes = {
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        addressFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            sort: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            account_type_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
            page_index: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
            start_range: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            end_range: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
        })
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAddressFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        toggleUpgradeModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setInfoModalDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $7124d16946ef5f91$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($7124d16946ef5f91$var$mapStateToProps, $7124d16946ef5f91$var$mapDispatchToProps)($7124d16946ef5f91$var$DemoAddressTableFilter);


var $634affd988178051$export$2e2bcd8739ae039 = (0, $7124d16946ef5f91$export$2e2bcd8739ae039);


/* eslint-disable react/no-unstable-nested-components */ 

var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");




const $54ffb075fb600ebd$export$fd2299f554be8993 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: 1fr 1.8fr;
  gap: 50px;
  align-items: center;

  padding: 10px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $54ffb075fb600ebd$export$9f515a68dfaeb9ef = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  gap: 20px;

  &:last-child > div:last-child {
    max-width: 150px;
  }
  &:last-child > div:first-child {
    justify-content: flex-end;
    max-width: 535px;
  }

  &:first-child > div:last-child {
    justify-content: flex-end;
    visibility: ${({ isExpanded: isExpanded })=>isExpanded && 'hidden'};
  }
  &:last-child > div:first-child {
    visibility: ${({ isExpanded: isExpanded })=>isExpanded && 'hidden'};
  }
`;
const $54ffb075fb600ebd$export$987cac99e7a31168 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  width: 100%;

  gap: 20px;
`;
const $54ffb075fb600ebd$export$6f4a084cc8e379b6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
`;
const $54ffb075fb600ebd$export$49316f37c3b5fade = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 15px;
  font-weight: 400;

  max-width: 250px;

  &:first-child {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
`;
const $54ffb075fb600ebd$export$edc246bee1ec68d2 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;

  & svg {
    height: 20px;
    width: 20px;
  }
`;
const $54ffb075fb600ebd$export$829b0583f0fe5152 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 15px;
  font-weight: 400;
`;
const $54ffb075fb600ebd$export$b30c94aee60c7d6b = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: absolute;
  top: 100%;
  margin-top: 10px;

  font-size: 15px;
  font-weight: 400;
  padding: 10px 20px;
  border-radius: 10px;
  background-color: ${({ theme: theme })=>theme.colors.background};

  transition: 0.1s;
  opacity: ${({ display: display })=>display ? 1 : 0};
  box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.15);
`;
const $54ffb075fb600ebd$export$b502300b413480 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).span`
  font-size: 8px;
  font-weight: 400;
`;
const $54ffb075fb600ebd$export$65b9fe47bb7b64b0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 10px;
  font-weight: 400;
`;
const $54ffb075fb600ebd$export$85524e8d4e82fc69 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;



/* eslint-disable react/prop-types */ /* eslint-disable react/forbid-prop-types */ 

var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");



const $3a4a5a582e22451a$export$e6dfd72ab29f8598 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
`;
const $3a4a5a582e22451a$export$d53c836cccbb0d90 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: absolute;
  top: 0;
  right: 0;

  display: flex;
  gap: 10px;
`;
const $3a4a5a582e22451a$export$42a852a2b6b56249 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $3a4a5a582e22451a$export$f5ec1ee0b77895e7 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $3a4a5a582e22451a$export$b2e35077a5c7bc77 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-start;

  width: 100%;
`;
const $3a4a5a582e22451a$export$f6e382949408c1f3 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  min-width: 300px;
  gap: 8px;
  max-width: 470px;
`;
const $3a4a5a582e22451a$export$bc7adc8ef74607f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding-top: 10px;
  display: flex;
  justify-content: space-between;
  gap: 10px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $3a4a5a582e22451a$export$4e8a51dfb7785a56 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  width: 100%;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 10px;
`;
const $3a4a5a582e22451a$export$a9754b3c8daa5172 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  gap: 10px;
`;
const $3a4a5a582e22451a$export$cd1f041fcaf00d90 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 10px;
  padding: 10px 0;
  border-bottom: 1px solid ${({ theme: theme })=>theme.colors.backgroundLite};
`;
const $3a4a5a582e22451a$export$acefde28a3cb7b20 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 10px;
  border-color: ${({ theme: theme })=>theme.colors.backgroundLite};
  border-style: solid;
  border-width: 0;
`;
const $3a4a5a582e22451a$export$a4fff7f2f85c4c81 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  padding: 20px;
  width: 100%;
  height: 100%;
  border-radius: 7px;
  border: 1px solid ${({ theme: theme })=>theme.colors.backgroundLite};
  transition: 0.3s;
  /* &:hover {
    background-color: ${({ theme: theme })=>`${theme.colors.secondary}10`};
  } */

  & > div:last-child {
    border: none;
    padding-bottom: 0;
  }
`;
const $3a4a5a582e22451a$export$87ad169bde460ddf = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 100%;

  border-color: ${({ theme: theme })=>theme.colors.backgroundLite};
  border-style: solid;
  border-width: 0;
`;
const $3a4a5a582e22451a$export$d747b2abe71e53f5 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 100%;

  & > div:last-child {
    border: none;
    padding-bottom: 0;
  }
`;
const $3a4a5a582e22451a$export$5f1af8db9871e1d6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  margin: 0;
  padding: 0;
  font-size: 14px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $3a4a5a582e22451a$export$c1dd341a97aad245 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).span`
  margin: 0;
  padding: 5px 15px;
  font-size: 12px;
  color: ${({ theme: theme })=>theme.colors.primary};
  background-color: ${({ theme: theme })=>`${theme.colors.secondary}30`};
  border: 1px solid ${({ theme: theme, color: color })=>color === 'darkGray' ? theme.colors.primary : theme.colors.backgroundLite};
  border-radius: 8px;
`;
const $3a4a5a582e22451a$export$f99233281efd08a0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h2`
  margin: 0;
  padding: 0;
  font-size: 15px;
  font-weight: 400;
  color: ${({ theme: theme })=>theme.colors.primary};
  text-transform: uppercase;
  margin-bottom: 10px;
`;
const $3a4a5a582e22451a$export$ae133abb7f01f500 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 20px 0 0 0;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(520px, 1fr));
  gap: 60px;
`;
const $3a4a5a582e22451a$export$8f314e512d92575f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  width: 40px;

  font-size: 20px;
  border: 1px solid ${({ theme: theme })=>theme.colors.primary};
  border-radius: 100%;
`;
const $3a4a5a582e22451a$export$87de03758d2d03db = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 20px 20px 0 20px;

  & #rsSubTitle {
    color: ${({ theme: theme })=>theme.colors.secondary};
  }
`;
const $3a4a5a582e22451a$export$71237909d9ca197d = (0, $a778141486c79bc3$export$2e2bcd8739ae039).hr`
  width: 100%;
  height: 2px !important;

  color: ${({ theme: theme })=>theme.colors.secondary};
  margin: 20px 0;
`;
const $3a4a5a582e22451a$export$dc8558b9a49863a4 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h2`
  margin: 0;
  padding: 0;
  font-size: 12px;
  font-weight: 400;
  color: ${({ theme: theme })=>theme.colors.secondary};
  text-transform: uppercase;
  margin-bottom: -7px;

  font-weight: 300;
  font-size: 10px;
  padding-top: 5px;
  display: flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;
`;
const $3a4a5a582e22451a$export$b2bf131c9f9cce5d = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  gap: 5px;
  height: 100%;
  cursor: pointer;

  & svg {
    height: 100%;
    max-height: 15px;
  }
`;
const $3a4a5a582e22451a$export$66b8cea0c448285 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;



/* eslint-disable react/prop-types */ /* eslint-disable no-nested-ternary */ /* eslint-disable react/jsx-no-useless-fragment */ /* eslint-disable react/no-array-index-key */ /* eslint-disable react/forbid-prop-types */ 
parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");


var $ejSM7 = parcelRequire("ejSM7");






// Map Redux Props
const $5d99076cb46981f9$var$mapStateToProps = (state)=>state;
const $5d99076cb46981f9$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $5d99076cb46981f9$var$DetailsSummary(props) {
    // Destructure
    const { actions: actions, BarWidth: BarWidth } = props;
    // Store
    const { toggleUpgradeModal: toggleUpgradeModal } = actions;
    // local state
    // const [sentBarWidth, setSentBarWidth] = useState('0%')
    // const [receivedBarWidth, setReceivedBarWidth] = useState('0%')
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$f5ec1ee0b77895e7), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3a4a5a582e22451a$export$bc7adc8ef74607f), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3a4a5a582e22451a$export$a4fff7f2f85c4c81), {
                    style: {
                        padding: '10px',
                        borderWidth: 2
                    },
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$4e8a51dfb7785a56), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$a4fff7f2f85c4c81), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$cd1f041fcaf00d90), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3a4a5a582e22451a$export$5f1af8db9871e1d6), {
                                                children: "Balance: "
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                width: "140"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$cd1f041fcaf00d90), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3a4a5a582e22451a$export$5f1af8db9871e1d6), {
                                                children: "Protocol: "
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                width: "180"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$a4fff7f2f85c4c81), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$cd1f041fcaf00d90), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3a4a5a582e22451a$export$5f1af8db9871e1d6), {
                                                children: "Travel Rule Transfers: "
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                width: "70"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$cd1f041fcaf00d90), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3a4a5a582e22451a$export$5f1af8db9871e1d6), {
                                                children: "Detection Engine Alerts: "
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                width: "120"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$a4fff7f2f85c4c81), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$cd1f041fcaf00d90), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3a4a5a582e22451a$export$5f1af8db9871e1d6), {
                                                children: "Linked Account Risk Level: "
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                width: "140"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$cd1f041fcaf00d90), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3a4a5a582e22451a$export$5f1af8db9871e1d6), {
                                                children: "Modified By: "
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                width: "110"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3a4a5a582e22451a$export$a4fff7f2f85c4c81), {
                style: {
                    padding: '10px',
                    marginTop: '20px',
                    borderWidth: 2
                },
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3a4a5a582e22451a$export$4e8a51dfb7785a56), {
                    style: {
                        gridTemplateColumns: '320px 1fr 0.79fr'
                    },
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3a4a5a582e22451a$export$a9754b3c8daa5172), {
                                style: {
                                    maxWidth: '320px',
                                    alignItems: 'center'
                                },
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3a4a5a582e22451a$export$a4fff7f2f85c4c81), {
                                    style: {
                                        display: 'flex',
                                        padding: 0
                                    },
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$87ad169bde460ddf), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3a4a5a582e22451a$export$87de03758d2d03db), {
                                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ba8982a7854b309f$export$2e2bcd8739ae039), {
                                                    id: `${1512}-${1}`,
                                                    size: 120,
                                                    progress: BarWidth,
                                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$d747b2abe71e53f5), {
                                                        style: {
                                                            justifyContent: 'center',
                                                            alignItems: 'center',
                                                            gap: 0
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3a4a5a582e22451a$export$5f1af8db9871e1d6), {
                                                                style: {
                                                                    fontSize: '18px',
                                                                    fontWeight: 600
                                                                },
                                                                children: `${BarWidth}%`
                                                            }),
                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3a4a5a582e22451a$export$5f1af8db9871e1d6), {
                                                                style: {
                                                                    fontSize: '12px',
                                                                    fontWeight: 400
                                                                },
                                                                id: "rsSubTitle",
                                                                children: "Risk"
                                                            })
                                                        ]
                                                    })
                                                }, 1512)
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$acefde28a3cb7b20), {
                                                style: {
                                                    padding: '20px'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$d747b2abe71e53f5), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$dc8558b9a49863a4), {
                                                                onClick: ()=>{
                                                                    (0, $60e52eb6c2680325$export$7ca4b19155f576fa)(toggleUpgradeModal);
                                                                },
                                                                children: [
                                                                    "Risk Score",
                                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b7c251a6b5f784dd$export$2e2bcd8739ae039), {
                                                                        size: 18
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$5f1af8db9871e1d6), {
                                                                style: {
                                                                    border: 'none',
                                                                    fontWeight: 600,
                                                                    fontSize: 15
                                                                },
                                                                children: [
                                                                    `${BarWidth}`,
                                                                    "/100"
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$d747b2abe71e53f5), {
                                                        style: {
                                                            alignItems: 'center'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3a4a5a582e22451a$export$dc8558b9a49863a4), {
                                                                style: {
                                                                    cursor: 'default'
                                                                },
                                                                children: "Timestamp"
                                                            }),
                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3a4a5a582e22451a$export$5f1af8db9871e1d6), {
                                                                style: {
                                                                    border: 'none',
                                                                    fontWeight: 600,
                                                                    fontSize: 15
                                                                },
                                                                children: (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))('2024-11-15').format((0, $41a9e38e6be32f35$export$67a03cd247c60132))
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$d747b2abe71e53f5), {
                                                        style: {
                                                            alignItems: 'flex-end'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$dc8558b9a49863a4), {
                                                                onClick: ()=>{
                                                                    (0, $60e52eb6c2680325$export$7ca4b19155f576fa)(toggleUpgradeModal);
                                                                },
                                                                children: [
                                                                    "Source",
                                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b7c251a6b5f784dd$export$2e2bcd8739ae039), {
                                                                        size: 18
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                                width: "60",
                                                                height: "14",
                                                                style: {
                                                                    marginTop: '3px'
                                                                }
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3a4a5a582e22451a$export$a9754b3c8daa5172), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3a4a5a582e22451a$export$a4fff7f2f85c4c81), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$d747b2abe71e53f5), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3a4a5a582e22451a$export$f99233281efd08a0), {
                                                children: "Risk Score Descriptors: "
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$a9754b3c8daa5172), {
                                                style: {
                                                    gap: 5,
                                                    maxHeight: '150px',
                                                    overflowY: 'auto',
                                                    paddingRight: '20px'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                        width: "80"
                                                    }),
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                        width: "180"
                                                    }),
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                        width: "210"
                                                    }),
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                        width: "150"
                                                    }),
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                        width: "140"
                                                    }),
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                        width: "150"
                                                    }),
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                        width: "120"
                                                    }),
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                        width: "110"
                                                    }),
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                        width: "140"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3a4a5a582e22451a$export$a9754b3c8daa5172), {
                                style: {
                                    maxWidth: '443px'
                                },
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3a4a5a582e22451a$export$a4fff7f2f85c4c81), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$d747b2abe71e53f5), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3a4a5a582e22451a$export$f99233281efd08a0), {
                                                children: "Controlling Entity: "
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$cd1f041fcaf00d90), {
                                                style: {
                                                    padding: '0 0 10px 0'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3a4a5a582e22451a$export$5f1af8db9871e1d6), {
                                                        children: "Name: "
                                                    }),
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                        width: "120"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$cd1f041fcaf00d90), {
                                                children: [
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3a4a5a582e22451a$export$5f1af8db9871e1d6), {
                                                        children: "Website: "
                                                    }),
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                        width: "180"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$cd1f041fcaf00d90), {
                                                children: [
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3a4a5a582e22451a$export$5f1af8db9871e1d6), {
                                                        children: "Type: "
                                                    }),
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                        width: "90"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                })
            }, 28948923),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3a4a5a582e22451a$export$a4fff7f2f85c4c81), {
                style: {
                    padding: '10px',
                    marginTop: '20px',
                    borderWidth: 2
                },
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3a4a5a582e22451a$export$4e8a51dfb7785a56), {
                    style: {
                        gridTemplateColumns: '320px 1fr 0.79fr'
                    },
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3a4a5a582e22451a$export$a9754b3c8daa5172), {
                                style: {
                                    maxWidth: '320px',
                                    alignItems: 'center'
                                },
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3a4a5a582e22451a$export$a4fff7f2f85c4c81), {
                                    style: {
                                        display: 'flex',
                                        padding: 0
                                    },
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$87ad169bde460ddf), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3a4a5a582e22451a$export$87de03758d2d03db), {
                                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ba8982a7854b309f$export$2e2bcd8739ae039), {
                                                    id: `${1512}-${1}`,
                                                    size: 120,
                                                    progress: BarWidth,
                                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$d747b2abe71e53f5), {
                                                        style: {
                                                            justifyContent: 'center',
                                                            alignItems: 'center',
                                                            gap: 0
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3a4a5a582e22451a$export$5f1af8db9871e1d6), {
                                                                style: {
                                                                    fontSize: '18px',
                                                                    fontWeight: 600
                                                                },
                                                                children: `${BarWidth}%`
                                                            }),
                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3a4a5a582e22451a$export$5f1af8db9871e1d6), {
                                                                style: {
                                                                    fontSize: '12px',
                                                                    fontWeight: 400
                                                                },
                                                                id: "rsSubTitle",
                                                                children: "Risk"
                                                            })
                                                        ]
                                                    })
                                                }, 1512)
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$acefde28a3cb7b20), {
                                                style: {
                                                    padding: '20px'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$d747b2abe71e53f5), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$dc8558b9a49863a4), {
                                                                onClick: ()=>{
                                                                    (0, $60e52eb6c2680325$export$7ca4b19155f576fa)(toggleUpgradeModal);
                                                                },
                                                                children: [
                                                                    "Risk Score",
                                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b7c251a6b5f784dd$export$2e2bcd8739ae039), {
                                                                        size: 18
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$5f1af8db9871e1d6), {
                                                                style: {
                                                                    border: 'none',
                                                                    fontWeight: 600,
                                                                    fontSize: 15
                                                                },
                                                                children: [
                                                                    `${BarWidth}`,
                                                                    "/100"
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$d747b2abe71e53f5), {
                                                        style: {
                                                            alignItems: 'center'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3a4a5a582e22451a$export$dc8558b9a49863a4), {
                                                                style: {
                                                                    cursor: 'default'
                                                                },
                                                                children: "Timestamp"
                                                            }),
                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3a4a5a582e22451a$export$5f1af8db9871e1d6), {
                                                                style: {
                                                                    border: 'none',
                                                                    fontWeight: 600,
                                                                    fontSize: 15
                                                                },
                                                                children: (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))('2024-11-13').format((0, $41a9e38e6be32f35$export$67a03cd247c60132))
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$d747b2abe71e53f5), {
                                                        style: {
                                                            alignItems: 'flex-end'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$dc8558b9a49863a4), {
                                                                onClick: ()=>{
                                                                    (0, $60e52eb6c2680325$export$7ca4b19155f576fa)(toggleUpgradeModal);
                                                                },
                                                                children: [
                                                                    "Source",
                                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b7c251a6b5f784dd$export$2e2bcd8739ae039), {
                                                                        size: 18
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                                width: "60",
                                                                height: "14",
                                                                style: {
                                                                    marginTop: '3px'
                                                                }
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3a4a5a582e22451a$export$a9754b3c8daa5172), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3a4a5a582e22451a$export$a4fff7f2f85c4c81), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$d747b2abe71e53f5), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3a4a5a582e22451a$export$f99233281efd08a0), {
                                                children: "Risk Score Descriptors: "
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$a9754b3c8daa5172), {
                                                style: {
                                                    gap: 5,
                                                    maxHeight: '150px',
                                                    overflowY: 'auto',
                                                    paddingRight: '20px'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                        width: "140"
                                                    }),
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                        width: "120"
                                                    }),
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                        width: "110"
                                                    }),
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                        width: "130"
                                                    }),
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                        width: "90"
                                                    }),
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                        width: "50"
                                                    }),
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                        width: "250"
                                                    }),
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                        width: "140"
                                                    }),
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                        width: "100"
                                                    }),
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                        width: "160"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3a4a5a582e22451a$export$a9754b3c8daa5172), {
                                style: {
                                    maxWidth: '443px'
                                },
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3a4a5a582e22451a$export$a4fff7f2f85c4c81), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$d747b2abe71e53f5), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3a4a5a582e22451a$export$f99233281efd08a0), {
                                                children: "Controlling Entity: "
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$cd1f041fcaf00d90), {
                                                style: {
                                                    padding: '0 0 10px 0'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3a4a5a582e22451a$export$5f1af8db9871e1d6), {
                                                        children: "Name: "
                                                    }),
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                        width: "120"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$cd1f041fcaf00d90), {
                                                children: [
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3a4a5a582e22451a$export$5f1af8db9871e1d6), {
                                                        children: "Website: "
                                                    }),
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                        width: "180"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$cd1f041fcaf00d90), {
                                                children: [
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3a4a5a582e22451a$export$5f1af8db9871e1d6), {
                                                        children: "Type: "
                                                    }),
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                        width: "90"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                })
            }, 28948762),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$bc7adc8ef74607f), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$a9754b3c8daa5172), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                variant: "outlined",
                                size: "small",
                                onClick: ()=>{
                                    (0, $60e52eb6c2680325$export$7ca4b19155f576fa)(toggleUpgradeModal);
                                },
                                children: "See History"
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                variant: "outlined",
                                size: "small",
                                onClick: ()=>{
                                    (0, $60e52eb6c2680325$export$7ca4b19155f576fa)(toggleUpgradeModal);
                                },
                                children: "Create Report"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$a9754b3c8daa5172), {
                        style: {
                            justifyContent: 'flex-end'
                        },
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                variant: "outlined",
                                size: "small",
                                endIcon: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b77b5de3fb591045$export$2e2bcd8739ae039), {
                                    size: 18
                                }),
                                onClick: ()=>{
                                    (0, $60e52eb6c2680325$export$7ca4b19155f576fa)(toggleUpgradeModal);
                                },
                                children: "Remove"
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                variant: "outlined",
                                size: "small",
                                endIcon: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ef7aaa91ec87194a$export$2e2bcd8739ae039), {
                                    size: 18
                                }),
                                onClick: ()=>{
                                    (0, $60e52eb6c2680325$export$7ca4b19155f576fa)(toggleUpgradeModal);
                                },
                                children: "Link"
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ca6f920a36c82944$export$2e2bcd8739ae039), {
                                direction: "down",
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                    variant: "outlined",
                                    size: "small",
                                    endIcon: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6417d0fa9c066aa3$export$2e2bcd8739ae039), {
                                        size: 18
                                    }),
                                    onClick: ()=>{
                                        (0, $60e52eb6c2680325$export$7ca4b19155f576fa)(toggleUpgradeModal);
                                    },
                                    children: "Add score"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    }, 1525161);
}
// Default Props
$5d99076cb46981f9$var$DetailsSummary.defaultProps = {
    actions: {}
};
// Proptypes Validation
$5d99076cb46981f9$var$DetailsSummary.propTypes = {
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        toggleUpgradeModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $5d99076cb46981f9$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($5d99076cb46981f9$var$mapStateToProps, $5d99076cb46981f9$var$mapDispatchToProps)($5d99076cb46981f9$var$DetailsSummary);


var $973aed32bf54913c$export$2e2bcd8739ae039 = (0, $5d99076cb46981f9$export$2e2bcd8739ae039);


/* eslint-disable react/forbid-prop-types */ 
parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");






// Map Redux Props
const $92502e80aed60cb0$var$mapStateToProps = (state)=>state;
const $92502e80aed60cb0$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $92502e80aed60cb0$var$LinkedAccount(props) {
    // Destructure
    const { actions: actions } = props;
    // Store
    const { toggleUpgradeModal: toggleUpgradeModal } = actions;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$f5ec1ee0b77895e7), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3a4a5a582e22451a$export$bc7adc8ef74607f), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3a4a5a582e22451a$export$f99233281efd08a0), {
                    style: {
                        fontWeight: '600',
                        fontSize: '15px',
                        padding: '10px 0 5px 20px'
                    },
                    children: "Linked Account Information:"
                })
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$bc7adc8ef74607f), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$a4fff7f2f85c4c81), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$cd1f041fcaf00d90), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3a4a5a582e22451a$export$5f1af8db9871e1d6), {
                                        children: "Reference ID: "
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3a4a5a582e22451a$export$5f1af8db9871e1d6), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$b2bf131c9f9cce5d), {
                                            onClick: ()=>{
                                                (0, $60e52eb6c2680325$export$7ca4b19155f576fa)(toggleUpgradeModal);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                    width: "80",
                                                    height: "16"
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2aac7bf62453042d$export$2e2bcd8739ae039), {
                                                    size: 18
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$cd1f041fcaf00d90), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3a4a5a582e22451a$export$5f1af8db9871e1d6), {
                                        children: "Account Type: "
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                        width: "80",
                                        height: "16"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$cd1f041fcaf00d90), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3a4a5a582e22451a$export$5f1af8db9871e1d6), {
                                        children: "Status: "
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                        width: "100",
                                        height: "16"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$cd1f041fcaf00d90), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3a4a5a582e22451a$export$5f1af8db9871e1d6), {
                                        children: "Email: "
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                        width: "60",
                                        height: "16"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$a4fff7f2f85c4c81), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$cd1f041fcaf00d90), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$66b8cea0c448285), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                width: "100",
                                                height: "18"
                                            }),
                                            " :",
                                            ' '
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                        width: "190",
                                        height: "18"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$cd1f041fcaf00d90), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$66b8cea0c448285), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                width: "120",
                                                height: "18"
                                            }),
                                            " :",
                                            ' '
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                        width: "160",
                                        height: "18"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$cd1f041fcaf00d90), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$66b8cea0c448285), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                width: "80",
                                                height: "18"
                                            }),
                                            " :",
                                            ' '
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                        width: "150",
                                        height: "18"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$cd1f041fcaf00d90), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$66b8cea0c448285), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                width: "90",
                                                height: "18"
                                            }),
                                            " :",
                                            ' '
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                        width: "160",
                                        height: "18"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$a4fff7f2f85c4c81), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$cd1f041fcaf00d90), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$66b8cea0c448285), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                width: "50",
                                                height: "18"
                                            }),
                                            " :",
                                            ' '
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                        width: "190",
                                        height: "18"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$cd1f041fcaf00d90), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$66b8cea0c448285), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                width: "120",
                                                height: "18"
                                            }),
                                            " :",
                                            ' '
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                        width: "160",
                                        height: "18"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$cd1f041fcaf00d90), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$66b8cea0c448285), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                width: "80",
                                                height: "18"
                                            }),
                                            " :",
                                            ' '
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                        width: "140",
                                        height: "18"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$cd1f041fcaf00d90), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$66b8cea0c448285), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                width: "50",
                                                height: "18"
                                            }),
                                            " :",
                                            ' '
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                        width: "190",
                                        height: "18"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3a4a5a582e22451a$export$bc7adc8ef74607f), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3a4a5a582e22451a$export$a9754b3c8daa5172), {
                    style: {
                        justifyContent: 'flex-end'
                    },
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                        variant: "outlined",
                        size: "small",
                        endIcon: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ef7aaa91ec87194a$export$2e2bcd8739ae039), {
                            size: 18
                        }),
                        onClick: ()=>{
                            (0, $60e52eb6c2680325$export$7ca4b19155f576fa)(toggleUpgradeModal);
                        },
                        children: "Link"
                    })
                })
            })
        ]
    });
}
// Default Props
$92502e80aed60cb0$var$LinkedAccount.defaultProps = {
    actions: {},
    address_data: {}
};
// Proptypes Validation
$92502e80aed60cb0$var$LinkedAccount.propTypes = {
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        toggleAddressHistoryModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        toggleAddressReportModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAddressReportDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAddressHistoryDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        toggleDeleteAddressModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setInfoModalDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        toggleUpgradeModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    accountDataProp: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        reference_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        business_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        account_type_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        name_first: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        name_middle: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        name_last: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        date_of_birth: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        nationality_code: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        display_country: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        name_legal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        name_business: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        inc_country_code: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        inc_date: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        email: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        address_street_name: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        address_city: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        address_region: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        address_postcode: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        address_country_code: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        primary_activity_code: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        account_risk_value: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        sanction_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        pep_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        adverse_media_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        comments: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        status_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        created: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        last_modified: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        is_customer: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    address_data: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        address: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        chain: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        symbol: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        risk_score: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        balance_usd: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        balance: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        modify_tz: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        link_type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        link_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    })
};
var $92502e80aed60cb0$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($92502e80aed60cb0$var$mapStateToProps, $92502e80aed60cb0$var$mapDispatchToProps)($92502e80aed60cb0$var$LinkedAccount);


var $b23676e155a1d74e$export$2e2bcd8739ae039 = (0, $92502e80aed60cb0$export$2e2bcd8739ae039);




// Map Redux Props
const $c8d91eb83307ec57$var$mapStateToProps = (state)=>state;
const $c8d91eb83307ec57$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $c8d91eb83307ec57$var$DemoAddressesTableItemDetails(props) {
    // Destructure
    const { isExpanded: isExpanded, BarWidth: BarWidth } = props;
    // Local state
    const [page, setPage] = (0, $tZqWC.useState)(0);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3a4a5a582e22451a$export$e6dfd72ab29f8598), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $3a4a5a582e22451a$export$42a852a2b6b56249), {
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b34cad56374d5647$export$2e2bcd8739ae039), {
                    page: page,
                    setPage: setPage
                }),
                page === 0 && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $973aed32bf54913c$export$2e2bcd8739ae039), {
                    isExpanded: isExpanded,
                    BarWidth: BarWidth
                }),
                page === 1 && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b23676e155a1d74e$export$2e2bcd8739ae039), {})
            ]
        })
    });
}
// Default Props
$c8d91eb83307ec57$var$DemoAddressesTableItemDetails.defaultProps = {
    addressData: null,
    actions: {},
    filters: {},
    ui: {},
    isExpanded: false
};
// Proptypes Validation
$c8d91eb83307ec57$var$DemoAddressesTableItemDetails.propTypes = {
    addressData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        address: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        chain: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        symbol: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        risk_score: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        risk_ratio: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        balance_usd: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        balance: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        modify_tz: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        create_tz: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        link_type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        link_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        modified_by_name: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    }),
    accountDataProp: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({}),
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        accountDirectoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object)
    }),
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        toggleAddressHistoryModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        toggleAddressReportModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAddressReportDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAddressHistoryDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        toggleDeleteAddressModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsLinkAddressDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAddressDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    isExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
};
var $c8d91eb83307ec57$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($c8d91eb83307ec57$var$mapStateToProps, $c8d91eb83307ec57$var$mapDispatchToProps)($c8d91eb83307ec57$var$DemoAddressesTableItemDetails);


var $6b641d0ecbd208c4$export$2e2bcd8739ae039 = (0, $c8d91eb83307ec57$export$2e2bcd8739ae039);


// Map Redux Props
const $de24ee18ef48309c$var$mapStateToProps = (state)=>state;
const $de24ee18ef48309c$var$mapDispatchToProps = (dispatch)=>(0, $2154a4c08d887b32$export$e324594224ef24da)(dispatch);
function $de24ee18ef48309c$var$DemoAddressesTableItem() {
    const [isExpanded, setIsExpanded] = (0, $tZqWC.useState)(false);
    // Local States
    const [BarWidth] = (0, $tZqWC.useState)(Math.floor(Math.random() * 100) + 1);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b3f7dc6528742bb0$export$2e2bcd8739ae039), {
        expandPanel: isExpanded,
        setIsExpanded: (val)=>{
            setIsExpanded(val);
        },
        panel: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6b641d0ecbd208c4$export$2e2bcd8739ae039), {
            BarWidth: BarWidth
        }),
        button: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $54ffb075fb600ebd$export$fd2299f554be8993), {
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $54ffb075fb600ebd$export$9f515a68dfaeb9ef), {
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $54ffb075fb600ebd$export$987cac99e7a31168), {
                            children: [
                                /*#__PURE__*/ (0, $tZqWC.cloneElement)((0, $df4784c9100a83b7$export$c25425c0b9a3de13).bitcoin),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                    width: "200"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $54ffb075fb600ebd$export$987cac99e7a31168), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                width: "80"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $54ffb075fb600ebd$export$9f515a68dfaeb9ef), {
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $54ffb075fb600ebd$export$987cac99e7a31168), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                    width: "40"
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f598a52270fcc8c$export$2e2bcd8739ae039), {
                                    width: BarWidth
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $54ffb075fb600ebd$export$987cac99e7a31168), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $54ffb075fb600ebd$export$6f4a084cc8e379b6), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                        width: "80",
                                        height: "17",
                                        style: {
                                            marginBottom: '4px'
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                        width: "40",
                                        height: "12",
                                        borderRadius: "3"
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
}
// Default Props
$de24ee18ef48309c$var$DemoAddressesTableItem.defaultProps = {
    actions: {},
    data: {
        id: '',
        address: '',
        chain: '',
        symbol: '',
        risk_score: 0,
        balance_usd: 0,
        balance: 0,
        last_modified: '',
        link_type: 1,
        link_id: ''
    }
};
// Proptypes Validation
$de24ee18ef48309c$var$DemoAddressesTableItem.propTypes = {
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        toggleUpgradeModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setInfoModalDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setScannedAddressDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAddressFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    data: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        address: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        chain: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        symbol: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        risk_score: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        risk_ratio: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        balance_usd: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        balance: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        last_modified: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        link_type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        link_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        modified_by_name: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    })
};
var $de24ee18ef48309c$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($de24ee18ef48309c$var$mapStateToProps, $de24ee18ef48309c$var$mapDispatchToProps)($de24ee18ef48309c$var$DemoAddressesTableItem);


var $c677612b35f7569e$export$2e2bcd8739ae039 = (0, $de24ee18ef48309c$export$2e2bcd8739ae039);


// Map Redux Props
const $759189601c3abb8d$var$mapStateToProps = (state)=>state;
const $759189601c3abb8d$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $759189601c3abb8d$var$DemoAddressesTable(props) {
    // Destructure
    const { filters: filters, actions: actions } = props;
    // Store States
    const { addressFilters: addressFilters } = filters;
    const { setAddressFilters: setAddressFilters } = actions;
    // Local states
    const [pagination] = (0, $tZqWC.useState)();
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $0f74268e2eba9440$export$4267411171632d35), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $d2b0b55dc8f66a40$export$2e2bcd8739ae039), {
            totalItems: pagination?.total && pagination.total,
            minWidth: 900,
            filterComponents: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $634affd988178051$export$2e2bcd8739ae039), {}),
            tableFilters: addressFilters,
            setTableFilters: setAddressFilters,
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c677612b35f7569e$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c677612b35f7569e$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c677612b35f7569e$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c677612b35f7569e$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c677612b35f7569e$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c677612b35f7569e$export$2e2bcd8739ae039), {})
            ]
        })
    });
}
// Default Props
$759189601c3abb8d$var$DemoAddressesTable.defaultProps = {
    actions: {},
    filters: {},
    ui: {},
    address: {
        addressChains: null
    }
};
// Proptypes Validation
$759189601c3abb8d$var$DemoAddressesTable.propTypes = {
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        addressFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object)
    }),
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setToBeUpdatedAccount: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAccountDirectoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsIndividualAccountDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsEntityAccountDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAddressFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setScannedAddress: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setScannedAddressDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAddressChains: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setDefaultAddressProvider: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    address: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        scannedAddress: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            address_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            address: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            chain: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            symbol: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            symbol_icon: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            financial_data: {
                provider_name: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
                balance: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
                balance_usd: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
                spent: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
                spent_usd: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
                received: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
                received_usd: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
                transaction_count: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
                latest_activity: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
            },
            risk_data: {
                provider_name: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
                risk_score: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
                vasp_name_legal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
                vasp_name_business: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
                vasp_website: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
                vasp_category: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
                api_result_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
            },
            request_tz: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            modified_by_name: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            link_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            link_type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number
        }),
        addressChains: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({}),
        defaultAddressProvider: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({})
    })
};
var $759189601c3abb8d$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($759189601c3abb8d$var$mapStateToProps, $759189601c3abb8d$var$mapDispatchToProps)($759189601c3abb8d$var$DemoAddressesTable);


var $46200402b6ebf2ff$export$2e2bcd8739ae039 = (0, $759189601c3abb8d$export$2e2bcd8739ae039);




/* eslint-disable react/prop-types */ 
parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");




const $e6a98ef17a7f7407$export$e6dfd72ab29f8598 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $e6a98ef17a7f7407$export$97ddd2af6308ba2 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  z-index: 6;
  position: fixed;
  top: 0;
  left: 0;
  height: 0;
  width: 100vw;

  display: flex;
  justify-content: center;
  align-items: flex-start;
  color: ${({ theme: theme })=>theme.colors.primary};
  // Themed Properties
`;
const $e6a98ef17a7f7407$export$b1d97b9d6e698468 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding-top: 20px;
  z-index: 7;
  position: relative;
  width: 100%;
  max-width: 700px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme: theme })=>theme.colors.primary};
  // Themed Properties
`;
const $e6a98ef17a7f7407$export$9fc98b514229b55b = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  z-index: ${({ isActive: isActive })=>isActive ? 7 : 0};
  width: 100%;
  display: grid;
  grid-template-columns: 30px 1fr 250px;
  justify-content: center;
  align-items: center;
  background: ${({ theme: theme, isActive: isActive })=>isActive ? theme.colors.backgroundLite : theme.colors.background};
  border-radius: 10px;
  padding: 5px 20px 5px 20px;

  transition: 0.3s;
  border: 1px solid ${({ theme: theme })=>`${theme.colors.backgroundLite}`};
  &:hover {
    border: 1px solid ${({ theme: theme })=>`${theme.colors.brand}40`};
  }
  & input {
    background: ${({ theme: theme, isActive: isActive })=>isActive ? theme.colors.backgroundLite : theme.colors.background};
    border: none;
    padding: 15px 20px 15px 15px;
  }
  & svg {
    stroke: ${({ theme: theme })=>theme.colors.primary};
  }
  & svg > path {
    stroke: ${({ theme: theme })=>theme.colors.primary};
  }
  & #addressSearchOptionsProvider {
    & > div > div:nth-child(3) {
      min-width: 160px;
      border-radius: 10px;
      & > div > div {
        padding: 8px 12px;
      }
    }
  }
  & #addressSearchOptionsChain {
    & > div > div:nth-child(3) {
      min-width: 160px;
      border-radius: 10px;
      & > div > div {
        padding: 8px 12px;
        & svg {
          min-width: 25px;
          stroke: transparent;
          & path {
            stroke: ${({ theme: theme })=>theme.colors.brand};
          }
        }
      }
    }
  }
`;
const $e6a98ef17a7f7407$export$a694082daf370b76 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-end;
`;
const $e6a98ef17a7f7407$export$698223c589197ab7 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background: ${({ theme: theme })=>`${theme.colors.background}`};
  transition: 0.3s;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 20px;
`;
const $e6a98ef17a7f7407$export$94756becb802e330 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: absolute;
  top: 39px;
  right: -60px;
  cursor: pointer;
  & svg {
    fill: ${({ theme: theme })=>theme.colors.primary};
  }
  & svg > path {
    fill: ${({ theme: theme })=>theme.colors.primary};
  }
`;
const $e6a98ef17a7f7407$export$d8f56ce9d09b24d3 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  z-index: ${({ isActive: isActive })=>isActive ? 6 : 0};
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  margin-top: -10px;
  display: flex;
  flex-direction: column;
  gap: 5px;

  background-color: ${({ theme: theme })=>theme.colors.background};
  padding: 20px 10px;
  border-radius: 0 0 10px 10px;
  box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.07);
  max-height: 400px;
  overflow-y: auto;
`;
const $e6a98ef17a7f7407$export$4b7e9f77c6f037f1 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  cursor: pointer;
  font-weight: 400;
  padding: 5px 10px;
  border-radius: 7px;

  &:hover {
    background-color: ${({ theme: theme, disabled: disabled })=>!disabled && theme.colors.backgroundLite};
  }
  border: ${({ theme: theme, active: active })=>active && `1px solid ${theme.colors.brand}`};
  border-radius: 8px;
`;
const $e6a98ef17a7f7407$export$f99233281efd08a0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h2`
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  margin: 15px 0 0 15px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;




// Map Redux Props
const $0ebccab34f4d2aa3$var$mapStateToProps = (state)=>state;
const $0ebccab34f4d2aa3$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $0ebccab34f4d2aa3$var$DemoAddressSearchBar(props) {
    // props
    const { actions: actions } = props;
    // destructure
    // Store Actions
    const { toggleUpgradeModal: toggleUpgradeModal } = actions;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e6a98ef17a7f7407$export$e6dfd72ab29f8598), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e6a98ef17a7f7407$export$97ddd2af6308ba2), {
            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e6a98ef17a7f7407$export$b1d97b9d6e698468), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $e6a98ef17a7f7407$export$9fc98b514229b55b), {
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2232f33a3cdf9fa0$export$2e2bcd8739ae039), {
                            size: 18
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ae78f1d128dc50d5$export$2e2bcd8739ae039), {
                            placeholder: "Screen a wallet address",
                            onClick: ()=>{
                                (0, $60e52eb6c2680325$export$7ca4b19155f576fa)(toggleUpgradeModal);
                            }
                        })
                    ]
                })
            })
        })
    });
}
// Default Props
$0ebccab34f4d2aa3$var$DemoAddressSearchBar.defaultProps = {
    actions: {}
};
// Proptypes Validation
$0ebccab34f4d2aa3$var$DemoAddressSearchBar.propTypes = {
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setScannedAddress: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        toggleUpgradeModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setInfoModalDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    address: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        addressChains: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({}),
        defaultAddressProvider: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({})
    })
};
var $0ebccab34f4d2aa3$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($0ebccab34f4d2aa3$var$mapStateToProps, $0ebccab34f4d2aa3$var$mapDispatchToProps)($0ebccab34f4d2aa3$var$DemoAddressSearchBar);


var $c1c00c24ff287506$export$2e2bcd8739ae039 = (0, $0ebccab34f4d2aa3$export$2e2bcd8739ae039);





var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");



const $b85a4c53f1ac9e4f$export$4267411171632d35 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 10px 0 0 0;
`;
const $b85a4c53f1ac9e4f$export$cbf11d5f692bc726 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
`;
const $b85a4c53f1ac9e4f$export$97d84ed62ab03b3f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  margin: 0px 0px 0px 16px;

  font-weight: inherit;
  font-size: inherit;
`;




parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");




const $d093d0378a7cd9a5$export$d052f996153b966 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  width: 100%;

  // If there is space then it's for the child
  // If there is no space then it's for the current component
  &#accountAddressTableFilter {
    & > div {
      padding: 0 !important;
      margin: 0 !important;
    }
  }
  & #travelruleDateFilter {
    justify-content: center;
    & > div {
      max-width: none !important;
    }
  }
  & #travelRuleSort {
    min-width: 245px;
    & .simpleSelectInputLabel {
      min-width: 165px;
    }
  }
  & #travelRuleAssetSort {
    & .simpleSelectInputLabel {
      min-width: 130px;
    }
  }
  & #addressDateFilter {
    & > div {
      max-width: none !important;
      padding: 0;
      height: 100%;
      gap: 10px;

      & p {
        font-size: 12px !important;
        margin: 0;
        display: flex;
        align-items: center;
        gap: 5px;
      }
    }
  }
  & #VASPSort {
    min-width: 200px;
    & .simpleSelectInputLabel {
      min-width: 120px;
    }
  }
`;
const $d093d0378a7cd9a5$export$ca4b1fc43afa0212 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;



// Map Redux Props
const $d921841276d18460$var$mapStateToProps = (state)=>state;
const $d921841276d18460$var$mapDispatchToProps = (dispatch)=>(0, $2154a4c08d887b32$export$e324594224ef24da)(dispatch);
function $d921841276d18460$var$DemoTransactionTableFilter(props) {
    // Destructure
    const { actions: actions } = props;
    // Store Actions
    const { toggleUpgradeModal: toggleUpgradeModal } = actions;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d093d0378a7cd9a5$export$d052f996153b966), {
        onClick: ()=>{
            (0, $60e52eb6c2680325$export$7ca4b19155f576fa)(toggleUpgradeModal);
        },
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $246a616d3a63a7c1$export$2e2bcd8739ae039), {
            filter: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("div", {})
        })
    });
}
// Default Props
$d921841276d18460$var$DemoTransactionTableFilter.defaultProps = {
    filters: {},
    actions: {}
};
// Proptypes Validation
$d921841276d18460$var$DemoTransactionTableFilter.propTypes = {
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        transactionFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            sort: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            account_type_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
            page_index: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
            start_range: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            end_range: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
        })
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setTransactionFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        toggleUpgradeModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setInfoModalDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $d921841276d18460$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($d921841276d18460$var$mapStateToProps, $d921841276d18460$var$mapDispatchToProps)($d921841276d18460$var$DemoTransactionTableFilter);


var $e2e92b45758884a9$export$2e2bcd8739ae039 = (0, $d921841276d18460$export$2e2bcd8739ae039);


/* eslint-disable react/no-unstable-nested-components */ 

var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");




const $4d894991528fc6b8$export$fd2299f554be8993 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: 1fr 1.8fr;
  gap: 50px;
  align-items: center;

  padding: 10px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $4d894991528fc6b8$export$9f515a68dfaeb9ef = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  gap: 20px;

  &:last-child > div:last-child {
    max-width: 150px;
  }
  &:last-child > div:first-child {
    justify-content: flex-end;
    max-width: 550px;
  }

  &:first-child > div:last-child {
    justify-content: flex-end;
    visibility: ${({ isExpanded: isExpanded })=>isExpanded && 'hidden'};
    width: ${({ isExpanded: isExpanded })=>isExpanded && 0};
  }
  &:last-child > div:first-child {
    visibility: ${({ isExpanded: isExpanded })=>isExpanded && 'hidden'};
    width: ${({ isExpanded: isExpanded })=>isExpanded && 0};
  }
`;
const $4d894991528fc6b8$export$987cac99e7a31168 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  width: 100%;

  gap: 20px;
`;
const $4d894991528fc6b8$export$6f4a084cc8e379b6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
`;
const $4d894991528fc6b8$export$49316f37c3b5fade = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 15px;
  font-weight: 400;

  max-width: 250px;

  &:first-child {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
`;
const $4d894991528fc6b8$export$edc246bee1ec68d2 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;

  & svg {
    height: 20px;
    width: 20px;
  }
`;
const $4d894991528fc6b8$export$829b0583f0fe5152 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 15px;
  font-weight: 400;
`;
const $4d894991528fc6b8$export$b30c94aee60c7d6b = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: absolute;
  top: 100%;
  margin-top: 10px;

  font-size: 15px;
  font-weight: 400;
  padding: 10px 20px;
  border-radius: 10px;
  background-color: ${({ theme: theme })=>theme.colors.background};

  transition: 0.1s;
  opacity: ${({ display: display })=>display ? 1 : 0};
  box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.15);
`;
const $4d894991528fc6b8$export$b502300b413480 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).span`
  font-size: 8px;
  font-weight: 400;
`;
const $4d894991528fc6b8$export$65b9fe47bb7b64b0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 10px;
  font-weight: 400;
`;
const $4d894991528fc6b8$export$85524e8d4e82fc69 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;



/* eslint-disable react/prop-types */ /* eslint-disable react/forbid-prop-types */ 
parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");




const $b731518ed0b1a470$export$e6dfd72ab29f8598 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
`;
const $b731518ed0b1a470$export$d53c836cccbb0d90 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: absolute;
  top: 0;
  right: 0;

  display: flex;
  gap: 10px;
`;
const $b731518ed0b1a470$export$42a852a2b6b56249 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $b731518ed0b1a470$export$f5ec1ee0b77895e7 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $b731518ed0b1a470$export$b2e35077a5c7bc77 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-start;

  width: 100%;
`;
const $b731518ed0b1a470$export$f6e382949408c1f3 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  min-width: 300px;
  gap: 8px;
  max-width: 470px;
`;
const $b731518ed0b1a470$export$bc7adc8ef74607f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding-top: 10px;
  display: flex;
  justify-content: space-between;
  gap: 10px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $b731518ed0b1a470$export$4e8a51dfb7785a56 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  width: 100%;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 10px;
`;
const $b731518ed0b1a470$export$a9754b3c8daa5172 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  gap: 10px;
`;
const $b731518ed0b1a470$export$cd1f041fcaf00d90 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 10px;
  padding: 10px 0;
  border-bottom: 1px solid ${({ theme: theme })=>theme.colors.backgroundLite};
`;
const $b731518ed0b1a470$export$acefde28a3cb7b20 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 10px;
  border-color: ${({ theme: theme })=>theme.colors.backgroundLite};
  border-style: solid;
  border-width: 0;
`;
const $b731518ed0b1a470$export$a4fff7f2f85c4c81 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  padding: 20px;
  width: 100%;
  height: 100%;
  border-radius: 7px;
  border: 1px solid ${({ theme: theme })=>theme.colors.backgroundLite};

  background-color: ${({ theme: theme })=>`${theme.colors.secondary}10`};
  & > div:last-child {
    border: none;
  }
`;
const $b731518ed0b1a470$export$87ad169bde460ddf = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 100%;

  border-color: ${({ theme: theme })=>theme.colors.backgroundLite};
  border-style: solid;
  border-width: 0;
`;
const $b731518ed0b1a470$export$d747b2abe71e53f5 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 100%;

  & > div:last-child {
    border: none;
    padding-bottom: 0;
  }
`;
const $b731518ed0b1a470$export$5f1af8db9871e1d6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  margin: 0;
  padding: 0;
  font-size: 14px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $b731518ed0b1a470$export$6d028b688a5b0ff9 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).span`
  /* color: ${({ theme: theme })=>theme.colors.brand}; */
  font-weight: 600;
`;
const $b731518ed0b1a470$export$c1dd341a97aad245 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).span`
  margin: 0;
  padding: 0;
  font-size: 12px;
  color: ${({ theme: theme, color: color })=>color === 'darkGray' ? theme.colors.primary : theme.colors.yellowGreen};
  border: 1px solid ${({ theme: theme, color: color })=>color === 'darkGray' ? theme.colors.primary : theme.colors.yellowGreen};
  border-radius: 5px;
`;
const $b731518ed0b1a470$export$f99233281efd08a0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h2`
  margin: 0;
  padding: 0;
  font-size: 15px;
  font-weight: 400;
  color: ${({ theme: theme })=>theme.colors.primary};
  text-transform: uppercase;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;
const $b731518ed0b1a470$export$ae133abb7f01f500 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 20px 0 0 0;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(520px, 1fr));
  gap: 60px;
`;
const $b731518ed0b1a470$export$8f314e512d92575f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  width: 40px;

  font-size: 20px;
  border: 1px solid ${({ theme: theme })=>theme.colors.primary};
  border-radius: 100%;
`;
const $b731518ed0b1a470$export$71237909d9ca197d = (0, $a778141486c79bc3$export$2e2bcd8739ae039).hr`
  width: 100%;
  height: 2px !important;

  color: ${({ theme: theme })=>theme.colors.secondary};
  margin: 20px 0;
`;
const $b731518ed0b1a470$export$dc8558b9a49863a4 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h2`
  margin: 0;
  padding: 0;
  font-size: 15px;
  font-weight: 400;
  color: ${({ theme: theme })=>theme.colors.primary};
  text-transform: uppercase;
  margin-bottom: -7px;

  font-weight: 300;
  font-size: 10px;
  padding-top: 5px;
  display: flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;
`;
const $b731518ed0b1a470$export$b2bf131c9f9cce5d = (0, $a778141486c79bc3$export$2e2bcd8739ae039)((0, $12b33660068e86aa$export$b0d92dbee9b5b60d))`
  display: flex;
  align-items: center;
  gap: 5px;
  height: 100%;

  & svg {
    height: 100%;
    max-height: 15px;
  }
`;
const $b731518ed0b1a470$export$87de03758d2d03db = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 20px 20px 0 20px;

  & #rsSubTitle {
    color: ${({ theme: theme })=>theme.colors.secondary};
  }
`;
const $b731518ed0b1a470$export$f2ab17920c9d243 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  justify-content: center;
  align-items: center;
  width: fit-content;
  padding: 20px 20px 20px 0;
  border-right: 1px solid ${({ theme: theme })=>theme.colors.backgroundLite};
`;


/* eslint-disable react/prop-types */ 
parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");






/* eslint-disable react/prop-types */ 
parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");


var $ejSM7 = parcelRequire("ejSM7");






const $000a77ad54c7a62a$export$5f1af8db9871e1d6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  margin: 0;
  padding: 0;
  font-size: 14px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $000a77ad54c7a62a$export$f99233281efd08a0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h2`
  margin: 0;
  padding: 0;
  font-size: 15px;
  font-weight: 400;
  color: ${({ theme: theme })=>theme.colors.primary};
  text-transform: uppercase;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;
const $000a77ad54c7a62a$export$d747b2abe71e53f5 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 100%;

  & > div:last-child {
    border: none;
    padding-bottom: 0;
  }
`;
const $000a77ad54c7a62a$export$bc7adc8ef74607f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding-top: 10px;
  display: flex;
  justify-content: space-between;
  gap: 10px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $000a77ad54c7a62a$export$a9754b3c8daa5172 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  gap: 10px;
`;
const $000a77ad54c7a62a$export$4e8a51dfb7785a56 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  width: 100%;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 10px;
`;
const $000a77ad54c7a62a$export$cd1f041fcaf00d90 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 10px;
  padding: 10px 0;
  border-bottom: 1px solid ${({ theme: theme })=>theme.colors.backgroundLite};
`;
const $000a77ad54c7a62a$export$a4fff7f2f85c4c81 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  padding: 20px;
  width: 100%;
  height: 100%;
  border-radius: 7px;
  border: 1px solid ${({ theme: theme })=>theme.colors.backgroundLite};
  transition: 0.3s;

  /* background-color: ${({ theme: theme })=>`${theme.colors.secondary}10`}; */
  & > div:last-child {
    border: none;
  }
  &#riskBlock:hover {
    cursor: pointer;
    border: 1px solid ${({ theme: theme })=>theme.colors.brand};
    background-color: ${({ theme: theme })=>`${theme.colors.brand}10`};
  }
`;
const $000a77ad54c7a62a$export$dc8558b9a49863a4 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h2`
  margin: 0;
  padding: 0;
  font-weight: 400;
  color: ${({ theme: theme })=>theme.colors.primary};

  font-size: 14px;
  padding-top: 5px;
  display: flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;
`;
const $000a77ad54c7a62a$export$87de03758d2d03db = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  & #rsSubTitle {
    color: ${({ theme: theme })=>theme.colors.secondary};
  }
`;


// Map Redux Props
const $5d09aaa87cf9ddea$var$mapStateToProps = (state)=>state;
const $5d09aaa87cf9ddea$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $5d09aaa87cf9ddea$var$RiskDetails(props) {
    const { isCreateOrUpdateTransactionLoading: isCreateOrUpdateTransactionLoading, actions: actions, BarWidth: BarWidth } = props;
    // Store
    const { toggleUpgradeModal: toggleUpgradeModal } = actions;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $000a77ad54c7a62a$export$a4fff7f2f85c4c81), {
        id: "riskBlock",
        onClick: ()=>{
            (0, $60e52eb6c2680325$export$7ca4b19155f576fa)(toggleUpgradeModal);
        },
        style: {
            marginTop: '15px',
            padding: '10px',
            borderWidth: 2
        },
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $000a77ad54c7a62a$export$bc7adc8ef74607f), {
            style: {
                padding: 0
            },
            children: !isCreateOrUpdateTransactionLoading && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $000a77ad54c7a62a$export$4e8a51dfb7785a56), {
                style: {
                    gap: '15px'
                },
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $000a77ad54c7a62a$export$a9754b3c8daa5172), {
                        style: {
                            gap: '10px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $000a77ad54c7a62a$export$a9754b3c8daa5172), {
                                style: {
                                    maxWidth: '250px',
                                    alignItems: 'center'
                                },
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $000a77ad54c7a62a$export$a4fff7f2f85c4c81), {
                                    style: {
                                        display: 'flex',
                                        padding: '30px 0'
                                    },
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $000a77ad54c7a62a$export$87de03758d2d03db), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ba8982a7854b309f$export$2e2bcd8739ae039), {
                                            id: `${123}-${1}`,
                                            size: 130,
                                            progress: BarWidth,
                                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $000a77ad54c7a62a$export$d747b2abe71e53f5), {
                                                style: {
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    gap: 0
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $000a77ad54c7a62a$export$5f1af8db9871e1d6), {
                                                        style: {
                                                            fontSize: '18px',
                                                            fontWeight: 600
                                                        },
                                                        children: `${BarWidth}%`
                                                    }),
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $000a77ad54c7a62a$export$5f1af8db9871e1d6), {
                                                        style: {
                                                            fontSize: '12px',
                                                            fontWeight: 400
                                                        },
                                                        id: "rsSubTitle",
                                                        children: "Risk"
                                                    })
                                                ]
                                            })
                                        }, 123)
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $000a77ad54c7a62a$export$a9754b3c8daa5172), {
                                style: {
                                    flex: 1
                                },
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $000a77ad54c7a62a$export$a4fff7f2f85c4c81), {
                                    children: [
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $000a77ad54c7a62a$export$f99233281efd08a0), {
                                            style: {
                                                textAlign: 'center'
                                            },
                                            children: [
                                                "Input Risk ",
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2d68211da31cd8b8$export$2e2bcd8739ae039), {
                                                    size: 18
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $000a77ad54c7a62a$export$cd1f041fcaf00d90), {
                                            children: [
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $000a77ad54c7a62a$export$dc8558b9a49863a4), {
                                                    children: "Risk Score"
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $000a77ad54c7a62a$export$5f1af8db9871e1d6), {
                                                    style: {
                                                        border: 'none',
                                                        fontSize: 15
                                                    },
                                                    children: [
                                                        `${BarWidth}`,
                                                        "/100"
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $000a77ad54c7a62a$export$cd1f041fcaf00d90), {
                                            children: [
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $000a77ad54c7a62a$export$dc8558b9a49863a4), {
                                                    style: {
                                                        cursor: 'default'
                                                    },
                                                    children: "Timestamp"
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $000a77ad54c7a62a$export$5f1af8db9871e1d6), {
                                                    style: {
                                                        border: 'none',
                                                        fontSize: 15
                                                    },
                                                    children: (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))('2024-11-07').format((0, $41a9e38e6be32f35$export$67a03cd247c60132))
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $000a77ad54c7a62a$export$cd1f041fcaf00d90), {
                                            children: [
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $000a77ad54c7a62a$export$dc8558b9a49863a4), {
                                                    children: "Source"
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                    width: "80",
                                                    height: "18"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $000a77ad54c7a62a$export$a9754b3c8daa5172), {
                        style: {
                            gap: '10px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $000a77ad54c7a62a$export$a9754b3c8daa5172), {
                                style: {
                                    maxWidth: '250px',
                                    alignItems: 'center'
                                },
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $000a77ad54c7a62a$export$a4fff7f2f85c4c81), {
                                    style: {
                                        display: 'flex',
                                        padding: '30px 0'
                                    },
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $000a77ad54c7a62a$export$87de03758d2d03db), {
                                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ba8982a7854b309f$export$2e2bcd8739ae039), {
                                            id: `${124}-${2}`,
                                            size: 130,
                                            progress: BarWidth - 5,
                                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $000a77ad54c7a62a$export$d747b2abe71e53f5), {
                                                style: {
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    gap: 0
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $000a77ad54c7a62a$export$5f1af8db9871e1d6), {
                                                        style: {
                                                            fontSize: '18px',
                                                            fontWeight: 600
                                                        },
                                                        children: `${BarWidth - 5}%`
                                                    }),
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $000a77ad54c7a62a$export$5f1af8db9871e1d6), {
                                                        style: {
                                                            fontSize: '12px',
                                                            fontWeight: 400
                                                        },
                                                        id: "rsSubTitle",
                                                        children: "Risk"
                                                    })
                                                ]
                                            })
                                        }, 124)
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $000a77ad54c7a62a$export$a9754b3c8daa5172), {
                                style: {
                                    flex: 1
                                },
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $000a77ad54c7a62a$export$a4fff7f2f85c4c81), {
                                    children: [
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $000a77ad54c7a62a$export$f99233281efd08a0), {
                                            style: {
                                                textAlign: 'center'
                                            },
                                            children: [
                                                "Output Risk ",
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $738b185bd23471f4$export$2e2bcd8739ae039), {
                                                    size: 18
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $000a77ad54c7a62a$export$cd1f041fcaf00d90), {
                                            children: [
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $000a77ad54c7a62a$export$dc8558b9a49863a4), {
                                                    children: "Risk Score"
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $000a77ad54c7a62a$export$5f1af8db9871e1d6), {
                                                    style: {
                                                        border: 'none',
                                                        fontSize: 15
                                                    },
                                                    children: [
                                                        `${BarWidth - 5}`,
                                                        "/100"
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $000a77ad54c7a62a$export$cd1f041fcaf00d90), {
                                            children: [
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $000a77ad54c7a62a$export$dc8558b9a49863a4), {
                                                    style: {
                                                        cursor: 'default'
                                                    },
                                                    children: "Timestamp"
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $000a77ad54c7a62a$export$5f1af8db9871e1d6), {
                                                    style: {
                                                        border: 'none',
                                                        fontSize: 15
                                                    },
                                                    children: (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))('2024-11-07').format((0, $41a9e38e6be32f35$export$67a03cd247c60132))
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $000a77ad54c7a62a$export$cd1f041fcaf00d90), {
                                            children: [
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $000a77ad54c7a62a$export$dc8558b9a49863a4), {
                                                    children: "Source"
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                    width: "80",
                                                    height: "18"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
}
// Default Props
$5d09aaa87cf9ddea$var$RiskDetails.defaultProps = {
    isCreateOrUpdateTransactionLoading: false,
    actions: {}
};
// Proptypes Validation
$5d09aaa87cf9ddea$var$RiskDetails.propTypes = {
    isCreateOrUpdateTransactionLoading: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool,
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        toggleUpgradeModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setInfoModalDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $5d09aaa87cf9ddea$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($5d09aaa87cf9ddea$var$mapStateToProps, $5d09aaa87cf9ddea$var$mapDispatchToProps)($5d09aaa87cf9ddea$var$RiskDetails);


var $886e3ac7cc714328$export$2e2bcd8739ae039 = (0, $5d09aaa87cf9ddea$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");


var $ejSM7 = parcelRequire("ejSM7");




const $6bf454379cbde962$export$5f1af8db9871e1d6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  margin: 0;
  padding: 0;
  font-size: 14px;
  color: ${({ theme: theme })=>theme.colors.primary};
  text-align: right;
`;
const $6bf454379cbde962$export$d747b2abe71e53f5 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  flex: 1;

  & > div:last-child {
    border: none;
    padding-bottom: 0;
  }
`;
const $6bf454379cbde962$export$bc7adc8ef74607f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding-top: 10px;
  display: flex;
  justify-content: space-between;
  gap: 10px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $6bf454379cbde962$export$a9754b3c8daa5172 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex: 1;
  gap: 20px;
`;
const $6bf454379cbde962$export$cd1f041fcaf00d90 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 10px;
  padding: 10px 0;
  border-bottom: 1px solid ${({ theme: theme })=>theme.colors.backgroundLite};
`;
const $6bf454379cbde962$export$a4fff7f2f85c4c81 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  padding: 20px;
  width: 100%;
  height: 100%;
  border-radius: 7px;
  border: 1px solid ${({ theme: theme })=>theme.colors.backgroundLite};

  /* background-color: ${({ theme: theme })=>`${theme.colors.secondary}10`}; */
  & > div:last-child {
    border: none;
  }
`;
const $6bf454379cbde962$export$dc8558b9a49863a4 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h2`
  margin: 0;
  padding: 0;
  font-weight: 400;
  color: ${({ theme: theme })=>theme.colors.primary};

  font-size: 14px;
  padding-top: 5px;
  display: flex;
  align-items: center;
  gap: 5px;
`;


// Map Redux Props
const $da759da0d44e22ba$var$mapStateToProps = (state)=>state;
const $da759da0d44e22ba$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $da759da0d44e22ba$var$FinancialDetails() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6bf454379cbde962$export$a4fff7f2f85c4c81), {
        style: {
            marginTop: '15px',
            padding: '10px',
            borderWidth: 2
        },
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6bf454379cbde962$export$bc7adc8ef74607f), {
            style: {
                padding: 0
            },
            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6bf454379cbde962$export$a9754b3c8daa5172), {
                style: {
                    gap: '15px'
                },
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6bf454379cbde962$export$a9754b3c8daa5172), {
                    style: {
                        gap: '15px'
                    },
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6bf454379cbde962$export$a4fff7f2f85c4c81), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6bf454379cbde962$export$a9754b3c8daa5172), {
                                style: {
                                    flex: 1
                                },
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6bf454379cbde962$export$d747b2abe71e53f5), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6bf454379cbde962$export$cd1f041fcaf00d90), {
                                                children: [
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6bf454379cbde962$export$dc8558b9a49863a4), {
                                                        children: "Digital Assets: "
                                                    }),
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                        width: "90"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6bf454379cbde962$export$cd1f041fcaf00d90), {
                                                children: [
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6bf454379cbde962$export$dc8558b9a49863a4), {
                                                        children: "Blockchain:"
                                                    }),
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                        width: "50"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6bf454379cbde962$export$cd1f041fcaf00d90), {
                                                children: [
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6bf454379cbde962$export$dc8558b9a49863a4), {
                                                        children: "Fee Amount USD: "
                                                    }),
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                        width: "80"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6bf454379cbde962$export$cd1f041fcaf00d90), {
                                                children: [
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6bf454379cbde962$export$dc8558b9a49863a4), {
                                                        children: "Timestamp:"
                                                    }),
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6bf454379cbde962$export$5f1af8db9871e1d6), {
                                                        children: (0, (/*@__PURE__*/$parcel$interopDefault($ejSM7)))('2024-11-07').format((0, $41a9e38e6be32f35$export$67a03cd247c60132))
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6bf454379cbde962$export$d747b2abe71e53f5), {
                                        children: [
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6bf454379cbde962$export$cd1f041fcaf00d90), {
                                                children: [
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6bf454379cbde962$export$dc8558b9a49863a4), {
                                                        children: "Input Amount USD:"
                                                    }),
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                        width: "110"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6bf454379cbde962$export$cd1f041fcaf00d90), {
                                                children: [
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6bf454379cbde962$export$dc8558b9a49863a4), {
                                                        children: "Input Events: "
                                                    }),
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                        width: "50"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6bf454379cbde962$export$cd1f041fcaf00d90), {
                                                children: [
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6bf454379cbde962$export$dc8558b9a49863a4), {
                                                        children: "Output Amount USD: "
                                                    }),
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                        width: "110"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $6bf454379cbde962$export$cd1f041fcaf00d90), {
                                                children: [
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6bf454379cbde962$export$dc8558b9a49863a4), {
                                                        children: "Output Events: "
                                                    }),
                                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                        width: "50"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6bf454379cbde962$export$a4fff7f2f85c4c81), {
                            style: {
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'flex-start',
                                gap: '8px',
                                flexWrap: 'wrap',
                                height: 'fit-content'
                            },
                            children: Array.from({
                                length: 30
                            }, (_, index)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                    width: `${Math.floor(Math.random() * 80) + 30}`
                                }, index))
                        })
                    ]
                })
            })
        })
    });
}
// Default Props
$da759da0d44e22ba$var$FinancialDetails.defaultProps = {
    actions: {},
    transactionData: {}
};
// Proptypes Validation
$da759da0d44e22ba$var$FinancialDetails.propTypes = {
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        toggleInfoModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setInfoModalDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    transactionData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        chain: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        symbol: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        risk_score: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        risk_ratio: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        in_usd: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        out_usd: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        fee_amount_usd: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        balance: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        last_modified: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        created: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        in_count: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        out_count: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        asset_count: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number
    })
};
var $da759da0d44e22ba$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($da759da0d44e22ba$var$mapStateToProps, $da759da0d44e22ba$var$mapDispatchToProps)($da759da0d44e22ba$var$FinancialDetails);


var $3fc53e1327439cdd$export$2e2bcd8739ae039 = (0, $da759da0d44e22ba$export$2e2bcd8739ae039);


// Map Redux Props
const $11991a76ef90ad87$var$mapStateToProps = (state)=>state;
const $11991a76ef90ad87$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $11991a76ef90ad87$var$DetailsSummary(props) {
    // Destructure
    const { actions: actions, BarWidth: BarWidth } = props;
    const { toggleUpgradeModal: toggleUpgradeModal } = actions;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $b731518ed0b1a470$export$f5ec1ee0b77895e7), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3fc53e1327439cdd$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $886e3ac7cc714328$export$2e2bcd8739ae039), {
                BarWidth: BarWidth
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $b731518ed0b1a470$export$bc7adc8ef74607f), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b731518ed0b1a470$export$a9754b3c8daa5172), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                            variant: "outlined",
                            size: "small",
                            disabled: true,
                            children: "Create Report"
                        })
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $b731518ed0b1a470$export$a9754b3c8daa5172), {
                        style: {
                            justifyContent: 'flex-end'
                        },
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                variant: "outlined",
                                size: "small",
                                endIcon: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b77b5de3fb591045$export$2e2bcd8739ae039), {
                                    size: 18
                                }),
                                onClick: ()=>{
                                    (0, $60e52eb6c2680325$export$7ca4b19155f576fa)(toggleUpgradeModal);
                                },
                                children: "Remove"
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ca6f920a36c82944$export$2e2bcd8739ae039), {
                                direction: "down",
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $478ff5739380e08c$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                        variant: "outlined",
                                        size: "small",
                                        endIcon: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6417d0fa9c066aa3$export$2e2bcd8739ae039), {
                                            size: 18
                                        }),
                                        onClick: ()=>{
                                            (0, $60e52eb6c2680325$export$7ca4b19155f576fa)(toggleUpgradeModal);
                                        },
                                        children: "Add score"
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
// Default Props
$11991a76ef90ad87$var$DetailsSummary.defaultProps = {
    actions: {}
};
// Proptypes Validation
$11991a76ef90ad87$var$DetailsSummary.propTypes = {
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        toggleTransactionReportModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setTransactionReportDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAddressHistoryDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        toggleDeleteTransactionModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsLinkTransactionDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setTransactionLinkDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAddressHistoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setTransactionRemove: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        toggleUpgradeModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setInfoModalDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        toggleTransactionDetailsModalOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setTransactionModalDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $11991a76ef90ad87$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($11991a76ef90ad87$var$mapStateToProps, $11991a76ef90ad87$var$mapDispatchToProps)($11991a76ef90ad87$var$DetailsSummary);


var $c4918315d0385545$export$2e2bcd8739ae039 = (0, $11991a76ef90ad87$export$2e2bcd8739ae039);




// Map Redux Props
const $e0d118e17f440628$var$mapStateToProps = (state)=>state;
const $e0d118e17f440628$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $e0d118e17f440628$var$DemoTransactionsTableItemDetails(props) {
    const { BarWidth: BarWidth } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b731518ed0b1a470$export$e6dfd72ab29f8598), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b731518ed0b1a470$export$42a852a2b6b56249), {
            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c4918315d0385545$export$2e2bcd8739ae039), {
                BarWidth: BarWidth
            })
        })
    });
}
// Default Props
$e0d118e17f440628$var$DemoTransactionsTableItemDetails.defaultProps = {
    transactionData: null,
    actions: {},
    filters: {},
    ui: {}
};
// Proptypes Validation
$e0d118e17f440628$var$DemoTransactionsTableItemDetails.propTypes = {
    eventDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        inputs: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            events: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).arrayOf({}),
            page: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number
        }),
        outputs: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            events: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).arrayOf({}),
            page: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number
        })
    }),
    transactionData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        address: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        chain: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        symbol: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        risk_score: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        risk_ratio: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        input_usd: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        output_usd: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        fee_amount_usd: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        balance: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        modify_tz: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        create_tz: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        sender_link_type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        sender_link_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setTransactionEventsFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    senderAccountData: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({}),
    // businessNotes: PropTypes.arrayOf({}),
    // setBusinessNotes: PropTypes.func,
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        transactionEventsFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object)
    }),
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    })
};
var $e0d118e17f440628$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($e0d118e17f440628$var$mapStateToProps, $e0d118e17f440628$var$mapDispatchToProps)($e0d118e17f440628$var$DemoTransactionsTableItemDetails);


var $53f004f4a0d8488a$export$2e2bcd8739ae039 = (0, $e0d118e17f440628$export$2e2bcd8739ae039);


// Map Redux Props
const $cd95ae1ae3d84f65$var$mapStateToProps = (state)=>state;
const $cd95ae1ae3d84f65$var$mapDispatchToProps = (dispatch)=>(0, $2154a4c08d887b32$export$e324594224ef24da)(dispatch);
function $cd95ae1ae3d84f65$var$DemoTransactionsTableItem() {
    const [isExpanded, setIsExpanded] = (0, $tZqWC.useState)(false);
    // Local States
    const [BarWidth] = (0, $tZqWC.useState)(Math.floor(Math.random() * 100) + 1);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b3f7dc6528742bb0$export$2e2bcd8739ae039), {
        expandPanel: isExpanded,
        setIsExpanded: (val)=>{
            setIsExpanded(val);
        },
        panel: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $53f004f4a0d8488a$export$2e2bcd8739ae039), {
            BarWidth: BarWidth
        }),
        button: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $4d894991528fc6b8$export$fd2299f554be8993), {
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $4d894991528fc6b8$export$9f515a68dfaeb9ef), {
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $4d894991528fc6b8$export$987cac99e7a31168), {
                            children: [
                                /*#__PURE__*/ (0, $tZqWC.cloneElement)((0, $df4784c9100a83b7$export$c25425c0b9a3de13).bitcoin),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                    width: "200"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $4d894991528fc6b8$export$987cac99e7a31168), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                width: "80"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $4d894991528fc6b8$export$9f515a68dfaeb9ef), {
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $4d894991528fc6b8$export$987cac99e7a31168), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                    width: "40"
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f598a52270fcc8c$export$2e2bcd8739ae039), {
                                    width: BarWidth
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $4d894991528fc6b8$export$987cac99e7a31168), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $4d894991528fc6b8$export$6f4a084cc8e379b6), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                        width: "80",
                                        height: "17",
                                        style: {
                                            marginBottom: '4px'
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                        width: "40",
                                        height: "12",
                                        borderRadius: "3"
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
}
// Default Props
$cd95ae1ae3d84f65$var$DemoTransactionsTableItem.defaultProps = {
    actions: {},
    data: {
        id: '',
        address: '',
        chain: '',
        symbol: '',
        risk_score: 0,
        balance_usd: 0,
        balance: 0,
        last_modified: '',
        link_type: 1,
        link_id: ''
    }
};
// Proptypes Validation
$cd95ae1ae3d84f65$var$DemoTransactionsTableItem.propTypes = {
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        toggleUpgradeModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setInfoModalDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setScannedAddressDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAddressFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    data: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        address: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        chain: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        symbol: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        risk_score: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        risk_ratio: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        balance_usd: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        balance: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        last_modified: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        link_type: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
        link_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
        modified_by_name: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
    })
};
var $cd95ae1ae3d84f65$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($cd95ae1ae3d84f65$var$mapStateToProps, $cd95ae1ae3d84f65$var$mapDispatchToProps)($cd95ae1ae3d84f65$var$DemoTransactionsTableItem);


var $267c19e3f632f48a$export$2e2bcd8739ae039 = (0, $cd95ae1ae3d84f65$export$2e2bcd8739ae039);


// Map Redux Props
const $820f672e33c765b7$var$mapStateToProps = (state)=>state;
const $820f672e33c765b7$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $820f672e33c765b7$var$DemoTransactionsTable(props) {
    // Destructure
    const { filters: filters, actions: actions } = props;
    // Store States
    const { transactionFilters: transactionFilters } = filters;
    const { setTransactionFilters: setTransactionFilters } = actions;
    // Local states
    const [pagination] = (0, $tZqWC.useState)();
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b85a4c53f1ac9e4f$export$4267411171632d35), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $d2b0b55dc8f66a40$export$2e2bcd8739ae039), {
            totalItems: pagination?.total && pagination.total,
            minWidth: 900,
            filterComponents: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e2e92b45758884a9$export$2e2bcd8739ae039), {}),
            tableFilters: transactionFilters,
            setTableFilters: setTransactionFilters,
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $267c19e3f632f48a$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $267c19e3f632f48a$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $267c19e3f632f48a$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $267c19e3f632f48a$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $267c19e3f632f48a$export$2e2bcd8739ae039), {})
            ]
        })
    });
}
// Default Props
$820f672e33c765b7$var$DemoTransactionsTable.defaultProps = {
    actions: {},
    filters: {},
    ui: {}
};
// Proptypes Validation
$820f672e33c765b7$var$DemoTransactionsTable.propTypes = {
    transaction: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        scannedTransaction: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object),
        transactionChains: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({}),
        defaultTransactionProvider: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({})
    }),
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        transactionFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object)
    }),
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setToBeUpdatedAccount: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAccountDirectoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsIndividualAccountDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsEntityAccountDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setTransactionFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setScannedTransaction: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setScannedTransactionDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setTransactionChains: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setDefaultTransactionProvider: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $820f672e33c765b7$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($820f672e33c765b7$var$mapStateToProps, $820f672e33c765b7$var$mapDispatchToProps)($820f672e33c765b7$var$DemoTransactionsTable);


var $8073406036120311$export$2e2bcd8739ae039 = (0, $820f672e33c765b7$export$2e2bcd8739ae039);




/* eslint-disable react/prop-types */ 
parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");




const $091751a0ebff14ed$export$e6dfd72ab29f8598 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $091751a0ebff14ed$export$97ddd2af6308ba2 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  z-index: 6;
  position: fixed;
  top: 0;
  left: 0;
  height: 0;
  width: 100vw;

  display: flex;
  justify-content: center;
  align-items: flex-start;
  color: ${({ theme: theme })=>theme.colors.primary};
  // Themed Properties
`;
const $091751a0ebff14ed$export$b1d97b9d6e698468 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding-top: 20px;
  z-index: 7;
  position: relative;
  width: 100%;
  max-width: 700px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme: theme })=>theme.colors.primary};
  // Themed Properties
`;
const $091751a0ebff14ed$export$9fc98b514229b55b = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  z-index: ${({ isActive: isActive })=>isActive ? 7 : 0};
  width: 100%;
  display: grid;
  grid-template-columns: 30px 1fr 250px;
  justify-content: center;
  align-items: center;
  background: ${({ theme: theme, isActive: isActive })=>isActive ? theme.colors.backgroundLite : theme.colors.background};
  border-radius: 10px;
  padding: 5px 20px 5px 20px;

  transition: 0.3s;
  border: 1px solid ${({ theme: theme })=>`${theme.colors.backgroundLite}`};
  &:hover {
    border: 1px solid ${({ theme: theme })=>`${theme.colors.brand}40`};
  }
  & input {
    background: ${({ theme: theme, isActive: isActive })=>isActive ? theme.colors.backgroundLite : theme.colors.background};
    border: none;
    padding: 15px 20px 15px 15px;
  }
  & svg {
    stroke: ${({ theme: theme })=>theme.colors.primary};
  }
  & svg > path {
    stroke: ${({ theme: theme })=>theme.colors.primary};
  }
  & #addressSearchOptionsProvider {
    & > div > div:nth-child(3) {
      min-width: 160px;
      border-radius: 10px;
      & > div > div {
        padding: 8px 12px;
      }
    }
  }
  & #addressSearchOptionsChain {
    & > div > div:nth-child(3) {
      min-width: 160px;
      border-radius: 10px;
      & > div > div {
        padding: 8px 12px;
        & svg {
          min-width: 25px;
          stroke: transparent;
          & path {
            stroke: ${({ theme: theme })=>theme.colors.brand};
          }
        }
      }
    }
  }
`;
const $091751a0ebff14ed$export$a694082daf370b76 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-end;
`;
const $091751a0ebff14ed$export$698223c589197ab7 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background: ${({ theme: theme })=>`${theme.colors.background}`};
  transition: 0.3s;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 20px;
`;
const $091751a0ebff14ed$export$94756becb802e330 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: absolute;
  top: 39px;
  right: -60px;
  cursor: pointer;
  & svg {
    fill: ${({ theme: theme })=>theme.colors.primary};
  }
  & svg > path {
    fill: ${({ theme: theme })=>theme.colors.primary};
  }
`;
const $091751a0ebff14ed$export$d8f56ce9d09b24d3 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  z-index: ${({ isActive: isActive })=>isActive ? 6 : 0};
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  margin-top: -10px;
  display: flex;
  flex-direction: column;
  gap: 5px;

  background-color: ${({ theme: theme })=>theme.colors.background};
  padding: 20px 10px;
  border-radius: 0 0 10px 10px;
  box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.07);
  max-height: 400px;
  overflow-y: auto;
`;
const $091751a0ebff14ed$export$4b7e9f77c6f037f1 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  cursor: pointer;
  font-weight: 400;
  padding: 5px 10px;
  border-radius: 7px;

  &:hover {
    background-color: ${({ theme: theme, disabled: disabled })=>!disabled && theme.colors.backgroundLite};
  }
  border: ${({ theme: theme, active: active })=>active && `1px solid ${theme.colors.brand}`};
  border-radius: 8px;
`;
const $091751a0ebff14ed$export$f99233281efd08a0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h2`
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  margin: 15px 0 0 15px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;




// Map Redux Props
const $407e679785df82b1$var$mapStateToProps = (state)=>state;
const $407e679785df82b1$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $407e679785df82b1$var$DemoTransactionSearchBar(props) {
    // props
    const { actions: actions } = props;
    // destructure
    // Store Actions
    const { toggleUpgradeModal: toggleUpgradeModal } = actions;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $091751a0ebff14ed$export$e6dfd72ab29f8598), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $091751a0ebff14ed$export$97ddd2af6308ba2), {
            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $091751a0ebff14ed$export$b1d97b9d6e698468), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $091751a0ebff14ed$export$9fc98b514229b55b), {
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2232f33a3cdf9fa0$export$2e2bcd8739ae039), {
                            size: 18
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ae78f1d128dc50d5$export$2e2bcd8739ae039), {
                            placeholder: "Screen a transaction hash",
                            onClick: ()=>{
                                (0, $60e52eb6c2680325$export$7ca4b19155f576fa)(toggleUpgradeModal);
                            }
                        })
                    ]
                })
            })
        })
    });
}
// Default Props
$407e679785df82b1$var$DemoTransactionSearchBar.defaultProps = {
    actions: {}
};
// Proptypes Validation
$407e679785df82b1$var$DemoTransactionSearchBar.propTypes = {
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setScannedAddress: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        toggleUpgradeModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setInfoModalDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    address: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        addressChains: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({}),
        defaultAddressProvider: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({})
    })
};
var $407e679785df82b1$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($407e679785df82b1$var$mapStateToProps, $407e679785df82b1$var$mapDispatchToProps)($407e679785df82b1$var$DemoTransactionSearchBar);


var $c04c240b3ffb5d63$export$2e2bcd8739ae039 = (0, $407e679785df82b1$export$2e2bcd8739ae039);




parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");





const $76d1193d285f22e0$export$603ae81ab9412b1f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;



/* eslint-disable react/prop-types */ 
parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");




const $0eef3ac5d8b0f2e4$export$d052f996153b966 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  width: 100%;

  // If there is space then it's for the child
  // If there is no space then it's for the current component
  &#accountAddressTableFilter {
    & > div {
      padding: 0 !important;
      margin: 0 !important;
    }
  }
  & #travelruleDateFilter {
    justify-content: center;
    & > div {
      max-width: none !important;
    }
  }
  & #travelRuleSort {
    min-width: 245px;
    & .simpleSelectInputLabel {
      min-width: 165px;
    }
  }
  & #travelRuleAssetSort {
    & .simpleSelectInputLabel {
      min-width: 130px;
    }
  }
  & #addressDateFilter {
    & > div {
      max-width: none !important;
      padding: 0;
      height: 100%;
      gap: 10px;

      & p {
        font-size: 12px !important;
        margin: 0;
        display: flex;
        align-items: center;
        gap: 5px;
      }
    }
  }
  & #VASPSort {
    min-width: 200px;
    & .simpleSelectInputLabel {
      min-width: 120px;
    }
  }
`;
const $0eef3ac5d8b0f2e4$export$ca4b1fc43afa0212 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;



// Map Redux Props
const $9a959838a253318e$var$mapStateToProps = (state)=>state;
const $9a959838a253318e$var$mapDispatchToProps = (dispatch)=>(0, $2154a4c08d887b32$export$e324594224ef24da)(dispatch);
function $9a959838a253318e$var$DemoTravelRuleTableFilter(props) {
    // Destructure
    const { actions: actions } = props;
    // Store Actions
    const { toggleUpgradeModal: toggleUpgradeModal } = actions;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $0eef3ac5d8b0f2e4$export$d052f996153b966), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $69a991355976a1a9$export$2e2bcd8739ae039), {
            disabledOptions: true,
            placeholder: "Search Transfer Number or Transaction Hash...",
            onInputChange: ()=>{},
            onClick: ()=>{
                (0, $60e52eb6c2680325$export$7ca4b19155f576fa)(toggleUpgradeModal);
            },
            isLoading: false
        })
    });
}
// Default Props
$9a959838a253318e$var$DemoTravelRuleTableFilter.defaultProps = {
    filters: {},
    actions: {}
};
// Proptypes Validation
$9a959838a253318e$var$DemoTravelRuleTableFilter.propTypes = {
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        travelRuleFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            sort: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            start_date: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            end_date: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            direction_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            asset_code: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
            transfer_status_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number
        })
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setTravelRuleFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    address: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        addressChains: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({})
    })
};
var $9a959838a253318e$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($9a959838a253318e$var$mapStateToProps, $9a959838a253318e$var$mapDispatchToProps)($9a959838a253318e$var$DemoTravelRuleTableFilter);


var $5f4dca5a2a3379f5$export$2e2bcd8739ae039 = (0, $9a959838a253318e$export$2e2bcd8739ae039);


/* eslint-disable react/no-unstable-nested-components */ 

var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");




const $0c23e0a7958ec8f2$export$fd2299f554be8993 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: 1fr 1.8fr;
  gap: 50px;
  align-items: center;

  padding: 10px 20px 10px 20px;
  color: ${({ theme: theme })=>theme.colors.primary};
  & svg > path {
    stroke: ${({ theme: theme })=>theme.colors.primary};
  }
`;
const $0c23e0a7958ec8f2$export$9f515a68dfaeb9ef = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  gap: 20px;

  &:last-child > div:last-child {
    max-width: 150px;
  }
  &:last-child > div:first-child {
    justify-content: flex-end;
    max-width: 550px;
  }

  &:first-child > div:last-child {
    justify-content: flex-end;
    visibility: ${({ isExpanded: isExpanded })=>isExpanded && 'hidden'};
  }
  &:last-child > div:first-child {
    visibility: ${({ isExpanded: isExpanded })=>isExpanded && 'hidden'};
  }
`;
const $0c23e0a7958ec8f2$export$987cac99e7a31168 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  width: 100%;

  gap: 20px;
`;
const $0c23e0a7958ec8f2$export$6f4a084cc8e379b6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
`;
const $0c23e0a7958ec8f2$export$49316f37c3b5fade = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 15px;
  font-weight: 400;

  max-width: 250px;

  &:first-child {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
`;
const $0c23e0a7958ec8f2$export$65b9fe47bb7b64b0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 10px;
  font-weight: 400;
  display: flex;
  align-items: center;
  gap: 5px;
`;
const $0c23e0a7958ec8f2$export$85524e8d4e82fc69 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;



/* eslint-disable react/forbid-prop-types */ 

var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");





const $50f142d87e46ab8e$export$e6dfd72ab29f8598 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  padding: 20px;
`;
const $50f142d87e46ab8e$export$d53c836cccbb0d90 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: absolute;
  top: 0;
  right: 0;

  display: flex;
  gap: 10px;
`;
const $50f142d87e46ab8e$export$42a852a2b6b56249 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $50f142d87e46ab8e$export$f5ec1ee0b77895e7 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: 1fr 1fr;

  margin-top: 20px;
  gap: 20px;
  padding-bottom: 20px;
`;
const $50f142d87e46ab8e$export$b2e35077a5c7bc77 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-start;

  width: 100%;
`;
const $50f142d87e46ab8e$export$f6e382949408c1f3 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  min-width: 300px;
  gap: 8px;
  height: fit-content;
`;
const $50f142d87e46ab8e$export$bc7adc8ef74607f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  gap: 20px;
  & p:nth-child(2) {
    text-align: right;
  }
  & p:first-child {
    min-width: 150px;
  }
`;
const $50f142d87e46ab8e$export$87ad169bde460ddf = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
`;
const $50f142d87e46ab8e$export$d747b2abe71e53f5 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 100%;
`;
const $50f142d87e46ab8e$export$5f1af8db9871e1d6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  margin: 0;
  padding: 0;
  font-size: 13px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $50f142d87e46ab8e$export$f99233281efd08a0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h2`
  margin: 0;
  padding: 0;
  font-size: 13px;
  font-weight: 700;
  color: ${({ theme: theme })=>theme.colors.primary};
  margin-bottom: 10px;
`;
const $50f142d87e46ab8e$export$ae133abb7f01f500 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 20px 0 0 0;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(520px, 1fr));
  gap: 20px;
`;
const $50f142d87e46ab8e$export$71237909d9ca197d = (0, $a778141486c79bc3$export$2e2bcd8739ae039).hr`
  width: 100%;
  height: 2px !important;

  color: ${({ theme: theme })=>theme.colors.secondary};
  margin: 20px 0;
`;
const $50f142d87e46ab8e$export$b2bf131c9f9cce5d = (0, $a778141486c79bc3$export$2e2bcd8739ae039)((0, $12b33660068e86aa$export$b0d92dbee9b5b60d))`
  display: flex;
  align-items: center;
  gap: 5px;
  height: 100%;

  & svg {
    height: 100%;
    max-height: 15px;
  }
`;
const $50f142d87e46ab8e$export$a4fff7f2f85c4c81 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  padding: 20px;
  width: 100%;
  border-radius: 7px;
  border: 1px solid ${({ theme: theme })=>theme.colors.backgroundLite};
  transition: 0.3s;
  height: fit-content;
`;




// Map Redux Props
const $f1838dbf630cad3c$var$mapStateToProps = (state)=>state;
const $f1838dbf630cad3c$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $f1838dbf630cad3c$var$DemoTravelRuleTableItemDetails(props) {
    // Destructure
    const { actions: actions } = props;
    const { toggleUpgradeModal: toggleUpgradeModal } = actions;
    // hooks
    const [page, setPage] = (0, $tZqWC.useState)(0);
    const [formattedFlow] = (0, $tZqWC.useState)([
        {
            leftLabel: '2024-11-13T03:09:33',
            rightLabel: 'Initiated',
            disabled: false,
            failed: false
        },
        {
            leftLabel: null,
            rightLabel: 'Information Sent',
            disabled: false,
            failed: false
        },
        {
            leftLabel: null,
            rightLabel: 'Pending Counterparty Action',
            disabled: false,
            failed: false
        },
        {
            leftLabel: null,
            rightLabel: 'Counterparty Action',
            disabled: false,
            failed: false
        },
        {
            leftLabel: null,
            rightLabel: 'Confirmed',
            disabled: false,
            failed: false
        }
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $50f142d87e46ab8e$export$e6dfd72ab29f8598), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $50f142d87e46ab8e$export$42a852a2b6b56249), {
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $50f142d87e46ab8e$export$d53c836cccbb0d90), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                        size: "small",
                        variant: "outlined",
                        onClick: ()=>{
                            (0, $60e52eb6c2680325$export$7ca4b19155f576fa)(toggleUpgradeModal);
                        },
                        children: "Cancel"
                    })
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $61931cc7babf29b2$export$2e2bcd8739ae039), {
                    page: page,
                    setPage: setPage
                }),
                page === 0 && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $50f142d87e46ab8e$export$f5ec1ee0b77895e7), {
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $50f142d87e46ab8e$export$b2e35077a5c7bc77), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $50f142d87e46ab8e$export$a4fff7f2f85c4c81), {
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $50f142d87e46ab8e$export$f6e382949408c1f3), {
                                    children: [
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $50f142d87e46ab8e$export$bc7adc8ef74607f), {
                                            children: [
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $50f142d87e46ab8e$export$5f1af8db9871e1d6), {
                                                    children: "Date Initiated:"
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                    width: "210"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $50f142d87e46ab8e$export$bc7adc8ef74607f), {
                                            children: [
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $50f142d87e46ab8e$export$5f1af8db9871e1d6), {
                                                    children: "Transfer Number:"
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                    width: "290"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $50f142d87e46ab8e$export$bc7adc8ef74607f), {
                                            children: [
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $50f142d87e46ab8e$export$5f1af8db9871e1d6), {
                                                    children: "Asset: "
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                    width: "100"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $50f142d87e46ab8e$export$bc7adc8ef74607f), {
                                            children: [
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $50f142d87e46ab8e$export$5f1af8db9871e1d6), {
                                                    children: "Amount:"
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                    width: "180"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $50f142d87e46ab8e$export$bc7adc8ef74607f), {
                                            children: [
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $50f142d87e46ab8e$export$5f1af8db9871e1d6), {
                                                    children: "Amount USD:"
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                    width: "150"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $50f142d87e46ab8e$export$b2e35077a5c7bc77), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $50f142d87e46ab8e$export$a4fff7f2f85c4c81), {
                                style: {
                                    paddingBottom: '60px'
                                },
                                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1388d6ff56865309$export$2e2bcd8739ae039), {
                                    headers: formattedFlow
                                })
                            })
                        })
                    ]
                }),
                page === 1 && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $50f142d87e46ab8e$export$ae133abb7f01f500), {
                    style: {
                        gridTemplateColumns: '1fr'
                    },
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $50f142d87e46ab8e$export$bc7adc8ef74607f), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $50f142d87e46ab8e$export$87ad169bde460ddf), {
                            style: {
                                display: 'grid',
                                gridTemplateColumns: 'repeat(auto-fill, minmax(500px, 1fr))'
                            },
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $50f142d87e46ab8e$export$a4fff7f2f85c4c81), {
                                    style: {
                                        height: '100%',
                                        gap: '8px',
                                        display: 'flex',
                                        flexDirection: 'column'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $50f142d87e46ab8e$export$f99233281efd08a0), {
                                            children: "Beneficiary"
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $50f142d87e46ab8e$export$bc7adc8ef74607f), {
                                            children: [
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $50f142d87e46ab8e$export$5f1af8db9871e1d6), {
                                                    children: "Reference ID: "
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                    width: "180"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $50f142d87e46ab8e$export$bc7adc8ef74607f), {
                                            children: [
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $50f142d87e46ab8e$export$5f1af8db9871e1d6), {
                                                    children: "Customer ID: "
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                    width: "180"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $50f142d87e46ab8e$export$bc7adc8ef74607f), {
                                            children: [
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $50f142d87e46ab8e$export$5f1af8db9871e1d6), {
                                                    children: "Name: "
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                    width: "240"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $50f142d87e46ab8e$export$bc7adc8ef74607f), {
                                            children: [
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $50f142d87e46ab8e$export$5f1af8db9871e1d6), {
                                                    children: "Wallet Address: "
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                    width: "280"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $50f142d87e46ab8e$export$bc7adc8ef74607f), {
                                            children: [
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $50f142d87e46ab8e$export$5f1af8db9871e1d6), {
                                                    children: "Physical Address: "
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                    width: "250"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $50f142d87e46ab8e$export$a4fff7f2f85c4c81), {
                                    style: {
                                        height: '100%',
                                        gap: '8px',
                                        display: 'flex',
                                        flexDirection: 'column'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $50f142d87e46ab8e$export$f99233281efd08a0), {
                                            children: "Beneficiary VASP"
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $50f142d87e46ab8e$export$bc7adc8ef74607f), {
                                            children: [
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $50f142d87e46ab8e$export$5f1af8db9871e1d6), {
                                                    children: "Legal Name: "
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                    width: "240"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $50f142d87e46ab8e$export$bc7adc8ef74607f), {
                                            children: [
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $50f142d87e46ab8e$export$5f1af8db9871e1d6), {
                                                    children: "Website: "
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                    width: "280"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $50f142d87e46ab8e$export$bc7adc8ef74607f), {
                                            children: [
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $50f142d87e46ab8e$export$5f1af8db9871e1d6), {
                                                    children: "National ID: "
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                    width: "180"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $50f142d87e46ab8e$export$bc7adc8ef74607f), {
                                            children: [
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $50f142d87e46ab8e$export$5f1af8db9871e1d6), {
                                                    children: "Registration Country: "
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                    width: "170"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $50f142d87e46ab8e$export$bc7adc8ef74607f), {
                                            children: [
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $50f142d87e46ab8e$export$5f1af8db9871e1d6), {
                                                    children: "Physical Address: "
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                    width: "230"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $50f142d87e46ab8e$export$a4fff7f2f85c4c81), {
                                    style: {
                                        height: '100%',
                                        gap: '8px',
                                        display: 'flex',
                                        flexDirection: 'column'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $50f142d87e46ab8e$export$f99233281efd08a0), {
                                            children: "Originator"
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $50f142d87e46ab8e$export$bc7adc8ef74607f), {
                                            children: [
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $50f142d87e46ab8e$export$5f1af8db9871e1d6), {
                                                    children: "Reference ID: "
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                    width: "180"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $50f142d87e46ab8e$export$bc7adc8ef74607f), {
                                            children: [
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $50f142d87e46ab8e$export$5f1af8db9871e1d6), {
                                                    children: "Customer ID: "
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                    width: "180"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $50f142d87e46ab8e$export$bc7adc8ef74607f), {
                                            children: [
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $50f142d87e46ab8e$export$5f1af8db9871e1d6), {
                                                    children: "Name: "
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                    width: "240"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $50f142d87e46ab8e$export$bc7adc8ef74607f), {
                                            children: [
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $50f142d87e46ab8e$export$5f1af8db9871e1d6), {
                                                    children: "National ID"
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                    width: "180"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $50f142d87e46ab8e$export$bc7adc8ef74607f), {
                                            children: [
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $50f142d87e46ab8e$export$5f1af8db9871e1d6), {
                                                    children: "Registration Country: "
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                    width: "150"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $50f142d87e46ab8e$export$bc7adc8ef74607f), {
                                            children: [
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $50f142d87e46ab8e$export$5f1af8db9871e1d6), {
                                                    children: "Wallet Address: "
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                    width: "280"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $50f142d87e46ab8e$export$bc7adc8ef74607f), {
                                            children: [
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $50f142d87e46ab8e$export$5f1af8db9871e1d6), {
                                                    children: "Physical Address: "
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                    width: "250"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $50f142d87e46ab8e$export$a4fff7f2f85c4c81), {
                                    style: {
                                        height: '100%',
                                        gap: '8px',
                                        display: 'flex',
                                        flexDirection: 'column'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $50f142d87e46ab8e$export$f99233281efd08a0), {
                                            children: "Originator VASP"
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $50f142d87e46ab8e$export$bc7adc8ef74607f), {
                                            children: [
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $50f142d87e46ab8e$export$5f1af8db9871e1d6), {
                                                    children: "Legal Name: "
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                    width: "240"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $50f142d87e46ab8e$export$bc7adc8ef74607f), {
                                            children: [
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $50f142d87e46ab8e$export$5f1af8db9871e1d6), {
                                                    children: "Website: "
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                    width: "280"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $50f142d87e46ab8e$export$bc7adc8ef74607f), {
                                            children: [
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $50f142d87e46ab8e$export$5f1af8db9871e1d6), {
                                                    children: "National ID: "
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                    width: "180"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $50f142d87e46ab8e$export$bc7adc8ef74607f), {
                                            children: [
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $50f142d87e46ab8e$export$5f1af8db9871e1d6), {
                                                    children: "Registration Country: "
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                    width: "170"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $50f142d87e46ab8e$export$bc7adc8ef74607f), {
                                            children: [
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $50f142d87e46ab8e$export$5f1af8db9871e1d6), {
                                                    children: "Physical Address: "
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                    width: "230"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
}
// Default Props
$f1838dbf630cad3c$var$DemoTravelRuleTableItemDetails.defaultProps = {
    actions: {}
};
// Proptypes Validation
$f1838dbf630cad3c$var$DemoTravelRuleTableItemDetails.propTypes = {
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        toggleUpgradeModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setInfoModalDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $f1838dbf630cad3c$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($f1838dbf630cad3c$var$mapStateToProps, $f1838dbf630cad3c$var$mapDispatchToProps)($f1838dbf630cad3c$var$DemoTravelRuleTableItemDetails);


var $95fa9eb1e8a1a9f2$export$2e2bcd8739ae039 = (0, $f1838dbf630cad3c$export$2e2bcd8739ae039);


// Map Redux Props
const $b19cde6aceae8b0d$var$mapStateToProps = (state)=>state;
const $b19cde6aceae8b0d$var$mapDispatchToProps = (dispatch)=>(0, $2154a4c08d887b32$export$e324594224ef24da)(dispatch);
function $b19cde6aceae8b0d$var$DemoTravelRuleTableItem(props) {
    // Destructure
    const { progress: progress } = props;
    const [isExpanded, setIsExpanded] = (0, $tZqWC.useState)(false);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b3f7dc6528742bb0$export$2e2bcd8739ae039), {
        setIsExpanded: setIsExpanded,
        expandPanel: isExpanded,
        button: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $0c23e0a7958ec8f2$export$fd2299f554be8993), {
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $0c23e0a7958ec8f2$export$9f515a68dfaeb9ef), {
                    isExpanded: false,
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $0c23e0a7958ec8f2$export$987cac99e7a31168), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $4557f77f1cb1ac6e$export$2e2bcd8739ae039), {
                                    size: 18
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $0c23e0a7958ec8f2$export$6f4a084cc8e379b6), {
                                    children: [
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $0c23e0a7958ec8f2$export$49316f37c3b5fade), {
                                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                width: "160"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $0c23e0a7958ec8f2$export$65b9fe47bb7b64b0), {
                                            children: [
                                                "Sent | ",
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                                    height: "10",
                                                    width: "90",
                                                    borderRadius: "3"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $0c23e0a7958ec8f2$export$987cac99e7a31168), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                width: "140"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $0c23e0a7958ec8f2$export$9f515a68dfaeb9ef), {
                    isExpanded: false,
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $0c23e0a7958ec8f2$export$987cac99e7a31168), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                    width: "70"
                                }),
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $badb5a82015e7095$export$2e2bcd8739ae039), {
                                    width: progress || '20%'
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $0c23e0a7958ec8f2$export$987cac99e7a31168), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $0c23e0a7958ec8f2$export$6f4a084cc8e379b6), {
                                children: [
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                        width: "60"
                                    }),
                                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                        width: "80",
                                        height: "10",
                                        borderRadius: "3",
                                        style: {
                                            marginTop: 2
                                        }
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        }),
        panel: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $95fa9eb1e8a1a9f2$export$2e2bcd8739ae039), {})
    });
}
// Default Props
$b19cde6aceae8b0d$var$DemoTravelRuleTableItem.defaultProps = {
    actions: {},
    progress: ''
};
// Proptypes Validation
$b19cde6aceae8b0d$var$DemoTravelRuleTableItem.propTypes = {
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        toggleUpgradeModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setInfoModalDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    progress: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
};
var $b19cde6aceae8b0d$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($b19cde6aceae8b0d$var$mapStateToProps, $b19cde6aceae8b0d$var$mapDispatchToProps)($b19cde6aceae8b0d$var$DemoTravelRuleTableItem);


var $858865e15ade3cb5$export$2e2bcd8739ae039 = (0, $b19cde6aceae8b0d$export$2e2bcd8739ae039);


// Map Redux Props
const $08f8dbf69d9820ba$var$mapStateToProps = (state)=>state;
const $08f8dbf69d9820ba$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $08f8dbf69d9820ba$var$DemoTravelRuleTable(props) {
    // Destructure
    const { actions: actions, filters: filters } = props;
    const { travelRuleFilters: travelRuleFilters } = filters;
    const { setTravelRuleFilters: setTravelRuleFilters, toggleUpgradeModal: toggleUpgradeModal } = actions;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $76d1193d285f22e0$export$603ae81ab9412b1f), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $d2b0b55dc8f66a40$export$2e2bcd8739ae039), {
            minWidth: 700,
            totalItems: 5,
            tableFilters: travelRuleFilters,
            setTableFilters: setTravelRuleFilters,
            filterComponents: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5f4dca5a2a3379f5$export$2e2bcd8739ae039), {}),
            headerOptions: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                        size: "small",
                        variant: "outlined",
                        startIcon: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6417d0fa9c066aa3$export$2e2bcd8739ae039), {
                            size: 18
                        }),
                        onClick: ()=>{
                            (0, $60e52eb6c2680325$export$7ca4b19155f576fa)(toggleUpgradeModal);
                        },
                        children: "Report"
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                        size: "small",
                        variant: "outlined",
                        startIcon: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6417d0fa9c066aa3$export$2e2bcd8739ae039), {
                            size: 18
                        }),
                        onClick: ()=>{
                            (0, $60e52eb6c2680325$export$7ca4b19155f576fa)(toggleUpgradeModal);
                        },
                        children: "Transfer"
                    })
                ]
            }),
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $858865e15ade3cb5$export$2e2bcd8739ae039), {
                    progress: "20%"
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $858865e15ade3cb5$export$2e2bcd8739ae039), {
                    progress: "20%"
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $858865e15ade3cb5$export$2e2bcd8739ae039), {
                    progress: "20%"
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $858865e15ade3cb5$export$2e2bcd8739ae039), {
                    progress: "20%"
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $858865e15ade3cb5$export$2e2bcd8739ae039), {
                    progress: "20%"
                })
            ]
        })
    });
}
// Default Props
$08f8dbf69d9820ba$var$DemoTravelRuleTable.defaultProps = {
    actions: {},
    ui: {},
    filters: {}
};
// Proptypes Validation
$08f8dbf69d9820ba$var$DemoTravelRuleTable.propTypes = {
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setAddressChains: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setTravelRuleFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsTransferDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        toggleTransferReportModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        toggleUpgradeModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setInfoModalDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        travelRuleFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object)
    }),
    address: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        addressChains: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({})
    })
};
var $08f8dbf69d9820ba$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($08f8dbf69d9820ba$var$mapStateToProps, $08f8dbf69d9820ba$var$mapDispatchToProps)($08f8dbf69d9820ba$var$DemoTravelRuleTable);


var $36d5296c6e8bf002$export$2e2bcd8739ae039 = (0, $08f8dbf69d9820ba$export$2e2bcd8739ae039);





/* eslint-disable react/prop-types */ 
parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");





const $1743d55e3c49b475$export$d052f996153b966 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  width: 100%;
`;
const $1743d55e3c49b475$export$fdd500c294eff378 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: relative;
  width: 100%;
  padding: 10px;
  margin-top: ${({ label: label })=>label ? '-5px;' : '20px;'};
  background: ${({ theme: theme })=>theme.colors.background};

  border-radius: ${({ open: open })=>open ? '10px 10px 0 0' : '10px'};
  transition: 0.3s;
  border: 1px solid ${({ theme: theme })=>`${theme.colors.backgroundLite}`};
  &:hover {
    border: 1px solid ${({ theme: theme })=>`${theme.colors.brand}40`};
  }
`;
const $1743d55e3c49b475$export$be58b4326e23250f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: absolute;
  z-index: 2;
  top: 12px;
  left: 10px;

  & svg {
    min-width: 20px;
    margin: 0 0 0 10px;
    & > path {
      stroke: ${({ theme: theme })=>theme.colors.primary};
    }
  }
`;
const $1743d55e3c49b475$export$c636d9aa34eb47a6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 10px;
  background: ${({ theme: theme })=>theme.colors.backgroundLite};
  margin: 0;
`;
const $1743d55e3c49b475$export$b8aa00b0e772c98a = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  margin: 10px 10px 10px 40px;
  padding: 10px 20px;
`;
const $1743d55e3c49b475$export$ca4b1fc43afa0212 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 2;

  display: flex;
  justify-content: space-between;
  align-items: center;

  // Themed Properties
  background: ${({ theme: theme })=>theme.colors.background};

  & button > svg > path {
    stroke: ${({ theme: theme })=>theme.colors.brand};
  }
  & button > svg > line {
    stroke: ${({ theme: theme })=>theme.colors.brand};
  }
`;
const $1743d55e3c49b475$export$2f96f6f204f87534 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  max-height: 35.5px;

  opacity: 1;
  transition: 0.3s;

  ${({ collapseFilter: collapseFilter })=>collapseFilter && 'opacity: 0; min-width: 0px; overflow: hidden; width: 0;'};
  & div {
    max-width: 260px;
  }
`;
const $1743d55e3c49b475$export$b04be29aa201d4f5 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).label`
  position: relative;
  z-index: 2;
  color: ${({ theme: theme })=>theme.colors.primary};
  font-size: 12px;
  padding: 0 7px;
  transform: translate(15px, 15px);

  background-color: ${({ theme: theme })=>theme.colors.background};
  border-radius: 5px;
`;
const $1743d55e3c49b475$export$55d7609a8f1eccd2 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).input`
  transition: 0.4s;

  position: relative;

  min-height: 35.5px;
  height: fit-content;
  width: 100%;

  padding: 0 12px 0 50px;

  font-size: 16px;
  font-weight: 400;
  box-shadow: none;
  outline: none;
  border: none;

  color: ${({ theme: theme })=>theme.colors.primary};
  border-radius: ${({ open: open })=>open ? '0 0 10px 10px' : '10px'};

  background-color: ${({ disabled: disabled, theme: theme })=>disabled ? 'transparent' : theme.colors.background};

  &:hover {
    box-shadow: none;
  }

  &::placeholder {
    color: ${({ theme: theme })=>theme.colors.primary};
  }
`;
const $1743d55e3c49b475$export$a6151309bfd46137 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  position: absolute;
  top: 100%;
  left: 0;
  display: flex;
  flex-direction: column;

  width: 100%;
  max-height: 300px;
  overflow-y: auto;

  font-size: 16px;
  border-radius: 10px;
  font-weight: 400;
  color: ${({ theme: theme })=>theme.colors.primary};

  background-color: ${({ theme: theme })=>theme.colors.background};
  user-select: none;
  z-index: 2;

  border-top: ${({ theme: theme })=>`1px solid ${theme.colors.backgroundLite}`};
  border-radius: 0 0 10px 10px;
  box-shadow: 0px 3px 7px rgba(0, 0, 0, 0.07);
`;
const $1743d55e3c49b475$export$ba141e9a22070242 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 10px 20px;
  gap: 10px;

  color: ${({ theme: theme })=>theme.colors.primary};

  cursor: pointer;
  transition: 0.4s;

  border-radius: 10px;
  border: 1px solid rgba(0, 0, 0, 0);

  margin: 0 10px 0 40px;

  &:first-child {
    margin: 10px 10px 0 40px;
  }
  &:last-child {
    margin: 0 10px 10px 40px;
  }
  &:only-child {
    margin: 10px 10px 10px 40px;
  }
  &:hover {
    background: ${({ theme: theme })=>theme.colors.backgroundLite};
  }
`;
const $1743d55e3c49b475$export$97a3b778b1052a22 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 16px;
  min-width: 40px;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const $1743d55e3c49b475$export$ea5e76b5dd06c221 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 12px;
  min-width: 40px;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  color: ${({ theme: theme })=>theme.colors.secondary};
`;


// Map Redux Props
const $e8b4b1a04656a704$var$mapStateToProps = (state)=>state;
const $e8b4b1a04656a704$var$mapDispatchToProps = (dispatch)=>(0, $2154a4c08d887b32$export$e324594224ef24da)(dispatch);
function $e8b4b1a04656a704$var$DemoDirectoryTableFilter(props) {
    // Destructure
    const { actions: actions } = props;
    // Store Actions
    const { toggleUpgradeModal: toggleUpgradeModal } = actions;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1743d55e3c49b475$export$d052f996153b966), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $1743d55e3c49b475$export$fdd500c294eff378), {
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1743d55e3c49b475$export$be58b4326e23250f), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b36636a5d09c33a7$export$2e2bcd8739ae039), {
                        size: 18
                    })
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1743d55e3c49b475$export$55d7609a8f1eccd2), {
                    value: "",
                    onChange: ()=>{},
                    placeholder: "Search ID or Name...",
                    onClick: ()=>{
                        (0, $60e52eb6c2680325$export$7ca4b19155f576fa)(toggleUpgradeModal);
                    },
                    type: "search",
                    autoComplete: "off"
                })
            ]
        })
    });
}
// Default Props
$e8b4b1a04656a704$var$DemoDirectoryTableFilter.defaultProps = {
    filters: {},
    actions: {}
};
// Proptypes Validation
$e8b4b1a04656a704$var$DemoDirectoryTableFilter.propTypes = {
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        accountDirectoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            sort: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            account_type_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
            status_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number
        })
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAccountDirectoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        toggleInfoModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setInfoModalDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $e8b4b1a04656a704$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($e8b4b1a04656a704$var$mapStateToProps, $e8b4b1a04656a704$var$mapDispatchToProps)($e8b4b1a04656a704$var$DemoDirectoryTableFilter);


var $e07ae8d0b40068c3$export$2e2bcd8739ae039 = (0, $e8b4b1a04656a704$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");





const $81f2d995ceb173cc$export$4267411171632d35 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $81f2d995ceb173cc$export$cbf11d5f692bc726 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
`;
const $81f2d995ceb173cc$export$97d84ed62ab03b3f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  margin: 0px 0px 0px 16px;

  font-weight: inherit;
  font-size: inherit;
`;






var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $9534210f9340b8b1$export$5f1af8db9871e1d6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  font-size: 13px;
  margin: 0;
  text-align: right;
`;
const $9534210f9340b8b1$export$b04be29aa201d4f5 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  font-size: 13px;
  margin: 0;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $9534210f9340b8b1$export$f99233281efd08a0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h3`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;

  font-size: 22px;
  font-weight: 700;
  margin-bottom: 2px;
  color: ${({ theme: theme })=>theme.colors.primary};

  max-width: 260px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;
const $9534210f9340b8b1$export$d5c56664638992a4 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h4`
  font-size: 10px;
  margin: 0;
  font-weight: 400;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $9534210f9340b8b1$export$987cac99e7a31168 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
`;
const $9534210f9340b8b1$export$6f4a084cc8e379b6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 15px;

  &:first-child {
    background-color: ${({ theme: theme })=>`${theme.colors.secondary}10`};
    border-bottom: 2px solid ${({ theme: theme })=>theme.colors.backgroundLite};
    border-radius: 10px 10px 0 0;
    gap: 5px;
    & button {
      visibility: ${({ pending: pending })=>!pending && 'hidden'};
      color: ${({ theme: theme })=>theme.colors.brand} !important;
      border-color: ${({ theme: theme })=>theme.colors.brand} !important;
    }
  }
  &:last-child {
    background-color: ${({ theme: theme })=>theme.colors.background};
    border-radius: 0 0 10px 10px;
  }

  &:last-child {
    border-top: 2px solid ${({ theme: theme })=>theme.colors.backgroundLite};
    & div > p {
      font-size: 13px;
      font-weight: 100;
      color: ${({ theme: theme })=>theme.colors.primary};
    }
  }
`;



function $dcf24eb1c607c4ae$var$DemoAccountsTableItem(props) {
    // Destructure
    const { account_type_id: account_type_id, ...rest } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $37202d75ee8521c4$export$2e2bcd8739ae039), {
        ...rest,
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9534210f9340b8b1$export$6f4a084cc8e379b6), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9534210f9340b8b1$export$f99233281efd08a0), {
                        children: [
                            "ID: ",
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                width: "120",
                                height: "24"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9534210f9340b8b1$export$d5c56664638992a4), {
                        children: account_type_id === 1 ? 'INDIVIDUAL ACCOUNT' : 'BUSINESS ACCOUNT'
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                        variant: "outlined",
                        disabled: true,
                        size: "tiny",
                        children: "PENDING TRANSFERS"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9534210f9340b8b1$export$6f4a084cc8e379b6), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9534210f9340b8b1$export$987cac99e7a31168), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9534210f9340b8b1$export$b04be29aa201d4f5), {
                                children: account_type_id === 1 ? 'Name: ' : 'Company Name: '
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)($dcf24eb1c607c4ae$var$LocalSkeletonText, {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9534210f9340b8b1$export$987cac99e7a31168), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9534210f9340b8b1$export$b04be29aa201d4f5), {
                                children: "Country of Domicile: "
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)($dcf24eb1c607c4ae$var$LocalSkeletonText, {})
                        ]
                    }),
                    account_type_id === 1 && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9534210f9340b8b1$export$987cac99e7a31168), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9534210f9340b8b1$export$b04be29aa201d4f5), {
                                children: [
                                    'Date of Birth: ',
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)($dcf24eb1c607c4ae$var$LocalSkeletonText, {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9534210f9340b8b1$export$987cac99e7a31168), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9534210f9340b8b1$export$b04be29aa201d4f5), {
                                children: [
                                    account_type_id === 1 ? 'Nationality: ' : 'Country of Incorporation: ',
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)($dcf24eb1c607c4ae$var$LocalSkeletonText, {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9534210f9340b8b1$export$6f4a084cc8e379b6), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9534210f9340b8b1$export$987cac99e7a31168), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9534210f9340b8b1$export$b04be29aa201d4f5), {
                                children: "Status: "
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)($dcf24eb1c607c4ae$var$LocalSkeletonText, {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9534210f9340b8b1$export$987cac99e7a31168), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9534210f9340b8b1$export$b04be29aa201d4f5), {
                                children: "Account Risk: "
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)($dcf24eb1c607c4ae$var$LocalSkeletonText, {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9534210f9340b8b1$export$987cac99e7a31168), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9534210f9340b8b1$export$b04be29aa201d4f5), {
                                children: "Open Alerts: "
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)($dcf24eb1c607c4ae$var$LocalSkeletonText, {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $9534210f9340b8b1$export$987cac99e7a31168), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9534210f9340b8b1$export$b04be29aa201d4f5), {
                                children: "Transfers: "
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)($dcf24eb1c607c4ae$var$LocalSkeletonText, {})
                        ]
                    })
                ]
            })
        ]
    });
}
// Default Props
$dcf24eb1c607c4ae$var$DemoAccountsTableItem.defaultProps = {};
// Proptypes Validation
$dcf24eb1c607c4ae$var$DemoAccountsTableItem.propTypes = {
    account_type_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number
};
var $dcf24eb1c607c4ae$export$2e2bcd8739ae039 = $dcf24eb1c607c4ae$var$DemoAccountsTableItem;
function $dcf24eb1c607c4ae$var$LocalSkeletonText() {
    const [num] = (0, $tZqWC.useState)(`${Math.floor(Math.random() * 80 + 30)}`);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
        width: num,
        height: "16",
        borderRadius: "4"
    });
}


var $f6fd23308ccc6d98$export$2e2bcd8739ae039 = (0, $dcf24eb1c607c4ae$export$2e2bcd8739ae039);


// Map Redux Props
const $6e05847b9dba07d2$var$mapStateToProps = (state)=>state;
const $6e05847b9dba07d2$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $6e05847b9dba07d2$var$DemoAccountsTable(props) {
    // Destructure
    const { filters: filters, actions: actions } = props;
    // Store States
    const { accountDirectoryFilters: accountDirectoryFilters } = filters;
    // Store Actions
    const { toggleUpgradeModal: toggleUpgradeModal } = actions;
    // Functions
    const notifyForPayment = ()=>{
        (0, $60e52eb6c2680325$export$7ca4b19155f576fa)(toggleUpgradeModal);
    };
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $81f2d995ceb173cc$export$4267411171632d35), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $7139282abdeb8ca4$export$2e2bcd8739ae039), {
            totalItems: 8,
            headerOptions: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ca6f920a36c82944$export$2e2bcd8739ae039), {
                direction: "down",
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $478ff5739380e08c$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                        size: "small",
                        variant: "outlined",
                        startIcon: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6417d0fa9c066aa3$export$2e2bcd8739ae039), {
                            size: 18
                        }),
                        onClick: notifyForPayment,
                        children: "Account"
                    })
                })
            }),
            minWidth: 900,
            filterComponents: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e07ae8d0b40068c3$export$2e2bcd8739ae039), {}),
            tableFilters: accountDirectoryFilters,
            setTableFilters: ()=>{},
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f6fd23308ccc6d98$export$2e2bcd8739ae039), {
                    account_type_id: 1,
                    onClick: notifyForPayment
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f6fd23308ccc6d98$export$2e2bcd8739ae039), {
                    account_type_id: 2,
                    onClick: notifyForPayment
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f6fd23308ccc6d98$export$2e2bcd8739ae039), {
                    account_type_id: 2,
                    onClick: notifyForPayment
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f6fd23308ccc6d98$export$2e2bcd8739ae039), {
                    account_type_id: 1,
                    onClick: notifyForPayment
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f6fd23308ccc6d98$export$2e2bcd8739ae039), {
                    account_type_id: 1,
                    onClick: notifyForPayment
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f6fd23308ccc6d98$export$2e2bcd8739ae039), {
                    account_type_id: 1,
                    onClick: notifyForPayment
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f6fd23308ccc6d98$export$2e2bcd8739ae039), {
                    account_type_id: 2,
                    onClick: notifyForPayment
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f6fd23308ccc6d98$export$2e2bcd8739ae039), {
                    account_type_id: 2,
                    onClick: notifyForPayment
                })
            ]
        }, 1)
    });
}
// Default Props
$6e05847b9dba07d2$var$DemoAccountsTable.defaultProps = {
    actions: {},
    filters: {},
    ui: {}
};
// Proptypes Validation
$6e05847b9dba07d2$var$DemoAccountsTable.propTypes = {
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        accountDirectoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object)
    }),
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setToBeUpdatedAccount: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAccountDirectoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsIndividualAccountDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsEntityAccountDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        toggleUpgradeModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setInfoModalDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $6e05847b9dba07d2$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($6e05847b9dba07d2$var$mapStateToProps, $6e05847b9dba07d2$var$mapDispatchToProps)($6e05847b9dba07d2$var$DemoAccountsTable);


var $79857ea5f912e1ce$export$2e2bcd8739ae039 = (0, $6e05847b9dba07d2$export$2e2bcd8739ae039);




parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");





const $cc0728b06599cfbf$export$4267411171632d35 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $cc0728b06599cfbf$export$cbf11d5f692bc726 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
`;
const $cc0728b06599cfbf$export$97d84ed62ab03b3f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  margin: 0px 0px 0px 16px;

  font-weight: inherit;
  font-size: inherit;
`;






var $tZqWC = parcelRequire("tZqWC");

const $c1882e2445b6d1e5$export$5f1af8db9871e1d6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  font-size: 13px;
  margin: 0;
  text-align: right;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $c1882e2445b6d1e5$export$b04be29aa201d4f5 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  font-size: 13px;
  margin: 0;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $c1882e2445b6d1e5$export$f99233281efd08a0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h3`
  margin: 0;
  font-size: 40px;
  font-weight: 700;
  padding-right: 15px;
  margin-right: 15px;
  border-right: 1px solid ${({ theme: theme })=>theme.colors.secondary};
  color: ${({ theme: theme })=>theme.colors.primary};
  text-transform: capitalize;
`;
const $c1882e2445b6d1e5$export$d5c56664638992a4 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).h4`
  font-size: 16px;
  margin: 0;
  color: ${({ theme: theme })=>theme.colors.primary};
  font-weight: 400;

  max-width: 260px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;
const $c1882e2445b6d1e5$export$987cac99e7a31168 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
`;
const $c1882e2445b6d1e5$export$2157c074a0891857 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  text-transform: uppercase;
`;
const $c1882e2445b6d1e5$export$6f4a084cc8e379b6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 20px;
  &:last-child {
    background-color: ${({ theme: theme })=>theme.colors.background};
    border-radius: 0 0 10px 10px;
  }
`;
const $c1882e2445b6d1e5$export$9f515a68dfaeb9ef = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  padding: 20px;
  background-color: ${({ theme: theme })=>`${theme.colors.secondary}10`};
  border-bottom: 2px solid ${({ theme: theme })=>theme.colors.backgroundLite};
  border-radius: 10px 10px 0 0;
`;
const $c1882e2445b6d1e5$export$15529022dcaf3eec = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: flex-end;
`;
const $c1882e2445b6d1e5$export$5a7f9a6004988d01 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).p`
  font-size: 13px;
  margin: 0 0 4px 0;
  width: fit-content;
  padding: 2px 28px;
  ${({ theme: theme, customer_status_id: customer_status_id })=>`
    ${customer_status_id === -1 && `
      color: ${theme.colors.red};
      background-color: transparent;
      border: 1px solid ${theme.colors.red};
      border-radius: 8px;
    `}
  `};
`;



function $63f955aa91fac431$var$DemoVaspsTableItem(props) {
    const { ...rest } = props;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $37202d75ee8521c4$export$2e2bcd8739ae039), {
        ...rest,
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $c1882e2445b6d1e5$export$9f515a68dfaeb9ef), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                        height: "40",
                        width: "70",
                        style: {
                            marginRight: '4px'
                        }
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $c1882e2445b6d1e5$export$2157c074a0891857), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)($63f955aa91fac431$var$LocalSkeletonText, {}),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)($63f955aa91fac431$var$LocalSkeletonText, {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $c1882e2445b6d1e5$export$6f4a084cc8e379b6), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $c1882e2445b6d1e5$export$987cac99e7a31168), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c1882e2445b6d1e5$export$b04be29aa201d4f5), {
                                children: "Vasp ID: "
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)($63f955aa91fac431$var$LocalSkeletonText, {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $c1882e2445b6d1e5$export$987cac99e7a31168), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c1882e2445b6d1e5$export$b04be29aa201d4f5), {
                                children: "Website: "
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)($63f955aa91fac431$var$LocalSkeletonText, {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $c1882e2445b6d1e5$export$987cac99e7a31168), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c1882e2445b6d1e5$export$b04be29aa201d4f5), {
                                children: "Email: "
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)($63f955aa91fac431$var$LocalSkeletonText, {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $c1882e2445b6d1e5$export$987cac99e7a31168), {
                        children: [
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c1882e2445b6d1e5$export$b04be29aa201d4f5), {
                                children: "Latest update: "
                            }),
                            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)($63f955aa91fac431$var$LocalSkeletonText, {})
                        ]
                    })
                ]
            })
        ]
    });
}
// Default Props
$63f955aa91fac431$var$DemoVaspsTableItem.defaultProps = {};
// Proptypes Validation
$63f955aa91fac431$var$DemoVaspsTableItem.propTypes = {};
var $63f955aa91fac431$export$2e2bcd8739ae039 = $63f955aa91fac431$var$DemoVaspsTableItem;
function $63f955aa91fac431$var$LocalSkeletonText() {
    const [num] = (0, $tZqWC.useState)(`${Math.floor(Math.random() * 120 + 30)}`);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
        width: num,
        height: "16",
        borderRadius: "4"
    });
}


var $b9d929f52e9bf40f$export$2e2bcd8739ae039 = (0, $63f955aa91fac431$export$2e2bcd8739ae039);


// Map Redux Props
const $0c5a01372eab8e14$var$mapStateToProps = (state)=>state;
const $0c5a01372eab8e14$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $0c5a01372eab8e14$var$DemoVaspsTable(props) {
    // Destructure
    const { filters: filters, actions: actions } = props;
    // Store States
    const { vaspDirectoryFilters: vaspDirectoryFilters } = filters;
    // Store Actions
    const { toggleUpgradeModal: toggleUpgradeModal } = actions;
    // Functions
    const notifyForPayment = ()=>{
        (0, $60e52eb6c2680325$export$7ca4b19155f576fa)(toggleUpgradeModal);
    };
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $cc0728b06599cfbf$export$4267411171632d35), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $7139282abdeb8ca4$export$2e2bcd8739ae039), {
            totalItems: 8,
            headerOptions: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                onClick: ()=>{
                    notifyForPayment();
                },
                size: "small",
                startIcon: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6417d0fa9c066aa3$export$2e2bcd8739ae039), {
                    size: 18
                }),
                variant: "outlined",
                children: "Request Vasp"
            }),
            minWidth: 900,
            filterComponents: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e07ae8d0b40068c3$export$2e2bcd8739ae039), {}),
            tableFilters: vaspDirectoryFilters,
            setTableFilters: ()=>{},
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b9d929f52e9bf40f$export$2e2bcd8739ae039), {
                    onClick: notifyForPayment
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b9d929f52e9bf40f$export$2e2bcd8739ae039), {
                    onClick: notifyForPayment
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b9d929f52e9bf40f$export$2e2bcd8739ae039), {
                    onClick: notifyForPayment
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b9d929f52e9bf40f$export$2e2bcd8739ae039), {
                    onClick: notifyForPayment
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b9d929f52e9bf40f$export$2e2bcd8739ae039), {
                    onClick: notifyForPayment
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b9d929f52e9bf40f$export$2e2bcd8739ae039), {
                    onClick: notifyForPayment
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b9d929f52e9bf40f$export$2e2bcd8739ae039), {
                    onClick: notifyForPayment
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b9d929f52e9bf40f$export$2e2bcd8739ae039), {
                    onClick: notifyForPayment
                })
            ]
        }, 1)
    });
}
// Default Props
$0c5a01372eab8e14$var$DemoVaspsTable.defaultProps = {
    actions: {},
    filters: {},
    ui: {}
};
// Proptypes Validation
$0c5a01372eab8e14$var$DemoVaspsTable.propTypes = {
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        vaspDirectoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object)
    }),
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setVaspDirectoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setToBeUpdatedVasp: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsVaspDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsEntityVaspDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        toggleUpgradeModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setInfoModalDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $0c5a01372eab8e14$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($0c5a01372eab8e14$var$mapStateToProps, $0c5a01372eab8e14$var$mapDispatchToProps)($0c5a01372eab8e14$var$DemoVaspsTable);


var $d8dcc9e5348e87c1$export$2e2bcd8739ae039 = (0, $0c5a01372eab8e14$export$2e2bcd8739ae039);




parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");




const $e38026dc2f15f42e$export$d052f996153b966 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  width: 100%;

  // If there is space then it's for the child
  // If there is no space then it's for the current component
  &#accountAddressTableFilter {
    & > div {
      padding: 0 !important;
      margin: 0 !important;
    }
  }
  & #travelruleDateFilter {
    justify-content: center;
    & > div {
      max-width: none !important;
    }
  }
  & #travelRuleSort {
    min-width: 245px;
    & .simpleSelectInputLabel {
      min-width: 165px;
    }
  }
  & #travelRuleAssetSort {
    & .simpleSelectInputLabel {
      min-width: 130px;
    }
  }
  & #addressDateFilter {
    & > div {
      max-width: none !important;
      padding: 0;
      height: 100%;
      gap: 10px;

      & p {
        font-size: 12px !important;
        margin: 0;
        display: flex;
        align-items: center;
        gap: 5px;
      }
    }
  }
  & #VASPSort {
    min-width: 200px;
    & .simpleSelectInputLabel {
      min-width: 120px;
    }
  }
`;
const $e38026dc2f15f42e$export$ca4b1fc43afa0212 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;



// Map Redux Props
const $67fcc4df87fe6ad6$var$mapStateToProps = (state)=>state;
const $67fcc4df87fe6ad6$var$mapDispatchToProps = (dispatch)=>(0, $2154a4c08d887b32$export$e324594224ef24da)(dispatch);
function $67fcc4df87fe6ad6$var$DemoReportsTableFilter(props) {
    // Destructure
    const { actions: actions } = props;
    // Store Actions
    const { toggleUpgradeModal: toggleUpgradeModal } = actions;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e38026dc2f15f42e$export$d052f996153b966), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $246a616d3a63a7c1$export$2e2bcd8739ae039), {
            onClick: ()=>(0, $60e52eb6c2680325$export$7ca4b19155f576fa)(toggleUpgradeModal),
            filter: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("div", {})
        })
    });
}
// Default Props
$67fcc4df87fe6ad6$var$DemoReportsTableFilter.defaultProps = {
    filters: {},
    actions: {}
};
// Proptypes Validation
$67fcc4df87fe6ad6$var$DemoReportsTableFilter.propTypes = {
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        reportsAddressFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            sort: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            account_type_id: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
            page_index: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).number,
            start_range: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string,
            end_range: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
        })
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setReportsAddressFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        toggleUpgradeModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setInfoModalDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $67fcc4df87fe6ad6$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($67fcc4df87fe6ad6$var$mapStateToProps, $67fcc4df87fe6ad6$var$mapDispatchToProps)($67fcc4df87fe6ad6$var$DemoReportsTableFilter);


var $d795a2a83308ae92$export$2e2bcd8739ae039 = (0, $67fcc4df87fe6ad6$export$2e2bcd8739ae039);


/* eslint-disable react/no-unstable-nested-components */ 
parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");




const $cd3f2d4b3042eac4$export$fd2299f554be8993 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: 1.8fr 1fr;
  gap: 50px;
  align-items: center;

  padding: 2px 10px;
  color: ${({ theme: theme })=>theme.colors.primary};
`;
const $cd3f2d4b3042eac4$export$9f515a68dfaeb9ef = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: grid;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  gap: 20px;

  &:last-child > div:last-child {
    max-width: 250px;
    justify-content: flex-end;
  }
  &:last-child > div:first-child {
    justify-content: flex-end;
    max-width: 550px;
  }
`;
const $cd3f2d4b3042eac4$export$987cac99e7a31168 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  width: 100%;

  gap: 20px;
`;
const $cd3f2d4b3042eac4$export$6f4a084cc8e379b6 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
`;
const $cd3f2d4b3042eac4$export$49316f37c3b5fade = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 15px;
  font-weight: 400;
  text-transform: capitalize;
  max-width: 250px;

  &:first-child {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
`;
const $cd3f2d4b3042eac4$export$b502300b413480 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).span`
  font-size: 8px;
  font-weight: 400;
`;
const $cd3f2d4b3042eac4$export$65b9fe47bb7b64b0 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  font-size: 10px;
  font-weight: 400;
`;
const $cd3f2d4b3042eac4$export$85524e8d4e82fc69 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $cd3f2d4b3042eac4$export$ccff7fe96c96c97 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 5px 30px;
  border-radius: 10px;
  width: 100%;
  text-align: center;
  ${({ theme: theme, status: status })=>status === 'Completed' && `color: ${theme.colors.brand}; border: 1px solid ${theme.colors.brand};`}
  ${({ theme: theme, status: status })=>status === 'Pending' && `color: ${theme.colors.yellowGreen}; border: 1px solid ${theme.colors.yellowGreen};`}
`;



// Map Redux Props
const $13aa0d6f9fbdc3fe$var$mapStateToProps = (state)=>state;
const $13aa0d6f9fbdc3fe$var$mapDispatchToProps = (dispatch)=>(0, $2154a4c08d887b32$export$e324594224ef24da)(dispatch);
function $13aa0d6f9fbdc3fe$var$DemoReportsTableItem(props) {
    // Destructure
    const { actions: actions, ...rest } = props;
    const { toggleUpgradeModal: toggleUpgradeModal } = actions;
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f32a2c939d2829ea$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $cd3f2d4b3042eac4$export$fd2299f554be8993), {
            ...rest,
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $cd3f2d4b3042eac4$export$9f515a68dfaeb9ef), {
                    style: {
                        gridTemplateColumns: '1fr 0.7fr 2fr'
                    },
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $cd3f2d4b3042eac4$export$987cac99e7a31168), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                width: "120"
                            })
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $cd3f2d4b3042eac4$export$987cac99e7a31168), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                width: "90"
                            })
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $cd3f2d4b3042eac4$export$987cac99e7a31168), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                width: "90"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $cd3f2d4b3042eac4$export$9f515a68dfaeb9ef), {
                    style: {
                        gridTemplateColumns: '150px 1fr'
                    },
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $cd3f2d4b3042eac4$export$987cac99e7a31168), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bc65e302a570aac6$export$2e2bcd8739ae039), {
                                width: "180"
                            })
                        }),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $cd3f2d4b3042eac4$export$987cac99e7a31168), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $431db40ca57b78c9$export$2e2bcd8739ae039), {
                                onClick: ()=>(0, $60e52eb6c2680325$export$7ca4b19155f576fa)(toggleUpgradeModal),
                                children: "Download"
                            })
                        })
                    ]
                })
            ]
        })
    });
}
// Default Props
$13aa0d6f9fbdc3fe$var$DemoReportsTableItem.defaultProps = {
    actions: {}
};
// Proptypes Validation
$13aa0d6f9fbdc3fe$var$DemoReportsTableItem.propTypes = {
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        toggleUpgradeModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setInfoModalDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $13aa0d6f9fbdc3fe$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($13aa0d6f9fbdc3fe$var$mapStateToProps, $13aa0d6f9fbdc3fe$var$mapDispatchToProps)($13aa0d6f9fbdc3fe$var$DemoReportsTableItem);


var $c870bbd9837a4ecc$export$2e2bcd8739ae039 = (0, $13aa0d6f9fbdc3fe$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");




const $1a7082995b93ec7f$export$4267411171632d35 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $1a7082995b93ec7f$export$cbf11d5f692bc726 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
`;
const $1a7082995b93ec7f$export$97d84ed62ab03b3f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  margin: 0px 0px 0px 16px;

  font-weight: inherit;
  font-size: inherit;
`;






// Map Redux Props
const $c35c776b1a2b3325$var$mapStateToProps = (state)=>state;
const $c35c776b1a2b3325$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $c35c776b1a2b3325$var$DemoReportsTable(props) {
    // Destructure
    const { filters: filters, actions: actions } = props;
    // Store States
    const { reportsAddressFilters: reportsAddressFilters } = filters;
    const { toggleUpgradeModal: toggleUpgradeModal } = actions;
    const notifyForPayment = ()=>{
        (0, $60e52eb6c2680325$export$7ca4b19155f576fa)(toggleUpgradeModal);
    };
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $1a7082995b93ec7f$export$4267411171632d35), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $06a400f584629957$export$2e2bcd8739ae039), {
            totalItems: 4,
            minWidth: 900,
            tableFilters: reportsAddressFilters,
            setTableFilters: ()=>{},
            children: [
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d795a2a83308ae92$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c2793ae25ec908bb$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c870bbd9837a4ecc$export$2e2bcd8739ae039), {
                    onClick: notifyForPayment
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c870bbd9837a4ecc$export$2e2bcd8739ae039), {
                    onClick: notifyForPayment
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c870bbd9837a4ecc$export$2e2bcd8739ae039), {
                    onClick: notifyForPayment
                }),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c870bbd9837a4ecc$export$2e2bcd8739ae039), {
                    onClick: notifyForPayment
                })
            ]
        })
    });
}
// Default Props
$c35c776b1a2b3325$var$DemoReportsTable.defaultProps = {
    actions: {},
    filters: {},
    ui: {}
};
// Proptypes Validation
$c35c776b1a2b3325$var$DemoReportsTable.propTypes = {
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        reportsAddressFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object)
    }),
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setToBeUpdatedAccount: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setAccountDirectoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsIndividualAccountDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsEntityAccountDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setReportsAddressFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        toggleUpgradeModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setInfoModalDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $c35c776b1a2b3325$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($c35c776b1a2b3325$var$mapStateToProps, $c35c776b1a2b3325$var$mapDispatchToProps)($c35c776b1a2b3325$var$DemoReportsTable);


var $bca6e691668cca93$export$2e2bcd8739ae039 = (0, $c35c776b1a2b3325$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");





const $e51be0e18a474eec$export$4267411171632d35 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div``;
const $e51be0e18a474eec$export$cbf11d5f692bc726 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  display: flex;
`;
const $e51be0e18a474eec$export$97d84ed62ab03b3f = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  margin: 0px 0px 0px 16px;

  font-weight: inherit;
  font-size: inherit;
`;





// Map Redux Props
const $176dffa9639def8e$var$mapStateToProps = (state)=>state;
const $176dffa9639def8e$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $176dffa9639def8e$var$MPVaspsTable(props) {
    // Destructure
    const { filters: filters, ui: ui, actions: actions } = props;
    // Store States
    const { vaspDirectoryFilters: vaspDirectoryFilters } = filters;
    const { isPageTableUpdated: isPageTableUpdated } = ui;
    // Store Actions
    const { setVaspDirectoryFilters: setVaspDirectoryFilters, setIsPageTableUpdated: setIsPageTableUpdated } = actions;
    // Variables
    const { sort: sort, page: page, size: size } = vaspDirectoryFilters;
    // States
    const [vaspsDataState, setVaspsDataState] = (0, $tZqWC.useState)({
        items: [],
        total: 0,
        page: 1
    });
    // Hooks
    const [userCredentials] = (0, $a9c50ebe96619b20$export$2e2bcd8739ae039)('userCredentials', false);
    const { allVaspsData: allVaspsData, getAllVasps: getAllVasps, isAllVaspsLoading: isAllVaspsLoading } = (0, $40506d7d94723792$export$2e2bcd8739ae039)();
    // Functions
    const fetchVasps = ()=>{
        getAllVasps({
            biz_id: userCredentials.Business_ID,
            sort: sort,
            page: page,
            size: size
        });
    };
    // UseEffects
    (0, $tZqWC.useEffect)(()=>{
        if (allVaspsData) setVaspsDataState(allVaspsData);
    }, [
        allVaspsData
    ]);
    (0, $tZqWC.useEffect)(()=>{
        if (vaspDirectoryFilters || isPageTableUpdated) {
            fetchVasps();
            setIsPageTableUpdated(false);
        }
    }, [
        vaspDirectoryFilters,
        isPageTableUpdated
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e51be0e18a474eec$export$4267411171632d35), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7139282abdeb8ca4$export$2e2bcd8739ae039), {
            totalItems: vaspsDataState.total,
            minWidth: 900,
            filterComponents: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d3cd0ff9e1046ed5$export$2e2bcd8739ae039), {}),
            tableFilters: vaspDirectoryFilters,
            setTableFilters: setVaspDirectoryFilters,
            children: vaspsDataState.items.length > 0 && !isAllVaspsLoading ? vaspsDataState.items.map((vaspDetails)=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $70ee8851925af7a1$export$2e2bcd8739ae039), {
                    vaspDetails: vaspDetails
                }, vaspDetails.id)) : /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                children: [
                    isAllVaspsLoading ? /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $647b8bc68ebce54f$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a6ea3b0f3caed586$export$2e2bcd8739ae039), {
                        setFilter: setVaspDirectoryFilters
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)("div", {})
                ]
            })
        }, vaspsDataState?.page)
    });
}
// Default Props
$176dffa9639def8e$var$MPVaspsTable.defaultProps = {
    actions: {},
    filters: {},
    ui: {}
};
// Proptypes Validation
$176dffa9639def8e$var$MPVaspsTable.propTypes = {
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        vaspDirectoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object)
    }),
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    }),
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setVaspDirectoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setToBeUpdatedVasp: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsVaspDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsEntityVaspDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        toggleUpgradeModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setInfoModalDetails: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $176dffa9639def8e$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($176dffa9639def8e$var$mapStateToProps, $176dffa9639def8e$var$mapDispatchToProps)($176dffa9639def8e$var$MPVaspsTable);


var $b3e0d1c13bd8182b$export$2e2bcd8739ae039 = (0, $176dffa9639def8e$export$2e2bcd8739ae039);





// Map Redux Props
const $d7cf07425e428506$var$mapStateToProps = (state)=>state;
const $d7cf07425e428506$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $d7cf07425e428506$var$BusinessDetails(props) {
    const { actions: actions } = props;
    // destructuring
    const { setIsUserDrawerOpen: setIsUserDrawerOpen, toggleCreateApiKeyModal: toggleCreateApiKeyModal } = actions;
    // State
    const [page, setPage] = (0, $tZqWC.useState)(0);
    const [usersLength, setUsersLength] = (0, $tZqWC.useState)(0);
    // hooks
    const history = (0, $a0d5c3f2fe524011$export$3420e1dc2c4a518c)();
    const [currentUser] = (0, $a9c50ebe96619b20$export$2e2bcd8739ae039)('userCredentials', {});
    (0, $tZqWC.useEffect)(()=>{
        if (currentUser?.role_id !== 1) history.push('/');
    }, []);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $7873b6261a2b1051$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $802ca450e3f2144f$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5387bf8dccf722e4$export$2e2bcd8739ae039), {
                pageTitle: "Business Details"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b27722fc7d4f5ccf$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $14870abc08ac0dc0$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d9a5995c1b70ae93$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $eb59b21762ea71e4$export$e6dfd72ab29f8598), {
                            children: [
                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $8598ac15cd4ceb60$export$2e2bcd8739ae039), {
                                    page: page,
                                    setPage: setPage
                                }),
                                page === 0 && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eb59b21762ea71e4$export$17b77c57254421ac), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $86a277d387878008$export$2e2bcd8739ae039), {})
                                }),
                                page === 1 && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $eb59b21762ea71e4$export$17b77c57254421ac), {
                                    children: [
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $eb59b21762ea71e4$export$bc7adc8ef74607f), {
                                            children: [
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $eb59b21762ea71e4$export$87ad169bde460ddf), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $eb59b21762ea71e4$export$f99233281efd08a0), {
                                                            children: [
                                                                "Created Users - (",
                                                                usersLength,
                                                                " / 5 Max Users)"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eb59b21762ea71e4$export$5f1af8db9871e1d6), {
                                                            children: "The list of users under the company. Managers can create users and update their email and roles."
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                                    onClick: ()=>{
                                                        setIsUserDrawerOpen(true);
                                                    },
                                                    children: "Create User"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $0f2f86ad44d6281a$export$2e2bcd8739ae039), {
                                            setUsersLength: setUsersLength
                                        })
                                    ]
                                }),
                                page === 2 && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $eb59b21762ea71e4$export$17b77c57254421ac), {
                                    children: [
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $eb59b21762ea71e4$export$bc7adc8ef74607f), {
                                            children: [
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $eb59b21762ea71e4$export$87ad169bde460ddf), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eb59b21762ea71e4$export$f99233281efd08a0), {
                                                            children: "API Keys"
                                                        }),
                                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $eb59b21762ea71e4$export$5f1af8db9871e1d6), {
                                                            children: "The list of active API Keys that can be used for Ospree Commercial API."
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f02f87ab33cad18$export$2e2bcd8739ae039), {
                                                    onClick: ()=>{
                                                        toggleCreateApiKeyModal();
                                                    },
                                                    children: "Create API Key"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $4eb647ade053420f$export$2e2bcd8739ae039), {})
                                    ]
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
}
// Default Props
$d7cf07425e428506$var$BusinessDetails.defaultProps = {
    actions: {}
};
// Proptypes Validation
$d7cf07425e428506$var$BusinessDetails.propTypes = {
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setIsUserDrawerOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        toggleCreateApiKeyModal: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    })
};
var $d7cf07425e428506$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($d7cf07425e428506$var$mapStateToProps, $d7cf07425e428506$var$mapDispatchToProps)($d7cf07425e428506$var$BusinessDetails);


var $5b007811787f07b1$export$2e2bcd8739ae039 = (0, $d7cf07425e428506$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");





const $b6487b95663b856a$export$4267411171632d35 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 5px 0px 0px 0px;
`;
const $b6487b95663b856a$export$9456d3a121d4b39 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  margin-bottom: -32px;
`;





// Map Redux Props
const $d8f4238cfbe56ddb$var$mapStateToProps = (state)=>state;
const $d8f4238cfbe56ddb$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $d8f4238cfbe56ddb$var$Accounts(props) {
    const { filters: filters, actions: actions } = props;
    const { accountDirectoryFilters: accountDirectoryFilters } = filters;
    const { setAccountDirectoryFilters: setAccountDirectoryFilters } = actions;
    const [csi] = (0, $tZqWC.useState)((0, $60e52eb6c2680325$export$96c4cef8dff1bd45)());
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $7873b6261a2b1051$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $802ca450e3f2144f$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5387bf8dccf722e4$export$2e2bcd8739ae039), {
                pageTitle: "Directory",
                subHeader: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $61ee040a7ed48adf$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b27722fc7d4f5ccf$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $14870abc08ac0dc0$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d9a5995c1b70ae93$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $b6487b95663b856a$export$4267411171632d35), {
                            children: [
                                csi === 1 && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b6487b95663b856a$export$9456d3a121d4b39), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9943dd893d8bba32$export$2e2bcd8739ae039), {
                                        pages: (0, $f398806f8c37b1c3$export$e7143bbefb1abdd7),
                                        page: accountDirectoryFilters?.account_category,
                                        setPage: (v)=>{
                                            setAccountDirectoryFilters({
                                                ...accountDirectoryFilters,
                                                account_category: v
                                            });
                                        }
                                    })
                                }),
                                (csi === 1 || csi === 2) && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $75c7e53cbfc5e98f$export$2e2bcd8739ae039), {}),
                                csi !== 1 && csi !== 2 && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $79857ea5f912e1ce$export$2e2bcd8739ae039), {})
                            ]
                        })
                    })
                })
            })
        ]
    });
}
// Default Props
$d8f4238cfbe56ddb$var$Accounts.defaultProps = {
    actions: {},
    ui: {},
    filters: {}
};
// Proptypes Validation
$d8f4238cfbe56ddb$var$Accounts.propTypes = {
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setAccountDirectoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({}),
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        accountDirectoryFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
            account_category: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).string
        })
    })
};
var $d8f4238cfbe56ddb$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($d8f4238cfbe56ddb$var$mapStateToProps, $d8f4238cfbe56ddb$var$mapDispatchToProps)($d8f4238cfbe56ddb$var$Accounts);


var $dec7029ca7cf4e45$export$2e2bcd8739ae039 = (0, $d8f4238cfbe56ddb$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");



const $5c8df35cbf9d21ed$export$4267411171632d35 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div` 
  padding: 5px 0px 0px 0px;
`;
const $5c8df35cbf9d21ed$export$9456d3a121d4b39 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  margin-bottom: -32px;
`;






// Map Redux Props
const $d8a73c2da9d763e7$var$mapStateToProps = (state)=>state;
const $d8a73c2da9d763e7$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
const $d8a73c2da9d763e7$var$pages = [
    {
        label: 'VASPs',
        value: 'vasps'
    },
    {
        label: 'Requested VASPs',
        value: 'requested-vasps'
    }
];
function $d8a73c2da9d763e7$var$Vasps() {
    const [csi] = (0, $tZqWC.useState)((0, $60e52eb6c2680325$export$96c4cef8dff1bd45)());
    const [page, setPage] = (0, $tZqWC.useState)($d8a73c2da9d763e7$var$pages[0]?.value);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $7873b6261a2b1051$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $802ca450e3f2144f$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5387bf8dccf722e4$export$2e2bcd8739ae039), {
                pageTitle: "Directory",
                subHeader: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $61ee040a7ed48adf$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b27722fc7d4f5ccf$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $14870abc08ac0dc0$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d9a5995c1b70ae93$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $5c8df35cbf9d21ed$export$4267411171632d35), {
                            children: [
                                csi === 1 && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5c8df35cbf9d21ed$export$9456d3a121d4b39), {
                                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9943dd893d8bba32$export$2e2bcd8739ae039), {
                                        pages: $d8a73c2da9d763e7$var$pages,
                                        page: page,
                                        setPage: setPage
                                    })
                                }),
                                page === 'vasps' && csi === 1 && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f90c01f719bc4742$export$2e2bcd8739ae039), {}),
                                page === 'vasps' && csi === 2 && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b3e0d1c13bd8182b$export$2e2bcd8739ae039), {}),
                                page === 'requested-vasps' && csi === 1 && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $135d46179e8e3c5a$export$2e2bcd8739ae039), {}),
                                csi !== 1 && csi !== 2 && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d8dcc9e5348e87c1$export$2e2bcd8739ae039), {})
                            ]
                        })
                    })
                })
            })
        ]
    });
}
// Default Props
$d8a73c2da9d763e7$var$Vasps.defaultProps = {
    actions: {},
    ui: {},
    filters: {}
};
// Proptypes Validation
$d8a73c2da9d763e7$var$Vasps.propTypes = {
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setActiveModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({}),
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({})
};
var $d8a73c2da9d763e7$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($d8a73c2da9d763e7$var$mapStateToProps, $d8a73c2da9d763e7$var$mapDispatchToProps)($d8a73c2da9d763e7$var$Vasps);


var $f1d905f698e7d497$export$2e2bcd8739ae039 = (0, $d8a73c2da9d763e7$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");



const $2a8efe816c2d4a8e$export$e6dfd72ab29f8598 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 5px 0 0 0;
`;





// Map Redux Props
const $1757fd3c19617a9a$var$mapStateToProps = (state)=>state;
const $1757fd3c19617a9a$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $1757fd3c19617a9a$var$AccountDetails() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $7873b6261a2b1051$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $802ca450e3f2144f$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5387bf8dccf722e4$export$2e2bcd8739ae039), {
                link: "/directory",
                pageTitle: "Accounts"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b27722fc7d4f5ccf$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $14870abc08ac0dc0$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d9a5995c1b70ae93$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2a8efe816c2d4a8e$export$e6dfd72ab29f8598), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $62a694e1d6159301$export$2e2bcd8739ae039), {})
                        })
                    })
                })
            })
        ]
    });
}
// Default Props
$1757fd3c19617a9a$var$AccountDetails.defaultProps = {
    actions: {},
    ui: {},
    filters: {}
};
// Proptypes Validation
$1757fd3c19617a9a$var$AccountDetails.propTypes = {
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setActiveModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({}),
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({})
};
var $1757fd3c19617a9a$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($1757fd3c19617a9a$var$mapStateToProps, $1757fd3c19617a9a$var$mapDispatchToProps)($1757fd3c19617a9a$var$AccountDetails);


var $cd63a69df41baa1a$export$2e2bcd8739ae039 = (0, $1757fd3c19617a9a$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");



const $b90938a59f3828dd$export$e6dfd72ab29f8598 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 5px 0 0 0;
`;





// Map Redux Props
const $022a95906210b431$var$mapStateToProps = (state)=>state;
const $022a95906210b431$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $022a95906210b431$var$VaspDetails() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $7873b6261a2b1051$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $802ca450e3f2144f$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5387bf8dccf722e4$export$2e2bcd8739ae039), {
                link: "/directory/vasps",
                pageTitle: "Vasps"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b27722fc7d4f5ccf$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $14870abc08ac0dc0$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d9a5995c1b70ae93$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b90938a59f3828dd$export$e6dfd72ab29f8598), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $947a021aba7686cf$export$2e2bcd8739ae039), {})
                        })
                    })
                })
            })
        ]
    });
}
// Default Props
$022a95906210b431$var$VaspDetails.defaultProps = {
    actions: {},
    ui: {},
    filters: {}
};
// Proptypes Validation
$022a95906210b431$var$VaspDetails.propTypes = {
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setActiveModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({}),
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({})
};
var $022a95906210b431$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($022a95906210b431$var$mapStateToProps, $022a95906210b431$var$mapDispatchToProps)($022a95906210b431$var$VaspDetails);


var $c6694e113f94721a$export$2e2bcd8739ae039 = (0, $022a95906210b431$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");






// Map Redux Props
const $cd378cc2c3d8f18d$var$mapStateToProps = ({ filters: filters, ui: ui })=>({
        filters: filters,
        ui: ui
    });
const $cd378cc2c3d8f18d$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $cd378cc2c3d8f18d$var$Address() {
    const [csi] = (0, $tZqWC.useState)((0, $60e52eb6c2680325$export$96c4cef8dff1bd45)());
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $7873b6261a2b1051$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $802ca450e3f2144f$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5387bf8dccf722e4$export$2e2bcd8739ae039), {
                subHeader: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d556ea73ca4389e2$export$2e2bcd8739ae039), {}),
                pageTitle: "Blockchain Analytics"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b27722fc7d4f5ccf$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $14870abc08ac0dc0$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $d9a5995c1b70ae93$export$2e2bcd8739ae039), {
                        children: [
                            (csi === 1 || csi === 2) && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9f7e8f2f16ba1f2b$export$2e2bcd8739ae039), {}),
                            csi !== 1 && csi !== 2 && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c1c00c24ff287506$export$2e2bcd8739ae039), {}),
                            csi !== 1 && csi !== 2 && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $46200402b6ebf2ff$export$2e2bcd8739ae039), {})
                        ]
                    })
                })
            })
        ]
    });
}
// Default Props
$cd378cc2c3d8f18d$var$Address.defaultProps = {
    actions: {},
    filters: {},
    ui: {}
};
// Proptypes Validation
$cd378cc2c3d8f18d$var$Address.propTypes = {
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        AddressFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object)
    }),
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    })
};
var $cd378cc2c3d8f18d$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($cd378cc2c3d8f18d$var$mapStateToProps, $cd378cc2c3d8f18d$var$mapDispatchToProps)($cd378cc2c3d8f18d$var$Address);


var $248e687a94a8051f$export$2e2bcd8739ae039 = (0, $cd378cc2c3d8f18d$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");






// Map Redux Props
const $93b06a7afb5243a9$var$mapStateToProps = ({ filters: filters, ui: ui })=>({
        filters: filters,
        ui: ui
    });
const $93b06a7afb5243a9$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $93b06a7afb5243a9$var$Transactions() {
    const [csi] = (0, $tZqWC.useState)((0, $60e52eb6c2680325$export$96c4cef8dff1bd45)());
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $7873b6261a2b1051$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $802ca450e3f2144f$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5387bf8dccf722e4$export$2e2bcd8739ae039), {
                subHeader: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d556ea73ca4389e2$export$2e2bcd8739ae039), {}),
                pageTitle: "Blockchain Analytics"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bb6cb7de1cdd9d3b$export$2e2bcd8739ae039), {})
        ]
    });
}
// Default Props
$93b06a7afb5243a9$var$Transactions.defaultProps = {
    actions: {},
    filters: {},
    ui: {}
};
// Proptypes Validation
$93b06a7afb5243a9$var$Transactions.propTypes = {
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        whitelistingFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object)
    }),
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    })
};
var $93b06a7afb5243a9$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($93b06a7afb5243a9$var$mapStateToProps, $93b06a7afb5243a9$var$mapDispatchToProps)($93b06a7afb5243a9$var$Transactions);


var $4c9e10184dbc51d2$export$2e2bcd8739ae039 = (0, $93b06a7afb5243a9$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

const $40397b885b9aa683$export$4267411171632d35 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 10px 0px 0px 0px;
`;






function $05b32bccc16f5217$var$TravelRule() {
    const [csi] = (0, $tZqWC.useState)((0, $60e52eb6c2680325$export$96c4cef8dff1bd45)());
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $7873b6261a2b1051$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $802ca450e3f2144f$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5387bf8dccf722e4$export$2e2bcd8739ae039), {
                pageTitle: "Travel Rule"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b27722fc7d4f5ccf$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $14870abc08ac0dc0$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d9a5995c1b70ae93$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $40397b885b9aa683$export$4267411171632d35), {
                            children: [
                                (csi === 1 || csi === 2) && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bdd1dc21fad1c965$export$2e2bcd8739ae039), {}),
                                csi !== 1 && csi !== 2 && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $36d5296c6e8bf002$export$2e2bcd8739ae039), {})
                            ]
                        })
                    })
                })
            })
        ]
    });
}
// Default Props
$05b32bccc16f5217$var$TravelRule.defaultProps = {
    actions: {},
    filters: {},
    ui: {}
};
// Proptypes Validation
$05b32bccc16f5217$var$TravelRule.propTypes = {
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        whitelistingFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object)
    }),
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    })
};
var $05b32bccc16f5217$export$2e2bcd8739ae039 = $05b32bccc16f5217$var$TravelRule;


var $1df9c2ae6e58bb6b$export$2e2bcd8739ae039 = (0, $05b32bccc16f5217$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");



function $7dfaf335a06f6409$var$AICatalyst() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $7873b6261a2b1051$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $802ca450e3f2144f$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5387bf8dccf722e4$export$2e2bcd8739ae039), {
                subHeader: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $30b91c47bbb7ea48$export$2e2bcd8739ae039), {}),
                pageTitle: "AI Catalyst"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b27722fc7d4f5ccf$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $14870abc08ac0dc0$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d9a5995c1b70ae93$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3f7d9681e9ab863$export$2e2bcd8739ae039), {})
                    })
                })
            })
        ]
    });
}
// Default Props
$7dfaf335a06f6409$var$AICatalyst.defaultProps = {
    actions: {},
    filters: {},
    ui: {}
};
// Proptypes Validation
$7dfaf335a06f6409$var$AICatalyst.propTypes = {
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        whitelistingFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object)
    }),
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    })
};
var $7dfaf335a06f6409$export$2e2bcd8739ae039 = $7dfaf335a06f6409$var$AICatalyst;


var $906bc5b580eb2d41$export$2e2bcd8739ae039 = (0, $7dfaf335a06f6409$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");



function $d7cf952b3ce025c6$var$OappDocsChat() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $7873b6261a2b1051$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $802ca450e3f2144f$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5387bf8dccf722e4$export$2e2bcd8739ae039), {
                subHeader: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $30b91c47bbb7ea48$export$2e2bcd8739ae039), {}),
                pageTitle: "AI Catalyst"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b27722fc7d4f5ccf$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $14870abc08ac0dc0$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d9a5995c1b70ae93$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3f7d9681e9ab863$export$2e2bcd8739ae039), {
                            model: "oapp_docs_chat"
                        })
                    })
                })
            })
        ]
    });
}
// Default Props
$d7cf952b3ce025c6$var$OappDocsChat.defaultProps = {
    actions: {},
    filters: {},
    ui: {}
};
// Proptypes Validation
$d7cf952b3ce025c6$var$OappDocsChat.propTypes = {
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        whitelistingFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object)
    }),
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    })
};
var $d7cf952b3ce025c6$export$2e2bcd8739ae039 = $d7cf952b3ce025c6$var$OappDocsChat;


var $f82d033a41293591$export$2e2bcd8739ae039 = (0, $d7cf952b3ce025c6$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");



function $0b9b8d01fffac5ef$var$RegulatoryChat() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $7873b6261a2b1051$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $802ca450e3f2144f$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5387bf8dccf722e4$export$2e2bcd8739ae039), {
                subHeader: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $30b91c47bbb7ea48$export$2e2bcd8739ae039), {}),
                pageTitle: "AI Catalyst"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b27722fc7d4f5ccf$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $14870abc08ac0dc0$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d9a5995c1b70ae93$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a3f7d9681e9ab863$export$2e2bcd8739ae039), {
                            model: "regulatory_chat"
                        })
                    })
                })
            })
        ]
    });
}
// Default Props
$0b9b8d01fffac5ef$var$RegulatoryChat.defaultProps = {
    actions: {},
    filters: {},
    ui: {}
};
// Proptypes Validation
$0b9b8d01fffac5ef$var$RegulatoryChat.propTypes = {
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        whitelistingFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object)
    }),
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    })
};
var $0b9b8d01fffac5ef$export$2e2bcd8739ae039 = $0b9b8d01fffac5ef$var$RegulatoryChat;


var $85cda75e0665bb77$export$2e2bcd8739ae039 = (0, $0b9b8d01fffac5ef$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");



const $7dee857d1043827c$export$4267411171632d35 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 50px 0px 0px 0px;
`;






// Map Redux Props
const $cf9b3c5058d03eb7$var$mapStateToProps = (state)=>state;
const $cf9b3c5058d03eb7$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
// !THIS PAGE IS NOT CURRENTLY SECURE
// !ADD RESTRICTIONS TO ROUTING IN THE CORE ROUTING
function $cf9b3c5058d03eb7$var$AdminVasps() {
    const [userCredentials] = (0, $a9c50ebe96619b20$export$2e2bcd8739ae039)('userCredentials', {});
    (0, $tZqWC.useEffect)(()=>{
        if (userCredentials?.role_id !== 0 || !userCredentials) window.location.replace(window.location.origin);
    }, [
        userCredentials
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $7873b6261a2b1051$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $802ca450e3f2144f$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5387bf8dccf722e4$export$2e2bcd8739ae039), {
                pageTitle: "Vasp Notification",
                subHeader: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $55f63aca8e1944fc$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $14870abc08ac0dc0$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d9a5995c1b70ae93$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7dee857d1043827c$export$4267411171632d35), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $56c27cbcc0484062$export$2e2bcd8739ae039), {})
                    })
                })
            })
        ]
    });
}
// Default Props
$cf9b3c5058d03eb7$var$AdminVasps.defaultProps = {
    actions: {},
    ui: {},
    filters: {}
};
// Proptypes Validation
$cf9b3c5058d03eb7$var$AdminVasps.propTypes = {
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setActiveModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({}),
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({})
};
var $cf9b3c5058d03eb7$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($cf9b3c5058d03eb7$var$mapStateToProps, $cf9b3c5058d03eb7$var$mapDispatchToProps)($cf9b3c5058d03eb7$var$AdminVasps);


var $bb23b22f85a7155f$export$2e2bcd8739ae039 = (0, $cf9b3c5058d03eb7$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");



const $32bed7a24c93bc56$export$e6dfd72ab29f8598 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 5px 0 0 0;
`;





// Map Redux Props
const $ce7e35e1ab7aa701$var$mapStateToProps = (state)=>state;
const $ce7e35e1ab7aa701$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $ce7e35e1ab7aa701$var$AdminVaspDetails() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $7873b6261a2b1051$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $802ca450e3f2144f$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5387bf8dccf722e4$export$2e2bcd8739ae039), {
                link: "/admin/vasps",
                pageTitle: "Vasps"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b27722fc7d4f5ccf$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $14870abc08ac0dc0$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d9a5995c1b70ae93$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $32bed7a24c93bc56$export$e6dfd72ab29f8598), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $036da670f35f4334$export$2e2bcd8739ae039), {})
                        })
                    })
                })
            })
        ]
    });
}
// Default Props
$ce7e35e1ab7aa701$var$AdminVaspDetails.defaultProps = {
    actions: {},
    ui: {},
    filters: {}
};
// Proptypes Validation
$ce7e35e1ab7aa701$var$AdminVaspDetails.propTypes = {
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setActiveModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({}),
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({})
};
var $ce7e35e1ab7aa701$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($ce7e35e1ab7aa701$var$mapStateToProps, $ce7e35e1ab7aa701$var$mapDispatchToProps)($ce7e35e1ab7aa701$var$AdminVaspDetails);


var $8b1a1b6f86e16016$export$2e2bcd8739ae039 = (0, $ce7e35e1ab7aa701$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");



const $366fff2e16b9a204$export$4267411171632d35 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 50px 0px 0px 0px;
`;






// Map Redux Props
const $77297d5840fe82e8$var$mapStateToProps = (state)=>state;
const $77297d5840fe82e8$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
// !THIS PAGE IS NOT CURRENTLY SECURE
// !ADD RESTRICTIONS TO ROUTING IN THE CORE ROUTING
function $77297d5840fe82e8$var$AdminRequestedVasps() {
    const [userCredentials] = (0, $a9c50ebe96619b20$export$2e2bcd8739ae039)('userCredentials', {});
    (0, $tZqWC.useEffect)(()=>{
        if (userCredentials?.role_id !== 0 || !userCredentials) window.location.replace(window.location.origin);
    }, [
        userCredentials
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $7873b6261a2b1051$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $802ca450e3f2144f$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5387bf8dccf722e4$export$2e2bcd8739ae039), {
                pageTitle: "Vasp Notification",
                subHeader: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $55f63aca8e1944fc$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $14870abc08ac0dc0$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d9a5995c1b70ae93$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $366fff2e16b9a204$export$4267411171632d35), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $39c621e1ae69d168$export$2e2bcd8739ae039), {})
                    })
                })
            })
        ]
    });
}
// Default Props
$77297d5840fe82e8$var$AdminRequestedVasps.defaultProps = {
    actions: {},
    ui: {},
    filters: {}
};
// Proptypes Validation
$77297d5840fe82e8$var$AdminRequestedVasps.propTypes = {
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setActiveModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({}),
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({})
};
var $77297d5840fe82e8$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($77297d5840fe82e8$var$mapStateToProps, $77297d5840fe82e8$var$mapDispatchToProps)($77297d5840fe82e8$var$AdminRequestedVasps);


var $75b91024556c8e1d$export$2e2bcd8739ae039 = (0, $77297d5840fe82e8$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");



const $ecbf5a3d276a3455$export$4267411171632d35 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 50px 0px 0px 0px;
`;






// Map Redux Props
const $ee5d81aeae6011fd$var$mapStateToProps = (state)=>state;
const $ee5d81aeae6011fd$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
// !THIS PAGE IS NOT CURRENTLY SECURE
// !ADD RESTRICTIONS TO ROUTING IN THE CORE ROUTING
function $ee5d81aeae6011fd$var$AdminCustomerVasps() {
    const [userCredentials] = (0, $a9c50ebe96619b20$export$2e2bcd8739ae039)('userCredentials', {});
    (0, $tZqWC.useEffect)(()=>{
        if (userCredentials?.role_id !== 0 || !userCredentials) window.location.replace(window.location.origin);
    }, [
        userCredentials
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $7873b6261a2b1051$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $802ca450e3f2144f$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5387bf8dccf722e4$export$2e2bcd8739ae039), {
                pageTitle: "Vasp Notification",
                subHeader: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $55f63aca8e1944fc$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $14870abc08ac0dc0$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d9a5995c1b70ae93$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ecbf5a3d276a3455$export$4267411171632d35), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ce8438c9ffc053f6$export$2e2bcd8739ae039), {})
                    })
                })
            })
        ]
    });
}
// Default Props
$ee5d81aeae6011fd$var$AdminCustomerVasps.defaultProps = {
    actions: {},
    ui: {},
    filters: {}
};
// Proptypes Validation
$ee5d81aeae6011fd$var$AdminCustomerVasps.propTypes = {
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setActiveModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({}),
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({})
};
var $ee5d81aeae6011fd$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($ee5d81aeae6011fd$var$mapStateToProps, $ee5d81aeae6011fd$var$mapDispatchToProps)($ee5d81aeae6011fd$var$AdminCustomerVasps);


var $2b2b6be12b0648f6$export$2e2bcd8739ae039 = (0, $ee5d81aeae6011fd$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");



const $c03cce81a661df73$export$4267411171632d35 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 50px 0px 0px 0px;
`;






// Map Redux Props
const $aeb86da58dcee5c1$var$mapStateToProps = (state)=>state;
const $aeb86da58dcee5c1$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
// !THIS PAGE IS NOT CURRENTLY SECURE
// !ADD RESTRICTIONS TO ROUTING IN THE CORE ROUTING
function $aeb86da58dcee5c1$var$AdminMidProspectVasps() {
    const [userCredentials] = (0, $a9c50ebe96619b20$export$2e2bcd8739ae039)('userCredentials', {});
    (0, $tZqWC.useEffect)(()=>{
        if (userCredentials?.role_id !== 0 || !userCredentials) window.location.replace(window.location.origin);
    }, [
        userCredentials
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $7873b6261a2b1051$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $802ca450e3f2144f$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5387bf8dccf722e4$export$2e2bcd8739ae039), {
                pageTitle: "Vasp Notification",
                subHeader: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $55f63aca8e1944fc$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $14870abc08ac0dc0$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d9a5995c1b70ae93$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c03cce81a661df73$export$4267411171632d35), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $69078ec0630cc6d2$export$2e2bcd8739ae039), {})
                    })
                })
            })
        ]
    });
}
// Default Props
$aeb86da58dcee5c1$var$AdminMidProspectVasps.defaultProps = {
    actions: {},
    ui: {},
    filters: {}
};
// Proptypes Validation
$aeb86da58dcee5c1$var$AdminMidProspectVasps.propTypes = {
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setActiveModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({}),
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({})
};
var $aeb86da58dcee5c1$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($aeb86da58dcee5c1$var$mapStateToProps, $aeb86da58dcee5c1$var$mapDispatchToProps)($aeb86da58dcee5c1$var$AdminMidProspectVasps);


var $c255f0c2ee3a2036$export$2e2bcd8739ae039 = (0, $aeb86da58dcee5c1$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");



const $59736b1b76e1d90a$export$4267411171632d35 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 50px 0px 0px 0px;
`;






// Map Redux Props
const $9b84a05cf1691ba5$var$mapStateToProps = (state)=>state;
const $9b84a05cf1691ba5$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
// !THIS PAGE IS NOT CURRENTLY SECURE
// !ADD RESTRICTIONS TO ROUTING IN THE CORE ROUTING
function $9b84a05cf1691ba5$var$AiDocument() {
    const [userCredentials] = (0, $a9c50ebe96619b20$export$2e2bcd8739ae039)('userCredentials', {});
    (0, $tZqWC.useEffect)(()=>{
        if (userCredentials?.role_id !== 0 || !userCredentials) window.location.replace(window.location.origin);
    }, [
        userCredentials
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $7873b6261a2b1051$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $802ca450e3f2144f$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5387bf8dccf722e4$export$2e2bcd8739ae039), {
                pageTitle: "AI Documents"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b27722fc7d4f5ccf$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $14870abc08ac0dc0$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d9a5995c1b70ae93$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $59736b1b76e1d90a$export$4267411171632d35), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $604230100f422599$export$2e2bcd8739ae039), {})
                        })
                    })
                })
            })
        ]
    });
}
// Default Props
$9b84a05cf1691ba5$var$AiDocument.defaultProps = {
    actions: {},
    ui: {},
    filters: {}
};
// Proptypes Validation
$9b84a05cf1691ba5$var$AiDocument.propTypes = {
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setActiveModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({}),
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({})
};
var $9b84a05cf1691ba5$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($9b84a05cf1691ba5$var$mapStateToProps, $9b84a05cf1691ba5$var$mapDispatchToProps)($9b84a05cf1691ba5$var$AiDocument);


var $4d97a00b11e9bb90$export$2e2bcd8739ae039 = (0, $9b84a05cf1691ba5$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");



const $a8a33946474a885a$export$4267411171632d35 = (0, $a778141486c79bc3$export$2e2bcd8739ae039).div`
  padding: 50px 0px 0px 0px;
`;






// Map Redux Props
const $cb7f6e5e29fc6f53$var$mapStateToProps = (state)=>state;
const $cb7f6e5e29fc6f53$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
// !THIS PAGE IS NOT CURRENTLY SECURE
// !ADD RESTRICTIONS TO ROUTING IN THE CORE ROUTING
function $cb7f6e5e29fc6f53$var$AiDocumentDetails() {
    const [userCredentials] = (0, $a9c50ebe96619b20$export$2e2bcd8739ae039)('userCredentials', {});
    (0, $tZqWC.useEffect)(()=>{
        if (userCredentials?.role_id !== 0 || !userCredentials) window.location.replace(window.location.origin);
    }, [
        userCredentials
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $7873b6261a2b1051$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $802ca450e3f2144f$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5387bf8dccf722e4$export$2e2bcd8739ae039), {
                link: "/admin/ai/documents",
                pageTitle: "AI Document Details"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b27722fc7d4f5ccf$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $14870abc08ac0dc0$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d9a5995c1b70ae93$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a8a33946474a885a$export$4267411171632d35), {
                            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $62669a44b4e7d09f$export$2e2bcd8739ae039), {})
                        })
                    })
                })
            })
        ]
    });
}
// Default Props
$cb7f6e5e29fc6f53$var$AiDocumentDetails.defaultProps = {
    actions: {},
    ui: {},
    filters: {}
};
// Proptypes Validation
$cb7f6e5e29fc6f53$var$AiDocumentDetails.propTypes = {
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setActiveModule: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({}),
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({})
};
var $cb7f6e5e29fc6f53$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($cb7f6e5e29fc6f53$var$mapStateToProps, $cb7f6e5e29fc6f53$var$mapDispatchToProps)($cb7f6e5e29fc6f53$var$AiDocumentDetails);


var $641034d6858dbff8$export$2e2bcd8739ae039 = (0, $cb7f6e5e29fc6f53$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");




function $80a1509f029bbd83$var$ReportsAddress() {
    const [csi] = (0, $tZqWC.useState)((0, $60e52eb6c2680325$export$96c4cef8dff1bd45)());
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $7873b6261a2b1051$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $802ca450e3f2144f$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5387bf8dccf722e4$export$2e2bcd8739ae039), {
                subHeader: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9376591085d0c38d$export$2e2bcd8739ae039), {}),
                pageTitle: "Reports"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b27722fc7d4f5ccf$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $14870abc08ac0dc0$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $d9a5995c1b70ae93$export$2e2bcd8739ae039), {
                        children: [
                            csi === 1 && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3b0006ef62aeb4f4$export$2e2bcd8739ae039), {}),
                            csi !== 1 && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bca6e691668cca93$export$2e2bcd8739ae039), {})
                        ]
                    })
                })
            })
        ]
    });
}
// Default Props
$80a1509f029bbd83$var$ReportsAddress.defaultProps = {
    actions: {},
    filters: {},
    ui: {}
};
// Proptypes Validation
$80a1509f029bbd83$var$ReportsAddress.propTypes = {
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        whitelistingFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object)
    }),
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    })
};
var $80a1509f029bbd83$export$2e2bcd8739ae039 = $80a1509f029bbd83$var$ReportsAddress;


var $c76a37d101d4bb2f$export$2e2bcd8739ae039 = (0, $80a1509f029bbd83$export$2e2bcd8739ae039);



parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");

function $58858e0e151e3a5b$var$ReportsTransaction() {
    // Destructure
    // const { } = props
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $7873b6261a2b1051$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $802ca450e3f2144f$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5387bf8dccf722e4$export$2e2bcd8739ae039), {
                subHeader: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9376591085d0c38d$export$2e2bcd8739ae039), {}),
                pageTitle: "Reports"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bb6cb7de1cdd9d3b$export$2e2bcd8739ae039), {})
        ]
    });
}
// Default Props
$58858e0e151e3a5b$var$ReportsTransaction.defaultProps = {
    actions: {},
    filters: {},
    ui: {}
};
// Proptypes Validation
$58858e0e151e3a5b$var$ReportsTransaction.propTypes = {
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        whitelistingFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object)
    }),
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    })
};
var $58858e0e151e3a5b$export$2e2bcd8739ae039 = $58858e0e151e3a5b$var$ReportsTransaction;


var $42120a234c035657$export$2e2bcd8739ae039 = (0, $58858e0e151e3a5b$export$2e2bcd8739ae039);




var $tZqWC = parcelRequire("tZqWC");

var $4L3zM = parcelRequire("4L3zM");




function $338e6f2f0cf4943f$var$ReportsTravelRule() {
    const [csi] = (0, $tZqWC.useState)((0, $60e52eb6c2680325$export$96c4cef8dff1bd45)());
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $7873b6261a2b1051$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $802ca450e3f2144f$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $5387bf8dccf722e4$export$2e2bcd8739ae039), {
                subHeader: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9376591085d0c38d$export$2e2bcd8739ae039), {}),
                pageTitle: "Reports"
            }),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $b27722fc7d4f5ccf$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $14870abc08ac0dc0$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $d9a5995c1b70ae93$export$2e2bcd8739ae039), {
                        children: [
                            csi === 1 && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $45fd8d9b60dccc63$export$2e2bcd8739ae039), {}),
                            csi !== 1 && /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $bca6e691668cca93$export$2e2bcd8739ae039), {})
                        ]
                    })
                })
            })
        ]
    });
}
// Default Props
$338e6f2f0cf4943f$var$ReportsTravelRule.defaultProps = {
    actions: {},
    filters: {},
    ui: {}
};
// Proptypes Validation
$338e6f2f0cf4943f$var$ReportsTravelRule.propTypes = {
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        setShowHeaderLoader: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        setIsPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func,
        showAlert: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).func
    }),
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        whitelistingFilters: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).instanceOf(Object)
    }),
    ui: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).shape({
        isPageTableUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($4L3zM))).bool
    })
};
var $338e6f2f0cf4943f$export$2e2bcd8739ae039 = $338e6f2f0cf4943f$var$ReportsTravelRule;


var $5a2797161d2386e6$export$2e2bcd8739ae039 = (0, $338e6f2f0cf4943f$export$2e2bcd8739ae039);




var $5dc37f8d3265b047$export$2e2bcd8739ae039 = [
    // Home
    {
        exact: true,
        isRouteProtected: true,
        isRouteAdmin: false,
        isRoutePublic: false,
        routing: {
            component: (0, $1df9c2ae6e58bb6b$export$2e2bcd8739ae039),
            path: '/travelrule'
        }
    },
    // Directory
    {
        exact: true,
        isRouteProtected: true,
        isRouteAdmin: false,
        isRoutePublic: false,
        routing: {
            component: (0, $dec7029ca7cf4e45$export$2e2bcd8739ae039),
            path: '/directory'
        }
    },
    {
        exact: true,
        isRouteProtected: true,
        isRouteAdmin: false,
        isRoutePublic: false,
        routing: {
            component: (0, $f1d905f698e7d497$export$2e2bcd8739ae039),
            path: '/directory/vasps'
        }
    },
    // Directory Details
    {
        exact: true,
        isRouteProtected: true,
        isRouteAdmin: false,
        isRoutePublic: false,
        routing: {
            component: (0, $cd63a69df41baa1a$export$2e2bcd8739ae039),
            path: '/directory/accounts/details/:account_id'
        }
    },
    {
        exact: true,
        isRouteProtected: true,
        isRouteAdmin: false,
        isRoutePublic: false,
        routing: {
            component: (0, $c6694e113f94721a$export$2e2bcd8739ae039),
            path: '/directory/vasps/details/:vasp_id'
        }
    },
    // Blockchain Analytics
    {
        exact: true,
        isRouteProtected: true,
        isRouteAdmin: false,
        isRoutePublic: false,
        routing: {
            component: (0, $248e687a94a8051f$export$2e2bcd8739ae039),
            path: '/blockchain-analytics'
        }
    },
    {
        exact: true,
        isRouteProtected: true,
        isRouteAdmin: false,
        isRoutePublic: false,
        routing: {
            component: (0, $4c9e10184dbc51d2$export$2e2bcd8739ae039),
            path: '/blockchain-analytics/transactions'
        }
    },
    // Reports
    {
        exact: true,
        isRouteProtected: true,
        isRouteAdmin: false,
        isRoutePublic: false,
        routing: {
            component: (0, $c76a37d101d4bb2f$export$2e2bcd8739ae039),
            path: '/reports'
        }
    },
    {
        exact: true,
        isRouteProtected: true,
        isRouteAdmin: false,
        isRoutePublic: false,
        routing: {
            component: (0, $42120a234c035657$export$2e2bcd8739ae039),
            path: '/reports/transaction'
        }
    },
    {
        exact: true,
        isRouteProtected: true,
        isRouteAdmin: false,
        isRoutePublic: false,
        routing: {
            component: (0, $5a2797161d2386e6$export$2e2bcd8739ae039),
            path: '/reports/travelrule'
        }
    },
    // User Profile
    {
        exact: true,
        isRouteProtected: true,
        isRouteAdmin: false,
        isRoutePublic: false,
        routing: {
            component: (0, $cd03c9b9c8639b1e$export$2e2bcd8739ae039),
            path: '/user-details/:user_id'
        }
    },
    // Settings
    {
        exact: true,
        isRouteProtected: true,
        isRouteAdmin: false,
        isRoutePublic: false,
        routing: {
            component: (0, $fb0348774b8b6d81$export$2e2bcd8739ae039),
            path: '/settings'
        }
    },
    {
        exact: true,
        isRouteProtected: true,
        isRouteAdmin: false,
        isRoutePublic: false,
        routing: {
            component: (0, $5b007811787f07b1$export$2e2bcd8739ae039),
            path: '/business-details'
        }
    },
    // Ai Chat
    {
        exact: true,
        isRouteProtected: true,
        isRouteAdmin: false,
        isRoutePublic: false,
        routing: {
            component: (0, $906bc5b580eb2d41$export$2e2bcd8739ae039),
            path: '/ai-catalyst/regulatory'
        }
    },
    {
        exact: true,
        isRouteProtected: true,
        isRouteAdmin: false,
        isRoutePublic: false,
        routing: {
            component: (0, $85cda75e0665bb77$export$2e2bcd8739ae039),
            path: '/ai-catalyst/regulatory_chat'
        }
    },
    {
        exact: true,
        isRouteProtected: true,
        isRouteAdmin: false,
        isRoutePublic: false,
        routing: {
            component: (0, $f82d033a41293591$export$2e2bcd8739ae039),
            path: '/ai-catalyst/oapp_docs_chat'
        }
    },
    // ----- ADMIN ROUTES -----
    // Vasp Notification
    {
        exact: true,
        isRouteProtected: true,
        isRouteAdmin: true,
        isRoutePublic: false,
        routing: {
            component: (0, $bb23b22f85a7155f$export$2e2bcd8739ae039),
            path: '/admin/vasps'
        }
    },
    {
        exact: true,
        isRouteProtected: true,
        isRouteAdmin: true,
        isRoutePublic: false,
        routing: {
            component: (0, $75b91024556c8e1d$export$2e2bcd8739ae039),
            path: '/admin/vasps/requested'
        }
    },
    {
        exact: true,
        isRouteProtected: true,
        isRouteAdmin: true,
        isRoutePublic: false,
        routing: {
            component: (0, $2b2b6be12b0648f6$export$2e2bcd8739ae039),
            path: '/admin/vasps/customers'
        }
    },
    {
        exact: true,
        isRouteProtected: true,
        isRouteAdmin: true,
        isRoutePublic: false,
        routing: {
            component: (0, $c255f0c2ee3a2036$export$2e2bcd8739ae039),
            path: '/admin/vasps/midprospects'
        }
    },
    {
        exact: true,
        isRouteProtected: true,
        isRouteAdmin: true,
        isRoutePublic: false,
        routing: {
            component: (0, $8b1a1b6f86e16016$export$2e2bcd8739ae039),
            path: '/admin/vasps/details/:vasp_id'
        }
    },
    {
        exact: true,
        isRouteProtected: true,
        isRouteAdmin: true,
        isRoutePublic: false,
        routing: {
            component: (0, $4d97a00b11e9bb90$export$2e2bcd8739ae039),
            path: '/admin/ai/documents'
        }
    },
    {
        exact: true,
        isRouteProtected: true,
        isRouteAdmin: true,
        isRoutePublic: false,
        routing: {
            component: (0, $641034d6858dbff8$export$2e2bcd8739ae039),
            path: '/admin/ai/documents/:document_id'
        }
    },
    // ----- PUBLIC ROUTES -----
    // Trial Signup
    {
        isRouteAdmin: false,
        isRoutePublic: true,
        isRouteProtected: false,
        exact: true,
        routing: {
            component: (0, $66cd7c85b7eacc31$export$2e2bcd8739ae039),
            path: '/signup/trial'
        }
    },
    {
        isRouteAdmin: false,
        isRoutePublic: true,
        isRouteProtected: false,
        exact: true,
        routing: {
            component: (0, $52af1cc490135e49$export$2e2bcd8739ae039),
            path: '/signup/trial/confirmation/:hash'
        }
    },
    // Vasp Signup
    {
        isRouteAdmin: false,
        isRoutePublic: true,
        isRouteProtected: false,
        exact: true,
        routing: {
            component: (0, $ca0cc3a52dcdb38b$export$2e2bcd8739ae039),
            path: '/register/:token'
        }
    },
    // Vasp Email Confirmation
    {
        isRouteAdmin: false,
        isRoutePublic: true,
        isRouteProtected: false,
        exact: true,
        routing: {
            component: (0, $550831ac8e233add$export$2e2bcd8739ae039),
            path: '/confirm_email/:hash'
        }
    },
    // Vasp User Email Confirmation
    {
        isRouteAdmin: false,
        isRoutePublic: true,
        isRouteProtected: false,
        exact: true,
        routing: {
            component: (0, $c9ee35e7a4200ef9$export$2e2bcd8739ae039),
            path: '/confirm_vasp_user/:hash'
        }
    },
    // Login
    {
        isRouteAdmin: false,
        isRoutePublic: true,
        isRouteProtected: false,
        exact: true,
        routing: {
            component: (0, $dd22bf1c377d691b$export$2e2bcd8739ae039),
            path: '/login'
        }
    },
    // Email Verification
    {
        isRouteAdmin: false,
        isRouteProtected: false,
        isRoutePublic: true,
        exact: true,
        routing: {
            component: (0, $546bd80c347f47f6$export$2e2bcd8739ae039),
            path: '/email/confirm/:auth_hash'
        }
    },
    // LoginTwoFa
    {
        isRouteAdmin: false,
        isRoutePublic: true,
        isRouteProtected: false,
        exact: true,
        routing: {
            component: (0, $7b764510d8a0ab8e$export$2e2bcd8739ae039),
            path: '/login/:auth_hash'
        }
    },
    // User Activation
    {
        isRouteAdmin: false,
        isRoutePublic: true,
        isRouteProtected: false,
        exact: true,
        routing: {
            component: (0, $d8708d366d43ba58$export$2e2bcd8739ae039),
            path: '/user/activation/:auth_hash'
        }
    },
    // Update Password
    {
        isRouteAdmin: false,
        isRoutePublic: false,
        isRouteProtected: true,
        exact: true,
        routing: {
            component: (0, $68cf2bde4ec542a4$export$2e2bcd8739ae039),
            path: '/update_password'
        }
    },
    // Reset Password
    {
        isRouteAdmin: false,
        isRoutePublic: true,
        isRouteProtected: false,
        exact: true,
        routing: {
            component: (0, $344dbf985b87386c$export$2e2bcd8739ae039),
            path: '/reset_password/:auth_hash'
        }
    },
    {
        isRouteAdmin: false,
        isRoutePublic: true,
        isRouteProtected: false,
        exact: true,
        routing: {
            component: (0, $c0fe5e608582cef7$export$2e2bcd8739ae039),
            path: '/reset_password'
        }
    },
    {
        isRouteAdmin: false,
        isRoutePublic: false,
        isRouteProtected: false,
        exact: false,
        routing: {
            component: (0, $d549f3728d941dad$export$2e2bcd8739ae039)
        }
    }
];


/* eslint-disable max-len */ /* eslint-disable react/prop-types */ 

var $tZqWC = parcelRequire("tZqWC");





// Map Redux Props
const $f3c4337929d008f6$var$mapStateToProps = (state)=>state;
const $f3c4337929d008f6$var$mapDispatchToProps = (0, $2154a4c08d887b32$export$e324594224ef24da);
function $f3c4337929d008f6$var$Global(props) {
    // Destructure
    const { actions: actions, address: address } = props;
    const { setAddressChains: setAddressChains, setDefaultAddressProvider: setDefaultAddressProvider } = actions;
    const { addressChains: addressChains } = address;
    // Hooks
    const [userCredentials] = (0, $a9c50ebe96619b20$export$2e2bcd8739ae039)('userCredentials', {});
    const { getAddressChains: getAddressChains, getAddressChainsData: getAddressChainsData } = (0, $2a86427d3edf9a86$export$2e2bcd8739ae039)();
    // Functions
    function handleAddressChains() {
        if (!getAddressChainsData || Object?.keys(getAddressChainsData || {})?.length < 1) return;
        // !Idk why but this is causing some bugs but we need this to optimize the process
        // if (addressChains && defaultAddressProvider) return
        const newAddressChains = {};
        const newDefaultAddressProvider = {};
        getAddressChainsData.forEach((item)=>{
            // Destructure with default values
            const { data_type: data_type = '', provider_code: provider_code = '', symbol: symbol = '', is_user_default: is_user_default = false, integration_id: integration_id = '' } = item || {};
            // Initialize the data_type and provider_code if they don't exist
            if (!newAddressChains[data_type]) newAddressChains[data_type] = {};
            if (!newAddressChains[data_type][provider_code]) newAddressChains[data_type][provider_code] = {};
            // Insert the item directly
            newAddressChains[data_type][provider_code][symbol] = item;
            // Handle the default address provider
            if (is_user_default && !newDefaultAddressProvider[data_type]) newDefaultAddressProvider[data_type] = {
                provider_code: provider_code,
                integration_id: integration_id,
                data_type: data_type
            };
        });
        // Sorting by symbol using .sort()
        Object.keys(newAddressChains).forEach((data_type)=>{
            Object.keys(newAddressChains[data_type]).forEach((provider_code)=>{
                // Get the symbols and sort them
                const symbols = Object.keys(newAddressChains[data_type][provider_code]);
                const sortedSymbols = symbols.sort() // Sort the symbols
                ;
                // Create a new object to store sorted entries
                const sortedPartner = {};
                sortedSymbols.forEach((symbol)=>{
                    sortedPartner[symbol] = newAddressChains[data_type][provider_code][symbol];
                });
                // Replace the unsorted partner object with the sorted one
                newAddressChains[data_type][provider_code] = sortedPartner;
            });
        });
        setAddressChains(newAddressChains);
        setDefaultAddressProvider(newDefaultAddressProvider);
    }
    // UseEffects
    (0, $tZqWC.useEffect)(()=>{
        if ((!addressChains || Object?.keys(addressChains || {})?.length < 1) && userCredentials.business_id) getAddressChains();
    }, []);
    (0, $tZqWC.useEffect)(()=>handleAddressChains(), [
        getAddressChainsData
    ]);
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $0b050a2b7a31f127$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $55024b2d0828f9e5$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $c8d1bfe51ed09424$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $00d8a2ddb487d42e$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $19281fb4a54057c2$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9c514ece6161cc09$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $110a85a156da9048$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3434805d4cb42c0f$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $3f16d287ce546a6e$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $cf1c5a197e1a201a$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d3be7dba4fa37a9c$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $02caa3170cb7f4b1$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $69d9caa7ff6e60d3$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $e7d8993ff401f9b8$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $549b1e336ae89b24$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $214523f7703887b7$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9486cd6f5d724c09$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f5b59232fc5c3635$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $9da9c61b29795f47$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $8f1528e0bd56ff87$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $36092b4a99a9312b$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ec8159c76f8fc419$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6368f279d4295f50$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a1ac23dc25f8fd23$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f1fd0152aa1d17c3$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $2277dfca698709e1$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ffe00bd7b05a71fe$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $4d4ef17600b059b2$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ee40469a5048d704$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $69d1d8fa475eba28$export$2e2bcd8739ae039), {})
        ]
    });
}
$f3c4337929d008f6$var$Global.defaultProps = {};
// Proptypes Validation
$f3c4337929d008f6$var$Global.propTypes = {};
var $f3c4337929d008f6$export$2e2bcd8739ae039 = (0, $9a02dcf7eea7138a$export$2e2bcd8739ae039)($f3c4337929d008f6$var$mapStateToProps, $f3c4337929d008f6$var$mapDispatchToProps)($f3c4337929d008f6$var$Global);


var $d3ab8a2f01720862$export$2e2bcd8739ae039 = (0, $f3c4337929d008f6$export$2e2bcd8739ae039);


function $8754910489049feb$var$Routing() {
    /// Check if user is logged in
    const userCredentials = JSON.parse(localStorage.getItem('userCredentials'));
    const isLoggedIn = JSON.parse(localStorage.getItem('isLoggedIn'));
    // Checking if Access token has expired
    // if (userCredentials) {
    //   if (Object.keys(userCredentials).length !== 0) {
    //     const expiryDate = new Date(userCredentials.expiry).getTime()
    //     const now = moment()
    //     const expirationDate = moment(expiryDate)
    //     // Compare if the current date is before the expiration date
    //     if (!now.isBefore(expirationDate)) {
    //       logout()
    //       return
    //     }
    //     const oneHour = 1 * 60 * 60 * 1000
    //     setTimeout(logout, oneHour)
    //     // const timeDiff = expirationDate.diff(now)
    //     // setTimeout(logout, timeDiff)
    //   }
    // }
    /**
   * Validates if current authenticated user is authorized to view a route
   * @param  {} roles
   */ const isUserAuthorized = (roles)=>{
        // If route has role restriction, check if user role is authorized
        if (roles && roles.length) roles.some((role)=>role === userCredentials.role);
        // Else route has no restriction give user access
        return true;
    };
    /**
   * Conditionally selects route/component to render based on authentication or authorization
   * @param  {} isRouteProtected
   * @param  {} routeRoleAccess
   * @param  {} component
   */ const renderRouteComponent = ({ isRoutePublic: isRoutePublic, isRouteProtected: isRouteProtected, isRouteAdmin: isRouteAdmin, routeRoleAccess: routeRoleAccess, component: component, path: path })=>{
        const emptyPath = path === undefined || path === '/';
        const localUserCredentials = JSON.parse(localStorage.getItem('userCredentials'));
        if (isRoutePublic) return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(component),
                /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d3ab8a2f01720862$export$2e2bcd8739ae039), {})
            ]
        });
        if (!isRouteProtected) {
            // Render public routes
            if ((!isLoggedIn || !localUserCredentials?.access_token) && emptyPath) return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a0d5c3f2fe524011$export$2d8d895a0a0f636e), {
                        to: "/login"
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d3ab8a2f01720862$export$2e2bcd8739ae039), {})
                ]
            });
            if (!isLoggedIn || !localUserCredentials?.access_token) return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(component),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d3ab8a2f01720862$export$2e2bcd8739ae039), {})
                ]
            });
            // Redirect to home page if logged in user access public routes
            if (isLoggedIn && localUserCredentials?.access_token && emptyPath) return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a0d5c3f2fe524011$export$2d8d895a0a0f636e), {
                        to: "/travelrule"
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d3ab8a2f01720862$export$2e2bcd8739ae039), {})
                ]
            });
            if (isLoggedIn && localUserCredentials?.access_token) return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a0d5c3f2fe524011$export$2d8d895a0a0f636e), {
                        to: "/travelrule"
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d3ab8a2f01720862$export$2e2bcd8739ae039), {})
                ]
            });
        }
        if (isRouteProtected) {
            // Redirect to login page if credentials are missing or not logged in
            if (!localUserCredentials?.access_token || !isLoggedIn) return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a0d5c3f2fe524011$export$2d8d895a0a0f636e), {
                        to: "/login"
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d3ab8a2f01720862$export$2e2bcd8739ae039), {})
                ]
            });
            if ((!localUserCredentials?.access_token || !isLoggedIn) && emptyPath) return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a0d5c3f2fe524011$export$2d8d895a0a0f636e), {
                        to: "/login"
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d3ab8a2f01720862$export$2e2bcd8739ae039), {})
                ]
            });
            // Render protected routes
            if (localUserCredentials?.role_id !== 0 && isRouteAdmin) return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a0d5c3f2fe524011$export$2d8d895a0a0f636e), {
                        to: "/travelrule"
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d3ab8a2f01720862$export$2e2bcd8739ae039), {})
                ]
            });
            if (localUserCredentials?.role_id !== 0 && isRouteAdmin && emptyPath) return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a0d5c3f2fe524011$export$2d8d895a0a0f636e), {
                        to: "/travelrule"
                    }),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d3ab8a2f01720862$export$2e2bcd8739ae039), {})
                ]
            });
            if (localUserCredentials?.access_token && isUserAuthorized(routeRoleAccess) && isLoggedIn) return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $8bbd0dc1ab5297af$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(component),
                    /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $d3ab8a2f01720862$export$2e2bcd8739ae039), {})
                ]
            });
        }
        // Render not found route
        if (isRouteProtected === undefined || !path) return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $8bbd0dc1ab5297af$exports.Fragment), {
            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($tZqWC))).createElement(component)
        });
    };
    // useEffect(() => {
    //   if (!userCredentials?.access_token) return
    //   const token = parseJwt(userCredentials?.access_token)
    //   if (token && token?.csi === 3) {
    //     // Add the external script
    //     const script = document.createElement('script')
    //     script.async = true
    //     script.src = 'https://static.hotjar.com/c/hotjar-5255258.js?sv=6'
    //     script.type = 'text/javascript'
    //     document.head.appendChild(script)
    //     // Initialize Hotjar after the script is loaded
    //     script.onload = () => {
    //       ;(function (h, o, t, j, a, r) {
    //         h.hj =
    //           h.hj ||
    //           function () {
    //             ;(h.hj.q = h.hj.q || []).push(arguments)
    //           }
    //         h._hjSettings = { hjid: 5255258, hjsv: 6 }
    //         a = o.getElementsByTagName('head')[0]
    //         r = o.createElement('script')
    //         r.async = 1
    //         r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv
    //         a.appendChild(r)
    //       })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=')
    //     }
    //     return () => {
    //       document.head.removeChild(script)
    //     }
    //   }
    // }, [userCredentials])
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $12b33660068e86aa$export$9ba4e89fdfa1fc54), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a0d5c3f2fe524011$export$b5d5cf8927ab7262), {
            children: (0, $5dc37f8d3265b047$export$2e2bcd8739ae039).map(({ isRoutePublic: isRoutePublic, isRouteProtected: isRouteProtected, isRouteAdmin: isRouteAdmin, exact: exact, roleAccess: roleAccess, routing: { path: path, component: component } })=>/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $a0d5c3f2fe524011$export$e7b0ac011bb776c6), {
                    exact: exact,
                    path: path,
                    render: ()=>renderRouteComponent({
                            isRoutePublic: isRoutePublic,
                            isRouteProtected: isRouteProtected,
                            isRouteAdmin: isRouteAdmin,
                            roleAccess: roleAccess,
                            component: component,
                            path: path
                        })
                }, (0, $5d7f1dba4fbacab8$export$2e2bcd8739ae039)()))
        })
    });
}
var $8754910489049feb$export$2e2bcd8739ae039 // function logout() {
 //   localStorage.removeItem('userCredentials')
 //   window.location.reload()
 // }
 = $8754910489049feb$var$Routing;


/* eslint-disable max-len */ 
const $7c436507295fbb9c$var$GlobalStyle = (0, $a778141486c79bc3$export$f0f03736edb61697)`
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    font-weight: 400;
    font-family: 'OpenSans', sans-serif;
    -webkit-font-smoothing: antialiased;
    line-height: 1.6;
  }

  html {
    height: 100%;
  }
  body { 
    height: 100%;
  }
  #root {
    height: 100%;
  }

  a {
    color: inherit;
    text-decoration: none;
    font-weight: inherit;
    
    &:hover, &:focus{
      text-decoration: none;
      color: inherit;
    }
  }

  ul {
    list-style: none;
    padding: 0px;
    margin: 0px;
  }

  button {
    &:focus {
      outline: none;
    }
  }

  button, input, optgroup, select, textarea {
    margin: 0;
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
  }

  select {
    -webkit-appearance: none;
    -moz-appearance: none;
    text-indent: 1px;
    text-overflow: '';
    box-shadow: none;

    &::-ms-expand {
      display: none;
    }

    &:focus {
      outline: none;
    }
  }

  label {
    margin-bottom: 5px;
  }
  
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  ::-webkit-scrollbar-button {
    width: 8px;
    height: 8px;
  }
  ::-webkit-scrollbar-thumb {
    background: #787878;
    border: 0px none #ffffff;
    border-radius: 100px;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: #8f8f8f;
  }
  ::-webkit-scrollbar-thumb:active {
    background: #787878;
  }
  ::-webkit-scrollbar-track {
    background: #e3e3e3;
    border: 0px none #ffffff;
    border-radius: 100px;
  }
  ::-webkit-scrollbar-track:hover {
    background: #e3e3e3;
  }
  ::-webkit-scrollbar-track:active {
    background: #e3e3e3;
  }
  ::-webkit-scrollbar-corner {
    background: transparent;
  }

`;
var $7c436507295fbb9c$export$2e2bcd8739ae039 = $7c436507295fbb9c$var$GlobalStyle;


function $f23f4452d96899d0$var$App() {
    return /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $8bbd0dc1ab5297af$exports.Fragment), {
        children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $ea5d2799a316b2c2$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $6829791a091ca67a$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsxs)((0, $114cb5fd5cac8cce$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $8754910489049feb$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $7c436507295fbb9c$export$2e2bcd8739ae039), {})
                    ]
                })
            })
        })
    });
}
var $f23f4452d96899d0$export$2e2bcd8739ae039 = $f23f4452d96899d0$var$App;


(0, (/*@__PURE__*/$parcel$interopDefault($f419cfc3d92fe631$exports))).render(/*#__PURE__*/ (0, $8bbd0dc1ab5297af$exports.jsx)((0, $f23f4452d96899d0$export$2e2bcd8739ae039), {}), document.getElementById('root'));
{
    function anon(h, o, t, j, a, r) {
        h.hj = h.hj || function() {
            (h.hj.q = h.hj.q || []).push(arguments);
        };
        h._hjSettings = {
            hjid: 5255258,
            hjsv: 6
        };
        a = o.getElementsByTagName('head')[0];
        r = o.createElement('script');
        r.async = 1;
        r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
        a.appendChild(r);
    }
    anon(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
}

//# sourceMappingURL=react-build.badfc382.js.map
